(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e0b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e0b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("J42oT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("59CkL"));

});
parcelRegister("59CkL", function(module, exports) {

$parcel$export(module.exports, "Children", () => $3c0b875640e65969$export$dca3b0875bd9a954, (v) => $3c0b875640e65969$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $3c0b875640e65969$export$16fa2f45be04daa8, (v) => $3c0b875640e65969$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $3c0b875640e65969$export$ffb0004e005737fa, (v) => $3c0b875640e65969$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $3c0b875640e65969$export$e2c29f18771995cb, (v) => $3c0b875640e65969$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $3c0b875640e65969$export$221d75b3f55bb0bd, (v) => $3c0b875640e65969$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $3c0b875640e65969$export$5f8d39834fd61797, (v) => $3c0b875640e65969$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3c0b875640e65969$export$74bf444e3cd11ea5, (v) => $3c0b875640e65969$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $3c0b875640e65969$export$ae55be85d98224ed, (v) => $3c0b875640e65969$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $3c0b875640e65969$export$e530037191fcd5d7, (v) => $3c0b875640e65969$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $3c0b875640e65969$export$fd42f52fd3ae1109, (v) => $3c0b875640e65969$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $3c0b875640e65969$export$c8a8987d4410bf2d, (v) => $3c0b875640e65969$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $3c0b875640e65969$export$d38cd72104c1f0e9, (v) => $3c0b875640e65969$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $3c0b875640e65969$export$7d1e3a5e95ceca43, (v) => $3c0b875640e65969$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $3c0b875640e65969$export$257a8862b851cb5b, (v) => $3c0b875640e65969$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $3c0b875640e65969$export$a8257692ac88316c, (v) => $3c0b875640e65969$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $3c0b875640e65969$export$488013bae63b21da, (v) => $3c0b875640e65969$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $3c0b875640e65969$export$7c73462e0d25e514, (v) => $3c0b875640e65969$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $3c0b875640e65969$export$35808ee640e87ca7, (v) => $3c0b875640e65969$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $3c0b875640e65969$export$fae74005e78b1a27, (v) => $3c0b875640e65969$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $3c0b875640e65969$export$dc8fbce3eb94dc1e, (v) => $3c0b875640e65969$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $3c0b875640e65969$export$6d9c69b0de29b591, (v) => $3c0b875640e65969$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $3c0b875640e65969$export$d5a552a76deda3c2, (v) => $3c0b875640e65969$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $3c0b875640e65969$export$e5c5a5f917a5871c, (v) => $3c0b875640e65969$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $3c0b875640e65969$export$1538c33de8887b59, (v) => $3c0b875640e65969$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $3c0b875640e65969$export$13e3392192263954, (v) => $3c0b875640e65969$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $3c0b875640e65969$export$b8f5890fc79d6aca, (v) => $3c0b875640e65969$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $3c0b875640e65969$export$60241385465d0a34, (v) => $3c0b875640e65969$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $3c0b875640e65969$export$83d89fbfd8236492, (v) => $3c0b875640e65969$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c0b875640e65969$export$dca3b0875bd9a954;
var $3c0b875640e65969$export$16fa2f45be04daa8;
var $3c0b875640e65969$export$ffb0004e005737fa;
var $3c0b875640e65969$export$e2c29f18771995cb;
var $3c0b875640e65969$export$221d75b3f55bb0bd;
var $3c0b875640e65969$export$5f8d39834fd61797;
var $3c0b875640e65969$export$74bf444e3cd11ea5;
var $3c0b875640e65969$export$ae55be85d98224ed;
var $3c0b875640e65969$export$e530037191fcd5d7;
var $3c0b875640e65969$export$fd42f52fd3ae1109;
var $3c0b875640e65969$export$c8a8987d4410bf2d;
var $3c0b875640e65969$export$d38cd72104c1f0e9;
var $3c0b875640e65969$export$7d1e3a5e95ceca43;
var $3c0b875640e65969$export$257a8862b851cb5b;
var $3c0b875640e65969$export$a8257692ac88316c;
var $3c0b875640e65969$export$488013bae63b21da;
var $3c0b875640e65969$export$7c73462e0d25e514;
var $3c0b875640e65969$export$35808ee640e87ca7;
var $3c0b875640e65969$export$fae74005e78b1a27;
var $3c0b875640e65969$export$dc8fbce3eb94dc1e;
var $3c0b875640e65969$export$6d9c69b0de29b591;
var $3c0b875640e65969$export$d5a552a76deda3c2;
var $3c0b875640e65969$export$e5c5a5f917a5871c;
var $3c0b875640e65969$export$1538c33de8887b59;
var $3c0b875640e65969$export$13e3392192263954;
var $3c0b875640e65969$export$b8f5890fc79d6aca;
var $3c0b875640e65969$export$60241385465d0a34;
var $3c0b875640e65969$export$83d89fbfd8236492;
'use strict';


(function() {
    'use strict';
    var _assign = (parcelRequire("7oJ2w"));
    var checkPropTypes = (parcelRequire("dMZkM"));
    var ReactVersion = '16.14.0';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        suspense: null
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
    function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, '');
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                    var pathBeforeSlash = match[1];
                    if (pathBeforeSlash) {
                        var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                        fileName = folderName + '/' + fileName;
                    }
                }
            }
            sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) sourceInfo = ' (created by ' + ownerName + ')';
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
    }
    var Resolved = 1;
    function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
                return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
            case REACT_LAZY_TYPE:
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) return getComponentName(resolvedThenable);
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = {};
    var currentlyValidatingElement = null;
    function setCurrentlyValidatingElement(element) {
        currentlyValidatingElement = element;
    }
    // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentlyValidatingElement) {
            var name = getComponentName(currentlyValidatingElement.type);
            var owner = currentlyValidatingElement._owner;
            stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
        } // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    _assign(ReactSharedInternals, {
        // These should not be included in production.
        ReactDebugCurrentFrame: ReactDebugCurrentFrame,
        // Shim for React DOM 16.0.0 which still destructured (but not used) this.
        // TODO: remove in React 17.0.
        ReactComponentTreeHook: {}
    });
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
        if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
                format += '%s';
                args = args.concat([
                    stack
                ]);
            }
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function() {
                return args[argIndex++];
            });
            throw new Error(message);
        } catch (x) {}
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = '' + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = '' + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = ('' + key).replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
    }
    var POOL_SIZE = 10;
    var traverseContextPool = [];
    function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
        if (traverseContextPool.length) {
            var traverseContext = traverseContextPool.pop();
            traverseContext.result = mapResult;
            traverseContext.keyPrefix = keyPrefix;
            traverseContext.func = mapFunction;
            traverseContext.context = mapContext;
            traverseContext.count = 0;
            return traverseContext;
        } else return {
            result: mapResult,
            keyPrefix: keyPrefix,
            func: mapFunction,
            context: mapContext,
            count: 0
        };
    }
    function releaseTraverseContext(traverseContext) {
        traverseContext.result = null;
        traverseContext.keyPrefix = null;
        traverseContext.func = null;
        traverseContext.context = null;
        traverseContext.count = 0;
        if (traverseContextPool.length < POOL_SIZE) traverseContextPool.push(traverseContext);
    }
    /**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */ function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            callback(traverseContext, children, // so that it's consistent if the number of children grows.
            nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getComponentKey(child, i);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                // Warn about using Maps as children
                if (iteratorFn === children.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(children);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getComponentKey(child, ii++);
                    subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                }
            } else if (type === 'object') {
                var addendum = '';
                addendum = " If you meant to render a collection of children, use an array instead." + ReactDebugCurrentFrame.getStackAddendum();
                var childrenString = '' + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + ")." + addendum);
            }
        }
        return subtreeCount;
    }
    /**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */ function traverseAllChildren(children, callback, traverseContext) {
        if (children == null) return 0;
        return traverseAllChildrenImpl(children, '', callback, traverseContext);
    }
    /**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getComponentKey(component, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof component === 'object' && component !== null && component.key != null) // Explicit key
        return escape(component.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function forEachSingleChild(bookKeeping, child, name) {
        var func = bookKeeping.func, context = bookKeeping.context;
        func.call(context, child, bookKeeping.count++);
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        if (children == null) return children;
        var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
        traverseAllChildren(children, forEachSingleChild, traverseContext);
        releaseTraverseContext(traverseContext);
    }
    function mapSingleChildIntoContext(bookKeeping, child, childKey) {
        var result = bookKeeping.result, keyPrefix = bookKeeping.keyPrefix, func = bookKeeping.func, context = bookKeeping.context;
        var mappedChild = func.call(context, child, bookKeeping.count++);
        if (Array.isArray(mappedChild)) mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function(c) {
            return c;
        });
        else if (mappedChild != null) {
            if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
            keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
            result.push(mappedChild);
        }
    }
    function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
        var escapedPrefix = '';
        if (prefix != null) escapedPrefix = escapeUserProvidedKey(prefix) + '/';
        var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
        traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
        releaseTraverseContext(traverseContext);
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, func, context);
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        return traverseAllChildren(children, function() {
            return null;
        }, null);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, function(child) {
            return child;
        });
        return result;
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    function lazy(ctor) {
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _ctor: ctor,
            // React uses these fields to store the result.
            _status: -1,
            _result: null
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes;
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        return {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
    }
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        return {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks" : '');
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var name = getComponentName(type);
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            setCurrentlyValidatingElement(element);
            checkPropTypes(propTypes, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
            setCurrentlyValidatingElement(null);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        setCurrentlyValidatingElement(fragment);
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                break;
            }
        }
        if (fragment.ref !== null) error('Invalid attribute `ref` supplied to `React.Fragment`.');
        setCurrentlyValidatingElement(null);
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (Array.isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        var testMap = new Map([
            [
                frozenObject,
                null
            ]
        ]);
        var testSet = new Set([
            frozenObject
        ]); // This is necessary for Rollup to not consider these unused.
        // https://github.com/rollup/rollup/issues/1771
        // TODO: we can remove these if Rollup fixes the bug.
        testMap.set(0, 0);
        testSet.add(0);
    } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    $3c0b875640e65969$export$dca3b0875bd9a954 = Children;
    $3c0b875640e65969$export$16fa2f45be04daa8 = Component;
    $3c0b875640e65969$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $3c0b875640e65969$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $3c0b875640e65969$export$221d75b3f55bb0bd = PureComponent;
    $3c0b875640e65969$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $3c0b875640e65969$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $3c0b875640e65969$export$ae55be85d98224ed = ReactSharedInternals;
    $3c0b875640e65969$export$e530037191fcd5d7 = cloneElement$1;
    $3c0b875640e65969$export$fd42f52fd3ae1109 = createContext;
    $3c0b875640e65969$export$c8a8987d4410bf2d = createElement$1;
    $3c0b875640e65969$export$d38cd72104c1f0e9 = createFactory;
    $3c0b875640e65969$export$7d1e3a5e95ceca43 = createRef;
    $3c0b875640e65969$export$257a8862b851cb5b = forwardRef;
    $3c0b875640e65969$export$a8257692ac88316c = isValidElement;
    $3c0b875640e65969$export$488013bae63b21da = lazy;
    $3c0b875640e65969$export$7c73462e0d25e514 = memo;
    $3c0b875640e65969$export$35808ee640e87ca7 = useCallback;
    $3c0b875640e65969$export$fae74005e78b1a27 = useContext;
    $3c0b875640e65969$export$dc8fbce3eb94dc1e = useDebugValue;
    $3c0b875640e65969$export$6d9c69b0de29b591 = useEffect;
    $3c0b875640e65969$export$d5a552a76deda3c2 = useImperativeHandle;
    $3c0b875640e65969$export$e5c5a5f917a5871c = useLayoutEffect;
    $3c0b875640e65969$export$1538c33de8887b59 = useMemo;
    $3c0b875640e65969$export$13e3392192263954 = useReducer;
    $3c0b875640e65969$export$b8f5890fc79d6aca = useRef;
    $3c0b875640e65969$export$60241385465d0a34 = useState;
    $3c0b875640e65969$export$83d89fbfd8236492 = ReactVersion;
})();

});
parcelRegister("7oJ2w", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $562db642758700fb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $562db642758700fb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $562db642758700fb$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $562db642758700fb$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $562db642758700fb$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $562db642758700fb$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $562db642758700fb$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($562db642758700fb$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($562db642758700fb$var$getOwnPropertySymbols) {
            symbols = $562db642758700fb$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($562db642758700fb$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("dMZkM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a09f55b7f1835455$var$printWarning = function() {};

var $g41Uv = parcelRequire("g41Uv");
var $a09f55b7f1835455$var$loggedTypeFailures = {};

var $2EqGK = parcelRequire("2EqGK");
$a09f55b7f1835455$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $a09f55b7f1835455$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($2EqGK(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $g41Uv);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $a09f55b7f1835455$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $a09f55b7f1835455$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $a09f55b7f1835455$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $a09f55b7f1835455$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $a09f55b7f1835455$var$checkPropTypes.resetWarningCache = function() {
    $a09f55b7f1835455$var$loggedTypeFailures = {};
};
module.exports = $a09f55b7f1835455$var$checkPropTypes;

});
parcelRegister("g41Uv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $bb1e80736c7b4e67$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $bb1e80736c7b4e67$var$ReactPropTypesSecret;

});

parcelRegister("2EqGK", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});




parcelRegister("f3ft4", function(module, exports) {
'use strict';
function $af532270cefe118a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("kbHwf"));

});
parcelRegister("kbHwf", function(module, exports) {
/** @license React v16.14.0
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';





(function() {
    'use strict';
    var React = (parcelRequire("J42oT"));
    var _assign = (parcelRequire("7oJ2w"));
    var Scheduler = (parcelRequire("7pM6b"));
    var checkPropTypes = (parcelRequire("dMZkM"));
    var tracing = (parcelRequire("2CVR1"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
    // Current owner and dispatcher used to share the same ref,
    // but PR #14548 split them out to better support the react-debug-tools package.
    if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) ReactSharedInternals.ReactCurrentDispatcher = {
        current: null
    };
    if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) ReactSharedInternals.ReactCurrentBatchConfig = {
        suspense: null
    };
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
        if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
                format += '%s';
                args = args.concat([
                    stack
                ]);
            }
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function() {
                return args[argIndex++];
            });
            throw new Error(message);
        } catch (x) {}
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var invokeGuardedCallbackImpl = function(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    };
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        var invokeGuardedCallbackDev = function(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://fb.me/react-crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
        };
        invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var getFiberCurrentPropsFromNode = null;
    var getInstanceFromNode = null;
    var getNodeFromInstance = null;
    function setComponentTree(getFiberCurrentPropsFromNodeImpl, getInstanceFromNodeImpl, getNodeFromInstanceImpl) {
        getFiberCurrentPropsFromNode = getFiberCurrentPropsFromNodeImpl;
        getInstanceFromNode = getInstanceFromNodeImpl;
        getNodeFromInstance = getNodeFromInstanceImpl;
        if (!getNodeFromInstance || !getInstanceFromNode) error("EventPluginUtils.setComponentTree(...): Injected module is missing getNodeFromInstance or getInstanceFromNode.");
    }
    var validateEventDispatches;
    validateEventDispatches = function(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        var listenersIsArr = Array.isArray(dispatchListeners);
        var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
        var instancesIsArr = Array.isArray(dispatchInstances);
        var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
        if (instancesIsArr !== listenersIsArr || instancesLen !== listenersLen) error('EventPluginUtils: Invalid `event`.');
    };
    /**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */ function executeDispatch(event, listener, inst) {
        var type = event.type || 'unknown-event';
        event.currentTarget = getNodeFromInstance(inst);
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    /**
 * Standard/simple iteration through an event's collected dispatches.
 */ function executeDispatchesInOrder(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        validateEventDispatches(event);
        if (Array.isArray(dispatchListeners)) for(var i = 0; i < dispatchListeners.length; i++){
            if (event.isPropagationStopped()) break;
             // Listeners and Instances are two parallel arrays that are always in sync.
            executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
        }
        else if (dispatchListeners) executeDispatch(event, dispatchListeners, dispatchInstances);
        event._dispatchListeners = null;
        event._dispatchInstances = null;
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    /**
 * Injectable ordering of event plugins.
 */ var eventPluginOrder = null;
    /**
 * Injectable mapping from names to event plugin modules.
 */ var namesToPlugins = {};
    /**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */ function recomputePluginOrdering() {
        if (!eventPluginOrder) // Wait until an `eventPluginOrder` is injected.
        return;
        for(var pluginName in namesToPlugins){
            var pluginModule = namesToPlugins[pluginName];
            var pluginIndex = eventPluginOrder.indexOf(pluginName);
            if (!(pluginIndex > -1)) throw Error("EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `" + pluginName + "`.");
            if (plugins[pluginIndex]) continue;
            if (!pluginModule.extractEvents) throw Error("EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `" + pluginName + "` does not.");
            plugins[pluginIndex] = pluginModule;
            var publishedEvents = pluginModule.eventTypes;
            for(var eventName in publishedEvents){
                if (!publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName)) throw Error("EventPluginRegistry: Failed to publish event `" + eventName + "` for plugin `" + pluginName + "`.");
            }
        }
    }
    /**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */ function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
        if (!!eventNameDispatchConfigs.hasOwnProperty(eventName)) throw Error("EventPluginRegistry: More than one plugin attempted to publish the same event name, `" + eventName + "`.");
        eventNameDispatchConfigs[eventName] = dispatchConfig;
        var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
        if (phasedRegistrationNames) {
            for(var phaseName in phasedRegistrationNames)if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
                var phasedRegistrationName = phasedRegistrationNames[phaseName];
                publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
            }
            return true;
        } else if (dispatchConfig.registrationName) {
            publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
            return true;
        }
        return false;
    }
    /**
 * Publishes a registration name that is used to identify dispatched events.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */ function publishRegistrationName(registrationName, pluginModule, eventName) {
        if (!!registrationNameModules[registrationName]) throw Error("EventPluginRegistry: More than one plugin attempted to publish the same registration name, `" + registrationName + "`.");
        registrationNameModules[registrationName] = pluginModule;
        registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
    }
    /**
 * Registers plugins so that they can extract and dispatch events.
 */ /**
 * Ordered list of injected plugins.
 */ var plugins = [];
    /**
 * Mapping from event name to dispatch config
 */ var eventNameDispatchConfigs = {};
    /**
 * Mapping from registration name to plugin module
 */ var registrationNameModules = {};
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    /**
 * Injects an ordering of plugins (by plugin name). This allows the ordering
 * to be decoupled from injection of the actual plugins so that ordering is
 * always deterministic regardless of packaging, on-the-fly injection, etc.
 *
 * @param {array} InjectedEventPluginOrder
 * @internal
 */ function injectEventPluginOrder(injectedEventPluginOrder) {
        if (!!eventPluginOrder) throw Error("EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.");
         // Clone the ordering so it cannot be dynamically mutated.
        eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
        recomputePluginOrdering();
    }
    /**
 * Injects plugins to be used by plugin event system. The plugin names must be
 * in the ordering injected by `injectEventPluginOrder`.
 *
 * Plugins can be injected as part of page initialization or on-the-fly.
 *
 * @param {object} injectedNamesToPlugins Map from names to plugin modules.
 * @internal
 */ function injectEventPluginsByName(injectedNamesToPlugins) {
        var isOrderingDirty = false;
        for(var pluginName in injectedNamesToPlugins){
            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) continue;
            var pluginModule = injectedNamesToPlugins[pluginName];
            if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
                if (!!namesToPlugins[pluginName]) throw Error("EventPluginRegistry: Cannot inject two different event plugins using the same name, `" + pluginName + "`.");
                namesToPlugins[pluginName] = pluginModule;
                isOrderingDirty = true;
            }
        }
        if (isOrderingDirty) recomputePluginOrdering();
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    var PLUGIN_EVENT_SYSTEM = 1;
    var IS_REPLAYED = 32;
    var IS_FIRST_ANCESTOR = 64;
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === 'function')) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    var enableProfilerTimer = true; // Trace which interactions trigger each commit.
    var enableDeprecatedFlareAPI = false; // Experimental Host Component support.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var warnAboutStringRefs = false;
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    } // This is for the React Flare event system
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        // event.timeStamp isn't overly reliable due to inconsistencies in
        // how different browsers have historically provided the time stamp.
        // Some browsers provide high-resolution time stamps for all events,
        // some provide low-resolution time stamps for all events. FF < 52
        // even mixes both time stamps together. Some browsers even report
        // negative time stamps or time stamps that are 0 (iOS9) in some cases.
        // Given we are only comparing two time stamps with equality (!==),
        // we are safe from the resolution differences. If the time stamp is 0
        // we bail-out of preventing the flush, which can affect semantics,
        // such as if an earlier flush removes or adds event listeners that
        // are fired in the subsequent flush. However, this is the same
        // behaviour as we had before this change, so the risks are low.
        if (!isInsideEventHandler && !enableDeprecatedFlareAPI) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the whitelist are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML whitelist.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true);
    });
    var ReactDebugCurrentFrame = null;
    ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, '' + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
    function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, '');
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                    var pathBeforeSlash = match[1];
                    if (pathBeforeSlash) {
                        var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                        fileName = folderName + '/' + fileName;
                    }
                }
            }
            sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) sourceInfo = ' (created by ' + ownerName + ')';
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
    }
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
    }
    function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
            lazyComponent._status = Pending;
            var ctor = lazyComponent._ctor;
            var thenable = ctor();
            lazyComponent._result = thenable;
            thenable.then(function(moduleObject) {
                if (lazyComponent._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    lazyComponent._status = Resolved;
                    lazyComponent._result = defaultExport;
                }
            }, function(error) {
                if (lazyComponent._status === Pending) {
                    lazyComponent._status = Rejected;
                    lazyComponent._result = error;
                }
            });
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
                return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
            case REACT_LAZY_TYPE:
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) return getComponentName(resolvedThenable);
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function describeFiber(fiber) {
        switch(fiber.tag){
            case HostRoot:
            case HostPortal:
            case HostText:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
                return '';
            default:
                var owner = fiber._debugOwner;
                var source = fiber._debugSource;
                var name = getComponentName(fiber.type);
                var ownerName = null;
                if (owner) ownerName = getComponentName(owner.type);
                return describeComponentFrame(name, source, ownerName);
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;
        do {
            info += describeFiber(node);
            node = node.return;
        }while (node);
        return info;
    }
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame$1.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var ReactDebugCurrentFrame$2 = null;
    var ReactControlledValuePropTypes = {
        checkPropTypes: null
    };
    ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    var propTypes = {
        value: function(props, propName, componentName) {
            if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) return null;
            return new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        },
        checked: function(props, propName, componentName) {
            if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) return null;
            return new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
        }
    };
    /**
   * Provide a linked `value` attribute for controlled forms. You should not use
   * this outside of the ReactDOM controlled form components.
   */ ReactControlledValuePropTypes.checkPropTypes = function(tagName, props) {
        checkPropTypes(propTypes, props, 'prop', tagName, ReactDebugCurrentFrame$2.getStackAddendum);
    };
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        ReactControlledValuePropTypes.checkPropTypes('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input of type %s to be controlled. Input elements should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input of type %s to be uncontrolled. Input elements should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || node.ownerDocument.activeElement !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ''; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration codepath too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the codepath above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === 'string' || typeof child === 'number') return;
            if (typeof child.type !== 'string') return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error('Only strings and numbers are supported as <option> children.');
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        ReactControlledValuePropTypes.checkPropTypes('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://fb.me/react-controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        ReactControlledValuePropTypes.checkPropTypes('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // Do not use the below two methods directly!
    // Instead use constants exported from DOMTopLevelEventTypes in ReactDOM.
    // (It is the only module that is allowed to access these methods.)
    function unsafeCastStringToDOMTopLevelType(topLevelType) {
        return topLevelType;
    }
    function unsafeCastDOMTopLevelTypeToString(topLevelType) {
        return topLevelType;
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    /**
 * To identify top level events in ReactDOM, we use constants defined by this
 * module. This is the only module that uses the unsafe* methods to express
 * that the constants actually correspond to the browser event names. This lets
 * us save some bundle size by avoiding a top level type -> event name map.
 * The rest of ReactDOM code should import top level types from this file.
 */ var TOP_ABORT = unsafeCastStringToDOMTopLevelType('abort');
    var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationend'));
    var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationiteration'));
    var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationstart'));
    var TOP_BLUR = unsafeCastStringToDOMTopLevelType('blur');
    var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType('canplay');
    var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType('canplaythrough');
    var TOP_CANCEL = unsafeCastStringToDOMTopLevelType('cancel');
    var TOP_CHANGE = unsafeCastStringToDOMTopLevelType('change');
    var TOP_CLICK = unsafeCastStringToDOMTopLevelType('click');
    var TOP_CLOSE = unsafeCastStringToDOMTopLevelType('close');
    var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType('compositionend');
    var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType('compositionstart');
    var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType('compositionupdate');
    var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType('contextmenu');
    var TOP_COPY = unsafeCastStringToDOMTopLevelType('copy');
    var TOP_CUT = unsafeCastStringToDOMTopLevelType('cut');
    var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType('dblclick');
    var TOP_AUX_CLICK = unsafeCastStringToDOMTopLevelType('auxclick');
    var TOP_DRAG = unsafeCastStringToDOMTopLevelType('drag');
    var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType('dragend');
    var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType('dragenter');
    var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType('dragexit');
    var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType('dragleave');
    var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType('dragover');
    var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType('dragstart');
    var TOP_DROP = unsafeCastStringToDOMTopLevelType('drop');
    var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType('durationchange');
    var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType('emptied');
    var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType('encrypted');
    var TOP_ENDED = unsafeCastStringToDOMTopLevelType('ended');
    var TOP_ERROR = unsafeCastStringToDOMTopLevelType('error');
    var TOP_FOCUS = unsafeCastStringToDOMTopLevelType('focus');
    var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('gotpointercapture');
    var TOP_INPUT = unsafeCastStringToDOMTopLevelType('input');
    var TOP_INVALID = unsafeCastStringToDOMTopLevelType('invalid');
    var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType('keydown');
    var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType('keypress');
    var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType('keyup');
    var TOP_LOAD = unsafeCastStringToDOMTopLevelType('load');
    var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType('loadstart');
    var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType('loadeddata');
    var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType('loadedmetadata');
    var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('lostpointercapture');
    var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType('mousedown');
    var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType('mousemove');
    var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType('mouseout');
    var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType('mouseover');
    var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType('mouseup');
    var TOP_PASTE = unsafeCastStringToDOMTopLevelType('paste');
    var TOP_PAUSE = unsafeCastStringToDOMTopLevelType('pause');
    var TOP_PLAY = unsafeCastStringToDOMTopLevelType('play');
    var TOP_PLAYING = unsafeCastStringToDOMTopLevelType('playing');
    var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType('pointercancel');
    var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType('pointerdown');
    var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType('pointermove');
    var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType('pointerout');
    var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType('pointerover');
    var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType('pointerup');
    var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType('progress');
    var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType('ratechange');
    var TOP_RESET = unsafeCastStringToDOMTopLevelType('reset');
    var TOP_SCROLL = unsafeCastStringToDOMTopLevelType('scroll');
    var TOP_SEEKED = unsafeCastStringToDOMTopLevelType('seeked');
    var TOP_SEEKING = unsafeCastStringToDOMTopLevelType('seeking');
    var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType('selectionchange');
    var TOP_STALLED = unsafeCastStringToDOMTopLevelType('stalled');
    var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType('submit');
    var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType('suspend');
    var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType('textInput');
    var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType('timeupdate');
    var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType('toggle');
    var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType('touchcancel');
    var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType('touchend');
    var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType('touchmove');
    var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType('touchstart');
    var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('transitionend'));
    var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType('volumechange');
    var TOP_WAITING = unsafeCastStringToDOMTopLevelType('waiting');
    var TOP_WHEEL = unsafeCastStringToDOMTopLevelType('wheel'); // List of events that need to be individually attached to media elements.
    // Note that events in this list will *not* be listened to at the top level
    // unless they're explicitly whitelisted in `ReactBrowserEventEmitter.listenTo`.
    var mediaEventTypes = [
        TOP_ABORT,
        TOP_CAN_PLAY,
        TOP_CAN_PLAY_THROUGH,
        TOP_DURATION_CHANGE,
        TOP_EMPTIED,
        TOP_ENCRYPTED,
        TOP_ENDED,
        TOP_ERROR,
        TOP_LOADED_DATA,
        TOP_LOADED_METADATA,
        TOP_LOAD_START,
        TOP_PAUSE,
        TOP_PLAY,
        TOP_PLAYING,
        TOP_PROGRESS,
        TOP_RATE_CHANGE,
        TOP_SEEKED,
        TOP_SEEKING,
        TOP_STALLED,
        TOP_SUSPEND,
        TOP_TIME_UPDATE,
        TOP_VOLUME_CHANGE,
        TOP_WAITING
    ];
    function getRawEventName(topLevelType) {
        return unsafeCastDOMTopLevelTypeToString(topLevelType);
    }
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map; // prettier-ignore
    var elementListenerMap = new PossiblyWeakMap();
    function getListenerMapForElement(element) {
        var listenerMap = elementListenerMap.get(element);
        if (listenerMap === undefined) {
            listenerMap = new Map();
            elementListenerMap.set(element, listenerMap);
        }
        return listenerMap;
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternalFiber;
    }
    function has(key) {
        return key._reactInternalFiber !== undefined;
    }
    function set(key, value) {
        key._reactInternalFiber = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoEffect = /*              */ 0;
    var PerformedWork = /*         */ 1; // You can change the rest (and add more).
    var Placement = /*             */ 2;
    var Update = /*                */ 4;
    var PlacementAndUpdate = /*    */ 6;
    var Deletion = /*              */ 8;
    var ContentReset = /*          */ 16;
    var Callback = /*              */ 32;
    var DidCapture = /*            */ 64;
    var Ref = /*                   */ 128;
    var Snapshot = /*              */ 256;
    var Passive = /*               */ 512;
    var Hydrating = /*             */ 1024;
    var HydratingAndUpdate = /*    */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*   */ 932; // Union of all host effects
    var HostEffectMask = /*        */ 2047;
    var Incomplete = /*            */ 2048;
    var ShouldCapture = /*         */ 4096;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    /**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */ function accumulateInto(current, next) {
        if (!(next != null)) throw Error("accumulateInto(...): Accumulated items must not be null or undefined.");
        if (current == null) return next;
         // Both are not empty. Warning: Never call x.concat(y) when you are not
        // certain that x is an Array (x could be a string with concat method).
        if (Array.isArray(current)) {
            if (Array.isArray(next)) {
                current.push.apply(current, next);
                return current;
            }
            current.push(next);
            return current;
        }
        if (Array.isArray(next)) // A bit too dangerous to mutate `next`.
        return [
            current
        ].concat(next);
        return [
            current,
            next
        ];
    }
    /**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 * @param {function} cb Callback invoked with each element or a collection.
 * @param {?} [scope] Scope used as `this` in a callback.
 */ function forEachAccumulated(arr, cb, scope) {
        if (Array.isArray(arr)) arr.forEach(cb, scope);
        else if (arr) cb.call(scope, arr);
    }
    /**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */ var eventQueue = null;
    /**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @private
 */ var executeDispatchesAndRelease = function(event) {
        if (event) {
            executeDispatchesInOrder(event);
            if (!event.isPersistent()) event.constructor.release(event);
        }
    };
    var executeDispatchesAndReleaseTopLevel = function(e) {
        return executeDispatchesAndRelease(e);
    };
    function runEventsInBatch(events) {
        if (events !== null) eventQueue = accumulateInto(eventQueue, events);
         // Set `eventQueue` to null before processing it so that we can tell if more
        // events get enqueued while processing.
        var processingEventQueue = eventQueue;
        eventQueue = null;
        if (!processingEventQueue) return;
        forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
        if (!!eventQueue) throw Error("processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.");
         // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    /**
 * Summary of `DOMEventPluginSystem` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactDOMEventListener, which is injected and can therefore support
 *    pluggable event sources. This is the only work that occurs in the main
 *    thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginRegistry`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginRegistry` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginRegistry` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|PluginRegistry|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */ var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
    var callbackBookkeepingPool = [];
    function releaseTopLevelCallbackBookKeeping(instance) {
        instance.topLevelType = null;
        instance.nativeEvent = null;
        instance.targetInst = null;
        instance.ancestors.length = 0;
        if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) callbackBookkeepingPool.push(instance);
    } // Used to store ancestor hierarchy in top level callback
    function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags) {
        if (callbackBookkeepingPool.length) {
            var instance = callbackBookkeepingPool.pop();
            instance.topLevelType = topLevelType;
            instance.eventSystemFlags = eventSystemFlags;
            instance.nativeEvent = nativeEvent;
            instance.targetInst = targetInst;
            return instance;
        }
        return {
            topLevelType: topLevelType,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetInst: targetInst,
            ancestors: []
        };
    }
    /**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */ function findRootContainerNode(inst) {
        if (inst.tag === HostRoot) return inst.stateNode.containerInfo;
         // TODO: It may be a good idea to cache this to prevent unnecessary DOM
        // traversal, but caching is difficult to do correctly without using a
        // mutation observer to listen for all DOM changes.
        while(inst.return)inst = inst.return;
        if (inst.tag !== HostRoot) // This can happen if we're in a detached tree.
        return null;
        return inst.stateNode.containerInfo;
    }
    /**
 * Allows registered plugins an opportunity to extract events from top-level
 * native browser events.
 *
 * @return {*} An accumulation of synthetic events.
 * @internal
 */ function extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = null;
        for(var i = 0; i < plugins.length; i++){
            // Not every plugin in the ordering may be loaded at runtime.
            var possiblePlugin = plugins[i];
            if (possiblePlugin) {
                var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
                if (extractedEvents) events = accumulateInto(events, extractedEvents);
            }
        }
        return events;
    }
    function runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        runEventsInBatch(events);
    }
    function handleTopLevel(bookKeeping) {
        var targetInst = bookKeeping.targetInst; // Loop through the hierarchy, in case there's any nested components.
        // It's important that we build the array of ancestors before calling any
        // event handlers, because event handlers can modify the DOM, leading to
        // inconsistencies with ReactMount's node cache. See #1105.
        var ancestor = targetInst;
        do {
            if (!ancestor) {
                var ancestors = bookKeeping.ancestors;
                ancestors.push(ancestor);
                break;
            }
            var root = findRootContainerNode(ancestor);
            if (!root) break;
            var tag = ancestor.tag;
            if (tag === HostComponent || tag === HostText) bookKeeping.ancestors.push(ancestor);
            ancestor = getClosestInstanceFromNode(root);
        }while (ancestor);
        for(var i = 0; i < bookKeeping.ancestors.length; i++){
            targetInst = bookKeeping.ancestors[i];
            var eventTarget = getEventTarget(bookKeeping.nativeEvent);
            var topLevelType = bookKeeping.topLevelType;
            var nativeEvent = bookKeeping.nativeEvent;
            var eventSystemFlags = bookKeeping.eventSystemFlags; // If this is the first ancestor, we mark it on the system flags
            if (i === 0) eventSystemFlags |= IS_FIRST_ANCESTOR;
            runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, eventTarget, eventSystemFlags);
        }
    }
    function dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst) {
        var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags);
        try {
            // Event queue being processed in the same cycle allows
            // `preventDefault`.
            batchedEventUpdates(handleTopLevel, bookKeeping);
        } finally{
            releaseTopLevelCallbackBookKeeping(bookKeeping);
        }
    }
    /**
 * We listen for bubbled touch events on the document object.
 *
 * Firefox v8.01 (and possibly others) exhibited strange behavior when
 * mounting `onmousemove` events at some node that was not the document
 * element. The symptoms were that if your mouse is not moving over something
 * contained within that mount point (for example on the background) the
 * top-level listeners for `onmousemove` won't be called. However, if you
 * register the `mousemove` on the document object, then it will of course
 * catch all `mousemove`s. This along with iOS quirks, justifies restricting
 * top-level listeners to the document object only, at least for these
 * movement types of events and possibly all events.
 *
 * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
 *
 * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
 * they bubble to document.
 *
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @param {object} mountAt Container where to mount the listener
 */ function legacyListenToEvent(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for(var i = 0; i < dependencies.length; i++){
            var dependency = dependencies[i];
            legacyListenToTopLevelEvent(dependency, mountAt, listenerMap);
        }
    }
    function legacyListenToTopLevelEvent(topLevelType, mountAt, listenerMap) {
        if (!listenerMap.has(topLevelType)) {
            switch(topLevelType){
                case TOP_SCROLL:
                    trapCapturedEvent(TOP_SCROLL, mountAt);
                    break;
                case TOP_FOCUS:
                case TOP_BLUR:
                    trapCapturedEvent(TOP_FOCUS, mountAt);
                    trapCapturedEvent(TOP_BLUR, mountAt); // We set the flag for a single dependency later in this function,
                    // but this ensures we mark both as attached rather than just one.
                    listenerMap.set(TOP_BLUR, null);
                    listenerMap.set(TOP_FOCUS, null);
                    break;
                case TOP_CANCEL:
                case TOP_CLOSE:
                    if (isEventSupported(getRawEventName(topLevelType))) trapCapturedEvent(topLevelType, mountAt);
                    break;
                case TOP_INVALID:
                case TOP_SUBMIT:
                case TOP_RESET:
                    break;
                default:
                    // By default, listen on the top level to all non-media events.
                    // Media events don't bubble so adding the listener wouldn't do anything.
                    var isMediaEvent = mediaEventTypes.indexOf(topLevelType) !== -1;
                    if (!isMediaEvent) trapBubbledEvent(topLevelType, mountAt);
                    break;
            }
            listenerMap.set(topLevelType, null);
        }
    }
    function isListeningToAllDependencies(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for(var i = 0; i < dependencies.length; i++){
            var dependency = dependencies[i];
            if (!listenerMap.has(dependency)) return false;
        }
        return true;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        TOP_MOUSE_DOWN,
        TOP_MOUSE_UP,
        TOP_TOUCH_CANCEL,
        TOP_TOUCH_END,
        TOP_TOUCH_START,
        TOP_AUX_CLICK,
        TOP_DOUBLE_CLICK,
        TOP_POINTER_CANCEL,
        TOP_POINTER_DOWN,
        TOP_POINTER_UP,
        TOP_DRAG_END,
        TOP_DRAG_START,
        TOP_DROP,
        TOP_COMPOSITION_END,
        TOP_COMPOSITION_START,
        TOP_KEY_DOWN,
        TOP_KEY_PRESS,
        TOP_KEY_UP,
        TOP_INPUT,
        TOP_TEXT_INPUT,
        TOP_CLOSE,
        TOP_CANCEL,
        TOP_COPY,
        TOP_CUT,
        TOP_PASTE,
        TOP_CLICK,
        TOP_CHANGE,
        TOP_CONTEXT_MENU,
        TOP_RESET,
        TOP_SUBMIT
    ];
    var continuousReplayableEvents = [
        TOP_FOCUS,
        TOP_BLUR,
        TOP_DRAG_ENTER,
        TOP_DRAG_LEAVE,
        TOP_MOUSE_OVER,
        TOP_MOUSE_OUT,
        TOP_POINTER_OVER,
        TOP_POINTER_OUT,
        TOP_GOT_POINTER_CAPTURE,
        TOP_LOST_POINTER_CAPTURE
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function trapReplayableEventForDocument(topLevelType, document1, listenerMap) {
        legacyListenToTopLevelEvent(topLevelType, document1, listenerMap);
    }
    function eagerlyTrapReplayableEvents(container, document1) {
        var listenerMapForDoc = getListenerMapForElement(document1); // Discrete
        discreteReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document1, listenerMapForDoc);
        }); // Continuous
        continuousReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document1, listenerMapForDoc);
        });
    }
    function createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        return {
            blockedOn: blockedOn,
            topLevelType: topLevelType,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            container: container
        };
    }
    function queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_FOCUS:
            case TOP_BLUR:
                queuedFocus = null;
                break;
            case TOP_DRAG_ENTER:
            case TOP_DRAG_LEAVE:
                queuedDrag = null;
                break;
            case TOP_MOUSE_OVER:
            case TOP_MOUSE_OUT:
                queuedMouse = null;
                break;
            case TOP_POINTER_OVER:
            case TOP_POINTER_OUT:
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case TOP_GOT_POINTER_CAPTURE:
            case TOP_LOST_POINTER_CAPTURE:
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode$1(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags and store a single event to be
        // replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(topLevelType){
            case TOP_FOCUS:
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, topLevelType, eventSystemFlags, container, focusEvent);
                return true;
            case TOP_DRAG_ENTER:
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, topLevelType, eventSystemFlags, container, dragEvent);
                return true;
            case TOP_MOUSE_OVER:
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, topLevelType, eventSystemFlags, container, mouseEvent);
                return true;
            case TOP_POINTER_OVER:
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, topLevelType, eventSystemFlags, container, pointerEvent));
                return true;
            case TOP_GOT_POINTER_CAPTURE:
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, topLevelType, eventSystemFlags, container, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var nextBlockedOn = attemptToDispatchEvent(queuedEvent.topLevelType, queuedEvent.eventSystemFlags, queuedEvent.container, queuedEvent.nativeEvent);
        if (nextBlockedOn !== null) {
            // We're still blocked. Try again later.
            var _fiber3 = getInstanceFromNode$1(nextBlockedOn);
            if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
            queuedEvent.blockedOn = nextBlockedOn;
            return false;
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode$1(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.topLevelType, nextDiscreteEvent.eventSystemFlags, nextDiscreteEvent.container, nextDiscreteEvent.nativeEvent);
            if (nextBlockedOn !== null) // We're still blocked. Try again later.
            nextDiscreteEvent.blockedOn = nextBlockedOn;
            else // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    function addEventBubbleListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, false);
    }
    function addEventCaptureListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, true);
    }
    // do it in two places, which duplicates logic
    // and increases the bundle size, we do it all
    // here once. If we remove or refactor the
    // SimpleEventPlugin, we should also remove or
    // update the below line.
    var simpleEventPluginEventTypes = {};
    var topLevelEventsToDispatchConfig = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        TOP_BLUR,
        'blur',
        TOP_CANCEL,
        'cancel',
        TOP_CLICK,
        'click',
        TOP_CLOSE,
        'close',
        TOP_CONTEXT_MENU,
        'contextMenu',
        TOP_COPY,
        'copy',
        TOP_CUT,
        'cut',
        TOP_AUX_CLICK,
        'auxClick',
        TOP_DOUBLE_CLICK,
        'doubleClick',
        TOP_DRAG_END,
        'dragEnd',
        TOP_DRAG_START,
        'dragStart',
        TOP_DROP,
        'drop',
        TOP_FOCUS,
        'focus',
        TOP_INPUT,
        'input',
        TOP_INVALID,
        'invalid',
        TOP_KEY_DOWN,
        'keyDown',
        TOP_KEY_PRESS,
        'keyPress',
        TOP_KEY_UP,
        'keyUp',
        TOP_MOUSE_DOWN,
        'mouseDown',
        TOP_MOUSE_UP,
        'mouseUp',
        TOP_PASTE,
        'paste',
        TOP_PAUSE,
        'pause',
        TOP_PLAY,
        'play',
        TOP_POINTER_CANCEL,
        'pointerCancel',
        TOP_POINTER_DOWN,
        'pointerDown',
        TOP_POINTER_UP,
        'pointerUp',
        TOP_RATE_CHANGE,
        'rateChange',
        TOP_RESET,
        'reset',
        TOP_SEEKED,
        'seeked',
        TOP_SUBMIT,
        'submit',
        TOP_TOUCH_CANCEL,
        'touchCancel',
        TOP_TOUCH_END,
        'touchEnd',
        TOP_TOUCH_START,
        'touchStart',
        TOP_VOLUME_CHANGE,
        'volumeChange'
    ];
    var otherDiscreteEvents = [
        TOP_CHANGE,
        TOP_SELECTION_CHANGE,
        TOP_TEXT_INPUT,
        TOP_COMPOSITION_START,
        TOP_COMPOSITION_END,
        TOP_COMPOSITION_UPDATE
    ]; // prettier-ignore
    var userBlockingPairsForSimpleEventPlugin = [
        TOP_DRAG,
        'drag',
        TOP_DRAG_ENTER,
        'dragEnter',
        TOP_DRAG_EXIT,
        'dragExit',
        TOP_DRAG_LEAVE,
        'dragLeave',
        TOP_DRAG_OVER,
        'dragOver',
        TOP_MOUSE_MOVE,
        'mouseMove',
        TOP_MOUSE_OUT,
        'mouseOut',
        TOP_MOUSE_OVER,
        'mouseOver',
        TOP_POINTER_MOVE,
        'pointerMove',
        TOP_POINTER_OUT,
        'pointerOut',
        TOP_POINTER_OVER,
        'pointerOver',
        TOP_SCROLL,
        'scroll',
        TOP_TOGGLE,
        'toggle',
        TOP_TOUCH_MOVE,
        'touchMove',
        TOP_WHEEL,
        'wheel'
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        TOP_ABORT,
        'abort',
        TOP_ANIMATION_END,
        'animationEnd',
        TOP_ANIMATION_ITERATION,
        'animationIteration',
        TOP_ANIMATION_START,
        'animationStart',
        TOP_CAN_PLAY,
        'canPlay',
        TOP_CAN_PLAY_THROUGH,
        'canPlayThrough',
        TOP_DURATION_CHANGE,
        'durationChange',
        TOP_EMPTIED,
        'emptied',
        TOP_ENCRYPTED,
        'encrypted',
        TOP_ENDED,
        'ended',
        TOP_ERROR,
        'error',
        TOP_GOT_POINTER_CAPTURE,
        'gotPointerCapture',
        TOP_LOAD,
        'load',
        TOP_LOADED_DATA,
        'loadedData',
        TOP_LOADED_METADATA,
        'loadedMetadata',
        TOP_LOAD_START,
        'loadStart',
        TOP_LOST_POINTER_CAPTURE,
        'lostPointerCapture',
        TOP_PLAYING,
        'playing',
        TOP_PROGRESS,
        'progress',
        TOP_SEEKING,
        'seeking',
        TOP_STALLED,
        'stalled',
        TOP_SUSPEND,
        'suspend',
        TOP_TIME_UPDATE,
        'timeUpdate',
        TOP_TRANSITION_END,
        'transitionEnd',
        TOP_WAITING,
        'waiting'
    ];
    /**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: [TOP_ABORT],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = new Map([
 *   [TOP_ABORT, { sameConfig }],
 * ]);
 */ function processSimpleEventPluginPairsByPriority(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var onEvent = 'on' + capitalizedEvent;
            var config = {
                phasedRegistrationNames: {
                    bubbled: onEvent,
                    captured: onEvent + 'Capture'
                },
                dependencies: [
                    topEvent
                ],
                eventPriority: priority
            };
            eventPriorities.set(topEvent, priority);
            topLevelEventsToDispatchConfig.set(topEvent, config);
            simpleEventPluginEventTypes[event] = config;
        }
    }
    function processTopEventPairsByPriority(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    } // SimpleEventPlugin
    processSimpleEventPluginPairsByPriority(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
    processSimpleEventPluginPairsByPriority(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
    processSimpleEventPluginPairsByPriority(continuousPairsForSimpleEventPlugin, ContinuousEvent); // Not used by SimpleEventPlugin
    processTopEventPairsByPriority(otherDiscreteEvents, DiscreteEvent);
    function getEventPriorityForPluginSystem(topLevelType) {
        var priority = eventPriorities.get(topLevelType); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true;
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function trapBubbledEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, false);
    }
    function trapCapturedEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, true);
    }
    function trapEventForPluginEventSystem(container, topLevelType, capture) {
        var listener;
        switch(getEventPriorityForPluginSystem(topLevelType)){
            case DiscreteEvent:
                listener = dispatchDiscreteEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
            case UserBlockingEvent:
                listener = dispatchUserBlockingUpdate.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
            case ContinuousEvent:
            default:
                listener = dispatchEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
        }
        var rawEventName = getRawEventName(topLevelType);
        if (capture) addEventCaptureListener(container, rawEventName, listener);
        else addEventBubbleListener(container, rawEventName, listener);
    }
    function dispatchDiscreteEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, topLevelType, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(topLevelType, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority, dispatchEvent.bind(null, topLevelType, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        if (!_enabled) return;
        if (hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(topLevelType)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, topLevelType, eventSystemFlags, container, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            clearIfContinuousEvent(topLevelType, nativeEvent);
            return;
        }
        if (isReplayableDiscreteEvent(topLevelType)) {
            // This this to be replayed later once the target is available.
            queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent)) return;
         // We need to clear only if we didn't queue because
        // queueing is accummulative.
        clearIfContinuousEvent(topLevelType, nativeEvent); // This is not replayable so we'll invoke it but without a target,
        dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, null);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst);
        return null;
    }
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a whitelist for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    var ReactDebugCurrentFrame$3 = null;
    ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ReactDebugCurrentFrame$3.getStackAddendum());
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === 'object')) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ReactDebugCurrentFrame$3.getStackAddendum());
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this whitelist too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG whitelist, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, canUseEventSystem) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (canUseEventSystem) {
            if (registrationNameModules.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, canUseEventSystem) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type);
    };
    function validateProperties$2(type, props, canUseEventSystem) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, canUseEventSystem);
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // Chrome is the only major browser not shipping <time>. But as of July
        // 2017 it intends to ship it due to widespread usage. We intentionally
        // *don't* warn for <time> even if it's unrecognized by Chrome because
        // it soon will be, and many apps have been using it anyway.
        time: true,
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, /* canUseEventSystem */ true);
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function ensureListeningTo(rootContainerElement, registrationName) {
        var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
        var doc = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
        legacyListenToEvent(registrationName, doc);
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'iframe':
            case 'object':
            case 'embed':
                trapBubbledEvent(TOP_LOAD, domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // Create listener for each media event
                for(var i = 0; i < mediaEventTypes.length; i++)trapBubbledEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                trapBubbledEvent(TOP_ERROR, domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                trapBubbledEvent(TOP_ERROR, domElement);
                trapBubbledEvent(TOP_LOAD, domElement);
                props = rawProps;
                break;
            case 'form':
                trapBubbledEvent(TOP_RESET, domElement);
                trapBubbledEvent(TOP_SUBMIT, domElement);
                props = rawProps;
                break;
            case 'details':
                trapBubbledEvent(TOP_TOGGLE, domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'option':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the whitelist in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (lastProp !== nextProp && (typeof nextProp === 'string' || typeof nextProp === 'number')) (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the whitelist during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'iframe':
            case 'object':
            case 'embed':
                trapBubbledEvent(TOP_LOAD, domElement);
                break;
            case 'video':
            case 'audio':
                // Create listener for each media event
                for(var i = 0; i < mediaEventTypes.length; i++)trapBubbledEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                trapBubbledEvent(TOP_ERROR, domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                trapBubbledEvent(TOP_ERROR, domElement);
                trapBubbledEvent(TOP_LOAD, domElement);
                break;
            case 'form':
                trapBubbledEvent(TOP_RESET, domElement);
                trapBubbledEvent(TOP_SUBMIT, domElement);
                break;
            case 'details':
                trapBubbledEvent(TOP_TOGGLE, domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, 'onChange');
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is whitelisted
                case 'data-reactroot':
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
            } else if (typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    var expectedHTML = normalizeHTML(domElement, nextHtml != null ? nextHtml : '');
                    if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            // Used by Flare
            activeElementDetached: null,
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start, end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var addendum = getCurrentFiberStackInDev();
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + addendum;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        setEnabled(false);
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps, rootContainerInstance);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function shouldDeprioritizeSubtree(type, props) {
        return !!props.hidden;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactInternalInstance$' + randomKey;
    var internalEventHandlersKey = '__reactEventHandlers$' + randomKey;
    var internalContainerInstanceKey = '__reactContainere$' + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode$1(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance$1(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode$1(node) {
        return node[internalEventHandlersKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalEventHandlersKey] = props;
    }
    function getParent(inst) {
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var depthA = 0;
        for(var tempA = instA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = instB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            instA = getParent(instA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            instB = getParent(instB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (instA === instB || instA === instB.alternate) return instA;
            instA = getParent(instA);
            instB = getParent(instB);
        }
        return null;
    }
    /**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */ function traverseTwoPhase(inst, fn, arg) {
        var path = [];
        while(inst){
            path.push(inst);
            inst = getParent(inst);
        }
        var i;
        for(i = path.length; i-- > 0;)fn(path[i], 'captured', arg);
        for(i = 0; i < path.length; i++)fn(path[i], 'bubbled', arg);
    }
    /**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */ function traverseEnterLeave(from, to, fn, argFrom, argTo) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        var pathFrom = [];
        while(true){
            if (!from) break;
            if (from === common) break;
            var alternate = from.alternate;
            if (alternate !== null && alternate === common) break;
            pathFrom.push(from);
            from = getParent(from);
        }
        var pathTo = [];
        while(true){
            if (!to) break;
            if (to === common) break;
            var _alternate = to.alternate;
            if (_alternate !== null && _alternate === common) break;
            pathTo.push(to);
            to = getParent(to);
        }
        for(var i = 0; i < pathFrom.length; i++)fn(pathFrom[i], 'bubbled', argFrom);
        for(var _i = pathTo.length; _i-- > 0;)fn(pathTo[_i], 'captured', argTo);
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var listener; // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon
        var stateNode = inst.stateNode;
        if (!stateNode) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (!props) // Work in progress.
        return null;
        listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === 'function')) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    /**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */ function listenerAtPhase(inst, event, propagationPhase) {
        var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
        return getListener(inst, registrationName);
    }
    /**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing even a
 * single one.
 */ /**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */ function accumulateDirectionalDispatches(inst, phase, event) {
        if (!inst) error('Dispatching inst must not be null');
        var listener = listenerAtPhase(inst, event, phase);
        if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
        }
    }
    /**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */ function accumulateTwoPhaseDispatchesSingle(event) {
        if (event && event.dispatchConfig.phasedRegistrationNames) traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
    }
    /**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */ function accumulateDispatches(inst, ignoredDirection, event) {
        if (inst && event && event.dispatchConfig.registrationName) {
            var registrationName = event.dispatchConfig.registrationName;
            var listener = getListener(inst, registrationName);
            if (listener) {
                event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
                event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
            }
        }
    }
    /**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */ function accumulateDirectDispatchesSingle(event) {
        if (event && event.dispatchConfig.registrationName) accumulateDispatches(event._targetInst, null, event);
    }
    function accumulateTwoPhaseDispatches(events) {
        forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
    }
    function accumulateEnterLeaveDispatches(leave, enter, from, to) {
        traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
    }
    function accumulateDirectDispatches(events) {
        forEachAccumulated(events, accumulateDirectDispatchesSingle);
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    var EVENT_POOL_SIZE = 10;
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        type: null,
        target: null,
        // currentTarget is set when dispatching; no use in copying it here
        currentTarget: function() {
            return null;
        },
        eventPhase: null,
        bubbles: null,
        cancelable: null,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: null,
        isTrusted: null
    };
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    }
    /**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */ function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
        // these have a getter/setter for warnings
        delete this.nativeEvent;
        delete this.preventDefault;
        delete this.stopPropagation;
        delete this.isDefaultPrevented;
        delete this.isPropagationStopped;
        this.dispatchConfig = dispatchConfig;
        this._targetInst = targetInst;
        this.nativeEvent = nativeEvent;
        var Interface = this.constructor.Interface;
        for(var propName in Interface){
            if (!Interface.hasOwnProperty(propName)) continue;
            delete this[propName]; // this has a getter/setter for warnings
            var normalize = Interface[propName];
            if (normalize) this[propName] = normalize(nativeEvent);
            else if (propName === 'target') this.target = nativeEventTarget;
            else this[propName] = nativeEvent[propName];
        }
        var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
        if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
        else this.isDefaultPrevented = functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    _assign(SyntheticEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;
            if (!event) return;
            if (event.preventDefault) event.preventDefault();
            else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
            this.isDefaultPrevented = functionThatReturnsTrue;
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            if (!event) return;
            if (event.stopPropagation) event.stopPropagation();
            else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
            // IE. This event does not support bubbling or cancelling, and
            // any references to cancelBubble throw "Member not found".  A
            // typeof check of "unknown" circumvents this issue (and is also
            // IE specific).
            event.cancelBubble = true;
            this.isPropagationStopped = functionThatReturnsTrue;
        },
        /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */ persist: function() {
            this.isPersistent = functionThatReturnsTrue;
        },
        /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */ isPersistent: functionThatReturnsFalse,
        /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */ destructor: function() {
            var Interface = this.constructor.Interface;
            for(var propName in Interface)Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
            this.dispatchConfig = null;
            this._targetInst = null;
            this.nativeEvent = null;
            this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            this._dispatchListeners = null;
            this._dispatchInstances = null;
            Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
            Object.defineProperty(this, 'isDefaultPrevented', getPooledWarningPropertyDefinition('isDefaultPrevented', functionThatReturnsFalse));
            Object.defineProperty(this, 'isPropagationStopped', getPooledWarningPropertyDefinition('isPropagationStopped', functionThatReturnsFalse));
            Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', function() {}));
            Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', function() {}));
        }
    });
    SyntheticEvent.Interface = EventInterface;
    /**
 * Helper to reduce boilerplate when creating subclasses.
 */ SyntheticEvent.extend = function(Interface) {
        var Super = this;
        var E = function() {};
        E.prototype = Super.prototype;
        var prototype = new E();
        function Class() {
            return Super.apply(this, arguments);
        }
        _assign(prototype, Class.prototype);
        Class.prototype = prototype;
        Class.prototype.constructor = Class;
        Class.Interface = _assign({}, Super.Interface, Interface);
        Class.extend = Super.extend;
        addEventPoolingTo(Class);
        return Class;
    };
    addEventPoolingTo(SyntheticEvent);
    /**
 * Helper to nullify syntheticEvent instance properties when destructing
 *
 * @param {String} propName
 * @param {?object} getVal
 * @return {object} defineProperty object
 */ function getPooledWarningPropertyDefinition(propName, getVal) {
        var isFunction = typeof getVal === 'function';
        return {
            configurable: true,
            set: set,
            get: get
        };
        function set(val) {
            var action = isFunction ? 'setting the method' : 'setting the property';
            warn(action, 'This is effectively a no-op');
            return val;
        }
        function get() {
            var action = isFunction ? 'accessing the method' : 'accessing the property';
            var result = isFunction ? 'This is a no-op function' : 'This is set to null';
            warn(action, result);
            return getVal;
        }
        function warn(action, result) {
            error("This synthetic event is reused for performance reasons. If you're seeing this, you're %s `%s` on a released/nullified synthetic event. %s. If you must keep the original synthetic event around, use event.persist(). See https://fb.me/react-event-pooling for more information.", action, propName, result);
        }
    }
    function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
        var EventConstructor = this;
        if (EventConstructor.eventPool.length) {
            var instance = EventConstructor.eventPool.pop();
            EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
            return instance;
        }
        return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
    }
    function releasePooledEvent(event) {
        var EventConstructor = this;
        if (!(event instanceof EventConstructor)) throw Error("Trying to release an event instance into a pool of a different type.");
        event.destructor();
        if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) EventConstructor.eventPool.push(event);
    }
    function addEventPoolingTo(EventConstructor) {
        EventConstructor.eventPool = [];
        EventConstructor.getPooled = getPooledEvent;
        EventConstructor.release = releasePooledEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var SyntheticCompositionEvent = SyntheticEvent.extend({
        data: null
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ var SyntheticInputEvent = SyntheticEvent.extend({
        data: null
    });
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE); // Events and their corresponding property names.
    var eventTypes = {
        beforeInput: {
            phasedRegistrationNames: {
                bubbled: 'onBeforeInput',
                captured: 'onBeforeInputCapture'
            },
            dependencies: [
                TOP_COMPOSITION_END,
                TOP_KEY_PRESS,
                TOP_TEXT_INPUT,
                TOP_PASTE
            ]
        },
        compositionEnd: {
            phasedRegistrationNames: {
                bubbled: 'onCompositionEnd',
                captured: 'onCompositionEndCapture'
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_END,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        },
        compositionStart: {
            phasedRegistrationNames: {
                bubbled: 'onCompositionStart',
                captured: 'onCompositionStartCapture'
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_START,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        },
        compositionUpdate: {
            phasedRegistrationNames: {
                bubbled: 'onCompositionUpdate',
                captured: 'onCompositionUpdateCapture'
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_UPDATE,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        }
    }; // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */ function getCompositionEventType(topLevelType) {
        switch(topLevelType){
            case TOP_COMPOSITION_START:
                return eventTypes.compositionStart;
            case TOP_COMPOSITION_END:
                return eventTypes.compositionEnd;
            case TOP_COMPOSITION_UPDATE:
                return eventTypes.compositionUpdate;
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isFallbackCompositionStart(topLevelType, nativeEvent) {
        return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isFallbackCompositionEnd(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_KEY_UP:
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case TOP_KEY_DOWN:
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case TOP_KEY_PRESS:
            case TOP_MOUSE_DOWN:
            case TOP_BLUR:
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(topLevelType);
        else if (!isComposing) {
            if (isFallbackCompositionStart(topLevelType, nativeEvent)) eventType = eventTypes.compositionStart;
        } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) eventType = eventTypes.compositionEnd;
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === eventTypes.compositionStart) isComposing = initialize(nativeEventTarget);
            else if (eventType === eventTypes.compositionEnd) {
                if (isComposing) fallbackData = getData();
            }
        }
        var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
        if (fallbackData) // Inject data generated from fallback path into the synthetic event.
        // This matches the property of native CompositionEventInterface.
        event.data = fallbackData;
        else {
            var customData = getDataFromCustomEvent(nativeEvent);
            if (customData !== null) event.data = customData;
        }
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * @param {TopLevelType} topLevelType Number from `TopLevelType`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */ function getNativeBeforeInputChars(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_COMPOSITION_END:
                return getDataFromCustomEvent(nativeEvent);
            case TOP_KEY_PRESS:
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case TOP_TEXT_INPUT:
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {number} topLevelType Number from `TopLevelEventTypes`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */ function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(topLevelType){
            case TOP_PASTE:
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case TOP_KEY_PRESS:
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case TOP_COMPOSITION_END:
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
        else chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
        event.data = chars;
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ var BeforeInputEventPlugin = {
        eventTypes: eventTypes,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            if (composition === null) return beforeInput;
            if (beforeInput === null) return composition;
            return [
                composition,
                beforeInput
            ];
        }
    };
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    var eventTypes$1 = {
        change: {
            phasedRegistrationNames: {
                bubbled: 'onChange',
                captured: 'onChangeCapture'
            },
            dependencies: [
                TOP_BLUR,
                TOP_CHANGE,
                TOP_CLICK,
                TOP_FOCUS,
                TOP_INPUT,
                TOP_KEY_DOWN,
                TOP_KEY_UP,
                TOP_SELECTION_CHANGE
            ]
        }
    };
    function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
        var event = SyntheticEvent.getPooled(eventTypes$1.change, inst, nativeEvent, target);
        event.type = 'change'; // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, event);
    }
    function runEventInBatch(event) {
        runEventsInBatch(event);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance$1(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CHANGE) return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
        if (topLevelType === TOP_FOCUS) {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (topLevelType === TOP_BLUR) stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
        if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CLICK) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ var ChangeEventPlugin = {
        eventTypes: eventTypes$1,
        _isInputEventSupported: isInputEventSupported,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            var getTargetInstFunc, handleEventFunc;
            if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
            else if (isTextInputElement(targetNode)) {
                if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                else {
                    getTargetInstFunc = getTargetInstForInputEventPolyfill;
                    handleEventFunc = handleEventsForInputEventPolyfill;
                }
            } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
            if (getTargetInstFunc) {
                var inst = getTargetInstFunc(topLevelType, targetInst);
                if (inst) {
                    var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                    return event;
                }
            }
            if (handleEventFunc) handleEventFunc(topLevelType, targetNode, targetInst);
             // When blurring, set the value attribute for number inputs
            if (topLevelType === TOP_BLUR) handleControlledInputBlur(targetNode);
        }
    };
    var SyntheticUIEvent = SyntheticEvent.extend({
        view: null,
        detail: null
    });
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    var previousScreenX = 0;
    var previousScreenY = 0; // Use flags to signal movementX/Y has already been set
    var isMovementXSet = false;
    var isMovementYSet = false;
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticMouseEvent = SyntheticUIEvent.extend({
        screenX: null,
        screenY: null,
        clientX: null,
        clientY: null,
        pageX: null,
        pageY: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        getModifierState: getEventModifierState,
        button: null,
        buttons: null,
        relatedTarget: function(event) {
            return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            var screenX = previousScreenX;
            previousScreenX = event.screenX;
            if (!isMovementXSet) {
                isMovementXSet = true;
                return 0;
            }
            return event.type === 'mousemove' ? event.screenX - screenX : 0;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
            var screenY = previousScreenY;
            previousScreenY = event.screenY;
            if (!isMovementYSet) {
                isMovementYSet = true;
                return 0;
            }
            return event.type === 'mousemove' ? event.screenY - screenY : 0;
        }
    });
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var SyntheticPointerEvent = SyntheticMouseEvent.extend({
        pointerId: null,
        width: null,
        height: null,
        pressure: null,
        tangentialPressure: null,
        tiltX: null,
        tiltY: null,
        twist: null,
        pointerType: null,
        isPrimary: null
    });
    var eventTypes$2 = {
        mouseEnter: {
            registrationName: 'onMouseEnter',
            dependencies: [
                TOP_MOUSE_OUT,
                TOP_MOUSE_OVER
            ]
        },
        mouseLeave: {
            registrationName: 'onMouseLeave',
            dependencies: [
                TOP_MOUSE_OUT,
                TOP_MOUSE_OVER
            ]
        },
        pointerEnter: {
            registrationName: 'onPointerEnter',
            dependencies: [
                TOP_POINTER_OUT,
                TOP_POINTER_OVER
            ]
        },
        pointerLeave: {
            registrationName: 'onPointerLeave',
            dependencies: [
                TOP_POINTER_OUT,
                TOP_POINTER_OVER
            ]
        }
    };
    var EnterLeaveEventPlugin = {
        eventTypes: eventTypes$2,
        /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */ extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
            var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;
            if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0 && (nativeEvent.relatedTarget || nativeEvent.fromElement)) // If this is an over event with a target, then we've already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            return null;
            if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
            return null;
            var win;
            if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
            win = nativeEventTarget;
            else {
                // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                var doc = nativeEventTarget.ownerDocument;
                if (doc) win = doc.defaultView || doc.parentWindow;
                else win = window;
            }
            var from;
            var to;
            if (isOutEvent) {
                from = targetInst;
                var related = nativeEvent.relatedTarget || nativeEvent.toElement;
                to = related ? getClosestInstanceFromNode(related) : null;
                if (to !== null) {
                    var nearestMounted = getNearestMountedFiber(to);
                    if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
                }
            } else {
                // Moving to a node from outside the window.
                from = null;
                to = targetInst;
            }
            if (from === to) // Nothing pertains to our managed components.
            return null;
            var eventInterface, leaveEventType, enterEventType, eventTypePrefix;
            if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
                eventInterface = SyntheticMouseEvent;
                leaveEventType = eventTypes$2.mouseLeave;
                enterEventType = eventTypes$2.mouseEnter;
                eventTypePrefix = 'mouse';
            } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
                eventInterface = SyntheticPointerEvent;
                leaveEventType = eventTypes$2.pointerLeave;
                enterEventType = eventTypes$2.pointerEnter;
                eventTypePrefix = 'pointer';
            }
            var fromNode = from == null ? win : getNodeFromInstance$1(from);
            var toNode = to == null ? win : getNodeFromInstance$1(to);
            var leave = eventInterface.getPooled(leaveEventType, from, nativeEvent, nativeEventTarget);
            leave.type = eventTypePrefix + 'leave';
            leave.target = fromNode;
            leave.relatedTarget = toNode;
            var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
            enter.type = eventTypePrefix + 'enter';
            enter.target = toNode;
            enter.relatedTarget = fromNode;
            accumulateEnterLeaveDispatches(leave, enter, from, to); // If we are not processing the first ancestor, then we
            // should not process the same nativeEvent again, as we
            // will have already processed it in the first ancestor.
            if ((eventSystemFlags & IS_FIRST_ANCESTOR) === 0) return [
                leave
            ];
            return [
                leave,
                enter
            ];
        }
    };
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    var eventTypes$3 = {
        select: {
            phasedRegistrationNames: {
                bubbled: 'onSelect',
                captured: 'onSelectCapture'
            },
            dependencies: [
                TOP_BLUR,
                TOP_CONTEXT_MENU,
                TOP_DRAG_END,
                TOP_FOCUS,
                TOP_KEY_DOWN,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN,
                TOP_MOUSE_UP,
                TOP_SELECTION_CHANGE
            ]
        }
    };
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 *
 * @param {object} nativeEventTarget
 * @return {Document}
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return null;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var syntheticEvent = SyntheticEvent.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
            syntheticEvent.type = 'select';
            syntheticEvent.target = activeElement$1;
            accumulateTwoPhaseDispatches(syntheticEvent);
            return syntheticEvent;
        }
        return null;
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ var SelectEventPlugin = {
        eventTypes: eventTypes$3,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, container) {
            var containerOrDoc = container || getEventTargetDocument(nativeEventTarget); // Track whether all listeners exists for this plugin. If none exist, we do
            // not extract events. See #3639.
            if (!containerOrDoc || !isListeningToAllDependencies('onSelect', containerOrDoc)) return null;
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            switch(topLevelType){
                // Track the input node that has focus.
                case TOP_FOCUS:
                    if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                        activeElement$1 = targetNode;
                        activeElementInst$1 = targetInst;
                        lastSelection = null;
                    }
                    break;
                case TOP_BLUR:
                    activeElement$1 = null;
                    activeElementInst$1 = null;
                    lastSelection = null;
                    break;
                // Don't fire the event while the user is dragging. This matches the
                // semantics of the native select event.
                case TOP_MOUSE_DOWN:
                    mouseDown = true;
                    break;
                case TOP_CONTEXT_MENU:
                case TOP_MOUSE_UP:
                case TOP_DRAG_END:
                    mouseDown = false;
                    return constructSelectEvent(nativeEvent, nativeEventTarget);
                // Chrome and IE fire non-standard event when selection is changed (and
                // sometimes when it hasn't). IE's event fires out of order with respect
                // to key and input events on deletion, so we discard it.
                //
                // Firefox doesn't support selectionchange, so check selection status
                // after each key entry. The selection changes after keydown and before
                // keyup, but we check on keydown as well in the case of holding down a
                // key, when multiple keydown events are fired but only one keyup is.
                // This is also our approach for IE handling, for the reason above.
                case TOP_SELECTION_CHANGE:
                    if (skipSelectionChangeEvent) break;
                // falls through
                case TOP_KEY_DOWN:
                case TOP_KEY_UP:
                    return constructSelectEvent(nativeEvent, nativeEventTarget);
            }
            return null;
        }
    };
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var SyntheticAnimationEvent = SyntheticEvent.extend({
        animationName: null,
        elapsedTime: null,
        pseudoElement: null
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var SyntheticClipboardEvent = SyntheticEvent.extend({
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticFocusEvent = SyntheticUIEvent.extend({
        relatedTarget: null
    });
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
        key: getEventKey,
        location: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        repeat: null,
        locale: null,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticDragEvent = SyntheticMouseEvent.extend({
        dataTransfer: null
    });
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var SyntheticTouchEvent = SyntheticUIEvent.extend({
        touches: null,
        targetTouches: null,
        changedTouches: null,
        altKey: null,
        metaKey: null,
        ctrlKey: null,
        shiftKey: null,
        getModifierState: getEventModifierState
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var SyntheticTransitionEvent = SyntheticEvent.extend({
        propertyName: null,
        elapsedTime: null,
        pseudoElement: null
    });
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticWheelEvent = SyntheticMouseEvent.extend({
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: null,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: null
    });
    var knownHTMLTopLevelTypes = [
        TOP_ABORT,
        TOP_CANCEL,
        TOP_CAN_PLAY,
        TOP_CAN_PLAY_THROUGH,
        TOP_CLOSE,
        TOP_DURATION_CHANGE,
        TOP_EMPTIED,
        TOP_ENCRYPTED,
        TOP_ENDED,
        TOP_ERROR,
        TOP_INPUT,
        TOP_INVALID,
        TOP_LOAD,
        TOP_LOADED_DATA,
        TOP_LOADED_METADATA,
        TOP_LOAD_START,
        TOP_PAUSE,
        TOP_PLAY,
        TOP_PLAYING,
        TOP_PROGRESS,
        TOP_RATE_CHANGE,
        TOP_RESET,
        TOP_SEEKED,
        TOP_SEEKING,
        TOP_STALLED,
        TOP_SUBMIT,
        TOP_SUSPEND,
        TOP_TIME_UPDATE,
        TOP_TOGGLE,
        TOP_VOLUME_CHANGE,
        TOP_WAITING
    ];
    var SimpleEventPlugin = {
        // simpleEventPluginEventTypes gets populated from
        // the DOMEventProperties module.
        eventTypes: simpleEventPluginEventTypes,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var dispatchConfig = topLevelEventsToDispatchConfig.get(topLevelType);
            if (!dispatchConfig) return null;
            var EventConstructor;
            switch(topLevelType){
                case TOP_KEY_PRESS:
                    // Firefox creates a keypress event for function keys too. This removes
                    // the unwanted keypress events. Enter is however both printable and
                    // non-printable. One would expect Tab to be as well (but it isn't).
                    if (getEventCharCode(nativeEvent) === 0) return null;
                /* falls through */ case TOP_KEY_DOWN:
                case TOP_KEY_UP:
                    EventConstructor = SyntheticKeyboardEvent;
                    break;
                case TOP_BLUR:
                case TOP_FOCUS:
                    EventConstructor = SyntheticFocusEvent;
                    break;
                case TOP_CLICK:
                    // Firefox creates a click event on right mouse clicks. This removes the
                    // unwanted click events.
                    if (nativeEvent.button === 2) return null;
                /* falls through */ case TOP_AUX_CLICK:
                case TOP_DOUBLE_CLICK:
                case TOP_MOUSE_DOWN:
                case TOP_MOUSE_MOVE:
                case TOP_MOUSE_UP:
                /* falls through */ case TOP_MOUSE_OUT:
                case TOP_MOUSE_OVER:
                case TOP_CONTEXT_MENU:
                    EventConstructor = SyntheticMouseEvent;
                    break;
                case TOP_DRAG:
                case TOP_DRAG_END:
                case TOP_DRAG_ENTER:
                case TOP_DRAG_EXIT:
                case TOP_DRAG_LEAVE:
                case TOP_DRAG_OVER:
                case TOP_DRAG_START:
                case TOP_DROP:
                    EventConstructor = SyntheticDragEvent;
                    break;
                case TOP_TOUCH_CANCEL:
                case TOP_TOUCH_END:
                case TOP_TOUCH_MOVE:
                case TOP_TOUCH_START:
                    EventConstructor = SyntheticTouchEvent;
                    break;
                case TOP_ANIMATION_END:
                case TOP_ANIMATION_ITERATION:
                case TOP_ANIMATION_START:
                    EventConstructor = SyntheticAnimationEvent;
                    break;
                case TOP_TRANSITION_END:
                    EventConstructor = SyntheticTransitionEvent;
                    break;
                case TOP_SCROLL:
                    EventConstructor = SyntheticUIEvent;
                    break;
                case TOP_WHEEL:
                    EventConstructor = SyntheticWheelEvent;
                    break;
                case TOP_COPY:
                case TOP_CUT:
                case TOP_PASTE:
                    EventConstructor = SyntheticClipboardEvent;
                    break;
                case TOP_GOT_POINTER_CAPTURE:
                case TOP_LOST_POINTER_CAPTURE:
                case TOP_POINTER_CANCEL:
                case TOP_POINTER_DOWN:
                case TOP_POINTER_MOVE:
                case TOP_POINTER_OUT:
                case TOP_POINTER_OVER:
                case TOP_POINTER_UP:
                    EventConstructor = SyntheticPointerEvent;
                    break;
                default:
                    if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) error("SimpleEventPlugin: Unhandled event type, `%s`. This warning is likely caused by a bug in React. Please file an issue.", topLevelType);
                    // @see http://www.w3.org/TR/html5/index.html#events-0
                    EventConstructor = SyntheticEvent;
                    break;
            }
            var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
            accumulateTwoPhaseDispatches(event);
            return event;
        }
    };
    /**
 * Specifies a deterministic ordering of `EventPlugin`s. A convenient way to
 * reason about plugins, without having to package every one of them. This
 * is better than having plugins be ordered in the same order that they
 * are injected because that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */ var DOMEventPluginOrder = [
        'ResponderEventPlugin',
        'SimpleEventPlugin',
        'EnterLeaveEventPlugin',
        'ChangeEventPlugin',
        'SelectEventPlugin',
        'BeforeInputEventPlugin'
    ];
    /**
 * Inject modules for resolving DOM hierarchy and plugin ordering.
 */ injectEventPluginOrder(DOMEventPluginOrder);
    setComponentTree(getFiberCurrentPropsFromNode$1, getInstanceFromNode$1, getNodeFromInstance$1);
    /**
 * Some important event plugins included by default (without having to require
 * them).
 */ injectEventPluginsByName({
        SimpleEventPlugin: SimpleEventPlugin,
        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
        ChangeEventPlugin: ChangeEventPlugin,
        SelectEventPlugin: SelectEventPlugin,
        BeforeInputEventPlugin: BeforeInputEventPlugin
    });
    // Prefix measurements so that it's possible to filter them.
    // Longer prefixes are hard to read in DevTools.
    var reactEmoji = "\u269B";
    var warningEmoji = "\u26D4";
    var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
    // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?
    var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
    // Reusing `currentFiber` would be confusing for this because user code fiber
    // can change during commit phase too, but we don't need to unwind it (since
    // lifecycles in the commit phase don't resemble a tree).
    var currentPhase = null;
    var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
    // so we will keep track of it, and include it in the report.
    // Track commits caused by cascading updates.
    var isCommitting = false;
    var hasScheduledUpdateInCurrentCommit = false;
    var hasScheduledUpdateInCurrentPhase = false;
    var commitCountInCurrentWorkLoop = 0;
    var effectCountInCurrentCommit = 0;
    // to avoid stretch the commit phase with measurement overhead.
    var labelsInCurrentCommit = new Set();
    var formatMarkName = function(markName) {
        return reactEmoji + " " + markName;
    };
    var formatLabel = function(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : '';
        return "" + prefix + label + suffix;
    };
    var beginMark = function(markName) {
        performance.mark(formatMarkName(markName));
    };
    var clearMark = function(markName) {
        performance.clearMarks(formatMarkName(markName));
    };
    var endMark = function(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
            performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.
        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
    };
    var getFiberMarkName = function(label, debugID) {
        return label + " (#" + debugID + ")";
    };
    var getFiberLabel = function(componentName, isMounted, phase) {
        if (phase === null) // These are composite component total time measurements.
        return componentName + " [" + (isMounted ? 'update' : 'mount') + "]";
        else // Composite component methods.
        return componentName + "." + phase;
    };
    var beginFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) // During the commit phase, we don't show duplicate labels because
        // there is a fixed overhead for every measurement, and we don't
        // want to stretch the commit phase beyond necessary.
        return false;
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
    };
    var clearFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
    };
    var endFiberMark = function(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
    };
    var shouldIgnoreFiber = function(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch(fiber.tag){
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
            case Mode:
                return true;
            default:
                return false;
        }
    };
    var clearPendingPhaseMeasurement = function() {
        if (currentPhase !== null && currentPhaseFiber !== null) clearFiberMark(currentPhaseFiber, currentPhase);
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
    };
    var pauseTimers = function() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while(fiber){
            if (fiber._debugIsCurrentlyTiming) endFiberMark(fiber, null, null);
            fiber = fiber.return;
        }
    };
    var resumeTimersRecursively = function(fiber) {
        if (fiber.return !== null) resumeTimersRecursively(fiber.return);
        if (fiber._debugIsCurrentlyTiming) beginFiberMark(fiber, null);
    };
    var resumeTimers = function() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) resumeTimersRecursively(currentFiber);
    };
    function recordEffect() {
        effectCountInCurrentCommit++;
    }
    function recordScheduleUpdate() {
        if (isCommitting) hasScheduledUpdateInCurrentCommit = true;
        if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') hasScheduledUpdateInCurrentPhase = true;
    }
    function startWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, this is the fiber to unwind from.
        currentFiber = fiber;
        if (!beginFiberMark(fiber, null)) return;
        fiber._debugIsCurrentlyTiming = true;
    }
    function cancelWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // Remember we shouldn't complete measurement for this fiber.
        // Otherwise flamechart will be deep even for small updates.
        fiber._debugIsCurrentlyTiming = false;
        clearFiberMark(fiber, null);
    }
    function stopWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, its parent is the fiber to unwind from.
        currentFiber = fiber.return;
        if (!fiber._debugIsCurrentlyTiming) return;
        fiber._debugIsCurrentlyTiming = false;
        endFiberMark(fiber, null, null);
    }
    function stopFailedWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, its parent is the fiber to unwind from.
        currentFiber = fiber.return;
        if (!fiber._debugIsCurrentlyTiming) return;
        fiber._debugIsCurrentlyTiming = false;
        var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
        endFiberMark(fiber, null, warning);
    }
    function startPhaseTimer(fiber, phase) {
        if (!supportsUserTiming) return;
        clearPendingPhaseMeasurement();
        if (!beginFiberMark(fiber, phase)) return;
        currentPhaseFiber = fiber;
        currentPhase = phase;
    }
    function stopPhaseTimer() {
        if (!supportsUserTiming) return;
        if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
        }
        currentPhase = null;
        currentPhaseFiber = null;
    }
    function startWorkLoopTimer(nextUnitOfWork) {
        currentFiber = nextUnitOfWork;
        if (!supportsUserTiming) return;
        commitCountInCurrentWorkLoop = 0; // This is top level call.
        // Any other measurements are performed within.
        beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.
        resumeTimers();
    }
    function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        if (!supportsUserTiming) return;
        var warning = null;
        if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) warning = 'A top-level update interrupted the previous render';
            else {
                var componentName = getComponentName(interruptedBy.type) || 'Unknown';
                warning = "An update to " + componentName + " interrupted the previous render";
            }
        } else if (commitCountInCurrentWorkLoop > 1) warning = 'There were cascading updates';
        commitCountInCurrentWorkLoop = 0;
        var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.
        pauseTimers();
        endMark(label, '(React Tree Reconciliation)', warning);
    }
    function startCommitTimer() {
        if (!supportsUserTiming) return;
        isCommitting = true;
        hasScheduledUpdateInCurrentCommit = false;
        labelsInCurrentCommit.clear();
        beginMark('(Committing Changes)');
    }
    function stopCommitTimer() {
        if (!supportsUserTiming) return;
        var warning = null;
        if (hasScheduledUpdateInCurrentCommit) warning = 'Lifecycle hook scheduled a cascading update';
        else if (commitCountInCurrentWorkLoop > 0) warning = 'Caused by a cascading update in earlier commit';
        hasScheduledUpdateInCurrentCommit = false;
        commitCountInCurrentWorkLoop++;
        isCommitting = false;
        labelsInCurrentCommit.clear();
        endMark('(Committing Changes)', '(Committing Changes)', warning);
    }
    function startCommitSnapshotEffectsTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark('(Committing Snapshot Effects)');
    }
    function stopCommitSnapshotEffectsTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Committing Snapshot Effects: " + count + " Total)", '(Committing Snapshot Effects)', null);
    }
    function startCommitHostEffectsTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark('(Committing Host Effects)');
    }
    function stopCommitHostEffectsTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Committing Host Effects: " + count + " Total)", '(Committing Host Effects)', null);
    }
    function startCommitLifeCyclesTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark('(Calling Lifecycle Methods)');
    }
    function stopCommitLifeCyclesTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Calling Lifecycle Methods: " + count + " Total)", '(Calling Lifecycle Methods)', null);
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentName(type) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext;
        startPhaseTimer(fiber, 'getChildContext');
        childContext = instance.getChildContext();
        stopPhaseTimer();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name, // somebody calls unstable_renderSubtreeIntoContainer() and we process
        // context from the parent component instance. The stack will be missing
        // because it's outside of the reconciliation, and so the pointer has not
        // been set. This is rare and doesn't matter. We'll also remove that API.
        getCurrentFiberStackInDev);
        return _assign({}, parentContext, {}, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority$1 = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs < 10000 ? Scheduler_now : function() {
        return Scheduler_now() - initialTimeMs;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$1;
            case Scheduler_NormalPriority:
                return NormalPriority;
            case Scheduler_LowPriority:
                return LowPriority;
            case Scheduler_IdlePriority:
                return IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$1:
                return Scheduler_UserBlockingPriority;
            case NormalPriority:
                return Scheduler_NormalPriority;
            case LowPriority:
                return Scheduler_LowPriority;
            case IdlePriority:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync = true;
                var queue = syncQueue;
                runWithPriority$1(ImmediatePriority, function() {
                    for(; i < queue.length; i++){
                        var callback = queue[i];
                        do callback = callback(_isSync);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
    // Never work can be committed in an inconsistent state without tearing the UI.
    // The main example is offscreen content, like a hidden subtree. So one possible
    // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
    // which are inconsistent in the sense that they haven't finished yet, but
    // aren't visibly inconsistent because the server rendered HTML matches what the
    // hydrated tree would look like.
    var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
    // order to be consistent.
    var Idle = 2; // Continuous Hydration is slightly higher than Idle and is used to increase
    // priority of hover targets.
    var ContinuousHydration = 3;
    var Sync = MAX_SIGNED_31_BIT_INT;
    var Batched = Sync - 1;
    var UNIT_SIZE = 10;
    var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.
    function msToExpirationTime(ms) {
        // Always subtract from the offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
    }
    function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
    }
    function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
    }
    function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
    } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
    // the names to reflect.
    var LOW_PRIORITY_EXPIRATION = 5000;
    var LOW_PRIORITY_BATCH_SIZE = 250;
    function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
    }
    function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
    } // We intentionally set a higher expiration time for interactive updates in
    // dev than in production.
    //
    // If the main thread is being blocked so long that you hit the expiration,
    // it's a problem that could be solved with better scheduling.
    //
    // People will be more likely to notice this and fix it with the long
    // expiration time in development.
    //
    // In production we opt for better UX at the risk of masking scheduling
    // problems, by expiring fast.
    var HIGH_PRIORITY_EXPIRATION = 500;
    var HIGH_PRIORITY_BATCH_SIZE = 100;
    function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
    }
    function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) return ImmediatePriority;
        if (expirationTime === Never || expirationTime === Idle) return IdlePriority;
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) return ImmediatePriority;
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) return UserBlockingPriority$1;
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) return NormalPriority;
         // TODO: Handle LowPriority
        // Assume anything lower has idle priority
        return IdlePriority;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
            error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://fb.me/react-legacy-context%s", sortedNames, firstComponentStack);
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        syncUpdates(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleWork(fiber, Sync);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) throw lazyComponent._result;
        return lazyComponent._result;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (node.childExpirationTime < renderExpirationTime) {
                node.childExpirationTime = renderExpirationTime;
                if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(renderExpirationTime, null);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
                        var alternate = fiber.alternate;
                        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
                        scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.
                        if (list.expirationTime < renderExpirationTime) list.expirationTime = renderExpirationTime;
                         // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (dependencies.expirationTime >= renderExpirationTime) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    expirationTime: NoWork,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            baseQueue: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                baseQueue: currentQueue.baseQueue,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(expirationTime, suspenseConfig) {
        var update = {
            expirationTime: expirationTime,
            suspenseConfig: suspenseConfig,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        update.next = update;
        update.priority = getCurrentPriorityLevel();
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, update) {
        var current = workInProgress.alternate;
        if (current !== null) // Ensure the work-in-progress queue is a clone
        cloneUpdateQueue(current, workInProgress);
         // Captured updates go only on the work-in-progress queue.
        var queue = workInProgress.updateQueue; // Append the update to the end of the list.
        var last = queue.baseQueue;
        if (last === null) {
            queue.baseQueue = update.next = update;
            update.next = update;
        } else {
            update.next = last.next;
            last.next = update;
        }
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    if (workInProgress.mode & StrictMode) payload.call(instance, prevState, nextProps);
                    var nextState = payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    if (workInProgress.mode & StrictMode) _payload.call(instance, prevState, nextProps);
                    partialState = _payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderExpirationTime) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var baseQueue = queue.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            baseQueue = pendingQueue;
            queue.shared.pending = null; // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                var currentQueue = current.updateQueue;
                if (currentQueue !== null) currentQueue.baseQueue = pendingQueue;
            }
        } // These values may change as we process the queue.
        if (baseQueue !== null) {
            var first = baseQueue.next; // Iterate through the list of updates to compute the result.
            var newState = queue.baseState;
            var newExpirationTime = NoWork;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            if (first !== null) {
                var update = first;
                do {
                    var updateExpirationTime = update.expirationTime;
                    if (updateExpirationTime < renderExpirationTime) {
                        // Priority is insufficient. Skip this update. If this is the first
                        // skipped update, the previous update/state is the new base
                        // update/state.
                        var clone = {
                            expirationTime: update.expirationTime,
                            suspenseConfig: update.suspenseConfig,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newBaseQueueLast === null) {
                            newBaseQueueFirst = newBaseQueueLast = clone;
                            newBaseState = newState;
                        } else newBaseQueueLast = newBaseQueueLast.next = clone;
                         // Update the remaining priority in the queue.
                        if (updateExpirationTime > newExpirationTime) newExpirationTime = updateExpirationTime;
                    } else {
                        // This update does have sufficient priority.
                        if (newBaseQueueLast !== null) {
                            var _clone = {
                                expirationTime: Sync,
                                // This update is going to be committed so we never want uncommit it.
                                suspenseConfig: update.suspenseConfig,
                                tag: update.tag,
                                payload: update.payload,
                                callback: update.callback,
                                next: null
                            };
                            newBaseQueueLast = newBaseQueueLast.next = _clone;
                        } // Mark the event time of this update as relevant to this render pass.
                        // TODO: This should ideally use the true event time of this update rather than
                        // its priority which is a derived and not reverseable value.
                        // TODO: We should skip this update if it was already committed but currently
                        // we have no way of detecting the difference between a committed and suspended
                        // update here.
                        markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.
                        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                        var callback = update.callback;
                        if (callback !== null) {
                            workInProgress.effectTag |= Callback;
                            var effects = queue.effects;
                            if (effects === null) queue.effects = [
                                update
                            ];
                            else effects.push(update);
                        }
                    }
                    update = update.next;
                    if (update === null || update === first) {
                        pendingQueue = queue.shared.pending;
                        if (pendingQueue === null) break;
                        else {
                            // An update was scheduled from inside a reducer. Add the new
                            // pending updates to the end of the list and keep processing.
                            update = baseQueue.next = pendingQueue.next;
                            pendingQueue.next = first;
                            queue.baseQueue = baseQueue = pendingQueue;
                            queue.shared.pending = null;
                        }
                    }
                }while (true);
            }
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
            queue.baseState = newBaseState;
            queue.baseQueue = newBaseQueueLast; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markUnprocessedUpdateTime(newExpirationTime);
            workInProgress.expirationTime = newExpirationTime;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === 'function')) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.expirationTime === NoWork) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            if (workInProgress.mode & StrictMode) // Invoke the function an extra time to help detect side-effects.
            instance.shouldComponentUpdate(newProps, newState, nextContext);
            startPhaseTimer(workInProgress, 'shouldComponentUpdate');
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            stopPhaseTimer();
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) new ctor(props, context); // eslint-disable-line no-new
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        stopPhaseTimer();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        stopPhaseTimer();
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                startPhaseTimer(workInProgress, 'componentWillMount');
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
                stopPhaseTimer();
            }
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                startPhaseTimer(workInProgress, 'componentWillUpdate');
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
                stopPhaseTimer();
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.effectTag |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.effectTag |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === 'object')) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var currentComponentErrorInfo = 'Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.' + getCurrentFiberStackInDev();
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
        error('Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === 'string')) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
            var addendum = '';
            addendum = " If you meant to render a collection of children, use an array instead." + getCurrentFiberStackInDev();
            throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + ")." + addendum);
        }
    }
    function warnOnFunctionType() {
        var currentComponentErrorInfo = "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it." + getCurrentFiberStackInDev();
        if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) return;
        ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.effectTag = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.effectTag = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.effectTag = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, expirationTime) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, expirationTime) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, expirationTime) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, expirationTime, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                            return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === 'function')) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === 'object' && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
            if (typeof newChild === 'string' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === 'function') warnOnFunctionType();
            if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case FunctionComponent:
                    var Component = returnFiber.type;
                    throw Error((Component.displayName || Component.name || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, renderExpirationTime);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function createDeprecatedResponderListener(responder, props) {
        var eventResponderListener = {
            responder: responder,
            props: props
        };
        Object.freeze(eventResponderListener);
        return eventResponderListener;
    }
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderExpirationTime = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderExpirationTime) {
        renderExpirationTime = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.expirationTime = NoWork; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (workInProgress.expirationTime === renderExpirationTime) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                workInProgress.expirationTime = NoWork;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (workInProgress.expirationTime === renderExpirationTime);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) current.expirationTime = NoWork;
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
        }
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdate = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateExpirationTime = update.expirationTime;
                if (updateExpirationTime < renderExpirationTime) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        expirationTime: update.expirationTime,
                        suspenseConfig: update.suspenseConfig,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                        currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                        markUnprocessedUpdateTime(updateExpirationTime);
                    }
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            expirationTime: Sync,
                            // This update is going to be committed so we never want uncommit it.
                            suspenseConfig: update.suspenseConfig,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Mark the event time of this update as relevant to this render pass.
                    // TODO: This should ideally use the true event time of this update rather than
                    // its priority which is a derived and not reverseable value.
                    // TODO: We should skip this update if it was already committed but currently
                    // we have no way of detecting the difference between a committed and suspended
                    // update here.
                    markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookEffectTag, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value, config) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function updateDeferredValue(value, config) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value, config) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function startTransition(setPending, config, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        });
    }
    function mountTransition(config) {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
        var start = mountCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function updateTransition(config) {
        var _updateState2 = updateState(), isPending = _updateState2[0], setPending = _updateState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition(config) {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0], setPending = _rerenderState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var currentTime = requestCurrentTimeForUpdate();
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
        var update = {
            expirationTime: expirationTime,
            suspenseConfig: suspenseConfig,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        };
        update.priority = getCurrentPriorityLevel();
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            update.expirationTime = renderExpirationTime;
            currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
        } else {
            if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher.current;
                    ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleWork(fiber, expirationTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition(config);
        }
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
        if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(type), getCurrentFiberStackInDev);
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentName(_type), getCurrentFiberStackInDev);
        var currentChild = current.child; // This is always exactly one child
        if (updateExpirationTime < renderExpirationTime) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) // We warn when you define propTypes on lazy()
            // so let's just skip over it to find memo() outer wrapper.
            // Inner props for memo are validated later.
            outerMemoType = refineResolvedLazyComponent(outerMemoType);
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentName(outerMemoType), getCurrentFiberStackInDev);
             // Inner propTypes will be validated in the function component path.
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (updateExpirationTime < renderExpirationTime) {
                    // The pending update priority was cleared at the beginning of
                    // beginWork. We're about to bail out, but there might be additional
                    // updates at a lower priority. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.expirationTime = current.expirationTime;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                }
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime);
    }
    function updateFragment(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderExpirationTime) {
        workInProgress.effectTag |= Update;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.effectTag |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
        if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.effectTag |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderExpirationTime);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        var inst = workInProgress.stateNode;
        if (inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) instance.render();
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime);
        else reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            // If the state is the same as before, that's a bailout because we had
            // no work that expires at this time.
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            // If we don't have any current children this might be the first pass.
            // We always try to hydrate. If this isn't a hydration pass there won't
            // be any children to hydrate which is effectively the same thing as
            // not hydrating.
            var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.effectTag = node.effectTag & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.effectTag |= ContentReset;
        markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.
        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(type, nextProps)) {
            markSpawnedWork(Never);
            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
            return null;
        }
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.
        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateExpirationTime, renderExpirationTime);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
        setIsRendering(false);
        workInProgress.effectTag |= PerformedWork;
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === 'function') applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderExpirationTime);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
            {
                if (workInProgress.memoizedState !== null) value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
            }
            reconcileChildren(null, workInProgress, value, renderExpirationTime);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName2);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support contextType.', _componentName3);
                didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
    };
    function shouldRemainOnFallback(suspenseContext, current, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current === null || current.memoizedState !== null);
    }
    function updateSuspenseComponent(current, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.effectTag |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            nextDidTimeout = true;
            workInProgress.effectTag &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.
        if (current === null) {
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
             // This is the initial mount. This branch is pretty simple because there's
            // no previous state that needs to be preserved.
            if (nextDidTimeout) {
                // Mount separate fragments for primary and fallback children.
                var nextFallbackChildren = nextProps.fallback;
                var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
                primaryChildFragment.return = workInProgress;
                if ((workInProgress.mode & BlockingMode) === NoMode) {
                    // Outside of blocking mode, we commit the effects from the
                    // partially completed, timed-out tree, too.
                    var progressedState = workInProgress.memoizedState;
                    var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
                    primaryChildFragment.child = progressedPrimaryChild;
                    var progressedChild = progressedPrimaryChild;
                    while(progressedChild !== null){
                        progressedChild.return = primaryChildFragment;
                        progressedChild = progressedChild.sibling;
                    }
                }
                var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
                fallbackChildFragment.return = workInProgress;
                primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                workInProgress.child = primaryChildFragment;
                return fallbackChildFragment;
            } else {
                // Mount the primary children without an intermediate fragment fiber.
                var nextPrimaryChildren = nextProps.children;
                workInProgress.memoizedState = null;
                return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
            }
        } else {
            // This is an update. This branch is more complicated because we need to
            // ensure the state of the primary children is preserved.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                // wrapped in a fragment fiber.
                var currentPrimaryChildFragment = current.child;
                var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
                if (nextDidTimeout) {
                    // Still timed out. Reuse the current primary children by cloning
                    // its fragment. We're going to skip over these entirely.
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
                    _primaryChildFragment2.return = workInProgress;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState = workInProgress.memoizedState;
                        var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                        if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                            _primaryChildFragment2.child = _progressedPrimaryChild;
                            var _progressedChild2 = _progressedPrimaryChild;
                            while(_progressedChild2 !== null){
                                _progressedChild2.return = _primaryChildFragment2;
                                _progressedChild2 = _progressedChild2.sibling;
                            }
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration = 0;
                        var _hiddenChild = _primaryChildFragment2.child;
                        while(_hiddenChild !== null){
                            _treeBaseDuration += _hiddenChild.treeBaseDuration;
                            _hiddenChild = _hiddenChild.sibling;
                        }
                        _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
                    } // Clone the fallback child fragment, too. These we'll continue
                    // working on.
                    var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
                    _fallbackChildFragment2.return = workInProgress;
                    _primaryChildFragment2.sibling = _fallbackChildFragment2;
                    _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment2;
                    return _fallbackChildFragment2;
                } else {
                    // No longer suspended. Switch back to showing the primary children,
                    // and remove the intermediate fragment fiber.
                    var _nextPrimaryChildren = nextProps.children;
                    var currentPrimaryChild = currentPrimaryChildFragment.child;
                    var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
                    // children. Wait until the complete phase, after we've confirmed the
                    // fallback is no longer needed.
                    // TODO: Would it be better to store the fallback fragment on
                    // the stateNode?
                    // Continue rendering the children, like we normally do.
                    workInProgress.memoizedState = null;
                    return workInProgress.child = primaryChild;
                }
            } else {
                // The current tree has not already timed out. That means the primary
                // children are not wrapped in a fragment fiber.
                var _currentPrimaryChild = current.child;
                if (nextDidTimeout) {
                    // Timed out. Wrap the children in a fragment fiber to keep them
                    // separate from the fallback children.
                    var _nextFallbackChildren3 = nextProps.fallback;
                    var _primaryChildFragment3 = createFiberFromFragment(// going to render this fragment.
                    null, mode, NoWork, null);
                    _primaryChildFragment3.return = workInProgress;
                    _primaryChildFragment3.child = _currentPrimaryChild;
                    if (_currentPrimaryChild !== null) _currentPrimaryChild.return = _primaryChildFragment3;
                     // Even though we're creating a new fiber, there are no new children,
                    // because we're reusing an already mounted tree. So we don't need to
                    // schedule a placement.
                    // primaryChildFragment.effectTag |= Placement;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState2 = workInProgress.memoizedState;
                        var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                        _primaryChildFragment3.child = _progressedPrimaryChild2;
                        var _progressedChild3 = _progressedPrimaryChild2;
                        while(_progressedChild3 !== null){
                            _progressedChild3.return = _primaryChildFragment3;
                            _progressedChild3 = _progressedChild3.sibling;
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration2 = 0;
                        var _hiddenChild2 = _primaryChildFragment3.child;
                        while(_hiddenChild2 !== null){
                            _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                            _hiddenChild2 = _hiddenChild2.sibling;
                        }
                        _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
                    } // Create a fragment from the fallback children, too.
                    var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
                    _fallbackChildFragment3.return = workInProgress;
                    _primaryChildFragment3.sibling = _fallbackChildFragment3;
                    _fallbackChildFragment3.effectTag |= Placement;
                    _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment3;
                    return _fallbackChildFragment3;
                } else {
                    // Still haven't timed out. Continue rendering the children, like we
                    // normally do.
                    workInProgress.memoizedState = null;
                    var _nextPrimaryChildren2 = nextProps.children;
                    return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
                }
            }
        }
    }
    function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderExpirationTime);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
        if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailExpiration = 0;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.effectTag |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.effectTag & DidCapture) !== NoEffect;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // Outside of blocking mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateContextProvider(current, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) markUnprocessedUpdateTime(updateExpirationTime);
         // Check if the children have any pending work.
        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.effectTag = Deletion;
        newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (updateExpirationTime < renderExpirationTime) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type, newProps)) {
                            markSpawnedWork(Never);
                            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                            return null;
                        }
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                        if (hasChildWork) workInProgress.effectTag |= Update;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                            if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
                            else {
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.effectTag & DidCapture) !== NoEffect;
                        var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.effectTag |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            } else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.expirationTime = NoWork;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderExpirationTime);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderExpirationTime);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderExpirationTime);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderExpirationTime);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderExpirationTime);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderExpirationTime);
            case Fragment:
                return updateFragment(current, workInProgress, renderExpirationTime);
            case Mode:
                return updateMode(current, workInProgress, renderExpirationTime);
            case Profiler:
                return updateProfiler(current, workInProgress, renderExpirationTime);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderExpirationTime);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderExpirationTime);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentName(_type2), getCurrentFiberStackInDev);
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners
                        workInProgress.stateNode = instance;
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                    if (!nextDidTimeout && prevState !== null) {
                        // We just switched from the fallback to the normal children.
                        // Delete the fallback.
                        // TODO: Would it be better to store the fallback fragment on
                        // the stateNode during the begin phase?
                        var currentFallbackChild = current.child.sibling;
                        if (currentFallbackChild !== null) {
                            // Deletions go at the beginning of the return fiber's effect list
                            var first = workInProgress.firstEffect;
                            if (first !== null) {
                                workInProgress.firstEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = first;
                            } else {
                                workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = null;
                            }
                            currentFallbackChild.effectTag = Deletion;
                        }
                    }
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.effectTag |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.effectTag |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.effectTag |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.effectTag |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// the expiration.
                        now() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime > Never) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. If we can show
                            // them, then they really have the same priority as this render.
                            // So we'll pick it back up the very next render pass once we've had
                            // an opportunity to yield for paint.
                            var nextPriority = renderExpirationTime - 1;
                            workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                            markSpawnedWork(nextPriority);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    if (renderState.tailExpiration === 0) {
                        // Heuristic for how long we're willing to spend rendering rows
                        // until we just give up and show what we have so far.
                        var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                        renderState.tailExpiration = now() + TAIL_EXPIRATION_TIMEOUT_MS; // TODO: This is meant to mimic the train model or JND but this
                    // is a per component value. It should really be since the start
                    // of the total render or last commit. Consider using something like
                    // globalMostRecentFallbackTime. That doesn't account for being
                    // suspended for part of the time or when it's a new render.
                    // It should probably use a global start time value instead.
                    } // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderExpirationTime) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var effectTag = workInProgress.effectTag;
                if (effectTag & ShouldCapture) {
                    workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var _effectTag = workInProgress.effectTag;
                if (!((_effectTag & DidCapture) === NoEffect)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _effectTag2 = workInProgress.effectTag;
                if (_effectTag2 & ShouldCapture) {
                    workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function logCapturedError(capturedError) {
        var error = capturedError.error;
        var componentName = capturedError.componentName, componentStack = capturedError.componentStack, errorBoundaryName = capturedError.errorBoundaryName, errorBoundaryFound = capturedError.errorBoundaryFound, willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
        // `preventDefault()` in window `error` handler.
        // We record this information as an expando on the error.
        if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) // The error is recoverable and was silenced.
            // Ignore it and don't print the stack addendum.
            // This is handy for testing error boundaries without noise.
            return;
             // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.
            console['error'](error); // Don't transform to our wrapper
        // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
        }
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
        var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.
        if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
        } else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://fb.me/react-error-boundaries to learn more about error boundaries.";
        var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
        // We don't include the original error message and JS stack because the browser
        // has already printed it. Even if the application swallows the error, it is still
        // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
        console['error'](combinedMessage); // Don't transform to our wrapper
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) stack = getStackByFiberInDevAndProd(source);
        var capturedError = {
            componentName: source !== null ? getComponentName(source.type) : null,
            componentStack: stack !== null ? stack : '',
            error: errorInfo.value,
            errorBoundary: null,
            errorBoundaryName: null,
            errorBoundaryFound: false,
            willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
            capturedError.errorBoundary = boundary.stateNode;
            capturedError.errorBoundaryName = getComponentName(boundary.type);
            capturedError.errorBoundaryFound = true;
            capturedError.willRetry = true;
        }
        try {
            logCapturedError(capturedError);
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        startPhaseTimer(current, 'componentWillUnmount');
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.effectTag & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                        stopPhaseTimer();
                    }
                }
                return;
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching";
                        else addendum = ' You returned: ' + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s%s", addendum, getStackByFiberInDevAndProd(finishedWork));
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                // TODO (#17945) We should call all passive destroy functions (for all fibers)
                // before calling any create functions. The current approach only serializes
                // these for a single fiber.
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedExpirationTime) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                // At this point layout effects have already been destroyed (during mutation phase).
                // This is done to prevent sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.effectTag & Update) {
                    if (current === null) {
                        startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidMount();
                        stopPhaseTimer();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState;
                        startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        stopPhaseTimer();
                    }
                }
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.effectTag & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
                // Found a nested Suspense component that timed out. Skip over the
                // primary child fragment, which should remain hidden.
                var fallbackChildFragment = node.child.sibling;
                fallbackChildFragment.return = node;
                node = fallbackChildFragment;
                continue;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().%s", getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === 'function') currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        // When the owner fiber is deleted, the destroy function of a passive
                        // effect hook is called during the synchronous commit phase. This is
                        // a concession to implementation complexity. Calling it in the
                        // passive effect phase (like they usually are, when dependencies
                        // change during an update) would require either traversing the
                        // children of the deleted fiber again, or including unmount effects
                        // as part of the fiber effect list.
                        //
                        // Because this is during the sync commit phase, we need to change
                        // the priority.
                        //
                        // TODO: Reconsider this implementation trade off.
                        var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                        runWithPriority$1(priorityLevel, function() {
                            var effect = firstEffect;
                            do {
                                var _destroy = effect.destroy;
                                if (_destroy !== undefined) safelyCallDestroy(current, _destroy);
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        });
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current, renderPriorityLevel);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiber(current) {
        var alternate = current.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        current.return = null;
        current.child = null;
        current.memoizedState = null;
        current.updateQueue = null;
        current.dependencies = null;
        current.alternate = null;
        current.firstEffect = null;
        current.lastEffect = null;
        current.pendingProps = null;
        current.memoizedProps = null;
        current.stateNode = null;
        if (alternate !== null) detachFiber(alternate);
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.effectTag & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.effectTag & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.effectTag & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current, renderPriorityLevel);
        detachFiber(current);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                // Layout effects are destroyed during the mutation phase so that all
                // destroy functions for all fibers are called before any create functions.
                // This prevents sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) newDidTimeout = false;
        else {
            newDidTimeout = true;
            primaryChildParent = finishedWork.child;
            markCommitTimeOfFallback();
        }
        if (primaryChildParent !== null) hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            thenables.forEach(function(thenable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
                if (!retryCache.has(thenable)) {
                    if (thenable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(thenable);
                    thenable.then(retry, retry);
                }
            });
        }
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (fiber.expirationTime !== Sync) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || 'Unknown');
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
        } else {
            threadIDs = pingCache.get(thenable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(thenable, threadIDs);
            }
        }
        if (!threadIDs.has(renderExpirationTime)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(renderExpirationTime);
            var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
            thenable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a thenable.
            var thenable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.expirationTime = currentSource.expirationTime;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var thenables = _workInProgress.updateQueue;
                    if (thenables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(thenable);
                        _workInProgress.updateQueue = updateQueue;
                    } else thenables.add(thenable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(Sync, null);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.expirationTime = Sync; // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. SuspenseConfig applies to
                    // this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, renderExpirationTime, thenable);
                    _workInProgress.effectTag |= ShouldCapture;
                    _workInProgress.expirationTime = renderExpirationTime;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.effectTag |= ShouldCapture;
                    workInProgress.expirationTime = renderExpirationTime;
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.effectTag |= ShouldCapture;
                        workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*                    */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The expiration time we're rendering
    var renderExpirationTime$1 = NoWork; // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
    // This is conceptually a time stamp but expressed in terms of an ExpirationTime
    // because we deal mostly with expiration times in the hot path, so this avoids
    // the conversion happening in the hot path.
    var workInProgressRootLatestProcessedExpirationTime = Sync;
    var workInProgressRootLatestSuspenseTimeout = Sync;
    var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
    // This flag determines if it might be worthwhile to restart if an opportunity
    // happens latere.
    var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500;
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority;
    var pendingPassiveEffectsExpirationTime = NoWork;
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
    // time). However, if two updates are scheduled within the same event, we
    // should treat their start times as simultaneous, even if the actual clock
    // time has advanced between the first and second call.
    // In other words, because expiration times determine how updates are batched,
    // we want all updates of like priority that occur within the same event to
    // receive the same expiration time. Otherwise we get tearing.
    var currentEventTime = NoWork;
    function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return msToExpirationTime(now());
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoWork) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = msToExpirationTime(now());
        return currentEventTime;
    }
    function getCurrentTime() {
        return msToExpirationTime(now());
    }
    function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return Sync;
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) return priorityLevel === ImmediatePriority ? Sync : Batched;
        if ((executionContext & RenderContext) !== NoContext) // Use whatever time we're already rendering
        // TODO: Should there be a way to opt out, like with `runWithPriority`?
        return renderExpirationTime$1;
        var expirationTime;
        if (suspenseConfig !== null) // Compute an expiration time based on the Suspense timeout.
        expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        else // Compute an expiration time based on the Scheduler priority.
        switch(priorityLevel){
            case ImmediatePriority:
                expirationTime = Sync;
                break;
            case UserBlockingPriority$1:
                // TODO: Rename this to computeUserBlockingExpiration
                expirationTime = computeInteractiveExpiration(currentTime);
                break;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowPriority
                // TODO: Rename this to... something better.
                expirationTime = computeAsyncExpiration(currentTime);
                break;
            case IdlePriority:
                expirationTime = Idle;
                break;
            default:
                throw Error("Expected a valid priority level");
        }
         // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.
        if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) // This is a trick to move this update into a separate batch
        expirationTime -= 1;
        return expirationTime;
    }
    function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, expirationTime);
                if (executionContext === NoContext) // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                flushSyncCallbackQueue();
            }
        } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
        (priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority)) {
            // This is the result of a discrete event. Track the lowest priority
            // discrete update per root so we can flush them early, if needed.
            if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Map([
                [
                    root,
                    expirationTime
                ]
            ]);
            else {
                var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
                if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
        }
    }
    var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) fiber.expirationTime = expirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) alternate.expirationTime = expirationTime;
         // Walk the parent path to the root and update the child expiration time.
        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) root = fiber.stateNode;
        else while(node !== null){
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
                node.childExpirationTime = expirationTime;
                if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            if (node.return === null && node.tag === HostRoot) {
                root = node.stateNode;
                break;
            }
            node = node.return;
        }
        if (root !== null) {
            if (workInProgressRoot === root) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that's unprocessed work on this root.
                markUnprocessedUpdateTime(expirationTime);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: This happens to work when receiving an update during the render
                // phase, because of the trick inside computeExpirationForFiber to
                // subtract 1 from `renderExpirationTime` to move it into a
                // separate bucket. But we should probably model it with an exception,
                // using the same mechanism we use to force hydration of a subtree.
                // TODO: This does not account for low pri updates that were already
                // scheduled before the root started rendering. Need to track the next
                // pending expiration time (perhaps by backtracking the return path) and
                // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
                markRootSuspendedAtTime(root, renderExpirationTime$1);
            } // Mark that the root has a pending update.
            markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
    }
    function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) return lastExpiredTime;
         // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.
        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) // The highest priority pending time is not suspended. Let's work on that.
        return firstPendingTime;
         // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.
        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
        if (nextLevel <= Idle && firstPendingTime !== nextLevel) // Don't work on Idle/Never priority unless everything else is committed.
        return NoWork;
        return nextLevel;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the
    // expiration time of the existing task is the same as the expiration time of
    // the next level that the root has work on. This function is called on every
    // update, and right before exiting a task.
    function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
            // Special case: Expired work should flush synchronously.
            root.callbackExpirationTime = Sync;
            root.callbackPriority = ImmediatePriority;
            root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
            // There's nothing to work on.
            if (existingCallbackNode !== null) {
                root.callbackNode = null;
                root.callbackExpirationTime = NoWork;
                root.callbackPriority = NoPriority;
            }
            return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.
        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            var existingCallbackExpirationTime = root.callbackExpirationTime;
            if (existingCallbackExpirationTime === expirationTime && // Callback must have greater or equal priority.
            existingCallbackPriority >= priorityLevel) // Existing callback is sufficient.
            return;
             // Need to schedule a new task.
            // TODO: Instead of scheduling a new task, we should be able to change the
            // priority of the existing one.
            cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) // Sync React callbacks are scheduled on a special internal queue
        callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root), // ordering because tasks are processed in timeout order.
        {
            timeout: expirationTimeToMs(expirationTime) - now()
        });
        root.callbackNode = callbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
            // The render task took too long to complete. Mark the current time as
            // expired to synchronously render all expired work in a single batch.
            var currentTime = requestCurrentTimeForUpdate();
            markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.
            ensureRootIsScheduled(root);
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
            var originalCallbackNode = root.callbackNode;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
            flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
            // and prepare a fresh one. Otherwise we'll continue where we left off.
            if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
                prepareFreshStack(root, expirationTime);
                startWorkOnPendingInteractions(root, expirationTime);
            } // If we have a work-in-progress fiber, it means there's still work to do
            // in this root.
            if (workInProgress !== null) {
                var prevExecutionContext = executionContext;
                executionContext |= RenderContext;
                var prevDispatcher = pushDispatcher();
                var prevInteractions = pushInteractions(root);
                startWorkLoopTimer(workInProgress);
                for(;;)try {
                    workLoopConcurrent();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
                resetContextDependencies();
                executionContext = prevExecutionContext;
                popDispatcher(prevDispatcher);
                popInteractions(prevInteractions);
                if (workInProgressRootExitStatus === RootFatalErrored) {
                    var fatalError = workInProgressRootFatalError;
                    stopInterruptedWorkLoopTimer();
                    prepareFreshStack(root, expirationTime);
                    markRootSuspendedAtTime(root, expirationTime);
                    ensureRootIsScheduled(root);
                    throw fatalError;
                }
                if (workInProgress !== null) // There's still work left over. Exit without committing.
                stopInterruptedWorkLoopTimer();
                else {
                    // We now have a consistent tree. The next step is either to commit it,
                    // or, if something suspended, wait to commit it after a timeout.
                    stopFinishedWorkLoopTimer();
                    var finishedWork = root.finishedWork = root.current.alternate;
                    root.finishedExpirationTime = expirationTime;
                    finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
                }
                ensureRootIsScheduled(root);
                if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
                // currently executed. Need to return a continuation.
                return performConcurrentWorkOnRoot.bind(null, root);
            }
        }
        return null;
    }
    function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // If this was an async render, the error may have happened due to
                // a mutation in a concurrent event. Try rendering one more time,
                // synchronously, to see if the error goes away. If there are
                // lower priority updates, let's include those, too, in case they
                // fix the inconsistency. Render at Idle to include all updates.
                // If it was Idle or Never or some not-yet-invented time, render
                // at that time.
                markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
                break;
            case RootSuspended:
                markRootSuspendedAtTime(root, expirationTime);
                var lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                 // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                // If we have processed new updates during this render, we may now
                // have a new loading state ready. We want to ensure that we commit
                // that as soon as possible.
                var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
                if (hasNotProcessedNewUpdates && // do not delay if we're inside an act() scope
                !IsThisRendererActing.current) {
                    // If we have not processed any new updates during this pass, then
                    // this is either a retry of an existing fallback state or a
                    // hidden tree. Hidden trees shouldn't be batched with other work
                    // and after that's fixed it can only be a retry. We're going to
                    // throttle committing retries so that we don't show too many
                    // loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        if (workInProgressRootHasPendingPing) {
                            var lastPingedTime = root.lastPingedTime;
                            if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                                // This render was pinged but we didn't get to restart
                                // earlier so try restarting now instead.
                                root.lastPingedTime = expirationTime;
                                prepareFreshStack(root, expirationTime);
                                break;
                            }
                        }
                        var nextTime = getNextRootExpirationTimeToWorkOn(root);
                        if (nextTime !== NoWork && nextTime !== expirationTime) break;
                        if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            root.lastPingedTime = lastSuspendedTime;
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspendedAtTime(root, expirationTime);
                var _lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === _lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                if (!IsThisRendererActing.current) {
                    // We're suspended in a state that should be avoided. We'll try to
                    // avoid committing it for as long as the timeouts let us.
                    if (workInProgressRootHasPendingPing) {
                        var _lastPingedTime = root.lastPingedTime;
                        if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                            // This render was pinged but we didn't get to restart earlier
                            // so try restarting now instead.
                            root.lastPingedTime = expirationTime;
                            prepareFreshStack(root, expirationTime);
                            break;
                        }
                    }
                    var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                    if (_nextTime !== NoWork && _nextTime !== expirationTime) break;
                    if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                        // We should prefer to render the fallback of at the last
                        // suspended level. Ping the last suspended level to try
                        // rendering it again.
                        root.lastPingedTime = _lastSuspendedTime;
                        break;
                    }
                    var _msUntilTimeout;
                    if (workInProgressRootLatestSuspenseTimeout !== Sync) // We have processed a suspense config whose expiration time we
                    // can use as the timeout.
                    _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now();
                    else if (workInProgressRootLatestProcessedExpirationTime === Sync) // This should never normally happen because only new updates
                    // cause delayed states, so we should have processed something.
                    // However, this could also happen in an offscreen tree.
                    _msUntilTimeout = 0;
                    else {
                        // If we don't have a suspense config, we're going to use a
                        // heuristic to determine how long we can suspend.
                        var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                        var currentTimeMs = now();
                        var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                        var timeElapsed = currentTimeMs - eventTimeMs;
                        if (timeElapsed < 0) // We get this wrong some time since we estimate the time.
                        timeElapsed = 0;
                        _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                        // event time is exact instead of inferred from expiration time
                        // we don't need this.
                        if (timeUntilExpirationMs < _msUntilTimeout) _msUntilTimeout = timeUntilExpirationMs;
                    } // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                if (!IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                    // If we have exceeded the minimum loading delay, which probably
                    // means we have shown a spinner already, we might have to suspend
                    // a bit longer to ensure that the spinner is shown for
                    // enough time.
                    var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                    if (_msUntilTimeout2 > 10) {
                        markRootSuspendedAtTime(root, expirationTime);
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                        break;
                    }
                }
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root, expirationTime);
            startWorkOnPendingInteractions(root, expirationTime);
        } // If we have a work-in-progress fiber, it means there's still work to do
        // in this root.
        if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root);
            startWorkLoopTimer(workInProgress);
            for(;;)try {
                workLoopSync();
                break;
            } catch (thrownValue) {
                handleError(root, thrownValue);
            }
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            popInteractions(prevInteractions);
            if (workInProgressRootExitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                stopInterruptedWorkLoopTimer();
                prepareFreshStack(root, expirationTime);
                markRootSuspendedAtTime(root, expirationTime);
                ensureRootIsScheduled(root);
                throw fatalError;
            }
            if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
            else {
                // We now have a consistent tree. Because this is a sync render, we
                // will commit it even if something suspended.
                stopFinishedWorkLoopTimer();
                root.finishedWork = root.current.alternate;
                root.finishedExpirationTime = expirationTime;
                finishSyncRender(root);
            } // Before exiting, make sure there's a callback scheduled for the next
            // pending level.
            ensureRootIsScheduled(root);
        }
        return null;
    }
    function finishSyncRender(root) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        commitRoot(root);
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function syncUpdates(fn, a, b, c) {
        return runWithPriority$1(ImmediatePriority, fn.bind(null, a, b, c));
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(expirationTime, root) {
                markRootExpiredAtTime(root, expirationTime);
                ensureRootIsScheduled(root);
            }); // Now flush the immediate queue.
            flushSyncCallbackQueue();
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            // Should this
            return runWithPriority$1(UserBlockingPriority$1, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function flushSync(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return runWithPriority$1(ImmediatePriority, fn.bind(null, a));
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        renderExpirationTime$1 = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber();
                if (workInProgress === null || workInProgress.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // interntionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return null;
                }
                if (enableProfilerTimer && workInProgress.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
                throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
                workInProgress = completeUnitOfWork(workInProgress);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$1.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) workInProgressRootLatestProcessedExpirationTime = expirationTime;
        if (suspenseConfig !== null) {
            if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
                workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.
                workInProgressRootCanSuspendUsingConfig = suspenseConfig;
            }
        }
    }
    function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) workInProgressRootNextUnprocessedUpdateTime = expirationTime;
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there's a lower priority update somewhere else in the tree.
        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
            // Mark the current render as suspended, and then mark that there's a
            // pending update.
            // TODO: This should immediately interrupt the current render, instead
            // of waiting until the next time we yield.
            markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
            markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
    }
    function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)workInProgress = performUnitOfWork(workInProgress);
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())workInProgress = performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        next = completeUnitOfWork(unitOfWork);
        ReactCurrentOwner$2.current = null;
        return next;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = workInProgress.alternate;
            var returnFiber = workInProgress.return; // Check if the work completed or if something threw.
            if ((workInProgress.effectTag & Incomplete) === NoEffect) {
                setCurrentFiber(workInProgress);
                var next = void 0;
                if ((workInProgress.mode & ProfileMode) === NoMode) next = completeWork(current, workInProgress, renderExpirationTime$1);
                else {
                    startProfilerTimer(workInProgress);
                    next = completeWork(current, workInProgress, renderExpirationTime$1); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
                }
                stopWorkTimer(workInProgress);
                resetCurrentFiber();
                resetChildExpirationTime(workInProgress);
                if (next !== null) // Completing this fiber spawned new work. Work on that next.
                return next;
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.effectTag & Incomplete) === NoEffect) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = workInProgress.firstEffect;
                    if (workInProgress.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                        returnFiber.lastEffect = workInProgress.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (effectTag > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress;
                        else returnFiber.firstEffect = workInProgress;
                        returnFiber.lastEffect = workInProgress;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(workInProgress); // Because this fiber did not complete, don't reset its expiration time.
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = workInProgress.actualDuration;
                    var child = workInProgress.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    workInProgress.actualDuration = actualDuration;
                }
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    // TODO: The name stopFailedWorkTimer is misleading because Suspense
                    // also captures and restarts.
                    stopFailedWorkTimer(workInProgress);
                    _next.effectTag &= HostEffectMask;
                    return _next;
                }
                stopWorkTimer(workInProgress);
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.effectTag |= Incomplete;
                }
            }
            var siblingFiber = workInProgress.sibling;
            if (siblingFiber !== null) // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
             // Otherwise, return to the parent
            workInProgress = returnFiber;
        }while (workInProgress !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
        return null;
    }
    function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
    }
    function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                var childUpdateExpirationTime = child.expirationTime;
                var childChildExpirationTime = child.childExpirationTime;
                if (childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = childUpdateExpirationTime;
                if (childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = childChildExpirationTime;
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                var _childUpdateExpirationTime = _child.expirationTime;
                var _childChildExpirationTime = _child.childExpirationTime;
                if (_childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = _childUpdateExpirationTime;
                if (_childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = _childChildExpirationTime;
                _child = _child.sibling;
            }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            renderExpirationTime$1 = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.
        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            startCommitSnapshotEffectsTimer();
            prepareForCommit(root.containerInfo);
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitSnapshotEffectsTimer();
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            startCommitHostEffectsTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitHostEffectsTimer();
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            startCommitLifeCyclesTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitLifeCyclesTimer();
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            // no effects.
            // TODO: Maybe there's a better way to report this.
            startCommitSnapshotEffectsTimer();
            stopCommitSnapshotEffectsTimer();
            recordCommitTime();
            startCommitHostEffectsTimer();
            stopCommitHostEffectsTimer();
            startCommitLifeCyclesTimer();
            stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsExpirationTime = expirationTime;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                nextEffect = nextNextEffect;
            }
        } // Check if there's remaining work on this root
        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingExpirationTime);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, expirationTime);
        if (remainingExpirationTime === Sync) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // This is a legacy edge case. We just committed the initial mount of
        // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var effectTag = nextEffect.effectTag;
            if ((effectTag & Snapshot) !== NoEffect) {
                setCurrentFiber(nextEffect);
                recordEffect();
                var current = nextEffect.alternate;
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((effectTag & Passive) !== NoEffect) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & ContentReset) commitResetTextContent(nextEffect);
            if (effectTag & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
            switch(primaryEffectTag){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.effectTag &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.effectTag &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.effectTag &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.effectTag &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect, renderPriorityLevel);
                    break;
            } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.
            recordEffect();
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & (Update | Callback)) {
                recordEffect();
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (effectTag & Ref) {
                recordEffect();
                commitAttachRef(nextEffect);
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root);
        // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var _effect2 = root.current.firstEffect;
        while(_effect2 !== null){
            setCurrentFiber(_effect2);
            invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
            if (hasCaughtError()) {
                if (!(_effect2 !== null)) throw Error("Should be working on an effect.");
                var _error5 = clearCaughtError();
                captureCommitPhaseError(_effect2, _error5);
            }
            resetCurrentFiber();
            var nextNextEffect = _effect2.nextEffect; // Remove nextEffect pointer to assist GC
            _effect2.nextEffect = null;
            _effect2 = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, expirationTime);
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, Sync);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, Sync);
                    enqueueUpdate(fiber, update);
                    var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
                    if (root !== null) {
                        ensureRootIsScheduled(root);
                        schedulePendingInteractions(root, Sync);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(thenable);
        if (workInProgressRoot === root && renderExpirationTime$1 === suspendedTime) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, we'll always suspend so we can always
            // restart. If we're suspended without any updates, it might be a retry.
            // If it's early in the retry we can restart. We can't know for sure
            // whether we'll eventually process an update during this render pass,
            // but it's somewhat unlikely that we get to a ping before that, since
            // getting to the root most update is usually very fast.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime$1);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
            return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) // The root is no longer suspended at this time.
        return;
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) // There's already a lower priority ping scheduled.
        return;
         // Mark the time at which this ping was scheduled.
        root.lastPingedTime = suspendedTime;
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
            var suspenseConfig = null; // Retries don't carry over the already committed update.
            var currentTime = requestCurrentTimeForUpdate();
            retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?
        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, retryTime);
        }
    }
    function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(thenable);
        retryTimedOutBoundary(boundaryFiber, retryTime);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) return 0;
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.
        var currentTimeMs = now();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) // If we haven't yet waited longer than the initial delay, we don't
        // have to wait any additional time.
        return 0;
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.
        return msUntilTimeout;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) interruptedBy = fiberThatReceivedUpdate;
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.%s", tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, expirationTime) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, expirationTime);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, expirationTime);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://fb.me/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from 'react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);%s", getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://fb.me/react-mock-scheduler");
            }
        }
    }
    function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(expirationTime) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            expirationTime
        ];
        else spawnedWorkDuringRender.push(expirationTime);
    }
    function scheduleInteractions(root, expirationTime, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(expirationTime);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, expirationTime) {
        scheduleInteractions(root, expirationTime, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, expirationTime) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
            if (scheduledExpirationTime >= expirationTime) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedExpirationTime) {
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                var threadID = computeThreadID(root, committedExpirationTime);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
                    pendingInteractionMap.delete(scheduledExpirationTime);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    }
    var onScheduleFiberRoot = null;
    var onCommitFiberRoot = null;
    var onCommitFiberUnmount = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://fb.me/react-devtools");
            return true;
        }
        try {
            var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            // Only used by Fast Refresh
            if (typeof hook.onScheduleFiberRoot === 'function') onScheduleFiberRoot = function(root, children) {
                try {
                    hook.onScheduleFiberRoot(rendererID, root, children);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error('React instrumentation encountered an error: %s', err);
                    }
                }
            };
            onCommitFiberRoot = function(root, expirationTime) {
                try {
                    var didError = (root.current.effectTag & DidCapture) === DidCapture;
                    if (enableProfilerTimer) {
                        var currentTime = getCurrentTime();
                        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                        hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
                    } else hook.onCommitFiberRoot(rendererID, root, undefined, didError);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error('React instrumentation encountered an error: %s', err);
                    }
                }
            };
            onCommitFiberUnmount = function(fiber) {
                try {
                    hook.onCommitFiberUnmount(rendererID, fiber);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error('React instrumentation encountered an error: %s', err);
                    }
                }
            };
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (typeof onScheduleFiberRoot === 'function') onScheduleFiberRoot(root, children);
    }
    function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === 'function') onCommitFiberRoot(root, expirationTime);
    }
    function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') onCommitFiberUnmount(fiber);
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        var testMap = new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        var testSet = new Set([
            nonExtensibleObject
        ]); // This is necessary for Rollup to not consider these unused.
        // https://github.com/rollup/rollup/issues/1771
        // TODO: we can remove these if Rollup fixes the bug.
        testMap.set(0, 0);
        testSet.add(0);
    } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        this._debugID = debugCounter++;
        this._debugIsCurrentlyTiming = false;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.effectTag = NoEffect; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childExpirationTime = NoWork;
            workInProgress.expirationTime = renderExpirationTime;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childExpirationTime = current.childExpirationTime;
            workInProgress.expirationTime = current.expirationTime;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                expirationTime: currentDependencies.expirationTime,
                firstContext: currentDependencies.firstContext,
                responders: currentDependencies.responders
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
                fiberTag = Mode;
                mode |= ConcurrentMode | BlockingMode | StrictMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') error('Profiler must specify an "id" string and "onRender" function as props');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
    }
    function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
    }
    function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) root.firstSuspendedTime = expirationTime;
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) root.lastSuspendedTime = expirationTime;
        if (expirationTime <= root.lastPingedTime) root.lastPingedTime = NoWork;
        if (expirationTime <= root.lastExpiredTime) root.lastExpiredTime = NoWork;
    }
    function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) root.firstPendingTime = expirationTime;
         // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.
        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
            if (expirationTime >= firstSuspendedTime) // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
            else if (expirationTime >= root.lastSuspendedTime) root.lastSuspendedTime = expirationTime + 1;
             // This is a pending level. Check if it's higher priority than the next
            // known pending level.
            if (expirationTime > root.nextKnownPendingLevel) root.nextKnownPendingLevel = expirationTime;
        }
    }
    function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.
        if (finishedExpirationTime <= root.lastSuspendedTime) // The entire suspended range is now unsuspended.
        root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        else if (finishedExpirationTime <= root.firstSuspendedTime) // Part of the suspended range is now unsuspended. Narrow the range to
        // include everything between the unsuspended time (non-inclusive) and the
        // last suspended time.
        root.firstSuspendedTime = finishedExpirationTime - 1;
        if (finishedExpirationTime <= root.lastPingedTime) // Clear the pinged time
        root.lastPingedTime = NoWork;
        if (finishedExpirationTime <= root.lastExpiredTime) // Clear the expired time
        root.lastExpiredTime = NoWork;
    }
    function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) root.lastExpiredTime = expirationTime;
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
                else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || 'Unknown');
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleWork(current$1, expirationTime);
        return expirationTime;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryTimeImpl(fiber, retryTime) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
            if (suspenseState.retryTime < retryTime) suspenseState.retryTime = retryTime;
        }
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryTimeIfNotHydrated(fiber, retryTime) {
        markRetryTimeImpl(fiber, retryTime);
        var alternate = fiber.alternate;
        if (alternate) markRetryTimeImpl(alternate, retryTime);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        scheduleWork(fiber, ContinuousHydration);
        markRetryTimeIfNotHydrated(fiber, ContinuousHydration);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var currentTime = requestCurrentTimeForUpdate();
        var expTime = computeExpirationForFiber(currentTime, fiber, null);
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideProps = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithSetImpl = function(obj, path, idx, value) {
        if (idx >= path.length) return value;
        var key = path[idx];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleWork(fiber, Sync);
    };
    scheduleUpdate = function(fiber) {
        scheduleWork(fiber, Sync);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
            overrideHookState: overrideHookState,
            overrideProps: overrideProps,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: function(fiber) {
                var hostFiber = findCurrentHostFiber(fiber);
                if (hostFiber === null) return null;
                return hostFiber.stateNode;
            },
            findFiberByHostInstance: function(instance) {
                if (!findFiberByHostInstance) // Might not be implemented by the renderer.
                return null;
                return findFiberByHostInstance(instance);
            },
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: function() {
                return current;
            }
        }));
    }
    var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        if (hydrate && tag !== LegacyRoot) {
            var doc = container.nodeType === DOCUMENT_NODE ? container : container.ownerDocument;
            eagerlyTrapReplayableEvents(container, doc);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v17. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var ReactVersion = '16.14.0';
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactDOMUnstableNativeDependencies.js
        // ReactTestUtils.js, and ReactTestUtilsAct.js. This is an array for better minification.
        Events: [
            getInstanceFromNode$1,
            getNodeFromInstance$1,
            getFiberCurrentPropsFromNode$1,
            injectEventPluginsByName,
            eventNameDispatchConfigs,
            accumulateTwoPhaseDispatches,
            accumulateDirectDispatches,
            enqueueStateRestore,
            restoreStateIfNeeded,
            dispatchEvent,
            runEventsInBatch,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://fb.me/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://fb.me/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

});
parcelRegister("7pM6b", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a84zE"));

});
parcelRegister("a84zE", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $75fe330518ebe242$export$c4744153514ff05d, (v) => $75fe330518ebe242$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $75fe330518ebe242$export$d66a1c1c77bd778b, (v) => $75fe330518ebe242$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $75fe330518ebe242$export$3e506c1ccc9cc1a7, (v) => $75fe330518ebe242$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $75fe330518ebe242$export$e26fe2ed2fa76875, (v) => $75fe330518ebe242$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $75fe330518ebe242$export$502329bbf4b505b1, (v) => $75fe330518ebe242$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $75fe330518ebe242$export$6e3807111c4874c4, (v) => $75fe330518ebe242$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $75fe330518ebe242$export$c27134553091fb3a, (v) => $75fe330518ebe242$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $75fe330518ebe242$export$33ee1acdc04fd2a2, (v) => $75fe330518ebe242$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $75fe330518ebe242$export$b00a404bbd5edef2, (v) => $75fe330518ebe242$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $75fe330518ebe242$export$8352ce38b91d0c62, (v) => $75fe330518ebe242$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $75fe330518ebe242$export$d3dfb8e4810cb555, (v) => $75fe330518ebe242$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $75fe330518ebe242$export$839f9183b0465a69, (v) => $75fe330518ebe242$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $75fe330518ebe242$export$72fdf0e06517287b, (v) => $75fe330518ebe242$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $75fe330518ebe242$export$4b844e58a3e414b4, (v) => $75fe330518ebe242$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $75fe330518ebe242$export$816d2913ae6b83b1, (v) => $75fe330518ebe242$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $75fe330518ebe242$export$61bcfe829111a1d0, (v) => $75fe330518ebe242$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $75fe330518ebe242$export$7ee8c9beb337bc3f, (v) => $75fe330518ebe242$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $75fe330518ebe242$export$b5836b71941fa3ed, (v) => $75fe330518ebe242$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $75fe330518ebe242$export$cf845f2c119da08a, (v) => $75fe330518ebe242$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $75fe330518ebe242$export$c4744153514ff05d;
var $75fe330518ebe242$export$d66a1c1c77bd778b;
var $75fe330518ebe242$export$3e506c1ccc9cc1a7;
var $75fe330518ebe242$export$e26fe2ed2fa76875;
var $75fe330518ebe242$export$502329bbf4b505b1;
var $75fe330518ebe242$export$6e3807111c4874c4;
var $75fe330518ebe242$export$c27134553091fb3a;
var $75fe330518ebe242$export$33ee1acdc04fd2a2;
var $75fe330518ebe242$export$b00a404bbd5edef2;
var $75fe330518ebe242$export$8352ce38b91d0c62;
var $75fe330518ebe242$export$d3dfb8e4810cb555;
var $75fe330518ebe242$export$839f9183b0465a69;
var $75fe330518ebe242$export$72fdf0e06517287b;
var $75fe330518ebe242$export$4b844e58a3e414b4;
var $75fe330518ebe242$export$816d2913ae6b83b1;
var $75fe330518ebe242$export$61bcfe829111a1d0;
var $75fe330518ebe242$export$7ee8c9beb337bc3f;
var $75fe330518ebe242$export$b5836b71941fa3ed;
var $75fe330518ebe242$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    var enableSchedulerDebugging = false;
    var enableProfiling = true;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var shouldYieldToHost;
    var requestPaint;
    if (// implementation using setTimeout.
    typeof window === 'undefined' || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = $75fe330518ebe242$export$c4744153514ff05d();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        var initialTime = Date.now();
        $75fe330518ebe242$export$c4744153514ff05d = function() {
            return Date.now() - initialTime;
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        shouldYieldToHost = function() {
            return false;
        };
        requestPaint = $75fe330518ebe242$export$d66a1c1c77bd778b = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var performance = window.performance;
        var _Date = window.Date;
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link
            if (typeof requestAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
            if (typeof cancelAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        }
        if (typeof performance === 'object' && typeof performance.now === 'function') $75fe330518ebe242$export$c4744153514ff05d = function() {
            return performance.now();
        };
        else {
            var _initialTime = _Date.now();
            $75fe330518ebe242$export$c4744153514ff05d = function() {
                return _Date.now() - _initialTime;
            };
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        shouldYieldToHost = function() {
            return $75fe330518ebe242$export$c4744153514ff05d() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        $75fe330518ebe242$export$d66a1c1c77bd778b = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console['error']("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = $75fe330518ebe242$export$c4744153514ff05d(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback($75fe330518ebe242$export$c4744153514ff05d());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var NoPriority = 0;
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    var runIdCounter = 0;
    var mainThreadIdCounter = 0;
    var profilingStateSize = 4;
    var sharedProfilingBuffer = typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
    ;
    var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks
    var PRIORITY = 0;
    var CURRENT_TASK_ID = 1;
    var CURRENT_RUN_ID = 2;
    var QUEUE_SIZE = 3;
    profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
    // array might include canceled tasks.
    profilingState[QUEUE_SIZE] = 0;
    profilingState[CURRENT_TASK_ID] = 0;
    var INITIAL_EVENT_LOG_SIZE = 131072;
    var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes
    var eventLogSize = 0;
    var eventLogBuffer = null;
    var eventLog = null;
    var eventLogIndex = 0;
    var TaskStartEvent = 1;
    var TaskCompleteEvent = 2;
    var TaskErrorEvent = 3;
    var TaskCancelEvent = 4;
    var TaskRunEvent = 5;
    var TaskYieldEvent = 6;
    var SchedulerSuspendEvent = 7;
    var SchedulerResumeEvent = 8;
    function logEvent(entries) {
        if (eventLog !== null) {
            var offset = eventLogIndex;
            eventLogIndex += entries.length;
            if (eventLogIndex + 1 > eventLogSize) {
                eventLogSize *= 2;
                if (eventLogSize > MAX_EVENT_LOG_SIZE) {
                    // Using console['error'] to evade Babel and ESLint
                    console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`.");
                    stopLoggingProfilingEvents();
                    return;
                }
                var newEventLog = new Int32Array(eventLogSize * 4);
                newEventLog.set(eventLog);
                eventLogBuffer = newEventLog.buffer;
                eventLog = newEventLog;
            }
            eventLog.set(entries, offset);
        }
    }
    function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
    }
    function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
    }
    function markTaskStart(task, ms) {
        profilingState[QUEUE_SIZE]++;
        if (eventLog !== null) // performance.now returns a float, representing milliseconds. When the
        // event is logged, it's coerced to an int. Convert to microseconds to
        // maintain extra degrees of precision.
        logEvent([
            TaskStartEvent,
            ms * 1000,
            task.id,
            task.priorityLevel
        ]);
    }
    function markTaskCompleted(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskCompleteEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskCanceled(task, ms) {
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskCancelEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskErrored(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskErrorEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskRun(task, ms) {
        runIdCounter++;
        profilingState[PRIORITY] = task.priorityLevel;
        profilingState[CURRENT_TASK_ID] = task.id;
        profilingState[CURRENT_RUN_ID] = runIdCounter;
        if (eventLog !== null) logEvent([
            TaskRunEvent,
            ms * 1000,
            task.id,
            runIdCounter
        ]);
    }
    function markTaskYield(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[CURRENT_RUN_ID] = 0;
        if (eventLog !== null) logEvent([
            TaskYieldEvent,
            ms * 1000,
            task.id,
            runIdCounter
        ]);
    }
    function markSchedulerSuspended(ms) {
        mainThreadIdCounter++;
        if (eventLog !== null) logEvent([
            SchedulerSuspendEvent,
            ms * 1000,
            mainThreadIdCounter
        ]);
    }
    function markSchedulerUnsuspended(ms) {
        if (eventLog !== null) logEvent([
            SchedulerResumeEvent,
            ms * 1000,
            mainThreadIdCounter
        ]);
    }
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
                markTaskStart(timer, currentTime);
                timer.isQueued = true;
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        markSchedulerUnsuspended(initialTime);
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $75fe330518ebe242$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod codepath.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
            var _currentTime = $75fe330518ebe242$export$c4744153514ff05d();
            markSchedulerSuspended(_currentTime);
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (callback !== null) {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                markTaskRun(currentTask, currentTime);
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $75fe330518ebe242$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') {
                    currentTask.callback = continuationCallback;
                    markTaskYield(currentTask, currentTime);
                } else {
                    markTaskCompleted(currentTask, currentTime);
                    currentTask.isQueued = false;
                    if (currentTask === peek(taskQueue)) pop(taskQueue);
                }
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function timeoutForPriorityLevel(priorityLevel) {
        switch(priorityLevel){
            case ImmediatePriority:
                return IMMEDIATE_PRIORITY_TIMEOUT;
            case UserBlockingPriority:
                return USER_BLOCKING_PRIORITY;
            case IdlePriority:
                return IDLE_PRIORITY;
            case LowPriority:
                return LOW_PRIORITY_TIMEOUT;
            case NormalPriority:
            default:
                return NORMAL_PRIORITY_TIMEOUT;
        }
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $75fe330518ebe242$export$c4744153514ff05d();
        var startTime;
        var timeout;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
            timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
            timeout = timeoutForPriorityLevel(priorityLevel);
            startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        newTask.isQueued = false;
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            markTaskStart(newTask, currentTime);
            newTask.isQueued = true;
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        if (task.isQueued) {
            var currentTime = $75fe330518ebe242$export$c4744153514ff05d();
            markTaskCanceled(task, currentTime);
            task.isQueued = false;
        }
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    function unstable_shouldYield() {
        var currentTime = $75fe330518ebe242$export$c4744153514ff05d();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
    };
    $75fe330518ebe242$export$3e506c1ccc9cc1a7 = IdlePriority;
    $75fe330518ebe242$export$e26fe2ed2fa76875 = ImmediatePriority;
    $75fe330518ebe242$export$502329bbf4b505b1 = LowPriority;
    $75fe330518ebe242$export$6e3807111c4874c4 = NormalPriority;
    $75fe330518ebe242$export$c27134553091fb3a = unstable_Profiling;
    $75fe330518ebe242$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $75fe330518ebe242$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $75fe330518ebe242$export$8352ce38b91d0c62 = unstable_continueExecution;
    $75fe330518ebe242$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $75fe330518ebe242$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $75fe330518ebe242$export$72fdf0e06517287b = unstable_next;
    $75fe330518ebe242$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $75fe330518ebe242$export$816d2913ae6b83b1 = unstable_requestPaint;
    $75fe330518ebe242$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $75fe330518ebe242$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $75fe330518ebe242$export$b5836b71941fa3ed = unstable_shouldYield;
    $75fe330518ebe242$export$cf845f2c119da08a = unstable_wrapCallback;
})();

});


parcelRegister("2CVR1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aQzhS"));

});
parcelRegister("aQzhS", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", () => $7e5a2206f41b3e17$export$236303149b061964, (v) => $7e5a2206f41b3e17$export$236303149b061964 = v);
$parcel$export(module.exports, "__subscriberRef", () => $7e5a2206f41b3e17$export$d8c36835f54f0a3b, (v) => $7e5a2206f41b3e17$export$d8c36835f54f0a3b = v);
$parcel$export(module.exports, "unstable_clear", () => $7e5a2206f41b3e17$export$4a908c8bc96de6cd, (v) => $7e5a2206f41b3e17$export$4a908c8bc96de6cd = v);
$parcel$export(module.exports, "unstable_getCurrent", () => $7e5a2206f41b3e17$export$49d8199c8144c803, (v) => $7e5a2206f41b3e17$export$49d8199c8144c803 = v);
$parcel$export(module.exports, "unstable_getThreadID", () => $7e5a2206f41b3e17$export$c7d3dd8712817dbc, (v) => $7e5a2206f41b3e17$export$c7d3dd8712817dbc = v);
$parcel$export(module.exports, "unstable_subscribe", () => $7e5a2206f41b3e17$export$932a6d6a24b633a5, (v) => $7e5a2206f41b3e17$export$932a6d6a24b633a5 = v);
$parcel$export(module.exports, "unstable_trace", () => $7e5a2206f41b3e17$export$8405cb466bd0a1f1, (v) => $7e5a2206f41b3e17$export$8405cb466bd0a1f1 = v);
$parcel$export(module.exports, "unstable_unsubscribe", () => $7e5a2206f41b3e17$export$4fd753a282912317, (v) => $7e5a2206f41b3e17$export$4fd753a282912317 = v);
$parcel$export(module.exports, "unstable_wrap", () => $7e5a2206f41b3e17$export$230d7bceee602808, (v) => $7e5a2206f41b3e17$export$230d7bceee602808 = v);
/** @license React v0.19.1
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.
var $7e5a2206f41b3e17$export$236303149b061964;
var $7e5a2206f41b3e17$export$d8c36835f54f0a3b;
var $7e5a2206f41b3e17$export$4a908c8bc96de6cd;
var $7e5a2206f41b3e17$export$49d8199c8144c803;
var $7e5a2206f41b3e17$export$c7d3dd8712817dbc;
var $7e5a2206f41b3e17$export$932a6d6a24b633a5;
var $7e5a2206f41b3e17$export$8405cb466bd0a1f1;
var $7e5a2206f41b3e17$export$4fd753a282912317;
var $7e5a2206f41b3e17$export$230d7bceee602808;
'use strict';
(function() {
    'use strict';
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    $7e5a2206f41b3e17$export$236303149b061964 = null; // Listener(s) to notify when interactions begin and end.
    $7e5a2206f41b3e17$export$d8c36835f54f0a3b = null;
    $7e5a2206f41b3e17$export$236303149b061964 = {
        current: new Set()
    };
    $7e5a2206f41b3e17$export$d8c36835f54f0a3b = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = $7e5a2206f41b3e17$export$236303149b061964.current;
        $7e5a2206f41b3e17$export$236303149b061964.current = new Set();
        try {
            return callback();
        } finally{
            $7e5a2206f41b3e17$export$236303149b061964.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return $7e5a2206f41b3e17$export$236303149b061964.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = $7e5a2206f41b3e17$export$236303149b061964.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        $7e5a2206f41b3e17$export$236303149b061964.current = interactions;
        var subscriber = $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    $7e5a2206f41b3e17$export$236303149b061964.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = $7e5a2206f41b3e17$export$236303149b061964.current;
        var subscriber = $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = $7e5a2206f41b3e17$export$236303149b061964.current;
            $7e5a2206f41b3e17$export$236303149b061964.current = wrappedInteractions;
            subscriber = $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        $7e5a2206f41b3e17$export$236303149b061964.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) $7e5a2206f41b3e17$export$d8c36835f54f0a3b.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    $7e5a2206f41b3e17$export$4a908c8bc96de6cd = unstable_clear;
    $7e5a2206f41b3e17$export$49d8199c8144c803 = unstable_getCurrent;
    $7e5a2206f41b3e17$export$c7d3dd8712817dbc = unstable_getThreadID;
    $7e5a2206f41b3e17$export$932a6d6a24b633a5 = unstable_subscribe;
    $7e5a2206f41b3e17$export$8405cb466bd0a1f1 = unstable_trace;
    $7e5a2206f41b3e17$export$4fd753a282912317 = unstable_unsubscribe;
    $7e5a2206f41b3e17$export$230d7bceee602808 = unstable_wrap;
})();

});




parcelRegister("01EAe", function(module, exports) {
"use strict";
function $004f932055a77f96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $004f932055a77f96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $004f932055a77f96$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $004f932055a77f96$var$_react = $004f932055a77f96$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $klIz4 = parcelRequire("klIz4");

var $004f932055a77f96$var$_async = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("dfWFX")));

var $004f932055a77f96$var$_TextField = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("1McdI")));

var $004f932055a77f96$var$_Autocomplete = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("e6mUx")));

var $004f932055a77f96$var$_Grid = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jDaBC")));

var $004f932055a77f96$var$_CircularProgress = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("aTo9O")));

var $004f932055a77f96$var$_Dialog = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("eEcXz")));

var $004f932055a77f96$var$_DialogTitle = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("cjc3M")));

var $004f932055a77f96$var$_DialogContent = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("ccMAL")));

var $004f932055a77f96$var$_DialogContentText = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("i6cb3")));

var $004f932055a77f96$var$_DialogActions = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("8qTHT")));

var $004f932055a77f96$var$_Button = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("1iKK0")));

var $004f932055a77f96$var$_Slider = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("bRcNV")));

var $6iob3 = parcelRequire("6iob3");
var $jTsdR = parcelRequire("jTsdR");
var $98N7C = parcelRequire("98N7C");

var $004f932055a77f96$var$_AppBar = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("gXU2h")));

var $004f932055a77f96$var$_Tabs = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("2diEy")));

var $004f932055a77f96$var$_Tab = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("2jXxB")));

var $004f932055a77f96$var$_Typography = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jhR24")));

var $004f932055a77f96$var$_Box = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("ld36h")));

var $3OcDw = parcelRequire("3OcDw");
var $gFzGS = parcelRequire("gFzGS");

var $004f932055a77f96$var$_moment = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jY97E")));

var $004f932055a77f96$var$_dateFns = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jEDhL")));

var $004f932055a77f96$var$_throttle = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("5zbtW")));

var $004f932055a77f96$var$_debounce = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("bgvW5")));

var $004f932055a77f96$var$_filter = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jTA3B")));

var $004f932055a77f96$var$_isEqual = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("7YTVN")));

var $004f932055a77f96$var$_includes = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("5CVir")));

var $004f932055a77f96$var$_uniqBy = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("gyBtf")));

var $004f932055a77f96$var$_sortBy = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("fZuoP")));

var $itj94 = parcelRequire("itj94");

var $004f932055a77f96$var$_EventTypes = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("kSUb8")));

var $004f932055a77f96$var$_Teams = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("8iJ1Q")));

var $004f932055a77f96$var$_Venues = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("h51r7")));

var $004f932055a77f96$var$_RunCalculations = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("fKd4Q")));

var $004f932055a77f96$var$_SavantModel = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("6Xpvk")));

var $004f932055a77f96$var$_find = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("clJ7m")));

var $4I68J = parcelRequire("4I68J");

var $aMSIv = parcelRequire("aMSIv");

var $004f932055a77f96$var$_canBePersonalized = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("jrjqE")));

var $004f932055a77f96$var$_Schema = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("394kY")));

var $004f932055a77f96$var$_MultiPick = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("dl4nW")));

var $kylyz = parcelRequire("kylyz");

var $004f932055a77f96$var$_App = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("8Qt6N")));

var $004f932055a77f96$var$_PlayerStats = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("hOWcg")));

var $004f932055a77f96$var$_FormOption = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("lvjWJ")));

var $004f932055a77f96$var$_index = $004f932055a77f96$var$_interopRequireDefault((parcelRequire("aQQ9o")));
var $004f932055a77f96$var$_excluded = [
    "children",
    "value",
    "index"
];
/* eslint-disable react/button-has-type */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* global queryString, isMinors, trendingPlayers */ /* Material UI Components */ // Use for calculations
function $004f932055a77f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $004f932055a77f96$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($004f932055a77f96$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $004f932055a77f96$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $004f932055a77f96$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $004f932055a77f96$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $004f932055a77f96$var$_slicedToArray(r, e) {
    return $004f932055a77f96$var$_arrayWithHoles(r) || $004f932055a77f96$var$_iterableToArrayLimit(r, e) || $004f932055a77f96$var$_unsupportedIterableToArray(r, e) || $004f932055a77f96$var$_nonIterableRest();
}
function $004f932055a77f96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $004f932055a77f96$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $004f932055a77f96$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $004f932055a77f96$var$_toConsumableArray(r) {
    return $004f932055a77f96$var$_arrayWithoutHoles(r) || $004f932055a77f96$var$_iterableToArray(r) || $004f932055a77f96$var$_unsupportedIterableToArray(r) || $004f932055a77f96$var$_nonIterableSpread();
}
function $004f932055a77f96$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $004f932055a77f96$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $004f932055a77f96$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $004f932055a77f96$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $004f932055a77f96$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $004f932055a77f96$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $004f932055a77f96$var$_arrayLikeToArray(r);
}
function $004f932055a77f96$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $004f932055a77f96$var$_extends() {
    return $004f932055a77f96$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $004f932055a77f96$var$_extends.apply(null, arguments);
}
function $004f932055a77f96$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $004f932055a77f96$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $004f932055a77f96$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $004f932055a77f96$var$_appSettings$illustra = $itj94.appSettings.illustrator, $004f932055a77f96$var$currentYear = $004f932055a77f96$var$_appSettings$illustra.currentYear, $004f932055a77f96$var$defaultYears = $004f932055a77f96$var$_appSettings$illustra.years;
var $004f932055a77f96$var$yearMin = $004f932055a77f96$var$defaultYears.at(-1);
var $004f932055a77f96$var$venueNamesDict = $004f932055a77f96$var$_Venues["default"].venues.reduce(function(acc, curr) {
    acc[curr.value] = curr.name;
    return acc;
}, {});
var $004f932055a77f96$var$generateClassName = (0, $6iob3.default)({
    productionPrefix: 'c',
    seed: 'App1'
});
/* Material UI Slider Functions */ function $004f932055a77f96$var$sliderValueText(value) {
    return "".concat(value, " MPH");
}
function $004f932055a77f96$var$TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = $004f932055a77f96$var$_objectWithoutProperties(props, $004f932055a77f96$var$_excluded);
    return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], $004f932055a77f96$var$_extends({
        component: "div",
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Box["default"], {
        p: 3
    }, children));
}
function $004f932055a77f96$var$isRealPitch(pitch) {
    return ![
        'UN',
        'IN',
        'AB',
        'AS',
        'NP'
    ].includes(pitch);
}
function $004f932055a77f96$var$a11yProps(index) {
    return {
        id: "simple-tab-".concat(index),
        'aria-controls': "simple-tabpanel-".concat(index)
    };
}
function $004f932055a77f96$var$fetchDateState(dateStr) {
    if (!dateStr) return null;
    return {
        dateStr: dateStr,
        // Bah to timezones, but thanks AI for this hack to make it local rather than utc
        dateObj: new Date("".concat(dateStr, "T00:00:00"))
    };
}
var $004f932055a77f96$var$useStyles = (0, $jTsdR.default)(function() {
    return {
        root: {
            flexGrow: 1,
            backgroundColor: '#fff'
        },
        tabRoot: {
            minWidth: 100
        }
    };
});
/* const acStyles = makeStyles((theme) => ({
    inputRoot: {
        borderRadius: "0px",
        padding: "0px",
        margin: "0px",
        height: "3rem",
        fontFamily: "Roboto Condensed",
    },
    label: {
        fontFamily: "Roboto Condensed",
    },
})); */ var $004f932055a77f96$var$acStyles = (0, $jTsdR.default)(function() {
    return {
        label: {
            transform: 'translate(1rem, 1rem) scale(1)',
            fontFamily: 'Roboto Condensed',
            paddingTop: '0rem'
        },
        focus: {
            color: '#3a9098 !important'
        },
        /* Styles applied when the popup icon is rendered. */ inputRoot: {
            borderRadius: '0px',
            padding: '0px',
            margin: '0px',
            height: '3rem'
        },
        cssLabel: {
            color: '#3a9098'
        },
        cssOutlinedInput: {
            '&$cssFocused $notchedOutline': {
                borderColor: "#3a9098 !important"
            }
        },
        cssFocused: {},
        notchedOutline: {
            borderWidth: '1px',
            borderColor: '#3a9098 !important'
        }
    };
});
function $004f932055a77f96$var$getYearData(data, years) {
    var yearsSet = new Set(years.map(Number));
    if (!(data !== null && data !== void 0 && data.length)) return [];
    // Filter the data down to the years that the user is looking at
    return data.filter(function(d) {
        return !years.length || yearsSet.has(Number(d.year));
    });
}
function $004f932055a77f96$var$getSeasonTypes(yearData) {
    if (!yearData) return $004f932055a77f96$var$_EventTypes["default"].seasonTypes;
    // The game types in the given year
    var gameTypes = new Set(yearData.map(function(d) {
        return d.game_type;
    }));
    return $004f932055a77f96$var$_EventTypes["default"].seasonTypes.filter(function(d) {
        return gameTypes.has(d.value);
    });
}
function $004f932055a77f96$var$getPitchTypes(yearData) {
    if (!yearData) return [];
    // Filter the data down to the years that the user is looking at
    var filteredData = yearData.filter(function(d) {
        return d.pitch_type !== null && d.pitch_type !== '' && $004f932055a77f96$var$isRealPitch(d.pitch_type);
    });
    var pitchTypes = $004f932055a77f96$var$_toConsumableArray(new Set(filteredData.map(function(d) {
        return d.pitch_type;
    })));
    return (0, $4I68J.sortPitchTypes)(pitchTypes).map(function(d) {
        return {
            name: (0, $aMSIv.getPitchName)(d),
            value: d
        };
    });
}
function $004f932055a77f96$var$getUniqueGames(yearData) {
    if (!yearData) return [];
    return (0, $004f932055a77f96$var$_uniqBy["default"])(yearData, function(d) {
        return d.game_pk;
    }).filter(function(d) {
        return d.game_pk !== null;
    }).map(function(d) {
        return {
            name: "".concat(d.away_team, " vs. ").concat(d.home_team, " - ").concat((0, $004f932055a77f96$var$_moment["default"])(d.game_date).format('YYYY-MM-DD')),
            value: d.game_pk
        };
    });
}
function $004f932055a77f96$var$populateClearedUrl(playerInfo, playerType) {
    return "?playerId=".concat(playerInfo.playerId, "&playerType=").concat(playerType, "&name=").concat(playerInfo.name);
}
function $004f932055a77f96$var$getUniquePlayers(yearData, otherPlayerType) {
    if (!yearData) return [];
    var playerMap = {};
    var prop = "".concat(otherPlayerType, "_name");
    yearData.forEach(function(p) {
        var playerKey = p[otherPlayerType];
        if (playerMap[playerKey]) return;
        playerMap[playerKey] = {
            name: p[prop],
            value: playerKey
        };
    });
    return Object.values(playerMap).sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
    });
}
var $004f932055a77f96$var$KAUFFMAN_ID = 7;
var $004f932055a77f96$var$standardVenues = $004f932055a77f96$var$_Venues["default"].venues.filter(function(d) {
    return !d.extra;
});
var $004f932055a77f96$var$extraVenues = $004f932055a77f96$var$_Venues["default"].venues.filter(function(d) {
    return d.extra;
});
var $004f932055a77f96$var$theK = $004f932055a77f96$var$_Venues["default"].venues.find(function(v) {
    return v.value === $004f932055a77f96$var$KAUFFMAN_ID;
});
function $004f932055a77f96$var$Data(props) {
    var classes = $004f932055a77f96$var$useStyles();
    var autoCompleteStyles = $004f932055a77f96$var$acStyles();
    var _useState = (0, $004f932055a77f96$var$_react.useState)(0), _useState2 = $004f932055a77f96$var$_slicedToArray(_useState, 2), tabSelection = _useState2[0], setTabSelection = _useState2[1];
    var _useState3 = (0, $004f932055a77f96$var$_react.useState)(window.innerWidth || 1000), _useState4 = $004f932055a77f96$var$_slicedToArray(_useState3, 2), pageWidth = _useState4[0], setPageWidth = _useState4[1];
    var _useState5 = (0, $004f932055a77f96$var$_react.useState)(false), _useState6 = $004f932055a77f96$var$_slicedToArray(_useState5, 2), modalOpen = _useState6[0], setModalOpen = _useState6[1];
    var _useState7 = (0, $004f932055a77f96$var$_react.useState)(false), _useState8 = $004f932055a77f96$var$_slicedToArray(_useState7, 2), togglePlayerStats = _useState8[0], setTogglePlayerStats = _useState8[1];
    var _useState9 = (0, $004f932055a77f96$var$_react.useState)(''), _useState10 = $004f932055a77f96$var$_slicedToArray(_useState9, 2), inputValue = _useState10[0], setInputValue = _useState10[1];
    var _useState11 = (0, $004f932055a77f96$var$_react.useState)(trendingPlayers || []), _useState12 = $004f932055a77f96$var$_slicedToArray(_useState11, 2), options = _useState12[0], setOptions = _useState12[1];
    var _useState13 = (0, $004f932055a77f96$var$_react.useState)(null), _useState14 = $004f932055a77f96$var$_slicedToArray(_useState13, 2), playerInfo = _useState14[0], setPlayerInfo = _useState14[1];
    var _React$useState = $004f932055a77f96$var$_react["default"].useState(// eslint-disable-next-line react/destructuring-assignment
    props.player || {
        playerType: 'pitcher',
        playerName: null,
        playerId: null
    }), _React$useState2 = $004f932055a77f96$var$_slicedToArray(_React$useState, 2), player = _React$useState2[0], setPlayer = _React$useState2[1];
    var playerTypes = [
        'batter',
        'pitcher'
    ];
    var initialPlayerType = playerTypes.includes(queryString.playerType) ? queryString.playerType : 'batter';
    var _useState15 = (0, $004f932055a77f96$var$_react.useState)(initialPlayerType === 'batter' ? 'pitcher' : 'batter'), _useState16 = $004f932055a77f96$var$_slicedToArray(_useState15, 2), otherPlayerType = _useState16[0], setOtherPlayerType = _useState16[1];
    var _useState17 = (0, $004f932055a77f96$var$_react.useState)(queryString.subTitle || ''), _useState18 = $004f932055a77f96$var$_slicedToArray(_useState17, 2), subTitle = _useState18[0], setSubTitle = _useState18[1];
    var _useState19 = (0, $004f932055a77f96$var$_react.useState)(queryString.chartType || 'zoneChart-totalPitches'), _useState20 = $004f932055a77f96$var$_slicedToArray(_useState19, 2), chartType = _useState20[0], setChartType = _useState20[1];
    var is3d = chartType.startsWith('3d-');
    var _useState21 = (0, $004f932055a77f96$var$_react.useState)(queryString.chartName || 'Zone - Total Pitches'), _useState22 = $004f932055a77f96$var$_slicedToArray(_useState21, 2), chartName = _useState22[0], setChartName = _useState22[1];
    var _useState23 = (0, $004f932055a77f96$var$_react.useState)(queryString.venue || $004f932055a77f96$var$KAUFFMAN_ID), _useState24 = $004f932055a77f96$var$_slicedToArray(_useState23, 2), venueId = _useState24[0], setVenueId = _useState24[1];
    var _useState25 = (0, $004f932055a77f96$var$_react.useState)($004f932055a77f96$var$venueNamesDict[venueId] || $004f932055a77f96$var$theK.name), _useState26 = $004f932055a77f96$var$_slicedToArray(_useState25, 2), venueName = _useState26[0], setVenueName = _useState26[1];
    var _useState27 = (0, $004f932055a77f96$var$_react.useState)('Save Image'), _useState28 = $004f932055a77f96$var$_slicedToArray(_useState27, 2), saveImageText = _useState28[0], setSaveImageText = _useState28[1];
    var _useState29 = (0, $004f932055a77f96$var$_react.useState)(false), _useState30 = $004f932055a77f96$var$_slicedToArray(_useState29, 2), isSavingImage = _useState30[0], setIsSavingImage = _useState30[1];
    var _useState31 = (0, $004f932055a77f96$var$_react.useState)('Embed Image'), _useState32 = $004f932055a77f96$var$_slicedToArray(_useState31, 2), embedImageText = _useState32[0], setEmbedImageText = _useState32[1];
    var _useState33 = (0, $004f932055a77f96$var$_react.useState)(null), _useState34 = $004f932055a77f96$var$_slicedToArray(_useState33, 2), embedLink = _useState34[0], setEmbedLink = _useState34[1];
    var _useState35 = (0, $004f932055a77f96$var$_react.useState)(false), _useState36 = $004f932055a77f96$var$_slicedToArray(_useState35, 2), isDataLoading = _useState36[0], setIsDataLoading = _useState36[1];
    var _useState37 = (0, $004f932055a77f96$var$_react.useState)(false), _useState38 = $004f932055a77f96$var$_slicedToArray(_useState37, 2), isYearlyDataLoading = _useState38[0], setIsYearlyDataLoading = _useState38[1];
    var _useState39 = (0, $004f932055a77f96$var$_react.useState)(false), _useState40 = $004f932055a77f96$var$_slicedToArray(_useState39, 2), pageLoad = _useState40[0], setPageLoad = _useState40[1];
    var _useState41 = (0, $004f932055a77f96$var$_react.useState)(false), _useState42 = $004f932055a77f96$var$_slicedToArray(_useState41, 2), tweakVisual = _useState42[0], setTweakVisual = _useState42[1];
    var handleClose = function handleClose() {
    // setOpen(false)
    };
    // Data Filters
    var _useState43 = (0, $004f932055a77f96$var$_react.useState)(queryString.shape || 'square'), _useState44 = $004f932055a77f96$var$_slicedToArray(_useState43, 2), shape = _useState44[0], setShape = _useState44[1];
    var _useState45 = (0, $004f932055a77f96$var$_react.useState)(queryString.shapeName || 'Square (Instagram)'), _useState46 = $004f932055a77f96$var$_slicedToArray(_useState45, 2), shapeName = _useState46[0], setShapeName = _useState46[1];
    var _useState47 = (0, $004f932055a77f96$var$_react.useState)(queryString.perspective || 'catcher'), _useState48 = $004f932055a77f96$var$_slicedToArray(_useState47, 2), perspective = _useState48[0], setPerspective = _useState48[1];
    var _useState49 = (0, $004f932055a77f96$var$_react.useState)(queryString.normalize || 'normalized'), _useState50 = $004f932055a77f96$var$_slicedToArray(_useState49, 2), normalize = _useState50[0], setNormalize = _useState50[1];
    var _useState51 = (0, $004f932055a77f96$var$_react.useState)(queryString.pitcherThrows || ''), _useState52 = $004f932055a77f96$var$_slicedToArray(_useState51, 2), pitcherThrows = _useState52[0], setPitcherThrows = _useState52[1];
    var _useState53 = (0, $004f932055a77f96$var$_react.useState)(queryString.batterStands || ''), _useState54 = $004f932055a77f96$var$_slicedToArray(_useState53, 2), batterStands = _useState54[0], setBatterStands = _useState54[1];
    var _useState55 = (0, $004f932055a77f96$var$_react.useState)(queryString.years ? JSON.parse(queryString.years) : [
        $004f932055a77f96$var$currentYear
    ]), _useState56 = $004f932055a77f96$var$_slicedToArray(_useState55, 2), years = _useState56[0], setYears = _useState56[1];
    var _useState57 = (0, $004f932055a77f96$var$_react.useState)(queryString.plateAppearanceResults ? JSON.parse(queryString.plateAppearanceResults) : []), _useState58 = $004f932055a77f96$var$_slicedToArray(_useState57, 2), plateAppearanceResults = _useState58[0], setPlateAppearanceResults = _useState58[1];
    var _useState59 = (0, $004f932055a77f96$var$_react.useState)(queryString.seasonType ? JSON.parse(queryString.seasonType) : [
        'R'
    ]), _useState60 = $004f932055a77f96$var$_slicedToArray(_useState59, 2), seasonType = _useState60[0], setSeasonType = _useState60[1];
    var _useState61 = (0, $004f932055a77f96$var$_react.useState)(queryString.pitchTypes ? JSON.parse(queryString.pitchTypes) : []), _useState62 = $004f932055a77f96$var$_slicedToArray(_useState61, 2), pitchTypes = _useState62[0], setPitchTypes = _useState62[1];
    var _useState63 = (0, $004f932055a77f96$var$_react.useState)(queryString.pitchResults ? JSON.parse(queryString.pitchResults) : []), _useState64 = $004f932055a77f96$var$_slicedToArray(_useState63, 2), pitchResults = _useState64[0], setPitchResults = _useState64[1];
    var _useState65 = (0, $004f932055a77f96$var$_react.useState)(queryString.facingPlayer ? JSON.parse(queryString.facingPlayer) : []), _useState66 = $004f932055a77f96$var$_slicedToArray(_useState65, 2), facingPlayer = _useState66[0], setFacingPlayer = _useState66[1];
    var _useState67 = (0, $004f932055a77f96$var$_react.useState)(queryString.balls ? JSON.parse(queryString.balls) : []), _useState68 = $004f932055a77f96$var$_slicedToArray(_useState67, 2), balls = _useState68[0], setBalls = _useState68[1];
    var _useState69 = (0, $004f932055a77f96$var$_react.useState)(queryString.strikes ? JSON.parse(queryString.strikes) : []), _useState70 = $004f932055a77f96$var$_slicedToArray(_useState69, 2), strikes = _useState70[0], setStrikes = _useState70[1];
    var _useState71 = (0, $004f932055a77f96$var$_react.useState)(queryString.outs ? JSON.parse(queryString.outs) : []), _useState72 = $004f932055a77f96$var$_slicedToArray(_useState71, 2), outs = _useState72[0], setOuts = _useState72[1];
    var _useState73 = (0, $004f932055a77f96$var$_react.useState)(queryString.battedBallType ? JSON.parse(queryString.battedBallType) : []), _useState74 = $004f932055a77f96$var$_slicedToArray(_useState73, 2), battedBallType = _useState74[0], setBattedBallType = _useState74[1];
    var _useState75 = (0, $004f932055a77f96$var$_react.useState)(queryString.selectedGames ? JSON.parse(queryString.selectedGames) : []), _useState76 = $004f932055a77f96$var$_slicedToArray(_useState75, 2), selectedGames = _useState76[0], setSelectedGames = _useState76[1];
    var _useState77 = (0, $004f932055a77f96$var$_react.useState)($004f932055a77f96$var$fetchDateState(queryString.gameDateGT)), _useState78 = $004f932055a77f96$var$_slicedToArray(_useState77, 2), gameDateGT = _useState78[0], setGameDateGT = _useState78[1];
    var _useState79 = (0, $004f932055a77f96$var$_react.useState)($004f932055a77f96$var$fetchDateState(queryString.gameDateLT)), _useState80 = $004f932055a77f96$var$_slicedToArray(_useState79, 2), gameDateLT = _useState80[0], setGameDateLT = _useState80[1];
    var _useState81 = (0, $004f932055a77f96$var$_react.useState)(queryString.exitVelocityGT ? Number(queryString.exitVelocityGT) : 0), _useState82 = $004f932055a77f96$var$_slicedToArray(_useState81, 2), exitVelocityGT = _useState82[0], setExitVelocityGT = _useState82[1];
    var _useState83 = (0, $004f932055a77f96$var$_react.useState)(queryString.exitVelocityLT ? Number(queryString.exitVelocityLT) : 125), _useState84 = $004f932055a77f96$var$_slicedToArray(_useState83, 2), exitVelocityLT = _useState84[0], setExitVelocityLT = _useState84[1];
    var _useState85 = (0, $004f932055a77f96$var$_react.useState)(queryString.launchAngleGT ? Number(queryString.launchAngleGT) : -90), _useState86 = $004f932055a77f96$var$_slicedToArray(_useState85, 2), launchAngleGT = _useState86[0], setLaunchAngleGT = _useState86[1];
    var _useState87 = (0, $004f932055a77f96$var$_react.useState)(queryString.launchAngleLT ? Number(queryString.launchAngleLT) : 90), _useState88 = $004f932055a77f96$var$_slicedToArray(_useState87, 2), launchAngleLT = _useState88[0], setLaunchAngleLT = _useState88[1];
    var _useState89 = (0, $004f932055a77f96$var$_react.useState)(queryString.pitchVelocityGT ? Number(queryString.pitchVelocityGT) : 0), _useState90 = $004f932055a77f96$var$_slicedToArray(_useState89, 2), pitchVelocityGT = _useState90[0], setPitchVelocityGT = _useState90[1];
    var _useState91 = (0, $004f932055a77f96$var$_react.useState)(queryString.pitchVelocityLT ? Number(queryString.pitchVelocityLT) : 105), _useState92 = $004f932055a77f96$var$_slicedToArray(_useState91, 2), pitchVelocityLT = _useState92[0], setPitchVelocityLT = _useState92[1];
    var _useState93 = (0, $004f932055a77f96$var$_react.useState)(queryString.homeTeam ? JSON.parse(queryString.homeTeam) : []), _useState94 = $004f932055a77f96$var$_slicedToArray(_useState93, 2), homeTeam = _useState94[0], setHomeTeam = _useState94[1];
    var _useState95 = (0, $004f932055a77f96$var$_react.useState)(queryString.awayTeam ? JSON.parse(queryString.awayTeam) : []), _useState96 = $004f932055a77f96$var$_slicedToArray(_useState95, 2), awayTeam = _useState96[0], setAwayTeam = _useState96[1];
    var _useState97 = (0, $004f932055a77f96$var$_react.useState)(queryString.vsTeam ? JSON.parse(queryString.vsTeam) : []), _useState98 = $004f932055a77f96$var$_slicedToArray(_useState97, 2), vsTeam = _useState98[0], setVsTeam = _useState98[1];
    var _useState99 = (0, $004f932055a77f96$var$_react.useState)(0), _useState100 = $004f932055a77f96$var$_slicedToArray(_useState99, 2), updateId = _useState100[0], setUpdateId = _useState100[1];
    function populateUrl() {
        var playerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var pType = playerInfo.playerType;
        var selectedYears = JSON.stringify(years);
        if (playerType) {
            selectedYears = '';
            pType = playerType;
        }
        var playerUrl = "?playerId=".concat(playerInfo.playerId, "&playerType=").concat(pType, "&name=").concat(playerInfo.name);
        var queryGameDateGT = gameDateGT ? "&gameDateGT=".concat(gameDateGT.dateStr) : '';
        var queryGameDateLT = gameDateLT ? "&gameDateLT=".concat(gameDateLT.dateStr) : '';
        var queryZoneNormal = normalize ? "&normalize=".concat(normalize) : '';
        var stateUrl = "&tabSelection=".concat(tabSelection, "&shape=").concat(shape, "&shapeName=").concat(shapeName, "&subTitle=").concat(subTitle, "&chartType=").concat(chartType, "&chartName=").concat(chartName, "&pitcherThrows=").concat(pitcherThrows, "&batterStands=").concat(batterStands, "&plateAppearanceResults=").concat(JSON.stringify(plateAppearanceResults), "&pitchTypes=").concat(JSON.stringify(pitchTypes), "&seasonType=").concat(JSON.stringify(seasonType), "&pitchResults=").concat(JSON.stringify(pitchResults), "&facingPlayer=").concat(JSON.stringify(facingPlayer), "&balls=").concat(JSON.stringify(balls), "&battedBallType=").concat(JSON.stringify(battedBallType), "&years=").concat(selectedYears, "&strikes=").concat(JSON.stringify(strikes), "&outs=").concat(JSON.stringify(outs), "&selectedGames=").concat(JSON.stringify(selectedGames), "&homeTeam=").concat(JSON.stringify(homeTeam), "&awayTeam=").concat(JSON.stringify(awayTeam), "&vsTeam=").concat(JSON.stringify(vsTeam), "&exitVelocityGT=").concat(exitVelocityGT, "&exitVelocityLT=").concat(exitVelocityLT, "&pitchVelocityGT=").concat(pitchVelocityGT, "&pitchVelocityLT=").concat(pitchVelocityLT, "&launchAngleGT=").concat(launchAngleGT, "&launchAngleLT=").concat(launchAngleLT, "&perspective=").concat(perspective, "&venue=").concat(venueId).concat(queryGameDateGT).concat(queryGameDateLT).concat(queryZoneNormal);
        window.history.pushState('', '', playerUrl + stateUrl);
        return playerUrl + stateUrl;
    }
    function resetStateFormValues() {
        setPitcherThrows('');
        setBatterStands('');
        setSeasonType([
            'R'
        ]);
        setPlateAppearanceResults([]);
        setPitchTypes([]);
        setPitchResults([]);
        setFacingPlayer([]);
        setBalls([]);
        setStrikes([]);
        // setYears([]);
        setOuts([]);
        setBattedBallType([]);
        setSelectedGames([]);
        setGameDateGT(null);
        setGameDateLT(null);
        setExitVelocityGT(0);
        setExitVelocityLT(125);
        setLaunchAngleGT(-90);
        setLaunchAngleLT(90);
        setPitchVelocityGT(0);
        setPitchVelocityLT(105);
    }
    var _useState101 = (0, $004f932055a77f96$var$_react.useState)(null), _useState102 = $004f932055a77f96$var$_slicedToArray(_useState101, 2), staticPlayerData = _useState102[0], setStaticPlayerData = _useState102[1];
    var _useState103 = (0, $004f932055a77f96$var$_react.useState)(null), _useState104 = $004f932055a77f96$var$_slicedToArray(_useState103, 2), playerData = _useState104[0], setPlayerData = _useState104[1];
    var _useState105 = (0, $004f932055a77f96$var$_react.useState)(null), _useState106 = $004f932055a77f96$var$_slicedToArray(_useState105, 2), playerStats = _useState106[0], setPlayerStats = _useState106[1];
    var previousDataState = usePrevious(playerData);
    var _useState107 = (0, $004f932055a77f96$var$_react.useState)([]), _useState108 = $004f932055a77f96$var$_slicedToArray(_useState107, 2), uniqYears = _useState108[0], setUniqYears = _useState108[1];
    function usePrevious(value) {
        var ref = (0, $004f932055a77f96$var$_react.useRef)();
        (0, $004f932055a77f96$var$_react.useEffect)(function() {
            ref.current = value;
        });
        return ref.current;
    }
    var yearData = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return $004f932055a77f96$var$getYearData(staticPlayerData, years);
    }, [
        staticPlayerData,
        years
    ]);
    var seasonTypes = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return $004f932055a77f96$var$getSeasonTypes(yearData);
    }, [
        yearData
    ]);
    var uniqPitches = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return $004f932055a77f96$var$getPitchTypes(yearData);
    }, [
        yearData
    ]);
    var uniqPlayers = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return $004f932055a77f96$var$getUniquePlayers(yearData, otherPlayerType);
    }, [
        yearData,
        otherPlayerType
    ]);
    var uniqueGames = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return $004f932055a77f96$var$getUniqueGames(yearData);
    }, [
        yearData
    ]);
    // Keep selected players limited to the reasonable set of players
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        if (!uniqPlayers.length) return;
        var newPlayers = facingPlayer.filter(function(id) {
            return uniqPlayers.find(function(d) {
                return d.value === id;
            });
        });
        setFacingPlayer(newPlayers);
    }, [
        uniqPlayers
    ]);
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        // compare selected pitch types to available pitch types
        if (!pitchTypes.length) return;
        var newPitchTypes = pitchTypes.filter(function(d) {
            return uniqPitches.find(function(p) {
                return p.value === d;
            });
        });
        setPitchTypes(newPitchTypes);
    }, [
        uniqPitches
    ]);
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        if (!selectedGames.length) return;
        var newGames = selectedGames.filter(function(gamePk) {
            return uniqueGames.find(function(g) {
                return g.value === gamePk;
            });
        });
        setSelectedGames(newGames);
    }, [
        uniqueGames
    ]);
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        var tempData = staticPlayerData;
        if (chartType === 'pitchChart-paResult') tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.is_lastpitch) === 1;
        });
        if (chartType === 'pitchChart-battedBallType') tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.is_hit_into_play) === 1;
        });
        if (pitcherThrows) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return d.p_throws === pitcherThrows;
        });
        if (batterStands) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return d.stand === batterStands;
        });
        if (plateAppearanceResults && plateAppearanceResults.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(plateAppearanceResults, d.events);
        });
        if (seasonType && seasonType.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(seasonType, d.game_type);
        });
        if (pitchResults && pitchResults.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(pitchResults, d.description);
        });
        if (balls && balls.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(balls, String(d.balls));
        });
        if (strikes && strikes.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(strikes, String(d.strikes));
        });
        if (battedBallType && battedBallType.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(battedBallType, String(d.bb_type));
        });
        if (years && years.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(years, Number(d.game_year));
        });
        if (outs && outs.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(outs, String(d.outs_when_up));
        });
        if (selectedGames && selectedGames.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(selectedGames, d.game_pk);
        });
        if (pitchTypes && pitchTypes.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(pitchTypes, d.pitch_type);
        });
        if (homeTeam && homeTeam.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return homeTeam === null || homeTeam === void 0 ? void 0 : homeTeam.includes(d.home_team_id);
        });
        if (vsTeam && vsTeam.length > 0) {
            if (otherPlayerType === 'pitcher') tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
                return vsTeam === null || vsTeam === void 0 ? void 0 : vsTeam.includes(d.fielding_team_id);
            });
            else tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
                return vsTeam === null || vsTeam === void 0 ? void 0 : vsTeam.includes(d.batting_team_id);
            });
        }
        if (awayTeam && awayTeam.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return awayTeam === null || awayTeam === void 0 ? void 0 : awayTeam.includes(d.away_team_id);
        });
        if (facingPlayer && facingPlayer.length > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return (0, $004f932055a77f96$var$_includes["default"])(facingPlayer, d[otherPlayerType]);
        });
        if (gameDateGT) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return d.game_date >= gameDateGT.dateStr;
        });
        if (gameDateLT) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return d.game_date <= gameDateLT.dateStr;
        });
        if (exitVelocityGT && exitVelocityGT > 0) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.launch_speed) >= Number(exitVelocityGT) && Number(d.launch_speed) > 0 && Number(d.launch_speed) !== 0;
        });
        if (exitVelocityLT && exitVelocityLT <= 124) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.launch_speed) <= Number(exitVelocityLT) && Number(d.launch_speed) > 0 && Number(d.launch_speed) !== 0;
        });
        if (launchAngleGT && launchAngleGT > -90) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.launch_angle) >= Number(launchAngleGT) && Number(d.launch_angle) > -90 && Number(d.launch_angle) !== 0;
        });
        if (launchAngleLT && launchAngleLT < 90) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.launch_angle) <= Number(launchAngleLT) && Number(d.launch_angle) > -90 && Number(d.launch_angle) !== 0;
        });
        if (pitchVelocityGT) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.release_speed) >= Number(pitchVelocityGT) && Number(d.release_speed) > 0;
        });
        if (pitchVelocityLT && pitchVelocityLT < 105) tempData = (0, $004f932055a77f96$var$_filter["default"])(tempData, function(d) {
            return Number(d.release_speed) <= Number(pitchVelocityLT) && Number(d.release_speed) > 0;
        });
        if (previousDataState && !(0, $004f932055a77f96$var$_isEqual["default"])(previousDataState, tempData)) {
            setPlayerData(tempData);
            var schema = (0, $004f932055a77f96$var$_Schema["default"])(tempData, player, getSchemaOptions(false));
            var modelData = (0, $004f932055a77f96$var$_SavantModel["default"])(schema, tempData);
            var tempStats = (0, $004f932055a77f96$var$_RunCalculations["default"])(modelData);
            setPlayerStats(tempStats);
        }
    });
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        function handleResize() {
            setPageWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
    });
    var debouncedPopulateUrl = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return (0, $004f932055a77f96$var$_debounce["default"])(function() {
            return populateUrl();
        }, 1000);
    }, [
        tabSelection,
        shape,
        shapeName,
        subTitle,
        chartType,
        chartName,
        pitcherThrows,
        batterStands,
        plateAppearanceResults,
        pitchTypes,
        seasonType,
        pitchResults,
        facingPlayer,
        balls,
        battedBallType,
        years,
        strikes,
        outs,
        selectedGames,
        homeTeam,
        awayTeam,
        vsTeam,
        exitVelocityGT,
        exitVelocityLT,
        pitchVelocityGT,
        pitchVelocityLT,
        launchAngleGT,
        launchAngleLT,
        perspective,
        venueId,
        playerInfo,
        gameDateGT,
        gameDateLT,
        normalize
    ]);
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        if (updateId > 0) debouncedPopulateUrl();
        return function() {
            debouncedPopulateUrl.cancel();
        };
    }, [
        updateId,
        debouncedPopulateUrl
    ]);
    var handleChange = function handleChange(event) {
        setInputValue(event.target.value);
    };
    var handleNormalizeChange = function handleNormalizeChange(e) {
        setNormalize(e.target.value);
        setUpdateId(updateId + 1);
    };
    var tabChanged = function tabChanged(event, newValue) {
        setTabSelection(newValue);
        setUpdateId(updateId + 1);
    };
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        if (playerInfo) loadPlayerData(); // This is be executed when `loading` state changes
    }, [
        playerInfo
    ]);
    function getPlayerType(isPitcher) {
        var findPlayerType = isPitcher ? 'pitcher' : 'batter';
        if (findPlayerType === 'pitcher') setOtherPlayerType('batter');
        else setOtherPlayerType('pitcher');
        setUpdateId(updateId + 1);
        return findPlayerType;
    }
    var smartSetSeasonTypes = function smartSetSeasonTypes(data, newYears, currentSeasonTypes) {
        var isSpringOnly = currentSeasonTypes.length === 1 && currentSeasonTypes[0] === 'S' && seasonTypes.length === 1;
        var newYearData = $004f932055a77f96$var$getYearData(data, newYears);
        var newSeasonTypes = $004f932055a77f96$var$getSeasonTypes(newYearData).map(function(n) {
            return n.value;
        });
        var hasRegularNext = newSeasonTypes.find(function(d) {
            return d === 'R';
        });
        // The step from 2026 (Spring Only) -> 2025 + 2026 (Spring Only) feels hostile
        // So we'll take that special case and add regular season to the options.
        var initialSeasonTypes = isSpringOnly && hasRegularNext ? [
            'S',
            'R'
        ] : currentSeasonTypes;
        // Make sure the selected seasonTypes exist in the current data set
        var nextSeasonTypes = initialSeasonTypes.filter(function(d) {
            return newSeasonTypes.includes(d);
        });
        if (!nextSeasonTypes.length) {
            // Set a new season type if none of current selection season types exist in the new data set
            if (newSeasonTypes.find(function(d) {
                return d === 'R';
            })) setSeasonType([
                'R'
            ]);
            else {
                var defaultSeason = newSeasonTypes[0];
                setSeasonType([
                    defaultSeason
                ]);
            }
        } else setSeasonType(nextSeasonTypes);
    };
    function loadPlayerData() {
        var loadYear = $004f932055a77f96$var$currentYear;
        var hasFoundYear = false;
        var incrementalYears = [];
        var queryData = [];
        // Function to laod data back to 2015
        function loadData(callback) {
            var pType = playerInfo.playerType;
            if (pType === 'pitcher') setOtherPlayerType('batter');
            else setOtherPlayerType('pitcher');
            setPlayer({
                playerType: pType,
                playerId: playerInfo.playerId,
                playerName: playerInfo.name
            });
            var todaysMonth = new Date().getMonth();
            // Until May 1
            var includeSpring = loadYear === $004f932055a77f96$var$currentYear && todaysMonth < 4;
            var gameTypes = includeSpring ? "S|R|PO|" : "R|PO|";
            (0, $klIz4.csv)("/feed?evp=true&csv=true&hfPT=&hfAB=&hfBBT=&hfPR=&hfZ=&stadium=&hfBBL=&hfNewZones=&hfGT=".concat(gameTypes, "&hfC=&hfSea=").concat(loadYear, "%7C&hfSit=&player_type=").concat(pType, "&hfOuts=&opponent=&pitcher_throws=&batter_stands=&hfSA=&game_date_gt=&game_date_lt=&hfInfield=&team=&position=&hfOutfield=&hfRO=&home_road=&").concat(pType, "s_lookup[]=").concat(playerInfo.playerId, "&hfFlag=&hfPull=&metric_1=&hfInn=&min_pitches=0&min_results=0&group_by=name&sort_col=pitches&player_event_sort=h_launch_speed&sort_order=desc&min_pas=0&type=details&player_id=").concat(playerInfo.playerId, "&minors=").concat(isMinors ? 'true' : '')).then(function(responseData) {
                if (responseData.length > 0) {
                    if (!hasFoundYear && !queryString.years) {
                        setYears([
                            loadYear
                        ]);
                        setUpdateId(updateId + 1);
                        hasFoundYear = true;
                    }
                    incrementalYears.push(loadYear);
                    setUniqYears(incrementalYears);
                    // Try to smartly set season types on initial load
                    if (!queryData.length && !queryString.seasonType) smartSetSeasonTypes(responseData, [], []);
                    queryData = queryData.concat(responseData);
                    queryData = (0, $004f932055a77f96$var$_sortBy["default"])(queryData, function(d) {
                        var gd = d.game_date.split('-').join('');
                        var sortNumber = Number("".concat(gd).concat(String(d.inning).padStart(2, '0')).concat(String(d.at_bat_number).padStart(3, '0')).concat(String(d.pitch_number).padStart(3, '0')));
                        return sortNumber;
                    });
                    setStaticPlayerData(queryData);
                    setPlayerData(queryData);
                    // const tempStats = runCalculations(queryData);
                    var schema = (0, $004f932055a77f96$var$_Schema["default"])(queryData, player, getSchemaOptions(false));
                    var modelData = (0, $004f932055a77f96$var$_SavantModel["default"])(schema, queryData);
                    var tempStats = (0, $004f932055a77f96$var$_RunCalculations["default"])(modelData);
                    setPlayerStats(tempStats);
                    setIsDataLoading(false);
                    setIsYearlyDataLoading(true);
                }
                loadYear -= 1;
                callback(null);
            });
        }
        setIsDataLoading(true);
        checkForHittingAndPitchingStats(playerInfo);
        var funcs = [];
        for(var i = $004f932055a77f96$var$currentYear; i > $004f932055a77f96$var$yearMin; i--)funcs.push(loadData);
        $004f932055a77f96$var$_async["default"].waterfall(funcs, function(err) {
            setIsYearlyDataLoading(false);
            if (err) setPlayerInfo([]);
        });
    }
    // if queryString playerId is set autoload data
    if (queryString.playerId && !pageLoad) {
        setPlayerInfo({
            playerId: queryString.playerId,
            name: queryString.name,
            playerType: queryString.playerType
        });
        setUpdateId(updateId + 1);
        setPageLoad(true);
    }
    // eslint-disable-next-line no-shadow
    function checkForHittingAndPitchingStats(playerInfo) {
        /// Does the player have both hitting & pitching stats
        fetch("/illustrator/stats?playerId=".concat(playerInfo.playerId)).then(function(response) {
            if (!response.ok) return {
                error: 'No data'
            };
            return response.json();
        }).then(function(data) {
            if (data && data.stats) {
                if ((0, $004f932055a77f96$var$_find["default"])(data.stats, function(d) {
                    return d.group.displayName === 'pitching';
                }) && (0, $004f932055a77f96$var$_find["default"])(data.stats, function(d) {
                    return d.group.displayName === 'hitting';
                })) setTogglePlayerStats(true);
            }
        });
    }
    var queryUrl = (0, $004f932055a77f96$var$_react.useMemo)(function() {
        return (0, $004f932055a77f96$var$_throttle["default"])(function(request, callback) {
            if (request && request.input) {
                if (request.input.length >= 3) fetch("/player/search-statcast?search=".concat(request.input, "&minors=").concat(isMinors ? 'true' : '')).then(function(response) {
                    if (!response.ok) return {
                        error: 'No data'
                    };
                    return response.json();
                }).then(function(data) {
                    callback(data);
                });
            }
        }, 200);
    }, []);
    (0, $004f932055a77f96$var$_react.useEffect)(function() {
        var active = true;
        if (inputValue === '') {
            setOptions(trendingPlayers);
            return undefined;
        }
        queryUrl({
            input: inputValue
        }, function(results) {
            if (active) setOptions(results || []);
        });
        return function() {
            active = false;
        };
    }, [
        inputValue,
        queryUrl
    ]);
    function getSchemaOptions(embed) {
        return {
            selectedChart: chartType,
            yearText: years.join(','),
            subTitle: subTitle,
            shape: shape,
            embed: embed,
            chartName: chartName,
            venueId: venueId,
            pageWidth: pageWidth,
            perspective: perspective,
            normalize: normalize,
            teamLogoId: isMinors ? 'milb' : 'primary'
        };
    }
    var showPerspectiveSelect = chartType.includes('zoneChart') || chartType.includes('pitchChart') || chartType.includes('hexBinChart') || chartType === 'pitchContourChart' || chartType === 'pitchPie';
    var personalized = (0, $004f932055a77f96$var$_canBePersonalized["default"])(playerData || []);
    var showScaleSelect = (chartType.includes('pitchChart') || chartType.includes('hexBinChart') || chartType === 'pitchContourChart' || chartType === 'pitchPie') && !personalized;
    var handleYearChange = function handleYearChange(newYears) {
        setYears(newYears);
        setUpdateId(updateId + 1);
        smartSetSeasonTypes(staticPlayerData, newYears, seasonType);
    };
    return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($98N7C.default, {
        generateClassName: $004f932055a77f96$var$generateClassName
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "evp-form"
    }, playerData ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("img", {
        src: "/sections/evp/images/logo.png",
        className: "illustrator-logo",
        alt: "Illustrator Logo"
    }) : null, playerData && isMinors ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            marginBottom: '1rem'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("img", {
        src: "https://www.mlbstatic.com/team-logos/league-on-light/milb-alt.svg",
        width: "50",
        alt: "Minor League Logo"
    }), ' ', "Minor Leagues") : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            marginBottom: '1rem'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Autocomplete["default"], {
        id: "search-complete",
        defaultValue: queryString.name || null,
        style: {
            width: '100%'
        },
        classes: {
            root: autoCompleteStyles.root,
            // class name, e.g. `classes-nesting-root-x`
            inputRoot: autoCompleteStyles.inputRoot,
            input: autoCompleteStyles.input
        },
        onChange: function onChange(event, value) {
            setPlayerData(null);
            if (value) {
                if (value.player_id) {
                    // Remove trending players after selection
                    setOptions([]);
                    setPlayerInfo({
                        playerId: value.player_id,
                        name: value.name_display_first_last,
                        playerType: getPlayerType(value.is_pitcher)
                    });
                    setUpdateId(updateId + 1);
                }
            } else {
                var element = document.getElementById('evp');
                element.parentNode.removeChild(element);
                // TODO: Remove this hack
                var url = isMinors ? '/illustrator-minors' : '/illustrator';
                window.location = url;
            }
        },
        freeSolo: true,
        filterOptions: function filterOptions(x) {
            return x;
        },
        options: options,
        autoComplete: true,
        getOptionLabel: function getOptionLabel(option) {
            if (typeof option !== 'string') {
                if (!option.id) return '';
                return option.name_display_first_last;
            }
            return option;
        },
        autoHighlight: true,
        clearOnEscape: true,
        includeInputInList: true,
        blurOnSelect: "touch",
        renderInput: function renderInput(params) {
            // eslint-disable-next-line no-param-reassign
            params.InputProps.classes = {
                root: autoCompleteStyles.cssOutlinedInput,
                focused: autoCompleteStyles.cssFocused,
                notchedOutline: autoCompleteStyles.notchedOutline
            };
            return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_TextField["default"], $004f932055a77f96$var$_extends({}, params, {
                InputLabelProps: {
                    classes: {
                        root: autoCompleteStyles.label,
                        focused: autoCompleteStyles.focus,
                        shrink: autoCompleteStyles.focus
                    }
                },
                label: "Enter Player Name",
                variant: "outlined",
                fullWidth: true,
                onChange: handleChange
            }));
        },
        renderOption: function renderOption(option) {
            if (!option.player_id) return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
                className: "trending-player-text"
            }, "Trending Players");
            var imageUrl = isMinors ? "https://midfield.mlbstatic.com/v1/people/".concat(option.player_id, "/milb/60?circle=true") : "https://content.mlb.com/images/headshots/current/60x60/".concat(option.player_id, ".png");
            return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Grid["default"], {
                container: true,
                alignItems: "center"
            }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Grid["default"], {
                item: true
            }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("img", {
                style: {
                    width: '40px',
                    height: '40px'
                },
                src: imageUrl,
                onError: function onError(e) {
                    // eslint-disable-next-line no-param-reassign
                    e.target.onerror = null;
                    // eslint-disable-next-line no-param-reassign
                    e.target.src = 'https://content.mlb.com/images/headshots/current/60x60/generic.png';
                },
                alt: "".concat(option.name_display_first_last, " Headshot")
            }), "\xA0"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Grid["default"], {
                item: true
            }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
                variant: "body2",
                color: "textSecondary"
            }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("b", null, option.name_display_first_last))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Grid["default"], {
                item: true
            }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
                variant: "body2",
                color: "textSecondary"
            }, ' ', ' - ', option.is_pitcher ? ' Pitcher' : ' Batter')));
        }
    }), !playerData && !isDataLoading ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("svg", {
        width: "320",
        height: "150"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("marker", {
        id: "arrow",
        viewBox: "0,0,5,5",
        refX: "2.5",
        refY: "2.5",
        markerWidth: "5",
        markerHeight: "5",
        orient: "auto-start-reverse"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("path", {
        d: "M0,0L0,5L5,2.5",
        stroke: "tomato",
        fill: "tomato"
    }))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("path", {
        id: "pointer",
        d: "M100,10L105,28.333333333333332C110,46.666666666666664,120,83.33333333333333,156.66666666666666,101.66666666666667C193.33333333333334,120,256.6666666666667,120,288.3333333333333,120L320,120",
        fill: "none",
        stroke: "#ef4c29",
        strokeWidth: "2",
        markerStart: "url(#arrow)"
    }), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("text", {
        dy: "-5",
        fill: "#3a9098",
        className: "start-here-pointer-text"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("textPath", {
        xlinkHref: "#pointer",
        startOffset: "50%",
        y: "10",
        style: {
            textAnchor: 'middle'
        }
    }, "Start Here"))) : null, playerData ? /*#__PURE__*/ // eslint-disable-next-line react/button-has-type
    $004f932055a77f96$var$_react["default"].createElement("button", {
        className: "mobile-toggle btn btn-default",
        onClick: function onClick() {
            setTweakVisual(!tweakVisual);
        }
    }, tweakVisual ? "Close Edits" : "Edit Visual") : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "controls-container"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "controls",
        style: {
            display: tweakVisual || pageWidth >= 1080 ? 'block' : 'none'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            paddingTop: '1rem',
            paddingBottom: '1rem'
        }
    }, playerData ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_react["default"].Fragment, null, togglePlayerStats ? /*#__PURE__*/ // eslint-disable-next-line react/button-has-type
    $004f932055a77f96$var$_react["default"].createElement("button", {
        className: "btn btn-default",
        style: {
            width: '100%'
        },
        onClick: function onClick() {
            var playerType = playerInfo.playerType === 'batter' ? 'pitcher' : 'batter';
            var url = $004f932055a77f96$var$populateClearedUrl(playerInfo, playerType);
            window.location = "/illustrator".concat(url);
        }
    }, "Switch to", ' ', playerInfo.playerType === 'batter' ? 'Pitching' : 'Batting', ' ', "Visuals") : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            paddingTop: '1rem'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblChartType",
        className: "ddl-label"
    }, "Chart: ", chartName), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: chartType,
        onChange: function onChange(event) {
            var newChartType = event.target.value;
            var index = event.target.selectedIndex;
            // Check if switching to 3D and current venue doesn't support 3D
            if (newChartType.startsWith('3d-')) {
                var currentVenue = [].concat($004f932055a77f96$var$_toConsumableArray($004f932055a77f96$var$standardVenues), $004f932055a77f96$var$_toConsumableArray($004f932055a77f96$var$extraVenues)).find(function(v) {
                    return v.value === Number(venueId);
                });
                if (currentVenue !== null && currentVenue !== void 0 && currentVenue.no3d) {
                    setVenueId($004f932055a77f96$var$KAUFFMAN_ID);
                    setVenueName($004f932055a77f96$var$theK.name);
                }
            }
            setChartType(newChartType);
            setChartName(event.target[index].text);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Zone Chart"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-totalPitches"
    }, "Zone - Total Pitches"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-percent"
    }, "Zone - Pitch Percent"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-ba"
    }, "Zone - Batting Avg"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-woba"
    }, "Zone - wOBA"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-avgExitVelocity"
    }, "Zone - Exit Velocity"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-avgLaunchAngle"
    }, "Zone - Launch Angle"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-batSpeedCompetitive"
    }, "Zone - Bat Speed"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-swingLengthCompetitive"
    }, "Zone - Swing Length"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-kPercent"
    }, "Zone - K Percent"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-runExp"
    }, "Zone - Batter Run Value"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "zoneChart-pitcherRunExp"
    }, "Zone - Pitcher Run Value")), playerData && playerData.length < 4000 ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Pitch Charts"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchChart-pitchName"
    }, "Pitch Types"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchChart-pitchResult"
    }, "Pitch Description"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchChart-paResult"
    }, "Pitch Result"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchChart-battedBallType"
    }, "Batted Ball Type"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchChart-isInZone"
    }, "In Zone")) : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchContourChart"
    }, "Pitch Heatmap"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Pitch Hexbin Charts"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-totalPitches"
    }, "Total Pitches"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-ba"
    }, "Batting Avg"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-woba"
    }, "wOBA"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-avgExitVelocity"
    }, "Exit Velocity"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-avgLaunchAngle"
    }, "Launch Angle"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "hexBinChart-kPercent"
    }, "K Percent")), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitchPie"
    }, "Pitch Pie Chart"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Pitch Count Breakdowns"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "network-pie"
    }, "Pie Charts"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "network-circlePack"
    }, "Circles")), playerData && playerData.length < 4000 ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_react["default"].Fragment, null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "release"
    }, "Release Point"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "movement"
    }, "Pitch Movement"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Line Chart"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "lineGraphChart-pitchVelocity"
    }, "Pitch Velocity"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "lineGraphChart-spinRate"
    }, "Spin Rate"))) : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "radial"
    }, "Radial"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayChart"
    }, "Spray Chart"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayContourChart"
    }, "Spray Heatmap"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Spray Hexbin Charts"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayHexBinChart-totalPitches"
    }, "Total Batted Balls"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayHexBinChart-ba"
    }, "Batting Avg"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayHexBinChart-woba"
    }, "wOBA"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayHexBinChart-avgExitVelocity"
    }, "Exit Velocity"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "sprayHexBinChart-avgLaunchAngle"
    }, "Launch Angle")), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "3d Spray Chart"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "3d-birdsEye"
    }, "3D Spray - Birds Eye"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "3d-cf"
    }, "3D Spray - CF View"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "3d-default"
    }, "3D Spray - High Home"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "3d-homeLow"
    }, "3D Spray - Low Home"))))), uniqYears ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Year",
        columns: uniqYears,
        currentSelection: years,
        zIndex: 1010,
        showValues: true,
        updatedSelection: handleYearChange
    }), isYearlyDataLoading ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "loading-data"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("img", {
        src: "/site-core/images/spinner.gif",
        alt: "loading"
    }), ' ', "Previous Years Data Still Loading in the Background") : null) : null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("input", {
        type: "text",
        placeholder: "Enter Subtitle..",
        className: "text-box",
        value: subTitle,
        onChange: function onChange(event) {
            setSubTitle(event.target.value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblChartSize",
        className: "ddl-label",
        style: {
            fontSize: '.8rem'
        }
    }, "Size: ", shapeName), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: shape,
        onChange: function onChange(event) {
            setShape(event.target.value);
            var index = event.target.selectedIndex;
            setShapeName(event.target[index].text);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "square"
    }, "Square (Instagram)"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "twitter"
    }, "Rectangle (Twitter)"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "snap"
    }, "Portrait (Snapchat/Instastory)"))), chartType.indexOf('spray') > -1 || chartType.indexOf('3d') > -1 ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblVenue",
        className: "ddl-label",
        style: {
            fontSize: '.9rem',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }
    }, "Venue:", ' ', venueName), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: venueId,
        onChange: function onChange(event) {
            setVenueId(event.target.value);
            var index = event.target.selectedIndex;
            setVenueName(event.target[index].text);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Current MLB"
    }, $004f932055a77f96$var$standardVenues.map(function(venue) {
        return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
            key: venue.value,
            value: venue.value
        }, venue.name);
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("optgroup", {
        label: "Others"
    }, $004f932055a77f96$var$extraVenues.map(function(venue) {
        return /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
            disabled: is3d && venue.no3d,
            key: venue.value,
            value: venue.value
        }, venue.name);
    }))))) : null), showPerspectiveSelect && /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblChartPerspective",
        className: "ddl-label",
        style: {
            fontSize: '.8rem'
        }
    }, "View: ", perspective, ' ', "Perspective"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: perspective,
        onChange: function onChange(e) {
            setPerspective(e.target.value);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "pitcher"
    }, "Pitcher Perspective"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "catcher"
    }, "Catcher Perspective")))), showScaleSelect && /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_FormOption["default"], {
        title: "Scale",
        options: $kylyz.scaleOptions,
        value: normalize,
        onChange: handleNormalizeChange
    }), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("button", {
        style: {
            width: '32%'
        },
        className: "btn btn-default btn-search-green",
        onClick: function onClick() {
            setSaveImageText('Saving Image...');
            setIsSavingImage(true);
            (0, $004f932055a77f96$var$_index["default"])({
                data: playerData,
                player: player,
                options: getSchemaOptions(false)
            }, function(err) {
                setIsSavingImage(false);
                setSaveImageText('Save Image');
                if (err) console.error(err);
                else {
                    setIsSavingImage(false);
                    setSaveImageText('Save Image');
                }
            });
        }
    }, saveImageText), ' ', /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("button", {
        style: {
            width: '32%'
        },
        className: "btn btn-default btn-search-green",
        onClick: function onClick() {
            setIsSavingImage(true);
            setEmbedImageText('Generating Link...');
            (0, $004f932055a77f96$var$_index["default"])({
                data: playerData,
                player: player,
                options: getSchemaOptions(true)
            }, function(err, res) {
                setIsSavingImage(false);
                setSaveImageText('Save Image');
                if (res && res.link) {
                    setEmbedLink("<iframe src=\"https://baseballsavant.mlb.com/illustrator/static?guid=".concat(res.link, "&scale=true\"></iframe>"));
                    setModalOpen(true);
                } else if (err) console.error(res.err);
                setEmbedImageText('Embed Image');
            });
        }
    }, embedImageText), ' ', /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("button", {
        className: "btn btn-default",
        style: {
            backgroundColor: '#f5f5f5',
            color: '#000',
            width: '31%'
        },
        onClick: function onClick() {
            resetStateFormValues();
            setUpdateId(updateId + 1);
        }
    }, "Clear Form"))) : null), isDataLoading ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            textAlign: 'center',
            paddingTop: '1rem'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("h6", null, "Visualizing Data... Please Wait."), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_CircularProgress["default"], null)) : null, playerData ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_react["default"].Fragment, null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_AppBar["default"], {
        position: "static",
        color: "default"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Tabs["default"], {
        value: tabSelection,
        onChange: tabChanged,
        indicatorColor: "primary",
        textColor: "primary",
        scrollButtons: "off",
        "aria-label": "Selection Tabs"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Tab["default"], $004f932055a77f96$var$_extends({
        disabled: !playerData,
        style: {
            minWidth: '70px'
        },
        classes: {
            root: classes.tabRoot
        },
        label: "Play"
    }, $004f932055a77f96$var$a11yProps(0))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Tab["default"], $004f932055a77f96$var$_extends({
        disabled: !playerData,
        style: {
            minWidth: '70px'
        },
        classes: {
            root: classes.tabRoot
        },
        label: "Game"
    }, $004f932055a77f96$var$a11yProps(1))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Tab["default"], $004f932055a77f96$var$_extends({
        disabled: !playerData,
        style: {
            minWidth: '70px'
        },
        classes: {
            root: classes.tabRoot
        },
        label: "Teams"
    }, $004f932055a77f96$var$a11yProps(2))))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$TabPanel, {
        value: tabSelection,
        index: 0
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblPitcherThrows",
        className: "ddl-label"
    }, "Pitcher Throws:", ' ', pitcherThrows || 'All'), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: pitcherThrows,
        onChange: function onChange(event) {
            setPitcherThrows(event.target.value);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: ""
    }, "All"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "R"
    }, "Right"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "L"
    }, "Left")))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("span", {
        id: "lblBatterStands",
        className: "ddl-label"
    }, "Batter Stands:", ' ', batterStands || 'All'), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("select", {
        value: batterStands,
        onChange: function onChange(event) {
            setBatterStands(event.target.value);
            setUpdateId(updateId + 1);
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: ""
    }, "All"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "R"
    }, "Right"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("option", {
        value: "L"
    }, "Left")))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Season Type",
        columns: seasonTypes,
        currentSelection: seasonType,
        zIndex: 1008,
        updatedSelection: function updatedSelection(values) {
            setSeasonType(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Plate Appearance",
        columns: $004f932055a77f96$var$_EventTypes["default"].plateAppearanceResults,
        currentSelection: plateAppearanceResults,
        zIndex: 1009,
        updatedSelection: function updatedSelection(values) {
            setPlateAppearanceResults(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Pitch Result",
        columns: $004f932055a77f96$var$_EventTypes["default"].pitchResult,
        currentSelection: pitchResults,
        zIndex: 1010,
        updatedSelection: function updatedSelection(values) {
            setPitchResults(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Pitch Type",
        columns: uniqPitches,
        currentSelection: pitchTypes,
        zIndex: 1008,
        updatedSelection: function updatedSelection(values) {
            setPitchTypes(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Facing Player",
        columns: uniqPlayers,
        currentSelection: facingPlayer,
        zIndex: 1007,
        updatedSelection: function updatedSelection(values) {
            setFacingPlayer(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Pitch Velocity >="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: 0,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        step: 1,
        value: pitchVelocityGT,
        valueLabelDisplay: "auto",
        min: 0,
        max: 105,
        marks: true,
        onChange: function onChange(event, value) {
            setPitchVelocityGT(value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Pitch Velocity <="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: 105,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        step: 1,
        value: pitchVelocityLT,
        valueLabelDisplay: "auto",
        min: 0,
        max: 105,
        marks: true,
        onChange: function onChange(event, value) {
            setPitchVelocityLT(value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Exit Velocity >="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: 0,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        value: exitVelocityGT,
        step: 1,
        valueLabelDisplay: "auto",
        min: 0,
        max: 125,
        marks: true,
        onChange: function onChange(event, value) {
            setExitVelocityGT(value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Exit Velocity <="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: 125,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        step: 1,
        value: exitVelocityLT,
        valueLabelDisplay: "auto",
        min: 0,
        max: 125,
        marks: true,
        onChange: function onChange(event, value) {
            setExitVelocityLT(value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Launch Angle >="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: -90,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        step: 1,
        value: launchAngleGT,
        valueLabelDisplay: "auto",
        min: -90,
        max: 90,
        marks: true,
        onChange: function onChange(event, value) {
            setLaunchAngleGT(value);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Typography["default"], {
        id: "discrete-slider-restrict",
        gutterBottom: true
    }, "Launch Angle <="), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Slider["default"], {
        defaultValue: 90,
        getAriaValueText: $004f932055a77f96$var$sliderValueText,
        "aria-labelledby": "discrete-slider-restrict",
        step: 1,
        value: launchAngleLT,
        valueLabelDisplay: "auto",
        min: -90,
        max: 90,
        marks: true,
        onChange: function onChange(event, value) {
            setLaunchAngleLT(value);
            setUpdateId(updateId + 1);
        }
    }))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$TabPanel, {
        value: tabSelection,
        index: 1
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Balls",
        columns: [
            '0',
            '1',
            '2',
            '3'
        ],
        currentSelection: balls,
        zIndex: 1011,
        updatedSelection: function updatedSelection(values) {
            setBalls(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Strikes",
        columns: [
            '0',
            '1',
            '2'
        ],
        currentSelection: strikes,
        zIndex: 1010,
        updatedSelection: function updatedSelection(values) {
            setStrikes(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Outs",
        columns: [
            '0',
            '1',
            '2'
        ],
        currentSelection: outs,
        zIndex: 1009,
        updatedSelection: function updatedSelection(values) {
            setOuts(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Batted Ball Type",
        columns: [
            {
                value: 'line_drive',
                name: 'Line Drive'
            },
            {
                value: 'fly_ball',
                name: 'Flyball'
            },
            {
                value: 'ground_ball',
                name: 'Groundball'
            },
            {
                value: 'popup',
                name: 'Popup'
            }
        ],
        currentSelection: battedBallType,
        zIndex: 1007,
        updatedSelection: function updatedSelection(values) {
            setBattedBallType(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Game",
        columns: uniqueGames,
        currentSelection: selectedGames,
        zIndex: 1006,
        updatedSelection: function updatedSelection(values) {
            setSelectedGames(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($gFzGS.M, {
        utils: $004f932055a77f96$var$_dateFns["default"]
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($3OcDw.KeyboardDatePicker, {
        style: {
            width: '100%'
        },
        disableToolbar: true,
        variant: "inline",
        format: "yyyy-MM-dd",
        margin: "normal",
        id: "date-picker-inline",
        label: "Game Date >=",
        value: (gameDateGT === null || gameDateGT === void 0 ? void 0 : gameDateGT.dateObj) || null,
        onChange: function onChange(dateObj, dateStr) {
            setGameDateGT({
                dateObj: dateObj,
                dateStr: dateStr
            });
            setUpdateId(updateId + 1);
        },
        KeyboardButtonProps: {
            'aria-label': 'change date'
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($3OcDw.KeyboardDatePicker, {
        style: {
            width: '100%'
        },
        disableToolbar: true,
        variant: "inline",
        format: "yyyy-MM-dd",
        margin: "normal",
        id: "date-picker-inline",
        label: "Game Date <=",
        value: (gameDateLT === null || gameDateLT === void 0 ? void 0 : gameDateLT.dateObj) || null,
        onChange: function onChange(dateObj, dateStr) {
            setGameDateLT({
                dateObj: dateObj,
                dateStr: dateStr
            });
            setUpdateId(updateId + 1);
        },
        KeyboardButtonProps: {
            'aria-label': 'change date'
        }
    })))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$TabPanel, {
        value: tabSelection,
        index: 2
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Vs. Team",
        columns: $004f932055a77f96$var$_Teams["default"].teamsById,
        currentSelection: vsTeam,
        zIndex: 1010,
        updatedSelection: function updatedSelection(values) {
            setVsTeam(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Home Team",
        columns: $004f932055a77f96$var$_Teams["default"].teamsById,
        currentSelection: homeTeam,
        zIndex: 1010,
        updatedSelection: function updatedSelection(values) {
            setHomeTeam(values);
            setUpdateId(updateId + 1);
        }
    })), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_MultiPick["default"], {
        name: "Away Team",
        columns: $004f932055a77f96$var$_Teams["default"].teamsById,
        currentSelection: awayTeam,
        zIndex: 1010,
        updatedSelection: function updatedSelection(values) {
            setAwayTeam(values);
            setUpdateId(updateId + 1);
        }
    })))) : null)))), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "chart-container",
        style: {
            position: 'relative'
        }
    }, playerData && !isDataLoading ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            position: 'sticky',
            top: 0
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_App["default"], {
        data: playerData,
        player: player,
        options: getSchemaOptions(false)
    }), playerStats && /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_PlayerStats["default"], {
        stats: playerStats
    })) : /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        className: "content-text"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("img", {
        src: "/sections/evp/images/logo.png",
        className: "illustrator-logo",
        alt: "illustrator Logo"
    }), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), "Welcome to ", /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("strong", null, "Savant Illustrator"), ", our new visualization tool designed to illuminate all the inherent nuances and figures that we believe make baseball special. To get started, just...", /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("ol", {
        style: {
            lineHeight: '2rem'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("li", null, "Enter a player's name in the search box or select trending player"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("li", null, "Choose one of our 30+ Chart Types"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("li", null, "Customize using our data settings"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("li", null, "Save it to share on social media or get an embed link")))), isSavingImage ? /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Dialog["default"], {
        open: isSavingImage,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogContent["default"], null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogContentText["default"], {
        id: "alert-dialog-description"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            fontFamily: 'Roboto Condensed',
            fontSize: '1.2rem',
            textAlign: 'center'
        }
    }, "Saving Image... Please Wait"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("div", {
        style: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_CircularProgress["default"], null))))) : null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Dialog["default"], {
        open: modalOpen,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogTitle["default"], {
        id: "alert-dialog-title"
    }, "Embeddable Link"), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogContent["default"], null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogContentText["default"], {
        id: "alert-dialog-description"
    }, "Copy the link below to use current visual:", /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement("br", null), embedLink)), /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_DialogActions["default"], null, /*#__PURE__*/ $004f932055a77f96$var$_react["default"].createElement($004f932055a77f96$var$_Button["default"], {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
            setModalOpen(false);
        }
    }, "Close"))));
}
var $004f932055a77f96$var$_default = module.exports["default"] = $004f932055a77f96$var$Data;

});
parcelRegister("klIz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed08566dc969f0a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "csv", () => $ed08566dc969f0a8$export$901ba78aa04f49da);
$parcel$export(module.exports, "tsv", () => $ed08566dc969f0a8$export$580b2de76423ff18);

var $aGeJV = parcelRequire("aGeJV");
var $jDNx7 = parcelRequire("jDNx7");
var $lShYg = parcelRequire("lShYg");

var $2I6Ok = parcelRequire("2I6Ok");
function $ed08566dc969f0a8$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $2I6Ok.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $ed08566dc969f0a8$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $jDNx7.default)(delimiter);
    return (0, $2I6Ok.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $ed08566dc969f0a8$export$901ba78aa04f49da = $ed08566dc969f0a8$var$dsvParse((0, $aGeJV.csvParse));
var $ed08566dc969f0a8$export$580b2de76423ff18 = $ed08566dc969f0a8$var$dsvParse((0, $lShYg.tsvParse));

});
parcelRegister("aGeJV", function(module, exports) {

$parcel$export(module.exports, "csvParse", () => $7c69429df3ecd000$export$289d25497b0f4c16);
$parcel$export(module.exports, "csvParseRows", () => $7c69429df3ecd000$export$c82550ca942d869);
$parcel$export(module.exports, "csvFormat", () => $7c69429df3ecd000$export$afe767551074aa08);
$parcel$export(module.exports, "csvFormatBody", () => $7c69429df3ecd000$export$b46fa59a5e3bc8a2);
$parcel$export(module.exports, "csvFormatRows", () => $7c69429df3ecd000$export$3f42a65843fbd1d9);
$parcel$export(module.exports, "csvFormatRow", () => $7c69429df3ecd000$export$c30212b87b2d080f);
$parcel$export(module.exports, "csvFormatValue", () => $7c69429df3ecd000$export$2771de09a60fc648);

var $jDNx7 = parcelRequire("jDNx7");
var $7c69429df3ecd000$var$csv = (0, $jDNx7.default)(",");
var $7c69429df3ecd000$export$289d25497b0f4c16 = $7c69429df3ecd000$var$csv.parse;
var $7c69429df3ecd000$export$c82550ca942d869 = $7c69429df3ecd000$var$csv.parseRows;
var $7c69429df3ecd000$export$afe767551074aa08 = $7c69429df3ecd000$var$csv.format;
var $7c69429df3ecd000$export$b46fa59a5e3bc8a2 = $7c69429df3ecd000$var$csv.formatBody;
var $7c69429df3ecd000$export$3f42a65843fbd1d9 = $7c69429df3ecd000$var$csv.formatRows;
var $7c69429df3ecd000$export$c30212b87b2d080f = $7c69429df3ecd000$var$csv.formatRow;
var $7c69429df3ecd000$export$2771de09a60fc648 = $7c69429df3ecd000$var$csv.formatValue;

});
parcelRegister("jDNx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c8151b2e3e6f2f$export$2e2bcd8739ae039);
var $e4c8151b2e3e6f2f$var$EOL = {}, $e4c8151b2e3e6f2f$var$EOF = {}, $e4c8151b2e3e6f2f$var$QUOTE = 34, $e4c8151b2e3e6f2f$var$NEWLINE = 10, $e4c8151b2e3e6f2f$var$RETURN = 13;
function $e4c8151b2e3e6f2f$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function $e4c8151b2e3e6f2f$var$customConverter(columns, f) {
    var object = $e4c8151b2e3e6f2f$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $e4c8151b2e3e6f2f$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $e4c8151b2e3e6f2f$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $e4c8151b2e3e6f2f$var$formatYear(year) {
    return year < 0 ? "-" + $e4c8151b2e3e6f2f$var$pad(-year, 6) : year > 9999 ? "+" + $e4c8151b2e3e6f2f$var$pad(year, 6) : $e4c8151b2e3e6f2f$var$pad(year, 4);
}
function $e4c8151b2e3e6f2f$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $e4c8151b2e3e6f2f$var$formatYear(date.getUTCFullYear(), 4) + "-" + $e4c8151b2e3e6f2f$var$pad(date.getUTCMonth() + 1, 2) + "-" + $e4c8151b2e3e6f2f$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(seconds, 2) + "." + $e4c8151b2e3e6f2f$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + "Z" : "");
}
function $e4c8151b2e3e6f2f$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $e4c8151b2e3e6f2f$var$customConverter(row, f) : $e4c8151b2e3e6f2f$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $e4c8151b2e3e6f2f$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $e4c8151b2e3e6f2f$var$RETURN) --N;
        function token() {
            if (eof) return $e4c8151b2e3e6f2f$var$EOF;
            if (eol) return eol = false, $e4c8151b2e3e6f2f$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $e4c8151b2e3e6f2f$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $e4c8151b2e3e6f2f$var$QUOTE || text.charCodeAt(++I) === $e4c8151b2e3e6f2f$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $e4c8151b2e3e6f2f$var$NEWLINE) eol = true;
                else if (c === $e4c8151b2e3e6f2f$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e4c8151b2e3e6f2f$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $e4c8151b2e3e6f2f$var$NEWLINE) eol = true;
                else if (c === $e4c8151b2e3e6f2f$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e4c8151b2e3e6f2f$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $e4c8151b2e3e6f2f$var$EOF){
            var row = [];
            while(t !== $e4c8151b2e3e6f2f$var$EOL && t !== $e4c8151b2e3e6f2f$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $e4c8151b2e3e6f2f$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $e4c8151b2e3e6f2f$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $e4c8151b2e3e6f2f$var$formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});


parcelRegister("lShYg", function(module, exports) {

$parcel$export(module.exports, "tsvParse", () => $fecc94c7e75a3a08$export$f913251db2f734ee);
$parcel$export(module.exports, "tsvParseRows", () => $fecc94c7e75a3a08$export$8de3b5abc40a067f);
$parcel$export(module.exports, "tsvFormat", () => $fecc94c7e75a3a08$export$77e754c4f8504293);
$parcel$export(module.exports, "tsvFormatBody", () => $fecc94c7e75a3a08$export$9d44987d460c9cb3);
$parcel$export(module.exports, "tsvFormatRows", () => $fecc94c7e75a3a08$export$ae461973f6adc981);
$parcel$export(module.exports, "tsvFormatRow", () => $fecc94c7e75a3a08$export$5d61cf35a4a738d2);
$parcel$export(module.exports, "tsvFormatValue", () => $fecc94c7e75a3a08$export$4280e6a416cd92a3);

var $jDNx7 = parcelRequire("jDNx7");
var $fecc94c7e75a3a08$var$tsv = (0, $jDNx7.default)("\t");
var $fecc94c7e75a3a08$export$f913251db2f734ee = $fecc94c7e75a3a08$var$tsv.parse;
var $fecc94c7e75a3a08$export$8de3b5abc40a067f = $fecc94c7e75a3a08$var$tsv.parseRows;
var $fecc94c7e75a3a08$export$77e754c4f8504293 = $fecc94c7e75a3a08$var$tsv.format;
var $fecc94c7e75a3a08$export$9d44987d460c9cb3 = $fecc94c7e75a3a08$var$tsv.formatBody;
var $fecc94c7e75a3a08$export$ae461973f6adc981 = $fecc94c7e75a3a08$var$tsv.formatRows;
var $fecc94c7e75a3a08$export$5d61cf35a4a738d2 = $fecc94c7e75a3a08$var$tsv.formatRow;
var $fecc94c7e75a3a08$export$4280e6a416cd92a3 = $fecc94c7e75a3a08$var$tsv.formatValue;

});

parcelRegister("2I6Ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f94f94efd91ec60$export$2e2bcd8739ae039);
function $1f94f94efd91ec60$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $1f94f94efd91ec60$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($1f94f94efd91ec60$var$responseText);
}

});


parcelRegister("dfWFX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "apply", () => $a368ca6f900f7a8d$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "setImmediate", () => $a368ca6f900f7a8d$export$c233f08fbfea0913);
$parcel$export(module.exports, "asyncify", () => $a368ca6f900f7a8d$export$b5d55b15b1db3122);
$parcel$export(module.exports, "eachOfLimit", () => $a368ca6f900f7a8d$export$8b05461b96b91438);
$parcel$export(module.exports, "eachOf", () => $a368ca6f900f7a8d$export$d10d68e43a57bce9);
$parcel$export(module.exports, "map", () => $a368ca6f900f7a8d$export$871de8747c9eaa88);
$parcel$export(module.exports, "applyEach", () => $a368ca6f900f7a8d$export$e0fc6250e304edaf);
$parcel$export(module.exports, "eachOfSeries", () => $a368ca6f900f7a8d$export$750e7e5fea3b0654);
$parcel$export(module.exports, "mapSeries", () => $a368ca6f900f7a8d$export$9a85c32cda85b0dd);
$parcel$export(module.exports, "applyEachSeries", () => $a368ca6f900f7a8d$export$cdb63afc167779e);
$parcel$export(module.exports, "auto", () => $a368ca6f900f7a8d$export$dfb5619354ba860);
$parcel$export(module.exports, "autoInject", () => $a368ca6f900f7a8d$export$868ec1c38c3c8735);
$parcel$export(module.exports, "cargo", () => $a368ca6f900f7a8d$export$f9549d7e5aef7637);
$parcel$export(module.exports, "cargoQueue", () => $a368ca6f900f7a8d$export$687de40d137ed486);
$parcel$export(module.exports, "foldl", () => $a368ca6f900f7a8d$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "seq", () => $a368ca6f900f7a8d$export$1041d4276c328e4d);
$parcel$export(module.exports, "compose", () => $a368ca6f900f7a8d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "mapLimit", () => $a368ca6f900f7a8d$export$6a28d19bcc59197c);
$parcel$export(module.exports, "concatLimit", () => $a368ca6f900f7a8d$export$4f1520afe59a31db);
$parcel$export(module.exports, "concat", () => $a368ca6f900f7a8d$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatSeries", () => $a368ca6f900f7a8d$export$b6df61d74da01b63);
$parcel$export(module.exports, "constant", () => $a368ca6f900f7a8d$export$c983f826f44ff86);
$parcel$export(module.exports, "detect", () => $a368ca6f900f7a8d$export$17b446b869dad473);
$parcel$export(module.exports, "detectLimit", () => $a368ca6f900f7a8d$export$922bcf02f3a5b284);
$parcel$export(module.exports, "detectSeries", () => $a368ca6f900f7a8d$export$922a9a31d0cff2ee);
$parcel$export(module.exports, "dir", () => $a368ca6f900f7a8d$export$147ec2801e896265);
$parcel$export(module.exports, "doDuring", () => $a368ca6f900f7a8d$export$df0899fd4acbef10);
$parcel$export(module.exports, "doUntil", () => $a368ca6f900f7a8d$export$16f3a0560cc13fb4);
$parcel$export(module.exports, "each", () => $a368ca6f900f7a8d$export$79b2f7037acddd43);
$parcel$export(module.exports, "eachLimit", () => $a368ca6f900f7a8d$export$2a2080ddac50d6b8);
$parcel$export(module.exports, "eachSeries", () => $a368ca6f900f7a8d$export$9bd663f1fadd104c);
$parcel$export(module.exports, "ensureAsync", () => $a368ca6f900f7a8d$export$85d5b9ccf228381c);
$parcel$export(module.exports, "all", () => $a368ca6f900f7a8d$export$84bf76cd7afc7469);
$parcel$export(module.exports, "allLimit", () => $a368ca6f900f7a8d$export$5b469f316a3f1415);
$parcel$export(module.exports, "allSeries", () => $a368ca6f900f7a8d$export$c4a4adf74205a63d);
$parcel$export(module.exports, "filter", () => $a368ca6f900f7a8d$export$3dea766d36a8935f);
$parcel$export(module.exports, "filterLimit", () => $a368ca6f900f7a8d$export$6a93acd3681313ac);
$parcel$export(module.exports, "filterSeries", () => $a368ca6f900f7a8d$export$ddcc38daaa46257c);
$parcel$export(module.exports, "forever", () => $a368ca6f900f7a8d$export$116a0f7f2303acd8);
$parcel$export(module.exports, "groupByLimit", () => $a368ca6f900f7a8d$export$335ad4c8e8977a4b);
$parcel$export(module.exports, "groupBy", () => $a368ca6f900f7a8d$export$3f063810d7bf01bd);
$parcel$export(module.exports, "groupBySeries", () => $a368ca6f900f7a8d$export$d0689f2b629adbdb);
$parcel$export(module.exports, "log", () => $a368ca6f900f7a8d$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "mapValuesLimit", () => $a368ca6f900f7a8d$export$d5d82430c6fa645f);
$parcel$export(module.exports, "mapValues", () => $a368ca6f900f7a8d$export$825e789796ab7275);
$parcel$export(module.exports, "mapValuesSeries", () => $a368ca6f900f7a8d$export$8fbd16e43ec40b44);
$parcel$export(module.exports, "memoize", () => $a368ca6f900f7a8d$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "nextTick", () => $a368ca6f900f7a8d$export$bdd553fddd433dcb);
$parcel$export(module.exports, "parallel", () => $a368ca6f900f7a8d$export$451942af9381149c);
$parcel$export(module.exports, "parallelLimit", () => $a368ca6f900f7a8d$export$362c0a688af131a0);
$parcel$export(module.exports, "queue", () => $a368ca6f900f7a8d$export$4f7fa46ff53e516f);
$parcel$export(module.exports, "priorityQueue", () => $a368ca6f900f7a8d$export$25579debde666a98);
$parcel$export(module.exports, "race", () => $a368ca6f900f7a8d$export$236c05de452bec2);
$parcel$export(module.exports, "foldr", () => $a368ca6f900f7a8d$export$a11cb61c36c4a4cf);
$parcel$export(module.exports, "reflect", () => $a368ca6f900f7a8d$export$9debe8cffacea23);
$parcel$export(module.exports, "reflectAll", () => $a368ca6f900f7a8d$export$1a54554d0a489acc);
$parcel$export(module.exports, "reject", () => $a368ca6f900f7a8d$export$2800f3ceda99eb84);
$parcel$export(module.exports, "rejectLimit", () => $a368ca6f900f7a8d$export$b59d647fa1894da8);
$parcel$export(module.exports, "rejectSeries", () => $a368ca6f900f7a8d$export$d68373657532124d);
$parcel$export(module.exports, "retry", () => $a368ca6f900f7a8d$export$9369b12211e1fce4);
$parcel$export(module.exports, "retryable", () => $a368ca6f900f7a8d$export$9e1b8e833f44ff21);
$parcel$export(module.exports, "series", () => $a368ca6f900f7a8d$export$7589597339a0562d);
$parcel$export(module.exports, "any", () => $a368ca6f900f7a8d$export$4154a199d7d90455);
$parcel$export(module.exports, "anyLimit", () => $a368ca6f900f7a8d$export$97c6076dd161c251);
$parcel$export(module.exports, "anySeries", () => $a368ca6f900f7a8d$export$728f30d6f8df8331);
$parcel$export(module.exports, "sortBy", () => $a368ca6f900f7a8d$export$b035e44d7bb4278f);
$parcel$export(module.exports, "timeout", () => $a368ca6f900f7a8d$export$83e74882c5df8fe1);
$parcel$export(module.exports, "timesLimit", () => $a368ca6f900f7a8d$export$5ebd4c84811c422b);
$parcel$export(module.exports, "times", () => $a368ca6f900f7a8d$export$b5bc26e198ce73d0);
$parcel$export(module.exports, "timesSeries", () => $a368ca6f900f7a8d$export$51c3f8bb1fe6838c);
$parcel$export(module.exports, "transform", () => $a368ca6f900f7a8d$export$51186ad6e864892a);
$parcel$export(module.exports, "tryEach", () => $a368ca6f900f7a8d$export$c382910393876e1e);
$parcel$export(module.exports, "unmemoize", () => $a368ca6f900f7a8d$export$a8183b28ba2fbf41);
$parcel$export(module.exports, "during", () => $a368ca6f900f7a8d$export$147085f09cc1931);
$parcel$export(module.exports, "until", () => $a368ca6f900f7a8d$export$a40009bd2c363351);
$parcel$export(module.exports, "waterfall", () => $a368ca6f900f7a8d$export$981f466e0ef96280);
$parcel$export(module.exports, "default", () => $a368ca6f900f7a8d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "doWhilst", () => $a368ca6f900f7a8d$export$df0899fd4acbef10);
$parcel$export(module.exports, "every", () => $a368ca6f900f7a8d$export$84bf76cd7afc7469);
$parcel$export(module.exports, "everyLimit", () => $a368ca6f900f7a8d$export$5b469f316a3f1415);
$parcel$export(module.exports, "everySeries", () => $a368ca6f900f7a8d$export$c4a4adf74205a63d);
$parcel$export(module.exports, "find", () => $a368ca6f900f7a8d$export$17b446b869dad473);
$parcel$export(module.exports, "findLimit", () => $a368ca6f900f7a8d$export$922bcf02f3a5b284);
$parcel$export(module.exports, "findSeries", () => $a368ca6f900f7a8d$export$922a9a31d0cff2ee);
$parcel$export(module.exports, "flatMap", () => $a368ca6f900f7a8d$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "flatMapLimit", () => $a368ca6f900f7a8d$export$4f1520afe59a31db);
$parcel$export(module.exports, "flatMapSeries", () => $a368ca6f900f7a8d$export$b6df61d74da01b63);
$parcel$export(module.exports, "forEach", () => $a368ca6f900f7a8d$export$79b2f7037acddd43);
$parcel$export(module.exports, "forEachLimit", () => $a368ca6f900f7a8d$export$2a2080ddac50d6b8);
$parcel$export(module.exports, "forEachOf", () => $a368ca6f900f7a8d$export$d10d68e43a57bce9);
$parcel$export(module.exports, "forEachOfLimit", () => $a368ca6f900f7a8d$export$8b05461b96b91438);
$parcel$export(module.exports, "forEachOfSeries", () => $a368ca6f900f7a8d$export$750e7e5fea3b0654);
$parcel$export(module.exports, "forEachSeries", () => $a368ca6f900f7a8d$export$9bd663f1fadd104c);
$parcel$export(module.exports, "inject", () => $a368ca6f900f7a8d$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "reduce", () => $a368ca6f900f7a8d$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "reduceRight", () => $a368ca6f900f7a8d$export$a11cb61c36c4a4cf);
$parcel$export(module.exports, "select", () => $a368ca6f900f7a8d$export$3dea766d36a8935f);
$parcel$export(module.exports, "selectLimit", () => $a368ca6f900f7a8d$export$6a93acd3681313ac);
$parcel$export(module.exports, "selectSeries", () => $a368ca6f900f7a8d$export$ddcc38daaa46257c);
$parcel$export(module.exports, "some", () => $a368ca6f900f7a8d$export$4154a199d7d90455);
$parcel$export(module.exports, "someLimit", () => $a368ca6f900f7a8d$export$97c6076dd161c251);
$parcel$export(module.exports, "someSeries", () => $a368ca6f900f7a8d$export$728f30d6f8df8331);
$parcel$export(module.exports, "whilst", () => $a368ca6f900f7a8d$export$147085f09cc1931);
$parcel$export(module.exports, "wrapSync", () => $a368ca6f900f7a8d$export$b5d55b15b1db3122);
/**
 * Creates a continuation function with some arguments already applied.
 *
 * Useful as a shorthand when combined with other control flow functions. Any
 * arguments passed to the returned function are added to the arguments
 * originally passed to apply.
 *
 * @name apply
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {Function} fn - The function you want to eventually apply all
 * arguments to. Invokes with (arguments...).
 * @param {...*} arguments... - Any number of arguments to automatically apply
 * when the continuation is called.
 * @returns {Function} the partially-applied function
 * @example
 *
 * // using apply
 * async.parallel([
 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
 *     async.apply(fs.writeFile, 'testfile2', 'test2')
 * ]);
 *
 *
 * // the same process without using apply
 * async.parallel([
 *     function(callback) {
 *         fs.writeFile('testfile1', 'test1', callback);
 *     },
 *     function(callback) {
 *         fs.writeFile('testfile2', 'test2', callback);
 *     }
 * ]);
 *
 * // It's possible to pass any number of additional arguments when calling the
 * // continuation:
 *
 * node> var fn = async.apply(sys.puts, 'one');
 * node> fn('two', 'three');
 * one
 * two
 * three
 */ 
var $jOTJ0 = parcelRequire("jOTJ0");
function $a368ca6f900f7a8d$export$5635d7ef4b8fee1c(fn, ...args) {
    return (...callArgs)=>fn(...args, ...callArgs);
}
function $a368ca6f900f7a8d$var$initialParams(fn) {
    return function(...args /*, callback*/ ) {
        var callback = args.pop();
        return fn.call(this, args, callback);
    };
}
/* istanbul ignore file */ var $a368ca6f900f7a8d$var$hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
var $a368ca6f900f7a8d$var$hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var $a368ca6f900f7a8d$var$hasNextTick = false;
function $a368ca6f900f7a8d$var$fallback(fn) {
    setTimeout(fn, 0);
}
function $a368ca6f900f7a8d$var$wrap(defer) {
    return (fn, ...args)=>defer(()=>fn(...args));
}
var $a368ca6f900f7a8d$var$_defer$1;
if ($a368ca6f900f7a8d$var$hasQueueMicrotask) $a368ca6f900f7a8d$var$_defer$1 = queueMicrotask;
else if ($a368ca6f900f7a8d$var$hasSetImmediate) $a368ca6f900f7a8d$var$_defer$1 = setImmediate;
else if ($a368ca6f900f7a8d$var$hasNextTick) $a368ca6f900f7a8d$var$_defer$1 = $jOTJ0.nextTick;
else $a368ca6f900f7a8d$var$_defer$1 = $a368ca6f900f7a8d$var$fallback;
var $a368ca6f900f7a8d$export$c233f08fbfea0913 = $a368ca6f900f7a8d$var$wrap($a368ca6f900f7a8d$var$_defer$1);
/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */ function $a368ca6f900f7a8d$export$b5d55b15b1db3122(func) {
    if ($a368ca6f900f7a8d$var$isAsync(func)) return function(...args /*, callback*/ ) {
        const callback = args.pop();
        const promise = func.apply(this, args);
        return $a368ca6f900f7a8d$var$handlePromise(promise, callback);
    };
    return $a368ca6f900f7a8d$var$initialParams(function(args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (result && typeof result.then === 'function') return $a368ca6f900f7a8d$var$handlePromise(result, callback);
        else callback(null, result);
    });
}
function $a368ca6f900f7a8d$var$handlePromise(promise, callback) {
    return promise.then((value)=>{
        $a368ca6f900f7a8d$var$invokeCallback(callback, null, value);
    }, (err)=>{
        $a368ca6f900f7a8d$var$invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
    });
}
function $a368ca6f900f7a8d$var$invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (err) {
        $a368ca6f900f7a8d$export$c233f08fbfea0913((e)=>{
            throw e;
        }, err);
    }
}
function $a368ca6f900f7a8d$var$isAsync(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
}
function $a368ca6f900f7a8d$var$isAsyncGenerator(fn) {
    return fn[Symbol.toStringTag] === 'AsyncGenerator';
}
function $a368ca6f900f7a8d$var$isAsyncIterable(obj) {
    return typeof obj[Symbol.asyncIterator] === 'function';
}
function $a368ca6f900f7a8d$var$wrapAsync(asyncFn) {
    if (typeof asyncFn !== 'function') throw new Error('expected a function');
    return $a368ca6f900f7a8d$var$isAsync(asyncFn) ? $a368ca6f900f7a8d$export$b5d55b15b1db3122(asyncFn) : asyncFn;
}
// conditionally promisify a function.
// only return a promise if a callback is omitted
function $a368ca6f900f7a8d$var$awaitify(asyncFn, arity) {
    if (!arity) arity = asyncFn.length;
    if (!arity) throw new Error('arity is undefined');
    function awaitable(...args) {
        if (typeof args[arity - 1] === 'function') return asyncFn.apply(this, args);
        return new Promise((resolve, reject)=>{
            args[arity - 1] = (err, ...cbArgs)=>{
                if (err) return reject(err);
                resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
            };
            asyncFn.apply(this, args);
        });
    }
    return awaitable;
}
function $a368ca6f900f7a8d$var$applyEach$1(eachfn) {
    return function applyEach(fns, ...callArgs) {
        const go = $a368ca6f900f7a8d$var$awaitify(function(callback) {
            var that = this;
            return eachfn(fns, (fn, cb)=>{
                $a368ca6f900f7a8d$var$wrapAsync(fn).apply(that, callArgs.concat(cb));
            }, callback);
        });
        return go;
    };
}
function $a368ca6f900f7a8d$var$_asyncMap(eachfn, arr, iteratee, callback) {
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return eachfn(arr, (value, _, iterCb)=>{
        var index = counter++;
        _iteratee(value, (err, v)=>{
            results[index] = v;
            iterCb(err);
        });
    }, (err)=>{
        callback(err, results);
    });
}
function $a368ca6f900f7a8d$var$isArrayLike(value) {
    return value && typeof value.length === 'number' && value.length >= 0 && value.length % 1 === 0;
}
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
const $a368ca6f900f7a8d$var$breakLoop = {};
function $a368ca6f900f7a8d$var$once(fn) {
    function wrapper(...args) {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    }
    Object.assign(wrapper, fn);
    return wrapper;
}
function $a368ca6f900f7a8d$var$getIterator(coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
}
function $a368ca6f900f7a8d$var$createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {
            value: coll[i],
            key: i
        } : null;
    };
}
function $a368ca6f900f7a8d$var$createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done) return null;
        i++;
        return {
            value: item.value,
            key: i
        };
    };
}
function $a368ca6f900f7a8d$var$createObjectIterator(obj) {
    var okeys = obj ? Object.keys(obj) : [];
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        if (key === '__proto__') return next();
        return i < len ? {
            value: obj[key],
            key: key
        } : null;
    };
}
function $a368ca6f900f7a8d$var$createIterator(coll) {
    if ($a368ca6f900f7a8d$var$isArrayLike(coll)) return $a368ca6f900f7a8d$var$createArrayIterator(coll);
    var iterator = $a368ca6f900f7a8d$var$getIterator(coll);
    return iterator ? $a368ca6f900f7a8d$var$createES2015Iterator(iterator) : $a368ca6f900f7a8d$var$createObjectIterator(coll);
}
function $a368ca6f900f7a8d$var$onlyOnce(fn) {
    return function(...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
// for async generators
function $a368ca6f900f7a8d$var$asyncEachOfLimit(generator, limit, iteratee, callback) {
    let done = false;
    let canceled = false;
    let awaiting = false;
    let running = 0;
    let idx = 0;
    function replenish() {
        //console.log('replenish')
        if (running >= limit || awaiting || done) return;
        //console.log('replenish awaiting')
        awaiting = true;
        generator.next().then(({ value: value, done: iterDone })=>{
            //console.log('got value', value)
            if (canceled || done) return;
            awaiting = false;
            if (iterDone) {
                done = true;
                if (running <= 0) //console.log('done nextCb')
                callback(null);
                return;
            }
            running++;
            iteratee(value, idx, iterateeCallback);
            idx++;
            replenish();
        }).catch(handleError);
    }
    function iterateeCallback(err, result) {
        //console.log('iterateeCallback')
        running -= 1;
        if (canceled) return;
        if (err) return handleError(err);
        if (err === false) {
            done = true;
            canceled = true;
            return;
        }
        if (result === $a368ca6f900f7a8d$var$breakLoop || done && running <= 0) {
            done = true;
            //console.log('done iterCb')
            return callback(null);
        }
        replenish();
    }
    function handleError(err) {
        if (canceled) return;
        awaiting = false;
        done = true;
        callback(err);
    }
    replenish();
}
var $a368ca6f900f7a8d$var$eachOfLimit$2 = (limit)=>{
    return (obj, iteratee, callback)=>{
        callback = $a368ca6f900f7a8d$var$once(callback);
        if (limit <= 0) throw new RangeError('concurrency limit cannot be less than 1');
        if (!obj) return callback(null);
        if ($a368ca6f900f7a8d$var$isAsyncGenerator(obj)) return $a368ca6f900f7a8d$var$asyncEachOfLimit(obj, limit, iteratee, callback);
        if ($a368ca6f900f7a8d$var$isAsyncIterable(obj)) return $a368ca6f900f7a8d$var$asyncEachOfLimit(obj[Symbol.asyncIterator](), limit, iteratee, callback);
        var nextElem = $a368ca6f900f7a8d$var$createIterator(obj);
        var done = false;
        var canceled = false;
        var running = 0;
        var looping = false;
        function iterateeCallback(err, value) {
            if (canceled) return;
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            } else if (err === false) {
                done = true;
                canceled = true;
            } else if (value === $a368ca6f900f7a8d$var$breakLoop || done && running <= 0) {
                done = true;
                return callback(null);
            } else if (!looping) replenish();
        }
        function replenish() {
            looping = true;
            while(running < limit && !done){
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) callback(null);
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, $a368ca6f900f7a8d$var$onlyOnce(iterateeCallback));
            }
            looping = false;
        }
        replenish();
    };
};
/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$eachOfLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$eachOfLimit$2(limit)(coll, $a368ca6f900f7a8d$var$wrapAsync(iteratee), callback);
}
var $a368ca6f900f7a8d$export$8b05461b96b91438 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachOfLimit, 4);
// eachOf implementation optimized for array-likes
function $a368ca6f900f7a8d$var$eachOfArrayLike(coll, iteratee, callback) {
    callback = $a368ca6f900f7a8d$var$once(callback);
    var index = 0, completed = 0, { length: length } = coll, canceled = false;
    if (length === 0) callback(null);
    function iteratorCallback(err, value) {
        if (err === false) canceled = true;
        if (canceled === true) return;
        if (err) callback(err);
        else if (++completed === length || value === $a368ca6f900f7a8d$var$breakLoop) callback(null);
    }
    for(; index < length; index++)iteratee(coll[index], index, $a368ca6f900f7a8d$var$onlyOnce(iteratorCallback));
}
// a generic version of eachOf which can handle array, object, and iterator cases.
function $a368ca6f900f7a8d$var$eachOfGeneric(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$8b05461b96b91438(coll, Infinity, iteratee, callback);
}
/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dev.json is a file containing a valid json object config for dev environment
 * // dev.json is a file containing a valid json object config for test environment
 * // prod.json is a file containing a valid json object config for prod environment
 * // invalid.json is a file with a malformed json object
 *
 * let configs = {}; //global variable
 * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
 * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
 *
 * // asynchronous function that reads a json file and parses the contents as json object
 * function parseFile(file, key, callback) {
 *     fs.readFile(file, "utf8", function(err, data) {
 *         if (err) return calback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }
 *
 * // Using callbacks
 * async.forEachOf(validConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *     } else {
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *         // JSON parse error exception
 *     } else {
 *         console.log(configs);
 *     }
 * });
 *
 * // Using Promises
 * async.forEachOf(validConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 *     // configs is now a map of JSON data, e.g.
 *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 * }).catch( err => {
 *     console.error(err);
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 * }).catch( err => {
 *     console.error(err);
 *     // JSON parse error exception
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.forEachOf(validConfigFileMap, parseFile);
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * //Error handing
 * async () => {
 *     try {
 *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
 *         console.log(configs);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // JSON parse error exception
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$eachOf(coll, iteratee, callback) {
    var eachOfImplementation = $a368ca6f900f7a8d$var$isArrayLike(coll) ? $a368ca6f900f7a8d$var$eachOfArrayLike : $a368ca6f900f7a8d$var$eachOfGeneric;
    return eachOfImplementation(coll, $a368ca6f900f7a8d$var$wrapAsync(iteratee), callback);
}
var $a368ca6f900f7a8d$export$d10d68e43a57bce9 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachOf, 3);
/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callbacks
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.map(fileList, getFileSizeInBytes, function(err, results) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(results);
 *         // results is now an array of the file size in bytes for each file, e.g.
 *         // [ 1000, 2000, 3000]
 *     }
 * });
 *
 * // Error Handling
 * async.map(withMissingFileList, getFileSizeInBytes, function(err, results) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(results);
 *     }
 * });
 *
 * // Using Promises
 * async.map(fileList, getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 *     // results is now an array of the file size in bytes for each file, e.g.
 *     // [ 1000, 2000, 3000]
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.map(withMissingFileList, getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.map(fileList, getFileSizeInBytes);
 *         console.log(results);
 *         // results is now an array of the file size in bytes for each file, e.g.
 *         // [ 1000, 2000, 3000]
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let results = await async.map(withMissingFileList, getFileSizeInBytes);
 *         console.log(results);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$map(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_asyncMap($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$871de8747c9eaa88 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$map, 3);
/**
 * Applies the provided arguments to each function in the array, calling
 * `callback` after all functions have completed. If you only provide the first
 * argument, `fns`, then it will return a function which lets you pass in the
 * arguments as if it were a single function call. If more arguments are
 * provided, `callback` is required while `args` is still optional. The results
 * for each of the applied async functions are passed to the final callback
 * as an array.
 *
 * @name applyEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s
 * to all call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {AsyncFunction} - Returns a function that takes no args other than
 * an optional callback, that is the result of applying the `args` to each
 * of the functions.
 * @example
 *
 * const appliedFn = async.applyEach([enableSearch, updateSchema], 'bucket')
 *
 * appliedFn((err, results) => {
 *     // results[0] is the results for `enableSearch`
 *     // results[1] is the results for `updateSchema`
 * });
 *
 * // partial application example:
 * async.each(
 *     buckets,
 *     async (bucket) => async.applyEach([enableSearch, updateSchema], bucket)(),
 *     callback
 * );
 */ var $a368ca6f900f7a8d$export$e0fc6250e304edaf = $a368ca6f900f7a8d$var$applyEach$1($a368ca6f900f7a8d$export$871de8747c9eaa88);
/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$eachOfSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$8b05461b96b91438(coll, 1, iteratee, callback);
}
var $a368ca6f900f7a8d$export$750e7e5fea3b0654 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachOfSeries, 3);
/**
 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
 *
 * @name mapSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$mapSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_asyncMap($a368ca6f900f7a8d$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$9a85c32cda85b0dd = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$mapSeries, 3);
/**
 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
 *
 * @name applyEachSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s to all
 * call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {AsyncFunction} - A function, that when called, is the result of
 * appling the `args` to the list of functions.  It takes no args, other than
 * a callback.
 */ var $a368ca6f900f7a8d$export$cdb63afc167779e = $a368ca6f900f7a8d$var$applyEach$1($a368ca6f900f7a8d$export$9a85c32cda85b0dd);
const $a368ca6f900f7a8d$var$PROMISE_SYMBOL = Symbol('promiseCallback');
function $a368ca6f900f7a8d$var$promiseCallback() {
    let resolve, reject;
    function callback(err, ...args) {
        if (err) return reject(err);
        resolve(args.length > 1 ? args : args[0]);
    }
    callback[$a368ca6f900f7a8d$var$PROMISE_SYMBOL] = new Promise((res, rej)=>{
        resolve = res, reject = rej;
    });
    return callback;
}
/**
 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
 * their requirements. Each function can optionally depend on other functions
 * being completed first, and each function is run as soon as its requirements
 * are satisfied.
 *
 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
 * will stop. Further tasks will not execute (so any other functions depending
 * on it will not run), and the main `callback` is immediately called with the
 * error.
 *
 * {@link AsyncFunction}s also receive an object containing the results of functions which
 * have completed so far as the first argument, if they have dependencies. If a
 * task function has no dependencies, it will only be passed a callback.
 *
 * @name auto
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Object} tasks - An object. Each of its properties is either a
 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
 * in the array. The object's key of a property serves as the name of the task
 * defined by that property, i.e. can be used when specifying requirements for
 * other tasks. The function receives one or two arguments:
 * * a `results` object, containing the results of the previously executed
 *   functions, only passed if the task has any dependencies,
 * * a `callback(err, result)` function, which must be called when finished,
 *   passing an `error` (which can be `null`) and the result of the function's
 *   execution.
 * @param {number} [concurrency=Infinity] - An optional `integer` for
 * determining the maximum number of tasks that can be run in parallel. By
 * default, as many as possible.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback. Results are always returned; however, if an
 * error occurs, no further `tasks` will be performed, and the results object
 * will only contain partial results. Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 * @example
 *
 * //Using Callbacks
 * async.auto({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         // once the file is written let's email a link to it...
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }, function(err, results) {
 *     if (err) {
 *         console.log('err = ', err);
 *     }
 *     console.log('results = ', results);
 *     // results = {
 *     //     get_data: ['data', 'converted to array']
 *     //     make_folder; 'folder',
 *     //     write_file: 'filename'
 *     //     email_link: { file: 'filename', email: 'user@example.com' }
 *     // }
 * });
 *
 * //Using Promises
 * async.auto({
 *     get_data: function(callback) {
 *         console.log('in get_data');
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         console.log('in make_folder');
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         // once the file is written let's email a link to it...
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }).then(results => {
 *     console.log('results = ', results);
 *     // results = {
 *     //     get_data: ['data', 'converted to array']
 *     //     make_folder; 'folder',
 *     //     write_file: 'filename'
 *     //     email_link: { file: 'filename', email: 'user@example.com' }
 *     // }
 * }).catch(err => {
 *     console.log('err = ', err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.auto({
 *             get_data: function(callback) {
 *                 // async code to get some data
 *                 callback(null, 'data', 'converted to array');
 *             },
 *             make_folder: function(callback) {
 *                 // async code to create a directory to store a file in
 *                 // this is run at the same time as getting the data
 *                 callback(null, 'folder');
 *             },
 *             write_file: ['get_data', 'make_folder', function(results, callback) {
 *                 // once there is some data and the directory exists,
 *                 // write the data to a file in the directory
 *                 callback(null, 'filename');
 *             }],
 *             email_link: ['write_file', function(results, callback) {
 *                 // once the file is written let's email a link to it...
 *                 callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *             }]
 *         });
 *         console.log('results = ', results);
 *         // results = {
 *         //     get_data: ['data', 'converted to array']
 *         //     make_folder; 'folder',
 *         //     write_file: 'filename'
 *         //     email_link: { file: 'filename', email: 'user@example.com' }
 *         // }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$dfb5619354ba860(tasks, concurrency, callback) {
    if (typeof concurrency !== 'number') {
        // concurrency is optional, shift the args.
        callback = concurrency;
        concurrency = null;
    }
    callback = $a368ca6f900f7a8d$var$once(callback || $a368ca6f900f7a8d$var$promiseCallback());
    var numTasks = Object.keys(tasks).length;
    if (!numTasks) return callback(null);
    if (!concurrency) concurrency = numTasks;
    var results = {};
    var runningTasks = 0;
    var canceled = false;
    var hasError = false;
    var listeners = Object.create(null);
    var readyTasks = [];
    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};
    Object.keys(tasks).forEach((key)=>{
        var task = tasks[key];
        if (!Array.isArray(task)) {
            // no dependencies
            enqueueTask(key, [
                task
            ]);
            readyToCheck.push(key);
            return;
        }
        var dependencies = task.slice(0, task.length - 1);
        var remainingDependencies = dependencies.length;
        if (remainingDependencies === 0) {
            enqueueTask(key, task);
            readyToCheck.push(key);
            return;
        }
        uncheckedDependencies[key] = remainingDependencies;
        dependencies.forEach((dependencyName)=>{
            if (!tasks[dependencyName]) throw new Error('async.auto task `' + key + '` has a non-existent dependency `' + dependencyName + '` in ' + dependencies.join(', '));
            addListener(dependencyName, ()=>{
                remainingDependencies--;
                if (remainingDependencies === 0) enqueueTask(key, task);
            });
        });
    });
    checkForDeadlocks();
    processQueue();
    function enqueueTask(key, task) {
        readyTasks.push(()=>runTask(key, task));
    }
    function processQueue() {
        if (canceled) return;
        if (readyTasks.length === 0 && runningTasks === 0) return callback(null, results);
        while(readyTasks.length && runningTasks < concurrency){
            var run = readyTasks.shift();
            run();
        }
    }
    function addListener(taskName, fn) {
        var taskListeners = listeners[taskName];
        if (!taskListeners) taskListeners = listeners[taskName] = [];
        taskListeners.push(fn);
    }
    function taskComplete(taskName) {
        var taskListeners = listeners[taskName] || [];
        taskListeners.forEach((fn)=>fn());
        processQueue();
    }
    function runTask(key, task) {
        if (hasError) return;
        var taskCallback = $a368ca6f900f7a8d$var$onlyOnce((err, ...result)=>{
            runningTasks--;
            if (err === false) {
                canceled = true;
                return;
            }
            if (result.length < 2) [result] = result;
            if (err) {
                var safeResults = {};
                Object.keys(results).forEach((rkey)=>{
                    safeResults[rkey] = results[rkey];
                });
                safeResults[key] = result;
                hasError = true;
                listeners = Object.create(null);
                if (canceled) return;
                callback(err, safeResults);
            } else {
                results[key] = result;
                taskComplete(key);
            }
        });
        runningTasks++;
        var taskFn = $a368ca6f900f7a8d$var$wrapAsync(task[task.length - 1]);
        if (task.length > 1) taskFn(results, taskCallback);
        else taskFn(taskCallback);
    }
    function checkForDeadlocks() {
        // Kahn's algorithm
        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
        var currentTask;
        var counter = 0;
        while(readyToCheck.length){
            currentTask = readyToCheck.pop();
            counter++;
            getDependents(currentTask).forEach((dependent)=>{
                if (--uncheckedDependencies[dependent] === 0) readyToCheck.push(dependent);
            });
        }
        if (counter !== numTasks) throw new Error('async.auto cannot execute tasks due to a recursive dependency');
    }
    function getDependents(taskName) {
        var result = [];
        Object.keys(tasks).forEach((key)=>{
            const task = tasks[key];
            if (Array.isArray(task) && task.indexOf(taskName) >= 0) result.push(key);
        });
        return result;
    }
    return callback[$a368ca6f900f7a8d$var$PROMISE_SYMBOL];
}
var $a368ca6f900f7a8d$var$FN_ARGS = /^(?:async\s)?(?:function)?\s*(?:\w+\s*)?\(([^)]+)\)(?:\s*{)/;
var $a368ca6f900f7a8d$var$ARROW_FN_ARGS = /^(?:async\s)?\s*(?:\(\s*)?((?:[^)=\s]\s*)*)(?:\)\s*)?=>/;
var $a368ca6f900f7a8d$var$FN_ARG_SPLIT = /,/;
var $a368ca6f900f7a8d$var$FN_ARG = /(=.+)?(\s*)$/;
function $a368ca6f900f7a8d$var$stripComments(string) {
    let stripped = '';
    let index = 0;
    let endBlockComment = string.indexOf('*/');
    while(index < string.length){
        if (string[index] === '/' && string[index + 1] === '/') {
            // inline comment
            let endIndex = string.indexOf('\n', index);
            index = endIndex === -1 ? string.length : endIndex;
        } else if (endBlockComment !== -1 && string[index] === '/' && string[index + 1] === '*') {
            // block comment
            let endIndex = string.indexOf('*/', index);
            if (endIndex !== -1) {
                index = endIndex + 2;
                endBlockComment = string.indexOf('*/', index);
            } else {
                stripped += string[index];
                index++;
            }
        } else {
            stripped += string[index];
            index++;
        }
    }
    return stripped;
}
function $a368ca6f900f7a8d$var$parseParams(func) {
    const src = $a368ca6f900f7a8d$var$stripComments(func.toString());
    let match = src.match($a368ca6f900f7a8d$var$FN_ARGS);
    if (!match) match = src.match($a368ca6f900f7a8d$var$ARROW_FN_ARGS);
    if (!match) throw new Error('could not parse args in autoInject\nSource:\n' + src);
    let [, args] = match;
    return args.replace(/\s/g, '').split($a368ca6f900f7a8d$var$FN_ARG_SPLIT).map((arg)=>arg.replace($a368ca6f900f7a8d$var$FN_ARG, '').trim());
}
/**
 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
 * tasks are specified as parameters to the function, after the usual callback
 * parameter, with the parameter names matching the names of the tasks it
 * depends on. This can provide even more readable task graphs which can be
 * easier to maintain.
 *
 * If a final callback is specified, the task results are similarly injected,
 * specified as named parameters after the initial error parameter.
 *
 * The autoInject function is purely syntactic sugar and its semantics are
 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
 *
 * @name autoInject
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.auto]{@link module:ControlFlow.auto}
 * @category Control Flow
 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
 * the form 'func([dependencies...], callback). The object's key of a property
 * serves as the name of the task defined by that property, i.e. can be used
 * when specifying requirements for other tasks.
 * * The `callback` parameter is a `callback(err, result)` which must be called
 *   when finished, passing an `error` (which can be `null`) and the result of
 *   the function's execution. The remaining parameters name other tasks on
 *   which the task is dependent, and the results from those tasks are the
 *   arguments of those parameters.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback, and a `results` object with any completed
 * task results, similar to `auto`.
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * //  The example from `auto` can be rewritten as follows:
 * async.autoInject({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: function(get_data, make_folder, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     },
 *     email_link: function(write_file, callback) {
 *         // once the file is written let's email a link to it...
 *         // write_file contains the filename returned by write_file.
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 *
 * // If you are using a JS minifier that mangles parameter names, `autoInject`
 * // will not work with plain functions, since the parameter names will be
 * // collapsed to a single letter identifier.  To work around this, you can
 * // explicitly specify the names of the parameters your task function needs
 * // in an array, similar to Angular.js dependency injection.
 *
 * // This still has an advantage over plain `auto`, since the results a task
 * // depends on are still spread into arguments.
 * async.autoInject({
 *     //...
 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(write_file, callback) {
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }]
 *     //...
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 */ function $a368ca6f900f7a8d$export$868ec1c38c3c8735(tasks, callback) {
    var newTasks = {};
    Object.keys(tasks).forEach((key)=>{
        var taskFn = tasks[key];
        var params;
        var fnIsAsync = $a368ca6f900f7a8d$var$isAsync(taskFn);
        var hasNoDeps = !fnIsAsync && taskFn.length === 1 || fnIsAsync && taskFn.length === 0;
        if (Array.isArray(taskFn)) {
            params = [
                ...taskFn
            ];
            taskFn = params.pop();
            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
        } else if (hasNoDeps) // no dependencies, use the function as-is
        newTasks[key] = taskFn;
        else {
            params = $a368ca6f900f7a8d$var$parseParams(taskFn);
            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) throw new Error("autoInject task functions require explicit parameters.");
            // remove callback param
            if (!fnIsAsync) params.pop();
            newTasks[key] = params.concat(newTask);
        }
        function newTask(results, taskCb) {
            var newArgs = params.map((name)=>results[name]);
            newArgs.push(taskCb);
            $a368ca6f900f7a8d$var$wrapAsync(taskFn)(...newArgs);
        }
    });
    return $a368ca6f900f7a8d$export$dfb5619354ba860(newTasks, callback);
}
// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
class $a368ca6f900f7a8d$var$DLL {
    constructor(){
        this.head = this.tail = null;
        this.length = 0;
    }
    removeLink(node) {
        if (node.prev) node.prev.next = node.next;
        else this.head = node.next;
        if (node.next) node.next.prev = node.prev;
        else this.tail = node.prev;
        node.prev = node.next = null;
        this.length -= 1;
        return node;
    }
    empty() {
        while(this.head)this.shift();
        return this;
    }
    insertAfter(node, newNode) {
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next) node.next.prev = newNode;
        else this.tail = newNode;
        node.next = newNode;
        this.length += 1;
    }
    insertBefore(node, newNode) {
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev) node.prev.next = newNode;
        else this.head = newNode;
        node.prev = newNode;
        this.length += 1;
    }
    unshift(node) {
        if (this.head) this.insertBefore(this.head, node);
        else $a368ca6f900f7a8d$var$setInitial(this, node);
    }
    push(node) {
        if (this.tail) this.insertAfter(this.tail, node);
        else $a368ca6f900f7a8d$var$setInitial(this, node);
    }
    shift() {
        return this.head && this.removeLink(this.head);
    }
    pop() {
        return this.tail && this.removeLink(this.tail);
    }
    toArray() {
        return [
            ...this
        ];
    }
    *[Symbol.iterator]() {
        var cur = this.head;
        while(cur){
            yield cur.data;
            cur = cur.next;
        }
    }
    remove(testFn) {
        var curr = this.head;
        while(curr){
            var { next: next } = curr;
            if (testFn(curr)) this.removeLink(curr);
            curr = next;
        }
        return this;
    }
}
function $a368ca6f900f7a8d$var$setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}
function $a368ca6f900f7a8d$var$queue$1(worker, concurrency, payload) {
    if (concurrency == null) concurrency = 1;
    else if (concurrency === 0) throw new RangeError('Concurrency must not be zero');
    var _worker = $a368ca6f900f7a8d$var$wrapAsync(worker);
    var numRunning = 0;
    var workersList = [];
    const events = {
        error: [],
        drain: [],
        saturated: [],
        unsaturated: [],
        empty: []
    };
    function on(event, handler) {
        events[event].push(handler);
    }
    function once(event, handler) {
        const handleAndRemove = (...args)=>{
            off(event, handleAndRemove);
            handler(...args);
        };
        events[event].push(handleAndRemove);
    }
    function off(event, handler) {
        if (!event) return Object.keys(events).forEach((ev)=>events[ev] = []);
        if (!handler) return events[event] = [];
        events[event] = events[event].filter((ev)=>ev !== handler);
    }
    function trigger(event, ...args) {
        events[event].forEach((handler)=>handler(...args));
    }
    var processingScheduled = false;
    function _insert(data, insertAtFront, rejectOnError, callback) {
        if (callback != null && typeof callback !== 'function') throw new Error('task callback must be a function');
        q.started = true;
        var res, rej;
        function promiseCallback(err, ...args) {
            // we don't care about the error, let the global error handler
            // deal with it
            if (err) return rejectOnError ? rej(err) : res();
            if (args.length <= 1) return res(args[0]);
            res(args);
        }
        var item = q._createTaskItem(data, rejectOnError ? promiseCallback : callback || promiseCallback);
        if (insertAtFront) q._tasks.unshift(item);
        else q._tasks.push(item);
        if (!processingScheduled) {
            processingScheduled = true;
            $a368ca6f900f7a8d$export$c233f08fbfea0913(()=>{
                processingScheduled = false;
                q.process();
            });
        }
        if (rejectOnError || !callback) return new Promise((resolve, reject)=>{
            res = resolve;
            rej = reject;
        });
    }
    function _createCB(tasks) {
        return function(err, ...args) {
            numRunning -= 1;
            for(var i = 0, l = tasks.length; i < l; i++){
                var task = tasks[i];
                var index = workersList.indexOf(task);
                if (index === 0) workersList.shift();
                else if (index > 0) workersList.splice(index, 1);
                task.callback(err, ...args);
                if (err != null) trigger('error', err, task.data);
            }
            if (numRunning <= q.concurrency - q.buffer) trigger('unsaturated');
            if (q.idle()) trigger('drain');
            q.process();
        };
    }
    function _maybeDrain(data) {
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            $a368ca6f900f7a8d$export$c233f08fbfea0913(()=>trigger('drain'));
            return true;
        }
        return false;
    }
    const eventMethod = (name)=>(handler)=>{
            if (!handler) return new Promise((resolve, reject)=>{
                once(name, (err, data)=>{
                    if (err) return reject(err);
                    resolve(data);
                });
            });
            off(name);
            on(name, handler);
        };
    var isProcessing = false;
    var q = {
        _tasks: new $a368ca6f900f7a8d$var$DLL(),
        _createTaskItem (data, callback) {
            return {
                data: data,
                callback: callback
            };
        },
        *[Symbol.iterator] () {
            yield* q._tasks[Symbol.iterator]();
        },
        concurrency: concurrency,
        payload: payload,
        buffer: concurrency / 4,
        started: false,
        paused: false,
        push (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, false, false, callback));
            }
            return _insert(data, false, false, callback);
        },
        pushAsync (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, false, true, callback));
            }
            return _insert(data, false, true, callback);
        },
        kill () {
            off();
            q._tasks.empty();
        },
        unshift (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, true, false, callback));
            }
            return _insert(data, true, false, callback);
        },
        unshiftAsync (data, callback) {
            if (Array.isArray(data)) {
                if (_maybeDrain(data)) return;
                return data.map((datum)=>_insert(datum, true, true, callback));
            }
            return _insert(data, true, true, callback);
        },
        remove (testFn) {
            q._tasks.remove(testFn);
        },
        process () {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) return;
            isProcessing = true;
            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                var tasks = [], data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for(var i = 0; i < l; i++){
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }
                numRunning += 1;
                if (q._tasks.length === 0) trigger('empty');
                if (numRunning === q.concurrency) trigger('saturated');
                var cb = $a368ca6f900f7a8d$var$onlyOnce(_createCB(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length () {
            return q._tasks.length;
        },
        running () {
            return numRunning;
        },
        workersList () {
            return workersList;
        },
        idle () {
            return q._tasks.length + numRunning === 0;
        },
        pause () {
            q.paused = true;
        },
        resume () {
            if (q.paused === false) return;
            q.paused = false;
            $a368ca6f900f7a8d$export$c233f08fbfea0913(q.process);
        }
    };
    // define these as fixed properties, so people get useful errors when updating
    Object.defineProperties(q, {
        saturated: {
            writable: false,
            value: eventMethod('saturated')
        },
        unsaturated: {
            writable: false,
            value: eventMethod('unsaturated')
        },
        empty: {
            writable: false,
            value: eventMethod('empty')
        },
        drain: {
            writable: false,
            value: eventMethod('drain')
        },
        error: {
            writable: false,
            value: eventMethod('error')
        }
    });
    return q;
}
/**
 * Creates a `cargo` object with the specified payload. Tasks added to the
 * cargo will be processed altogether (up to the `payload` limit). If the
 * `worker` is in progress, the task is queued until it becomes available. Once
 * the `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, cargo passes an array of tasks to a single worker, repeating
 * when the worker is finished.
 *
 * @name cargo
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.QueueObject} A cargo object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargo and inner queue.
 * @example
 *
 * // create a cargo object with payload 2
 * var cargo = async.cargo(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2);
 *
 * // add some items
 * cargo.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargo.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * await cargo.push({name: 'baz'});
 * console.log('finished processing baz');
 */ function $a368ca6f900f7a8d$export$f9549d7e5aef7637(worker, payload) {
    return $a368ca6f900f7a8d$var$queue$1(worker, 1, payload);
}
/**
 * Creates a `cargoQueue` object with the specified payload. Tasks added to the
 * cargoQueue will be processed together (up to the `payload` limit) in `concurrency` parallel workers.
 * If the all `workers` are in progress, the task is queued until one becomes available. Once
 * a `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, and [`cargo`]{@link module:ControlFlow.cargo} passes an array of tasks to a single worker,
 * the cargoQueue passes an array of tasks to multiple parallel workers.
 *
 * @name cargoQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @see [async.cargo]{@link module:ControlFLow.cargo}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.QueueObject} A cargoQueue object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargoQueue and inner queue.
 * @example
 *
 * // create a cargoQueue object with payload 2 and concurrency 2
 * var cargoQueue = async.cargoQueue(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2, 2);
 *
 * // add some items
 * cargoQueue.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargoQueue.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * cargoQueue.push({name: 'baz'}, function(err) {
 *     console.log('finished processing baz');
 * });
 * cargoQueue.push({name: 'boo'}, function(err) {
 *     console.log('finished processing boo');
 * });
 */ function $a368ca6f900f7a8d$export$687de40d137ed486(worker, concurrency, payload) {
    return $a368ca6f900f7a8d$var$queue$1(worker, concurrency, payload);
}
/**
 * Reduces `coll` into a single value using an async `iteratee` to return each
 * successive step. `memo` is the initial state of the reduction. This function
 * only operates in series.
 *
 * For performance reasons, it may make sense to split a call to this function
 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
 * results. This function is for situations where each step in the reduction
 * needs to be async; if you can get the data before reducing it, then it's
 * probably a good idea to do so.
 *
 * @name reduce
 * @static
 * @memberOf module:Collections
 * @method
 * @alias inject
 * @alias foldl
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee completes with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file3.txt', 'file4.txt'];
 *
 * // asynchronous function that computes the file size in bytes
 * // file size is added to the memoized value, then returned
 * function getFileSizeInBytes(memo, file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, memo + stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.reduce(fileList, 0, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // 6000
 *         // which is the sum of the file sizes of the three files
 *     }
 * });
 *
 * // Error Handling
 * async.reduce(withMissingFileList, 0, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(result);
 *     }
 * });
 *
 * // Using Promises
 * async.reduce(fileList, 0, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 *     // 6000
 *     // which is the sum of the file sizes of the three files
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.reduce(withMissingFileList, 0, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.reduce(fileList, 0, getFileSizeInBytes);
 *         console.log(result);
 *         // 6000
 *         // which is the sum of the file sizes of the three files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let result = await async.reduce(withMissingFileList, 0, getFileSizeInBytes);
 *         console.log(result);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$reduce(coll, memo, iteratee, callback) {
    callback = $a368ca6f900f7a8d$var$once(callback);
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$export$750e7e5fea3b0654(coll, (x, i, iterCb)=>{
        _iteratee(memo, x, (err, v)=>{
            memo = v;
            iterCb(err);
        });
    }, (err)=>callback(err, memo));
}
var $a368ca6f900f7a8d$export$50ae948ca12cdcbc = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$reduce, 4);
/**
 * Version of the compose function that is more natural to read. Each function
 * consumes the return value of the previous function. It is the equivalent of
 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name seq
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.compose]{@link module:ControlFlow.compose}
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} a function that composes the `functions` in order
 * @example
 *
 * // Requires lodash (or underscore), express3 and dresende's orm2.
 * // Part of an app, that fetches cats of the logged user.
 * // This example uses `seq` function to avoid overnesting and error
 * // handling clutter.
 * app.get('/cats', function(request, response) {
 *     var User = request.models.User;
 *     async.seq(
 *         User.get.bind(User),  // 'User.get' has signature (id, callback(err, data))
 *         function(user, fn) {
 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
 *         }
 *     )(req.session.user_id, function (err, cats) {
 *         if (err) {
 *             console.error(err);
 *             response.json({ status: 'error', message: err.message });
 *         } else {
 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
 *         }
 *     });
 * });
 */ function $a368ca6f900f7a8d$export$1041d4276c328e4d(...functions) {
    var _functions = functions.map($a368ca6f900f7a8d$var$wrapAsync);
    return function(...args) {
        var that = this;
        var cb = args[args.length - 1];
        if (typeof cb == 'function') args.pop();
        else cb = $a368ca6f900f7a8d$var$promiseCallback();
        $a368ca6f900f7a8d$export$50ae948ca12cdcbc(_functions, args, (newargs, fn, iterCb)=>{
            fn.apply(that, newargs.concat((err, ...nextargs)=>{
                iterCb(err, nextargs);
            }));
        }, (err, results)=>cb(err, ...results));
        return cb[$a368ca6f900f7a8d$var$PROMISE_SYMBOL];
    };
}
/**
 * Creates a function which is a composition of the passed asynchronous
 * functions. Each function consumes the return value of the function that
 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
 *
 * If the last argument to the composed function is not a function, a promise
 * is returned when you call it.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name compose
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} an asynchronous function that is the composed
 * asynchronous `functions`
 * @example
 *
 * function add1(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n + 1);
 *     }, 10);
 * }
 *
 * function mul3(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n * 3);
 *     }, 10);
 * }
 *
 * var add1mul3 = async.compose(mul3, add1);
 * add1mul3(4, function (err, result) {
 *     // result now equals 15
 * });
 */ function $a368ca6f900f7a8d$export$f672e0b6f7222cd7(...args) {
    return $a368ca6f900f7a8d$export$1041d4276c328e4d(...args.reverse());
}
/**
 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
 *
 * @name mapLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$mapLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_asyncMap($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$6a28d19bcc59197c = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$mapLimit, 4);
/**
 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
 *
 * @name concatLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @alias flatMapLimit
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$concatLimit(coll, limit, iteratee, callback) {
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$export$6a28d19bcc59197c(coll, limit, (val, iterCb)=>{
        _iteratee(val, (err, ...args)=>{
            if (err) return iterCb(err);
            return iterCb(err, args);
        });
    }, (err, mapResults)=>{
        var result = [];
        for(var i = 0; i < mapResults.length; i++)if (mapResults[i]) result = result.concat(...mapResults[i]);
        return callback(err, result);
    });
}
var $a368ca6f900f7a8d$export$4f1520afe59a31db = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$concatLimit, 4);
/**
 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
 * the concatenated list. The `iteratee`s are called in parallel, and the
 * results are concatenated as they return. The results array will be returned in
 * the original order of `coll` passed to the `iteratee` function.
 *
 * @name concat
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @alias flatMap
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * let directoryList = ['dir1','dir2','dir3'];
 * let withMissingDirectoryList = ['dir1','dir2','dir3', 'dir4'];
 *
 * // Using callbacks
 * async.concat(directoryList, fs.readdir, function(err, results) {
 *    if (err) {
 *        console.log(err);
 *    } else {
 *        console.log(results);
 *        // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 *    }
 * });
 *
 * // Error Handling
 * async.concat(withMissingDirectoryList, fs.readdir, function(err, results) {
 *    if (err) {
 *        console.log(err);
 *        // [ Error: ENOENT: no such file or directory ]
 *        // since dir4 does not exist
 *    } else {
 *        console.log(results);
 *    }
 * });
 *
 * // Using Promises
 * async.concat(directoryList, fs.readdir)
 * .then(results => {
 *     console.log(results);
 *     // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 * }).catch(err => {
 *      console.log(err);
 * });
 *
 * // Error Handling
 * async.concat(withMissingDirectoryList, fs.readdir)
 * .then(results => {
 *     console.log(results);
 * }).catch(err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4 does not exist
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.concat(directoryList, fs.readdir);
 *         console.log(results);
 *         // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
 *     } catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let results = await async.concat(withMissingDirectoryList, fs.readdir);
 *         console.log(results);
 *     } catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4 does not exist
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$concat(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$4f1520afe59a31db(coll, Infinity, iteratee, callback);
}
var $a368ca6f900f7a8d$export$ee1b3e54f0441b22 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$concat, 3);
/**
 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
 *
 * @name concatSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @alias flatMapSeries
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
 * The iteratee should complete with an array an array of results.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @returns A Promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$concatSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$4f1520afe59a31db(coll, 1, iteratee, callback);
}
var $a368ca6f900f7a8d$export$b6df61d74da01b63 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$concatSeries, 3);
/**
 * Returns a function that when called, calls-back with the values provided.
 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
 * [`auto`]{@link module:ControlFlow.auto}.
 *
 * @name constant
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {...*} arguments... - Any number of arguments to automatically invoke
 * callback with.
 * @returns {AsyncFunction} Returns a function that when invoked, automatically
 * invokes the callback with the previous given arguments.
 * @example
 *
 * async.waterfall([
 *     async.constant(42),
 *     function (value, next) {
 *         // value === 42
 *     },
 *     //...
 * ], callback);
 *
 * async.waterfall([
 *     async.constant(filename, "utf8"),
 *     fs.readFile,
 *     function (fileData, next) {
 *         //...
 *     }
 *     //...
 * ], callback);
 *
 * async.auto({
 *     hostname: async.constant("https://server.net/"),
 *     port: findFreePort,
 *     launchServer: ["hostname", "port", function (options, cb) {
 *         startServer(options, cb);
 *     }],
 *     //...
 * }, callback);
 */ function $a368ca6f900f7a8d$export$c983f826f44ff86(...args) {
    return function(...ignoredArgs /*, callback*/ ) {
        var callback = ignoredArgs.pop();
        return callback(null, ...args);
    };
}
function $a368ca6f900f7a8d$var$_createTester(check, getResult) {
    return (eachfn, arr, _iteratee, cb)=>{
        var testPassed = false;
        var testResult;
        const iteratee = $a368ca6f900f7a8d$var$wrapAsync(_iteratee);
        eachfn(arr, (value, _, callback)=>{
            iteratee(value, (err, result)=>{
                if (err || err === false) return callback(err);
                if (check(result) && !testResult) {
                    testPassed = true;
                    testResult = getResult(true, value);
                    return callback(null, $a368ca6f900f7a8d$var$breakLoop);
                }
                callback();
            });
        }, (err)=>{
            if (err) return cb(err);
            cb(null, testPassed ? testResult : getResult(false));
        });
    };
}
/**
 * Returns the first value in `coll` that passes an async truth test. The
 * `iteratee` is applied in parallel, meaning the first iteratee to return
 * `true` will fire the detect `callback` with that result. That means the
 * result might not be the first item in the original `coll` (in terms of order)
 * that passes the test.

 * If order within the original `coll` is important, then look at
 * [`detectSeries`]{@link module:Collections.detectSeries}.
 *
 * @name detect
 * @static
 * @memberOf module:Collections
 * @method
 * @alias find
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // dir1/file1.txt
 *        // result now equals the first file in the list that exists
 *    }
 *);
 *
 * // Using Promises
 * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists)
 * .then(result => {
 *     console.log(result);
 *     // dir1/file1.txt
 *     // result now equals the first file in the list that exists
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists);
 *         console.log(result);
 *         // dir1/file1.txt
 *         // result now equals the file in the list that exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$detect(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>bool, (res, item)=>item)($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$17b446b869dad473 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$detect, 3);
/**
 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name detectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findLimit
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$detectLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>bool, (res, item)=>item)($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$922bcf02f3a5b284 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$detectLimit, 4);
/**
 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
 *
 * @name detectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findSeries
 * @category Collections
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$detectSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>bool, (res, item)=>item)($a368ca6f900f7a8d$var$eachOfLimit$2(1), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$922a9a31d0cff2ee = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$detectSeries, 3);
function $a368ca6f900f7a8d$var$consoleFunc(name) {
    return (fn, ...args)=>$a368ca6f900f7a8d$var$wrapAsync(fn)(...args, (err, ...resultArgs)=>{
            /* istanbul ignore else */ if (typeof console === 'object') {
                /* istanbul ignore else */ if (err) /* istanbul ignore else */ {
                    if (console.error) console.error(err);
                } else if (console[name]) resultArgs.forEach((x)=>console[name](x));
            }
        });
}
/**
 * Logs the result of an [`async` function]{@link AsyncFunction} to the
 * `console` using `console.dir` to display the properties of the resulting object.
 * Only works in Node.js or in browsers that support `console.dir` and
 * `console.error` (such as FF and Chrome).
 * If multiple arguments are returned from the async function,
 * `console.dir` is called on each argument in order.
 *
 * @name dir
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, {hello: name});
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.dir(hello, 'world');
 * {hello: 'world'}
 */ var $a368ca6f900f7a8d$export$147ec2801e896265 = $a368ca6f900f7a8d$var$consoleFunc('dir');
/**
 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
 * the order of operations, the arguments `test` and `iteratee` are switched.
 *
 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
 *
 * @name doWhilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - A function which is called each time `test`
 * passes. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform after each
 * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped.
 * `callback` will be passed an error and any arguments passed to the final
 * `iteratee`'s callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$doWhilst(iteratee, test, callback) {
    callback = $a368ca6f900f7a8d$var$onlyOnce(callback);
    var _fn = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    var _test = $a368ca6f900f7a8d$var$wrapAsync(test);
    var results;
    function next(err, ...args) {
        if (err) return callback(err);
        if (err === false) return;
        results = args;
        _test(...args, check);
    }
    function check(err, truth) {
        if (err) return callback(err);
        if (err === false) return;
        if (!truth) return callback(null, ...results);
        _fn(next);
    }
    return check(null, true);
}
var $a368ca6f900f7a8d$export$df0899fd4acbef10 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$doWhilst, 3);
/**
 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
 * argument ordering differs from `until`.
 *
 * @name doUntil
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform after each
 * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `iteratee`
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$export$16f3a0560cc13fb4(iteratee, test, callback) {
    const _test = $a368ca6f900f7a8d$var$wrapAsync(test);
    return $a368ca6f900f7a8d$export$df0899fd4acbef10(iteratee, (...args)=>{
        const cb = args.pop();
        _test(...args, (err, truth)=>cb(err, !truth));
    }, callback);
}
function $a368ca6f900f7a8d$var$_withoutIndex(iteratee) {
    return (value, index, callback)=>iteratee(value, callback);
}
/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
 * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
 *
 * // asynchronous function that deletes a file
 * const deleteFile = function(file, callback) {
 *     fs.unlink(file, callback);
 * };
 *
 * // Using callbacks
 * async.each(fileList, deleteFile, function(err) {
 *     if( err ) {
 *         console.log(err);
 *     } else {
 *         console.log('All files have been deleted successfully');
 *     }
 * });
 *
 * // Error Handling
 * async.each(withMissingFileList, deleteFile, function(err){
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using Promises
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         await async.each(files, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         await async.each(withMissingFileList, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4/file2.txt does not exist
 *         // dir1/file1.txt could have been deleted
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$eachLimit$2(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$d10d68e43a57bce9(coll, $a368ca6f900f7a8d$var$_withoutIndex($a368ca6f900f7a8d$var$wrapAsync(iteratee)), callback);
}
var $a368ca6f900f7a8d$export$79b2f7037acddd43 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachLimit$2, 3);
/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$eachLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$eachOfLimit$2(limit)(coll, $a368ca6f900f7a8d$var$_withoutIndex($a368ca6f900f7a8d$var$wrapAsync(iteratee)), callback);
}
var $a368ca6f900f7a8d$export$2a2080ddac50d6b8 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachLimit, 4);
/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * Note, that unlike [`each`]{@link module:Collections.each}, this function applies iteratee to each item
 * in series and therefore the iteratee functions will complete in order.

 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */ function $a368ca6f900f7a8d$var$eachSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$2a2080ddac50d6b8(coll, 1, iteratee, callback);
}
var $a368ca6f900f7a8d$export$9bd663f1fadd104c = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$eachSeries, 3);
/**
 * Wrap an async function and ensure it calls its callback on a later tick of
 * the event loop.  If the function already calls its callback on a next tick,
 * no extra deferral is added. This is useful for preventing stack overflows
 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
 * contained. ES2017 `async` functions are returned as-is -- they are immune
 * to Zalgo's corrupting influences, as they always resolve on a later tick.
 *
 * @name ensureAsync
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - an async function, one that expects a node-style
 * callback as its last argument.
 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
 * signature as the function passed in.
 * @example
 *
 * function sometimesAsync(arg, callback) {
 *     if (cache[arg]) {
 *         return callback(null, cache[arg]); // this would be synchronous!!
 *     } else {
 *         doSomeIO(arg, callback); // this IO would be asynchronous
 *     }
 * }
 *
 * // this has a risk of stack overflows if many results are cached in a row
 * async.mapSeries(args, sometimesAsync, done);
 *
 * // this will defer sometimesAsync's callback if necessary,
 * // preventing stack overflows
 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
 */ function $a368ca6f900f7a8d$export$85d5b9ccf228381c(fn) {
    if ($a368ca6f900f7a8d$var$isAsync(fn)) return fn;
    return function(...args /*, callback*/ ) {
        var callback = args.pop();
        var sync = true;
        args.push((...innerArgs)=>{
            if (sync) $a368ca6f900f7a8d$export$c233f08fbfea0913(()=>callback(...innerArgs));
            else callback(...innerArgs);
        });
        fn.apply(this, args);
        sync = false;
    };
}
/**
 * Returns `true` if every element in `coll` satisfies an async test. If any
 * iteratee call returns `false`, the main `callback` is immediately called.
 *
 * @name every
 * @static
 * @memberOf module:Collections
 * @method
 * @alias all
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file5.txt'];
 * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.every(fileList, fileExists, function(err, result) {
 *     console.log(result);
 *     // true
 *     // result is true since every file exists
 * });
 *
 * async.every(withMissingFileList, fileExists, function(err, result) {
 *     console.log(result);
 *     // false
 *     // result is false since NOT every file exists
 * });
 *
 * // Using Promises
 * async.every(fileList, fileExists)
 * .then( result => {
 *     console.log(result);
 *     // true
 *     // result is true since every file exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * async.every(withMissingFileList, fileExists)
 * .then( result => {
 *     console.log(result);
 *     // false
 *     // result is false since NOT every file exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.every(fileList, fileExists);
 *         console.log(result);
 *         // true
 *         // result is true since every file exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * async () => {
 *     try {
 *         let result = await async.every(withMissingFileList, fileExists);
 *         console.log(result);
 *         // false
 *         // result is false since NOT every file exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$every(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>!bool, (res)=>!res)($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$84bf76cd7afc7469 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$every, 3);
/**
 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
 *
 * @name everyLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$everyLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>!bool, (res)=>!res)($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$5b469f316a3f1415 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$everyLimit, 4);
/**
 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
 *
 * @name everySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in series.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$everySeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester((bool)=>!bool, (res)=>!res)($a368ca6f900f7a8d$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$c4a4adf74205a63d = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$everySeries, 3);
function $a368ca6f900f7a8d$var$filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, (x, index, iterCb)=>{
        iteratee(x, (err, v)=>{
            truthValues[index] = !!v;
            iterCb(err);
        });
    }, (err)=>{
        if (err) return callback(err);
        var results = [];
        for(var i = 0; i < arr.length; i++)if (truthValues[i]) results.push(arr[i]);
        callback(null, results);
    });
}
function $a368ca6f900f7a8d$var$filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, (x, index, iterCb)=>{
        iteratee(x, (err, v)=>{
            if (err) return iterCb(err);
            if (v) results.push({
                index: index,
                value: x
            });
            iterCb(err);
        });
    }, (err)=>{
        if (err) return callback(err);
        callback(null, results.sort((a, b)=>a.index - b.index).map((v)=>v.value));
    });
}
function $a368ca6f900f7a8d$var$_filter(eachfn, coll, iteratee, callback) {
    var filter = $a368ca6f900f7a8d$var$isArrayLike(coll) ? $a368ca6f900f7a8d$var$filterArray : $a368ca6f900f7a8d$var$filterGeneric;
    return filter(eachfn, coll, $a368ca6f900f7a8d$var$wrapAsync(iteratee), callback);
}
/**
 * Returns a new array of all the values in `coll` which pass an async truth
 * test. This operation is performed in parallel, but the results array will be
 * in the same order as the original.
 *
 * @name filter
 * @static
 * @memberOf module:Collections
 * @method
 * @alias select
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * const files = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.filter(files, fileExists, function(err, results) {
 *    if(err) {
 *        console.log(err);
 *    } else {
 *        console.log(results);
 *        // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *        // results is now an array of the existing files
 *    }
 * });
 *
 * // Using Promises
 * async.filter(files, fileExists)
 * .then(results => {
 *     console.log(results);
 *     // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *     // results is now an array of the existing files
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.filter(files, fileExists);
 *         console.log(results);
 *         // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
 *         // results is now an array of the existing files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$filter(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_filter($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$3dea766d36a8935f = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$filter, 3);
/**
 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name filterLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$filterLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_filter($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$6a93acd3681313ac = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$filterLimit, 4);
/**
 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
 *
 * @name filterSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results)
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$filterSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_filter($a368ca6f900f7a8d$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$ddcc38daaa46257c = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$filterSeries, 3);
/**
 * Calls the asynchronous function `fn` with a callback parameter that allows it
 * to call itself again, in series, indefinitely.

 * If an error is passed to the callback then `errback` is called with the
 * error, and execution stops, otherwise it will never be called.
 *
 * @name forever
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} fn - an async function to call repeatedly.
 * Invoked with (next).
 * @param {Function} [errback] - when `fn` passes an error to it's callback,
 * this function will be called, and execution stops. Invoked with (err).
 * @returns {Promise} a promise that rejects if an error occurs and an errback
 * is not passed
 * @example
 *
 * async.forever(
 *     function(next) {
 *         // next is suitable for passing to things that need a callback(err [, whatever]);
 *         // it will result in this function being called again.
 *     },
 *     function(err) {
 *         // if next is called with a value in its first parameter, it will appear
 *         // in here as 'err', and execution will stop.
 *     }
 * );
 */ function $a368ca6f900f7a8d$var$forever(fn, errback) {
    var done = $a368ca6f900f7a8d$var$onlyOnce(errback);
    var task = $a368ca6f900f7a8d$var$wrapAsync($a368ca6f900f7a8d$export$85d5b9ccf228381c(fn));
    function next(err) {
        if (err) return done(err);
        if (err === false) return;
        task(next);
    }
    return next();
}
var $a368ca6f900f7a8d$export$116a0f7f2303acd8 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$forever, 2);
/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
 *
 * @name groupByLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$groupByLimit(coll, limit, iteratee, callback) {
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$export$6a28d19bcc59197c(coll, limit, (val, iterCb)=>{
        _iteratee(val, (err, key)=>{
            if (err) return iterCb(err);
            return iterCb(err, {
                key: key,
                val: val
            });
        });
    }, (err, mapResults)=>{
        var result = {};
        // from MDN, handle object having an `hasOwnProperty` prop
        var { hasOwnProperty: hasOwnProperty } = Object.prototype;
        for(var i = 0; i < mapResults.length; i++)if (mapResults[i]) {
            var { key: key } = mapResults[i];
            var { val: val } = mapResults[i];
            if (hasOwnProperty.call(result, key)) result[key].push(val);
            else result[key] = [
                val
            ];
        }
        return callback(err, result);
    });
}
var $a368ca6f900f7a8d$export$335ad4c8e8977a4b = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$groupByLimit, 4);
/**
 * Returns a new object, where each value corresponds to an array of items, from
 * `coll`, that returned the corresponding key. That is, the keys of the object
 * correspond to the values passed to the `iteratee` callback.
 *
 * Note: Since this function applies the `iteratee` to each item in parallel,
 * there is no guarantee that the `iteratee` functions will complete in order.
 * However, the values for each key in the `result` will be in the same order as
 * the original `coll`. For Objects, the values will roughly be in the order of
 * the original Objects' keys (but this can vary across JavaScript engines).
 *
 * @name groupBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const files = ['dir1/file1.txt','dir2','dir4']
 *
 * // asynchronous function that detects file type as none, file, or directory
 * function detectFile(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(null, 'none');
 *         }
 *         callback(null, stat.isDirectory() ? 'directory' : 'file');
 *     });
 * }
 *
 * //Using callbacks
 * async.groupBy(files, detectFile, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *	       console.log(result);
 *         // {
 *         //     file: [ 'dir1/file1.txt' ],
 *         //     none: [ 'dir4' ],
 *         //     directory: [ 'dir2']
 *         // }
 *         // result is object containing the files grouped by type
 *     }
 * });
 *
 * // Using Promises
 * async.groupBy(files, detectFile)
 * .then( result => {
 *     console.log(result);
 *     // {
 *     //     file: [ 'dir1/file1.txt' ],
 *     //     none: [ 'dir4' ],
 *     //     directory: [ 'dir2']
 *     // }
 *     // result is object containing the files grouped by type
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.groupBy(files, detectFile);
 *         console.log(result);
 *         // {
 *         //     file: [ 'dir1/file1.txt' ],
 *         //     none: [ 'dir4' ],
 *         //     directory: [ 'dir2']
 *         // }
 *         // result is object containing the files grouped by type
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$3f063810d7bf01bd(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$335ad4c8e8977a4b(coll, Infinity, iteratee, callback);
}
/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
 *
 * @name groupBySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whose
 * properties are arrays of values which returned the corresponding key.
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$export$d0689f2b629adbdb(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$export$335ad4c8e8977a4b(coll, 1, iteratee, callback);
}
/**
 * Logs the result of an `async` function to the `console`. Only works in
 * Node.js or in browsers that support `console.log` and `console.error` (such
 * as FF and Chrome). If multiple arguments are returned from the async
 * function, `console.log` is called on each argument in order.
 *
 * @name log
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, 'hello ' + name);
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.log(hello, 'world');
 * 'hello world'
 */ var $a368ca6f900f7a8d$export$bef1f36f5486a6a3 = $a368ca6f900f7a8d$var$consoleFunc('log');
/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name mapValuesLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$mapValuesLimit(obj, limit, iteratee, callback) {
    callback = $a368ca6f900f7a8d$var$once(callback);
    var newObj = {};
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$var$eachOfLimit$2(limit)(obj, (val, key, next)=>{
        _iteratee(val, key, (err, result)=>{
            if (err) return next(err);
            newObj[key] = result;
            next(err);
        });
    }, (err)=>callback(err, newObj));
}
var $a368ca6f900f7a8d$export$d5d82430c6fa645f = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$mapValuesLimit, 4);
/**
 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
 *
 * Produces a new Object by mapping each value of `obj` through the `iteratee`
 * function. The `iteratee` is called each `value` and `key` from `obj` and a
 * callback for when it has finished processing. Each of these callbacks takes
 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
 * passes an error to its callback, the main `callback` (for the `mapValues`
 * function) is immediately called with the error.
 *
 * Note, the order of the keys in the result is not guaranteed.  The keys will
 * be roughly in the order they complete, (but this is very engine-specific)
 *
 * @name mapValues
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 * // file4.txt does not exist
 *
 * const fileMap = {
 *     f1: 'file1.txt',
 *     f2: 'file2.txt',
 *     f3: 'file3.txt'
 * };
 *
 * const withMissingFileMap = {
 *     f1: 'file1.txt',
 *     f2: 'file2.txt',
 *     f3: 'file4.txt'
 * };
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, key, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.mapValues(fileMap, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // result is now a map of file size in bytes for each file, e.g.
 *         // {
 *         //     f1: 1000,
 *         //     f2: 2000,
 *         //     f3: 3000
 *         // }
 *     }
 * });
 *
 * // Error handling
 * async.mapValues(withMissingFileMap, getFileSizeInBytes, function(err, result) {
 *     if (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     } else {
 *         console.log(result);
 *     }
 * });
 *
 * // Using Promises
 * async.mapValues(fileMap, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 *     // result is now a map of file size in bytes for each file, e.g.
 *     // {
 *     //     f1: 1000,
 *     //     f2: 2000,
 *     //     f3: 3000
 *     // }
 * }).catch (err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.mapValues(withMissingFileMap, getFileSizeInBytes)
 * .then( result => {
 *     console.log(result);
 * }).catch (err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.mapValues(fileMap, getFileSizeInBytes);
 *         console.log(result);
 *         // result is now a map of file size in bytes for each file, e.g.
 *         // {
 *         //     f1: 1000,
 *         //     f2: 2000,
 *         //     f3: 3000
 *         // }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         let result = await async.mapValues(withMissingFileMap, getFileSizeInBytes);
 *         console.log(result);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$825e789796ab7275(obj, iteratee, callback) {
    return $a368ca6f900f7a8d$export$d5d82430c6fa645f(obj, Infinity, iteratee, callback);
}
/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
 *
 * @name mapValuesSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$export$8fbd16e43ec40b44(obj, iteratee, callback) {
    return $a368ca6f900f7a8d$export$d5d82430c6fa645f(obj, 1, iteratee, callback);
}
/**
 * Caches the results of an async function. When creating a hash to store
 * function results against, the callback is omitted from the hash and an
 * optional hash function can be used.
 *
 * **Note: if the async function errs, the result will not be cached and
 * subsequent calls will call the wrapped function.**
 *
 * If no hash function is specified, the first argument is used as a hash key,
 * which may work reasonably if it is a string or a data type that converts to a
 * distinct string. Note that objects and arrays will not behave reasonably.
 * Neither will cases where the other arguments are significant. In such cases,
 * specify your own hash function.
 *
 * The cache of results is exposed as the `memo` property of the function
 * returned by `memoize`.
 *
 * @name memoize
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
 * @param {Function} hasher - An optional function for generating a custom hash
 * for storing results. It has all the arguments applied to it apart from the
 * callback, and must be synchronous.
 * @returns {AsyncFunction} a memoized version of `fn`
 * @example
 *
 * var slow_fn = function(name, callback) {
 *     // do something
 *     callback(null, result);
 * };
 * var fn = async.memoize(slow_fn);
 *
 * // fn can now be used as if it were slow_fn
 * fn('some name', function() {
 *     // callback
 * });
 */ function $a368ca6f900f7a8d$export$fc10aeed3a532e2a(fn, hasher = (v)=>v) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    var _fn = $a368ca6f900f7a8d$var$wrapAsync(fn);
    var memoized = $a368ca6f900f7a8d$var$initialParams((args, callback)=>{
        var key = hasher(...args);
        if (key in memo) $a368ca6f900f7a8d$export$c233f08fbfea0913(()=>callback(null, ...memo[key]));
        else if (key in queues) queues[key].push(callback);
        else {
            queues[key] = [
                callback
            ];
            _fn(...args, (err, ...resultArgs)=>{
                // #1465 don't memoize if an error occurred
                if (!err) memo[key] = resultArgs;
                var q = queues[key];
                delete queues[key];
                for(var i = 0, l = q.length; i < l; i++)q[i](err, ...resultArgs);
            });
        }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
}
/* istanbul ignore file */ /**
 * Calls `callback` on a later loop around the event loop. In Node.js this just
 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
 * available, otherwise `setTimeout(callback, 0)`, which means other higher
 * priority events may precede the execution of `callback`.
 *
 * This is used internally for browser-compatibility purposes.
 *
 * @name nextTick
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.setImmediate]{@link module:Utils.setImmediate}
 * @category Util
 * @param {Function} callback - The function to call on a later loop around
 * the event loop. Invoked with (args...).
 * @param {...*} args... - any number of additional arguments to pass to the
 * callback on the next tick.
 * @example
 *
 * var call_order = [];
 * async.nextTick(function() {
 *     call_order.push('two');
 *     // call_order now equals ['one','two']
 * });
 * call_order.push('one');
 *
 * async.setImmediate(function (a, b, c) {
 *     // a, b, and c equal 1, 2, and 3
 * }, 1, 2, 3);
 */ var $a368ca6f900f7a8d$var$_defer;
if ($a368ca6f900f7a8d$var$hasNextTick) $a368ca6f900f7a8d$var$_defer = $jOTJ0.nextTick;
else if ($a368ca6f900f7a8d$var$hasSetImmediate) $a368ca6f900f7a8d$var$_defer = setImmediate;
else $a368ca6f900f7a8d$var$_defer = $a368ca6f900f7a8d$var$fallback;
var $a368ca6f900f7a8d$export$bdd553fddd433dcb = $a368ca6f900f7a8d$var$wrap($a368ca6f900f7a8d$var$_defer);
var $a368ca6f900f7a8d$var$_parallel = $a368ca6f900f7a8d$var$awaitify((eachfn, tasks, callback)=>{
    var results = $a368ca6f900f7a8d$var$isArrayLike(tasks) ? [] : {};
    eachfn(tasks, (task, key, taskCb)=>{
        $a368ca6f900f7a8d$var$wrapAsync(task)((err, ...result)=>{
            if (result.length < 2) [result] = result;
            results[key] = result;
            taskCb(err);
        });
    }, (err)=>callback(err, results));
}, 3);
/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 *
 * @example
 *
 * //Using Callbacks
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two'] even though
 *     // the second function had a shorter timeout.
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.parallel([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two'] even though
 *         // the second function had a shorter timeout.
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$451942af9381149c(tasks, callback) {
    return $a368ca6f900f7a8d$var$_parallel($a368ca6f900f7a8d$export$d10d68e43a57bce9, tasks, callback);
}
/**
 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name parallelLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.parallel]{@link module:ControlFlow.parallel}
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 * @returns {Promise} a promise, if a callback is not passed
 */ function $a368ca6f900f7a8d$export$362c0a688af131a0(tasks, limit, callback) {
    return $a368ca6f900f7a8d$var$_parallel($a368ca6f900f7a8d$var$eachOfLimit$2(limit), tasks, callback);
}
/**
 * A queue of tasks for the worker function to complete.
 * @typedef {Iterable} QueueObject
 * @memberOf module:ControlFlow
 * @property {Function} length - a function returning the number of items
 * waiting to be processed. Invoke with `queue.length()`.
 * @property {boolean} started - a boolean indicating whether or not any
 * items have been pushed and processed by the queue.
 * @property {Function} running - a function returning the number of items
 * currently being processed. Invoke with `queue.running()`.
 * @property {Function} workersList - a function returning the array of items
 * currently being processed. Invoke with `queue.workersList()`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
 * @property {number} concurrency - an integer for determining how many `worker`
 * functions should be run in parallel. This property can be changed after a
 * `queue` is created to alter the concurrency on-the-fly.
 * @property {number} payload - an integer that specifies how many items are
 * passed to the worker function at a time. only applies if this is a
 * [cargo]{@link module:ControlFlow.cargo} object
 * @property {AsyncFunction} push - add a new task to the `queue`. Calls `callback`
 * once the `worker` has finished processing the task. Instead of a single task,
 * a `tasks` array can be submitted. The respective callback is used for every
 * task in the list. Invoke with `queue.push(task, [callback])`,
 * @property {AsyncFunction} unshift - add a new task to the front of the `queue`.
 * Invoke with `queue.unshift(task, [callback])`.
 * @property {AsyncFunction} pushAsync - the same as `q.push`, except this returns
 * a promise that rejects if an error occurs.
 * @property {AsyncFunction} unshiftAsync - the same as `q.unshift`, except this returns
 * a promise that rejects if an error occurs.
 * @property {Function} remove - remove items from the queue that match a test
 * function.  The test function will be passed an object with a `data` property,
 * and a `priority` property, if this is a
 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
 * `function ({data, priority}) {}` and returns a Boolean.
 * @property {Function} saturated - a function that sets a callback that is
 * called when the number of running workers hits the `concurrency` limit, and
 * further tasks will be queued.  If the callback is omitted, `q.saturated()`
 * returns a promise for the next occurrence.
 * @property {Function} unsaturated - a function that sets a callback that is
 * called when the number of running workers is less than the `concurrency` &
 * `buffer` limits, and further tasks will not be queued. If the callback is
 * omitted, `q.unsaturated()` returns a promise for the next occurrence.
 * @property {number} buffer - A minimum threshold buffer in order to say that
 * the `queue` is `unsaturated`.
 * @property {Function} empty - a function that sets a callback that is called
 * when the last item from the `queue` is given to a `worker`. If the callback
 * is omitted, `q.empty()` returns a promise for the next occurrence.
 * @property {Function} drain - a function that sets a callback that is called
 * when the last item from the `queue` has returned from the `worker`. If the
 * callback is omitted, `q.drain()` returns a promise for the next occurrence.
 * @property {Function} error - a function that sets a callback that is called
 * when a task errors. Has the signature `function(error, task)`. If the
 * callback is omitted, `error()` returns a promise that rejects on the next
 * error.
 * @property {boolean} paused - a boolean for determining whether the queue is
 * in a paused state.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke with `queue.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. No more tasks
 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
 *
 * @example
 * const q = async.queue(worker, 2)
 * q.push(item1)
 * q.push(item2)
 * q.push(item3)
 * // queues are iterable, spread into an array to inspect
 * const items = [...q] // [item1, item2, item3]
 * // or use for of
 * for (let item of q) {
 *     console.log(item)
 * }
 *
 * q.drain(() => {
 *     console.log('all done')
 * })
 * // or
 * await q.drain()
 */ /**
 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
 * `queue` are processed in parallel (up to the `concurrency` limit). If all
 * `worker`s are in progress, the task is queued until one becomes available.
 * Once a `worker` completes a `task`, that `task`'s callback is called.
 *
 * @name queue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`. Invoked with (task, callback).
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can be
 * attached as certain properties to listen for specific events during the
 * lifecycle of the queue.
 * @example
 *
 * // create a queue object with concurrency 2
 * var q = async.queue(function(task, callback) {
 *     console.log('hello ' + task.name);
 *     callback();
 * }, 2);
 *
 * // assign a callback
 * q.drain(function() {
 *     console.log('all items have been processed');
 * });
 * // or await the end
 * await q.drain()
 *
 * // assign an error callback
 * q.error(function(err, task) {
 *     console.error('task experienced an error');
 * });
 *
 * // add some items to the queue
 * q.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * // callback is optional
 * q.push({name: 'bar'});
 *
 * // add some items to the queue (batch-wise)
 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
 *     console.log('finished processing item');
 * });
 *
 * // add some items to the front of the queue
 * q.unshift({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 */ function $a368ca6f900f7a8d$export$4f7fa46ff53e516f(worker, concurrency) {
    var _worker = $a368ca6f900f7a8d$var$wrapAsync(worker);
    return $a368ca6f900f7a8d$var$queue$1((items, cb)=>{
        _worker(items[0], cb);
    }, concurrency, 1);
}
// Binary min-heap implementation used for priority queue.
// Implementation is stable, i.e. push time is considered for equal priorities
class $a368ca6f900f7a8d$var$Heap {
    constructor(){
        this.heap = [];
        this.pushCount = Number.MIN_SAFE_INTEGER;
    }
    get length() {
        return this.heap.length;
    }
    empty() {
        this.heap = [];
        return this;
    }
    percUp(index) {
        let p;
        while(index > 0 && $a368ca6f900f7a8d$var$smaller(this.heap[index], this.heap[p = $a368ca6f900f7a8d$var$parent(index)])){
            let t = this.heap[index];
            this.heap[index] = this.heap[p];
            this.heap[p] = t;
            index = p;
        }
    }
    percDown(index) {
        let l;
        while((l = $a368ca6f900f7a8d$var$leftChi(index)) < this.heap.length){
            if (l + 1 < this.heap.length && $a368ca6f900f7a8d$var$smaller(this.heap[l + 1], this.heap[l])) l = l + 1;
            if ($a368ca6f900f7a8d$var$smaller(this.heap[index], this.heap[l])) break;
            let t = this.heap[index];
            this.heap[index] = this.heap[l];
            this.heap[l] = t;
            index = l;
        }
    }
    push(node) {
        node.pushCount = ++this.pushCount;
        this.heap.push(node);
        this.percUp(this.heap.length - 1);
    }
    unshift(node) {
        return this.heap.push(node);
    }
    shift() {
        let [top] = this.heap;
        this.heap[0] = this.heap[this.heap.length - 1];
        this.heap.pop();
        this.percDown(0);
        return top;
    }
    toArray() {
        return [
            ...this
        ];
    }
    *[Symbol.iterator]() {
        for(let i = 0; i < this.heap.length; i++)yield this.heap[i].data;
    }
    remove(testFn) {
        let j = 0;
        for(let i = 0; i < this.heap.length; i++)if (!testFn(this.heap[i])) {
            this.heap[j] = this.heap[i];
            j++;
        }
        this.heap.splice(j);
        for(let i = $a368ca6f900f7a8d$var$parent(this.heap.length - 1); i >= 0; i--)this.percDown(i);
        return this;
    }
}
function $a368ca6f900f7a8d$var$leftChi(i) {
    return (i << 1) + 1;
}
function $a368ca6f900f7a8d$var$parent(i) {
    return (i + 1 >> 1) - 1;
}
function $a368ca6f900f7a8d$var$smaller(x, y) {
    if (x.priority !== y.priority) return x.priority < y.priority;
    else return x.pushCount < y.pushCount;
}
/**
 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
 * completed in ascending priority order.
 *
 * @name priorityQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`.
 * Invoked with (task, callback).
 * @param {number} concurrency - An `integer` for determining how many `worker`
 * functions should be run in parallel.  If omitted, the concurrency defaults to
 * `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are three
 * differences between `queue` and `priorityQueue` objects:
 * * `push(task, priority, [callback])` - `priority` should be a number. If an
 *   array of `tasks` is given, all tasks will be assigned the same priority.
 * * `pushAsync(task, priority, [callback])` - the same as `priorityQueue.push`,
 *   except this returns a promise that rejects if an error occurs.
 * * The `unshift` and `unshiftAsync` methods were removed.
 */ function $a368ca6f900f7a8d$export$25579debde666a98(worker, concurrency) {
    // Start with a normal queue
    var q = $a368ca6f900f7a8d$export$4f7fa46ff53e516f(worker, concurrency);
    var { push: push, pushAsync: pushAsync } = q;
    q._tasks = new $a368ca6f900f7a8d$var$Heap();
    q._createTaskItem = ({ data: data, priority: priority }, callback)=>{
        return {
            data: data,
            priority: priority,
            callback: callback
        };
    };
    function createDataItems(tasks, priority) {
        if (!Array.isArray(tasks)) return {
            data: tasks,
            priority: priority
        };
        return tasks.map((data)=>{
            return {
                data: data,
                priority: priority
            };
        });
    }
    // Override push to accept second parameter representing priority
    q.push = function(data, priority = 0, callback) {
        return push(createDataItems(data, priority), callback);
    };
    q.pushAsync = function(data, priority = 0, callback) {
        return pushAsync(createDataItems(data, priority), callback);
    };
    // Remove unshift functions
    delete q.unshift;
    delete q.unshiftAsync;
    return q;
}
/**
 * Runs the `tasks` array of functions in parallel, without waiting until the
 * previous function has completed. Once any of the `tasks` complete or pass an
 * error to its callback, the main `callback` is immediately called. It's
 * equivalent to `Promise.race()`.
 *
 * @name race
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
 * to run. Each function can complete with an optional `result` value.
 * @param {Function} callback - A callback to run once any of the functions have
 * completed. This function gets an error or result from the first function that
 * completed. Invoked with (err, result).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * async.race([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // main callback
 * function(err, result) {
 *     // the result will be equal to 'two' as it finishes earlier
 * });
 */ function $a368ca6f900f7a8d$var$race(tasks, callback) {
    callback = $a368ca6f900f7a8d$var$once(callback);
    if (!Array.isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
    if (!tasks.length) return callback();
    for(var i = 0, l = tasks.length; i < l; i++)$a368ca6f900f7a8d$var$wrapAsync(tasks[i])(callback);
}
var $a368ca6f900f7a8d$export$236c05de452bec2 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$race, 2);
/**
 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
 *
 * @name reduceRight
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reduce]{@link module:Collections.reduce}
 * @alias foldr
 * @category Collection
 * @param {Array} array - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee completes with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$export$a11cb61c36c4a4cf(array, memo, iteratee, callback) {
    var reversed = [
        ...array
    ].reverse();
    return $a368ca6f900f7a8d$export$50ae948ca12cdcbc(reversed, memo, iteratee, callback);
}
/**
 * Wraps the async function in another function that always completes with a
 * result object, even when it errors.
 *
 * The result object has either the property `error` or `value`.
 *
 * @name reflect
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function you want to wrap
 * @returns {Function} - A function that always passes null to it's callback as
 * the error. The second argument to the callback will be an `object` with
 * either an `error` or a `value` property.
 * @example
 *
 * async.parallel([
 *     async.reflect(function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff but error ...
 *         callback('bad stuff happened');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     })
 * ],
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = 'bad stuff happened'
 *     // results[2].value = 'two'
 * });
 */ function $a368ca6f900f7a8d$export$9debe8cffacea23(fn) {
    var _fn = $a368ca6f900f7a8d$var$wrapAsync(fn);
    return $a368ca6f900f7a8d$var$initialParams(function reflectOn(args, reflectCallback) {
        args.push((error, ...cbArgs)=>{
            let retVal = {};
            if (error) retVal.error = error;
            if (cbArgs.length > 0) {
                var value = cbArgs;
                if (cbArgs.length <= 1) [value] = cbArgs;
                retVal.value = value;
            }
            reflectCallback(null, retVal);
        });
        return _fn.apply(this, args);
    });
}
/**
 * A helper function that wraps an array or an object of functions with `reflect`.
 *
 * @name reflectAll
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.reflect]{@link module:Utils.reflect}
 * @category Util
 * @param {Array|Object|Iterable} tasks - The collection of
 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
 * @returns {Array} Returns an array of async functions, each wrapped in
 * `async.reflect`
 * @example
 *
 * let tasks = [
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         // do some more stuff but error ...
 *         callback(new Error('bad stuff happened'));
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ];
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = Error('bad stuff happened')
 *     // results[2].value = 'two'
 * });
 *
 * // an example using an object instead of an array
 * let tasks = {
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         callback('two');
 *     },
 *     three: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'three');
 *         }, 100);
 *     }
 * };
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results.one.value = 'one'
 *     // results.two.error = 'two'
 *     // results.three.value = 'three'
 * });
 */ function $a368ca6f900f7a8d$export$1a54554d0a489acc(tasks) {
    var results;
    if (Array.isArray(tasks)) results = tasks.map($a368ca6f900f7a8d$export$9debe8cffacea23);
    else {
        results = {};
        Object.keys(tasks).forEach((key)=>{
            results[key] = $a368ca6f900f7a8d$export$9debe8cffacea23.call(this, tasks[key]);
        });
    }
    return results;
}
function $a368ca6f900f7a8d$var$reject$2(eachfn, arr, _iteratee, callback) {
    const iteratee = $a368ca6f900f7a8d$var$wrapAsync(_iteratee);
    return $a368ca6f900f7a8d$var$_filter(eachfn, arr, (value, cb)=>{
        iteratee(value, (err, v)=>{
            cb(err, !v);
        });
    }, callback);
}
/**
 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
 *
 * @name reject
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 *
 * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.reject(fileList, fileExists, function(err, results) {
 *    // [ 'dir3/file6.txt' ]
 *    // results now equals an array of the non-existing files
 * });
 *
 * // Using Promises
 * async.reject(fileList, fileExists)
 * .then( results => {
 *     console.log(results);
 *     // [ 'dir3/file6.txt' ]
 *     // results now equals an array of the non-existing files
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let results = await async.reject(fileList, fileExists);
 *         console.log(results);
 *         // [ 'dir3/file6.txt' ]
 *         // results now equals an array of the non-existing files
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$reject(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$reject$2($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$2800f3ceda99eb84 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$reject, 3);
/**
 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name rejectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$rejectLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$reject$2($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$b59d647fa1894da8 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$rejectLimit, 4);
/**
 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
 *
 * @name rejectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback is passed
 */ function $a368ca6f900f7a8d$var$rejectSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$reject$2($a368ca6f900f7a8d$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$d68373657532124d = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$rejectSeries, 3);
function $a368ca6f900f7a8d$var$constant(value) {
    return function() {
        return value;
    };
}
/**
 * Attempts to get a successful response from `task` no more than `times` times
 * before returning an error. If the task is successful, the `callback` will be
 * passed the result of the successful task. If all attempts fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name retry
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @see [async.retryable]{@link module:ControlFlow.retryable}
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
 * object with `times` and `interval` or a number.
 * * `times` - The number of attempts to make before giving up.  The default
 *   is `5`.
 * * `interval` - The time to wait between retries, in milliseconds.  The
 *   default is `0`. The interval may also be specified as a function of the
 *   retry count (see example).
 * * `errorFilter` - An optional synchronous function that is invoked on
 *   erroneous result. If it returns `true` the retry attempts will continue;
 *   if the function returns `false` the retry flow is aborted with the current
 *   attempt's error and result being returned to the final callback.
 *   Invoked with (err).
 * * If `opts` is a number, the number specifies the number of times to retry,
 *   with the default interval of `0`.
 * @param {AsyncFunction} task - An async function to retry.
 * Invoked with (callback).
 * @param {Function} [callback] - An optional callback which is called when the
 * task has succeeded, or after the final failed attempt. It receives the `err`
 * and `result` arguments of the last attempt at completing the `task`. Invoked
 * with (err, results).
 * @returns {Promise} a promise if no callback provided
 *
 * @example
 *
 * // The `retry` function can be used as a stand-alone control flow by passing
 * // a callback, as shown below:
 *
 * // try calling apiMethod 3 times
 * async.retry(3, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 3 times, waiting 200 ms between each retry
 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 10 times with exponential backoff
 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
 * async.retry({
 *   times: 10,
 *   interval: function(retryCount) {
 *     return 50 * Math.pow(2, retryCount);
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod the default 5 times no delay between each retry
 * async.retry(apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod only when error condition satisfies, all other
 * // errors will abort the retry control flow and return to final callback
 * async.retry({
 *   errorFilter: function(err) {
 *     return err.message === 'Temporary error'; // only retry on a specific error
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // to retry individual methods that are not as reliable within other
 * // control flow functions, use the `retryable` wrapper:
 * async.auto({
 *     users: api.getUsers.bind(api),
 *     payments: async.retryable(3, api.getPayments.bind(api))
 * }, function(err, results) {
 *     // do something with the results
 * });
 *
 */ const $a368ca6f900f7a8d$var$DEFAULT_TIMES = 5;
const $a368ca6f900f7a8d$var$DEFAULT_INTERVAL = 0;
function $a368ca6f900f7a8d$export$9369b12211e1fce4(opts, task, callback) {
    var options = {
        times: $a368ca6f900f7a8d$var$DEFAULT_TIMES,
        intervalFunc: $a368ca6f900f7a8d$var$constant($a368ca6f900f7a8d$var$DEFAULT_INTERVAL)
    };
    if (arguments.length < 3 && typeof opts === 'function') {
        callback = task || $a368ca6f900f7a8d$var$promiseCallback();
        task = opts;
    } else {
        $a368ca6f900f7a8d$var$parseTimes(options, opts);
        callback = callback || $a368ca6f900f7a8d$var$promiseCallback();
    }
    if (typeof task !== 'function') throw new Error("Invalid arguments for async.retry");
    var _task = $a368ca6f900f7a8d$var$wrapAsync(task);
    var attempt = 1;
    function retryAttempt() {
        _task((err, ...args)=>{
            if (err === false) return;
            if (err && attempt++ < options.times && (typeof options.errorFilter != 'function' || options.errorFilter(err))) setTimeout(retryAttempt, options.intervalFunc(attempt - 1));
            else callback(err, ...args);
        });
    }
    retryAttempt();
    return callback[$a368ca6f900f7a8d$var$PROMISE_SYMBOL];
}
function $a368ca6f900f7a8d$var$parseTimes(acc, t) {
    if (typeof t === 'object') {
        acc.times = +t.times || $a368ca6f900f7a8d$var$DEFAULT_TIMES;
        acc.intervalFunc = typeof t.interval === 'function' ? t.interval : $a368ca6f900f7a8d$var$constant(+t.interval || $a368ca6f900f7a8d$var$DEFAULT_INTERVAL);
        acc.errorFilter = t.errorFilter;
    } else if (typeof t === 'number' || typeof t === 'string') acc.times = +t || $a368ca6f900f7a8d$var$DEFAULT_TIMES;
    else throw new Error("Invalid arguments for async.retry");
}
/**
 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
 * wraps a task and makes it retryable, rather than immediately calling it
 * with retries.
 *
 * @name retryable
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.retry]{@link module:ControlFlow.retry}
 * @category Control Flow
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
 * options, exactly the same as from `retry`, except for a `opts.arity` that
 * is the arity of the `task` function, defaulting to `task.length`
 * @param {AsyncFunction} task - the asynchronous function to wrap.
 * This function will be passed any arguments passed to the returned wrapper.
 * Invoked with (...args, callback).
 * @returns {AsyncFunction} The wrapped function, which when invoked, will
 * retry on an error, based on the parameters specified in `opts`.
 * This function will accept the same parameters as `task`.
 * @example
 *
 * async.auto({
 *     dep1: async.retryable(3, getFromFlakyService),
 *     process: ["dep1", async.retryable(3, function (results, cb) {
 *         maybeProcessData(results.dep1, cb);
 *     })]
 * }, callback);
 */ function $a368ca6f900f7a8d$export$9e1b8e833f44ff21(opts, task) {
    if (!task) {
        task = opts;
        opts = null;
    }
    let arity = opts && opts.arity || task.length;
    if ($a368ca6f900f7a8d$var$isAsync(task)) arity += 1;
    var _task = $a368ca6f900f7a8d$var$wrapAsync(task);
    return $a368ca6f900f7a8d$var$initialParams((args, callback)=>{
        if (args.length < arity - 1 || callback == null) {
            args.push(callback);
            callback = $a368ca6f900f7a8d$var$promiseCallback();
        }
        function taskFn(cb) {
            _task(...args, cb);
        }
        if (opts) $a368ca6f900f7a8d$export$9369b12211e1fce4(opts, taskFn, callback);
        else $a368ca6f900f7a8d$export$9369b12211e1fce4(taskFn, callback);
        return callback[$a368ca6f900f7a8d$var$PROMISE_SYMBOL];
    });
}
/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @return {Promise} a promise, if no callback is passed
 * @example
 *
 * //Using Callbacks
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * });
 *
 * // an example using objects instead of arrays
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.series([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$7589597339a0562d(tasks, callback) {
    return $a368ca6f900f7a8d$var$_parallel($a368ca6f900f7a8d$export$750e7e5fea3b0654, tasks, callback);
}
/**
 * Returns `true` if at least one element in the `coll` satisfies an async test.
 * If any iteratee call returns `true`, the main `callback` is immediately
 * called.
 *
 * @name some
 * @static
 * @memberOf module:Collections
 * @method
 * @alias any
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * // asynchronous function that checks if a file exists
 * function fileExists(file, callback) {
 *    fs.access(file, fs.constants.F_OK, (err) => {
 *        callback(null, !err);
 *    });
 * }
 *
 * // Using callbacks
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // true
 *        // result is true since some file in the list exists
 *    }
 *);
 *
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists,
 *    function(err, result) {
 *        console.log(result);
 *        // false
 *        // result is false since none of the files exists
 *    }
 *);
 *
 * // Using Promises
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists)
 * .then( result => {
 *     console.log(result);
 *     // true
 *     // result is true since some file in the list exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists)
 * .then( result => {
 *     console.log(result);
 *     // false
 *     // result is false since none of the files exists
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists);
 *         console.log(result);
 *         // true
 *         // result is true since some file in the list exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * async () => {
 *     try {
 *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists);
 *         console.log(result);
 *         // false
 *         // result is false since none of the files exists
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$some(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester(Boolean, (res)=>res)($a368ca6f900f7a8d$export$d10d68e43a57bce9, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$4154a199d7d90455 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$some, 3);
/**
 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
 *
 * @name someLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anyLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$someLimit(coll, limit, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester(Boolean, (res)=>res)($a368ca6f900f7a8d$var$eachOfLimit$2(limit), coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$97c6076dd161c251 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$someLimit, 4);
/**
 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
 *
 * @name someSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anySeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in series.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 */ function $a368ca6f900f7a8d$var$someSeries(coll, iteratee, callback) {
    return $a368ca6f900f7a8d$var$_createTester(Boolean, (res)=>res)($a368ca6f900f7a8d$export$750e7e5fea3b0654, coll, iteratee, callback);
}
var $a368ca6f900f7a8d$export$728f30d6f8df8331 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$someSeries, 3);
/**
 * Sorts a list by the results of running each `coll` value through an async
 * `iteratee`.
 *
 * @name sortBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a value to use as the sort criteria as
 * its `result`.
 * Invoked with (item, callback).
 * @param {Function} callback - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is the items
 * from the original `coll` sorted by the values returned by the `iteratee`
 * calls. Invoked with (err, results).
 * @returns {Promise} a promise, if no callback passed
 * @example
 *
 * // bigfile.txt is a file that is 251100 bytes in size
 * // mediumfile.txt is a file that is 11000 bytes in size
 * // smallfile.txt is a file that is 121 bytes in size
 *
 * // asynchronous function that returns the file size in bytes
 * function getFileSizeInBytes(file, callback) {
 *     fs.stat(file, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         callback(null, stat.size);
 *     });
 * }
 *
 * // Using callbacks
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes,
 *     function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *         }
 *     }
 * );
 *
 * // By modifying the callback parameter the
 * // sorting order can be influenced:
 *
 * // ascending order
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], function(file, callback) {
 *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
 *         if (getFileSizeErr) return callback(getFileSizeErr);
 *         callback(null, fileSize);
 *     });
 * }, function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *         }
 *     }
 * );
 *
 * // descending order
 * async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], function(file, callback) {
 *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
 *         if (getFileSizeErr) {
 *             return callback(getFileSizeErr);
 *         }
 *         callback(null, fileSize * -1);
 *     });
 * }, function(err, results) {
 *         if (err) {
 *             console.log(err);
 *         } else {
 *             console.log(results);
 *             // results is now the original array of files sorted by
 *             // file size (ascending by default), e.g.
 *             // [ 'bigfile.txt', 'mediumfile.txt', 'smallfile.txt']
 *         }
 *     }
 * );
 *
 * // Error handling
 * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes,
 *     function(err, results) {
 *         if (err) {
 *             console.log(err);
 *             // [ Error: ENOENT: no such file or directory ]
 *         } else {
 *             console.log(results);
 *         }
 *     }
 * );
 *
 * // Using Promises
 * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 *     // results is now the original array of files sorted by
 *     // file size (ascending by default), e.g.
 *     // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error handling
 * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes)
 * .then( results => {
 *     console.log(results);
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 * });
 *
 * // Using async/await
 * (async () => {
 *     try {
 *         let results = await async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
 *         console.log(results);
 *         // results is now the original array of files sorted by
 *         // file size (ascending by default), e.g.
 *         // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * })();
 *
 * // Error handling
 * async () => {
 *     try {
 *         let results = await async.sortBy(['missingfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
 *         console.log(results);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$var$sortBy(coll, iteratee, callback) {
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$export$871de8747c9eaa88(coll, (x, iterCb)=>{
        _iteratee(x, (err, criteria)=>{
            if (err) return iterCb(err);
            iterCb(err, {
                value: x,
                criteria: criteria
            });
        });
    }, (err, results)=>{
        if (err) return callback(err);
        callback(null, results.sort(comparator).map((v)=>v.value));
    });
    function comparator(left, right) {
        var a = left.criteria, b = right.criteria;
        return a < b ? -1 : a > b ? 1 : 0;
    }
}
var $a368ca6f900f7a8d$export$b035e44d7bb4278f = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$sortBy, 3);
/**
 * Sets a time limit on an asynchronous function. If the function does not call
 * its callback within the specified milliseconds, it will be called with a
 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
 *
 * @name timeout
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} asyncFn - The async function to limit in time.
 * @param {number} milliseconds - The specified time limit.
 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
 * to timeout Error for more information..
 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
 * of the control flow functions.
 * Invoke this function with the same parameters as you would `asyncFunc`.
 * @example
 *
 * function myFunction(foo, callback) {
 *     doAsyncTask(foo, function(err, data) {
 *         // handle errors
 *         if (err) return callback(err);
 *
 *         // do some stuff ...
 *
 *         // return processed data
 *         return callback(null, data);
 *     });
 * }
 *
 * var wrapped = async.timeout(myFunction, 1000);
 *
 * // call `wrapped` as you would `myFunction`
 * wrapped({ bar: 'bar' }, function(err, data) {
 *     // if `myFunction` takes < 1000 ms to execute, `err`
 *     // and `data` will have their expected values
 *
 *     // else `err` will be an Error with the code 'ETIMEDOUT'
 * });
 */ function $a368ca6f900f7a8d$export$83e74882c5df8fe1(asyncFn, milliseconds, info) {
    var fn = $a368ca6f900f7a8d$var$wrapAsync(asyncFn);
    return $a368ca6f900f7a8d$var$initialParams((args, callback)=>{
        var timedOut = false;
        var timer;
        function timeoutCallback() {
            var name = asyncFn.name || 'anonymous';
            var error = new Error('Callback function "' + name + '" timed out.');
            error.code = 'ETIMEDOUT';
            if (info) error.info = info;
            timedOut = true;
            callback(error);
        }
        args.push((...cbArgs)=>{
            if (!timedOut) {
                callback(...cbArgs);
                clearTimeout(timer);
            }
        });
        // setup timer and call original function
        timer = setTimeout(timeoutCallback, milliseconds);
        fn(...args);
    });
}
function $a368ca6f900f7a8d$var$range(size) {
    var result = Array(size);
    while(size--)result[size] = size;
    return result;
}
/**
 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name timesLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} count - The number of times to run the function.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 */ function $a368ca6f900f7a8d$export$5ebd4c84811c422b(count, limit, iteratee, callback) {
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    return $a368ca6f900f7a8d$export$6a28d19bcc59197c($a368ca6f900f7a8d$var$range(count), limit, _iteratee, callback);
}
/**
 * Calls the `iteratee` function `n` times, and accumulates results in the same
 * manner you would use with [map]{@link module:Collections.map}.
 *
 * @name times
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 * @example
 *
 * // Pretend this is some complicated async factory
 * var createUser = function(id, callback) {
 *     callback(null, {
 *         id: 'user' + id
 *     });
 * };
 *
 * // generate 5 users
 * async.times(5, function(n, next) {
 *     createUser(n, function(err, user) {
 *         next(err, user);
 *     });
 * }, function(err, users) {
 *     // we should now have 5 users
 * });
 */ function $a368ca6f900f7a8d$export$b5bc26e198ce73d0(n, iteratee, callback) {
    return $a368ca6f900f7a8d$export$5ebd4c84811c422b(n, Infinity, iteratee, callback);
}
/**
 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
 *
 * @name timesSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @returns {Promise} a promise, if no callback is provided
 */ function $a368ca6f900f7a8d$export$51c3f8bb1fe6838c(n, iteratee, callback) {
    return $a368ca6f900f7a8d$export$5ebd4c84811c422b(n, 1, iteratee, callback);
}
/**
 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
 * element in parallel, each step potentially mutating an `accumulator` value.
 * The type of the accumulator defaults to the type of collection passed in.
 *
 * @name transform
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
 * it will default to an empty Object or Array, depending on the type of `coll`
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * collection that potentially modifies the accumulator.
 * Invoked with (accumulator, item, key, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the transformed accumulator.
 * Invoked with (err, result).
 * @returns {Promise} a promise, if no callback provided
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 *
 * // helper function that returns human-readable size format from bytes
 * function formatBytes(bytes, decimals = 2) {
 *   // implementation not included for brevity
 *   return humanReadbleFilesize;
 * }
 *
 * const fileList = ['file1.txt','file2.txt','file3.txt'];
 *
 * // asynchronous function that returns the file size, transformed to human-readable format
 * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
 * function transformFileSize(acc, value, key, callback) {
 *     fs.stat(value, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         acc[key] = formatBytes(stat.size);
 *         callback(null);
 *     });
 * }
 *
 * // Using callbacks
 * async.transform(fileList, transformFileSize, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 *     }
 * });
 *
 * // Using Promises
 * async.transform(fileList, transformFileSize)
 * .then(result => {
 *     console.log(result);
 *     // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * (async () => {
 *     try {
 *         let result = await async.transform(fileList, transformFileSize);
 *         console.log(result);
 *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * })();
 *
 * @example
 *
 * // file1.txt is a file that is 1000 bytes in size
 * // file2.txt is a file that is 2000 bytes in size
 * // file3.txt is a file that is 3000 bytes in size
 *
 * // helper function that returns human-readable size format from bytes
 * function formatBytes(bytes, decimals = 2) {
 *   // implementation not included for brevity
 *   return humanReadbleFilesize;
 * }
 *
 * const fileMap = { f1: 'file1.txt', f2: 'file2.txt', f3: 'file3.txt' };
 *
 * // asynchronous function that returns the file size, transformed to human-readable format
 * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
 * function transformFileSize(acc, value, key, callback) {
 *     fs.stat(value, function(err, stat) {
 *         if (err) {
 *             return callback(err);
 *         }
 *         acc[key] = formatBytes(stat.size);
 *         callback(null);
 *     });
 * }
 *
 * // Using callbacks
 * async.transform(fileMap, transformFileSize, function(err, result) {
 *     if(err) {
 *         console.log(err);
 *     } else {
 *         console.log(result);
 *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 *     }
 * });
 *
 * // Using Promises
 * async.transform(fileMap, transformFileSize)
 * .then(result => {
 *     console.log(result);
 *     // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.transform(fileMap, transformFileSize);
 *         console.log(result);
 *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */ function $a368ca6f900f7a8d$export$51186ad6e864892a(coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3 && typeof accumulator === 'function') {
        callback = iteratee;
        iteratee = accumulator;
        accumulator = Array.isArray(coll) ? [] : {};
    }
    callback = $a368ca6f900f7a8d$var$once(callback || $a368ca6f900f7a8d$var$promiseCallback());
    var _iteratee = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    $a368ca6f900f7a8d$export$d10d68e43a57bce9(coll, (v, k, cb)=>{
        _iteratee(accumulator, v, k, cb);
    }, (err)=>callback(err, accumulator));
    return callback[$a368ca6f900f7a8d$var$PROMISE_SYMBOL];
}
/**
 * It runs each task in series but stops whenever any of the functions were
 * successful. If one of the tasks were successful, the `callback` will be
 * passed the result of the successful task. If all tasks fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name tryEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing functions to
 * run, each function is passed a `callback(err, result)` it must call on
 * completion with an error `err` (which can be `null`) and an optional `result`
 * value.
 * @param {Function} [callback] - An optional callback which is called when one
 * of the tasks has succeeded, or all have failed. It receives the `err` and
 * `result` arguments of the last attempt at completing the `task`. Invoked with
 * (err, results).
 * @returns {Promise} a promise, if no callback is passed
 * @example
 * async.tryEach([
 *     function getDataFromFirstWebsite(callback) {
 *         // Try getting the data from the first website
 *         callback(err, data);
 *     },
 *     function getDataFromSecondWebsite(callback) {
 *         // First website failed,
 *         // Try getting the data from the backup website
 *         callback(err, data);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     Now do something with the data.
 * });
 *
 */ function $a368ca6f900f7a8d$var$tryEach(tasks, callback) {
    var error = null;
    var result;
    return $a368ca6f900f7a8d$export$9bd663f1fadd104c(tasks, (task, taskCb)=>{
        $a368ca6f900f7a8d$var$wrapAsync(task)((err, ...args)=>{
            if (err === false) return taskCb(err);
            if (args.length < 2) [result] = args;
            else result = args;
            error = err;
            taskCb(err ? null : {});
        });
    }, ()=>callback(error, result));
}
var $a368ca6f900f7a8d$export$c382910393876e1e = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$tryEach);
/**
 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
 * unmemoized form. Handy for testing.
 *
 * @name unmemoize
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.memoize]{@link module:Utils.memoize}
 * @category Util
 * @param {AsyncFunction} fn - the memoized function
 * @returns {AsyncFunction} a function that calls the original unmemoized function
 */ function $a368ca6f900f7a8d$export$a8183b28ba2fbf41(fn) {
    return (...args)=>{
        return (fn.unmemoized || fn)(...args);
    };
}
/**
 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs.
 *
 * @name whilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `iteratee`. Invoked with (callback).
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if no callback is passed
 * @example
 *
 * var count = 0;
 * async.whilst(
 *     function test(cb) { cb(null, count < 5); },
 *     function iter(callback) {
 *         count++;
 *         setTimeout(function() {
 *             callback(null, count);
 *         }, 1000);
 *     },
 *     function (err, n) {
 *         // 5 seconds have passed, n = 5
 *     }
 * );
 */ function $a368ca6f900f7a8d$var$whilst(test, iteratee, callback) {
    callback = $a368ca6f900f7a8d$var$onlyOnce(callback);
    var _fn = $a368ca6f900f7a8d$var$wrapAsync(iteratee);
    var _test = $a368ca6f900f7a8d$var$wrapAsync(test);
    var results = [];
    function next(err, ...rest) {
        if (err) return callback(err);
        results = rest;
        if (err === false) return;
        _test(check);
    }
    function check(err, truth) {
        if (err) return callback(err);
        if (err === false) return;
        if (!truth) return callback(null, ...results);
        _fn(next);
    }
    return _test(check);
}
var $a368ca6f900f7a8d$export$147085f09cc1931 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$whilst, 3);
/**
 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs. `callback` will be passed an error and any
 * arguments passed to the final `iteratee`'s callback.
 *
 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
 *
 * @name until
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `iteratee`. Invoked with (callback).
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns {Promise} a promise, if a callback is not passed
 *
 * @example
 * const results = []
 * let finished = false
 * async.until(function test(cb) {
 *     cb(null, finished)
 * }, function iter(next) {
 *     fetchPage(url, (err, body) => {
 *         if (err) return next(err)
 *         results = results.concat(body.objects)
 *         finished = !!body.next
 *         next(err)
 *     })
 * }, function done (err) {
 *     // all pages have been fetched
 * })
 */ function $a368ca6f900f7a8d$export$a40009bd2c363351(test, iteratee, callback) {
    const _test = $a368ca6f900f7a8d$var$wrapAsync(test);
    return $a368ca6f900f7a8d$export$147085f09cc1931((cb)=>_test((err, truth)=>cb(err, !truth)), iteratee, callback);
}
/**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */ function $a368ca6f900f7a8d$var$waterfall(tasks, callback) {
    callback = $a368ca6f900f7a8d$var$once(callback);
    if (!Array.isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return callback();
    var taskIndex = 0;
    function nextTask(args) {
        var task = $a368ca6f900f7a8d$var$wrapAsync(tasks[taskIndex++]);
        task(...args, $a368ca6f900f7a8d$var$onlyOnce(next));
    }
    function next(err, ...args) {
        if (err === false) return;
        if (err || taskIndex === tasks.length) return callback(err, ...args);
        nextTask(args);
    }
    nextTask([]);
}
var $a368ca6f900f7a8d$export$981f466e0ef96280 = $a368ca6f900f7a8d$var$awaitify($a368ca6f900f7a8d$var$waterfall);
/**
 * An "async function" in the context of Async is an asynchronous function with
 * a variable number of parameters, with the final parameter being a callback.
 * (`function (arg1, arg2, ..., callback) {}`)
 * The final callback is of the form `callback(err, results...)`, which must be
 * called once the function is completed.  The callback should be called with a
 * Error as its first argument to signal that an error occurred.
 * Otherwise, if no error occurred, it should be called with `null` as the first
 * argument, and any additional `result` arguments that may apply, to signal
 * successful completion.
 * The callback must be called exactly once, ideally on a later tick of the
 * JavaScript event loop.
 *
 * This type of function is also referred to as a "Node-style async function",
 * or a "continuation passing-style function" (CPS). Most of the methods of this
 * library are themselves CPS/Node-style async functions, or functions that
 * return CPS/Node-style async functions.
 *
 * Wherever we accept a Node-style async function, we also directly accept an
 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
 * In this case, the `async` function will not be passed a final callback
 * argument, and any thrown error will be used as the `err` argument of the
 * implicit callback, and the return value will be used as the `result` value.
 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
 * argument, and a `resolved` value becomes the `result`.)
 *
 * Note, due to JavaScript limitations, we can only detect native `async`
 * functions and not transpilied implementations.
 * Your environment must have `async`/`await` support for this to work.
 * (e.g. Node > v7.6, or a recent version of a modern browser).
 * If you are using `async` functions through a transpiler (e.g. Babel), you
 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
 * because the `async function` will be compiled to an ordinary function that
 * returns a promise.
 *
 * @typedef {Function} AsyncFunction
 * @static
 */ var $a368ca6f900f7a8d$export$2e2bcd8739ae039 = {
    apply: $a368ca6f900f7a8d$export$5635d7ef4b8fee1c,
    applyEach: $a368ca6f900f7a8d$export$e0fc6250e304edaf,
    applyEachSeries: $a368ca6f900f7a8d$export$cdb63afc167779e,
    asyncify: $a368ca6f900f7a8d$export$b5d55b15b1db3122,
    auto: $a368ca6f900f7a8d$export$dfb5619354ba860,
    autoInject: $a368ca6f900f7a8d$export$868ec1c38c3c8735,
    cargo: $a368ca6f900f7a8d$export$f9549d7e5aef7637,
    cargoQueue: $a368ca6f900f7a8d$export$687de40d137ed486,
    compose: $a368ca6f900f7a8d$export$f672e0b6f7222cd7,
    concat: $a368ca6f900f7a8d$export$ee1b3e54f0441b22,
    concatLimit: $a368ca6f900f7a8d$export$4f1520afe59a31db,
    concatSeries: $a368ca6f900f7a8d$export$b6df61d74da01b63,
    constant: $a368ca6f900f7a8d$export$c983f826f44ff86,
    detect: $a368ca6f900f7a8d$export$17b446b869dad473,
    detectLimit: $a368ca6f900f7a8d$export$922bcf02f3a5b284,
    detectSeries: $a368ca6f900f7a8d$export$922a9a31d0cff2ee,
    dir: $a368ca6f900f7a8d$export$147ec2801e896265,
    doUntil: $a368ca6f900f7a8d$export$16f3a0560cc13fb4,
    doWhilst: $a368ca6f900f7a8d$export$df0899fd4acbef10,
    each: $a368ca6f900f7a8d$export$79b2f7037acddd43,
    eachLimit: $a368ca6f900f7a8d$export$2a2080ddac50d6b8,
    eachOf: $a368ca6f900f7a8d$export$d10d68e43a57bce9,
    eachOfLimit: $a368ca6f900f7a8d$export$8b05461b96b91438,
    eachOfSeries: $a368ca6f900f7a8d$export$750e7e5fea3b0654,
    eachSeries: $a368ca6f900f7a8d$export$9bd663f1fadd104c,
    ensureAsync: $a368ca6f900f7a8d$export$85d5b9ccf228381c,
    every: $a368ca6f900f7a8d$export$84bf76cd7afc7469,
    everyLimit: $a368ca6f900f7a8d$export$5b469f316a3f1415,
    everySeries: $a368ca6f900f7a8d$export$c4a4adf74205a63d,
    filter: $a368ca6f900f7a8d$export$3dea766d36a8935f,
    filterLimit: $a368ca6f900f7a8d$export$6a93acd3681313ac,
    filterSeries: $a368ca6f900f7a8d$export$ddcc38daaa46257c,
    forever: $a368ca6f900f7a8d$export$116a0f7f2303acd8,
    groupBy: $a368ca6f900f7a8d$export$3f063810d7bf01bd,
    groupByLimit: $a368ca6f900f7a8d$export$335ad4c8e8977a4b,
    groupBySeries: $a368ca6f900f7a8d$export$d0689f2b629adbdb,
    log: $a368ca6f900f7a8d$export$bef1f36f5486a6a3,
    map: $a368ca6f900f7a8d$export$871de8747c9eaa88,
    mapLimit: $a368ca6f900f7a8d$export$6a28d19bcc59197c,
    mapSeries: $a368ca6f900f7a8d$export$9a85c32cda85b0dd,
    mapValues: $a368ca6f900f7a8d$export$825e789796ab7275,
    mapValuesLimit: $a368ca6f900f7a8d$export$d5d82430c6fa645f,
    mapValuesSeries: $a368ca6f900f7a8d$export$8fbd16e43ec40b44,
    memoize: $a368ca6f900f7a8d$export$fc10aeed3a532e2a,
    nextTick: $a368ca6f900f7a8d$export$bdd553fddd433dcb,
    parallel: $a368ca6f900f7a8d$export$451942af9381149c,
    parallelLimit: $a368ca6f900f7a8d$export$362c0a688af131a0,
    priorityQueue: $a368ca6f900f7a8d$export$25579debde666a98,
    queue: $a368ca6f900f7a8d$export$4f7fa46ff53e516f,
    race: $a368ca6f900f7a8d$export$236c05de452bec2,
    reduce: $a368ca6f900f7a8d$export$50ae948ca12cdcbc,
    reduceRight: $a368ca6f900f7a8d$export$a11cb61c36c4a4cf,
    reflect: $a368ca6f900f7a8d$export$9debe8cffacea23,
    reflectAll: $a368ca6f900f7a8d$export$1a54554d0a489acc,
    reject: $a368ca6f900f7a8d$export$2800f3ceda99eb84,
    rejectLimit: $a368ca6f900f7a8d$export$b59d647fa1894da8,
    rejectSeries: $a368ca6f900f7a8d$export$d68373657532124d,
    retry: $a368ca6f900f7a8d$export$9369b12211e1fce4,
    retryable: $a368ca6f900f7a8d$export$9e1b8e833f44ff21,
    seq: $a368ca6f900f7a8d$export$1041d4276c328e4d,
    series: $a368ca6f900f7a8d$export$7589597339a0562d,
    setImmediate: $a368ca6f900f7a8d$export$c233f08fbfea0913,
    some: $a368ca6f900f7a8d$export$4154a199d7d90455,
    someLimit: $a368ca6f900f7a8d$export$97c6076dd161c251,
    someSeries: $a368ca6f900f7a8d$export$728f30d6f8df8331,
    sortBy: $a368ca6f900f7a8d$export$b035e44d7bb4278f,
    timeout: $a368ca6f900f7a8d$export$83e74882c5df8fe1,
    times: $a368ca6f900f7a8d$export$b5bc26e198ce73d0,
    timesLimit: $a368ca6f900f7a8d$export$5ebd4c84811c422b,
    timesSeries: $a368ca6f900f7a8d$export$51c3f8bb1fe6838c,
    transform: $a368ca6f900f7a8d$export$51186ad6e864892a,
    tryEach: $a368ca6f900f7a8d$export$c382910393876e1e,
    unmemoize: $a368ca6f900f7a8d$export$a8183b28ba2fbf41,
    until: $a368ca6f900f7a8d$export$a40009bd2c363351,
    waterfall: $a368ca6f900f7a8d$export$981f466e0ef96280,
    whilst: $a368ca6f900f7a8d$export$147085f09cc1931,
    // aliases
    all: $a368ca6f900f7a8d$export$84bf76cd7afc7469,
    allLimit: $a368ca6f900f7a8d$export$5b469f316a3f1415,
    allSeries: $a368ca6f900f7a8d$export$c4a4adf74205a63d,
    any: $a368ca6f900f7a8d$export$4154a199d7d90455,
    anyLimit: $a368ca6f900f7a8d$export$97c6076dd161c251,
    anySeries: $a368ca6f900f7a8d$export$728f30d6f8df8331,
    find: $a368ca6f900f7a8d$export$17b446b869dad473,
    findLimit: $a368ca6f900f7a8d$export$922bcf02f3a5b284,
    findSeries: $a368ca6f900f7a8d$export$922a9a31d0cff2ee,
    flatMap: $a368ca6f900f7a8d$export$ee1b3e54f0441b22,
    flatMapLimit: $a368ca6f900f7a8d$export$4f1520afe59a31db,
    flatMapSeries: $a368ca6f900f7a8d$export$b6df61d74da01b63,
    forEach: $a368ca6f900f7a8d$export$79b2f7037acddd43,
    forEachSeries: $a368ca6f900f7a8d$export$9bd663f1fadd104c,
    forEachLimit: $a368ca6f900f7a8d$export$2a2080ddac50d6b8,
    forEachOf: $a368ca6f900f7a8d$export$d10d68e43a57bce9,
    forEachOfSeries: $a368ca6f900f7a8d$export$750e7e5fea3b0654,
    forEachOfLimit: $a368ca6f900f7a8d$export$8b05461b96b91438,
    inject: $a368ca6f900f7a8d$export$50ae948ca12cdcbc,
    foldl: $a368ca6f900f7a8d$export$50ae948ca12cdcbc,
    foldr: $a368ca6f900f7a8d$export$a11cb61c36c4a4cf,
    select: $a368ca6f900f7a8d$export$3dea766d36a8935f,
    selectLimit: $a368ca6f900f7a8d$export$6a93acd3681313ac,
    selectSeries: $a368ca6f900f7a8d$export$ddcc38daaa46257c,
    wrapSync: $a368ca6f900f7a8d$export$b5d55b15b1db3122,
    during: $a368ca6f900f7a8d$export$147085f09cc1931,
    doDuring: $a368ca6f900f7a8d$export$df0899fd4acbef10
};

});
parcelRegister("jOTJ0", function(module, exports) {
// shim for using process in browser
var $e6dde9a6c7b22e79$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e6dde9a6c7b22e79$var$cachedSetTimeout;
var $e6dde9a6c7b22e79$var$cachedClearTimeout;
function $e6dde9a6c7b22e79$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e6dde9a6c7b22e79$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e6dde9a6c7b22e79$var$cachedSetTimeout = setTimeout;
        else $e6dde9a6c7b22e79$var$cachedSetTimeout = $e6dde9a6c7b22e79$var$defaultSetTimout;
    } catch (e) {
        $e6dde9a6c7b22e79$var$cachedSetTimeout = $e6dde9a6c7b22e79$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e6dde9a6c7b22e79$var$cachedClearTimeout = clearTimeout;
        else $e6dde9a6c7b22e79$var$cachedClearTimeout = $e6dde9a6c7b22e79$var$defaultClearTimeout;
    } catch (e) {
        $e6dde9a6c7b22e79$var$cachedClearTimeout = $e6dde9a6c7b22e79$var$defaultClearTimeout;
    }
})();
function $e6dde9a6c7b22e79$var$runTimeout(fun) {
    if ($e6dde9a6c7b22e79$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e6dde9a6c7b22e79$var$cachedSetTimeout === $e6dde9a6c7b22e79$var$defaultSetTimout || !$e6dde9a6c7b22e79$var$cachedSetTimeout) && setTimeout) {
        $e6dde9a6c7b22e79$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e6dde9a6c7b22e79$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e6dde9a6c7b22e79$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e6dde9a6c7b22e79$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e6dde9a6c7b22e79$var$runClearTimeout(marker) {
    if ($e6dde9a6c7b22e79$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e6dde9a6c7b22e79$var$cachedClearTimeout === $e6dde9a6c7b22e79$var$defaultClearTimeout || !$e6dde9a6c7b22e79$var$cachedClearTimeout) && clearTimeout) {
        $e6dde9a6c7b22e79$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e6dde9a6c7b22e79$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e6dde9a6c7b22e79$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e6dde9a6c7b22e79$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e6dde9a6c7b22e79$var$queue = [];
var $e6dde9a6c7b22e79$var$draining = false;
var $e6dde9a6c7b22e79$var$currentQueue;
var $e6dde9a6c7b22e79$var$queueIndex = -1;
function $e6dde9a6c7b22e79$var$cleanUpNextTick() {
    if (!$e6dde9a6c7b22e79$var$draining || !$e6dde9a6c7b22e79$var$currentQueue) return;
    $e6dde9a6c7b22e79$var$draining = false;
    if ($e6dde9a6c7b22e79$var$currentQueue.length) $e6dde9a6c7b22e79$var$queue = $e6dde9a6c7b22e79$var$currentQueue.concat($e6dde9a6c7b22e79$var$queue);
    else $e6dde9a6c7b22e79$var$queueIndex = -1;
    if ($e6dde9a6c7b22e79$var$queue.length) $e6dde9a6c7b22e79$var$drainQueue();
}
function $e6dde9a6c7b22e79$var$drainQueue() {
    if ($e6dde9a6c7b22e79$var$draining) return;
    var timeout = $e6dde9a6c7b22e79$var$runTimeout($e6dde9a6c7b22e79$var$cleanUpNextTick);
    $e6dde9a6c7b22e79$var$draining = true;
    var len = $e6dde9a6c7b22e79$var$queue.length;
    while(len){
        $e6dde9a6c7b22e79$var$currentQueue = $e6dde9a6c7b22e79$var$queue;
        $e6dde9a6c7b22e79$var$queue = [];
        while(++$e6dde9a6c7b22e79$var$queueIndex < len)if ($e6dde9a6c7b22e79$var$currentQueue) $e6dde9a6c7b22e79$var$currentQueue[$e6dde9a6c7b22e79$var$queueIndex].run();
        $e6dde9a6c7b22e79$var$queueIndex = -1;
        len = $e6dde9a6c7b22e79$var$queue.length;
    }
    $e6dde9a6c7b22e79$var$currentQueue = null;
    $e6dde9a6c7b22e79$var$draining = false;
    $e6dde9a6c7b22e79$var$runClearTimeout(timeout);
}
$e6dde9a6c7b22e79$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e6dde9a6c7b22e79$var$queue.push(new $e6dde9a6c7b22e79$var$Item(fun, args));
    if ($e6dde9a6c7b22e79$var$queue.length === 1 && !$e6dde9a6c7b22e79$var$draining) $e6dde9a6c7b22e79$var$runTimeout($e6dde9a6c7b22e79$var$drainQueue);
};
// v8 likes predictible objects
function $e6dde9a6c7b22e79$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e6dde9a6c7b22e79$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e6dde9a6c7b22e79$var$process.title = 'browser';
$e6dde9a6c7b22e79$var$process.browser = true;
$e6dde9a6c7b22e79$var$process.env = {};
$e6dde9a6c7b22e79$var$process.argv = [];
$e6dde9a6c7b22e79$var$process.version = ''; // empty string to avoid regexp issues
$e6dde9a6c7b22e79$var$process.versions = {};
function $e6dde9a6c7b22e79$var$noop() {}
$e6dde9a6c7b22e79$var$process.on = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.addListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.once = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.off = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.removeListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.removeAllListeners = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.emit = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.prependListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.prependOnceListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.listeners = function(name) {
    return [];
};
$e6dde9a6c7b22e79$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e6dde9a6c7b22e79$var$process.cwd = function() {
    return '/';
};
$e6dde9a6c7b22e79$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e6dde9a6c7b22e79$var$process.umask = function() {
    return 0;
};

});


parcelRegister("1McdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8q8cf")).default);

var $8q8cf = parcelRequire("8q8cf");

});
parcelRegister("8q8cf", function(module, exports) {

$parcel$export(module.exports, "default", () => $62171c1bb0b5994e$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $6CUay = parcelRequire("6CUay");

var $2KyCl = parcelRequire("2KyCl");

var $ddikI = parcelRequire("ddikI");

var $2hFu1 = parcelRequire("2hFu1");

var $fDlpw = parcelRequire("fDlpw");

var $WrObz = parcelRequire("WrObz");

var $89540 = parcelRequire("89540");

var $ex0UA = parcelRequire("ex0UA");

var $cV5xs = parcelRequire("cV5xs");
var $62171c1bb0b5994e$var$variantComponent = {
    standard: (0, $2KyCl.default),
    filled: (0, $ddikI.default),
    outlined: (0, $2hFu1.default)
};
var $62171c1bb0b5994e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $62171c1bb0b5994e$var$TextField = /*#__PURE__*/ $J42oT.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    if (select && !children) console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    var InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, label, displayRequired && "\xA0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $62171c1bb0b5994e$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $J42oT.createElement(InputComponent, (0, $fXPf9.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $J42oT.createElement((0, $WrObz.default), (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $J42oT.createElement((0, $fDlpw.default), (0, $fXPf9.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $J42oT.createElement((0, $ex0UA.default), (0, $fXPf9.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $J42oT.createElement((0, $89540.default), (0, $fXPf9.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
$62171c1bb0b5994e$var$TextField.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the `input` element will be focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The default value of the `input` element.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the `input` element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label will be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */ FormHelperTextProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The helper text content.
   */ helperText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */ InputLabelProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */ InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $bYG1J.default),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Minimum number of rows to display.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * If `true`, a textarea element will be rendered instead of an input.
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The short hint displayed in the input before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   * @deprecated Use `minRows` instead.
   */ rows: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]), 'Use `minRows` instead'),
    /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */ rowsMax: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]), 'Use `maxRows` instead'),
    /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */ select: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Props applied to the [`Select`](/api/select/) element.
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The size of the text field.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'medium',
        'small'
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $62171c1bb0b5994e$export$2e2bcd8739ae039 = (0, $cV5xs.default)($62171c1bb0b5994e$export$9dd6ff9ea0189349, {
    name: 'MuiTextField'
})($62171c1bb0b5994e$var$TextField);

});
parcelRegister("fXPf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f41d9153bffe9c$export$2e2bcd8739ae039);
function $b9f41d9153bffe9c$export$2e2bcd8739ae039() {
    return $b9f41d9153bffe9c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b9f41d9153bffe9c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cVOSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a24625a424d271$export$2e2bcd8739ae039);

var $bXxv0 = parcelRequire("bXxv0");
function $96a24625a424d271$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bXxv0.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("bXxv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4f309d4ba1468c$export$2e2bcd8739ae039);
function $8b4f309d4ba1468c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("fcOLE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jCWPV = parcelRequire("jCWPV");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $b11f5b63159f3da7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("htQOa"))($jCWPV.isElement, $b11f5b63159f3da7$var$throwOnDirectAccess);

});
parcelRegister("jCWPV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("e7bnU"));

});
parcelRegister("e7bnU", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a46a8ce0ec2a95eb$export$2b8d127b894957b9, (v) => $a46a8ce0ec2a95eb$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a46a8ce0ec2a95eb$export$cea3a54a6425200c, (v) => $a46a8ce0ec2a95eb$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a46a8ce0ec2a95eb$export$a7c73072b1a182ae, (v) => $a46a8ce0ec2a95eb$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a46a8ce0ec2a95eb$export$9f27bc3417b4524d, (v) => $a46a8ce0ec2a95eb$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a46a8ce0ec2a95eb$export$db77ccec0bb4ccac, (v) => $a46a8ce0ec2a95eb$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a46a8ce0ec2a95eb$export$8392c0c9d3dcbd35, (v) => $a46a8ce0ec2a95eb$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a46a8ce0ec2a95eb$export$ffb0004e005737fa, (v) => $a46a8ce0ec2a95eb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a46a8ce0ec2a95eb$export$b624eff549462981, (v) => $a46a8ce0ec2a95eb$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a46a8ce0ec2a95eb$export$7897aa7841a5380c, (v) => $a46a8ce0ec2a95eb$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a46a8ce0ec2a95eb$export$602eac185826482c, (v) => $a46a8ce0ec2a95eb$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a46a8ce0ec2a95eb$export$e2c29f18771995cb, (v) => $a46a8ce0ec2a95eb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a46a8ce0ec2a95eb$export$5f8d39834fd61797, (v) => $a46a8ce0ec2a95eb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a46a8ce0ec2a95eb$export$74bf444e3cd11ea5, (v) => $a46a8ce0ec2a95eb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a46a8ce0ec2a95eb$export$92387174baf9b227, (v) => $a46a8ce0ec2a95eb$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a46a8ce0ec2a95eb$export$ec112efeb987d9c6, (v) => $a46a8ce0ec2a95eb$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a46a8ce0ec2a95eb$export$b706b080d889d2c9, (v) => $a46a8ce0ec2a95eb$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a46a8ce0ec2a95eb$export$5be5a87408f70ddc, (v) => $a46a8ce0ec2a95eb$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a46a8ce0ec2a95eb$export$45a5e7f76e0caa8d, (v) => $a46a8ce0ec2a95eb$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a46a8ce0ec2a95eb$export$455c2e768291efa6, (v) => $a46a8ce0ec2a95eb$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a46a8ce0ec2a95eb$export$9522e17588c12572, (v) => $a46a8ce0ec2a95eb$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a46a8ce0ec2a95eb$export$2110ac352bb060b9, (v) => $a46a8ce0ec2a95eb$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a46a8ce0ec2a95eb$export$56885ab8b9c456ab, (v) => $a46a8ce0ec2a95eb$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a46a8ce0ec2a95eb$export$d927fcb6adf8f9de, (v) => $a46a8ce0ec2a95eb$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a46a8ce0ec2a95eb$export$b82d16f27459e05a, (v) => $a46a8ce0ec2a95eb$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a46a8ce0ec2a95eb$export$522c17b4f5e123e8, (v) => $a46a8ce0ec2a95eb$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a46a8ce0ec2a95eb$export$1aabd8a0274ecfd6, (v) => $a46a8ce0ec2a95eb$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a46a8ce0ec2a95eb$export$9b621391a187a31a, (v) => $a46a8ce0ec2a95eb$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a46a8ce0ec2a95eb$export$f5bbd400c2f4426f, (v) => $a46a8ce0ec2a95eb$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a46a8ce0ec2a95eb$export$2b8d127b894957b9;
var $a46a8ce0ec2a95eb$export$cea3a54a6425200c;
var $a46a8ce0ec2a95eb$export$a7c73072b1a182ae;
var $a46a8ce0ec2a95eb$export$9f27bc3417b4524d;
var $a46a8ce0ec2a95eb$export$db77ccec0bb4ccac;
var $a46a8ce0ec2a95eb$export$8392c0c9d3dcbd35;
var $a46a8ce0ec2a95eb$export$ffb0004e005737fa;
var $a46a8ce0ec2a95eb$export$b624eff549462981;
var $a46a8ce0ec2a95eb$export$7897aa7841a5380c;
var $a46a8ce0ec2a95eb$export$602eac185826482c;
var $a46a8ce0ec2a95eb$export$e2c29f18771995cb;
var $a46a8ce0ec2a95eb$export$5f8d39834fd61797;
var $a46a8ce0ec2a95eb$export$74bf444e3cd11ea5;
var $a46a8ce0ec2a95eb$export$92387174baf9b227;
var $a46a8ce0ec2a95eb$export$ec112efeb987d9c6;
var $a46a8ce0ec2a95eb$export$b706b080d889d2c9;
var $a46a8ce0ec2a95eb$export$5be5a87408f70ddc;
var $a46a8ce0ec2a95eb$export$45a5e7f76e0caa8d;
var $a46a8ce0ec2a95eb$export$455c2e768291efa6;
var $a46a8ce0ec2a95eb$export$9522e17588c12572;
var $a46a8ce0ec2a95eb$export$2110ac352bb060b9;
var $a46a8ce0ec2a95eb$export$56885ab8b9c456ab;
var $a46a8ce0ec2a95eb$export$d927fcb6adf8f9de;
var $a46a8ce0ec2a95eb$export$b82d16f27459e05a;
var $a46a8ce0ec2a95eb$export$522c17b4f5e123e8;
var $a46a8ce0ec2a95eb$export$1aabd8a0274ecfd6;
var $a46a8ce0ec2a95eb$export$9b621391a187a31a;
var $a46a8ce0ec2a95eb$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $a46a8ce0ec2a95eb$export$2b8d127b894957b9 = AsyncMode;
    $a46a8ce0ec2a95eb$export$cea3a54a6425200c = ConcurrentMode;
    $a46a8ce0ec2a95eb$export$a7c73072b1a182ae = ContextConsumer;
    $a46a8ce0ec2a95eb$export$9f27bc3417b4524d = ContextProvider;
    $a46a8ce0ec2a95eb$export$db77ccec0bb4ccac = Element;
    $a46a8ce0ec2a95eb$export$8392c0c9d3dcbd35 = ForwardRef;
    $a46a8ce0ec2a95eb$export$ffb0004e005737fa = Fragment;
    $a46a8ce0ec2a95eb$export$b624eff549462981 = Lazy;
    $a46a8ce0ec2a95eb$export$7897aa7841a5380c = Memo;
    $a46a8ce0ec2a95eb$export$602eac185826482c = Portal;
    $a46a8ce0ec2a95eb$export$e2c29f18771995cb = Profiler;
    $a46a8ce0ec2a95eb$export$5f8d39834fd61797 = StrictMode;
    $a46a8ce0ec2a95eb$export$74bf444e3cd11ea5 = Suspense;
    $a46a8ce0ec2a95eb$export$92387174baf9b227 = isAsyncMode;
    $a46a8ce0ec2a95eb$export$ec112efeb987d9c6 = isConcurrentMode;
    $a46a8ce0ec2a95eb$export$b706b080d889d2c9 = isContextConsumer;
    $a46a8ce0ec2a95eb$export$5be5a87408f70ddc = isContextProvider;
    $a46a8ce0ec2a95eb$export$45a5e7f76e0caa8d = isElement;
    $a46a8ce0ec2a95eb$export$455c2e768291efa6 = isForwardRef;
    $a46a8ce0ec2a95eb$export$9522e17588c12572 = isFragment;
    $a46a8ce0ec2a95eb$export$2110ac352bb060b9 = isLazy;
    $a46a8ce0ec2a95eb$export$56885ab8b9c456ab = isMemo;
    $a46a8ce0ec2a95eb$export$d927fcb6adf8f9de = isPortal;
    $a46a8ce0ec2a95eb$export$b82d16f27459e05a = isProfiler;
    $a46a8ce0ec2a95eb$export$522c17b4f5e123e8 = isStrictMode;
    $a46a8ce0ec2a95eb$export$1aabd8a0274ecfd6 = isSuspense;
    $a46a8ce0ec2a95eb$export$9b621391a187a31a = isValidElementType;
    $a46a8ce0ec2a95eb$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("htQOa", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jCWPV = parcelRequire("jCWPV");

var $7oJ2w = parcelRequire("7oJ2w");

var $g41Uv = parcelRequire("g41Uv");

var $2EqGK = parcelRequire("2EqGK");

var $dMZkM = parcelRequire("dMZkM");
var $cb9e1bb32541c7aa$var$printWarning = function() {};
$cb9e1bb32541c7aa$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $cb9e1bb32541c7aa$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $g41Uv) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $cb9e1bb32541c7aa$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($cb9e1bb32541c7aa$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $g41Uv);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$jCWPV.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $cb9e1bb32541c7aa$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $cb9e1bb32541c7aa$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $cb9e1bb32541c7aa$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($2EqGK(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $g41Uv);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $cb9e1bb32541c7aa$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $cb9e1bb32541c7aa$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $cb9e1bb32541c7aa$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $cb9e1bb32541c7aa$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $g41Uv);
                if (checkerResult == null) return null;
                if (checkerResult.data && $2EqGK(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $g41Uv);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $7oJ2w({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($2EqGK(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $g41Uv);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $dMZkM;
    ReactPropTypes.resetWarningCache = $dMZkM.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});


parcelRegister("lKxJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd580f69e60081f4$export$2e2bcd8739ae039);
function $fd580f69e60081f4$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $fd580f69e60081f4$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $fd580f69e60081f4$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $fd580f69e60081f4$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fd580f69e60081f4$export$2e2bcd8739ae039 = $fd580f69e60081f4$export$4f5d2d50c9deca37;

});

parcelRegister("bYG1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b85e5ffc4fc8238$export$2e2bcd8739ae039);

var $fcOLE = parcelRequire("fcOLE");
var $8b85e5ffc4fc8238$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
]);
var $8b85e5ffc4fc8238$export$2e2bcd8739ae039 = $8b85e5ffc4fc8238$var$refType;

});

parcelRegister("6CUay", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31dcbabaf6aa52$export$2e2bcd8739ae039);
function $4d31dcbabaf6aa52$export$2e2bcd8739ae039(validator, reason) {
    return function(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (typeof props[propName] !== 'undefined') return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
        return null;
    };
}

});

parcelRegister("2KyCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $200abaf08ede3ddf$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $8LPju = parcelRequire("8LPju");

var $cV5xs = parcelRequire("cV5xs");
var $200abaf08ede3ddf$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative'
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            'label + &': {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:not($disabled):before': {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $200abaf08ede3ddf$var$Input = /*#__PURE__*/ $J42oT.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $cVOSt.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $8LPju.default), (0, $fXPf9.default)({
        classes: (0, $fXPf9.default)({}, classes, {
            root: (0, $lKxJt.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$200abaf08ede3ddf$var$Input.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the `input` element will be focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The default `input` element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the `input` element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $bYG1J.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * If `true`, a textarea element will be rendered.
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The short hint displayed in the input before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the `input` element will be required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any
};
$200abaf08ede3ddf$var$Input.muiName = 'Input';
var $200abaf08ede3ddf$export$2e2bcd8739ae039 = (0, $cV5xs.default)($200abaf08ede3ddf$export$9dd6ff9ea0189349, {
    name: 'MuiInput'
})($200abaf08ede3ddf$var$Input);

});
parcelRegister("8LPju", function(module, exports) {

$parcel$export(module.exports, "default", () => $662a8444e077869c$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $bYG1J = parcelRequire("bYG1J");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $lyguR = parcelRequire("lyguR");

var $6t69i = parcelRequire("6t69i");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");

var $bDH0e = parcelRequire("bDH0e");

var $9tpKk = parcelRequire("9tpKk");

var $f3VeP = parcelRequire("f3VeP");
var $662a8444e077869c$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var placeholder = {
        color: 'currentColor',
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: '0 !important'
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        '@global': {
            '@keyframes mui-auto-fill': {},
            '@keyframes mui-auto-fill-cancel': {}
        },
        /* Styles applied to the root element. */ root: (0, $fXPf9.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: '1.1876em',
            // Reset (19px), match the native input line-height
            boxSizing: 'border-box',
            // Prevent padding issue with fullWidth.
            position: 'relative',
            cursor: 'text',
            display: 'inline-flex',
            alignItems: 'center',
            '&$disabled': {
                color: theme.palette.text.disabled,
                cursor: 'default'
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            '&$marginDense': {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the `input` element. */ input: {
            font: 'inherit',
            letterSpacing: 'inherit',
            color: 'currentColor',
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: 'content-box',
            background: 'none',
            height: '1.1876em',
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: 'transparent',
            display: 'block',
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: '100%',
            // Fix IE 11 width issue
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '10ms',
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholder,
            // IE 11
            '&::-ms-input-placeholder': placeholder,
            // Edge
            '&:focus': {
                outline: 0
            },
            // Reset Firefox invalid required input style
            '&:invalid': {
                boxShadow: 'none'
            },
            '&::-webkit-search-decoration': {
                // Remove the padding when type=search.
                '-webkit-appearance': 'none'
            },
            // Show and hide the placeholder logic
            'label[data-shrink=false] + $formControl &': {
                '&::-webkit-input-placeholder': placeholderHidden,
                '&::-moz-placeholder': placeholderHidden,
                // Firefox 19+
                '&:-ms-input-placeholder': placeholderHidden,
                // IE 11
                '&::-ms-input-placeholder': placeholderHidden,
                // Edge
                '&:focus::-webkit-input-placeholder': placeholderVisible,
                '&:focus::-moz-placeholder': placeholderVisible,
                // Firefox 19+
                '&:focus:-ms-input-placeholder': placeholderVisible,
                // IE 11
                '&:focus::-ms-input-placeholder': placeholderVisible // Edge
            },
            '&$disabled': {
                opacity: 1 // Reset iOS opacity
            },
            '&:-webkit-autofill': {
                animationDuration: '5000s',
                animationName: 'mui-auto-fill'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: 'auto',
            resize: 'none',
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            '-moz-appearance': 'textfield',
            '-webkit-appearance': 'textfield'
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $662a8444e077869c$var$useEnhancedEffect = typeof window === 'undefined' ? $J42oT.useEffect : $J42oT.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $662a8444e077869c$var$InputBase = /*#__PURE__*/ $J42oT.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props['aria-describedby'], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, valueProp = props.value, other = (0, $cVOSt.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $J42oT.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $J42oT.useRef();
    var handleInputRefWarning = $J42oT.useCallback(function(instance) {
        if (instance && instance.nodeName !== 'INPUT' && !instance.focus) console.error([
            'Material-UI: You have provided a `inputComponent` to the input component',
            'that does not correctly handle the `inputRef` prop.',
            'Make sure the `inputRef` prop is called with a HTMLInputElement.'
        ].join('\n'));
    }, []);
    var handleInputPropsRefProp = (0, $bDH0e.default)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $bDH0e.default)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $bDH0e.default)(inputRef, handleInputRefProp);
    var _React$useState = $J42oT.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $6t69i.useFormControl)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $J42oT.useEffect(function() {
        if (muiFormControl) return muiFormControl.registerEffect();
        return undefined;
    }, [
        muiFormControl
    ]);
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'margin',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $J42oT.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $J42oT.useCallback(function(obj) {
        if ((0, $f3VeP.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $662a8444e077869c$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error("Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.");
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $J42oT.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $fXPf9.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== 'string') inputProps = (0, $fXPf9.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = 'textarea';
        else {
            inputProps = (0, $fXPf9.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $9tpKk.default);
        }
    } else inputProps = (0, $fXPf9.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $J42oT.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes["color".concat((0, $7OrFE.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $J42oT.createElement((0, $6t69i.default).Provider, {
        value: null
    }, /*#__PURE__*/ $J42oT.createElement(InputComponent, (0, $fXPf9.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $lKxJt.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $fXPf9.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
$662a8444e077869c$var$InputBase.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * @ignore
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the `input` element will be focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The default `input` element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the `input` element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $bYG1J.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * If `true`, a textarea element will be rendered.
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The short hint displayed in the input before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ renderSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If `true`, the `input` element will be required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */ rowsMax: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */ rowsMin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any
};
var $662a8444e077869c$export$2e2bcd8739ae039 = (0, $cV5xs.default)($662a8444e077869c$export$9dd6ff9ea0189349, {
    name: 'MuiInputBase'
})($662a8444e077869c$var$InputBase);

});
parcelRegister("lyguR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb0991d8eab1e846$export$2e2bcd8739ae039);
function $fb0991d8eab1e846$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("6t69i", function(module, exports) {

$parcel$export(module.exports, "useFormControl", () => $4b5a3895b3eaf4eb$export$62ecd8ad1bbe1a18);
$parcel$export(module.exports, "default", () => $4b5a3895b3eaf4eb$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
/**
 * @ignore - internal component.
 */ var $4b5a3895b3eaf4eb$var$FormControlContext = $J42oT.createContext();
$4b5a3895b3eaf4eb$var$FormControlContext.displayName = 'FormControlContext';
function $4b5a3895b3eaf4eb$export$62ecd8ad1bbe1a18() {
    return $J42oT.useContext($4b5a3895b3eaf4eb$var$FormControlContext);
}
var $4b5a3895b3eaf4eb$export$2e2bcd8739ae039 = $4b5a3895b3eaf4eb$var$FormControlContext;

});

parcelRegister("cV5xs", function(module, exports) {

$parcel$export(module.exports, "default", () => $967f1ac684cfc16b$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $khg1r = parcelRequire("khg1r");

var $6MwfJ = parcelRequire("6MwfJ");
function $967f1ac684cfc16b$var$withStyles(stylesOrCreator, options) {
    return (0, $khg1r.default)(stylesOrCreator, (0, $fXPf9.default)({
        defaultTheme: (0, $6MwfJ.default)
    }, options));
}
var $967f1ac684cfc16b$export$2e2bcd8739ae039 = $967f1ac684cfc16b$var$withStyles;

});
parcelRegister("khg1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec31d2d889546896$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $eapUt = parcelRequire("eapUt");

var $81kKd = parcelRequire("81kKd");
var $9u4l7 = parcelRequire("9u4l7");

var $R8WKp = parcelRequire("R8WKp");

var $dxjd5 = parcelRequire("dxjd5");

var $27Cb9 = parcelRequire("27Cb9");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $ec31d2d889546896$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $cVOSt.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        if (Component === undefined) throw new Error([
            'You are calling withStyles(styles)(Component) with an undefined component.',
            'You may have forgotten to import it.'
        ].join('\n'));
        var classNamePrefix = name;
        if (!name) {
            // Provide a better DX outside production.
            var displayName = (0, $9u4l7.default)(Component);
            if (displayName !== undefined) classNamePrefix = displayName;
        }
        var useStyles = (0, $R8WKp.default)(stylesOrCreator, (0, $fXPf9.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $cVOSt.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $fXPf9.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $27Cb9.default)() || defaultTheme;
                if (name) more = (0, $dxjd5.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement(Component, (0, $fXPf9.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        WithStyles.propTypes = {
            /**
       * Override or extend the styles applied to the component.
       */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
            /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */ innerRef: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
            ]), function(props) {
                if (props.innerRef == null) return null;
                return null; // return new Error(
            //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
            //     'Refs are now automatically forwarded to the inner component.',
            // );
            })
        };
        WithStyles.displayName = "WithStyles(".concat((0, $9u4l7.default)(Component), ")");
        (0, (/*@__PURE__*/$parcel$interopDefault($eapUt)))(WithStyles, Component);
        // Exposed for test purposes.
        WithStyles.Naked = Component;
        WithStyles.options = options;
        WithStyles.useStyles = useStyles;
        return WithStyles;
    };
};
var $ec31d2d889546896$export$2e2bcd8739ae039 = $ec31d2d889546896$var$withStyles;

});
parcelRegister("eapUt", function(module, exports) {
'use strict';

var $jCWPV = parcelRequire("jCWPV");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a5061908dbe55118$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a5061908dbe55118$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a5061908dbe55118$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $a5061908dbe55118$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $a5061908dbe55118$var$TYPE_STATICS = {};
$a5061908dbe55118$var$TYPE_STATICS[$jCWPV.ForwardRef] = $a5061908dbe55118$var$FORWARD_REF_STATICS;
$a5061908dbe55118$var$TYPE_STATICS[$jCWPV.Memo] = $a5061908dbe55118$var$MEMO_STATICS;
function $a5061908dbe55118$var$getStatics(component) {
    // React v16.11 and below
    if ($jCWPV.isMemo(component)) return $a5061908dbe55118$var$MEMO_STATICS;
     // React v16.12 and above
    return $a5061908dbe55118$var$TYPE_STATICS[component['$$typeof']] || $a5061908dbe55118$var$REACT_STATICS;
}
var $a5061908dbe55118$var$defineProperty = Object.defineProperty;
var $a5061908dbe55118$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a5061908dbe55118$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a5061908dbe55118$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a5061908dbe55118$var$getPrototypeOf = Object.getPrototypeOf;
var $a5061908dbe55118$var$objectPrototype = Object.prototype;
function $a5061908dbe55118$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($a5061908dbe55118$var$objectPrototype) {
            var inheritedComponent = $a5061908dbe55118$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a5061908dbe55118$var$objectPrototype) $a5061908dbe55118$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a5061908dbe55118$var$getOwnPropertyNames(sourceComponent);
        if ($a5061908dbe55118$var$getOwnPropertySymbols) keys = keys.concat($a5061908dbe55118$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $a5061908dbe55118$var$getStatics(targetComponent);
        var sourceStatics = $a5061908dbe55118$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a5061908dbe55118$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $a5061908dbe55118$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $a5061908dbe55118$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $a5061908dbe55118$var$hoistNonReactStatics;

});

parcelRegister("81kKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d6e821ccffb4ad2$export$2e2bcd8739ae039);
function $5d6e821ccffb4ad2$export$2e2bcd8739ae039(propType1, propType2) {
    return function validate() {
        return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
    };
}

});

parcelRegister("9u4l7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7a4825bbabe910$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $fhrWn = parcelRequire("fhrWn");
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var $6e7a4825bbabe910$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $6e7a4825bbabe910$export$aad197c7121a6651(fn) {
    var match = "".concat(fn).match($6e7a4825bbabe910$var$fnNameMatchRegex);
    var name = match && match[1];
    return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */ function $6e7a4825bbabe910$var$getFunctionComponentName(Component) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Component.displayName || Component.name || $6e7a4825bbabe910$export$aad197c7121a6651(Component) || fallback;
}
function $6e7a4825bbabe910$var$getWrappedName(outerType, innerType, wrapperName) {
    var functionName = $6e7a4825bbabe910$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
function $6e7a4825bbabe910$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6e7a4825bbabe910$var$getFunctionComponentName(Component, 'Component');
    if ((0, $5z6Dx.default)(Component) === 'object') switch(Component.$$typeof){
        case 0, $fhrWn.ForwardRef:
            return $6e7a4825bbabe910$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $fhrWn.Memo:
            return $6e7a4825bbabe910$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("5z6Dx", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d55e910edaf5b5$export$2e2bcd8739ae039);
function $40d55e910edaf5b5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $40d55e910edaf5b5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $40d55e910edaf5b5$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fhrWn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jIf7S"));

});
parcelRegister("jIf7S", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $e59ddc155c86883b$export$a7c73072b1a182ae, (v) => $e59ddc155c86883b$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $e59ddc155c86883b$export$9f27bc3417b4524d, (v) => $e59ddc155c86883b$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $e59ddc155c86883b$export$db77ccec0bb4ccac, (v) => $e59ddc155c86883b$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $e59ddc155c86883b$export$8392c0c9d3dcbd35, (v) => $e59ddc155c86883b$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $e59ddc155c86883b$export$ffb0004e005737fa, (v) => $e59ddc155c86883b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $e59ddc155c86883b$export$b624eff549462981, (v) => $e59ddc155c86883b$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $e59ddc155c86883b$export$7897aa7841a5380c, (v) => $e59ddc155c86883b$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $e59ddc155c86883b$export$602eac185826482c, (v) => $e59ddc155c86883b$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $e59ddc155c86883b$export$e2c29f18771995cb, (v) => $e59ddc155c86883b$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $e59ddc155c86883b$export$5f8d39834fd61797, (v) => $e59ddc155c86883b$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e59ddc155c86883b$export$74bf444e3cd11ea5, (v) => $e59ddc155c86883b$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $e59ddc155c86883b$export$92387174baf9b227, (v) => $e59ddc155c86883b$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $e59ddc155c86883b$export$ec112efeb987d9c6, (v) => $e59ddc155c86883b$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $e59ddc155c86883b$export$b706b080d889d2c9, (v) => $e59ddc155c86883b$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $e59ddc155c86883b$export$5be5a87408f70ddc, (v) => $e59ddc155c86883b$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $e59ddc155c86883b$export$45a5e7f76e0caa8d, (v) => $e59ddc155c86883b$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $e59ddc155c86883b$export$455c2e768291efa6, (v) => $e59ddc155c86883b$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $e59ddc155c86883b$export$9522e17588c12572, (v) => $e59ddc155c86883b$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $e59ddc155c86883b$export$2110ac352bb060b9, (v) => $e59ddc155c86883b$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $e59ddc155c86883b$export$56885ab8b9c456ab, (v) => $e59ddc155c86883b$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $e59ddc155c86883b$export$d927fcb6adf8f9de, (v) => $e59ddc155c86883b$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $e59ddc155c86883b$export$b82d16f27459e05a, (v) => $e59ddc155c86883b$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $e59ddc155c86883b$export$522c17b4f5e123e8, (v) => $e59ddc155c86883b$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $e59ddc155c86883b$export$1aabd8a0274ecfd6, (v) => $e59ddc155c86883b$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $e59ddc155c86883b$export$9b621391a187a31a, (v) => $e59ddc155c86883b$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $e59ddc155c86883b$export$f5bbd400c2f4426f, (v) => $e59ddc155c86883b$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59ddc155c86883b$export$a7c73072b1a182ae;
var $e59ddc155c86883b$export$9f27bc3417b4524d;
var $e59ddc155c86883b$export$db77ccec0bb4ccac;
var $e59ddc155c86883b$export$8392c0c9d3dcbd35;
var $e59ddc155c86883b$export$ffb0004e005737fa;
var $e59ddc155c86883b$export$b624eff549462981;
var $e59ddc155c86883b$export$7897aa7841a5380c;
var $e59ddc155c86883b$export$602eac185826482c;
var $e59ddc155c86883b$export$e2c29f18771995cb;
var $e59ddc155c86883b$export$5f8d39834fd61797;
var $e59ddc155c86883b$export$74bf444e3cd11ea5;
var $e59ddc155c86883b$export$92387174baf9b227;
var $e59ddc155c86883b$export$ec112efeb987d9c6;
var $e59ddc155c86883b$export$b706b080d889d2c9;
var $e59ddc155c86883b$export$5be5a87408f70ddc;
var $e59ddc155c86883b$export$45a5e7f76e0caa8d;
var $e59ddc155c86883b$export$455c2e768291efa6;
var $e59ddc155c86883b$export$9522e17588c12572;
var $e59ddc155c86883b$export$2110ac352bb060b9;
var $e59ddc155c86883b$export$56885ab8b9c456ab;
var $e59ddc155c86883b$export$d927fcb6adf8f9de;
var $e59ddc155c86883b$export$b82d16f27459e05a;
var $e59ddc155c86883b$export$522c17b4f5e123e8;
var $e59ddc155c86883b$export$1aabd8a0274ecfd6;
var $e59ddc155c86883b$export$9b621391a187a31a;
var $e59ddc155c86883b$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $e59ddc155c86883b$export$a7c73072b1a182ae = ContextConsumer;
    $e59ddc155c86883b$export$9f27bc3417b4524d = ContextProvider;
    $e59ddc155c86883b$export$db77ccec0bb4ccac = Element;
    $e59ddc155c86883b$export$8392c0c9d3dcbd35 = ForwardRef;
    $e59ddc155c86883b$export$ffb0004e005737fa = Fragment;
    $e59ddc155c86883b$export$b624eff549462981 = Lazy;
    $e59ddc155c86883b$export$7897aa7841a5380c = Memo;
    $e59ddc155c86883b$export$602eac185826482c = Portal;
    $e59ddc155c86883b$export$e2c29f18771995cb = Profiler;
    $e59ddc155c86883b$export$5f8d39834fd61797 = StrictMode;
    $e59ddc155c86883b$export$74bf444e3cd11ea5 = Suspense;
    $e59ddc155c86883b$export$92387174baf9b227 = isAsyncMode;
    $e59ddc155c86883b$export$ec112efeb987d9c6 = isConcurrentMode;
    $e59ddc155c86883b$export$b706b080d889d2c9 = isContextConsumer;
    $e59ddc155c86883b$export$5be5a87408f70ddc = isContextProvider;
    $e59ddc155c86883b$export$45a5e7f76e0caa8d = isElement;
    $e59ddc155c86883b$export$455c2e768291efa6 = isForwardRef;
    $e59ddc155c86883b$export$9522e17588c12572 = isFragment;
    $e59ddc155c86883b$export$2110ac352bb060b9 = isLazy;
    $e59ddc155c86883b$export$56885ab8b9c456ab = isMemo;
    $e59ddc155c86883b$export$d927fcb6adf8f9de = isPortal;
    $e59ddc155c86883b$export$b82d16f27459e05a = isProfiler;
    $e59ddc155c86883b$export$522c17b4f5e123e8 = isStrictMode;
    $e59ddc155c86883b$export$1aabd8a0274ecfd6 = isSuspense;
    $e59ddc155c86883b$export$9b621391a187a31a = isValidElementType;
    $e59ddc155c86883b$export$f5bbd400c2f4426f = typeOf;
})();

});



parcelRegister("R8WKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fbe3f2cfe44724$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $7bmQK = parcelRequire("7bmQK");

var $cDKOG = parcelRequire("cDKOG");

var $17jv3 = parcelRequire("17jv3");

var $27Cb9 = parcelRequire("27Cb9");

var $98N7C = parcelRequire("98N7C");

var $1Pckh = parcelRequire("1Pckh");

var $2HcOW = parcelRequire("2HcOW");

var $ezmNJ = parcelRequire("ezmNJ");
function $09fbe3f2cfe44724$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $cDKOG.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $09fbe3f2cfe44724$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $17jv3.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $17jv3.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $fXPf9.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $17jv3.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $fXPf9.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $17jv3.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $7bmQK.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $fXPf9.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $cDKOG.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $09fbe3f2cfe44724$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $09fbe3f2cfe44724$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $17jv3.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $17jv3.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $09fbe3f2cfe44724$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $09fbe3f2cfe44724$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ezmNJ.default) : _options$defaultTheme, stylesOptions2 = (0, $cVOSt.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $2HcOW.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $1Pckh.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $27Cb9.default)() || defaultTheme;
        var stylesOptions = (0, $fXPf9.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useContext((0, $98N7C.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useRef();
        $09fbe3f2cfe44724$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $09fbe3f2cfe44724$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $09fbe3f2cfe44724$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useEffect(function() {
            if (shouldUpdate.current) $09fbe3f2cfe44724$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $09fbe3f2cfe44724$var$getClasses(instance.current, props.classes, Component);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useDebugValue(classes);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("7bmQK", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $fXPf9 = parcelRequire("fXPf9");

var $cgBlS = parcelRequire("cgBlS");

var $6wuQQ = parcelRequire("6wuQQ");

var $cWCsL = parcelRequire("cWCsL");

var $1bdSs = parcelRequire("1bdSs");

var $5h49q = parcelRequire("5h49q");

var $bXxv0 = parcelRequire("bXxv0");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    if (name[0] === '@') (0, $6wuQQ.default)(false, "[JSS] Unknown rule " + name);
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        if (sheet && sheet.attached) (0, $6wuQQ.default)(false, '[JSS] Rule is not linked. Missing sheet option "link: true".');
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1bdSs.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $5h49q.default)((0, $5h49q.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $fXPf9.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $cWCsL.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $fXPf9.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else {
            this.name = 'noname';
            (0, $6wuQQ.default)(false, "[JSS] Bad keyframes name " + key);
        }
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $fXPf9.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $fXPf9.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        (0, $6wuQQ.default)(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.");
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1bdSs.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $fXPf9.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $fXPf9.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $fXPf9.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $fXPf9.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            else (0, $6wuQQ.default)(false, "[JSS] Unknown hook \"" + name + "\".");
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $bXxv0.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $cWCsL.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        if (ruleCounter > maxRules) (0, $6wuQQ.default)(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".");
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {
        (0, $6wuQQ.default)(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".");
    }
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
        // bad specificity issues may appear.
        (0, $6wuQQ.default)(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.");
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        else (0, $6wuQQ.default)(false, '[JSS] Insertion point is not in the DOM.');
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        (0, $6wuQQ.default)(false, "[JSS] " + err.message);
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $cgBlS.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $fXPf9.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $fXPf9.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $fXPf9.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $6wuQQ.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $6wuQQ.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $cWCsL.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $53ab48f7f2a9a41e$export$2e2bcd8739ae039 = index;

});
parcelRegister("cgBlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee3f3f2b9193f6a$export$2e2bcd8739ae039);
var $8ee3f3f2b9193f6a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $8ee3f3f2b9193f6a$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $8ee3f3f2b9193f6a$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $8ee3f3f2b9193f6a$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $8ee3f3f2b9193f6a$export$2e2bcd8739ae039 = $8ee3f3f2b9193f6a$export$4e09c449d6c407f7;

});

parcelRegister("6wuQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfda9a6c65202f3$export$2e2bcd8739ae039);
var $4bfda9a6c65202f3$var$isProduction = false;
function $4bfda9a6c65202f3$var$warning(condition, message) {
    if (!$4bfda9a6c65202f3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $4bfda9a6c65202f3$export$2e2bcd8739ae039 = $4bfda9a6c65202f3$var$warning;

});

parcelRegister("cWCsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c8bcbd2f4814b3$export$2e2bcd8739ae039);

var $lUEg5 = parcelRequire("lUEg5");
function $96c8bcbd2f4814b3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $lUEg5.default)(o.key), o);
    }
}
function $96c8bcbd2f4814b3$export$2e2bcd8739ae039(e, r, t) {
    return r && $96c8bcbd2f4814b3$var$_defineProperties(e.prototype, r), t && $96c8bcbd2f4814b3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("lUEg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff3e0e6ca2d2a396$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $8PLe2 = parcelRequire("8PLe2");
function $ff3e0e6ca2d2a396$export$2e2bcd8739ae039(t) {
    var i = (0, $8PLe2.default)(t, "string");
    return "symbol" == (0, $5z6Dx.default)(i) ? i : i + "";
}

});
parcelRegister("8PLe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e7b81c4d145d28$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");
function $66e7b81c4d145d28$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5z6Dx.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5z6Dx.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("1bdSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc1954a024a0ab5$export$2e2bcd8739ae039);

var $3bCBG = parcelRequire("3bCBG");
function $0dc1954a024a0ab5$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3bCBG.default)(t, o);
}

});
parcelRegister("3bCBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $252058afc02d5b3d$export$2e2bcd8739ae039);
function $252058afc02d5b3d$export$2e2bcd8739ae039(t, e) {
    return $252058afc02d5b3d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $252058afc02d5b3d$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("5h49q", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d71c29198820bb6$export$2e2bcd8739ae039);
function $3d71c29198820bb6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("cDKOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $933d714e4cd2c2a3$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $9u4l7 = parcelRequire("9u4l7");
function $933d714e4cd2c2a3$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $fXPf9.default)({}, baseClasses);
    if (typeof newClasses === 'string') {
        console.error([
            "Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, $9u4l7.default)(Component), " is incorrect."),
            'You might want to use the className prop instead.'
        ].join('\n'));
        return baseClasses;
    }
    Object.keys(newClasses).forEach(function(key) {
        if (!baseClasses[key] && newClasses[key]) console.error([
            "Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, $9u4l7.default)(Component), "."),
            "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")
        ].join('\n'));
        if (newClasses[key] && typeof newClasses[key] !== 'string') console.error([
            "Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, $9u4l7.default)(Component), "."),
            "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")
        ].join('\n'));
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("17jv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d0592281ced9c21$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $0d0592281ced9c21$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $0d0592281ced9c21$export$2e2bcd8739ae039 = $0d0592281ced9c21$var$multiKeyStore;

});

parcelRegister("27Cb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b9d9c2ad902a21$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $45XHm = parcelRequire("45XHm");
function $18b9d9c2ad902a21$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useContext((0, $45XHm.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useDebugValue(theme);
    return theme;
}

});
parcelRegister("45XHm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb5efe33f9dcbfa$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
var $2fb5efe33f9dcbfa$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createContext(null);
$2fb5efe33f9dcbfa$var$ThemeContext.displayName = 'ThemeContext';
var $2fb5efe33f9dcbfa$export$2e2bcd8739ae039 = $2fb5efe33f9dcbfa$var$ThemeContext;

});


parcelRegister("98N7C", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $6a7af700fa64abb9$export$f4de434b269fe487);
$parcel$export(module.exports, "default", () => $6a7af700fa64abb9$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $bsqoQ = parcelRequire("bsqoQ");

var $6iob3 = parcelRequire("6iob3");

var $7bmQK = parcelRequire("7bmQK");

var $6IUuc = parcelRequire("6IUuc");
var $6a7af700fa64abb9$var$jss = (0, $7bmQK.create)((0, $6IUuc.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $6a7af700fa64abb9$var$generateClassName = (0, $6iob3.default)(); // Exported for test purposes
var $6a7af700fa64abb9$export$70a8aea9ff58d1cd = new Map();
var $6a7af700fa64abb9$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $6a7af700fa64abb9$var$generateClassName,
    jss: $6a7af700fa64abb9$var$jss,
    sheetsCache: null,
    sheetsManager: $6a7af700fa64abb9$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $6a7af700fa64abb9$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createContext($6a7af700fa64abb9$var$defaultOptions);
$6a7af700fa64abb9$export$f4de434b269fe487.displayName = 'StylesContext';
var $6a7af700fa64abb9$var$injectFirstNode;
function $6a7af700fa64abb9$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $cVOSt.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useContext($6a7af700fa64abb9$export$f4de434b269fe487);
    var context = (0, $fXPf9.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (typeof window === 'undefined' && !context.sheetsManager) console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    if (context.jss.options.insertionPoint && injectFirst) console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    if (injectFirst && localOptions.jss) console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$6a7af700fa64abb9$var$injectFirstNode) {
            var head = document.head;
            $6a7af700fa64abb9$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($6a7af700fa64abb9$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $7bmQK.create)({
            plugins: (0, $6IUuc.default)().plugins,
            insertionPoint: $6a7af700fa64abb9$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement($6a7af700fa64abb9$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}
$6a7af700fa64abb9$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node.isRequired,
    /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */ disableGeneration: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * JSS's class name generator.
   */ generateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * JSS's instance.
   */ jss: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ serverGenerateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */ sheetsCache: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */ sheetsManager: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   *
   * Collect the sheets.
   */ sheetsRegistry: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
$6a7af700fa64abb9$export$2e2bcd8739ae039.propTypes = (0, $bsqoQ.default)($6a7af700fa64abb9$export$2e2bcd8739ae039.propTypes);

});
parcelRegister("bsqoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8576c9a750f8117e$export$2e2bcd8739ae039);

var $6JmtS = parcelRequire("6JmtS");

var $fXPf9 = parcelRequire("fXPf9");
var $8576c9a750f8117e$export$779da81cd30caf6c = "exact-prop: \u200B";
function $8576c9a750f8117e$export$2e2bcd8739ae039(propTypes) {
    return (0, $fXPf9.default)({}, propTypes, (0, $6JmtS.default)({}, $8576c9a750f8117e$export$779da81cd30caf6c, function(props) {
        var unsupportedProps = Object.keys(props).filter(function(prop) {
            return !propTypes.hasOwnProperty(prop);
        });
        if (unsupportedProps.length > 0) return new Error("The following props are not supported: ".concat(unsupportedProps.map(function(prop) {
            return "`".concat(prop, "`");
        }).join(', '), ". Please remove them."));
        return null;
    }));
}

});
parcelRegister("6JmtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0143bf8533a10cfe$export$2e2bcd8739ae039);

var $lUEg5 = parcelRequire("lUEg5");
function $0143bf8533a10cfe$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $lUEg5.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("6iob3", function(module, exports) {

$parcel$export(module.exports, "default", () => $49572d9cc3d58e01$export$2e2bcd8739ae039);

var $8k0Rr = parcelRequire("8k0Rr");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $49572d9cc3d58e01$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $49572d9cc3d58e01$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        if (ruleCounter >= 1e10) console.warn([
            'Material-UI: You might have a memory leak.',
            'The ruleCounter is not supposed to grow that much.'
        ].join(''));
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($49572d9cc3d58e01$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $8k0Rr.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
        if (styleSheet.options.classNamePrefix) return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
        return "".concat(seedPrefix).concat(suffix);
    };
}

});
parcelRegister("8k0Rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $60f0dbf31eebefc4$export$2e2bcd8739ae039);
var $60f0dbf31eebefc4$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $60f0dbf31eebefc4$export$2e2bcd8739ae039 = $60f0dbf31eebefc4$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("6IUuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e52ab1b5e61e542$export$2e2bcd8739ae039);

var $eV7M0 = parcelRequire("eV7M0");

var $9Ft0q = parcelRequire("9Ft0q");

var $lE9dU = parcelRequire("lE9dU");

var $8T4FC = parcelRequire("8T4FC");

var $3dK51 = parcelRequire("3dK51");

var $ipvnw = parcelRequire("ipvnw");

var $fvRry = parcelRequire("fvRry");
function $4e52ab1b5e61e542$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $eV7M0.default)(),
            (0, $9Ft0q.default)(),
            (0, $lE9dU.default)(),
            (0, $8T4FC.default)(),
            (0, $3dK51.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $ipvnw.default)(),
            (0, $fvRry.default)()
        ]
    };
}

});
parcelRegister("eV7M0", function(module, exports) {

$parcel$export(module.exports, "default", () => $adcc6b2d27e61a75$export$2e2bcd8739ae039);


var $7bmQK = parcelRequire("7bmQK");
var $adcc6b2d27e61a75$var$now = Date.now();
var $adcc6b2d27e61a75$var$fnValuesNs = "fnValues" + $adcc6b2d27e61a75$var$now;
var $adcc6b2d27e61a75$var$fnRuleNs = "fnStyle" + ++$adcc6b2d27e61a75$var$now;
var $adcc6b2d27e61a75$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $7bmQK.createRule)(name, {}, options);
            rule[$adcc6b2d27e61a75$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($adcc6b2d27e61a75$var$fnValuesNs in rule || $adcc6b2d27e61a75$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$adcc6b2d27e61a75$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$adcc6b2d27e61a75$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$adcc6b2d27e61a75$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $adcc6b2d27e61a75$export$2e2bcd8739ae039 = $adcc6b2d27e61a75$var$functionPlugin;

});

parcelRegister("9Ft0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $709e715efb65770e$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $7bmQK = parcelRequire("7bmQK");
var $709e715efb65770e$var$at = '@global';
var $709e715efb65770e$var$atPrefix = '@global ';
var $709e715efb65770e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $709e715efb65770e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $7bmQK.RuleList)((0, $fXPf9.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $709e715efb65770e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $709e715efb65770e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($709e715efb65770e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $fXPf9.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $709e715efb65770e$var$separatorRegExp = /\s*,\s*/g;
function $709e715efb65770e$var$addScope(selector, scope) {
    var parts = selector.split($709e715efb65770e$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $709e715efb65770e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$709e715efb65770e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $fXPf9.default)({}, options, {
        selector: $709e715efb65770e$var$addScope(name, rule.selector)
    }));
    delete style[$709e715efb65770e$var$at];
}
function $709e715efb65770e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $709e715efb65770e$var$at.length) !== $709e715efb65770e$var$at) continue;
        var selector = $709e715efb65770e$var$addScope(prop.substr($709e715efb65770e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $fXPf9.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $709e715efb65770e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $709e715efb65770e$var$at) return new $709e715efb65770e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $709e715efb65770e$var$atPrefix.length) === $709e715efb65770e$var$atPrefix) return new $709e715efb65770e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $709e715efb65770e$var$handleNestedGlobalContainerRule(rule, sheet);
        $709e715efb65770e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $709e715efb65770e$export$2e2bcd8739ae039 = $709e715efb65770e$var$jssGlobal;

});

parcelRegister("lE9dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc247cf1a9903553$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $6wuQQ = parcelRequire("6wuQQ");
var $fc247cf1a9903553$var$separatorRegExp = /\s*,\s*/g;
var $fc247cf1a9903553$var$parentRegExp = /&/g;
var $fc247cf1a9903553$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $fc247cf1a9903553$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            (0, $6wuQQ.default)(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".");
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($fc247cf1a9903553$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($fc247cf1a9903553$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($fc247cf1a9903553$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $fXPf9.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $fXPf9.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($fc247cf1a9903553$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $fXPf9.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $fXPf9.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $fc247cf1a9903553$export$2e2bcd8739ae039 = $fc247cf1a9903553$var$jssNested;

});

parcelRegister("8T4FC", function(module, exports) {

$parcel$export(module.exports, "default", () => $67871538fcf088a3$export$2e2bcd8739ae039);

var $lUk2a = parcelRequire("lUk2a");
/**
 * Convert camel cased property names to dash separated.
 */ function $67871538fcf088a3$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $lUk2a.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($67871538fcf088a3$var$convertCase);
        else converted.fallbacks = $67871538fcf088a3$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $67871538fcf088a3$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $67871538fcf088a3$var$convertCase(style[index]);
            return style;
        }
        return $67871538fcf088a3$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $lUk2a.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $67871538fcf088a3$export$2e2bcd8739ae039 = $67871538fcf088a3$var$camelCase;

});
parcelRegister("lUk2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2e5e470868c8b9$export$2e2bcd8739ae039);
/* eslint-disable no-var, prefer-template */ var $ff2e5e470868c8b9$var$uppercasePattern = /[A-Z]/g;
var $ff2e5e470868c8b9$var$msPattern = /^ms-/;
var $ff2e5e470868c8b9$var$cache = {};
function $ff2e5e470868c8b9$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $ff2e5e470868c8b9$var$hyphenateStyleName(name) {
    if ($ff2e5e470868c8b9$var$cache.hasOwnProperty(name)) return $ff2e5e470868c8b9$var$cache[name];
    var hName = name.replace($ff2e5e470868c8b9$var$uppercasePattern, $ff2e5e470868c8b9$var$toHyphenLower);
    return $ff2e5e470868c8b9$var$cache[name] = $ff2e5e470868c8b9$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $ff2e5e470868c8b9$export$2e2bcd8739ae039 = $ff2e5e470868c8b9$var$hyphenateStyleName;

});


parcelRegister("3dK51", function(module, exports) {

$parcel$export(module.exports, "default", () => $2586548c9d98f050$export$2e2bcd8739ae039);

var $7bmQK = parcelRequire("7bmQK");
var $2586548c9d98f050$var$px = (0, $7bmQK.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $2586548c9d98f050$var$ms = (0, $7bmQK.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $2586548c9d98f050$var$percent = (0, $7bmQK.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $2586548c9d98f050$var$defaultUnits = {
    // Animation properties
    'animation-delay': $2586548c9d98f050$var$ms,
    'animation-duration': $2586548c9d98f050$var$ms,
    // Background properties
    'background-position': $2586548c9d98f050$var$px,
    'background-position-x': $2586548c9d98f050$var$px,
    'background-position-y': $2586548c9d98f050$var$px,
    'background-size': $2586548c9d98f050$var$px,
    // Border Properties
    border: $2586548c9d98f050$var$px,
    'border-bottom': $2586548c9d98f050$var$px,
    'border-bottom-left-radius': $2586548c9d98f050$var$px,
    'border-bottom-right-radius': $2586548c9d98f050$var$px,
    'border-bottom-width': $2586548c9d98f050$var$px,
    'border-left': $2586548c9d98f050$var$px,
    'border-left-width': $2586548c9d98f050$var$px,
    'border-radius': $2586548c9d98f050$var$px,
    'border-right': $2586548c9d98f050$var$px,
    'border-right-width': $2586548c9d98f050$var$px,
    'border-top': $2586548c9d98f050$var$px,
    'border-top-left-radius': $2586548c9d98f050$var$px,
    'border-top-right-radius': $2586548c9d98f050$var$px,
    'border-top-width': $2586548c9d98f050$var$px,
    'border-width': $2586548c9d98f050$var$px,
    'border-block': $2586548c9d98f050$var$px,
    'border-block-end': $2586548c9d98f050$var$px,
    'border-block-end-width': $2586548c9d98f050$var$px,
    'border-block-start': $2586548c9d98f050$var$px,
    'border-block-start-width': $2586548c9d98f050$var$px,
    'border-block-width': $2586548c9d98f050$var$px,
    'border-inline': $2586548c9d98f050$var$px,
    'border-inline-end': $2586548c9d98f050$var$px,
    'border-inline-end-width': $2586548c9d98f050$var$px,
    'border-inline-start': $2586548c9d98f050$var$px,
    'border-inline-start-width': $2586548c9d98f050$var$px,
    'border-inline-width': $2586548c9d98f050$var$px,
    'border-start-start-radius': $2586548c9d98f050$var$px,
    'border-start-end-radius': $2586548c9d98f050$var$px,
    'border-end-start-radius': $2586548c9d98f050$var$px,
    'border-end-end-radius': $2586548c9d98f050$var$px,
    // Margin properties
    margin: $2586548c9d98f050$var$px,
    'margin-bottom': $2586548c9d98f050$var$px,
    'margin-left': $2586548c9d98f050$var$px,
    'margin-right': $2586548c9d98f050$var$px,
    'margin-top': $2586548c9d98f050$var$px,
    'margin-block': $2586548c9d98f050$var$px,
    'margin-block-end': $2586548c9d98f050$var$px,
    'margin-block-start': $2586548c9d98f050$var$px,
    'margin-inline': $2586548c9d98f050$var$px,
    'margin-inline-end': $2586548c9d98f050$var$px,
    'margin-inline-start': $2586548c9d98f050$var$px,
    // Padding properties
    padding: $2586548c9d98f050$var$px,
    'padding-bottom': $2586548c9d98f050$var$px,
    'padding-left': $2586548c9d98f050$var$px,
    'padding-right': $2586548c9d98f050$var$px,
    'padding-top': $2586548c9d98f050$var$px,
    'padding-block': $2586548c9d98f050$var$px,
    'padding-block-end': $2586548c9d98f050$var$px,
    'padding-block-start': $2586548c9d98f050$var$px,
    'padding-inline': $2586548c9d98f050$var$px,
    'padding-inline-end': $2586548c9d98f050$var$px,
    'padding-inline-start': $2586548c9d98f050$var$px,
    // Mask properties
    'mask-position-x': $2586548c9d98f050$var$px,
    'mask-position-y': $2586548c9d98f050$var$px,
    'mask-size': $2586548c9d98f050$var$px,
    // Width and height properties
    height: $2586548c9d98f050$var$px,
    width: $2586548c9d98f050$var$px,
    'min-height': $2586548c9d98f050$var$px,
    'max-height': $2586548c9d98f050$var$px,
    'min-width': $2586548c9d98f050$var$px,
    'max-width': $2586548c9d98f050$var$px,
    // Position properties
    bottom: $2586548c9d98f050$var$px,
    left: $2586548c9d98f050$var$px,
    top: $2586548c9d98f050$var$px,
    right: $2586548c9d98f050$var$px,
    inset: $2586548c9d98f050$var$px,
    'inset-block': $2586548c9d98f050$var$px,
    'inset-block-end': $2586548c9d98f050$var$px,
    'inset-block-start': $2586548c9d98f050$var$px,
    'inset-inline': $2586548c9d98f050$var$px,
    'inset-inline-end': $2586548c9d98f050$var$px,
    'inset-inline-start': $2586548c9d98f050$var$px,
    // Shadow properties
    'box-shadow': $2586548c9d98f050$var$px,
    'text-shadow': $2586548c9d98f050$var$px,
    // Column properties
    'column-gap': $2586548c9d98f050$var$px,
    'column-rule': $2586548c9d98f050$var$px,
    'column-rule-width': $2586548c9d98f050$var$px,
    'column-width': $2586548c9d98f050$var$px,
    // Font and text properties
    'font-size': $2586548c9d98f050$var$px,
    'font-size-delta': $2586548c9d98f050$var$px,
    'letter-spacing': $2586548c9d98f050$var$px,
    'text-decoration-thickness': $2586548c9d98f050$var$px,
    'text-indent': $2586548c9d98f050$var$px,
    'text-stroke': $2586548c9d98f050$var$px,
    'text-stroke-width': $2586548c9d98f050$var$px,
    'word-spacing': $2586548c9d98f050$var$px,
    // Motion properties
    motion: $2586548c9d98f050$var$px,
    'motion-offset': $2586548c9d98f050$var$px,
    // Outline properties
    outline: $2586548c9d98f050$var$px,
    'outline-offset': $2586548c9d98f050$var$px,
    'outline-width': $2586548c9d98f050$var$px,
    // Perspective properties
    perspective: $2586548c9d98f050$var$px,
    'perspective-origin-x': $2586548c9d98f050$var$percent,
    'perspective-origin-y': $2586548c9d98f050$var$percent,
    // Transform properties
    'transform-origin': $2586548c9d98f050$var$percent,
    'transform-origin-x': $2586548c9d98f050$var$percent,
    'transform-origin-y': $2586548c9d98f050$var$percent,
    'transform-origin-z': $2586548c9d98f050$var$percent,
    // Transition properties
    'transition-delay': $2586548c9d98f050$var$ms,
    'transition-duration': $2586548c9d98f050$var$ms,
    // Alignment properties
    'vertical-align': $2586548c9d98f050$var$px,
    'flex-basis': $2586548c9d98f050$var$px,
    // Some random properties
    'shape-margin': $2586548c9d98f050$var$px,
    size: $2586548c9d98f050$var$px,
    gap: $2586548c9d98f050$var$px,
    // Grid properties
    grid: $2586548c9d98f050$var$px,
    'grid-gap': $2586548c9d98f050$var$px,
    'row-gap': $2586548c9d98f050$var$px,
    'grid-row-gap': $2586548c9d98f050$var$px,
    'grid-column-gap': $2586548c9d98f050$var$px,
    'grid-template-rows': $2586548c9d98f050$var$px,
    'grid-template-columns': $2586548c9d98f050$var$px,
    'grid-auto-rows': $2586548c9d98f050$var$px,
    'grid-auto-columns': $2586548c9d98f050$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $2586548c9d98f050$var$px,
    'box-shadow-y': $2586548c9d98f050$var$px,
    'box-shadow-blur': $2586548c9d98f050$var$px,
    'box-shadow-spread': $2586548c9d98f050$var$px,
    'font-line-height': $2586548c9d98f050$var$px,
    'text-shadow-x': $2586548c9d98f050$var$px,
    'text-shadow-y': $2586548c9d98f050$var$px,
    'text-shadow-blur': $2586548c9d98f050$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $2586548c9d98f050$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $2586548c9d98f050$var$units = $2586548c9d98f050$var$addCamelCasedVersion($2586548c9d98f050$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $2586548c9d98f050$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $2586548c9d98f050$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $2586548c9d98f050$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $2586548c9d98f050$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $2586548c9d98f050$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $2586548c9d98f050$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $2586548c9d98f050$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $2586548c9d98f050$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $2586548c9d98f050$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $2586548c9d98f050$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $2586548c9d98f050$export$2e2bcd8739ae039 = $2586548c9d98f050$var$defaultUnit;

});

parcelRegister("ipvnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d672e6e01e48026e$export$2e2bcd8739ae039);

var $78hdY = parcelRequire("78hdY");

var $7bmQK = parcelRequire("7bmQK");
/**
 * Add vendor prefix to a property name when needed.
 */ function $d672e6e01e48026e$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $78hdY.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $78hdY.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $78hdY.supportedValue)(supportedProp, (0, $7bmQK.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $78hdY.supportedValue)(prop, (0, $7bmQK.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $d672e6e01e48026e$export$2e2bcd8739ae039 = $d672e6e01e48026e$var$jssVendorPrefixer;

});
parcelRegister("78hdY", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", () => $5316a422e7ea2c99$export$b6aa0648d950180a);
$parcel$export(module.exports, "supportedProperty", () => $5316a422e7ea2c99$export$ce097f82c2e4551a);
$parcel$export(module.exports, "supportedValue", () => $5316a422e7ea2c99$export$511766124059c277);

var $cgBlS = parcelRequire("cgBlS");

var $6kfYZ = parcelRequire("6kfYZ");
// Export javascript style and css style vendor prefixes.
var $5316a422e7ea2c99$var$js = '';
var $5316a422e7ea2c99$var$css = '';
var $5316a422e7ea2c99$var$vendor = '';
var $5316a422e7ea2c99$var$browser = '';
var $5316a422e7ea2c99$var$isTouch = (0, $cgBlS.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $cgBlS.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $5316a422e7ea2c99$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $5316a422e7ea2c99$var$_document$createEleme = document.createElement('p'), $5316a422e7ea2c99$var$style = $5316a422e7ea2c99$var$_document$createEleme.style;
    var $5316a422e7ea2c99$var$testProp = 'Transform';
    for(var $5316a422e7ea2c99$var$key in $5316a422e7ea2c99$var$jsCssMap)if ($5316a422e7ea2c99$var$key + $5316a422e7ea2c99$var$testProp in $5316a422e7ea2c99$var$style) {
        $5316a422e7ea2c99$var$js = $5316a422e7ea2c99$var$key;
        $5316a422e7ea2c99$var$css = $5316a422e7ea2c99$var$jsCssMap[$5316a422e7ea2c99$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($5316a422e7ea2c99$var$js === 'Webkit' && 'msHyphens' in $5316a422e7ea2c99$var$style) {
        $5316a422e7ea2c99$var$js = 'ms';
        $5316a422e7ea2c99$var$css = $5316a422e7ea2c99$var$jsCssMap.ms;
        $5316a422e7ea2c99$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($5316a422e7ea2c99$var$js === 'Webkit' && '-apple-trailing-word' in $5316a422e7ea2c99$var$style) $5316a422e7ea2c99$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $5316a422e7ea2c99$export$82e9f45cca5ba907 = {
    js: $5316a422e7ea2c99$var$js,
    css: $5316a422e7ea2c99$var$css,
    vendor: $5316a422e7ea2c99$var$vendor,
    browser: $5316a422e7ea2c99$var$browser,
    isTouch: $5316a422e7ea2c99$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $5316a422e7ea2c99$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $5316a422e7ea2c99$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $5316a422e7ea2c99$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $5316a422e7ea2c99$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Webkit') return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $5316a422e7ea2c99$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $5316a422e7ea2c99$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $5316a422e7ea2c99$var$camelize(str) {
    return str.replace($5316a422e7ea2c99$var$regExp, $5316a422e7ea2c99$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $5316a422e7ea2c99$var$pascalize(str) {
    return $5316a422e7ea2c99$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $5316a422e7ea2c99$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($5316a422e7ea2c99$var$camelize(longhand) in style) return prop;
            if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js + $5316a422e7ea2c99$var$pascalize(longhand) in style) return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $5316a422e7ea2c99$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.vendor === 'apple' && !$5316a422e7ea2c99$export$82e9f45cca5ba907.isTouch) return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $5316a422e7ea2c99$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $5316a422e7ea2c99$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $5316a422e7ea2c99$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Webkit' || $5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms' && $5316a422e7ea2c99$export$82e9f45cca5ba907.browser !== 'edge') return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $5316a422e7ea2c99$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Moz' || $5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms' || $5316a422e7ea2c99$export$82e9f45cca5ba907.vendor === 'apple') return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $5316a422e7ea2c99$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $5316a422e7ea2c99$var$pascalize(prop);
            return jsProp in style ? $5316a422e7ea2c99$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $5316a422e7ea2c99$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $5316a422e7ea2c99$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $5316a422e7ea2c99$export$82e9f45cca5ba907.js + $5316a422e7ea2c99$var$pascalize(newProp) in style ? $5316a422e7ea2c99$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $5316a422e7ea2c99$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $5316a422e7ea2c99$var$camelize(prop) in style ? prop : false;
    }
};
var $5316a422e7ea2c99$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $5316a422e7ea2c99$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js + pascalized in style) return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $5316a422e7ea2c99$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms') return "" + $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $5316a422e7ea2c99$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($5316a422e7ea2c99$export$82e9f45cca5ba907.js === 'ms') return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $5316a422e7ea2c99$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $5316a422e7ea2c99$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $5316a422e7ea2c99$var$propMap[prop];
        if (!newProp) return false;
        return $5316a422e7ea2c99$export$82e9f45cca5ba907.js + $5316a422e7ea2c99$var$pascalize(newProp) in style ? $5316a422e7ea2c99$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $5316a422e7ea2c99$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $5316a422e7ea2c99$var$propKeys = Object.keys($5316a422e7ea2c99$var$propMap$1);
var $5316a422e7ea2c99$var$prefixCss = function prefixCss(p) {
    return $5316a422e7ea2c99$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $5316a422e7ea2c99$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($5316a422e7ea2c99$var$propKeys.indexOf(prop) > -1) {
            var newProp = $5316a422e7ea2c99$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $5316a422e7ea2c99$export$82e9f45cca5ba907.js + $5316a422e7ea2c99$var$pascalize(newProp) in style ? $5316a422e7ea2c99$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($5316a422e7ea2c99$export$82e9f45cca5ba907.js + $5316a422e7ea2c99$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($5316a422e7ea2c99$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $5316a422e7ea2c99$var$plugins = [
    $5316a422e7ea2c99$var$appearence,
    $5316a422e7ea2c99$var$colorAdjust,
    $5316a422e7ea2c99$var$mask,
    $5316a422e7ea2c99$var$textOrientation,
    $5316a422e7ea2c99$var$transform,
    $5316a422e7ea2c99$var$transition,
    $5316a422e7ea2c99$var$writingMode,
    $5316a422e7ea2c99$var$userSelect,
    $5316a422e7ea2c99$var$breakPropsOld,
    $5316a422e7ea2c99$var$inlineLogicalOld,
    $5316a422e7ea2c99$var$unprefixed,
    $5316a422e7ea2c99$var$prefixed,
    $5316a422e7ea2c99$var$scrollSnap,
    $5316a422e7ea2c99$var$overscrollBehavior,
    $5316a422e7ea2c99$var$flex2012,
    $5316a422e7ea2c99$var$flex2009
];
var $5316a422e7ea2c99$var$propertyDetectors = $5316a422e7ea2c99$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $5316a422e7ea2c99$var$noPrefill = $5316a422e7ea2c99$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $6kfYZ.default)(p.noPrefill));
    return a;
}, []);
var $5316a422e7ea2c99$var$el;
var $5316a422e7ea2c99$var$cache = {};
if (0, $cgBlS.default) {
    $5316a422e7ea2c99$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $5316a422e7ea2c99$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $5316a422e7ea2c99$var$key$1 in $5316a422e7ea2c99$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($5316a422e7ea2c99$var$key$1)) $5316a422e7ea2c99$var$cache[$5316a422e7ea2c99$var$computed[$5316a422e7ea2c99$var$key$1]] = $5316a422e7ea2c99$var$computed[$5316a422e7ea2c99$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $5316a422e7ea2c99$var$noPrefill.forEach(function(x) {
        return delete $5316a422e7ea2c99$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $5316a422e7ea2c99$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$5316a422e7ea2c99$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($5316a422e7ea2c99$var$cache[prop] != null) return $5316a422e7ea2c99$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $5316a422e7ea2c99$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $5316a422e7ea2c99$var$propertyDetectors.length; i++){
        $5316a422e7ea2c99$var$cache[prop] = $5316a422e7ea2c99$var$propertyDetectors[i](prop, $5316a422e7ea2c99$var$el.style, options); // Break loop, if value found.
        if ($5316a422e7ea2c99$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $5316a422e7ea2c99$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $5316a422e7ea2c99$var$cache[prop];
}
var $5316a422e7ea2c99$var$cache$1 = {};
var $5316a422e7ea2c99$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $5316a422e7ea2c99$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $5316a422e7ea2c99$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $5316a422e7ea2c99$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $5316a422e7ea2c99$export$ce097f82c2e4551a(p1) : ", " + $5316a422e7ea2c99$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $cgBlS.default) $5316a422e7ea2c99$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $5316a422e7ea2c99$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$5316a422e7ea2c99$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($5316a422e7ea2c99$var$cache$1[cacheKey] != null) return $5316a422e7ea2c99$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $5316a422e7ea2c99$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $5316a422e7ea2c99$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($5316a422e7ea2c99$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($5316a422e7ea2c99$var$transPropsRegExp, $5316a422e7ea2c99$var$prefixTransitionCallback);
    else if ($5316a422e7ea2c99$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $5316a422e7ea2c99$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $5316a422e7ea2c99$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $5316a422e7ea2c99$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($5316a422e7ea2c99$var$el$1.style[property] === '') {
            $5316a422e7ea2c99$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $5316a422e7ea2c99$var$el$1.style[property] = ''; // Write current value to cache.
    $5316a422e7ea2c99$var$cache$1[cacheKey] = prefixedValue;
    return $5316a422e7ea2c99$var$cache$1[cacheKey];
}

});
parcelRegister("6kfYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b1022e70a21c5b$export$2e2bcd8739ae039);

var $88Nvy = parcelRequire("88Nvy");

var $6FnDC = parcelRequire("6FnDC");

var $3bQlz = parcelRequire("3bQlz");

var $5QCpG = parcelRequire("5QCpG");
function $49b1022e70a21c5b$export$2e2bcd8739ae039(r) {
    return (0, $88Nvy.default)(r) || (0, $6FnDC.default)(r) || (0, $3bQlz.default)(r) || (0, $5QCpG.default)();
}

});
parcelRegister("88Nvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed5795354a95201$export$2e2bcd8739ae039);

var $9nqk3 = parcelRequire("9nqk3");
function $5ed5795354a95201$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9nqk3.default)(r);
}

});
parcelRegister("9nqk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d3aae24a1121687$export$2e2bcd8739ae039);
function $6d3aae24a1121687$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6FnDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da8e86e3d601eac$export$2e2bcd8739ae039);
function $4da8e86e3d601eac$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("3bQlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $252b01309536fa98$export$2e2bcd8739ae039);

var $9nqk3 = parcelRequire("9nqk3");
function $252b01309536fa98$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9nqk3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9nqk3.default)(r, a) : void 0;
    }
}

});

parcelRegister("5QCpG", function(module, exports) {

$parcel$export(module.exports, "default", () => $441f9b24dce31535$export$2e2bcd8739ae039);
function $441f9b24dce31535$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("fvRry", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4b33502bbcd9f5f$export$2e2bcd8739ae039);
/**
 * Sort props by length.
 */ function $b4b33502bbcd9f5f$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $b4b33502bbcd9f5f$export$2e2bcd8739ae039 = $b4b33502bbcd9f5f$var$jssPropsSort;

});



parcelRegister("1Pckh", function(module, exports) {

$parcel$export(module.exports, "increment", () => $15441d95bd420919$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $15441d95bd420919$var$indexCounter = -1000000000;
function $15441d95bd420919$export$a2647aa13413c947() {
    $15441d95bd420919$var$indexCounter += 1;
    if ($15441d95bd420919$var$indexCounter >= 0) console.warn([
        'Material-UI: You might have a memory leak.',
        'The indexCounter is not supposed to grow that much.'
    ].join('\n'));
    return $15441d95bd420919$var$indexCounter;
}

});

parcelRegister("2HcOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f698acf40394a12$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $5z6Dx = parcelRequire("5z6Dx");

var $lERz5 = parcelRequire("lERz5");

var $ezmNJ = parcelRequire("ezmNJ");
function $1f698acf40394a12$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    if ((0, $5z6Dx.default)(stylesOrCreator) !== 'object' && !themingEnabled) console.error([
        'Material-UI: The `styles` argument provided is invalid.',
        'You need to provide a function generating the styles or a styles object.'
    ].join('\n'));
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                if (themingEnabled === true && theme === (0, $ezmNJ.default)) // TODO: prepend error message/name instead
                console.error([
                    'Material-UI: The `styles` argument provided is invalid.',
                    'You are providing a function without a theme in the context.',
                    'One of the parent elements needs to use a ThemeProvider.'
                ].join('\n'));
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $fXPf9.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                if (!stylesWithOverrides[key]) console.warn([
                    'Material-UI: You are trying to override a style that does not exist.',
                    "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")
                ].join('\n'));
                stylesWithOverrides[key] = (0, $lERz5.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("lERz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc46e242c63a29a9$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $5z6Dx = parcelRequire("5z6Dx");
function $fc46e242c63a29a9$export$53b83ca8eaab0383(item) {
    return item && (0, $5z6Dx.default)(item) === 'object' && item.constructor === Object;
}
function $fc46e242c63a29a9$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $fXPf9.default)({}, target) : target;
    if ($fc46e242c63a29a9$export$53b83ca8eaab0383(target) && $fc46e242c63a29a9$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($fc46e242c63a29a9$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $fc46e242c63a29a9$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("ezmNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b60564e6db32fa$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
var $a9b60564e6db32fa$var$noopTheme = {};
var $a9b60564e6db32fa$export$2e2bcd8739ae039 = $a9b60564e6db32fa$var$noopTheme;

});



parcelRegister("dxjd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dad4223423b91b3$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-syntax */ function $9dad4223423b91b3$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("6MwfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f003e796bc7f529$export$2e2bcd8739ae039);

var $kITGR = parcelRequire("kITGR");
var $4f003e796bc7f529$var$defaultTheme = (0, $kITGR.default)();
var $4f003e796bc7f529$export$2e2bcd8739ae039 = $4f003e796bc7f529$var$defaultTheme;

});
parcelRegister("kITGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1631da939d2081d$export$2e2bcd8739ae039);

var $6JmtS = parcelRequire("6JmtS");

var $cVOSt = parcelRequire("cVOSt");

var $lERz5 = parcelRequire("lERz5");

var $5vZNX = parcelRequire("5vZNX");

var $dPiW4 = parcelRequire("dPiW4");

var $ltdBf = parcelRequire("ltdBf");

var $31Ovo = parcelRequire("31Ovo");

var $8Xspk = parcelRequire("8Xspk");

var $eVP5a = parcelRequire("eVP5a");

var $lm2QE = parcelRequire("lm2QE");

var $gERaq = parcelRequire("gERaq");

var $asx4i = parcelRequire("asx4i");
function $f1631da939d2081d$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $cVOSt.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $ltdBf.default)(paletteInput);
    var breakpoints = (0, $5vZNX.default)(breakpointsInput);
    var spacing = (0, $lm2QE.default)(spacingInput);
    var muiTheme = (0, $lERz5.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $dPiW4.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $8Xspk.default),
        typography: (0, $31Ovo.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $eVP5a.default),
        transitions: (0, $gERaq.default),
        zIndex: (0, $asx4i.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $lERz5.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses = [
        'checked',
        'disabled',
        'error',
        'focused',
        'focusVisible',
        'required',
        'expanded',
        'selected'
    ];
    var traverse = function traverse(node, parentKey) {
        var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(key in node){
            var child = node[key];
            if (depth === 1) {
                if (key.indexOf('Mui') === 0 && child) traverse(child, key, depth + 1);
            } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
                console.error([
                    "Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."),
                    'You can not override it like this: ',
                    JSON.stringify(node, null, 2),
                    '',
                    'Instead, you need to use the $ruleName syntax:',
                    JSON.stringify({
                        root: (0, $6JmtS.default)({}, "&$".concat(key), child)
                    }, null, 2),
                    '',
                    'https://mui.com/r/pseudo-classes-guide'
                ].join('\n'));
                node[key] = {};
            }
        }
    };
    traverse(muiTheme.overrides);
    return muiTheme;
}
var $f1631da939d2081d$var$warnedOnce = false;
function $f1631da939d2081d$export$c469355549431d9b() {
    if (!$f1631da939d2081d$var$warnedOnce) {
        $f1631da939d2081d$var$warnedOnce = true;
        console.error([
            'Material-UI: the createMuiTheme function was renamed to createTheme.',
            '',
            "You should use `import { createTheme } from '@material-ui/core/styles'`"
        ].join('\n'));
    }
    return $f1631da939d2081d$var$createTheme.apply(void 0, arguments);
}
var $f1631da939d2081d$export$2e2bcd8739ae039 = $f1631da939d2081d$var$createTheme;

});
parcelRegister("5vZNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $403fca1e4269a72d$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");
var $403fca1e4269a72d$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $403fca1e4269a72d$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $cVOSt.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $403fca1e4269a72d$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$403fca1e4269a72d$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $403fca1e4269a72d$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $403fca1e4269a72d$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $403fca1e4269a72d$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$403fca1e4269a72d$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$403fca1e4269a72d$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        if (!warnedOnce) {
            warnedOnce = true;
            console.warn([
                "Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.",
                'Use the `theme.breakpoints.values` instead.'
            ].join('\n'));
        }
        return values[key];
    }
    return (0, $fXPf9.default)({
        keys: $403fca1e4269a72d$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("dPiW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10eb9fd84344aee$export$2e2bcd8739ae039);

var $6JmtS = parcelRequire("6JmtS");

var $fXPf9 = parcelRequire("fXPf9");
function $a10eb9fd84344aee$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $fXPf9.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $fXPf9.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $6JmtS.default)({}, breakpoints.up('sm'), (0, $fXPf9.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $6JmtS.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $6JmtS.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("ltdBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa16db0708337791$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $lERz5 = parcelRequire("lERz5");

var $lu4Pr = parcelRequire("lu4Pr");

var $8Sl3l = parcelRequire("8Sl3l");

var $7FIXm = parcelRequire("7FIXm");

var $4PwHl = parcelRequire("4PwHl");

var $jilrj = parcelRequire("jilrj");

var $jO8Pa = parcelRequire("jO8Pa");

var $2zyj5 = parcelRequire("2zyj5");

var $hSXK7 = parcelRequire("hSXK7");

var $idwNS = parcelRequire("idwNS");
var $fa16db0708337791$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $lu4Pr.default).white,
        default: (0, $8Sl3l.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $fa16db0708337791$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $lu4Pr.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $8Sl3l.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $lu4Pr.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $fa16db0708337791$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $idwNS.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $idwNS.darken)(intent.main, tonalOffsetDark);
    }
}
function $fa16db0708337791$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $7FIXm.default)[300],
        main: (0, $7FIXm.default)[500],
        dark: (0, $7FIXm.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $4PwHl.default).A200,
        main: (0, $4PwHl.default).A400,
        dark: (0, $4PwHl.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $jilrj.default)[300],
        main: (0, $jilrj.default)[500],
        dark: (0, $jilrj.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $jO8Pa.default)[300],
        main: (0, $jO8Pa.default)[500],
        dark: (0, $jO8Pa.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $2zyj5.default)[300],
        main: (0, $2zyj5.default)[500],
        dark: (0, $2zyj5.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $hSXK7.default)[300],
        main: (0, $hSXK7.default)[500],
        dark: (0, $hSXK7.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $cVOSt.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $idwNS.getContrastRatio)(background, $fa16db0708337791$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $fa16db0708337791$export$55ce6f3a06c59543.text.primary : $fa16db0708337791$export$a43af521ac8c3202.text.primary;
        var contrast = (0, $idwNS.getContrastRatio)(background, contrastText);
        if (contrast < 3) console.error([
            "Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background),
            'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.',
            'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'
        ].join('\n'));
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $fXPf9.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error("Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property."));
        if (typeof color.main !== 'string') throw new Error("Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });"));
        $fa16db0708337791$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $fa16db0708337791$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $fa16db0708337791$export$55ce6f3a06c59543,
        light: $fa16db0708337791$export$a43af521ac8c3202
    };
    if (!types[type]) console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    var paletteOutput = (0, $lERz5.default)((0, $fXPf9.default)({
        // A collection of common colors.
        common: (0, $lu4Pr.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $8Sl3l.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("lu4Pr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa402534ea5240b0$export$2e2bcd8739ae039);
var $fa402534ea5240b0$var$common = {
    black: '#000',
    white: '#fff'
};
var $fa402534ea5240b0$export$2e2bcd8739ae039 = $fa402534ea5240b0$var$common;

});

parcelRegister("8Sl3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6763b29187856ca8$export$2e2bcd8739ae039);
var $6763b29187856ca8$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $6763b29187856ca8$export$2e2bcd8739ae039 = $6763b29187856ca8$var$grey;

});

parcelRegister("7FIXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $595f3c21f202a72b$export$2e2bcd8739ae039);
var $595f3c21f202a72b$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $595f3c21f202a72b$export$2e2bcd8739ae039 = $595f3c21f202a72b$var$indigo;

});

parcelRegister("4PwHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $38454a02e6ae4672$export$2e2bcd8739ae039);
var $38454a02e6ae4672$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $38454a02e6ae4672$export$2e2bcd8739ae039 = $38454a02e6ae4672$var$pink;

});

parcelRegister("jilrj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c05438bd3c0b92$export$2e2bcd8739ae039);
var $e0c05438bd3c0b92$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $e0c05438bd3c0b92$export$2e2bcd8739ae039 = $e0c05438bd3c0b92$var$red;

});

parcelRegister("jO8Pa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b98821e36f2d86$export$2e2bcd8739ae039);
var $e6b98821e36f2d86$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $e6b98821e36f2d86$export$2e2bcd8739ae039 = $e6b98821e36f2d86$var$orange;

});

parcelRegister("2zyj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df9764cf42a5a2c$export$2e2bcd8739ae039);
var $1df9764cf42a5a2c$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $1df9764cf42a5a2c$export$2e2bcd8739ae039 = $1df9764cf42a5a2c$var$blue;

});

parcelRegister("hSXK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d055d284974a0ece$export$2e2bcd8739ae039);
var $d055d284974a0ece$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $d055d284974a0ece$export$2e2bcd8739ae039 = $d055d284974a0ece$var$green;

});

parcelRegister("idwNS", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $d432e2f4d46ffbf1$export$d061e26956a60b0a);
$parcel$export(module.exports, "emphasize", () => $d432e2f4d46ffbf1$export$e665714f76e581fd);
$parcel$export(module.exports, "darken", () => $d432e2f4d46ffbf1$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $d432e2f4d46ffbf1$export$c0816ed86df316af);
$parcel$export(module.exports, "fade", () => $d432e2f4d46ffbf1$export$cbea29d068a2e18f);
$parcel$export(module.exports, "alpha", () => $d432e2f4d46ffbf1$export$58f0f39f63f3cf42);

/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d432e2f4d46ffbf1$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (value < min || value > max) console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    return Math.min(Math.max(min, value), max);
}
function $d432e2f4d46ffbf1$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $d432e2f4d46ffbf1$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $d432e2f4d46ffbf1$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $d432e2f4d46ffbf1$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $d432e2f4d46ffbf1$var$intToHex(n);
    }).join(''));
}
function $d432e2f4d46ffbf1$export$29fb7152bd3f781a(color) {
    color = $d432e2f4d46ffbf1$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d432e2f4d46ffbf1$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $d432e2f4d46ffbf1$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d432e2f4d46ffbf1$export$677b39864803984e($d432e2f4d46ffbf1$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error("Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $d432e2f4d46ffbf1$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $d432e2f4d46ffbf1$export$d061e26956a60b0a(foreground, background) {
    var lumA = $d432e2f4d46ffbf1$export$c852d90bf7403b62(foreground);
    var lumB = $d432e2f4d46ffbf1$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $d432e2f4d46ffbf1$export$c852d90bf7403b62(color) {
    color = $d432e2f4d46ffbf1$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $d432e2f4d46ffbf1$export$677b39864803984e($d432e2f4d46ffbf1$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $d432e2f4d46ffbf1$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $d432e2f4d46ffbf1$export$c852d90bf7403b62(color) > 0.5 ? $d432e2f4d46ffbf1$export$4b073707ff63303(color, coefficient) : $d432e2f4d46ffbf1$export$c0816ed86df316af(color, coefficient);
}
var $d432e2f4d46ffbf1$var$warnedOnce = false;
function $d432e2f4d46ffbf1$export$cbea29d068a2e18f(color, value) {
    if (!$d432e2f4d46ffbf1$var$warnedOnce) {
        $d432e2f4d46ffbf1$var$warnedOnce = true;
        console.error([
            'Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.',
            '',
            "You should use `import { alpha } from '@material-ui/core/styles'`"
        ].join('\n'));
    }
    return $d432e2f4d46ffbf1$export$58f0f39f63f3cf42(color, value);
}
function $d432e2f4d46ffbf1$export$58f0f39f63f3cf42(color, value) {
    color = $d432e2f4d46ffbf1$export$677b39864803984e(color);
    value = $d432e2f4d46ffbf1$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $d432e2f4d46ffbf1$export$211a73f2b8c10ce4(color);
}
function $d432e2f4d46ffbf1$export$4b073707ff63303(color, coefficient) {
    color = $d432e2f4d46ffbf1$export$677b39864803984e(color);
    coefficient = $d432e2f4d46ffbf1$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d432e2f4d46ffbf1$export$211a73f2b8c10ce4(color);
}
function $d432e2f4d46ffbf1$export$c0816ed86df316af(color, coefficient) {
    color = $d432e2f4d46ffbf1$export$677b39864803984e(color);
    coefficient = $d432e2f4d46ffbf1$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $d432e2f4d46ffbf1$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("31Ovo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2348a465de55c573$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $lERz5 = parcelRequire("lERz5");
function $2348a465de55c573$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $2348a465de55c573$var$warnedOnce = false;
function $2348a465de55c573$var$roundWithDeprecationWarning(value) {
    if (!$2348a465de55c573$var$warnedOnce) {
        console.warn([
            'Material-UI: The `theme.typography.round` helper is deprecated.',
            'Head to https://mui.com/r/migration-v4/#theme for a migration path.'
        ].join('\n'));
        $2348a465de55c573$var$warnedOnce = true;
    }
    return $2348a465de55c573$var$round(value);
}
var $2348a465de55c573$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $2348a465de55c573$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $2348a465de55c573$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $2348a465de55c573$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $cVOSt.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    if (typeof fontSize !== 'number') console.error('Material-UI: `fontSize` is required to be a number.');
    if (typeof htmlFontSize !== 'number') console.error('Material-UI: `htmlFontSize` is required to be a number.');
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $fXPf9.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $2348a465de55c573$var$defaultFontFamily ? {
            letterSpacing: "".concat($2348a465de55c573$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $2348a465de55c573$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $2348a465de55c573$var$caseAllCaps)
    };
    return (0, $lERz5.default)((0, $fXPf9.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $2348a465de55c573$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("8Xspk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6859de8c5a9206c5$export$2e2bcd8739ae039);
var $6859de8c5a9206c5$var$shadowKeyUmbraOpacity = 0.2;
var $6859de8c5a9206c5$var$shadowKeyPenumbraOpacity = 0.14;
var $6859de8c5a9206c5$var$shadowAmbientShadowOpacity = 0.12;
function $6859de8c5a9206c5$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($6859de8c5a9206c5$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($6859de8c5a9206c5$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($6859de8c5a9206c5$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $6859de8c5a9206c5$var$shadows = [
    'none',
    $6859de8c5a9206c5$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $6859de8c5a9206c5$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $6859de8c5a9206c5$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $6859de8c5a9206c5$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $6859de8c5a9206c5$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $6859de8c5a9206c5$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $6859de8c5a9206c5$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $6859de8c5a9206c5$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $6859de8c5a9206c5$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $6859de8c5a9206c5$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $6859de8c5a9206c5$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $6859de8c5a9206c5$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $6859de8c5a9206c5$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $6859de8c5a9206c5$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $6859de8c5a9206c5$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $6859de8c5a9206c5$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $6859de8c5a9206c5$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $6859de8c5a9206c5$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $6859de8c5a9206c5$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $6859de8c5a9206c5$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $6859de8c5a9206c5$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $6859de8c5a9206c5$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $6859de8c5a9206c5$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $6859de8c5a9206c5$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $6859de8c5a9206c5$export$2e2bcd8739ae039 = $6859de8c5a9206c5$var$shadows;

});

parcelRegister("eVP5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $adee036d81884476$export$2e2bcd8739ae039);
var $adee036d81884476$var$shape = {
    borderRadius: 4
};
var $adee036d81884476$export$2e2bcd8739ae039 = $adee036d81884476$var$shape;

});

parcelRegister("lm2QE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8bddca5d4e55431$export$2e2bcd8739ae039);

var $gbfsn = parcelRequire("gbfsn");
var $f8bddca5d4e55431$var$warnOnce;
function $f8bddca5d4e55431$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $gbfsn.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!(args.length <= 4)) console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            if (!$f8bddca5d4e55431$var$warnOnce || false) console.error([
                'Material-UI: theme.spacing.unit usage has been deprecated.',
                'It will be removed in v5.',
                'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.',
                '',
                'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'
            ].join('\n'));
            $f8bddca5d4e55431$var$warnOnce = true;
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("gbfsn", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", () => $bc79a9c8e512c57f$export$1def6f833384e3d1);
$parcel$export(module.exports, "default", () => $bc79a9c8e512c57f$export$2e2bcd8739ae039);

var $30ito = parcelRequire("30ito");

var $6I38e = parcelRequire("6I38e");

var $esfZy = parcelRequire("esfZy");

var $1vXAh = parcelRequire("1vXAh");

var $hHwL0 = parcelRequire("hHwL0");
var $bc79a9c8e512c57f$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $bc79a9c8e512c57f$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $bc79a9c8e512c57f$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $bc79a9c8e512c57f$var$getCssProperties = (0, $hHwL0.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($bc79a9c8e512c57f$var$aliases[prop]) prop = $bc79a9c8e512c57f$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $30ito.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $bc79a9c8e512c57f$var$properties[a];
    var direction = $bc79a9c8e512c57f$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $bc79a9c8e512c57f$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $bc79a9c8e512c57f$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        if (typeof abs !== 'number') console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        if (abs > themeSpacing.length - 1) console.error([
            "Material-UI: The value provided (".concat(abs, ") overflows."),
            "The supported values are: ".concat(JSON.stringify(themeSpacing), "."),
            "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")
        ].join('\n'));
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    console.error([
        "Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."),
        'It should be a number, an array or a function.'
    ].join('\n'));
    return function() {
        return undefined;
    };
}
function $bc79a9c8e512c57f$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $bc79a9c8e512c57f$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $bc79a9c8e512c57f$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $bc79a9c8e512c57f$var$spacing(props) {
    var theme = props.theme;
    var transformer = $bc79a9c8e512c57f$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($bc79a9c8e512c57f$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $bc79a9c8e512c57f$var$getCssProperties(prop);
        var styleFromPropValue = $bc79a9c8e512c57f$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $esfZy.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $1vXAh.default), {});
}
$bc79a9c8e512c57f$var$spacing.propTypes = $bc79a9c8e512c57f$var$spacingKeys.reduce(function(obj, key) {
    obj[key] = (0, $6I38e.default);
    return obj;
}, {});
$bc79a9c8e512c57f$var$spacing.filterProps = $bc79a9c8e512c57f$var$spacingKeys;
var $bc79a9c8e512c57f$export$2e2bcd8739ae039 = $bc79a9c8e512c57f$var$spacing;

});
parcelRegister("30ito", function(module, exports) {

$parcel$export(module.exports, "default", () => $22ffb38c0c818141$export$2e2bcd8739ae039);

var $jUBPx = parcelRequire("jUBPx");

var $dkttC = parcelRequire("dkttC");

var $3bQlz = parcelRequire("3bQlz");

var $gdWah = parcelRequire("gdWah");
function $22ffb38c0c818141$export$2e2bcd8739ae039(r, e) {
    return (0, $jUBPx.default)(r) || (0, $dkttC.default)(r, e) || (0, $3bQlz.default)(r, e) || (0, $gdWah.default)();
}

});
parcelRegister("jUBPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f09794ca822d94$export$2e2bcd8739ae039);
function $e7f09794ca822d94$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("dkttC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b44021186839025$export$2e2bcd8739ae039);
function $9b44021186839025$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gdWah", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcfafa8e163e9b83$export$2e2bcd8739ae039);
function $bcfafa8e163e9b83$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6I38e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e29480cdc23e11b$export$2e2bcd8739ae039);

var $fcOLE = parcelRequire("fcOLE");
var $4e29480cdc23e11b$var$responsivePropType = (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).array
]);
var $4e29480cdc23e11b$export$2e2bcd8739ae039 = $4e29480cdc23e11b$var$responsivePropType;

});

parcelRegister("esfZy", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", () => $02b73a28bddd45d8$export$88347efdb2e19abd);

var $6kfYZ = parcelRequire("6kfYZ");

var $fXPf9 = parcelRequire("fXPf9");

var $5z6Dx = parcelRequire("5z6Dx");

var $fcOLE = parcelRequire("fcOLE");

var $1vXAh = parcelRequire("1vXAh");
// For instance with the first breakpoint xs: [xs, sm[.
var $02b73a28bddd45d8$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $02b73a28bddd45d8$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($02b73a28bddd45d8$var$values[key], "px)");
    }
};
function $02b73a28bddd45d8$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (!props.theme) console.error('Material-UI: You are calling a style function without a theme value.');
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $02b73a28bddd45d8$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $5z6Dx.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $02b73a28bddd45d8$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $02b73a28bddd45d8$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $02b73a28bddd45d8$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $fXPf9.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $1vXAh.default)(base, extended);
    };
    newStyleFunction.propTypes = (0, $fXPf9.default)({}, styleFunction.propTypes, {
        xs: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
        sm: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
        md: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
        lg: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
        xl: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
    });
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $6kfYZ.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $02b73a28bddd45d8$export$2e2bcd8739ae039 = $02b73a28bddd45d8$var$breakpoints;

});
parcelRegister("1vXAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a6e7e1f2bbcaec$export$2e2bcd8739ae039);

var $lERz5 = parcelRequire("lERz5");
function $11a6e7e1f2bbcaec$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $lERz5.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $11a6e7e1f2bbcaec$export$2e2bcd8739ae039 = $11a6e7e1f2bbcaec$var$merge;

});


parcelRegister("hHwL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2fdcb4e3d1f169$export$2e2bcd8739ae039);
function $ce2fdcb4e3d1f169$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("gERaq", function(module, exports) {

$parcel$export(module.exports, "duration", () => $c2099fa7b107979f$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $c2099fa7b107979f$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");
var $c2099fa7b107979f$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $c2099fa7b107979f$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $c2099fa7b107979f$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $c2099fa7b107979f$export$2e2bcd8739ae039 = {
    easing: $c2099fa7b107979f$export$24c5ac7c37452e7d,
    duration: $c2099fa7b107979f$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $c2099fa7b107979f$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $c2099fa7b107979f$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $cVOSt.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString = function isString(value) {
            return typeof value === 'string';
        };
        var isNumber = function isNumber(value) {
            return !isNaN(parseFloat(value));
        };
        if (!isString(props) && !Array.isArray(props)) console.error('Material-UI: Argument "props" must be a string or Array.');
        if (!isNumber(durationOption) && !isString(durationOption)) console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
        if (!isString(easingOption)) console.error('Material-UI: Argument "easing" must be a string.');
        if (!isNumber(delay) && !isString(delay)) console.error('Material-UI: Argument "delay" must be a number or a string.');
        if (Object.keys(other).length !== 0) console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $c2099fa7b107979f$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $c2099fa7b107979f$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("asx4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $79d62b971a8f7657$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $79d62b971a8f7657$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $79d62b971a8f7657$export$2e2bcd8739ae039 = $79d62b971a8f7657$var$zIndex;

});




parcelRegister("7OrFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b02aac1a7ce0fe0$export$2e2bcd8739ae039);

function $5b02aac1a7ce0fe0$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error("Material-UI: capitalize(string) expects a string argument.");
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("bDH0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $8794b1aa5824b0ca$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $2VSrH = parcelRequire("2VSrH");
function $8794b1aa5824b0ca$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $J42oT.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $2VSrH.default)(refA, refValue);
            (0, $2VSrH.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("2VSrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $222b236ec56b52cd$export$2e2bcd8739ae039);
// TODO v5: consider to make it private
function $222b236ec56b52cd$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("9tpKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e5acb2bdf46b33f$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $cVQrg = parcelRequire("cVQrg");

var $bDH0e = parcelRequire("bDH0e");

var $6CUay = parcelRequire("6CUay");
function $6e5acb2bdf46b33f$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $6e5acb2bdf46b33f$var$useEnhancedEffect = typeof window !== 'undefined' ? $J42oT.useLayoutEffect : $J42oT.useEffect;
var $6e5acb2bdf46b33f$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
var $6e5acb2bdf46b33f$var$TextareaAutosize = /*#__PURE__*/ $J42oT.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $cVOSt.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $J42oT.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $J42oT.useRef(null);
    var handleRef = (0, $bDH0e.default)(ref, inputRef);
    var shadowRef = $J42oT.useRef(null);
    var renders = $J42oT.useRef(0);
    var _React$useState = $J42oT.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $J42oT.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        var boxSizing = computedStyle['box-sizing'];
        var padding = $6e5acb2bdf46b33f$var$getStyleValue(computedStyle, 'padding-bottom') + $6e5acb2bdf46b33f$var$getStyleValue(computedStyle, 'padding-top');
        var border = $6e5acb2bdf46b33f$var$getStyleValue(computedStyle, 'border-bottom-width') + $6e5acb2bdf46b33f$var$getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            if (renders.current === 20) console.error([
                'Material-UI: Too many re-renders. The layout is unstable.',
                'TextareaAutosize limits the number of renders to prevent an infinite loop.'
            ].join('\n'));
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $J42oT.useEffect(function() {
        var handleResize = (0, $cVQrg.default)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        syncHeight
    ]);
    $6e5acb2bdf46b33f$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $J42oT.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, /*#__PURE__*/ $J42oT.createElement("textarea", (0, $fXPf9.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $fXPf9.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? 'hidden' : null
        }, style)
    }, other)), /*#__PURE__*/ $J42oT.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $fXPf9.default)({}, $6e5acb2bdf46b33f$var$styles.shadow, style)
    }));
});
$6e5acb2bdf46b33f$var$TextareaAutosize.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Maximum number of rows to display.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Minimum number of rows to display.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */ rows: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]), 'Use `minRows` instead.'),
    /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */ rowsMax: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]), 'Use `maxRows` instead.'),
    /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */ rowsMin: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]), 'Use `minRows` instead.'),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ])
};
var $6e5acb2bdf46b33f$export$2e2bcd8739ae039 = $6e5acb2bdf46b33f$var$TextareaAutosize;

});
parcelRegister("cVQrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a37c292267a402$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $96a37c292267a402$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("f3VeP", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $af738928921cbcf4$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $af738928921cbcf4$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $af738928921cbcf4$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $af738928921cbcf4$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($af738928921cbcf4$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $af738928921cbcf4$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
function $af738928921cbcf4$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});



parcelRegister("ddikI", function(module, exports) {

$parcel$export(module.exports, "default", () => $99eab5dc98431f2a$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $8LPju = parcelRequire("8LPju");

var $cV5xs = parcelRequire("cV5xs");
var $99eab5dc98431f2a$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            '&:hover': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: backgroundColor
                }
            },
            '&$focused': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
            },
            '&$disabled': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:before': {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '27px 12px 10px',
            '&$marginDense': {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '27px 12px 10px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            '&$inputMarginDense': {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $99eab5dc98431f2a$var$FilledInput = /*#__PURE__*/ $J42oT.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $cVOSt.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $8LPju.default), (0, $fXPf9.default)({
        classes: (0, $fXPf9.default)({}, classes, {
            root: (0, $lKxJt.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$99eab5dc98431f2a$var$FilledInput.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the `input` element will be focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The default `input` element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the `input` element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $bYG1J.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * If `true`, a textarea element will be rendered.
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The short hint displayed in the input before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the `input` element will be required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any
};
$99eab5dc98431f2a$var$FilledInput.muiName = 'Input';
var $99eab5dc98431f2a$export$2e2bcd8739ae039 = (0, $cV5xs.default)($99eab5dc98431f2a$export$9dd6ff9ea0189349, {
    name: 'MuiFilledInput'
})($99eab5dc98431f2a$var$FilledInput);

});

parcelRegister("2hFu1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9d58fcd5fef35d$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $8LPju = parcelRequire("8LPju");

var $6PiyU = parcelRequire("6PiyU");

var $cV5xs = parcelRequire("cV5xs");
var $1a9d58fcd5fef35d$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            '&:hover $notchedOutline': {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: borderColor
                }
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '18.5px 14px',
            '&$marginDense': {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '18.5px 14px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $1a9d58fcd5fef35d$var$OutlinedInput = /*#__PURE__*/ $J42oT.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $cVOSt.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $8LPju.default), (0, $fXPf9.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $J42oT.createElement((0, $6PiyU.default), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $fXPf9.default)({}, classes, {
            root: (0, $lKxJt.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$1a9d58fcd5fef35d$var$OutlinedInput.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the `input` element will be focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The default `input` element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the `input` element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $bYG1J.default),
    /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */ labelWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * If `true`, a textarea element will be rendered.
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The short hint displayed in the input before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the `input` element will be required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any
};
$1a9d58fcd5fef35d$var$OutlinedInput.muiName = 'Input';
var $1a9d58fcd5fef35d$export$2e2bcd8739ae039 = (0, $cV5xs.default)($1a9d58fcd5fef35d$export$9dd6ff9ea0189349, {
    name: 'MuiOutlinedInput'
})($1a9d58fcd5fef35d$var$OutlinedInput);

});
parcelRegister("6PiyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f85e78d546ea76b$export$2e2bcd8739ae039);

var $6JmtS = parcelRequire("6JmtS");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $IQ3Oi = parcelRequire("IQ3Oi");

var $7OrFE = parcelRequire("7OrFE");
var $4f85e78d546ea76b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: '0 8px',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            borderStyle: 'solid',
            borderWidth: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: 'left',
            padding: 0,
            lineHeight: '11px',
            // sync with `height` in `legend` styles
            transition: theme.transitions.create('width', {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: 'block',
            width: 'auto',
            textAlign: 'left',
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: '0.75em',
            visibility: 'hidden',
            maxWidth: 0.01,
            transition: theme.transitions.create('max-width', {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            '& > span': {
                paddingLeft: 5,
                paddingRight: 5,
                display: 'inline-block'
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create('max-width', {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $4f85e78d546ea76b$var$NotchedOutline = /*#__PURE__*/ $J42oT.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $IQ3Oi.default)();
    var align = theme.direction === 'rtl' ? 'right' : 'left';
    if (label !== undefined) return /*#__PURE__*/ $J42oT.createElement("fieldset", (0, $fXPf9.default)({
        "aria-hidden": true,
        className: (0, $lKxJt.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $J42oT.createElement("legend", {
        className: (0, $lKxJt.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $J42oT.createElement("span", null, label) : /*#__PURE__*/ $J42oT.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $J42oT.createElement("fieldset", (0, $fXPf9.default)({
        "aria-hidden": true,
        style: (0, $fXPf9.default)((0, $6JmtS.default)({}, "padding".concat((0, $7OrFE.default)(align)), 8), style),
        className: (0, $lKxJt.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $J42oT.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $J42oT.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
});
$4f85e78d546ea76b$var$NotchedOutline.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The label.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * The width of the label.
   */ labelWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number.isRequired,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
var $4f85e78d546ea76b$export$2e2bcd8739ae039 = (0, $cV5xs.default)($4f85e78d546ea76b$export$9dd6ff9ea0189349, {
    name: 'PrivateNotchedOutline'
})($4f85e78d546ea76b$var$NotchedOutline);

});
parcelRegister("IQ3Oi", function(module, exports) {

$parcel$export(module.exports, "default", () => $086c7e4c10e7ef72$export$2e2bcd8739ae039);

var $27Cb9 = parcelRequire("27Cb9");

var $J42oT = parcelRequire("J42oT");

var $6MwfJ = parcelRequire("6MwfJ");
function $086c7e4c10e7ef72$export$2e2bcd8739ae039() {
    var theme = (0, $27Cb9.default)() || (0, $6MwfJ.default);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).useDebugValue(theme);
    return theme;
}

});



parcelRegister("fDlpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61b1b3ef57f7319$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $lyguR = parcelRequire("lyguR");

var $24AJO = parcelRequire("24AJO");

var $cV5xs = parcelRequire("cV5xs");

var $hfCm8 = parcelRequire("hfCm8");
var $b61b1b3ef57f7319$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            transformOrigin: 'top left'
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: 'absolute',
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: 'translate(0, 24px) scale(1)'
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: 'translate(0, 21px) scale(1)'
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                'color',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(12px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(12px, 17px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(12px, 10px) scale(0.75)',
                '&$marginDense': {
                    transform: 'translate(12px, 7px) scale(0.75)'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(14px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(14px, 12px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        }
    };
};
var $b61b1b3ef57f7319$var$InputLabel = /*#__PURE__*/ $J42oT.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $24AJO.default)();
    var shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'margin',
            'variant'
        ]
    });
    return /*#__PURE__*/ $J42oT.createElement((0, $hfCm8.default), (0, $fXPf9.default)({
        "data-shrink": shrink,
        className: (0, $lKxJt.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
            'filled': classes.filled,
            'outlined': classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
$b61b1b3ef57f7319$var$InputLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The contents of the `InputLabel`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * If `true`, the transition animation is disabled.
   */ disableAnimation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, apply disabled class.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label will be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input of this label is focused.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense'
    ]),
    /**
   * if `true`, the label will indicate that the input is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label is shrunk.
   */ shrink: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $b61b1b3ef57f7319$export$2e2bcd8739ae039 = (0, $cV5xs.default)($b61b1b3ef57f7319$export$9dd6ff9ea0189349, {
    name: 'MuiInputLabel'
})($b61b1b3ef57f7319$var$InputLabel);

});
parcelRegister("24AJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $182873e129ba514c$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $6t69i = parcelRequire("6t69i");
function $182873e129ba514c$export$2e2bcd8739ae039() {
    return $J42oT.useContext((0, $6t69i.default));
}

});

parcelRegister("hfCm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f19714aa844a43$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $lyguR = parcelRequire("lyguR");

var $24AJO = parcelRequire("24AJO");

var $7OrFE = parcelRequire("7OrFE");

var $cV5xs = parcelRequire("cV5xs");
var $c8f19714aa844a43$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $fXPf9.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            '&$focused': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused': {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            '&$error': {
                color: theme.palette.error.main
            }
        }
    };
};
var $c8f19714aa844a43$var$FormLabel = /*#__PURE__*/ $J42oT.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? 'label' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $24AJO.default)();
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes["color".concat((0, $7OrFE.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $J42oT.createElement("span", {
        "aria-hidden": true,
        className: (0, $lKxJt.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", '*'));
});
$c8f19714aa844a43$var$FormLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the label should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label will indicate that the input is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $c8f19714aa844a43$export$2e2bcd8739ae039 = (0, $cV5xs.default)($c8f19714aa844a43$export$9dd6ff9ea0189349, {
    name: 'MuiFormLabel'
})($c8f19714aa844a43$var$FormLabel);

});


parcelRegister("WrObz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afafd12937c59ea$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $f3VeP = parcelRequire("f3VeP");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");

var $bjTDo = parcelRequire("bjTDo");

var $6t69i = parcelRequire("6t69i");
var $0afafd12937c59ea$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top' // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: '100%'
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $0afafd12937c59ea$var$FormControl = /*#__PURE__*/ $J42oT.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? 'none' : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $J42oT.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $J42oT.Children.forEach(children, function(child) {
            if (!(0, $bjTDo.default)(child, [
                'Input',
                'Select'
            ])) return;
            var input = (0, $bjTDo.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $f3VeP.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $J42oT.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $J42oT.Children.forEach(children, function(child) {
            if (!(0, $bjTDo.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $f3VeP.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $J42oT.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = $J42oT.useRef(false);
    registerEffect = function registerEffect() {
        if (registeredInput.current) console.error([
            'Material-UI: There are multiple InputBase components inside a FormControl.',
            'This is not supported. It might cause infinite rendering loops.',
            'Only use one InputBase.'
        ].join('\n'));
        registeredInput.current = true;
        return function() {
            registeredInput.current = false;
        };
    };
    var onFilled = $J42oT.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $J42oT.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === 'small' ? 'dense' : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $J42oT.createElement((0, $6t69i.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, $7OrFE.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
$0afafd12937c59ea$var$FormControl.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The contents of the form control.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the component will be displayed in focused state.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the component will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * If `true`, the label will indicate that the input is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The size of the text field.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'medium',
        'small'
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $0afafd12937c59ea$export$2e2bcd8739ae039 = (0, $cV5xs.default)($0afafd12937c59ea$export$9dd6ff9ea0189349, {
    name: 'MuiFormControl'
})($0afafd12937c59ea$var$FormControl);

});
parcelRegister("bjTDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $83dc9fe8ba5818a2$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
function $83dc9fe8ba5818a2$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $J42oT.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRegister("89540", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ee31789e1041ba9$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $lyguR = parcelRequire("lyguR");

var $24AJO = parcelRequire("24AJO");

var $cV5xs = parcelRequire("cV5xs");
var $5ee31789e1041ba9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $fXPf9.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: 'left',
            marginTop: 3,
            margin: 0,
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $5ee31789e1041ba9$var$FormHelperText = /*#__PURE__*/ $J42oT.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'p' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $24AJO.default)();
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'margin',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), children === ' ' ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $J42oT.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : children);
});
$5ee31789e1041ba9$var$FormHelperText.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'dense'
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $5ee31789e1041ba9$export$2e2bcd8739ae039 = (0, $cV5xs.default)($5ee31789e1041ba9$export$9dd6ff9ea0189349, {
    name: 'MuiFormHelperText'
})($5ee31789e1041ba9$var$FormHelperText);

});

parcelRegister("ex0UA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a944dac5b831d98d$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $cDKOG = parcelRequire("cDKOG");

var $lQnDo = parcelRequire("lQnDo");

var $lyguR = parcelRequire("lyguR");

var $24AJO = parcelRequire("24AJO");

var $cV5xs = parcelRequire("cV5xs");

var $kLrPs = parcelRequire("kLrPs");

var $2KyCl = parcelRequire("2KyCl");

var $id1vj = parcelRequire("id1vj");

var $Xwc2k = parcelRequire("Xwc2k");

var $ddikI = parcelRequire("ddikI");

var $2hFu1 = parcelRequire("2hFu1");
var $a944dac5b831d98d$export$9dd6ff9ea0189349 = (0, $id1vj.styles);
var $a944dac5b831d98d$var$_ref = /*#__PURE__*/ $J42oT.createElement((0, $2KyCl.default), null);
var $a944dac5b831d98d$var$_ref2 = /*#__PURE__*/ $J42oT.createElement((0, $ddikI.default), null);
var $a944dac5b831d98d$var$Select = /*#__PURE__*/ $J42oT.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $kLrPs.default) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $Xwc2k.default) : (0, $lQnDo.default);
    var muiFormControl = (0, $24AJO.default)();
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $a944dac5b831d98d$var$_ref,
        outlined: /*#__PURE__*/ $J42oT.createElement((0, $2hFu1.default), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $a944dac5b831d98d$var$_ref2
    })[variant];
    return /*#__PURE__*/ $J42oT.cloneElement(InputComponent, (0, $fXPf9.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $fXPf9.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $fXPf9.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $cDKOG.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$a944dac5b831d98d$var$Select.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The default element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */ labelWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the component will be using a native `select` element.
   */ native: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$a944dac5b831d98d$var$Select.muiName = 'Select';
var $a944dac5b831d98d$export$2e2bcd8739ae039 = (0, $cV5xs.default)($a944dac5b831d98d$export$9dd6ff9ea0189349, {
    name: 'MuiSelect'
})($a944dac5b831d98d$var$Select);

});
parcelRegister("lQnDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe70c996451b3923$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $30ito = parcelRequire("30ito");

var $cVOSt = parcelRequire("cVOSt");

var $5z6Dx = parcelRequire("5z6Dx");

var $bYG1J = parcelRequire("bYG1J");

var $J42oT = parcelRequire("J42oT");

var $5vJdk = parcelRequire("5vJdk");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $1DuTQ = parcelRequire("1DuTQ");

var $7OrFE = parcelRequire("7OrFE");

var $4twna = parcelRequire("4twna");

var $f3VeP = parcelRequire("f3VeP");

var $bDH0e = parcelRequire("bDH0e");

var $7tsbi = parcelRequire("7tsbi");
function $fe70c996451b3923$var$areEqualValues(a, b) {
    if ((0, $5z6Dx.default)(b) === 'object' && b !== null) return a === b;
    return String(a) === String(b);
}
function $fe70c996451b3923$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $fe70c996451b3923$var$SelectInput = /*#__PURE__*/ $J42oT.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props['aria-label'], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $7tsbi.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    }), _useControlled2 = (0, $30ito.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $J42oT.useRef(null);
    var _React$useState = $J42oT.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $J42oT.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $J42oT.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $J42oT.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $bDH0e.default)(ref, inputRefProp);
    $J42oT.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $J42oT.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $J42oT.useEffect(function() {
        if (displayNode) {
            var label = (0, $1DuTQ.default)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener('click', handler);
                return function() {
                    label.removeEventListener('click', handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $J42oT.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $f3VeP.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $J42oT.isValidElement(child)) return null;
        if ((0, $5vJdk.isFragment)(child)) console.error([
            "Material-UI: The Select component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error("Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`.");
            selected = value.some(function(v) {
                return $fe70c996451b3923$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $fe70c996451b3923$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $J42oT.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $J42oT.useEffect(function() {
        if (!foundMatch && !multiple && value !== '') {
            var values = childrenArray.map(function(child) {
                return child.props.value;
            });
            console.warn([
                "Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."),
                "Consider providing a value that matches one of the available options or ''.",
                "The available values are ".concat(values.filter(function(x) {
                    return x != null;
                }).map(function(x) {
                    return "`".concat(x, "`");
                }).join(', ') || '""', ".")
            ].join('\n'));
        }
    }, [
        foundMatch,
        childrenArray,
        multiple,
        name,
        value
    ]);
    if (computeDisplay) display = multiple ? displayMultiple.join(', ') : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(' ') || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $fe70c996451b3923$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $J42oT.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : display), /*#__PURE__*/ $J42oT.createElement("input", (0, $fXPf9.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $J42oT.createElement(IconComponent, {
        className: (0, $lKxJt.default)(classes.icon, classes["icon".concat((0, $7OrFE.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $J42oT.createElement((0, $4twna.default), (0, $fXPf9.default)({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $fXPf9.default)({
            'aria-labelledby': labelId,
            role: 'listbox',
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $fXPf9.default)({}, MenuProps.PaperProps, {
            style: (0, $fXPf9.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
$fe70c996451b3923$var$SelectInput.propTypes = {
    /**
   * @ignore
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The default element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the select will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the selected item is displayed even if its value is empty.
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType.isRequired,
    /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */ inputRef: (0, $bYG1J.default),
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Control `select` open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $fe70c996451b3923$export$2e2bcd8739ae039 = $fe70c996451b3923$var$SelectInput;

});
parcelRegister("5vJdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7yQJZ"));

});
parcelRegister("7yQJZ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $58149e95b6e1d9cb$export$a7c73072b1a182ae, (v) => $58149e95b6e1d9cb$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $58149e95b6e1d9cb$export$9f27bc3417b4524d, (v) => $58149e95b6e1d9cb$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $58149e95b6e1d9cb$export$db77ccec0bb4ccac, (v) => $58149e95b6e1d9cb$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $58149e95b6e1d9cb$export$8392c0c9d3dcbd35, (v) => $58149e95b6e1d9cb$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $58149e95b6e1d9cb$export$ffb0004e005737fa, (v) => $58149e95b6e1d9cb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $58149e95b6e1d9cb$export$b624eff549462981, (v) => $58149e95b6e1d9cb$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $58149e95b6e1d9cb$export$7897aa7841a5380c, (v) => $58149e95b6e1d9cb$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $58149e95b6e1d9cb$export$602eac185826482c, (v) => $58149e95b6e1d9cb$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $58149e95b6e1d9cb$export$e2c29f18771995cb, (v) => $58149e95b6e1d9cb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $58149e95b6e1d9cb$export$5f8d39834fd61797, (v) => $58149e95b6e1d9cb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $58149e95b6e1d9cb$export$74bf444e3cd11ea5, (v) => $58149e95b6e1d9cb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $58149e95b6e1d9cb$export$92387174baf9b227, (v) => $58149e95b6e1d9cb$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $58149e95b6e1d9cb$export$ec112efeb987d9c6, (v) => $58149e95b6e1d9cb$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $58149e95b6e1d9cb$export$b706b080d889d2c9, (v) => $58149e95b6e1d9cb$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $58149e95b6e1d9cb$export$5be5a87408f70ddc, (v) => $58149e95b6e1d9cb$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $58149e95b6e1d9cb$export$45a5e7f76e0caa8d, (v) => $58149e95b6e1d9cb$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $58149e95b6e1d9cb$export$455c2e768291efa6, (v) => $58149e95b6e1d9cb$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $58149e95b6e1d9cb$export$9522e17588c12572, (v) => $58149e95b6e1d9cb$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $58149e95b6e1d9cb$export$2110ac352bb060b9, (v) => $58149e95b6e1d9cb$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $58149e95b6e1d9cb$export$56885ab8b9c456ab, (v) => $58149e95b6e1d9cb$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $58149e95b6e1d9cb$export$d927fcb6adf8f9de, (v) => $58149e95b6e1d9cb$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $58149e95b6e1d9cb$export$b82d16f27459e05a, (v) => $58149e95b6e1d9cb$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $58149e95b6e1d9cb$export$522c17b4f5e123e8, (v) => $58149e95b6e1d9cb$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $58149e95b6e1d9cb$export$1aabd8a0274ecfd6, (v) => $58149e95b6e1d9cb$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $58149e95b6e1d9cb$export$9b621391a187a31a, (v) => $58149e95b6e1d9cb$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $58149e95b6e1d9cb$export$f5bbd400c2f4426f, (v) => $58149e95b6e1d9cb$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $58149e95b6e1d9cb$export$a7c73072b1a182ae;
var $58149e95b6e1d9cb$export$9f27bc3417b4524d;
var $58149e95b6e1d9cb$export$db77ccec0bb4ccac;
var $58149e95b6e1d9cb$export$8392c0c9d3dcbd35;
var $58149e95b6e1d9cb$export$ffb0004e005737fa;
var $58149e95b6e1d9cb$export$b624eff549462981;
var $58149e95b6e1d9cb$export$7897aa7841a5380c;
var $58149e95b6e1d9cb$export$602eac185826482c;
var $58149e95b6e1d9cb$export$e2c29f18771995cb;
var $58149e95b6e1d9cb$export$5f8d39834fd61797;
var $58149e95b6e1d9cb$export$74bf444e3cd11ea5;
var $58149e95b6e1d9cb$export$92387174baf9b227;
var $58149e95b6e1d9cb$export$ec112efeb987d9c6;
var $58149e95b6e1d9cb$export$b706b080d889d2c9;
var $58149e95b6e1d9cb$export$5be5a87408f70ddc;
var $58149e95b6e1d9cb$export$45a5e7f76e0caa8d;
var $58149e95b6e1d9cb$export$455c2e768291efa6;
var $58149e95b6e1d9cb$export$9522e17588c12572;
var $58149e95b6e1d9cb$export$2110ac352bb060b9;
var $58149e95b6e1d9cb$export$56885ab8b9c456ab;
var $58149e95b6e1d9cb$export$d927fcb6adf8f9de;
var $58149e95b6e1d9cb$export$b82d16f27459e05a;
var $58149e95b6e1d9cb$export$522c17b4f5e123e8;
var $58149e95b6e1d9cb$export$1aabd8a0274ecfd6;
var $58149e95b6e1d9cb$export$9b621391a187a31a;
var $58149e95b6e1d9cb$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $58149e95b6e1d9cb$export$a7c73072b1a182ae = ContextConsumer;
    $58149e95b6e1d9cb$export$9f27bc3417b4524d = ContextProvider;
    $58149e95b6e1d9cb$export$db77ccec0bb4ccac = Element;
    $58149e95b6e1d9cb$export$8392c0c9d3dcbd35 = ForwardRef;
    $58149e95b6e1d9cb$export$ffb0004e005737fa = Fragment;
    $58149e95b6e1d9cb$export$b624eff549462981 = Lazy;
    $58149e95b6e1d9cb$export$7897aa7841a5380c = Memo;
    $58149e95b6e1d9cb$export$602eac185826482c = Portal;
    $58149e95b6e1d9cb$export$e2c29f18771995cb = Profiler;
    $58149e95b6e1d9cb$export$5f8d39834fd61797 = StrictMode;
    $58149e95b6e1d9cb$export$74bf444e3cd11ea5 = Suspense;
    $58149e95b6e1d9cb$export$92387174baf9b227 = isAsyncMode;
    $58149e95b6e1d9cb$export$ec112efeb987d9c6 = isConcurrentMode;
    $58149e95b6e1d9cb$export$b706b080d889d2c9 = isContextConsumer;
    $58149e95b6e1d9cb$export$5be5a87408f70ddc = isContextProvider;
    $58149e95b6e1d9cb$export$45a5e7f76e0caa8d = isElement;
    $58149e95b6e1d9cb$export$455c2e768291efa6 = isForwardRef;
    $58149e95b6e1d9cb$export$9522e17588c12572 = isFragment;
    $58149e95b6e1d9cb$export$2110ac352bb060b9 = isLazy;
    $58149e95b6e1d9cb$export$56885ab8b9c456ab = isMemo;
    $58149e95b6e1d9cb$export$d927fcb6adf8f9de = isPortal;
    $58149e95b6e1d9cb$export$b82d16f27459e05a = isProfiler;
    $58149e95b6e1d9cb$export$522c17b4f5e123e8 = isStrictMode;
    $58149e95b6e1d9cb$export$1aabd8a0274ecfd6 = isSuspense;
    $58149e95b6e1d9cb$export$9b621391a187a31a = isValidElementType;
    $58149e95b6e1d9cb$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("1DuTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $131166faa8833f9c$export$2e2bcd8739ae039);
function $131166faa8833f9c$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("4twna", function(module, exports) {

$parcel$export(module.exports, "default", () => $3422fb61a63058cf$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $5vJdk = parcelRequire("5vJdk");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $9qmQg = parcelRequire("9qmQg");

var $cV5xs = parcelRequire("cV5xs");

var $fteVY = parcelRequire("fteVY");

var $6CiPN = parcelRequire("6CiPN");

var $f3ft4 = parcelRequire("f3ft4");

var $2VSrH = parcelRequire("2VSrH");

var $IQ3Oi = parcelRequire("IQ3Oi");

var $6CUay = parcelRequire("6CUay");
var $3422fb61a63058cf$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var $3422fb61a63058cf$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var $3422fb61a63058cf$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: 'calc(100% - 96px)',
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: 'touch'
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $3422fb61a63058cf$var$Menu = /*#__PURE__*/ $J42oT.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $cVOSt.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $cVOSt.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $IQ3Oi.default)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $J42oT.useRef(null);
    var contentAnchorRef = $J42oT.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $J42oT.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $J42oT.isValidElement(child)) return;
        if ((0, $5vJdk.isFragment)(child)) console.error([
            "Material-UI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $J42oT.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $J42oT.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $f3ft4.findDOMNode(instance);
                (0, $2VSrH.default)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $J42oT.createElement((0, $fteVY.default), (0, $fXPf9.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $fXPf9.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === 'rtl' ? $3422fb61a63058cf$var$RTL_ORIGIN : $3422fb61a63058cf$var$LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? $3422fb61a63058cf$var$RTL_ORIGIN : $3422fb61a63058cf$var$LTR_ORIGIN,
        PaperProps: (0, $fXPf9.default)({}, PaperProps, {
            classes: (0, $fXPf9.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $J42oT.createElement((0, $6CiPN.default), (0, $fXPf9.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $lKxJt.default)(classes.list, MenuListProps.className)
    }), items));
});
$3422fb61a63058cf$var$Menu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */ disableAutoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */ MenuListProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEnter: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntered: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntering: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExit: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExited: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExiting: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * If `true`, the menu is visible.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * @ignore
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */ PopoverClasses: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The length of the transition in `ms`, or 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $3422fb61a63058cf$export$2e2bcd8739ae039 = (0, $cV5xs.default)($3422fb61a63058cf$export$9dd6ff9ea0189349, {
    name: 'MuiMenu'
})($3422fb61a63058cf$var$Menu);

});
parcelRegister("9qmQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc842af8685b975$export$2e2bcd8739ae039);
function $6dc842af8685b975$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var safePropName = propFullName || propName;
    if (propValue == null) return null;
    if (propValue && propValue.nodeType !== 1) return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
    return null;
}

});

parcelRegister("fteVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b435260f3a7867b2$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $f3ft4 = parcelRequire("f3ft4");

var $81kKd = parcelRequire("81kKd");
var $2NTyb = parcelRequire("2NTyb");
var $9qmQg = parcelRequire("9qmQg");
var $bYG1J = parcelRequire("bYG1J");

var $cVQrg = parcelRequire("cVQrg");

var $lKxJt = parcelRequire("lKxJt");

var $1DuTQ = parcelRequire("1DuTQ");

var $6fgQ7 = parcelRequire("6fgQ7");

var $iHBmE = parcelRequire("iHBmE");

var $6CUay = parcelRequire("6CUay");

var $cV5xs = parcelRequire("cV5xs");

var $8GoYc = parcelRequire("8GoYc");

var $1xyBb = parcelRequire("1xyBb");

var $apEOs = parcelRequire("apEOs");
function $b435260f3a7867b2$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $b435260f3a7867b2$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $b435260f3a7867b2$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
} // Sum the scrollTop between two elements.
function $b435260f3a7867b2$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $b435260f3a7867b2$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $b435260f3a7867b2$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: 'absolute',
        overflowY: 'auto',
        overflowX: 'hidden',
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100% - 32px)',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $b435260f3a7867b2$var$Popover = /*#__PURE__*/ $J42oT.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $1xyBb.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $cVOSt.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $J42oT.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $J42oT.useCallback(function(contentAnchorOffset) {
        if (anchorReference === 'anchorPosition') {
            if (!anchorPosition) console.error('Material-UI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
            return anchorPosition;
        }
        var resolvedAnchorEl = $b435260f3a7867b2$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $1DuTQ.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box = anchorElement.getBoundingClientRect();
        if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
            'Material-UI: The `anchorEl` prop provided to the component is invalid.',
            'The anchor element should be part of the document layout.',
            "Make sure the element is present in the document or that it's not display none."
        ].join('\n'));
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
        return {
            top: anchorRect.top + $b435260f3a7867b2$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $b435260f3a7867b2$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $J42oT.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $b435260f3a7867b2$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
            if (anchorOrigin.vertical !== 'top') console.error([
                'Material-UI: You can not change the default `anchorOrigin.vertical` value ',
                'when also providing the `getContentAnchorEl` prop to the popover component.',
                'Only use one of the two props.',
                "Set `getContentAnchorEl` to `null | undefined` or leave `anchorOrigin.vertical` unchanged."
            ].join('\n'));
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $J42oT.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $b435260f3a7867b2$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $b435260f3a7867b2$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $J42oT.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $b435260f3a7867b2$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $6fgQ7.default)($b435260f3a7867b2$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
            'Material-UI: The popover component is too tall.',
            "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."),
            'Please consider adding a `max-height` to improve the user-experience.'
        ].join('\n'));
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $b435260f3a7867b2$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $J42oT.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $J42oT.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $f3ft4.findDOMNode(instance);
    }, []);
    $J42oT.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $J42oT.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $J42oT.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $cVQrg.default)(function() {
            setPositioningStyles();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $1DuTQ.default)($b435260f3a7867b2$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $J42oT.createElement((0, $8GoYc.default), (0, $fXPf9.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $lKxJt.default)(classes.root, className)
    }, other), /*#__PURE__*/ $J42oT.createElement(TransitionComponent, (0, $fXPf9.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $iHBmE.default)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $J42oT.createElement((0, $apEOs.default), (0, $fXPf9.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $lKxJt.default)(classes.paper, PaperProps.className)
    }), children)));
});
$b435260f3a7867b2$var$Popover.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */ action: (0, $bYG1J.default),
    /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */ anchorEl: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]), function(props) {
        if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
            var resolvedAnchorEl = $b435260f3a7867b2$var$getAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                var box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'Material-UI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else return new Error([
                'Material-UI: The `anchorEl` prop provided to the component is invalid.',
                "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")
            ].join('\n'));
        }
        return null;
    }),
    /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        ]).isRequired
    }),
    /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */ anchorPosition: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number.isRequired,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number.isRequired
    }),
    /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */ anchorReference: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'anchorEl',
        'anchorPosition',
        'none'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).instanceOf($J42oT.Component),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]),
    /**
   * The elevation of the popover.
   */ elevation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */ getContentAnchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Specifies how close to the edge of the window the popover can appear.
   */ marginThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * Callback fired when the component requests to be closed.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEnter: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntered: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntering: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExit: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExited: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExiting: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * If `true`, the popover is visible.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .shape({
        component: (0, $2NTyb.default)
    }),
    /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */ transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        ]).isRequired
    }),
    /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ]),
    /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
var $b435260f3a7867b2$export$2e2bcd8739ae039 = (0, $cV5xs.default)($b435260f3a7867b2$export$9dd6ff9ea0189349, {
    name: 'MuiPopover'
})($b435260f3a7867b2$var$Popover);

});
parcelRegister("2NTyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ab3f7d850f3be9$export$2e2bcd8739ae039);

var $fcOLE = parcelRequire("fcOLE");

var $81kKd = parcelRequire("81kKd");
function $20ab3f7d850f3be9$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    var _elementType$prototyp = elementType.prototype, prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
    return Boolean(prototype.isReactComponent);
}
function $20ab3f7d850f3be9$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var safePropName = propFullName || propName;
    if (propValue == null) return null;
    var warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$20ab3f7d850f3be9$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $20ab3f7d850f3be9$export$2e2bcd8739ae039 = (0, $81kKd.default)($fcOLE.elementType, $20ab3f7d850f3be9$var$elementTypeAcceptingRef);

});

parcelRegister("6fgQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $48c134cc5b7c5965$export$2e2bcd8739ae039);

var $1DuTQ = parcelRequire("1DuTQ");
function $48c134cc5b7c5965$export$2e2bcd8739ae039(node) {
    var doc = (0, $1DuTQ.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("iHBmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d939ed36de861b$export$2e2bcd8739ae039);
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $d9d939ed36de861b$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        if (typeof func !== 'function') console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});

parcelRegister("8GoYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $65259d789b24c43d$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $f3ft4 = parcelRequire("f3ft4");

var $fcOLE = parcelRequire("fcOLE");

var $dxjd5 = parcelRequire("dxjd5");
var $27Cb9 = parcelRequire("27Cb9");

var $4InlD = parcelRequire("4InlD");
var $9qmQg = parcelRequire("9qmQg");

var $6CUay = parcelRequire("6CUay");

var $1DuTQ = parcelRequire("1DuTQ");

var $4D53l = parcelRequire("4D53l");

var $iHBmE = parcelRequire("iHBmE");

var $bDH0e = parcelRequire("bDH0e");

var $dzxus = parcelRequire("dzxus");

var $asx4i = parcelRequire("asx4i");

var $5d6wC = parcelRequire("5d6wC");

var $3ockC = parcelRequire("3ockC");

var $h7xLc = parcelRequire("h7xLc");
function $65259d789b24c43d$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    return $f3ft4.findDOMNode(container);
}
function $65259d789b24c43d$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $65259d789b24c43d$var$defaultManager = new (0, $5d6wC.default)();
var $65259d789b24c43d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'fixed',
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: 'hidden'
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $65259d789b24c43d$var$Modal = /*#__PURE__*/ $J42oT.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $27Cb9.default)();
    var props = (0, $dxjd5.default)({
        name: 'MuiModal',
        props: (0, $fXPf9.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $h7xLc.default) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $65259d789b24c43d$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $cVOSt.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $J42oT.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $J42oT.useRef({});
    var mountNodeRef = $J42oT.useRef(null);
    var modalRef = $J42oT.useRef(null);
    var handleRef = (0, $bDH0e.default)(modalRef, ref);
    var hasTransition = $65259d789b24c43d$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $1DuTQ.default)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $dzxus.default)(function() {
        var resolvedContainer = $65259d789b24c43d$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $J42oT.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $dzxus.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $5d6wC.ariaHidden)(modalRef.current, true);
    });
    var handleClose = $J42oT.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $J42oT.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $J42oT.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    var inlineStyle = $65259d789b24c43d$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $asx4i.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || '-1';
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $iHBmE.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $iHBmE.default)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $J42oT.createElement((0, $4D53l.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $fXPf9.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $J42oT.createElement(BackdropComponent, (0, $fXPf9.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $J42oT.createElement((0, $3ockC.default), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $J42oT.cloneElement(children, childProps))));
});
$65259d789b24c43d$var$Modal.propTypes = {
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * A single child content element.
   */ children: (0, $4InlD.default).isRequired,
    /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */ closeAfterTransition: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).instanceOf($J42oT.Component),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]),
    /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */ disableBackdropClick: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),
    /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, hitting escape will not fire `onClose`.
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Disable the scroll lock behavior.
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the backdrop is not rendered.
   */ hideBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ manager: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Callback fired when the backdrop is clicked.
   */ onBackdropClick: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */ onEscapeKeyDown: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),
    /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be removed in v5, the ref can be used instead.
   */ onRendered: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the ref instead.'),
    /**
   * If `true`, the modal is open.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired
};
var $65259d789b24c43d$export$2e2bcd8739ae039 = $65259d789b24c43d$var$Modal;

});
parcelRegister("4InlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ed61ea94b41d66$export$2e2bcd8739ae039);

var $fcOLE = parcelRequire("fcOLE");

var $81kKd = parcelRequire("81kKd");
function $36ed61ea94b41d66$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    var _elementType$prototyp = elementType.prototype, prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
    return Boolean(prototype.isReactComponent);
}
function $36ed61ea94b41d66$var$acceptingRef(props, propName, componentName, location, propFullName) {
    var element = props[propName];
    var safePropName = propFullName || propName;
    if (element == null) return null;
    var warningHint;
    var elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !$36ed61ea94b41d66$var$isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $36ed61ea94b41d66$var$elementAcceptingRef = (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element, $36ed61ea94b41d66$var$acceptingRef);
$36ed61ea94b41d66$var$elementAcceptingRef.isRequired = (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element.isRequired, $36ed61ea94b41d66$var$acceptingRef);
var $36ed61ea94b41d66$export$2e2bcd8739ae039 = $36ed61ea94b41d66$var$elementAcceptingRef;

});

parcelRegister("4D53l", function(module, exports) {

$parcel$export(module.exports, "default", () => $35eeb95eced888a9$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $f3ft4 = parcelRequire("f3ft4");

var $fcOLE = parcelRequire("fcOLE");

var $bsqoQ = parcelRequire("bsqoQ");
var $9qmQg = parcelRequire("9qmQg");

var $6CUay = parcelRequire("6CUay");

var $2VSrH = parcelRequire("2VSrH");

var $bDH0e = parcelRequire("bDH0e");
function $35eeb95eced888a9$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container; // #StrictMode ready
    return $f3ft4.findDOMNode(container);
}
var $35eeb95eced888a9$var$useEnhancedEffect = typeof window !== 'undefined' ? $J42oT.useLayoutEffect : $J42oT.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $35eeb95eced888a9$var$Portal = /*#__PURE__*/ $J42oT.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $J42oT.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $bDH0e.default)(/*#__PURE__*/ $J42oT.isValidElement(children) ? children.ref : null, ref);
    $35eeb95eced888a9$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($35eeb95eced888a9$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $35eeb95eced888a9$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $2VSrH.default)(ref, mountNode);
            return function() {
                (0, $2VSrH.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $35eeb95eced888a9$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $J42oT.isValidElement(children)) return /*#__PURE__*/ $J42oT.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $f3ft4.createPortal(children, mountNode) : mountNode;
});
$35eeb95eced888a9$var$Portal.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The children to render into the `container`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).instanceOf($J42oT.Component),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]),
    /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */ onRendered: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the ref instead.')
};
// eslint-disable-next-line
$35eeb95eced888a9$var$Portal["propTypes"] = (0, $bsqoQ.default)($35eeb95eced888a9$var$Portal.propTypes);
var $35eeb95eced888a9$export$2e2bcd8739ae039 = $35eeb95eced888a9$var$Portal;

});

parcelRegister("dzxus", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1885b8787f43de$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
var $9e1885b8787f43de$var$useEnhancedEffect = typeof window !== 'undefined' ? $J42oT.useLayoutEffect : $J42oT.useEffect;
function $9e1885b8787f43de$export$2e2bcd8739ae039(fn) {
    var ref = $J42oT.useRef(fn);
    $9e1885b8787f43de$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $J42oT.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("5d6wC", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $3cb33a6aadcfb54a$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "default", () => $3cb33a6aadcfb54a$export$2e2bcd8739ae039);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $6kfYZ = parcelRequire("6kfYZ");

var $b5Swd = parcelRequire("b5Swd");

var $1DuTQ = parcelRequire("1DuTQ");

var $6fgQ7 = parcelRequire("6fgQ7");
function $3cb33a6aadcfb54a$var$isOverflowing(container) {
    var doc = (0, $1DuTQ.default)(container);
    if (doc.body === container) return (0, $6fgQ7.default)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $3cb33a6aadcfb54a$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $3cb33a6aadcfb54a$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
function $3cb33a6aadcfb54a$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $6kfYZ.default)(nodesToExclude));
    var blacklistTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE'
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $3cb33a6aadcfb54a$export$e1bd0c6150f13d96(node, show);
    });
}
function $3cb33a6aadcfb54a$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $3cb33a6aadcfb54a$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($3cb33a6aadcfb54a$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $b5Swd.default)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style['padding-right'] = "".concat($3cb33a6aadcfb54a$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $1DuTQ.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($3cb33a6aadcfb54a$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: 'overflow',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty('padding-right');
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $3cb33a6aadcfb54a$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $3cb33a6aadcfb54a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $lfYGa.default)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $cWCsL.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $3cb33a6aadcfb54a$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $3cb33a6aadcfb54a$var$getHiddenSiblings(container);
                $3cb33a6aadcfb54a$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $3cb33a6aadcfb54a$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $3cb33a6aadcfb54a$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $3cb33a6aadcfb54a$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $3cb33a6aadcfb54a$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $3cb33a6aadcfb54a$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $3cb33a6aadcfb54a$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $3cb33a6aadcfb54a$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});
parcelRegister("lfYGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79a114dfc669e8b$export$2e2bcd8739ae039);
function $f79a114dfc669e8b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("b5Swd", function(module, exports) {

$parcel$export(module.exports, "default", () => $813a739498253a75$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $813a739498253a75$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}

});


parcelRegister("3ockC", function(module, exports) {

$parcel$export(module.exports, "default", () => $277d2dc637e86b9b$export$2e2bcd8739ae039);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $J42oT = parcelRequire("J42oT");

var $f3ft4 = parcelRequire("f3ft4");

var $fcOLE = parcelRequire("fcOLE");

var $1DuTQ = parcelRequire("1DuTQ");

var $bDH0e = parcelRequire("bDH0e");

var $bsqoQ = parcelRequire("bsqoQ");
/**
 * Utility component that locks focus inside the component.
 */ function $277d2dc637e86b9b$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $J42oT.useRef();
    var sentinelStart = $J42oT.useRef(null);
    var sentinelEnd = $J42oT.useRef(null);
    var nodeToRestore = $J42oT.useRef();
    var rootRef = $J42oT.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $J42oT.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $f3ft4.findDOMNode(instance);
    }, []);
    var handleRef = (0, $bDH0e.default)(children.ref, handleOwnRef);
    var prevOpenRef = $J42oT.useRef();
    $J42oT.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== 'undefined') // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $J42oT.useEffect(function() {
        if (!open) return;
        var doc = (0, $1DuTQ.default)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) {
                console.error([
                    'Material-UI: The modal content node does not accept focus.',
                    'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'
                ].join('\n'));
                rootRef.current.setAttribute('tabIndex', -1);
            }
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener('focus', contain, true);
        doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener('focus', contain, true);
            doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, /*#__PURE__*/ $J42oT.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $J42oT.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $J42oT.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
$277d2dc637e86b9b$var$Unstable_TrapFocus.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A single child content element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */ getDoc: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func.isRequired,
    /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */ isEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func.isRequired,
    /**
   * If `true`, focus will be locked.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired
};
// eslint-disable-next-line
$277d2dc637e86b9b$var$Unstable_TrapFocus["propTypes"] = (0, $bsqoQ.default)($277d2dc637e86b9b$var$Unstable_TrapFocus.propTypes);
var $277d2dc637e86b9b$export$2e2bcd8739ae039 = $277d2dc637e86b9b$var$Unstable_TrapFocus;

});

parcelRegister("h7xLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $033770a1d34ad410$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");
var $033770a1d34ad410$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: 'fixed',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
/**
 * @ignore - internal component.
 */ var $033770a1d34ad410$var$SimpleBackdrop = /*#__PURE__*/ $J42oT.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $cVOSt.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $fXPf9.default)({}, $033770a1d34ad410$export$9dd6ff9ea0189349.root, invisible ? $033770a1d34ad410$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
$033770a1d34ad410$var$SimpleBackdrop.propTypes = {
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */ invisible: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the backdrop is open.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired
};
var $033770a1d34ad410$export$2e2bcd8739ae039 = $033770a1d34ad410$var$SimpleBackdrop;

});


parcelRegister("1xyBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f3b618e4301a23$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $30ito = parcelRequire("30ito");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $5pZVD = parcelRequire("5pZVD");

var $IQ3Oi = parcelRequire("IQ3Oi");

var $joV8i = parcelRequire("joV8i");

var $bDH0e = parcelRequire("bDH0e");
function $11f3b618e4301a23$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $11f3b618e4301a23$var$styles = {
    entering: {
        opacity: 1,
        transform: $11f3b618e4301a23$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $11f3b618e4301a23$var$Grow = /*#__PURE__*/ $J42oT.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 'auto' : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5pZVD.default) : _props$TransitionComp, other = (0, $cVOSt.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $J42oT.useRef();
    var autoTimeout = $J42oT.useRef();
    var theme = (0, $IQ3Oi.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $J42oT.useRef(null);
    var foreignRef = (0, $bDH0e.default)(children.ref, ref);
    var handleRef = (0, $bDH0e.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $30ito.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $joV8i.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $joV8i.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $joV8i.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = $11f3b618e4301a23$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $J42oT.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $J42oT.createElement(TransitionComponent, (0, $fXPf9.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $J42oT.cloneElement(children, (0, $fXPf9.default)({
            style: (0, $fXPf9.default)({
                opacity: 0,
                transform: $11f3b618e4301a23$var$getScale(0.75),
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $11f3b618e4301a23$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$11f3b618e4301a23$var$Grow.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A single child content element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */ disableStrictModeCompat: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, show the component; triggers the enter or exit animation.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ])
};
$11f3b618e4301a23$var$Grow.muiSupportAuto = true;
var $11f3b618e4301a23$export$2e2bcd8739ae039 = $11f3b618e4301a23$var$Grow;

});
parcelRegister("5pZVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f1f5342397a16f3$export$2e2bcd8739ae039);

var $bXxv0 = parcelRequire("bXxv0");

var $1bdSs = parcelRequire("1bdSs");

var $fcOLE = parcelRequire("fcOLE");

var $J42oT = parcelRequire("J42oT");

var $f3ft4 = parcelRequire("f3ft4");

var $7OJxK = parcelRequire("7OJxK");

var $jDKSq = parcelRequire("jDKSq");

var $9M2ch = parcelRequire("9M2ch");

var $fbWlz = parcelRequire("fbWlz");
var $3f1f5342397a16f3$export$bb38bb9a1161268 = 'unmounted';
var $3f1f5342397a16f3$export$84cbff306f539230 = 'exited';
var $3f1f5342397a16f3$export$df38205c966be359 = 'entering';
var $3f1f5342397a16f3$export$78e9e6e3e014d60a = 'entered';
var $3f1f5342397a16f3$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3f1f5342397a16f3$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1bdSs.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3f1f5342397a16f3$export$84cbff306f539230;
                _this.appearStatus = $3f1f5342397a16f3$export$df38205c966be359;
            } else initialStatus = $3f1f5342397a16f3$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3f1f5342397a16f3$export$bb38bb9a1161268;
        else initialStatus = $3f1f5342397a16f3$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3f1f5342397a16f3$export$bb38bb9a1161268) return {
            status: $3f1f5342397a16f3$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3f1f5342397a16f3$export$df38205c966be359 && status !== $3f1f5342397a16f3$export$78e9e6e3e014d60a) nextStatus = $3f1f5342397a16f3$export$df38205c966be359;
            } else if (status === $3f1f5342397a16f3$export$df38205c966be359 || status === $3f1f5342397a16f3$export$78e9e6e3e014d60a) nextStatus = $3f1f5342397a16f3$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3f1f5342397a16f3$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $fbWlz.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3f1f5342397a16f3$export$84cbff306f539230) this.setState({
            status: $3f1f5342397a16f3$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $7OJxK.default).disabled) {
            this.safeSetState({
                status: $3f1f5342397a16f3$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3f1f5342397a16f3$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3f1f5342397a16f3$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $7OJxK.default).disabled) {
            this.safeSetState({
                status: $3f1f5342397a16f3$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3f1f5342397a16f3$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3f1f5342397a16f3$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3f1f5342397a16f3$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bXxv0.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $9M2ch.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).Component);
$3f1f5342397a16f3$var$Transition.contextType = (0, $9M2ch.default);
$3f1f5342397a16f3$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $jDKSq.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
}; // Name the function so it is clearer in the documentation
function $3f1f5342397a16f3$var$noop() {}
$3f1f5342397a16f3$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3f1f5342397a16f3$var$noop,
    onEntering: $3f1f5342397a16f3$var$noop,
    onEntered: $3f1f5342397a16f3$var$noop,
    onExit: $3f1f5342397a16f3$var$noop,
    onExiting: $3f1f5342397a16f3$var$noop,
    onExited: $3f1f5342397a16f3$var$noop
};
$3f1f5342397a16f3$var$Transition.UNMOUNTED = $3f1f5342397a16f3$export$bb38bb9a1161268;
$3f1f5342397a16f3$var$Transition.EXITED = $3f1f5342397a16f3$export$84cbff306f539230;
$3f1f5342397a16f3$var$Transition.ENTERING = $3f1f5342397a16f3$export$df38205c966be359;
$3f1f5342397a16f3$var$Transition.ENTERED = $3f1f5342397a16f3$export$78e9e6e3e014d60a;
$3f1f5342397a16f3$var$Transition.EXITING = $3f1f5342397a16f3$export$4aacc83d4d59139f;
var $3f1f5342397a16f3$export$2e2bcd8739ae039 = $3f1f5342397a16f3$var$Transition;

});
parcelRegister("7OJxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1087dc2cdefc14$export$2e2bcd8739ae039);
var $5b1087dc2cdefc14$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("jDKSq", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", () => $e4c605a0117d9e65$export$3458ee1082941f5e);
$parcel$export(module.exports, "classNamesShape", () => $e4c605a0117d9e65$export$d61341ca8ef7c732);

var $fcOLE = parcelRequire("fcOLE");
var $e4c605a0117d9e65$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
    }).isRequired
]);
var $e4c605a0117d9e65$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    })
]);

});

parcelRegister("9M2ch", function(module, exports) {

$parcel$export(module.exports, "default", () => $71da4d0544480449$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
var $71da4d0544480449$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createContext(null);

});

parcelRegister("fbWlz", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $b0f524907a6af5d6$export$7d26bbb1236dafd6);
var $b0f524907a6af5d6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("joV8i", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $e1fc9393810cce19$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $e1fc9393810cce19$export$8cb1e9b404609ae9);
var $e1fc9393810cce19$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $e1fc9393810cce19$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});


parcelRegister("apEOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $794be5c4e9e5d3f5$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $81kKd = parcelRequire("81kKd");

var $cV5xs = parcelRequire("cV5xs");
var $794be5c4e9e5d3f5$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $fXPf9.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('box-shadow')
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $794be5c4e9e5d3f5$var$Paper = /*#__PURE__*/ $J42oT.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? 'elevation' : _props$variant, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
$794be5c4e9e5d3f5$var$Paper.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */ elevation: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number, function(props) {
        var classes = props.classes, elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
        if (classes === undefined) return null;
        if (elevation != null && classes["elevation".concat(elevation)] === undefined) return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'elevation',
        'outlined'
    ])
};
var $794be5c4e9e5d3f5$export$2e2bcd8739ae039 = (0, $cV5xs.default)($794be5c4e9e5d3f5$export$9dd6ff9ea0189349, {
    name: 'MuiPaper'
})($794be5c4e9e5d3f5$var$Paper);

});


parcelRegister("6CiPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d14e6c93a1b070a$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $5vJdk = parcelRequire("5vJdk");

var $fcOLE = parcelRequire("fcOLE");

var $f3ft4 = parcelRequire("f3ft4");

var $1DuTQ = parcelRequire("1DuTQ");

var $a0fFY = parcelRequire("a0fFY");

var $b5Swd = parcelRequire("b5Swd");

var $bDH0e = parcelRequire("bDH0e");
function $4d14e6c93a1b070a$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4d14e6c93a1b070a$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4d14e6c93a1b070a$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $4d14e6c93a1b070a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$4d14e6c93a1b070a$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $4d14e6c93a1b070a$var$useEnhancedEffect = typeof window === 'undefined' ? $J42oT.useEffect : $J42oT.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $4d14e6c93a1b070a$var$MenuList = /*#__PURE__*/ $J42oT.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $cVOSt.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $J42oT.useRef(null);
    var textCriteriaRef = $J42oT.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $4d14e6c93a1b070a$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $J42oT.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $b5Swd.default)(true), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $1DuTQ.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $4d14e6c93a1b070a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4d14e6c93a1b070a$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $4d14e6c93a1b070a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4d14e6c93a1b070a$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $4d14e6c93a1b070a$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4d14e6c93a1b070a$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $4d14e6c93a1b070a$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4d14e6c93a1b070a$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $4d14e6c93a1b070a$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4d14e6c93a1b070a$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4d14e6c93a1b070a$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $J42oT.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $f3ft4.findDOMNode(instance);
    }, []);
    var handleRef = (0, $bDH0e.default)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $J42oT.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $J42oT.isValidElement(child)) return;
        if ((0, $5vJdk.isFragment)(child)) console.error([
            "Material-UI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $J42oT.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $J42oT.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $J42oT.createElement((0, $a0fFY.default), (0, $fXPf9.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
$4d14e6c93a1b070a$var$MenuList.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */ autoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * MenuList contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, will allow focus on disabled items.
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the menu items will not wrap focus.
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $4d14e6c93a1b070a$export$2e2bcd8739ae039 = $4d14e6c93a1b070a$var$MenuList;

});
parcelRegister("a0fFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $748610684fbc7efa$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $9bPBa = parcelRequire("9bPBa");
var $748610684fbc7efa$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $748610684fbc7efa$var$List = /*#__PURE__*/ $J42oT.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'ul' : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $J42oT.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $9bPBa.default).Provider, {
        value: context
    }, /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
$748610684fbc7efa$var$List.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, vertical padding will be removed from the list.
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The content of the subheader, normally `ListSubheader`.
   */ subheader: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node
};
var $748610684fbc7efa$export$2e2bcd8739ae039 = (0, $cV5xs.default)($748610684fbc7efa$export$9dd6ff9ea0189349, {
    name: 'MuiList'
})($748610684fbc7efa$var$List);

});
parcelRegister("9bPBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0d2a7e9d7a25bd$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
/**
 * @ignore - internal component.
 */ var $6b0d2a7e9d7a25bd$var$ListContext = $J42oT.createContext({});
$6b0d2a7e9d7a25bd$var$ListContext.displayName = 'ListContext';
var $6b0d2a7e9d7a25bd$export$2e2bcd8739ae039 = $6b0d2a7e9d7a25bd$var$ListContext;

});




parcelRegister("7tsbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $57111a097a6c1630$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $J42oT = parcelRequire("J42oT");
function $57111a097a6c1630$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $J42oT.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $J42oT.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    $J42oT.useEffect(function() {
        if (isControlled !== (controlled !== undefined)) console.error([
            "Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."),
            'Elements should not switch from uncontrolled to controlled (or vice versa).',
            "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.',
            "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.",
            'More info: https://fb.me/react-controlled-components'
        ].join('\n'));
    }, [
        controlled
    ]);
    var _React$useRef2 = $J42oT.useRef(defaultProp), defaultValue = _React$useRef2.current;
    $J42oT.useEffect(function() {
        if (!isControlled && defaultValue !== defaultProp) console.error([
            "Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")
        ].join('\n'));
    }, [
        JSON.stringify(defaultProp)
    ]);
    var setValueIfUncontrolled = $J42oT.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("kLrPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ddc8ac7a2a1955$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $f1ddc8ac7a2a1955$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});
parcelRegister("fUra3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95127985a851a98$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $coELO = parcelRequire("coELO");
function $b95127985a851a98$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $coELO.default), (0, $fXPf9.default)({
            ref: ref
        }, props), path);
    };
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
    Component.muiName = (0, $coELO.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).forwardRef(Component));
}

});
parcelRegister("coELO", function(module, exports) {

$parcel$export(module.exports, "default", () => $90675a09a85f62cb$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $81kKd = parcelRequire("81kKd");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");
var $90675a09a85f62cb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $90675a09a85f62cb$var$SvgIcon = /*#__PURE__*/ $J42oT.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $7OrFE.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $7OrFE.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $J42oT.createElement("title", null, titleAccess) : null);
});
$90675a09a85f62cb$var$SvgIcon.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Node passed into the SVG element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'action',
        'disabled',
        'error',
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */ fontSize: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'inherit',
        'large',
        'medium',
        'small'
    ]), function(props) {
        var fontSize = props.fontSize;
        if (fontSize === 'default') throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
        return null;
    }),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */ shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */ viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
};
$90675a09a85f62cb$var$SvgIcon.muiName = 'SvgIcon';
var $90675a09a85f62cb$export$2e2bcd8739ae039 = (0, $cV5xs.default)($90675a09a85f62cb$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($90675a09a85f62cb$var$SvgIcon);

});



parcelRegister("id1vj", function(module, exports) {

$parcel$export(module.exports, "styles", () => $d41a9b969a081dff$export$9dd6ff9ea0189349);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $Xwc2k = parcelRequire("Xwc2k");

var $cV5xs = parcelRequire("cV5xs");

var $lyguR = parcelRequire("lyguR");

var $24AJO = parcelRequire("24AJO");

var $kLrPs = parcelRequire("kLrPs");

var $2KyCl = parcelRequire("2KyCl");
var $d41a9b969a081dff$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            '-moz-appearance': 'none',
            // Reset
            '-webkit-appearance': 'none',
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: 'none',
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: 'pointer',
            '&:focus': {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            '&::-ms-expand': {
                display: 'none'
            },
            '&$disabled': {
                cursor: 'default'
            },
            '&[multiple]': {
                height: 'auto'
            },
            '&:not([multiple]) option, &:not([multiple]) optgroup': {
                backgroundColor: theme.palette.background.paper
            },
            '&&': {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: 'auto',
            // Resets for multpile select with chips
            minHeight: '1.1876em',
            // Required for select\text-field height consistency
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 12px)',
            // Center vertically
            pointerEvents: 'none',
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            width: '100%'
        }
    };
};
var $d41a9b969a081dff$var$defaultInput = /*#__PURE__*/ $J42oT.createElement((0, $2KyCl.default), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $d41a9b969a081dff$var$NativeSelect = /*#__PURE__*/ $J42oT.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $kLrPs.default) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $d41a9b969a081dff$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $24AJO.default)();
    var fcs = (0, $lyguR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    return /*#__PURE__*/ $J42oT.cloneElement(input, (0, $fXPf9.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $Xwc2k.default),
        inputProps: (0, $fXPf9.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$d41a9b969a081dff$var$NativeSelect.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * Attributes applied to the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The input value. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$d41a9b969a081dff$var$NativeSelect.muiName = 'Select';
var $d41a9b969a081dff$export$2e2bcd8739ae039 = (0, $cV5xs.default)($d41a9b969a081dff$export$9dd6ff9ea0189349, {
    name: 'MuiNativeSelect'
})($d41a9b969a081dff$var$NativeSelect);

});
parcelRegister("Xwc2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b2e7bb09989873d$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $7OrFE = parcelRequire("7OrFE");
/**
 * @ignore - internal component.
 */ var $0b2e7bb09989873d$var$NativeSelectInput = /*#__PURE__*/ $J42oT.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, /*#__PURE__*/ $J42oT.createElement("select", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $J42oT.createElement(IconComponent, {
        className: (0, $lKxJt.default)(classes.icon, classes["icon".concat((0, $7OrFE.default)(variant))], disabled && classes.disabled)
    }));
});
$0b2e7bb09989873d$var$NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the select will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: (0, $bYG1J.default),
    /**
   * @ignore
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $0b2e7bb09989873d$export$2e2bcd8739ae039 = $0b2e7bb09989873d$var$NativeSelectInput;

});





parcelRegister("e6mUx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kwppE")).default);
$parcel$export(module.exports, "createFilterOptions", () => (parcelRequire("3l5Bc")).createFilterOptions);

var $3l5Bc = parcelRequire("3l5Bc");
var $kwppE = parcelRequire("kwppE");

});
parcelRegister("3l5Bc", function(module, exports) {

$parcel$export(module.exports, "createFilterOptions", () => $26e7ad1cf28e3d5f$export$f76f94b238d946d8);
$parcel$export(module.exports, "default", () => $26e7ad1cf28e3d5f$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $30ito = parcelRequire("30ito");

var $5z6Dx = parcelRequire("5z6Dx");

var $J42oT = parcelRequire("J42oT");

var $2VSrH = parcelRequire("2VSrH");
var $jXLbU = parcelRequire("jXLbU");
var $7tsbi = parcelRequire("7tsbi");
var $dzxus = parcelRequire("dzxus");
// Give up on IE 11 support for this feature
function $26e7ad1cf28e3d5f$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $26e7ad1cf28e3d5f$export$f76f94b238d946d8() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$ignoreAccents = config.ignoreAccents, ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents, _config$ignoreCase = config.ignoreCase, ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase, limit = config.limit, _config$matchFrom = config.matchFrom, matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom, stringify = config.stringify, _config$trim = config.trim, trim = _config$trim === void 0 ? false : _config$trim;
    return function(options, _ref) {
        var inputValue = _ref.inputValue, getOptionLabel = _ref.getOptionLabel;
        var input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $26e7ad1cf28e3d5f$var$stripDiacritics(input);
        var filteredOptions = options.filter(function(option) {
            var candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $26e7ad1cf28e3d5f$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
} // To replace with .findIndex() once we stop IE 11 support.
function $26e7ad1cf28e3d5f$var$findIndex(array, comp) {
    for(var i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
var $26e7ad1cf28e3d5f$var$defaultFilterOptions = $26e7ad1cf28e3d5f$export$f76f94b238d946d8(); // Number of options to jump in list box when pageup and pagedown keys are used.
var $26e7ad1cf28e3d5f$var$pageSize = 5;
function $26e7ad1cf28e3d5f$export$2e2bcd8739ae039(props) {
    var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$filterOptions = props.filterOptions, filterOptions = _props$filterOptions === void 0 ? $26e7ad1cf28e3d5f$var$defaultFilterOptions : _props$filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabelProp = _props$getOptionLabel === void 0 ? function(option) {
        return option;
    } : _props$getOptionLabel, _props$getOptionSelec = props.getOptionSelected, getOptionSelected = _props$getOptionSelec === void 0 ? function(option, value) {
        return option === value;
    } : _props$getOptionSelec, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, openProp = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, options = props.options, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, valueProp = props.value;
    var id = (0, $jXLbU.default)(idProp);
    var getOptionLabel = getOptionLabelProp;
    getOptionLabel = function getOptionLabel(option) {
        var optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') {
            var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat((0, $5z6Dx.default)(optionLabel), " (").concat(optionLabel, ")");
            console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
        }
        return optionLabel;
    };
    var ignoreFocus = $J42oT.useRef(false);
    var firstFocus = $J42oT.useRef(true);
    var inputRef = $J42oT.useRef(null);
    var listboxRef = $J42oT.useRef(null);
    var _React$useState = $J42oT.useState(null), anchorEl = _React$useState[0], setAnchorEl = _React$useState[1];
    var _React$useState2 = $J42oT.useState(-1), focusedTag = _React$useState2[0], setFocusedTag = _React$useState2[1];
    var defaultHighlighted = autoHighlight ? 0 : -1;
    var highlightedIndexRef = $J42oT.useRef(defaultHighlighted);
    var _useControlled = (0, $7tsbi.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    }), _useControlled2 = (0, $30ito.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var _useControlled3 = (0, $7tsbi.default)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    }), _useControlled4 = (0, $30ito.default)(_useControlled3, 2), inputValue = _useControlled4[0], setInputValue = _useControlled4[1];
    var _React$useState3 = $J42oT.useState(false), focused = _React$useState3[0], setFocused = _React$useState3[1];
    var resetInputValue = (0, $dzxus.default)(function(event, newValue) {
        var newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            var optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValue(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    });
    $J42oT.useEffect(function() {
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue
    ]);
    var _useControlled5 = (0, $7tsbi.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    }), _useControlled6 = (0, $30ito.default)(_useControlled5, 2), open = _useControlled6[0], setOpenState = _useControlled6[1];
    var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    var popupOpen = open;
    var filteredOptions = popupOpen ? filterOptions(options.filter(function(option) {
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some(function(value2) {
            return value2 !== null && getOptionSelected(option, value2);
        })) return false;
        return true;
    }), // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    if (value !== null && !freeSolo && options.length > 0) {
        var missingValue = (multiple ? value : [
            value
        ]).filter(function(value2) {
            return !options.some(function(option) {
                return getOptionSelected(option, value2);
            });
        });
        if (missingValue.length > 0) console.warn([
            "Material-UI: The value provided to ".concat(componentName, " is invalid."),
            "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."),
            'You can use the `getOptionSelected` prop to customize the equality test.'
        ].join('\n'));
    }
    var focusTag = (0, $dzxus.default)(function(tagToFocus) {
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }); // Ensure the focusedTag is never inconsistent
    $J42oT.useEffect(function() {
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) return -1;
            var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
            var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');
            if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    var setHighlightedIndex = (0, $dzxus.default)(function(_ref2) {
        var event = _ref2.event, index = _ref2.index, _ref2$reason = _ref2.reason, reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
        highlightedIndexRef.current = index; // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        var prev = listboxRef.current.querySelector('[data-focus]');
        if (prev) prev.removeAttribute('data-focus');
        var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));
        if (!option) return;
        option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
            var element = option;
            var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            var elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    var changeHighlightedIndex = (0, $dzxus.default)(function(_ref3) {
        var event = _ref3.event, diff = _ref3.diff, _ref3$direction = _ref3.direction, direction = _ref3$direction === void 0 ? 'next' : _ref3$direction, _ref3$reason = _ref3.reason, reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;
        if (!popupOpen) return;
        var getNextIndex = function getNextIndex() {
            var maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            var newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        var nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        }); // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                var option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    var syncHighlightedIndex = $J42oT.useCallback(function() {
        if (!popupOpen) return;
        var valueItem = multiple ? value[0] : value; // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
         // Synchronize the value with the highlighted index
        if (!filterSelectedOptions && valueItem != null) {
            var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
            if (multiple && currentOption && $26e7ad1cf28e3d5f$var$findIndex(value, function(val) {
                return getOptionSelected(currentOption, val);
            }) !== -1) return;
            var itemIndex = $26e7ad1cf28e3d5f$var$findIndex(filteredOptions, function(optionItem) {
                return getOptionSelected(optionItem, valueItem);
            });
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        } // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        } // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        filteredOptions.length === 0,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    var handleListboxRef = (0, $dzxus.default)(function(node) {
        (0, $2VSrH.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $J42oT.useEffect(function() {
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    var handleOpen = function handleOpen(event) {
        if (open) return;
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleClose = function handleClose(event, reason) {
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    var handleValue = function handleValue(event, newValue, reason, details) {
        if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValue(newValue);
    };
    var isTouch = $J42oT.useRef(false);
    var selectNewValue = function selectNewValue(event, option) {
        var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
        var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
        var reason = reasonProp;
        var newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var matches = newValue.filter(function(val) {
                return getOptionSelected(option, val);
            });
            if (matches.length > 1) console.error([
                "Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."),
                "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")
            ].join('\n'));
            var itemIndex = $26e7ad1cf28e3d5f$var$findIndex(newValue, function(valueItem) {
                return getOptionSelected(option, valueItem);
            });
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'remove-option';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
            if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    var handleFocusTag = function handleFocusTag(event, direction) {
        if (!multiple) return;
        handleClose(event, 'toggleInput');
        var nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    var handleClear = function handleClear(event) {
        ignoreFocus.current = true;
        setInputValue('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    var handleKeyDown = function handleKeyDown(other) {
        return function(event) {
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$26e7ad1cf28e3d5f$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $26e7ad1cf28e3d5f$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    // Wait until IME is settled.
                    if (event.which === 229) break;
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        var option = filteredOptions[highlightedIndexRef.current];
                        var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'select-option'); // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'create-option', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    if (multiple && inputValue === '' && value.length > 0) {
                        var index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        var newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'remove-option', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
            if (other.onKeyDown) other.onKeyDown(event);
        };
    };
    var handleFocus = function handleFocus(event) {
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    var handleBlur = function handleBlur(event) {
        // Ignore the event when using the scrollbar with IE 11
        if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (debug && inputValue !== '') return;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    var handleInputChange = function handleInputChange(event) {
        var newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValue(newValue);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    var handleOptionMouseOver = function handleOptionMouseOver(event) {
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'mouse'
        });
    };
    var handleOptionTouchStart = function handleOptionTouchStart() {
        isTouch.current = true;
    };
    var handleOptionClick = function handleOptionClick(event) {
        var index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'select-option');
        isTouch.current = false;
    };
    var handleTagDelete = function handleTagDelete(index) {
        return function(event) {
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
                option: value[index]
            });
        };
    };
    var handlePopupIndicator = function handlePopupIndicator(event) {
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    }; // Prevent input blur when interacting with the combobox
    var handleMouseDown = function handleMouseDown(event) {
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    }; // Focus the input when interacting with the combobox
    var handleClick = function handleClick() {
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    var handleInputMouseDown = function handleInputMouseDown(event) {
        if (inputValue === '' || !open) handlePopupIndicator(event);
    };
    var dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    var groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        var indexBy = new Map();
        var warn = false;
        groupedOptions = filteredOptions.reduce(function(acc, option, index) {
            var group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else {
                if (indexBy.get(group) && !warn) {
                    console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
                    warn = true;
                }
                indexBy.set(group, true);
                acc.push({
                    key: index,
                    index: index,
                    group: group,
                    options: [
                        option
                    ]
                });
            }
            return acc;
        }, []);
    }
    return {
        getRootProps: function getRootProps() {
            var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return (0, $fXPf9.default)({
                'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
                role: 'combobox',
                'aria-expanded': popupOpen
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            });
        },
        getInputLabelProps: function getInputLabelProps() {
            return {
                id: "".concat(id, "-label"),
                htmlFor: id
            };
        },
        getInputProps: function getInputProps() {
            return {
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperativeley so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false'
            };
        },
        getClearProps: function getClearProps() {
            return {
                tabIndex: -1,
                onClick: handleClear
            };
        },
        getPopupIndicatorProps: function getPopupIndicatorProps() {
            return {
                tabIndex: -1,
                onClick: handlePopupIndicator
            };
        },
        getTagProps: function getTagProps(_ref4) {
            var index = _ref4.index;
            return {
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                onDelete: handleTagDelete(index)
            };
        },
        getListboxProps: function getListboxProps() {
            return {
                role: 'listbox',
                id: "".concat(id, "-popup"),
                'aria-labelledby': "".concat(id, "-label"),
                ref: handleListboxRef,
                onMouseDown: function onMouseDown(event) {
                    // Prevent blur
                    event.preventDefault();
                }
            };
        },
        getOptionProps: function getOptionProps(_ref5) {
            var index = _ref5.index, option = _ref5.option;
            var selected = (multiple ? value : [
                value
            ]).some(function(value2) {
                return value2 != null && getOptionSelected(option, value2);
            });
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: index,
                tabIndex: -1,
                role: 'option',
                id: "".concat(id, "-option-").concat(index),
                onMouseOver: handleOptionMouseOver,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}

});
parcelRegister("jXLbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e888222e1ab3c729$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
function $e888222e1ab3c729$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $J42oT.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $J42oT.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}

});


parcelRegister("kwppE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0a823899086208$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $6JmtS = parcelRequire("6JmtS");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $3pZUL = parcelRequire("3pZUL");

var $XfB1L = parcelRequire("XfB1L");

var $apEOs = parcelRequire("apEOs");

var $io0Xu = parcelRequire("io0Xu");

var $fycnb = parcelRequire("fycnb");

var $3XEAu = parcelRequire("3XEAu");

var $hGbhY = parcelRequire("hGbhY");

var $3l5Bc = parcelRequire("3l5Bc");
var $ef0a823899086208$export$9dd6ff9ea0189349 = function styles(theme) {
    var _option;
    return {
        /* Styles applied to the root element. */ root: {
            '&$focused $clearIndicatorDirty': {
                visibility: 'visible'
            },
            /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
                '&:hover $clearIndicatorDirty': {
                    visibility: 'visible'
                }
            }
        },
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Pseudo-class applied to the root element if focused. */ focused: {},
        /* Styles applied to the tag elements, e.g. the chips. */ tag: {
            margin: 3,
            maxWidth: 'calc(100% - 6px)'
        },
        /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */ tagSizeSmall: {
            margin: 2,
            maxWidth: 'calc(100% - 4px)'
        },
        /* Styles applied when the popup icon is rendered. */ hasPopupIcon: {},
        /* Styles applied when the clear icon is rendered. */ hasClearIcon: {},
        /* Styles applied to the Input element. */ inputRoot: {
            flexWrap: 'wrap',
            '$hasPopupIcon &, $hasClearIcon &': {
                paddingRight: 30
            },
            '$hasPopupIcon$hasClearIcon &': {
                paddingRight: 56
            },
            '& $input': {
                width: 0,
                minWidth: 30
            },
            '&[class*="MuiInput-root"]': {
                paddingBottom: 1,
                '& $input': {
                    padding: 4
                },
                '& $input:first-child': {
                    padding: '6px 0'
                }
            },
            '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
                '& $input': {
                    padding: '4px 4px 5px'
                },
                '& $input:first-child': {
                    padding: '3px 0 6px'
                }
            },
            '&[class*="MuiOutlinedInput-root"]': {
                padding: 9,
                '$hasPopupIcon &, $hasClearIcon &': {
                    paddingRight: 39
                },
                '$hasPopupIcon$hasClearIcon &': {
                    paddingRight: 65
                },
                '& $input': {
                    padding: '9.5px 4px'
                },
                '& $input:first-child': {
                    paddingLeft: 6
                },
                '& $endAdornment': {
                    right: 9
                }
            },
            '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
                padding: 6,
                '& $input': {
                    padding: '4.5px 4px'
                }
            },
            '&[class*="MuiFilledInput-root"]': {
                paddingTop: 19,
                paddingLeft: 8,
                '$hasPopupIcon &, $hasClearIcon &': {
                    paddingRight: 39
                },
                '$hasPopupIcon$hasClearIcon &': {
                    paddingRight: 65
                },
                '& $input': {
                    padding: '9px 4px'
                },
                '& $endAdornment': {
                    right: 9
                }
            },
            '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
                paddingBottom: 1,
                '& $input': {
                    padding: '4.5px 4px'
                }
            }
        },
        /* Styles applied to the input element. */ input: {
            flexGrow: 1,
            textOverflow: 'ellipsis',
            opacity: 0
        },
        /* Styles applied to the input element if tag focused. */ inputFocused: {
            opacity: 1
        },
        /* Styles applied to the endAdornment element. */ endAdornment: {
            // We use a position absolute to support wrapping tags.
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 14px)' // Center vertically
        },
        /* Styles applied to the clear indicator. */ clearIndicator: {
            marginRight: -2,
            padding: 4,
            visibility: 'hidden'
        },
        /* Styles applied to the clear indicator if the input is dirty. */ clearIndicatorDirty: {},
        /* Styles applied to the popup indicator. */ popupIndicator: {
            padding: 2,
            marginRight: -2
        },
        /* Styles applied to the popup indicator if the popup is open. */ popupIndicatorOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the popper element. */ popper: {
            zIndex: theme.zIndex.modal
        },
        /* Styles applied to the popper element if `disablePortal={true}`. */ popperDisablePortal: {
            position: 'absolute'
        },
        /* Styles applied to the `Paper` component. */ paper: (0, $fXPf9.default)({}, theme.typography.body1, {
            overflow: 'hidden',
            margin: '4px 0'
        }),
        /* Styles applied to the `listbox` component. */ listbox: {
            listStyle: 'none',
            margin: 0,
            padding: '8px 0',
            maxHeight: '40vh',
            overflow: 'auto'
        },
        /* Styles applied to the loading wrapper. */ loading: {
            color: theme.palette.text.secondary,
            padding: '14px 16px'
        },
        /* Styles applied to the no option wrapper. */ noOptions: {
            color: theme.palette.text.secondary,
            padding: '14px 16px'
        },
        /* Styles applied to the option elements. */ option: (_option = {
            minHeight: 48,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16
        }, (0, $6JmtS.default)(_option, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        }), (0, $6JmtS.default)(_option, '&[aria-selected="true"]', {
            backgroundColor: theme.palette.action.selected
        }), (0, $6JmtS.default)(_option, '&[data-focus="true"]', {
            backgroundColor: theme.palette.action.hover
        }), (0, $6JmtS.default)(_option, '&:active', {
            backgroundColor: theme.palette.action.selected
        }), (0, $6JmtS.default)(_option, '&[aria-disabled="true"]', {
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: 'none'
        }), _option),
        /* Styles applied to the group's label elements. */ groupLabel: {
            backgroundColor: theme.palette.background.paper,
            top: -8
        },
        /* Styles applied to the group's ul elements. */ groupUl: {
            padding: 0,
            '& $option': {
                paddingLeft: 24
            }
        }
    };
};
function $ef0a823899086208$var$DisablePortal(props) {
    // eslint-disable-next-line react/prop-types
    var anchorEl = props.anchorEl, open = props.open, other = (0, $cVOSt.default)(props, [
        "anchorEl",
        "open"
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", other);
}
var $ef0a823899086208$var$_ref = /*#__PURE__*/ $J42oT.createElement((0, $3XEAu.default), {
    fontSize: "small"
});
var $ef0a823899086208$var$_ref2 = /*#__PURE__*/ $J42oT.createElement((0, $hGbhY.default), null);
var $ef0a823899086208$var$Autocomplete = /*#__PURE__*/ $J42oT.forwardRef(function Autocomplete(props, ref) {
    /* eslint-disable no-unused-vars */ var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, ChipProps = props.ChipProps, classes = props.classes, className = props.className, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$clearText = props.clearText, clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? $ef0a823899086208$var$_ref : _props$closeIcon, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? 'Close' : _props$closeText, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, filterOptions = props.filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$forcePopupIcon = props.forcePopupIcon, forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$getLimitTagsTe = props.getLimitTagsText, getLimitTagsText = _props$getLimitTagsTe === void 0 ? function(more) {
        return "+".concat(more);
    } : _props$getLimitTagsTe, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabel = _props$getOptionLabel === void 0 ? function(x) {
        return x;
    } : _props$getOptionLabel, getOptionSelected = props.getOptionSelected, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$limitTags = props.limitTags, limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags, _props$ListboxCompone = props.ListboxComponent, ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone, ListboxProps = props.ListboxProps, _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, _props$loadingText = props.loadingText, loadingText = _props$loadingText === void 0 ? "Loading\u2026" : _props$loadingText, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$noOptionsText = props.noOptionsText, noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, open = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, _props$openText = props.openText, openText = _props$openText === void 0 ? 'Open' : _props$openText, options = props.options, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $apEOs.default) : _props$PaperComponent, _props$PopperComponen = props.PopperComponent, PopperComponentProp = _props$PopperComponen === void 0 ? (0, $3pZUL.default) : _props$PopperComponen, _props$popupIcon = props.popupIcon, popupIcon = _props$popupIcon === void 0 ? $ef0a823899086208$var$_ref2 : _props$popupIcon, renderGroupProp = props.renderGroup, renderInput = props.renderInput, renderOptionProp = props.renderOption, renderTags = props.renderTags, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, valueProp = props.value, other = (0, $cVOSt.default)(props, [
        "autoComplete",
        "autoHighlight",
        "autoSelect",
        "blurOnSelect",
        "ChipProps",
        "classes",
        "className",
        "clearOnBlur",
        "clearOnEscape",
        "clearText",
        "closeIcon",
        "closeText",
        "debug",
        "defaultValue",
        "disableClearable",
        "disableCloseOnSelect",
        "disabled",
        "disabledItemsFocusable",
        "disableListWrap",
        "disablePortal",
        "filterOptions",
        "filterSelectedOptions",
        "forcePopupIcon",
        "freeSolo",
        "fullWidth",
        "getLimitTagsText",
        "getOptionDisabled",
        "getOptionLabel",
        "getOptionSelected",
        "groupBy",
        "handleHomeEndKeys",
        "id",
        "includeInputInList",
        "inputValue",
        "limitTags",
        "ListboxComponent",
        "ListboxProps",
        "loading",
        "loadingText",
        "multiple",
        "noOptionsText",
        "onChange",
        "onClose",
        "onHighlightChange",
        "onInputChange",
        "onOpen",
        "open",
        "openOnFocus",
        "openText",
        "options",
        "PaperComponent",
        "PopperComponent",
        "popupIcon",
        "renderGroup",
        "renderInput",
        "renderOption",
        "renderTags",
        "selectOnFocus",
        "size",
        "value"
    ]);
    /* eslint-enable no-unused-vars */ var PopperComponent = disablePortal ? $ef0a823899086208$var$DisablePortal : PopperComponentProp;
    var _useAutocomplete = (0, $3l5Bc.default)((0, $fXPf9.default)({}, props, {
        componentName: 'Autocomplete'
    })), getRootProps = _useAutocomplete.getRootProps, getInputProps = _useAutocomplete.getInputProps, getInputLabelProps = _useAutocomplete.getInputLabelProps, getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps, getClearProps = _useAutocomplete.getClearProps, getTagProps = _useAutocomplete.getTagProps, getListboxProps = _useAutocomplete.getListboxProps, getOptionProps = _useAutocomplete.getOptionProps, value = _useAutocomplete.value, dirty = _useAutocomplete.dirty, id = _useAutocomplete.id, popupOpen = _useAutocomplete.popupOpen, focused = _useAutocomplete.focused, focusedTag = _useAutocomplete.focusedTag, anchorEl = _useAutocomplete.anchorEl, setAnchorEl = _useAutocomplete.setAnchorEl, inputValue = _useAutocomplete.inputValue, groupedOptions = _useAutocomplete.groupedOptions;
    var startAdornment;
    if (multiple && value.length > 0) {
        var getCustomizedTagProps = function getCustomizedTagProps(params) {
            return (0, $fXPf9.default)({
                className: (0, $lKxJt.default)(classes.tag, size === 'small' && classes.tagSizeSmall),
                disabled: disabled
            }, getTagProps(params));
        };
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps);
        else startAdornment = value.map(function(option, index) {
            return /*#__PURE__*/ $J42oT.createElement((0, $fycnb.default), (0, $fXPf9.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps));
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        var more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ $J42oT.createElement("span", {
                className: classes.tag,
                key: startAdornment.length
            }, getLimitTagsText(more)));
        }
    }
    var defaultRenderGroup = function defaultRenderGroup(params) {
        return /*#__PURE__*/ $J42oT.createElement("li", {
            key: params.key
        }, /*#__PURE__*/ $J42oT.createElement((0, $XfB1L.default), {
            className: classes.groupLabel,
            component: "div"
        }, params.group), /*#__PURE__*/ $J42oT.createElement("ul", {
            className: classes.groupUl
        }, params.children));
    };
    var renderGroup = renderGroupProp || defaultRenderGroup;
    var renderOption = renderOptionProp || getOptionLabel;
    var renderListOption = function renderListOption(option, index) {
        var optionProps = getOptionProps({
            option: option,
            index: index
        });
        return /*#__PURE__*/ $J42oT.createElement("li", (0, $fXPf9.default)({}, optionProps, {
            className: classes.option
        }), renderOption(option, {
            selected: optionProps['aria-selected'],
            inputValue: inputValue
        }));
    };
    var hasClearIcon = !disableClearable && !disabled;
    var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, null, /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        ref: ref,
        className: (0, $lKxJt.default)(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
    }, getRootProps(other)), renderInput({
        id: id,
        disabled: disabled,
        fullWidth: true,
        size: size === 'small' ? 'small' : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: {
            ref: setAnchorEl,
            className: classes.inputRoot,
            startAdornment: startAdornment,
            endAdornment: /*#__PURE__*/ $J42oT.createElement("div", {
                className: classes.endAdornment
            }, hasClearIcon ? /*#__PURE__*/ $J42oT.createElement((0, $io0Xu.default), (0, $fXPf9.default)({}, getClearProps(), {
                "aria-label": clearText,
                title: clearText,
                className: (0, $lKxJt.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
            }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/ $J42oT.createElement((0, $io0Xu.default), (0, $fXPf9.default)({}, getPopupIndicatorProps(), {
                disabled: disabled,
                "aria-label": popupOpen ? closeText : openText,
                title: popupOpen ? closeText : openText,
                className: (0, $lKxJt.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
            }), popupIcon) : null)
        },
        inputProps: (0, $fXPf9.default)({
            className: (0, $lKxJt.default)(classes.input, focusedTag === -1 && classes.inputFocused),
            disabled: disabled
        }, getInputProps())
    })), popupOpen && anchorEl ? /*#__PURE__*/ $J42oT.createElement(PopperComponent, {
        className: (0, $lKxJt.default)(classes.popper, disablePortal && classes.popperDisablePortal),
        style: {
            width: anchorEl ? anchorEl.clientWidth : null
        },
        role: "presentation",
        anchorEl: anchorEl,
        open: true
    }, /*#__PURE__*/ $J42oT.createElement(PaperComponent, {
        className: classes.paper
    }, loading && groupedOptions.length === 0 ? /*#__PURE__*/ $J42oT.createElement("div", {
        className: classes.loading
    }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ $J42oT.createElement("div", {
        className: classes.noOptions
    }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/ $J42oT.createElement(ListboxComponent, (0, $fXPf9.default)({
        className: classes.listbox
    }, getListboxProps(), ListboxProps), groupedOptions.map(function(option, index) {
        if (groupBy) return renderGroup({
            key: option.key,
            group: option.group,
            children: option.options.map(function(option2, index2) {
                return renderListOption(option2, option.index + index2);
            })
        });
        return renderListOption(option, index);
    })) : null)) : null);
});
$ef0a823899086208$var$Autocomplete.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the first option is automatically highlighted.
   */ autoHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */ autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */ blurOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'mouse',
            'touch'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
    ]),
    /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */ ChipProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */ clearOnBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */ clearOnEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */ clearText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The icon to display in place of the default close icon.
   */ closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */ closeText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */ debug: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The default input value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * If `true`, the input can't be cleared.
   */ disableClearable: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .bool,
    /**
   * If `true`, the popup won't close when a value is selected.
   */ disableCloseOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the input will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, will allow focus on disabled items.
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the list box in the popup will not wrap focus.
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */ filterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If `true`, hide the selected options from the list box.
   */ filterSelectedOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Force the visibility display of the popup icon.
   */ forcePopupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
    ]),
    /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */ freeSolo: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .bool,
    /**
   * If `true`, the input will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */ getLimitTagsText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */ getOptionDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */ getOptionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */ getOptionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */ groupBy: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */ handleHomeEndKeys: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the highlight can move to the input.
   */ includeInputInList: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The input value.
   */ inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */ limitTags: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * The component used to render the listbox.
   */ ListboxComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Props applied to the Listbox element.
   */ ListboxProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * If `true`, the component is in a loading state.
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */ loadingText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .bool,
    /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */ noOptionsText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */ onHighlightChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Control the popup` open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the popup will open on input focus.
   */ openOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */ openText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Array of options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).array.isRequired,
    /**
   * The component used to render the body of the popup.
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * The component used to position the popup.
   */ PopperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * The icon to display in place of the default popup icon.
   */ popupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */ renderGroup: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func.isRequired,
    /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */ renderOption: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */ renderTags: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */ selectOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The size of the autocomplete.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'medium',
        'small'
    ]),
    /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any
};
var $ef0a823899086208$export$2e2bcd8739ae039 = (0, $cV5xs.default)($ef0a823899086208$export$9dd6ff9ea0189349, {
    name: 'MuiAutocomplete'
})($ef0a823899086208$var$Autocomplete);

});
parcelRegister("3pZUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d3bbd4d25417fc$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $2rCyT = parcelRequire("2rCyT");

var $81kKd = parcelRequire("81kKd");
var $9qmQg = parcelRequire("9qmQg");
var $bYG1J = parcelRequire("bYG1J");

var $27Cb9 = parcelRequire("27Cb9");

var $4D53l = parcelRequire("4D53l");

var $iHBmE = parcelRequire("iHBmE");

var $2VSrH = parcelRequire("2VSrH");

var $bDH0e = parcelRequire("bDH0e");
function $27d3bbd4d25417fc$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || 'ltr';
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $27d3bbd4d25417fc$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $27d3bbd4d25417fc$var$useEnhancedEffect = typeof window !== 'undefined' ? $J42oT.useLayoutEffect : $J42oT.useEffect;
var $27d3bbd4d25417fc$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $27d3bbd4d25417fc$var$Popper = /*#__PURE__*/ $J42oT.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $27d3bbd4d25417fc$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $cVOSt.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $J42oT.useRef(null);
    var ownRef = (0, $bDH0e.default)(tooltipRef, ref);
    var popperRef = $J42oT.useRef(null);
    var handlePopperRef = (0, $bDH0e.default)(popperRef, popperRefProp);
    var handlePopperRefRef = $J42oT.useRef(handlePopperRef);
    $27d3bbd4d25417fc$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $J42oT.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $J42oT.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $27Cb9.default)();
    var rtlPlacement = $27d3bbd4d25417fc$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $J42oT.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $J42oT.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $J42oT.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $27d3bbd4d25417fc$var$getAnchorEl(anchorEl);
        if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
            var box = resolvedAnchorEl.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'Material-UI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        var popper = new (0, $2rCyT.default)($27d3bbd4d25417fc$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $fXPf9.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $fXPf9.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: 'window'
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $iHBmE.default)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $iHBmE.default)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $J42oT.useCallback(function(node) {
        (0, $2VSrH.default)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $J42oT.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $J42oT.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $J42oT.createElement((0, $4D53l.default), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $fXPf9.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: 'fixed',
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? 'none' : null
        }, style)
    }), typeof children === 'function' ? children(childProps) : children));
});
$27d3bbd4d25417fc$var$Popper.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]), function(props) {
        if (props.open) {
            var resolvedAnchorEl = $27d3bbd4d25417fc$var$getAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                var box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'Material-UI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') return new Error([
                'Material-UI: The `anchorEl` prop provided to the component is invalid.',
                'It should be an HTML element instance or a referenceObject ',
                '(https://popper.js.org/docs/v1/#referenceObject).'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * Popper render function or node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]).isRequired,
    /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .oneOfType([
        (0, $9qmQg.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).instanceOf($J42oT.Component),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ]),
    /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */ modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * If `true`, the popper is visible.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * Popper placement.
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */ popperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * A ref that points to the used popper instance.
   */ popperRef: (0, $bYG1J.default),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Help supporting a react-transition-group/Transition component.
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $27d3bbd4d25417fc$export$2e2bcd8739ae039 = $27d3bbd4d25417fc$var$Popper;

});
parcelRegister("2rCyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7c03f906ef5407$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $1c7c03f906ef5407$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $1c7c03f906ef5407$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($1c7c03f906ef5407$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $1c7c03f906ef5407$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $1c7c03f906ef5407$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $1c7c03f906ef5407$var$timeoutDuration);
        }
    };
}
var $1c7c03f906ef5407$var$supportsMicroTasks = $1c7c03f906ef5407$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $1c7c03f906ef5407$var$debounce = $1c7c03f906ef5407$var$supportsMicroTasks ? $1c7c03f906ef5407$var$microtaskDebounce : $1c7c03f906ef5407$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $1c7c03f906ef5407$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $1c7c03f906ef5407$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $1c7c03f906ef5407$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $1c7c03f906ef5407$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $1c7c03f906ef5407$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $1c7c03f906ef5407$var$getScrollParent($1c7c03f906ef5407$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $1c7c03f906ef5407$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $1c7c03f906ef5407$var$isIE11 = $1c7c03f906ef5407$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $1c7c03f906ef5407$var$isIE10 = $1c7c03f906ef5407$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $1c7c03f906ef5407$var$isIE(version) {
    if (version === 11) return $1c7c03f906ef5407$var$isIE11;
    if (version === 10) return $1c7c03f906ef5407$var$isIE10;
    return $1c7c03f906ef5407$var$isIE11 || $1c7c03f906ef5407$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $1c7c03f906ef5407$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $1c7c03f906ef5407$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $1c7c03f906ef5407$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $1c7c03f906ef5407$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $1c7c03f906ef5407$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $1c7c03f906ef5407$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $1c7c03f906ef5407$var$getRoot(node) {
    if (node.parentNode !== null) return $1c7c03f906ef5407$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $1c7c03f906ef5407$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($1c7c03f906ef5407$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $1c7c03f906ef5407$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $1c7c03f906ef5407$var$getRoot(element1);
    if (element1root.host) return $1c7c03f906ef5407$var$findCommonOffsetParent(element1root.host, element2);
    else return $1c7c03f906ef5407$var$findCommonOffsetParent(element1, $1c7c03f906ef5407$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $1c7c03f906ef5407$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $1c7c03f906ef5407$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $1c7c03f906ef5407$var$getScroll(element, 'top');
    var scrollLeft = $1c7c03f906ef5407$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $1c7c03f906ef5407$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $1c7c03f906ef5407$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $1c7c03f906ef5407$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $1c7c03f906ef5407$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $1c7c03f906ef5407$var$isIE(10) && getComputedStyle(html);
    return {
        height: $1c7c03f906ef5407$var$getSize('Height', body, html, computedStyle),
        width: $1c7c03f906ef5407$var$getSize('Width', body, html, computedStyle)
    };
}
var $1c7c03f906ef5407$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $1c7c03f906ef5407$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $1c7c03f906ef5407$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $1c7c03f906ef5407$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $1c7c03f906ef5407$var$getClientRect(offsets) {
    return $1c7c03f906ef5407$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $1c7c03f906ef5407$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($1c7c03f906ef5407$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $1c7c03f906ef5407$var$getScroll(element, 'top');
            var scrollLeft = $1c7c03f906ef5407$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $1c7c03f906ef5407$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $1c7c03f906ef5407$var$getStyleComputedProperty(element);
        horizScrollbar -= $1c7c03f906ef5407$var$getBordersSize(styles, 'x');
        vertScrollbar -= $1c7c03f906ef5407$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $1c7c03f906ef5407$var$getClientRect(result);
}
function $1c7c03f906ef5407$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $1c7c03f906ef5407$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $1c7c03f906ef5407$var$getBoundingClientRect(children);
    var parentRect = $1c7c03f906ef5407$var$getBoundingClientRect(parent);
    var scrollParent = $1c7c03f906ef5407$var$getScrollParent(children);
    var styles = $1c7c03f906ef5407$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $1c7c03f906ef5407$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $1c7c03f906ef5407$var$includeScroll(offsets, parent);
    return offsets;
}
function $1c7c03f906ef5407$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $1c7c03f906ef5407$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $1c7c03f906ef5407$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $1c7c03f906ef5407$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $1c7c03f906ef5407$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $1c7c03f906ef5407$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($1c7c03f906ef5407$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $1c7c03f906ef5407$var$getParentNode(element);
    if (!parentNode) return false;
    return $1c7c03f906ef5407$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $1c7c03f906ef5407$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $1c7c03f906ef5407$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $1c7c03f906ef5407$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $1c7c03f906ef5407$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $1c7c03f906ef5407$var$getFixedPositionOffsetParent(popper) : $1c7c03f906ef5407$var$findCommonOffsetParent(popper, $1c7c03f906ef5407$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $1c7c03f906ef5407$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $1c7c03f906ef5407$var$getScrollParent($1c7c03f906ef5407$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $1c7c03f906ef5407$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$1c7c03f906ef5407$var$isFixed(offsetParent)) {
            var _getWindowSizes = $1c7c03f906ef5407$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $1c7c03f906ef5407$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $1c7c03f906ef5407$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $1c7c03f906ef5407$var$_extends({
            key: key
        }, rects[key], {
            area: $1c7c03f906ef5407$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $1c7c03f906ef5407$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $1c7c03f906ef5407$var$getFixedPositionOffsetParent(popper) : $1c7c03f906ef5407$var$findCommonOffsetParent(popper, $1c7c03f906ef5407$var$getReferenceNode(reference));
    return $1c7c03f906ef5407$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $1c7c03f906ef5407$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $1c7c03f906ef5407$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $1c7c03f906ef5407$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $1c7c03f906ef5407$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$1c7c03f906ef5407$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $1c7c03f906ef5407$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $1c7c03f906ef5407$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $1c7c03f906ef5407$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $1c7c03f906ef5407$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $1c7c03f906ef5407$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $1c7c03f906ef5407$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $1c7c03f906ef5407$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $1c7c03f906ef5407$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $1c7c03f906ef5407$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $1c7c03f906ef5407$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $1c7c03f906ef5407$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $1c7c03f906ef5407$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $1c7c03f906ef5407$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $1c7c03f906ef5407$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $1c7c03f906ef5407$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $1c7c03f906ef5407$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($1c7c03f906ef5407$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$1c7c03f906ef5407$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $1c7c03f906ef5407$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $1c7c03f906ef5407$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $1c7c03f906ef5407$var$attachToScrollParents($1c7c03f906ef5407$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $1c7c03f906ef5407$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $1c7c03f906ef5407$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $1c7c03f906ef5407$var$getScrollParent(reference);
    $1c7c03f906ef5407$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $1c7c03f906ef5407$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $1c7c03f906ef5407$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $1c7c03f906ef5407$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $1c7c03f906ef5407$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $1c7c03f906ef5407$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $1c7c03f906ef5407$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $1c7c03f906ef5407$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $1c7c03f906ef5407$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $1c7c03f906ef5407$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $1c7c03f906ef5407$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $1c7c03f906ef5407$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $1c7c03f906ef5407$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $1c7c03f906ef5407$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $1c7c03f906ef5407$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $1c7c03f906ef5407$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $1c7c03f906ef5407$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $1c7c03f906ef5407$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $1c7c03f906ef5407$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $1c7c03f906ef5407$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $1c7c03f906ef5407$var$isFirefox = $1c7c03f906ef5407$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $1c7c03f906ef5407$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $1c7c03f906ef5407$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $1c7c03f906ef5407$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $1c7c03f906ef5407$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$1c7c03f906ef5407$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $1c7c03f906ef5407$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $1c7c03f906ef5407$var$_extends({}, attributes, data.attributes);
    data.styles = $1c7c03f906ef5407$var$_extends({}, styles, data.styles);
    data.arrowStyles = $1c7c03f906ef5407$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $1c7c03f906ef5407$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $1c7c03f906ef5407$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$1c7c03f906ef5407$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $1c7c03f906ef5407$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $1c7c03f906ef5407$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $1c7c03f906ef5407$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $1c7c03f906ef5407$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $1c7c03f906ef5407$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $1c7c03f906ef5407$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $1c7c03f906ef5407$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $1c7c03f906ef5407$var$validPlacements = $1c7c03f906ef5407$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $1c7c03f906ef5407$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $1c7c03f906ef5407$var$validPlacements.indexOf(placement);
    var arr = $1c7c03f906ef5407$var$validPlacements.slice(index + 1).concat($1c7c03f906ef5407$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $1c7c03f906ef5407$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($1c7c03f906ef5407$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $1c7c03f906ef5407$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $1c7c03f906ef5407$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $1c7c03f906ef5407$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $1c7c03f906ef5407$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $1c7c03f906ef5407$var$clockwise(placement);
            break;
        case $1c7c03f906ef5407$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $1c7c03f906ef5407$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $1c7c03f906ef5407$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $1c7c03f906ef5407$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $1c7c03f906ef5407$var$_extends({}, data.offsets.popper, $1c7c03f906ef5407$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $1c7c03f906ef5407$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $1c7c03f906ef5407$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $1c7c03f906ef5407$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $1c7c03f906ef5407$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($1c7c03f906ef5407$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $1c7c03f906ef5407$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($1c7c03f906ef5407$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($1c7c03f906ef5407$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $1c7c03f906ef5407$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $1c7c03f906ef5407$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $1c7c03f906ef5407$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $1c7c03f906ef5407$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $1c7c03f906ef5407$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $1c7c03f906ef5407$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $1c7c03f906ef5407$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $1c7c03f906ef5407$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $1c7c03f906ef5407$var$defineProperty({}, side, reference[side]),
            end: $1c7c03f906ef5407$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $1c7c03f906ef5407$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$hide(data) {
    if (!$1c7c03f906ef5407$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $1c7c03f906ef5407$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1c7c03f906ef5407$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $1c7c03f906ef5407$var$getOppositePlacement(placement);
    data.offsets.popper = $1c7c03f906ef5407$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $1c7c03f906ef5407$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1c7c03f906ef5407$var$applyStyle,
        /** @prop {Function} */ onLoad: $1c7c03f906ef5407$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $1c7c03f906ef5407$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $1c7c03f906ef5407$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $1c7c03f906ef5407$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $1c7c03f906ef5407$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $1c7c03f906ef5407$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $1c7c03f906ef5407$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($1c7c03f906ef5407$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $1c7c03f906ef5407$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $1c7c03f906ef5407$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $1c7c03f906ef5407$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $1c7c03f906ef5407$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $1c7c03f906ef5407$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $1c7c03f906ef5407$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $1c7c03f906ef5407$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $1c7c03f906ef5407$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $1c7c03f906ef5407$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$1c7c03f906ef5407$var$Popper.placements = $1c7c03f906ef5407$var$placements;
$1c7c03f906ef5407$var$Popper.Defaults = $1c7c03f906ef5407$var$Defaults;
var $1c7c03f906ef5407$export$2e2bcd8739ae039 = $1c7c03f906ef5407$var$Popper;

});


parcelRegister("XfB1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b219be2f9fdeae2$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");
var $0b219be2f9fdeae2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            boxSizing: 'border-box',
            lineHeight: '48px',
            listStyle: 'none',
            color: theme.palette.text.secondary,
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(14)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the root element if `inset={true}`. */ inset: {
            paddingLeft: 72
        },
        /* Styles applied to the root element if `disableSticky={false}`. */ sticky: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'inherit'
        }
    };
};
var $0b219be2f9fdeae2$var$ListSubheader = /*#__PURE__*/ $J42oT.forwardRef(function ListSubheader(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$disableSticky = props.disableSticky, disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "disableGutters",
        "disableSticky",
        "inset"
    ]);
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $7OrFE.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
$0b219be2f9fdeae2$var$ListSubheader.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'primary',
        'inherit'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the List Subheader will not have gutters.
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */ disableSticky: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the List Subheader will be indented.
   */ inset: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $0b219be2f9fdeae2$export$2e2bcd8739ae039 = (0, $cV5xs.default)($0b219be2f9fdeae2$export$9dd6ff9ea0189349, {
    name: 'MuiListSubheader'
})($0b219be2f9fdeae2$var$ListSubheader);

});

parcelRegister("io0Xu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62b363d99e10e27$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $81kKd = parcelRequire("81kKd");

var $cV5xs = parcelRequire("cV5xs");

var $idwNS = parcelRequire("idwNS");

var $igPVj = parcelRequire("igPVj");

var $7OrFE = parcelRequire("7OrFE");
var $d62b363d99e10e27$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $d62b363d99e10e27$var$IconButton = /*#__PURE__*/ $J42oT.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $cVOSt.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $igPVj.default), (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $7OrFE.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $7OrFE.default)(size))], {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.label
    }, children));
});
$d62b363d99e10e27$var$IconButton.propTypes = {
    /**
   * The icon element.
   */ children: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node, function(props) {
        var found = $J42oT.Children.toArray(props.children).some(function(child) {
            return /*#__PURE__*/ $J42oT.isValidElement(child) && child.props.onClick;
        });
        if (found) return new Error([
            "Material-UI: You are providing an onClick event listener to a child of a button element.",
            'Firefox will never trigger the event.',
            'You should move the onClick listener to the parent button element.',
            'https://github.com/mui-org/material-ui/issues/13957'
        ].join('\n'));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * If `true`, the button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'start',
        'end',
        false
    ]),
    /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'small',
        'medium'
    ])
};
var $d62b363d99e10e27$export$2e2bcd8739ae039 = (0, $cV5xs.default)($d62b363d99e10e27$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($d62b363d99e10e27$var$IconButton);

});
parcelRegister("igPVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d1ff86238ef148$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $f3ft4 = parcelRequire("f3ft4");

var $lKxJt = parcelRequire("lKxJt");

var $2NTyb = parcelRequire("2NTyb");
var $bYG1J = parcelRequire("bYG1J");

var $bDH0e = parcelRequire("bDH0e");

var $dzxus = parcelRequire("dzxus");

var $6CUay = parcelRequire("6CUay");

var $cV5xs = parcelRequire("cV5xs");

var $4bCnZ = parcelRequire("4bCnZ");

var $b2mQs = parcelRequire("b2mQs");
var $d4d1ff86238ef148$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $d4d1ff86238ef148$var$ButtonBase = /*#__PURE__*/ $J42oT.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $cVOSt.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $J42oT.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $f3ft4.findDOMNode(buttonRef.current);
    }
    var rippleRef = $J42oT.useRef(null);
    var _React$useState = $J42oT.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $4bCnZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $J42oT.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $J42oT.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $dzxus.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $dzxus.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $J42oT.useRef(false);
    var handleKeyDown = (0, $dzxus.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $dzxus.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $bDH0e.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $bDH0e.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $bDH0e.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $J42oT.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $J42oT.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $J42oT.useEffect(function() {
        if (enableTouchRipple && !rippleRef.current) console.error([
            'Material-UI: The `component` prop provided to ButtonBase is invalid.',
            'Please make sure the children prop is rendered in this custom component.'
        ].join('\n'));
    }, [
        enableTouchRipple
    ]);
    return /*#__PURE__*/ $J42oT.createElement(ComponentProp, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $J42oT.createElement((0, $b2mQs.default), (0, $fXPf9.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
$d4d1ff86238ef148$var$ButtonBase.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: (0, $bYG1J.default),
    /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */ buttonRef: (0, $6CUay.default)((0, $bYG1J.default), 'Use `ref` instead.'),
    /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */ centerRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $2NTyb.default),
    /**
   * If `true`, the base button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the touch ripple effect will be disabled.
   */ disableTouchRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   */ focusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ])
};
var $d4d1ff86238ef148$export$2e2bcd8739ae039 = (0, $cV5xs.default)($d4d1ff86238ef148$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($d4d1ff86238ef148$var$ButtonBase);

});
parcelRegister("4bCnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c5f720743c3867$export$2e2bcd8739ae039);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $J42oT = parcelRequire("J42oT");

var $f3ft4 = parcelRequire("f3ft4");
var $30c5f720743c3867$var$hadKeyboardEvent = true;
var $30c5f720743c3867$var$hadFocusVisibleRecently = false;
var $30c5f720743c3867$var$hadFocusVisibleRecentlyTimeout = null;
var $30c5f720743c3867$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $30c5f720743c3867$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $30c5f720743c3867$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $30c5f720743c3867$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $30c5f720743c3867$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $30c5f720743c3867$var$handlePointerDown() {
    $30c5f720743c3867$var$hadKeyboardEvent = false;
}
function $30c5f720743c3867$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($30c5f720743c3867$var$hadFocusVisibleRecently) $30c5f720743c3867$var$hadKeyboardEvent = true;
    }
}
function $30c5f720743c3867$var$prepare(doc) {
    doc.addEventListener('keydown', $30c5f720743c3867$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $30c5f720743c3867$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $30c5f720743c3867$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $30c5f720743c3867$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $30c5f720743c3867$var$handleVisibilityChange, true);
}
function $30c5f720743c3867$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $30c5f720743c3867$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $30c5f720743c3867$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $30c5f720743c3867$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $30c5f720743c3867$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $30c5f720743c3867$var$handleVisibilityChange, true);
}
function $30c5f720743c3867$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $30c5f720743c3867$var$hadKeyboardEvent || $30c5f720743c3867$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $30c5f720743c3867$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $30c5f720743c3867$var$hadFocusVisibleRecently = true;
    window.clearTimeout($30c5f720743c3867$var$hadFocusVisibleRecentlyTimeout);
    $30c5f720743c3867$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $30c5f720743c3867$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $30c5f720743c3867$export$2e2bcd8739ae039() {
    var ref = $J42oT.useCallback(function(instance) {
        var node = $f3ft4.findDOMNode(instance);
        if (node != null) $30c5f720743c3867$var$prepare(node.ownerDocument);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $J42oT.useDebugValue($30c5f720743c3867$var$isFocusVisible);
    return {
        isFocusVisible: $30c5f720743c3867$var$isFocusVisible,
        onBlurVisible: $30c5f720743c3867$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("b2mQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $80919a26f7d310da$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $6kfYZ = parcelRequire("6kfYZ");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $kDjVp = parcelRequire("kDjVp");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $k16JC = parcelRequire("k16JC");
var $80919a26f7d310da$var$DURATION = 550;
var $80919a26f7d310da$export$95d0c9356b2231a3 = 80;
var $80919a26f7d310da$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($80919a26f7d310da$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($80919a26f7d310da$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $80919a26f7d310da$var$TouchRipple = /*#__PURE__*/ $J42oT.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $cVOSt.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $J42oT.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $J42oT.useRef(0);
    var rippleCallback = $J42oT.useRef(null);
    $J42oT.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $J42oT.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $J42oT.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $J42oT.useRef(null);
    var container = $J42oT.useRef(null);
    $J42oT.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $J42oT.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $6kfYZ.default)(oldRipples), [
                /*#__PURE__*/ $J42oT.createElement((0, $k16JC.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $80919a26f7d310da$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $J42oT.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $80919a26f7d310da$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $J42oT.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $J42oT.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $J42oT.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $J42oT.createElement("span", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $J42oT.createElement((0, $kDjVp.default), {
        component: null,
        exit: true
    }, ripples));
});
$80919a26f7d310da$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
};
var $80919a26f7d310da$export$2e2bcd8739ae039 = (0, $cV5xs.default)($80919a26f7d310da$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $J42oT.memo($80919a26f7d310da$var$TouchRipple));

});
parcelRegister("kDjVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e7d6a18235c7$export$2e2bcd8739ae039);

var $bXxv0 = parcelRequire("bXxv0");

var $fXPf9 = parcelRequire("fXPf9");

var $5h49q = parcelRequire("5h49q");

var $1bdSs = parcelRequire("1bdSs");

var $fcOLE = parcelRequire("fcOLE");

var $J42oT = parcelRequire("J42oT");

var $9M2ch = parcelRequire("9M2ch");

var $a531M = parcelRequire("a531M");
var $f056e7d6a18235c7$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $f056e7d6a18235c7$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $f056e7d6a18235c7$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1bdSs.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $5h49q.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $a531M.getInitialChildMapping)(nextProps, handleExited) : (0, $a531M.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $a531M.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $fXPf9.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $bXxv0.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $f056e7d6a18235c7$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $9M2ch.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $9M2ch.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).Component);
$f056e7d6a18235c7$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
};
$f056e7d6a18235c7$var$TransitionGroup.defaultProps = $f056e7d6a18235c7$var$defaultProps;
var $f056e7d6a18235c7$export$2e2bcd8739ae039 = $f056e7d6a18235c7$var$TransitionGroup;

});
parcelRegister("a531M", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $756cb84659476a47$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $756cb84659476a47$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $756cb84659476a47$export$36fd1af28d383ec0);

var $J42oT = parcelRequire("J42oT");
function $756cb84659476a47$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $J42oT.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $J42oT.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $756cb84659476a47$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $756cb84659476a47$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $756cb84659476a47$export$fa71e2345c31d7a2(props, onExited) {
    return $756cb84659476a47$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $J42oT.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $756cb84659476a47$var$getProp(child, 'appear', props),
            enter: $756cb84659476a47$var$getProp(child, 'enter', props),
            exit: $756cb84659476a47$var$getProp(child, 'exit', props)
        });
    });
}
function $756cb84659476a47$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $756cb84659476a47$export$bbc8a025727ea824(nextProps.children);
    var children = $756cb84659476a47$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $J42oT.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $J42oT.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $J42oT.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $756cb84659476a47$var$getProp(child, 'exit', nextProps),
            enter: $756cb84659476a47$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $J42oT.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $J42oT.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $J42oT.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $756cb84659476a47$var$getProp(child, 'exit', nextProps),
            enter: $756cb84659476a47$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("k16JC", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c2ba529d319a3d$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $dzxus = parcelRequire("dzxus");
var $03c2ba529d319a3d$var$useEnhancedEffect = typeof window === 'undefined' ? $J42oT.useEffect : $J42oT.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $03c2ba529d319a3d$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $J42oT.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $lKxJt.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $lKxJt.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $dzxus.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $03c2ba529d319a3d$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $J42oT.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $J42oT.createElement("span", {
        className: childClassName
    }));
}
$03c2ba529d319a3d$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore - injected from TransitionGroup
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * exit delay
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number.isRequired
};
var $03c2ba529d319a3d$export$2e2bcd8739ae039 = $03c2ba529d319a3d$var$Ripple;

});




parcelRegister("fycnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b523a102d794bd21$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $dUxD4 = parcelRequire("dUxD4");

var $cV5xs = parcelRequire("cV5xs");

var $idwNS = parcelRequire("idwNS");

var $bDH0e = parcelRequire("bDH0e");

var $8jVXc = parcelRequire("8jVXc");

var $7OrFE = parcelRequire("7OrFE");

var $igPVj = parcelRequire("igPVj");
var $b523a102d794bd21$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $idwNS.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: 'nowrap',
            transition: theme.transitions.create([
                'background-color',
                'box-shadow'
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: 'default',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: 'none',
            border: 'none',
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: 'middle',
            boxSizing: 'border-box',
            '&$disabled': {
                opacity: 0.5,
                pointerEvents: 'none'
            },
            '& $avatar': {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            '& $avatarColorPrimary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            '& $avatarColorSecondary': {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            '& $avatarSmall': {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: (0, $idwNS.emphasize)(backgroundColor, 0.08)
            },
            '&:active': {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $idwNS.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $idwNS.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            '&:focus': {
                backgroundColor: (0, $idwNS.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            '&:focus': {
                backgroundColor: (0, $idwNS.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            '&:focus': {
                backgroundColor: (0, $idwNS.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: 'transparent',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            '& $avatar': {
                marginLeft: 4
            },
            '& $avatarSmall': {
                marginLeft: 2
            },
            '& $icon': {
                marginLeft: 4
            },
            '& $iconSmall': {
                marginLeft: 2
            },
            '& $deleteIcon': {
                marginRight: 5
            },
            '& $deleteIconSmall': {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: 'inherit'
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: 'inherit'
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: 'transparent',
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: (0, $idwNS.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $idwNS.alpha)(theme.palette.primary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $idwNS.alpha)(theme.palette.secondary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $idwNS.alpha)(theme.palette.primary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $idwNS.alpha)(theme.palette.secondary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $b523a102d794bd21$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $b523a102d794bd21$var$Chip = /*#__PURE__*/ $J42oT.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'default' : _props$variant, other = (0, $cVOSt.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $J42oT.useRef(null);
    var handleRef = (0, $bDH0e.default)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $b523a102d794bd21$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $b523a102d794bd21$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === 'small';
    var Component = ComponentProp || (clickable ? (0, $igPVj.default) : 'div');
    var moreProps = Component === (0, $igPVj.default) ? {
        component: 'div'
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $lKxJt.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, $7OrFE.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $7OrFE.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $J42oT.isValidElement(deleteIconProp) ? /*#__PURE__*/ $J42oT.cloneElement(deleteIconProp, {
            className: (0, $lKxJt.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $J42oT.createElement((0, $dUxD4.default), {
            className: (0, $lKxJt.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $J42oT.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $J42oT.cloneElement(avatarProp, {
        className: (0, $lKxJt.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, $7OrFE.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $J42oT.isValidElement(iconProp)) icon = /*#__PURE__*/ $J42oT.cloneElement(iconProp, {
        className: (0, $lKxJt.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, $7OrFE.default)(color))])
    });
    if (avatar && icon) console.error("Material-UI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        role: clickable || onDelete ? 'button' : undefined,
        className: (0, $lKxJt.default)(classes.root, className, color !== 'default' && [
            classes["color".concat((0, $7OrFE.default)(color))],
            clickable && classes["clickableColor".concat((0, $7OrFE.default)(color))],
            onDelete && classes["deletableColor".concat((0, $7OrFE.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                'primary': classes.outlinedPrimary,
                'secondary': classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $J42oT.createElement("span", {
        className: (0, $lKxJt.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
$b523a102d794bd21$var$Chip.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Avatar element.
   */ avatar: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $8jVXc.default),
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */ clickable: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */ deleteIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * If `true`, the chip should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Icon element.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * The content of the label.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */ onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The size of the chip.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'medium',
        'small'
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'outlined'
    ])
};
var $b523a102d794bd21$export$2e2bcd8739ae039 = (0, $cV5xs.default)($b523a102d794bd21$export$9dd6ff9ea0189349, {
    name: 'MuiChip'
})($b523a102d794bd21$var$Chip);

});
parcelRegister("dUxD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a20a975a665ae4cc$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $a20a975a665ae4cc$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("8jVXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $60ed0d7e2b290c01$export$2e2bcd8739ae039);
function $60ed0d7e2b290c01$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    var propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
    return null;
}

});


parcelRegister("3XEAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e265da0268a39d5$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $2e265da0268a39d5$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("hGbhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdef1da479bb8d9b$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $cdef1da479bb8d9b$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});



parcelRegister("jDaBC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("elWn0")).default);

var $elWn0 = parcelRequire("elWn0");

});
parcelRegister("elWn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7304de9cca21200$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $dajvT = parcelRequire("dajvT");

var $6CUay = parcelRequire("6CUay");
var $a7304de9cca21200$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $a7304de9cca21200$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $a7304de9cca21200$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $a7304de9cca21200$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%'
            };
            return;
        }
        if (size === 'auto') {
            styles[key] = {
                flexBasis: 'auto',
                flexGrow: 0,
                maxWidth: 'none'
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === 'xs') (0, $fXPf9.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $a7304de9cca21200$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}
function $a7304de9cca21200$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $a7304de9cca21200$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($a7304de9cca21200$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($a7304de9cca21200$var$getOffset(themeSpacing), ")"),
            '& > $item': {
                padding: $a7304de9cca21200$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $a7304de9cca21200$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $fXPf9.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: 'border-box',
            margin: '0' // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ 'direction-xs-column': {
            flexDirection: 'column'
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ 'direction-xs-column-reverse': {
            flexDirection: 'column-reverse'
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ 'direction-xs-row-reverse': {
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ 'wrap-xs-nowrap': {
            flexWrap: 'nowrap'
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ 'wrap-xs-wrap-reverse': {
            flexWrap: 'wrap-reverse'
        },
        /* Styles applied to the root element if `alignItems="center"`. */ 'align-items-xs-center': {
            alignItems: 'center'
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ 'align-items-xs-flex-start': {
            alignItems: 'flex-start'
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ 'align-items-xs-flex-end': {
            alignItems: 'flex-end'
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ 'align-items-xs-baseline': {
            alignItems: 'baseline'
        },
        /* Styles applied to the root element if `alignContent="center"`. */ 'align-content-xs-center': {
            alignContent: 'center'
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ 'align-content-xs-flex-start': {
            alignContent: 'flex-start'
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ 'align-content-xs-flex-end': {
            alignContent: 'flex-end'
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ 'align-content-xs-space-between': {
            alignContent: 'space-between'
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ 'align-content-xs-space-around': {
            alignContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ 'justify-content-xs-center': {
            justifyContent: 'center'
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ 'justify-content-xs-flex-end': {
            justifyContent: 'flex-end'
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ 'justify-content-xs-space-between': {
            justifyContent: 'space-between'
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ 'justify-content-xs-space-around': {
            justifyContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ 'justify-content-xs-space-evenly': {
            justifyContent: 'space-evenly'
        }
    }, $a7304de9cca21200$var$generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $a7304de9cca21200$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $a7304de9cca21200$var$Grid = /*#__PURE__*/ $J42oT.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? 'row' : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $cVOSt.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $lKxJt.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: className,
        ref: ref
    }, other));
});
$a7304de9cca21200$var$Grid.propTypes = {
    /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */ alignContent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'stretch',
        'center',
        'flex-start',
        'flex-end',
        'space-between',
        'space-around'
    ]),
    /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'flex-start',
        'center',
        'flex-end',
        'stretch',
        'baseline'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'row',
        'row-reverse',
        'column',
        'column-reverse'
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */ item: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   * @deprecated Use `justifyContent` instead, the prop was renamed
   */ justify: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'flex-start',
        'center',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly'
    ]), 'Use `justifyContent` instead, the prop was renamed.'),
    /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */ justifyContent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'flex-start',
        'center',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly'
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */ lg: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        false,
        'auto',
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */ md: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        false,
        'auto',
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */ sm: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        false,
        'auto',
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf($a7304de9cca21200$var$SPACINGS),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */ wrap: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse'
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */ xl: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        false,
        'auto',
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */ xs: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        false,
        'auto',
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */ zeroMinWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $a7304de9cca21200$var$StyledGrid = (0, $cV5xs.default)($a7304de9cca21200$export$9dd6ff9ea0189349, {
    name: 'MuiGrid'
})($a7304de9cca21200$var$Grid);
var $a7304de9cca21200$var$requireProp = (0, $dajvT.default)('Grid');
$a7304de9cca21200$var$StyledGrid.propTypes = (0, $fXPf9.default)({}, $a7304de9cca21200$var$StyledGrid.propTypes, {
    alignContent: $a7304de9cca21200$var$requireProp('container'),
    alignItems: $a7304de9cca21200$var$requireProp('container'),
    direction: $a7304de9cca21200$var$requireProp('container'),
    justifyContent: $a7304de9cca21200$var$requireProp('container'),
    lg: $a7304de9cca21200$var$requireProp('item'),
    md: $a7304de9cca21200$var$requireProp('item'),
    sm: $a7304de9cca21200$var$requireProp('item'),
    spacing: $a7304de9cca21200$var$requireProp('container'),
    wrap: $a7304de9cca21200$var$requireProp('container'),
    xs: $a7304de9cca21200$var$requireProp('item'),
    zeroMinWidth: $a7304de9cca21200$var$requireProp('item')
});
var $a7304de9cca21200$export$2e2bcd8739ae039 = $a7304de9cca21200$var$StyledGrid;

});
parcelRegister("dajvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $995b5880a02805e0$export$2e2bcd8739ae039);
function $995b5880a02805e0$export$2e2bcd8739ae039(componentNameInError) {
    var requireProp = function requireProp(requiredProp) {
        return function(props, propName, componentName, location, propFullName) {
            var propFullNameSafe = propFullName || propName;
            if (typeof props[propName] !== 'undefined' && !props[requiredProp]) return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
            return null;
        };
    };
    return requireProp;
}

});



parcelRegister("aTo9O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("f3GC3")).default);

var $f3GC3 = parcelRequire("f3GC3");

});
parcelRegister("f3GC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6830d7cb2d97fb$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $81kKd = parcelRequire("81kKd");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");
var $af6830d7cb2d97fb$var$SIZE = 44;
var $af6830d7cb2d97fb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-block'
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: '$circular-rotate 1.4s linear infinite'
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: 'block' // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: '$circular-dash 1.4s ease-in-out infinite',
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: '80px, 200px',
            strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        '@keyframes circular-rotate': {
            '0%': {
                // Fix IE 11 wobbly
                transformOrigin: '50% 50%'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        },
        '@keyframes circular-dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0px'
            },
            '50%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-15px'
            },
            '100%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-125px'
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: 'none'
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $af6830d7cb2d97fb$var$CircularProgress = /*#__PURE__*/ $J42oT.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === 'determinate' || variant === 'static') {
        var circumference = 2 * Math.PI * (($af6830d7cb2d97fb$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $7OrFE.default)(color))], {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'static': classes.static
        }[variant]),
        style: (0, $fXPf9.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $J42oT.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($af6830d7cb2d97fb$var$SIZE / 2, " ").concat($af6830d7cb2d97fb$var$SIZE / 2, " ").concat($af6830d7cb2d97fb$var$SIZE, " ").concat($af6830d7cb2d97fb$var$SIZE)
    }, /*#__PURE__*/ $J42oT.createElement("circle", {
        className: (0, $lKxJt.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            'determinate': classes.circleDeterminate,
            'indeterminate': classes.circleIndeterminate,
            'static': classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $af6830d7cb2d97fb$var$SIZE,
        cy: $af6830d7cb2d97fb$var$SIZE,
        r: ($af6830d7cb2d97fb$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
$af6830d7cb2d97fb$var$CircularProgress.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */ disableShrink: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool, function(props) {
        if (props.disableShrink && props.variant && props.variant !== 'indeterminate') return new Error("Material-UI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The thickness of the circle.
   */ thickness: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */ variant: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'determinate',
        'indeterminate',
        'static'
    ]), function(props) {
        var variant = props.variant;
        if (variant === 'static') throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
        return null;
    })
};
var $af6830d7cb2d97fb$export$2e2bcd8739ae039 = (0, $cV5xs.default)($af6830d7cb2d97fb$export$9dd6ff9ea0189349, {
    name: 'MuiCircularProgress',
    flip: false
})($af6830d7cb2d97fb$var$CircularProgress);

});


parcelRegister("eEcXz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("46ylj")).default);

var $46ylj = parcelRequire("46ylj");

});
parcelRegister("46ylj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fd25cb607666aef$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");

var $6CUay = parcelRequire("6CUay");

var $8GoYc = parcelRequire("8GoYc");

var $6As9D = parcelRequire("6As9D");

var $dmEqn = parcelRequire("dmEqn");

var $gERaq = parcelRequire("gERaq");

var $apEOs = parcelRequire("apEOs");
var $2fd25cb607666aef$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            '@media print': {
                // Use !important to override the Modal inline-style.
                position: 'absolute !important'
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: 'auto',
            overflowX: 'hidden',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0'
            }
        },
        /* Styles applied to the container element. */ container: {
            height: '100%',
            '@media print': {
                height: 'auto'
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: 'relative',
            overflowY: 'auto',
            // Fix IE 11 issue, to remove at some point.
            '@media print': {
                overflowY: 'visible',
                boxShadow: 'none'
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'left' // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            '&$paperScrollBody': (0, $6JmtS.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            '&$paperScrollBody': (0, $6JmtS.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            '&$paperScrollBody': (0, $6JmtS.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            '&$paperScrollBody': (0, $6JmtS.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            '&$paperScrollBody': (0, $6JmtS.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0,
            '&$paperScrollBody': {
                margin: 0,
                maxWidth: '100%'
            }
        }
    };
};
var $2fd25cb607666aef$var$defaultTransitionDuration = {
    enter: (0, $gERaq.duration).enteringScreen,
    exit: (0, $gERaq.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $2fd25cb607666aef$var$Dialog = /*#__PURE__*/ $J42oT.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $apEOs.default) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? 'paper' : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dmEqn.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $2fd25cb607666aef$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props['aria-describedby'], ariaLabelledby = props['aria-labelledby'], other = (0, $cVOSt.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $J42oT.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    return /*#__PURE__*/ $J42oT.createElement((0, $8GoYc.default), (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className),
        BackdropComponent: (0, $6As9D.default),
        BackdropProps: (0, $fXPf9.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $J42oT.createElement(TransitionComponent, (0, $fXPf9.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $J42oT.createElement("div", {
        className: (0, $lKxJt.default)(classes.container, classes["scroll".concat((0, $7OrFE.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $J42oT.createElement(PaperComponent, (0, $fXPf9.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $lKxJt.default)(classes.paper, classes["paperScroll".concat((0, $7OrFE.default)(scroll))], classes["paperWidth".concat((0, $7OrFE.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
$2fd25cb607666aef$var$Dialog.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The id(s) of the element(s) that describe the dialog.
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The id(s) of the element(s) that label the dialog.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Dialog children, usually the included sub-components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   * @deprecated Use the onClose prop with the `reason` argument to filter the `backdropClick` events.
   */ disableBackdropClick: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the dialog will be full-screen
   */ fullScreen: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'lg',
        'md',
        'sm',
        'xl',
        'xs',
        false
    ]),
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback fired before the dialog enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEnter: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the dialog has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntered: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the dialog is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onEntering: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.
   */ onEscapeKeyDown: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),
    /**
   * Callback fired before the dialog exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExit: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the dialog has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExited: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * Callback fired when the dialog is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */ onExiting: (0, $6CUay.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func, 'Use the `TransitionProps` prop instead.'),
    /**
   * If `true`, the Dialog is open.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * The component used to render the body of the dialog.
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Determine the container for scrolling the dialog.
   */ scroll: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'body',
        'paper'
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ]),
    /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
var $2fd25cb607666aef$export$2e2bcd8739ae039 = (0, $cV5xs.default)($2fd25cb607666aef$export$9dd6ff9ea0189349, {
    name: 'MuiDialog'
})($2fd25cb607666aef$var$Dialog);

});
parcelRegister("6As9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbbf1bdb5edc762$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $dmEqn = parcelRequire("dmEqn");
var $4cbbf1bdb5edc762$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
var $4cbbf1bdb5edc762$var$Backdrop = /*#__PURE__*/ $J42oT.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dmEqn.default) : _props$TransitionComp, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $J42oT.createElement(TransitionComponent, (0, $fXPf9.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $J42oT.createElement("div", {
        className: (0, $lKxJt.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
$4cbbf1bdb5edc762$var$Backdrop.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */ invisible: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the backdrop is open.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool.isRequired,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ])
};
var $4cbbf1bdb5edc762$export$2e2bcd8739ae039 = (0, $cV5xs.default)($4cbbf1bdb5edc762$export$9dd6ff9ea0189349, {
    name: 'MuiBackdrop'
})($4cbbf1bdb5edc762$var$Backdrop);

});
parcelRegister("dmEqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bacafe0acb9bd96$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $30ito = parcelRequire("30ito");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $5pZVD = parcelRequire("5pZVD");

var $gERaq = parcelRequire("gERaq");

var $IQ3Oi = parcelRequire("IQ3Oi");

var $joV8i = parcelRequire("joV8i");

var $bDH0e = parcelRequire("bDH0e");
var $9bacafe0acb9bd96$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $9bacafe0acb9bd96$var$defaultTimeout = {
    enter: (0, $gERaq.duration).enteringScreen,
    exit: (0, $gERaq.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $9bacafe0acb9bd96$var$Fade = /*#__PURE__*/ $J42oT.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5pZVD.default) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $9bacafe0acb9bd96$var$defaultTimeout : _props$timeout, other = (0, $cVOSt.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $IQ3Oi.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $J42oT.useRef(null);
    var foreignRef = (0, $bDH0e.default)(children.ref, ref);
    var handleRef = (0, $bDH0e.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $30ito.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $joV8i.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, $joV8i.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $joV8i.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $J42oT.createElement(TransitionComponent, (0, $fXPf9.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $J42oT.cloneElement(children, (0, $fXPf9.default)({
            style: (0, $fXPf9.default)({
                opacity: 0,
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $9bacafe0acb9bd96$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$9bacafe0acb9bd96$var$Fade.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A single child content element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).element,
    /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */ disableStrictModeCompat: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number
        })
    ])
};
var $9bacafe0acb9bd96$export$2e2bcd8739ae039 = $9bacafe0acb9bd96$var$Fade;

});




parcelRegister("cjc3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6zlmX")).default);

var $6zlmX = parcelRequire("6zlmX");

});
parcelRegister("6zlmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c869676dda6410c$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $cqRKQ = parcelRequire("cqRKQ");
var $4c869676dda6410c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        margin: 0,
        padding: '16px 24px',
        flex: '0 0 auto'
    }
};
var $4c869676dda6410c$var$DialogTitle = /*#__PURE__*/ $J42oT.forwardRef(function DialogTitle(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography"
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className),
        ref: ref
    }, other), disableTypography ? children : /*#__PURE__*/ $J42oT.createElement((0, $cqRKQ.default), {
        component: "h2",
        variant: "h6"
    }, children));
});
$4c869676dda6410c$var$DialogTitle.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $4c869676dda6410c$export$2e2bcd8739ae039 = (0, $cV5xs.default)($4c869676dda6410c$export$9dd6ff9ea0189349, {
    name: 'MuiDialogTitle'
})($4c869676dda6410c$var$DialogTitle);

});
parcelRegister("cqRKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d19c45efd35435$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");
var $90d19c45efd35435$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $90d19c45efd35435$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $90d19c45efd35435$var$Typography = /*#__PURE__*/ $J42oT.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $90d19c45efd35435$var$defaultVariantMapping : _props$variantMapping, other = (0, $cVOSt.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $90d19c45efd35435$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $7OrFE.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $7OrFE.default)(align))], display !== 'initial' && classes["display".concat((0, $7OrFE.default)(display))]),
        ref: ref
    }, other));
});
$90d19c45efd35435$var$Typography.propTypes = {
    /**
   * Set the text-align on the component.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'inherit',
        'left',
        'center',
        'right',
        'justify'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'initial',
        'inherit',
        'primary',
        'secondary',
        'textPrimary',
        'textSecondary',
        'error'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Controls the display type
   */ display: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'initial',
        'block',
        'inline'
    ]),
    /**
   * If `true`, the text will have a bottom margin.
   */ gutterBottom: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */ noWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the text will have a bottom margin.
   */ paragraph: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Applies the theme typography styles.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline',
        'srOnly',
        'inherit'
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */ variantMapping: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
var $90d19c45efd35435$export$2e2bcd8739ae039 = (0, $cV5xs.default)($90d19c45efd35435$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($90d19c45efd35435$var$Typography);

});



parcelRegister("ccMAL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6fGoL")).default);

var $6fGoL = parcelRequire("6fGoL");

});
parcelRegister("6fGoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d5083f28582e04$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");
var $48d5083f28582e04$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto',
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            overflowY: 'auto',
            padding: '8px 24px',
            '&:first-child': {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: '16px 24px',
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $48d5083f28582e04$var$DialogContent = /*#__PURE__*/ $J42oT.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
$48d5083f28582e04$var$DialogContent.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Display the top and bottom dividers.
   */ dividers: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $48d5083f28582e04$export$2e2bcd8739ae039 = (0, $cV5xs.default)($48d5083f28582e04$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContent'
})($48d5083f28582e04$var$DialogContent);

});


parcelRegister("i6cb3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("hjEEz")).default);

var $hjEEz = parcelRequire("hjEEz");

});
parcelRegister("hjEEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b3beee1b0255c4$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $cV5xs = parcelRequire("cV5xs");

var $cqRKQ = parcelRequire("cqRKQ");
var $c9b3beee1b0255c4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        marginBottom: 12
    }
};
var $c9b3beee1b0255c4$var$DialogContentText = /*#__PURE__*/ $J42oT.forwardRef(function DialogContentText(props, ref) {
    return /*#__PURE__*/ $J42oT.createElement((0, $cqRKQ.default), (0, $fXPf9.default)({
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref
    }, props));
});
$c9b3beee1b0255c4$var$DialogContentText.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
};
var $c9b3beee1b0255c4$export$2e2bcd8739ae039 = (0, $cV5xs.default)($c9b3beee1b0255c4$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContentText'
})($c9b3beee1b0255c4$var$DialogContentText);

});


parcelRegister("8qTHT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lwYTP")).default);

var $lwYTP = parcelRequire("lwYTP");

});
parcelRegister("lwYTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $facbd3792f17bc98$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");
var $facbd3792f17bc98$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $facbd3792f17bc98$var$DialogActions = /*#__PURE__*/ $J42oT.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $cVOSt.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
$facbd3792f17bc98$var$DialogActions.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the actions do not have additional margin.
   */ disableSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $facbd3792f17bc98$export$2e2bcd8739ae039 = (0, $cV5xs.default)($facbd3792f17bc98$export$9dd6ff9ea0189349, {
    name: 'MuiDialogActions'
})($facbd3792f17bc98$var$DialogActions);

});


parcelRegister("1iKK0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("icZBK")).default);

var $icZBK = parcelRequire("icZBK");

});
parcelRegister("icZBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4192302f7ff4350$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $idwNS = parcelRequire("idwNS");

var $igPVj = parcelRequire("igPVj");

var $7OrFE = parcelRequire("7OrFE");
var $d4192302f7ff4350$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $fXPf9.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $idwNS.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $idwNS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $idwNS.alpha)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $idwNS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $idwNS.alpha)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $idwNS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $d4192302f7ff4350$var$Button = /*#__PURE__*/ $J42oT.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $J42oT.createElement("span", {
        className: (0, $lKxJt.default)(classes.startIcon, classes["iconSize".concat((0, $7OrFE.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $J42oT.createElement("span", {
        className: (0, $lKxJt.default)(classes.endIcon, classes["iconSize".concat((0, $7OrFE.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $J42oT.createElement((0, $igPVj.default), (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $7OrFE.default)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $7OrFE.default)(size))],
            classes["size".concat((0, $7OrFE.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $lKxJt.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
$d4192302f7ff4350$var$Button.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the button.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, no elevation is used.
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Element placed after the children.
   */ endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the button will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'large',
        'medium',
        'small'
    ]),
    /**
   * Element placed before the children.
   */ startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'contained',
        'outlined',
        'text'
    ])
};
var $d4192302f7ff4350$export$2e2bcd8739ae039 = (0, $cV5xs.default)($d4192302f7ff4350$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($d4192302f7ff4350$var$Button);

});


parcelRegister("bRcNV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8lUHk")).default);

var $8lUHk = parcelRequire("8lUHk");

});
parcelRegister("8lUHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $614c43e9b355d80a$export$2e2bcd8739ae039);

var $6kfYZ = parcelRequire("6kfYZ");

var $30ito = parcelRequire("30ito");

var $cVOSt = parcelRequire("cVOSt");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $81kKd = parcelRequire("81kKd");

var $cV5xs = parcelRequire("cV5xs");

var $IQ3Oi = parcelRequire("IQ3Oi");

var $idwNS = parcelRequire("idwNS");

var $4bCnZ = parcelRequire("4bCnZ");

var $1DuTQ = parcelRequire("1DuTQ");

var $dzxus = parcelRequire("dzxus");

var $bDH0e = parcelRequire("bDH0e");

var $7OrFE = parcelRequire("7OrFE");

var $7tsbi = parcelRequire("7tsbi");

var $5j56v = parcelRequire("5j56v");
function $614c43e9b355d80a$var$asc(a, b) {
    return a - b;
}
function $614c43e9b355d80a$var$clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
}
function $614c43e9b355d80a$var$findClosest(values, currentValue) {
    var _values$reduce = values.reduce(function(acc, value, index) {
        var distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null), closestIndex = _values$reduce.index;
    return closestIndex;
}
function $614c43e9b355d80a$var$trackFinger(event, touchId) {
    if (touchId.current !== undefined && event.changedTouches) {
        for(var i = 0; i < event.changedTouches.length; i += 1){
            var touch = event.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $614c43e9b355d80a$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $614c43e9b355d80a$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $614c43e9b355d80a$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        var parts = num.toExponential().split('e-');
        var matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    var decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $614c43e9b355d80a$var$roundValueToStep(value, step, min) {
    var nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($614c43e9b355d80a$var$getDecimalPrecision(step)));
}
function $614c43e9b355d80a$var$setValueIndex(_ref) {
    var values = _ref.values, source = _ref.source, newValue = _ref.newValue, index = _ref.index;
    // Performance shortcut
    if (values[index] === newValue) return source;
    var output = values.slice();
    output[index] = newValue;
    return output;
}
function $614c43e9b355d80a$var$focusThumb(_ref2) {
    var sliderRef = _ref2.sliderRef, activeIndex = _ref2.activeIndex, setActive = _ref2.setActive;
    if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
    if (setActive) setActive(activeIndex);
}
var $614c43e9b355d80a$var$axisProps = {
    horizontal: {
        offset: function offset(percent) {
            return {
                left: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    'horizontal-reverse': {
        offset: function offset(percent) {
            return {
                right: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    vertical: {
        offset: function offset(percent) {
            return {
                bottom: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                height: "".concat(percent, "%")
            };
        }
    }
};
var $614c43e9b355d80a$var$Identity = function Identity(x) {
    return x;
};
var $614c43e9b355d80a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 2,
            width: '100%',
            boxSizing: 'content-box',
            padding: '13px 0',
            display: 'inline-block',
            position: 'relative',
            cursor: 'pointer',
            touchAction: 'none',
            color: theme.palette.primary.main,
            WebkitTapHighlightColor: 'transparent',
            '&$disabled': {
                pointerEvents: 'none',
                cursor: 'default',
                color: theme.palette.grey[400]
            },
            '&$vertical': {
                width: 2,
                height: '100%',
                padding: '0 13px'
            },
            // The primary input mechanism of the device includes a pointing device of limited accuracy.
            '@media (pointer: coarse)': {
                // Reach 42px touch target, about ~8mm on screen.
                padding: '20px 0',
                '&$vertical': {
                    padding: '0 20px'
                }
            },
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {},
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `marks` is provided with at least one label. */ marked: {
            marginBottom: 20,
            '&$vertical': {
                marginBottom: 'auto',
                marginRight: 20
            }
        },
        /* Pseudo-class applied to the root element if `orientation="vertical"`. */ vertical: {},
        /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the rail element. */ rail: {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            opacity: 0.38,
            '$vertical &': {
                height: '100%',
                width: 2
            }
        },
        /* Styles applied to the track element. */ track: {
            display: 'block',
            position: 'absolute',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            '$vertical &': {
                width: 2
            }
        },
        /* Styles applied to the track element if `track={false}`. */ trackFalse: {
            '& $track': {
                display: 'none'
            }
        },
        /* Styles applied to the track element if `track="inverted"`. */ trackInverted: {
            '& $track': {
                backgroundColor: theme.palette.type === 'light' ? (0, $idwNS.lighten)(theme.palette.primary.main, 0.62) : (0, $idwNS.darken)(theme.palette.primary.main, 0.5)
            },
            '& $rail': {
                opacity: 1
            }
        },
        /* Styles applied to the thumb element. */ thumb: {
            position: 'absolute',
            width: 12,
            height: 12,
            marginLeft: -6,
            marginTop: -5,
            boxSizing: 'border-box',
            borderRadius: '50%',
            outline: 0,
            backgroundColor: 'currentColor',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: theme.transitions.create([
                'box-shadow'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&::after': {
                position: 'absolute',
                content: '""',
                borderRadius: '50%',
                // reach 42px hit target (2 * 15 + thumb diameter)
                left: -15,
                top: -15,
                right: -15,
                bottom: -15
            },
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $idwNS.alpha)(theme.palette.primary.main, 0.16)),
                '@media (hover: none)': {
                    boxShadow: 'none'
                }
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $idwNS.alpha)(theme.palette.primary.main, 0.16))
            },
            '&$disabled': {
                width: 8,
                height: 8,
                marginLeft: -4,
                marginTop: -3,
                '&:hover': {
                    boxShadow: 'none'
                }
            },
            '$vertical &': {
                marginLeft: -5,
                marginBottom: -6
            },
            '$vertical &$disabled': {
                marginLeft: -3,
                marginBottom: -4
            }
        },
        /* Styles applied to the thumb element if `color="primary"`. */ thumbColorPrimary: {},
        /* Styles applied to the thumb element if `color="secondary"`. */ thumbColorSecondary: {
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $idwNS.alpha)(theme.palette.secondary.main, 0.16))
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $idwNS.alpha)(theme.palette.secondary.main, 0.16))
            }
        },
        /* Pseudo-class applied to the thumb element if it's active. */ active: {},
        /* Pseudo-class applied to the thumb element if keyboard focused. */ focusVisible: {},
        /* Styles applied to the thumb label element. */ valueLabel: {
            // IE 11 centering bug, to remove from the customization demos once no longer supported
            left: 'calc(-50% - 4px)'
        },
        /* Styles applied to the mark element. */ mark: {
            position: 'absolute',
            width: 2,
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the mark element if active (depending on the value). */ markActive: {
            backgroundColor: theme.palette.background.paper,
            opacity: 0.8
        },
        /* Styles applied to the mark label element. */ markLabel: (0, $fXPf9.default)({}, theme.typography.body2, {
            color: theme.palette.text.secondary,
            position: 'absolute',
            top: 26,
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            '$vertical &': {
                top: 'auto',
                left: 26,
                transform: 'translateY(50%)'
            },
            '@media (pointer: coarse)': {
                top: 40,
                '$vertical &': {
                    left: 31
                }
            }
        }),
        /* Styles applied to the mark label element if active (depending on the value). */ markLabelActive: {
            color: theme.palette.text.primary
        }
    };
};
var $614c43e9b355d80a$var$Slider = /*#__PURE__*/ $J42oT.forwardRef(function Slider(props, ref) {
    var ariaLabel = props['aria-label'], ariaLabelledby = props['aria-labelledby'], ariaValuetext = props['aria-valuetext'], classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'span' : _props$component, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, getAriaLabel = props.getAriaLabel, getAriaValueText = props.getAriaValueText, _props$marks = props.marks, marksProp = _props$marks === void 0 ? false : _props$marks, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, name = props.name, onChange = props.onChange, onChangeCommitted = props.onChangeCommitted, onMouseDown = props.onMouseDown, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$scale = props.scale, scale = _props$scale === void 0 ? $614c43e9b355d80a$var$Identity : _props$scale, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, _props$ThumbComponent = props.ThumbComponent, ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent, _props$track = props.track, track = _props$track === void 0 ? 'normal' : _props$track, valueProp = props.value, _props$ValueLabelComp = props.ValueLabelComponent, ValueLabelComponent = _props$ValueLabelComp === void 0 ? (0, $5j56v.default) : _props$ValueLabelComp, _props$valueLabelDisp = props.valueLabelDisplay, valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp, _props$valueLabelForm = props.valueLabelFormat, valueLabelFormat = _props$valueLabelForm === void 0 ? $614c43e9b355d80a$var$Identity : _props$valueLabelForm, other = (0, $cVOSt.default)(props, [
        "aria-label",
        "aria-labelledby",
        "aria-valuetext",
        "classes",
        "className",
        "color",
        "component",
        "defaultValue",
        "disabled",
        "getAriaLabel",
        "getAriaValueText",
        "marks",
        "max",
        "min",
        "name",
        "onChange",
        "onChangeCommitted",
        "onMouseDown",
        "orientation",
        "scale",
        "step",
        "ThumbComponent",
        "track",
        "value",
        "ValueLabelComponent",
        "valueLabelDisplay",
        "valueLabelFormat"
    ]);
    var theme = (0, $IQ3Oi.default)();
    var touchId = $J42oT.useRef(); // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transfered when inversing a range slider.
    var _React$useState = $J42oT.useState(-1), active = _React$useState[0], setActive = _React$useState[1];
    var _React$useState2 = $J42oT.useState(-1), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _useControlled = (0, $7tsbi.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Slider'
    }), _useControlled2 = (0, $30ito.default)(_useControlled, 2), valueDerived = _useControlled2[0], setValueState = _useControlled2[1];
    var range = Array.isArray(valueDerived);
    var values = range ? valueDerived.slice().sort($614c43e9b355d80a$var$asc) : [
        valueDerived
    ];
    values = values.map(function(value) {
        return $614c43e9b355d80a$var$clamp(value, min, max);
    });
    var marks = marksProp === true && step !== null ? (0, $6kfYZ.default)(Array(Math.floor((max - min) / step) + 1)).map(function(_, index) {
        return {
            value: min + step * index
        };
    }) : marksProp || [];
    var _useIsFocusVisible = (0, $4bCnZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $J42oT.useState(-1), focusVisible = _React$useState3[0], setFocusVisible = _React$useState3[1];
    var sliderRef = $J42oT.useRef();
    var handleFocusRef = (0, $bDH0e.default)(focusVisibleRef, sliderRef);
    var handleRef = (0, $bDH0e.default)(ref, handleFocusRef);
    var handleFocus = (0, $dzxus.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        if (isFocusVisible(event)) setFocusVisible(index);
        setOpen(index);
    });
    var handleBlur = (0, $dzxus.default)(function() {
        if (focusVisible !== -1) {
            setFocusVisible(-1);
            onBlurVisible();
        }
        setOpen(-1);
    });
    var handleMouseOver = (0, $dzxus.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        setOpen(index);
    });
    var handleMouseLeave = (0, $dzxus.default)(function() {
        setOpen(-1);
    });
    var isRtl = theme.direction === 'rtl';
    var handleKeyDown = (0, $dzxus.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        var value = values[index];
        var tenPercents = (max - min) / 10;
        var marksValues = marks.map(function(mark) {
            return mark.value;
        });
        var marksIndex = marksValues.indexOf(value);
        var newValue;
        var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
        var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
        switch(event.key){
            case 'Home':
                newValue = min;
                break;
            case 'End':
                newValue = max;
                break;
            case 'PageUp':
                if (step) newValue = value + tenPercents;
                break;
            case 'PageDown':
                if (step) newValue = value - tenPercents;
                break;
            case increaseKey:
            case 'ArrowUp':
                if (step) newValue = value + step;
                else newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
                break;
            case decreaseKey:
            case 'ArrowDown':
                if (step) newValue = value - step;
                else newValue = marksValues[marksIndex - 1] || marksValues[0];
                break;
            default:
                return;
        } // Prevent scroll of the page
        event.preventDefault();
        if (step) newValue = $614c43e9b355d80a$var$roundValueToStep(newValue, step, min);
        newValue = $614c43e9b355d80a$var$clamp(newValue, min, max);
        if (range) {
            var previousValue = newValue;
            newValue = $614c43e9b355d80a$var$setValueIndex({
                values: values,
                source: valueDerived,
                newValue: newValue,
                index: index
            }).sort($614c43e9b355d80a$var$asc);
            $614c43e9b355d80a$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: newValue.indexOf(previousValue)
            });
        }
        setValueState(newValue);
        setFocusVisible(index);
        if (onChange) onChange(event, newValue);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    });
    var previousIndex = $J42oT.useRef();
    var axis = orientation;
    if (isRtl && orientation !== "vertical") axis += '-reverse';
    var getFingerNewValue = function getFingerNewValue(_ref3) {
        var finger = _ref3.finger, _ref3$move = _ref3.move, move = _ref3$move === void 0 ? false : _ref3$move, values2 = _ref3.values, source = _ref3.source;
        var slider = sliderRef.current;
        var _slider$getBoundingCl = slider.getBoundingClientRect(), width = _slider$getBoundingCl.width, height = _slider$getBoundingCl.height, bottom = _slider$getBoundingCl.bottom, left = _slider$getBoundingCl.left;
        var percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        var newValue;
        newValue = $614c43e9b355d80a$var$percentToValue(percent, min, max);
        if (step) newValue = $614c43e9b355d80a$var$roundValueToStep(newValue, step, min);
        else {
            var marksValues = marks.map(function(mark) {
                return mark.value;
            });
            var closestIndex = $614c43e9b355d80a$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = $614c43e9b355d80a$var$clamp(newValue, min, max);
        var activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $614c43e9b355d80a$var$findClosest(values2, newValue);
            else activeIndex = previousIndex.current;
            var previousValue = newValue;
            newValue = $614c43e9b355d80a$var$setValueIndex({
                values: values2,
                source: source,
                newValue: newValue,
                index: activeIndex
            }).sort($614c43e9b355d80a$var$asc);
            activeIndex = newValue.indexOf(previousValue);
            previousIndex.current = activeIndex;
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    var handleTouchMove = (0, $dzxus.default)(function(event) {
        var finger = $614c43e9b355d80a$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue = getFingerNewValue({
            finger: finger,
            move: true,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue.newValue, activeIndex = _getFingerNewValue.activeIndex;
        $614c43e9b355d80a$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    });
    var handleTouchEnd = (0, $dzxus.default)(function(event) {
        var finger = $614c43e9b355d80a$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue2 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue2.newValue;
        setActive(-1);
        if (event.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
        touchId.current = undefined;
        var doc = (0, $1DuTQ.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    });
    var handleTouchStart = (0, $dzxus.default)(function(event) {
        // Workaround as Safari has partial support for touchAction: 'none'.
        event.preventDefault();
        var touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        var finger = $614c43e9b355d80a$var$trackFinger(event, touchId);
        var _getFingerNewValue3 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue3.newValue, activeIndex = _getFingerNewValue3.activeIndex;
        $614c43e9b355d80a$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $1DuTQ.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    $J42oT.useEffect(function() {
        var slider = sliderRef.current;
        slider.addEventListener('touchstart', handleTouchStart);
        var doc = (0, $1DuTQ.default)(slider);
        return function() {
            slider.removeEventListener('touchstart', handleTouchStart);
            doc.removeEventListener('mousemove', handleTouchMove);
            doc.removeEventListener('mouseup', handleTouchEnd);
            doc.removeEventListener('touchmove', handleTouchMove);
            doc.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart
    ]);
    var handleMouseDown = (0, $dzxus.default)(function(event) {
        if (onMouseDown) onMouseDown(event);
        event.preventDefault();
        var finger = $614c43e9b355d80a$var$trackFinger(event, touchId);
        var _getFingerNewValue4 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue4.newValue, activeIndex = _getFingerNewValue4.activeIndex;
        $614c43e9b355d80a$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $1DuTQ.default)(sliderRef.current);
        doc.addEventListener('mousemove', handleTouchMove);
        doc.addEventListener('mouseup', handleTouchEnd);
    });
    var trackOffset = $614c43e9b355d80a$var$valueToPercent(range ? values[0] : min, min, max);
    var trackLeap = $614c43e9b355d80a$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    var trackStyle = (0, $fXPf9.default)({}, $614c43e9b355d80a$var$axisProps[axis].offset(trackOffset), $614c43e9b355d80a$var$axisProps[axis].leap(trackLeap));
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        ref: handleRef,
        className: (0, $lKxJt.default)(classes.root, classes["color".concat((0, $7OrFE.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function(mark) {
            return mark.label;
        }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
        onMouseDown: handleMouseDown
    }, other), /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.rail
    }), /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.track,
        style: trackStyle
    }), /*#__PURE__*/ $J42oT.createElement("input", {
        value: values.join(','),
        name: name,
        type: "hidden"
    }), marks.map(function(mark, index) {
        var percent = $614c43e9b355d80a$var$valueToPercent(mark.value, min, max);
        var style = $614c43e9b355d80a$var$axisProps[axis].offset(percent);
        var markActive;
        if (track === false) markActive = values.indexOf(mark.value) !== -1;
        else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
        return /*#__PURE__*/ $J42oT.createElement($J42oT.Fragment, {
            key: mark.value
        }, /*#__PURE__*/ $J42oT.createElement("span", {
            style: style,
            "data-index": index,
            className: (0, $lKxJt.default)(classes.mark, markActive && classes.markActive)
        }), mark.label != null ? /*#__PURE__*/ $J42oT.createElement("span", {
            "aria-hidden": true,
            "data-index": index,
            style: style,
            className: (0, $lKxJt.default)(classes.markLabel, markActive && classes.markLabelActive)
        }, mark.label) : null);
    }), values.map(function(value, index) {
        var percent = $614c43e9b355d80a$var$valueToPercent(value, min, max);
        var style = $614c43e9b355d80a$var$axisProps[axis].offset(percent);
        return /*#__PURE__*/ $J42oT.createElement(ValueLabelComponent, {
            key: index,
            valueLabelFormat: valueLabelFormat,
            valueLabelDisplay: valueLabelDisplay,
            className: classes.valueLabel,
            value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
            index: index,
            open: open === index || active === index || valueLabelDisplay === 'on',
            disabled: disabled
        }, /*#__PURE__*/ $J42oT.createElement(ThumbComponent, {
            className: (0, $lKxJt.default)(classes.thumb, classes["thumbColor".concat((0, $7OrFE.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
            tabIndex: disabled ? null : 0,
            role: "slider",
            style: style,
            "data-index": index,
            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            "aria-valuenow": scale(value),
            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave
        }));
    }));
});
$614c43e9b355d80a$var$Slider.propTypes = {
    /**
   * The label of the slider.
   */ 'aria-label': (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string, function(props) {
        var range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-label'] != null) return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
        return null;
    }),
    /**
   * The id of the element containing a label for the slider.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */ 'aria-valuetext': (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string, function(props) {
        var range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-valuetext'] != null) return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * The default element value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number)
    ]),
    /**
   * If `true`, the slider will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaValueText: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */ marks: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).array
    ]),
    /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */ max: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */ min: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * Name attribute of the hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */ onChangeCommitted: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The slider orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * A transformation function, to change the scale of the slider.
   */ scale: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */ step: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
    /**
   * The component used to display the value label.
   */ ThumbComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */ track: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'normal',
        false,
        'inverted'
    ]),
    /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).number)
    ]),
    /**
   * The value label component.
   */ ValueLabelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */ valueLabelDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'on',
        'auto',
        'off'
    ]),
    /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */ valueLabelFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
    ])
};
var $614c43e9b355d80a$export$2e2bcd8739ae039 = (0, $cV5xs.default)($614c43e9b355d80a$export$9dd6ff9ea0189349, {
    name: 'MuiSlider'
})($614c43e9b355d80a$var$Slider);

});
parcelRegister("5j56v", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dd2af9ef4f3900f$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");
var $3dd2af9ef4f3900f$var$styles = function styles(theme) {
    return {
        thumb: {
            '&$open': {
                '& $offset': {
                    transform: 'scale(1) translateY(-10px)'
                }
            }
        },
        open: {},
        offset: (0, $fXPf9.default)({
            zIndex: 1
        }, theme.typography.body2, {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.2,
            transition: theme.transitions.create([
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            top: -34,
            transformOrigin: 'bottom center',
            transform: 'scale(0)',
            position: 'absolute'
        }),
        circle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '50% 50% 50% 0',
            backgroundColor: 'currentColor',
            transform: 'rotate(-45deg)'
        },
        label: {
            color: theme.palette.primary.contrastText,
            transform: 'rotate(45deg)'
        }
    };
};
/**
 * @ignore - internal component.
 */ function $3dd2af9ef4f3900f$var$ValueLabel(props) {
    var children = props.children, classes = props.classes, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
    if (valueLabelDisplay === 'off') return children;
    return /*#__PURE__*/ $J42oT.cloneElement(children, {
        className: (0, $lKxJt.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
    }, /*#__PURE__*/ $J42oT.createElement("span", {
        className: (0, $lKxJt.default)(classes.offset, className)
    }, /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.circle
    }, /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.label
    }, value))));
}
var $3dd2af9ef4f3900f$export$2e2bcd8739ae039 = (0, $cV5xs.default)($3dd2af9ef4f3900f$var$styles, {
    name: 'PrivateValueLabel'
})($3dd2af9ef4f3900f$var$ValueLabel);

});



parcelRegister("jTsdR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b90bcf3ac7c3b6$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $R8WKp = parcelRequire("R8WKp");

var $6MwfJ = parcelRequire("6MwfJ");
function $e7b90bcf3ac7c3b6$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $R8WKp.default)(stylesOrCreator, (0, $fXPf9.default)({
        defaultTheme: (0, $6MwfJ.default)
    }, options));
}
var $e7b90bcf3ac7c3b6$export$2e2bcd8739ae039 = $e7b90bcf3ac7c3b6$var$makeStyles;

});

parcelRegister("gXU2h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7F3Nd")).default);

var $7F3Nd = parcelRequire("7F3Nd");

});
parcelRegister("7F3Nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $593f4de94ab9b3d9$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");

var $apEOs = parcelRequire("apEOs");
var $593f4de94ab9b3d9$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            boxSizing: 'border-box',
            // Prevent padding issue with the Modal and fixed positioned AppBar.
            zIndex: theme.zIndex.appBar,
            flexShrink: 0
        },
        /* Styles applied to the root element if `position="fixed"`. */ positionFixed: {
            position: 'fixed',
            top: 0,
            left: 'auto',
            right: 0,
            '@media print': {
                // Prevent the app bar to be visible on each printed page.
                position: 'absolute'
            }
        },
        /* Styles applied to the root element if `position="absolute"`. */ positionAbsolute: {
            position: 'absolute',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="sticky"`. */ positionSticky: {
            // ⚠️ sticky is not supported by IE 11.
            position: 'sticky',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="static"`. */ positionStatic: {
            position: 'static'
        },
        /* Styles applied to the root element if `position="relative"`. */ positionRelative: {
            position: 'relative'
        },
        /* Styles applied to the root element if `color="default"`. */ colorDefault: {
            backgroundColor: backgroundColorDefault,
            color: theme.palette.getContrastText(backgroundColorDefault)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="transparent"`. */ colorTransparent: {
            backgroundColor: 'transparent',
            color: 'inherit'
        }
    };
};
var $593f4de94ab9b3d9$var$AppBar = /*#__PURE__*/ $J42oT.forwardRef(function AppBar(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$position = props.position, position = _props$position === void 0 ? 'fixed' : _props$position, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "color",
        "position"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $apEOs.default), (0, $fXPf9.default)({
        square: true,
        component: "header",
        elevation: 4,
        className: (0, $lKxJt.default)(classes.root, classes["position".concat((0, $7OrFE.default)(position))], classes["color".concat((0, $7OrFE.default)(color))], className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
$593f4de94ab9b3d9$var$AppBar.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'default',
        'inherit',
        'primary',
        'secondary',
        'transparent'
    ]),
    /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'absolute',
        'fixed',
        'relative',
        'static',
        'sticky'
    ])
};
var $593f4de94ab9b3d9$export$2e2bcd8739ae039 = (0, $cV5xs.default)($593f4de94ab9b3d9$export$9dd6ff9ea0189349, {
    name: 'MuiAppBar'
})($593f4de94ab9b3d9$var$AppBar);

});


parcelRegister("2diEy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6Ql9L")).default);

var $6Ql9L = parcelRequire("6Ql9L");

});
parcelRegister("6Ql9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb802ab09c4a01f$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");

var $5vJdk = parcelRequire("5vJdk");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $bYG1J = parcelRequire("bYG1J");

var $cVQrg = parcelRequire("cVQrg");

var $6fgQ7 = parcelRequire("6fgQ7");

var $ktIK4 = parcelRequire("ktIK4");

var $liifv = parcelRequire("liifv");

var $8wkaq = parcelRequire("8wkaq");

var $cV5xs = parcelRequire("cV5xs");

var $Usx0b = parcelRequire("Usx0b");

var $gnTfo = parcelRequire("gnTfo");

var $dzxus = parcelRequire("dzxus");

var $IQ3Oi = parcelRequire("IQ3Oi");
var $4fb802ab09c4a01f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            minHeight: 48,
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            display: 'flex'
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the flex container element. */ flexContainer: {
            display: 'flex'
        },
        /* Styles applied to the flex container element if `orientation="vertical"`. */ flexContainerVertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */ centered: {
            justifyContent: 'center'
        },
        /* Styles applied to the tablist element. */ scroller: {
            position: 'relative',
            display: 'inline-block',
            flex: '1 1 auto',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the tablist element if `!variant="scrollable"`. */ fixed: {
            overflowX: 'hidden',
            width: '100%'
        },
        /* Styles applied to the tablist element if `variant="scrollable"`. */ scrollable: {
            overflowX: 'scroll',
            // Hide dimensionless scrollbar on MacOS
            scrollbarWidth: 'none',
            // Firefox
            '&::-webkit-scrollbar': {
                display: 'none' // Safari + Chrome
            }
        },
        /* Styles applied to the `ScrollButtonComponent` component. */ scrollButtons: {},
        /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */ scrollButtonsDesktop: (0, $6JmtS.default)({}, theme.breakpoints.down('xs'), {
            display: 'none'
        }),
        /* Styles applied to the `TabIndicator` component. */ indicator: {}
    };
};
var $4fb802ab09c4a01f$var$Tabs = /*#__PURE__*/ $J42oT.forwardRef(function Tabs(props, ref) {
    var ariaLabel = props['aria-label'], ariaLabelledBy = props['aria-labelledby'], action = props.action, _props$centered = props.centered, centered = _props$centered === void 0 ? false : _props$centered, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$indicatorColor = props.indicatorColor, indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$ScrollButtonCo = props.ScrollButtonComponent, ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? (0, $gnTfo.default) : _props$ScrollButtonCo, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons, selectionFollowsFocus = props.selectionFollowsFocus, _props$TabIndicatorPr = props.TabIndicatorProps, TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr, TabScrollButtonProps = props.TabScrollButtonProps, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $cVOSt.default)(props, [
        "aria-label",
        "aria-labelledby",
        "action",
        "centered",
        "children",
        "classes",
        "className",
        "component",
        "indicatorColor",
        "onChange",
        "orientation",
        "ScrollButtonComponent",
        "scrollButtons",
        "selectionFollowsFocus",
        "TabIndicatorProps",
        "TabScrollButtonProps",
        "textColor",
        "value",
        "variant"
    ]);
    var theme = (0, $IQ3Oi.default)();
    var scrollable = variant === 'scrollable';
    var isRtl = theme.direction === 'rtl';
    var vertical = orientation === 'vertical';
    var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    var start = vertical ? 'top' : 'left';
    var end = vertical ? 'bottom' : 'right';
    var clientSize = vertical ? 'clientHeight' : 'clientWidth';
    var size = vertical ? 'height' : 'width';
    if (centered && scrollable) console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    var _React$useState = $J42oT.useState(false), mounted = _React$useState[0], setMounted = _React$useState[1];
    var _React$useState2 = $J42oT.useState({}), indicatorStyle = _React$useState2[0], setIndicatorStyle = _React$useState2[1];
    var _React$useState3 = $J42oT.useState({
        start: false,
        end: false
    }), displayScroll = _React$useState3[0], setDisplayScroll = _React$useState3[1];
    var _React$useState4 = $J42oT.useState({
        overflow: 'hidden',
        marginBottom: null
    }), scrollerStyle = _React$useState4[0], setScrollerStyle = _React$useState4[1];
    var valueToIndex = new Map();
    var tabsRef = $J42oT.useRef(null);
    var tabListRef = $J42oT.useRef(null);
    var getTabsMeta = function getTabsMeta() {
        var tabsNode = tabsRef.current;
        var tabsMeta;
        if (tabsNode) {
            var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $ktIK4.getNormalizedScrollLeft)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        var tabMeta;
        if (tabsNode && value !== false) {
            var _children = tabListRef.current.children;
            if (_children.length > 0) {
                var tab = _children[valueToIndex.get(value)];
                if (!tab) console.error([
                    "Material-UI: The value provided to the Tabs component is invalid.",
                    "None of the Tabs' children match with `".concat(value, "`."),
                    valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null
                ].join('\n'));
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    var updateIndicatorState = (0, $dzxus.default)(function() {
        var _newIndicatorStyle;
        var _getTabsMeta = getTabsMeta(), tabsMeta = _getTabsMeta.tabsMeta, tabMeta = _getTabsMeta.tabMeta;
        var startValue = 0;
        if (tabMeta && tabsMeta) {
            if (vertical) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
            else {
                var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = tabMeta.left - tabsMeta.left + correction;
            }
        }
        var newIndicatorStyle = (_newIndicatorStyle = {}, (0, $6JmtS.default)(_newIndicatorStyle, start, startValue), (0, $6JmtS.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
        if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
            var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    var scroll = function scroll(scrollValue) {
        (0, $liifv.default)(scrollStart, tabsRef.current, scrollValue);
    };
    var moveTabsScroll = function moveTabsScroll(delta) {
        var scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
            scrollValue *= isRtl && (0, $ktIK4.detectScrollType)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    var handleStartScrollClick = function handleStartScrollClick() {
        moveTabsScroll(-tabsRef.current[clientSize]);
    };
    var handleEndScrollClick = function handleEndScrollClick() {
        moveTabsScroll(tabsRef.current[clientSize]);
    };
    var handleScrollbarSizeChange = $J42oT.useCallback(function(scrollbarHeight) {
        setScrollerStyle({
            overflow: null,
            marginBottom: -scrollbarHeight
        });
    }, []);
    var getConditionalElements = function getConditionalElements() {
        var conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ $J42oT.createElement((0, $8wkaq.default), {
            className: classes.scrollable,
            onChange: handleScrollbarSizeChange
        }) : null;
        var scrollButtonsActive = displayScroll.start || displayScroll.end;
        var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ $J42oT.createElement(ScrollButtonComponent, (0, $fXPf9.default)({
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start,
            className: (0, $lKxJt.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ $J42oT.createElement(ScrollButtonComponent, (0, $fXPf9.default)({
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end,
            className: (0, $lKxJt.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        return conditionalElements;
    };
    var scrollSelectedIntoView = (0, $dzxus.default)(function() {
        var _getTabsMeta2 = getTabsMeta(), tabsMeta = _getTabsMeta2.tabsMeta, tabMeta = _getTabsMeta2.tabMeta;
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart);
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(_nextScrollStart);
        }
    });
    var updateScrollButtonState = (0, $dzxus.default)(function() {
        if (scrollable && scrollButtons !== 'off') {
            var _tabsRef$current = tabsRef.current, scrollTop = _tabsRef$current.scrollTop, scrollHeight = _tabsRef$current.scrollHeight, clientHeight = _tabsRef$current.clientHeight, scrollWidth = _tabsRef$current.scrollWidth, clientWidth = _tabsRef$current.clientWidth;
            var showStartScroll;
            var showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                var scrollLeft = (0, $ktIK4.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $J42oT.useEffect(function() {
        var handleResize = (0, $cVQrg.default)(function() {
            updateIndicatorState();
            updateScrollButtonState();
        });
        var win = (0, $6fgQ7.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var handleTabsScroll = $J42oT.useCallback((0, $cVQrg.default)(function() {
        updateScrollButtonState();
    }));
    $J42oT.useEffect(function() {
        return function() {
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $J42oT.useEffect(function() {
        setMounted(true);
    }, []);
    $J42oT.useEffect(function() {
        updateIndicatorState();
        updateScrollButtonState();
    });
    $J42oT.useEffect(function() {
        scrollSelectedIntoView();
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $J42oT.useImperativeHandle(action, function() {
        return {
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var indicator = /*#__PURE__*/ $J42oT.createElement((0, $Usx0b.default), (0, $fXPf9.default)({
        className: classes.indicator,
        orientation: orientation,
        color: indicatorColor
    }, TabIndicatorProps, {
        style: (0, $fXPf9.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    var childIndex = 0;
    var children = $J42oT.Children.map(childrenProp, function(child) {
        if (!/*#__PURE__*/ $J42oT.isValidElement(child)) return null;
        if ((0, $5vJdk.isFragment)(child)) console.error([
            "Material-UI: The Tabs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        var childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        var selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $J42oT.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        });
    });
    var handleKeyDown = function handleKeyDown(event) {
        var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        var role = target.getAttribute('role');
        if (role !== 'tab') return;
        var newFocusTarget = null;
        var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
        var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';
        if (orientation !== "vertical" && theme.direction === 'rtl') {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
                break;
            case nextItemKey:
                newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
                break;
            case 'Home':
                newFocusTarget = tabListRef.current.firstChild;
                break;
            case 'End':
                newFocusTarget = tabListRef.current.lastChild;
                break;
            default:
                break;
        }
        if (newFocusTarget !== null) {
            newFocusTarget.focus();
            event.preventDefault();
        }
    };
    var conditionalElements = getConditionalElements();
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, vertical && classes.vertical),
        ref: ref
    }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/ $J42oT.createElement("div", {
        className: (0, $lKxJt.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
        style: scrollerStyle,
        ref: tabsRef,
        onScroll: handleTabsScroll
    }, /*#__PURE__*/ $J42oT.createElement("div", {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        className: (0, $lKxJt.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist"
    }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
$4fb802ab09c4a01f$var$Tabs.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */ action: (0, $bYG1J.default),
    /**
   * The label for the Tabs as a string.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * An id or list of ids separated by a space that label the Tabs.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */ centered: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Determines the color of the indicator.
   */ indicatorColor: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]),
    /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child (number)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * The tabs orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The component used to render the scroll buttons.
   */ ScrollButtonComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).elementType,
    /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `desktop` will only present them on medium and larger viewports.
   * - `on` will always present them.
   * - `off` will never present them.
   */ scrollButtons: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'auto',
        'desktop',
        'off',
        'on'
    ]),
    /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */ selectionFollowsFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * Props applied to the tab indicator element.
   */ TabIndicatorProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
   */ TabScrollButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * Determines the color of the `Tab`.
   */ textColor: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'fullWidth',
        'scrollable',
        'standard'
    ])
};
var $4fb802ab09c4a01f$export$2e2bcd8739ae039 = (0, $cV5xs.default)($4fb802ab09c4a01f$export$9dd6ff9ea0189349, {
    name: 'MuiTabs'
})($4fb802ab09c4a01f$var$Tabs);

});
parcelRegister("ktIK4", function(module, exports) {

$parcel$export(module.exports, "detectScrollType", () => $ee8938e61f9015f5$export$a10970ffb6510128);
$parcel$export(module.exports, "getNormalizedScrollLeft", () => $ee8938e61f9015f5$export$3c615b88e5d7e4f6);
// Source from https://github.com/alitaheri/normalize-scroll-left
var $ee8938e61f9015f5$var$cachedType;
function $ee8938e61f9015f5$export$a10970ffb6510128() {
    if ($ee8938e61f9015f5$var$cachedType) return $ee8938e61f9015f5$var$cachedType;
    var dummy = document.createElement('div');
    var container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $ee8938e61f9015f5$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $ee8938e61f9015f5$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $ee8938e61f9015f5$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $ee8938e61f9015f5$var$cachedType;
} // Based on https://stackoverflow.com/a/24394376
function $ee8938e61f9015f5$export$3c615b88e5d7e4f6(element, direction) {
    var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') return scrollLeft;
    var type = $ee8938e61f9015f5$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

});

parcelRegister("liifv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8096f53e770f411$export$2e2bcd8739ae039);
function $f8096f53e770f411$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f8096f53e770f411$export$2e2bcd8739ae039(property, element, to) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {};
    var _options$ease = options.ease, ease = _options$ease === void 0 ? $f8096f53e770f411$var$easeInOutSin : _options$ease, _options$duration = options.duration, duration = _options$duration === void 0 ? 300 : _options$duration;
    var start = null;
    var from = element[property];
    var cancelled = false;
    var cancel = function cancel() {
        cancelled = true;
    };
    var step = function step(timestamp) {
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        var time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(function() {
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("8wkaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6340f4af327c300c$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $cVQrg = parcelRequire("cVQrg");
var $6340f4af327c300c$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $6340f4af327c300c$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, other = (0, $cVOSt.default)(props, [
        "onChange"
    ]);
    var scrollbarHeight = $J42oT.useRef();
    var nodeRef = $J42oT.useRef(null);
    var setMeasurements = function setMeasurements() {
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    $J42oT.useEffect(function() {
        var handleResize = (0, $cVQrg.default)(function() {
            var prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $J42oT.useEffect(function() {
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $J42oT.createElement("div", (0, $fXPf9.default)({
        style: $6340f4af327c300c$var$styles,
        ref: nodeRef
    }, other));
}
$6340f4af327c300c$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func.isRequired
};

});

parcelRegister("Usx0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9b5ccbfc270665$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $7OrFE = parcelRequire("7OrFE");
var $0a9b5ccbfc270665$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: 'absolute',
            height: 2,
            bottom: 0,
            width: '100%',
            transition: theme.transitions.create()
        },
        colorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        colorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        vertical: {
            height: '100%',
            width: 2,
            right: 0
        }
    };
};
/**
 * @ignore - internal component.
 */ var $0a9b5ccbfc270665$var$TabIndicator = /*#__PURE__*/ $J42oT.forwardRef(function TabIndicator(props, ref) {
    var classes = props.classes, className = props.className, color = props.color, orientation = props.orientation, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "color",
        "orientation"
    ]);
    return /*#__PURE__*/ $J42oT.createElement("span", (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes["color".concat((0, $7OrFE.default)(color))], className, orientation === 'vertical' && classes.vertical),
        ref: ref
    }, other));
});
$0a9b5ccbfc270665$var$TabIndicator.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * @ignore
   * The color of the tab indicator.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'primary',
        'secondary'
    ]).isRequired,
    /**
   * The tabs orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'horizontal',
        'vertical'
    ]).isRequired
};
var $0a9b5ccbfc270665$export$2e2bcd8739ae039 = (0, $cV5xs.default)($0a9b5ccbfc270665$export$9dd6ff9ea0189349, {
    name: 'PrivateTabIndicator'
})($0a9b5ccbfc270665$var$TabIndicator);

});

parcelRegister("gnTfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bed9a642929f2fd6$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $6Bqli = parcelRequire("6Bqli");

var $iPoMQ = parcelRequire("iPoMQ");

var $cV5xs = parcelRequire("cV5xs");

var $igPVj = parcelRequire("igPVj");
var $bed9a642929f2fd6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        '&$disabled': {
            opacity: 0
        }
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
        width: '100%',
        height: 40,
        '& svg': {
            transform: 'rotate(90deg)'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {}
};
var $bed9a642929f2fd6$var$_ref = /*#__PURE__*/ $J42oT.createElement((0, $6Bqli.default), {
    fontSize: "small"
});
var $bed9a642929f2fd6$var$_ref2 = /*#__PURE__*/ $J42oT.createElement((0, $iPoMQ.default), {
    fontSize: "small"
});
var $bed9a642929f2fd6$var$TabScrollButton = /*#__PURE__*/ $J42oT.forwardRef(function TabScrollButton(props, ref) {
    var classes = props.classes, classNameProp = props.className, direction = props.direction, orientation = props.orientation, disabled = props.disabled, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "direction",
        "orientation",
        "disabled"
    ]);
    return /*#__PURE__*/ $J42oT.createElement((0, $igPVj.default), (0, $fXPf9.default)({
        component: "div",
        className: (0, $lKxJt.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
        ref: ref,
        role: null,
        tabIndex: null
    }, other), direction === 'left' ? $bed9a642929f2fd6$var$_ref : $bed9a642929f2fd6$var$_ref2);
});
$bed9a642929f2fd6$var$TabScrollButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * Which direction should the button indicate?
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'left',
        'right'
    ]).isRequired,
    /**
   * If `true`, the element will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The tabs orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'horizontal',
        'vertical'
    ]).isRequired
};
var $bed9a642929f2fd6$export$2e2bcd8739ae039 = (0, $cV5xs.default)($bed9a642929f2fd6$export$9dd6ff9ea0189349, {
    name: 'MuiTabScrollButton'
})($bed9a642929f2fd6$var$TabScrollButton);

});
parcelRegister("6Bqli", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ceaa1d76e35f60d$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $4ceaa1d76e35f60d$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("iPoMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db50378fd89b889e$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fUra3 = parcelRequire("fUra3");
var /**
 * @ignore - internal component.
 */ $db50378fd89b889e$export$2e2bcd8739ae039 = (0, $fUra3.default)(/*#__PURE__*/ $J42oT.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});




parcelRegister("2jXxB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("ic8Hs")).default);

var $ic8Hs = parcelRequire("ic8Hs");

});
parcelRegister("ic8Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3f018a1f6e02480$export$2e2bcd8739ae039);

var $cVOSt = parcelRequire("cVOSt");

var $6JmtS = parcelRequire("6JmtS");

var $fXPf9 = parcelRequire("fXPf9");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");

var $igPVj = parcelRequire("igPVj");

var $7OrFE = parcelRequire("7OrFE");

var $8jVXc = parcelRequire("8jVXc");
var $d3f018a1f6e02480$export$9dd6ff9ea0189349 = function styles(theme) {
    var _extends2;
    return {
        /* Styles applied to the root element. */ root: (0, $fXPf9.default)({}, theme.typography.button, (_extends2 = {
            maxWidth: 264,
            minWidth: 72,
            position: 'relative',
            boxSizing: 'border-box',
            minHeight: 48,
            flexShrink: 0,
            padding: '6px 12px'
        }, (0, $6JmtS.default)(_extends2, theme.breakpoints.up('sm'), {
            padding: '6px 24px'
        }), (0, $6JmtS.default)(_extends2, "overflow", 'hidden'), (0, $6JmtS.default)(_extends2, "whiteSpace", 'normal'), (0, $6JmtS.default)(_extends2, "textAlign", 'center'), (0, $6JmtS.default)(_extends2, theme.breakpoints.up('sm'), {
            minWidth: 160
        }), _extends2)),
        /* Styles applied to the root element if both `icon` and `label` are provided. */ labelIcon: {
            minHeight: 72,
            paddingTop: 9,
            '& $wrapper > *:first-child': {
                marginBottom: 6
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */ textColorInherit: {
            color: 'inherit',
            opacity: 0.7,
            '&$selected': {
                opacity: 1
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */ textColorPrimary: {
            color: theme.palette.text.secondary,
            '&$selected': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */ textColorSecondary: {
            color: theme.palette.text.secondary,
            '&$selected': {
                color: theme.palette.secondary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */ selected: {},
        /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */ fullWidth: {
            flexShrink: 1,
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: 'none'
        },
        /* Styles applied to the root element if `wrapped={true}`. */ wrapped: {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.5
        },
        /* Styles applied to the `icon` and `label`'s wrapper element. */ wrapper: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            flexDirection: 'column'
        }
    };
};
var $d3f018a1f6e02480$var$Tab = /*#__PURE__*/ $J42oT.forwardRef(function Tab(props, ref) {
    var classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, fullWidth = props.fullWidth, icon = props.icon, indicator = props.indicator, label = props.label, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, selected = props.selected, selectionFollowsFocus = props.selectionFollowsFocus, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor, value = props.value, _props$wrapped = props.wrapped, wrapped = _props$wrapped === void 0 ? false : _props$wrapped, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "icon",
        "indicator",
        "label",
        "onChange",
        "onClick",
        "onFocus",
        "selected",
        "selectionFollowsFocus",
        "textColor",
        "value",
        "wrapped"
    ]);
    var handleClick = function handleClick(event) {
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    var handleFocus = function handleFocus(event) {
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $J42oT.createElement((0, $igPVj.default), (0, $fXPf9.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $lKxJt.default)(classes.root, classes["textColor".concat((0, $7OrFE.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        tabIndex: selected ? 0 : -1
    }, other), /*#__PURE__*/ $J42oT.createElement("span", {
        className: classes.wrapper
    }, icon, label), indicator);
});
$d3f018a1f6e02480$var$Tab.propTypes = {
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $8jVXc.default),
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * If `true`, the tab will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The icon element.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */ indicator: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * The label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * @ignore
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ selectionFollowsFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ textColor: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'secondary',
        'primary',
        'inherit'
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   */ wrapped: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool
};
var $d3f018a1f6e02480$export$2e2bcd8739ae039 = (0, $cV5xs.default)($d3f018a1f6e02480$export$9dd6ff9ea0189349, {
    name: 'MuiTab'
})($d3f018a1f6e02480$var$Tab);

});


parcelRegister("jhR24", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cqRKQ")).default);

var $cqRKQ = parcelRequire("cqRKQ");

});

parcelRegister("ld36h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iEdjU")).default);
$parcel$export(module.exports, "styleFunction", () => (parcelRequire("iEdjU")).styleFunction);

var $iEdjU = parcelRequire("iEdjU");

});
parcelRegister("iEdjU", function(module, exports) {

$parcel$export(module.exports, "styleFunction", () => $d9364b832ae59eb8$export$8b4cd039ebcc4f7b);
$parcel$export(module.exports, "default", () => $d9364b832ae59eb8$export$2e2bcd8739ae039);

var $loiZB = parcelRequire("loiZB");
var $baxHj = parcelRequire("baxHj");
var $jDOe0 = parcelRequire("jDOe0");
var $4WcDw = parcelRequire("4WcDw");
var $kYtKq = parcelRequire("kYtKq");
var $aMfQU = parcelRequire("aMfQU");
var $4xqop = parcelRequire("4xqop");
var $g6w4o = parcelRequire("g6w4o");
var $b8w2I = parcelRequire("b8w2I");
var $gbfsn = parcelRequire("gbfsn");
var $176u4 = parcelRequire("176u4");
var $4T5cp = parcelRequire("4T5cp");

var $6HCf6 = parcelRequire("6HCf6");
var $d9364b832ae59eb8$export$8b4cd039ebcc4f7b = (0, $176u4.default)((0, $baxHj.default)((0, $loiZB.default), (0, $jDOe0.default), (0, $4WcDw.default), (0, $kYtKq.default), (0, $4xqop.default), (0, $aMfQU.default), (0, $g6w4o.default), (0, $b8w2I.default), (0, $gbfsn.default), (0, $4T5cp.default)));
/**
 * @ignore - do not document.
 */ var $d9364b832ae59eb8$var$Box = (0, $6HCf6.default)('div')($d9364b832ae59eb8$export$8b4cd039ebcc4f7b, {
    name: 'MuiBox'
});
var $d9364b832ae59eb8$export$2e2bcd8739ae039 = $d9364b832ae59eb8$var$Box;

});
parcelRegister("loiZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92a926519a76b1b$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
function $f92a926519a76b1b$var$getBorder(value) {
    if (typeof value !== 'number') return value;
    return "".concat(value, "px solid");
}
var $f92a926519a76b1b$export$1edee58a52776cd9 = (0, $d5U7P.default)({
    prop: 'border',
    themeKey: 'borders',
    transform: $f92a926519a76b1b$var$getBorder
});
var $f92a926519a76b1b$export$f9a7b6bd24892946 = (0, $d5U7P.default)({
    prop: 'borderTop',
    themeKey: 'borders',
    transform: $f92a926519a76b1b$var$getBorder
});
var $f92a926519a76b1b$export$5abca33e6be905d2 = (0, $d5U7P.default)({
    prop: 'borderRight',
    themeKey: 'borders',
    transform: $f92a926519a76b1b$var$getBorder
});
var $f92a926519a76b1b$export$e2ce9f12a980a822 = (0, $d5U7P.default)({
    prop: 'borderBottom',
    themeKey: 'borders',
    transform: $f92a926519a76b1b$var$getBorder
});
var $f92a926519a76b1b$export$47658cca1a909427 = (0, $d5U7P.default)({
    prop: 'borderLeft',
    themeKey: 'borders',
    transform: $f92a926519a76b1b$var$getBorder
});
var $f92a926519a76b1b$export$e7fb0694ba2404fc = (0, $d5U7P.default)({
    prop: 'borderColor',
    themeKey: 'palette'
});
var $f92a926519a76b1b$export$7a57f79000377ca2 = (0, $d5U7P.default)({
    prop: 'borderRadius',
    themeKey: 'shape'
});
var $f92a926519a76b1b$var$borders = (0, $baxHj.default)($f92a926519a76b1b$export$1edee58a52776cd9, $f92a926519a76b1b$export$f9a7b6bd24892946, $f92a926519a76b1b$export$5abca33e6be905d2, $f92a926519a76b1b$export$e2ce9f12a980a822, $f92a926519a76b1b$export$47658cca1a909427, $f92a926519a76b1b$export$e7fb0694ba2404fc, $f92a926519a76b1b$export$7a57f79000377ca2);
var $f92a926519a76b1b$export$2e2bcd8739ae039 = $f92a926519a76b1b$var$borders;

});
parcelRegister("d5U7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $9887475057e61af9$export$2e2bcd8739ae039);

var $6JmtS = parcelRequire("6JmtS");

var $6I38e = parcelRequire("6I38e");

var $esfZy = parcelRequire("esfZy");
function $9887475057e61af9$var$getPath(obj, path) {
    if (!path || typeof path !== 'string') return null;
    return path.split('.').reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $9887475057e61af9$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $9887475057e61af9$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $9887475057e61af9$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $6JmtS.default)({}, cssProperty, value);
        };
        return (0, $esfZy.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = (0, $6JmtS.default)({}, prop, (0, $6I38e.default));
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9887475057e61af9$export$2e2bcd8739ae039 = $9887475057e61af9$var$style;

});

parcelRegister("baxHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $821ac4807bb800d5$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $1vXAh = parcelRequire("1vXAh");
function $821ac4807bb800d5$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $1vXAh.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = styles.reduce(function(acc, style) {
        return (0, $fXPf9.default)(acc, style.propTypes);
    }, {});
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $821ac4807bb800d5$export$2e2bcd8739ae039 = $821ac4807bb800d5$var$compose;

});


parcelRegister("jDOe0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c89e735eec557c$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $e4c89e735eec557c$export$95a5c40fb210fe3e = (0, $d5U7P.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: function transform(value) {
        return {
            '@media print': {
                display: value
            }
        };
    }
});
var $e4c89e735eec557c$export$e5efd59aba9975ad = (0, $d5U7P.default)({
    prop: 'display'
});
var $e4c89e735eec557c$export$f6530fb6e67e00bd = (0, $d5U7P.default)({
    prop: 'overflow'
});
var $e4c89e735eec557c$export$f00f69a6f0e8c5b6 = (0, $d5U7P.default)({
    prop: 'textOverflow'
});
var $e4c89e735eec557c$export$91fa9ac3f4021ce4 = (0, $d5U7P.default)({
    prop: 'visibility'
});
var $e4c89e735eec557c$export$9ef81298ca34ad41 = (0, $d5U7P.default)({
    prop: 'whiteSpace'
});
var $e4c89e735eec557c$export$2e2bcd8739ae039 = (0, $baxHj.default)($e4c89e735eec557c$export$95a5c40fb210fe3e, $e4c89e735eec557c$export$e5efd59aba9975ad, $e4c89e735eec557c$export$f6530fb6e67e00bd, $e4c89e735eec557c$export$f00f69a6f0e8c5b6, $e4c89e735eec557c$export$91fa9ac3f4021ce4, $e4c89e735eec557c$export$9ef81298ca34ad41);

});

parcelRegister("4WcDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $398661840d0dbdfb$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $398661840d0dbdfb$export$d2ad290394bbc49d = (0, $d5U7P.default)({
    prop: 'flexBasis'
});
var $398661840d0dbdfb$export$84c3c16c9ed6c908 = (0, $d5U7P.default)({
    prop: 'flexDirection'
});
var $398661840d0dbdfb$export$9a4bcd01f5c204bc = (0, $d5U7P.default)({
    prop: 'flexWrap'
});
var $398661840d0dbdfb$export$8dea3061ba53bfd1 = (0, $d5U7P.default)({
    prop: 'justifyContent'
});
var $398661840d0dbdfb$export$898d9006406726bd = (0, $d5U7P.default)({
    prop: 'alignItems'
});
var $398661840d0dbdfb$export$38c32c6918694134 = (0, $d5U7P.default)({
    prop: 'alignContent'
});
var $398661840d0dbdfb$export$aaaeab0fac9a3ccb = (0, $d5U7P.default)({
    prop: 'order'
});
var $398661840d0dbdfb$export$97691fbb80847c19 = (0, $d5U7P.default)({
    prop: 'flex'
});
var $398661840d0dbdfb$export$36c65c169152373d = (0, $d5U7P.default)({
    prop: 'flexGrow'
});
var $398661840d0dbdfb$export$2670ac60b02109d2 = (0, $d5U7P.default)({
    prop: 'flexShrink'
});
var $398661840d0dbdfb$export$4545dd3632cb520b = (0, $d5U7P.default)({
    prop: 'alignSelf'
});
var $398661840d0dbdfb$export$55e6b7a7f0eaa3ff = (0, $d5U7P.default)({
    prop: 'justifyItems'
});
var $398661840d0dbdfb$export$d012640ac9a6446f = (0, $d5U7P.default)({
    prop: 'justifySelf'
});
var $398661840d0dbdfb$var$flexbox = (0, $baxHj.default)($398661840d0dbdfb$export$d2ad290394bbc49d, $398661840d0dbdfb$export$84c3c16c9ed6c908, $398661840d0dbdfb$export$9a4bcd01f5c204bc, $398661840d0dbdfb$export$8dea3061ba53bfd1, $398661840d0dbdfb$export$898d9006406726bd, $398661840d0dbdfb$export$38c32c6918694134, $398661840d0dbdfb$export$aaaeab0fac9a3ccb, $398661840d0dbdfb$export$97691fbb80847c19, $398661840d0dbdfb$export$36c65c169152373d, $398661840d0dbdfb$export$2670ac60b02109d2, $398661840d0dbdfb$export$4545dd3632cb520b, $398661840d0dbdfb$export$55e6b7a7f0eaa3ff, $398661840d0dbdfb$export$d012640ac9a6446f);
var $398661840d0dbdfb$export$2e2bcd8739ae039 = $398661840d0dbdfb$var$flexbox;

});

parcelRegister("kYtKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4507c83ed2e9437$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $f4507c83ed2e9437$export$62ffeaf1cd78b2a6 = (0, $d5U7P.default)({
    prop: 'gridGap'
});
var $f4507c83ed2e9437$export$d6171c086ca0de0 = (0, $d5U7P.default)({
    prop: 'gridColumnGap'
});
var $f4507c83ed2e9437$export$8bb113508eaa54d = (0, $d5U7P.default)({
    prop: 'gridRowGap'
});
var $f4507c83ed2e9437$export$baf44164ca3a34e8 = (0, $d5U7P.default)({
    prop: 'gridColumn'
});
var $f4507c83ed2e9437$export$8f7213a1cd01e832 = (0, $d5U7P.default)({
    prop: 'gridRow'
});
var $f4507c83ed2e9437$export$b0e0abbc49ba668 = (0, $d5U7P.default)({
    prop: 'gridAutoFlow'
});
var $f4507c83ed2e9437$export$bcd8b929d4b4142 = (0, $d5U7P.default)({
    prop: 'gridAutoColumns'
});
var $f4507c83ed2e9437$export$e5039a674e14c828 = (0, $d5U7P.default)({
    prop: 'gridAutoRows'
});
var $f4507c83ed2e9437$export$42bd9088661ffb03 = (0, $d5U7P.default)({
    prop: 'gridTemplateColumns'
});
var $f4507c83ed2e9437$export$920682ae05b999bc = (0, $d5U7P.default)({
    prop: 'gridTemplateRows'
});
var $f4507c83ed2e9437$export$1b88fbdd482fd33a = (0, $d5U7P.default)({
    prop: 'gridTemplateAreas'
});
var $f4507c83ed2e9437$export$bdb486e40d52d26f = (0, $d5U7P.default)({
    prop: 'gridArea'
});
var $f4507c83ed2e9437$var$grid = (0, $baxHj.default)($f4507c83ed2e9437$export$62ffeaf1cd78b2a6, $f4507c83ed2e9437$export$d6171c086ca0de0, $f4507c83ed2e9437$export$8bb113508eaa54d, $f4507c83ed2e9437$export$baf44164ca3a34e8, $f4507c83ed2e9437$export$8f7213a1cd01e832, $f4507c83ed2e9437$export$b0e0abbc49ba668, $f4507c83ed2e9437$export$bcd8b929d4b4142, $f4507c83ed2e9437$export$e5039a674e14c828, $f4507c83ed2e9437$export$42bd9088661ffb03, $f4507c83ed2e9437$export$920682ae05b999bc, $f4507c83ed2e9437$export$1b88fbdd482fd33a, $f4507c83ed2e9437$export$bdb486e40d52d26f);
var $f4507c83ed2e9437$export$2e2bcd8739ae039 = $f4507c83ed2e9437$var$grid;

});

parcelRegister("aMfQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d8aaf07739171da$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $7d8aaf07739171da$export$35e9368ef982300f = (0, $d5U7P.default)({
    prop: 'color',
    themeKey: 'palette'
});
var $7d8aaf07739171da$export$2506f56c10355b33 = (0, $d5U7P.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette'
});
var $7d8aaf07739171da$var$palette = (0, $baxHj.default)($7d8aaf07739171da$export$35e9368ef982300f, $7d8aaf07739171da$export$2506f56c10355b33);
var $7d8aaf07739171da$export$2e2bcd8739ae039 = $7d8aaf07739171da$var$palette;

});

parcelRegister("4xqop", function(module, exports) {

$parcel$export(module.exports, "default", () => $34deb78525a31ec3$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $34deb78525a31ec3$export$5880b8b5730aff45 = (0, $d5U7P.default)({
    prop: 'position'
});
var $34deb78525a31ec3$export$56446adcecbeec34 = (0, $d5U7P.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
var $34deb78525a31ec3$export$1e95b668f3b82d = (0, $d5U7P.default)({
    prop: 'top'
});
var $34deb78525a31ec3$export$79ffe56a765070d2 = (0, $d5U7P.default)({
    prop: 'right'
});
var $34deb78525a31ec3$export$40e543e69a8b3fbb = (0, $d5U7P.default)({
    prop: 'bottom'
});
var $34deb78525a31ec3$export$eabcd2c8791e7bf4 = (0, $d5U7P.default)({
    prop: 'left'
});
var $34deb78525a31ec3$export$2e2bcd8739ae039 = (0, $baxHj.default)($34deb78525a31ec3$export$5880b8b5730aff45, $34deb78525a31ec3$export$56446adcecbeec34, $34deb78525a31ec3$export$1e95b668f3b82d, $34deb78525a31ec3$export$79ffe56a765070d2, $34deb78525a31ec3$export$40e543e69a8b3fbb, $34deb78525a31ec3$export$eabcd2c8791e7bf4);

});

parcelRegister("g6w4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb961547327747a4$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");
var $bb961547327747a4$var$boxShadow = (0, $d5U7P.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $bb961547327747a4$export$2e2bcd8739ae039 = $bb961547327747a4$var$boxShadow;

});

parcelRegister("b8w2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b94c138ca77dfa$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
function $81b94c138ca77dfa$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $81b94c138ca77dfa$export$7e3df82ee760448c = (0, $d5U7P.default)({
    prop: 'width',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$488fda99655ff65a = (0, $d5U7P.default)({
    prop: 'maxWidth',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$ee148fbbe8357dd2 = (0, $d5U7P.default)({
    prop: 'minWidth',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$ac607276a8fe9f0a = (0, $d5U7P.default)({
    prop: 'height',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$dc0d8bd0b94f8570 = (0, $d5U7P.default)({
    prop: 'maxHeight',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$a43cf604e12f3b17 = (0, $d5U7P.default)({
    prop: 'minHeight',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$ffed9f14fb65e276 = (0, $d5U7P.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$905076ed6620e671 = (0, $d5U7P.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $81b94c138ca77dfa$var$transform
});
var $81b94c138ca77dfa$export$6ccc93f785106a58 = (0, $d5U7P.default)({
    prop: 'boxSizing'
});
var $81b94c138ca77dfa$var$sizing = (0, $baxHj.default)($81b94c138ca77dfa$export$7e3df82ee760448c, $81b94c138ca77dfa$export$488fda99655ff65a, $81b94c138ca77dfa$export$ee148fbbe8357dd2, $81b94c138ca77dfa$export$ac607276a8fe9f0a, $81b94c138ca77dfa$export$dc0d8bd0b94f8570, $81b94c138ca77dfa$export$a43cf604e12f3b17, $81b94c138ca77dfa$export$6ccc93f785106a58);
var $81b94c138ca77dfa$export$2e2bcd8739ae039 = $81b94c138ca77dfa$var$sizing;

});

parcelRegister("176u4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfb797bcb506264$export$2e2bcd8739ae039);

var $6kfYZ = parcelRequire("6kfYZ");

var $fXPf9 = parcelRequire("fXPf9");

var $fcOLE = parcelRequire("fcOLE");

var $81kKd = parcelRequire("81kKd");

var $1vXAh = parcelRequire("1vXAh");
function $0cfb797bcb506264$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $0cfb797bcb506264$var$warnedOnce = false;
function $0cfb797bcb506264$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $fXPf9.default)({}, (0, $1vXAh.default)(output, styleFunction((0, $fXPf9.default)({
            theme: props.theme
        }, props.css))), $0cfb797bcb506264$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $fXPf9.default)({}, (0, $1vXAh.default)(output, styleFunction((0, $fXPf9.default)({
            theme: props.theme
        }, props.sx))), $0cfb797bcb506264$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = (0, $fXPf9.default)({}, styleFunction.propTypes, {
        css: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object, function(props) {
            if (!$0cfb797bcb506264$var$warnedOnce && props.css !== undefined) {
                $0cfb797bcb506264$var$warnedOnce = true;
                return new Error('Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.');
            }
            return null;
        }),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object
    });
    newStyleFunction.filterProps = [
        'css',
        'sx'
    ].concat((0, $6kfYZ.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $0cfb797bcb506264$export$dbf350e5966cf602(styleFunction) {
    console.warn('Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead.');
    return $0cfb797bcb506264$var$styleFunctionSx(styleFunction);
}
var $0cfb797bcb506264$export$2e2bcd8739ae039 = $0cfb797bcb506264$var$styleFunctionSx;

});

parcelRegister("4T5cp", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f054eaaf63f6c4$export$2e2bcd8739ae039);

var $d5U7P = parcelRequire("d5U7P");

var $baxHj = parcelRequire("baxHj");
var $38f054eaaf63f6c4$export$a5975749f0374264 = (0, $d5U7P.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
var $38f054eaaf63f6c4$export$85e3c3ca0c6fb93 = (0, $d5U7P.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
var $38f054eaaf63f6c4$export$a827189a08c5a3a3 = (0, $d5U7P.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
var $38f054eaaf63f6c4$export$bc0b29e67df3229e = (0, $d5U7P.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
var $38f054eaaf63f6c4$export$3eb52878e4502ad1 = (0, $d5U7P.default)({
    prop: 'letterSpacing'
});
var $38f054eaaf63f6c4$export$c9b91427b594e14 = (0, $d5U7P.default)({
    prop: 'lineHeight'
});
var $38f054eaaf63f6c4$export$a87999391cd10ae9 = (0, $d5U7P.default)({
    prop: 'textAlign'
});
var $38f054eaaf63f6c4$var$typography = (0, $baxHj.default)($38f054eaaf63f6c4$export$a5975749f0374264, $38f054eaaf63f6c4$export$85e3c3ca0c6fb93, $38f054eaaf63f6c4$export$a827189a08c5a3a3, $38f054eaaf63f6c4$export$bc0b29e67df3229e, $38f054eaaf63f6c4$export$3eb52878e4502ad1, $38f054eaaf63f6c4$export$c9b91427b594e14, $38f054eaaf63f6c4$export$a87999391cd10ae9);
var $38f054eaaf63f6c4$export$2e2bcd8739ae039 = $38f054eaaf63f6c4$var$typography;

});

parcelRegister("6HCf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $014264d864b3c41e$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $2JGiM = parcelRequire("2JGiM");

var $6MwfJ = parcelRequire("6MwfJ");
var $014264d864b3c41e$var$styled = function styled(Component) {
    var componentCreator = (0, $2JGiM.default)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $fXPf9.default)({
            defaultTheme: (0, $6MwfJ.default)
        }, options));
    };
};
var $014264d864b3c41e$export$2e2bcd8739ae039 = $014264d864b3c41e$var$styled;

});
parcelRegister("2JGiM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe0990178994d2e$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $lKxJt = parcelRequire("lKxJt");

var $fcOLE = parcelRequire("fcOLE");

var $81kKd = parcelRequire("81kKd");
var $9u4l7 = parcelRequire("9u4l7");

var $eapUt = parcelRequire("eapUt");

var $R8WKp = parcelRequire("R8WKp");
function $1fe0990178994d2e$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $1fe0990178994d2e$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $cVOSt.default)(options, [
            "name"
        ]);
        if (Component === undefined) throw new Error([
            'You are calling styled(Component)(style) with an undefined component.',
            'You may have forgotten to import it.'
        ].join('\n'));
        var classNamePrefix = name;
        if (!name) {
            // Provide a better DX outside production.
            var displayName = (0, $9u4l7.default)(Component);
            if (displayName !== undefined) classNamePrefix = displayName;
        }
        var stylesOrCreator = typeof style === 'function' ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $fXPf9.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $R8WKp.default)(stylesOrCreator, (0, $fXPf9.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $cVOSt.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $lKxJt.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $1fe0990178994d2e$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).cloneElement(children, (0, $fXPf9.default)({
                className: (0, $lKxJt.default)(children.props.className, className)
            }, spread));
            if (typeof children === 'function') return children((0, $fXPf9.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement(FinalComponent, (0, $fXPf9.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        StyledComponent.propTypes = (0, $fXPf9.default)({
            /**
       * A render function or node.
       */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
                (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
            ]),
            /**
       * @ignore
       */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
            /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */ clone: (0, $81kKd.default)((0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool, function(props) {
                if (props.clone && props.component) return new Error('You can not use the clone and component prop at the same time.');
                return null;
            }),
            /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType
        }, propTypes);
        StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
        (0, (/*@__PURE__*/$parcel$interopDefault($eapUt)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}

});




parcelRegister("3OcDw", function(module, exports) {

$parcel$export(module.exports, "KeyboardDatePicker", () => $2c5fd7ec30d7508c$export$d8c44f501031ee7c);

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");


var $gFzGS = parcelRequire("gFzGS");

var $lKxJt = parcelRequire("lKxJt");
parcelRequire("fXPf9");
parcelRequire("cVOSt");


var $jTsdR = parcelRequire("jTsdR");

var $8LmSw = parcelRequire("8LmSw");




var $j7UbN = parcelRequire("j7UbN");



parcelRequire("4nWei");

parcelRequire("30ito");

var $eu8ma = parcelRequire("eu8ma");
parcelRequire("lfYGa");
parcelRequire("cWCsL");
parcelRequire("42JcH");
parcelRequire("1h73G");
parcelRequire("hIvGi");









var $2c5fd7ec30d7508c$var$useStyles = (0, $jTsdR.default)({
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    toolbarLandscape: {
        padding: 16
    },
    dateLandscape: {
        marginRight: 16
    }
}, {
    name: 'MuiPickersDatePickerRoot'
});
var $2c5fd7ec30d7508c$var$DatePickerToolbar = function DatePickerToolbar(_ref) {
    var date = _ref.date, views = _ref.views, setOpenView = _ref.setOpenView, isLandscape = _ref.isLandscape, openView = _ref.openView;
    var utils = (0, $gFzGS.u)();
    var classes = $2c5fd7ec30d7508c$var$useStyles();
    var isYearOnly = (0, $J42oT.useMemo)(function() {
        return (0, $j7UbN.i)(views);
    }, [
        views
    ]);
    var isYearAndMonth = (0, $J42oT.useMemo)(function() {
        return (0, $j7UbN.b)(views);
    }, [
        views
    ]);
    return (0, $J42oT.createElement)((0, $8LmSw.P), {
        isLandscape: isLandscape,
        className: (0, $lKxJt.default)(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
    }, (0, $J42oT.createElement)((0, $8LmSw.T), {
        variant: isYearOnly ? 'h3' : 'subtitle1',
        onClick: function onClick() {
            return setOpenView('year');
        },
        selected: openView === 'year',
        label: utils.getYearText(date)
    }), !isYearOnly && !isYearAndMonth && (0, $J42oT.createElement)((0, $8LmSw.T), {
        variant: "h4",
        selected: openView === 'date',
        onClick: function onClick() {
            return setOpenView('date');
        },
        align: isLandscape ? 'left' : 'center',
        label: utils.getDatePickerHeaderText(date),
        className: (0, $lKxJt.default)(isLandscape && classes.dateLandscape)
    }), isYearAndMonth && (0, $J42oT.createElement)((0, $8LmSw.T), {
        variant: "h4",
        onClick: function onClick() {
            return setOpenView('month');
        },
        selected: openView === 'month',
        label: utils.getMonthText(date)
    }));
};
function $2c5fd7ec30d7508c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2c5fd7ec30d7508c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2c5fd7ec30d7508c$var$ownKeys(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2c5fd7ec30d7508c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2c5fd7ec30d7508c$var$defaultProps = $2c5fd7ec30d7508c$var$_objectSpread({}, (0, $eu8ma.d), {
    openTo: 'date',
    views: [
        'year',
        'date'
    ]
});
function $2c5fd7ec30d7508c$var$useOptions(props) {
    var utils = (0, $gFzGS.u)();
    return {
        getDefaultFormat: function getDefaultFormat() {
            return (0, $j7UbN.g)(props.views, utils);
        }
    };
}
var $2c5fd7ec30d7508c$export$5109c6dd95d8fb00 = (0, $8LmSw.m)({
    useOptions: $2c5fd7ec30d7508c$var$useOptions,
    Input: (0, $8LmSw.a),
    useState: (0, $8LmSw.u),
    DefaultToolbarComponent: $2c5fd7ec30d7508c$var$DatePickerToolbar
});
var $2c5fd7ec30d7508c$export$d8c44f501031ee7c = (0, $8LmSw.m)({
    useOptions: $2c5fd7ec30d7508c$var$useOptions,
    Input: (0, $8LmSw.K),
    useState: (0, $8LmSw.b),
    DefaultToolbarComponent: $2c5fd7ec30d7508c$var$DatePickerToolbar
});
$2c5fd7ec30d7508c$export$5109c6dd95d8fb00.defaultProps = $2c5fd7ec30d7508c$var$defaultProps;
$2c5fd7ec30d7508c$export$d8c44f501031ee7c.defaultProps = $2c5fd7ec30d7508c$var$defaultProps;

});
parcelRegister("gFzGS", function(module, exports) {

$parcel$export(module.exports, "M", () => $c22c291032dfe357$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "u", () => $c22c291032dfe357$export$3b14a55fb2447963);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");
var $c22c291032dfe357$export$407448d2b89b1813 = (0, $J42oT.createContext)(null);
var $c22c291032dfe357$export$3a1a48c8f6ef640e = function MuiPickersUtilsProvider(_ref) {
    var Utils = _ref.utils, children = _ref.children, locale = _ref.locale, libInstance = _ref.libInstance;
    var utils = (0, $J42oT.useMemo)(function() {
        return new Utils({
            locale: locale,
            instance: libInstance
        });
    }, [
        Utils,
        libInstance,
        locale
    ]);
    return (0, $J42oT.createElement)($c22c291032dfe357$export$407448d2b89b1813.Provider, {
        value: utils,
        children: children
    });
};
$c22c291032dfe357$export$3a1a48c8f6ef640e.propTypes = {
    utils: (0, $fcOLE.func).isRequired,
    locale: (0, $fcOLE.oneOfType)([
        (0, $fcOLE.object),
        (0, $fcOLE.string)
    ]),
    children: (0, $fcOLE.oneOfType)([
        (0, $fcOLE.element).isRequired,
        (0, $fcOLE.arrayOf)((0, $fcOLE.element).isRequired)
    ]).isRequired
};
var $c22c291032dfe357$var$checkUtils = function checkUtils(utils) {
    if (!utils) // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
};
function $c22c291032dfe357$export$3b14a55fb2447963() {
    var utils = (0, $J42oT.useContext)($c22c291032dfe357$export$407448d2b89b1813);
    $c22c291032dfe357$var$checkUtils(utils);
    return utils;
}

});

parcelRegister("8LmSw", function(module, exports) {

$parcel$export(module.exports, "T", () => $661475ab5388fff5$export$971d5caa766a69d7);
$parcel$export(module.exports, "P", () => $661475ab5388fff5$export$56c0d5a1e737357d);
$parcel$export(module.exports, "a", () => $661475ab5388fff5$export$407448d2b89b1813);
$parcel$export(module.exports, "K", () => $661475ab5388fff5$export$3466f893ebf79586);
$parcel$export(module.exports, "u", () => $661475ab5388fff5$export$3b14a55fb2447963);
$parcel$export(module.exports, "b", () => $661475ab5388fff5$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "m", () => $661475ab5388fff5$export$953cecd6e717a553);

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $gFzGS = parcelRequire("gFzGS");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $cqRKQ = parcelRequire("cqRKQ");

var $ewLWY = parcelRequire("ewLWY");
var $idwNS = parcelRequire("idwNS");
var $jTsdR = parcelRequire("jTsdR");
var $cV5xs = parcelRequire("cV5xs");

var $icZBK = parcelRequire("icZBK");

var $lkOoC = parcelRequire("lkOoC");

var $iYjqA = parcelRequire("iYjqA");

var $8q8cf = parcelRequire("8q8cf");

var $io0Xu = parcelRequire("io0Xu");

var $gnNOC = parcelRequire("gnNOC");

var $4nWei = parcelRequire("4nWei");

var $coELO = parcelRequire("coELO");

var $30ito = parcelRequire("30ito");

var $eu8ma = parcelRequire("eu8ma");
var $661475ab5388fff5$var$useStyles = (0, $jTsdR.default)(function(theme) {
    var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
    return {
        toolbarTxt: {
            color: (0, $idwNS.fade)(textColor, 0.54)
        },
        toolbarBtnSelected: {
            color: textColor
        }
    };
}, {
    name: 'MuiPickersToolbarText'
});
var $661475ab5388fff5$export$db3b6bfb95261072 = function ToolbarText(_ref) {
    var selected = _ref.selected, label = _ref.label, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $cVOSt.default)(_ref, [
        "selected",
        "label",
        "className"
    ]);
    var classes = $661475ab5388fff5$var$useStyles();
    return (0, $J42oT.createElement)((0, $cqRKQ.default), (0, $fXPf9.default)({
        children: label,
        className: (0, $lKxJt.default)(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
    }, other));
};
var $661475ab5388fff5$var$ToolbarButton = function ToolbarButton(_ref) {
    var classes = _ref.classes, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, label = _ref.label, selected = _ref.selected, variant = _ref.variant, align = _ref.align, typographyClassName = _ref.typographyClassName, other = (0, $cVOSt.default)(_ref, [
        "classes",
        "className",
        "label",
        "selected",
        "variant",
        "align",
        "typographyClassName"
    ]);
    return (0, $J42oT.createElement)((0, $icZBK.default), (0, $fXPf9.default)({
        variant: "text",
        className: (0, $lKxJt.default)(classes.toolbarBtn, className)
    }, other), (0, $J42oT.createElement)($661475ab5388fff5$export$db3b6bfb95261072, {
        align: align,
        className: typographyClassName,
        variant: variant,
        label: label,
        selected: selected
    }));
};
$661475ab5388fff5$var$ToolbarButton.propTypes = {
    selected: (0, $fcOLE.bool).isRequired,
    label: (0, $fcOLE.string).isRequired,
    classes: (0, $fcOLE.any).isRequired,
    className: (0, $fcOLE.string),
    innerRef: (0, $fcOLE.any)
};
$661475ab5388fff5$var$ToolbarButton.defaultProps = {
    className: ''
};
var $661475ab5388fff5$var$styles = (0, $ewLWY.default)({
    toolbarBtn: {
        padding: 0,
        minWidth: '16px',
        textTransform: 'none'
    }
});
var $661475ab5388fff5$export$971d5caa766a69d7 = (0, $cV5xs.default)($661475ab5388fff5$var$styles, {
    name: 'MuiPickersToolbarButton'
})($661475ab5388fff5$var$ToolbarButton);
var $661475ab5388fff5$var$useStyles$1 = (0, $jTsdR.default)(function(theme) {
    return {
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
        },
        toolbarLandscape: {
            height: 'auto',
            maxWidth: 150,
            padding: 8,
            justifyContent: 'flex-start'
        }
    };
}, {
    name: 'MuiPickersToolbar'
});
var $661475ab5388fff5$export$56c0d5a1e737357d = function PickerToolbar(_ref) {
    var children = _ref.children, isLandscape = _ref.isLandscape, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $cVOSt.default)(_ref, [
        "children",
        "isLandscape",
        "className"
    ]);
    var classes = $661475ab5388fff5$var$useStyles$1();
    return (0, $J42oT.createElement)((0, $lkOoC.default), (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
    }, other), children);
};
function $661475ab5388fff5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $661475ab5388fff5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $661475ab5388fff5$var$ownKeys(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $661475ab5388fff5$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $661475ab5388fff5$export$407448d2b89b1813 = function PureDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, InputProps = _ref.InputProps, onOpen = _ref.openPicker, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $8q8cf.default) : _ref$TextFieldCompone, other = (0, $cVOSt.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "InputProps",
        "openPicker",
        "TextFieldComponent"
    ]);
    var PureDateInputProps = (0, $J42oT.useMemo)(function() {
        return $661475ab5388fff5$var$_objectSpread({}, InputProps, {
            readOnly: true
        });
    }, [
        InputProps
    ]);
    return (0, $J42oT.createElement)(TextFieldComponent, (0, $fXPf9.default)({
        error: Boolean(validationError),
        helperText: validationError
    }, other, {
        // do not overridable
        onClick: onOpen,
        value: inputValue,
        variant: inputVariant,
        InputProps: PureDateInputProps,
        onKeyDown: function onKeyDown(e) {
            // space
            if (e.keyCode === 32) {
                e.stopPropagation();
                onOpen();
            }
        }
    }));
};
$661475ab5388fff5$export$407448d2b89b1813.displayName = 'PureDateInput';
var $661475ab5388fff5$var$KeyboardIcon = function KeyboardIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $coELO.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }));
};
var $661475ab5388fff5$var$getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
    var invalidLabel = _ref.invalidLabel, emptyLabel = _ref.emptyLabel, labelFunc = _ref.labelFunc;
    var date = utils.date(value);
    if (labelFunc) return labelFunc(isEmpty ? null : date, invalidLabel);
    if (isEmpty) return emptyLabel || '';
    return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var $661475ab5388fff5$var$getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.endOfDay(date);
};
var $661475ab5388fff5$var$getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.startOfDay(date);
};
var $661475ab5388fff5$export$90a7f3efeed30595 = function validate(value, utils, _ref2) {
    var maxDate = _ref2.maxDate, minDate = _ref2.minDate, disablePast = _ref2.disablePast, disableFuture = _ref2.disableFuture, maxDateMessage = _ref2.maxDateMessage, minDateMessage = _ref2.minDateMessage, invalidDateMessage = _ref2.invalidDateMessage, strictCompareDates = _ref2.strictCompareDates;
    var parsedValue = utils.date(value); // if null - do not show error
    if (value === null) return '';
    if (!utils.isValid(value)) return invalidDateMessage;
    if (maxDate && utils.isAfter(parsedValue, $661475ab5388fff5$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) return maxDateMessage;
    if (disableFuture && utils.isAfter(parsedValue, $661475ab5388fff5$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) return maxDateMessage;
    if (minDate && utils.isBefore(parsedValue, $661475ab5388fff5$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) return minDateMessage;
    if (disablePast && utils.isBefore(parsedValue, $661475ab5388fff5$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) return minDateMessage;
    return '';
};
function $661475ab5388fff5$export$ffb5f4729a158638(userFormat) {
    var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var formats = arguments.length > 2 ? arguments[2] : undefined;
    if (userFormat) return userFormat;
    return ampm ? formats['12h'] : formats['24h'];
}
function $661475ab5388fff5$var$makeMaskFromFormat(format, numberMaskChar) {
    return format.replace(/[a-z]/gi, numberMaskChar);
}
var $661475ab5388fff5$var$maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
    return function(value) {
        var result = '';
        var parsed = value.replace(refuse, '');
        if (parsed === '') return parsed;
        var i = 0;
        var n = 0;
        while(i < mask.length){
            var maskChar = mask[i];
            if (maskChar === numberMaskChar && n < parsed.length) {
                var parsedChar = parsed[n];
                result += parsedChar;
                n += 1;
            } else result += maskChar;
            i += 1;
        }
        return result;
    };
};
function $661475ab5388fff5$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $661475ab5388fff5$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $661475ab5388fff5$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $661475ab5388fff5$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $661475ab5388fff5$export$3466f893ebf79586 = function KeyboardDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, KeyboardButtonProps = _ref.KeyboardButtonProps, InputAdornmentProps = _ref.InputAdornmentProps, onOpen = _ref.openPicker, onChange = _ref.onChange, InputProps = _ref.InputProps, mask = _ref.mask, _ref$maskChar = _ref.maskChar, maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar, _ref$refuse = _ref.refuse, refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse, format = _ref.format, keyboardIcon = _ref.keyboardIcon, disabled = _ref.disabled, rifmFormatter = _ref.rifmFormatter, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $8q8cf.default) : _ref$TextFieldCompone, other = (0, $cVOSt.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "KeyboardButtonProps",
        "InputAdornmentProps",
        "openPicker",
        "onChange",
        "InputProps",
        "mask",
        "maskChar",
        "refuse",
        "format",
        "keyboardIcon",
        "disabled",
        "rifmFormatter",
        "TextFieldComponent"
    ]);
    var inputMask = mask || $661475ab5388fff5$var$makeMaskFromFormat(format, maskChar); // prettier-ignore
    var formatter = (0, $J42oT.useMemo)(function() {
        return $661475ab5388fff5$var$maskedDateFormatter(inputMask, maskChar, refuse);
    }, [
        inputMask,
        maskChar,
        refuse
    ]);
    var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
    var handleChange = function handleChange(text) {
        var finalString = text === '' || text === inputMask ? null : text;
        onChange(finalString);
    };
    return (0, $J42oT.createElement)((0, $4nWei.Rifm), {
        key: inputMask,
        value: inputValue,
        onChange: handleChange,
        refuse: refuse,
        format: rifmFormatter || formatter
    }, function(_ref2) {
        var onChange = _ref2.onChange, value = _ref2.value;
        return (0, $J42oT.createElement)(TextFieldComponent, (0, $fXPf9.default)({
            disabled: disabled,
            error: Boolean(validationError),
            helperText: validationError
        }, other, {
            value: value,
            onChange: onChange,
            variant: inputVariant,
            InputProps: $661475ab5388fff5$var$_objectSpread$1({}, InputProps, (0, $6JmtS.default)({}, "".concat(position, "Adornment"), (0, $J42oT.createElement)((0, $gnNOC.default), (0, $fXPf9.default)({
                position: position
            }, InputAdornmentProps), (0, $J42oT.createElement)((0, $io0Xu.default), (0, $fXPf9.default)({
                disabled: disabled
            }, KeyboardButtonProps, {
                onClick: onOpen
            }), keyboardIcon))))
        }));
    });
};
$661475ab5388fff5$export$3466f893ebf79586.defaultProps = {
    keyboardIcon: (0, $J42oT.createElement)($661475ab5388fff5$var$KeyboardIcon, null)
};
function $661475ab5388fff5$var$useOpenState(_ref) {
    var open = _ref.open, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var setIsOpenState = null;
    if (open === undefined || open === null) {
        // The component is uncontrolled, so we need to give it its own state.
        var _useState = (0, $J42oT.useState)(false);
        var _useState2 = (0, $30ito.default)(_useState, 2);
        open = _useState2[0];
        setIsOpenState = _useState2[1];
    } // prettier-ignore
    var setIsOpen = (0, $J42oT.useCallback)(function(newIsOpen) {
        setIsOpenState && setIsOpenState(newIsOpen);
        return newIsOpen ? onOpen && onOpen() : onClose && onClose();
    }, [
        onOpen,
        onClose,
        setIsOpenState
    ]);
    return {
        isOpen: open,
        setIsOpen: setIsOpen
    };
}
var $661475ab5388fff5$var$useValueToDate = function useValueToDate(utils, _ref) {
    var value = _ref.value, initialFocusedDate = _ref.initialFocusedDate;
    var nowRef = (0, $J42oT.useRef)(utils.date());
    var date = utils.date(value || initialFocusedDate || nowRef.current);
    return date && utils.isValid(date) ? date : nowRef.current;
};
function $661475ab5388fff5$var$useDateValues(props, options) {
    var utils = (0, $gFzGS.u)();
    var date = $661475ab5388fff5$var$useValueToDate(utils, props);
    var format = props.format || options.getDefaultFormat();
    return {
        date: date,
        format: format
    };
}
function $661475ab5388fff5$export$3b14a55fb2447963(props, options) {
    var autoOk = props.autoOk, disabled = props.disabled, readOnly = props.readOnly, onAccept = props.onAccept, _onChange = props.onChange, onError = props.onError, value = props.value, variant = props.variant;
    var utils = (0, $gFzGS.u)();
    var _useOpenState = $661475ab5388fff5$var$useOpenState(props), isOpen = _useOpenState.isOpen, setIsOpen = _useOpenState.setIsOpen;
    var _useDateValues = $661475ab5388fff5$var$useDateValues(props, options), date = _useDateValues.date, format = _useDateValues.format;
    var _useState = (0, $J42oT.useState)(date), _useState2 = (0, $30ito.default)(_useState, 2), pickerDate = _useState2[0], setPickerDate = _useState2[1];
    (0, $J42oT.useEffect)(function() {
        // if value was changed in closed state - treat it as accepted
        if (!isOpen && !utils.isEqual(pickerDate, date)) setPickerDate(date);
    }, [
        date,
        isOpen,
        pickerDate,
        utils
    ]);
    var acceptDate = (0, $J42oT.useCallback)(function(acceptedDate) {
        _onChange(acceptedDate);
        if (onAccept) onAccept(acceptedDate);
        setIsOpen(false);
    }, [
        onAccept,
        _onChange,
        setIsOpen
    ]);
    var wrapperProps = (0, $J42oT.useMemo)(function() {
        return {
            format: format,
            open: isOpen,
            onClear: function onClear() {
                return acceptDate(null);
            },
            onAccept: function onAccept() {
                return acceptDate(pickerDate);
            },
            onSetToday: function onSetToday() {
                return setPickerDate(utils.date());
            },
            onDismiss: function onDismiss() {
                setIsOpen(false);
            }
        };
    }, [
        acceptDate,
        format,
        isOpen,
        pickerDate,
        setIsOpen,
        utils
    ]);
    var pickerProps = (0, $J42oT.useMemo)(function() {
        return {
            date: pickerDate,
            onChange: function onChange(newDate) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                setPickerDate(newDate);
                if (isFinish && autoOk) {
                    acceptDate(newDate);
                    return;
                } // simulate autoOk, but do not close the modal
                if (variant === 'inline' || variant === 'static') {
                    _onChange(newDate);
                    onAccept && onAccept(newDate);
                }
            }
        };
    }, [
        acceptDate,
        autoOk,
        onAccept,
        _onChange,
        pickerDate,
        variant
    ]);
    var validationError = $661475ab5388fff5$export$90a7f3efeed30595(value, utils, props);
    (0, $J42oT.useEffect)(function() {
        if (onError) onError(validationError, value);
    }, [
        onError,
        validationError,
        value
    ]);
    var inputValue = $661475ab5388fff5$var$getDisplayDate(date, format, utils, value === null, props);
    var inputProps = (0, $J42oT.useMemo)(function() {
        return {
            inputValue: inputValue,
            validationError: validationError,
            openPicker: function openPicker() {
                return !readOnly && !disabled && setIsOpen(true);
            }
        };
    }, [
        disabled,
        inputValue,
        readOnly,
        setIsOpen,
        validationError
    ]);
    var pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    (0, $J42oT.useDebugValue)(pickerState);
    return pickerState;
}
function $661475ab5388fff5$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $661475ab5388fff5$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $661475ab5388fff5$var$ownKeys$2(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $661475ab5388fff5$var$ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $661475ab5388fff5$var$parseInputString(value, utils, format) {
    try {
        return utils.parse(value, format);
    } catch (_unused) {
        return null;
    }
}
function $661475ab5388fff5$export$8b22cf2602fb60ce(props, options) {
    var _props$format = props.format, format = _props$format === void 0 ? options.getDefaultFormat() : _props$format, inputValue = props.inputValue, _onChange = props.onChange, value = props.value;
    var utils = (0, $gFzGS.u)();
    var displayDate = $661475ab5388fff5$var$getDisplayDate(value, format, utils, value === null, props);
    var _useState = (0, $J42oT.useState)(displayDate), _useState2 = (0, $30ito.default)(_useState, 2), innerInputValue = _useState2[0], setInnerInputValue = _useState2[1];
    var dateValue = inputValue ? $661475ab5388fff5$var$parseInputString(inputValue, utils, format) : value;
    (0, $J42oT.useEffect)(function() {
        if (value === null || utils.isValid(value)) setInnerInputValue(displayDate);
    }, [
        displayDate,
        setInnerInputValue,
        utils,
        value
    ]);
    var handleKeyboardChange = (0, $J42oT.useCallback)(function(date) {
        _onChange(date, date === null ? null : utils.format(date, format));
    }, [
        format,
        _onChange,
        utils
    ]);
    var _usePickerState = $661475ab5388fff5$export$3b14a55fb2447963($661475ab5388fff5$var$_objectSpread$2({}, props, {
        value: dateValue,
        onChange: handleKeyboardChange
    }), options), innerInputProps = _usePickerState.inputProps, wrapperProps = _usePickerState.wrapperProps, pickerProps = _usePickerState.pickerProps;
    var inputProps = (0, $J42oT.useMemo)(function() {
        return $661475ab5388fff5$var$_objectSpread$2({}, innerInputProps, {
            // reuse validation and open/close logic
            format: wrapperProps.format,
            inputValue: inputValue || innerInputValue,
            onChange: function onChange(value) {
                setInnerInputValue(value || '');
                var date = value === null ? null : utils.parse(value, wrapperProps.format);
                _onChange(date, value);
            }
        });
    }, [
        innerInputProps,
        innerInputValue,
        inputValue,
        _onChange,
        utils,
        wrapperProps.format
    ]);
    return {
        inputProps: inputProps,
        wrapperProps: wrapperProps,
        pickerProps: pickerProps
    };
}
function $661475ab5388fff5$export$953cecd6e717a553(_ref) {
    var Input = _ref.Input, useState = _ref.useState, useOptions = _ref.useOptions, getCustomProps = _ref.getCustomProps, DefaultToolbarComponent = _ref.DefaultToolbarComponent;
    function PickerWithState(props) {
        var allowKeyboardControl = props.allowKeyboardControl, ampm = props.ampm, animateYearScrolling = props.animateYearScrolling, autoOk = props.autoOk, dateRangeIcon = props.dateRangeIcon, disableFuture = props.disableFuture, disablePast = props.disablePast, disableToolbar = props.disableToolbar, emptyLabel = props.emptyLabel, format = props.format, forwardedRef = props.forwardedRef, hideTabs = props.hideTabs, initialFocusedDate = props.initialFocusedDate, invalidDateMessage = props.invalidDateMessage, invalidLabel = props.invalidLabel, labelFunc = props.labelFunc, leftArrowButtonProps = props.leftArrowButtonProps, leftArrowIcon = props.leftArrowIcon, loadingIndicator = props.loadingIndicator, maxDate = props.maxDate, maxDateMessage = props.maxDateMessage, minDate = props.minDate, minDateMessage = props.minDateMessage, minutesStep = props.minutesStep, onAccept = props.onAccept, onChange = props.onChange, onClose = props.onClose, onMonthChange = props.onMonthChange, onOpen = props.onOpen, onYearChange = props.onYearChange, openTo = props.openTo, orientation = props.orientation, renderDay = props.renderDay, rightArrowButtonProps = props.rightArrowButtonProps, rightArrowIcon = props.rightArrowIcon, shouldDisableDate = props.shouldDisableDate, strictCompareDates = props.strictCompareDates, timeIcon = props.timeIcon, _props$ToolbarCompone = props.ToolbarComponent, ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone, value = props.value, variant = props.variant, views = props.views, other = (0, $cVOSt.default)(props, [
            "allowKeyboardControl",
            "ampm",
            "animateYearScrolling",
            "autoOk",
            "dateRangeIcon",
            "disableFuture",
            "disablePast",
            "disableToolbar",
            "emptyLabel",
            "format",
            "forwardedRef",
            "hideTabs",
            "initialFocusedDate",
            "invalidDateMessage",
            "invalidLabel",
            "labelFunc",
            "leftArrowButtonProps",
            "leftArrowIcon",
            "loadingIndicator",
            "maxDate",
            "maxDateMessage",
            "minDate",
            "minDateMessage",
            "minutesStep",
            "onAccept",
            "onChange",
            "onClose",
            "onMonthChange",
            "onOpen",
            "onYearChange",
            "openTo",
            "orientation",
            "renderDay",
            "rightArrowButtonProps",
            "rightArrowIcon",
            "shouldDisableDate",
            "strictCompareDates",
            "timeIcon",
            "ToolbarComponent",
            "value",
            "variant",
            "views"
        ]);
        var injectedProps = getCustomProps ? getCustomProps(props) : {};
        var options = useOptions(props);
        var _useState = useState(props, options), pickerProps = _useState.pickerProps, inputProps = _useState.inputProps, wrapperProps = _useState.wrapperProps;
        return (0, $J42oT.createElement)((0, $iYjqA.W), (0, $fXPf9.default)({
            variant: variant,
            InputComponent: Input,
            DateInputProps: inputProps
        }, injectedProps, wrapperProps, other), (0, $J42oT.createElement)((0, $eu8ma.P), (0, $fXPf9.default)({}, pickerProps, {
            allowKeyboardControl: allowKeyboardControl,
            ampm: ampm,
            animateYearScrolling: animateYearScrolling,
            dateRangeIcon: dateRangeIcon,
            disableFuture: disableFuture,
            disablePast: disablePast,
            disableToolbar: disableToolbar,
            hideTabs: hideTabs,
            leftArrowButtonProps: leftArrowButtonProps,
            leftArrowIcon: leftArrowIcon,
            loadingIndicator: loadingIndicator,
            maxDate: maxDate,
            minDate: minDate,
            minutesStep: minutesStep,
            onMonthChange: onMonthChange,
            onYearChange: onYearChange,
            openTo: openTo,
            orientation: orientation,
            renderDay: renderDay,
            rightArrowButtonProps: rightArrowButtonProps,
            rightArrowIcon: rightArrowIcon,
            shouldDisableDate: shouldDisableDate,
            strictCompareDates: strictCompareDates,
            timeIcon: timeIcon,
            ToolbarComponent: ToolbarComponent,
            views: views
        })));
    }
    return PickerWithState;
}

});
parcelRegister("ewLWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9393fc31e9120d7$export$2e2bcd8739ae039);

var $9ZnBE = parcelRequire("9ZnBE");
function $a9393fc31e9120d7$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $9ZnBE.default)(styles);
}

});
parcelRegister("9ZnBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $745c1f48ece994fc$export$2e2bcd8739ae039);
function $745c1f48ece994fc$export$2e2bcd8739ae039(styles) {
    return styles;
}

});


parcelRegister("lkOoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8828ed8c7a3de72$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cV5xs = parcelRequire("cV5xs");
var $f8828ed8c7a3de72$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $6JmtS.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $f8828ed8c7a3de72$var$Toolbar = /*#__PURE__*/ $J42oT.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? 'regular' : _props$variant, other = (0, $cVOSt.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
$f8828ed8c7a3de72$var$Toolbar.propTypes = {
    /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, disables gutter padding.
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'regular',
        'dense'
    ])
};
var $f8828ed8c7a3de72$export$2e2bcd8739ae039 = (0, $cV5xs.default)($f8828ed8c7a3de72$export$9dd6ff9ea0189349, {
    name: 'MuiToolbar'
})($f8828ed8c7a3de72$var$Toolbar);

});

parcelRegister("iYjqA", function(module, exports) {

$parcel$export(module.exports, "a", () => $dcfce68f9839a81b$export$407448d2b89b1813);
$parcel$export(module.exports, "D", () => $dcfce68f9839a81b$export$96f57966bedc81b4);
$parcel$export(module.exports, "c", () => $dcfce68f9839a81b$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $dcfce68f9839a81b$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "u", () => $dcfce68f9839a81b$export$3b14a55fb2447963);
$parcel$export(module.exports, "r", () => $dcfce68f9839a81b$export$43caf9889c228507);
$parcel$export(module.exports, "V", () => $dcfce68f9839a81b$export$e7c866399fa523f5);
$parcel$export(module.exports, "W", () => $dcfce68f9839a81b$export$71cec2538cb2c617);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $ewLWY = parcelRequire("ewLWY");
var $jTsdR = parcelRequire("jTsdR");
var $cV5xs = parcelRequire("cV5xs");

var $icZBK = parcelRequire("icZBK");

var $lwYTP = parcelRequire("lwYTP");

var $6fGoL = parcelRequire("6fGoL");

var $46ylj = parcelRequire("46ylj");

var $fteVY = parcelRequire("fteVY");
/** Use it instead of .includes method for IE support */ function $dcfce68f9839a81b$export$407448d2b89b1813(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every(function(item) {
        return array.indexOf(item) !== -1;
    });
    return array.indexOf(itemOrItems) !== -1;
}
var $dcfce68f9839a81b$export$96f57966bedc81b4 = 310;
var $dcfce68f9839a81b$export$db3b6bfb95261072 = 325;
var $dcfce68f9839a81b$export$8b22cf2602fb60ce = 305;
var $dcfce68f9839a81b$var$useStyles = (0, $jTsdR.default)(function(theme) {
    return {
        staticWrapperRoot: {
            overflow: 'hidden',
            minWidth: $dcfce68f9839a81b$export$96f57966bedc81b4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper
        }
    };
}, {
    name: 'MuiPickersStaticWrapper'
});
var $dcfce68f9839a81b$var$StaticWrapper = function StaticWrapper(_ref) {
    var children = _ref.children;
    var classes = $dcfce68f9839a81b$var$useStyles();
    return (0, $J42oT.createElement)("div", {
        className: classes.staticWrapperRoot,
        children: children
    });
};
var $dcfce68f9839a81b$var$ModalDialog = function ModalDialog(_ref) {
    var children = _ref.children, classes = _ref.classes, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onClear = _ref.onClear, onSetToday = _ref.onSetToday, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, clearable = _ref.clearable, showTodayButton = _ref.showTodayButton, showTabs = _ref.showTabs, wider = _ref.wider, other = (0, $cVOSt.default)(_ref, [
        "children",
        "classes",
        "onAccept",
        "onDismiss",
        "onClear",
        "onSetToday",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "clearable",
        "showTodayButton",
        "showTabs",
        "wider"
    ]);
    return (0, $J42oT.createElement)((0, $46ylj.default), (0, $fXPf9.default)({
        role: "dialog",
        onClose: onDismiss,
        classes: {
            paper: (0, $lKxJt.default)(classes.dialogRoot, wider && classes.dialogRootWider)
        }
    }, other), (0, $J42oT.createElement)((0, $6fGoL.default), {
        children: children,
        className: classes.dialog
    }), (0, $J42oT.createElement)((0, $lwYTP.default), {
        classes: {
            root: (0, $lKxJt.default)((clearable || showTodayButton) && classes.withAdditionalAction)
        }
    }, clearable && (0, $J42oT.createElement)((0, $icZBK.default), {
        color: "primary",
        onClick: onClear
    }, clearLabel), showTodayButton && (0, $J42oT.createElement)((0, $icZBK.default), {
        color: "primary",
        onClick: onSetToday
    }, todayLabel), cancelLabel && (0, $J42oT.createElement)((0, $icZBK.default), {
        color: "primary",
        onClick: onDismiss
    }, cancelLabel), okLabel && (0, $J42oT.createElement)((0, $icZBK.default), {
        color: "primary",
        onClick: onAccept
    }, okLabel)));
};
$dcfce68f9839a81b$var$ModalDialog.displayName = 'ModalDialog';
var $dcfce68f9839a81b$var$styles = (0, $ewLWY.default)({
    dialogRoot: {
        minWidth: $dcfce68f9839a81b$export$96f57966bedc81b4
    },
    dialogRootWider: {
        minWidth: $dcfce68f9839a81b$export$db3b6bfb95261072
    },
    dialog: {
        '&:first-child': {
            padding: 0
        }
    },
    withAdditionalAction: {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    }
});
var $dcfce68f9839a81b$var$ModalDialog$1 = (0, $cV5xs.default)($dcfce68f9839a81b$var$styles, {
    name: 'MuiPickersModal'
})($dcfce68f9839a81b$var$ModalDialog);
var $dcfce68f9839a81b$export$3b14a55fb2447963 = typeof window === 'undefined' ? (0, $J42oT.useEffect) : (0, $J42oT.useLayoutEffect);
function $dcfce68f9839a81b$export$43caf9889c228507(e, keyHandlers) {
    var handler = keyHandlers[e.key];
    if (handler) {
        handler(); // if event was handled prevent other side effects (e.g. page scroll)
        e.preventDefault();
    }
}
function $dcfce68f9839a81b$var$useKeyDown(active, keyHandlers) {
    var keyHandlersRef = (0, $J42oT.useRef)(keyHandlers);
    keyHandlersRef.current = keyHandlers;
    $dcfce68f9839a81b$export$3b14a55fb2447963(function() {
        if (active) {
            var handleKeyDown = function handleKeyDown(event) {
                $dcfce68f9839a81b$export$43caf9889c228507(event, keyHandlersRef.current);
            };
            window.addEventListener('keydown', handleKeyDown);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        active
    ]);
}
var $dcfce68f9839a81b$var$ModalWrapper = function ModalWrapper(_ref) {
    var open = _ref.open, children = _ref.children, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, showTodayButton = _ref.showTodayButton, clearable = _ref.clearable, DialogProps = _ref.DialogProps, showTabs = _ref.showTabs, wider = _ref.wider, InputComponent = _ref.InputComponent, DateInputProps = _ref.DateInputProps, onClear = _ref.onClear, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, other = (0, $cVOSt.default)(_ref, [
        "open",
        "children",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "showTodayButton",
        "clearable",
        "DialogProps",
        "showTabs",
        "wider",
        "InputComponent",
        "DateInputProps",
        "onClear",
        "onAccept",
        "onDismiss",
        "onSetToday"
    ]);
    $dcfce68f9839a81b$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $J42oT.createElement)((0, $J42oT.Fragment), null, (0, $J42oT.createElement)(InputComponent, (0, $fXPf9.default)({}, other, DateInputProps)), (0, $J42oT.createElement)($dcfce68f9839a81b$var$ModalDialog$1, (0, $fXPf9.default)({
        wider: wider,
        showTabs: showTabs,
        open: open,
        onClear: onClear,
        onAccept: onAccept,
        onDismiss: onDismiss,
        onSetToday: onSetToday,
        clearLabel: clearLabel,
        todayLabel: todayLabel,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        clearable: clearable,
        showTodayButton: showTodayButton,
        children: children
    }, DialogProps)));
};
$dcfce68f9839a81b$var$ModalWrapper.propTypes = {
    okLabel: (0, $fcOLE.node),
    cancelLabel: (0, $fcOLE.node),
    clearLabel: (0, $fcOLE.node),
    clearable: (0, $fcOLE.bool),
    todayLabel: (0, $fcOLE.node),
    showTodayButton: (0, $fcOLE.bool),
    DialogProps: (0, $fcOLE.object)
};
$dcfce68f9839a81b$var$ModalWrapper.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false
};
var $dcfce68f9839a81b$var$InlineWrapper = function InlineWrapper(_ref) {
    var open = _ref.open, wider = _ref.wider, children = _ref.children, PopoverProps = _ref.PopoverProps, onClear = _ref.onClear, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, onAccept = _ref.onAccept, showTabs = _ref.showTabs, DateInputProps = _ref.DateInputProps, InputComponent = _ref.InputComponent, other = (0, $cVOSt.default)(_ref, [
        "open",
        "wider",
        "children",
        "PopoverProps",
        "onClear",
        "onDismiss",
        "onSetToday",
        "onAccept",
        "showTabs",
        "DateInputProps",
        "InputComponent"
    ]);
    var ref = (0, $J42oT.useRef)();
    $dcfce68f9839a81b$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $J42oT.createElement)((0, $J42oT.Fragment), null, (0, $J42oT.createElement)(InputComponent, (0, $fXPf9.default)({}, other, DateInputProps, {
        inputRef: ref
    })), (0, $J42oT.createElement)((0, $fteVY.default), (0, $fXPf9.default)({
        open: open,
        onClose: onDismiss,
        anchorEl: ref.current,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: children
    }, PopoverProps)));
};
$dcfce68f9839a81b$var$InlineWrapper.propTypes = {
    onOpen: (0, $fcOLE.func),
    onClose: (0, $fcOLE.func),
    PopoverProps: (0, $fcOLE.object)
};
function $dcfce68f9839a81b$var$getWrapperFromVariant(variant) {
    switch(variant){
        case 'inline':
            return $dcfce68f9839a81b$var$InlineWrapper;
        case 'static':
            return $dcfce68f9839a81b$var$StaticWrapper;
        default:
            return $dcfce68f9839a81b$var$ModalWrapper;
    }
}
var $dcfce68f9839a81b$export$e7c866399fa523f5 = (0, $J42oT.createContext)(null);
var $dcfce68f9839a81b$export$71cec2538cb2c617 = function Wrapper(_ref) {
    var variant = _ref.variant, props = (0, $cVOSt.default)(_ref, [
        "variant"
    ]);
    var Component = $dcfce68f9839a81b$var$getWrapperFromVariant(variant);
    return (0, $J42oT.createElement)($dcfce68f9839a81b$export$e7c866399fa523f5.Provider, {
        value: variant || 'dialog'
    }, (0, $J42oT.createElement)(Component, props));
};

});

parcelRegister("gnNOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bed56f9f91883ba1$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $cqRKQ = parcelRequire("cqRKQ");

var $cV5xs = parcelRequire("cV5xs");

var $6t69i = parcelRequire("6t69i");
var $bed56f9f91883ba1$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        height: '0.01em',
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        '&$positionStart:not($hiddenLabel)': {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: 'none'
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $bed56f9f91883ba1$var$InputAdornment = /*#__PURE__*/ $J42oT.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $cVOSt.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $6t69i.useFormControl)() || {};
    var variant = variantProp;
    if (variantProp && muiFormControl.variant) {
        if (variantProp === muiFormControl.variant) console.error("Material-UI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
    }
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $J42oT.createElement((0, $6t69i.default).Provider, {
        value: null
    }, /*#__PURE__*/ $J42oT.createElement(Component, (0, $fXPf9.default)({
        className: (0, $lKxJt.default)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/ $J42oT.createElement((0, $cqRKQ.default), {
        color: "textSecondary"
    }, children) : children));
});
$bed56f9f91883ba1$var$InputAdornment.propTypes = {
    /**
   * The content of the component, normally an `IconButton` or string.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */ disablePointerEvents: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * If children is a string then disable wrapping in a Typography component.
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).bool,
    /**
   * @ignore
   */ muiFormControl: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).object,
    /**
   * The position this adornment should appear relative to the `Input`.
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'start',
        'end'
    ]).isRequired,
    /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $bed56f9f91883ba1$export$2e2bcd8739ae039 = (0, $cV5xs.default)($bed56f9f91883ba1$export$9dd6ff9ea0189349, {
    name: 'MuiInputAdornment'
})($bed56f9f91883ba1$var$InputAdornment);

});

parcelRegister("4nWei", function(module, exports) {

$parcel$export(module.exports, "Rifm", () => $33167a97e413e13f$export$5519909ee832c7c);

var $1bdSs = parcelRequire("1bdSs");

var $J42oT = parcelRequire("J42oT");
var $33167a97e413e13f$export$5519909ee832c7c = /*#__PURE__*/ function(_React$Component) {
    (0, $1bdSs.default)(Rifm, _React$Component);
    function Rifm(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._state = null;
        _this._del = false;
        _this._handleChange = function(evt) {
            if (evt.target.type === 'number') {
                console.error('Rifm does not support input type=number, use type=tel instead.');
                return;
            }
            var stateValue = _this.state.value;
            var value = evt.target.value;
            var input = evt.target;
            var op = value.length > stateValue.length;
            var del = _this._del;
            var noOp = stateValue === _this.props.format(value);
            _this.setState({
                value: value,
                local: true
            }, function() {
                var selectionStart = input.selectionStart;
                var refuse = _this.props.refuse || /[^\d]+/g;
                var before = value.substr(0, selectionStart).replace(refuse, '');
                _this._state = {
                    input: input,
                    before: before,
                    op: op,
                    di: del && noOp,
                    del: del
                };
                if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
                    var start = -1;
                    for(var i = 0; i !== before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
                    var c = value.substr(start + 1).replace(refuse, '')[0];
                    start = value.indexOf(c, start + 1);
                    value = "" + value.substr(0, start) + value.substr(start + 1);
                }
                var fv = _this.props.format(value);
                if (stateValue === fv) _this.setState({
                    value: value
                });
                else _this.props.onChange(fv);
            });
        };
        _this._hKD = function(evt) {
            if (evt.code === 'Delete') _this._del = true;
        };
        _this._hKU = function(evt) {
            if (evt.code === 'Delete') _this._del = false;
        };
        _this.state = {
            value: props.value,
            local: true
        };
        return _this;
    }
    Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return {
            value: state.local ? state.value : props.value,
            local: false
        };
    };
    var _proto = Rifm.prototype;
    _proto.render = function render() {
        var _handleChange = this._handleChange, value = this.state.value, children = this.props.children;
        return children({
            value: value,
            onChange: _handleChange
        });
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this._hKD);
        document.removeEventListener('keyup', this._hKU);
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this._hKD);
        document.addEventListener('keyup', this._hKU);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var _state = this._state;
        if (_state) {
            var value = this.state.value;
            var start = -1;
            for(var i = 0; i !== _state.before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
             // format usually looks better without this
            if (this.props.replace && (_state.op || _state.del && !_state.di)) while(value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1]))start += 1;
            _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
        }
        this._state = null;
    };
    return Rifm;
}((0, $J42oT.Component));

});

parcelRegister("eu8ma", function(module, exports) {

$parcel$export(module.exports, "d", () => $a8ba597acedc0121$export$4368d992c4eafac0);
$parcel$export(module.exports, "P", () => $a8ba597acedc0121$export$56c0d5a1e737357d);

var $6JmtS = parcelRequire("6JmtS");

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $gFzGS = parcelRequire("gFzGS");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $cqRKQ = parcelRequire("cqRKQ");

var $jTsdR = parcelRequire("jTsdR");

var $iYjqA = parcelRequire("iYjqA");

var $j7UbN = parcelRequire("j7UbN");

var $30ito = parcelRequire("30ito");

var $xqZqF = parcelRequire("xqZqF");
function $a8ba597acedc0121$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a8ba597acedc0121$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a8ba597acedc0121$var$ownKeys(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a8ba597acedc0121$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a8ba597acedc0121$var$date = (0, $fcOLE.oneOfType)([
    (0, $fcOLE.object),
    (0, $fcOLE.string),
    (0, $fcOLE.number),
    (0, $fcOLE.instanceOf)(Date)
]);
var $a8ba597acedc0121$var$datePickerView = (0, $fcOLE.oneOf)([
    'year',
    'month',
    'day'
]);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */ var $a8ba597acedc0121$export$625550452a3fa3ec = {
    ampm: true,
    invalidDateMessage: 'Invalid Time Format'
};
var $a8ba597acedc0121$export$4368d992c4eafac0 = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    invalidDateMessage: 'Invalid Date Format',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    allowKeyboardControl: true
};
var $a8ba597acedc0121$export$407448d2b89b1813 = $a8ba597acedc0121$var$_objectSpread({}, $a8ba597acedc0121$export$625550452a3fa3ec, {}, $a8ba597acedc0121$export$4368d992c4eafac0, {
    showTabs: true
});
function $a8ba597acedc0121$var$useViews(views, openTo, onChange) {
    var _React$useState = (0, $J42oT.useState)(openTo && (0, $iYjqA.a)(views, openTo) ? openTo : views[0]), _React$useState2 = (0, $30ito.default)(_React$useState, 2), openView = _React$useState2[0], setOpenView = _React$useState2[1];
    var handleChangeAndOpenNext = (0, $J42oT.useCallback)(function(date, isFinish) {
        var nextViewToOpen = views[views.indexOf(openView) + 1];
        if (isFinish && nextViewToOpen) {
            // do not close picker if needs to show next view
            onChange(date, false);
            setOpenView(nextViewToOpen);
            return;
        }
        onChange(date, Boolean(isFinish));
    }, [
        onChange,
        openView,
        views
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        openView: openView,
        setOpenView: setOpenView
    };
}
var $a8ba597acedc0121$var$useStyles = (0, $jTsdR.default)(function(theme) {
    return {
        root: {
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        yearSelected: {
            margin: '10px 0',
            fontWeight: theme.typography.fontWeightMedium
        },
        yearDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersYear'
});
var $a8ba597acedc0121$var$Year = function Year(_ref) {
    var onSelect = _ref.onSelect, forwardedRef = _ref.forwardedRef, value = _ref.value, selected = _ref.selected, disabled = _ref.disabled, children = _ref.children, other = (0, $cVOSt.default)(_ref, [
        "onSelect",
        "forwardedRef",
        "value",
        "selected",
        "disabled",
        "children"
    ]);
    var classes = $a8ba597acedc0121$var$useStyles();
    var handleClick = (0, $J42oT.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $J42oT.createElement)((0, $cqRKQ.default), (0, $fXPf9.default)({
        role: "button",
        component: "div",
        tabIndex: disabled ? -1 : 0,
        onClick: handleClick,
        onKeyPress: handleClick,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children,
        ref: forwardedRef,
        className: (0, $lKxJt.default)(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
    }, other));
};
$a8ba597acedc0121$var$Year.displayName = 'Year';
var $a8ba597acedc0121$var$Year$1 = (0, $J42oT.forwardRef)(function(props, ref) {
    return (0, $J42oT.createElement)($a8ba597acedc0121$var$Year, (0, $fXPf9.default)({}, props, {
        forwardedRef: ref
    }));
});
var $a8ba597acedc0121$var$useStyles$1 = (0, $jTsdR.default)({
    container: {
        height: 300,
        overflowY: 'auto'
    }
}, {
    name: 'MuiPickersYearSelection'
});
var $a8ba597acedc0121$var$YearSelection = function YearSelection(_ref) {
    var date = _ref.date, onChange = _ref.onChange, onYearChange = _ref.onYearChange, minDate = _ref.minDate, maxDate = _ref.maxDate, disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, animateYearScrolling = _ref.animateYearScrolling;
    var utils = (0, $gFzGS.u)();
    var classes = $a8ba597acedc0121$var$useStyles$1();
    var currentVariant = (0, $J42oT.useContext)((0, $iYjqA.V));
    var selectedYearRef = (0, $J42oT.useRef)(null);
    (0, $J42oT.useEffect)(function() {
        if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) try {
            selectedYearRef.current.scrollIntoView({
                block: currentVariant === 'static' ? 'nearest' : 'center',
                behavior: animateYearScrolling ? 'smooth' : 'auto'
            });
        } catch (e) {
            // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
            selectedYearRef.current.scrollIntoView();
        }
    }, []); // eslint-disable-line
    var currentYear = utils.getYear(date);
    var onYearSelect = (0, $J42oT.useCallback)(function(year) {
        var newDate = utils.setYear(date, year);
        if (onYearChange) onYearChange(newDate);
        onChange(newDate, true);
    }, [
        date,
        onChange,
        onYearChange,
        utils
    ]);
    return (0, $J42oT.createElement)("div", {
        className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function(year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return (0, $J42oT.createElement)($a8ba597acedc0121$var$Year$1, {
            key: utils.getYearText(year),
            selected: selected,
            value: yearNumber,
            onSelect: onYearSelect,
            ref: selected ? selectedYearRef : undefined,
            disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
        }, utils.getYearText(year));
    }));
};
var $a8ba597acedc0121$var$useStyles$2 = (0, $jTsdR.default)(function(theme) {
    return {
        root: {
            flex: '1 0 33.33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            height: 75,
            transition: theme.transitions.create('font-size', {
                duration: '100ms'
            }),
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        monthSelected: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        monthDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersMonth'
});
var $a8ba597acedc0121$var$Month = function Month(_ref) {
    var selected = _ref.selected, onSelect = _ref.onSelect, disabled = _ref.disabled, value = _ref.value, children = _ref.children, other = (0, $cVOSt.default)(_ref, [
        "selected",
        "onSelect",
        "disabled",
        "value",
        "children"
    ]);
    var classes = $a8ba597acedc0121$var$useStyles$2();
    var handleSelection = (0, $J42oT.useCallback)(function() {
        onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $J42oT.createElement)((0, $cqRKQ.default), (0, $fXPf9.default)({
        role: "button",
        component: "div",
        className: (0, $lKxJt.default)(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyPress: handleSelection,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children
    }, other));
};
$a8ba597acedc0121$var$Month.displayName = 'Month';
var $a8ba597acedc0121$var$useStyles$3 = (0, $jTsdR.default)({
    container: {
        width: 310,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch'
    }
}, {
    name: 'MuiPickersMonthSelection'
});
var $a8ba597acedc0121$var$MonthSelection = function MonthSelection(_ref) {
    var disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, minDate = _ref.minDate, maxDate = _ref.maxDate, date = _ref.date, onMonthChange = _ref.onMonthChange, onChange = _ref.onChange;
    var utils = (0, $gFzGS.u)();
    var classes = $a8ba597acedc0121$var$useStyles$3();
    var currentMonth = utils.getMonth(date);
    var shouldDisableMonth = function shouldDisableMonth(month) {
        var now = utils.date();
        var utilMinDate = utils.date(minDate);
        var utilMaxDate = utils.date(maxDate);
        var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
        var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
        var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    var onMonthSelect = (0, $J42oT.useCallback)(function(month) {
        var newDate = utils.setMonth(date, month);
        onChange(newDate, true);
        if (onMonthChange) onMonthChange(newDate);
    }, [
        date,
        onChange,
        onMonthChange,
        utils
    ]);
    return (0, $J42oT.createElement)("div", {
        className: classes.container
    }, utils.getMonthArray(date).map(function(month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'MMM');
        return (0, $J42oT.createElement)($a8ba597acedc0121$var$Month, {
            key: monthText,
            value: monthNumber,
            selected: monthNumber === currentMonth,
            onSelect: onMonthSelect,
            disabled: shouldDisableMonth(month)
        }, monthText);
    }));
};
var $a8ba597acedc0121$var$getOrientation = function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
};
function $a8ba597acedc0121$var$useIsLandscape(customOrientation) {
    var _React$useState = (0, $J42oT.useState)($a8ba597acedc0121$var$getOrientation()), _React$useState2 = (0, $30ito.default)(_React$useState, 2), orientation = _React$useState2[0], setOrientation = _React$useState2[1];
    var eventHandler = (0, $J42oT.useCallback)(function() {
        return setOrientation($a8ba597acedc0121$var$getOrientation());
    }, []);
    (0, $iYjqA.u)(function() {
        window.addEventListener('orientationchange', eventHandler);
        return function() {
            return window.removeEventListener('orientationchange', eventHandler);
        };
    }, [
        eventHandler
    ]);
    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
function $a8ba597acedc0121$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a8ba597acedc0121$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a8ba597acedc0121$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $6JmtS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a8ba597acedc0121$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a8ba597acedc0121$var$viewsMap = {
    year: $a8ba597acedc0121$var$YearSelection,
    month: $a8ba597acedc0121$var$MonthSelection,
    date: (0, $j7UbN.a),
    hours: (0, $xqZqF.ClockView),
    minutes: (0, $xqZqF.ClockView),
    seconds: (0, $xqZqF.ClockView)
};
var $a8ba597acedc0121$var$useStyles$4 = (0, $jTsdR.default)({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerLandscape: {
        flexDirection: 'row'
    },
    pickerView: {
        overflowX: 'hidden',
        minHeight: (0, $iYjqA.b),
        minWidth: (0, $iYjqA.D),
        maxWidth: (0, $iYjqA.c),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    pickerViewLandscape: {
        padding: '0 8px'
    }
}, {
    name: 'MuiPickersBasePicker'
});
var $a8ba597acedc0121$export$56c0d5a1e737357d = function Picker(_ref) {
    var date = _ref.date, views = _ref.views, disableToolbar = _ref.disableToolbar, onChange = _ref.onChange, openTo = _ref.openTo, unparsedMinDate = _ref.minDate, unparsedMaxDate = _ref.maxDate, ToolbarComponent = _ref.ToolbarComponent, orientation = _ref.orientation, rest = (0, $cVOSt.default)(_ref, [
        "date",
        "views",
        "disableToolbar",
        "onChange",
        "openTo",
        "minDate",
        "maxDate",
        "ToolbarComponent",
        "orientation"
    ]);
    var utils = (0, $gFzGS.u)();
    var classes = $a8ba597acedc0121$var$useStyles$4();
    var isLandscape = $a8ba597acedc0121$var$useIsLandscape(orientation);
    var _useViews = $a8ba597acedc0121$var$useViews(views, openTo, onChange), openView = _useViews.openView, setOpenView = _useViews.setOpenView, handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
    var minDate = (0, $J42oT.useMemo)(function() {
        return utils.date(unparsedMinDate);
    }, [
        unparsedMinDate,
        utils
    ]);
    var maxDate = (0, $J42oT.useMemo)(function() {
        return utils.date(unparsedMaxDate);
    }, [
        unparsedMaxDate,
        utils
    ]);
    return (0, $J42oT.createElement)("div", {
        className: (0, $lKxJt.default)(classes.container, isLandscape && classes.containerLandscape)
    }, !disableToolbar && (0, $J42oT.createElement)(ToolbarComponent, (0, $fXPf9.default)({}, rest, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: onChange,
        setOpenView: setOpenView,
        openView: openView
    })), (0, $J42oT.createElement)("div", {
        className: (0, $lKxJt.default)(classes.pickerView, isLandscape && classes.pickerViewLandscape)
    }, openView === 'year' && (0, $J42oT.createElement)($a8ba597acedc0121$var$YearSelection, (0, $fXPf9.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'month' && (0, $J42oT.createElement)($a8ba597acedc0121$var$MonthSelection, (0, $fXPf9.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'date' && (0, $J42oT.createElement)((0, $j7UbN.a), (0, $fXPf9.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && (0, $J42oT.createElement)((0, $xqZqF.ClockView), (0, $fXPf9.default)({}, rest, {
        date: date,
        type: openView,
        onHourChange: handleChangeAndOpenNext,
        onMinutesChange: handleChangeAndOpenNext,
        onSecondsChange: handleChangeAndOpenNext
    }))));
};
$a8ba597acedc0121$export$56c0d5a1e737357d.defaultProps = $a8ba597acedc0121$var$_objectSpread$1({}, $a8ba597acedc0121$export$4368d992c4eafac0, {
    views: Object.keys($a8ba597acedc0121$var$viewsMap)
});

});
parcelRegister("j7UbN", function(module, exports) {

$parcel$export(module.exports, "i", () => $deca41c535ea243d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "b", () => $deca41c535ea243d$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $deca41c535ea243d$export$39b482c5e57630a8);
$parcel$export(module.exports, "a", () => $deca41c535ea243d$export$407448d2b89b1813);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $gFzGS = parcelRequire("gFzGS");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $cqRKQ = parcelRequire("cqRKQ");

var $jTsdR = parcelRequire("jTsdR");
var $IQ3Oi = parcelRequire("IQ3Oi");
var $cV5xs = parcelRequire("cV5xs");

var $iYjqA = parcelRequire("iYjqA");

var $io0Xu = parcelRequire("io0Xu");

var $coELO = parcelRequire("coELO");

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $42JcH = parcelRequire("42JcH");

var $1h73G = parcelRequire("1h73G");

var $hIvGi = parcelRequire("hIvGi");

var $1fPZ3 = parcelRequire("1fPZ3");

var $jYuW6 = parcelRequire("jYuW6");
var $kDjVp = parcelRequire("kDjVp");

var $f3GC3 = parcelRequire("f3GC3");
var $deca41c535ea243d$var$findClosestEnabledDate = function findClosestEnabledDate(_ref) {
    var date = _ref.date, utils = _ref.utils, minDate = _ref.minDate, maxDate = _ref.maxDate, disableFuture = _ref.disableFuture, disablePast = _ref.disablePast, shouldDisableDate = _ref.shouldDisableDate;
    var today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    var forward = date;
    var backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    } // fallback to today if no enabled days
    return utils.date();
};
var $deca41c535ea243d$export$23f2a1d2818174ef = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
};
var $deca41c535ea243d$export$8b22cf2602fb60ce = function isYearAndMonthViews(views) {
    return views.length === 2 && (0, $iYjqA.a)(views, 'month') && (0, $iYjqA.a)(views, 'year');
};
var $deca41c535ea243d$export$39b482c5e57630a8 = function getFormatByViews(views, utils) {
    if ($deca41c535ea243d$export$23f2a1d2818174ef(views)) return utils.yearFormat;
    if ($deca41c535ea243d$export$8b22cf2602fb60ce(views)) return utils.yearMonthFormat;
    return utils.dateFormat;
};
var $deca41c535ea243d$var$DayWrapper = function DayWrapper(_ref) {
    var children = _ref.children, value = _ref.value, disabled = _ref.disabled, onSelect = _ref.onSelect, dayInCurrentMonth = _ref.dayInCurrentMonth, other = (0, $cVOSt.default)(_ref, [
        "children",
        "value",
        "disabled",
        "onSelect",
        "dayInCurrentMonth"
    ]);
    var handleClick = (0, $J42oT.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $J42oT.createElement)("div", (0, $fXPf9.default)({
        role: "presentation",
        onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
        onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
    }, other), children);
};
var $deca41c535ea243d$var$animationDuration = 350;
var $deca41c535ea243d$var$useStyles = (0, $jTsdR.default)(function(theme) {
    var slideTransition = theme.transitions.create('transform', {
        duration: $deca41c535ea243d$var$animationDuration,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        transitionContainer: {
            display: 'block',
            position: 'relative',
            '& > *': {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0
            }
        },
        'slideEnter-left': {
            willChange: 'transform',
            transform: 'translate(100%)'
        },
        'slideEnter-right': {
            willChange: 'transform',
            transform: 'translate(-100%)'
        },
        slideEnterActive: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        slideExit: {
            transform: 'translate(0%)'
        },
        'slideExitActiveLeft-left': {
            willChange: 'transform',
            transform: 'translate(-200%)',
            transition: slideTransition
        },
        'slideExitActiveLeft-right': {
            willChange: 'transform',
            transform: 'translate(200%)',
            transition: slideTransition
        }
    };
}, {
    name: 'MuiPickersSlideTransition'
});
var $deca41c535ea243d$var$SlideTransition = function SlideTransition(_ref) {
    var children = _ref.children, transKey = _ref.transKey, slideDirection = _ref.slideDirection, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className;
    var classes = $deca41c535ea243d$var$useStyles();
    var transitionClasses = {
        exit: classes.slideExit,
        enterActive: classes.slideEnterActive,
        // @ts-ignore
        enter: classes['slideEnter-' + slideDirection],
        // @ts-ignore
        exitActive: classes['slideExitActiveLeft-' + slideDirection]
    };
    return (0, $J42oT.createElement)((0, $kDjVp.default), {
        className: (0, $lKxJt.default)(classes.transitionContainer, className),
        childFactory: function childFactory(element) {
            return (0, $J42oT.cloneElement)(element, {
                classNames: transitionClasses
            });
        }
    }, (0, $J42oT.createElement)((0, $jYuW6.default), {
        mountOnEnter: true,
        unmountOnExit: true,
        key: transKey + slideDirection,
        timeout: $deca41c535ea243d$var$animationDuration,
        classNames: transitionClasses,
        children: children
    }));
};
var $deca41c535ea243d$var$ArrowLeftIcon = function ArrowLeftIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $coELO.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $deca41c535ea243d$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $coELO.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $deca41c535ea243d$var$useStyles$1 = (0, $jTsdR.default)(function(theme) {
    return {
        switchHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        transitionContainer: {
            width: '100%',
            overflow: 'hidden',
            height: 23
        },
        iconButton: {
            zIndex: 1,
            backgroundColor: theme.palette.background.paper
        },
        daysHeader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: 16
        },
        dayLabel: {
            width: 36,
            margin: '0 2px',
            textAlign: 'center',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersCalendarHeader'
});
var $deca41c535ea243d$var$CalendarHeader = function CalendarHeader(_ref) {
    var currentMonth = _ref.currentMonth, onMonthChange = _ref.onMonthChange, leftArrowIcon = _ref.leftArrowIcon, rightArrowIcon = _ref.rightArrowIcon, leftArrowButtonProps = _ref.leftArrowButtonProps, rightArrowButtonProps = _ref.rightArrowButtonProps, disablePrevMonth = _ref.disablePrevMonth, disableNextMonth = _ref.disableNextMonth, slideDirection = _ref.slideDirection;
    var utils = (0, $gFzGS.u)();
    var classes = $deca41c535ea243d$var$useStyles$1();
    var theme = (0, $IQ3Oi.default)();
    var rtl = theme.direction === 'rtl';
    var selectNextMonth = function selectNextMonth() {
        return onMonthChange(utils.getNextMonth(currentMonth), 'left');
    };
    var selectPreviousMonth = function selectPreviousMonth() {
        return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
    };
    return (0, $J42oT.createElement)("div", null, (0, $J42oT.createElement)("div", {
        className: classes.switchHeader
    }, (0, $J42oT.createElement)((0, $io0Xu.default), (0, $fXPf9.default)({}, leftArrowButtonProps, {
        disabled: disablePrevMonth,
        onClick: selectPreviousMonth,
        className: classes.iconButton
    }), rtl ? rightArrowIcon : leftArrowIcon), (0, $J42oT.createElement)($deca41c535ea243d$var$SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
    }, (0, $J42oT.createElement)((0, $cqRKQ.default), {
        align: "center",
        variant: "body1"
    }, utils.getCalendarHeaderText(currentMonth))), (0, $J42oT.createElement)((0, $io0Xu.default), (0, $fXPf9.default)({}, rightArrowButtonProps, {
        disabled: disableNextMonth,
        onClick: selectNextMonth,
        className: classes.iconButton
    }), rtl ? leftArrowIcon : rightArrowIcon)), (0, $J42oT.createElement)("div", {
        className: classes.daysHeader
    }, utils.getWeekdays().map(function(day, index) {
        return (0, $J42oT.createElement)((0, $cqRKQ.default), {
            key: index // eslint-disable-line react/no-array-index-key
            ,
            variant: "caption",
            className: classes.dayLabel
        }, day);
    })));
};
$deca41c535ea243d$var$CalendarHeader.displayName = 'CalendarHeader';
$deca41c535ea243d$var$CalendarHeader.propTypes = {
    leftArrowIcon: (0, $fcOLE.node),
    rightArrowIcon: (0, $fcOLE.node),
    disablePrevMonth: (0, $fcOLE.bool),
    disableNextMonth: (0, $fcOLE.bool)
};
$deca41c535ea243d$var$CalendarHeader.defaultProps = {
    leftArrowIcon: (0, $J42oT.createElement)($deca41c535ea243d$var$ArrowLeftIcon, null),
    rightArrowIcon: (0, $J42oT.createElement)($deca41c535ea243d$var$ArrowRightIcon, null),
    disablePrevMonth: false,
    disableNextMonth: false
};
var $deca41c535ea243d$var$withUtils = function withUtils() {
    return function(Component) {
        var WithUtils = function WithUtils(props) {
            var utils = (0, $gFzGS.u)();
            return (0, $J42oT.createElement)(Component, (0, $fXPf9.default)({
                utils: utils
            }, props));
        };
        WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
        return WithUtils;
    };
};
var $deca41c535ea243d$var$KeyDownListener = function KeyDownListener(_ref) {
    var onKeyDown = _ref.onKeyDown;
    (0, $J42oT.useEffect)(function() {
        window.addEventListener('keydown', onKeyDown);
        return function() {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    return null;
};
var $deca41c535ea243d$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $hIvGi.default)(Calendar, _React$Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        (0, $lfYGa.default)(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $42JcH.default)(this, (_getPrototypeOf2 = (0, $1h73G.default)(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            slideDirection: 'left',
            currentMonth: _this.props.utils.startOfMonth(_this.props.date),
            loadingQueue: 0
        };
        _this.pushToLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue + 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.popFromLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue;
            loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.handleChangeMonth = function(newMonth, slideDirection) {
            _this.setState({
                currentMonth: newMonth,
                slideDirection: slideDirection
            });
            if (_this.props.onMonthChange) {
                var returnVal = _this.props.onMonthChange(newMonth);
                if (returnVal) {
                    _this.pushToLoadingQueue();
                    returnVal.then(function() {
                        _this.popFromLoadingQueue();
                    });
                }
            }
        };
        _this.validateMinMaxDate = function(day) {
            var _this$props = _this.props, minDate = _this$props.minDate, maxDate = _this$props.maxDate, utils = _this$props.utils, disableFuture = _this$props.disableFuture, disablePast = _this$props.disablePast;
            var now = utils.date();
            return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
        };
        _this.shouldDisablePrevMonth = function() {
            var _this$props2 = _this.props, utils = _this$props2.utils, disablePast = _this$props2.disablePast, minDate = _this$props2.minDate;
            var now = utils.date();
            var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
            return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _this$props3 = _this.props, utils = _this$props3.utils, disableFuture = _this$props3.disableFuture, maxDate = _this$props3.maxDate;
            var now = utils.date();
            var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
            return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var shouldDisableDate = _this.props.shouldDisableDate;
            return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
        };
        _this.handleDaySelect = function(day) {
            var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props4 = _this.props, date = _this$props4.date, utils = _this$props4.utils;
            _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
        };
        _this.moveToDay = function(day) {
            var utils = _this.props.utils;
            if (day && !_this.shouldDisableDate(day)) {
                if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) _this.handleChangeMonth(utils.startOfMonth(day), 'left');
                _this.handleDaySelect(day, false);
            }
        };
        _this.handleKeyDown = function(event) {
            var _this$props5 = _this.props, theme = _this$props5.theme, date = _this$props5.date, utils = _this$props5.utils;
            (0, $iYjqA.r)(event, {
                ArrowUp: function ArrowUp() {
                    return _this.moveToDay(utils.addDays(date, -7));
                },
                ArrowDown: function ArrowDown() {
                    return _this.moveToDay(utils.addDays(date, 7));
                },
                ArrowLeft: function ArrowLeft() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
                },
                ArrowRight: function ArrowRight() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
                }
            });
        };
        _this.renderWeeks = function() {
            var _this$props6 = _this.props, utils = _this$props6.utils, classes = _this$props6.classes;
            var weeks = utils.getWeekArray(_this.state.currentMonth);
            return weeks.map(function(week) {
                return (0, $J42oT.createElement)("div", {
                    key: "week-".concat(week[0].toString()),
                    className: classes.week
                }, _this.renderDays(week));
            });
        };
        _this.renderDays = function(week) {
            var _this$props7 = _this.props, date = _this$props7.date, renderDay = _this$props7.renderDay, utils = _this$props7.utils;
            var now = utils.date();
            var selectedDate = utils.startOfDay(date);
            var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var dayComponent = (0, $J42oT.createElement)((0, $1fPZ3.default), {
                    disabled: disabled,
                    current: utils.isSameDay(day, now),
                    hidden: !isDayInCurrentMonth,
                    selected: utils.isSameDay(selectedDate, day)
                }, utils.getDayText(day));
                if (renderDay) dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
                return (0, $J42oT.createElement)($deca41c535ea243d$var$DayWrapper, {
                    value: day,
                    key: day.toString(),
                    disabled: disabled,
                    dayInCurrentMonth: isDayInCurrentMonth,
                    onSelect: _this.handleDaySelect
                }, dayComponent);
            });
        };
        return _this;
    }
    (0, $cWCsL.default)(Calendar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props8 = this.props, date = _this$props8.date, minDate = _this$props8.minDate, maxDate = _this$props8.maxDate, utils = _this$props8.utils, disablePast = _this$props8.disablePast, disableFuture = _this$props8.disableFuture;
                if (this.shouldDisableDate(date)) {
                    var closestEnabledDate = $deca41c535ea243d$var$findClosestEnabledDate({
                        date: date,
                        utils: utils,
                        minDate: utils.date(minDate),
                        maxDate: utils.date(maxDate),
                        disablePast: Boolean(disablePast),
                        disableFuture: Boolean(disableFuture),
                        shouldDisableDate: this.shouldDisableDate
                    });
                    this.handleDaySelect(closestEnabledDate, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, currentMonth = _this$state.currentMonth, slideDirection = _this$state.slideDirection;
                var _this$props9 = this.props, classes = _this$props9.classes, allowKeyboardControl = _this$props9.allowKeyboardControl, leftArrowButtonProps = _this$props9.leftArrowButtonProps, leftArrowIcon = _this$props9.leftArrowIcon, rightArrowButtonProps = _this$props9.rightArrowButtonProps, rightArrowIcon = _this$props9.rightArrowIcon, loadingIndicator = _this$props9.loadingIndicator;
                var loadingElement = loadingIndicator ? loadingIndicator : (0, $J42oT.createElement)((0, $f3GC3.default), null);
                return (0, $J42oT.createElement)((0, $J42oT.Fragment), null, allowKeyboardControl && this.context !== 'static' && (0, $J42oT.createElement)($deca41c535ea243d$var$KeyDownListener, {
                    onKeyDown: this.handleKeyDown
                }), (0, $J42oT.createElement)($deca41c535ea243d$var$CalendarHeader, {
                    currentMonth: currentMonth,
                    slideDirection: slideDirection,
                    onMonthChange: this.handleChangeMonth,
                    leftArrowIcon: leftArrowIcon,
                    leftArrowButtonProps: leftArrowButtonProps,
                    rightArrowIcon: rightArrowIcon,
                    rightArrowButtonProps: rightArrowButtonProps,
                    disablePrevMonth: this.shouldDisablePrevMonth(),
                    disableNextMonth: this.shouldDisableNextMonth()
                }), (0, $J42oT.createElement)($deca41c535ea243d$var$SlideTransition, {
                    slideDirection: slideDirection,
                    transKey: currentMonth.toString(),
                    className: classes.transitionContainer
                }, (0, $J42oT.createElement)((0, $J42oT.Fragment), null, this.state.loadingQueue > 0 && (0, $J42oT.createElement)("div", {
                    className: classes.progressContainer
                }, loadingElement) || (0, $J42oT.createElement)("div", null, this.renderWeeks()))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                var utils = nextProps.utils, nextDate = nextProps.date;
                if (!utils.isEqual(nextDate, state.lastDate)) {
                    var nextMonth = utils.getMonth(nextDate);
                    var lastDate = state.lastDate || nextDate;
                    var lastMonth = utils.getMonth(lastDate);
                    return {
                        lastDate: nextDate,
                        currentMonth: nextProps.utils.startOfMonth(nextDate),
                        // prettier-ignore
                        slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
                    };
                }
                return null;
            }
        }
    ]);
    return Calendar;
}((0, $J42oT.Component));
$deca41c535ea243d$export$e7094788287c5e9b.contextType = (0, $iYjqA.V);
$deca41c535ea243d$export$e7094788287c5e9b.propTypes = {
    renderDay: (0, $fcOLE.func),
    shouldDisableDate: (0, $fcOLE.func),
    allowKeyboardControl: (0, $fcOLE.bool)
};
$deca41c535ea243d$export$e7094788287c5e9b.defaultProps = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: true
};
var $deca41c535ea243d$export$2408f22a0fab9ae5 = function styles(theme) {
    return {
        transitionContainer: {
            minHeight: 216,
            marginTop: theme.spacing(1.5)
        },
        progressContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        week: {
            display: 'flex',
            justifyContent: 'center'
        }
    };
};
var $deca41c535ea243d$export$407448d2b89b1813 = (0, $cV5xs.default)($deca41c535ea243d$export$2408f22a0fab9ae5, {
    name: 'MuiPickersCalendar',
    withTheme: true
})($deca41c535ea243d$var$withUtils()($deca41c535ea243d$export$e7094788287c5e9b));

});
parcelRegister("42JcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1a69d7dd09a858$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $5h49q = parcelRequire("5h49q");
function $2f1a69d7dd09a858$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5z6Dx.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $5h49q.default)(t);
}

});

parcelRegister("1h73G", function(module, exports) {

$parcel$export(module.exports, "default", () => $0edcda9e64ee3a39$export$2e2bcd8739ae039);
function $0edcda9e64ee3a39$export$2e2bcd8739ae039(t) {
    return $0edcda9e64ee3a39$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0edcda9e64ee3a39$export$2e2bcd8739ae039(t);
}

});

parcelRegister("hIvGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5f1ef71fd02d7f$export$2e2bcd8739ae039);

var $3bCBG = parcelRequire("3bCBG");
function $ce5f1ef71fd02d7f$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3bCBG.default)(t, e);
}

});

parcelRegister("1fPZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9f840d32558852$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cVOSt = parcelRequire("cVOSt");

var $cqRKQ = parcelRequire("cqRKQ");

var $jTsdR = parcelRequire("jTsdR");

var $io0Xu = parcelRequire("io0Xu");
var $0e9f840d32558852$export$28e6b9b82ee883c = (0, $jTsdR.default)(function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: '0 2px',
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none'
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        daySelected: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            }
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersDay'
});
var $0e9f840d32558852$export$7a9a31a911eb9a20 = function Day(_ref) {
    var children = _ref.children, disabled = _ref.disabled, hidden = _ref.hidden, current = _ref.current, selected = _ref.selected, other = (0, $cVOSt.default)(_ref, [
        "children",
        "disabled",
        "hidden",
        "current",
        "selected"
    ]);
    var classes = $0e9f840d32558852$export$28e6b9b82ee883c();
    var className = (0, $lKxJt.default)(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
    return (0, $J42oT.createElement)((0, $io0Xu.default), (0, $fXPf9.default)({
        className: className,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), (0, $J42oT.createElement)((0, $cqRKQ.default), {
        variant: "body2",
        color: "inherit"
    }, children));
};
$0e9f840d32558852$export$7a9a31a911eb9a20.displayName = 'Day';
$0e9f840d32558852$export$7a9a31a911eb9a20.propTypes = {
    current: (0, $fcOLE.bool),
    disabled: (0, $fcOLE.bool),
    hidden: (0, $fcOLE.bool),
    selected: (0, $fcOLE.bool)
};
$0e9f840d32558852$export$7a9a31a911eb9a20.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
};
var $0e9f840d32558852$export$2e2bcd8739ae039 = $0e9f840d32558852$export$7a9a31a911eb9a20;

});

parcelRegister("jYuW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ab9e34d4888fac$export$2e2bcd8739ae039);

var $fXPf9 = parcelRequire("fXPf9");

var $bXxv0 = parcelRequire("bXxv0");

var $1bdSs = parcelRequire("1bdSs");

var $fcOLE = parcelRequire("fcOLE");

var $jB1ev = parcelRequire("jB1ev");

var $1n7yg = parcelRequire("1n7yg");

var $J42oT = parcelRequire("J42oT");

var $5pZVD = parcelRequire("5pZVD");

var $jDKSq = parcelRequire("jDKSq");

var $fbWlz = parcelRequire("fbWlz");
var $e8ab9e34d4888fac$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $jB1ev.default)(node, c);
    });
};
var $e8ab9e34d4888fac$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1n7yg.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $e8ab9e34d4888fac$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $1bdSs.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $fbWlz.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $e8ab9e34d4888fac$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $e8ab9e34d4888fac$var$removeClass(node, baseClassName);
        if (activeClassName) $e8ab9e34d4888fac$var$removeClass(node, activeClassName);
        if (doneClassName) $e8ab9e34d4888fac$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $bXxv0.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement((0, $5pZVD.default), (0, $fXPf9.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).Component);
$e8ab9e34d4888fac$var$CSSTransition.defaultProps = {
    classNames: ''
};
$e8ab9e34d4888fac$var$CSSTransition.propTypes = (0, $fXPf9.default)({}, (0, $5pZVD.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, $jDKSq.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fcOLE))).func
});
var $e8ab9e34d4888fac$export$2e2bcd8739ae039 = $e8ab9e34d4888fac$var$CSSTransition;

});
parcelRegister("jB1ev", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4426dd77bce28fe$export$2e2bcd8739ae039);

var $iDPYx = parcelRequire("iDPYx");
function $e4426dd77bce28fe$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $iDPYx.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("iDPYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9242fc61cde3c59$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $d9242fc61cde3c59$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("1n7yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ffdcc058648b5eb$export$2e2bcd8739ae039);
function $0ffdcc058648b5eb$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $0ffdcc058648b5eb$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $0ffdcc058648b5eb$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $0ffdcc058648b5eb$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});



parcelRegister("xqZqF", function(module, exports) {

$parcel$export(module.exports, "ClockView", () => $064804cad2c62939$export$e6ca67116c8adcad);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $gFzGS = parcelRequire("gFzGS");

var $lKxJt = parcelRequire("lKxJt");

var $fXPf9 = parcelRequire("fXPf9");

var $cqRKQ = parcelRequire("cqRKQ");

var $jTsdR = parcelRequire("jTsdR");
parcelRequire("lfYGa");
parcelRequire("cWCsL");
parcelRequire("42JcH");
parcelRequire("1h73G");
parcelRequire("hIvGi");

var $kkla5 = parcelRequire("kkla5");
var $064804cad2c62939$var$positions = {
    0: [
        0,
        40
    ],
    1: [
        55,
        19.6
    ],
    2: [
        94.4,
        59.5
    ],
    3: [
        109,
        114
    ],
    4: [
        94.4,
        168.5
    ],
    5: [
        54.5,
        208.4
    ],
    6: [
        0,
        223
    ],
    7: [
        -54.5,
        208.4
    ],
    8: [
        -94.4,
        168.5
    ],
    9: [
        -109,
        114
    ],
    10: [
        -94.4,
        59.5
    ],
    11: [
        -54.5,
        19.6
    ],
    12: [
        0,
        5
    ],
    13: [
        36.9,
        49.9
    ],
    14: [
        64,
        77
    ],
    15: [
        74,
        114
    ],
    16: [
        64,
        151
    ],
    17: [
        37,
        178
    ],
    18: [
        0,
        188
    ],
    19: [
        -37,
        178
    ],
    20: [
        -64,
        151
    ],
    21: [
        -74,
        114
    ],
    22: [
        -64,
        77
    ],
    23: [
        -37,
        50
    ]
};
var $064804cad2c62939$var$useStyles = (0, $jTsdR.default)(function(theme) {
    var size = theme.spacing(4);
    return {
        clockNumber: {
            width: size,
            height: 32,
            userSelect: 'none',
            position: 'absolute',
            left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
        },
        clockNumberSelected: {
            color: theme.palette.primary.contrastText
        }
    };
}, {
    name: 'MuiPickersClockNumber'
});
var $064804cad2c62939$var$ClockNumber = function ClockNumber(_ref) {
    var selected = _ref.selected, label = _ref.label, index = _ref.index, isInner = _ref.isInner;
    var classes = $064804cad2c62939$var$useStyles();
    var className = (0, $lKxJt.default)(classes.clockNumber, selected && classes.clockNumberSelected);
    var transformStyle = (0, $J42oT.useMemo)(function() {
        var position = $064804cad2c62939$var$positions[index];
        return {
            transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
        };
    }, [
        index
    ]);
    return (0, $J42oT.createElement)((0, $cqRKQ.default), {
        component: "span",
        className: className,
        variant: isInner ? 'body2' : 'body1',
        style: transformStyle,
        children: label
    });
};
var $064804cad2c62939$var$getHourNumbers = function getHourNumbers(_ref) {
    var ampm = _ref.ampm, utils = _ref.utils, date = _ref.date;
    var currentHours = utils.getHours(date);
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;
    var isSelected = function isSelected(hour) {
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(var hour = startHour; hour <= endHour; hour += 1){
        var label = hour.toString();
        if (hour === 0) label = '00';
        var props = {
            index: hour,
            label: utils.formatNumber(label),
            selected: isSelected(hour),
            isInner: !ampm && (hour === 0 || hour > 12)
        };
        hourNumbers.push((0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, (0, $fXPf9.default)({
            key: hour
        }, props)));
    }
    return hourNumbers;
};
var $064804cad2c62939$var$getMinutesNumbers = function getMinutesNumbers(_ref2) {
    var value = _ref2.value, utils = _ref2.utils;
    var f = utils.formatNumber;
    return [
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('00'),
            selected: value === 0,
            index: 12,
            key: 12
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('05'),
            selected: value === 5,
            index: 1,
            key: 1
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('10'),
            selected: value === 10,
            index: 2,
            key: 2
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('15'),
            selected: value === 15,
            index: 3,
            key: 3
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('20'),
            selected: value === 20,
            index: 4,
            key: 4
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('25'),
            selected: value === 25,
            index: 5,
            key: 5
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('30'),
            selected: value === 30,
            index: 6,
            key: 6
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('35'),
            selected: value === 35,
            index: 7,
            key: 7
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('40'),
            selected: value === 40,
            index: 8,
            key: 8
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('45'),
            selected: value === 45,
            index: 9,
            key: 9
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('50'),
            selected: value === 50,
            index: 10,
            key: 10
        }),
        (0, $J42oT.createElement)($064804cad2c62939$var$ClockNumber, {
            label: f('55'),
            selected: value === 55,
            index: 11,
            key: 11
        })
    ];
};
var $064804cad2c62939$export$e6ca67116c8adcad = function ClockView(_ref) {
    var type = _ref.type, onHourChange = _ref.onHourChange, onMinutesChange = _ref.onMinutesChange, onSecondsChange = _ref.onSecondsChange, ampm = _ref.ampm, date = _ref.date, minutesStep = _ref.minutesStep;
    var utils = (0, $gFzGS.u)();
    var viewProps = (0, $J42oT.useMemo)(function() {
        switch(type){
            case (0, $kkla5.b).HOURS:
                return {
                    value: utils.getHours(date),
                    children: $064804cad2c62939$var$getHourNumbers({
                        date: date,
                        utils: utils,
                        ampm: Boolean(ampm)
                    }),
                    onChange: function onChange(value, isFinish) {
                        var currentMeridiem = (0, $kkla5.g)(date, utils);
                        var updatedTimeWithMeridiem = (0, $kkla5.c)(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
                        onHourChange(updatedTimeWithMeridiem, isFinish);
                    }
                };
            case (0, $kkla5.b).MINUTES:
                var minutesValue = utils.getMinutes(date);
                return {
                    value: minutesValue,
                    children: $064804cad2c62939$var$getMinutesNumbers({
                        value: minutesValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setMinutes(date, value);
                        onMinutesChange(updatedTime, isFinish);
                    }
                };
            case (0, $kkla5.b).SECONDS:
                var secondsValue = utils.getSeconds(date);
                return {
                    value: secondsValue,
                    children: $064804cad2c62939$var$getMinutesNumbers({
                        value: secondsValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setSeconds(date, value);
                        onSecondsChange(updatedTime, isFinish);
                    }
                };
            default:
                throw new Error('You must provide the type for TimePickerView');
        }
    }, [
        ampm,
        date,
        onHourChange,
        onMinutesChange,
        onSecondsChange,
        type,
        utils
    ]);
    return (0, $J42oT.createElement)((0, $kkla5.a), (0, $fXPf9.default)({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep
    }, viewProps));
};
$064804cad2c62939$export$e6ca67116c8adcad.displayName = 'TimePickerView';
$064804cad2c62939$export$e6ca67116c8adcad.propTypes = {
    date: (0, $fcOLE.object).isRequired,
    onHourChange: (0, $fcOLE.func).isRequired,
    onMinutesChange: (0, $fcOLE.func).isRequired,
    onSecondsChange: (0, $fcOLE.func).isRequired,
    ampm: (0, $fcOLE.bool),
    minutesStep: (0, $fcOLE.number),
    type: (0, $fcOLE.oneOf)(Object.keys((0, $kkla5.b)).map(function(key) {
        return (0, $kkla5.b)[key];
    })).isRequired
};
$064804cad2c62939$export$e6ca67116c8adcad.defaultProps = {
    ampm: true,
    minutesStep: 1
};
var $064804cad2c62939$var$ClockView$1 = (0, $J42oT.memo)($064804cad2c62939$export$e6ca67116c8adcad);
var $064804cad2c62939$export$2e2bcd8739ae039 = $064804cad2c62939$var$ClockView$1;

});
parcelRegister("kkla5", function(module, exports) {

$parcel$export(module.exports, "b", () => $ecc6172bdab98ac9$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $ecc6172bdab98ac9$export$39b482c5e57630a8);
$parcel$export(module.exports, "c", () => $ecc6172bdab98ac9$export$db3b6bfb95261072);
$parcel$export(module.exports, "a", () => $ecc6172bdab98ac9$export$407448d2b89b1813);

var $J42oT = parcelRequire("J42oT");

var $fcOLE = parcelRequire("fcOLE");

var $lKxJt = parcelRequire("lKxJt");

var $ewLWY = parcelRequire("ewLWY");
var $cV5xs = parcelRequire("cV5xs");

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $42JcH = parcelRequire("42JcH");

var $1h73G = parcelRequire("1h73G");

var $hIvGi = parcelRequire("hIvGi");
var $ecc6172bdab98ac9$var$ClockType;
(function(ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})($ecc6172bdab98ac9$var$ClockType || ($ecc6172bdab98ac9$var$ClockType = {}));
var $ecc6172bdab98ac9$export$8b22cf2602fb60ce = $ecc6172bdab98ac9$var$ClockType;
var $ecc6172bdab98ac9$var$ClockPointer = /*#__PURE__*/ function(_React$Component) {
    (0, $hIvGi.default)(ClockPointer, _React$Component);
    function ClockPointer() {
        var _getPrototypeOf2;
        var _this;
        (0, $lfYGa.default)(this, ClockPointer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $42JcH.default)(this, (_getPrototypeOf2 = (0, $1h73G.default)(ClockPointer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
        _this.getAngleStyle = function() {
            var _this$props = _this.props, value = _this$props.value, isInner = _this$props.isInner, type = _this$props.type;
            var max = type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.HOURS ? 12 : 60;
            var angle = 360 / max * value;
            if (type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.HOURS && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: isInner ? '26%' : '40%',
                transform: "rotateZ(".concat(angle, "deg)")
            };
        };
        return _this;
    }
    (0, $cWCsL.default)(ClockPointer, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, hasSelected = _this$props2.hasSelected;
                return (0, $J42oT.createElement)("div", {
                    style: this.getAngleStyle(),
                    className: (0, $lKxJt.default)(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
                }, (0, $J42oT.createElement)("div", {
                    className: (0, $lKxJt.default)(classes.thumb, hasSelected && classes.noPoint)
                }));
            }
        }
    ]);
    return ClockPointer;
}((0, $J42oT.Component));
$ecc6172bdab98ac9$var$ClockPointer.getDerivedStateFromProps = function(nextProps, state) {
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $ecc6172bdab98ac9$var$styles = function styles(theme) {
    return (0, $ewLWY.default)({
        pointer: {
            width: 2,
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            left: 'calc(50% - 1px)',
            bottom: '50%',
            transformOrigin: 'center bottom 0px'
        },
        animateTransform: {
            transition: theme.transitions.create([
                'transform',
                'height'
            ])
        },
        thumb: {
            width: 4,
            height: 4,
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: '100%',
            position: 'absolute',
            top: -21,
            left: -15,
            border: "14px solid ".concat(theme.palette.primary.main),
            boxSizing: 'content-box'
        },
        noPoint: {
            backgroundColor: theme.palette.primary.main
        }
    });
};
var $ecc6172bdab98ac9$var$ClockPointer$1 = (0, $cV5xs.default)($ecc6172bdab98ac9$var$styles, {
    name: 'MuiPickersClockPointer'
})($ecc6172bdab98ac9$var$ClockPointer);
var $ecc6172bdab98ac9$var$center = {
    x: 130,
    y: 130
};
var $ecc6172bdab98ac9$var$basePoint = {
    x: $ecc6172bdab98ac9$var$center.x,
    y: 0
};
var $ecc6172bdab98ac9$var$cx = $ecc6172bdab98ac9$var$basePoint.x - $ecc6172bdab98ac9$var$center.x;
var $ecc6172bdab98ac9$var$cy = $ecc6172bdab98ac9$var$basePoint.y - $ecc6172bdab98ac9$var$center.y;
var $ecc6172bdab98ac9$var$rad2deg = function rad2deg(rad) {
    return rad * 57.29577951308232;
};
var $ecc6172bdab98ac9$var$getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - $ecc6172bdab98ac9$var$center.x;
    var y = offsetY - $ecc6172bdab98ac9$var$center.y;
    var atan = Math.atan2($ecc6172bdab98ac9$var$cx, $ecc6172bdab98ac9$var$cy) - Math.atan2(x, y);
    var deg = $ecc6172bdab98ac9$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
var $ecc6172bdab98ac9$var$getHours = function getHours(offsetX, offsetY, ampm) {
    var _getAngleValue = $ecc6172bdab98ac9$var$getAngleValue(30, offsetX, offsetY), value = _getAngleValue.value, distance = _getAngleValue.distance;
    value = value || 12;
    if (!ampm) {
        if (distance < 90) {
            value += 12;
            value %= 24;
        }
    } else value %= 12;
    return value;
};
var $ecc6172bdab98ac9$var$getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;
    var _getAngleValue2 = $ecc6172bdab98ac9$var$getAngleValue(angleStep, offsetX, offsetY), value = _getAngleValue2.value;
    value = value * step % 60;
    return value;
};
var $ecc6172bdab98ac9$export$39b482c5e57630a8 = function getMeridiem(date, utils) {
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var $ecc6172bdab98ac9$export$db3b6bfb95261072 = function convertToMeridiem(time, meridiem, ampm, utils) {
    if (ampm) {
        var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) {
            var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
            return utils.setHours(time, hours);
        }
    }
    return time;
};
var $ecc6172bdab98ac9$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $hIvGi.default)(Clock, _React$Component);
    function Clock() {
        var _getPrototypeOf2;
        var _this;
        (0, $lfYGa.default)(this, Clock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $42JcH.default)(this, (_getPrototypeOf2 = (0, $1h73G.default)(Clock)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.isMoving = false;
        _this.handleTouchMove = function(e) {
            _this.isMoving = true;
            _this.setTime(e);
        };
        _this.handleTouchEnd = function(e) {
            if (_this.isMoving) {
                _this.setTime(e, true);
                _this.isMoving = false;
            }
        };
        _this.handleMove = function(e) {
            e.preventDefault();
            e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
            var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
            if (isButtonPressed) _this.setTime(e.nativeEvent, false);
        };
        _this.handleMouseUp = function(e) {
            if (_this.isMoving) _this.isMoving = false;
            _this.setTime(e.nativeEvent, true);
        };
        _this.hasSelected = function() {
            var _this$props = _this.props, type = _this$props.type, value = _this$props.value;
            if (type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.HOURS) return true;
            return value % 5 === 0;
        };
        return _this;
    }
    (0, $cWCsL.default)(Clock, [
        {
            key: "setTime",
            value: function setTime(e) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var offsetX = e.offsetX, offsetY = e.offsetY;
                if (typeof offsetX === 'undefined') {
                    var rect = e.target.getBoundingClientRect();
                    offsetX = e.changedTouches[0].clientX - rect.left;
                    offsetY = e.changedTouches[0].clientY - rect.top;
                }
                var value = this.props.type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.SECONDS || this.props.type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.MINUTES ? $ecc6172bdab98ac9$var$getMinutes(offsetX, offsetY, this.props.minutesStep) : $ecc6172bdab98ac9$var$getHours(offsetX, offsetY, Boolean(this.props.ampm));
                this.props.onChange(value, isFinish);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, value = _this$props2.value, children = _this$props2.children, type = _this$props2.type, ampm = _this$props2.ampm;
                var isPointerInner = !ampm && type === $ecc6172bdab98ac9$export$8b22cf2602fb60ce.HOURS && (value < 1 || value > 12);
                return (0, $J42oT.createElement)("div", {
                    className: classes.container
                }, (0, $J42oT.createElement)("div", {
                    className: classes.clock
                }, (0, $J42oT.createElement)("div", {
                    role: "menu",
                    tabIndex: -1,
                    className: classes.squareMask,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    onMouseUp: this.handleMouseUp,
                    onMouseMove: this.handleMove
                }), (0, $J42oT.createElement)("div", {
                    className: classes.pin
                }), (0, $J42oT.createElement)($ecc6172bdab98ac9$var$ClockPointer$1, {
                    type: type,
                    value: value,
                    isInner: isPointerInner,
                    hasSelected: this.hasSelected()
                }), children));
            }
        }
    ]);
    return Clock;
}((0, $J42oT.Component));
$ecc6172bdab98ac9$export$e7094788287c5e9b.propTypes = {
    type: (0, $fcOLE.oneOf)(Object.keys($ecc6172bdab98ac9$export$8b22cf2602fb60ce).map(function(key) {
        return $ecc6172bdab98ac9$export$8b22cf2602fb60ce[key];
    })).isRequired,
    value: (0, $fcOLE.number).isRequired,
    onChange: (0, $fcOLE.func).isRequired,
    children: (0, $fcOLE.arrayOf)((0, $fcOLE.node)).isRequired,
    ampm: (0, $fcOLE.bool),
    minutesStep: (0, $fcOLE.number),
    innerRef: (0, $fcOLE.any)
};
$ecc6172bdab98ac9$export$e7094788287c5e9b.defaultProps = {
    ampm: false,
    minutesStep: 1
};
var $ecc6172bdab98ac9$export$2408f22a0fab9ae5 = function styles(theme) {
    return (0, $ewLWY.default)({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
        },
        clock: {
            backgroundColor: 'rgba(0,0,0,.07)',
            borderRadius: '50%',
            height: 260,
            width: 260,
            position: 'relative',
            pointerEvents: 'none'
        },
        squareMask: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            pointerEvents: 'auto',
            outline: 'none',
            touchActions: 'none',
            userSelect: 'none',
            '&:active': {
                cursor: 'move'
            }
        },
        pin: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    });
};
var $ecc6172bdab98ac9$export$407448d2b89b1813 = (0, $cV5xs.default)($ecc6172bdab98ac9$export$2408f22a0fab9ae5, {
    name: 'MuiPickersClock'
})($ecc6172bdab98ac9$export$e7094788287c5e9b);

});





parcelRegister("jY97E", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("jEDhL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4f03a06e77204b4$export$2e2bcd8739ae039);

var $bTlUp = parcelRequire("bTlUp");

var $g1Rs3 = parcelRequire("g1Rs3");

var $e39m1 = parcelRequire("e39m1");

var $k3mQu = parcelRequire("k3mQu");

var $3Zqq2 = parcelRequire("3Zqq2");

var $6Lya9 = parcelRequire("6Lya9");

var $g5H1z = parcelRequire("g5H1z");

var $3atTC = parcelRequire("3atTC");

var $fPOfT = parcelRequire("fPOfT");

var $3JFRf = parcelRequire("3JFRf");

var $ecpxD = parcelRequire("ecpxD");

var $dW6yV = parcelRequire("dW6yV");

var $kacOD = parcelRequire("kacOD");

var $507dH = parcelRequire("507dH");

var $iGgH4 = parcelRequire("iGgH4");

var $9km0R = parcelRequire("9km0R");

var $fdD0d = parcelRequire("fdD0d");

var $bzzhP = parcelRequire("bzzhP");

var $8Y7EG = parcelRequire("8Y7EG");

var $fiXUF = parcelRequire("fiXUF");

var $eg1ZQ = parcelRequire("eg1ZQ");

var $15IWz = parcelRequire("15IWz");

var $d3Z4S = parcelRequire("d3Z4S");

var $kSVJ9 = parcelRequire("kSVJ9");

var $fMl8C = parcelRequire("fMl8C");

var $hdPFj = parcelRequire("hdPFj");

var $4ew6s = parcelRequire("4ew6s");

var $fSMd3 = parcelRequire("fSMd3");

var $gLQiv = parcelRequire("gLQiv");

var $3gBpT = parcelRequire("3gBpT");

var $gX301 = parcelRequire("gX301");
var $e4f03a06e77204b4$var$DateFnsUtils = /** @class */ function() {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function(value, count) {
        return (0, $bTlUp.default)(value, count);
    };
    DateFnsUtils.prototype.isValid = function(value) {
        return (0, $fiXUF.default)(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function(value, comparing) {
        return (0, $k3mQu.default)(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function(value, comparing) {
        return (0, $kacOD.default)(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function(value, comparing) {
        return (0, $507dH.default)(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function(value) {
        return (0, $4ew6s.default)(value);
    };
    DateFnsUtils.prototype.endOfDay = function(value) {
        return (0, $6Lya9.default)(value);
    };
    DateFnsUtils.prototype.getHours = function(value) {
        return (0, $3JFRf.default)(value);
    };
    DateFnsUtils.prototype.setHours = function(value, count) {
        return (0, $15IWz.default)(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function(value, count) {
        return (0, $d3Z4S.default)(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function(value) {
        return (0, $ecpxD.default)(value);
    };
    DateFnsUtils.prototype.setSeconds = function(value, count) {
        return (0, $fMl8C.default)(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function(value, comparing) {
        return (0, $9km0R.default)(value, comparing);
    };
    DateFnsUtils.prototype.isSameMonth = function(value, comparing) {
        return (0, $bzzhP.default)(value, comparing);
    };
    DateFnsUtils.prototype.isSameYear = function(value, comparing) {
        return (0, $fdD0d.default)(value, comparing);
    };
    DateFnsUtils.prototype.isSameHour = function(value, comparing) {
        return (0, $8Y7EG.default)(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function(value) {
        return (0, $fSMd3.default)(value);
    };
    DateFnsUtils.prototype.endOfMonth = function(value) {
        return (0, $gLQiv.default)(value);
    };
    DateFnsUtils.prototype.getYear = function(value) {
        return (0, $dW6yV.default)(value);
    };
    DateFnsUtils.prototype.setYear = function(value, count) {
        return (0, $hdPFj.default)(value, count);
    };
    DateFnsUtils.prototype.date = function(value) {
        if (typeof value === "undefined") return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function(value, formatString) {
        if (value === "") return null;
        return (0, $eg1ZQ.default)(value, formatString, new Date(), {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.format = function(date, formatString) {
        return (0, $fPOfT.default)(date, formatString, {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.isEqual = function(date, comparing) {
        if (date === null && comparing === null) return true;
        return (0, $iGgH4.default)(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function(date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function(date, value) {
        return (0, $kacOD.default)(date, (0, $6Lya9.default)(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function(date, value) {
        return (0, $507dH.default)(date, (0, $4ew6s.default)(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function(date, value) {
        return (0, $507dH.default)(date, (0, $gX301.default)(value));
    };
    DateFnsUtils.prototype.isAfterYear = function(date, value) {
        return (0, $kacOD.default)(date, (0, $3atTC.default)(value));
    };
    DateFnsUtils.prototype.formatNumber = function(numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function(date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function(date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function(date, count) {
        return (0, $kSVJ9.default)(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function(ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function(date) {
        return (0, $g1Rs3.default)(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function(date) {
        return (0, $g1Rs3.default)(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function(date) {
        var firstMonth = (0, $gX301.default)(date);
        var monthArray = [
            firstMonth
        ];
        while(monthArray.length < 12){
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function(date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function() {
        var _this = this;
        var now = new Date();
        return (0, $3Zqq2.default)({
            start: (0, $3gBpT.default)(now, {
                locale: this.locale
            }),
            end: (0, $g5H1z.default)(now, {
                locale: this.locale
            })
        }).map(function(day) {
            return _this.format(day, "EEEEEE");
        });
    };
    DateFnsUtils.prototype.getWeekArray = function(date) {
        var start = (0, $3gBpT.default)((0, $fSMd3.default)(date), {
            locale: this.locale
        });
        var end = (0, $g5H1z.default)((0, $gLQiv.default)(date), {
            locale: this.locale
        });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while((0, $507dH.default)(current, end)){
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = (0, $bTlUp.default)(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function(start, end) {
        var startDate = (0, $gX301.default)(start);
        var endDate = (0, $3atTC.default)(end);
        var years = [];
        var current = startDate;
        while((0, $507dH.default)(current, endDate)){
            years.push(current);
            current = (0, $e39m1.default)(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function(date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function(date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function(date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function(date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function(date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function(date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function(date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function(date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function(date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}();
var $e4f03a06e77204b4$export$2e2bcd8739ae039 = $e4f03a06e77204b4$var$DateFnsUtils;

});
parcelRegister("bTlUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a85d363055595e7$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $8a85d363055595e7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var amount = (0, $8xes0.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("8xes0", function(module, exports) {

$parcel$export(module.exports, "default", () => $636c9d69c7fed6d0$export$2e2bcd8739ae039);
function $636c9d69c7fed6d0$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("ePYBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd4d6868741f9d7$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $nKVN9 = parcelRequire("nKVN9");
function $acd4d6868741f9d7$export$2e2bcd8739ae039(argument) {
    (0, $nKVN9.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $5z6Dx.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("nKVN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $04768da424899c75$export$2e2bcd8739ae039);
function $04768da424899c75$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});



parcelRegister("g1Rs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab633aeec32a9a3$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $bab633aeec32a9a3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var amount = (0, $8xes0.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("e39m1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a89a0c79629fb0$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $g1Rs3 = parcelRequire("g1Rs3");

var $nKVN9 = parcelRequire("nKVN9");
function $a3a89a0c79629fb0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $nKVN9.default)(2, arguments);
    var amount = (0, $8xes0.default)(dirtyAmount);
    return (0, $g1Rs3.default)(dirtyDate, amount * 12);
}

});

parcelRegister("k3mQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e995cf2191ef0ddb$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $e995cf2191ef0ddb$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $nKVN9.default)(2, arguments);
    return (0, $ePYBq.default)(dateLeft).getTime() - (0, $ePYBq.default)(dateRight).getTime();
}

});

parcelRegister("3Zqq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e7b8fdccfe85263$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $2e7b8fdccfe85263$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $nKVN9.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $ePYBq.default)(interval.start);
    var endDate = (0, $ePYBq.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $ePYBq.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("6Lya9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed1a1db8fd89c69$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $4ed1a1db8fd89c69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("g5H1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6e7cb6e18b92a8$export$2e2bcd8739ae039);

var $9FGZ0 = parcelRequire("9FGZ0");

var $ePYBq = parcelRequire("ePYBq");

var $8xes0 = parcelRequire("8xes0");

var $nKVN9 = parcelRequire("nKVN9");
function $bb6e7cb6e18b92a8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(1, arguments);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var weekStartsOn = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $ePYBq.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("9FGZ0", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $70a948ec8e475d27$export$430a3269e24b912e);
var $70a948ec8e475d27$var$defaultOptions = {};
function $70a948ec8e475d27$export$430a3269e24b912e() {
    return $70a948ec8e475d27$var$defaultOptions;
}
function $70a948ec8e475d27$export$95365be1b0704abc(newOptions) {
    $70a948ec8e475d27$var$defaultOptions = newOptions;
}

});


parcelRegister("3atTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $24e97f0262636f0e$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $24e97f0262636f0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("fPOfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f99721785c1c82$export$2e2bcd8739ae039);

var $fiXUF = parcelRequire("fiXUF");

var $2DmxP = parcelRequire("2DmxP");

var $ePYBq = parcelRequire("ePYBq");

var $7fqST = parcelRequire("7fqST");

var $gpUTD = parcelRequire("gpUTD");

var $eHquE = parcelRequire("eHquE");

var $eLBIe = parcelRequire("eLBIe");

var $8xes0 = parcelRequire("8xes0");

var $nKVN9 = parcelRequire("nKVN9");

var $9FGZ0 = parcelRequire("9FGZ0");

var $88s9N = parcelRequire("88s9N");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $02f99721785c1c82$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $02f99721785c1c82$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $02f99721785c1c82$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $02f99721785c1c82$var$doubleQuoteRegExp = /''/g;
var $02f99721785c1c82$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $02f99721785c1c82$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $nKVN9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $88s9N.default);
    var firstWeekContainsDate = (0, $8xes0.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8xes0.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $ePYBq.default)(dirtyDate);
    if (!(0, $fiXUF.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $eHquE.default)(originalDate);
    var utcDate = (0, $2DmxP.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($02f99721785c1c82$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $gpUTD.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($02f99721785c1c82$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $02f99721785c1c82$var$cleanEscapedString(substring);
        var formatter = (0, $7fqST.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eLBIe.isProtectedWeekYearToken)(substring)) (0, $eLBIe.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eLBIe.isProtectedDayOfYearToken)(substring)) (0, $eLBIe.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($02f99721785c1c82$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $02f99721785c1c82$var$cleanEscapedString(input) {
    var matched = input.match($02f99721785c1c82$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($02f99721785c1c82$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("fiXUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b24702ec0b277533$export$2e2bcd8739ae039);

var $gRVK2 = parcelRequire("gRVK2");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $b24702ec0b277533$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    if (!(0, $gRVK2.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $ePYBq.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("gRVK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47e62de866c01e4$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $nKVN9 = parcelRequire("nKVN9");
function $c47e62de866c01e4$export$2e2bcd8739ae039(value) {
    (0, $nKVN9.default)(1, arguments);
    return value instanceof Date || (0, $5z6Dx.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("2DmxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb0b62a3cf150c8$export$2e2bcd8739ae039);

var $fayze = parcelRequire("fayze");

var $nKVN9 = parcelRequire("nKVN9");

var $8xes0 = parcelRequire("8xes0");
function $1eb0b62a3cf150c8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $nKVN9.default)(2, arguments);
    var amount = (0, $8xes0.default)(dirtyAmount);
    return (0, $fayze.default)(dirtyDate, -amount);
}

});
parcelRegister("fayze", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b29a8af61acfb7$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $b0b29a8af61acfb7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $nKVN9.default)(2, arguments);
    var timestamp = (0, $ePYBq.default)(dirtyDate).getTime();
    var amount = (0, $8xes0.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("7fqST", function(module, exports) {

$parcel$export(module.exports, "default", () => $546ec9d0d5fd023b$export$2e2bcd8739ae039);

var $fcKF7 = parcelRequire("fcKF7");

var $ho43J = parcelRequire("ho43J");

var $abmvT = parcelRequire("abmvT");

var $2MGiB = parcelRequire("2MGiB");

var $gCwGq = parcelRequire("gCwGq");

var $3phrF = parcelRequire("3phrF");

var $bZI8A = parcelRequire("bZI8A");
var $546ec9d0d5fd023b$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $546ec9d0d5fd023b$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $bZI8A.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $gCwGq.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $3phrF.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $3phrF.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $abmvT.default)(date);
        // Padding
        return (0, $3phrF.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $3phrF.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $3phrF.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $3phrF.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $bZI8A.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $3phrF.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $2MGiB.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $3phrF.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $ho43J.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $3phrF.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $bZI8A.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $fcKF7.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $3phrF.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $3phrF.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $3phrF.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $3phrF.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $546ec9d0d5fd023b$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $bZI8A.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $bZI8A.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $3phrF.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $3phrF.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $bZI8A.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $bZI8A.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $bZI8A.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $546ec9d0d5fd023b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $546ec9d0d5fd023b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $546ec9d0d5fd023b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $546ec9d0d5fd023b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $546ec9d0d5fd023b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $3phrF.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $3phrF.default)(timestamp, token.length);
    }
};
function $546ec9d0d5fd023b$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $3phrF.default)(minutes, 2);
}
function $546ec9d0d5fd023b$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $3phrF.default)(Math.abs(offset) / 60, 2);
    }
    return $546ec9d0d5fd023b$var$formatTimezone(offset, dirtyDelimiter);
}
function $546ec9d0d5fd023b$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $3phrF.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $3phrF.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $546ec9d0d5fd023b$export$2e2bcd8739ae039 = $546ec9d0d5fd023b$var$formatters;

});
parcelRegister("fcKF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b11c2c2c0e46bab9$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
var $b11c2c2c0e46bab9$var$MILLISECONDS_IN_DAY = 86400000;
function $b11c2c2c0e46bab9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $b11c2c2c0e46bab9$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("ho43J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca87d39cea0709a6$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $56GQx = parcelRequire("56GQx");

var $47VJC = parcelRequire("47VJC");

var $nKVN9 = parcelRequire("nKVN9");
var $ca87d39cea0709a6$var$MILLISECONDS_IN_WEEK = 604800000;
function $ca87d39cea0709a6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var diff = (0, $56GQx.default)(date).getTime() - (0, $47VJC.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ca87d39cea0709a6$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("56GQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7ebfaccaacbeee$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $3b7ebfaccaacbeee$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $ePYBq.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("47VJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $301499ccc5936620$export$2e2bcd8739ae039);

var $abmvT = parcelRequire("abmvT");

var $56GQx = parcelRequire("56GQx");

var $nKVN9 = parcelRequire("nKVN9");
function $301499ccc5936620$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var year = (0, $abmvT.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $56GQx.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("abmvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $769c652b453373c4$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");

var $56GQx = parcelRequire("56GQx");
function $769c652b453373c4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $56GQx.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $56GQx.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("2MGiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2070e026c7358208$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $4fO8T = parcelRequire("4fO8T");

var $fy6V6 = parcelRequire("fy6V6");

var $nKVN9 = parcelRequire("nKVN9");
var $2070e026c7358208$var$MILLISECONDS_IN_WEEK = 604800000;
function $2070e026c7358208$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var diff = (0, $4fO8T.default)(date, options).getTime() - (0, $fy6V6.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2070e026c7358208$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("4fO8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $318f7563cb6b84f4$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");

var $8xes0 = parcelRequire("8xes0");

var $9FGZ0 = parcelRequire("9FGZ0");
function $318f7563cb6b84f4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(1, arguments);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var weekStartsOn = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $ePYBq.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("fy6V6", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ebdc7c97c124d9$export$2e2bcd8739ae039);

var $gCwGq = parcelRequire("gCwGq");

var $nKVN9 = parcelRequire("nKVN9");

var $4fO8T = parcelRequire("4fO8T");

var $8xes0 = parcelRequire("8xes0");

var $9FGZ0 = parcelRequire("9FGZ0");
function $02ebdc7c97c124d9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(1, arguments);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $gCwGq.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $4fO8T.default)(firstWeek, options);
    return date;
}

});
parcelRegister("gCwGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1998c278cb4c194$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");

var $4fO8T = parcelRequire("4fO8T");

var $8xes0 = parcelRequire("8xes0");

var $9FGZ0 = parcelRequire("9FGZ0");
function $c1998c278cb4c194$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4fO8T.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4fO8T.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("3phrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b13d2bfb5db4ae$export$2e2bcd8739ae039);
function $27b13d2bfb5db4ae$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("bZI8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb7a1014e3906f4$export$2e2bcd8739ae039);

var $3phrF = parcelRequire("3phrF");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8bb7a1014e3906f4$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3phrF.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $3phrF.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $3phrF.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $3phrF.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $3phrF.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $3phrF.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $3phrF.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3phrF.default)(fractionalSeconds, token.length);
    }
};
var $8bb7a1014e3906f4$export$2e2bcd8739ae039 = $8bb7a1014e3906f4$var$formatters;

});


parcelRegister("gpUTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf3b1d96a448ac37$export$2e2bcd8739ae039);
var $bf3b1d96a448ac37$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $bf3b1d96a448ac37$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $bf3b1d96a448ac37$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $bf3b1d96a448ac37$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $bf3b1d96a448ac37$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $bf3b1d96a448ac37$var$timeLongFormatter(timePattern, formatLong));
};
var $bf3b1d96a448ac37$var$longFormatters = {
    p: $bf3b1d96a448ac37$var$timeLongFormatter,
    P: $bf3b1d96a448ac37$var$dateTimeLongFormatter
};
var $bf3b1d96a448ac37$export$2e2bcd8739ae039 = $bf3b1d96a448ac37$var$longFormatters;

});

parcelRegister("eHquE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab39a1e412a87e21$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $ab39a1e412a87e21$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("eLBIe", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $ac02b55f90b8223d$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $ac02b55f90b8223d$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $ac02b55f90b8223d$export$8073c1ae88f0e727);
var $ac02b55f90b8223d$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $ac02b55f90b8223d$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $ac02b55f90b8223d$export$c6cc36aa33304772(token) {
    return $ac02b55f90b8223d$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $ac02b55f90b8223d$export$c6b49d6dceb604a1(token) {
    return $ac02b55f90b8223d$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $ac02b55f90b8223d$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("88s9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ec4e978e62ec50e$export$2e2bcd8739ae039);

var $cZZR6 = parcelRequire("cZZR6");
var $5ec4e978e62ec50e$export$2e2bcd8739ae039 = (0, $cZZR6.default);

});
parcelRegister("cZZR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $976b29c6922d383e$export$2e2bcd8739ae039);

var $7BQ9I = parcelRequire("7BQ9I");

var $63kOj = parcelRequire("63kOj");

var $bNU0Y = parcelRequire("bNU0Y");

var $i8dMY = parcelRequire("i8dMY");

var $3EtiF = parcelRequire("3EtiF");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $976b29c6922d383e$var$locale = {
    code: 'en-US',
    formatDistance: (0, $7BQ9I.default),
    formatLong: (0, $63kOj.default),
    formatRelative: (0, $bNU0Y.default),
    localize: (0, $i8dMY.default),
    match: (0, $3EtiF.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $976b29c6922d383e$export$2e2bcd8739ae039 = $976b29c6922d383e$var$locale;

});
parcelRegister("7BQ9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a4722179b029bc$export$2e2bcd8739ae039);
var $58a4722179b029bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $58a4722179b029bc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $58a4722179b029bc$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $58a4722179b029bc$export$2e2bcd8739ae039 = $58a4722179b029bc$var$formatDistance;

});

parcelRegister("63kOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $46832a6df1903724$export$2e2bcd8739ae039);

var $iW7NX = parcelRequire("iW7NX");
var $46832a6df1903724$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $46832a6df1903724$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $46832a6df1903724$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $46832a6df1903724$var$formatLong = {
    date: (0, $iW7NX.default)({
        formats: $46832a6df1903724$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $iW7NX.default)({
        formats: $46832a6df1903724$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $iW7NX.default)({
        formats: $46832a6df1903724$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $46832a6df1903724$export$2e2bcd8739ae039 = $46832a6df1903724$var$formatLong;

});
parcelRegister("iW7NX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc93b2a8fa70601f$export$2e2bcd8739ae039);
function $dc93b2a8fa70601f$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("bNU0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $897fb8a7ae7b7221$export$2e2bcd8739ae039);
var $897fb8a7ae7b7221$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $897fb8a7ae7b7221$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $897fb8a7ae7b7221$var$formatRelativeLocale[token];
};
var $897fb8a7ae7b7221$export$2e2bcd8739ae039 = $897fb8a7ae7b7221$var$formatRelative;

});

parcelRegister("i8dMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d333ab87e26ab18b$export$2e2bcd8739ae039);

var $i5Usp = parcelRequire("i5Usp");
var $d333ab87e26ab18b$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $d333ab87e26ab18b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d333ab87e26ab18b$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $d333ab87e26ab18b$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $d333ab87e26ab18b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $d333ab87e26ab18b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $d333ab87e26ab18b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $d333ab87e26ab18b$var$localize = {
    ordinalNumber: $d333ab87e26ab18b$var$ordinalNumber,
    era: (0, $i5Usp.default)({
        values: $d333ab87e26ab18b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $i5Usp.default)({
        values: $d333ab87e26ab18b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $i5Usp.default)({
        values: $d333ab87e26ab18b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $i5Usp.default)({
        values: $d333ab87e26ab18b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $i5Usp.default)({
        values: $d333ab87e26ab18b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d333ab87e26ab18b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d333ab87e26ab18b$export$2e2bcd8739ae039 = $d333ab87e26ab18b$var$localize;

});
parcelRegister("i5Usp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c47cd7cb2d3e9d$export$2e2bcd8739ae039);
function $d2c47cd7cb2d3e9d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("3EtiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8bd5ee1e051071$export$2e2bcd8739ae039);

var $ivWG8 = parcelRequire("ivWG8");

var $1JED0 = parcelRequire("1JED0");
var $2a8bd5ee1e051071$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2a8bd5ee1e051071$var$parseOrdinalNumberPattern = /\d+/i;
var $2a8bd5ee1e051071$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2a8bd5ee1e051071$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2a8bd5ee1e051071$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2a8bd5ee1e051071$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2a8bd5ee1e051071$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2a8bd5ee1e051071$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2a8bd5ee1e051071$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2a8bd5ee1e051071$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2a8bd5ee1e051071$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2a8bd5ee1e051071$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2a8bd5ee1e051071$var$match = {
    ordinalNumber: (0, $1JED0.default)({
        matchPattern: $2a8bd5ee1e051071$var$matchOrdinalNumberPattern,
        parsePattern: $2a8bd5ee1e051071$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ivWG8.default)({
        matchPatterns: $2a8bd5ee1e051071$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a8bd5ee1e051071$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ivWG8.default)({
        matchPatterns: $2a8bd5ee1e051071$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a8bd5ee1e051071$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ivWG8.default)({
        matchPatterns: $2a8bd5ee1e051071$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a8bd5ee1e051071$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ivWG8.default)({
        matchPatterns: $2a8bd5ee1e051071$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a8bd5ee1e051071$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ivWG8.default)({
        matchPatterns: $2a8bd5ee1e051071$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2a8bd5ee1e051071$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2a8bd5ee1e051071$export$2e2bcd8739ae039 = $2a8bd5ee1e051071$var$match;

});
parcelRegister("ivWG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a8a3960c7293d1$export$2e2bcd8739ae039);
function $d7a8a3960c7293d1$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d7a8a3960c7293d1$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d7a8a3960c7293d1$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d7a8a3960c7293d1$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d7a8a3960c7293d1$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("1JED0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1439825227a20577$export$2e2bcd8739ae039);
function $1439825227a20577$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("3JFRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b860b2bda5652ba$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $2b860b2bda5652ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("ecpxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a565ffad58d47ee3$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $a565ffad58d47ee3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("dW6yV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a255c84e45698040$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $a255c84e45698040$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    return (0, $ePYBq.default)(dirtyDate).getFullYear();
}

});

parcelRegister("kacOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eadeaebb412bd397$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $eadeaebb412bd397$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var dateToCompare = (0, $ePYBq.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("507dH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a428d8c048e6aa4$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $3a428d8c048e6aa4$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var dateToCompare = (0, $ePYBq.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("iGgH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9991942df206337$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $d9991942df206337$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $nKVN9.default)(2, arguments);
    var dateLeft = (0, $ePYBq.default)(dirtyLeftDate);
    var dateRight = (0, $ePYBq.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("9km0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca70e9d7dd10e96$export$2e2bcd8739ae039);

var $4ew6s = parcelRequire("4ew6s");

var $nKVN9 = parcelRequire("nKVN9");
function $6ca70e9d7dd10e96$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $nKVN9.default)(2, arguments);
    var dateLeftStartOfDay = (0, $4ew6s.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $4ew6s.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});
parcelRegister("4ew6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $31515f40494b52c8$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $31515f40494b52c8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("fdD0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14652faf7a92c7b$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $b14652faf7a92c7b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $nKVN9.default)(2, arguments);
    var dateLeft = (0, $ePYBq.default)(dirtyDateLeft);
    var dateRight = (0, $ePYBq.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("bzzhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ce55c55286d778$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $86ce55c55286d778$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $nKVN9.default)(2, arguments);
    var dateLeft = (0, $ePYBq.default)(dirtyDateLeft);
    var dateRight = (0, $ePYBq.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("8Y7EG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6879dd80c003f11f$export$2e2bcd8739ae039);

var $7wgAV = parcelRequire("7wgAV");

var $nKVN9 = parcelRequire("nKVN9");
function $6879dd80c003f11f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $nKVN9.default)(2, arguments);
    var dateLeftStartOfHour = (0, $7wgAV.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $7wgAV.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

});
parcelRegister("7wgAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $579864e6686394fb$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $579864e6686394fb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

});


parcelRegister("eg1ZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6141bc596efd56c$export$2e2bcd8739ae039);

var $5z6Dx = parcelRequire("5z6Dx");

var $bfRlw = parcelRequire("bfRlw");

var $88s9N = parcelRequire("88s9N");

var $2DmxP = parcelRequire("2DmxP");

var $ePYBq = parcelRequire("ePYBq");

var $2k66e = parcelRequire("2k66e");

var $gpUTD = parcelRequire("gpUTD");

var $eHquE = parcelRequire("eHquE");

var $eLBIe = parcelRequire("eLBIe");

var $8xes0 = parcelRequire("8xes0");

var $nKVN9 = parcelRequire("nKVN9");

var $1NfhH = parcelRequire("1NfhH");

var $cz9m8 = parcelRequire("cz9m8");

var $9FGZ0 = parcelRequire("9FGZ0");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a6141bc596efd56c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a6141bc596efd56c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a6141bc596efd56c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a6141bc596efd56c$var$doubleQuoteRegExp = /''/g;
var $a6141bc596efd56c$var$notWhitespaceRegExp = /\S/;
var $a6141bc596efd56c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a6141bc596efd56c$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $nKVN9.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $88s9N.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $8xes0.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8xes0.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $ePYBq.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $1NfhH.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($a6141bc596efd56c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $gpUTD.default)) {
            var longFormatter = (0, $gpUTD.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a6141bc596efd56c$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $bfRlw.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eLBIe.isProtectedWeekYearToken)(token)) (0, $eLBIe.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eLBIe.isProtectedDayOfYearToken)(token)) (0, $eLBIe.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $cz9m8.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($a6141bc596efd56c$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $a6141bc596efd56c$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $5z6Dx.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $a6141bc596efd56c$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $ePYBq.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $2DmxP.default)(date, (0, $eHquE.default)(date));
    var flags = {};
    var _iterator2 = (0, $bfRlw.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $2k66e.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $a6141bc596efd56c$var$cleanEscapedString(input) {
    return input.match($a6141bc596efd56c$var$escapedStringRegExp)[1].replace($a6141bc596efd56c$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("bfRlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $831a79dfec5f391f$export$2e2bcd8739ae039);

var $3bQlz = parcelRequire("3bQlz");
function $831a79dfec5f391f$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $3bQlz.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});

parcelRegister("2k66e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b122e43de1a13e7$export$2e2bcd8739ae039);
function $1b122e43de1a13e7$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("1NfhH", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $14e6393b85e973ae$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $14e6393b85e973ae$export$5aaf7ff7f09ea4ee);

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $6JmtS = parcelRequire("6JmtS");
var $14e6393b85e973ae$var$TIMEZONE_UNIT_PRIORITY = 10;
var $14e6393b85e973ae$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $lfYGa.default)(this, Setter);
        (0, $6JmtS.default)(this, "priority", void 0);
        (0, $6JmtS.default)(this, "subPriority", 0);
    }
    (0, $cWCsL.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $14e6393b85e973ae$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $hIvGi.default)(ValueSetter, _Setter);
    var _super = (0, $iGrZN.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $lfYGa.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $cWCsL.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($14e6393b85e973ae$export$81d53e3678089a6);
var $14e6393b85e973ae$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $hIvGi.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $iGrZN.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $lfYGa.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this2), "priority", $14e6393b85e973ae$var$TIMEZONE_UNIT_PRIORITY);
        (0, $6JmtS.default)((0, $5h49q.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $cWCsL.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($14e6393b85e973ae$export$81d53e3678089a6);

});
parcelRegister("iGrZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a1dd9f1c101c7c$export$2e2bcd8739ae039);

var $1h73G = parcelRequire("1h73G");

var $gKGbk = parcelRequire("gKGbk");

var $42JcH = parcelRequire("42JcH");
function $d9a1dd9f1c101c7c$export$2e2bcd8739ae039(t) {
    var r = (0, $gKGbk.default)();
    return function() {
        var e, o = (0, $1h73G.default)(t);
        if (r) {
            var s = (0, $1h73G.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $42JcH.default)(this, e);
    };
}

});
parcelRegister("gKGbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c321a9a529be1fba$export$2e2bcd8739ae039);
function $c321a9a529be1fba$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c321a9a529be1fba$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});



parcelRegister("cz9m8", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $926002d9fcc808ec$export$19131010e7fd8373);

var $7QE2y = parcelRequire("7QE2y");

var $5AaDS = parcelRequire("5AaDS");

var $j2Jxx = parcelRequire("j2Jxx");

var $auWky = parcelRequire("auWky");

var $eVmwA = parcelRequire("eVmwA");

var $6giZ6 = parcelRequire("6giZ6");

var $jKqja = parcelRequire("jKqja");

var $jM2mL = parcelRequire("jM2mL");

var $8cF1n = parcelRequire("8cF1n");

var $hr9nE = parcelRequire("hr9nE");

var $jnOtq = parcelRequire("jnOtq");

var $5wKwe = parcelRequire("5wKwe");

var $blt2Y = parcelRequire("blt2Y");

var $dB62W = parcelRequire("dB62W");

var $d218V = parcelRequire("d218V");

var $cAibd = parcelRequire("cAibd");

var $6Mf2q = parcelRequire("6Mf2q");

var $4tuoa = parcelRequire("4tuoa");

var $bXZKZ = parcelRequire("bXZKZ");

var $gRZAp = parcelRequire("gRZAp");

var $1uHO4 = parcelRequire("1uHO4");

var $dzWYh = parcelRequire("dzWYh");

var $efmiD = parcelRequire("efmiD");

var $6Mq63 = parcelRequire("6Mq63");

var $fpyMF = parcelRequire("fpyMF");

var $gKVo5 = parcelRequire("gKVo5");

var $bxKpk = parcelRequire("bxKpk");

var $7zwOS = parcelRequire("7zwOS");

var $h6z2R = parcelRequire("h6z2R");

var $du5mE = parcelRequire("du5mE");

var $5gwto = parcelRequire("5gwto");
var $926002d9fcc808ec$export$19131010e7fd8373 = {
    G: new (0, $7QE2y.EraParser)(),
    y: new (0, $5AaDS.YearParser)(),
    Y: new (0, $j2Jxx.LocalWeekYearParser)(),
    R: new (0, $auWky.ISOWeekYearParser)(),
    u: new (0, $eVmwA.ExtendedYearParser)(),
    Q: new (0, $6giZ6.QuarterParser)(),
    q: new (0, $jKqja.StandAloneQuarterParser)(),
    M: new (0, $jM2mL.MonthParser)(),
    L: new (0, $8cF1n.StandAloneMonthParser)(),
    w: new (0, $hr9nE.LocalWeekParser)(),
    I: new (0, $jnOtq.ISOWeekParser)(),
    d: new (0, $5wKwe.DateParser)(),
    D: new (0, $blt2Y.DayOfYearParser)(),
    E: new (0, $dB62W.DayParser)(),
    e: new (0, $d218V.LocalDayParser)(),
    c: new (0, $cAibd.StandAloneLocalDayParser)(),
    i: new (0, $6Mf2q.ISODayParser)(),
    a: new (0, $4tuoa.AMPMParser)(),
    b: new (0, $bXZKZ.AMPMMidnightParser)(),
    B: new (0, $gRZAp.DayPeriodParser)(),
    h: new (0, $1uHO4.Hour1to12Parser)(),
    H: new (0, $dzWYh.Hour0to23Parser)(),
    K: new (0, $efmiD.Hour0To11Parser)(),
    k: new (0, $6Mq63.Hour1To24Parser)(),
    m: new (0, $fpyMF.MinuteParser)(),
    s: new (0, $gKVo5.SecondParser)(),
    S: new (0, $bxKpk.FractionOfSecondParser)(),
    X: new (0, $7zwOS.ISOTimezoneWithZParser)(),
    x: new (0, $h6z2R.ISOTimezoneParser)(),
    t: new (0, $du5mE.TimestampSecondsParser)(),
    T: new (0, $5gwto.TimestampMillisecondsParser)()
};

});
parcelRegister("7QE2y", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $5b6c72e42f864af2$export$8e5a1d3f85a9688);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");
var $5b6c72e42f864af2$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(EraParser, _Parser);
    var _super = (0, $iGrZN.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $lfYGa.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 140);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("4Wz2Y", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $3997c3cb21ea9fd1$export$7acfa6ed01010e37);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $6JmtS = parcelRequire("6JmtS");

var $1NfhH = parcelRequire("1NfhH");
var $3997c3cb21ea9fd1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $lfYGa.default)(this, Parser);
        (0, $6JmtS.default)(this, "incompatibleTokens", void 0);
        (0, $6JmtS.default)(this, "priority", void 0);
        (0, $6JmtS.default)(this, "subPriority", void 0);
    }
    (0, $cWCsL.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $1NfhH.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("5AaDS", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $010c867b60d42c77$export$48d352de7cd4a988);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $010c867b60d42c77$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(YearParser, _Parser);
    var _super = (0, $iGrZN.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $lfYGa.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 130);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $4k0BJ.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("4k0BJ", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $32598055cea694e3$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $32598055cea694e3$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $32598055cea694e3$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $32598055cea694e3$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $32598055cea694e3$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $32598055cea694e3$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $32598055cea694e3$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $32598055cea694e3$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $32598055cea694e3$export$3d50627710b84d75);

var $lwc0R = parcelRequire("lwc0R");

var $1fxxH = parcelRequire("1fxxH");
function $32598055cea694e3$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $32598055cea694e3$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $32598055cea694e3$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $lwc0R.millisecondsInHour) + minutes * (0, $lwc0R.millisecondsInMinute) + seconds * (0, $lwc0R.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $32598055cea694e3$export$d931c43c4608a164(dateString) {
    return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).anyDigitsSigned, dateString);
}
function $32598055cea694e3$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).singleDigit, dateString);
        case 2:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).twoDigits, dateString);
        case 3:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).threeDigits, dateString);
        case 4:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).fourDigits, dateString);
        default:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $32598055cea694e3$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388((0, $1fxxH.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $32598055cea694e3$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $32598055cea694e3$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $32598055cea694e3$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $32598055cea694e3$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("lwc0R", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $faa5e79e2433c077$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $faa5e79e2433c077$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $faa5e79e2433c077$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $faa5e79e2433c077$export$dfd9b671c89acc8e = 7;
var $faa5e79e2433c077$export$3913210603d8e9ae = 365.2425;
var $faa5e79e2433c077$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $faa5e79e2433c077$export$91246f0b9bd9beff = 60000;
var $faa5e79e2433c077$export$7f72910d6dfd237a = 3600000;
var $faa5e79e2433c077$export$397c2d5776aa9055 = 1000;
var $faa5e79e2433c077$export$4dec998e48f9c246 = -$faa5e79e2433c077$export$81caae6e1cc7a622;
var $faa5e79e2433c077$export$f2f5ae5a8e2d8f9f = 60;
var $faa5e79e2433c077$export$3c58128db900d44e = 3;
var $faa5e79e2433c077$export$80d7e435f744f319 = 12;
var $faa5e79e2433c077$export$4db7641526e3241f = 4;
var $faa5e79e2433c077$export$698aec755e92c695 = 3600;
var $faa5e79e2433c077$export$a77c1a7ebebe2a5a = 60;
var $faa5e79e2433c077$export$815a9362476d2fe3 = $faa5e79e2433c077$export$698aec755e92c695 * 24;
var $faa5e79e2433c077$export$34804a017b31e2fe = $faa5e79e2433c077$export$815a9362476d2fe3 * 7;
var $faa5e79e2433c077$export$7271e9e3478110d1 = $faa5e79e2433c077$export$815a9362476d2fe3 * $faa5e79e2433c077$export$3913210603d8e9ae;
var $faa5e79e2433c077$export$8e6600bbdee7dabb = $faa5e79e2433c077$export$7271e9e3478110d1 / 12;
var $faa5e79e2433c077$export$be1dccf2de902d31 = $faa5e79e2433c077$export$8e6600bbdee7dabb * 3;

});

parcelRegister("1fxxH", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $0e913602c24987e0$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $0e913602c24987e0$export$a7ee192b982af9c1);
var $0e913602c24987e0$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $0e913602c24987e0$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("j2Jxx", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $ddd187819e0c72a6$export$b8ef38dfcf05d5db);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");

var $gCwGq = parcelRequire("gCwGq");

var $4fO8T = parcelRequire("4fO8T");
var $ddd187819e0c72a6$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $iGrZN.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $lfYGa.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 130);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $gCwGq.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $4k0BJ.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $4fO8T.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $4fO8T.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("auWky", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $7a49f3f02c4166f5$export$951d1df011fde06f);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");

var $56GQx = parcelRequire("56GQx");
var $7a49f3f02c4166f5$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $iGrZN.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $lfYGa.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 130);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $4k0BJ.parseNDigitsSigned)(4, dateString);
                return (0, $4k0BJ.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $56GQx.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("eVmwA", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $add7dc7a5170fe2f$export$bad9d2ea38e8f1a);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $add7dc7a5170fe2f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ExtendedYearParser, _Parser);
    var _super = (0, $iGrZN.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $lfYGa.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 130);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $4k0BJ.parseNDigitsSigned)(4, dateString);
                return (0, $4k0BJ.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("6giZ6", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $48f2f6a2a699ed87$export$5cb0f701186dde1d);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $48f2f6a2a699ed87$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(QuarterParser, _Parser);
    var _super = (0, $iGrZN.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $lfYGa.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 120);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("jKqja", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $e606b8780791de4e$export$300c0c2990e20e6d);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $e606b8780791de4e$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $iGrZN.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $lfYGa.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 120);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("jM2mL", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $e65455e3c051215a$export$400dd8b40ef138a3);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4k0BJ = parcelRequire("4k0BJ");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");
var $e65455e3c051215a$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(MonthParser, _Parser);
    var _super = (0, $iGrZN.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $lfYGa.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 110);
        return _this;
    }
    (0, $cWCsL.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("8cF1n", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $5f8f43b14fb4716b$export$1d7eaa53eaa5deba);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $5f8f43b14fb4716b$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $iGrZN.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $lfYGa.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 110);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("hr9nE", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $cb1c3c099dcce980$export$c4005ffc174e07c0);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");

var $bMRF0 = parcelRequire("bMRF0");

var $4fO8T = parcelRequire("4fO8T");
var $cb1c3c099dcce980$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(LocalWeekParser, _Parser);
    var _super = (0, $iGrZN.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $lfYGa.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 100);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $4fO8T.default)((0, $bMRF0.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("bMRF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $894dcd372dd77701$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $2MGiB = parcelRequire("2MGiB");

var $nKVN9 = parcelRequire("nKVN9");
function $894dcd372dd77701$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var week = (0, $8xes0.default)(dirtyWeek);
    var diff = (0, $2MGiB.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("jnOtq", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $e1c7514aa616bf88$export$6fc8dbedd560a6af);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");

var $leogP = parcelRequire("leogP");

var $56GQx = parcelRequire("56GQx");
var $e1c7514aa616bf88$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ISOWeekParser, _Parser);
    var _super = (0, $iGrZN.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $lfYGa.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 100);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $56GQx.default)((0, $leogP.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("leogP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f74dbb60c0832fb7$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $ho43J = parcelRequire("ho43J");

var $nKVN9 = parcelRequire("nKVN9");
function $f74dbb60c0832fb7$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var isoWeek = (0, $8xes0.default)(dirtyISOWeek);
    var diff = (0, $ho43J.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("5wKwe", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $40640693f6721f40$export$e8d4b28a20981dd2);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4k0BJ = parcelRequire("4k0BJ");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");
var $40640693f6721f40$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $40640693f6721f40$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $40640693f6721f40$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(DateParser, _Parser);
    var _super = (0, $iGrZN.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $lfYGa.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "subPriority", 1);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $4k0BJ.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $40640693f6721f40$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $40640693f6721f40$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("blt2Y", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $84283004db607b83$export$6cfe0d613455f615);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $84283004db607b83$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(DayOfYearParser, _Parser);
    var _super = (0, $iGrZN.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $lfYGa.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "subpriority", 1);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $4k0BJ.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("dB62W", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $9e636bc670aea2af$export$1b03c8b76262f7bd);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $dfHpM = parcelRequire("dfHpM");
var $9e636bc670aea2af$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(DayParser, _Parser);
    var _super = (0, $iGrZN.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $lfYGa.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dfHpM.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("dfHpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5e5a5b90b029dd$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");

var $8xes0 = parcelRequire("8xes0");

var $9FGZ0 = parcelRequire("9FGZ0");
function $9a5e5a5b90b029dd$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(2, arguments);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var weekStartsOn = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $ePYBq.default)(dirtyDate);
    var day = (0, $8xes0.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("d218V", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $97cc59408bd429de$export$44d1c127ab42c480);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");

var $dfHpM = parcelRequire("dfHpM");
var $97cc59408bd429de$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(LocalDayParser, _Parser);
    var _super = (0, $iGrZN.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $lfYGa.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dfHpM.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("cAibd", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $9296f2fa3d47cd69$export$e447a647caaaec1d);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");

var $dfHpM = parcelRequire("dfHpM");
var $9296f2fa3d47cd69$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $iGrZN.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $lfYGa.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $4k0BJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dfHpM.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("6Mf2q", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $4ef2e40b7a96b91c$export$693fb1e525095b2a);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");

var $aTYiy = parcelRequire("aTYiy");
var $4ef2e40b7a96b91c$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ISODayParser, _Parser);
    var _super = (0, $iGrZN.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $lfYGa.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 90);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $4k0BJ.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $4k0BJ.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $4k0BJ.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $4k0BJ.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $aTYiy.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $4Wz2Y.Parser));

});
parcelRegister("aTYiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7efdd06770f41c6d$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");

var $8xes0 = parcelRequire("8xes0");
function $7efdd06770f41c6d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $nKVN9.default)(2, arguments);
    var day = (0, $8xes0.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $ePYBq.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("4tuoa", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $3421716a222e1bce$export$8d1e08492351df91);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $3421716a222e1bce$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(AMPMParser, _Parser);
    var _super = (0, $iGrZN.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $lfYGa.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 80);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $4k0BJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("bXZKZ", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $8b651c05f59cf484$export$73ca2bd0a17d273);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $8b651c05f59cf484$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $iGrZN.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $lfYGa.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 80);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $4k0BJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("gRZAp", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $c4815e53ac0fc330$export$bb9212adf05373db);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $c4815e53ac0fc330$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(DayPeriodParser, _Parser);
    var _super = (0, $iGrZN.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $lfYGa.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 80);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $4k0BJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("1uHO4", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $116a92de9684b036$export$8a04050a727a1756);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $116a92de9684b036$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(Hour1to12Parser, _Parser);
    var _super = (0, $iGrZN.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $lfYGa.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 70);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("dzWYh", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $9e2c49b1d6598e53$export$e56f4dea2c3e56dd);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $9e2c49b1d6598e53$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(Hour0to23Parser, _Parser);
    var _super = (0, $iGrZN.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $lfYGa.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 70);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("efmiD", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $a5f3c3a4503dd418$export$cbbe855312f87d77);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $a5f3c3a4503dd418$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(Hour0To11Parser, _Parser);
    var _super = (0, $iGrZN.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $lfYGa.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 70);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("6Mq63", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $4efb780b0243da06$export$6008046d2b34b6a5);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $4efb780b0243da06$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(Hour1To24Parser, _Parser);
    var _super = (0, $iGrZN.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $lfYGa.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 70);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("fpyMF", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $b3842c3082472bb7$export$2b52670d9e2be53);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $b3842c3082472bb7$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(MinuteParser, _Parser);
    var _super = (0, $iGrZN.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $lfYGa.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 60);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("gKVo5", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $c32d7528fedcf689$export$94d46d540cf1366a);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $c32d7528fedcf689$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(SecondParser, _Parser);
    var _super = (0, $iGrZN.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $lfYGa.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 50);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $4k0BJ.parseNumericPattern)((0, $1fxxH.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $4k0BJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("bxKpk", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $8676c654bfa2ed35$export$b8e6f8b2d70893b1);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $8676c654bfa2ed35$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $iGrZN.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $lfYGa.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 30);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $4k0BJ.mapValue)((0, $4k0BJ.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("7zwOS", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $58354296e30935de$export$104d901d49fea29b);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $58354296e30935de$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $iGrZN.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $lfYGa.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 10);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("h6z2R", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $c73e2e71729641a4$export$12910e5204b52b9);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $1fxxH = parcelRequire("1fxxH");

var $4k0BJ = parcelRequire("4k0BJ");
var $c73e2e71729641a4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $iGrZN.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $lfYGa.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 10);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $cWCsL.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $4k0BJ.parseTimezonePattern)((0, $1fxxH.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("du5mE", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $9d123cee864cd395$export$2cd8bf877a05e96);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $9d123cee864cd395$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $iGrZN.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $lfYGa.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 40);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $cWCsL.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $4k0BJ.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $4Wz2Y.Parser));

});

parcelRegister("5gwto", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $3d57a2d5a0970ee4$export$6d8f69c6906d6368);

var $lfYGa = parcelRequire("lfYGa");

var $cWCsL = parcelRequire("cWCsL");

var $5h49q = parcelRequire("5h49q");

var $hIvGi = parcelRequire("hIvGi");

var $iGrZN = parcelRequire("iGrZN");

var $6JmtS = parcelRequire("6JmtS");

var $4Wz2Y = parcelRequire("4Wz2Y");

var $4k0BJ = parcelRequire("4k0BJ");
var $3d57a2d5a0970ee4$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $hIvGi.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $iGrZN.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $lfYGa.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "priority", 20);
        (0, $6JmtS.default)((0, $5h49q.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $cWCsL.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $4k0BJ.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $4Wz2Y.Parser));

});



parcelRegister("15IWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb91ef22938ea3d$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $0cb91ef22938ea3d$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var hours = (0, $8xes0.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("d3Z4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $982aeef29b7042eb$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $982aeef29b7042eb$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var minutes = (0, $8xes0.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("kSVJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f345a1383bcd79b1$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $4gMnE = parcelRequire("4gMnE");

var $nKVN9 = parcelRequire("nKVN9");
function $f345a1383bcd79b1$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var month = (0, $8xes0.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $4gMnE.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("4gMnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $31be2f6ce7ed53e6$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $31be2f6ce7ed53e6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("fMl8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cbbc4663c26c6c$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $b7cbbc4663c26c6c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var seconds = (0, $8xes0.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("hdPFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89bba34fbdc74f3$export$2e2bcd8739ae039);

var $8xes0 = parcelRequire("8xes0");

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $c89bba34fbdc74f3$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $nKVN9.default)(2, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var year = (0, $8xes0.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("fSMd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9014b92a2aa45d2$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $b9014b92a2aa45d2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gLQiv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3599a57bf6a2861$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $c3599a57bf6a2861$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var date = (0, $ePYBq.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("3gBpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $260fe3de73709661$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $8xes0 = parcelRequire("8xes0");

var $nKVN9 = parcelRequire("nKVN9");

var $9FGZ0 = parcelRequire("9FGZ0");
function $260fe3de73709661$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $nKVN9.default)(1, arguments);
    var defaultOptions = (0, $9FGZ0.getDefaultOptions)();
    var weekStartsOn = (0, $8xes0.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $ePYBq.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gX301", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5747ba9f7f31cb3$export$2e2bcd8739ae039);

var $ePYBq = parcelRequire("ePYBq");

var $nKVN9 = parcelRequire("nKVN9");
function $c5747ba9f7f31cb3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $nKVN9.default)(1, arguments);
    var cleanDate = (0, $ePYBq.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("5zbtW", function(module, exports) {

var $bgvW5 = parcelRequire("bgvW5");

var $e3UGS = parcelRequire("e3UGS");
/** Error message constants. */ var $010bc2977e6f1c8c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $010bc2977e6f1c8c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($010bc2977e6f1c8c$var$FUNC_ERROR_TEXT);
    if ($e3UGS(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $bgvW5(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $010bc2977e6f1c8c$var$throttle;

});
parcelRegister("bgvW5", function(module, exports) {

var $e3UGS = parcelRequire("e3UGS");

var $czF7M = parcelRequire("czF7M");

var $9BEYN = parcelRequire("9BEYN");
/** Error message constants. */ var $8339f61d5d015150$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8339f61d5d015150$var$nativeMax = Math.max, $8339f61d5d015150$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8339f61d5d015150$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($8339f61d5d015150$var$FUNC_ERROR_TEXT);
    wait = $9BEYN(wait) || 0;
    if ($e3UGS(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $8339f61d5d015150$var$nativeMax($9BEYN(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8339f61d5d015150$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $czF7M();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($czF7M());
    }
    function debounced() {
        var time = $czF7M(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $8339f61d5d015150$var$debounce;

});
parcelRegister("e3UGS", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a3cd520c2d7c2625$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $a3cd520c2d7c2625$var$isObject;

});

parcelRegister("czF7M", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $9278a75f957dccb0$var$now = function() {
    return $Cqd9Z.Date.now();
};
module.exports = $9278a75f957dccb0$var$now;

});
parcelRegister("Cqd9Z", function(module, exports) {

var $5ffNg = parcelRequire("5ffNg");
/** Detect free variable `self`. */ var $0737e1bc0419762f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0737e1bc0419762f$var$root = $5ffNg || $0737e1bc0419762f$var$freeSelf || Function('return this')();
module.exports = $0737e1bc0419762f$var$root;

});
parcelRegister("5ffNg", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $3d1a9ac3bc76ed8a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $3d1a9ac3bc76ed8a$var$freeGlobal;

});



parcelRegister("9BEYN", function(module, exports) {

var $e95DI = parcelRequire("e95DI");

var $e3UGS = parcelRequire("e3UGS");

var $bbKgq = parcelRequire("bbKgq");
/** Used as references for various `Number` constants. */ var $6fe75b79afd3a2e9$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $6fe75b79afd3a2e9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6fe75b79afd3a2e9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6fe75b79afd3a2e9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6fe75b79afd3a2e9$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6fe75b79afd3a2e9$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($bbKgq(value)) return $6fe75b79afd3a2e9$var$NAN;
    if ($e3UGS(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e3UGS(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $e95DI(value);
    var isBinary = $6fe75b79afd3a2e9$var$reIsBinary.test(value);
    return isBinary || $6fe75b79afd3a2e9$var$reIsOctal.test(value) ? $6fe75b79afd3a2e9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6fe75b79afd3a2e9$var$reIsBadHex.test(value) ? $6fe75b79afd3a2e9$var$NAN : +value;
}
module.exports = $6fe75b79afd3a2e9$var$toNumber;

});
parcelRegister("e95DI", function(module, exports) {

var $5qIEZ = parcelRequire("5qIEZ");
/** Used to match leading whitespace. */ var $a4c647d5fbd72df3$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $a4c647d5fbd72df3$var$baseTrim(string) {
    return string ? string.slice(0, $5qIEZ(string) + 1).replace($a4c647d5fbd72df3$var$reTrimStart, '') : string;
}
module.exports = $a4c647d5fbd72df3$var$baseTrim;

});
parcelRegister("5qIEZ", function(module, exports) {
/** Used to match a single whitespace character. */ var $3f420607d50a13d6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3f420607d50a13d6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3f420607d50a13d6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $3f420607d50a13d6$var$trimmedEndIndex;

});


parcelRegister("bbKgq", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $82549bd7d3fc8997$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $82549bd7d3fc8997$var$isSymbol(value) {
    return typeof value == 'symbol' || $1cw4V(value) && $fmOnE(value) == $82549bd7d3fc8997$var$symbolTag;
}
module.exports = $82549bd7d3fc8997$var$isSymbol;

});
parcelRegister("fmOnE", function(module, exports) {

var $hIfba = parcelRequire("hIfba");

var $c4XYZ = parcelRequire("c4XYZ");

var $7ODSB = parcelRequire("7ODSB");
/** `Object#toString` result references. */ var $b2fffd98538bb699$var$nullTag = '[object Null]', $b2fffd98538bb699$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b2fffd98538bb699$var$symToStringTag = $hIfba ? $hIfba.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b2fffd98538bb699$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b2fffd98538bb699$var$undefinedTag : $b2fffd98538bb699$var$nullTag;
    return $b2fffd98538bb699$var$symToStringTag && $b2fffd98538bb699$var$symToStringTag in Object(value) ? $c4XYZ(value) : $7ODSB(value);
}
module.exports = $b2fffd98538bb699$var$baseGetTag;

});
parcelRegister("hIfba", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");
/** Built-in value references. */ var $ce5251f9043a4a18$var$Symbol = $Cqd9Z.Symbol;
module.exports = $ce5251f9043a4a18$var$Symbol;

});

parcelRegister("c4XYZ", function(module, exports) {

var $hIfba = parcelRequire("hIfba");
/** Used for built-in method references. */ var $8cb4631753311d74$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8cb4631753311d74$var$hasOwnProperty = $8cb4631753311d74$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8cb4631753311d74$var$nativeObjectToString = $8cb4631753311d74$var$objectProto.toString;
/** Built-in value references. */ var $8cb4631753311d74$var$symToStringTag = $hIfba ? $hIfba.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8cb4631753311d74$var$getRawTag(value) {
    var isOwn = $8cb4631753311d74$var$hasOwnProperty.call(value, $8cb4631753311d74$var$symToStringTag), tag = value[$8cb4631753311d74$var$symToStringTag];
    try {
        value[$8cb4631753311d74$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8cb4631753311d74$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8cb4631753311d74$var$symToStringTag] = tag;
        else delete value[$8cb4631753311d74$var$symToStringTag];
    }
    return result;
}
module.exports = $8cb4631753311d74$var$getRawTag;

});

parcelRegister("7ODSB", function(module, exports) {
/** Used for built-in method references. */ var $5b0c2333bf20e575$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5b0c2333bf20e575$var$nativeObjectToString = $5b0c2333bf20e575$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $5b0c2333bf20e575$var$objectToString(value) {
    return $5b0c2333bf20e575$var$nativeObjectToString.call(value);
}
module.exports = $5b0c2333bf20e575$var$objectToString;

});


parcelRegister("1cw4V", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0dffcb84cdb4ab0c$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $0dffcb84cdb4ab0c$var$isObjectLike;

});





parcelRegister("jTA3B", function(module, exports) {

var $d9MsT = parcelRequire("d9MsT");

var $3dbVW = parcelRequire("3dbVW");

var $gMaAW = parcelRequire("gMaAW");

var $fOEh0 = parcelRequire("fOEh0");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $e7bf1f940a49439e$var$filter(collection, predicate) {
    var func = $fOEh0(collection) ? $d9MsT : $3dbVW;
    return func(collection, $gMaAW(predicate, 3));
}
module.exports = $e7bf1f940a49439e$var$filter;

});
parcelRegister("d9MsT", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $9941b5c69900bdd0$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $9941b5c69900bdd0$var$arrayFilter;

});

parcelRegister("3dbVW", function(module, exports) {

var $holbX = parcelRequire("holbX");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $256bd7c1371781bf$var$baseFilter(collection, predicate) {
    var result = [];
    $holbX(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $256bd7c1371781bf$var$baseFilter;

});
parcelRegister("holbX", function(module, exports) {

var $7QfHz = parcelRequire("7QfHz");

var $02y3R = parcelRequire("02y3R");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $ca951dcc3ab6be87$var$baseEach = $02y3R($7QfHz);
module.exports = $ca951dcc3ab6be87$var$baseEach;

});
parcelRegister("7QfHz", function(module, exports) {

var $ihPhl = parcelRequire("ihPhl");

var $2XAnP = parcelRequire("2XAnP");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $5b5991cac0072de2$var$baseForOwn(object, iteratee) {
    return object && $ihPhl(object, iteratee, $2XAnP);
}
module.exports = $5b5991cac0072de2$var$baseForOwn;

});
parcelRegister("ihPhl", function(module, exports) {

var $1Pzzt = parcelRequire("1Pzzt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $d501976c19ea68f3$var$baseFor = $1Pzzt();
module.exports = $d501976c19ea68f3$var$baseFor;

});
parcelRegister("1Pzzt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $155625937f7d6f2f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $155625937f7d6f2f$var$createBaseFor;

});


parcelRegister("2XAnP", function(module, exports) {

var $5HBsj = parcelRequire("5HBsj");

var $iAIek = parcelRequire("iAIek");

var $iHYLr = parcelRequire("iHYLr");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $227d506e25e74311$var$keys(object) {
    return $iHYLr(object) ? $5HBsj(object) : $iAIek(object);
}
module.exports = $227d506e25e74311$var$keys;

});
parcelRegister("5HBsj", function(module, exports) {

var $cUMvp = parcelRequire("cUMvp");

var $kAVVc = parcelRequire("kAVVc");

var $fOEh0 = parcelRequire("fOEh0");

var $fLGD4 = parcelRequire("fLGD4");

var $jshhj = parcelRequire("jshhj");

var $37Lwg = parcelRequire("37Lwg");
/** Used for built-in method references. */ var $426e05ca5c442c89$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $426e05ca5c442c89$var$hasOwnProperty = $426e05ca5c442c89$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $426e05ca5c442c89$var$arrayLikeKeys(value, inherited) {
    var isArr = $fOEh0(value), isArg = !isArr && $kAVVc(value), isBuff = !isArr && !isArg && $fLGD4(value), isType = !isArr && !isArg && !isBuff && $37Lwg(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $cUMvp(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $426e05ca5c442c89$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $jshhj(key, length)))) result.push(key);
    return result;
}
module.exports = $426e05ca5c442c89$var$arrayLikeKeys;

});
parcelRegister("cUMvp", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9670573807368707$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $9670573807368707$var$baseTimes;

});

parcelRegister("kAVVc", function(module, exports) {

var $RWMKM = parcelRequire("RWMKM");

var $1cw4V = parcelRequire("1cw4V");
/** Used for built-in method references. */ var $efe4197a55d7ba6b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efe4197a55d7ba6b$var$hasOwnProperty = $efe4197a55d7ba6b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $efe4197a55d7ba6b$var$propertyIsEnumerable = $efe4197a55d7ba6b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $efe4197a55d7ba6b$var$isArguments = $RWMKM(function() {
    return arguments;
}()) ? $RWMKM : function(value) {
    return $1cw4V(value) && $efe4197a55d7ba6b$var$hasOwnProperty.call(value, 'callee') && !$efe4197a55d7ba6b$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $efe4197a55d7ba6b$var$isArguments;

});
parcelRegister("RWMKM", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $0a228ce5c35874ff$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $0a228ce5c35874ff$var$baseIsArguments(value) {
    return $1cw4V(value) && $fmOnE(value) == $0a228ce5c35874ff$var$argsTag;
}
module.exports = $0a228ce5c35874ff$var$baseIsArguments;

});


parcelRegister("fOEh0", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b83ac3f6411083d2$var$isArray = Array.isArray;
module.exports = $b83ac3f6411083d2$var$isArray;

});

parcelRegister("fLGD4", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");

var $2ftDb = parcelRequire("2ftDb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $Cqd9Z.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $2ftDb;
module.exports = isBuffer;

});
parcelRegister("2ftDb", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $1a33f791156b5cb7$var$stubFalse() {
    return false;
}
module.exports = $1a33f791156b5cb7$var$stubFalse;

});


parcelRegister("jshhj", function(module, exports) {
/** Used as references for various `Number` constants. */ var $03a7b5d266b388ed$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $03a7b5d266b388ed$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $03a7b5d266b388ed$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $03a7b5d266b388ed$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $03a7b5d266b388ed$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $03a7b5d266b388ed$var$isIndex;

});

parcelRegister("37Lwg", function(module, exports) {

var $hSzCF = parcelRequire("hSzCF");

var $bGjiY = parcelRequire("bGjiY");

var $bc1nU = parcelRequire("bc1nU");
/* Node.js helper references. */ var $2466e2ea5bc44b0a$var$nodeIsTypedArray = $bc1nU && $bc1nU.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $2466e2ea5bc44b0a$var$isTypedArray = $2466e2ea5bc44b0a$var$nodeIsTypedArray ? $bGjiY($2466e2ea5bc44b0a$var$nodeIsTypedArray) : $hSzCF;
module.exports = $2466e2ea5bc44b0a$var$isTypedArray;

});
parcelRegister("hSzCF", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $b8k6Q = parcelRequire("b8k6Q");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $d0431cb98826b619$var$argsTag = '[object Arguments]', $d0431cb98826b619$var$arrayTag = '[object Array]', $d0431cb98826b619$var$boolTag = '[object Boolean]', $d0431cb98826b619$var$dateTag = '[object Date]', $d0431cb98826b619$var$errorTag = '[object Error]', $d0431cb98826b619$var$funcTag = '[object Function]', $d0431cb98826b619$var$mapTag = '[object Map]', $d0431cb98826b619$var$numberTag = '[object Number]', $d0431cb98826b619$var$objectTag = '[object Object]', $d0431cb98826b619$var$regexpTag = '[object RegExp]', $d0431cb98826b619$var$setTag = '[object Set]', $d0431cb98826b619$var$stringTag = '[object String]', $d0431cb98826b619$var$weakMapTag = '[object WeakMap]';
var $d0431cb98826b619$var$arrayBufferTag = '[object ArrayBuffer]', $d0431cb98826b619$var$dataViewTag = '[object DataView]', $d0431cb98826b619$var$float32Tag = '[object Float32Array]', $d0431cb98826b619$var$float64Tag = '[object Float64Array]', $d0431cb98826b619$var$int8Tag = '[object Int8Array]', $d0431cb98826b619$var$int16Tag = '[object Int16Array]', $d0431cb98826b619$var$int32Tag = '[object Int32Array]', $d0431cb98826b619$var$uint8Tag = '[object Uint8Array]', $d0431cb98826b619$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d0431cb98826b619$var$uint16Tag = '[object Uint16Array]', $d0431cb98826b619$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $d0431cb98826b619$var$typedArrayTags = {};
$d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$float32Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$float64Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$int8Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$int16Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$int32Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$uint8Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$uint8ClampedTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$uint16Tag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$uint32Tag] = true;
$d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$argsTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$arrayTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$arrayBufferTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$boolTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$dataViewTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$dateTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$errorTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$funcTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$mapTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$numberTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$objectTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$regexpTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$setTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$stringTag] = $d0431cb98826b619$var$typedArrayTags[$d0431cb98826b619$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d0431cb98826b619$var$baseIsTypedArray(value) {
    return $1cw4V(value) && $b8k6Q(value.length) && !!$d0431cb98826b619$var$typedArrayTags[$fmOnE(value)];
}
module.exports = $d0431cb98826b619$var$baseIsTypedArray;

});
parcelRegister("b8k6Q", function(module, exports) {
/** Used as references for various `Number` constants. */ var $81b00a5938f79c67$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $81b00a5938f79c67$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $81b00a5938f79c67$var$MAX_SAFE_INTEGER;
}
module.exports = $81b00a5938f79c67$var$isLength;

});


parcelRegister("bGjiY", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $881297866f1f980e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $881297866f1f980e$var$baseUnary;

});

parcelRegister("bc1nU", function(module, exports) {

var $5ffNg = parcelRequire("5ffNg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $5ffNg.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("iAIek", function(module, exports) {

var $ejPao = parcelRequire("ejPao");

var $4Pzzc = parcelRequire("4Pzzc");
/** Used for built-in method references. */ var $d88de5fc28d5d863$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d88de5fc28d5d863$var$hasOwnProperty = $d88de5fc28d5d863$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d88de5fc28d5d863$var$baseKeys(object) {
    if (!$ejPao(object)) return $4Pzzc(object);
    var result = [];
    for(var key in Object(object))if ($d88de5fc28d5d863$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $d88de5fc28d5d863$var$baseKeys;

});
parcelRegister("ejPao", function(module, exports) {
/** Used for built-in method references. */ var $a6ca87a836f6b5af$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a6ca87a836f6b5af$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $a6ca87a836f6b5af$var$objectProto;
    return value === proto;
}
module.exports = $a6ca87a836f6b5af$var$isPrototype;

});

parcelRegister("4Pzzc", function(module, exports) {

var $f5JoS = parcelRequire("f5JoS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $384783a84f52d85d$var$nativeKeys = $f5JoS(Object.keys, Object);
module.exports = $384783a84f52d85d$var$nativeKeys;

});
parcelRegister("f5JoS", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $afca8a3604f1a5e9$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $afca8a3604f1a5e9$var$overArg;

});



parcelRegister("iHYLr", function(module, exports) {

var $1zPU1 = parcelRequire("1zPU1");

var $b8k6Q = parcelRequire("b8k6Q");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d9eb60ac06a7b9ca$var$isArrayLike(value) {
    return value != null && $b8k6Q(value.length) && !$1zPU1(value);
}
module.exports = $d9eb60ac06a7b9ca$var$isArrayLike;

});
parcelRegister("1zPU1", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $e3UGS = parcelRequire("e3UGS");
/** `Object#toString` result references. */ var $12615219f3f99030$var$asyncTag = '[object AsyncFunction]', $12615219f3f99030$var$funcTag = '[object Function]', $12615219f3f99030$var$genTag = '[object GeneratorFunction]', $12615219f3f99030$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $12615219f3f99030$var$isFunction(value) {
    if (!$e3UGS(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $fmOnE(value);
    return tag == $12615219f3f99030$var$funcTag || tag == $12615219f3f99030$var$genTag || tag == $12615219f3f99030$var$asyncTag || tag == $12615219f3f99030$var$proxyTag;
}
module.exports = $12615219f3f99030$var$isFunction;

});




parcelRegister("02y3R", function(module, exports) {

var $iHYLr = parcelRequire("iHYLr");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $007a9bdbe6876b05$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$iHYLr(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $007a9bdbe6876b05$var$createBaseEach;

});



parcelRegister("gMaAW", function(module, exports) {

var $bJYwN = parcelRequire("bJYwN");

var $65rrn = parcelRequire("65rrn");

var $7kIZw = parcelRequire("7kIZw");

var $fOEh0 = parcelRequire("fOEh0");

var $a7vpD = parcelRequire("a7vpD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $c36958f69906ef83$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $7kIZw;
    if (typeof value == 'object') return $fOEh0(value) ? $65rrn(value[0], value[1]) : $bJYwN(value);
    return $a7vpD(value);
}
module.exports = $c36958f69906ef83$var$baseIteratee;

});
parcelRegister("bJYwN", function(module, exports) {

var $k72KU = parcelRequire("k72KU");

var $9ebKt = parcelRequire("9ebKt");

var $9J15O = parcelRequire("9J15O");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $88c2d94a534756e2$var$baseMatches(source) {
    var matchData = $9ebKt(source);
    if (matchData.length == 1 && matchData[0][2]) return $9J15O(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $k72KU(object, source, matchData);
    };
}
module.exports = $88c2d94a534756e2$var$baseMatches;

});
parcelRegister("k72KU", function(module, exports) {

var $1xZOv = parcelRequire("1xZOv");

var $1fdPW = parcelRequire("1fdPW");
/** Used to compose bitmasks for value comparisons. */ var $ea46994880062925$var$COMPARE_PARTIAL_FLAG = 1, $ea46994880062925$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ea46994880062925$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $1xZOv;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1fdPW(srcValue, objValue, $ea46994880062925$var$COMPARE_PARTIAL_FLAG | $ea46994880062925$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ea46994880062925$var$baseIsMatch;

});
parcelRegister("1xZOv", function(module, exports) {

var $8qgKf = parcelRequire("8qgKf");

var $3fJsT = parcelRequire("3fJsT");

var $kmtwY = parcelRequire("kmtwY");

var $f0AMd = parcelRequire("f0AMd");

var $a7lBd = parcelRequire("a7lBd");

var $8HG8C = parcelRequire("8HG8C");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1208d26c01f01004$var$Stack(entries) {
    var data = this.__data__ = new $8qgKf(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1208d26c01f01004$var$Stack.prototype.clear = $3fJsT;
$1208d26c01f01004$var$Stack.prototype['delete'] = $kmtwY;
$1208d26c01f01004$var$Stack.prototype.get = $f0AMd;
$1208d26c01f01004$var$Stack.prototype.has = $a7lBd;
$1208d26c01f01004$var$Stack.prototype.set = $8HG8C;
module.exports = $1208d26c01f01004$var$Stack;

});
parcelRegister("8qgKf", function(module, exports) {

var $4bXDA = parcelRequire("4bXDA");

var $1eRrz = parcelRequire("1eRrz");

var $kYLY6 = parcelRequire("kYLY6");

var $krOmc = parcelRequire("krOmc");

var $2HiXN = parcelRequire("2HiXN");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $621dbda270003cba$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$621dbda270003cba$var$ListCache.prototype.clear = $4bXDA;
$621dbda270003cba$var$ListCache.prototype['delete'] = $1eRrz;
$621dbda270003cba$var$ListCache.prototype.get = $kYLY6;
$621dbda270003cba$var$ListCache.prototype.has = $krOmc;
$621dbda270003cba$var$ListCache.prototype.set = $2HiXN;
module.exports = $621dbda270003cba$var$ListCache;

});
parcelRegister("4bXDA", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $30d6734a9db2d74f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $30d6734a9db2d74f$var$listCacheClear;

});

parcelRegister("1eRrz", function(module, exports) {

var $jYFgu = parcelRequire("jYFgu");
/** Used for built-in method references. */ var $0e708e0eb7381066$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0e708e0eb7381066$var$splice = $0e708e0eb7381066$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0e708e0eb7381066$var$listCacheDelete(key) {
    var data = this.__data__, index = $jYFgu(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0e708e0eb7381066$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $0e708e0eb7381066$var$listCacheDelete;

});
parcelRegister("jYFgu", function(module, exports) {

var $pkV5g = parcelRequire("pkV5g");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e8b3a141cafb6483$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($pkV5g(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $e8b3a141cafb6483$var$assocIndexOf;

});
parcelRegister("pkV5g", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $04c2902200a9910b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $04c2902200a9910b$var$eq;

});



parcelRegister("kYLY6", function(module, exports) {

var $jYFgu = parcelRequire("jYFgu");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f45e9ebfda9593c5$var$listCacheGet(key) {
    var data = this.__data__, index = $jYFgu(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $f45e9ebfda9593c5$var$listCacheGet;

});

parcelRegister("krOmc", function(module, exports) {

var $jYFgu = parcelRequire("jYFgu");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ee2d6421643c418e$var$listCacheHas(key) {
    return $jYFgu(this.__data__, key) > -1;
}
module.exports = $ee2d6421643c418e$var$listCacheHas;

});

parcelRegister("2HiXN", function(module, exports) {

var $jYFgu = parcelRequire("jYFgu");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1f6e4eaba468d17e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $jYFgu(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $1f6e4eaba468d17e$var$listCacheSet;

});


parcelRegister("3fJsT", function(module, exports) {

var $8qgKf = parcelRequire("8qgKf");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $25e60a3c7ca79c05$var$stackClear() {
    this.__data__ = new $8qgKf;
    this.size = 0;
}
module.exports = $25e60a3c7ca79c05$var$stackClear;

});

parcelRegister("kmtwY", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed2cc4e79e0d86c9$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $ed2cc4e79e0d86c9$var$stackDelete;

});

parcelRegister("f0AMd", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $aed3622d89445754$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $aed3622d89445754$var$stackGet;

});

parcelRegister("a7lBd", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75db5002eea49d86$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $75db5002eea49d86$var$stackHas;

});

parcelRegister("8HG8C", function(module, exports) {

var $8qgKf = parcelRequire("8qgKf");

var $6ihY6 = parcelRequire("6ihY6");

var $hg87X = parcelRequire("hg87X");
/** Used as the size to enable large array optimizations. */ var $656306993edf566f$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $656306993edf566f$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $8qgKf) {
        var pairs = data.__data__;
        if (!$6ihY6 || pairs.length < $656306993edf566f$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $hg87X(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $656306993edf566f$var$stackSet;

});
parcelRegister("6ihY6", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");

var $Cqd9Z = parcelRequire("Cqd9Z");
/* Built-in method references that are verified to be native. */ var $49525ca8f9620bad$var$Map = $jAYxa($Cqd9Z, 'Map');
module.exports = $49525ca8f9620bad$var$Map;

});
parcelRegister("jAYxa", function(module, exports) {

var $es4uA = parcelRequire("es4uA");

var $R3UJN = parcelRequire("R3UJN");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e44055e71ae881a3$var$getNative(object, key) {
    var value = $R3UJN(object, key);
    return $es4uA(value) ? value : undefined;
}
module.exports = $e44055e71ae881a3$var$getNative;

});
parcelRegister("es4uA", function(module, exports) {

var $1zPU1 = parcelRequire("1zPU1");

var $j5kAM = parcelRequire("j5kAM");

var $e3UGS = parcelRequire("e3UGS");

var $gZoFt = parcelRequire("gZoFt");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a8572a4a6a942095$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $a8572a4a6a942095$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $a8572a4a6a942095$var$funcProto = Function.prototype, $a8572a4a6a942095$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a8572a4a6a942095$var$funcToString = $a8572a4a6a942095$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a8572a4a6a942095$var$hasOwnProperty = $a8572a4a6a942095$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $a8572a4a6a942095$var$reIsNative = RegExp('^' + $a8572a4a6a942095$var$funcToString.call($a8572a4a6a942095$var$hasOwnProperty).replace($a8572a4a6a942095$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $a8572a4a6a942095$var$baseIsNative(value) {
    if (!$e3UGS(value) || $j5kAM(value)) return false;
    var pattern = $1zPU1(value) ? $a8572a4a6a942095$var$reIsNative : $a8572a4a6a942095$var$reIsHostCtor;
    return pattern.test($gZoFt(value));
}
module.exports = $a8572a4a6a942095$var$baseIsNative;

});
parcelRegister("j5kAM", function(module, exports) {

var $jBvvY = parcelRequire("jBvvY");
/** Used to detect methods masquerading as native. */ var $de4e75284e29a08b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($jBvvY && $jBvvY.keys && $jBvvY.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $de4e75284e29a08b$var$isMasked(func) {
    return !!$de4e75284e29a08b$var$maskSrcKey && $de4e75284e29a08b$var$maskSrcKey in func;
}
module.exports = $de4e75284e29a08b$var$isMasked;

});
parcelRegister("jBvvY", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");
/** Used to detect overreaching core-js shims. */ var $e459eb3308e0595a$var$coreJsData = $Cqd9Z["__core-js_shared__"];
module.exports = $e459eb3308e0595a$var$coreJsData;

});


parcelRegister("gZoFt", function(module, exports) {
/** Used for built-in method references. */ var $c5e57a6570f0f826$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c5e57a6570f0f826$var$funcToString = $c5e57a6570f0f826$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c5e57a6570f0f826$var$toSource(func) {
    if (func != null) {
        try {
            return $c5e57a6570f0f826$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $c5e57a6570f0f826$var$toSource;

});


parcelRegister("R3UJN", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $09f7fc9d72e7134e$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $09f7fc9d72e7134e$var$getValue;

});



parcelRegister("hg87X", function(module, exports) {

var $2aSce = parcelRequire("2aSce");

var $jtZgU = parcelRequire("jtZgU");

var $lq7Xt = parcelRequire("lq7Xt");

var $dnCQH = parcelRequire("dnCQH");

var $hD3Jx = parcelRequire("hD3Jx");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c90a3c36a6bd14af$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c90a3c36a6bd14af$var$MapCache.prototype.clear = $2aSce;
$c90a3c36a6bd14af$var$MapCache.prototype['delete'] = $jtZgU;
$c90a3c36a6bd14af$var$MapCache.prototype.get = $lq7Xt;
$c90a3c36a6bd14af$var$MapCache.prototype.has = $dnCQH;
$c90a3c36a6bd14af$var$MapCache.prototype.set = $hD3Jx;
module.exports = $c90a3c36a6bd14af$var$MapCache;

});
parcelRegister("2aSce", function(module, exports) {

var $2N6XG = parcelRequire("2N6XG");

var $8qgKf = parcelRequire("8qgKf");

var $6ihY6 = parcelRequire("6ihY6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $19568e2fcdcf6f6a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $2N6XG,
        'map': new ($6ihY6 || $8qgKf),
        'string': new $2N6XG
    };
}
module.exports = $19568e2fcdcf6f6a$var$mapCacheClear;

});
parcelRegister("2N6XG", function(module, exports) {

var $jPUBx = parcelRequire("jPUBx");

var $eNIKn = parcelRequire("eNIKn");

var $1TdHr = parcelRequire("1TdHr");

var $66GQO = parcelRequire("66GQO");

var $76QKW = parcelRequire("76QKW");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $20858ed3da11152d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$20858ed3da11152d$var$Hash.prototype.clear = $jPUBx;
$20858ed3da11152d$var$Hash.prototype['delete'] = $eNIKn;
$20858ed3da11152d$var$Hash.prototype.get = $1TdHr;
$20858ed3da11152d$var$Hash.prototype.has = $66GQO;
$20858ed3da11152d$var$Hash.prototype.set = $76QKW;
module.exports = $20858ed3da11152d$var$Hash;

});
parcelRegister("jPUBx", function(module, exports) {

var $cOviy = parcelRequire("cOviy");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e70eb03548a4a082$var$hashClear() {
    this.__data__ = $cOviy ? $cOviy(null) : {};
    this.size = 0;
}
module.exports = $e70eb03548a4a082$var$hashClear;

});
parcelRegister("cOviy", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");
/* Built-in method references that are verified to be native. */ var $95426ebb0d22f87c$var$nativeCreate = $jAYxa(Object, 'create');
module.exports = $95426ebb0d22f87c$var$nativeCreate;

});


parcelRegister("eNIKn", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ac685a1aa79464f4$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ac685a1aa79464f4$var$hashDelete;

});

parcelRegister("1TdHr", function(module, exports) {

var $cOviy = parcelRequire("cOviy");
/** Used to stand-in for `undefined` hash values. */ var $16058df6647cffb1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $16058df6647cffb1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $16058df6647cffb1$var$hasOwnProperty = $16058df6647cffb1$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $16058df6647cffb1$var$hashGet(key) {
    var data = this.__data__;
    if ($cOviy) {
        var result = data[key];
        return result === $16058df6647cffb1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $16058df6647cffb1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $16058df6647cffb1$var$hashGet;

});

parcelRegister("66GQO", function(module, exports) {

var $cOviy = parcelRequire("cOviy");
/** Used for built-in method references. */ var $47248ae4967489a2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $47248ae4967489a2$var$hasOwnProperty = $47248ae4967489a2$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $47248ae4967489a2$var$hashHas(key) {
    var data = this.__data__;
    return $cOviy ? data[key] !== undefined : $47248ae4967489a2$var$hasOwnProperty.call(data, key);
}
module.exports = $47248ae4967489a2$var$hashHas;

});

parcelRegister("76QKW", function(module, exports) {

var $cOviy = parcelRequire("cOviy");
/** Used to stand-in for `undefined` hash values. */ var $52d2043ac2e16702$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $52d2043ac2e16702$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cOviy && value === undefined ? $52d2043ac2e16702$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $52d2043ac2e16702$var$hashSet;

});



parcelRegister("jtZgU", function(module, exports) {

var $6I400 = parcelRequire("6I400");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e2f041048fbc5e9a$var$mapCacheDelete(key) {
    var result = $6I400(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $e2f041048fbc5e9a$var$mapCacheDelete;

});
parcelRegister("6I400", function(module, exports) {

var $9YrJA = parcelRequire("9YrJA");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4e29f44663d9b15b$var$getMapData(map, key) {
    var data = map.__data__;
    return $9YrJA(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $4e29f44663d9b15b$var$getMapData;

});
parcelRegister("9YrJA", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $742f3b203ec51a15$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $742f3b203ec51a15$var$isKeyable;

});



parcelRegister("lq7Xt", function(module, exports) {

var $6I400 = parcelRequire("6I400");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f982330017808361$var$mapCacheGet(key) {
    return $6I400(this, key).get(key);
}
module.exports = $f982330017808361$var$mapCacheGet;

});

parcelRegister("dnCQH", function(module, exports) {

var $6I400 = parcelRequire("6I400");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9bdb8eefef8ac1c8$var$mapCacheHas(key) {
    return $6I400(this, key).has(key);
}
module.exports = $9bdb8eefef8ac1c8$var$mapCacheHas;

});

parcelRegister("hD3Jx", function(module, exports) {

var $6I400 = parcelRequire("6I400");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $cd58f990d8ed641f$var$mapCacheSet(key, value) {
    var data = $6I400(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $cd58f990d8ed641f$var$mapCacheSet;

});




parcelRegister("1fdPW", function(module, exports) {

var $7XfLf = parcelRequire("7XfLf");

var $1cw4V = parcelRequire("1cw4V");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $0e81ecdf49d35ff7$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$1cw4V(value) && !$1cw4V(other)) return value !== value && other !== other;
    return $7XfLf(value, other, bitmask, customizer, $0e81ecdf49d35ff7$var$baseIsEqual, stack);
}
module.exports = $0e81ecdf49d35ff7$var$baseIsEqual;

});
parcelRegister("7XfLf", function(module, exports) {

var $1xZOv = parcelRequire("1xZOv");

var $4Jkpd = parcelRequire("4Jkpd");

var $k7jL9 = parcelRequire("k7jL9");

var $9F4oO = parcelRequire("9F4oO");

var $HAWwk = parcelRequire("HAWwk");

var $fOEh0 = parcelRequire("fOEh0");

var $fLGD4 = parcelRequire("fLGD4");

var $37Lwg = parcelRequire("37Lwg");
/** Used to compose bitmasks for value comparisons. */ var $5caa44e4bc18a3d9$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5caa44e4bc18a3d9$var$argsTag = '[object Arguments]', $5caa44e4bc18a3d9$var$arrayTag = '[object Array]', $5caa44e4bc18a3d9$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5caa44e4bc18a3d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5caa44e4bc18a3d9$var$hasOwnProperty = $5caa44e4bc18a3d9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5caa44e4bc18a3d9$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $fOEh0(object), othIsArr = $fOEh0(other), objTag = objIsArr ? $5caa44e4bc18a3d9$var$arrayTag : $HAWwk(object), othTag = othIsArr ? $5caa44e4bc18a3d9$var$arrayTag : $HAWwk(other);
    objTag = objTag == $5caa44e4bc18a3d9$var$argsTag ? $5caa44e4bc18a3d9$var$objectTag : objTag;
    othTag = othTag == $5caa44e4bc18a3d9$var$argsTag ? $5caa44e4bc18a3d9$var$objectTag : othTag;
    var objIsObj = objTag == $5caa44e4bc18a3d9$var$objectTag, othIsObj = othTag == $5caa44e4bc18a3d9$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $fLGD4(object)) {
        if (!$fLGD4(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $1xZOv);
        return objIsArr || $37Lwg(object) ? $4Jkpd(object, other, bitmask, customizer, equalFunc, stack) : $k7jL9(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5caa44e4bc18a3d9$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5caa44e4bc18a3d9$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $5caa44e4bc18a3d9$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $1xZOv);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $1xZOv);
    return $9F4oO(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $5caa44e4bc18a3d9$var$baseIsEqualDeep;

});
parcelRegister("4Jkpd", function(module, exports) {

var $dy8xE = parcelRequire("dy8xE");

var $flOKy = parcelRequire("flOKy");

var $33jv1 = parcelRequire("33jv1");
/** Used to compose bitmasks for value comparisons. */ var $371b318a1a1ad163$var$COMPARE_PARTIAL_FLAG = 1, $371b318a1a1ad163$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $371b318a1a1ad163$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $371b318a1a1ad163$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $371b318a1a1ad163$var$COMPARE_UNORDERED_FLAG ? new $dy8xE : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$flOKy(other, function(othValue, othIndex) {
                if (!$33jv1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $371b318a1a1ad163$var$equalArrays;

});
parcelRegister("dy8xE", function(module, exports) {

var $hg87X = parcelRequire("hg87X");

var $kDnr2 = parcelRequire("kDnr2");

var $5GQB9 = parcelRequire("5GQB9");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $9dd51388dca7398f$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $hg87X;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$9dd51388dca7398f$var$SetCache.prototype.add = $9dd51388dca7398f$var$SetCache.prototype.push = $kDnr2;
$9dd51388dca7398f$var$SetCache.prototype.has = $5GQB9;
module.exports = $9dd51388dca7398f$var$SetCache;

});
parcelRegister("kDnr2", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $f059a0e9277e4150$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f059a0e9277e4150$var$setCacheAdd(value) {
    this.__data__.set(value, $f059a0e9277e4150$var$HASH_UNDEFINED);
    return this;
}
module.exports = $f059a0e9277e4150$var$setCacheAdd;

});

parcelRegister("5GQB9", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $4249aced997f1f6f$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $4249aced997f1f6f$var$setCacheHas;

});


parcelRegister("flOKy", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b2d02f0dc13252b0$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $b2d02f0dc13252b0$var$arraySome;

});

parcelRegister("33jv1", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2390c711ee3d9d02$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $2390c711ee3d9d02$var$cacheHas;

});


parcelRegister("k7jL9", function(module, exports) {

var $hIfba = parcelRequire("hIfba");

var $he00J = parcelRequire("he00J");

var $pkV5g = parcelRequire("pkV5g");

var $4Jkpd = parcelRequire("4Jkpd");

var $hxUxo = parcelRequire("hxUxo");

var $4r1X2 = parcelRequire("4r1X2");
/** Used to compose bitmasks for value comparisons. */ var $ea53c9f14e1372a1$var$COMPARE_PARTIAL_FLAG = 1, $ea53c9f14e1372a1$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $ea53c9f14e1372a1$var$boolTag = '[object Boolean]', $ea53c9f14e1372a1$var$dateTag = '[object Date]', $ea53c9f14e1372a1$var$errorTag = '[object Error]', $ea53c9f14e1372a1$var$mapTag = '[object Map]', $ea53c9f14e1372a1$var$numberTag = '[object Number]', $ea53c9f14e1372a1$var$regexpTag = '[object RegExp]', $ea53c9f14e1372a1$var$setTag = '[object Set]', $ea53c9f14e1372a1$var$stringTag = '[object String]', $ea53c9f14e1372a1$var$symbolTag = '[object Symbol]';
var $ea53c9f14e1372a1$var$arrayBufferTag = '[object ArrayBuffer]', $ea53c9f14e1372a1$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $ea53c9f14e1372a1$var$symbolProto = $hIfba ? $hIfba.prototype : undefined, $ea53c9f14e1372a1$var$symbolValueOf = $ea53c9f14e1372a1$var$symbolProto ? $ea53c9f14e1372a1$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ea53c9f14e1372a1$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $ea53c9f14e1372a1$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $ea53c9f14e1372a1$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $he00J(object), new $he00J(other))) return false;
            return true;
        case $ea53c9f14e1372a1$var$boolTag:
        case $ea53c9f14e1372a1$var$dateTag:
        case $ea53c9f14e1372a1$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $pkV5g(+object, +other);
        case $ea53c9f14e1372a1$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $ea53c9f14e1372a1$var$regexpTag:
        case $ea53c9f14e1372a1$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $ea53c9f14e1372a1$var$mapTag:
            var convert = $hxUxo;
        case $ea53c9f14e1372a1$var$setTag:
            var isPartial = bitmask & $ea53c9f14e1372a1$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $4r1X2);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $ea53c9f14e1372a1$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $4Jkpd(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $ea53c9f14e1372a1$var$symbolTag:
            if ($ea53c9f14e1372a1$var$symbolValueOf) return $ea53c9f14e1372a1$var$symbolValueOf.call(object) == $ea53c9f14e1372a1$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $ea53c9f14e1372a1$var$equalByTag;

});
parcelRegister("he00J", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");
/** Built-in value references. */ var $c8a3c097f8e9f2db$var$Uint8Array = $Cqd9Z.Uint8Array;
module.exports = $c8a3c097f8e9f2db$var$Uint8Array;

});

parcelRegister("hxUxo", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $cc615ff1b5e4d5ad$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $cc615ff1b5e4d5ad$var$mapToArray;

});

parcelRegister("4r1X2", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $33ab3285a8d74ef3$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $33ab3285a8d74ef3$var$setToArray;

});


parcelRegister("9F4oO", function(module, exports) {

var $eyYJk = parcelRequire("eyYJk");
/** Used to compose bitmasks for value comparisons. */ var $708b5af51b824d70$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $708b5af51b824d70$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $708b5af51b824d70$var$hasOwnProperty = $708b5af51b824d70$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $708b5af51b824d70$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $708b5af51b824d70$var$COMPARE_PARTIAL_FLAG, objProps = $eyYJk(object), objLength = objProps.length, othProps = $eyYJk(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $708b5af51b824d70$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $708b5af51b824d70$var$equalObjects;

});
parcelRegister("eyYJk", function(module, exports) {

var $iXLDj = parcelRequire("iXLDj");

var $bRsra = parcelRequire("bRsra");

var $2XAnP = parcelRequire("2XAnP");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a9a3595ff9460b74$var$getAllKeys(object) {
    return $iXLDj(object, $2XAnP, $bRsra);
}
module.exports = $a9a3595ff9460b74$var$getAllKeys;

});
parcelRegister("iXLDj", function(module, exports) {

var $3tLL3 = parcelRequire("3tLL3");

var $fOEh0 = parcelRequire("fOEh0");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $dce2afa0fd7e473c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $fOEh0(object) ? result : $3tLL3(result, symbolsFunc(object));
}
module.exports = $dce2afa0fd7e473c$var$baseGetAllKeys;

});
parcelRegister("3tLL3", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $28892045b527b0b7$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $28892045b527b0b7$var$arrayPush;

});


parcelRegister("bRsra", function(module, exports) {

var $d9MsT = parcelRequire("d9MsT");

var $9j53I = parcelRequire("9j53I");
/** Used for built-in method references. */ var $8a2ab3fe63fb20f6$var$objectProto = Object.prototype;
/** Built-in value references. */ var $8a2ab3fe63fb20f6$var$propertyIsEnumerable = $8a2ab3fe63fb20f6$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8a2ab3fe63fb20f6$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8a2ab3fe63fb20f6$var$getSymbols = !$8a2ab3fe63fb20f6$var$nativeGetSymbols ? $9j53I : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $d9MsT($8a2ab3fe63fb20f6$var$nativeGetSymbols(object), function(symbol) {
        return $8a2ab3fe63fb20f6$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $8a2ab3fe63fb20f6$var$getSymbols;

});
parcelRegister("9j53I", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $6c69d0019d45f000$var$stubArray() {
    return [];
}
module.exports = $6c69d0019d45f000$var$stubArray;

});




parcelRegister("HAWwk", function(module, exports) {

var $9Ghu7 = parcelRequire("9Ghu7");

var $6ihY6 = parcelRequire("6ihY6");

var $9FQoE = parcelRequire("9FQoE");

var $jwD8V = parcelRequire("jwD8V");

var $5oZiV = parcelRequire("5oZiV");

var $fmOnE = parcelRequire("fmOnE");

var $gZoFt = parcelRequire("gZoFt");
/** `Object#toString` result references. */ var $0830ac5a70dccab6$var$mapTag = '[object Map]', $0830ac5a70dccab6$var$objectTag = '[object Object]', $0830ac5a70dccab6$var$promiseTag = '[object Promise]', $0830ac5a70dccab6$var$setTag = '[object Set]', $0830ac5a70dccab6$var$weakMapTag = '[object WeakMap]';
var $0830ac5a70dccab6$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $0830ac5a70dccab6$var$dataViewCtorString = $gZoFt($9Ghu7), $0830ac5a70dccab6$var$mapCtorString = $gZoFt($6ihY6), $0830ac5a70dccab6$var$promiseCtorString = $gZoFt($9FQoE), $0830ac5a70dccab6$var$setCtorString = $gZoFt($jwD8V), $0830ac5a70dccab6$var$weakMapCtorString = $gZoFt($5oZiV);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0830ac5a70dccab6$var$getTag = $fmOnE;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($9Ghu7 && $0830ac5a70dccab6$var$getTag(new $9Ghu7(new ArrayBuffer(1))) != $0830ac5a70dccab6$var$dataViewTag || $6ihY6 && $0830ac5a70dccab6$var$getTag(new $6ihY6) != $0830ac5a70dccab6$var$mapTag || $9FQoE && $0830ac5a70dccab6$var$getTag($9FQoE.resolve()) != $0830ac5a70dccab6$var$promiseTag || $jwD8V && $0830ac5a70dccab6$var$getTag(new $jwD8V) != $0830ac5a70dccab6$var$setTag || $5oZiV && $0830ac5a70dccab6$var$getTag(new $5oZiV) != $0830ac5a70dccab6$var$weakMapTag) $0830ac5a70dccab6$var$getTag = function(value) {
    var result = $fmOnE(value), Ctor = result == $0830ac5a70dccab6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $gZoFt(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $0830ac5a70dccab6$var$dataViewCtorString:
            return $0830ac5a70dccab6$var$dataViewTag;
        case $0830ac5a70dccab6$var$mapCtorString:
            return $0830ac5a70dccab6$var$mapTag;
        case $0830ac5a70dccab6$var$promiseCtorString:
            return $0830ac5a70dccab6$var$promiseTag;
        case $0830ac5a70dccab6$var$setCtorString:
            return $0830ac5a70dccab6$var$setTag;
        case $0830ac5a70dccab6$var$weakMapCtorString:
            return $0830ac5a70dccab6$var$weakMapTag;
    }
    return result;
};
module.exports = $0830ac5a70dccab6$var$getTag;

});
parcelRegister("9Ghu7", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");

var $Cqd9Z = parcelRequire("Cqd9Z");
/* Built-in method references that are verified to be native. */ var $70c599666d90b8a5$var$DataView = $jAYxa($Cqd9Z, 'DataView');
module.exports = $70c599666d90b8a5$var$DataView;

});

parcelRegister("9FQoE", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");

var $Cqd9Z = parcelRequire("Cqd9Z");
/* Built-in method references that are verified to be native. */ var $70b0964870db6aec$var$Promise = $jAYxa($Cqd9Z, 'Promise');
module.exports = $70b0964870db6aec$var$Promise;

});

parcelRegister("jwD8V", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");

var $Cqd9Z = parcelRequire("Cqd9Z");
/* Built-in method references that are verified to be native. */ var $e36f5e781f33b788$var$Set = $jAYxa($Cqd9Z, 'Set');
module.exports = $e36f5e781f33b788$var$Set;

});

parcelRegister("5oZiV", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");

var $Cqd9Z = parcelRequire("Cqd9Z");
/* Built-in method references that are verified to be native. */ var $3eeebf62ce850db2$var$WeakMap = $jAYxa($Cqd9Z, 'WeakMap');
module.exports = $3eeebf62ce850db2$var$WeakMap;

});





parcelRegister("9ebKt", function(module, exports) {

var $3KfKH = parcelRequire("3KfKH");

var $2XAnP = parcelRequire("2XAnP");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b7e88dd038738d1$var$getMatchData(object) {
    var result = $2XAnP(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3KfKH(value)
        ];
    }
    return result;
}
module.exports = $6b7e88dd038738d1$var$getMatchData;

});
parcelRegister("3KfKH", function(module, exports) {

var $e3UGS = parcelRequire("e3UGS");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $2ba1e304f47d5a01$var$isStrictComparable(value) {
    return value === value && !$e3UGS(value);
}
module.exports = $2ba1e304f47d5a01$var$isStrictComparable;

});


parcelRegister("9J15O", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $71492a01b72d9c5e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $71492a01b72d9c5e$var$matchesStrictComparable;

});


parcelRegister("65rrn", function(module, exports) {

var $1fdPW = parcelRequire("1fdPW");

var $8K6DG = parcelRequire("8K6DG");

var $ltlKn = parcelRequire("ltlKn");

var $gREpp = parcelRequire("gREpp");

var $3KfKH = parcelRequire("3KfKH");

var $9J15O = parcelRequire("9J15O");

var $iRWdG = parcelRequire("iRWdG");
/** Used to compose bitmasks for value comparisons. */ var $46e87ed7e826224e$var$COMPARE_PARTIAL_FLAG = 1, $46e87ed7e826224e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $46e87ed7e826224e$var$baseMatchesProperty(path, srcValue) {
    if ($gREpp(path) && $3KfKH(srcValue)) return $9J15O($iRWdG(path), srcValue);
    return function(object) {
        var objValue = $8K6DG(object, path);
        return objValue === undefined && objValue === srcValue ? $ltlKn(object, path) : $1fdPW(srcValue, objValue, $46e87ed7e826224e$var$COMPARE_PARTIAL_FLAG | $46e87ed7e826224e$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $46e87ed7e826224e$var$baseMatchesProperty;

});
parcelRegister("8K6DG", function(module, exports) {

var $hNgrA = parcelRequire("hNgrA");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $65d7c4f709de0293$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $hNgrA(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $65d7c4f709de0293$var$get;

});
parcelRegister("hNgrA", function(module, exports) {

var $6HxlX = parcelRequire("6HxlX");

var $iRWdG = parcelRequire("iRWdG");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $cf43c4b5a3e3dd81$var$baseGet(object, path) {
    path = $6HxlX(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$iRWdG(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $cf43c4b5a3e3dd81$var$baseGet;

});
parcelRegister("6HxlX", function(module, exports) {

var $fOEh0 = parcelRequire("fOEh0");

var $gREpp = parcelRequire("gREpp");

var $dZj61 = parcelRequire("dZj61");

var $iv3UF = parcelRequire("iv3UF");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4e10a173033d14e2$var$castPath(value, object) {
    if ($fOEh0(value)) return value;
    return $gREpp(value, object) ? [
        value
    ] : $dZj61($iv3UF(value));
}
module.exports = $4e10a173033d14e2$var$castPath;

});
parcelRegister("gREpp", function(module, exports) {

var $fOEh0 = parcelRequire("fOEh0");

var $bbKgq = parcelRequire("bbKgq");
/** Used to match property names within property paths. */ var $c470f0ecec71d16b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $c470f0ecec71d16b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $c470f0ecec71d16b$var$isKey(value, object) {
    if ($fOEh0(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $bbKgq(value)) return true;
    return $c470f0ecec71d16b$var$reIsPlainProp.test(value) || !$c470f0ecec71d16b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $c470f0ecec71d16b$var$isKey;

});

parcelRegister("dZj61", function(module, exports) {

var $id39E = parcelRequire("id39E");
/** Used to match property names within property paths. */ var $a2efc8fbf410d053$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a2efc8fbf410d053$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a2efc8fbf410d053$var$stringToPath = $id39E(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a2efc8fbf410d053$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a2efc8fbf410d053$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a2efc8fbf410d053$var$stringToPath;

});
parcelRegister("id39E", function(module, exports) {

var $g6Dt9 = parcelRequire("g6Dt9");
/** Used as the maximum memoize cache size. */ var $d41be354341a2a9f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d41be354341a2a9f$var$memoizeCapped(func) {
    var result = $g6Dt9(func, function(key) {
        if (cache.size === $d41be354341a2a9f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $d41be354341a2a9f$var$memoizeCapped;

});
parcelRegister("g6Dt9", function(module, exports) {

var $hg87X = parcelRequire("hg87X");
/** Error message constants. */ var $bb9bd29ceb5a7888$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $bb9bd29ceb5a7888$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($bb9bd29ceb5a7888$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($bb9bd29ceb5a7888$var$memoize.Cache || $hg87X);
    return memoized;
}
// Expose `MapCache`.
$bb9bd29ceb5a7888$var$memoize.Cache = $hg87X;
module.exports = $bb9bd29ceb5a7888$var$memoize;

});



parcelRegister("iv3UF", function(module, exports) {

var $1zhwF = parcelRequire("1zhwF");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d77e284d0398641e$var$toString(value) {
    return value == null ? '' : $1zhwF(value);
}
module.exports = $d77e284d0398641e$var$toString;

});
parcelRegister("1zhwF", function(module, exports) {

var $hIfba = parcelRequire("hIfba");

var $cuXSp = parcelRequire("cuXSp");

var $fOEh0 = parcelRequire("fOEh0");

var $bbKgq = parcelRequire("bbKgq");
/** Used as references for various `Number` constants. */ var $1246a7984b8ab9e9$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $1246a7984b8ab9e9$var$symbolProto = $hIfba ? $hIfba.prototype : undefined, $1246a7984b8ab9e9$var$symbolToString = $1246a7984b8ab9e9$var$symbolProto ? $1246a7984b8ab9e9$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $1246a7984b8ab9e9$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($fOEh0(value)) // Recursively convert values (susceptible to call stack limits).
    return $cuXSp(value, $1246a7984b8ab9e9$var$baseToString) + '';
    if ($bbKgq(value)) return $1246a7984b8ab9e9$var$symbolToString ? $1246a7984b8ab9e9$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$1246a7984b8ab9e9$var$INFINITY ? '-0' : result;
}
module.exports = $1246a7984b8ab9e9$var$baseToString;

});
parcelRegister("cuXSp", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9196bba39087d903$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $9196bba39087d903$var$arrayMap;

});




parcelRegister("iRWdG", function(module, exports) {

var $bbKgq = parcelRequire("bbKgq");
/** Used as references for various `Number` constants. */ var $dbca56773c805db5$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $dbca56773c805db5$var$toKey(value) {
    if (typeof value == 'string' || $bbKgq(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$dbca56773c805db5$var$INFINITY ? '-0' : result;
}
module.exports = $dbca56773c805db5$var$toKey;

});



parcelRegister("ltlKn", function(module, exports) {

var $J3kFL = parcelRequire("J3kFL");

var $2ChO2 = parcelRequire("2ChO2");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $fa1d2ce5b26dddd7$var$hasIn(object, path) {
    return object != null && $2ChO2(object, path, $J3kFL);
}
module.exports = $fa1d2ce5b26dddd7$var$hasIn;

});
parcelRegister("J3kFL", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0876c9d5ac3a1299$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $0876c9d5ac3a1299$var$baseHasIn;

});

parcelRegister("2ChO2", function(module, exports) {

var $6HxlX = parcelRequire("6HxlX");

var $kAVVc = parcelRequire("kAVVc");

var $fOEh0 = parcelRequire("fOEh0");

var $jshhj = parcelRequire("jshhj");

var $b8k6Q = parcelRequire("b8k6Q");

var $iRWdG = parcelRequire("iRWdG");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $1e7cf14e37a1cb04$var$hasPath(object, path, hasFunc) {
    path = $6HxlX(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $iRWdG(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $b8k6Q(length) && $jshhj(key, length) && ($fOEh0(object) || $kAVVc(object));
}
module.exports = $1e7cf14e37a1cb04$var$hasPath;

});



parcelRegister("7kIZw", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $556d4cfd5c634b25$var$identity(value) {
    return value;
}
module.exports = $556d4cfd5c634b25$var$identity;

});

parcelRegister("a7vpD", function(module, exports) {

var $2GgAO = parcelRequire("2GgAO");

var $5uP3r = parcelRequire("5uP3r");

var $gREpp = parcelRequire("gREpp");

var $iRWdG = parcelRequire("iRWdG");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $75e2ecb637cbe01f$var$property(path) {
    return $gREpp(path) ? $2GgAO($iRWdG(path)) : $5uP3r(path);
}
module.exports = $75e2ecb637cbe01f$var$property;

});
parcelRegister("2GgAO", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1f3c6001b51e6870$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $1f3c6001b51e6870$var$baseProperty;

});

parcelRegister("5uP3r", function(module, exports) {

var $hNgrA = parcelRequire("hNgrA");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $40075b7a84c00ab2$var$basePropertyDeep(path) {
    return function(object) {
        return $hNgrA(object, path);
    };
}
module.exports = $40075b7a84c00ab2$var$basePropertyDeep;

});




parcelRegister("7YTVN", function(module, exports) {

var $1fdPW = parcelRequire("1fdPW");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $5cf985c066ffeb03$var$isEqual(value, other) {
    return $1fdPW(value, other);
}
module.exports = $5cf985c066ffeb03$var$isEqual;

});

parcelRegister("5CVir", function(module, exports) {

var $aLHdi = parcelRequire("aLHdi");

var $iHYLr = parcelRequire("iHYLr");

var $9GJgY = parcelRequire("9GJgY");

var $9Ze0B = parcelRequire("9Ze0B");

var $kh0Y1 = parcelRequire("kh0Y1");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $418cf23dfeedf240$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $418cf23dfeedf240$var$includes(collection, value, fromIndex, guard) {
    collection = $iHYLr(collection) ? collection : $kh0Y1(collection);
    fromIndex = fromIndex && !guard ? $9Ze0B(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $418cf23dfeedf240$var$nativeMax(length + fromIndex, 0);
    return $9GJgY(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $aLHdi(collection, value, fromIndex) > -1;
}
module.exports = $418cf23dfeedf240$var$includes;

});
parcelRegister("aLHdi", function(module, exports) {

var $eYJO6 = parcelRequire("eYJO6");

var $87Xm4 = parcelRequire("87Xm4");

var $lULYS = parcelRequire("lULYS");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7d6fd07864d51fcb$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $lULYS(array, value, fromIndex) : $eYJO6(array, $87Xm4, fromIndex);
}
module.exports = $7d6fd07864d51fcb$var$baseIndexOf;

});
parcelRegister("eYJO6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae7a33a2424f8529$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $ae7a33a2424f8529$var$baseFindIndex;

});

parcelRegister("87Xm4", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $5ead04d877495782$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $5ead04d877495782$var$baseIsNaN;

});

parcelRegister("lULYS", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ff440bed8308b699$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $ff440bed8308b699$var$strictIndexOf;

});


parcelRegister("9GJgY", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $fOEh0 = parcelRequire("fOEh0");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $70db27859eadeed6$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $70db27859eadeed6$var$isString(value) {
    return typeof value == 'string' || !$fOEh0(value) && $1cw4V(value) && $fmOnE(value) == $70db27859eadeed6$var$stringTag;
}
module.exports = $70db27859eadeed6$var$isString;

});

parcelRegister("9Ze0B", function(module, exports) {

var $jECF9 = parcelRequire("jECF9");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $7454ad6972c0f00e$var$toInteger(value) {
    var result = $jECF9(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $7454ad6972c0f00e$var$toInteger;

});
parcelRegister("jECF9", function(module, exports) {

var $9BEYN = parcelRequire("9BEYN");
/** Used as references for various `Number` constants. */ var $e4efbe5ae80d2a86$var$INFINITY = 1 / 0, $e4efbe5ae80d2a86$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $e4efbe5ae80d2a86$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $9BEYN(value);
    if (value === $e4efbe5ae80d2a86$var$INFINITY || value === -$e4efbe5ae80d2a86$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $e4efbe5ae80d2a86$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $e4efbe5ae80d2a86$var$toFinite;

});


parcelRegister("kh0Y1", function(module, exports) {

var $hzfse = parcelRequire("hzfse");

var $2XAnP = parcelRequire("2XAnP");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $ec26253a34d8a266$var$values(object) {
    return object == null ? [] : $hzfse(object, $2XAnP(object));
}
module.exports = $ec26253a34d8a266$var$values;

});
parcelRegister("hzfse", function(module, exports) {

var $cuXSp = parcelRequire("cuXSp");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $cca1b17a29862fad$var$baseValues(object, props) {
    return $cuXSp(props, function(key) {
        return object[key];
    });
}
module.exports = $cca1b17a29862fad$var$baseValues;

});



parcelRegister("gyBtf", function(module, exports) {

var $gMaAW = parcelRequire("gMaAW");

var $1Kx8V = parcelRequire("1Kx8V");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $c0dce336019b11fe$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Kx8V(array, $gMaAW(iteratee, 2)) : [];
}
module.exports = $c0dce336019b11fe$var$uniqBy;

});
parcelRegister("1Kx8V", function(module, exports) {

var $dy8xE = parcelRequire("dy8xE");

var $670kX = parcelRequire("670kX");

var $2HaJA = parcelRequire("2HaJA");

var $33jv1 = parcelRequire("33jv1");

var $fihIG = parcelRequire("fihIG");

var $4r1X2 = parcelRequire("4r1X2");
/** Used as the size to enable large array optimizations. */ var $1463cbd2dc055383$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $1463cbd2dc055383$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $670kX, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $2HaJA;
    } else if (length >= $1463cbd2dc055383$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $fihIG(array);
        if (set) return $4r1X2(set);
        isCommon = false;
        includes = $33jv1;
        seen = new $dy8xE;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $1463cbd2dc055383$var$baseUniq;

});
parcelRegister("670kX", function(module, exports) {

var $aLHdi = parcelRequire("aLHdi");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $4733a872bc72594e$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $aLHdi(array, value, 0) > -1;
}
module.exports = $4733a872bc72594e$var$arrayIncludes;

});

parcelRegister("2HaJA", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1f67ec82d2aa00da$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $1f67ec82d2aa00da$var$arrayIncludesWith;

});

parcelRegister("fihIG", function(module, exports) {

var $jwD8V = parcelRequire("jwD8V");

var $5Zx2g = parcelRequire("5Zx2g");

var $4r1X2 = parcelRequire("4r1X2");
/** Used as references for various `Number` constants. */ var $b2264838474c1ae5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $b2264838474c1ae5$var$createSet = !($jwD8V && 1 / $4r1X2(new $jwD8V([
    ,
    -0
]))[1] == $b2264838474c1ae5$var$INFINITY) ? $5Zx2g : function(values) {
    return new $jwD8V(values);
};
module.exports = $b2264838474c1ae5$var$createSet;

});
parcelRegister("5Zx2g", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $45cc466b3209d74f$var$noop() {
// No operation performed.
}
module.exports = $45cc466b3209d74f$var$noop;

});




parcelRegister("fZuoP", function(module, exports) {

var $luj8w = parcelRequire("luj8w");

var $h6Nu0 = parcelRequire("h6Nu0");

var $87Ear = parcelRequire("87Ear");

var $ecELx = parcelRequire("ecELx");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $ba4422341152c585$var$sortBy = $87Ear(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $ecELx(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $ecELx(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $h6Nu0(collection, $luj8w(iteratees, 1), []);
});
module.exports = $ba4422341152c585$var$sortBy;

});
parcelRegister("luj8w", function(module, exports) {

var $3tLL3 = parcelRequire("3tLL3");

var $7Fxff = parcelRequire("7Fxff");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $fa4b3e6ab32e6ee5$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $7Fxff);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $fa4b3e6ab32e6ee5$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $3tLL3(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $fa4b3e6ab32e6ee5$var$baseFlatten;

});
parcelRegister("7Fxff", function(module, exports) {

var $hIfba = parcelRequire("hIfba");

var $kAVVc = parcelRequire("kAVVc");

var $fOEh0 = parcelRequire("fOEh0");
/** Built-in value references. */ var $5956267cc15c988e$var$spreadableSymbol = $hIfba ? $hIfba.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $5956267cc15c988e$var$isFlattenable(value) {
    return $fOEh0(value) || $kAVVc(value) || !!($5956267cc15c988e$var$spreadableSymbol && value && value[$5956267cc15c988e$var$spreadableSymbol]);
}
module.exports = $5956267cc15c988e$var$isFlattenable;

});


parcelRegister("h6Nu0", function(module, exports) {

var $cuXSp = parcelRequire("cuXSp");

var $hNgrA = parcelRequire("hNgrA");

var $gMaAW = parcelRequire("gMaAW");

var $9bolA = parcelRequire("9bolA");

var $gleu4 = parcelRequire("gleu4");

var $bGjiY = parcelRequire("bGjiY");

var $4THIq = parcelRequire("4THIq");

var $7kIZw = parcelRequire("7kIZw");

var $fOEh0 = parcelRequire("fOEh0");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $c749617860eedb61$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $cuXSp(iteratees, function(iteratee) {
        if ($fOEh0(iteratee)) return function(value) {
            return $hNgrA(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $7kIZw
    ];
    var index = -1;
    iteratees = $cuXSp(iteratees, $bGjiY($gMaAW));
    var result = $9bolA(collection, function(value, key, collection) {
        var criteria = $cuXSp(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $gleu4(result, function(object, other) {
        return $4THIq(object, other, orders);
    });
}
module.exports = $c749617860eedb61$var$baseOrderBy;

});
parcelRegister("9bolA", function(module, exports) {

var $holbX = parcelRequire("holbX");

var $iHYLr = parcelRequire("iHYLr");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6af806f9f713538a$var$baseMap(collection, iteratee) {
    var index = -1, result = $iHYLr(collection) ? Array(collection.length) : [];
    $holbX(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $6af806f9f713538a$var$baseMap;

});

parcelRegister("gleu4", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $be59d7b784791654$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $be59d7b784791654$var$baseSortBy;

});

parcelRegister("4THIq", function(module, exports) {

var $3Z8uF = parcelRequire("3Z8uF");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $390e3576429bb1d1$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $3Z8uF(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $390e3576429bb1d1$var$compareMultiple;

});
parcelRegister("3Z8uF", function(module, exports) {

var $bbKgq = parcelRequire("bbKgq");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $2e6da846515a2963$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $bbKgq(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $bbKgq(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $2e6da846515a2963$var$compareAscending;

});



parcelRegister("87Ear", function(module, exports) {

var $7kIZw = parcelRequire("7kIZw");

var $4fRQb = parcelRequire("4fRQb");

var $hiG9p = parcelRequire("hiG9p");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $5e9e2290873d193f$var$baseRest(func, start) {
    return $hiG9p($4fRQb(func, start, $7kIZw), func + '');
}
module.exports = $5e9e2290873d193f$var$baseRest;

});
parcelRegister("4fRQb", function(module, exports) {

var $6HQv1 = parcelRequire("6HQv1");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $319253ca19a6b100$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $319253ca19a6b100$var$overRest(func, start, transform) {
    start = $319253ca19a6b100$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $319253ca19a6b100$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $6HQv1(func, this, otherArgs);
    };
}
module.exports = $319253ca19a6b100$var$overRest;

});
parcelRegister("6HQv1", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $4e1f7b7f62793c9e$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $4e1f7b7f62793c9e$var$apply;

});


parcelRegister("hiG9p", function(module, exports) {

var $fk5NQ = parcelRequire("fk5NQ");

var $kk6UN = parcelRequire("kk6UN");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $c984d05ca2bc6f75$var$setToString = $kk6UN($fk5NQ);
module.exports = $c984d05ca2bc6f75$var$setToString;

});
parcelRegister("fk5NQ", function(module, exports) {

var $ei6nQ = parcelRequire("ei6nQ");

var $di57Q = parcelRequire("di57Q");

var $7kIZw = parcelRequire("7kIZw");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b27d39a2d410f24b$var$baseSetToString = !$di57Q ? $7kIZw : function(func, string) {
    return $di57Q(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $ei6nQ(string),
        'writable': true
    });
};
module.exports = $b27d39a2d410f24b$var$baseSetToString;

});
parcelRegister("ei6nQ", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $a677b2c568368f7c$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $a677b2c568368f7c$var$constant;

});

parcelRegister("di57Q", function(module, exports) {

var $jAYxa = parcelRequire("jAYxa");
var $9ad0eea5f2381159$var$defineProperty = function() {
    try {
        var func = $jAYxa(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $9ad0eea5f2381159$var$defineProperty;

});


parcelRegister("kk6UN", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ecbb0a18067f1a9c$var$HOT_COUNT = 800, $ecbb0a18067f1a9c$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ecbb0a18067f1a9c$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ecbb0a18067f1a9c$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ecbb0a18067f1a9c$var$nativeNow(), remaining = $ecbb0a18067f1a9c$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ecbb0a18067f1a9c$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $ecbb0a18067f1a9c$var$shortOut;

});



parcelRegister("ecELx", function(module, exports) {

var $pkV5g = parcelRequire("pkV5g");

var $iHYLr = parcelRequire("iHYLr");

var $jshhj = parcelRequire("jshhj");

var $e3UGS = parcelRequire("e3UGS");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $a571ceeb4d2705ae$var$isIterateeCall(value, index, object) {
    if (!$e3UGS(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $iHYLr(object) && $jshhj(index, object.length) : type == 'string' && index in object) return $pkV5g(object[index], value);
    return false;
}
module.exports = $a571ceeb4d2705ae$var$isIterateeCall;

});


parcelRegister("itj94", function(module, exports) {
"use strict";
function $d729c943390d67ec$var$_slicedToArray(r, e) {
    return $d729c943390d67ec$var$_arrayWithHoles(r) || $d729c943390d67ec$var$_iterableToArrayLimit(r, e) || $d729c943390d67ec$var$_unsupportedIterableToArray(r, e) || $d729c943390d67ec$var$_nonIterableRest();
}
function $d729c943390d67ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d729c943390d67ec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d729c943390d67ec$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d729c943390d67ec$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d729c943390d67ec$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d729c943390d67ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d729c943390d67ec$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $d729c943390d67ec$var$generateYearArray(maxYear, minYear) {
    if (minYear > maxYear) throw new Error('Min year must be less than max year');
    var year = maxYear;
    var years = [];
    while(year >= minYear){
        years.push(year);
        year -= 1;
    }
    return years;
}
var $d729c943390d67ec$var$minBatTrackingDate = '2023-07-14';
// This will potentially be out of date until the next time the pod restarts after the new year, hence "ish"
var $d729c943390d67ec$var$currentYearIsh = new Date().getFullYear();
var $d729c943390d67ec$var$minStatcastYear = 2015;
var $d729c943390d67ec$var$minPitchFxYear = 2008;
var $d729c943390d67ec$var$thresholds = {
    // We'll use actual months rather than JS zero indexed
    spring: [
        2,
        16
    ],
    // day after spring opener
    first: [
        3,
        27
    ],
    // day after MLB opener
    firstMinors: [
        3,
        28
    ],
    // day after AAA opener
    second: [
        3,
        31
    ],
    // 3-5 days after MLB opener
    third: [
        4,
        10
    ],
    // couple weeks for later stuff
    fourth: [
        5,
        1
    ] // real slow things
};
function $d729c943390d67ec$var$getThresholdYear(type) {
    var _thresholds$type = $d729c943390d67ec$var$_slicedToArray($d729c943390d67ec$var$thresholds[type], 2), month = _thresholds$type[0], day = _thresholds$type[1];
    if (!month || !day) throw new Error("no threshold of type ".concat(type));
    var now = new Date();
    var currentYear = now.getFullYear();
    // EDT is 4 hours behind UTC. So 8 o'clock there gets us to about 4am EDT, about when the nightly load might be finishing up running
    var thresholdUnix = Date.UTC(currentYear, month - 1, day, 8, 0, 0, 0);
    var thresholdYear = thresholdUnix < now ? currentYear : currentYear - 1;
    return thresholdYear;
}
function $d729c943390d67ec$var$getFirstThresholdDate() {
    var now = new Date();
    var currentYear = now.getFullYear();
    return new Date(currentYear, 2, 27); // March 27th
}
var $d729c943390d67ec$var$appSettings = {
    // Home page
    SETTINGS_TOP_PERFORMERS: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    dragDashboard: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        }
    },
    // Batting
    batTracking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            return $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$getThresholdYear('first'), 2023);
        },
        minBatTrackingDate: $d729c943390d67ec$var$minBatTrackingDate
    },
    battedBall: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear1 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear1, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    exitVelocity: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear2 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear2, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    expectedStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear3 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear3, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    homeRunTracking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear4 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear4, 2019);
        }
    },
    percentileRankings: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear5 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear5, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    pitchArsenalStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        min: 1,
        minPitches: 'q',
        useCache: true,
        get years () {
            var firstThresholdYear6 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear6, 2019);
        }
    },
    pitcherArmAngles: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear7 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear7, 2020);
        }
    },
    pitcherTempo: {
        baseState: 'Bases Empty',
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        minPitches: 'q',
        isTake: 1,
        useCache: true,
        get years () {
            var firstThresholdYear8 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear8, 2010);
        }
    },
    swingTake: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear9 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear9, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_YEAR_TO_YEAR: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear10 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear10, firstThresholdYear10 - 8);
        },
        get allYears () {
            var firstThresholdYear11 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear11, 2016);
        },
        useCache: true
    },
    // Pitchers
    // Takes 100 pitches to show up, so don't have 2025 show up as an option early
    activeSpin: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        },
        useCache: true,
        get years () {
            var thirdThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear, 2020);
        },
        min: 50
    },
    pitchArsenals: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        spinCutoffYear: 2015,
        get years () {
            var firstThresholdYear12 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear12, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    pitchMovement: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear13 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear13, 2017);
        }
    },
    // Handles comparison as well
    spinAxis: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear14 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear14, 2020);
        }
    },
    // FIELDING
    armStrength: {
        // Set because 1B is the longest to qualify @100 throws.
        minThrows: 50,
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        useCache: true,
        // Start exposing the new year option later than on other leaderboards
        get years () {
            var thirdThresholdYear1 = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear1, 2020);
        }
    },
    catcherBlocking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear15 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear15, 2018);
        }
    },
    catcherFraming: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear16 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear16, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    catcherFramingOld: {
        year: 2017,
        useCache: true,
        years: $d729c943390d67ec$var$generateYearArray(2017, 2015)
    },
    catcherFramingNew: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear17 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear17, 2018);
        }
    },
    catcherThrowing: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear18 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear18, 2016);
        }
    },
    SETTINGS_CATCHER_STANCE: {
        firstDate: '2020-07-23',
        firstYear: 2020,
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear19 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear19, 2020);
        }
    },
    pitcherRunningGame: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear20 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear20, 2016);
        }
    },
    fieldingRuns: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear21 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear21, 2016);
        }
    },
    SETTINGS_FIELDING_RUN_VALUE: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear22 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear22, 2018);
        },
        firstYear: 2018,
        firstDate: '2018-03-29'
    },
    poptime: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear23 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear23, $d729c943390d67ec$var$minStatcastYear);
        },
        useCache: true,
        min: 5
    },
    catchProbability: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear24 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear24, 2016);
        }
    },
    directionalCatchProbability: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear25 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear25, 2016);
        }
    },
    infieldDefense: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        min: 10,
        useCache: true,
        get years () {
            var firstThresholdYear26 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear26, 2016);
        }
    },
    jump: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear27 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear27, 2016);
        }
    },
    baseRunning: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear28 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear28, 2016);
        }
    },
    baseRunningRunValue: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear29 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear29, 2016);
        }
    },
    basestealingRunningGame: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear30 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear30, 2016);
        }
    },
    sprintSpeed: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear31 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear31, $d729c943390d67ec$var$minStatcastYear);
        },
        min: 10
    },
    runningSplits: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        get playerYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        useCache: true,
        min: 5,
        get years () {
            var thirdThresholdYear2 = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear2, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_SLBI: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        dateMin: "".concat($d729c943390d67ec$var$currentYearIsh, "-03-22"),
        dateMax: "".concat($d729c943390d67ec$var$currentYearIsh, "-11-01")
    },
    // This is only powering an old URL that's kept around for scrapers
    oaa: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        useCache: true
    },
    parkFactors: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        firstWallChangeYear: 2022,
        secondWallChangeYear: 2025,
        get years () {
            var firstThresholdYear32 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear32, 1969);
        },
        get statcastyYears () {
            var firstThresholdYear33 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear33, 2016);
        },
        get dimensionYears () {
            var firstThresholdYear34 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear34, 2015);
        },
        earliestParkFactorYear: 1969,
        wallChangeDefault: 2024,
        wallChangeYears: $d729c943390d67ec$var$generateYearArray(2024, 2022),
        get secondWallChangeYears () {
            var secondThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear, 2025);
        }
    },
    sortableStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear35 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear35, 1950);
        }
    },
    // /statcast_hit_probability
    breakdown: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear36 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear36, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    pitchTimerInfractions: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            var firstThresholdYear37 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear37, 2023);
        }
    },
    // /replay
    replay: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        useCache: true,
        get years () {
            var firstThresholdYear38 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear38, 2014);
        }
    },
    // NON LEADERBOARD PLACES
    SETTINGS_STATISTICS_MENU: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            var firstThresholdYear39 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear39, firstThresholdYear39 - 5);
        },
        get statcastYears () {
            var firstThresholdYear40 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear40, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_DERBY: {
        year: 2025,
        years: $d729c943390d67ec$var$generateYearArray(2025, 2017)
    },
    draft: {
        year: 2025,
        years: $d729c943390d67ec$var$generateYearArray(2025, 1965)
    },
    games: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    illustrator: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var springThresholdYear = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    league: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            var firstThresholdYear41 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear41, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    team: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            var firstThresholdYear42 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear42, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    playerScroll: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        }
    },
    // I feel like these should always have a year selected, but perhaps I'm wrong.
    searchCharts: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    SETTINGS_METRICS_CONTEXT: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear43 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear43, 2016);
        },
        minBatTrackingDate: $d729c943390d67ec$var$minBatTrackingDate,
        minBatTrackingYear: 2023
    },
    // Okay if this is slow, so an injured player could trend
    trending: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        }
    },
    weightedGameScore: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    // VISUALS imported
    brushing: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear44 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear44, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_AFFINITY: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    SETTINGS_HITTING_SIGNATURE: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear45 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear45, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_PLAYER_COMPARISON: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear46 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear46, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    // Flip When Schedule Comes Out
    map: {
        currentYear: 2025,
        years: $d729c943390d67ec$var$generateYearArray(2026, 1974)
    },
    oaaVisual: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear47 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear47, 2016);
        }
    },
    pitchPercent: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear48 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear48, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    pitchPlinko: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        },
        get years () {
            var thirdThresholdYear3 = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear3, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    positioning: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var firstThresholdYear49 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear49, 2016);
        }
    },
    swingMissProfile: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var secondThresholdYear1 = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear1, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    swingTakeVisual: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var secondThresholdYear2 = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear2, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    textureHeatMap: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var secondThresholdYear3 = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear3, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_HOT_STOVE: {
        currentYear: 2026,
        years: $d729c943390d67ec$var$generateYearArray(2026, 2020),
        yearsOptions: $d729c943390d67ec$var$generateYearArray(2026, 2020).map(function(d) {
            return {
                label: "".concat(d - 1, " - ").concat(d),
                value: d
            };
        }),
        get statYears () {
            var firstThresholdYear50 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear50, 2019);
        },
        minPa: 100,
        minIp: 20,
        // Magic Numbers
        MAGIC: {
            unsigned: 99887766,
            sameTeam: 99998888,
            diffTeam: 99997777
        }
    },
    // GAMES
    SETTINGS_SPRAY_CHART_GAME: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    // INTERNAL PAGES
    SETTINGS_PLAYER_RANKING: {
        lastTwoYears: $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$currentYearIsh, $d729c943390d67ec$var$currentYearIsh - 1)
    },
    // PLAYER PAGE
    SETTINGS_PLAYER_PAGE: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    SETTINGS_VENUE_INFO: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            var firstThresholdYear51 = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear51, 2015);
        }
    },
    // CHANGELOG
    SETTINGS_CHANGELOG: {
        currentYear: $d729c943390d67ec$var$currentYearIsh,
        years: $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$currentYearIsh, 2025)
    },
    // ABS
    SETTINGS_ABS: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('spring');
        },
        get regSeasonFlipDate () {
            return $d729c943390d67ec$var$getFirstThresholdDate();
        },
        firstMajorsYear: 2026,
        firstMinorsYear: 2025,
        // TODO: Change when threshold year flips
        get majorsYears () {
            var springThresholdYear1 = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear1, 2025);
        },
        get minorsYears () {
            var springThresholdYear2 = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear2, 2025);
        }
    },
    PIPELINE_PROSPECTS_CRON: {
        // Used for team history join
        currentYear: 2026
    },
    SETTINGS_SEARCH: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('spring');
        },
        get currentMinorsYear () {
            return $d729c943390d67ec$var$getThresholdYear('firstMinors');
        },
        firstMinorsYear: 2021,
        firstStatcastYear: 2015,
        firstMajorsYear: 2008,
        wbcYears: [
            2026,
            2023
        ]
    },
    SETTINGS_COMPARISON_TOOL: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            var currentYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(currentYear, 2015);
        }
    }
};
module.exports = {
    appSettings: $d729c943390d67ec$var$appSettings,
    minPitchFxYear: $d729c943390d67ec$var$minPitchFxYear,
    minStatcastYear: $d729c943390d67ec$var$minStatcastYear,
    // Most things default to this
    currentYear: $d729c943390d67ec$var$getThresholdYear('second')
};

});

parcelRegister("kSUb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $f3446db2400b2b9c$var$_default = module.exports["default"] = {
    seasonTypes: [
        {
            value: 'S',
            name: 'Spring'
        },
        {
            value: 'R',
            name: 'Regular Season'
        },
        {
            value: 'F',
            name: 'Wild Card'
        },
        {
            value: 'D',
            name: 'Division Series'
        },
        {
            value: 'L',
            name: 'Championship Series'
        },
        {
            value: 'W',
            name: 'World Series'
        }
    ],
    plateAppearanceResults: [
        {
            value: 'single',
            name: 'Single'
        },
        {
            value: 'double',
            name: 'Double'
        },
        {
            value: 'triple',
            name: 'Triple'
        },
        {
            value: 'home_run',
            name: 'Home Run'
        },
        {
            value: 'strikeout',
            name: 'Strikeout'
        },
        {
            value: 'strikeout_double_play',
            name: 'Strikeout Double Play'
        },
        {
            value: 'walk',
            name: 'Walk'
        },
        {
            value: 'double_play',
            name: 'Double Play'
        },
        {
            value: 'error',
            name: 'Error'
        },
        {
            value: 'field_error',
            name: 'Field Error'
        },
        {
            value: 'fielders_choice',
            name: 'Fielders Choice'
        },
        {
            value: 'fielders_choice_out',
            name: 'Fielders Choice - Out'
        },
        {
            value: 'field_out',
            name: 'Field Out'
        },
        {
            value: 'force_out',
            name: 'Force Out'
        },
        {
            value: 'grounded_into_double_play',
            name: 'Ground Into Double Play'
        },
        {
            value: 'hit_by_pitch',
            name: 'Hit By Pitch'
        },
        {
            value: 'in_progress',
            name: 'In Progress'
        },
        {
            value: 'sac_bunt',
            name: 'Sac Bunt'
        },
        {
            value: 'sac_bunt_double_play',
            name: 'Sac Bunt - Double Play'
        },
        {
            value: 'sac_fly',
            name: 'Sac Fly'
        },
        {
            value: 'sac_fly_double_play',
            name: 'Sac Fly - Double Play'
        }
    ],
    pitchTypes: [
        {
            value: 'FF',
            name: '4-Seam Fastball'
        },
        {
            value: 'FT',
            name: '2-Seam Fastball'
        },
        {
            value: 'FC',
            name: 'Cutter'
        },
        {
            value: 'SI',
            name: 'Sinker'
        },
        {
            value: 'FS',
            name: 'Split-Finger'
        },
        {
            value: 'SL',
            name: 'Slider'
        },
        {
            value: 'CH',
            name: 'Changeup'
        },
        {
            value: 'CU',
            name: 'Curveball'
        },
        {
            value: 'KC',
            name: 'Knuckle Curve'
        },
        {
            value: 'KN',
            name: 'Knuckleball'
        },
        {
            value: 'FO',
            name: 'Forkball'
        },
        {
            value: 'EP',
            name: 'Eephus'
        },
        {
            value: 'SC',
            name: 'Screwball'
        },
        {
            value: 'AB',
            name: 'Automatic'
        },
        {
            value: 'CS',
            name: 'Curveball'
        },
        {
            value: 'FA',
            name: 'Fastball'
        },
        {
            value: 'IN',
            name: 'Intentional'
        },
        {
            value: 'PO',
            name: 'Pitchout'
        },
        {
            value: 'UN',
            name: 'Unknown'
        }
    ],
    pitchResult: [
        {
            value: 'hit_into_play',
            name: 'Hit into Play'
        },
        {
            value: 'ball',
            name: 'Ball'
        },
        {
            value: 'blocked_ball',
            name: 'Blocked Ball In Dirt'
        },
        {
            value: 'called_strike',
            name: 'Called Strike'
        },
        {
            value: 'swinging_strike',
            name: 'Swinging Strike'
        },
        {
            value: 'swinging_strike_blocked',
            name: 'Swinging Strike in Dirt'
        },
        {
            value: 'swinging_pitchout',
            name: 'Swinging Pitchout'
        },
        {
            value: 'missed_bunt',
            name: 'Missed Bunt'
        },
        {
            value: 'bunt_foul_tip',
            name: 'Foul Tip Bunt'
        },
        {
            value: 'foul',
            name: 'Foulball'
        },
        {
            value: 'foul_bunt',
            name: 'Foul - Bunt'
        },
        {
            value: 'foul_tip',
            name: 'Foul Tip'
        },
        {
            value: 'foul_pitchout',
            name: 'Foul Pitchout'
        },
        {
            value: 'hit_by_pitch',
            name: 'Hit by Pitch'
        },
        {
            value: 'pitchout',
            name: 'Pitchout'
        }
    ]
};

});

parcelRegister("8iJ1Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $60b2eeed1f301cd7$var$_default = module.exports["default"] = {
    teams: [
        {
            team_id: '108',
            value: 'LAA',
            name: 'Angels'
        },
        {
            team_id: '117',
            value: 'HOU',
            name: 'Astros'
        },
        {
            team_id: '133',
            value: 'OAK',
            name: 'Athletics'
        },
        {
            team_id: '141',
            value: 'TOR',
            name: 'Blue Jays'
        },
        {
            team_id: '144',
            value: 'ATL',
            name: 'Braves'
        },
        {
            team_id: '158',
            value: 'MIL',
            name: 'Brewers'
        },
        {
            team_id: '138',
            value: 'STL',
            name: 'Cardinals'
        },
        {
            team_id: '112',
            value: 'CHC',
            name: 'Cubs'
        },
        {
            team_id: '109',
            value: 'ARI',
            name: 'D-backs'
        },
        {
            team_id: '119',
            value: 'LAD',
            name: 'Dodgers'
        },
        {
            team_id: '137',
            value: 'SF',
            name: 'Giants'
        },
        {
            team_id: '114',
            value: 'CLE',
            name: 'Guardians'
        },
        {
            team_id: '136',
            value: 'SEA',
            name: 'Mariners'
        },
        {
            team_id: '146',
            value: 'MIA',
            name: 'Marlins'
        },
        {
            team_id: '121',
            value: 'NYM',
            name: 'Mets'
        },
        {
            team_id: '120',
            value: 'WSH',
            name: 'Nationals'
        },
        {
            team_id: '110',
            value: 'BAL',
            name: 'Orioles'
        },
        {
            team_id: '135',
            value: 'SD',
            name: 'Padres'
        },
        {
            team_id: '143',
            value: 'PHI',
            name: 'Phillies'
        },
        {
            team_id: '134',
            value: 'PIT',
            name: 'Pirates'
        },
        {
            team_id: '140',
            value: 'TEX',
            name: 'Rangers'
        },
        {
            team_id: '139',
            value: 'TB',
            name: 'Rays'
        },
        {
            team_id: '113',
            value: 'CIN',
            name: 'Reds'
        },
        {
            team_id: '111',
            value: 'BOS',
            name: 'Red Sox'
        },
        {
            team_id: '115',
            value: 'COL',
            name: 'Rockies'
        },
        {
            team_id: '118',
            value: 'KC',
            name: 'Royals'
        },
        {
            team_id: '116',
            value: 'DET',
            name: 'Tigers'
        },
        {
            team_id: '142',
            value: 'MIN',
            name: 'Twins'
        },
        {
            team_id: '145',
            value: 'CWS',
            name: 'White Sox'
        },
        {
            team_id: '147',
            value: 'NYY',
            name: 'Yankees'
        }
    ],
    teamsById: [
        {
            value: '108',
            name: 'Angels'
        },
        {
            value: '117',
            name: 'Astros'
        },
        {
            value: '133',
            name: 'Athletics'
        },
        {
            value: '141',
            name: 'Blue Jays'
        },
        {
            value: '144',
            name: 'Braves'
        },
        {
            value: '158',
            name: 'Brewers'
        },
        {
            value: '138',
            name: 'Cardinals'
        },
        {
            value: '112',
            name: 'Cubs'
        },
        {
            value: '109',
            name: 'D-backs'
        },
        {
            value: '119',
            name: 'Dodgers'
        },
        {
            value: '137',
            name: 'Giants'
        },
        {
            value: '114',
            name: 'Guardians'
        },
        {
            value: '136',
            name: 'Mariners'
        },
        {
            value: '146',
            name: 'Marlins'
        },
        {
            value: '121',
            name: 'Mets'
        },
        {
            value: '120',
            name: 'Nationals'
        },
        {
            value: '110',
            name: 'Orioles'
        },
        {
            value: '135',
            name: 'Padres'
        },
        {
            value: '143',
            name: 'Phillies'
        },
        {
            value: '134',
            name: 'Pirates'
        },
        {
            value: '140',
            name: 'Rangers'
        },
        {
            value: '139',
            name: 'Rays'
        },
        {
            value: '113',
            name: 'Reds'
        },
        {
            value: '111',
            name: 'Red Sox'
        },
        {
            value: '115',
            name: 'Rockies'
        },
        {
            value: '118',
            name: 'Royals'
        },
        {
            value: '116',
            name: 'Tigers'
        },
        {
            value: '142',
            name: 'Twins'
        },
        {
            value: '145',
            name: 'White Sox'
        },
        {
            value: '147',
            name: 'Yankees'
        }
    ]
};

});

parcelRegister("h51r7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $c6f4048bbf9a4966$var$_default = module.exports["default"] = {
    venues: [
        {
            name: 'Angels - Angel Stadium',
            value: 1
        },
        {
            name: 'Astros - Daikin Park',
            value: 2392
        },
        {
            name: 'Athletics - Sutter Health Park',
            value: 2529
        },
        {
            name: 'Blue Jays - Rogers Centre',
            value: 14
        },
        {
            name: 'Braves - Truist Park',
            value: 4705
        },
        {
            name: 'Brewers - American Family Field',
            value: 32
        },
        {
            name: 'Cardinals - Busch Stadium',
            value: 2889
        },
        {
            name: 'Cubs - Wrigley Field',
            value: 17
        },
        {
            name: 'Diamondbacks - Chase Field',
            value: 15
        },
        {
            name: 'Dodgers - Dodger Stadium',
            value: 22
        },
        {
            name: 'Giants - Oracle Park',
            value: 2395
        },
        {
            name: 'Guardians - Progressive Field',
            value: 5
        },
        {
            name: 'Mariners - T-Mobile Park',
            value: 680
        },
        {
            name: 'Marlins - Marlins Park',
            value: 4169
        },
        {
            name: 'Mets - Citi Field',
            value: 3289
        },
        {
            name: 'Nationals - Nationals Park',
            value: 3309
        },
        {
            name: 'Orioles - Oriole Park',
            value: 2
        },
        {
            name: 'Padres - Petco Park',
            value: 2680
        },
        {
            name: 'Phillies - Citizens Bank Park',
            value: 2681
        },
        {
            name: 'Pirates - PNC Park',
            value: 31
        },
        {
            name: 'Rangers - Globe Life Field',
            value: 5325
        },
        {
            name: 'Rays - Tropicana Field',
            value: 12
        },
        {
            name: 'Red Sox - Fenway Park',
            value: 3
        },
        {
            name: 'Reds - GABP',
            value: 2602
        },
        {
            name: 'Rockies - Coors Field',
            value: 19
        },
        {
            name: 'Royals - Kauffman Stadium',
            value: 7
        },
        {
            name: 'Tigers - Comerica Park',
            value: 2394
        },
        {
            name: 'Twins - Target Field',
            value: 3312
        },
        {
            name: 'White Sox - Rate Field',
            value: 4
        },
        {
            name: 'Yankees - Yankee Stadium',
            value: 3313
        },
        // // Extras
        {
            name: 'Athletics - Oakland Coliseum',
            value: 10,
            extra: true
        },
        // Doesn't work with 3D FYI, don't know why
        {
            name: 'Braves - Turner Field',
            value: 16,
            extra: true,
            no3d: true
        },
        {
            name: 'Rangers - Globe Life Park',
            value: 13,
            extra: true,
            no3d: true
        },
        // Doesn't work with 3D FYI, don't know why
        {
            name: 'Rays - George M. Steinbrenner Field',
            value: 2523,
            extra: true
        },
        {
            name: 'Bristol Motor Speedway',
            value: 6130,
            extra: true
        },
        {
            name: 'Field of Dreams',
            value: 5445,
            extra: true
        },
        // Missing from FencesLidar
        {
            name: 'Estadio Hiram Bithorn.',
            value: 2535,
            extra: true,
            no3d: true
        },
        {
            name: 'Las Vegas Ballpark',
            value: 5355,
            extra: true
        },
        // Missing from FencesLidar
        {
            name: 'Polo Grounds',
            value: 3140,
            extra: true,
            no3d: true
        }
    ]
};

});

parcelRegister("fKd4Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $944a42ec455eead4$var$runCalculations;

var $5eFx0 = parcelRequire("5eFx0");

var $5kS6g = parcelRequire("5kS6g");
function $944a42ec455eead4$var$threeDigitFormat(val) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
        if (val === null || val === undefined) return placeholder;
        var num = Number(val);
        if (num >= 0 && num < 1) return num.toFixed(3).slice(-4);
        // Negative numbers? Meh
        return num.toFixed(3);
    } catch (e) {
        console.error('threeDigitFormat error', e, val);
        return String(val);
    }
}
var $944a42ec455eead4$var$batTrackingMetricKeys = {
    attackAngle: {
        dbProp: 'attack_angle'
    },
    attackDirection: {
        dbProp: 'attack_direction'
    },
    batSpeed: {
        dbProp: 'sweetspot_speed_mph'
    },
    swingLength: {
        dbProp: 'swing_length'
    },
    swingPathTilt: {
        dbProp: 'swing_path_tilt'
    },
    idealAttackAngle: {
        // This isn't a db property, but I add it manually
        dbProp: 'ideal_angle'
    }
};
var $944a42ec455eead4$var$batTrackingMetrics = Object.keys($944a42ec455eead4$var$batTrackingMetricKeys);
function $944a42ec455eead4$var$addBatTrackingMetricsRaw(calculations, row) {
    if ((0, $5kS6g.isGamefeedRawData)(row.raw)) return;
    var rawData = row.raw;
    $944a42ec455eead4$var$batTrackingMetrics.forEach(function(prop) {
        var dbProp = $944a42ec455eead4$var$batTrackingMetricKeys[prop].dbProp;
        if (!dbProp) throw new Error("missing database property ".concat(prop));
        var sumKey = "".concat(prop, "Sum");
        var competitiveSumKey = "".concat(prop, "CompetitiveSum");
        calculations[sumKey] += row.trackedBatSpeed ? Number(rawData[dbProp]) : 0;
        calculations[competitiveSumKey] += row.trackedBatSpeedCompetitive ? Number(rawData[dbProp]) : 0;
    });
}
function $944a42ec455eead4$var$addBatTrackingMetricsPercents(calculations, trackedBatSpeed, trackedBatSpeedCompetitive) {
    $944a42ec455eead4$var$batTrackingMetrics.forEach(function(prop) {
        var sumKey = "".concat(prop, "Sum");
        var competitiveKey = "".concat(prop, "Competitive");
        var competitiveSumKey = "".concat(prop, "CompetitiveSum");
        calculations[sumKey] = trackedBatSpeed ? calculations[sumKey] / trackedBatSpeed : null;
        calculations[competitiveKey] = trackedBatSpeedCompetitive ? calculations[competitiveSumKey] / trackedBatSpeedCompetitive : null;
    });
}
function $944a42ec455eead4$var$runCalculations(data, totalSize) {
    var trackedSwingLength = data.filter(function(d) {
        return d.trackedSwingLength;
    }).length;
    var trackedSwingLengthCompetitive = data.filter(function(d) {
        return d.trackedSwingLengthCompetitive;
    }).length;
    var trackedBatSpeed = data.filter(function(d) {
        return d.trackedBatSpeed;
    }).length;
    var trackedBatSpeedCompetitive = data.filter(function(d) {
        return d.trackedBatSpeedCompetitive;
    }).length;
    var calculations = {
        totalPitches: data.length,
        hits: 0,
        bip: 0,
        trackedBIP: 0,
        trackedSwingLength: trackedSwingLength,
        trackedBatSpeed: trackedBatSpeed,
        trackedSwingLengthCompetitive: trackedSwingLengthCompetitive,
        trackedBatSpeedCompetitive: trackedBatSpeedCompetitive,
        ab: 0,
        pa: 0,
        hr: 0,
        so: 0,
        single: 0,
        "double": 0,
        triple: 0,
        pitches: 0,
        wobaNumer: 0,
        wobaDenom: 0,
        xWobaNumer: 0,
        xWobaDenom: 0,
        runExp: 0,
        pitcherRunExp: 0,
        swings: 0,
        whiffs: 0,
        launchSpeed: 0,
        launchAngle: 0,
        releaseSpeedSum: 0,
        releaseSpinRateSum: 0,
        batSpeedSum: 0,
        batSpeedCompetitiveSum: 0,
        swingLengthSum: 0,
        swingLengthCompetitiveSum: 0,
        idealAttackAngleSum: 0,
        idealAttackAngleCompetitiveSum: 0,
        attackAngleSum: 0,
        attackAngleCompetitiveSum: 0,
        attackDirectionSum: 0,
        attackDirectionCompetitiveSum: 0,
        swingPathTiltSum: 0,
        swingPathTiltCompetitiveSum: 0,
        // Averages
        percent: null,
        avgExitVelocity: null,
        avgLaunchAngle: null,
        ba: null,
        woba: null,
        slg: null,
        slgRaw: null,
        xWoba: null,
        kPercent: null,
        swing_miss_percent: null,
        releaseSpeed: null,
        releaseSpinRate: null,
        batSpeed: null,
        batSpeedCompetitive: null,
        swingLength: null,
        swingLengthCompetitive: null,
        idealAttackAngle: null,
        idealAttackAngleCompetitive: null,
        attackAngle: null,
        attackAngleCompetitive: null,
        attackDirection: null,
        attackDirectionCompetitive: null,
        swingPathTilt: null,
        swingPathTiltCompetitive: null
    };
    var trackedSpin = data.filter(function(d) {
        return d.releaseSpinRate;
    }).length;
    var trackedSpeed = data.filter(function(d) {
        return d.releaseSpeed;
    }).length;
    for(var i = 0; i < data.length; i++){
        var d = data[i];
        if (!(0, $5kS6g.isGamefeedRawData)(d.raw) && d.raw.attack_angle) d.raw.ideal_angle = d.trackedBatSpeed && d.raw.attack_angle >= 5 && d.raw.attack_angle <= 20 ? 1 : 0;
        calculations.hits += Number(d.hits);
        calculations.ab += Number(d.ab);
        calculations.pa += Number(d.pa);
        calculations.bip += Number(d.bip);
        calculations.swings += d.is_swing ? d.is_swing : 0;
        calculations.whiffs += d.is_whiff ? d.is_whiff : 0;
        if (d.launchSpeed && d.launchSpeed > 0) calculations.trackedBIP += 1;
        calculations.single += Number(d.single);
        calculations["double"] += Number(d["double"]);
        calculations.triple += Number(d.triple);
        calculations.hr += Number(d.hr);
        calculations.so += Number(d.so);
        calculations.launchSpeed += !Number.isNaN(d.launchSpeed) ? Number(d.launchSpeed) : 0;
        calculations.launchAngle += !Number.isNaN(d.launchAngle) ? Number(d.launchAngle) : 0;
        calculations.wobaNumer += Number(d.wobaNumer);
        calculations.wobaDenom += Number(d.wobaDenom);
        calculations.xWobaNumer += Number(d.xWobaNumer);
        calculations.xWobaDenom += Number(d.xWobaDenom);
        // pitch
        calculations.releaseSpeedSum += Number.isNaN(d.releaseSpeed) ? 0 : d.releaseSpeed;
        calculations.releaseSpinRateSum += Number.isNaN(d.releaseSpinRate) ? 0 : d.releaseSpinRate;
        if (d.deltaRunExp) {
            calculations.runExp = Number(calculations.runExp) + (Number.isNaN(d.deltaRunExp) ? 0 : d.deltaRunExp);
            calculations.pitcherRunExp = Number(calculations.pitcherRunExp) - (Number.isNaN(d.deltaRunExp) ? 0 : d.deltaRunExp);
        }
        // Add bat tracking metrics
        $944a42ec455eead4$var$addBatTrackingMetricsRaw(calculations, d);
        var isPitch = d.event_type && ![
            'automatic_ball',
            'automatic_strike',
            'intent_ball'
        ].includes(d.event_type);
        if (d.pitchType !== '' && !isPitch) calculations.pitches += 1;
    }
    // Averages/Percents
    calculations.percent = (calculations.pitches / totalSize * 100).toFixed(1);
    calculations.avgExitVelocity = calculations.trackedBIP ? (calculations.launchSpeed / calculations.trackedBIP).toFixed(1) : null;
    calculations.avgLaunchAngle = calculations.trackedBIP ? (calculations.launchAngle / calculations.trackedBIP).toFixed(0) : null;
    calculations.ba = calculations.ab ? $944a42ec455eead4$var$removeLeadingZero((calculations.hits / calculations.ab).toFixed(3)) : null;
    calculations.woba = calculations.wobaDenom ? $944a42ec455eead4$var$removeLeadingZero((calculations.wobaNumer / calculations.wobaDenom).toFixed(3)) : null;
    if (calculations.ab) {
        var slg = (calculations.single + 2 * calculations["double"] + 3 * calculations.triple + 4 * calculations.hr) / calculations.ab;
        calculations.slgRaw = slg;
        calculations.slg = $944a42ec455eead4$var$threeDigitFormat(slg);
    } else calculations.slg = null;
    if (calculations.xWobaDenom) calculations.xWoba = $944a42ec455eead4$var$removeLeadingZero((calculations.xWobaNumer / calculations.xWobaDenom).toFixed(3));
    calculations.kPercent = calculations.pa ? (calculations.so / calculations.pa * 100).toFixed(1) : null;
    calculations.swing_miss_percent = calculations.swings ? (0, $5eFx0.guff)(100 * calculations.whiffs / calculations.swings, 'swing_miss_percent') : null;
    calculations.releaseSpeed = trackedSpeed ? (calculations.releaseSpeedSum / trackedSpeed).toFixed(1) : 0;
    calculations.releaseSpinRate = trackedSpin ? Math.round(calculations.releaseSpinRateSum / trackedSpin) : null;
    calculations.runExp = Number(calculations.runExp).toFixed(1);
    calculations.pitcherRunExp = Number(calculations.pitcherRunExp).toFixed(1);
    $944a42ec455eead4$var$addBatTrackingMetricsPercents(calculations, trackedBatSpeed, trackedBatSpeedCompetitive);
    return calculations;
}
/* eslint-disable no-param-reassign */ function $944a42ec455eead4$var$removeLeadingZero(value) {
    try {
        if (value.substring(0, 1) === '0') value = value.substring(1, value.length);
        else if (value.substring(0, 2) === '-0') value = "-".concat(value.substring(2, value.length));
    } catch (ex) {
    /* empty */ }
    return value;
} /* eslint-enable no-param-reassign */ 

});
parcelRegister("5eFx0", function(module, exports) {
"use strict";
function $3cfe79d709e6baf3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cfe79d709e6baf3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cfe79d709e6baf3$var$_typeof(o);
}
function $3cfe79d709e6baf3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cfe79d709e6baf3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cfe79d709e6baf3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cfe79d709e6baf3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cfe79d709e6baf3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cfe79d709e6baf3$var$_defineProperty(e, r, t) {
    return (r = $3cfe79d709e6baf3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3cfe79d709e6baf3$var$_toPropertyKey(t) {
    var i = $3cfe79d709e6baf3$var$_toPrimitive(t, "string");
    return "symbol" == $3cfe79d709e6baf3$var$_typeof(i) ? i : i + "";
}
function $3cfe79d709e6baf3$var$_toPrimitive(t, r) {
    if ("object" != $3cfe79d709e6baf3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3cfe79d709e6baf3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// @ts-check
// grand unified formatting function
/**
 *
 * @param {number} val
 * @param {number} digits
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$toFixed(val, digits) {
    var string = Number(val).toFixed(digits);
    // Ditch -0.0
    return 1 / Number(string) === -Infinity ? 0..toFixed(digits) : string;
}
// Realistically, we have too many changes of spellings and things to not do this, sadly
/**
 *
 * @param {string} type
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$getStandardizedType(type) {
    // of the form { alt: standard }
    /** @type {Record<string, string>} */ var altSpellings = {
        abs: 'ab',
        avg_swing_length: 'swing_length_qualified',
        avg_swing_speed: 'swing_speed_qualified',
        barrels: 'barrel',
        barrels_per_bbe_percent: 'barrel_batted_rate',
        barrels_per_pa_percent: 'barrels_per_pa',
        batting_avg: 'ba',
        bb: 'walk',
        dbls: 'double',
        ev: 'launch_speed',
        hardhit_percent: 'hard_hit_percent',
        hits: 'hit',
        hrs: 'home_run',
        isolated_power: 'iso',
        on_base_percent: 'obp',
        on_base_plus_slg: 'ops',
        pitch_speed: 'pitch_velocity',
        singles: 'single',
        slg_percent: 'slg',
        so: 'strikeout',
        triples: 'triple',
        attack_angle: 'bat_path_angle',
        attack_angle_asc: 'bat_path_angle',
        attack_direction: 'bat_path_angle',
        attack_direction_pullopp: 'bat_path_angle',
        swing_path_tilt: 'bat_path_angle',
        avg_plane_vertical_angle: 'bat_path_angle',
        avg_plane_vertical_angle_asc: 'bat_path_angle',
        vertical_swing_path: 'bat_path_angle',
        bat_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_y_inches: 'dist_in_inches',
        bat_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_x_inches: 'dist_in_inches',
        pull_percent_airballs: 'airballs_percent',
        // bit of a hack
        spin_rate: '_avg_spin'
    };
    return altSpellings[type] || type;
}
/**
 *
 * @param {number|string} val
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$threeDigitFormat(val) {
    var num = Number(val);
    if (num >= 0 && num < 1) return num.toFixed(3).slice(-4);
    if (num < 0 && num > -1) return "-".concat(Math.abs(num).toFixed(3).slice(-4));
    return num.toFixed(3);
}
var $3cfe79d709e6baf3$var$threeDigitTypes = [
    'ba',
    'xba',
    'est_ba',
    'obp',
    'xobp',
    'est_obp',
    'slg',
    'xslg',
    'est_slg',
    'iso',
    'xiso',
    'est_iso',
    'ops',
    'babip',
    'est_babip',
    'woba',
    'xwoba',
    'est_woba',
    'wobacon',
    'xwobacon',
    'est_wobacon',
    'bacon',
    'xbacon',
    'est_bacon'
];
var $3cfe79d709e6baf3$var$thousandthTypes = [
    'delta_pitcher_run_exp',
    'delta_run_exp',
    'unadj_delta_pitcher_run_exp',
    'unadj_delta_run_exp',
    'delev_delta_pitcher_run_exp',
    'delev_delta_run_exp'
];
var $3cfe79d709e6baf3$var$hundredthTypes = [
    'catcher_exchange',
    'catcher_poptime',
    'pop_2b_sba',
    'home_to_first',
    'running_splits',
    'era',
    'xera',
    'exchange_time',
    'pop_time',
    'rate_cs_aa',
    'runner_stealing_runs_drawer',
    'avg_hr_trot',
    'home_runs_per_nine',
    'runs_gained_per_chal'
];
var $3cfe79d709e6baf3$var$tenthTypes = [
    'hard_hit_percent',
    'launch_speed',
    'exit_velocity_avg',
    'avg_best_speed',
    'hyper_speed',
    'avg_hyper_speed',
    'pitch_tempo_empty',
    'sweet_spot_percent',
    'barrel_batted_rate',
    'barrels_per_pa',
    'launch_angle_avg',
    // Pitch metrics
    'fastball_velo',
    'breaking_velo',
    'offspeed_velo',
    'ff_avg_speed',
    'fastball_extension',
    'pitch_type_percent',
    'pitch_velocity',
    'api_break_z_with_gravity',
    'api_break_z_induced',
    'api_break_x_arm',
    'api_break_x_batter_in',
    'active_spin_percent',
    'pitch_usage_fastball',
    'pitch_usage_offspeed',
    'pitch_usage_breaking',
    // Bat tracking
    'sweetspot_speed_mph',
    'swing_speed',
    'swing_speed_qualified',
    'swing_length',
    'swing_length_qualified',
    'bat_speed_avg',
    'metric-percent',
    'ideal_angle_rate',
    'miss_distance',
    'swing_timing_dist',
    // bat tracking from sortable stats
    'squared_up_contact',
    'squared_up_swing',
    'blasts_swing',
    'blasts_contact',
    'fast_swing_rate',
    'accel_time_ms',
    // Batted Ball
    'popups_percent',
    'flyballs_percent',
    'linedrives_percent',
    'groundballs_percent',
    'airballs_percent',
    'pull_percent',
    'straightaway_percent',
    'opposite_percent',
    'poorlyweak_percent',
    'poorlytopped_percent',
    'poorlyunder_percent',
    'flareburner_percent',
    'solidcontact_percent',
    'hr_flyballs_percent',
    'dist_in_inches',
    // Plate disc
    'in_zone_percent',
    'out_zone_percent',
    'edge_percent',
    'z_swing_percent',
    'oz_swing_percent',
    'iz_contact_percent',
    'oz_contact_percent',
    'whiff_percent',
    'f_strike_percent',
    'f_swing_percent',
    'swing_percent',
    'meatball_swing_percent',
    'meatball_percent',
    'z_swing_miss_percent',
    'oz_swing_miss_percent',
    'swing_miss_percent',
    // Basics
    'k_percent',
    'bb_percent',
    'putaway_percent',
    // catcher arm
    'catcher_arm',
    // Fielding
    'arm_strength_inf',
    'arm_strength_of',
    'arm_overall',
    'outfield_jump',
    'jump_out_percent',
    // Basestealing
    'r_sec_minus_prim_lead',
    'r_sec_minus_prim_lead_sbx',
    // Baserunning
    'sprint_speed',
    'jump',
    'runs_stolen_on_running_act_drawer',
    // Pitcher Stealing
    'r_primary_lead',
    'r_secondary_lead',
    'r_sec_minus_prim_lead',
    'r_primary_lead_sbx',
    'r_secondary_lead_sbx',
    'r_sec_minus_prim_lead_sbx',
    // Catcher framing
    'strike_rate',
    // Catcher throwing
    'arm_strength',
    'distance_to_target',
    'seasonal_sprint_speed',
    // Other
    'game_score',
    'batter_run_value_per_100',
    'pitcher_run_value_per_100',
    'arm_angle',
    'strike_zone_distance',
    'run_value_zone',
    'exp_abs_chals',
    'batter_run_exp_contact',
    'batter_run_exp_take',
    'batter_run_exp_swing',
    'batter_run_exp',
    'pitcher_run_exp_contact',
    'pitcher_run_exp_take',
    'pitcher_run_exp_swing',
    'pitcher_run_exp',
    'edge_dist',
    'abs_chal_runs',
    // ABS
    'overturns_vs_exp',
    'net_net_chal',
    'net_net_chal_against',
    'exp_chal',
    'exp_chal_against',
    'exp_chal_gained_against',
    'exp_chal_gained',
    'exp_chal_lost_against',
    'exp_chal_lost',
    'net_chal_gained_against',
    'net_chal_gained',
    'net_chal_lost_against',
    'net_chal_lost'
];
// Should these be noops? Eh.
var $3cfe79d709e6baf3$var$wholeTypes = [
    'barrel',
    'popups',
    'flyballs',
    'linedrives',
    'groundballs',
    'launch_angle',
    'bbdist',
    // Plate disc.
    'in_zone',
    'out_zone',
    'edge',
    'in_zone_swing',
    'out_zone_swing',
    'in_zone_swing_miss',
    'out_zone_swing_miss',
    // Basic
    'pitch_count',
    'pa',
    'ab',
    'bip',
    'hit',
    'single',
    'double',
    'triple',
    'home_run',
    'walk',
    'strikeout',
    'hbp',
    'batted_ball',
    'pitch_count_fastball',
    'pitch_count_offspeed',
    'pitch_count_breaking',
    'whiffs',
    'swings',
    // Total baserunning
    'runner_runs_sb',
    'runner_runs_xb',
    // Baserunning
    'baserunning',
    'fielder_runs',
    'runner_runs',
    'runner_runs_swipe',
    'runner_runs_snipe',
    'runner_runs_freeze',
    'fielder_runs_swipe',
    'fielder_runs_snipe',
    'fielder_runs_freeze',
    'bolts',
    // Basestealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    'n_init',
    'n_plus',
    'n_minus',
    // Baserunning Top Performers
    'baserunning_runs',
    'basestealing',
    'extra_bases_taken',
    // Pitcher Stealing
    'runs_prevented_on_running_attr',
    'simple_prevented_on_running_attr',
    'net_attr_plus',
    'net_attr_minus',
    // Runner Stealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    // Fielding Runs
    'runs_prevented',
    // Run Value
    'run_value',
    'swing_take_run_value',
    'run_exp',
    'pitcher_run_exp',
    'unadj_run_exp',
    'unadj_pitcher_run_exp',
    'delev_run_exp',
    'delev_pitcher_run_exp',
    'runner_run_value',
    'fielding_run_value',
    'fielding_run_value_arm',
    'pitch_run_value_fastball',
    'pitch_run_value_breaking',
    'pitch_run_value_offspeed',
    'pitcher_stealing_runs',
    'runner_stealing_runs',
    //
    'oaa',
    'outs_above_average',
    'cs_above_average',
    'blocks_above_average',
    'catcher_blocking',
    'catcher_throwing',
    'fielding_run_value',
    'fielding_run_value_framing',
    'framing',
    'player_age',
    // lazy whole ages, someday improve
    'arm_angle_viz',
    // for some reason generally going with whole angles, except not always
    // Bat tracking
    'swords',
    'num_swings',
    'peak_accel_ms',
    // Catcher throwing
    'n_xcs_with_untracked_over_xcs',
    'n_xcs_with_onfly_other_over_xcs',
    'n_xcs_with_ground_other_over_xcs',
    'n_xcs_with_accuracy_over_xcs',
    'n_xcs_with_exchange_over_xcs',
    'n_xcs_with_flight_over_xcs',
    'n_xcs',
    'n_cs_aa',
    'cs_raa',
    'venue_fence_distance',
    'venue_square_footage',
    'venue_fence_height',
    'pitch_spin_search',
    'abs_challenges',
    'attack_angle_zone',
    'attack_direction_pullopp_zone',
    'swing_path_tilt_zone'
];
var $3cfe79d709e6baf3$var$percentWhole = [
    // Baserunning
    'rate_att_xb',
    'est_rate_att_generic_runner',
    'est_rate_att_generic_fielder',
    'rate_att_xb_diff_runner',
    'rate_att_xb_diff_fielder',
    'base_running_rate_safe',
    'base_running_rate_safe_per_attempt',
    'rate_xcs',
    'rate_cs',
    'knee_percent',
    'cs_percent',
    // bat tracking
    'swing_timing_percent',
    // player page pitch percent
    'handed_pitch_percent',
    // ABS
    'abs_chal_percent',
    // gamefeed pitch percent
    'gamefeed_pitch_percent',
    // ABS
    'rate_overturns',
    'rate_overturns_against',
    'exp_rate_overturns',
    'exp_rate_overturns_against',
    'rate_chal_reasonable',
    'rate_chal_reasonable_against',
    'rate_reasonable_opp_taken',
    'rate_reasonable_opp_taken_against'
];
var $3cfe79d709e6baf3$var$percentTenth = [
    // Pitcher Steal
    'rate_sbx',
    // bat tracking
    'swings_qualified_percent',
    'avg_is_sweetspot_speed_high_qualified',
    // fast swing rate
    'squared_up_per_bat_contact',
    'squared_up_per_swing',
    'squared_up_with_speed_per_swing',
    'squared_up_with_speed_per_bat_contact',
    // Batted ball
    'batted_ball_rate',
    'rate_ideal_attack_angle',
    // Basestealing
    'rate_sbx',
    // Pitching
    'pitch_percent',
    'whiff_rate_percent',
    // Other
    'called_strike_prob',
    'venue_square_footage_diff',
    'home_run_percent',
    // ABS
    'abs_chal_rate_percent',
    'exp_rate_challenges_diff',
    'exp_rate_challenges_diff_against',
    'exp_rate_challenges',
    'exp_rate_challenges_against',
    'rate_challenges',
    'rate_challenges_against',
    'n_chal_reasonable_opps',
    'n_chal_reasonable_opps_against',
    'n_chal_reasonable',
    'n_chal_reasonable_against'
];
var $3cfe79d709e6baf3$var$angleWhole = [
    'bat_path_angle',
    'launch_angle_search'
];
var $3cfe79d709e6baf3$var$defaultOpts = {
    placeholder: '--',
    isMissingFn: function isMissingFn(val) {
        return [
            null,
            undefined,
            ''
        ].includes(val);
    },
    isDiff: false,
    ignoreExtremaHandling: false
};
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isMovementType(type) {
    return type.includes('movement_vertical_') || type.includes('movement_horizontal_');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpeed(type) {
    return type.includes('_avg_speed');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpin(type) {
    return type.includes('_avg_spin');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isActiveSpin(type) {
    return type.includes('formatted_active_spin_');
}
// grand unified formatting function
/**
 *
 * @param {string|number|null|undefined} val
 * @param {string} rawType
 * @param {{ placeholder?: any, isMissingFn?: function, isDiff?: boolean, removePercent?: boolean }} [opts]
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$guff(val, rawType) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $3cfe79d709e6baf3$var$defaultOpts;
    var mergedOpts = $3cfe79d709e6baf3$var$_objectSpread($3cfe79d709e6baf3$var$_objectSpread({}, $3cfe79d709e6baf3$var$defaultOpts), opts);
    var type = $3cfe79d709e6baf3$var$getStandardizedType(rawType);
    try {
        // Add some extra checks to pacify typescript
        if (mergedOpts.isMissingFn(val) || val === undefined || val === null) // How is TS okay with turning any here?
        return mergedOpts.placeholder;
        var numberVal = Number(val);
        if (Number.isNaN(numberVal)) return mergedOpts.placeholder;
        // Three Digit Formats (with diffs)
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type) && mergedOpts.isDiff) {
            if (numberVal > -1 && numberVal < 1) {
                var _formattedVal = $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
                if (Number(_formattedVal) > 0) return "+".concat(_formattedVal);
                return _formattedVal;
            }
            var formattedVal = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            if (Number(formattedVal) > 0) return "+".concat(formattedVal);
            if (Number(formattedVal) < 0) return formattedVal;
            return formattedVal;
        }
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type)) return $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
        if ($3cfe79d709e6baf3$var$thousandthTypes.includes(type)) {
            var formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? "+".concat(formattedValue) : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$hundredthTypes.includes(type)) {
            var _formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 2);
            return Number(_formattedValue) > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue) : _formattedValue;
        }
        if ($3cfe79d709e6baf3$var$tenthTypes.includes(type) || $3cfe79d709e6baf3$var$isMovementType(type) || $3cfe79d709e6baf3$var$isActiveSpin(type) || $3cfe79d709e6baf3$var$isAvgSpeed(type)) {
            var _formattedValue2 = $3cfe79d709e6baf3$var$toFixed(numberVal, 1);
            return Number(_formattedValue2) > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue2) : _formattedValue2;
        }
        if ($3cfe79d709e6baf3$var$wholeTypes.includes(type) || $3cfe79d709e6baf3$var$isAvgSpin(type)) {
            var _formattedValue3 = Math.round(numberVal) || 0;
            // FWIW - This avoids the -0 problem because String(-0) => '0' and -0 || 0 => 0
            return Number(_formattedValue3) > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue3.toLocaleString()) : _formattedValue3.toLocaleString(); // for consistently returning a string
        }
        if ($3cfe79d709e6baf3$var$percentWhole.includes(type)) {
            var roundedNumber = Math.round(numberVal * 100);
            var _formattedValue4 = String(roundedNumber);
            if (roundedNumber === 100 && numberVal < 1) _formattedValue4 = '>99';
            else if (roundedNumber === 0 && numberVal > 0) _formattedValue4 = '<1';
            var suffix = mergedOpts.removePercent ? '' : '%';
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return roundedNumber > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue4).concat(suffix) : _formattedValue4 + suffix;
        }
        if ($3cfe79d709e6baf3$var$percentTenth.includes(type)) {
            var _formattedValue5 = (numberVal * 100).toFixed(1);
            var _suffix = mergedOpts.removePercent ? '' : '%';
            if (!mergedOpts.ignoreExtremaHandling) {
                if (_formattedValue5 === '100.0' && numberVal < 1) _formattedValue5 = '>99.9';
                else if (_formattedValue5 === '0.0' && numberVal > 0) _formattedValue5 = '<0.1';
            }
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(_formattedValue5) > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue5).concat(_suffix) : _formattedValue5 + _suffix;
        }
        if ($3cfe79d709e6baf3$var$angleWhole.includes(type)) {
            var _formattedValue6 = Math.round(numberVal);
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(_formattedValue6) > 0 && mergedOpts.isDiff ? "+".concat(_formattedValue6, "\xB0") : "".concat(_formattedValue6, "\xB0");
        }
        throw new Error("type: ".concat(type, " not found"));
    } catch (e) {
        console.error('GUFF ERROR', e, val, type);
        return String(val);
    }
}
var $3cfe79d709e6baf3$var$validTypes = [].concat($3cfe79d709e6baf3$var$threeDigitTypes, $3cfe79d709e6baf3$var$thousandthTypes, $3cfe79d709e6baf3$var$hundredthTypes, $3cfe79d709e6baf3$var$tenthTypes, $3cfe79d709e6baf3$var$wholeTypes, $3cfe79d709e6baf3$var$percentWhole, $3cfe79d709e6baf3$var$percentTenth, $3cfe79d709e6baf3$var$angleWhole);
var $3cfe79d709e6baf3$var$validTypeMap = $3cfe79d709e6baf3$var$validTypes.reduce(function(acc, curr) {
    acc[curr] = true;
    return acc;
}, {});
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isGuffable(type) {
    var standardType = $3cfe79d709e6baf3$var$getStandardizedType(type);
    return Boolean($3cfe79d709e6baf3$var$validTypeMap[standardType]) || $3cfe79d709e6baf3$var$isAvgSpeed(standardType) || $3cfe79d709e6baf3$var$isMovementType(standardType) || $3cfe79d709e6baf3$var$isActiveSpin(standardType) || $3cfe79d709e6baf3$var$isAvgSpin(standardType);
}
// table
/**
 *
 * @param {string|number|null|undefined} val
 * @param {any} _
 * @param {{ field: string}} column
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$displayFn(val, _, _ref) {
    var field = _ref.field;
    return $3cfe79d709e6baf3$var$guff(val, field);
}
// table
/**
 *
 */ /**
 *
 * @param {string} type
 * @returns {(val: string|number|null|undefined) => string}
 */ function $3cfe79d709e6baf3$var$displayFnFactory(type) {
    return function displayFunc(val) {
        return $3cfe79d709e6baf3$var$guff(val, type);
    };
}
module.exports = {
    displayFn: $3cfe79d709e6baf3$var$displayFn,
    displayFnFactory: $3cfe79d709e6baf3$var$displayFnFactory,
    guff: $3cfe79d709e6baf3$var$guff,
    isGuffable: $3cfe79d709e6baf3$var$isGuffable
};

});

parcelRegister("5kS6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isGamefeedRawData = $3c150833c0b8faf7$var$isGamefeedRawData;
module.exports.strikeZoneTypes = void 0;
// When parsing from a CSV everything is a string, so that's tricky...
// We should be very careful not to parse Boolean('0') and expect false.
function $3c150833c0b8faf7$var$isGamefeedRawData(raw) {
    return raw.source === 'gamefeed';
}
// TODO: a d.ts file wasn't picked up for me, is there a better way to have some globally available types?
var $3c150833c0b8faf7$var$strikeZoneTypes = module.exports.strikeZoneTypes = [
    'personal',
    // 'generic-old',
    'generic',
    'fuzzy',
    'average'
];

});


parcelRegister("6Xpvk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b46f5dc2a8c116b5$var$Convert;

var $b46f5dc2a8c116b5$var$_get = $b46f5dc2a8c116b5$var$_interopRequireDefault((parcelRequire("jWTe4")));

var $mdo2f = parcelRequire("mdo2f");

var $b46f5dc2a8c116b5$var$_SingleEvent = $b46f5dc2a8c116b5$var$_interopRequireDefault((parcelRequire("1WMBp")));

var $1k8Kz = parcelRequire("1k8Kz");

var $5kS6g = parcelRequire("5kS6g");
function $b46f5dc2a8c116b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable no-param-reassign */ // Creates generic data model based off savant's default model
// Looks at the schema to determine what type of chart is being requested and creates the appropriate model
// This helps make the generic model simple for non savant/statsapi requests
// px required
// pz required
// legendType required
function $b46f5dc2a8c116b5$var$Convert(schema, savantData) {
    var data = [];
    var chartOptions = (0, $b46f5dc2a8c116b5$var$_get["default"])(schema, 'charts[0]');
    if (chartOptions.chartType) {
        if (chartOptions.chartType === 'pitch' || chartOptions.chartType === 'release' || chartOptions.chartType === 'field' || chartOptions.chartType === 'radial' || chartOptions.chartType === '3d' || chartOptions.chartType === 'movement') {
            savantData = $b46f5dc2a8c116b5$var$filterSavantData(chartOptions, savantData);
            data = savantData.map(function(d) {
                return $b46f5dc2a8c116b5$var$formatSavantData(chartOptions, d, Boolean(schema.showToolTip));
            });
        } else data = savantData.map(function(d) {
            return $b46f5dc2a8c116b5$var$formatSavantData(chartOptions, d);
        });
    }
    return data;
}
// Remove various data points based on chart types
function $b46f5dc2a8c116b5$var$filterSavantData(_ref, savantData) {
    var _ref$chartType = _ref.chartType, chartType = _ref$chartType === void 0 ? 'pitch' : _ref$chartType;
    if (chartType === 'pitch' || chartType === 'movement' || chartType === 'release' || chartType === 'network') return (0, $1k8Kz.RemoveBadPitchPoints)(savantData);
    if (chartType === 'field' || chartType === 'radial' || chartType === '3d') return (0, $1k8Kz.RemoveBadSprayPoints)(savantData);
    return savantData;
}
function $b46f5dc2a8c116b5$var$formatAbsChallenge(pitch) {
    var chalPlayerType = 'fielder';
    if (Number(pitch.challenging_player_id) === Number(pitch.challenge_batter_id) || Number(pitch.batting_team_id) === Number(pitch.abs_challenge_team_id)) chalPlayerType = 'batter';
    else if (Number(pitch.challenging_player_id) === Number(pitch.challenge_catcher_id)) chalPlayerType = 'catcher';
    else if (Number(pitch.challenging_player_id) === Number(pitch.challenge_pitcher_id)) chalPlayerType = 'pitcher';
    else chalPlayerType = 'fielder';
    return Number(pitch.is_abs_challenge) ? {
        is_batter: Number(pitch.batting_team_id) === Number(pitch.abs_challenge_team_id),
        is_overturned: Boolean(Number(pitch.is_abs_overturned)),
        challenge_team_id: Number(pitch.abs_challenge_team_id),
        challenging_player_type: chalPlayerType
    } : undefined;
}
function $b46f5dc2a8c116b5$var$formatSavantData(_ref2, d) {
    var _ref2$legendType = _ref2.legendType, legendType = _ref2$legendType === void 0 ? 'pitchName' : _ref2$legendType, _ref2$chartType = _ref2.chartType, chartType = _ref2$chartType === void 0 ? 'pitch' : _ref2$chartType;
    var showToolTip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isGamefeed = (0, $5kS6g.isGamefeedRawData)(d);
    if (isGamefeed) return $b46f5dc2a8c116b5$var$formatGamefeedData(chartType, legendType, d, showToolTip);
    var x = 'plate_x';
    var y = 'plate_z';
    if (chartType === 'field' || chartType === '3d') {
        x = 'hc_x_ft';
        y = 'hc_y_ft';
    }
    if (chartType === 'pitch') {
        x = 'plate_x';
        y = 'plate_z';
    }
    if (chartType === 'movement') {
        x = 'pfx_x';
        y = 'pfx_z_gravity';
    }
    if (chartType === 'release') {
        x = 'x0';
        y = 'z0';
    }
    var hasStrikeZone = Boolean(d.sz_top && d.sz_bot);
    var legendKey = legendType;
    var legend = d[legendKey];
    var abs_challenge = $b46f5dc2a8c116b5$var$formatAbsChallenge(d);
    var isInZone = Number(d.zone) > 0 && Number(d.zone) < 10;
    return {
        x: Number(d[x]),
        y: Number(d[y]),
        pitchType: d.pitch_type,
        pitchName: d.pitch_name,
        legend: legend ? String(legend) : null,
        paResult: d.events,
        pitchResult: d.description,
        hits: Number(d.is_hit_into_play_basehit),
        battedBallType: d.bb_type,
        ab: Number(d.is_ab),
        pa: Number(d.is_pa),
        bip: Number(d.is_hit_into_play),
        trackedBIP: Number(d.launch_speed) > 0 ? Number(d.is_hit_into_play) : 0,
        trackedSwingLength: Number(d.swing_length) ? 1 : 0,
        trackedBatSpeed: Number(d.sweetspot_speed_mph) ? 1 : 0,
        trackedSwingLengthCompetitive: Number(d.swing_length) && Number(d.is_competitive) ? 1 : 0,
        trackedBatSpeedCompetitive: Number(d.sweetspot_speed_mph) && Number(d.is_competitive) ? 1 : 0,
        single: Number(d.is_hit_into_play_basehit_single),
        "double": Number(d.is_hit_into_play_basehit_double),
        triple: Number(d.is_hit_into_play_basehit_triple),
        hr: Number(d.is_hit_into_play_basehit_home_run),
        so: Number(d.is_strikeout),
        zone: d.zone,
        isInZone: isInZone,
        balls: Number(d.pre_ball_count) || Number(d.balls),
        strikes: Number(d.pre_strike_count) || Number(d.strikes),
        releaseSpeed: Number(d.release_speed),
        releaseSpinRate: Number(d.release_spin_rate) || 0,
        pfxX: Number(d.pfx_x) || null,
        pfxZGravity: Number(d.pfx_z_gravity) || null,
        launchSpeed: d.is_hit_into_play ? Number(d.launch_speed) : 0,
        // TODO can we change these to undefined
        launchAngle: d.is_hit_into_play ? Number(d.launch_angle) : 0,
        swingLength: Number(d.swing_length) || null,
        batSpeed: Number(d.sweetspot_speed_mph) || null,
        is_swing: Number(d.is_swing) || null,
        is_whiff: Number(d.is_whiff) || null,
        deltaRunExp: Number(d.delta_run_exp),
        wobaNumer: Number(d.fangraphs_woba_numer),
        wobaDenom: Number(d.fangraphs_woba_denom),
        xWobaNumer: Number(d.fangraphs_est_woba_numer),
        xWobaDenom: Number(d.fangraphs_est_woba_denom),
        tooltip: showToolTip ? (0, $b46f5dc2a8c116b5$var$_SingleEvent["default"])(d, abs_challenge) : null,
        videoUrl: d.game_year >= 2016 && d.play_id ? "https://baseballsavant.mlb.com/sporty-videos?playId=".concat(d.play_id) : null,
        raw: d,
        hasStrikeZone: hasStrikeZone,
        szBot: d.sz_bot ? Number(d.sz_bot) : null,
        szTop: d.sz_top ? Number(d.sz_top) : null,
        szDepth: !Number.isNaN(Number(d.sz_depth)) && d.sz_depth !== '' ? Number(d.sz_depth) : $mdo2f.depthMidPlateInches,
        szWidth: $mdo2f.plateWidthFt,
        is_abs_challenge: Boolean(Number(d.is_abs_challenge)),
        abs_challenge: abs_challenge
    };
}
function $b46f5dc2a8c116b5$var$formatGamefeedData(chartType, legendType, pitch, showToolTip) {
    var _pitch$x, _pitch$y;
    // let x: keyof GamefeedRawData = 'plate_x'
    // let y: keyof GamefeedRawData = 'plate_z'
    var x = 'plate_x';
    var y = 'plate_z';
    if (chartType === 'field' || chartType === '3d') {
        x = 'hc_x_ft';
        y = 'hc_y_ft';
    }
    if (chartType === 'pitch') {
        x = 'plate_x';
        y = 'plate_z';
    }
    if (chartType === 'movement') {
        x = 'pfxX';
        y = 'pfxZWithGravity';
    }
    if (chartType === 'release') {
        x = 'x0';
        y = 'z0';
    }
    var hasStrikeZone = Boolean(pitch.sz_top && pitch.sz_bot && pitch.sz_width);
    var isInZone = Number(pitch.zone) > 0 && Number(pitch.zone) < 10;
    // const isPitch = pitch.type !== 'no_pitch'
    var legendKey = legendType;
    var legend = pitch[legendKey];
    return {
        x: (_pitch$x = pitch[x]) !== null && _pitch$x !== void 0 ? _pitch$x : null,
        y: (_pitch$y = pitch[y]) !== null && _pitch$y !== void 0 ? _pitch$y : null,
        pitchType: pitch.pitch_type,
        pitchName: pitch.pitch_name,
        legend: legend ? String(legend) : null,
        paResult: pitch.events,
        pitchResult: pitch.description,
        trackedBatSpeed: Number(pitch.batSpeed) ? 1 : 0,
        zone: pitch.zone,
        isInZone: isInZone,
        callName: pitch.call_name,
        balls: Number(pitch.balls),
        strikes: Number(pitch.strikes),
        releaseSpeed: Number(pitch.start_speed),
        releaseSpinRate: Number(pitch.spin_rate) || 0,
        pfxX: typeof pitch.breakXInches === 'number' ? pitch.breakXInches : null,
        pfxZGravity: typeof pitch.breakZWithGravityInches === 'number' ? Math.abs(pitch.breakZWithGravityInches) : null,
        launchSpeed: Number(pitch.hit_speed) || 0,
        launchAngle: Number(pitch.hit_angle) || 0,
        batSpeed: Number(pitch.batSpeed) || null,
        tooltip: showToolTip ? (0, $b46f5dc2a8c116b5$var$_SingleEvent["default"])(pitch) : null,
        raw: pitch,
        hasStrikeZone: hasStrikeZone,
        szBot: pitch.sz_bot && Number(pitch.sz_bot),
        szTop: pitch.sz_top && Number(pitch.sz_top),
        szDepth: pitch.sz_depth && Number(pitch.sz_depth) || $mdo2f.depthMidPlateInches,
        szWidth: (pitch.sz_width || $mdo2f.plateWidthInches) / 12,
        // ABS
        is_abs_challenge: pitch.is_abs_challenge,
        abs_challenge: pitch.abs_challenge,
        illustrator_pitch_number: pitch.illustrator_pitch_number ? pitch.illustrator_pitch_number : 0
    };
}

});
parcelRegister("jWTe4", function(module, exports) {

var $jS5c4 = parcelRequire("jS5c4");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e85e45d1f71ede7f$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $jS5c4(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $e85e45d1f71ede7f$var$get;

});
parcelRegister("jS5c4", function(module, exports) {

var $bftq9 = parcelRequire("bftq9");

var $2vQDZ = parcelRequire("2vQDZ");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e77716d8c14b93be$var$baseGet(object, path) {
    path = $bftq9(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$2vQDZ(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $e77716d8c14b93be$var$baseGet;

});
parcelRegister("bftq9", function(module, exports) {

var $9yDvq = parcelRequire("9yDvq");

var $4Gv9o = parcelRequire("4Gv9o");

var $lPml2 = parcelRequire("lPml2");

var $9GATr = parcelRequire("9GATr");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $8307eac196ce2471$var$castPath(value, object) {
    if ($9yDvq(value)) return value;
    return $4Gv9o(value, object) ? [
        value
    ] : $lPml2($9GATr(value));
}
module.exports = $8307eac196ce2471$var$castPath;

});
parcelRegister("9yDvq", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $6f55ef14dc1277e7$var$isArray = Array.isArray;
module.exports = $6f55ef14dc1277e7$var$isArray;

});

parcelRegister("4Gv9o", function(module, exports) {

var $9yDvq = parcelRequire("9yDvq");

var $5WTbi = parcelRequire("5WTbi");
/** Used to match property names within property paths. */ var $36933f81a203c885$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $36933f81a203c885$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $36933f81a203c885$var$isKey(value, object) {
    if ($9yDvq(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $5WTbi(value)) return true;
    return $36933f81a203c885$var$reIsPlainProp.test(value) || !$36933f81a203c885$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $36933f81a203c885$var$isKey;

});
parcelRegister("5WTbi", function(module, exports) {

var $9ooXF = parcelRequire("9ooXF");

var $efn5V = parcelRequire("efn5V");
/** `Object#toString` result references. */ var $454d2c607fa6e363$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $454d2c607fa6e363$var$isSymbol(value) {
    return typeof value == 'symbol' || $efn5V(value) && $9ooXF(value) == $454d2c607fa6e363$var$symbolTag;
}
module.exports = $454d2c607fa6e363$var$isSymbol;

});
parcelRegister("9ooXF", function(module, exports) {

var $8tMG2 = parcelRequire("8tMG2");

var $3rDcQ = parcelRequire("3rDcQ");

var $2GRWc = parcelRequire("2GRWc");
/** `Object#toString` result references. */ var $6d69b7c6cc0e3d37$var$nullTag = '[object Null]', $6d69b7c6cc0e3d37$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $6d69b7c6cc0e3d37$var$symToStringTag = $8tMG2 ? $8tMG2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6d69b7c6cc0e3d37$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $6d69b7c6cc0e3d37$var$undefinedTag : $6d69b7c6cc0e3d37$var$nullTag;
    return $6d69b7c6cc0e3d37$var$symToStringTag && $6d69b7c6cc0e3d37$var$symToStringTag in Object(value) ? $3rDcQ(value) : $2GRWc(value);
}
module.exports = $6d69b7c6cc0e3d37$var$baseGetTag;

});
parcelRegister("8tMG2", function(module, exports) {

var $4U0WH = parcelRequire("4U0WH");
/** Built-in value references. */ var $62c6ca6632bc186b$var$Symbol = $4U0WH.Symbol;
module.exports = $62c6ca6632bc186b$var$Symbol;

});
parcelRegister("4U0WH", function(module, exports) {

var $itmd2 = parcelRequire("itmd2");
/** Detect free variable `self`. */ var $391d202d5c32700f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $391d202d5c32700f$var$root = $itmd2 || $391d202d5c32700f$var$freeSelf || Function('return this')();
module.exports = $391d202d5c32700f$var$root;

});
parcelRegister("itmd2", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $d72c29baa8b52b50$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $d72c29baa8b52b50$var$freeGlobal;

});



parcelRegister("3rDcQ", function(module, exports) {

var $8tMG2 = parcelRequire("8tMG2");
/** Used for built-in method references. */ var $28224e3b6f57460b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28224e3b6f57460b$var$hasOwnProperty = $28224e3b6f57460b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $28224e3b6f57460b$var$nativeObjectToString = $28224e3b6f57460b$var$objectProto.toString;
/** Built-in value references. */ var $28224e3b6f57460b$var$symToStringTag = $8tMG2 ? $8tMG2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $28224e3b6f57460b$var$getRawTag(value) {
    var isOwn = $28224e3b6f57460b$var$hasOwnProperty.call(value, $28224e3b6f57460b$var$symToStringTag), tag = value[$28224e3b6f57460b$var$symToStringTag];
    try {
        value[$28224e3b6f57460b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $28224e3b6f57460b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$28224e3b6f57460b$var$symToStringTag] = tag;
        else delete value[$28224e3b6f57460b$var$symToStringTag];
    }
    return result;
}
module.exports = $28224e3b6f57460b$var$getRawTag;

});

parcelRegister("2GRWc", function(module, exports) {
/** Used for built-in method references. */ var $1f5957e7bc9bfe4a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1f5957e7bc9bfe4a$var$nativeObjectToString = $1f5957e7bc9bfe4a$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1f5957e7bc9bfe4a$var$objectToString(value) {
    return $1f5957e7bc9bfe4a$var$nativeObjectToString.call(value);
}
module.exports = $1f5957e7bc9bfe4a$var$objectToString;

});


parcelRegister("efn5V", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a5f4617d722be5e8$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $a5f4617d722be5e8$var$isObjectLike;

});



parcelRegister("lPml2", function(module, exports) {

var $a83Ew = parcelRequire("a83Ew");
/** Used to match property names within property paths. */ var $fe3fb04f00534b0e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $fe3fb04f00534b0e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $fe3fb04f00534b0e$var$stringToPath = $a83Ew(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($fe3fb04f00534b0e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($fe3fb04f00534b0e$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $fe3fb04f00534b0e$var$stringToPath;

});
parcelRegister("a83Ew", function(module, exports) {

var $i0gjo = parcelRequire("i0gjo");
/** Used as the maximum memoize cache size. */ var $75fd7c10c55b0a6a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $75fd7c10c55b0a6a$var$memoizeCapped(func) {
    var result = $i0gjo(func, function(key) {
        if (cache.size === $75fd7c10c55b0a6a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $75fd7c10c55b0a6a$var$memoizeCapped;

});
parcelRegister("i0gjo", function(module, exports) {

var $9rczp = parcelRequire("9rczp");
/** Error message constants. */ var $d1b4e149b1d3d9b6$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $d1b4e149b1d3d9b6$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($d1b4e149b1d3d9b6$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($d1b4e149b1d3d9b6$var$memoize.Cache || $9rczp);
    return memoized;
}
// Expose `MapCache`.
$d1b4e149b1d3d9b6$var$memoize.Cache = $9rczp;
module.exports = $d1b4e149b1d3d9b6$var$memoize;

});
parcelRegister("9rczp", function(module, exports) {

var $4ciYr = parcelRequire("4ciYr");

var $5UCMw = parcelRequire("5UCMw");

var $3YKn0 = parcelRequire("3YKn0");

var $IUCv3 = parcelRequire("IUCv3");

var $iw0Ge = parcelRequire("iw0Ge");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6df062dad6507454$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$6df062dad6507454$var$MapCache.prototype.clear = $4ciYr;
$6df062dad6507454$var$MapCache.prototype['delete'] = $5UCMw;
$6df062dad6507454$var$MapCache.prototype.get = $3YKn0;
$6df062dad6507454$var$MapCache.prototype.has = $IUCv3;
$6df062dad6507454$var$MapCache.prototype.set = $iw0Ge;
module.exports = $6df062dad6507454$var$MapCache;

});
parcelRegister("4ciYr", function(module, exports) {

var $1l4S1 = parcelRequire("1l4S1");

var $94FgI = parcelRequire("94FgI");

var $3LQIk = parcelRequire("3LQIk");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $30e7003896efd939$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $1l4S1,
        'map': new ($3LQIk || $94FgI),
        'string': new $1l4S1
    };
}
module.exports = $30e7003896efd939$var$mapCacheClear;

});
parcelRegister("1l4S1", function(module, exports) {

var $jh4wd = parcelRequire("jh4wd");

var $2IwA2 = parcelRequire("2IwA2");

var $i6veF = parcelRequire("i6veF");

var $1EiS9 = parcelRequire("1EiS9");

var $gZNph = parcelRequire("gZNph");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0f9b87be4fcb3b73$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$0f9b87be4fcb3b73$var$Hash.prototype.clear = $jh4wd;
$0f9b87be4fcb3b73$var$Hash.prototype['delete'] = $2IwA2;
$0f9b87be4fcb3b73$var$Hash.prototype.get = $i6veF;
$0f9b87be4fcb3b73$var$Hash.prototype.has = $1EiS9;
$0f9b87be4fcb3b73$var$Hash.prototype.set = $gZNph;
module.exports = $0f9b87be4fcb3b73$var$Hash;

});
parcelRegister("jh4wd", function(module, exports) {

var $15r8s = parcelRequire("15r8s");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e0831c2dc0060ca7$var$hashClear() {
    this.__data__ = $15r8s ? $15r8s(null) : {};
    this.size = 0;
}
module.exports = $e0831c2dc0060ca7$var$hashClear;

});
parcelRegister("15r8s", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");
/* Built-in method references that are verified to be native. */ var $0cab4e9d8f24f91b$var$nativeCreate = $kXBTM(Object, 'create');
module.exports = $0cab4e9d8f24f91b$var$nativeCreate;

});
parcelRegister("kXBTM", function(module, exports) {

var $2v8Lv = parcelRequire("2v8Lv");

var $5yed8 = parcelRequire("5yed8");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f426b73df29dcbd2$var$getNative(object, key) {
    var value = $5yed8(object, key);
    return $2v8Lv(value) ? value : undefined;
}
module.exports = $f426b73df29dcbd2$var$getNative;

});
parcelRegister("2v8Lv", function(module, exports) {

var $3Hr6t = parcelRequire("3Hr6t");

var $1FSoq = parcelRequire("1FSoq");

var $5HTQb = parcelRequire("5HTQb");

var $7KX6U = parcelRequire("7KX6U");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $1d25469f5c9b8da3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $1d25469f5c9b8da3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $1d25469f5c9b8da3$var$funcProto = Function.prototype, $1d25469f5c9b8da3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1d25469f5c9b8da3$var$funcToString = $1d25469f5c9b8da3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1d25469f5c9b8da3$var$hasOwnProperty = $1d25469f5c9b8da3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $1d25469f5c9b8da3$var$reIsNative = RegExp('^' + $1d25469f5c9b8da3$var$funcToString.call($1d25469f5c9b8da3$var$hasOwnProperty).replace($1d25469f5c9b8da3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $1d25469f5c9b8da3$var$baseIsNative(value) {
    if (!$5HTQb(value) || $1FSoq(value)) return false;
    var pattern = $3Hr6t(value) ? $1d25469f5c9b8da3$var$reIsNative : $1d25469f5c9b8da3$var$reIsHostCtor;
    return pattern.test($7KX6U(value));
}
module.exports = $1d25469f5c9b8da3$var$baseIsNative;

});
parcelRegister("3Hr6t", function(module, exports) {

var $9ooXF = parcelRequire("9ooXF");

var $5HTQb = parcelRequire("5HTQb");
/** `Object#toString` result references. */ var $2b1a69704e0e723e$var$asyncTag = '[object AsyncFunction]', $2b1a69704e0e723e$var$funcTag = '[object Function]', $2b1a69704e0e723e$var$genTag = '[object GeneratorFunction]', $2b1a69704e0e723e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $2b1a69704e0e723e$var$isFunction(value) {
    if (!$5HTQb(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $9ooXF(value);
    return tag == $2b1a69704e0e723e$var$funcTag || tag == $2b1a69704e0e723e$var$genTag || tag == $2b1a69704e0e723e$var$asyncTag || tag == $2b1a69704e0e723e$var$proxyTag;
}
module.exports = $2b1a69704e0e723e$var$isFunction;

});
parcelRegister("5HTQb", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $427c48aff08e3437$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $427c48aff08e3437$var$isObject;

});


parcelRegister("1FSoq", function(module, exports) {

var $cMWzg = parcelRequire("cMWzg");
/** Used to detect methods masquerading as native. */ var $1383d01ce810c830$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($cMWzg && $cMWzg.keys && $cMWzg.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1383d01ce810c830$var$isMasked(func) {
    return !!$1383d01ce810c830$var$maskSrcKey && $1383d01ce810c830$var$maskSrcKey in func;
}
module.exports = $1383d01ce810c830$var$isMasked;

});
parcelRegister("cMWzg", function(module, exports) {

var $4U0WH = parcelRequire("4U0WH");
/** Used to detect overreaching core-js shims. */ var $94f76617347c0ff9$var$coreJsData = $4U0WH["__core-js_shared__"];
module.exports = $94f76617347c0ff9$var$coreJsData;

});


parcelRegister("7KX6U", function(module, exports) {
/** Used for built-in method references. */ var $5a5aae65703f9db8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5a5aae65703f9db8$var$funcToString = $5a5aae65703f9db8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5a5aae65703f9db8$var$toSource(func) {
    if (func != null) {
        try {
            return $5a5aae65703f9db8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $5a5aae65703f9db8$var$toSource;

});


parcelRegister("5yed8", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $40ab26ba8f16049a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $40ab26ba8f16049a$var$getValue;

});




parcelRegister("2IwA2", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1fa8f699f4446789$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $1fa8f699f4446789$var$hashDelete;

});

parcelRegister("i6veF", function(module, exports) {

var $15r8s = parcelRequire("15r8s");
/** Used to stand-in for `undefined` hash values. */ var $d2e104438937a8d7$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d2e104438937a8d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d2e104438937a8d7$var$hasOwnProperty = $d2e104438937a8d7$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d2e104438937a8d7$var$hashGet(key) {
    var data = this.__data__;
    if ($15r8s) {
        var result = data[key];
        return result === $d2e104438937a8d7$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d2e104438937a8d7$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $d2e104438937a8d7$var$hashGet;

});

parcelRegister("1EiS9", function(module, exports) {

var $15r8s = parcelRequire("15r8s");
/** Used for built-in method references. */ var $13382a8c1f0d9ddf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $13382a8c1f0d9ddf$var$hasOwnProperty = $13382a8c1f0d9ddf$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $13382a8c1f0d9ddf$var$hashHas(key) {
    var data = this.__data__;
    return $15r8s ? data[key] !== undefined : $13382a8c1f0d9ddf$var$hasOwnProperty.call(data, key);
}
module.exports = $13382a8c1f0d9ddf$var$hashHas;

});

parcelRegister("gZNph", function(module, exports) {

var $15r8s = parcelRequire("15r8s");
/** Used to stand-in for `undefined` hash values. */ var $c5f8ab057e645ae6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c5f8ab057e645ae6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $15r8s && value === undefined ? $c5f8ab057e645ae6$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $c5f8ab057e645ae6$var$hashSet;

});


parcelRegister("94FgI", function(module, exports) {

var $fLrYt = parcelRequire("fLrYt");

var $4RII4 = parcelRequire("4RII4");

var $9srpI = parcelRequire("9srpI");

var $dvcdi = parcelRequire("dvcdi");

var $h2Xkv = parcelRequire("h2Xkv");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $69b47fdda96d894c$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$69b47fdda96d894c$var$ListCache.prototype.clear = $fLrYt;
$69b47fdda96d894c$var$ListCache.prototype['delete'] = $4RII4;
$69b47fdda96d894c$var$ListCache.prototype.get = $9srpI;
$69b47fdda96d894c$var$ListCache.prototype.has = $dvcdi;
$69b47fdda96d894c$var$ListCache.prototype.set = $h2Xkv;
module.exports = $69b47fdda96d894c$var$ListCache;

});
parcelRegister("fLrYt", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b7a0f1f1bdb2d3e1$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $b7a0f1f1bdb2d3e1$var$listCacheClear;

});

parcelRegister("4RII4", function(module, exports) {

var $8lqGW = parcelRequire("8lqGW");
/** Used for built-in method references. */ var $38aecb1b90d8ca92$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $38aecb1b90d8ca92$var$splice = $38aecb1b90d8ca92$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $38aecb1b90d8ca92$var$listCacheDelete(key) {
    var data = this.__data__, index = $8lqGW(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $38aecb1b90d8ca92$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $38aecb1b90d8ca92$var$listCacheDelete;

});
parcelRegister("8lqGW", function(module, exports) {

var $ii1fP = parcelRequire("ii1fP");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6134fd486de8967b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ii1fP(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $6134fd486de8967b$var$assocIndexOf;

});
parcelRegister("ii1fP", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d50ae184ceb1a3ed$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $d50ae184ceb1a3ed$var$eq;

});



parcelRegister("9srpI", function(module, exports) {

var $8lqGW = parcelRequire("8lqGW");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6e2bfe628de6ba46$var$listCacheGet(key) {
    var data = this.__data__, index = $8lqGW(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $6e2bfe628de6ba46$var$listCacheGet;

});

parcelRegister("dvcdi", function(module, exports) {

var $8lqGW = parcelRequire("8lqGW");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9d47a4eec56fd715$var$listCacheHas(key) {
    return $8lqGW(this.__data__, key) > -1;
}
module.exports = $9d47a4eec56fd715$var$listCacheHas;

});

parcelRegister("h2Xkv", function(module, exports) {

var $8lqGW = parcelRequire("8lqGW");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c690a53bce16c5d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = $8lqGW(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $c690a53bce16c5d6$var$listCacheSet;

});


parcelRegister("3LQIk", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");

var $4U0WH = parcelRequire("4U0WH");
/* Built-in method references that are verified to be native. */ var $2beea6c53ef96283$var$Map = $kXBTM($4U0WH, 'Map');
module.exports = $2beea6c53ef96283$var$Map;

});


parcelRegister("5UCMw", function(module, exports) {

var $ghL6c = parcelRequire("ghL6c");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44e043ed10569a56$var$mapCacheDelete(key) {
    var result = $ghL6c(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44e043ed10569a56$var$mapCacheDelete;

});
parcelRegister("ghL6c", function(module, exports) {

var $dmHp9 = parcelRequire("dmHp9");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $bdb2c4c440b2272e$var$getMapData(map, key) {
    var data = map.__data__;
    return $dmHp9(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $bdb2c4c440b2272e$var$getMapData;

});
parcelRegister("dmHp9", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9baeffb8c1780d8a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $9baeffb8c1780d8a$var$isKeyable;

});



parcelRegister("3YKn0", function(module, exports) {

var $ghL6c = parcelRequire("ghL6c");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2e5af1d6e1a7eab1$var$mapCacheGet(key) {
    return $ghL6c(this, key).get(key);
}
module.exports = $2e5af1d6e1a7eab1$var$mapCacheGet;

});

parcelRegister("IUCv3", function(module, exports) {

var $ghL6c = parcelRequire("ghL6c");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $087007b8a318adde$var$mapCacheHas(key) {
    return $ghL6c(this, key).has(key);
}
module.exports = $087007b8a318adde$var$mapCacheHas;

});

parcelRegister("iw0Ge", function(module, exports) {

var $ghL6c = parcelRequire("ghL6c");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $d7abbe3e5079e8f9$var$mapCacheSet(key, value) {
    var data = $ghL6c(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $d7abbe3e5079e8f9$var$mapCacheSet;

});





parcelRegister("9GATr", function(module, exports) {

var $iyTl2 = parcelRequire("iyTl2");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $70d4a782b8e297cf$var$toString(value) {
    return value == null ? '' : $iyTl2(value);
}
module.exports = $70d4a782b8e297cf$var$toString;

});
parcelRegister("iyTl2", function(module, exports) {

var $8tMG2 = parcelRequire("8tMG2");

var $e9Ynw = parcelRequire("e9Ynw");

var $9yDvq = parcelRequire("9yDvq");

var $5WTbi = parcelRequire("5WTbi");
/** Used as references for various `Number` constants. */ var $d83653fe33bcddec$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $d83653fe33bcddec$var$symbolProto = $8tMG2 ? $8tMG2.prototype : undefined, $d83653fe33bcddec$var$symbolToString = $d83653fe33bcddec$var$symbolProto ? $d83653fe33bcddec$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d83653fe33bcddec$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($9yDvq(value)) // Recursively convert values (susceptible to call stack limits).
    return $e9Ynw(value, $d83653fe33bcddec$var$baseToString) + '';
    if ($5WTbi(value)) return $d83653fe33bcddec$var$symbolToString ? $d83653fe33bcddec$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$d83653fe33bcddec$var$INFINITY ? '-0' : result;
}
module.exports = $d83653fe33bcddec$var$baseToString;

});
parcelRegister("e9Ynw", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a4f0bdd74bf5fa9e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $a4f0bdd74bf5fa9e$var$arrayMap;

});




parcelRegister("2vQDZ", function(module, exports) {

var $5WTbi = parcelRequire("5WTbi");
/** Used as references for various `Number` constants. */ var $1d475003ca79aac9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1d475003ca79aac9$var$toKey(value) {
    if (typeof value == 'string' || $5WTbi(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$1d475003ca79aac9$var$INFINITY ? '-0' : result;
}
module.exports = $1d475003ca79aac9$var$toKey;

});



parcelRegister("mdo2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.depthMidPlateInches = module.exports.depthMidPlateFt = module.exports.depthFrontOfPlateInches = module.exports.depthFrontOfPlateFt = module.exports.bottomZoneOld = module.exports.bottomZoneAverage = void 0;
module.exports.getSVGRectPositioning = $8477aae16d611aec$var$getSVGRectPositioning;
module.exports.getSixFootNormalized = $8477aae16d611aec$var$getSixFootNormalized;
module.exports.normalizeToZone = $8477aae16d611aec$var$normalizeToZone;
module.exports.topZoneOld = module.exports.topZoneAverage = module.exports.plateWidthInches = module.exports.plateWidthFt = void 0;
parcelRequire("blS65");
var $aSvrg = parcelRequire("aSvrg");

var $22K6d = parcelRequire("22K6d");
// eslint-disable-next-line import/extensions
var $8477aae16d611aec$var$depthFrontOfPlateInches = module.exports.depthFrontOfPlateInches = 17;
var $8477aae16d611aec$var$depthMidPlateInches = module.exports.depthMidPlateInches = $8477aae16d611aec$var$depthFrontOfPlateInches / 2;
var $8477aae16d611aec$var$depthMidPlateFt = module.exports.depthMidPlateFt = $8477aae16d611aec$var$depthMidPlateInches / 12;
var $8477aae16d611aec$var$depthFrontOfPlateFt = module.exports.depthFrontOfPlateFt = $8477aae16d611aec$var$depthFrontOfPlateInches / 12;
// // For a "relative" zone, we'll make a roughly average zone
// // This is Tom's average for a ~6ft player
var $8477aae16d611aec$var$topZoneAverage = module.exports.topZoneAverage = 38.5 / 12;
var $8477aae16d611aec$var$bottomZoneAverage = module.exports.bottomZoneAverage = 1.625;
var $8477aae16d611aec$var$plateWidthInches = module.exports.plateWidthInches = 17;
var $8477aae16d611aec$var$plateWidthFt = module.exports.plateWidthFt = 17 / 12;
// export const firstBaseZone = plateWidthFt / 2
// export const thirdBaseZone = plateWidthFt / -2
// export const topZoneFullyInZone = topZone - ballRadiusFeet
// export const bottomZoneFullyInZone = bottomZone + ballRadiusFeet
// export const firstBaseZoneFullyIn = firstBaseZone - ballRadiusFeet
// export const thirdBaseZoneFullyIn = thirdBaseZone + ballRadiusFeet
// // GENERIC OLD
var $8477aae16d611aec$var$topZoneOld = module.exports.topZoneOld = 3.5;
var $8477aae16d611aec$var$bottomZoneOld = module.exports.bottomZoneOld = 1.5;
// Takes a pitch and zone and "normalizes" it to a generic six foot ABS zone
function $8477aae16d611aec$var$getSixFootNormalized(px, pz, szTop, szBot, szWidthInches) {
    return $8477aae16d611aec$var$normalizeToZone(px, pz, szTop, szBot, szWidthInches, $8477aae16d611aec$var$topZoneAverage, $8477aae16d611aec$var$bottomZoneAverage, 17);
}
// Makes everything work in SVG space taking into account strokes
function $8477aae16d611aec$var$getSVGRectPositioning(szTop, szBot, szWidth, xScale, yScale, strokeWidth) {
    var halfPlate = szWidth / 2;
    // Handle pitcher perspective by assuming the canvas coords are always positive heading to the right
    var middle = xScale(0);
    var diff = Math.abs(xScale(halfPlate) - middle);
    var x = middle - diff + strokeWidth / 2;
    var y = yScale(szTop) + strokeWidth / 2;
    var width = Math.abs(xScale(halfPlate) - xScale(-halfPlate)) - strokeWidth;
    var height = yScale(szBot) - yScale(szTop) - strokeWidth;
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
// Takes a pitch with strike zone, and a target zone, and "normalizes" the pitch to the target zone
function $8477aae16d611aec$var$normalizeToZone(px, pz, szTop, szBot, szWidthInches, targetSzTop, targetSzBot, targetSzWidthInches) {
    var targetPlateWidthFt = targetSzWidthInches / 12;
    var targetFirstBaseZone = targetPlateWidthFt / 2;
    var targetThirdBaseZone = targetPlateWidthFt / -2;
    var topZoneFullyInZone = targetSzTop - $22K6d.ballRadiusFeet;
    var bottomZoneFullyInZone = targetSzBot + $22K6d.ballRadiusFeet;
    var firstBaseZoneFullyIn = targetFirstBaseZone - $22K6d.ballRadiusFeet;
    var thirdBaseZoneFullyIn = targetThirdBaseZone + $22K6d.ballRadiusFeet;
    var playerTopZoneFullyIn = szTop - $22K6d.ballRadiusFeet;
    var playerBottomZoneFullyIn = szBot + $22K6d.ballRadiusFeet;
    var fullyInUp = pz < playerTopZoneFullyIn;
    var fullyInDown = pz > playerBottomZoneFullyIn;
    var fullyInZ = fullyInUp && fullyInDown;
    var halfPlate = szWidthInches / 12 / 2;
    var playerFirstBaseZoneFullyIn = halfPlate - $22K6d.ballRadiusFeet;
    var playerThirdBaseZoneFullyIn = -halfPlate + $22K6d.ballRadiusFeet;
    var fullyInFirst = px < playerFirstBaseZoneFullyIn;
    var fullyInThird = px > playerThirdBaseZoneFullyIn;
    var fullyInX = fullyInFirst && fullyInThird;
    var newX = px;
    var newZ = pz;
    if (fullyInX) {
        // Do some scaling
        // X axis is likely to be a noop, assuming the plate stays 17 inches
        var xScale = (0, $aSvrg.default)().domain([
            playerThirdBaseZoneFullyIn,
            playerFirstBaseZoneFullyIn
        ]).range([
            thirdBaseZoneFullyIn,
            firstBaseZoneFullyIn
        ]);
        newX = xScale(px);
    }
    if (fullyInZ) {
        var zScale = (0, $aSvrg.default)().domain([
            playerBottomZoneFullyIn,
            playerTopZoneFullyIn
        ]).range([
            bottomZoneFullyInZone,
            topZoneFullyInZone
        ]);
        newZ = zScale(pz);
    }
    if (!fullyInUp) {
        // translate
        var amountAboveZone = pz - playerTopZoneFullyIn;
        newZ = topZoneFullyInZone + amountAboveZone;
    }
    if (!fullyInDown) {
        // translate, I didn't really need to flip the signs, but my brain understands it better I think.
        var amountBelowZone = playerBottomZoneFullyIn - pz;
        newZ = bottomZoneFullyInZone - amountBelowZone;
    }
    if (!fullyInFirst) {
        // translate
        var amountOutsideZone = px - playerFirstBaseZoneFullyIn;
        newX = firstBaseZoneFullyIn + amountOutsideZone;
    }
    if (!fullyInThird) {
        // translate
        var _amountOutsideZone = playerThirdBaseZoneFullyIn - px;
        newX = thirdBaseZoneFullyIn - _amountOutsideZone;
    }
    if (!fullyInUp && !fullyInDown || !fullyInFirst && !fullyInThird) {
        console.error('SANITY CHECK FAILED');
        throw new Error('Sanity check failed');
    }
    return {
        x: newX,
        z: newZ
    };
}

});
parcelRegister("blS65", function(module, exports) {

$parcel$export(module.exports, "version", () => (parcelRequire("1jJNd")).version);

var $1jJNd = parcelRequire("1jJNd");

var $bLRBz = parcelRequire("bLRBz");

var $hqMSL = parcelRequire("hqMSL");

var $drc4U = parcelRequire("drc4U");

var $5pHLB = parcelRequire("5pHLB");

var $18ELu = parcelRequire("18ELu");

var $3MDY6 = parcelRequire("3MDY6");

var $9IfuZ = parcelRequire("9IfuZ");

var $4lCzg = parcelRequire("4lCzg");

var $6qavz = parcelRequire("6qavz");

var $5pGIM = parcelRequire("5pGIM");

var $cQwnF = parcelRequire("cQwnF");

var $i6mn5 = parcelRequire("i6mn5");

var $f4uLp = parcelRequire("f4uLp");

var $9o5I9 = parcelRequire("9o5I9");

var $lE4ix = parcelRequire("lE4ix");

var $gwfK8 = parcelRequire("gwfK8");

var $hI6ph = parcelRequire("hI6ph");

var $5Svs5 = parcelRequire("5Svs5");

var $eKigJ = parcelRequire("eKigJ");

var $g2PCc = parcelRequire("g2PCc");

var $kWcvL = parcelRequire("kWcvL");

var $6DK8J = parcelRequire("6DK8J");

var $hsbXN = parcelRequire("hsbXN");

var $cA5kC = parcelRequire("cA5kC");

var $3PZlk = parcelRequire("3PZlk");

var $anGg0 = parcelRequire("anGg0");

var $hvg0P = parcelRequire("hvg0P");

var $d44Sf = parcelRequire("d44Sf");

var $d0ohb = parcelRequire("d0ohb");

var $B8rCm = parcelRequire("B8rCm");
$parcel$exportWildcard(module.exports, $bLRBz);
$parcel$exportWildcard(module.exports, $hqMSL);
$parcel$exportWildcard(module.exports, $drc4U);
$parcel$exportWildcard(module.exports, $5pHLB);
$parcel$exportWildcard(module.exports, $18ELu);
$parcel$exportWildcard(module.exports, $3MDY6);
$parcel$exportWildcard(module.exports, $9IfuZ);
$parcel$exportWildcard(module.exports, $4lCzg);
$parcel$exportWildcard(module.exports, $6qavz);
$parcel$exportWildcard(module.exports, $5pGIM);
$parcel$exportWildcard(module.exports, $cQwnF);
$parcel$exportWildcard(module.exports, $i6mn5);
$parcel$exportWildcard(module.exports, $f4uLp);
$parcel$exportWildcard(module.exports, $9o5I9);
$parcel$exportWildcard(module.exports, $lE4ix);
$parcel$exportWildcard(module.exports, $gwfK8);
$parcel$exportWildcard(module.exports, $hI6ph);
$parcel$exportWildcard(module.exports, $5Svs5);
$parcel$exportWildcard(module.exports, $eKigJ);
$parcel$exportWildcard(module.exports, $g2PCc);
$parcel$exportWildcard(module.exports, $kWcvL);
$parcel$exportWildcard(module.exports, $6DK8J);
$parcel$exportWildcard(module.exports, $hsbXN);
$parcel$exportWildcard(module.exports, $cA5kC);
$parcel$exportWildcard(module.exports, $3PZlk);
$parcel$exportWildcard(module.exports, $anGg0);
$parcel$exportWildcard(module.exports, $hvg0P);
$parcel$exportWildcard(module.exports, $d44Sf);
$parcel$exportWildcard(module.exports, $d0ohb);
$parcel$exportWildcard(module.exports, $B8rCm);

});
parcelRegister("1jJNd", function(module, exports) {

$parcel$export(module.exports, "version", () => $0f5b164ab16c4920$export$83d89fbfd8236492);
var $0f5b164ab16c4920$export$a8ff84c12d48cfa6 = "d3";
var $0f5b164ab16c4920$export$83d89fbfd8236492 = "6.7.0";
var $0f5b164ab16c4920$export$6d59db4903f20f7d = "Data-Driven Documents";
var $0f5b164ab16c4920$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $0f5b164ab16c4920$export$4cec2234a9c7ce6d = "https://d3js.org";
var $0f5b164ab16c4920$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $0f5b164ab16c4920$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $0f5b164ab16c4920$export$f22da7240b7add18 = "dist/d3.node.js";
var $0f5b164ab16c4920$export$101358e655b23e68 = "dist/d3.min.js";
var $0f5b164ab16c4920$export$a2877c4988dda7ec = "dist/d3.min.js";
var $0f5b164ab16c4920$export$130be424786e852f = "index.js";
var $0f5b164ab16c4920$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $0f5b164ab16c4920$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $0f5b164ab16c4920$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $0f5b164ab16c4920$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var $0f5b164ab16c4920$export$b74ff737e0e298b5 = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};

});

parcelRegister("bLRBz", function(module, exports) {

$parcel$export(module.exports, "bisect", () => (parcelRequire("3AuND")).default);
$parcel$export(module.exports, "bisectRight", () => (parcelRequire("3AuND")).bisectRight);
$parcel$export(module.exports, "bisectLeft", () => (parcelRequire("3AuND")).bisectLeft);
$parcel$export(module.exports, "bisectCenter", () => (parcelRequire("3AuND")).bisectCenter);
$parcel$export(module.exports, "ascending", () => (parcelRequire("f4B6o")).default);
$parcel$export(module.exports, "bisector", () => (parcelRequire("aoNYj")).default);
$parcel$export(module.exports, "count", () => (parcelRequire("kZKSQ")).default);
$parcel$export(module.exports, "cross", () => (parcelRequire("kA75x")).default);
$parcel$export(module.exports, "cumsum", () => (parcelRequire("kglVr")).default);
$parcel$export(module.exports, "descending", () => (parcelRequire("cHdKv")).default);
$parcel$export(module.exports, "deviation", () => (parcelRequire("6bGEl")).default);
$parcel$export(module.exports, "extent", () => (parcelRequire("800Ds")).default);
$parcel$export(module.exports, "Adder", () => (parcelRequire("loqCp")).Adder);
$parcel$export(module.exports, "fsum", () => (parcelRequire("loqCp")).fsum);
$parcel$export(module.exports, "fcumsum", () => (parcelRequire("loqCp")).fcumsum);
$parcel$export(module.exports, "group", () => (parcelRequire("jPLbq")).default);
$parcel$export(module.exports, "groups", () => (parcelRequire("jPLbq")).groups);
$parcel$export(module.exports, "index", () => (parcelRequire("jPLbq")).index);
$parcel$export(module.exports, "indexes", () => (parcelRequire("jPLbq")).indexes);
$parcel$export(module.exports, "rollup", () => (parcelRequire("jPLbq")).rollup);
$parcel$export(module.exports, "rollups", () => (parcelRequire("jPLbq")).rollups);
$parcel$export(module.exports, "groupSort", () => (parcelRequire("goxFO")).default);
$parcel$export(module.exports, "bin", () => (parcelRequire("apYDd")).default);
$parcel$export(module.exports, "histogram", () => (parcelRequire("apYDd")).default);
$parcel$export(module.exports, "thresholdFreedmanDiaconis", () => (parcelRequire("JAH46")).default);
$parcel$export(module.exports, "thresholdScott", () => (parcelRequire("52e02")).default);
$parcel$export(module.exports, "thresholdSturges", () => (parcelRequire("dJyty")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("3nBT6")).default);
$parcel$export(module.exports, "maxIndex", () => (parcelRequire("6nWCr")).default);
$parcel$export(module.exports, "mean", () => (parcelRequire("8m9Q1")).default);
$parcel$export(module.exports, "median", () => (parcelRequire("2tfw3")).default);
$parcel$export(module.exports, "merge", () => (parcelRequire("c5gab")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("d7JLk")).default);
$parcel$export(module.exports, "minIndex", () => (parcelRequire("7rqn4")).default);
$parcel$export(module.exports, "nice", () => (parcelRequire("048Ce")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("h8lcU")).default);
$parcel$export(module.exports, "permute", () => (parcelRequire("2CTPq")).default);
$parcel$export(module.exports, "quantile", () => (parcelRequire("iuauc")).default);
$parcel$export(module.exports, "quantileSorted", () => (parcelRequire("iuauc")).quantileSorted);
$parcel$export(module.exports, "quickselect", () => (parcelRequire("bSi1l")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("4n9LK")).default);
$parcel$export(module.exports, "least", () => (parcelRequire("ftL4W")).default);
$parcel$export(module.exports, "leastIndex", () => (parcelRequire("1cI4K")).default);
$parcel$export(module.exports, "greatest", () => (parcelRequire("uaIHo")).default);
$parcel$export(module.exports, "greatestIndex", () => (parcelRequire("iEMM3")).default);
$parcel$export(module.exports, "scan", () => (parcelRequire("6pi7x")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("IGIla")).default);
$parcel$export(module.exports, "shuffler", () => (parcelRequire("IGIla")).shuffler);
$parcel$export(module.exports, "sum", () => (parcelRequire("a5XFg")).default);
$parcel$export(module.exports, "ticks", () => (parcelRequire("3PQRV")).default);
$parcel$export(module.exports, "tickIncrement", () => (parcelRequire("3PQRV")).tickIncrement);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("3PQRV")).tickStep);
$parcel$export(module.exports, "transpose", () => (parcelRequire("2nRGP")).default);
$parcel$export(module.exports, "variance", () => (parcelRequire("6IjmO")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("cRbyZ")).default);
$parcel$export(module.exports, "every", () => (parcelRequire("a4Asp")).default);
$parcel$export(module.exports, "some", () => (parcelRequire("ccgmP")).default);
$parcel$export(module.exports, "filter", () => (parcelRequire("57hpY")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("cDGmr")).default);
$parcel$export(module.exports, "reduce", () => (parcelRequire("eV6Yj")).default);
$parcel$export(module.exports, "reverse", () => (parcelRequire("3Ih2C")).default);
$parcel$export(module.exports, "sort", () => (parcelRequire("jrlov")).default);
$parcel$export(module.exports, "difference", () => (parcelRequire("aZTQY")).default);
$parcel$export(module.exports, "disjoint", () => (parcelRequire("3jojo")).default);
$parcel$export(module.exports, "intersection", () => (parcelRequire("3JL5w")).default);
$parcel$export(module.exports, "subset", () => (parcelRequire("iXWFx")).default);
$parcel$export(module.exports, "superset", () => (parcelRequire("4blRS")).default);
$parcel$export(module.exports, "union", () => (parcelRequire("50EAO")).default);
$parcel$export(module.exports, "InternMap", () => (parcelRequire("fDhVf")).InternMap);
$parcel$export(module.exports, "InternSet", () => (parcelRequire("fDhVf")).InternSet);

var $3AuND = parcelRequire("3AuND");

var $f4B6o = parcelRequire("f4B6o");

var $aoNYj = parcelRequire("aoNYj");

var $kZKSQ = parcelRequire("kZKSQ");

var $kA75x = parcelRequire("kA75x");

var $kglVr = parcelRequire("kglVr");

var $cHdKv = parcelRequire("cHdKv");

var $6bGEl = parcelRequire("6bGEl");

var $800Ds = parcelRequire("800Ds");

var $loqCp = parcelRequire("loqCp");

var $jPLbq = parcelRequire("jPLbq");

var $goxFO = parcelRequire("goxFO");

var $apYDd = parcelRequire("apYDd");

var $JAH46 = parcelRequire("JAH46");

var $52e02 = parcelRequire("52e02");

var $dJyty = parcelRequire("dJyty");

var $3nBT6 = parcelRequire("3nBT6");

var $6nWCr = parcelRequire("6nWCr");

var $8m9Q1 = parcelRequire("8m9Q1");

var $2tfw3 = parcelRequire("2tfw3");

var $c5gab = parcelRequire("c5gab");

var $d7JLk = parcelRequire("d7JLk");

var $7rqn4 = parcelRequire("7rqn4");

var $048Ce = parcelRequire("048Ce");

var $h8lcU = parcelRequire("h8lcU");

var $2CTPq = parcelRequire("2CTPq");

var $iuauc = parcelRequire("iuauc");

var $bSi1l = parcelRequire("bSi1l");

var $4n9LK = parcelRequire("4n9LK");

var $ftL4W = parcelRequire("ftL4W");

var $1cI4K = parcelRequire("1cI4K");

var $uaIHo = parcelRequire("uaIHo");

var $iEMM3 = parcelRequire("iEMM3");

var $6pi7x = parcelRequire("6pi7x");

var $IGIla = parcelRequire("IGIla");

var $a5XFg = parcelRequire("a5XFg");

var $3PQRV = parcelRequire("3PQRV");

var $2nRGP = parcelRequire("2nRGP");

var $6IjmO = parcelRequire("6IjmO");

var $cRbyZ = parcelRequire("cRbyZ");

var $a4Asp = parcelRequire("a4Asp");

var $ccgmP = parcelRequire("ccgmP");

var $57hpY = parcelRequire("57hpY");

var $cDGmr = parcelRequire("cDGmr");

var $eV6Yj = parcelRequire("eV6Yj");

var $3Ih2C = parcelRequire("3Ih2C");

var $jrlov = parcelRequire("jrlov");

var $aZTQY = parcelRequire("aZTQY");

var $3jojo = parcelRequire("3jojo");

var $3JL5w = parcelRequire("3JL5w");

var $iXWFx = parcelRequire("iXWFx");

var $4blRS = parcelRequire("4blRS");

var $50EAO = parcelRequire("50EAO");

var $fDhVf = parcelRequire("fDhVf");

});
parcelRegister("3AuND", function(module, exports) {

$parcel$export(module.exports, "bisectRight", () => $29cca007c10acc59$export$4d945ad3ad5751b0);
$parcel$export(module.exports, "bisectLeft", () => $29cca007c10acc59$export$df7d25c84ebd12a5);
$parcel$export(module.exports, "bisectCenter", () => $29cca007c10acc59$export$c1cb828b1117c77b);
$parcel$export(module.exports, "default", () => $29cca007c10acc59$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");

var $aoNYj = parcelRequire("aoNYj");

var $68LHL = parcelRequire("68LHL");
const $29cca007c10acc59$var$ascendingBisect = (0, $aoNYj.default)((0, $f4B6o.default));
const $29cca007c10acc59$export$4d945ad3ad5751b0 = $29cca007c10acc59$var$ascendingBisect.right;
const $29cca007c10acc59$export$df7d25c84ebd12a5 = $29cca007c10acc59$var$ascendingBisect.left;
const $29cca007c10acc59$export$c1cb828b1117c77b = (0, $aoNYj.default)((0, $68LHL.default)).center;
var $29cca007c10acc59$export$2e2bcd8739ae039 = $29cca007c10acc59$export$4d945ad3ad5751b0;

});
parcelRegister("f4B6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $af94026fb8a6594c$export$2e2bcd8739ae039);
function $af94026fb8a6594c$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("aoNYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7922e89a8d82e463$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");
function $7922e89a8d82e463$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $7922e89a8d82e463$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $7922e89a8d82e463$var$ascendingComparator(f) {
    return (d, x)=>(0, $f4B6o.default)(f(d), x);
}

});

parcelRegister("68LHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $47887ea20d06e35c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "numbers", () => $47887ea20d06e35c$export$1f6c9cc012ebacae);
function $47887ea20d06e35c$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $47887ea20d06e35c$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("kZKSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48ddf452e497f46$export$2e2bcd8739ae039);
function $f48ddf452e497f46$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("kA75x", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbcab06ceecfdd5$export$2e2bcd8739ae039);
function $efbcab06ceecfdd5$var$length(array) {
    return array.length | 0;
}
function $efbcab06ceecfdd5$var$empty(length) {
    return !(length > 0);
}
function $efbcab06ceecfdd5$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $efbcab06ceecfdd5$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $efbcab06ceecfdd5$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $efbcab06ceecfdd5$var$reducer(values.pop());
    values = values.map($efbcab06ceecfdd5$var$arrayify);
    const lengths = values.map($efbcab06ceecfdd5$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($efbcab06ceecfdd5$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("kglVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec064f3c082977f1$export$2e2bcd8739ae039);
function $ec064f3c082977f1$export$2e2bcd8739ae039(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("cHdKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93e42a7cb162a894$export$2e2bcd8739ae039);
function $93e42a7cb162a894$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("6bGEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4814da7e2e9a8c63$export$2e2bcd8739ae039);

var $6IjmO = parcelRequire("6IjmO");
function $4814da7e2e9a8c63$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $6IjmO.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("6IjmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e35e004568d68b6$export$2e2bcd8739ae039);
function $4e35e004568d68b6$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("800Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2ed1001fe09cbd$export$2e2bcd8739ae039);
function $5d2ed1001fe09cbd$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("loqCp", function(module, exports) {

$parcel$export(module.exports, "Adder", () => $f9307cc0e0568532$export$bda7ba77fb86c375);
$parcel$export(module.exports, "fsum", () => $f9307cc0e0568532$export$61cb83f1a93e9fae);
$parcel$export(module.exports, "fcumsum", () => $f9307cc0e0568532$export$5a6391da70c130da);
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $f9307cc0e0568532$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $f9307cc0e0568532$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $f9307cc0e0568532$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $f9307cc0e0568532$export$5a6391da70c130da(values, valueof) {
    const adder = new $f9307cc0e0568532$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("jPLbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e707615e767d70b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "groups", () => $e707615e767d70b6$export$d4abd167df80d226);
$parcel$export(module.exports, "rollup", () => $e707615e767d70b6$export$97e11c0b0230f130);
$parcel$export(module.exports, "rollups", () => $e707615e767d70b6$export$24814875ed03194b);
$parcel$export(module.exports, "index", () => $e707615e767d70b6$export$b610b8812bbcded9);
$parcel$export(module.exports, "indexes", () => $e707615e767d70b6$export$8b04ba635e5803cd);

var $fDhVf = parcelRequire("fDhVf");

var $icwyS = parcelRequire("icwyS");
function $e707615e767d70b6$export$2e2bcd8739ae039(values, ...keys) {
    return $e707615e767d70b6$var$nest(values, (0, $icwyS.default), (0, $icwyS.default), keys);
}
function $e707615e767d70b6$export$d4abd167df80d226(values, ...keys) {
    return $e707615e767d70b6$var$nest(values, Array.from, (0, $icwyS.default), keys);
}
function $e707615e767d70b6$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $e707615e767d70b6$var$nest(values, (0, $icwyS.default), reduce, keys);
}
function $e707615e767d70b6$export$24814875ed03194b(values, reduce, ...keys) {
    return $e707615e767d70b6$var$nest(values, Array.from, reduce, keys);
}
function $e707615e767d70b6$export$b610b8812bbcded9(values, ...keys) {
    return $e707615e767d70b6$var$nest(values, (0, $icwyS.default), $e707615e767d70b6$var$unique, keys);
}
function $e707615e767d70b6$export$8b04ba635e5803cd(values, ...keys) {
    return $e707615e767d70b6$var$nest(values, Array.from, $e707615e767d70b6$var$unique, keys);
}
function $e707615e767d70b6$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $e707615e767d70b6$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $fDhVf.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("fDhVf", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $b6186689e1e2d8dc$export$dcc6fb7d82b5bc7b);
$parcel$export(module.exports, "InternSet", () => $b6186689e1e2d8dc$export$55278c3294239828);
class $b6186689e1e2d8dc$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $b6186689e1e2d8dc$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($b6186689e1e2d8dc$var$intern_get(this, key));
    }
    has(key) {
        return super.has($b6186689e1e2d8dc$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($b6186689e1e2d8dc$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($b6186689e1e2d8dc$var$intern_delete(this, key));
    }
}
class $b6186689e1e2d8dc$export$55278c3294239828 extends Set {
    constructor(values, key = $b6186689e1e2d8dc$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($b6186689e1e2d8dc$var$intern_get(this, value));
    }
    add(value) {
        return super.add($b6186689e1e2d8dc$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($b6186689e1e2d8dc$var$intern_delete(this, value));
    }
}
function $b6186689e1e2d8dc$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $b6186689e1e2d8dc$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $b6186689e1e2d8dc$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $b6186689e1e2d8dc$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("icwyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4029b0a05c9c537$export$2e2bcd8739ae039);
function $d4029b0a05c9c537$export$2e2bcd8739ae039(x) {
    return x;
}

});


parcelRegister("goxFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef9021680e4ed6a$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");

var $jPLbq = parcelRequire("jPLbq");

var $jrlov = parcelRequire("jrlov");
function $bef9021680e4ed6a$export$2e2bcd8739ae039(values, reduce, key) {
    return (reduce.length === 1 ? (0, $jrlov.default)((0, $jPLbq.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $f4B6o.default)(av, bv) || (0, $f4B6o.default)(ak, bk)) : (0, $jrlov.default)((0, $jPLbq.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $f4B6o.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("jrlov", function(module, exports) {

$parcel$export(module.exports, "default", () => $e271226aa9851879$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");

var $2CTPq = parcelRequire("2CTPq");
function $e271226aa9851879$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f = (0, $f4B6o.default)] = F;
    if (f.length === 1 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = (0, $f4B6o.default)(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>(0, $f4B6o.default)(f[i], f[j]));
        }
        return (0, $2CTPq.default)(values, index);
    }
    return values.sort(f);
}

});
parcelRegister("2CTPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e9a6fbeafe08ef9$export$2e2bcd8739ae039);
function $1e9a6fbeafe08ef9$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("apYDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $795b4554f705a7e3$export$2e2bcd8739ae039);

var $lwBjB = parcelRequire("lwBjB");

var $3AuND = parcelRequire("3AuND");

var $9pz33 = parcelRequire("9pz33");

var $800Ds = parcelRequire("800Ds");

var $icwyS = parcelRequire("icwyS");

var $048Ce = parcelRequire("048Ce");

var $3PQRV = parcelRequire("3PQRV");

var $dJyty = parcelRequire("dJyty");
function $795b4554f705a7e3$export$2e2bcd8739ae039() {
    var value = (0, $icwyS.default), domain = (0, $800Ds.default), threshold = (0, $dJyty.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, $800Ds.default)) [x0, x1] = (0, $048Ce.default)(x0, x1, tn);
            tz = (0, $3PQRV.default)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, $800Ds.default)) {
                    const step = (0, $3PQRV.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $3AuND.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $9pz33.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $9pz33.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $9pz33.default)((0, $lwBjB.slice).call(_)) : (0, $9pz33.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("lwBjB", function(module, exports) {

$parcel$export(module.exports, "slice", () => $fab98823468b301a$export$58adb3bec8346d0f);
var $fab98823468b301a$var$array = Array.prototype;
var $fab98823468b301a$export$58adb3bec8346d0f = $fab98823468b301a$var$array.slice;
var $fab98823468b301a$export$871de8747c9eaa88 = $fab98823468b301a$var$array.map;

});

parcelRegister("9pz33", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da1a2b10d3eff84$export$2e2bcd8739ae039);
function $6da1a2b10d3eff84$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("048Ce", function(module, exports) {

$parcel$export(module.exports, "default", () => $00c70ebbfcd0b5d9$export$2e2bcd8739ae039);

var $3PQRV = parcelRequire("3PQRV");
function $00c70ebbfcd0b5d9$export$2e2bcd8739ae039(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $3PQRV.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("3PQRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2caf25283def2653$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $2caf25283def2653$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $2caf25283def2653$export$81087d9b915d4ede);
var $2caf25283def2653$var$e10 = Math.sqrt(50), $2caf25283def2653$var$e5 = Math.sqrt(10), $2caf25283def2653$var$e2 = Math.sqrt(2);
function $2caf25283def2653$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $2caf25283def2653$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $2caf25283def2653$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $2caf25283def2653$var$e10 ? 10 : error >= $2caf25283def2653$var$e5 ? 5 : error >= $2caf25283def2653$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $2caf25283def2653$var$e10 ? 10 : error >= $2caf25283def2653$var$e5 ? 5 : error >= $2caf25283def2653$var$e2 ? 2 : 1);
}
function $2caf25283def2653$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $2caf25283def2653$var$e10) step1 *= 10;
    else if (error >= $2caf25283def2653$var$e5) step1 *= 5;
    else if (error >= $2caf25283def2653$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("dJyty", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffa3877919e995a$export$2e2bcd8739ae039);

var $kZKSQ = parcelRequire("kZKSQ");
function $9ffa3877919e995a$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log((0, $kZKSQ.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("JAH46", function(module, exports) {

$parcel$export(module.exports, "default", () => $0890aaab1b28474b$export$2e2bcd8739ae039);

var $kZKSQ = parcelRequire("kZKSQ");

var $iuauc = parcelRequire("iuauc");
function $0890aaab1b28474b$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $iuauc.default)(values, 0.75) - (0, $iuauc.default)(values, 0.25)) * Math.pow((0, $kZKSQ.default)(values), -1 / 3)));
}

});
parcelRegister("iuauc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d75329a49cb61985$export$2e2bcd8739ae039);
$parcel$export(module.exports, "quantileSorted", () => $d75329a49cb61985$export$f924a6cad778dddb);

var $3nBT6 = parcelRequire("3nBT6");

var $d7JLk = parcelRequire("d7JLk");

var $bSi1l = parcelRequire("bSi1l");

var $68LHL = parcelRequire("68LHL");
function $d75329a49cb61985$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $68LHL.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $d7JLk.default)(values);
    if (p >= 1) return (0, $3nBT6.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $3nBT6.default)((0, $bSi1l.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $d7JLk.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $d75329a49cb61985$export$f924a6cad778dddb(values, p, valueof = (0, $68LHL.default)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("3nBT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2760e8cda5b2de5f$export$2e2bcd8739ae039);
function $2760e8cda5b2de5f$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("d7JLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $98df6d48690993dc$export$2e2bcd8739ae039);
function $98df6d48690993dc$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("bSi1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a52b764dd587ccb$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");
function $8a52b764dd587ccb$export$2e2bcd8739ae039(array, k, left = 0, right = array.length - 1, compare = (0, $f4B6o.default)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $8a52b764dd587ccb$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $8a52b764dd587ccb$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $8a52b764dd587ccb$var$swap(array, left, right);
        while(i < j){
            $8a52b764dd587ccb$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $8a52b764dd587ccb$var$swap(array, left, j);
        else ++j, $8a52b764dd587ccb$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $8a52b764dd587ccb$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("52e02", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aa7ffacec3af070$export$2e2bcd8739ae039);

var $kZKSQ = parcelRequire("kZKSQ");

var $6bGEl = parcelRequire("6bGEl");
function $3aa7ffacec3af070$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $6bGEl.default)(values) * Math.pow((0, $kZKSQ.default)(values), -1 / 3)));
}

});

parcelRegister("6nWCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a625c90af6cddb1$export$2e2bcd8739ae039);
function $4a625c90af6cddb1$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("8m9Q1", function(module, exports) {

$parcel$export(module.exports, "default", () => $615802752a8ed5aa$export$2e2bcd8739ae039);
function $615802752a8ed5aa$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("2tfw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cca535a6ea9a266$export$2e2bcd8739ae039);

var $iuauc = parcelRequire("iuauc");
function $1cca535a6ea9a266$export$2e2bcd8739ae039(values, valueof) {
    return (0, $iuauc.default)(values, 0.5, valueof);
}

});

parcelRegister("c5gab", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc27d59b926073f$export$2e2bcd8739ae039);
function* $8cc27d59b926073f$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $8cc27d59b926073f$export$2e2bcd8739ae039(arrays) {
    return Array.from($8cc27d59b926073f$var$flatten(arrays));
}

});

parcelRegister("7rqn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $56af82c609913aae$export$2e2bcd8739ae039);
function $56af82c609913aae$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("h8lcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c793a257877601e6$export$2e2bcd8739ae039);
function $c793a257877601e6$export$2e2bcd8739ae039(values, pairof = $c793a257877601e6$export$a04cb3fe8b81dd) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $c793a257877601e6$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("4n9LK", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f0e3536d4a140d$export$2e2bcd8739ae039);
function $32f0e3536d4a140d$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ftL4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $b44e154a88d0f95f$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");
function $b44e154a88d0f95f$export$2e2bcd8739ae039(values, compare = (0, $f4B6o.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f4B6o.default)(value, minValue) < 0 : (0, $f4B6o.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("1cI4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e0919eb717df783$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");

var $7rqn4 = parcelRequire("7rqn4");
function $0e0919eb717df783$export$2e2bcd8739ae039(values, compare = (0, $f4B6o.default)) {
    if (compare.length === 1) return (0, $7rqn4.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("uaIHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $05ab1e37104a2e35$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");
function $05ab1e37104a2e35$export$2e2bcd8739ae039(values, compare = (0, $f4B6o.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f4B6o.default)(value, maxValue) > 0 : (0, $f4B6o.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("iEMM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d951cbf4451a6132$export$2e2bcd8739ae039);

var $f4B6o = parcelRequire("f4B6o");

var $6nWCr = parcelRequire("6nWCr");
function $d951cbf4451a6132$export$2e2bcd8739ae039(values, compare = (0, $f4B6o.default)) {
    if (compare.length === 1) return (0, $6nWCr.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("6pi7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa322451694925b$export$2e2bcd8739ae039);

var $1cI4K = parcelRequire("1cI4K");
function $4aa322451694925b$export$2e2bcd8739ae039(values, compare) {
    const index = (0, $1cI4K.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("IGIla", function(module, exports) {

$parcel$export(module.exports, "default", () => $08653e51dca4d8dc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "shuffler", () => $08653e51dca4d8dc$export$a430ea578c95d356);
var $08653e51dca4d8dc$export$2e2bcd8739ae039 = $08653e51dca4d8dc$export$a430ea578c95d356(Math.random);
function $08653e51dca4d8dc$export$a430ea578c95d356(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("a5XFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7598a7283d2dc9c0$export$2e2bcd8739ae039);
function $7598a7283d2dc9c0$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("2nRGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc7607104b4d056$export$2e2bcd8739ae039);

var $d7JLk = parcelRequire("d7JLk");
function $1bc7607104b4d056$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $d7JLk.default)(matrix, $1bc7607104b4d056$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $1bc7607104b4d056$var$length(d) {
    return d.length;
}

});

parcelRegister("cRbyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c3677e67a7fcbb$export$2e2bcd8739ae039);

var $2nRGP = parcelRequire("2nRGP");
function $95c3677e67a7fcbb$export$2e2bcd8739ae039() {
    return (0, $2nRGP.default)(arguments);
}

});

parcelRegister("a4Asp", function(module, exports) {

$parcel$export(module.exports, "default", () => $75568ebf83742334$export$2e2bcd8739ae039);
function $75568ebf83742334$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("ccgmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e134d394c1adbf3$export$2e2bcd8739ae039);
function $8e134d394c1adbf3$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("57hpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b9b1e0a0825d23d$export$2e2bcd8739ae039);
function $3b9b1e0a0825d23d$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("cDGmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9339fc93cba03544$export$2e2bcd8739ae039);
function $9339fc93cba03544$export$2e2bcd8739ae039(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("eV6Yj", function(module, exports) {

$parcel$export(module.exports, "default", () => $adcbcc02c3eab1ab$export$2e2bcd8739ae039);
function $adcbcc02c3eab1ab$export$2e2bcd8739ae039(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("3Ih2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b33347debb17$export$2e2bcd8739ae039);
function $2b42b33347debb17$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("aZTQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $801aed2fcd3f98b1$export$2e2bcd8739ae039);
function $801aed2fcd3f98b1$export$2e2bcd8739ae039(values, ...others) {
    values = new Set(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("3jojo", function(module, exports) {

$parcel$export(module.exports, "default", () => $26960145b9110fbd$export$2e2bcd8739ae039);
function $26960145b9110fbd$export$2e2bcd8739ae039(values, other) {
    const iterator = other[Symbol.iterator](), set = new Set();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("3JL5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8a19c11a66f515$export$2e2bcd8739ae039);

var $9DhMI = parcelRequire("9DhMI");
function $2b8a19c11a66f515$export$2e2bcd8739ae039(values, ...others) {
    values = new Set(values);
    others = others.map((0, $9DhMI.default));
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}

});
parcelRegister("9DhMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $70358d3a8c578ca4$export$2e2bcd8739ae039);
function $70358d3a8c578ca4$export$2e2bcd8739ae039(values) {
    return values instanceof Set ? values : new Set(values);
}

});


parcelRegister("iXWFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dceb3f1f653f3686$export$2e2bcd8739ae039);

var $4blRS = parcelRequire("4blRS");
function $dceb3f1f653f3686$export$2e2bcd8739ae039(values, other) {
    return (0, $4blRS.default)(other, values);
}

});
parcelRegister("4blRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b927079e81427a$export$2e2bcd8739ae039);
function $30b927079e81427a$export$2e2bcd8739ae039(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        if (set.has(o)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            set.add(value);
            if (Object.is(o, value)) break;
        }
    }
    return true;
}

});


parcelRegister("50EAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a5c70b20864f4c2$export$2e2bcd8739ae039);
function $3a5c70b20864f4c2$export$2e2bcd8739ae039(...others) {
    const set = new Set();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("hqMSL", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => (parcelRequire("euOem")).axisTop);
$parcel$export(module.exports, "axisRight", () => (parcelRequire("euOem")).axisRight);
$parcel$export(module.exports, "axisBottom", () => (parcelRequire("euOem")).axisBottom);
$parcel$export(module.exports, "axisLeft", () => (parcelRequire("euOem")).axisLeft);

var $euOem = parcelRequire("euOem");

});
parcelRegister("euOem", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => $a8dad4c5cc80e50a$export$59b8cfab074bdeb1);
$parcel$export(module.exports, "axisRight", () => $a8dad4c5cc80e50a$export$b0d2e24dc4f898f0);
$parcel$export(module.exports, "axisBottom", () => $a8dad4c5cc80e50a$export$e5cb22533a15e72e);
$parcel$export(module.exports, "axisLeft", () => $a8dad4c5cc80e50a$export$2749afb169a520d2);

var $iGPVl = parcelRequire("iGPVl");

var $7G8Iv = parcelRequire("7G8Iv");
var $a8dad4c5cc80e50a$var$top = 1, $a8dad4c5cc80e50a$var$right = 2, $a8dad4c5cc80e50a$var$bottom = 3, $a8dad4c5cc80e50a$var$left = 4, $a8dad4c5cc80e50a$var$epsilon = 1e-6;
function $a8dad4c5cc80e50a$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $a8dad4c5cc80e50a$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $a8dad4c5cc80e50a$var$number(scale) {
    return (d)=>+scale(d);
}
function $a8dad4c5cc80e50a$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $a8dad4c5cc80e50a$var$entering() {
    return !this.__axis;
}
function $a8dad4c5cc80e50a$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $a8dad4c5cc80e50a$var$top || orient === $a8dad4c5cc80e50a$var$left ? -1 : 1, x = orient === $a8dad4c5cc80e50a$var$left || orient === $a8dad4c5cc80e50a$var$right ? "x" : "y", transform = orient === $a8dad4c5cc80e50a$var$top || orient === $a8dad4c5cc80e50a$var$bottom ? $a8dad4c5cc80e50a$var$translateX : $a8dad4c5cc80e50a$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $7G8Iv.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $a8dad4c5cc80e50a$var$center : $a8dad4c5cc80e50a$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $a8dad4c5cc80e50a$var$top ? "0em" : orient === $a8dad4c5cc80e50a$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $a8dad4c5cc80e50a$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $a8dad4c5cc80e50a$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $a8dad4c5cc80e50a$var$left || orient === $a8dad4c5cc80e50a$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($a8dad4c5cc80e50a$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $a8dad4c5cc80e50a$var$right ? "start" : orient === $a8dad4c5cc80e50a$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $iGPVl.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $iGPVl.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $iGPVl.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $a8dad4c5cc80e50a$export$59b8cfab074bdeb1(scale) {
    return $a8dad4c5cc80e50a$var$axis($a8dad4c5cc80e50a$var$top, scale);
}
function $a8dad4c5cc80e50a$export$b0d2e24dc4f898f0(scale) {
    return $a8dad4c5cc80e50a$var$axis($a8dad4c5cc80e50a$var$right, scale);
}
function $a8dad4c5cc80e50a$export$e5cb22533a15e72e(scale) {
    return $a8dad4c5cc80e50a$var$axis($a8dad4c5cc80e50a$var$bottom, scale);
}
function $a8dad4c5cc80e50a$export$2749afb169a520d2(scale) {
    return $a8dad4c5cc80e50a$var$axis($a8dad4c5cc80e50a$var$left, scale);
}

});
parcelRegister("iGPVl", function(module, exports) {

$parcel$export(module.exports, "slice", () => $d9b46d445dffedd8$export$58adb3bec8346d0f);
var $d9b46d445dffedd8$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("7G8Iv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5973379b65e81b20$export$2e2bcd8739ae039);
function $5973379b65e81b20$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("drc4U", function(module, exports) {

$parcel$export(module.exports, "brush", () => (parcelRequire("gmkY3")).default);
$parcel$export(module.exports, "brushX", () => (parcelRequire("gmkY3")).brushX);
$parcel$export(module.exports, "brushY", () => (parcelRequire("gmkY3")).brushY);
$parcel$export(module.exports, "brushSelection", () => (parcelRequire("gmkY3")).brushSelection);

var $gmkY3 = parcelRequire("gmkY3");

});
parcelRegister("gmkY3", function(module, exports) {

$parcel$export(module.exports, "brushSelection", () => $be8ef7207c2c73a5$export$69760394fc76f689);
$parcel$export(module.exports, "brushX", () => $be8ef7207c2c73a5$export$979ace6c88860aa8);
$parcel$export(module.exports, "brushY", () => $be8ef7207c2c73a5$export$468748b530991c54);
$parcel$export(module.exports, "default", () => $be8ef7207c2c73a5$export$2e2bcd8739ae039);

var $2LbPR = parcelRequire("2LbPR");

var $ZdBH5 = parcelRequire("ZdBH5");

var $4PXvd = parcelRequire("4PXvd");

var $2GQnz = parcelRequire("2GQnz");
var $cn1Uc = parcelRequire("cn1Uc");
parcelRequire("d0ohb");
var $cY1kc = parcelRequire("cY1kc");

var $eaHrV = parcelRequire("eaHrV");

var $bNHS9 = parcelRequire("bNHS9");

var $eRpSf = parcelRequire("eRpSf");
var $be8ef7207c2c73a5$var$MODE_DRAG = {
    name: "drag"
}, $be8ef7207c2c73a5$var$MODE_SPACE = {
    name: "space"
}, $be8ef7207c2c73a5$var$MODE_HANDLE = {
    name: "handle"
}, $be8ef7207c2c73a5$var$MODE_CENTER = {
    name: "center"
};
const { abs: $be8ef7207c2c73a5$var$abs, max: $be8ef7207c2c73a5$var$max, min: $be8ef7207c2c73a5$var$min } = Math;
function $be8ef7207c2c73a5$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $be8ef7207c2c73a5$var$number2(e) {
    return [
        $be8ef7207c2c73a5$var$number1(e[0]),
        $be8ef7207c2c73a5$var$number1(e[1])
    ];
}
var $be8ef7207c2c73a5$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $be8ef7207c2c73a5$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $be8ef7207c2c73a5$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(xy) {
        return xy == null ? null : $be8ef7207c2c73a5$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $be8ef7207c2c73a5$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $be8ef7207c2c73a5$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $be8ef7207c2c73a5$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $be8ef7207c2c73a5$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $be8ef7207c2c73a5$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $be8ef7207c2c73a5$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $be8ef7207c2c73a5$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $be8ef7207c2c73a5$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $be8ef7207c2c73a5$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $be8ef7207c2c73a5$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $be8ef7207c2c73a5$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $be8ef7207c2c73a5$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $be8ef7207c2c73a5$export$979ace6c88860aa8() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$X);
}
function $be8ef7207c2c73a5$export$468748b530991c54() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$Y);
}
function $be8ef7207c2c73a5$export$2e2bcd8739ae039() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$XY);
}
function $be8ef7207c2c73a5$var$brush(dim) {
    var extent = $be8ef7207c2c73a5$var$defaultExtent, filter = $be8ef7207c2c73a5$var$defaultFilter, touchable = $be8ef7207c2c73a5$var$defaultTouchable, keys = true, listeners = (0, $2LbPR.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $be8ef7207c2c73a5$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $be8ef7207c2c73a5$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $be8ef7207c2c73a5$var$local(this).extent;
            (0, $cn1Uc.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $be8ef7207c2c73a5$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $be8ef7207c2c73a5$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $be8ef7207c2c73a5$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $4PXvd.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $cY1kc.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $cn1Uc.default)(this), selection = $be8ef7207c2c73a5$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $cn1Uc.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $bNHS9.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $be8ef7207c2c73a5$var$MODE_DRAG : keys && event.altKey ? $be8ef7207c2c73a5$var$MODE_CENTER : $be8ef7207c2c73a5$var$MODE_HANDLE, signX = dim === $be8ef7207c2c73a5$var$Y ? null : $be8ef7207c2c73a5$var$signsX[type], signY = dim === $be8ef7207c2c73a5$var$X ? null : $be8ef7207c2c73a5$var$signsY[type], state = $be8ef7207c2c73a5$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $2GQnz.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $be8ef7207c2c73a5$var$Y ? W : $be8ef7207c2c73a5$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $be8ef7207c2c73a5$var$X ? N : $be8ef7207c2c73a5$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $be8ef7207c2c73a5$var$Y ? E : $be8ef7207c2c73a5$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $be8ef7207c2c73a5$var$X ? S : $be8ef7207c2c73a5$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cn1Uc.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $be8ef7207c2c73a5$var$cursors[type]);
        (0, $cY1kc.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cn1Uc.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $ZdBH5.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $2GQnz.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($be8ef7207c2c73a5$var$abs(point.cur[0] - point[0]) > $be8ef7207c2c73a5$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $eRpSf.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $be8ef7207c2c73a5$var$MODE_SPACE:
                case $be8ef7207c2c73a5$var$MODE_DRAG:
                    if (signX) dx = $be8ef7207c2c73a5$var$max(W - w0, $be8ef7207c2c73a5$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $be8ef7207c2c73a5$var$max(N - n0, $be8ef7207c2c73a5$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $be8ef7207c2c73a5$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, points[0][0])), e1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, points[0][1])), s1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $be8ef7207c2c73a5$var$max(W - w0, $be8ef7207c2c73a5$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $be8ef7207c2c73a5$var$max(W - e0, $be8ef7207c2c73a5$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $be8ef7207c2c73a5$var$max(N - n0, $be8ef7207c2c73a5$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $be8ef7207c2c73a5$var$max(N - s0, $be8ef7207c2c73a5$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $be8ef7207c2c73a5$var$MODE_CENTER:
                    if (signX) w1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, w0 - dx * signX)), e1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, n0 - dy * signY)), s1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $be8ef7207c2c73a5$var$flipX) overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type = $be8ef7207c2c73a5$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $be8ef7207c2c73a5$var$flipY) overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type = $be8ef7207c2c73a5$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $eRpSf.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $ZdBH5.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($be8ef7207c2c73a5$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $be8ef7207c2c73a5$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $be8ef7207c2c73a5$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $be8ef7207c2c73a5$var$MODE_HANDLE || mode === $be8ef7207c2c73a5$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $be8ef7207c2c73a5$var$MODE_SPACE;
                        overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $eRpSf.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $be8ef7207c2c73a5$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $be8ef7207c2c73a5$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $be8ef7207c2c73a5$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $be8ef7207c2c73a5$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $be8ef7207c2c73a5$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $eRpSf.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $be8ef7207c2c73a5$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $eaHrV.default)($be8ef7207c2c73a5$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $eaHrV.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $eaHrV.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("2LbPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $202926d84f9eb26c$export$2e2bcd8739ae039);
var $202926d84f9eb26c$var$noop = {
    value: ()=>{}
};
function $202926d84f9eb26c$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $202926d84f9eb26c$var$Dispatch(_);
}
function $202926d84f9eb26c$var$Dispatch(_) {
    this._ = _;
}
function $202926d84f9eb26c$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$202926d84f9eb26c$var$Dispatch.prototype = $202926d84f9eb26c$var$dispatch.prototype = {
    constructor: $202926d84f9eb26c$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $202926d84f9eb26c$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $202926d84f9eb26c$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $202926d84f9eb26c$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $202926d84f9eb26c$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $202926d84f9eb26c$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $202926d84f9eb26c$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $202926d84f9eb26c$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $202926d84f9eb26c$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $202926d84f9eb26c$export$2e2bcd8739ae039 = $202926d84f9eb26c$var$dispatch;

});

parcelRegister("ZdBH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b8040ae2b576907$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $0b8040ae2b576907$export$833237748009e1e1);

var $cn1Uc = parcelRequire("cn1Uc");

var $8Xieg = parcelRequire("8Xieg");
function $0b8040ae2b576907$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cn1Uc.default)(view).on("dragstart.drag", (0, $8Xieg.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $8Xieg.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $0b8040ae2b576907$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cn1Uc.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $8Xieg.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("cn1Uc", function(module, exports) {

$parcel$export(module.exports, "default", () => $90191c63f6c0937e$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");
function $90191c63f6c0937e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $4MWrt.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $4MWrt.Selection)([
        [
            selector
        ]
    ], (0, $4MWrt.root));
}

});
parcelRegister("4MWrt", function(module, exports) {

$parcel$export(module.exports, "root", () => $37c8fa7d5de8e53a$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $37c8fa7d5de8e53a$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $37c8fa7d5de8e53a$export$2e2bcd8739ae039);

var $gS6kN = parcelRequire("gS6kN");

var $25C3I = parcelRequire("25C3I");

var $dBP6q = parcelRequire("dBP6q");

var $52INz = parcelRequire("52INz");

var $j1kmW = parcelRequire("j1kmW");

var $9lFVO = parcelRequire("9lFVO");

var $ehCLQ = parcelRequire("ehCLQ");

var $jwV3d = parcelRequire("jwV3d");

var $6m7cX = parcelRequire("6m7cX");

var $lI9lC = parcelRequire("lI9lC");

var $3IeqJ = parcelRequire("3IeqJ");

var $c27Ky = parcelRequire("c27Ky");

var $5dkDe = parcelRequire("5dkDe");

var $35GDk = parcelRequire("35GDk");

var $hrk8f = parcelRequire("hrk8f");

var $lzZx7 = parcelRequire("lzZx7");

var $fHxYt = parcelRequire("fHxYt");

var $h6bNt = parcelRequire("h6bNt");

var $hKYji = parcelRequire("hKYji");

var $fWzBb = parcelRequire("fWzBb");

var $a7TW5 = parcelRequire("a7TW5");

var $kQxsU = parcelRequire("kQxsU");

var $1zr5C = parcelRequire("1zr5C");

var $75k6j = parcelRequire("75k6j");

var $kWe6j = parcelRequire("kWe6j");

var $51HoV = parcelRequire("51HoV");

var $aftTw = parcelRequire("aftTw");

var $dGQOX = parcelRequire("dGQOX");

var $ed7Jb = parcelRequire("ed7Jb");

var $2rsO5 = parcelRequire("2rsO5");

var $aH0eD = parcelRequire("aH0eD");

var $5fER9 = parcelRequire("5fER9");

var $47Cow = parcelRequire("47Cow");

var $iRYG5 = parcelRequire("iRYG5");
var $37c8fa7d5de8e53a$export$e8e78c978b129247 = [
    null
];
function $37c8fa7d5de8e53a$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $37c8fa7d5de8e53a$var$selection() {
    return new $37c8fa7d5de8e53a$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $37c8fa7d5de8e53a$export$e8e78c978b129247);
}
function $37c8fa7d5de8e53a$var$selection_selection() {
    return this;
}
$37c8fa7d5de8e53a$export$52baac22726c72bf.prototype = $37c8fa7d5de8e53a$var$selection.prototype = {
    constructor: $37c8fa7d5de8e53a$export$52baac22726c72bf,
    select: (0, $gS6kN.default),
    selectAll: (0, $25C3I.default),
    selectChild: (0, $dBP6q.default),
    selectChildren: (0, $52INz.default),
    filter: (0, $j1kmW.default),
    data: (0, $9lFVO.default),
    enter: (0, $ehCLQ.default),
    exit: (0, $jwV3d.default),
    join: (0, $6m7cX.default),
    merge: (0, $lI9lC.default),
    selection: $37c8fa7d5de8e53a$var$selection_selection,
    order: (0, $3IeqJ.default),
    sort: (0, $c27Ky.default),
    call: (0, $5dkDe.default),
    nodes: (0, $35GDk.default),
    node: (0, $hrk8f.default),
    size: (0, $lzZx7.default),
    empty: (0, $fHxYt.default),
    each: (0, $h6bNt.default),
    attr: (0, $hKYji.default),
    style: (0, $fWzBb.default),
    property: (0, $a7TW5.default),
    classed: (0, $kQxsU.default),
    text: (0, $1zr5C.default),
    html: (0, $75k6j.default),
    raise: (0, $kWe6j.default),
    lower: (0, $51HoV.default),
    append: (0, $aftTw.default),
    insert: (0, $dGQOX.default),
    remove: (0, $ed7Jb.default),
    clone: (0, $2rsO5.default),
    datum: (0, $aH0eD.default),
    on: (0, $5fER9.default),
    dispatch: (0, $47Cow.default),
    [Symbol.iterator]: (0, $iRYG5.default)
};
var $37c8fa7d5de8e53a$export$2e2bcd8739ae039 = $37c8fa7d5de8e53a$var$selection;

});
parcelRegister("gS6kN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4869a60ffcedcc8$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");

var $2Dn0x = parcelRequire("2Dn0x");
function $c4869a60ffcedcc8$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $2Dn0x.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $4MWrt.Selection)(subgroups, this._parents);
}

});
parcelRegister("2Dn0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb11220c0df6fba$export$2e2bcd8739ae039);
function $1eb11220c0df6fba$var$none() {}
function $1eb11220c0df6fba$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1eb11220c0df6fba$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("25C3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1859921b5009b8a8$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");

var $jj7uD = parcelRequire("jj7uD");

var $4yYEN = parcelRequire("4yYEN");
function $1859921b5009b8a8$var$arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, $jj7uD.default)(group);
    };
}
function $1859921b5009b8a8$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $1859921b5009b8a8$var$arrayAll(select);
    else select = (0, $4yYEN.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $4MWrt.Selection)(subgroups, parents);
}

});
parcelRegister("jj7uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e59aa4c770e5f3$export$2e2bcd8739ae039);
function $e0e59aa4c770e5f3$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("4yYEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $35296398f5f08b14$export$2e2bcd8739ae039);
function $35296398f5f08b14$var$empty() {
    return [];
}
function $35296398f5f08b14$export$2e2bcd8739ae039(selector) {
    return selector == null ? $35296398f5f08b14$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("dBP6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e865efb2db100ca$export$2e2bcd8739ae039);

var $3Pm5Z = parcelRequire("3Pm5Z");
var $9e865efb2db100ca$var$find = Array.prototype.find;
function $9e865efb2db100ca$var$childFind(match) {
    return function() {
        return $9e865efb2db100ca$var$find.call(this.children, match);
    };
}
function $9e865efb2db100ca$var$childFirst() {
    return this.firstElementChild;
}
function $9e865efb2db100ca$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $9e865efb2db100ca$var$childFirst : $9e865efb2db100ca$var$childFind(typeof match === "function" ? match : (0, $3Pm5Z.childMatcher)(match)));
}

});
parcelRegister("3Pm5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c974644544610bf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "childMatcher", () => $2c974644544610bf$export$90c2759c036528);
function $2c974644544610bf$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $2c974644544610bf$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("52INz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3abfe3b3bab936a2$export$2e2bcd8739ae039);

var $3Pm5Z = parcelRequire("3Pm5Z");
var $3abfe3b3bab936a2$var$filter = Array.prototype.filter;
function $3abfe3b3bab936a2$var$children() {
    return this.children;
}
function $3abfe3b3bab936a2$var$childrenFilter(match) {
    return function() {
        return $3abfe3b3bab936a2$var$filter.call(this.children, match);
    };
}
function $3abfe3b3bab936a2$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $3abfe3b3bab936a2$var$children : $3abfe3b3bab936a2$var$childrenFilter(typeof match === "function" ? match : (0, $3Pm5Z.childMatcher)(match)));
}

});

parcelRegister("j1kmW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8de9327f9b4bee$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");

var $3Pm5Z = parcelRequire("3Pm5Z");
function $dd8de9327f9b4bee$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $3Pm5Z.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $4MWrt.Selection)(subgroups, this._parents);
}

});

parcelRegister("9lFVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce699ef026be5ba$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");

var $ehCLQ = parcelRequire("ehCLQ");

var $jj7uD = parcelRequire("jj7uD");

var $hraRo = parcelRequire("hraRo");
function $6ce699ef026be5ba$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $ehCLQ.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $6ce699ef026be5ba$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $ehCLQ.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $6ce699ef026be5ba$var$datum(node) {
    return node.__data__;
}
function $6ce699ef026be5ba$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $6ce699ef026be5ba$var$datum);
    var bind = key ? $6ce699ef026be5ba$var$bindKey : $6ce699ef026be5ba$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $hraRo.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, $jj7uD.default)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $4MWrt.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("ehCLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a660ba455f4c25d9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $a660ba455f4c25d9$export$67b01759a14cf6a4);

var $i6qd4 = parcelRequire("i6qd4");

var $4MWrt = parcelRequire("4MWrt");
function $a660ba455f4c25d9$export$2e2bcd8739ae039() {
    return new (0, $4MWrt.Selection)(this._enter || this._groups.map((0, $i6qd4.default)), this._parents);
}
function $a660ba455f4c25d9$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$a660ba455f4c25d9$export$67b01759a14cf6a4.prototype = {
    constructor: $a660ba455f4c25d9$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("i6qd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2dd1e4699e2bab8$export$2e2bcd8739ae039);
function $d2dd1e4699e2bab8$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("hraRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1d61e5b917df77$export$2e2bcd8739ae039);
function $cb1d61e5b917df77$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("jwV3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37d429e6ee20412$export$2e2bcd8739ae039);

var $i6qd4 = parcelRequire("i6qd4");

var $4MWrt = parcelRequire("4MWrt");
function $e37d429e6ee20412$export$2e2bcd8739ae039() {
    return new (0, $4MWrt.Selection)(this._exit || this._groups.map((0, $i6qd4.default)), this._parents);
}

});

parcelRegister("6m7cX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a0a638312565382$export$2e2bcd8739ae039);
function $4a0a638312565382$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("lI9lC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce4f54fc901af6e$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");
function $fce4f54fc901af6e$export$2e2bcd8739ae039(selection) {
    if (!(selection instanceof (0, $4MWrt.Selection))) throw new Error("invalid merge");
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $4MWrt.Selection)(merges, this._parents);
}

});

parcelRegister("3IeqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b40acab8a6e5339$export$2e2bcd8739ae039);
function $2b40acab8a6e5339$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("c27Ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2baeed5e8519df$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");
function $8c2baeed5e8519df$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $8c2baeed5e8519df$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $4MWrt.Selection)(sortgroups, this._parents).order();
}
function $8c2baeed5e8519df$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("5dkDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbe2bb0fbfbc492$export$2e2bcd8739ae039);
function $3cbe2bb0fbfbc492$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("35GDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2402e8d45219fe31$export$2e2bcd8739ae039);
function $2402e8d45219fe31$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("hrk8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb24931c2e13001d$export$2e2bcd8739ae039);
function $cb24931c2e13001d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("lzZx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb5c990f621cbc31$export$2e2bcd8739ae039);
function $fb5c990f621cbc31$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("fHxYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6e539c56aac262b$export$2e2bcd8739ae039);
function $b6e539c56aac262b$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("h6bNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72c25cfd594e701$export$2e2bcd8739ae039);
function $c72c25cfd594e701$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("hKYji", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced583e5a728fccf$export$2e2bcd8739ae039);

var $vb4DM = parcelRequire("vb4DM");
function $ced583e5a728fccf$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $ced583e5a728fccf$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $ced583e5a728fccf$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $ced583e5a728fccf$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $ced583e5a728fccf$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $ced583e5a728fccf$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $ced583e5a728fccf$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $vb4DM.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $ced583e5a728fccf$var$attrRemoveNS : $ced583e5a728fccf$var$attrRemove : typeof value === "function" ? fullname.local ? $ced583e5a728fccf$var$attrFunctionNS : $ced583e5a728fccf$var$attrFunction : fullname.local ? $ced583e5a728fccf$var$attrConstantNS : $ced583e5a728fccf$var$attrConstant)(fullname, value));
}

});
parcelRegister("vb4DM", function(module, exports) {

$parcel$export(module.exports, "default", () => $05db7c66aecd909a$export$2e2bcd8739ae039);

var $81LHV = parcelRequire("81LHV");
function $05db7c66aecd909a$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $81LHV.default).hasOwnProperty(prefix) ? {
        space: (0, $81LHV.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("81LHV", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $5d836c69637356d2$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $5d836c69637356d2$export$2e2bcd8739ae039);
var $5d836c69637356d2$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $5d836c69637356d2$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $5d836c69637356d2$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("fWzBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b7e2f0730f1bd4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd);

var $6Qhlj = parcelRequire("6Qhlj");
function $b9b7e2f0730f1bd4$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b9b7e2f0730f1bd4$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $b9b7e2f0730f1bd4$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $b9b7e2f0730f1bd4$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $b9b7e2f0730f1bd4$var$styleRemove : typeof value === "function" ? $b9b7e2f0730f1bd4$var$styleFunction : $b9b7e2f0730f1bd4$var$styleConstant)(name, value, priority == null ? "" : priority)) : $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd(this.node(), name);
}
function $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $6Qhlj.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("6Qhlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb50d4df15a5dbd$export$2e2bcd8739ae039);
function $4fb50d4df15a5dbd$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("a7TW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $75f5f28dc7285710$export$2e2bcd8739ae039);
function $75f5f28dc7285710$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $75f5f28dc7285710$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $75f5f28dc7285710$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $75f5f28dc7285710$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $75f5f28dc7285710$var$propertyRemove : typeof value === "function" ? $75f5f28dc7285710$var$propertyFunction : $75f5f28dc7285710$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("kQxsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d29f7fce70ee8a$export$2e2bcd8739ae039);
function $f2d29f7fce70ee8a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $f2d29f7fce70ee8a$var$classList(node) {
    return node.classList || new $f2d29f7fce70ee8a$var$ClassList(node);
}
function $f2d29f7fce70ee8a$var$ClassList(node) {
    this._node = node;
    this._names = $f2d29f7fce70ee8a$var$classArray(node.getAttribute("class") || "");
}
$f2d29f7fce70ee8a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $f2d29f7fce70ee8a$var$classedAdd(node, names) {
    var list = $f2d29f7fce70ee8a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $f2d29f7fce70ee8a$var$classedRemove(node, names) {
    var list = $f2d29f7fce70ee8a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $f2d29f7fce70ee8a$var$classedTrue(names) {
    return function() {
        $f2d29f7fce70ee8a$var$classedAdd(this, names);
    };
}
function $f2d29f7fce70ee8a$var$classedFalse(names) {
    return function() {
        $f2d29f7fce70ee8a$var$classedRemove(this, names);
    };
}
function $f2d29f7fce70ee8a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $f2d29f7fce70ee8a$var$classedAdd : $f2d29f7fce70ee8a$var$classedRemove)(this, names);
    };
}
function $f2d29f7fce70ee8a$export$2e2bcd8739ae039(name, value) {
    var names = $f2d29f7fce70ee8a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $f2d29f7fce70ee8a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $f2d29f7fce70ee8a$var$classedFunction : value ? $f2d29f7fce70ee8a$var$classedTrue : $f2d29f7fce70ee8a$var$classedFalse)(names, value));
}

});

parcelRegister("1zr5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $124e12be4e036f2d$export$2e2bcd8739ae039);
function $124e12be4e036f2d$var$textRemove() {
    this.textContent = "";
}
function $124e12be4e036f2d$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $124e12be4e036f2d$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $124e12be4e036f2d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $124e12be4e036f2d$var$textRemove : (typeof value === "function" ? $124e12be4e036f2d$var$textFunction : $124e12be4e036f2d$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("75k6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $528897a0215e3bc7$export$2e2bcd8739ae039);
function $528897a0215e3bc7$var$htmlRemove() {
    this.innerHTML = "";
}
function $528897a0215e3bc7$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $528897a0215e3bc7$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $528897a0215e3bc7$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $528897a0215e3bc7$var$htmlRemove : (typeof value === "function" ? $528897a0215e3bc7$var$htmlFunction : $528897a0215e3bc7$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("kWe6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e42992a2a034a4$export$2e2bcd8739ae039);
function $f3e42992a2a034a4$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $f3e42992a2a034a4$export$2e2bcd8739ae039() {
    return this.each($f3e42992a2a034a4$var$raise);
}

});

parcelRegister("51HoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8eb643c39635f8$export$2e2bcd8739ae039);
function $3a8eb643c39635f8$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $3a8eb643c39635f8$export$2e2bcd8739ae039() {
    return this.each($3a8eb643c39635f8$var$lower);
}

});

parcelRegister("aftTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $77627e894347281e$export$2e2bcd8739ae039);

var $4y1qm = parcelRequire("4y1qm");
function $77627e894347281e$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $4y1qm.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("4y1qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fb713b367a11f3$export$2e2bcd8739ae039);

var $vb4DM = parcelRequire("vb4DM");

var $81LHV = parcelRequire("81LHV");
function $34fb713b367a11f3$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $81LHV.xhtml) && document.documentElement.namespaceURI === (0, $81LHV.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $34fb713b367a11f3$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $34fb713b367a11f3$export$2e2bcd8739ae039(name) {
    var fullname = (0, $vb4DM.default)(name);
    return (fullname.local ? $34fb713b367a11f3$var$creatorFixed : $34fb713b367a11f3$var$creatorInherit)(fullname);
}

});


parcelRegister("dGQOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f782bbe06836b26$export$2e2bcd8739ae039);

var $4y1qm = parcelRequire("4y1qm");

var $2Dn0x = parcelRequire("2Dn0x");
function $9f782bbe06836b26$var$constantNull() {
    return null;
}
function $9f782bbe06836b26$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $4y1qm.default)(name), select = before == null ? $9f782bbe06836b26$var$constantNull : typeof before === "function" ? before : (0, $2Dn0x.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("ed7Jb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5884629119a54d6$export$2e2bcd8739ae039);
function $a5884629119a54d6$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $a5884629119a54d6$export$2e2bcd8739ae039() {
    return this.each($a5884629119a54d6$var$remove);
}

});

parcelRegister("2rsO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7472d506ae9d40$export$2e2bcd8739ae039);
function $1c7472d506ae9d40$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $1c7472d506ae9d40$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $1c7472d506ae9d40$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $1c7472d506ae9d40$var$selection_cloneDeep : $1c7472d506ae9d40$var$selection_cloneShallow);
}

});

parcelRegister("aH0eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c8e1a318d26686d$export$2e2bcd8739ae039);
function $7c8e1a318d26686d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("5fER9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d2e0bafdbc91f83$export$2e2bcd8739ae039);
function $3d2e0bafdbc91f83$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $3d2e0bafdbc91f83$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $3d2e0bafdbc91f83$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $3d2e0bafdbc91f83$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $3d2e0bafdbc91f83$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $3d2e0bafdbc91f83$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $3d2e0bafdbc91f83$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $3d2e0bafdbc91f83$var$onAdd : $3d2e0bafdbc91f83$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("47Cow", function(module, exports) {

$parcel$export(module.exports, "default", () => $3005993bf96415b3$export$2e2bcd8739ae039);

var $6Qhlj = parcelRequire("6Qhlj");
function $3005993bf96415b3$var$dispatchEvent(node, type, params) {
    var window = (0, $6Qhlj.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3005993bf96415b3$var$dispatchConstant(type, params) {
    return function() {
        return $3005993bf96415b3$var$dispatchEvent(this, type, params);
    };
}
function $3005993bf96415b3$var$dispatchFunction(type, params) {
    return function() {
        return $3005993bf96415b3$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3005993bf96415b3$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3005993bf96415b3$var$dispatchFunction : $3005993bf96415b3$var$dispatchConstant)(type, params));
}

});

parcelRegister("iRYG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbcc3e94759a2b80$export$2e2bcd8739ae039);
function* $dbcc3e94759a2b80$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("8Xieg", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $6851f954aa290e90$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $6851f954aa290e90$export$2e2bcd8739ae039);
function $6851f954aa290e90$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $6851f954aa290e90$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("4PXvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $385a14c856d32e86$export$2e2bcd8739ae039);

var $bxlao = parcelRequire("bxlao");

var $5AM6O = parcelRequire("5AM6O");

var $8aASV = parcelRequire("8aASV");

var $3kqxa = parcelRequire("3kqxa");

var $ggpD5 = parcelRequire("ggpD5");

var $dZipD = parcelRequire("dZipD");

var $hHjDE = parcelRequire("hHjDE");

var $9NSCf = parcelRequire("9NSCf");

var $3co7c = parcelRequire("3co7c");
function $385a14c856d32e86$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $9NSCf.default)(b) : (t === "number" ? (0, $ggpD5.default) : t === "string" ? (c = (0, $bxlao.default)(b)) ? (b = c, $5AM6O.default) : (0, $hHjDE.default) : b instanceof (0, $bxlao.default) ? (0, $5AM6O.default) : b instanceof Date ? (0, $3kqxa.default) : (0, $3co7c.isNumberArray)(b) ? (0, $3co7c.default) : Array.isArray(b) ? (0, $8aASV.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $dZipD.default) : (0, $ggpD5.default))(a, b);
}

});
parcelRegister("bxlao", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $81PUJ = parcelRequire("81PUJ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $81PUJ.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $81PUJ.default)(Rgb, rgb, (0, $81PUJ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $81PUJ.default)(Hsl, hsl, (0, $81PUJ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("81PUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d86afbecc899f0f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $5d86afbecc899f0f$export$8b58be045bf06082);
function $5d86afbecc899f0f$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $5d86afbecc899f0f$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("5AM6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $4125a1f7550a0949$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rgbBasis", () => $4125a1f7550a0949$export$2c0e28f2e2852d3f);
$parcel$export(module.exports, "rgbBasisClosed", () => $4125a1f7550a0949$export$53d5214f625ccd4c);

var $bxlao = parcelRequire("bxlao");

var $pN4j7 = parcelRequire("pN4j7");

var $8d03e = parcelRequire("8d03e");

var $adQ5o = parcelRequire("adQ5o");
var $4125a1f7550a0949$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $adQ5o.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bxlao.rgb)(start)).r, (end = (0, $bxlao.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $adQ5o.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $4125a1f7550a0949$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bxlao.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $4125a1f7550a0949$export$2c0e28f2e2852d3f = $4125a1f7550a0949$var$rgbSpline((0, $pN4j7.default));
var $4125a1f7550a0949$export$53d5214f625ccd4c = $4125a1f7550a0949$var$rgbSpline((0, $8d03e.default));

});
parcelRegister("pN4j7", function(module, exports) {

$parcel$export(module.exports, "basis", () => $04d865e42d90ee8a$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $04d865e42d90ee8a$export$2e2bcd8739ae039);
function $04d865e42d90ee8a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $04d865e42d90ee8a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $04d865e42d90ee8a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8d03e", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9f93c773f83a3b$export$2e2bcd8739ae039);

var $pN4j7 = parcelRequire("pN4j7");
function $5f9f93c773f83a3b$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $pN4j7.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("adQ5o", function(module, exports) {

$parcel$export(module.exports, "hue", () => $77138572fdc11224$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $77138572fdc11224$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $77138572fdc11224$export$2e2bcd8739ae039);

var $9NSCf = parcelRequire("9NSCf");
function $77138572fdc11224$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $77138572fdc11224$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $77138572fdc11224$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $77138572fdc11224$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $9NSCf.default)(isNaN(a) ? b : a);
}
function $77138572fdc11224$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $77138572fdc11224$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $77138572fdc11224$var$exponential(a, b, y) : (0, $9NSCf.default)(isNaN(a) ? b : a);
    };
}
function $77138572fdc11224$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $77138572fdc11224$var$linear(a, d) : (0, $9NSCf.default)(isNaN(a) ? b : a);
}

});
parcelRegister("9NSCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $72330e37709385c9$export$2e2bcd8739ae039);
var $72330e37709385c9$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("8aASV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2bde7a416918d7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "genericArray", () => $5f2bde7a416918d7$export$15d09067c6a5ee49);

var $4PXvd = parcelRequire("4PXvd");

var $3co7c = parcelRequire("3co7c");
function $5f2bde7a416918d7$export$2e2bcd8739ae039(a, b) {
    return ((0, $3co7c.isNumberArray)(b) ? (0, $3co7c.default) : $5f2bde7a416918d7$export$15d09067c6a5ee49)(a, b);
}
function $5f2bde7a416918d7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $4PXvd.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("3co7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $254532d7e68385b0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $254532d7e68385b0$export$5cd576d1827d40c8);
function $254532d7e68385b0$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $254532d7e68385b0$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("3kqxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c7d274b1004e2c$export$2e2bcd8739ae039);
function $26c7d274b1004e2c$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("ggpD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7205726919eb40$export$2e2bcd8739ae039);
function $bd7205726919eb40$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("dZipD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ef4130a24d9f4b$export$2e2bcd8739ae039);

var $4PXvd = parcelRequire("4PXvd");
function $a2ef4130a24d9f4b$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $4PXvd.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("hHjDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce25afa52e53938c$export$2e2bcd8739ae039);

var $ggpD5 = parcelRequire("ggpD5");
var $ce25afa52e53938c$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ce25afa52e53938c$var$reB = new RegExp($ce25afa52e53938c$var$reA.source, "g");
function $ce25afa52e53938c$var$zero(b) {
    return function() {
        return b;
    };
}
function $ce25afa52e53938c$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ce25afa52e53938c$export$2e2bcd8739ae039(a, b) {
    var bi = $ce25afa52e53938c$var$reA.lastIndex = $ce25afa52e53938c$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $ce25afa52e53938c$var$reA.exec(a)) && (bm = $ce25afa52e53938c$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ggpD5.default)(am, bm)
            });
        }
        bi = $ce25afa52e53938c$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ce25afa52e53938c$var$one(q[0].x) : $ce25afa52e53938c$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("2GQnz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5822687e66fdad$export$2e2bcd8739ae039);

var $hVmiL = parcelRequire("hVmiL");
function $1f5822687e66fdad$export$2e2bcd8739ae039(event, node) {
    event = (0, $hVmiL.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("hVmiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c90f2f1cfd0eb2$export$2e2bcd8739ae039);
function $d0c90f2f1cfd0eb2$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("d0ohb", function(module, exports) {

$parcel$export(module.exports, "transition", () => (parcelRequire("11MXt")).default);
$parcel$export(module.exports, "active", () => (parcelRequire("2lKbE")).default);
$parcel$export(module.exports, "interrupt", () => (parcelRequire("cY1kc")).default);
parcelRequire("9KOAj");

var $11MXt = parcelRequire("11MXt");

var $2lKbE = parcelRequire("2lKbE");

var $cY1kc = parcelRequire("cY1kc");

});
parcelRegister("9KOAj", function(module, exports) {

var $4MWrt = parcelRequire("4MWrt");

var $V2Ak7 = parcelRequire("V2Ak7");

var $hya2q = parcelRequire("hya2q");
(0, $4MWrt.default).prototype.interrupt = (0, $V2Ak7.default);
(0, $4MWrt.default).prototype.transition = (0, $hya2q.default);

});
parcelRegister("V2Ak7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab754491a6057f1$export$2e2bcd8739ae039);

var $cY1kc = parcelRequire("cY1kc");
function $0ab754491a6057f1$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $cY1kc.default)(this, name);
    });
}

});
parcelRegister("cY1kc", function(module, exports) {

$parcel$export(module.exports, "default", () => $970c1db1cc92ab03$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $970c1db1cc92ab03$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $khvw0.STARTING) && schedule.state < (0, $khvw0.ENDING);
        schedule.state = (0, $khvw0.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("khvw0", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $ec3dd76e362215c0$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $ec3dd76e362215c0$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $ec3dd76e362215c0$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $ec3dd76e362215c0$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $ec3dd76e362215c0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $ec3dd76e362215c0$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $ec3dd76e362215c0$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $ec3dd76e362215c0$export$adaa4cf7ef1b65be);

var $2LbPR = parcelRequire("2LbPR");

var $1bY0C = parcelRequire("1bY0C");
var $knAOt = parcelRequire("knAOt");
var $ec3dd76e362215c0$var$emptyOn = (0, $2LbPR.default)("start", "end", "cancel", "interrupt");
var $ec3dd76e362215c0$var$emptyTween = [];
var $ec3dd76e362215c0$export$ff39ebd4bb12b718 = 0;
var $ec3dd76e362215c0$export$584530fe98d14a84 = 1;
var $ec3dd76e362215c0$export$a5d151aee16efd42 = 2;
var $ec3dd76e362215c0$export$fb935ab5849a0db9 = 3;
var $ec3dd76e362215c0$export$1573e22b087389af = 4;
var $ec3dd76e362215c0$export$a2e792214ded83b2 = 5;
var $ec3dd76e362215c0$export$9d38167254403955 = 6;
function $ec3dd76e362215c0$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $ec3dd76e362215c0$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $ec3dd76e362215c0$var$emptyOn,
        tween: $ec3dd76e362215c0$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $ec3dd76e362215c0$export$ff39ebd4bb12b718
    });
}
function $ec3dd76e362215c0$export$2cd8252107eb640b(node, id) {
    var schedule = $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $ec3dd76e362215c0$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $ec3dd76e362215c0$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $ec3dd76e362215c0$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $ec3dd76e362215c0$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $knAOt.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $ec3dd76e362215c0$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $ec3dd76e362215c0$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $ec3dd76e362215c0$export$fb935ab5849a0db9) return (0, $1bY0C.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $ec3dd76e362215c0$export$1573e22b087389af) {
                o.state = $ec3dd76e362215c0$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $ec3dd76e362215c0$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $1bY0C.default)(function() {
            if (self.state === $ec3dd76e362215c0$export$fb935ab5849a0db9) {
                self.state = $ec3dd76e362215c0$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $ec3dd76e362215c0$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $ec3dd76e362215c0$export$a5d151aee16efd42) return; // interrupted
        self.state = $ec3dd76e362215c0$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $ec3dd76e362215c0$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $ec3dd76e362215c0$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $ec3dd76e362215c0$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("1bY0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de55e089ddef178$export$2e2bcd8739ae039);

var $knAOt = parcelRequire("knAOt");
function $0de55e089ddef178$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $knAOt.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("knAOt", function(module, exports) {

$parcel$export(module.exports, "now", () => $ed6282f03875f8f7$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $ed6282f03875f8f7$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $ed6282f03875f8f7$export$9dc4ecf953986f04);
$parcel$export(module.exports, "timerFlush", () => $ed6282f03875f8f7$export$d60154c1d7f3990e);
var $ed6282f03875f8f7$var$frame = 0, $ed6282f03875f8f7$var$timeout = 0, $ed6282f03875f8f7$var$interval = 0, $ed6282f03875f8f7$var$pokeDelay = 1000, $ed6282f03875f8f7$var$taskHead, $ed6282f03875f8f7$var$taskTail, $ed6282f03875f8f7$var$clockLast = 0, $ed6282f03875f8f7$var$clockNow = 0, $ed6282f03875f8f7$var$clockSkew = 0, $ed6282f03875f8f7$var$clock = typeof performance === "object" && performance.now ? performance : Date, $ed6282f03875f8f7$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $ed6282f03875f8f7$export$461939dd4422153() {
    return $ed6282f03875f8f7$var$clockNow || ($ed6282f03875f8f7$var$setFrame($ed6282f03875f8f7$var$clearNow), $ed6282f03875f8f7$var$clockNow = $ed6282f03875f8f7$var$clock.now() + $ed6282f03875f8f7$var$clockSkew);
}
function $ed6282f03875f8f7$var$clearNow() {
    $ed6282f03875f8f7$var$clockNow = 0;
}
function $ed6282f03875f8f7$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$ed6282f03875f8f7$export$c57e9b2d8b9e4de.prototype = $ed6282f03875f8f7$export$9dc4ecf953986f04.prototype = {
    constructor: $ed6282f03875f8f7$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $ed6282f03875f8f7$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $ed6282f03875f8f7$var$taskTail !== this) {
            if ($ed6282f03875f8f7$var$taskTail) $ed6282f03875f8f7$var$taskTail._next = this;
            else $ed6282f03875f8f7$var$taskHead = this;
            $ed6282f03875f8f7$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $ed6282f03875f8f7$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $ed6282f03875f8f7$var$sleep();
        }
    }
};
function $ed6282f03875f8f7$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $ed6282f03875f8f7$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $ed6282f03875f8f7$export$d60154c1d7f3990e() {
    $ed6282f03875f8f7$export$461939dd4422153(); // Get the current time, if not already set.
    ++$ed6282f03875f8f7$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $ed6282f03875f8f7$var$taskHead, e;
    while(t){
        if ((e = $ed6282f03875f8f7$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$ed6282f03875f8f7$var$frame;
}
function $ed6282f03875f8f7$var$wake() {
    $ed6282f03875f8f7$var$clockNow = ($ed6282f03875f8f7$var$clockLast = $ed6282f03875f8f7$var$clock.now()) + $ed6282f03875f8f7$var$clockSkew;
    $ed6282f03875f8f7$var$frame = $ed6282f03875f8f7$var$timeout = 0;
    try {
        $ed6282f03875f8f7$export$d60154c1d7f3990e();
    } finally{
        $ed6282f03875f8f7$var$frame = 0;
        $ed6282f03875f8f7$var$nap();
        $ed6282f03875f8f7$var$clockNow = 0;
    }
}
function $ed6282f03875f8f7$var$poke() {
    var now = $ed6282f03875f8f7$var$clock.now(), delay = now - $ed6282f03875f8f7$var$clockLast;
    if (delay > $ed6282f03875f8f7$var$pokeDelay) $ed6282f03875f8f7$var$clockSkew -= delay, $ed6282f03875f8f7$var$clockLast = now;
}
function $ed6282f03875f8f7$var$nap() {
    var t0, t1 = $ed6282f03875f8f7$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $ed6282f03875f8f7$var$taskHead = t2;
    }
    $ed6282f03875f8f7$var$taskTail = t0;
    $ed6282f03875f8f7$var$sleep(time);
}
function $ed6282f03875f8f7$var$sleep(time) {
    if ($ed6282f03875f8f7$var$frame) return; // Soonest alarm already set, or will be.
    if ($ed6282f03875f8f7$var$timeout) $ed6282f03875f8f7$var$timeout = clearTimeout($ed6282f03875f8f7$var$timeout);
    var delay = time - $ed6282f03875f8f7$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $ed6282f03875f8f7$var$timeout = setTimeout($ed6282f03875f8f7$var$wake, time - $ed6282f03875f8f7$var$clock.now() - $ed6282f03875f8f7$var$clockSkew);
        if ($ed6282f03875f8f7$var$interval) $ed6282f03875f8f7$var$interval = clearInterval($ed6282f03875f8f7$var$interval);
    } else {
        if (!$ed6282f03875f8f7$var$interval) $ed6282f03875f8f7$var$clockLast = $ed6282f03875f8f7$var$clock.now(), $ed6282f03875f8f7$var$interval = setInterval($ed6282f03875f8f7$var$poke, $ed6282f03875f8f7$var$pokeDelay);
        $ed6282f03875f8f7$var$frame = 1, $ed6282f03875f8f7$var$setFrame($ed6282f03875f8f7$var$wake);
    }
}

});





parcelRegister("hya2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc6d65fe96485f27$export$2e2bcd8739ae039);

var $11MXt = parcelRequire("11MXt");

var $khvw0 = parcelRequire("khvw0");

var $bQGHq = parcelRequire("bQGHq");

var $knAOt = parcelRequire("knAOt");
var $cc6d65fe96485f27$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $bQGHq.cubicInOut)
};
function $cc6d65fe96485f27$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $cc6d65fe96485f27$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $11MXt.Transition)) id = name._id, name = name._name;
    else id = (0, $11MXt.newId)(), (timing = $cc6d65fe96485f27$var$defaultTiming).time = (0, $knAOt.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $khvw0.default)(node, name, id, i, group, timing || $cc6d65fe96485f27$var$inherit(node, id));
    }
    return new (0, $11MXt.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("11MXt", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $0bfbdc865a41e63d$export$be58926105124dd4);
$parcel$export(module.exports, "default", () => $0bfbdc865a41e63d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "newId", () => $0bfbdc865a41e63d$export$9ffd10a3fbdc175b);

var $4MWrt = parcelRequire("4MWrt");

var $fNNsq = parcelRequire("fNNsq");

var $2mmSi = parcelRequire("2mmSi");

var $4aB3f = parcelRequire("4aB3f");

var $lSlGO = parcelRequire("lSlGO");

var $21OtE = parcelRequire("21OtE");

var $i67bL = parcelRequire("i67bL");

var $diCW0 = parcelRequire("diCW0");

var $4qjDs = parcelRequire("4qjDs");

var $hII2E = parcelRequire("hII2E");

var $eW9rL = parcelRequire("eW9rL");

var $6Thjg = parcelRequire("6Thjg");

var $gTzqy = parcelRequire("gTzqy");

var $16Dx8 = parcelRequire("16Dx8");

var $jgLcJ = parcelRequire("jgLcJ");

var $eSKi8 = parcelRequire("eSKi8");

var $azVec = parcelRequire("azVec");

var $bt3mH = parcelRequire("bt3mH");

var $ep6gd = parcelRequire("ep6gd");

var $2N5KL = parcelRequire("2N5KL");

var $kLUfm = parcelRequire("kLUfm");
var $0bfbdc865a41e63d$var$id = 0;
function $0bfbdc865a41e63d$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $0bfbdc865a41e63d$export$2e2bcd8739ae039(name) {
    return (0, $4MWrt.default)().transition(name);
}
function $0bfbdc865a41e63d$export$9ffd10a3fbdc175b() {
    return ++$0bfbdc865a41e63d$var$id;
}
var $0bfbdc865a41e63d$var$selection_prototype = (0, $4MWrt.default).prototype;
$0bfbdc865a41e63d$export$be58926105124dd4.prototype = $0bfbdc865a41e63d$export$2e2bcd8739ae039.prototype = {
    constructor: $0bfbdc865a41e63d$export$be58926105124dd4,
    select: (0, $6Thjg.default),
    selectAll: (0, $gTzqy.default),
    filter: (0, $diCW0.default),
    merge: (0, $4qjDs.default),
    selection: (0, $16Dx8.default),
    transition: (0, $ep6gd.default),
    call: $0bfbdc865a41e63d$var$selection_prototype.call,
    nodes: $0bfbdc865a41e63d$var$selection_prototype.nodes,
    node: $0bfbdc865a41e63d$var$selection_prototype.node,
    size: $0bfbdc865a41e63d$var$selection_prototype.size,
    empty: $0bfbdc865a41e63d$var$selection_prototype.empty,
    each: $0bfbdc865a41e63d$var$selection_prototype.each,
    on: (0, $hII2E.default),
    attr: (0, $fNNsq.default),
    attrTween: (0, $2mmSi.default),
    style: (0, $jgLcJ.default),
    styleTween: (0, $eSKi8.default),
    text: (0, $azVec.default),
    textTween: (0, $bt3mH.default),
    remove: (0, $eW9rL.default),
    tween: (0, $2N5KL.default),
    delay: (0, $4aB3f.default),
    duration: (0, $lSlGO.default),
    ease: (0, $21OtE.default),
    easeVarying: (0, $i67bL.default),
    end: (0, $kLUfm.default),
    [Symbol.iterator]: $0bfbdc865a41e63d$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("fNNsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b811cbd300b30749$export$2e2bcd8739ae039);

var $8XBh2 = parcelRequire("8XBh2");

var $vb4DM = parcelRequire("vb4DM");

var $2N5KL = parcelRequire("2N5KL");

var $fSVNJ = parcelRequire("fSVNJ");
function $b811cbd300b30749$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $b811cbd300b30749$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $b811cbd300b30749$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $b811cbd300b30749$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $b811cbd300b30749$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $b811cbd300b30749$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $b811cbd300b30749$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $vb4DM.default)(name), i = fullname === "transform" ? (0, $8XBh2.interpolateTransformSvg) : (0, $fSVNJ.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $b811cbd300b30749$var$attrFunctionNS : $b811cbd300b30749$var$attrFunction)(fullname, i, (0, $2N5KL.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $b811cbd300b30749$var$attrRemoveNS : $b811cbd300b30749$var$attrRemove)(fullname) : (fullname.local ? $b811cbd300b30749$var$attrConstantNS : $b811cbd300b30749$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("8XBh2", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $6860bf3d8f30166d$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $6860bf3d8f30166d$export$da8cba906d64c082);

var $ggpD5 = parcelRequire("ggpD5");

var $1TkTS = parcelRequire("1TkTS");
function $6860bf3d8f30166d$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $ggpD5.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ggpD5.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $ggpD5.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $ggpD5.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $ggpD5.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ggpD5.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $6860bf3d8f30166d$export$56bec7123bb3589a = $6860bf3d8f30166d$var$interpolateTransform((0, $1TkTS.parseCss), "px, ", "px)", "deg)");
var $6860bf3d8f30166d$export$da8cba906d64c082 = $6860bf3d8f30166d$var$interpolateTransform((0, $1TkTS.parseSvg), ", ", ")", ")");

});
parcelRegister("1TkTS", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $160b23dc7ba1d4f8$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $160b23dc7ba1d4f8$export$f9ef43f9a1d89a18);

var $9hEgi = parcelRequire("9hEgi");
var $160b23dc7ba1d4f8$var$svgNode;
function $160b23dc7ba1d4f8$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $9hEgi.identity) : (0, $9hEgi.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $160b23dc7ba1d4f8$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $9hEgi.identity;
    if (!$160b23dc7ba1d4f8$var$svgNode) $160b23dc7ba1d4f8$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $160b23dc7ba1d4f8$var$svgNode.setAttribute("transform", value);
    if (!(value = $160b23dc7ba1d4f8$var$svgNode.transform.baseVal.consolidate())) return 0, $9hEgi.identity;
    value = value.matrix;
    return (0, $9hEgi.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("9hEgi", function(module, exports) {

$parcel$export(module.exports, "identity", () => $6c24eebe0efa54be$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $6c24eebe0efa54be$export$2e2bcd8739ae039);
var $6c24eebe0efa54be$var$degrees = 180 / Math.PI;
var $6c24eebe0efa54be$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $6c24eebe0efa54be$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $6c24eebe0efa54be$var$degrees,
        skewX: Math.atan(skewX) * $6c24eebe0efa54be$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("2N5KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $20849ede6b5aef58$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $20849ede6b5aef58$export$f78ce6ab10405d82);

var $khvw0 = parcelRequire("khvw0");
function $20849ede6b5aef58$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $khvw0.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $20849ede6b5aef58$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $khvw0.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $20849ede6b5aef58$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $khvw0.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $20849ede6b5aef58$var$tweenRemove : $20849ede6b5aef58$var$tweenFunction)(id, name, value));
}
function $20849ede6b5aef58$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $khvw0.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $khvw0.get)(node, id).value[name];
    };
}

});

parcelRegister("fSVNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b908bc440aa7da76$export$2e2bcd8739ae039);

var $bxlao = parcelRequire("bxlao");

var $ggpD5 = parcelRequire("ggpD5");
var $5AM6O = parcelRequire("5AM6O");
var $hHjDE = parcelRequire("hHjDE");
function $b908bc440aa7da76$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $ggpD5.default) : b instanceof (0, $bxlao.default) ? (0, $5AM6O.default) : (c = (0, $bxlao.default)(b)) ? (b = c, $5AM6O.default) : (0, $hHjDE.default))(a, b);
}

});


parcelRegister("2mmSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7f614745d671e8$export$2e2bcd8739ae039);

var $vb4DM = parcelRequire("vb4DM");
function $1b7f614745d671e8$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $1b7f614745d671e8$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $1b7f614745d671e8$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1b7f614745d671e8$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1b7f614745d671e8$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1b7f614745d671e8$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1b7f614745d671e8$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $vb4DM.default)(name);
    return this.tween(key, (fullname.local ? $1b7f614745d671e8$var$attrTweenNS : $1b7f614745d671e8$var$attrTween)(fullname, value));
}

});

parcelRegister("4aB3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3094d63d1610a34e$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $3094d63d1610a34e$var$delayFunction(id, value) {
    return function() {
        (0, $khvw0.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $3094d63d1610a34e$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $khvw0.init)(this, id).delay = value;
    };
}
function $3094d63d1610a34e$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3094d63d1610a34e$var$delayFunction : $3094d63d1610a34e$var$delayConstant)(id, value)) : (0, $khvw0.get)(this.node(), id).delay;
}

});

parcelRegister("lSlGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecf773811012fc0$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $fecf773811012fc0$var$durationFunction(id, value) {
    return function() {
        (0, $khvw0.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fecf773811012fc0$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $khvw0.set)(this, id).duration = value;
    };
}
function $fecf773811012fc0$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fecf773811012fc0$var$durationFunction : $fecf773811012fc0$var$durationConstant)(id, value)) : (0, $khvw0.get)(this.node(), id).duration;
}

});

parcelRegister("21OtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a2d48292061c51$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $17a2d48292061c51$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $khvw0.set)(this, id).ease = value;
    };
}
function $17a2d48292061c51$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($17a2d48292061c51$var$easeConstant(id, value)) : (0, $khvw0.get)(this.node(), id).ease;
}

});

parcelRegister("i67bL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ce5d15218789a1$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $d2ce5d15218789a1$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $khvw0.set)(this, id).ease = v;
    };
}
function $d2ce5d15218789a1$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($d2ce5d15218789a1$var$easeVarying(this._id, value));
}

});

parcelRegister("diCW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aeb2865eedd2e89$export$2e2bcd8739ae039);

var $3Pm5Z = parcelRequire("3Pm5Z");

var $11MXt = parcelRequire("11MXt");
function $9aeb2865eedd2e89$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $3Pm5Z.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $11MXt.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("4qjDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3388d24e4977753f$export$2e2bcd8739ae039);

var $11MXt = parcelRequire("11MXt");
function $3388d24e4977753f$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $11MXt.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("hII2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce68b585666bb98e$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $ce68b585666bb98e$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $ce68b585666bb98e$var$onFunction(id, name, listener) {
    var on0, on1, sit = $ce68b585666bb98e$var$start(name) ? (0, $khvw0.init) : (0, $khvw0.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $ce68b585666bb98e$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $khvw0.get)(this.node(), id).on.on(name) : this.each($ce68b585666bb98e$var$onFunction(id, name, listener));
}

});

parcelRegister("eW9rL", function(module, exports) {

$parcel$export(module.exports, "default", () => $adfdcf6692d21379$export$2e2bcd8739ae039);
function $adfdcf6692d21379$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $adfdcf6692d21379$export$2e2bcd8739ae039() {
    return this.on("end.remove", $adfdcf6692d21379$var$removeFunction(this._id));
}

});

parcelRegister("6Thjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $50454e8103d76419$export$2e2bcd8739ae039);

var $2Dn0x = parcelRequire("2Dn0x");

var $11MXt = parcelRequire("11MXt");

var $khvw0 = parcelRequire("khvw0");
function $50454e8103d76419$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $2Dn0x.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $khvw0.default)(subgroup[i], name, id, i, subgroup, (0, $khvw0.get)(node, id));
        }
    }
    return new (0, $11MXt.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("gTzqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4cd43840974036c$export$2e2bcd8739ae039);

var $4yYEN = parcelRequire("4yYEN");

var $11MXt = parcelRequire("11MXt");

var $khvw0 = parcelRequire("khvw0");
function $c4cd43840974036c$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $4yYEN.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $khvw0.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $khvw0.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $11MXt.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("16Dx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ce5047e8669f4d4$export$2e2bcd8739ae039);

var $4MWrt = parcelRequire("4MWrt");
var $0ce5047e8669f4d4$var$Selection = (0, $4MWrt.default).prototype.constructor;
function $0ce5047e8669f4d4$export$2e2bcd8739ae039() {
    return new $0ce5047e8669f4d4$var$Selection(this._groups, this._parents);
}

});

parcelRegister("jgLcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07420bb4c337cc2$export$2e2bcd8739ae039);

var $8XBh2 = parcelRequire("8XBh2");

var $fWzBb = parcelRequire("fWzBb");

var $khvw0 = parcelRequire("khvw0");

var $2N5KL = parcelRequire("2N5KL");

var $fSVNJ = parcelRequire("fSVNJ");
function $e07420bb4c337cc2$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $fWzBb.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $fWzBb.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $e07420bb4c337cc2$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e07420bb4c337cc2$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $fWzBb.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $e07420bb4c337cc2$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $fWzBb.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $fWzBb.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $e07420bb4c337cc2$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $khvw0.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $e07420bb4c337cc2$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $e07420bb4c337cc2$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $8XBh2.interpolateTransformCss) : (0, $fSVNJ.default);
    return value == null ? this.styleTween(name, $e07420bb4c337cc2$var$styleNull(name, i)).on("end.style." + name, $e07420bb4c337cc2$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $e07420bb4c337cc2$var$styleFunction(name, i, (0, $2N5KL.tweenValue)(this, "style." + name, value))).each($e07420bb4c337cc2$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $e07420bb4c337cc2$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("eSKi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5a045fba1137e4$export$2e2bcd8739ae039);
function $ad5a045fba1137e4$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $ad5a045fba1137e4$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $ad5a045fba1137e4$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $ad5a045fba1137e4$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $ad5a045fba1137e4$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("azVec", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b39908a348d0cbb$export$2e2bcd8739ae039);

var $2N5KL = parcelRequire("2N5KL");
function $7b39908a348d0cbb$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $7b39908a348d0cbb$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $7b39908a348d0cbb$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $7b39908a348d0cbb$var$textFunction((0, $2N5KL.tweenValue)(this, "text", value)) : $7b39908a348d0cbb$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("bt3mH", function(module, exports) {

$parcel$export(module.exports, "default", () => $85950362d0b400c3$export$2e2bcd8739ae039);
function $85950362d0b400c3$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $85950362d0b400c3$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $85950362d0b400c3$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $85950362d0b400c3$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $85950362d0b400c3$var$textTween(value));
}

});

parcelRegister("ep6gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c841b4114413dc$export$2e2bcd8739ae039);

var $11MXt = parcelRequire("11MXt");

var $khvw0 = parcelRequire("khvw0");
function $a7c841b4114413dc$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $11MXt.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $khvw0.get)(node, id0);
            (0, $khvw0.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $11MXt.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("kLUfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f3d3dd75a82e46$export$2e2bcd8739ae039);

var $khvw0 = parcelRequire("khvw0");
function $f1f3d3dd75a82e46$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $khvw0.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("bQGHq", function(module, exports) {

$parcel$export(module.exports, "cubicIn", () => $8a05ac3b967f900c$export$b1a09cb1b71f86aa);
$parcel$export(module.exports, "cubicOut", () => $8a05ac3b967f900c$export$68d528839c701b6);
$parcel$export(module.exports, "cubicInOut", () => $8a05ac3b967f900c$export$89238d3bc79d3ada);
function $8a05ac3b967f900c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $8a05ac3b967f900c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $8a05ac3b967f900c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("2lKbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b615eabfb312a22$export$2e2bcd8739ae039);

var $11MXt = parcelRequire("11MXt");

var $khvw0 = parcelRequire("khvw0");
var $1b615eabfb312a22$var$root = [
    null
];
function $1b615eabfb312a22$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $khvw0.SCHEDULED) && schedule.name === name) return new (0, $11MXt.Transition)([
                [
                    node
                ]
            ], $1b615eabfb312a22$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("eaHrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a513b3fc7344dc0b$export$2e2bcd8739ae039);
var $a513b3fc7344dc0b$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("bNHS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $89764d737e0f558c$export$2e2bcd8739ae039);
function $89764d737e0f558c$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("eRpSf", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $ad1a15f3efa60bb1$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $ad1a15f3efa60bb1$export$2e2bcd8739ae039);
function $ad1a15f3efa60bb1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $ad1a15f3efa60bb1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("5pHLB", function(module, exports) {

$parcel$export(module.exports, "chord", () => (parcelRequire("hE0Tn")).default);
$parcel$export(module.exports, "chordTranspose", () => (parcelRequire("hE0Tn")).chordTranspose);
$parcel$export(module.exports, "chordDirected", () => (parcelRequire("hE0Tn")).chordDirected);
$parcel$export(module.exports, "ribbon", () => (parcelRequire("5kPVg")).default);
$parcel$export(module.exports, "ribbonArrow", () => (parcelRequire("5kPVg")).ribbonArrow);

var $hE0Tn = parcelRequire("hE0Tn");

var $5kPVg = parcelRequire("5kPVg");

});
parcelRegister("hE0Tn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd86dd3fbe394b2b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "chordTranspose", () => $cd86dd3fbe394b2b$export$ccf0fb804feeadb0);
$parcel$export(module.exports, "chordDirected", () => $cd86dd3fbe394b2b$export$66e653ba9a7a4d8c);

var $2ZBRZ = parcelRequire("2ZBRZ");
function $cd86dd3fbe394b2b$var$range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function $cd86dd3fbe394b2b$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $cd86dd3fbe394b2b$export$2e2bcd8739ae039() {
    return $cd86dd3fbe394b2b$var$chord(false, false);
}
function $cd86dd3fbe394b2b$export$ccf0fb804feeadb0() {
    return $cd86dd3fbe394b2b$var$chord(false, true);
}
function $cd86dd3fbe394b2b$export$66e653ba9a7a4d8c() {
    return $cd86dd3fbe394b2b$var$chord(true, false);
}
function $cd86dd3fbe394b2b$var$chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = $cd86dd3fbe394b2b$var$range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, $2ZBRZ.max)(0, (0, $2ZBRZ.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, $2ZBRZ.tau) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = $cd86dd3fbe394b2b$var$range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = $cd86dd3fbe394b2b$var$range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $2ZBRZ.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $cd86dd3fbe394b2b$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

});
parcelRegister("2ZBRZ", function(module, exports) {

$parcel$export(module.exports, "abs", () => $22dea76b4625cce4$export$2335f513bbd82c6d);
$parcel$export(module.exports, "cos", () => $22dea76b4625cce4$export$50d414a77b60d802);
$parcel$export(module.exports, "sin", () => $22dea76b4625cce4$export$5de3937cb4b592ed);
$parcel$export(module.exports, "halfPi", () => $22dea76b4625cce4$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $22dea76b4625cce4$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "max", () => $22dea76b4625cce4$export$8960430cfd85939f);
$parcel$export(module.exports, "epsilon", () => $22dea76b4625cce4$export$6c421550c66a327d);
var $22dea76b4625cce4$export$2335f513bbd82c6d = Math.abs;
var $22dea76b4625cce4$export$50d414a77b60d802 = Math.cos;
var $22dea76b4625cce4$export$5de3937cb4b592ed = Math.sin;
var $22dea76b4625cce4$export$18c7bea995a110f = Math.PI;
var $22dea76b4625cce4$export$e51408a300e8929a = $22dea76b4625cce4$export$18c7bea995a110f / 2;
var $22dea76b4625cce4$export$a4b4b4d4d776fe92 = $22dea76b4625cce4$export$18c7bea995a110f * 2;
var $22dea76b4625cce4$export$8960430cfd85939f = Math.max;
var $22dea76b4625cce4$export$6c421550c66a327d = 1e-12;

});


parcelRegister("5kPVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2718c49f56e79d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ribbonArrow", () => $3e2718c49f56e79d$export$63f6c8bb9e816a34);

var $1ErJ0 = parcelRequire("1ErJ0");

var $kEJ87 = parcelRequire("kEJ87");

var $bxKRl = parcelRequire("bxKRl");

var $2ZBRZ = parcelRequire("2ZBRZ");
function $3e2718c49f56e79d$var$defaultSource(d) {
    return d.source;
}
function $3e2718c49f56e79d$var$defaultTarget(d) {
    return d.target;
}
function $3e2718c49f56e79d$var$defaultRadius(d) {
    return d.radius;
}
function $3e2718c49f56e79d$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $3e2718c49f56e79d$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $3e2718c49f56e79d$var$defaultPadAngle() {
    return 0;
}
function $3e2718c49f56e79d$var$defaultArrowheadRadius() {
    return 10;
}
function $3e2718c49f56e79d$var$ribbon(headRadius) {
    var source = $3e2718c49f56e79d$var$defaultSource, target = $3e2718c49f56e79d$var$defaultTarget, sourceRadius = $3e2718c49f56e79d$var$defaultRadius, targetRadius = $3e2718c49f56e79d$var$defaultRadius, startAngle = $3e2718c49f56e79d$var$defaultStartAngle, endAngle = $3e2718c49f56e79d$var$defaultEndAngle, padAngle = $3e2718c49f56e79d$var$defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, $kEJ87.slice).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $2ZBRZ.halfPi), sa1 = endAngle.apply(this, argv) - (0, $2ZBRZ.halfPi), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $2ZBRZ.halfPi), ta1 = endAngle.apply(this, argv) - (0, $2ZBRZ.halfPi);
        if (!context) context = buffer = (0, $1ErJ0.default)();
        if (ap > (0, $2ZBRZ.epsilon)) {
            if ((0, $2ZBRZ.abs)(sa1 - sa0) > ap * 2 + (0, $2ZBRZ.epsilon)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, $2ZBRZ.abs)(ta1 - ta0) > ap * 2 + (0, $2ZBRZ.epsilon)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, $2ZBRZ.cos)(sa0), sr * (0, $2ZBRZ.sin)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, $2ZBRZ.cos)(ta0), tr2 * (0, $2ZBRZ.sin)(ta0));
                context.lineTo(tr * (0, $2ZBRZ.cos)(ta2), tr * (0, $2ZBRZ.sin)(ta2));
                context.lineTo(tr2 * (0, $2ZBRZ.cos)(ta1), tr2 * (0, $2ZBRZ.sin)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, $2ZBRZ.cos)(ta0), tr * (0, $2ZBRZ.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, $2ZBRZ.cos)(sa0), sr * (0, $2ZBRZ.sin)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $bxKRl.default)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function $3e2718c49f56e79d$export$2e2bcd8739ae039() {
    return $3e2718c49f56e79d$var$ribbon();
}
function $3e2718c49f56e79d$export$63f6c8bb9e816a34() {
    return $3e2718c49f56e79d$var$ribbon($3e2718c49f56e79d$var$defaultArrowheadRadius);
}

});
parcelRegister("1ErJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $133f087380a55fa3$export$2e2bcd8739ae039);
const $133f087380a55fa3$var$pi = Math.PI, $133f087380a55fa3$var$tau = 2 * $133f087380a55fa3$var$pi, $133f087380a55fa3$var$epsilon = 1e-6, $133f087380a55fa3$var$tauEpsilon = $133f087380a55fa3$var$tau - $133f087380a55fa3$var$epsilon;
function $133f087380a55fa3$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $133f087380a55fa3$var$path() {
    return new $133f087380a55fa3$var$Path;
}
$133f087380a55fa3$var$Path.prototype = $133f087380a55fa3$var$path.prototype = {
    constructor: $133f087380a55fa3$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $133f087380a55fa3$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $133f087380a55fa3$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($133f087380a55fa3$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $133f087380a55fa3$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $133f087380a55fa3$var$epsilon || Math.abs(this._y1 - y0) > $133f087380a55fa3$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $133f087380a55fa3$var$tau + $133f087380a55fa3$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $133f087380a55fa3$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $133f087380a55fa3$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $133f087380a55fa3$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $133f087380a55fa3$export$2e2bcd8739ae039 = $133f087380a55fa3$var$path;

});

parcelRegister("kEJ87", function(module, exports) {

$parcel$export(module.exports, "slice", () => $f09a8cf100c54637$export$58adb3bec8346d0f);
var $f09a8cf100c54637$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("bxKRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $867720151bffecb8$export$2e2bcd8739ae039);
function $867720151bffecb8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("18ELu", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("bxlao")).default);
$parcel$export(module.exports, "rgb", () => (parcelRequire("bxlao")).rgb);
$parcel$export(module.exports, "hsl", () => (parcelRequire("bxlao")).hsl);
$parcel$export(module.exports, "lab", () => (parcelRequire("7xKu8")).default);
$parcel$export(module.exports, "hcl", () => (parcelRequire("7xKu8")).hcl);
$parcel$export(module.exports, "lch", () => (parcelRequire("7xKu8")).lch);
$parcel$export(module.exports, "gray", () => (parcelRequire("7xKu8")).gray);
$parcel$export(module.exports, "cubehelix", () => (parcelRequire("lRTRF")).default);

var $bxlao = parcelRequire("bxlao");

var $7xKu8 = parcelRequire("7xKu8");

var $lRTRF = parcelRequire("lRTRF");

});
parcelRegister("7xKu8", function(module, exports) {

$parcel$export(module.exports, "gray", () => $57dfac6d5500a8f3$export$3e2c219d3ab79d01);
$parcel$export(module.exports, "default", () => $57dfac6d5500a8f3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "lch", () => $57dfac6d5500a8f3$export$5a21418738164530);
$parcel$export(module.exports, "hcl", () => $57dfac6d5500a8f3$export$d0e870ba50062ff1);

var $81PUJ = parcelRequire("81PUJ");

var $bxlao = parcelRequire("bxlao");

var $lLyV8 = parcelRequire("lLyV8");
// https://observablehq.com/@mbostock/lab-and-rgb
const $57dfac6d5500a8f3$var$K = 18, $57dfac6d5500a8f3$var$Xn = 0.96422, $57dfac6d5500a8f3$var$Yn = 1, $57dfac6d5500a8f3$var$Zn = 0.82521, $57dfac6d5500a8f3$var$t0 = 4 / 29, $57dfac6d5500a8f3$var$t1 = 6 / 29, $57dfac6d5500a8f3$var$t2 = 3 * $57dfac6d5500a8f3$var$t1 * $57dfac6d5500a8f3$var$t1, $57dfac6d5500a8f3$var$t3 = $57dfac6d5500a8f3$var$t1 * $57dfac6d5500a8f3$var$t1 * $57dfac6d5500a8f3$var$t1;
function $57dfac6d5500a8f3$var$labConvert(o) {
    if (o instanceof $57dfac6d5500a8f3$export$f2722c70a60257f7) return new $57dfac6d5500a8f3$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $57dfac6d5500a8f3$export$d9397e094a5fbb9a) return $57dfac6d5500a8f3$var$hcl2lab(o);
    if (!(o instanceof (0, $bxlao.Rgb))) o = (0, $bxlao.rgbConvert)(o);
    var r = $57dfac6d5500a8f3$var$rgb2lrgb(o.r), g = $57dfac6d5500a8f3$var$rgb2lrgb(o.g), b = $57dfac6d5500a8f3$var$rgb2lrgb(o.b), y = $57dfac6d5500a8f3$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $57dfac6d5500a8f3$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $57dfac6d5500a8f3$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $57dfac6d5500a8f3$var$Xn);
        z = $57dfac6d5500a8f3$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $57dfac6d5500a8f3$var$Zn);
    }
    return new $57dfac6d5500a8f3$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $57dfac6d5500a8f3$export$3e2c219d3ab79d01(l, opacity) {
    return new $57dfac6d5500a8f3$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $57dfac6d5500a8f3$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $57dfac6d5500a8f3$var$labConvert(l) : new $57dfac6d5500a8f3$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $57dfac6d5500a8f3$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $81PUJ.default)($57dfac6d5500a8f3$export$f2722c70a60257f7, $57dfac6d5500a8f3$export$2e2bcd8739ae039, (0, $81PUJ.extend)((0, $bxlao.Color), {
    brighter: function(k) {
        return new $57dfac6d5500a8f3$export$f2722c70a60257f7(this.l + $57dfac6d5500a8f3$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $57dfac6d5500a8f3$export$f2722c70a60257f7(this.l - $57dfac6d5500a8f3$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $57dfac6d5500a8f3$var$Xn * $57dfac6d5500a8f3$var$lab2xyz(x);
        y = $57dfac6d5500a8f3$var$Yn * $57dfac6d5500a8f3$var$lab2xyz(y);
        z = $57dfac6d5500a8f3$var$Zn * $57dfac6d5500a8f3$var$lab2xyz(z);
        return new (0, $bxlao.Rgb)($57dfac6d5500a8f3$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $57dfac6d5500a8f3$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $57dfac6d5500a8f3$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $57dfac6d5500a8f3$var$xyz2lab(t) {
    return t > $57dfac6d5500a8f3$var$t3 ? Math.pow(t, 1 / 3) : t / $57dfac6d5500a8f3$var$t2 + $57dfac6d5500a8f3$var$t0;
}
function $57dfac6d5500a8f3$var$lab2xyz(t) {
    return t > $57dfac6d5500a8f3$var$t1 ? t * t * t : $57dfac6d5500a8f3$var$t2 * (t - $57dfac6d5500a8f3$var$t0);
}
function $57dfac6d5500a8f3$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $57dfac6d5500a8f3$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $57dfac6d5500a8f3$var$hclConvert(o) {
    if (o instanceof $57dfac6d5500a8f3$export$d9397e094a5fbb9a) return new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $57dfac6d5500a8f3$export$f2722c70a60257f7)) o = $57dfac6d5500a8f3$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $lLyV8.degrees);
    return new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $57dfac6d5500a8f3$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $57dfac6d5500a8f3$var$hclConvert(l) : new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $57dfac6d5500a8f3$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $57dfac6d5500a8f3$var$hclConvert(h) : new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $57dfac6d5500a8f3$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $57dfac6d5500a8f3$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $57dfac6d5500a8f3$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $lLyV8.radians);
    return new $57dfac6d5500a8f3$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $81PUJ.default)($57dfac6d5500a8f3$export$d9397e094a5fbb9a, $57dfac6d5500a8f3$export$d0e870ba50062ff1, (0, $81PUJ.extend)((0, $bxlao.Color), {
    brighter: function(k) {
        return new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(this.h, this.c, this.l + $57dfac6d5500a8f3$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $57dfac6d5500a8f3$export$d9397e094a5fbb9a(this.h, this.c, this.l - $57dfac6d5500a8f3$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $57dfac6d5500a8f3$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("lLyV8", function(module, exports) {

$parcel$export(module.exports, "radians", () => $fd89133cbda3d68a$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $fd89133cbda3d68a$export$41fc368e1a942b97);
const $fd89133cbda3d68a$export$8449e153fbd325fc = Math.PI / 180;
const $fd89133cbda3d68a$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("lRTRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb9e1be9d8a4d63$export$2e2bcd8739ae039);

var $81PUJ = parcelRequire("81PUJ");

var $bxlao = parcelRequire("bxlao");

var $lLyV8 = parcelRequire("lLyV8");
var $feb9e1be9d8a4d63$var$A = -0.14861, $feb9e1be9d8a4d63$var$B = 1.78277, $feb9e1be9d8a4d63$var$C = -0.29227, $feb9e1be9d8a4d63$var$D = -0.90649, $feb9e1be9d8a4d63$var$E = 1.97294, $feb9e1be9d8a4d63$var$ED = $feb9e1be9d8a4d63$var$E * $feb9e1be9d8a4d63$var$D, $feb9e1be9d8a4d63$var$EB = $feb9e1be9d8a4d63$var$E * $feb9e1be9d8a4d63$var$B, $feb9e1be9d8a4d63$var$BC_DA = $feb9e1be9d8a4d63$var$B * $feb9e1be9d8a4d63$var$C - $feb9e1be9d8a4d63$var$D * $feb9e1be9d8a4d63$var$A;
function $feb9e1be9d8a4d63$var$cubehelixConvert(o) {
    if (o instanceof $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2) return new $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $bxlao.Rgb))) o = (0, $bxlao.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($feb9e1be9d8a4d63$var$BC_DA * b + $feb9e1be9d8a4d63$var$ED * r - $feb9e1be9d8a4d63$var$EB * g) / ($feb9e1be9d8a4d63$var$BC_DA + $feb9e1be9d8a4d63$var$ED - $feb9e1be9d8a4d63$var$EB), bl = b - l, k = ($feb9e1be9d8a4d63$var$E * (g - l) - $feb9e1be9d8a4d63$var$C * bl) / $feb9e1be9d8a4d63$var$D, s = Math.sqrt(k * k + bl * bl) / ($feb9e1be9d8a4d63$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $lLyV8.degrees) - 120 : NaN;
    return new $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $feb9e1be9d8a4d63$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $feb9e1be9d8a4d63$var$cubehelixConvert(h) : new $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $81PUJ.default)($feb9e1be9d8a4d63$export$57ed4bde61a1e2f2, $feb9e1be9d8a4d63$export$2e2bcd8739ae039, (0, $81PUJ.extend)((0, $bxlao.Color), {
    brighter: function(k) {
        k = k == null ? (0, $bxlao.brighter) : Math.pow((0, $bxlao.brighter), k);
        return new $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $bxlao.darker) : Math.pow((0, $bxlao.darker), k);
        return new $feb9e1be9d8a4d63$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $lLyV8.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $bxlao.Rgb)(255 * (l + a * ($feb9e1be9d8a4d63$var$A * cosh + $feb9e1be9d8a4d63$var$B * sinh)), 255 * (l + a * ($feb9e1be9d8a4d63$var$C * cosh + $feb9e1be9d8a4d63$var$D * sinh)), 255 * (l + a * ($feb9e1be9d8a4d63$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("3MDY6", function(module, exports) {

$parcel$export(module.exports, "contours", () => (parcelRequire("31p12")).default);
$parcel$export(module.exports, "contourDensity", () => (parcelRequire("6eFwx")).default);

var $31p12 = parcelRequire("31p12");

var $6eFwx = parcelRequire("6eFwx");

});
parcelRegister("31p12", function(module, exports) {

$parcel$export(module.exports, "default", () => $2334deb045c7836d$export$2e2bcd8739ae039);

var $800Ds = parcelRequire("800Ds");
var $4n9LK = parcelRequire("4n9LK");
var $dJyty = parcelRequire("dJyty");
var $3PQRV = parcelRequire("3PQRV");

var $klfHd = parcelRequire("klfHd");

var $fYRar = parcelRequire("fYRar");

var $1f5xv = parcelRequire("1f5xv");

var $7Pmm6 = parcelRequire("7Pmm6");

var $cI3mO = parcelRequire("cI3mO");

var $1LJXn = parcelRequire("1LJXn");
var $2334deb045c7836d$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $2334deb045c7836d$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $dJyty.default), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var domain = (0, $800Ds.default)(values), start = domain[0], stop = domain[1];
            tz = (0, $3PQRV.tickStep)(start, stop, tz);
            tz = (0, $4n9LK.default)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
        } else tz = tz.slice().sort((0, $fYRar.default));
        return tz.map(function(value) {
            return contour(values, value);
        });
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $1f5xv.default)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $cI3mO.default)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $2334deb045c7836d$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $2334deb045c7836d$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $2334deb045c7836d$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $2334deb045c7836d$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $2334deb045c7836d$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $2334deb045c7836d$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $2334deb045c7836d$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $2334deb045c7836d$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $2334deb045c7836d$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $7Pmm6.default)((0, $klfHd.slice).call(_)) : (0, $7Pmm6.default)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $1LJXn.default), contours) : smooth === smoothLinear;
    };
    return contours;
}

});
parcelRegister("klfHd", function(module, exports) {

$parcel$export(module.exports, "slice", () => $ecf1f1b1bf8eb85f$export$58adb3bec8346d0f);
var $ecf1f1b1bf8eb85f$var$array = Array.prototype;
var $ecf1f1b1bf8eb85f$export$58adb3bec8346d0f = $ecf1f1b1bf8eb85f$var$array.slice;

});

parcelRegister("fYRar", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba25b388a53ec662$export$2e2bcd8739ae039);
function $ba25b388a53ec662$export$2e2bcd8739ae039(a, b) {
    return a - b;
}

});

parcelRegister("1f5xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7b7d2b05b72140$export$2e2bcd8739ae039);
function $0e7b7d2b05b72140$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}

});

parcelRegister("7Pmm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2ea32738aef625$export$2e2bcd8739ae039);
var $5b2ea32738aef625$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("cI3mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $940c34b6802487f0$export$2e2bcd8739ae039);
function $940c34b6802487f0$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $940c34b6802487f0$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $940c34b6802487f0$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($940c34b6802487f0$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $940c34b6802487f0$var$segmentContains(a, b, c) {
    var i;
    return $940c34b6802487f0$var$collinear(a, b, c) && $940c34b6802487f0$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $940c34b6802487f0$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $940c34b6802487f0$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

});

parcelRegister("1LJXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $149dd44a7599aae2$export$2e2bcd8739ae039);
function $149dd44a7599aae2$export$2e2bcd8739ae039() {}

});


parcelRegister("6eFwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a442a83f3322e0$export$2e2bcd8739ae039);

var $3nBT6 = parcelRequire("3nBT6");
var $4n9LK = parcelRequire("4n9LK");
var $3PQRV = parcelRequire("3PQRV");

var $klfHd = parcelRequire("klfHd");

var $7JSLq = parcelRequire("7JSLq");

var $7Pmm6 = parcelRequire("7Pmm6");

var $31p12 = parcelRequire("31p12");
function $48a442a83f3322e0$var$defaultX(d) {
    return d[0];
}
function $48a442a83f3322e0$var$defaultY(d) {
    return d[1];
}
function $48a442a83f3322e0$var$defaultWeight() {
    return 1;
}
function $48a442a83f3322e0$export$2e2bcd8739ae039() {
    var x = $48a442a83f3322e0$var$defaultX, y = $48a442a83f3322e0$var$defaultY, weight = $48a442a83f3322e0$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $7Pmm6.default)(20);
    function density(data) {
        var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        data.forEach(function(d, i, data) {
            var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
        });
        // TODO Optimize.
        (0, $7JSLq.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $7JSLq.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $7JSLq.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $7JSLq.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $7JSLq.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $7JSLq.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        var tz = threshold(values0);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var stop = (0, $3nBT6.default)(values0);
            tz = (0, $3PQRV.tickStep)(0, stop, tz);
            tz = (0, $4n9LK.default)(0, Math.floor(stop / tz) * tz, tz);
            tz.shift();
        }
        return (0, $31p12.default)().thresholds(tz).size([
            n,
            m
        ])(values0).map(transform);
    }
    function transform(geometry) {
        geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7Pmm6.default)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7Pmm6.default)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $7Pmm6.default)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $7Pmm6.default)((0, $klfHd.slice).call(_)) : (0, $7Pmm6.default)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
    };
    return density;
}

});
parcelRegister("7JSLq", function(module, exports) {

$parcel$export(module.exports, "blurX", () => $5a27375d6fe34ca7$export$d6b6c69cb5897b44);
$parcel$export(module.exports, "blurY", () => $5a27375d6fe34ca7$export$96ba1179f8344c4b);
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function $5a27375d6fe34ca7$export$d6b6c69cb5897b44(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function $5a27375d6fe34ca7$export$96ba1179f8344c4b(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}

});



parcelRegister("9IfuZ", function(module, exports) {

$parcel$export(module.exports, "Delaunay", () => (parcelRequire("g7tcq")).default);
$parcel$export(module.exports, "Voronoi", () => (parcelRequire("irv29")).default);

var $g7tcq = parcelRequire("g7tcq");

var $irv29 = parcelRequire("irv29");

});
parcelRegister("g7tcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc3f32a182869d7$export$2e2bcd8739ae039);

var $l5BEk = parcelRequire("l5BEk");

var $iJqlv = parcelRequire("iJqlv");

var $iSlBM = parcelRequire("iSlBM");

var $irv29 = parcelRequire("irv29");
const $bbc3f32a182869d7$var$tau = 2 * Math.PI, $bbc3f32a182869d7$var$pow = Math.pow;
function $bbc3f32a182869d7$var$pointX(p) {
    return p[0];
}
function $bbc3f32a182869d7$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $bbc3f32a182869d7$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $bbc3f32a182869d7$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $bbc3f32a182869d7$export$2e2bcd8739ae039 {
    static from(points, fx = $bbc3f32a182869d7$var$pointX, fy = $bbc3f32a182869d7$var$pointY, that) {
        return new $bbc3f32a182869d7$export$2e2bcd8739ae039("length" in points ? $bbc3f32a182869d7$var$flatArray(points, fx, fy, that) : Float64Array.from($bbc3f32a182869d7$var$flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, $l5BEk.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $bbc3f32a182869d7$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $bbc3f32a182869d7$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $l5BEk.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
            inedges[hull[0]] = 1;
            if (hull.length === 2) inedges[hull[1]] = 0;
        }
    }
    voronoi(bounds) {
        return new (0, $irv29.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $bbc3f32a182869d7$var$pow(x - points[i * 2], 2) + $bbc3f32a182869d7$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $bbc3f32a182869d7$var$pow(x - points[t * 2], 2) + $bbc3f32a182869d7$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($bbc3f32a182869d7$var$pow(x - points[e * 2], 2) + $bbc3f32a182869d7$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r = 2) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $bbc3f32a182869d7$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $iSlBM.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $iSlBM.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
function $bbc3f32a182869d7$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $bbc3f32a182869d7$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

});
parcelRegister("l5BEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a744ffe2bb20e2$export$2e2bcd8739ae039);
const $f5a744ffe2bb20e2$var$EPSILON = Math.pow(2, -52);
const $f5a744ffe2bb20e2$var$EDGE_STACK = new Uint32Array(512);
class $f5a744ffe2bb20e2$export$2e2bcd8739ae039 {
    static from(points, getX = $f5a744ffe2bb20e2$var$defaultGetX, getY = $f5a744ffe2bb20e2$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $f5a744ffe2bb20e2$export$2e2bcd8739ae039(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $f5a744ffe2bb20e2$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $f5a744ffe2bb20e2$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $f5a744ffe2bb20e2$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $f5a744ffe2bb20e2$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ($f5a744ffe2bb20e2$var$orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $f5a744ffe2bb20e2$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $f5a744ffe2bb20e2$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $f5a744ffe2bb20e2$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $f5a744ffe2bb20e2$var$EPSILON && Math.abs(y - yp) <= $f5a744ffe2bb20e2$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], !$f5a744ffe2bb20e2$var$orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], $f5a744ffe2bb20e2$var$orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], $f5a744ffe2bb20e2$var$orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($f5a744ffe2bb20e2$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $f5a744ffe2bb20e2$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $f5a744ffe2bb20e2$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $f5a744ffe2bb20e2$var$EDGE_STACK.length) $f5a744ffe2bb20e2$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $f5a744ffe2bb20e2$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $f5a744ffe2bb20e2$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $f5a744ffe2bb20e2$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function $f5a744ffe2bb20e2$var$orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}
// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function $f5a744ffe2bb20e2$var$orient(rx, ry, qx, qy, px, py) {
    const sign = $f5a744ffe2bb20e2$var$orientIfSure(px, py, rx, ry, qx, qy) || $f5a744ffe2bb20e2$var$orientIfSure(rx, ry, qx, qy, px, py) || $f5a744ffe2bb20e2$var$orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}
function $f5a744ffe2bb20e2$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $f5a744ffe2bb20e2$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $f5a744ffe2bb20e2$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $f5a744ffe2bb20e2$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $f5a744ffe2bb20e2$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $f5a744ffe2bb20e2$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $f5a744ffe2bb20e2$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $f5a744ffe2bb20e2$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $f5a744ffe2bb20e2$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $f5a744ffe2bb20e2$var$quicksort(ids, dists, i, right);
            $f5a744ffe2bb20e2$var$quicksort(ids, dists, left, j - 1);
        } else {
            $f5a744ffe2bb20e2$var$quicksort(ids, dists, left, j - 1);
            $f5a744ffe2bb20e2$var$quicksort(ids, dists, i, right);
        }
    }
}
function $f5a744ffe2bb20e2$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $f5a744ffe2bb20e2$var$defaultGetX(p) {
    return p[0];
}
function $f5a744ffe2bb20e2$var$defaultGetY(p) {
    return p[1];
}

});

parcelRegister("iJqlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $da30ddb6b9fd83d6$export$2e2bcd8739ae039);
const $da30ddb6b9fd83d6$var$epsilon = 1e-6;
class $da30ddb6b9fd83d6$export$2e2bcd8739ae039 {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $da30ddb6b9fd83d6$var$epsilon || Math.abs(this._y1 - y0) > $da30ddb6b9fd83d6$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}

});

parcelRegister("iSlBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbde0818e34bf287$export$2e2bcd8739ae039);
class $dbde0818e34bf287$export$2e2bcd8739ae039 {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}

});

parcelRegister("irv29", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d2d24303f53dcc$export$2e2bcd8739ae039);

var $iJqlv = parcelRequire("iJqlv");

var $iSlBM = parcelRequire("iSlBM");
class $d6d2d24303f53dcc$export$2e2bcd8739ae039 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const ab = (dx * ey - dy * ex) * 2;
            if (!ab) {
                // degenerate case (collinear diagram)
                x = (x1 + x3) / 2 - 1e8 * ey;
                y = (y1 + y3) / 2 + 1e8 * ex;
            } else if (Math.abs(ab) < 1e-8) {
                // almost equal points (degenerate triangle)
                x = (x1 + x3) / 2;
                y = (y1 + y3) / 2;
            } else {
                const d = 1 / ab;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $iJqlv.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $iSlBM.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        while(true){
            if (c0 === 0 && c1 === 0) return [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        if (P.length > 4) for(let i = 0; i < P.length; i += 2){
            const j = (i + 2) % P.length, k = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
}

});



parcelRegister("4lCzg", function(module, exports) {

$parcel$export(module.exports, "dispatch", () => (parcelRequire("2LbPR")).default);

var $2LbPR = parcelRequire("2LbPR");

});

parcelRegister("6qavz", function(module, exports) {

$parcel$export(module.exports, "drag", () => (parcelRequire("jICZ8")).default);
$parcel$export(module.exports, "dragDisable", () => (parcelRequire("ZdBH5")).default);
$parcel$export(module.exports, "dragEnable", () => (parcelRequire("ZdBH5")).yesdrag);

var $jICZ8 = parcelRequire("jICZ8");

var $ZdBH5 = parcelRequire("ZdBH5");

});
parcelRegister("jICZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5b05dfe5fab4012$export$2e2bcd8739ae039);

var $2LbPR = parcelRequire("2LbPR");

var $2GQnz = parcelRequire("2GQnz");
var $cn1Uc = parcelRequire("cn1Uc");

var $ZdBH5 = parcelRequire("ZdBH5");

var $8Xieg = parcelRequire("8Xieg");

var $3VGOj = parcelRequire("3VGOj");

var $lxy2D = parcelRequire("lxy2D");
// Ignore right-click, since that should open the context menu.
function $e5b05dfe5fab4012$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $e5b05dfe5fab4012$var$defaultContainer() {
    return this.parentNode;
}
function $e5b05dfe5fab4012$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $e5b05dfe5fab4012$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $e5b05dfe5fab4012$export$2e2bcd8739ae039() {
    var filter = $e5b05dfe5fab4012$var$defaultFilter, container = $e5b05dfe5fab4012$var$defaultContainer, subject = $e5b05dfe5fab4012$var$defaultSubject, touchable = $e5b05dfe5fab4012$var$defaultTouchable, gestures = {}, listeners = (0, $2LbPR.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $cn1Uc.default)(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $ZdBH5.default)(event.view);
        (0, $8Xieg.nopropagation)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $8Xieg.default)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $cn1Uc.default)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $ZdBH5.yesdrag)(event.view, mousemoving);
        (0, $8Xieg.default)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $8Xieg.nopropagation)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $8Xieg.default)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $8Xieg.nopropagation)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $2GQnz.default)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $lxy2D.default)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // nobreak
                case "drag":
                    p = (0, $2GQnz.default)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $lxy2D.default)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $3VGOj.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $3VGOj.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $3VGOj.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $3VGOj.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("3VGOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc7e73c8d1e0173$export$2e2bcd8739ae039);
var $2dc7e73c8d1e0173$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("lxy2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae715fd52ddceaa$export$2e2bcd8739ae039);
function $fae715fd52ddceaa$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$fae715fd52ddceaa$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});



parcelRegister("5pGIM", function(module, exports) {

$parcel$export(module.exports, "dsvFormat", () => (parcelRequire("i20GR")).default);
$parcel$export(module.exports, "csvParse", () => (parcelRequire("iya4m")).csvParse);
$parcel$export(module.exports, "csvParseRows", () => (parcelRequire("iya4m")).csvParseRows);
$parcel$export(module.exports, "csvFormat", () => (parcelRequire("iya4m")).csvFormat);
$parcel$export(module.exports, "csvFormatBody", () => (parcelRequire("iya4m")).csvFormatBody);
$parcel$export(module.exports, "csvFormatRows", () => (parcelRequire("iya4m")).csvFormatRows);
$parcel$export(module.exports, "csvFormatRow", () => (parcelRequire("iya4m")).csvFormatRow);
$parcel$export(module.exports, "csvFormatValue", () => (parcelRequire("iya4m")).csvFormatValue);
$parcel$export(module.exports, "tsvParse", () => (parcelRequire("95QRk")).tsvParse);
$parcel$export(module.exports, "tsvParseRows", () => (parcelRequire("95QRk")).tsvParseRows);
$parcel$export(module.exports, "tsvFormat", () => (parcelRequire("95QRk")).tsvFormat);
$parcel$export(module.exports, "tsvFormatBody", () => (parcelRequire("95QRk")).tsvFormatBody);
$parcel$export(module.exports, "tsvFormatRows", () => (parcelRequire("95QRk")).tsvFormatRows);
$parcel$export(module.exports, "tsvFormatRow", () => (parcelRequire("95QRk")).tsvFormatRow);
$parcel$export(module.exports, "tsvFormatValue", () => (parcelRequire("95QRk")).tsvFormatValue);
$parcel$export(module.exports, "autoType", () => (parcelRequire("d0J3t")).default);

var $i20GR = parcelRequire("i20GR");

var $iya4m = parcelRequire("iya4m");

var $95QRk = parcelRequire("95QRk");

var $d0J3t = parcelRequire("d0J3t");

});
parcelRegister("i20GR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d208f2fb4ccba6c4$export$2e2bcd8739ae039);
var $d208f2fb4ccba6c4$var$EOL = {}, $d208f2fb4ccba6c4$var$EOF = {}, $d208f2fb4ccba6c4$var$QUOTE = 34, $d208f2fb4ccba6c4$var$NEWLINE = 10, $d208f2fb4ccba6c4$var$RETURN = 13;
function $d208f2fb4ccba6c4$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function $d208f2fb4ccba6c4$var$customConverter(columns, f) {
    var object = $d208f2fb4ccba6c4$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $d208f2fb4ccba6c4$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $d208f2fb4ccba6c4$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $d208f2fb4ccba6c4$var$formatYear(year) {
    return year < 0 ? "-" + $d208f2fb4ccba6c4$var$pad(-year, 6) : year > 9999 ? "+" + $d208f2fb4ccba6c4$var$pad(year, 6) : $d208f2fb4ccba6c4$var$pad(year, 4);
}
function $d208f2fb4ccba6c4$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $d208f2fb4ccba6c4$var$formatYear(date.getUTCFullYear(), 4) + "-" + $d208f2fb4ccba6c4$var$pad(date.getUTCMonth() + 1, 2) + "-" + $d208f2fb4ccba6c4$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $d208f2fb4ccba6c4$var$pad(hours, 2) + ":" + $d208f2fb4ccba6c4$var$pad(minutes, 2) + ":" + $d208f2fb4ccba6c4$var$pad(seconds, 2) + "." + $d208f2fb4ccba6c4$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $d208f2fb4ccba6c4$var$pad(hours, 2) + ":" + $d208f2fb4ccba6c4$var$pad(minutes, 2) + ":" + $d208f2fb4ccba6c4$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $d208f2fb4ccba6c4$var$pad(hours, 2) + ":" + $d208f2fb4ccba6c4$var$pad(minutes, 2) + "Z" : "");
}
function $d208f2fb4ccba6c4$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $d208f2fb4ccba6c4$var$customConverter(row, f) : $d208f2fb4ccba6c4$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $d208f2fb4ccba6c4$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $d208f2fb4ccba6c4$var$RETURN) --N;
        function token() {
            if (eof) return $d208f2fb4ccba6c4$var$EOF;
            if (eol) return eol = false, $d208f2fb4ccba6c4$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $d208f2fb4ccba6c4$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $d208f2fb4ccba6c4$var$QUOTE || text.charCodeAt(++I) === $d208f2fb4ccba6c4$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $d208f2fb4ccba6c4$var$NEWLINE) eol = true;
                else if (c === $d208f2fb4ccba6c4$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $d208f2fb4ccba6c4$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $d208f2fb4ccba6c4$var$NEWLINE) eol = true;
                else if (c === $d208f2fb4ccba6c4$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $d208f2fb4ccba6c4$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $d208f2fb4ccba6c4$var$EOF){
            var row = [];
            while(t !== $d208f2fb4ccba6c4$var$EOL && t !== $d208f2fb4ccba6c4$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $d208f2fb4ccba6c4$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $d208f2fb4ccba6c4$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $d208f2fb4ccba6c4$var$formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});

parcelRegister("iya4m", function(module, exports) {

$parcel$export(module.exports, "csvParse", () => $d81336815aa7bb9c$export$289d25497b0f4c16);
$parcel$export(module.exports, "csvParseRows", () => $d81336815aa7bb9c$export$c82550ca942d869);
$parcel$export(module.exports, "csvFormat", () => $d81336815aa7bb9c$export$afe767551074aa08);
$parcel$export(module.exports, "csvFormatBody", () => $d81336815aa7bb9c$export$b46fa59a5e3bc8a2);
$parcel$export(module.exports, "csvFormatRows", () => $d81336815aa7bb9c$export$3f42a65843fbd1d9);
$parcel$export(module.exports, "csvFormatRow", () => $d81336815aa7bb9c$export$c30212b87b2d080f);
$parcel$export(module.exports, "csvFormatValue", () => $d81336815aa7bb9c$export$2771de09a60fc648);

var $i20GR = parcelRequire("i20GR");
var $d81336815aa7bb9c$var$csv = (0, $i20GR.default)(",");
var $d81336815aa7bb9c$export$289d25497b0f4c16 = $d81336815aa7bb9c$var$csv.parse;
var $d81336815aa7bb9c$export$c82550ca942d869 = $d81336815aa7bb9c$var$csv.parseRows;
var $d81336815aa7bb9c$export$afe767551074aa08 = $d81336815aa7bb9c$var$csv.format;
var $d81336815aa7bb9c$export$b46fa59a5e3bc8a2 = $d81336815aa7bb9c$var$csv.formatBody;
var $d81336815aa7bb9c$export$3f42a65843fbd1d9 = $d81336815aa7bb9c$var$csv.formatRows;
var $d81336815aa7bb9c$export$c30212b87b2d080f = $d81336815aa7bb9c$var$csv.formatRow;
var $d81336815aa7bb9c$export$2771de09a60fc648 = $d81336815aa7bb9c$var$csv.formatValue;

});

parcelRegister("95QRk", function(module, exports) {

$parcel$export(module.exports, "tsvParse", () => $69ed95648879ef47$export$f913251db2f734ee);
$parcel$export(module.exports, "tsvParseRows", () => $69ed95648879ef47$export$8de3b5abc40a067f);
$parcel$export(module.exports, "tsvFormat", () => $69ed95648879ef47$export$77e754c4f8504293);
$parcel$export(module.exports, "tsvFormatBody", () => $69ed95648879ef47$export$9d44987d460c9cb3);
$parcel$export(module.exports, "tsvFormatRows", () => $69ed95648879ef47$export$ae461973f6adc981);
$parcel$export(module.exports, "tsvFormatRow", () => $69ed95648879ef47$export$5d61cf35a4a738d2);
$parcel$export(module.exports, "tsvFormatValue", () => $69ed95648879ef47$export$4280e6a416cd92a3);

var $i20GR = parcelRequire("i20GR");
var $69ed95648879ef47$var$tsv = (0, $i20GR.default)("\t");
var $69ed95648879ef47$export$f913251db2f734ee = $69ed95648879ef47$var$tsv.parse;
var $69ed95648879ef47$export$8de3b5abc40a067f = $69ed95648879ef47$var$tsv.parseRows;
var $69ed95648879ef47$export$77e754c4f8504293 = $69ed95648879ef47$var$tsv.format;
var $69ed95648879ef47$export$9d44987d460c9cb3 = $69ed95648879ef47$var$tsv.formatBody;
var $69ed95648879ef47$export$ae461973f6adc981 = $69ed95648879ef47$var$tsv.formatRows;
var $69ed95648879ef47$export$5d61cf35a4a738d2 = $69ed95648879ef47$var$tsv.formatRow;
var $69ed95648879ef47$export$4280e6a416cd92a3 = $69ed95648879ef47$var$tsv.formatValue;

});

parcelRegister("d0J3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $978e396f99c438e1$export$2e2bcd8739ae039);
function $978e396f99c438e1$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($978e396f99c438e1$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const $978e396f99c438e1$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

});


parcelRegister("cQwnF", function(module, exports) {

$parcel$export(module.exports, "easeLinear", () => (parcelRequire("ebdft")).linear);
$parcel$export(module.exports, "easeQuad", () => (parcelRequire("2FRVI")).quadInOut);
$parcel$export(module.exports, "easeQuadIn", () => (parcelRequire("2FRVI")).quadIn);
$parcel$export(module.exports, "easeQuadOut", () => (parcelRequire("2FRVI")).quadOut);
$parcel$export(module.exports, "easeQuadInOut", () => (parcelRequire("2FRVI")).quadInOut);
$parcel$export(module.exports, "easeCubic", () => (parcelRequire("bQGHq")).cubicInOut);
$parcel$export(module.exports, "easeCubicIn", () => (parcelRequire("bQGHq")).cubicIn);
$parcel$export(module.exports, "easeCubicOut", () => (parcelRequire("bQGHq")).cubicOut);
$parcel$export(module.exports, "easeCubicInOut", () => (parcelRequire("bQGHq")).cubicInOut);
$parcel$export(module.exports, "easePoly", () => (parcelRequire("h4RT0")).polyInOut);
$parcel$export(module.exports, "easePolyIn", () => (parcelRequire("h4RT0")).polyIn);
$parcel$export(module.exports, "easePolyOut", () => (parcelRequire("h4RT0")).polyOut);
$parcel$export(module.exports, "easePolyInOut", () => (parcelRequire("h4RT0")).polyInOut);
$parcel$export(module.exports, "easeSin", () => (parcelRequire("bSqxB")).sinInOut);
$parcel$export(module.exports, "easeSinIn", () => (parcelRequire("bSqxB")).sinIn);
$parcel$export(module.exports, "easeSinOut", () => (parcelRequire("bSqxB")).sinOut);
$parcel$export(module.exports, "easeSinInOut", () => (parcelRequire("bSqxB")).sinInOut);
$parcel$export(module.exports, "easeExp", () => (parcelRequire("6vJB4")).expInOut);
$parcel$export(module.exports, "easeExpIn", () => (parcelRequire("6vJB4")).expIn);
$parcel$export(module.exports, "easeExpOut", () => (parcelRequire("6vJB4")).expOut);
$parcel$export(module.exports, "easeExpInOut", () => (parcelRequire("6vJB4")).expInOut);
$parcel$export(module.exports, "easeCircle", () => (parcelRequire("1rlG8")).circleInOut);
$parcel$export(module.exports, "easeCircleIn", () => (parcelRequire("1rlG8")).circleIn);
$parcel$export(module.exports, "easeCircleOut", () => (parcelRequire("1rlG8")).circleOut);
$parcel$export(module.exports, "easeCircleInOut", () => (parcelRequire("1rlG8")).circleInOut);
$parcel$export(module.exports, "easeBounce", () => (parcelRequire("88vjs")).bounceOut);
$parcel$export(module.exports, "easeBounceIn", () => (parcelRequire("88vjs")).bounceIn);
$parcel$export(module.exports, "easeBounceOut", () => (parcelRequire("88vjs")).bounceOut);
$parcel$export(module.exports, "easeBounceInOut", () => (parcelRequire("88vjs")).bounceInOut);
$parcel$export(module.exports, "easeBack", () => (parcelRequire("fYGhq")).backInOut);
$parcel$export(module.exports, "easeBackIn", () => (parcelRequire("fYGhq")).backIn);
$parcel$export(module.exports, "easeBackOut", () => (parcelRequire("fYGhq")).backOut);
$parcel$export(module.exports, "easeBackInOut", () => (parcelRequire("fYGhq")).backInOut);
$parcel$export(module.exports, "easeElastic", () => (parcelRequire("jdonE")).elasticOut);
$parcel$export(module.exports, "easeElasticIn", () => (parcelRequire("jdonE")).elasticIn);
$parcel$export(module.exports, "easeElasticOut", () => (parcelRequire("jdonE")).elasticOut);
$parcel$export(module.exports, "easeElasticInOut", () => (parcelRequire("jdonE")).elasticInOut);

var $ebdft = parcelRequire("ebdft");

var $2FRVI = parcelRequire("2FRVI");

var $bQGHq = parcelRequire("bQGHq");

var $h4RT0 = parcelRequire("h4RT0");

var $bSqxB = parcelRequire("bSqxB");

var $6vJB4 = parcelRequire("6vJB4");

var $1rlG8 = parcelRequire("1rlG8");

var $88vjs = parcelRequire("88vjs");

var $fYGhq = parcelRequire("fYGhq");

var $jdonE = parcelRequire("jdonE");

});
parcelRegister("ebdft", function(module, exports) {

$parcel$export(module.exports, "linear", () => $a52c5eab5c04d229$export$45db2fc2f15997e7);
const $a52c5eab5c04d229$export$45db2fc2f15997e7 = (t)=>+t;

});

parcelRegister("2FRVI", function(module, exports) {

$parcel$export(module.exports, "quadIn", () => $1f293e71c833a719$export$5118fc7a1e64441b);
$parcel$export(module.exports, "quadOut", () => $1f293e71c833a719$export$5be5f5e804d0b60c);
$parcel$export(module.exports, "quadInOut", () => $1f293e71c833a719$export$d6ded66933892ed3);
function $1f293e71c833a719$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $1f293e71c833a719$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $1f293e71c833a719$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRegister("h4RT0", function(module, exports) {

$parcel$export(module.exports, "polyIn", () => $c6ec9c14c289d135$export$aa0b5c3ce2df9d7d);
$parcel$export(module.exports, "polyOut", () => $c6ec9c14c289d135$export$e3d987a417dc6640);
$parcel$export(module.exports, "polyInOut", () => $c6ec9c14c289d135$export$ae94c6a40058b429);
var $c6ec9c14c289d135$var$exponent = 3;
var $c6ec9c14c289d135$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($c6ec9c14c289d135$var$exponent);
var $c6ec9c14c289d135$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($c6ec9c14c289d135$var$exponent);
var $c6ec9c14c289d135$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($c6ec9c14c289d135$var$exponent);

});

parcelRegister("bSqxB", function(module, exports) {

$parcel$export(module.exports, "sinIn", () => $8a59535c5a904be5$export$a83a280f8d31ba8d);
$parcel$export(module.exports, "sinOut", () => $8a59535c5a904be5$export$62ec6410ca53f2a7);
$parcel$export(module.exports, "sinInOut", () => $8a59535c5a904be5$export$ff58b604d3ba15ba);
var $8a59535c5a904be5$var$pi = Math.PI, $8a59535c5a904be5$var$halfPi = $8a59535c5a904be5$var$pi / 2;
function $8a59535c5a904be5$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $8a59535c5a904be5$var$halfPi);
}
function $8a59535c5a904be5$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $8a59535c5a904be5$var$halfPi);
}
function $8a59535c5a904be5$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($8a59535c5a904be5$var$pi * t)) / 2;
}

});

parcelRegister("6vJB4", function(module, exports) {

$parcel$export(module.exports, "expIn", () => $4bd901f14a1c07b9$export$fc3e95f15e1ef38e);
$parcel$export(module.exports, "expOut", () => $4bd901f14a1c07b9$export$f3c9b2f85fbcf0ab);
$parcel$export(module.exports, "expInOut", () => $4bd901f14a1c07b9$export$ae4d4e77fab188ff);

var $blcDf = parcelRequire("blcDf");
function $4bd901f14a1c07b9$export$fc3e95f15e1ef38e(t) {
    return (0, $blcDf.tpmt)(1 - +t);
}
function $4bd901f14a1c07b9$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $blcDf.tpmt)(t);
}
function $4bd901f14a1c07b9$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $blcDf.tpmt)(1 - t) : 2 - (0, $blcDf.tpmt)(t - 1)) / 2;
}

});
parcelRegister("blcDf", function(module, exports) {

$parcel$export(module.exports, "tpmt", () => $841b7456b49dc10e$export$be3f0f7224794b88);
// tpmt is two power minus ten times t scaled to [0,1]
function $841b7456b49dc10e$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

});


parcelRegister("1rlG8", function(module, exports) {

$parcel$export(module.exports, "circleIn", () => $10c920f51b67f457$export$9f82a71b0377c018);
$parcel$export(module.exports, "circleOut", () => $10c920f51b67f457$export$27989e665abef2c8);
$parcel$export(module.exports, "circleInOut", () => $10c920f51b67f457$export$2d757ff9ad09038f);
function $10c920f51b67f457$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $10c920f51b67f457$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $10c920f51b67f457$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRegister("88vjs", function(module, exports) {

$parcel$export(module.exports, "bounceIn", () => $5ec75c2420ca6671$export$fccebd7948554554);
$parcel$export(module.exports, "bounceOut", () => $5ec75c2420ca6671$export$cccc9e04465dce11);
$parcel$export(module.exports, "bounceInOut", () => $5ec75c2420ca6671$export$41ad9e9849a703ce);
var $5ec75c2420ca6671$var$b1 = 4 / 11, $5ec75c2420ca6671$var$b2 = 6 / 11, $5ec75c2420ca6671$var$b3 = 8 / 11, $5ec75c2420ca6671$var$b4 = 3 / 4, $5ec75c2420ca6671$var$b5 = 9 / 11, $5ec75c2420ca6671$var$b6 = 10 / 11, $5ec75c2420ca6671$var$b7 = 15 / 16, $5ec75c2420ca6671$var$b8 = 21 / 22, $5ec75c2420ca6671$var$b9 = 63 / 64, $5ec75c2420ca6671$var$b0 = 1 / $5ec75c2420ca6671$var$b1 / $5ec75c2420ca6671$var$b1;
function $5ec75c2420ca6671$export$fccebd7948554554(t) {
    return 1 - $5ec75c2420ca6671$export$cccc9e04465dce11(1 - t);
}
function $5ec75c2420ca6671$export$cccc9e04465dce11(t) {
    return (t = +t) < $5ec75c2420ca6671$var$b1 ? $5ec75c2420ca6671$var$b0 * t * t : t < $5ec75c2420ca6671$var$b3 ? $5ec75c2420ca6671$var$b0 * (t -= $5ec75c2420ca6671$var$b2) * t + $5ec75c2420ca6671$var$b4 : t < $5ec75c2420ca6671$var$b6 ? $5ec75c2420ca6671$var$b0 * (t -= $5ec75c2420ca6671$var$b5) * t + $5ec75c2420ca6671$var$b7 : $5ec75c2420ca6671$var$b0 * (t -= $5ec75c2420ca6671$var$b8) * t + $5ec75c2420ca6671$var$b9;
}
function $5ec75c2420ca6671$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $5ec75c2420ca6671$export$cccc9e04465dce11(1 - t) : $5ec75c2420ca6671$export$cccc9e04465dce11(t - 1) + 1) / 2;
}

});

parcelRegister("fYGhq", function(module, exports) {

$parcel$export(module.exports, "backIn", () => $ba1d41883e227244$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backOut", () => $ba1d41883e227244$export$77edfce482316a60);
$parcel$export(module.exports, "backInOut", () => $ba1d41883e227244$export$ddc5fd596f6c71b2);
var $ba1d41883e227244$var$overshoot = 1.70158;
var $ba1d41883e227244$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($ba1d41883e227244$var$overshoot);
var $ba1d41883e227244$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($ba1d41883e227244$var$overshoot);
var $ba1d41883e227244$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($ba1d41883e227244$var$overshoot);

});

parcelRegister("jdonE", function(module, exports) {

$parcel$export(module.exports, "elasticIn", () => $dfd224a6de0d40aa$export$41f42134872a5fa0);
$parcel$export(module.exports, "elasticOut", () => $dfd224a6de0d40aa$export$ed1782b99e69bbc8);
$parcel$export(module.exports, "elasticInOut", () => $dfd224a6de0d40aa$export$309de4f35f218bfd);

var $blcDf = parcelRequire("blcDf");
var $dfd224a6de0d40aa$var$tau = 2 * Math.PI, $dfd224a6de0d40aa$var$amplitude = 1, $dfd224a6de0d40aa$var$period = 0.3;
var $dfd224a6de0d40aa$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $dfd224a6de0d40aa$var$tau);
    function elasticIn(t) {
        return a * (0, $blcDf.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $dfd224a6de0d40aa$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($dfd224a6de0d40aa$var$amplitude, $dfd224a6de0d40aa$var$period);
var $dfd224a6de0d40aa$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $dfd224a6de0d40aa$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $blcDf.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $dfd224a6de0d40aa$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($dfd224a6de0d40aa$var$amplitude, $dfd224a6de0d40aa$var$period);
var $dfd224a6de0d40aa$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $dfd224a6de0d40aa$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $blcDf.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $blcDf.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $dfd224a6de0d40aa$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($dfd224a6de0d40aa$var$amplitude, $dfd224a6de0d40aa$var$period);

});


parcelRegister("i6mn5", function(module, exports) {

$parcel$export(module.exports, "blob", () => (parcelRequire("kSOid")).default);
$parcel$export(module.exports, "buffer", () => (parcelRequire("cTWHr")).default);
$parcel$export(module.exports, "dsv", () => (parcelRequire("2UNKH")).default);
$parcel$export(module.exports, "csv", () => (parcelRequire("2UNKH")).csv);
$parcel$export(module.exports, "tsv", () => (parcelRequire("2UNKH")).tsv);
$parcel$export(module.exports, "image", () => (parcelRequire("4TUUE")).default);
$parcel$export(module.exports, "json", () => (parcelRequire("ixyrJ")).default);
$parcel$export(module.exports, "text", () => (parcelRequire("660ZC")).default);
$parcel$export(module.exports, "xml", () => (parcelRequire("fmsQP")).default);
$parcel$export(module.exports, "html", () => (parcelRequire("fmsQP")).html);
$parcel$export(module.exports, "svg", () => (parcelRequire("fmsQP")).svg);

var $kSOid = parcelRequire("kSOid");

var $cTWHr = parcelRequire("cTWHr");

var $2UNKH = parcelRequire("2UNKH");

var $4TUUE = parcelRequire("4TUUE");

var $ixyrJ = parcelRequire("ixyrJ");

var $660ZC = parcelRequire("660ZC");

var $fmsQP = parcelRequire("fmsQP");

});
parcelRegister("kSOid", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33fdce3fa3ac2c0$export$2e2bcd8739ae039);
function $f33fdce3fa3ac2c0$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $f33fdce3fa3ac2c0$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($f33fdce3fa3ac2c0$var$responseBlob);
}

});

parcelRegister("cTWHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $964827a3f8b3aa67$export$2e2bcd8739ae039);
function $964827a3f8b3aa67$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $964827a3f8b3aa67$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($964827a3f8b3aa67$var$responseArrayBuffer);
}

});

parcelRegister("2UNKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $21f7677ae400b504$export$2e2bcd8739ae039);
$parcel$export(module.exports, "csv", () => $21f7677ae400b504$export$901ba78aa04f49da);
$parcel$export(module.exports, "tsv", () => $21f7677ae400b504$export$580b2de76423ff18);

var $iya4m = parcelRequire("iya4m");
var $i20GR = parcelRequire("i20GR");
var $95QRk = parcelRequire("95QRk");

var $660ZC = parcelRequire("660ZC");
function $21f7677ae400b504$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $660ZC.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $21f7677ae400b504$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $i20GR.default)(delimiter);
    return (0, $660ZC.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $21f7677ae400b504$export$901ba78aa04f49da = $21f7677ae400b504$var$dsvParse((0, $iya4m.csvParse));
var $21f7677ae400b504$export$580b2de76423ff18 = $21f7677ae400b504$var$dsvParse((0, $95QRk.tsvParse));

});
parcelRegister("660ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $470412c4cf33f115$export$2e2bcd8739ae039);
function $470412c4cf33f115$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $470412c4cf33f115$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($470412c4cf33f115$var$responseText);
}

});


parcelRegister("4TUUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $39187224dcb0c1a8$export$2e2bcd8739ae039);
function $39187224dcb0c1a8$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}

});

parcelRegister("ixyrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f6075f4fb152b3$export$2e2bcd8739ae039);
function $d7f6075f4fb152b3$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $d7f6075f4fb152b3$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($d7f6075f4fb152b3$var$responseJson);
}

});

parcelRegister("fmsQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ef4a4a8d8bf447$export$2e2bcd8739ae039);
$parcel$export(module.exports, "html", () => $b2ef4a4a8d8bf447$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $b2ef4a4a8d8bf447$export$7ed1367e7fa1ad68);

var $660ZC = parcelRequire("660ZC");
function $b2ef4a4a8d8bf447$var$parser(type) {
    return (input, init)=>(0, $660ZC.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
var $b2ef4a4a8d8bf447$export$2e2bcd8739ae039 = $b2ef4a4a8d8bf447$var$parser("application/xml");
var $b2ef4a4a8d8bf447$export$c0bb0b647f701bb5 = $b2ef4a4a8d8bf447$var$parser("text/html");
var $b2ef4a4a8d8bf447$export$7ed1367e7fa1ad68 = $b2ef4a4a8d8bf447$var$parser("image/svg+xml");

});


parcelRegister("f4uLp", function(module, exports) {

$parcel$export(module.exports, "forceCenter", () => (parcelRequire("i2so7")).default);
$parcel$export(module.exports, "forceCollide", () => (parcelRequire("1V8eg")).default);
$parcel$export(module.exports, "forceLink", () => (parcelRequire("3vbGI")).default);
$parcel$export(module.exports, "forceManyBody", () => (parcelRequire("gUCyw")).default);
$parcel$export(module.exports, "forceRadial", () => (parcelRequire("h2CLN")).default);
$parcel$export(module.exports, "forceSimulation", () => (parcelRequire("1US8R")).default);
$parcel$export(module.exports, "forceX", () => (parcelRequire("1XIxx")).default);
$parcel$export(module.exports, "forceY", () => (parcelRequire("fEp5o")).default);

var $i2so7 = parcelRequire("i2so7");

var $1V8eg = parcelRequire("1V8eg");

var $3vbGI = parcelRequire("3vbGI");

var $gUCyw = parcelRequire("gUCyw");

var $h2CLN = parcelRequire("h2CLN");

var $1US8R = parcelRequire("1US8R");

var $1XIxx = parcelRequire("1XIxx");

var $fEp5o = parcelRequire("fEp5o");

});
parcelRegister("i2so7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21e6f27f1aea50a$export$2e2bcd8739ae039);
function $d21e6f27f1aea50a$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

});

parcelRegister("1V8eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $16617f740a79a41e$export$2e2bcd8739ae039);

var $20E0v = parcelRequire("20E0v");

var $faXzJ = parcelRequire("faXzJ");

var $5IsZ6 = parcelRequire("5IsZ6");
function $16617f740a79a41e$var$x(d) {
    return d.x + d.vx;
}
function $16617f740a79a41e$var$y(d) {
    return d.y + d.vy;
}
function $16617f740a79a41e$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $faXzJ.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $20E0v.default)(nodes, $16617f740a79a41e$var$x, $16617f740a79a41e$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $5IsZ6.default)(random), l += x * x;
                        if (y === 0) y = (0, $5IsZ6.default)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("20E0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $176a9d707be7649d$export$2e2bcd8739ae039);

var $eJZ7i = parcelRequire("eJZ7i");

var $8iFLz = parcelRequire("8iFLz");

var $feelG = parcelRequire("feelG");

var $j6J1D = parcelRequire("j6J1D");

var $U9bjB = parcelRequire("U9bjB");

var $gmUXU = parcelRequire("gmUXU");

var $91Otj = parcelRequire("91Otj");

var $1Z4qz = parcelRequire("1Z4qz");

var $98jEA = parcelRequire("98jEA");

var $7wVg6 = parcelRequire("7wVg6");

var $7kcho = parcelRequire("7kcho");

var $4S3yS = parcelRequire("4S3yS");
function $176a9d707be7649d$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $176a9d707be7649d$var$Quadtree(x == null ? (0, $7kcho.defaultX) : x, y == null ? (0, $4S3yS.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $176a9d707be7649d$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $176a9d707be7649d$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $176a9d707be7649d$var$treeProto = $176a9d707be7649d$export$2e2bcd8739ae039.prototype = $176a9d707be7649d$var$Quadtree.prototype;
$176a9d707be7649d$var$treeProto.copy = function() {
    var copy = new $176a9d707be7649d$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $176a9d707be7649d$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $176a9d707be7649d$var$leaf_copy(child);
        }
    }
    return copy;
};
$176a9d707be7649d$var$treeProto.add = (0, $eJZ7i.default);
$176a9d707be7649d$var$treeProto.addAll = (0, $eJZ7i.addAll);
$176a9d707be7649d$var$treeProto.cover = (0, $8iFLz.default);
$176a9d707be7649d$var$treeProto.data = (0, $feelG.default);
$176a9d707be7649d$var$treeProto.extent = (0, $j6J1D.default);
$176a9d707be7649d$var$treeProto.find = (0, $U9bjB.default);
$176a9d707be7649d$var$treeProto.remove = (0, $gmUXU.default);
$176a9d707be7649d$var$treeProto.removeAll = (0, $gmUXU.removeAll);
$176a9d707be7649d$var$treeProto.root = (0, $91Otj.default);
$176a9d707be7649d$var$treeProto.size = (0, $1Z4qz.default);
$176a9d707be7649d$var$treeProto.visit = (0, $98jEA.default);
$176a9d707be7649d$var$treeProto.visitAfter = (0, $7wVg6.default);
$176a9d707be7649d$var$treeProto.x = (0, $7kcho.default);
$176a9d707be7649d$var$treeProto.y = (0, $4S3yS.default);

});
parcelRegister("eJZ7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb4ad23a7520cc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $abb4ad23a7520cc9$export$32ed0561867ec8a1);
function $abb4ad23a7520cc9$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $abb4ad23a7520cc9$var$add(this.cover(x, y), x, y, d);
}
function $abb4ad23a7520cc9$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $abb4ad23a7520cc9$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$abb4ad23a7520cc9$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("8iFLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b06717631a5864$export$2e2bcd8739ae039);
function $60b06717631a5864$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("feelG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1634b282283046e$export$2e2bcd8739ae039);
function $b1634b282283046e$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("j6J1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9180f66f227648$export$2e2bcd8739ae039);
function $de9180f66f227648$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("U9bjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8c5a55257ec86d$export$2e2bcd8739ae039);

var $dzp40 = parcelRequire("dzp40");
function $0a8c5a55257ec86d$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $dzp40.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $dzp40.default)(node[3], xm, ym, x2, y2), new (0, $dzp40.default)(node[2], x1, ym, xm, y2), new (0, $dzp40.default)(node[1], xm, y1, x2, ym), new (0, $dzp40.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("dzp40", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e11fc5580f906e9$export$2e2bcd8739ae039);
function $9e11fc5580f906e9$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("gmUXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beaae38ea3a783e5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $beaae38ea3a783e5$export$1cfc7aad5cb1833b);
function $beaae38ea3a783e5$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $beaae38ea3a783e5$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("91Otj", function(module, exports) {

$parcel$export(module.exports, "default", () => $692b5bb4b08d5af1$export$2e2bcd8739ae039);
function $692b5bb4b08d5af1$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("1Z4qz", function(module, exports) {

$parcel$export(module.exports, "default", () => $171eec2e15d783d6$export$2e2bcd8739ae039);
function $171eec2e15d783d6$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("98jEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a641b370f431f0f$export$2e2bcd8739ae039);

var $dzp40 = parcelRequire("dzp40");
function $6a641b370f431f0f$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $dzp40.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $dzp40.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $dzp40.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $dzp40.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $dzp40.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("7wVg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b7eff03e723e0a$export$2e2bcd8739ae039);

var $dzp40 = parcelRequire("dzp40");
function $57b7eff03e723e0a$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $dzp40.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $dzp40.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $dzp40.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $dzp40.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $dzp40.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("7kcho", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $5553ed220a1db0cc$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $5553ed220a1db0cc$export$2e2bcd8739ae039);
function $5553ed220a1db0cc$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $5553ed220a1db0cc$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("4S3yS", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $38bef7d579dd74a0$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $38bef7d579dd74a0$export$2e2bcd8739ae039);
function $38bef7d579dd74a0$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $38bef7d579dd74a0$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});


parcelRegister("faXzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c60094c4e5ab4f$export$2e2bcd8739ae039);
function $b0c60094c4e5ab4f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("5IsZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $42978b8f5143e198$export$2e2bcd8739ae039);
function $42978b8f5143e198$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}

});


parcelRegister("3vbGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cd5555a10e77f9$export$2e2bcd8739ae039);

var $faXzJ = parcelRequire("faXzJ");

var $5IsZ6 = parcelRequire("5IsZ6");
function $28cd5555a10e77f9$var$index(d) {
    return d.index;
}
function $28cd5555a10e77f9$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $28cd5555a10e77f9$export$2e2bcd8739ae039(links) {
    var id = $28cd5555a10e77f9$var$index, strength = defaultStrength, strengths, distance = (0, $faXzJ.default)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $5IsZ6.default)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $5IsZ6.default)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $28cd5555a10e77f9$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $28cd5555a10e77f9$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});

parcelRegister("gUCyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4ffc8b1ad0aa126$export$2e2bcd8739ae039);

var $20E0v = parcelRequire("20E0v");

var $faXzJ = parcelRequire("faXzJ");

var $5IsZ6 = parcelRequire("5IsZ6");

var $1US8R = parcelRequire("1US8R");
function $c4ffc8b1ad0aa126$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $faXzJ.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $20E0v.default)(nodes, (0, $1US8R.x), (0, $1US8R.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $5IsZ6.default)(random), l += x * x;
                if (y === 0) y = (0, $5IsZ6.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $5IsZ6.default)(random), l += x * x;
            if (y === 0) y = (0, $5IsZ6.default)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("1US8R", function(module, exports) {

$parcel$export(module.exports, "x", () => $165504e02711ec22$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $165504e02711ec22$export$4a5767248b18ef41);
$parcel$export(module.exports, "default", () => $165504e02711ec22$export$2e2bcd8739ae039);

var $2LbPR = parcelRequire("2LbPR");

var $knAOt = parcelRequire("knAOt");

var $khqbD = parcelRequire("khqbD");
function $165504e02711ec22$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $165504e02711ec22$export$4a5767248b18ef41(d) {
    return d.y;
}
var $165504e02711ec22$var$initialRadius = 10, $165504e02711ec22$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $165504e02711ec22$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $knAOt.timer)(step), event = (0, $2LbPR.default)("tick", "end"), random = (0, $khqbD.default)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $165504e02711ec22$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $165504e02711ec22$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});
parcelRegister("khqbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec39b5535166de09$export$2e2bcd8739ae039);
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $ec39b5535166de09$var$a = 1664525;
const $ec39b5535166de09$var$c = 1013904223;
const $ec39b5535166de09$var$m = 4294967296; // 2^32
function $ec39b5535166de09$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($ec39b5535166de09$var$a * s + $ec39b5535166de09$var$c) % $ec39b5535166de09$var$m) / $ec39b5535166de09$var$m;
}

});



parcelRegister("h2CLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c680b27bd6a9477b$export$2e2bcd8739ae039);

var $faXzJ = parcelRequire("faXzJ");
function $c680b27bd6a9477b$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $faXzJ.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $faXzJ.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("1XIxx", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ddd9d8399c88d5$export$2e2bcd8739ae039);

var $faXzJ = parcelRequire("faXzJ");
function $16ddd9d8399c88d5$export$2e2bcd8739ae039(x) {
    var strength = (0, $faXzJ.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $faXzJ.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("fEp5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64e0d02b1c7b1b9$export$2e2bcd8739ae039);

var $faXzJ = parcelRequire("faXzJ");
function $b64e0d02b1c7b1b9$export$2e2bcd8739ae039(y) {
    var strength = (0, $faXzJ.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $faXzJ.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $faXzJ.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("9o5I9", function(module, exports) {

$parcel$export(module.exports, "formatDefaultLocale", () => (parcelRequire("2qeEX")).default);
$parcel$export(module.exports, "format", () => (parcelRequire("2qeEX")).format);
$parcel$export(module.exports, "formatPrefix", () => (parcelRequire("2qeEX")).formatPrefix);
$parcel$export(module.exports, "formatLocale", () => (parcelRequire("5W8Ax")).default);
$parcel$export(module.exports, "formatSpecifier", () => (parcelRequire("bXv5i")).default);
$parcel$export(module.exports, "FormatSpecifier", () => (parcelRequire("bXv5i")).FormatSpecifier);
$parcel$export(module.exports, "precisionFixed", () => (parcelRequire("6ADyx")).default);
$parcel$export(module.exports, "precisionPrefix", () => (parcelRequire("5N6Cc")).default);
$parcel$export(module.exports, "precisionRound", () => (parcelRequire("aGLXt")).default);

var $2qeEX = parcelRequire("2qeEX");

var $5W8Ax = parcelRequire("5W8Ax");

var $bXv5i = parcelRequire("bXv5i");

var $6ADyx = parcelRequire("6ADyx");

var $5N6Cc = parcelRequire("5N6Cc");

var $aGLXt = parcelRequire("aGLXt");

});
parcelRegister("2qeEX", function(module, exports) {

$parcel$export(module.exports, "format", () => $1c39618f652fafda$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $1c39618f652fafda$export$8d85692a469dde6f);
$parcel$export(module.exports, "default", () => $1c39618f652fafda$export$2e2bcd8739ae039);

var $5W8Ax = parcelRequire("5W8Ax");
var $1c39618f652fafda$var$locale;
var $1c39618f652fafda$export$d9468344d3651243;
var $1c39618f652fafda$export$8d85692a469dde6f;
$1c39618f652fafda$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $1c39618f652fafda$export$2e2bcd8739ae039(definition) {
    $1c39618f652fafda$var$locale = (0, $5W8Ax.default)(definition);
    $1c39618f652fafda$export$d9468344d3651243 = $1c39618f652fafda$var$locale.format;
    $1c39618f652fafda$export$8d85692a469dde6f = $1c39618f652fafda$var$locale.formatPrefix;
    return $1c39618f652fafda$var$locale;
}

});
parcelRegister("5W8Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $452907fe8a223992$export$2e2bcd8739ae039);

var $7ndQc = parcelRequire("7ndQc");

var $dsHkB = parcelRequire("dsHkB");

var $iyoNi = parcelRequire("iyoNi");

var $bXv5i = parcelRequire("bXv5i");

var $gWMct = parcelRequire("gWMct");

var $drjCn = parcelRequire("drjCn");

var $6A49c = parcelRequire("6A49c");

var $hIhHF = parcelRequire("hIhHF");
var $452907fe8a223992$var$map = Array.prototype.map, $452907fe8a223992$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $452907fe8a223992$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $hIhHF.default) : (0, $dsHkB.default)($452907fe8a223992$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $hIhHF.default) : (0, $iyoNi.default)($452907fe8a223992$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $bXv5i.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $drjCn.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $drjCn.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $gWMct.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $452907fe8a223992$var$prefixes[8 + (0, $6A49c.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $bXv5i.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $7ndQc.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $452907fe8a223992$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("7ndQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e56ae29ca19dc3$export$2e2bcd8739ae039);

var $dnVpa = parcelRequire("dnVpa");
function $55e56ae29ca19dc3$export$2e2bcd8739ae039(x) {
    return x = (0, $dnVpa.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("dnVpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be9f3c2b88edd4a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $9be9f3c2b88edd4a$export$8f8e23dd27dc19f5);
function $9be9f3c2b88edd4a$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $9be9f3c2b88edd4a$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("dsHkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccf809aafe43d27$export$2e2bcd8739ae039);
function $9ccf809aafe43d27$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("iyoNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81ea28dea4433e6$export$2e2bcd8739ae039);
function $d81ea28dea4433e6$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("bXv5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4d51180f0f9375$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FormatSpecifier", () => $8b4d51180f0f9375$export$963aac351db36ed4);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $8b4d51180f0f9375$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $8b4d51180f0f9375$export$2e2bcd8739ae039(specifier) {
    if (!(match = $8b4d51180f0f9375$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $8b4d51180f0f9375$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$8b4d51180f0f9375$export$2e2bcd8739ae039.prototype = $8b4d51180f0f9375$export$963aac351db36ed4.prototype; // instanceof
function $8b4d51180f0f9375$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$8b4d51180f0f9375$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("gWMct", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56773ad03160313$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $c56773ad03160313$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("drjCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8d03b643a524cf$export$2e2bcd8739ae039);

var $dnVpa = parcelRequire("dnVpa");

var $6A49c = parcelRequire("6A49c");

var $lrBZb = parcelRequire("lrBZb");
var $9c8d03b643a524cf$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $dnVpa.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $lrBZb.default)(x * 100, p),
    "r": (0, $lrBZb.default),
    "s": (0, $6A49c.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("6A49c", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $4ca9527382d58238$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $4ca9527382d58238$export$2e2bcd8739ae039);

var $dnVpa = parcelRequire("dnVpa");
var $4ca9527382d58238$export$6863724d9a42263;
function $4ca9527382d58238$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dnVpa.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4ca9527382d58238$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $dnVpa.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lrBZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c995c249193f8a$export$2e2bcd8739ae039);

var $dnVpa = parcelRequire("dnVpa");
function $f9c995c249193f8a$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dnVpa.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("hIhHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce54473f30d17710$export$2e2bcd8739ae039);
function $ce54473f30d17710$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("6ADyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc4c9db8fec824f$export$2e2bcd8739ae039);

var $7ndQc = parcelRequire("7ndQc");
function $4cc4c9db8fec824f$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $7ndQc.default)(Math.abs(step)));
}

});

parcelRegister("5N6Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4376a9008781ee02$export$2e2bcd8739ae039);

var $7ndQc = parcelRequire("7ndQc");
function $4376a9008781ee02$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $7ndQc.default)(value) / 3))) * 3 - (0, $7ndQc.default)(Math.abs(step)));
}

});

parcelRegister("aGLXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c8307237dbd6dbf$export$2e2bcd8739ae039);

var $7ndQc = parcelRequire("7ndQc");
function $7c8307237dbd6dbf$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $7ndQc.default)(max) - (0, $7ndQc.default)(step)) + 1;
}

});


parcelRegister("lE4ix", function(module, exports) {

$parcel$export(module.exports, "geoArea", () => (parcelRequire("9EdcX")).default);
$parcel$export(module.exports, "geoBounds", () => (parcelRequire("jfeHP")).default);
$parcel$export(module.exports, "geoCentroid", () => (parcelRequire("e8asm")).default);
$parcel$export(module.exports, "geoCircle", () => (parcelRequire("1SbW0")).default);
$parcel$export(module.exports, "geoClipAntimeridian", () => (parcelRequire("iRL8s")).default);
$parcel$export(module.exports, "geoClipCircle", () => (parcelRequire("1rmrh")).default);
$parcel$export(module.exports, "geoClipExtent", () => (parcelRequire("3tz05")).default);
$parcel$export(module.exports, "geoClipRectangle", () => (parcelRequire("2LCTV")).default);
$parcel$export(module.exports, "geoContains", () => (parcelRequire("6NN2H")).default);
$parcel$export(module.exports, "geoDistance", () => (parcelRequire("d9z72")).default);
$parcel$export(module.exports, "geoGraticule", () => (parcelRequire("h1BuA")).default);
$parcel$export(module.exports, "geoGraticule10", () => (parcelRequire("h1BuA")).graticule10);
$parcel$export(module.exports, "geoInterpolate", () => (parcelRequire("gcJnD")).default);
$parcel$export(module.exports, "geoLength", () => (parcelRequire("cBQFi")).default);
$parcel$export(module.exports, "geoPath", () => (parcelRequire("ijkmu")).default);
$parcel$export(module.exports, "geoAlbers", () => (parcelRequire("24RUV")).default);
$parcel$export(module.exports, "geoAlbersUsa", () => (parcelRequire("e9sev")).default);
$parcel$export(module.exports, "geoAzimuthalEqualArea", () => (parcelRequire("c6L2S")).default);
$parcel$export(module.exports, "geoAzimuthalEqualAreaRaw", () => (parcelRequire("c6L2S")).azimuthalEqualAreaRaw);
$parcel$export(module.exports, "geoAzimuthalEquidistant", () => (parcelRequire("ewvEK")).default);
$parcel$export(module.exports, "geoAzimuthalEquidistantRaw", () => (parcelRequire("ewvEK")).azimuthalEquidistantRaw);
$parcel$export(module.exports, "geoConicConformal", () => (parcelRequire("bsnCY")).default);
$parcel$export(module.exports, "geoConicConformalRaw", () => (parcelRequire("bsnCY")).conicConformalRaw);
$parcel$export(module.exports, "geoConicEqualArea", () => (parcelRequire("9RZwn")).default);
$parcel$export(module.exports, "geoConicEqualAreaRaw", () => (parcelRequire("9RZwn")).conicEqualAreaRaw);
$parcel$export(module.exports, "geoConicEquidistant", () => (parcelRequire("hgI6X")).default);
$parcel$export(module.exports, "geoConicEquidistantRaw", () => (parcelRequire("hgI6X")).conicEquidistantRaw);
$parcel$export(module.exports, "geoEqualEarth", () => (parcelRequire("6ZOLm")).default);
$parcel$export(module.exports, "geoEqualEarthRaw", () => (parcelRequire("6ZOLm")).equalEarthRaw);
$parcel$export(module.exports, "geoEquirectangular", () => (parcelRequire("hkLJu")).default);
$parcel$export(module.exports, "geoEquirectangularRaw", () => (parcelRequire("hkLJu")).equirectangularRaw);
$parcel$export(module.exports, "geoGnomonic", () => (parcelRequire("ePN5V")).default);
$parcel$export(module.exports, "geoGnomonicRaw", () => (parcelRequire("ePN5V")).gnomonicRaw);
$parcel$export(module.exports, "geoIdentity", () => (parcelRequire("e1PVd")).default);
$parcel$export(module.exports, "geoProjection", () => (parcelRequire("k6OY5")).default);
$parcel$export(module.exports, "geoProjectionMutator", () => (parcelRequire("k6OY5")).projectionMutator);
$parcel$export(module.exports, "geoMercator", () => (parcelRequire("2XkiJ")).default);
$parcel$export(module.exports, "geoMercatorRaw", () => (parcelRequire("2XkiJ")).mercatorRaw);
$parcel$export(module.exports, "geoNaturalEarth1", () => (parcelRequire("ibFeJ")).default);
$parcel$export(module.exports, "geoNaturalEarth1Raw", () => (parcelRequire("ibFeJ")).naturalEarth1Raw);
$parcel$export(module.exports, "geoOrthographic", () => (parcelRequire("gYyBI")).default);
$parcel$export(module.exports, "geoOrthographicRaw", () => (parcelRequire("gYyBI")).orthographicRaw);
$parcel$export(module.exports, "geoStereographic", () => (parcelRequire("iuncC")).default);
$parcel$export(module.exports, "geoStereographicRaw", () => (parcelRequire("iuncC")).stereographicRaw);
$parcel$export(module.exports, "geoTransverseMercator", () => (parcelRequire("bjR5r")).default);
$parcel$export(module.exports, "geoTransverseMercatorRaw", () => (parcelRequire("bjR5r")).transverseMercatorRaw);
$parcel$export(module.exports, "geoRotation", () => (parcelRequire("7k5xN")).default);
$parcel$export(module.exports, "geoStream", () => (parcelRequire("cLMeO")).default);
$parcel$export(module.exports, "geoTransform", () => (parcelRequire("bit3e")).default);

var $9EdcX = parcelRequire("9EdcX");

var $jfeHP = parcelRequire("jfeHP");

var $e8asm = parcelRequire("e8asm");

var $1SbW0 = parcelRequire("1SbW0");

var $iRL8s = parcelRequire("iRL8s");

var $1rmrh = parcelRequire("1rmrh");

var $3tz05 = parcelRequire("3tz05");

var $2LCTV = parcelRequire("2LCTV");

var $6NN2H = parcelRequire("6NN2H");

var $d9z72 = parcelRequire("d9z72");

var $h1BuA = parcelRequire("h1BuA");

var $gcJnD = parcelRequire("gcJnD");

var $cBQFi = parcelRequire("cBQFi");

var $ijkmu = parcelRequire("ijkmu");

var $24RUV = parcelRequire("24RUV");

var $e9sev = parcelRequire("e9sev");

var $c6L2S = parcelRequire("c6L2S");

var $ewvEK = parcelRequire("ewvEK");

var $bsnCY = parcelRequire("bsnCY");

var $9RZwn = parcelRequire("9RZwn");

var $hgI6X = parcelRequire("hgI6X");

var $6ZOLm = parcelRequire("6ZOLm");

var $hkLJu = parcelRequire("hkLJu");

var $ePN5V = parcelRequire("ePN5V");

var $e1PVd = parcelRequire("e1PVd");

var $k6OY5 = parcelRequire("k6OY5");

var $2XkiJ = parcelRequire("2XkiJ");

var $ibFeJ = parcelRequire("ibFeJ");

var $gYyBI = parcelRequire("gYyBI");

var $iuncC = parcelRequire("iuncC");

var $bjR5r = parcelRequire("bjR5r");

var $7k5xN = parcelRequire("7k5xN");

var $cLMeO = parcelRequire("cLMeO");

var $bit3e = parcelRequire("bit3e");

});
parcelRegister("9EdcX", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", () => $7062184cafc7bff3$export$bf8f994332070c7f);
$parcel$export(module.exports, "areaStream", () => $7062184cafc7bff3$export$cb67cfa750ae69dc);
$parcel$export(module.exports, "default", () => $7062184cafc7bff3$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");

var $cLMeO = parcelRequire("cLMeO");
var $7062184cafc7bff3$export$bf8f994332070c7f = new (0, $loqCp.Adder)();
// hello?
var $7062184cafc7bff3$var$areaSum = new (0, $loqCp.Adder)(), $7062184cafc7bff3$var$lambda00, $7062184cafc7bff3$var$phi00, $7062184cafc7bff3$var$lambda0, $7062184cafc7bff3$var$cosPhi0, $7062184cafc7bff3$var$sinPhi0;
var $7062184cafc7bff3$export$cb67cfa750ae69dc = {
    point: (0, $e88Rm.default),
    lineStart: (0, $e88Rm.default),
    lineEnd: (0, $e88Rm.default),
    polygonStart: function() {
        $7062184cafc7bff3$export$bf8f994332070c7f = new (0, $loqCp.Adder)();
        $7062184cafc7bff3$export$cb67cfa750ae69dc.lineStart = $7062184cafc7bff3$var$areaRingStart;
        $7062184cafc7bff3$export$cb67cfa750ae69dc.lineEnd = $7062184cafc7bff3$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$7062184cafc7bff3$export$bf8f994332070c7f;
        $7062184cafc7bff3$var$areaSum.add(areaRing < 0 ? (0, $6pzD4.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $e88Rm.default);
    },
    sphere: function() {
        $7062184cafc7bff3$var$areaSum.add((0, $6pzD4.tau));
    }
};
function $7062184cafc7bff3$var$areaRingStart() {
    $7062184cafc7bff3$export$cb67cfa750ae69dc.point = $7062184cafc7bff3$var$areaPointFirst;
}
function $7062184cafc7bff3$var$areaRingEnd() {
    $7062184cafc7bff3$var$areaPoint($7062184cafc7bff3$var$lambda00, $7062184cafc7bff3$var$phi00);
}
function $7062184cafc7bff3$var$areaPointFirst(lambda, phi) {
    $7062184cafc7bff3$export$cb67cfa750ae69dc.point = $7062184cafc7bff3$var$areaPoint;
    $7062184cafc7bff3$var$lambda00 = lambda, $7062184cafc7bff3$var$phi00 = phi;
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    $7062184cafc7bff3$var$lambda0 = lambda, $7062184cafc7bff3$var$cosPhi0 = (0, $6pzD4.cos)(phi = phi / 2 + (0, $6pzD4.quarterPi)), $7062184cafc7bff3$var$sinPhi0 = (0, $6pzD4.sin)(phi);
}
function $7062184cafc7bff3$var$areaPoint(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    phi = phi / 2 + (0, $6pzD4.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $7062184cafc7bff3$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $6pzD4.cos)(phi), sinPhi = (0, $6pzD4.sin)(phi), k = $7062184cafc7bff3$var$sinPhi0 * sinPhi, u = $7062184cafc7bff3$var$cosPhi0 * cosPhi + k * (0, $6pzD4.cos)(adLambda), v = k * sdLambda * (0, $6pzD4.sin)(adLambda);
    $7062184cafc7bff3$export$bf8f994332070c7f.add((0, $6pzD4.atan2)(v, u));
    // Advance the previous points.
    $7062184cafc7bff3$var$lambda0 = lambda, $7062184cafc7bff3$var$cosPhi0 = cosPhi, $7062184cafc7bff3$var$sinPhi0 = sinPhi;
}
function $7062184cafc7bff3$export$2e2bcd8739ae039(object) {
    $7062184cafc7bff3$var$areaSum = new (0, $loqCp.Adder)();
    (0, $cLMeO.default)(object, $7062184cafc7bff3$export$cb67cfa750ae69dc);
    return $7062184cafc7bff3$var$areaSum * 2;
}

});
parcelRegister("6pzD4", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => $4ab0b718a1109ae7$export$6c421550c66a327d);
$parcel$export(module.exports, "epsilon2", () => $4ab0b718a1109ae7$export$92c06fba281fe81b);
$parcel$export(module.exports, "pi", () => $4ab0b718a1109ae7$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $4ab0b718a1109ae7$export$e51408a300e8929a);
$parcel$export(module.exports, "quarterPi", () => $4ab0b718a1109ae7$export$c39a5cba78ea0fc2);
$parcel$export(module.exports, "tau", () => $4ab0b718a1109ae7$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "degrees", () => $4ab0b718a1109ae7$export$41fc368e1a942b97);
$parcel$export(module.exports, "radians", () => $4ab0b718a1109ae7$export$8449e153fbd325fc);
$parcel$export(module.exports, "abs", () => $4ab0b718a1109ae7$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan", () => $4ab0b718a1109ae7$export$628dc4eed22b0fbd);
$parcel$export(module.exports, "atan2", () => $4ab0b718a1109ae7$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $4ab0b718a1109ae7$export$50d414a77b60d802);
$parcel$export(module.exports, "ceil", () => $4ab0b718a1109ae7$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "exp", () => $4ab0b718a1109ae7$export$b310ec824aaee37f);
$parcel$export(module.exports, "hypot", () => $4ab0b718a1109ae7$export$f95c7888b62f8e9a);
$parcel$export(module.exports, "log", () => $4ab0b718a1109ae7$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "pow", () => $4ab0b718a1109ae7$export$9c297f60e22e3389);
$parcel$export(module.exports, "sin", () => $4ab0b718a1109ae7$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sign", () => $4ab0b718a1109ae7$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "sqrt", () => $4ab0b718a1109ae7$export$eba8049fb5020b81);
$parcel$export(module.exports, "tan", () => $4ab0b718a1109ae7$export$fcdd3b0b3246a325);
$parcel$export(module.exports, "acos", () => $4ab0b718a1109ae7$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $4ab0b718a1109ae7$export$41726bdb1fc63f);
$parcel$export(module.exports, "haversin", () => $4ab0b718a1109ae7$export$e808712c2966e662);
var $4ab0b718a1109ae7$export$6c421550c66a327d = 1e-6;
var $4ab0b718a1109ae7$export$92c06fba281fe81b = 1e-12;
var $4ab0b718a1109ae7$export$18c7bea995a110f = Math.PI;
var $4ab0b718a1109ae7$export$e51408a300e8929a = $4ab0b718a1109ae7$export$18c7bea995a110f / 2;
var $4ab0b718a1109ae7$export$c39a5cba78ea0fc2 = $4ab0b718a1109ae7$export$18c7bea995a110f / 4;
var $4ab0b718a1109ae7$export$a4b4b4d4d776fe92 = $4ab0b718a1109ae7$export$18c7bea995a110f * 2;
var $4ab0b718a1109ae7$export$41fc368e1a942b97 = 180 / $4ab0b718a1109ae7$export$18c7bea995a110f;
var $4ab0b718a1109ae7$export$8449e153fbd325fc = $4ab0b718a1109ae7$export$18c7bea995a110f / 180;
var $4ab0b718a1109ae7$export$2335f513bbd82c6d = Math.abs;
var $4ab0b718a1109ae7$export$628dc4eed22b0fbd = Math.atan;
var $4ab0b718a1109ae7$export$b8b770ee6a0d9760 = Math.atan2;
var $4ab0b718a1109ae7$export$50d414a77b60d802 = Math.cos;
var $4ab0b718a1109ae7$export$803ce6b71a0a94b2 = Math.ceil;
var $4ab0b718a1109ae7$export$b310ec824aaee37f = Math.exp;
var $4ab0b718a1109ae7$export$a3fe094919f356fd = Math.floor;
var $4ab0b718a1109ae7$export$f95c7888b62f8e9a = Math.hypot;
var $4ab0b718a1109ae7$export$bef1f36f5486a6a3 = Math.log;
var $4ab0b718a1109ae7$export$9c297f60e22e3389 = Math.pow;
var $4ab0b718a1109ae7$export$5de3937cb4b592ed = Math.sin;
var $4ab0b718a1109ae7$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $4ab0b718a1109ae7$export$eba8049fb5020b81 = Math.sqrt;
var $4ab0b718a1109ae7$export$fcdd3b0b3246a325 = Math.tan;
function $4ab0b718a1109ae7$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $4ab0b718a1109ae7$export$18c7bea995a110f : Math.acos(x);
}
function $4ab0b718a1109ae7$export$41726bdb1fc63f(x) {
    return x > 1 ? $4ab0b718a1109ae7$export$e51408a300e8929a : x < -1 ? -$4ab0b718a1109ae7$export$e51408a300e8929a : Math.asin(x);
}
function $4ab0b718a1109ae7$export$e808712c2966e662(x) {
    return (x = $4ab0b718a1109ae7$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("e88Rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a498af5caa77857c$export$2e2bcd8739ae039);
function $a498af5caa77857c$export$2e2bcd8739ae039() {}

});

parcelRegister("cLMeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $94bf4ae05acdc96f$export$2e2bcd8739ae039);
function $94bf4ae05acdc96f$var$streamGeometry(geometry, stream) {
    if (geometry && $94bf4ae05acdc96f$var$streamGeometryType.hasOwnProperty(geometry.type)) $94bf4ae05acdc96f$var$streamGeometryType[geometry.type](geometry, stream);
}
var $94bf4ae05acdc96f$var$streamObjectType = {
    Feature: function(object, stream) {
        $94bf4ae05acdc96f$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$94bf4ae05acdc96f$var$streamGeometry(features[i].geometry, stream);
    }
};
var $94bf4ae05acdc96f$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $94bf4ae05acdc96f$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$94bf4ae05acdc96f$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $94bf4ae05acdc96f$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$94bf4ae05acdc96f$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$94bf4ae05acdc96f$var$streamGeometry(geometries[i], stream);
    }
};
function $94bf4ae05acdc96f$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $94bf4ae05acdc96f$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$94bf4ae05acdc96f$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $94bf4ae05acdc96f$export$2e2bcd8739ae039(object, stream) {
    if (object && $94bf4ae05acdc96f$var$streamObjectType.hasOwnProperty(object.type)) $94bf4ae05acdc96f$var$streamObjectType[object.type](object, stream);
    else $94bf4ae05acdc96f$var$streamGeometry(object, stream);
}

});


parcelRegister("jfeHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e02ad34fa1e8b9aa$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $9EdcX = parcelRequire("9EdcX");

var $ap01U = parcelRequire("ap01U");

var $6pzD4 = parcelRequire("6pzD4");

var $cLMeO = parcelRequire("cLMeO");
var $e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$phi0, $e02ad34fa1e8b9aa$var$lambda1, $e02ad34fa1e8b9aa$var$phi1, $e02ad34fa1e8b9aa$var$lambda2, $e02ad34fa1e8b9aa$var$lambda00, $e02ad34fa1e8b9aa$var$phi00, $e02ad34fa1e8b9aa$var$p0, $e02ad34fa1e8b9aa$var$deltaSum, $e02ad34fa1e8b9aa$var$ranges, $e02ad34fa1e8b9aa$var$range;
var $e02ad34fa1e8b9aa$var$boundsStream = {
    point: $e02ad34fa1e8b9aa$var$boundsPoint,
    lineStart: $e02ad34fa1e8b9aa$var$boundsLineStart,
    lineEnd: $e02ad34fa1e8b9aa$var$boundsLineEnd,
    polygonStart: function() {
        $e02ad34fa1e8b9aa$var$boundsStream.point = $e02ad34fa1e8b9aa$var$boundsRingPoint;
        $e02ad34fa1e8b9aa$var$boundsStream.lineStart = $e02ad34fa1e8b9aa$var$boundsRingStart;
        $e02ad34fa1e8b9aa$var$boundsStream.lineEnd = $e02ad34fa1e8b9aa$var$boundsRingEnd;
        $e02ad34fa1e8b9aa$var$deltaSum = new (0, $loqCp.Adder)();
        (0, $9EdcX.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $9EdcX.areaStream).polygonEnd();
        $e02ad34fa1e8b9aa$var$boundsStream.point = $e02ad34fa1e8b9aa$var$boundsPoint;
        $e02ad34fa1e8b9aa$var$boundsStream.lineStart = $e02ad34fa1e8b9aa$var$boundsLineStart;
        $e02ad34fa1e8b9aa$var$boundsStream.lineEnd = $e02ad34fa1e8b9aa$var$boundsLineEnd;
        if ((0, $9EdcX.areaRingSum) < 0) $e02ad34fa1e8b9aa$var$lambda0 = -($e02ad34fa1e8b9aa$var$lambda1 = 180), $e02ad34fa1e8b9aa$var$phi0 = -($e02ad34fa1e8b9aa$var$phi1 = 90);
        else if ($e02ad34fa1e8b9aa$var$deltaSum > (0, $6pzD4.epsilon)) $e02ad34fa1e8b9aa$var$phi1 = 90;
        else if ($e02ad34fa1e8b9aa$var$deltaSum < -(0, $6pzD4.epsilon)) $e02ad34fa1e8b9aa$var$phi0 = -90;
        $e02ad34fa1e8b9aa$var$range[0] = $e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$range[1] = $e02ad34fa1e8b9aa$var$lambda1;
    },
    sphere: function() {
        $e02ad34fa1e8b9aa$var$lambda0 = -($e02ad34fa1e8b9aa$var$lambda1 = 180), $e02ad34fa1e8b9aa$var$phi0 = -($e02ad34fa1e8b9aa$var$phi1 = 90);
    }
};
function $e02ad34fa1e8b9aa$var$boundsPoint(lambda, phi) {
    $e02ad34fa1e8b9aa$var$ranges.push($e02ad34fa1e8b9aa$var$range = [
        $e02ad34fa1e8b9aa$var$lambda0 = lambda,
        $e02ad34fa1e8b9aa$var$lambda1 = lambda
    ]);
    if (phi < $e02ad34fa1e8b9aa$var$phi0) $e02ad34fa1e8b9aa$var$phi0 = phi;
    if (phi > $e02ad34fa1e8b9aa$var$phi1) $e02ad34fa1e8b9aa$var$phi1 = phi;
}
function $e02ad34fa1e8b9aa$var$linePoint(lambda, phi) {
    var p = (0, $ap01U.cartesian)([
        lambda * (0, $6pzD4.radians),
        phi * (0, $6pzD4.radians)
    ]);
    if ($e02ad34fa1e8b9aa$var$p0) {
        var normal = (0, $ap01U.cartesianCross)($e02ad34fa1e8b9aa$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $ap01U.cartesianCross)(equatorial, normal);
        (0, $ap01U.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $ap01U.spherical)(inflection);
        var delta = lambda - $e02ad34fa1e8b9aa$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $6pzD4.degrees) * sign, phii, antimeridian = (0, $6pzD4.abs)(delta) > 180;
        if (antimeridian ^ (sign * $e02ad34fa1e8b9aa$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $6pzD4.degrees);
            if (phii > $e02ad34fa1e8b9aa$var$phi1) $e02ad34fa1e8b9aa$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $e02ad34fa1e8b9aa$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $6pzD4.degrees);
            if (phii < $e02ad34fa1e8b9aa$var$phi0) $e02ad34fa1e8b9aa$var$phi0 = phii;
        } else {
            if (phi < $e02ad34fa1e8b9aa$var$phi0) $e02ad34fa1e8b9aa$var$phi0 = phi;
            if (phi > $e02ad34fa1e8b9aa$var$phi1) $e02ad34fa1e8b9aa$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $e02ad34fa1e8b9aa$var$lambda2) {
                if ($e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, lambda) > $e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$lambda1)) $e02ad34fa1e8b9aa$var$lambda1 = lambda;
            } else if ($e02ad34fa1e8b9aa$var$angle(lambda, $e02ad34fa1e8b9aa$var$lambda1) > $e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$lambda1)) $e02ad34fa1e8b9aa$var$lambda0 = lambda;
        } else if ($e02ad34fa1e8b9aa$var$lambda1 >= $e02ad34fa1e8b9aa$var$lambda0) {
            if (lambda < $e02ad34fa1e8b9aa$var$lambda0) $e02ad34fa1e8b9aa$var$lambda0 = lambda;
            if (lambda > $e02ad34fa1e8b9aa$var$lambda1) $e02ad34fa1e8b9aa$var$lambda1 = lambda;
        } else {
            if (lambda > $e02ad34fa1e8b9aa$var$lambda2) {
                if ($e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, lambda) > $e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$lambda1)) $e02ad34fa1e8b9aa$var$lambda1 = lambda;
            } else if ($e02ad34fa1e8b9aa$var$angle(lambda, $e02ad34fa1e8b9aa$var$lambda1) > $e02ad34fa1e8b9aa$var$angle($e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$lambda1)) $e02ad34fa1e8b9aa$var$lambda0 = lambda;
        }
    } else $e02ad34fa1e8b9aa$var$ranges.push($e02ad34fa1e8b9aa$var$range = [
        $e02ad34fa1e8b9aa$var$lambda0 = lambda,
        $e02ad34fa1e8b9aa$var$lambda1 = lambda
    ]);
    if (phi < $e02ad34fa1e8b9aa$var$phi0) $e02ad34fa1e8b9aa$var$phi0 = phi;
    if (phi > $e02ad34fa1e8b9aa$var$phi1) $e02ad34fa1e8b9aa$var$phi1 = phi;
    $e02ad34fa1e8b9aa$var$p0 = p, $e02ad34fa1e8b9aa$var$lambda2 = lambda;
}
function $e02ad34fa1e8b9aa$var$boundsLineStart() {
    $e02ad34fa1e8b9aa$var$boundsStream.point = $e02ad34fa1e8b9aa$var$linePoint;
}
function $e02ad34fa1e8b9aa$var$boundsLineEnd() {
    $e02ad34fa1e8b9aa$var$range[0] = $e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$range[1] = $e02ad34fa1e8b9aa$var$lambda1;
    $e02ad34fa1e8b9aa$var$boundsStream.point = $e02ad34fa1e8b9aa$var$boundsPoint;
    $e02ad34fa1e8b9aa$var$p0 = null;
}
function $e02ad34fa1e8b9aa$var$boundsRingPoint(lambda, phi) {
    if ($e02ad34fa1e8b9aa$var$p0) {
        var delta = lambda - $e02ad34fa1e8b9aa$var$lambda2;
        $e02ad34fa1e8b9aa$var$deltaSum.add((0, $6pzD4.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $e02ad34fa1e8b9aa$var$lambda00 = lambda, $e02ad34fa1e8b9aa$var$phi00 = phi;
    (0, $9EdcX.areaStream).point(lambda, phi);
    $e02ad34fa1e8b9aa$var$linePoint(lambda, phi);
}
function $e02ad34fa1e8b9aa$var$boundsRingStart() {
    (0, $9EdcX.areaStream).lineStart();
}
function $e02ad34fa1e8b9aa$var$boundsRingEnd() {
    $e02ad34fa1e8b9aa$var$boundsRingPoint($e02ad34fa1e8b9aa$var$lambda00, $e02ad34fa1e8b9aa$var$phi00);
    (0, $9EdcX.areaStream).lineEnd();
    if ((0, $6pzD4.abs)($e02ad34fa1e8b9aa$var$deltaSum) > (0, $6pzD4.epsilon)) $e02ad34fa1e8b9aa$var$lambda0 = -($e02ad34fa1e8b9aa$var$lambda1 = 180);
    $e02ad34fa1e8b9aa$var$range[0] = $e02ad34fa1e8b9aa$var$lambda0, $e02ad34fa1e8b9aa$var$range[1] = $e02ad34fa1e8b9aa$var$lambda1;
    $e02ad34fa1e8b9aa$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $e02ad34fa1e8b9aa$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $e02ad34fa1e8b9aa$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $e02ad34fa1e8b9aa$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $e02ad34fa1e8b9aa$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $e02ad34fa1e8b9aa$var$phi1 = $e02ad34fa1e8b9aa$var$lambda1 = -($e02ad34fa1e8b9aa$var$lambda0 = $e02ad34fa1e8b9aa$var$phi0 = Infinity);
    $e02ad34fa1e8b9aa$var$ranges = [];
    (0, $cLMeO.default)(feature, $e02ad34fa1e8b9aa$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $e02ad34fa1e8b9aa$var$ranges.length) {
        $e02ad34fa1e8b9aa$var$ranges.sort($e02ad34fa1e8b9aa$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $e02ad34fa1e8b9aa$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $e02ad34fa1e8b9aa$var$ranges[i];
            if ($e02ad34fa1e8b9aa$var$rangeContains(a, b[0]) || $e02ad34fa1e8b9aa$var$rangeContains(a, b[1])) {
                if ($e02ad34fa1e8b9aa$var$angle(a[0], b[1]) > $e02ad34fa1e8b9aa$var$angle(a[0], a[1])) a[1] = b[1];
                if ($e02ad34fa1e8b9aa$var$angle(b[0], a[1]) > $e02ad34fa1e8b9aa$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $e02ad34fa1e8b9aa$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $e02ad34fa1e8b9aa$var$lambda0 = b[0], $e02ad34fa1e8b9aa$var$lambda1 = a[1];
        }
    }
    $e02ad34fa1e8b9aa$var$ranges = $e02ad34fa1e8b9aa$var$range = null;
    return $e02ad34fa1e8b9aa$var$lambda0 === Infinity || $e02ad34fa1e8b9aa$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $e02ad34fa1e8b9aa$var$lambda0,
            $e02ad34fa1e8b9aa$var$phi0
        ],
        [
            $e02ad34fa1e8b9aa$var$lambda1,
            $e02ad34fa1e8b9aa$var$phi1
        ]
    ];
}

});
parcelRegister("ap01U", function(module, exports) {

$parcel$export(module.exports, "spherical", () => $792c431eb1584cf2$export$12f9ad44fe773943);
$parcel$export(module.exports, "cartesian", () => $792c431eb1584cf2$export$6e6697ef026a96);
$parcel$export(module.exports, "cartesianDot", () => $792c431eb1584cf2$export$2ef80f51436a9de9);
$parcel$export(module.exports, "cartesianCross", () => $792c431eb1584cf2$export$4763f5351b14293f);
$parcel$export(module.exports, "cartesianAddInPlace", () => $792c431eb1584cf2$export$e62eba72fc898eae);
$parcel$export(module.exports, "cartesianScale", () => $792c431eb1584cf2$export$52d0ee3fc868d452);
$parcel$export(module.exports, "cartesianNormalizeInPlace", () => $792c431eb1584cf2$export$6789498aec2cb34b);

var $6pzD4 = parcelRequire("6pzD4");
function $792c431eb1584cf2$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $6pzD4.atan2)(cartesian[1], cartesian[0]),
        (0, $6pzD4.asin)(cartesian[2])
    ];
}
function $792c431eb1584cf2$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $6pzD4.cos)(phi);
    return [
        cosPhi * (0, $6pzD4.cos)(lambda),
        cosPhi * (0, $6pzD4.sin)(lambda),
        (0, $6pzD4.sin)(phi)
    ];
}
function $792c431eb1584cf2$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $792c431eb1584cf2$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $792c431eb1584cf2$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $792c431eb1584cf2$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $792c431eb1584cf2$export$6789498aec2cb34b(d) {
    var l = (0, $6pzD4.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("e8asm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a499ec7b9e1c1974$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");

var $cLMeO = parcelRequire("cLMeO");
var $a499ec7b9e1c1974$var$W0, $a499ec7b9e1c1974$var$W1, $a499ec7b9e1c1974$var$X0, $a499ec7b9e1c1974$var$Y0, $a499ec7b9e1c1974$var$Z0, $a499ec7b9e1c1974$var$X1, $a499ec7b9e1c1974$var$Y1, $a499ec7b9e1c1974$var$Z1, $a499ec7b9e1c1974$var$X2, $a499ec7b9e1c1974$var$Y2, $a499ec7b9e1c1974$var$Z2, $a499ec7b9e1c1974$var$lambda00, $a499ec7b9e1c1974$var$phi00, $a499ec7b9e1c1974$var$x0, $a499ec7b9e1c1974$var$y0, $a499ec7b9e1c1974$var$z0; // previous point
var $a499ec7b9e1c1974$var$centroidStream = {
    sphere: (0, $e88Rm.default),
    point: $a499ec7b9e1c1974$var$centroidPoint,
    lineStart: $a499ec7b9e1c1974$var$centroidLineStart,
    lineEnd: $a499ec7b9e1c1974$var$centroidLineEnd,
    polygonStart: function() {
        $a499ec7b9e1c1974$var$centroidStream.lineStart = $a499ec7b9e1c1974$var$centroidRingStart;
        $a499ec7b9e1c1974$var$centroidStream.lineEnd = $a499ec7b9e1c1974$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $a499ec7b9e1c1974$var$centroidStream.lineStart = $a499ec7b9e1c1974$var$centroidLineStart;
        $a499ec7b9e1c1974$var$centroidStream.lineEnd = $a499ec7b9e1c1974$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $a499ec7b9e1c1974$var$centroidPoint(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    var cosPhi = (0, $6pzD4.cos)(phi);
    $a499ec7b9e1c1974$var$centroidPointCartesian(cosPhi * (0, $6pzD4.cos)(lambda), cosPhi * (0, $6pzD4.sin)(lambda), (0, $6pzD4.sin)(phi));
}
function $a499ec7b9e1c1974$var$centroidPointCartesian(x, y, z) {
    ++$a499ec7b9e1c1974$var$W0;
    $a499ec7b9e1c1974$var$X0 += (x - $a499ec7b9e1c1974$var$X0) / $a499ec7b9e1c1974$var$W0;
    $a499ec7b9e1c1974$var$Y0 += (y - $a499ec7b9e1c1974$var$Y0) / $a499ec7b9e1c1974$var$W0;
    $a499ec7b9e1c1974$var$Z0 += (z - $a499ec7b9e1c1974$var$Z0) / $a499ec7b9e1c1974$var$W0;
}
function $a499ec7b9e1c1974$var$centroidLineStart() {
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidLinePointFirst;
}
function $a499ec7b9e1c1974$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    var cosPhi = (0, $6pzD4.cos)(phi);
    $a499ec7b9e1c1974$var$x0 = cosPhi * (0, $6pzD4.cos)(lambda);
    $a499ec7b9e1c1974$var$y0 = cosPhi * (0, $6pzD4.sin)(lambda);
    $a499ec7b9e1c1974$var$z0 = (0, $6pzD4.sin)(phi);
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidLinePoint;
    $a499ec7b9e1c1974$var$centroidPointCartesian($a499ec7b9e1c1974$var$x0, $a499ec7b9e1c1974$var$y0, $a499ec7b9e1c1974$var$z0);
}
function $a499ec7b9e1c1974$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    var cosPhi = (0, $6pzD4.cos)(phi), x = cosPhi * (0, $6pzD4.cos)(lambda), y = cosPhi * (0, $6pzD4.sin)(lambda), z = (0, $6pzD4.sin)(phi), w = (0, $6pzD4.atan2)((0, $6pzD4.sqrt)((w = $a499ec7b9e1c1974$var$y0 * z - $a499ec7b9e1c1974$var$z0 * y) * w + (w = $a499ec7b9e1c1974$var$z0 * x - $a499ec7b9e1c1974$var$x0 * z) * w + (w = $a499ec7b9e1c1974$var$x0 * y - $a499ec7b9e1c1974$var$y0 * x) * w), $a499ec7b9e1c1974$var$x0 * x + $a499ec7b9e1c1974$var$y0 * y + $a499ec7b9e1c1974$var$z0 * z);
    $a499ec7b9e1c1974$var$W1 += w;
    $a499ec7b9e1c1974$var$X1 += w * ($a499ec7b9e1c1974$var$x0 + ($a499ec7b9e1c1974$var$x0 = x));
    $a499ec7b9e1c1974$var$Y1 += w * ($a499ec7b9e1c1974$var$y0 + ($a499ec7b9e1c1974$var$y0 = y));
    $a499ec7b9e1c1974$var$Z1 += w * ($a499ec7b9e1c1974$var$z0 + ($a499ec7b9e1c1974$var$z0 = z));
    $a499ec7b9e1c1974$var$centroidPointCartesian($a499ec7b9e1c1974$var$x0, $a499ec7b9e1c1974$var$y0, $a499ec7b9e1c1974$var$z0);
}
function $a499ec7b9e1c1974$var$centroidLineEnd() {
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $a499ec7b9e1c1974$var$centroidRingStart() {
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidRingPointFirst;
}
function $a499ec7b9e1c1974$var$centroidRingEnd() {
    $a499ec7b9e1c1974$var$centroidRingPoint($a499ec7b9e1c1974$var$lambda00, $a499ec7b9e1c1974$var$phi00);
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidPoint;
}
function $a499ec7b9e1c1974$var$centroidRingPointFirst(lambda, phi) {
    $a499ec7b9e1c1974$var$lambda00 = lambda, $a499ec7b9e1c1974$var$phi00 = phi;
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    $a499ec7b9e1c1974$var$centroidStream.point = $a499ec7b9e1c1974$var$centroidRingPoint;
    var cosPhi = (0, $6pzD4.cos)(phi);
    $a499ec7b9e1c1974$var$x0 = cosPhi * (0, $6pzD4.cos)(lambda);
    $a499ec7b9e1c1974$var$y0 = cosPhi * (0, $6pzD4.sin)(lambda);
    $a499ec7b9e1c1974$var$z0 = (0, $6pzD4.sin)(phi);
    $a499ec7b9e1c1974$var$centroidPointCartesian($a499ec7b9e1c1974$var$x0, $a499ec7b9e1c1974$var$y0, $a499ec7b9e1c1974$var$z0);
}
function $a499ec7b9e1c1974$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    var cosPhi = (0, $6pzD4.cos)(phi), x = cosPhi * (0, $6pzD4.cos)(lambda), y = cosPhi * (0, $6pzD4.sin)(lambda), z = (0, $6pzD4.sin)(phi), cx = $a499ec7b9e1c1974$var$y0 * z - $a499ec7b9e1c1974$var$z0 * y, cy = $a499ec7b9e1c1974$var$z0 * x - $a499ec7b9e1c1974$var$x0 * z, cz = $a499ec7b9e1c1974$var$x0 * y - $a499ec7b9e1c1974$var$y0 * x, m = (0, $6pzD4.hypot)(cx, cy, cz), w = (0, $6pzD4.asin)(m), v = m && -w / m; // area weight multiplier
    $a499ec7b9e1c1974$var$X2.add(v * cx);
    $a499ec7b9e1c1974$var$Y2.add(v * cy);
    $a499ec7b9e1c1974$var$Z2.add(v * cz);
    $a499ec7b9e1c1974$var$W1 += w;
    $a499ec7b9e1c1974$var$X1 += w * ($a499ec7b9e1c1974$var$x0 + ($a499ec7b9e1c1974$var$x0 = x));
    $a499ec7b9e1c1974$var$Y1 += w * ($a499ec7b9e1c1974$var$y0 + ($a499ec7b9e1c1974$var$y0 = y));
    $a499ec7b9e1c1974$var$Z1 += w * ($a499ec7b9e1c1974$var$z0 + ($a499ec7b9e1c1974$var$z0 = z));
    $a499ec7b9e1c1974$var$centroidPointCartesian($a499ec7b9e1c1974$var$x0, $a499ec7b9e1c1974$var$y0, $a499ec7b9e1c1974$var$z0);
}
function $a499ec7b9e1c1974$export$2e2bcd8739ae039(object) {
    $a499ec7b9e1c1974$var$W0 = $a499ec7b9e1c1974$var$W1 = $a499ec7b9e1c1974$var$X0 = $a499ec7b9e1c1974$var$Y0 = $a499ec7b9e1c1974$var$Z0 = $a499ec7b9e1c1974$var$X1 = $a499ec7b9e1c1974$var$Y1 = $a499ec7b9e1c1974$var$Z1 = 0;
    $a499ec7b9e1c1974$var$X2 = new (0, $loqCp.Adder)();
    $a499ec7b9e1c1974$var$Y2 = new (0, $loqCp.Adder)();
    $a499ec7b9e1c1974$var$Z2 = new (0, $loqCp.Adder)();
    (0, $cLMeO.default)(object, $a499ec7b9e1c1974$var$centroidStream);
    var x = +$a499ec7b9e1c1974$var$X2, y = +$a499ec7b9e1c1974$var$Y2, z = +$a499ec7b9e1c1974$var$Z2, m = (0, $6pzD4.hypot)(x, y, z);
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $6pzD4.epsilon2)) {
        x = $a499ec7b9e1c1974$var$X1, y = $a499ec7b9e1c1974$var$Y1, z = $a499ec7b9e1c1974$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($a499ec7b9e1c1974$var$W1 < (0, $6pzD4.epsilon)) x = $a499ec7b9e1c1974$var$X0, y = $a499ec7b9e1c1974$var$Y0, z = $a499ec7b9e1c1974$var$Z0;
        m = (0, $6pzD4.hypot)(x, y, z);
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $6pzD4.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $6pzD4.atan2)(y, x) * (0, $6pzD4.degrees),
        (0, $6pzD4.asin)(z / m) * (0, $6pzD4.degrees)
    ];
}

});

parcelRegister("1SbW0", function(module, exports) {

$parcel$export(module.exports, "circleStream", () => $15d4178c1d32e2d9$export$b5441eb324cd8d4e);
$parcel$export(module.exports, "default", () => $15d4178c1d32e2d9$export$2e2bcd8739ae039);

var $ap01U = parcelRequire("ap01U");

var $g2J10 = parcelRequire("g2J10");

var $6pzD4 = parcelRequire("6pzD4");

var $7k5xN = parcelRequire("7k5xN");
function $15d4178c1d32e2d9$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $6pzD4.cos)(radius), sinRadius = (0, $6pzD4.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $6pzD4.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $15d4178c1d32e2d9$var$circleRadius(cosRadius, t0);
        t1 = $15d4178c1d32e2d9$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $6pzD4.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $ap01U.spherical)([
            cosRadius,
            -sinRadius * (0, $6pzD4.cos)(t),
            -sinRadius * (0, $6pzD4.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $15d4178c1d32e2d9$var$circleRadius(cosRadius, point) {
    point = (0, $ap01U.cartesian)(point), point[0] -= cosRadius;
    (0, $ap01U.cartesianNormalizeInPlace)(point);
    var radius = (0, $6pzD4.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $6pzD4.tau) - (0, $6pzD4.epsilon)) % (0, $6pzD4.tau);
}
function $15d4178c1d32e2d9$export$2e2bcd8739ae039() {
    var center = (0, $g2J10.default)([
        0,
        0
    ]), radius = (0, $g2J10.default)(90), precision = (0, $g2J10.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $6pzD4.degrees), x[1] *= (0, $6pzD4.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $6pzD4.radians), p = precision.apply(this, arguments) * (0, $6pzD4.radians);
        ring = [];
        rotate = (0, $7k5xN.rotateRadians)(-c[0] * (0, $6pzD4.radians), -c[1] * (0, $6pzD4.radians), 0).invert;
        $15d4178c1d32e2d9$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $g2J10.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $g2J10.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $g2J10.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("g2J10", function(module, exports) {

$parcel$export(module.exports, "default", () => $badfc05333275d4c$export$2e2bcd8739ae039);
function $badfc05333275d4c$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("7k5xN", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", () => $554eb394a3ec19d2$export$a2ba89726971a90f);
$parcel$export(module.exports, "default", () => $554eb394a3ec19d2$export$2e2bcd8739ae039);

var $377Lg = parcelRequire("377Lg");

var $6pzD4 = parcelRequire("6pzD4");
function $554eb394a3ec19d2$var$rotationIdentity(lambda, phi) {
    return [
        (0, $6pzD4.abs)(lambda) > (0, $6pzD4.pi) ? lambda + Math.round(-lambda / (0, $6pzD4.tau)) * (0, $6pzD4.tau) : lambda,
        phi
    ];
}
$554eb394a3ec19d2$var$rotationIdentity.invert = $554eb394a3ec19d2$var$rotationIdentity;
function $554eb394a3ec19d2$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $6pzD4.tau)) ? deltaPhi || deltaGamma ? (0, $377Lg.default)($554eb394a3ec19d2$var$rotationLambda(deltaLambda), $554eb394a3ec19d2$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $554eb394a3ec19d2$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $554eb394a3ec19d2$var$rotationPhiGamma(deltaPhi, deltaGamma) : $554eb394a3ec19d2$var$rotationIdentity;
}
function $554eb394a3ec19d2$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $6pzD4.pi) ? lambda - (0, $6pzD4.tau) : lambda < -(0, $6pzD4.pi) ? lambda + (0, $6pzD4.tau) : lambda,
            phi
        ];
    };
}
function $554eb394a3ec19d2$var$rotationLambda(deltaLambda) {
    var rotation = $554eb394a3ec19d2$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $554eb394a3ec19d2$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $554eb394a3ec19d2$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $6pzD4.cos)(deltaPhi), sinDeltaPhi = (0, $6pzD4.sin)(deltaPhi), cosDeltaGamma = (0, $6pzD4.cos)(deltaGamma), sinDeltaGamma = (0, $6pzD4.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $6pzD4.cos)(phi), x = (0, $6pzD4.cos)(lambda) * cosPhi, y = (0, $6pzD4.sin)(lambda) * cosPhi, z = (0, $6pzD4.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $6pzD4.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $6pzD4.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $6pzD4.cos)(phi), x = (0, $6pzD4.cos)(lambda) * cosPhi, y = (0, $6pzD4.sin)(lambda) * cosPhi, z = (0, $6pzD4.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $6pzD4.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $6pzD4.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $554eb394a3ec19d2$export$2e2bcd8739ae039(rotate) {
    rotate = $554eb394a3ec19d2$export$a2ba89726971a90f(rotate[0] * (0, $6pzD4.radians), rotate[1] * (0, $6pzD4.radians), rotate.length > 2 ? rotate[2] * (0, $6pzD4.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $6pzD4.radians), coordinates[1] * (0, $6pzD4.radians));
        return coordinates[0] *= (0, $6pzD4.degrees), coordinates[1] *= (0, $6pzD4.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $6pzD4.radians), coordinates[1] * (0, $6pzD4.radians));
        return coordinates[0] *= (0, $6pzD4.degrees), coordinates[1] *= (0, $6pzD4.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("377Lg", function(module, exports) {

$parcel$export(module.exports, "default", () => $24480bcca5822032$export$2e2bcd8739ae039);
function $24480bcca5822032$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("iRL8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc1bd5b689d1e27$export$2e2bcd8739ae039);

var $dCS9E = parcelRequire("dCS9E");

var $6pzD4 = parcelRequire("6pzD4");
var $dbc1bd5b689d1e27$export$2e2bcd8739ae039 = (0, $dCS9E.default)(function() {
    return true;
}, $dbc1bd5b689d1e27$var$clipAntimeridianLine, $dbc1bd5b689d1e27$var$clipAntimeridianInterpolate, [
    -(0, $6pzD4.pi),
    -(0, $6pzD4.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $dbc1bd5b689d1e27$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $6pzD4.pi) : -(0, $6pzD4.pi), delta = (0, $6pzD4.abs)(lambda1 - lambda0);
            if ((0, $6pzD4.abs)(delta - (0, $6pzD4.pi)) < (0, $6pzD4.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $6pzD4.halfPi) : -(0, $6pzD4.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $6pzD4.pi)) {
                if ((0, $6pzD4.abs)(lambda0 - sign0) < (0, $6pzD4.epsilon)) lambda0 -= sign0 * (0, $6pzD4.epsilon); // handle degeneracies
                if ((0, $6pzD4.abs)(lambda1 - sign1) < (0, $6pzD4.epsilon)) lambda1 -= sign1 * (0, $6pzD4.epsilon);
                phi0 = $dbc1bd5b689d1e27$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $dbc1bd5b689d1e27$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $6pzD4.sin)(lambda0 - lambda1);
    return (0, $6pzD4.abs)(sinLambda0Lambda1) > (0, $6pzD4.epsilon) ? (0, $6pzD4.atan)(((0, $6pzD4.sin)(phi0) * (cosPhi1 = (0, $6pzD4.cos)(phi1)) * (0, $6pzD4.sin)(lambda1) - (0, $6pzD4.sin)(phi1) * (cosPhi0 = (0, $6pzD4.cos)(phi0)) * (0, $6pzD4.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $dbc1bd5b689d1e27$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $6pzD4.halfPi);
        stream.point(-(0, $6pzD4.pi), phi);
        stream.point(0, phi);
        stream.point((0, $6pzD4.pi), phi);
        stream.point((0, $6pzD4.pi), 0);
        stream.point((0, $6pzD4.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $6pzD4.pi), -phi);
        stream.point(-(0, $6pzD4.pi), 0);
        stream.point(-(0, $6pzD4.pi), phi);
    } else if ((0, $6pzD4.abs)(from[0] - to[0]) > (0, $6pzD4.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $6pzD4.pi) : -(0, $6pzD4.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("dCS9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb8d4f54ac9a29b$export$2e2bcd8739ae039);

var $d1Vay = parcelRequire("d1Vay");

var $e3sc8 = parcelRequire("e3sc8");

var $6pzD4 = parcelRequire("6pzD4");

var $5J5Sc = parcelRequire("5J5Sc");

var $c5gab = parcelRequire("c5gab");
function $9eb8d4f54ac9a29b$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $d1Vay.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $c5gab.default)(segments);
                var startInside = (0, $5J5Sc.default)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $e3sc8.default)(segments, $9eb8d4f54ac9a29b$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($9eb8d4f54ac9a29b$var$validSegment));
        }
        return clip;
    };
}
function $9eb8d4f54ac9a29b$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $9eb8d4f54ac9a29b$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $6pzD4.halfPi) - (0, $6pzD4.epsilon) : (0, $6pzD4.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $6pzD4.halfPi) - (0, $6pzD4.epsilon) : (0, $6pzD4.halfPi) - b[1]);
}

});
parcelRegister("d1Vay", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c7b6f3b1c88dd3$export$2e2bcd8739ae039);

var $e88Rm = parcelRequire("e88Rm");
function $97c7b6f3b1c88dd3$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $e88Rm.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("e3sc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b73764930e706b$export$2e2bcd8739ae039);

var $gEGRg = parcelRequire("gEGRg");

var $6pzD4 = parcelRequire("6pzD4");
function $a3b73764930e706b$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $a3b73764930e706b$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $gEGRg.default)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $6pzD4.epsilon);
        }
        subject.push(x = new $a3b73764930e706b$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $a3b73764930e706b$var$Intersection(p0, null, x, false));
        subject.push(x = new $a3b73764930e706b$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $a3b73764930e706b$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $a3b73764930e706b$var$link(subject);
    $a3b73764930e706b$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $a3b73764930e706b$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("gEGRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c201a082e3d539bd$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");
function $c201a082e3d539bd$export$2e2bcd8739ae039(a, b) {
    return (0, $6pzD4.abs)(a[0] - b[0]) < (0, $6pzD4.epsilon) && (0, $6pzD4.abs)(a[1] - b[1]) < (0, $6pzD4.epsilon);
}

});


parcelRegister("5J5Sc", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b5b60899396aee$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $ap01U = parcelRequire("ap01U");

var $6pzD4 = parcelRequire("6pzD4");
function $42b5b60899396aee$var$longitude(point) {
    if ((0, $6pzD4.abs)(point[0]) <= (0, $6pzD4.pi)) return point[0];
    else return (0, $6pzD4.sign)(point[0]) * (((0, $6pzD4.abs)(point[0]) + (0, $6pzD4.pi)) % (0, $6pzD4.tau) - (0, $6pzD4.pi));
}
function $42b5b60899396aee$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $42b5b60899396aee$var$longitude(point), phi = point[1], sinPhi = (0, $6pzD4.sin)(phi), normal = [
        (0, $6pzD4.sin)(lambda),
        -(0, $6pzD4.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $loqCp.Adder)();
    if (sinPhi === 1) phi = (0, $6pzD4.halfPi) + (0, $6pzD4.epsilon);
    else if (sinPhi === -1) phi = -(0, $6pzD4.halfPi) - (0, $6pzD4.epsilon);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $42b5b60899396aee$var$longitude(point0), phi0 = point0[1] / 2 + (0, $6pzD4.quarterPi), sinPhi0 = (0, $6pzD4.sin)(phi0), cosPhi0 = (0, $6pzD4.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $42b5b60899396aee$var$longitude(point1), phi1 = point1[1] / 2 + (0, $6pzD4.quarterPi), sinPhi1 = (0, $6pzD4.sin)(phi1), cosPhi1 = (0, $6pzD4.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $6pzD4.pi), k = sinPhi0 * sinPhi1;
            sum.add((0, $6pzD4.atan2)(k * sign * (0, $6pzD4.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $6pzD4.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $6pzD4.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $ap01U.cartesianCross)((0, $ap01U.cartesian)(point0), (0, $ap01U.cartesian)(point1));
                (0, $ap01U.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $ap01U.cartesianCross)(normal, arc);
                (0, $ap01U.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $6pzD4.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $6pzD4.epsilon) || angle < (0, $6pzD4.epsilon) && sum < -(0, $6pzD4.epsilon2)) ^ winding & 1;
}

});



parcelRegister("1rmrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c9b7fd8d94b803$export$2e2bcd8739ae039);

var $ap01U = parcelRequire("ap01U");

var $1SbW0 = parcelRequire("1SbW0");

var $6pzD4 = parcelRequire("6pzD4");

var $gEGRg = parcelRequire("gEGRg");

var $dCS9E = parcelRequire("dCS9E");
function $10c9b7fd8d94b803$export$2e2bcd8739ae039(radius) {
    var cr = (0, $6pzD4.cos)(radius), delta = 6 * (0, $6pzD4.radians), smallRadius = cr > 0, notHemisphere = (0, $6pzD4.abs)(cr) > (0, $6pzD4.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $1SbW0.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $6pzD4.cos)(lambda) * (0, $6pzD4.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $6pzD4.pi) : -(0, $6pzD4.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $gEGRg.default)(point0, point2) || (0, $gEGRg.default)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $gEGRg.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $ap01U.cartesian)(a), pb = (0, $ap01U.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $ap01U.cartesianCross)(pa, pb), n2n2 = (0, $ap01U.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $ap01U.cartesianCross)(n1, n2), A = (0, $ap01U.cartesianScale)(n1, c1), B = (0, $ap01U.cartesianScale)(n2, c2);
        (0, $ap01U.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $ap01U.cartesianDot)(A, u), uu = (0, $ap01U.cartesianDot)(u, u), t2 = w * w - uu * ((0, $ap01U.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $6pzD4.sqrt)(t2), q = (0, $ap01U.cartesianScale)(u, (-w - t) / uu);
        (0, $ap01U.cartesianAddInPlace)(q, A);
        q = (0, $ap01U.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $6pzD4.abs)(delta - (0, $6pzD4.pi)) < (0, $6pzD4.epsilon), meridian = polar || delta < (0, $6pzD4.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $6pzD4.abs)(q[0] - lambda0) < (0, $6pzD4.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $6pzD4.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $ap01U.cartesianScale)(u, (-w + t) / uu);
            (0, $ap01U.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $ap01U.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $6pzD4.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $dCS9E.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $6pzD4.pi),
        radius - (0, $6pzD4.pi)
    ]);
}

});

parcelRegister("3tz05", function(module, exports) {

$parcel$export(module.exports, "default", () => $287f3adf4d56df6f$export$2e2bcd8739ae039);

var $2LCTV = parcelRequire("2LCTV");
function $287f3adf4d56df6f$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $2LCTV.default)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("2LCTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $203e257be79d3904$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $d1Vay = parcelRequire("d1Vay");

var $42xZS = parcelRequire("42xZS");

var $e3sc8 = parcelRequire("e3sc8");

var $c5gab = parcelRequire("c5gab");
var $203e257be79d3904$var$clipMax = 1e9, $203e257be79d3904$var$clipMin = -$203e257be79d3904$var$clipMax;
function $203e257be79d3904$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $6pzD4.abs)(p[0] - x0) < (0, $6pzD4.epsilon) ? direction > 0 ? 0 : 3 : (0, $6pzD4.abs)(p[0] - x1) < (0, $6pzD4.epsilon) ? direction > 0 ? 2 : 1 : (0, $6pzD4.abs)(p[1] - y0) < (0, $6pzD4.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $d1Vay.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $c5gab.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $e3sc8.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($203e257be79d3904$var$clipMin, Math.min($203e257be79d3904$var$clipMax, x_)),
                    y_ = Math.max($203e257be79d3904$var$clipMin, Math.min($203e257be79d3904$var$clipMax, y_))
                ], b = [
                    x = Math.max($203e257be79d3904$var$clipMin, Math.min($203e257be79d3904$var$clipMax, x)),
                    y = Math.max($203e257be79d3904$var$clipMin, Math.min($203e257be79d3904$var$clipMax, y))
                ];
                if ((0, $42xZS.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

});
parcelRegister("42xZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f11b86eb01eeffb$export$2e2bcd8739ae039);
function $2f11b86eb01eeffb$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});



parcelRegister("6NN2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3d5c851941671e$export$2e2bcd8739ae039);

var $5J5Sc = parcelRequire("5J5Sc");

var $d9z72 = parcelRequire("d9z72");

var $6pzD4 = parcelRequire("6pzD4");
var $4f3d5c851941671e$var$containsObjectType = {
    Feature: function(object, point) {
        return $4f3d5c851941671e$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($4f3d5c851941671e$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $4f3d5c851941671e$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $4f3d5c851941671e$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4f3d5c851941671e$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $4f3d5c851941671e$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4f3d5c851941671e$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $4f3d5c851941671e$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4f3d5c851941671e$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($4f3d5c851941671e$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $4f3d5c851941671e$var$containsGeometry(geometry, point) {
    return geometry && $4f3d5c851941671e$var$containsGeometryType.hasOwnProperty(geometry.type) ? $4f3d5c851941671e$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $4f3d5c851941671e$var$containsPoint(coordinates, point) {
    return (0, $d9z72.default)(coordinates, point) === 0;
}
function $4f3d5c851941671e$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $d9z72.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $d9z72.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $6pzD4.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $4f3d5c851941671e$var$containsPolygon(coordinates, point) {
    return !!(0, $5J5Sc.default)(coordinates.map($4f3d5c851941671e$var$ringRadians), $4f3d5c851941671e$var$pointRadians(point));
}
function $4f3d5c851941671e$var$ringRadians(ring) {
    return ring = ring.map($4f3d5c851941671e$var$pointRadians), ring.pop(), ring;
}
function $4f3d5c851941671e$var$pointRadians(point) {
    return [
        point[0] * (0, $6pzD4.radians),
        point[1] * (0, $6pzD4.radians)
    ];
}
function $4f3d5c851941671e$export$2e2bcd8739ae039(object, point) {
    return (object && $4f3d5c851941671e$var$containsObjectType.hasOwnProperty(object.type) ? $4f3d5c851941671e$var$containsObjectType[object.type] : $4f3d5c851941671e$var$containsGeometry)(object, point);
}

});
parcelRegister("d9z72", function(module, exports) {

$parcel$export(module.exports, "default", () => $99375a4193c07557$export$2e2bcd8739ae039);

var $cBQFi = parcelRequire("cBQFi");
var $99375a4193c07557$var$coordinates = [
    null,
    null
], $99375a4193c07557$var$object = {
    type: "LineString",
    coordinates: $99375a4193c07557$var$coordinates
};
function $99375a4193c07557$export$2e2bcd8739ae039(a, b) {
    $99375a4193c07557$var$coordinates[0] = a;
    $99375a4193c07557$var$coordinates[1] = b;
    return (0, $cBQFi.default)($99375a4193c07557$var$object);
}

});
parcelRegister("cBQFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e1caf1b1d2206c$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");

var $cLMeO = parcelRequire("cLMeO");
var $92e1caf1b1d2206c$var$lengthSum, $92e1caf1b1d2206c$var$lambda0, $92e1caf1b1d2206c$var$sinPhi0, $92e1caf1b1d2206c$var$cosPhi0;
var $92e1caf1b1d2206c$var$lengthStream = {
    sphere: (0, $e88Rm.default),
    point: (0, $e88Rm.default),
    lineStart: $92e1caf1b1d2206c$var$lengthLineStart,
    lineEnd: (0, $e88Rm.default),
    polygonStart: (0, $e88Rm.default),
    polygonEnd: (0, $e88Rm.default)
};
function $92e1caf1b1d2206c$var$lengthLineStart() {
    $92e1caf1b1d2206c$var$lengthStream.point = $92e1caf1b1d2206c$var$lengthPointFirst;
    $92e1caf1b1d2206c$var$lengthStream.lineEnd = $92e1caf1b1d2206c$var$lengthLineEnd;
}
function $92e1caf1b1d2206c$var$lengthLineEnd() {
    $92e1caf1b1d2206c$var$lengthStream.point = $92e1caf1b1d2206c$var$lengthStream.lineEnd = (0, $e88Rm.default);
}
function $92e1caf1b1d2206c$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    $92e1caf1b1d2206c$var$lambda0 = lambda, $92e1caf1b1d2206c$var$sinPhi0 = (0, $6pzD4.sin)(phi), $92e1caf1b1d2206c$var$cosPhi0 = (0, $6pzD4.cos)(phi);
    $92e1caf1b1d2206c$var$lengthStream.point = $92e1caf1b1d2206c$var$lengthPoint;
}
function $92e1caf1b1d2206c$var$lengthPoint(lambda, phi) {
    lambda *= (0, $6pzD4.radians), phi *= (0, $6pzD4.radians);
    var sinPhi = (0, $6pzD4.sin)(phi), cosPhi = (0, $6pzD4.cos)(phi), delta = (0, $6pzD4.abs)(lambda - $92e1caf1b1d2206c$var$lambda0), cosDelta = (0, $6pzD4.cos)(delta), sinDelta = (0, $6pzD4.sin)(delta), x = cosPhi * sinDelta, y = $92e1caf1b1d2206c$var$cosPhi0 * sinPhi - $92e1caf1b1d2206c$var$sinPhi0 * cosPhi * cosDelta, z = $92e1caf1b1d2206c$var$sinPhi0 * sinPhi + $92e1caf1b1d2206c$var$cosPhi0 * cosPhi * cosDelta;
    $92e1caf1b1d2206c$var$lengthSum.add((0, $6pzD4.atan2)((0, $6pzD4.sqrt)(x * x + y * y), z));
    $92e1caf1b1d2206c$var$lambda0 = lambda, $92e1caf1b1d2206c$var$sinPhi0 = sinPhi, $92e1caf1b1d2206c$var$cosPhi0 = cosPhi;
}
function $92e1caf1b1d2206c$export$2e2bcd8739ae039(object) {
    $92e1caf1b1d2206c$var$lengthSum = new (0, $loqCp.Adder)();
    (0, $cLMeO.default)(object, $92e1caf1b1d2206c$var$lengthStream);
    return +$92e1caf1b1d2206c$var$lengthSum;
}

});



parcelRegister("h1BuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64f9cda4373b284$export$2e2bcd8739ae039);
$parcel$export(module.exports, "graticule10", () => $c64f9cda4373b284$export$b8db4e9403a5b6f1);

var $4n9LK = parcelRequire("4n9LK");

var $6pzD4 = parcelRequire("6pzD4");
function $c64f9cda4373b284$var$graticuleX(y0, y1, dy) {
    var y = (0, $4n9LK.default)(y0, y1 - (0, $6pzD4.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $c64f9cda4373b284$var$graticuleY(x0, x1, dx) {
    var x = (0, $4n9LK.default)(x0, x1 - (0, $6pzD4.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $c64f9cda4373b284$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $4n9LK.default)((0, $6pzD4.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $4n9LK.default)((0, $6pzD4.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $4n9LK.default)((0, $6pzD4.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $6pzD4.abs)(x % DX) > (0, $6pzD4.epsilon);
        }).map(x)).concat((0, $4n9LK.default)((0, $6pzD4.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $6pzD4.abs)(y % DY) > (0, $6pzD4.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $c64f9cda4373b284$var$graticuleX(y0, y1, 90);
        y = $c64f9cda4373b284$var$graticuleY(x0, x1, precision);
        X = $c64f9cda4373b284$var$graticuleX(Y0, Y1, 90);
        Y = $c64f9cda4373b284$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $6pzD4.epsilon)
        ],
        [
            180,
            90 - (0, $6pzD4.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $6pzD4.epsilon)
        ],
        [
            180,
            80 + (0, $6pzD4.epsilon)
        ]
    ]);
}
function $c64f9cda4373b284$export$b8db4e9403a5b6f1() {
    return $c64f9cda4373b284$export$2e2bcd8739ae039()();
}

});

parcelRegister("gcJnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc0f7e4760c9c41$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");
function $bcc0f7e4760c9c41$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $6pzD4.radians), y0 = a[1] * (0, $6pzD4.radians), x1 = b[0] * (0, $6pzD4.radians), y1 = b[1] * (0, $6pzD4.radians), cy0 = (0, $6pzD4.cos)(y0), sy0 = (0, $6pzD4.sin)(y0), cy1 = (0, $6pzD4.cos)(y1), sy1 = (0, $6pzD4.sin)(y1), kx0 = cy0 * (0, $6pzD4.cos)(x0), ky0 = cy0 * (0, $6pzD4.sin)(x0), kx1 = cy1 * (0, $6pzD4.cos)(x1), ky1 = cy1 * (0, $6pzD4.sin)(x1), d = 2 * (0, $6pzD4.asin)((0, $6pzD4.sqrt)((0, $6pzD4.haversin)(y1 - y0) + cy0 * cy1 * (0, $6pzD4.haversin)(x1 - x0))), k = (0, $6pzD4.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $6pzD4.sin)(t *= d) / k, A = (0, $6pzD4.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $6pzD4.atan2)(y, x) * (0, $6pzD4.degrees),
            (0, $6pzD4.atan2)(z, (0, $6pzD4.sqrt)(x * x + y * y)) * (0, $6pzD4.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $6pzD4.degrees),
            y0 * (0, $6pzD4.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("ijkmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d549cbbd947c0897$export$2e2bcd8739ae039);

var $ebWea = parcelRequire("ebWea");

var $cLMeO = parcelRequire("cLMeO");

var $fEqcy = parcelRequire("fEqcy");

var $9CYy2 = parcelRequire("9CYy2");

var $3twsc = parcelRequire("3twsc");

var $cAYPM = parcelRequire("cAYPM");

var $3Zn77 = parcelRequire("3Zn77");

var $7rcAN = parcelRequire("7rcAN");
function $d549cbbd947c0897$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $cLMeO.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $cLMeO.default)(object, projectionStream((0, $fEqcy.default)));
        return (0, $fEqcy.default).result();
    };
    path.measure = function(object) {
        (0, $cLMeO.default)(object, projectionStream((0, $3Zn77.default)));
        return (0, $3Zn77.default).result();
    };
    path.bounds = function(object) {
        (0, $cLMeO.default)(object, projectionStream((0, $9CYy2.default)));
        return (0, $9CYy2.default).result();
    };
    path.centroid = function(object) {
        (0, $cLMeO.default)(object, projectionStream((0, $3twsc.default)));
        return (0, $3twsc.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $ebWea.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $7rcAN.default)) : new (0, $cAYPM.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("ebWea", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54f4285b04e2c92$export$2e2bcd8739ae039);
var $a54f4285b04e2c92$export$2e2bcd8739ae039 = (x)=>x;

});

parcelRegister("fEqcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64eea84e4271010$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");
var $b64eea84e4271010$var$areaSum = new (0, $loqCp.Adder)(), $b64eea84e4271010$var$areaRingSum = new (0, $loqCp.Adder)(), $b64eea84e4271010$var$x00, $b64eea84e4271010$var$y00, $b64eea84e4271010$var$x0, $b64eea84e4271010$var$y0;
var $b64eea84e4271010$var$areaStream = {
    point: (0, $e88Rm.default),
    lineStart: (0, $e88Rm.default),
    lineEnd: (0, $e88Rm.default),
    polygonStart: function() {
        $b64eea84e4271010$var$areaStream.lineStart = $b64eea84e4271010$var$areaRingStart;
        $b64eea84e4271010$var$areaStream.lineEnd = $b64eea84e4271010$var$areaRingEnd;
    },
    polygonEnd: function() {
        $b64eea84e4271010$var$areaStream.lineStart = $b64eea84e4271010$var$areaStream.lineEnd = $b64eea84e4271010$var$areaStream.point = (0, $e88Rm.default);
        $b64eea84e4271010$var$areaSum.add((0, $6pzD4.abs)($b64eea84e4271010$var$areaRingSum));
        $b64eea84e4271010$var$areaRingSum = new (0, $loqCp.Adder)();
    },
    result: function() {
        var area = $b64eea84e4271010$var$areaSum / 2;
        $b64eea84e4271010$var$areaSum = new (0, $loqCp.Adder)();
        return area;
    }
};
function $b64eea84e4271010$var$areaRingStart() {
    $b64eea84e4271010$var$areaStream.point = $b64eea84e4271010$var$areaPointFirst;
}
function $b64eea84e4271010$var$areaPointFirst(x, y) {
    $b64eea84e4271010$var$areaStream.point = $b64eea84e4271010$var$areaPoint;
    $b64eea84e4271010$var$x00 = $b64eea84e4271010$var$x0 = x, $b64eea84e4271010$var$y00 = $b64eea84e4271010$var$y0 = y;
}
function $b64eea84e4271010$var$areaPoint(x, y) {
    $b64eea84e4271010$var$areaRingSum.add($b64eea84e4271010$var$y0 * x - $b64eea84e4271010$var$x0 * y);
    $b64eea84e4271010$var$x0 = x, $b64eea84e4271010$var$y0 = y;
}
function $b64eea84e4271010$var$areaRingEnd() {
    $b64eea84e4271010$var$areaPoint($b64eea84e4271010$var$x00, $b64eea84e4271010$var$y00);
}
var $b64eea84e4271010$export$2e2bcd8739ae039 = $b64eea84e4271010$var$areaStream;

});

parcelRegister("9CYy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7026a13ae2b37796$export$2e2bcd8739ae039);

var $e88Rm = parcelRequire("e88Rm");
var $7026a13ae2b37796$var$x0 = Infinity, $7026a13ae2b37796$var$y0 = $7026a13ae2b37796$var$x0, $7026a13ae2b37796$var$x1 = -$7026a13ae2b37796$var$x0, $7026a13ae2b37796$var$y1 = $7026a13ae2b37796$var$x1;
var $7026a13ae2b37796$var$boundsStream = {
    point: $7026a13ae2b37796$var$boundsPoint,
    lineStart: (0, $e88Rm.default),
    lineEnd: (0, $e88Rm.default),
    polygonStart: (0, $e88Rm.default),
    polygonEnd: (0, $e88Rm.default),
    result: function() {
        var bounds = [
            [
                $7026a13ae2b37796$var$x0,
                $7026a13ae2b37796$var$y0
            ],
            [
                $7026a13ae2b37796$var$x1,
                $7026a13ae2b37796$var$y1
            ]
        ];
        $7026a13ae2b37796$var$x1 = $7026a13ae2b37796$var$y1 = -($7026a13ae2b37796$var$y0 = $7026a13ae2b37796$var$x0 = Infinity);
        return bounds;
    }
};
function $7026a13ae2b37796$var$boundsPoint(x, y) {
    if (x < $7026a13ae2b37796$var$x0) $7026a13ae2b37796$var$x0 = x;
    if (x > $7026a13ae2b37796$var$x1) $7026a13ae2b37796$var$x1 = x;
    if (y < $7026a13ae2b37796$var$y0) $7026a13ae2b37796$var$y0 = y;
    if (y > $7026a13ae2b37796$var$y1) $7026a13ae2b37796$var$y1 = y;
}
var $7026a13ae2b37796$export$2e2bcd8739ae039 = $7026a13ae2b37796$var$boundsStream;

});

parcelRegister("3twsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $287d4135fb106805$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");
// TODO Enforce positive area for exterior, negative area for interior?
var $287d4135fb106805$var$X0 = 0, $287d4135fb106805$var$Y0 = 0, $287d4135fb106805$var$Z0 = 0, $287d4135fb106805$var$X1 = 0, $287d4135fb106805$var$Y1 = 0, $287d4135fb106805$var$Z1 = 0, $287d4135fb106805$var$X2 = 0, $287d4135fb106805$var$Y2 = 0, $287d4135fb106805$var$Z2 = 0, $287d4135fb106805$var$x00, $287d4135fb106805$var$y00, $287d4135fb106805$var$x0, $287d4135fb106805$var$y0;
var $287d4135fb106805$var$centroidStream = {
    point: $287d4135fb106805$var$centroidPoint,
    lineStart: $287d4135fb106805$var$centroidLineStart,
    lineEnd: $287d4135fb106805$var$centroidLineEnd,
    polygonStart: function() {
        $287d4135fb106805$var$centroidStream.lineStart = $287d4135fb106805$var$centroidRingStart;
        $287d4135fb106805$var$centroidStream.lineEnd = $287d4135fb106805$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPoint;
        $287d4135fb106805$var$centroidStream.lineStart = $287d4135fb106805$var$centroidLineStart;
        $287d4135fb106805$var$centroidStream.lineEnd = $287d4135fb106805$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $287d4135fb106805$var$Z2 ? [
            $287d4135fb106805$var$X2 / $287d4135fb106805$var$Z2,
            $287d4135fb106805$var$Y2 / $287d4135fb106805$var$Z2
        ] : $287d4135fb106805$var$Z1 ? [
            $287d4135fb106805$var$X1 / $287d4135fb106805$var$Z1,
            $287d4135fb106805$var$Y1 / $287d4135fb106805$var$Z1
        ] : $287d4135fb106805$var$Z0 ? [
            $287d4135fb106805$var$X0 / $287d4135fb106805$var$Z0,
            $287d4135fb106805$var$Y0 / $287d4135fb106805$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $287d4135fb106805$var$X0 = $287d4135fb106805$var$Y0 = $287d4135fb106805$var$Z0 = $287d4135fb106805$var$X1 = $287d4135fb106805$var$Y1 = $287d4135fb106805$var$Z1 = $287d4135fb106805$var$X2 = $287d4135fb106805$var$Y2 = $287d4135fb106805$var$Z2 = 0;
        return centroid;
    }
};
function $287d4135fb106805$var$centroidPoint(x, y) {
    $287d4135fb106805$var$X0 += x;
    $287d4135fb106805$var$Y0 += y;
    ++$287d4135fb106805$var$Z0;
}
function $287d4135fb106805$var$centroidLineStart() {
    $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPointFirstLine;
}
function $287d4135fb106805$var$centroidPointFirstLine(x, y) {
    $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPointLine;
    $287d4135fb106805$var$centroidPoint($287d4135fb106805$var$x0 = x, $287d4135fb106805$var$y0 = y);
}
function $287d4135fb106805$var$centroidPointLine(x, y) {
    var dx = x - $287d4135fb106805$var$x0, dy = y - $287d4135fb106805$var$y0, z = (0, $6pzD4.sqrt)(dx * dx + dy * dy);
    $287d4135fb106805$var$X1 += z * ($287d4135fb106805$var$x0 + x) / 2;
    $287d4135fb106805$var$Y1 += z * ($287d4135fb106805$var$y0 + y) / 2;
    $287d4135fb106805$var$Z1 += z;
    $287d4135fb106805$var$centroidPoint($287d4135fb106805$var$x0 = x, $287d4135fb106805$var$y0 = y);
}
function $287d4135fb106805$var$centroidLineEnd() {
    $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPoint;
}
function $287d4135fb106805$var$centroidRingStart() {
    $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPointFirstRing;
}
function $287d4135fb106805$var$centroidRingEnd() {
    $287d4135fb106805$var$centroidPointRing($287d4135fb106805$var$x00, $287d4135fb106805$var$y00);
}
function $287d4135fb106805$var$centroidPointFirstRing(x, y) {
    $287d4135fb106805$var$centroidStream.point = $287d4135fb106805$var$centroidPointRing;
    $287d4135fb106805$var$centroidPoint($287d4135fb106805$var$x00 = $287d4135fb106805$var$x0 = x, $287d4135fb106805$var$y00 = $287d4135fb106805$var$y0 = y);
}
function $287d4135fb106805$var$centroidPointRing(x, y) {
    var dx = x - $287d4135fb106805$var$x0, dy = y - $287d4135fb106805$var$y0, z = (0, $6pzD4.sqrt)(dx * dx + dy * dy);
    $287d4135fb106805$var$X1 += z * ($287d4135fb106805$var$x0 + x) / 2;
    $287d4135fb106805$var$Y1 += z * ($287d4135fb106805$var$y0 + y) / 2;
    $287d4135fb106805$var$Z1 += z;
    z = $287d4135fb106805$var$y0 * x - $287d4135fb106805$var$x0 * y;
    $287d4135fb106805$var$X2 += z * ($287d4135fb106805$var$x0 + x);
    $287d4135fb106805$var$Y2 += z * ($287d4135fb106805$var$y0 + y);
    $287d4135fb106805$var$Z2 += z * 3;
    $287d4135fb106805$var$centroidPoint($287d4135fb106805$var$x0 = x, $287d4135fb106805$var$y0 = y);
}
var $287d4135fb106805$export$2e2bcd8739ae039 = $287d4135fb106805$var$centroidStream;

});

parcelRegister("cAYPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b80934d7501cb3$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");
function $92b80934d7501cb3$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$92b80934d7501cb3$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $6pzD4.tau));
                break;
        }
    },
    result: (0, $e88Rm.default)
};

});

parcelRegister("3Zn77", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e78ff828b307211$export$2e2bcd8739ae039);

var $loqCp = parcelRequire("loqCp");

var $6pzD4 = parcelRequire("6pzD4");

var $e88Rm = parcelRequire("e88Rm");
var $2e78ff828b307211$var$lengthSum = new (0, $loqCp.Adder)(), $2e78ff828b307211$var$lengthRing, $2e78ff828b307211$var$x00, $2e78ff828b307211$var$y00, $2e78ff828b307211$var$x0, $2e78ff828b307211$var$y0;
var $2e78ff828b307211$var$lengthStream = {
    point: (0, $e88Rm.default),
    lineStart: function() {
        $2e78ff828b307211$var$lengthStream.point = $2e78ff828b307211$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($2e78ff828b307211$var$lengthRing) $2e78ff828b307211$var$lengthPoint($2e78ff828b307211$var$x00, $2e78ff828b307211$var$y00);
        $2e78ff828b307211$var$lengthStream.point = (0, $e88Rm.default);
    },
    polygonStart: function() {
        $2e78ff828b307211$var$lengthRing = true;
    },
    polygonEnd: function() {
        $2e78ff828b307211$var$lengthRing = null;
    },
    result: function() {
        var length = +$2e78ff828b307211$var$lengthSum;
        $2e78ff828b307211$var$lengthSum = new (0, $loqCp.Adder)();
        return length;
    }
};
function $2e78ff828b307211$var$lengthPointFirst(x, y) {
    $2e78ff828b307211$var$lengthStream.point = $2e78ff828b307211$var$lengthPoint;
    $2e78ff828b307211$var$x00 = $2e78ff828b307211$var$x0 = x, $2e78ff828b307211$var$y00 = $2e78ff828b307211$var$y0 = y;
}
function $2e78ff828b307211$var$lengthPoint(x, y) {
    $2e78ff828b307211$var$x0 -= x, $2e78ff828b307211$var$y0 -= y;
    $2e78ff828b307211$var$lengthSum.add((0, $6pzD4.sqrt)($2e78ff828b307211$var$x0 * $2e78ff828b307211$var$x0 + $2e78ff828b307211$var$y0 * $2e78ff828b307211$var$y0));
    $2e78ff828b307211$var$x0 = x, $2e78ff828b307211$var$y0 = y;
}
var $2e78ff828b307211$export$2e2bcd8739ae039 = $2e78ff828b307211$var$lengthStream;

});

parcelRegister("7rcAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a4d2a0fe5eb8d3$export$2e2bcd8739ae039);
function $56a4d2a0fe5eb8d3$export$2e2bcd8739ae039() {
    this._string = [];
}
$56a4d2a0fe5eb8d3$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $56a4d2a0fe5eb8d3$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $56a4d2a0fe5eb8d3$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $56a4d2a0fe5eb8d3$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("24RUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1835c74aded4ba77$export$2e2bcd8739ae039);

var $9RZwn = parcelRequire("9RZwn");
function $1835c74aded4ba77$export$2e2bcd8739ae039() {
    return (0, $9RZwn.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("9RZwn", function(module, exports) {

$parcel$export(module.exports, "conicEqualAreaRaw", () => $72f8c91efaeee84f$export$75409dad1c406288);
$parcel$export(module.exports, "default", () => $72f8c91efaeee84f$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $bNFOO = parcelRequire("bNFOO");

var $gprnh = parcelRequire("gprnh");
function $72f8c91efaeee84f$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $6pzD4.sin)(y0), n = (sy0 + (0, $6pzD4.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $6pzD4.abs)(n) < (0, $6pzD4.epsilon)) return (0, $gprnh.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $6pzD4.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $6pzD4.sqrt)(c - 2 * n * (0, $6pzD4.sin)(y)) / n;
        return [
            r * (0, $6pzD4.sin)(x *= n),
            r0 - r * (0, $6pzD4.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $6pzD4.atan2)(x, (0, $6pzD4.abs)(r0y)) * (0, $6pzD4.sign)(r0y);
        if (r0y * n < 0) l -= (0, $6pzD4.pi) * (0, $6pzD4.sign)(x) * (0, $6pzD4.sign)(r0y);
        return [
            l / n,
            (0, $6pzD4.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $72f8c91efaeee84f$export$2e2bcd8739ae039() {
    return (0, $bNFOO.conicProjection)($72f8c91efaeee84f$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("bNFOO", function(module, exports) {

$parcel$export(module.exports, "conicProjection", () => $8974b5954662e442$export$228272587c4d24d8);

var $6pzD4 = parcelRequire("6pzD4");

var $k6OY5 = parcelRequire("k6OY5");
function $8974b5954662e442$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $6pzD4.pi) / 3, m = (0, $k6OY5.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $6pzD4.radians), phi1 = _[1] * (0, $6pzD4.radians)) : [
            phi0 * (0, $6pzD4.degrees),
            phi1 * (0, $6pzD4.degrees)
        ];
    };
    return p;
}

});
parcelRegister("k6OY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3be76a07ee4cf7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "projectionMutator", () => $ea3be76a07ee4cf7$export$155d5a6fa6fddeba);

var $iRL8s = parcelRequire("iRL8s");

var $1rmrh = parcelRequire("1rmrh");

var $2LCTV = parcelRequire("2LCTV");

var $377Lg = parcelRequire("377Lg");

var $ebWea = parcelRequire("ebWea");

var $6pzD4 = parcelRequire("6pzD4");

var $7k5xN = parcelRequire("7k5xN");

var $bit3e = parcelRequire("bit3e");

var $fGwDt = parcelRequire("fGwDt");

var $isaft = parcelRequire("isaft");
var $ea3be76a07ee4cf7$var$transformRadians = (0, $bit3e.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $6pzD4.radians), y * (0, $6pzD4.radians));
    }
});
function $ea3be76a07ee4cf7$var$transformRotate(rotate) {
    return (0, $bit3e.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $ea3be76a07ee4cf7$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $ea3be76a07ee4cf7$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $ea3be76a07ee4cf7$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $6pzD4.cos)(alpha), sinAlpha = (0, $6pzD4.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $ea3be76a07ee4cf7$export$2e2bcd8739ae039(project) {
    return $ea3be76a07ee4cf7$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $ea3be76a07ee4cf7$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $iRL8s.default), x0 = null, y0, x1, y1, postclip = (0, $ebWea.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $6pzD4.radians), point[1] * (0, $6pzD4.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $6pzD4.degrees),
            point[1] * (0, $6pzD4.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $ea3be76a07ee4cf7$var$transformRadians($ea3be76a07ee4cf7$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $1rmrh.default)(theta = _ * (0, $6pzD4.radians)) : (theta = null, $iRL8s.default), reset()) : theta * (0, $6pzD4.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $ebWea.default) : (0, $2LCTV.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $6pzD4.radians), phi = _[1] % 360 * (0, $6pzD4.radians), recenter()) : [
            lambda * (0, $6pzD4.degrees),
            phi * (0, $6pzD4.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $6pzD4.radians), deltaPhi = _[1] % 360 * (0, $6pzD4.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $6pzD4.radians) : 0, recenter()) : [
            deltaLambda * (0, $6pzD4.degrees),
            deltaPhi * (0, $6pzD4.degrees),
            deltaGamma * (0, $6pzD4.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $6pzD4.radians), recenter()) : alpha * (0, $6pzD4.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $isaft.default)(projectTransform, delta2 = _ * _), reset()) : (0, $6pzD4.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $fGwDt.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $fGwDt.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $fGwDt.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $fGwDt.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = $ea3be76a07ee4cf7$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $ea3be76a07ee4cf7$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $7k5xN.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $377Lg.default)(project, transform);
        projectRotateTransform = (0, $377Lg.default)(rotate, projectTransform);
        projectResample = (0, $isaft.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("bit3e", function(module, exports) {

$parcel$export(module.exports, "default", () => $8397e91ee23cbd6c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "transformer", () => $8397e91ee23cbd6c$export$6b468dcfb64c653c);
function $8397e91ee23cbd6c$export$2e2bcd8739ae039(methods) {
    return {
        stream: $8397e91ee23cbd6c$export$6b468dcfb64c653c(methods)
    };
}
function $8397e91ee23cbd6c$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $8397e91ee23cbd6c$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $8397e91ee23cbd6c$var$TransformStream() {}
$8397e91ee23cbd6c$var$TransformStream.prototype = {
    constructor: $8397e91ee23cbd6c$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("fGwDt", function(module, exports) {

$parcel$export(module.exports, "fitExtent", () => $b6b41800df26a0fb$export$e450184041869e7f);
$parcel$export(module.exports, "fitSize", () => $b6b41800df26a0fb$export$33a367fa1728c3ba);
$parcel$export(module.exports, "fitWidth", () => $b6b41800df26a0fb$export$7d8f2192ef31c5a7);
$parcel$export(module.exports, "fitHeight", () => $b6b41800df26a0fb$export$7069bab0d2ced675);

var $cLMeO = parcelRequire("cLMeO");

var $9CYy2 = parcelRequire("9CYy2");
function $b6b41800df26a0fb$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $cLMeO.default)(object, projection.stream((0, $9CYy2.default)));
    fitBounds((0, $9CYy2.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $b6b41800df26a0fb$export$e450184041869e7f(projection, extent, object) {
    return $b6b41800df26a0fb$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $b6b41800df26a0fb$export$33a367fa1728c3ba(projection, size, object) {
    return $b6b41800df26a0fb$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $b6b41800df26a0fb$export$7d8f2192ef31c5a7(projection, width, object) {
    return $b6b41800df26a0fb$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $b6b41800df26a0fb$export$7069bab0d2ced675(projection, height, object) {
    return $b6b41800df26a0fb$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

});

parcelRegister("isaft", function(module, exports) {

$parcel$export(module.exports, "default", () => $03778765e99063b0$export$2e2bcd8739ae039);

var $ap01U = parcelRequire("ap01U");

var $6pzD4 = parcelRequire("6pzD4");

var $bit3e = parcelRequire("bit3e");
var $03778765e99063b0$var$maxDepth = 16, $03778765e99063b0$var$cosMinDistance = (0, $6pzD4.cos)(30 * (0, $6pzD4.radians)); // cos(minimum angular distance)
function $03778765e99063b0$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $03778765e99063b0$var$resample(project, delta2) : $03778765e99063b0$var$resampleNone(project);
}
function $03778765e99063b0$var$resampleNone(project) {
    return (0, $bit3e.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $03778765e99063b0$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $6pzD4.sqrt)(a * a + b * b + c * c), phi2 = (0, $6pzD4.asin)(c /= m), lambda2 = (0, $6pzD4.abs)((0, $6pzD4.abs)(c) - 1) < (0, $6pzD4.epsilon) || (0, $6pzD4.abs)(lambda0 - lambda1) < (0, $6pzD4.epsilon) ? (lambda0 + lambda1) / 2 : (0, $6pzD4.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $6pzD4.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $03778765e99063b0$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $ap01U.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $03778765e99063b0$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $03778765e99063b0$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("gprnh", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", () => $bf243726b9e8e737$export$ae68c6db8b65046a);

var $6pzD4 = parcelRequire("6pzD4");
function $bf243726b9e8e737$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $6pzD4.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $6pzD4.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $6pzD4.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("e9sev", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d7ce6b3ba3c55f$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $24RUV = parcelRequire("24RUV");

var $9RZwn = parcelRequire("9RZwn");

var $fGwDt = parcelRequire("fGwDt");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $a4d7ce6b3ba3c55f$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $a4d7ce6b3ba3c55f$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $24RUV.default)(), lower48Point, alaska = (0, $9RZwn.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $9RZwn.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $a4d7ce6b3ba3c55f$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $6pzD4.epsilon),
                y + 0.120 * k + (0, $6pzD4.epsilon)
            ],
            [
                x - 0.214 * k - (0, $6pzD4.epsilon),
                y + 0.234 * k - (0, $6pzD4.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $6pzD4.epsilon),
                y + 0.166 * k + (0, $6pzD4.epsilon)
            ],
            [
                x - 0.115 * k - (0, $6pzD4.epsilon),
                y + 0.234 * k - (0, $6pzD4.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $fGwDt.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $fGwDt.fitSize)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $fGwDt.fitWidth)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $fGwDt.fitHeight)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("c6L2S", function(module, exports) {

$parcel$export(module.exports, "azimuthalEqualAreaRaw", () => $8d0a89cd4fed9f56$export$5e11f94fc4a8d2c6);
$parcel$export(module.exports, "default", () => $8d0a89cd4fed9f56$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $1dXpS = parcelRequire("1dXpS");

var $k6OY5 = parcelRequire("k6OY5");
var $8d0a89cd4fed9f56$export$5e11f94fc4a8d2c6 = (0, $1dXpS.azimuthalRaw)(function(cxcy) {
    return (0, $6pzD4.sqrt)(2 / (1 + cxcy));
});
$8d0a89cd4fed9f56$export$5e11f94fc4a8d2c6.invert = (0, $1dXpS.azimuthalInvert)(function(z) {
    return 2 * (0, $6pzD4.asin)(z / 2);
});
function $8d0a89cd4fed9f56$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($8d0a89cd4fed9f56$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("1dXpS", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", () => $0e45182d89b9a92e$export$f1211ac1bdb0796);
$parcel$export(module.exports, "azimuthalInvert", () => $0e45182d89b9a92e$export$3cee429f13e44eac);

var $6pzD4 = parcelRequire("6pzD4");
function $0e45182d89b9a92e$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $6pzD4.cos)(x), cy = (0, $6pzD4.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $6pzD4.sin)(x),
            k * (0, $6pzD4.sin)(y)
        ];
    };
}
function $0e45182d89b9a92e$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $6pzD4.sqrt)(x * x + y * y), c = angle(z), sc = (0, $6pzD4.sin)(c), cc = (0, $6pzD4.cos)(c);
        return [
            (0, $6pzD4.atan2)(x * sc, z * cc),
            (0, $6pzD4.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("ewvEK", function(module, exports) {

$parcel$export(module.exports, "azimuthalEquidistantRaw", () => $a92c9c1f2e0e629d$export$b94a4d6aa3dd25c);
$parcel$export(module.exports, "default", () => $a92c9c1f2e0e629d$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $1dXpS = parcelRequire("1dXpS");

var $k6OY5 = parcelRequire("k6OY5");
var $a92c9c1f2e0e629d$export$b94a4d6aa3dd25c = (0, $1dXpS.azimuthalRaw)(function(c) {
    return (c = (0, $6pzD4.acos)(c)) && c / (0, $6pzD4.sin)(c);
});
$a92c9c1f2e0e629d$export$b94a4d6aa3dd25c.invert = (0, $1dXpS.azimuthalInvert)(function(z) {
    return z;
});
function $a92c9c1f2e0e629d$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($a92c9c1f2e0e629d$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("bsnCY", function(module, exports) {

$parcel$export(module.exports, "conicConformalRaw", () => $8574a32e67662a75$export$2b1bc913962ed170);
$parcel$export(module.exports, "default", () => $8574a32e67662a75$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $bNFOO = parcelRequire("bNFOO");

var $2XkiJ = parcelRequire("2XkiJ");
function $8574a32e67662a75$var$tany(y) {
    return (0, $6pzD4.tan)(((0, $6pzD4.halfPi) + y) / 2);
}
function $8574a32e67662a75$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $6pzD4.cos)(y0), n = y0 === y1 ? (0, $6pzD4.sin)(y0) : (0, $6pzD4.log)(cy0 / (0, $6pzD4.cos)(y1)) / (0, $6pzD4.log)($8574a32e67662a75$var$tany(y1) / $8574a32e67662a75$var$tany(y0)), f = cy0 * (0, $6pzD4.pow)($8574a32e67662a75$var$tany(y0), n) / n;
    if (!n) return 0, $2XkiJ.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $6pzD4.halfPi) + (0, $6pzD4.epsilon)) y = -(0, $6pzD4.halfPi) + (0, $6pzD4.epsilon);
        } else if (y > (0, $6pzD4.halfPi) - (0, $6pzD4.epsilon)) y = (0, $6pzD4.halfPi) - (0, $6pzD4.epsilon);
        var r = f / (0, $6pzD4.pow)($8574a32e67662a75$var$tany(y), n);
        return [
            r * (0, $6pzD4.sin)(n * x),
            f - r * (0, $6pzD4.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $6pzD4.sign)(n) * (0, $6pzD4.sqrt)(x * x + fy * fy), l = (0, $6pzD4.atan2)(x, (0, $6pzD4.abs)(fy)) * (0, $6pzD4.sign)(fy);
        if (fy * n < 0) l -= (0, $6pzD4.pi) * (0, $6pzD4.sign)(x) * (0, $6pzD4.sign)(fy);
        return [
            l / n,
            2 * (0, $6pzD4.atan)((0, $6pzD4.pow)(f / r, 1 / n)) - (0, $6pzD4.halfPi)
        ];
    };
    return project;
}
function $8574a32e67662a75$export$2e2bcd8739ae039() {
    return (0, $bNFOO.conicProjection)($8574a32e67662a75$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("2XkiJ", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", () => $2270d6db16708641$export$94ff8a57e9b91cc3);
$parcel$export(module.exports, "default", () => $2270d6db16708641$export$2e2bcd8739ae039);
$parcel$export(module.exports, "mercatorProjection", () => $2270d6db16708641$export$44b9b66a01f2127b);

var $6pzD4 = parcelRequire("6pzD4");

var $7k5xN = parcelRequire("7k5xN");

var $k6OY5 = parcelRequire("k6OY5");
function $2270d6db16708641$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $6pzD4.log)((0, $6pzD4.tan)(((0, $6pzD4.halfPi) + phi) / 2))
    ];
}
$2270d6db16708641$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $6pzD4.atan)((0, $6pzD4.exp)(y)) - (0, $6pzD4.halfPi)
    ];
};
function $2270d6db16708641$export$2e2bcd8739ae039() {
    return $2270d6db16708641$export$44b9b66a01f2127b($2270d6db16708641$export$94ff8a57e9b91cc3).scale(961 / (0, $6pzD4.tau));
}
function $2270d6db16708641$export$44b9b66a01f2127b(project) {
    var m = (0, $k6OY5.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $6pzD4.pi) * scale(), t = m((0, $7k5xN.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $2270d6db16708641$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("hgI6X", function(module, exports) {

$parcel$export(module.exports, "conicEquidistantRaw", () => $c92625d8b177c54f$export$24f604fe80e5f192);
$parcel$export(module.exports, "default", () => $c92625d8b177c54f$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $bNFOO = parcelRequire("bNFOO");

var $hkLJu = parcelRequire("hkLJu");
function $c92625d8b177c54f$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $6pzD4.cos)(y0), n = y0 === y1 ? (0, $6pzD4.sin)(y0) : (cy0 - (0, $6pzD4.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $6pzD4.abs)(n) < (0, $6pzD4.epsilon)) return 0, $hkLJu.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $6pzD4.sin)(nx),
            g - gy * (0, $6pzD4.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $6pzD4.atan2)(x, (0, $6pzD4.abs)(gy)) * (0, $6pzD4.sign)(gy);
        if (gy * n < 0) l -= (0, $6pzD4.pi) * (0, $6pzD4.sign)(x) * (0, $6pzD4.sign)(gy);
        return [
            l / n,
            g - (0, $6pzD4.sign)(n) * (0, $6pzD4.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $c92625d8b177c54f$export$2e2bcd8739ae039() {
    return (0, $bNFOO.conicProjection)($c92625d8b177c54f$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("hkLJu", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", () => $c9e954a8c185b038$export$f5fee52180f2f058);
$parcel$export(module.exports, "default", () => $c9e954a8c185b038$export$2e2bcd8739ae039);

var $k6OY5 = parcelRequire("k6OY5");
function $c9e954a8c185b038$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$c9e954a8c185b038$export$f5fee52180f2f058.invert = $c9e954a8c185b038$export$f5fee52180f2f058;
function $c9e954a8c185b038$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($c9e954a8c185b038$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("6ZOLm", function(module, exports) {

$parcel$export(module.exports, "equalEarthRaw", () => $517fd1078508b72a$export$a320734067e7a731);
$parcel$export(module.exports, "default", () => $517fd1078508b72a$export$2e2bcd8739ae039);

var $k6OY5 = parcelRequire("k6OY5");

var $6pzD4 = parcelRequire("6pzD4");
var $517fd1078508b72a$var$A1 = 1.340264, $517fd1078508b72a$var$A2 = -0.081106, $517fd1078508b72a$var$A3 = 0.000893, $517fd1078508b72a$var$A4 = 0.003796, $517fd1078508b72a$var$M = (0, $6pzD4.sqrt)(3) / 2, $517fd1078508b72a$var$iterations = 12;
function $517fd1078508b72a$export$a320734067e7a731(lambda, phi) {
    var l = (0, $6pzD4.asin)($517fd1078508b72a$var$M * (0, $6pzD4.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $6pzD4.cos)(l) / ($517fd1078508b72a$var$M * ($517fd1078508b72a$var$A1 + 3 * $517fd1078508b72a$var$A2 * l2 + l6 * (7 * $517fd1078508b72a$var$A3 + 9 * $517fd1078508b72a$var$A4 * l2))),
        l * ($517fd1078508b72a$var$A1 + $517fd1078508b72a$var$A2 * l2 + l6 * ($517fd1078508b72a$var$A3 + $517fd1078508b72a$var$A4 * l2))
    ];
}
$517fd1078508b72a$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $517fd1078508b72a$var$iterations; ++i){
        fy = l * ($517fd1078508b72a$var$A1 + $517fd1078508b72a$var$A2 * l2 + l6 * ($517fd1078508b72a$var$A3 + $517fd1078508b72a$var$A4 * l2)) - y;
        fpy = $517fd1078508b72a$var$A1 + 3 * $517fd1078508b72a$var$A2 * l2 + l6 * (7 * $517fd1078508b72a$var$A3 + 9 * $517fd1078508b72a$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $6pzD4.abs)(delta) < (0, $6pzD4.epsilon2)) break;
    }
    return [
        $517fd1078508b72a$var$M * x * ($517fd1078508b72a$var$A1 + 3 * $517fd1078508b72a$var$A2 * l2 + l6 * (7 * $517fd1078508b72a$var$A3 + 9 * $517fd1078508b72a$var$A4 * l2)) / (0, $6pzD4.cos)(l),
        (0, $6pzD4.asin)((0, $6pzD4.sin)(l) / $517fd1078508b72a$var$M)
    ];
};
function $517fd1078508b72a$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($517fd1078508b72a$export$a320734067e7a731).scale(177.158);
}

});

parcelRegister("ePN5V", function(module, exports) {

$parcel$export(module.exports, "gnomonicRaw", () => $accbe947c94348e0$export$dc8c6ddfc8b22c85);
$parcel$export(module.exports, "default", () => $accbe947c94348e0$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $1dXpS = parcelRequire("1dXpS");

var $k6OY5 = parcelRequire("k6OY5");
function $accbe947c94348e0$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $6pzD4.cos)(y), k = (0, $6pzD4.cos)(x) * cy;
    return [
        cy * (0, $6pzD4.sin)(x) / k,
        (0, $6pzD4.sin)(y) / k
    ];
}
$accbe947c94348e0$export$dc8c6ddfc8b22c85.invert = (0, $1dXpS.azimuthalInvert)((0, $6pzD4.atan));
function $accbe947c94348e0$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($accbe947c94348e0$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("e1PVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3696f44eba8fd7e$export$2e2bcd8739ae039);

var $2LCTV = parcelRequire("2LCTV");

var $ebWea = parcelRequire("ebWea");

var $bit3e = parcelRequire("bit3e");

var $fGwDt = parcelRequire("fGwDt");

var $6pzD4 = parcelRequire("6pzD4");
function $a3696f44eba8fd7e$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $bit3e.transformer)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $ebWea.default), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $ebWea.default) : (0, $2LCTV.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $6pzD4.radians), sa = (0, $6pzD4.sin)(alpha), ca = (0, $6pzD4.cos)(alpha), reset()) : alpha * (0, $6pzD4.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $fGwDt.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $fGwDt.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $fGwDt.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $fGwDt.fitHeight)(projection, height, object);
    };
    return projection;
}

});

parcelRegister("ibFeJ", function(module, exports) {

$parcel$export(module.exports, "naturalEarth1Raw", () => $d3d93dc825a48e26$export$acb6def22fe878e6);
$parcel$export(module.exports, "default", () => $d3d93dc825a48e26$export$2e2bcd8739ae039);

var $k6OY5 = parcelRequire("k6OY5");

var $6pzD4 = parcelRequire("6pzD4");
function $d3d93dc825a48e26$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$d3d93dc825a48e26$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $6pzD4.abs)(delta) > (0, $6pzD4.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $d3d93dc825a48e26$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($d3d93dc825a48e26$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("gYyBI", function(module, exports) {

$parcel$export(module.exports, "orthographicRaw", () => $c5bd183dc11d824f$export$1cd9c2eb846182a);
$parcel$export(module.exports, "default", () => $c5bd183dc11d824f$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $1dXpS = parcelRequire("1dXpS");

var $k6OY5 = parcelRequire("k6OY5");
function $c5bd183dc11d824f$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $6pzD4.cos)(y) * (0, $6pzD4.sin)(x),
        (0, $6pzD4.sin)(y)
    ];
}
$c5bd183dc11d824f$export$1cd9c2eb846182a.invert = (0, $1dXpS.azimuthalInvert)((0, $6pzD4.asin));
function $c5bd183dc11d824f$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($c5bd183dc11d824f$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $6pzD4.epsilon));
}

});

parcelRegister("iuncC", function(module, exports) {

$parcel$export(module.exports, "stereographicRaw", () => $d75d06db550cd124$export$f9ccbb0dcb3dcd2b);
$parcel$export(module.exports, "default", () => $d75d06db550cd124$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $1dXpS = parcelRequire("1dXpS");

var $k6OY5 = parcelRequire("k6OY5");
function $d75d06db550cd124$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $6pzD4.cos)(y), k = 1 + (0, $6pzD4.cos)(x) * cy;
    return [
        cy * (0, $6pzD4.sin)(x) / k,
        (0, $6pzD4.sin)(y) / k
    ];
}
$d75d06db550cd124$export$f9ccbb0dcb3dcd2b.invert = (0, $1dXpS.azimuthalInvert)(function(z) {
    return 2 * (0, $6pzD4.atan)(z);
});
function $d75d06db550cd124$export$2e2bcd8739ae039() {
    return (0, $k6OY5.default)($d75d06db550cd124$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("bjR5r", function(module, exports) {

$parcel$export(module.exports, "transverseMercatorRaw", () => $83daa5fe00d96f79$export$e84942adec6de533);
$parcel$export(module.exports, "default", () => $83daa5fe00d96f79$export$2e2bcd8739ae039);

var $6pzD4 = parcelRequire("6pzD4");

var $2XkiJ = parcelRequire("2XkiJ");
function $83daa5fe00d96f79$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $6pzD4.log)((0, $6pzD4.tan)(((0, $6pzD4.halfPi) + phi) / 2)),
        -lambda
    ];
}
$83daa5fe00d96f79$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $6pzD4.atan)((0, $6pzD4.exp)(x)) - (0, $6pzD4.halfPi)
    ];
};
function $83daa5fe00d96f79$export$2e2bcd8739ae039() {
    var m = (0, $2XkiJ.mercatorProjection)($83daa5fe00d96f79$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});


parcelRegister("gwfK8", function(module, exports) {

$parcel$export(module.exports, "cluster", () => (parcelRequire("1Ezpx")).default);
$parcel$export(module.exports, "hierarchy", () => (parcelRequire("fW6ZT")).default);
$parcel$export(module.exports, "pack", () => (parcelRequire("gftuo")).default);
$parcel$export(module.exports, "packSiblings", () => (parcelRequire("8jEW4")).default);
$parcel$export(module.exports, "packEnclose", () => (parcelRequire("g0CEb")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("cocwQ")).default);
$parcel$export(module.exports, "stratify", () => (parcelRequire("bhgR2")).default);
$parcel$export(module.exports, "tree", () => (parcelRequire("3Annl")).default);
$parcel$export(module.exports, "treemap", () => (parcelRequire("3I6Qx")).default);
$parcel$export(module.exports, "treemapBinary", () => (parcelRequire("1umSj")).default);
$parcel$export(module.exports, "treemapDice", () => (parcelRequire("43RX6")).default);
$parcel$export(module.exports, "treemapSlice", () => (parcelRequire("fZgZ7")).default);
$parcel$export(module.exports, "treemapSliceDice", () => (parcelRequire("iyWQC")).default);
$parcel$export(module.exports, "treemapSquarify", () => (parcelRequire("a5gDW")).default);
$parcel$export(module.exports, "treemapResquarify", () => (parcelRequire("bzyEw")).default);

var $1Ezpx = parcelRequire("1Ezpx");

var $fW6ZT = parcelRequire("fW6ZT");

var $gftuo = parcelRequire("gftuo");

var $8jEW4 = parcelRequire("8jEW4");

var $g0CEb = parcelRequire("g0CEb");

var $cocwQ = parcelRequire("cocwQ");

var $bhgR2 = parcelRequire("bhgR2");

var $3Annl = parcelRequire("3Annl");

var $3I6Qx = parcelRequire("3I6Qx");

var $1umSj = parcelRequire("1umSj");

var $43RX6 = parcelRequire("43RX6");

var $fZgZ7 = parcelRequire("fZgZ7");

var $iyWQC = parcelRequire("iyWQC");

var $a5gDW = parcelRequire("a5gDW");

var $bzyEw = parcelRequire("bzyEw");

});
parcelRegister("1Ezpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1344feb6efdf274e$export$2e2bcd8739ae039);
function $1344feb6efdf274e$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $1344feb6efdf274e$var$meanX(children) {
    return children.reduce($1344feb6efdf274e$var$meanXReduce, 0) / children.length;
}
function $1344feb6efdf274e$var$meanXReduce(x, c) {
    return x + c.x;
}
function $1344feb6efdf274e$var$maxY(children) {
    return 1 + children.reduce($1344feb6efdf274e$var$maxYReduce, 0);
}
function $1344feb6efdf274e$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $1344feb6efdf274e$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $1344feb6efdf274e$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $1344feb6efdf274e$export$2e2bcd8739ae039() {
    var separation = $1344feb6efdf274e$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $1344feb6efdf274e$var$meanX(children);
                node.y = $1344feb6efdf274e$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $1344feb6efdf274e$var$leafLeft(root), right = $1344feb6efdf274e$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}

});

parcelRegister("fW6ZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a1b352881cb5ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Node", () => $b9a1b352881cb5ac$export$85c928794f8d04d4);
$parcel$export(module.exports, "computeHeight", () => $b9a1b352881cb5ac$export$5af32d52ab5dfd57);

var $5IuOJ = parcelRequire("5IuOJ");

var $dtUBq = parcelRequire("dtUBq");

var $kPxNS = parcelRequire("kPxNS");

var $01ReT = parcelRequire("01ReT");

var $hRtUa = parcelRequire("hRtUa");

var $90yJg = parcelRequire("90yJg");

var $eAOXI = parcelRequire("eAOXI");

var $8cnX6 = parcelRequire("8cnX6");

var $fL3Ws = parcelRequire("fL3Ws");

var $lWxTu = parcelRequire("lWxTu");

var $7qRKB = parcelRequire("7qRKB");

var $eIQXM = parcelRequire("eIQXM");

var $9r1yp = parcelRequire("9r1yp");
function $b9a1b352881cb5ac$export$2e2bcd8739ae039(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = $b9a1b352881cb5ac$var$mapChildren;
    } else if (children === undefined) children = $b9a1b352881cb5ac$var$objectChildren;
    var root = new $b9a1b352881cb5ac$export$85c928794f8d04d4(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new $b9a1b352881cb5ac$export$85c928794f8d04d4(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore($b9a1b352881cb5ac$export$5af32d52ab5dfd57);
}
function $b9a1b352881cb5ac$var$node_copy() {
    return $b9a1b352881cb5ac$export$2e2bcd8739ae039(this).eachBefore($b9a1b352881cb5ac$var$copyData);
}
function $b9a1b352881cb5ac$var$objectChildren(d) {
    return d.children;
}
function $b9a1b352881cb5ac$var$mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function $b9a1b352881cb5ac$var$copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function $b9a1b352881cb5ac$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $b9a1b352881cb5ac$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$b9a1b352881cb5ac$export$85c928794f8d04d4.prototype = $b9a1b352881cb5ac$export$2e2bcd8739ae039.prototype = {
    constructor: $b9a1b352881cb5ac$export$85c928794f8d04d4,
    count: (0, $5IuOJ.default),
    each: (0, $dtUBq.default),
    eachAfter: (0, $01ReT.default),
    eachBefore: (0, $kPxNS.default),
    find: (0, $hRtUa.default),
    sum: (0, $90yJg.default),
    sort: (0, $eAOXI.default),
    path: (0, $8cnX6.default),
    ancestors: (0, $fL3Ws.default),
    descendants: (0, $lWxTu.default),
    leaves: (0, $7qRKB.default),
    links: (0, $eIQXM.default),
    copy: $b9a1b352881cb5ac$var$node_copy,
    [Symbol.iterator]: (0, $9r1yp.default)
};

});
parcelRegister("5IuOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4298f77ec93adf66$export$2e2bcd8739ae039);
function $4298f77ec93adf66$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $4298f77ec93adf66$export$2e2bcd8739ae039() {
    return this.eachAfter($4298f77ec93adf66$var$count);
}

});

parcelRegister("dtUBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d09e3e97e0373c2$export$2e2bcd8739ae039);
function $9d09e3e97e0373c2$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this)callback.call(that, node, ++index, this);
    return this;
}

});

parcelRegister("kPxNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a2cac049090a91$export$2e2bcd8739ae039);
function $f2a2cac049090a91$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], children, i, index = -1;
    while(node = nodes.pop()){
        callback.call(that, node, ++index, this);
        if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}

});

parcelRegister("01ReT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0059644b258db2b7$export$2e2bcd8739ae039);
function $0059644b258db2b7$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n, index = -1;
    while(node = nodes.pop()){
        next.push(node);
        if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback.call(that, node, ++index, this);
    return this;
}

});

parcelRegister("hRtUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $035b12ed0b2f2ac3$export$2e2bcd8739ae039);
function $035b12ed0b2f2ac3$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this){
        if (callback.call(that, node, ++index, this)) return node;
    }
}

});

parcelRegister("90yJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ef0da08e94f4c7$export$2e2bcd8739ae039);
function $68ef0da08e94f4c7$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}

});

parcelRegister("eAOXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9fbf57ae5c2db58$export$2e2bcd8739ae039);
function $a9fbf57ae5c2db58$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}

});

parcelRegister("8cnX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8206224e6e47e7$export$2e2bcd8739ae039);
function $5f8206224e6e47e7$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $5f8206224e6e47e7$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $5f8206224e6e47e7$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

});

parcelRegister("fL3Ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78e4d96a445fe46$export$2e2bcd8739ae039);
function $b78e4d96a445fe46$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}

});

parcelRegister("lWxTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff994e6044bcc89a$export$2e2bcd8739ae039);
function $ff994e6044bcc89a$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("7qRKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5694a7deb02c3338$export$2e2bcd8739ae039);
function $5694a7deb02c3338$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}

});

parcelRegister("eIQXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab7e42226a187d8a$export$2e2bcd8739ae039);
function $ab7e42226a187d8a$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}

});

parcelRegister("9r1yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7d73deddfbf13$export$2e2bcd8739ae039);
function* $6de7d73deddfbf13$export$2e2bcd8739ae039() {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            yield node;
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
}

});


parcelRegister("gftuo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd44ec005c31f569$export$2e2bcd8739ae039);

var $8jEW4 = parcelRequire("8jEW4");

var $6JwHc = parcelRequire("6JwHc");

var $iADJ3 = parcelRequire("iADJ3");
function $bd44ec005c31f569$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $bd44ec005c31f569$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $iADJ3.constantZero);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($bd44ec005c31f569$var$radiusLeaf(radius)).eachAfter($bd44ec005c31f569$var$packChildren(padding, 0.5)).eachBefore($bd44ec005c31f569$var$translateChild(1));
        else root.eachBefore($bd44ec005c31f569$var$radiusLeaf($bd44ec005c31f569$var$defaultRadius)).eachAfter($bd44ec005c31f569$var$packChildren((0, $iADJ3.constantZero), 1)).eachAfter($bd44ec005c31f569$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($bd44ec005c31f569$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $6JwHc.optional)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $iADJ3.default)(+x), pack) : padding;
    };
    return pack;
}
function $bd44ec005c31f569$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $bd44ec005c31f569$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $8jEW4.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $bd44ec005c31f569$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

});
parcelRegister("8jEW4", function(module, exports) {

$parcel$export(module.exports, "packEnclose", () => $60dfda0b63487fe4$export$b86b5dcbc4bfc7a7);
$parcel$export(module.exports, "default", () => $60dfda0b63487fe4$export$2e2bcd8739ae039);

var $eMSqC = parcelRequire("eMSqC");

var $g0CEb = parcelRequire("g0CEb");
function $60dfda0b63487fe4$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $60dfda0b63487fe4$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $60dfda0b63487fe4$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $60dfda0b63487fe4$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $60dfda0b63487fe4$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = (circles = (0, $eMSqC.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $60dfda0b63487fe4$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $60dfda0b63487fe4$var$Node(a), b = new $60dfda0b63487fe4$var$Node(b), c = new $60dfda0b63487fe4$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $60dfda0b63487fe4$var$place(a._, b._, c = circles[i]), c = new $60dfda0b63487fe4$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($60dfda0b63487fe4$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($60dfda0b63487fe4$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $60dfda0b63487fe4$var$score(a);
        while((c = c.next) !== b)if ((ca = $60dfda0b63487fe4$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $g0CEb.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $60dfda0b63487fe4$export$2e2bcd8739ae039(circles) {
    $60dfda0b63487fe4$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}

});
parcelRegister("eMSqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3fc4b646408854$export$2e2bcd8739ae039);
$parcel$export(module.exports, "shuffle", () => $ac3fc4b646408854$export$448332262467e042);
function $ac3fc4b646408854$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}
function $ac3fc4b646408854$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

});

parcelRegister("g0CEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba7a9feb181291a0$export$2e2bcd8739ae039);

var $eMSqC = parcelRequire("eMSqC");
function $ba7a9feb181291a0$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $eMSqC.shuffle)(Array.from(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $ba7a9feb181291a0$var$enclosesWeak(e, p)) ++i;
        else e = $ba7a9feb181291a0$var$encloseBasis(B = $ba7a9feb181291a0$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $ba7a9feb181291a0$var$extendBasis(B, p) {
    var i, j;
    if ($ba7a9feb181291a0$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($ba7a9feb181291a0$var$enclosesNot(p, B[i]) && $ba7a9feb181291a0$var$enclosesWeakAll($ba7a9feb181291a0$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($ba7a9feb181291a0$var$enclosesNot($ba7a9feb181291a0$var$encloseBasis2(B[i], B[j]), p) && $ba7a9feb181291a0$var$enclosesNot($ba7a9feb181291a0$var$encloseBasis2(B[i], p), B[j]) && $ba7a9feb181291a0$var$enclosesNot($ba7a9feb181291a0$var$encloseBasis2(B[j], p), B[i]) && $ba7a9feb181291a0$var$enclosesWeakAll($ba7a9feb181291a0$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $ba7a9feb181291a0$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $ba7a9feb181291a0$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $ba7a9feb181291a0$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$ba7a9feb181291a0$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $ba7a9feb181291a0$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $ba7a9feb181291a0$var$encloseBasis1(B[0]);
        case 2:
            return $ba7a9feb181291a0$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $ba7a9feb181291a0$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $ba7a9feb181291a0$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $ba7a9feb181291a0$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $ba7a9feb181291a0$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

});


parcelRegister("6JwHc", function(module, exports) {

$parcel$export(module.exports, "optional", () => $4e704ebcbd31669f$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "required", () => $4e704ebcbd31669f$export$a7a0278c004aac3f);
function $4e704ebcbd31669f$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $4e704ebcbd31669f$export$a7a0278c004aac3f(f);
}
function $4e704ebcbd31669f$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

});

parcelRegister("iADJ3", function(module, exports) {

$parcel$export(module.exports, "constantZero", () => $d88a6776bb6afd81$export$99e2e371aa6a9db);
$parcel$export(module.exports, "default", () => $d88a6776bb6afd81$export$2e2bcd8739ae039);
function $d88a6776bb6afd81$export$99e2e371aa6a9db() {
    return 0;
}
function $d88a6776bb6afd81$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("cocwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $905171e1acab9b1b$export$2e2bcd8739ae039);

var $dSV0N = parcelRequire("dSV0N");

var $43RX6 = parcelRequire("43RX6");
function $905171e1acab9b1b$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $dSV0N.default));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $43RX6.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}

});
parcelRegister("dSV0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1bc8add441eb7eb$export$2e2bcd8739ae039);
function $a1bc8add441eb7eb$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}

});

parcelRegister("43RX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f514b0f15b79980$export$2e2bcd8739ae039);
function $2f514b0f15b79980$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});


parcelRegister("bhgR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $835e5b327108d383$export$2e2bcd8739ae039);

var $6JwHc = parcelRequire("6JwHc");

var $fW6ZT = parcelRequire("fW6ZT");
var $835e5b327108d383$var$preroot = {
    depth: -1
}, $835e5b327108d383$var$ambiguous = {};
function $835e5b327108d383$var$defaultId(d) {
    return d.id;
}
function $835e5b327108d383$var$defaultParentId(d) {
    return d.parentId;
}
function $835e5b327108d383$export$2e2bcd8739ae039() {
    var id = $835e5b327108d383$var$defaultId, parentId = $835e5b327108d383$var$defaultParentId;
    function stratify(data) {
        var nodes = Array.from(data), n = nodes.length, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
        for(i = 0; i < n; ++i){
            d = nodes[i], node = nodes[i] = new (0, $fW6ZT.Node)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = node.id = nodeId;
                nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? $835e5b327108d383$var$ambiguous : node);
            }
            if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
        }
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (nodeId = node.parent) {
                parent = nodeByKey.get(nodeId);
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $835e5b327108d383$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            } else {
                if (root) throw new Error("multiple roots");
                root = node;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $835e5b327108d383$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $fW6ZT.computeHeight));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $6JwHc.required)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $6JwHc.required)(x), stratify) : parentId;
    };
    return stratify;
}

});

parcelRegister("3Annl", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c6ddce4984be67$export$2e2bcd8739ae039);

var $fW6ZT = parcelRequire("fW6ZT");
function $29c6ddce4984be67$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $29c6ddce4984be67$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $29c6ddce4984be67$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $29c6ddce4984be67$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $29c6ddce4984be67$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $29c6ddce4984be67$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $29c6ddce4984be67$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$29c6ddce4984be67$var$TreeNode.prototype = Object.create((0, $fW6ZT.Node).prototype);
function $29c6ddce4984be67$var$treeRoot(root) {
    var tree = new $29c6ddce4984be67$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $29c6ddce4984be67$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $29c6ddce4984be67$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $29c6ddce4984be67$export$2e2bcd8739ae039() {
    var separation = $29c6ddce4984be67$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $29c6ddce4984be67$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $29c6ddce4984be67$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $29c6ddce4984be67$var$nextRight(vim), vip = $29c6ddce4984be67$var$nextLeft(vip), vim && vip){
                vom = $29c6ddce4984be67$var$nextLeft(vom);
                vop = $29c6ddce4984be67$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $29c6ddce4984be67$var$moveSubtree($29c6ddce4984be67$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$29c6ddce4984be67$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$29c6ddce4984be67$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}

});

parcelRegister("3I6Qx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b3acab81791f302$export$2e2bcd8739ae039);

var $dSV0N = parcelRequire("dSV0N");

var $a5gDW = parcelRequire("a5gDW");

var $6JwHc = parcelRequire("6JwHc");

var $iADJ3 = parcelRequire("iADJ3");
function $2b3acab81791f302$export$2e2bcd8739ae039() {
    var tile = (0, $a5gDW.default), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $iADJ3.constantZero), paddingTop = (0, $iADJ3.constantZero), paddingRight = (0, $iADJ3.constantZero), paddingBottom = (0, $iADJ3.constantZero), paddingLeft = (0, $iADJ3.constantZero);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $dSV0N.default));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $6JwHc.required)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $iADJ3.default)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $iADJ3.default)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $iADJ3.default)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $iADJ3.default)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $iADJ3.default)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

});
parcelRegister("a5gDW", function(module, exports) {

$parcel$export(module.exports, "phi", () => $757747ffbaa40136$export$324943737027944a);
$parcel$export(module.exports, "squarifyRatio", () => $757747ffbaa40136$export$9ff1217655212093);
$parcel$export(module.exports, "default", () => $757747ffbaa40136$export$2e2bcd8739ae039);

var $43RX6 = parcelRequire("43RX6");

var $fZgZ7 = parcelRequire("fZgZ7");
var $757747ffbaa40136$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $757747ffbaa40136$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $43RX6.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $fZgZ7.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $757747ffbaa40136$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $757747ffbaa40136$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($757747ffbaa40136$export$324943737027944a);

});
parcelRegister("fZgZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39ba5b3b3af0dd$export$2e2bcd8739ae039);
function $ba39ba5b3b3af0dd$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});



parcelRegister("1umSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $115a5643525a9fab$export$2e2bcd8739ae039);
function $115a5643525a9fab$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("iyWQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8390ce461d667d9$export$2e2bcd8739ae039);

var $43RX6 = parcelRequire("43RX6");

var $fZgZ7 = parcelRequire("fZgZ7");
function $d8390ce461d667d9$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $fZgZ7.default) : (0, $43RX6.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("bzyEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $86cdd7dd4602a739$export$2e2bcd8739ae039);

var $43RX6 = parcelRequire("43RX6");

var $fZgZ7 = parcelRequire("fZgZ7");

var $a5gDW = parcelRequire("a5gDW");
var $86cdd7dd4602a739$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $43RX6.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, $fZgZ7.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $a5gDW.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $a5gDW.phi));

});


parcelRegister("hI6ph", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => (parcelRequire("4PXvd")).default);
$parcel$export(module.exports, "interpolateArray", () => (parcelRequire("8aASV")).default);
$parcel$export(module.exports, "interpolateBasis", () => (parcelRequire("pN4j7")).default);
$parcel$export(module.exports, "interpolateBasisClosed", () => (parcelRequire("8d03e")).default);
$parcel$export(module.exports, "interpolateDate", () => (parcelRequire("3kqxa")).default);
$parcel$export(module.exports, "interpolateDiscrete", () => (parcelRequire("7ll2a")).default);
$parcel$export(module.exports, "interpolateHue", () => (parcelRequire("7NZ6h")).default);
$parcel$export(module.exports, "interpolateNumber", () => (parcelRequire("ggpD5")).default);
$parcel$export(module.exports, "interpolateNumberArray", () => (parcelRequire("3co7c")).default);
$parcel$export(module.exports, "interpolateObject", () => (parcelRequire("dZipD")).default);
$parcel$export(module.exports, "interpolateRound", () => (parcelRequire("ODyG2")).default);
$parcel$export(module.exports, "interpolateString", () => (parcelRequire("hHjDE")).default);
$parcel$export(module.exports, "interpolateTransformCss", () => (parcelRequire("8XBh2")).interpolateTransformCss);
$parcel$export(module.exports, "interpolateTransformSvg", () => (parcelRequire("8XBh2")).interpolateTransformSvg);
$parcel$export(module.exports, "interpolateZoom", () => (parcelRequire("ajJVo")).default);
$parcel$export(module.exports, "interpolateRgb", () => (parcelRequire("5AM6O")).default);
$parcel$export(module.exports, "interpolateRgbBasis", () => (parcelRequire("5AM6O")).rgbBasis);
$parcel$export(module.exports, "interpolateRgbBasisClosed", () => (parcelRequire("5AM6O")).rgbBasisClosed);
$parcel$export(module.exports, "interpolateHsl", () => (parcelRequire("2Hxkk")).default);
$parcel$export(module.exports, "interpolateHslLong", () => (parcelRequire("2Hxkk")).hslLong);
$parcel$export(module.exports, "interpolateLab", () => (parcelRequire("5dtM7")).default);
$parcel$export(module.exports, "interpolateHcl", () => (parcelRequire("chAuG")).default);
$parcel$export(module.exports, "interpolateHclLong", () => (parcelRequire("chAuG")).hclLong);
$parcel$export(module.exports, "interpolateCubehelix", () => (parcelRequire("h4rrQ")).default);
$parcel$export(module.exports, "interpolateCubehelixLong", () => (parcelRequire("h4rrQ")).cubehelixLong);
$parcel$export(module.exports, "piecewise", () => (parcelRequire("kqc7c")).default);
$parcel$export(module.exports, "quantize", () => (parcelRequire("JWfug")).default);

var $4PXvd = parcelRequire("4PXvd");

var $8aASV = parcelRequire("8aASV");

var $pN4j7 = parcelRequire("pN4j7");

var $8d03e = parcelRequire("8d03e");

var $3kqxa = parcelRequire("3kqxa");

var $7ll2a = parcelRequire("7ll2a");

var $7NZ6h = parcelRequire("7NZ6h");

var $ggpD5 = parcelRequire("ggpD5");

var $3co7c = parcelRequire("3co7c");

var $dZipD = parcelRequire("dZipD");

var $ODyG2 = parcelRequire("ODyG2");

var $hHjDE = parcelRequire("hHjDE");

var $8XBh2 = parcelRequire("8XBh2");

var $ajJVo = parcelRequire("ajJVo");

var $5AM6O = parcelRequire("5AM6O");

var $2Hxkk = parcelRequire("2Hxkk");

var $5dtM7 = parcelRequire("5dtM7");

var $chAuG = parcelRequire("chAuG");

var $h4rrQ = parcelRequire("h4rrQ");

var $kqc7c = parcelRequire("kqc7c");

var $JWfug = parcelRequire("JWfug");

});
parcelRegister("7ll2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $558acf7a0af11985$export$2e2bcd8739ae039);
function $558acf7a0af11985$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("7NZ6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aec813aaece13bd$export$2e2bcd8739ae039);

var $adQ5o = parcelRequire("adQ5o");
function $5aec813aaece13bd$export$2e2bcd8739ae039(a, b) {
    var i = (0, $adQ5o.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("ODyG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $09835b150e5e23f6$export$2e2bcd8739ae039);
function $09835b150e5e23f6$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ajJVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $782f4d66cab6427f$export$2e2bcd8739ae039);
var $782f4d66cab6427f$var$epsilon2 = 1e-12;
function $782f4d66cab6427f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $782f4d66cab6427f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $782f4d66cab6427f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $782f4d66cab6427f$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $782f4d66cab6427f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $782f4d66cab6427f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $782f4d66cab6427f$var$tanh(rho * s + r0) - $782f4d66cab6427f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $782f4d66cab6427f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("2Hxkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7972f198b89799$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hslLong", () => $1f7972f198b89799$export$a2c535e270a59256);

var $bxlao = parcelRequire("bxlao");

var $adQ5o = parcelRequire("adQ5o");
function $1f7972f198b89799$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $bxlao.hsl)(start)).h, (end = (0, $bxlao.hsl)(end)).h), s = (0, $adQ5o.default)(start.s, end.s), l = (0, $adQ5o.default)(start.l, end.l), opacity = (0, $adQ5o.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $1f7972f198b89799$export$2e2bcd8739ae039 = $1f7972f198b89799$var$hsl((0, $adQ5o.hue));
var $1f7972f198b89799$export$a2c535e270a59256 = $1f7972f198b89799$var$hsl((0, $adQ5o.default));

});

parcelRegister("5dtM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc543587123b8ae$export$2e2bcd8739ae039);

var $7xKu8 = parcelRequire("7xKu8");

var $adQ5o = parcelRequire("adQ5o");
function $3cc543587123b8ae$export$2e2bcd8739ae039(start, end) {
    var l = (0, $adQ5o.default)((start = (0, $7xKu8.default)(start)).l, (end = (0, $7xKu8.default)(end)).l), a = (0, $adQ5o.default)(start.a, end.a), b = (0, $adQ5o.default)(start.b, end.b), opacity = (0, $adQ5o.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("chAuG", function(module, exports) {

$parcel$export(module.exports, "default", () => $024ec3a3026f2f07$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hclLong", () => $024ec3a3026f2f07$export$5aaa50f7615f9b70);

var $7xKu8 = parcelRequire("7xKu8");

var $adQ5o = parcelRequire("adQ5o");
function $024ec3a3026f2f07$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7xKu8.hcl)(start)).h, (end = (0, $7xKu8.hcl)(end)).h), c = (0, $adQ5o.default)(start.c, end.c), l = (0, $adQ5o.default)(start.l, end.l), opacity = (0, $adQ5o.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $024ec3a3026f2f07$export$2e2bcd8739ae039 = $024ec3a3026f2f07$var$hcl((0, $adQ5o.hue));
var $024ec3a3026f2f07$export$5aaa50f7615f9b70 = $024ec3a3026f2f07$var$hcl((0, $adQ5o.default));

});

parcelRegister("h4rrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d81a078ed9c869$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cubehelixLong", () => $c6d81a078ed9c869$export$934fa09ad474a1b4);

var $lRTRF = parcelRequire("lRTRF");

var $adQ5o = parcelRequire("adQ5o");
function $c6d81a078ed9c869$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $lRTRF.default)(start)).h, (end = (0, $lRTRF.default)(end)).h), s = (0, $adQ5o.default)(start.s, end.s), l = (0, $adQ5o.default)(start.l, end.l), opacity = (0, $adQ5o.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $c6d81a078ed9c869$export$2e2bcd8739ae039 = $c6d81a078ed9c869$var$cubehelix((0, $adQ5o.hue));
var $c6d81a078ed9c869$export$934fa09ad474a1b4 = $c6d81a078ed9c869$var$cubehelix((0, $adQ5o.default));

});

parcelRegister("kqc7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eddfa22abbc0678d$export$2e2bcd8739ae039);

var $4PXvd = parcelRequire("4PXvd");
function $eddfa22abbc0678d$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $4PXvd.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("JWfug", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a16314c0cf178f$export$2e2bcd8739ae039);
function $08a16314c0cf178f$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("5Svs5", function(module, exports) {

$parcel$export(module.exports, "path", () => (parcelRequire("1ErJ0")).default);

var $1ErJ0 = parcelRequire("1ErJ0");

});

parcelRegister("eKigJ", function(module, exports) {

$parcel$export(module.exports, "polygonArea", () => (parcelRequire("dmAA3")).default);
$parcel$export(module.exports, "polygonCentroid", () => (parcelRequire("41JKR")).default);
$parcel$export(module.exports, "polygonHull", () => (parcelRequire("hTMEX")).default);
$parcel$export(module.exports, "polygonContains", () => (parcelRequire("3gMrw")).default);
$parcel$export(module.exports, "polygonLength", () => (parcelRequire("ZjbvZ")).default);

var $dmAA3 = parcelRequire("dmAA3");

var $41JKR = parcelRequire("41JKR");

var $hTMEX = parcelRequire("hTMEX");

var $3gMrw = parcelRequire("3gMrw");

var $ZjbvZ = parcelRequire("ZjbvZ");

});
parcelRegister("dmAA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9b491cddab207$export$2e2bcd8739ae039);
function $9ba9b491cddab207$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}

});

parcelRegister("41JKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eeabf63a1dffbc3$export$2e2bcd8739ae039);
function $2eeabf63a1dffbc3$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}

});

parcelRegister("hTMEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d07d518828b4ab1c$export$2e2bcd8739ae039);

var $2wnxw = parcelRequire("2wnxw");
function $d07d518828b4ab1c$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $d07d518828b4ab1c$var$computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, $2wnxw.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $d07d518828b4ab1c$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($d07d518828b4ab1c$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $d07d518828b4ab1c$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $d07d518828b4ab1c$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}

});
parcelRegister("2wnxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d60d4667d5a470c$export$2e2bcd8739ae039);
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $1d60d4667d5a470c$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

});


parcelRegister("3gMrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2618717d72b04c91$export$2e2bcd8739ae039);
function $2618717d72b04c91$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}

});

parcelRegister("ZjbvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b84944e925c9e58$export$2e2bcd8739ae039);
function $0b84944e925c9e58$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.hypot(xa, ya);
    }
    return perimeter;
}

});


parcelRegister("g2PCc", function(module, exports) {

$parcel$export(module.exports, "quadtree", () => (parcelRequire("20E0v")).default);

var $20E0v = parcelRequire("20E0v");

});

parcelRegister("kWcvL", function(module, exports) {

$parcel$export(module.exports, "randomUniform", () => (parcelRequire("7tGZK")).default);
$parcel$export(module.exports, "randomInt", () => (parcelRequire("cEeE3")).default);
$parcel$export(module.exports, "randomNormal", () => (parcelRequire("e3Hec")).default);
$parcel$export(module.exports, "randomLogNormal", () => (parcelRequire("hAi9g")).default);
$parcel$export(module.exports, "randomBates", () => (parcelRequire("1K9hZ")).default);
$parcel$export(module.exports, "randomIrwinHall", () => (parcelRequire("fDsKJ")).default);
$parcel$export(module.exports, "randomExponential", () => (parcelRequire("8is24")).default);
$parcel$export(module.exports, "randomPareto", () => (parcelRequire("bWnAW")).default);
$parcel$export(module.exports, "randomBernoulli", () => (parcelRequire("aWpVZ")).default);
$parcel$export(module.exports, "randomGeometric", () => (parcelRequire("c4pbB")).default);
$parcel$export(module.exports, "randomBinomial", () => (parcelRequire("e7xsb")).default);
$parcel$export(module.exports, "randomGamma", () => (parcelRequire("6uvle")).default);
$parcel$export(module.exports, "randomBeta", () => (parcelRequire("1TMEb")).default);
$parcel$export(module.exports, "randomWeibull", () => (parcelRequire("9hgAy")).default);
$parcel$export(module.exports, "randomCauchy", () => (parcelRequire("lEBin")).default);
$parcel$export(module.exports, "randomLogistic", () => (parcelRequire("3jqs1")).default);
$parcel$export(module.exports, "randomPoisson", () => (parcelRequire("1l5Gg")).default);
$parcel$export(module.exports, "randomLcg", () => (parcelRequire("ax1io")).default);

var $7tGZK = parcelRequire("7tGZK");

var $cEeE3 = parcelRequire("cEeE3");

var $e3Hec = parcelRequire("e3Hec");

var $hAi9g = parcelRequire("hAi9g");

var $1K9hZ = parcelRequire("1K9hZ");

var $fDsKJ = parcelRequire("fDsKJ");

var $8is24 = parcelRequire("8is24");

var $bWnAW = parcelRequire("bWnAW");

var $aWpVZ = parcelRequire("aWpVZ");

var $c4pbB = parcelRequire("c4pbB");

var $e7xsb = parcelRequire("e7xsb");

var $6uvle = parcelRequire("6uvle");

var $1TMEb = parcelRequire("1TMEb");

var $9hgAy = parcelRequire("9hgAy");

var $lEBin = parcelRequire("lEBin");

var $3jqs1 = parcelRequire("3jqs1");

var $1l5Gg = parcelRequire("1l5Gg");

var $ax1io = parcelRequire("ax1io");

});
parcelRegister("7tGZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $571c97bf4da4c917$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $571c97bf4da4c917$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $1vLPT.default));

});
parcelRegister("1vLPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $119dcaf14956a351$export$2e2bcd8739ae039);
var $119dcaf14956a351$export$2e2bcd8739ae039 = Math.random;

});


parcelRegister("cEeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $935494a9ddff51c5$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $935494a9ddff51c5$export$2e2bcd8739ae039 = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, $1vLPT.default));

});

parcelRegister("e3Hec", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c2e0b2122d3213$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $a3c2e0b2122d3213$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $1vLPT.default));

});

parcelRegister("hAi9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd3e060a4233b66$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $e3Hec = parcelRequire("e3Hec");
var $ccd3e060a4233b66$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    var N = (0, $e3Hec.default).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $1vLPT.default));

});

parcelRegister("1K9hZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $14514af4a7248b97$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $fDsKJ = parcelRequire("fDsKJ");
var $14514af4a7248b97$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    var I = (0, $fDsKJ.default).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $1vLPT.default));

});
parcelRegister("fDsKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b620cd3be2bae2f7$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $b620cd3be2bae2f7$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $1vLPT.default));

});


parcelRegister("8is24", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a5bfd1a83ccbf8$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $60a5bfd1a83ccbf8$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $1vLPT.default));

});

parcelRegister("bWnAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1769f0ad34a98a$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $8b1769f0ad34a98a$export$2e2bcd8739ae039 = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, $1vLPT.default));

});

parcelRegister("aWpVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f737032fbe78912$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $7f737032fbe78912$export$2e2bcd8739ae039 = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, $1vLPT.default));

});

parcelRegister("c4pbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c996532298ea815$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $8c996532298ea815$export$2e2bcd8739ae039 = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, $1vLPT.default));

});

parcelRegister("e7xsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47bab5001366e4d$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $1TMEb = parcelRequire("1TMEb");

var $c4pbB = parcelRequire("c4pbB");
var $a47bab5001366e4d$export$2e2bcd8739ae039 = function sourceRandomBinomial(source) {
    var G = (0, $c4pbB.default).source(source), B = (0, $1TMEb.default).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, $1vLPT.default));

});
parcelRegister("1TMEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1620a9c8b5c569d4$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $6uvle = parcelRequire("6uvle");
var $1620a9c8b5c569d4$export$2e2bcd8739ae039 = function sourceRandomBeta(source) {
    var G = (0, $6uvle.default).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, $1vLPT.default));

});
parcelRegister("6uvle", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9ddb319346c9cd$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $e3Hec = parcelRequire("e3Hec");
var $4b9ddb319346c9cd$export$2e2bcd8739ae039 = function sourceRandomGamma(source) {
    var randomNormal = (0, $e3Hec.default).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, $1vLPT.default));

});



parcelRegister("9hgAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1291bc22db0f14$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $6c1291bc22db0f14$export$2e2bcd8739ae039 = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, $1vLPT.default));

});

parcelRegister("lEBin", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3a437c6e244bd1$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $fc3a437c6e244bd1$export$2e2bcd8739ae039 = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, $1vLPT.default));

});

parcelRegister("3jqs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2697aa0a384a236d$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");
var $2697aa0a384a236d$export$2e2bcd8739ae039 = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, $1vLPT.default));

});

parcelRegister("1l5Gg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9c28b2708f5cde$export$2e2bcd8739ae039);

var $1vLPT = parcelRequire("1vLPT");

var $e7xsb = parcelRequire("e7xsb");

var $6uvle = parcelRequire("6uvle");
var $0f9c28b2708f5cde$export$2e2bcd8739ae039 = function sourceRandomPoisson(source) {
    var G = (0, $6uvle.default).source(source), B = (0, $e7xsb.default).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, $1vLPT.default));

});

parcelRegister("ax1io", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aadfdc22115d138$export$2e2bcd8739ae039);
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $7aadfdc22115d138$var$mul = 0x19660D;
const $7aadfdc22115d138$var$inc = 0x3C6EF35F;
const $7aadfdc22115d138$var$eps = 1 / 0x100000000;
function $7aadfdc22115d138$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $7aadfdc22115d138$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $7aadfdc22115d138$var$mul * state + $7aadfdc22115d138$var$inc | 0, $7aadfdc22115d138$var$eps * (state >>> 0));
}

});


parcelRegister("6DK8J", function(module, exports) {

$parcel$export(module.exports, "scaleBand", () => (parcelRequire("6fsuq")).default);
$parcel$export(module.exports, "scalePoint", () => (parcelRequire("6fsuq")).point);
$parcel$export(module.exports, "scaleIdentity", () => (parcelRequire("3f9zj")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("aSvrg")).default);
$parcel$export(module.exports, "scaleLog", () => (parcelRequire("lh0D1")).default);
$parcel$export(module.exports, "scaleSymlog", () => (parcelRequire("gGeSO")).default);
$parcel$export(module.exports, "scaleOrdinal", () => (parcelRequire("1lbp8")).default);
$parcel$export(module.exports, "scaleImplicit", () => (parcelRequire("1lbp8")).implicit);
$parcel$export(module.exports, "scalePow", () => (parcelRequire("3xref")).default);
$parcel$export(module.exports, "scaleSqrt", () => (parcelRequire("3xref")).sqrt);
$parcel$export(module.exports, "scaleRadial", () => (parcelRequire("7f4I4")).default);
$parcel$export(module.exports, "scaleQuantile", () => (parcelRequire("lawnp")).default);
$parcel$export(module.exports, "scaleQuantize", () => (parcelRequire("aYopJ")).default);
$parcel$export(module.exports, "scaleThreshold", () => (parcelRequire("9zJXE")).default);
$parcel$export(module.exports, "scaleTime", () => (parcelRequire("698oU")).default);
$parcel$export(module.exports, "scaleUtc", () => (parcelRequire("3pFRM")).default);
$parcel$export(module.exports, "scaleSequential", () => (parcelRequire("cUX6y")).default);
$parcel$export(module.exports, "scaleSequentialLog", () => (parcelRequire("cUX6y")).sequentialLog);
$parcel$export(module.exports, "scaleSequentialPow", () => (parcelRequire("cUX6y")).sequentialPow);
$parcel$export(module.exports, "scaleSequentialSqrt", () => (parcelRequire("cUX6y")).sequentialSqrt);
$parcel$export(module.exports, "scaleSequentialSymlog", () => (parcelRequire("cUX6y")).sequentialSymlog);
$parcel$export(module.exports, "scaleSequentialQuantile", () => (parcelRequire("eByw3")).default);
$parcel$export(module.exports, "scaleDiverging", () => (parcelRequire("wUwgT")).default);
$parcel$export(module.exports, "scaleDivergingLog", () => (parcelRequire("wUwgT")).divergingLog);
$parcel$export(module.exports, "scaleDivergingPow", () => (parcelRequire("wUwgT")).divergingPow);
$parcel$export(module.exports, "scaleDivergingSqrt", () => (parcelRequire("wUwgT")).divergingSqrt);
$parcel$export(module.exports, "scaleDivergingSymlog", () => (parcelRequire("wUwgT")).divergingSymlog);
$parcel$export(module.exports, "tickFormat", () => (parcelRequire("edgk5")).default);

var $6fsuq = parcelRequire("6fsuq");

var $3f9zj = parcelRequire("3f9zj");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $gGeSO = parcelRequire("gGeSO");

var $1lbp8 = parcelRequire("1lbp8");

var $3xref = parcelRequire("3xref");

var $7f4I4 = parcelRequire("7f4I4");

var $lawnp = parcelRequire("lawnp");

var $aYopJ = parcelRequire("aYopJ");

var $9zJXE = parcelRequire("9zJXE");

var $698oU = parcelRequire("698oU");

var $3pFRM = parcelRequire("3pFRM");

var $cUX6y = parcelRequire("cUX6y");

var $eByw3 = parcelRequire("eByw3");

var $wUwgT = parcelRequire("wUwgT");

var $edgk5 = parcelRequire("edgk5");

});
parcelRegister("6fsuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ca3e488b2a42bd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "point", () => $48ca3e488b2a42bd$export$105684a3041cb6f3);

var $5sIn2 = parcelRequire("5sIn2");

var $iGmDW = parcelRequire("iGmDW");

var $1lbp8 = parcelRequire("1lbp8");
function $48ca3e488b2a42bd$export$2e2bcd8739ae039() {
    var scale = (0, $1lbp8.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $5sIn2.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $48ca3e488b2a42bd$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $iGmDW.initRange).apply(rescale(), arguments);
}
function $48ca3e488b2a42bd$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $48ca3e488b2a42bd$var$pointish(copy());
    };
    return scale;
}
function $48ca3e488b2a42bd$export$105684a3041cb6f3() {
    return $48ca3e488b2a42bd$var$pointish($48ca3e488b2a42bd$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("5sIn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa1fc580654d03a$export$2e2bcd8739ae039);
function $3fa1fc580654d03a$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("iGmDW", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $d99db6b9f4809fde$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $d99db6b9f4809fde$export$7d6b419e59e83f3d);
function $d99db6b9f4809fde$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $d99db6b9f4809fde$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("1lbp8", function(module, exports) {

$parcel$export(module.exports, "implicit", () => $0fa099478f81ee7e$export$e4f898ab14d9d460);
$parcel$export(module.exports, "default", () => $0fa099478f81ee7e$export$2e2bcd8739ae039);

var $iGmDW = parcelRequire("iGmDW");
const $0fa099478f81ee7e$export$e4f898ab14d9d460 = Symbol("implicit");
function $0fa099478f81ee7e$export$2e2bcd8739ae039() {
    var index = new Map(), domain = [], range = [], unknown = $0fa099478f81ee7e$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $0fa099478f81ee7e$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0fa099478f81ee7e$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}

});


parcelRegister("3f9zj", function(module, exports) {

$parcel$export(module.exports, "default", () => $25ca31efb1610c90$export$2e2bcd8739ae039);

var $aSvrg = parcelRequire("aSvrg");

var $6sY3H = parcelRequire("6sY3H");
function $25ca31efb1610c90$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6sY3H.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $25ca31efb1610c90$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $6sY3H.default)) : [
        0,
        1
    ];
    return (0, $aSvrg.linearish)(scale);
}

});
parcelRegister("aSvrg", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $7eb7559767ab28a3$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $7eb7559767ab28a3$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $edgk5 = parcelRequire("edgk5");
function $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $3um73.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $edgk5.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $3um73.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $7eb7559767ab28a3$export$2e2bcd8739ae039() {
    var scale = (0, $aNOl6.default)();
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $7eb7559767ab28a3$export$2e2bcd8739ae039());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("3um73", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a55395a79a6785$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $28a55395a79a6785$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $28a55395a79a6785$export$81087d9b915d4ede);
var $28a55395a79a6785$var$e10 = Math.sqrt(50), $28a55395a79a6785$var$e5 = Math.sqrt(10), $28a55395a79a6785$var$e2 = Math.sqrt(2);
function $28a55395a79a6785$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1);
}
function $28a55395a79a6785$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $28a55395a79a6785$var$e10) step1 *= 10;
    else if (error >= $28a55395a79a6785$var$e5) step1 *= 5;
    else if (error >= $28a55395a79a6785$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("aNOl6", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7dd587536c83aff7$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $7dd587536c83aff7$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $7dd587536c83aff7$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $7dd587536c83aff7$export$2e2bcd8739ae039);

var $cB7hd = parcelRequire("cB7hd");

var $6JuYh = parcelRequire("6JuYh");
var $fxmGQ = parcelRequire("fxmGQ");
var $bmlMK = parcelRequire("bmlMK");

var $84Czd = parcelRequire("84Czd");

var $6sY3H = parcelRequire("6sY3H");
var $7dd587536c83aff7$var$unit = [
    0,
    1
];
function $7dd587536c83aff7$export$f0954fd7d5368655(x) {
    return x;
}
function $7dd587536c83aff7$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $84Czd.default)(isNaN(b) ? NaN : 0.5);
}
function $7dd587536c83aff7$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $7dd587536c83aff7$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $7dd587536c83aff7$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $7dd587536c83aff7$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $7dd587536c83aff7$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $7dd587536c83aff7$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $cB7hd.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $7dd587536c83aff7$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $7dd587536c83aff7$export$6b468dcfb64c653c() {
    var domain = $7dd587536c83aff7$var$unit, range = $7dd587536c83aff7$var$unit, interpolate = (0, $6JuYh.default), transform, untransform, unknown, clamp = $7dd587536c83aff7$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $7dd587536c83aff7$export$f0954fd7d5368655) clamp = $7dd587536c83aff7$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $7dd587536c83aff7$var$polymap : $7dd587536c83aff7$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $fxmGQ.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6sY3H.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $bmlMK.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $7dd587536c83aff7$export$f0954fd7d5368655, rescale()) : clamp !== $7dd587536c83aff7$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $7dd587536c83aff7$export$2e2bcd8739ae039() {
    return $7dd587536c83aff7$export$6b468dcfb64c653c()($7dd587536c83aff7$export$f0954fd7d5368655, $7dd587536c83aff7$export$f0954fd7d5368655);
}

});
parcelRegister("cB7hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92be95bfb77a34dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");

var $1xmrF = parcelRequire("1xmrF");

var $30m79 = parcelRequire("30m79");
const $92be95bfb77a34dd$var$ascendingBisect = (0, $1xmrF.default)((0, $733O4.default));
const $92be95bfb77a34dd$export$4d945ad3ad5751b0 = $92be95bfb77a34dd$var$ascendingBisect.right;
const $92be95bfb77a34dd$export$df7d25c84ebd12a5 = $92be95bfb77a34dd$var$ascendingBisect.left;
const $92be95bfb77a34dd$export$c1cb828b1117c77b = (0, $1xmrF.default)((0, $30m79.default)).center;
var $92be95bfb77a34dd$export$2e2bcd8739ae039 = $92be95bfb77a34dd$export$4d945ad3ad5751b0;

});
parcelRegister("733O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $521bc42303c41d3f$export$2e2bcd8739ae039);
function $521bc42303c41d3f$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1xmrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ea48af9b87e2dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
function $11ea48af9b87e2dd$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $11ea48af9b87e2dd$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $11ea48af9b87e2dd$var$ascendingComparator(f) {
    return (d, x)=>(0, $733O4.default)(f(d), x);
}

});

parcelRegister("30m79", function(module, exports) {

$parcel$export(module.exports, "default", () => $230286a6954ff4a3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "numbers", () => $230286a6954ff4a3$export$1f6c9cc012ebacae);
function $230286a6954ff4a3$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $230286a6954ff4a3$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("6JuYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6ef844ac4b3a47$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $dFDiJ = parcelRequire("dFDiJ");

var $3IkHg = parcelRequire("3IkHg");

var $fw8eO = parcelRequire("fw8eO");

var $fxmGQ = parcelRequire("fxmGQ");

var $9oPd3 = parcelRequire("9oPd3");

var $dNfKS = parcelRequire("dNfKS");

var $lFlsW = parcelRequire("lFlsW");

var $k994c = parcelRequire("k994c");
function $4e6ef844ac4b3a47$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $lFlsW.default)(b) : (t === "number" ? (0, $fxmGQ.default) : t === "string" ? (c = (0, $e1U5l.default)(b)) ? (b = c, $dFDiJ.default) : (0, $dNfKS.default) : b instanceof (0, $e1U5l.default) ? (0, $dFDiJ.default) : b instanceof Date ? (0, $fw8eO.default) : (0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : Array.isArray(b) ? (0, $3IkHg.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $9oPd3.default) : (0, $fxmGQ.default))(a, b);
}

});
parcelRegister("e1U5l", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $ioX81 = parcelRequire("ioX81");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $ioX81.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Rgb, rgb, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Hsl, hsl, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("ioX81", function(module, exports) {

$parcel$export(module.exports, "default", () => $037509a362c79022$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $037509a362c79022$export$8b58be045bf06082);
function $037509a362c79022$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $037509a362c79022$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dFDiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3d9714057a674e$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $etJnf = parcelRequire("etJnf");

var $e5IXz = parcelRequire("e5IXz");

var $kKoo2 = parcelRequire("kKoo2");
var $9f3d9714057a674e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $kKoo2.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $e1U5l.rgb)(start)).r, (end = (0, $e1U5l.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $kKoo2.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9f3d9714057a674e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $e1U5l.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9f3d9714057a674e$export$2c0e28f2e2852d3f = $9f3d9714057a674e$var$rgbSpline((0, $etJnf.default));
var $9f3d9714057a674e$export$53d5214f625ccd4c = $9f3d9714057a674e$var$rgbSpline((0, $e5IXz.default));

});
parcelRegister("etJnf", function(module, exports) {

$parcel$export(module.exports, "basis", () => $a8a6f872a67f9f91$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $a8a6f872a67f9f91$export$2e2bcd8739ae039);
function $a8a6f872a67f9f91$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a8a6f872a67f9f91$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a8a6f872a67f9f91$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("e5IXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4246869a2b2013d$export$2e2bcd8739ae039);

var $etJnf = parcelRequire("etJnf");
function $a4246869a2b2013d$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $etJnf.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("kKoo2", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $f1ab053cfa8196f9$export$2e2bcd8739ae039);

var $lFlsW = parcelRequire("lFlsW");
function $f1ab053cfa8196f9$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $f1ab053cfa8196f9$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $f1ab053cfa8196f9$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}
function $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $f1ab053cfa8196f9$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $f1ab053cfa8196f9$var$exponential(a, b, y) : (0, $lFlsW.default)(isNaN(a) ? b : a);
    };
}
function $f1ab053cfa8196f9$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}

});
parcelRegister("lFlsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5e13f4bdfeecbb$export$2e2bcd8739ae039);
var $fc5e13f4bdfeecbb$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("3IkHg", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $2b45891ca744d3db$export$15d09067c6a5ee49);

var $6JuYh = parcelRequire("6JuYh");

var $k994c = parcelRequire("k994c");
function $2b45891ca744d3db$export$2e2bcd8739ae039(a, b) {
    return ((0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : $2b45891ca744d3db$export$15d09067c6a5ee49)(a, b);
}
function $2b45891ca744d3db$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6JuYh.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("k994c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaabae5aec58682c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $eaabae5aec58682c$export$5cd576d1827d40c8);
function $eaabae5aec58682c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $eaabae5aec58682c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("fw8eO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c03c06faca7439$export$2e2bcd8739ae039);
function $b4c03c06faca7439$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("fxmGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fb89d7e21add48$export$2e2bcd8739ae039);
function $b4fb89d7e21add48$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("9oPd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7e141c27bcdec9$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $6d7e141c27bcdec9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6JuYh.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("dNfKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ac1293c2d5ecbd$export$2e2bcd8739ae039);

var $fxmGQ = parcelRequire("fxmGQ");
var $a0ac1293c2d5ecbd$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $a0ac1293c2d5ecbd$var$reB = new RegExp($a0ac1293c2d5ecbd$var$reA.source, "g");
function $a0ac1293c2d5ecbd$var$zero(b) {
    return function() {
        return b;
    };
}
function $a0ac1293c2d5ecbd$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $a0ac1293c2d5ecbd$export$2e2bcd8739ae039(a, b) {
    var bi = $a0ac1293c2d5ecbd$var$reA.lastIndex = $a0ac1293c2d5ecbd$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $a0ac1293c2d5ecbd$var$reA.exec(a)) && (bm = $a0ac1293c2d5ecbd$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fxmGQ.default)(am, bm)
            });
        }
        bi = $a0ac1293c2d5ecbd$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $a0ac1293c2d5ecbd$var$one(q[0].x) : $a0ac1293c2d5ecbd$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("bmlMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8452a5df9255c68e$export$2e2bcd8739ae039);
function $8452a5df9255c68e$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("84Czd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0c9d0e02557db5$export$2e2bcd8739ae039);
function $5e0c9d0e02557db5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("6sY3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b53f1fd03e1a986$export$2e2bcd8739ae039);
function $4b53f1fd03e1a986$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("edgk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58ef0ffdff81f44$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");
var $eHEu2 = parcelRequire("eHEu2");
var $5FDlc = parcelRequire("5FDlc");
var $81T5G = parcelRequire("81T5G");
var $djxyw = parcelRequire("djxyw");
function $a58ef0ffdff81f44$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $3um73.tickStep)(start, stop, count), precision;
    specifier = (0, $eHEu2.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $81T5G.default)(step, value))) specifier.precision = precision;
            return (0, $2Znxj.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $djxyw.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5FDlc.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $2Znxj.format)(specifier);
}

});
parcelRegister("2Znxj", function(module, exports) {

$parcel$export(module.exports, "format", () => $22d3891b0a8207dc$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $22d3891b0a8207dc$export$8d85692a469dde6f);

var $6jrXW = parcelRequire("6jrXW");
var $22d3891b0a8207dc$var$locale;
var $22d3891b0a8207dc$export$d9468344d3651243;
var $22d3891b0a8207dc$export$8d85692a469dde6f;
$22d3891b0a8207dc$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $22d3891b0a8207dc$export$2e2bcd8739ae039(definition) {
    $22d3891b0a8207dc$var$locale = (0, $6jrXW.default)(definition);
    $22d3891b0a8207dc$export$d9468344d3651243 = $22d3891b0a8207dc$var$locale.format;
    $22d3891b0a8207dc$export$8d85692a469dde6f = $22d3891b0a8207dc$var$locale.formatPrefix;
    return $22d3891b0a8207dc$var$locale;
}

});
parcelRegister("6jrXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $498a35d68f49e7e2$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");

var $7wwOm = parcelRequire("7wwOm");

var $2fbAQ = parcelRequire("2fbAQ");

var $eHEu2 = parcelRequire("eHEu2");

var $aW3cW = parcelRequire("aW3cW");

var $7XVtR = parcelRequire("7XVtR");

var $4j2D3 = parcelRequire("4j2D3");

var $cFVbY = parcelRequire("cFVbY");
var $498a35d68f49e7e2$var$map = Array.prototype.map, $498a35d68f49e7e2$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $498a35d68f49e7e2$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $cFVbY.default) : (0, $7wwOm.default)($498a35d68f49e7e2$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $cFVbY.default) : (0, $2fbAQ.default)($498a35d68f49e7e2$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $eHEu2.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $7XVtR.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $7XVtR.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $aW3cW.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $498a35d68f49e7e2$var$prefixes[8 + (0, $4j2D3.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $eHEu2.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $498a35d68f49e7e2$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("KN7ee", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ca65535483c84a$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $08ca65535483c84a$export$2e2bcd8739ae039(x) {
    return x = (0, $7IWiR.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("7IWiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f9de4283371c3d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $59f9de4283371c3d$export$8f8e23dd27dc19f5);
function $59f9de4283371c3d$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $59f9de4283371c3d$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("7wwOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a4f9340c729126$export$2e2bcd8739ae039);
function $57a4f9340c729126$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2fbAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a25f9af2d42035d$export$2e2bcd8739ae039);
function $1a25f9af2d42035d$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("eHEu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab447c01a5372829$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $ab447c01a5372829$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $ab447c01a5372829$export$2e2bcd8739ae039(specifier) {
    if (!(match = $ab447c01a5372829$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $ab447c01a5372829$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$ab447c01a5372829$export$2e2bcd8739ae039.prototype = $ab447c01a5372829$export$963aac351db36ed4.prototype; // instanceof
function $ab447c01a5372829$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$ab447c01a5372829$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("aW3cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f61cf24ddaee9e2$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $7f61cf24ddaee9e2$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("7XVtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ccaa18de028dacc$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");

var $4j2D3 = parcelRequire("4j2D3");

var $bb5Zx = parcelRequire("bb5Zx");
var $5ccaa18de028dacc$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $7IWiR.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $bb5Zx.default)(x * 100, p),
    "r": (0, $bb5Zx.default),
    "s": (0, $4j2D3.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("4j2D3", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $322af9d78239adb9$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $322af9d78239adb9$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
var $322af9d78239adb9$export$6863724d9a42263;
function $322af9d78239adb9$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($322af9d78239adb9$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7IWiR.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("bb5Zx", function(module, exports) {

$parcel$export(module.exports, "default", () => $82355e931f5c47fe$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $82355e931f5c47fe$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cFVbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a5ad840c97a223$export$2e2bcd8739ae039);
function $93a5ad840c97a223$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("5FDlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $420f4c647bf8858f$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $420f4c647bf8858f$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("81T5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d89269b2b96d903$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $5d89269b2b96d903$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3 - (0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("djxyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b17143390a46e38$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $9b17143390a46e38$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $KN7ee.default)(max) - (0, $KN7ee.default)(step)) + 1;
}

});




parcelRegister("lh0D1", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $f7cbac45ef330d6b$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $f7cbac45ef330d6b$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");

var $7vI1J = parcelRequire("7vI1J");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $f7cbac45ef330d6b$var$transformLog(x) {
    return Math.log(x);
}
function $f7cbac45ef330d6b$var$transformExp(x) {
    return Math.exp(x);
}
function $f7cbac45ef330d6b$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f7cbac45ef330d6b$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f7cbac45ef330d6b$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f7cbac45ef330d6b$var$powp(base) {
    return base === 10 ? $f7cbac45ef330d6b$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $f7cbac45ef330d6b$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $f7cbac45ef330d6b$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $f7cbac45ef330d6b$export$860836db074028f0(transform) {
    var scale = transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $f7cbac45ef330d6b$var$logp(base), pows = $f7cbac45ef330d6b$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f7cbac45ef330d6b$var$reflect(logs), pows = $f7cbac45ef330d6b$var$reflect(pows);
            transform($f7cbac45ef330d6b$var$transformLogn, $f7cbac45ef330d6b$var$transformExpn);
        } else transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $3um73.default)(u, v, n);
        } else z = (0, $3um73.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $2Znxj.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $7vI1J.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $f7cbac45ef330d6b$export$2e2bcd8739ae039() {
    var scale = $f7cbac45ef330d6b$export$860836db074028f0((0, $aNOl6.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $f7cbac45ef330d6b$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("7vI1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $577d948182c6aae1$export$2e2bcd8739ae039);
function $577d948182c6aae1$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("gGeSO", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $c24c1d0768db7e3c$export$4602684e614eba38);
$parcel$export(module.exports, "default", () => $c24c1d0768db7e3c$export$2e2bcd8739ae039);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $c24c1d0768db7e3c$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $c24c1d0768db7e3c$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $c24c1d0768db7e3c$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($c24c1d0768db7e3c$var$transformSymlog(c), $c24c1d0768db7e3c$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($c24c1d0768db7e3c$var$transformSymlog(c = +_), $c24c1d0768db7e3c$var$transformSymexp(c)) : c;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $c24c1d0768db7e3c$export$2e2bcd8739ae039() {
    var scale = $c24c1d0768db7e3c$export$4602684e614eba38((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $c24c1d0768db7e3c$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $iGmDW.initRange).apply(scale, arguments);
}

});

parcelRegister("3xref", function(module, exports) {

$parcel$export(module.exports, "powish", () => $29399341a46df5cd$export$34695211ec403a46);
$parcel$export(module.exports, "default", () => $29399341a46df5cd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sqrt", () => $29399341a46df5cd$export$eba8049fb5020b81);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $29399341a46df5cd$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $29399341a46df5cd$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $29399341a46df5cd$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $29399341a46df5cd$export$34695211ec403a46(transform) {
    var scale = transform((0, $aNOl6.identity), (0, $aNOl6.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $aNOl6.identity), (0, $aNOl6.identity)) : exponent === 0.5 ? transform($29399341a46df5cd$var$transformSqrt, $29399341a46df5cd$var$transformSquare) : transform($29399341a46df5cd$var$transformPow(exponent), $29399341a46df5cd$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $29399341a46df5cd$export$2e2bcd8739ae039() {
    var scale = $29399341a46df5cd$export$34695211ec403a46((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $29399341a46df5cd$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}
function $29399341a46df5cd$export$eba8049fb5020b81() {
    return $29399341a46df5cd$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("7f4I4", function(module, exports) {

$parcel$export(module.exports, "default", () => $545d96634f47af1c$export$2e2bcd8739ae039);

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $6sY3H = parcelRequire("6sY3H");
function $545d96634f47af1c$var$square(x) {
    return Math.sign(x) * x * x;
}
function $545d96634f47af1c$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $545d96634f47af1c$export$2e2bcd8739ae039() {
    var squared = (0, $aNOl6.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $545d96634f47af1c$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($545d96634f47af1c$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $6sY3H.default))).map($545d96634f47af1c$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $545d96634f47af1c$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return (0, $aSvrg.linearish)(scale);
}

});

parcelRegister("lawnp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f693a571ec5de761$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
var $cB7hd = parcelRequire("cB7hd");
var $6hpNw = parcelRequire("6hpNw");

var $iGmDW = parcelRequire("iGmDW");
function $f693a571ec5de761$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $6hpNw.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $cB7hd.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $733O4.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $f693a571ec5de761$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $iGmDW.initRange).apply(scale, arguments);
}

});
parcelRegister("6hpNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $49285781773dfab7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "quantileSorted", () => $49285781773dfab7$export$f924a6cad778dddb);

var $clxq8 = parcelRequire("clxq8");

var $6WYRU = parcelRequire("6WYRU");

var $fxUWn = parcelRequire("fxUWn");

var $30m79 = parcelRequire("30m79");
function $49285781773dfab7$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $30m79.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $6WYRU.default)(values);
    if (p >= 1) return (0, $clxq8.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $clxq8.default)((0, $fxUWn.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $6WYRU.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $49285781773dfab7$export$f924a6cad778dddb(values, p, valueof = (0, $30m79.default)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("clxq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd15ecf9bd5e232$export$2e2bcd8739ae039);
function $8fd15ecf9bd5e232$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("6WYRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f760110e98a642$export$2e2bcd8739ae039);
function $50f760110e98a642$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("fxUWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5161b4d19b4b49f$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
function $b5161b4d19b4b49f$export$2e2bcd8739ae039(array, k, left = 0, right = array.length - 1, compare = (0, $733O4.default)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $b5161b4d19b4b49f$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $b5161b4d19b4b49f$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $b5161b4d19b4b49f$var$swap(array, left, right);
        while(i < j){
            $b5161b4d19b4b49f$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $b5161b4d19b4b49f$var$swap(array, left, j);
        else ++j, $b5161b4d19b4b49f$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $b5161b4d19b4b49f$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("aYopJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fd272133fdf6d47$export$2e2bcd8739ae039);

var $cB7hd = parcelRequire("cB7hd");

var $aSvrg = parcelRequire("aSvrg");

var $iGmDW = parcelRequire("iGmDW");
function $7fd272133fdf6d47$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cB7hd.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $7fd272133fdf6d47$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $iGmDW.initRange).apply((0, $aSvrg.linearish)(scale), arguments);
}

});

parcelRegister("9zJXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8b08d626822abe$export$2e2bcd8739ae039);

var $cB7hd = parcelRequire("cB7hd");

var $iGmDW = parcelRequire("iGmDW");
function $6f8b08d626822abe$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cB7hd.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $6f8b08d626822abe$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $iGmDW.initRange).apply(scale, arguments);
}

});

parcelRegister("698oU", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $479a1991a412010b$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $479a1991a412010b$export$2e2bcd8739ae039);

var $dC7VU = parcelRequire("dC7VU");
var $1TIln = parcelRequire("1TIln");
var $fNSZa = parcelRequire("fNSZa");
var $3Q36U = parcelRequire("3Q36U");
var $cK13a = parcelRequire("cK13a");
var $g1UtK = parcelRequire("g1UtK");
var $gLr5w = parcelRequire("gLr5w");
var $6uU17 = parcelRequire("6uU17");

var $cg8H6 = parcelRequire("cg8H6");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $7vI1J = parcelRequire("7vI1J");
function $479a1991a412010b$var$date(t) {
    return new Date(t);
}
function $479a1991a412010b$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $479a1991a412010b$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $aNOl6.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $479a1991a412010b$var$number)) : domain().map($479a1991a412010b$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $7vI1J.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $479a1991a412010b$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $479a1991a412010b$export$2e2bcd8739ae039() {
    return (0, $iGmDW.initRange).apply($479a1991a412010b$export$56bbcdb8aca31149((0, $g1UtK.timeTicks), (0, $g1UtK.timeTickInterval), (0, $6uU17.default), (0, $3Q36U.default), (0, $gLr5w.sunday), (0, $dC7VU.default), (0, $1TIln.default), (0, $fNSZa.default), (0, $cK13a.default), (0, $cg8H6.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("dC7VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e94fa4a89193b67$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $9e94fa4a89193b67$var$day = (0, $48K44.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $bYVTi.durationMinute)) / (0, $bYVTi.durationDay), (date)=>date.getDate() - 1);
var $9e94fa4a89193b67$export$2e2bcd8739ae039 = $9e94fa4a89193b67$var$day;
var $9e94fa4a89193b67$export$3cf5dda4201cc0f2 = $9e94fa4a89193b67$var$day.range;

});
parcelRegister("48K44", function(module, exports) {

$parcel$export(module.exports, "default", () => $303ba43cd74b67a3$export$2e2bcd8739ae039);
var $303ba43cd74b67a3$var$t0 = new Date, $303ba43cd74b67a3$var$t1 = new Date;
function $303ba43cd74b67a3$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $303ba43cd74b67a3$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $303ba43cd74b67a3$var$t0.setTime(+start), $303ba43cd74b67a3$var$t1.setTime(+end);
            floori($303ba43cd74b67a3$var$t0), floori($303ba43cd74b67a3$var$t1);
            return Math.floor(count($303ba43cd74b67a3$var$t0, $303ba43cd74b67a3$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("bYVTi", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $8b923436b1c7c2d4$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $8b923436b1c7c2d4$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $8b923436b1c7c2d4$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $8b923436b1c7c2d4$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $8b923436b1c7c2d4$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $8b923436b1c7c2d4$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $8b923436b1c7c2d4$export$61f8ee2d834c6959);
const $8b923436b1c7c2d4$export$79ef0e34099623dc = 1000;
const $8b923436b1c7c2d4$export$683905d551c33fa9 = $8b923436b1c7c2d4$export$79ef0e34099623dc * 60;
const $8b923436b1c7c2d4$export$4157bf0c8e241659 = $8b923436b1c7c2d4$export$683905d551c33fa9 * 60;
const $8b923436b1c7c2d4$export$353686095f4fbf45 = $8b923436b1c7c2d4$export$4157bf0c8e241659 * 24;
const $8b923436b1c7c2d4$export$c241eb88520d5016 = $8b923436b1c7c2d4$export$353686095f4fbf45 * 7;
const $8b923436b1c7c2d4$export$ab95684df7020b26 = $8b923436b1c7c2d4$export$353686095f4fbf45 * 30;
const $8b923436b1c7c2d4$export$61f8ee2d834c6959 = $8b923436b1c7c2d4$export$353686095f4fbf45 * 365;

});


parcelRegister("1TIln", function(module, exports) {

$parcel$export(module.exports, "default", () => $161d5346c97d4e9a$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $161d5346c97d4e9a$var$hour = (0, $48K44.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $bYVTi.durationSecond) - date.getMinutes() * (0, $bYVTi.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $bYVTi.durationHour));
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationHour);
}, function(date) {
    return date.getHours();
});
var $161d5346c97d4e9a$export$2e2bcd8739ae039 = $161d5346c97d4e9a$var$hour;
var $161d5346c97d4e9a$export$8d468796d69cdad1 = $161d5346c97d4e9a$var$hour.range;

});

parcelRegister("fNSZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b816159ec9e62b3f$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $b816159ec9e62b3f$var$minute = (0, $48K44.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $bYVTi.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $bYVTi.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $b816159ec9e62b3f$export$2e2bcd8739ae039 = $b816159ec9e62b3f$var$minute;
var $b816159ec9e62b3f$export$666252b437cce0c7 = $b816159ec9e62b3f$var$minute.range;

});

parcelRegister("3Q36U", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb8a41698d4fb33$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");
var $2cb8a41698d4fb33$var$month = (0, $48K44.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $2cb8a41698d4fb33$export$2e2bcd8739ae039 = $2cb8a41698d4fb33$var$month;
var $2cb8a41698d4fb33$export$16352d1b10c5eb38 = $2cb8a41698d4fb33$var$month.range;

});

parcelRegister("cK13a", function(module, exports) {

$parcel$export(module.exports, "default", () => $946a986b57a89c9f$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $946a986b57a89c9f$var$second = (0, $48K44.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $bYVTi.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $946a986b57a89c9f$export$2e2bcd8739ae039 = $946a986b57a89c9f$var$second;
var $946a986b57a89c9f$export$4792e48abc550fa1 = $946a986b57a89c9f$var$second.range;

});

parcelRegister("g1UtK", function(module, exports) {

$parcel$export(module.exports, "utcTicks", () => $bab88cd7f7550995$export$826ba5ae907e9767);
$parcel$export(module.exports, "utcTickInterval", () => $bab88cd7f7550995$export$6262d8d056ea44c4);
$parcel$export(module.exports, "timeTicks", () => $bab88cd7f7550995$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $bab88cd7f7550995$export$69511150134dd174);

var $1xmrF = parcelRequire("1xmrF");
var $3um73 = parcelRequire("3um73");

var $bYVTi = parcelRequire("bYVTi");

var $kpYbP = parcelRequire("kpYbP");

var $cK13a = parcelRequire("cK13a");

var $fNSZa = parcelRequire("fNSZa");

var $1TIln = parcelRequire("1TIln");

var $dC7VU = parcelRequire("dC7VU");

var $gLr5w = parcelRequire("gLr5w");

var $3Q36U = parcelRequire("3Q36U");

var $6uU17 = parcelRequire("6uU17");

var $3uvlJ = parcelRequire("3uvlJ");

var $inLwC = parcelRequire("inLwC");

var $kDBKI = parcelRequire("kDBKI");

var $dcONi = parcelRequire("dcONi");

var $682nx = parcelRequire("682nx");

var $70TYJ = parcelRequire("70TYJ");
function $bab88cd7f7550995$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $cK13a.default),
            1,
            (0, $bYVTi.durationSecond)
        ],
        [
            (0, $cK13a.default),
            5,
            5 * (0, $bYVTi.durationSecond)
        ],
        [
            (0, $cK13a.default),
            15,
            15 * (0, $bYVTi.durationSecond)
        ],
        [
            (0, $cK13a.default),
            30,
            30 * (0, $bYVTi.durationSecond)
        ],
        [
            minute,
            1,
            (0, $bYVTi.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $bYVTi.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $bYVTi.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $bYVTi.durationMinute)
        ],
        [
            hour,
            1,
            (0, $bYVTi.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $bYVTi.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $bYVTi.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $bYVTi.durationHour)
        ],
        [
            day,
            1,
            (0, $bYVTi.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $bYVTi.durationDay)
        ],
        [
            week,
            1,
            (0, $bYVTi.durationWeek)
        ],
        [
            month,
            1,
            (0, $bYVTi.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $bYVTi.durationMonth)
        ],
        [
            year,
            1,
            (0, $bYVTi.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $1xmrF.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $3um73.tickStep)(start / (0, $bYVTi.durationYear), stop / (0, $bYVTi.durationYear), count));
        if (i === 0) return (0, $kpYbP.default).every(Math.max((0, $3um73.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$bab88cd7f7550995$export$826ba5ae907e9767, $bab88cd7f7550995$export$6262d8d056ea44c4] = $bab88cd7f7550995$var$ticker((0, $70TYJ.default), (0, $682nx.default), (0, $dcONi.utcSunday), (0, $kDBKI.default), (0, $inLwC.default), (0, $3uvlJ.default));
const [$bab88cd7f7550995$export$60c76498552d28a6, $bab88cd7f7550995$export$69511150134dd174] = $bab88cd7f7550995$var$ticker((0, $6uU17.default), (0, $3Q36U.default), (0, $gLr5w.sunday), (0, $dC7VU.default), (0, $1TIln.default), (0, $fNSZa.default));

});
parcelRegister("kpYbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd4d4df257e0023$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");
var $edd4d4df257e0023$var$millisecond = (0, $48K44.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$edd4d4df257e0023$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $edd4d4df257e0023$var$millisecond;
    return (0, $48K44.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $edd4d4df257e0023$export$2e2bcd8739ae039 = $edd4d4df257e0023$var$millisecond;
var $edd4d4df257e0023$export$9a27fac83d67afd3 = $edd4d4df257e0023$var$millisecond.range;

});

parcelRegister("gLr5w", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $c3460c3d42a2292a$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $c3460c3d42a2292a$export$6416afaab03bc9b8);
$parcel$export(module.exports, "thursday", () => $c3460c3d42a2292a$export$2f2b56683a3e5629);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
function $c3460c3d42a2292a$var$weekday(i) {
    return (0, $48K44.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $bYVTi.durationMinute)) / (0, $bYVTi.durationWeek);
    });
}
var $c3460c3d42a2292a$export$fb3ee18ed410cc21 = $c3460c3d42a2292a$var$weekday(0);
var $c3460c3d42a2292a$export$6416afaab03bc9b8 = $c3460c3d42a2292a$var$weekday(1);
var $c3460c3d42a2292a$export$cb8f040f5d17ac7b = $c3460c3d42a2292a$var$weekday(2);
var $c3460c3d42a2292a$export$347581849975dfc8 = $c3460c3d42a2292a$var$weekday(3);
var $c3460c3d42a2292a$export$2f2b56683a3e5629 = $c3460c3d42a2292a$var$weekday(4);
var $c3460c3d42a2292a$export$59b8c2ccd931d806 = $c3460c3d42a2292a$var$weekday(5);
var $c3460c3d42a2292a$export$478ceadebff4d377 = $c3460c3d42a2292a$var$weekday(6);
var $c3460c3d42a2292a$export$e8daabaa40641211 = $c3460c3d42a2292a$export$fb3ee18ed410cc21.range;
var $c3460c3d42a2292a$export$74e5b559c235c00e = $c3460c3d42a2292a$export$6416afaab03bc9b8.range;
var $c3460c3d42a2292a$export$e7d6aa4fb107bc56 = $c3460c3d42a2292a$export$cb8f040f5d17ac7b.range;
var $c3460c3d42a2292a$export$fcd5880b20bb06a8 = $c3460c3d42a2292a$export$347581849975dfc8.range;
var $c3460c3d42a2292a$export$682716b7bbe33641 = $c3460c3d42a2292a$export$2f2b56683a3e5629.range;
var $c3460c3d42a2292a$export$482924968ca86084 = $c3460c3d42a2292a$export$59b8c2ccd931d806.range;
var $c3460c3d42a2292a$export$7d755172c9cda9d2 = $c3460c3d42a2292a$export$478ceadebff4d377.range;

});

parcelRegister("6uU17", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb0ff41b000c7eb$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");
var $4bb0ff41b000c7eb$var$year = (0, $48K44.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$4bb0ff41b000c7eb$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $48K44.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $4bb0ff41b000c7eb$export$2e2bcd8739ae039 = $4bb0ff41b000c7eb$var$year;
var $4bb0ff41b000c7eb$export$6fda41c7fb23acf9 = $4bb0ff41b000c7eb$var$year.range;

});

parcelRegister("3uvlJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $28ac7dcde97d24fa$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $28ac7dcde97d24fa$var$utcMinute = (0, $48K44.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $bYVTi.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $28ac7dcde97d24fa$export$2e2bcd8739ae039 = $28ac7dcde97d24fa$var$utcMinute;
var $28ac7dcde97d24fa$export$cedd563624e8ee50 = $28ac7dcde97d24fa$var$utcMinute.range;

});

parcelRegister("inLwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61f3d7877993d16$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $d61f3d7877993d16$var$utcHour = (0, $48K44.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $bYVTi.durationHour));
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $d61f3d7877993d16$export$2e2bcd8739ae039 = $d61f3d7877993d16$var$utcHour;
var $d61f3d7877993d16$export$6e7a76cd5f50b719 = $d61f3d7877993d16$var$utcHour.range;

});

parcelRegister("kDBKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f064bc03c17d2c89$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
var $f064bc03c17d2c89$var$utcDay = (0, $48K44.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $bYVTi.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $f064bc03c17d2c89$export$2e2bcd8739ae039 = $f064bc03c17d2c89$var$utcDay;
var $f064bc03c17d2c89$export$d277e198508549a1 = $f064bc03c17d2c89$var$utcDay.range;

});

parcelRegister("dcONi", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $99d3cc0103c104ba$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $99d3cc0103c104ba$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $99d3cc0103c104ba$export$1db08111baec2f53);

var $48K44 = parcelRequire("48K44");

var $bYVTi = parcelRequire("bYVTi");
function $99d3cc0103c104ba$var$utcWeekday(i) {
    return (0, $48K44.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $bYVTi.durationWeek);
    });
}
var $99d3cc0103c104ba$export$4898b06303a92011 = $99d3cc0103c104ba$var$utcWeekday(0);
var $99d3cc0103c104ba$export$9cfc53b9cfafd080 = $99d3cc0103c104ba$var$utcWeekday(1);
var $99d3cc0103c104ba$export$2a6d545f77eceb15 = $99d3cc0103c104ba$var$utcWeekday(2);
var $99d3cc0103c104ba$export$a5c25d8ed64433c4 = $99d3cc0103c104ba$var$utcWeekday(3);
var $99d3cc0103c104ba$export$1db08111baec2f53 = $99d3cc0103c104ba$var$utcWeekday(4);
var $99d3cc0103c104ba$export$29265e34dd5921f7 = $99d3cc0103c104ba$var$utcWeekday(5);
var $99d3cc0103c104ba$export$85b74dad05049604 = $99d3cc0103c104ba$var$utcWeekday(6);
var $99d3cc0103c104ba$export$6f3e1c2b0f7d7880 = $99d3cc0103c104ba$export$4898b06303a92011.range;
var $99d3cc0103c104ba$export$1d2d8b858bb366f9 = $99d3cc0103c104ba$export$9cfc53b9cfafd080.range;
var $99d3cc0103c104ba$export$1d5f6785fc7f30f8 = $99d3cc0103c104ba$export$2a6d545f77eceb15.range;
var $99d3cc0103c104ba$export$7a75faf0e37ef4af = $99d3cc0103c104ba$export$a5c25d8ed64433c4.range;
var $99d3cc0103c104ba$export$417eb959611b2f2f = $99d3cc0103c104ba$export$1db08111baec2f53.range;
var $99d3cc0103c104ba$export$59d308db7af08c64 = $99d3cc0103c104ba$export$29265e34dd5921f7.range;
var $99d3cc0103c104ba$export$a124108a0a7f34c8 = $99d3cc0103c104ba$export$85b74dad05049604.range;

});

parcelRegister("682nx", function(module, exports) {

$parcel$export(module.exports, "default", () => $476555c4536301f2$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");
var $476555c4536301f2$var$utcMonth = (0, $48K44.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $476555c4536301f2$export$2e2bcd8739ae039 = $476555c4536301f2$var$utcMonth;
var $476555c4536301f2$export$49159f585997498 = $476555c4536301f2$var$utcMonth.range;

});

parcelRegister("70TYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b3f4ab164db26c$export$2e2bcd8739ae039);

var $48K44 = parcelRequire("48K44");
var $51b3f4ab164db26c$var$utcYear = (0, $48K44.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$51b3f4ab164db26c$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $48K44.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $51b3f4ab164db26c$export$2e2bcd8739ae039 = $51b3f4ab164db26c$var$utcYear;
var $51b3f4ab164db26c$export$3e24d311e17f5802 = $51b3f4ab164db26c$var$utcYear.range;

});


parcelRegister("cg8H6", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $8ecdb92a9fc256d0$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "utcFormat", () => $8ecdb92a9fc256d0$export$1a08fe38f63ebbbb);

var $fl4zA = parcelRequire("fl4zA");
var $8ecdb92a9fc256d0$var$locale;
var $8ecdb92a9fc256d0$export$94f4d87fad5dcf9a;
var $8ecdb92a9fc256d0$export$32b9cd16e1b8c8d2;
var $8ecdb92a9fc256d0$export$1a08fe38f63ebbbb;
var $8ecdb92a9fc256d0$export$3edae9cf8e233729;
$8ecdb92a9fc256d0$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $8ecdb92a9fc256d0$export$2e2bcd8739ae039(definition) {
    $8ecdb92a9fc256d0$var$locale = (0, $fl4zA.default)(definition);
    $8ecdb92a9fc256d0$export$94f4d87fad5dcf9a = $8ecdb92a9fc256d0$var$locale.format;
    $8ecdb92a9fc256d0$export$32b9cd16e1b8c8d2 = $8ecdb92a9fc256d0$var$locale.parse;
    $8ecdb92a9fc256d0$export$1a08fe38f63ebbbb = $8ecdb92a9fc256d0$var$locale.utcFormat;
    $8ecdb92a9fc256d0$export$3edae9cf8e233729 = $8ecdb92a9fc256d0$var$locale.utcParse;
    return $8ecdb92a9fc256d0$var$locale;
}

});
parcelRegister("fl4zA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ac5d481565b04d$export$2e2bcd8739ae039);

var $dC7VU = parcelRequire("dC7VU");
var $gLr5w = parcelRequire("gLr5w");
var $6uU17 = parcelRequire("6uU17");
var $kDBKI = parcelRequire("kDBKI");
var $dcONi = parcelRequire("dcONi");
var $70TYJ = parcelRequire("70TYJ");
function $b2ac5d481565b04d$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $b2ac5d481565b04d$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $b2ac5d481565b04d$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $b2ac5d481565b04d$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $b2ac5d481565b04d$var$formatRe(locale_periods), periodLookup = $b2ac5d481565b04d$var$formatLookup(locale_periods), weekdayRe = $b2ac5d481565b04d$var$formatRe(locale_weekdays), weekdayLookup = $b2ac5d481565b04d$var$formatLookup(locale_weekdays), shortWeekdayRe = $b2ac5d481565b04d$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $b2ac5d481565b04d$var$formatLookup(locale_shortWeekdays), monthRe = $b2ac5d481565b04d$var$formatRe(locale_months), monthLookup = $b2ac5d481565b04d$var$formatLookup(locale_months), shortMonthRe = $b2ac5d481565b04d$var$formatRe(locale_shortMonths), shortMonthLookup = $b2ac5d481565b04d$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $b2ac5d481565b04d$var$formatDayOfMonth,
        "e": $b2ac5d481565b04d$var$formatDayOfMonth,
        "f": $b2ac5d481565b04d$var$formatMicroseconds,
        "g": $b2ac5d481565b04d$var$formatYearISO,
        "G": $b2ac5d481565b04d$var$formatFullYearISO,
        "H": $b2ac5d481565b04d$var$formatHour24,
        "I": $b2ac5d481565b04d$var$formatHour12,
        "j": $b2ac5d481565b04d$var$formatDayOfYear,
        "L": $b2ac5d481565b04d$var$formatMilliseconds,
        "m": $b2ac5d481565b04d$var$formatMonthNumber,
        "M": $b2ac5d481565b04d$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $b2ac5d481565b04d$var$formatUnixTimestamp,
        "s": $b2ac5d481565b04d$var$formatUnixTimestampSeconds,
        "S": $b2ac5d481565b04d$var$formatSeconds,
        "u": $b2ac5d481565b04d$var$formatWeekdayNumberMonday,
        "U": $b2ac5d481565b04d$var$formatWeekNumberSunday,
        "V": $b2ac5d481565b04d$var$formatWeekNumberISO,
        "w": $b2ac5d481565b04d$var$formatWeekdayNumberSunday,
        "W": $b2ac5d481565b04d$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b2ac5d481565b04d$var$formatYear,
        "Y": $b2ac5d481565b04d$var$formatFullYear,
        "Z": $b2ac5d481565b04d$var$formatZone,
        "%": $b2ac5d481565b04d$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $b2ac5d481565b04d$var$formatUTCDayOfMonth,
        "e": $b2ac5d481565b04d$var$formatUTCDayOfMonth,
        "f": $b2ac5d481565b04d$var$formatUTCMicroseconds,
        "g": $b2ac5d481565b04d$var$formatUTCYearISO,
        "G": $b2ac5d481565b04d$var$formatUTCFullYearISO,
        "H": $b2ac5d481565b04d$var$formatUTCHour24,
        "I": $b2ac5d481565b04d$var$formatUTCHour12,
        "j": $b2ac5d481565b04d$var$formatUTCDayOfYear,
        "L": $b2ac5d481565b04d$var$formatUTCMilliseconds,
        "m": $b2ac5d481565b04d$var$formatUTCMonthNumber,
        "M": $b2ac5d481565b04d$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $b2ac5d481565b04d$var$formatUnixTimestamp,
        "s": $b2ac5d481565b04d$var$formatUnixTimestampSeconds,
        "S": $b2ac5d481565b04d$var$formatUTCSeconds,
        "u": $b2ac5d481565b04d$var$formatUTCWeekdayNumberMonday,
        "U": $b2ac5d481565b04d$var$formatUTCWeekNumberSunday,
        "V": $b2ac5d481565b04d$var$formatUTCWeekNumberISO,
        "w": $b2ac5d481565b04d$var$formatUTCWeekdayNumberSunday,
        "W": $b2ac5d481565b04d$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b2ac5d481565b04d$var$formatUTCYear,
        "Y": $b2ac5d481565b04d$var$formatUTCFullYear,
        "Z": $b2ac5d481565b04d$var$formatUTCZone,
        "%": $b2ac5d481565b04d$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $b2ac5d481565b04d$var$parseDayOfMonth,
        "e": $b2ac5d481565b04d$var$parseDayOfMonth,
        "f": $b2ac5d481565b04d$var$parseMicroseconds,
        "g": $b2ac5d481565b04d$var$parseYear,
        "G": $b2ac5d481565b04d$var$parseFullYear,
        "H": $b2ac5d481565b04d$var$parseHour24,
        "I": $b2ac5d481565b04d$var$parseHour24,
        "j": $b2ac5d481565b04d$var$parseDayOfYear,
        "L": $b2ac5d481565b04d$var$parseMilliseconds,
        "m": $b2ac5d481565b04d$var$parseMonthNumber,
        "M": $b2ac5d481565b04d$var$parseMinutes,
        "p": parsePeriod,
        "q": $b2ac5d481565b04d$var$parseQuarter,
        "Q": $b2ac5d481565b04d$var$parseUnixTimestamp,
        "s": $b2ac5d481565b04d$var$parseUnixTimestampSeconds,
        "S": $b2ac5d481565b04d$var$parseSeconds,
        "u": $b2ac5d481565b04d$var$parseWeekdayNumberMonday,
        "U": $b2ac5d481565b04d$var$parseWeekNumberSunday,
        "V": $b2ac5d481565b04d$var$parseWeekNumberISO,
        "w": $b2ac5d481565b04d$var$parseWeekdayNumberSunday,
        "W": $b2ac5d481565b04d$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $b2ac5d481565b04d$var$parseYear,
        "Y": $b2ac5d481565b04d$var$parseFullYear,
        "Z": $b2ac5d481565b04d$var$parseZone,
        "%": $b2ac5d481565b04d$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $b2ac5d481565b04d$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $b2ac5d481565b04d$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $b2ac5d481565b04d$var$utcDate($b2ac5d481565b04d$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $dcONi.utcMonday).ceil(week) : (0, $dcONi.utcMonday)(week);
                    week = (0, $kDBKI.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $b2ac5d481565b04d$var$localDate($b2ac5d481565b04d$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $gLr5w.monday).ceil(week) : (0, $gLr5w.monday)(week);
                    week = (0, $dC7VU.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $b2ac5d481565b04d$var$utcDate($b2ac5d481565b04d$var$newDate(d.y, 0, 1)).getUTCDay() : $b2ac5d481565b04d$var$localDate($b2ac5d481565b04d$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $b2ac5d481565b04d$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $b2ac5d481565b04d$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $b2ac5d481565b04d$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $b2ac5d481565b04d$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $b2ac5d481565b04d$var$numberRe = /^\s*\d+/, $b2ac5d481565b04d$var$percentRe = /^%/, $b2ac5d481565b04d$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $b2ac5d481565b04d$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $b2ac5d481565b04d$var$requote(s) {
    return s.replace($b2ac5d481565b04d$var$requoteRe, "\\$&");
}
function $b2ac5d481565b04d$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($b2ac5d481565b04d$var$requote).join("|") + ")", "i");
}
function $b2ac5d481565b04d$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $b2ac5d481565b04d$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseWeekNumberSunday(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseWeekNumberISO(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseWeekNumberMonday(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseFullYear(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseYear(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseQuarter(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseMonthNumber(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseDayOfMonth(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseDayOfYear(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseHour24(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseMinutes(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseSeconds(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseMilliseconds(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseMicroseconds(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseLiteralPercent(d, string, i) {
    var n = $b2ac5d481565b04d$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $b2ac5d481565b04d$var$parseUnixTimestamp(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $b2ac5d481565b04d$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $b2ac5d481565b04d$var$formatDayOfMonth(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getDate(), p, 2);
}
function $b2ac5d481565b04d$var$formatHour24(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getHours(), p, 2);
}
function $b2ac5d481565b04d$var$formatHour12(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $b2ac5d481565b04d$var$formatDayOfYear(d, p) {
    return $b2ac5d481565b04d$var$pad(1 + (0, $dC7VU.default).count((0, $6uU17.default)(d), d), p, 3);
}
function $b2ac5d481565b04d$var$formatMilliseconds(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getMilliseconds(), p, 3);
}
function $b2ac5d481565b04d$var$formatMicroseconds(d, p) {
    return $b2ac5d481565b04d$var$formatMilliseconds(d, p) + "000";
}
function $b2ac5d481565b04d$var$formatMonthNumber(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getMonth() + 1, p, 2);
}
function $b2ac5d481565b04d$var$formatMinutes(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getMinutes(), p, 2);
}
function $b2ac5d481565b04d$var$formatSeconds(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getSeconds(), p, 2);
}
function $b2ac5d481565b04d$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $b2ac5d481565b04d$var$formatWeekNumberSunday(d, p) {
    return $b2ac5d481565b04d$var$pad((0, $gLr5w.sunday).count((0, $6uU17.default)(d) - 1, d), p, 2);
}
function $b2ac5d481565b04d$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $gLr5w.thursday)(d) : (0, $gLr5w.thursday).ceil(d);
}
function $b2ac5d481565b04d$var$formatWeekNumberISO(d, p) {
    d = $b2ac5d481565b04d$var$dISO(d);
    return $b2ac5d481565b04d$var$pad((0, $gLr5w.thursday).count((0, $6uU17.default)(d), d) + ((0, $6uU17.default)(d).getDay() === 4), p, 2);
}
function $b2ac5d481565b04d$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $b2ac5d481565b04d$var$formatWeekNumberMonday(d, p) {
    return $b2ac5d481565b04d$var$pad((0, $gLr5w.monday).count((0, $6uU17.default)(d) - 1, d), p, 2);
}
function $b2ac5d481565b04d$var$formatYear(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getFullYear() % 100, p, 2);
}
function $b2ac5d481565b04d$var$formatYearISO(d, p) {
    d = $b2ac5d481565b04d$var$dISO(d);
    return $b2ac5d481565b04d$var$pad(d.getFullYear() % 100, p, 2);
}
function $b2ac5d481565b04d$var$formatFullYear(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b2ac5d481565b04d$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $gLr5w.thursday)(d) : (0, $gLr5w.thursday).ceil(d);
    return $b2ac5d481565b04d$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b2ac5d481565b04d$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $b2ac5d481565b04d$var$pad(z / 60 | 0, "0", 2) + $b2ac5d481565b04d$var$pad(z % 60, "0", 2);
}
function $b2ac5d481565b04d$var$formatUTCDayOfMonth(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCDate(), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCHour24(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCHours(), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCHour12(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $b2ac5d481565b04d$var$formatUTCDayOfYear(d, p) {
    return $b2ac5d481565b04d$var$pad(1 + (0, $kDBKI.default).count((0, $70TYJ.default)(d), d), p, 3);
}
function $b2ac5d481565b04d$var$formatUTCMilliseconds(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $b2ac5d481565b04d$var$formatUTCMicroseconds(d, p) {
    return $b2ac5d481565b04d$var$formatUTCMilliseconds(d, p) + "000";
}
function $b2ac5d481565b04d$var$formatUTCMonthNumber(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $b2ac5d481565b04d$var$formatUTCMinutes(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCMinutes(), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCSeconds(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCSeconds(), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $b2ac5d481565b04d$var$formatUTCWeekNumberSunday(d, p) {
    return $b2ac5d481565b04d$var$pad((0, $dcONi.utcSunday).count((0, $70TYJ.default)(d) - 1, d), p, 2);
}
function $b2ac5d481565b04d$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $dcONi.utcThursday)(d) : (0, $dcONi.utcThursday).ceil(d);
}
function $b2ac5d481565b04d$var$formatUTCWeekNumberISO(d, p) {
    d = $b2ac5d481565b04d$var$UTCdISO(d);
    return $b2ac5d481565b04d$var$pad((0, $dcONi.utcThursday).count((0, $70TYJ.default)(d), d) + ((0, $70TYJ.default)(d).getUTCDay() === 4), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $b2ac5d481565b04d$var$formatUTCWeekNumberMonday(d, p) {
    return $b2ac5d481565b04d$var$pad((0, $dcONi.utcMonday).count((0, $70TYJ.default)(d) - 1, d), p, 2);
}
function $b2ac5d481565b04d$var$formatUTCYear(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b2ac5d481565b04d$var$formatUTCYearISO(d, p) {
    d = $b2ac5d481565b04d$var$UTCdISO(d);
    return $b2ac5d481565b04d$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b2ac5d481565b04d$var$formatUTCFullYear(d, p) {
    return $b2ac5d481565b04d$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b2ac5d481565b04d$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $dcONi.utcThursday)(d) : (0, $dcONi.utcThursday).ceil(d);
    return $b2ac5d481565b04d$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b2ac5d481565b04d$var$formatUTCZone() {
    return "+0000";
}
function $b2ac5d481565b04d$var$formatLiteralPercent() {
    return "%";
}
function $b2ac5d481565b04d$var$formatUnixTimestamp(d) {
    return +d;
}
function $b2ac5d481565b04d$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});



parcelRegister("3pFRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c42eae2390f9c9$export$2e2bcd8739ae039);

var $kDBKI = parcelRequire("kDBKI");
var $inLwC = parcelRequire("inLwC");
var $3uvlJ = parcelRequire("3uvlJ");
var $682nx = parcelRequire("682nx");
var $cK13a = parcelRequire("cK13a");
var $g1UtK = parcelRequire("g1UtK");
var $dcONi = parcelRequire("dcONi");
var $70TYJ = parcelRequire("70TYJ");

var $cg8H6 = parcelRequire("cg8H6");

var $698oU = parcelRequire("698oU");

var $iGmDW = parcelRequire("iGmDW");
function $27c42eae2390f9c9$export$2e2bcd8739ae039() {
    return (0, $iGmDW.initRange).apply((0, $698oU.calendar)((0, $g1UtK.utcTicks), (0, $g1UtK.utcTickInterval), (0, $70TYJ.default), (0, $682nx.default), (0, $dcONi.utcSunday), (0, $kDBKI.default), (0, $inLwC.default), (0, $3uvlJ.default), (0, $cK13a.default), (0, $cg8H6.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("cUX6y", function(module, exports) {

$parcel$export(module.exports, "copy", () => $96788ff93b613852$export$784d13d8ee351f07);
$parcel$export(module.exports, "default", () => $96788ff93b613852$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sequentialLog", () => $96788ff93b613852$export$6843e08bf2ff981f);
$parcel$export(module.exports, "sequentialSymlog", () => $96788ff93b613852$export$9d4af4de62c81941);
$parcel$export(module.exports, "sequentialPow", () => $96788ff93b613852$export$de9f78581b4f2405);
$parcel$export(module.exports, "sequentialSqrt", () => $96788ff93b613852$export$413d935127ed466e);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $96788ff93b613852$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $aNOl6.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $96788ff93b613852$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $96788ff93b613852$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($96788ff93b613852$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$6843e08bf2ff981f() {
    var scale = (0, $lh0D1.loggish)($96788ff93b613852$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$9d4af4de62c81941() {
    var scale = (0, $gGeSO.symlogish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$de9f78581b4f2405() {
    var scale = (0, $3xref.powish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$413d935127ed466e() {
    return $96788ff93b613852$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("eByw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1f4b866034b37c$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
var $cB7hd = parcelRequire("cB7hd");
var $6hpNw = parcelRequire("6hpNw");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $aa1f4b866034b37c$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $aNOl6.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $cB7hd.default)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $733O4.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $6hpNw.default)(domain, i / n));
    };
    scale.copy = function() {
        return $aa1f4b866034b37c$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("wUwgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $062ed4def101d7fa$export$2e2bcd8739ae039);
$parcel$export(module.exports, "divergingLog", () => $062ed4def101d7fa$export$5f0266a9159c47fb);
$parcel$export(module.exports, "divergingSymlog", () => $062ed4def101d7fa$export$50b3da713cf557c6);
$parcel$export(module.exports, "divergingPow", () => $062ed4def101d7fa$export$d6cedcc63bf26e7e);
$parcel$export(module.exports, "divergingSqrt", () => $062ed4def101d7fa$export$33ddefb5c4ab9e9c);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");
var $9M96w = parcelRequire("9M96w");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $cUX6y = parcelRequire("cUX6y");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $062ed4def101d7fa$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $aNOl6.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $9M96w.default)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $062ed4def101d7fa$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($062ed4def101d7fa$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$5f0266a9159c47fb() {
    var scale = (0, $lh0D1.loggish)($062ed4def101d7fa$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$50b3da713cf557c6() {
    var scale = (0, $gGeSO.symlogish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$d6cedcc63bf26e7e() {
    var scale = (0, $3xref.powish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$33ddefb5c4ab9e9c() {
    return $062ed4def101d7fa$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("9M96w", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dfa8a5df6ac0fc$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $71dfa8a5df6ac0fc$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $6JuYh.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});



parcelRegister("hsbXN", function(module, exports) {

$parcel$export(module.exports, "schemeCategory10", () => (parcelRequire("25pzP")).default);
$parcel$export(module.exports, "schemeAccent", () => (parcelRequire("5ISFX")).default);
$parcel$export(module.exports, "schemeDark2", () => (parcelRequire("2kFMb")).default);
$parcel$export(module.exports, "schemePaired", () => (parcelRequire("b6Z2r")).default);
$parcel$export(module.exports, "schemePastel1", () => (parcelRequire("k6Bhp")).default);
$parcel$export(module.exports, "schemePastel2", () => (parcelRequire("ky181")).default);
$parcel$export(module.exports, "schemeSet1", () => (parcelRequire("cPUWp")).default);
$parcel$export(module.exports, "schemeSet2", () => (parcelRequire("48kRw")).default);
$parcel$export(module.exports, "schemeSet3", () => (parcelRequire("2YmEi")).default);
$parcel$export(module.exports, "schemeTableau10", () => (parcelRequire("bcV1y")).default);
$parcel$export(module.exports, "interpolateBrBG", () => (parcelRequire("1DG7j")).default);
$parcel$export(module.exports, "schemeBrBG", () => (parcelRequire("1DG7j")).scheme);
$parcel$export(module.exports, "interpolatePRGn", () => (parcelRequire("aCOa6")).default);
$parcel$export(module.exports, "schemePRGn", () => (parcelRequire("aCOa6")).scheme);
$parcel$export(module.exports, "interpolatePiYG", () => (parcelRequire("iM90z")).default);
$parcel$export(module.exports, "schemePiYG", () => (parcelRequire("iM90z")).scheme);
$parcel$export(module.exports, "interpolatePuOr", () => (parcelRequire("39Prd")).default);
$parcel$export(module.exports, "schemePuOr", () => (parcelRequire("39Prd")).scheme);
$parcel$export(module.exports, "interpolateRdBu", () => (parcelRequire("ivJGg")).default);
$parcel$export(module.exports, "schemeRdBu", () => (parcelRequire("ivJGg")).scheme);
$parcel$export(module.exports, "interpolateRdGy", () => (parcelRequire("eMT4p")).default);
$parcel$export(module.exports, "schemeRdGy", () => (parcelRequire("eMT4p")).scheme);
$parcel$export(module.exports, "interpolateRdYlBu", () => (parcelRequire("fcJYg")).default);
$parcel$export(module.exports, "schemeRdYlBu", () => (parcelRequire("fcJYg")).scheme);
$parcel$export(module.exports, "interpolateRdYlGn", () => (parcelRequire("3Bf9x")).default);
$parcel$export(module.exports, "schemeRdYlGn", () => (parcelRequire("3Bf9x")).scheme);
$parcel$export(module.exports, "interpolateSpectral", () => (parcelRequire("kzeO2")).default);
$parcel$export(module.exports, "schemeSpectral", () => (parcelRequire("kzeO2")).scheme);
$parcel$export(module.exports, "interpolateBuGn", () => (parcelRequire("7ggnu")).default);
$parcel$export(module.exports, "schemeBuGn", () => (parcelRequire("7ggnu")).scheme);
$parcel$export(module.exports, "interpolateBuPu", () => (parcelRequire("1Em7G")).default);
$parcel$export(module.exports, "schemeBuPu", () => (parcelRequire("1Em7G")).scheme);
$parcel$export(module.exports, "interpolateGnBu", () => (parcelRequire("kjyZr")).default);
$parcel$export(module.exports, "schemeGnBu", () => (parcelRequire("kjyZr")).scheme);
$parcel$export(module.exports, "interpolateOrRd", () => (parcelRequire("b4jqF")).default);
$parcel$export(module.exports, "schemeOrRd", () => (parcelRequire("b4jqF")).scheme);
$parcel$export(module.exports, "interpolatePuBuGn", () => (parcelRequire("10oMz")).default);
$parcel$export(module.exports, "schemePuBuGn", () => (parcelRequire("10oMz")).scheme);
$parcel$export(module.exports, "interpolatePuBu", () => (parcelRequire("379Ba")).default);
$parcel$export(module.exports, "schemePuBu", () => (parcelRequire("379Ba")).scheme);
$parcel$export(module.exports, "interpolatePuRd", () => (parcelRequire("hSzd8")).default);
$parcel$export(module.exports, "schemePuRd", () => (parcelRequire("hSzd8")).scheme);
$parcel$export(module.exports, "interpolateRdPu", () => (parcelRequire("dcJ5T")).default);
$parcel$export(module.exports, "schemeRdPu", () => (parcelRequire("dcJ5T")).scheme);
$parcel$export(module.exports, "interpolateYlGnBu", () => (parcelRequire("bgNFw")).default);
$parcel$export(module.exports, "schemeYlGnBu", () => (parcelRequire("bgNFw")).scheme);
$parcel$export(module.exports, "interpolateYlGn", () => (parcelRequire("jNaNS")).default);
$parcel$export(module.exports, "schemeYlGn", () => (parcelRequire("jNaNS")).scheme);
$parcel$export(module.exports, "interpolateYlOrBr", () => (parcelRequire("fmE6L")).default);
$parcel$export(module.exports, "schemeYlOrBr", () => (parcelRequire("fmE6L")).scheme);
$parcel$export(module.exports, "interpolateYlOrRd", () => (parcelRequire("371r2")).default);
$parcel$export(module.exports, "schemeYlOrRd", () => (parcelRequire("371r2")).scheme);
$parcel$export(module.exports, "interpolateBlues", () => (parcelRequire("bNziL")).default);
$parcel$export(module.exports, "schemeBlues", () => (parcelRequire("bNziL")).scheme);
$parcel$export(module.exports, "interpolateGreens", () => (parcelRequire("4I0q7")).default);
$parcel$export(module.exports, "schemeGreens", () => (parcelRequire("4I0q7")).scheme);
$parcel$export(module.exports, "interpolateGreys", () => (parcelRequire("6cyDu")).default);
$parcel$export(module.exports, "schemeGreys", () => (parcelRequire("6cyDu")).scheme);
$parcel$export(module.exports, "interpolatePurples", () => (parcelRequire("b26Q6")).default);
$parcel$export(module.exports, "schemePurples", () => (parcelRequire("b26Q6")).scheme);
$parcel$export(module.exports, "interpolateReds", () => (parcelRequire("gVFQJ")).default);
$parcel$export(module.exports, "schemeReds", () => (parcelRequire("gVFQJ")).scheme);
$parcel$export(module.exports, "interpolateOranges", () => (parcelRequire("5HAIW")).default);
$parcel$export(module.exports, "schemeOranges", () => (parcelRequire("5HAIW")).scheme);
$parcel$export(module.exports, "interpolateCividis", () => (parcelRequire("2h6fG")).default);
$parcel$export(module.exports, "interpolateCubehelixDefault", () => (parcelRequire("3eL2u")).default);
$parcel$export(module.exports, "interpolateRainbow", () => (parcelRequire("dTVcM")).default);
$parcel$export(module.exports, "interpolateWarm", () => (parcelRequire("dTVcM")).warm);
$parcel$export(module.exports, "interpolateCool", () => (parcelRequire("dTVcM")).cool);
$parcel$export(module.exports, "interpolateSinebow", () => (parcelRequire("JEdBi")).default);
$parcel$export(module.exports, "interpolateTurbo", () => (parcelRequire("bzRII")).default);
$parcel$export(module.exports, "interpolateViridis", () => (parcelRequire("2fRjh")).default);
$parcel$export(module.exports, "interpolateMagma", () => (parcelRequire("2fRjh")).magma);
$parcel$export(module.exports, "interpolateInferno", () => (parcelRequire("2fRjh")).inferno);
$parcel$export(module.exports, "interpolatePlasma", () => (parcelRequire("2fRjh")).plasma);

var $25pzP = parcelRequire("25pzP");

var $5ISFX = parcelRequire("5ISFX");

var $2kFMb = parcelRequire("2kFMb");

var $b6Z2r = parcelRequire("b6Z2r");

var $k6Bhp = parcelRequire("k6Bhp");

var $ky181 = parcelRequire("ky181");

var $cPUWp = parcelRequire("cPUWp");

var $48kRw = parcelRequire("48kRw");

var $2YmEi = parcelRequire("2YmEi");

var $bcV1y = parcelRequire("bcV1y");

var $1DG7j = parcelRequire("1DG7j");

var $aCOa6 = parcelRequire("aCOa6");

var $iM90z = parcelRequire("iM90z");

var $39Prd = parcelRequire("39Prd");

var $ivJGg = parcelRequire("ivJGg");

var $eMT4p = parcelRequire("eMT4p");

var $fcJYg = parcelRequire("fcJYg");

var $3Bf9x = parcelRequire("3Bf9x");

var $kzeO2 = parcelRequire("kzeO2");

var $7ggnu = parcelRequire("7ggnu");

var $1Em7G = parcelRequire("1Em7G");

var $kjyZr = parcelRequire("kjyZr");

var $b4jqF = parcelRequire("b4jqF");

var $10oMz = parcelRequire("10oMz");

var $379Ba = parcelRequire("379Ba");

var $hSzd8 = parcelRequire("hSzd8");

var $dcJ5T = parcelRequire("dcJ5T");

var $bgNFw = parcelRequire("bgNFw");

var $jNaNS = parcelRequire("jNaNS");

var $fmE6L = parcelRequire("fmE6L");

var $371r2 = parcelRequire("371r2");

var $bNziL = parcelRequire("bNziL");

var $4I0q7 = parcelRequire("4I0q7");

var $6cyDu = parcelRequire("6cyDu");

var $b26Q6 = parcelRequire("b26Q6");

var $gVFQJ = parcelRequire("gVFQJ");

var $5HAIW = parcelRequire("5HAIW");

var $2h6fG = parcelRequire("2h6fG");

var $3eL2u = parcelRequire("3eL2u");

var $dTVcM = parcelRequire("dTVcM");

var $JEdBi = parcelRequire("JEdBi");

var $bzRII = parcelRequire("bzRII");

var $2fRjh = parcelRequire("2fRjh");

});
parcelRegister("25pzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $184fe36bafdd4232$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $184fe36bafdd4232$export$2e2bcd8739ae039 = (0, $4uSui.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});
parcelRegister("4uSui", function(module, exports) {

$parcel$export(module.exports, "default", () => $34643ae23f868424$export$2e2bcd8739ae039);
function $34643ae23f868424$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});


parcelRegister("5ISFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ab79451332c864$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $42ab79451332c864$export$2e2bcd8739ae039 = (0, $4uSui.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

});

parcelRegister("2kFMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2ddaea93b0c0f3$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $1b2ddaea93b0c0f3$export$2e2bcd8739ae039 = (0, $4uSui.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

});

parcelRegister("b6Z2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $816f9a3108a5f113$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $816f9a3108a5f113$export$2e2bcd8739ae039 = (0, $4uSui.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

});

parcelRegister("k6Bhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3149271d9a03d5$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $ea3149271d9a03d5$export$2e2bcd8739ae039 = (0, $4uSui.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

});

parcelRegister("ky181", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef57dbb5d5bed42e$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $ef57dbb5d5bed42e$export$2e2bcd8739ae039 = (0, $4uSui.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

});

parcelRegister("cPUWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $95866ac1818b9536$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $95866ac1818b9536$export$2e2bcd8739ae039 = (0, $4uSui.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

});

parcelRegister("48kRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3028179478b46469$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $3028179478b46469$export$2e2bcd8739ae039 = (0, $4uSui.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

});

parcelRegister("2YmEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a2c0fc3c07c200$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $22a2c0fc3c07c200$export$2e2bcd8739ae039 = (0, $4uSui.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

});

parcelRegister("bcV1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $828d0c7b29d22009$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");
var $828d0c7b29d22009$export$2e2bcd8739ae039 = (0, $4uSui.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

});

parcelRegister("1DG7j", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $131a1a7f6c3130e3$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $131a1a7f6c3130e3$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $131a1a7f6c3130e3$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $4uSui.default));
var $131a1a7f6c3130e3$export$2e2bcd8739ae039 = (0, $dgHWV.default)($131a1a7f6c3130e3$export$3005042704f95a69);

});
parcelRegister("dgHWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8edc69e669c27b$export$2e2bcd8739ae039);

var $gEc1c = parcelRequire("gEc1c");
var $9a8edc69e669c27b$export$2e2bcd8739ae039 = (scheme)=>(0, $gEc1c.rgbBasis)(scheme[scheme.length - 1]);

});
parcelRegister("gEc1c", function(module, exports) {

$parcel$export(module.exports, "rgbBasis", () => $c1e9b4622fd5e18f$export$2c0e28f2e2852d3f);

var $5Q7WV = parcelRequire("5Q7WV");

var $2d3mQ = parcelRequire("2d3mQ");

var $8lglV = parcelRequire("8lglV");

var $63YzK = parcelRequire("63YzK");
var $c1e9b4622fd5e18f$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $63YzK.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $5Q7WV.rgb)(start)).r, (end = (0, $5Q7WV.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $63YzK.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c1e9b4622fd5e18f$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $5Q7WV.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c1e9b4622fd5e18f$export$2c0e28f2e2852d3f = $c1e9b4622fd5e18f$var$rgbSpline((0, $2d3mQ.default));
var $c1e9b4622fd5e18f$export$53d5214f625ccd4c = $c1e9b4622fd5e18f$var$rgbSpline((0, $8lglV.default));

});
parcelRegister("5Q7WV", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);

var $GECEq = parcelRequire("GECEq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $GECEq.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $GECEq.default)(Rgb, rgb, (0, $GECEq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $GECEq.default)(Hsl, hsl, (0, $GECEq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("GECEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $08036f1f24b2939d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $08036f1f24b2939d$export$8b58be045bf06082);
function $08036f1f24b2939d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $08036f1f24b2939d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("2d3mQ", function(module, exports) {

$parcel$export(module.exports, "basis", () => $19bf6865e928d3e8$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $19bf6865e928d3e8$export$2e2bcd8739ae039);
function $19bf6865e928d3e8$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $19bf6865e928d3e8$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $19bf6865e928d3e8$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8lglV", function(module, exports) {

$parcel$export(module.exports, "default", () => $612cf83080322085$export$2e2bcd8739ae039);

var $2d3mQ = parcelRequire("2d3mQ");
function $612cf83080322085$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $2d3mQ.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("63YzK", function(module, exports) {

$parcel$export(module.exports, "hue", () => $46a202f358da5920$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $46a202f358da5920$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $46a202f358da5920$export$2e2bcd8739ae039);

var $8qR87 = parcelRequire("8qR87");
function $46a202f358da5920$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $46a202f358da5920$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $46a202f358da5920$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $46a202f358da5920$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $8qR87.default)(isNaN(a) ? b : a);
}
function $46a202f358da5920$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $46a202f358da5920$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $46a202f358da5920$var$exponential(a, b, y) : (0, $8qR87.default)(isNaN(a) ? b : a);
    };
}
function $46a202f358da5920$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $46a202f358da5920$var$linear(a, d) : (0, $8qR87.default)(isNaN(a) ? b : a);
}

});
parcelRegister("8qR87", function(module, exports) {

$parcel$export(module.exports, "default", () => $6239f6ed36ad39d4$export$2e2bcd8739ae039);
var $6239f6ed36ad39d4$export$2e2bcd8739ae039 = (x)=>()=>x;

});





parcelRegister("aCOa6", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $7bc45d1c2284c33c$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $7bc45d1c2284c33c$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $7bc45d1c2284c33c$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $4uSui.default));
var $7bc45d1c2284c33c$export$2e2bcd8739ae039 = (0, $dgHWV.default)($7bc45d1c2284c33c$export$3005042704f95a69);

});

parcelRegister("iM90z", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $dab3b287ad218e99$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $dab3b287ad218e99$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $dab3b287ad218e99$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $4uSui.default));
var $dab3b287ad218e99$export$2e2bcd8739ae039 = (0, $dgHWV.default)($dab3b287ad218e99$export$3005042704f95a69);

});

parcelRegister("39Prd", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $24ca1cdb1a705db6$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $24ca1cdb1a705db6$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $24ca1cdb1a705db6$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $4uSui.default));
var $24ca1cdb1a705db6$export$2e2bcd8739ae039 = (0, $dgHWV.default)($24ca1cdb1a705db6$export$3005042704f95a69);

});

parcelRegister("ivJGg", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $d79e8e76b0dc7e62$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $d79e8e76b0dc7e62$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $d79e8e76b0dc7e62$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $4uSui.default));
var $d79e8e76b0dc7e62$export$2e2bcd8739ae039 = (0, $dgHWV.default)($d79e8e76b0dc7e62$export$3005042704f95a69);

});

parcelRegister("eMT4p", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $ac40442fa61fca91$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $ac40442fa61fca91$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $ac40442fa61fca91$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $4uSui.default));
var $ac40442fa61fca91$export$2e2bcd8739ae039 = (0, $dgHWV.default)($ac40442fa61fca91$export$3005042704f95a69);

});

parcelRegister("fcJYg", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $b11ba2ddfed1f254$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $b11ba2ddfed1f254$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $b11ba2ddfed1f254$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $4uSui.default));
var $b11ba2ddfed1f254$export$2e2bcd8739ae039 = (0, $dgHWV.default)($b11ba2ddfed1f254$export$3005042704f95a69);

});

parcelRegister("3Bf9x", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $29f094d9febc9c53$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $29f094d9febc9c53$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $29f094d9febc9c53$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $4uSui.default));
var $29f094d9febc9c53$export$2e2bcd8739ae039 = (0, $dgHWV.default)($29f094d9febc9c53$export$3005042704f95a69);

});

parcelRegister("kzeO2", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $ef928fb4c009a2ee$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $ef928fb4c009a2ee$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $ef928fb4c009a2ee$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $4uSui.default));
var $ef928fb4c009a2ee$export$2e2bcd8739ae039 = (0, $dgHWV.default)($ef928fb4c009a2ee$export$3005042704f95a69);

});

parcelRegister("7ggnu", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $5496bb521de17271$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $5496bb521de17271$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $5496bb521de17271$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $4uSui.default));
var $5496bb521de17271$export$2e2bcd8739ae039 = (0, $dgHWV.default)($5496bb521de17271$export$3005042704f95a69);

});

parcelRegister("1Em7G", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $133ab000ef9c868d$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $133ab000ef9c868d$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $133ab000ef9c868d$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $4uSui.default));
var $133ab000ef9c868d$export$2e2bcd8739ae039 = (0, $dgHWV.default)($133ab000ef9c868d$export$3005042704f95a69);

});

parcelRegister("kjyZr", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $eca0b94262411413$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $eca0b94262411413$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $eca0b94262411413$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $4uSui.default));
var $eca0b94262411413$export$2e2bcd8739ae039 = (0, $dgHWV.default)($eca0b94262411413$export$3005042704f95a69);

});

parcelRegister("b4jqF", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $80ef23a2800581fb$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $80ef23a2800581fb$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $80ef23a2800581fb$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $4uSui.default));
var $80ef23a2800581fb$export$2e2bcd8739ae039 = (0, $dgHWV.default)($80ef23a2800581fb$export$3005042704f95a69);

});

parcelRegister("10oMz", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $0bb903cf188b2c8a$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $0bb903cf188b2c8a$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $0bb903cf188b2c8a$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $4uSui.default));
var $0bb903cf188b2c8a$export$2e2bcd8739ae039 = (0, $dgHWV.default)($0bb903cf188b2c8a$export$3005042704f95a69);

});

parcelRegister("379Ba", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $24497896885a019e$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $24497896885a019e$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $24497896885a019e$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $4uSui.default));
var $24497896885a019e$export$2e2bcd8739ae039 = (0, $dgHWV.default)($24497896885a019e$export$3005042704f95a69);

});

parcelRegister("hSzd8", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $d042caf1c784373e$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $d042caf1c784373e$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $d042caf1c784373e$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $4uSui.default));
var $d042caf1c784373e$export$2e2bcd8739ae039 = (0, $dgHWV.default)($d042caf1c784373e$export$3005042704f95a69);

});

parcelRegister("dcJ5T", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $99cf6015392f3a97$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $99cf6015392f3a97$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $99cf6015392f3a97$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $4uSui.default));
var $99cf6015392f3a97$export$2e2bcd8739ae039 = (0, $dgHWV.default)($99cf6015392f3a97$export$3005042704f95a69);

});

parcelRegister("bgNFw", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $8347b78297a6a265$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $8347b78297a6a265$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $8347b78297a6a265$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $4uSui.default));
var $8347b78297a6a265$export$2e2bcd8739ae039 = (0, $dgHWV.default)($8347b78297a6a265$export$3005042704f95a69);

});

parcelRegister("jNaNS", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $e68af94860786527$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $e68af94860786527$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $e68af94860786527$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $4uSui.default));
var $e68af94860786527$export$2e2bcd8739ae039 = (0, $dgHWV.default)($e68af94860786527$export$3005042704f95a69);

});

parcelRegister("fmE6L", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $02e2f7d5a20d8a11$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $02e2f7d5a20d8a11$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $02e2f7d5a20d8a11$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $4uSui.default));
var $02e2f7d5a20d8a11$export$2e2bcd8739ae039 = (0, $dgHWV.default)($02e2f7d5a20d8a11$export$3005042704f95a69);

});

parcelRegister("371r2", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $24432380ac871516$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $24432380ac871516$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $24432380ac871516$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $4uSui.default));
var $24432380ac871516$export$2e2bcd8739ae039 = (0, $dgHWV.default)($24432380ac871516$export$3005042704f95a69);

});

parcelRegister("bNziL", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $896fa77b3f281059$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $896fa77b3f281059$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $896fa77b3f281059$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $4uSui.default));
var $896fa77b3f281059$export$2e2bcd8739ae039 = (0, $dgHWV.default)($896fa77b3f281059$export$3005042704f95a69);

});

parcelRegister("4I0q7", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $36db98f22a3eedeb$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $36db98f22a3eedeb$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $36db98f22a3eedeb$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $4uSui.default));
var $36db98f22a3eedeb$export$2e2bcd8739ae039 = (0, $dgHWV.default)($36db98f22a3eedeb$export$3005042704f95a69);

});

parcelRegister("6cyDu", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $483ebb1070643d79$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $483ebb1070643d79$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $483ebb1070643d79$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $4uSui.default));
var $483ebb1070643d79$export$2e2bcd8739ae039 = (0, $dgHWV.default)($483ebb1070643d79$export$3005042704f95a69);

});

parcelRegister("b26Q6", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $80852fc7c9f0a6e5$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $80852fc7c9f0a6e5$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $80852fc7c9f0a6e5$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $4uSui.default));
var $80852fc7c9f0a6e5$export$2e2bcd8739ae039 = (0, $dgHWV.default)($80852fc7c9f0a6e5$export$3005042704f95a69);

});

parcelRegister("gVFQJ", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $c5326ea223b911c4$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $c5326ea223b911c4$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $c5326ea223b911c4$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $4uSui.default));
var $c5326ea223b911c4$export$2e2bcd8739ae039 = (0, $dgHWV.default)($c5326ea223b911c4$export$3005042704f95a69);

});

parcelRegister("5HAIW", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $426d747b1bbfdc66$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $426d747b1bbfdc66$export$2e2bcd8739ae039);

var $4uSui = parcelRequire("4uSui");

var $dgHWV = parcelRequire("dgHWV");
var $426d747b1bbfdc66$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $4uSui.default));
var $426d747b1bbfdc66$export$2e2bcd8739ae039 = (0, $dgHWV.default)($426d747b1bbfdc66$export$3005042704f95a69);

});

parcelRegister("2h6fG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8204d4f03f9127$export$2e2bcd8739ae039);
function $1a8204d4f03f9127$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

});

parcelRegister("3eL2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b72ae3a2b5a9e4$export$2e2bcd8739ae039);

var $jnItG = parcelRequire("jnItG");

var $g6txU = parcelRequire("g6txU");
var $25b72ae3a2b5a9e4$export$2e2bcd8739ae039 = (0, $g6txU.cubehelixLong)((0, $jnItG.default)(300, 0.5, 0.0), (0, $jnItG.default)(-240, 0.5, 1.0));

});
parcelRegister("jnItG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2aaa6e2d37e2a$export$2e2bcd8739ae039);

var $GECEq = parcelRequire("GECEq");

var $5Q7WV = parcelRequire("5Q7WV");

var $2Qxpp = parcelRequire("2Qxpp");
var $e1c2aaa6e2d37e2a$var$A = -0.14861, $e1c2aaa6e2d37e2a$var$B = 1.78277, $e1c2aaa6e2d37e2a$var$C = -0.29227, $e1c2aaa6e2d37e2a$var$D = -0.90649, $e1c2aaa6e2d37e2a$var$E = 1.97294, $e1c2aaa6e2d37e2a$var$ED = $e1c2aaa6e2d37e2a$var$E * $e1c2aaa6e2d37e2a$var$D, $e1c2aaa6e2d37e2a$var$EB = $e1c2aaa6e2d37e2a$var$E * $e1c2aaa6e2d37e2a$var$B, $e1c2aaa6e2d37e2a$var$BC_DA = $e1c2aaa6e2d37e2a$var$B * $e1c2aaa6e2d37e2a$var$C - $e1c2aaa6e2d37e2a$var$D * $e1c2aaa6e2d37e2a$var$A;
function $e1c2aaa6e2d37e2a$var$cubehelixConvert(o) {
    if (o instanceof $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2) return new $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $5Q7WV.Rgb))) o = (0, $5Q7WV.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($e1c2aaa6e2d37e2a$var$BC_DA * b + $e1c2aaa6e2d37e2a$var$ED * r - $e1c2aaa6e2d37e2a$var$EB * g) / ($e1c2aaa6e2d37e2a$var$BC_DA + $e1c2aaa6e2d37e2a$var$ED - $e1c2aaa6e2d37e2a$var$EB), bl = b - l, k = ($e1c2aaa6e2d37e2a$var$E * (g - l) - $e1c2aaa6e2d37e2a$var$C * bl) / $e1c2aaa6e2d37e2a$var$D, s = Math.sqrt(k * k + bl * bl) / ($e1c2aaa6e2d37e2a$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $2Qxpp.degrees) - 120 : NaN;
    return new $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $e1c2aaa6e2d37e2a$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $e1c2aaa6e2d37e2a$var$cubehelixConvert(h) : new $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $GECEq.default)($e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2, $e1c2aaa6e2d37e2a$export$2e2bcd8739ae039, (0, $GECEq.extend)((0, $5Q7WV.Color), {
    brighter: function(k) {
        k = k == null ? (0, $5Q7WV.brighter) : Math.pow((0, $5Q7WV.brighter), k);
        return new $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $5Q7WV.darker) : Math.pow((0, $5Q7WV.darker), k);
        return new $e1c2aaa6e2d37e2a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $2Qxpp.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $5Q7WV.Rgb)(255 * (l + a * ($e1c2aaa6e2d37e2a$var$A * cosh + $e1c2aaa6e2d37e2a$var$B * sinh)), 255 * (l + a * ($e1c2aaa6e2d37e2a$var$C * cosh + $e1c2aaa6e2d37e2a$var$D * sinh)), 255 * (l + a * ($e1c2aaa6e2d37e2a$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("2Qxpp", function(module, exports) {

$parcel$export(module.exports, "radians", () => $212a5a677a0ecc5c$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $212a5a677a0ecc5c$export$41fc368e1a942b97);
const $212a5a677a0ecc5c$export$8449e153fbd325fc = Math.PI / 180;
const $212a5a677a0ecc5c$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("g6txU", function(module, exports) {

$parcel$export(module.exports, "cubehelixLong", () => $bb942016c4c147d0$export$934fa09ad474a1b4);

var $jnItG = parcelRequire("jnItG");

var $63YzK = parcelRequire("63YzK");
function $bb942016c4c147d0$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $jnItG.default)(start)).h, (end = (0, $jnItG.default)(end)).h), s = (0, $63YzK.default)(start.s, end.s), l = (0, $63YzK.default)(start.l, end.l), opacity = (0, $63YzK.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $bb942016c4c147d0$export$2e2bcd8739ae039 = $bb942016c4c147d0$var$cubehelix((0, $63YzK.hue));
var $bb942016c4c147d0$export$934fa09ad474a1b4 = $bb942016c4c147d0$var$cubehelix((0, $63YzK.default));

});


parcelRegister("dTVcM", function(module, exports) {

$parcel$export(module.exports, "warm", () => $a1ecc92c6e5fb6c6$export$fc70efcec537be98);
$parcel$export(module.exports, "cool", () => $a1ecc92c6e5fb6c6$export$c5cedbc1ab3be2c3);
$parcel$export(module.exports, "default", () => $a1ecc92c6e5fb6c6$export$2e2bcd8739ae039);

var $jnItG = parcelRequire("jnItG");

var $g6txU = parcelRequire("g6txU");
var $a1ecc92c6e5fb6c6$export$fc70efcec537be98 = (0, $g6txU.cubehelixLong)((0, $jnItG.default)(-100, 0.75, 0.35), (0, $jnItG.default)(80, 1.50, 0.8));
var $a1ecc92c6e5fb6c6$export$c5cedbc1ab3be2c3 = (0, $g6txU.cubehelixLong)((0, $jnItG.default)(260, 0.75, 0.35), (0, $jnItG.default)(80, 1.50, 0.8));
var $a1ecc92c6e5fb6c6$var$c = (0, $jnItG.default)();
function $a1ecc92c6e5fb6c6$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $a1ecc92c6e5fb6c6$var$c.h = 360 * t - 100;
    $a1ecc92c6e5fb6c6$var$c.s = 1.5 - 1.5 * ts;
    $a1ecc92c6e5fb6c6$var$c.l = 0.8 - 0.9 * ts;
    return $a1ecc92c6e5fb6c6$var$c + "";
}

});

parcelRegister("JEdBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0893669d0cadb076$export$2e2bcd8739ae039);

var $5Q7WV = parcelRequire("5Q7WV");
var $0893669d0cadb076$var$c = (0, $5Q7WV.rgb)(), $0893669d0cadb076$var$pi_1_3 = Math.PI / 3, $0893669d0cadb076$var$pi_2_3 = Math.PI * 2 / 3;
function $0893669d0cadb076$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $0893669d0cadb076$var$c.r = 255 * (x = Math.sin(t)) * x;
    $0893669d0cadb076$var$c.g = 255 * (x = Math.sin(t + $0893669d0cadb076$var$pi_1_3)) * x;
    $0893669d0cadb076$var$c.b = 255 * (x = Math.sin(t + $0893669d0cadb076$var$pi_2_3)) * x;
    return $0893669d0cadb076$var$c + "";
}

});

parcelRegister("bzRII", function(module, exports) {

$parcel$export(module.exports, "default", () => $86dca2506925344a$export$2e2bcd8739ae039);
function $86dca2506925344a$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

});

parcelRegister("2fRjh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a4655c01c8c0377$export$2e2bcd8739ae039);
$parcel$export(module.exports, "magma", () => $1a4655c01c8c0377$export$c41e69203f572e8d);
$parcel$export(module.exports, "inferno", () => $1a4655c01c8c0377$export$ad0c8285c8ea6dbd);
$parcel$export(module.exports, "plasma", () => $1a4655c01c8c0377$export$6664860a633d9daf);

var $4uSui = parcelRequire("4uSui");
function $1a4655c01c8c0377$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $1a4655c01c8c0377$export$2e2bcd8739ae039 = $1a4655c01c8c0377$var$ramp((0, $4uSui.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $1a4655c01c8c0377$export$c41e69203f572e8d = $1a4655c01c8c0377$var$ramp((0, $4uSui.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $1a4655c01c8c0377$export$ad0c8285c8ea6dbd = $1a4655c01c8c0377$var$ramp((0, $4uSui.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $1a4655c01c8c0377$export$6664860a633d9daf = $1a4655c01c8c0377$var$ramp((0, $4uSui.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});


parcelRegister("cA5kC", function(module, exports) {

$parcel$export(module.exports, "create", () => (parcelRequire("68Nxz")).default);
$parcel$export(module.exports, "creator", () => (parcelRequire("4y1qm")).default);
$parcel$export(module.exports, "local", () => (parcelRequire("lD431")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("3Pm5Z")).default);
$parcel$export(module.exports, "namespace", () => (parcelRequire("vb4DM")).default);
$parcel$export(module.exports, "namespaces", () => (parcelRequire("81LHV")).default);
$parcel$export(module.exports, "pointer", () => (parcelRequire("2GQnz")).default);
$parcel$export(module.exports, "pointers", () => (parcelRequire("iBKIW")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("cn1Uc")).default);
$parcel$export(module.exports, "selectAll", () => (parcelRequire("bhKOn")).default);
$parcel$export(module.exports, "selection", () => (parcelRequire("4MWrt")).default);
$parcel$export(module.exports, "selector", () => (parcelRequire("2Dn0x")).default);
$parcel$export(module.exports, "selectorAll", () => (parcelRequire("4yYEN")).default);
$parcel$export(module.exports, "style", () => (parcelRequire("fWzBb")).styleValue);
$parcel$export(module.exports, "window", () => (parcelRequire("6Qhlj")).default);

var $68Nxz = parcelRequire("68Nxz");

var $4y1qm = parcelRequire("4y1qm");

var $lD431 = parcelRequire("lD431");

var $3Pm5Z = parcelRequire("3Pm5Z");

var $vb4DM = parcelRequire("vb4DM");

var $81LHV = parcelRequire("81LHV");

var $2GQnz = parcelRequire("2GQnz");

var $iBKIW = parcelRequire("iBKIW");

var $cn1Uc = parcelRequire("cn1Uc");

var $bhKOn = parcelRequire("bhKOn");

var $4MWrt = parcelRequire("4MWrt");

var $2Dn0x = parcelRequire("2Dn0x");

var $4yYEN = parcelRequire("4yYEN");

var $fWzBb = parcelRequire("fWzBb");

var $6Qhlj = parcelRequire("6Qhlj");

});
parcelRegister("68Nxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4789eb247cf5f23c$export$2e2bcd8739ae039);

var $4y1qm = parcelRequire("4y1qm");

var $cn1Uc = parcelRequire("cn1Uc");
function $4789eb247cf5f23c$export$2e2bcd8739ae039(name) {
    return (0, $cn1Uc.default)((0, $4y1qm.default)(name).call(document.documentElement));
}

});

parcelRegister("lD431", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf06147e3a35bd2$export$2e2bcd8739ae039);
var $fbf06147e3a35bd2$var$nextId = 0;
function $fbf06147e3a35bd2$export$2e2bcd8739ae039() {
    return new $fbf06147e3a35bd2$var$Local;
}
function $fbf06147e3a35bd2$var$Local() {
    this._ = "@" + (++$fbf06147e3a35bd2$var$nextId).toString(36);
}
$fbf06147e3a35bd2$var$Local.prototype = $fbf06147e3a35bd2$export$2e2bcd8739ae039.prototype = {
    constructor: $fbf06147e3a35bd2$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

});

parcelRegister("iBKIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8bfed0e7b303058$export$2e2bcd8739ae039);

var $2GQnz = parcelRequire("2GQnz");

var $hVmiL = parcelRequire("hVmiL");
function $d8bfed0e7b303058$export$2e2bcd8739ae039(events, node) {
    if (events.target) {
        events = (0, $hVmiL.default)(events);
        if (node === undefined) node = events.currentTarget;
        events = events.touches || [
            events
        ];
    }
    return Array.from(events, (event)=>(0, $2GQnz.default)(event, node));
}

});

parcelRegister("bhKOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8375980c9028c4a0$export$2e2bcd8739ae039);

var $jj7uD = parcelRequire("jj7uD");

var $4MWrt = parcelRequire("4MWrt");
function $8375980c9028c4a0$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $4MWrt.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $4MWrt.Selection)([
        selector == null ? [] : (0, $jj7uD.default)(selector)
    ], (0, $4MWrt.root));
}

});


parcelRegister("3PZlk", function(module, exports) {

$parcel$export(module.exports, "arc", () => (parcelRequire("7r1QM")).default);
$parcel$export(module.exports, "area", () => (parcelRequire("hqSfo")).default);
$parcel$export(module.exports, "line", () => (parcelRequire("cEbdq")).default);
$parcel$export(module.exports, "pie", () => (parcelRequire("brp9a")).default);
$parcel$export(module.exports, "areaRadial", () => (parcelRequire("6gaRa")).default);
$parcel$export(module.exports, "radialArea", () => (parcelRequire("6gaRa")).default);
$parcel$export(module.exports, "lineRadial", () => (parcelRequire("fPH47")).default);
$parcel$export(module.exports, "radialLine", () => (parcelRequire("fPH47")).default);
$parcel$export(module.exports, "pointRadial", () => (parcelRequire("kmjru")).default);
$parcel$export(module.exports, "linkHorizontal", () => (parcelRequire("38CWb")).linkHorizontal);
$parcel$export(module.exports, "linkVertical", () => (parcelRequire("38CWb")).linkVertical);
$parcel$export(module.exports, "linkRadial", () => (parcelRequire("38CWb")).linkRadial);
$parcel$export(module.exports, "symbol", () => (parcelRequire("7sFR5")).default);
$parcel$export(module.exports, "symbols", () => (parcelRequire("7sFR5")).symbols);
$parcel$export(module.exports, "symbolCircle", () => (parcelRequire("lxkZm")).default);
$parcel$export(module.exports, "symbolCross", () => (parcelRequire("eEmnV")).default);
$parcel$export(module.exports, "symbolDiamond", () => (parcelRequire("01Nu3")).default);
$parcel$export(module.exports, "symbolSquare", () => (parcelRequire("2bVEh")).default);
$parcel$export(module.exports, "symbolStar", () => (parcelRequire("7iDov")).default);
$parcel$export(module.exports, "symbolTriangle", () => (parcelRequire("2cfMI")).default);
$parcel$export(module.exports, "symbolWye", () => (parcelRequire("hnYZl")).default);
$parcel$export(module.exports, "curveBasisClosed", () => (parcelRequire("ed2Ne")).default);
$parcel$export(module.exports, "curveBasisOpen", () => (parcelRequire("32nF2")).default);
$parcel$export(module.exports, "curveBasis", () => (parcelRequire("4eMJy")).default);
$parcel$export(module.exports, "curveBumpX", () => (parcelRequire("ipXVw")).bumpX);
$parcel$export(module.exports, "curveBumpY", () => (parcelRequire("ipXVw")).bumpY);
$parcel$export(module.exports, "curveBundle", () => (parcelRequire("2kka0")).default);
$parcel$export(module.exports, "curveCardinalClosed", () => (parcelRequire("4BFkD")).default);
$parcel$export(module.exports, "curveCardinalOpen", () => (parcelRequire("gSuRo")).default);
$parcel$export(module.exports, "curveCardinal", () => (parcelRequire("l2Zah")).default);
$parcel$export(module.exports, "curveCatmullRomClosed", () => (parcelRequire("iZe0v")).default);
$parcel$export(module.exports, "curveCatmullRomOpen", () => (parcelRequire("9ABJX")).default);
$parcel$export(module.exports, "curveCatmullRom", () => (parcelRequire("Ccl0h")).default);
$parcel$export(module.exports, "curveLinearClosed", () => (parcelRequire("2R061")).default);
$parcel$export(module.exports, "curveLinear", () => (parcelRequire("ibqDt")).default);
$parcel$export(module.exports, "curveMonotoneX", () => (parcelRequire("l4TGP")).monotoneX);
$parcel$export(module.exports, "curveMonotoneY", () => (parcelRequire("l4TGP")).monotoneY);
$parcel$export(module.exports, "curveNatural", () => (parcelRequire("4FUVT")).default);
$parcel$export(module.exports, "curveStep", () => (parcelRequire("cyzCF")).default);
$parcel$export(module.exports, "curveStepAfter", () => (parcelRequire("cyzCF")).stepAfter);
$parcel$export(module.exports, "curveStepBefore", () => (parcelRequire("cyzCF")).stepBefore);
$parcel$export(module.exports, "stack", () => (parcelRequire("e0afK")).default);
$parcel$export(module.exports, "stackOffsetExpand", () => (parcelRequire("gn1No")).default);
$parcel$export(module.exports, "stackOffsetDiverging", () => (parcelRequire("ltv9b")).default);
$parcel$export(module.exports, "stackOffsetNone", () => (parcelRequire("e7T1S")).default);
$parcel$export(module.exports, "stackOffsetSilhouette", () => (parcelRequire("lcCPb")).default);
$parcel$export(module.exports, "stackOffsetWiggle", () => (parcelRequire("j1Kvi")).default);
$parcel$export(module.exports, "stackOrderAppearance", () => (parcelRequire("9BWi7")).default);
$parcel$export(module.exports, "stackOrderAscending", () => (parcelRequire("bvOzZ")).default);
$parcel$export(module.exports, "stackOrderDescending", () => (parcelRequire("l3aX0")).default);
$parcel$export(module.exports, "stackOrderInsideOut", () => (parcelRequire("6BQEL")).default);
$parcel$export(module.exports, "stackOrderNone", () => (parcelRequire("eYuBV")).default);
$parcel$export(module.exports, "stackOrderReverse", () => (parcelRequire("6E2GP")).default);

var $7r1QM = parcelRequire("7r1QM");

var $hqSfo = parcelRequire("hqSfo");

var $cEbdq = parcelRequire("cEbdq");

var $brp9a = parcelRequire("brp9a");

var $6gaRa = parcelRequire("6gaRa");

var $fPH47 = parcelRequire("fPH47");

var $kmjru = parcelRequire("kmjru");

var $38CWb = parcelRequire("38CWb");

var $7sFR5 = parcelRequire("7sFR5");

var $lxkZm = parcelRequire("lxkZm");

var $eEmnV = parcelRequire("eEmnV");

var $01Nu3 = parcelRequire("01Nu3");

var $2bVEh = parcelRequire("2bVEh");

var $7iDov = parcelRequire("7iDov");

var $2cfMI = parcelRequire("2cfMI");

var $hnYZl = parcelRequire("hnYZl");

var $ed2Ne = parcelRequire("ed2Ne");

var $32nF2 = parcelRequire("32nF2");

var $4eMJy = parcelRequire("4eMJy");

var $ipXVw = parcelRequire("ipXVw");

var $2kka0 = parcelRequire("2kka0");

var $4BFkD = parcelRequire("4BFkD");

var $gSuRo = parcelRequire("gSuRo");

var $l2Zah = parcelRequire("l2Zah");

var $iZe0v = parcelRequire("iZe0v");

var $9ABJX = parcelRequire("9ABJX");

var $Ccl0h = parcelRequire("Ccl0h");

var $2R061 = parcelRequire("2R061");

var $ibqDt = parcelRequire("ibqDt");

var $l4TGP = parcelRequire("l4TGP");

var $4FUVT = parcelRequire("4FUVT");

var $cyzCF = parcelRequire("cyzCF");

var $e0afK = parcelRequire("e0afK");

var $gn1No = parcelRequire("gn1No");

var $ltv9b = parcelRequire("ltv9b");

var $e7T1S = parcelRequire("e7T1S");

var $lcCPb = parcelRequire("lcCPb");

var $j1Kvi = parcelRequire("j1Kvi");

var $9BWi7 = parcelRequire("9BWi7");

var $bvOzZ = parcelRequire("bvOzZ");

var $l3aX0 = parcelRequire("l3aX0");

var $6BQEL = parcelRequire("6BQEL");

var $eYuBV = parcelRequire("eYuBV");

var $6E2GP = parcelRequire("6E2GP");

});
parcelRegister("7r1QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $569c7d6cd9e8047f$export$2e2bcd8739ae039);

var $1ErJ0 = parcelRequire("1ErJ0");

var $6O7ZR = parcelRequire("6O7ZR");

var $86oec = parcelRequire("86oec");
function $569c7d6cd9e8047f$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $569c7d6cd9e8047f$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $569c7d6cd9e8047f$var$arcStartAngle(d) {
    return d.startAngle;
}
function $569c7d6cd9e8047f$var$arcEndAngle(d) {
    return d.endAngle;
}
function $569c7d6cd9e8047f$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $569c7d6cd9e8047f$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $86oec.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $569c7d6cd9e8047f$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $86oec.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $86oec.sqrt)((0, $86oec.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $569c7d6cd9e8047f$export$2e2bcd8739ae039() {
    var innerRadius = $569c7d6cd9e8047f$var$arcInnerRadius, outerRadius = $569c7d6cd9e8047f$var$arcOuterRadius, cornerRadius = (0, $6O7ZR.default)(0), padRadius = null, startAngle = $569c7d6cd9e8047f$var$arcStartAngle, endAngle = $569c7d6cd9e8047f$var$arcEndAngle, padAngle = $569c7d6cd9e8047f$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $86oec.halfPi), a1 = endAngle.apply(this, arguments) - (0, $86oec.halfPi), da = (0, $86oec.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $1ErJ0.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $86oec.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $86oec.tau) - (0, $86oec.epsilon)) {
            context.moveTo(r1 * (0, $86oec.cos)(a0), r1 * (0, $86oec.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $86oec.epsilon)) {
                context.moveTo(r0 * (0, $86oec.cos)(a1), r0 * (0, $86oec.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $86oec.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $86oec.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $86oec.min)((0, $86oec.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $86oec.epsilon)) {
                var p0 = (0, $86oec.asin)(rp / r0 * (0, $86oec.sin)(ap)), p1 = (0, $86oec.asin)(rp / r1 * (0, $86oec.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $86oec.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $86oec.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $86oec.cos)(a01), y01 = r1 * (0, $86oec.sin)(a01), x10 = r0 * (0, $86oec.cos)(a10), y10 = r0 * (0, $86oec.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $86oec.epsilon)) {
                var x11 = r1 * (0, $86oec.cos)(a11), y11 = r1 * (0, $86oec.sin)(a11), x00 = r0 * (0, $86oec.cos)(a00), y00 = r0 * (0, $86oec.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $86oec.pi) && (oc = $569c7d6cd9e8047f$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $86oec.sin)((0, $86oec.acos)((ax * bx + ay * by) / ((0, $86oec.sqrt)(ax * ax + ay * ay) * (0, $86oec.sqrt)(bx * bx + by * by))) / 2), lc = (0, $86oec.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $86oec.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $86oec.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $86oec.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $86oec.epsilon)) {
                t0 = $569c7d6cd9e8047f$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $569c7d6cd9e8047f$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $86oec.atan2)(t0.y01, t0.x01), (0, $86oec.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $86oec.atan2)(t0.y01, t0.x01), (0, $86oec.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $86oec.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $86oec.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $86oec.atan2)(t1.y11, t1.x11), (0, $86oec.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $86oec.epsilon)) || !(da0 > (0, $86oec.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $86oec.epsilon)) {
                t0 = $569c7d6cd9e8047f$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $569c7d6cd9e8047f$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $86oec.atan2)(t0.y01, t0.x01), (0, $86oec.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $86oec.atan2)(t0.y01, t0.x01), (0, $86oec.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $86oec.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $86oec.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $86oec.atan2)(t1.y11, t1.x11), (0, $86oec.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $86oec.pi) / 2;
        return [
            (0, $86oec.cos)(a) * r,
            (0, $86oec.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("6O7ZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4d9d97190e1c24$export$2e2bcd8739ae039);
function $4f4d9d97190e1c24$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("86oec", function(module, exports) {

$parcel$export(module.exports, "abs", () => $5e61ad6f4c5fe0eb$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $5e61ad6f4c5fe0eb$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $5e61ad6f4c5fe0eb$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $5e61ad6f4c5fe0eb$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5e61ad6f4c5fe0eb$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $5e61ad6f4c5fe0eb$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $5e61ad6f4c5fe0eb$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $5e61ad6f4c5fe0eb$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $5e61ad6f4c5fe0eb$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $5e61ad6f4c5fe0eb$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $5e61ad6f4c5fe0eb$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $5e61ad6f4c5fe0eb$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $5e61ad6f4c5fe0eb$export$41726bdb1fc63f);
var $5e61ad6f4c5fe0eb$export$2335f513bbd82c6d = Math.abs;
var $5e61ad6f4c5fe0eb$export$b8b770ee6a0d9760 = Math.atan2;
var $5e61ad6f4c5fe0eb$export$50d414a77b60d802 = Math.cos;
var $5e61ad6f4c5fe0eb$export$8960430cfd85939f = Math.max;
var $5e61ad6f4c5fe0eb$export$96ec731ed4dcb222 = Math.min;
var $5e61ad6f4c5fe0eb$export$5de3937cb4b592ed = Math.sin;
var $5e61ad6f4c5fe0eb$export$eba8049fb5020b81 = Math.sqrt;
var $5e61ad6f4c5fe0eb$export$6c421550c66a327d = 1e-12;
var $5e61ad6f4c5fe0eb$export$18c7bea995a110f = Math.PI;
var $5e61ad6f4c5fe0eb$export$e51408a300e8929a = $5e61ad6f4c5fe0eb$export$18c7bea995a110f / 2;
var $5e61ad6f4c5fe0eb$export$a4b4b4d4d776fe92 = 2 * $5e61ad6f4c5fe0eb$export$18c7bea995a110f;
function $5e61ad6f4c5fe0eb$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $5e61ad6f4c5fe0eb$export$18c7bea995a110f : Math.acos(x);
}
function $5e61ad6f4c5fe0eb$export$41726bdb1fc63f(x) {
    return x >= 1 ? $5e61ad6f4c5fe0eb$export$e51408a300e8929a : x <= -1 ? -$5e61ad6f4c5fe0eb$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("hqSfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0ef1bcad37b883$export$2e2bcd8739ae039);

var $1ErJ0 = parcelRequire("1ErJ0");

var $lVtd9 = parcelRequire("lVtd9");

var $6O7ZR = parcelRequire("6O7ZR");

var $ibqDt = parcelRequire("ibqDt");

var $cEbdq = parcelRequire("cEbdq");

var $3PYLN = parcelRequire("3PYLN");
function $cb0ef1bcad37b883$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $6O7ZR.default)(true), context = null, curve = (0, $ibqDt.default), output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $3PYLN.x) : (0, $6O7ZR.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $6O7ZR.default)(0) : (0, $6O7ZR.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $3PYLN.y) : (0, $6O7ZR.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $lVtd9.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $1ErJ0.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $cEbdq.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $6O7ZR.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("lVtd9", function(module, exports) {

$parcel$export(module.exports, "slice", () => $ff659494eb48a2fd$export$58adb3bec8346d0f);
$parcel$export(module.exports, "default", () => $ff659494eb48a2fd$export$2e2bcd8739ae039);
var $ff659494eb48a2fd$export$58adb3bec8346d0f = Array.prototype.slice;
function $ff659494eb48a2fd$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("ibqDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3cdea62868349dd$export$2e2bcd8739ae039);
function $d3cdea62868349dd$var$Linear(context) {
    this._context = context;
}
$d3cdea62868349dd$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $d3cdea62868349dd$export$2e2bcd8739ae039(context) {
    return new $d3cdea62868349dd$var$Linear(context);
}

});

parcelRegister("cEbdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9351eba0787c368c$export$2e2bcd8739ae039);

var $1ErJ0 = parcelRequire("1ErJ0");

var $lVtd9 = parcelRequire("lVtd9");

var $6O7ZR = parcelRequire("6O7ZR");

var $ibqDt = parcelRequire("ibqDt");

var $3PYLN = parcelRequire("3PYLN");
function $9351eba0787c368c$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $6O7ZR.default)(true), context = null, curve = (0, $ibqDt.default), output = null;
    x = typeof x === "function" ? x : x === undefined ? (0, $3PYLN.x) : (0, $6O7ZR.default)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $3PYLN.y) : (0, $6O7ZR.default)(y);
    function line(data) {
        var i, n = (data = (0, $lVtd9.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $1ErJ0.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $6O7ZR.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("3PYLN", function(module, exports) {

$parcel$export(module.exports, "x", () => $2cb54627820ab8e3$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $2cb54627820ab8e3$export$4a5767248b18ef41);
function $2cb54627820ab8e3$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $2cb54627820ab8e3$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("brp9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $8545b8fce2934508$export$2e2bcd8739ae039);

var $lVtd9 = parcelRequire("lVtd9");

var $6O7ZR = parcelRequire("6O7ZR");

var $eHyVS = parcelRequire("eHyVS");

var $czLTs = parcelRequire("czLTs");

var $86oec = parcelRequire("86oec");
function $8545b8fce2934508$export$2e2bcd8739ae039() {
    var value = (0, $czLTs.default), sortValues = (0, $eHyVS.default), sort = null, startAngle = (0, $6O7ZR.default)(0), endAngle = (0, $6O7ZR.default)((0, $86oec.tau)), padAngle = (0, $6O7ZR.default)(0);
    function pie(data) {
        var i, n = (data = (0, $lVtd9.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $86oec.tau), Math.max(-(0, $86oec.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("eHyVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab402db6a1c7cc90$export$2e2bcd8739ae039);
function $ab402db6a1c7cc90$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("czLTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $927de7946c1286bf$export$2e2bcd8739ae039);
function $927de7946c1286bf$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("6gaRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $48eca898f158ccfa$export$2e2bcd8739ae039);

var $eJuvG = parcelRequire("eJuvG");

var $hqSfo = parcelRequire("hqSfo");

var $fPH47 = parcelRequire("fPH47");
function $48eca898f158ccfa$export$2e2bcd8739ae039() {
    var a = (0, $hqSfo.default)().curve((0, $eJuvG.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $fPH47.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $fPH47.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $fPH47.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $fPH47.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $eJuvG.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("eJuvG", function(module, exports) {

$parcel$export(module.exports, "curveRadialLinear", () => $ab9cef4cf0f38de0$export$22d25ffb9fb15b6f);
$parcel$export(module.exports, "default", () => $ab9cef4cf0f38de0$export$2e2bcd8739ae039);

var $ibqDt = parcelRequire("ibqDt");
var $ab9cef4cf0f38de0$export$22d25ffb9fb15b6f = $ab9cef4cf0f38de0$export$2e2bcd8739ae039((0, $ibqDt.default));
function $ab9cef4cf0f38de0$var$Radial(curve) {
    this._curve = curve;
}
$ab9cef4cf0f38de0$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $ab9cef4cf0f38de0$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $ab9cef4cf0f38de0$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("fPH47", function(module, exports) {

$parcel$export(module.exports, "lineRadial", () => $b86d06544ee30c21$export$4d8815a75dc8cd4d);
$parcel$export(module.exports, "default", () => $b86d06544ee30c21$export$2e2bcd8739ae039);

var $eJuvG = parcelRequire("eJuvG");

var $cEbdq = parcelRequire("cEbdq");
function $b86d06544ee30c21$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $eJuvG.default)(_)) : c()._curve;
    };
    return l;
}
function $b86d06544ee30c21$export$2e2bcd8739ae039() {
    return $b86d06544ee30c21$export$4d8815a75dc8cd4d((0, $cEbdq.default)().curve((0, $eJuvG.curveRadialLinear)));
}

});


parcelRegister("kmjru", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed24f18e508b7f19$export$2e2bcd8739ae039);
function $ed24f18e508b7f19$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("38CWb", function(module, exports) {

$parcel$export(module.exports, "linkHorizontal", () => $2490529da86dae46$export$e7c381889b2cd14d);
$parcel$export(module.exports, "linkVertical", () => $2490529da86dae46$export$75de4c8c66884e04);
$parcel$export(module.exports, "linkRadial", () => $2490529da86dae46$export$7739cfe68d4e0799);

var $1ErJ0 = parcelRequire("1ErJ0");

var $lVtd9 = parcelRequire("lVtd9");

var $6O7ZR = parcelRequire("6O7ZR");

var $3PYLN = parcelRequire("3PYLN");

var $kmjru = parcelRequire("kmjru");
function $2490529da86dae46$var$linkSource(d) {
    return d.source;
}
function $2490529da86dae46$var$linkTarget(d) {
    return d.target;
}
function $2490529da86dae46$var$link(curve) {
    var source = $2490529da86dae46$var$linkSource, target = $2490529da86dae46$var$linkTarget, x = (0, $3PYLN.x), y = (0, $3PYLN.y), context = null;
    function link() {
        var buffer, argv = (0, $lVtd9.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $1ErJ0.default)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $2490529da86dae46$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $2490529da86dae46$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $2490529da86dae46$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $kmjru.default)(x0, y0), p1 = (0, $kmjru.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, $kmjru.default)(x1, y0), p3 = (0, $kmjru.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $2490529da86dae46$export$e7c381889b2cd14d() {
    return $2490529da86dae46$var$link($2490529da86dae46$var$curveHorizontal);
}
function $2490529da86dae46$export$75de4c8c66884e04() {
    return $2490529da86dae46$var$link($2490529da86dae46$var$curveVertical);
}
function $2490529da86dae46$export$7739cfe68d4e0799() {
    var l = $2490529da86dae46$var$link($2490529da86dae46$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});

parcelRegister("7sFR5", function(module, exports) {

$parcel$export(module.exports, "symbols", () => $56eb9d7d9998d6dc$export$47616e9f7f5fe113);
$parcel$export(module.exports, "default", () => $56eb9d7d9998d6dc$export$2e2bcd8739ae039);

var $1ErJ0 = parcelRequire("1ErJ0");

var $lxkZm = parcelRequire("lxkZm");

var $eEmnV = parcelRequire("eEmnV");

var $01Nu3 = parcelRequire("01Nu3");

var $7iDov = parcelRequire("7iDov");

var $2bVEh = parcelRequire("2bVEh");

var $2cfMI = parcelRequire("2cfMI");

var $hnYZl = parcelRequire("hnYZl");

var $6O7ZR = parcelRequire("6O7ZR");
var $56eb9d7d9998d6dc$export$47616e9f7f5fe113 = [
    (0, $lxkZm.default),
    (0, $eEmnV.default),
    (0, $01Nu3.default),
    (0, $2bVEh.default),
    (0, $7iDov.default),
    (0, $2cfMI.default),
    (0, $hnYZl.default)
];
function $56eb9d7d9998d6dc$export$2e2bcd8739ae039(type, size) {
    var context = null;
    type = typeof type === "function" ? type : (0, $6O7ZR.default)(type || (0, $lxkZm.default));
    size = typeof size === "function" ? size : (0, $6O7ZR.default)(size === undefined ? 64 : +size);
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $1ErJ0.default)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $6O7ZR.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("lxkZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fadcf5fb0bb27d29$export$2e2bcd8739ae039);

var $86oec = parcelRequire("86oec");
var $fadcf5fb0bb27d29$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $86oec.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $86oec.tau));
    }
};

});

parcelRegister("eEmnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa62a439f16d386$export$2e2bcd8739ae039);
var $aaa62a439f16d386$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("01Nu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $00567a89ad3c803a$export$2e2bcd8739ae039);
var $00567a89ad3c803a$var$tan30 = Math.sqrt(1 / 3), $00567a89ad3c803a$var$tan30_2 = $00567a89ad3c803a$var$tan30 * 2;
var $00567a89ad3c803a$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $00567a89ad3c803a$var$tan30_2), x = y * $00567a89ad3c803a$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("7iDov", function(module, exports) {

$parcel$export(module.exports, "default", () => $5508c5b76cf5fd1f$export$2e2bcd8739ae039);

var $86oec = parcelRequire("86oec");
var $5508c5b76cf5fd1f$var$ka = 0.89081309152928522810, $5508c5b76cf5fd1f$var$kr = Math.sin((0, $86oec.pi) / 10) / Math.sin(7 * (0, $86oec.pi) / 10), $5508c5b76cf5fd1f$var$kx = Math.sin((0, $86oec.tau) / 10) * $5508c5b76cf5fd1f$var$kr, $5508c5b76cf5fd1f$var$ky = -Math.cos((0, $86oec.tau) / 10) * $5508c5b76cf5fd1f$var$kr;
var $5508c5b76cf5fd1f$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $5508c5b76cf5fd1f$var$ka), x = $5508c5b76cf5fd1f$var$kx * r, y = $5508c5b76cf5fd1f$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $86oec.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("2bVEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $198953b05fe4b9ad$export$2e2bcd8739ae039);
var $198953b05fe4b9ad$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("2cfMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1998f247d84313fb$export$2e2bcd8739ae039);
var $1998f247d84313fb$var$sqrt3 = Math.sqrt(3);
var $1998f247d84313fb$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($1998f247d84313fb$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$1998f247d84313fb$var$sqrt3 * y, -y);
        context.lineTo($1998f247d84313fb$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("hnYZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca83e4abce6dfbd6$export$2e2bcd8739ae039);
var $ca83e4abce6dfbd6$var$c = -0.5, $ca83e4abce6dfbd6$var$s = Math.sqrt(3) / 2, $ca83e4abce6dfbd6$var$k = 1 / Math.sqrt(12), $ca83e4abce6dfbd6$var$a = ($ca83e4abce6dfbd6$var$k / 2 + 1) * 3;
var $ca83e4abce6dfbd6$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $ca83e4abce6dfbd6$var$a), x0 = r / 2, y0 = r * $ca83e4abce6dfbd6$var$k, x1 = x0, y1 = r * $ca83e4abce6dfbd6$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($ca83e4abce6dfbd6$var$c * x0 - $ca83e4abce6dfbd6$var$s * y0, $ca83e4abce6dfbd6$var$s * x0 + $ca83e4abce6dfbd6$var$c * y0);
        context.lineTo($ca83e4abce6dfbd6$var$c * x1 - $ca83e4abce6dfbd6$var$s * y1, $ca83e4abce6dfbd6$var$s * x1 + $ca83e4abce6dfbd6$var$c * y1);
        context.lineTo($ca83e4abce6dfbd6$var$c * x2 - $ca83e4abce6dfbd6$var$s * y2, $ca83e4abce6dfbd6$var$s * x2 + $ca83e4abce6dfbd6$var$c * y2);
        context.lineTo($ca83e4abce6dfbd6$var$c * x0 + $ca83e4abce6dfbd6$var$s * y0, $ca83e4abce6dfbd6$var$c * y0 - $ca83e4abce6dfbd6$var$s * x0);
        context.lineTo($ca83e4abce6dfbd6$var$c * x1 + $ca83e4abce6dfbd6$var$s * y1, $ca83e4abce6dfbd6$var$c * y1 - $ca83e4abce6dfbd6$var$s * x1);
        context.lineTo($ca83e4abce6dfbd6$var$c * x2 + $ca83e4abce6dfbd6$var$s * y2, $ca83e4abce6dfbd6$var$c * y2 - $ca83e4abce6dfbd6$var$s * x2);
        context.closePath();
    }
};

});


parcelRegister("ed2Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $a584723facb401f7$export$2e2bcd8739ae039);

var $eQQpP = parcelRequire("eQQpP");

var $4eMJy = parcelRequire("4eMJy");
function $a584723facb401f7$var$BasisClosed(context) {
    this._context = context;
}
$a584723facb401f7$var$BasisClosed.prototype = {
    areaStart: (0, $eQQpP.default),
    areaEnd: (0, $eQQpP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4eMJy.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a584723facb401f7$export$2e2bcd8739ae039(context) {
    return new $a584723facb401f7$var$BasisClosed(context);
}

});
parcelRegister("eQQpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfe94a7bf413c1d$export$2e2bcd8739ae039);
function $acfe94a7bf413c1d$export$2e2bcd8739ae039() {}

});

parcelRegister("4eMJy", function(module, exports) {

$parcel$export(module.exports, "point", () => $315e45bef88fb3e1$export$105684a3041cb6f3);
$parcel$export(module.exports, "Basis", () => $315e45bef88fb3e1$export$957f7263e89bedd2);
$parcel$export(module.exports, "default", () => $315e45bef88fb3e1$export$2e2bcd8739ae039);
function $315e45bef88fb3e1$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $315e45bef88fb3e1$export$957f7263e89bedd2(context) {
    this._context = context;
}
$315e45bef88fb3e1$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $315e45bef88fb3e1$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $315e45bef88fb3e1$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $315e45bef88fb3e1$export$2e2bcd8739ae039(context) {
    return new $315e45bef88fb3e1$export$957f7263e89bedd2(context);
}

});


parcelRegister("32nF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2363e98e924ecd7a$export$2e2bcd8739ae039);

var $4eMJy = parcelRequire("4eMJy");
function $2363e98e924ecd7a$var$BasisOpen(context) {
    this._context = context;
}
$2363e98e924ecd7a$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $4eMJy.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2363e98e924ecd7a$export$2e2bcd8739ae039(context) {
    return new $2363e98e924ecd7a$var$BasisOpen(context);
}

});

parcelRegister("ipXVw", function(module, exports) {

$parcel$export(module.exports, "bumpX", () => $d6890bfe6597022a$export$2c099b5096f70ce6);
$parcel$export(module.exports, "bumpY", () => $d6890bfe6597022a$export$908da9dfa54cbed6);
class $d6890bfe6597022a$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
function $d6890bfe6597022a$export$2c099b5096f70ce6(context) {
    return new $d6890bfe6597022a$var$Bump(context, true);
}
function $d6890bfe6597022a$export$908da9dfa54cbed6(context) {
    return new $d6890bfe6597022a$var$Bump(context, false);
}

});

parcelRegister("2kka0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1d1674f89f15ca$export$2e2bcd8739ae039);

var $4eMJy = parcelRequire("4eMJy");
function $1b1d1674f89f15ca$var$Bundle(context, beta) {
    this._basis = new (0, $4eMJy.Basis)(context);
    this._beta = beta;
}
$1b1d1674f89f15ca$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $1b1d1674f89f15ca$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $4eMJy.Basis)(context) : new $1b1d1674f89f15ca$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("4BFkD", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", () => $35aaadc7c9e3f8cd$export$da3940d7e9162858);
$parcel$export(module.exports, "default", () => $35aaadc7c9e3f8cd$export$2e2bcd8739ae039);

var $eQQpP = parcelRequire("eQQpP");

var $l2Zah = parcelRequire("l2Zah");
function $35aaadc7c9e3f8cd$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$35aaadc7c9e3f8cd$export$da3940d7e9162858.prototype = {
    areaStart: (0, $eQQpP.default),
    areaEnd: (0, $eQQpP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $l2Zah.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $35aaadc7c9e3f8cd$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $35aaadc7c9e3f8cd$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("l2Zah", function(module, exports) {

$parcel$export(module.exports, "point", () => $f5293af0ba608843$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $f5293af0ba608843$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $f5293af0ba608843$export$2e2bcd8739ae039);
function $f5293af0ba608843$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $f5293af0ba608843$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$f5293af0ba608843$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $f5293af0ba608843$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $f5293af0ba608843$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f5293af0ba608843$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $f5293af0ba608843$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("gSuRo", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", () => $c499a0a7d27cfc04$export$cd7d1a617282f2f1);
$parcel$export(module.exports, "default", () => $c499a0a7d27cfc04$export$2e2bcd8739ae039);

var $l2Zah = parcelRequire("l2Zah");
function $c499a0a7d27cfc04$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c499a0a7d27cfc04$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $l2Zah.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c499a0a7d27cfc04$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c499a0a7d27cfc04$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("iZe0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd28ca0dbf063458$export$2e2bcd8739ae039);

var $4BFkD = parcelRequire("4BFkD");

var $eQQpP = parcelRequire("eQQpP");

var $Ccl0h = parcelRequire("Ccl0h");
function $dd28ca0dbf063458$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$dd28ca0dbf063458$var$CatmullRomClosed.prototype = {
    areaStart: (0, $eQQpP.default),
    areaEnd: (0, $eQQpP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $Ccl0h.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $dd28ca0dbf063458$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $dd28ca0dbf063458$var$CatmullRomClosed(context, alpha) : new (0, $4BFkD.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("Ccl0h", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $072d1ebf6eea818a$export$2e2bcd8739ae039);

var $86oec = parcelRequire("86oec");

var $l2Zah = parcelRequire("l2Zah");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $86oec.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $86oec.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $072d1ebf6eea818a$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $l2Zah.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("9ABJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb4c0494d67e601$export$2e2bcd8739ae039);

var $gSuRo = parcelRequire("gSuRo");

var $Ccl0h = parcelRequire("Ccl0h");
function $6fb4c0494d67e601$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$6fb4c0494d67e601$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $Ccl0h.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $6fb4c0494d67e601$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $6fb4c0494d67e601$var$CatmullRomOpen(context, alpha) : new (0, $gSuRo.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("2R061", function(module, exports) {

$parcel$export(module.exports, "default", () => $21409b17b51117ee$export$2e2bcd8739ae039);

var $eQQpP = parcelRequire("eQQpP");
function $21409b17b51117ee$var$LinearClosed(context) {
    this._context = context;
}
$21409b17b51117ee$var$LinearClosed.prototype = {
    areaStart: (0, $eQQpP.default),
    areaEnd: (0, $eQQpP.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $21409b17b51117ee$export$2e2bcd8739ae039(context) {
    return new $21409b17b51117ee$var$LinearClosed(context);
}

});

parcelRegister("l4TGP", function(module, exports) {

$parcel$export(module.exports, "monotoneX", () => $f5852b879ab5dcb3$export$99563b5420dbdc55);
$parcel$export(module.exports, "monotoneY", () => $f5852b879ab5dcb3$export$8b5360456d6bdb88);
function $f5852b879ab5dcb3$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $f5852b879ab5dcb3$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($f5852b879ab5dcb3$var$sign(s0) + $f5852b879ab5dcb3$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $f5852b879ab5dcb3$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $f5852b879ab5dcb3$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $f5852b879ab5dcb3$var$MonotoneX(context) {
    this._context = context;
}
$f5852b879ab5dcb3$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $f5852b879ab5dcb3$var$point(this, this._t0, $f5852b879ab5dcb3$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $f5852b879ab5dcb3$var$point(this, $f5852b879ab5dcb3$var$slope2(this, t1 = $f5852b879ab5dcb3$var$slope3(this, x, y)), t1);
                break;
            default:
                $f5852b879ab5dcb3$var$point(this, this._t0, t1 = $f5852b879ab5dcb3$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $f5852b879ab5dcb3$var$MonotoneY(context) {
    this._context = new $f5852b879ab5dcb3$var$ReflectContext(context);
}
($f5852b879ab5dcb3$var$MonotoneY.prototype = Object.create($f5852b879ab5dcb3$var$MonotoneX.prototype)).point = function(x, y) {
    $f5852b879ab5dcb3$var$MonotoneX.prototype.point.call(this, y, x);
};
function $f5852b879ab5dcb3$var$ReflectContext(context) {
    this._context = context;
}
$f5852b879ab5dcb3$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $f5852b879ab5dcb3$export$99563b5420dbdc55(context) {
    return new $f5852b879ab5dcb3$var$MonotoneX(context);
}
function $f5852b879ab5dcb3$export$8b5360456d6bdb88(context) {
    return new $f5852b879ab5dcb3$var$MonotoneY(context);
}

});

parcelRegister("4FUVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3677276f90bfbba6$export$2e2bcd8739ae039);
function $3677276f90bfbba6$var$Natural(context) {
    this._context = context;
}
$3677276f90bfbba6$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $3677276f90bfbba6$var$controlPoints(x), py = $3677276f90bfbba6$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $3677276f90bfbba6$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $3677276f90bfbba6$export$2e2bcd8739ae039(context) {
    return new $3677276f90bfbba6$var$Natural(context);
}

});

parcelRegister("cyzCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444ae9253d96cf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "stepBefore", () => $92444ae9253d96cf$export$10eafa5b7478b343);
$parcel$export(module.exports, "stepAfter", () => $92444ae9253d96cf$export$793b3db073781cbb);
function $92444ae9253d96cf$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$92444ae9253d96cf$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $92444ae9253d96cf$export$2e2bcd8739ae039(context) {
    return new $92444ae9253d96cf$var$Step(context, 0.5);
}
function $92444ae9253d96cf$export$10eafa5b7478b343(context) {
    return new $92444ae9253d96cf$var$Step(context, 0);
}
function $92444ae9253d96cf$export$793b3db073781cbb(context) {
    return new $92444ae9253d96cf$var$Step(context, 1);
}

});

parcelRegister("e0afK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31904d0bc8f6d0d$export$2e2bcd8739ae039);

var $lVtd9 = parcelRequire("lVtd9");

var $6O7ZR = parcelRequire("6O7ZR");

var $e7T1S = parcelRequire("e7T1S");

var $eYuBV = parcelRequire("eYuBV");
function $a31904d0bc8f6d0d$var$stackValue(d, key) {
    return d[key];
}
function $a31904d0bc8f6d0d$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $a31904d0bc8f6d0d$export$2e2bcd8739ae039() {
    var keys = (0, $6O7ZR.default)([]), order = (0, $eYuBV.default), offset = (0, $e7T1S.default), value = $a31904d0bc8f6d0d$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $a31904d0bc8f6d0d$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $lVtd9.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $6O7ZR.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $6O7ZR.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $eYuBV.default) : typeof _ === "function" ? _ : (0, $6O7ZR.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $e7T1S.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("e7T1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48c67c7ddac628d$export$2e2bcd8739ae039);
function $a48c67c7ddac628d$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("eYuBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6e69edfff2cbd7$export$2e2bcd8739ae039);
function $ae6e69edfff2cbd7$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("gn1No", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb02fe97dab1aa4$export$2e2bcd8739ae039);

var $e7T1S = parcelRequire("e7T1S");
function $beb02fe97dab1aa4$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $e7T1S.default)(series, order);
}

});

parcelRegister("ltv9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa24778d4c563abb$export$2e2bcd8739ae039);
function $fa24778d4c563abb$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("lcCPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f8d5b3ab9ea9f2$export$2e2bcd8739ae039);

var $e7T1S = parcelRequire("e7T1S");
function $f6f8d5b3ab9ea9f2$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $e7T1S.default)(series, order);
}

});

parcelRegister("j1Kvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda22f011324da61$export$2e2bcd8739ae039);

var $e7T1S = parcelRequire("e7T1S");
function $dda22f011324da61$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $e7T1S.default)(series, order);
}

});

parcelRegister("9BWi7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff4c92b60e7c8ac$export$2e2bcd8739ae039);

var $eYuBV = parcelRequire("eYuBV");
function $6ff4c92b60e7c8ac$export$2e2bcd8739ae039(series) {
    var peaks = series.map($6ff4c92b60e7c8ac$var$peak);
    return (0, $eYuBV.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $6ff4c92b60e7c8ac$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("bvOzZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8619d3019b00e54a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sum", () => $8619d3019b00e54a$export$8a63f25cc62965f1);

var $eYuBV = parcelRequire("eYuBV");
function $8619d3019b00e54a$export$2e2bcd8739ae039(series) {
    var sums = series.map($8619d3019b00e54a$export$8a63f25cc62965f1);
    return (0, $eYuBV.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $8619d3019b00e54a$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("l3aX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5325f625a17f11a$export$2e2bcd8739ae039);

var $bvOzZ = parcelRequire("bvOzZ");
function $f5325f625a17f11a$export$2e2bcd8739ae039(series) {
    return (0, $bvOzZ.default)(series).reverse();
}

});

parcelRegister("6BQEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cff0b44fa39b48c$export$2e2bcd8739ae039);

var $9BWi7 = parcelRequire("9BWi7");

var $bvOzZ = parcelRequire("bvOzZ");
function $4cff0b44fa39b48c$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $bvOzZ.sum)), order = (0, $9BWi7.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("6E2GP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d68909e6e0b8ad5$export$2e2bcd8739ae039);

var $eYuBV = parcelRequire("eYuBV");
function $4d68909e6e0b8ad5$export$2e2bcd8739ae039(series) {
    return (0, $eYuBV.default)(series).reverse();
}

});


parcelRegister("anGg0", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => (parcelRequire("kn9b0")).default);
$parcel$export(module.exports, "timeMillisecond", () => (parcelRequire("fdE0C")).default);
$parcel$export(module.exports, "timeMilliseconds", () => (parcelRequire("fdE0C")).milliseconds);
$parcel$export(module.exports, "utcMillisecond", () => (parcelRequire("fdE0C")).default);
$parcel$export(module.exports, "utcMilliseconds", () => (parcelRequire("fdE0C")).milliseconds);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("2fBxA")).default);
$parcel$export(module.exports, "timeSeconds", () => (parcelRequire("2fBxA")).seconds);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("2fBxA")).default);
$parcel$export(module.exports, "utcSeconds", () => (parcelRequire("2fBxA")).seconds);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("86qgV")).default);
$parcel$export(module.exports, "timeMinutes", () => (parcelRequire("86qgV")).minutes);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("3k7CW")).default);
$parcel$export(module.exports, "timeHours", () => (parcelRequire("3k7CW")).hours);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("2XjAb")).default);
$parcel$export(module.exports, "timeDays", () => (parcelRequire("2XjAb")).days);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("EC7VO")).sunday);
$parcel$export(module.exports, "timeWeeks", () => (parcelRequire("EC7VO")).sundays);
$parcel$export(module.exports, "timeSunday", () => (parcelRequire("EC7VO")).sunday);
$parcel$export(module.exports, "timeSundays", () => (parcelRequire("EC7VO")).sundays);
$parcel$export(module.exports, "timeMonday", () => (parcelRequire("EC7VO")).monday);
$parcel$export(module.exports, "timeMondays", () => (parcelRequire("EC7VO")).mondays);
$parcel$export(module.exports, "timeTuesday", () => (parcelRequire("EC7VO")).tuesday);
$parcel$export(module.exports, "timeTuesdays", () => (parcelRequire("EC7VO")).tuesdays);
$parcel$export(module.exports, "timeWednesday", () => (parcelRequire("EC7VO")).wednesday);
$parcel$export(module.exports, "timeWednesdays", () => (parcelRequire("EC7VO")).wednesdays);
$parcel$export(module.exports, "timeThursday", () => (parcelRequire("EC7VO")).thursday);
$parcel$export(module.exports, "timeThursdays", () => (parcelRequire("EC7VO")).thursdays);
$parcel$export(module.exports, "timeFriday", () => (parcelRequire("EC7VO")).friday);
$parcel$export(module.exports, "timeFridays", () => (parcelRequire("EC7VO")).fridays);
$parcel$export(module.exports, "timeSaturday", () => (parcelRequire("EC7VO")).saturday);
$parcel$export(module.exports, "timeSaturdays", () => (parcelRequire("EC7VO")).saturdays);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("gp296")).default);
$parcel$export(module.exports, "timeMonths", () => (parcelRequire("gp296")).months);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("lHBvw")).default);
$parcel$export(module.exports, "timeYears", () => (parcelRequire("lHBvw")).years);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("13Jpy")).default);
$parcel$export(module.exports, "utcMinutes", () => (parcelRequire("13Jpy")).utcMinutes);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("avRHS")).default);
$parcel$export(module.exports, "utcHours", () => (parcelRequire("avRHS")).utcHours);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("6lT5S")).default);
$parcel$export(module.exports, "utcDays", () => (parcelRequire("6lT5S")).utcDays);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("1nFLz")).utcSunday);
$parcel$export(module.exports, "utcWeeks", () => (parcelRequire("1nFLz")).utcSundays);
$parcel$export(module.exports, "utcSunday", () => (parcelRequire("1nFLz")).utcSunday);
$parcel$export(module.exports, "utcSundays", () => (parcelRequire("1nFLz")).utcSundays);
$parcel$export(module.exports, "utcMonday", () => (parcelRequire("1nFLz")).utcMonday);
$parcel$export(module.exports, "utcMondays", () => (parcelRequire("1nFLz")).utcMondays);
$parcel$export(module.exports, "utcTuesday", () => (parcelRequire("1nFLz")).utcTuesday);
$parcel$export(module.exports, "utcTuesdays", () => (parcelRequire("1nFLz")).utcTuesdays);
$parcel$export(module.exports, "utcWednesday", () => (parcelRequire("1nFLz")).utcWednesday);
$parcel$export(module.exports, "utcWednesdays", () => (parcelRequire("1nFLz")).utcWednesdays);
$parcel$export(module.exports, "utcThursday", () => (parcelRequire("1nFLz")).utcThursday);
$parcel$export(module.exports, "utcThursdays", () => (parcelRequire("1nFLz")).utcThursdays);
$parcel$export(module.exports, "utcFriday", () => (parcelRequire("1nFLz")).utcFriday);
$parcel$export(module.exports, "utcFridays", () => (parcelRequire("1nFLz")).utcFridays);
$parcel$export(module.exports, "utcSaturday", () => (parcelRequire("1nFLz")).utcSaturday);
$parcel$export(module.exports, "utcSaturdays", () => (parcelRequire("1nFLz")).utcSaturdays);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("6JAQ4")).default);
$parcel$export(module.exports, "utcMonths", () => (parcelRequire("6JAQ4")).utcMonths);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("geqc3")).default);
$parcel$export(module.exports, "utcYears", () => (parcelRequire("geqc3")).utcYears);
$parcel$export(module.exports, "utcTicks", () => (parcelRequire("jqhhn")).utcTicks);
$parcel$export(module.exports, "utcTickInterval", () => (parcelRequire("jqhhn")).utcTickInterval);
$parcel$export(module.exports, "timeTicks", () => (parcelRequire("jqhhn")).timeTicks);
$parcel$export(module.exports, "timeTickInterval", () => (parcelRequire("jqhhn")).timeTickInterval);

var $kn9b0 = parcelRequire("kn9b0");

var $fdE0C = parcelRequire("fdE0C");

var $2fBxA = parcelRequire("2fBxA");

var $86qgV = parcelRequire("86qgV");

var $3k7CW = parcelRequire("3k7CW");

var $2XjAb = parcelRequire("2XjAb");

var $EC7VO = parcelRequire("EC7VO");

var $gp296 = parcelRequire("gp296");

var $lHBvw = parcelRequire("lHBvw");

var $13Jpy = parcelRequire("13Jpy");

var $avRHS = parcelRequire("avRHS");

var $6lT5S = parcelRequire("6lT5S");

var $1nFLz = parcelRequire("1nFLz");

var $6JAQ4 = parcelRequire("6JAQ4");

var $geqc3 = parcelRequire("geqc3");

var $jqhhn = parcelRequire("jqhhn");

});
parcelRegister("kn9b0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed4d12e7367c8e36$export$2e2bcd8739ae039);
var $ed4d12e7367c8e36$var$t0 = new Date, $ed4d12e7367c8e36$var$t1 = new Date;
function $ed4d12e7367c8e36$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $ed4d12e7367c8e36$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $ed4d12e7367c8e36$var$t0.setTime(+start), $ed4d12e7367c8e36$var$t1.setTime(+end);
            floori($ed4d12e7367c8e36$var$t0), floori($ed4d12e7367c8e36$var$t1);
            return Math.floor(count($ed4d12e7367c8e36$var$t0, $ed4d12e7367c8e36$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("fdE0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1471ad9b6bfef3c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "milliseconds", () => $b1471ad9b6bfef3c$export$9a27fac83d67afd3);

var $kn9b0 = parcelRequire("kn9b0");
var $b1471ad9b6bfef3c$var$millisecond = (0, $kn9b0.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$b1471ad9b6bfef3c$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $b1471ad9b6bfef3c$var$millisecond;
    return (0, $kn9b0.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $b1471ad9b6bfef3c$export$2e2bcd8739ae039 = $b1471ad9b6bfef3c$var$millisecond;
var $b1471ad9b6bfef3c$export$9a27fac83d67afd3 = $b1471ad9b6bfef3c$var$millisecond.range;

});

parcelRegister("2fBxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3a1a49acc4a2e7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "seconds", () => $1a3a1a49acc4a2e7$export$4792e48abc550fa1);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $1a3a1a49acc4a2e7$var$second = (0, $kn9b0.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $jVh1d.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $1a3a1a49acc4a2e7$export$2e2bcd8739ae039 = $1a3a1a49acc4a2e7$var$second;
var $1a3a1a49acc4a2e7$export$4792e48abc550fa1 = $1a3a1a49acc4a2e7$var$second.range;

});
parcelRegister("jVh1d", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $e8108ab7b611e93d$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $e8108ab7b611e93d$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $e8108ab7b611e93d$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $e8108ab7b611e93d$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $e8108ab7b611e93d$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $e8108ab7b611e93d$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $e8108ab7b611e93d$export$61f8ee2d834c6959);
const $e8108ab7b611e93d$export$79ef0e34099623dc = 1000;
const $e8108ab7b611e93d$export$683905d551c33fa9 = $e8108ab7b611e93d$export$79ef0e34099623dc * 60;
const $e8108ab7b611e93d$export$4157bf0c8e241659 = $e8108ab7b611e93d$export$683905d551c33fa9 * 60;
const $e8108ab7b611e93d$export$353686095f4fbf45 = $e8108ab7b611e93d$export$4157bf0c8e241659 * 24;
const $e8108ab7b611e93d$export$c241eb88520d5016 = $e8108ab7b611e93d$export$353686095f4fbf45 * 7;
const $e8108ab7b611e93d$export$ab95684df7020b26 = $e8108ab7b611e93d$export$353686095f4fbf45 * 30;
const $e8108ab7b611e93d$export$61f8ee2d834c6959 = $e8108ab7b611e93d$export$353686095f4fbf45 * 365;

});


parcelRegister("86qgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e634353e7dab8e3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "minutes", () => $5e634353e7dab8e3$export$666252b437cce0c7);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $5e634353e7dab8e3$var$minute = (0, $kn9b0.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $jVh1d.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $jVh1d.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $5e634353e7dab8e3$export$2e2bcd8739ae039 = $5e634353e7dab8e3$var$minute;
var $5e634353e7dab8e3$export$666252b437cce0c7 = $5e634353e7dab8e3$var$minute.range;

});

parcelRegister("3k7CW", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b927f43d7bbfc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hours", () => $26b927f43d7bbfc9$export$8d468796d69cdad1);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $26b927f43d7bbfc9$var$hour = (0, $kn9b0.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $jVh1d.durationSecond) - date.getMinutes() * (0, $jVh1d.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $jVh1d.durationHour));
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationHour);
}, function(date) {
    return date.getHours();
});
var $26b927f43d7bbfc9$export$2e2bcd8739ae039 = $26b927f43d7bbfc9$var$hour;
var $26b927f43d7bbfc9$export$8d468796d69cdad1 = $26b927f43d7bbfc9$var$hour.range;

});

parcelRegister("2XjAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $22704829921c4c4b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "days", () => $22704829921c4c4b$export$3cf5dda4201cc0f2);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $22704829921c4c4b$var$day = (0, $kn9b0.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $jVh1d.durationMinute)) / (0, $jVh1d.durationDay), (date)=>date.getDate() - 1);
var $22704829921c4c4b$export$2e2bcd8739ae039 = $22704829921c4c4b$var$day;
var $22704829921c4c4b$export$3cf5dda4201cc0f2 = $22704829921c4c4b$var$day.range;

});

parcelRegister("EC7VO", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $07a14fc15c628c6c$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $07a14fc15c628c6c$export$6416afaab03bc9b8);
$parcel$export(module.exports, "tuesday", () => $07a14fc15c628c6c$export$cb8f040f5d17ac7b);
$parcel$export(module.exports, "wednesday", () => $07a14fc15c628c6c$export$347581849975dfc8);
$parcel$export(module.exports, "thursday", () => $07a14fc15c628c6c$export$2f2b56683a3e5629);
$parcel$export(module.exports, "friday", () => $07a14fc15c628c6c$export$59b8c2ccd931d806);
$parcel$export(module.exports, "saturday", () => $07a14fc15c628c6c$export$478ceadebff4d377);
$parcel$export(module.exports, "sundays", () => $07a14fc15c628c6c$export$e8daabaa40641211);
$parcel$export(module.exports, "mondays", () => $07a14fc15c628c6c$export$74e5b559c235c00e);
$parcel$export(module.exports, "tuesdays", () => $07a14fc15c628c6c$export$e7d6aa4fb107bc56);
$parcel$export(module.exports, "wednesdays", () => $07a14fc15c628c6c$export$fcd5880b20bb06a8);
$parcel$export(module.exports, "thursdays", () => $07a14fc15c628c6c$export$682716b7bbe33641);
$parcel$export(module.exports, "fridays", () => $07a14fc15c628c6c$export$482924968ca86084);
$parcel$export(module.exports, "saturdays", () => $07a14fc15c628c6c$export$7d755172c9cda9d2);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
function $07a14fc15c628c6c$var$weekday(i) {
    return (0, $kn9b0.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $jVh1d.durationMinute)) / (0, $jVh1d.durationWeek);
    });
}
var $07a14fc15c628c6c$export$fb3ee18ed410cc21 = $07a14fc15c628c6c$var$weekday(0);
var $07a14fc15c628c6c$export$6416afaab03bc9b8 = $07a14fc15c628c6c$var$weekday(1);
var $07a14fc15c628c6c$export$cb8f040f5d17ac7b = $07a14fc15c628c6c$var$weekday(2);
var $07a14fc15c628c6c$export$347581849975dfc8 = $07a14fc15c628c6c$var$weekday(3);
var $07a14fc15c628c6c$export$2f2b56683a3e5629 = $07a14fc15c628c6c$var$weekday(4);
var $07a14fc15c628c6c$export$59b8c2ccd931d806 = $07a14fc15c628c6c$var$weekday(5);
var $07a14fc15c628c6c$export$478ceadebff4d377 = $07a14fc15c628c6c$var$weekday(6);
var $07a14fc15c628c6c$export$e8daabaa40641211 = $07a14fc15c628c6c$export$fb3ee18ed410cc21.range;
var $07a14fc15c628c6c$export$74e5b559c235c00e = $07a14fc15c628c6c$export$6416afaab03bc9b8.range;
var $07a14fc15c628c6c$export$e7d6aa4fb107bc56 = $07a14fc15c628c6c$export$cb8f040f5d17ac7b.range;
var $07a14fc15c628c6c$export$fcd5880b20bb06a8 = $07a14fc15c628c6c$export$347581849975dfc8.range;
var $07a14fc15c628c6c$export$682716b7bbe33641 = $07a14fc15c628c6c$export$2f2b56683a3e5629.range;
var $07a14fc15c628c6c$export$482924968ca86084 = $07a14fc15c628c6c$export$59b8c2ccd931d806.range;
var $07a14fc15c628c6c$export$7d755172c9cda9d2 = $07a14fc15c628c6c$export$478ceadebff4d377.range;

});

parcelRegister("gp296", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf10a5411a0000b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "months", () => $bf10a5411a0000b3$export$16352d1b10c5eb38);

var $kn9b0 = parcelRequire("kn9b0");
var $bf10a5411a0000b3$var$month = (0, $kn9b0.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $bf10a5411a0000b3$export$2e2bcd8739ae039 = $bf10a5411a0000b3$var$month;
var $bf10a5411a0000b3$export$16352d1b10c5eb38 = $bf10a5411a0000b3$var$month.range;

});

parcelRegister("lHBvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fccab54cd55d3d88$export$2e2bcd8739ae039);
$parcel$export(module.exports, "years", () => $fccab54cd55d3d88$export$6fda41c7fb23acf9);

var $kn9b0 = parcelRequire("kn9b0");
var $fccab54cd55d3d88$var$year = (0, $kn9b0.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$fccab54cd55d3d88$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kn9b0.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $fccab54cd55d3d88$export$2e2bcd8739ae039 = $fccab54cd55d3d88$var$year;
var $fccab54cd55d3d88$export$6fda41c7fb23acf9 = $fccab54cd55d3d88$var$year.range;

});

parcelRegister("13Jpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c594bf7f4c3e8ff$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcMinutes", () => $0c594bf7f4c3e8ff$export$cedd563624e8ee50);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $0c594bf7f4c3e8ff$var$utcMinute = (0, $kn9b0.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $jVh1d.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $0c594bf7f4c3e8ff$export$2e2bcd8739ae039 = $0c594bf7f4c3e8ff$var$utcMinute;
var $0c594bf7f4c3e8ff$export$cedd563624e8ee50 = $0c594bf7f4c3e8ff$var$utcMinute.range;

});

parcelRegister("avRHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a7675ab16e0362f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcHours", () => $7a7675ab16e0362f$export$6e7a76cd5f50b719);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $7a7675ab16e0362f$var$utcHour = (0, $kn9b0.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $jVh1d.durationHour));
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $7a7675ab16e0362f$export$2e2bcd8739ae039 = $7a7675ab16e0362f$var$utcHour;
var $7a7675ab16e0362f$export$6e7a76cd5f50b719 = $7a7675ab16e0362f$var$utcHour.range;

});

parcelRegister("6lT5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ff70b5e706551e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcDays", () => $49ff70b5e706551e$export$d277e198508549a1);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
var $49ff70b5e706551e$var$utcDay = (0, $kn9b0.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $jVh1d.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $49ff70b5e706551e$export$2e2bcd8739ae039 = $49ff70b5e706551e$var$utcDay;
var $49ff70b5e706551e$export$d277e198508549a1 = $49ff70b5e706551e$var$utcDay.range;

});

parcelRegister("1nFLz", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $1018565cd81920c7$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $1018565cd81920c7$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcTuesday", () => $1018565cd81920c7$export$2a6d545f77eceb15);
$parcel$export(module.exports, "utcWednesday", () => $1018565cd81920c7$export$a5c25d8ed64433c4);
$parcel$export(module.exports, "utcThursday", () => $1018565cd81920c7$export$1db08111baec2f53);
$parcel$export(module.exports, "utcFriday", () => $1018565cd81920c7$export$29265e34dd5921f7);
$parcel$export(module.exports, "utcSaturday", () => $1018565cd81920c7$export$85b74dad05049604);
$parcel$export(module.exports, "utcSundays", () => $1018565cd81920c7$export$6f3e1c2b0f7d7880);
$parcel$export(module.exports, "utcMondays", () => $1018565cd81920c7$export$1d2d8b858bb366f9);
$parcel$export(module.exports, "utcTuesdays", () => $1018565cd81920c7$export$1d5f6785fc7f30f8);
$parcel$export(module.exports, "utcWednesdays", () => $1018565cd81920c7$export$7a75faf0e37ef4af);
$parcel$export(module.exports, "utcThursdays", () => $1018565cd81920c7$export$417eb959611b2f2f);
$parcel$export(module.exports, "utcFridays", () => $1018565cd81920c7$export$59d308db7af08c64);
$parcel$export(module.exports, "utcSaturdays", () => $1018565cd81920c7$export$a124108a0a7f34c8);

var $kn9b0 = parcelRequire("kn9b0");

var $jVh1d = parcelRequire("jVh1d");
function $1018565cd81920c7$var$utcWeekday(i) {
    return (0, $kn9b0.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $jVh1d.durationWeek);
    });
}
var $1018565cd81920c7$export$4898b06303a92011 = $1018565cd81920c7$var$utcWeekday(0);
var $1018565cd81920c7$export$9cfc53b9cfafd080 = $1018565cd81920c7$var$utcWeekday(1);
var $1018565cd81920c7$export$2a6d545f77eceb15 = $1018565cd81920c7$var$utcWeekday(2);
var $1018565cd81920c7$export$a5c25d8ed64433c4 = $1018565cd81920c7$var$utcWeekday(3);
var $1018565cd81920c7$export$1db08111baec2f53 = $1018565cd81920c7$var$utcWeekday(4);
var $1018565cd81920c7$export$29265e34dd5921f7 = $1018565cd81920c7$var$utcWeekday(5);
var $1018565cd81920c7$export$85b74dad05049604 = $1018565cd81920c7$var$utcWeekday(6);
var $1018565cd81920c7$export$6f3e1c2b0f7d7880 = $1018565cd81920c7$export$4898b06303a92011.range;
var $1018565cd81920c7$export$1d2d8b858bb366f9 = $1018565cd81920c7$export$9cfc53b9cfafd080.range;
var $1018565cd81920c7$export$1d5f6785fc7f30f8 = $1018565cd81920c7$export$2a6d545f77eceb15.range;
var $1018565cd81920c7$export$7a75faf0e37ef4af = $1018565cd81920c7$export$a5c25d8ed64433c4.range;
var $1018565cd81920c7$export$417eb959611b2f2f = $1018565cd81920c7$export$1db08111baec2f53.range;
var $1018565cd81920c7$export$59d308db7af08c64 = $1018565cd81920c7$export$29265e34dd5921f7.range;
var $1018565cd81920c7$export$a124108a0a7f34c8 = $1018565cd81920c7$export$85b74dad05049604.range;

});

parcelRegister("6JAQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e738572f3dc9b25$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcMonths", () => $4e738572f3dc9b25$export$49159f585997498);

var $kn9b0 = parcelRequire("kn9b0");
var $4e738572f3dc9b25$var$utcMonth = (0, $kn9b0.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $4e738572f3dc9b25$export$2e2bcd8739ae039 = $4e738572f3dc9b25$var$utcMonth;
var $4e738572f3dc9b25$export$49159f585997498 = $4e738572f3dc9b25$var$utcMonth.range;

});

parcelRegister("geqc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1245a2010a5c7d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcYears", () => $bd1245a2010a5c7d$export$3e24d311e17f5802);

var $kn9b0 = parcelRequire("kn9b0");
var $bd1245a2010a5c7d$var$utcYear = (0, $kn9b0.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$bd1245a2010a5c7d$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kn9b0.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $bd1245a2010a5c7d$export$2e2bcd8739ae039 = $bd1245a2010a5c7d$var$utcYear;
var $bd1245a2010a5c7d$export$3e24d311e17f5802 = $bd1245a2010a5c7d$var$utcYear.range;

});

parcelRegister("jqhhn", function(module, exports) {

$parcel$export(module.exports, "utcTicks", () => $e23dd9592f914736$export$826ba5ae907e9767);
$parcel$export(module.exports, "utcTickInterval", () => $e23dd9592f914736$export$6262d8d056ea44c4);
$parcel$export(module.exports, "timeTicks", () => $e23dd9592f914736$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $e23dd9592f914736$export$69511150134dd174);

var $aoNYj = parcelRequire("aoNYj");
var $3PQRV = parcelRequire("3PQRV");

var $jVh1d = parcelRequire("jVh1d");

var $fdE0C = parcelRequire("fdE0C");

var $2fBxA = parcelRequire("2fBxA");

var $86qgV = parcelRequire("86qgV");

var $3k7CW = parcelRequire("3k7CW");

var $2XjAb = parcelRequire("2XjAb");

var $EC7VO = parcelRequire("EC7VO");

var $gp296 = parcelRequire("gp296");

var $lHBvw = parcelRequire("lHBvw");

var $13Jpy = parcelRequire("13Jpy");

var $avRHS = parcelRequire("avRHS");

var $6lT5S = parcelRequire("6lT5S");

var $1nFLz = parcelRequire("1nFLz");

var $6JAQ4 = parcelRequire("6JAQ4");

var $geqc3 = parcelRequire("geqc3");
function $e23dd9592f914736$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $2fBxA.default),
            1,
            (0, $jVh1d.durationSecond)
        ],
        [
            (0, $2fBxA.default),
            5,
            5 * (0, $jVh1d.durationSecond)
        ],
        [
            (0, $2fBxA.default),
            15,
            15 * (0, $jVh1d.durationSecond)
        ],
        [
            (0, $2fBxA.default),
            30,
            30 * (0, $jVh1d.durationSecond)
        ],
        [
            minute,
            1,
            (0, $jVh1d.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $jVh1d.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $jVh1d.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $jVh1d.durationMinute)
        ],
        [
            hour,
            1,
            (0, $jVh1d.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $jVh1d.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $jVh1d.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $jVh1d.durationHour)
        ],
        [
            day,
            1,
            (0, $jVh1d.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $jVh1d.durationDay)
        ],
        [
            week,
            1,
            (0, $jVh1d.durationWeek)
        ],
        [
            month,
            1,
            (0, $jVh1d.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $jVh1d.durationMonth)
        ],
        [
            year,
            1,
            (0, $jVh1d.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $aoNYj.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $3PQRV.tickStep)(start / (0, $jVh1d.durationYear), stop / (0, $jVh1d.durationYear), count));
        if (i === 0) return (0, $fdE0C.default).every(Math.max((0, $3PQRV.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$e23dd9592f914736$export$826ba5ae907e9767, $e23dd9592f914736$export$6262d8d056ea44c4] = $e23dd9592f914736$var$ticker((0, $geqc3.default), (0, $6JAQ4.default), (0, $1nFLz.utcSunday), (0, $6lT5S.default), (0, $avRHS.default), (0, $13Jpy.default));
const [$e23dd9592f914736$export$60c76498552d28a6, $e23dd9592f914736$export$69511150134dd174] = $e23dd9592f914736$var$ticker((0, $lHBvw.default), (0, $gp296.default), (0, $EC7VO.sunday), (0, $2XjAb.default), (0, $3k7CW.default), (0, $86qgV.default));

});


parcelRegister("hvg0P", function(module, exports) {

$parcel$export(module.exports, "timeFormatDefaultLocale", () => (parcelRequire("ioAXI")).default);
$parcel$export(module.exports, "timeFormat", () => (parcelRequire("ioAXI")).timeFormat);
$parcel$export(module.exports, "timeParse", () => (parcelRequire("ioAXI")).timeParse);
$parcel$export(module.exports, "utcFormat", () => (parcelRequire("ioAXI")).utcFormat);
$parcel$export(module.exports, "utcParse", () => (parcelRequire("ioAXI")).utcParse);
$parcel$export(module.exports, "timeFormatLocale", () => (parcelRequire("fhVIv")).default);
$parcel$export(module.exports, "isoFormat", () => (parcelRequire("614Qz")).default);
$parcel$export(module.exports, "isoParse", () => (parcelRequire("9Rxw8")).default);

var $ioAXI = parcelRequire("ioAXI");

var $fhVIv = parcelRequire("fhVIv");

var $614Qz = parcelRequire("614Qz");

var $9Rxw8 = parcelRequire("9Rxw8");

});
parcelRegister("ioAXI", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $d64723d0c30dfb42$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "timeParse", () => $d64723d0c30dfb42$export$32b9cd16e1b8c8d2);
$parcel$export(module.exports, "utcFormat", () => $d64723d0c30dfb42$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $d64723d0c30dfb42$export$3edae9cf8e233729);
$parcel$export(module.exports, "default", () => $d64723d0c30dfb42$export$2e2bcd8739ae039);

var $fhVIv = parcelRequire("fhVIv");
var $d64723d0c30dfb42$var$locale;
var $d64723d0c30dfb42$export$94f4d87fad5dcf9a;
var $d64723d0c30dfb42$export$32b9cd16e1b8c8d2;
var $d64723d0c30dfb42$export$1a08fe38f63ebbbb;
var $d64723d0c30dfb42$export$3edae9cf8e233729;
$d64723d0c30dfb42$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $d64723d0c30dfb42$export$2e2bcd8739ae039(definition) {
    $d64723d0c30dfb42$var$locale = (0, $fhVIv.default)(definition);
    $d64723d0c30dfb42$export$94f4d87fad5dcf9a = $d64723d0c30dfb42$var$locale.format;
    $d64723d0c30dfb42$export$32b9cd16e1b8c8d2 = $d64723d0c30dfb42$var$locale.parse;
    $d64723d0c30dfb42$export$1a08fe38f63ebbbb = $d64723d0c30dfb42$var$locale.utcFormat;
    $d64723d0c30dfb42$export$3edae9cf8e233729 = $d64723d0c30dfb42$var$locale.utcParse;
    return $d64723d0c30dfb42$var$locale;
}

});
parcelRegister("fhVIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21536e7693c10b0$export$2e2bcd8739ae039);

var $2XjAb = parcelRequire("2XjAb");
var $EC7VO = parcelRequire("EC7VO");
var $lHBvw = parcelRequire("lHBvw");
var $6lT5S = parcelRequire("6lT5S");
var $1nFLz = parcelRequire("1nFLz");
var $geqc3 = parcelRequire("geqc3");
function $b21536e7693c10b0$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $b21536e7693c10b0$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $b21536e7693c10b0$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $b21536e7693c10b0$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $b21536e7693c10b0$var$formatRe(locale_periods), periodLookup = $b21536e7693c10b0$var$formatLookup(locale_periods), weekdayRe = $b21536e7693c10b0$var$formatRe(locale_weekdays), weekdayLookup = $b21536e7693c10b0$var$formatLookup(locale_weekdays), shortWeekdayRe = $b21536e7693c10b0$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $b21536e7693c10b0$var$formatLookup(locale_shortWeekdays), monthRe = $b21536e7693c10b0$var$formatRe(locale_months), monthLookup = $b21536e7693c10b0$var$formatLookup(locale_months), shortMonthRe = $b21536e7693c10b0$var$formatRe(locale_shortMonths), shortMonthLookup = $b21536e7693c10b0$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $b21536e7693c10b0$var$formatDayOfMonth,
        "e": $b21536e7693c10b0$var$formatDayOfMonth,
        "f": $b21536e7693c10b0$var$formatMicroseconds,
        "g": $b21536e7693c10b0$var$formatYearISO,
        "G": $b21536e7693c10b0$var$formatFullYearISO,
        "H": $b21536e7693c10b0$var$formatHour24,
        "I": $b21536e7693c10b0$var$formatHour12,
        "j": $b21536e7693c10b0$var$formatDayOfYear,
        "L": $b21536e7693c10b0$var$formatMilliseconds,
        "m": $b21536e7693c10b0$var$formatMonthNumber,
        "M": $b21536e7693c10b0$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $b21536e7693c10b0$var$formatUnixTimestamp,
        "s": $b21536e7693c10b0$var$formatUnixTimestampSeconds,
        "S": $b21536e7693c10b0$var$formatSeconds,
        "u": $b21536e7693c10b0$var$formatWeekdayNumberMonday,
        "U": $b21536e7693c10b0$var$formatWeekNumberSunday,
        "V": $b21536e7693c10b0$var$formatWeekNumberISO,
        "w": $b21536e7693c10b0$var$formatWeekdayNumberSunday,
        "W": $b21536e7693c10b0$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b21536e7693c10b0$var$formatYear,
        "Y": $b21536e7693c10b0$var$formatFullYear,
        "Z": $b21536e7693c10b0$var$formatZone,
        "%": $b21536e7693c10b0$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $b21536e7693c10b0$var$formatUTCDayOfMonth,
        "e": $b21536e7693c10b0$var$formatUTCDayOfMonth,
        "f": $b21536e7693c10b0$var$formatUTCMicroseconds,
        "g": $b21536e7693c10b0$var$formatUTCYearISO,
        "G": $b21536e7693c10b0$var$formatUTCFullYearISO,
        "H": $b21536e7693c10b0$var$formatUTCHour24,
        "I": $b21536e7693c10b0$var$formatUTCHour12,
        "j": $b21536e7693c10b0$var$formatUTCDayOfYear,
        "L": $b21536e7693c10b0$var$formatUTCMilliseconds,
        "m": $b21536e7693c10b0$var$formatUTCMonthNumber,
        "M": $b21536e7693c10b0$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $b21536e7693c10b0$var$formatUnixTimestamp,
        "s": $b21536e7693c10b0$var$formatUnixTimestampSeconds,
        "S": $b21536e7693c10b0$var$formatUTCSeconds,
        "u": $b21536e7693c10b0$var$formatUTCWeekdayNumberMonday,
        "U": $b21536e7693c10b0$var$formatUTCWeekNumberSunday,
        "V": $b21536e7693c10b0$var$formatUTCWeekNumberISO,
        "w": $b21536e7693c10b0$var$formatUTCWeekdayNumberSunday,
        "W": $b21536e7693c10b0$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b21536e7693c10b0$var$formatUTCYear,
        "Y": $b21536e7693c10b0$var$formatUTCFullYear,
        "Z": $b21536e7693c10b0$var$formatUTCZone,
        "%": $b21536e7693c10b0$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $b21536e7693c10b0$var$parseDayOfMonth,
        "e": $b21536e7693c10b0$var$parseDayOfMonth,
        "f": $b21536e7693c10b0$var$parseMicroseconds,
        "g": $b21536e7693c10b0$var$parseYear,
        "G": $b21536e7693c10b0$var$parseFullYear,
        "H": $b21536e7693c10b0$var$parseHour24,
        "I": $b21536e7693c10b0$var$parseHour24,
        "j": $b21536e7693c10b0$var$parseDayOfYear,
        "L": $b21536e7693c10b0$var$parseMilliseconds,
        "m": $b21536e7693c10b0$var$parseMonthNumber,
        "M": $b21536e7693c10b0$var$parseMinutes,
        "p": parsePeriod,
        "q": $b21536e7693c10b0$var$parseQuarter,
        "Q": $b21536e7693c10b0$var$parseUnixTimestamp,
        "s": $b21536e7693c10b0$var$parseUnixTimestampSeconds,
        "S": $b21536e7693c10b0$var$parseSeconds,
        "u": $b21536e7693c10b0$var$parseWeekdayNumberMonday,
        "U": $b21536e7693c10b0$var$parseWeekNumberSunday,
        "V": $b21536e7693c10b0$var$parseWeekNumberISO,
        "w": $b21536e7693c10b0$var$parseWeekdayNumberSunday,
        "W": $b21536e7693c10b0$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $b21536e7693c10b0$var$parseYear,
        "Y": $b21536e7693c10b0$var$parseFullYear,
        "Z": $b21536e7693c10b0$var$parseZone,
        "%": $b21536e7693c10b0$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $b21536e7693c10b0$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $b21536e7693c10b0$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $b21536e7693c10b0$var$utcDate($b21536e7693c10b0$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $1nFLz.utcMonday).ceil(week) : (0, $1nFLz.utcMonday)(week);
                    week = (0, $6lT5S.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $b21536e7693c10b0$var$localDate($b21536e7693c10b0$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $EC7VO.monday).ceil(week) : (0, $EC7VO.monday)(week);
                    week = (0, $2XjAb.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $b21536e7693c10b0$var$utcDate($b21536e7693c10b0$var$newDate(d.y, 0, 1)).getUTCDay() : $b21536e7693c10b0$var$localDate($b21536e7693c10b0$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $b21536e7693c10b0$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $b21536e7693c10b0$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $b21536e7693c10b0$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $b21536e7693c10b0$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $b21536e7693c10b0$var$numberRe = /^\s*\d+/, $b21536e7693c10b0$var$percentRe = /^%/, $b21536e7693c10b0$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $b21536e7693c10b0$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $b21536e7693c10b0$var$requote(s) {
    return s.replace($b21536e7693c10b0$var$requoteRe, "\\$&");
}
function $b21536e7693c10b0$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($b21536e7693c10b0$var$requote).join("|") + ")", "i");
}
function $b21536e7693c10b0$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $b21536e7693c10b0$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseWeekNumberSunday(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseWeekNumberISO(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseWeekNumberMonday(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseFullYear(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseYear(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseQuarter(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseMonthNumber(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseDayOfMonth(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseDayOfYear(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseHour24(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseMinutes(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseSeconds(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseMilliseconds(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseMicroseconds(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseLiteralPercent(d, string, i) {
    var n = $b21536e7693c10b0$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $b21536e7693c10b0$var$parseUnixTimestamp(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $b21536e7693c10b0$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $b21536e7693c10b0$var$formatDayOfMonth(d, p) {
    return $b21536e7693c10b0$var$pad(d.getDate(), p, 2);
}
function $b21536e7693c10b0$var$formatHour24(d, p) {
    return $b21536e7693c10b0$var$pad(d.getHours(), p, 2);
}
function $b21536e7693c10b0$var$formatHour12(d, p) {
    return $b21536e7693c10b0$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $b21536e7693c10b0$var$formatDayOfYear(d, p) {
    return $b21536e7693c10b0$var$pad(1 + (0, $2XjAb.default).count((0, $lHBvw.default)(d), d), p, 3);
}
function $b21536e7693c10b0$var$formatMilliseconds(d, p) {
    return $b21536e7693c10b0$var$pad(d.getMilliseconds(), p, 3);
}
function $b21536e7693c10b0$var$formatMicroseconds(d, p) {
    return $b21536e7693c10b0$var$formatMilliseconds(d, p) + "000";
}
function $b21536e7693c10b0$var$formatMonthNumber(d, p) {
    return $b21536e7693c10b0$var$pad(d.getMonth() + 1, p, 2);
}
function $b21536e7693c10b0$var$formatMinutes(d, p) {
    return $b21536e7693c10b0$var$pad(d.getMinutes(), p, 2);
}
function $b21536e7693c10b0$var$formatSeconds(d, p) {
    return $b21536e7693c10b0$var$pad(d.getSeconds(), p, 2);
}
function $b21536e7693c10b0$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $b21536e7693c10b0$var$formatWeekNumberSunday(d, p) {
    return $b21536e7693c10b0$var$pad((0, $EC7VO.sunday).count((0, $lHBvw.default)(d) - 1, d), p, 2);
}
function $b21536e7693c10b0$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $EC7VO.thursday)(d) : (0, $EC7VO.thursday).ceil(d);
}
function $b21536e7693c10b0$var$formatWeekNumberISO(d, p) {
    d = $b21536e7693c10b0$var$dISO(d);
    return $b21536e7693c10b0$var$pad((0, $EC7VO.thursday).count((0, $lHBvw.default)(d), d) + ((0, $lHBvw.default)(d).getDay() === 4), p, 2);
}
function $b21536e7693c10b0$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $b21536e7693c10b0$var$formatWeekNumberMonday(d, p) {
    return $b21536e7693c10b0$var$pad((0, $EC7VO.monday).count((0, $lHBvw.default)(d) - 1, d), p, 2);
}
function $b21536e7693c10b0$var$formatYear(d, p) {
    return $b21536e7693c10b0$var$pad(d.getFullYear() % 100, p, 2);
}
function $b21536e7693c10b0$var$formatYearISO(d, p) {
    d = $b21536e7693c10b0$var$dISO(d);
    return $b21536e7693c10b0$var$pad(d.getFullYear() % 100, p, 2);
}
function $b21536e7693c10b0$var$formatFullYear(d, p) {
    return $b21536e7693c10b0$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b21536e7693c10b0$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $EC7VO.thursday)(d) : (0, $EC7VO.thursday).ceil(d);
    return $b21536e7693c10b0$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b21536e7693c10b0$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $b21536e7693c10b0$var$pad(z / 60 | 0, "0", 2) + $b21536e7693c10b0$var$pad(z % 60, "0", 2);
}
function $b21536e7693c10b0$var$formatUTCDayOfMonth(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCDate(), p, 2);
}
function $b21536e7693c10b0$var$formatUTCHour24(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCHours(), p, 2);
}
function $b21536e7693c10b0$var$formatUTCHour12(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $b21536e7693c10b0$var$formatUTCDayOfYear(d, p) {
    return $b21536e7693c10b0$var$pad(1 + (0, $6lT5S.default).count((0, $geqc3.default)(d), d), p, 3);
}
function $b21536e7693c10b0$var$formatUTCMilliseconds(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $b21536e7693c10b0$var$formatUTCMicroseconds(d, p) {
    return $b21536e7693c10b0$var$formatUTCMilliseconds(d, p) + "000";
}
function $b21536e7693c10b0$var$formatUTCMonthNumber(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $b21536e7693c10b0$var$formatUTCMinutes(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCMinutes(), p, 2);
}
function $b21536e7693c10b0$var$formatUTCSeconds(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCSeconds(), p, 2);
}
function $b21536e7693c10b0$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $b21536e7693c10b0$var$formatUTCWeekNumberSunday(d, p) {
    return $b21536e7693c10b0$var$pad((0, $1nFLz.utcSunday).count((0, $geqc3.default)(d) - 1, d), p, 2);
}
function $b21536e7693c10b0$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $1nFLz.utcThursday)(d) : (0, $1nFLz.utcThursday).ceil(d);
}
function $b21536e7693c10b0$var$formatUTCWeekNumberISO(d, p) {
    d = $b21536e7693c10b0$var$UTCdISO(d);
    return $b21536e7693c10b0$var$pad((0, $1nFLz.utcThursday).count((0, $geqc3.default)(d), d) + ((0, $geqc3.default)(d).getUTCDay() === 4), p, 2);
}
function $b21536e7693c10b0$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $b21536e7693c10b0$var$formatUTCWeekNumberMonday(d, p) {
    return $b21536e7693c10b0$var$pad((0, $1nFLz.utcMonday).count((0, $geqc3.default)(d) - 1, d), p, 2);
}
function $b21536e7693c10b0$var$formatUTCYear(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b21536e7693c10b0$var$formatUTCYearISO(d, p) {
    d = $b21536e7693c10b0$var$UTCdISO(d);
    return $b21536e7693c10b0$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b21536e7693c10b0$var$formatUTCFullYear(d, p) {
    return $b21536e7693c10b0$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b21536e7693c10b0$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $1nFLz.utcThursday)(d) : (0, $1nFLz.utcThursday).ceil(d);
    return $b21536e7693c10b0$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b21536e7693c10b0$var$formatUTCZone() {
    return "+0000";
}
function $b21536e7693c10b0$var$formatLiteralPercent() {
    return "%";
}
function $b21536e7693c10b0$var$formatUnixTimestamp(d) {
    return +d;
}
function $b21536e7693c10b0$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("614Qz", function(module, exports) {

$parcel$export(module.exports, "isoSpecifier", () => $4616988af4d29eb1$export$491f7bf2e88d83ce);
$parcel$export(module.exports, "default", () => $4616988af4d29eb1$export$2e2bcd8739ae039);

var $ioAXI = parcelRequire("ioAXI");
var $4616988af4d29eb1$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $4616988af4d29eb1$var$formatIsoNative(date) {
    return date.toISOString();
}
var $4616988af4d29eb1$var$formatIso = Date.prototype.toISOString ? $4616988af4d29eb1$var$formatIsoNative : (0, $ioAXI.utcFormat)($4616988af4d29eb1$export$491f7bf2e88d83ce);
var $4616988af4d29eb1$export$2e2bcd8739ae039 = $4616988af4d29eb1$var$formatIso;

});

parcelRegister("9Rxw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e31027306efc6e$export$2e2bcd8739ae039);

var $614Qz = parcelRequire("614Qz");

var $ioAXI = parcelRequire("ioAXI");
function $72e31027306efc6e$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $72e31027306efc6e$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $72e31027306efc6e$var$parseIsoNative : (0, $ioAXI.utcParse)((0, $614Qz.isoSpecifier));
var $72e31027306efc6e$export$2e2bcd8739ae039 = $72e31027306efc6e$var$parseIso;

});


parcelRegister("d44Sf", function(module, exports) {

$parcel$export(module.exports, "now", () => (parcelRequire("knAOt")).now);
$parcel$export(module.exports, "timer", () => (parcelRequire("knAOt")).timer);
$parcel$export(module.exports, "timerFlush", () => (parcelRequire("knAOt")).timerFlush);
$parcel$export(module.exports, "timeout", () => (parcelRequire("1bY0C")).default);
$parcel$export(module.exports, "interval", () => (parcelRequire("i374R")).default);

var $knAOt = parcelRequire("knAOt");

var $1bY0C = parcelRequire("1bY0C");

var $i374R = parcelRequire("i374R");

});
parcelRegister("i374R", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23dff3ef536b569$export$2e2bcd8739ae039);

var $knAOt = parcelRequire("knAOt");
function $d23dff3ef536b569$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $knAOt.Timer), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $knAOt.now)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}

});


parcelRegister("B8rCm", function(module, exports) {

$parcel$export(module.exports, "zoom", () => (parcelRequire("4cX13")).default);
$parcel$export(module.exports, "zoomTransform", () => (parcelRequire("2cBXh")).default);
$parcel$export(module.exports, "zoomIdentity", () => (parcelRequire("2cBXh")).identity);

var $4cX13 = parcelRequire("4cX13");

var $2cBXh = parcelRequire("2cBXh");

});
parcelRegister("4cX13", function(module, exports) {

$parcel$export(module.exports, "default", () => $31060fc2a93034e9$export$2e2bcd8739ae039);

var $2LbPR = parcelRequire("2LbPR");

var $ZdBH5 = parcelRequire("ZdBH5");

var $ajJVo = parcelRequire("ajJVo");

var $2GQnz = parcelRequire("2GQnz");
var $cn1Uc = parcelRequire("cn1Uc");
parcelRequire("d0ohb");
var $cY1kc = parcelRequire("cY1kc");

var $deNr3 = parcelRequire("deNr3");

var $f21ay = parcelRequire("f21ay");

var $2cBXh = parcelRequire("2cBXh");

var $4U0lP = parcelRequire("4U0lP");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $31060fc2a93034e9$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $31060fc2a93034e9$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $31060fc2a93034e9$var$defaultTransform() {
    return this.__zoom || (0, $2cBXh.identity);
}
function $31060fc2a93034e9$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $31060fc2a93034e9$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $31060fc2a93034e9$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $31060fc2a93034e9$export$2e2bcd8739ae039() {
    var filter = $31060fc2a93034e9$var$defaultFilter, extent = $31060fc2a93034e9$var$defaultExtent, constrain = $31060fc2a93034e9$var$defaultConstrain, wheelDelta = $31060fc2a93034e9$var$defaultWheelDelta, touchable = $31060fc2a93034e9$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $ajJVo.default), listeners = (0, $2LbPR.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $31060fc2a93034e9$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $31060fc2a93034e9$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $2cBXh.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $2cBXh.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $2cBXh.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $2cBXh.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cn1Uc.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $f21ay.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $2GQnz.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $cY1kc.default)(this);
            g.start();
        }
        (0, $4U0lP.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, args, true).event(event), v = (0, $cn1Uc.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $2GQnz.default)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
        (0, $ZdBH5.default)(event.view);
        (0, $4U0lP.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $cY1kc.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $4U0lP.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $2GQnz.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $ZdBH5.yesdrag)(event.view, g.moved);
            (0, $4U0lP.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $2GQnz.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4U0lP.default)(event);
        if (duration > 0) (0, $cn1Uc.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cn1Uc.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4U0lP.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $2GQnz.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $cY1kc.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4U0lP.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $2GQnz.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4U0lP.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $2GQnz.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cn1Uc.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $deNr3.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $deNr3.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $deNr3.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $deNr3.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("deNr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a32edfc289e30de$export$2e2bcd8739ae039);
var $9a32edfc289e30de$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("f21ay", function(module, exports) {

$parcel$export(module.exports, "default", () => $af17f31e0702a6ae$export$2e2bcd8739ae039);
function $af17f31e0702a6ae$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("2cBXh", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $19aa24db5d4d0b85$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $19aa24db5d4d0b85$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $19aa24db5d4d0b85$export$2e2bcd8739ae039);
function $19aa24db5d4d0b85$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$19aa24db5d4d0b85$export$563a914cafbdc389.prototype = {
    constructor: $19aa24db5d4d0b85$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $19aa24db5d4d0b85$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $19aa24db5d4d0b85$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $19aa24db5d4d0b85$export$f0954fd7d5368655 = new $19aa24db5d4d0b85$export$563a914cafbdc389(1, 0, 0);
$19aa24db5d4d0b85$export$2e2bcd8739ae039.prototype = $19aa24db5d4d0b85$export$563a914cafbdc389.prototype;
function $19aa24db5d4d0b85$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $19aa24db5d4d0b85$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("4U0lP", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $391caa1c424f1341$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $391caa1c424f1341$export$2e2bcd8739ae039);
function $391caa1c424f1341$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $391caa1c424f1341$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});




parcelRegister("22K6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ballRadiusInches = module.exports.ballRadiusFeet = module.exports.ballDiameterInches = void 0;
var $17cf8706f895e458$var$ballDiameterInches = module.exports.ballDiameterInches = 2.9;
var $17cf8706f895e458$var$ballRadiusInches = module.exports.ballRadiusInches = $17cf8706f895e458$var$ballDiameterInches / 2;
var $17cf8706f895e458$var$ballRadiusFeet = module.exports.ballRadiusFeet = $17cf8706f895e458$var$ballRadiusInches / 12;

});


parcelRegister("1WMBp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $53a54aef8495494b$var$SingleEventHtml;

var $53a54aef8495494b$var$_formatCapitals = $53a54aef8495494b$var$_interopRequireDefault((parcelRequire("hARn9")));

var $5kS6g = parcelRequire("5kS6g");
function $53a54aef8495494b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $53a54aef8495494b$var$getBaseSituationText(pitch) {
    var runnerOn1B = pitch.runnerOn1B || false;
    var runnerOn2B = pitch.runnerOn2B || false;
    var runnerOn3B = pitch.runnerOn3B || false;
    if (!runnerOn1B && !runnerOn2B && !runnerOn3B) return 'None';
    if (runnerOn1B && runnerOn2B && runnerOn3B) return 'Bases Loaded';
    var runnersOn = Number(runnerOn1B) + Number(runnerOn2B) + Number(runnerOn3B);
    var firstText = runnerOn1B ? '1st' : '';
    var secondText = runnerOn2B ? '2nd' : '';
    var thirdText = runnerOn3B ? '3rd' : '';
    if (runnersOn === 1) return "".concat(firstText).concat(secondText).concat(thirdText);
    // Only 2 runners on case left
    if (runnerOn1B) return "".concat(firstText, " & ").concat(secondText).concat(thirdText);
    return "".concat(secondText, " & ").concat(thirdText);
}
function $53a54aef8495494b$var$getNiceChallengeText(pitch, desc, challenge) {
    var type = challenge.challenging_player_type;
    var capitalType = type.charAt(0).toUpperCase() + type.slice(1);
    var decision = challenge.is_overturned ? 'overturned' : 'confirmed';
    var isGamefeed = (0, $5kS6g.isGamefeedRawData)(pitch);
    var basesSituationText;
    if (isGamefeed) basesSituationText = $53a54aef8495494b$var$getBaseSituationText(pitch);
    return "\n        ".concat(isGamefeed ? "<div>Runners On: ".concat(basesSituationText, "</div>") : '', "\n        <div>\n            <em>").concat(capitalType, " challenged, call ").concat(decision, "</em>\n        </div>\n        ");
}
function $53a54aef8495494b$var$getNiceDescription(desc, event_text) {
    switch(desc){
        case '':
            return '';
        case 'swinging_strike_blocked':
            return 'Swinging Strike (Blocked)';
        case 'hit_into_play':
            return (0, $53a54aef8495494b$var$_formatCapitals["default"])(event_text);
        default:
            // All other event types in the database can be handled just by the default capitalization handling
            return (0, $53a54aef8495494b$var$_formatCapitals["default"])(desc);
    }
}
function $53a54aef8495494b$var$SingleEventHtml(point, challenge) {
    if ((0, $5kS6g.isGamefeedRawData)(point)) return $53a54aef8495494b$var$getGamefeedHtml(point);
    var niceDescription = $53a54aef8495494b$var$getNiceDescription(point.description, point.events);
    var absDescription = challenge ? $53a54aef8495494b$var$getNiceChallengeText(point, point.description, challenge) : '';
    var niceContactType = point.is_hit_into_play ? (0, $53a54aef8495494b$var$_formatCapitals["default"])(point.stringer_hit_trajectory) : '';
    return "\n    ".concat(point.pitch_name ? "<div>".concat(point.pitch_name, "</div>") : '', "\n    ").concat(point.batter_name ? "<div>Batter: ".concat(point.batter_name, "</div>") : '', "\n    ").concat(point.pitcher_name ? "<div>Pitcher: ".concat(point.pitcher_name, "</div>") : '', "\n    ").concat(point.game_date ? "<div>Date: ".concat(point.game_date, "</div>") : '', "\n\n    ").concat(point.release_speed ? "<div>Pitch Speed: ".concat(point.release_speed, "</div>") : '', "\n    ").concat(point.launch_speed ? "<div>Exit Velocity: ".concat(point.launch_speed, "</div>") : '', "\n    ").concat(!point.launch_speed && point.h_launch_speed ? "<div>Exit Velocity: ".concat(point.h_launch_speed, "</div>") : '', "\n\n    ").concat(point.launch_angle ? "<div>Launch Angle: ".concat(point.launch_angle, "</div>") : '', "\n    ").concat(!point.launch_angle && point.h_launch_angle ? "<div>Launch Angle: ".concat(point.h_launch_angle, "</div>") : '', "\n\n    ").concat(point.inning != null ? "<div>Inning: ".concat(point.inning, "</div>") : '', "\n\n    ").concat(point.balls != null ? "<div>Count: ".concat(point.balls, "-").concat(point.strikes, "</div>") : '', "\n    ").concat(point.outs_when_up != null ? "<div>Outs: ".concat(point.outs_when_up, "</div>") : '', "\n\n    ").concat(niceDescription ? "<div>Result: ".concat(niceDescription, "</div>") : '', "\n    ").concat(absDescription, "\n\n    ").concat(niceContactType ? "<div>Contact Type: ".concat(niceContactType, "</div>") : '', "\n    ");
}
// TODO: Outs is wrong
function $53a54aef8495494b$var$getGamefeedHtml(pitch) {
    var absDescription = pitch.abs_challenge ? $53a54aef8495494b$var$getNiceChallengeText(pitch, pitch.description, pitch.abs_challenge) : '';
    var niceDescription = $53a54aef8495494b$var$getNiceDescription(pitch.description, pitch.events);
    return "\n    ".concat(pitch.pitch_name ? "<div>".concat(pitch.pitch_name, "</div>") : '', "\n    ").concat(pitch.batter_name ? "<div>Batter: ".concat(pitch.batter_name, "</div>") : '', "\n    ").concat(pitch.pitcher_name ? "<div>Pitcher: ".concat(pitch.pitcher_name, "</div>") : '', "\n\n    ").concat(pitch.hit_speed ? "<div>Exit Velocity: ".concat(pitch.hit_speed, "</div>") : '', "\n\n    ").concat(pitch.hit_angle ? "<div>Launch Angle: ".concat(pitch.hit_angle, "</div>") : '', "\n\n    ").concat(pitch.start_speed ? "<div>Pitch Speed: ".concat(pitch.start_speed, "</div>") : '', "\n\n    ").concat(pitch.inning != null ? "<div>Inning: ".concat(pitch.inning, "</div>") : '', "\n\n    ").concat(pitch.balls != null ? "<div>Count: ".concat(pitch.balls, "-").concat(pitch.strikes, "</div>") : '', "\n    ").concat(pitch.outs != null ? "<div>Outs: ".concat(pitch.outs, "</div>") : '', "\n    ").concat(absDescription, "\n    ").concat(niceDescription ? "<div>Result: ".concat(niceDescription, "</div>") : '', "\n    ");
}

});
parcelRegister("hARn9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5676234b096b9d6d$var$formatCapitals;
function $5676234b096b9d6d$var$formatCapitals(str) {
    if (typeof str !== 'string') return '';
    return str.toLowerCase().split('_').map(function(s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
    }).join(' ');
}

});


parcelRegister("1k8Kz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveBadPitchPoints = $b9da95d2ac7edaf3$var$RemoveBadPitchPoints;
module.exports.RemoveBadSprayPoints = $b9da95d2ac7edaf3$var$RemoveBadSprayPoints;

var $5kS6g = parcelRequire("5kS6g");
function $b9da95d2ac7edaf3$var$RemoveBadSprayPoints(data) {
    return data.filter(function(d) {
        return d.hc_x_ft && d.hc_y_ft;
    });
}
function $b9da95d2ac7edaf3$var$RemoveBadPitchPoints(data) {
    return data.filter(function(d) {
        return d.px && d.pz && d.pitch_type && d.pitch_type !== null && d.pitch_type !== '' || // TODO: Is this what we want? Just copying the way it's been done.
        !(0, $5kS6g.isGamefeedRawData)(d) && d.is_pa === '1';
    });
}

});


parcelRegister("clJ7m", function(module, exports) {

var $3lsK8 = parcelRequire("3lsK8");

var $a8kKW = parcelRequire("a8kKW");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $8fda71a8e3edfd8d$var$find = $3lsK8($a8kKW);
module.exports = $8fda71a8e3edfd8d$var$find;

});
parcelRegister("3lsK8", function(module, exports) {

var $gMaAW = parcelRequire("gMaAW");

var $iHYLr = parcelRequire("iHYLr");

var $2XAnP = parcelRequire("2XAnP");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $26f9a1107f145caf$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$iHYLr(collection)) {
            var iteratee = $gMaAW(predicate, 3);
            collection = $2XAnP(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $26f9a1107f145caf$var$createFind;

});

parcelRegister("a8kKW", function(module, exports) {

var $eYJO6 = parcelRequire("eYJO6");

var $gMaAW = parcelRequire("gMaAW");

var $9Ze0B = parcelRequire("9Ze0B");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $760ac075ca49c0fb$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $760ac075ca49c0fb$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $9Ze0B(fromIndex);
    if (index < 0) index = $760ac075ca49c0fb$var$nativeMax(length + index, 0);
    return $eYJO6(array, $gMaAW(predicate, 3), index);
}
module.exports = $760ac075ca49c0fb$var$findIndex;

});


parcelRegister("4I68J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.getPitchWeight = $ac1d4bed8f82917f$var$getPitchWeight;
module.exports.sortPitchTypes = $ac1d4bed8f82917f$var$sortPitchTypes;
var $ac1d4bed8f82917f$var$pitchTypeOrder = {
    // Fastballs
    FF: 10,
    SI: 20,
    FT: 30,
    FC: 40,
    // Offspeed
    CH: 50,
    FS: 60,
    FO: 70,
    SC: 80,
    // Breaking
    // Curveballs
    CU: 90,
    KC: 100,
    CS: 110,
    // Sliders
    SL: 120,
    ST: 130,
    SV: 140,
    // Weird
    KN: 150,
    // OTher
    EP: 160,
    FA: 170,
    IN: 180,
    PO: 190
};
var $ac1d4bed8f82917f$var$_default = module.exports["default"] = $ac1d4bed8f82917f$var$pitchTypeOrder;
function $ac1d4bed8f82917f$var$getPitchWeight(pitchType) {
    return $ac1d4bed8f82917f$var$pitchTypeOrder[pitchType] || Number.MAX_SAFE_INTEGER;
}
function $ac1d4bed8f82917f$var$sortPitchTypes(types) {
    return types.sort(function(a, b) {
        return $ac1d4bed8f82917f$var$getPitchWeight(a) - $ac1d4bed8f82917f$var$getPitchWeight(b);
    });
}

});

parcelRegister("aMSIv", function(module, exports) {
"use strict";

var $cbJvd = parcelRequire("cbJvd");
var $7da8d4b21cb48d39$var$getPitchTypeGroup = $cbJvd.getPitchTypeGroup;
var $7da8d4b21cb48d39$var$pitchNames = {
    ALL: 'All Pitches',
    Fastball: 'Fastballs',
    Offspeed: 'Offspeed',
    Breaking: 'Breaking',
    FASTBALL: 'Fastballs',
    OFFSPEED: 'Offspeed',
    BREAKING: 'Breaking',
    CHFS: 'Changeup',
    CUKC: 'Curve',
    SIFT: 'Sinker',
    FF: 'Four Seamer',
    FT: 'Two Seamer',
    SI: 'Sinker',
    FC: 'Cutter',
    FA: 'Other',
    CH: 'Changeup',
    FS: 'Split Finger',
    SC: 'Screwball',
    FO: 'Forkball',
    SL: 'Slider',
    ST: 'Sweeper',
    SV: 'Slurve',
    GY: 'Gyro',
    CU: 'Curveball',
    KC: 'Knuckle Curve',
    CS: 'Slow Curve',
    KN: 'Knuckleball',
    EP: 'Eephus'
};
function $7da8d4b21cb48d39$var$getPitchName(pitchType) {
    try {
        return $7da8d4b21cb48d39$var$pitchNames[pitchType.toUpperCase()] || pitchType;
    } catch (e) {
        return '';
    }
}
function $7da8d4b21cb48d39$var$getPitchNameGrouping(pitchType) {
    var pitchTypeGroup = $7da8d4b21cb48d39$var$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) // TODO: WHATTODO?
    return 'Unknown';
    return $7da8d4b21cb48d39$var$getPitchName(pitchTypeGroup);
}
function $7da8d4b21cb48d39$var$orderPitchTypes(typesArr) {
    var pitchOrder = Object.keys($7da8d4b21cb48d39$var$pitchNames);
    return typesArr.sort(function(a, b) {
        return pitchOrder.indexOf(a) - pitchOrder.indexOf(b);
    });
}
// These subgroups combines offspeed -> changeup but also fastballs.
function $7da8d4b21cb48d39$var$orderPitchTypeSubgroups(typesArr) {
    var pitchOrder = [
        'Fastball',
        'Cutter',
        'Slider',
        'Curve',
        'Changeup',
        'Knuckleball'
    ];
    return typesArr.sort(function(a, b) {
        return pitchOrder.indexOf(a) - pitchOrder.indexOf(b);
    });
}
module.exports = {
    pitchNames: $7da8d4b21cb48d39$var$pitchNames,
    getPitchName: $7da8d4b21cb48d39$var$getPitchName,
    getPitchNameGrouping: $7da8d4b21cb48d39$var$getPitchNameGrouping,
    orderPitchTypes: $7da8d4b21cb48d39$var$orderPitchTypes,
    orderPitchTypeSubgroups: $7da8d4b21cb48d39$var$orderPitchTypeSubgroups
};

});
parcelRegister("cbJvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPitchTypeGroup = $d95d8b439f5daf31$var$getPitchTypeGroup;
/* eslint-disable import/prefer-default-export */ var $d95d8b439f5daf31$var$pitchTypeGroups = {
    FF: 'FASTBALL',
    CU: 'BREAKING',
    CH: 'OFFSPEED'
};
function $d95d8b439f5daf31$var$getPitchTypeGroup(pitchType) {
    var upperPitchType = String(pitchType || '').toUpperCase();
    return $d95d8b439f5daf31$var$pitchTypeGroups[upperPitchType] || null;
}

});


parcelRegister("jrjqE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1d4204e157a04fc6$var$canBePersonalized;
// Same idea as `canBePersonalized` in evp
function $1d4204e157a04fc6$var$canBePersonalized(data) {
    // Need to find the strike zone data and all be equivalent to be personalized
    if (!data.length) return false;
    var _data$ = data[0], sz_bot = _data$.sz_bot, sz_depth = _data$.sz_depth, sz_top = _data$.sz_top, sz_width = _data$.sz_width;
    if (sz_bot === undefined || sz_top === undefined || sz_top === null || sz_bot === null) return false;
    return data.every(function(d) {
        return d.sz_bot === sz_bot && d.sz_top === sz_top && d.sz_width === sz_width && d.sz_depth === sz_depth;
    });
}

});

parcelRegister("394kY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $24a593a7508162c2$var$LoadSchema;

var $24a593a7508162c2$var$_default = $24a593a7508162c2$var$_interopRequireDefault((parcelRequire("75Wp0")));

var $24a593a7508162c2$var$_clone = $24a593a7508162c2$var$_interopRequireDefault((parcelRequire("1O5Th")));

var $24a593a7508162c2$var$_find = $24a593a7508162c2$var$_interopRequireDefault((parcelRequire("clJ7m")));
function $24a593a7508162c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable prefer-destructuring */ function $24a593a7508162c2$var$LoadSchema(data, player, options) {
    var schema = (0, $24a593a7508162c2$var$_clone["default"])($24a593a7508162c2$var$_default["default"]);
    schema.chartTypeCategory = '';
    schema.selectedChart = options.selectedChart;
    var chart = {
        legend: true
    };
    var isRHB = (0, $24a593a7508162c2$var$_find["default"])(data, function(d) {
        return d.stand === 'R';
    });
    var isLHB = (0, $24a593a7508162c2$var$_find["default"])(data, function(d) {
        return d.stand === 'L';
    });
    chart.showRHB = !!isRHB;
    chart.showLHB = !!isLHB;
    var pitcherPerspective = options.perspective === 'pitcher';
    var normalize = options.normalize === 'normalized';
    if (options.selectedChart.indexOf('pitchChart') > -1) {
        var type = options.selectedChart.split('-');
        chart.chartType = 'pitch';
        chart.overlayType = 'pitch';
        schema.chartType = 'pitch';
        schema.chartTypeCategory = 'pitch';
        chart.strikeZoneFill = 'NONE';
        chart.type = type[1];
        chart.legendType = type[1];
        chart.show = true;
        chart.legend = true;
        chart.showStrikeZone = true;
        chart.showPlate = true;
        chart.pitcherPerspective = pitcherPerspective;
        chart.normalize = normalize;
    } else if (options.selectedChart.indexOf('zoneChart') > -1) {
        var _type = options.selectedChart.split('-');
        chart.chartType = 'pitch';
        chart.overlayType = 'zone';
        schema.chartType = 'pitch';
        schema.chartTypeCategory = 'zone';
        chart.showText = true;
        chart.type = _type[1];
        chart.show = true;
        chart.showPlate = true;
        chart.pitcherPerspective = pitcherPerspective;
    } else if (options.selectedChart.indexOf('hexBinChart') > -1) {
        var _type2 = options.selectedChart.split('-');
        chart.chartType = 'pitch';
        chart.overlayType = 'hexbin';
        schema.chartType = 'pitch';
        schema.chartTypeCategory = 'hexbin';
        chart.type = _type2[1];
        chart.show = true;
        chart.scaleRadius = true;
        chart.legend = true;
        chart.showStrikeZone = true;
        chart.showPlate = true;
        chart.pitcherPerspective = pitcherPerspective;
        chart.normalize = normalize;
    } else if (options.selectedChart.indexOf('pitchPie') > -1) {
        chart.chartType = 'pitch';
        chart.overlayType = 'pie';
        schema.chartType = 'pitch';
        schema.chartTypeCategory = 'pie';
        chart.show = true;
        chart.scaleRadius = true;
        chart.legend = true;
        chart.showStrikeZone = true;
        chart.showPlate = true;
        chart.pitcherPerspective = pitcherPerspective;
        chart.normalize = normalize;
    } else if (options.selectedChart.indexOf('pitchContour') > -1) {
        chart.chartType = 'pitch';
        chart.overlayType = 'contour';
        schema.chartType = 'pitch';
        schema.chartTypeCategory = 'contour';
        chart.legend = true;
        chart.show = true;
        chart.showStrikeZone = true;
        chart.showPlate = true;
        chart.pitcherPerspective = pitcherPerspective;
        chart.normalize = normalize;
    } else if (options.selectedChart.indexOf('lineGraphChart') > -1) {
        var _type3 = options.selectedChart.split('-')[1];
        schema.chartType = 'line';
        chart.show = true;
        chart.chartType = 'line';
        chart.chartTypeCategory = _type3[1];
        if (_type3 === 'pitchVelocity') {
            chart.yField = 'releaseSpeed';
            chart.legendType = 'pitchName';
            chart.groupBy = 'pitchName';
            chart.autoFilterBadPoints = true;
            chart.unit = 'MPH';
            chart.yDomain = [
                60,
                105
            ];
            chart.yRange = 10;
        }
        if (_type3 === 'spinRate') {
            chart.yField = 'releaseSpinRate';
            chart.legendType = 'pitchName';
            chart.groupBy = 'pitchName';
            chart.autoFilterBadPoints = true;
            chart.unit = 'RPM';
            chart.yDomain = [
                0,
                3500
            ];
            chart.yRange = 1000;
        }
    } else if (options.selectedChart.indexOf('sprayChart') > -1) {
        schema.chartType = 'field';
        schema.chartTypeCategory = 'spray';
        chart.chartType = 'field';
        chart.overlayType = 'spray';
        chart.legend = true;
        chart.legendType = 'paResult';
        chart.show = true;
    } else if (options.selectedChart.indexOf('sprayHexBin') > -1) {
        var _type4 = options.selectedChart.split('-');
        chart.chartType = 'field';
        chart.overlayType = 'hexbin';
        schema.chartType = 'field';
        schema.chartTypeCategory = 'hexbin';
        chart.type = _type4[1];
        chart.legend = true;
        chart.show = true;
        chart.scaleRadius = true;
    } else if (options.selectedChart.indexOf('sprayContour') > -1) {
        chart.chartType = 'field';
        chart.overlayType = 'contour';
        schema.chartType = 'field';
        schema.chartTypeCategory = 'contour';
        chart.show = true;
        chart.legend = true;
    } else if (options.selectedChart.indexOf('3d') > -1) {
        var view = options.selectedChart.split('-');
        schema.chartType = '3d';
        schema.chartTypeCategory = 'spray';
        chart.chartType = '3d';
        chart.legend = true;
        chart.legendType = 'paResult';
        chart.overlayType = 'spray';
        chart.view = view[1];
    } else if (options.selectedChart === 'release') {
        schema.chartType = 'release';
        chart.legendType = 'pitchName';
        chart.legend = true;
        chart.chartType = 'release';
    } else if (options.selectedChart === 'movement') {
        schema.chartType = 'movement';
        chart.legendType = 'pitchName';
        chart.legend = true;
        chart.chartType = 'movement';
    } else if (options.selectedChart.indexOf('z-movement-line') > -1) {
        chart.show = true;
        chart.chartType = 'line';
        schema.chartType = 'line';
        chart.yField = 'pfxZGravity';
        chart.legend = true;
        chart.legendType = 'pitchName';
        chart.groupBy = 'pitchName';
        chart.autoFilterBadPoints = true;
        chart.unit = '"';
        chart.yDomain = [
            70,
            0
        ];
        chart.yRange = 10;
    } else if (options.selectedChart.indexOf('x-movement-line') > -1) {
        chart.show = true;
        chart.chartType = 'line';
        schema.chartType = 'line';
        chart.yField = 'pfxX';
        chart.legend = true;
        chart.legendType = 'pitchName';
        chart.groupBy = 'pitchName';
        chart.autoFilterBadPoints = false;
        chart.unit = '"';
        chart.yDomain = [
            -25,
            25
        ];
        chart.yRange = 5;
    } else if (options.selectedChart === 'radial') {
        schema.chartType = 'radial';
        chart.chartType = 'radial';
    } else if (options.selectedChart.indexOf('network') > -1) {
        schema.chartType = 'network';
        var _view = options.selectedChart.split('-');
        chart.chartType = 'network';
        chart.overlayType = _view[1];
        chart.legend = true;
        chart.scaleRadius = true;
    }
    schema.charts = [];
    schema.charts.push(chart);
    if (options.subTitle) schema.namePlate.secondaryTitleText = options.subTitle;
    else {
        schema.namePlate.secondaryTitleText = '';
        schema.namePlate.tertiaryTitleText = null;
    }
    schema.sourcePlate.sourceTitle = 'promo';
    schema.sourcePlate.sourceColor = '#041E42';
    schema.sourcePlate.siteTitle = options.chartName.toUpperCase();
    schema.sourcePlate.siteColor = '#3a9098';
    schema.venueId = options.venueId || 7;
    schema.namePlate.primaryTitleText = player.playerName;
    schema.namePlate.photoId = player.playerId;
    schema.namePlate.teamLogoId = options.teamLogoId || 'primary';
    schema.shape = options.shape || 'square';
    if (window.innerWidth <= 1080 && schema.shape === 'square') {
        var shapeRatio = window.innerWidth * 0.93 / 500;
        schema.shapeRatio = shapeRatio;
    } else if (window.innerWidth <= 1080 && schema.shape === 'twitter') {
        var _shapeRatio = window.innerWidth * 0.75 / 500;
        schema.shapeRatio = _shapeRatio;
    } else schema.shapeRatio = 1.2;
    return schema;
}

});
parcelRegister("75Wp0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $d622d4a183fdee25$var$defaultSchema = {
    shape: 'square',
    shapeRatio: 1,
    size: 500,
    charts: [],
    namePlate: {
        show: true,
        background: 'stripes',
        backgroundColor: '#fff',
        titleFontColor: '#000',
        primaryTitleText: '',
        secondaryTitleText: '',
        secondaryFontColor: '#a9a9a9',
        tertiaryTitleText: '',
        tertiaryFontColor: '#000',
        teamLogoId: 'primary'
    },
    sourcePlate: {
        show: true,
        background: 'none',
        backgroundColor: '#fff',
        siteTitle: 'SAVANT',
        siteColor: '#32858d',
        sourceTitle: 'SOURCE: MLB.COM',
        sourceColor: '#000'
    },
    mainPanelBackground: 'none',
    venueId: 7,
    enableZoom: false
};
var $d622d4a183fdee25$var$_default = module.exports["default"] = $d622d4a183fdee25$var$defaultSchema;

});

parcelRegister("1O5Th", function(module, exports) {

var $hDz4f = parcelRequire("hDz4f");
/** Used to compose bitmasks for cloning. */ var $150f07afbd53aecf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $150f07afbd53aecf$var$clone(value) {
    return $hDz4f(value, $150f07afbd53aecf$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $150f07afbd53aecf$var$clone;

});
parcelRegister("hDz4f", function(module, exports) {

var $1xZOv = parcelRequire("1xZOv");

var $hU0Pf = parcelRequire("hU0Pf");

var $l3R3f = parcelRequire("l3R3f");

var $iX6wA = parcelRequire("iX6wA");

var $js0so = parcelRequire("js0so");

var $8QVMG = parcelRequire("8QVMG");

var $94RvR = parcelRequire("94RvR");

var $9LwJm = parcelRequire("9LwJm");

var $hU6zB = parcelRequire("hU6zB");

var $eyYJk = parcelRequire("eyYJk");

var $6WsyT = parcelRequire("6WsyT");

var $HAWwk = parcelRequire("HAWwk");

var $gq4pH = parcelRequire("gq4pH");

var $6wrG8 = parcelRequire("6wrG8");

var $lzTrK = parcelRequire("lzTrK");

var $fOEh0 = parcelRequire("fOEh0");

var $fLGD4 = parcelRequire("fLGD4");

var $4Kmdz = parcelRequire("4Kmdz");

var $e3UGS = parcelRequire("e3UGS");

var $7dnjU = parcelRequire("7dnjU");

var $2XAnP = parcelRequire("2XAnP");

var $jhaFO = parcelRequire("jhaFO");
/** Used to compose bitmasks for cloning. */ var $cd7147e1ec7c8d2c$var$CLONE_DEEP_FLAG = 1, $cd7147e1ec7c8d2c$var$CLONE_FLAT_FLAG = 2, $cd7147e1ec7c8d2c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cd7147e1ec7c8d2c$var$argsTag = '[object Arguments]', $cd7147e1ec7c8d2c$var$arrayTag = '[object Array]', $cd7147e1ec7c8d2c$var$boolTag = '[object Boolean]', $cd7147e1ec7c8d2c$var$dateTag = '[object Date]', $cd7147e1ec7c8d2c$var$errorTag = '[object Error]', $cd7147e1ec7c8d2c$var$funcTag = '[object Function]', $cd7147e1ec7c8d2c$var$genTag = '[object GeneratorFunction]', $cd7147e1ec7c8d2c$var$mapTag = '[object Map]', $cd7147e1ec7c8d2c$var$numberTag = '[object Number]', $cd7147e1ec7c8d2c$var$objectTag = '[object Object]', $cd7147e1ec7c8d2c$var$regexpTag = '[object RegExp]', $cd7147e1ec7c8d2c$var$setTag = '[object Set]', $cd7147e1ec7c8d2c$var$stringTag = '[object String]', $cd7147e1ec7c8d2c$var$symbolTag = '[object Symbol]', $cd7147e1ec7c8d2c$var$weakMapTag = '[object WeakMap]';
var $cd7147e1ec7c8d2c$var$arrayBufferTag = '[object ArrayBuffer]', $cd7147e1ec7c8d2c$var$dataViewTag = '[object DataView]', $cd7147e1ec7c8d2c$var$float32Tag = '[object Float32Array]', $cd7147e1ec7c8d2c$var$float64Tag = '[object Float64Array]', $cd7147e1ec7c8d2c$var$int8Tag = '[object Int8Array]', $cd7147e1ec7c8d2c$var$int16Tag = '[object Int16Array]', $cd7147e1ec7c8d2c$var$int32Tag = '[object Int32Array]', $cd7147e1ec7c8d2c$var$uint8Tag = '[object Uint8Array]', $cd7147e1ec7c8d2c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cd7147e1ec7c8d2c$var$uint16Tag = '[object Uint16Array]', $cd7147e1ec7c8d2c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cd7147e1ec7c8d2c$var$cloneableTags = {};
$cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$argsTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$arrayTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$arrayBufferTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$dataViewTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$boolTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$dateTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$float32Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$float64Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$int8Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$int16Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$int32Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$mapTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$numberTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$objectTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$regexpTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$setTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$stringTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$symbolTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$uint8Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$uint8ClampedTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$uint16Tag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$uint32Tag] = true;
$cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$errorTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$funcTag] = $cd7147e1ec7c8d2c$var$cloneableTags[$cd7147e1ec7c8d2c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cd7147e1ec7c8d2c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cd7147e1ec7c8d2c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cd7147e1ec7c8d2c$var$CLONE_FLAT_FLAG, isFull = bitmask & $cd7147e1ec7c8d2c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$e3UGS(value)) return value;
    var isArr = $fOEh0(value);
    if (isArr) {
        result = $gq4pH(value);
        if (!isDeep) return $94RvR(value, result);
    } else {
        var tag = $HAWwk(value), isFunc = tag == $cd7147e1ec7c8d2c$var$funcTag || tag == $cd7147e1ec7c8d2c$var$genTag;
        if ($fLGD4(value)) return $8QVMG(value, isDeep);
        if (tag == $cd7147e1ec7c8d2c$var$objectTag || tag == $cd7147e1ec7c8d2c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $lzTrK(value);
            if (!isDeep) return isFlat ? $hU6zB(value, $js0so(result, value)) : $9LwJm(value, $iX6wA(result, value));
        } else {
            if (!$cd7147e1ec7c8d2c$var$cloneableTags[tag]) return object ? value : {};
            result = $6wrG8(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1xZOv);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($7dnjU(value)) value.forEach(function(subValue) {
        result.add($cd7147e1ec7c8d2c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($4Kmdz(value)) value.forEach(function(subValue, key) {
        result.set(key, $cd7147e1ec7c8d2c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $6WsyT : $eyYJk : isFlat ? $jhaFO : $2XAnP;
    var props = isArr ? undefined : keysFunc(value);
    $hU0Pf(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $l3R3f(result, key, $cd7147e1ec7c8d2c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cd7147e1ec7c8d2c$var$baseClone;

});
parcelRegister("hU0Pf", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d0884e91061ec2c8$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $d0884e91061ec2c8$var$arrayEach;

});

parcelRegister("l3R3f", function(module, exports) {

var $FZ6LZ = parcelRequire("FZ6LZ");

var $pkV5g = parcelRequire("pkV5g");
/** Used for built-in method references. */ var $f55307aaa10e281a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f55307aaa10e281a$var$hasOwnProperty = $f55307aaa10e281a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f55307aaa10e281a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($f55307aaa10e281a$var$hasOwnProperty.call(object, key) && $pkV5g(objValue, value)) || value === undefined && !(key in object)) $FZ6LZ(object, key, value);
}
module.exports = $f55307aaa10e281a$var$assignValue;

});
parcelRegister("FZ6LZ", function(module, exports) {

var $di57Q = parcelRequire("di57Q");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $07e33b4639710b19$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $di57Q) $di57Q(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $07e33b4639710b19$var$baseAssignValue;

});


parcelRegister("iX6wA", function(module, exports) {

var $brXXW = parcelRequire("brXXW");

var $2XAnP = parcelRequire("2XAnP");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $dcc2cc590936ae32$var$baseAssign(object, source) {
    return object && $brXXW(source, $2XAnP(source), object);
}
module.exports = $dcc2cc590936ae32$var$baseAssign;

});
parcelRegister("brXXW", function(module, exports) {

var $l3R3f = parcelRequire("l3R3f");

var $FZ6LZ = parcelRequire("FZ6LZ");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $8560bb4d2d89812d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $FZ6LZ(object, key, newValue);
        else $l3R3f(object, key, newValue);
    }
    return object;
}
module.exports = $8560bb4d2d89812d$var$copyObject;

});


parcelRegister("js0so", function(module, exports) {

var $brXXW = parcelRequire("brXXW");

var $jhaFO = parcelRequire("jhaFO");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e290fc8fc7973603$var$baseAssignIn(object, source) {
    return object && $brXXW(source, $jhaFO(source), object);
}
module.exports = $e290fc8fc7973603$var$baseAssignIn;

});
parcelRegister("jhaFO", function(module, exports) {

var $5HBsj = parcelRequire("5HBsj");

var $bwHSN = parcelRequire("bwHSN");

var $iHYLr = parcelRequire("iHYLr");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e087e25f98a604b7$var$keysIn(object) {
    return $iHYLr(object) ? $5HBsj(object, true) : $bwHSN(object);
}
module.exports = $e087e25f98a604b7$var$keysIn;

});
parcelRegister("bwHSN", function(module, exports) {

var $e3UGS = parcelRequire("e3UGS");

var $ejPao = parcelRequire("ejPao");

var $eKNXz = parcelRequire("eKNXz");
/** Used for built-in method references. */ var $8644b914ca09dbdf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8644b914ca09dbdf$var$hasOwnProperty = $8644b914ca09dbdf$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8644b914ca09dbdf$var$baseKeysIn(object) {
    if (!$e3UGS(object)) return $eKNXz(object);
    var isProto = $ejPao(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8644b914ca09dbdf$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $8644b914ca09dbdf$var$baseKeysIn;

});
parcelRegister("eKNXz", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $abdc1d86583a678f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $abdc1d86583a678f$var$nativeKeysIn;

});




parcelRegister("8QVMG", function(module, exports) {

var $Cqd9Z = parcelRequire("Cqd9Z");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $Cqd9Z.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("94RvR", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $69bdff553f0dd634$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $69bdff553f0dd634$var$copyArray;

});

parcelRegister("9LwJm", function(module, exports) {

var $brXXW = parcelRequire("brXXW");

var $bRsra = parcelRequire("bRsra");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $71c1e470507a0502$var$copySymbols(source, object) {
    return $brXXW(source, $bRsra(source), object);
}
module.exports = $71c1e470507a0502$var$copySymbols;

});

parcelRegister("hU6zB", function(module, exports) {

var $brXXW = parcelRequire("brXXW");

var $eQn44 = parcelRequire("eQn44");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d08cc3eeda90fb37$var$copySymbolsIn(source, object) {
    return $brXXW(source, $eQn44(source), object);
}
module.exports = $d08cc3eeda90fb37$var$copySymbolsIn;

});
parcelRegister("eQn44", function(module, exports) {

var $3tLL3 = parcelRequire("3tLL3");

var $onQAM = parcelRequire("onQAM");

var $bRsra = parcelRequire("bRsra");

var $9j53I = parcelRequire("9j53I");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ace7d02e33925055$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ace7d02e33925055$var$getSymbolsIn = !$ace7d02e33925055$var$nativeGetSymbols ? $9j53I : function(object) {
    var result = [];
    while(object){
        $3tLL3(result, $bRsra(object));
        object = $onQAM(object);
    }
    return result;
};
module.exports = $ace7d02e33925055$var$getSymbolsIn;

});
parcelRegister("onQAM", function(module, exports) {

var $f5JoS = parcelRequire("f5JoS");
/** Built-in value references. */ var $0494bd9342610377$var$getPrototype = $f5JoS(Object.getPrototypeOf, Object);
module.exports = $0494bd9342610377$var$getPrototype;

});



parcelRegister("6WsyT", function(module, exports) {

var $iXLDj = parcelRequire("iXLDj");

var $eQn44 = parcelRequire("eQn44");

var $jhaFO = parcelRequire("jhaFO");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $50de50a03bf9e837$var$getAllKeysIn(object) {
    return $iXLDj(object, $jhaFO, $eQn44);
}
module.exports = $50de50a03bf9e837$var$getAllKeysIn;

});

parcelRegister("gq4pH", function(module, exports) {
/** Used for built-in method references. */ var $bf427f788cb108a4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bf427f788cb108a4$var$hasOwnProperty = $bf427f788cb108a4$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $bf427f788cb108a4$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $bf427f788cb108a4$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $bf427f788cb108a4$var$initCloneArray;

});

parcelRegister("6wrG8", function(module, exports) {

var $g0AZG = parcelRequire("g0AZG");

var $iq7zZ = parcelRequire("iq7zZ");

var $lX2MT = parcelRequire("lX2MT");

var $1hcFi = parcelRequire("1hcFi");

var $h6Mpw = parcelRequire("h6Mpw");
/** `Object#toString` result references. */ var $4bfb33a66374fcf8$var$boolTag = '[object Boolean]', $4bfb33a66374fcf8$var$dateTag = '[object Date]', $4bfb33a66374fcf8$var$mapTag = '[object Map]', $4bfb33a66374fcf8$var$numberTag = '[object Number]', $4bfb33a66374fcf8$var$regexpTag = '[object RegExp]', $4bfb33a66374fcf8$var$setTag = '[object Set]', $4bfb33a66374fcf8$var$stringTag = '[object String]', $4bfb33a66374fcf8$var$symbolTag = '[object Symbol]';
var $4bfb33a66374fcf8$var$arrayBufferTag = '[object ArrayBuffer]', $4bfb33a66374fcf8$var$dataViewTag = '[object DataView]', $4bfb33a66374fcf8$var$float32Tag = '[object Float32Array]', $4bfb33a66374fcf8$var$float64Tag = '[object Float64Array]', $4bfb33a66374fcf8$var$int8Tag = '[object Int8Array]', $4bfb33a66374fcf8$var$int16Tag = '[object Int16Array]', $4bfb33a66374fcf8$var$int32Tag = '[object Int32Array]', $4bfb33a66374fcf8$var$uint8Tag = '[object Uint8Array]', $4bfb33a66374fcf8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $4bfb33a66374fcf8$var$uint16Tag = '[object Uint16Array]', $4bfb33a66374fcf8$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4bfb33a66374fcf8$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $4bfb33a66374fcf8$var$arrayBufferTag:
            return $g0AZG(object);
        case $4bfb33a66374fcf8$var$boolTag:
        case $4bfb33a66374fcf8$var$dateTag:
            return new Ctor(+object);
        case $4bfb33a66374fcf8$var$dataViewTag:
            return $iq7zZ(object, isDeep);
        case $4bfb33a66374fcf8$var$float32Tag:
        case $4bfb33a66374fcf8$var$float64Tag:
        case $4bfb33a66374fcf8$var$int8Tag:
        case $4bfb33a66374fcf8$var$int16Tag:
        case $4bfb33a66374fcf8$var$int32Tag:
        case $4bfb33a66374fcf8$var$uint8Tag:
        case $4bfb33a66374fcf8$var$uint8ClampedTag:
        case $4bfb33a66374fcf8$var$uint16Tag:
        case $4bfb33a66374fcf8$var$uint32Tag:
            return $h6Mpw(object, isDeep);
        case $4bfb33a66374fcf8$var$mapTag:
            return new Ctor;
        case $4bfb33a66374fcf8$var$numberTag:
        case $4bfb33a66374fcf8$var$stringTag:
            return new Ctor(object);
        case $4bfb33a66374fcf8$var$regexpTag:
            return $lX2MT(object);
        case $4bfb33a66374fcf8$var$setTag:
            return new Ctor;
        case $4bfb33a66374fcf8$var$symbolTag:
            return $1hcFi(object);
    }
}
module.exports = $4bfb33a66374fcf8$var$initCloneByTag;

});
parcelRegister("g0AZG", function(module, exports) {

var $he00J = parcelRequire("he00J");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $ba79579f11182d51$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $he00J(result).set(new $he00J(arrayBuffer));
    return result;
}
module.exports = $ba79579f11182d51$var$cloneArrayBuffer;

});

parcelRegister("iq7zZ", function(module, exports) {

var $g0AZG = parcelRequire("g0AZG");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $d69088da02d5187b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $g0AZG(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $d69088da02d5187b$var$cloneDataView;

});

parcelRegister("lX2MT", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $ffb1453516d665bb$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $ffb1453516d665bb$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $ffb1453516d665bb$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $ffb1453516d665bb$var$cloneRegExp;

});

parcelRegister("1hcFi", function(module, exports) {

var $hIfba = parcelRequire("hIfba");
/** Used to convert symbols to primitives and strings. */ var $0ee133fa8f334166$var$symbolProto = $hIfba ? $hIfba.prototype : undefined, $0ee133fa8f334166$var$symbolValueOf = $0ee133fa8f334166$var$symbolProto ? $0ee133fa8f334166$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $0ee133fa8f334166$var$cloneSymbol(symbol) {
    return $0ee133fa8f334166$var$symbolValueOf ? Object($0ee133fa8f334166$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $0ee133fa8f334166$var$cloneSymbol;

});

parcelRegister("h6Mpw", function(module, exports) {

var $g0AZG = parcelRequire("g0AZG");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c7488c93be8d2de5$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $g0AZG(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $c7488c93be8d2de5$var$cloneTypedArray;

});


parcelRegister("lzTrK", function(module, exports) {

var $buDsK = parcelRequire("buDsK");

var $onQAM = parcelRequire("onQAM");

var $ejPao = parcelRequire("ejPao");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $fb57e05d1c656a2b$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$ejPao(object) ? $buDsK($onQAM(object)) : {};
}
module.exports = $fb57e05d1c656a2b$var$initCloneObject;

});
parcelRegister("buDsK", function(module, exports) {

var $e3UGS = parcelRequire("e3UGS");
/** Built-in value references. */ var $85e11b8723f9d129$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $85e11b8723f9d129$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$e3UGS(proto)) return {};
        if ($85e11b8723f9d129$var$objectCreate) return $85e11b8723f9d129$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $85e11b8723f9d129$var$baseCreate;

});


parcelRegister("4Kmdz", function(module, exports) {

var $9GXAw = parcelRequire("9GXAw");

var $bGjiY = parcelRequire("bGjiY");

var $bc1nU = parcelRequire("bc1nU");
/* Node.js helper references. */ var $374cb153c72cf50d$var$nodeIsMap = $bc1nU && $bc1nU.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $374cb153c72cf50d$var$isMap = $374cb153c72cf50d$var$nodeIsMap ? $bGjiY($374cb153c72cf50d$var$nodeIsMap) : $9GXAw;
module.exports = $374cb153c72cf50d$var$isMap;

});
parcelRegister("9GXAw", function(module, exports) {

var $HAWwk = parcelRequire("HAWwk");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $70e642454f6ac7cc$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $70e642454f6ac7cc$var$baseIsMap(value) {
    return $1cw4V(value) && $HAWwk(value) == $70e642454f6ac7cc$var$mapTag;
}
module.exports = $70e642454f6ac7cc$var$baseIsMap;

});


parcelRegister("7dnjU", function(module, exports) {

var $639J0 = parcelRequire("639J0");

var $bGjiY = parcelRequire("bGjiY");

var $bc1nU = parcelRequire("bc1nU");
/* Node.js helper references. */ var $540bd6316ab6a4d9$var$nodeIsSet = $bc1nU && $bc1nU.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $540bd6316ab6a4d9$var$isSet = $540bd6316ab6a4d9$var$nodeIsSet ? $bGjiY($540bd6316ab6a4d9$var$nodeIsSet) : $639J0;
module.exports = $540bd6316ab6a4d9$var$isSet;

});
parcelRegister("639J0", function(module, exports) {

var $HAWwk = parcelRequire("HAWwk");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $467a911367d026b9$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $467a911367d026b9$var$baseIsSet(value) {
    return $1cw4V(value) && $HAWwk(value) == $467a911367d026b9$var$setTag;
}
module.exports = $467a911367d026b9$var$baseIsSet;

});





parcelRegister("dl4nW", function(module, exports) {
"use strict";
function $9b60a34d8a86a332$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9b60a34d8a86a332$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b60a34d8a86a332$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9b60a34d8a86a332$var$MultiPick;

var $9b60a34d8a86a332$var$_react = $9b60a34d8a86a332$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $9b60a34d8a86a332$var$_find = $9b60a34d8a86a332$var$_interopRequireDefault((parcelRequire("clJ7m")));

var $9b60a34d8a86a332$var$_filter = $9b60a34d8a86a332$var$_interopRequireDefault((parcelRequire("jTA3B")));

var $9b60a34d8a86a332$var$_clone = $9b60a34d8a86a332$var$_interopRequireDefault((parcelRequire("1O5Th")));

var $gAVyq = parcelRequire("gAVyq");
function $9b60a34d8a86a332$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9b60a34d8a86a332$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9b60a34d8a86a332$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9b60a34d8a86a332$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9b60a34d8a86a332$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9b60a34d8a86a332$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9b60a34d8a86a332$var$_slicedToArray(r, e) {
    return $9b60a34d8a86a332$var$_arrayWithHoles(r) || $9b60a34d8a86a332$var$_iterableToArrayLimit(r, e) || $9b60a34d8a86a332$var$_unsupportedIterableToArray(r, e) || $9b60a34d8a86a332$var$_nonIterableRest();
}
function $9b60a34d8a86a332$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b60a34d8a86a332$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9b60a34d8a86a332$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9b60a34d8a86a332$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9b60a34d8a86a332$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9b60a34d8a86a332$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9b60a34d8a86a332$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable */ 
function $9b60a34d8a86a332$var$MultiPick(props) {
    var name = props.name, columns = props.columns, currentSelection = props.currentSelection, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? 1000 : _props$zIndex, updatedSelection = props.updatedSelection, showValues = props.showValues;
    var parentRef = (0, $9b60a34d8a86a332$var$_react.useRef)(null);
    var _useState = (0, $9b60a34d8a86a332$var$_react.useState)(false), _useState2 = $9b60a34d8a86a332$var$_slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var _useState3 = (0, $9b60a34d8a86a332$var$_react.useState)(0), _useState4 = $9b60a34d8a86a332$var$_slicedToArray(_useState3, 2), scrollTop = _useState4[0], setScrollTop = _useState4[1];
    (0, $9b60a34d8a86a332$var$_react.useEffect)(function() {
        if (isOpen) // Massive hack to wait until box repaints
        setTimeout(function() {
            parentRef.current.scrollTop = Number(scrollTop);
        }, 25);
    });
    var toggleIsOpen = function toggleIsOpen() {
        if (isOpen) setIsOpen(false);
        else setIsOpen(true);
    };
    var handleCheckClick = function handleCheckClick(value) {
        var tempValues = (0, $9b60a34d8a86a332$var$_clone["default"])(currentSelection);
        var findValue = (0, $9b60a34d8a86a332$var$_find["default"])(tempValues, function(d) {
            if (value.value) return String(value.value) === String(d);
            return String(value) === String(d);
        });
        if (findValue) {
            tempValues = (0, $9b60a34d8a86a332$var$_filter["default"])(tempValues, function(d) {
                if (value.value) return String(value.value) !== String(d);
                return String(d) !== String(value);
            });
            updatedSelection(tempValues);
        } else {
            tempValues.push(value.value ? value.value : value);
            updatedSelection(tempValues);
        }
        if (scrollTop != parentRef.current.scrollTop) setScrollTop(parentRef.current.scrollTop);
    };
    var id = (0, $gAVyq.v4)();
    return /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("div", {
        key: "parent_".concat(id),
        className: "dropdown",
        onClick: function onClick(event) {
            toggleIsOpen();
        }
    }, /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("span", {
        key: "span_".concat(id),
        className: "ddl-label",
        style: {
            color: currentSelection.length > 0 ? '#ef4c29' : '#666'
        }
    }, showValues ? currentSelection.length > 0 ? "".concat(name, " (").concat(currentSelection.length == 1 ? currentSelection[0] : "".concat(currentSelection[0], " + ").concat(currentSelection.length - 1), ")") : "".concat(name) : currentSelection.length > 0 ? "".concat(name, " (").concat(currentSelection.length, ")") : "".concat(name)), /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("div", {
        key: "".concat(id, "_mp_div"),
        className: "dropdown-arrow"
    }, "\u25BE"), isOpen && columns ? /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("div", {
        ref: parentRef,
        key: "".concat(id, "_mp_div_child"),
        className: "multipick",
        style: {
            zIndex: zIndex
        }
    }, columns.map(function(column, key) {
        var isChecked = (0, $9b60a34d8a86a332$var$_find["default"])(currentSelection, function(value) {
            if (column.value) return value === column.value;
            return String(value) === String(column);
        });
        return /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("div", {
            key: "div_".concat(id, "_").concat(key),
            onClick: function onClick(event) {
                event.stopPropagation();
                event.preventDefault();
                handleCheckClick(column);
            }
        }, /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("input", {
            type: "checkbox",
            key: "input_".concat(id, "_").concat(key),
            name: column.value ? column.value : column,
            value: column.value ? column.value : column,
            checked: isChecked,
            onChange: function onChange(event) {
                event.stopPropagation();
                event.preventDefault();
                setScrollTop(parentRef.current.scrollTop);
                handleCheckClick(column);
            }
        }), "\xA0", /*#__PURE__*/ $9b60a34d8a86a332$var$_react["default"].createElement("label", {
            key: "label_".concat(id, "_").concat(key)
        }, column.name ? column.name : column));
    })) : null);
}

});
parcelRegister("gAVyq", function(module, exports) {

var $1bNys = parcelRequire("1bNys");

var $2kjTJ = parcelRequire("2kjTJ");
var $c14ca7352229ae64$var$uuid = $2kjTJ;
$c14ca7352229ae64$var$uuid.v1 = $1bNys;
$c14ca7352229ae64$var$uuid.v4 = $2kjTJ;
module.exports = $c14ca7352229ae64$var$uuid;

});
parcelRegister("1bNys", function(module, exports) {

var $g8vFT = parcelRequire("g8vFT");

var $lMIO2 = parcelRequire("lMIO2");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $0ddd4211a680a7f2$var$_nodeId;
var $0ddd4211a680a7f2$var$_clockseq;
// Previous uuid creation time
var $0ddd4211a680a7f2$var$_lastMSecs = 0;
var $0ddd4211a680a7f2$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $0ddd4211a680a7f2$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $0ddd4211a680a7f2$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $0ddd4211a680a7f2$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $g8vFT();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $0ddd4211a680a7f2$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $0ddd4211a680a7f2$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $0ddd4211a680a7f2$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $0ddd4211a680a7f2$var$_lastMSecs + (nsecs - $0ddd4211a680a7f2$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $0ddd4211a680a7f2$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $0ddd4211a680a7f2$var$_lastMSecs = msecs;
    $0ddd4211a680a7f2$var$_lastNSecs = nsecs;
    $0ddd4211a680a7f2$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lMIO2(b);
}
module.exports = $0ddd4211a680a7f2$var$v1;

});
parcelRegister("g8vFT", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $bbf5f69b8437e4fa$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($bbf5f69b8437e4fa$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $bbf5f69b8437e4fa$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $bbf5f69b8437e4fa$var$getRandomValues($bbf5f69b8437e4fa$var$rnds8);
        return $bbf5f69b8437e4fa$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $bbf5f69b8437e4fa$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $bbf5f69b8437e4fa$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $bbf5f69b8437e4fa$var$rnds;
    };
}

});

parcelRegister("lMIO2", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $fdc0d632ee18e744$var$byteToHex = [];
for(var $fdc0d632ee18e744$var$i = 0; $fdc0d632ee18e744$var$i < 256; ++$fdc0d632ee18e744$var$i)$fdc0d632ee18e744$var$byteToHex[$fdc0d632ee18e744$var$i] = ($fdc0d632ee18e744$var$i + 0x100).toString(16).substr(1);
function $fdc0d632ee18e744$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $fdc0d632ee18e744$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $fdc0d632ee18e744$var$bytesToUuid;

});


parcelRegister("2kjTJ", function(module, exports) {

var $g8vFT = parcelRequire("g8vFT");

var $lMIO2 = parcelRequire("lMIO2");
function $1b1ce25054613298$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $g8vFT)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lMIO2(rnds);
}
module.exports = $1b1ce25054613298$var$v4;

});



parcelRegister("kylyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scaleOptions = void 0;
// eslint-disable-next-line import/prefer-default-export
var $83d808143290a8dd$var$scaleOptions = module.exports.scaleOptions = [
    {
        label: 'Adjusted for Batter Zone',
        value: 'normalized'
    },
    {
        label: 'Actual Pitch Height',
        value: 'actual'
    }
];

});

parcelRegister("8Qt6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6709c26d2debe96b$var$App;

var $6709c26d2debe96b$var$_react = $6709c26d2debe96b$var$_interopRequireDefault((parcelRequire("J42oT")));

var $6709c26d2debe96b$var$_Visual = $6709c26d2debe96b$var$_interopRequireDefault((parcelRequire("9udcu")));

var $6709c26d2debe96b$var$_SavantModel = $6709c26d2debe96b$var$_interopRequireDefault((parcelRequire("6Xpvk")));

var $6709c26d2debe96b$var$_Schema = $6709c26d2debe96b$var$_interopRequireDefault((parcelRequire("394kY")));
function $6709c26d2debe96b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable import/no-extraneous-dependencies, react/prop-types */ function $6709c26d2debe96b$var$App(_ref) {
    var data = _ref.data, player = _ref.player, options = _ref.options;
    var schema = (0, $6709c26d2debe96b$var$_Schema["default"])(data, player, options);
    schema.showToolTip = true;
    return /*#__PURE__*/ $6709c26d2debe96b$var$_react["default"].createElement($6709c26d2debe96b$var$_Visual["default"], {
        data: (0, $6709c26d2debe96b$var$_SavantModel["default"])(schema, data),
        chart: schema
    });
}

});
parcelRegister("9udcu", function(module, exports) {
"use strict";
function $6e8127b8a1edc099$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e8127b8a1edc099$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e8127b8a1edc099$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6e8127b8a1edc099$var$Visual;

var $6e8127b8a1edc099$var$_react = $6e8127b8a1edc099$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $6e8127b8a1edc099$var$_uniqueId = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("1CEkx")));

var $3wgDt = parcelRequire("3wgDt");

var $6e8127b8a1edc099$var$_Settings = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("6UN3I")));

var $6e8127b8a1edc099$var$_NamePlate = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("hRpC3")));

var $6e8127b8a1edc099$var$_Border = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("bRQDe")));

var $6e8127b8a1edc099$var$_Stripes = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("1p1Zk")));

var $6e8127b8a1edc099$var$_DoubleStripes = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("6RScG")));

var $6e8127b8a1edc099$var$_Textures = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("jemXX")));

var $6e8127b8a1edc099$var$_FuzzFilter = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("9qs11")));

var $6e8127b8a1edc099$var$_SourcePlate = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("d8FBT")));

var $6e8127b8a1edc099$var$_Chart = $6e8127b8a1edc099$var$_interopRequireDefault((parcelRequire("bs2qR")));

function $6e8127b8a1edc099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $6e8127b8a1edc099$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6e8127b8a1edc099$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6e8127b8a1edc099$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6e8127b8a1edc099$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6e8127b8a1edc099$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6e8127b8a1edc099$var$_slicedToArray(r, e) {
    return $6e8127b8a1edc099$var$_arrayWithHoles(r) || $6e8127b8a1edc099$var$_iterableToArrayLimit(r, e) || $6e8127b8a1edc099$var$_unsupportedIterableToArray(r, e) || $6e8127b8a1edc099$var$_nonIterableRest();
}
function $6e8127b8a1edc099$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e8127b8a1edc099$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6e8127b8a1edc099$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6e8127b8a1edc099$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6e8127b8a1edc099$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6e8127b8a1edc099$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6e8127b8a1edc099$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/no-array-index-key */  /* eslint-disable react/prop-types */  // VISUAL COMPONENT HELPERS
function $6e8127b8a1edc099$var$getTranslate(localPoint, newZoom) {
    return {
        x: -localPoint.x * (newZoom - 1),
        y: -localPoint.y * (newZoom - 1)
    };
}
var $6e8127b8a1edc099$var$chartDefaults = {
    shape: 'snap',
    shapeRatio: 1,
    charts: [],
    namePlate: {
        show: true,
        background: 'stripes',
        backgroundColor: '#fff',
        titleFontColor: '#000',
        primaryTitleText: '',
        secondaryTitleText: '',
        secondaryFontColor: '#a9a9a9',
        tertiaryTitleText: '',
        tertiaryFontColor: '#000'
    },
    sourcePlate: {
        show: true,
        background: 'none',
        backgroundColor: '#c2c2c2',
        siteTitle: 'SAVANT',
        siteColor: '#32858d',
        sourceTitle: 'SOURCE: MLB.COM',
        sourceColor: '#000'
    },
    venueId: '7',
    mainPanelBackground: 'none',
    showToolTip: false,
    embedStyle: {},
    pitcherPerspective: false
};
function $6e8127b8a1edc099$var$VisualContent(_ref) {
    var data = _ref.data, chart = _ref.chart;
    var initialZoom = 1;
    var _useZoom = (0, $3wgDt.useZoom)(), zoom = _useZoom.zoom, translate = _useZoom.translate, setZoom = _useZoom.setZoom;
    var zoomRef = (0, $6e8127b8a1edc099$var$_react.useRef)(null);
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    function handleResetZoom(e) {
        e.stopPropagation();
        var centerish = new DOMPoint(250, 250);
        setZoom(initialZoom, $6e8127b8a1edc099$var$getTranslate(centerish, initialZoom));
    }
    // function handleRightMouseClick(e) {
    //     // Probably bad
    //     e.preventDefault()
    //     // New API for me, thanks AI
    //     const point = new DOMPoint(e.clientX, e.clientY)
    //     const globalToLocalMatrix = zoomRef.current.getScreenCTM().inverse()
    //     const localPoint = point.matrixTransform(globalToLocalMatrix)
    //     const newZoom = Math.max(Math.min(15, zoom / 1.5), initialZoom)
    //     const newTranslate = getTranslate(localPoint, newZoom)
    //     setZoom(newZoom, newTranslate)
    // }
    // Settings JSON
    // Powers the entire visualization
    var settings = (0, $6e8127b8a1edc099$var$_Settings["default"])(data, chart);
    var handlePitchClick = (0, $6e8127b8a1edc099$var$_react.useCallback)(function(e) {
        // TODO: use a chart option to enable/disable zoom
        if (!settings.enableZoom) return;
        // New API for me, thanks AI
        var point = new DOMPoint(e.clientX, e.clientY);
        var globalToLocalMatrix = zoomRef.current.getScreenCTM().inverse();
        var localPoint = point.matrixTransform(globalToLocalMatrix);
        // Make the first step relatively big, then meander in for a bit until 15x
        var newZoom = Math.max(Math.min(50, zoom * 5), initialZoom);
        var newTranslate = $6e8127b8a1edc099$var$getTranslate(localPoint, newZoom);
        setZoom(newZoom, newTranslate);
    }, [
        zoom,
        settings
    ]);
    var _useState = (0, $6e8127b8a1edc099$var$_react.useState)((0, $6e8127b8a1edc099$var$_uniqueId["default"])('svg-')), _useState2 = $6e8127b8a1edc099$var$_slicedToArray(_useState, 1), id = _useState2[0];
    return /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("svg", {
        key: "svg_source",
        id: id,
        width: settings.ratioWidth,
        height: settings.ratioHeight,
        viewBox: "0 0 ".concat(settings.svgWidth, " ").concat(settings.svgHeight)
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("defs", {
        key: "defs"
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_Stripes["default"], null), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_DoubleStripes["default"], null), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_Textures["default"], null), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_FuzzFilter["default"], null), chart.embedStyle ? /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: chart.embedStyle
        }
    }) : null), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_Border["default"], {
        key: "border",
        settings: settings
    }), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("g", {
        className: "evp-zoom-wrapper",
        ref: zoomRef,
        transform: "translate(".concat(translate.x, ", ").concat(translate.y, ") scale(").concat(zoom, ")")
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("g", {
        key: "gHolder",
        transform: "scale(".concat(settings.vizScaleOverride || settings.vizScale, ") translate(").concat(settings.vizPadding.left, ",").concat(settings.vizPadding.top, ")")
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("rect", {
        key: "rect-background",
        width: settings.vizWidth,
        height: settings.vizHeight,
        fill: "none",
        stroke: "none"
    }), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("g", {
        key: "rect-transform",
        transform: settings.svgZoom || null
    }, settings.charts.map(function(c, i) {
        return /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_Chart["default"], {
            key: "chart-".concat(i),
            chartIndex: i,
            settings: settings,
            onPitchClick: handlePitchClick
        });
    })), /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("g", {
        key: "tooltip",
        ref: tooltipRef,
        style: {
            display: chart.showToolTip ? 'block' : 'none'
        }
    }))), zoom !== initialZoom && /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("g", {
        transform: "translate(10, 120)"
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement("text", {
        fontSize: "20",
        onClick: handleResetZoom
    }, "Reset Zoom")), chart.namePlate.show ? /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_NamePlate["default"], {
        settings: settings
    }) : null, chart.sourcePlate.show ? /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$_SourcePlate["default"], {
        settings: settings
    }) : null);
}
function $6e8127b8a1edc099$var$Visual(_ref2) {
    var _ref2$data = _ref2.data, data = _ref2$data === void 0 ? [] : _ref2$data, _ref2$chart = _ref2.chart, chart = _ref2$chart === void 0 ? $6e8127b8a1edc099$var$chartDefaults : _ref2$chart;
    var settings = (0, $6e8127b8a1edc099$var$_react.useMemo)(function() {
        return (0, $6e8127b8a1edc099$var$_Settings["default"])(data, chart);
    }, [
        data,
        chart
    ]);
    return /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($3wgDt.ChartProvider, {
        initialSettings: settings
    }, /*#__PURE__*/ $6e8127b8a1edc099$var$_react["default"].createElement($6e8127b8a1edc099$var$VisualContent, {
        data: data,
        chart: chart,
        settings: settings
    }));
}

});
parcelRegister("1CEkx", function(module, exports) {

var $9GATr = parcelRequire("9GATr");
/** Used to generate unique IDs. */ var $12e89fc7e3cc7c82$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $12e89fc7e3cc7c82$var$uniqueId(prefix) {
    var id = ++$12e89fc7e3cc7c82$var$idCounter;
    return $9GATr(prefix) + id;
}
module.exports = $12e89fc7e3cc7c82$var$uniqueId;

});

parcelRegister("3wgDt", function(module, exports) {
"use strict";
function $e059bee99257817c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e059bee99257817c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e059bee99257817c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartIndexProvider = $e059bee99257817c$var$ChartIndexProvider;
module.exports.ChartProvider = $e059bee99257817c$var$ChartProvider;
module.exports.useChart = $e059bee99257817c$var$useChart;
module.exports.useChartOptions = $e059bee99257817c$var$useChartOptions;
module.exports.useLocationAccurate_TODOFIX = $e059bee99257817c$var$useLocationAccurate_TODOFIX;
module.exports.usePixelPositions = $e059bee99257817c$var$usePixelPositions;
module.exports.useScales = $e059bee99257817c$var$useScales;
module.exports.useShouldShowNormalized = $e059bee99257817c$var$useShouldShowNormalized;
module.exports.useStrikeZoneDims = $e059bee99257817c$var$useStrikeZoneDims;
module.exports.useStrikeZonePositions = $e059bee99257817c$var$useStrikeZonePositions;
module.exports.useStrikeZoneType = $e059bee99257817c$var$useStrikeZoneType;
module.exports.useTooltip = $e059bee99257817c$var$useTooltip;
module.exports.useZoom = $e059bee99257817c$var$useZoom;

var $e059bee99257817c$var$_react = $e059bee99257817c$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $5kS6g = parcelRequire("5kS6g");

var $e059bee99257817c$var$_getScales = $e059bee99257817c$var$_interopRequireDefault((parcelRequire("dDZ3L")));

var $e059bee99257817c$var$_shouldShowNormalized = $e059bee99257817c$var$_interopRequireDefault((parcelRequire("lbfwa")));

var $42dow = parcelRequire("42dow");

var $e059bee99257817c$var$_getStrikeZoneDims = $e059bee99257817c$var$_interopRequireDefault((parcelRequire("15SjV")));

var $e059bee99257817c$var$_getStrikeZoneType = $e059bee99257817c$var$_interopRequireDefault((parcelRequire("4CtDJ")));
function $e059bee99257817c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $e059bee99257817c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e059bee99257817c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e059bee99257817c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e059bee99257817c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e059bee99257817c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e059bee99257817c$var$_slicedToArray(r, e) {
    return $e059bee99257817c$var$_arrayWithHoles(r) || $e059bee99257817c$var$_iterableToArrayLimit(r, e) || $e059bee99257817c$var$_unsupportedIterableToArray(r, e) || $e059bee99257817c$var$_nonIterableRest();
}
function $e059bee99257817c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e059bee99257817c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e059bee99257817c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e059bee99257817c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e059bee99257817c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e059bee99257817c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e059bee99257817c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e059bee99257817c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e059bee99257817c$var$_defineProperty(e, r, t) {
    return (r = $e059bee99257817c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e059bee99257817c$var$_toPropertyKey(t) {
    var i = $e059bee99257817c$var$_toPrimitive(t, "string");
    return "symbol" == $e059bee99257817c$var$_typeof(i) ? i : i + "";
}
function $e059bee99257817c$var$_toPrimitive(t, r) {
    if ("object" != $e059bee99257817c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e059bee99257817c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e059bee99257817c$var$_toConsumableArray(r) {
    return $e059bee99257817c$var$_arrayWithoutHoles(r) || $e059bee99257817c$var$_iterableToArray(r) || $e059bee99257817c$var$_unsupportedIterableToArray(r) || $e059bee99257817c$var$_nonIterableSpread();
}
function $e059bee99257817c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e059bee99257817c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e059bee99257817c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e059bee99257817c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e059bee99257817c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e059bee99257817c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e059bee99257817c$var$_arrayLikeToArray(r);
}
function $e059bee99257817c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e059bee99257817c$var$ChartContext = /*#__PURE__*/ (0, $e059bee99257817c$var$_react.createContext)(undefined);
function $e059bee99257817c$var$chartReducer(state, action) {
    switch(action.type){
        case 'UPDATE_CHART_OPTION':
            var newOptions = $e059bee99257817c$var$_toConsumableArray(state.chartOptions);
            newOptions[action.index] = $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, newOptions[action.index]), action.updates);
            return $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, state), {}, {
                chartOptions: newOptions
            });
        case 'CYCLE_STRIKE_ZONE':
            var noPersonal = $5kS6g.strikeZoneTypes.filter(function(d) {
                return d !== 'personal';
            });
            var types = action.canBePersonal ? $5kS6g.strikeZoneTypes : noPersonal;
            var _newOptions = $e059bee99257817c$var$_toConsumableArray(state.chartOptions);
            var current = _newOptions[action.index].strikeZone || 'generic';
            var idx = types.findIndex(function(d) {
                return d === current;
            });
            var newIdx = (idx + 1) % types.length;
            _newOptions[action.index] = $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, _newOptions[action.index]), {}, {
                strikeZone: types[newIdx]
            });
            return $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, state), {}, {
                chartOptions: _newOptions
            });
        case 'SET_ZOOM':
            return $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, state), {}, {
                zoom: action.zoom,
                translate: action.translate
            });
        case 'RESET_CHART_SETTINGS':
            return $e059bee99257817c$var$_objectSpread($e059bee99257817c$var$_objectSpread({}, state), {}, {
                settings: action.settings,
                chartOptions: action.settings.charts
            });
        default:
            return state;
    }
}
function $e059bee99257817c$var$ChartProvider(_ref) {
    var children = _ref.children, initialSettings = _ref.initialSettings;
    var tooltipRef = (0, $e059bee99257817c$var$_react.useRef)(null);
    var _useReducer = (0, $e059bee99257817c$var$_react.useReducer)($e059bee99257817c$var$chartReducer, {
        chartOptions: initialSettings.charts,
        settings: initialSettings,
        zoom: 1,
        translate: {
            x: 0,
            y: 0
        }
    }), _useReducer2 = $e059bee99257817c$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var prevSettings = (0, $e059bee99257817c$var$_react.useRef)(initialSettings);
    (0, $e059bee99257817c$var$_react.useEffect)(function() {
        var isDifferent = JSON.stringify(prevSettings.current) !== JSON.stringify(initialSettings);
        if (isDifferent) {
            dispatch({
                type: 'RESET_CHART_SETTINGS',
                settings: initialSettings
            });
            prevSettings.current = initialSettings;
        }
    }, [
        initialSettings
    ]);
    var value = (0, $e059bee99257817c$var$_react.useMemo)(function() {
        return {
            state: state,
            dispatch: dispatch,
            tooltipRef: tooltipRef
        };
    }, [
        state,
        tooltipRef
    ]);
    return /*#__PURE__*/ $e059bee99257817c$var$_react["default"].createElement($e059bee99257817c$var$ChartContext.Provider, {
        value: value
    }, children);
}
function $e059bee99257817c$var$useChart() {
    var context = (0, $e059bee99257817c$var$_react.useContext)($e059bee99257817c$var$ChartContext);
    if (!context) throw new Error('useChart must be used within ChartProvider');
    return context;
}
// Convenience hooks
function $e059bee99257817c$var$useChartOptions(indexOverride) {
    var contextIndex = $e059bee99257817c$var$useChartIndex();
    var index = indexOverride !== null && indexOverride !== void 0 ? indexOverride : contextIndex;
    if (index === undefined) throw new Error('useChartOptions should be used within ChartIndexProvider');
    var _useChart = $e059bee99257817c$var$useChart(), state = _useChart.state, dispatch = _useChart.dispatch;
    var chartOptions = state.chartOptions[index];
    var updateChartOptions = function updateChartOptions(updates) {
        dispatch({
            type: 'UPDATE_CHART_OPTION',
            index: index,
            updates: updates
        });
    };
    var cycleStrikeZone = function cycleStrikeZone(canBePersonal) {
        dispatch({
            type: 'CYCLE_STRIKE_ZONE',
            index: index,
            canBePersonal: canBePersonal
        });
    };
    return {
        chartOptions: chartOptions,
        updateChartOptions: updateChartOptions,
        cycleStrikeZone: cycleStrikeZone,
        settings: state.settings
    };
}
function $e059bee99257817c$var$useZoom() {
    var _useChart2 = $e059bee99257817c$var$useChart(), state = _useChart2.state, dispatch = _useChart2.dispatch;
    return {
        zoom: state.zoom,
        translate: state.translate,
        setZoom: function setZoom(zoom, translate) {
            return dispatch({
                type: 'SET_ZOOM',
                zoom: zoom,
                translate: translate
            });
        }
    };
}
function $e059bee99257817c$var$useTooltip() {
    var _useChart3 = $e059bee99257817c$var$useChart(), tooltipRef = _useChart3.tooltipRef;
    return {
        tooltipRef: tooltipRef
    };
}
function $e059bee99257817c$var$useScales() {
    var _useChartOptions = $e059bee99257817c$var$useChartOptions(), chartOptions = _useChartOptions.chartOptions, settings = _useChartOptions.settings;
    return (0, $e059bee99257817c$var$_getScales["default"])(settings, chartOptions);
}
function $e059bee99257817c$var$useStrikeZoneDims(optionalData) {
    var _useChartOptions2 = $e059bee99257817c$var$useChartOptions(), settings = _useChartOptions2.settings;
    var data = optionalData || settings.data;
    return (0, $e059bee99257817c$var$_getStrikeZoneDims["default"])('average', data);
}
function $e059bee99257817c$var$useShouldShowNormalized() {
    var _useChartOptions3 = $e059bee99257817c$var$useChartOptions(), chartOptions = _useChartOptions3.chartOptions;
    return (0, $e059bee99257817c$var$_shouldShowNormalized["default"])(chartOptions, 'average');
}
// I'm not happy with the fuzz yet, so ditching it for now.
var $e059bee99257817c$var$hideFuzzy = true;
// Check if the scale is "actual" but the strike zone is not personal
// This would trigger "fuzzy" renderings
function $e059bee99257817c$var$useLocationAccurate_TODOFIX() {
    var showNormalized = $e059bee99257817c$var$useShouldShowNormalized();
    var isPersonal = $e059bee99257817c$var$useStrikeZoneType() === 'personal';
    return !$e059bee99257817c$var$hideFuzzy && !isPersonal && !showNormalized;
}
function $e059bee99257817c$var$useStrikeZoneType() {
    var _useChartOptions4 = $e059bee99257817c$var$useChartOptions(), chartOptions = _useChartOptions4.chartOptions, settings = _useChartOptions4.settings;
    return (0, $e059bee99257817c$var$_getStrikeZoneType["default"])(chartOptions, settings.data);
}
// Use to get the normalized feet. Doesn't pass to scales
function $e059bee99257817c$var$useStrikeZonePositions(optionalData) {
    var _useChartOptions5 = $e059bee99257817c$var$useChartOptions(), settings = _useChartOptions5.settings;
    var data = optionalData || settings.data;
    var strikeZoneDims = $e059bee99257817c$var$useStrikeZoneDims(data);
    var showNormalized = $e059bee99257817c$var$useShouldShowNormalized();
    return data.map(function(pitch) {
        if (pitch.x === null || pitch.y === null) {
            // throw??
            console.error('no value found');
            return {
                x: 0,
                z: 0
            };
        }
        return showNormalized ? (0, $42dow.dynamicNormalizationFeet)(strikeZoneDims, pitch) : {
            x: pitch.x,
            z: pitch.y
        };
    });
}
function $e059bee99257817c$var$usePixelPositions(optionalData) {
    var _useScales = $e059bee99257817c$var$useScales(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var _useChartOptions6 = $e059bee99257817c$var$useChartOptions(), settings = _useChartOptions6.settings;
    var data = optionalData || settings.data;
    var zonePositions = $e059bee99257817c$var$useStrikeZonePositions(data);
    return zonePositions.map(function(pos) {
        return {
            x: xScale(pos.x),
            y: yScale(pos.z)
        };
    });
}
// Chart Index
var $e059bee99257817c$var$ChartIndexContext = /*#__PURE__*/ (0, $e059bee99257817c$var$_react.createContext)(undefined);
function $e059bee99257817c$var$ChartIndexProvider(_ref2) {
    var children = _ref2.children, index = _ref2.index;
    return /*#__PURE__*/ $e059bee99257817c$var$_react["default"].createElement($e059bee99257817c$var$ChartIndexContext.Provider, {
        value: index
    }, children);
}
function $e059bee99257817c$var$useChartIndex() {
    var index = (0, $e059bee99257817c$var$_react.useContext)($e059bee99257817c$var$ChartIndexContext);
    if (index === undefined) throw new Error('useChartIndex must be used within ChartIndexProvider');
    return index;
}

});
parcelRegister("dDZ3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e4f7675649d19c40$var$getScales;
parcelRequire("jEBA8");
var $l0gqL = parcelRequire("l0gqL");
function $e4f7675649d19c40$var$getScales(settings, chartOptions) {
    var vizWidth = settings.vizWidth, vizHeight = settings.vizHeight;
    var pitcherView = chartOptions.pitcherView;
    var xyRatio = vizWidth / vizHeight;
    var xDomainAbs = 3.75;
    var xDomain = pitcherView ? [
        xDomainAbs,
        -xDomainAbs
    ] : [
        -xDomainAbs,
        xDomainAbs
    ];
    // const yDomain = strikeZone === 'relative' ? [-4, 4] : [-1, 7]
    var yDomain = [
        -1,
        6.5
    ];
    var scaledWidth = Math.abs(xDomain[1] - xDomain[0]);
    var scaledHeight = Math.abs(yDomain[1] - yDomain[0]);
    var scaledRatio = scaledWidth / scaledHeight;
    if (scaledRatio > xyRatio) {
        var newHeight = scaledWidth / xyRatio;
        var nudge = (newHeight - scaledHeight) / 2;
        yDomain[0] -= nudge;
        yDomain[1] += nudge;
    } else if (scaledRatio < xyRatio) {
        var newWidth = scaledHeight / xyRatio;
        var _nudge = (newWidth - scaledWidth) / 2;
        xDomain[0] -= _nudge;
        xDomain[1] += _nudge;
    }
    if (chartOptions.pitcherPerspective) {
        var xMin = xDomain[0], xMax = xDomain[1];
        xDomain[0] = xMax;
        xDomain[1] = xMin;
    }
    // These scales should have the same pixel to ft ratio
    var xScale = (0, $l0gqL.default)().range([
        0,
        vizWidth
    ]).domain(xDomain);
    var yScale = (0, $l0gqL.default)().range([
        vizHeight,
        0
    ]).domain(yDomain);
    return {
        xScale: xScale,
        yScale: yScale
    };
}

});
parcelRegister("jEBA8", function(module, exports) {

$parcel$export(module.exports, "version", () => (parcelRequire("jRxTS")).version);

var $jRxTS = parcelRequire("jRxTS");

var $4Plq2 = parcelRequire("4Plq2");

var $6gWbe = parcelRequire("6gWbe");

var $4ckZY = parcelRequire("4ckZY");

var $4s7WH = parcelRequire("4s7WH");

var $gz1Te = parcelRequire("gz1Te");

var $6xhCH = parcelRequire("6xhCH");

var $5kU6m = parcelRequire("5kU6m");

var $6Yrra = parcelRequire("6Yrra");

var $kaKTm = parcelRequire("kaKTm");

var $8KyJ5 = parcelRequire("8KyJ5");

var $3XlZC = parcelRequire("3XlZC");

var $bwHK4 = parcelRequire("bwHK4");

var $kxMuV = parcelRequire("kxMuV");

var $dgorV = parcelRequire("dgorV");

var $cUtk9 = parcelRequire("cUtk9");

var $2FHGO = parcelRequire("2FHGO");

var $7FapI = parcelRequire("7FapI");

var $hv0Wi = parcelRequire("hv0Wi");

var $8V7nn = parcelRequire("8V7nn");

var $h1Vgw = parcelRequire("h1Vgw");

var $aZAXJ = parcelRequire("aZAXJ");

var $eTC2I = parcelRequire("eTC2I");

var $jqBjs = parcelRequire("jqBjs");

var $lbKui = parcelRequire("lbKui");

var $89UbF = parcelRequire("89UbF");

var $zPqH5 = parcelRequire("zPqH5");

var $gHshw = parcelRequire("gHshw");

var $4y3tC = parcelRequire("4y3tC");

var $lshu4 = parcelRequire("lshu4");

var $iMyMP = parcelRequire("iMyMP");

var $kO7Mc = parcelRequire("kO7Mc");
$parcel$exportWildcard(module.exports, $4Plq2);
$parcel$exportWildcard(module.exports, $6gWbe);
$parcel$exportWildcard(module.exports, $4ckZY);
$parcel$exportWildcard(module.exports, $4s7WH);
$parcel$exportWildcard(module.exports, $gz1Te);
$parcel$exportWildcard(module.exports, $6xhCH);
$parcel$exportWildcard(module.exports, $5kU6m);
$parcel$exportWildcard(module.exports, $6Yrra);
$parcel$exportWildcard(module.exports, $kaKTm);
$parcel$exportWildcard(module.exports, $8KyJ5);
$parcel$exportWildcard(module.exports, $3XlZC);
$parcel$exportWildcard(module.exports, $bwHK4);
$parcel$exportWildcard(module.exports, $kxMuV);
$parcel$exportWildcard(module.exports, $dgorV);
$parcel$exportWildcard(module.exports, $cUtk9);
$parcel$exportWildcard(module.exports, $2FHGO);
$parcel$exportWildcard(module.exports, $7FapI);
$parcel$exportWildcard(module.exports, $hv0Wi);
$parcel$exportWildcard(module.exports, $8V7nn);
$parcel$exportWildcard(module.exports, $h1Vgw);
$parcel$exportWildcard(module.exports, $aZAXJ);
$parcel$exportWildcard(module.exports, $eTC2I);
$parcel$exportWildcard(module.exports, $jqBjs);
$parcel$exportWildcard(module.exports, $lbKui);
$parcel$exportWildcard(module.exports, $89UbF);
$parcel$exportWildcard(module.exports, $zPqH5);
$parcel$exportWildcard(module.exports, $gHshw);
$parcel$exportWildcard(module.exports, $4y3tC);
$parcel$exportWildcard(module.exports, $lshu4);
$parcel$exportWildcard(module.exports, $iMyMP);
$parcel$exportWildcard(module.exports, $kO7Mc);

});
parcelRegister("jRxTS", function(module, exports) {

$parcel$export(module.exports, "version", () => $e75d437129cf6177$export$83d89fbfd8236492);
var $e75d437129cf6177$export$a8ff84c12d48cfa6 = "d3";
var $e75d437129cf6177$export$83d89fbfd8236492 = "5.16.0";
var $e75d437129cf6177$export$6d59db4903f20f7d = "Data-Driven Documents";
var $e75d437129cf6177$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $e75d437129cf6177$export$4cec2234a9c7ce6d = "https://d3js.org";
var $e75d437129cf6177$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $e75d437129cf6177$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $e75d437129cf6177$export$f22da7240b7add18 = "dist/d3.node.js";
var $e75d437129cf6177$export$101358e655b23e68 = "dist/d3.min.js";
var $e75d437129cf6177$export$a2877c4988dda7ec = "dist/d3.min.js";
var $e75d437129cf6177$export$130be424786e852f = "index.js";
var $e75d437129cf6177$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $e75d437129cf6177$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $e75d437129cf6177$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $e75d437129cf6177$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "2",
    "rollup": "1",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "rollup-plugin-terser": "5",
    "tape": "4"
};
var $e75d437129cf6177$export$b74ff737e0e298b5 = {
    "d3-array": "1",
    "d3-axis": "1",
    "d3-brush": "1",
    "d3-chord": "1",
    "d3-collection": "1",
    "d3-color": "1",
    "d3-contour": "1",
    "d3-dispatch": "1",
    "d3-drag": "1",
    "d3-dsv": "1",
    "d3-ease": "1",
    "d3-fetch": "1",
    "d3-force": "1",
    "d3-format": "1",
    "d3-geo": "1",
    "d3-hierarchy": "1",
    "d3-interpolate": "1",
    "d3-path": "1",
    "d3-polygon": "1",
    "d3-quadtree": "1",
    "d3-random": "1",
    "d3-scale": "2",
    "d3-scale-chromatic": "1",
    "d3-selection": "1",
    "d3-shape": "1",
    "d3-time": "1",
    "d3-time-format": "2",
    "d3-timer": "1",
    "d3-transition": "1",
    "d3-voronoi": "1",
    "d3-zoom": "1"
};

});

parcelRegister("4Plq2", function(module, exports) {

$parcel$export(module.exports, "bisect", () => (parcelRequire("2A9YO")).default);
$parcel$export(module.exports, "bisectRight", () => (parcelRequire("2A9YO")).bisectRight);
$parcel$export(module.exports, "bisectLeft", () => (parcelRequire("2A9YO")).bisectLeft);
$parcel$export(module.exports, "ascending", () => (parcelRequire("kEOKb")).default);
$parcel$export(module.exports, "bisector", () => (parcelRequire("28lCl")).default);
$parcel$export(module.exports, "cross", () => (parcelRequire("6dCQI")).default);
$parcel$export(module.exports, "descending", () => (parcelRequire("b2EXe")).default);
$parcel$export(module.exports, "deviation", () => (parcelRequire("igFpD")).default);
$parcel$export(module.exports, "extent", () => (parcelRequire("79fpR")).default);
$parcel$export(module.exports, "histogram", () => (parcelRequire("bXNsh")).default);
$parcel$export(module.exports, "thresholdFreedmanDiaconis", () => (parcelRequire("4cjlt")).default);
$parcel$export(module.exports, "thresholdScott", () => (parcelRequire("6JY0d")).default);
$parcel$export(module.exports, "thresholdSturges", () => (parcelRequire("kYiil")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("cxHPt")).default);
$parcel$export(module.exports, "mean", () => (parcelRequire("1wS4Q")).default);
$parcel$export(module.exports, "median", () => (parcelRequire("i2qfY")).default);
$parcel$export(module.exports, "merge", () => (parcelRequire("aMnMV")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("fwvAz")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("17kMd")).default);
$parcel$export(module.exports, "permute", () => (parcelRequire("52fHH")).default);
$parcel$export(module.exports, "quantile", () => (parcelRequire("deRMV")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("c44DK")).default);
$parcel$export(module.exports, "scan", () => (parcelRequire("5vGEH")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("6ELSR")).default);
$parcel$export(module.exports, "sum", () => (parcelRequire("AU0HI")).default);
$parcel$export(module.exports, "ticks", () => (parcelRequire("8YDch")).default);
$parcel$export(module.exports, "tickIncrement", () => (parcelRequire("8YDch")).tickIncrement);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("8YDch")).tickStep);
$parcel$export(module.exports, "transpose", () => (parcelRequire("kuT1V")).default);
$parcel$export(module.exports, "variance", () => (parcelRequire("jxOZG")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("Bq03L")).default);

var $2A9YO = parcelRequire("2A9YO");

var $kEOKb = parcelRequire("kEOKb");

var $28lCl = parcelRequire("28lCl");

var $6dCQI = parcelRequire("6dCQI");

var $b2EXe = parcelRequire("b2EXe");

var $igFpD = parcelRequire("igFpD");

var $79fpR = parcelRequire("79fpR");

var $bXNsh = parcelRequire("bXNsh");

var $4cjlt = parcelRequire("4cjlt");

var $6JY0d = parcelRequire("6JY0d");

var $kYiil = parcelRequire("kYiil");

var $cxHPt = parcelRequire("cxHPt");

var $1wS4Q = parcelRequire("1wS4Q");

var $i2qfY = parcelRequire("i2qfY");

var $aMnMV = parcelRequire("aMnMV");

var $fwvAz = parcelRequire("fwvAz");

var $17kMd = parcelRequire("17kMd");

var $52fHH = parcelRequire("52fHH");

var $deRMV = parcelRequire("deRMV");

var $c44DK = parcelRequire("c44DK");

var $5vGEH = parcelRequire("5vGEH");

var $6ELSR = parcelRequire("6ELSR");

var $AU0HI = parcelRequire("AU0HI");

var $8YDch = parcelRequire("8YDch");

var $kuT1V = parcelRequire("kuT1V");

var $jxOZG = parcelRequire("jxOZG");

var $Bq03L = parcelRequire("Bq03L");

});
parcelRegister("2A9YO", function(module, exports) {

$parcel$export(module.exports, "bisectRight", () => $1e16af60ad8d9b2d$export$4d945ad3ad5751b0);
$parcel$export(module.exports, "bisectLeft", () => $1e16af60ad8d9b2d$export$df7d25c84ebd12a5);
$parcel$export(module.exports, "default", () => $1e16af60ad8d9b2d$export$2e2bcd8739ae039);

var $kEOKb = parcelRequire("kEOKb");

var $28lCl = parcelRequire("28lCl");
var $1e16af60ad8d9b2d$var$ascendingBisect = (0, $28lCl.default)((0, $kEOKb.default));
var $1e16af60ad8d9b2d$export$4d945ad3ad5751b0 = $1e16af60ad8d9b2d$var$ascendingBisect.right;
var $1e16af60ad8d9b2d$export$df7d25c84ebd12a5 = $1e16af60ad8d9b2d$var$ascendingBisect.left;
var $1e16af60ad8d9b2d$export$2e2bcd8739ae039 = $1e16af60ad8d9b2d$export$4d945ad3ad5751b0;

});
parcelRegister("kEOKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f09ee7c02ea8ba40$export$2e2bcd8739ae039);
function $f09ee7c02ea8ba40$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("28lCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dd18ed16a4165c$export$2e2bcd8739ae039);

var $kEOKb = parcelRequire("kEOKb");
function $18dd18ed16a4165c$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $18dd18ed16a4165c$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $18dd18ed16a4165c$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $kEOKb.default)(f(d), x);
    };
}

});


parcelRegister("6dCQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $487217a3ed092b35$export$2e2bcd8739ae039);

var $17kMd = parcelRequire("17kMd");
function $487217a3ed092b35$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $17kMd.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("17kMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d068fb936040f9d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "pair", () => $0d068fb936040f9d$export$a04cb3fe8b81dd);
function $0d068fb936040f9d$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $0d068fb936040f9d$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $0d068fb936040f9d$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("b2EXe", function(module, exports) {

$parcel$export(module.exports, "default", () => $809fa64f4cdea41a$export$2e2bcd8739ae039);
function $809fa64f4cdea41a$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("igFpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c9d842b21a9e10$export$2e2bcd8739ae039);

var $jxOZG = parcelRequire("jxOZG");
function $d4c9d842b21a9e10$export$2e2bcd8739ae039(array, f) {
    var v = (0, $jxOZG.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("jxOZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3a8a7b6939c7d1e$export$2e2bcd8739ae039);

var $ab25q = parcelRequire("ab25q");
function $e3a8a7b6939c7d1e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("ab25q", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c8cce7360b8e5$export$2e2bcd8739ae039);
function $768c8cce7360b8e5$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("79fpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $534554fb1ae15eee$export$2e2bcd8739ae039);
function $534554fb1ae15eee$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("bXNsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b5b91298b975a35$export$2e2bcd8739ae039);

var $5t7MQ = parcelRequire("5t7MQ");

var $2A9YO = parcelRequire("2A9YO");

var $dsEFs = parcelRequire("dsEFs");

var $79fpR = parcelRequire("79fpR");

var $8BBgJ = parcelRequire("8BBgJ");

var $c44DK = parcelRequire("c44DK");

var $8YDch = parcelRequire("8YDch");

var $kYiil = parcelRequire("kYiil");
function $8b5b91298b975a35$export$2e2bcd8739ae039() {
    var value = (0, $8BBgJ.default), domain = (0, $79fpR.default), threshold = (0, $kYiil.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $8YDch.tickStep)(x0, x1, tz);
            tz = (0, $c44DK.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $2A9YO.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dsEFs.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $dsEFs.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $dsEFs.default)((0, $5t7MQ.slice).call(_)) : (0, $dsEFs.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("5t7MQ", function(module, exports) {

$parcel$export(module.exports, "slice", () => $3fb5b380cb85e38c$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $3fb5b380cb85e38c$export$871de8747c9eaa88);
var $3fb5b380cb85e38c$var$array = Array.prototype;
var $3fb5b380cb85e38c$export$58adb3bec8346d0f = $3fb5b380cb85e38c$var$array.slice;
var $3fb5b380cb85e38c$export$871de8747c9eaa88 = $3fb5b380cb85e38c$var$array.map;

});

parcelRegister("dsEFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccd6fa7a43cacba$export$2e2bcd8739ae039);
function $9ccd6fa7a43cacba$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("8BBgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $643eb03aea1cd143$export$2e2bcd8739ae039);
function $643eb03aea1cd143$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("c44DK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c89752bbf2ee008$export$2e2bcd8739ae039);
function $8c89752bbf2ee008$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("8YDch", function(module, exports) {

$parcel$export(module.exports, "default", () => $68925509b0aa0cdd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $68925509b0aa0cdd$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $68925509b0aa0cdd$export$81087d9b915d4ede);
var $68925509b0aa0cdd$var$e10 = Math.sqrt(50), $68925509b0aa0cdd$var$e5 = Math.sqrt(10), $68925509b0aa0cdd$var$e2 = Math.sqrt(2);
function $68925509b0aa0cdd$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $68925509b0aa0cdd$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $68925509b0aa0cdd$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $68925509b0aa0cdd$var$e10 ? 10 : error >= $68925509b0aa0cdd$var$e5 ? 5 : error >= $68925509b0aa0cdd$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $68925509b0aa0cdd$var$e10 ? 10 : error >= $68925509b0aa0cdd$var$e5 ? 5 : error >= $68925509b0aa0cdd$var$e2 ? 2 : 1);
}
function $68925509b0aa0cdd$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $68925509b0aa0cdd$var$e10) step1 *= 10;
    else if (error >= $68925509b0aa0cdd$var$e5) step1 *= 5;
    else if (error >= $68925509b0aa0cdd$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("kYiil", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4479a3591712a5f$export$2e2bcd8739ae039);
function $f4479a3591712a5f$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("4cjlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e749fcd37b9b9b$export$2e2bcd8739ae039);

var $5t7MQ = parcelRequire("5t7MQ");

var $kEOKb = parcelRequire("kEOKb");

var $ab25q = parcelRequire("ab25q");

var $deRMV = parcelRequire("deRMV");
function $30e749fcd37b9b9b$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $5t7MQ.map).call(values, (0, $ab25q.default)).sort((0, $kEOKb.default));
    return Math.ceil((max - min) / (2 * ((0, $deRMV.default)(values, 0.75) - (0, $deRMV.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("deRMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a364e593336a9a0$export$2e2bcd8739ae039);

var $ab25q = parcelRequire("ab25q");
function $9a364e593336a9a0$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $ab25q.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("6JY0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e857d453110bd62$export$2e2bcd8739ae039);

var $igFpD = parcelRequire("igFpD");
function $4e857d453110bd62$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $igFpD.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("cxHPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $921a90ace5bcd4b4$export$2e2bcd8739ae039);
function $921a90ace5bcd4b4$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("1wS4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d2ba31eaaa706b$export$2e2bcd8739ae039);

var $ab25q = parcelRequire("ab25q");
function $11d2ba31eaaa706b$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("i2qfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21cc7f12aa94877$export$2e2bcd8739ae039);

var $kEOKb = parcelRequire("kEOKb");

var $ab25q = parcelRequire("ab25q");

var $deRMV = parcelRequire("deRMV");
function $d21cc7f12aa94877$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $ab25q.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $deRMV.default)(numbers.sort((0, $kEOKb.default)), 0.5);
}

});

parcelRegister("aMnMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d90d6e8cf8f3074$export$2e2bcd8739ae039);
function $7d90d6e8cf8f3074$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("fwvAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d2590a2a0c7300$export$2e2bcd8739ae039);
function $b4d2590a2a0c7300$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("52fHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aa9521bee140b20$export$2e2bcd8739ae039);
function $3aa9521bee140b20$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("5vGEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4030ef7b676ae832$export$2e2bcd8739ae039);

var $kEOKb = parcelRequire("kEOKb");
function $4030ef7b676ae832$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $kEOKb.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("6ELSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8b9f3990d4d490$export$2e2bcd8739ae039);
function $4d8b9f3990d4d490$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("AU0HI", function(module, exports) {

$parcel$export(module.exports, "default", () => $06eecf65bdbef790$export$2e2bcd8739ae039);
function $06eecf65bdbef790$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("kuT1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec14bceafaa611d$export$2e2bcd8739ae039);

var $fwvAz = parcelRequire("fwvAz");
function $eec14bceafaa611d$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $fwvAz.default)(matrix, $eec14bceafaa611d$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $eec14bceafaa611d$var$length(d) {
    return d.length;
}

});

parcelRegister("Bq03L", function(module, exports) {

$parcel$export(module.exports, "default", () => $07079fdded5819ac$export$2e2bcd8739ae039);

var $kuT1V = parcelRequire("kuT1V");
function $07079fdded5819ac$export$2e2bcd8739ae039() {
    return (0, $kuT1V.default)(arguments);
}

});


parcelRegister("6gWbe", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => (parcelRequire("fs1Ou")).axisTop);
$parcel$export(module.exports, "axisRight", () => (parcelRequire("fs1Ou")).axisRight);
$parcel$export(module.exports, "axisBottom", () => (parcelRequire("fs1Ou")).axisBottom);
$parcel$export(module.exports, "axisLeft", () => (parcelRequire("fs1Ou")).axisLeft);

var $fs1Ou = parcelRequire("fs1Ou");

});
parcelRegister("fs1Ou", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => $b3fae0a1f45ad55c$export$59b8cfab074bdeb1);
$parcel$export(module.exports, "axisRight", () => $b3fae0a1f45ad55c$export$b0d2e24dc4f898f0);
$parcel$export(module.exports, "axisBottom", () => $b3fae0a1f45ad55c$export$e5cb22533a15e72e);
$parcel$export(module.exports, "axisLeft", () => $b3fae0a1f45ad55c$export$2749afb169a520d2);

var $ijFVh = parcelRequire("ijFVh");

var $aqL9R = parcelRequire("aqL9R");
var $b3fae0a1f45ad55c$var$top = 1, $b3fae0a1f45ad55c$var$right = 2, $b3fae0a1f45ad55c$var$bottom = 3, $b3fae0a1f45ad55c$var$left = 4, $b3fae0a1f45ad55c$var$epsilon = 1e-6;
function $b3fae0a1f45ad55c$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $b3fae0a1f45ad55c$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $b3fae0a1f45ad55c$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $b3fae0a1f45ad55c$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $b3fae0a1f45ad55c$var$entering() {
    return !this.__axis;
}
function $b3fae0a1f45ad55c$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $b3fae0a1f45ad55c$var$top || orient === $b3fae0a1f45ad55c$var$left ? -1 : 1, x = orient === $b3fae0a1f45ad55c$var$left || orient === $b3fae0a1f45ad55c$var$right ? "x" : "y", transform = orient === $b3fae0a1f45ad55c$var$top || orient === $b3fae0a1f45ad55c$var$bottom ? $b3fae0a1f45ad55c$var$translateX : $b3fae0a1f45ad55c$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $aqL9R.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $b3fae0a1f45ad55c$var$center : $b3fae0a1f45ad55c$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $b3fae0a1f45ad55c$var$top ? "0em" : orient === $b3fae0a1f45ad55c$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $b3fae0a1f45ad55c$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $b3fae0a1f45ad55c$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $b3fae0a1f45ad55c$var$left || orient == $b3fae0a1f45ad55c$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($b3fae0a1f45ad55c$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $b3fae0a1f45ad55c$var$right ? "start" : orient === $b3fae0a1f45ad55c$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $ijFVh.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $ijFVh.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $ijFVh.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $b3fae0a1f45ad55c$export$59b8cfab074bdeb1(scale) {
    return $b3fae0a1f45ad55c$var$axis($b3fae0a1f45ad55c$var$top, scale);
}
function $b3fae0a1f45ad55c$export$b0d2e24dc4f898f0(scale) {
    return $b3fae0a1f45ad55c$var$axis($b3fae0a1f45ad55c$var$right, scale);
}
function $b3fae0a1f45ad55c$export$e5cb22533a15e72e(scale) {
    return $b3fae0a1f45ad55c$var$axis($b3fae0a1f45ad55c$var$bottom, scale);
}
function $b3fae0a1f45ad55c$export$2749afb169a520d2(scale) {
    return $b3fae0a1f45ad55c$var$axis($b3fae0a1f45ad55c$var$left, scale);
}

});
parcelRegister("ijFVh", function(module, exports) {

$parcel$export(module.exports, "slice", () => $d55a855b041570b7$export$58adb3bec8346d0f);
var $d55a855b041570b7$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("aqL9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $7980e9b5e6e74fc8$export$2e2bcd8739ae039);
function $7980e9b5e6e74fc8$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("4ckZY", function(module, exports) {

$parcel$export(module.exports, "brush", () => (parcelRequire("2F9ka")).default);
$parcel$export(module.exports, "brushX", () => (parcelRequire("2F9ka")).brushX);
$parcel$export(module.exports, "brushY", () => (parcelRequire("2F9ka")).brushY);
$parcel$export(module.exports, "brushSelection", () => (parcelRequire("2F9ka")).brushSelection);

var $2F9ka = parcelRequire("2F9ka");

});
parcelRegister("2F9ka", function(module, exports) {

$parcel$export(module.exports, "brushSelection", () => $1f06a4b2e8615bd0$export$69760394fc76f689);
$parcel$export(module.exports, "brushX", () => $1f06a4b2e8615bd0$export$979ace6c88860aa8);
$parcel$export(module.exports, "brushY", () => $1f06a4b2e8615bd0$export$468748b530991c54);
$parcel$export(module.exports, "default", () => $1f06a4b2e8615bd0$export$2e2bcd8739ae039);

var $4h5V5 = parcelRequire("4h5V5");

var $kza96 = parcelRequire("kza96");

var $4ONh6 = parcelRequire("4ONh6");

var $cdh1A = parcelRequire("cdh1A");
var $gZqlB = parcelRequire("gZqlB");
var $kCHcF = parcelRequire("kCHcF");
var $jSl7R = parcelRequire("jSl7R");
parcelRequire("lshu4");
var $4zBBK = parcelRequire("4zBBK");

var $fEIkN = parcelRequire("fEIkN");

var $ciUFq = parcelRequire("ciUFq");

var $etb7C = parcelRequire("etb7C");
var $1f06a4b2e8615bd0$var$MODE_DRAG = {
    name: "drag"
}, $1f06a4b2e8615bd0$var$MODE_SPACE = {
    name: "space"
}, $1f06a4b2e8615bd0$var$MODE_HANDLE = {
    name: "handle"
}, $1f06a4b2e8615bd0$var$MODE_CENTER = {
    name: "center"
};
function $1f06a4b2e8615bd0$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $1f06a4b2e8615bd0$var$number2(e) {
    return [
        $1f06a4b2e8615bd0$var$number1(e[0]),
        $1f06a4b2e8615bd0$var$number1(e[1])
    ];
}
function $1f06a4b2e8615bd0$var$toucher(identifier) {
    return function(target) {
        return (0, $jSl7R.default)(target, (0, $cdh1A.event).touches, identifier);
    };
}
var $1f06a4b2e8615bd0$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($1f06a4b2e8615bd0$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $1f06a4b2e8615bd0$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($1f06a4b2e8615bd0$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $1f06a4b2e8615bd0$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($1f06a4b2e8615bd0$var$type),
    input: function(xy) {
        return xy == null ? null : $1f06a4b2e8615bd0$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $1f06a4b2e8615bd0$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $1f06a4b2e8615bd0$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $1f06a4b2e8615bd0$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $1f06a4b2e8615bd0$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $1f06a4b2e8615bd0$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $1f06a4b2e8615bd0$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $1f06a4b2e8615bd0$var$defaultFilter() {
    return !(0, $cdh1A.event).ctrlKey && !(0, $cdh1A.event).button;
}
function $1f06a4b2e8615bd0$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $1f06a4b2e8615bd0$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $1f06a4b2e8615bd0$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $1f06a4b2e8615bd0$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $1f06a4b2e8615bd0$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $1f06a4b2e8615bd0$export$979ace6c88860aa8() {
    return $1f06a4b2e8615bd0$var$brush($1f06a4b2e8615bd0$var$X);
}
function $1f06a4b2e8615bd0$export$468748b530991c54() {
    return $1f06a4b2e8615bd0$var$brush($1f06a4b2e8615bd0$var$Y);
}
function $1f06a4b2e8615bd0$export$2e2bcd8739ae039() {
    return $1f06a4b2e8615bd0$var$brush($1f06a4b2e8615bd0$var$XY);
}
function $1f06a4b2e8615bd0$var$brush(dim) {
    var extent = $1f06a4b2e8615bd0$var$defaultExtent, filter = $1f06a4b2e8615bd0$var$defaultFilter, touchable = $1f06a4b2e8615bd0$var$defaultTouchable, keys = true, listeners = (0, $4h5V5.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $1f06a4b2e8615bd0$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $1f06a4b2e8615bd0$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $1f06a4b2e8615bd0$var$local(this).extent;
            (0, $kCHcF.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $1f06a4b2e8615bd0$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $1f06a4b2e8615bd0$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $1f06a4b2e8615bd0$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $4ONh6.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $4zBBK.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $kCHcF.default)(this), selection = $1f06a4b2e8615bd0$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $cdh1A.customEvent)(new (0, $ciUFq.default)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if (touchending && !(0, $cdh1A.event).touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $cdh1A.event).target.__data__.type, mode = (keys && (0, $cdh1A.event).metaKey ? type = "overlay" : type) === "selection" ? $1f06a4b2e8615bd0$var$MODE_DRAG : keys && (0, $cdh1A.event).altKey ? $1f06a4b2e8615bd0$var$MODE_CENTER : $1f06a4b2e8615bd0$var$MODE_HANDLE, signX = dim === $1f06a4b2e8615bd0$var$Y ? null : $1f06a4b2e8615bd0$var$signsX[type], signY = dim === $1f06a4b2e8615bd0$var$X ? null : $1f06a4b2e8615bd0$var$signsY[type], state = $1f06a4b2e8615bd0$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && (0, $cdh1A.event).shiftKey, lockX, lockY, pointer = (0, $cdh1A.event).touches ? $1f06a4b2e8615bd0$var$toucher((0, $cdh1A.event).changedTouches[0].identifier) : (0, $gZqlB.default), point0 = pointer(that), point = point0, emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
                [
                    w0 = dim === $1f06a4b2e8615bd0$var$Y ? W : point0[0],
                    n0 = dim === $1f06a4b2e8615bd0$var$X ? N : point0[1]
                ],
                [
                    e0 = dim === $1f06a4b2e8615bd0$var$Y ? E : w0,
                    s0 = dim === $1f06a4b2e8615bd0$var$X ? S : n0
                ]
            ];
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $kCHcF.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $1f06a4b2e8615bd0$var$cursors[type]);
        if ((0, $cdh1A.event).touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $kCHcF.default)((0, $cdh1A.event).view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $kza96.default)((0, $cdh1A.event).view);
        }
        (0, $etb7C.nopropagation)();
        (0, $4zBBK.default)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $etb7C.default)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $1f06a4b2e8615bd0$var$MODE_SPACE:
                case $1f06a4b2e8615bd0$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $1f06a4b2e8615bd0$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $1f06a4b2e8615bd0$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $1f06a4b2e8615bd0$var$flipX) overlay.attr("cursor", $1f06a4b2e8615bd0$var$cursors[type = $1f06a4b2e8615bd0$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $1f06a4b2e8615bd0$var$flipY) overlay.attr("cursor", $1f06a4b2e8615bd0$var$cursors[type = $1f06a4b2e8615bd0$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $etb7C.nopropagation)();
            if ((0, $cdh1A.event).touches) {
                if ((0, $cdh1A.event).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $kza96.yesdrag)((0, $cdh1A.event).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $1f06a4b2e8615bd0$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($1f06a4b2e8615bd0$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $cdh1A.event).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $1f06a4b2e8615bd0$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $1f06a4b2e8615bd0$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $1f06a4b2e8615bd0$var$MODE_HANDLE || mode === $1f06a4b2e8615bd0$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $1f06a4b2e8615bd0$var$MODE_SPACE;
                        overlay.attr("cursor", $1f06a4b2e8615bd0$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $etb7C.default)();
        }
        function keyupped() {
            switch((0, $cdh1A.event).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $1f06a4b2e8615bd0$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $1f06a4b2e8615bd0$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $1f06a4b2e8615bd0$var$MODE_SPACE) {
                        if ((0, $cdh1A.event).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $1f06a4b2e8615bd0$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $1f06a4b2e8615bd0$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $1f06a4b2e8615bd0$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $etb7C.default)();
        }
    }
    function touchmoved() {
        emitter(this, arguments).moved();
    }
    function touchended() {
        emitter(this, arguments).ended();
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $1f06a4b2e8615bd0$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $fEIkN.default)($1f06a4b2e8615bd0$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $fEIkN.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $fEIkN.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("4h5V5", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cd57835620496c$export$2e2bcd8739ae039);
var $31cd57835620496c$var$noop = {
    value: function() {}
};
function $31cd57835620496c$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $31cd57835620496c$var$Dispatch(_);
}
function $31cd57835620496c$var$Dispatch(_) {
    this._ = _;
}
function $31cd57835620496c$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$31cd57835620496c$var$Dispatch.prototype = $31cd57835620496c$var$dispatch.prototype = {
    constructor: $31cd57835620496c$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $31cd57835620496c$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $31cd57835620496c$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $31cd57835620496c$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $31cd57835620496c$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $31cd57835620496c$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $31cd57835620496c$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $31cd57835620496c$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $31cd57835620496c$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $31cd57835620496c$export$2e2bcd8739ae039 = $31cd57835620496c$var$dispatch;

});

parcelRegister("kza96", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8ef24c8cfbb662$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $ef8ef24c8cfbb662$export$833237748009e1e1);

var $kCHcF = parcelRequire("kCHcF");

var $6OzG5 = parcelRequire("6OzG5");
function $ef8ef24c8cfbb662$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $kCHcF.default)(view).on("dragstart.drag", (0, $6OzG5.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $6OzG5.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $ef8ef24c8cfbb662$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $kCHcF.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $6OzG5.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("kCHcF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f038de826dcf04e6$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $f038de826dcf04e6$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $71I3e.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $71I3e.Selection)([
        [
            selector
        ]
    ], (0, $71I3e.root));
}

});
parcelRegister("71I3e", function(module, exports) {

$parcel$export(module.exports, "root", () => $51dacc0364d439f6$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $51dacc0364d439f6$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $51dacc0364d439f6$export$2e2bcd8739ae039);

var $az2lm = parcelRequire("az2lm");

var $8qOO0 = parcelRequire("8qOO0");

var $21w6c = parcelRequire("21w6c");

var $jZILB = parcelRequire("jZILB");

var $kQxS5 = parcelRequire("kQxS5");

var $2iDjG = parcelRequire("2iDjG");

var $2bUxG = parcelRequire("2bUxG");

var $vYs98 = parcelRequire("vYs98");

var $7az1U = parcelRequire("7az1U");

var $5NQyZ = parcelRequire("5NQyZ");

var $1jaRO = parcelRequire("1jaRO");

var $9JTOe = parcelRequire("9JTOe");

var $hYrEx = parcelRequire("hYrEx");

var $4y1I6 = parcelRequire("4y1I6");

var $8eEs1 = parcelRequire("8eEs1");

var $hUK07 = parcelRequire("hUK07");

var $5FcLt = parcelRequire("5FcLt");

var $7p4b3 = parcelRequire("7p4b3");

var $5tmfn = parcelRequire("5tmfn");

var $hVxsg = parcelRequire("hVxsg");

var $hc3uF = parcelRequire("hc3uF");

var $hbKVt = parcelRequire("hbKVt");

var $c45BA = parcelRequire("c45BA");

var $bQQzq = parcelRequire("bQQzq");

var $apdts = parcelRequire("apdts");

var $3RvP5 = parcelRequire("3RvP5");

var $5Zksf = parcelRequire("5Zksf");

var $eGyQL = parcelRequire("eGyQL");

var $cVn7l = parcelRequire("cVn7l");

var $cdh1A = parcelRequire("cdh1A");

var $belbG = parcelRequire("belbG");
var $51dacc0364d439f6$export$e8e78c978b129247 = [
    null
];
function $51dacc0364d439f6$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $51dacc0364d439f6$var$selection() {
    return new $51dacc0364d439f6$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $51dacc0364d439f6$export$e8e78c978b129247);
}
$51dacc0364d439f6$export$52baac22726c72bf.prototype = $51dacc0364d439f6$var$selection.prototype = {
    constructor: $51dacc0364d439f6$export$52baac22726c72bf,
    select: (0, $az2lm.default),
    selectAll: (0, $8qOO0.default),
    filter: (0, $21w6c.default),
    data: (0, $jZILB.default),
    enter: (0, $kQxS5.default),
    exit: (0, $2iDjG.default),
    join: (0, $2bUxG.default),
    merge: (0, $vYs98.default),
    order: (0, $7az1U.default),
    sort: (0, $5NQyZ.default),
    call: (0, $1jaRO.default),
    nodes: (0, $9JTOe.default),
    node: (0, $hYrEx.default),
    size: (0, $4y1I6.default),
    empty: (0, $8eEs1.default),
    each: (0, $hUK07.default),
    attr: (0, $5FcLt.default),
    style: (0, $7p4b3.default),
    property: (0, $5tmfn.default),
    classed: (0, $hVxsg.default),
    text: (0, $hc3uF.default),
    html: (0, $hbKVt.default),
    raise: (0, $c45BA.default),
    lower: (0, $bQQzq.default),
    append: (0, $apdts.default),
    insert: (0, $3RvP5.default),
    remove: (0, $5Zksf.default),
    clone: (0, $eGyQL.default),
    datum: (0, $cVn7l.default),
    on: (0, $cdh1A.default),
    dispatch: (0, $belbG.default)
};
var $51dacc0364d439f6$export$2e2bcd8739ae039 = $51dacc0364d439f6$var$selection;

});
parcelRegister("az2lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0efda42c300db2$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $lfS1Y = parcelRequire("lfS1Y");
function $7b0efda42c300db2$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $lfS1Y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $71I3e.Selection)(subgroups, this._parents);
}

});
parcelRegister("lfS1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f794e91189614b3e$export$2e2bcd8739ae039);
function $f794e91189614b3e$var$none() {}
function $f794e91189614b3e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $f794e91189614b3e$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("8qOO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $623829604b735567$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $eLBth = parcelRequire("eLBth");
function $623829604b735567$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $eLBth.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $71I3e.Selection)(subgroups, parents);
}

});
parcelRegister("eLBth", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac028579b5493d0d$export$2e2bcd8739ae039);
function $ac028579b5493d0d$var$empty() {
    return [];
}
function $ac028579b5493d0d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $ac028579b5493d0d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("21w6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $179492fa5a972faa$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $fVVXs = parcelRequire("fVVXs");
function $179492fa5a972faa$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fVVXs.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $71I3e.Selection)(subgroups, this._parents);
}

});
parcelRegister("fVVXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9992320fa5b2c5c$export$2e2bcd8739ae039);
function $b9992320fa5b2c5c$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("jZILB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e670973c8cb7de$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $kQxS5 = parcelRequire("kQxS5");

var $4A2gJ = parcelRequire("4A2gJ");
var $e8e670973c8cb7de$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $e8e670973c8cb7de$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $kQxS5.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $e8e670973c8cb7de$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $e8e670973c8cb7de$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $e8e670973c8cb7de$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $kQxS5.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $e8e670973c8cb7de$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $e8e670973c8cb7de$var$bindKey : $e8e670973c8cb7de$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $4A2gJ.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $71I3e.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("kQxS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d2f02459f34c10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $f2d2f02459f34c10$export$67b01759a14cf6a4);

var $bjuDp = parcelRequire("bjuDp");

var $71I3e = parcelRequire("71I3e");
function $f2d2f02459f34c10$export$2e2bcd8739ae039() {
    return new (0, $71I3e.Selection)(this._enter || this._groups.map((0, $bjuDp.default)), this._parents);
}
function $f2d2f02459f34c10$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$f2d2f02459f34c10$export$67b01759a14cf6a4.prototype = {
    constructor: $f2d2f02459f34c10$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("bjuDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c93b6f14b7948e$export$2e2bcd8739ae039);
function $83c93b6f14b7948e$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("4A2gJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $355c48c360a4beab$export$2e2bcd8739ae039);
function $355c48c360a4beab$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("2iDjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acbc29f08408aa6$export$2e2bcd8739ae039);

var $bjuDp = parcelRequire("bjuDp");

var $71I3e = parcelRequire("71I3e");
function $1acbc29f08408aa6$export$2e2bcd8739ae039() {
    return new (0, $71I3e.Selection)(this._exit || this._groups.map((0, $bjuDp.default)), this._parents);
}

});

parcelRegister("2bUxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $198877fe7f84216c$export$2e2bcd8739ae039);
function $198877fe7f84216c$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("vYs98", function(module, exports) {

$parcel$export(module.exports, "default", () => $0601ca10fed17547$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $0601ca10fed17547$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $71I3e.Selection)(merges, this._parents);
}

});

parcelRegister("7az1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5384a3bd66c4904d$export$2e2bcd8739ae039);
function $5384a3bd66c4904d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("5NQyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $439a4d5d946e661c$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $439a4d5d946e661c$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $439a4d5d946e661c$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $71I3e.Selection)(sortgroups, this._parents).order();
}
function $439a4d5d946e661c$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1jaRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3ffebfaed4ec12$export$2e2bcd8739ae039);
function $0f3ffebfaed4ec12$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("9JTOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $71739b8b88a251a1$export$2e2bcd8739ae039);
function $71739b8b88a251a1$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("hYrEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15d7d87bb3a9007$export$2e2bcd8739ae039);
function $d15d7d87bb3a9007$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("4y1I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fbaa063e6a8700$export$2e2bcd8739ae039);
function $34fbaa063e6a8700$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("8eEs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fef0242b28b43ea$export$2e2bcd8739ae039);
function $5fef0242b28b43ea$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("hUK07", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ab5975949642bc$export$2e2bcd8739ae039);
function $d0ab5975949642bc$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("5FcLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $01106e2d08cea534$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");
function $01106e2d08cea534$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $01106e2d08cea534$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $01106e2d08cea534$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $01106e2d08cea534$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $01106e2d08cea534$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $01106e2d08cea534$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $01106e2d08cea534$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $7UbnV.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $01106e2d08cea534$var$attrRemoveNS : $01106e2d08cea534$var$attrRemove : typeof value === "function" ? fullname.local ? $01106e2d08cea534$var$attrFunctionNS : $01106e2d08cea534$var$attrFunction : fullname.local ? $01106e2d08cea534$var$attrConstantNS : $01106e2d08cea534$var$attrConstant)(fullname, value));
}

});
parcelRegister("7UbnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c169828ee12e8de$export$2e2bcd8739ae039);

var $6pLcb = parcelRequire("6pLcb");
function $5c169828ee12e8de$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $6pLcb.default).hasOwnProperty(prefix) ? {
        space: (0, $6pLcb.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("6pLcb", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $4ab9afed4165bb3f$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $4ab9afed4165bb3f$export$2e2bcd8739ae039);
var $4ab9afed4165bb3f$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $4ab9afed4165bb3f$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $4ab9afed4165bb3f$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("7p4b3", function(module, exports) {

$parcel$export(module.exports, "default", () => $563e1bc004cc19fb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $563e1bc004cc19fb$export$5e3cec964f0b5efd);

var $5qPs0 = parcelRequire("5qPs0");
function $563e1bc004cc19fb$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $563e1bc004cc19fb$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $563e1bc004cc19fb$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $563e1bc004cc19fb$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $563e1bc004cc19fb$var$styleRemove : typeof value === "function" ? $563e1bc004cc19fb$var$styleFunction : $563e1bc004cc19fb$var$styleConstant)(name, value, priority == null ? "" : priority)) : $563e1bc004cc19fb$export$5e3cec964f0b5efd(this.node(), name);
}
function $563e1bc004cc19fb$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $5qPs0.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("5qPs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f474a78f86b8639$export$2e2bcd8739ae039);
function $3f474a78f86b8639$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("5tmfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc0eafa0aab896f$export$2e2bcd8739ae039);
function $3fc0eafa0aab896f$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $3fc0eafa0aab896f$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $3fc0eafa0aab896f$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $3fc0eafa0aab896f$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $3fc0eafa0aab896f$var$propertyRemove : typeof value === "function" ? $3fc0eafa0aab896f$var$propertyFunction : $3fc0eafa0aab896f$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("hVxsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0d1b5fc16f58f08$export$2e2bcd8739ae039);
function $d0d1b5fc16f58f08$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d0d1b5fc16f58f08$var$classList(node) {
    return node.classList || new $d0d1b5fc16f58f08$var$ClassList(node);
}
function $d0d1b5fc16f58f08$var$ClassList(node) {
    this._node = node;
    this._names = $d0d1b5fc16f58f08$var$classArray(node.getAttribute("class") || "");
}
$d0d1b5fc16f58f08$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d0d1b5fc16f58f08$var$classedAdd(node, names) {
    var list = $d0d1b5fc16f58f08$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d0d1b5fc16f58f08$var$classedRemove(node, names) {
    var list = $d0d1b5fc16f58f08$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d0d1b5fc16f58f08$var$classedTrue(names) {
    return function() {
        $d0d1b5fc16f58f08$var$classedAdd(this, names);
    };
}
function $d0d1b5fc16f58f08$var$classedFalse(names) {
    return function() {
        $d0d1b5fc16f58f08$var$classedRemove(this, names);
    };
}
function $d0d1b5fc16f58f08$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d0d1b5fc16f58f08$var$classedAdd : $d0d1b5fc16f58f08$var$classedRemove)(this, names);
    };
}
function $d0d1b5fc16f58f08$export$2e2bcd8739ae039(name, value) {
    var names = $d0d1b5fc16f58f08$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d0d1b5fc16f58f08$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d0d1b5fc16f58f08$var$classedFunction : value ? $d0d1b5fc16f58f08$var$classedTrue : $d0d1b5fc16f58f08$var$classedFalse)(names, value));
}

});

parcelRegister("hc3uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84644666e021619$export$2e2bcd8739ae039);
function $c84644666e021619$var$textRemove() {
    this.textContent = "";
}
function $c84644666e021619$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $c84644666e021619$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $c84644666e021619$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c84644666e021619$var$textRemove : (typeof value === "function" ? $c84644666e021619$var$textFunction : $c84644666e021619$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("hbKVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c837dd484b133241$export$2e2bcd8739ae039);
function $c837dd484b133241$var$htmlRemove() {
    this.innerHTML = "";
}
function $c837dd484b133241$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c837dd484b133241$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c837dd484b133241$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c837dd484b133241$var$htmlRemove : (typeof value === "function" ? $c837dd484b133241$var$htmlFunction : $c837dd484b133241$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("c45BA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8a34d6fd885bc5$export$2e2bcd8739ae039);
function $8c8a34d6fd885bc5$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $8c8a34d6fd885bc5$export$2e2bcd8739ae039() {
    return this.each($8c8a34d6fd885bc5$var$raise);
}

});

parcelRegister("bQQzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0d546df42bfead$export$2e2bcd8739ae039);
function $8a0d546df42bfead$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $8a0d546df42bfead$export$2e2bcd8739ae039() {
    return this.each($8a0d546df42bfead$var$lower);
}

});

parcelRegister("apdts", function(module, exports) {

$parcel$export(module.exports, "default", () => $7936b0d69331db14$export$2e2bcd8739ae039);

var $bjcho = parcelRequire("bjcho");
function $7936b0d69331db14$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $bjcho.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("bjcho", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bafe80a2f64bec$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");

var $6pLcb = parcelRequire("6pLcb");
function $83bafe80a2f64bec$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $6pLcb.xhtml) && document.documentElement.namespaceURI === (0, $6pLcb.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $83bafe80a2f64bec$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $83bafe80a2f64bec$export$2e2bcd8739ae039(name) {
    var fullname = (0, $7UbnV.default)(name);
    return (fullname.local ? $83bafe80a2f64bec$var$creatorFixed : $83bafe80a2f64bec$var$creatorInherit)(fullname);
}

});


parcelRegister("3RvP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cff01b2d138f246$export$2e2bcd8739ae039);

var $bjcho = parcelRequire("bjcho");

var $lfS1Y = parcelRequire("lfS1Y");
function $2cff01b2d138f246$var$constantNull() {
    return null;
}
function $2cff01b2d138f246$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $bjcho.default)(name), select = before == null ? $2cff01b2d138f246$var$constantNull : typeof before === "function" ? before : (0, $lfS1Y.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("5Zksf", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c28421f4deb594$export$2e2bcd8739ae039);
function $45c28421f4deb594$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $45c28421f4deb594$export$2e2bcd8739ae039() {
    return this.each($45c28421f4deb594$var$remove);
}

});

parcelRegister("eGyQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab100572b50eeab0$export$2e2bcd8739ae039);
function $ab100572b50eeab0$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $ab100572b50eeab0$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $ab100572b50eeab0$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $ab100572b50eeab0$var$selection_cloneDeep : $ab100572b50eeab0$var$selection_cloneShallow);
}

});

parcelRegister("cVn7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $968cbd923db60e9e$export$2e2bcd8739ae039);
function $968cbd923db60e9e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("cdh1A", function(module, exports) {

$parcel$export(module.exports, "event", () => $8e43e7a9663fe880$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $8e43e7a9663fe880$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $8e43e7a9663fe880$export$4c724631b4750aef);
var $8e43e7a9663fe880$var$filterEvents = {};
var $8e43e7a9663fe880$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $8e43e7a9663fe880$var$element = document.documentElement;
    if (!("onmouseenter" in $8e43e7a9663fe880$var$element)) $8e43e7a9663fe880$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $8e43e7a9663fe880$var$filterContextListener(listener, index, group) {
    listener = $8e43e7a9663fe880$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $8e43e7a9663fe880$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $8e43e7a9663fe880$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $8e43e7a9663fe880$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $8e43e7a9663fe880$export$6cd530ed55e06764 = event0;
        }
    };
}
function $8e43e7a9663fe880$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $8e43e7a9663fe880$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $8e43e7a9663fe880$var$onAdd(typename, value, capture) {
    var wrap = $8e43e7a9663fe880$var$filterEvents.hasOwnProperty(typename.type) ? $8e43e7a9663fe880$var$filterContextListener : $8e43e7a9663fe880$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $8e43e7a9663fe880$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $8e43e7a9663fe880$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $8e43e7a9663fe880$var$onAdd : $8e43e7a9663fe880$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $8e43e7a9663fe880$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $8e43e7a9663fe880$export$6cd530ed55e06764;
    event1.sourceEvent = $8e43e7a9663fe880$export$6cd530ed55e06764;
    $8e43e7a9663fe880$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $8e43e7a9663fe880$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("belbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d16fe7b06b44f7$export$2e2bcd8739ae039);

var $5qPs0 = parcelRequire("5qPs0");
function $82d16fe7b06b44f7$var$dispatchEvent(node, type, params) {
    var window = (0, $5qPs0.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $82d16fe7b06b44f7$var$dispatchConstant(type, params) {
    return function() {
        return $82d16fe7b06b44f7$var$dispatchEvent(this, type, params);
    };
}
function $82d16fe7b06b44f7$var$dispatchFunction(type, params) {
    return function() {
        return $82d16fe7b06b44f7$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $82d16fe7b06b44f7$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $82d16fe7b06b44f7$var$dispatchFunction : $82d16fe7b06b44f7$var$dispatchConstant)(type, params));
}

});



parcelRegister("6OzG5", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $4f63167173775644$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $4f63167173775644$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $4f63167173775644$export$2e2561858db9bf47() {
    (0, $cdh1A.event).stopImmediatePropagation();
}
function $4f63167173775644$export$2e2bcd8739ae039() {
    (0, $cdh1A.event).preventDefault();
    (0, $cdh1A.event).stopImmediatePropagation();
}

});


parcelRegister("4ONh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $38220de93305e1dd$export$2e2bcd8739ae039);

var $7TBR2 = parcelRequire("7TBR2");

var $lap8T = parcelRequire("lap8T");

var $5KJO9 = parcelRequire("5KJO9");

var $7uriv = parcelRequire("7uriv");

var $34azb = parcelRequire("34azb");

var $j5xin = parcelRequire("j5xin");

var $8rKaq = parcelRequire("8rKaq");

var $liQuG = parcelRequire("liQuG");

var $iOSz0 = parcelRequire("iOSz0");
function $38220de93305e1dd$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $liQuG.default)(b) : (t === "number" ? (0, $34azb.default) : t === "string" ? (c = (0, $7TBR2.default)(b)) ? (b = c, $lap8T.default) : (0, $8rKaq.default) : b instanceof (0, $7TBR2.default) ? (0, $lap8T.default) : b instanceof Date ? (0, $7uriv.default) : (0, $iOSz0.isNumberArray)(b) ? (0, $iOSz0.default) : Array.isArray(b) ? (0, $5KJO9.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $j5xin.default) : (0, $34azb.default))(a, b);
}

});
parcelRegister("7TBR2", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $llFwZ = parcelRequire("llFwZ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $llFwZ.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $llFwZ.default)(Rgb, rgb, (0, $llFwZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $llFwZ.default)(Hsl, hsl, (0, $llFwZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("llFwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8abc65f18ba9491$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $f8abc65f18ba9491$export$8b58be045bf06082);
function $f8abc65f18ba9491$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f8abc65f18ba9491$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("lap8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68e08ec6d7168ce$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rgbBasis", () => $f68e08ec6d7168ce$export$2c0e28f2e2852d3f);
$parcel$export(module.exports, "rgbBasisClosed", () => $f68e08ec6d7168ce$export$53d5214f625ccd4c);

var $7TBR2 = parcelRequire("7TBR2");

var $86tqN = parcelRequire("86tqN");

var $l5LKG = parcelRequire("l5LKG");

var $6isdb = parcelRequire("6isdb");
var $f68e08ec6d7168ce$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $6isdb.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7TBR2.rgb)(start)).r, (end = (0, $7TBR2.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f68e08ec6d7168ce$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7TBR2.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f68e08ec6d7168ce$export$2c0e28f2e2852d3f = $f68e08ec6d7168ce$var$rgbSpline((0, $86tqN.default));
var $f68e08ec6d7168ce$export$53d5214f625ccd4c = $f68e08ec6d7168ce$var$rgbSpline((0, $l5LKG.default));

});
parcelRegister("86tqN", function(module, exports) {

$parcel$export(module.exports, "basis", () => $5e65b6b294505426$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $5e65b6b294505426$export$2e2bcd8739ae039);
function $5e65b6b294505426$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $5e65b6b294505426$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $5e65b6b294505426$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("l5LKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5af1b22bfa963ff$export$2e2bcd8739ae039);

var $86tqN = parcelRequire("86tqN");
function $f5af1b22bfa963ff$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $86tqN.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("6isdb", function(module, exports) {

$parcel$export(module.exports, "hue", () => $495a4ec92a76a6a5$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $495a4ec92a76a6a5$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $495a4ec92a76a6a5$export$2e2bcd8739ae039);

var $liQuG = parcelRequire("liQuG");
function $495a4ec92a76a6a5$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $495a4ec92a76a6a5$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $495a4ec92a76a6a5$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $495a4ec92a76a6a5$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $liQuG.default)(isNaN(a) ? b : a);
}
function $495a4ec92a76a6a5$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $495a4ec92a76a6a5$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $495a4ec92a76a6a5$var$exponential(a, b, y) : (0, $liQuG.default)(isNaN(a) ? b : a);
    };
}
function $495a4ec92a76a6a5$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $495a4ec92a76a6a5$var$linear(a, d) : (0, $liQuG.default)(isNaN(a) ? b : a);
}

});
parcelRegister("liQuG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f823ff9c35fdc982$export$2e2bcd8739ae039);
function $f823ff9c35fdc982$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("5KJO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4304c81dac28bf8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "genericArray", () => $4304c81dac28bf8f$export$15d09067c6a5ee49);

var $4ONh6 = parcelRequire("4ONh6");

var $iOSz0 = parcelRequire("iOSz0");
function $4304c81dac28bf8f$export$2e2bcd8739ae039(a, b) {
    return ((0, $iOSz0.isNumberArray)(b) ? (0, $iOSz0.default) : $4304c81dac28bf8f$export$15d09067c6a5ee49)(a, b);
}
function $4304c81dac28bf8f$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $4ONh6.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("iOSz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $db3738b73f93a607$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $db3738b73f93a607$export$5cd576d1827d40c8);
function $db3738b73f93a607$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $db3738b73f93a607$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("7uriv", function(module, exports) {

$parcel$export(module.exports, "default", () => $574082789c91c9b7$export$2e2bcd8739ae039);
function $574082789c91c9b7$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("34azb", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b9f119ed71a3ce$export$2e2bcd8739ae039);
function $23b9f119ed71a3ce$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("j5xin", function(module, exports) {

$parcel$export(module.exports, "default", () => $de584fbe050ab0d3$export$2e2bcd8739ae039);

var $4ONh6 = parcelRequire("4ONh6");
function $de584fbe050ab0d3$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $4ONh6.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("8rKaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6264a832e9b7e426$export$2e2bcd8739ae039);

var $34azb = parcelRequire("34azb");
var $6264a832e9b7e426$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6264a832e9b7e426$var$reB = new RegExp($6264a832e9b7e426$var$reA.source, "g");
function $6264a832e9b7e426$var$zero(b) {
    return function() {
        return b;
    };
}
function $6264a832e9b7e426$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6264a832e9b7e426$export$2e2bcd8739ae039(a, b) {
    var bi = $6264a832e9b7e426$var$reA.lastIndex = $6264a832e9b7e426$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $6264a832e9b7e426$var$reA.exec(a)) && (bm = $6264a832e9b7e426$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $34azb.default)(am, bm)
            });
        }
        bi = $6264a832e9b7e426$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6264a832e9b7e426$var$one(q[0].x) : $6264a832e9b7e426$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("gZqlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e6c7e4e9ef7868$export$2e2bcd8739ae039);

var $gzaJc = parcelRequire("gzaJc");

var $faQ2F = parcelRequire("faQ2F");
function $c5e6c7e4e9ef7868$export$2e2bcd8739ae039(node) {
    var event = (0, $gzaJc.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $faQ2F.default)(node, event);
}

});
parcelRegister("gzaJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f83c96a52a7d72$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $c0f83c96a52a7d72$export$2e2bcd8739ae039() {
    var current = (0, $cdh1A.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("faQ2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c028aa3041b87a$export$2e2bcd8739ae039);
function $b0c028aa3041b87a$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("jSl7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7837298f6cb26ca$export$2e2bcd8739ae039);

var $gzaJc = parcelRequire("gzaJc");

var $faQ2F = parcelRequire("faQ2F");
function $e7837298f6cb26ca$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $gzaJc.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $faQ2F.default)(node, touch);
    }
    return null;
}

});

parcelRegister("lshu4", function(module, exports) {

$parcel$export(module.exports, "transition", () => (parcelRequire("8lOOg")).default);
$parcel$export(module.exports, "active", () => (parcelRequire("k7Z5Z")).default);
$parcel$export(module.exports, "interrupt", () => (parcelRequire("4zBBK")).default);
parcelRequire("5h6ag");

var $8lOOg = parcelRequire("8lOOg");

var $k7Z5Z = parcelRequire("k7Z5Z");

var $4zBBK = parcelRequire("4zBBK");

});
parcelRegister("5h6ag", function(module, exports) {

var $71I3e = parcelRequire("71I3e");

var $hi6Vp = parcelRequire("hi6Vp");

var $h6AQL = parcelRequire("h6AQL");
(0, $71I3e.default).prototype.interrupt = (0, $hi6Vp.default);
(0, $71I3e.default).prototype.transition = (0, $h6AQL.default);

});
parcelRegister("hi6Vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9697d4458116367$export$2e2bcd8739ae039);

var $4zBBK = parcelRequire("4zBBK");
function $c9697d4458116367$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $4zBBK.default)(this, name);
    });
}

});
parcelRegister("4zBBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $35479a768f4e5ab2$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $35479a768f4e5ab2$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $gx72e.STARTING) && schedule.state < (0, $gx72e.ENDING);
        schedule.state = (0, $gx72e.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("gx72e", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $c0952f67df27d0c6$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $c0952f67df27d0c6$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $c0952f67df27d0c6$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $c0952f67df27d0c6$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $c0952f67df27d0c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $c0952f67df27d0c6$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $c0952f67df27d0c6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $c0952f67df27d0c6$export$adaa4cf7ef1b65be);

var $4h5V5 = parcelRequire("4h5V5");

var $fF74h = parcelRequire("fF74h");
var $5hwOF = parcelRequire("5hwOF");
var $c0952f67df27d0c6$var$emptyOn = (0, $4h5V5.default)("start", "end", "cancel", "interrupt");
var $c0952f67df27d0c6$var$emptyTween = [];
var $c0952f67df27d0c6$export$ff39ebd4bb12b718 = 0;
var $c0952f67df27d0c6$export$584530fe98d14a84 = 1;
var $c0952f67df27d0c6$export$a5d151aee16efd42 = 2;
var $c0952f67df27d0c6$export$fb935ab5849a0db9 = 3;
var $c0952f67df27d0c6$export$1573e22b087389af = 4;
var $c0952f67df27d0c6$export$a2e792214ded83b2 = 5;
var $c0952f67df27d0c6$export$9d38167254403955 = 6;
function $c0952f67df27d0c6$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $c0952f67df27d0c6$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $c0952f67df27d0c6$var$emptyOn,
        tween: $c0952f67df27d0c6$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $c0952f67df27d0c6$export$ff39ebd4bb12b718
    });
}
function $c0952f67df27d0c6$export$2cd8252107eb640b(node, id) {
    var schedule = $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c0952f67df27d0c6$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $c0952f67df27d0c6$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c0952f67df27d0c6$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $c0952f67df27d0c6$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $5hwOF.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $c0952f67df27d0c6$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $c0952f67df27d0c6$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $c0952f67df27d0c6$export$fb935ab5849a0db9) return (0, $fF74h.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $c0952f67df27d0c6$export$1573e22b087389af) {
                o.state = $c0952f67df27d0c6$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $c0952f67df27d0c6$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $fF74h.default)(function() {
            if (self.state === $c0952f67df27d0c6$export$fb935ab5849a0db9) {
                self.state = $c0952f67df27d0c6$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $c0952f67df27d0c6$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $c0952f67df27d0c6$export$a5d151aee16efd42) return; // interrupted
        self.state = $c0952f67df27d0c6$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $c0952f67df27d0c6$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $c0952f67df27d0c6$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $c0952f67df27d0c6$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("fF74h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6702aebe54e863c$export$2e2bcd8739ae039);

var $5hwOF = parcelRequire("5hwOF");
function $b6702aebe54e863c$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $5hwOF.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("5hwOF", function(module, exports) {

$parcel$export(module.exports, "now", () => $3d87fee47766823b$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $3d87fee47766823b$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $3d87fee47766823b$export$9dc4ecf953986f04);
$parcel$export(module.exports, "timerFlush", () => $3d87fee47766823b$export$d60154c1d7f3990e);
var $3d87fee47766823b$var$frame = 0, $3d87fee47766823b$var$timeout = 0, $3d87fee47766823b$var$interval = 0, $3d87fee47766823b$var$pokeDelay = 1000, $3d87fee47766823b$var$taskHead, $3d87fee47766823b$var$taskTail, $3d87fee47766823b$var$clockLast = 0, $3d87fee47766823b$var$clockNow = 0, $3d87fee47766823b$var$clockSkew = 0, $3d87fee47766823b$var$clock = typeof performance === "object" && performance.now ? performance : Date, $3d87fee47766823b$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $3d87fee47766823b$export$461939dd4422153() {
    return $3d87fee47766823b$var$clockNow || ($3d87fee47766823b$var$setFrame($3d87fee47766823b$var$clearNow), $3d87fee47766823b$var$clockNow = $3d87fee47766823b$var$clock.now() + $3d87fee47766823b$var$clockSkew);
}
function $3d87fee47766823b$var$clearNow() {
    $3d87fee47766823b$var$clockNow = 0;
}
function $3d87fee47766823b$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$3d87fee47766823b$export$c57e9b2d8b9e4de.prototype = $3d87fee47766823b$export$9dc4ecf953986f04.prototype = {
    constructor: $3d87fee47766823b$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $3d87fee47766823b$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $3d87fee47766823b$var$taskTail !== this) {
            if ($3d87fee47766823b$var$taskTail) $3d87fee47766823b$var$taskTail._next = this;
            else $3d87fee47766823b$var$taskHead = this;
            $3d87fee47766823b$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $3d87fee47766823b$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $3d87fee47766823b$var$sleep();
        }
    }
};
function $3d87fee47766823b$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $3d87fee47766823b$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $3d87fee47766823b$export$d60154c1d7f3990e() {
    $3d87fee47766823b$export$461939dd4422153(); // Get the current time, if not already set.
    ++$3d87fee47766823b$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $3d87fee47766823b$var$taskHead, e;
    while(t){
        if ((e = $3d87fee47766823b$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$3d87fee47766823b$var$frame;
}
function $3d87fee47766823b$var$wake() {
    $3d87fee47766823b$var$clockNow = ($3d87fee47766823b$var$clockLast = $3d87fee47766823b$var$clock.now()) + $3d87fee47766823b$var$clockSkew;
    $3d87fee47766823b$var$frame = $3d87fee47766823b$var$timeout = 0;
    try {
        $3d87fee47766823b$export$d60154c1d7f3990e();
    } finally{
        $3d87fee47766823b$var$frame = 0;
        $3d87fee47766823b$var$nap();
        $3d87fee47766823b$var$clockNow = 0;
    }
}
function $3d87fee47766823b$var$poke() {
    var now = $3d87fee47766823b$var$clock.now(), delay = now - $3d87fee47766823b$var$clockLast;
    if (delay > $3d87fee47766823b$var$pokeDelay) $3d87fee47766823b$var$clockSkew -= delay, $3d87fee47766823b$var$clockLast = now;
}
function $3d87fee47766823b$var$nap() {
    var t0, t1 = $3d87fee47766823b$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $3d87fee47766823b$var$taskHead = t2;
    }
    $3d87fee47766823b$var$taskTail = t0;
    $3d87fee47766823b$var$sleep(time);
}
function $3d87fee47766823b$var$sleep(time) {
    if ($3d87fee47766823b$var$frame) return; // Soonest alarm already set, or will be.
    if ($3d87fee47766823b$var$timeout) $3d87fee47766823b$var$timeout = clearTimeout($3d87fee47766823b$var$timeout);
    var delay = time - $3d87fee47766823b$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $3d87fee47766823b$var$timeout = setTimeout($3d87fee47766823b$var$wake, time - $3d87fee47766823b$var$clock.now() - $3d87fee47766823b$var$clockSkew);
        if ($3d87fee47766823b$var$interval) $3d87fee47766823b$var$interval = clearInterval($3d87fee47766823b$var$interval);
    } else {
        if (!$3d87fee47766823b$var$interval) $3d87fee47766823b$var$clockLast = $3d87fee47766823b$var$clock.now(), $3d87fee47766823b$var$interval = setInterval($3d87fee47766823b$var$poke, $3d87fee47766823b$var$pokeDelay);
        $3d87fee47766823b$var$frame = 1, $3d87fee47766823b$var$setFrame($3d87fee47766823b$var$wake);
    }
}

});





parcelRegister("h6AQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73f94db51dbe3f4$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");

var $22Bya = parcelRequire("22Bya");

var $5hwOF = parcelRequire("5hwOF");
var $c73f94db51dbe3f4$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $22Bya.cubicInOut)
};
function $c73f94db51dbe3f4$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $c73f94db51dbe3f4$var$defaultTiming.time = (0, $5hwOF.now)(), $c73f94db51dbe3f4$var$defaultTiming;
    }
    return timing;
}
function $c73f94db51dbe3f4$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $8lOOg.Transition)) id = name._id, name = name._name;
    else id = (0, $8lOOg.newId)(), (timing = $c73f94db51dbe3f4$var$defaultTiming).time = (0, $5hwOF.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $gx72e.default)(node, name, id, i, group, timing || $c73f94db51dbe3f4$var$inherit(node, id));
    }
    return new (0, $8lOOg.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("8lOOg", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $6147b2aa1cec151b$export$be58926105124dd4);
$parcel$export(module.exports, "default", () => $6147b2aa1cec151b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "newId", () => $6147b2aa1cec151b$export$9ffd10a3fbdc175b);

var $71I3e = parcelRequire("71I3e");

var $86bWk = parcelRequire("86bWk");

var $j0Usx = parcelRequire("j0Usx");

var $fqGOf = parcelRequire("fqGOf");

var $aB3mk = parcelRequire("aB3mk");

var $dDvSs = parcelRequire("dDvSs");

var $6KZCG = parcelRequire("6KZCG");

var $j10GM = parcelRequire("j10GM");

var $7ag9F = parcelRequire("7ag9F");

var $kVVA3 = parcelRequire("kVVA3");

var $dvPTX = parcelRequire("dvPTX");

var $8iK2g = parcelRequire("8iK2g");

var $1nELt = parcelRequire("1nELt");

var $14car = parcelRequire("14car");

var $64LGr = parcelRequire("64LGr");

var $dqcLv = parcelRequire("dqcLv");

var $bnHxX = parcelRequire("bnHxX");

var $8l6LB = parcelRequire("8l6LB");

var $fsQmP = parcelRequire("fsQmP");

var $allsl = parcelRequire("allsl");
var $6147b2aa1cec151b$var$id = 0;
function $6147b2aa1cec151b$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $6147b2aa1cec151b$export$2e2bcd8739ae039(name) {
    return (0, $71I3e.default)().transition(name);
}
function $6147b2aa1cec151b$export$9ffd10a3fbdc175b() {
    return ++$6147b2aa1cec151b$var$id;
}
var $6147b2aa1cec151b$var$selection_prototype = (0, $71I3e.default).prototype;
$6147b2aa1cec151b$export$be58926105124dd4.prototype = $6147b2aa1cec151b$export$2e2bcd8739ae039.prototype = {
    constructor: $6147b2aa1cec151b$export$be58926105124dd4,
    select: (0, $dvPTX.default),
    selectAll: (0, $8iK2g.default),
    filter: (0, $6KZCG.default),
    merge: (0, $j10GM.default),
    selection: (0, $1nELt.default),
    transition: (0, $8l6LB.default),
    call: $6147b2aa1cec151b$var$selection_prototype.call,
    nodes: $6147b2aa1cec151b$var$selection_prototype.nodes,
    node: $6147b2aa1cec151b$var$selection_prototype.node,
    size: $6147b2aa1cec151b$var$selection_prototype.size,
    empty: $6147b2aa1cec151b$var$selection_prototype.empty,
    each: $6147b2aa1cec151b$var$selection_prototype.each,
    on: (0, $7ag9F.default),
    attr: (0, $86bWk.default),
    attrTween: (0, $j0Usx.default),
    style: (0, $14car.default),
    styleTween: (0, $64LGr.default),
    text: (0, $dqcLv.default),
    textTween: (0, $bnHxX.default),
    remove: (0, $kVVA3.default),
    tween: (0, $fsQmP.default),
    delay: (0, $fqGOf.default),
    duration: (0, $aB3mk.default),
    ease: (0, $dDvSs.default),
    end: (0, $allsl.default)
};

});
parcelRegister("86bWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e58253cc65629d3$export$2e2bcd8739ae039);

var $i3tg2 = parcelRequire("i3tg2");

var $7UbnV = parcelRequire("7UbnV");

var $fsQmP = parcelRequire("fsQmP");

var $3JL3T = parcelRequire("3JL3T");
function $5e58253cc65629d3$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $5e58253cc65629d3$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $5e58253cc65629d3$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $5e58253cc65629d3$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $5e58253cc65629d3$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $5e58253cc65629d3$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $5e58253cc65629d3$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $7UbnV.default)(name), i = fullname === "transform" ? (0, $i3tg2.interpolateTransformSvg) : (0, $3JL3T.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $5e58253cc65629d3$var$attrFunctionNS : $5e58253cc65629d3$var$attrFunction)(fullname, i, (0, $fsQmP.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $5e58253cc65629d3$var$attrRemoveNS : $5e58253cc65629d3$var$attrRemove)(fullname) : (fullname.local ? $5e58253cc65629d3$var$attrConstantNS : $5e58253cc65629d3$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("i3tg2", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $d24f33c6f6939f6a$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $d24f33c6f6939f6a$export$da8cba906d64c082);

var $34azb = parcelRequire("34azb");

var $afoVi = parcelRequire("afoVi");
function $d24f33c6f6939f6a$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $34azb.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $34azb.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $34azb.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $34azb.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $34azb.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $34azb.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $d24f33c6f6939f6a$export$56bec7123bb3589a = $d24f33c6f6939f6a$var$interpolateTransform((0, $afoVi.parseCss), "px, ", "px)", "deg)");
var $d24f33c6f6939f6a$export$da8cba906d64c082 = $d24f33c6f6939f6a$var$interpolateTransform((0, $afoVi.parseSvg), ", ", ")", ")");

});
parcelRegister("afoVi", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $775ea34d03daa12d$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $775ea34d03daa12d$export$f9ef43f9a1d89a18);

var $7wwlt = parcelRequire("7wwlt");
var $775ea34d03daa12d$var$cssNode, $775ea34d03daa12d$var$cssRoot, $775ea34d03daa12d$var$cssView, $775ea34d03daa12d$var$svgNode;
function $775ea34d03daa12d$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $7wwlt.identity;
    if (!$775ea34d03daa12d$var$cssNode) $775ea34d03daa12d$var$cssNode = document.createElement("DIV"), $775ea34d03daa12d$var$cssRoot = document.documentElement, $775ea34d03daa12d$var$cssView = document.defaultView;
    $775ea34d03daa12d$var$cssNode.style.transform = value;
    value = $775ea34d03daa12d$var$cssView.getComputedStyle($775ea34d03daa12d$var$cssRoot.appendChild($775ea34d03daa12d$var$cssNode), null).getPropertyValue("transform");
    $775ea34d03daa12d$var$cssRoot.removeChild($775ea34d03daa12d$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $7wwlt.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $775ea34d03daa12d$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $7wwlt.identity;
    if (!$775ea34d03daa12d$var$svgNode) $775ea34d03daa12d$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $775ea34d03daa12d$var$svgNode.setAttribute("transform", value);
    if (!(value = $775ea34d03daa12d$var$svgNode.transform.baseVal.consolidate())) return 0, $7wwlt.identity;
    value = value.matrix;
    return (0, $7wwlt.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("7wwlt", function(module, exports) {

$parcel$export(module.exports, "identity", () => $57a49cb08f968769$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $57a49cb08f968769$export$2e2bcd8739ae039);
var $57a49cb08f968769$var$degrees = 180 / Math.PI;
var $57a49cb08f968769$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $57a49cb08f968769$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $57a49cb08f968769$var$degrees,
        skewX: Math.atan(skewX) * $57a49cb08f968769$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("fsQmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42217906e34a7a5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $b42217906e34a7a5$export$f78ce6ab10405d82);

var $gx72e = parcelRequire("gx72e");
function $b42217906e34a7a5$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b42217906e34a7a5$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b42217906e34a7a5$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $gx72e.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b42217906e34a7a5$var$tweenRemove : $b42217906e34a7a5$var$tweenFunction)(id, name, value));
}
function $b42217906e34a7a5$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $gx72e.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $gx72e.get)(node, id).value[name];
    };
}

});

parcelRegister("3JL3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8a1488a1229fb5$export$2e2bcd8739ae039);

var $7TBR2 = parcelRequire("7TBR2");

var $34azb = parcelRequire("34azb");
var $lap8T = parcelRequire("lap8T");
var $8rKaq = parcelRequire("8rKaq");
function $2b8a1488a1229fb5$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $34azb.default) : b instanceof (0, $7TBR2.default) ? (0, $lap8T.default) : (c = (0, $7TBR2.default)(b)) ? (b = c, $lap8T.default) : (0, $8rKaq.default))(a, b);
}

});


parcelRegister("j0Usx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd79d010a4c8efb5$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");
function $dd79d010a4c8efb5$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $dd79d010a4c8efb5$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $dd79d010a4c8efb5$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $dd79d010a4c8efb5$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $dd79d010a4c8efb5$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $dd79d010a4c8efb5$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $dd79d010a4c8efb5$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $7UbnV.default)(name);
    return this.tween(key, (fullname.local ? $dd79d010a4c8efb5$var$attrTweenNS : $dd79d010a4c8efb5$var$attrTween)(fullname, value));
}

});

parcelRegister("fqGOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ba7dce83d64446$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $b3ba7dce83d64446$var$delayFunction(id, value) {
    return function() {
        (0, $gx72e.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $b3ba7dce83d64446$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $gx72e.init)(this, id).delay = value;
    };
}
function $b3ba7dce83d64446$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $b3ba7dce83d64446$var$delayFunction : $b3ba7dce83d64446$var$delayConstant)(id, value)) : (0, $gx72e.get)(this.node(), id).delay;
}

});

parcelRegister("aB3mk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6ff7278dc27637$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $7b6ff7278dc27637$var$durationFunction(id, value) {
    return function() {
        (0, $gx72e.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $7b6ff7278dc27637$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $gx72e.set)(this, id).duration = value;
    };
}
function $7b6ff7278dc27637$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $7b6ff7278dc27637$var$durationFunction : $7b6ff7278dc27637$var$durationConstant)(id, value)) : (0, $gx72e.get)(this.node(), id).duration;
}

});

parcelRegister("dDvSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed7a50b52f9ec5f$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $9ed7a50b52f9ec5f$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $gx72e.set)(this, id).ease = value;
    };
}
function $9ed7a50b52f9ec5f$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($9ed7a50b52f9ec5f$var$easeConstant(id, value)) : (0, $gx72e.get)(this.node(), id).ease;
}

});

parcelRegister("6KZCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb6d700db7c69fc$export$2e2bcd8739ae039);

var $fVVXs = parcelRequire("fVVXs");

var $8lOOg = parcelRequire("8lOOg");
function $4eb6d700db7c69fc$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fVVXs.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $8lOOg.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("j10GM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7ea529e16d1e50$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");
function $dd7ea529e16d1e50$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $8lOOg.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("7ag9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5375ff9982ff8775$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $5375ff9982ff8775$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $5375ff9982ff8775$var$onFunction(id, name, listener) {
    var on0, on1, sit = $5375ff9982ff8775$var$start(name) ? (0, $gx72e.init) : (0, $gx72e.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $5375ff9982ff8775$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $gx72e.get)(this.node(), id).on.on(name) : this.each($5375ff9982ff8775$var$onFunction(id, name, listener));
}

});

parcelRegister("kVVA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d5cbd04340ac15$export$2e2bcd8739ae039);
function $f3d5cbd04340ac15$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $f3d5cbd04340ac15$export$2e2bcd8739ae039() {
    return this.on("end.remove", $f3d5cbd04340ac15$var$removeFunction(this._id));
}

});

parcelRegister("dvPTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d666e2bac3e636b$export$2e2bcd8739ae039);

var $lfS1Y = parcelRequire("lfS1Y");

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $9d666e2bac3e636b$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $lfS1Y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $gx72e.default)(subgroup[i], name, id, i, subgroup, (0, $gx72e.get)(node, id));
        }
    }
    return new (0, $8lOOg.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("8iK2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b3b6dd402a5a11$export$2e2bcd8739ae039);

var $eLBth = parcelRequire("eLBth");

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $60b3b6dd402a5a11$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $eLBth.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $gx72e.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $gx72e.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $8lOOg.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("1nELt", function(module, exports) {

$parcel$export(module.exports, "default", () => $10178f78754a35a3$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
var $10178f78754a35a3$var$Selection = (0, $71I3e.default).prototype.constructor;
function $10178f78754a35a3$export$2e2bcd8739ae039() {
    return new $10178f78754a35a3$var$Selection(this._groups, this._parents);
}

});

parcelRegister("14car", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c6f9a5802cc5750$export$2e2bcd8739ae039);

var $i3tg2 = parcelRequire("i3tg2");

var $7p4b3 = parcelRequire("7p4b3");

var $gx72e = parcelRequire("gx72e");

var $fsQmP = parcelRequire("fsQmP");

var $3JL3T = parcelRequire("3JL3T");
function $0c6f9a5802cc5750$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $7p4b3.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $0c6f9a5802cc5750$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $0c6f9a5802cc5750$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $0c6f9a5802cc5750$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $7p4b3.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $0c6f9a5802cc5750$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $0c6f9a5802cc5750$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $0c6f9a5802cc5750$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $i3tg2.interpolateTransformCss) : (0, $3JL3T.default);
    return value == null ? this.styleTween(name, $0c6f9a5802cc5750$var$styleNull(name, i)).on("end.style." + name, $0c6f9a5802cc5750$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $0c6f9a5802cc5750$var$styleFunction(name, i, (0, $fsQmP.tweenValue)(this, "style." + name, value))).each($0c6f9a5802cc5750$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $0c6f9a5802cc5750$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("64LGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c81abc7eeee1f9$export$2e2bcd8739ae039);
function $46c81abc7eeee1f9$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $46c81abc7eeee1f9$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $46c81abc7eeee1f9$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $46c81abc7eeee1f9$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $46c81abc7eeee1f9$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("dqcLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $02858ac2033469a6$export$2e2bcd8739ae039);

var $fsQmP = parcelRequire("fsQmP");
function $02858ac2033469a6$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $02858ac2033469a6$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $02858ac2033469a6$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $02858ac2033469a6$var$textFunction((0, $fsQmP.tweenValue)(this, "text", value)) : $02858ac2033469a6$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("bnHxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $84939f2669c0b99f$export$2e2bcd8739ae039);
function $84939f2669c0b99f$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $84939f2669c0b99f$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $84939f2669c0b99f$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $84939f2669c0b99f$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $84939f2669c0b99f$var$textTween(value));
}

});

parcelRegister("8l6LB", function(module, exports) {

$parcel$export(module.exports, "default", () => $612588a8d9c566b4$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $612588a8d9c566b4$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $8lOOg.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $gx72e.get)(node, id0);
            (0, $gx72e.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $8lOOg.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("allsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $787c824bbab868af$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $787c824bbab868af$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $gx72e.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}

});


parcelRegister("22Bya", function(module, exports) {

$parcel$export(module.exports, "cubicIn", () => $17c8e550f30a6519$export$b1a09cb1b71f86aa);
$parcel$export(module.exports, "cubicOut", () => $17c8e550f30a6519$export$68d528839c701b6);
$parcel$export(module.exports, "cubicInOut", () => $17c8e550f30a6519$export$89238d3bc79d3ada);
function $17c8e550f30a6519$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $17c8e550f30a6519$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $17c8e550f30a6519$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("k7Z5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea73da68e524b250$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
var $ea73da68e524b250$var$root = [
    null
];
function $ea73da68e524b250$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $gx72e.SCHEDULED) && schedule.name === name) return new (0, $8lOOg.Transition)([
                [
                    node
                ]
            ], $ea73da68e524b250$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("fEIkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65cfb54224253c8$export$2e2bcd8739ae039);
function $b65cfb54224253c8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("ciUFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f531f65ca062591$export$2e2bcd8739ae039);
function $8f531f65ca062591$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}

});

parcelRegister("etb7C", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $a88c66af784fe81e$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $a88c66af784fe81e$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $a88c66af784fe81e$export$2e2561858db9bf47() {
    (0, $cdh1A.event).stopImmediatePropagation();
}
function $a88c66af784fe81e$export$2e2bcd8739ae039() {
    (0, $cdh1A.event).preventDefault();
    (0, $cdh1A.event).stopImmediatePropagation();
}

});



parcelRegister("4s7WH", function(module, exports) {

$parcel$export(module.exports, "chord", () => (parcelRequire("lHhtK")).default);
$parcel$export(module.exports, "ribbon", () => (parcelRequire("FtZNm")).default);

var $lHhtK = parcelRequire("lHhtK");

var $FtZNm = parcelRequire("FtZNm");

});
parcelRegister("lHhtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcbb2c08a5df4a3f$export$2e2bcd8739ae039);
parcelRequire("kRV0S");
var $fVvRk = parcelRequire("fVvRk");

var $2n87f = parcelRequire("2n87f");
function $fcbb2c08a5df4a3f$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $fcbb2c08a5df4a3f$export$2e2bcd8739ae039() {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = [], groupIndex = (0, $fVvRk.default)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
        // Compute the sum.
        k = 0, i = -1;
        while(++i < n){
            x = 0, j = -1;
            while(++j < n)x += matrix[i][j];
            groupSums.push(x);
            subgroupIndex.push((0, $fVvRk.default)(n));
            k += x;
        }
        // Sort groups…
        if (sortGroups) groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
        });
        // Sort subgroups…
        if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
        });
        // Convert the sum to scaling factor for [0, 2pi].
        // TODO Allow start and end angle to be specified?
        // TODO Allow padding to be specified as percentage?
        k = (0, $2n87f.max)(0, (0, $2n87f.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, $2n87f.tau) / n;
        // Compute the start and end angle for each group and subgroup.
        // Note: Opera has a bug reordering object literal properties!
        x = 0, i = -1;
        while(++i < n){
            x0 = x, j = -1;
            while(++j < n){
                var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                subgroups[dj * n + di] = {
                    index: di,
                    subindex: dj,
                    startAngle: a0,
                    endAngle: a1,
                    value: v
                };
            }
            groups[di] = {
                index: di,
                startAngle: x0,
                endAngle: x,
                value: groupSums[di]
            };
            x += dx;
        }
        // Generate chords for each (non-empty) subgroup-subgroup link.
        i = -1;
        while(++i < n){
            j = i - 1;
            while(++j < n){
                var source = subgroups[j * n + i], target = subgroups[i * n + j];
                if (source.value || target.value) chords.push(source.value < target.value ? {
                    source: target,
                    target: source
                } : {
                    source: source,
                    target: target
                });
            }
        }
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $2n87f.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $fcbb2c08a5df4a3f$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

});
parcelRegister("kRV0S", function(module, exports) {

$parcel$export(module.exports, "range", () => (parcelRequire("fVvRk")).default);

var $l08sl = parcelRequire("l08sl");

var $f2PEm = parcelRequire("f2PEm");

var $iQRN3 = parcelRequire("iQRN3");

var $8DCk6 = parcelRequire("8DCk6");

var $4Eovr = parcelRequire("4Eovr");

var $eltqY = parcelRequire("eltqY");

var $5wWrP = parcelRequire("5wWrP");

var $2zdQM = parcelRequire("2zdQM");

var $3CshV = parcelRequire("3CshV");

var $eGUx4 = parcelRequire("eGUx4");

var $iGFIk = parcelRequire("iGFIk");

var $jCgQX = parcelRequire("jCgQX");

var $55eUz = parcelRequire("55eUz");

var $f8kqd = parcelRequire("f8kqd");

var $k2HYg = parcelRequire("k2HYg");

var $eWP0j = parcelRequire("eWP0j");

var $d7fUF = parcelRequire("d7fUF");

var $3xkOT = parcelRequire("3xkOT");

var $1VJBh = parcelRequire("1VJBh");

var $fVvRk = parcelRequire("fVvRk");

var $eqmB7 = parcelRequire("eqmB7");

var $8rNAL = parcelRequire("8rNAL");

var $akOoL = parcelRequire("akOoL");

var $cl8O7 = parcelRequire("cl8O7");

var $jOaFW = parcelRequire("jOaFW");

var $gOyT9 = parcelRequire("gOyT9");

var $7VYqe = parcelRequire("7VYqe");

});
parcelRegister("l08sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a0284943ec4882$export$2e2bcd8739ae039);

var $f2PEm = parcelRequire("f2PEm");

var $iQRN3 = parcelRequire("iQRN3");
var $f4a0284943ec4882$var$ascendingBisect = (0, $iQRN3.default)((0, $f2PEm.default));
var $f4a0284943ec4882$export$4d945ad3ad5751b0 = $f4a0284943ec4882$var$ascendingBisect.right;
var $f4a0284943ec4882$export$df7d25c84ebd12a5 = $f4a0284943ec4882$var$ascendingBisect.left;
var $f4a0284943ec4882$export$2e2bcd8739ae039 = $f4a0284943ec4882$export$4d945ad3ad5751b0;

});
parcelRegister("f2PEm", function(module, exports) {

$parcel$export(module.exports, "default", () => $af3f1b8551ee54d0$export$2e2bcd8739ae039);
function $af3f1b8551ee54d0$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("iQRN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $db96cef1f473e33e$export$2e2bcd8739ae039);

var $f2PEm = parcelRequire("f2PEm");
function $db96cef1f473e33e$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $db96cef1f473e33e$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $db96cef1f473e33e$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $f2PEm.default)(f(d), x);
    };
}

});


parcelRegister("8DCk6", function(module, exports) {

var $d7fUF = parcelRequire("d7fUF");
function $649fb175b8d36965$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $d7fUF.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("d7fUF", function(module, exports) {

$parcel$export(module.exports, "pair", () => $98c845cf5fe8f64d$export$a04cb3fe8b81dd);
function $98c845cf5fe8f64d$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $98c845cf5fe8f64d$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $98c845cf5fe8f64d$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("4Eovr", function(module, exports) {
function $362de841474ee31c$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("eltqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a719dbd1faf3cbb2$export$2e2bcd8739ae039);

var $gOyT9 = parcelRequire("gOyT9");
function $a719dbd1faf3cbb2$export$2e2bcd8739ae039(array, f) {
    var v = (0, $gOyT9.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("gOyT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3dc60f87703bcdc$export$2e2bcd8739ae039);

var $YEF5X = parcelRequire("YEF5X");
function $c3dc60f87703bcdc$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("YEF5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b65254d5eaedba0$export$2e2bcd8739ae039);
function $0b65254d5eaedba0$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("5wWrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $406d47731800ec71$export$2e2bcd8739ae039);
function $406d47731800ec71$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("2zdQM", function(module, exports) {

var $hBe1v = parcelRequire("hBe1v");

var $l08sl = parcelRequire("l08sl");

var $a0acQ = parcelRequire("a0acQ");

var $5wWrP = parcelRequire("5wWrP");

var $aLbSE = parcelRequire("aLbSE");

var $fVvRk = parcelRequire("fVvRk");

var $cl8O7 = parcelRequire("cl8O7");

var $iGFIk = parcelRequire("iGFIk");
function $1de9980ce03de604$export$2e2bcd8739ae039() {
    var value = (0, $aLbSE.default), domain = (0, $5wWrP.default), threshold = (0, $iGFIk.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $cl8O7.tickStep)(x0, x1, tz);
            tz = (0, $fVvRk.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $l08sl.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $a0acQ.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $a0acQ.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $a0acQ.default)((0, $hBe1v.slice).call(_)) : (0, $a0acQ.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("hBe1v", function(module, exports) {

$parcel$export(module.exports, "slice", () => $cd00c51881840a02$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $cd00c51881840a02$export$871de8747c9eaa88);
var $cd00c51881840a02$var$array = Array.prototype;
var $cd00c51881840a02$export$58adb3bec8346d0f = $cd00c51881840a02$var$array.slice;
var $cd00c51881840a02$export$871de8747c9eaa88 = $cd00c51881840a02$var$array.map;

});

parcelRegister("a0acQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7481d23410ac8613$export$2e2bcd8739ae039);
function $7481d23410ac8613$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("aLbSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d57825f81b8fd30$export$2e2bcd8739ae039);
function $7d57825f81b8fd30$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("fVvRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b984e4759055eb60$export$2e2bcd8739ae039);
function $b984e4759055eb60$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("cl8O7", function(module, exports) {

$parcel$export(module.exports, "tickStep", () => $8fbe4728a9fb60ee$export$81087d9b915d4ede);
var $8fbe4728a9fb60ee$var$e10 = Math.sqrt(50), $8fbe4728a9fb60ee$var$e5 = Math.sqrt(10), $8fbe4728a9fb60ee$var$e2 = Math.sqrt(2);
function $8fbe4728a9fb60ee$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $8fbe4728a9fb60ee$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $8fbe4728a9fb60ee$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $8fbe4728a9fb60ee$var$e10 ? 10 : error >= $8fbe4728a9fb60ee$var$e5 ? 5 : error >= $8fbe4728a9fb60ee$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $8fbe4728a9fb60ee$var$e10 ? 10 : error >= $8fbe4728a9fb60ee$var$e5 ? 5 : error >= $8fbe4728a9fb60ee$var$e2 ? 2 : 1);
}
function $8fbe4728a9fb60ee$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $8fbe4728a9fb60ee$var$e10) step1 *= 10;
    else if (error >= $8fbe4728a9fb60ee$var$e5) step1 *= 5;
    else if (error >= $8fbe4728a9fb60ee$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("iGFIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ac81c6d61303c7$export$2e2bcd8739ae039);
function $d9ac81c6d61303c7$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("3CshV", function(module, exports) {

var $hBe1v = parcelRequire("hBe1v");

var $f2PEm = parcelRequire("f2PEm");

var $YEF5X = parcelRequire("YEF5X");

var $1VJBh = parcelRequire("1VJBh");
function $2a2add1ee6698bc0$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $hBe1v.map).call(values, (0, $YEF5X.default)).sort((0, $f2PEm.default));
    return Math.ceil((max - min) / (2 * ((0, $1VJBh.default)(values, 0.75) - (0, $1VJBh.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("1VJBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $167e7c97e78e1244$export$2e2bcd8739ae039);

var $YEF5X = parcelRequire("YEF5X");
function $167e7c97e78e1244$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $YEF5X.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("eGUx4", function(module, exports) {

var $eltqY = parcelRequire("eltqY");
function $ab20d717a3c1d960$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $eltqY.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("jCgQX", function(module, exports) {
function $e47ea3a30e10637e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("55eUz", function(module, exports) {

var $YEF5X = parcelRequire("YEF5X");
function $3b38fc75f4d19442$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("f8kqd", function(module, exports) {

var $f2PEm = parcelRequire("f2PEm");

var $YEF5X = parcelRequire("YEF5X");

var $1VJBh = parcelRequire("1VJBh");
function $b04771b957a3f0dc$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $YEF5X.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $1VJBh.default)(numbers.sort((0, $f2PEm.default)), 0.5);
}

});

parcelRegister("k2HYg", function(module, exports) {
function $e9761a4ae35e4ee0$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("eWP0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1e0bcb1ab8cbd0$export$2e2bcd8739ae039);
function $ae1e0bcb1ab8cbd0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("3xkOT", function(module, exports) {
function $29349a92f8d0ad65$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("eqmB7", function(module, exports) {

var $f2PEm = parcelRequire("f2PEm");
function $a80505d72a2e08f1$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $f2PEm.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("8rNAL", function(module, exports) {
function $626750437cb01265$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("akOoL", function(module, exports) {
function $7862ddbc4a525f7b$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("jOaFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6baf7beb6cccb77$export$2e2bcd8739ae039);

var $eWP0j = parcelRequire("eWP0j");
function $e6baf7beb6cccb77$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $eWP0j.default)(matrix, $e6baf7beb6cccb77$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $e6baf7beb6cccb77$var$length(d) {
    return d.length;
}

});

parcelRegister("7VYqe", function(module, exports) {

var $jOaFW = parcelRequire("jOaFW");
function $5c6cb9d7c2259c23$export$2e2bcd8739ae039() {
    return (0, $jOaFW.default)(arguments);
}

});


parcelRegister("2n87f", function(module, exports) {

$parcel$export(module.exports, "cos", () => $1ba40662afeb0313$export$50d414a77b60d802);
$parcel$export(module.exports, "sin", () => $1ba40662afeb0313$export$5de3937cb4b592ed);
$parcel$export(module.exports, "halfPi", () => $1ba40662afeb0313$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $1ba40662afeb0313$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "max", () => $1ba40662afeb0313$export$8960430cfd85939f);
var $1ba40662afeb0313$export$50d414a77b60d802 = Math.cos;
var $1ba40662afeb0313$export$5de3937cb4b592ed = Math.sin;
var $1ba40662afeb0313$export$18c7bea995a110f = Math.PI;
var $1ba40662afeb0313$export$e51408a300e8929a = $1ba40662afeb0313$export$18c7bea995a110f / 2;
var $1ba40662afeb0313$export$a4b4b4d4d776fe92 = $1ba40662afeb0313$export$18c7bea995a110f * 2;
var $1ba40662afeb0313$export$8960430cfd85939f = Math.max;

});


parcelRegister("FtZNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $07cb18f85f16151a$export$2e2bcd8739ae039);

var $7jFn0 = parcelRequire("7jFn0");

var $2ffXl = parcelRequire("2ffXl");

var $2n87f = parcelRequire("2n87f");

var $176ah = parcelRequire("176ah");
function $07cb18f85f16151a$var$defaultSource(d) {
    return d.source;
}
function $07cb18f85f16151a$var$defaultTarget(d) {
    return d.target;
}
function $07cb18f85f16151a$var$defaultRadius(d) {
    return d.radius;
}
function $07cb18f85f16151a$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $07cb18f85f16151a$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $07cb18f85f16151a$export$2e2bcd8739ae039() {
    var source = $07cb18f85f16151a$var$defaultSource, target = $07cb18f85f16151a$var$defaultTarget, radius = $07cb18f85f16151a$var$defaultRadius, startAngle = $07cb18f85f16151a$var$defaultStartAngle, endAngle = $07cb18f85f16151a$var$defaultEndAngle, context = null;
    function ribbon() {
        var buffer, argv = (0, $7jFn0.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $2n87f.halfPi), sa1 = endAngle.apply(this, argv) - (0, $2n87f.halfPi), sx0 = sr * (0, $2n87f.cos)(sa0), sy0 = sr * (0, $2n87f.sin)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $2n87f.halfPi), ta1 = endAngle.apply(this, argv) - (0, $2n87f.halfPi);
        if (!context) context = buffer = (0, $176ah.default)();
        context.moveTo(sx0, sy0);
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            context.quadraticCurveTo(0, 0, tr * (0, $2n87f.cos)(ta0), tr * (0, $2n87f.sin)(ta0));
            context.arc(0, 0, tr, ta0, ta1);
        }
        context.quadraticCurveTo(0, 0, sx0, sy0);
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    ribbon.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $2ffXl.default)(+_), ribbon) : radius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2ffXl.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2ffXl.default)(+_), ribbon) : endAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}

});
parcelRegister("7jFn0", function(module, exports) {

$parcel$export(module.exports, "slice", () => $553a6602aa45bfa1$export$58adb3bec8346d0f);
var $553a6602aa45bfa1$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("2ffXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a295c0b28f87ff8$export$2e2bcd8739ae039);
function $1a295c0b28f87ff8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("176ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfb3a1425ae275c$export$2e2bcd8739ae039);
var $0cfb3a1425ae275c$var$pi = Math.PI, $0cfb3a1425ae275c$var$tau = 2 * $0cfb3a1425ae275c$var$pi, $0cfb3a1425ae275c$var$epsilon = 1e-6, $0cfb3a1425ae275c$var$tauEpsilon = $0cfb3a1425ae275c$var$tau - $0cfb3a1425ae275c$var$epsilon;
function $0cfb3a1425ae275c$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $0cfb3a1425ae275c$var$path() {
    return new $0cfb3a1425ae275c$var$Path;
}
$0cfb3a1425ae275c$var$Path.prototype = $0cfb3a1425ae275c$var$path.prototype = {
    constructor: $0cfb3a1425ae275c$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $0cfb3a1425ae275c$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $0cfb3a1425ae275c$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($0cfb3a1425ae275c$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $0cfb3a1425ae275c$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $0cfb3a1425ae275c$var$epsilon || Math.abs(this._y1 - y0) > $0cfb3a1425ae275c$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $0cfb3a1425ae275c$var$tau + $0cfb3a1425ae275c$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $0cfb3a1425ae275c$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $0cfb3a1425ae275c$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $0cfb3a1425ae275c$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $0cfb3a1425ae275c$export$2e2bcd8739ae039 = $0cfb3a1425ae275c$var$path;

});



parcelRegister("gz1Te", function(module, exports) {

$parcel$export(module.exports, "nest", () => (parcelRequire("glRO0")).default);
$parcel$export(module.exports, "set", () => (parcelRequire("27fQJ")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("5Mltl")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("3EC4g")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("iI00m")).default);
$parcel$export(module.exports, "entries", () => (parcelRequire("5XG0I")).default);

var $glRO0 = parcelRequire("glRO0");

var $27fQJ = parcelRequire("27fQJ");

var $5Mltl = parcelRequire("5Mltl");

var $3EC4g = parcelRequire("3EC4g");

var $iI00m = parcelRequire("iI00m");

var $5XG0I = parcelRequire("5XG0I");

});
parcelRegister("glRO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $be78582de6c6a367$export$2e2bcd8739ae039);

var $5Mltl = parcelRequire("5Mltl");
function $be78582de6c6a367$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $5Mltl.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $be78582de6c6a367$var$createObject, $be78582de6c6a367$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $be78582de6c6a367$var$createMap, $be78582de6c6a367$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $be78582de6c6a367$var$createMap, $be78582de6c6a367$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $be78582de6c6a367$var$createObject() {
    return {};
}
function $be78582de6c6a367$var$setObject(object, key, value) {
    object[key] = value;
}
function $be78582de6c6a367$var$createMap() {
    return (0, $5Mltl.default)();
}
function $be78582de6c6a367$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("5Mltl", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $43521769693521bb$export$82e9f45cca5ba907);
$parcel$export(module.exports, "default", () => $43521769693521bb$export$2e2bcd8739ae039);
var $43521769693521bb$export$82e9f45cca5ba907 = "$";
function $43521769693521bb$var$Map() {}
$43521769693521bb$var$Map.prototype = $43521769693521bb$var$map.prototype = {
    constructor: $43521769693521bb$var$Map,
    has: function(key) {
        return $43521769693521bb$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$43521769693521bb$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$43521769693521bb$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $43521769693521bb$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $43521769693521bb$var$map(object, f) {
    var map = new $43521769693521bb$var$Map;
    // Copy constructor.
    if (object instanceof $43521769693521bb$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $43521769693521bb$export$2e2bcd8739ae039 = $43521769693521bb$var$map;

});


parcelRegister("27fQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a8879a950ce9b8$export$2e2bcd8739ae039);

var $5Mltl = parcelRequire("5Mltl");
function $18a8879a950ce9b8$var$Set() {}
var $18a8879a950ce9b8$var$proto = (0, $5Mltl.default).prototype;
$18a8879a950ce9b8$var$Set.prototype = $18a8879a950ce9b8$var$set.prototype = {
    constructor: $18a8879a950ce9b8$var$Set,
    has: $18a8879a950ce9b8$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $5Mltl.prefix) + value] = value;
        return this;
    },
    remove: $18a8879a950ce9b8$var$proto.remove,
    clear: $18a8879a950ce9b8$var$proto.clear,
    values: $18a8879a950ce9b8$var$proto.keys,
    size: $18a8879a950ce9b8$var$proto.size,
    empty: $18a8879a950ce9b8$var$proto.empty,
    each: $18a8879a950ce9b8$var$proto.each
};
function $18a8879a950ce9b8$var$set(object, f) {
    var set = new $18a8879a950ce9b8$var$Set;
    // Copy constructor.
    if (object instanceof $18a8879a950ce9b8$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $18a8879a950ce9b8$export$2e2bcd8739ae039 = $18a8879a950ce9b8$var$set;

});

parcelRegister("3EC4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a92a2fea54d6c89$export$2e2bcd8739ae039);
function $2a92a2fea54d6c89$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("iI00m", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ec57042712cf33$export$2e2bcd8739ae039);
function $d9ec57042712cf33$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("5XG0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $45730cddb299af25$export$2e2bcd8739ae039);
function $45730cddb299af25$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});


parcelRegister("6xhCH", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("7K0RM")).default);
$parcel$export(module.exports, "rgb", () => (parcelRequire("7K0RM")).rgb);
$parcel$export(module.exports, "hsl", () => (parcelRequire("7K0RM")).hsl);
$parcel$export(module.exports, "lab", () => (parcelRequire("5kDrv")).default);
$parcel$export(module.exports, "hcl", () => (parcelRequire("5kDrv")).hcl);
$parcel$export(module.exports, "lch", () => (parcelRequire("5kDrv")).lch);
$parcel$export(module.exports, "gray", () => (parcelRequire("5kDrv")).gray);
$parcel$export(module.exports, "cubehelix", () => (parcelRequire("8KiXt")).default);

var $7K0RM = parcelRequire("7K0RM");

var $5kDrv = parcelRequire("5kDrv");

var $8KiXt = parcelRequire("8KiXt");

});
parcelRegister("7K0RM", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $7driR = parcelRequire("7driR");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $7driR.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7driR.default)(Rgb, rgb, (0, $7driR.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $7driR.default)(Hsl, hsl, (0, $7driR.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("7driR", function(module, exports) {

$parcel$export(module.exports, "default", () => $540eed24bd7a7808$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $540eed24bd7a7808$export$8b58be045bf06082);
function $540eed24bd7a7808$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $540eed24bd7a7808$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("5kDrv", function(module, exports) {

$parcel$export(module.exports, "gray", () => $3e1d6a8529f218d9$export$3e2c219d3ab79d01);
$parcel$export(module.exports, "default", () => $3e1d6a8529f218d9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "lch", () => $3e1d6a8529f218d9$export$5a21418738164530);
$parcel$export(module.exports, "hcl", () => $3e1d6a8529f218d9$export$d0e870ba50062ff1);

var $7driR = parcelRequire("7driR");

var $7K0RM = parcelRequire("7K0RM");

var $31pY0 = parcelRequire("31pY0");
// https://observablehq.com/@mbostock/lab-and-rgb
var $3e1d6a8529f218d9$var$K = 18, $3e1d6a8529f218d9$var$Xn = 0.96422, $3e1d6a8529f218d9$var$Yn = 1, $3e1d6a8529f218d9$var$Zn = 0.82521, $3e1d6a8529f218d9$var$t0 = 4 / 29, $3e1d6a8529f218d9$var$t1 = 6 / 29, $3e1d6a8529f218d9$var$t2 = 3 * $3e1d6a8529f218d9$var$t1 * $3e1d6a8529f218d9$var$t1, $3e1d6a8529f218d9$var$t3 = $3e1d6a8529f218d9$var$t1 * $3e1d6a8529f218d9$var$t1 * $3e1d6a8529f218d9$var$t1;
function $3e1d6a8529f218d9$var$labConvert(o) {
    if (o instanceof $3e1d6a8529f218d9$export$f2722c70a60257f7) return new $3e1d6a8529f218d9$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $3e1d6a8529f218d9$export$d9397e094a5fbb9a) return $3e1d6a8529f218d9$var$hcl2lab(o);
    if (!(o instanceof (0, $7K0RM.Rgb))) o = (0, $7K0RM.rgbConvert)(o);
    var r = $3e1d6a8529f218d9$var$rgb2lrgb(o.r), g = $3e1d6a8529f218d9$var$rgb2lrgb(o.g), b = $3e1d6a8529f218d9$var$rgb2lrgb(o.b), y = $3e1d6a8529f218d9$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $3e1d6a8529f218d9$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $3e1d6a8529f218d9$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $3e1d6a8529f218d9$var$Xn);
        z = $3e1d6a8529f218d9$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $3e1d6a8529f218d9$var$Zn);
    }
    return new $3e1d6a8529f218d9$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $3e1d6a8529f218d9$export$3e2c219d3ab79d01(l, opacity) {
    return new $3e1d6a8529f218d9$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $3e1d6a8529f218d9$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $3e1d6a8529f218d9$var$labConvert(l) : new $3e1d6a8529f218d9$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $3e1d6a8529f218d9$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7driR.default)($3e1d6a8529f218d9$export$f2722c70a60257f7, $3e1d6a8529f218d9$export$2e2bcd8739ae039, (0, $7driR.extend)((0, $7K0RM.Color), {
    brighter: function(k) {
        return new $3e1d6a8529f218d9$export$f2722c70a60257f7(this.l + $3e1d6a8529f218d9$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $3e1d6a8529f218d9$export$f2722c70a60257f7(this.l - $3e1d6a8529f218d9$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $3e1d6a8529f218d9$var$Xn * $3e1d6a8529f218d9$var$lab2xyz(x);
        y = $3e1d6a8529f218d9$var$Yn * $3e1d6a8529f218d9$var$lab2xyz(y);
        z = $3e1d6a8529f218d9$var$Zn * $3e1d6a8529f218d9$var$lab2xyz(z);
        return new (0, $7K0RM.Rgb)($3e1d6a8529f218d9$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $3e1d6a8529f218d9$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $3e1d6a8529f218d9$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $3e1d6a8529f218d9$var$xyz2lab(t) {
    return t > $3e1d6a8529f218d9$var$t3 ? Math.pow(t, 1 / 3) : t / $3e1d6a8529f218d9$var$t2 + $3e1d6a8529f218d9$var$t0;
}
function $3e1d6a8529f218d9$var$lab2xyz(t) {
    return t > $3e1d6a8529f218d9$var$t1 ? t * t * t : $3e1d6a8529f218d9$var$t2 * (t - $3e1d6a8529f218d9$var$t0);
}
function $3e1d6a8529f218d9$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $3e1d6a8529f218d9$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $3e1d6a8529f218d9$var$hclConvert(o) {
    if (o instanceof $3e1d6a8529f218d9$export$d9397e094a5fbb9a) return new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $3e1d6a8529f218d9$export$f2722c70a60257f7)) o = $3e1d6a8529f218d9$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $31pY0.rad2deg);
    return new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $3e1d6a8529f218d9$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $3e1d6a8529f218d9$var$hclConvert(l) : new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $3e1d6a8529f218d9$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $3e1d6a8529f218d9$var$hclConvert(h) : new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $3e1d6a8529f218d9$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $3e1d6a8529f218d9$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $3e1d6a8529f218d9$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $31pY0.deg2rad);
    return new $3e1d6a8529f218d9$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $7driR.default)($3e1d6a8529f218d9$export$d9397e094a5fbb9a, $3e1d6a8529f218d9$export$d0e870ba50062ff1, (0, $7driR.extend)((0, $7K0RM.Color), {
    brighter: function(k) {
        return new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(this.h, this.c, this.l + $3e1d6a8529f218d9$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $3e1d6a8529f218d9$export$d9397e094a5fbb9a(this.h, this.c, this.l - $3e1d6a8529f218d9$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $3e1d6a8529f218d9$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("31pY0", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $23359b97061a96a3$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $23359b97061a96a3$export$b2ba2578f2c43d74);
var $23359b97061a96a3$export$b1b275608b2b1b8 = Math.PI / 180;
var $23359b97061a96a3$export$b2ba2578f2c43d74 = 180 / Math.PI;

});


parcelRegister("8KiXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e15351cc889394$export$2e2bcd8739ae039);

var $7driR = parcelRequire("7driR");

var $7K0RM = parcelRequire("7K0RM");

var $31pY0 = parcelRequire("31pY0");
var $65e15351cc889394$var$A = -0.14861, $65e15351cc889394$var$B = 1.78277, $65e15351cc889394$var$C = -0.29227, $65e15351cc889394$var$D = -0.90649, $65e15351cc889394$var$E = 1.97294, $65e15351cc889394$var$ED = $65e15351cc889394$var$E * $65e15351cc889394$var$D, $65e15351cc889394$var$EB = $65e15351cc889394$var$E * $65e15351cc889394$var$B, $65e15351cc889394$var$BC_DA = $65e15351cc889394$var$B * $65e15351cc889394$var$C - $65e15351cc889394$var$D * $65e15351cc889394$var$A;
function $65e15351cc889394$var$cubehelixConvert(o) {
    if (o instanceof $65e15351cc889394$export$57ed4bde61a1e2f2) return new $65e15351cc889394$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $7K0RM.Rgb))) o = (0, $7K0RM.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($65e15351cc889394$var$BC_DA * b + $65e15351cc889394$var$ED * r - $65e15351cc889394$var$EB * g) / ($65e15351cc889394$var$BC_DA + $65e15351cc889394$var$ED - $65e15351cc889394$var$EB), bl = b - l, k = ($65e15351cc889394$var$E * (g - l) - $65e15351cc889394$var$C * bl) / $65e15351cc889394$var$D, s = Math.sqrt(k * k + bl * bl) / ($65e15351cc889394$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $31pY0.rad2deg) - 120 : NaN;
    return new $65e15351cc889394$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $65e15351cc889394$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $65e15351cc889394$var$cubehelixConvert(h) : new $65e15351cc889394$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $65e15351cc889394$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $7driR.default)($65e15351cc889394$export$57ed4bde61a1e2f2, $65e15351cc889394$export$2e2bcd8739ae039, (0, $7driR.extend)((0, $7K0RM.Color), {
    brighter: function(k) {
        k = k == null ? (0, $7K0RM.brighter) : Math.pow((0, $7K0RM.brighter), k);
        return new $65e15351cc889394$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $7K0RM.darker) : Math.pow((0, $7K0RM.darker), k);
        return new $65e15351cc889394$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $31pY0.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $7K0RM.Rgb)(255 * (l + a * ($65e15351cc889394$var$A * cosh + $65e15351cc889394$var$B * sinh)), 255 * (l + a * ($65e15351cc889394$var$C * cosh + $65e15351cc889394$var$D * sinh)), 255 * (l + a * ($65e15351cc889394$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("5kU6m", function(module, exports) {

$parcel$export(module.exports, "contours", () => (parcelRequire("6LTg0")).default);
$parcel$export(module.exports, "contourDensity", () => (parcelRequire("6FOtT")).default);

var $6LTg0 = parcelRequire("6LTg0");

var $6FOtT = parcelRequire("6FOtT");

});
parcelRegister("6LTg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee1fecbcd7827ef$export$2e2bcd8739ae039);
parcelRequire("8qmD5");
var $7vAcD = parcelRequire("7vAcD");
var $g4YVZ = parcelRequire("g4YVZ");
var $aHgyR = parcelRequire("aHgyR");
var $jmphu = parcelRequire("jmphu");

var $hwbq9 = parcelRequire("hwbq9");

var $vk0Xw = parcelRequire("vk0Xw");

var $gTeRH = parcelRequire("gTeRH");

var $68dxl = parcelRequire("68dxl");

var $den4k = parcelRequire("den4k");

var $lTaPK = parcelRequire("lTaPK");
var $4ee1fecbcd7827ef$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $4ee1fecbcd7827ef$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $aHgyR.default), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var domain = (0, $7vAcD.default)(values), start = domain[0], stop = domain[1];
            tz = (0, $jmphu.tickStep)(start, stop, tz);
            tz = (0, $g4YVZ.default)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
        } else tz = tz.slice().sort((0, $vk0Xw.default));
        return tz.map(function(value) {
            return contour(values, value);
        });
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $gTeRH.default)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $den4k.default)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $4ee1fecbcd7827ef$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $4ee1fecbcd7827ef$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $4ee1fecbcd7827ef$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $4ee1fecbcd7827ef$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $4ee1fecbcd7827ef$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $4ee1fecbcd7827ef$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $4ee1fecbcd7827ef$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $4ee1fecbcd7827ef$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $4ee1fecbcd7827ef$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $68dxl.default)((0, $hwbq9.slice).call(_)) : (0, $68dxl.default)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $lTaPK.default), contours) : smooth === smoothLinear;
    };
    return contours;
}

});
parcelRegister("8qmD5", function(module, exports) {

$parcel$export(module.exports, "extent", () => (parcelRequire("7vAcD")).default);
$parcel$export(module.exports, "thresholdSturges", () => (parcelRequire("aHgyR")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("KpPuy")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("g4YVZ")).default);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("jmphu")).tickStep);

var $cwZCH = parcelRequire("cwZCH");

var $ikXK9 = parcelRequire("ikXK9");

var $1hA0I = parcelRequire("1hA0I");

var $2FKxn = parcelRequire("2FKxn");

var $h7Ue2 = parcelRequire("h7Ue2");

var $2uDpI = parcelRequire("2uDpI");

var $7vAcD = parcelRequire("7vAcD");

var $9EYaC = parcelRequire("9EYaC");

var $4577G = parcelRequire("4577G");

var $6YZeN = parcelRequire("6YZeN");

var $aHgyR = parcelRequire("aHgyR");

var $KpPuy = parcelRequire("KpPuy");

var $4yfeG = parcelRequire("4yfeG");

var $l1gm2 = parcelRequire("l1gm2");

var $aXvHU = parcelRequire("aXvHU");

var $kAZFv = parcelRequire("kAZFv");

var $EjaQz = parcelRequire("EjaQz");

var $j7ztS = parcelRequire("j7ztS");

var $dAnXI = parcelRequire("dAnXI");

var $g4YVZ = parcelRequire("g4YVZ");

var $fgOxt = parcelRequire("fgOxt");

var $lNlBs = parcelRequire("lNlBs");

var $7FxEL = parcelRequire("7FxEL");

var $jmphu = parcelRequire("jmphu");

var $iow2t = parcelRequire("iow2t");

var $iCJvK = parcelRequire("iCJvK");

var $i1MSl = parcelRequire("i1MSl");

});
parcelRegister("cwZCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f8464a3528c5ce$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");

var $1hA0I = parcelRequire("1hA0I");
var $91f8464a3528c5ce$var$ascendingBisect = (0, $1hA0I.default)((0, $ikXK9.default));
var $91f8464a3528c5ce$export$4d945ad3ad5751b0 = $91f8464a3528c5ce$var$ascendingBisect.right;
var $91f8464a3528c5ce$export$df7d25c84ebd12a5 = $91f8464a3528c5ce$var$ascendingBisect.left;
var $91f8464a3528c5ce$export$2e2bcd8739ae039 = $91f8464a3528c5ce$export$4d945ad3ad5751b0;

});
parcelRegister("ikXK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d598700e36b5a148$export$2e2bcd8739ae039);
function $d598700e36b5a148$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1hA0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef34ff1b66340ea$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");
function $0ef34ff1b66340ea$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $0ef34ff1b66340ea$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $0ef34ff1b66340ea$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $ikXK9.default)(f(d), x);
    };
}

});


parcelRegister("2FKxn", function(module, exports) {

var $EjaQz = parcelRequire("EjaQz");
function $1f23826fb05aba34$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $EjaQz.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("EjaQz", function(module, exports) {

$parcel$export(module.exports, "pair", () => $07929c169d633b68$export$a04cb3fe8b81dd);
function $07929c169d633b68$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $07929c169d633b68$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $07929c169d633b68$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("h7Ue2", function(module, exports) {
function $c77eb44d730cfaa4$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("2uDpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0cf4d82ba929b5$export$2e2bcd8739ae039);

var $iCJvK = parcelRequire("iCJvK");
function $1d0cf4d82ba929b5$export$2e2bcd8739ae039(array, f) {
    var v = (0, $iCJvK.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("iCJvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ef142b429b71f1$export$2e2bcd8739ae039);

var $lqKDf = parcelRequire("lqKDf");
function $d8ef142b429b71f1$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("lqKDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a032d23365899f$export$2e2bcd8739ae039);
function $f9a032d23365899f$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("7vAcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $577782c99ff74bed$export$2e2bcd8739ae039);
function $577782c99ff74bed$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("9EYaC", function(module, exports) {

var $3TF7W = parcelRequire("3TF7W");

var $cwZCH = parcelRequire("cwZCH");

var $3i4QB = parcelRequire("3i4QB");

var $7vAcD = parcelRequire("7vAcD");

var $89GLX = parcelRequire("89GLX");

var $g4YVZ = parcelRequire("g4YVZ");

var $jmphu = parcelRequire("jmphu");

var $aHgyR = parcelRequire("aHgyR");
function $7086860614c67edf$export$2e2bcd8739ae039() {
    var value = (0, $89GLX.default), domain = (0, $7vAcD.default), threshold = (0, $aHgyR.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $jmphu.tickStep)(x0, x1, tz);
            tz = (0, $g4YVZ.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $cwZCH.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $3i4QB.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $3i4QB.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $3i4QB.default)((0, $3TF7W.slice).call(_)) : (0, $3i4QB.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("3TF7W", function(module, exports) {

$parcel$export(module.exports, "slice", () => $2d66691cfe8394ae$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $2d66691cfe8394ae$export$871de8747c9eaa88);
var $2d66691cfe8394ae$var$array = Array.prototype;
var $2d66691cfe8394ae$export$58adb3bec8346d0f = $2d66691cfe8394ae$var$array.slice;
var $2d66691cfe8394ae$export$871de8747c9eaa88 = $2d66691cfe8394ae$var$array.map;

});

parcelRegister("3i4QB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2656d0219b83d594$export$2e2bcd8739ae039);
function $2656d0219b83d594$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("89GLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0057b51f7fe5bb$export$2e2bcd8739ae039);
function $5f0057b51f7fe5bb$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("g4YVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4c495b508b89d6$export$2e2bcd8739ae039);
function $bb4c495b508b89d6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("jmphu", function(module, exports) {

$parcel$export(module.exports, "tickStep", () => $e183aeb81cd707dd$export$81087d9b915d4ede);
var $e183aeb81cd707dd$var$e10 = Math.sqrt(50), $e183aeb81cd707dd$var$e5 = Math.sqrt(10), $e183aeb81cd707dd$var$e2 = Math.sqrt(2);
function $e183aeb81cd707dd$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $e183aeb81cd707dd$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $e183aeb81cd707dd$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $e183aeb81cd707dd$var$e10 ? 10 : error >= $e183aeb81cd707dd$var$e5 ? 5 : error >= $e183aeb81cd707dd$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $e183aeb81cd707dd$var$e10 ? 10 : error >= $e183aeb81cd707dd$var$e5 ? 5 : error >= $e183aeb81cd707dd$var$e2 ? 2 : 1);
}
function $e183aeb81cd707dd$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $e183aeb81cd707dd$var$e10) step1 *= 10;
    else if (error >= $e183aeb81cd707dd$var$e5) step1 *= 5;
    else if (error >= $e183aeb81cd707dd$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("aHgyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9ac43f0750ec32$export$2e2bcd8739ae039);
function $7c9ac43f0750ec32$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("4577G", function(module, exports) {

var $3TF7W = parcelRequire("3TF7W");

var $ikXK9 = parcelRequire("ikXK9");

var $lqKDf = parcelRequire("lqKDf");

var $dAnXI = parcelRequire("dAnXI");
function $2f8d278a267c0aea$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $3TF7W.map).call(values, (0, $lqKDf.default)).sort((0, $ikXK9.default));
    return Math.ceil((max - min) / (2 * ((0, $dAnXI.default)(values, 0.75) - (0, $dAnXI.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("dAnXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e41398df751047a$export$2e2bcd8739ae039);

var $lqKDf = parcelRequire("lqKDf");
function $9e41398df751047a$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $lqKDf.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("6YZeN", function(module, exports) {

var $2uDpI = parcelRequire("2uDpI");
function $5157d92b80fddd2c$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $2uDpI.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("KpPuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $08b8553225be4ad3$export$2e2bcd8739ae039);
function $08b8553225be4ad3$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("4yfeG", function(module, exports) {

var $lqKDf = parcelRequire("lqKDf");
function $350627edb0fd1355$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("l1gm2", function(module, exports) {

var $ikXK9 = parcelRequire("ikXK9");

var $lqKDf = parcelRequire("lqKDf");

var $dAnXI = parcelRequire("dAnXI");
function $f4d660a154239ee6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $dAnXI.default)(numbers.sort((0, $ikXK9.default)), 0.5);
}

});

parcelRegister("aXvHU", function(module, exports) {
function $7fa80274138b92c0$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("kAZFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe701885a1d3da6$export$2e2bcd8739ae039);
function $efe701885a1d3da6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("j7ztS", function(module, exports) {
function $deba318444812356$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("fgOxt", function(module, exports) {

var $ikXK9 = parcelRequire("ikXK9");
function $b1df8d99ffd1b619$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $ikXK9.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("lNlBs", function(module, exports) {
function $fddeee7d9dab40a6$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("7FxEL", function(module, exports) {
function $595678317647702e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("iow2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6435228b354c3fc$export$2e2bcd8739ae039);

var $kAZFv = parcelRequire("kAZFv");
function $d6435228b354c3fc$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $kAZFv.default)(matrix, $d6435228b354c3fc$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $d6435228b354c3fc$var$length(d) {
    return d.length;
}

});

parcelRegister("i1MSl", function(module, exports) {

var $iow2t = parcelRequire("iow2t");
function $d1fe3ba6484d9b47$export$2e2bcd8739ae039() {
    return (0, $iow2t.default)(arguments);
}

});


parcelRegister("hwbq9", function(module, exports) {

$parcel$export(module.exports, "slice", () => $cc0e48c7964c64bc$export$58adb3bec8346d0f);
var $cc0e48c7964c64bc$var$array = Array.prototype;
var $cc0e48c7964c64bc$export$58adb3bec8346d0f = $cc0e48c7964c64bc$var$array.slice;

});

parcelRegister("vk0Xw", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e26bd2653a1ec0$export$2e2bcd8739ae039);
function $05e26bd2653a1ec0$export$2e2bcd8739ae039(a, b) {
    return a - b;
}

});

parcelRegister("gTeRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bd5048c0502746$export$2e2bcd8739ae039);
function $c4bd5048c0502746$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}

});

parcelRegister("68dxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $476dfd8af0dd799d$export$2e2bcd8739ae039);
function $476dfd8af0dd799d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("den4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e7a25b33148d4$export$2e2bcd8739ae039);
function $9a1e7a25b33148d4$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $9a1e7a25b33148d4$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $9a1e7a25b33148d4$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($9a1e7a25b33148d4$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $9a1e7a25b33148d4$var$segmentContains(a, b, c) {
    var i;
    return $9a1e7a25b33148d4$var$collinear(a, b, c) && $9a1e7a25b33148d4$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $9a1e7a25b33148d4$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $9a1e7a25b33148d4$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

});

parcelRegister("lTaPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef7235b2b81b51a$export$2e2bcd8739ae039);
function $fef7235b2b81b51a$export$2e2bcd8739ae039() {}

});


parcelRegister("6FOtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbdbae65dc5b705$export$2e2bcd8739ae039);
parcelRequire("8qmD5");
var $KpPuy = parcelRequire("KpPuy");
var $g4YVZ = parcelRequire("g4YVZ");
var $jmphu = parcelRequire("jmphu");

var $hwbq9 = parcelRequire("hwbq9");

var $jWE6V = parcelRequire("jWE6V");

var $68dxl = parcelRequire("68dxl");

var $6LTg0 = parcelRequire("6LTg0");
function $4dbdbae65dc5b705$var$defaultX(d) {
    return d[0];
}
function $4dbdbae65dc5b705$var$defaultY(d) {
    return d[1];
}
function $4dbdbae65dc5b705$var$defaultWeight() {
    return 1;
}
function $4dbdbae65dc5b705$export$2e2bcd8739ae039() {
    var x = $4dbdbae65dc5b705$var$defaultX, y = $4dbdbae65dc5b705$var$defaultY, weight = $4dbdbae65dc5b705$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $68dxl.default)(20);
    function density(data) {
        var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        data.forEach(function(d, i, data) {
            var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
        });
        // TODO Optimize.
        (0, $jWE6V.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $jWE6V.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $jWE6V.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $jWE6V.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $jWE6V.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $jWE6V.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        var tz = threshold(values0);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var stop = (0, $KpPuy.default)(values0);
            tz = (0, $jmphu.tickStep)(0, stop, tz);
            tz = (0, $g4YVZ.default)(0, Math.floor(stop / tz) * tz, tz);
            tz.shift();
        }
        return (0, $6LTg0.default)().thresholds(tz).size([
            n,
            m
        ])(values0).map(transform);
    }
    function transform(geometry) {
        geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $68dxl.default)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $68dxl.default)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $68dxl.default)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $68dxl.default)((0, $hwbq9.slice).call(_)) : (0, $68dxl.default)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
    };
    return density;
}

});
parcelRegister("jWE6V", function(module, exports) {

$parcel$export(module.exports, "blurX", () => $e8528c43d7269408$export$d6b6c69cb5897b44);
$parcel$export(module.exports, "blurY", () => $e8528c43d7269408$export$96ba1179f8344c4b);
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function $e8528c43d7269408$export$d6b6c69cb5897b44(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function $e8528c43d7269408$export$96ba1179f8344c4b(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}

});



parcelRegister("6Yrra", function(module, exports) {

$parcel$export(module.exports, "dispatch", () => (parcelRequire("4h5V5")).default);

var $4h5V5 = parcelRequire("4h5V5");

});

parcelRegister("kaKTm", function(module, exports) {

$parcel$export(module.exports, "drag", () => (parcelRequire("kg26P")).default);
$parcel$export(module.exports, "dragDisable", () => (parcelRequire("kza96")).default);
$parcel$export(module.exports, "dragEnable", () => (parcelRequire("kza96")).yesdrag);

var $kg26P = parcelRequire("kg26P");

var $kza96 = parcelRequire("kza96");

});
parcelRegister("kg26P", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf6f017748280ae$export$2e2bcd8739ae039);

var $4h5V5 = parcelRequire("4h5V5");

var $cdh1A = parcelRequire("cdh1A");
var $gZqlB = parcelRequire("gZqlB");
var $kCHcF = parcelRequire("kCHcF");
var $jSl7R = parcelRequire("jSl7R");

var $kza96 = parcelRequire("kza96");

var $6OzG5 = parcelRequire("6OzG5");

var $iYvrD = parcelRequire("iYvrD");

var $gFLNx = parcelRequire("gFLNx");
// Ignore right-click, since that should open the context menu.
function $ebf6f017748280ae$var$defaultFilter() {
    return !(0, $cdh1A.event).ctrlKey && !(0, $cdh1A.event).button;
}
function $ebf6f017748280ae$var$defaultContainer() {
    return this.parentNode;
}
function $ebf6f017748280ae$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $cdh1A.event).x,
        y: (0, $cdh1A.event).y
    } : d;
}
function $ebf6f017748280ae$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $ebf6f017748280ae$export$2e2bcd8739ae039() {
    var filter = $ebf6f017748280ae$var$defaultFilter, container = $ebf6f017748280ae$var$defaultContainer, subject = $ebf6f017748280ae$var$defaultSubject, touchable = $ebf6f017748280ae$var$defaultTouchable, gestures = {}, listeners = (0, $4h5V5.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $gZqlB.default), this, arguments);
        if (!gesture) return;
        (0, $kCHcF.default)((0, $cdh1A.event).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $kza96.default)((0, $cdh1A.event).view);
        (0, $6OzG5.nopropagation)();
        mousemoving = false;
        mousedownx = (0, $cdh1A.event).clientX;
        mousedowny = (0, $cdh1A.event).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $6OzG5.default)();
        if (!mousemoving) {
            var dx = (0, $cdh1A.event).clientX - mousedownx, dy = (0, $cdh1A.event).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $kCHcF.default)((0, $cdh1A.event).view).on("mousemove.drag mouseup.drag", null);
        (0, $kza96.yesdrag)((0, $cdh1A.event).view, mousemoving);
        (0, $6OzG5.default)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $cdh1A.event).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $jSl7R.default), this, arguments)) {
            (0, $6OzG5.nopropagation)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $cdh1A.event).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $6OzG5.default)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $cdh1A.event).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $6OzG5.nopropagation)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $cdh1A.customEvent)(new (0, $gFLNx.default)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $cdh1A.event).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $cdh1A.customEvent)(new (0, $gFLNx.default)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $iYvrD.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $iYvrD.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $iYvrD.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $iYvrD.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("iYvrD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0638dd6bf718b9$export$2e2bcd8739ae039);
function $dd0638dd6bf718b9$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("gFLNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2358d631d88893d$export$2e2bcd8739ae039);
function $c2358d631d88893d$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$c2358d631d88893d$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});



parcelRegister("8KyJ5", function(module, exports) {

$parcel$export(module.exports, "dsvFormat", () => (parcelRequire("jDNx7")).default);
$parcel$export(module.exports, "csvParse", () => (parcelRequire("aGeJV")).csvParse);
$parcel$export(module.exports, "csvParseRows", () => (parcelRequire("aGeJV")).csvParseRows);
$parcel$export(module.exports, "csvFormat", () => (parcelRequire("aGeJV")).csvFormat);
$parcel$export(module.exports, "csvFormatBody", () => (parcelRequire("aGeJV")).csvFormatBody);
$parcel$export(module.exports, "csvFormatRows", () => (parcelRequire("aGeJV")).csvFormatRows);
$parcel$export(module.exports, "csvFormatRow", () => (parcelRequire("aGeJV")).csvFormatRow);
$parcel$export(module.exports, "csvFormatValue", () => (parcelRequire("aGeJV")).csvFormatValue);
$parcel$export(module.exports, "tsvParse", () => (parcelRequire("lShYg")).tsvParse);
$parcel$export(module.exports, "tsvParseRows", () => (parcelRequire("lShYg")).tsvParseRows);
$parcel$export(module.exports, "tsvFormat", () => (parcelRequire("lShYg")).tsvFormat);
$parcel$export(module.exports, "tsvFormatBody", () => (parcelRequire("lShYg")).tsvFormatBody);
$parcel$export(module.exports, "tsvFormatRows", () => (parcelRequire("lShYg")).tsvFormatRows);
$parcel$export(module.exports, "tsvFormatRow", () => (parcelRequire("lShYg")).tsvFormatRow);
$parcel$export(module.exports, "tsvFormatValue", () => (parcelRequire("lShYg")).tsvFormatValue);
$parcel$export(module.exports, "autoType", () => (parcelRequire("715Dm")).default);

var $jDNx7 = parcelRequire("jDNx7");

var $aGeJV = parcelRequire("aGeJV");

var $lShYg = parcelRequire("lShYg");

var $715Dm = parcelRequire("715Dm");

});
parcelRegister("715Dm", function(module, exports) {

$parcel$export(module.exports, "default", () => $51bcff29312f2adc$export$2e2bcd8739ae039);
function $51bcff29312f2adc$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($51bcff29312f2adc$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
var $51bcff29312f2adc$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

});


parcelRegister("3XlZC", function(module, exports) {

$parcel$export(module.exports, "easeLinear", () => (parcelRequire("4KYr6")).linear);
$parcel$export(module.exports, "easeQuad", () => (parcelRequire("eQrwF")).quadInOut);
$parcel$export(module.exports, "easeQuadIn", () => (parcelRequire("eQrwF")).quadIn);
$parcel$export(module.exports, "easeQuadOut", () => (parcelRequire("eQrwF")).quadOut);
$parcel$export(module.exports, "easeQuadInOut", () => (parcelRequire("eQrwF")).quadInOut);
$parcel$export(module.exports, "easeCubic", () => (parcelRequire("22Bya")).cubicInOut);
$parcel$export(module.exports, "easeCubicIn", () => (parcelRequire("22Bya")).cubicIn);
$parcel$export(module.exports, "easeCubicOut", () => (parcelRequire("22Bya")).cubicOut);
$parcel$export(module.exports, "easeCubicInOut", () => (parcelRequire("22Bya")).cubicInOut);
$parcel$export(module.exports, "easePoly", () => (parcelRequire("iZ6x6")).polyInOut);
$parcel$export(module.exports, "easePolyIn", () => (parcelRequire("iZ6x6")).polyIn);
$parcel$export(module.exports, "easePolyOut", () => (parcelRequire("iZ6x6")).polyOut);
$parcel$export(module.exports, "easePolyInOut", () => (parcelRequire("iZ6x6")).polyInOut);
$parcel$export(module.exports, "easeSin", () => (parcelRequire("b0P3k")).sinInOut);
$parcel$export(module.exports, "easeSinIn", () => (parcelRequire("b0P3k")).sinIn);
$parcel$export(module.exports, "easeSinOut", () => (parcelRequire("b0P3k")).sinOut);
$parcel$export(module.exports, "easeSinInOut", () => (parcelRequire("b0P3k")).sinInOut);
$parcel$export(module.exports, "easeExp", () => (parcelRequire("d4FtC")).expInOut);
$parcel$export(module.exports, "easeExpIn", () => (parcelRequire("d4FtC")).expIn);
$parcel$export(module.exports, "easeExpOut", () => (parcelRequire("d4FtC")).expOut);
$parcel$export(module.exports, "easeExpInOut", () => (parcelRequire("d4FtC")).expInOut);
$parcel$export(module.exports, "easeCircle", () => (parcelRequire("fZrL2")).circleInOut);
$parcel$export(module.exports, "easeCircleIn", () => (parcelRequire("fZrL2")).circleIn);
$parcel$export(module.exports, "easeCircleOut", () => (parcelRequire("fZrL2")).circleOut);
$parcel$export(module.exports, "easeCircleInOut", () => (parcelRequire("fZrL2")).circleInOut);
$parcel$export(module.exports, "easeBounce", () => (parcelRequire("e2eTd")).bounceOut);
$parcel$export(module.exports, "easeBounceIn", () => (parcelRequire("e2eTd")).bounceIn);
$parcel$export(module.exports, "easeBounceOut", () => (parcelRequire("e2eTd")).bounceOut);
$parcel$export(module.exports, "easeBounceInOut", () => (parcelRequire("e2eTd")).bounceInOut);
$parcel$export(module.exports, "easeBack", () => (parcelRequire("9YH1n")).backInOut);
$parcel$export(module.exports, "easeBackIn", () => (parcelRequire("9YH1n")).backIn);
$parcel$export(module.exports, "easeBackOut", () => (parcelRequire("9YH1n")).backOut);
$parcel$export(module.exports, "easeBackInOut", () => (parcelRequire("9YH1n")).backInOut);
$parcel$export(module.exports, "easeElastic", () => (parcelRequire("9savh")).elasticOut);
$parcel$export(module.exports, "easeElasticIn", () => (parcelRequire("9savh")).elasticIn);
$parcel$export(module.exports, "easeElasticOut", () => (parcelRequire("9savh")).elasticOut);
$parcel$export(module.exports, "easeElasticInOut", () => (parcelRequire("9savh")).elasticInOut);

var $4KYr6 = parcelRequire("4KYr6");

var $eQrwF = parcelRequire("eQrwF");

var $22Bya = parcelRequire("22Bya");

var $iZ6x6 = parcelRequire("iZ6x6");

var $b0P3k = parcelRequire("b0P3k");

var $d4FtC = parcelRequire("d4FtC");

var $fZrL2 = parcelRequire("fZrL2");

var $e2eTd = parcelRequire("e2eTd");

var $9YH1n = parcelRequire("9YH1n");

var $9savh = parcelRequire("9savh");

});
parcelRegister("4KYr6", function(module, exports) {

$parcel$export(module.exports, "linear", () => $376a56abe60eeb9f$export$45db2fc2f15997e7);
function $376a56abe60eeb9f$export$45db2fc2f15997e7(t) {
    return +t;
}

});

parcelRegister("eQrwF", function(module, exports) {

$parcel$export(module.exports, "quadIn", () => $aceb46139b392d55$export$5118fc7a1e64441b);
$parcel$export(module.exports, "quadOut", () => $aceb46139b392d55$export$5be5f5e804d0b60c);
$parcel$export(module.exports, "quadInOut", () => $aceb46139b392d55$export$d6ded66933892ed3);
function $aceb46139b392d55$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $aceb46139b392d55$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $aceb46139b392d55$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRegister("iZ6x6", function(module, exports) {

$parcel$export(module.exports, "polyIn", () => $dd22fdc93ac574df$export$aa0b5c3ce2df9d7d);
$parcel$export(module.exports, "polyOut", () => $dd22fdc93ac574df$export$e3d987a417dc6640);
$parcel$export(module.exports, "polyInOut", () => $dd22fdc93ac574df$export$ae94c6a40058b429);
var $dd22fdc93ac574df$var$exponent = 3;
var $dd22fdc93ac574df$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($dd22fdc93ac574df$var$exponent);
var $dd22fdc93ac574df$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($dd22fdc93ac574df$var$exponent);
var $dd22fdc93ac574df$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($dd22fdc93ac574df$var$exponent);

});

parcelRegister("b0P3k", function(module, exports) {

$parcel$export(module.exports, "sinIn", () => $80474bca71715acf$export$a83a280f8d31ba8d);
$parcel$export(module.exports, "sinOut", () => $80474bca71715acf$export$62ec6410ca53f2a7);
$parcel$export(module.exports, "sinInOut", () => $80474bca71715acf$export$ff58b604d3ba15ba);
var $80474bca71715acf$var$pi = Math.PI, $80474bca71715acf$var$halfPi = $80474bca71715acf$var$pi / 2;
function $80474bca71715acf$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $80474bca71715acf$var$halfPi);
}
function $80474bca71715acf$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $80474bca71715acf$var$halfPi);
}
function $80474bca71715acf$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($80474bca71715acf$var$pi * t)) / 2;
}

});

parcelRegister("d4FtC", function(module, exports) {

$parcel$export(module.exports, "expIn", () => $984bd27aeda18065$export$fc3e95f15e1ef38e);
$parcel$export(module.exports, "expOut", () => $984bd27aeda18065$export$f3c9b2f85fbcf0ab);
$parcel$export(module.exports, "expInOut", () => $984bd27aeda18065$export$ae4d4e77fab188ff);

var $7Jbrp = parcelRequire("7Jbrp");
function $984bd27aeda18065$export$fc3e95f15e1ef38e(t) {
    return (0, $7Jbrp.tpmt)(1 - +t);
}
function $984bd27aeda18065$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $7Jbrp.tpmt)(t);
}
function $984bd27aeda18065$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $7Jbrp.tpmt)(1 - t) : 2 - (0, $7Jbrp.tpmt)(t - 1)) / 2;
}

});
parcelRegister("7Jbrp", function(module, exports) {

$parcel$export(module.exports, "tpmt", () => $5a059c55ce6a983b$export$be3f0f7224794b88);
// tpmt is two power minus ten times t scaled to [0,1]
function $5a059c55ce6a983b$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

});


parcelRegister("fZrL2", function(module, exports) {

$parcel$export(module.exports, "circleIn", () => $ba42159b87562d71$export$9f82a71b0377c018);
$parcel$export(module.exports, "circleOut", () => $ba42159b87562d71$export$27989e665abef2c8);
$parcel$export(module.exports, "circleInOut", () => $ba42159b87562d71$export$2d757ff9ad09038f);
function $ba42159b87562d71$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $ba42159b87562d71$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $ba42159b87562d71$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRegister("e2eTd", function(module, exports) {

$parcel$export(module.exports, "bounceIn", () => $a37ccd5bfe22f369$export$fccebd7948554554);
$parcel$export(module.exports, "bounceOut", () => $a37ccd5bfe22f369$export$cccc9e04465dce11);
$parcel$export(module.exports, "bounceInOut", () => $a37ccd5bfe22f369$export$41ad9e9849a703ce);
var $a37ccd5bfe22f369$var$b1 = 4 / 11, $a37ccd5bfe22f369$var$b2 = 6 / 11, $a37ccd5bfe22f369$var$b3 = 8 / 11, $a37ccd5bfe22f369$var$b4 = 3 / 4, $a37ccd5bfe22f369$var$b5 = 9 / 11, $a37ccd5bfe22f369$var$b6 = 10 / 11, $a37ccd5bfe22f369$var$b7 = 15 / 16, $a37ccd5bfe22f369$var$b8 = 21 / 22, $a37ccd5bfe22f369$var$b9 = 63 / 64, $a37ccd5bfe22f369$var$b0 = 1 / $a37ccd5bfe22f369$var$b1 / $a37ccd5bfe22f369$var$b1;
function $a37ccd5bfe22f369$export$fccebd7948554554(t) {
    return 1 - $a37ccd5bfe22f369$export$cccc9e04465dce11(1 - t);
}
function $a37ccd5bfe22f369$export$cccc9e04465dce11(t) {
    return (t = +t) < $a37ccd5bfe22f369$var$b1 ? $a37ccd5bfe22f369$var$b0 * t * t : t < $a37ccd5bfe22f369$var$b3 ? $a37ccd5bfe22f369$var$b0 * (t -= $a37ccd5bfe22f369$var$b2) * t + $a37ccd5bfe22f369$var$b4 : t < $a37ccd5bfe22f369$var$b6 ? $a37ccd5bfe22f369$var$b0 * (t -= $a37ccd5bfe22f369$var$b5) * t + $a37ccd5bfe22f369$var$b7 : $a37ccd5bfe22f369$var$b0 * (t -= $a37ccd5bfe22f369$var$b8) * t + $a37ccd5bfe22f369$var$b9;
}
function $a37ccd5bfe22f369$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $a37ccd5bfe22f369$export$cccc9e04465dce11(1 - t) : $a37ccd5bfe22f369$export$cccc9e04465dce11(t - 1) + 1) / 2;
}

});

parcelRegister("9YH1n", function(module, exports) {

$parcel$export(module.exports, "backIn", () => $743b16c99eef8ee9$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backOut", () => $743b16c99eef8ee9$export$77edfce482316a60);
$parcel$export(module.exports, "backInOut", () => $743b16c99eef8ee9$export$ddc5fd596f6c71b2);
var $743b16c99eef8ee9$var$overshoot = 1.70158;
var $743b16c99eef8ee9$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($743b16c99eef8ee9$var$overshoot);
var $743b16c99eef8ee9$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($743b16c99eef8ee9$var$overshoot);
var $743b16c99eef8ee9$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($743b16c99eef8ee9$var$overshoot);

});

parcelRegister("9savh", function(module, exports) {

$parcel$export(module.exports, "elasticIn", () => $6e1ee05bb982dfcf$export$41f42134872a5fa0);
$parcel$export(module.exports, "elasticOut", () => $6e1ee05bb982dfcf$export$ed1782b99e69bbc8);
$parcel$export(module.exports, "elasticInOut", () => $6e1ee05bb982dfcf$export$309de4f35f218bfd);

var $7Jbrp = parcelRequire("7Jbrp");
var $6e1ee05bb982dfcf$var$tau = 2 * Math.PI, $6e1ee05bb982dfcf$var$amplitude = 1, $6e1ee05bb982dfcf$var$period = 0.3;
var $6e1ee05bb982dfcf$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $6e1ee05bb982dfcf$var$tau);
    function elasticIn(t) {
        return a * (0, $7Jbrp.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $6e1ee05bb982dfcf$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($6e1ee05bb982dfcf$var$amplitude, $6e1ee05bb982dfcf$var$period);
var $6e1ee05bb982dfcf$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $6e1ee05bb982dfcf$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $7Jbrp.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $6e1ee05bb982dfcf$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($6e1ee05bb982dfcf$var$amplitude, $6e1ee05bb982dfcf$var$period);
var $6e1ee05bb982dfcf$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $6e1ee05bb982dfcf$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $7Jbrp.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $7Jbrp.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $6e1ee05bb982dfcf$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($6e1ee05bb982dfcf$var$amplitude, $6e1ee05bb982dfcf$var$period);

});


parcelRegister("bwHK4", function(module, exports) {

$parcel$export(module.exports, "blob", () => (parcelRequire("21cmv")).default);
$parcel$export(module.exports, "buffer", () => (parcelRequire("5Iuj8")).default);
$parcel$export(module.exports, "dsv", () => (parcelRequire("klIz4")).default);
$parcel$export(module.exports, "csv", () => (parcelRequire("klIz4")).csv);
$parcel$export(module.exports, "tsv", () => (parcelRequire("klIz4")).tsv);
$parcel$export(module.exports, "image", () => (parcelRequire("Xll6w")).default);
$parcel$export(module.exports, "json", () => (parcelRequire("51WmZ")).default);
$parcel$export(module.exports, "text", () => (parcelRequire("2I6Ok")).default);
$parcel$export(module.exports, "xml", () => (parcelRequire("2hWEj")).default);
$parcel$export(module.exports, "html", () => (parcelRequire("2hWEj")).html);
$parcel$export(module.exports, "svg", () => (parcelRequire("2hWEj")).svg);

var $21cmv = parcelRequire("21cmv");

var $5Iuj8 = parcelRequire("5Iuj8");

var $klIz4 = parcelRequire("klIz4");

var $Xll6w = parcelRequire("Xll6w");

var $51WmZ = parcelRequire("51WmZ");

var $2I6Ok = parcelRequire("2I6Ok");

var $2hWEj = parcelRequire("2hWEj");

});
parcelRegister("21cmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1785439cf81340f6$export$2e2bcd8739ae039);
function $1785439cf81340f6$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $1785439cf81340f6$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($1785439cf81340f6$var$responseBlob);
}

});

parcelRegister("5Iuj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $42989246605c503e$export$2e2bcd8739ae039);
function $42989246605c503e$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $42989246605c503e$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($42989246605c503e$var$responseArrayBuffer);
}

});

parcelRegister("Xll6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b26105c82eab316$export$2e2bcd8739ae039);
function $0b26105c82eab316$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}

});

parcelRegister("51WmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9a52c44e9e4966$export$2e2bcd8739ae039);
function $3a9a52c44e9e4966$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $3a9a52c44e9e4966$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($3a9a52c44e9e4966$var$responseJson);
}

});

parcelRegister("2hWEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aaaa9cd5445b053$export$2e2bcd8739ae039);
$parcel$export(module.exports, "html", () => $1aaaa9cd5445b053$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $1aaaa9cd5445b053$export$7ed1367e7fa1ad68);

var $2I6Ok = parcelRequire("2I6Ok");
function $1aaaa9cd5445b053$var$parser(type) {
    return function(input, init) {
        return (0, $2I6Ok.default)(input, init).then(function(text) {
            return (new DOMParser).parseFromString(text, type);
        });
    };
}
var $1aaaa9cd5445b053$export$2e2bcd8739ae039 = $1aaaa9cd5445b053$var$parser("application/xml");
var $1aaaa9cd5445b053$export$c0bb0b647f701bb5 = $1aaaa9cd5445b053$var$parser("text/html");
var $1aaaa9cd5445b053$export$7ed1367e7fa1ad68 = $1aaaa9cd5445b053$var$parser("image/svg+xml");

});


parcelRegister("kxMuV", function(module, exports) {

$parcel$export(module.exports, "forceCenter", () => (parcelRequire("1txQo")).default);
$parcel$export(module.exports, "forceCollide", () => (parcelRequire("kDaOZ")).default);
$parcel$export(module.exports, "forceLink", () => (parcelRequire("bKQos")).default);
$parcel$export(module.exports, "forceManyBody", () => (parcelRequire("fipdQ")).default);
$parcel$export(module.exports, "forceRadial", () => (parcelRequire("4HuUr")).default);
$parcel$export(module.exports, "forceSimulation", () => (parcelRequire("7BYKt")).default);
$parcel$export(module.exports, "forceX", () => (parcelRequire("lHNMy")).default);
$parcel$export(module.exports, "forceY", () => (parcelRequire("iERvZ")).default);

var $1txQo = parcelRequire("1txQo");

var $kDaOZ = parcelRequire("kDaOZ");

var $bKQos = parcelRequire("bKQos");

var $fipdQ = parcelRequire("fipdQ");

var $4HuUr = parcelRequire("4HuUr");

var $7BYKt = parcelRequire("7BYKt");

var $lHNMy = parcelRequire("lHNMy");

var $iERvZ = parcelRequire("iERvZ");

});
parcelRegister("1txQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1132c098d8adb837$export$2e2bcd8739ae039);
function $1132c098d8adb837$export$2e2bcd8739ae039(x, y) {
    var nodes;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("kDaOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04fd80deef7c79f$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");

var $2R0KX = parcelRequire("2R0KX");

var $8H00M = parcelRequire("8H00M");
function $f04fd80deef7c79f$var$x(d) {
    return d.x + d.vx;
}
function $f04fd80deef7c79f$var$y(d) {
    return d.y + d.vy;
}
function $f04fd80deef7c79f$export$2e2bcd8739ae039(radius) {
    var nodes, radii, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $eqMp9.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $8H00M.default)(nodes, $f04fd80deef7c79f$var$x, $f04fd80deef7c79f$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $2R0KX.default)(), l += x * x;
                        if (y === 0) y = (0, $2R0KX.default)(), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("eqMp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8190a9023ad33fd$export$2e2bcd8739ae039);
function $a8190a9023ad33fd$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("2R0KX", function(module, exports) {

$parcel$export(module.exports, "default", () => $21411e350aba24f4$export$2e2bcd8739ae039);
function $21411e350aba24f4$export$2e2bcd8739ae039() {
    return (Math.random() - 0.5) * 1e-6;
}

});

parcelRegister("8H00M", function(module, exports) {

$parcel$export(module.exports, "default", () => $6542592f68a846af$export$2e2bcd8739ae039);

var $7Fr6t = parcelRequire("7Fr6t");

var $8T1oc = parcelRequire("8T1oc");

var $6c1Nb = parcelRequire("6c1Nb");

var $giVKT = parcelRequire("giVKT");

var $f9i8t = parcelRequire("f9i8t");

var $6CDA9 = parcelRequire("6CDA9");

var $6jQej = parcelRequire("6jQej");

var $iA9MU = parcelRequire("iA9MU");

var $3ANgU = parcelRequire("3ANgU");

var $4fNl3 = parcelRequire("4fNl3");

var $hwlWB = parcelRequire("hwlWB");

var $dCv0y = parcelRequire("dCv0y");
function $6542592f68a846af$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $6542592f68a846af$var$Quadtree(x == null ? (0, $hwlWB.defaultX) : x, y == null ? (0, $dCv0y.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $6542592f68a846af$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $6542592f68a846af$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $6542592f68a846af$var$treeProto = $6542592f68a846af$export$2e2bcd8739ae039.prototype = $6542592f68a846af$var$Quadtree.prototype;
$6542592f68a846af$var$treeProto.copy = function() {
    var copy = new $6542592f68a846af$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $6542592f68a846af$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $6542592f68a846af$var$leaf_copy(child);
        }
    }
    return copy;
};
$6542592f68a846af$var$treeProto.add = (0, $7Fr6t.default);
$6542592f68a846af$var$treeProto.addAll = (0, $7Fr6t.addAll);
$6542592f68a846af$var$treeProto.cover = (0, $8T1oc.default);
$6542592f68a846af$var$treeProto.data = (0, $6c1Nb.default);
$6542592f68a846af$var$treeProto.extent = (0, $giVKT.default);
$6542592f68a846af$var$treeProto.find = (0, $f9i8t.default);
$6542592f68a846af$var$treeProto.remove = (0, $6CDA9.default);
$6542592f68a846af$var$treeProto.removeAll = (0, $6CDA9.removeAll);
$6542592f68a846af$var$treeProto.root = (0, $6jQej.default);
$6542592f68a846af$var$treeProto.size = (0, $iA9MU.default);
$6542592f68a846af$var$treeProto.visit = (0, $3ANgU.default);
$6542592f68a846af$var$treeProto.visitAfter = (0, $4fNl3.default);
$6542592f68a846af$var$treeProto.x = (0, $hwlWB.default);
$6542592f68a846af$var$treeProto.y = (0, $dCv0y.default);

});
parcelRegister("7Fr6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $595162eaa5955e0c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $595162eaa5955e0c$export$32ed0561867ec8a1);
function $595162eaa5955e0c$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $595162eaa5955e0c$var$add(this.cover(x, y), x, y, d);
}
function $595162eaa5955e0c$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $595162eaa5955e0c$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$595162eaa5955e0c$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("8T1oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $678489adabafad3e$export$2e2bcd8739ae039);
function $678489adabafad3e$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("6c1Nb", function(module, exports) {

$parcel$export(module.exports, "default", () => $482540f40461db04$export$2e2bcd8739ae039);
function $482540f40461db04$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("giVKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdeb20c746c4bb0d$export$2e2bcd8739ae039);
function $bdeb20c746c4bb0d$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("f9i8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b075c3a9c3dc65a3$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $b075c3a9c3dc65a3$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $WGeW1.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $WGeW1.default)(node[3], xm, ym, x2, y2), new (0, $WGeW1.default)(node[2], x1, ym, xm, y2), new (0, $WGeW1.default)(node[1], xm, y1, x2, ym), new (0, $WGeW1.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("WGeW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b062edb07fb906a$export$2e2bcd8739ae039);
function $0b062edb07fb906a$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("6CDA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d24fed8e0d56ecc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $4d24fed8e0d56ecc$export$1cfc7aad5cb1833b);
function $4d24fed8e0d56ecc$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $4d24fed8e0d56ecc$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("6jQej", function(module, exports) {

$parcel$export(module.exports, "default", () => $499d082dee1a532a$export$2e2bcd8739ae039);
function $499d082dee1a532a$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("iA9MU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8732e734012c35d$export$2e2bcd8739ae039);
function $d8732e734012c35d$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("3ANgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $29daf43ae6cd393b$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $29daf43ae6cd393b$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $WGeW1.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $WGeW1.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $WGeW1.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $WGeW1.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $WGeW1.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("4fNl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $318ed5c4d617b5ec$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $318ed5c4d617b5ec$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $WGeW1.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $WGeW1.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $WGeW1.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $WGeW1.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $WGeW1.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("hwlWB", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $cc167280ddcb56ad$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $cc167280ddcb56ad$export$2e2bcd8739ae039);
function $cc167280ddcb56ad$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $cc167280ddcb56ad$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("dCv0y", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $9ea6e0837101e005$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $9ea6e0837101e005$export$2e2bcd8739ae039);
function $9ea6e0837101e005$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $9ea6e0837101e005$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});



parcelRegister("bKQos", function(module, exports) {

$parcel$export(module.exports, "default", () => $88eca1dd665ebd89$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");

var $2R0KX = parcelRequire("2R0KX");
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");
function $88eca1dd665ebd89$var$index(d) {
    return d.index;
}
function $88eca1dd665ebd89$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}
function $88eca1dd665ebd89$export$2e2bcd8739ae039(links) {
    var id = $88eca1dd665ebd89$var$index, strength = defaultStrength, strengths, distance = (0, $eqMp9.default)(30), distances, nodes, count, bias, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $2R0KX.default)();
            y = target.y + target.vy - source.y - source.vy || (0, $2R0KX.default)();
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = (0, $5Mltl.default)(nodes, id), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $88eca1dd665ebd89$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $88eca1dd665ebd89$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});

parcelRegister("fipdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b22c1a1819be8f3d$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");

var $2R0KX = parcelRequire("2R0KX");

var $8H00M = parcelRequire("8H00M");

var $7BYKt = parcelRequire("7BYKt");
function $b22c1a1819be8f3d$export$2e2bcd8739ae039() {
    var nodes, node, alpha, strength = (0, $eqMp9.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $8H00M.default)(nodes, (0, $7BYKt.x), (0, $7BYKt.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $2R0KX.default)(), l += x * x;
                if (y === 0) y = (0, $2R0KX.default)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $2R0KX.default)(), l += x * x;
            if (y === 0) y = (0, $2R0KX.default)(), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("7BYKt", function(module, exports) {

$parcel$export(module.exports, "x", () => $58ab1c82c9ca3ad7$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $58ab1c82c9ca3ad7$export$4a5767248b18ef41);
$parcel$export(module.exports, "default", () => $58ab1c82c9ca3ad7$export$2e2bcd8739ae039);

var $4h5V5 = parcelRequire("4h5V5");
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");

var $5hwOF = parcelRequire("5hwOF");
function $58ab1c82c9ca3ad7$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $58ab1c82c9ca3ad7$export$4a5767248b18ef41(d) {
    return d.y;
}
var $58ab1c82c9ca3ad7$var$initialRadius = 10, $58ab1c82c9ca3ad7$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $58ab1c82c9ca3ad7$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, $5Mltl.default)(), stepper = (0, $5hwOF.timer)(step), event = (0, $4h5V5.default)("tick", "end");
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.each(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $58ab1c82c9ca3ad7$var$initialRadius * Math.sqrt(i), angle = i * $58ab1c82c9ca3ad7$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});


parcelRegister("4HuUr", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c32784d6a645cc$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");
function $36c32784d6a645cc$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $eqMp9.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $eqMp9.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("lHNMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd43ad1c6c5b35e$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");
function $fcd43ad1c6c5b35e$export$2e2bcd8739ae039(x) {
    var strength = (0, $eqMp9.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $eqMp9.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("iERvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d955796372c58db6$export$2e2bcd8739ae039);

var $eqMp9 = parcelRequire("eqMp9");
function $d955796372c58db6$export$2e2bcd8739ae039(y) {
    var strength = (0, $eqMp9.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $eqMp9.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $eqMp9.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("dgorV", function(module, exports) {

$parcel$export(module.exports, "formatDefaultLocale", () => (parcelRequire("haUiJ")).default);
$parcel$export(module.exports, "format", () => (parcelRequire("haUiJ")).format);
$parcel$export(module.exports, "formatPrefix", () => (parcelRequire("haUiJ")).formatPrefix);
$parcel$export(module.exports, "formatLocale", () => (parcelRequire("8rG4l")).default);
$parcel$export(module.exports, "formatSpecifier", () => (parcelRequire("1C4ra")).default);
$parcel$export(module.exports, "FormatSpecifier", () => (parcelRequire("1C4ra")).FormatSpecifier);
$parcel$export(module.exports, "precisionFixed", () => (parcelRequire("4UzjU")).default);
$parcel$export(module.exports, "precisionPrefix", () => (parcelRequire("l3ng3")).default);
$parcel$export(module.exports, "precisionRound", () => (parcelRequire("lLQAg")).default);

var $haUiJ = parcelRequire("haUiJ");

var $8rG4l = parcelRequire("8rG4l");

var $1C4ra = parcelRequire("1C4ra");

var $4UzjU = parcelRequire("4UzjU");

var $l3ng3 = parcelRequire("l3ng3");

var $lLQAg = parcelRequire("lLQAg");

});
parcelRegister("haUiJ", function(module, exports) {

$parcel$export(module.exports, "format", () => $c80f0b11616fc486$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $c80f0b11616fc486$export$8d85692a469dde6f);
$parcel$export(module.exports, "default", () => $c80f0b11616fc486$export$2e2bcd8739ae039);

var $8rG4l = parcelRequire("8rG4l");
var $c80f0b11616fc486$var$locale;
var $c80f0b11616fc486$export$d9468344d3651243;
var $c80f0b11616fc486$export$8d85692a469dde6f;
$c80f0b11616fc486$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $c80f0b11616fc486$export$2e2bcd8739ae039(definition) {
    $c80f0b11616fc486$var$locale = (0, $8rG4l.default)(definition);
    $c80f0b11616fc486$export$d9468344d3651243 = $c80f0b11616fc486$var$locale.format;
    $c80f0b11616fc486$export$8d85692a469dde6f = $c80f0b11616fc486$var$locale.formatPrefix;
    return $c80f0b11616fc486$var$locale;
}

});
parcelRegister("8rG4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $62617a666e7c3d15$export$2e2bcd8739ae039);

var $2Fh2X = parcelRequire("2Fh2X");

var $dinCm = parcelRequire("dinCm");

var $1j2te = parcelRequire("1j2te");

var $1C4ra = parcelRequire("1C4ra");

var $2cDJX = parcelRequire("2cDJX");

var $ilI8Z = parcelRequire("ilI8Z");

var $b12w5 = parcelRequire("b12w5");

var $giwMC = parcelRequire("giwMC");
var $62617a666e7c3d15$var$map = Array.prototype.map, $62617a666e7c3d15$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $62617a666e7c3d15$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $giwMC.default) : (0, $dinCm.default)($62617a666e7c3d15$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $giwMC.default) : (0, $1j2te.default)($62617a666e7c3d15$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $1C4ra.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $ilI8Z.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $ilI8Z.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $2cDJX.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $62617a666e7c3d15$var$prefixes[8 + (0, $b12w5.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $1C4ra.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $2Fh2X.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $62617a666e7c3d15$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("2Fh2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0ca2361b1a94c4$export$2e2bcd8739ae039);

var $Tz3yQ = parcelRequire("Tz3yQ");
function $1f0ca2361b1a94c4$export$2e2bcd8739ae039(x) {
    return x = (0, $Tz3yQ.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("Tz3yQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a7054a5881fce7d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $0a7054a5881fce7d$export$8f8e23dd27dc19f5);
function $0a7054a5881fce7d$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0a7054a5881fce7d$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("dinCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9adf46cec61834c7$export$2e2bcd8739ae039);
function $9adf46cec61834c7$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("1j2te", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f397b5d27f63def$export$2e2bcd8739ae039);
function $0f397b5d27f63def$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("1C4ra", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ccc82fd043e3f4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FormatSpecifier", () => $12ccc82fd043e3f4$export$963aac351db36ed4);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $12ccc82fd043e3f4$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $12ccc82fd043e3f4$export$2e2bcd8739ae039(specifier) {
    if (!(match = $12ccc82fd043e3f4$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $12ccc82fd043e3f4$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$12ccc82fd043e3f4$export$2e2bcd8739ae039.prototype = $12ccc82fd043e3f4$export$963aac351db36ed4.prototype; // instanceof
function $12ccc82fd043e3f4$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$12ccc82fd043e3f4$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("2cDJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ab875c7e0fd77a$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $19ab875c7e0fd77a$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("ilI8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5bc6e3a71a12c77$export$2e2bcd8739ae039);

var $Tz3yQ = parcelRequire("Tz3yQ");

var $b12w5 = parcelRequire("b12w5");

var $4KVJ5 = parcelRequire("4KVJ5");
var $d5bc6e3a71a12c77$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $Tz3yQ.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $4KVJ5.default)(x * 100, p);
    },
    "r": (0, $4KVJ5.default),
    "s": (0, $b12w5.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("b12w5", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $8051bd695055f2bf$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $8051bd695055f2bf$export$2e2bcd8739ae039);

var $Tz3yQ = parcelRequire("Tz3yQ");
var $8051bd695055f2bf$export$6863724d9a42263;
function $8051bd695055f2bf$export$2e2bcd8739ae039(x, p) {
    var d = (0, $Tz3yQ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($8051bd695055f2bf$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $Tz3yQ.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("4KVJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $37683c8547f3581d$export$2e2bcd8739ae039);

var $Tz3yQ = parcelRequire("Tz3yQ");
function $37683c8547f3581d$export$2e2bcd8739ae039(x, p) {
    var d = (0, $Tz3yQ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("giwMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd7c1d740c62154$export$2e2bcd8739ae039);
function $bdd7c1d740c62154$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("4UzjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3937ca35dec01e74$export$2e2bcd8739ae039);

var $2Fh2X = parcelRequire("2Fh2X");
function $3937ca35dec01e74$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $2Fh2X.default)(Math.abs(step)));
}

});

parcelRegister("l3ng3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f53beb5691f47081$export$2e2bcd8739ae039);

var $2Fh2X = parcelRequire("2Fh2X");
function $f53beb5691f47081$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $2Fh2X.default)(value) / 3))) * 3 - (0, $2Fh2X.default)(Math.abs(step)));
}

});

parcelRegister("lLQAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd96c6d42ddb12b5$export$2e2bcd8739ae039);

var $2Fh2X = parcelRequire("2Fh2X");
function $fd96c6d42ddb12b5$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $2Fh2X.default)(max) - (0, $2Fh2X.default)(step)) + 1;
}

});


parcelRegister("cUtk9", function(module, exports) {

$parcel$export(module.exports, "geoArea", () => (parcelRequire("YU0K3")).default);
$parcel$export(module.exports, "geoBounds", () => (parcelRequire("jn8gQ")).default);
$parcel$export(module.exports, "geoCentroid", () => (parcelRequire("a2Ud9")).default);
$parcel$export(module.exports, "geoCircle", () => (parcelRequire("1TYNa")).default);
$parcel$export(module.exports, "geoClipAntimeridian", () => (parcelRequire("coMxq")).default);
$parcel$export(module.exports, "geoClipCircle", () => (parcelRequire("eF197")).default);
$parcel$export(module.exports, "geoClipExtent", () => (parcelRequire("1pl6s")).default);
$parcel$export(module.exports, "geoClipRectangle", () => (parcelRequire("aYocN")).default);
$parcel$export(module.exports, "geoContains", () => (parcelRequire("aHGMm")).default);
$parcel$export(module.exports, "geoDistance", () => (parcelRequire("9wJ1q")).default);
$parcel$export(module.exports, "geoGraticule", () => (parcelRequire("eYegQ")).default);
$parcel$export(module.exports, "geoGraticule10", () => (parcelRequire("eYegQ")).graticule10);
$parcel$export(module.exports, "geoInterpolate", () => (parcelRequire("4UZHq")).default);
$parcel$export(module.exports, "geoLength", () => (parcelRequire("8sz9q")).default);
$parcel$export(module.exports, "geoPath", () => (parcelRequire("86Qdc")).default);
$parcel$export(module.exports, "geoAlbers", () => (parcelRequire("2O9Dv")).default);
$parcel$export(module.exports, "geoAlbersUsa", () => (parcelRequire("4BLTa")).default);
$parcel$export(module.exports, "geoAzimuthalEqualArea", () => (parcelRequire("iBZjK")).default);
$parcel$export(module.exports, "geoAzimuthalEqualAreaRaw", () => (parcelRequire("iBZjK")).azimuthalEqualAreaRaw);
$parcel$export(module.exports, "geoAzimuthalEquidistant", () => (parcelRequire("6mNYZ")).default);
$parcel$export(module.exports, "geoAzimuthalEquidistantRaw", () => (parcelRequire("6mNYZ")).azimuthalEquidistantRaw);
$parcel$export(module.exports, "geoConicConformal", () => (parcelRequire("3LCvH")).default);
$parcel$export(module.exports, "geoConicConformalRaw", () => (parcelRequire("3LCvH")).conicConformalRaw);
$parcel$export(module.exports, "geoConicEqualArea", () => (parcelRequire("k4tPe")).default);
$parcel$export(module.exports, "geoConicEqualAreaRaw", () => (parcelRequire("k4tPe")).conicEqualAreaRaw);
$parcel$export(module.exports, "geoConicEquidistant", () => (parcelRequire("9351D")).default);
$parcel$export(module.exports, "geoConicEquidistantRaw", () => (parcelRequire("9351D")).conicEquidistantRaw);
$parcel$export(module.exports, "geoEqualEarth", () => (parcelRequire("jF6JO")).default);
$parcel$export(module.exports, "geoEqualEarthRaw", () => (parcelRequire("jF6JO")).equalEarthRaw);
$parcel$export(module.exports, "geoEquirectangular", () => (parcelRequire("gJXwU")).default);
$parcel$export(module.exports, "geoEquirectangularRaw", () => (parcelRequire("gJXwU")).equirectangularRaw);
$parcel$export(module.exports, "geoGnomonic", () => (parcelRequire("1OeV0")).default);
$parcel$export(module.exports, "geoGnomonicRaw", () => (parcelRequire("1OeV0")).gnomonicRaw);
$parcel$export(module.exports, "geoIdentity", () => (parcelRequire("1i3k9")).default);
$parcel$export(module.exports, "geoProjection", () => (parcelRequire("66c7U")).default);
$parcel$export(module.exports, "geoProjectionMutator", () => (parcelRequire("66c7U")).projectionMutator);
$parcel$export(module.exports, "geoMercator", () => (parcelRequire("gIZcl")).default);
$parcel$export(module.exports, "geoMercatorRaw", () => (parcelRequire("gIZcl")).mercatorRaw);
$parcel$export(module.exports, "geoNaturalEarth1", () => (parcelRequire("kh9hL")).default);
$parcel$export(module.exports, "geoNaturalEarth1Raw", () => (parcelRequire("kh9hL")).naturalEarth1Raw);
$parcel$export(module.exports, "geoOrthographic", () => (parcelRequire("60S88")).default);
$parcel$export(module.exports, "geoOrthographicRaw", () => (parcelRequire("60S88")).orthographicRaw);
$parcel$export(module.exports, "geoStereographic", () => (parcelRequire("jBilA")).default);
$parcel$export(module.exports, "geoStereographicRaw", () => (parcelRequire("jBilA")).stereographicRaw);
$parcel$export(module.exports, "geoTransverseMercator", () => (parcelRequire("2mZe2")).default);
$parcel$export(module.exports, "geoTransverseMercatorRaw", () => (parcelRequire("2mZe2")).transverseMercatorRaw);
$parcel$export(module.exports, "geoRotation", () => (parcelRequire("dhP4q")).default);
$parcel$export(module.exports, "geoStream", () => (parcelRequire("g6Z33")).default);
$parcel$export(module.exports, "geoTransform", () => (parcelRequire("bWfHn")).default);

var $YU0K3 = parcelRequire("YU0K3");

var $jn8gQ = parcelRequire("jn8gQ");

var $a2Ud9 = parcelRequire("a2Ud9");

var $1TYNa = parcelRequire("1TYNa");

var $coMxq = parcelRequire("coMxq");

var $eF197 = parcelRequire("eF197");

var $1pl6s = parcelRequire("1pl6s");

var $aYocN = parcelRequire("aYocN");

var $aHGMm = parcelRequire("aHGMm");

var $9wJ1q = parcelRequire("9wJ1q");

var $eYegQ = parcelRequire("eYegQ");

var $4UZHq = parcelRequire("4UZHq");

var $8sz9q = parcelRequire("8sz9q");

var $86Qdc = parcelRequire("86Qdc");

var $2O9Dv = parcelRequire("2O9Dv");

var $4BLTa = parcelRequire("4BLTa");

var $iBZjK = parcelRequire("iBZjK");

var $6mNYZ = parcelRequire("6mNYZ");

var $3LCvH = parcelRequire("3LCvH");

var $k4tPe = parcelRequire("k4tPe");

var $9351D = parcelRequire("9351D");

var $jF6JO = parcelRequire("jF6JO");

var $gJXwU = parcelRequire("gJXwU");

var $1OeV0 = parcelRequire("1OeV0");

var $1i3k9 = parcelRequire("1i3k9");

var $66c7U = parcelRequire("66c7U");

var $gIZcl = parcelRequire("gIZcl");

var $kh9hL = parcelRequire("kh9hL");

var $60S88 = parcelRequire("60S88");

var $jBilA = parcelRequire("jBilA");

var $2mZe2 = parcelRequire("2mZe2");

var $dhP4q = parcelRequire("dhP4q");

var $g6Z33 = parcelRequire("g6Z33");

var $bWfHn = parcelRequire("bWfHn");

});
parcelRegister("YU0K3", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", () => $0b710d52772e8a48$export$bf8f994332070c7f);
$parcel$export(module.exports, "areaStream", () => $0b710d52772e8a48$export$cb67cfa750ae69dc);
$parcel$export(module.exports, "default", () => $0b710d52772e8a48$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");

var $g6Z33 = parcelRequire("g6Z33");
var $0b710d52772e8a48$export$bf8f994332070c7f = (0, $ji7uQ.default)();
var $0b710d52772e8a48$var$areaSum = (0, $ji7uQ.default)(), $0b710d52772e8a48$var$lambda00, $0b710d52772e8a48$var$phi00, $0b710d52772e8a48$var$lambda0, $0b710d52772e8a48$var$cosPhi0, $0b710d52772e8a48$var$sinPhi0;
var $0b710d52772e8a48$export$cb67cfa750ae69dc = {
    point: (0, $9BJ1Y.default),
    lineStart: (0, $9BJ1Y.default),
    lineEnd: (0, $9BJ1Y.default),
    polygonStart: function() {
        $0b710d52772e8a48$export$bf8f994332070c7f.reset();
        $0b710d52772e8a48$export$cb67cfa750ae69dc.lineStart = $0b710d52772e8a48$var$areaRingStart;
        $0b710d52772e8a48$export$cb67cfa750ae69dc.lineEnd = $0b710d52772e8a48$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$0b710d52772e8a48$export$bf8f994332070c7f;
        $0b710d52772e8a48$var$areaSum.add(areaRing < 0 ? (0, $2ssN0.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $9BJ1Y.default);
    },
    sphere: function() {
        $0b710d52772e8a48$var$areaSum.add((0, $2ssN0.tau));
    }
};
function $0b710d52772e8a48$var$areaRingStart() {
    $0b710d52772e8a48$export$cb67cfa750ae69dc.point = $0b710d52772e8a48$var$areaPointFirst;
}
function $0b710d52772e8a48$var$areaRingEnd() {
    $0b710d52772e8a48$var$areaPoint($0b710d52772e8a48$var$lambda00, $0b710d52772e8a48$var$phi00);
}
function $0b710d52772e8a48$var$areaPointFirst(lambda, phi) {
    $0b710d52772e8a48$export$cb67cfa750ae69dc.point = $0b710d52772e8a48$var$areaPoint;
    $0b710d52772e8a48$var$lambda00 = lambda, $0b710d52772e8a48$var$phi00 = phi;
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    $0b710d52772e8a48$var$lambda0 = lambda, $0b710d52772e8a48$var$cosPhi0 = (0, $2ssN0.cos)(phi = phi / 2 + (0, $2ssN0.quarterPi)), $0b710d52772e8a48$var$sinPhi0 = (0, $2ssN0.sin)(phi);
}
function $0b710d52772e8a48$var$areaPoint(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    phi = phi / 2 + (0, $2ssN0.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $0b710d52772e8a48$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $2ssN0.cos)(phi), sinPhi = (0, $2ssN0.sin)(phi), k = $0b710d52772e8a48$var$sinPhi0 * sinPhi, u = $0b710d52772e8a48$var$cosPhi0 * cosPhi + k * (0, $2ssN0.cos)(adLambda), v = k * sdLambda * (0, $2ssN0.sin)(adLambda);
    $0b710d52772e8a48$export$bf8f994332070c7f.add((0, $2ssN0.atan2)(v, u));
    // Advance the previous points.
    $0b710d52772e8a48$var$lambda0 = lambda, $0b710d52772e8a48$var$cosPhi0 = cosPhi, $0b710d52772e8a48$var$sinPhi0 = sinPhi;
}
function $0b710d52772e8a48$export$2e2bcd8739ae039(object) {
    $0b710d52772e8a48$var$areaSum.reset();
    (0, $g6Z33.default)(object, $0b710d52772e8a48$export$cb67cfa750ae69dc);
    return $0b710d52772e8a48$var$areaSum * 2;
}

});
parcelRegister("ji7uQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b5836a8498af5c$export$2e2bcd8739ae039);
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $e0b5836a8498af5c$export$2e2bcd8739ae039() {
    return new $e0b5836a8498af5c$var$Adder;
}
function $e0b5836a8498af5c$var$Adder() {
    this.reset();
}
$e0b5836a8498af5c$var$Adder.prototype = {
    constructor: $e0b5836a8498af5c$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $e0b5836a8498af5c$var$add($e0b5836a8498af5c$var$temp, y, this.t);
        $e0b5836a8498af5c$var$add(this, $e0b5836a8498af5c$var$temp.s, this.s);
        if (this.s) this.t += $e0b5836a8498af5c$var$temp.t;
        else this.s = $e0b5836a8498af5c$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $e0b5836a8498af5c$var$temp = new $e0b5836a8498af5c$var$Adder;
function $e0b5836a8498af5c$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

});

parcelRegister("2ssN0", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => $1ca4874470794eff$export$6c421550c66a327d);
$parcel$export(module.exports, "epsilon2", () => $1ca4874470794eff$export$92c06fba281fe81b);
$parcel$export(module.exports, "pi", () => $1ca4874470794eff$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $1ca4874470794eff$export$e51408a300e8929a);
$parcel$export(module.exports, "quarterPi", () => $1ca4874470794eff$export$c39a5cba78ea0fc2);
$parcel$export(module.exports, "tau", () => $1ca4874470794eff$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "degrees", () => $1ca4874470794eff$export$41fc368e1a942b97);
$parcel$export(module.exports, "radians", () => $1ca4874470794eff$export$8449e153fbd325fc);
$parcel$export(module.exports, "abs", () => $1ca4874470794eff$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan", () => $1ca4874470794eff$export$628dc4eed22b0fbd);
$parcel$export(module.exports, "atan2", () => $1ca4874470794eff$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $1ca4874470794eff$export$50d414a77b60d802);
$parcel$export(module.exports, "ceil", () => $1ca4874470794eff$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "exp", () => $1ca4874470794eff$export$b310ec824aaee37f);
$parcel$export(module.exports, "log", () => $1ca4874470794eff$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "pow", () => $1ca4874470794eff$export$9c297f60e22e3389);
$parcel$export(module.exports, "sin", () => $1ca4874470794eff$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sign", () => $1ca4874470794eff$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "sqrt", () => $1ca4874470794eff$export$eba8049fb5020b81);
$parcel$export(module.exports, "tan", () => $1ca4874470794eff$export$fcdd3b0b3246a325);
$parcel$export(module.exports, "acos", () => $1ca4874470794eff$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $1ca4874470794eff$export$41726bdb1fc63f);
$parcel$export(module.exports, "haversin", () => $1ca4874470794eff$export$e808712c2966e662);
var $1ca4874470794eff$export$6c421550c66a327d = 1e-6;
var $1ca4874470794eff$export$92c06fba281fe81b = 1e-12;
var $1ca4874470794eff$export$18c7bea995a110f = Math.PI;
var $1ca4874470794eff$export$e51408a300e8929a = $1ca4874470794eff$export$18c7bea995a110f / 2;
var $1ca4874470794eff$export$c39a5cba78ea0fc2 = $1ca4874470794eff$export$18c7bea995a110f / 4;
var $1ca4874470794eff$export$a4b4b4d4d776fe92 = $1ca4874470794eff$export$18c7bea995a110f * 2;
var $1ca4874470794eff$export$41fc368e1a942b97 = 180 / $1ca4874470794eff$export$18c7bea995a110f;
var $1ca4874470794eff$export$8449e153fbd325fc = $1ca4874470794eff$export$18c7bea995a110f / 180;
var $1ca4874470794eff$export$2335f513bbd82c6d = Math.abs;
var $1ca4874470794eff$export$628dc4eed22b0fbd = Math.atan;
var $1ca4874470794eff$export$b8b770ee6a0d9760 = Math.atan2;
var $1ca4874470794eff$export$50d414a77b60d802 = Math.cos;
var $1ca4874470794eff$export$803ce6b71a0a94b2 = Math.ceil;
var $1ca4874470794eff$export$b310ec824aaee37f = Math.exp;
var $1ca4874470794eff$export$a3fe094919f356fd = Math.floor;
var $1ca4874470794eff$export$bef1f36f5486a6a3 = Math.log;
var $1ca4874470794eff$export$9c297f60e22e3389 = Math.pow;
var $1ca4874470794eff$export$5de3937cb4b592ed = Math.sin;
var $1ca4874470794eff$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $1ca4874470794eff$export$eba8049fb5020b81 = Math.sqrt;
var $1ca4874470794eff$export$fcdd3b0b3246a325 = Math.tan;
function $1ca4874470794eff$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $1ca4874470794eff$export$18c7bea995a110f : Math.acos(x);
}
function $1ca4874470794eff$export$41726bdb1fc63f(x) {
    return x > 1 ? $1ca4874470794eff$export$e51408a300e8929a : x < -1 ? -$1ca4874470794eff$export$e51408a300e8929a : Math.asin(x);
}
function $1ca4874470794eff$export$e808712c2966e662(x) {
    return (x = $1ca4874470794eff$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("9BJ1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fea7ff02031e46e$export$2e2bcd8739ae039);
function $6fea7ff02031e46e$export$2e2bcd8739ae039() {}

});

parcelRegister("g6Z33", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbac8fc7d924948b$export$2e2bcd8739ae039);
function $bbac8fc7d924948b$var$streamGeometry(geometry, stream) {
    if (geometry && $bbac8fc7d924948b$var$streamGeometryType.hasOwnProperty(geometry.type)) $bbac8fc7d924948b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $bbac8fc7d924948b$var$streamObjectType = {
    Feature: function(object, stream) {
        $bbac8fc7d924948b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$bbac8fc7d924948b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $bbac8fc7d924948b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $bbac8fc7d924948b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$bbac8fc7d924948b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $bbac8fc7d924948b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$bbac8fc7d924948b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$bbac8fc7d924948b$var$streamGeometry(geometries[i], stream);
    }
};
function $bbac8fc7d924948b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $bbac8fc7d924948b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$bbac8fc7d924948b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $bbac8fc7d924948b$export$2e2bcd8739ae039(object, stream) {
    if (object && $bbac8fc7d924948b$var$streamObjectType.hasOwnProperty(object.type)) $bbac8fc7d924948b$var$streamObjectType[object.type](object, stream);
    else $bbac8fc7d924948b$var$streamGeometry(object, stream);
}

});


parcelRegister("jn8gQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a694b30f8801ea$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $YU0K3 = parcelRequire("YU0K3");

var $ikdcr = parcelRequire("ikdcr");

var $2ssN0 = parcelRequire("2ssN0");

var $g6Z33 = parcelRequire("g6Z33");
var $e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$phi0, $e1a694b30f8801ea$var$lambda1, $e1a694b30f8801ea$var$phi1, $e1a694b30f8801ea$var$lambda2, $e1a694b30f8801ea$var$lambda00, $e1a694b30f8801ea$var$phi00, $e1a694b30f8801ea$var$p0, $e1a694b30f8801ea$var$deltaSum = (0, $ji7uQ.default)(), $e1a694b30f8801ea$var$ranges, $e1a694b30f8801ea$var$range;
var $e1a694b30f8801ea$var$boundsStream = {
    point: $e1a694b30f8801ea$var$boundsPoint,
    lineStart: $e1a694b30f8801ea$var$boundsLineStart,
    lineEnd: $e1a694b30f8801ea$var$boundsLineEnd,
    polygonStart: function() {
        $e1a694b30f8801ea$var$boundsStream.point = $e1a694b30f8801ea$var$boundsRingPoint;
        $e1a694b30f8801ea$var$boundsStream.lineStart = $e1a694b30f8801ea$var$boundsRingStart;
        $e1a694b30f8801ea$var$boundsStream.lineEnd = $e1a694b30f8801ea$var$boundsRingEnd;
        $e1a694b30f8801ea$var$deltaSum.reset();
        (0, $YU0K3.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $YU0K3.areaStream).polygonEnd();
        $e1a694b30f8801ea$var$boundsStream.point = $e1a694b30f8801ea$var$boundsPoint;
        $e1a694b30f8801ea$var$boundsStream.lineStart = $e1a694b30f8801ea$var$boundsLineStart;
        $e1a694b30f8801ea$var$boundsStream.lineEnd = $e1a694b30f8801ea$var$boundsLineEnd;
        if ((0, $YU0K3.areaRingSum) < 0) $e1a694b30f8801ea$var$lambda0 = -($e1a694b30f8801ea$var$lambda1 = 180), $e1a694b30f8801ea$var$phi0 = -($e1a694b30f8801ea$var$phi1 = 90);
        else if ($e1a694b30f8801ea$var$deltaSum > (0, $2ssN0.epsilon)) $e1a694b30f8801ea$var$phi1 = 90;
        else if ($e1a694b30f8801ea$var$deltaSum < -(0, $2ssN0.epsilon)) $e1a694b30f8801ea$var$phi0 = -90;
        $e1a694b30f8801ea$var$range[0] = $e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$range[1] = $e1a694b30f8801ea$var$lambda1;
    },
    sphere: function() {
        $e1a694b30f8801ea$var$lambda0 = -($e1a694b30f8801ea$var$lambda1 = 180), $e1a694b30f8801ea$var$phi0 = -($e1a694b30f8801ea$var$phi1 = 90);
    }
};
function $e1a694b30f8801ea$var$boundsPoint(lambda, phi) {
    $e1a694b30f8801ea$var$ranges.push($e1a694b30f8801ea$var$range = [
        $e1a694b30f8801ea$var$lambda0 = lambda,
        $e1a694b30f8801ea$var$lambda1 = lambda
    ]);
    if (phi < $e1a694b30f8801ea$var$phi0) $e1a694b30f8801ea$var$phi0 = phi;
    if (phi > $e1a694b30f8801ea$var$phi1) $e1a694b30f8801ea$var$phi1 = phi;
}
function $e1a694b30f8801ea$var$linePoint(lambda, phi) {
    var p = (0, $ikdcr.cartesian)([
        lambda * (0, $2ssN0.radians),
        phi * (0, $2ssN0.radians)
    ]);
    if ($e1a694b30f8801ea$var$p0) {
        var normal = (0, $ikdcr.cartesianCross)($e1a694b30f8801ea$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $ikdcr.cartesianCross)(equatorial, normal);
        (0, $ikdcr.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $ikdcr.spherical)(inflection);
        var delta = lambda - $e1a694b30f8801ea$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $2ssN0.degrees) * sign, phii, antimeridian = (0, $2ssN0.abs)(delta) > 180;
        if (antimeridian ^ (sign * $e1a694b30f8801ea$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $2ssN0.degrees);
            if (phii > $e1a694b30f8801ea$var$phi1) $e1a694b30f8801ea$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $e1a694b30f8801ea$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $2ssN0.degrees);
            if (phii < $e1a694b30f8801ea$var$phi0) $e1a694b30f8801ea$var$phi0 = phii;
        } else {
            if (phi < $e1a694b30f8801ea$var$phi0) $e1a694b30f8801ea$var$phi0 = phi;
            if (phi > $e1a694b30f8801ea$var$phi1) $e1a694b30f8801ea$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $e1a694b30f8801ea$var$lambda2) {
                if ($e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, lambda) > $e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$lambda1)) $e1a694b30f8801ea$var$lambda1 = lambda;
            } else if ($e1a694b30f8801ea$var$angle(lambda, $e1a694b30f8801ea$var$lambda1) > $e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$lambda1)) $e1a694b30f8801ea$var$lambda0 = lambda;
        } else if ($e1a694b30f8801ea$var$lambda1 >= $e1a694b30f8801ea$var$lambda0) {
            if (lambda < $e1a694b30f8801ea$var$lambda0) $e1a694b30f8801ea$var$lambda0 = lambda;
            if (lambda > $e1a694b30f8801ea$var$lambda1) $e1a694b30f8801ea$var$lambda1 = lambda;
        } else {
            if (lambda > $e1a694b30f8801ea$var$lambda2) {
                if ($e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, lambda) > $e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$lambda1)) $e1a694b30f8801ea$var$lambda1 = lambda;
            } else if ($e1a694b30f8801ea$var$angle(lambda, $e1a694b30f8801ea$var$lambda1) > $e1a694b30f8801ea$var$angle($e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$lambda1)) $e1a694b30f8801ea$var$lambda0 = lambda;
        }
    } else $e1a694b30f8801ea$var$ranges.push($e1a694b30f8801ea$var$range = [
        $e1a694b30f8801ea$var$lambda0 = lambda,
        $e1a694b30f8801ea$var$lambda1 = lambda
    ]);
    if (phi < $e1a694b30f8801ea$var$phi0) $e1a694b30f8801ea$var$phi0 = phi;
    if (phi > $e1a694b30f8801ea$var$phi1) $e1a694b30f8801ea$var$phi1 = phi;
    $e1a694b30f8801ea$var$p0 = p, $e1a694b30f8801ea$var$lambda2 = lambda;
}
function $e1a694b30f8801ea$var$boundsLineStart() {
    $e1a694b30f8801ea$var$boundsStream.point = $e1a694b30f8801ea$var$linePoint;
}
function $e1a694b30f8801ea$var$boundsLineEnd() {
    $e1a694b30f8801ea$var$range[0] = $e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$range[1] = $e1a694b30f8801ea$var$lambda1;
    $e1a694b30f8801ea$var$boundsStream.point = $e1a694b30f8801ea$var$boundsPoint;
    $e1a694b30f8801ea$var$p0 = null;
}
function $e1a694b30f8801ea$var$boundsRingPoint(lambda, phi) {
    if ($e1a694b30f8801ea$var$p0) {
        var delta = lambda - $e1a694b30f8801ea$var$lambda2;
        $e1a694b30f8801ea$var$deltaSum.add((0, $2ssN0.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $e1a694b30f8801ea$var$lambda00 = lambda, $e1a694b30f8801ea$var$phi00 = phi;
    (0, $YU0K3.areaStream).point(lambda, phi);
    $e1a694b30f8801ea$var$linePoint(lambda, phi);
}
function $e1a694b30f8801ea$var$boundsRingStart() {
    (0, $YU0K3.areaStream).lineStart();
}
function $e1a694b30f8801ea$var$boundsRingEnd() {
    $e1a694b30f8801ea$var$boundsRingPoint($e1a694b30f8801ea$var$lambda00, $e1a694b30f8801ea$var$phi00);
    (0, $YU0K3.areaStream).lineEnd();
    if ((0, $2ssN0.abs)($e1a694b30f8801ea$var$deltaSum) > (0, $2ssN0.epsilon)) $e1a694b30f8801ea$var$lambda0 = -($e1a694b30f8801ea$var$lambda1 = 180);
    $e1a694b30f8801ea$var$range[0] = $e1a694b30f8801ea$var$lambda0, $e1a694b30f8801ea$var$range[1] = $e1a694b30f8801ea$var$lambda1;
    $e1a694b30f8801ea$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $e1a694b30f8801ea$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $e1a694b30f8801ea$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $e1a694b30f8801ea$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $e1a694b30f8801ea$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $e1a694b30f8801ea$var$phi1 = $e1a694b30f8801ea$var$lambda1 = -($e1a694b30f8801ea$var$lambda0 = $e1a694b30f8801ea$var$phi0 = Infinity);
    $e1a694b30f8801ea$var$ranges = [];
    (0, $g6Z33.default)(feature, $e1a694b30f8801ea$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $e1a694b30f8801ea$var$ranges.length) {
        $e1a694b30f8801ea$var$ranges.sort($e1a694b30f8801ea$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $e1a694b30f8801ea$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $e1a694b30f8801ea$var$ranges[i];
            if ($e1a694b30f8801ea$var$rangeContains(a, b[0]) || $e1a694b30f8801ea$var$rangeContains(a, b[1])) {
                if ($e1a694b30f8801ea$var$angle(a[0], b[1]) > $e1a694b30f8801ea$var$angle(a[0], a[1])) a[1] = b[1];
                if ($e1a694b30f8801ea$var$angle(b[0], a[1]) > $e1a694b30f8801ea$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $e1a694b30f8801ea$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $e1a694b30f8801ea$var$lambda0 = b[0], $e1a694b30f8801ea$var$lambda1 = a[1];
        }
    }
    $e1a694b30f8801ea$var$ranges = $e1a694b30f8801ea$var$range = null;
    return $e1a694b30f8801ea$var$lambda0 === Infinity || $e1a694b30f8801ea$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $e1a694b30f8801ea$var$lambda0,
            $e1a694b30f8801ea$var$phi0
        ],
        [
            $e1a694b30f8801ea$var$lambda1,
            $e1a694b30f8801ea$var$phi1
        ]
    ];
}

});
parcelRegister("ikdcr", function(module, exports) {

$parcel$export(module.exports, "spherical", () => $d5745572949c1b44$export$12f9ad44fe773943);
$parcel$export(module.exports, "cartesian", () => $d5745572949c1b44$export$6e6697ef026a96);
$parcel$export(module.exports, "cartesianDot", () => $d5745572949c1b44$export$2ef80f51436a9de9);
$parcel$export(module.exports, "cartesianCross", () => $d5745572949c1b44$export$4763f5351b14293f);
$parcel$export(module.exports, "cartesianAddInPlace", () => $d5745572949c1b44$export$e62eba72fc898eae);
$parcel$export(module.exports, "cartesianScale", () => $d5745572949c1b44$export$52d0ee3fc868d452);
$parcel$export(module.exports, "cartesianNormalizeInPlace", () => $d5745572949c1b44$export$6789498aec2cb34b);

var $2ssN0 = parcelRequire("2ssN0");
function $d5745572949c1b44$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $2ssN0.atan2)(cartesian[1], cartesian[0]),
        (0, $2ssN0.asin)(cartesian[2])
    ];
}
function $d5745572949c1b44$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $2ssN0.cos)(phi);
    return [
        cosPhi * (0, $2ssN0.cos)(lambda),
        cosPhi * (0, $2ssN0.sin)(lambda),
        (0, $2ssN0.sin)(phi)
    ];
}
function $d5745572949c1b44$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $d5745572949c1b44$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $d5745572949c1b44$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $d5745572949c1b44$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $d5745572949c1b44$export$6789498aec2cb34b(d) {
    var l = (0, $2ssN0.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("a2Ud9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7505b19e65e206cc$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");

var $g6Z33 = parcelRequire("g6Z33");
var $7505b19e65e206cc$var$W0, $7505b19e65e206cc$var$W1, $7505b19e65e206cc$var$X0, $7505b19e65e206cc$var$Y0, $7505b19e65e206cc$var$Z0, $7505b19e65e206cc$var$X1, $7505b19e65e206cc$var$Y1, $7505b19e65e206cc$var$Z1, $7505b19e65e206cc$var$X2, $7505b19e65e206cc$var$Y2, $7505b19e65e206cc$var$Z2, $7505b19e65e206cc$var$lambda00, $7505b19e65e206cc$var$phi00, $7505b19e65e206cc$var$x0, $7505b19e65e206cc$var$y0, $7505b19e65e206cc$var$z0; // previous point
var $7505b19e65e206cc$var$centroidStream = {
    sphere: (0, $9BJ1Y.default),
    point: $7505b19e65e206cc$var$centroidPoint,
    lineStart: $7505b19e65e206cc$var$centroidLineStart,
    lineEnd: $7505b19e65e206cc$var$centroidLineEnd,
    polygonStart: function() {
        $7505b19e65e206cc$var$centroidStream.lineStart = $7505b19e65e206cc$var$centroidRingStart;
        $7505b19e65e206cc$var$centroidStream.lineEnd = $7505b19e65e206cc$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $7505b19e65e206cc$var$centroidStream.lineStart = $7505b19e65e206cc$var$centroidLineStart;
        $7505b19e65e206cc$var$centroidStream.lineEnd = $7505b19e65e206cc$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $7505b19e65e206cc$var$centroidPoint(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    var cosPhi = (0, $2ssN0.cos)(phi);
    $7505b19e65e206cc$var$centroidPointCartesian(cosPhi * (0, $2ssN0.cos)(lambda), cosPhi * (0, $2ssN0.sin)(lambda), (0, $2ssN0.sin)(phi));
}
function $7505b19e65e206cc$var$centroidPointCartesian(x, y, z) {
    ++$7505b19e65e206cc$var$W0;
    $7505b19e65e206cc$var$X0 += (x - $7505b19e65e206cc$var$X0) / $7505b19e65e206cc$var$W0;
    $7505b19e65e206cc$var$Y0 += (y - $7505b19e65e206cc$var$Y0) / $7505b19e65e206cc$var$W0;
    $7505b19e65e206cc$var$Z0 += (z - $7505b19e65e206cc$var$Z0) / $7505b19e65e206cc$var$W0;
}
function $7505b19e65e206cc$var$centroidLineStart() {
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidLinePointFirst;
}
function $7505b19e65e206cc$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    var cosPhi = (0, $2ssN0.cos)(phi);
    $7505b19e65e206cc$var$x0 = cosPhi * (0, $2ssN0.cos)(lambda);
    $7505b19e65e206cc$var$y0 = cosPhi * (0, $2ssN0.sin)(lambda);
    $7505b19e65e206cc$var$z0 = (0, $2ssN0.sin)(phi);
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidLinePoint;
    $7505b19e65e206cc$var$centroidPointCartesian($7505b19e65e206cc$var$x0, $7505b19e65e206cc$var$y0, $7505b19e65e206cc$var$z0);
}
function $7505b19e65e206cc$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    var cosPhi = (0, $2ssN0.cos)(phi), x = cosPhi * (0, $2ssN0.cos)(lambda), y = cosPhi * (0, $2ssN0.sin)(lambda), z = (0, $2ssN0.sin)(phi), w = (0, $2ssN0.atan2)((0, $2ssN0.sqrt)((w = $7505b19e65e206cc$var$y0 * z - $7505b19e65e206cc$var$z0 * y) * w + (w = $7505b19e65e206cc$var$z0 * x - $7505b19e65e206cc$var$x0 * z) * w + (w = $7505b19e65e206cc$var$x0 * y - $7505b19e65e206cc$var$y0 * x) * w), $7505b19e65e206cc$var$x0 * x + $7505b19e65e206cc$var$y0 * y + $7505b19e65e206cc$var$z0 * z);
    $7505b19e65e206cc$var$W1 += w;
    $7505b19e65e206cc$var$X1 += w * ($7505b19e65e206cc$var$x0 + ($7505b19e65e206cc$var$x0 = x));
    $7505b19e65e206cc$var$Y1 += w * ($7505b19e65e206cc$var$y0 + ($7505b19e65e206cc$var$y0 = y));
    $7505b19e65e206cc$var$Z1 += w * ($7505b19e65e206cc$var$z0 + ($7505b19e65e206cc$var$z0 = z));
    $7505b19e65e206cc$var$centroidPointCartesian($7505b19e65e206cc$var$x0, $7505b19e65e206cc$var$y0, $7505b19e65e206cc$var$z0);
}
function $7505b19e65e206cc$var$centroidLineEnd() {
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $7505b19e65e206cc$var$centroidRingStart() {
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidRingPointFirst;
}
function $7505b19e65e206cc$var$centroidRingEnd() {
    $7505b19e65e206cc$var$centroidRingPoint($7505b19e65e206cc$var$lambda00, $7505b19e65e206cc$var$phi00);
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidPoint;
}
function $7505b19e65e206cc$var$centroidRingPointFirst(lambda, phi) {
    $7505b19e65e206cc$var$lambda00 = lambda, $7505b19e65e206cc$var$phi00 = phi;
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    $7505b19e65e206cc$var$centroidStream.point = $7505b19e65e206cc$var$centroidRingPoint;
    var cosPhi = (0, $2ssN0.cos)(phi);
    $7505b19e65e206cc$var$x0 = cosPhi * (0, $2ssN0.cos)(lambda);
    $7505b19e65e206cc$var$y0 = cosPhi * (0, $2ssN0.sin)(lambda);
    $7505b19e65e206cc$var$z0 = (0, $2ssN0.sin)(phi);
    $7505b19e65e206cc$var$centroidPointCartesian($7505b19e65e206cc$var$x0, $7505b19e65e206cc$var$y0, $7505b19e65e206cc$var$z0);
}
function $7505b19e65e206cc$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    var cosPhi = (0, $2ssN0.cos)(phi), x = cosPhi * (0, $2ssN0.cos)(lambda), y = cosPhi * (0, $2ssN0.sin)(lambda), z = (0, $2ssN0.sin)(phi), cx = $7505b19e65e206cc$var$y0 * z - $7505b19e65e206cc$var$z0 * y, cy = $7505b19e65e206cc$var$z0 * x - $7505b19e65e206cc$var$x0 * z, cz = $7505b19e65e206cc$var$x0 * y - $7505b19e65e206cc$var$y0 * x, m = (0, $2ssN0.sqrt)(cx * cx + cy * cy + cz * cz), w = (0, $2ssN0.asin)(m), v = m && -w / m; // area weight multiplier
    $7505b19e65e206cc$var$X2 += v * cx;
    $7505b19e65e206cc$var$Y2 += v * cy;
    $7505b19e65e206cc$var$Z2 += v * cz;
    $7505b19e65e206cc$var$W1 += w;
    $7505b19e65e206cc$var$X1 += w * ($7505b19e65e206cc$var$x0 + ($7505b19e65e206cc$var$x0 = x));
    $7505b19e65e206cc$var$Y1 += w * ($7505b19e65e206cc$var$y0 + ($7505b19e65e206cc$var$y0 = y));
    $7505b19e65e206cc$var$Z1 += w * ($7505b19e65e206cc$var$z0 + ($7505b19e65e206cc$var$z0 = z));
    $7505b19e65e206cc$var$centroidPointCartesian($7505b19e65e206cc$var$x0, $7505b19e65e206cc$var$y0, $7505b19e65e206cc$var$z0);
}
function $7505b19e65e206cc$export$2e2bcd8739ae039(object) {
    $7505b19e65e206cc$var$W0 = $7505b19e65e206cc$var$W1 = $7505b19e65e206cc$var$X0 = $7505b19e65e206cc$var$Y0 = $7505b19e65e206cc$var$Z0 = $7505b19e65e206cc$var$X1 = $7505b19e65e206cc$var$Y1 = $7505b19e65e206cc$var$Z1 = $7505b19e65e206cc$var$X2 = $7505b19e65e206cc$var$Y2 = $7505b19e65e206cc$var$Z2 = 0;
    (0, $g6Z33.default)(object, $7505b19e65e206cc$var$centroidStream);
    var x = $7505b19e65e206cc$var$X2, y = $7505b19e65e206cc$var$Y2, z = $7505b19e65e206cc$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $2ssN0.epsilon2)) {
        x = $7505b19e65e206cc$var$X1, y = $7505b19e65e206cc$var$Y1, z = $7505b19e65e206cc$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($7505b19e65e206cc$var$W1 < (0, $2ssN0.epsilon)) x = $7505b19e65e206cc$var$X0, y = $7505b19e65e206cc$var$Y0, z = $7505b19e65e206cc$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $2ssN0.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $2ssN0.atan2)(y, x) * (0, $2ssN0.degrees),
        (0, $2ssN0.asin)(z / (0, $2ssN0.sqrt)(m)) * (0, $2ssN0.degrees)
    ];
}

});

parcelRegister("1TYNa", function(module, exports) {

$parcel$export(module.exports, "circleStream", () => $162a158a65c890c3$export$b5441eb324cd8d4e);
$parcel$export(module.exports, "default", () => $162a158a65c890c3$export$2e2bcd8739ae039);

var $ikdcr = parcelRequire("ikdcr");

var $6gjUq = parcelRequire("6gjUq");

var $2ssN0 = parcelRequire("2ssN0");

var $dhP4q = parcelRequire("dhP4q");
function $162a158a65c890c3$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $2ssN0.cos)(radius), sinRadius = (0, $2ssN0.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $2ssN0.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $162a158a65c890c3$var$circleRadius(cosRadius, t0);
        t1 = $162a158a65c890c3$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $2ssN0.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $ikdcr.spherical)([
            cosRadius,
            -sinRadius * (0, $2ssN0.cos)(t),
            -sinRadius * (0, $2ssN0.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $162a158a65c890c3$var$circleRadius(cosRadius, point) {
    point = (0, $ikdcr.cartesian)(point), point[0] -= cosRadius;
    (0, $ikdcr.cartesianNormalizeInPlace)(point);
    var radius = (0, $2ssN0.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $2ssN0.tau) - (0, $2ssN0.epsilon)) % (0, $2ssN0.tau);
}
function $162a158a65c890c3$export$2e2bcd8739ae039() {
    var center = (0, $6gjUq.default)([
        0,
        0
    ]), radius = (0, $6gjUq.default)(90), precision = (0, $6gjUq.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $2ssN0.degrees), x[1] *= (0, $2ssN0.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $2ssN0.radians), p = precision.apply(this, arguments) * (0, $2ssN0.radians);
        ring = [];
        rotate = (0, $dhP4q.rotateRadians)(-c[0] * (0, $2ssN0.radians), -c[1] * (0, $2ssN0.radians), 0).invert;
        $162a158a65c890c3$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $6gjUq.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $6gjUq.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $6gjUq.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("6gjUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f3ae3ef1f1811c$export$2e2bcd8739ae039);
function $48f3ae3ef1f1811c$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("dhP4q", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", () => $9ac47a63b088667b$export$a2ba89726971a90f);
$parcel$export(module.exports, "default", () => $9ac47a63b088667b$export$2e2bcd8739ae039);

var $jKFB2 = parcelRequire("jKFB2");

var $2ssN0 = parcelRequire("2ssN0");
function $9ac47a63b088667b$var$rotationIdentity(lambda, phi) {
    return [
        (0, $2ssN0.abs)(lambda) > (0, $2ssN0.pi) ? lambda + Math.round(-lambda / (0, $2ssN0.tau)) * (0, $2ssN0.tau) : lambda,
        phi
    ];
}
$9ac47a63b088667b$var$rotationIdentity.invert = $9ac47a63b088667b$var$rotationIdentity;
function $9ac47a63b088667b$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $2ssN0.tau)) ? deltaPhi || deltaGamma ? (0, $jKFB2.default)($9ac47a63b088667b$var$rotationLambda(deltaLambda), $9ac47a63b088667b$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $9ac47a63b088667b$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $9ac47a63b088667b$var$rotationPhiGamma(deltaPhi, deltaGamma) : $9ac47a63b088667b$var$rotationIdentity;
}
function $9ac47a63b088667b$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $2ssN0.pi) ? lambda - (0, $2ssN0.tau) : lambda < -(0, $2ssN0.pi) ? lambda + (0, $2ssN0.tau) : lambda,
            phi
        ];
    };
}
function $9ac47a63b088667b$var$rotationLambda(deltaLambda) {
    var rotation = $9ac47a63b088667b$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $9ac47a63b088667b$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $9ac47a63b088667b$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $2ssN0.cos)(deltaPhi), sinDeltaPhi = (0, $2ssN0.sin)(deltaPhi), cosDeltaGamma = (0, $2ssN0.cos)(deltaGamma), sinDeltaGamma = (0, $2ssN0.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $2ssN0.cos)(phi), x = (0, $2ssN0.cos)(lambda) * cosPhi, y = (0, $2ssN0.sin)(lambda) * cosPhi, z = (0, $2ssN0.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $2ssN0.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $2ssN0.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $2ssN0.cos)(phi), x = (0, $2ssN0.cos)(lambda) * cosPhi, y = (0, $2ssN0.sin)(lambda) * cosPhi, z = (0, $2ssN0.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $2ssN0.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $2ssN0.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $9ac47a63b088667b$export$2e2bcd8739ae039(rotate) {
    rotate = $9ac47a63b088667b$export$a2ba89726971a90f(rotate[0] * (0, $2ssN0.radians), rotate[1] * (0, $2ssN0.radians), rotate.length > 2 ? rotate[2] * (0, $2ssN0.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $2ssN0.radians), coordinates[1] * (0, $2ssN0.radians));
        return coordinates[0] *= (0, $2ssN0.degrees), coordinates[1] *= (0, $2ssN0.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $2ssN0.radians), coordinates[1] * (0, $2ssN0.radians));
        return coordinates[0] *= (0, $2ssN0.degrees), coordinates[1] *= (0, $2ssN0.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("jKFB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6129460b0122c4b$export$2e2bcd8739ae039);
function $e6129460b0122c4b$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("coMxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $906d609c55b82393$export$2e2bcd8739ae039);

var $2G41A = parcelRequire("2G41A");

var $2ssN0 = parcelRequire("2ssN0");
var $906d609c55b82393$export$2e2bcd8739ae039 = (0, $2G41A.default)(function() {
    return true;
}, $906d609c55b82393$var$clipAntimeridianLine, $906d609c55b82393$var$clipAntimeridianInterpolate, [
    -(0, $2ssN0.pi),
    -(0, $2ssN0.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $906d609c55b82393$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $2ssN0.pi) : -(0, $2ssN0.pi), delta = (0, $2ssN0.abs)(lambda1 - lambda0);
            if ((0, $2ssN0.abs)(delta - (0, $2ssN0.pi)) < (0, $2ssN0.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $2ssN0.halfPi) : -(0, $2ssN0.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $2ssN0.pi)) {
                if ((0, $2ssN0.abs)(lambda0 - sign0) < (0, $2ssN0.epsilon)) lambda0 -= sign0 * (0, $2ssN0.epsilon); // handle degeneracies
                if ((0, $2ssN0.abs)(lambda1 - sign1) < (0, $2ssN0.epsilon)) lambda1 -= sign1 * (0, $2ssN0.epsilon);
                phi0 = $906d609c55b82393$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $906d609c55b82393$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $2ssN0.sin)(lambda0 - lambda1);
    return (0, $2ssN0.abs)(sinLambda0Lambda1) > (0, $2ssN0.epsilon) ? (0, $2ssN0.atan)(((0, $2ssN0.sin)(phi0) * (cosPhi1 = (0, $2ssN0.cos)(phi1)) * (0, $2ssN0.sin)(lambda1) - (0, $2ssN0.sin)(phi1) * (cosPhi0 = (0, $2ssN0.cos)(phi0)) * (0, $2ssN0.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $906d609c55b82393$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $2ssN0.halfPi);
        stream.point(-(0, $2ssN0.pi), phi);
        stream.point(0, phi);
        stream.point((0, $2ssN0.pi), phi);
        stream.point((0, $2ssN0.pi), 0);
        stream.point((0, $2ssN0.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $2ssN0.pi), -phi);
        stream.point(-(0, $2ssN0.pi), 0);
        stream.point(-(0, $2ssN0.pi), phi);
    } else if ((0, $2ssN0.abs)(from[0] - to[0]) > (0, $2ssN0.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $2ssN0.pi) : -(0, $2ssN0.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("2G41A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f32a035d7cc3b86$export$2e2bcd8739ae039);

var $7cS1H = parcelRequire("7cS1H");

var $jlpCW = parcelRequire("jlpCW");

var $2ssN0 = parcelRequire("2ssN0");

var $i3rPV = parcelRequire("i3rPV");
parcelRequire("4Plq2");
var $aMnMV = parcelRequire("aMnMV");
function $1f32a035d7cc3b86$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $7cS1H.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $aMnMV.default)(segments);
                var startInside = (0, $i3rPV.default)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $jlpCW.default)(segments, $1f32a035d7cc3b86$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($1f32a035d7cc3b86$var$validSegment));
        }
        return clip;
    };
}
function $1f32a035d7cc3b86$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $1f32a035d7cc3b86$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $2ssN0.halfPi) - (0, $2ssN0.epsilon) : (0, $2ssN0.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $2ssN0.halfPi) - (0, $2ssN0.epsilon) : (0, $2ssN0.halfPi) - b[1]);
}

});
parcelRegister("7cS1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f38fedd16bada7$export$2e2bcd8739ae039);

var $9BJ1Y = parcelRequire("9BJ1Y");
function $53f38fedd16bada7$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $9BJ1Y.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("jlpCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e153db79b15e45a2$export$2e2bcd8739ae039);

var $aJ99Y = parcelRequire("aJ99Y");

var $2ssN0 = parcelRequire("2ssN0");
function $e153db79b15e45a2$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $e153db79b15e45a2$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $aJ99Y.default)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $2ssN0.epsilon);
        }
        subject.push(x = new $e153db79b15e45a2$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $e153db79b15e45a2$var$Intersection(p0, null, x, false));
        subject.push(x = new $e153db79b15e45a2$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $e153db79b15e45a2$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $e153db79b15e45a2$var$link(subject);
    $e153db79b15e45a2$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $e153db79b15e45a2$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("aJ99Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf5364e1031683e$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");
function $7cf5364e1031683e$export$2e2bcd8739ae039(a, b) {
    return (0, $2ssN0.abs)(a[0] - b[0]) < (0, $2ssN0.epsilon) && (0, $2ssN0.abs)(a[1] - b[1]) < (0, $2ssN0.epsilon);
}

});


parcelRegister("i3rPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $03645b404cc31cdd$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $ikdcr = parcelRequire("ikdcr");

var $2ssN0 = parcelRequire("2ssN0");
var $03645b404cc31cdd$var$sum = (0, $ji7uQ.default)();
function $03645b404cc31cdd$var$longitude(point) {
    if ((0, $2ssN0.abs)(point[0]) <= (0, $2ssN0.pi)) return point[0];
    else return (0, $2ssN0.sign)(point[0]) * (((0, $2ssN0.abs)(point[0]) + (0, $2ssN0.pi)) % (0, $2ssN0.tau) - (0, $2ssN0.pi));
}
function $03645b404cc31cdd$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $03645b404cc31cdd$var$longitude(point), phi = point[1], sinPhi = (0, $2ssN0.sin)(phi), normal = [
        (0, $2ssN0.sin)(lambda),
        -(0, $2ssN0.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    $03645b404cc31cdd$var$sum.reset();
    if (sinPhi === 1) phi = (0, $2ssN0.halfPi) + (0, $2ssN0.epsilon);
    else if (sinPhi === -1) phi = -(0, $2ssN0.halfPi) - (0, $2ssN0.epsilon);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $03645b404cc31cdd$var$longitude(point0), phi0 = point0[1] / 2 + (0, $2ssN0.quarterPi), sinPhi0 = (0, $2ssN0.sin)(phi0), cosPhi0 = (0, $2ssN0.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $03645b404cc31cdd$var$longitude(point1), phi1 = point1[1] / 2 + (0, $2ssN0.quarterPi), sinPhi1 = (0, $2ssN0.sin)(phi1), cosPhi1 = (0, $2ssN0.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $2ssN0.pi), k = sinPhi0 * sinPhi1;
            $03645b404cc31cdd$var$sum.add((0, $2ssN0.atan2)(k * sign * (0, $2ssN0.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $2ssN0.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $2ssN0.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $ikdcr.cartesianCross)((0, $ikdcr.cartesian)(point0), (0, $ikdcr.cartesian)(point1));
                (0, $ikdcr.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $ikdcr.cartesianCross)(normal, arc);
                (0, $ikdcr.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $2ssN0.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $2ssN0.epsilon) || angle < (0, $2ssN0.epsilon) && $03645b404cc31cdd$var$sum < -(0, $2ssN0.epsilon)) ^ winding & 1;
}

});



parcelRegister("eF197", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac5c8a0316cd0e0$export$2e2bcd8739ae039);

var $ikdcr = parcelRequire("ikdcr");

var $1TYNa = parcelRequire("1TYNa");

var $2ssN0 = parcelRequire("2ssN0");

var $aJ99Y = parcelRequire("aJ99Y");

var $2G41A = parcelRequire("2G41A");
function $aac5c8a0316cd0e0$export$2e2bcd8739ae039(radius) {
    var cr = (0, $2ssN0.cos)(radius), delta = 6 * (0, $2ssN0.radians), smallRadius = cr > 0, notHemisphere = (0, $2ssN0.abs)(cr) > (0, $2ssN0.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $1TYNa.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $2ssN0.cos)(lambda) * (0, $2ssN0.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $2ssN0.pi) : -(0, $2ssN0.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $aJ99Y.default)(point0, point2) || (0, $aJ99Y.default)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $aJ99Y.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $ikdcr.cartesian)(a), pb = (0, $ikdcr.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $ikdcr.cartesianCross)(pa, pb), n2n2 = (0, $ikdcr.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $ikdcr.cartesianCross)(n1, n2), A = (0, $ikdcr.cartesianScale)(n1, c1), B = (0, $ikdcr.cartesianScale)(n2, c2);
        (0, $ikdcr.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $ikdcr.cartesianDot)(A, u), uu = (0, $ikdcr.cartesianDot)(u, u), t2 = w * w - uu * ((0, $ikdcr.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $2ssN0.sqrt)(t2), q = (0, $ikdcr.cartesianScale)(u, (-w - t) / uu);
        (0, $ikdcr.cartesianAddInPlace)(q, A);
        q = (0, $ikdcr.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $2ssN0.abs)(delta - (0, $2ssN0.pi)) < (0, $2ssN0.epsilon), meridian = polar || delta < (0, $2ssN0.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $2ssN0.abs)(q[0] - lambda0) < (0, $2ssN0.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $2ssN0.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $ikdcr.cartesianScale)(u, (-w + t) / uu);
            (0, $ikdcr.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $ikdcr.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $2ssN0.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $2G41A.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $2ssN0.pi),
        radius - (0, $2ssN0.pi)
    ]);
}

});

parcelRegister("1pl6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $10687ee1fffdf467$export$2e2bcd8739ae039);

var $aYocN = parcelRequire("aYocN");
function $10687ee1fffdf467$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $aYocN.default)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("aYocN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fd248aecda36b3d$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $7cS1H = parcelRequire("7cS1H");

var $ipb1R = parcelRequire("ipb1R");

var $jlpCW = parcelRequire("jlpCW");
parcelRequire("4Plq2");
var $aMnMV = parcelRequire("aMnMV");
var $7fd248aecda36b3d$var$clipMax = 1e9, $7fd248aecda36b3d$var$clipMin = -$7fd248aecda36b3d$var$clipMax;
function $7fd248aecda36b3d$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $2ssN0.abs)(p[0] - x0) < (0, $2ssN0.epsilon) ? direction > 0 ? 0 : 3 : (0, $2ssN0.abs)(p[0] - x1) < (0, $2ssN0.epsilon) ? direction > 0 ? 2 : 1 : (0, $2ssN0.abs)(p[1] - y0) < (0, $2ssN0.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $7cS1H.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $aMnMV.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $jlpCW.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($7fd248aecda36b3d$var$clipMin, Math.min($7fd248aecda36b3d$var$clipMax, x_)),
                    y_ = Math.max($7fd248aecda36b3d$var$clipMin, Math.min($7fd248aecda36b3d$var$clipMax, y_))
                ], b = [
                    x = Math.max($7fd248aecda36b3d$var$clipMin, Math.min($7fd248aecda36b3d$var$clipMax, x)),
                    y = Math.max($7fd248aecda36b3d$var$clipMin, Math.min($7fd248aecda36b3d$var$clipMax, y))
                ];
                if ((0, $ipb1R.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

});
parcelRegister("ipb1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6631def041b79f2$export$2e2bcd8739ae039);
function $d6631def041b79f2$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});



parcelRegister("aHGMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7caf1a88b9bf212e$export$2e2bcd8739ae039);

var $i3rPV = parcelRequire("i3rPV");

var $9wJ1q = parcelRequire("9wJ1q");

var $2ssN0 = parcelRequire("2ssN0");
var $7caf1a88b9bf212e$var$containsObjectType = {
    Feature: function(object, point) {
        return $7caf1a88b9bf212e$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($7caf1a88b9bf212e$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $7caf1a88b9bf212e$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $7caf1a88b9bf212e$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($7caf1a88b9bf212e$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $7caf1a88b9bf212e$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($7caf1a88b9bf212e$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $7caf1a88b9bf212e$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($7caf1a88b9bf212e$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($7caf1a88b9bf212e$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $7caf1a88b9bf212e$var$containsGeometry(geometry, point) {
    return geometry && $7caf1a88b9bf212e$var$containsGeometryType.hasOwnProperty(geometry.type) ? $7caf1a88b9bf212e$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $7caf1a88b9bf212e$var$containsPoint(coordinates, point) {
    return (0, $9wJ1q.default)(coordinates, point) === 0;
}
function $7caf1a88b9bf212e$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $9wJ1q.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $9wJ1q.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $2ssN0.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $7caf1a88b9bf212e$var$containsPolygon(coordinates, point) {
    return !!(0, $i3rPV.default)(coordinates.map($7caf1a88b9bf212e$var$ringRadians), $7caf1a88b9bf212e$var$pointRadians(point));
}
function $7caf1a88b9bf212e$var$ringRadians(ring) {
    return ring = ring.map($7caf1a88b9bf212e$var$pointRadians), ring.pop(), ring;
}
function $7caf1a88b9bf212e$var$pointRadians(point) {
    return [
        point[0] * (0, $2ssN0.radians),
        point[1] * (0, $2ssN0.radians)
    ];
}
function $7caf1a88b9bf212e$export$2e2bcd8739ae039(object, point) {
    return (object && $7caf1a88b9bf212e$var$containsObjectType.hasOwnProperty(object.type) ? $7caf1a88b9bf212e$var$containsObjectType[object.type] : $7caf1a88b9bf212e$var$containsGeometry)(object, point);
}

});
parcelRegister("9wJ1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efa06a1a3db22c2$export$2e2bcd8739ae039);

var $8sz9q = parcelRequire("8sz9q");
var $6efa06a1a3db22c2$var$coordinates = [
    null,
    null
], $6efa06a1a3db22c2$var$object = {
    type: "LineString",
    coordinates: $6efa06a1a3db22c2$var$coordinates
};
function $6efa06a1a3db22c2$export$2e2bcd8739ae039(a, b) {
    $6efa06a1a3db22c2$var$coordinates[0] = a;
    $6efa06a1a3db22c2$var$coordinates[1] = b;
    return (0, $8sz9q.default)($6efa06a1a3db22c2$var$object);
}

});
parcelRegister("8sz9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $628c347ff349dade$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");

var $g6Z33 = parcelRequire("g6Z33");
var $628c347ff349dade$var$lengthSum = (0, $ji7uQ.default)(), $628c347ff349dade$var$lambda0, $628c347ff349dade$var$sinPhi0, $628c347ff349dade$var$cosPhi0;
var $628c347ff349dade$var$lengthStream = {
    sphere: (0, $9BJ1Y.default),
    point: (0, $9BJ1Y.default),
    lineStart: $628c347ff349dade$var$lengthLineStart,
    lineEnd: (0, $9BJ1Y.default),
    polygonStart: (0, $9BJ1Y.default),
    polygonEnd: (0, $9BJ1Y.default)
};
function $628c347ff349dade$var$lengthLineStart() {
    $628c347ff349dade$var$lengthStream.point = $628c347ff349dade$var$lengthPointFirst;
    $628c347ff349dade$var$lengthStream.lineEnd = $628c347ff349dade$var$lengthLineEnd;
}
function $628c347ff349dade$var$lengthLineEnd() {
    $628c347ff349dade$var$lengthStream.point = $628c347ff349dade$var$lengthStream.lineEnd = (0, $9BJ1Y.default);
}
function $628c347ff349dade$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    $628c347ff349dade$var$lambda0 = lambda, $628c347ff349dade$var$sinPhi0 = (0, $2ssN0.sin)(phi), $628c347ff349dade$var$cosPhi0 = (0, $2ssN0.cos)(phi);
    $628c347ff349dade$var$lengthStream.point = $628c347ff349dade$var$lengthPoint;
}
function $628c347ff349dade$var$lengthPoint(lambda, phi) {
    lambda *= (0, $2ssN0.radians), phi *= (0, $2ssN0.radians);
    var sinPhi = (0, $2ssN0.sin)(phi), cosPhi = (0, $2ssN0.cos)(phi), delta = (0, $2ssN0.abs)(lambda - $628c347ff349dade$var$lambda0), cosDelta = (0, $2ssN0.cos)(delta), sinDelta = (0, $2ssN0.sin)(delta), x = cosPhi * sinDelta, y = $628c347ff349dade$var$cosPhi0 * sinPhi - $628c347ff349dade$var$sinPhi0 * cosPhi * cosDelta, z = $628c347ff349dade$var$sinPhi0 * sinPhi + $628c347ff349dade$var$cosPhi0 * cosPhi * cosDelta;
    $628c347ff349dade$var$lengthSum.add((0, $2ssN0.atan2)((0, $2ssN0.sqrt)(x * x + y * y), z));
    $628c347ff349dade$var$lambda0 = lambda, $628c347ff349dade$var$sinPhi0 = sinPhi, $628c347ff349dade$var$cosPhi0 = cosPhi;
}
function $628c347ff349dade$export$2e2bcd8739ae039(object) {
    $628c347ff349dade$var$lengthSum.reset();
    (0, $g6Z33.default)(object, $628c347ff349dade$var$lengthStream);
    return +$628c347ff349dade$var$lengthSum;
}

});



parcelRegister("eYegQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae61bd1f514f616e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "graticule10", () => $ae61bd1f514f616e$export$b8db4e9403a5b6f1);
parcelRequire("4Plq2");
var $c44DK = parcelRequire("c44DK");

var $2ssN0 = parcelRequire("2ssN0");
function $ae61bd1f514f616e$var$graticuleX(y0, y1, dy) {
    var y = (0, $c44DK.default)(y0, y1 - (0, $2ssN0.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $ae61bd1f514f616e$var$graticuleY(x0, x1, dx) {
    var x = (0, $c44DK.default)(x0, x1 - (0, $2ssN0.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $ae61bd1f514f616e$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $c44DK.default)((0, $2ssN0.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $c44DK.default)((0, $2ssN0.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $c44DK.default)((0, $2ssN0.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $2ssN0.abs)(x % DX) > (0, $2ssN0.epsilon);
        }).map(x)).concat((0, $c44DK.default)((0, $2ssN0.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $2ssN0.abs)(y % DY) > (0, $2ssN0.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $ae61bd1f514f616e$var$graticuleX(y0, y1, 90);
        y = $ae61bd1f514f616e$var$graticuleY(x0, x1, precision);
        X = $ae61bd1f514f616e$var$graticuleX(Y0, Y1, 90);
        Y = $ae61bd1f514f616e$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $2ssN0.epsilon)
        ],
        [
            180,
            90 - (0, $2ssN0.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $2ssN0.epsilon)
        ],
        [
            180,
            80 + (0, $2ssN0.epsilon)
        ]
    ]);
}
function $ae61bd1f514f616e$export$b8db4e9403a5b6f1() {
    return $ae61bd1f514f616e$export$2e2bcd8739ae039()();
}

});

parcelRegister("4UZHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $394c40970842c7e6$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");
function $394c40970842c7e6$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $2ssN0.radians), y0 = a[1] * (0, $2ssN0.radians), x1 = b[0] * (0, $2ssN0.radians), y1 = b[1] * (0, $2ssN0.radians), cy0 = (0, $2ssN0.cos)(y0), sy0 = (0, $2ssN0.sin)(y0), cy1 = (0, $2ssN0.cos)(y1), sy1 = (0, $2ssN0.sin)(y1), kx0 = cy0 * (0, $2ssN0.cos)(x0), ky0 = cy0 * (0, $2ssN0.sin)(x0), kx1 = cy1 * (0, $2ssN0.cos)(x1), ky1 = cy1 * (0, $2ssN0.sin)(x1), d = 2 * (0, $2ssN0.asin)((0, $2ssN0.sqrt)((0, $2ssN0.haversin)(y1 - y0) + cy0 * cy1 * (0, $2ssN0.haversin)(x1 - x0))), k = (0, $2ssN0.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $2ssN0.sin)(t *= d) / k, A = (0, $2ssN0.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $2ssN0.atan2)(y, x) * (0, $2ssN0.degrees),
            (0, $2ssN0.atan2)(z, (0, $2ssN0.sqrt)(x * x + y * y)) * (0, $2ssN0.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $2ssN0.degrees),
            y0 * (0, $2ssN0.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("86Qdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e77627ad4d84e9a$export$2e2bcd8739ae039);

var $haFgD = parcelRequire("haFgD");

var $g6Z33 = parcelRequire("g6Z33");

var $75b2n = parcelRequire("75b2n");

var $9Mtkb = parcelRequire("9Mtkb");

var $7TOIk = parcelRequire("7TOIk");

var $998Pg = parcelRequire("998Pg");

var $3lFrR = parcelRequire("3lFrR");

var $5yclL = parcelRequire("5yclL");
function $5e77627ad4d84e9a$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $g6Z33.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $g6Z33.default)(object, projectionStream((0, $75b2n.default)));
        return (0, $75b2n.default).result();
    };
    path.measure = function(object) {
        (0, $g6Z33.default)(object, projectionStream((0, $3lFrR.default)));
        return (0, $3lFrR.default).result();
    };
    path.bounds = function(object) {
        (0, $g6Z33.default)(object, projectionStream((0, $9Mtkb.default)));
        return (0, $9Mtkb.default).result();
    };
    path.centroid = function(object) {
        (0, $g6Z33.default)(object, projectionStream((0, $7TOIk.default)));
        return (0, $7TOIk.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $haFgD.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $5yclL.default)) : new (0, $998Pg.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("haFgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c80361b073066f68$export$2e2bcd8739ae039);
function $c80361b073066f68$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("75b2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $52818fce7ffd2920$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");
var $52818fce7ffd2920$var$areaSum = (0, $ji7uQ.default)(), $52818fce7ffd2920$var$areaRingSum = (0, $ji7uQ.default)(), $52818fce7ffd2920$var$x00, $52818fce7ffd2920$var$y00, $52818fce7ffd2920$var$x0, $52818fce7ffd2920$var$y0;
var $52818fce7ffd2920$var$areaStream = {
    point: (0, $9BJ1Y.default),
    lineStart: (0, $9BJ1Y.default),
    lineEnd: (0, $9BJ1Y.default),
    polygonStart: function() {
        $52818fce7ffd2920$var$areaStream.lineStart = $52818fce7ffd2920$var$areaRingStart;
        $52818fce7ffd2920$var$areaStream.lineEnd = $52818fce7ffd2920$var$areaRingEnd;
    },
    polygonEnd: function() {
        $52818fce7ffd2920$var$areaStream.lineStart = $52818fce7ffd2920$var$areaStream.lineEnd = $52818fce7ffd2920$var$areaStream.point = (0, $9BJ1Y.default);
        $52818fce7ffd2920$var$areaSum.add((0, $2ssN0.abs)($52818fce7ffd2920$var$areaRingSum));
        $52818fce7ffd2920$var$areaRingSum.reset();
    },
    result: function() {
        var area = $52818fce7ffd2920$var$areaSum / 2;
        $52818fce7ffd2920$var$areaSum.reset();
        return area;
    }
};
function $52818fce7ffd2920$var$areaRingStart() {
    $52818fce7ffd2920$var$areaStream.point = $52818fce7ffd2920$var$areaPointFirst;
}
function $52818fce7ffd2920$var$areaPointFirst(x, y) {
    $52818fce7ffd2920$var$areaStream.point = $52818fce7ffd2920$var$areaPoint;
    $52818fce7ffd2920$var$x00 = $52818fce7ffd2920$var$x0 = x, $52818fce7ffd2920$var$y00 = $52818fce7ffd2920$var$y0 = y;
}
function $52818fce7ffd2920$var$areaPoint(x, y) {
    $52818fce7ffd2920$var$areaRingSum.add($52818fce7ffd2920$var$y0 * x - $52818fce7ffd2920$var$x0 * y);
    $52818fce7ffd2920$var$x0 = x, $52818fce7ffd2920$var$y0 = y;
}
function $52818fce7ffd2920$var$areaRingEnd() {
    $52818fce7ffd2920$var$areaPoint($52818fce7ffd2920$var$x00, $52818fce7ffd2920$var$y00);
}
var $52818fce7ffd2920$export$2e2bcd8739ae039 = $52818fce7ffd2920$var$areaStream;

});

parcelRegister("9Mtkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $71ef58017af1316f$export$2e2bcd8739ae039);

var $9BJ1Y = parcelRequire("9BJ1Y");
var $71ef58017af1316f$var$x0 = Infinity, $71ef58017af1316f$var$y0 = $71ef58017af1316f$var$x0, $71ef58017af1316f$var$x1 = -$71ef58017af1316f$var$x0, $71ef58017af1316f$var$y1 = $71ef58017af1316f$var$x1;
var $71ef58017af1316f$var$boundsStream = {
    point: $71ef58017af1316f$var$boundsPoint,
    lineStart: (0, $9BJ1Y.default),
    lineEnd: (0, $9BJ1Y.default),
    polygonStart: (0, $9BJ1Y.default),
    polygonEnd: (0, $9BJ1Y.default),
    result: function() {
        var bounds = [
            [
                $71ef58017af1316f$var$x0,
                $71ef58017af1316f$var$y0
            ],
            [
                $71ef58017af1316f$var$x1,
                $71ef58017af1316f$var$y1
            ]
        ];
        $71ef58017af1316f$var$x1 = $71ef58017af1316f$var$y1 = -($71ef58017af1316f$var$y0 = $71ef58017af1316f$var$x0 = Infinity);
        return bounds;
    }
};
function $71ef58017af1316f$var$boundsPoint(x, y) {
    if (x < $71ef58017af1316f$var$x0) $71ef58017af1316f$var$x0 = x;
    if (x > $71ef58017af1316f$var$x1) $71ef58017af1316f$var$x1 = x;
    if (y < $71ef58017af1316f$var$y0) $71ef58017af1316f$var$y0 = y;
    if (y > $71ef58017af1316f$var$y1) $71ef58017af1316f$var$y1 = y;
}
var $71ef58017af1316f$export$2e2bcd8739ae039 = $71ef58017af1316f$var$boundsStream;

});

parcelRegister("7TOIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c050237e6952fb7$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");
// TODO Enforce positive area for exterior, negative area for interior?
var $5c050237e6952fb7$var$X0 = 0, $5c050237e6952fb7$var$Y0 = 0, $5c050237e6952fb7$var$Z0 = 0, $5c050237e6952fb7$var$X1 = 0, $5c050237e6952fb7$var$Y1 = 0, $5c050237e6952fb7$var$Z1 = 0, $5c050237e6952fb7$var$X2 = 0, $5c050237e6952fb7$var$Y2 = 0, $5c050237e6952fb7$var$Z2 = 0, $5c050237e6952fb7$var$x00, $5c050237e6952fb7$var$y00, $5c050237e6952fb7$var$x0, $5c050237e6952fb7$var$y0;
var $5c050237e6952fb7$var$centroidStream = {
    point: $5c050237e6952fb7$var$centroidPoint,
    lineStart: $5c050237e6952fb7$var$centroidLineStart,
    lineEnd: $5c050237e6952fb7$var$centroidLineEnd,
    polygonStart: function() {
        $5c050237e6952fb7$var$centroidStream.lineStart = $5c050237e6952fb7$var$centroidRingStart;
        $5c050237e6952fb7$var$centroidStream.lineEnd = $5c050237e6952fb7$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPoint;
        $5c050237e6952fb7$var$centroidStream.lineStart = $5c050237e6952fb7$var$centroidLineStart;
        $5c050237e6952fb7$var$centroidStream.lineEnd = $5c050237e6952fb7$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $5c050237e6952fb7$var$Z2 ? [
            $5c050237e6952fb7$var$X2 / $5c050237e6952fb7$var$Z2,
            $5c050237e6952fb7$var$Y2 / $5c050237e6952fb7$var$Z2
        ] : $5c050237e6952fb7$var$Z1 ? [
            $5c050237e6952fb7$var$X1 / $5c050237e6952fb7$var$Z1,
            $5c050237e6952fb7$var$Y1 / $5c050237e6952fb7$var$Z1
        ] : $5c050237e6952fb7$var$Z0 ? [
            $5c050237e6952fb7$var$X0 / $5c050237e6952fb7$var$Z0,
            $5c050237e6952fb7$var$Y0 / $5c050237e6952fb7$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $5c050237e6952fb7$var$X0 = $5c050237e6952fb7$var$Y0 = $5c050237e6952fb7$var$Z0 = $5c050237e6952fb7$var$X1 = $5c050237e6952fb7$var$Y1 = $5c050237e6952fb7$var$Z1 = $5c050237e6952fb7$var$X2 = $5c050237e6952fb7$var$Y2 = $5c050237e6952fb7$var$Z2 = 0;
        return centroid;
    }
};
function $5c050237e6952fb7$var$centroidPoint(x, y) {
    $5c050237e6952fb7$var$X0 += x;
    $5c050237e6952fb7$var$Y0 += y;
    ++$5c050237e6952fb7$var$Z0;
}
function $5c050237e6952fb7$var$centroidLineStart() {
    $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPointFirstLine;
}
function $5c050237e6952fb7$var$centroidPointFirstLine(x, y) {
    $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPointLine;
    $5c050237e6952fb7$var$centroidPoint($5c050237e6952fb7$var$x0 = x, $5c050237e6952fb7$var$y0 = y);
}
function $5c050237e6952fb7$var$centroidPointLine(x, y) {
    var dx = x - $5c050237e6952fb7$var$x0, dy = y - $5c050237e6952fb7$var$y0, z = (0, $2ssN0.sqrt)(dx * dx + dy * dy);
    $5c050237e6952fb7$var$X1 += z * ($5c050237e6952fb7$var$x0 + x) / 2;
    $5c050237e6952fb7$var$Y1 += z * ($5c050237e6952fb7$var$y0 + y) / 2;
    $5c050237e6952fb7$var$Z1 += z;
    $5c050237e6952fb7$var$centroidPoint($5c050237e6952fb7$var$x0 = x, $5c050237e6952fb7$var$y0 = y);
}
function $5c050237e6952fb7$var$centroidLineEnd() {
    $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPoint;
}
function $5c050237e6952fb7$var$centroidRingStart() {
    $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPointFirstRing;
}
function $5c050237e6952fb7$var$centroidRingEnd() {
    $5c050237e6952fb7$var$centroidPointRing($5c050237e6952fb7$var$x00, $5c050237e6952fb7$var$y00);
}
function $5c050237e6952fb7$var$centroidPointFirstRing(x, y) {
    $5c050237e6952fb7$var$centroidStream.point = $5c050237e6952fb7$var$centroidPointRing;
    $5c050237e6952fb7$var$centroidPoint($5c050237e6952fb7$var$x00 = $5c050237e6952fb7$var$x0 = x, $5c050237e6952fb7$var$y00 = $5c050237e6952fb7$var$y0 = y);
}
function $5c050237e6952fb7$var$centroidPointRing(x, y) {
    var dx = x - $5c050237e6952fb7$var$x0, dy = y - $5c050237e6952fb7$var$y0, z = (0, $2ssN0.sqrt)(dx * dx + dy * dy);
    $5c050237e6952fb7$var$X1 += z * ($5c050237e6952fb7$var$x0 + x) / 2;
    $5c050237e6952fb7$var$Y1 += z * ($5c050237e6952fb7$var$y0 + y) / 2;
    $5c050237e6952fb7$var$Z1 += z;
    z = $5c050237e6952fb7$var$y0 * x - $5c050237e6952fb7$var$x0 * y;
    $5c050237e6952fb7$var$X2 += z * ($5c050237e6952fb7$var$x0 + x);
    $5c050237e6952fb7$var$Y2 += z * ($5c050237e6952fb7$var$y0 + y);
    $5c050237e6952fb7$var$Z2 += z * 3;
    $5c050237e6952fb7$var$centroidPoint($5c050237e6952fb7$var$x0 = x, $5c050237e6952fb7$var$y0 = y);
}
var $5c050237e6952fb7$export$2e2bcd8739ae039 = $5c050237e6952fb7$var$centroidStream;

});

parcelRegister("998Pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8bccee71b71f47$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");
function $6a8bccee71b71f47$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$6a8bccee71b71f47$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $2ssN0.tau));
                break;
        }
    },
    result: (0, $9BJ1Y.default)
};

});

parcelRegister("3lFrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $27037c1005108cf1$export$2e2bcd8739ae039);

var $ji7uQ = parcelRequire("ji7uQ");

var $2ssN0 = parcelRequire("2ssN0");

var $9BJ1Y = parcelRequire("9BJ1Y");
var $27037c1005108cf1$var$lengthSum = (0, $ji7uQ.default)(), $27037c1005108cf1$var$lengthRing, $27037c1005108cf1$var$x00, $27037c1005108cf1$var$y00, $27037c1005108cf1$var$x0, $27037c1005108cf1$var$y0;
var $27037c1005108cf1$var$lengthStream = {
    point: (0, $9BJ1Y.default),
    lineStart: function() {
        $27037c1005108cf1$var$lengthStream.point = $27037c1005108cf1$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($27037c1005108cf1$var$lengthRing) $27037c1005108cf1$var$lengthPoint($27037c1005108cf1$var$x00, $27037c1005108cf1$var$y00);
        $27037c1005108cf1$var$lengthStream.point = (0, $9BJ1Y.default);
    },
    polygonStart: function() {
        $27037c1005108cf1$var$lengthRing = true;
    },
    polygonEnd: function() {
        $27037c1005108cf1$var$lengthRing = null;
    },
    result: function() {
        var length = +$27037c1005108cf1$var$lengthSum;
        $27037c1005108cf1$var$lengthSum.reset();
        return length;
    }
};
function $27037c1005108cf1$var$lengthPointFirst(x, y) {
    $27037c1005108cf1$var$lengthStream.point = $27037c1005108cf1$var$lengthPoint;
    $27037c1005108cf1$var$x00 = $27037c1005108cf1$var$x0 = x, $27037c1005108cf1$var$y00 = $27037c1005108cf1$var$y0 = y;
}
function $27037c1005108cf1$var$lengthPoint(x, y) {
    $27037c1005108cf1$var$x0 -= x, $27037c1005108cf1$var$y0 -= y;
    $27037c1005108cf1$var$lengthSum.add((0, $2ssN0.sqrt)($27037c1005108cf1$var$x0 * $27037c1005108cf1$var$x0 + $27037c1005108cf1$var$y0 * $27037c1005108cf1$var$y0));
    $27037c1005108cf1$var$x0 = x, $27037c1005108cf1$var$y0 = y;
}
var $27037c1005108cf1$export$2e2bcd8739ae039 = $27037c1005108cf1$var$lengthStream;

});

parcelRegister("5yclL", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a9b5343f94dc24$export$2e2bcd8739ae039);
function $40a9b5343f94dc24$export$2e2bcd8739ae039() {
    this._string = [];
}
$40a9b5343f94dc24$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $40a9b5343f94dc24$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $40a9b5343f94dc24$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $40a9b5343f94dc24$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("2O9Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b7b9d96a013eeb$export$2e2bcd8739ae039);

var $k4tPe = parcelRequire("k4tPe");
function $20b7b9d96a013eeb$export$2e2bcd8739ae039() {
    return (0, $k4tPe.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("k4tPe", function(module, exports) {

$parcel$export(module.exports, "conicEqualAreaRaw", () => $e9cb510880a27e20$export$75409dad1c406288);
$parcel$export(module.exports, "default", () => $e9cb510880a27e20$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $d3mPZ = parcelRequire("d3mPZ");

var $auxpr = parcelRequire("auxpr");
function $e9cb510880a27e20$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $2ssN0.sin)(y0), n = (sy0 + (0, $2ssN0.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $2ssN0.abs)(n) < (0, $2ssN0.epsilon)) return (0, $auxpr.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $2ssN0.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $2ssN0.sqrt)(c - 2 * n * (0, $2ssN0.sin)(y)) / n;
        return [
            r * (0, $2ssN0.sin)(x *= n),
            r0 - r * (0, $2ssN0.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $2ssN0.atan2)(x, (0, $2ssN0.abs)(r0y)) * (0, $2ssN0.sign)(r0y);
        if (r0y * n < 0) l -= (0, $2ssN0.pi) * (0, $2ssN0.sign)(x) * (0, $2ssN0.sign)(r0y);
        return [
            l / n,
            (0, $2ssN0.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $e9cb510880a27e20$export$2e2bcd8739ae039() {
    return (0, $d3mPZ.conicProjection)($e9cb510880a27e20$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("d3mPZ", function(module, exports) {

$parcel$export(module.exports, "conicProjection", () => $980d453dfe681995$export$228272587c4d24d8);

var $2ssN0 = parcelRequire("2ssN0");

var $66c7U = parcelRequire("66c7U");
function $980d453dfe681995$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $2ssN0.pi) / 3, m = (0, $66c7U.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $2ssN0.radians), phi1 = _[1] * (0, $2ssN0.radians)) : [
            phi0 * (0, $2ssN0.degrees),
            phi1 * (0, $2ssN0.degrees)
        ];
    };
    return p;
}

});
parcelRegister("66c7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $470cb5b633f6dd7a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "projectionMutator", () => $470cb5b633f6dd7a$export$155d5a6fa6fddeba);

var $coMxq = parcelRequire("coMxq");

var $eF197 = parcelRequire("eF197");

var $aYocN = parcelRequire("aYocN");

var $jKFB2 = parcelRequire("jKFB2");

var $haFgD = parcelRequire("haFgD");

var $2ssN0 = parcelRequire("2ssN0");

var $dhP4q = parcelRequire("dhP4q");

var $bWfHn = parcelRequire("bWfHn");

var $7jZdv = parcelRequire("7jZdv");

var $aau9D = parcelRequire("aau9D");
var $470cb5b633f6dd7a$var$transformRadians = (0, $bWfHn.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $2ssN0.radians), y * (0, $2ssN0.radians));
    }
});
function $470cb5b633f6dd7a$var$transformRotate(rotate) {
    return (0, $bWfHn.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $470cb5b633f6dd7a$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $470cb5b633f6dd7a$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    var cosAlpha = (0, $2ssN0.cos)(alpha), sinAlpha = (0, $2ssN0.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $470cb5b633f6dd7a$export$2e2bcd8739ae039(project) {
    return $470cb5b633f6dd7a$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $470cb5b633f6dd7a$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $coMxq.default), x0 = null, y0, x1, y1, postclip = (0, $haFgD.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $2ssN0.radians), point[1] * (0, $2ssN0.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $2ssN0.degrees),
            point[1] * (0, $2ssN0.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $470cb5b633f6dd7a$var$transformRadians($470cb5b633f6dd7a$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $eF197.default)(theta = _ * (0, $2ssN0.radians)) : (theta = null, $coMxq.default), reset()) : theta * (0, $2ssN0.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $haFgD.default) : (0, $aYocN.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $2ssN0.radians), phi = _[1] % 360 * (0, $2ssN0.radians), recenter()) : [
            lambda * (0, $2ssN0.degrees),
            phi * (0, $2ssN0.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $2ssN0.radians), deltaPhi = _[1] % 360 * (0, $2ssN0.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $2ssN0.radians) : 0, recenter()) : [
            deltaLambda * (0, $2ssN0.degrees),
            deltaPhi * (0, $2ssN0.degrees),
            deltaGamma * (0, $2ssN0.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $2ssN0.radians), recenter()) : alpha * (0, $2ssN0.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $aau9D.default)(projectTransform, delta2 = _ * _), reset()) : (0, $2ssN0.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $7jZdv.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $7jZdv.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $7jZdv.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $7jZdv.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = $470cb5b633f6dd7a$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = (alpha ? $470cb5b633f6dd7a$var$scaleTranslateRotate : $470cb5b633f6dd7a$var$scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $dhP4q.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $jKFB2.default)(project, transform);
        projectRotateTransform = (0, $jKFB2.default)(rotate, projectTransform);
        projectResample = (0, $aau9D.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("bWfHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1149ea233a4d2e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "transformer", () => $8b1149ea233a4d2e$export$6b468dcfb64c653c);
function $8b1149ea233a4d2e$export$2e2bcd8739ae039(methods) {
    return {
        stream: $8b1149ea233a4d2e$export$6b468dcfb64c653c(methods)
    };
}
function $8b1149ea233a4d2e$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $8b1149ea233a4d2e$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $8b1149ea233a4d2e$var$TransformStream() {}
$8b1149ea233a4d2e$var$TransformStream.prototype = {
    constructor: $8b1149ea233a4d2e$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("7jZdv", function(module, exports) {

$parcel$export(module.exports, "fitExtent", () => $5549cb1f60c2eb8b$export$e450184041869e7f);
$parcel$export(module.exports, "fitSize", () => $5549cb1f60c2eb8b$export$33a367fa1728c3ba);
$parcel$export(module.exports, "fitWidth", () => $5549cb1f60c2eb8b$export$7d8f2192ef31c5a7);
$parcel$export(module.exports, "fitHeight", () => $5549cb1f60c2eb8b$export$7069bab0d2ced675);

var $g6Z33 = parcelRequire("g6Z33");

var $9Mtkb = parcelRequire("9Mtkb");
function $5549cb1f60c2eb8b$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $g6Z33.default)(object, projection.stream((0, $9Mtkb.default)));
    fitBounds((0, $9Mtkb.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $5549cb1f60c2eb8b$export$e450184041869e7f(projection, extent, object) {
    return $5549cb1f60c2eb8b$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $5549cb1f60c2eb8b$export$33a367fa1728c3ba(projection, size, object) {
    return $5549cb1f60c2eb8b$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $5549cb1f60c2eb8b$export$7d8f2192ef31c5a7(projection, width, object) {
    return $5549cb1f60c2eb8b$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $5549cb1f60c2eb8b$export$7069bab0d2ced675(projection, height, object) {
    return $5549cb1f60c2eb8b$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

});

parcelRegister("aau9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $76723a9866755d55$export$2e2bcd8739ae039);

var $ikdcr = parcelRequire("ikdcr");

var $2ssN0 = parcelRequire("2ssN0");

var $bWfHn = parcelRequire("bWfHn");
var $76723a9866755d55$var$maxDepth = 16, $76723a9866755d55$var$cosMinDistance = (0, $2ssN0.cos)(30 * (0, $2ssN0.radians)); // cos(minimum angular distance)
function $76723a9866755d55$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $76723a9866755d55$var$resample(project, delta2) : $76723a9866755d55$var$resampleNone(project);
}
function $76723a9866755d55$var$resampleNone(project) {
    return (0, $bWfHn.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $76723a9866755d55$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $2ssN0.sqrt)(a * a + b * b + c * c), phi2 = (0, $2ssN0.asin)(c /= m), lambda2 = (0, $2ssN0.abs)((0, $2ssN0.abs)(c) - 1) < (0, $2ssN0.epsilon) || (0, $2ssN0.abs)(lambda0 - lambda1) < (0, $2ssN0.epsilon) ? (lambda0 + lambda1) / 2 : (0, $2ssN0.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $2ssN0.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $76723a9866755d55$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $ikdcr.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $76723a9866755d55$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $76723a9866755d55$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("auxpr", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", () => $7a369f1fa9135315$export$ae68c6db8b65046a);

var $2ssN0 = parcelRequire("2ssN0");
function $7a369f1fa9135315$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $2ssN0.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $2ssN0.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $2ssN0.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("4BLTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $35afc3d1f1b00b14$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $2O9Dv = parcelRequire("2O9Dv");

var $k4tPe = parcelRequire("k4tPe");

var $7jZdv = parcelRequire("7jZdv");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $35afc3d1f1b00b14$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $35afc3d1f1b00b14$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $2O9Dv.default)(), lower48Point, alaska = (0, $k4tPe.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $k4tPe.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $35afc3d1f1b00b14$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $2ssN0.epsilon),
                y + 0.120 * k + (0, $2ssN0.epsilon)
            ],
            [
                x - 0.214 * k - (0, $2ssN0.epsilon),
                y + 0.234 * k - (0, $2ssN0.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $2ssN0.epsilon),
                y + 0.166 * k + (0, $2ssN0.epsilon)
            ],
            [
                x - 0.115 * k - (0, $2ssN0.epsilon),
                y + 0.234 * k - (0, $2ssN0.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $7jZdv.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $7jZdv.fitSize)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $7jZdv.fitWidth)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $7jZdv.fitHeight)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("iBZjK", function(module, exports) {

$parcel$export(module.exports, "azimuthalEqualAreaRaw", () => $d8cb3f1330e2df48$export$5e11f94fc4a8d2c6);
$parcel$export(module.exports, "default", () => $d8cb3f1330e2df48$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $6ATdw = parcelRequire("6ATdw");

var $66c7U = parcelRequire("66c7U");
var $d8cb3f1330e2df48$export$5e11f94fc4a8d2c6 = (0, $6ATdw.azimuthalRaw)(function(cxcy) {
    return (0, $2ssN0.sqrt)(2 / (1 + cxcy));
});
$d8cb3f1330e2df48$export$5e11f94fc4a8d2c6.invert = (0, $6ATdw.azimuthalInvert)(function(z) {
    return 2 * (0, $2ssN0.asin)(z / 2);
});
function $d8cb3f1330e2df48$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($d8cb3f1330e2df48$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("6ATdw", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", () => $4cd0efd8d1655ee4$export$f1211ac1bdb0796);
$parcel$export(module.exports, "azimuthalInvert", () => $4cd0efd8d1655ee4$export$3cee429f13e44eac);

var $2ssN0 = parcelRequire("2ssN0");
function $4cd0efd8d1655ee4$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $2ssN0.cos)(x), cy = (0, $2ssN0.cos)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $2ssN0.sin)(x),
            k * (0, $2ssN0.sin)(y)
        ];
    };
}
function $4cd0efd8d1655ee4$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $2ssN0.sqrt)(x * x + y * y), c = angle(z), sc = (0, $2ssN0.sin)(c), cc = (0, $2ssN0.cos)(c);
        return [
            (0, $2ssN0.atan2)(x * sc, z * cc),
            (0, $2ssN0.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("6mNYZ", function(module, exports) {

$parcel$export(module.exports, "azimuthalEquidistantRaw", () => $4a2b91a94fc5ad12$export$b94a4d6aa3dd25c);
$parcel$export(module.exports, "default", () => $4a2b91a94fc5ad12$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $6ATdw = parcelRequire("6ATdw");

var $66c7U = parcelRequire("66c7U");
var $4a2b91a94fc5ad12$export$b94a4d6aa3dd25c = (0, $6ATdw.azimuthalRaw)(function(c) {
    return (c = (0, $2ssN0.acos)(c)) && c / (0, $2ssN0.sin)(c);
});
$4a2b91a94fc5ad12$export$b94a4d6aa3dd25c.invert = (0, $6ATdw.azimuthalInvert)(function(z) {
    return z;
});
function $4a2b91a94fc5ad12$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($4a2b91a94fc5ad12$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("3LCvH", function(module, exports) {

$parcel$export(module.exports, "conicConformalRaw", () => $2be3a23c89814e7e$export$2b1bc913962ed170);
$parcel$export(module.exports, "default", () => $2be3a23c89814e7e$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $d3mPZ = parcelRequire("d3mPZ");

var $gIZcl = parcelRequire("gIZcl");
function $2be3a23c89814e7e$var$tany(y) {
    return (0, $2ssN0.tan)(((0, $2ssN0.halfPi) + y) / 2);
}
function $2be3a23c89814e7e$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $2ssN0.cos)(y0), n = y0 === y1 ? (0, $2ssN0.sin)(y0) : (0, $2ssN0.log)(cy0 / (0, $2ssN0.cos)(y1)) / (0, $2ssN0.log)($2be3a23c89814e7e$var$tany(y1) / $2be3a23c89814e7e$var$tany(y0)), f = cy0 * (0, $2ssN0.pow)($2be3a23c89814e7e$var$tany(y0), n) / n;
    if (!n) return 0, $gIZcl.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $2ssN0.halfPi) + (0, $2ssN0.epsilon)) y = -(0, $2ssN0.halfPi) + (0, $2ssN0.epsilon);
        } else if (y > (0, $2ssN0.halfPi) - (0, $2ssN0.epsilon)) y = (0, $2ssN0.halfPi) - (0, $2ssN0.epsilon);
        var r = f / (0, $2ssN0.pow)($2be3a23c89814e7e$var$tany(y), n);
        return [
            r * (0, $2ssN0.sin)(n * x),
            f - r * (0, $2ssN0.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $2ssN0.sign)(n) * (0, $2ssN0.sqrt)(x * x + fy * fy), l = (0, $2ssN0.atan2)(x, (0, $2ssN0.abs)(fy)) * (0, $2ssN0.sign)(fy);
        if (fy * n < 0) l -= (0, $2ssN0.pi) * (0, $2ssN0.sign)(x) * (0, $2ssN0.sign)(fy);
        return [
            l / n,
            2 * (0, $2ssN0.atan)((0, $2ssN0.pow)(f / r, 1 / n)) - (0, $2ssN0.halfPi)
        ];
    };
    return project;
}
function $2be3a23c89814e7e$export$2e2bcd8739ae039() {
    return (0, $d3mPZ.conicProjection)($2be3a23c89814e7e$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("gIZcl", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", () => $c2d03a1342920952$export$94ff8a57e9b91cc3);
$parcel$export(module.exports, "default", () => $c2d03a1342920952$export$2e2bcd8739ae039);
$parcel$export(module.exports, "mercatorProjection", () => $c2d03a1342920952$export$44b9b66a01f2127b);

var $2ssN0 = parcelRequire("2ssN0");

var $dhP4q = parcelRequire("dhP4q");

var $66c7U = parcelRequire("66c7U");
function $c2d03a1342920952$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $2ssN0.log)((0, $2ssN0.tan)(((0, $2ssN0.halfPi) + phi) / 2))
    ];
}
$c2d03a1342920952$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $2ssN0.atan)((0, $2ssN0.exp)(y)) - (0, $2ssN0.halfPi)
    ];
};
function $c2d03a1342920952$export$2e2bcd8739ae039() {
    return $c2d03a1342920952$export$44b9b66a01f2127b($c2d03a1342920952$export$94ff8a57e9b91cc3).scale(961 / (0, $2ssN0.tau));
}
function $c2d03a1342920952$export$44b9b66a01f2127b(project) {
    var m = (0, $66c7U.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $2ssN0.pi) * scale(), t = m((0, $dhP4q.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $c2d03a1342920952$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("9351D", function(module, exports) {

$parcel$export(module.exports, "conicEquidistantRaw", () => $69684ad2cc0fe972$export$24f604fe80e5f192);
$parcel$export(module.exports, "default", () => $69684ad2cc0fe972$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $d3mPZ = parcelRequire("d3mPZ");

var $gJXwU = parcelRequire("gJXwU");
function $69684ad2cc0fe972$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $2ssN0.cos)(y0), n = y0 === y1 ? (0, $2ssN0.sin)(y0) : (cy0 - (0, $2ssN0.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $2ssN0.abs)(n) < (0, $2ssN0.epsilon)) return 0, $gJXwU.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $2ssN0.sin)(nx),
            g - gy * (0, $2ssN0.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $2ssN0.atan2)(x, (0, $2ssN0.abs)(gy)) * (0, $2ssN0.sign)(gy);
        if (gy * n < 0) l -= (0, $2ssN0.pi) * (0, $2ssN0.sign)(x) * (0, $2ssN0.sign)(gy);
        return [
            l / n,
            g - (0, $2ssN0.sign)(n) * (0, $2ssN0.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $69684ad2cc0fe972$export$2e2bcd8739ae039() {
    return (0, $d3mPZ.conicProjection)($69684ad2cc0fe972$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("gJXwU", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", () => $c2ff06b6333dccd1$export$f5fee52180f2f058);
$parcel$export(module.exports, "default", () => $c2ff06b6333dccd1$export$2e2bcd8739ae039);

var $66c7U = parcelRequire("66c7U");
function $c2ff06b6333dccd1$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$c2ff06b6333dccd1$export$f5fee52180f2f058.invert = $c2ff06b6333dccd1$export$f5fee52180f2f058;
function $c2ff06b6333dccd1$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($c2ff06b6333dccd1$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("jF6JO", function(module, exports) {

$parcel$export(module.exports, "equalEarthRaw", () => $e50712a5798056a7$export$a320734067e7a731);
$parcel$export(module.exports, "default", () => $e50712a5798056a7$export$2e2bcd8739ae039);

var $66c7U = parcelRequire("66c7U");

var $2ssN0 = parcelRequire("2ssN0");
var $e50712a5798056a7$var$A1 = 1.340264, $e50712a5798056a7$var$A2 = -0.081106, $e50712a5798056a7$var$A3 = 0.000893, $e50712a5798056a7$var$A4 = 0.003796, $e50712a5798056a7$var$M = (0, $2ssN0.sqrt)(3) / 2, $e50712a5798056a7$var$iterations = 12;
function $e50712a5798056a7$export$a320734067e7a731(lambda, phi) {
    var l = (0, $2ssN0.asin)($e50712a5798056a7$var$M * (0, $2ssN0.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $2ssN0.cos)(l) / ($e50712a5798056a7$var$M * ($e50712a5798056a7$var$A1 + 3 * $e50712a5798056a7$var$A2 * l2 + l6 * (7 * $e50712a5798056a7$var$A3 + 9 * $e50712a5798056a7$var$A4 * l2))),
        l * ($e50712a5798056a7$var$A1 + $e50712a5798056a7$var$A2 * l2 + l6 * ($e50712a5798056a7$var$A3 + $e50712a5798056a7$var$A4 * l2))
    ];
}
$e50712a5798056a7$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $e50712a5798056a7$var$iterations; ++i){
        fy = l * ($e50712a5798056a7$var$A1 + $e50712a5798056a7$var$A2 * l2 + l6 * ($e50712a5798056a7$var$A3 + $e50712a5798056a7$var$A4 * l2)) - y;
        fpy = $e50712a5798056a7$var$A1 + 3 * $e50712a5798056a7$var$A2 * l2 + l6 * (7 * $e50712a5798056a7$var$A3 + 9 * $e50712a5798056a7$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $2ssN0.abs)(delta) < (0, $2ssN0.epsilon2)) break;
    }
    return [
        $e50712a5798056a7$var$M * x * ($e50712a5798056a7$var$A1 + 3 * $e50712a5798056a7$var$A2 * l2 + l6 * (7 * $e50712a5798056a7$var$A3 + 9 * $e50712a5798056a7$var$A4 * l2)) / (0, $2ssN0.cos)(l),
        (0, $2ssN0.asin)((0, $2ssN0.sin)(l) / $e50712a5798056a7$var$M)
    ];
};
function $e50712a5798056a7$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($e50712a5798056a7$export$a320734067e7a731).scale(177.158);
}

});

parcelRegister("1OeV0", function(module, exports) {

$parcel$export(module.exports, "gnomonicRaw", () => $15160875a2a0b4a3$export$dc8c6ddfc8b22c85);
$parcel$export(module.exports, "default", () => $15160875a2a0b4a3$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $6ATdw = parcelRequire("6ATdw");

var $66c7U = parcelRequire("66c7U");
function $15160875a2a0b4a3$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $2ssN0.cos)(y), k = (0, $2ssN0.cos)(x) * cy;
    return [
        cy * (0, $2ssN0.sin)(x) / k,
        (0, $2ssN0.sin)(y) / k
    ];
}
$15160875a2a0b4a3$export$dc8c6ddfc8b22c85.invert = (0, $6ATdw.azimuthalInvert)((0, $2ssN0.atan));
function $15160875a2a0b4a3$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($15160875a2a0b4a3$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("1i3k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0a0cfb7f68c856$export$2e2bcd8739ae039);

var $aYocN = parcelRequire("aYocN");

var $haFgD = parcelRequire("haFgD");

var $bWfHn = parcelRequire("bWfHn");

var $7jZdv = parcelRequire("7jZdv");

var $2ssN0 = parcelRequire("2ssN0");
function $0f0a0cfb7f68c856$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $bWfHn.transformer)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $haFgD.default), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $haFgD.default) : (0, $aYocN.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $2ssN0.radians), sa = (0, $2ssN0.sin)(alpha), ca = (0, $2ssN0.cos)(alpha), reset()) : alpha * (0, $2ssN0.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $7jZdv.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $7jZdv.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $7jZdv.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $7jZdv.fitHeight)(projection, height, object);
    };
    return projection;
}

});

parcelRegister("kh9hL", function(module, exports) {

$parcel$export(module.exports, "naturalEarth1Raw", () => $ec2c99164aae8479$export$acb6def22fe878e6);
$parcel$export(module.exports, "default", () => $ec2c99164aae8479$export$2e2bcd8739ae039);

var $66c7U = parcelRequire("66c7U");

var $2ssN0 = parcelRequire("2ssN0");
function $ec2c99164aae8479$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$ec2c99164aae8479$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $2ssN0.abs)(delta) > (0, $2ssN0.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $ec2c99164aae8479$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($ec2c99164aae8479$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("60S88", function(module, exports) {

$parcel$export(module.exports, "orthographicRaw", () => $460cbb4bb6460952$export$1cd9c2eb846182a);
$parcel$export(module.exports, "default", () => $460cbb4bb6460952$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $6ATdw = parcelRequire("6ATdw");

var $66c7U = parcelRequire("66c7U");
function $460cbb4bb6460952$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $2ssN0.cos)(y) * (0, $2ssN0.sin)(x),
        (0, $2ssN0.sin)(y)
    ];
}
$460cbb4bb6460952$export$1cd9c2eb846182a.invert = (0, $6ATdw.azimuthalInvert)((0, $2ssN0.asin));
function $460cbb4bb6460952$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($460cbb4bb6460952$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $2ssN0.epsilon));
}

});

parcelRegister("jBilA", function(module, exports) {

$parcel$export(module.exports, "stereographicRaw", () => $e44fb4673b75667b$export$f9ccbb0dcb3dcd2b);
$parcel$export(module.exports, "default", () => $e44fb4673b75667b$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $6ATdw = parcelRequire("6ATdw");

var $66c7U = parcelRequire("66c7U");
function $e44fb4673b75667b$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $2ssN0.cos)(y), k = 1 + (0, $2ssN0.cos)(x) * cy;
    return [
        cy * (0, $2ssN0.sin)(x) / k,
        (0, $2ssN0.sin)(y) / k
    ];
}
$e44fb4673b75667b$export$f9ccbb0dcb3dcd2b.invert = (0, $6ATdw.azimuthalInvert)(function(z) {
    return 2 * (0, $2ssN0.atan)(z);
});
function $e44fb4673b75667b$export$2e2bcd8739ae039() {
    return (0, $66c7U.default)($e44fb4673b75667b$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("2mZe2", function(module, exports) {

$parcel$export(module.exports, "transverseMercatorRaw", () => $1b9d20ea270865fe$export$e84942adec6de533);
$parcel$export(module.exports, "default", () => $1b9d20ea270865fe$export$2e2bcd8739ae039);

var $2ssN0 = parcelRequire("2ssN0");

var $gIZcl = parcelRequire("gIZcl");
function $1b9d20ea270865fe$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $2ssN0.log)((0, $2ssN0.tan)(((0, $2ssN0.halfPi) + phi) / 2)),
        -lambda
    ];
}
$1b9d20ea270865fe$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $2ssN0.atan)((0, $2ssN0.exp)(x)) - (0, $2ssN0.halfPi)
    ];
};
function $1b9d20ea270865fe$export$2e2bcd8739ae039() {
    var m = (0, $gIZcl.mercatorProjection)($1b9d20ea270865fe$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});


parcelRegister("2FHGO", function(module, exports) {

$parcel$export(module.exports, "cluster", () => (parcelRequire("1TEvk")).default);
$parcel$export(module.exports, "hierarchy", () => (parcelRequire("gFgWw")).default);
$parcel$export(module.exports, "pack", () => (parcelRequire("k4c8D")).default);
$parcel$export(module.exports, "packSiblings", () => (parcelRequire("7SJxE")).default);
$parcel$export(module.exports, "packEnclose", () => (parcelRequire("juWrQ")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("7bzOn")).default);
$parcel$export(module.exports, "stratify", () => (parcelRequire("cNdXi")).default);
$parcel$export(module.exports, "tree", () => (parcelRequire("48Fuz")).default);
$parcel$export(module.exports, "treemap", () => (parcelRequire("79lmm")).default);
$parcel$export(module.exports, "treemapBinary", () => (parcelRequire("g60jB")).default);
$parcel$export(module.exports, "treemapDice", () => (parcelRequire("bjRI6")).default);
$parcel$export(module.exports, "treemapSlice", () => (parcelRequire("6bf71")).default);
$parcel$export(module.exports, "treemapSliceDice", () => (parcelRequire("6GOn7")).default);
$parcel$export(module.exports, "treemapSquarify", () => (parcelRequire("hUEdR")).default);
$parcel$export(module.exports, "treemapResquarify", () => (parcelRequire("9hBWo")).default);

var $1TEvk = parcelRequire("1TEvk");

var $gFgWw = parcelRequire("gFgWw");

var $k4c8D = parcelRequire("k4c8D");

var $7SJxE = parcelRequire("7SJxE");

var $juWrQ = parcelRequire("juWrQ");

var $7bzOn = parcelRequire("7bzOn");

var $cNdXi = parcelRequire("cNdXi");

var $48Fuz = parcelRequire("48Fuz");

var $79lmm = parcelRequire("79lmm");

var $g60jB = parcelRequire("g60jB");

var $bjRI6 = parcelRequire("bjRI6");

var $6bf71 = parcelRequire("6bf71");

var $6GOn7 = parcelRequire("6GOn7");

var $hUEdR = parcelRequire("hUEdR");

var $9hBWo = parcelRequire("9hBWo");

});
parcelRegister("1TEvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $161a58d0934e7689$export$2e2bcd8739ae039);
function $161a58d0934e7689$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $161a58d0934e7689$var$meanX(children) {
    return children.reduce($161a58d0934e7689$var$meanXReduce, 0) / children.length;
}
function $161a58d0934e7689$var$meanXReduce(x, c) {
    return x + c.x;
}
function $161a58d0934e7689$var$maxY(children) {
    return 1 + children.reduce($161a58d0934e7689$var$maxYReduce, 0);
}
function $161a58d0934e7689$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $161a58d0934e7689$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $161a58d0934e7689$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $161a58d0934e7689$export$2e2bcd8739ae039() {
    var separation = $161a58d0934e7689$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $161a58d0934e7689$var$meanX(children);
                node.y = $161a58d0934e7689$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $161a58d0934e7689$var$leafLeft(root), right = $161a58d0934e7689$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}

});

parcelRegister("gFgWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21d9e2e37017efc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Node", () => $c21d9e2e37017efc$export$85c928794f8d04d4);
$parcel$export(module.exports, "computeHeight", () => $c21d9e2e37017efc$export$5af32d52ab5dfd57);

var $jWFUb = parcelRequire("jWFUb");

var $3MYzI = parcelRequire("3MYzI");

var $8cYxD = parcelRequire("8cYxD");

var $2RVH3 = parcelRequire("2RVH3");

var $ldLW0 = parcelRequire("ldLW0");

var $2qxiX = parcelRequire("2qxiX");

var $f783e = parcelRequire("f783e");

var $3Dwix = parcelRequire("3Dwix");

var $bs2di = parcelRequire("bs2di");

var $5DsS2 = parcelRequire("5DsS2");

var $j0bKe = parcelRequire("j0bKe");
function $c21d9e2e37017efc$export$2e2bcd8739ae039(data, children) {
    var root = new $c21d9e2e37017efc$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $c21d9e2e37017efc$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $c21d9e2e37017efc$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($c21d9e2e37017efc$export$5af32d52ab5dfd57);
}
function $c21d9e2e37017efc$var$node_copy() {
    return $c21d9e2e37017efc$export$2e2bcd8739ae039(this).eachBefore($c21d9e2e37017efc$var$copyData);
}
function $c21d9e2e37017efc$var$defaultChildren(d) {
    return d.children;
}
function $c21d9e2e37017efc$var$copyData(node) {
    node.data = node.data.data;
}
function $c21d9e2e37017efc$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $c21d9e2e37017efc$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$c21d9e2e37017efc$export$85c928794f8d04d4.prototype = $c21d9e2e37017efc$export$2e2bcd8739ae039.prototype = {
    constructor: $c21d9e2e37017efc$export$85c928794f8d04d4,
    count: (0, $jWFUb.default),
    each: (0, $3MYzI.default),
    eachAfter: (0, $2RVH3.default),
    eachBefore: (0, $8cYxD.default),
    sum: (0, $ldLW0.default),
    sort: (0, $2qxiX.default),
    path: (0, $f783e.default),
    ancestors: (0, $3Dwix.default),
    descendants: (0, $bs2di.default),
    leaves: (0, $5DsS2.default),
    links: (0, $j0bKe.default),
    copy: $c21d9e2e37017efc$var$node_copy
};

});
parcelRegister("jWFUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e853f09a0c934c81$export$2e2bcd8739ae039);
function $e853f09a0c934c81$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $e853f09a0c934c81$export$2e2bcd8739ae039() {
    return this.eachAfter($e853f09a0c934c81$var$count);
}

});

parcelRegister("3MYzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c24d7c179bc1153$export$2e2bcd8739ae039);
function $2c24d7c179bc1153$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}

});

parcelRegister("8cYxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9e6802400c6329$export$2e2bcd8739ae039);
function $5f9e6802400c6329$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}

});

parcelRegister("2RVH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $216d48b489bcba7a$export$2e2bcd8739ae039);
function $216d48b489bcba7a$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}

});

parcelRegister("ldLW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72ffeac77580ceb$export$2e2bcd8739ae039);
function $f72ffeac77580ceb$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}

});

parcelRegister("2qxiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c47d81f2fa486e9$export$2e2bcd8739ae039);
function $1c47d81f2fa486e9$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}

});

parcelRegister("f783e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00dc1400316ba28$export$2e2bcd8739ae039);
function $b00dc1400316ba28$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $b00dc1400316ba28$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $b00dc1400316ba28$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

});

parcelRegister("3Dwix", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a5e1155cc72755e$export$2e2bcd8739ae039);
function $2a5e1155cc72755e$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}

});

parcelRegister("bs2di", function(module, exports) {

$parcel$export(module.exports, "default", () => $856406cd63058593$export$2e2bcd8739ae039);
function $856406cd63058593$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}

});

parcelRegister("5DsS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $41a6fd5c05cbec7d$export$2e2bcd8739ae039);
function $41a6fd5c05cbec7d$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}

});

parcelRegister("j0bKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5720a36dacd31b$export$2e2bcd8739ae039);
function $dd5720a36dacd31b$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}

});


parcelRegister("k4c8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9bd98c950dafc2f$export$2e2bcd8739ae039);

var $7SJxE = parcelRequire("7SJxE");

var $lxZxX = parcelRequire("lxZxX");

var $at0yK = parcelRequire("at0yK");
function $e9bd98c950dafc2f$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $e9bd98c950dafc2f$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $at0yK.constantZero);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($e9bd98c950dafc2f$var$radiusLeaf(radius)).eachAfter($e9bd98c950dafc2f$var$packChildren(padding, 0.5)).eachBefore($e9bd98c950dafc2f$var$translateChild(1));
        else root.eachBefore($e9bd98c950dafc2f$var$radiusLeaf($e9bd98c950dafc2f$var$defaultRadius)).eachAfter($e9bd98c950dafc2f$var$packChildren((0, $at0yK.constantZero), 1)).eachAfter($e9bd98c950dafc2f$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($e9bd98c950dafc2f$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $lxZxX.optional)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $at0yK.default)(+x), pack) : padding;
    };
    return pack;
}
function $e9bd98c950dafc2f$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $e9bd98c950dafc2f$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $7SJxE.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $e9bd98c950dafc2f$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

});
parcelRegister("7SJxE", function(module, exports) {

$parcel$export(module.exports, "packEnclose", () => $5bd0e72da006dc34$export$b86b5dcbc4bfc7a7);
$parcel$export(module.exports, "default", () => $5bd0e72da006dc34$export$2e2bcd8739ae039);

var $juWrQ = parcelRequire("juWrQ");
function $5bd0e72da006dc34$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $5bd0e72da006dc34$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $5bd0e72da006dc34$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $5bd0e72da006dc34$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $5bd0e72da006dc34$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $5bd0e72da006dc34$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $5bd0e72da006dc34$var$Node(a), b = new $5bd0e72da006dc34$var$Node(b), c = new $5bd0e72da006dc34$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $5bd0e72da006dc34$var$place(a._, b._, c = circles[i]), c = new $5bd0e72da006dc34$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($5bd0e72da006dc34$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($5bd0e72da006dc34$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $5bd0e72da006dc34$var$score(a);
        while((c = c.next) !== b)if ((ca = $5bd0e72da006dc34$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $juWrQ.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $5bd0e72da006dc34$export$2e2bcd8739ae039(circles) {
    $5bd0e72da006dc34$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}

});
parcelRegister("juWrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31e2836d8a24553$export$2e2bcd8739ae039);

var $5xMbR = parcelRequire("5xMbR");
function $e31e2836d8a24553$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $5xMbR.shuffle)((0, $5xMbR.slice).call(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $e31e2836d8a24553$var$enclosesWeak(e, p)) ++i;
        else e = $e31e2836d8a24553$var$encloseBasis(B = $e31e2836d8a24553$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $e31e2836d8a24553$var$extendBasis(B, p) {
    var i, j;
    if ($e31e2836d8a24553$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($e31e2836d8a24553$var$enclosesNot(p, B[i]) && $e31e2836d8a24553$var$enclosesWeakAll($e31e2836d8a24553$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($e31e2836d8a24553$var$enclosesNot($e31e2836d8a24553$var$encloseBasis2(B[i], B[j]), p) && $e31e2836d8a24553$var$enclosesNot($e31e2836d8a24553$var$encloseBasis2(B[i], p), B[j]) && $e31e2836d8a24553$var$enclosesNot($e31e2836d8a24553$var$encloseBasis2(B[j], p), B[i]) && $e31e2836d8a24553$var$enclosesWeakAll($e31e2836d8a24553$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $e31e2836d8a24553$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $e31e2836d8a24553$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $e31e2836d8a24553$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$e31e2836d8a24553$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $e31e2836d8a24553$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $e31e2836d8a24553$var$encloseBasis1(B[0]);
        case 2:
            return $e31e2836d8a24553$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $e31e2836d8a24553$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $e31e2836d8a24553$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $e31e2836d8a24553$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $e31e2836d8a24553$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

});
parcelRegister("5xMbR", function(module, exports) {

$parcel$export(module.exports, "slice", () => $40956a6adac0f30f$export$58adb3bec8346d0f);
$parcel$export(module.exports, "shuffle", () => $40956a6adac0f30f$export$448332262467e042);
var $40956a6adac0f30f$export$58adb3bec8346d0f = Array.prototype.slice;
function $40956a6adac0f30f$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

});



parcelRegister("lxZxX", function(module, exports) {

$parcel$export(module.exports, "optional", () => $fafc6be9c227bade$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "required", () => $fafc6be9c227bade$export$a7a0278c004aac3f);
function $fafc6be9c227bade$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $fafc6be9c227bade$export$a7a0278c004aac3f(f);
}
function $fafc6be9c227bade$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

});

parcelRegister("at0yK", function(module, exports) {

$parcel$export(module.exports, "constantZero", () => $79ed0bebf2af5c18$export$99e2e371aa6a9db);
$parcel$export(module.exports, "default", () => $79ed0bebf2af5c18$export$2e2bcd8739ae039);
function $79ed0bebf2af5c18$export$99e2e371aa6a9db() {
    return 0;
}
function $79ed0bebf2af5c18$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("7bzOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b556ea06986012$export$2e2bcd8739ae039);

var $a91XM = parcelRequire("a91XM");

var $bjRI6 = parcelRequire("bjRI6");
function $53b556ea06986012$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $a91XM.default));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $bjRI6.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}

});
parcelRegister("a91XM", function(module, exports) {

$parcel$export(module.exports, "default", () => $762c4483865b663e$export$2e2bcd8739ae039);
function $762c4483865b663e$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}

});

parcelRegister("bjRI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $83db21d1b4f72041$export$2e2bcd8739ae039);
function $83db21d1b4f72041$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});


parcelRegister("cNdXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9504e2ea05f8311a$export$2e2bcd8739ae039);

var $lxZxX = parcelRequire("lxZxX");

var $gFgWw = parcelRequire("gFgWw");
var $9504e2ea05f8311a$var$keyPrefix = "$", $9504e2ea05f8311a$var$preroot = {
    depth: -1
}, $9504e2ea05f8311a$var$ambiguous = {};
function $9504e2ea05f8311a$var$defaultId(d) {
    return d.id;
}
function $9504e2ea05f8311a$var$defaultParentId(d) {
    return d.parentId;
}
function $9504e2ea05f8311a$export$2e2bcd8739ae039() {
    var id = $9504e2ea05f8311a$var$defaultId, parentId = $9504e2ea05f8311a$var$defaultParentId;
    function stratify(data) {
        var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
        for(i = 0; i < n; ++i){
            d = data[i], node = nodes[i] = new (0, $gFgWw.Node)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = $9504e2ea05f8311a$var$keyPrefix + (node.id = nodeId);
                nodeByKey[nodeKey] = nodeKey in nodeByKey ? $9504e2ea05f8311a$var$ambiguous : node;
            }
        }
        for(i = 0; i < n; ++i){
            node = nodes[i], nodeId = parentId(data[i], i, data);
            if (nodeId == null || !(nodeId += "")) {
                if (root) throw new Error("multiple roots");
                root = node;
            } else {
                parent = nodeByKey[$9504e2ea05f8311a$var$keyPrefix + nodeId];
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $9504e2ea05f8311a$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $9504e2ea05f8311a$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $gFgWw.computeHeight));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $lxZxX.required)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $lxZxX.required)(x), stratify) : parentId;
    };
    return stratify;
}

});

parcelRegister("48Fuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3038183de0254eb1$export$2e2bcd8739ae039);

var $gFgWw = parcelRequire("gFgWw");
function $3038183de0254eb1$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $3038183de0254eb1$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $3038183de0254eb1$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $3038183de0254eb1$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $3038183de0254eb1$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $3038183de0254eb1$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $3038183de0254eb1$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$3038183de0254eb1$var$TreeNode.prototype = Object.create((0, $gFgWw.Node).prototype);
function $3038183de0254eb1$var$treeRoot(root) {
    var tree = new $3038183de0254eb1$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $3038183de0254eb1$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $3038183de0254eb1$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $3038183de0254eb1$export$2e2bcd8739ae039() {
    var separation = $3038183de0254eb1$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $3038183de0254eb1$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $3038183de0254eb1$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $3038183de0254eb1$var$nextRight(vim), vip = $3038183de0254eb1$var$nextLeft(vip), vim && vip){
                vom = $3038183de0254eb1$var$nextLeft(vom);
                vop = $3038183de0254eb1$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $3038183de0254eb1$var$moveSubtree($3038183de0254eb1$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$3038183de0254eb1$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$3038183de0254eb1$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}

});

parcelRegister("79lmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5349f145167a030e$export$2e2bcd8739ae039);

var $a91XM = parcelRequire("a91XM");

var $hUEdR = parcelRequire("hUEdR");

var $lxZxX = parcelRequire("lxZxX");

var $at0yK = parcelRequire("at0yK");
function $5349f145167a030e$export$2e2bcd8739ae039() {
    var tile = (0, $hUEdR.default), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $at0yK.constantZero), paddingTop = (0, $at0yK.constantZero), paddingRight = (0, $at0yK.constantZero), paddingBottom = (0, $at0yK.constantZero), paddingLeft = (0, $at0yK.constantZero);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $a91XM.default));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $lxZxX.required)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $at0yK.default)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $at0yK.default)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $at0yK.default)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $at0yK.default)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $at0yK.default)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

});
parcelRegister("hUEdR", function(module, exports) {

$parcel$export(module.exports, "phi", () => $d0a6ddff4d75ae0e$export$324943737027944a);
$parcel$export(module.exports, "squarifyRatio", () => $d0a6ddff4d75ae0e$export$9ff1217655212093);
$parcel$export(module.exports, "default", () => $d0a6ddff4d75ae0e$export$2e2bcd8739ae039);

var $bjRI6 = parcelRequire("bjRI6");

var $6bf71 = parcelRequire("6bf71");
var $d0a6ddff4d75ae0e$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $d0a6ddff4d75ae0e$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $bjRI6.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $6bf71.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $d0a6ddff4d75ae0e$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $d0a6ddff4d75ae0e$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($d0a6ddff4d75ae0e$export$324943737027944a);

});
parcelRegister("6bf71", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ff7e27af3768d3$export$2e2bcd8739ae039);
function $47ff7e27af3768d3$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});



parcelRegister("g60jB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7d73720c563af3$export$2e2bcd8739ae039);
function $bb7d73720c563af3$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = (x0 * valueRight + x1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = (y0 * valueRight + y1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("6GOn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dedbd2211a321ec$export$2e2bcd8739ae039);

var $bjRI6 = parcelRequire("bjRI6");

var $6bf71 = parcelRequire("6bf71");
function $4dedbd2211a321ec$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $6bf71.default) : (0, $bjRI6.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("9hBWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c2321d7f89256b8$export$2e2bcd8739ae039);

var $bjRI6 = parcelRequire("bjRI6");

var $6bf71 = parcelRequire("6bf71");

var $hUEdR = parcelRequire("hUEdR");
var $6c2321d7f89256b8$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $bjRI6.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, $6bf71.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $hUEdR.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $hUEdR.phi));

});


parcelRegister("7FapI", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => (parcelRequire("4ONh6")).default);
$parcel$export(module.exports, "interpolateArray", () => (parcelRequire("5KJO9")).default);
$parcel$export(module.exports, "interpolateBasis", () => (parcelRequire("86tqN")).default);
$parcel$export(module.exports, "interpolateBasisClosed", () => (parcelRequire("l5LKG")).default);
$parcel$export(module.exports, "interpolateDate", () => (parcelRequire("7uriv")).default);
$parcel$export(module.exports, "interpolateDiscrete", () => (parcelRequire("kpAC2")).default);
$parcel$export(module.exports, "interpolateHue", () => (parcelRequire("7Sh1q")).default);
$parcel$export(module.exports, "interpolateNumber", () => (parcelRequire("34azb")).default);
$parcel$export(module.exports, "interpolateNumberArray", () => (parcelRequire("iOSz0")).default);
$parcel$export(module.exports, "interpolateObject", () => (parcelRequire("j5xin")).default);
$parcel$export(module.exports, "interpolateRound", () => (parcelRequire("kSfaZ")).default);
$parcel$export(module.exports, "interpolateString", () => (parcelRequire("8rKaq")).default);
$parcel$export(module.exports, "interpolateTransformCss", () => (parcelRequire("i3tg2")).interpolateTransformCss);
$parcel$export(module.exports, "interpolateTransformSvg", () => (parcelRequire("i3tg2")).interpolateTransformSvg);
$parcel$export(module.exports, "interpolateZoom", () => (parcelRequire("5lXLL")).default);
$parcel$export(module.exports, "interpolateRgb", () => (parcelRequire("lap8T")).default);
$parcel$export(module.exports, "interpolateRgbBasis", () => (parcelRequire("lap8T")).rgbBasis);
$parcel$export(module.exports, "interpolateRgbBasisClosed", () => (parcelRequire("lap8T")).rgbBasisClosed);
$parcel$export(module.exports, "interpolateHsl", () => (parcelRequire("cBWew")).default);
$parcel$export(module.exports, "interpolateHslLong", () => (parcelRequire("cBWew")).hslLong);
$parcel$export(module.exports, "interpolateLab", () => (parcelRequire("coFsQ")).default);
$parcel$export(module.exports, "interpolateHcl", () => (parcelRequire("iz274")).default);
$parcel$export(module.exports, "interpolateHclLong", () => (parcelRequire("iz274")).hclLong);
$parcel$export(module.exports, "interpolateCubehelix", () => (parcelRequire("29rg6")).default);
$parcel$export(module.exports, "interpolateCubehelixLong", () => (parcelRequire("29rg6")).cubehelixLong);
$parcel$export(module.exports, "piecewise", () => (parcelRequire("dV13s")).default);
$parcel$export(module.exports, "quantize", () => (parcelRequire("izj9I")).default);

var $4ONh6 = parcelRequire("4ONh6");

var $5KJO9 = parcelRequire("5KJO9");

var $86tqN = parcelRequire("86tqN");

var $l5LKG = parcelRequire("l5LKG");

var $7uriv = parcelRequire("7uriv");

var $kpAC2 = parcelRequire("kpAC2");

var $7Sh1q = parcelRequire("7Sh1q");

var $34azb = parcelRequire("34azb");

var $iOSz0 = parcelRequire("iOSz0");

var $j5xin = parcelRequire("j5xin");

var $kSfaZ = parcelRequire("kSfaZ");

var $8rKaq = parcelRequire("8rKaq");

var $i3tg2 = parcelRequire("i3tg2");

var $5lXLL = parcelRequire("5lXLL");

var $lap8T = parcelRequire("lap8T");

var $cBWew = parcelRequire("cBWew");

var $coFsQ = parcelRequire("coFsQ");

var $iz274 = parcelRequire("iz274");

var $29rg6 = parcelRequire("29rg6");

var $dV13s = parcelRequire("dV13s");

var $izj9I = parcelRequire("izj9I");

});
parcelRegister("kpAC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc28af221815d44$export$2e2bcd8739ae039);
function $edc28af221815d44$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("7Sh1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bbac7c937687503$export$2e2bcd8739ae039);

var $6isdb = parcelRequire("6isdb");
function $5bbac7c937687503$export$2e2bcd8739ae039(a, b) {
    var i = (0, $6isdb.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("kSfaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3249f7e675a7e74$export$2e2bcd8739ae039);
function $f3249f7e675a7e74$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("5lXLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5d46e41644f294$export$2e2bcd8739ae039);
var $3e5d46e41644f294$var$rho = Math.SQRT2, $3e5d46e41644f294$var$rho2 = 2, $3e5d46e41644f294$var$rho4 = 4, $3e5d46e41644f294$var$epsilon2 = 1e-12;
function $3e5d46e41644f294$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $3e5d46e41644f294$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $3e5d46e41644f294$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $3e5d46e41644f294$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $3e5d46e41644f294$var$epsilon2) {
        S = Math.log(w1 / w0) / $3e5d46e41644f294$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($3e5d46e41644f294$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $3e5d46e41644f294$var$rho4 * d2) / (2 * w0 * $3e5d46e41644f294$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $3e5d46e41644f294$var$rho4 * d2) / (2 * w1 * $3e5d46e41644f294$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $3e5d46e41644f294$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $3e5d46e41644f294$var$cosh(r0), u = w0 / ($3e5d46e41644f294$var$rho2 * d1) * (coshr0 * $3e5d46e41644f294$var$tanh($3e5d46e41644f294$var$rho * s + r0) - $3e5d46e41644f294$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $3e5d46e41644f294$var$cosh($3e5d46e41644f294$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}

});

parcelRegister("cBWew", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e61ca9822f2c10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hslLong", () => $92e61ca9822f2c10$export$a2c535e270a59256);

var $7TBR2 = parcelRequire("7TBR2");

var $6isdb = parcelRequire("6isdb");
function $92e61ca9822f2c10$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7TBR2.hsl)(start)).h, (end = (0, $7TBR2.hsl)(end)).h), s = (0, $6isdb.default)(start.s, end.s), l = (0, $6isdb.default)(start.l, end.l), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $92e61ca9822f2c10$export$2e2bcd8739ae039 = $92e61ca9822f2c10$var$hsl((0, $6isdb.hue));
var $92e61ca9822f2c10$export$a2c535e270a59256 = $92e61ca9822f2c10$var$hsl((0, $6isdb.default));

});

parcelRegister("coFsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9067e3d7b24555ed$export$2e2bcd8739ae039);

var $iB2u4 = parcelRequire("iB2u4");

var $6isdb = parcelRequire("6isdb");
function $9067e3d7b24555ed$export$2e2bcd8739ae039(start, end) {
    var l = (0, $6isdb.default)((start = (0, $iB2u4.default)(start)).l, (end = (0, $iB2u4.default)(end)).l), a = (0, $6isdb.default)(start.a, end.a), b = (0, $6isdb.default)(start.b, end.b), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});
parcelRegister("iB2u4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d89d9bf4e4ae0fca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hcl", () => $d89d9bf4e4ae0fca$export$d0e870ba50062ff1);

var $llFwZ = parcelRequire("llFwZ");

var $7TBR2 = parcelRequire("7TBR2");

var $l7euY = parcelRequire("l7euY");
// https://observablehq.com/@mbostock/lab-and-rgb
var $d89d9bf4e4ae0fca$var$K = 18, $d89d9bf4e4ae0fca$var$Xn = 0.96422, $d89d9bf4e4ae0fca$var$Yn = 1, $d89d9bf4e4ae0fca$var$Zn = 0.82521, $d89d9bf4e4ae0fca$var$t0 = 4 / 29, $d89d9bf4e4ae0fca$var$t1 = 6 / 29, $d89d9bf4e4ae0fca$var$t2 = 3 * $d89d9bf4e4ae0fca$var$t1 * $d89d9bf4e4ae0fca$var$t1, $d89d9bf4e4ae0fca$var$t3 = $d89d9bf4e4ae0fca$var$t1 * $d89d9bf4e4ae0fca$var$t1 * $d89d9bf4e4ae0fca$var$t1;
function $d89d9bf4e4ae0fca$var$labConvert(o) {
    if (o instanceof $d89d9bf4e4ae0fca$export$f2722c70a60257f7) return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a) return $d89d9bf4e4ae0fca$var$hcl2lab(o);
    if (!(o instanceof (0, $7TBR2.Rgb))) o = (0, $7TBR2.rgbConvert)(o);
    var r = $d89d9bf4e4ae0fca$var$rgb2lrgb(o.r), g = $d89d9bf4e4ae0fca$var$rgb2lrgb(o.g), b = $d89d9bf4e4ae0fca$var$rgb2lrgb(o.b), y = $d89d9bf4e4ae0fca$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $d89d9bf4e4ae0fca$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $d89d9bf4e4ae0fca$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $d89d9bf4e4ae0fca$var$Xn);
        z = $d89d9bf4e4ae0fca$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $d89d9bf4e4ae0fca$var$Zn);
    }
    return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $d89d9bf4e4ae0fca$export$3e2c219d3ab79d01(l, opacity) {
    return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $d89d9bf4e4ae0fca$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $d89d9bf4e4ae0fca$var$labConvert(l) : new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $d89d9bf4e4ae0fca$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $llFwZ.default)($d89d9bf4e4ae0fca$export$f2722c70a60257f7, $d89d9bf4e4ae0fca$export$2e2bcd8739ae039, (0, $llFwZ.extend)((0, $7TBR2.Color), {
    brighter: function(k) {
        return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(this.l + $d89d9bf4e4ae0fca$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(this.l - $d89d9bf4e4ae0fca$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $d89d9bf4e4ae0fca$var$Xn * $d89d9bf4e4ae0fca$var$lab2xyz(x);
        y = $d89d9bf4e4ae0fca$var$Yn * $d89d9bf4e4ae0fca$var$lab2xyz(y);
        z = $d89d9bf4e4ae0fca$var$Zn * $d89d9bf4e4ae0fca$var$lab2xyz(z);
        return new (0, $7TBR2.Rgb)($d89d9bf4e4ae0fca$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $d89d9bf4e4ae0fca$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $d89d9bf4e4ae0fca$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $d89d9bf4e4ae0fca$var$xyz2lab(t) {
    return t > $d89d9bf4e4ae0fca$var$t3 ? Math.pow(t, 1 / 3) : t / $d89d9bf4e4ae0fca$var$t2 + $d89d9bf4e4ae0fca$var$t0;
}
function $d89d9bf4e4ae0fca$var$lab2xyz(t) {
    return t > $d89d9bf4e4ae0fca$var$t1 ? t * t * t : $d89d9bf4e4ae0fca$var$t2 * (t - $d89d9bf4e4ae0fca$var$t0);
}
function $d89d9bf4e4ae0fca$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $d89d9bf4e4ae0fca$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $d89d9bf4e4ae0fca$var$hclConvert(o) {
    if (o instanceof $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a) return new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $d89d9bf4e4ae0fca$export$f2722c70a60257f7)) o = $d89d9bf4e4ae0fca$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $l7euY.rad2deg);
    return new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $d89d9bf4e4ae0fca$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $d89d9bf4e4ae0fca$var$hclConvert(l) : new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $d89d9bf4e4ae0fca$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $d89d9bf4e4ae0fca$var$hclConvert(h) : new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $d89d9bf4e4ae0fca$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $l7euY.deg2rad);
    return new $d89d9bf4e4ae0fca$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $llFwZ.default)($d89d9bf4e4ae0fca$export$d9397e094a5fbb9a, $d89d9bf4e4ae0fca$export$d0e870ba50062ff1, (0, $llFwZ.extend)((0, $7TBR2.Color), {
    brighter: function(k) {
        return new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(this.h, this.c, this.l + $d89d9bf4e4ae0fca$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $d89d9bf4e4ae0fca$export$d9397e094a5fbb9a(this.h, this.c, this.l - $d89d9bf4e4ae0fca$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $d89d9bf4e4ae0fca$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("l7euY", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $f5f57f899a70217e$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $f5f57f899a70217e$export$b2ba2578f2c43d74);
var $f5f57f899a70217e$export$b1b275608b2b1b8 = Math.PI / 180;
var $f5f57f899a70217e$export$b2ba2578f2c43d74 = 180 / Math.PI;

});



parcelRegister("iz274", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83d22810528f6c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hclLong", () => $d83d22810528f6c6$export$5aaa50f7615f9b70);

var $iB2u4 = parcelRequire("iB2u4");

var $6isdb = parcelRequire("6isdb");
function $d83d22810528f6c6$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $iB2u4.hcl)(start)).h, (end = (0, $iB2u4.hcl)(end)).h), c = (0, $6isdb.default)(start.c, end.c), l = (0, $6isdb.default)(start.l, end.l), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $d83d22810528f6c6$export$2e2bcd8739ae039 = $d83d22810528f6c6$var$hcl((0, $6isdb.hue));
var $d83d22810528f6c6$export$5aaa50f7615f9b70 = $d83d22810528f6c6$var$hcl((0, $6isdb.default));

});

parcelRegister("29rg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1911910ee49510df$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cubehelixLong", () => $1911910ee49510df$export$934fa09ad474a1b4);

var $jgwrE = parcelRequire("jgwrE");

var $6isdb = parcelRequire("6isdb");
function $1911910ee49510df$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $jgwrE.default)(start)).h, (end = (0, $jgwrE.default)(end)).h), s = (0, $6isdb.default)(start.s, end.s), l = (0, $6isdb.default)(start.l, end.l), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $1911910ee49510df$export$2e2bcd8739ae039 = $1911910ee49510df$var$cubehelix((0, $6isdb.hue));
var $1911910ee49510df$export$934fa09ad474a1b4 = $1911910ee49510df$var$cubehelix((0, $6isdb.default));

});
parcelRegister("jgwrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e068add6336fb8a2$export$2e2bcd8739ae039);

var $llFwZ = parcelRequire("llFwZ");

var $7TBR2 = parcelRequire("7TBR2");

var $l7euY = parcelRequire("l7euY");
var $e068add6336fb8a2$var$A = -0.14861, $e068add6336fb8a2$var$B = 1.78277, $e068add6336fb8a2$var$C = -0.29227, $e068add6336fb8a2$var$D = -0.90649, $e068add6336fb8a2$var$E = 1.97294, $e068add6336fb8a2$var$ED = $e068add6336fb8a2$var$E * $e068add6336fb8a2$var$D, $e068add6336fb8a2$var$EB = $e068add6336fb8a2$var$E * $e068add6336fb8a2$var$B, $e068add6336fb8a2$var$BC_DA = $e068add6336fb8a2$var$B * $e068add6336fb8a2$var$C - $e068add6336fb8a2$var$D * $e068add6336fb8a2$var$A;
function $e068add6336fb8a2$var$cubehelixConvert(o) {
    if (o instanceof $e068add6336fb8a2$export$57ed4bde61a1e2f2) return new $e068add6336fb8a2$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $7TBR2.Rgb))) o = (0, $7TBR2.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($e068add6336fb8a2$var$BC_DA * b + $e068add6336fb8a2$var$ED * r - $e068add6336fb8a2$var$EB * g) / ($e068add6336fb8a2$var$BC_DA + $e068add6336fb8a2$var$ED - $e068add6336fb8a2$var$EB), bl = b - l, k = ($e068add6336fb8a2$var$E * (g - l) - $e068add6336fb8a2$var$C * bl) / $e068add6336fb8a2$var$D, s = Math.sqrt(k * k + bl * bl) / ($e068add6336fb8a2$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $l7euY.rad2deg) - 120 : NaN;
    return new $e068add6336fb8a2$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $e068add6336fb8a2$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $e068add6336fb8a2$var$cubehelixConvert(h) : new $e068add6336fb8a2$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $e068add6336fb8a2$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $llFwZ.default)($e068add6336fb8a2$export$57ed4bde61a1e2f2, $e068add6336fb8a2$export$2e2bcd8739ae039, (0, $llFwZ.extend)((0, $7TBR2.Color), {
    brighter: function(k) {
        k = k == null ? (0, $7TBR2.brighter) : Math.pow((0, $7TBR2.brighter), k);
        return new $e068add6336fb8a2$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $7TBR2.darker) : Math.pow((0, $7TBR2.darker), k);
        return new $e068add6336fb8a2$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $l7euY.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $7TBR2.Rgb)(255 * (l + a * ($e068add6336fb8a2$var$A * cosh + $e068add6336fb8a2$var$B * sinh)), 255 * (l + a * ($e068add6336fb8a2$var$C * cosh + $e068add6336fb8a2$var$D * sinh)), 255 * (l + a * ($e068add6336fb8a2$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("dV13s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2216aaac49b3e0c$export$2e2bcd8739ae039);
function $a2216aaac49b3e0c$export$2e2bcd8739ae039(interpolate, values) {
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("izj9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d84a5acc52934ab9$export$2e2bcd8739ae039);
function $d84a5acc52934ab9$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("hv0Wi", function(module, exports) {

$parcel$export(module.exports, "path", () => (parcelRequire("176ah")).default);

var $176ah = parcelRequire("176ah");

});

parcelRegister("8V7nn", function(module, exports) {

$parcel$export(module.exports, "polygonArea", () => (parcelRequire("dDezH")).default);
$parcel$export(module.exports, "polygonCentroid", () => (parcelRequire("1KFys")).default);
$parcel$export(module.exports, "polygonHull", () => (parcelRequire("en5JR")).default);
$parcel$export(module.exports, "polygonContains", () => (parcelRequire("itrJs")).default);
$parcel$export(module.exports, "polygonLength", () => (parcelRequire("lySt0")).default);

var $dDezH = parcelRequire("dDezH");

var $1KFys = parcelRequire("1KFys");

var $en5JR = parcelRequire("en5JR");

var $itrJs = parcelRequire("itrJs");

var $lySt0 = parcelRequire("lySt0");

});
parcelRegister("dDezH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eca39256006a0e4$export$2e2bcd8739ae039);
function $9eca39256006a0e4$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}

});

parcelRegister("1KFys", function(module, exports) {

$parcel$export(module.exports, "default", () => $146a523c6fbf83a7$export$2e2bcd8739ae039);
function $146a523c6fbf83a7$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}

});

parcelRegister("en5JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a767aa3f7281f72a$export$2e2bcd8739ae039);

var $kBrZ8 = parcelRequire("kBrZ8");
function $a767aa3f7281f72a$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $a767aa3f7281f72a$var$computeUpperHullIndexes(points) {
    var n = points.length, indexes = [
        0,
        1
    ], size = 2;
    for(var i = 2; i < n; ++i){
        while(size > 1 && (0, $kBrZ8.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $a767aa3f7281f72a$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($a767aa3f7281f72a$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $a767aa3f7281f72a$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $a767aa3f7281f72a$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}

});
parcelRegister("kBrZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $effcf89c0bad0333$export$2e2bcd8739ae039);
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $effcf89c0bad0333$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

});


parcelRegister("itrJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7307274e3707ac2$export$2e2bcd8739ae039);
function $d7307274e3707ac2$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}

});

parcelRegister("lySt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2705e9110a9bb1$export$2e2bcd8739ae039);
function $fb2705e9110a9bb1$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.sqrt(xa * xa + ya * ya);
    }
    return perimeter;
}

});


parcelRegister("h1Vgw", function(module, exports) {

$parcel$export(module.exports, "quadtree", () => (parcelRequire("8H00M")).default);

var $8H00M = parcelRequire("8H00M");

});

parcelRegister("aZAXJ", function(module, exports) {

$parcel$export(module.exports, "randomUniform", () => (parcelRequire("jixt5")).default);
$parcel$export(module.exports, "randomNormal", () => (parcelRequire("hgXde")).default);
$parcel$export(module.exports, "randomLogNormal", () => (parcelRequire("igsxq")).default);
$parcel$export(module.exports, "randomBates", () => (parcelRequire("6xlSw")).default);
$parcel$export(module.exports, "randomIrwinHall", () => (parcelRequire("998gu")).default);
$parcel$export(module.exports, "randomExponential", () => (parcelRequire("dVNnA")).default);

var $jixt5 = parcelRequire("jixt5");

var $hgXde = parcelRequire("hgXde");

var $igsxq = parcelRequire("igsxq");

var $6xlSw = parcelRequire("6xlSw");

var $998gu = parcelRequire("998gu");

var $dVNnA = parcelRequire("dVNnA");

});
parcelRegister("jixt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c9a8da77281330$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");
var $e0c9a8da77281330$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $in1tu.default));

});
parcelRegister("in1tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $03738a6674295e43$export$2e2bcd8739ae039);
function $03738a6674295e43$export$2e2bcd8739ae039() {
    return Math.random();
}

});


parcelRegister("hgXde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c931dca3c83ec285$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");
var $c931dca3c83ec285$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $in1tu.default));

});

parcelRegister("igsxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4bfdbaea471cc4e$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");

var $hgXde = parcelRequire("hgXde");
var $d4bfdbaea471cc4e$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, $hgXde.default).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $in1tu.default));

});

parcelRegister("6xlSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26cbbe217e9fd2$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");

var $998gu = parcelRequire("998gu");
var $4c26cbbe217e9fd2$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, $998gu.default).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $in1tu.default));

});
parcelRegister("998gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8b5d8ddbd1d462$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");
var $6a8b5d8ddbd1d462$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $in1tu.default));

});


parcelRegister("dVNnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a246e6f3cd8bd3df$export$2e2bcd8739ae039);

var $in1tu = parcelRequire("in1tu");
var $a246e6f3cd8bd3df$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $in1tu.default));

});


parcelRegister("eTC2I", function(module, exports) {

$parcel$export(module.exports, "scaleBand", () => (parcelRequire("8V5eP")).default);
$parcel$export(module.exports, "scalePoint", () => (parcelRequire("8V5eP")).point);
$parcel$export(module.exports, "scaleIdentity", () => (parcelRequire("cmAel")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("l0gqL")).default);
$parcel$export(module.exports, "scaleLog", () => (parcelRequire("hBLnv")).default);
$parcel$export(module.exports, "scaleSymlog", () => (parcelRequire("bcLGb")).default);
$parcel$export(module.exports, "scaleOrdinal", () => (parcelRequire("1BIcY")).default);
$parcel$export(module.exports, "scaleImplicit", () => (parcelRequire("1BIcY")).implicit);
$parcel$export(module.exports, "scalePow", () => (parcelRequire("faiGI")).default);
$parcel$export(module.exports, "scaleSqrt", () => (parcelRequire("faiGI")).sqrt);
$parcel$export(module.exports, "scaleQuantile", () => (parcelRequire("92AG8")).default);
$parcel$export(module.exports, "scaleQuantize", () => (parcelRequire("7J9j5")).default);
$parcel$export(module.exports, "scaleThreshold", () => (parcelRequire("aOvZJ")).default);
$parcel$export(module.exports, "scaleTime", () => (parcelRequire("kPFCU")).default);
$parcel$export(module.exports, "scaleUtc", () => (parcelRequire("2cFHM")).default);
$parcel$export(module.exports, "scaleSequential", () => (parcelRequire("gSZjF")).default);
$parcel$export(module.exports, "scaleSequentialLog", () => (parcelRequire("gSZjF")).sequentialLog);
$parcel$export(module.exports, "scaleSequentialPow", () => (parcelRequire("gSZjF")).sequentialPow);
$parcel$export(module.exports, "scaleSequentialSqrt", () => (parcelRequire("gSZjF")).sequentialSqrt);
$parcel$export(module.exports, "scaleSequentialSymlog", () => (parcelRequire("gSZjF")).sequentialSymlog);
$parcel$export(module.exports, "scaleSequentialQuantile", () => (parcelRequire("fBnKL")).default);
$parcel$export(module.exports, "scaleDiverging", () => (parcelRequire("b1jld")).default);
$parcel$export(module.exports, "scaleDivergingLog", () => (parcelRequire("b1jld")).divergingLog);
$parcel$export(module.exports, "scaleDivergingPow", () => (parcelRequire("b1jld")).divergingPow);
$parcel$export(module.exports, "scaleDivergingSqrt", () => (parcelRequire("b1jld")).divergingSqrt);
$parcel$export(module.exports, "scaleDivergingSymlog", () => (parcelRequire("b1jld")).divergingSymlog);
$parcel$export(module.exports, "tickFormat", () => (parcelRequire("hV6Mi")).default);

var $8V5eP = parcelRequire("8V5eP");

var $cmAel = parcelRequire("cmAel");

var $l0gqL = parcelRequire("l0gqL");

var $hBLnv = parcelRequire("hBLnv");

var $bcLGb = parcelRequire("bcLGb");

var $1BIcY = parcelRequire("1BIcY");

var $faiGI = parcelRequire("faiGI");

var $92AG8 = parcelRequire("92AG8");

var $7J9j5 = parcelRequire("7J9j5");

var $aOvZJ = parcelRequire("aOvZJ");

var $kPFCU = parcelRequire("kPFCU");

var $2cFHM = parcelRequire("2cFHM");

var $gSZjF = parcelRequire("gSZjF");

var $fBnKL = parcelRequire("fBnKL");

var $b1jld = parcelRequire("b1jld");

var $hV6Mi = parcelRequire("hV6Mi");

});
parcelRegister("8V5eP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67e7b5cd3c1d1984$export$2e2bcd8739ae039);
$parcel$export(module.exports, "point", () => $67e7b5cd3c1d1984$export$105684a3041cb6f3);
parcelRequire("4Plq2");
var $c44DK = parcelRequire("c44DK");

var $7Mads = parcelRequire("7Mads");

var $1BIcY = parcelRequire("1BIcY");
function $67e7b5cd3c1d1984$export$2e2bcd8739ae039() {
    var scale = (0, $1BIcY.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $c44DK.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $67e7b5cd3c1d1984$export$2e2bcd8739ae039(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $7Mads.initRange).apply(rescale(), arguments);
}
function $67e7b5cd3c1d1984$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $67e7b5cd3c1d1984$var$pointish(copy());
    };
    return scale;
}
function $67e7b5cd3c1d1984$export$105684a3041cb6f3() {
    return $67e7b5cd3c1d1984$var$pointish($67e7b5cd3c1d1984$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("7Mads", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $5a94f0cb17c0bc91$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $5a94f0cb17c0bc91$export$7d6b419e59e83f3d);
function $5a94f0cb17c0bc91$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5a94f0cb17c0bc91$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.interpolator(domain);
            break;
        default:
            this.interpolator(interpolator).domain(domain);
            break;
    }
    return this;
}

});

parcelRegister("1BIcY", function(module, exports) {

$parcel$export(module.exports, "implicit", () => $12bb8a028024bc48$export$e4f898ab14d9d460);
$parcel$export(module.exports, "default", () => $12bb8a028024bc48$export$2e2bcd8739ae039);
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");

var $6vB8f = parcelRequire("6vB8f");

var $7Mads = parcelRequire("7Mads");
var $12bb8a028024bc48$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $12bb8a028024bc48$export$2e2bcd8739ae039() {
    var index = (0, $5Mltl.default)(), domain = [], range = [], unknown = $12bb8a028024bc48$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $12bb8a028024bc48$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $5Mltl.default)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6vB8f.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $12bb8a028024bc48$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $7Mads.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("6vB8f", function(module, exports) {

$parcel$export(module.exports, "map", () => $4bd270f7a190e1b8$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $4bd270f7a190e1b8$export$58adb3bec8346d0f);
var $4bd270f7a190e1b8$var$array = Array.prototype;
var $4bd270f7a190e1b8$export$871de8747c9eaa88 = $4bd270f7a190e1b8$var$array.map;
var $4bd270f7a190e1b8$export$58adb3bec8346d0f = $4bd270f7a190e1b8$var$array.slice;

});



parcelRegister("cmAel", function(module, exports) {

$parcel$export(module.exports, "default", () => $9003a4b63fddf08d$export$2e2bcd8739ae039);

var $6vB8f = parcelRequire("6vB8f");

var $l0gqL = parcelRequire("l0gqL");

var $eyko4 = parcelRequire("eyko4");
function $9003a4b63fddf08d$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $6vB8f.map).call(_, (0, $eyko4.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $9003a4b63fddf08d$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? (0, $6vB8f.map).call(domain, (0, $eyko4.default)) : [
        0,
        1
    ];
    return (0, $l0gqL.linearish)(scale);
}

});
parcelRegister("l0gqL", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $f4a657d50a9236d6$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $f4a657d50a9236d6$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $8YDch = parcelRequire("8YDch");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");

var $hV6Mi = parcelRequire("hV6Mi");
function $f4a657d50a9236d6$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $8YDch.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $hV6Mi.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $8YDch.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $8YDch.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $8YDch.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $f4a657d50a9236d6$export$2e2bcd8739ae039() {
    var scale = (0, $lnCzi.default)((0, $lnCzi.identity), (0, $lnCzi.identity));
    scale.copy = function() {
        return (0, $lnCzi.copy)(scale, $f4a657d50a9236d6$export$2e2bcd8739ae039());
    };
    (0, $7Mads.initRange).apply(scale, arguments);
    return $f4a657d50a9236d6$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("lnCzi", function(module, exports) {

$parcel$export(module.exports, "identity", () => $f909a9cd374ba4d2$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $f909a9cd374ba4d2$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $f909a9cd374ba4d2$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $f909a9cd374ba4d2$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $2A9YO = parcelRequire("2A9YO");

var $4ONh6 = parcelRequire("4ONh6");
var $34azb = parcelRequire("34azb");
var $kSfaZ = parcelRequire("kSfaZ");

var $6vB8f = parcelRequire("6vB8f");

var $k3uDD = parcelRequire("k3uDD");

var $eyko4 = parcelRequire("eyko4");
var $f909a9cd374ba4d2$var$unit = [
    0,
    1
];
function $f909a9cd374ba4d2$export$f0954fd7d5368655(x) {
    return x;
}
function $f909a9cd374ba4d2$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $k3uDD.default)(isNaN(b) ? NaN : 0.5);
}
function $f909a9cd374ba4d2$var$clamper(domain) {
    var a = domain[0], b = domain[domain.length - 1], t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $f909a9cd374ba4d2$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $f909a9cd374ba4d2$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $f909a9cd374ba4d2$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $f909a9cd374ba4d2$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $f909a9cd374ba4d2$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $2A9YO.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $f909a9cd374ba4d2$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $f909a9cd374ba4d2$export$6b468dcfb64c653c() {
    var domain = $f909a9cd374ba4d2$var$unit, range = $f909a9cd374ba4d2$var$unit, interpolate = (0, $4ONh6.default), transform, untransform, unknown, clamp = $f909a9cd374ba4d2$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $f909a9cd374ba4d2$var$polymap : $f909a9cd374ba4d2$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $34azb.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $6vB8f.map).call(_, (0, $eyko4.default)), clamp === $f909a9cd374ba4d2$export$f0954fd7d5368655 || (clamp = $f909a9cd374ba4d2$var$clamper(domain)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6vB8f.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $6vB8f.slice).call(_), interpolate = (0, $kSfaZ.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? $f909a9cd374ba4d2$var$clamper(domain) : $f909a9cd374ba4d2$export$f0954fd7d5368655, scale) : clamp !== $f909a9cd374ba4d2$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $f909a9cd374ba4d2$export$2e2bcd8739ae039(transform, untransform) {
    return $f909a9cd374ba4d2$export$6b468dcfb64c653c()(transform, untransform);
}

});
parcelRegister("k3uDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99bda8fc9aa2cdc$export$2e2bcd8739ae039);
function $e99bda8fc9aa2cdc$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("eyko4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9840e2b3b0d15c9$export$2e2bcd8739ae039);
function $a9840e2b3b0d15c9$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("hV6Mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bd04865c2f03f2$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $8YDch = parcelRequire("8YDch");

var $haUiJ = parcelRequire("haUiJ");
var $1C4ra = parcelRequire("1C4ra");
var $4UzjU = parcelRequire("4UzjU");
var $l3ng3 = parcelRequire("l3ng3");
var $lLQAg = parcelRequire("lLQAg");
function $d0bd04865c2f03f2$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $8YDch.tickStep)(start, stop, count), precision;
    specifier = (0, $1C4ra.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $l3ng3.default)(step, value))) specifier.precision = precision;
            return (0, $haUiJ.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $lLQAg.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $4UzjU.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $haUiJ.format)(specifier);
}

});



parcelRegister("hBLnv", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $cd1aa4a8e2529717$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $cd1aa4a8e2529717$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $8YDch = parcelRequire("8YDch");

var $haUiJ = parcelRequire("haUiJ");

var $icwPY = parcelRequire("icwPY");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");
function $cd1aa4a8e2529717$var$transformLog(x) {
    return Math.log(x);
}
function $cd1aa4a8e2529717$var$transformExp(x) {
    return Math.exp(x);
}
function $cd1aa4a8e2529717$var$transformLogn(x) {
    return -Math.log(-x);
}
function $cd1aa4a8e2529717$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $cd1aa4a8e2529717$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $cd1aa4a8e2529717$var$powp(base) {
    return base === 10 ? $cd1aa4a8e2529717$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $cd1aa4a8e2529717$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $cd1aa4a8e2529717$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $cd1aa4a8e2529717$export$860836db074028f0(transform) {
    var scale = transform($cd1aa4a8e2529717$var$transformLog, $cd1aa4a8e2529717$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $cd1aa4a8e2529717$var$logp(base), pows = $cd1aa4a8e2529717$var$powp(base);
        if (domain()[0] < 0) {
            logs = $cd1aa4a8e2529717$var$reflect(logs), pows = $cd1aa4a8e2529717$var$reflect(pows);
            transform($cd1aa4a8e2529717$var$transformLogn, $cd1aa4a8e2529717$var$transformExpn);
        } else transform($cd1aa4a8e2529717$var$transformLog, $cd1aa4a8e2529717$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $8YDch.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $haUiJ.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $icwPY.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $cd1aa4a8e2529717$export$2e2bcd8739ae039() {
    var scale = $cd1aa4a8e2529717$export$860836db074028f0((0, $lnCzi.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $lnCzi.copy)(scale, $cd1aa4a8e2529717$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $7Mads.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("icwPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d402d1ceec4b9da9$export$2e2bcd8739ae039);
function $d402d1ceec4b9da9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("bcLGb", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $8285ccd409cbd04f$export$4602684e614eba38);
$parcel$export(module.exports, "default", () => $8285ccd409cbd04f$export$2e2bcd8739ae039);

var $l0gqL = parcelRequire("l0gqL");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");
function $8285ccd409cbd04f$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $8285ccd409cbd04f$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $8285ccd409cbd04f$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($8285ccd409cbd04f$var$transformSymlog(c), $8285ccd409cbd04f$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($8285ccd409cbd04f$var$transformSymlog(c = +_), $8285ccd409cbd04f$var$transformSymexp(c)) : c;
    };
    return (0, $l0gqL.linearish)(scale);
}
function $8285ccd409cbd04f$export$2e2bcd8739ae039() {
    var scale = $8285ccd409cbd04f$export$4602684e614eba38((0, $lnCzi.transformer)());
    scale.copy = function() {
        return (0, $lnCzi.copy)(scale, $8285ccd409cbd04f$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $7Mads.initRange).apply(scale, arguments);
}

});

parcelRegister("faiGI", function(module, exports) {

$parcel$export(module.exports, "powish", () => $b0a649340bd26d15$export$34695211ec403a46);
$parcel$export(module.exports, "default", () => $b0a649340bd26d15$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sqrt", () => $b0a649340bd26d15$export$eba8049fb5020b81);

var $l0gqL = parcelRequire("l0gqL");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");
function $b0a649340bd26d15$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $b0a649340bd26d15$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $b0a649340bd26d15$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $b0a649340bd26d15$export$34695211ec403a46(transform) {
    var scale = transform((0, $lnCzi.identity), (0, $lnCzi.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $lnCzi.identity), (0, $lnCzi.identity)) : exponent === 0.5 ? transform($b0a649340bd26d15$var$transformSqrt, $b0a649340bd26d15$var$transformSquare) : transform($b0a649340bd26d15$var$transformPow(exponent), $b0a649340bd26d15$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $l0gqL.linearish)(scale);
}
function $b0a649340bd26d15$export$2e2bcd8739ae039() {
    var scale = $b0a649340bd26d15$export$34695211ec403a46((0, $lnCzi.transformer)());
    scale.copy = function() {
        return (0, $lnCzi.copy)(scale, $b0a649340bd26d15$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $7Mads.initRange).apply(scale, arguments);
    return scale;
}
function $b0a649340bd26d15$export$eba8049fb5020b81() {
    return $b0a649340bd26d15$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("92AG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6950c0949e1a1773$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $kEOKb = parcelRequire("kEOKb");
var $2A9YO = parcelRequire("2A9YO");
var $deRMV = parcelRequire("deRMV");

var $6vB8f = parcelRequire("6vB8f");

var $7Mads = parcelRequire("7Mads");
function $6950c0949e1a1773$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $deRMV.default)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : range[(0, $2A9YO.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $kEOKb.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6vB8f.slice).call(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $6950c0949e1a1773$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7Mads.initRange).apply(scale, arguments);
}

});

parcelRegister("7J9j5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a03f48087bed10e$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $2A9YO = parcelRequire("2A9YO");

var $6vB8f = parcelRequire("6vB8f");

var $l0gqL = parcelRequire("l0gqL");

var $7Mads = parcelRequire("7Mads");
function $5a03f48087bed10e$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x <= x ? range[(0, $2A9YO.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $6vB8f.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $5a03f48087bed10e$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $7Mads.initRange).apply((0, $l0gqL.linearish)(scale), arguments);
}

});

parcelRegister("aOvZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df7645beb8dfe6c$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $2A9YO = parcelRequire("2A9YO");

var $6vB8f = parcelRequire("6vB8f");

var $7Mads = parcelRequire("7Mads");
function $7df7645beb8dfe6c$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x <= x ? range[(0, $2A9YO.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $6vB8f.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6vB8f.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $7df7645beb8dfe6c$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7Mads.initRange).apply(scale, arguments);
}

});

parcelRegister("kPFCU", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $f2a8dc36932de61c$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $f2a8dc36932de61c$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $28lCl = parcelRequire("28lCl");
var $8YDch = parcelRequire("8YDch");

var $hV544 = parcelRequire("hV544");
var $lY3qh = parcelRequire("lY3qh");
var $hr5Dg = parcelRequire("hr5Dg");
var $hz54K = parcelRequire("hz54K");
var $6R4qR = parcelRequire("6R4qR");
var $kqr4R = parcelRequire("kqr4R");
var $3Jr8b = parcelRequire("3Jr8b");
var $ao3mD = parcelRequire("ao3mD");

var $harJx = parcelRequire("harJx");

var $6vB8f = parcelRequire("6vB8f");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");

var $icwPY = parcelRequire("icwPY");
var $f2a8dc36932de61c$var$durationSecond = 1000, $f2a8dc36932de61c$var$durationMinute = $f2a8dc36932de61c$var$durationSecond * 60, $f2a8dc36932de61c$var$durationHour = $f2a8dc36932de61c$var$durationMinute * 60, $f2a8dc36932de61c$var$durationDay = $f2a8dc36932de61c$var$durationHour * 24, $f2a8dc36932de61c$var$durationWeek = $f2a8dc36932de61c$var$durationDay * 7, $f2a8dc36932de61c$var$durationMonth = $f2a8dc36932de61c$var$durationDay * 30, $f2a8dc36932de61c$var$durationYear = $f2a8dc36932de61c$var$durationDay * 365;
function $f2a8dc36932de61c$var$date(t) {
    return new Date(t);
}
function $f2a8dc36932de61c$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $f2a8dc36932de61c$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $lnCzi.default)((0, $lnCzi.identity), (0, $lnCzi.identity)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $f2a8dc36932de61c$var$durationSecond
        ],
        [
            second,
            5,
            5 * $f2a8dc36932de61c$var$durationSecond
        ],
        [
            second,
            15,
            15 * $f2a8dc36932de61c$var$durationSecond
        ],
        [
            second,
            30,
            30 * $f2a8dc36932de61c$var$durationSecond
        ],
        [
            minute,
            1,
            $f2a8dc36932de61c$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $f2a8dc36932de61c$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $f2a8dc36932de61c$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $f2a8dc36932de61c$var$durationMinute
        ],
        [
            hour,
            1,
            $f2a8dc36932de61c$var$durationHour
        ],
        [
            hour,
            3,
            3 * $f2a8dc36932de61c$var$durationHour
        ],
        [
            hour,
            6,
            6 * $f2a8dc36932de61c$var$durationHour
        ],
        [
            hour,
            12,
            12 * $f2a8dc36932de61c$var$durationHour
        ],
        [
            day,
            1,
            $f2a8dc36932de61c$var$durationDay
        ],
        [
            day,
            2,
            2 * $f2a8dc36932de61c$var$durationDay
        ],
        [
            week,
            1,
            $f2a8dc36932de61c$var$durationWeek
        ],
        [
            month,
            1,
            $f2a8dc36932de61c$var$durationMonth
        ],
        [
            month,
            3,
            3 * $f2a8dc36932de61c$var$durationMonth
        ],
        [
            year,
            1,
            $f2a8dc36932de61c$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $28lCl.default)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $8YDch.tickStep)(start / $f2a8dc36932de61c$var$durationYear, stop / $f2a8dc36932de61c$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $8YDch.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $6vB8f.map).call(_, $f2a8dc36932de61c$var$number)) : domain().map($f2a8dc36932de61c$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $icwPY.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $lnCzi.copy)(scale, $f2a8dc36932de61c$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $f2a8dc36932de61c$export$2e2bcd8739ae039() {
    return (0, $7Mads.initRange).apply($f2a8dc36932de61c$export$56bbcdb8aca31149((0, $ao3mD.default), (0, $6R4qR.default), (0, $3Jr8b.sunday), (0, $hV544.default), (0, $lY3qh.default), (0, $hz54K.default), (0, $kqr4R.default), (0, $hr5Dg.default), (0, $harJx.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("hV544", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bbb040a393c7f3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "days", () => $d0bbb040a393c7f3$export$3cf5dda4201cc0f2);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $d0bbb040a393c7f3$var$day = (0, $4Iq8c.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $brbHu.durationMinute)) / (0, $brbHu.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $d0bbb040a393c7f3$export$2e2bcd8739ae039 = $d0bbb040a393c7f3$var$day;
var $d0bbb040a393c7f3$export$3cf5dda4201cc0f2 = $d0bbb040a393c7f3$var$day.range;

});
parcelRegister("4Iq8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ef8a9e6269ec7f$export$2e2bcd8739ae039);
var $36ef8a9e6269ec7f$var$t0 = new Date, $36ef8a9e6269ec7f$var$t1 = new Date;
function $36ef8a9e6269ec7f$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $36ef8a9e6269ec7f$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $36ef8a9e6269ec7f$var$t0.setTime(+start), $36ef8a9e6269ec7f$var$t1.setTime(+end);
            floori($36ef8a9e6269ec7f$var$t0), floori($36ef8a9e6269ec7f$var$t1);
            return Math.floor(count($36ef8a9e6269ec7f$var$t0, $36ef8a9e6269ec7f$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("brbHu", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $853b4ac8f1ab7753$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $853b4ac8f1ab7753$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $853b4ac8f1ab7753$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $853b4ac8f1ab7753$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $853b4ac8f1ab7753$export$c241eb88520d5016);
var $853b4ac8f1ab7753$export$79ef0e34099623dc = 1e3;
var $853b4ac8f1ab7753$export$683905d551c33fa9 = 6e4;
var $853b4ac8f1ab7753$export$4157bf0c8e241659 = 36e5;
var $853b4ac8f1ab7753$export$353686095f4fbf45 = 864e5;
var $853b4ac8f1ab7753$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("lY3qh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe1db4ea4716977$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hours", () => $ffe1db4ea4716977$export$8d468796d69cdad1);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $ffe1db4ea4716977$var$hour = (0, $4Iq8c.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $brbHu.durationSecond) - date.getMinutes() * (0, $brbHu.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $brbHu.durationHour));
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationHour);
}, function(date) {
    return date.getHours();
});
var $ffe1db4ea4716977$export$2e2bcd8739ae039 = $ffe1db4ea4716977$var$hour;
var $ffe1db4ea4716977$export$8d468796d69cdad1 = $ffe1db4ea4716977$var$hour.range;

});

parcelRegister("hr5Dg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1953bc98671521$export$2e2bcd8739ae039);
$parcel$export(module.exports, "milliseconds", () => $cb1953bc98671521$export$9a27fac83d67afd3);

var $4Iq8c = parcelRequire("4Iq8c");
var $cb1953bc98671521$var$millisecond = (0, $4Iq8c.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$cb1953bc98671521$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $cb1953bc98671521$var$millisecond;
    return (0, $4Iq8c.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $cb1953bc98671521$export$2e2bcd8739ae039 = $cb1953bc98671521$var$millisecond;
var $cb1953bc98671521$export$9a27fac83d67afd3 = $cb1953bc98671521$var$millisecond.range;

});

parcelRegister("hz54K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc99a470c9481ea2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "minutes", () => $cc99a470c9481ea2$export$666252b437cce0c7);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $cc99a470c9481ea2$var$minute = (0, $4Iq8c.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $brbHu.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $brbHu.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $cc99a470c9481ea2$export$2e2bcd8739ae039 = $cc99a470c9481ea2$var$minute;
var $cc99a470c9481ea2$export$666252b437cce0c7 = $cc99a470c9481ea2$var$minute.range;

});

parcelRegister("6R4qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fdb217a05fcc93a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "months", () => $4fdb217a05fcc93a$export$16352d1b10c5eb38);

var $4Iq8c = parcelRequire("4Iq8c");
var $4fdb217a05fcc93a$var$month = (0, $4Iq8c.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $4fdb217a05fcc93a$export$2e2bcd8739ae039 = $4fdb217a05fcc93a$var$month;
var $4fdb217a05fcc93a$export$16352d1b10c5eb38 = $4fdb217a05fcc93a$var$month.range;

});

parcelRegister("kqr4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeb3d5a59cdb654$export$2e2bcd8739ae039);
$parcel$export(module.exports, "seconds", () => $edeb3d5a59cdb654$export$4792e48abc550fa1);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $edeb3d5a59cdb654$var$second = (0, $4Iq8c.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $brbHu.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $edeb3d5a59cdb654$export$2e2bcd8739ae039 = $edeb3d5a59cdb654$var$second;
var $edeb3d5a59cdb654$export$4792e48abc550fa1 = $edeb3d5a59cdb654$var$second.range;

});

parcelRegister("3Jr8b", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $2b7a9ebcd25c21ec$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $2b7a9ebcd25c21ec$export$6416afaab03bc9b8);
$parcel$export(module.exports, "tuesday", () => $2b7a9ebcd25c21ec$export$cb8f040f5d17ac7b);
$parcel$export(module.exports, "wednesday", () => $2b7a9ebcd25c21ec$export$347581849975dfc8);
$parcel$export(module.exports, "thursday", () => $2b7a9ebcd25c21ec$export$2f2b56683a3e5629);
$parcel$export(module.exports, "friday", () => $2b7a9ebcd25c21ec$export$59b8c2ccd931d806);
$parcel$export(module.exports, "saturday", () => $2b7a9ebcd25c21ec$export$478ceadebff4d377);
$parcel$export(module.exports, "sundays", () => $2b7a9ebcd25c21ec$export$e8daabaa40641211);
$parcel$export(module.exports, "mondays", () => $2b7a9ebcd25c21ec$export$74e5b559c235c00e);
$parcel$export(module.exports, "tuesdays", () => $2b7a9ebcd25c21ec$export$e7d6aa4fb107bc56);
$parcel$export(module.exports, "wednesdays", () => $2b7a9ebcd25c21ec$export$fcd5880b20bb06a8);
$parcel$export(module.exports, "thursdays", () => $2b7a9ebcd25c21ec$export$682716b7bbe33641);
$parcel$export(module.exports, "fridays", () => $2b7a9ebcd25c21ec$export$482924968ca86084);
$parcel$export(module.exports, "saturdays", () => $2b7a9ebcd25c21ec$export$7d755172c9cda9d2);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
function $2b7a9ebcd25c21ec$var$weekday(i) {
    return (0, $4Iq8c.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $brbHu.durationMinute)) / (0, $brbHu.durationWeek);
    });
}
var $2b7a9ebcd25c21ec$export$fb3ee18ed410cc21 = $2b7a9ebcd25c21ec$var$weekday(0);
var $2b7a9ebcd25c21ec$export$6416afaab03bc9b8 = $2b7a9ebcd25c21ec$var$weekday(1);
var $2b7a9ebcd25c21ec$export$cb8f040f5d17ac7b = $2b7a9ebcd25c21ec$var$weekday(2);
var $2b7a9ebcd25c21ec$export$347581849975dfc8 = $2b7a9ebcd25c21ec$var$weekday(3);
var $2b7a9ebcd25c21ec$export$2f2b56683a3e5629 = $2b7a9ebcd25c21ec$var$weekday(4);
var $2b7a9ebcd25c21ec$export$59b8c2ccd931d806 = $2b7a9ebcd25c21ec$var$weekday(5);
var $2b7a9ebcd25c21ec$export$478ceadebff4d377 = $2b7a9ebcd25c21ec$var$weekday(6);
var $2b7a9ebcd25c21ec$export$e8daabaa40641211 = $2b7a9ebcd25c21ec$export$fb3ee18ed410cc21.range;
var $2b7a9ebcd25c21ec$export$74e5b559c235c00e = $2b7a9ebcd25c21ec$export$6416afaab03bc9b8.range;
var $2b7a9ebcd25c21ec$export$e7d6aa4fb107bc56 = $2b7a9ebcd25c21ec$export$cb8f040f5d17ac7b.range;
var $2b7a9ebcd25c21ec$export$fcd5880b20bb06a8 = $2b7a9ebcd25c21ec$export$347581849975dfc8.range;
var $2b7a9ebcd25c21ec$export$682716b7bbe33641 = $2b7a9ebcd25c21ec$export$2f2b56683a3e5629.range;
var $2b7a9ebcd25c21ec$export$482924968ca86084 = $2b7a9ebcd25c21ec$export$59b8c2ccd931d806.range;
var $2b7a9ebcd25c21ec$export$7d755172c9cda9d2 = $2b7a9ebcd25c21ec$export$478ceadebff4d377.range;

});

parcelRegister("ao3mD", function(module, exports) {

$parcel$export(module.exports, "default", () => $78fec155ea52bf03$export$2e2bcd8739ae039);
$parcel$export(module.exports, "years", () => $78fec155ea52bf03$export$6fda41c7fb23acf9);

var $4Iq8c = parcelRequire("4Iq8c");
var $78fec155ea52bf03$var$year = (0, $4Iq8c.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$78fec155ea52bf03$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4Iq8c.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $78fec155ea52bf03$export$2e2bcd8739ae039 = $78fec155ea52bf03$var$year;
var $78fec155ea52bf03$export$6fda41c7fb23acf9 = $78fec155ea52bf03$var$year.range;

});

parcelRegister("harJx", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $c7f8e21ec920fd6b$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "timeParse", () => $c7f8e21ec920fd6b$export$32b9cd16e1b8c8d2);
$parcel$export(module.exports, "utcFormat", () => $c7f8e21ec920fd6b$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $c7f8e21ec920fd6b$export$3edae9cf8e233729);
$parcel$export(module.exports, "default", () => $c7f8e21ec920fd6b$export$2e2bcd8739ae039);

var $dEXnN = parcelRequire("dEXnN");
var $c7f8e21ec920fd6b$var$locale;
var $c7f8e21ec920fd6b$export$94f4d87fad5dcf9a;
var $c7f8e21ec920fd6b$export$32b9cd16e1b8c8d2;
var $c7f8e21ec920fd6b$export$1a08fe38f63ebbbb;
var $c7f8e21ec920fd6b$export$3edae9cf8e233729;
$c7f8e21ec920fd6b$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c7f8e21ec920fd6b$export$2e2bcd8739ae039(definition) {
    $c7f8e21ec920fd6b$var$locale = (0, $dEXnN.default)(definition);
    $c7f8e21ec920fd6b$export$94f4d87fad5dcf9a = $c7f8e21ec920fd6b$var$locale.format;
    $c7f8e21ec920fd6b$export$32b9cd16e1b8c8d2 = $c7f8e21ec920fd6b$var$locale.parse;
    $c7f8e21ec920fd6b$export$1a08fe38f63ebbbb = $c7f8e21ec920fd6b$var$locale.utcFormat;
    $c7f8e21ec920fd6b$export$3edae9cf8e233729 = $c7f8e21ec920fd6b$var$locale.utcParse;
    return $c7f8e21ec920fd6b$var$locale;
}

});
parcelRegister("dEXnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1d12fc325ae996$export$2e2bcd8739ae039);

var $hV544 = parcelRequire("hV544");
var $3Jr8b = parcelRequire("3Jr8b");
var $ao3mD = parcelRequire("ao3mD");
var $43zPd = parcelRequire("43zPd");
var $gATo1 = parcelRequire("gATo1");
var $lq9oP = parcelRequire("lq9oP");
function $9f1d12fc325ae996$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $9f1d12fc325ae996$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $9f1d12fc325ae996$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $9f1d12fc325ae996$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $9f1d12fc325ae996$var$formatRe(locale_periods), periodLookup = $9f1d12fc325ae996$var$formatLookup(locale_periods), weekdayRe = $9f1d12fc325ae996$var$formatRe(locale_weekdays), weekdayLookup = $9f1d12fc325ae996$var$formatLookup(locale_weekdays), shortWeekdayRe = $9f1d12fc325ae996$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $9f1d12fc325ae996$var$formatLookup(locale_shortWeekdays), monthRe = $9f1d12fc325ae996$var$formatRe(locale_months), monthLookup = $9f1d12fc325ae996$var$formatLookup(locale_months), shortMonthRe = $9f1d12fc325ae996$var$formatRe(locale_shortMonths), shortMonthLookup = $9f1d12fc325ae996$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $9f1d12fc325ae996$var$formatDayOfMonth,
        "e": $9f1d12fc325ae996$var$formatDayOfMonth,
        "f": $9f1d12fc325ae996$var$formatMicroseconds,
        "g": $9f1d12fc325ae996$var$formatYearISO,
        "G": $9f1d12fc325ae996$var$formatFullYearISO,
        "H": $9f1d12fc325ae996$var$formatHour24,
        "I": $9f1d12fc325ae996$var$formatHour12,
        "j": $9f1d12fc325ae996$var$formatDayOfYear,
        "L": $9f1d12fc325ae996$var$formatMilliseconds,
        "m": $9f1d12fc325ae996$var$formatMonthNumber,
        "M": $9f1d12fc325ae996$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $9f1d12fc325ae996$var$formatUnixTimestamp,
        "s": $9f1d12fc325ae996$var$formatUnixTimestampSeconds,
        "S": $9f1d12fc325ae996$var$formatSeconds,
        "u": $9f1d12fc325ae996$var$formatWeekdayNumberMonday,
        "U": $9f1d12fc325ae996$var$formatWeekNumberSunday,
        "V": $9f1d12fc325ae996$var$formatWeekNumberISO,
        "w": $9f1d12fc325ae996$var$formatWeekdayNumberSunday,
        "W": $9f1d12fc325ae996$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9f1d12fc325ae996$var$formatYear,
        "Y": $9f1d12fc325ae996$var$formatFullYear,
        "Z": $9f1d12fc325ae996$var$formatZone,
        "%": $9f1d12fc325ae996$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $9f1d12fc325ae996$var$formatUTCDayOfMonth,
        "e": $9f1d12fc325ae996$var$formatUTCDayOfMonth,
        "f": $9f1d12fc325ae996$var$formatUTCMicroseconds,
        "g": $9f1d12fc325ae996$var$formatUTCYearISO,
        "G": $9f1d12fc325ae996$var$formatUTCFullYearISO,
        "H": $9f1d12fc325ae996$var$formatUTCHour24,
        "I": $9f1d12fc325ae996$var$formatUTCHour12,
        "j": $9f1d12fc325ae996$var$formatUTCDayOfYear,
        "L": $9f1d12fc325ae996$var$formatUTCMilliseconds,
        "m": $9f1d12fc325ae996$var$formatUTCMonthNumber,
        "M": $9f1d12fc325ae996$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $9f1d12fc325ae996$var$formatUnixTimestamp,
        "s": $9f1d12fc325ae996$var$formatUnixTimestampSeconds,
        "S": $9f1d12fc325ae996$var$formatUTCSeconds,
        "u": $9f1d12fc325ae996$var$formatUTCWeekdayNumberMonday,
        "U": $9f1d12fc325ae996$var$formatUTCWeekNumberSunday,
        "V": $9f1d12fc325ae996$var$formatUTCWeekNumberISO,
        "w": $9f1d12fc325ae996$var$formatUTCWeekdayNumberSunday,
        "W": $9f1d12fc325ae996$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9f1d12fc325ae996$var$formatUTCYear,
        "Y": $9f1d12fc325ae996$var$formatUTCFullYear,
        "Z": $9f1d12fc325ae996$var$formatUTCZone,
        "%": $9f1d12fc325ae996$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $9f1d12fc325ae996$var$parseDayOfMonth,
        "e": $9f1d12fc325ae996$var$parseDayOfMonth,
        "f": $9f1d12fc325ae996$var$parseMicroseconds,
        "g": $9f1d12fc325ae996$var$parseYear,
        "G": $9f1d12fc325ae996$var$parseFullYear,
        "H": $9f1d12fc325ae996$var$parseHour24,
        "I": $9f1d12fc325ae996$var$parseHour24,
        "j": $9f1d12fc325ae996$var$parseDayOfYear,
        "L": $9f1d12fc325ae996$var$parseMilliseconds,
        "m": $9f1d12fc325ae996$var$parseMonthNumber,
        "M": $9f1d12fc325ae996$var$parseMinutes,
        "p": parsePeriod,
        "q": $9f1d12fc325ae996$var$parseQuarter,
        "Q": $9f1d12fc325ae996$var$parseUnixTimestamp,
        "s": $9f1d12fc325ae996$var$parseUnixTimestampSeconds,
        "S": $9f1d12fc325ae996$var$parseSeconds,
        "u": $9f1d12fc325ae996$var$parseWeekdayNumberMonday,
        "U": $9f1d12fc325ae996$var$parseWeekNumberSunday,
        "V": $9f1d12fc325ae996$var$parseWeekNumberISO,
        "w": $9f1d12fc325ae996$var$parseWeekdayNumberSunday,
        "W": $9f1d12fc325ae996$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $9f1d12fc325ae996$var$parseYear,
        "Y": $9f1d12fc325ae996$var$parseFullYear,
        "Z": $9f1d12fc325ae996$var$parseZone,
        "%": $9f1d12fc325ae996$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $9f1d12fc325ae996$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $9f1d12fc325ae996$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $9f1d12fc325ae996$var$utcDate($9f1d12fc325ae996$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $gATo1.utcMonday).ceil(week) : (0, $gATo1.utcMonday)(week);
                    week = (0, $43zPd.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $9f1d12fc325ae996$var$localDate($9f1d12fc325ae996$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $3Jr8b.monday).ceil(week) : (0, $3Jr8b.monday)(week);
                    week = (0, $hV544.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $9f1d12fc325ae996$var$utcDate($9f1d12fc325ae996$var$newDate(d.y, 0, 1)).getUTCDay() : $9f1d12fc325ae996$var$localDate($9f1d12fc325ae996$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $9f1d12fc325ae996$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $9f1d12fc325ae996$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $9f1d12fc325ae996$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $9f1d12fc325ae996$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $9f1d12fc325ae996$var$numberRe = /^\s*\d+/, $9f1d12fc325ae996$var$percentRe = /^%/, $9f1d12fc325ae996$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $9f1d12fc325ae996$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $9f1d12fc325ae996$var$requote(s) {
    return s.replace($9f1d12fc325ae996$var$requoteRe, "\\$&");
}
function $9f1d12fc325ae996$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($9f1d12fc325ae996$var$requote).join("|") + ")", "i");
}
function $9f1d12fc325ae996$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $9f1d12fc325ae996$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseWeekNumberSunday(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseWeekNumberISO(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseWeekNumberMonday(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseFullYear(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseYear(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseQuarter(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseMonthNumber(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseDayOfMonth(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseDayOfYear(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseHour24(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseMinutes(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseSeconds(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseMilliseconds(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseMicroseconds(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseLiteralPercent(d, string, i) {
    var n = $9f1d12fc325ae996$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $9f1d12fc325ae996$var$parseUnixTimestamp(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $9f1d12fc325ae996$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $9f1d12fc325ae996$var$formatDayOfMonth(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getDate(), p, 2);
}
function $9f1d12fc325ae996$var$formatHour24(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getHours(), p, 2);
}
function $9f1d12fc325ae996$var$formatHour12(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $9f1d12fc325ae996$var$formatDayOfYear(d, p) {
    return $9f1d12fc325ae996$var$pad(1 + (0, $hV544.default).count((0, $ao3mD.default)(d), d), p, 3);
}
function $9f1d12fc325ae996$var$formatMilliseconds(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getMilliseconds(), p, 3);
}
function $9f1d12fc325ae996$var$formatMicroseconds(d, p) {
    return $9f1d12fc325ae996$var$formatMilliseconds(d, p) + "000";
}
function $9f1d12fc325ae996$var$formatMonthNumber(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getMonth() + 1, p, 2);
}
function $9f1d12fc325ae996$var$formatMinutes(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getMinutes(), p, 2);
}
function $9f1d12fc325ae996$var$formatSeconds(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getSeconds(), p, 2);
}
function $9f1d12fc325ae996$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $9f1d12fc325ae996$var$formatWeekNumberSunday(d, p) {
    return $9f1d12fc325ae996$var$pad((0, $3Jr8b.sunday).count((0, $ao3mD.default)(d) - 1, d), p, 2);
}
function $9f1d12fc325ae996$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $3Jr8b.thursday)(d) : (0, $3Jr8b.thursday).ceil(d);
}
function $9f1d12fc325ae996$var$formatWeekNumberISO(d, p) {
    d = $9f1d12fc325ae996$var$dISO(d);
    return $9f1d12fc325ae996$var$pad((0, $3Jr8b.thursday).count((0, $ao3mD.default)(d), d) + ((0, $ao3mD.default)(d).getDay() === 4), p, 2);
}
function $9f1d12fc325ae996$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $9f1d12fc325ae996$var$formatWeekNumberMonday(d, p) {
    return $9f1d12fc325ae996$var$pad((0, $3Jr8b.monday).count((0, $ao3mD.default)(d) - 1, d), p, 2);
}
function $9f1d12fc325ae996$var$formatYear(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getFullYear() % 100, p, 2);
}
function $9f1d12fc325ae996$var$formatYearISO(d, p) {
    d = $9f1d12fc325ae996$var$dISO(d);
    return $9f1d12fc325ae996$var$pad(d.getFullYear() % 100, p, 2);
}
function $9f1d12fc325ae996$var$formatFullYear(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9f1d12fc325ae996$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $3Jr8b.thursday)(d) : (0, $3Jr8b.thursday).ceil(d);
    return $9f1d12fc325ae996$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9f1d12fc325ae996$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $9f1d12fc325ae996$var$pad(z / 60 | 0, "0", 2) + $9f1d12fc325ae996$var$pad(z % 60, "0", 2);
}
function $9f1d12fc325ae996$var$formatUTCDayOfMonth(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCDate(), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCHour24(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCHours(), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCHour12(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $9f1d12fc325ae996$var$formatUTCDayOfYear(d, p) {
    return $9f1d12fc325ae996$var$pad(1 + (0, $43zPd.default).count((0, $lq9oP.default)(d), d), p, 3);
}
function $9f1d12fc325ae996$var$formatUTCMilliseconds(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $9f1d12fc325ae996$var$formatUTCMicroseconds(d, p) {
    return $9f1d12fc325ae996$var$formatUTCMilliseconds(d, p) + "000";
}
function $9f1d12fc325ae996$var$formatUTCMonthNumber(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $9f1d12fc325ae996$var$formatUTCMinutes(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCMinutes(), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCSeconds(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCSeconds(), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $9f1d12fc325ae996$var$formatUTCWeekNumberSunday(d, p) {
    return $9f1d12fc325ae996$var$pad((0, $gATo1.utcSunday).count((0, $lq9oP.default)(d) - 1, d), p, 2);
}
function $9f1d12fc325ae996$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $gATo1.utcThursday)(d) : (0, $gATo1.utcThursday).ceil(d);
}
function $9f1d12fc325ae996$var$formatUTCWeekNumberISO(d, p) {
    d = $9f1d12fc325ae996$var$UTCdISO(d);
    return $9f1d12fc325ae996$var$pad((0, $gATo1.utcThursday).count((0, $lq9oP.default)(d), d) + ((0, $lq9oP.default)(d).getUTCDay() === 4), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $9f1d12fc325ae996$var$formatUTCWeekNumberMonday(d, p) {
    return $9f1d12fc325ae996$var$pad((0, $gATo1.utcMonday).count((0, $lq9oP.default)(d) - 1, d), p, 2);
}
function $9f1d12fc325ae996$var$formatUTCYear(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9f1d12fc325ae996$var$formatUTCYearISO(d, p) {
    d = $9f1d12fc325ae996$var$UTCdISO(d);
    return $9f1d12fc325ae996$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9f1d12fc325ae996$var$formatUTCFullYear(d, p) {
    return $9f1d12fc325ae996$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9f1d12fc325ae996$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $gATo1.utcThursday)(d) : (0, $gATo1.utcThursday).ceil(d);
    return $9f1d12fc325ae996$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9f1d12fc325ae996$var$formatUTCZone() {
    return "+0000";
}
function $9f1d12fc325ae996$var$formatLiteralPercent() {
    return "%";
}
function $9f1d12fc325ae996$var$formatUnixTimestamp(d) {
    return +d;
}
function $9f1d12fc325ae996$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("43zPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f433b56d345f271$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcDays", () => $2f433b56d345f271$export$d277e198508549a1);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $2f433b56d345f271$var$utcDay = (0, $4Iq8c.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $2f433b56d345f271$export$2e2bcd8739ae039 = $2f433b56d345f271$var$utcDay;
var $2f433b56d345f271$export$d277e198508549a1 = $2f433b56d345f271$var$utcDay.range;

});

parcelRegister("gATo1", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $c14af8b86f04c911$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $c14af8b86f04c911$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcTuesday", () => $c14af8b86f04c911$export$2a6d545f77eceb15);
$parcel$export(module.exports, "utcWednesday", () => $c14af8b86f04c911$export$a5c25d8ed64433c4);
$parcel$export(module.exports, "utcThursday", () => $c14af8b86f04c911$export$1db08111baec2f53);
$parcel$export(module.exports, "utcFriday", () => $c14af8b86f04c911$export$29265e34dd5921f7);
$parcel$export(module.exports, "utcSaturday", () => $c14af8b86f04c911$export$85b74dad05049604);
$parcel$export(module.exports, "utcSundays", () => $c14af8b86f04c911$export$6f3e1c2b0f7d7880);
$parcel$export(module.exports, "utcMondays", () => $c14af8b86f04c911$export$1d2d8b858bb366f9);
$parcel$export(module.exports, "utcTuesdays", () => $c14af8b86f04c911$export$1d5f6785fc7f30f8);
$parcel$export(module.exports, "utcWednesdays", () => $c14af8b86f04c911$export$7a75faf0e37ef4af);
$parcel$export(module.exports, "utcThursdays", () => $c14af8b86f04c911$export$417eb959611b2f2f);
$parcel$export(module.exports, "utcFridays", () => $c14af8b86f04c911$export$59d308db7af08c64);
$parcel$export(module.exports, "utcSaturdays", () => $c14af8b86f04c911$export$a124108a0a7f34c8);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
function $c14af8b86f04c911$var$utcWeekday(i) {
    return (0, $4Iq8c.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $brbHu.durationWeek);
    });
}
var $c14af8b86f04c911$export$4898b06303a92011 = $c14af8b86f04c911$var$utcWeekday(0);
var $c14af8b86f04c911$export$9cfc53b9cfafd080 = $c14af8b86f04c911$var$utcWeekday(1);
var $c14af8b86f04c911$export$2a6d545f77eceb15 = $c14af8b86f04c911$var$utcWeekday(2);
var $c14af8b86f04c911$export$a5c25d8ed64433c4 = $c14af8b86f04c911$var$utcWeekday(3);
var $c14af8b86f04c911$export$1db08111baec2f53 = $c14af8b86f04c911$var$utcWeekday(4);
var $c14af8b86f04c911$export$29265e34dd5921f7 = $c14af8b86f04c911$var$utcWeekday(5);
var $c14af8b86f04c911$export$85b74dad05049604 = $c14af8b86f04c911$var$utcWeekday(6);
var $c14af8b86f04c911$export$6f3e1c2b0f7d7880 = $c14af8b86f04c911$export$4898b06303a92011.range;
var $c14af8b86f04c911$export$1d2d8b858bb366f9 = $c14af8b86f04c911$export$9cfc53b9cfafd080.range;
var $c14af8b86f04c911$export$1d5f6785fc7f30f8 = $c14af8b86f04c911$export$2a6d545f77eceb15.range;
var $c14af8b86f04c911$export$7a75faf0e37ef4af = $c14af8b86f04c911$export$a5c25d8ed64433c4.range;
var $c14af8b86f04c911$export$417eb959611b2f2f = $c14af8b86f04c911$export$1db08111baec2f53.range;
var $c14af8b86f04c911$export$59d308db7af08c64 = $c14af8b86f04c911$export$29265e34dd5921f7.range;
var $c14af8b86f04c911$export$a124108a0a7f34c8 = $c14af8b86f04c911$export$85b74dad05049604.range;

});

parcelRegister("lq9oP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f983513a949fd280$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcYears", () => $f983513a949fd280$export$3e24d311e17f5802);

var $4Iq8c = parcelRequire("4Iq8c");
var $f983513a949fd280$var$utcYear = (0, $4Iq8c.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$f983513a949fd280$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4Iq8c.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $f983513a949fd280$export$2e2bcd8739ae039 = $f983513a949fd280$var$utcYear;
var $f983513a949fd280$export$3e24d311e17f5802 = $f983513a949fd280$var$utcYear.range;

});




parcelRegister("2cFHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ad0d8d6fb9fc53$export$2e2bcd8739ae039);

var $kPFCU = parcelRequire("kPFCU");

var $harJx = parcelRequire("harJx");

var $43zPd = parcelRequire("43zPd");
var $llWB4 = parcelRequire("llWB4");
var $hr5Dg = parcelRequire("hr5Dg");
var $9TFkI = parcelRequire("9TFkI");
var $1eU7m = parcelRequire("1eU7m");
var $kqr4R = parcelRequire("kqr4R");
var $gATo1 = parcelRequire("gATo1");
var $lq9oP = parcelRequire("lq9oP");

var $7Mads = parcelRequire("7Mads");
function $19ad0d8d6fb9fc53$export$2e2bcd8739ae039() {
    return (0, $7Mads.initRange).apply((0, $kPFCU.calendar)((0, $lq9oP.default), (0, $1eU7m.default), (0, $gATo1.utcSunday), (0, $43zPd.default), (0, $llWB4.default), (0, $9TFkI.default), (0, $kqr4R.default), (0, $hr5Dg.default), (0, $harJx.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("llWB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8b90349c95b1d60$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcHours", () => $f8b90349c95b1d60$export$6e7a76cd5f50b719);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $f8b90349c95b1d60$var$utcHour = (0, $4Iq8c.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $brbHu.durationHour));
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $f8b90349c95b1d60$export$2e2bcd8739ae039 = $f8b90349c95b1d60$var$utcHour;
var $f8b90349c95b1d60$export$6e7a76cd5f50b719 = $f8b90349c95b1d60$var$utcHour.range;

});

parcelRegister("9TFkI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7349500670ab9f49$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcMinutes", () => $7349500670ab9f49$export$cedd563624e8ee50);

var $4Iq8c = parcelRequire("4Iq8c");

var $brbHu = parcelRequire("brbHu");
var $7349500670ab9f49$var$utcMinute = (0, $4Iq8c.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $brbHu.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $brbHu.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $7349500670ab9f49$export$2e2bcd8739ae039 = $7349500670ab9f49$var$utcMinute;
var $7349500670ab9f49$export$cedd563624e8ee50 = $7349500670ab9f49$var$utcMinute.range;

});

parcelRegister("1eU7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e72a10f1a66c62d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "utcMonths", () => $0e72a10f1a66c62d$export$49159f585997498);

var $4Iq8c = parcelRequire("4Iq8c");
var $0e72a10f1a66c62d$var$utcMonth = (0, $4Iq8c.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $0e72a10f1a66c62d$export$2e2bcd8739ae039 = $0e72a10f1a66c62d$var$utcMonth;
var $0e72a10f1a66c62d$export$49159f585997498 = $0e72a10f1a66c62d$var$utcMonth.range;

});


parcelRegister("gSZjF", function(module, exports) {

$parcel$export(module.exports, "copy", () => $c4b1409f34289c14$export$784d13d8ee351f07);
$parcel$export(module.exports, "default", () => $c4b1409f34289c14$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sequentialLog", () => $c4b1409f34289c14$export$6843e08bf2ff981f);
$parcel$export(module.exports, "sequentialSymlog", () => $c4b1409f34289c14$export$9d4af4de62c81941);
$parcel$export(module.exports, "sequentialPow", () => $c4b1409f34289c14$export$de9f78581b4f2405);
$parcel$export(module.exports, "sequentialSqrt", () => $c4b1409f34289c14$export$413d935127ed466e);

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");

var $l0gqL = parcelRequire("l0gqL");

var $hBLnv = parcelRequire("hBLnv");

var $bcLGb = parcelRequire("bcLGb");

var $faiGI = parcelRequire("faiGI");
function $c4b1409f34289c14$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $lnCzi.identity), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $c4b1409f34289c14$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $c4b1409f34289c14$export$2e2bcd8739ae039() {
    var scale = (0, $l0gqL.linearish)($c4b1409f34289c14$var$transformer()((0, $lnCzi.identity)));
    scale.copy = function() {
        return $c4b1409f34289c14$export$784d13d8ee351f07(scale, $c4b1409f34289c14$export$2e2bcd8739ae039());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $c4b1409f34289c14$export$6843e08bf2ff981f() {
    var scale = (0, $hBLnv.loggish)($c4b1409f34289c14$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $c4b1409f34289c14$export$784d13d8ee351f07(scale, $c4b1409f34289c14$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $c4b1409f34289c14$export$9d4af4de62c81941() {
    var scale = (0, $bcLGb.symlogish)($c4b1409f34289c14$var$transformer());
    scale.copy = function() {
        return $c4b1409f34289c14$export$784d13d8ee351f07(scale, $c4b1409f34289c14$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $c4b1409f34289c14$export$de9f78581b4f2405() {
    var scale = (0, $faiGI.powish)($c4b1409f34289c14$var$transformer());
    scale.copy = function() {
        return $c4b1409f34289c14$export$784d13d8ee351f07(scale, $c4b1409f34289c14$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $c4b1409f34289c14$export$413d935127ed466e() {
    return $c4b1409f34289c14$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("fBnKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bcbc9ad8bf1007$export$2e2bcd8739ae039);
parcelRequire("4Plq2");
var $kEOKb = parcelRequire("kEOKb");
var $2A9YO = parcelRequire("2A9YO");

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");
function $b5bcbc9ad8bf1007$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $lnCzi.identity);
    function scale(x) {
        if (!isNaN(x = +x)) return interpolator(((0, $2A9YO.default)(domain, x) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $kEOKb.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $b5bcbc9ad8bf1007$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("b1jld", function(module, exports) {

$parcel$export(module.exports, "default", () => $805eca726ff2e511$export$2e2bcd8739ae039);
$parcel$export(module.exports, "divergingLog", () => $805eca726ff2e511$export$5f0266a9159c47fb);
$parcel$export(module.exports, "divergingSymlog", () => $805eca726ff2e511$export$50b3da713cf557c6);
$parcel$export(module.exports, "divergingPow", () => $805eca726ff2e511$export$d6cedcc63bf26e7e);
$parcel$export(module.exports, "divergingSqrt", () => $805eca726ff2e511$export$33ddefb5c4ab9e9c);

var $lnCzi = parcelRequire("lnCzi");

var $7Mads = parcelRequire("7Mads");

var $l0gqL = parcelRequire("l0gqL");

var $hBLnv = parcelRequire("hBLnv");

var $gSZjF = parcelRequire("gSZjF");

var $bcLGb = parcelRequire("bcLGb");

var $faiGI = parcelRequire("faiGI");
function $805eca726ff2e511$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, t0, t1, t2, k10, k21, interpolator = (0, $lnCzi.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
        return scale;
    };
}
function $805eca726ff2e511$export$2e2bcd8739ae039() {
    var scale = (0, $l0gqL.linearish)($805eca726ff2e511$var$transformer()((0, $lnCzi.identity)));
    scale.copy = function() {
        return (0, $gSZjF.copy)(scale, $805eca726ff2e511$export$2e2bcd8739ae039());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $805eca726ff2e511$export$5f0266a9159c47fb() {
    var scale = (0, $hBLnv.loggish)($805eca726ff2e511$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $gSZjF.copy)(scale, $805eca726ff2e511$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $805eca726ff2e511$export$50b3da713cf557c6() {
    var scale = (0, $bcLGb.symlogish)($805eca726ff2e511$var$transformer());
    scale.copy = function() {
        return (0, $gSZjF.copy)(scale, $805eca726ff2e511$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $805eca726ff2e511$export$d6cedcc63bf26e7e() {
    var scale = (0, $faiGI.powish)($805eca726ff2e511$var$transformer());
    scale.copy = function() {
        return (0, $gSZjF.copy)(scale, $805eca726ff2e511$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $7Mads.initInterpolator).apply(scale, arguments);
}
function $805eca726ff2e511$export$33ddefb5c4ab9e9c() {
    return $805eca726ff2e511$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});


parcelRegister("jqBjs", function(module, exports) {

$parcel$export(module.exports, "schemeCategory10", () => (parcelRequire("ciKcO")).default);
$parcel$export(module.exports, "schemeAccent", () => (parcelRequire("89UGV")).default);
$parcel$export(module.exports, "schemeDark2", () => (parcelRequire("cTf2M")).default);
$parcel$export(module.exports, "schemePaired", () => (parcelRequire("llVPC")).default);
$parcel$export(module.exports, "schemePastel1", () => (parcelRequire("hbVdn")).default);
$parcel$export(module.exports, "schemePastel2", () => (parcelRequire("iqBme")).default);
$parcel$export(module.exports, "schemeSet1", () => (parcelRequire("gAZ2T")).default);
$parcel$export(module.exports, "schemeSet2", () => (parcelRequire("hUcgn")).default);
$parcel$export(module.exports, "schemeSet3", () => (parcelRequire("idoQC")).default);
$parcel$export(module.exports, "schemeTableau10", () => (parcelRequire("6LzbZ")).default);
$parcel$export(module.exports, "interpolateBrBG", () => (parcelRequire("3ol93")).default);
$parcel$export(module.exports, "schemeBrBG", () => (parcelRequire("3ol93")).scheme);
$parcel$export(module.exports, "interpolatePRGn", () => (parcelRequire("3hiVf")).default);
$parcel$export(module.exports, "schemePRGn", () => (parcelRequire("3hiVf")).scheme);
$parcel$export(module.exports, "interpolatePiYG", () => (parcelRequire("hRuK1")).default);
$parcel$export(module.exports, "schemePiYG", () => (parcelRequire("hRuK1")).scheme);
$parcel$export(module.exports, "interpolatePuOr", () => (parcelRequire("fUx5B")).default);
$parcel$export(module.exports, "schemePuOr", () => (parcelRequire("fUx5B")).scheme);
$parcel$export(module.exports, "interpolateRdBu", () => (parcelRequire("u6Ak4")).default);
$parcel$export(module.exports, "schemeRdBu", () => (parcelRequire("u6Ak4")).scheme);
$parcel$export(module.exports, "interpolateRdGy", () => (parcelRequire("g5VnU")).default);
$parcel$export(module.exports, "schemeRdGy", () => (parcelRequire("g5VnU")).scheme);
$parcel$export(module.exports, "interpolateRdYlBu", () => (parcelRequire("Ich1J")).default);
$parcel$export(module.exports, "schemeRdYlBu", () => (parcelRequire("Ich1J")).scheme);
$parcel$export(module.exports, "interpolateRdYlGn", () => (parcelRequire("6KJdr")).default);
$parcel$export(module.exports, "schemeRdYlGn", () => (parcelRequire("6KJdr")).scheme);
$parcel$export(module.exports, "interpolateSpectral", () => (parcelRequire("cDzD4")).default);
$parcel$export(module.exports, "schemeSpectral", () => (parcelRequire("cDzD4")).scheme);
$parcel$export(module.exports, "interpolateBuGn", () => (parcelRequire("jY8XT")).default);
$parcel$export(module.exports, "schemeBuGn", () => (parcelRequire("jY8XT")).scheme);
$parcel$export(module.exports, "interpolateBuPu", () => (parcelRequire("hdv2o")).default);
$parcel$export(module.exports, "schemeBuPu", () => (parcelRequire("hdv2o")).scheme);
$parcel$export(module.exports, "interpolateGnBu", () => (parcelRequire("bkQgc")).default);
$parcel$export(module.exports, "schemeGnBu", () => (parcelRequire("bkQgc")).scheme);
$parcel$export(module.exports, "interpolateOrRd", () => (parcelRequire("9LwmP")).default);
$parcel$export(module.exports, "schemeOrRd", () => (parcelRequire("9LwmP")).scheme);
$parcel$export(module.exports, "interpolatePuBuGn", () => (parcelRequire("1aTB2")).default);
$parcel$export(module.exports, "schemePuBuGn", () => (parcelRequire("1aTB2")).scheme);
$parcel$export(module.exports, "interpolatePuBu", () => (parcelRequire("k0DXD")).default);
$parcel$export(module.exports, "schemePuBu", () => (parcelRequire("k0DXD")).scheme);
$parcel$export(module.exports, "interpolatePuRd", () => (parcelRequire("jGDLd")).default);
$parcel$export(module.exports, "schemePuRd", () => (parcelRequire("jGDLd")).scheme);
$parcel$export(module.exports, "interpolateRdPu", () => (parcelRequire("4w9GK")).default);
$parcel$export(module.exports, "schemeRdPu", () => (parcelRequire("4w9GK")).scheme);
$parcel$export(module.exports, "interpolateYlGnBu", () => (parcelRequire("e4ptP")).default);
$parcel$export(module.exports, "schemeYlGnBu", () => (parcelRequire("e4ptP")).scheme);
$parcel$export(module.exports, "interpolateYlGn", () => (parcelRequire("1d021")).default);
$parcel$export(module.exports, "schemeYlGn", () => (parcelRequire("1d021")).scheme);
$parcel$export(module.exports, "interpolateYlOrBr", () => (parcelRequire("arM1C")).default);
$parcel$export(module.exports, "schemeYlOrBr", () => (parcelRequire("arM1C")).scheme);
$parcel$export(module.exports, "interpolateYlOrRd", () => (parcelRequire("hm7fW")).default);
$parcel$export(module.exports, "schemeYlOrRd", () => (parcelRequire("hm7fW")).scheme);
$parcel$export(module.exports, "interpolateBlues", () => (parcelRequire("c3nyb")).default);
$parcel$export(module.exports, "schemeBlues", () => (parcelRequire("c3nyb")).scheme);
$parcel$export(module.exports, "interpolateGreens", () => (parcelRequire("gQjUU")).default);
$parcel$export(module.exports, "schemeGreens", () => (parcelRequire("gQjUU")).scheme);
$parcel$export(module.exports, "interpolateGreys", () => (parcelRequire("jozKM")).default);
$parcel$export(module.exports, "schemeGreys", () => (parcelRequire("jozKM")).scheme);
$parcel$export(module.exports, "interpolatePurples", () => (parcelRequire("8EIqh")).default);
$parcel$export(module.exports, "schemePurples", () => (parcelRequire("8EIqh")).scheme);
$parcel$export(module.exports, "interpolateReds", () => (parcelRequire("eq03E")).default);
$parcel$export(module.exports, "schemeReds", () => (parcelRequire("eq03E")).scheme);
$parcel$export(module.exports, "interpolateOranges", () => (parcelRequire("b7UPp")).default);
$parcel$export(module.exports, "schemeOranges", () => (parcelRequire("b7UPp")).scheme);
$parcel$export(module.exports, "interpolateCividis", () => (parcelRequire("5V2gY")).default);
$parcel$export(module.exports, "interpolateCubehelixDefault", () => (parcelRequire("lBWcO")).default);
$parcel$export(module.exports, "interpolateRainbow", () => (parcelRequire("eEOhZ")).default);
$parcel$export(module.exports, "interpolateWarm", () => (parcelRequire("eEOhZ")).warm);
$parcel$export(module.exports, "interpolateCool", () => (parcelRequire("eEOhZ")).cool);
$parcel$export(module.exports, "interpolateSinebow", () => (parcelRequire("d5MIg")).default);
$parcel$export(module.exports, "interpolateTurbo", () => (parcelRequire("9Vh3l")).default);
$parcel$export(module.exports, "interpolateViridis", () => (parcelRequire("jbN6M")).default);
$parcel$export(module.exports, "interpolateMagma", () => (parcelRequire("jbN6M")).magma);
$parcel$export(module.exports, "interpolateInferno", () => (parcelRequire("jbN6M")).inferno);
$parcel$export(module.exports, "interpolatePlasma", () => (parcelRequire("jbN6M")).plasma);

var $ciKcO = parcelRequire("ciKcO");

var $89UGV = parcelRequire("89UGV");

var $cTf2M = parcelRequire("cTf2M");

var $llVPC = parcelRequire("llVPC");

var $hbVdn = parcelRequire("hbVdn");

var $iqBme = parcelRequire("iqBme");

var $gAZ2T = parcelRequire("gAZ2T");

var $hUcgn = parcelRequire("hUcgn");

var $idoQC = parcelRequire("idoQC");

var $6LzbZ = parcelRequire("6LzbZ");

var $3ol93 = parcelRequire("3ol93");

var $3hiVf = parcelRequire("3hiVf");

var $hRuK1 = parcelRequire("hRuK1");

var $fUx5B = parcelRequire("fUx5B");

var $u6Ak4 = parcelRequire("u6Ak4");

var $g5VnU = parcelRequire("g5VnU");

var $Ich1J = parcelRequire("Ich1J");

var $6KJdr = parcelRequire("6KJdr");

var $cDzD4 = parcelRequire("cDzD4");

var $jY8XT = parcelRequire("jY8XT");

var $hdv2o = parcelRequire("hdv2o");

var $bkQgc = parcelRequire("bkQgc");

var $9LwmP = parcelRequire("9LwmP");

var $1aTB2 = parcelRequire("1aTB2");

var $k0DXD = parcelRequire("k0DXD");

var $jGDLd = parcelRequire("jGDLd");

var $4w9GK = parcelRequire("4w9GK");

var $e4ptP = parcelRequire("e4ptP");

var $1d021 = parcelRequire("1d021");

var $arM1C = parcelRequire("arM1C");

var $hm7fW = parcelRequire("hm7fW");

var $c3nyb = parcelRequire("c3nyb");

var $gQjUU = parcelRequire("gQjUU");

var $jozKM = parcelRequire("jozKM");

var $8EIqh = parcelRequire("8EIqh");

var $eq03E = parcelRequire("eq03E");

var $b7UPp = parcelRequire("b7UPp");

var $5V2gY = parcelRequire("5V2gY");

var $lBWcO = parcelRequire("lBWcO");

var $eEOhZ = parcelRequire("eEOhZ");

var $d5MIg = parcelRequire("d5MIg");

var $9Vh3l = parcelRequire("9Vh3l");

var $jbN6M = parcelRequire("jbN6M");

});
parcelRegister("ciKcO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f4b01fa32953e44$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $8f4b01fa32953e44$export$2e2bcd8739ae039 = (0, $5CprN.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});
parcelRegister("5CprN", function(module, exports) {

$parcel$export(module.exports, "default", () => $41743db1ebdc8a3c$export$2e2bcd8739ae039);
function $41743db1ebdc8a3c$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});


parcelRegister("89UGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b23b10be74996$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $5f0b23b10be74996$export$2e2bcd8739ae039 = (0, $5CprN.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

});

parcelRegister("cTf2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $96264a775ac735fa$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $96264a775ac735fa$export$2e2bcd8739ae039 = (0, $5CprN.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

});

parcelRegister("llVPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8b86b428db23c58$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $f8b86b428db23c58$export$2e2bcd8739ae039 = (0, $5CprN.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

});

parcelRegister("hbVdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c83fd86ec655499d$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $c83fd86ec655499d$export$2e2bcd8739ae039 = (0, $5CprN.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

});

parcelRegister("iqBme", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a7a2230dbf8359$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $d6a7a2230dbf8359$export$2e2bcd8739ae039 = (0, $5CprN.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

});

parcelRegister("gAZ2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $c14f5c86a73d790f$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $c14f5c86a73d790f$export$2e2bcd8739ae039 = (0, $5CprN.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

});

parcelRegister("hUcgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0912dd1f08a869a$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $d0912dd1f08a869a$export$2e2bcd8739ae039 = (0, $5CprN.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

});

parcelRegister("idoQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42cb72249c973e1$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $d42cb72249c973e1$export$2e2bcd8739ae039 = (0, $5CprN.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

});

parcelRegister("6LzbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed26e5c6cdf2b08$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");
var $4ed26e5c6cdf2b08$export$2e2bcd8739ae039 = (0, $5CprN.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

});

parcelRegister("3ol93", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $278403f78435adfe$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $278403f78435adfe$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $278403f78435adfe$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $5CprN.default));
var $278403f78435adfe$export$2e2bcd8739ae039 = (0, $1gHae.default)($278403f78435adfe$export$3005042704f95a69);

});
parcelRegister("1gHae", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec8c48f75d1f283$export$2e2bcd8739ae039);

var $lap8T = parcelRequire("lap8T");
function $0ec8c48f75d1f283$export$2e2bcd8739ae039(scheme) {
    return (0, $lap8T.rgbBasis)(scheme[scheme.length - 1]);
}

});


parcelRegister("3hiVf", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $2631a33191ccccfc$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $2631a33191ccccfc$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $2631a33191ccccfc$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $5CprN.default));
var $2631a33191ccccfc$export$2e2bcd8739ae039 = (0, $1gHae.default)($2631a33191ccccfc$export$3005042704f95a69);

});

parcelRegister("hRuK1", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $d00f3b7d20e8c8c7$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $d00f3b7d20e8c8c7$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $d00f3b7d20e8c8c7$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $5CprN.default));
var $d00f3b7d20e8c8c7$export$2e2bcd8739ae039 = (0, $1gHae.default)($d00f3b7d20e8c8c7$export$3005042704f95a69);

});

parcelRegister("fUx5B", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $b955c0d2f8ba274e$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $b955c0d2f8ba274e$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $b955c0d2f8ba274e$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $5CprN.default));
var $b955c0d2f8ba274e$export$2e2bcd8739ae039 = (0, $1gHae.default)($b955c0d2f8ba274e$export$3005042704f95a69);

});

parcelRegister("u6Ak4", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $05a7e91216b93ef1$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $05a7e91216b93ef1$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $05a7e91216b93ef1$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $5CprN.default));
var $05a7e91216b93ef1$export$2e2bcd8739ae039 = (0, $1gHae.default)($05a7e91216b93ef1$export$3005042704f95a69);

});

parcelRegister("g5VnU", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $bb79a0580fb03eb9$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $bb79a0580fb03eb9$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $bb79a0580fb03eb9$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $5CprN.default));
var $bb79a0580fb03eb9$export$2e2bcd8739ae039 = (0, $1gHae.default)($bb79a0580fb03eb9$export$3005042704f95a69);

});

parcelRegister("Ich1J", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $084da176519b5589$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $084da176519b5589$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $084da176519b5589$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $5CprN.default));
var $084da176519b5589$export$2e2bcd8739ae039 = (0, $1gHae.default)($084da176519b5589$export$3005042704f95a69);

});

parcelRegister("6KJdr", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $4eaa1ce39136ddcf$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $4eaa1ce39136ddcf$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $4eaa1ce39136ddcf$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $5CprN.default));
var $4eaa1ce39136ddcf$export$2e2bcd8739ae039 = (0, $1gHae.default)($4eaa1ce39136ddcf$export$3005042704f95a69);

});

parcelRegister("cDzD4", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $9334c3c79790a955$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $9334c3c79790a955$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $9334c3c79790a955$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $5CprN.default));
var $9334c3c79790a955$export$2e2bcd8739ae039 = (0, $1gHae.default)($9334c3c79790a955$export$3005042704f95a69);

});

parcelRegister("jY8XT", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $e89a93353c63d568$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $e89a93353c63d568$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $e89a93353c63d568$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $5CprN.default));
var $e89a93353c63d568$export$2e2bcd8739ae039 = (0, $1gHae.default)($e89a93353c63d568$export$3005042704f95a69);

});

parcelRegister("hdv2o", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $c88bba004bc810bf$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $c88bba004bc810bf$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $c88bba004bc810bf$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $5CprN.default));
var $c88bba004bc810bf$export$2e2bcd8739ae039 = (0, $1gHae.default)($c88bba004bc810bf$export$3005042704f95a69);

});

parcelRegister("bkQgc", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $840a19c02e6b6ae7$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $840a19c02e6b6ae7$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $840a19c02e6b6ae7$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $5CprN.default));
var $840a19c02e6b6ae7$export$2e2bcd8739ae039 = (0, $1gHae.default)($840a19c02e6b6ae7$export$3005042704f95a69);

});

parcelRegister("9LwmP", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $71c19c4854418243$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $71c19c4854418243$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $71c19c4854418243$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $5CprN.default));
var $71c19c4854418243$export$2e2bcd8739ae039 = (0, $1gHae.default)($71c19c4854418243$export$3005042704f95a69);

});

parcelRegister("1aTB2", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $0db1d9e3468e9414$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $0db1d9e3468e9414$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $0db1d9e3468e9414$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $5CprN.default));
var $0db1d9e3468e9414$export$2e2bcd8739ae039 = (0, $1gHae.default)($0db1d9e3468e9414$export$3005042704f95a69);

});

parcelRegister("k0DXD", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $e912ce23633c29b5$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $e912ce23633c29b5$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $e912ce23633c29b5$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $5CprN.default));
var $e912ce23633c29b5$export$2e2bcd8739ae039 = (0, $1gHae.default)($e912ce23633c29b5$export$3005042704f95a69);

});

parcelRegister("jGDLd", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $e550c832081aae32$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $e550c832081aae32$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $e550c832081aae32$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $5CprN.default));
var $e550c832081aae32$export$2e2bcd8739ae039 = (0, $1gHae.default)($e550c832081aae32$export$3005042704f95a69);

});

parcelRegister("4w9GK", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $34a1aa838680122f$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $34a1aa838680122f$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $34a1aa838680122f$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $5CprN.default));
var $34a1aa838680122f$export$2e2bcd8739ae039 = (0, $1gHae.default)($34a1aa838680122f$export$3005042704f95a69);

});

parcelRegister("e4ptP", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $a3e53435b598249b$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $a3e53435b598249b$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $a3e53435b598249b$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $5CprN.default));
var $a3e53435b598249b$export$2e2bcd8739ae039 = (0, $1gHae.default)($a3e53435b598249b$export$3005042704f95a69);

});

parcelRegister("1d021", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $0e17079ac5b117a7$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $0e17079ac5b117a7$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $0e17079ac5b117a7$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $5CprN.default));
var $0e17079ac5b117a7$export$2e2bcd8739ae039 = (0, $1gHae.default)($0e17079ac5b117a7$export$3005042704f95a69);

});

parcelRegister("arM1C", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $79b1adc60737f25d$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $79b1adc60737f25d$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $79b1adc60737f25d$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $5CprN.default));
var $79b1adc60737f25d$export$2e2bcd8739ae039 = (0, $1gHae.default)($79b1adc60737f25d$export$3005042704f95a69);

});

parcelRegister("hm7fW", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $ca2a1ea93f2fc756$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $ca2a1ea93f2fc756$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $ca2a1ea93f2fc756$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $5CprN.default));
var $ca2a1ea93f2fc756$export$2e2bcd8739ae039 = (0, $1gHae.default)($ca2a1ea93f2fc756$export$3005042704f95a69);

});

parcelRegister("c3nyb", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $8c6808724a3388e8$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $8c6808724a3388e8$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $8c6808724a3388e8$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $5CprN.default));
var $8c6808724a3388e8$export$2e2bcd8739ae039 = (0, $1gHae.default)($8c6808724a3388e8$export$3005042704f95a69);

});

parcelRegister("gQjUU", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $c430f3bfae233015$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $c430f3bfae233015$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $c430f3bfae233015$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $5CprN.default));
var $c430f3bfae233015$export$2e2bcd8739ae039 = (0, $1gHae.default)($c430f3bfae233015$export$3005042704f95a69);

});

parcelRegister("jozKM", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $e1ebfe19324224e6$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $e1ebfe19324224e6$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $e1ebfe19324224e6$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $5CprN.default));
var $e1ebfe19324224e6$export$2e2bcd8739ae039 = (0, $1gHae.default)($e1ebfe19324224e6$export$3005042704f95a69);

});

parcelRegister("8EIqh", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $64d484a1728f30d5$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $64d484a1728f30d5$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $64d484a1728f30d5$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $5CprN.default));
var $64d484a1728f30d5$export$2e2bcd8739ae039 = (0, $1gHae.default)($64d484a1728f30d5$export$3005042704f95a69);

});

parcelRegister("eq03E", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $a7f389e87678c22d$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $a7f389e87678c22d$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $a7f389e87678c22d$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $5CprN.default));
var $a7f389e87678c22d$export$2e2bcd8739ae039 = (0, $1gHae.default)($a7f389e87678c22d$export$3005042704f95a69);

});

parcelRegister("b7UPp", function(module, exports) {

$parcel$export(module.exports, "scheme", () => $819c6e09d4b965ad$export$3005042704f95a69);
$parcel$export(module.exports, "default", () => $819c6e09d4b965ad$export$2e2bcd8739ae039);

var $5CprN = parcelRequire("5CprN");

var $1gHae = parcelRequire("1gHae");
var $819c6e09d4b965ad$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $5CprN.default));
var $819c6e09d4b965ad$export$2e2bcd8739ae039 = (0, $1gHae.default)($819c6e09d4b965ad$export$3005042704f95a69);

});

parcelRegister("5V2gY", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f409f6f5ffbae3$export$2e2bcd8739ae039);
function $44f409f6f5ffbae3$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

});

parcelRegister("lBWcO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbba341eee8660c9$export$2e2bcd8739ae039);

var $4Mifs = parcelRequire("4Mifs");

var $29rg6 = parcelRequire("29rg6");
var $fbba341eee8660c9$export$2e2bcd8739ae039 = (0, $29rg6.cubehelixLong)((0, $4Mifs.default)(300, 0.5, 0.0), (0, $4Mifs.default)(-240, 0.5, 1.0));

});
parcelRegister("4Mifs", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a9ccdb65b426a0$export$2e2bcd8739ae039);

var $Os3Yo = parcelRequire("Os3Yo");

var $lYiVZ = parcelRequire("lYiVZ");

var $clsUo = parcelRequire("clsUo");
var $37a9ccdb65b426a0$var$A = -0.14861, $37a9ccdb65b426a0$var$B = 1.78277, $37a9ccdb65b426a0$var$C = -0.29227, $37a9ccdb65b426a0$var$D = -0.90649, $37a9ccdb65b426a0$var$E = 1.97294, $37a9ccdb65b426a0$var$ED = $37a9ccdb65b426a0$var$E * $37a9ccdb65b426a0$var$D, $37a9ccdb65b426a0$var$EB = $37a9ccdb65b426a0$var$E * $37a9ccdb65b426a0$var$B, $37a9ccdb65b426a0$var$BC_DA = $37a9ccdb65b426a0$var$B * $37a9ccdb65b426a0$var$C - $37a9ccdb65b426a0$var$D * $37a9ccdb65b426a0$var$A;
function $37a9ccdb65b426a0$var$cubehelixConvert(o) {
    if (o instanceof $37a9ccdb65b426a0$export$57ed4bde61a1e2f2) return new $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $lYiVZ.Rgb))) o = (0, $lYiVZ.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($37a9ccdb65b426a0$var$BC_DA * b + $37a9ccdb65b426a0$var$ED * r - $37a9ccdb65b426a0$var$EB * g) / ($37a9ccdb65b426a0$var$BC_DA + $37a9ccdb65b426a0$var$ED - $37a9ccdb65b426a0$var$EB), bl = b - l, k = ($37a9ccdb65b426a0$var$E * (g - l) - $37a9ccdb65b426a0$var$C * bl) / $37a9ccdb65b426a0$var$D, s = Math.sqrt(k * k + bl * bl) / ($37a9ccdb65b426a0$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $clsUo.rad2deg) - 120 : NaN;
    return new $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $37a9ccdb65b426a0$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $37a9ccdb65b426a0$var$cubehelixConvert(h) : new $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $Os3Yo.default)($37a9ccdb65b426a0$export$57ed4bde61a1e2f2, $37a9ccdb65b426a0$export$2e2bcd8739ae039, (0, $Os3Yo.extend)((0, $lYiVZ.Color), {
    brighter: function(k) {
        k = k == null ? (0, $lYiVZ.brighter) : Math.pow((0, $lYiVZ.brighter), k);
        return new $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $lYiVZ.darker) : Math.pow((0, $lYiVZ.darker), k);
        return new $37a9ccdb65b426a0$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $clsUo.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $lYiVZ.Rgb)(255 * (l + a * ($37a9ccdb65b426a0$var$A * cosh + $37a9ccdb65b426a0$var$B * sinh)), 255 * (l + a * ($37a9ccdb65b426a0$var$C * cosh + $37a9ccdb65b426a0$var$D * sinh)), 255 * (l + a * ($37a9ccdb65b426a0$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("Os3Yo", function(module, exports) {

$parcel$export(module.exports, "default", () => $097a705ea8d59ca3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $097a705ea8d59ca3$export$8b58be045bf06082);
function $097a705ea8d59ca3$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $097a705ea8d59ca3$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});

parcelRegister("lYiVZ", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);

var $Os3Yo = parcelRequire("Os3Yo");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $Os3Yo.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $Os3Yo.default)(Rgb, rgb, (0, $Os3Yo.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $Os3Yo.default)(Hsl, hsl, (0, $Os3Yo.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});

parcelRegister("clsUo", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $8fcdded5b3ff9060$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $8fcdded5b3ff9060$export$b2ba2578f2c43d74);
var $8fcdded5b3ff9060$export$b1b275608b2b1b8 = Math.PI / 180;
var $8fcdded5b3ff9060$export$b2ba2578f2c43d74 = 180 / Math.PI;

});



parcelRegister("eEOhZ", function(module, exports) {

$parcel$export(module.exports, "warm", () => $aabbcf7cbb69d462$export$fc70efcec537be98);
$parcel$export(module.exports, "cool", () => $aabbcf7cbb69d462$export$c5cedbc1ab3be2c3);
$parcel$export(module.exports, "default", () => $aabbcf7cbb69d462$export$2e2bcd8739ae039);

var $4Mifs = parcelRequire("4Mifs");

var $29rg6 = parcelRequire("29rg6");
var $aabbcf7cbb69d462$export$fc70efcec537be98 = (0, $29rg6.cubehelixLong)((0, $4Mifs.default)(-100, 0.75, 0.35), (0, $4Mifs.default)(80, 1.50, 0.8));
var $aabbcf7cbb69d462$export$c5cedbc1ab3be2c3 = (0, $29rg6.cubehelixLong)((0, $4Mifs.default)(260, 0.75, 0.35), (0, $4Mifs.default)(80, 1.50, 0.8));
var $aabbcf7cbb69d462$var$c = (0, $4Mifs.default)();
function $aabbcf7cbb69d462$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $aabbcf7cbb69d462$var$c.h = 360 * t - 100;
    $aabbcf7cbb69d462$var$c.s = 1.5 - 1.5 * ts;
    $aabbcf7cbb69d462$var$c.l = 0.8 - 0.9 * ts;
    return $aabbcf7cbb69d462$var$c + "";
}

});

parcelRegister("d5MIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9881876250375186$export$2e2bcd8739ae039);

var $lYiVZ = parcelRequire("lYiVZ");
var $9881876250375186$var$c = (0, $lYiVZ.rgb)(), $9881876250375186$var$pi_1_3 = Math.PI / 3, $9881876250375186$var$pi_2_3 = Math.PI * 2 / 3;
function $9881876250375186$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $9881876250375186$var$c.r = 255 * (x = Math.sin(t)) * x;
    $9881876250375186$var$c.g = 255 * (x = Math.sin(t + $9881876250375186$var$pi_1_3)) * x;
    $9881876250375186$var$c.b = 255 * (x = Math.sin(t + $9881876250375186$var$pi_2_3)) * x;
    return $9881876250375186$var$c + "";
}

});

parcelRegister("9Vh3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $7396aa4dcc91a82f$export$2e2bcd8739ae039);
function $7396aa4dcc91a82f$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

});

parcelRegister("jbN6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $df85234ef383f8df$export$2e2bcd8739ae039);
$parcel$export(module.exports, "magma", () => $df85234ef383f8df$export$c41e69203f572e8d);
$parcel$export(module.exports, "inferno", () => $df85234ef383f8df$export$ad0c8285c8ea6dbd);
$parcel$export(module.exports, "plasma", () => $df85234ef383f8df$export$6664860a633d9daf);

var $5CprN = parcelRequire("5CprN");
function $df85234ef383f8df$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $df85234ef383f8df$export$2e2bcd8739ae039 = $df85234ef383f8df$var$ramp((0, $5CprN.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $df85234ef383f8df$export$c41e69203f572e8d = $df85234ef383f8df$var$ramp((0, $5CprN.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $df85234ef383f8df$export$ad0c8285c8ea6dbd = $df85234ef383f8df$var$ramp((0, $5CprN.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $df85234ef383f8df$export$6664860a633d9daf = $df85234ef383f8df$var$ramp((0, $5CprN.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});


parcelRegister("lbKui", function(module, exports) {

$parcel$export(module.exports, "create", () => (parcelRequire("2U7rp")).default);
$parcel$export(module.exports, "creator", () => (parcelRequire("c3C99")).default);
$parcel$export(module.exports, "local", () => (parcelRequire("fFYRk")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("frlHm")).default);
$parcel$export(module.exports, "mouse", () => (parcelRequire("85VrD")).default);
$parcel$export(module.exports, "namespace", () => (parcelRequire("c3Psc")).default);
$parcel$export(module.exports, "namespaces", () => (parcelRequire("7r1Kk")).default);
$parcel$export(module.exports, "clientPoint", () => (parcelRequire("aA90S")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("g33fC")).default);
$parcel$export(module.exports, "selectAll", () => (parcelRequire("ipXuP")).default);
$parcel$export(module.exports, "selection", () => (parcelRequire("lrYgE")).default);
$parcel$export(module.exports, "selector", () => (parcelRequire("kmXBn")).default);
$parcel$export(module.exports, "selectorAll", () => (parcelRequire("gaA7M")).default);
$parcel$export(module.exports, "style", () => (parcelRequire("jW9rp")).styleValue);
$parcel$export(module.exports, "touch", () => (parcelRequire("db7mx")).default);
$parcel$export(module.exports, "touches", () => (parcelRequire("96ZhD")).default);
$parcel$export(module.exports, "window", () => (parcelRequire("k1QrJ")).default);
$parcel$export(module.exports, "event", () => (parcelRequire("bGBjI")).event);
$parcel$export(module.exports, "customEvent", () => (parcelRequire("bGBjI")).customEvent);

var $2U7rp = parcelRequire("2U7rp");

var $c3C99 = parcelRequire("c3C99");

var $fFYRk = parcelRequire("fFYRk");

var $frlHm = parcelRequire("frlHm");

var $85VrD = parcelRequire("85VrD");

var $c3Psc = parcelRequire("c3Psc");

var $7r1Kk = parcelRequire("7r1Kk");

var $aA90S = parcelRequire("aA90S");

var $g33fC = parcelRequire("g33fC");

var $ipXuP = parcelRequire("ipXuP");

var $lrYgE = parcelRequire("lrYgE");

var $kmXBn = parcelRequire("kmXBn");

var $gaA7M = parcelRequire("gaA7M");

var $jW9rp = parcelRequire("jW9rp");

var $db7mx = parcelRequire("db7mx");

var $96ZhD = parcelRequire("96ZhD");

var $k1QrJ = parcelRequire("k1QrJ");

var $bGBjI = parcelRequire("bGBjI");

});
parcelRegister("2U7rp", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d6955ccdb78371$export$2e2bcd8739ae039);

var $c3C99 = parcelRequire("c3C99");

var $g33fC = parcelRequire("g33fC");
function $21d6955ccdb78371$export$2e2bcd8739ae039(name) {
    return (0, $g33fC.default)((0, $c3C99.default)(name).call(document.documentElement));
}

});
parcelRegister("c3C99", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c735afc519f720a$export$2e2bcd8739ae039);

var $c3Psc = parcelRequire("c3Psc");

var $7r1Kk = parcelRequire("7r1Kk");
function $8c735afc519f720a$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $7r1Kk.xhtml) && document.documentElement.namespaceURI === (0, $7r1Kk.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8c735afc519f720a$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8c735afc519f720a$export$2e2bcd8739ae039(name) {
    var fullname = (0, $c3Psc.default)(name);
    return (fullname.local ? $8c735afc519f720a$var$creatorFixed : $8c735afc519f720a$var$creatorInherit)(fullname);
}

});
parcelRegister("c3Psc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c7dad85ee54e593$export$2e2bcd8739ae039);

var $7r1Kk = parcelRequire("7r1Kk");
function $8c7dad85ee54e593$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $7r1Kk.default).hasOwnProperty(prefix) ? {
        space: (0, $7r1Kk.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("7r1Kk", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $569c68c64851400b$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $569c68c64851400b$export$2e2bcd8739ae039);
var $569c68c64851400b$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $569c68c64851400b$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $569c68c64851400b$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("g33fC", function(module, exports) {

$parcel$export(module.exports, "default", () => $baef72bd02eae12b$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");
function $baef72bd02eae12b$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $lrYgE.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $lrYgE.Selection)([
        [
            selector
        ]
    ], (0, $lrYgE.root));
}

});
parcelRegister("lrYgE", function(module, exports) {

$parcel$export(module.exports, "root", () => $f9dade7d95f3711f$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $f9dade7d95f3711f$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $f9dade7d95f3711f$export$2e2bcd8739ae039);

var $el83L = parcelRequire("el83L");

var $bUjNG = parcelRequire("bUjNG");

var $lKY5K = parcelRequire("lKY5K");

var $7Zzmp = parcelRequire("7Zzmp");

var $4pgBL = parcelRequire("4pgBL");

var $jsnVe = parcelRequire("jsnVe");

var $iFLrB = parcelRequire("iFLrB");

var $2xjTi = parcelRequire("2xjTi");

var $dRMf6 = parcelRequire("dRMf6");

var $diV2M = parcelRequire("diV2M");

var $cFtQq = parcelRequire("cFtQq");

var $a0EDT = parcelRequire("a0EDT");

var $2R67j = parcelRequire("2R67j");

var $ki1oH = parcelRequire("ki1oH");

var $c4Upi = parcelRequire("c4Upi");

var $iqFmY = parcelRequire("iqFmY");

var $8QlSX = parcelRequire("8QlSX");

var $jW9rp = parcelRequire("jW9rp");

var $fwhSO = parcelRequire("fwhSO");

var $6WVva = parcelRequire("6WVva");

var $1XQ7w = parcelRequire("1XQ7w");

var $9xLkW = parcelRequire("9xLkW");

var $2gQMp = parcelRequire("2gQMp");

var $cQA9V = parcelRequire("cQA9V");

var $fh9Xr = parcelRequire("fh9Xr");

var $3k11q = parcelRequire("3k11q");

var $fiDaz = parcelRequire("fiDaz");

var $iyxqn = parcelRequire("iyxqn");

var $b7hAI = parcelRequire("b7hAI");

var $bGBjI = parcelRequire("bGBjI");

var $4Xfu5 = parcelRequire("4Xfu5");
var $f9dade7d95f3711f$export$e8e78c978b129247 = [
    null
];
function $f9dade7d95f3711f$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $f9dade7d95f3711f$var$selection() {
    return new $f9dade7d95f3711f$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $f9dade7d95f3711f$export$e8e78c978b129247);
}
$f9dade7d95f3711f$export$52baac22726c72bf.prototype = $f9dade7d95f3711f$var$selection.prototype = {
    constructor: $f9dade7d95f3711f$export$52baac22726c72bf,
    select: (0, $el83L.default),
    selectAll: (0, $bUjNG.default),
    filter: (0, $lKY5K.default),
    data: (0, $7Zzmp.default),
    enter: (0, $4pgBL.default),
    exit: (0, $jsnVe.default),
    join: (0, $iFLrB.default),
    merge: (0, $2xjTi.default),
    order: (0, $dRMf6.default),
    sort: (0, $diV2M.default),
    call: (0, $cFtQq.default),
    nodes: (0, $a0EDT.default),
    node: (0, $2R67j.default),
    size: (0, $ki1oH.default),
    empty: (0, $c4Upi.default),
    each: (0, $iqFmY.default),
    attr: (0, $8QlSX.default),
    style: (0, $jW9rp.default),
    property: (0, $fwhSO.default),
    classed: (0, $6WVva.default),
    text: (0, $1XQ7w.default),
    html: (0, $9xLkW.default),
    raise: (0, $2gQMp.default),
    lower: (0, $cQA9V.default),
    append: (0, $fh9Xr.default),
    insert: (0, $3k11q.default),
    remove: (0, $fiDaz.default),
    clone: (0, $iyxqn.default),
    datum: (0, $b7hAI.default),
    on: (0, $bGBjI.default),
    dispatch: (0, $4Xfu5.default)
};
var $f9dade7d95f3711f$export$2e2bcd8739ae039 = $f9dade7d95f3711f$var$selection;

});
parcelRegister("el83L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7094759b92b1828$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");

var $kmXBn = parcelRequire("kmXBn");
function $a7094759b92b1828$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $kmXBn.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $lrYgE.Selection)(subgroups, this._parents);
}

});
parcelRegister("kmXBn", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d3add02d1f71d5$export$2e2bcd8739ae039);
function $03d3add02d1f71d5$var$none() {}
function $03d3add02d1f71d5$export$2e2bcd8739ae039(selector) {
    return selector == null ? $03d3add02d1f71d5$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("bUjNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ab448981f8bc369$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");

var $gaA7M = parcelRequire("gaA7M");
function $8ab448981f8bc369$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $gaA7M.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $lrYgE.Selection)(subgroups, parents);
}

});
parcelRegister("gaA7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc599a18436c8ffb$export$2e2bcd8739ae039);
function $bc599a18436c8ffb$var$empty() {
    return [];
}
function $bc599a18436c8ffb$export$2e2bcd8739ae039(selector) {
    return selector == null ? $bc599a18436c8ffb$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("lKY5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6c81d5c2bcfb03$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");

var $frlHm = parcelRequire("frlHm");
function $fd6c81d5c2bcfb03$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $frlHm.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $lrYgE.Selection)(subgroups, this._parents);
}

});
parcelRegister("frlHm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3da3577285bb352$export$2e2bcd8739ae039);
function $b3da3577285bb352$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("7Zzmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $018069f29669d734$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");

var $4pgBL = parcelRequire("4pgBL");

var $azPLh = parcelRequire("azPLh");
var $018069f29669d734$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $018069f29669d734$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $4pgBL.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $018069f29669d734$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $018069f29669d734$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $018069f29669d734$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $4pgBL.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $018069f29669d734$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $018069f29669d734$var$bindKey : $018069f29669d734$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $azPLh.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $lrYgE.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("4pgBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356613fd5b44d29$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $3356613fd5b44d29$export$67b01759a14cf6a4);

var $6X5Al = parcelRequire("6X5Al");

var $lrYgE = parcelRequire("lrYgE");
function $3356613fd5b44d29$export$2e2bcd8739ae039() {
    return new (0, $lrYgE.Selection)(this._enter || this._groups.map((0, $6X5Al.default)), this._parents);
}
function $3356613fd5b44d29$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3356613fd5b44d29$export$67b01759a14cf6a4.prototype = {
    constructor: $3356613fd5b44d29$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("6X5Al", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fc95e094d6daf9$export$2e2bcd8739ae039);
function $50fc95e094d6daf9$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("azPLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b35530e92417e1f$export$2e2bcd8739ae039);
function $7b35530e92417e1f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("jsnVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a3304b9b636024$export$2e2bcd8739ae039);

var $6X5Al = parcelRequire("6X5Al");

var $lrYgE = parcelRequire("lrYgE");
function $e2a3304b9b636024$export$2e2bcd8739ae039() {
    return new (0, $lrYgE.Selection)(this._exit || this._groups.map((0, $6X5Al.default)), this._parents);
}

});

parcelRegister("iFLrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d980dbc2b4880044$export$2e2bcd8739ae039);
function $d980dbc2b4880044$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("2xjTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8e17bdd90b3525$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");
function $1d8e17bdd90b3525$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $lrYgE.Selection)(merges, this._parents);
}

});

parcelRegister("dRMf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a185a58fc420a6ef$export$2e2bcd8739ae039);
function $a185a58fc420a6ef$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("diV2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $9af9348146648ec1$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");
function $9af9348146648ec1$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $9af9348146648ec1$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $lrYgE.Selection)(sortgroups, this._parents).order();
}
function $9af9348146648ec1$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("cFtQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $939076ddae605dad$export$2e2bcd8739ae039);
function $939076ddae605dad$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("a0EDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $74996e313edd96ed$export$2e2bcd8739ae039);
function $74996e313edd96ed$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("2R67j", function(module, exports) {

$parcel$export(module.exports, "default", () => $214546b1dbdb7512$export$2e2bcd8739ae039);
function $214546b1dbdb7512$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("ki1oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec56929801a65cb5$export$2e2bcd8739ae039);
function $ec56929801a65cb5$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("c4Upi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb19d05ec1e92f6$export$2e2bcd8739ae039);
function $8cb19d05ec1e92f6$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("iqFmY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6aabecf67bab50e$export$2e2bcd8739ae039);
function $d6aabecf67bab50e$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("8QlSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $670428063d4adb12$export$2e2bcd8739ae039);

var $c3Psc = parcelRequire("c3Psc");
function $670428063d4adb12$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $670428063d4adb12$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $670428063d4adb12$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $670428063d4adb12$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $670428063d4adb12$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $670428063d4adb12$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $670428063d4adb12$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $c3Psc.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $670428063d4adb12$var$attrRemoveNS : $670428063d4adb12$var$attrRemove : typeof value === "function" ? fullname.local ? $670428063d4adb12$var$attrFunctionNS : $670428063d4adb12$var$attrFunction : fullname.local ? $670428063d4adb12$var$attrConstantNS : $670428063d4adb12$var$attrConstant)(fullname, value));
}

});

parcelRegister("jW9rp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83ac1e669a28fd4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $e83ac1e669a28fd4$export$5e3cec964f0b5efd);

var $k1QrJ = parcelRequire("k1QrJ");
function $e83ac1e669a28fd4$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e83ac1e669a28fd4$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $e83ac1e669a28fd4$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $e83ac1e669a28fd4$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $e83ac1e669a28fd4$var$styleRemove : typeof value === "function" ? $e83ac1e669a28fd4$var$styleFunction : $e83ac1e669a28fd4$var$styleConstant)(name, value, priority == null ? "" : priority)) : $e83ac1e669a28fd4$export$5e3cec964f0b5efd(this.node(), name);
}
function $e83ac1e669a28fd4$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $k1QrJ.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("k1QrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94c956605a23541$export$2e2bcd8739ae039);
function $e94c956605a23541$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("fwhSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c7b75b111f2e21$export$2e2bcd8739ae039);
function $b4c7b75b111f2e21$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $b4c7b75b111f2e21$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $b4c7b75b111f2e21$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $b4c7b75b111f2e21$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $b4c7b75b111f2e21$var$propertyRemove : typeof value === "function" ? $b4c7b75b111f2e21$var$propertyFunction : $b4c7b75b111f2e21$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("6WVva", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f4c38515052721$export$2e2bcd8739ae039);
function $50f4c38515052721$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $50f4c38515052721$var$classList(node) {
    return node.classList || new $50f4c38515052721$var$ClassList(node);
}
function $50f4c38515052721$var$ClassList(node) {
    this._node = node;
    this._names = $50f4c38515052721$var$classArray(node.getAttribute("class") || "");
}
$50f4c38515052721$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $50f4c38515052721$var$classedAdd(node, names) {
    var list = $50f4c38515052721$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $50f4c38515052721$var$classedRemove(node, names) {
    var list = $50f4c38515052721$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $50f4c38515052721$var$classedTrue(names) {
    return function() {
        $50f4c38515052721$var$classedAdd(this, names);
    };
}
function $50f4c38515052721$var$classedFalse(names) {
    return function() {
        $50f4c38515052721$var$classedRemove(this, names);
    };
}
function $50f4c38515052721$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $50f4c38515052721$var$classedAdd : $50f4c38515052721$var$classedRemove)(this, names);
    };
}
function $50f4c38515052721$export$2e2bcd8739ae039(name, value) {
    var names = $50f4c38515052721$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $50f4c38515052721$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $50f4c38515052721$var$classedFunction : value ? $50f4c38515052721$var$classedTrue : $50f4c38515052721$var$classedFalse)(names, value));
}

});

parcelRegister("1XQ7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e3bb2854de1cd5$export$2e2bcd8739ae039);
function $16e3bb2854de1cd5$var$textRemove() {
    this.textContent = "";
}
function $16e3bb2854de1cd5$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $16e3bb2854de1cd5$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $16e3bb2854de1cd5$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $16e3bb2854de1cd5$var$textRemove : (typeof value === "function" ? $16e3bb2854de1cd5$var$textFunction : $16e3bb2854de1cd5$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("9xLkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2bea3d8dd1d809$export$2e2bcd8739ae039);
function $6f2bea3d8dd1d809$var$htmlRemove() {
    this.innerHTML = "";
}
function $6f2bea3d8dd1d809$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $6f2bea3d8dd1d809$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $6f2bea3d8dd1d809$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $6f2bea3d8dd1d809$var$htmlRemove : (typeof value === "function" ? $6f2bea3d8dd1d809$var$htmlFunction : $6f2bea3d8dd1d809$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("2gQMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a760457483c182f$export$2e2bcd8739ae039);
function $1a760457483c182f$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $1a760457483c182f$export$2e2bcd8739ae039() {
    return this.each($1a760457483c182f$var$raise);
}

});

parcelRegister("cQA9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a663c7c856268e$export$2e2bcd8739ae039);
function $95a663c7c856268e$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $95a663c7c856268e$export$2e2bcd8739ae039() {
    return this.each($95a663c7c856268e$var$lower);
}

});

parcelRegister("fh9Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f02af55fcee38c$export$2e2bcd8739ae039);

var $c3C99 = parcelRequire("c3C99");
function $b1f02af55fcee38c$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $c3C99.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});

parcelRegister("3k11q", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b4084e25ac7379$export$2e2bcd8739ae039);

var $c3C99 = parcelRequire("c3C99");

var $kmXBn = parcelRequire("kmXBn");
function $26b4084e25ac7379$var$constantNull() {
    return null;
}
function $26b4084e25ac7379$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $c3C99.default)(name), select = before == null ? $26b4084e25ac7379$var$constantNull : typeof before === "function" ? before : (0, $kmXBn.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("fiDaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b236ebae5f6fa04c$export$2e2bcd8739ae039);
function $b236ebae5f6fa04c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $b236ebae5f6fa04c$export$2e2bcd8739ae039() {
    return this.each($b236ebae5f6fa04c$var$remove);
}

});

parcelRegister("iyxqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d825545c87a0a353$export$2e2bcd8739ae039);
function $d825545c87a0a353$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $d825545c87a0a353$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $d825545c87a0a353$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $d825545c87a0a353$var$selection_cloneDeep : $d825545c87a0a353$var$selection_cloneShallow);
}

});

parcelRegister("b7hAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $817dfe63a4f59855$export$2e2bcd8739ae039);
function $817dfe63a4f59855$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("bGBjI", function(module, exports) {

$parcel$export(module.exports, "event", () => $8820904e57f999ec$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $8820904e57f999ec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $8820904e57f999ec$export$4c724631b4750aef);
var $8820904e57f999ec$var$filterEvents = {};
var $8820904e57f999ec$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $8820904e57f999ec$var$element = document.documentElement;
    if (!("onmouseenter" in $8820904e57f999ec$var$element)) $8820904e57f999ec$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $8820904e57f999ec$var$filterContextListener(listener, index, group) {
    listener = $8820904e57f999ec$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $8820904e57f999ec$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $8820904e57f999ec$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $8820904e57f999ec$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $8820904e57f999ec$export$6cd530ed55e06764 = event0;
        }
    };
}
function $8820904e57f999ec$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $8820904e57f999ec$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $8820904e57f999ec$var$onAdd(typename, value, capture) {
    var wrap = $8820904e57f999ec$var$filterEvents.hasOwnProperty(typename.type) ? $8820904e57f999ec$var$filterContextListener : $8820904e57f999ec$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $8820904e57f999ec$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $8820904e57f999ec$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $8820904e57f999ec$var$onAdd : $8820904e57f999ec$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $8820904e57f999ec$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $8820904e57f999ec$export$6cd530ed55e06764;
    event1.sourceEvent = $8820904e57f999ec$export$6cd530ed55e06764;
    $8820904e57f999ec$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $8820904e57f999ec$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("4Xfu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b8aefa0ead67bc$export$2e2bcd8739ae039);

var $k1QrJ = parcelRequire("k1QrJ");
function $39b8aefa0ead67bc$var$dispatchEvent(node, type, params) {
    var window = (0, $k1QrJ.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $39b8aefa0ead67bc$var$dispatchConstant(type, params) {
    return function() {
        return $39b8aefa0ead67bc$var$dispatchEvent(this, type, params);
    };
}
function $39b8aefa0ead67bc$var$dispatchFunction(type, params) {
    return function() {
        return $39b8aefa0ead67bc$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $39b8aefa0ead67bc$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $39b8aefa0ead67bc$var$dispatchFunction : $39b8aefa0ead67bc$var$dispatchConstant)(type, params));
}

});




parcelRegister("fFYRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b699e4b818ea1ea2$export$2e2bcd8739ae039);
var $b699e4b818ea1ea2$var$nextId = 0;
function $b699e4b818ea1ea2$export$2e2bcd8739ae039() {
    return new $b699e4b818ea1ea2$var$Local;
}
function $b699e4b818ea1ea2$var$Local() {
    this._ = "@" + (++$b699e4b818ea1ea2$var$nextId).toString(36);
}
$b699e4b818ea1ea2$var$Local.prototype = $b699e4b818ea1ea2$export$2e2bcd8739ae039.prototype = {
    constructor: $b699e4b818ea1ea2$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

});

parcelRegister("85VrD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e4b59b260871a9d$export$2e2bcd8739ae039);

var $jMcqB = parcelRequire("jMcqB");

var $aA90S = parcelRequire("aA90S");
function $5e4b59b260871a9d$export$2e2bcd8739ae039(node) {
    var event = (0, $jMcqB.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $aA90S.default)(node, event);
}

});
parcelRegister("jMcqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65c23f4347eac77$export$2e2bcd8739ae039);

var $bGBjI = parcelRequire("bGBjI");
function $e65c23f4347eac77$export$2e2bcd8739ae039() {
    var current = (0, $bGBjI.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("aA90S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4441fdfbba54c5$export$2e2bcd8739ae039);
function $7b4441fdfbba54c5$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("ipXuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d688b67dbc9abe37$export$2e2bcd8739ae039);

var $lrYgE = parcelRequire("lrYgE");
function $d688b67dbc9abe37$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $lrYgE.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $lrYgE.Selection)([
        selector == null ? [] : selector
    ], (0, $lrYgE.root));
}

});

parcelRegister("db7mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $99820375c06f940f$export$2e2bcd8739ae039);

var $jMcqB = parcelRequire("jMcqB");

var $aA90S = parcelRequire("aA90S");
function $99820375c06f940f$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $jMcqB.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $aA90S.default)(node, touch);
    }
    return null;
}

});

parcelRegister("96ZhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a24363b3718d7b1$export$2e2bcd8739ae039);

var $jMcqB = parcelRequire("jMcqB");

var $aA90S = parcelRequire("aA90S");
function $6a24363b3718d7b1$export$2e2bcd8739ae039(node, touches) {
    if (touches == null) touches = (0, $jMcqB.default)().touches;
    for(var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i)points[i] = (0, $aA90S.default)(node, touches[i]);
    return points;
}

});


parcelRegister("89UbF", function(module, exports) {

$parcel$export(module.exports, "arc", () => (parcelRequire("hAvpi")).default);
$parcel$export(module.exports, "area", () => (parcelRequire("bTUmV")).default);
$parcel$export(module.exports, "line", () => (parcelRequire("1izgn")).default);
$parcel$export(module.exports, "pie", () => (parcelRequire("aRYI3")).default);
$parcel$export(module.exports, "areaRadial", () => (parcelRequire("7B2dS")).default);
$parcel$export(module.exports, "radialArea", () => (parcelRequire("7B2dS")).default);
$parcel$export(module.exports, "lineRadial", () => (parcelRequire("evBJZ")).default);
$parcel$export(module.exports, "radialLine", () => (parcelRequire("evBJZ")).default);
$parcel$export(module.exports, "pointRadial", () => (parcelRequire("jtD56")).default);
$parcel$export(module.exports, "linkHorizontal", () => (parcelRequire("qhMiS")).linkHorizontal);
$parcel$export(module.exports, "linkVertical", () => (parcelRequire("qhMiS")).linkVertical);
$parcel$export(module.exports, "linkRadial", () => (parcelRequire("qhMiS")).linkRadial);
$parcel$export(module.exports, "symbol", () => (parcelRequire("dPoji")).default);
$parcel$export(module.exports, "symbols", () => (parcelRequire("dPoji")).symbols);
$parcel$export(module.exports, "symbolCircle", () => (parcelRequire("93Rby")).default);
$parcel$export(module.exports, "symbolCross", () => (parcelRequire("dL3ck")).default);
$parcel$export(module.exports, "symbolDiamond", () => (parcelRequire("8syux")).default);
$parcel$export(module.exports, "symbolSquare", () => (parcelRequire("em6VM")).default);
$parcel$export(module.exports, "symbolStar", () => (parcelRequire("8fWKs")).default);
$parcel$export(module.exports, "symbolTriangle", () => (parcelRequire("ivm0K")).default);
$parcel$export(module.exports, "symbolWye", () => (parcelRequire("hYhFZ")).default);
$parcel$export(module.exports, "curveBasisClosed", () => (parcelRequire("eRUUX")).default);
$parcel$export(module.exports, "curveBasisOpen", () => (parcelRequire("87vg6")).default);
$parcel$export(module.exports, "curveBasis", () => (parcelRequire("jy52E")).default);
$parcel$export(module.exports, "curveBundle", () => (parcelRequire("4i7UE")).default);
$parcel$export(module.exports, "curveCardinalClosed", () => (parcelRequire("j1RWi")).default);
$parcel$export(module.exports, "curveCardinalOpen", () => (parcelRequire("hRUWK")).default);
$parcel$export(module.exports, "curveCardinal", () => (parcelRequire("gBRyf")).default);
$parcel$export(module.exports, "curveCatmullRomClosed", () => (parcelRequire("eJQi8")).default);
$parcel$export(module.exports, "curveCatmullRomOpen", () => (parcelRequire("hUBHb")).default);
$parcel$export(module.exports, "curveCatmullRom", () => (parcelRequire("5jkgm")).default);
$parcel$export(module.exports, "curveLinearClosed", () => (parcelRequire("li5VB")).default);
$parcel$export(module.exports, "curveLinear", () => (parcelRequire("6Au9n")).default);
$parcel$export(module.exports, "curveMonotoneX", () => (parcelRequire("1zuK2")).monotoneX);
$parcel$export(module.exports, "curveMonotoneY", () => (parcelRequire("1zuK2")).monotoneY);
$parcel$export(module.exports, "curveNatural", () => (parcelRequire("bS2sF")).default);
$parcel$export(module.exports, "curveStep", () => (parcelRequire("5xtrd")).default);
$parcel$export(module.exports, "curveStepAfter", () => (parcelRequire("5xtrd")).stepAfter);
$parcel$export(module.exports, "curveStepBefore", () => (parcelRequire("5xtrd")).stepBefore);
$parcel$export(module.exports, "stack", () => (parcelRequire("awfCb")).default);
$parcel$export(module.exports, "stackOffsetExpand", () => (parcelRequire("dob8E")).default);
$parcel$export(module.exports, "stackOffsetDiverging", () => (parcelRequire("eyChT")).default);
$parcel$export(module.exports, "stackOffsetNone", () => (parcelRequire("l3lLO")).default);
$parcel$export(module.exports, "stackOffsetSilhouette", () => (parcelRequire("1b1Nz")).default);
$parcel$export(module.exports, "stackOffsetWiggle", () => (parcelRequire("1MkOd")).default);
$parcel$export(module.exports, "stackOrderAppearance", () => (parcelRequire("c5NgE")).default);
$parcel$export(module.exports, "stackOrderAscending", () => (parcelRequire("9NZzu")).default);
$parcel$export(module.exports, "stackOrderDescending", () => (parcelRequire("gZBfv")).default);
$parcel$export(module.exports, "stackOrderInsideOut", () => (parcelRequire("ldIUg")).default);
$parcel$export(module.exports, "stackOrderNone", () => (parcelRequire("16LW3")).default);
$parcel$export(module.exports, "stackOrderReverse", () => (parcelRequire("9KY9i")).default);

var $hAvpi = parcelRequire("hAvpi");

var $bTUmV = parcelRequire("bTUmV");

var $1izgn = parcelRequire("1izgn");

var $aRYI3 = parcelRequire("aRYI3");

var $7B2dS = parcelRequire("7B2dS");

var $evBJZ = parcelRequire("evBJZ");

var $jtD56 = parcelRequire("jtD56");

var $qhMiS = parcelRequire("qhMiS");

var $dPoji = parcelRequire("dPoji");

var $93Rby = parcelRequire("93Rby");

var $dL3ck = parcelRequire("dL3ck");

var $8syux = parcelRequire("8syux");

var $em6VM = parcelRequire("em6VM");

var $8fWKs = parcelRequire("8fWKs");

var $ivm0K = parcelRequire("ivm0K");

var $hYhFZ = parcelRequire("hYhFZ");

var $eRUUX = parcelRequire("eRUUX");

var $87vg6 = parcelRequire("87vg6");

var $jy52E = parcelRequire("jy52E");

var $4i7UE = parcelRequire("4i7UE");

var $j1RWi = parcelRequire("j1RWi");

var $hRUWK = parcelRequire("hRUWK");

var $gBRyf = parcelRequire("gBRyf");

var $eJQi8 = parcelRequire("eJQi8");

var $hUBHb = parcelRequire("hUBHb");

var $5jkgm = parcelRequire("5jkgm");

var $li5VB = parcelRequire("li5VB");

var $6Au9n = parcelRequire("6Au9n");

var $1zuK2 = parcelRequire("1zuK2");

var $bS2sF = parcelRequire("bS2sF");

var $5xtrd = parcelRequire("5xtrd");

var $awfCb = parcelRequire("awfCb");

var $dob8E = parcelRequire("dob8E");

var $eyChT = parcelRequire("eyChT");

var $l3lLO = parcelRequire("l3lLO");

var $1b1Nz = parcelRequire("1b1Nz");

var $1MkOd = parcelRequire("1MkOd");

var $c5NgE = parcelRequire("c5NgE");

var $9NZzu = parcelRequire("9NZzu");

var $gZBfv = parcelRequire("gZBfv");

var $ldIUg = parcelRequire("ldIUg");

var $16LW3 = parcelRequire("16LW3");

var $9KY9i = parcelRequire("9KY9i");

});
parcelRegister("hAvpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccde2937b740f12e$export$2e2bcd8739ae039);

var $176ah = parcelRequire("176ah");

var $dDit9 = parcelRequire("dDit9");

var $5O1Cf = parcelRequire("5O1Cf");
function $ccde2937b740f12e$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $ccde2937b740f12e$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $ccde2937b740f12e$var$arcStartAngle(d) {
    return d.startAngle;
}
function $ccde2937b740f12e$var$arcEndAngle(d) {
    return d.endAngle;
}
function $ccde2937b740f12e$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $ccde2937b740f12e$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $5O1Cf.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $ccde2937b740f12e$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $5O1Cf.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $5O1Cf.sqrt)((0, $5O1Cf.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $ccde2937b740f12e$export$2e2bcd8739ae039() {
    var innerRadius = $ccde2937b740f12e$var$arcInnerRadius, outerRadius = $ccde2937b740f12e$var$arcOuterRadius, cornerRadius = (0, $dDit9.default)(0), padRadius = null, startAngle = $ccde2937b740f12e$var$arcStartAngle, endAngle = $ccde2937b740f12e$var$arcEndAngle, padAngle = $ccde2937b740f12e$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $5O1Cf.halfPi), a1 = endAngle.apply(this, arguments) - (0, $5O1Cf.halfPi), da = (0, $5O1Cf.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $176ah.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $5O1Cf.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $5O1Cf.tau) - (0, $5O1Cf.epsilon)) {
            context.moveTo(r1 * (0, $5O1Cf.cos)(a0), r1 * (0, $5O1Cf.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $5O1Cf.epsilon)) {
                context.moveTo(r0 * (0, $5O1Cf.cos)(a1), r0 * (0, $5O1Cf.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $5O1Cf.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $5O1Cf.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $5O1Cf.min)((0, $5O1Cf.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $5O1Cf.epsilon)) {
                var p0 = (0, $5O1Cf.asin)(rp / r0 * (0, $5O1Cf.sin)(ap)), p1 = (0, $5O1Cf.asin)(rp / r1 * (0, $5O1Cf.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $5O1Cf.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $5O1Cf.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $5O1Cf.cos)(a01), y01 = r1 * (0, $5O1Cf.sin)(a01), x10 = r0 * (0, $5O1Cf.cos)(a10), y10 = r0 * (0, $5O1Cf.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $5O1Cf.epsilon)) {
                var x11 = r1 * (0, $5O1Cf.cos)(a11), y11 = r1 * (0, $5O1Cf.sin)(a11), x00 = r0 * (0, $5O1Cf.cos)(a00), y00 = r0 * (0, $5O1Cf.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $5O1Cf.pi) && (oc = $ccde2937b740f12e$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $5O1Cf.sin)((0, $5O1Cf.acos)((ax * bx + ay * by) / ((0, $5O1Cf.sqrt)(ax * ax + ay * ay) * (0, $5O1Cf.sqrt)(bx * bx + by * by))) / 2), lc = (0, $5O1Cf.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $5O1Cf.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $5O1Cf.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $5O1Cf.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $5O1Cf.epsilon)) {
                t0 = $ccde2937b740f12e$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $ccde2937b740f12e$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $5O1Cf.atan2)(t0.y01, t0.x01), (0, $5O1Cf.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $5O1Cf.atan2)(t0.y01, t0.x01), (0, $5O1Cf.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $5O1Cf.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $5O1Cf.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $5O1Cf.atan2)(t1.y11, t1.x11), (0, $5O1Cf.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $5O1Cf.epsilon)) || !(da0 > (0, $5O1Cf.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $5O1Cf.epsilon)) {
                t0 = $ccde2937b740f12e$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $ccde2937b740f12e$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $5O1Cf.atan2)(t0.y01, t0.x01), (0, $5O1Cf.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $5O1Cf.atan2)(t0.y01, t0.x01), (0, $5O1Cf.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $5O1Cf.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $5O1Cf.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $5O1Cf.atan2)(t1.y11, t1.x11), (0, $5O1Cf.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $5O1Cf.pi) / 2;
        return [
            (0, $5O1Cf.cos)(a) * r,
            (0, $5O1Cf.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("dDit9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecd3e79f10138eb$export$2e2bcd8739ae039);
function $9ecd3e79f10138eb$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("5O1Cf", function(module, exports) {

$parcel$export(module.exports, "abs", () => $43a2e022d5fa3609$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $43a2e022d5fa3609$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $43a2e022d5fa3609$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $43a2e022d5fa3609$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $43a2e022d5fa3609$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $43a2e022d5fa3609$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $43a2e022d5fa3609$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $43a2e022d5fa3609$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $43a2e022d5fa3609$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $43a2e022d5fa3609$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $43a2e022d5fa3609$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $43a2e022d5fa3609$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $43a2e022d5fa3609$export$41726bdb1fc63f);
var $43a2e022d5fa3609$export$2335f513bbd82c6d = Math.abs;
var $43a2e022d5fa3609$export$b8b770ee6a0d9760 = Math.atan2;
var $43a2e022d5fa3609$export$50d414a77b60d802 = Math.cos;
var $43a2e022d5fa3609$export$8960430cfd85939f = Math.max;
var $43a2e022d5fa3609$export$96ec731ed4dcb222 = Math.min;
var $43a2e022d5fa3609$export$5de3937cb4b592ed = Math.sin;
var $43a2e022d5fa3609$export$eba8049fb5020b81 = Math.sqrt;
var $43a2e022d5fa3609$export$6c421550c66a327d = 1e-12;
var $43a2e022d5fa3609$export$18c7bea995a110f = Math.PI;
var $43a2e022d5fa3609$export$e51408a300e8929a = $43a2e022d5fa3609$export$18c7bea995a110f / 2;
var $43a2e022d5fa3609$export$a4b4b4d4d776fe92 = 2 * $43a2e022d5fa3609$export$18c7bea995a110f;
function $43a2e022d5fa3609$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $43a2e022d5fa3609$export$18c7bea995a110f : Math.acos(x);
}
function $43a2e022d5fa3609$export$41726bdb1fc63f(x) {
    return x >= 1 ? $43a2e022d5fa3609$export$e51408a300e8929a : x <= -1 ? -$43a2e022d5fa3609$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("bTUmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aa08e6ed39f2e17$export$2e2bcd8739ae039);

var $176ah = parcelRequire("176ah");

var $dDit9 = parcelRequire("dDit9");

var $6Au9n = parcelRequire("6Au9n");

var $1izgn = parcelRequire("1izgn");

var $ehRky = parcelRequire("ehRky");
function $8aa08e6ed39f2e17$export$2e2bcd8739ae039() {
    var x0 = (0, $ehRky.x), x1 = null, y0 = (0, $dDit9.default)(0), y1 = (0, $ehRky.y), defined = (0, $dDit9.default)(true), context = null, curve = (0, $6Au9n.default), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $176ah.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $1izgn.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $dDit9.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $dDit9.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $dDit9.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("6Au9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbd7e10bec1daa5$export$2e2bcd8739ae039);
function $4cbd7e10bec1daa5$var$Linear(context) {
    this._context = context;
}
$4cbd7e10bec1daa5$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $4cbd7e10bec1daa5$export$2e2bcd8739ae039(context) {
    return new $4cbd7e10bec1daa5$var$Linear(context);
}

});

parcelRegister("1izgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f22d369ccfd243a$export$2e2bcd8739ae039);

var $176ah = parcelRequire("176ah");

var $dDit9 = parcelRequire("dDit9");

var $6Au9n = parcelRequire("6Au9n");

var $ehRky = parcelRequire("ehRky");
function $0f22d369ccfd243a$export$2e2bcd8739ae039() {
    var x = (0, $ehRky.x), y = (0, $ehRky.y), defined = (0, $dDit9.default)(true), context = null, curve = (0, $6Au9n.default), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $176ah.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $dDit9.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ehRky", function(module, exports) {

$parcel$export(module.exports, "x", () => $a66c058be1aaee4b$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $a66c058be1aaee4b$export$4a5767248b18ef41);
function $a66c058be1aaee4b$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $a66c058be1aaee4b$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("aRYI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9df24616d5b04b$export$2e2bcd8739ae039);

var $dDit9 = parcelRequire("dDit9");

var $dnaTd = parcelRequire("dnaTd");

var $14SnT = parcelRequire("14SnT");

var $5O1Cf = parcelRequire("5O1Cf");
function $7e9df24616d5b04b$export$2e2bcd8739ae039() {
    var value = (0, $14SnT.default), sortValues = (0, $dnaTd.default), sort = null, startAngle = (0, $dDit9.default)(0), endAngle = (0, $dDit9.default)((0, $5O1Cf.tau)), padAngle = (0, $dDit9.default)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $5O1Cf.tau), Math.max(-(0, $5O1Cf.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("dnaTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc5dec36c5eae5c$export$2e2bcd8739ae039);
function $9bc5dec36c5eae5c$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("14SnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c9059c4c52dbd0d$export$2e2bcd8739ae039);
function $0c9059c4c52dbd0d$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("7B2dS", function(module, exports) {

$parcel$export(module.exports, "default", () => $587db682290a5992$export$2e2bcd8739ae039);

var $f7Z9s = parcelRequire("f7Z9s");

var $bTUmV = parcelRequire("bTUmV");

var $evBJZ = parcelRequire("evBJZ");
function $587db682290a5992$export$2e2bcd8739ae039() {
    var a = (0, $bTUmV.default)().curve((0, $f7Z9s.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $evBJZ.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $evBJZ.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $evBJZ.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $evBJZ.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $f7Z9s.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("f7Z9s", function(module, exports) {

$parcel$export(module.exports, "curveRadialLinear", () => $b036f1e285f8fd01$export$22d25ffb9fb15b6f);
$parcel$export(module.exports, "default", () => $b036f1e285f8fd01$export$2e2bcd8739ae039);

var $6Au9n = parcelRequire("6Au9n");
var $b036f1e285f8fd01$export$22d25ffb9fb15b6f = $b036f1e285f8fd01$export$2e2bcd8739ae039((0, $6Au9n.default));
function $b036f1e285f8fd01$var$Radial(curve) {
    this._curve = curve;
}
$b036f1e285f8fd01$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $b036f1e285f8fd01$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $b036f1e285f8fd01$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("evBJZ", function(module, exports) {

$parcel$export(module.exports, "lineRadial", () => $a9013c798c955358$export$4d8815a75dc8cd4d);
$parcel$export(module.exports, "default", () => $a9013c798c955358$export$2e2bcd8739ae039);

var $f7Z9s = parcelRequire("f7Z9s");

var $1izgn = parcelRequire("1izgn");
function $a9013c798c955358$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $f7Z9s.default)(_)) : c()._curve;
    };
    return l;
}
function $a9013c798c955358$export$2e2bcd8739ae039() {
    return $a9013c798c955358$export$4d8815a75dc8cd4d((0, $1izgn.default)().curve((0, $f7Z9s.curveRadialLinear)));
}

});


parcelRegister("jtD56", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2df0a7ff6375705$export$2e2bcd8739ae039);
function $e2df0a7ff6375705$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("qhMiS", function(module, exports) {

$parcel$export(module.exports, "linkHorizontal", () => $04f0382e32bafed1$export$e7c381889b2cd14d);
$parcel$export(module.exports, "linkVertical", () => $04f0382e32bafed1$export$75de4c8c66884e04);
$parcel$export(module.exports, "linkRadial", () => $04f0382e32bafed1$export$7739cfe68d4e0799);

var $176ah = parcelRequire("176ah");

var $k8DO8 = parcelRequire("k8DO8");

var $dDit9 = parcelRequire("dDit9");

var $ehRky = parcelRequire("ehRky");

var $jtD56 = parcelRequire("jtD56");
function $04f0382e32bafed1$var$linkSource(d) {
    return d.source;
}
function $04f0382e32bafed1$var$linkTarget(d) {
    return d.target;
}
function $04f0382e32bafed1$var$link(curve) {
    var source = $04f0382e32bafed1$var$linkSource, target = $04f0382e32bafed1$var$linkTarget, x = (0, $ehRky.x), y = (0, $ehRky.y), context = null;
    function link() {
        var buffer, argv = (0, $k8DO8.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $176ah.default)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $04f0382e32bafed1$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $04f0382e32bafed1$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $04f0382e32bafed1$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $jtD56.default)(x0, y0), p1 = (0, $jtD56.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, $jtD56.default)(x1, y0), p3 = (0, $jtD56.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $04f0382e32bafed1$export$e7c381889b2cd14d() {
    return $04f0382e32bafed1$var$link($04f0382e32bafed1$var$curveHorizontal);
}
function $04f0382e32bafed1$export$75de4c8c66884e04() {
    return $04f0382e32bafed1$var$link($04f0382e32bafed1$var$curveVertical);
}
function $04f0382e32bafed1$export$7739cfe68d4e0799() {
    var l = $04f0382e32bafed1$var$link($04f0382e32bafed1$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("k8DO8", function(module, exports) {

$parcel$export(module.exports, "slice", () => $ea936efc6ce7cfd4$export$58adb3bec8346d0f);
var $ea936efc6ce7cfd4$export$58adb3bec8346d0f = Array.prototype.slice;

});


parcelRegister("dPoji", function(module, exports) {

$parcel$export(module.exports, "symbols", () => $a112e546e85e7f1a$export$47616e9f7f5fe113);
$parcel$export(module.exports, "default", () => $a112e546e85e7f1a$export$2e2bcd8739ae039);

var $176ah = parcelRequire("176ah");

var $93Rby = parcelRequire("93Rby");

var $dL3ck = parcelRequire("dL3ck");

var $8syux = parcelRequire("8syux");

var $8fWKs = parcelRequire("8fWKs");

var $em6VM = parcelRequire("em6VM");

var $ivm0K = parcelRequire("ivm0K");

var $hYhFZ = parcelRequire("hYhFZ");

var $dDit9 = parcelRequire("dDit9");
var $a112e546e85e7f1a$export$47616e9f7f5fe113 = [
    (0, $93Rby.default),
    (0, $dL3ck.default),
    (0, $8syux.default),
    (0, $em6VM.default),
    (0, $8fWKs.default),
    (0, $ivm0K.default),
    (0, $hYhFZ.default)
];
function $a112e546e85e7f1a$export$2e2bcd8739ae039() {
    var type = (0, $dDit9.default)((0, $93Rby.default)), size = (0, $dDit9.default)(64), context = null;
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $176ah.default)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $dDit9.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("93Rby", function(module, exports) {

$parcel$export(module.exports, "default", () => $698da6612925aba2$export$2e2bcd8739ae039);

var $5O1Cf = parcelRequire("5O1Cf");
var $698da6612925aba2$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $5O1Cf.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $5O1Cf.tau));
    }
};

});

parcelRegister("dL3ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0422528117f39a2$export$2e2bcd8739ae039);
var $a0422528117f39a2$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("8syux", function(module, exports) {

$parcel$export(module.exports, "default", () => $628bb18db2c8ab69$export$2e2bcd8739ae039);
var $628bb18db2c8ab69$var$tan30 = Math.sqrt(1 / 3), $628bb18db2c8ab69$var$tan30_2 = $628bb18db2c8ab69$var$tan30 * 2;
var $628bb18db2c8ab69$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $628bb18db2c8ab69$var$tan30_2), x = y * $628bb18db2c8ab69$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("8fWKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $602d4ba389790000$export$2e2bcd8739ae039);

var $5O1Cf = parcelRequire("5O1Cf");
var $602d4ba389790000$var$ka = 0.89081309152928522810, $602d4ba389790000$var$kr = Math.sin((0, $5O1Cf.pi) / 10) / Math.sin(7 * (0, $5O1Cf.pi) / 10), $602d4ba389790000$var$kx = Math.sin((0, $5O1Cf.tau) / 10) * $602d4ba389790000$var$kr, $602d4ba389790000$var$ky = -Math.cos((0, $5O1Cf.tau) / 10) * $602d4ba389790000$var$kr;
var $602d4ba389790000$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $602d4ba389790000$var$ka), x = $602d4ba389790000$var$kx * r, y = $602d4ba389790000$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $5O1Cf.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("em6VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7387f16af0ef307$export$2e2bcd8739ae039);
var $a7387f16af0ef307$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("ivm0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d78c3233fdf19261$export$2e2bcd8739ae039);
var $d78c3233fdf19261$var$sqrt3 = Math.sqrt(3);
var $d78c3233fdf19261$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($d78c3233fdf19261$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d78c3233fdf19261$var$sqrt3 * y, -y);
        context.lineTo($d78c3233fdf19261$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("hYhFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d155c064d49fbbdd$export$2e2bcd8739ae039);
var $d155c064d49fbbdd$var$c = -0.5, $d155c064d49fbbdd$var$s = Math.sqrt(3) / 2, $d155c064d49fbbdd$var$k = 1 / Math.sqrt(12), $d155c064d49fbbdd$var$a = ($d155c064d49fbbdd$var$k / 2 + 1) * 3;
var $d155c064d49fbbdd$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $d155c064d49fbbdd$var$a), x0 = r / 2, y0 = r * $d155c064d49fbbdd$var$k, x1 = x0, y1 = r * $d155c064d49fbbdd$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($d155c064d49fbbdd$var$c * x0 - $d155c064d49fbbdd$var$s * y0, $d155c064d49fbbdd$var$s * x0 + $d155c064d49fbbdd$var$c * y0);
        context.lineTo($d155c064d49fbbdd$var$c * x1 - $d155c064d49fbbdd$var$s * y1, $d155c064d49fbbdd$var$s * x1 + $d155c064d49fbbdd$var$c * y1);
        context.lineTo($d155c064d49fbbdd$var$c * x2 - $d155c064d49fbbdd$var$s * y2, $d155c064d49fbbdd$var$s * x2 + $d155c064d49fbbdd$var$c * y2);
        context.lineTo($d155c064d49fbbdd$var$c * x0 + $d155c064d49fbbdd$var$s * y0, $d155c064d49fbbdd$var$c * y0 - $d155c064d49fbbdd$var$s * x0);
        context.lineTo($d155c064d49fbbdd$var$c * x1 + $d155c064d49fbbdd$var$s * y1, $d155c064d49fbbdd$var$c * y1 - $d155c064d49fbbdd$var$s * x1);
        context.lineTo($d155c064d49fbbdd$var$c * x2 + $d155c064d49fbbdd$var$s * y2, $d155c064d49fbbdd$var$c * y2 - $d155c064d49fbbdd$var$s * x2);
        context.closePath();
    }
};

});


parcelRegister("eRUUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad322a98c1a36593$export$2e2bcd8739ae039);

var $dAnHq = parcelRequire("dAnHq");

var $jy52E = parcelRequire("jy52E");
function $ad322a98c1a36593$var$BasisClosed(context) {
    this._context = context;
}
$ad322a98c1a36593$var$BasisClosed.prototype = {
    areaStart: (0, $dAnHq.default),
    areaEnd: (0, $dAnHq.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $jy52E.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $ad322a98c1a36593$export$2e2bcd8739ae039(context) {
    return new $ad322a98c1a36593$var$BasisClosed(context);
}

});
parcelRegister("dAnHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e41056308b077ca$export$2e2bcd8739ae039);
function $9e41056308b077ca$export$2e2bcd8739ae039() {}

});

parcelRegister("jy52E", function(module, exports) {

$parcel$export(module.exports, "point", () => $e3b51a7e33ceb900$export$105684a3041cb6f3);
$parcel$export(module.exports, "Basis", () => $e3b51a7e33ceb900$export$957f7263e89bedd2);
$parcel$export(module.exports, "default", () => $e3b51a7e33ceb900$export$2e2bcd8739ae039);
function $e3b51a7e33ceb900$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $e3b51a7e33ceb900$export$957f7263e89bedd2(context) {
    this._context = context;
}
$e3b51a7e33ceb900$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $e3b51a7e33ceb900$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $e3b51a7e33ceb900$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $e3b51a7e33ceb900$export$2e2bcd8739ae039(context) {
    return new $e3b51a7e33ceb900$export$957f7263e89bedd2(context);
}

});


parcelRegister("87vg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e97398005d98140$export$2e2bcd8739ae039);

var $jy52E = parcelRequire("jy52E");
function $5e97398005d98140$var$BasisOpen(context) {
    this._context = context;
}
$5e97398005d98140$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $jy52E.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5e97398005d98140$export$2e2bcd8739ae039(context) {
    return new $5e97398005d98140$var$BasisOpen(context);
}

});

parcelRegister("4i7UE", function(module, exports) {

$parcel$export(module.exports, "default", () => $31fefb24caba9b72$export$2e2bcd8739ae039);

var $jy52E = parcelRequire("jy52E");
function $31fefb24caba9b72$var$Bundle(context, beta) {
    this._basis = new (0, $jy52E.Basis)(context);
    this._beta = beta;
}
$31fefb24caba9b72$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $31fefb24caba9b72$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $jy52E.Basis)(context) : new $31fefb24caba9b72$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("j1RWi", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", () => $dda7f389af511275$export$da3940d7e9162858);
$parcel$export(module.exports, "default", () => $dda7f389af511275$export$2e2bcd8739ae039);

var $dAnHq = parcelRequire("dAnHq");

var $gBRyf = parcelRequire("gBRyf");
function $dda7f389af511275$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$dda7f389af511275$export$da3940d7e9162858.prototype = {
    areaStart: (0, $dAnHq.default),
    areaEnd: (0, $dAnHq.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $gBRyf.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $dda7f389af511275$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $dda7f389af511275$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("gBRyf", function(module, exports) {

$parcel$export(module.exports, "point", () => $c179a438b7599f81$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $c179a438b7599f81$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $c179a438b7599f81$export$2e2bcd8739ae039);
function $c179a438b7599f81$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c179a438b7599f81$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c179a438b7599f81$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c179a438b7599f81$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $c179a438b7599f81$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c179a438b7599f81$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c179a438b7599f81$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("hRUWK", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", () => $d0238f4db410d9c3$export$cd7d1a617282f2f1);
$parcel$export(module.exports, "default", () => $d0238f4db410d9c3$export$2e2bcd8739ae039);

var $gBRyf = parcelRequire("gBRyf");
function $d0238f4db410d9c3$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d0238f4db410d9c3$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $gBRyf.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d0238f4db410d9c3$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $d0238f4db410d9c3$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("eJQi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $abadd4ae142d053a$export$2e2bcd8739ae039);

var $j1RWi = parcelRequire("j1RWi");

var $dAnHq = parcelRequire("dAnHq");

var $5jkgm = parcelRequire("5jkgm");
function $abadd4ae142d053a$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$abadd4ae142d053a$var$CatmullRomClosed.prototype = {
    areaStart: (0, $dAnHq.default),
    areaEnd: (0, $dAnHq.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $5jkgm.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $abadd4ae142d053a$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $abadd4ae142d053a$var$CatmullRomClosed(context, alpha) : new (0, $j1RWi.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("5jkgm", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $3dde71e76f39986c$export$2e2bcd8739ae039);

var $5O1Cf = parcelRequire("5O1Cf");

var $gBRyf = parcelRequire("gBRyf");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $5O1Cf.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $5O1Cf.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3dde71e76f39986c$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $gBRyf.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("hUBHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a4e82f9e0ffa30$export$2e2bcd8739ae039);

var $hRUWK = parcelRequire("hRUWK");

var $5jkgm = parcelRequire("5jkgm");
function $d0a4e82f9e0ffa30$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$d0a4e82f9e0ffa30$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $5jkgm.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d0a4e82f9e0ffa30$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $d0a4e82f9e0ffa30$var$CatmullRomOpen(context, alpha) : new (0, $hRUWK.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("li5VB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ffe098053ac867$export$2e2bcd8739ae039);

var $dAnHq = parcelRequire("dAnHq");
function $f7ffe098053ac867$var$LinearClosed(context) {
    this._context = context;
}
$f7ffe098053ac867$var$LinearClosed.prototype = {
    areaStart: (0, $dAnHq.default),
    areaEnd: (0, $dAnHq.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $f7ffe098053ac867$export$2e2bcd8739ae039(context) {
    return new $f7ffe098053ac867$var$LinearClosed(context);
}

});

parcelRegister("1zuK2", function(module, exports) {

$parcel$export(module.exports, "monotoneX", () => $1250e7ef84ffbcc7$export$99563b5420dbdc55);
$parcel$export(module.exports, "monotoneY", () => $1250e7ef84ffbcc7$export$8b5360456d6bdb88);
function $1250e7ef84ffbcc7$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $1250e7ef84ffbcc7$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($1250e7ef84ffbcc7$var$sign(s0) + $1250e7ef84ffbcc7$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $1250e7ef84ffbcc7$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $1250e7ef84ffbcc7$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $1250e7ef84ffbcc7$var$MonotoneX(context) {
    this._context = context;
}
$1250e7ef84ffbcc7$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $1250e7ef84ffbcc7$var$point(this, this._t0, $1250e7ef84ffbcc7$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $1250e7ef84ffbcc7$var$point(this, $1250e7ef84ffbcc7$var$slope2(this, t1 = $1250e7ef84ffbcc7$var$slope3(this, x, y)), t1);
                break;
            default:
                $1250e7ef84ffbcc7$var$point(this, this._t0, t1 = $1250e7ef84ffbcc7$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $1250e7ef84ffbcc7$var$MonotoneY(context) {
    this._context = new $1250e7ef84ffbcc7$var$ReflectContext(context);
}
($1250e7ef84ffbcc7$var$MonotoneY.prototype = Object.create($1250e7ef84ffbcc7$var$MonotoneX.prototype)).point = function(x, y) {
    $1250e7ef84ffbcc7$var$MonotoneX.prototype.point.call(this, y, x);
};
function $1250e7ef84ffbcc7$var$ReflectContext(context) {
    this._context = context;
}
$1250e7ef84ffbcc7$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $1250e7ef84ffbcc7$export$99563b5420dbdc55(context) {
    return new $1250e7ef84ffbcc7$var$MonotoneX(context);
}
function $1250e7ef84ffbcc7$export$8b5360456d6bdb88(context) {
    return new $1250e7ef84ffbcc7$var$MonotoneY(context);
}

});

parcelRegister("bS2sF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a46a59f95d84e23$export$2e2bcd8739ae039);
function $8a46a59f95d84e23$var$Natural(context) {
    this._context = context;
}
$8a46a59f95d84e23$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $8a46a59f95d84e23$var$controlPoints(x), py = $8a46a59f95d84e23$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $8a46a59f95d84e23$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $8a46a59f95d84e23$export$2e2bcd8739ae039(context) {
    return new $8a46a59f95d84e23$var$Natural(context);
}

});

parcelRegister("5xtrd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4086de99947229e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "stepBefore", () => $4086de99947229e2$export$10eafa5b7478b343);
$parcel$export(module.exports, "stepAfter", () => $4086de99947229e2$export$793b3db073781cbb);
function $4086de99947229e2$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$4086de99947229e2$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $4086de99947229e2$export$2e2bcd8739ae039(context) {
    return new $4086de99947229e2$var$Step(context, 0.5);
}
function $4086de99947229e2$export$10eafa5b7478b343(context) {
    return new $4086de99947229e2$var$Step(context, 0);
}
function $4086de99947229e2$export$793b3db073781cbb(context) {
    return new $4086de99947229e2$var$Step(context, 1);
}

});

parcelRegister("awfCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8901534066aba0$export$2e2bcd8739ae039);

var $k8DO8 = parcelRequire("k8DO8");

var $dDit9 = parcelRequire("dDit9");

var $l3lLO = parcelRequire("l3lLO");

var $16LW3 = parcelRequire("16LW3");
function $7a8901534066aba0$var$stackValue(d, key) {
    return d[key];
}
function $7a8901534066aba0$export$2e2bcd8739ae039() {
    var keys = (0, $dDit9.default)([]), order = (0, $16LW3.default), offset = (0, $l3lLO.default), value = $7a8901534066aba0$var$stackValue;
    function stack(data) {
        var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
        for(i = 0; i < n; ++i){
            for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                si[j] = sij = [
                    0,
                    +value(data[j], ki, j, data)
                ];
                sij.data = data[j];
            }
            si.key = ki;
        }
        for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $dDit9.default)((0, $k8DO8.slice).call(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dDit9.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $16LW3.default) : typeof _ === "function" ? _ : (0, $dDit9.default)((0, $k8DO8.slice).call(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $l3lLO.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("l3lLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f53ac3ddcd6c66aa$export$2e2bcd8739ae039);
function $f53ac3ddcd6c66aa$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("16LW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ceb88f87180cafc$export$2e2bcd8739ae039);
function $0ceb88f87180cafc$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("dob8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf62824e0936a0f$export$2e2bcd8739ae039);

var $l3lLO = parcelRequire("l3lLO");
function $9bf62824e0936a0f$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $l3lLO.default)(series, order);
}

});

parcelRegister("eyChT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a991f0c5c96c6f43$export$2e2bcd8739ae039);
function $a991f0c5c96c6f43$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("1b1Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db836b17b938c9f$export$2e2bcd8739ae039);

var $l3lLO = parcelRequire("l3lLO");
function $0db836b17b938c9f$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $l3lLO.default)(series, order);
}

});

parcelRegister("1MkOd", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ba6a57b499fdb1$export$2e2bcd8739ae039);

var $l3lLO = parcelRequire("l3lLO");
function $14ba6a57b499fdb1$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $l3lLO.default)(series, order);
}

});

parcelRegister("c5NgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cdc2b2d2684b57c$export$2e2bcd8739ae039);

var $16LW3 = parcelRequire("16LW3");
function $8cdc2b2d2684b57c$export$2e2bcd8739ae039(series) {
    var peaks = series.map($8cdc2b2d2684b57c$var$peak);
    return (0, $16LW3.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $8cdc2b2d2684b57c$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("9NZzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $723873705d92daca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sum", () => $723873705d92daca$export$8a63f25cc62965f1);

var $16LW3 = parcelRequire("16LW3");
function $723873705d92daca$export$2e2bcd8739ae039(series) {
    var sums = series.map($723873705d92daca$export$8a63f25cc62965f1);
    return (0, $16LW3.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $723873705d92daca$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("gZBfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5ef3cb8afc680bf$export$2e2bcd8739ae039);

var $9NZzu = parcelRequire("9NZzu");
function $c5ef3cb8afc680bf$export$2e2bcd8739ae039(series) {
    return (0, $9NZzu.default)(series).reverse();
}

});

parcelRegister("ldIUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72da5611ce155ea$export$2e2bcd8739ae039);

var $c5NgE = parcelRequire("c5NgE");

var $9NZzu = parcelRequire("9NZzu");
function $f72da5611ce155ea$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $9NZzu.sum)), order = (0, $c5NgE.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("9KY9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a711416f4e1be4$export$2e2bcd8739ae039);

var $16LW3 = parcelRequire("16LW3");
function $71a711416f4e1be4$export$2e2bcd8739ae039(series) {
    return (0, $16LW3.default)(series).reverse();
}

});


parcelRegister("zPqH5", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => (parcelRequire("4Iq8c")).default);
$parcel$export(module.exports, "timeMillisecond", () => (parcelRequire("hr5Dg")).default);
$parcel$export(module.exports, "timeMilliseconds", () => (parcelRequire("hr5Dg")).milliseconds);
$parcel$export(module.exports, "utcMillisecond", () => (parcelRequire("hr5Dg")).default);
$parcel$export(module.exports, "utcMilliseconds", () => (parcelRequire("hr5Dg")).milliseconds);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("kqr4R")).default);
$parcel$export(module.exports, "timeSeconds", () => (parcelRequire("kqr4R")).seconds);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("kqr4R")).default);
$parcel$export(module.exports, "utcSeconds", () => (parcelRequire("kqr4R")).seconds);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("hz54K")).default);
$parcel$export(module.exports, "timeMinutes", () => (parcelRequire("hz54K")).minutes);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("lY3qh")).default);
$parcel$export(module.exports, "timeHours", () => (parcelRequire("lY3qh")).hours);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("hV544")).default);
$parcel$export(module.exports, "timeDays", () => (parcelRequire("hV544")).days);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("3Jr8b")).sunday);
$parcel$export(module.exports, "timeWeeks", () => (parcelRequire("3Jr8b")).sundays);
$parcel$export(module.exports, "timeSunday", () => (parcelRequire("3Jr8b")).sunday);
$parcel$export(module.exports, "timeSundays", () => (parcelRequire("3Jr8b")).sundays);
$parcel$export(module.exports, "timeMonday", () => (parcelRequire("3Jr8b")).monday);
$parcel$export(module.exports, "timeMondays", () => (parcelRequire("3Jr8b")).mondays);
$parcel$export(module.exports, "timeTuesday", () => (parcelRequire("3Jr8b")).tuesday);
$parcel$export(module.exports, "timeTuesdays", () => (parcelRequire("3Jr8b")).tuesdays);
$parcel$export(module.exports, "timeWednesday", () => (parcelRequire("3Jr8b")).wednesday);
$parcel$export(module.exports, "timeWednesdays", () => (parcelRequire("3Jr8b")).wednesdays);
$parcel$export(module.exports, "timeThursday", () => (parcelRequire("3Jr8b")).thursday);
$parcel$export(module.exports, "timeThursdays", () => (parcelRequire("3Jr8b")).thursdays);
$parcel$export(module.exports, "timeFriday", () => (parcelRequire("3Jr8b")).friday);
$parcel$export(module.exports, "timeFridays", () => (parcelRequire("3Jr8b")).fridays);
$parcel$export(module.exports, "timeSaturday", () => (parcelRequire("3Jr8b")).saturday);
$parcel$export(module.exports, "timeSaturdays", () => (parcelRequire("3Jr8b")).saturdays);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("6R4qR")).default);
$parcel$export(module.exports, "timeMonths", () => (parcelRequire("6R4qR")).months);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("ao3mD")).default);
$parcel$export(module.exports, "timeYears", () => (parcelRequire("ao3mD")).years);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("9TFkI")).default);
$parcel$export(module.exports, "utcMinutes", () => (parcelRequire("9TFkI")).utcMinutes);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("llWB4")).default);
$parcel$export(module.exports, "utcHours", () => (parcelRequire("llWB4")).utcHours);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("43zPd")).default);
$parcel$export(module.exports, "utcDays", () => (parcelRequire("43zPd")).utcDays);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("gATo1")).utcSunday);
$parcel$export(module.exports, "utcWeeks", () => (parcelRequire("gATo1")).utcSundays);
$parcel$export(module.exports, "utcSunday", () => (parcelRequire("gATo1")).utcSunday);
$parcel$export(module.exports, "utcSundays", () => (parcelRequire("gATo1")).utcSundays);
$parcel$export(module.exports, "utcMonday", () => (parcelRequire("gATo1")).utcMonday);
$parcel$export(module.exports, "utcMondays", () => (parcelRequire("gATo1")).utcMondays);
$parcel$export(module.exports, "utcTuesday", () => (parcelRequire("gATo1")).utcTuesday);
$parcel$export(module.exports, "utcTuesdays", () => (parcelRequire("gATo1")).utcTuesdays);
$parcel$export(module.exports, "utcWednesday", () => (parcelRequire("gATo1")).utcWednesday);
$parcel$export(module.exports, "utcWednesdays", () => (parcelRequire("gATo1")).utcWednesdays);
$parcel$export(module.exports, "utcThursday", () => (parcelRequire("gATo1")).utcThursday);
$parcel$export(module.exports, "utcThursdays", () => (parcelRequire("gATo1")).utcThursdays);
$parcel$export(module.exports, "utcFriday", () => (parcelRequire("gATo1")).utcFriday);
$parcel$export(module.exports, "utcFridays", () => (parcelRequire("gATo1")).utcFridays);
$parcel$export(module.exports, "utcSaturday", () => (parcelRequire("gATo1")).utcSaturday);
$parcel$export(module.exports, "utcSaturdays", () => (parcelRequire("gATo1")).utcSaturdays);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("1eU7m")).default);
$parcel$export(module.exports, "utcMonths", () => (parcelRequire("1eU7m")).utcMonths);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("lq9oP")).default);
$parcel$export(module.exports, "utcYears", () => (parcelRequire("lq9oP")).utcYears);

var $4Iq8c = parcelRequire("4Iq8c");

var $hr5Dg = parcelRequire("hr5Dg");

var $kqr4R = parcelRequire("kqr4R");

var $hz54K = parcelRequire("hz54K");

var $lY3qh = parcelRequire("lY3qh");

var $hV544 = parcelRequire("hV544");

var $3Jr8b = parcelRequire("3Jr8b");

var $6R4qR = parcelRequire("6R4qR");

var $ao3mD = parcelRequire("ao3mD");

var $9TFkI = parcelRequire("9TFkI");

var $llWB4 = parcelRequire("llWB4");

var $43zPd = parcelRequire("43zPd");

var $gATo1 = parcelRequire("gATo1");

var $1eU7m = parcelRequire("1eU7m");

var $lq9oP = parcelRequire("lq9oP");

});

parcelRegister("gHshw", function(module, exports) {

$parcel$export(module.exports, "timeFormatDefaultLocale", () => (parcelRequire("harJx")).default);
$parcel$export(module.exports, "timeFormat", () => (parcelRequire("harJx")).timeFormat);
$parcel$export(module.exports, "timeParse", () => (parcelRequire("harJx")).timeParse);
$parcel$export(module.exports, "utcFormat", () => (parcelRequire("harJx")).utcFormat);
$parcel$export(module.exports, "utcParse", () => (parcelRequire("harJx")).utcParse);
$parcel$export(module.exports, "timeFormatLocale", () => (parcelRequire("dEXnN")).default);
$parcel$export(module.exports, "isoFormat", () => (parcelRequire("411ws")).default);
$parcel$export(module.exports, "isoParse", () => (parcelRequire("5wOMW")).default);

var $harJx = parcelRequire("harJx");

var $dEXnN = parcelRequire("dEXnN");

var $411ws = parcelRequire("411ws");

var $5wOMW = parcelRequire("5wOMW");

});
parcelRegister("411ws", function(module, exports) {

$parcel$export(module.exports, "isoSpecifier", () => $2ec86fbe9b7f1236$export$491f7bf2e88d83ce);
$parcel$export(module.exports, "default", () => $2ec86fbe9b7f1236$export$2e2bcd8739ae039);

var $harJx = parcelRequire("harJx");
var $2ec86fbe9b7f1236$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $2ec86fbe9b7f1236$var$formatIsoNative(date) {
    return date.toISOString();
}
var $2ec86fbe9b7f1236$var$formatIso = Date.prototype.toISOString ? $2ec86fbe9b7f1236$var$formatIsoNative : (0, $harJx.utcFormat)($2ec86fbe9b7f1236$export$491f7bf2e88d83ce);
var $2ec86fbe9b7f1236$export$2e2bcd8739ae039 = $2ec86fbe9b7f1236$var$formatIso;

});

parcelRegister("5wOMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $40675670e7407e3f$export$2e2bcd8739ae039);

var $411ws = parcelRequire("411ws");

var $harJx = parcelRequire("harJx");
function $40675670e7407e3f$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $40675670e7407e3f$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $40675670e7407e3f$var$parseIsoNative : (0, $harJx.utcParse)((0, $411ws.isoSpecifier));
var $40675670e7407e3f$export$2e2bcd8739ae039 = $40675670e7407e3f$var$parseIso;

});


parcelRegister("4y3tC", function(module, exports) {

$parcel$export(module.exports, "now", () => (parcelRequire("5hwOF")).now);
$parcel$export(module.exports, "timer", () => (parcelRequire("5hwOF")).timer);
$parcel$export(module.exports, "timerFlush", () => (parcelRequire("5hwOF")).timerFlush);
$parcel$export(module.exports, "timeout", () => (parcelRequire("fF74h")).default);
$parcel$export(module.exports, "interval", () => (parcelRequire("drxbM")).default);

var $5hwOF = parcelRequire("5hwOF");

var $fF74h = parcelRequire("fF74h");

var $drxbM = parcelRequire("drxbM");

});
parcelRegister("drxbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c978a9912bb3c03$export$2e2bcd8739ae039);

var $5hwOF = parcelRequire("5hwOF");
function $9c978a9912bb3c03$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $5hwOF.Timer), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    delay = +delay, time = time == null ? (0, $5hwOF.now)() : +time;
    t.restart(function tick(elapsed) {
        elapsed += total;
        t.restart(tick, total += delay, time);
        callback(elapsed);
    }, delay, time);
    return t;
}

});


parcelRegister("iMyMP", function(module, exports) {

$parcel$export(module.exports, "voronoi", () => (parcelRequire("5MkZl")).default);

var $5MkZl = parcelRequire("5MkZl");

});
parcelRegister("5MkZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4351b74debc58638$export$2e2bcd8739ae039);

var $c0wTy = parcelRequire("c0wTy");

var $k5dkv = parcelRequire("k5dkv");

var $gdiNw = parcelRequire("gdiNw");
function $4351b74debc58638$export$2e2bcd8739ae039() {
    var x = (0, $k5dkv.x), y = (0, $k5dkv.y), extent = null;
    function voronoi(data) {
        return new (0, $gdiNw.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $gdiNw.epsilon)) * (0, $gdiNw.epsilon),
                Math.round(y(d, i, data) / (0, $gdiNw.epsilon)) * (0, $gdiNw.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $c0wTy.default)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $c0wTy.default)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}

});
parcelRegister("c0wTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bdf00601dad4f96$export$2e2bcd8739ae039);
function $8bdf00601dad4f96$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("k5dkv", function(module, exports) {

$parcel$export(module.exports, "x", () => $e9ee9d4ccc522090$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $e9ee9d4ccc522090$export$4a5767248b18ef41);
function $e9ee9d4ccc522090$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $e9ee9d4ccc522090$export$4a5767248b18ef41(d) {
    return d[1];
}

});

parcelRegister("gdiNw", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => epsilon);
$parcel$export(module.exports, "epsilon2", () => epsilon2);
$parcel$export(module.exports, "beaches", () => beaches);
$parcel$export(module.exports, "cells", () => cells);
$parcel$export(module.exports, "circles", () => circles);
$parcel$export(module.exports, "edges", () => edges);
$parcel$export(module.exports, "default", () => Diagram);

var $fYMsn = parcelRequire("fYMsn");

var $3UQkD = parcelRequire("3UQkD");

var $hqrkT = parcelRequire("hqrkT");

var $4PEXg = parcelRequire("4PEXg");

var $1Kby6 = parcelRequire("1Kby6");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $1Kby6.default);
    circles = new (0, $1Kby6.default);
    while(true){
        circle = (0, $hqrkT.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $fYMsn.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $fYMsn.removeBeach)(circle.arc);
        else break;
    }
    (0, $3UQkD.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $4PEXg.clipEdges)(x0, y0, x1, y1);
        (0, $3UQkD.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $3UQkD.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("fYMsn", function(module, exports) {

$parcel$export(module.exports, "removeBeach", () => $ba220c1c099761c3$export$25be321a9b2d3c3c);
$parcel$export(module.exports, "addBeach", () => $ba220c1c099761c3$export$fec167a219592370);

var $1Kby6 = parcelRequire("1Kby6");

var $3UQkD = parcelRequire("3UQkD");

var $hqrkT = parcelRequire("hqrkT");

var $4PEXg = parcelRequire("4PEXg");

var $gdiNw = parcelRequire("gdiNw");
var $ba220c1c099761c3$var$beachPool = [];
function $ba220c1c099761c3$var$Beach() {
    (0, $1Kby6.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $ba220c1c099761c3$var$createBeach(site) {
    var beach = $ba220c1c099761c3$var$beachPool.pop() || new $ba220c1c099761c3$var$Beach;
    beach.site = site;
    return beach;
}
function $ba220c1c099761c3$var$detachBeach(beach) {
    (0, $hqrkT.detachCircle)(beach);
    (0, $gdiNw.beaches).remove(beach);
    $ba220c1c099761c3$var$beachPool.push(beach);
    (0, $1Kby6.RedBlackNode)(beach);
}
function $ba220c1c099761c3$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $ba220c1c099761c3$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $gdiNw.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $gdiNw.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $ba220c1c099761c3$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $hqrkT.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $gdiNw.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $gdiNw.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $ba220c1c099761c3$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $hqrkT.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $4PEXg.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $4PEXg.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $hqrkT.attachCircle)(lArc);
    (0, $hqrkT.attachCircle)(rArc);
}
function $ba220c1c099761c3$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $gdiNw.beaches)._;
    while(node){
        dxl = $ba220c1c099761c3$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $gdiNw.epsilon)) node = node.L;
        else {
            dxr = x - $ba220c1c099761c3$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $gdiNw.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $gdiNw.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $gdiNw.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $3UQkD.createCell)(site);
    var newArc = $ba220c1c099761c3$var$createBeach(site);
    (0, $gdiNw.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $hqrkT.detachCircle)(lArc);
        rArc = $ba220c1c099761c3$var$createBeach(lArc.site);
        (0, $gdiNw.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $4PEXg.createEdge)(lArc.site, newArc.site);
        (0, $hqrkT.attachCircle)(lArc);
        (0, $hqrkT.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $4PEXg.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $hqrkT.detachCircle)(lArc);
    (0, $hqrkT.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $4PEXg.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $4PEXg.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $4PEXg.createEdge)(site, rSite, null, vertex);
    (0, $hqrkT.attachCircle)(lArc);
    (0, $hqrkT.attachCircle)(rArc);
}
function $ba220c1c099761c3$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $ba220c1c099761c3$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $ba220c1c099761c3$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("1Kby6", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", () => $14530bb5b2a4c3db$export$5072552a5e64b90a);
$parcel$export(module.exports, "default", () => $14530bb5b2a4c3db$export$2e2bcd8739ae039);
function $14530bb5b2a4c3db$var$RedBlackTree() {
    this._ = null; // root node
}
function $14530bb5b2a4c3db$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$14530bb5b2a4c3db$var$RedBlackTree.prototype = {
    constructor: $14530bb5b2a4c3db$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $14530bb5b2a4c3db$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $14530bb5b2a4c3db$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $14530bb5b2a4c3db$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $14530bb5b2a4c3db$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $14530bb5b2a4c3db$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $14530bb5b2a4c3db$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $14530bb5b2a4c3db$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $14530bb5b2a4c3db$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $14530bb5b2a4c3db$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $14530bb5b2a4c3db$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $14530bb5b2a4c3db$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $14530bb5b2a4c3db$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $14530bb5b2a4c3db$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $14530bb5b2a4c3db$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $14530bb5b2a4c3db$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $14530bb5b2a4c3db$export$2e2bcd8739ae039 = $14530bb5b2a4c3db$var$RedBlackTree;

});

parcelRegister("3UQkD", function(module, exports) {

$parcel$export(module.exports, "createCell", () => $2d9f32140e33ed70$export$3cb21b6b1233300e);
$parcel$export(module.exports, "cellHalfedgeStart", () => $2d9f32140e33ed70$export$67c16aa967774be);
$parcel$export(module.exports, "sortCellHalfedges", () => $2d9f32140e33ed70$export$41888d88cbc31210);
$parcel$export(module.exports, "clipCells", () => $2d9f32140e33ed70$export$cdcebd68073bc3f);

var $4PEXg = parcelRequire("4PEXg");

var $gdiNw = parcelRequire("gdiNw");
function $2d9f32140e33ed70$export$3cb21b6b1233300e(site) {
    return (0, $gdiNw.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $2d9f32140e33ed70$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $2d9f32140e33ed70$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $2d9f32140e33ed70$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $2d9f32140e33ed70$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $gdiNw.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $gdiNw.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $2d9f32140e33ed70$var$cellHalfedgeAngle(cell, (0, $gdiNw.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $2d9f32140e33ed70$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $gdiNw.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $gdiNw.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $gdiNw.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $2d9f32140e33ed70$export$bf8e581ba65a00a5(cell, (0, $gdiNw.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $2d9f32140e33ed70$export$67c16aa967774be(cell, (0, $gdiNw.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $gdiNw.epsilon) || Math.abs(endY - startY) > (0, $gdiNw.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $gdiNw.edges).push((0, $4PEXg.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $gdiNw.epsilon) && y1 - endY > (0, $gdiNw.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $gdiNw.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $gdiNw.epsilon) && x1 - endX > (0, $gdiNw.epsilon) ? [
                    Math.abs(startY - y1) < (0, $gdiNw.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $gdiNw.epsilon) && endY - y0 > (0, $gdiNw.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $gdiNw.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $gdiNw.epsilon) && endX - x0 > (0, $gdiNw.epsilon) ? [
                    Math.abs(startY - y0) < (0, $gdiNw.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $gdiNw.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $gdiNw.edges).push((0, $4PEXg.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $gdiNw.edges).push((0, $4PEXg.createBorderEdge)(site, v01, v11)) - 1, (0, $gdiNw.edges).push((0, $4PEXg.createBorderEdge)(site, v11, v10)) - 1, (0, $gdiNw.edges).push((0, $4PEXg.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $gdiNw.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $gdiNw.cells)[iCell];
        }
    }
}

});
parcelRegister("4PEXg", function(module, exports) {

$parcel$export(module.exports, "createEdge", () => $384bb19abab0f560$export$bdd941b9b8806569);
$parcel$export(module.exports, "setEdgeEnd", () => $384bb19abab0f560$export$9e883caea829cb44);
$parcel$export(module.exports, "createBorderEdge", () => $384bb19abab0f560$export$681cc0bbec712be1);
$parcel$export(module.exports, "clipEdges", () => $384bb19abab0f560$export$db4502aa9c1617af);

var $gdiNw = parcelRequire("gdiNw");
function $384bb19abab0f560$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $gdiNw.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $384bb19abab0f560$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $384bb19abab0f560$export$9e883caea829cb44(edge, right, left, v1);
    (0, $gdiNw.cells)[left.index].halfedges.push(index);
    (0, $gdiNw.cells)[right.index].halfedges.push(index);
    return edge;
}
function $384bb19abab0f560$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $384bb19abab0f560$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $384bb19abab0f560$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $384bb19abab0f560$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $384bb19abab0f560$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $gdiNw.edges).length, edge;
    while(i--)if (!$384bb19abab0f560$var$connectEdge(edge = (0, $gdiNw.edges)[i], x0, y0, x1, y1) || !$384bb19abab0f560$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $gdiNw.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $gdiNw.epsilon))) delete (0, $gdiNw.edges)[i];
}

});


parcelRegister("hqrkT", function(module, exports) {

$parcel$export(module.exports, "firstCircle", () => $cafa11bbdba49e7a$export$2ca650a30b282a37);
$parcel$export(module.exports, "attachCircle", () => $cafa11bbdba49e7a$export$2a19333f6373b7a2);
$parcel$export(module.exports, "detachCircle", () => $cafa11bbdba49e7a$export$f0bd50ff687673c1);

var $1Kby6 = parcelRequire("1Kby6");

var $gdiNw = parcelRequire("gdiNw");
var $cafa11bbdba49e7a$var$circlePool = [];
var $cafa11bbdba49e7a$export$2ca650a30b282a37;
function $cafa11bbdba49e7a$var$Circle() {
    (0, $1Kby6.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $cafa11bbdba49e7a$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $gdiNw.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $cafa11bbdba49e7a$var$circlePool.pop() || new $cafa11bbdba49e7a$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $gdiNw.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $gdiNw.circles).insert(before, circle);
    if (!before) $cafa11bbdba49e7a$export$2ca650a30b282a37 = circle;
}
function $cafa11bbdba49e7a$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $cafa11bbdba49e7a$export$2ca650a30b282a37 = circle.N;
        (0, $gdiNw.circles).remove(circle);
        $cafa11bbdba49e7a$var$circlePool.push(circle);
        (0, $1Kby6.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});





parcelRegister("kO7Mc", function(module, exports) {

$parcel$export(module.exports, "zoom", () => (parcelRequire("lyhXM")).default);
$parcel$export(module.exports, "zoomTransform", () => (parcelRequire("lHll8")).default);
$parcel$export(module.exports, "zoomIdentity", () => (parcelRequire("lHll8")).identity);

var $lyhXM = parcelRequire("lyhXM");

var $lHll8 = parcelRequire("lHll8");

});
parcelRegister("lyhXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb0ab515596f390a$export$2e2bcd8739ae039);

var $4h5V5 = parcelRequire("4h5V5");

var $kza96 = parcelRequire("kza96");

var $5lXLL = parcelRequire("5lXLL");

var $e5rGV = parcelRequire("e5rGV");
var $eX1M2 = parcelRequire("eX1M2");
var $kmZ55 = parcelRequire("kmZ55");
var $eZ35f = parcelRequire("eZ35f");
parcelRequire("lshu4");
var $4zBBK = parcelRequire("4zBBK");

var $k7k9Z = parcelRequire("k7k9Z");

var $6fQqd = parcelRequire("6fQqd");

var $lHll8 = parcelRequire("lHll8");

var $aJROE = parcelRequire("aJROE");
// Ignore right-click, since that should open the context menu.
function $fb0ab515596f390a$var$defaultFilter() {
    return !(0, $e5rGV.event).ctrlKey && !(0, $e5rGV.event).button;
}
function $fb0ab515596f390a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $fb0ab515596f390a$var$defaultTransform() {
    return this.__zoom || (0, $lHll8.identity);
}
function $fb0ab515596f390a$var$defaultWheelDelta() {
    return -(0, $e5rGV.event).deltaY * ((0, $e5rGV.event).deltaMode === 1 ? 0.05 : (0, $e5rGV.event).deltaMode ? 1 : 0.002);
}
function $fb0ab515596f390a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $fb0ab515596f390a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $fb0ab515596f390a$export$2e2bcd8739ae039() {
    var filter = $fb0ab515596f390a$var$defaultFilter, extent = $fb0ab515596f390a$var$defaultExtent, constrain = $fb0ab515596f390a$var$defaultConstrain, wheelDelta = $fb0ab515596f390a$var$defaultWheelDelta, touchable = $fb0ab515596f390a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $5lXLL.default), listeners = (0, $4h5V5.default)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $fb0ab515596f390a$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $fb0ab515596f390a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p);
    };
    zoom.scaleTo = function(selection, k, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p);
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $lHll8.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $lHll8.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $lHll8.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $lHll8.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $e5rGV.customEvent)(new (0, $6fQqd.default)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $eX1M2.default)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $4zBBK.default)(this);
            g.start();
        }
        (0, $aJROE.default)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments, true), v = (0, $kmZ55.default)((0, $e5rGV.event).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $eX1M2.default)(this), x0 = (0, $e5rGV.event).clientX, y0 = (0, $e5rGV.event).clientY;
        (0, $kza96.default)((0, $e5rGV.event).view);
        (0, $aJROE.nopropagation)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $4zBBK.default)(this);
        g.start();
        function mousemoved() {
            (0, $aJROE.default)();
            if (!g.moved) {
                var dx = (0, $e5rGV.event).clientX - x0, dy = (0, $e5rGV.event).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $eX1M2.default)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $kza96.yesdrag)((0, $e5rGV.event).view, g.moved);
            (0, $aJROE.default)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $eX1M2.default)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $e5rGV.event).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $aJROE.default)();
        if (duration > 0) (0, $kmZ55.default)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $kmZ55.default)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $e5rGV.event).touches, n = touches.length, g = gesture(this, arguments, (0, $e5rGV.event).changedTouches.length === n), started, i, t, p;
        (0, $aJROE.nopropagation)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $eZ35f.default)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $4zBBK.default)(this);
            g.start();
        }
    }
    function touchmoved() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $e5rGV.event).changedTouches, n = touches.length, i, t, p, l;
        (0, $aJROE.default)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        g.taps = 0;
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $eZ35f.default)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $e5rGV.event).changedTouches, n = touches.length, i, t;
        (0, $aJROE.nopropagation)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                var p = (0, $kmZ55.default)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $k7k9Z.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $k7k9Z.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $k7k9Z.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $k7k9Z.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}

});
parcelRegister("e5rGV", function(module, exports) {

$parcel$export(module.exports, "event", () => $a4170344759ffcbe$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $a4170344759ffcbe$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $a4170344759ffcbe$export$4c724631b4750aef);
var $a4170344759ffcbe$var$filterEvents = {};
var $a4170344759ffcbe$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $a4170344759ffcbe$var$element = document.documentElement;
    if (!("onmouseenter" in $a4170344759ffcbe$var$element)) $a4170344759ffcbe$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $a4170344759ffcbe$var$filterContextListener(listener, index, group) {
    listener = $a4170344759ffcbe$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $a4170344759ffcbe$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $a4170344759ffcbe$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $a4170344759ffcbe$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $a4170344759ffcbe$export$6cd530ed55e06764 = event0;
        }
    };
}
function $a4170344759ffcbe$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $a4170344759ffcbe$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $a4170344759ffcbe$var$onAdd(typename, value, capture) {
    var wrap = $a4170344759ffcbe$var$filterEvents.hasOwnProperty(typename.type) ? $a4170344759ffcbe$var$filterContextListener : $a4170344759ffcbe$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $a4170344759ffcbe$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $a4170344759ffcbe$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $a4170344759ffcbe$var$onAdd : $a4170344759ffcbe$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $a4170344759ffcbe$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $a4170344759ffcbe$export$6cd530ed55e06764;
    event1.sourceEvent = $a4170344759ffcbe$export$6cd530ed55e06764;
    $a4170344759ffcbe$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $a4170344759ffcbe$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("eX1M2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae27f3a21aa2ad66$export$2e2bcd8739ae039);

var $i65mF = parcelRequire("i65mF");

var $8ggsK = parcelRequire("8ggsK");
function $ae27f3a21aa2ad66$export$2e2bcd8739ae039(node) {
    var event = (0, $i65mF.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $8ggsK.default)(node, event);
}

});
parcelRegister("i65mF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ccf2da8f8d2337$export$2e2bcd8739ae039);

var $e5rGV = parcelRequire("e5rGV");
function $d2ccf2da8f8d2337$export$2e2bcd8739ae039() {
    var current = (0, $e5rGV.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("8ggsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $603c9683a6235200$export$2e2bcd8739ae039);
function $603c9683a6235200$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("kmZ55", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed453e2273573d2c$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");
function $ed453e2273573d2c$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $kBIy1.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $kBIy1.Selection)([
        [
            selector
        ]
    ], (0, $kBIy1.root));
}

});
parcelRegister("kBIy1", function(module, exports) {

$parcel$export(module.exports, "root", () => $f009d19ad7503979$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $f009d19ad7503979$export$52baac22726c72bf);

var $5h7Sm = parcelRequire("5h7Sm");

var $jEabq = parcelRequire("jEabq");

var $7XkN9 = parcelRequire("7XkN9");

var $eykXZ = parcelRequire("eykXZ");

var $czIbC = parcelRequire("czIbC");

var $gomwe = parcelRequire("gomwe");

var $geOhD = parcelRequire("geOhD");

var $ij8rH = parcelRequire("ij8rH");

var $lcUXX = parcelRequire("lcUXX");

var $84Yb6 = parcelRequire("84Yb6");

var $1lbc8 = parcelRequire("1lbc8");

var $9Zi7w = parcelRequire("9Zi7w");

var $kfjzm = parcelRequire("kfjzm");

var $dNETS = parcelRequire("dNETS");

var $8JvsF = parcelRequire("8JvsF");

var $3G1w9 = parcelRequire("3G1w9");

var $hE1ve = parcelRequire("hE1ve");

var $1rarN = parcelRequire("1rarN");

var $5gLGZ = parcelRequire("5gLGZ");

var $dFg8b = parcelRequire("dFg8b");

var $cMIWZ = parcelRequire("cMIWZ");

var $h47Pf = parcelRequire("h47Pf");

var $jMEDV = parcelRequire("jMEDV");

var $83CwP = parcelRequire("83CwP");

var $177Xn = parcelRequire("177Xn");

var $9Wj7t = parcelRequire("9Wj7t");

var $emivF = parcelRequire("emivF");

var $hDO5b = parcelRequire("hDO5b");

var $kQgKM = parcelRequire("kQgKM");

var $e5rGV = parcelRequire("e5rGV");

var $4Zt4f = parcelRequire("4Zt4f");
var $f009d19ad7503979$export$e8e78c978b129247 = [
    null
];
function $f009d19ad7503979$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $f009d19ad7503979$var$selection() {
    return new $f009d19ad7503979$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $f009d19ad7503979$export$e8e78c978b129247);
}
$f009d19ad7503979$export$52baac22726c72bf.prototype = $f009d19ad7503979$var$selection.prototype = {
    constructor: $f009d19ad7503979$export$52baac22726c72bf,
    select: (0, $5h7Sm.default),
    selectAll: (0, $jEabq.default),
    filter: (0, $7XkN9.default),
    data: (0, $eykXZ.default),
    enter: (0, $czIbC.default),
    exit: (0, $gomwe.default),
    join: (0, $geOhD.default),
    merge: (0, $ij8rH.default),
    order: (0, $lcUXX.default),
    sort: (0, $84Yb6.default),
    call: (0, $1lbc8.default),
    nodes: (0, $9Zi7w.default),
    node: (0, $kfjzm.default),
    size: (0, $dNETS.default),
    empty: (0, $8JvsF.default),
    each: (0, $3G1w9.default),
    attr: (0, $hE1ve.default),
    style: (0, $1rarN.default),
    property: (0, $5gLGZ.default),
    classed: (0, $dFg8b.default),
    text: (0, $cMIWZ.default),
    html: (0, $h47Pf.default),
    raise: (0, $jMEDV.default),
    lower: (0, $83CwP.default),
    append: (0, $177Xn.default),
    insert: (0, $9Wj7t.default),
    remove: (0, $emivF.default),
    clone: (0, $hDO5b.default),
    datum: (0, $kQgKM.default),
    on: (0, $e5rGV.default),
    dispatch: (0, $4Zt4f.default)
};
var $f009d19ad7503979$export$2e2bcd8739ae039 = $f009d19ad7503979$var$selection;

});
parcelRegister("5h7Sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d74a63a2bafefe4$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");

var $VWias = parcelRequire("VWias");
function $3d74a63a2bafefe4$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $VWias.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $kBIy1.Selection)(subgroups, this._parents);
}

});
parcelRegister("VWias", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae28a918c4beaa6$export$2e2bcd8739ae039);
function $0ae28a918c4beaa6$var$none() {}
function $0ae28a918c4beaa6$export$2e2bcd8739ae039(selector) {
    return selector == null ? $0ae28a918c4beaa6$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("jEabq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d9a6e96cfcb69e$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");

var $2lDRQ = parcelRequire("2lDRQ");
function $e4d9a6e96cfcb69e$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $2lDRQ.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $kBIy1.Selection)(subgroups, parents);
}

});
parcelRegister("2lDRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5c77cf255a56fd$export$2e2bcd8739ae039);
function $1b5c77cf255a56fd$var$empty() {
    return [];
}
function $1b5c77cf255a56fd$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1b5c77cf255a56fd$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("7XkN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cae2be0894ef766$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");

var $3Avsh = parcelRequire("3Avsh");
function $5cae2be0894ef766$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $3Avsh.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $kBIy1.Selection)(subgroups, this._parents);
}

});
parcelRegister("3Avsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $29cd223babb3fbf4$export$2e2bcd8739ae039);
function $29cd223babb3fbf4$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("eykXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9848130d786b7a9$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");

var $czIbC = parcelRequire("czIbC");

var $lbPHs = parcelRequire("lbPHs");
var $a9848130d786b7a9$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $a9848130d786b7a9$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $czIbC.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $a9848130d786b7a9$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $a9848130d786b7a9$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $a9848130d786b7a9$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $czIbC.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $a9848130d786b7a9$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $a9848130d786b7a9$var$bindKey : $a9848130d786b7a9$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $lbPHs.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $kBIy1.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("czIbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $927b07681630d60a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $927b07681630d60a$export$67b01759a14cf6a4);

var $4XphF = parcelRequire("4XphF");

var $kBIy1 = parcelRequire("kBIy1");
function $927b07681630d60a$export$2e2bcd8739ae039() {
    return new (0, $kBIy1.Selection)(this._enter || this._groups.map((0, $4XphF.default)), this._parents);
}
function $927b07681630d60a$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$927b07681630d60a$export$67b01759a14cf6a4.prototype = {
    constructor: $927b07681630d60a$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("4XphF", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c048fef2f9b376$export$2e2bcd8739ae039);
function $39c048fef2f9b376$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("lbPHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d2ba966a86f2a2$export$2e2bcd8739ae039);
function $f6d2ba966a86f2a2$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("gomwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef05b0099869e56$export$2e2bcd8739ae039);

var $4XphF = parcelRequire("4XphF");

var $kBIy1 = parcelRequire("kBIy1");
function $bef05b0099869e56$export$2e2bcd8739ae039() {
    return new (0, $kBIy1.Selection)(this._exit || this._groups.map((0, $4XphF.default)), this._parents);
}

});

parcelRegister("geOhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd24f5639d88ca0e$export$2e2bcd8739ae039);
function $bd24f5639d88ca0e$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("ij8rH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5408d7c41bd2535$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");
function $d5408d7c41bd2535$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $kBIy1.Selection)(merges, this._parents);
}

});

parcelRegister("lcUXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f706e83860741fb0$export$2e2bcd8739ae039);
function $f706e83860741fb0$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("84Yb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e1d608c444c8cd4$export$2e2bcd8739ae039);

var $kBIy1 = parcelRequire("kBIy1");
function $5e1d608c444c8cd4$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $5e1d608c444c8cd4$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $kBIy1.Selection)(sortgroups, this._parents).order();
}
function $5e1d608c444c8cd4$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1lbc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa06fabef8b4e63$export$2e2bcd8739ae039);
function $0fa06fabef8b4e63$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("9Zi7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7457dddf0854225a$export$2e2bcd8739ae039);
function $7457dddf0854225a$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("kfjzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebd46368cee6a624$export$2e2bcd8739ae039);
function $ebd46368cee6a624$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("dNETS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0bf93eb6655d4ff$export$2e2bcd8739ae039);
function $a0bf93eb6655d4ff$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("8JvsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $65baee4498a6b6f8$export$2e2bcd8739ae039);
function $65baee4498a6b6f8$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("3G1w9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad678b9458aff09$export$2e2bcd8739ae039);
function $2ad678b9458aff09$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("hE1ve", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd87568163e82955$export$2e2bcd8739ae039);

var $YAd25 = parcelRequire("YAd25");
function $cd87568163e82955$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $cd87568163e82955$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $cd87568163e82955$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $cd87568163e82955$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $cd87568163e82955$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $cd87568163e82955$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $cd87568163e82955$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $YAd25.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $cd87568163e82955$var$attrRemoveNS : $cd87568163e82955$var$attrRemove : typeof value === "function" ? fullname.local ? $cd87568163e82955$var$attrFunctionNS : $cd87568163e82955$var$attrFunction : fullname.local ? $cd87568163e82955$var$attrConstantNS : $cd87568163e82955$var$attrConstant)(fullname, value));
}

});
parcelRegister("YAd25", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b61b11af752e868$export$2e2bcd8739ae039);

var $b6RAy = parcelRequire("b6RAy");
function $0b61b11af752e868$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $b6RAy.default).hasOwnProperty(prefix) ? {
        space: (0, $b6RAy.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("b6RAy", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $8169d2d18fd52e1e$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $8169d2d18fd52e1e$export$2e2bcd8739ae039);
var $8169d2d18fd52e1e$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $8169d2d18fd52e1e$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $8169d2d18fd52e1e$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("1rarN", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c06ab3918fbd05$export$2e2bcd8739ae039);

var $2Ppay = parcelRequire("2Ppay");
function $10c06ab3918fbd05$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $10c06ab3918fbd05$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $10c06ab3918fbd05$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $10c06ab3918fbd05$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $10c06ab3918fbd05$var$styleRemove : typeof value === "function" ? $10c06ab3918fbd05$var$styleFunction : $10c06ab3918fbd05$var$styleConstant)(name, value, priority == null ? "" : priority)) : $10c06ab3918fbd05$export$5e3cec964f0b5efd(this.node(), name);
}
function $10c06ab3918fbd05$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $2Ppay.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("2Ppay", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f3de4c96591a5e$export$2e2bcd8739ae039);
function $20f3de4c96591a5e$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("5gLGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d63711098b78a19$export$2e2bcd8739ae039);
function $3d63711098b78a19$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $3d63711098b78a19$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $3d63711098b78a19$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $3d63711098b78a19$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $3d63711098b78a19$var$propertyRemove : typeof value === "function" ? $3d63711098b78a19$var$propertyFunction : $3d63711098b78a19$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("dFg8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2b9dff3fc58412$export$2e2bcd8739ae039);
function $9f2b9dff3fc58412$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $9f2b9dff3fc58412$var$classList(node) {
    return node.classList || new $9f2b9dff3fc58412$var$ClassList(node);
}
function $9f2b9dff3fc58412$var$ClassList(node) {
    this._node = node;
    this._names = $9f2b9dff3fc58412$var$classArray(node.getAttribute("class") || "");
}
$9f2b9dff3fc58412$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $9f2b9dff3fc58412$var$classedAdd(node, names) {
    var list = $9f2b9dff3fc58412$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $9f2b9dff3fc58412$var$classedRemove(node, names) {
    var list = $9f2b9dff3fc58412$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $9f2b9dff3fc58412$var$classedTrue(names) {
    return function() {
        $9f2b9dff3fc58412$var$classedAdd(this, names);
    };
}
function $9f2b9dff3fc58412$var$classedFalse(names) {
    return function() {
        $9f2b9dff3fc58412$var$classedRemove(this, names);
    };
}
function $9f2b9dff3fc58412$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $9f2b9dff3fc58412$var$classedAdd : $9f2b9dff3fc58412$var$classedRemove)(this, names);
    };
}
function $9f2b9dff3fc58412$export$2e2bcd8739ae039(name, value) {
    var names = $9f2b9dff3fc58412$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $9f2b9dff3fc58412$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $9f2b9dff3fc58412$var$classedFunction : value ? $9f2b9dff3fc58412$var$classedTrue : $9f2b9dff3fc58412$var$classedFalse)(names, value));
}

});

parcelRegister("cMIWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $94ecd5f54ef5383a$export$2e2bcd8739ae039);
function $94ecd5f54ef5383a$var$textRemove() {
    this.textContent = "";
}
function $94ecd5f54ef5383a$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $94ecd5f54ef5383a$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $94ecd5f54ef5383a$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $94ecd5f54ef5383a$var$textRemove : (typeof value === "function" ? $94ecd5f54ef5383a$var$textFunction : $94ecd5f54ef5383a$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("h47Pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6c8e160381add23$export$2e2bcd8739ae039);
function $c6c8e160381add23$var$htmlRemove() {
    this.innerHTML = "";
}
function $c6c8e160381add23$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c6c8e160381add23$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c6c8e160381add23$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c6c8e160381add23$var$htmlRemove : (typeof value === "function" ? $c6c8e160381add23$var$htmlFunction : $c6c8e160381add23$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("jMEDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e67206dca4c4edac$export$2e2bcd8739ae039);
function $e67206dca4c4edac$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $e67206dca4c4edac$export$2e2bcd8739ae039() {
    return this.each($e67206dca4c4edac$var$raise);
}

});

parcelRegister("83CwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddc7d7ceb22194b$export$2e2bcd8739ae039);
function $5ddc7d7ceb22194b$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $5ddc7d7ceb22194b$export$2e2bcd8739ae039() {
    return this.each($5ddc7d7ceb22194b$var$lower);
}

});

parcelRegister("177Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfc9dedc513b5fe$export$2e2bcd8739ae039);

var $asWpo = parcelRequire("asWpo");
function $0cfc9dedc513b5fe$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $asWpo.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("asWpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f76261a1d8118b$export$2e2bcd8739ae039);

var $YAd25 = parcelRequire("YAd25");

var $b6RAy = parcelRequire("b6RAy");
function $01f76261a1d8118b$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $b6RAy.xhtml) && document.documentElement.namespaceURI === (0, $b6RAy.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $01f76261a1d8118b$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $01f76261a1d8118b$export$2e2bcd8739ae039(name) {
    var fullname = (0, $YAd25.default)(name);
    return (fullname.local ? $01f76261a1d8118b$var$creatorFixed : $01f76261a1d8118b$var$creatorInherit)(fullname);
}

});


parcelRegister("9Wj7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c85c96f1763178$export$2e2bcd8739ae039);

var $asWpo = parcelRequire("asWpo");

var $VWias = parcelRequire("VWias");
function $73c85c96f1763178$var$constantNull() {
    return null;
}
function $73c85c96f1763178$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $asWpo.default)(name), select = before == null ? $73c85c96f1763178$var$constantNull : typeof before === "function" ? before : (0, $VWias.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("emivF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7417a64317cdb17$export$2e2bcd8739ae039);
function $a7417a64317cdb17$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $a7417a64317cdb17$export$2e2bcd8739ae039() {
    return this.each($a7417a64317cdb17$var$remove);
}

});

parcelRegister("hDO5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd7ced8872caec35$export$2e2bcd8739ae039);
function $cd7ced8872caec35$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $cd7ced8872caec35$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $cd7ced8872caec35$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $cd7ced8872caec35$var$selection_cloneDeep : $cd7ced8872caec35$var$selection_cloneShallow);
}

});

parcelRegister("kQgKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c5a8e4a197dd72$export$2e2bcd8739ae039);
function $f2c5a8e4a197dd72$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("4Zt4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a23681ccfb0267a$export$2e2bcd8739ae039);

var $2Ppay = parcelRequire("2Ppay");
function $3a23681ccfb0267a$var$dispatchEvent(node, type, params) {
    var window = (0, $2Ppay.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3a23681ccfb0267a$var$dispatchConstant(type, params) {
    return function() {
        return $3a23681ccfb0267a$var$dispatchEvent(this, type, params);
    };
}
function $3a23681ccfb0267a$var$dispatchFunction(type, params) {
    return function() {
        return $3a23681ccfb0267a$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3a23681ccfb0267a$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3a23681ccfb0267a$var$dispatchFunction : $3a23681ccfb0267a$var$dispatchConstant)(type, params));
}

});



parcelRegister("eZ35f", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae8927841c815837$export$2e2bcd8739ae039);

var $i65mF = parcelRequire("i65mF");

var $8ggsK = parcelRequire("8ggsK");
function $ae8927841c815837$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $i65mF.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $8ggsK.default)(node, touch);
    }
    return null;
}

});

parcelRegister("k7k9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea54197c69b80d53$export$2e2bcd8739ae039);
function $ea54197c69b80d53$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("6fQqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $48dccea70af5d476$export$2e2bcd8739ae039);
function $48dccea70af5d476$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}

});

parcelRegister("lHll8", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $fcbe2acdf5426805$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $fcbe2acdf5426805$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $fcbe2acdf5426805$export$2e2bcd8739ae039);
function $fcbe2acdf5426805$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$fcbe2acdf5426805$export$563a914cafbdc389.prototype = {
    constructor: $fcbe2acdf5426805$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $fcbe2acdf5426805$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $fcbe2acdf5426805$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $fcbe2acdf5426805$export$f0954fd7d5368655 = new $fcbe2acdf5426805$export$563a914cafbdc389(1, 0, 0);
$fcbe2acdf5426805$export$2e2bcd8739ae039.prototype = $fcbe2acdf5426805$export$563a914cafbdc389.prototype;
function $fcbe2acdf5426805$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $fcbe2acdf5426805$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("aJROE", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $7d17da16f7c6c8f9$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $7d17da16f7c6c8f9$export$2e2bcd8739ae039);

var $e5rGV = parcelRequire("e5rGV");
function $7d17da16f7c6c8f9$export$2e2561858db9bf47() {
    (0, $e5rGV.event).stopImmediatePropagation();
}
function $7d17da16f7c6c8f9$export$2e2bcd8739ae039() {
    (0, $e5rGV.event).preventDefault();
    (0, $e5rGV.event).stopImmediatePropagation();
}

});





parcelRegister("lbfwa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c54325f0a5490591$var$shouldShowNormalized;
var $c54325f0a5490591$var$realZones = new Set([
    'personal'
]);
function $c54325f0a5490591$var$shouldShowNormalized(chartOptions, strikeZone) {
    if (typeof chartOptions.normalize === 'boolean') return chartOptions.normalize;
    return !$c54325f0a5490591$var$realZones.has(strikeZone);
}

});

parcelRegister("42dow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dynamicNormalization = $6c315df241a1086b$var$dynamicNormalization;
module.exports.dynamicNormalizationFeet = $6c315df241a1086b$var$dynamicNormalizationFeet;

var $mdo2f = parcelRequire("mdo2f");
function $6c315df241a1086b$var$dynamicNormalizationFeet(strikeZoneDims, pitch) {
    if (pitch.x === null || pitch.y === null) {
        console.warn('no x/y value');
        return {
            x: 0,
            z: 0
        };
    }
    if (pitch.szTop === null || pitch.szBot === null || pitch.szWidth === null) // no strike zone value
    return {
        x: pitch.x || 0,
        z: pitch.y || 0
    };
    var epsilon = 0.00001;
    // Perhaps incorrectly assume we'll never have the same zone with different depths 🤔
    // Averaging brings us into fun floating point world
    var sameZone = Math.abs(strikeZoneDims.top - pitch.szTop) < epsilon && Math.abs(strikeZoneDims.bot - pitch.szBot) < epsilon && Math.abs(strikeZoneDims.width - pitch.szWidth) < epsilon;
    // Save a bit of time maybe
    if (sameZone) return {
        x: pitch.x,
        z: pitch.y
    };
    return (0, $mdo2f.normalizeToZone)(pitch.x, pitch.y, pitch.szTop || $mdo2f.topZoneAverage, pitch.szBot || $mdo2f.bottomZoneAverage, (pitch.szWidth || 17 / 12) * 12, // silly inches vs ft conversions back and forth
    strikeZoneDims.top, strikeZoneDims.bot, strikeZoneDims.width * 12 // silly inches vs ft conversions back and forth
    );
}
function $6c315df241a1086b$var$dynamicNormalization(strikeZoneDims, pitch, xScale, yScale) {
    var _dynamicNormalization = $6c315df241a1086b$var$dynamicNormalizationFeet(strikeZoneDims, pitch), x = _dynamicNormalization.x, z = _dynamicNormalization.z;
    return {
        x: xScale(x),
        y: yScale(z)
    };
}

});

parcelRegister("15SjV", function(module, exports) {
"use strict";
function $b5c8140ca5a125fb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b5c8140ca5a125fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b5c8140ca5a125fb$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b5c8140ca5a125fb$var$getStrikeZoneDims;

var $b5c8140ca5a125fb$var$d3 = $b5c8140ca5a125fb$var$_interopRequireWildcard((parcelRequire("jEBA8")));

var $mdo2f = parcelRequire("mdo2f");

var $b5c8140ca5a125fb$var$_canBePersonalized = $b5c8140ca5a125fb$var$_interopRequireDefault((parcelRequire("ibFsF")));
function $b5c8140ca5a125fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b5c8140ca5a125fb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b5c8140ca5a125fb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b5c8140ca5a125fb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b5c8140ca5a125fb$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b5c8140ca5a125fb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var $b5c8140ca5a125fb$var$genericZone = {
    top: $mdo2f.topZoneAverage,
    bot: $mdo2f.bottomZoneAverage,
    width: $mdo2f.plateWidthFt,
    depth: $mdo2f.depthMidPlateFt
};
function $b5c8140ca5a125fb$var$getPersonalZone(data) {
    var _data$ = data[0], szBot = _data$.szBot, szTop = _data$.szTop, szWidth = _data$.szWidth, szDepth = _data$.szDepth;
    if (!(0, $b5c8140ca5a125fb$var$_canBePersonalized["default"])(data)) console.error("Personal Zone can't be Personalized");
    return {
        top: szTop || $mdo2f.topZoneAverage,
        bot: szBot || $mdo2f.bottomZoneAverage,
        width: szWidth || $mdo2f.plateWidthFt,
        depth: szDepth || $mdo2f.depthMidPlateFt
    };
}
function $b5c8140ca5a125fb$var$getAverageZone(data) {
    var szTop = $b5c8140ca5a125fb$var$d3.mean(data, function(d) {
        return d.szTop;
    });
    var szBot = $b5c8140ca5a125fb$var$d3.mean(data, function(d) {
        return d.szBot;
    });
    var szWidth = $b5c8140ca5a125fb$var$d3.mean(data, function(d) {
        return d.szWidth;
    });
    // Yikes
    var szDepth = $b5c8140ca5a125fb$var$d3.mean(data, function(d) {
        return d.szDepth;
    });
    if (!data.length || !szTop || !szBot || !szWidth || !szDepth) return $b5c8140ca5a125fb$var$genericZone;
    return {
        top: szTop,
        bot: szBot,
        width: szWidth,
        depth: szDepth
    };
}
function $b5c8140ca5a125fb$var$getStrikeZoneDims(strikeZone, data) {
    switch(strikeZone){
        case 'personal':
            return $b5c8140ca5a125fb$var$getPersonalZone(data);
        case 'average':
            return $b5c8140ca5a125fb$var$getAverageZone(data);
        // case 'generic-old':
        //     return {
        //         top: topZoneOld,
        //         bot: bottomZoneOld,
        //         width: plateWidthFt,
        //         depth: depthOld,
        //     }
        case 'generic':
        default:
            return $b5c8140ca5a125fb$var$genericZone;
    }
}

});
parcelRegister("ibFsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $37a059100dc814bd$var$canBePersonalized;
function $37a059100dc814bd$var$canBePersonalized(data) {
    // Need to find the strike zone data and all be equivalent to be personalized
    if (!data.length) // console.warn('No Data')
    return false;
    // This is a temporary place to find the sz data
    var _data$ = data[0], szBot = _data$.szBot, szTop = _data$.szTop, szWidth = _data$.szWidth, szDepth = _data$.szDepth;
    if (szBot === undefined || szTop === undefined || szBot === null || szTop === null) return false;
    return data.every(function(d) {
        return d.szBot === szBot && d.szTop === szTop && d.szWidth === szWidth && d.szDepth === szDepth;
    });
}

});


parcelRegister("4CtDJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $58b7d84183251c51$var$getStrikeZoneType;

var $58b7d84183251c51$var$_canBePersonalized = $58b7d84183251c51$var$_interopRequireDefault((parcelRequire("ibFsF")));
function $58b7d84183251c51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $58b7d84183251c51$var$getStrikeZoneType(chartOptions, data) {
    if (chartOptions.strikeZone) // respect any override
    return chartOptions.strikeZone;
    var personal = (0, $58b7d84183251c51$var$_canBePersonalized["default"])(data);
    return personal ? 'personal' : 'average';
}

});


parcelRegister("6UN3I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $508e071ff0407ce2$var$PopulateSettings;
function $508e071ff0407ce2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $508e071ff0407ce2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $508e071ff0407ce2$var$_typeof(o);
}
function $508e071ff0407ce2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $508e071ff0407ce2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $508e071ff0407ce2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $508e071ff0407ce2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $508e071ff0407ce2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $508e071ff0407ce2$var$_defineProperty(e, r, t) {
    return (r = $508e071ff0407ce2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $508e071ff0407ce2$var$_toPropertyKey(t) {
    var i = $508e071ff0407ce2$var$_toPrimitive(t, "string");
    return "symbol" == $508e071ff0407ce2$var$_typeof(i) ? i : i + "";
}
function $508e071ff0407ce2$var$_toPrimitive(t, r) {
    if ("object" != $508e071ff0407ce2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $508e071ff0407ce2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $508e071ff0407ce2$var$isRealPitch(pitch) {
    return ![
        'UN',
        'IN',
        'AB',
        'AS',
        'NP',
        ''
    ].includes(pitch);
}
function $508e071ff0407ce2$var$PopulateSettings(data, chart) {
    // DEFAULT SCALE SETTINGS = SQUARE (Instagram)
    var svgWidth = 500;
    var svgHeight = 500;
    var margin = {
        top: svgWidth * 0.18,
        right: svgWidth * 0.28,
        bottom: svgWidth * 0.08,
        left: svgWidth * 0.04
    };
    var vizScale = 0.65;
    var vizPadding = {
        top: svgWidth * 0.35,
        left: svgWidth * 0.2
    };
    var orientation = 'landscape';
    if (chart.shape === 'square') {
        svgWidth = 500;
        svgHeight = 500;
        margin = {
            top: svgWidth * 0.18,
            right: svgWidth * 0.28,
            bottom: svgWidth * 0.08,
            left: svgWidth * 0.04
        };
        vizScale = 0.65;
        vizPadding = {
            top: svgWidth * 0.35,
            left: svgWidth * 0.2
        };
        // try to auto determine padding.... buggy
        if (chart.vizScaleOverride && !chart.vizScaleOverrideTop && !chart.vizScaleOverrideLeft) vizPadding = {
            top: svgWidth / 2 / chart.vizScaleOverride - svgWidth * chart.vizScaleOverride / 2,
            left: svgWidth / 2 / chart.vizScaleOverride - svgWidth * chart.vizScaleOverride / 2
        };
        else if (chart.vizScaleOverride && chart.vizScaleOverrideTop && chart.vizScaleOverrideLeft) vizPadding = {
            top: chart.vizScaleOverrideTop,
            left: chart.vizScaleOverrideLeft
        };
        if (chart.chartType === 'sideways') vizPadding = {
            top: svgWidth * 0.45,
            left: svgWidth * 0.05
        };
        if (chart.chartType === 'line') vizPadding = {
            top: svgWidth * 0.3,
            left: svgWidth * 0.2
        };
    }
    if (chart.shape === 'twitter') {
        svgWidth = 640;
        svgHeight = 360;
        margin = {
            top: svgHeight * 0.225,
            right: svgWidth * 0.3,
            bottom: svgHeight * 0.09,
            left: svgWidth * 0.2
        };
        vizScale = 0.46;
        vizPadding = {
            top: svgHeight * 0.58,
            left: svgWidth * 0.5
        };
        if (chart.chartType === 'sideways') {
            vizScale = 0.65;
            vizPadding = {
                top: svgWidth * 0.18,
                left: svgWidth * 0.125
            };
        }
        if (chart.chartType === 'line') vizPadding = {
            top: svgWidth * 0.28,
            left: svgWidth * 0.65
        };
    }
    if (chart.shape === 'snap') {
        svgWidth = 360;
        svgHeight = 640;
        margin = {
            top: svgHeight * 0.15,
            right: svgWidth * 0.1,
            bottom: svgHeight * 0.08,
            left: svgWidth * 0.0
        };
        vizScale = 0.6;
        vizPadding = {
            top: svgHeight * 0.4,
            left: svgWidth * 0.1
        };
        orientation = 'portrait';
        if (chart.chartType === 'sideways') {
            vizScale = 0.48;
            vizPadding = {
                top: svgWidth * 0.9,
                left: svgWidth * 0.05
            };
        }
        if (chart.chartType === 'line') {
            vizScale = 0.6;
            vizPadding = {
                top: svgWidth * 0.7,
                left: svgWidth * 0.3
            };
        }
    }
    // Scale for g
    var VIZ_WIDTH = 500;
    var VIZ_HEIGHT = 500;
    var shapeRatio = chart.shapeRatio || 1;
    var firstFieldType = chart.charts.findIndex(function(c) {
        return c.chartType === 'field';
    });
    var charts = chart.charts.map(function(d, i) {
        return $508e071ff0407ce2$var$_objectSpread($508e071ff0407ce2$var$_objectSpread({}, d), {}, {
            index: i,
            showField: i <= firstFieldType
        });
    });
    var settings = {
        data: Array.isArray(data) ? data.filter(function(d) {
            return typeof d.pitchType !== 'string' || $508e071ff0407ce2$var$isRealPitch(d.pitchType);
        }) : data,
        //    chartType: chart.chartType || "pitch",
        charts: charts,
        shape: chart.shape || 'square',
        vizWidth: VIZ_WIDTH || 500,
        vizHeight: VIZ_HEIGHT || 500,
        svgWidth: svgWidth,
        svgHeight: svgHeight,
        ratioWidth: svgWidth * shapeRatio,
        ratioHeight: svgHeight * shapeRatio,
        venueId: chart.venueId || 7,
        margin: margin || {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        },
        vizPadding: vizPadding || {
            top: 0,
            left: 0
        },
        vizScale: vizScale || 0.65,
        vizScaleOverride: chart.vizScaleOverride || 0,
        orientation: orientation || 'landscape',
        lineGraphChart: chart.lineGraphChart || {
            show: false
        },
        namePlate: chart.namePlate || {
            show: false
        },
        sourcePlate: chart.sourcePlate || {
            show: false
        },
        mainPanelBackground: chart.mainPanelBackground || '#fff',
        mainPanelStroke: chart.mainPanelStroke || '#c2c2c2',
        svgZoom: chart.svgZoom || null,
        enableZoom: Boolean(chart.enableZoom)
    };
    settings.width = svgWidth - settings.margin.left - settings.margin.right;
    settings.height = svgHeight - settings.margin.top - settings.margin.bottom;
    return settings;
}

});

parcelRegister("hRpC3", function(module, exports) {
"use strict";
function $d00b410ba17592b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d00b410ba17592b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d00b410ba17592b3$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d00b410ba17592b3$var$_react = $d00b410ba17592b3$var$_interopRequireWildcard((parcelRequire("J42oT")));
parcelRequire("fDxci");
var $fWcxG = parcelRequire("fWcxG");

var $d00b410ba17592b3$var$_get = $d00b410ba17592b3$var$_interopRequireDefault((parcelRequire("jWTe4")));

var $d00b410ba17592b3$var$_MlbLogo = $d00b410ba17592b3$var$_interopRequireDefault((parcelRequire("dDxK0")));
function $d00b410ba17592b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $d00b410ba17592b3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d00b410ba17592b3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d00b410ba17592b3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $d00b410ba17592b3$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $d00b410ba17592b3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d00b410ba17592b3$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $d00b410ba17592b3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $d00b410ba17592b3$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($d00b410ba17592b3$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $d00b410ba17592b3$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $d00b410ba17592b3$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $d00b410ba17592b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $d00b410ba17592b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $d00b410ba17592b3$var$_slicedToArray(r, e) {
    return $d00b410ba17592b3$var$_arrayWithHoles(r) || $d00b410ba17592b3$var$_iterableToArrayLimit(r, e) || $d00b410ba17592b3$var$_unsupportedIterableToArray(r, e) || $d00b410ba17592b3$var$_nonIterableRest();
}
function $d00b410ba17592b3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d00b410ba17592b3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d00b410ba17592b3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d00b410ba17592b3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d00b410ba17592b3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d00b410ba17592b3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d00b410ba17592b3$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable */ 
function $d00b410ba17592b3$var$NamePlate(_ref) {
    var settings = _ref.settings;
    var namePlate = settings.namePlate;
    var supressImage = namePlate.supressImage;
    var photoId = (0, $d00b410ba17592b3$var$_get["default"])(settings, "namePlate.photoId") || '';
    var errorPhotoUrl = (0, $d00b410ba17592b3$var$_get["default"])(settings, "namePlate.errorPhotoUrl") || 'https://content.mlb.com/images/headshots/current/60x60/generic.png';
    var photoUrl = (0, $d00b410ba17592b3$var$_get["default"])(settings, "namePlate.photoUrl") || "https://img.mlbstatic.com/mlb-photos/image/upload/w_120,q_100/v1/people/".concat(photoId, "/headshot/silo/current");
    if (photoUrl.indexOf('{1}') > -1) photoUrl = photoUrl.replace('{1}', photoId);
    var image = /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("image", {
        x: "5",
        y: "10",
        height: "50",
        width: "50",
        href: errorPhotoUrl
    });
    if (namePlate.forcePlayerImage && photoId) image = /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("image", {
        x: "5",
        y: "12",
        height: "50",
        width: "50",
        href: photoUrl
    });
    if (supressImage) image = null;
    var _useState = (0, $d00b410ba17592b3$var$_react.useState)(image), _useState2 = $d00b410ba17592b3$var$_slicedToArray(_useState, 2), imageHolder = _useState2[0], setImageHolder = _useState2[1];
    (0, $d00b410ba17592b3$var$_react.useEffect)(function() {
        function fetchImage() {
            return _fetchImage.apply(this, arguments);
        }
        function _fetchImage() {
            _fetchImage = $d00b410ba17592b3$var$_asyncToGenerator(/*#__PURE__*/ $d00b410ba17592b3$var$_regeneratorRuntime().mark(function _callee() {
                return $d00b410ba17592b3$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            (0, $fWcxG.default)(photoUrl).mimeType('image/png').get(function(err, image) {
                                if (image) setImageHolder(/*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("image", {
                                    x: "5",
                                    y: "12",
                                    height: "50",
                                    width: "50",
                                    href: photoUrl
                                }));
                            });
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return _fetchImage.apply(this, arguments);
        }
        if (!namePlate.forcePlayerImage) fetchImage();
    }, []);
    var defaultX = namePlate.supressImage ? 20 : 65;
    return /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("g", {
        id: "namePlate",
        transform: "translate(0,0)"
    }, /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("rect", {
        fill: namePlate.backgroundColor,
        width: settings.svgWidth,
        height: settings.margin.top,
        stroke: "#c2c2c2"
    }), /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("rect", {
        fill: namePlate.background === 'none' ? 'none' : "url('#".concat(namePlate.background, "')"),
        width: settings.svgWidth,
        height: settings.margin.top,
        stroke: "#c2c2c2"
    }), /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("text", {
        x: namePlate.primaryTitleX || defaultX,
        y: namePlate.primaryTitleY || 36,
        className: "title",
        fill: namePlate.titleFontColor,
        style: {
            fontSize: namePlate.primaryTitleFontSize,
            fontFamily: namePlate.primaryTitleFontFamily
        }
    }, namePlate.primaryTitleText), /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("text", {
        x: namePlate.secondaryTitleX || defaultX,
        y: namePlate.secondaryTitleY || 58,
        className: "sub-title",
        fill: namePlate.secondaryFontColor,
        style: {
            fontSize: namePlate.secondaryTitleFontSize,
            fontFamily: namePlate.secondaryTitleFontFamily
        }
    }, namePlate.secondaryTitleText, namePlate.tertiaryTitleText && namePlate.secondaryTitleText ? /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement("tspan", {
        style: {
            fill: namePlate.tertiaryFontColor
        }
    }, ' ', "\u2022 ", namePlate.tertiaryTitleText) : null), !supressImage && imageHolder, namePlate.teamLogoId !== '-1' ? /*#__PURE__*/ $d00b410ba17592b3$var$_react["default"].createElement($d00b410ba17592b3$var$_MlbLogo["default"], {
        settings: settings,
        teamLogoId: namePlate.teamLogoId
    }) : null);
}
var $d00b410ba17592b3$var$_default = module.exports["default"] = $d00b410ba17592b3$var$NamePlate;

});
parcelRegister("fDxci", function(module, exports) {

$parcel$export(module.exports, "request", () => (parcelRequire("fWcxG")).default);

var $fWcxG = parcelRequire("fWcxG");

var $kWeV5 = parcelRequire("kWeV5");

var $55gmY = parcelRequire("55gmY");

var $gyFZM = parcelRequire("gyFZM");

var $gT6Lq = parcelRequire("gT6Lq");

var $hmiEm = parcelRequire("hmiEm");

var $kSNW2 = parcelRequire("kSNW2");

});
parcelRegister("fWcxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a6006ac6917382$export$2e2bcd8739ae039);
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");

var $4h5V5 = parcelRequire("4h5V5");
function $b9a6006ac6917382$export$2e2bcd8739ae039(url, callback) {
    var request, event = (0, $4h5V5.default)("beforesend", "progress", "load", "error"), mimeType, headers = (0, $5Mltl.default)(), xhr = new XMLHttpRequest, user = null, password = null, response, responseType, timeout = 0;
    // If IE does not support CORS, use XDomainRequest.
    if (typeof XDomainRequest !== "undefined" && !("withCredentials" in xhr) && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
    "onload" in xhr ? xhr.onload = xhr.onerror = xhr.ontimeout = respond : xhr.onreadystatechange = function(o) {
        xhr.readyState > 3 && respond(o);
    };
    function respond(o) {
        var status = xhr.status, result;
        if (!status && $b9a6006ac6917382$var$hasResponse(xhr) || status >= 200 && status < 300 || status === 304) {
            if (response) try {
                result = response.call(request, xhr);
            } catch (e) {
                event.call("error", request, e);
                return;
            }
            else result = xhr;
            event.call("load", request, result);
        } else event.call("error", request, o);
    }
    xhr.onprogress = function(e) {
        event.call("progress", request, e);
    };
    request = {
        header: function(name, value) {
            name = (name + "").toLowerCase();
            if (arguments.length < 2) return headers.get(name);
            if (value == null) headers.remove(name);
            else headers.set(name, value + "");
            return request;
        },
        // If mimeType is non-null and no Accept header is set, a default is used.
        mimeType: function(value) {
            if (!arguments.length) return mimeType;
            mimeType = value == null ? null : value + "";
            return request;
        },
        // Specifies what type the response value should take;
        // for instance, arraybuffer, blob, document, or text.
        responseType: function(value) {
            if (!arguments.length) return responseType;
            responseType = value;
            return request;
        },
        timeout: function(value) {
            if (!arguments.length) return timeout;
            timeout = +value;
            return request;
        },
        user: function(value) {
            return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
        },
        password: function(value) {
            return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
        },
        // Specify how to convert the response content to a specific type;
        // changes the callback value on "load" events.
        response: function(value) {
            response = value;
            return request;
        },
        // Alias for send("GET", …).
        get: function(data, callback) {
            return request.send("GET", data, callback);
        },
        // Alias for send("POST", …).
        post: function(data, callback) {
            return request.send("POST", data, callback);
        },
        // If callback is non-null, it will be used for error and load events.
        send: function(method, data, callback) {
            xhr.open(method, url, true, user, password);
            if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
            if (xhr.setRequestHeader) headers.each(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
            if (responseType != null) xhr.responseType = responseType;
            if (timeout > 0) xhr.timeout = timeout;
            if (callback == null && typeof data === "function") callback = data, data = null;
            if (callback != null && callback.length === 1) callback = $b9a6006ac6917382$var$fixCallback(callback);
            if (callback != null) request.on("error", callback).on("load", function(xhr) {
                callback(null, xhr);
            });
            event.call("beforesend", request, xhr);
            xhr.send(data == null ? null : data);
            return request;
        },
        abort: function() {
            xhr.abort();
            return request;
        },
        on: function() {
            var value = event.on.apply(event, arguments);
            return value === event ? request : value;
        }
    };
    if (callback != null) {
        if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
        return request.get(callback);
    }
    return request;
}
function $b9a6006ac6917382$var$fixCallback(callback) {
    return function(error, xhr) {
        callback(error == null ? xhr : null);
    };
}
function $b9a6006ac6917382$var$hasResponse(xhr) {
    var type = xhr.responseType;
    return type && type !== "text" ? xhr.response // null on error
     : xhr.responseText; // "" on error
}

});

parcelRegister("kWeV5", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $f3e4cc33f2854c63$export$2e2bcd8739ae039 = (0, $gTX0G.default)("text/html", function(xhr) {
    return document.createRange().createContextualFragment(xhr.responseText);
});

});
parcelRegister("gTX0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4df8e8d49334f61$export$2e2bcd8739ae039);

var $fWcxG = parcelRequire("fWcxG");
function $c4df8e8d49334f61$export$2e2bcd8739ae039(defaultMimeType, response) {
    return function(url, callback) {
        var r = (0, $fWcxG.default)(url).mimeType(defaultMimeType).response(response);
        if (callback != null) {
            if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
            return r.get(callback);
        }
        return r;
    };
}

});


parcelRegister("55gmY", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $3b3a1e0ce8b5e9cc$export$2e2bcd8739ae039 = (0, $gTX0G.default)("application/json", function(xhr) {
    return JSON.parse(xhr.responseText);
});

});

parcelRegister("gyFZM", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $c0e065bf7f296a68$export$2e2bcd8739ae039 = (0, $gTX0G.default)("text/plain", function(xhr) {
    return xhr.responseText;
});

});

parcelRegister("gT6Lq", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $c4b7078ce337602d$export$2e2bcd8739ae039 = (0, $gTX0G.default)("application/xml", function(xhr) {
    var xml = xhr.responseXML;
    if (!xml) throw new Error("parse error");
    return xml;
});

});

parcelRegister("hmiEm", function(module, exports) {

var $aGeJV = parcelRequire("aGeJV");

var $ePrGJ = parcelRequire("ePrGJ");
var $ca32f538f6217bbd$export$2e2bcd8739ae039 = (0, $ePrGJ.default)("text/csv", (0, $aGeJV.csvParse));

});
parcelRegister("ePrGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbb4e6b21ade262$export$2e2bcd8739ae039);

var $fWcxG = parcelRequire("fWcxG");
function $acbb4e6b21ade262$export$2e2bcd8739ae039(defaultMimeType, parse) {
    return function(url, row, callback) {
        if (arguments.length < 3) callback = row, row = null;
        var r = (0, $fWcxG.default)(url).mimeType(defaultMimeType);
        r.row = function(_) {
            return arguments.length ? r.response($acbb4e6b21ade262$var$responseOf(parse, row = _)) : row;
        };
        r.row(row);
        return callback ? r.get(callback) : r;
    };
}
function $acbb4e6b21ade262$var$responseOf(parse, row) {
    return function(request) {
        return parse(request.responseText, row);
    };
}

});


parcelRegister("kSNW2", function(module, exports) {

var $lShYg = parcelRequire("lShYg");

var $ePrGJ = parcelRequire("ePrGJ");
var $f33f95df637de9bd$export$2e2bcd8739ae039 = (0, $ePrGJ.default)("text/tab-separated-values", (0, $lShYg.tsvParse));

});


parcelRegister("dDxK0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ed917297d821520$var$_react = $9ed917297d821520$var$_interopRequireDefault((parcelRequire("J42oT")));
function $9ed917297d821520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $9ed917297d821520$var$Logo(_ref) {
    var settings = _ref.settings, teamLogoId = _ref.teamLogoId;
    var url;
    var height = settings.svgWidth * 0.08;
    var x = settings.svgWidth / 1.2;
    var y = settings.margin.top / 4;
    if (settings.shape === 'twitter') height = settings.svgWidth * 0.06;
    if (teamLogoId === 'primary') url = "https://www.mlbstatic.com/team-logos/league-on-dark/1.svg";
    else if (teamLogoId === 'milb') url = 'https://www.mlbstatic.com/team-logos/league-on-light/milb-alt.svg';
    else if (teamLogoId === 'savant') url = 'https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg';
    else if (teamLogoId === 'savant-logo') {
        height = settings.svgWidth * 0.1;
        y = settings.margin.top / 6;
        url = 'https://baseballsavant.mlb.com/site-core/images/savant-logo.svg';
    } else url = "https://www.mlbstatic.com/team-logos/".concat(teamLogoId, ".svg");
    return /*#__PURE__*/ $9ed917297d821520$var$_react["default"].createElement("g", {
        id: "logo",
        transform: "translate(0,0)"
    }, /*#__PURE__*/ $9ed917297d821520$var$_react["default"].createElement("image", {
        href: url,
        x: x,
        y: y,
        height: height
    }));
}
var $9ed917297d821520$var$_default = module.exports["default"] = $9ed917297d821520$var$Logo;

});


parcelRegister("bRQDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8a3d788b7e832e3c$var$_react = $8a3d788b7e832e3c$var$_interopRequireDefault((parcelRequire("J42oT")));
function $8a3d788b7e832e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $8a3d788b7e832e3c$var$Border(_ref) {
    var settings = _ref.settings, _ref$mainPanelBackgro = _ref.mainPanelBackground, mainPanelBackground = _ref$mainPanelBackgro === void 0 ? '#fff' : _ref$mainPanelBackgro;
    var background;
    if (settings.mainPanelBackground === 'none') background = 'none';
    else if (settings.mainPanelBackground && settings.mainPanelBackground.indexOf('#') > -1) background = mainPanelBackground;
    else if (settings.mainPanelBackground) background = "url('#".concat(settings.mainPanelBackground, "')");
    else background = '#fff';
    return /*#__PURE__*/ $8a3d788b7e832e3c$var$_react["default"].createElement("rect", {
        width: settings.svgWidth,
        height: settings.svgHeight,
        fill: background,
        stroke: settings.mainPanelStroke || '#c2c2c2'
    });
}
var $8a3d788b7e832e3c$var$_default = module.exports["default"] = $8a3d788b7e832e3c$var$Border;

});

parcelRegister("1p1Zk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1059ab0a4fd8cdd1$var$_react = $1059ab0a4fd8cdd1$var$_interopRequireDefault((parcelRequire("J42oT")));
function $1059ab0a4fd8cdd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1059ab0a4fd8cdd1$var$Stripes() {
    return /*#__PURE__*/ $1059ab0a4fd8cdd1$var$_react["default"].createElement("pattern", {
        id: "stripes",
        width: "8",
        height: "8",
        patternUnits: "userSpaceOnUse",
        patternTransform: "rotate(30)"
    }, /*#__PURE__*/ $1059ab0a4fd8cdd1$var$_react["default"].createElement("rect", {
        width: ".5",
        height: "8",
        opacity: ".5",
        transform: "translate(0,0)",
        fill: "#32858d"
    }));
}
var $1059ab0a4fd8cdd1$var$_default = module.exports["default"] = $1059ab0a4fd8cdd1$var$Stripes;

});

parcelRegister("6RScG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5001bd0120ac995d$var$_react = $5001bd0120ac995d$var$_interopRequireDefault((parcelRequire("J42oT")));
function $5001bd0120ac995d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5001bd0120ac995d$var$DoubleStripes() {
    return /*#__PURE__*/ $5001bd0120ac995d$var$_react["default"].createElement("pattern", {
        id: "double-stripes",
        width: "16",
        height: "8",
        patternUnits: "userSpaceOnUse",
        patternTransform: "rotate(45)"
    }, /*#__PURE__*/ $5001bd0120ac995d$var$_react["default"].createElement("rect", {
        key: "rect_1",
        width: "1",
        height: "8",
        opacity: ".5",
        transform: "translate(0,0)",
        fill: "#f5f5f5"
    }), /*#__PURE__*/ $5001bd0120ac995d$var$_react["default"].createElement("rect", {
        key: "rect_2",
        width: "1",
        height: "8",
        opacity: ".5",
        transform: "translate(8,0)",
        fill: "#b2dfdb"
    }));
}
var $5001bd0120ac995d$var$_default = module.exports["default"] = $5001bd0120ac995d$var$DoubleStripes;

});

parcelRegister("jemXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e00123b71e5b4a1a$var$_react = $e00123b71e5b4a1a$var$_interopRequireDefault((parcelRequire("J42oT")));
function $e00123b71e5b4a1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $e00123b71e5b4a1a$var$Textures() {
    return /*#__PURE__*/ $e00123b71e5b4a1a$var$_react["default"].createElement("pattern", {
        id: "lines",
        patternUnits: "userSpaceOnUse",
        width: "60",
        height: "60"
    }, /*#__PURE__*/ $e00123b71e5b4a1a$var$_react["default"].createElement("path", {
        d: "M 0,60 l 60,-60 M -15,15 l 30,-30 M 45,75 l 30,-30",
        strokeWidth: "40",
        shapeRendering: "auto",
        stroke: "#f5f5f5",
        fill: "#000000",
        strokeLinecap: "square"
    }));
}
var $e00123b71e5b4a1a$var$_default = module.exports["default"] = $e00123b71e5b4a1a$var$Textures;

});

parcelRegister("9qs11", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $07017b6f69841c53$var$FuzzFilter;

var $07017b6f69841c53$var$_react = $07017b6f69841c53$var$_interopRequireDefault((parcelRequire("J42oT")));
function $07017b6f69841c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $07017b6f69841c53$var$FuzzFilter() {
    return /*#__PURE__*/ $07017b6f69841c53$var$_react["default"].createElement("filter", {
        id: "fuzzFilter",
        x: "-20%",
        y: "-20%",
        width: "140%",
        height: "140%"
    }, /*#__PURE__*/ $07017b6f69841c53$var$_react["default"].createElement("feGaussianBlur", {
        "in": "SourceGraphic",
        stdDeviation: "0 10"
    }));
}

});

parcelRegister("d8FBT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $990c4ca5262e44f9$var$SourcePlate;

var $990c4ca5262e44f9$var$_react = $990c4ca5262e44f9$var$_interopRequireDefault((parcelRequire("J42oT")));
function $990c4ca5262e44f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ /* eslint-disable react/prop-types */ function $990c4ca5262e44f9$var$SourcePlate(_ref) {
    var settings = _ref.settings;
    var sp = settings.sourcePlate;
    var promoX = 1.5;
    var promoY = 5;
    if (settings.shape === 'twitter') {
        promoX = 1.35;
        promoY = 10;
    }
    if (settings.shape === 'snap') {
        promoX = 1.9;
        promoY = 3.5;
    }
    var siteTextProps = {
        x: settings.svgWidth * 0.025,
        y: settings.margin.bottom / 1.6,
        className: 'site-title',
        fill: sp.siteColor,
        style: {
            fontSize: sp.siteTitleFontSize,
            fontFamily: sp.siteTitleFontFamily
        }
    };
    var siteText;
    if (sp.siteHrefUrl) siteText = /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("a", {
        href: sp.siteHrefUrl
    }, /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("text", siteTextProps, sp.siteTitle));
    else siteText = /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("text", siteTextProps, sp.siteTitle);
    var sourceTextProps = {
        x: settings.svgWidth / 1.025,
        y: settings.margin.bottom / 1.6,
        className: 'source-title',
        fill: sp.sourceColor,
        style: {
            fontSize: sp.sourceTitleFontSize,
            fontFamily: sp.sourceTitleFontFamily
        }
    };
    var sourceText;
    if (sp.sourceHrefUrl) sourceText = /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("a", {
        href: sp.sourceHrefUrl
    }, /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("text", sourceTextProps, sp.sourceTitle));
    else sourceText = /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("text", sourceTextProps, sp.sourceTitle);
    return /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("g", {
        id: "sourcePlate",
        transform: "translate(0,".concat(settings.height + settings.margin.top, ")")
    }, /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("rect", {
        width: settings.svgWidth,
        height: settings.margin.bottom,
        fill: sp.background === 'none' ? sp.backgroundColor : "url('#".concat(sp.background, "')"),
        stroke: sp.strokeBackground || '#c2c2c2'
    }), siteText, sp.sourceTitle === 'promo' ? /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("g", {
        id: "logo",
        transform: "translate(0,0)"
    }, /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("a", {
        href: "https://baseballsavant.mlb.com/illustrator"
    }, /*#__PURE__*/ $990c4ca5262e44f9$var$_react["default"].createElement("image", {
        href: "https://baseballsavant.mlb.com/sections/evp/images/logo.png",
        x: settings.svgWidth / promoX,
        y: settings.margin.bottom / promoY,
        height: 22,
        opacity: 1
    }))) : sourceText);
}

});

parcelRegister("bs2qR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $00912d2fca2fd769$var$Chart;

var $00912d2fca2fd769$var$_react = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("J42oT")));

var $00912d2fca2fd769$var$_CirclePack = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("4ckNK")));

var $00912d2fca2fd769$var$_PieChart = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("60K0S")));

var $00912d2fca2fd769$var$_ReleasePoint = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("gSr2G")));

var $00912d2fca2fd769$var$_Scatter = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("mWIIN")));

var $00912d2fca2fd769$var$_LineGraph = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("9Ab9m")));

var $00912d2fca2fd769$var$_FieldSVG = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("eJm9R")));

var $00912d2fca2fd769$var$_Spray = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("faaIi")));

var $00912d2fca2fd769$var$_Boxes = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("UOQ6x")));

var $00912d2fca2fd769$var$_Contour = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("4S9rz")));

var $00912d2fca2fd769$var$_HexBin = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("ifBYI")));

var $00912d2fca2fd769$var$_Radial = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("83RM4")));

var $00912d2fca2fd769$var$_Sideways = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("adpbZ")));

var $00912d2fca2fd769$var$_d = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("3tRLx")));

var $00912d2fca2fd769$var$_Legend = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $00912d2fca2fd769$var$_HomeRunsLegend = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("7cM02")));

var $00912d2fca2fd769$var$_FieldDegreeMarkers = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("69H9A")));

var $00912d2fca2fd769$var$_PitchType = $00912d2fca2fd769$var$_interopRequireDefault((parcelRequire("6e0KX")));

var $3wgDt = parcelRequire("3wgDt");
function $00912d2fca2fd769$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/prop-types */ // VISUALS
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// @ts-expect-error - TODO: Convert to TypeScript
// LEGENDS
// @ts-expect-error - TODO: Convert to TypeScript
/// VISUAL HELPERS
// @ts-expect-error - TODO: Convert to TypeScript
function $00912d2fca2fd769$var$ChartContent(_ref) {
    var settings = _ref.settings, onPitchClick = _ref.onPitchClick;
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions;
    var chartOptionsCurr = chartOptions;
    if (chartOptions.chartType === 'pitch') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_PitchType["default"], {
        chartOptions: chartOptionsCurr,
        settings: settings,
        onPitchClick: onPitchClick
    });
    if (chartOptions.chartType === 'line') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_LineGraph["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    });
    if (chartOptions.chartType === 'network') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_react["default"].Fragment, null, chartOptions.overlayType === 'circlePack' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_CirclePack["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null, chartOptions.overlayType === 'pie' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_PieChart["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null, /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Legend["default"], {
        settings: settings,
        type: "pitchName"
    }));
    if (chartOptions.chartType === 'release') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_ReleasePoint["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    });
    if (chartOptions.chartType === 'movement') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Scatter["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    });
    if (chartOptions.chartType === 'radial') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Radial["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    });
    if (chartOptions.chartType === 'sideways') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Sideways["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    });
    if (chartOptions.chartType === 'field') return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_react["default"].Fragment, null, chartOptions.showField && /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_FieldSVG["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr,
        venueId: settings.venueId
    }), chartOptions.showFieldDegreeMarkers ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_FieldDegreeMarkers["default"], {
        settings: settings
    }) : null, chartOptions.overlayType === 'spray' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Spray["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null, chartOptions.overlayType === 'contour' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Contour["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null, chartOptions.overlayType === 'hexbin' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_HexBin["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null, chartOptions.overlayType === 'boxes' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Boxes["default"], {
        settings: settings,
        chartOptions: chartOptionsCurr
    }) : null);
    if (chartOptions.chartType === '3d') return function() {
        return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_react["default"].Fragment, null, /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement("foreignObject", {
            width: settings.vizWidth,
            height: settings.vizHeight
        }, /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_d["default"], {
            settings: settings,
            chartOptions: chartOptionsCurr
        })), chartOptions.overlayType === 'spray' ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_Legend["default"], {
            settings: settings,
            type: chartOptions.legendType
        }) : null, chartOptions.overlayType === 'trajectory' && chartOptions.legend ? /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$_HomeRunsLegend["default"], {
            settings: settings,
            type: chartOptions.legendType,
            chartOptions: chartOptionsCurr
        }) : null);
    }();
}
function $00912d2fca2fd769$var$Chart(_ref2) {
    var chartIndex = _ref2.chartIndex, settings = _ref2.settings, onPitchClick = _ref2.onPitchClick;
    return /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($3wgDt.ChartIndexProvider, {
        index: chartIndex
    }, /*#__PURE__*/ $00912d2fca2fd769$var$_react["default"].createElement($00912d2fca2fd769$var$ChartContent, {
        settings: settings,
        onPitchClick: onPitchClick
    }));
}

});
parcelRegister("4ckNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $30e86b26db2fc50d$var$CirclePack;

var $30e86b26db2fc50d$var$_react = $30e86b26db2fc50d$var$_interopRequireDefault((parcelRequire("J42oT")));

var $30e86b26db2fc50d$var$_countBy = $30e86b26db2fc50d$var$_interopRequireDefault((parcelRequire("jVTXl")));

var $30e86b26db2fc50d$var$_find = $30e86b26db2fc50d$var$_interopRequireDefault((parcelRequire("ihZKh")));

var $fW6ZT = parcelRequire("fW6ZT");
var $gftuo = parcelRequire("gftuo");

var $30e86b26db2fc50d$var$_LoadCounts = $30e86b26db2fc50d$var$_interopRequireDefault((parcelRequire("41zvR")));

var $30e86b26db2fc50d$var$_ColorMap = $30e86b26db2fc50d$var$_interopRequireDefault((parcelRequire("uw3x8")));
function $30e86b26db2fc50d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ var $30e86b26db2fc50d$var$connections = [
    [
        '00',
        '01'
    ],
    [
        '00',
        '10'
    ],
    [
        '01',
        '02'
    ],
    [
        '02',
        '12'
    ],
    [
        '01',
        '11'
    ],
    [
        '10',
        '11'
    ],
    [
        '10',
        '20'
    ],
    [
        '11',
        '12'
    ],
    [
        '11',
        '21'
    ],
    [
        '12',
        '22'
    ],
    [
        '22',
        '32'
    ],
    [
        '20',
        '30'
    ],
    [
        '20',
        '21'
    ],
    [
        '30',
        '31'
    ],
    [
        '21',
        '22'
    ],
    [
        '21',
        '31'
    ],
    [
        '31',
        '32'
    ]
];
function $30e86b26db2fc50d$var$CirclePack(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var counts = settings.data;
    if (!chartOptions.skipDataProcess) counts = (0, $30e86b26db2fc50d$var$_LoadCounts["default"])(settings.data);
    var layerCount = (0, $30e86b26db2fc50d$var$_countBy["default"])(counts, 'layer');
    var layers = [];
    var maxCircleSize = 75;
    var scaleHeight = 0.24;
    if (settings.shape === 'twitter') scaleHeight = 0.34;
    // Array to store location of cx for connecting lines
    var xyLocations = [];
    var cPack = function cPack(data) {
        return (0, $gftuo.default)().size([
            maxCircleSize,
            maxCircleSize
        ])((0, $fW6ZT.default)(data).sum(function(d) {
            return d.value;
        }).sort(function(a, b) {
            return b.value - a.value;
        }));
    };
    var elements = [];
    var scaleX = function scaleX(d) {
        var layer = d.layer.toString();
        if (!layers[layer] && layers[d.layer.toString()] != 0) layers[layer] = 1;
        else layers[layer]++;
        var widthCircle = settings.vizWidth / (layerCount[d.layer] + 1);
        widthCircle *= layers[layer];
        return widthCircle;
    };
    counts.map(function(count) {
        var root = cPack(count);
        var xLocation = scaleX(count);
        elements.push(/*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("g", {
            key: "g_".concat(count.name),
            transform: "translate(".concat(xLocation, ", ").concat(count.layer * (settings.height * scaleHeight), ")")
        }, root.descendants().map(function(parent, i) {
            if (!parent.parent) xyLocations.push({
                layer: count.name,
                x: xLocation + parent.x,
                y: count.layer * (settings.height * scaleHeight) + parent.y
            });
            return /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement($30e86b26db2fc50d$var$_react["default"].Fragment, {
                key: "circlePack_".concat(i)
            }, !parent.parent ? /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("text", {
                x: maxCircleSize / 2,
                y: -maxCircleSize * 0.03,
                className: "network-label-text"
            }, count.balls, "-", count.strikes) : null, /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("g", {
                key: "parent_".concat(count.layer, "_").concat(parent.data.name),
                className: "".concat(!parent.children ? ' node--leaf' : parent.depth ? '' : ' node--root')
            }, /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("circle", {
                r: parent.r || 3,
                stroke: "#000",
                fill: parent.data.isPitch ? (0, $30e86b26db2fc50d$var$_ColorMap["default"])('pitchName', parent.data.name) : '#fff',
                cx: parent.x,
                cy: parent.y
            })));
        })));
    });
    $30e86b26db2fc50d$var$connections.map(function(line, i) {
        var lineStart = (0, $30e86b26db2fc50d$var$_find["default"])(xyLocations, function(d) {
            return d.layer === line[0];
        });
        var lineEnd = (0, $30e86b26db2fc50d$var$_find["default"])(xyLocations, function(d) {
            return d.layer === line[1];
        });
        elements.unshift(/*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("g", {
            key: "connections_".concat(i)
        }, /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("line", {
            x1: lineStart.x,
            y1: lineStart.y,
            x2: lineEnd.x,
            y2: lineEnd.y,
            stroke: "#000",
            strokeWidth: 2
        })));
    });
    return /*#__PURE__*/ $30e86b26db2fc50d$var$_react["default"].createElement("g", {
        id: "network"
    }, elements);
}

});
parcelRegister("jVTXl", function(module, exports) {

var $l8IaK = parcelRequire("l8IaK");

var $2zUiw = parcelRequire("2zUiw");
/** Used for built-in method references. */ var $e82ebee84976685e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e82ebee84976685e$var$hasOwnProperty = $e82ebee84976685e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $e82ebee84976685e$var$countBy = $2zUiw(function(result, value, key) {
    if ($e82ebee84976685e$var$hasOwnProperty.call(result, key)) ++result[key];
    else $l8IaK(result, key, 1);
});
module.exports = $e82ebee84976685e$var$countBy;

});
parcelRegister("l8IaK", function(module, exports) {

var $7sYG2 = parcelRequire("7sYG2");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f63c9c07e3913938$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $7sYG2) $7sYG2(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $f63c9c07e3913938$var$baseAssignValue;

});
parcelRegister("7sYG2", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");
var $56fa37258a866a2b$var$defineProperty = function() {
    try {
        var func = $kXBTM(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $56fa37258a866a2b$var$defineProperty;

});


parcelRegister("2zUiw", function(module, exports) {

var $jBRGG = parcelRequire("jBRGG");

var $2XsHv = parcelRequire("2XsHv");

var $hUuQW = parcelRequire("hUuQW");

var $9yDvq = parcelRequire("9yDvq");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $1e0a853a1dd4a41b$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $9yDvq(collection) ? $jBRGG : $2XsHv, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hUuQW(iteratee, 2), accumulator);
    };
}
module.exports = $1e0a853a1dd4a41b$var$createAggregator;

});
parcelRegister("jBRGG", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $e46b1e3a192d959e$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $e46b1e3a192d959e$var$arrayAggregator;

});

parcelRegister("2XsHv", function(module, exports) {

var $1h9b0 = parcelRequire("1h9b0");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $22775ad8e81992d2$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $1h9b0(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $22775ad8e81992d2$var$baseAggregator;

});
parcelRegister("1h9b0", function(module, exports) {

var $9gOGv = parcelRequire("9gOGv");

var $2lcFi = parcelRequire("2lcFi");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $0ede7f40a4662357$var$baseEach = $2lcFi($9gOGv);
module.exports = $0ede7f40a4662357$var$baseEach;

});
parcelRegister("9gOGv", function(module, exports) {

var $9QSZD = parcelRequire("9QSZD");

var $ivNeF = parcelRequire("ivNeF");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $6bfcec9b4f3cc192$var$baseForOwn(object, iteratee) {
    return object && $9QSZD(object, iteratee, $ivNeF);
}
module.exports = $6bfcec9b4f3cc192$var$baseForOwn;

});
parcelRegister("9QSZD", function(module, exports) {

var $5Rofo = parcelRequire("5Rofo");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $72c3a0d8d392f221$var$baseFor = $5Rofo();
module.exports = $72c3a0d8d392f221$var$baseFor;

});
parcelRegister("5Rofo", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4444b5fa6ce37173$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $4444b5fa6ce37173$var$createBaseFor;

});


parcelRegister("ivNeF", function(module, exports) {

var $lPYKm = parcelRequire("lPYKm");

var $cmztU = parcelRequire("cmztU");

var $4Occq = parcelRequire("4Occq");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d7a1506b81a636af$var$keys(object) {
    return $4Occq(object) ? $lPYKm(object) : $cmztU(object);
}
module.exports = $d7a1506b81a636af$var$keys;

});
parcelRegister("lPYKm", function(module, exports) {

var $an7sq = parcelRequire("an7sq");

var $dO1wD = parcelRequire("dO1wD");

var $9yDvq = parcelRequire("9yDvq");

var $j3Y1z = parcelRequire("j3Y1z");

var $7q8gD = parcelRequire("7q8gD");

var $36ugb = parcelRequire("36ugb");
/** Used for built-in method references. */ var $fe5d7b6cb231b0ec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fe5d7b6cb231b0ec$var$hasOwnProperty = $fe5d7b6cb231b0ec$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $fe5d7b6cb231b0ec$var$arrayLikeKeys(value, inherited) {
    var isArr = $9yDvq(value), isArg = !isArr && $dO1wD(value), isBuff = !isArr && !isArg && $j3Y1z(value), isType = !isArr && !isArg && !isBuff && $36ugb(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $an7sq(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $fe5d7b6cb231b0ec$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $7q8gD(key, length)))) result.push(key);
    return result;
}
module.exports = $fe5d7b6cb231b0ec$var$arrayLikeKeys;

});
parcelRegister("an7sq", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $78d1d649234ee546$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $78d1d649234ee546$var$baseTimes;

});

parcelRegister("dO1wD", function(module, exports) {

var $2B4VV = parcelRequire("2B4VV");

var $efn5V = parcelRequire("efn5V");
/** Used for built-in method references. */ var $a0d120c9d4d1d4ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a0d120c9d4d1d4ba$var$hasOwnProperty = $a0d120c9d4d1d4ba$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $a0d120c9d4d1d4ba$var$propertyIsEnumerable = $a0d120c9d4d1d4ba$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $a0d120c9d4d1d4ba$var$isArguments = $2B4VV(function() {
    return arguments;
}()) ? $2B4VV : function(value) {
    return $efn5V(value) && $a0d120c9d4d1d4ba$var$hasOwnProperty.call(value, 'callee') && !$a0d120c9d4d1d4ba$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $a0d120c9d4d1d4ba$var$isArguments;

});
parcelRegister("2B4VV", function(module, exports) {

var $9ooXF = parcelRequire("9ooXF");

var $efn5V = parcelRequire("efn5V");
/** `Object#toString` result references. */ var $1e42dd182bca7b96$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1e42dd182bca7b96$var$baseIsArguments(value) {
    return $efn5V(value) && $9ooXF(value) == $1e42dd182bca7b96$var$argsTag;
}
module.exports = $1e42dd182bca7b96$var$baseIsArguments;

});


parcelRegister("j3Y1z", function(module, exports) {

var $4U0WH = parcelRequire("4U0WH");

var $aqDtk = parcelRequire("aqDtk");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $4U0WH.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $aqDtk;
module.exports = isBuffer;

});
parcelRegister("aqDtk", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $797af366aaff3726$var$stubFalse() {
    return false;
}
module.exports = $797af366aaff3726$var$stubFalse;

});


parcelRegister("7q8gD", function(module, exports) {
/** Used as references for various `Number` constants. */ var $56715fd52509ed19$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $56715fd52509ed19$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $56715fd52509ed19$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $56715fd52509ed19$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $56715fd52509ed19$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $56715fd52509ed19$var$isIndex;

});

parcelRegister("36ugb", function(module, exports) {

var $b24im = parcelRequire("b24im");

var $kJ1X7 = parcelRequire("kJ1X7");

var $4rZX5 = parcelRequire("4rZX5");
/* Node.js helper references. */ var $242967a70f2a02a5$var$nodeIsTypedArray = $4rZX5 && $4rZX5.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $242967a70f2a02a5$var$isTypedArray = $242967a70f2a02a5$var$nodeIsTypedArray ? $kJ1X7($242967a70f2a02a5$var$nodeIsTypedArray) : $b24im;
module.exports = $242967a70f2a02a5$var$isTypedArray;

});
parcelRegister("b24im", function(module, exports) {

var $9ooXF = parcelRequire("9ooXF");

var $1UptS = parcelRequire("1UptS");

var $efn5V = parcelRequire("efn5V");
/** `Object#toString` result references. */ var $8083368f60c79bc0$var$argsTag = '[object Arguments]', $8083368f60c79bc0$var$arrayTag = '[object Array]', $8083368f60c79bc0$var$boolTag = '[object Boolean]', $8083368f60c79bc0$var$dateTag = '[object Date]', $8083368f60c79bc0$var$errorTag = '[object Error]', $8083368f60c79bc0$var$funcTag = '[object Function]', $8083368f60c79bc0$var$mapTag = '[object Map]', $8083368f60c79bc0$var$numberTag = '[object Number]', $8083368f60c79bc0$var$objectTag = '[object Object]', $8083368f60c79bc0$var$regexpTag = '[object RegExp]', $8083368f60c79bc0$var$setTag = '[object Set]', $8083368f60c79bc0$var$stringTag = '[object String]', $8083368f60c79bc0$var$weakMapTag = '[object WeakMap]';
var $8083368f60c79bc0$var$arrayBufferTag = '[object ArrayBuffer]', $8083368f60c79bc0$var$dataViewTag = '[object DataView]', $8083368f60c79bc0$var$float32Tag = '[object Float32Array]', $8083368f60c79bc0$var$float64Tag = '[object Float64Array]', $8083368f60c79bc0$var$int8Tag = '[object Int8Array]', $8083368f60c79bc0$var$int16Tag = '[object Int16Array]', $8083368f60c79bc0$var$int32Tag = '[object Int32Array]', $8083368f60c79bc0$var$uint8Tag = '[object Uint8Array]', $8083368f60c79bc0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $8083368f60c79bc0$var$uint16Tag = '[object Uint16Array]', $8083368f60c79bc0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $8083368f60c79bc0$var$typedArrayTags = {};
$8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$float32Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$float64Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$int8Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$int16Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$int32Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$uint8Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$uint8ClampedTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$uint16Tag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$uint32Tag] = true;
$8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$argsTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$arrayTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$arrayBufferTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$boolTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$dataViewTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$dateTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$errorTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$funcTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$mapTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$numberTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$objectTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$regexpTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$setTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$stringTag] = $8083368f60c79bc0$var$typedArrayTags[$8083368f60c79bc0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $8083368f60c79bc0$var$baseIsTypedArray(value) {
    return $efn5V(value) && $1UptS(value.length) && !!$8083368f60c79bc0$var$typedArrayTags[$9ooXF(value)];
}
module.exports = $8083368f60c79bc0$var$baseIsTypedArray;

});
parcelRegister("1UptS", function(module, exports) {
/** Used as references for various `Number` constants. */ var $163ec96656222f93$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $163ec96656222f93$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $163ec96656222f93$var$MAX_SAFE_INTEGER;
}
module.exports = $163ec96656222f93$var$isLength;

});


parcelRegister("kJ1X7", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $f1698654d2c4f811$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $f1698654d2c4f811$var$baseUnary;

});

parcelRegister("4rZX5", function(module, exports) {

var $itmd2 = parcelRequire("itmd2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $itmd2.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("cmztU", function(module, exports) {

var $2yI7S = parcelRequire("2yI7S");

var $inPTK = parcelRequire("inPTK");
/** Used for built-in method references. */ var $90030fffcece19dd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $90030fffcece19dd$var$hasOwnProperty = $90030fffcece19dd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $90030fffcece19dd$var$baseKeys(object) {
    if (!$2yI7S(object)) return $inPTK(object);
    var result = [];
    for(var key in Object(object))if ($90030fffcece19dd$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $90030fffcece19dd$var$baseKeys;

});
parcelRegister("2yI7S", function(module, exports) {
/** Used for built-in method references. */ var $1dd0fc4647b6bdbe$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $1dd0fc4647b6bdbe$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $1dd0fc4647b6bdbe$var$objectProto;
    return value === proto;
}
module.exports = $1dd0fc4647b6bdbe$var$isPrototype;

});

parcelRegister("inPTK", function(module, exports) {

var $aDAdP = parcelRequire("aDAdP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d622a1e1bb282a34$var$nativeKeys = $aDAdP(Object.keys, Object);
module.exports = $d622a1e1bb282a34$var$nativeKeys;

});
parcelRegister("aDAdP", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7be9a4dafcc4416d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $7be9a4dafcc4416d$var$overArg;

});



parcelRegister("4Occq", function(module, exports) {

var $3Hr6t = parcelRequire("3Hr6t");

var $1UptS = parcelRequire("1UptS");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $38054b769f6ba951$var$isArrayLike(value) {
    return value != null && $1UptS(value.length) && !$3Hr6t(value);
}
module.exports = $38054b769f6ba951$var$isArrayLike;

});



parcelRegister("2lcFi", function(module, exports) {

var $4Occq = parcelRequire("4Occq");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $1b475df58894acb3$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$4Occq(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $1b475df58894acb3$var$createBaseEach;

});



parcelRegister("hUuQW", function(module, exports) {

var $iGy1K = parcelRequire("iGy1K");

var $dqEzb = parcelRequire("dqEzb");

var $77uJf = parcelRequire("77uJf");

var $9yDvq = parcelRequire("9yDvq");

var $88Z00 = parcelRequire("88Z00");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $d09f995af8cc7d65$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $77uJf;
    if (typeof value == 'object') return $9yDvq(value) ? $dqEzb(value[0], value[1]) : $iGy1K(value);
    return $88Z00(value);
}
module.exports = $d09f995af8cc7d65$var$baseIteratee;

});
parcelRegister("iGy1K", function(module, exports) {

var $h5X8N = parcelRequire("h5X8N");

var $fugp7 = parcelRequire("fugp7");

var $6CM5s = parcelRequire("6CM5s");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $d9a68b57a132792d$var$baseMatches(source) {
    var matchData = $fugp7(source);
    if (matchData.length == 1 && matchData[0][2]) return $6CM5s(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $h5X8N(object, source, matchData);
    };
}
module.exports = $d9a68b57a132792d$var$baseMatches;

});
parcelRegister("h5X8N", function(module, exports) {

var $67W1a = parcelRequire("67W1a");

var $977JU = parcelRequire("977JU");
/** Used to compose bitmasks for value comparisons. */ var $c720c777dd5627b5$var$COMPARE_PARTIAL_FLAG = 1, $c720c777dd5627b5$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $c720c777dd5627b5$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $67W1a;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $977JU(srcValue, objValue, $c720c777dd5627b5$var$COMPARE_PARTIAL_FLAG | $c720c777dd5627b5$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $c720c777dd5627b5$var$baseIsMatch;

});
parcelRegister("67W1a", function(module, exports) {

var $94FgI = parcelRequire("94FgI");

var $lUG3t = parcelRequire("lUG3t");

var $hNpcE = parcelRequire("hNpcE");

var $2QQof = parcelRequire("2QQof");

var $jUTV7 = parcelRequire("jUTV7");

var $k8pGJ = parcelRequire("k8pGJ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $476066a9a00c86ed$var$Stack(entries) {
    var data = this.__data__ = new $94FgI(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$476066a9a00c86ed$var$Stack.prototype.clear = $lUG3t;
$476066a9a00c86ed$var$Stack.prototype['delete'] = $hNpcE;
$476066a9a00c86ed$var$Stack.prototype.get = $2QQof;
$476066a9a00c86ed$var$Stack.prototype.has = $jUTV7;
$476066a9a00c86ed$var$Stack.prototype.set = $k8pGJ;
module.exports = $476066a9a00c86ed$var$Stack;

});
parcelRegister("lUG3t", function(module, exports) {

var $94FgI = parcelRequire("94FgI");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $ff3f7329c3ddfd3f$var$stackClear() {
    this.__data__ = new $94FgI;
    this.size = 0;
}
module.exports = $ff3f7329c3ddfd3f$var$stackClear;

});

parcelRegister("hNpcE", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cf4a9015426112a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $cf4a9015426112a5$var$stackDelete;

});

parcelRegister("2QQof", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $213913b33f3dfb43$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $213913b33f3dfb43$var$stackGet;

});

parcelRegister("jUTV7", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e7fe9fdebaccf603$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $e7fe9fdebaccf603$var$stackHas;

});

parcelRegister("k8pGJ", function(module, exports) {

var $94FgI = parcelRequire("94FgI");

var $3LQIk = parcelRequire("3LQIk");

var $9rczp = parcelRequire("9rczp");
/** Used as the size to enable large array optimizations. */ var $ea887b26c091a785$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $ea887b26c091a785$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $94FgI) {
        var pairs = data.__data__;
        if (!$3LQIk || pairs.length < $ea887b26c091a785$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9rczp(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $ea887b26c091a785$var$stackSet;

});


parcelRegister("977JU", function(module, exports) {

var $f6R0c = parcelRequire("f6R0c");

var $efn5V = parcelRequire("efn5V");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6a2ac562c7b4a3fb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$efn5V(value) && !$efn5V(other)) return value !== value && other !== other;
    return $f6R0c(value, other, bitmask, customizer, $6a2ac562c7b4a3fb$var$baseIsEqual, stack);
}
module.exports = $6a2ac562c7b4a3fb$var$baseIsEqual;

});
parcelRegister("f6R0c", function(module, exports) {

var $67W1a = parcelRequire("67W1a");

var $lPLPi = parcelRequire("lPLPi");

var $l1BGE = parcelRequire("l1BGE");

var $igcjz = parcelRequire("igcjz");

var $eDwI8 = parcelRequire("eDwI8");

var $9yDvq = parcelRequire("9yDvq");

var $j3Y1z = parcelRequire("j3Y1z");

var $36ugb = parcelRequire("36ugb");
/** Used to compose bitmasks for value comparisons. */ var $b00087af3d26965e$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $b00087af3d26965e$var$argsTag = '[object Arguments]', $b00087af3d26965e$var$arrayTag = '[object Array]', $b00087af3d26965e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $b00087af3d26965e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b00087af3d26965e$var$hasOwnProperty = $b00087af3d26965e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b00087af3d26965e$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $9yDvq(object), othIsArr = $9yDvq(other), objTag = objIsArr ? $b00087af3d26965e$var$arrayTag : $eDwI8(object), othTag = othIsArr ? $b00087af3d26965e$var$arrayTag : $eDwI8(other);
    objTag = objTag == $b00087af3d26965e$var$argsTag ? $b00087af3d26965e$var$objectTag : objTag;
    othTag = othTag == $b00087af3d26965e$var$argsTag ? $b00087af3d26965e$var$objectTag : othTag;
    var objIsObj = objTag == $b00087af3d26965e$var$objectTag, othIsObj = othTag == $b00087af3d26965e$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $j3Y1z(object)) {
        if (!$j3Y1z(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $67W1a);
        return objIsArr || $36ugb(object) ? $lPLPi(object, other, bitmask, customizer, equalFunc, stack) : $l1BGE(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $b00087af3d26965e$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $b00087af3d26965e$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $b00087af3d26965e$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $67W1a);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $67W1a);
    return $igcjz(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $b00087af3d26965e$var$baseIsEqualDeep;

});
parcelRegister("lPLPi", function(module, exports) {

var $4Fs4j = parcelRequire("4Fs4j");

var $9JYN0 = parcelRequire("9JYN0");

var $9oeve = parcelRequire("9oeve");
/** Used to compose bitmasks for value comparisons. */ var $fe5375bcbcb1d770$var$COMPARE_PARTIAL_FLAG = 1, $fe5375bcbcb1d770$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $fe5375bcbcb1d770$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fe5375bcbcb1d770$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & $fe5375bcbcb1d770$var$COMPARE_UNORDERED_FLAG ? new $4Fs4j : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$9JYN0(other, function(othValue, othIndex) {
                if (!$9oeve(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $fe5375bcbcb1d770$var$equalArrays;

});
parcelRegister("4Fs4j", function(module, exports) {

var $9rczp = parcelRequire("9rczp");

var $dRa1d = parcelRequire("dRa1d");

var $gKVlv = parcelRequire("gKVlv");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $3660c3954b05b108$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9rczp;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$3660c3954b05b108$var$SetCache.prototype.add = $3660c3954b05b108$var$SetCache.prototype.push = $dRa1d;
$3660c3954b05b108$var$SetCache.prototype.has = $gKVlv;
module.exports = $3660c3954b05b108$var$SetCache;

});
parcelRegister("dRa1d", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $a167ff132cfcfa01$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $a167ff132cfcfa01$var$setCacheAdd(value) {
    this.__data__.set(value, $a167ff132cfcfa01$var$HASH_UNDEFINED);
    return this;
}
module.exports = $a167ff132cfcfa01$var$setCacheAdd;

});

parcelRegister("gKVlv", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $c32d6cee800ccba7$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $c32d6cee800ccba7$var$setCacheHas;

});


parcelRegister("9JYN0", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7177788a8afe489d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $7177788a8afe489d$var$arraySome;

});

parcelRegister("9oeve", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6d619ae3c38e3ab1$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $6d619ae3c38e3ab1$var$cacheHas;

});


parcelRegister("l1BGE", function(module, exports) {

var $8tMG2 = parcelRequire("8tMG2");

var $c82kU = parcelRequire("c82kU");

var $ii1fP = parcelRequire("ii1fP");

var $lPLPi = parcelRequire("lPLPi");

var $crACF = parcelRequire("crACF");

var $5hV8k = parcelRequire("5hV8k");
/** Used to compose bitmasks for value comparisons. */ var $f4e6ecd289999c25$var$COMPARE_PARTIAL_FLAG = 1, $f4e6ecd289999c25$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $f4e6ecd289999c25$var$boolTag = '[object Boolean]', $f4e6ecd289999c25$var$dateTag = '[object Date]', $f4e6ecd289999c25$var$errorTag = '[object Error]', $f4e6ecd289999c25$var$mapTag = '[object Map]', $f4e6ecd289999c25$var$numberTag = '[object Number]', $f4e6ecd289999c25$var$regexpTag = '[object RegExp]', $f4e6ecd289999c25$var$setTag = '[object Set]', $f4e6ecd289999c25$var$stringTag = '[object String]', $f4e6ecd289999c25$var$symbolTag = '[object Symbol]';
var $f4e6ecd289999c25$var$arrayBufferTag = '[object ArrayBuffer]', $f4e6ecd289999c25$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $f4e6ecd289999c25$var$symbolProto = $8tMG2 ? $8tMG2.prototype : undefined, $f4e6ecd289999c25$var$symbolValueOf = $f4e6ecd289999c25$var$symbolProto ? $f4e6ecd289999c25$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f4e6ecd289999c25$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $f4e6ecd289999c25$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $f4e6ecd289999c25$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $c82kU(object), new $c82kU(other))) return false;
            return true;
        case $f4e6ecd289999c25$var$boolTag:
        case $f4e6ecd289999c25$var$dateTag:
        case $f4e6ecd289999c25$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ii1fP(+object, +other);
        case $f4e6ecd289999c25$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $f4e6ecd289999c25$var$regexpTag:
        case $f4e6ecd289999c25$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $f4e6ecd289999c25$var$mapTag:
            var convert = $crACF;
        case $f4e6ecd289999c25$var$setTag:
            var isPartial = bitmask & $f4e6ecd289999c25$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $5hV8k);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $f4e6ecd289999c25$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $lPLPi(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $f4e6ecd289999c25$var$symbolTag:
            if ($f4e6ecd289999c25$var$symbolValueOf) return $f4e6ecd289999c25$var$symbolValueOf.call(object) == $f4e6ecd289999c25$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $f4e6ecd289999c25$var$equalByTag;

});
parcelRegister("c82kU", function(module, exports) {

var $4U0WH = parcelRequire("4U0WH");
/** Built-in value references. */ var $8d480b4f41e4dd24$var$Uint8Array = $4U0WH.Uint8Array;
module.exports = $8d480b4f41e4dd24$var$Uint8Array;

});

parcelRegister("crACF", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $90f46a2795ab4f70$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $90f46a2795ab4f70$var$mapToArray;

});

parcelRegister("5hV8k", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3d9adbc147541d27$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $3d9adbc147541d27$var$setToArray;

});


parcelRegister("igcjz", function(module, exports) {

var $hZ89v = parcelRequire("hZ89v");
/** Used to compose bitmasks for value comparisons. */ var $d4b346073607897d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $d4b346073607897d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4b346073607897d$var$hasOwnProperty = $d4b346073607897d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d4b346073607897d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d4b346073607897d$var$COMPARE_PARTIAL_FLAG, objProps = $hZ89v(object), objLength = objProps.length, othProps = $hZ89v(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $d4b346073607897d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $d4b346073607897d$var$equalObjects;

});
parcelRegister("hZ89v", function(module, exports) {

var $5iQJ7 = parcelRequire("5iQJ7");

var $835bL = parcelRequire("835bL");

var $ivNeF = parcelRequire("ivNeF");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d17e750c78384211$var$getAllKeys(object) {
    return $5iQJ7(object, $ivNeF, $835bL);
}
module.exports = $d17e750c78384211$var$getAllKeys;

});
parcelRegister("5iQJ7", function(module, exports) {

var $42oSY = parcelRequire("42oSY");

var $9yDvq = parcelRequire("9yDvq");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3dc788a403cf3ab8$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $9yDvq(object) ? result : $42oSY(result, symbolsFunc(object));
}
module.exports = $3dc788a403cf3ab8$var$baseGetAllKeys;

});
parcelRegister("42oSY", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2f0aa71a07232e93$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $2f0aa71a07232e93$var$arrayPush;

});


parcelRegister("835bL", function(module, exports) {

var $gxW9B = parcelRequire("gxW9B");

var $8hRfE = parcelRequire("8hRfE");
/** Used for built-in method references. */ var $5dc2a0e531bbc810$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5dc2a0e531bbc810$var$propertyIsEnumerable = $5dc2a0e531bbc810$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5dc2a0e531bbc810$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5dc2a0e531bbc810$var$getSymbols = !$5dc2a0e531bbc810$var$nativeGetSymbols ? $8hRfE : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $gxW9B($5dc2a0e531bbc810$var$nativeGetSymbols(object), function(symbol) {
        return $5dc2a0e531bbc810$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $5dc2a0e531bbc810$var$getSymbols;

});
parcelRegister("gxW9B", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $c0bcd68f71d071bb$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $c0bcd68f71d071bb$var$arrayFilter;

});

parcelRegister("8hRfE", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $608937e6581d3afb$var$stubArray() {
    return [];
}
module.exports = $608937e6581d3afb$var$stubArray;

});




parcelRegister("eDwI8", function(module, exports) {

var $61HSD = parcelRequire("61HSD");

var $3LQIk = parcelRequire("3LQIk");

var $hKiDf = parcelRequire("hKiDf");

var $gDURT = parcelRequire("gDURT");

var $4CLsU = parcelRequire("4CLsU");

var $9ooXF = parcelRequire("9ooXF");

var $7KX6U = parcelRequire("7KX6U");
/** `Object#toString` result references. */ var $aa7e14e73768e22e$var$mapTag = '[object Map]', $aa7e14e73768e22e$var$objectTag = '[object Object]', $aa7e14e73768e22e$var$promiseTag = '[object Promise]', $aa7e14e73768e22e$var$setTag = '[object Set]', $aa7e14e73768e22e$var$weakMapTag = '[object WeakMap]';
var $aa7e14e73768e22e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $aa7e14e73768e22e$var$dataViewCtorString = $7KX6U($61HSD), $aa7e14e73768e22e$var$mapCtorString = $7KX6U($3LQIk), $aa7e14e73768e22e$var$promiseCtorString = $7KX6U($hKiDf), $aa7e14e73768e22e$var$setCtorString = $7KX6U($gDURT), $aa7e14e73768e22e$var$weakMapCtorString = $7KX6U($4CLsU);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $aa7e14e73768e22e$var$getTag = $9ooXF;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($61HSD && $aa7e14e73768e22e$var$getTag(new $61HSD(new ArrayBuffer(1))) != $aa7e14e73768e22e$var$dataViewTag || $3LQIk && $aa7e14e73768e22e$var$getTag(new $3LQIk) != $aa7e14e73768e22e$var$mapTag || $hKiDf && $aa7e14e73768e22e$var$getTag($hKiDf.resolve()) != $aa7e14e73768e22e$var$promiseTag || $gDURT && $aa7e14e73768e22e$var$getTag(new $gDURT) != $aa7e14e73768e22e$var$setTag || $4CLsU && $aa7e14e73768e22e$var$getTag(new $4CLsU) != $aa7e14e73768e22e$var$weakMapTag) $aa7e14e73768e22e$var$getTag = function(value) {
    var result = $9ooXF(value), Ctor = result == $aa7e14e73768e22e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $7KX6U(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $aa7e14e73768e22e$var$dataViewCtorString:
            return $aa7e14e73768e22e$var$dataViewTag;
        case $aa7e14e73768e22e$var$mapCtorString:
            return $aa7e14e73768e22e$var$mapTag;
        case $aa7e14e73768e22e$var$promiseCtorString:
            return $aa7e14e73768e22e$var$promiseTag;
        case $aa7e14e73768e22e$var$setCtorString:
            return $aa7e14e73768e22e$var$setTag;
        case $aa7e14e73768e22e$var$weakMapCtorString:
            return $aa7e14e73768e22e$var$weakMapTag;
    }
    return result;
};
module.exports = $aa7e14e73768e22e$var$getTag;

});
parcelRegister("61HSD", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");

var $4U0WH = parcelRequire("4U0WH");
/* Built-in method references that are verified to be native. */ var $4634dfc1a402e711$var$DataView = $kXBTM($4U0WH, 'DataView');
module.exports = $4634dfc1a402e711$var$DataView;

});

parcelRegister("hKiDf", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");

var $4U0WH = parcelRequire("4U0WH");
/* Built-in method references that are verified to be native. */ var $ceb52f7db38e78a7$var$Promise = $kXBTM($4U0WH, 'Promise');
module.exports = $ceb52f7db38e78a7$var$Promise;

});

parcelRegister("gDURT", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");

var $4U0WH = parcelRequire("4U0WH");
/* Built-in method references that are verified to be native. */ var $c1dc66b530b5ebba$var$Set = $kXBTM($4U0WH, 'Set');
module.exports = $c1dc66b530b5ebba$var$Set;

});

parcelRegister("4CLsU", function(module, exports) {

var $kXBTM = parcelRequire("kXBTM");

var $4U0WH = parcelRequire("4U0WH");
/* Built-in method references that are verified to be native. */ var $35df87a1e8844ae3$var$WeakMap = $kXBTM($4U0WH, 'WeakMap');
module.exports = $35df87a1e8844ae3$var$WeakMap;

});





parcelRegister("fugp7", function(module, exports) {

var $lPo3s = parcelRequire("lPo3s");

var $ivNeF = parcelRequire("ivNeF");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $b46661df58e7c3b7$var$getMatchData(object) {
    var result = $ivNeF(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $lPo3s(value)
        ];
    }
    return result;
}
module.exports = $b46661df58e7c3b7$var$getMatchData;

});
parcelRegister("lPo3s", function(module, exports) {

var $5HTQb = parcelRequire("5HTQb");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $fe41053133cef68d$var$isStrictComparable(value) {
    return value === value && !$5HTQb(value);
}
module.exports = $fe41053133cef68d$var$isStrictComparable;

});


parcelRegister("6CM5s", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $4d2b97ca4972fd22$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $4d2b97ca4972fd22$var$matchesStrictComparable;

});


parcelRegister("dqEzb", function(module, exports) {

var $977JU = parcelRequire("977JU");

var $jWTe4 = parcelRequire("jWTe4");

var $d8sdd = parcelRequire("d8sdd");

var $4Gv9o = parcelRequire("4Gv9o");

var $lPo3s = parcelRequire("lPo3s");

var $6CM5s = parcelRequire("6CM5s");

var $2vQDZ = parcelRequire("2vQDZ");
/** Used to compose bitmasks for value comparisons. */ var $9c6d2bbc50d66202$var$COMPARE_PARTIAL_FLAG = 1, $9c6d2bbc50d66202$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9c6d2bbc50d66202$var$baseMatchesProperty(path, srcValue) {
    if ($4Gv9o(path) && $lPo3s(srcValue)) return $6CM5s($2vQDZ(path), srcValue);
    return function(object) {
        var objValue = $jWTe4(object, path);
        return objValue === undefined && objValue === srcValue ? $d8sdd(object, path) : $977JU(srcValue, objValue, $9c6d2bbc50d66202$var$COMPARE_PARTIAL_FLAG | $9c6d2bbc50d66202$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $9c6d2bbc50d66202$var$baseMatchesProperty;

});
parcelRegister("d8sdd", function(module, exports) {

var $1dcfP = parcelRequire("1dcfP");

var $fFtXj = parcelRequire("fFtXj");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $9901e81603bc4174$var$hasIn(object, path) {
    return object != null && $fFtXj(object, path, $1dcfP);
}
module.exports = $9901e81603bc4174$var$hasIn;

});
parcelRegister("1dcfP", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0e2082ca3d014513$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $0e2082ca3d014513$var$baseHasIn;

});

parcelRegister("fFtXj", function(module, exports) {

var $bftq9 = parcelRequire("bftq9");

var $dO1wD = parcelRequire("dO1wD");

var $9yDvq = parcelRequire("9yDvq");

var $7q8gD = parcelRequire("7q8gD");

var $1UptS = parcelRequire("1UptS");

var $2vQDZ = parcelRequire("2vQDZ");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b681ebe6abb617d9$var$hasPath(object, path, hasFunc) {
    path = $bftq9(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $2vQDZ(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1UptS(length) && $7q8gD(key, length) && ($9yDvq(object) || $dO1wD(object));
}
module.exports = $b681ebe6abb617d9$var$hasPath;

});



parcelRegister("77uJf", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $52f105eedc43bf83$var$identity(value) {
    return value;
}
module.exports = $52f105eedc43bf83$var$identity;

});

parcelRegister("88Z00", function(module, exports) {

var $evF66 = parcelRequire("evF66");

var $6DtH9 = parcelRequire("6DtH9");

var $4Gv9o = parcelRequire("4Gv9o");

var $2vQDZ = parcelRequire("2vQDZ");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $5ede63369938f003$var$property(path) {
    return $4Gv9o(path) ? $evF66($2vQDZ(path)) : $6DtH9(path);
}
module.exports = $5ede63369938f003$var$property;

});
parcelRegister("evF66", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a903d704e9b5af02$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $a903d704e9b5af02$var$baseProperty;

});

parcelRegister("6DtH9", function(module, exports) {

var $jS5c4 = parcelRequire("jS5c4");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4d4d6b62b1a36b50$var$basePropertyDeep(path) {
    return function(object) {
        return $jS5c4(object, path);
    };
}
module.exports = $4d4d6b62b1a36b50$var$basePropertyDeep;

});





parcelRegister("ihZKh", function(module, exports) {

var $a9Iuw = parcelRequire("a9Iuw");

var $bJjBi = parcelRequire("bJjBi");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $d509b5e6ec12aba3$var$find = $a9Iuw($bJjBi);
module.exports = $d509b5e6ec12aba3$var$find;

});
parcelRegister("a9Iuw", function(module, exports) {

var $hUuQW = parcelRequire("hUuQW");

var $4Occq = parcelRequire("4Occq");

var $ivNeF = parcelRequire("ivNeF");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $764d41b11ab7d9f5$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$4Occq(collection)) {
            var iteratee = $hUuQW(predicate, 3);
            collection = $ivNeF(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $764d41b11ab7d9f5$var$createFind;

});

parcelRegister("bJjBi", function(module, exports) {

var $gh84N = parcelRequire("gh84N");

var $hUuQW = parcelRequire("hUuQW");

var $iDvlx = parcelRequire("iDvlx");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $88a319f0b8076451$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $88a319f0b8076451$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $iDvlx(fromIndex);
    if (index < 0) index = $88a319f0b8076451$var$nativeMax(length + index, 0);
    return $gh84N(array, $hUuQW(predicate, 3), index);
}
module.exports = $88a319f0b8076451$var$findIndex;

});
parcelRegister("gh84N", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bd947faca4b526df$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $bd947faca4b526df$var$baseFindIndex;

});

parcelRegister("iDvlx", function(module, exports) {

var $fwAkU = parcelRequire("fwAkU");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $d9142f3afe860e6e$var$toInteger(value) {
    var result = $fwAkU(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $d9142f3afe860e6e$var$toInteger;

});
parcelRegister("fwAkU", function(module, exports) {

var $5XQif = parcelRequire("5XQif");
/** Used as references for various `Number` constants. */ var $b4d607cf2c8b3763$var$INFINITY = 1 / 0, $b4d607cf2c8b3763$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $b4d607cf2c8b3763$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $5XQif(value);
    if (value === $b4d607cf2c8b3763$var$INFINITY || value === -$b4d607cf2c8b3763$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $b4d607cf2c8b3763$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $b4d607cf2c8b3763$var$toFinite;

});
parcelRegister("5XQif", function(module, exports) {

var $5HTQb = parcelRequire("5HTQb");

var $5WTbi = parcelRequire("5WTbi");
/** Used as references for various `Number` constants. */ var $457b06cb8b12efe4$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $457b06cb8b12efe4$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $457b06cb8b12efe4$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $457b06cb8b12efe4$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $457b06cb8b12efe4$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $457b06cb8b12efe4$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $457b06cb8b12efe4$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5WTbi(value)) return $457b06cb8b12efe4$var$NAN;
    if ($5HTQb(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $5HTQb(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($457b06cb8b12efe4$var$reTrim, '');
    var isBinary = $457b06cb8b12efe4$var$reIsBinary.test(value);
    return isBinary || $457b06cb8b12efe4$var$reIsOctal.test(value) ? $457b06cb8b12efe4$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $457b06cb8b12efe4$var$reIsBadHex.test(value) ? $457b06cb8b12efe4$var$NAN : +value;
}
module.exports = $457b06cb8b12efe4$var$toNumber;

});





parcelRegister("41zvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $2ee2cd86a152960e$var$LoadCounts;

var $2ee2cd86a152960e$var$_filter = $2ee2cd86a152960e$var$_interopRequireDefault((parcelRequire("Aq07U")));

var $2ee2cd86a152960e$var$_groupBy = $2ee2cd86a152960e$var$_interopRequireDefault((parcelRequire("7fnPG")));
function $2ee2cd86a152960e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable no-restricted-syntax, guard-for-in */ function $2ee2cd86a152960e$var$LoadCounts(data) {
    var chartOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var counts = [];
    var types = chartOptions.types || {
        ballPropertyName: 'balls',
        strikePropertyName: 'strikes'
    };
    var _loop = function _loop(balls) {
        var _loop2 = function _loop2(strikes) {
            // Get different pitch types per count
            var pitchBreakdown = (0, $2ee2cd86a152960e$var$_filter["default"])(data, function(d) {
                return Number(d[types.strikePropertyName]) === strikes && Number(d[types.ballPropertyName]) === balls;
            });
            var percentages = (0, $2ee2cd86a152960e$var$_groupBy["default"])(pitchBreakdown, function(d) {
                return d.pitchType;
            });
            var count = 0;
            for(var percent in percentages)count += percentages[percent].length;
            var countBreakdown = {
                name: "".concat(balls).concat(strikes),
                strikes: strikes,
                balls: balls,
                layer: strikes + balls
            };
            var children = [];
            var totalPitches = 0;
            for(var _percent in percentages){
                var pitch = {};
                pitch.name = _percent;
                pitch.value = String(Number(percentages[_percent].length / count).toFixed(3));
                pitch.total = Number(percentages[_percent].length);
                pitch.isPitch = true;
                pitch.layer = countBreakdown.layer;
                pitch.pitchName = percentages[_percent][0].pitchName;
                totalPitches += percentages[_percent].length;
                children.push(pitch);
            }
            countBreakdown.children = children;
            countBreakdown.totalPitches = totalPitches;
            counts.push(countBreakdown);
        };
        for(var strikes = 0; strikes < 3; strikes++)_loop2(strikes);
    };
    for(var balls = 0; balls < 4; balls++)_loop(balls);
    return counts;
}

});
parcelRegister("Aq07U", function(module, exports) {

var $gxW9B = parcelRequire("gxW9B");

var $1S7FV = parcelRequire("1S7FV");

var $hUuQW = parcelRequire("hUuQW");

var $9yDvq = parcelRequire("9yDvq");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */ function $06d7882c2b7a6aa0$var$filter(collection, predicate) {
    var func = $9yDvq(collection) ? $gxW9B : $1S7FV;
    return func(collection, $hUuQW(predicate, 3));
}
module.exports = $06d7882c2b7a6aa0$var$filter;

});
parcelRegister("1S7FV", function(module, exports) {

var $1h9b0 = parcelRequire("1h9b0");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $15d0c9bb72119bf8$var$baseFilter(collection, predicate) {
    var result = [];
    $1h9b0(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $15d0c9bb72119bf8$var$baseFilter;

});


parcelRegister("7fnPG", function(module, exports) {

var $l8IaK = parcelRequire("l8IaK");

var $2zUiw = parcelRequire("2zUiw");
/** Used for built-in method references. */ var $546c6bc49dba28b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $546c6bc49dba28b1$var$hasOwnProperty = $546c6bc49dba28b1$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $546c6bc49dba28b1$var$groupBy = $2zUiw(function(result, value, key) {
    if ($546c6bc49dba28b1$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $l8IaK(result, key, [
        value
    ]);
});
module.exports = $546c6bc49dba28b1$var$groupBy;

});


parcelRegister("uw3x8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $cfc7a75c43df1f50$var$Color;

var $1CK2d = parcelRequire("1CK2d");
function $cfc7a75c43df1f50$var$Color(// TODO: Can we track down the remaining five outliers?
type, value) {
    try {
        if ((type === 'bb_type' || type === 'bbType' || type === 'battedBallType') && value && value !== 'NULL') {
            if (Number(value) === 4 || value === 'Ground Ball' || value === 'ground_ball') return '#B71484';
            if (Number(value) === 3 || value === 'Line Drive' || value === 'line_drive') return '#eced4d';
            if (Number(value) === 2 || value === 'Popup' || value === 'popup') return '#DE1E24';
            if (Number(value) === 1 || value === 'Fly Ball' || value === 'fly_ball') return '#505F39';
        }
        if (type === 'pitchResult' && value) {
            if (value === 'Ball' || value === 'ball' || value === 'blocked_ball') return '#1F77B4';
            if (value === 'Called Strike' || value === 'called_strike') return '#FF7F0E';
            if (value === 'Foul' || value.indexOf('foul') > -1) return '#2CA02C';
            if (value === 'In play, no out' || value === 'hit_into_play_no_out') return '#D62728';
            if (value === 'In play, out(s)' || value === 'hit_into_play') return '#9467BD';
            if (value === 'In play, run(s)' || value === 'hit_into_play_score') return '#8C564B';
            if (value === 'Swinging Strike' || value === 'swinging_strike' || value === 'swinging_strike_blocked') return '#E377C2';
            return '#000000';
        }
        if ((type === 'call_name' || type === 'callName') && value) {
            if (value.toLowerCase() === 'ball') return '#1F77B4';
            if (value.toLowerCase() === 'strike') return '#FF7F0E';
            if (value.toLowerCase() === 'in play' || value.toLowerCase() === 'in_play') return '#2CA02C';
            return '#000';
        }
        if (type === 'paResult' && value) try {
            if (value.toLowerCase() === 'single') return '#FE6100';
            if (value.toLowerCase() === 'double') return '#785EF0';
            if (value.toLowerCase() === 'triple') return '#FFB000';
            if (value.toLowerCase() === 'home_run' || value.toLowerCase() === 'home run') return '#DC267F';
            if (value.toLowerCase() === 'walk') return '#565D97';
            if (value.toLowerCase().indexOf('strikeout') > -1) return '#791734';
            if (value.toLowerCase().indexOf('sac') > -1) return '#cc6600';
            if (value.toLowerCase().indexOf('error') > -1) return '#999900';
            if (value.toLowerCase().indexOf('hit_by_pitch') > -1) return '#28282b';
            return '#c2c2c2';
        } catch (ex) {
            return '#c2c2c2';
        }
        if ((type === 'pitch_name' || type === 'pitchName' || type === 'pitch_type' || type === 'pitchType') && value) return (0, $1CK2d.getPitchTypeColor)(value, false);
        if (type === 'isInZone') // Would like to change these colors
        return value === 'false' ? 'rgb(121, 121, 255)' : 'rgb(235, 125, 115)';
    } catch (ex) {
        return '#c2c2c2';
    }
    if (type === 'homeRunTypes' && value) try {
        if (value === 'No Doubter') return '#ff5722';
        if (value === 'Mostly Gone') return '#3a9098';
        return '#9e9e9e';
    } catch (ex) {
        return '#c2c2c2';
    }
}

});
parcelRegister("1CK2d", function(module, exports) {
"use strict";
parcelRequire("blS65");
var $bxlao = parcelRequire("bxlao");

var $cbJvd = parcelRequire("cbJvd");
var $12ed0c91dd1ed4e8$var$getPitchTypeGroup = $cbJvd.getPitchTypeGroup;
// There is another file: bam-node-bdata-charts/utils/colors.js which has some colors and helper functions
// This is DB's attempt to standardize pitch type colors in one place
/**
 * @type {Object.<string, string>}
 */ var $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap = {
    '4-SEAM FASTBALL': 'FF',
    'FOUR SEAMER': 'FF',
    '2-SEAM FASTBALL': 'FT',
    SINKER: 'SI',
    CUTTER: 'FC',
    CHANGEUP: 'CH',
    'SPLIT FINGER': 'FS',
    'SPLIT-FINGER': 'FS',
    SPLITTER: 'FS',
    SCREWBALL: 'SC',
    FORKBALL: 'FO',
    SWEEPER: 'ST',
    SLIDER: 'SL',
    SLURVE: 'SV',
    CURVEBALL: 'CU',
    'KNUCKLE CURVE': 'KC',
    'KNUCKLE BALL': 'KN',
    KNUCKLEBALL: 'KN',
    'SLOW CURVE': 'CS',
    FF: 'FF',
    FT: 'FT',
    SI: 'SI',
    FC: 'FC',
    CH: 'CH',
    FS: 'FS',
    SC: 'SC',
    FO: 'FO',
    ST: 'ST',
    SL: 'SL',
    SV: 'SV',
    CU: 'CU',
    KC: 'KC',
    KN: 'KN',
    CS: 'CS',
    GY: 'GY',
    // Special ones?
    SIFT: 'FT',
    CHFS: 'CH',
    CUKC: 'CU',
    ALL: 'ALL',
    FASTBALL: 'FASTBALL',
    OFFSPEED: 'OFFSPEED',
    BREAKING: 'BREAKING'
};
/**
 * @typedef { { textColor: string, vizColor?: string } } PitchTypeColorObj
 */ // Always provide textColor, optionally provide vizColor
/**
 * @type Object.<string, PitchTypeColorObj>
 */ var $12ed0c91dd1ed4e8$var$pitchTypeColors = {
    FF: {
        textColor: '#D22D49'
    },
    FT: {
        textColor: '#DE6A04'
    },
    SI: {
        textColor: '#FE9D00'
    },
    FC: {
        textColor: '#933F2C'
    },
    CH: {
        textColor: '#1DBE3A'
    },
    FS: {
        textColor: '#3BACAC'
    },
    SC: {
        textColor: '#60DB33'
    },
    FO: {
        textColor: '#55CCAB'
    },
    ST: {
        textColor: '#DDB33A' // <<== NEW
    },
    SL: {
        textColor: '#C3BD0E',
        vizColor: '#EEE716'
    },
    SV: {
        textColor: '#93AFD4'
    },
    GY: {
        textColor: '#FFFF99' // <<== NEW
    },
    CU: {
        textColor: '#00D1ED'
    },
    KC: {
        textColor: '#6236CD'
    },
    KN: {
        textColor: '#3C44CD'
    },
    CS: {
        textColor: '#0068FF' // <<== NEW
    },
    ALL: {
        textColor: '#f00'
    },
    FASTBALL: {
        textColor: '#f00'
    },
    OFFSPEED: {
        vizColor: '#0f0',
        textColor: '#24CA24'
    },
    BREAKING: {
        textColor: '#00f'
    }
};
/**
 *
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeColor() {
    var pitchType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var useTextColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var upperPitchType = String(pitchType).toUpperCase();
    var pitchAbbrev = $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap[upperPitchType];
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType);
        return '#888888';
    }
    var _pitchTypeColors$pitc = $12ed0c91dd1ed4e8$var$pitchTypeColors[pitchAbbrev], textColor = _pitchTypeColors$pitc.textColor, vizColor = _pitchTypeColors$pitc.vizColor;
    return useTextColor ? textColor : vizColor || textColor;
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeColorGrouping(pitchType) {
    var useTextColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var pitchTypeGroup = $12ed0c91dd1ed4e8$var$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) // TODO: WHATTODO?
    return 'Unknown';
    return $12ed0c91dd1ed4e8$var$getPitchTypeColor(pitchTypeGroup, useTextColor);
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @param {number} darkerRatio
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor(pitchType) {
    var useTextColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var darkerRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var upperPitchType = String(pitchType).toUpperCase();
    var pitchAbbrev = $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap[upperPitchType];
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType);
        return '#888888';
    }
    var _pitchTypeColors$pitc2 = $12ed0c91dd1ed4e8$var$pitchTypeColors[pitchAbbrev], textColor = _pitchTypeColors$pitc2.textColor, vizColor = _pitchTypeColors$pitc2.vizColor;
    var returnColor = useTextColor ? textColor : vizColor || textColor;
    var color = $bxlao.default(returnColor);
    return color ? color.darker(darkerRatio).formatHex() : '#ccc';
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @param {number} darkerRatio
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColorGrouping(pitchType) {
    var useTextColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var darkerRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var pitchTypeGroup = $12ed0c91dd1ed4e8$var$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) return '#888888';
    return $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor(pitchTypeGroup, useTextColor, darkerRatio);
}
module.exports = {
    getPitchTypeColor: $12ed0c91dd1ed4e8$var$getPitchTypeColor,
    getPitchTypeColorGrouping: $12ed0c91dd1ed4e8$var$getPitchTypeColorGrouping,
    getPitchTypeOutlineColor: $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor,
    getPitchTypeOutlineColorGrouping: $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColorGrouping
};

});



parcelRegister("60K0S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $46066f6bea58bae8$var$PieChart;

var $46066f6bea58bae8$var$_react = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("J42oT")));

var $hAvpi = parcelRequire("hAvpi");
var $aRYI3 = parcelRequire("aRYI3");

var $csdlO = parcelRequire("csdlO");

var $gDbQf = parcelRequire("gDbQf");

var $46066f6bea58bae8$var$_countBy = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("jVTXl")));

var $46066f6bea58bae8$var$_find = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("ihZKh")));

var $46066f6bea58bae8$var$_LoadCounts = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("41zvR")));

var $46066f6bea58bae8$var$_ColorMap = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $46066f6bea58bae8$var$_NetworkPieLegend = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("e849R")));

var $46066f6bea58bae8$var$_Tooltip = $46066f6bea58bae8$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $3wgDt = parcelRequire("3wgDt");
function $46066f6bea58bae8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ var $46066f6bea58bae8$var$connections = [
    [
        '00',
        '01'
    ],
    [
        '00',
        '10'
    ],
    [
        '01',
        '02'
    ],
    [
        '02',
        '12'
    ],
    [
        '01',
        '11'
    ],
    [
        '10',
        '11'
    ],
    [
        '10',
        '20'
    ],
    [
        '11',
        '12'
    ],
    [
        '11',
        '21'
    ],
    [
        '12',
        '22'
    ],
    [
        '22',
        '32'
    ],
    [
        '20',
        '30'
    ],
    [
        '20',
        '21'
    ],
    [
        '30',
        '31'
    ],
    [
        '21',
        '22'
    ],
    [
        '21',
        '31'
    ],
    [
        '31',
        '32'
    ]
];
function $46066f6bea58bae8$var$PieChart(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    function handleMouseOver(event, tip) {
        (0, $46066f6bea58bae8$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $46066f6bea58bae8$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    var counts = settings.data;
    if (!chartOptions.skipDataProcess) counts = (0, $46066f6bea58bae8$var$_LoadCounts["default"])(settings.data, chartOptions);
    var pieChart = (0, $aRYI3.default)().sort(null).value(function(d) {
        return d.total;
    });
    var layerCount = (0, $46066f6bea58bae8$var$_countBy["default"])(counts, 'layer');
    var layers = [];
    var maxCircleSize = 75;
    var minCircleSize = 30;
    var scaleHeight = 0.24;
    if (settings.shape === 'twitter') scaleHeight = 0.34;
    // Array to store location of cx for connecting lines
    var xyLocations = [];
    var elements = [];
    var scaleX = function scaleX(d) {
        var layer = d.layer.toString();
        if (!layers[layer] && layers[d.layer.toString()] != 0) layers[layer] = 1;
        else layers[layer]++;
        var widthCircle = settings.vizWidth / (layerCount[d.layer] + 1);
        widthCircle *= layers[layer];
        return widthCircle;
    };
    var domain = (0, $gDbQf.default)(counts, function(d) {
        if (d.totalPitches > 0) return d.totalPitches;
    });
    var scaleCircle = (0, $csdlO.default)().domain(domain).range([
        minCircleSize,
        maxCircleSize
    ]);
    counts.map(function(count) {
        var makeArc = (0, $hAvpi.default)().innerRadius(0).outerRadius(maxCircleSize / 2 - 1);
        if (chartOptions.scaleRadius) makeArc = (0, $hAvpi.default)().innerRadius(0).outerRadius(scaleCircle(count.totalPitches) / 2 - 1);
        var arcs = pieChart(count.children);
        var xLocation = scaleX(count);
        xyLocations.push({
            layer: count.name,
            x: xLocation + maxCircleSize / 2,
            y: count.layer * (settings.height * scaleHeight) + maxCircleSize / 2
        });
        elements.push(/*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("g", {
            key: "g_".concat(count.name),
            transform: "translate(".concat(xLocation, ", ").concat(count.layer * (settings.height * scaleHeight), ")")
        }, /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("text", {
            x: maxCircleSize / 2,
            y: -maxCircleSize * 0.03,
            className: "network-label-text"
        }, count.balls, "-", count.strikes), arcs.map(function(arcValue, i) {
            var path = makeArc(arcValue);
            return /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("path", {
                key: "network_pie_".concat(i),
                transform: "translate(".concat(maxCircleSize / 2, ",").concat(maxCircleSize / 2, ")"),
                d: path,
                fill: (0, $46066f6bea58bae8$var$_ColorMap["default"])('pitchName', arcValue.data.name),
                stroke: "#000",
                onMouseOver: function onMouseOver(event) {
                    var html = "<div><b>Pitch Type</b>: ".concat(arcValue.data.pitchName, "<br/>").concat(arcValue.data.total, " ").concat(arcValue.data.total > 1 ? "Pitches" : "Pitch", "<br>").concat(Number(arcValue.data.value * 100).toFixed(1), "%</div>");
                    handleMouseOver(event, html);
                },
                onMouseOut: function onMouseOut(event) {
                    handleMouseOut(event, null);
                }
            });
        })));
    });
    $46066f6bea58bae8$var$connections.map(function(line, i) {
        var lineStart = (0, $46066f6bea58bae8$var$_find["default"])(xyLocations, function(d) {
            return d.layer === line[0];
        });
        var lineEnd = (0, $46066f6bea58bae8$var$_find["default"])(xyLocations, function(d) {
            return d.layer === line[1];
        });
        elements.unshift(/*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("g", {
            key: "connection_".concat(i)
        }, /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("line", {
            x1: lineStart.x,
            y1: lineStart.y,
            x2: lineEnd.x,
            y2: lineEnd.y,
            stroke: "#c2c2c2",
            strokeWidth: 1
        })));
    });
    return /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement($46066f6bea58bae8$var$_react["default"].Fragment, null, /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement("g", {
        id: "network"
    }, elements), chartOptions.scaleRadius ? /*#__PURE__*/ $46066f6bea58bae8$var$_react["default"].createElement($46066f6bea58bae8$var$_NetworkPieLegend["default"], {
        settings: settings,
        radiusScale: scaleCircle.range([
            minCircleSize / 2,
            maxCircleSize / 2
        ])
    }) : null);
}

});
parcelRegister("csdlO", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $911274c07c90152c$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $911274c07c90152c$export$2e2bcd8739ae039);

var $eRcVk = parcelRequire("eRcVk");

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");

var $2Xusf = parcelRequire("2Xusf");
function $911274c07c90152c$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $eRcVk.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $2Xusf.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $eRcVk.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $eRcVk.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $eRcVk.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $911274c07c90152c$export$2e2bcd8739ae039() {
    var scale = (0, $g7ot1.default)();
    scale.copy = function() {
        return (0, $g7ot1.copy)(scale, $911274c07c90152c$export$2e2bcd8739ae039());
    };
    (0, $9HCq2.initRange).apply(scale, arguments);
    return $911274c07c90152c$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("eRcVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad100a4535a01ba0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $ad100a4535a01ba0$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $ad100a4535a01ba0$export$81087d9b915d4ede);
var $ad100a4535a01ba0$var$e10 = Math.sqrt(50), $ad100a4535a01ba0$var$e5 = Math.sqrt(10), $ad100a4535a01ba0$var$e2 = Math.sqrt(2);
function $ad100a4535a01ba0$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $ad100a4535a01ba0$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $ad100a4535a01ba0$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $ad100a4535a01ba0$var$e10 ? 10 : error >= $ad100a4535a01ba0$var$e5 ? 5 : error >= $ad100a4535a01ba0$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $ad100a4535a01ba0$var$e10 ? 10 : error >= $ad100a4535a01ba0$var$e5 ? 5 : error >= $ad100a4535a01ba0$var$e2 ? 2 : 1);
}
function $ad100a4535a01ba0$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $ad100a4535a01ba0$var$e10) step1 *= 10;
    else if (error >= $ad100a4535a01ba0$var$e5) step1 *= 5;
    else if (error >= $ad100a4535a01ba0$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("g7ot1", function(module, exports) {

$parcel$export(module.exports, "identity", () => $bbc0477176bd0d2c$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $bbc0477176bd0d2c$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $bbc0477176bd0d2c$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $bbc0477176bd0d2c$export$2e2bcd8739ae039);

var $jwA8W = parcelRequire("jwA8W");

var $4ONh6 = parcelRequire("4ONh6");
var $34azb = parcelRequire("34azb");
var $kSfaZ = parcelRequire("kSfaZ");

var $kAzNi = parcelRequire("kAzNi");

var $cl20v = parcelRequire("cl20v");
var $bbc0477176bd0d2c$var$unit = [
    0,
    1
];
function $bbc0477176bd0d2c$export$f0954fd7d5368655(x) {
    return x;
}
function $bbc0477176bd0d2c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $kAzNi.default)(isNaN(b) ? NaN : 0.5);
}
function $bbc0477176bd0d2c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $bbc0477176bd0d2c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $bbc0477176bd0d2c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $bbc0477176bd0d2c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $bbc0477176bd0d2c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $bbc0477176bd0d2c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $jwA8W.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $bbc0477176bd0d2c$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $bbc0477176bd0d2c$export$6b468dcfb64c653c() {
    var domain = $bbc0477176bd0d2c$var$unit, range = $bbc0477176bd0d2c$var$unit, interpolate = (0, $4ONh6.default), transform, untransform, unknown, clamp = $bbc0477176bd0d2c$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $bbc0477176bd0d2c$export$f0954fd7d5368655) clamp = $bbc0477176bd0d2c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $bbc0477176bd0d2c$var$polymap : $bbc0477176bd0d2c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $34azb.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $cl20v.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $kSfaZ.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $bbc0477176bd0d2c$export$f0954fd7d5368655, rescale()) : clamp !== $bbc0477176bd0d2c$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $bbc0477176bd0d2c$export$2e2bcd8739ae039() {
    return $bbc0477176bd0d2c$export$6b468dcfb64c653c()($bbc0477176bd0d2c$export$f0954fd7d5368655, $bbc0477176bd0d2c$export$f0954fd7d5368655);
}

});
parcelRegister("jwA8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e36d0ac1b3a1d303$export$2e2bcd8739ae039);

var $5nFB0 = parcelRequire("5nFB0");

var $eRNYR = parcelRequire("eRNYR");

var $52j0M = parcelRequire("52j0M");
const $e36d0ac1b3a1d303$var$ascendingBisect = (0, $eRNYR.default)((0, $5nFB0.default));
const $e36d0ac1b3a1d303$export$4d945ad3ad5751b0 = $e36d0ac1b3a1d303$var$ascendingBisect.right;
const $e36d0ac1b3a1d303$export$df7d25c84ebd12a5 = $e36d0ac1b3a1d303$var$ascendingBisect.left;
const $e36d0ac1b3a1d303$export$c1cb828b1117c77b = (0, $eRNYR.default)((0, $52j0M.default)).center;
var $e36d0ac1b3a1d303$export$2e2bcd8739ae039 = $e36d0ac1b3a1d303$export$4d945ad3ad5751b0;

});
parcelRegister("5nFB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eaf5dc8707e2030$export$2e2bcd8739ae039);
function $3eaf5dc8707e2030$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("eRNYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2cc90c2b34fb53$export$2e2bcd8739ae039);

var $5nFB0 = parcelRequire("5nFB0");
function $ad2cc90c2b34fb53$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $ad2cc90c2b34fb53$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $ad2cc90c2b34fb53$var$ascendingComparator(f) {
    return (d, x)=>(0, $5nFB0.default)(f(d), x);
}

});

parcelRegister("52j0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aabe2f708193749$export$2e2bcd8739ae039);
function $3aabe2f708193749$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $3aabe2f708193749$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("kAzNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd2ef630020c529$export$2e2bcd8739ae039);
function $efd2ef630020c529$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("cl20v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb900c5b2f5fa17$export$2e2bcd8739ae039);
function $8fb900c5b2f5fa17$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("9HCq2", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $7105ee6afdfd6bec$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $7105ee6afdfd6bec$export$7d6b419e59e83f3d);
function $7105ee6afdfd6bec$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $7105ee6afdfd6bec$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("2Xusf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2278b72059def604$export$2e2bcd8739ae039);

var $eRcVk = parcelRequire("eRcVk");

var $haUiJ = parcelRequire("haUiJ");
var $1C4ra = parcelRequire("1C4ra");
var $4UzjU = parcelRequire("4UzjU");
var $l3ng3 = parcelRequire("l3ng3");
var $lLQAg = parcelRequire("lLQAg");
function $2278b72059def604$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $eRcVk.tickStep)(start, stop, count), precision;
    specifier = (0, $1C4ra.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $l3ng3.default)(step, value))) specifier.precision = precision;
            return (0, $haUiJ.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $lLQAg.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $4UzjU.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $haUiJ.format)(specifier);
}

});


parcelRegister("gDbQf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b9796205d69916$export$2e2bcd8739ae039);
function $c1b9796205d69916$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("e849R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a49509bd4292c761$var$PieLegend;

var $a49509bd4292c761$var$_react = $a49509bd4292c761$var$_interopRequireDefault((parcelRequire("J42oT")));
function $a49509bd4292c761$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $a49509bd4292c761$var$PieLegend(_ref) {
    var settings = _ref.settings, radiusScale = _ref.radiusScale;
    var domain = radiusScale.domain().reverse();
    var domainTotal = 0;
    // Get total sum of domain... if it equals 2 it has 1,1 in array which we don't want showing up on the legend
    for(var i = 0; i < domain.length; i++)domainTotal += domain[i];
    if (domainTotal == 2) domain = [
        1
    ];
    var translate = [
        settings.vizWidth * 1.02,
        settings.vizHeight * 0.85
    ];
    if (settings.orientation === 'portrait') translate = [
        settings.vizWidth / 1.2,
        settings.vizWidth * 1.2
    ];
    return /*#__PURE__*/ $a49509bd4292c761$var$_react["default"].createElement("g", {
        key: "pieLegend",
        id: "pieLegend",
        transform: "translate(".concat([
            translate
        ], ")")
    }, domain.map(function(d, i) {
        return /*#__PURE__*/ $a49509bd4292c761$var$_react["default"].createElement("g", {
            key: "g_".concat(i)
        }, /*#__PURE__*/ $a49509bd4292c761$var$_react["default"].createElement("circle", {
            key: "pieLegendPath_".concat(i),
            r: radiusScale(d),
            transform: "translate(0, ".concat(i * 60, ")"),
            fill: "none",
            stroke: "#000"
        }), /*#__PURE__*/ $a49509bd4292c761$var$_react["default"].createElement("text", {
            key: "pieLegendText_".concat(i),
            className: "legend",
            dy: "4",
            transform: "translate(46, ".concat(i * 61, ")"),
            fill: "#000",
            style: {
                fontSize: "1rem"
            }
        }, d ? d : '', " ", d ? d === 1 ? 'Pitch' : 'Pitches' : ''));
    }));
}

});

parcelRegister("ksMP3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $218af1bc2d51c599$var$Tooltip;

var $218af1bc2d51c599$var$_get = $218af1bc2d51c599$var$_interopRequireDefault((parcelRequire("jWTe4")));
function $218af1bc2d51c599$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable no-param-reassign */ // These shouldn't be changing since neither the tooltip nor the viz is resized with the window.
var $218af1bc2d51c599$var$TIP_HEIGHT_DEFAULT = 202;
var $218af1bc2d51c599$var$TIP_OVERFLOW_OFFSET = 20;
var $218af1bc2d51c599$var$TIP_FOUL_OFFSET = 34;
var $218af1bc2d51c599$var$TIP_IN_PLAY_OFFSET = 63;
var $218af1bc2d51c599$var$VIZ_RIGHT_EDGE = 650;
function $218af1bc2d51c599$var$Tooltip(event, settings, tipElement) {
    var tipData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!tipData) {
        tipElement.innerHTML = '';
        return;
    }
    var x;
    var y;
    var eventData = (0, $218af1bc2d51c599$var$_get["default"])(event, 'currentTarget.cx');
    var target = event.currentTarget;
    if (eventData) {
        x = target.cx.baseVal.value + 5;
        y = target.cy.baseVal.value;
    } else {
        x = target.transform.baseVal[0].matrix.e;
        y = target.transform.baseVal[0].matrix.f;
    }
    var tipHeight = $218af1bc2d51c599$var$TIP_HEIGHT_DEFAULT;
    var width = settings.vizWidth / 2 + 10;
    var tipWidth = width;
    // TODO: Why wasn't this necessary in the current PR?
    if (tipData.includes('Foul') && tipData.includes('Exit Velocity')) // Vertical tooltip offset for foul balls (with EV/LA lines)
    tipHeight += $218af1bc2d51c599$var$TIP_FOUL_OFFSET;
    else if (tipData.includes('(Blocked)')) // Offset for Swinging Strike (Blocked) wrapping to new line
    tipHeight += $218af1bc2d51c599$var$TIP_OVERFLOW_OFFSET;
    else if (tipData.includes('Contact Type:')) {
        // Offset for in-play balls introducing exit velo, contact type lines
        tipHeight += $218af1bc2d51c599$var$TIP_IN_PLAY_OFFSET;
        if (!tipData.includes('Exit Velocity')) // Offset for in-play balls that do not have EV/LA data
        tipHeight -= $218af1bc2d51c599$var$TIP_FOUL_OFFSET;
        if (tipData.includes('Double Play')) tipHeight += $218af1bc2d51c599$var$TIP_OVERFLOW_OFFSET;
    }
    if (y + tipHeight > settings.vizHeight) y -= tipHeight;
    var xOffset = 10;
    if (x + tipWidth > $218af1bc2d51c599$var$VIZ_RIGHT_EDGE) x -= width + xOffset;
    else x += xOffset;
    tipElement.innerHTML = "\n        <foreignObject x=".concat(x, " y=").concat(y, " width=").concat(width, " height=").concat(settings.vizHeight, ">\n                <div class=\"evp-svg-tooltip\">\n                ").concat(tipData, "\n                </div>\n        </foreignObject>\n        ");
}

});


parcelRegister("gSr2G", function(module, exports) {
"use strict";
function $c496aa83d97eb510$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c496aa83d97eb510$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c496aa83d97eb510$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c496aa83d97eb510$var$ReleasePoint;

var $c496aa83d97eb510$var$_react = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $jy52E = parcelRequire("jy52E");
var $1izgn = parcelRequire("1izgn");


var $c496aa83d97eb510$var$_filter = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("Aq07U")));

var $c496aa83d97eb510$var$d3Color = $c496aa83d97eb510$var$_interopRequireWildcard((parcelRequire("hA40b")));
parcelRequire("1k8Kz");

var $c496aa83d97eb510$var$_ColorMap = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $c496aa83d97eb510$var$_Legend = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $c496aa83d97eb510$var$_Tooltip = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $c496aa83d97eb510$var$_SingleEvent = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("1WMBp")));

var $c496aa83d97eb510$var$_setTextColorWithBackground = $c496aa83d97eb510$var$_interopRequireDefault((parcelRequire("koIK5")));

var $3wgDt = parcelRequire("3wgDt");
function $c496aa83d97eb510$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c496aa83d97eb510$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c496aa83d97eb510$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $c496aa83d97eb510$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c496aa83d97eb510$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c496aa83d97eb510$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $c496aa83d97eb510$var$ReleasePoint(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    var pitchData = settings.data;
    var legendType = chartOptions.legendType;
    var x = (0, $csdlO.default)().range([
        0,
        settings.vizWidth
    ]).domain([
        -9,
        9
    ]);
    var y = (0, $csdlO.default)().range([
        settings.vizHeight,
        0
    ]).domain([
        0,
        9
    ]);
    function handleMouseOver(event, tip) {
        (0, $c496aa83d97eb510$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $c496aa83d97eb510$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    var radiusSize = 3;
    if (chartOptions.labelPitches && pitchData.length >= 1000) radiusSize = 10;
    else if (chartOptions.labelPitches && pitchData.length >= 100) radiusSize = 8;
    else if (chartOptions.labelPitches && pitchData.length >= 10) radiusSize = 6;
    else if (chartOptions.labelPitches && pitchData.length >= 1) radiusSize = 5;
    var path = (0, $1izgn.default)().x(function(d) {
        return x(d[0]);
    }).y(function(d) {
        return y(d[1]);
    }).curve($jy52E.default);
    var yLabels = [
        8,
        6,
        4,
        2
    ];
    var xLabels = [
        -6,
        -4,
        -2,
        0,
        2,
        4,
        6
    ];
    return /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement($c496aa83d97eb510$var$_react["default"].Fragment, null, /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("g", {
        id: "releaseChart"
    }, /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("line", {
        x1: x(-9),
        x2: x(9),
        y1: y(8),
        y2: y(8),
        stroke: "#eeeeee"
    }), xLabels.map(function(label, i) {
        return /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement($c496aa83d97eb510$var$_react["default"].Fragment, {
            key: "key_xrpLabel_".concat(i)
        }, /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("line", {
            key: "xLabelLine_".concat(i),
            x1: x(label),
            x2: x(label),
            y1: y(0),
            y2: y(8),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("text", {
            key: "xLabelText_".concat(i),
            x: x(label),
            y: y(8.05),
            className: "release-point-axis-label"
        }, label != 0 ? "".concat(Math.abs(label), "ft") : null));
    }), yLabels.map(function(label, i) {
        return /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement($c496aa83d97eb510$var$_react["default"].Fragment, {
            key: "key_yrpLabel_".concat(i)
        }, /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("line", {
            key: "yLabelLine_".concat(i),
            x1: x(-9),
            x2: x(9),
            y1: y(label),
            y2: y(label),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("text", {
            key: "yLabelText_".concat(i),
            x: x(-8.8),
            y: y(label + 0.05),
            className: "release-point-axis-label"
        }, label, "ft"));
    }), /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("path", {
        d: path([
            [
                -9,
                0
            ],
            [
                0,
                0.8
            ],
            [
                9,
                0
            ]
        ]),
        className: "mound"
    }), pitchData.map(function(d, i) {
        return /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("g", {
            key: "g_rp_key_".concat(i),
            transform: "translate(".concat(x(d.x), ",").concat(y(d.y), ")"),
            style: {
                cursor: 'pointer'
            },
            onMouseOver: function onMouseOver(event) {
                var html = (0, $c496aa83d97eb510$var$_SingleEvent["default"])(d);
                handleMouseOver(event, html);
            },
            onMouseOut: function onMouseOut(event) {
                handleMouseOut(event, d);
            },
            onClick: function onClick() {
                if (d.game_year >= 2017) window.open("https://baseballsavant.mlb.com/sporty-videos?playId=".concat(d.play_id));
            }
        }, /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("circle", {
            key: "rp_".concat(i),
            r: radiusSize / settings.vizScale,
            opacity: chartOptions.opacity,
            fill: (0, $c496aa83d97eb510$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]),
            stroke: "black"
        }), chartOptions.labelPitches ? /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement("text", {
            className: "pitch-label",
            key: "rp_text_key_".concat(i),
            id: "text_".concat(i),
            textAnchor: "middle",
            dy: 4,
            fill: (0, $c496aa83d97eb510$var$_setTextColorWithBackground["default"])((0, $c496aa83d97eb510$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]))
        }, i + 1) : null);
    })), chartOptions.legend ? /*#__PURE__*/ $c496aa83d97eb510$var$_react["default"].createElement($c496aa83d97eb510$var$_Legend["default"], {
        settings: settings,
        type: chartOptions.legendType
    }) : null);
}

});
parcelRegister("hA40b", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("3BZ8u")).default);
$parcel$export(module.exports, "rgb", () => (parcelRequire("3BZ8u")).rgb);
$parcel$export(module.exports, "hsl", () => (parcelRequire("3BZ8u")).hsl);
$parcel$export(module.exports, "lab", () => (parcelRequire("8GCmV")).default);
$parcel$export(module.exports, "hcl", () => (parcelRequire("8GCmV")).hcl);
$parcel$export(module.exports, "lch", () => (parcelRequire("8GCmV")).lch);
$parcel$export(module.exports, "gray", () => (parcelRequire("8GCmV")).gray);
$parcel$export(module.exports, "cubehelix", () => (parcelRequire("7gKfE")).default);

var $3BZ8u = parcelRequire("3BZ8u");

var $8GCmV = parcelRequire("8GCmV");

var $7gKfE = parcelRequire("7gKfE");

});
parcelRegister("3BZ8u", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $6jhEZ = parcelRequire("6jhEZ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $6jhEZ.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $6jhEZ.default)(Rgb, rgb, (0, $6jhEZ.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $6jhEZ.default)(Hsl, hsl, (0, $6jhEZ.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("6jhEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4982375e5f38018f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $4982375e5f38018f$export$8b58be045bf06082);
function $4982375e5f38018f$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $4982375e5f38018f$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("8GCmV", function(module, exports) {

$parcel$export(module.exports, "gray", () => $65300230882f31ce$export$3e2c219d3ab79d01);
$parcel$export(module.exports, "default", () => $65300230882f31ce$export$2e2bcd8739ae039);
$parcel$export(module.exports, "lch", () => $65300230882f31ce$export$5a21418738164530);
$parcel$export(module.exports, "hcl", () => $65300230882f31ce$export$d0e870ba50062ff1);

var $6jhEZ = parcelRequire("6jhEZ");

var $3BZ8u = parcelRequire("3BZ8u");

var $fRGt4 = parcelRequire("fRGt4");
// https://observablehq.com/@mbostock/lab-and-rgb
const $65300230882f31ce$var$K = 18, $65300230882f31ce$var$Xn = 0.96422, $65300230882f31ce$var$Yn = 1, $65300230882f31ce$var$Zn = 0.82521, $65300230882f31ce$var$t0 = 4 / 29, $65300230882f31ce$var$t1 = 6 / 29, $65300230882f31ce$var$t2 = 3 * $65300230882f31ce$var$t1 * $65300230882f31ce$var$t1, $65300230882f31ce$var$t3 = $65300230882f31ce$var$t1 * $65300230882f31ce$var$t1 * $65300230882f31ce$var$t1;
function $65300230882f31ce$var$labConvert(o) {
    if (o instanceof $65300230882f31ce$export$f2722c70a60257f7) return new $65300230882f31ce$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $65300230882f31ce$export$d9397e094a5fbb9a) return $65300230882f31ce$var$hcl2lab(o);
    if (!(o instanceof (0, $3BZ8u.Rgb))) o = (0, $3BZ8u.rgbConvert)(o);
    var r = $65300230882f31ce$var$rgb2lrgb(o.r), g = $65300230882f31ce$var$rgb2lrgb(o.g), b = $65300230882f31ce$var$rgb2lrgb(o.b), y = $65300230882f31ce$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $65300230882f31ce$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $65300230882f31ce$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $65300230882f31ce$var$Xn);
        z = $65300230882f31ce$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $65300230882f31ce$var$Zn);
    }
    return new $65300230882f31ce$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $65300230882f31ce$export$3e2c219d3ab79d01(l, opacity) {
    return new $65300230882f31ce$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $65300230882f31ce$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $65300230882f31ce$var$labConvert(l) : new $65300230882f31ce$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $65300230882f31ce$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $6jhEZ.default)($65300230882f31ce$export$f2722c70a60257f7, $65300230882f31ce$export$2e2bcd8739ae039, (0, $6jhEZ.extend)((0, $3BZ8u.Color), {
    brighter (k) {
        return new $65300230882f31ce$export$f2722c70a60257f7(this.l + $65300230882f31ce$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $65300230882f31ce$export$f2722c70a60257f7(this.l - $65300230882f31ce$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $65300230882f31ce$var$Xn * $65300230882f31ce$var$lab2xyz(x);
        y = $65300230882f31ce$var$Yn * $65300230882f31ce$var$lab2xyz(y);
        z = $65300230882f31ce$var$Zn * $65300230882f31ce$var$lab2xyz(z);
        return new (0, $3BZ8u.Rgb)($65300230882f31ce$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $65300230882f31ce$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $65300230882f31ce$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $65300230882f31ce$var$xyz2lab(t) {
    return t > $65300230882f31ce$var$t3 ? Math.pow(t, 1 / 3) : t / $65300230882f31ce$var$t2 + $65300230882f31ce$var$t0;
}
function $65300230882f31ce$var$lab2xyz(t) {
    return t > $65300230882f31ce$var$t1 ? t * t * t : $65300230882f31ce$var$t2 * (t - $65300230882f31ce$var$t0);
}
function $65300230882f31ce$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $65300230882f31ce$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $65300230882f31ce$var$hclConvert(o) {
    if (o instanceof $65300230882f31ce$export$d9397e094a5fbb9a) return new $65300230882f31ce$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $65300230882f31ce$export$f2722c70a60257f7)) o = $65300230882f31ce$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $65300230882f31ce$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $fRGt4.degrees);
    return new $65300230882f31ce$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $65300230882f31ce$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $65300230882f31ce$var$hclConvert(l) : new $65300230882f31ce$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $65300230882f31ce$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $65300230882f31ce$var$hclConvert(h) : new $65300230882f31ce$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $65300230882f31ce$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $65300230882f31ce$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $65300230882f31ce$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $fRGt4.radians);
    return new $65300230882f31ce$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $6jhEZ.default)($65300230882f31ce$export$d9397e094a5fbb9a, $65300230882f31ce$export$d0e870ba50062ff1, (0, $6jhEZ.extend)((0, $3BZ8u.Color), {
    brighter (k) {
        return new $65300230882f31ce$export$d9397e094a5fbb9a(this.h, this.c, this.l + $65300230882f31ce$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $65300230882f31ce$export$d9397e094a5fbb9a(this.h, this.c, this.l - $65300230882f31ce$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $65300230882f31ce$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("fRGt4", function(module, exports) {

$parcel$export(module.exports, "radians", () => $b8ccbf78a3f5156e$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $b8ccbf78a3f5156e$export$41fc368e1a942b97);
const $b8ccbf78a3f5156e$export$8449e153fbd325fc = Math.PI / 180;
const $b8ccbf78a3f5156e$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("7gKfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ade79cc54f71a1$export$2e2bcd8739ae039);

var $6jhEZ = parcelRequire("6jhEZ");

var $3BZ8u = parcelRequire("3BZ8u");

var $fRGt4 = parcelRequire("fRGt4");
var $54ade79cc54f71a1$var$A = -0.14861, $54ade79cc54f71a1$var$B = 1.78277, $54ade79cc54f71a1$var$C = -0.29227, $54ade79cc54f71a1$var$D = -0.90649, $54ade79cc54f71a1$var$E = 1.97294, $54ade79cc54f71a1$var$ED = $54ade79cc54f71a1$var$E * $54ade79cc54f71a1$var$D, $54ade79cc54f71a1$var$EB = $54ade79cc54f71a1$var$E * $54ade79cc54f71a1$var$B, $54ade79cc54f71a1$var$BC_DA = $54ade79cc54f71a1$var$B * $54ade79cc54f71a1$var$C - $54ade79cc54f71a1$var$D * $54ade79cc54f71a1$var$A;
function $54ade79cc54f71a1$var$cubehelixConvert(o) {
    if (o instanceof $54ade79cc54f71a1$export$57ed4bde61a1e2f2) return new $54ade79cc54f71a1$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $3BZ8u.Rgb))) o = (0, $3BZ8u.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($54ade79cc54f71a1$var$BC_DA * b + $54ade79cc54f71a1$var$ED * r - $54ade79cc54f71a1$var$EB * g) / ($54ade79cc54f71a1$var$BC_DA + $54ade79cc54f71a1$var$ED - $54ade79cc54f71a1$var$EB), bl = b - l, k = ($54ade79cc54f71a1$var$E * (g - l) - $54ade79cc54f71a1$var$C * bl) / $54ade79cc54f71a1$var$D, s = Math.sqrt(k * k + bl * bl) / ($54ade79cc54f71a1$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $fRGt4.degrees) - 120 : NaN;
    return new $54ade79cc54f71a1$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $54ade79cc54f71a1$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $54ade79cc54f71a1$var$cubehelixConvert(h) : new $54ade79cc54f71a1$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $54ade79cc54f71a1$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $6jhEZ.default)($54ade79cc54f71a1$export$57ed4bde61a1e2f2, $54ade79cc54f71a1$export$2e2bcd8739ae039, (0, $6jhEZ.extend)((0, $3BZ8u.Color), {
    brighter (k) {
        k = k == null ? (0, $3BZ8u.brighter) : Math.pow((0, $3BZ8u.brighter), k);
        return new $54ade79cc54f71a1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $3BZ8u.darker) : Math.pow((0, $3BZ8u.darker), k);
        return new $54ade79cc54f71a1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $fRGt4.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $3BZ8u.Rgb)(255 * (l + a * ($54ade79cc54f71a1$var$A * cosh + $54ade79cc54f71a1$var$B * sinh)), 255 * (l + a * ($54ade79cc54f71a1$var$C * cosh + $54ade79cc54f71a1$var$D * sinh)), 255 * (l + a * ($54ade79cc54f71a1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("ixwYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d55ef3f6d16dad37$var$Legend;

var $d55ef3f6d16dad37$var$_react = $d55ef3f6d16dad37$var$_interopRequireDefault((parcelRequire("J42oT")));

var $d55ef3f6d16dad37$var$_groupBy = $d55ef3f6d16dad37$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $d55ef3f6d16dad37$var$_sortBy = $d55ef3f6d16dad37$var$_interopRequireDefault((parcelRequire("fChqD")));

var $d55ef3f6d16dad37$var$_find = $d55ef3f6d16dad37$var$_interopRequireDefault((parcelRequire("ihZKh")));

var $d55ef3f6d16dad37$var$_ColorMap = $d55ef3f6d16dad37$var$_interopRequireDefault((parcelRequire("uw3x8")));
function $d55ef3f6d16dad37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $d55ef3f6d16dad37$var$_slicedToArray(r, e) {
    return $d55ef3f6d16dad37$var$_arrayWithHoles(r) || $d55ef3f6d16dad37$var$_iterableToArrayLimit(r, e) || $d55ef3f6d16dad37$var$_unsupportedIterableToArray(r, e) || $d55ef3f6d16dad37$var$_nonIterableRest();
}
function $d55ef3f6d16dad37$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d55ef3f6d16dad37$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d55ef3f6d16dad37$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d55ef3f6d16dad37$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d55ef3f6d16dad37$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d55ef3f6d16dad37$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d55ef3f6d16dad37$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */  // import { RemoveBadPitchPoints } from '../Utilities/RemoveBadPoints.ts'
/*
Current Supported Legend Types:
'callName': from gumbo, 'STRIKE', 'BALL', 'IN PLAY'
'paResult':
'pitchResult':
'pitchName':

*/ function $d55ef3f6d16dad37$var$Legend(_ref) {
    var settings = _ref.settings, _ref$type = _ref.type, type = _ref$type === void 0 ? 'pitchName' : _ref$type, _ref$preFormatted = _ref.preFormatted, preFormatted = _ref$preFormatted === void 0 ? false : _ref$preFormatted, handleMouseOver = _ref.handleMouseOver, handleMouseOut = _ref.handleMouseOut, handleClick = _ref.handleClick;
    var legendData = preFormatted ? settings.data : $d55ef3f6d16dad37$var$formatData(settings.data, type);
    var SCALE_SPACING = 36;
    var SCALE_RADIUS = 5;
    var SPLIT_COUNT = 5;
    var COLUMN_LENGTH = 200;
    var column = 0;
    var translate = [
        settings.vizWidth * 1.05,
        0
    ];
    if (settings.orientation === 'portrait') {
        translate = [
            0,
            settings.vizWidth * 1.12
        ];
        column = -COLUMN_LENGTH;
    }
    var ySize = 0;
    return /*#__PURE__*/ $d55ef3f6d16dad37$var$_react["default"].createElement("g", {
        id: "legend",
        transform: "translate(".concat(translate, ")")
    }, legendData.filter(function(d) {
        return type === 'battedBallType' ? d.eventFormatted !== 'NULL' : d;
    }).map(function(d, i) {
        ySize += 1;
        // If in portrait orientation split legend into multiple columns
        if (settings.orientation === 'portrait' && i % SPLIT_COUNT === 0) {
            column += COLUMN_LENGTH;
            ySize = 0;
        }
        return /*#__PURE__*/ $d55ef3f6d16dad37$var$_react["default"].createElement("g", {
            key: "pitchLegend_".concat(d.eventFormatted + d.pitchType),
            onMouseOver: function onMouseOver(e) {
                return handleMouseOver && handleMouseOver(e, d);
            },
            onMouseOut: function onMouseOut(e) {
                return handleMouseOut && handleMouseOut(e, d);
            },
            onClick: function onClick(e) {
                return handleClick && handleClick(e, d);
            }
        }, /*#__PURE__*/ $d55ef3f6d16dad37$var$_react["default"].createElement("text", {
            key: "legend_text_".concat(d.eventFormatted + d.pitchType),
            x: column,
            y: ySize * SCALE_SPACING,
            className: "legend",
            style: {
                fontSize: "1rem"
            }
        }, d.eventFormatted), /*#__PURE__*/ $d55ef3f6d16dad37$var$_react["default"].createElement("circle", {
            key: "legend_circle_".concat(d.pitchType),
            cx: column - 14,
            cy: ySize * SCALE_SPACING - 6,
            r: SCALE_RADIUS / settings.vizScale,
            stroke: "#000",
            fill: (0, $d55ef3f6d16dad37$var$_ColorMap["default"])(type, d.event)
        }));
    }));
}
function $d55ef3f6d16dad37$var$formatPitches(groupedData) {
    return Object.entries(groupedData).sort(function(_ref2, _ref3) {
        var _ref4 = $d55ef3f6d16dad37$var$_slicedToArray(_ref2, 2), valueA = _ref4[1];
        var _ref5 = $d55ef3f6d16dad37$var$_slicedToArray(_ref3, 2), valueB = _ref5[1];
        return valueA.length > valueB.length ? -1 : 1;
    }).map(function(_ref6) {
        var _ref7 = $d55ef3f6d16dad37$var$_slicedToArray(_ref6, 1), event = _ref7[0];
        var eventFormatted = event.toUpperCase().split('_').join(' ');
        return {
            eventFormatted: eventFormatted,
            event: event,
            sort: 1
        };
    });
}
function $d55ef3f6d16dad37$var$formatData(data, type) {
    var types = (0, $d55ef3f6d16dad37$var$_groupBy["default"])(data, function(d) {
        return d[type];
    });
    var whiteList = [
        'battedBallType',
        'pitchName',
        'pitchResult'
    ];
    if (whiteList.includes(type)) return $d55ef3f6d16dad37$var$formatPitches(types);
    if (type === 'isInZone') return [
        {
            event: 'true',
            eventFormatted: 'IN STRIKE ZONE',
            sort: 1
        },
        {
            event: 'false',
            eventFormatted: 'OUTSIDE ZONE',
            sort: 1
        }
    ];
    var nonHits = [];
    var hits = [];
    // eslint-disable-next-line no-restricted-syntax
    for(var event in types)if (event && event !== 'null') {
        if (event === 'grounded_into_double_play') event = 'GIDP';
        var eventFormatted = event.toUpperCase().split('_').join(' ');
        if (eventFormatted === 'SINGLE') hits.push({
            eventFormatted: eventFormatted,
            event: event,
            sort: 1
        });
        else if (eventFormatted === 'DOUBLE') hits.push({
            eventFormatted: eventFormatted,
            event: event,
            sort: 2
        });
        else if (eventFormatted === 'TRIPLE') hits.push({
            eventFormatted: eventFormatted,
            event: event,
            sort: 3
        });
        else if (eventFormatted === 'HOME RUN') hits.push({
            eventFormatted: eventFormatted,
            event: event,
            sort: 4
        });
        else if (eventFormatted === 'WALK') nonHits.push({
            eventFormatted: 'WALK',
            event: event,
            sort: -2
        });
        else if (eventFormatted === 'IN PROGRESS') nonHits.push({
            eventFormatted: 'IN PROGRESS',
            event: event,
            sort: -2
        });
        else if (eventFormatted.indexOf('SAC') > -1 && !(0, $d55ef3f6d16dad37$var$_find["default"])(nonHits, function(d) {
            return d.eventFormatted === 'SACRIFICE';
        })) nonHits.push({
            eventFormatted: 'SACRIFICE',
            event: 'sacrifice',
            sort: 2
        });
        else if (eventFormatted.indexOf('ERROR') > -1 && !(0, $d55ef3f6d16dad37$var$_find["default"])(nonHits, function(d) {
            return d.eventFormatted.indexOf('ERROR') > -1;
        })) nonHits.push({
            eventFormatted: 'ERROR',
            event: 'error',
            sort: 1
        });
        else if (eventFormatted.indexOf('STRIKEOUT') > -1 && !(0, $d55ef3f6d16dad37$var$_find["default"])(nonHits, function(d) {
            return d.eventFormatted.indexOf('STRIKEOUT') > -1;
        })) nonHits.push({
            eventFormatted: 'STRIKEOUT',
            event: 'strikeout',
            sort: -1
        });
        else if (eventFormatted.indexOf('HIT BY PITCH') > -1 && !(0, $d55ef3f6d16dad37$var$_find["default"])(nonHits, function(d) {
            return d.eventFormatted.indexOf('HIT BY PITCH') > -1;
        })) nonHits.push({
            eventFormatted: 'HIT BY PITCH',
            event: 'hit_by_pitch',
            sort: -1
        });
        else if (type === 'description' && event.indexOf('hit_into_play') > -1) nonHits.push({
            eventFormatted: eventFormatted.replace('HIT INTO PLAY', 'IN PLAY'),
            event: event,
            sort: 0
        });
        else if (type === 'callName' && eventFormatted === 'STRIKE') nonHits.push({
            eventFormatted: 'STRIKE',
            event: event,
            sort: 1
        });
        else if (type === 'callName' && eventFormatted === 'BALL') nonHits.push({
            eventFormatted: 'BALL',
            event: event,
            sort: 2
        });
        else if (type === 'callName' && eventFormatted === 'IN PLAY') nonHits.push({
            eventFormatted: 'IN PLAY',
            event: event,
            sort: 3
        });
        else if (!nonHits.find(function(d) {
            return d.eventFormatted === 'FIELD OUT';
        })) nonHits.push({
            eventFormatted: 'FIELD OUT',
            event: 'field_out',
            sort: 0
        });
    }
    hits = (0, $d55ef3f6d16dad37$var$_sortBy["default"])(hits, 'sort');
    if (hits.length > 0) hits[hits.length - 1].isLast = 1;
    nonHits = (0, $d55ef3f6d16dad37$var$_sortBy["default"])(nonHits, 'sort');
    return hits.concat(nonHits);
}

});
parcelRegister("fChqD", function(module, exports) {

var $kgMRD = parcelRequire("kgMRD");

var $bTUVC = parcelRequire("bTUVC");

var $1Qr8x = parcelRequire("1Qr8x");

var $cYbK3 = parcelRequire("cYbK3");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */ var $b5e7ec8f6fedbc9c$var$sortBy = $1Qr8x(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $cYbK3(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $cYbK3(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $bTUVC(collection, $kgMRD(iteratees, 1), []);
});
module.exports = $b5e7ec8f6fedbc9c$var$sortBy;

});
parcelRegister("kgMRD", function(module, exports) {

var $42oSY = parcelRequire("42oSY");

var $ftdY1 = parcelRequire("ftdY1");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $ec1b34ab8e3eea11$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ftdY1);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $ec1b34ab8e3eea11$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $42oSY(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $ec1b34ab8e3eea11$var$baseFlatten;

});
parcelRegister("ftdY1", function(module, exports) {

var $8tMG2 = parcelRequire("8tMG2");

var $dO1wD = parcelRequire("dO1wD");

var $9yDvq = parcelRequire("9yDvq");
/** Built-in value references. */ var $b4346606fa608e2b$var$spreadableSymbol = $8tMG2 ? $8tMG2.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $b4346606fa608e2b$var$isFlattenable(value) {
    return $9yDvq(value) || $dO1wD(value) || !!($b4346606fa608e2b$var$spreadableSymbol && value && value[$b4346606fa608e2b$var$spreadableSymbol]);
}
module.exports = $b4346606fa608e2b$var$isFlattenable;

});


parcelRegister("bTUVC", function(module, exports) {

var $e9Ynw = parcelRequire("e9Ynw");

var $hUuQW = parcelRequire("hUuQW");

var $f3TrK = parcelRequire("f3TrK");

var $AInIY = parcelRequire("AInIY");

var $kJ1X7 = parcelRequire("kJ1X7");

var $3I2W1 = parcelRequire("3I2W1");

var $77uJf = parcelRequire("77uJf");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $8aa0fd8d4c2db995$var$baseOrderBy(collection, iteratees, orders) {
    var index = -1;
    iteratees = $e9Ynw(iteratees.length ? iteratees : [
        $77uJf
    ], $kJ1X7($hUuQW));
    var result = $f3TrK(collection, function(value, key, collection) {
        var criteria = $e9Ynw(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $AInIY(result, function(object, other) {
        return $3I2W1(object, other, orders);
    });
}
module.exports = $8aa0fd8d4c2db995$var$baseOrderBy;

});
parcelRegister("f3TrK", function(module, exports) {

var $1h9b0 = parcelRequire("1h9b0");

var $4Occq = parcelRequire("4Occq");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $af7225612882a60c$var$baseMap(collection, iteratee) {
    var index = -1, result = $4Occq(collection) ? Array(collection.length) : [];
    $1h9b0(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $af7225612882a60c$var$baseMap;

});

parcelRegister("AInIY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $06e5ca2dceae0fdc$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $06e5ca2dceae0fdc$var$baseSortBy;

});

parcelRegister("3I2W1", function(module, exports) {

var $cR27B = parcelRequire("cR27B");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $2b37c1f0c47300fc$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $cR27B(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $2b37c1f0c47300fc$var$compareMultiple;

});
parcelRegister("cR27B", function(module, exports) {

var $5WTbi = parcelRequire("5WTbi");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $95bc14999751b9e6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $5WTbi(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $5WTbi(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $95bc14999751b9e6$var$compareAscending;

});



parcelRegister("1Qr8x", function(module, exports) {

var $77uJf = parcelRequire("77uJf");

var $dGnSG = parcelRequire("dGnSG");

var $bnN9p = parcelRequire("bnN9p");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $157fb293b9f09e0f$var$baseRest(func, start) {
    return $bnN9p($dGnSG(func, start, $77uJf), func + '');
}
module.exports = $157fb293b9f09e0f$var$baseRest;

});
parcelRegister("dGnSG", function(module, exports) {

var $bDCSC = parcelRequire("bDCSC");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9f61b8decb1db2c8$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $9f61b8decb1db2c8$var$overRest(func, start, transform) {
    start = $9f61b8decb1db2c8$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $9f61b8decb1db2c8$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $bDCSC(func, this, otherArgs);
    };
}
module.exports = $9f61b8decb1db2c8$var$overRest;

});
parcelRegister("bDCSC", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $87917ef86b5a86f9$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $87917ef86b5a86f9$var$apply;

});


parcelRegister("bnN9p", function(module, exports) {

var $040JJ = parcelRequire("040JJ");

var $alFBY = parcelRequire("alFBY");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $8497f7fc94d337d2$var$setToString = $alFBY($040JJ);
module.exports = $8497f7fc94d337d2$var$setToString;

});
parcelRegister("040JJ", function(module, exports) {

var $lpXKU = parcelRequire("lpXKU");

var $7sYG2 = parcelRequire("7sYG2");

var $77uJf = parcelRequire("77uJf");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $00c0f21a26315921$var$baseSetToString = !$7sYG2 ? $77uJf : function(func, string) {
    return $7sYG2(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $lpXKU(string),
        'writable': true
    });
};
module.exports = $00c0f21a26315921$var$baseSetToString;

});
parcelRegister("lpXKU", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f97a490349197abe$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $f97a490349197abe$var$constant;

});


parcelRegister("alFBY", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $788c24bab2b5dc3c$var$HOT_COUNT = 800, $788c24bab2b5dc3c$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $788c24bab2b5dc3c$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $788c24bab2b5dc3c$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $788c24bab2b5dc3c$var$nativeNow(), remaining = $788c24bab2b5dc3c$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $788c24bab2b5dc3c$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $788c24bab2b5dc3c$var$shortOut;

});



parcelRegister("cYbK3", function(module, exports) {

var $ii1fP = parcelRequire("ii1fP");

var $4Occq = parcelRequire("4Occq");

var $7q8gD = parcelRequire("7q8gD");

var $5HTQb = parcelRequire("5HTQb");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $9714324c4f0a5507$var$isIterateeCall(value, index, object) {
    if (!$5HTQb(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $4Occq(object) && $7q8gD(index, object.length) : type == 'string' && index in object) return $ii1fP(object[index], value);
    return false;
}
module.exports = $9714324c4f0a5507$var$isIterateeCall;

});



parcelRegister("koIK5", function(module, exports) {
"use strict";
function $9977350c630bb193$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9977350c630bb193$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9977350c630bb193$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9977350c630bb193$var$setTextColorWithBackground;

var $9977350c630bb193$var$d3 = $9977350c630bb193$var$_interopRequireWildcard((parcelRequire("blS65")));
function $9977350c630bb193$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9977350c630bb193$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9977350c630bb193$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9977350c630bb193$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9977350c630bb193$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/**
 * Returns contrasting text color (#000 or #fff) for a background color.
 */ function $9977350c630bb193$var$setTextColorWithBackground(input) {
    if (input == null) return '#000';
    var parsed;
    if (typeof input === 'string') parsed = $9977350c630bb193$var$d3.color(input);
    else if ('r' in input && 'g' in input && 'b' in input) parsed = $9977350c630bb193$var$d3.rgb(input.r, input.g, input.b);
    else parsed = $9977350c630bb193$var$d3.rgb(input);
    if (!parsed) return '#000';
    var _d3$rgb = $9977350c630bb193$var$d3.rgb(parsed), r = _d3$rgb.r, g = _d3$rgb.g, b = _d3$rgb.b;
    var luminance = Math.round((r * 299 + g * 587 + b * 114) / 1000);
    return luminance > 125 ? '#000' : '#fff';
}

});


parcelRegister("mWIIN", function(module, exports) {
"use strict";
function $044f9ad1df26b22f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $044f9ad1df26b22f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $044f9ad1df26b22f$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $044f9ad1df26b22f$var$Scatter;

var $044f9ad1df26b22f$var$_react = $044f9ad1df26b22f$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $jy52E = parcelRequire("jy52E");
var $1izgn = parcelRequire("1izgn");

var $044f9ad1df26b22f$var$d3Color = $044f9ad1df26b22f$var$_interopRequireWildcard((parcelRequire("hA40b")));

var $044f9ad1df26b22f$var$_ColorMap = $044f9ad1df26b22f$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $044f9ad1df26b22f$var$_Legend = $044f9ad1df26b22f$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $044f9ad1df26b22f$var$_Tooltip = $044f9ad1df26b22f$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $044f9ad1df26b22f$var$_setTextColorWithBackground = $044f9ad1df26b22f$var$_interopRequireDefault((parcelRequire("koIK5")));

var $3wgDt = parcelRequire("3wgDt");
function $044f9ad1df26b22f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($044f9ad1df26b22f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $044f9ad1df26b22f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $044f9ad1df26b22f$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $044f9ad1df26b22f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $044f9ad1df26b22f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $044f9ad1df26b22f$var$Scatter(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    var pitchData = settings.data;
    var x = (0, $csdlO.default)().range([
        0,
        settings.vizWidth
    ]).domain([
        -3,
        4
    ]);
    var y = (0, $csdlO.default)().range([
        settings.vizHeight,
        0
    ]).domain([
        -8,
        1
    ]);
    function handleMouseOver(event, tip) {
        (0, $044f9ad1df26b22f$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $044f9ad1df26b22f$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    var radiusSize = 3;
    if (chartOptions.labelPitches && pitchData.length >= 1000) radiusSize = 10;
    else if (chartOptions.labelPitches && pitchData.length >= 100) radiusSize = 8;
    else if (chartOptions.labelPitches && pitchData.length >= 10) radiusSize = 6;
    else if (chartOptions.labelPitches && pitchData.length >= 1) radiusSize = 5;
    var path = (0, $1izgn.default)().x(function(d) {
        return x(d[0]);
    }).y(function(d) {
        return y(d[1]);
    }).curve($jy52E.default);
    var yLabels = chartOptions.yLabels || [
        -1,
        -2,
        -3,
        -4,
        -5,
        -6,
        -7
    ];
    var xLabels = [
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3
    ];
    return /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement($044f9ad1df26b22f$var$_react["default"].Fragment, null, /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("g", {
        id: "movementChart"
    }, /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("line", {
        x1: x(-3),
        x2: x(3),
        y1: y(0),
        y2: y(0),
        stroke: "#eeeeee"
    }), xLabels.map(function(label, i) {
        return /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement($044f9ad1df26b22f$var$_react["default"].Fragment, {
            key: "scatter_xLabel_".concat(i)
        }, /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("line", {
            key: "xLabelLine_".concat(i),
            x1: x(label),
            x2: x(label),
            y1: y(0),
            y2: y(-7),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("text", {
            key: "xLabelText_".concat(i),
            x: x(label),
            y: y(0.05),
            textAnchor: "middle",
            className: "release-point-axis-label"
        }, label != 0 ? "".concat(Math.abs(label) * 12, "\"") : null));
    }), yLabels.map(function(label, i) {
        return /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement($044f9ad1df26b22f$var$_react["default"].Fragment, {
            key: "scatter_yLabel_".concat(i)
        }, /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("line", {
            key: "yLabelLine_".concat(i),
            x1: x(-3),
            x2: x(3),
            y1: y(label),
            y2: y(label),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("text", {
            key: "yLabelText_".concat(i),
            x: x(-3.6),
            y: y(label + 0.05),
            className: "release-point-axis-label"
        }, label * 12, "\""));
    }), pitchData.map(function(d, i) {
        return /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("g", {
            key: "g_scatter_key_".concat(i),
            transform: "translate(".concat(x(d.x), ",").concat(y(d.y), ")"),
            style: {
                cursor: 'pointer'
            },
            onMouseOver: function onMouseOver(event) {
                var html = d.tooltip;
                if (html) handleMouseOver(event, html);
            },
            onMouseOut: function onMouseOut(event) {
                handleMouseOut(event, d);
            },
            onClick: function onClick() {
                if (d.videoUrl) window.open(d.videoUrl);
            }
        }, /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("circle", {
            key: "pm_".concat(i),
            r: radiusSize / settings.vizScale,
            opacity: chartOptions.opacity,
            fill: (0, $044f9ad1df26b22f$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]),
            stroke: "black"
        }), chartOptions.labelPitches ? /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement("text", {
            className: "pitch-label",
            key: "rp_text_key_".concat(i),
            id: "text_".concat(i),
            textAnchor: "middle",
            dy: 4,
            fill: (0, $044f9ad1df26b22f$var$_setTextColorWithBackground["default"])((0, $044f9ad1df26b22f$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]))
        }, i + 1) : null);
    })), chartOptions.legend ? /*#__PURE__*/ $044f9ad1df26b22f$var$_react["default"].createElement($044f9ad1df26b22f$var$_Legend["default"], {
        settings: settings,
        type: chartOptions.legendType
    }) : null);
}

});

parcelRegister("9Ab9m", function(module, exports) {
"use strict";
function $6fa020017718572d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6fa020017718572d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6fa020017718572d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6fa020017718572d$var$Pitches;

var $6fa020017718572d$var$_react = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $fyOQE = parcelRequire("fyOQE");

var $1izgn = parcelRequire("1izgn");

var $6fa020017718572d$var$_filter = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("Aq07U")));

var $6fa020017718572d$var$_groupBy = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $6fa020017718572d$var$d3Color = $6fa020017718572d$var$_interopRequireWildcard((parcelRequire("hA40b")));
parcelRequire("1k8Kz");

var $6fa020017718572d$var$_ColorMap = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $6fa020017718572d$var$_Tooltip = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $6fa020017718572d$var$_Legend = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $6fa020017718572d$var$_setTextColorWithBackground = $6fa020017718572d$var$_interopRequireDefault((parcelRequire("koIK5")));

var $3wgDt = parcelRequire("3wgDt");
function $6fa020017718572d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fa020017718572d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fa020017718572d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6fa020017718572d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6fa020017718572d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6fa020017718572d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $6fa020017718572d$var$Pitches(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    var pitchData = settings.data;
    var groupData = chartOptions.groupBy;
    // Field to bind
    var yField = chartOptions.yField || 'releaseSpeed';
    // Unit (MPH, RPM) for Label
    var unit = chartOptions.unit || 'MPH';
    // Used to set the range between horizontal lines (10 MPH)
    var yRangeSize = chartOptions.yRange || 10;
    if (chartOptions.autoFilterBadPoints) pitchData = (0, $6fa020017718572d$var$_filter["default"])(pitchData, function(d) {
        return d[yField] && d[yField] !== null && d[yField] !== '' && Number(d[yField]) > 0;
    });
    var groupedData = (0, $6fa020017718572d$var$_groupBy["default"])(pitchData, function(d) {
        return d[groupData];
    });
    // Default x, y MPH
    var xDomain = [
        0,
        1
    ];
    var yDomain = [
        60,
        105
    ];
    if (chartOptions.yDomain) yDomain = chartOptions.yDomain;
    var max = 1;
    var pitchTypes = [];
    if (chartOptions.xDomain) xDomain = chartOptions.xDomain;
    else {
        for(var type in groupedData){
            if (groupedData[type].length > max) max = groupedData[type].length;
            pitchTypes.push(groupedData[type]);
        }
        xDomain = [
            1,
            max
        ];
    }
    var path = (0, $1izgn.default)().x(function(d, i) {
        return x(i + 1);
    }).y(function(d) {
        return y(d[yField]);
    });
    var x = (0, $csdlO.default)().range([
        0,
        settings.vizWidth
    ]).domain(xDomain);
    var y = (0, $csdlO.default)().range([
        settings.vizHeight,
        0
    ]).domain(yDomain);
    var yRange;
    var hideTopLegendValue = false;
    if (yDomain[0] < yDomain[1]) yRange = (0, $fyOQE.default)(yDomain[0], yDomain[1], yRangeSize);
    else {
        hideTopLegendValue = true;
        yRange = (0, $fyOQE.default)(yDomain[1], yDomain[0], yRangeSize);
    }
    var xRangeUgly = (0, $fyOQE.default)(xDomain[0], xDomain[1], xDomain[1] / 5);
    var xScale = (0, $csdlO.default)().domain(xRangeUgly).nice();
    var xRange = xScale.ticks(5);
    function handleMouseOver(event, tip) {
        (0, $6fa020017718572d$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $6fa020017718572d$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    var radiusSize = 2;
    var xContainerAdjustment = settings.shape === 'snap' ? -30 : -20;
    var yContainerAdjustment = settings.shape === 'snap' ? -50 : 10;
    return /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement($6fa020017718572d$var$_react["default"].Fragment, null, /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("g", {
        transform: "translate(".concat(xContainerAdjustment, ", ").concat(yContainerAdjustment, ")"),
        id: "lineGraph"
    }, /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("line", {
        x1: x(xDomain[0]),
        x2: x(xDomain[1]),
        y1: y(yDomain[0]),
        y2: y(yDomain[0]),
        stroke: "#eeeeee"
    }), /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("line", {
        x1: x(1),
        x2: x(1),
        y1: y(yDomain[0]),
        y2: y(yDomain[1]),
        stroke: "#eeeeee"
    }), /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("text", {
        x: settings.vizWidth / 2,
        y: y(yDomain[0]),
        dy: 30,
        textAnchor: "middle"
    }, "Pitches"), xRange.map(function(label, i) {
        return /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement($6fa020017718572d$var$_react["default"].Fragment, {
            key: "xLabelLineFrag_".concat(i + 1)
        }, /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("line", {
            key: "xLabelLine_".concat(i + 1),
            id: "xLabelLine_".concat(i + 1),
            x1: x(Number(label) == 0 ? Number(label) + 1 : label),
            x2: x(Number(label) == 0 ? Number(label) + 1 : label),
            y1: y(yDomain[0]),
            y2: y(yDomain[1]),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("text", {
            key: "xLabelText_".concat(i),
            id: "xLabelText_".concat(i),
            x: x(label),
            y: y(yDomain[0]),
            dy: 14,
            className: "line-graph-x-axis-label",
            textAnchor: "middle"
        }, i === xRange.length ? "" : label != 0 ? Math.abs(label) : null));
    }), yRange.map(function(label, i) {
        return /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement($6fa020017718572d$var$_react["default"].Fragment, {
            key: "yLabelLineFrag_".concat(i + 1)
        }, /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("line", {
            key: "yLabelLine_".concat(i),
            x1: x(xDomain[0]),
            x2: x(xDomain[1]),
            y1: y(label),
            y2: y(label),
            stroke: "#f0f0f0"
        }), /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("text", {
            key: "yLabelText_".concat(i),
            x: x(xDomain[0]) / 1.1,
            y: y(label),
            dx: -5,
            className: "line-graph-y-axis-label"
        }, i === 0 && hideTopLegendValue ? "" : label != 0 ? "".concat(label, " ").concat(unit) : "".concat(label, " ").concat(unit)));
    }), pitchTypes.map(function(pitches, z) {
        return /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("path", {
            key: "linePitch_".concat(z),
            d: path(pitches),
            fill: "none",
            strokeWidth: 2,
            stroke: (0, $6fa020017718572d$var$_ColorMap["default"])(chartOptions.legendType, pitches[0][chartOptions.legendType])
        });
    }), pitchTypes.map(function(pitches, z) {
        return pitches.map(function(d, i) {
            return /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("g", {
                key: "g_rp_key_".concat(i),
                transform: "translate(".concat(x(i + 1), ",").concat(y(Number(d[yField])), ")"),
                style: {
                    cursor: 'pointer'
                },
                onMouseOver: function onMouseOver(event) {
                    var html = d.tooltip;
                    if (html) handleMouseOver(event, html);
                },
                onMouseOut: function onMouseOut(event) {
                    handleMouseOut(event, d);
                },
                onClick: function onClick() {
                    if (d.videoUrl) window.open(d.videoUrl);
                }
            }, /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("circle", {
                key: "rp_".concat(i),
                r: radiusSize / settings.vizScale,
                opacity: chartOptions.opacity,
                fill: (0, $6fa020017718572d$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]),
                stroke: "black"
            }), chartOptions.labelPitches ? /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement("text", {
                className: "pitch-label",
                key: "rp_text_key_".concat(i),
                id: "text_".concat(i),
                textAnchor: "middle",
                dy: 4,
                fill: (0, $6fa020017718572d$var$_setTextColorWithBackground["default"])((0, $6fa020017718572d$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]))
            }, i + 1) : null);
        });
    })), chartOptions.legend ? /*#__PURE__*/ $6fa020017718572d$var$_react["default"].createElement($6fa020017718572d$var$_Legend["default"], {
        settings: settings,
        type: chartOptions.legendType
    }) : null);
}

});
parcelRegister("fyOQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5417961efe6ef61$export$2e2bcd8739ae039);
function $b5417961efe6ef61$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});


parcelRegister("eJm9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ab9674ce280c28d9$var$FieldSVG;

var $ab9674ce280c28d9$var$_react = $ab9674ce280c28d9$var$_interopRequireDefault((parcelRequire("J42oT")));

var $ab9674ce280c28d9$var$_FieldVisual = $ab9674ce280c28d9$var$_interopRequireDefault((parcelRequire("fVj9G")));

var $ab9674ce280c28d9$var$_VenueMap = $ab9674ce280c28d9$var$_interopRequireDefault((parcelRequire("iUko2")));
function $ab9674ce280c28d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/prop-types */ var $ab9674ce280c28d9$var$pos = {
    lf: 'translate(-100,-300) scale(3)',
    cf: 'translate(-500,-160) scale(3)',
    rf: 'translate(-850,-300) scale(3)',
    first: 'translate(-900,-1100) scale(4)',
    second: 'translate(-835,-875) scale(4)',
    ss: 'translate(-700,-875) scale(4)',
    third: 'translate(-650,-1050) scale(4)',
    all: ''
};
function $ab9674ce280c28d9$var$FieldSVG(_ref) {
    var settings = _ref.settings, chartOptions = _ref.chartOptions, _ref$venueId = _ref.venueId, venueId = _ref$venueId === void 0 ? '7' : _ref$venueId;
    var Venue = $ab9674ce280c28d9$var$_VenueMap["default"][venueId];
    if (Venue) {
        var compassVisibility = 'hidden';
        var distancesVisibility = !chartOptions.hideFieldDistances ? 'visible' : 'hidden';
        var gWrapperClass = 'evp-venue-svg';
        return /*#__PURE__*/ $ab9674ce280c28d9$var$_react["default"].createElement("g", {
            id: gWrapperClass
        }, /*#__PURE__*/ $ab9674ce280c28d9$var$_react["default"].createElement(Venue, {
            width: settings.vizWidth,
            height: settings.vizHeight
        }), /*#__PURE__*/ $ab9674ce280c28d9$var$_react["default"].createElement("style", null, "\n                        #grass, #grass_1_, #grass_00000174589876715782793730000007613552633814403240_, #grass_00000090994939672626314830000016650827298536189595_ { fill: #b2dfdb; }\n                        #infield_sand, #infield_sand_copy_2 path { fill: #fff; }\n                        #pitching-mound, #pitching-mound_1_, #pitching-mound_2_, #Pitchers_mound ellipse { fill: #fff; }\n                        #pitching-rubber, #pitching-rubber_1_ { fill: #c2c2c2; }\n                        #warning_track, #Outfield, #outfield, #Outfield_1_, #Outfield_00000139263571581690122010000007572633505411225276_, #Outfield_00000141422436691043141870000004421356628436405419_, #Outfield_00000079455967559065699190000006373183002832104345_,\n                        #Outfield_00000094597754240764042730000018294815217055423873_, #outfield_00000176019447424471975020000015478149771427856801_ { fill: #fff; stroke: #e2e2e2; stroke-width: 0.5; }\n\n                        #lines path, #lines_1_ path, #lines line, #Bases_and_chalk_lines-ALL polyline { stroke: #c2c2c2; stroke-width: 0.75; }\n                        #first-base, #second-base, #third-base, #home, #bases_2_ rect, #bases_2_ polygon, #Bases_and_chalk_lines-ALL rect, #Bases_and_chalk_lines-ALL polygon { fill: #c2c2c2; }\n                        #compass, #Compass {visibility: ".concat(compassVisibility, ";}\n                        #").concat(gWrapperClass, " text {visibility: ").concat(distancesVisibility, "; fill: #b2dfdb; font-family: 'Roboto Condensed'; }\n                        #ATL_-_16 .st4 { fill: #b2dfdb; }\n                        #ATL_-_16 .st3 { fill: #fff; stroke: #e2e2e2; stroke-width: 0.5; }\n                        #ATL_-_16 .st7 { fill: #fff; stroke-width: 0.5; }\n                    ")));
    }
    // The old way, keep for stadiums that we don't have copies of
    var svg = (0, $ab9674ce280c28d9$var$_FieldVisual["default"])(venueId, !chartOptions.hideFieldDistances);
    svg = svg.replace("<svg", "<svg transform=\"".concat($ab9674ce280c28d9$var$pos.all, "\" id=\"bam-evp-field-svg\" width=").concat(settings.vizWidth, " height=").concat(settings.vizHeight));
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ $ab9674ce280c28d9$var$_react["default"].createElement("g", {
        dangerouslySetInnerHTML: {
            __html: svg
        }
    });
}

});
parcelRegister("fVj9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b97b09b334364901$var$getField;
// Use this for server side renders with the forceSVG option
function $b97b09b334364901$var$getField() {
    var venueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var showDistances = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var showCompass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var distancesVisible = " visibility=\"visible\" ";
    if (!showDistances) distancesVisible = " visibility=\"hidden\" ";
    var compassVisible = " visibility=\"visible\" ";
    if (!showCompass) compassVisible = " visibility=\"hidden\" ";
    if (venueId === 'infield') return "<svg version=\"1.1\" id=\"bam-evp-field-svg\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" viewBox=\"0 0 250 250\" xml:space=\"preserve\"><defs><style type=\"text/css\">.cls-0{fill:#b2b2b2;}.cls-1{fill:#ffffff; stroke: #c2c2c2; stroke-width: .5px; }.cls-2{fill:#c2c2c2;}.cls-3{fill:#ffffff; stroke:#c2c2c2; stroke-width: .5px;}.cls-4{fill:#b2dfdb;}.cls-5{fill:#B2DFDB;}/* Distance Numbers */.cls-6{font-family:'Rajdhani', serif; font-size: 12px;}.cls-7{font-size:11px; fill: #e2e2e2;}/* Foul line */.cls-8{fill:#e2e2e2;}.cls-9{fill:#c2c2c2;stroke:none;}.cls-10{fill:none;stroke:#c2c2c2;stroke-width:.5;}</style></defs><rect width=\"250\" height=\"250\" fill=\"#b2dfdb\"></rect><g id=\"LAA_-_1\" data-name=\"LAA - 1\"><g id=\"infeild_sand\" data-name=\"infeild sand\"><path class=\"cls-1\" d=\"M133.2,138.54C96,128.44,86.31,168.31,86.31,168.31s0,0,0,0l0,0L99,181l1.29-1.29,20,20a5.52,5.52,0,1,0,9.75-.55l19.55-19.55,1,1L163,168.15l-.39-.39.39-.52C162.83,167.44,159,145.54,133.2,138.54Zm15.15,39.84-19.69,19.69h-7l-19.92-19.92,3.64-3.64-.08-.08c.59-.71,1.1-2.08,0-4.22l16.52-16.52H128L144.38,170c-.45,1-1.47,2.8-.19,4.2Z\"></path></g></g><g id=\"Pitchers_mound\" data-name=\"Pitchers mound\"><circle class=\"cls-1\" cx=\"125.25\" cy=\"177.46\" r=\"3.83\" transform=\"translate(-88.8 140.54) rotate(-45)\"></circle></g><g id=\"Bases_and_chalk_lines-ALL\" data-name=\"Bases and chalk lines-ALL\"><rect class=\"cls-8\" x=\"123.17\" y=\"176.68\" width=\"3.98\" height=\"1.55\"></rect><rect class=\"cls-8\" x=\"98.41\" y=\"174.55\" width=\"3.04\" height=\"3.04\" transform=\"translate(-95.22 122.19) rotate(-44.99)\"></rect><rect class=\"cls-8\" x=\"148.89\" y=\"174.55\" width=\"3.04\" height=\"3.04\" transform=\"translate(-80.45 157.87) rotate(-44.99)\"></rect><rect class=\"cls-8\" x=\"123.65\" y=\"149.32\" width=\"3.04\" height=\"3.04\" transform=\"translate(-70 132.73) rotate(-45.01)\"></rect><polygon class=\"cls-8\" points=\"126.7 201.88 125.16 203.41 123.65 201.88 123.65 200.36 126.7 200.36 126.7 201.88\"></polygon><path class=\"cls-9\" d=\"M125.18,204.53,26.95,106.26l-.64-.63-.12-2.2,1.47,1.42,97.52,97.56,99-98.83a7.42,7.42,0,0,1-.11,2.23Z\"></path></g></svg>";
    switch(Number(venueId)){
        case 13:
            return "<svg version=\"1.1\" id=\"bam-evp-field-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 250 250\" style=\"enable-background:new 0 0 250 250;\" xml:space=\"preserve\"><style type=\"text/css\">.st0{fill:#5B5B5B;}.st1{fill:#7F7F7F;}.st2{fill:#FFEC5F;}.st3{fill:#b2dfdb;}.st4{font-family:'Roboto Condensed';}.st5{font-size:11px;}.st6{fill:#fff; stroke: #e2e2e2; stroke-width: 0.5;}.st7{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;}.st8{fill:none;stroke:#c2c2c2;stroke-width:0.75;}.st9{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}.st10{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0004;}</style><g id=\"TEX\"><g id=\"distances\" ".concat(distancesVisible, "><g id=\"right-field\"><text transform=\"matrix(1 0 0 1 225.668 112.8232)\" class=\"st3 st4 st5\">326</text></g><g id=\"_x37_\"><text transform=\"matrix(1 0 0 1 172.9463 49.3672)\" class=\"st3 st4 st5\">374</text></g><g id=\"_x35_\"><text transform=\"matrix(1 0 0 1 147.9355 32.4043)\" class=\"st3 st4 st5\">410</text></g><g id=\"_x35__1_\"><text transform=\"matrix(1 0 0 1 85 32.4043)\" class=\"st3 st4 st5\">410</text></g><g id=\"center_1_\"><text transform=\"matrix(1 0 0 1 116.4678 32.4043)\" class=\"st3 st4 st5\">407</text></g><g id=\"_x33_\"><text transform=\"matrix(1 0 0 1 50.5732 53.7129)\" class=\"st3 st4 st5\">372</text></g><g id=\"_x32_\"><text transform=\"matrix(1 0 0 1 13.6899 98.3701)\" class=\"st3 st4 st5\">334</text></g><g id=\"left-field\"><text transform=\"matrix(1 0 0 1 9.2397 116.1748)\" class=\"st3 st4 st5\">329</text></g></g><g id=\"compass\" ").concat(compassVisible, "><polygon class=\"st0\" points=\"232.2,192.2 228.3,200.5 222.5,206.1 225.6,198.7 \"/><path class=\"st4\" d=\"M235.8,186.7c7,4.8,8.8,14.5,4,21.6c-4.8,7.1-14.5,8.8-21.6,4c-7-4.8-8.8-14.5-4-21.6C219.1,183.7,228.7,181.9,235.8,186.7z M219,211.2c6.5,4.4,15.3,2.8,19.7-3.7c4.4-6.4,2.8-15.3-3.7-19.7c-6.4-4.4-15.3-2.8-19.7,3.7C210.9,197.9,212.5,206.8,219,211.2z\"/><path class=\"st1\" d=\"M224.1,200.1c-0.3-1.6,0.8-3.2,2.4-3.5c1.6-0.3,3.2,0.8,3.5,2.4c0.3,1.6-0.8,3.2-2.4,3.5C225.9,202.7,224.4,201.7,224.1,200.1z\"/><g><path class=\"st0\" d=\"M222.8,207.8l-1.7,2.5l-0.4-0.3l0-2.5l0,0l-1.2,1.8L219,209l1.7-2.5l0.4,0.3l0,2.6l0,0l1.2-1.8L222.8,207.8z\"/></g><path class=\"st2\" d=\"M225.4,199.8c-0.2-0.9,0.4-1.8,1.3-1.9s1.8,0.4,1.9,1.3c0.2,0.9-0.4,1.8-1.3,1.9C226.4,201.3,225.6,200.7,225.4,199.8z\"/></g><g id=\"field_1_\"><path id=\"outfield\" class=\"st6\" d=\"M221.4,106.7l-0.8-2.6l-0.9-2.6l-0.9-2.7l-0.9-2.7l-0.9-2.8l-0.9-2.8l-1-2.9l-1-2.9l-1-3l-1-3.1l-1.7-2.2l-2.3-1.3l-2.4-1.3l-2.3-1.3l-2.3-1.3l-2.3-1.3l-2.3-1.3l-2.4-1.2l-2.3-1.3l-2.3-1.3l-2.4-1.3l-2.3-1.3l-2.4-1.3l-2.4-1.3l-2.4-1.3l-2.4-1.3l-2.4-1.3l-2.4-1.3l-0.9-6.7l-2.6-1.4l-2.5-1.5l-2.6-1.4l-2.6-1.5l-2.7-1.5l-2.7-1.5l-2.7-1.5l-2.8-1.5l-2.8-1.6l-2.9-0.1h-3h-2.9h-3h-2.9h-2.9H125H122h-2.9h-2.9h-3h-2.9h-3l-2.9,0.2l-2.6,2.7l-2.6,2.6l-2.4,2.6l-2.4,2.5l-2.4,2.4l-2.3,2.4l-2.3,2.3l-2.2,2.2l-2.2,2L80,56L77,55.6l-3-0.4l-3-0.4l-2.4,1.6l-2.1,2.2l-2.1,2.2l-2,2.1l-2,2.1l-2,2l-1.9,2l-1.9,2l-1.9,2l-1.9,1.9L49,76.8l-1.8,1.9l-1.8,1.9l-1.8,1.9l-1.8,1.9l-1.8,1.9L38.2,88l-1.7,1.9l-1,2.7l-1.1,2.6l-1,2.6l-1,2.5l-1,2.4l-1,2.4l-1,2.4v2.7l27.1,27.4c1.7,4.6,1,11.2,5.4,18.8c7.1,12.1,29.8,41.6,29.8,41.6S105,213.9,106,215c0.9,1.1,10.9,7.6,18.9,7.6c6.3,0,16-5.5,16-5.5s30.7-32,37.8-44.1c5-8.6,8.1-22.8,11.8-31.9l30.9-31V106.7z\"/><path id=\"grass_1_\" class=\"st3\" d=\"M124.3,216.4c-4.6,0-13.9-5.2-13.9-5.3c-1.9-2.1-4-4.1-13-14.9c-2.9-3.7-23.4-29.7-29.7-40.5c-4.1-7-1-13.4-2.7-18l-0.6-1.6l-26.7-26.7l2.1-6.1l1-2.6l1-2.5l1.1-2.7l0.5-1.4l0.7-0.8l3.4-3.6l3.6-3.7l5.6-5.8l1.8-1.8l5.8-6.1l1.9-2l7-7.3l2.9,0.4l9.5,1.2l5.1-4.7l4.6-4.7l4.7-4.9l2.5-2.5l2.4-2.5l2.5-2.6l0.5-0.5h34.8l0.8,0l1.2,0.7l2.7,1.5l2.7,1.5l5.3,3l2.6,1.5l2.6,1.4l1.6,0.9l0.9,6.8l6,3.3l2.4,1.4l2.3,1.2l2.4,1.3l4.7,2.5l2.4,1.4l2.4,1.3l4.7,2.6l2.3,1.2l9.2,5.1l2.4,1.3l2.7,1.5l7.9,24.4l-30.2,29.6l-0.6,1.5c-6.3,15.3-6.9,25.2-10.4,31.2c-6,10.2-36.5,43-36.5,43S129.8,216.4,124.3,216.4z\"/><path id=\"infield_sand_1_\" class=\"st6\" d=\"M163,165.8c-0.2,0.2-6-28.1-37.1-28.1c-33.4,0-39,25.5-39.5,28.1l-0.4,0.4l14.8,14.8l0.7-0.7l18.2,17.9c-0.7,1-1.1,2.2-1.1,3.6c0,1.2,0.4,2.4,1,3.4c0,0,0,0,0,0.1c1.1,1.8,3.1,3,5.4,3c3.5,0,6.4-2.9,6.4-6.4c0-1.5-0.5-2.8-1.3-3.9l18.7-17.7l1.5,0.5l13.5-13.5L163,165.8z M128.6,196.7c-1-0.7-2.3-1.2-3.7-1.2c-1.5,0-2.8,0.5-3.9,1.3l-17.6-18.2c0,0,6.2-5.6,2.7-10.2l17.4-14.5c0.5-0.3,1.1-0.4,1.8-0.4c0.9,0,1.7,0.5,2.3,1.1c0,0,0.1,0,0.1,0.1l16.2,15.5c-0.5,1,0.1,6.3,3,8.9L128.6,196.7z\"/></g><g id=\"persistent_1_\"><g id=\"mound_1_\"><path id=\"pitching-mound_1_\" class=\"st6\" d=\"M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4C126.5,173.2,124,173.2,122.5,174.7z\"/><rect id=\"pitching-rubber_1_\" x=\"123.2\" y=\"176.6\" class=\"st7\" width=\"4\" height=\"1.6\"/></g><g id=\"lines_1_\"><line id=\"left-foul-line_1_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"28.1\" y2=\"106.1\"/><line id=\"right-foul-line_1_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"222.3\" y2=\"106\"/></g><g id=\"bases_1_\"><rect id=\"third-base_1_\" x=\"98.4\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -95.1992 122.1442)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"first-base_1_\" x=\"148.9\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -80.4168 157.8396)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"second-base_1_\" x=\"123.7\" y=\"149.3\" transform=\"matrix(0.707 -0.7073 0.7073 0.707 -69.9813 132.7504)\" class=\"st10\" width=\"3\" height=\"3\"/><polygon id=\"home_1_\" class=\"st7\" points=\"126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3 \"/></g></g></g></svg>");
        case 3140:
            return "<svg version=\"1.1\" id=\"bam-evp-field-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 250 250\" style=\"enable-background:new 0 0 250 250;\" xml:space=\"preserve\"><style type=\"text/css\">.st0{fill:#5B5B5B;}.st1{fill:#7F7F7F;}.st2{fill:#FFEC5F;}.st3{fill:#b2dfdb;}.st4{font-family:'Roboto Condensed';}.st5{font-size:11px;}.st6{fill:#fff; stroke: #e2e2e2; stroke-width: 0.5;}.st7{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;}.st8{fill:none;stroke:#c2c2c2;stroke-width:0.75;}.st9{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}.st10{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0004;}</style><g id=\"polo_grounds_1_\"><g id=\"compass\" ".concat(compassVisible, "><g id=\"Compass_1_\"><polygon class=\"st0\" points=\"235.2,195.8 227.6,201 219.9,203 226.2,198.1 \"/><path class=\"st1\" d=\"M241,192.9c3.7,7.7,0.4,17-7.3,20.7c-7.7,3.7-17,0.4-20.7-7.3c-3.7-7.7-0.4-17,7.3-20.7C228.1,181.8,237.3,185.1,241,192.9z M214.2,205.6c3.4,7.1,11.8,10.1,18.9,6.7c7.1-3.4,10.1-11.8,6.7-18.9c-3.4-7.1-11.8-10.1-18.9-6.7C213.9,190.1,210.8,198.5,214.2,205.6z\"/><path class=\"st0\" d=\"M224.2,198.5c0.5-1.5,2.2-2.4,3.8-1.8c1.5,0.5,2.4,2.2,1.8,3.8c-0.5,1.5-2.2,2.4-3.8,1.8C224.5,201.8,223.7,200.1,224.2,198.5z\"/><g><path class=\"st0\" d=\"M216.8,206.1l-1.2-2.8l0.4-0.2l2.1,1.4l0,0l-0.9-1.9l0.5-0.2l1.2,2.8l-0.4,0.2l-2.2-1.4l0,0l0.9,1.9L216.8,206.1z\"/></g><path class=\"st2\" d=\"M225.5,199c0.3-0.9,1.2-1.3,2.1-1c0.9,0.3,1.3,1.2,1,2.1c-0.3,0.9-1.2,1.3-2.1,1C225.6,200.8,225.2,199.8,225.5,199z\"/></g></g><g id=\"distances\" ").concat(distancesVisible, "><text id=\"right\" transform=\"matrix(1 0 0 1 206.9248 94.0186)\" class=\"st3 st4 st5\">339</text><text id=\"right_3_\" transform=\"matrix(1 0 0 1 206.9248 69.9404)\" class=\"st3 st4 st5\">395</text><text id=\"right_4_\" transform=\"matrix(1 0 0 1 142.7393 15.876)\" class=\"st3 st4 st5\">483</text><text id=\"right_1_\" transform=\"matrix(1 0 0 1 206.9248 113.0967)\" class=\"st3 st4 st5\">294</text><text id=\"right_2_\" transform=\"matrix(1 0 0 1 206.9248 132.1748)\" class=\"st3 st4 st5\">258</text><text id=\"right_6_\" transform=\"matrix(1 0 0 1 24.4712 122.1748)\" class=\"st3 st4 st5\">279</text><text id=\"right_7_\" transform=\"matrix(1 0 0 1 24.4712 109.1753)\" class=\"st3 st4 st5\">315</text><text id=\"right_8_\" transform=\"matrix(1 0 0 1 24.4712 85.6255)\" class=\"st3 st4 st5\">360</text><text id=\"right_9_\" transform=\"matrix(1 0 0 1 24.4712 64.416)\" class=\"st3 st4 st5\">414</text><text id=\"right_10_\" transform=\"matrix(1 0 0 1 24.4712 43.8623)\" class=\"st3 st4 st5\">447</text><text id=\"right_11_\" transform=\"matrix(1 0 0 1 35.541 25.6138)\" class=\"st3 st4 st5\">455</text><text id=\"right_12_\" transform=\"matrix(1 0 0 1 200.5801 34.0361)\" class=\"st3 st4 st5\">449</text><text id=\"center_1_\" transform=\"matrix(1 0 0 1 116.9365 34.0361)\" class=\"st3 st4 st5\">400</text><text id=\"right_5_\" transform=\"matrix(1 0 0 1 203.8066 48.8623)\" class=\"st3 st4 st5\">440</text></g><g id=\"field\" transform=\"translate(0 0) scale(1)\"><path id=\"Outfield_1_\" class=\"st6\" d=\"M201.9,126.9v-2.3v-2.8V119v-3v-3.1v-3.3v-3.4v-3.6v-3.7v-3.9v-4.1v-4.3v-4.6v-1.3V77v-5.1v-5.5v-5.8v-6.2v-6.6l0-4.2l0,0.1l-0.2-2.7l-0.3-1.9l-1-2.8l-0.5-0.9l-1.6-2.5l-0.7-0.8l-1.8-1.7l-1.2-0.9l-1.6-1l-1.9-1l-1-0.5l-2.9-1l-0.2,0l-3.2-0.7l-0.9-0.1l-2.4-0.2l-2.1-0.1h-1.2h-3h-0.4h-3.3h-3.3H164h-3.2h-3.2h-3.2h-3.2h-3.2h-3.2h-3.1l-2.3,0l0-10.4l-0.1,0l-1.3,0l0-9.4l1.4,0l0-2.8h-2.8H133h-3.5l-3.4,0l0,1.1l-0.1,0l-1.1,0l0-1.1l-2.4,0H119h-3.5h-3.4l0,1.1l0,1.7l1.3,0l0,9.4l-1.3,0l0,10.4l-1.6,0h-3.1h-3.2h-3.2h-3.2h-3.2h-3.2h-3.2h-3.3h-3.3h-3.3h-3.4H72h-0.6H68h-0.2l0,0l-3.2,0.2L63.7,25l-2.4,0.4l-1.7,0.4l-1.5,0.5l-2.5,1L55,27.5l-2.9,1.6L52,29.2l-2.5,1.9l-0.6,0.6l-1.8,2l-0.7,1.1l-1.2,2.4l-0.4,1.2L44,42.3l0,6.8v6.3v5.9v5.6V72v5v4.7v2.6v1.8v4.2v4v3.9v3.7v3.5v3.4v3.3v3.1v3v8.5v41.3c0,0,1.1,39,22.1,57.6c20.8,18.3,39.4,22.4,56.7,24.2c0,0,0,0.1,0,0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0,0,0-0.1,0-0.1c17.3-1.8,35.9-5.9,56.7-24.2c21.1-18.6,22.1-57.6,22.1-57.6v-41.3L201.9,126.9z\"/><path id=\"grass\" class=\"st3\" d=\"M172.9,28.7L70,28.7L47.1,53.8v90.7l7,3.4v20c0.3,9.8,4.2,37.4,18.8,50.3c1.4,1.2,2.7,2.3,4,3.4l8.4-6.6c0,0,20.5,15.7,39.7,15.7s38.8-15.7,38.8-15.7l7.2,5.5c0.9-0.7,1.8-1.5,2.7-2.3c17-15,18.7-48.2,18.8-50.3v-19.2l6.8-2.4l1.3-88.7L172.9,28.7z\"/><path id=\"infield_sand_1_\" class=\"st6\" d=\"M163,165.8c-0.2,0.2-6-28.1-37.1-28.1c-33.4,0-39,25.5-39.5,28.1l-0.4,0.4l14.8,14.8l0.7-0.7l18.2,17.9c-0.7,1-1.1,2.2-1.1,3.6c0,1.2,0.4,2.4,1,3.4c0,0,0,0,0,0.1c1.1,1.8,3.1,3,5.4,3c3.5,0,6.4-2.9,6.4-6.4c0-1.5-0.5-2.8-1.3-3.9l18.7-17.7l1.5,0.5l13.5-13.5L163,165.8z M128.6,196.7c-1-0.7-2.3-1.2-3.7-1.2c-1.5,0-2.8,0.5-3.9,1.3l-17.6-18.2c0,0,6.2-5.6,2.7-10.2l17.4-14.5c0.5-0.3,1.1-0.4,1.8-0.4c0.9,0,1.7,0.5,2.3,1.1c0,0,0.1,0,0.1,0.1l16.2,15.5c-0.5,1,0.1,6.3,3,8.9L128.6,196.7z\"/></g><g id=\"persistent_1_\"><g id=\"mound_1_\"><path id=\"pitching-mound_1_\" class=\"st6\" d=\"M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4C126.5,173.2,124,173.2,122.5,174.7z\"/><rect id=\"pitching-rubber_1_\" x=\"123.2\" y=\"176.6\" class=\"st7\" width=\"4\" height=\"1.6\"/></g><g id=\"lines_1_\"><line id=\"left-foul-line_1_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"44.2\" y2=\"122.2\"/><line id=\"right-foul-line_2_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"202.3\" y2=\"126\"/></g><g id=\"bases_1_\"><rect id=\"third-base_1_\" x=\"98.4\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -95.1992 122.1442)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"first-base_1_\" x=\"148.9\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -80.4168 157.8396)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"second-base_1_\" x=\"123.7\" y=\"149.3\" transform=\"matrix(0.707 -0.7073 0.7073 0.707 -69.9813 132.7504)\" class=\"st10\" width=\"3\" height=\"3\"/><polygon id=\"home_1_\" class=\"st7\" points=\"126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3 \"/></g></g></g></svg>");
        case 9999:
            return "<svg version=\"1.1\" id=\"bam-evp-field-svg\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" viewBox=\"0 0 250 250\" xml:space=\"preserve\"><defs><style type=\"text/css\">.cls-0{fill:#b2b2b2;}.cls-1{fill:#ffffff; stroke: #c2c2c2; stroke-width: .5px; }.cls-2{fill:#c2c2c2;}.cls-3{fill:#ffffff; stroke:#c2c2c2; stroke-width: .5px;}.cls-4{fill:#b2dfdb;}.cls-5{fill:#B2DFDB;}/* Distance Numbers */.cls-6{font-family:'Rajdhani', serif; font-size: 12px;}.cls-7{font-size:11px; fill: #e2e2e2;}/* Foul line */.cls-8{fill:#e2e2e2;}.cls-9{fill:#c2c2c2;stroke:none;}.cls-10{fill:none;stroke:#c2c2c2;stroke-width:.5;}</style></defs><rect width=\"250\" height=\"250\" fill=\"#b2dfdb\"></rect><g id=\"LAA_-_1\" data-name=\"LAA - 1\"><g id=\"infeild_sand\" data-name=\"infeild sand\"><path class=\"cls-1\" d=\"M133.2,138.54C96,128.44,86.31,168.31,86.31,168.31s0,0,0,0l0,0L99,181l1.29-1.29,20,20a5.52,5.52,0,1,0,9.75-.55l19.55-19.55,1,1L163,168.15l-.39-.39.39-.52C162.83,167.44,159,145.54,133.2,138.54Zm15.15,39.84-19.69,19.69h-7l-19.92-19.92,3.64-3.64-.08-.08c.59-.71,1.1-2.08,0-4.22l16.52-16.52H128L144.38,170c-.45,1-1.47,2.8-.19,4.2Z\"></path></g></g><g id=\"Pitchers_mound\" data-name=\"Pitchers mound\"><circle class=\"cls-1\" cx=\"125.25\" cy=\"177.46\" r=\"3.83\" transform=\"translate(-88.8 140.54) rotate(-45)\"></circle></g><g id=\"Bases_and_chalk_lines-ALL\" data-name=\"Bases and chalk lines-ALL\"><rect class=\"cls-8\" x=\"123.17\" y=\"176.68\" width=\"3.98\" height=\"1.55\"></rect><rect class=\"cls-8\" x=\"98.41\" y=\"174.55\" width=\"3.04\" height=\"3.04\" transform=\"translate(-95.22 122.19) rotate(-44.99)\"></rect><rect class=\"cls-8\" x=\"148.89\" y=\"174.55\" width=\"3.04\" height=\"3.04\" transform=\"translate(-80.45 157.87) rotate(-44.99)\"></rect><rect class=\"cls-8\" x=\"123.65\" y=\"149.32\" width=\"3.04\" height=\"3.04\" transform=\"translate(-70 132.73) rotate(-45.01)\"></rect><polygon class=\"cls-8\" points=\"126.7 201.88 125.16 203.41 123.65 201.88 123.65 200.36 126.7 200.36 126.7 201.88\"></polygon><path class=\"cls-9\" d=\"M125.18,204.53,26.95,106.26l-.64-.63-.12-2.2,1.47,1.42,97.52,97.56,99-98.83a7.42,7.42,0,0,1-.11,2.23Z\"></path></g></svg>";
        default:
            return "<svg version=\"1.1\" id=\"bam-evp-field-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 250 250\" style=\"enable-background:new 0 0 250 250;\" xml:space=\"preserve\"><style type=\"text/css\">.st0{fill:#5B5B5B;}.st1{fill:#7F7F7F;}.st2{fill:#FFEC5F;}.st3{fill:#b2dfdb;}.st4{font-family:'Roboto Condensed';}.st5{font-size:11px;}.st6{fill:#fff; stroke: #e2e2e2; stroke-width: 0.5;}.st7{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;}.st8{fill:none;stroke:#c2c2c2;stroke-width:0.75;}.st9{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}.st10{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0004;}</style><g id=\"KCR\"><g id=\"compass\" ".concat(compassVisible, "><polygon class=\"st0\" points=\"232.8,206.4 225.7,200.5 221.8,193.5 228.2,198.4 \"/><path class=\"st1\" d=\"M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5c-5.6-6.4-4.9-16.3,1.5-21.9c6.4-5.6,16.3-4.9,21.9,1.5C244.3,195.8,243.7,205.6,237.2,211.2z M217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20c5.1,5.9,14.1,6.5,20,1.4c5.9-5.1,6.5-14.1,1.4-20C232.6,184.3,223.6,183.7,217.7,188.8z\"/><path class=\"st0\" d=\"M227.2,196.6c1.6,0.1,2.9,1.5,2.8,3.2c-0.1,1.6-1.5,2.9-3.2,2.8c-1.6-0.1-2.9-1.5-2.8-3.2C224.2,197.7,225.6,196.4,227.2,196.6z\"/><g><path class=\"st0\" d=\"M220,193.3l-2-2.3l0.4-0.3l2.5,0.7l0,0l-1.4-1.6l0.4-0.3l2,2.3l-0.4,0.3l-2.5-0.7l0,0l1.4,1.6L220,193.3z\"/></g><path class=\"st2\" d=\"M227.1,197.9c0.9,0.1,1.6,0.9,1.5,1.8c-0.1,0.9-0.9,1.6-1.8,1.5c-0.9-0.1-1.6-0.9-1.5-1.8C225.4,198.5,226.2,197.8,227.1,197.9z\"/></g><g id=\"distances\" ").concat(distancesVisible, "><text id=\"right\" transform=\"matrix(1 0 0 1 223.2178 111.8696)\" class=\"st3 st4 st5\">330</text><g id=\"right-center\"><text transform=\"matrix(1 0 0 1 188.6943 54.0254)\" class=\"st3 st4 st5\">387</text></g><text id=\"center\" transform=\"matrix(1 0 0 1 94.6968 32.4785)\" class=\"st3 st4 st5\">410</text><g id=\"left-center\"><text transform=\"matrix(1 0 0 1 45.7861 53.0264)\" class=\"st3 st4 st5\">387</text></g><text id=\"left\" transform=\"matrix(1 0 0 1 7.2158 111.8696)\" class=\"st3 st4 st5\">330</text></g><g id=\"field\" transform=\"translate(0 0) scale(1)\"><path id=\"Outfield_1_\" class=\"st6\" d=\"M125.1,224.6c-17.7,0-27.7-12.3-27.7-12.3S75,177.8,68.3,173c-11.5-8.2-39.2-64.6-39.2-64.6l-0.5-1.6l-1.4-4.9L27,98.1l0.4-3.3l0.8-2.9l1.3-2.5l1.7-2l1.8-2l1.8-2l1.8-2l1.8-2l1.8-2.1l1.8-2.1l1.8-2.2l1.8-2.1l1.9-2.1l1.9-2.1l2.1-1.9l2.2-1.8l2.2-1.8l2.2-1.8l2.2-1.8l2.3-1.7l2.3-1.7l2.4-1.6l2.4-1.6l2.5-1.6l2.5-1.6l2.5-1.5l2.6-1.4l2.6-1.4l2.7-1.3l2.7-1.3l2.7-1.2l2.8-1l2.8-1.1l2.8-0.9l2.9-0.8l2.9-0.8l2.9-0.6l2.9-0.5l2.9-0.5l3-0.4l3-0.2l3-0.1l3,0l3,0l3,0.1l3,0.4l3,0.4l3,0.3l2.9,0.6l2.9,0.6l2.9,0.6l2.9,0.9l2.8,1l2.8,1.1l2.8,1.1l2.7,1.3l2.6,1.4l2.6,1.4l2.6,1.4l2.6,1.4l2.6,1.4l2.5,1.5l2.4,1.6l2.4,1.6l2.4,1.6l2.4,1.6l2.3,1.7l2.2,1.8l2.2,1.8l2.2,1.8l2.2,1.8l2,2l1.9,2.1l1.9,2.1l1.9,2.1l1.9,2.1l1.8,2l1.8,2l1.8,2l1.8,2l1.8,2l1.7,2l1.7,2l1.1,2.7l0.8,3l0.4,3.3l-0.3,3.9l-1.4,4.8l-1.9,6.3c-5.8,14.5-30.4,52.6-39,57.8c-8.6,5.1-26.7,40.6-26.7,40.6S142.8,224.6,125.1,224.6z\"/><path id=\"grass_1_\" class=\"st3\" d=\"M126.1,216.6c-9.8,0-17.4-3.5-21.2-6.4c-5-3.8-30.9-43.6-30.9-43.6l-13.4-18.8l-24.1-42.5l-1.4-4.7L35,98.3l0.2-2.1l0.4-1.5l0.5-0.9l1.1-1.3l1.7-1.9l3.6-4.1l1.8-2.1l1.8-2.1l1.9-2.2l1.8-2.1l1.8-2.1l1.8-2l1.6-1.8l1.7-1.5l2.1-1.7l4.2-3.5l2.1-1.7l2.2-1.7l2.1-1.6l4.5-3.1l4.7-3l2.4-1.4l2.4-1.4l2.4-1.3l5.1-2.5l2.4-1.1l5.1-1.9l2.5-0.8l5.2-1.5l2.4-0.5l5.7-0.9l2.6-0.4l2.6-0.2l2.6-0.1l5.7,0.1l2.5,0.1l8.1,1l2.5,0.6l5.4,1.2l2.3,0.7l2.6,0.9l5.2,2l2.3,1.1l12.6,6.7l2.1,1.3l9.4,6.3l2,1.5l8.4,6.8l1.6,1.5l1.7,1.9l1.9,2.2l1.9,2.1l7.3,8.1l1.8,2l1.7,2l1.6,1.9l0.9,1l0.4,1l0.5,2l0.3,2l-0.2,2.3l-1.1,4l-1.8,5.9c-3,7.4-8.4,15.8-12.7,22.6c-4.7,7.3-9.7,15.3-9.7,15.3l-12.8,15.7L158,192.8c0,0-9.7,13.5-12.3,15.9S135.6,216.6,126.1,216.6z\"/><path id=\"infield_sand_1_\" class=\"st6\" d=\"M163,165.8c-0.2,0.2-6-28.1-37.1-28.1c-33.4,0-39,25.5-39.5,28.1l-0.4,0.4l14.8,14.8l0.7-0.7l18.2,17.9c-0.7,1-1.1,2.2-1.1,3.6c0,1.2,0.4,2.4,1,3.4c0,0,0,0,0,0.1c1.1,1.8,3.1,3,5.4,3c3.5,0,6.4-2.9,6.4-6.4c0-1.5-0.5-2.8-1.3-3.9l18.7-17.7l1.5,0.5l13.5-13.5L163,165.8z M128.6,196.7c-1-0.7-2.3-1.2-3.7-1.2c-1.5,0-2.8,0.5-3.9,1.3l-17.6-18.2c0,0,6.2-5.6,2.7-10.2l17.4-14.5c0.5-0.3,1.1-0.4,1.8-0.4c0.9,0,1.7,0.5,2.3,1.1c0,0,0.1,0,0.1,0.1l16.2,15.5c-0.5,1,0.1,6.3,3,8.9L128.6,196.7z\"/></g><g id=\"persistent_1_\"><g id=\"mound_1_\"><path id=\"pitching-mound_1_\" class=\"st6\" d=\"M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4C126.5,173.2,124,173.2,122.5,174.7z\"/><rect id=\"pitching-rubber_1_\" x=\"123.2\" y=\"176.6\" class=\"st7\" width=\"4\" height=\"1.6\"/></g><g id=\"lines_1_\"><line id=\"left-foul-line_1_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"28.1\" y2=\"106.1\"/><line id=\"right-foul-line_1_\" class=\"st8\" x1=\"125.2\" y1=\"203.2\" x2=\"222.3\" y2=\"106\"/></g><g id=\"bases_1_\"><rect id=\"third-base_1_\" x=\"98.4\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -95.1992 122.1442)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"first-base_1_\" x=\"148.9\" y=\"174.5\" transform=\"matrix(0.7073 -0.7069 0.7069 0.7073 -80.4168 157.8396)\" class=\"st9\" width=\"3\" height=\"3\"/><rect id=\"second-base_1_\" x=\"123.7\" y=\"149.3\" transform=\"matrix(0.707 -0.7073 0.7073 0.707 -69.9813 132.7504)\" class=\"st10\" width=\"3\" height=\"3\"/><polygon id=\"home_1_\" class=\"st7\" points=\"126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3 \"/></g></g></g></svg>");
    }
}

});

parcelRegister("iUko2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dc3d4551a5a9c59a$var$_ = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("f0iQz")));

var $dc3d4551a5a9c59a$var$_2 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("5K2BB")));

var $dc3d4551a5a9c59a$var$_3 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("dLcMP")));

var $dc3d4551a5a9c59a$var$_4 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("aFNri")));

var $dc3d4551a5a9c59a$var$_5 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("gnezC")));

var $dc3d4551a5a9c59a$var$_6 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("I10m5")));

var $dc3d4551a5a9c59a$var$_7 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("bQd55")));

var $dc3d4551a5a9c59a$var$_8 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("M3hBi")));

var $dc3d4551a5a9c59a$var$_9 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("esLVO")));

var $dc3d4551a5a9c59a$var$_10 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("6XYHt")));

var $dc3d4551a5a9c59a$var$_11 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("kLrPm")));

var $dc3d4551a5a9c59a$var$_12 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("aNjSP")));

var $dc3d4551a5a9c59a$var$_13 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("fGzhH")));

var $dc3d4551a5a9c59a$var$_14 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("d9LSj")));

var $dc3d4551a5a9c59a$var$_15 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("iErUj")));

var $dc3d4551a5a9c59a$var$_16 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("hJpBV")));

var $dc3d4551a5a9c59a$var$_17 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("4r9oI")));

var $dc3d4551a5a9c59a$var$_18 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("1RT1Z")));

var $dc3d4551a5a9c59a$var$_19 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("jQs4E")));

var $dc3d4551a5a9c59a$var$_20 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("1JDEm")));

var $dc3d4551a5a9c59a$var$_21 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("bpbGd")));

var $dc3d4551a5a9c59a$var$_22 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("7BDj5")));

var $dc3d4551a5a9c59a$var$_23 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("1HiC0")));

var $dc3d4551a5a9c59a$var$_24 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("jWsOX")));

var $dc3d4551a5a9c59a$var$_25 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("hIFtS")));

var $dc3d4551a5a9c59a$var$_26 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("aZC7t")));

var $dc3d4551a5a9c59a$var$_27 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("alOdp")));

var $dc3d4551a5a9c59a$var$_28 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("chE02")));

var $dc3d4551a5a9c59a$var$_29 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("2YGpi")));

var $dc3d4551a5a9c59a$var$_30 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("6AS4l")));

var $dc3d4551a5a9c59a$var$_31 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("39X87")));

var $dc3d4551a5a9c59a$var$_32 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("LYuJp")));

var $dc3d4551a5a9c59a$var$_33 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("1mxmJ")));

var $dc3d4551a5a9c59a$var$_34 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("7Wdld")));

var $dc3d4551a5a9c59a$var$_35 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("4R04T")));

var $dc3d4551a5a9c59a$var$_36 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("5JKL4")));

var $dc3d4551a5a9c59a$var$_37 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("gVDVH")));

var $dc3d4551a5a9c59a$var$_38 = $dc3d4551a5a9c59a$var$_interopRequireDefault((parcelRequire("24Q5R")));
function $dc3d4551a5a9c59a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $dc3d4551a5a9c59a$var$_default = module.exports["default"] = {
    1: $dc3d4551a5a9c59a$var$_["default"],
    2: $dc3d4551a5a9c59a$var$_2["default"],
    3: $dc3d4551a5a9c59a$var$_3["default"],
    4: $dc3d4551a5a9c59a$var$_4["default"],
    5: $dc3d4551a5a9c59a$var$_5["default"],
    7: $dc3d4551a5a9c59a$var$_6["default"],
    10: $dc3d4551a5a9c59a$var$_7["default"],
    12: $dc3d4551a5a9c59a$var$_8["default"],
    13: $dc3d4551a5a9c59a$var$_9["default"],
    14: $dc3d4551a5a9c59a$var$_10["default"],
    15: $dc3d4551a5a9c59a$var$_11["default"],
    16: $dc3d4551a5a9c59a$var$_12["default"],
    17: $dc3d4551a5a9c59a$var$_13["default"],
    19: $dc3d4551a5a9c59a$var$_14["default"],
    22: $dc3d4551a5a9c59a$var$_15["default"],
    31: $dc3d4551a5a9c59a$var$_16["default"],
    32: $dc3d4551a5a9c59a$var$_17["default"],
    680: $dc3d4551a5a9c59a$var$_18["default"],
    2392: $dc3d4551a5a9c59a$var$_19["default"],
    2394: $dc3d4551a5a9c59a$var$_20["default"],
    2395: $dc3d4551a5a9c59a$var$_21["default"],
    2523: $dc3d4551a5a9c59a$var$_22["default"],
    2529: $dc3d4551a5a9c59a$var$_23["default"],
    2535: $dc3d4551a5a9c59a$var$_24["default"],
    2602: $dc3d4551a5a9c59a$var$_25["default"],
    2680: $dc3d4551a5a9c59a$var$_26["default"],
    2681: $dc3d4551a5a9c59a$var$_27["default"],
    2889: $dc3d4551a5a9c59a$var$_28["default"],
    3289: $dc3d4551a5a9c59a$var$_29["default"],
    3309: $dc3d4551a5a9c59a$var$_30["default"],
    3312: $dc3d4551a5a9c59a$var$_31["default"],
    3313: $dc3d4551a5a9c59a$var$_32["default"],
    4169: $dc3d4551a5a9c59a$var$_33["default"],
    4705: $dc3d4551a5a9c59a$var$_34["default"],
    5325: $dc3d4551a5a9c59a$var$_35["default"],
    5355: $dc3d4551a5a9c59a$var$_36["default"],
    5445: $dc3d4551a5a9c59a$var$_37["default"],
    6130: $dc3d4551a5a9c59a$var$_38["default"]
};

});
parcelRegister("f0iQz", function(module, exports) {
"use strict";
function $aec579b9ff3792de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aec579b9ff3792de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aec579b9ff3792de$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $aec579b9ff3792de$var$React = $aec579b9ff3792de$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $aec579b9ff3792de$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($aec579b9ff3792de$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $aec579b9ff3792de$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $aec579b9ff3792de$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $aec579b9ff3792de$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $aec579b9ff3792de$var$_extends() {
    return $aec579b9ff3792de$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aec579b9ff3792de$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $aec579b9ff3792de$var$Venue1(props) {
    return /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("svg", $aec579b9ff3792de$var$_extends({
        id: "_x31_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "LAA"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        className: "st0",
        d: "M234.2,205.1l-8.2-4l-5.6-5.8l7.4,3.1L234.2,205.1z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        className: "st1",
        d: "M239.7,208.7c-4.9,7-14.6,8.8-21.6,3.9c-7-4.9-8.8-14.6-3.9-21.6c4.9-7,14.6-8.8,21.6-3.9 C242.9,192,244.6,201.7,239.7,208.7z M215.3,191.7c-4.5,6.4-2.9,15.3,3.5,19.7c6.4,4.5,15.3,2.9,19.7-3.5 c4.5-6.4,2.9-15.3-3.5-19.7C228.7,183.7,219.8,185.3,215.3,191.7z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        className: "st0",
        d: "M226.5,196.9c1.6-0.3,3.2,0.8,3.4,2.4c0.3,1.6-0.8,3.2-2.4,3.4c-1.6,0.3-3.2-0.8-3.4-2.4 C223.8,198.7,224.8,197.2,226.5,196.9z M218.7,195.5l-2.5-1.8l0.3-0.4l2.5,0.1l-1.7-1.2l0.3-0.4l2.5,1.8l-0.3,0.4l-2.6-0.1 l1.7,1.2L218.7,195.5z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        className: "st2",
        d: "M226.7,198.2c0.9-0.2,1.8,0.4,1.9,1.3c0.2,0.9-0.4,1.8-1.3,1.9c-0.9,0.2-1.8-0.4-1.9-1.3 C225.2,199.2,225.8,198.4,226.7,198.2z"
    })), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("text", {
        id: "right-right-center",
        transform: "matrix(1 0 0 1 224.3615 99.1749)",
        className: "st3 st4 st5"
    }, "350"), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("text", {
        id: "right-center",
        transform: "matrix(1 0 0 1 180.75 60.1753)",
        className: "st3 st4 st5"
    }, "365"), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 142.4549 39.0148)",
        className: "st3 st4 st5"
    }, "396"), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("text", {
        id: "left-center",
        transform: "matrix(1 0 0 1 93.0547 40.1971)",
        className: "st3 st4 st5"
    }, "390"), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("text", {
        id: "left-left-center",
        transform: "matrix(1 0 0 1 7.2404 111.3675)",
        className: "st3 st4 st5"
    }, "347")), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "Outfield",
        className: "st6",
        d: "M125,226.5c-13.8,0-17.8-7.4-24.6-15.6c-8.3-10.1-35.3-53.3-39.2-58.3 c-4.4-5.6-8.8-11.2-13.3-16.7c-3.8-4.8-7.6-9.5-11.3-14.2c-1.9-2.4-6-7.5-6-7.6l-2.4-8.1l-0.9-4.4l-0.1-3.7l0.4-3.3l0.8-2.9 l1.2-2.6l1.4-2.4l1.6-2.2l1.8-1.9l1.8-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l2-2.1l2-2.1l2-2.1l2-2.1l2.1-2.2l2.1-2.2l2.3-1.8 l2.8-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L81,49l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L100,44l2.7-0.7l2.8-0.7 l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.9-0.8l2.9-0.8l2.9-0.8l2.9-0.8h2.9l2.8,1.5l2.8,1.5l2.7,1.5l2.7,1.5l2.7,1.5l2.6,1.4 l2.6,1.4l2.6,1.4L158,49l2.5,1.4l2.5,1.4l2.5,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.3,1.3l2.3,1.3l2.3,1.3 l2.3,1.3l2.3,1.3l2.3,1.3L196,70l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3L214,81l1.9,1.9l1.9,1.9l1.6,2.2 l1.4,2.4L222,92l0.8,3l0.3,3.4v3.7l-0.9,4.4l-0.4,0.4l-35.3,49.9c0,0-37.4,55.7-43.8,61.1C137.8,222.1,131.8,226.5,125,226.5 L125,226.5z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "grass",
        className: "st3",
        d: "M124.6,220.3c-10.9,0-17.2-7.8-21.2-14.3c-4.5-7.2-18.3-28.9-21.4-33.3l-13.2-19.8L36.7,111 l-2.9-6.8l-0.7-3.3L33,98.2l0.3-2.4l0.6-2.1l0.9-1.9L36,90l1.2-1.6l3.4-3.6l23.1-24.5l1-0.8l67.2-17.7h0.6l74.7,40.9l1.6,0.9 l4.8,4.8l1.1,1.5l1.1,1.9l0.8,1.9l0.5,2.1l0.3,2.6v2.7l-0.5,2.5l-32.7,43l-34.3,51.8C149.9,198.6,137.4,220.3,124.6,220.3 L124.6,220.3z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $aec579b9ff3792de$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $aec579b9ff3792de$var$_default = module.exports["default"] = $aec579b9ff3792de$var$Venue1;

});

parcelRegister("5K2BB", function(module, exports) {
"use strict";
function $42e34506b7821b24$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $42e34506b7821b24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $42e34506b7821b24$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $42e34506b7821b24$var$React = $42e34506b7821b24$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $42e34506b7821b24$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($42e34506b7821b24$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $42e34506b7821b24$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $42e34506b7821b24$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $42e34506b7821b24$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $42e34506b7821b24$var$_extends() {
    return $42e34506b7821b24$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42e34506b7821b24$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $42e34506b7821b24$var$Venue2(props) {
    return /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("svg", $42e34506b7821b24$var$_extends({
        id: "_x32_",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("defs", null, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st5, .st6 {\n        stroke: #fff;\n      }\n\n      .st4, .st5, .st6 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st7, .st8, .st9 {\n        isolation: isolate;\n      }\n\n      .st10, .st8 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st8 {\n        font-size: 11px;\n      }\n\n      .st8, .st9 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st9 {\n        font-size: 5px;\n      }\n\n      .st5 {\n        stroke-width: .8px;\n      }\n\n      .st5, .st6 {\n        stroke-miterlimit: 4;\n      }\n\n      .st6 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "BAL"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "BAL1"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("polygon", {
        className: "st3",
        points: "231.9 207 225.6 200.3 222.6 192.9 228.3 198.5 231.9 207"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st13",
        d: "M235.7,212.4c-7.1,4.8-16.7,2.9-21.5-4.2-4.8-7.1-2.9-16.7,4.2-21.5,7.1-4.8,16.7-2.9,21.5,4.2,4.8,7.1,2.9,16.7-4.2,21.5ZM219.1,187.7c-6.5,4.4-8.2,13.2-3.8,19.7s13.2,8.2,19.7,3.8,8.2-13.2,3.8-19.7c-4.4-6.4-13.2-8.1-19.7-3.8Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st3",
        d: "M227.6,196.6c1.6.3,2.7,1.9,2.3,3.5-.3,1.6-1.9,2.7-3.5,2.3-1.6-.3-2.7-1.9-2.3-3.5.3-1.6,1.9-2.6,3.5-2.3Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st3",
        d: "M220.8,192.5l-1.7-2.6.4-.3,2.4,1h0l-1.2-1.8.4-.3,1.7,2.6-.4.3-2.4-1h0l1.2,1.8-.4.3Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st11",
        d: "M227.3,197.9c.9.2,1.5,1,1.3,1.9s-1,1.5-1.9,1.3-1.5-1-1.3-1.9,1-1.5,1.9-1.3Z"
    })), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "right",
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st8",
        transform: "translate(223.2 114.4)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "318")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "right-center",
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st8",
        transform: "translate(185.1 55.3)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "373")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "center",
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st8",
        transform: "translate(105.7 30.3)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "410")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "left",
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st8",
        transform: "translate(38.6 61.4)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "363")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "left1",
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st8",
        transform: "translate(4.9 101.9)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "333"))))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "warning_track",
        className: "st12",
        d: "M27.2,105.1l-.5-4-1.8-5.6-2-6,1-3,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.6-.8,3.8,1.9,2.6-.6,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.3-1.6,2.3-1.6,2.3-1.6,2.4-1.6,2.4-1.6,2.4-1.7,2.5-1.7,2.5-1.7,2.5-1.7,2.6-1.7,2.6-1.8,2.6-1.8,2.7-1.8,2.7-1.9,2.8-1.9,3-.2,3,.8,3,.8,3,.8,2.9.8,2.9.8,2.9.8,2.8.8,2.8.8,2.8.7,2.8.8,2.8.7,2.7.7,2.7.8,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.4,1.6,2,2.7,1.9,2.7,1.8,2.7,1.7,2.6,1.7,2.6,1.7,2.5,1.7,2.5,1.7,2.4,1.6,2.4,1.6,2.3,1.6,2.2,1.5,2.2,1.5,2.2,1.5,2.2,1.5,2.1,1.5,2.1,1.5,2.1,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.3,2,1.3,2,3.3,11.6c-1.3,2-9.2-.5-10.9,2-17.6,25.7-53.7,77.2-64.4,88.6-13.8,14.9-27.2,23.4-46-3.1-7-9.9-19.1-26.8-31.5-43.6l-2.2.9c-20.3-27.6-40.3-58.2-40.3-58.2l.5-2.6v.2Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M175.2,58.2l-61.9-17.2-29.6,20-19,12.1-7-.6-1.6.9-25.1,17.4,4.2,13.8-1.3,3.3s47.1,68,70.5,97.3c6.2,8.8,12.9,15.5,20.3,15.5s15.1-8.3,18.6-13.4c2.6-3.7,11.8-11.9,21.7-26.5,19.7-28.9,46.1-70.4,46.1-70.4l-35.8-52.3h-.1Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    })), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("rect", {
        id: "pitching-rubber",
        className: "st4",
        x: 123.2,
        y: 176.6,
        width: 4,
        height: 1.6
    })), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("line", {
        id: "left-foul-line",
        className: "st2",
        x1: 125.2,
        y1: 203.2,
        x2: 27,
        y2: 105.1
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("line", {
        id: "right-foul-line",
        className: "st2",
        x1: 125.2,
        y1: 203.2,
        x2: 218.7,
        y2: 109.6
    })), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("rect", {
        id: "third-base",
        className: "st6",
        x: 99.2,
        y: 175.1,
        width: 3,
        height: 3,
        transform: "translate(-95.4 122.9) rotate(-45)"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("rect", {
        id: "first-base",
        className: "st6",
        x: 148.1,
        y: 175.2,
        width: 3,
        height: 3,
        transform: "translate(-81.1 157.5) rotate(-45)"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("rect", {
        id: "second-base",
        className: "st5",
        x: 123.7,
        y: 148.6,
        width: 3,
        height: 3,
        transform: "translate(-69.5 132.5) rotate(-45)"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("polygon", {
        id: "home",
        className: "st4",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", null, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(91 184.1) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(56.5 153.8) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(71 168.4) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(80.4 177.7) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(41.6 139) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(27.5 124) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(12.7 109.2) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 75.9) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 49.4) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450")))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 24.6) rotate(-44.2)"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500"))))))), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $42e34506b7821b24$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    })))));
}
var $42e34506b7821b24$var$_default = module.exports["default"] = $42e34506b7821b24$var$Venue2;

});

parcelRegister("dLcMP", function(module, exports) {
"use strict";
function $a0499550d88ab6d6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a0499550d88ab6d6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a0499550d88ab6d6$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a0499550d88ab6d6$var$React = $a0499550d88ab6d6$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $a0499550d88ab6d6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a0499550d88ab6d6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a0499550d88ab6d6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $a0499550d88ab6d6$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $a0499550d88ab6d6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a0499550d88ab6d6$var$_extends() {
    return $a0499550d88ab6d6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0499550d88ab6d6$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $a0499550d88ab6d6$var$Venue3(props) {
    return /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("svg", $a0499550d88ab6d6$var$_extends({
        id: "_x33__1_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "BOS"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        className: "st0",
        d: "M232.9,206.3l-7.2-5.8l-4-6.9l6.5,4.8L232.9,206.3z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        className: "st1",
        d: "M237.4,211.1c-6.4,5.7-16.2,5.2-21.9-1.2s-5.2-16.2,1.2-21.9s16.2-5.2,21.9,1.2 C244.3,195.5,243.7,205.4,237.4,211.1z M217.6,189c-5.8,5.2-6.3,14.2-1.1,20s14.2,6.3,20,1.1s6.3-14.2,1.1-20 C232.4,184.2,223.4,183.7,217.6,189z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        className: "st0",
        d: "M227.2,196.6c1.6,0.1,2.9,1.5,2.8,3.1c-0.1,1.6-1.5,2.9-3.1,2.8c-1.6-0.1-2.9-1.5-2.8-3.1 C224.1,197.7,225.5,196.5,227.2,196.6z M219.9,193.4l-2.1-2.3l0.3-0.3l2.5,0.6l-1.4-1.6l0.4-0.3l2.1,2.3l-0.3,0.3l-2.5-0.6 l1.4,1.6L219.9,193.4z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        className: "st2",
        d: "M227.1,197.9c0.9,0,1.6,0.8,1.6,1.7c-0.1,0.9-0.8,1.6-1.7,1.6c-0.9-0.1-1.6-0.8-1.6-1.7 C225.4,198.5,226.2,197.8,227.1,197.9z"
    })), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 132.1328 32.4541)",
        className: "st3 st4 st5"
    }, "420"), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 82.2178 46.2109)",
        className: "st3 st4 st5"
    }, "379"), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 214.7891 123)",
        className: "st3 st4 st5"
    }, "302"), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 222.8662 77.126)",
        className: "st3 st4 st5"
    }, "380"), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 15.98 109.7246)",
        className: "st3 st4 st5"
    }, "310")), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M72.1,173.9l-3.7-26.2l-34.2-35.4l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6 l1.6-1.6l1.6-1.6l1.6-1.6l1.7-1.6l1.7-1.6l1.7-1.6L57,90l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.7l1.8-1.7l1.8-1.7l1.8-1.8l1.8-1.8 l1.9-1.8l1.9-1.8l1.9-1.9l1.9-1.9l2-1.9l2-2l2.1-2l2.1-2l2.1-2.1l2.2-2.1l2.2-2.2l2.3-2.2L98,50l2.4-2.3l2.5-1.9h2.8l2.8-0.2 l2.7-0.7l2.7-0.7l2.7-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.9-0.8l2.9-0.8l2.9-0.8l3-0.8l3-0.8l3-0.8l3.1-0.8l3.1-0.8l3.2-0.8 l3.2-0.8l2.2,4l1.6,6.1l1.5,5.7l2.5,1.6l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2 l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.4,1.3l2.2,1.7l1.9,2.1l1.5,2.6l1,3.1 l0.2,3.9l-1.4,5.6l-3.9,7.9l-3.5,7.1l-3.1,6.3l-23.7,27l-18.1,36.1c0,0-30.6,37.8-33.4,41.6c-2.8,3.8-20.4,3.9-23.9,0.3 C110.4,216.6,72.1,173.9,72.1,173.9z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M80.2,171.3L75.9,144l-30.5-31.5l56.6-54l40.4-11.4l69.7,33.5l1.6,0.9l1.1,0.9l0.9,1l0.6,1.1 l0.4,1.3l0.1,1.6l-0.9,3.6l-7,14.2l-2.7,5.5L179.5,144l-15.7,33.5c0,0-29.2,35.1-30.4,36.6c-2.3,3-12,3.4-15,0.2 S80.2,171.3,80.2,171.3L80.2,171.3z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-91-91"
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l88-88"
    })), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $a0499550d88ab6d6$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $a0499550d88ab6d6$var$_default = module.exports["default"] = $a0499550d88ab6d6$var$Venue3;

});

parcelRegister("aFNri", function(module, exports) {
"use strict";
function $7c5415537392bc66$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7c5415537392bc66$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7c5415537392bc66$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7c5415537392bc66$var$React = $7c5415537392bc66$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $7c5415537392bc66$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7c5415537392bc66$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7c5415537392bc66$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $7c5415537392bc66$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $7c5415537392bc66$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7c5415537392bc66$var$_extends() {
    return $7c5415537392bc66$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c5415537392bc66$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $7c5415537392bc66$var$Venue4(props) {
    return /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("svg", $7c5415537392bc66$var$_extends({
        id: "_x34__1_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "CWS"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "Compass_100_"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        className: "st0",
        d: "M234,193.9l-6,6.9l-7.1,3.8l5-6.3L234,193.9z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        className: "st1",
        d: "M239,189.6c5.5,6.6,4.5,16.4-2.1,21.8c-6.6,5.5-16.4,4.5-21.8-2.1c-5.5-6.6-4.5-16.4,2.1-21.8 C223.7,182.1,233.5,183,239,189.6z M216.1,208.6c5,6,13.9,6.9,20,1.9c6-5,6.9-13.9,1.9-20c-5-6-13.9-6.9-20-1.9 S211.1,202.5,216.1,208.6z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        className: "st0",
        d: "M224.1,199.2c0.2-1.6,1.6-2.8,3.2-2.7c1.6,0.2,2.8,1.6,2.7,3.2c-0.2,1.6-1.6,2.8-3.2,2.7 C225.1,202.3,223.9,200.9,224.1,199.2z M218.7,208.4l-1.9-2.4l0.4-0.3l2.4,0.8l-1.3-1.7l0.4-0.3l1.9,2.4l-0.4,0.3l-2.4-0.8 l1.3,1.7L218.7,208.4z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        className: "st2",
        d: "M225.4,199.4c0.1-0.9,0.9-1.6,1.8-1.5c0.9,0.1,1.6,0.9,1.5,1.8c-0.1,0.9-0.9,1.6-1.8,1.5 C226,201.1,225.3,200.3,225.4,199.4z"
    }))), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 223.998 104.0229)",
        className: "st3 st4 st5"
    }, "335"), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 116.9365 34.0361)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 6.7607 112.9746)",
        className: "st3 st4 st5"
    }, "330")), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M27.4,107.2l1-0.6l1.4-2l1.4-2l1.4-2l1.4-2l1.4-2.1l1.5-2.1l1.5-2.1l1.5-2.1l1.5-2.1 l1.5-2.2l1.5-2.2l1.7-2.1l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.9l2-1.9l2-1.9l2-1.9l2-2l2.1-2l2.1-2l2.1-2l2.2-2 l2.3-1.7l2.4-1.6l2.4-1.6l2.5-1.4l2.5-1.4l2.6-1.4l2.6-1.1l2.7-1l2.7-1l2.7-1l2.7-1.3l2.7-1.6l2.7-1.6l2.9-0.5h29l2.9,0.4l2.7,1.6 l2.7,1.6l2.7,1.2l2.7,1l2.7,1l2.7,1l2.7,1l2.5,1.5l2.5,1.5l2.5,1.4l2.5,1.4l2.5,1.4l2.4,1.5l2.2,1.9l2.2,1.8l2.2,1.8l2,2.2l2,2.1 l2,2.1l1.9,2.1l1.9,2l1.9,2l1.9,2l1.8,2l1.8,2l1.8,2l1.7,2l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.6,1.8 l1.6,1.8l1.6,1.8l1.6,1.8l1.6,1.8l1,1.9l-9.7,10.3L177.4,176L150,208.2c0,0-13.4,14.3-24.6,14.6c-16.3,0-26.9-16.4-26.9-16.4 l-24.9-29.3L68,166.3l-29.3-48.4L27.4,107.2L27.4,107.2z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M110.1,208.5l-32.5-38l-31.8-54.4c0,0-4.7-5.8-5.5-7.4c-0.9-1.6-0.8-3.4-0.8-3.4 s-0.4-0.9,1.4-4c2-3.4,5.4-8.4,11.1-14.1c10.9-10.9,27.2-26,27.2-26l1.8-1.4l2.2-1.5l2-1.3c0,0,21.4-13.4,41-13.4 c11.4,0,22.1,3.1,33.6,7.9c11.5,4.7,30.7,28.4,30.7,28.4l20.4,22.7l1.2,3.5l-0.7,3.9l-1.6,2.7l-21.3,36l-16,24.3l-32.7,35.1 c-2.4,2.5-8.5,8.7-15.7,8.7S112,210.8,110.1,208.5L110.1,208.5z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-96.7-96.7"
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l98.4-98.4"
    })), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7c5415537392bc66$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $7c5415537392bc66$var$_default = module.exports["default"] = $7c5415537392bc66$var$Venue4;

});

parcelRegister("gnezC", function(module, exports) {
"use strict";
function $beba194f26ba4835$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $beba194f26ba4835$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $beba194f26ba4835$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $beba194f26ba4835$var$React = $beba194f26ba4835$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $beba194f26ba4835$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($beba194f26ba4835$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $beba194f26ba4835$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $beba194f26ba4835$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $beba194f26ba4835$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $beba194f26ba4835$var$_extends() {
    return $beba194f26ba4835$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $beba194f26ba4835$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $beba194f26ba4835$var$Venue5(props) {
    return /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("svg", $beba194f26ba4835$var$_extends({
        id: "_x35__1_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "CLE"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        className: "st0",
        d: "M227.1,208.5l-1.7-9l1.4-7.9l1.8,7.8L227.1,208.5z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        className: "st1",
        d: "M227.4,215c-8.5,0.2-15.7-6.6-15.9-15.1s6.6-15.7,15.1-15.9s15.7,6.6,15.9,15.1 C242.7,207.7,235.9,214.8,227.4,215z M226.7,185.3c-7.8,0.2-14,6.7-13.9,14.5c0.2,7.8,6.7,14,14.5,13.9c7.8-0.2,14-6.7,13.9-14.5 C241,191.4,234.5,185.2,226.7,185.3z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.1,1.2,3,0.1,4.2c-1.1,1.2-3,1.2-4.2,0.1c-1.2-1.1-1.2-3-0.1-4.2S227.9,196.2,229.1,197.4z  M225.6,190.3l-0.1-3.1h0.5l1.5,2.1v-2.1h0.5l0.1,3.1h-0.5l-1.5-2.1v2.1H225.6z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.3c0.7,0.6,0.7,1.7,0.1,2.3c-0.6,0.7-1.7,0.7-2.3,0.1c-0.7-0.6-0.7-1.7-0.1-2.3 C226.5,197.7,227.5,197.7,228.2,198.3z"
    })), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 222.4082 120.0635)",
        className: "st3 st4 st5"
    }, "325"), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 89.4565 36.2256)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 6.1768 120.0635)",
        className: "st3 st4 st5"
    }, "325")), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M204.2,129.3c0,0-13.1,16.3-28.1,38.7s-28.8,44.3-29.7,45.3c0,0-7.9,10.9-20.1,10.9 s-21.1-10.4-21.1-10.4l-50.3-76.1l-26.6-27.6l1.3-2.5l1.1-2.2l1.2-2.2l1.2-2.3l1.2-2.3l1.2-2.3l1.2-2.4l1.2-2.4l1.3-2.4l1.3-2.5 l1.3-2.5l1.3-2.6l1.8-2l2.1-1.4l2.1-1.4l2.1-1.4l2.2-1.4l2.2-1.4l2.2-1.4l2.2-1.5l2-1.6l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.3-1.5 l2.3-1.5l2.3-1.5L80,56l2.3-1.6l2.4-1.6l2.4-1.6l2.4-1.6L92,48l2.5-1.7l2.5-1.7l2.6-1.7l2.6-1.7l2.7-1.8l2.7-1.8l2.8-1.8l2.8-1.9 l2.9-0.5l3,1.1l3,1.1l2.9,1.1l2.9,1.1l2.9,1.1l2.8,1.1l2.8,1l2.8,1l2.7,1l2.7,1l2.7,1l2.7,1l2.6,1l2.6,1l2.6,1l2.6,1l2.6,1l2.6,1 l2.6,1l2.6,1l2.6,1l2.5,1l2.5,1l2.5,1l2.5,1l2.5,1l2.6,1l2,2.2l1.7,2.6l1.7,2.5l1.7,2.5l1.6,2.4l1.6,2.4l1.6,2.4l1.6,2.3l1.5,2.3 l1.5,2.3l1.5,2.2l1.5,2.2l1.5,2.2l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.3,2.1l1.3,2l1.3,2l1.9,3L204.2,129.3L204.2,129.3z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M126.7,218c-10.4,0-17.5-7.7-17.5-7.7l-49.4-75.1l-22-26.4l11.8-22.6l0.4-0.5l65.7-43.9 l68.2,25.6l0.3,0.3l28,43.5l-11.8,11.2c-20,29.5-57.5,86.1-57.5,86.1C142.5,209,136.5,218,126.7,218z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-95.7-95.7"
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l95.4-95.5"
    })), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $beba194f26ba4835$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $beba194f26ba4835$var$_default = module.exports["default"] = $beba194f26ba4835$var$Venue5;

});

parcelRegister("I10m5", function(module, exports) {
"use strict";
function $0844e3b19dfeda2c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0844e3b19dfeda2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0844e3b19dfeda2c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0844e3b19dfeda2c$var$React = $0844e3b19dfeda2c$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $0844e3b19dfeda2c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0844e3b19dfeda2c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0844e3b19dfeda2c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $0844e3b19dfeda2c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $0844e3b19dfeda2c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0844e3b19dfeda2c$var$_extends() {
    return $0844e3b19dfeda2c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0844e3b19dfeda2c$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $0844e3b19dfeda2c$var$Venue7(props) {
    return /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("svg", $0844e3b19dfeda2c$var$_extends({
        id: "_x37_",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("defs", null, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st4, .st5, .st6 {\n        isolation: isolate;\n      }\n\n      .st7, .st2 {\n        stroke-width: .75px;\n      }\n\n      .st7, .st2, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st5, .st6 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st6 {\n        font-size: 5px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "KCR"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st3",
        d: "M232.8,206.4l-7.1-5.9-3.9-7,6.4,4.9,4.6,8Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st13",
        d: "M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5-5.6-6.4-4.9-16.3,1.5-21.9,6.4-5.6,16.3-4.9,21.9,1.5,5.6,6.5,5,16.3-1.5,21.9ZM217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20s14.1,6.5,20,1.4,6.5-14.1,1.4-20-14.1-6.5-20-1.4Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st3",
        d: "M227.2,196.6c1.6.1,2.9,1.5,2.8,3.2-.1,1.6-1.5,2.9-3.2,2.8-1.6-.1-2.9-1.5-2.8-3.2.2-1.7,1.6-3,3.2-2.8ZM220,193.3l-2-2.3.4-.3,2.5.7-1.4-1.6.4-.3,2,2.3-.4.3-2.5-.7,1.4,1.6-.4.3Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st11",
        d: "M227.1,197.9c.9.1,1.6.9,1.5,1.8-.1.9-.9,1.6-1.8,1.5-.9-.1-1.6-.9-1.5-1.8.1-.9.9-1.6,1.8-1.5Z"
    })), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "right",
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st5",
        transform: "translate(224.91 94.79)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "344")))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "right-center",
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st5",
        transform: "translate(188.69 54.03)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "379")))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "center",
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st5",
        transform: "translate(104.27 30.24)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "410")))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "left-center",
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st5",
        transform: "translate(45.79 53.03)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "379")))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "left",
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st5",
        transform: "translate(9.19 93.18)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "347"))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "Outfield",
        className: "st12",
        d: "M29.48,107.32l-1.75-5.21-.27-3.88,1.26-2.34,1.67-1.91,1.68-1.92,1.69-1.93,1.7-1.94,1.71-1.95,1.73-1.97,1.74-1.98,1.75-2,1.77-2.02,1.79-2.04,1.81-2.06,1.83-2.08,1.85-2.11,1.91-2.07,2.1-1.77,2.13-1.75,2.15-1.76,2.2-1.72,2.23-1.69,2.25-1.71,2.31-1.64,2.35-1.58,2.37-1.6,2.39-1.62,2.42-1.63,2.44-1.65,2.47-1.67,2.5-1.69,2.53-1.71,2.57-1.73,2.6-1.76,2.64-1.78,2.78-1.19,2.85-.86,2.89-.72,2.91-.59,2.93-.56,2.95-.44,2.96-.32,2.97-.21,2.98-.13,2.98-.1,2.98.04,2.98.09,2.97.23,2.95.43,2.94.47,2.92.57,2.92.57,2.89.68,2.85.9,2.8,1.1,2.64,1.8,2.6,1.78,2.56,1.75,2.53,1.73,2.5,1.71,2.47,1.68,2.44,1.66,2.41,1.65,2.39,1.63,2.36,1.61,2.34,1.6,2.32,1.59,2.3,1.57,2.26,1.63,2.18,1.75,2.15,1.77,2.1,1.81,2.08,1.79,1.95,1.99,1.86,2.09,1.84,2.07,1.82,2.04,1.8,2.02,1.78,2,1.77,1.99,1.75,1.97,1.74,1.95,1.73,1.94,1.72,1.93,1.71,1.92,1.7,1.91,1.69,1.9,1.24,2.36-.24,3.85-1.68,5.15-.48.52-.7,5.86c-5.8,14.5-30.4,52.6-39,57.8-8.6,5.1-26.7,40.6-26.7,40.6,0,0-11.5,12.8-29.2,12.8h0c-17.7,0-27.7-12.3-27.7-12.3,0,0-22.4-34.5-29.1-39.3-11.5-8.2-39.2-64.6-39.2-64.6l.36-1.1Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M214.5,100.6l.2-2.3-.12-.81-22.56-24.29-1.62-1.32-17.76-13.55-14.54-10.17-1.9-1.31-5.09-1.96-2.6-.9-2.3-.7-5.4-1.2-2.5-.6-8.1-1-2.5-.1-5.7-.1-2.6.1-1.48.11-1.4.13-2.32.36-5.7.9-2.4.5-5.2,1.5-2.5.8-2.4.89-15.8,11.32-19.84,15.24-1.53,1.37-22.7,25.53,1.1,7.51v.02l23.37,41.22,13.4,18.8s25.9,39.8,30.9,43.6c3.8,2.9,11.4,6.4,21.2,6.4s17-5.5,19.6-7.9,12.3-15.9,12.3-15.9l18.4-28.7,12.8-15.7s5-8,9.7-15.3c4.3-6.8,9.7-15.2,12.7-22.6l1.8-5.9,1.1-4h-.01Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    })), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st2",
        d: "M125.2,203.2L28.1,106.1"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st2",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("rect", {
        id: "third-base",
        className: "st9",
        x: 99.21,
        y: 175.12,
        width: 3,
        height: 3,
        transform: "translate(-95.38 122.88) rotate(-44.98)"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("rect", {
        id: "first-base",
        className: "st9",
        x: 148.11,
        y: 175.21,
        width: 3,
        height: 3,
        transform: "translate(-81.13 157.47) rotate(-44.98)"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("rect", {
        id: "second-base",
        className: "st8",
        x: 123.71,
        y: 148.62,
        width: 3,
        height: 3,
        transform: "translate(-69.48 132.54) rotate(-45.01)"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("polygon", {
        id: "home",
        className: "st7",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", null, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(91.04 184.06) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(56.54 153.76) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(71.04 168.36) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(80.44 177.66) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(41.64 138.96) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(27.54 123.96) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(12.74 109.16) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.04 75.86) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.04 49.36) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450")))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.04 24.56) rotate(-44.2)"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500"))))))))), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $0844e3b19dfeda2c$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    }))));
}
var $0844e3b19dfeda2c$var$_default = module.exports["default"] = $0844e3b19dfeda2c$var$Venue7;

});

parcelRegister("bQd55", function(module, exports) {
"use strict";
function $89eeb2aa5878f01e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $89eeb2aa5878f01e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $89eeb2aa5878f01e$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $89eeb2aa5878f01e$var$React = $89eeb2aa5878f01e$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $89eeb2aa5878f01e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($89eeb2aa5878f01e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $89eeb2aa5878f01e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $89eeb2aa5878f01e$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $89eeb2aa5878f01e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $89eeb2aa5878f01e$var$_extends() {
    return $89eeb2aa5878f01e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $89eeb2aa5878f01e$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $89eeb2aa5878f01e$var$Venue10(props) {
    return /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("svg", $89eeb2aa5878f01e$var$_extends({
        id: "_x31_0_1_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "OAK"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        className: "st0",
        d: "M231.6,207.2l-6-6.9l-2.8-7.5l5.5,5.8L231.6,207.2z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        className: "st1",
        d: "M235.3,212.7c-7.2,4.5-16.8,2.3-21.4-4.9c-4.5-7.2-2.3-16.8,4.9-21.4c7.2-4.5,16.8-2.3,21.4,4.9 C244.7,198.5,242.5,208.1,235.3,212.7z M219.5,187.5c-6.6,4.2-8.6,12.9-4.5,19.6c4.2,6.6,12.9,8.6,19.6,4.5 c6.6-4.2,8.6-12.9,4.5-19.6C234.9,185.4,226.1,183.3,219.5,187.5z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        className: "st0",
        d: "M227.7,196.6c1.6,0.4,2.6,2,2.2,3.6c-0.4,1.6-2,2.6-3.6,2.2c-1.6-0.4-2.6-2-2.2-3.6 C224.5,197.3,226.1,196.3,227.7,196.6z M221.1,192.3l-1.6-2.6l0.4-0.2l2.3,1.1l-1.1-1.8l0.4-0.3l1.6,2.6l-0.4,0.2l-2.3-1.1 l1.1,1.8L221.1,192.3z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        className: "st2",
        d: "M227.4,197.9c0.9,0.2,1.4,1.1,1.2,2s-1.1,1.4-2,1.2s-1.4-1.1-1.2-2S226.5,197.7,227.4,197.9z"
    })), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 225.6758 115.0547)",
        className: "st3 st4 st5"
    }, "330"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x38_",
        transform: "matrix(1 0 0 1 211.5156 78.3281)",
        className: "st3 st4 st5"
    }, "367"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x37_",
        transform: "matrix(1 0 0 1 186.002 62.0732)",
        className: "st3 st4 st5"
    }, "362"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x36_",
        transform: "matrix(1 0 0 1 160.6152 46.4502)",
        className: "st3 st4 st5"
    }, "388"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 118.8296 33.3311)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x34_",
        transform: "matrix(1 0 0 1 71.5942 46.4492)",
        className: "st3 st4 st5"
    }, "388"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x33_",
        transform: "matrix(1 0 0 1 45.772 62.0732)",
        className: "st3 st4 st5"
    }, "362"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "_x32_",
        transform: "matrix(1 0 0 1 22.4839 78.3281)",
        className: "st3 st4 st5"
    }, "367"), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 4.8774 115.0547)",
        className: "st3 st4 st5"
    }, "330")), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M141.9,222.2c0,0-9.7,2.1-16.4,2.1s-16.4-1.9-16.4-1.9L102,215c0,0-56-19.7-60.2-82.7 l-16.1-20.7l2.3-5.5l1-2.4l1.1-2.4l1.1-2.4l1.1-2.5l1.1-2.5l1.1-2.6l1.1-2.6l1.2-2.7l1.2-2.7l1.2-2.8l1.2-2.8l1.3-2.9l2-1.8 l2.4-1.1l2.5-1l2.5-1l2.5-1l2.5-1l2.4-1l2.4-1l2.4-1l2.4-1l2.3-1.3l2.2-1.5l2.3-1.5L75,58l2.3-1.6l2.3-1.6l2.4-1.6l2.4-1.6 l2.4-1.6l2.4-1.7l2.5-1.7l2.6-1.5l2.6-1.3l2.7-1.3l2.7-1.3l2.7-1.3l2.7-1.3l2.8-1.3l2.9-0.3h23.2l2.9,0.3l2.8,1.4L145,40l2.7,1.3 l2.7,1.3l2.7,1.3l2.6,1.3l2.5,1.5l2.5,1.7l2.4,1.7l2.4,1.7l2.4,1.6l2.4,1.6l2.3,1.6L175,58l2.3,1.6l2.3,1.5l2.2,1.5l2.4,1.2l2.4,1 l2.4,1l2.4,1l2.5,1l2.5,1l2.5,1l2.5,1l2.5,1l2.4,1.1l2,1.9l1.3,2.9l1.2,2.8l1.2,2.8l1.2,2.7l1.2,2.7l1.1,2.6l1.1,2.6l1.1,2.5 l1.1,2.5l1.1,2.4l1.1,2.4l1.1,2.3l2.5,5l-15.9,22c-4.1,62.9-61.3,81.9-61.3,81.9L141.9,222.2L141.9,222.2z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M107.4,209.7l-6.9-3.1c-1.7-0.5-38.6-13.8-51.1-67.3l4.9-4l-19.8-23.8l13.9-31.6l1.1-0.5 l19.9-8.3l3-1.7L96,53.3l2-1.2l14.6-7.1l1.1-0.1l22.5-0.1l1.1,0.1l14.6,7.1l2,1.2l23.8,16.3l3.1,1.6l21.7,8.7l13.3,31.9L201,132.2 c4.2,26.3-16.3,51.1-33.7,64.9c-13.1,10.3-24,13.2-24,13.2l-2.7,5.9c0,0-8.3,2.1-15.1,2.1s-12.9-1.9-12.9-1.9L107.4,209.7 L107.4,209.7z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $89eeb2aa5878f01e$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $89eeb2aa5878f01e$var$_default = module.exports["default"] = $89eeb2aa5878f01e$var$Venue10;

});

parcelRegister("M3hBi", function(module, exports) {
"use strict";
function $090707b898cfb033$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $090707b898cfb033$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $090707b898cfb033$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $090707b898cfb033$var$React = $090707b898cfb033$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $090707b898cfb033$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($090707b898cfb033$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $090707b898cfb033$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $090707b898cfb033$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $090707b898cfb033$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $090707b898cfb033$var$_extends() {
    return $090707b898cfb033$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $090707b898cfb033$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $090707b898cfb033$var$Venue12(props) {
    return /*#__PURE__*/ $090707b898cfb033$var$React.createElement("svg", $090707b898cfb033$var$_extends({
        id: "_x31_2",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "TBR"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        className: "st0",
        d: "M232.5,206.6l-6.8-6.1l-3.7-7.2l6.2,5.1L232.5,206.6z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        className: "st1",
        d: "M236.7,211.6c-6.7,5.3-16.5,4.3-21.8-2.4s-4.3-16.5,2.4-21.8s16.5-4.3,21.8,2.4 C244.5,196.5,243.4,206.3,236.7,211.6z M218.1,188.4c-6.1,4.9-7.1,13.8-2.2,19.9c4.9,6.1,13.8,7.1,19.9,2.2 c6.1-4.9,7.1-13.8,2.2-19.9C233.2,184.5,224.3,183.6,218.1,188.4z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        className: "st0",
        d: "M227.3,196.6c1.6,0.2,2.8,1.6,2.6,3.3c-0.2,1.6-1.6,2.8-3.3,2.6c-1.6-0.2-2.8-1.6-2.6-3.3 C224.2,197.6,225.7,196.4,227.3,196.6z M220.3,193l-1.9-2.4l0.4-0.3l2.4,0.8l-1.3-1.7l0.4-0.3l1.9,2.4l-0.4,0.3l-2.4-0.8l1.3,1.7 L220.3,193z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        className: "st2",
        d: "M227.2,197.9c0.9,0.1,1.6,0.9,1.5,1.8c-0.1,0.9-0.9,1.6-1.8,1.5c-0.9-0.1-1.6-0.9-1.5-1.8 C225.5,198.4,226.3,197.8,227.2,197.9z"
    })), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 220.2607 114.3403)",
        className: "st3 st4 st5"
    }, "322"), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 175.7031 52.4072)",
        className: "st3 st4 st5"
    }, "378"), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 112.9507 33.5566)",
        className: "st3 st4 st5"
    }, "404"), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 55.1606 52.4072)",
        className: "st3 st4 st5"
    }, "378"), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 11.4497 119.7744)",
        className: "st3 st4 st5"
    }, "315")), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M219.2,109l-8,13.3l1.8,2.7l-0.7,6.7l-2.7,6l-6.5,6.5l-9.6,15.9l-21.1,21.5l-0.1,7.5 L150.7,210l-2.4,2.2l-4.4-0.3c0,0-9.4,8.5-12.4,9.4s-5.2,1.9-11.7,0.3s-14.6-9.8-14.6-9.8h-4.8l-22.8-22.1l0.2-8l-22.6-22.1 l-9-15.2l-8.2-9.1L32.8,111l-0.9-4.2l-0.9-4.3l-0.5-4.1l1.1-2.4l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8 l1.8-1.8l1.8-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-2l2-2l2-2l2-2l2-2.1l2.1-2.1l2.1-2.1l2.1-2.2l2.2-2.2l2.2-2.2l2.3-2.3 l2.3-2.3l2.5-1.7l2.8-0.7l2.4-2.6l2.1-4.3l2.6-2.3l3.1,0.2l3.1,0.2l3,0.2l3,0.2l3,0.2l3,0.2l3,0.2l3,0.2l2.9,0.2l2.9,0.2l2.9,0.2 l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.5l2.8,0.9l2.8,0.9l2.8,0.9l2.4,2.4L167,45l2.3,2.3 l2.3,2.3l2.2,2.2L176,54l2.1,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l1.9,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8 l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l-0.5,4.2l-0.5,4.1L219.2,109L219.2,109z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M107.1,207.7l-5.1,0.1l-19.8-20l0.6-8.7l-24.2-21.9l-9-15.8l2-3.8l-3.8-4.5 c0,0-1.3,0.4-1.9-0.1l-5.2-23.3l-0.9-4.6l-0.8-4l-0.1-1.1l58.3-58.8l53.3,3.4l1.9,0.3l6,2l1.1,1.1l51.1,52l-2.5,20.2l0.5,9 l-2.4,5.8l-7.2,7.1l-7.5,12.5l-24.6,24.5l-0.1,8.5l-21.4,21.1l-2.3-2.1c0,0-11.3,11.4-14.5,11.4s-0.4,0.2-6.2,0.2 S107.1,207.7,107.1,207.7z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-92.3-92.3"
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l94-94.1"
    })), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $090707b898cfb033$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090707b898cfb033$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $090707b898cfb033$var$_default = module.exports["default"] = $090707b898cfb033$var$Venue12;

});

parcelRegister("esLVO", function(module, exports) {
"use strict";
function $a878dc66a960aafd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a878dc66a960aafd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a878dc66a960aafd$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a878dc66a960aafd$var$React = $a878dc66a960aafd$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $a878dc66a960aafd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a878dc66a960aafd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a878dc66a960aafd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $a878dc66a960aafd$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $a878dc66a960aafd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a878dc66a960aafd$var$_extends() {
    return $a878dc66a960aafd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a878dc66a960aafd$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $a878dc66a960aafd$var$Venue13(props) {
    return /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("svg", $a878dc66a960aafd$var$_extends({
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("defs", null, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("style", null, '\n      .st0 {\n        fill: #5b5b5b;\n      }\n\n      .st1, .st2 {\n        isolation: isolate;\n      }\n\n      .st3, .st4, .st5, .st6 {\n        fill: #fff;\n      }\n\n      .st3, .st5, .st6 {\n        stroke: #fff;\n      }\n\n      .st7, .st2 {\n        fill: #68836a;\n      }\n\n      .st8 {\n        fill: #ffec5f;\n      }\n\n      .st9 {\n        fill: #a88b49;\n      }\n\n      .st10 {\n        fill: #a98c48;\n      }\n\n      .st11 {\n        fill: #7f7f7f;\n      }\n\n      .st2 {\n        font-family: ArialMT, Arial;\n        font-size: 11px;\n      }\n\n      .st5 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n\n      .st6 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n    ')), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "TEX_-_13"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "Compass_copy_8"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "Compass"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("polygon", {
        className: "st0",
        points: "232.2 192.24 228.3 200.52 222.54 206.09 225.62 198.68 232.2 192.24"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("path", {
        className: "st11",
        d: "M235.79,186.73c7.06,4.85,8.86,14.5,4.01,21.57s-14.5,8.86-21.57,4.01c-7.06-4.85-8.86-14.5-4.01-21.57h0c4.85-7.05,14.5-8.84,21.56-4h.01ZM219,211.22c6.46,4.44,15.29,2.8,19.73-3.66s2.8-15.29-3.66-19.73-15.29-2.8-19.73,3.66h0c-4.42,6.47-2.78,15.29,3.67,19.73h0Z"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("circle", {
        className: "st0",
        cx: 227.02,
        cy: 199.53,
        r: 2.97
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("path", {
        className: "st0",
        d: "M222.77,207.85l-1.77,2.54-.39-.27v-2.55h0l-1.2,1.75-.41-.32,1.74-2.54.39.27v2.56h0l1.21-1.76.43.32Z"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("circle", {
        className: "st8",
        cx: 227.01,
        cy: 199.54,
        r: 1.65
    }))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("path", {
        id: "Outfield",
        className: "st10",
        d: "M27.36,108.91l.06-14,43.76-52.67,19.38-10.79,67.28-.3,16,13.56h8.52l43.12,47.64-1.48,16.91-16.59,16.92-1.58,2.32s-57.18,84.47-63.13,92c-8.74,11-21.62,12.66-32.25.48-11.45-13.26-59.11-75.56-66.81-87.1l.72-3.37s-17-21.6-17-21.6Z"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("path", {
        id: "grass",
        className: "st7",
        d: "M36.58,109.13v-13.23l38.7-48.66,18.44-10.35,58.89-.3,15.33,12.8h6.5l43.75,47.41-2.95,12.94-16.32,17.51-.72,2.41s-54.61,77.46-60.14,84.67-13.71,14.43-21.41,4.09-66.65-86.59-66.65-86.59v-4.57s-13.42-18.13-13.42-18.13Z"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "infield_sand"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("path", {
        className: "st3",
        d: "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53,0,4.51,3.66,8.17,8.18,8.16,4.51,0,8.16-3.66,8.16-8.16,0-1.41-.38-2.79-1.1-4l32.13-30.95ZM120.75,195.16l-17.67-17.71c1.14-1.37,3.31-3.3,3.31-5.2,0-.92-.17-1.83-.49-2.69l14.58-14.19c1.34.94,2.9,1,4.68,1s3.36,0,4.67-.83l14.54,14.16c-.3.83-.46,1.71-.46,2.6,0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66h-8.59Z"
    })), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(10.24 88.03)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "332"))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(48.45 42.27)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "390"))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(115.3 26.26)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400"))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(162.94 31.15)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "407"))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(198.56 58.23)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "381"))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        className: "st1"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("text", {
        className: "st2",
        transform: "translate(228.67 94.68)"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "325")))), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "Pitchers_mound"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("circle", {
        className: "st3",
        cx: 125.25,
        cy: 177.46,
        r: 3.83
    })), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("g", {
        id: "Bases_and_chalk_lines-ALL"
    }, /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("rect", {
        className: "st3",
        x: 123.17,
        y: 176.68,
        width: 3.98,
        height: 1.55
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("rect", {
        className: "st6",
        x: 98.4,
        y: 174.55,
        width: 3.04,
        height: 3.04,
        transform: "translate(-95.22 122.19) rotate(-44.99)"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("rect", {
        className: "st6",
        x: 148.88,
        y: 174.54,
        width: 3.04,
        height: 3.04,
        transform: "translate(-80.44 157.88) rotate(-44.99)"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("rect", {
        className: "st5",
        x: 123.65,
        y: 149.33,
        width: 3.04,
        height: 3.04,
        transform: "translate(-70.01 132.73) rotate(-45.01)"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("polygon", {
        className: "st3",
        points: "126.7 201.88 125.16 203.41 123.65 201.88 123.65 200.36 126.7 200.36 126.7 201.88"
    }), /*#__PURE__*/ $a878dc66a960aafd$var$React.createElement("polygon", {
        className: "st4",
        points: "125.18 204.53 124.65 204 27.36 106.67 27.36 104.55 125.18 202.41 219.49 108.25 224.56 103.47 224.37 105.54 219.49 110.36 125.18 204.53"
    })));
}
var $a878dc66a960aafd$var$_default = module.exports["default"] = $a878dc66a960aafd$var$Venue13;

});

parcelRegister("6XYHt", function(module, exports) {
"use strict";
function $51275690d9574966$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $51275690d9574966$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $51275690d9574966$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $51275690d9574966$var$React = $51275690d9574966$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $51275690d9574966$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($51275690d9574966$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $51275690d9574966$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $51275690d9574966$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $51275690d9574966$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $51275690d9574966$var$_extends() {
    return $51275690d9574966$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $51275690d9574966$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $51275690d9574966$var$Venue14(props) {
    return /*#__PURE__*/ $51275690d9574966$var$React.createElement("svg", $51275690d9574966$var$_extends({
        id: "_x31_4",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $51275690d9574966$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n\t.st16{fill:none;stroke:#B3B3B3;stroke-width:0.25;stroke-miterlimit:10;}\n"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "TOR"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st0",
        d: "M226.9,208.5l-1.5-9.1l1.6-7.8l1.6,7.8L226.9,208.5z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st1",
        d: "M227.1,215c-8.6,0-15.5-6.9-15.5-15.5s6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5C242.5,208,235.6,215,227.1,215z  M227,185.3c-7.8,0-14.2,6.4-14.1,14.2c0,7.8,6.4,14.2,14.2,14.1c7.8,0,14.2-6.4,14.1-14.2C241.2,191.7,234.8,185.3,227,185.3z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.2,1.2,3,0,4.2s-3,1.2-4.2,0s-1.2-3,0-4.2C226.1,196.3,227.9,196.3,229.1,197.4z  M225.8,190.3v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.8z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.4c0.6,0.6,0.6,1.7,0,2.3s-1.7,0.6-2.3,0s-0.6-1.7,0-2.3C226.5,197.7,227.5,197.7,228.2,198.4z"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 224.0186 113.4121)",
        className: "st3 st4 st5"
    }, "328"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 178.751 51.9463)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 116.1396 33.0791)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 54.8125 52.1807)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 7.8335 113.4126)",
        className: "st3 st4 st5"
    }, "328")), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "Outfield_00000139263571581690122010000007572633505411225276_",
        className: "st6",
        d: "M28.6,106.5l1.7-1.6l1.6-1.7l1.7-1.7 l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.6-1.9l1.6-1.9l1.6-2l1.6-2l1.6-2l1.7-2l1.4-2.4L53,78l1.5-2.5L56,73l1.6-2.6l1.8-2.2l2-1.9 l2-2l2-2l2-2l2.1-2l2.1-2l2.2-2.1l2.2-2.1l2.5-1.2l2.6-1.1l2.6-1l2.6-1l2.6-1.1l2.6-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1 l2.8-1l2.8-1l2.8-0.7l2.9-0.4l2.9-0.4l2.9-0.2h2.9h2.9l2.9,0.2l2.9,0.4l2.9,0.4l2.8,0.8l2.8,0.9l2.8,1l2.7,1.2l2.7,1.3l2.7,1.3 l2.6,1.3l2.6,1.2l2.6,1.2l2.6,1.2L166,50l2.5,1.2l2.4,1.6l2.2,2.2l2.1,2.2l2.1,2.2l2,2.1l2,2.1l2,2l2,2l1.9,2l2,1.8l2,1.7l2,1.7 l2,1.7l2,1.5l2.1,1.3l2.2,1.3l2.1,1.3l2.1,1.3l1.5,2.2l1.5,2.2l1.5,2.1l1.5,2.1l1.5,2.1l1.5,2l1.5,2.1l1.4,2l1.4,2l1.4,2l1.4,2 l0.5,0.8c0,0-7.3,7.6-8.9,9.1c-1.6,1.5-3,2.3-4.8,5.2c-1.9,2.9-3,5.7-4.3,8.3s-4.8,10.4-6.2,13.7s-3.9,8.3-5.2,10.4 c-1.3,2.1-5.6,9.2-7.5,12.3s-9.2,13.6-11.6,16.5c-2.4,3-8.9,11.2-8.9,11.2s-2.6,3.4-3.5,4.9l-4.3,5.7l0.5,0.9c0,0-7,6.5-8.2,7.5 c-1.1,0.9-4.2,3.3-4.2,3.3l-0.8-0.8c-4.2,2.7-7.2,4.8-10,5.4s-2.3,0.8-4.2,0.8s-9.6,0-11.6,0s-8.9-3.4-10.1-4.1l-1,0.7 c0,0-7.2-5.7-9-7.4s-6.2-5.1-6.2-5.1l0.5-0.8c0,0-2.7-4.1-3.6-5.4s-3.1-4.4-3.1-4.4s-0.7-0.8-2.1-2.3s-7.2-9.4-9.7-12.4 c-2.4-3-3.8-5.4-6.4-9.2s-5.3-8.7-7.3-12.2s-5.3-9.4-7.2-13.1c-1.9-3.7-3.9-8.6-4.8-11.2c-0.9-2.6-4.2-8.9-4.9-10.2 c-0.7-1.3-1.8-3.4-3.2-5.1c-1.4-1.6-12.1-12.8-12.1-12.8L28.6,106.5z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "grass_00000174589876715782793730000007613552633814403240_",
        className: "st3",
        d: "M190.9,144.1c-2.6,4.8-13.4,22.5-16,25.8 c-2.7,3.3-16,19.3-19,23.1s-11,14.3-14.3,16.9c-3.3,2.6-9.6,6.4-11.9,6.4c-2.3,0-6.6,0-9.3,0c-2.7,0-11.5-5.1-14.6-7.4 c-3.2-2.3-6.6-5.2-9.3-8.7c-2.7-3.6-9-13.2-12.4-17.3S73.7,169,70.4,164.2c-3.3-4.8-11.5-20.6-13-23.9c-1.5-3.4-6.8-14.8-7.6-16.5 s-3.7-6.2-3.7-6.2s-0.9-1.8-1.9-3.1c-1-1.3-6.1-6.8-6.1-6.8s5.2-4.7,7.6-7.3s10.2-12.7,11.9-14.9S64,73.1,66.4,71 c2.4-2.2,12.1-11.7,15.4-13.5s12.1-5.6,16.3-7.2c4.2-1.6,17.3-7.1,19.8-7.1s10.8,0,14.9,0c4.1,0,29.2,12.9,32.4,15.3 s7.8,7,10.1,9.9s12.3,12.3,15,14.5s6.9,4.2,8.9,5.9c2,1.7,13.7,18.7,13.7,18.7l-9.2,9.4l-1.9,2.7 C201.9,119.4,197.6,131.9,190.9,144.1z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "grid",
        className: "st11"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)",
        className: "st4 st13"
    }, "90"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)",
        className: "st4 st13"
    }, "200"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)",
        className: "st4 st13"
    }, "150"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)",
        className: "st4 st13"
    }, "120"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)",
        className: "st4 st13"
    }, "250"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)",
        className: "st4 st13"
    }, "300"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)",
        className: "st4 st13"
    }, "350"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)",
        className: "st4 st13"
    }, "400"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)",
        className: "st4 st13"
    }, "450"), /*#__PURE__*/ $51275690d9574966$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)",
        className: "st4 st13"
    }, "500")), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        id: "surface29_2_"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st14",
        d: "M125.5,203.8l-148-148"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st14",
        d: "M124.8,203.8l148-148"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5l79.8-192.6"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st14",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x32_00-line_2_",
        className: "st14",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x39_0-line_2_",
        className: "st14",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st14",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st14",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st14",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st14",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st14",
        d: "M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x34_00-line_1_",
        className: "st14",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st14",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
    })), /*#__PURE__*/ $51275690d9574966$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 16,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 18,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 20.1,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 22.2,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 24.3,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 26.3,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 28.4,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 30.5,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 32.6,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $51275690d9574966$var$React.createElement("rect", {
        x: 125.2,
        y: 34.6,
        className: "st16",
        width: 4.9,
        height: 2.1
    }))));
}
var $51275690d9574966$var$_default = module.exports["default"] = $51275690d9574966$var$Venue14;

});

parcelRegister("kLrPm", function(module, exports) {
"use strict";
function $f1ddc85f7d807944$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1ddc85f7d807944$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1ddc85f7d807944$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f1ddc85f7d807944$var$React = $f1ddc85f7d807944$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $f1ddc85f7d807944$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f1ddc85f7d807944$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f1ddc85f7d807944$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $f1ddc85f7d807944$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $f1ddc85f7d807944$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f1ddc85f7d807944$var$_extends() {
    return $f1ddc85f7d807944$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f1ddc85f7d807944$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $f1ddc85f7d807944$var$Venue15(props) {
    return /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("svg", $f1ddc85f7d807944$var$_extends({
        id: "_x31_5",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "ARI"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        className: "st0",
        d: "M226.8,208.5l-1.4-9.1l1.6-7.8l1.6,7.8L226.8,208.5z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        className: "st1",
        d: "M227,215c-8.6,0-15.5-7-15.5-15.5c0-8.6,7-15.5,15.5-15.5c8.6,0,15.5,7,15.5,15.5 C242.5,208.1,235.5,215,227,215z M227,185.3c-7.8,0-14.2,6.3-14.2,14.2c0,7.8,6.3,14.2,14.2,14.2c7.8,0,14.2-6.3,14.2-14.2 C241.2,191.7,234.9,185.3,227,185.3z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.2,1.2,3,0,4.2s-3,1.2-4.2,0s-1.2-3,0-4.2C226.1,196.3,228,196.3,229.1,197.4z  M225.8,190.2v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.8z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.4c0.6,0.6,0.6,1.7,0,2.3s-1.7,0.6-2.3,0s-0.6-1.7,0-2.3C226.5,197.7,227.5,197.7,228.2,198.4z"
    })), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 6.9824 117.9487)",
        className: "st3 st4 st5"
    }, "330"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 43.75 60.9282)",
        className: "st3 st4 st5"
    }, "368"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 72.6675 34.1655)",
        className: "st3 st4 st5"
    }, "413"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 156.168 34.2153)",
        className: "st3 st4 st5"
    }, "413"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 120.2983 30.564)",
        className: "st3 st4 st5"
    }, "407"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 179.1035 52.6802)",
        className: "st3 st4 st5"
    }, "376"), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 226.0488 108.4307)",
        className: "st3 st4 st5"
    }, "335")), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M223.2,105l-0.5,1.8l-1.4,2.2v7.4h-0.8L202.7,135l-22.8,39.3c0,0-41.1,45.9-45.7,48.1 c-1.6,1-3,2.9-8.8,2.9c-5.1,0-8-1.9-9.9-2.9c-4.2-2.1-43.2-47-43.2-47l-23.8-40.3L30,115.7h-2l-0.1-9.6V95.3l-0.1-3.9l-0.1-4.1 l2.9-0.7h3.3l2-1.6l1.9-1.7l1.9-1.7l1.9-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2.1-1.9l2.1-1.9l2.1-1.9l2.1-1.9l2.2-1.9 l2.2-2l2.2-2l2.2-2l2.3-2l2.3-2.1l2.3-2.1l2.4-2.2l2.4-2.2l2.5-2.2l2.5-2.3l2.7-1.7l2.9-0.6l3-0.5h21l3,0.8h5.8l3-0.8h21l2.8,1.1 h3l2.7,1.9l2.5,2.3l2.5,2.2l2.4,2.2l2.4,2.1l2.3,2.1l2.3,2.1l2.3,2l2.2,2l2.2,2l2.2,2l2.2,1.9l2.2,1.7l2.1,1.9l2.1,1.9l2.1,1.9 l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l1.9,1.8l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7l3.1,0.3l2.1,1.5v11.3L223.2,105L223.2,105z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.7,220.2c-3.1,0-6.3-1.6-7.4-2.2c-3.8-2.9-23.2-24.2-40.5-42.8l-22.9-41.9L36,114.4v-11.8 l0.8-8l4.3-3.6l53.4-48l4.3-1.1h51.6l4.8,1.1l0.2,0.1l59.2,53.1v16.5l-17.2,18.4l-22.9,39.4c-16.6,18.5-38.8,44.7-42.8,47.7 C131.7,218.3,129.3,220.2,125.7,220.2z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7 s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.3,0,0.5,0,0.8l-12.6,2.5l7.2,8l6.7-7.4c1.2,1.7,3.2,2.8,5.4,2.8 s4.2-1.1,5.4-2.8l6.7,7.4l7.2-8l-12.6-2.5C131.9,202.9,131.9,202.7,131.9,202.4z M125.2,195.7c-1.6,0-3.2,0.6-4.3,1.6l-17.7-17.7 l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5 l-17.7,17.7C128.4,196.3,126.8,195.7,125.2,195.7z"
    })), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2L28,106.1"
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l98.1-98.1"
    })), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $f1ddc85f7d807944$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $f1ddc85f7d807944$var$_default = module.exports["default"] = $f1ddc85f7d807944$var$Venue15;

});

parcelRegister("aNjSP", function(module, exports) {
"use strict";
function $7dbde76483385f87$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7dbde76483385f87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7dbde76483385f87$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7dbde76483385f87$var$React = $7dbde76483385f87$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $7dbde76483385f87$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7dbde76483385f87$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7dbde76483385f87$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $7dbde76483385f87$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $7dbde76483385f87$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7dbde76483385f87$var$_extends() {
    return $7dbde76483385f87$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7dbde76483385f87$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $7dbde76483385f87$var$Venue16(props) {
    return /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("svg", $7dbde76483385f87$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#A98C48;}\n\t.st4{fill:#68836A;}\n\t.st5{font-family:'ArialMT';}\n\t.st6{font-size:11px;}\n\t.st7{fill:#A88B49;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:1.5;}\n"), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "ATL_-_16"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "Compass_copy_11"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("polygon", {
        className: "st0",
        points: "231.2,207.4 225.5,200.2 223.1,192.6 228.4,198.6  "
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st1",
        d: "M234.5,213.1c-7.5,4.1-16.9,1.4-21.1-6c-4.1-7.5-1.4-16.9,6-21.1c7.5-4.1,16.9-1.4,21.1,6 C244.7,199.5,242,208.9,234.5,213.1z M220.1,187.1c-6.8,3.8-9.3,12.4-5.5,19.3c3.8,6.8,12.4,9.3,19.3,5.5 c6.8-3.8,9.3-12.4,5.5-19.3C235.6,185.8,227,183.3,220.1,187.1z"
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("ellipse", {
        transform: "matrix(0.2752 -0.9614 0.9614 0.2752 -27.2691 362.8697)",
        className: "st0",
        cx: 227,
        cy: 199.5,
        rx: 3,
        ry: 3
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", null, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st0",
        d: "M221.5,192l-1.5-2.7l0.4-0.2l2.3,1.2l0,0l-1-1.9l0.5-0.3l1.5,2.7l-0.4,0.2l-2.3-1.2l0,0l1,1.9L221.5,192z"
    })), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("ellipse", {
        transform: "matrix(0.2751 -0.9614 0.9614 0.2751 -27.2615 362.8816)",
        className: "st2",
        cx: 227,
        cy: 199.5,
        rx: 1.6,
        ry: 1.6
    }))), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st3",
        d: "M231.6,116.3l-6.6-11.2l-23.7-48.5l-21.1-14.8c0,0-39.8-11.1-50-10.8c-59,1.9-96.8,47.1-96.8,47.1l-11.5,22.1 l-3.3,15.2l18.8,15.5L64,177.3c0,0,19.5,22.7,24.1,28c4.6,5.3,16.1,17.9,19.7,21.5c3.6,3.6,8.9,7.1,15.5,7.4 c6.6,0.3,16-7.5,25.9-19.1c9.9-11.5,32-33.3,32-33.3l20.1-33.6L231.6,116.3z"
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st4",
        d: "M225.3,118.4l-5.8-13.5l-23.8-47l-18.3-12.2c0,0-34.3-10.8-44.3-10.5c-57.5,1.9-91.1,43.4-91.1,43.4 l-13.5,24.7L28,118.2l12.2,10.3l26,45.3c0,0,19,22.2,23.5,27.3c4.5,5.1,15.6,17.5,19.2,21c3.5,3.5,8.6,6.9,15.1,7.2 c6.4,0.3,15.6-7.4,25.2-18.6c9.6-11.2,31.2-32.5,31.2-32.5l19.6-32.8L225.3,118.4z"
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "infield_sand_copy_4"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st3",
        d: "M164.3,168.5c0,0-12-31-38.8-30.8c-27.3,0.2-39.4,30.1-39.4,30.1l32.5,31.2c-1.2,1.1-1.6,3.3-1.6,4.5 c0,4.4,3.7,8,8.2,8c4.5,0,8.2-3.6,8.2-8c0-1.4-0.4-2.8-1.1-4L164.3,168.5z M125.1,195.5c-1.2,0-2.3,0.2-3.3,0.7l-18.3-17.9 c1.1-1.4,1.8-3.1,1.8-5c0-0.9-0.2-1.8-0.5-2.7l15.6-15.2c1.3,0.9,3,1.5,4.8,1.5c1.7,0,3.3-0.5,4.6-1.4l15.5,15.2 c-0.3,0.8-0.5,1.7-0.5,2.6c0,1.9,0.7,3.6,1.8,5l-18.4,17.9C127.4,195.7,126.3,195.5,125.1,195.5z"
    })), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 2.5835 113.2129)",
        className: "st4 st5 st6"
    }, "335"), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 226.7085 100.7139)",
        className: "st4 st5 st6"
    }, "330"), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 194.5464 43.9053)",
        className: "st4 st5 st6"
    }, "390"), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 121.4312 25.1065)",
        className: "st4 st5 st6"
    }, "401"), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("text", {
        transform: "matrix(1 0 0 1 27.3965 59.6983)",
        className: "st4 st5 st6"
    }, "380")), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "Pitchers_mound"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("ellipse", {
        transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -88.7986 140.5403)",
        className: "st7",
        cx: 125.2,
        cy: 177.5,
        rx: 3.8,
        ry: 3.8
    })), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", {
        id: "Bases_and_chalk_lines-ALL"
    }, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("g", null, /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st8",
        d: "M15.6,93.6"
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st8",
        d: "M125.2,204.3"
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("path", {
        className: "st8",
        d: "M232,94.3"
    })), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("rect", {
        x: 123.2,
        y: 176.7,
        className: "st9",
        width: 4,
        height: 1.6
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("rect", {
        x: 98.4,
        y: 174.6,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.2212 122.1912)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("rect", {
        x: 148.9,
        y: 174.6,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -80.4458 157.8735)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("rect", {
        x: 123.7,
        y: 149.3,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -70.0001 132.7314)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("polygon", {
        className: "st9",
        points: "126.7,201.9 125.2,203.4 123.7,201.9 123.7,200.4 126.7,200.4  "
    }), /*#__PURE__*/ $7dbde76483385f87$var$React.createElement("polyline", {
        className: "st10",
        points: "234.6,94.3 125.2,203.5 17.9,96.2  "
    })));
}
var $7dbde76483385f87$var$_default = module.exports["default"] = $7dbde76483385f87$var$Venue16;

});

parcelRegister("fGzhH", function(module, exports) {
"use strict";
function $b6b62609e7d90bfb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b6b62609e7d90bfb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b6b62609e7d90bfb$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b6b62609e7d90bfb$var$React = $b6b62609e7d90bfb$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $b6b62609e7d90bfb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b6b62609e7d90bfb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b6b62609e7d90bfb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b6b62609e7d90bfb$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b6b62609e7d90bfb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b6b62609e7d90bfb$var$_extends() {
    return $b6b62609e7d90bfb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b6b62609e7d90bfb$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $b6b62609e7d90bfb$var$Venue17(props) {
    return /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("svg", $b6b62609e7d90bfb$var$_extends({
        id: "_x31_7",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "CHC"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        className: "st0",
        d: "M230.8,207.6l-5.3-7.5l-2-7.7l4.9,6.3L230.8,207.6z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        className: "st1",
        d: "M233.9,213.4c-7.7,3.8-17,0.6-20.8-7c-3.8-7.7-0.6-17,7-20.8c7.7-3.8,17-0.6,20.8,7 C244.7,200.3,241.6,209.6,233.9,213.4z M220.7,186.8c-7,3.5-9.9,12-6.4,19s12,9.9,19,6.4s9.9-12,6.4-19 C236.3,186.2,227.7,183.3,220.7,186.8z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        className: "st0",
        d: "M228,196.7c1.6,0.5,2.4,2.2,1.9,3.8s-2.2,2.4-3.8,1.9s-2.4-2.2-1.9-3.8S226.4,196.2,228,196.7z M221.8,191.7 l-1.4-2.8l0.4-0.2l2.2,1.3l-0.9-1.9l0.5-0.2l1.4,2.8l-0.4,0.2l-2.2-1.3l0.9,1.9L221.8,191.7z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        className: "st2",
        d: "M227.5,198c0.9,0.3,1.3,1.2,1,2.1c-0.3,0.9-1.2,1.3-2.1,1c-0.9-0.3-1.3-1.2-1-2.1 C225.7,198.1,226.7,197.7,227.5,198z"
    })), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 226.9287 95.6519)",
        className: "st3 st4 st5"
    }, "353"), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("text", {
        id: "_x34_",
        transform: "matrix(1 0 0 1 175.7158 51.2051)",
        className: "st3 st4 st5"
    }, "368"), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 118.5474 33.9897)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("text", {
        id: "_x33_",
        transform: "matrix(1 0 0 1 73.4697 51.2051)",
        className: "st3 st4 st5"
    }, "368"), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 4.9717 94.0034)",
        className: "st3 st4 st5"
    }, "355")), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M60.1,148.8l-17.3-27.2L20.9,99.8l1.3,0.6l0.5-3.1l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6 l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.7l2-1.7l3.5,1l2.6-0.5l2.1-1.5l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3 l2.2-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.4-1.4l2.4-1.4l2.4-1.5l2.4-1.5l2.5-1.5l2.5-1.5l2.5-1.5l2.6-1.6l2.6-1.6 l2.7-1.6l2.7-1.4l2.8-1.1l2.8-1l2.9-0.8l2.9-0.5l2.9-0.5l2.9-0.5l2.9-0.3l2.9-0.1l2.9-0.1l2.9,0.5l2.9,0.7l2.9,0.5l2.8,0.8 l2.8,0.8l2.8,1l2.7,1.4L162,43l2.6,1.6l2.5,1.6l2.4,1.8l2.3,2l2.3,1.9l2.2,2.1l2.2,2.1l2.1,2.1l2.1,2.1l2.1,2l2,2l2,2l2,2l2,1.9 l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l2.6,0.7l4-1.4l2.9,0.3l1.9,2l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2 l1.6,2l-22.2,22.3c0,0-41.7,66.6-45.4,73.2c-3,5.5-13.3,13.2-25.9,24.6c-7.3,6.6-15.2,7.5-22.9-1.7L60.1,148.8L60.1,148.8z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M122.5,217.3c-0.4,0-2.4-1-4.1-2.9l-52.6-70c0,0-30.4-35.1-29.8-40.9 c0.5-5.8,22.3-20.3,22.3-20.3l7.5-0.9L69,80l1.9-1.1l44-28l2.2-1.1l2.2-0.9l2.4-0.8l2.2-0.6l5.4-0.9l2.6-0.4l2.4-0.2l4.8-0.1 l1.8,0.3l2.8,0.7l2.7,0.5l4,1.5l2.1,0.8l2.1,1.1l2.4,1.3l2.4,1.5l2.2,1.4l2,1.5l4.2,3.6l2,1.9l23.9,24.2c0,0,2.9,2.6,4.8,3.1 s4.4,0.3,5.5,0.7s10,12.8,10,14.9c0,0.5-3.5,4.4-3.5,4.4l-16.7,16.1l-0.4,0.7c-4.5,6.8-35.7,61-39.4,67.7 c-1.9,3.3-7.2,7.6-15.2,14.9c-2,1.8-5.1,3.7-7.3,5.7C126.4,218.6,123.6,217.3,122.5,217.3L122.5,217.3z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2L21.6,99.7"
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2L228.4,99.9"
    })), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $b6b62609e7d90bfb$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $b6b62609e7d90bfb$var$_default = module.exports["default"] = $b6b62609e7d90bfb$var$Venue17;

});

parcelRegister("d9LSj", function(module, exports) {
"use strict";
function $9941409eda18393d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9941409eda18393d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9941409eda18393d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9941409eda18393d$var$React = $9941409eda18393d$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $9941409eda18393d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9941409eda18393d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9941409eda18393d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9941409eda18393d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9941409eda18393d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9941409eda18393d$var$_extends() {
    return $9941409eda18393d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9941409eda18393d$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $9941409eda18393d$var$Venue19(props) {
    return /*#__PURE__*/ $9941409eda18393d$var$React.createElement("svg", $9941409eda18393d$var$_extends({
        id: "_x31_9",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "COL"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        className: "st0",
        d: "M227.1,208.5l-1.7-9l1.4-7.9l1.8,7.8L227.1,208.5z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        className: "st1",
        d: "M227.4,215c-8.5,0.2-15.7-6.6-15.8-15.2c-0.2-8.5,6.6-15.7,15.2-15.8c8.5-0.2,15.7,6.6,15.8,15.2 C242.7,207.7,235.9,214.8,227.4,215z M226.7,185.3c-7.8,0.2-14,6.7-13.9,14.5c0.2,7.8,6.7,14,14.5,13.9c7.8-0.2,14-6.7,13.9-14.5 C241,191.4,234.5,185.2,226.7,185.3z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.1,1.2,3,0.1,4.2c-1.1,1.2-3,1.2-4.2,0.1c-1.2-1.1-1.2-3-0.1-4.2S227.9,196.2,229.1,197.4z  M225.6,190.3l-0.1-3.1h0.5l1.5,2.1v-2.1h0.5l0.1,3.1h-0.5l-1.5-2.1v2.1H225.6z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.3c0.7,0.6,0.7,1.7,0.1,2.3c-0.6,0.7-1.7,0.7-2.3,0.1c-0.7-0.6-0.7-1.7-0.1-2.3 C226.5,197.7,227.5,197.7,228.2,198.3z"
    })), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 229.9873 100.9761)",
        className: "st3 st4 st5"
    }, "350"), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 189.3115 59.7378)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 101.5088 29.1909)",
        className: "st3 st4 st5"
    }, "415"), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 38.8613 55.2993)",
        className: "st3 st4 st5"
    }, "390"), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 4.4224 117.1904)",
        className: "st3 st4 st5"
    }, "347")), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M19.4,105l3.4-4l1.6-2l1.6-2l1.6-2l1.6-2l1.7-2l1.7-2l1.7-2l1.7-2l1.7-2l1.7-2.1l1.7-2.1 l1.8-2.1l1.8-2.1l1.8-2.1l1.8-2.2l1.8-2.2l1.9-2.2l1.9-2.3l1.9-2.3l2-2.3l2-2.4l2-2.4l2.1-2.4l2.1-2.5l2.1-2.5l2.2-2.6l2.2-2.6 l2.3-2.7l2.3-2.8l2.7-1.8l3.1-0.3l3.1-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3 l3-0.3l3-0.3l3.1-0.3l3.1-0.3l3.1-0.3l3.1-0.2l3,1l2.7,2.3l2.7,2.2l2.6,2.2l2.6,2.2l2.5,2.1l2.5,2.1l2.4,2l2.4,2l2.4,2l2.3,1.9 l2.3,1.9l2.3,1.9l2.2,1.9l2.2,1.8l2.2,1.8l2.2,1.8l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.7l2.1,1.7l2.1,1.7l2,1.7l2,1.7l2,1.7l2,1.7 l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l1,2.7l0.3,3.3l0.2,5.8l-21.5,21.6l0.4,3.7L189,160.3l-45.2,53.4 c0,0-7,9.9-18.9,9.9s-15.4-5.8-19-8.7l-46.1-52.7l-23.6-41.3L19.4,105z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125,215.6c-6.6,0-8.8-3.1-11.6-5.8c-0.2-0.2-3.1-0.7-5.9-2.6c-4.1-2.9-40.8-49.4-40.8-49.4 l-16.6-29.7l-19.7-23.7l3.5-4.2l48.7-58l58.4-5.1l3.1-0.3l1.4-0.1l74.4,62.2l0.2,1.8l0.1,2.1l-21.7,21.8l1.5,6.8l-17.3,28 c0,0-39.4,45.9-41.2,47.4c-1.8,1.5-6.4,2.6-6.4,2.6C134.9,209.7,132,215.6,125,215.6L125,215.6z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-96.5-96.5l-5.9-5.7"
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l96.5-96.6l6.3-6.4"
    })), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $9941409eda18393d$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $9941409eda18393d$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $9941409eda18393d$var$_default = module.exports["default"] = $9941409eda18393d$var$Venue19;

});

parcelRegister("iErUj", function(module, exports) {
"use strict";
function $d9419c370ae45e87$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d9419c370ae45e87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d9419c370ae45e87$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d9419c370ae45e87$var$React = $d9419c370ae45e87$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $d9419c370ae45e87$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d9419c370ae45e87$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d9419c370ae45e87$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $d9419c370ae45e87$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $d9419c370ae45e87$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d9419c370ae45e87$var$_extends() {
    return $d9419c370ae45e87$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d9419c370ae45e87$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $d9419c370ae45e87$var$Venue22(props) {
    return /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("svg", $d9419c370ae45e87$var$_extends({
        id: "_x32_2",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "LAD"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        className: "st0",
        d: "M231.5,207.3l-5.9-7l-2.7-7.6l5.5,5.9L231.5,207.3z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        className: "st1",
        d: "M235,212.8c-7.3,4.4-16.9,2-21.3-5.4c-4.4-7.3-2-16.9,5.4-21.3c7.3-4.4,16.9-2,21.3,5.4 C244.7,198.9,242.3,208.4,235,212.8z M219.7,187.3c-6.7,4-8.9,12.7-4.9,19.5c4,6.7,12.7,8.9,19.5,4.9c6.7-4,8.9-12.7,4.9-19.5 C235.2,185.5,226.5,183.3,219.7,187.3z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        className: "st0",
        d: "M227.7,196.6c1.6,0.4,2.6,2,2.2,3.6c-0.4,1.6-2,2.6-3.6,2.2c-1.6-0.4-2.6-2-2.2-3.6S226.2,196.2,227.7,196.6z  M221.2,192.2l-1.6-2.6l0.4-0.2l2.3,1.1l-1.1-1.8l0.4-0.3l1.6,2.6l-0.4,0.2l-2.3-1.1l1.1,1.8L221.2,192.2z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        className: "st2",
        d: "M227.4,197.9c0.9,0.2,1.4,1.1,1.2,2s-1.1,1.4-2,1.2s-1.4-1.1-1.2-2S226.5,197.7,227.4,197.9z"
    })), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 222.9199 115.5483)",
        className: "st3 st4 st5"
    }, "330"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "_x36_",
        transform: "matrix(1 0 0 1 214.4951 81.6094)",
        className: "st3 st4 st5"
    }, "360"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "_x35__1_",
        transform: "matrix(1 0 0 1 162.2285 49.5474)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 116.0342 34.7349)",
        className: "st3 st4 st5"
    }, "395"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "_x33_",
        transform: "matrix(1 0 0 1 66.1963 49.5474)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "_x32_",
        transform: "matrix(1 0 0 1 14.3223 81.6094)",
        className: "st3 st4 st5"
    }, "360"), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.3506 115.5483)",
        className: "st3 st4 st5"
    }, "330")), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M30.1,112l-1.3-5v-3.4l0.2-3.3l0.4-3.2l0.7-3l0.9-2.9l1.1-2.8l1.4-2.4l1.6-2.2l1.6-2.2 l2.1-1.6l2.2-1.5l2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.4l2.2-1.4l2.3-1.4l2.3-1.4L63,64l2.3-1.4l2.3-1.4l2.3-1.4l2.4-1.4 l2.4-1.3l2.4-1.3l2.4-1.3l2.5-1.3l2.5-1.2l2.5-1.2l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.7-1l2.7-1l2.7-0.9l2.8-0.9l2.8-0.9 l2.8-0.8l2.8-0.6l2.9-0.4l2.9-0.3l2.9,0.3l2.9,0.4l2.8,0.7l2.8,0.8l2.8,0.8l2.7,1l2.7,1l2.7,0.9l2.7,1.1l2.6,1.1l2.6,1.1l2.6,1 l2.6,1.1L163,51l2.5,1.2l2.5,1.2l2.5,1.2l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.3,1.4l2.3,1.4L187,64l2.3,1.4l2.3,1.4l2.2,1.4 l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.5l2.2,1.5l2.2,1.5l2.1,1.6l1.6,2.3l1.6,2.2l1.5,2.3l0.9,2.9l0.9,2.9l0.7,3 l0.4,3.2l0.3,3.2l-0.1,3.5l-1.5,9L196,140.3c0,0-42.9,66-46.9,70.5c-3.2,3.6-9.5,15.1-25.3,15.1c-17.9,0-26.2-18.1-26.2-18.1 l-41.7-70.4L30.1,112z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M123.8,218.2c-16.7,0-23.5-15.8-23.9-16.3l-36.8-68.1l-23.9-25.9l-0.5-1.9v-2.1l0.2-2.8 l0.4-2.6l0.5-2.4l0.7-2.3l0.7-1.9l0.9-1.5l1.4-1.9l1-1.3l3.1-3.6l2.2-1.5l4.3-2.9l2.1-1.4l2.2-1.4l2.2-1.4l2.2-1.4l2.3-1.4 l6.8-4.2l2.3-1.3l2.2-1.3l7.1-3.8l2.3-1.2l2.4-1.2l2.3-1.1l2.4-1.1l2.5-1.1l5.2-2.2l2.4-1l2.7-1l2.6-1l2.5-0.9l2.8-0.9l2.6-0.9 l2.3-0.7l2.2-0.5l2.5-0.3l2-0.2l1.9,0.2l2.2,0.3l2.4,0.6l2.6,0.7l2.5,0.7l5.3,1.8l2.6,0.9l7.8,3.2l2.5,1l2.3,1l4.9,2.3l2.4,1.1 l2.3,1.2l2.4,1.2l2.3,1.2l2.3,1.3l2.2,1.3l2.2,1.3l4.5,2.8l2.3,1.4l2.2,1.4l4.4,2.8l2.2,1.4l4.4,2.8l2.1,1.3l4.2,2.9l2,1.4 l0.9,0.7l2.4,3.4l0.8,1.3l1.4,4.5l0.5,2.4l0.4,2.7l0.2,2.6v1.9l-1.7,8.3L186.3,140c0,0-37.8,61.9-38.2,62.4 c-2.7,3-8.5,15.4-23.8,15.4L123.8,218.2L123.8,218.2z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-96.4-96.3"
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l96-96"
    })), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $d9419c370ae45e87$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $d9419c370ae45e87$var$_default = module.exports["default"] = $d9419c370ae45e87$var$Venue22;

});

parcelRegister("hJpBV", function(module, exports) {
"use strict";
function $ce8a816495846325$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ce8a816495846325$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ce8a816495846325$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ce8a816495846325$var$React = $ce8a816495846325$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $ce8a816495846325$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ce8a816495846325$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ce8a816495846325$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $ce8a816495846325$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $ce8a816495846325$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ce8a816495846325$var$_extends() {
    return $ce8a816495846325$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce8a816495846325$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $ce8a816495846325$var$Venue31(props) {
    return /*#__PURE__*/ $ce8a816495846325$var$React.createElement("svg", $ce8a816495846325$var$_extends({
        id: "_x33_1_1_",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "PIT"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        className: "st0",
        d: "M233.8,193.7l-5.8,7.1l-6.9,4l4.8-6.4L233.8,193.7z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        className: "st1",
        d: "M238.6,189.2c5.7,6.4,5.1,16.2-1.3,21.9c-6.4,5.7-16.2,5.1-21.9-1.3c-5.7-6.4-5.1-16.2,1.3-21.9 C223.2,182.2,233,182.8,238.6,189.2z M216.4,208.9c5.2,5.9,14.2,6.4,20,1.2c5.9-5.2,6.4-14.2,1.2-20c-5.2-5.9-14.2-6.4-20-1.2 S211.2,203.1,216.4,208.9z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        className: "st0",
        d: "M224.1,199.3c0.1-1.6,1.5-2.9,3.1-2.8c1.6,0.1,2.9,1.5,2.8,3.1c-0.1,1.6-1.5,2.9-3.1,2.8 C225.2,202.4,224,201,224.1,199.3z M220.9,206.6l-2.3,2l-0.3-0.4l0.7-2.5l-1.6,1.4l-0.3-0.4l2.3-2l0.3,0.4l-0.7,2.5l1.6-1.4 L220.9,206.6z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        className: "st2",
        d: "M225.4,199.4c0.1-0.9,0.8-1.6,1.7-1.5s1.6,0.8,1.5,1.7s-0.8,1.6-1.7,1.5C226,201.1,225.3,200.3,225.4,199.4z"
    })), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 223.0479 117.5005)",
        className: "st3 st4 st5"
    }, "320"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 188.5293 61.7378)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 127.5479 36.4312)",
        className: "st3 st4 st5"
    }, "399"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 59.9863 39.1558)",
        className: "st3 st4 st5"
    }, "410"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 38.043 57.9976)",
        className: "st3 st4 st5"
    }, "379"), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.3975 114.6216)",
        className: "st3 st4 st5"
    }, "325")), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M29.3,109.8l0.3-2l0.3-3.1l0.3-3.2l0.3-3.3l0.3-3.4l0.3-3.5l0.3-3.7l0.3-3.8l0.3-3.9l2-1.9 l2.1-1.7l2.1-1.7l2.1-1.8l2.1-1.8l2.1-1.8l2.1-1.8l2.1-1.8l2.2-1.8l2.2-1.8l2.2-1.8l2.2-1.8l2.2-1.9l2.2-1.9l2.3-1.9l2.3-1.9 l2.3-1.9l2.4-2l2.4-2l2.4-2l2.5-2.1l2.5-2.1l4.3,5l2.9-0.3l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5 l2.8-0.5l2.8-0.5l2.9-0.5l2.9-0.5l2.9-0.4l2.9,0.6l2.9,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6 l2.7,1.1l2.6,1.3l2.6,1.3l2.6,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.2l2.4,1.2l2.4,1.2l2.2,1.8l1.8,2.6l1.8,2.6 l1.7,2.5l1.7,2.5l1.7,2.4l1.6,2.4l1.6,2.3l1.6,2.3l1.6,2.3l1.5,2.2l1.5,2.2l1.5,2.2l1.5,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2l1.4,2 l1.4,2l1.4,2l1.4,2l1.4,1.9l2.5,3.3l-20.2,20.3l-9.4,28c0,0-41.7,49.3-51.4,59.8c-7.5,8.1-13.9,6.8-16.9,6.8 c-9.4,0-16.6-8.7-21.4-14.9L49,143.1l1-11.7C50,131.4,29.3,109.8,29.3,109.8z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.2,219.2h-1.4c-5.8,0-11.7-7.4-15.2-11.9l-51.4-66.7l1-12.2L37.7,107l2-23.2L80,50l2,2.3 l7.3-0.9l34.1-5.6l1.4-0.2l26.1,5.6l1.7,0.7L179,65.3l0.6,0.5l31.5,45.7l-16.7,16.8l-9.6,28.3c-6.4,7.5-41.5,49-50.1,58.3 C130.8,219.2,125.5,219.2,125.2,219.2L125.2,219.2z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-95.5-95.5"
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l94-94.1"
    })), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $ce8a816495846325$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce8a816495846325$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $ce8a816495846325$var$_default = module.exports["default"] = $ce8a816495846325$var$Venue31;

});

parcelRegister("4r9oI", function(module, exports) {
"use strict";
function $33b0f939ca16f9c1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $33b0f939ca16f9c1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $33b0f939ca16f9c1$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $33b0f939ca16f9c1$var$React = $33b0f939ca16f9c1$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $33b0f939ca16f9c1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($33b0f939ca16f9c1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $33b0f939ca16f9c1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $33b0f939ca16f9c1$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $33b0f939ca16f9c1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $33b0f939ca16f9c1$var$_extends() {
    return $33b0f939ca16f9c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $33b0f939ca16f9c1$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $33b0f939ca16f9c1$var$Venue32(props) {
    return /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("svg", $33b0f939ca16f9c1$var$_extends({
        id: "_x33_2",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "MIL"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        className: "st0",
        d: "M232.5,192.5l-4.2,8.1l-6,5.3l3.4-7.3L232.5,192.5z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        className: "st1",
        d: "M236.3,187.1c6.8,5.1,8.2,14.9,3.1,21.7c-5.1,6.8-14.9,8.2-21.7,3.1c-6.8-5.1-8.2-14.9-3.1-21.7 C219.7,183.4,229.5,182,236.3,187.1z M218.5,210.9c6.3,4.7,15.2,3.4,19.9-2.9c4.7-6.3,3.4-15.2-2.9-19.9 c-6.3-4.7-15.2-3.4-19.9,2.9C211,197.3,212.3,206.2,218.5,210.9z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        className: "st0",
        d: "M224.1,199.9c-0.2-1.6,0.9-3.1,2.5-3.4c1.6-0.2,3.1,0.9,3.4,2.5c0.2,1.6-0.9,3.1-2.5,3.4 C225.8,202.7,224.3,201.6,224.1,199.9z M222.4,207.7l-1.8,2.5l-0.4-0.3l0.1-2.5l-1.3,1.7l-0.4-0.3l1.8-2.5l0.4,0.3l-0.1,2.6 l1.3-1.7L222.4,207.7z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        className: "st2",
        d: "M225.4,199.8c-0.1-0.9,0.5-1.7,1.4-1.9s1.7,0.5,1.9,1.4c0.1,0.9-0.5,1.7-1.4,1.9 C226.4,201.3,225.5,200.7,225.4,199.8z"
    })), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 230.9219 107.7896)",
        className: "st3 st4 st5"
    }, "345"), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 115.8994 34.5454)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 2.9648 112.5405)",
        className: "st3 st4 st5"
    }, "342")), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M229.1,104.1l-41.3,42.3l0.6,2.5l-13.7,28.6c0,0-27,33.8-32.7,40.2 c-4.2,5.2-10.9,8.4-18.4,8.4c-12.1,0-19.1-8.4-27.7-20.1l-24.3-31.5L51,142.2l-2.5-9.5l-25.1-24.9l1.2-5.1l0.8-2.7l0.8-2.8 l0.8-2.8l0.9-2.9l1.3-2.5l1.8-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2.1-1.7l2.5-1.1l2.5-1.1 l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.4-1.3l2.4-1.3l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.6-1.2 l2.4-2.1l2.3-3.1l2.3-3.2l2.6-2.3l2.9-0.4l2.9-0.3l2.9-0.2l2.9-0.3l2.9-0.2l2.9-0.1l2.9-0.1h5.8l2.9,0.1l2.9,0.1l2.9,0.2l2.9,0.2 l2.9,0.3l2.9,0.3l2.9,0.4l2.6,2.3l2.3,3.3l2.5,1.8l2.6,1.2l2.6,1.2l2.6,1.2l2.6,1.2l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1L179,56 l2.5,1.1l2.5,1.1l2.2,1.9l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.8l0.5,4.5l1.4,2.8l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7 l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.6l1.9,1.6L219,95l1.9,1.6l1.9,1.6l1.9,1.6l1.8,1.7L229.1,104.1L229.1,104.1z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.5,219.1c-7.7,0-14.6-6-23.2-17.9l-24.2-31.4l-19.8-30.9l-2.7-10.4l-23.5-23.2l0.1-0.5 l3.1-10.3l0.4-0.7L53.4,76l1-0.8l19-8.4l2.6-1.4l2.2-1.1L96.6,56l4-3.4l4.7-6.5l0.1-0.1h0.3l2.7-0.3l2.9-0.2l2.7-0.3l2.7-0.2 l2.8-0.1l2.8-0.1h5.5l2.7,0.1l2.8,0.1l2.8,0.2l2.7,0.2l2.8,0.3l2.6,0.3l0.3,0.1l0.2,0.1l2.6,3.6l4.2,3l27.6,12.4l9.4,8.1l0.3,2.8 l2.7,5.5l26,22.8L179,143.9l0.9,3.9l-11.5,26.6c-3.7,4.6-31.6,38.1-31.6,38.1S131.9,219.1,125.5,219.1z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-96.8-96.8l-3.8-3.9"
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l96.7-96.8l4.6-4.7"
    })), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $33b0f939ca16f9c1$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $33b0f939ca16f9c1$var$_default = module.exports["default"] = $33b0f939ca16f9c1$var$Venue32;

});

parcelRegister("1RT1Z", function(module, exports) {
"use strict";
function $15c56db4caaa8714$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $15c56db4caaa8714$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $15c56db4caaa8714$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $15c56db4caaa8714$var$React = $15c56db4caaa8714$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $15c56db4caaa8714$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($15c56db4caaa8714$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $15c56db4caaa8714$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $15c56db4caaa8714$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $15c56db4caaa8714$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $15c56db4caaa8714$var$_extends() {
    return $15c56db4caaa8714$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15c56db4caaa8714$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $15c56db4caaa8714$var$Venue680(props) {
    return /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("svg", $15c56db4caaa8714$var$_extends({
        id: "_x36_80",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "SEA"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        className: "st0",
        d: "M232.6,206.5l-6.9-6l-3.8-7.1l6.3,5L232.6,206.5z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        className: "st1",
        d: "M237,211.4c-6.5,5.5-16.3,4.6-21.8-1.9s-4.6-16.3,1.9-21.8s16.3-4.6,21.8,1.9S243.5,205.9,237,211.4z  M217.9,188.7c-6,5-6.8,14-1.7,20c5,6,14,6.8,20,1.7c6-5,6.8-14,1.7-20C232.9,184.4,223.9,183.6,217.9,188.7z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        className: "st0",
        d: "M227.3,196.6c1.6,0.1,2.8,1.6,2.7,3.2c-0.1,1.6-1.6,2.8-3.2,2.7c-1.6-0.1-2.8-1.6-2.7-3.2 C224.2,197.6,225.6,196.4,227.3,196.6z M220.1,193.2l-2-2.4l0.4-0.3l2.4,0.7l-1.4-1.6l0.4-0.3l2,2.4l-0.4,0.3l-2.5-0.7l1.4,1.6 L220.1,193.2L220.1,193.2z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        className: "st2",
        d: "M227.2,197.9c0.9,0.1,1.6,0.9,1.5,1.8c-0.1,0.9-0.9,1.6-1.8,1.5c-0.9-0.1-1.6-0.9-1.5-1.8 C225.5,198.5,226.3,197.8,227.2,197.9z"
    })), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 223.0488 115.4155)",
        className: "st3 st4 st5"
    }, "325"), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 156.7998 45.4438)",
        className: "st3 st4 st5"
    }, "380"), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 127.6758 36.27)",
        className: "st3 st4 st5"
    }, "401"), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 57.5859 52.7603)",
        className: "st3 st4 st5"
    }, "376"), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.8232 114.4155)",
        className: "st3 st4 st5"
    }, "331")), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M65.6,172l-18.4-36.9l0.3-3.9l-19.9-20.9l-0.7-2.9l0.6-1.6l-0.1-3.5l1.7-1.8l1.7-1.8 l1.7-1.8l1.7-1.8l1.7-1.8l1.7-1.8l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.8-1.9l1.8-1.9l1.8-1.9l1.8-2l1.8-2l1.8-2l1.9-2l1.9-2.1 l1.9-2.1l2-2.1l2-2.2l2-2.2l2.3-1.7l2.3-1.5l2.4-1.5l2.4-1.5l2.4-1.6l2.4-1.6l2.5-1.6l2.6-1.3l2.6-1l2.7-1l2.7-1l2.7-1.1l2.7-1.1 l2.7-1.1l2.8-1.1l2.8-1.1l2.8-1.1l2.8-1.1l2.9-1.1l2.9-0.9l3,0.9l2.9,0.9l2.9,0.9l2.9,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9 l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.8l2.7,0.8l2.7,0.8l2.7,0.8l2.7,0.8l2.6,0.8l2.6,0.8l2.6,0.8l2.3,1.9l2,2.5l2,2.4 l1.9,2.4l1.9,2.3l1.9,2.3l1.8,2.3l1.8,2.2l1.8,2.2l1.7,2.2l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9 l1.6,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l0.9,0.9L200,129.2v3.2l-19.8,39.4l-12,14.6c0,0-21.8,28-26.1,32.5 c-4.7,5-18.6,15.3-34.9-0.7L65.6,172z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M126.2,219.4c-3.7,0-9.9-2.5-13.1-5.6l-31.8-35.5L71.5,168l-19.1-35.9l0.4-5.5l-17.9-16.9V109 l0.7-1.9v-1.8l36.7-40l1.4-1.1l13.8-8.9l1.9-0.9L119,42.8l0.2-0.1L173,59.8l0.5,0.4l37.9,47L192,125.8v4.9l-17.6,39l-6,6.8 l-29.6,36.8C137.3,214.6,132.3,219.4,126.2,219.4L126.2,219.4z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-97.6-97.5"
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l96.2-96.3"
    })), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $15c56db4caaa8714$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $15c56db4caaa8714$var$_default = module.exports["default"] = $15c56db4caaa8714$var$Venue680;

});

parcelRegister("jQs4E", function(module, exports) {
"use strict";
function $e728a6907a0964ce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e728a6907a0964ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e728a6907a0964ce$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e728a6907a0964ce$var$React = $e728a6907a0964ce$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $e728a6907a0964ce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e728a6907a0964ce$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e728a6907a0964ce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e728a6907a0964ce$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e728a6907a0964ce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e728a6907a0964ce$var$_extends() {
    return $e728a6907a0964ce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e728a6907a0964ce$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $e728a6907a0964ce$var$Venue2392(props) {
    return /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("svg", $e728a6907a0964ce$var$_extends({
        id: "_x32_392",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0022;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "HOU"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st0",
        d: "M229.6,208.1l-4.2-8.2l-0.8-7.9l3.9,6.9L229.6,208.1z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st1",
        d: "M231.7,214.3c-8.1,2.6-16.9-1.9-19.5-10s1.9-16.9,10-19.5s16.9,1.9,19.5,10 C244.4,202.9,239.9,211.7,231.7,214.3z M222.7,186c-7.5,2.4-11.6,10.4-9.2,17.8c2.4,7.5,10.4,11.6,17.8,9.2 c7.5-2.4,11.6-10.4,9.2-17.8C238.1,187.7,230.1,183.6,222.7,186z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st0",
        d: "M228.4,196.9c1.5,0.8,2,2.5,1.3,4c-0.8,1.5-2.5,2-4,1.3c-1.5-0.8-2-2.5-1.3-4S226.9,196.1,228.4,196.9z  M223,191.1l-0.9-2.9l0.4-0.1l2,1.6l-0.6-2l0.5-0.2l0.9,2.9l-0.4,0.1l-2-1.6l0.6,2L223,191.1z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st2",
        d: "M227.8,198.1c0.8,0.4,1.1,1.4,0.7,2.2c-0.4,0.8-1.4,1.1-2.2,0.7c-0.8-0.4-1.1-1.4-0.7-2.2 C226,198,227,197.6,227.8,198.1z"
    })), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 224.7256 111.0234)",
        className: "st3 st4 st5"
    }, "326"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 173.7773 54.1211)",
        className: "st3 st4 st5"
    }, "373"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 157.1455 32.1655)",
        className: "st3 st4 st5"
    }, "409"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "center-left",
        transform: "matrix(1 0 0 1 85 34.7173)",
        className: "st3 st4 st5"
    }, "404"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 53.7124 58.1631)",
        className: "st3 st4 st5"
    }, "362"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.9321 116.0493)",
        className: "st3 st4 st5"
    }, "315")), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M125.7,222.2c-11.4,0-19.8-9.7-19.8-9.7l-45.4-55.1l1-12.9l-31.3-31.3l2.3-2.7L34,109 l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6L42,101l1.6-1.6l1.7-1.6l1.7-1.6l1.7-1.6l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.7l1.9-1.5 l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.6L67,66.5l1.9-2.2l2-2.2l2-2.2l21.4-15.2l2.5-2l2.6-2.1l2.6-2.1l2.7-2.1l2.7-2.2l2.9-1.4 h45.1l2.6,2.5l2.4,3.1l2.6,1.8l2.3,2.8l2.2,2.8l2.2,2.7l2.1,2.6l2.1,2.6l2,2.5l2,2.5l2.5,0.9l2.7,0.4l1.9,2.4l1.9,2.3l1.8,2.3 l1.8,2.3l1.8,2.2l1.8,2.2l1.7,2.2l1.7,2.1l1.7,2.1l1.7,2.1l1.6,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9l1.6,1.9l1.5,1.9l1.5,1.9 l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.6l-23.5,23.2c0,0,1.8,12.2-6.7,20.6c-5.3,5.2-47.7,59.9-47.7,59.9 S137.1,222.2,125.7,222.2L125.7,222.2z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.7,214.2c-7.2,0-13.3-6.3-13.7-6.9l-45.6-54.4l1-10.4l-22.1-22.6v-10.7l16-15.7l1.5-1.4 L78.9,79l-1.8-12.1L112,40.7l39.8,0.1l21,24.6l5.3,2l0.5,0.1l30.4,37.8l-0.7,6.3l-13.5,12.9c0,0,2.1,9-5.1,19 c-4.4,6.2-44.4,54.9-51.5,64.1C138.2,207.7,132.9,214.2,125.7,214.2L125.7,214.2z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7 s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.2,0,0.3,0,0.4l-11.1,2.5l4.4,6.2l7.7-5.7 c1.2,1.9,3.3,3.2,5.7,3.2s4.5-1.3,5.7-3.2l7.7,5.7l4.4-6.2l-11.1-2.5C131.9,202.7,131.9,202.6,131.9,202.4z M120.9,197.3 l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6 l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6C123.6,195.7,122,196.3,120.9,197.3z"
    })), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-92.7-92.7"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l95.7-95.8"
    })), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3756 122.8773)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1257 157.48)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4716 132.5411)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    }))), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "grid",
        className: "st11"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)",
        className: "st4 st13"
    }, "90"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)",
        className: "st4 st13"
    }, "200"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)",
        className: "st4 st13"
    }, "150"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)",
        className: "st4 st13"
    }, "120"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)",
        className: "st4 st13"
    }, "250"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)",
        className: "st4 st13"
    }, "300"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)",
        className: "st4 st13"
    }, "350"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)",
        className: "st4 st13"
    }, "400"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)",
        className: "st4 st13"
    }, "450"), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)",
        className: "st4 st13"
    }, "500")), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("g", {
        id: "surface29_2_"
    }, /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st14",
        d: "M125.5,203.8l-148-148"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st14",
        d: "M124.8,203.8l148-148"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5l79.8-192.6"
    })), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st14",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x32_00-line_2_",
        className: "st14",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x39_0-line_2_",
        className: "st14",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st14",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st14",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st14",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st14",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st14",
        d: "M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x34_00-line_1_",
        className: "st14",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $e728a6907a0964ce$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st14",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
    })))));
}
var $e728a6907a0964ce$var$_default = module.exports["default"] = $e728a6907a0964ce$var$Venue2392;

});

parcelRegister("1JDEm", function(module, exports) {
"use strict";
function $1438c0112a9009df$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1438c0112a9009df$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1438c0112a9009df$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1438c0112a9009df$var$React = $1438c0112a9009df$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $1438c0112a9009df$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1438c0112a9009df$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1438c0112a9009df$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $1438c0112a9009df$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $1438c0112a9009df$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1438c0112a9009df$var$_extends() {
    return $1438c0112a9009df$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1438c0112a9009df$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $1438c0112a9009df$var$Venue2394(props) {
    return /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("svg", $1438c0112a9009df$var$_extends({
        id: "_x32_394",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("defs", null, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st4 {\n        font-size: 5px;\n      }\n\n      .st4, .st5 {\n        font-family: ArialMT, Arial;\n        isolation: isolate;\n      }\n\n      .st6 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke-miterlimit: 3.9;\n      }\n\n      .st1, .st2 {\n        stroke: #b3b3b3;\n      }\n\n      .st7, .st3 {\n        stroke-width: .8px;\n      }\n\n      .st7, .st3, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st2 {\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .8px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "DET"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st6",
        d: "M233.3,193.2l-5.2,7.5-6.6,4.6,4.3-6.8,7.5-5.3Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st13",
        d: "M237.8,188.3c6.2,5.9,6.4,15.8.4,21.9-5.9,6.2-15.8,6.4-21.9.4-6.2-5.9-6.4-15.8-.4-21.9,5.9-6.1,15.7-6.3,21.9-.4ZM217.2,209.8c5.6,5.4,14.6,5.2,20.1-.4,5.4-5.6,5.2-14.6-.4-20.1-5.6-5.4-14.6-5.2-20.1.4-5.4,5.6-5.2,14.6.4,20.1Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st6",
        d: "M224,199.6c0-1.6,1.3-3,2.9-3s3,1.3,3,2.9-1.3,3-2.9,3-2.9-1.3-3-2.9ZM221.5,207l-2.1,2.2-.3-.3.5-2.5-1.5,1.5-.4-.4,2.1-2.2.3.3-.5,2.5,1.5-1.5.4.4Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st11",
        d: "M225.4,199.6c0-.9.7-1.7,1.6-1.7s1.7.7,1.7,1.6-.7,1.7-1.6,1.7c-1,0-1.7-.7-1.7-1.6Z"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        id: "right",
        className: "st5",
        transform: "translate(223.5 115.3)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "328")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        id: "right-center",
        className: "st5",
        transform: "translate(186.2 62.5)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "365")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        id: "center",
        className: "st5",
        transform: "translate(114.7 27.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "412")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        id: "left",
        className: "st5",
        transform: "translate(5.6 114.6)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "341"))), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "Outfield",
        className: "st12",
        d: "M24.8,102.6l.6-3,2.7-.8,1.8-1.8,1.8-1.7,1.8-1.8,1.8-1.8,1.8-1.9,1.8-1.8,1.8-1.8,1.8-1.9,1.9-1.8,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,2-2,2-2,2-2,2-2,2-2,2.1-2.1,2.1-2.1,2.2-2.1,2.2-2.2,2.2-2.2,2.3-2.3,2.3-2.3,2.3-2.3,2.4-2.4,2.4-2.4,2.5-2.5,2.5-2.5,2.6-2.2,2.8-1.3,2.8-1.3,2.8-1.3h51.6l2.8,1.2,2.8,1.2,2.8,1.2,2.8,1.2,2.5,2.5,2.5,2.5,2.4,2.4,2.4,2.4,2.3,2.3,2.3,2.3,2.3,2.3,1.4,4.2,1,4.8,1.9,2.5,2,2,2,2,2,2,2,2,2,2,1.9,1.9,1.9,1.9,1.9,1.9,1.9,1.8,1.9,1.9,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,2,1.6,1.7,1.8,1.8,1.8,1.8,1.7,1.7,1.9.9,2.5v3.3c0,0,0,4.6,0,4.6l-20.8,21v13.8l-25.5,37.8s-15.3,18.6-30,33.6h0c-14.7,15.1-30.2,8.9-36.7,2.7s-32-32.5-32-32.5l-35.3-58.4.3-3.6-17.4-17.6-.4-4.5Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M111.3,211.3c-5.8-5.5-26.9-27.9-30.9-32l-23.8-39.9-7.9-12.6-.3-6-15.5-15.5,61.4-61.8s2.1-1.7,4.2-2.9,4.4-2,4.4-2l47.7.6,7.4,3.2,14.1,13.6.9,1.1,1.6,8.3,20.8,20.5,16.4,16.6,2,2.1-.4,2.2.4,2.1-18.7,18.9.6,13.9-14.2,21.1-13.3,18.8c0,0-14.6,14.9-29,29.7-2.1,2.1-8.5,8.5-14.4,8.3-6.8-.4-12.8-7.5-13.4-8.1Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7v3.2l6.1,6.2,6-6v-3.4l32.6-32.7ZM120.8,197.2l-17.6-17.6,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c.8.5,1.8.8,2.7.8s2-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.6,17.6h-8.8Z"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st3",
        d: "M125.2,203.2L24.5,102.6"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st3",
        d: "M125.2,203.2l96.5-96.6"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        id: "third-base",
        className: "st9",
        x: 99.2,
        y: 175.1,
        width: 3,
        height: 3,
        transform: "translate(-95.4 122.9) rotate(-45)"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        id: "first-base",
        className: "st9",
        x: 148.1,
        y: 175.2,
        width: 3,
        height: 3,
        transform: "translate(-81.1 157.5) rotate(-45)"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        id: "second-base",
        className: "st8",
        x: 123.7,
        y: 148.6,
        width: 3,
        height: 3,
        transform: "translate(-69.5 132.5) rotate(-45)"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("polygon", {
        id: "home",
        className: "st7",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", null, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(91 184.1) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(56.5 153.8) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(71 168.4) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(80.4 177.7) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(41.6 139) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(27.5 124) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(12.7 109.2) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(15 75.9) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(15 49.4) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450")), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("text", {
        className: "st4",
        transform: "translate(15 24.6) rotate(-44.2)"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500"))), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    })), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("g", null, /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 16,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 18,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 20.1,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 22.2,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 24.3,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 26.3,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 28.4,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 30.5,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 32.6,
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $1438c0112a9009df$var$React.createElement("rect", {
        className: "st2",
        x: 125.2,
        y: 34.6,
        width: 4.9,
        height: 2.1
    }))));
}
var $1438c0112a9009df$var$_default = module.exports["default"] = $1438c0112a9009df$var$Venue2394;

});

parcelRegister("bpbGd", function(module, exports) {
"use strict";
function $84db16e770a4810b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $84db16e770a4810b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $84db16e770a4810b$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $84db16e770a4810b$var$React = $84db16e770a4810b$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $84db16e770a4810b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($84db16e770a4810b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $84db16e770a4810b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $84db16e770a4810b$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $84db16e770a4810b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $84db16e770a4810b$var$_extends() {
    return $84db16e770a4810b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $84db16e770a4810b$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $84db16e770a4810b$var$Venue2395(props) {
    return /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("svg", $84db16e770a4810b$var$_extends({
        id: "_x32_395",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "SFG"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        className: "st0",
        d: "M235.9,200.3l-9.1,0.8l-7.7-2.1l7.9-1.1L235.9,200.3z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        className: "st1",
        d: "M242.5,200.6c-0.6,8.5-8.1,15-16.6,14.4s-15-8.1-14.4-16.6s8.1-15,16.6-14.4 C236.7,184.7,243.1,192.1,242.5,200.6z M212.9,198.5c-0.6,7.8,5.3,14.6,13.1,15.2c7.8,0.6,14.6-5.3,15.2-13.1 c0.6-7.8-5.3-14.6-13.1-15.2C220.2,184.8,213.4,190.7,212.9,198.5z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        className: "st0",
        d: "M225.1,197.3c1.2-1.1,3.1-0.9,4.2,0.3s0.9,3.1-0.3,4.2s-3.1,0.9-4.2-0.3C223.7,200.2,223.8,198.3,225.1,197.3 z M217.7,200.1l-3.1-0.2v-0.5l2.2-1.3l-2.1-0.2v-0.5l3.1,0.2v0.5l-2.2,1.3l2.1,0.2V200.1z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        className: "st2",
        d: "M225.9,198.3c0.7-0.6,1.7-0.5,2.3,0.2s0.5,1.7-0.2,2.3s-1.7,0.5-2.3-0.2C225.2,199.9,225.2,198.9,225.9,198.3 z"
    })), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 219.5801 120.0679)",
        className: "st3 st4 st5"
    }, "309"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "right-right-center_1_",
        transform: "matrix(1 0 0 1 192.8008 65.4839)",
        className: "st3 st4 st5"
    }, "365"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 163.1299 36.9458)",
        className: "st3 st4 st5"
    }, "415"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 116.8262 36.9458)",
        className: "st3 st4 st5"
    }, "391"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 55.8916 53.4839)",
        className: "st3 st4 st5"
    }, "382"), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 7.2314 97.0532)",
        className: "st3 st4 st5"
    }, "339")), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "Outfield_00000141422436691043141870000004421356628436405419_",
        className: "st6",
        d: "M23.4,106.8L42,126l22.5,35.2l43.7,50.9 c13.5,15.4,27.3,4.9,27.3,4.9l43.9-50.7l12.1-14.8c1-1.6,6.3-18.6,6.3-18.6l10.3-10l4.8-1.2l-1.2-2.3l5.2-2.9l0,0l-2.2-3l-0.9-2.3 l-0.9-2.3l-0.9-2.4l-0.9-2.4l-0.9-2.5l-1-2.5l-1-2.5l-1-2.6l-1-2.7l-1-2.7l-1-2.8l-1.1-2.9l-1.1-3l-1.1-3l-1.2-3.1l-1.2-3.2 l-2.3-1.3l-2.4-1.1l-1.6-2.8L191,62l-1.3-3.6l-1.4-3.7l-1.5-3.9l-1.5-4l-1.6-4.2l-2.4-2.2h-3.2H175h-3.1h-3.1h-3h-3h-3h-3h-3H151 h-2.9h-2.9h-2.9l-2.9-0.1h-2.8h-2.9h-2.8H128h-2.8h-2.8h-2.9h-2.8h-2.9H111h-2.9h-2.9h-2.9h-2.9h-2.9h-3l-2.6,1.8L88.5,44l-2.4,2 l-2.4,2l-2.3,2L79,52l-2.2,1.9l-2.2,1.9l-2.2,1.9l-2.2,1.8L68,61.3l-2.1,1.8l-2.1,1.8l-2.1,1.7l-2.1,1.7l-2,1.7l-2,1.7l-2,1.7 l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.6l-2,1.6l-1.9,1.7l-2,1.6l-1.9,1.6l-2,1.7l-1.6,2L27,97.9l-1,2.6l-1,2.6 L23.4,106.8z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M126,215c-2.1,0-9.1-0.9-13.5-6.7s-48.3-56.7-48.3-56.7l-16.3-26.3l-16.5-16.2l1.1-3.1l2.7-6.8 l0.4-0.5l60.9-51.6l79.2,0.1l9.1,22l3.2,5.6l5.9,2.7l13.8,34.9l-0.3,0.1l-13.6,13.2l0.5,6.2l-6.1,5.8l1.6,8.5L135,209.6 C134.1,210.6,129.2,215,126,215L126,215z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2L25.1,103.1"
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l90.9-91"
    })), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $84db16e770a4810b$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $84db16e770a4810b$var$_default = module.exports["default"] = $84db16e770a4810b$var$Venue2395;

});

parcelRegister("7BDj5", function(module, exports) {
"use strict";
function $589a7aa46b54bdb1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $589a7aa46b54bdb1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $589a7aa46b54bdb1$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $589a7aa46b54bdb1$var$React = $589a7aa46b54bdb1$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $589a7aa46b54bdb1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($589a7aa46b54bdb1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $589a7aa46b54bdb1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $589a7aa46b54bdb1$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $589a7aa46b54bdb1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $589a7aa46b54bdb1$var$_extends() {
    return $589a7aa46b54bdb1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $589a7aa46b54bdb1$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $589a7aa46b54bdb1$var$Venue2523(props) {
    return /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("svg", $589a7aa46b54bdb1$var$_extends({
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("defs", null, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st5, .st6, .st7 {\n        fill: #fff;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st6, .st7 {\n        stroke: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st8, .st9, .st10 {\n        isolation: isolate;\n      }\n\n      .st11, .st9 {\n        fill: #68836a;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st9 {\n        font-size: 11px;\n      }\n\n      .st9, .st10 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st10 {\n        font-size: 5px;\n      }\n\n      .st6 {\n        stroke-width: .8px;\n      }\n\n      .st6, .st7 {\n        stroke-miterlimit: 4;\n      }\n\n      .st7 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "Layer_11"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "_x32_523_-_George_M._Steinbrenner_Field"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "Compass_copy_4"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "Compass"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("polygon", {
        className: "st3",
        points: "230.6 203.7 222.1 200.4 216.2 195 223.8 197.6 230.6 203.7"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st13",
        d: "M236.4,206.9c-4.4,7.4-13.9,9.8-21.2,5.4s-9.8-13.9-5.4-21.2c4.4-7.4,13.9-9.8,21.2-5.4,7.3,4.3,9.7,13.9,5.4,21.2ZM210.8,191.8c-4,6.7-1.8,15.4,5,19.4,6.7,4,15.4,1.8,19.4-5,4-6.7,1.8-15.4-5-19.4-6.7-4-15.4-1.7-19.4,5Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st3",
        d: "M241.6,210c-6.1,10.2-19.3,13.6-29.6,7.6-10.2-6.1-13.6-19.3-7.6-29.6,6.1-10.2,19.3-13.6,29.6-7.6,10.3,6.1,13.7,19.4,7.6,29.6ZM206.2,189c-5.5,9.3-2.4,21.3,6.9,26.9,9.3,5.5,21.3,2.4,26.9-6.9,5.5-9.3,2.4-21.3-6.9-26.9-9.4-5.5-21.4-2.4-26.9,6.9Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("circle", {
        className: "st3",
        cx: 223,
        cy: 199,
        r: 3
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st3",
        d: "M214.4,195.3l-2.6-1.6.2-.4h2.5c0-.1-1.8-1.2-1.8-1.2l.3-.4,2.6,1.6-.2.4h-2.6c0,.1,1.8,1.2,1.8,1.2l-.2.4Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("circle", {
        className: "st5",
        cx: 223,
        cy: 199,
        r: 1.6
    }))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "outfield",
        className: "st12",
        d: "M216.5,108.5l-1.1-1.7-1.2-2-1.1-1.9-1.2-1.9-1.5-2.2-1.6-1.7-1.6-1.9-1.7-1.6-1.7-2-1.8-1.9-1.5-1.5-1.8-1.9-1.9-2.1-1.4-1.4-2.1-2.2-1.8-2.1-1.8-1.8-1.8-1.9-1.9-1.9-1.9-1.9-1.9-1.9-1.9-2-2-2-2-2-2-2.1-2.1-2.1-2.1-2.1-2.2-2.2-2.2-2.2-2.2-2.3-2.3-1.7-2.5-1.7-2.5-1.9-2.7-2.1-2.5-1.8-2.4-1.4-3-1.1-2.7-1-2.5-.7-2.7-.8-2.7-.7-3.1-.5-3-.4-3.5-.7h-2.9c0-.1-2.7,0-2.7,0h-6.1s-3,.4-3,.4l-2.7.3-3,.5-3.6.5-1.9.7-2.8,1-2.9.9-3.6,1.3-2.7,1.5-2.5,1.6-2.1,1.2-2.9,1.7-2.5,1.5-2.4,1.6-2.3,2.1-2.2,2.2-2.2,2.2-2.1,2.1-2.1,2.1-2.1,2.1-2,2-2,2-2,2-2,2-2,2-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.7,2-1.3,2.5-1.5,2.6-1.2,2.9-.9,2.9-.8,2.5-.5,2.3-.5,3.7-.4,3.2-.6,3.4,2.2,2.5,1.9,3.4.9-.7,23.8,24.1,11.8,20,1.5-.6,1.1,2.1,8.4,14-.5.5,19.5,32.7,1.8-1s2.1,2.9,3.1,4.4,2.8,3.7,4.7,4.9c2.5,1.4,6.5,4.1,10.3,4.8s5.8.5,8.6-.3,5.9-2.7,7.8-3.9,1.9-1,2.9-1.8c1.5-1.2,2.8-3,3.4-4.3,1.7-2.5,2.7-4.2,2.7-4.2l2.8,1.9,18.7-32.9-1.4-1,9.9-16.3,1.2.7,5.6-9.7,6.9-11.5,9-9.3,17.7-17.5-.6-2-.5-.9Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "grass",
        className: "st11",
        d: "M49.2,120.8s-3.1-3.6-5.8-6.2-2.9-3.6-3-7.7,2.9-9.4,4.1-12.6,2.8-6.8,4.3-8.8,2.3-2.9,4.8-5.7,10.1-10,13.1-13,10.1-9.8,12.2-11.7,6.4-4.5,8.5-5.9,8.8-4.2,11.8-5.8,9.2-2.2,13.1-2.5,11.7.5,13.6.6c1.9,0,16.6,3.2,19,4.3s8.6,5.4,14.1,9.3c1.2.8,44.6,46.4,46.1,48.1s3,3.7,2.9,6.1-.4,3-1.8,4.7-10.8,10.6-13.8,13.7c-3,3.1-5.1,6.2-5.8,7.1s-5.9,7.7-10.9,15.9c-7.8,12.7-16.7,27.5-17.6,29.1-3,5.3-6.9,12.2-8.2,14s-9.9,13.5-11.2,15.1-3,3.6-4.8,5.1-5.5,3-8.6,2.9c-4.8-.1-7.7-2.7-9.1-4.1s-5.6-7-7.2-9-4.7-6.3-7-9.3-8-12.1-10.9-16.4-4.3-8.2-7.8-13.9-3.2-5.1-4.6-7.4c-2.1-3.4-3.9-6.2-5.3-7.7-3.1-3.4-7.6-10.7-8.8-12.6s-13.3-13.6-13.3-13.6l-1.9-2Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st9",
        transform: "translate(211.4 95.6)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "314")))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15.3 88.6)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "318")))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st9",
        transform: "translate(115.4 28.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "408"))))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st4",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st2",
        d: "M125.2,203.2L18.5,96.5"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st2",
        d: "M125.2,203.2l106.7-106.8"
    })), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("rect", {
        id: "third-base",
        className: "st7",
        x: 99.2,
        y: 175.1,
        width: 3,
        height: 3,
        transform: "translate(-95.4 122.9) rotate(-45)"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("rect", {
        id: "first-base",
        className: "st7",
        x: 148.1,
        y: 175.2,
        width: 3,
        height: 3,
        transform: "translate(-81.1 157.5) rotate(-45)"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("rect", {
        id: "second-base",
        className: "st6",
        x: 123.7,
        y: 148.6,
        width: 3,
        height: 3,
        transform: "translate(-69.5 132.5) rotate(-45)"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("polygon", {
        id: "home",
        className: "st4",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    }))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", null, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(91 184.1) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(56.5 153.8) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(71 168.4) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(80.4 177.7) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(41.6 139) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(27.5 124) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(12.7 109.2) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 75.9) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 49.4) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450"))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 24.6) rotate(-44.2)"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500")))), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $589a7aa46b54bdb1$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    })))));
}
var $589a7aa46b54bdb1$var$_default = module.exports["default"] = $589a7aa46b54bdb1$var$Venue2523;

});

parcelRegister("1HiC0", function(module, exports) {
"use strict";
function $13c83e87d6272e5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $13c83e87d6272e5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $13c83e87d6272e5a$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $13c83e87d6272e5a$var$React = $13c83e87d6272e5a$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $13c83e87d6272e5a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($13c83e87d6272e5a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $13c83e87d6272e5a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $13c83e87d6272e5a$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $13c83e87d6272e5a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $13c83e87d6272e5a$var$_extends() {
    return $13c83e87d6272e5a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $13c83e87d6272e5a$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $13c83e87d6272e5a$var$Venue2529(props) {
    return /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("svg", $13c83e87d6272e5a$var$_extends({
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("defs", null, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st5, .st6, .st7 {\n        fill: #fff;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st6, .st7 {\n        stroke: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st8, .st9, .st10 {\n        isolation: isolate;\n      }\n\n      .st11, .st9 {\n        fill: #68836a;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st9 {\n        font-size: 11px;\n      }\n\n      .st9, .st10 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st10 {\n        font-size: 5px;\n      }\n\n      .st6 {\n        stroke-width: .8px;\n      }\n\n      .st6, .st7 {\n        stroke-miterlimit: 4;\n      }\n\n      .st7 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "_x32_529"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "warning_track",
        className: "st12",
        d: "M220.3,117.7l-42.5,47.1-24.2,47.4s-8.7,19.8-29.5,19.8-31-21.3-31-21.3l-17.4-42.1-48.1-54.2-2.5-2.8,3-5.6,1.3-2.1,1.3-2.1,1.3-2.1,1.4-2.1,1.4-2.2,1.4-2.2,1.4-2.2,1.5-2.2,1.4-2.2,1.5-2.3,1.5-2.3,1.5-2.4,1.5-2.4,1.5-2.4,1.6-2.5,1.6-2.5,1.7-2.6,2-1.9,2.2-1.5,2.2-1.5,2.2-1.6,2.3-1.6,2.3-1.6,2.3-1.6,2.3-1.6,2.4-1.7,2.4-1.6,2.4-1.7,2.5-1.7,2.5-1.7,2.5-1.7,2.7-.9,2.7-.9,2.7-.9,2.8-.9,2.7-.9,2.8-.9,2.8-.9,2.8-.9,2.9-1,2.9-.6h26.4l2.9.2,2.8,1.5,2.7,1.5,2.7,1.5,2.7,1.5,2.7,1.5,2.6,1.4,2.6,1.4,2.6,1.4,2.5,1.4,2.5,1.4,2.5,1.3,2.5,1.4,2.5,1.3,2.5,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.2,1.7,1.5,2.8,1.5,2.8,1.4,2.7,1.4,2.7,1.4,2.6,1.3,2.6,1.3,2.5,1.3,2.5,1.2,2.4,1.2,2.4,1.2,2.4,1.2,2.3,1.2,2.3,1.2,2.3,1.2,2.2,1.1,2.2,2.4,7-3,3.3Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "grass",
        className: "st11",
        d: "M34.7,112.7l23.8-37.3,3-3.5,27.2-18.9,23.1-7.9h27.3l53.2,30.7,19.3,34.5,2.4,4-2.7,4.8-38.6,43.8-24.2,46.3s-6.8,18.2-23.9,18.2-25.2-18.2-25.2-18.2l-18.7-43.1-45.9-53.5Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st9",
        transform: "translate(2.2 107.9)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "330"))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st9",
        transform: "translate(50 48.7)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380"))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st9",
        transform: "translate(184.5 50.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380"))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st9",
        transform: "translate(118.1 28)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "403"))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st9",
        transform: "translate(228.6 111.5)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "325"))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "Compass"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("polygon", {
        className: "st3",
        points: "232.5 206.6 225.7 200.5 222 193.4 228.2 198.4 232.5 206.6"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st13",
        d: "M236.8,211.6c-6.7,5.4-16.4,4.3-21.8-2.3-5.4-6.7-4.3-16.4,2.3-21.8,6.7-5.4,16.4-4.3,21.8,2.3,5.4,6.6,4.3,16.4-2.3,21.8ZM218.1,188.5c-6.1,4.9-7,13.9-2.1,20s13.9,7,20,2.1,7-13.9,2.1-20c-5-6.1-13.9-7-20-2.1Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st3",
        d: "M240.6,216.3c-9.3,7.5-22.9,6-30.4-3.2-7.5-9.3-6-22.9,3.2-30.4,9.3-7.5,22.9-6,30.4,3.2,7.5,9.3,6,22.9-3.2,30.4ZM214.7,184.3c-8.4,6.8-9.7,19.2-2.9,27.6,6.8,8.4,19.2,9.7,27.6,2.9,8.4-6.8,9.7-19.2,2.9-27.6-6.8-8.4-19.2-9.7-27.6-2.9Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("circle", {
        className: "st3",
        cx: 227,
        cy: 199.5,
        r: 3
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st3",
        d: "M220.3,193.1l-1.9-2.4.4-.3,2.4.8h0l-1.3-1.7.4-.3,1.9,2.4-.4.3-2.4-.8h0l1.3,1.7-.4.3Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("circle", {
        className: "st5",
        cx: 227,
        cy: 199.5,
        r: 1.6
    }))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st4",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st2",
        d: "M125.2,203.2L18.5,96.5"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st2",
        d: "M125.2,203.2l106.7-106.8"
    })), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("rect", {
        id: "third-base",
        className: "st7",
        x: 99.2,
        y: 175.1,
        width: 3,
        height: 3,
        transform: "translate(-95.4 122.9) rotate(-45)"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("rect", {
        id: "first-base",
        className: "st7",
        x: 148.1,
        y: 175.2,
        width: 3,
        height: 3,
        transform: "translate(-81.1 157.5) rotate(-45)"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("rect", {
        id: "second-base",
        className: "st6",
        x: 123.7,
        y: 148.6,
        width: 3,
        height: 3,
        transform: "translate(-69.5 132.5) rotate(-45)"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("polygon", {
        id: "home",
        className: "st4",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    }))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", null, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(91 184.1) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(56.5 153.8) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(71 168.4) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(80.4 177.7) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(41.6 139) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(27.5 124) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(12.7 109.2) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 75.9) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 49.4) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450")))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        className: "st8"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("text", {
        className: "st10",
        transform: "translate(15 24.6) rotate(-44.2)"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500"))))), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $13c83e87d6272e5a$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    }))));
}
var $13c83e87d6272e5a$var$_default = module.exports["default"] = $13c83e87d6272e5a$var$Venue2529;

});

parcelRegister("jWsOX", function(module, exports) {
"use strict";
function $e849ca51674757bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e849ca51674757bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e849ca51674757bc$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e849ca51674757bc$var$React = $e849ca51674757bc$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $e849ca51674757bc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e849ca51674757bc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e849ca51674757bc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e849ca51674757bc$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e849ca51674757bc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e849ca51674757bc$var$_extends() {
    return $e849ca51674757bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e849ca51674757bc$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $e849ca51674757bc$var$Venue2535(props) {
    return /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("svg", $e849ca51674757bc$var$_extends({
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("defs", null, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("style", null, '\n      .st0 {\n        fill: #aa8d49;\n      }\n\n      .st1 {\n        fill: #5b5b5b;\n      }\n\n      .st2, .st3, .st4, .st5 {\n        fill: #fff;\n      }\n\n      .st2, .st6 {\n        stroke-width: .8px;\n      }\n\n      .st2, .st6, .st4, .st5 {\n        stroke: #fff;\n      }\n\n      .st7, .st8 {\n        fill: #68836a;\n      }\n\n      .st9 {\n        fill: #a88b49;\n      }\n\n      .st8 {\n        font-family: ArialMT, Arial;\n        font-size: 11px;\n      }\n\n      .st10 {\n        fill: #7f7f7f;\n      }\n\n      .st6 {\n        fill: none;\n      }\n\n      .st4 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st5 {\n        stroke-miterlimit: 4;\n      }\n\n      .st5 {\n        stroke-width: .7px;\n      }\n    ')), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "Compass"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("polygon", {
        className: "st1",
        points: "227 190.5 228.6 199.5 227.2 207.4 225.4 199.5 227 190.5"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        className: "st10",
        d: "M226.8,183.9c8.5-.1,15.6,6.7,15.7,15.3.1,8.5-6.7,15.6-15.3,15.7-8.5.1-15.6-6.7-15.7-15.3-.1-8.5,6.7-15.6,15.3-15.7ZM227.2,213.6c7.8-.1,14.1-6.6,14-14.4-.1-7.8-6.6-14.1-14.4-14-7.8.1-14.1,6.6-14,14.4.1,7.8,6.6,14.1,14.4,14Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        className: "st1",
        d: "M226.7,177.8c11.9-.2,21.7,9.4,21.9,21.3.2,11.9-9.4,21.7-21.3,21.9-11.9.2-21.7-9.4-21.9-21.3-.1-11.9,9.4-21.7,21.3-21.9ZM227.3,219c10.8-.2,19.5-9.1,19.3-19.9-.2-10.8-9.1-19.5-19.9-19.3-10.8.2-19.5,9.1-19.3,19.9.2,10.8,9.1,19.5,19.9,19.3Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("circle", {
        className: "st1",
        cx: 227,
        cy: 199.4,
        r: 3
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        className: "st1",
        d: "M228.4,208.7v3.1h-.5l-1.4-2.1h0v2.1h-.5v-3.1h.5l1.4,2.1h0v-2.1h.5Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("circle", {
        className: "st3",
        cx: 227,
        cy: 199.4,
        r: 1.6
    })), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("text", {
        className: "st8",
        transform: "translate(10.09 79.21)"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "325")), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("text", {
        className: "st8",
        transform: "translate(114.55 26.37)"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "404")), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("text", {
        className: "st8",
        transform: "translate(45.4 50.88)"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "375")), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("text", {
        className: "st8",
        transform: "translate(189.49 50.88)"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "375")), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("text", {
        className: "st8",
        transform: "translate(223.31 84.66)"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "325"))), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "Outfield",
        className: "st9",
        d: "M126.5,227.7c-18.3,0-28.5-10.9-28.5-10.9l-.2-4-16.5-19.8h-4.3l-21.9-37.3-27.1-51.3-1.5-4.2s-2-13.5,4.5-22.2c8.5-11.5,58.8-43,82-46.2,0,0,12.2-4,26-.5s68.5,36.5,74.7,43c5.6,5.9,11,21.5,5,36.5s-15.2,31.8-16.5,37.3-24.5,43.8-27.3,45-4,0-4,0l-16.7,19.2.2,4.5c-.1-.2-9.6,10.9-27.9,10.9Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "grass",
        className: "st7",
        d: "M126.4,218.8c-16.6,0-25.8-9.9-25.8-9.9l-.2-3.6-15-17.9h-3.9l-19.9-33.8-24.7-47.1-1.4-3.9s-1.8-12.2,4.1-20.2c7.7-10.4,53.3-39,74.4-41.9,0,0,11-3.6,23.6-.5,12.5,3.2,62.1,33.1,67.7,39,5.1,5.4,10,19.5,4.5,33.1-5.4,13.6-13.6,29.3-14.8,34.3s-22.2,39.8-24.8,40.8c-2.6,1.1-3.6,0-3.6,0l-15.1,17.4.2,4.1s-8.6,10.1-25.3,10.1Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "infield_sand",
        className: "st0",
        d: "M101.7,170l-6.1,6.1,6.1,6.1c3.4-3.4,3.4-8.8,0-12.2ZM148.6,182.2l6.1-6.1-6.1-6.1c-3.3,3.4-3.3,8.8,0,12.2ZM131.2,152.6l-6.1-6.1-6.1,6.1c3.4,3.4,8.9,3.4,12.2,0ZM125.2,173.5c2.15,0,3.9,1.75,3.9,3.9s-1.75,3.9-3.9,3.9-3.9-1.75-3.9-3.9,1.75-3.9,3.9-3.9ZM125.2,197.8c3.09,0,5.6,2.51,5.6,5.6s-2.51,5.6-5.6,5.6-5.6-2.51-5.6-5.6,2.51-5.6,5.6-5.6Z"
    })), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st9",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st2",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st6",
        d: "M125.2,203.2L23.5,101.6"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st6",
        d: "M125.2,203.2l99-99.1"
    })), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("rect", {
        id: "third-base",
        className: "st5",
        x: 99.18,
        y: 175.07,
        width: 3,
        height: 3,
        transform: "translate(-95.36 122.91) rotate(-45)"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("rect", {
        id: "first-base",
        className: "st5",
        x: 148.13,
        y: 175.16,
        width: 3,
        height: 3,
        transform: "translate(-81.09 157.55) rotate(-45)"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("rect", {
        id: "second-base",
        className: "st4",
        x: 123.67,
        y: 148.61,
        width: 3,
        height: 3,
        transform: "translate(-69.48 132.47) rotate(-45)"
    }), /*#__PURE__*/ $e849ca51674757bc$var$React.createElement("polygon", {
        id: "home",
        className: "st2",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    }))));
}
var $e849ca51674757bc$var$_default = module.exports["default"] = $e849ca51674757bc$var$Venue2535;

});

parcelRegister("hIFtS", function(module, exports) {
"use strict";
function $ce66b8f468ddffa2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ce66b8f468ddffa2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ce66b8f468ddffa2$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ce66b8f468ddffa2$var$React = $ce66b8f468ddffa2$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $ce66b8f468ddffa2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ce66b8f468ddffa2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ce66b8f468ddffa2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $ce66b8f468ddffa2$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $ce66b8f468ddffa2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ce66b8f468ddffa2$var$_extends() {
    return $ce66b8f468ddffa2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce66b8f468ddffa2$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $ce66b8f468ddffa2$var$Venue2602(props) {
    return /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("svg", $ce66b8f468ddffa2$var$_extends({
        id: "_x32_602",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "CIN"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        className: "st0",
        d: "M232,192.1l-3.7,8.4l-5.6,5.7l2.9-7.5L232,192.1z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        className: "st1",
        d: "M235.5,186.5c7.2,4.7,9.2,14.3,4.6,21.5c-4.7,7.2-14.3,9.2-21.5,4.6c-7.2-4.7-9.2-14.3-4.6-21.5 C218.7,183.9,228.3,181.9,235.5,186.5z M219.3,211.4c6.6,4.3,15.4,2.4,19.6-4.2c4.3-6.6,2.4-15.4-4.2-19.6 c-6.6-4.3-15.4-2.4-19.6,4.2C210.9,198.3,212.7,207.2,219.3,211.4z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        className: "st0",
        d: "M224.1,200.1c-0.3-1.6,0.7-3.2,2.3-3.5s3.2,0.7,3.5,2.3s-0.7,3.2-2.3,3.5C226,202.8,224.5,201.7,224.1,200.1z  M223,208l-1.7,2.6l-0.4-0.3v-2.5l-1.2,1.8l-0.4-0.3l1.7-2.6l0.4,0.3v2.6l1.2-1.8L223,208z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        className: "st2",
        d: "M225.4,199.9c-0.2-0.9,0.4-1.8,1.3-2c0.9-0.2,1.8,0.4,2,1.3c0.2,0.9-0.4,1.8-1.3,2 C226.5,201.3,225.6,200.8,225.4,199.9z"
    })), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 222.0479 113.9326)",
        className: "st3 st4 st5"
    }, "325"), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 179.5762 60.6973)",
        className: "st3 st4 st5"
    }, "370"), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 117.5718 32.6191)",
        className: "st3 st4 st5"
    }, "404"), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 62.4883 48.8057)",
        className: "st3 st4 st5"
    }, "387"), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.7344 102.6973)",
        className: "st3 st4 st5"
    }, "328")), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "field",
        transform: "matrix(.98 0 0 -.98 250 420)"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M-147.3,207c-3.5,1.8-26.4,35.5-29.7,40.3l-9.4,27.4l-39.4,39.5l-0.2,5.6l0.6,2.9l0.6,2.9 l1.3,2.3l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.9,1.8l1.9,1.8l1.9,1.8l1.9,1.9l1.9,1.9l1.9,1.9 l2,1.9l2,1.9l2,1.9l2,2l2.1,2l2.1,2l2.1,2.1l2.1,2.1l2.2,2.1l2.2,2.2l2.2,2.2l2.3,2.2l2.4,2.2l2.7,0.9l2.8,0.8l2.8,0.8l2.8,0.8 l2.8,0.8l2.8,0.8l2.8,0.8l2.8,0.8l2.8,0.9l2.9,0.9l2.9,0.9l2.9,0.9l2.9,0.9l3,0.9l3,0.9l3-0.7l2.9-1.1l2.9-1.1l2.9-1.1l2.9-1.1 l2.8-1.2l2.8-1.2l2.8-1.2l2.7-1.3l2.7-1.3l2.7-1.3l2.6-1.4l2.6-1.4l2.5-1.4l2.5-1.5l2.4-1.6l2.4-1.6l2.4-1.6l2.4-1.6l2.3-1.6 l2.2-1.7l2.2-1.7l2.2-1.7l2.1-1.8l2.1-1.8l2.1-1.8l2-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.8-1.9l1.7-2l1.7-2l1.7-2l1.7-2 l1.7-1.9l1.7-1.9l1.6-1.9l1.6-1.9l1.6-1.9l1.5-2l1.1-2.4l1.2-2.3l1.3-2.2l-1.1-11.6c-2-3-28.4-29.5-28.4-29.5S-79,238.5-84,231.5 c-5-7.1-20.4-27.4-27.4-30.8c-7-3.3-11.6-3.7-17.1-3C-142.3,199.6-147.3,207-147.3,207z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M-124.7,205.9c-0.9,0-1.9,0.1-3.2,0.2c-8.6,1-12.2,4.9-12.8,5.5l-1.1,1.8l-1.2,0.4 c-1.9,2-7.7,9.3-26.2,36.2l-0.5,0.8l-9.7,28.2l-38.5,38.6l-0.1,1.4l0.7,3.5l0.1,0.2l50.3,49l1,0.9l1,0.3l2.6,0.8l34.9,10.5 l0.4-0.1l11-4.1l2.7-1.1l2.7-1.1l2.6-1.1l7.7-3.7l2.4-1.3l2.5-1.4l2.5-1.3l2.2-1.3l7.1-4.6l2.2-1.5l2.1-1.5l4.3-3.2l2-1.6l2.1-1.7 l2.1-1.7l1.9-1.6l1.8-1.7l7.5-7.3l1.6-1.7l6.7-7.8l3.4-3.9l1.6-1.9l3.1-3.6l0.9-1.2l0.8-1.6l1.3-2.6l0.1-0.1l-0.6-6.5 c-4-4.4-15.7-16.4-26.3-27l-0.9-0.9l-0.6-1.1c-7.5-14.8-20.8-40-24.2-44.8c-9.5-13.3-20.8-26.5-24.3-28.2 C-119.9,206.2-122.5,205.9-124.7,205.9L-124.7,205.9z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4 c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7 c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6 s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z"
    })), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l95.5-95.6"
    })), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $ce66b8f468ddffa2$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $ce66b8f468ddffa2$var$_default = module.exports["default"] = $ce66b8f468ddffa2$var$Venue2602;

});

parcelRegister("aZC7t", function(module, exports) {
"use strict";
function $800d2ba78814bf31$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $800d2ba78814bf31$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $800d2ba78814bf31$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $800d2ba78814bf31$var$React = $800d2ba78814bf31$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $800d2ba78814bf31$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($800d2ba78814bf31$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $800d2ba78814bf31$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $800d2ba78814bf31$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $800d2ba78814bf31$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $800d2ba78814bf31$var$_extends() {
    return $800d2ba78814bf31$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $800d2ba78814bf31$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $800d2ba78814bf31$var$Venue2680(props) {
    return /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("svg", $800d2ba78814bf31$var$_extends({
        id: "_x32_680",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "SDP"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        className: "st0",
        d: "M227,208.5l-1.6-9.1l1.5-7.8l1.7,7.8L227,208.5z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        className: "st1",
        d: "M227.2,215c-8.5,0.1-15.6-6.8-15.7-15.3c-0.1-8.5,6.8-15.6,15.3-15.7c8.5-0.1,15.6,6.8,15.7,15.3 C242.6,207.9,235.8,214.9,227.2,215z M226.8,185.3c-7.8,0.1-14.1,6.5-14,14.4c0.1,7.8,6.5,14.1,14.4,14c7.8-0.1,14.1-6.5,14-14.4 C241.1,191.5,234.7,185.2,226.8,185.3z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.1,1.2,3,0,4.2c-1.1,1.2-3,1.2-4.2,0.1c-1.2-1.1-1.2-3-0.1-4.2 C226,196.3,227.9,196.2,229.1,197.4z M225.7,190.3v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.7z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.3c0.7,0.6,0.7,1.7,0,2.3c-0.6,0.7-1.7,0.7-2.3,0c-0.7-0.6-0.7-1.7,0-2.3 C226.5,197.7,227.5,197.7,228.2,198.3z"
    })), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 220.4932 116.9326)",
        className: "st3 st4 st5"
    }, "322"), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 120.7759 36.4277)",
        className: "st3 st4 st5"
    }, "396"), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 7.3081 114.4888)",
        className: "st3 st4 st5"
    }, "334")), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "field",
        transform: "matrix(.98 0 0 -.98 250 420)"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M-228,314.7v7l2.2,1.3l1.5,2l1.4,2.2l1.4,2.2l1.4,2.2l1.6,2l1.8,1.8l1.8,1.8l1.8,1.8 l1.8,1.8l1.8,1.8l1.9,1.8l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l2,1.9l2,2l2,2l2,2l2.1,2l2.1,2.1l2.1,2.1l2.1,2.1l2.2,2.2 l2.2,2.2l2.3,2.3l2.4,2.1l2.6,1.5l2.6,1.5l2.6,1.5l2.6,1.5l2.7,1.5l3,0.1h17.6l2.8,1.6l2.9,1h26.4l2.9-0.4l2.9-0.6l2.9-0.6 l2.9-0.6l2.9-0.6l2.9-0.6l2.7-1.5l2.6-1.6l2.6-1.6l2.6-1.6l2.5-1.8l2.3-2.3l2.2-2.2l2.2-2.2l2.2-2.2l2.1-2.1l2.1-2.1l2.1-2.1l2-2 l2-2l2-2l2-2l2-2l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.8-1.8l0.6-3.3v-11.5l1.5-1.9l1.7-1.7l1.5-1.9 l0.6-10.6l-31.5-31.5l-20.4-35l-2.4-2.4l-4.8-7.3l-16.3-17.6l-2.7-0.5l-7.2-6.8l-8.2-4h-7.3l-8.8,3.7l-9.6,9.6l-3-0.3l-13.5,14 l-4.2,8.1l-3.6,3.2l-23.4,36.5v7.2L-228,314.7L-228,314.7z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M-129.5,210.3l-5.9,2.5l-11.3,11.2l-17.1,18.4l-3.8,3.5l-21.6,33.6v8.2l-25.9,26.8l-0.7,8.1 l3.2,5.6l43,42.9l1.6,1.4l10.6,6.1h0.8l19.6,0.1l4,0.2l3,2.3l22.7,0.1l2.2-0.3l13-2.5l1.4-0.8l7.3-4.5l1.7-1.2l37-40 c0,0,1.7-1.7,2.1-5.2c0.4-3.5,0-20.4,0-20.4l-25.6-25.6l-20.4-35l-2.2-2.2l-21.3-22.9l-8.1-7.7l-5.3-2.6h-4V210.3z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4 c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7 c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6 s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z"
    })), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-98.6-98.6"
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l94.5-94.6"
    })), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $800d2ba78814bf31$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $800d2ba78814bf31$var$_default = module.exports["default"] = $800d2ba78814bf31$var$Venue2680;

});

parcelRegister("alOdp", function(module, exports) {
"use strict";
function $7892d144e1fe4a38$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7892d144e1fe4a38$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7892d144e1fe4a38$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7892d144e1fe4a38$var$React = $7892d144e1fe4a38$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $7892d144e1fe4a38$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7892d144e1fe4a38$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7892d144e1fe4a38$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $7892d144e1fe4a38$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $7892d144e1fe4a38$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7892d144e1fe4a38$var$_extends() {
    return $7892d144e1fe4a38$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7892d144e1fe4a38$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $7892d144e1fe4a38$var$Venue2681(props) {
    return /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("svg", $7892d144e1fe4a38$var$_extends({
        id: "_x32_681",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "PHI"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        className: "st0",
        d: "M227,208.5l-1.6-9.1l1.5-7.8l1.7,7.8L227,208.5z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        className: "st1",
        d: "M227.2,215c-8.5,0.1-15.6-6.8-15.7-15.3c-0.1-8.5,6.8-15.6,15.3-15.7c8.5-0.1,15.6,6.8,15.7,15.3 C242.6,207.9,235.8,214.9,227.2,215z M226.8,185.3c-7.8,0.1-14.1,6.5-14,14.4c0.1,7.8,6.5,14.1,14.4,14c7.8-0.1,14.1-6.5,14-14.4 C241.1,191.5,234.7,185.2,226.8,185.3z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        className: "st0",
        d: "M229.1,197.4c1.2,1.1,1.2,3,0.1,4.2c-1.1,1.2-3,1.2-4.2,0.1c-1.2-1.1-1.2-3-0.1-4.2S227.9,196.2,229.1,197.4z  M225.7,190.3v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.7z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        className: "st2",
        d: "M228.2,198.3c0.7,0.6,0.7,1.7,0,2.3c-0.6,0.7-1.7,0.7-2.3,0c-0.7-0.6-0.7-1.7,0-2.3 C226.5,197.7,227.5,197.7,228.2,198.3z"
    })), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 223.8877 113.5547)",
        className: "st3 st4 st5"
    }, "330"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 135.9971 35.5254)",
        className: "st3 st4 st5"
    }, "401"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 108.9951 31.6152)",
        className: "st3 st4 st5"
    }, "409"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 78.3115 45.4072)",
        className: "st3 st4 st5"
    }, "387"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 59.1709 52.4688)",
        className: "st3 st4 st5"
    }, "374"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "left-left-left-center",
        transform: "matrix(1 0 0 1 14.3525 97.2334)",
        className: "st3 st4 st5"
    }, "334"), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 7.499 115.2637)",
        className: "st3 st4 st5"
    }, "329")), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M199.8,132l-2.4,2.3l-0.2,10.4L186.8,173l-49.7,48.3l-21.8,0.1l-49.2-47.2l-10.9-27.1 l0.1-9.4l-27.1-27.6l0.1-3.5v-3.5l1.7-1.8l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8 l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2-2l2-2l2-2l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.2-2.2 l2.3-2.3l2.7-0.7h8.6l2.4-2.4l2.5-2.4l2.5-2.5l2.6-2.6l2.7-2.6l2.9-0.6l3,0.4l3,0.4l3,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4 l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.8,0.8l2.4,2.4l2.4,2.4l2.3,2.3l2.3,2.3l2.2,2.2l2.2,2.2 l2.2,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l2,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8 l1.8,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l0.1,3.5L199.8,132L199.8,132z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M70.2,169.7l-9.8-23.5l0.2-13.4l-26.1-24l2-2.4l51-51h4.4l6.1-0.1l13.1-13l41,5.7h0.3 l62.9,61.5L191,133.3l-0.5,11.7l-8.6,22.5l-46.5,47.1h-18.8L70.2,169.7z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $7892d144e1fe4a38$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $7892d144e1fe4a38$var$_default = module.exports["default"] = $7892d144e1fe4a38$var$Venue2681;

});

parcelRegister("chE02", function(module, exports) {
"use strict";
function $024ecedd77cf32b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $024ecedd77cf32b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $024ecedd77cf32b2$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $024ecedd77cf32b2$var$React = $024ecedd77cf32b2$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $024ecedd77cf32b2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($024ecedd77cf32b2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $024ecedd77cf32b2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $024ecedd77cf32b2$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $024ecedd77cf32b2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $024ecedd77cf32b2$var$_extends() {
    return $024ecedd77cf32b2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $024ecedd77cf32b2$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $024ecedd77cf32b2$var$Venue2889(props) {
    return /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("svg", $024ecedd77cf32b2$var$_extends({
        id: "_x32_889",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.002;}\n"), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "STL"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        className: "st0",
        d: "M233.7,205.5l-7.8-4.8l-4.9-6.4l7,3.9L233.7,205.5z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        className: "st1",
        d: "M238.7,209.7c-5.6,6.5-15.4,7.1-21.9,1.5s-7.1-15.4-1.5-21.9s15.4-7.1,21.9-1.5 C243.6,193.4,244.3,203.2,238.7,209.7z M216.3,190.2c-5.1,5.9-4.5,14.9,1.4,20s14.9,4.5,20-1.4s4.5-14.9-1.4-20 S221.4,184.3,216.3,190.2z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        className: "st0",
        d: "M226.8,196.6c1.6-0.1,3.1,1.1,3.2,2.8c0.1,1.6-1.1,3.1-2.8,3.2c-1.6,0.1-3.1-1.1-3.2-2.8 C223.9,198.1,225.2,196.7,226.8,196.6z M219.2,194.4l-2.3-2l0.3-0.4l2.5,0.3l-1.6-1.4l0.3-0.4l2.3,2l-0.3,0.4l-2.5-0.3l1.6,1.4 L219.2,194.4z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        className: "st2",
        d: "M226.9,197.9c0.9-0.1,1.7,0.6,1.8,1.5s-0.6,1.7-1.5,1.8s-1.7-0.6-1.8-1.5C225.3,198.7,226,197.9,226.9,197.9z "
    })), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 219.8574 119)",
        className: "st3 st4 st5"
    }, "335"), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 43.833 58.0244)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 116.0986 34.3447)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 188.0674 58.0244)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 9.043 115.0767)",
        className: "st3 st4 st5"
    }, "336")), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "field_1_"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M223.8,107.4l-14.2,14.2l-0.4,6.9l-29.9,52c0,0-18.3,18.4-24.2,25 c-4.4,5.4-15.6,18.5-29.5,18.5c-12.4,0-20.5-8.2-29.4-18.5L62,171.3l-8.4-37L28.2,108l-1.9-3.6l-1-4.6v-3.6l1.8-1.8l1.8-1.8 l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2-2l2-2l2-2l2.1-2.1 l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.3-2l2.6-1l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.8-0.9l2.8-0.9 l2.8-0.9l2.8-0.9l2.8-0.9l2.9-0.1h26.1l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9 l2.7,0.9l2.7,0.9l2.7,1l2.3,1.9l2.2,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l2,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9 l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.1,2.6l0.5,3.2l0.4,3.1l0.4,3.1L223.8,107.4L223.8,107.4z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.6,215.8c-8,0-17.8-9-27.8-20.2L69,167.5l-9.7-39.4L38.8,107l-1.9-11.1l38.5-38.4l1-0.9 l1.1-0.4l34.4-11.1l1.7-0.1h24.7l34.3,11l1.2,0.5l1,0.9l36.3,36.8l0.4,8.9l0.1,3L201,117.3l0.9,11.1L177,171.7 c-3.7,4.3-32.5,32.7-32.9,33.1C139.7,209.5,134.8,215.8,125.6,215.8L125.6,215.8z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "left-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l-98.9-98.9"
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l98.4-98.5"
    })), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3661 122.8889)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1129 157.4789)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4747 132.5383)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $024ecedd77cf32b2$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $024ecedd77cf32b2$var$_default = module.exports["default"] = $024ecedd77cf32b2$var$Venue2889;

});

parcelRegister("2YGpi", function(module, exports) {
"use strict";
function $22b21489391c7771$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $22b21489391c7771$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $22b21489391c7771$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $22b21489391c7771$var$React = $22b21489391c7771$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $22b21489391c7771$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($22b21489391c7771$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $22b21489391c7771$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $22b21489391c7771$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $22b21489391c7771$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $22b21489391c7771$var$_extends() {
    return $22b21489391c7771$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22b21489391c7771$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $22b21489391c7771$var$Venue3289(props) {
    return /*#__PURE__*/ $22b21489391c7771$var$React.createElement("svg", $22b21489391c7771$var$_extends({
        id: "_x33_289",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n\t.st16{fill:none;stroke:#B3B3B3;stroke-width:0.25;stroke-miterlimit:10;}\n"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "NYM"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st0",
        d: "M229.6,208.1l-4.2-8.2l-0.8-7.9l3.9,6.9L229.6,208.1z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st1",
        d: "M231.7,214.3c-8.1,2.6-16.9-1.9-19.5-10s1.9-16.9,10-19.5s16.9,1.9,19.5,10 C244.4,202.9,239.9,211.7,231.7,214.3z M222.7,186c-7.5,2.4-11.6,10.4-9.2,17.8s10.4,11.6,17.8,9.2c7.5-2.4,11.6-10.4,9.2-17.8 C238.1,187.7,230.1,183.6,222.7,186z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st0",
        d: "M228.4,196.9c1.5,0.8,2,2.5,1.3,4c-0.8,1.5-2.5,2-4,1.3c-1.5-0.8-2-2.5-1.3-4S226.9,196.1,228.4,196.9z  M223,191.1l-0.9-2.9l0.4-0.1l2,1.6l-0.6-2l0.5-0.2l0.9,2.9l-0.4,0.1l-2-1.6l0.6,2L223,191.1z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st2",
        d: "M227.8,198.1c0.8,0.4,1.1,1.4,0.7,2.2c-0.4,0.8-1.4,1.1-2.2,0.7c-0.8-0.4-1.1-1.4-0.7-2.2 C226,198,227,197.6,227.8,198.1z"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 225.6533 114.5732)",
        className: "st3 st4 st5"
    }, "330"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "right-right-center_1_",
        transform: "matrix(1 0 0 1 62.8115 54.1855)",
        className: "st3 st4 st5"
    }, "370"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 158.0547 44.0811)",
        className: "st3 st4 st5"
    }, "380"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 116.4346 29.8398)",
        className: "st3 st4 st5"
    }, "408"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 171.5967 54.186)",
        className: "st3 st4 st5"
    }, "370"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 21.8096 79.4854)",
        className: "st3 st4 st5"
    }, "358"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 5.165 113.0767)",
        className: "st3 st4 st5"
    }, "335")), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "field",
        transform: "matrix(.98 0 0 -.98 250 420)"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "Outfield_00000094597754240764042730000018294815217055423873_",
        className: "st6",
        d: "M-26.2,318.5L-26.2,318.5l-37.4-37.7 l-5.4-28.5c0,0-22.6-33-28.4-39.5c-7.9-11.7-21.6-12.8-29.2-12.8c-12.3,0-22.5,2-31.3,13.3l-28.2,38.6l-7.6,30.8l-35.9,35.8 l1.8,3.3l1.2,2.3l1.2,2.3l1.2,2.4l1.3,2.4l1.2,2.5l1.3,2.5l1.3,2.5l1.3,2.5l1.3,2.6l2.1,1.6l2.2,1.5l2.2,1.5l2.2,1.5l2.3,1.4 l2.2,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.4,1.4l2.4,1.5l2.4,1.6 l2.4,1.7l2.4,1.7l2.5,1.7l2.5,1.7l2.5,1.8l2.6,1.8l2.6,1.8l2.7,1.8l2.7,1.9l2.8,1.9l2.8,2l2.9,1.6h3h3.1h3h3h3h3h3.1l3-0.5 l2.9-1.8l2.8-1.7l2.8-1.7l2.8-1.6l2.7-1.6l2.7-1.6l2.6-1.6l2.6-1.5l2.5-1.6l2.5-1.5l2.5-1.5l2.5-1.5l2.4-1.5l2.5-1.4l2.4-1.5 l2.4-1.4l2.4-1.4l2.4-1.4l2.8-0.5l2.8-0.6l2.8-0.5l2.4-1.4l1.7-2.7l1.7-2.5l1.7-2.5l1.7-2.4l1.7-2.4l1.7-2.3l1.6-2.3l1.6-2.3 l1.6-2.3l1.6-2.2l1.5-2.2l1.5-2.2l1.5-2.1l1.5-2.1l1.5-2.1l1.4-2.1l1.4-2.1l1.4-2l1.4-2L-26.2,318.5z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M-126.5,208.1c-10.9-0.1-18.1,1.4-24.8,9.8l-27.7,36.8l-8.1,31.3l-33.9,32.9l9.2,18.6l0.5,0.4 l6.2,4.5l2,1.3l29.9,18.7l2.6,1.6l30.3,21.8l0.7,0.4l18.6,0.2l0.8-0.1l43.2-25.1l3.3-1.9l6.3-1.7l2.7-0.7l20.1-28l2.6-3.8l3.7-5.1 l-33.4-34.6l-5.1-29.4c-8.8-13.2-22.5-33.2-26.3-37.6l-0.4-0.4l-0.3-0.5C-108.3,211.4-115.5,208.3-126.5,208.1L-126.5,208.1z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4 c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7 c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6 s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-98.7-98.6"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "grid",
        className: "st11"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)",
        className: "st4 st13"
    }, "90"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)",
        className: "st4 st13"
    }, "200"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)",
        className: "st4 st13"
    }, "150"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)",
        className: "st4 st13"
    }, "120"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)",
        className: "st4 st13"
    }, "250"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)",
        className: "st4 st13"
    }, "300"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)",
        className: "st4 st13"
    }, "350"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)",
        className: "st4 st13"
    }, "400"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)",
        className: "st4 st13"
    }, "450"), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)",
        className: "st4 st13"
    }, "500")), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        id: "surface29_2_"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st14",
        d: "M125.5,203.8l-148-148"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st14",
        d: "M124.8,203.8l148-148"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5l79.8-192.6"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st14",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x32_00-line_2_",
        className: "st14",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x39_0-line_2_",
        className: "st14",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st14",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st14",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st14",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st14",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st14",
        d: "M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x34_00-line_1_",
        className: "st14",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st14",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
    })), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 16,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 18,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 20.1,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 22.2,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 24.3,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 26.3,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 28.4,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 30.5,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 32.6,
        className: "st16",
        width: 4.9,
        height: 2.1
    }), /*#__PURE__*/ $22b21489391c7771$var$React.createElement("rect", {
        x: 125.2,
        y: 34.6,
        className: "st16",
        width: 4.9,
        height: 2.1
    }))));
}
var $22b21489391c7771$var$_default = module.exports["default"] = $22b21489391c7771$var$Venue3289;

});

parcelRegister("6AS4l", function(module, exports) {
"use strict";
function $4cd00bdbf8811713$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4cd00bdbf8811713$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4cd00bdbf8811713$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4cd00bdbf8811713$var$React = $4cd00bdbf8811713$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $4cd00bdbf8811713$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4cd00bdbf8811713$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4cd00bdbf8811713$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4cd00bdbf8811713$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4cd00bdbf8811713$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4cd00bdbf8811713$var$_extends() {
    return $4cd00bdbf8811713$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4cd00bdbf8811713$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $4cd00bdbf8811713$var$Venue3309(props) {
    return /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("svg", $4cd00bdbf8811713$var$_extends({
        id: "_x33_309",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "WSH"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        className: "st0",
        d: "M231.3,207.4l-5.7-7.2l-2.5-7.6l5.3,6L231.3,207.4z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        className: "st1",
        d: "M234.6,213c-7.5,4.2-16.9,1.5-21.1-5.9c-4.2-7.5-1.5-16.9,5.9-21.1c7.5-4.2,16.9-1.5,21.1,5.9 C244.7,199.4,242.1,208.8,234.6,213z M220.1,187.2c-6.8,3.8-9.2,12.5-5.4,19.3s12.5,9.2,19.3,5.4s9.2-12.5,5.4-19.3 C235.6,185.7,226.9,183.3,220.1,187.2z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        className: "st0",
        d: "M227.8,196.7c1.6,0.4,2.5,2.1,2.1,3.7c-0.4,1.6-2.1,2.5-3.7,2.1c-1.6-0.4-2.5-2.1-2.1-3.7 C224.6,197.1,226.2,196.2,227.8,196.7z M221.4,192l-1.5-2.7l0.4-0.2l2.3,1.2l-1-1.9l0.5-0.3l1.5,2.7l-0.4,0.2l-2.3-1.2l1,1.9 L221.4,192z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        className: "st2",
        d: "M227.5,197.9c0.9,0.2,1.4,1.2,1.1,2c-0.2,0.9-1.2,1.4-2,1.1c-0.9-0.2-1.4-1.2-1.1-2 C225.7,198.2,226.6,197.7,227.5,197.9z"
    })), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 228.6035 111.2568)",
        className: "st3 st4 st5"
    }, "335"), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 96.8735 34.9316)",
        className: "st3 st4 st5"
    }, "402"), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 65.4326 49.3799)",
        className: "st3 st4 st5"
    }, "377"), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 8.8486 100.2334)",
        className: "st3 st4 st5"
    }, "336")), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M109.7,215l-42.1-39.9l-20.1-36.5l-0.3-7.5l-22.9-23.9l1.7-3l1.3-2.2l1.3-2.2l1.3-2.2 l1.3-2.2l1.4-2.3l1.4-2.3l1.4-2.3l1.4-2.3l1.4-2.4l1.4-2.4l1.5-2.5l1.5-2.5l1.5-2.5l1.8-2.1l2.3-1.3l1.8-2.3l2.4-1.3l2.4-1.3 l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.5-1.4l2.5-1.4l2.5-1.4l2.6-1.1l3.2,1.4l2.5-1.2 l2.5-1.4l2.6-1.4l2.6-1.4l2.6-1.4l2.7-1.5l2.7-1.5l2.7-1.5l2.8-1.5l2.8-1.6l2.9-1.6l3,0.6l2.9,1.3l2.9,1.3l2.9,1.3l2.8,1.2 l2.8,1.2l2.7,1.2l2.7,1.2l2.7,1.2l2.7,1.2l2.6,1.2l2.6,1.1l2.6,1l2.6,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1 l2.5,1.1l2.5,1.1l2.5,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l1.7,2.4l1.5,2.7 l1.4,2.6l1.4,2.6l1.4,2.5l1.4,2.5l1.3,2.4l1.3,2.4l1.3,2.4l1.3,2.3l1.3,2.3l1.3,2.3l1.2,2.2l1.2,2.2l2,3.2L200,134.4l1.3,8.6 c0,0-16.8,28.4-17.7,30l-43,43.2C138.4,218.1,125,230,109.7,215L109.7,215z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.7,216.9c-2.5,0-6-1.2-8.7-3.8l-0.2-0.2L73,173l-19.8-35.5l-0.7-12.3l-18.8-18.1l17-28.4 l0.4-0.5l2.6-1.4l1.8-2.3l31-17.1l3.2,1.4l6-2.9l24.4-13.4l79,34.9l0.2,0.2l16.1,29l-20,19.8l-0.8,12.6 c-5.4,12.1-12.4,23.3-14.8,28.3l-45,44.6c-0.6,0.4-1.1,0.8-1.4,1.1C130.4,215.5,128.4,216.9,125.7,216.9L125.7,216.9z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-99-99"
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l98.4-98.5"
    })), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $4cd00bdbf8811713$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $4cd00bdbf8811713$var$_default = module.exports["default"] = $4cd00bdbf8811713$var$Venue3309;

});

parcelRegister("39X87", function(module, exports) {
"use strict";
function $24d01452c957ea0c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24d01452c957ea0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24d01452c957ea0c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $24d01452c957ea0c$var$React = $24d01452c957ea0c$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $24d01452c957ea0c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24d01452c957ea0c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24d01452c957ea0c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $24d01452c957ea0c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $24d01452c957ea0c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $24d01452c957ea0c$var$_extends() {
    return $24d01452c957ea0c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24d01452c957ea0c$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $24d01452c957ea0c$var$Venue3312(props) {
    return /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("svg", $24d01452c957ea0c$var$_extends({
        id: "_x33_312",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "MIN"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        className: "st0",
        d: "M236,199.6l-9.1,1.5l-7.8-1.5l7.8-1.7L236,199.6z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        className: "st1",
        d: "M242.5,199.4c0,8.6-6.9,15.5-15.4,15.6c-8.6,0-15.5-6.9-15.6-15.4c0-8.6,6.9-15.5,15.4-15.6 C235.5,184,242.5,190.9,242.5,199.4z M212.8,199.6c0,7.8,6.4,14.2,14.3,14.1c7.8,0,14.2-6.4,14.1-14.3c0-7.8-6.4-14.2-14.3-14.1 C219.1,185.4,212.8,191.8,212.8,199.6z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        className: "st0",
        d: "M224.9,197.4c1.2-1.2,3-1.2,4.2,0s1.2,3,0,4.2s-3,1.2-4.2,0C223.8,200.5,223.8,198.6,224.9,197.4z  M217.8,200.8h-3.1v-0.5l2.1-1.4h-2.1v-0.5h3.1v0.5l-2.1,1.4h2.1V200.8z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        className: "st2",
        d: "M225.8,198.4c0.6-0.6,1.7-0.7,2.3,0c0.6,0.6,0.7,1.7,0,2.3c-0.6,0.6-1.7,0.7-2.3,0 C225.2,200.1,225.2,199,225.8,198.4z"
    })), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 225.501 114.416)",
        className: "st3 st4 st5"
    }, "328"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "right-right-center_1_",
        transform: "matrix(1 0 0 1 191.4268 68.5586)",
        className: "st3 st4 st5"
    }, "365"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 144.2588 36.3398)",
        className: "st3 st4 st5"
    }, "403"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 113.145 32.6328)",
        className: "st3 st4 st5"
    }, "411"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 43.3491 60.9365)",
        className: "st3 st4 st5"
    }, "377"), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 7.3159 99.9365)",
        className: "st3 st4 st5"
    }, "339")), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M24,105.1l1.3-1.7l1.6-1.8l1.6-1.9l1.6-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9 l1.7-1.9l1.7-1.9l1.7-2l1.7-2l1.8-2l1.8-2l1.8-2l1.8-2.1l1.8-2.1l1.9-2.1l1.9-2.1l1.9-2.2l2-2.2l2-2.2l2.2-1.9l2.4-1.5l2.4-1.5 l2.4-1.5l2.4-1.5l2.4-1.5l2.5-1.5l2.5-1.5l2.5-1.5l2.5-1.6l2.6-1.6l2.6-1.6l2.6-1.6l2.7-1.6l2.7-1.7l2.8-1.7l2.9-1.1l3,0.3l3,0.3 l3,0.3l3,0.3l3,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.8,1.1l2.7,1.7l2.7,1.7l2.6,1.7l2.6,1.7l2.5,1.6 l2.5,1.6l2.5,1.6l2.4,1.6l2.4,1.6l2.4,1.5l2.4,1.5l2.3,1.5l2.3,1.5L180,60l2.3,1.5l2.3,1.5l2.3,1.5l1.9,2.2l1.8,2.2l1.8,2.2 l1.8,2.2l1.8,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9l1.6,1.9l1.6,1.9l1.5,1.9l1.5,1.9l1.5,1.9 l1.5,1.9l1.5,1.9l2,2l-29.4,29.7l-9,27.1l-9.9,14c0,0-13.3,14.3-34.5,34.9c-15.9,15.5-32.5-1.3-32.5-1.3L56.8,158l-14.7-34.2 L24,105.1z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.9,216.3c-6.7,0-11.7-5.4-11.8-5.5l-0.2-0.2l-0.1-0.1l-48.4-49.1l-14.6-40.2L35,104.8 l34.7-39.4l1.3-1.1l40.3-22.9l29.4,2.9l1,0.4l39.8,25.7l1.1,1.3l32.1,39.3l-24.6,23.9l-8.4,24.2l-11.9,17.4 c-3,3-14.4,14.3-31.8,32.3C133.2,213.8,130.5,216.3,125.9,216.3L125.9,216.3z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-99.9-99.9"
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st8",
        d: "M125.2,203.2l96.4-96.4"
    })), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $24d01452c957ea0c$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $24d01452c957ea0c$var$_default = module.exports["default"] = $24d01452c957ea0c$var$Venue3312;

});

parcelRegister("LYuJp", function(module, exports) {
"use strict";
function $090350e1dc88de5d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $090350e1dc88de5d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $090350e1dc88de5d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $090350e1dc88de5d$var$React = $090350e1dc88de5d$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $090350e1dc88de5d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($090350e1dc88de5d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $090350e1dc88de5d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $090350e1dc88de5d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $090350e1dc88de5d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $090350e1dc88de5d$var$_extends() {
    return $090350e1dc88de5d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $090350e1dc88de5d$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $090350e1dc88de5d$var$Venue3313(props) {
    return /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("svg", $090350e1dc88de5d$var$_extends({
        id: "_x33_313",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "NYY"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        className: "st0",
        d: "M235.9,200.6l-9.1,0.5l-7.7-2.4l8-0.8L235.9,200.6z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        className: "st1",
        d: "M242.4,201.1c-0.9,8.5-8.5,14.7-17,13.9c-8.5-0.9-14.7-8.5-13.9-17c0.9-8.5,8.5-14.7,17-13.9 C237.1,185,243.3,192.6,242.4,201.1z M212.9,198.1c-0.8,7.8,4.9,14.8,12.7,15.5c7.8,0.8,14.8-4.9,15.5-12.7 c0.8-7.8-4.9-14.8-12.7-15.5C220.7,184.6,213.7,190.3,212.9,198.1z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        className: "st0",
        d: "M225.1,197.2c1.3-1,3.1-0.8,4.2,0.4c1,1.3,0.8,3.1-0.4,4.2c-1.3,1-3.1,0.8-4.2-0.4 C223.7,200.1,223.9,198.3,225.1,197.2z M217.7,199.8l-3.1-0.3V199l2.3-1.2l-2.1-0.2l0.1-0.5l3.1,0.3v0.5l-2.3,1.2l2.1,0.2 L217.7,199.8z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        className: "st2",
        d: "M226,198.2c0.7-0.6,1.7-0.5,2.3,0.2s0.5,1.7-0.2,2.3s-1.7,0.5-2.3-0.2C225.2,199.9,225.3,198.8,226,198.2z"
    })), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 220.1484 120.0078)",
        className: "st3 st4 st5"
    }, "314"), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 166.9551 52.3149)",
        className: "st3 st4 st5"
    }, "385"), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 130.6514 32.1792)",
        className: "st3 st4 st5"
    }, "408"), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 60.1245 45.5811)",
        className: "st3 st4 st5"
    }, "399"), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 10.3823 115.9326)",
        className: "st3 st4 st5"
    }, "318")), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M125.8,222.5c-13.4,0-22-10.9-22-10.9L79.4,182L69,168.9l-16.7-34.3l-18.5-17.2l-2.4-7.7 l0.1-3.3l0.4-3l0.5-3.1l0.6-3l0.9-2.7l1-2.8l1.1-2.6l1.3-2.5l1.3-2.5l1.7-2l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2 l2-2l2-2l2-2l2-2l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.2-2.2l2.3-2.1l2.5-1.5l2.5-1.5l2.6-1.5l2.6-1.6l2.6-1.6l2.6-1.6l2.8-0.9 l2.8-0.9l2.9-0.8l2.9-0.7l2.9-0.7l2.9-0.6l2.9-0.5l2.9-0.4h12l3,0.5l2.9,0.5l2.9,0.5l2.9,0.5l2.9,0.9l2.8,0.9l2.8,0.9l2.8,1.1 l2.6,1.9l2.6,1.9l2.5,1.8l2.5,1.8l2.5,1.8l2.4,1.7l2.3,2.2l2.2,2.2l2.2,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l1.9,1.9l1.9,1.9 l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7 l1.4,2.1l1.3,2l0.9,2.4l0.9,2.4l0.4,2.8l-0.7,4.3l-21.8,21.8l-24.5,43.3l-24.9,32.4C145.6,212.7,138.2,222.5,125.8,222.5 L125.8,222.5z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125.8,216.5c-9.2,0-15.7-7.8-15.8-7.9l-32.4-37.1L59,129.8l-18.1-16.9l-1.4-4.4V107l0.3-2.5 l0.4-2.8l0.5-2.3l1.6-4.7l0.9-2.1l3-3.9l0.9-1.1c0,0,26.1-27.6,30.8-31.7c12.6-11.3,34.8-12.8,34.8-12.8h10.6l8.2,1.3l2.3,0.4 l7.8,2.6l1.6,0.6L157,58l47,45.1l1.1,1.1c0,0,2.7,3.1,0,6.5s-11.9,14.7-11.9,14.7l-23.1,43.3l-32.5,42 C135.9,212.7,131.6,216.5,125.8,216.5z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st8",
        d: "M125.2,203.2l-97.1-97.1"
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st8",
        d: "M125.2,203.2l97.1-97.2"
    })), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $090350e1dc88de5d$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $090350e1dc88de5d$var$_default = module.exports["default"] = $090350e1dc88de5d$var$Venue3313;

});

parcelRegister("1mxmJ", function(module, exports) {
"use strict";
function $0fe1ba438fcde797$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0fe1ba438fcde797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0fe1ba438fcde797$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0fe1ba438fcde797$var$React = $0fe1ba438fcde797$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $0fe1ba438fcde797$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0fe1ba438fcde797$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0fe1ba438fcde797$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $0fe1ba438fcde797$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $0fe1ba438fcde797$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0fe1ba438fcde797$var$_extends() {
    return $0fe1ba438fcde797$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0fe1ba438fcde797$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $0fe1ba438fcde797$var$Venue4169(props) {
    return /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("svg", $0fe1ba438fcde797$var$_extends({
        id: "_x34_169",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "MIA"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        className: "st0",
        d: "M231.5,191.8l-3.1,8.6l-5.2,6.1l2.3-7.7L231.5,191.8z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        className: "st1",
        d: "M234.5,185.9c7.5,4.1,10.2,13.6,6.1,21.1c-4.1,7.5-13.6,10.2-21.1,6.1c-7.5-4.1-10.2-13.6-6.1-21.1 C217.6,184.5,227,181.8,234.5,185.9z M220.2,211.9c6.8,3.8,15.5,1.3,19.3-5.6c3.8-6.8,1.3-15.5-5.6-19.3 c-6.8-3.8-15.5-1.3-19.3,5.6C210.8,199.5,213.3,208.2,220.2,211.9z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        className: "st0",
        d: "M224.2,200.3c-0.5-1.6,0.5-3.2,2-3.7c1.6-0.5,3.2,0.5,3.7,2c0.5,1.6-0.5,3.2-2,3.7 C226.3,202.8,224.6,201.9,224.2,200.3z M223.6,208.2l-1.5,2.7l-0.4-0.2l-0.2-2.5l-1,1.9l-0.5-0.3l1.5-2.7l0.4,0.2l0.2,2.5l1-1.9 L223.6,208.2z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        className: "st2",
        d: "M225.4,200c-0.3-0.9,0.3-1.8,1.1-2c0.9-0.3,1.8,0.3,2,1.1c0.3,0.9-0.3,1.8-1.1,2 C226.6,201.4,225.7,200.9,225.4,200z"
    })), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 229.6678 112.2565)",
        className: "st3 st4 st5"
    }, "335"), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 164.8248 46.366)",
        className: "st3 st4 st5"
    }, "387"), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 89.7701 33.6937)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 53.6915 49.5938)",
        className: "st3 st4 st5"
    }, "382"), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 3.813 99.3971)",
        className: "st3 st4 st5"
    }, "344")), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "Outfield_00000079455967559065699190000006373183002832104345_",
        className: "st6",
        d: "M23.1,102.6l-2.1,3.2l87.1,105.6 c18.4,22.3,34.3-0.3,34.3-0.3l84.4-102.6l-3.1-3.9l-1.5-1.9l-1.5-1.9l-1.5-1.9l-1.6-2l-1.5-2l-1.6-2l-1.5-2l-1.6-2l-1.6-2l-1.6-2 l-1.6-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.8-2.2l-1.7-2.2l-1.8-2.3l-1.8-2.3l-1.8-2.3l-1.9-2.4l-1.9-2.5l-2.2-2l-2.5-1.3 l-2.5-1.3l-2.5-1.3l-2.5-1.3l-2.5-1.4l-2.5-1.2l-2.7-0.7l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.7L151,44l-2.7-0.7l-2.8-0.6 l-2.7-0.9l-2.7-1l-2.8-0.5l-2.8-0.4l-2.8-0.5l-2.8-0.6l-2.9-0.7l-2.9-0.7l-3-0.7l-2.9-0.2h-2.9h-2.9h-3h-2.9l-2.9,0.7l-2.6,2.3 l-2.6,2L94.1,43l-2.7,1.1l-2.7,0.8L86,45.6l-2.7,0.8l-2.7,1L78,48.5l-2.5,1.3L73,51.3l-2.5,1.5l-2.4,1.5l-2.4,1.6l-2.3,1.5 l-2.3,1.7L58.9,61l-2.2,1.8l-2.1,1.8l-2.2,1.7l-2.1,1.8l-2,2l-2,2L44.6,74l-1.9,2l-1.9,1.9L39,80l-1.7,2.2l-1.7,2.1L34,86.4 l-1.7,2l-1.5,2.2l-1.4,2.3L28,95.1l-1.4,2.3l-1.3,2.2l-1.3,2.2L23.1,102.6z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M125,214.2c-3.3,0-6.9-0.3-10.7-4.8l-83.5-102l6.5-10.3l1.3-1.9L45,87l1.5-1.8l9.1-9.4l1.8-1.5 l8.4-6.9l1.9-1.4l2.2-1.4l2.5-1.6l2.4-1.6l2.3-1.5l2.2-1.3l2-1.1l2.1-0.9l2.1-0.8l2.3-0.6l2.8-0.7l3.3-1l3.5-1.5l3.4-1.9l3.3-2.3 l3.3-3l0.9-1c0,0,6.3-1.4,11.2-0.2s47,11.6,47,11.6l6.1,2.6l2,1.4l4.4,4.6l1.5,1.6l9.1,11.5l26.1,32.8l0.8,1l-80.7,98.9 C134.5,211.4,129.9,214.2,125,214.2L125,214.2z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st8",
        d: "M125.2,203.2l-96.7-96.6l-4.8-4.7"
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st8",
        d: "M125.2,203.2l96.6-96.7l1.7-1.8"
    })), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $0fe1ba438fcde797$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $0fe1ba438fcde797$var$_default = module.exports["default"] = $0fe1ba438fcde797$var$Venue4169;

});

parcelRegister("7Wdld", function(module, exports) {
"use strict";
function $5c784c789bc4dc5e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5c784c789bc4dc5e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5c784c789bc4dc5e$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5c784c789bc4dc5e$var$React = $5c784c789bc4dc5e$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $5c784c789bc4dc5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5c784c789bc4dc5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5c784c789bc4dc5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $5c784c789bc4dc5e$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $5c784c789bc4dc5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5c784c789bc4dc5e$var$_extends() {
    return $5c784c789bc4dc5e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c784c789bc4dc5e$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $5c784c789bc4dc5e$var$Venue4705(props) {
    return /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("svg", $5c784c789bc4dc5e$var$_extends({
        id: "_x34_705",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "ATL"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        className: "st0",
        d: "M230.3,191.2l-1.8,9l-4.3,6.8l1.3-8L230.3,191.2z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        className: "st1",
        d: "M232.5,185c8,3,12.1,12,9.1,20s-12,12.1-20,9.1s-12.1-12-9.1-20S224.5,182,232.5,185z M222,212.8 c7.3,2.7,15.5-1,18.3-8.3c2.7-7.3-1-15.5-8.3-18.3c-7.3-2.7-15.5,1-18.3,8.3C211,201.9,214.7,210.1,222,212.8z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        className: "st0",
        d: "M224.3,200.7c-0.7-1.5,0-3.3,1.5-3.9c1.5-0.7,3.3,0,3.9,1.5c0.7,1.5,0,3.3-1.5,3.9 C226.8,202.9,225,202.2,224.3,200.7z M224.9,208.6l-1.1,2.9l-0.4-0.2l-0.6-2.5l-0.7,2l-0.5-0.2l1.1-2.9l0.4,0.2l0.6,2.5l0.7-2 L224.9,208.6z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        className: "st2",
        d: "M225.5,200.2c-0.4-0.8,0-1.8,0.8-2.2s1.8,0,2.2,0.8s0,1.8-0.8,2.2S225.9,201,225.5,200.2z"
    })), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "right",
        transform: "matrix(1 0 0 1 224.21 117.2139)",
        className: "st3 st4 st5"
    }, "325"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "right-center_1_",
        transform: "matrix(1 0 0 1 189.2979 64.1982)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "center",
        transform: "matrix(1 0 0 1 116.4307 33.9648)",
        className: "st3 st4 st5"
    }, "400"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "left-center_1_",
        transform: "matrix(1 0 0 1 45.6475 53.3066)",
        className: "st3 st4 st5"
    }, "385"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "left-left-center_1_",
        transform: "matrix(1 0 0 1 20.3818 71.5596)",
        className: "st3 st4 st5"
    }, "375"), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("text", {
        id: "left",
        transform: "matrix(1 0 0 1 4.083 114.4629)",
        className: "st3 st4 st5"
    }, "335")), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "Outfield_1_",
        className: "st6",
        d: "M222.4,111.8l-16.8,16.6c2.2,6.9,0.9,8.5-3.5,14.3c-5.8,7.2-59.8,72.7-59.8,72.7 s-15.9,20-33.6,1c0,0-61.2-72.7-63.9-77.1c-2.4-3.9-4.8-6.9-1.5-11.1l-19-18.4v-1l1.2-2.4l1-1.7l1.1-2.4l1.1-2.4l1.1-2.4l1.1-2.5 l1.2-2.5l1.2-2.6l1.2-2.6l1.2-2.7l1.2-2.7l1.3-2.8l1.3-2.8l1.3-2.9l1.3-2.9l2.1-1.8l2.3-1.6l2.3-1.6l2.3-1.6l2.3-1.6l2.3-1.6 l2.3-1.6l2.3-1.6l2.3-1.6l2.5-1.4l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.7-1.1l2.7-1.1l2.7-1.1 l2.7-1.1l2.7-1.1l2.7-1.1l2.8-1.1l2.8-1.2l2.9-0.4h29l2.9,0.3l2.8,1.4l2.7,1.4l2.7,1.4l2.7,1.4l2.6,1.4l2.6,1.4l2.6,1.3l2.6,1.3 l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.4,1.3l2.4,1.3l2.2,1.9l1.9,2.5l1.8,2.5l1.8,2.4l1.7,2.4l1.7,2.3l1.7,2.3 l1.7,2.3l1.6,2.2l1.6,2.2l1.6,2.2l1.6,2.1l1.6,2.1l1.5,2.1l1.5,2.1l1.5,2l1.5,2l1.5,2l1.5,2l1.4,2l1.4,1.9l1.4,1.9l1.4,1.9 l0.5,0.4l1.5,2L222.4,111.8L222.4,111.8z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "grass_1_",
        className: "st3",
        d: "M124.7,216.6c-3.3,0-6.6-1.9-10.1-5.5l-61-71.9c-1.1-1.9-4.4-4.7-4.1-8.6l1.2-4.6l-17-18 l14.9-32.7l0.5-0.4l17.6-12.2l1.7-0.9l41.2-17.1l1.3-0.2l28.2,0.2l1,0.1L179,65.1l0.8,0.7l32.8,44.5l-13.4,13.3l1.5,3.6 c1.4,4.4,0.6,9.3-2.2,13c-6.3,7.7-61.8,69.4-62.4,70.1C136.1,210.3,131.6,216.6,124.7,216.6L124.7,216.6z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-98.7-98.6"
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("path", {
        id: "right-foul-line_1_",
        className: "st8",
        d: "M125.2,203.2l95.5-95.5"
    })), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $5c784c789bc4dc5e$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))));
}
var $5c784c789bc4dc5e$var$_default = module.exports["default"] = $5c784c789bc4dc5e$var$Venue4705;

});

parcelRegister("4R04T", function(module, exports) {
"use strict";
function $388c2c22cb16148d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $388c2c22cb16148d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $388c2c22cb16148d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $388c2c22cb16148d$var$React = $388c2c22cb16148d$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $388c2c22cb16148d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($388c2c22cb16148d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $388c2c22cb16148d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $388c2c22cb16148d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $388c2c22cb16148d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $388c2c22cb16148d$var$_extends() {
    return $388c2c22cb16148d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $388c2c22cb16148d$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $388c2c22cb16148d$var$Venue5325(props) {
    return /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("svg", $388c2c22cb16148d$var$_extends({
        id: "_x35_325",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 250",
        style: {
            enableBackground: 'new 0 0 250 250'
        },
        xmlSpace: "preserve"
    }, props), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#68836A;}\n\t.st1{font-family:'ArialMT';}\n\t.st2{font-size:11px;}\n\t.st3{fill:#5B5B5B;}\n\t.st4{fill:#7F7F7F;}\n\t.st5{fill:#FFEC5F;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "TEX"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "right-field",
        transform: "matrix(1 0 0 1 224.0507 111.1338)",
        className: "st0 st1 st2"
    }, "326"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "_x37_",
        transform: "matrix(1 0 0 1 172.9463 50.3672)",
        className: "st0 st1 st2"
    }, "374"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "_x35_",
        transform: "matrix(1 0 0 1 147.9355 32.4043)",
        className: "st0 st1 st2"
    }, "410"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "_x35__1_",
        transform: "matrix(1 0 0 1 85 32.4043)",
        className: "st0 st1 st2"
    }, "410"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "center_1_",
        transform: "matrix(1 0 0 1 116.4678 31.4043)",
        className: "st0 st1 st2"
    }, "407"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "_x33_",
        transform: "matrix(1 0 0 1 50.5732 53.7129)",
        className: "st0 st1 st2"
    }, "372"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        id: "left-field",
        transform: "matrix(1 0 0 1 5.861 107.4464)",
        className: "st0 st1 st2"
    }, "329")), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st3",
        d: "M232.2,192.2l-3.9,8.3l-5.8,5.6l3.1-7.4L232.2,192.2z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st4",
        d: "M235.8,186.7c7,4.8,8.8,14.5,4,21.6s-14.5,8.8-21.6,4c-7-4.8-8.8-14.5-4-21.6 C219.1,183.7,228.7,181.9,235.8,186.7z M219,211.2c6.5,4.4,15.3,2.8,19.7-3.7c4.4-6.4,2.8-15.3-3.7-19.7 c-6.4-4.4-15.3-2.8-19.7,3.7C210.9,197.9,212.5,206.8,219,211.2z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st3",
        d: "M224.1,200.1c-0.3-1.6,0.8-3.2,2.4-3.5c1.6-0.3,3.2,0.8,3.5,2.4c0.3,1.6-0.8,3.2-2.4,3.5 C225.9,202.7,224.4,201.7,224.1,200.1z M222.8,207.8l-1.7,2.5l-0.4-0.3v-2.5l-1.2,1.8L219,209l1.7-2.5l0.4,0.3v2.6l1.2-1.8 L222.8,207.8z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st5",
        d: "M225.4,199.8c-0.2-0.9,0.4-1.8,1.3-1.9s1.8,0.4,1.9,1.3c0.2,0.9-0.4,1.8-1.3,1.9 C226.4,201.3,225.6,200.7,225.4,199.8z"
    })), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "outfield_00000176019447424471975020000015478149771427856801_",
        className: "st6",
        d: "M27.8,110L56,138.6l6.9,22.9l8.5,12.1 l33.5,41.2c0,0,9.6,5.8,10.2,6s6.6,0.1,10.2,0.1c3,0,9.1,0.2,9.8,0s8.9-5.1,9.4-5.8c17.6-20.9,30.5-37.4,30.5-37.4l22.3-29.5 l3.9-14l-0.2-3.5l17.3-17.7l1.6-2l-0.2-2.5l-0.5-2.8l-0.6-2.9l-0.5-2.9l-0.6-3l-0.6-3.1l-1.1-2.6l-1.8-1.8l-1.8-1.8l-1.8-1.8 l-1.8-1.8l-1.8-1.8l-1.8-1.9l-1.9-1.8l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.4-3l-2-2l-2-2l-2-2l-2-2l-2.1-2.1l-2.1-2.1 l-2.8-0.4l-3.1,0.5l-2.7-0.4l-2.2-2.2l-2.2-2.2l-2.2-2.2l-2.3-2.3l-2.4-2.4l-2.4-2.4l-2.5-2.5l-2.5-2.5l-2.5-2.6l-3-0.2h-3h-3h-3 h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3l-2.8,1.4l-2.7,1.6l-2.7,1.6L93.5,40l-2.7,1.5L88.3,43l-2.6,1.5L83.1,46l-2.5,1.5L78.1,49 l-1.8,3.5l-2.2,2.3L71.7,56l-2.4,1.4l-2.4,1.4l-2.4,1.4l-2.4,1.3l-2.4,1.4l-2.3,1.3l-2.3,1.4l-2.3,1.3l-2.3,1.3l-2.3,1.4l-2.3,1.3 l-2.3,1.3l-2.3,1.3L38.8,75l-2.3,1.3l-2.3,1.5l-0.7,3.5l-0.7,3.5l-0.6,3.4l-0.7,3.2l-0.6,3.2l-0.6,3.1l-0.6,3l-0.6,2.9l-0.6,2.8 L27.8,110z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "grass_00000090994939672626314830000016650827298536189595_",
        className: "st0",
        d: "M148.4,39.7l22.9,22.6l6.4-1.9l11.5,11.3 l0.3,1.5l4.7,5.1l17.1,16.1l2.4,14.4l-20,19.7l1.7,4.4c0,0-2.5,10.7-3.4,12.2s-7.2,8.7-8.1,10.1c0,0-13,17.5-15.7,20.8 c-2.7,3.2-11.6,15.6-13.4,17.6s-7.8,10.2-9.3,12.1s-9.1,8-11.9,9c-1.4,0.5-4.8,0.3-8.3,0.4c-3.5,0-7.1,0.3-8.7-0.4 c-3.2-1.3-7.5-3.8-11.7-9.1c0,0-10.4-13.2-14.5-18.8s-4.2-5.5-4.2-5.5s-15.3-19.2-18-22.5c-2.7-3.2-4.3-13-5.2-15.9 s-0.2-5.6-3.6-9.3C56,129.9,33.8,108,33.8,108s3-16.7,3.3-18s1.8-8.3,1.8-8.3l41.4-24.2l1.2-4.5l23.4-13.5h43.5V39.7z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "infield_sand",
        className: "st6",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
    })), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "persistent_1_"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "mound_1_"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "pitching-mound_1_",
        className: "st6",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "pitching-rubber_1_",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4V176.6z"
    })), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "lines_1_"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "left-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l-97-97"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "right-foul-line_2_",
        className: "st8",
        d: "M125.2,203.2l94.4-94.5"
    })), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "bases_2_"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("rect", {
        id: "third-base_2_",
        x: 99.2,
        y: 175.1,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("rect", {
        id: "first-base_2_",
        x: 148.1,
        y: 175.2,
        transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)",
        className: "st9",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("rect", {
        id: "second-base_2_",
        x: 123.7,
        y: 148.6,
        transform: "matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)",
        className: "st10",
        width: 3,
        height: 3
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("polygon", {
        id: "home_2_",
        className: "st7",
        points: "126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
    })))), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "grid",
        className: "st11"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        className: "st12"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)",
        className: "st1 st13"
    }, "90"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)",
        className: "st1 st13"
    }, "200"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)",
        className: "st1 st13"
    }, "150"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)",
        className: "st1 st13"
    }, "120"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)",
        className: "st1 st13"
    }, "250"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)",
        className: "st1 st13"
    }, "300"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)",
        className: "st1 st13"
    }, "350"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)",
        className: "st1 st13"
    }, "400"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)",
        className: "st1 st13"
    }, "450"), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("text", {
        transform: "matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)",
        className: "st1 st13"
    }, "500")), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("g", {
        id: "surface29_2_"
    }, /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st14",
        d: "M125.5,203.8l-148-148"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st14",
        d: "M124.8,203.8l148-148"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        className: "st15",
        d: "M125.1,203.5l79.8-192.6"
    })), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st14",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x32_00-line_2_",
        className: "st14",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x39_0-line_2_",
        className: "st14",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st14",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st14",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st14",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st14",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st14",
        d: "M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x34_00-line_1_",
        className: "st14",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $388c2c22cb16148d$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st14",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
    }))));
}
var $388c2c22cb16148d$var$_default = module.exports["default"] = $388c2c22cb16148d$var$Venue5325;

});

parcelRegister("5JKL4", function(module, exports) {
"use strict";
function $42d56ced39999aaa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $42d56ced39999aaa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $42d56ced39999aaa$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $42d56ced39999aaa$var$React = $42d56ced39999aaa$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $42d56ced39999aaa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($42d56ced39999aaa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $42d56ced39999aaa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $42d56ced39999aaa$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $42d56ced39999aaa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $42d56ced39999aaa$var$_extends() {
    return $42d56ced39999aaa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42d56ced39999aaa$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $42d56ced39999aaa$var$Venue5355(props) {
    return /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("svg", $42d56ced39999aaa$var$_extends({
        id: "_x35_355",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("defs", null, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st4, .st5, .st6 {\n        isolation: isolate;\n      }\n\n      .st7, .st2 {\n        stroke-width: .75px;\n      }\n\n      .st7, .st2, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st5, .st6 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st6 {\n        font-size: 5px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "_x35_3551",
        "data-name": "_x35_355"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st3",
        d: "M232.8,206.4l-7.1-5.9-3.9-7,6.4,4.9,4.6,8Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st13",
        d: "M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5-5.6-6.4-4.9-16.3,1.5-21.9,6.4-5.6,16.3-4.9,21.9,1.5,5.6,6.5,5,16.3-1.5,21.9ZM217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20s14.1,6.5,20,1.4,6.5-14.1,1.4-20-14.1-6.5-20-1.4Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st3",
        d: "M227.2,196.6c1.6.1,2.9,1.5,2.8,3.2-.1,1.6-1.5,2.9-3.2,2.8-1.6-.1-2.9-1.5-2.8-3.2.2-1.7,1.6-3,3.2-2.8ZM220,193.3l-2-2.3.4-.3,2.5.7-1.4-1.6.4-.3,2,2.3-.4.3-2.5-.7,1.4,1.6-.4.3Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st11",
        d: "M227.1,197.9c.9.1,1.6.9,1.5,1.8-.1.9-.9,1.6-1.8,1.5-.9-.1-1.6-.9-1.5-1.8.1-.9.9-1.6,1.8-1.5Z"
    })), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "right",
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st5",
        transform: "translate(224.91 93.99)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "340"))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "right-center",
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st5",
        transform: "translate(183.69 55.53)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380"))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "center",
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st5",
        transform: "translate(112.27 27.24)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "415"))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "left-center",
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st5",
        transform: "translate(47.79 55.53)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380"))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "left",
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st5",
        transform: "translate(9.19 93.98)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "340")))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "Outfield",
        className: "st12",
        d: "M205.8,125l1.55,4.8-16.75,29.5-47.16,52.13s-7.71,10.7-18.64,10.7-18.53-12.25-18.53-12.25l-26.75-29.7-19.15-20.88-17.08-29.5,1.31-5.16-19.78-21.97,1.76-1.75,1.78-1.73,1.76-1.75,1.76-1.76,1.76-1.76,1.77-1.77,1.77-1.77,1.78-1.78,1.79-1.79,1.8-1.8,1.81-1.81,1.82-1.82,1.84-1.84,1.85-1.85,1.87-1.87,1.89-1.89,1.9-1.9,1.93-1.93,1.95-1.95,1.97-1.97,2-2,2.02-2.02,2.05-2.05,2.08-2.08,2.12-2.12,2.15-2.15,2.19-2.19,2.22-2.23,2.27-2.27,2.31-2.32,2.36-2.36,2.41-2.42,2.68-1.46,2.86-.66,2.87-.66,2.87-.66,2.88-.66,2.89-.67,2.9-.67,2.91-.67,2.92-.67,2.94-.68,2.96-.68,2.98-.69,3-.68,3,.72,2.94,1.7,2.89,1.67,2.84,1.64,2.79,1.61,2.74,1.59,2.7,1.56,2.66,1.54,2.62,1.52,2.59,1.5,2.56,1.48,2.63.95,2.94-.44,2.98-.45,3.03-.45,2.56,1.31,2.26,2.24,2.22,2.2,2.18,2.17,2.14,2.14,2.1,2.11,2.07,2.07,2.04,2.04,2.01,2.01,1.99,1.99,1.96,1.96,1.94,1.94,1.91,1.92,1.89,1.9,1.88,1.88,1.86,1.86,1.84,1.84,1.83,1.83,1.81,1.82,1.8,1.8,1.79,1.79,1.78,1.78,1.77,1.77,1.76,1.77,1.76,1.76,1.75,1.75,1.75,1.75,1.75,1.74,1.77,1.72,1.75,1.74-19.23,21.79h-.02Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M198.8,121.61s11.44-12.04,12.42-13.3,1.48-5.57-.77-7.71-25.76-25.65-27.8-27.84-16.4-16.56-16.4-16.56l-8.75.84-32.28-17.22-31.47,7.39s-53.78,53.36-55.04,54.55-1.41,6.34-.42,7.46,13.23,13.94,13.23,13.94l-1.87,4.76s14.62,25.93,15.46,27.33,26.54,29.14,29.56,32.59,17.67,20.2,19.92,22.17,6.3,5.63,10.22,5.63,7.51-1.2,9.98-4.08,50.05-54.83,51.03-55.89,15.13-27.03,15.13-27.03l-2.14-7.04h0Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    })), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st2",
        d: "M125.2,203.2L24.75,102.75"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st2",
        d: "M125.2,203.2l99.86-99.96"
    })), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("rect", {
        id: "third-base",
        className: "st9",
        x: 99.2,
        y: 175.12,
        width: 3,
        height: 3,
        transform: "translate(-95.38 122.87) rotate(-44.98)"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("rect", {
        id: "first-base",
        className: "st9",
        x: 148.11,
        y: 175.21,
        width: 3,
        height: 3,
        transform: "translate(-81.13 157.47) rotate(-44.98)"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("rect", {
        id: "second-base",
        className: "st8",
        x: 123.71,
        y: 148.62,
        width: 3,
        height: 3,
        transform: "translate(-69.48 132.54) rotate(-45.01)"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("polygon", {
        id: "home",
        className: "st7",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", null, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(91.08 184.02) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(56.58 153.72) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(71.08 168.32) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(80.48 177.62) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(41.68 138.92) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(27.58 123.92) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(12.78 109.12) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 75.82) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 49.32) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450"))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 24.52) rotate(-44.2)"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500")))))))))), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $42d56ced39999aaa$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    }))));
}
var $42d56ced39999aaa$var$_default = module.exports["default"] = $42d56ced39999aaa$var$Venue5355;

});

parcelRegister("gVDVH", function(module, exports) {
"use strict";
function $c530f16aa9acad45$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c530f16aa9acad45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c530f16aa9acad45$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c530f16aa9acad45$var$React = $c530f16aa9acad45$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $c530f16aa9acad45$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c530f16aa9acad45$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c530f16aa9acad45$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $c530f16aa9acad45$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c530f16aa9acad45$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c530f16aa9acad45$var$_extends() {
    return $c530f16aa9acad45$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c530f16aa9acad45$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $c530f16aa9acad45$var$Venue5445(props) {
    return /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("svg", $c530f16aa9acad45$var$_extends({
        id: "_x35_445",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("defs", null, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st4, .st5, .st6 {\n        isolation: isolate;\n      }\n\n      .st7, .st2 {\n        stroke-width: .75px;\n      }\n\n      .st7, .st2, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st5, .st6 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st6 {\n        font-size: 5px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "_x35_4451",
        "data-name": "_x35_445"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st3",
        d: "M232.8,206.4l-7.1-5.9-3.9-7,6.4,4.9,4.6,8Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st13",
        d: "M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5-5.6-6.4-4.9-16.3,1.5-21.9,6.4-5.6,16.3-4.9,21.9,1.5,5.6,6.5,5,16.3-1.5,21.9ZM217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20s14.1,6.5,20,1.4,6.5-14.1,1.4-20-14.1-6.5-20-1.4Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st3",
        d: "M227.2,196.6c1.6.1,2.9,1.5,2.8,3.2-.1,1.6-1.5,2.9-3.2,2.8-1.6-.1-2.9-1.5-2.8-3.2.2-1.7,1.6-3,3.2-2.8ZM220,193.3l-2-2.3.4-.3,2.5.7-1.4-1.6.4-.3,2,2.3-.4.3-2.5-.7,1.4,1.6-.4.3Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st11",
        d: "M227.1,197.9c.9.1,1.6.9,1.5,1.8-.1.9-.9,1.6-1.8,1.5-.9-.1-1.6-.9-1.5-1.8.1-.9.9-1.6,1.8-1.5Z"
    })), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "right",
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st5",
        transform: "translate(224.91 97.99)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "335")))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "right-center",
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st5",
        transform: "translate(183.69 58.53)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380")))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "center",
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st5",
        transform: "translate(112.27 32.24)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "left-center",
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st5",
        transform: "translate(47.79 58.53)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "380")))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "left",
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st5",
        transform: "translate(9.19 97.98)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "335"))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "Outfield",
        className: "st12",
        d: "M26.6,104.44l1.7-1.74,1.7-1.75,1.7-1.75,1.71-1.75,1.71-1.76,1.72-1.76,1.73-1.77,1.73-1.78,1.74-1.79,1.75-1.8,1.77-1.81,1.78-1.83,1.79-1.84,1.81-1.86,1.82-1.87,1.84-1.89,1.86-1.91,1.88-1.93,1.91-1.96,1.93-1.98,1.95-2.01,1.98-2.04,2.01-2.07,2.04-2.1,2.08-2.13,2.11-2.17,2.15-2.21,2.19-2.25,2.23-2.29,2.28-2.34,2.32-2.39,2.37-2.44,2.43-2.49,2.5-2.46h3.01s2.99,0,2.99,0h2.97s2.96,0,2.96,0h2.94s2.93,0,2.93,0h2.92s2.92,0,2.92,0h2.91s2.91,0,2.91,0h2.91s2.91,0,2.91,0h2.91s2.91,0,2.91,0h2.92s2.92,0,2.92,0h2.93s2.94,0,2.94,0h2.96s2.97,0,2.97,0h2.99s3.01,0,3.01,0l2.5,2.46,2.43,2.49,2.37,2.44,2.32,2.39,2.28,2.34,2.23,2.29,2.19,2.25,2.15,2.21,2.11,2.17,2.08,2.13,2.04,2.1,2.01,2.07,1.98,2.04,1.95,2.01,1.93,1.98,1.91,1.96,1.88,1.93,1.86,1.91,1.84,1.89,1.82,1.87,1.81,1.86,1.79,1.84,1.78,1.83,1.77,1.81,1.75,1.8,1.74,1.79,1.73,1.78,1.73,1.77,1.72,1.76,1.71,1.76,1.71,1.75,1.7,1.75,1.7,1.75,1.7,1.74,3.19,4.08-28.51,27.45-16.4,25.9-5.77,8.87-7.53,11.33.49.77-2.18,4.79-23.72,22.81-9.36,9.22h-19.71l-32.66-31.32-10.28-17.1-23.23-35.69-26.75-25.62,5.22-5.49Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M57.37,139.02s10.33,15.96,11.17,17.36,13.59,24.49,16.61,27.94,26.57,25.6,28.82,27.57,7.11,2.06,11.03,2.06,7.32.47,9.79-2.41c.69-.81,25.61-26.22,25.61-26.22,0,0,19.78-29.88,20.48-30.64.98-1.06,11.97-20.63,11.97-20.63l22.74-23.93s-29.86-32.75-31.9-34.94-30.02-29.28-30.02-29.28l-2.06-.75-56.83.98L31.09,112.37l24.03,23.28,2.25,3.38Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    })), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "pitching-rubber",
        className: "st7",
        d: "M123.2,176.6h4v1.6h-4v-1.6Z"
    })), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "left-foul-line",
        className: "st2",
        d: "M125.2,203.2L24.75,102.75"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "right-foul-line",
        className: "st2",
        d: "M125.2,203.2l99.86-99.96"
    })), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("rect", {
        id: "third-base",
        className: "st9",
        x: 99.2,
        y: 175.12,
        width: 3,
        height: 3,
        transform: "translate(-95.38 122.87) rotate(-44.98)"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("rect", {
        id: "first-base",
        className: "st9",
        x: 148.11,
        y: 175.21,
        width: 3,
        height: 3,
        transform: "translate(-81.13 157.47) rotate(-44.98)"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("rect", {
        id: "second-base",
        className: "st8",
        x: 123.71,
        y: 148.62,
        width: 3,
        height: 3,
        transform: "translate(-69.48 132.54) rotate(-45.01)"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("polygon", {
        id: "home",
        className: "st7",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", null, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(91.08 184.02) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(56.58 153.72) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(71.08 168.32) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(80.48 177.62) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(41.68 138.92) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(27.58 123.92) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(12.78 109.12) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 75.82) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 49.32) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450")))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        className: "st4"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("text", {
        className: "st6",
        transform: "translate(15.08 24.52) rotate(-44.2)"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500"))))))))))), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $c530f16aa9acad45$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    }))));
}
var $c530f16aa9acad45$var$_default = module.exports["default"] = $c530f16aa9acad45$var$Venue5445;

});

parcelRegister("24Q5R", function(module, exports) {
"use strict";
function $18345d2a032f5769$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $18345d2a032f5769$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $18345d2a032f5769$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $18345d2a032f5769$var$React = $18345d2a032f5769$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $18345d2a032f5769$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($18345d2a032f5769$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $18345d2a032f5769$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $18345d2a032f5769$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $18345d2a032f5769$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $18345d2a032f5769$var$_extends() {
    return $18345d2a032f5769$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $18345d2a032f5769$var$_extends.apply(null, arguments);
} // FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */ function $18345d2a032f5769$var$Venue6130(props) {
    return /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("svg", $18345d2a032f5769$var$_extends({
        id: "_x36_130",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 250 250"
    }, props), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("defs", null, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("style", null, '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st5, .st6 {\n        stroke: #fff;\n      }\n\n      .st4, .st5, .st6 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st7, .st8, .st9 {\n        isolation: isolate;\n      }\n\n      .st10, .st8 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st8 {\n        font-size: 11px;\n      }\n\n      .st8, .st9 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st9 {\n        font-size: 5px;\n      }\n\n      .st5 {\n        stroke-width: .8px;\n      }\n\n      .st5, .st6 {\n        stroke-miterlimit: 4;\n      }\n\n      .st6 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    ')), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "Speedway"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "Speedway1",
        "data-name": "Speedway"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "compass"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("polygon", {
        className: "st3",
        points: "231.9 207 225.6 200.3 222.6 192.9 228.3 198.5 231.9 207"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st13",
        d: "M235.7,212.4c-7.1,4.8-16.7,2.9-21.5-4.2-4.8-7.1-2.9-16.7,4.2-21.5,7.1-4.8,16.7-2.9,21.5,4.2,4.8,7.1,2.9,16.7-4.2,21.5ZM219.1,187.7c-6.5,4.4-8.2,13.2-3.8,19.7s13.2,8.2,19.7,3.8,8.2-13.2,3.8-19.7c-4.4-6.4-13.2-8.1-19.7-3.8Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st3",
        d: "M227.6,196.6c1.6.3,2.7,1.9,2.3,3.5-.3,1.6-1.9,2.7-3.5,2.3-1.6-.3-2.7-1.9-2.3-3.5.3-1.6,1.9-2.6,3.5-2.3Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st3",
        d: "M220.8,192.5l-1.7-2.6.4-.3,2.4,1h0l-1.2-1.8.4-.3,1.7,2.6-.4.3-2.4-1h0l1.2,1.8-.4.3Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st11",
        d: "M227.3,197.9c.9.2,1.5,1,1.3,1.9s-1,1.5-1.9,1.3-1.5-1-1.3-1.9,1-1.5,1.9-1.3Z"
    })), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "field"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "warning_track",
        className: "st12",
        d: "M225.8,109.8s-92.3,113.7-93.5,114.3-13.6.6-14.7,0S25.2,110.5,25.2,110.5l1.4-3,1.5-1.6,1.3-2.1,1.3-2.1,1.3-2.1,1.3-2.2,1.4-2.2,1.4-2.2,1.4-2.2,1.4-2.3,1.4-2.3,1.4-2.3,1.5-2.4,1.5-2.4,1.5-2.4,1.5-2.5,1.6-2.5,1.6-2.6,1.6-2.6,1.7-2.7,1.8-2.6,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.6-1.5,2.6-1.5,2.6-1.5,2.6-1.5,2.7-1.5,2.7-1.5,2.9-.3h3s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s3,0,3,0h3c0,0,2.6,2.2,2.6,2.2l2.6,2.1,2.5,2,2.5,2,2.4,2,2.4,1.9,2.4,1.9,2.3,1.9,2.3,1.8,2.3,1.8,2.2,1.8,2.2,1.8,2.2,1.7,2.2,1.7,2.1,1.7,2.1,1.7,2,1.8,1.8,2.2,1.8,2.2,1.8,2.1,1.7,2.1,1.7,2.1,1.7,2,1.7,2,1.7,2,1.6,2,1.6,2,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.5,1.9,1.5,1.9,3.5,3.9Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "grass",
        className: "st10",
        d: "M120.5,217.3l8.5.6,33.8-41.3,53-64.2-31.9-37.7-34.2-27.2-49.2.3-40,22.9-26.1,41.7,86,105Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "infield_sand",
        className: "st12",
        d: "M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "distances"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "right",
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st8",
        transform: "translate(227 115.9)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "330"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "right-center",
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st8",
        transform: "translate(192.6 66.1)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "375"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "center",
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st8",
        transform: "translate(113.2 33.8)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "left",
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st8",
        transform: "translate(32.3 62.9)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "385"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "left1",
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st8",
        transform: "translate(8.7 103.4)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "330"))))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "persistent"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "mound"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "pitching-mound",
        className: "st12",
        d: "M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("rect", {
        id: "pitching-rubber",
        className: "st4",
        x: 123.2,
        y: 176.6,
        width: 4,
        height: 1.6
    })), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "lines"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("line", {
        id: "left-foul-line",
        className: "st2",
        x1: 125.2,
        y1: 203.2,
        x2: 27,
        y2: 105.1
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("line", {
        id: "right-foul-line",
        className: "st2",
        x1: 125.2,
        y1: 203.2,
        x2: 222.8,
        y2: 105.5
    })), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "bases"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("rect", {
        id: "third-base",
        className: "st6",
        x: 99.2,
        y: 175.1,
        width: 3,
        height: 3,
        transform: "translate(-95.4 122.9) rotate(-45)"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("rect", {
        id: "first-base",
        className: "st6",
        x: 148.1,
        y: 175.2,
        width: 3,
        height: 3,
        transform: "translate(-81.1 157.5) rotate(-45)"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("rect", {
        id: "second-base",
        className: "st5",
        x: 123.7,
        y: 148.6,
        width: 3,
        height: 3,
        transform: "translate(-69.5 132.5) rotate(-45)"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("polygon", {
        id: "home",
        className: "st4",
        points: "126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
    })))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "grid",
        className: "st14"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", null, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "numbers"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(91 184.1) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "90"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(56.5 153.8) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "200"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(71 168.4) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "150"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(80.4 177.7) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "120"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(41.6 139) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "250"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(27.5 124) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "300"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(12.7 109.2) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "350"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 75.9) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "400"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 49.4) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "450"))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        className: "st7"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("text", {
        className: "st9",
        transform: "translate(15 24.6) rotate(-44.2)"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("tspan", {
        x: 0,
        y: 0
    }, "500")))))))), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("g", {
        id: "surface29"
    }, /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st1",
        d: "M125.5,203.8L-22.5,55.8"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st1",
        d: "M124.8,203.8L272.8,55.8"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L45.4,10.9"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5V-4.9"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        className: "st0",
        d: "M125.1,203.5L204.9,10.9"
    })), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x31_00-line",
        className: "st1",
        d: "M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x32_00-line",
        className: "st1",
        d: "M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x39_0-line",
        className: "st1",
        d: "M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x31_20-line",
        className: "st1",
        d: "M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x32_50-line",
        className: "st1",
        d: "M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x33_00-line",
        className: "st1",
        d: "M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x33_50-line",
        className: "st1",
        d: "M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x34_50-line",
        className: "st1",
        d: "M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x34_00-line",
        className: "st1",
        d: "M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
    }), /*#__PURE__*/ $18345d2a032f5769$var$React.createElement("path", {
        id: "_x35_00-line",
        className: "st1",
        d: "M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
    })))));
}
var $18345d2a032f5769$var$_default = module.exports["default"] = $18345d2a032f5769$var$Venue6130;

});



parcelRegister("faaIi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b0a019ab2515d207$var$Spray;

var $b0a019ab2515d207$var$_react = $b0a019ab2515d207$var$_interopRequireDefault((parcelRequire("J42oT")));

var $b0a019ab2515d207$var$_CalculateHitLocation = $b0a019ab2515d207$var$_interopRequireDefault((parcelRequire("4hAZJ")));

var $b0a019ab2515d207$var$_ColorMap = $b0a019ab2515d207$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $b0a019ab2515d207$var$_Legend = $b0a019ab2515d207$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $b0a019ab2515d207$var$_Tooltip = $b0a019ab2515d207$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $3wgDt = parcelRequire("3wgDt");
function $b0a019ab2515d207$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $b0a019ab2515d207$var$Spray(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    // Remove null spray
    var sprayData = settings.data;
    // Set data to property in data set
    if (chartOptions.linkedDataProperty) sprayData = settings.data[chartOptions.linkedDataProperty];
    function handleMouseOver(event, tip) {
        debugger;
        (0, $b0a019ab2515d207$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $b0a019ab2515d207$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    return /*#__PURE__*/ $b0a019ab2515d207$var$_react["default"].createElement($b0a019ab2515d207$var$_react["default"].Fragment, null, /*#__PURE__*/ $b0a019ab2515d207$var$_react["default"].createElement("g", {
        id: "sprayChart"
    }, sprayData.map(function(d, i) {
        var coords = {
            x: d.x,
            y: d.y
        };
        return /*#__PURE__*/ $b0a019ab2515d207$var$_react["default"].createElement("circle", {
            id: "sprayChart_".concat(d.id || i),
            key: "pitch_".concat(i),
            cx: (0, $b0a019ab2515d207$var$_CalculateHitLocation["default"])(coords, settings.vizWidth, settings.vizHeight).x,
            cy: (0, $b0a019ab2515d207$var$_CalculateHitLocation["default"])(coords, settings.vizWidth, settings.vizHeight).y,
            r: chartOptions.radius || 4 / settings.vizScale,
            fill: chartOptions.color || (0, $b0a019ab2515d207$var$_ColorMap["default"])(chartOptions.legendType, d[chartOptions.legendType]),
            opacity: chartOptions.opacity || 1,
            stroke: "black",
            style: {
                cursor: d.videoUrl ? 'pointer' : 'default'
            },
            onMouseOver: function onMouseOver(event) {
                var html = d.tooltip;
                if (html) handleMouseOver(event, html);
            },
            onMouseOut: function onMouseOut(event) {
                var html = d.tooltip;
                if (html) handleMouseOut(event, d);
            },
            onClick: function onClick() {
                if (d.videoUrl) window.open(d.videoUrl);
            }
        });
    })), chartOptions.legend ? /*#__PURE__*/ $b0a019ab2515d207$var$_react["default"].createElement($b0a019ab2515d207$var$_Legend["default"], {
        settings: settings,
        type: chartOptions.legendType
    }) : null);
}

});
parcelRegister("4hAZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $31e5724e167b1a96$var$CalculateHitLocation;
function $31e5724e167b1a96$var$CalculateHitLocation(fieldCoords, imageWidth, imageHeight) {
    var percentChange = imageWidth / 500;
    var PLOT_LOCATION_MAP = {
        imageWidth: 500 * percentChange,
        imageHeight: 500 * percentChange,
        ft410y: 58 * percentChange,
        home: {
            x: 252 * percentChange,
            y: 409 * percentChange
        },
        radius_small: 7 * percentChange,
        radius_big: 20 * percentChange
    };
    var x = fieldCoords.x;
    var y = fieldCoords.y;
    var direction = parseFloat(null);
    var distance = parseFloat(null);
    var ft410y = PLOT_LOCATION_MAP.home.y - PLOT_LOCATION_MAP.ft410y;
    var hitXFromOrigin;
    var hitYFromOrigin;
    if ((x || x === 0) && (y || y === 0)) {
        hitXFromOrigin = ft410y / 410 * parseFloat(x);
        hitYFromOrigin = ft410y / 410 * parseFloat(y);
    } else {
        var normalizedDistance = ft410y / 410 * distance;
        normalizedDistance *= imageWidth / PLOT_LOCATION_MAP.imageWidth;
        hitXFromOrigin = normalizedDistance * Math.sin(direction * 0.0174532925);
        hitYFromOrigin = normalizedDistance * Math.cos(direction * 0.0174532925);
    }
    var hitX = PLOT_LOCATION_MAP.home.x + hitXFromOrigin;
    var hitY = PLOT_LOCATION_MAP.home.y - hitYFromOrigin;
    if (hitY < 15) hitY = 15;
    else if (hitY > imageHeight - 15) hitY = imageHeight - 15;
    if (hitX < 15) hitX = 15;
    else if (hitX > imageWidth - 15) hitX = imageWidth - 15;
    return {
        x: hitX,
        y: hitY
    };
}

});


parcelRegister("UOQ6x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0aacaab8dd0e68bd$var$Boxes;

var $0aacaab8dd0e68bd$var$_react = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $esw4H = parcelRequire("esw4H");

var $0aacaab8dd0e68bd$var$_groupBy = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $0aacaab8dd0e68bd$var$_sumBy = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("4NG48")));

var $0aacaab8dd0e68bd$var$_CalculateHitLocation3 = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("4hAZJ")));

var $0aacaab8dd0e68bd$var$_ColorMap = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $0aacaab8dd0e68bd$var$_BoxLegend = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("88q9M")));

var $0aacaab8dd0e68bd$var$_Tooltip = $0aacaab8dd0e68bd$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $3wgDt = parcelRequire("3wgDt");
function $0aacaab8dd0e68bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $0aacaab8dd0e68bd$var$Boxes(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    // Remove null spray
    var sprayData = settings.data;
    // Set data to property in data set
    if (chartOptions.linkedDataProperty) sprayData = settings.data[chartOptions.linkedDataProperty];
    if (!chartOptions.isGrouped) {
        sprayData.map(function(d) {
            d.xyGroup = "".concat(Number(d.x)).concat(Number(d.y));
        });
        var groupData = (0, $0aacaab8dd0e68bd$var$_groupBy["default"])(sprayData, function(d) {
            return d.xyGroup;
        });
        sprayData = [];
        for(var group in groupData){
            var g = groupData[group];
            sprayData.push({
                value: Number(_.sumBy(g, function(d) {
                    return Number(d[chartOptions.sumColumn]);
                })),
                n: g.length,
                x: g[0].x,
                y: g[0].y
            });
        }
    }
    var colorBox = (0, $csdlO.default)().domain(chartOptions.domain || [
        -5,
        0,
        5
    ]).range([
        '#3661AD',
        '#ffffff',
        '#D82129'
    ]);
    var maxN = (0, $esw4H.default)(sprayData, function(d) {
        return Number(d.n);
    });
    var size = (0, $csdlO.default)().domain([
        1,
        maxN
    ]).range([
        settings.vizWidth * 0.006,
        settings.vizWidth * 0.022
    ]);
    function handleMouseOver(event, tip) {
        (0, $0aacaab8dd0e68bd$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $0aacaab8dd0e68bd$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    function calculateX(coords, d) {
        var _CalculateHitLocation = (0, $0aacaab8dd0e68bd$var$_CalculateHitLocation3["default"])(coords, settings.vizWidth, settings.vizHeight), x = _CalculateHitLocation.x;
        var w = size(Number(d.n)) / 2;
        x += size(Number(maxN)) / 2 - w;
        return x;
    }
    function calculateY(coords, d) {
        var _CalculateHitLocation2 = (0, $0aacaab8dd0e68bd$var$_CalculateHitLocation3["default"])(coords, settings.vizWidth, settings.vizHeight), y = _CalculateHitLocation2.y;
        var w = size(Number(d.n)) / 2;
        y += size(Number(maxN)) / 2 - w;
        return y;
    }
    return /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement($0aacaab8dd0e68bd$var$_react["default"].Fragment, null, /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement("g", {
        id: "sprayRectanglesChart"
    }, sprayData.map(function(d, i) {
        var coords = {
            x: d.x,
            y: d.y
        };
        return /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement($0aacaab8dd0e68bd$var$_react["default"].Fragment, null, chartOptions.hideOuterRectangle ? null : /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement("rect", {
            id: "rectOuter_".concat(d.id || i),
            key: "outer_".concat(i),
            x: (0, $0aacaab8dd0e68bd$var$_CalculateHitLocation3["default"])(coords, settings.vizWidth, settings.vizHeight).x,
            y: (0, $0aacaab8dd0e68bd$var$_CalculateHitLocation3["default"])(coords, settings.vizWidth, settings.vizHeight).y,
            width: settings.vizWidth * 0.022,
            height: settings.vizWidth * 0.022,
            fill: chartOptions.backgroundOuterFill || 'none',
            opacity: chartOptions.outerOpacity || 1,
            stroke: chartOptions.outerStrokeColor || '#f5f5f5',
            style: {
                cursor: 'pointer'
            }
        }), /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement("rect", {
            id: "rectInner_".concat(d.id || i),
            key: "inner_".concat(i),
            x: calculateX(coords, d),
            y: calculateY(coords, d),
            width: size(d.n),
            height: size(d.n),
            fill: chartOptions.innerBackgroundFill || colorBox(d.value),
            opacity: chartOptions.innerOpacity || 1,
            stroke: chartOptions.innerStrokeColor || '#000',
            strokeWidth: chartOptions.innerStrokeWidth || 0.5,
            style: {
                cursor: 'pointer'
            },
            onMouseOver: function onMouseOver(event) {
                var html = d.tooltip;
                if (html) handleMouseOver(event, html);
            },
            onMouseOut: function onMouseOut(event) {
                handleMouseOut(event, d);
            },
            onClick: function onClick() {
                if (d.videoUrl) window.open(d.videoUrl);
            }
        }));
    })), chartOptions.legend ? /*#__PURE__*/ $0aacaab8dd0e68bd$var$_react["default"].createElement($0aacaab8dd0e68bd$var$_BoxLegend["default"], {
        settings: settings,
        color: colorBox,
        size: size,
        maxCount: maxN,
        chartOptions: chartOptions
    }) : null);
}

});
parcelRegister("esw4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a86c8f987fde0b71$export$2e2bcd8739ae039);
function $a86c8f987fde0b71$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("4NG48", function(module, exports) {

var $hUuQW = parcelRequire("hUuQW");

var $8NfC6 = parcelRequire("8NfC6");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $37ec5e6657d351df$var$sumBy(array, iteratee) {
    return array && array.length ? $8NfC6(array, $hUuQW(iteratee, 2)) : 0;
}
module.exports = $37ec5e6657d351df$var$sumBy;

});
parcelRegister("8NfC6", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $666f02e2dab93dfc$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $666f02e2dab93dfc$var$baseSum;

});


parcelRegister("88q9M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5ec35c489f638070$var$BoxLegend;

var $5ec35c489f638070$var$_react = $5ec35c489f638070$var$_interopRequireDefault((parcelRequire("J42oT")));
function $5ec35c489f638070$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $5ec35c489f638070$var$BoxLegend(_ref) {
    var settings = _ref.settings, color = _ref.color, size = _ref.size, maxCount = _ref.maxCount, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var sizes = [
        maxCount,
        Math.floor(maxCount / 2),
        1
    ];
    if (Math.floor(maxCount / 2) == 1 && maxCount > 1) sizes = [
        maxCount,
        1
    ];
    if (maxCount === 1) sizes = [
        1
    ];
    var legendType = chartOptions.type;
    var translateRightLegend = [
        settings.vizWidth * 0.77,
        settings.vizWidth * 0.75
    ];
    var translateLeftLegend = [
        settings.vizWidth * 0.05,
        settings.vizWidth * 0.75
    ];
    if (settings.orientation === 'portrait') translate = [
        0,
        settings.vizWidth * 1.05
    ];
    if (color.domain && color.domain().length > 0) {
        var yStart = 0;
        var legendNameMultiple = chartOptions.legendName ? "".concat(chartOptions.legendName, "s") : 'Attempts';
        var legendNameOne = chartOptions.legendName ? "".concat(chartOptions.legendName) : 'Attempt';
        var legend = [];
        legend.push(/*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("g", {
            key: "boxLegend",
            id: "boxLegend",
            transform: "translate(".concat(translateRightLegend, ")")
        }, sizes.map(function(d, i) {
            yStart = i;
            return /*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("g", {
                key: "g_".concat(i)
            }, /*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("rect", {
                id: "rectOuter_".concat(d.id || i),
                key: "outer_".concat(i),
                transform: "translate(0, ".concat(i * 28, ")"),
                y: -6,
                width: size(d),
                height: size(d),
                fill: "none",
                stroke: "#000"
            }), /*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("text", {
                key: "boxLegendText_".concat(i),
                className: "legend",
                dy: "4",
                transform: "translate(20, ".concat(i * 28, ")"),
                fill: "#000",
                style: {
                    fontSize: ".8rem"
                }
            }, d, ' ', d === 1 ? legendNameOne : legendNameMultiple));
        }), ");"));
        var oaa = [
            5,
            0,
            -5
        ];
        legend.push(/*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("g", {
            key: "boxLegend",
            id: "boxLegend",
            transform: "translate(".concat(translateLeftLegend, ")")
        }, oaa.map(function(d, i) {
            yStart = i;
            return /*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("g", {
                key: "g_".concat(i)
            }, /*#__PURE__*/ $5ec35c489f638070$var$_react["default"].createElement("text", {
                key: "boxLegendText_".concat(i),
                className: "legend",
                dy: "4",
                transform: "translate(20, ".concat(i * 28, ")"),
                fill: color(d),
                style: {
                    fontSize: ".8rem"
                }
            }, d, " OAA"));
        })));
        return legend;
    }
    return null;
}

});


parcelRegister("4S9rz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $38c387dfdf8ade2d$var$Contour;

var $38c387dfdf8ade2d$var$_react = $38c387dfdf8ade2d$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $esw4H = parcelRequire("esw4H");

var $1S3JZ = parcelRequire("1S3JZ");
parcelRequire("5kU6m");
var $6FOtT = parcelRequire("6FOtT");

var $itrJs = parcelRequire("itrJs");

var $38c387dfdf8ade2d$var$_last = $38c387dfdf8ade2d$var$_interopRequireDefault((parcelRequire("bGVi6")));
parcelRequire("1k8Kz");

var $38c387dfdf8ade2d$var$_CalculateHitLocation2 = $38c387dfdf8ade2d$var$_interopRequireDefault((parcelRequire("4hAZJ")));

var $38c387dfdf8ade2d$var$_ContourLegend = $38c387dfdf8ade2d$var$_interopRequireDefault((parcelRequire("7x0W2")));
function $38c387dfdf8ade2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $38c387dfdf8ade2d$var$Contour(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var sprayData = settings.data;
    // Set data to property in data set
    if (chartOptions.linkedDataProperty) sprayData = settings.data[String(chartOptions.linkedDataProperty)];
    if (sprayData.length > 0) {
        var density = (0, $6FOtT.default)().x(function(d) {
            return (0, $38c387dfdf8ade2d$var$_CalculateHitLocation2["default"])({
                x: d.x,
                y: d.y
            }, settings.vizWidth, settings.vizHeight).x;
        }).y(function(d) {
            return (0, $38c387dfdf8ade2d$var$_CalculateHitLocation2["default"])({
                x: d.x,
                y: d.y
            }, settings.vizWidth, settings.vizHeight).y;
        }).thresholds(12).size([
            settings.vizWidth,
            settings.vizHeight
        ]).bandwidth(chartOptions.bandwidth || 12)(sprayData);
        // Use this to calculate legend max density
        density.forEach(function(d) {
            d.count = 0;
            d.coordinates.forEach(function(poly) {
                sprayData.forEach(function(p) {
                    var _CalculateHitLocation = (0, $38c387dfdf8ade2d$var$_CalculateHitLocation2["default"])({
                        x: p.x,
                        y: p.y
                    }, settings.vizWidth, settings.vizHeight), x = _CalculateHitLocation.x, y = _CalculateHitLocation.y;
                    if ((0, $itrJs.default)(poly[0], [
                        x,
                        y
                    ])) d.count++;
                });
            });
        });
        var maxCount = (0, $38c387dfdf8ade2d$var$_last["default"])(density).count;
        var maxValue = (0, $esw4H.default)(density, function(d) {
            return d.value;
        });
        var colorDensity = (0, $csdlO.default)().range([
            '#3661AD',
            '#ffffff',
            '#D82129'
        ]).domain([
            0,
            maxValue / 2,
            maxValue
        ]);
        var path = (0, $1S3JZ.default)();
        return /*#__PURE__*/ $38c387dfdf8ade2d$var$_react["default"].createElement($38c387dfdf8ade2d$var$_react["default"].Fragment, null, /*#__PURE__*/ $38c387dfdf8ade2d$var$_react["default"].createElement("g", {
            key: "contourChart",
            id: "contourChart"
        }, density.map(function(d, i) {
            var stroke = 'none';
            i;
            return /*#__PURE__*/ $38c387dfdf8ade2d$var$_react["default"].createElement("path", {
                key: "contour_".concat(i),
                stroke: stroke,
                d: path(d),
                fill: colorDensity(d.value),
                opacity: chartOptions.opacity
            });
        })), chartOptions.legend ? /*#__PURE__*/ $38c387dfdf8ade2d$var$_react["default"].createElement($38c387dfdf8ade2d$var$_ContourLegend["default"], {
            settings: settings,
            maxCount: maxCount,
            opacity: chartOptions.opacity
        }) : null);
    }
    return null;
}

});
parcelRegister("1S3JZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $15cdbc676a245217$export$2e2bcd8739ae039);

var $1pxbp = parcelRequire("1pxbp");

var $kfwpt = parcelRequire("kfwpt");

var $ehdE9 = parcelRequire("ehdE9");

var $dQrxl = parcelRequire("dQrxl");

var $f9IwG = parcelRequire("f9IwG");

var $ct2X8 = parcelRequire("ct2X8");

var $aXXFZ = parcelRequire("aXXFZ");

var $9nYX9 = parcelRequire("9nYX9");
function $15cdbc676a245217$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $kfwpt.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $kfwpt.default)(object, projectionStream((0, $ehdE9.default)));
        return (0, $ehdE9.default).result();
    };
    path.measure = function(object) {
        (0, $kfwpt.default)(object, projectionStream((0, $aXXFZ.default)));
        return (0, $aXXFZ.default).result();
    };
    path.bounds = function(object) {
        (0, $kfwpt.default)(object, projectionStream((0, $dQrxl.default)));
        return (0, $dQrxl.default).result();
    };
    path.centroid = function(object) {
        (0, $kfwpt.default)(object, projectionStream((0, $f9IwG.default)));
        return (0, $f9IwG.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $1pxbp.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $9nYX9.default)) : new (0, $ct2X8.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("1pxbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1071ddb96aebb483$export$2e2bcd8739ae039);
function $1071ddb96aebb483$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("kfwpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebde59434e827109$export$2e2bcd8739ae039);
function $ebde59434e827109$var$streamGeometry(geometry, stream) {
    if (geometry && $ebde59434e827109$var$streamGeometryType.hasOwnProperty(geometry.type)) $ebde59434e827109$var$streamGeometryType[geometry.type](geometry, stream);
}
var $ebde59434e827109$var$streamObjectType = {
    Feature: function(object, stream) {
        $ebde59434e827109$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$ebde59434e827109$var$streamGeometry(features[i].geometry, stream);
    }
};
var $ebde59434e827109$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $ebde59434e827109$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$ebde59434e827109$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $ebde59434e827109$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$ebde59434e827109$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$ebde59434e827109$var$streamGeometry(geometries[i], stream);
    }
};
function $ebde59434e827109$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $ebde59434e827109$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$ebde59434e827109$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $ebde59434e827109$export$2e2bcd8739ae039(object, stream) {
    if (object && $ebde59434e827109$var$streamObjectType.hasOwnProperty(object.type)) $ebde59434e827109$var$streamObjectType[object.type](object, stream);
    else $ebde59434e827109$var$streamGeometry(object, stream);
}

});

parcelRegister("ehdE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64d3d2b7f3af62f$export$2e2bcd8739ae039);

var $jkU6J = parcelRequire("jkU6J");

var $hmDk1 = parcelRequire("hmDk1");

var $dAkyR = parcelRequire("dAkyR");
var $a64d3d2b7f3af62f$var$areaSum = (0, $jkU6J.default)(), $a64d3d2b7f3af62f$var$areaRingSum = (0, $jkU6J.default)(), $a64d3d2b7f3af62f$var$x00, $a64d3d2b7f3af62f$var$y00, $a64d3d2b7f3af62f$var$x0, $a64d3d2b7f3af62f$var$y0;
var $a64d3d2b7f3af62f$var$areaStream = {
    point: (0, $dAkyR.default),
    lineStart: (0, $dAkyR.default),
    lineEnd: (0, $dAkyR.default),
    polygonStart: function() {
        $a64d3d2b7f3af62f$var$areaStream.lineStart = $a64d3d2b7f3af62f$var$areaRingStart;
        $a64d3d2b7f3af62f$var$areaStream.lineEnd = $a64d3d2b7f3af62f$var$areaRingEnd;
    },
    polygonEnd: function() {
        $a64d3d2b7f3af62f$var$areaStream.lineStart = $a64d3d2b7f3af62f$var$areaStream.lineEnd = $a64d3d2b7f3af62f$var$areaStream.point = (0, $dAkyR.default);
        $a64d3d2b7f3af62f$var$areaSum.add((0, $hmDk1.abs)($a64d3d2b7f3af62f$var$areaRingSum));
        $a64d3d2b7f3af62f$var$areaRingSum.reset();
    },
    result: function() {
        var area = $a64d3d2b7f3af62f$var$areaSum / 2;
        $a64d3d2b7f3af62f$var$areaSum.reset();
        return area;
    }
};
function $a64d3d2b7f3af62f$var$areaRingStart() {
    $a64d3d2b7f3af62f$var$areaStream.point = $a64d3d2b7f3af62f$var$areaPointFirst;
}
function $a64d3d2b7f3af62f$var$areaPointFirst(x, y) {
    $a64d3d2b7f3af62f$var$areaStream.point = $a64d3d2b7f3af62f$var$areaPoint;
    $a64d3d2b7f3af62f$var$x00 = $a64d3d2b7f3af62f$var$x0 = x, $a64d3d2b7f3af62f$var$y00 = $a64d3d2b7f3af62f$var$y0 = y;
}
function $a64d3d2b7f3af62f$var$areaPoint(x, y) {
    $a64d3d2b7f3af62f$var$areaRingSum.add($a64d3d2b7f3af62f$var$y0 * x - $a64d3d2b7f3af62f$var$x0 * y);
    $a64d3d2b7f3af62f$var$x0 = x, $a64d3d2b7f3af62f$var$y0 = y;
}
function $a64d3d2b7f3af62f$var$areaRingEnd() {
    $a64d3d2b7f3af62f$var$areaPoint($a64d3d2b7f3af62f$var$x00, $a64d3d2b7f3af62f$var$y00);
}
var $a64d3d2b7f3af62f$export$2e2bcd8739ae039 = $a64d3d2b7f3af62f$var$areaStream;

});
parcelRegister("jkU6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $e13b685e6c82bfc3$export$2e2bcd8739ae039);
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $e13b685e6c82bfc3$export$2e2bcd8739ae039() {
    return new $e13b685e6c82bfc3$var$Adder;
}
function $e13b685e6c82bfc3$var$Adder() {
    this.reset();
}
$e13b685e6c82bfc3$var$Adder.prototype = {
    constructor: $e13b685e6c82bfc3$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $e13b685e6c82bfc3$var$add($e13b685e6c82bfc3$var$temp, y, this.t);
        $e13b685e6c82bfc3$var$add(this, $e13b685e6c82bfc3$var$temp.s, this.s);
        if (this.s) this.t += $e13b685e6c82bfc3$var$temp.t;
        else this.s = $e13b685e6c82bfc3$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $e13b685e6c82bfc3$var$temp = new $e13b685e6c82bfc3$var$Adder;
function $e13b685e6c82bfc3$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

});

parcelRegister("hmDk1", function(module, exports) {

$parcel$export(module.exports, "tau", () => $ca42fe45664fb748$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "abs", () => $ca42fe45664fb748$export$2335f513bbd82c6d);
$parcel$export(module.exports, "sqrt", () => $ca42fe45664fb748$export$eba8049fb5020b81);
var $ca42fe45664fb748$export$6c421550c66a327d = 1e-6;
var $ca42fe45664fb748$export$92c06fba281fe81b = 1e-12;
var $ca42fe45664fb748$export$18c7bea995a110f = Math.PI;
var $ca42fe45664fb748$export$e51408a300e8929a = $ca42fe45664fb748$export$18c7bea995a110f / 2;
var $ca42fe45664fb748$export$c39a5cba78ea0fc2 = $ca42fe45664fb748$export$18c7bea995a110f / 4;
var $ca42fe45664fb748$export$a4b4b4d4d776fe92 = $ca42fe45664fb748$export$18c7bea995a110f * 2;
var $ca42fe45664fb748$export$41fc368e1a942b97 = 180 / $ca42fe45664fb748$export$18c7bea995a110f;
var $ca42fe45664fb748$export$8449e153fbd325fc = $ca42fe45664fb748$export$18c7bea995a110f / 180;
var $ca42fe45664fb748$export$2335f513bbd82c6d = Math.abs;
var $ca42fe45664fb748$export$628dc4eed22b0fbd = Math.atan;
var $ca42fe45664fb748$export$b8b770ee6a0d9760 = Math.atan2;
var $ca42fe45664fb748$export$50d414a77b60d802 = Math.cos;
var $ca42fe45664fb748$export$803ce6b71a0a94b2 = Math.ceil;
var $ca42fe45664fb748$export$b310ec824aaee37f = Math.exp;
var $ca42fe45664fb748$export$a3fe094919f356fd = Math.floor;
var $ca42fe45664fb748$export$bef1f36f5486a6a3 = Math.log;
var $ca42fe45664fb748$export$9c297f60e22e3389 = Math.pow;
var $ca42fe45664fb748$export$5de3937cb4b592ed = Math.sin;
var $ca42fe45664fb748$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $ca42fe45664fb748$export$eba8049fb5020b81 = Math.sqrt;
var $ca42fe45664fb748$export$fcdd3b0b3246a325 = Math.tan;
function $ca42fe45664fb748$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $ca42fe45664fb748$export$18c7bea995a110f : Math.acos(x);
}
function $ca42fe45664fb748$export$41726bdb1fc63f(x) {
    return x > 1 ? $ca42fe45664fb748$export$e51408a300e8929a : x < -1 ? -$ca42fe45664fb748$export$e51408a300e8929a : Math.asin(x);
}
function $ca42fe45664fb748$export$e808712c2966e662(x) {
    return (x = $ca42fe45664fb748$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("dAkyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e3e96364ea1331e$export$2e2bcd8739ae039);
function $9e3e96364ea1331e$export$2e2bcd8739ae039() {}

});


parcelRegister("dQrxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1457deaf416c132$export$2e2bcd8739ae039);

var $dAkyR = parcelRequire("dAkyR");
var $a1457deaf416c132$var$x0 = Infinity, $a1457deaf416c132$var$y0 = $a1457deaf416c132$var$x0, $a1457deaf416c132$var$x1 = -$a1457deaf416c132$var$x0, $a1457deaf416c132$var$y1 = $a1457deaf416c132$var$x1;
var $a1457deaf416c132$var$boundsStream = {
    point: $a1457deaf416c132$var$boundsPoint,
    lineStart: (0, $dAkyR.default),
    lineEnd: (0, $dAkyR.default),
    polygonStart: (0, $dAkyR.default),
    polygonEnd: (0, $dAkyR.default),
    result: function() {
        var bounds = [
            [
                $a1457deaf416c132$var$x0,
                $a1457deaf416c132$var$y0
            ],
            [
                $a1457deaf416c132$var$x1,
                $a1457deaf416c132$var$y1
            ]
        ];
        $a1457deaf416c132$var$x1 = $a1457deaf416c132$var$y1 = -($a1457deaf416c132$var$y0 = $a1457deaf416c132$var$x0 = Infinity);
        return bounds;
    }
};
function $a1457deaf416c132$var$boundsPoint(x, y) {
    if (x < $a1457deaf416c132$var$x0) $a1457deaf416c132$var$x0 = x;
    if (x > $a1457deaf416c132$var$x1) $a1457deaf416c132$var$x1 = x;
    if (y < $a1457deaf416c132$var$y0) $a1457deaf416c132$var$y0 = y;
    if (y > $a1457deaf416c132$var$y1) $a1457deaf416c132$var$y1 = y;
}
var $a1457deaf416c132$export$2e2bcd8739ae039 = $a1457deaf416c132$var$boundsStream;

});

parcelRegister("f9IwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08a3c3fb0fbf018$export$2e2bcd8739ae039);

var $hmDk1 = parcelRequire("hmDk1");
// TODO Enforce positive area for exterior, negative area for interior?
var $b08a3c3fb0fbf018$var$X0 = 0, $b08a3c3fb0fbf018$var$Y0 = 0, $b08a3c3fb0fbf018$var$Z0 = 0, $b08a3c3fb0fbf018$var$X1 = 0, $b08a3c3fb0fbf018$var$Y1 = 0, $b08a3c3fb0fbf018$var$Z1 = 0, $b08a3c3fb0fbf018$var$X2 = 0, $b08a3c3fb0fbf018$var$Y2 = 0, $b08a3c3fb0fbf018$var$Z2 = 0, $b08a3c3fb0fbf018$var$x00, $b08a3c3fb0fbf018$var$y00, $b08a3c3fb0fbf018$var$x0, $b08a3c3fb0fbf018$var$y0;
var $b08a3c3fb0fbf018$var$centroidStream = {
    point: $b08a3c3fb0fbf018$var$centroidPoint,
    lineStart: $b08a3c3fb0fbf018$var$centroidLineStart,
    lineEnd: $b08a3c3fb0fbf018$var$centroidLineEnd,
    polygonStart: function() {
        $b08a3c3fb0fbf018$var$centroidStream.lineStart = $b08a3c3fb0fbf018$var$centroidRingStart;
        $b08a3c3fb0fbf018$var$centroidStream.lineEnd = $b08a3c3fb0fbf018$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPoint;
        $b08a3c3fb0fbf018$var$centroidStream.lineStart = $b08a3c3fb0fbf018$var$centroidLineStart;
        $b08a3c3fb0fbf018$var$centroidStream.lineEnd = $b08a3c3fb0fbf018$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $b08a3c3fb0fbf018$var$Z2 ? [
            $b08a3c3fb0fbf018$var$X2 / $b08a3c3fb0fbf018$var$Z2,
            $b08a3c3fb0fbf018$var$Y2 / $b08a3c3fb0fbf018$var$Z2
        ] : $b08a3c3fb0fbf018$var$Z1 ? [
            $b08a3c3fb0fbf018$var$X1 / $b08a3c3fb0fbf018$var$Z1,
            $b08a3c3fb0fbf018$var$Y1 / $b08a3c3fb0fbf018$var$Z1
        ] : $b08a3c3fb0fbf018$var$Z0 ? [
            $b08a3c3fb0fbf018$var$X0 / $b08a3c3fb0fbf018$var$Z0,
            $b08a3c3fb0fbf018$var$Y0 / $b08a3c3fb0fbf018$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $b08a3c3fb0fbf018$var$X0 = $b08a3c3fb0fbf018$var$Y0 = $b08a3c3fb0fbf018$var$Z0 = $b08a3c3fb0fbf018$var$X1 = $b08a3c3fb0fbf018$var$Y1 = $b08a3c3fb0fbf018$var$Z1 = $b08a3c3fb0fbf018$var$X2 = $b08a3c3fb0fbf018$var$Y2 = $b08a3c3fb0fbf018$var$Z2 = 0;
        return centroid;
    }
};
function $b08a3c3fb0fbf018$var$centroidPoint(x, y) {
    $b08a3c3fb0fbf018$var$X0 += x;
    $b08a3c3fb0fbf018$var$Y0 += y;
    ++$b08a3c3fb0fbf018$var$Z0;
}
function $b08a3c3fb0fbf018$var$centroidLineStart() {
    $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPointFirstLine;
}
function $b08a3c3fb0fbf018$var$centroidPointFirstLine(x, y) {
    $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPointLine;
    $b08a3c3fb0fbf018$var$centroidPoint($b08a3c3fb0fbf018$var$x0 = x, $b08a3c3fb0fbf018$var$y0 = y);
}
function $b08a3c3fb0fbf018$var$centroidPointLine(x, y) {
    var dx = x - $b08a3c3fb0fbf018$var$x0, dy = y - $b08a3c3fb0fbf018$var$y0, z = (0, $hmDk1.sqrt)(dx * dx + dy * dy);
    $b08a3c3fb0fbf018$var$X1 += z * ($b08a3c3fb0fbf018$var$x0 + x) / 2;
    $b08a3c3fb0fbf018$var$Y1 += z * ($b08a3c3fb0fbf018$var$y0 + y) / 2;
    $b08a3c3fb0fbf018$var$Z1 += z;
    $b08a3c3fb0fbf018$var$centroidPoint($b08a3c3fb0fbf018$var$x0 = x, $b08a3c3fb0fbf018$var$y0 = y);
}
function $b08a3c3fb0fbf018$var$centroidLineEnd() {
    $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPoint;
}
function $b08a3c3fb0fbf018$var$centroidRingStart() {
    $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPointFirstRing;
}
function $b08a3c3fb0fbf018$var$centroidRingEnd() {
    $b08a3c3fb0fbf018$var$centroidPointRing($b08a3c3fb0fbf018$var$x00, $b08a3c3fb0fbf018$var$y00);
}
function $b08a3c3fb0fbf018$var$centroidPointFirstRing(x, y) {
    $b08a3c3fb0fbf018$var$centroidStream.point = $b08a3c3fb0fbf018$var$centroidPointRing;
    $b08a3c3fb0fbf018$var$centroidPoint($b08a3c3fb0fbf018$var$x00 = $b08a3c3fb0fbf018$var$x0 = x, $b08a3c3fb0fbf018$var$y00 = $b08a3c3fb0fbf018$var$y0 = y);
}
function $b08a3c3fb0fbf018$var$centroidPointRing(x, y) {
    var dx = x - $b08a3c3fb0fbf018$var$x0, dy = y - $b08a3c3fb0fbf018$var$y0, z = (0, $hmDk1.sqrt)(dx * dx + dy * dy);
    $b08a3c3fb0fbf018$var$X1 += z * ($b08a3c3fb0fbf018$var$x0 + x) / 2;
    $b08a3c3fb0fbf018$var$Y1 += z * ($b08a3c3fb0fbf018$var$y0 + y) / 2;
    $b08a3c3fb0fbf018$var$Z1 += z;
    z = $b08a3c3fb0fbf018$var$y0 * x - $b08a3c3fb0fbf018$var$x0 * y;
    $b08a3c3fb0fbf018$var$X2 += z * ($b08a3c3fb0fbf018$var$x0 + x);
    $b08a3c3fb0fbf018$var$Y2 += z * ($b08a3c3fb0fbf018$var$y0 + y);
    $b08a3c3fb0fbf018$var$Z2 += z * 3;
    $b08a3c3fb0fbf018$var$centroidPoint($b08a3c3fb0fbf018$var$x0 = x, $b08a3c3fb0fbf018$var$y0 = y);
}
var $b08a3c3fb0fbf018$export$2e2bcd8739ae039 = $b08a3c3fb0fbf018$var$centroidStream;

});

parcelRegister("ct2X8", function(module, exports) {

$parcel$export(module.exports, "default", () => $913a7bd3f67dc436$export$2e2bcd8739ae039);

var $hmDk1 = parcelRequire("hmDk1");

var $dAkyR = parcelRequire("dAkyR");
function $913a7bd3f67dc436$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$913a7bd3f67dc436$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $hmDk1.tau));
                break;
        }
    },
    result: (0, $dAkyR.default)
};

});

parcelRegister("aXXFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fbdb48655fd3f33$export$2e2bcd8739ae039);

var $jkU6J = parcelRequire("jkU6J");

var $hmDk1 = parcelRequire("hmDk1");

var $dAkyR = parcelRequire("dAkyR");
var $7fbdb48655fd3f33$var$lengthSum = (0, $jkU6J.default)(), $7fbdb48655fd3f33$var$lengthRing, $7fbdb48655fd3f33$var$x00, $7fbdb48655fd3f33$var$y00, $7fbdb48655fd3f33$var$x0, $7fbdb48655fd3f33$var$y0;
var $7fbdb48655fd3f33$var$lengthStream = {
    point: (0, $dAkyR.default),
    lineStart: function() {
        $7fbdb48655fd3f33$var$lengthStream.point = $7fbdb48655fd3f33$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($7fbdb48655fd3f33$var$lengthRing) $7fbdb48655fd3f33$var$lengthPoint($7fbdb48655fd3f33$var$x00, $7fbdb48655fd3f33$var$y00);
        $7fbdb48655fd3f33$var$lengthStream.point = (0, $dAkyR.default);
    },
    polygonStart: function() {
        $7fbdb48655fd3f33$var$lengthRing = true;
    },
    polygonEnd: function() {
        $7fbdb48655fd3f33$var$lengthRing = null;
    },
    result: function() {
        var length = +$7fbdb48655fd3f33$var$lengthSum;
        $7fbdb48655fd3f33$var$lengthSum.reset();
        return length;
    }
};
function $7fbdb48655fd3f33$var$lengthPointFirst(x, y) {
    $7fbdb48655fd3f33$var$lengthStream.point = $7fbdb48655fd3f33$var$lengthPoint;
    $7fbdb48655fd3f33$var$x00 = $7fbdb48655fd3f33$var$x0 = x, $7fbdb48655fd3f33$var$y00 = $7fbdb48655fd3f33$var$y0 = y;
}
function $7fbdb48655fd3f33$var$lengthPoint(x, y) {
    $7fbdb48655fd3f33$var$x0 -= x, $7fbdb48655fd3f33$var$y0 -= y;
    $7fbdb48655fd3f33$var$lengthSum.add((0, $hmDk1.sqrt)($7fbdb48655fd3f33$var$x0 * $7fbdb48655fd3f33$var$x0 + $7fbdb48655fd3f33$var$y0 * $7fbdb48655fd3f33$var$y0));
    $7fbdb48655fd3f33$var$x0 = x, $7fbdb48655fd3f33$var$y0 = y;
}
var $7fbdb48655fd3f33$export$2e2bcd8739ae039 = $7fbdb48655fd3f33$var$lengthStream;

});

parcelRegister("9nYX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d558b08da6b768e$export$2e2bcd8739ae039);
function $6d558b08da6b768e$export$2e2bcd8739ae039() {
    this._string = [];
}
$6d558b08da6b768e$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $6d558b08da6b768e$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $6d558b08da6b768e$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $6d558b08da6b768e$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("bGVi6", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $88300eb9f05cb13b$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $88300eb9f05cb13b$var$last;

});

parcelRegister("7x0W2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $57bc572fe8600213$var$ContourLegend;

var $57bc572fe8600213$var$_react = $57bc572fe8600213$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");
function $57bc572fe8600213$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $57bc572fe8600213$var$ContourLegend(_ref) {
    var settings = _ref.settings, maxCount = _ref.maxCount, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 0.75 : _ref$opacity;
    var colorLegend = (0, $csdlO.default)().range([
        '#3661AD',
        '#ffffff',
        '#D82129'
    ]).domain([
        0,
        maxCount / 2,
        maxCount
    ]);
    var range = [];
    var increments = maxCount / 20;
    for(var i = maxCount; i > 0; i -= increments)range.push(i);
    return /*#__PURE__*/ $57bc572fe8600213$var$_react["default"].createElement("g", {
        id: "legend",
        transform: "translate(".concat(settings.vizWidth * 1.08, ",").concat(settings.margin.top, ")")
    }, range.map(function(d, i) {
        return /*#__PURE__*/ $57bc572fe8600213$var$_react["default"].createElement("g", {
            key: "contourLegend_".concat(i)
        }, /*#__PURE__*/ $57bc572fe8600213$var$_react["default"].createElement("rect", {
            height: 15,
            width: 40,
            x: -24,
            y: 14 + i * 8,
            stroke: "none",
            fill: colorLegend(d),
            opacity: opacity
        }));
    }), /*#__PURE__*/ $57bc572fe8600213$var$_react["default"].createElement("text", {
        className: "legend",
        fill: "#f5f5f5",
        textAnchor: "middle",
        style: {
            fontSize: '1rem'
        },
        x: -6,
        y: 34
    }, maxCount), /*#__PURE__*/ $57bc572fe8600213$var$_react["default"].createElement("text", {
        className: "legend",
        fill: "#fff",
        textAnchor: "middle",
        style: {
            fontSize: '1rem'
        },
        y: 16 + range.length * 8
    }, "1"));
}

});


parcelRegister("ifBYI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d497166d986d8fee$var$HexBin;

var $d497166d986d8fee$var$_react = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("J42oT")));
parcelRequire("ee3f6");
var $ezPfT = parcelRequire("ezPfT");

var $esw4H = parcelRequire("esw4H");

var $jIYPg = parcelRequire("jIYPg");

var $d497166d986d8fee$var$_filter = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("Aq07U")));
parcelRequire("1k8Kz");

var $d497166d986d8fee$var$_CalculateHitLocation = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("4hAZJ")));

var $d497166d986d8fee$var$_RunCalculations = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("fKd4Q")));

var $d497166d986d8fee$var$_Palettes = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("8uo4Y")));

var $d497166d986d8fee$var$_HexLegend = $d497166d986d8fee$var$_interopRequireDefault((parcelRequire("cM8HK")));
function $d497166d986d8fee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $d497166d986d8fee$var$HexBin(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var pitchData = settings.data;
    var chartType = chartOptions.type;
    var radiusSize = 14;
    var hex = (0, $ezPfT.default)().x(function(d) {
        return (0, $d497166d986d8fee$var$_CalculateHitLocation["default"])({
            x: d.x,
            y: d.y
        }, settings.vizWidth, settings.vizHeight).x;
    }).y(function(d) {
        return (0, $d497166d986d8fee$var$_CalculateHitLocation["default"])({
            x: d.x,
            y: d.y
        }, settings.vizWidth, settings.vizHeight).y;
    }).radius(radiusSize * settings.vizWidth / settings.vizWidth - 1).extent([
        [
            0,
            0
        ],
        [
            settings.vizWidth - 0,
            settings.vizHeight - 0
        ]
    ]);
    var bins = hex(pitchData);
    for(var i = 0; i < bins.length; i++)bins[i].calculations = (0, $d497166d986d8fee$var$_RunCalculations["default"])(bins[i]);
    var palette = new $d497166d986d8fee$var$_Palettes["default"]({
        type: chartType,
        data: bins
    });
    var color = palette.color;
    var maxCount = (0, $esw4H.default)(bins, function(d) {
        return d.length;
    });
    var minRadius = 5;
    var radius = (0, $jIYPg.sqrt)([
        1,
        maxCount
    ], [
        minRadius,
        hex.radius()
    ]);
    if (!chartOptions.scaleRadius) radius = function radius() {
        return radiusSize;
    };
    return /*#__PURE__*/ $d497166d986d8fee$var$_react["default"].createElement($d497166d986d8fee$var$_react["default"].Fragment, null, /*#__PURE__*/ $d497166d986d8fee$var$_react["default"].createElement("g", {
        id: "hexbinChart"
    }, bins.map(function(d, i) {
        return /*#__PURE__*/ $d497166d986d8fee$var$_react["default"].createElement("path", {
            key: "hexPath_".concat(i),
            d: hex.hexagon(radius(d.length), d),
            transform: "translate(".concat(d.x, ",").concat(d.y, ")"),
            fill: d ? color(Number(d.calculations[chartType])) : '#000',
            stroke: "#000",
            opacity: chartOptions.opacity
        });
    })), chartOptions.legend ? /*#__PURE__*/ $d497166d986d8fee$var$_react["default"].createElement($d497166d986d8fee$var$_HexLegend["default"], {
        type: "field",
        settings: settings,
        hex: hex,
        color: color,
        radius: radius,
        maxCount: maxCount,
        chartType: chartType,
        chartOptions: chartOptions
    }) : null);
}

});
parcelRegister("ee3f6", function(module, exports) {

$parcel$export(module.exports, "hexbin", () => (parcelRequire("ezPfT")).default);

var $ezPfT = parcelRequire("ezPfT");

});
parcelRegister("ezPfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9cc17d43f6ae635$export$2e2bcd8739ae039);
var $a9cc17d43f6ae635$var$thirdPi = Math.PI / 3, $a9cc17d43f6ae635$var$angles = [
    0,
    $a9cc17d43f6ae635$var$thirdPi,
    2 * $a9cc17d43f6ae635$var$thirdPi,
    3 * $a9cc17d43f6ae635$var$thirdPi,
    4 * $a9cc17d43f6ae635$var$thirdPi,
    5 * $a9cc17d43f6ae635$var$thirdPi
];
function $a9cc17d43f6ae635$var$pointX(d) {
    return d[0];
}
function $a9cc17d43f6ae635$var$pointY(d) {
    return d[1];
}
function $a9cc17d43f6ae635$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 1, y1 = 1, x = $a9cc17d43f6ae635$var$pointX, y = $a9cc17d43f6ae635$var$pointY, r, dx, dy;
    function hexbin(points) {
        var binsById = {}, bins = [], i, n = points.length;
        for(i = 0; i < n; ++i){
            if (isNaN(px = +x.call(null, point = points[i], i, points)) || isNaN(py = +y.call(null, point, i, points))) continue;
            var point, px, py, pj = Math.round(py = py / dy), pi = Math.round(px = px / dx - (pj & 1) / 2), py1 = py - pj;
            if (Math.abs(py1) * 3 > 1) {
                var px1 = px - pi, pi2 = pi + (px < pi ? -1 : 1) / 2, pj2 = pj + (py < pj ? -1 : 1), px2 = px - pi2, py2 = py - pj2;
                if (px1 * px1 + py1 * py1 > px2 * px2 + py2 * py2) pi = pi2 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
            }
            var id = pi + "-" + pj, bin = binsById[id];
            if (bin) bin.push(point);
            else {
                bins.push(bin = binsById[id] = [
                    point
                ]);
                bin.x = (pi + (pj & 1) / 2) * dx;
                bin.y = pj * dy;
            }
        }
        return bins;
    }
    function hexagon(radius) {
        var x0 = 0, y0 = 0;
        return $a9cc17d43f6ae635$var$angles.map(function(angle) {
            var x1 = Math.sin(angle) * radius, y1 = -Math.cos(angle) * radius, dx = x1 - x0, dy = y1 - y0;
            x0 = x1, y0 = y1;
            return [
                dx,
                dy
            ];
        });
    }
    hexbin.hexagon = function(radius) {
        return "m" + hexagon(radius == null ? r : +radius).join("l") + "z";
    };
    hexbin.centers = function() {
        var centers = [], j = Math.round(y0 / dy), i = Math.round(x0 / dx);
        for(var y = j * dy; y < y1 + r; y += dy, ++j)for(var x = i * dx + (j & 1) * dx / 2; x < x1 + dx / 2; x += dx)centers.push([
            x,
            y
        ]);
        return centers;
    };
    hexbin.mesh = function() {
        var fragment = hexagon(r).slice(0, 4).join("l");
        return hexbin.centers().map(function(p) {
            return "M" + p + "m" + fragment;
        }).join("");
    };
    hexbin.x = function(_) {
        return arguments.length ? (x = _, hexbin) : x;
    };
    hexbin.y = function(_) {
        return arguments.length ? (y = _, hexbin) : y;
    };
    hexbin.radius = function(_) {
        return arguments.length ? (r = +_, dx = r * 2 * Math.sin($a9cc17d43f6ae635$var$thirdPi), dy = r * 1.5, hexbin) : r;
    };
    hexbin.size = function(_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], hexbin) : [
            x1 - x0,
            y1 - y0
        ];
    };
    hexbin.extent = function(_) {
        return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], hexbin) : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    return hexbin.radius(1);
}

});


parcelRegister("jIYPg", function(module, exports) {

$parcel$export(module.exports, "powish", () => $e5c14f2273c3a28d$export$34695211ec403a46);
$parcel$export(module.exports, "sqrt", () => $e5c14f2273c3a28d$export$eba8049fb5020b81);

var $csdlO = parcelRequire("csdlO");

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");
function $e5c14f2273c3a28d$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $e5c14f2273c3a28d$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $e5c14f2273c3a28d$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $e5c14f2273c3a28d$export$34695211ec403a46(transform) {
    var scale = transform((0, $g7ot1.identity), (0, $g7ot1.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $g7ot1.identity), (0, $g7ot1.identity)) : exponent === 0.5 ? transform($e5c14f2273c3a28d$var$transformSqrt, $e5c14f2273c3a28d$var$transformSquare) : transform($e5c14f2273c3a28d$var$transformPow(exponent), $e5c14f2273c3a28d$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $csdlO.linearish)(scale);
}
function $e5c14f2273c3a28d$export$2e2bcd8739ae039() {
    var scale = $e5c14f2273c3a28d$export$34695211ec403a46((0, $g7ot1.transformer)());
    scale.copy = function() {
        return (0, $g7ot1.copy)(scale, $e5c14f2273c3a28d$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $9HCq2.initRange).apply(scale, arguments);
    return scale;
}
function $e5c14f2273c3a28d$export$eba8049fb5020b81() {
    return $e5c14f2273c3a28d$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("8uo4Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
parcelRequire("jEBA8");
var $1d021 = parcelRequire("1d021");

var $gDbQf = parcelRequire("gDbQf");

var $csdlO = parcelRequire("csdlO");
var $khT4b = parcelRequire("khT4b");
function $9e022e3beddc8678$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e022e3beddc8678$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e022e3beddc8678$var$_typeof(o);
}
function $9e022e3beddc8678$var$_slicedToArray(r, e) {
    return $9e022e3beddc8678$var$_arrayWithHoles(r) || $9e022e3beddc8678$var$_iterableToArrayLimit(r, e) || $9e022e3beddc8678$var$_unsupportedIterableToArray(r, e) || $9e022e3beddc8678$var$_nonIterableRest();
}
function $9e022e3beddc8678$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e022e3beddc8678$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9e022e3beddc8678$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9e022e3beddc8678$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9e022e3beddc8678$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9e022e3beddc8678$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e022e3beddc8678$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9e022e3beddc8678$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9e022e3beddc8678$var$_toPropertyKey(o.key), o);
    }
}
function $9e022e3beddc8678$var$_createClass(e, r, t) {
    return r && $9e022e3beddc8678$var$_defineProperties(e.prototype, r), t && $9e022e3beddc8678$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9e022e3beddc8678$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $9e022e3beddc8678$var$_defineProperty(e, r, t) {
    return (r = $9e022e3beddc8678$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9e022e3beddc8678$var$_toPropertyKey(t) {
    var i = $9e022e3beddc8678$var$_toPrimitive(t, "string");
    return "symbol" == $9e022e3beddc8678$var$_typeof(i) ? i : i + "";
}
function $9e022e3beddc8678$var$_toPrimitive(t, r) {
    if ("object" != $9e022e3beddc8678$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9e022e3beddc8678$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9e022e3beddc8678$var$ColorPalette = module.exports["default"] = /*#__PURE__*/ $9e022e3beddc8678$var$_createClass(function ColorPalette(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'totalPitches' : _ref$type, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, _ref$customPalette = _ref.customPalette, customPalette = _ref$customPalette === void 0 ? [] : _ref$customPalette;
    $9e022e3beddc8678$var$_classCallCheck(this, ColorPalette);
    $9e022e3beddc8678$var$_defineProperty(this, "color", void 0);
    $9e022e3beddc8678$var$_defineProperty(this, "extent", void 0);
    $9e022e3beddc8678$var$_defineProperty(this, "min", void 0);
    $9e022e3beddc8678$var$_defineProperty(this, "max", void 0);
    var palette = [
        '#3661AD',
        '#ffffff',
        '#D82129',
        '#8e161b'
    ];
    this.color = function() {
        return '#000 ';
    };
    if (customPalette && customPalette.length > 0) palette = customPalette;
    this.extent = (0, $gDbQf.default)(data, function(d) {
        return Number(d.calculations[type]);
    });
    var _this$extent = $9e022e3beddc8678$var$_slicedToArray(this.extent, 2), min = _this$extent[0], max = _this$extent[1];
    if (min === undefined || max === undefined) // TODO: How to handle this?
    throw new Error('color palette error');
    this.min = min;
    this.max = max;
    var laPalette = [
        '#3661AD',
        '#ffffff',
        '#D82129',
        '#ffffff',
        '#3661AD'
    ];
    if (this.max || this.min || this.max === 0 && this.min === 0) {
        if (type === 'totalPitches') this.color = (0, $csdlO.default)().range(palette).domain([
            0,
            this.max / 2,
            this.max
        ]);
        else if (type === 'percent' || type === 'kPercent') this.color = (0, $csdlO.default)().range(palette).domain([
            0,
            15,
            30
        ]).clamp(true);
        else if (type === 'ba') this.color = (0, $csdlO.default)().range(palette).domain([
            0,
            0.25,
            0.333,
            1
        ]);
        else if (type === 'woba' || type === 'slg' || type === 'xWoba') this.color = (0, $csdlO.default)().range(palette).domain([
            0,
            0.32,
            0.65,
            1.0
        ]).clamp(true);
        else if (type === 'avgExitVelocity') this.color = (0, $csdlO.default)().range(palette).domain([
            60,
            85,
            100
        ]).clamp(true);
        else if (type === 'avgLaunchAngle') this.color = (0, $csdlO.default)().range(laPalette).domain([
            -5,
            10,
            20,
            30,
            45
        ]).clamp(true);
        else if (type === 'releaseSpinRate') this.color = (0, $csdlO.default)().range(palette).domain([
            1000,
            2000,
            2800,
            3000
        ]).clamp(true);
        else if (type === 'releaseSpeed') this.color = (0, $csdlO.default)().range(palette).domain([
            70,
            88,
            96,
            100
        ]).clamp(true);
        else if (type === 'batSpeed' || type === 'batSpeedCompetitive') this.color = (0, $csdlO.default)().range([
            '#3661AD',
            '#ffffff',
            '#D82129'
        ]).domain([
            62,
            71,
            80
        ]).clamp(true);
        else if (type === 'attackAngle' || type === 'attackAngleCompetitive') this.color = (0, $csdlO.default)().range(laPalette)// I feel extremely meh about this
        .domain([
            0,
            2.5,
            12.5,
            22.5,
            25
        ]).clamp(true);
        else if (type === 'attackDirection' || type === 'attackDirectionCompetitive') this.color = (0, $khT4b.default)($1d021.default).domain([
            5,
            -15
        ]);
        else if (type === 'swingPathTilt' || type === 'swingPathTiltCompetitive') this.color = (0, $khT4b.default)($1d021.default).domain([
            20,
            45
        ]);
        else if (type === 'swingLength' || type === 'swingLengthCompetitive') this.color = (0, $csdlO.default)().range([
            '#3661AD',
            '#ffffff',
            '#D82129'
        ]).domain([
            8.2,
            7.3,
            6.4
        ]).clamp(true);
        else if (type === 'idealAttackAngle' || type === 'idealAttackAngleCompetitive') this.color = (0, $csdlO.default)().range([
            '#3661AD',
            '#ffffff',
            '#D82129'
        ]).domain([
            0.35,
            0.5,
            0.65
        ]).clamp(true);
        else if (type === 'swing_miss_percent') this.color = (0, $csdlO.default)().range(palette).domain([
            0,
            25,
            50,
            100
        ]);
        else if (type === 'runExp' || type === 'pitcherRunExp') {
            // Max could be zero...
            // Positive Values are good (red) either way
            var maxAbs = Math.max(Math.abs(min), Math.abs(max));
            this.color = (0, $csdlO.default)().range([
                '#3661AD',
                '#ffffff',
                '#D82129'
            ]).domain([
                -maxAbs,
                0,
                maxAbs
            ]).clamp(true);
        }
    } else this.color = (0, $csdlO.default)().range([
        '#ededed',
        '#ededed',
        '#ededed'
    ]);
});

});
parcelRegister("khT4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec501c3badfe2fef$export$2e2bcd8739ae039);

var $4ONh6 = parcelRequire("4ONh6");
var $kSfaZ = parcelRequire("kSfaZ");

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");

var $csdlO = parcelRequire("csdlO");

var $bQItL = parcelRequire("bQItL");

var $hmzop = parcelRequire("hmzop");

var $jIYPg = parcelRequire("jIYPg");
function $ec501c3badfe2fef$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $g7ot1.identity), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $4ONh6.default));
    scale.rangeRound = range((0, $kSfaZ.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $ec501c3badfe2fef$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $ec501c3badfe2fef$export$2e2bcd8739ae039() {
    var scale = (0, $csdlO.linearish)($ec501c3badfe2fef$var$transformer()((0, $g7ot1.identity)));
    scale.copy = function() {
        return $ec501c3badfe2fef$export$784d13d8ee351f07(scale, $ec501c3badfe2fef$export$2e2bcd8739ae039());
    };
    return (0, $9HCq2.initInterpolator).apply(scale, arguments);
}
function $ec501c3badfe2fef$export$6843e08bf2ff981f() {
    var scale = (0, $bQItL.loggish)($ec501c3badfe2fef$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $ec501c3badfe2fef$export$784d13d8ee351f07(scale, $ec501c3badfe2fef$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $9HCq2.initInterpolator).apply(scale, arguments);
}
function $ec501c3badfe2fef$export$9d4af4de62c81941() {
    var scale = (0, $hmzop.symlogish)($ec501c3badfe2fef$var$transformer());
    scale.copy = function() {
        return $ec501c3badfe2fef$export$784d13d8ee351f07(scale, $ec501c3badfe2fef$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $9HCq2.initInterpolator).apply(scale, arguments);
}
function $ec501c3badfe2fef$export$de9f78581b4f2405() {
    var scale = (0, $jIYPg.powish)($ec501c3badfe2fef$var$transformer());
    scale.copy = function() {
        return $ec501c3badfe2fef$export$784d13d8ee351f07(scale, $ec501c3badfe2fef$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $9HCq2.initInterpolator).apply(scale, arguments);
}
function $ec501c3badfe2fef$export$413d935127ed466e() {
    return $ec501c3badfe2fef$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("bQItL", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $8a070da81d0e65b4$export$860836db074028f0);

var $eRcVk = parcelRequire("eRcVk");

var $haUiJ = parcelRequire("haUiJ");

var $a5Qfw = parcelRequire("a5Qfw");

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");
function $8a070da81d0e65b4$var$transformLog(x) {
    return Math.log(x);
}
function $8a070da81d0e65b4$var$transformExp(x) {
    return Math.exp(x);
}
function $8a070da81d0e65b4$var$transformLogn(x) {
    return -Math.log(-x);
}
function $8a070da81d0e65b4$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $8a070da81d0e65b4$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $8a070da81d0e65b4$var$powp(base) {
    return base === 10 ? $8a070da81d0e65b4$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $8a070da81d0e65b4$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $8a070da81d0e65b4$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $8a070da81d0e65b4$export$860836db074028f0(transform) {
    var scale = transform($8a070da81d0e65b4$var$transformLog, $8a070da81d0e65b4$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $8a070da81d0e65b4$var$logp(base), pows = $8a070da81d0e65b4$var$powp(base);
        if (domain()[0] < 0) {
            logs = $8a070da81d0e65b4$var$reflect(logs), pows = $8a070da81d0e65b4$var$reflect(pows);
            transform($8a070da81d0e65b4$var$transformLogn, $8a070da81d0e65b4$var$transformExpn);
        } else transform($8a070da81d0e65b4$var$transformLog, $8a070da81d0e65b4$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $eRcVk.default)(u, v, n);
        } else z = (0, $eRcVk.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $haUiJ.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $a5Qfw.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $8a070da81d0e65b4$export$2e2bcd8739ae039() {
    var scale = $8a070da81d0e65b4$export$860836db074028f0((0, $g7ot1.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $g7ot1.copy)(scale, $8a070da81d0e65b4$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $9HCq2.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("a5Qfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7592e6aadd9e9917$export$2e2bcd8739ae039);
function $7592e6aadd9e9917$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("hmzop", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $ca3ff1f7fec6f285$export$4602684e614eba38);

var $csdlO = parcelRequire("csdlO");

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");
function $ca3ff1f7fec6f285$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $ca3ff1f7fec6f285$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $ca3ff1f7fec6f285$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($ca3ff1f7fec6f285$var$transformSymlog(c), $ca3ff1f7fec6f285$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($ca3ff1f7fec6f285$var$transformSymlog(c = +_), $ca3ff1f7fec6f285$var$transformSymexp(c)) : c;
    };
    return (0, $csdlO.linearish)(scale);
}
function $ca3ff1f7fec6f285$export$2e2bcd8739ae039() {
    var scale = $ca3ff1f7fec6f285$export$4602684e614eba38((0, $g7ot1.transformer)());
    scale.copy = function() {
        return (0, $g7ot1.copy)(scale, $ca3ff1f7fec6f285$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $9HCq2.initRange).apply(scale, arguments);
}

});



parcelRegister("cM8HK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ccc23eb6e9f4a724$var$HexLegend;

var $ccc23eb6e9f4a724$var$_react = $ccc23eb6e9f4a724$var$_interopRequireDefault((parcelRequire("J42oT")));
function $ccc23eb6e9f4a724$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/no-array-index-key */ function $ccc23eb6e9f4a724$var$threeDigitFormat(val) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
        if (val === null || val === undefined) return placeholder;
        var num = Number(val);
        if (num >= 0 && num < 1) return num.toFixed(3).slice(-4);
        // Negative numbers? Meh
        return num.toFixed(3);
    } catch (e) {
        console.log('threeDigitFormat error', e, val); // eslint-disable-line no-console
        return val;
    }
}
function $ccc23eb6e9f4a724$var$HexLegend(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'pitch' : _ref$type, settings = _ref.settings, hex = _ref.hex, radius = _ref.radius, color = _ref.color, maxCount = _ref.maxCount, chartOptions = _ref.chartOptions;
    var sizes = [
        maxCount,
        Math.floor(maxCount / 2),
        1
    ];
    if (Math.floor(maxCount / 2) === 1 && maxCount > 1) sizes = [
        maxCount,
        1
    ];
    if (maxCount === 1) sizes = [
        1
    ];
    var legendType = chartOptions.type;
    var translate = [
        settings.vizWidth * 1.05,
        0
    ];
    if (settings.orientation === 'portrait') translate = [
        0,
        settings.vizWidth * 1.05
    ];
    if ('domain' in color && color.domain().length > 0) {
        var domain = color.domain().reverse();
        var legendNameMultiple = 'Pitches';
        var legendNameOne = 'Pitch';
        if (type === 'field') {
            legendNameMultiple = 'Batted Balls';
            legendNameOne = 'Batted Ball';
        }
        return /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("g", {
            key: "hexLegend",
            id: "hexLegend",
            transform: "translate(".concat(translate, ")")
        }, sizes.map(function(d, i) {
            return /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("g", {
                key: "g_".concat(i)
            }, /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("path", {
                key: "hexLegendPath_".concat(i),
                d: hex.hexagon(radius(d)),
                transform: "translate(0, ".concat(i * 28, ")"),
                fill: "#fff",
                stroke: "#000",
                opacity: 1
            }), /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("text", {
                key: "hexLegendText_".concat(i),
                className: "legend",
                dy: "4",
                transform: "translate(20, ".concat(i * 28, ")"),
                fill: "#000",
                style: {
                    fontSize: "1rem"
                }
            }, d, " ", d === 1 ? legendNameOne : legendNameMultiple));
        }), legendType !== 'totalPitches' ? domain.map(function(d, i) {
            var first = i === 0;
            var last = domain.length - 1 === i;
            var row = sizes.length + i + 1;
            var translatePath = [
                0,
                row * 28
            ];
            var translateText = [
                20,
                row * 28
            ];
            if (settings.orientation === 'portrait') {
                translatePath = [
                    settings.vizWidth / 3,
                    i * 28
                ];
                translateText = [
                    settings.vizWidth / 3 + 20,
                    i * 28
                ];
            }
            var value = String(d);
            if (legendType === 'ba' || legendType === 'woba') value = String($ccc23eb6e9f4a724$var$threeDigitFormat(value));
            else if (legendType === 'avgExitVelocity' && first) value += '+ MPH';
            else if (legendType === 'avgExitVelocity' && last) value = "< ".concat(value, " MPH");
            else if (legendType === 'avgExitVelocity') value += ' MPH';
            else if (legendType === 'avgLaunchAngle') value += " \xb0";
            else if (legendType === 'kPercent') value += '%';
            return /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("g", {
                key: "gAlt_".concat(row)
            }, /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("path", {
                key: "hexLegendPathAlt_".concat(row),
                d: hex.hexagon(radius(maxCount)),
                transform: "translate(".concat(translatePath, ")"),
                fill: String(color(d)),
                stroke: "#000",
                opacity: 1
            }), /*#__PURE__*/ $ccc23eb6e9f4a724$var$_react["default"].createElement("text", {
                key: "hexLegendTextAlt_".concat(row),
                className: "legend",
                dy: "4",
                transform: "translate(".concat(translateText, ")"),
                fill: "#000"
            }, value));
        }) : null);
    }
    return null;
}

});


parcelRegister("83RM4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5de850fb54843b2b$var$Radial;

var $5de850fb54843b2b$var$_react = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $7tGZK = parcelRequire("7tGZK");

var $1izgn = parcelRequire("1izgn");

var $5de850fb54843b2b$var$_filter = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("Aq07U")));

var $5de850fb54843b2b$var$_CalculateHitLocation = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("4hAZJ")));
parcelRequire("1k8Kz");

var $5de850fb54843b2b$var$_ColorMap = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $5de850fb54843b2b$var$_Legend = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $5de850fb54843b2b$var$_Tooltip = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $5de850fb54843b2b$var$_RadialVisual = $5de850fb54843b2b$var$_interopRequireDefault((parcelRequire("cNLMF")));

var $3wgDt = parcelRequire("3wgDt");
function $5de850fb54843b2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $5de850fb54843b2b$var$Radial(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    // Remove null spray
    var sprayData = settings.data;
    var angleMin = -80;
    var angleMax = 80;
    var angle = (0, $7tGZK.default)(angleMin, angleMax);
    var veloMin = 20;
    var veloMax = 120;
    var originX = 124;
    var originY = 292;
    var radius = 270;
    var xscale = (0, $csdlO.default)().domain([
        0,
        1
    ]).range([
        originX,
        originX + radius
    ]);
    var yscale = (0, $csdlO.default)().domain([
        -1,
        1
    ]).range([
        originY - radius,
        originY + radius
    ]);
    var toRadians = function toRadians(deg) {
        return -Math.PI * deg / 180;
    };
    var toX = function toX(d) {
        var vnorm = parseFloat(d.launchSpeed) / veloMax;
        var theta = toRadians(parseFloat(d.launchAngle));
        return vnorm * Math.cos(theta);
    };
    var toY = function toY(d) {
        var vnorm = parseFloat(d.launchSpeed) / veloMax;
        var theta = toRadians(parseFloat(d.launchAngle));
        return vnorm * Math.sin(theta);
    };
    var lineDegree = (0, $1izgn.default)().x(function(d) {
        return xscale(toX(d));
    }).y(function(d) {
        return yscale(toY(d));
    });
    var keyLines = [
        [
            {
                launchSpeed: 0,
                launchAngle: 0
            },
            {
                launchSpeed: 120,
                launchAngle: 0
            }
        ],
        [
            {
                launchSpeed: 0,
                launchAngle: 0
            },
            {
                launchSpeed: 120,
                launchAngle: 45
            }
        ]
    ];
    var keyText = [
        {
            launchSpeed: 123,
            launchAngle: 51,
            text: '120 MPH'
        },
        {
            launchSpeed: 123,
            launchAngle: 45,
            text: "45 \xb0"
        },
        {
            launchSpeed: 123,
            launchAngle: -1,
            text: "0 \xb0"
        },
        {
            launchSpeed: 123,
            launchAngle: 90,
            text: '120 MPH'
        },
        {
            launchSpeed: 126,
            launchAngle: -90,
            text: '120 MPH'
        },
        {
            launchSpeed: 114,
            launchAngle: 90,
            text: "90 \xb0"
        },
        {
            launchSpeed: 117,
            launchAngle: -90,
            text: "-90 \xb0"
        }
    ];
    function handleMouseOver(event, tip) {
        (0, $5de850fb54843b2b$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        (0, $5de850fb54843b2b$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    return /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement($5de850fb54843b2b$var$_react["default"].Fragment, null, /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("g", null, /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("svg", {
        width: settings.vizWidth,
        height: settings.vizHeight,
        viewBox: [
            0,
            0,
            600,
            600
        ],
        id: "radial",
        dangerouslySetInnerHTML: {
            __html: $5de850fb54843b2b$var$_RadialVisual["default"]
        }
    }), /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("svg", {
        width: settings.vizWidth,
        height: settings.vizHeight,
        viewBox: [
            0,
            0,
            600,
            600
        ],
        id: "radial"
    }, /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("g", null, sprayData.map(function(d, i) {
        return /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("circle", {
            key: "radial_circle_".concat(i),
            cx: xscale(toX(d)),
            cy: yscale(toY(d)),
            r: 7,
            fill: (0, $5de850fb54843b2b$var$_ColorMap["default"])('paResult', d.paResult),
            stroke: "#000",
            strokeWidth: 0.5,
            onMouseOver: function onMouseOver(event) {
                var html = d.tooltip;
                if (html) handleMouseOver(event, html);
            },
            onMouseOut: function onMouseOut(event) {
                handleMouseOut(event, d);
            },
            onClick: function onClick() {
                if (d.videoUrl) window.open(d.videoUrl);
            }
        });
    }), keyLines.map(function(d, i) {
        return /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("path", {
            key: "radial_lines_".concat(i),
            d: lineDegree(d),
            stroke: "#b2b2b2",
            strokeWidth: 2,
            fill: "none"
        });
    }), keyText.map(function(d, i) {
        return /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement("text", {
            key: "radial_text_".concat(i),
            x: xscale(toX(d)),
            y: yscale(toY(d)),
            style: {
                fontSize: '14px'
            }
        }, d.text);
    })))), /*#__PURE__*/ $5de850fb54843b2b$var$_react["default"].createElement($5de850fb54843b2b$var$_Legend["default"], {
        settings: settings,
        type: "paResult"
    }));
}

});
parcelRegister("cNLMF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $951f2089a0f83b42$var$_default = module.exports["default"] = "<svg viewBox=\"525 365 338 527\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n         xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <defs></defs>\n  <path d=\"M8.22438559,1.98074789 C8.31843828,1.69680935 8.78870176,0.65570136 9.25896523,0.371762818 C9.7292287,0.0878242755 10.1054395,-0.196114266 11.1400191,0.182470456 C12.1745987,0.561055179 12.5508095,1.12893226 12.8329676,1.60216317 C13.1151257,2.07539407 12.7389149,3.30579442 12.7389149,3.30579442 C12.7389149,3.30579442 13.3032311,3.58973296 13.2091784,4.06296386 C13.1151257,4.53619477 13.0060283,4.60493678 12.5508095,4.72548713 C12.0955907,4.84603748 11.4221772,4.53619477 11.4221772,4.53619477 C11.4221772,4.53619477 13.0078046,5.1908013 13.6794419,5.48265657 C14.3510791,5.77451185 15.5604957,6.3344722 15.5604957,6.3344722 L16.8772335,7.09164164 C16.8772335,7.09164164 18.0058658,7.56487255 18.2880239,7.84881109 C18.5701819,8.13274963 18.5701819,8.51133435 18.5701819,8.51133435 L19.6988143,8.60598054 L19.9809724,8.88991908 L19.8869197,9.2685038 L19.8869197,9.55244234 L23.6490274,11.1614274 C23.6490274,11.1614274 24.8717125,11.5400121 25.4360286,11.7293045 C26.0003448,11.9185969 29.9505579,13.8115205 29.9505579,13.8115205 C29.9505579,13.8115205 30.1112446,14.3731414 30,14.619424 C29.8887554,14.8657065 29,16 29,16 C29,16 25.3762108,14.1892924 25,14 C24.6237892,13.8107076 23,12.3918278 23,12.3918278 L19.8869197,9.93102706 C19.8869197,9.93102706 19.792867,10.0256732 19.5107089,10.1203194 C19.2285508,10.2149656 18.0058658,10.2149656 18.0058658,10.2149656 C18.0058658,10.2149656 15.8480267,10.4989041 14.9961796,10.4989041 C14.1443325,10.4989041 13.3032311,10.2149656 13.3032311,10.2149656 L12.7389149,9.7417347 C12.7389149,9.7417347 12.1745987,9.55244234 11.9864934,9.45779616 C11.6763095,9.86357971 11.798388,10.9721351 11.798388,10.9721351 L12.1745987,12.4864739 L12.0805461,13.1489972 L12.2686514,14.5686899 L12.3627041,15.8937364 C12.3627041,15.8937364 14.1497053,18.6384757 14.3378107,19.0170604 C14.5259161,19.3956451 14.7140215,20.1528146 14.7140215,20.1528146 L15.9367065,22.2350306 L17.2534442,23.9386618 L18.0999185,24.9797698 L19.8869197,26.2101701 L21.7679736,26.9673396 L22.3322897,27.5352167 L22.1441843,28.0084476 L19.6988143,28.1030938 L16.5010227,28.1030938 L16.3129173,27.2512781 L16.3129173,26.683401 C16.3129173,26.683401 14.6199688,24.6958312 14.4318634,24.4118927 C14.243758,24.1279542 13.2091784,22.5189691 13.2091784,22.5189691 L12.8329676,21.8564458 L11.7043353,20.8153378 C11.7043353,20.8153378 11.0459664,23.2761385 11.1400191,22.9922 C11.2340718,22.7082615 10.9519137,23.3707847 10.7638083,23.5600771 C10.5757029,23.7493694 8,24.4118927 8,24.4118927 L4.27417244,25.2101701 L3.80390896,25.3048163 L2.86338202,25.8726934 L2.58122394,27.0084476 L2.67527663,27.9549094 L2.67527663,28.2388479 L1.45259161,28.2388479 L0.982328139,27.9549094 L0.794222751,26.4405705 C0.794222751,26.4405705 0.135853892,25.4941087 0.0418011974,25.115524 C-0.0522514968,24.7369392 0.0418011974,23.8851236 0.0418011974,23.8851236 C0.0418011974,23.8851236 0.629365459,23.5302498 1.26448622,23.4118927 C1.89960698,23.2935356 2.48717125,23.4118927 2.58122394,23.4118927 C2.67527663,23.4118927 5.30875207,22.2761385 5.30875207,22.2761385 C5.30875207,22.2761385 6.15522632,22.0457382 6.5314371,21.8564458 C6.90764787,21.6671535 8.22438559,21.2000008 8.22438559,21.2000008 C8.22438559,21.2000008 8.31843828,21.0046302 8.41249098,20.8153378 C8.50654367,20.6260455 8.41249098,18.5438295 8.41249098,18.5438295 L8.22438559,17.6920139 C8.22438559,17.6920139 7.52024784,17.2679339 7.09575326,16.6509059 C6.67125868,16.0338779 6.5314371,15.2312132 6.5314371,15.2312132 C6.5314371,15.2312132 6.34333171,14.9449012 6.34333171,14.3793976 C6.34333171,13.813894 6.5314371,13.2436434 6.5314371,13.2436434 L5.68496285,12.3918278 L5.21469938,11.2560736 L5.12064668,10.5935503 C5.12064668,10.5935503 5.00302424,9.79099354 5.02659399,8.98456526 C5.05016374,8.17813697 5.02659399,7.47022637 5.02659399,7.47022637 C5.02659399,7.47022637 5.08985339,5.43988535 5.12064668,4.82013331 C5.15143997,4.20038127 5.40280477,3.58973296 5.40280477,3.58973296 C5.40280477,3.58973296 5.59091015,3.11650206 5.87306824,2.83256351 C6.15522632,2.54862497 6.34333171,2.35933261 6.81359518,2.26468643 C7.28385865,2.17004025 8.1303329,2.54862497 8.1303329,2.54862497 C8.1303329,2.54862497 8.1303329,2.26468643 8.22438559,1.98074789 Z M14.6199688,7.47022637 C15.0902323,7.56487255 15.8426538,7.65951873 15.8426538,7.65951873 L16.3129173,8.13274963 L16.3129173,8.41668817 C16.3129173,8.70062672 16.6891281,9.07921144 16.6891281,9.07921144 L16.3129173,9.07921144 C16.2188646,9.07921144 15.8164469,8.86230169 15.3723903,8.7952729 C14.9283338,8.7282441 14.4318634,8.7952729 14.4318634,8.7952729 L13.8675472,8.41668817 C13.8675472,8.41668817 14.1617033,8.07588534 14.243758,7.84881109 C14.3258127,7.62173684 14.243758,7.37558019 14.243758,7.37558019 C14.243758,7.37558019 14.1497053,7.37558019 14.6199688,7.47022637 Z\" transform=\"translate(450, 580) scale(3)\" style=\"fill: rgb(155, 155, 155); fill-rule: evenodd; stroke: none;\"></path>\n\n        <path d=\"M539.907062,563 C539.799523,686.519219 539.55518,833.005734 539,861 C661.957983,861 775,764 775,622 C775,601.325978 772.668336,581.605819 768.298162,563 L539.907062,563 Z\"\n              id=\"green\" stroke=\"none\" fill=\"#c4dee0\" fill-rule=\"evenodd\"></path>\n        <path d=\"M539.905311,565 C539.991597,467.045223 539.991597,383 539.991597,383 C647.450555,383 743.819264,454.676794 768.759093,565 L539.905311,565 Z\"\n              id=\"blue\" stroke=\"none\" fill=\"#b0d3d6\" fill-rule=\"evenodd\"></path>\n        <path d=\"M654,622 C654,691.194915 598.915966,738.461864 539,738.461864 C539.483193,714.097458 539.483193,505.538136 539.483193,505.538136 C600.398305,505.538136 654,552.805085 654,622 Z\"\n              id=\"yellow\" stroke=\"none\" fill=\"#9dc8cc\" fill-rule=\"evenodd\"></path>\n        <path d=\"M774.998754,621.17258 C774.685942,620.458002 774.353312,619.733802 774,619 C761,594 749.559912,573.940449 719,552 C712,561 710,562 695,562 C680,559 676,552 659,548 C648,544 640,534 637,534 C634,534 633,533 633,540 C633,547 639,566 646,576 C672,586 673.150622,590 706.150622,607 C739.150622,624 772,660 772,660 C772,660 772.08943,659.916532 772.248496,659.750055 C774.056625,647.568673 775,634.972107 775,622 C775,621.724023 774.999585,621.448216 774.998754,621.17258 Z\"\n              id=\"orange\" stroke=\"none\" fill=\"#61a6ad\" fill-rule=\"evenodd\"></path>\n\n        <path d=\"M773.986939,618.974883 C774.332926,619.404252 774.668876,619.821316 774.994265,620.225402 C774.472954,539.626806 738.453252,473.67303 684.444105,431.948763 L684.239157,432 C684.239157,432 674,441 671.239157,450 C671.239157,460 680.239157,469 687.239157,485 C694.239157,501 693.239157,512 697.239157,523 C701.239157,534 705.239157,541 713.239157,547 C714.267647,547.771367 716.155591,549.683164 718.665005,552.429412 C718.775419,552.288338 718.887059,552.14521 719,552 C749.549676,573.933101 760.992335,593.986563 773.986939,618.974883 Z\"\n              id=\"pink\" opacity=\".75\" stroke=\"none\" fill=\"#4e9ba2\" fill-rule=\"evenodd\"></path>\n        <path d=\"M691.973588,438.0211 C686.985909,442.000031 682.992954,442.017614 679,452 C683,462 692,476 698,491 C704,506 700,518 708,532 C721,546 725,544 739,560 C749.309285,571.78204 766.125592,592.240109 774.275443,602.20771 C769.199401,533.495926 737.825949,476.610507 691.973588,438.0211 Z\"\n              id=\"red\" stroke=\"none\" fill=\"#3a9098\" fill-rule=\"evenodd\"></path>\n    </svg>";

});


parcelRegister("adpbZ", function(module, exports) {
"use strict";
function $76fea8f3268234ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $76fea8f3268234ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $76fea8f3268234ec$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $76fea8f3268234ec$var$Sideways;

var $76fea8f3268234ec$var$_react = $76fea8f3268234ec$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $76fea8f3268234ec$var$_SidewaysChart = $76fea8f3268234ec$var$_interopRequireDefault((parcelRequire("iYXIT")));

var $76fea8f3268234ec$var$_FieldSVG = $76fea8f3268234ec$var$_interopRequireDefault((parcelRequire("eJm9R")));
function $76fea8f3268234ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $76fea8f3268234ec$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($76fea8f3268234ec$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $76fea8f3268234ec$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $76fea8f3268234ec$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $76fea8f3268234ec$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $76fea8f3268234ec$var$_slicedToArray(r, e) {
    return $76fea8f3268234ec$var$_arrayWithHoles(r) || $76fea8f3268234ec$var$_iterableToArrayLimit(r, e) || $76fea8f3268234ec$var$_unsupportedIterableToArray(r, e) || $76fea8f3268234ec$var$_nonIterableRest();
}
function $76fea8f3268234ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76fea8f3268234ec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $76fea8f3268234ec$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $76fea8f3268234ec$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $76fea8f3268234ec$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $76fea8f3268234ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $76fea8f3268234ec$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable */ 
function $76fea8f3268234ec$var$Sideways(_ref) {
    var settings = _ref.settings;
    var _useState = (0, $76fea8f3268234ec$var$_react.useState)(null), _useState2 = $76fea8f3268234ec$var$_slicedToArray(_useState, 2), svg = _useState2[0], setSvg = _useState2[1];
    var height = 327;
    var width = 720;
    settings.shape;
    var opts = {
        playData: settings.data,
        arcType: 'standard',
        colors: {
            bleachers: '#d8d8d8',
            ground: '#417505',
            hit: '#D0011B',
            metricMark: '#888'
        },
        height: height,
        width: width,
        hitTypeVisible: false,
        scaleType: 'true'
    };
    (0, $76fea8f3268234ec$var$_react.useEffect)(function() {
        (0, $76fea8f3268234ec$var$_SidewaysChart["default"])(opts, function(sidewaysSvg) {
            setSvg(sidewaysSvg);
        });
    }, []);
    return /*#__PURE__*/ $76fea8f3268234ec$var$_react["default"].createElement($76fea8f3268234ec$var$_react["default"].Fragment, null, /*#__PURE__*/ $76fea8f3268234ec$var$_react["default"].createElement("g", {
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }));
}

});
parcelRegister("iYXIT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $dd1c285998727551$var$SidewaysChart;

/* eslint-disable */ function $dd1c285998727551$var$SidewaysChart(opts, callback) {
    var VizHitTracking = (parcelRequire("gYqqF"));
    var svgBody = document.createElement('body');
    var viz = new VizHitTracking(svgBody);
    try {
        viz.render(opts.playData, opts, function(svg) {
            callback(svg);
        });
    } catch (err) {
        console.log(err);
        // return 1-pixel transparent svg
        callback('<svg width="1px" height="1px"></svg>');
    }
/* new viz(opts, function (svg) {
      callback(svg);
  }); */ }

});
parcelRegister("gYqqF", function(module, exports) {
"use strict";
/* eslint-disable */ define(function(require) {
    var _ = require('underscore');
    var d3 = require('d3');
    var VizBase = require('./VizBase');
    var metrics = require('./Metrics');
    var tutil = require('./TrackUtil');
    var trajectory = require('./Trajectory');
    var xform = require('./Transform');
    // maps EVENT_TYPES to display text
    var EVENT_TEXT = {
        SINGLE: [
            'SINGLE'
        ],
        DOUBLE: [
            'DOUBLE'
        ],
        TRIPLE: [
            'TRIPLE'
        ],
        HOME_RUN: [
            'HOME RUN'
        ],
        ITP_HOME_RUN: [
            'INSIDE THE PARK',
            'HOME RUN'
        ],
        POP_UP: [
            'POP UP'
        ],
        FLY_BALL: [
            'FLY BALL'
        ],
        SAC_FLY: [
            'SAC FLY'
        ],
        LINE_DRIVE: [
            'LINE DRIVE'
        ],
        OTHER: [
            '-----'
        ]
    };
    var isServerSide = typeof window === 'undefined';
    var fs;
    function VizHitTracking(sel) {
        _.extend(this, VizBase);
        this.sel = sel;
    }
    function toRadians(deg) {
        return Math.PI * deg / 180;
    }
    function toDegrees(rad) {
        return 180 * rad / Math.PI;
    }
    function dist(p1, p2) {
        var dx = p2.x - p1.x;
        var dy = p2.y - p1.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    VizHitTracking.prototype.toXScale = function(playType, spec) {
        var minHitDistance = spec.minHitDistance || 77;
        var maxHitDistance = spec.maxHitDistance || 370;
        var domain = [
            minHitDistance,
            maxHitDistance
        ];
        // switch (playType) {
        // 	case this.PLAY_TYPES.CAUGHT:
        // 		return d3.scaleLinear().domain(domain).range([133.4, 247.5]).clamp(true);
        // 	case this.PLAY_TYPES.DROPPED:
        // 	default:
        // 		return d3.scaleLinear().domain(domain).range([133.4, 226.5]).clamp(true);
        // }
        switch(playType){
            case this.PLAY_TYPES.CAUGHT:
                return d3.scaleLinear().domain(domain).range([
                    spec.xTailMin,
                    spec.xTailMaxCaught
                ]).clamp(true);
            case this.PLAY_TYPES.DROPPED:
            default:
                return d3.scaleLinear().domain(domain).range([
                    spec.xTailMin,
                    spec.xTailMaxDropped
                ]).clamp(true);
        }
    };
    VizHitTracking.prototype.render = function(trackingData, spec, cb) {
        // console.info('received…');
        // console.info('spec.width: ' + spec.width);
        // console.info('spec.height: ' + spec.height);
        spec = this.toDefaultSpec(spec);
        // // for testing
        // spec.eventPillVisible = true;
        // spec.batterName = 'A. Rizzo';
        // spec.teamId = 110;
        // console.log('using…');
        // console.log('spec.width: ' + spec.width);
        // console.log('spec.height: ' + spec.height);
        // console.log('aspect ratio: ' + (spec.width / spec.height));
        // set y positions of elements
        this.updateDim();
        var dim = this.dim;
        var svg = this.clearSvg(spec);
        console.log(svg);
        var defs = this.defs();
        var gMain;
        var gTail;
        var vbParts = svg.attr('viewBox').split(' ');
        var vbw = +vbParts[2];
        var vbh = +vbParts[3];
        var hitMetrics = metrics.toHitMetrics(trackingData);
        var playType = this.toPlayType(trackingData);
        // isHomer = playType === this.PLAY_TYPES.HOMERUN,
        var isCaught = playType === this.PLAY_TYPES.CAUGHT;
        var isDropped = playType === this.PLAY_TYPES.DROPPED;
        var isMissed = playType === this.PLAY_TYPES.MISSED;
        // isInParkHomer = this.isInsideParkHR(trackingData),
        var eventType = this.toEventType(trackingData);
        var viewType = this.toViewType(trackingData);
        // xScale only used for non-homer batted ball plays
        var xScale = this.toXScale(playType, spec);
        var pHead;
        var pTail;
        var dxTail;
        var isLogoOrNameVisible = spec.batterName || spec.teamId;
        // gMain ty for when logo|name displayed
        var gMainOffsetY = 0; // -15;
        // background rect
        svg.append('rect').classed('background', true).attr('width', spec.width).attr('height', spec.height);
        gMain = svg.append('g').classed('main', true);
        // be sure to call addCss and addFont after clearSvg
        this.addCss(svg);
        this.addFont(svg);
        addGridPattern(defs);
        if (spec.endType === 'auto') {
            isCaught = this.isCaught(trackingData);
            isDropped = !isCaught;
        }
        if (spec.endType !== 'auto') {
            isCaught = spec.endType === 'caught';
            isDropped = spec.endType === 'dropped';
            isMissed = spec.endType === 'missed';
        }
        if (isLogoOrNameVisible) {
            gMain.attr('transform', "translate(0,".concat(gMainOffsetY, ")"));
            this.renderBelow(spec, svg, spec.teamId, spec.batterName);
        }
        pHead = dim.hit.head;
        switch(viewType){
            case this.VIEW_TYPES.WALL:
                pTail = dim.hit.tail.homer;
                break;
            case this.VIEW_TYPES.FIELDER:
                pTail = dim.hit.tail.caught;
                pTail.x = xScale(hitMetrics.distance.value);
                break;
            case this.VIEW_TYPES.BOUNCES:
                pTail = dim.hit.tail.dropped;
                pTail.x = xScale(hitMetrics.distance.value);
                break;
            default:
                pTail = dim.hit.tail.missed;
        }
        var points3D = trajectory.reconstructSeriesToHeightThreshold(trackingData, -1);
        // Note: to2D normalizes y values so that first point's y is 0
        var points2DWorld = tutil.simplify(tutil.to2D(points3D), 3);
        var pointsView = xform.worldToView(points2DWorld);
        // scale to target endpoints x values, scaling x and y proportionally
        var pointsViewScaled = xform.xInterpolate(pointsView, pHead.x, pTail.x);
        // match target endpoints vertically
        var pointsViewYInterpolated = xform.yInterpolate(pointsViewScaled, pHead.y, pTail.y);
        // clamp to yViewMinApex, scaling to fit, if necessary
        // pointsViewYClamped = xform.yClampView(pointsViewYInterpolated, pHead, pTail, this.dim.yViewMinApex),
        // if logo|name displayed, compensate for the vertical translation of gMain
        var yTop = isLogoOrNameVisible ? this.dim.yViewMinApex - gMainOffsetY : this.dim.yViewMinApex;
        var pointsViewYClamped = xform.yClampView(pointsViewYInterpolated, pHead, pTail, yTop);
        // final view model points
        var points = pointsViewYClamped;
        var pApexView = _.min(points, function(p) {
            return p.y;
        });
        var p0 = points[0];
        var p1 = points[1];
        var yTopHeightLine; // top y view coordinate of height line
        var dx = p1.x - p0.x;
        var dy = p1.y - p0.y;
        var arcAngle = Math.atan2(dy, dx);
        var arcAngleDegrees = toDegrees(arcAngle);
        var v01 = {
            x: p1.x - p0.x,
            y: p1.y - p0.y
        };
        var vlen = dist({
            x: 0,
            y: 0
        }, v01);
        var vNormal = {
            x: v01.y / vlen,
            y: -v01.x / vlen
        };
        var marginBottom = 5;
        var pVelo = {
            x: p1.x + marginBottom * vNormal.x,
            y: p1.y + marginBottom * vNormal.y
        };
        var p1Arc = {
            x: p1.x,
            y: p1.y
        };
        var p2Arc = {
            x: p1.x + 8,
            y: dim.yBase
        };
        // account for spec.endType
        // HR defaults
        var isDistanceMetricHigh = spec.metricsDistanceVPos === 'high';
        var isHeightMetricHigh = spec.metricsHeightVPos === 'high';
        // TODOHI  move to dim in viz_base?
        var dimMetrics = {
            exitvelo: pVelo,
            // TODOHI  still need to handle option for height text below arc
            maxheight: {
                x: pApexView.x,
                y: isHeightMetricHigh ? pApexView.y - dim.metrics.height.margin.bottom : pApexView.y + dim.metrics.height.margin.top + dim.fontSize
            },
            // distance defaults to VIEW_TYPE.WALL(HR)
            distance: {},
            hangtime: {
                // x: 258,
                x: 298,
                y: 13.5
            },
            launchangle: {
                x: p2Arc.x + 4,
                y: p2Arc.y - 0.5 * (p2Arc.y - p1Arc.y)
            }
        };
        if (isHeightMetricHigh) yTopHeightLine = pApexView.y + 3;
        else yTopHeightLine = dimMetrics.maxheight.y + dim.metrics.height.margin.bottom;
        if (isLogoOrNameVisible) switch(viewType){
            case this.VIEW_TYPES.WALL:
                dimMetrics.distance = {
                    x: 257,
                    y: dim.yBase + 16
                };
                break;
            case this.VIEW_TYPES.FIELDER:
                dimMetrics.distance = {
                    x: pTail.x + 5,
                    y: dim.yBase + 16
                };
                break;
            case this.VIEW_TYPES.BOUNCES:
                dimMetrics.distance = {
                    x: pTail.x - 25,
                    y: dim.yBase + 16
                };
                break;
            default:
                dimMetrics.distance = {
                    // TODO    base on pTail.x like above?
                    x: 270,
                    y: dim.yBase + 16
                };
        }
        else switch(viewType){
            case this.VIEW_TYPES.WALL:
                if (isDistanceMetricHigh) dimMetrics.distance = {
                    x: 261,
                    y: dim.yBase - 70
                };
                else dimMetrics.distance = {
                    x: 255,
                    y: dim.yBase - 35
                };
                break;
            case this.VIEW_TYPES.FIELDER:
                dimMetrics.distance = {
                    x: pTail.x + 23,
                    y: dim.yBase - 17
                };
                break;
            case this.VIEW_TYPES.BOUNCES:
                dimMetrics.distance = {
                    x: pTail.x - 7,
                    y: dim.yBase - 25
                };
                break;
            default:
                dimMetrics.distance = {
                    // TODO    base on pTail.x like above?
                    x: 270,
                    y: dim.yBase - 4
                };
        }
        if (spec.referenceMarks) drawReferenceGrid(gMain, vbw, vbh);
        // this.addArrowheadDefs(defs, spec);
        // hit arc from tracking
        var line = d3.line().x(function(d) {
            return d.x;
        }).y(function(d) {
            return d.y;
        }).curve(d3.curveLinear);
        gMain.append('path').classed('hit_arc', true).attr('d', line(points));
        addGrid(gMain, dim.yBase, spec.gridOpacity, points);
        // launch angle arc
        gMain.append('path').classed('launch_angle', true).attr('d', "M ".concat(p1Arc.x, " ").concat(p1Arc.y, "A 40 20 60 0 1 ").concat(p2Arc.x, " ").concat(p2Arc.y));
        // if (isHomer) {
        // 	this.addOutfieldWall(gMain, dim.yBase, spec);
        // }
        if (viewType === this.VIEW_TYPES.WALL) this.addOutfieldWall(gMain, dim.yBase, spec);
        this.addGround(gMain, spec);
        this.addPlate(gMain);
        this.addHitter(gMain, spec);
        // if (isCaught && !isHomer) {
        if (viewType === this.VIEW_TYPES.FIELDER) {
            dxTail = pTail.x - 266;
            gTail = gMain.append('g').classed('tail', true).attr('transform', "translate(".concat(dxTail, ", 0)"));
            this.addFielder(gTail, spec);
        }
        // if (isDropped && !isHomer) {
        if (viewType === this.VIEW_TYPES.BOUNCES) {
            dxTail = pTail.x - 233;
            gTail = gMain.append('g').classed('tail', true).attr('transform', "translate(".concat(dxTail, ", 0)"));
            this.addHops(gTail, spec);
        }
        renderHeightLine(gMain, dim, pApexView, yTopHeightLine);
        renderHitArcGradient(gMain, points);
        // ball at head of hit
        this.addBall(gMain, points[0]);
        if (spec.hitTypeVisible) gMain.append('text').text(hitMetrics.hitType.value).classed('annotation', true).attr('x', 10).attr('y', 20);
        metric(gMain, "".concat(Math.round(hitMetrics.exitVelocity.value)), ' mph', 'exitvelo', 'hit', dimMetrics.exitvelo, arcAngleDegrees, false);
        metric(gMain, "".concat(Math.round(hitMetrics.maxHeight.value)), ' ft', 'maxheight', null, dimMetrics.maxheight, 0, 'middle');
        metric(gMain, "".concat(Math.round(hitMetrics.distance.value)), ' ft', 'distance', null, dimMetrics.distance, 0, false);
        metric(gMain, "".concat(Math.round(hitMetrics.launchAngle.value), "\xB0"), '', 'launchangle', null, dimMetrics.launchangle, 0, false);
        if (spec.hangTimePillVisible) {
            var gTime;
            // // hang time box outline
            // svg.append('rect')
            // 	.classed('hang_time', true)
            // 	.attr('x', dim.metrics.hangtime.rect.x)
            // 	.attr('y', dim.metrics.hangtime.rect.y)
            // 	.attr('width', dim.metrics.hangtime.rect.width)
            // 	.attr('height', dim.metrics.hangtime.rect.height);
            gTime = metric(svg, "".concat((+hitMetrics.hangTime.value).toFixed(1)), ' sec', 'hangtime', 'hangtime', dimMetrics.hangtime, 0, 'end');
            // stopwatch icon
            addStopwatch(gTime);
        }
        // play result (event pill) at top left
        // does not display when eventType unknown
        if (spec.eventPillVisible && eventType !== this.EVENT_TYPES.OTHER) renderEventPill(svg, dim, eventType);
        if (spec.referenceMarks) drawReference(gMain);
        // return svg markup when called by graphics server
        cb && cb(d3.select(this.sel).html());
    };
    /**
   * Renders team logo and hitter name, if given
   * @param spec
   * @param svg
   * @param teamId
   * @param name
   */ VizHitTracking.prototype.renderBelow = function(spec, svg, teamId, name) {
        // translate to right a little to handle widest logo, Braves
        var isHatLogo = spec.logoType === 'hat';
        var tx = isHatLogo ? -3 : 5;
        var ty = 120;
        var g = svg.append('g').classed('below', true).attr('transform', "translate(".concat(tx, ",").concat(ty, ")"));
        var logoPath;
        if (teamId) {
            logoPath = this.toLogoPath(teamId, isHatLogo);
            // console.info('logoPath: ' + logoPath);
            var gLogo = g.append('g').classed('logo', true).attr('transform', 'translate(0, 2) scale(0.12)');
            if (isServerSide) fs.readFile(logoPath, function(err, buf) {
                console.log("err: ".concat(err));
                if (err) throw err;
                var svg = buf.toString();
                // console.log('SVG: '+ svg);
                // TODOHI  checked with &svg=true option, but doesn't appear to be inserting the logo svg into gLogo
                // gLogo.append('div').html(svg);
                gLogo.html(svg);
            });
            else d3.xml(logoPath).mimeType('image/svg+xml').get(function(error, xml) {
                if (error) throw error;
                var el = xml.documentElement;
                gLogo.node().appendChild(el);
            });
        }
        if (name) g.append('text').text(name).classed('name', true).attr('x', isHatLogo ? 35 : 42).attr('y', 13);
    };
    // defaults to horizontally centered text
    function metric(el, text, units, id, className, p, angle, textAnchor) {
        units = units || '';
        textAnchor = textAnchor !== undefined ? textAnchor : 'start';
        angle = angle || 0;
        // get text width
        var textWidth;
        // temporary text to determine size
        el.append('text').text(text).attr('x', 40).attr('y', 15).each(function() {
            // TODOHI  not working in server context
            // textWidth = this.getComputedTextLength();
            textWidth = 20;
            this.remove();
        }).append('tspan').classed('units', true).text(units);
        var g = el.append('g').classed('metric', true).classed(className, className !== null).attr('transform', "translate(".concat(p.x, ",").concat(p.y, ") rotate(").concat(angle, ")"));
        g.append('text').classed('metric', true).classed(className, className).text(text).attr('id', id).style('text-anchor', textAnchor).attr('x', 0).attr('y', 0).append('tspan').classed('units', true).text(units);
        return g;
    }
    function addGridPattern(defs) {
        var pat = defs.append('pattern').attr('id', 'grid_pattern').attr('x', 0).attr('y', 0).attr('width', 4).attr('height', 4).attr('patternUnits', 'userSpaceOnUse');
        // horizontal
        pat.append('line').attr('x1', 0).attr('y1', 0).attr('x2', 4).attr('y2', 0).style('stroke', '#000').style('strike-width', 1);
        // vertical
        pat.append('line').attr('x1', 3).attr('y1', 0).attr('x2', 3).attr('y2', 4).style('stroke', '#000').style('strike-width', 1);
    }
    function renderHitArcGradient(g, points) {
        var colorHead = '#FF7800';
        var colorTail = '#FF0000';
        var color = d3.interpolateLab(colorHead, colorTail);
        _.each(_.initial(points), function(p, i) {
            var q = points[i + 1];
            var f = i / points.length;
            var c = color(f);
            // console.log('f: ' + f + ', color: ' + c);
            g.append('line').attr('x1', p.x).attr('y1', p.y).attr('x2', q.x).attr('y2', q.y).style('stroke', c).style('stroke-linecap', 'round').style('stroke-width', 2);
        });
    }
    function renderHeightLine(g, dim, pApex, yTop) {
        var gLine = g.append('g').classed('height', true);
        var p1 = {
            x: pApex.x,
            y: dim.yBase - 3
        };
        var p2 = {
            x: pApex.x,
            // y: Math.max(20, pApex.y) + 3
            y: yTop
        };
        var p = _.extend({}, p1);
        while(p.y >= p2.y){
            gLine.append('circle').attr('cx', p1.x).attr('cy', p.y).attr('r', 0.75);
            p.y -= 3;
        }
    }
    function addGrid(g, yBase, opacity, points) {
        opacity = opacity || 0.1;
        var p1x = points[0];
        var p2x = _.last(points);
        points = points.slice();
        points.push({
            x: p2x.x,
            y: yBase - 3
        });
        points.unshift({
            x: p1x.x,
            y: yBase - 3
        });
        var pointsStr = _.map(points, function(p) {
            return "".concat(p.x, " ").concat(p.y);
        }).join(', ');
        // create polygon
        g.insert('polygon', '.hit_arc').attr('points', pointsStr).style('fill', 'url(#grid_pattern)').style('fill-opacity', opacity);
    }
    function addStopwatch(g) {
        var tx = -39;
        var ty = -7.3;
        var gWatch = g.append('g').classed('stopwatch', true)// .attr('transform', 'translate(-13, -10)')
        .attr('transform', "translate(".concat(tx, ",").concat(ty, ") scale(0.75)")).style('stroke', 'none').style('fill', 'none').style('fill-rule', 'evenodd');
        gWatch.html('<path d="M5.01804706,5.40898235 C5.01804706,5.73545294 4.75351765,5.99998235 4.42704706,5.99998235 C4.10075294,5.99998235 3.83622353,5.73545294 3.83622353,5.40898235 C3.83622353,5.08268824 4.10075294,4.81798235 4.42704706,4.81798235 C4.75351765,4.81798235 5.01804706,5.08268824 5.01804706,5.40898235 Z" id="center" fill="#000"></path><path d="M3.84289412,6.22231765 C3.77954118,6.28584706 3.67701176,6.28584706 3.61365882,6.22231765 C3.55030588,6.15914118 3.55030588,6.05678824 3.61365882,5.99308235 L6.26936471,3.33772941 C6.33254118,3.27437647 6.43507059,3.27437647 6.49842353,3.33755294 C6.56177647,3.40108235 6.5616,3.50361176 6.4986,3.56678824 L3.84289412,6.22231765 Z" id="hand" fill="#000"></path><path d="M4.4271,9.07392353 C2.41304118,9.07392353 0.774688235,7.43557059 0.774688235,5.42168824 C0.774688235,3.40780588 2.41304118,1.7691 4.4271,1.7691 C6.44115882,1.7691 8.07933529,3.40780588 8.07933529,5.42168824 C8.07933529,7.43557059 6.44115882,9.07392353 4.4271,9.07392353 M4.73098235,0.975511765 L4.73098235,0.951158824 L4.0251,0.949923529 L4.0251,0.985747059 C1.73098235,1.22045294 -1.76470588e-05,3.11680588 -1.76470588e-05,5.42168824 C-1.76470588e-05,7.88521765 1.98033529,9.88233529 4.44404118,9.88233529 C6.90757059,9.88233529 8.87592353,7.88521765 8.87592353,5.42168824 C8.87592353,3.07427647 7.0251,1.15162941 4.73098235,0.975511765" id="body" fill="#000"></path><polygon id="top_button_shaft" fill="#000" points="3.84864706 1.23529412 4.90747059 1.23529412 4.90747059 0.529411765 3.84864706 0.529411765"></polygon><polygon id="top-button_head" fill="#000" points="3.49570588 0.705882353 5.26041176 0.705882353 5.26041176 0 3.49570588 0"></polygon><polygon id="side_button" fill="#000" points="1.82537647 2.41888235 1.32631765 2.91811765 0.577729412 2.16935294 1.07678824 1.67011765"></polygon>');
    }
    // TODOHI  size box to fit text size
    // note: temporary text trick doesn't work in server context, so have to estimate text width
    // TODOHI  center text in box
    function renderEventPill(g, dim, eventType) {
        var resultLines = EVENT_TEXT[eventType];
        // take count from last line - ITPHR's HOME RUN line, or the only line
        var charCount = resultLines[resultLines.length - 1].length;
        // estimate text width as multiple of character count
        var textWidth = 10 * charCount;
        var rectWidth = 1.1 * textWidth;
        // rectWidth = dim.result.rect.width;
        g.append('rect').classed('result', true).attr('x', dim.result.rect.x).attr('y', dim.result.rect.y).attr('width', rectWidth).attr('height', function() {
            if (resultLines.length === 1) return dim.result.rect.height;
            return dim.result.rect.height + 6;
        });
        if (resultLines.length === 1) g.append('text').text(resultLines[0]).classed('result', true).attr('x', dim.result.rect.x + 0.5 * rectWidth).attr('y', dim.result.rect.y + dim.result.rect.height - 6);
        else {
            // assume two lines
            g.append('text').text(resultLines[0]).classed('result short', true).attr('x', dim.result.rect.x + 0.5 * rectWidth).attr('y', dim.result.rect.y + dim.result.rect.height - 11);
            g.append('text').text(resultLines[1]).classed('result', true).attr('x', dim.result.rect.x + 0.5 * rectWidth).attr('y', dim.result.rect.y + dim.result.rect.height + 2);
        }
    }
    function drawReferenceGrid(g, w, h) {
        var g = g.append('g').classed('grid', true);
        _.each(_.range(0, 300, 10), function(x, i) {
            g.append('line').attr('x1', x).attr('y1', 0).attr('x2', x).attr('y2', h).style('stroke', i % 5 === 0 ? '#888' : '#ccc').style('stroke-opacity', 0.5).style('stroke-width', 0.5);
        });
        _.each(_.range(0, 300, 10), function(y, i) {
            g.append('line').attr('x1', 0).attr('y1', y).attr('x2', w).attr('y2', y).style('stroke', i % 5 === 0 ? '#888' : '#ccc').style('stroke-opacity', 0.5).style('stroke-width', 0.5);
        });
    }
    // Sample the SVG path uniformly with the specified precision.
    function samples(path, precision) {
        var n = path.getTotalLength();
        var t = [
            0
        ];
        var i = 0;
        var dt = precision;
        while((i += dt) < n)t.push(i);
        t.push(n);
        return t.map(function(t) {
            var p = path.getPointAtLength(t);
            var a = [
                p.x,
                p.y
            ];
            a.t = t / n;
            return a;
        });
    }
    // Compute quads of adjacent points [p0, p1, p2, p3].
    function quads(points) {
        return d3.range(points.length - 1).map(function(i) {
            var a = [
                points[i - 1],
                points[i],
                points[i + 1],
                points[i + 2]
            ];
            a.t = (points[i].t + points[i + 1].t) / 2;
            return a;
        });
    }
    // Compute stroke outline for segment p12.
    function lineJoin(p0, p1, p2, p3, width) {
        var u12 = perp(p1, p2);
        var r = width / 2;
        var a = [
            p1[0] + u12[0] * r,
            p1[1] + u12[1] * r
        ];
        var b = [
            p2[0] + u12[0] * r,
            p2[1] + u12[1] * r
        ];
        var c = [
            p2[0] - u12[0] * r,
            p2[1] - u12[1] * r
        ];
        var d = [
            p1[0] - u12[0] * r,
            p1[1] - u12[1] * r
        ];
        if (p0) {
            // clip ad and dc using average of u01 and u12
            var u01 = perp(p0, p1);
            var e = [
                p1[0] + u01[0] + u12[0],
                p1[1] + u01[1] + u12[1]
            ];
            a = lineIntersect(p1, e, a, b);
            d = lineIntersect(p1, e, d, c);
        }
        if (p3) {
            // clip ab and dc using average of u12 and u23
            var u23 = perp(p2, p3);
            var e = [
                p2[0] + u23[0] + u12[0],
                p2[1] + u23[1] + u12[1]
            ];
            b = lineIntersect(p2, e, a, b);
            c = lineIntersect(p2, e, d, c);
        }
        return "M".concat(a, "L").concat(b, " ").concat(c, " ").concat(d, "Z");
    }
    // Compute intersection of two infinite lines ab and cd.
    function lineIntersect(a, b, c, d) {
        var x1 = c[0];
        var x3 = a[0];
        var x21 = d[0] - x1;
        var x43 = b[0] - x3;
        var y1 = c[1];
        var y3 = a[1];
        var y21 = d[1] - y1;
        var y43 = b[1] - y3;
        var ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
        return [
            x1 + ua * x21,
            y1 + ua * y21
        ];
    }
    // Compute unit vector perpendicular to p01.
    function perp(p0, p1) {
        var u01x = p0[1] - p1[1];
        var u01y = p1[0] - p0[0];
        var u01d = Math.sqrt(u01x * u01x + u01y * u01y);
        return [
            u01x / u01d,
            u01y / u01d
        ];
    }
    function drawReference(g) {
        // bat tip
        g.append('circle').attr('cx', 40).attr('cy', 101) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
        // helmet
        g.append('circle').attr('cx', 18).attr('cy', 86) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
        // back toe
        g.append('circle').attr('cx', 9).attr('cy', 116) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
        // front toe
        g.append('circle').attr('cx', 31).attr('cy', 116) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
        // ball center
        g.append('circle').attr('cx', 40.5).attr('cy', 97.5) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
        // hit tail
        g.append('circle').attr('cx', 291.5).attr('cy', 74.5) // 124 height viewbox
        .attr('r', 0.5).style('fill', '#13b709').style('stroke', 'none');
    }
    return VizHitTracking;
});

});



parcelRegister("3tRLx", function(module, exports) {
"use strict";
function $288dc94be2accbc7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $288dc94be2accbc7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $288dc94be2accbc7$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $288dc94be2accbc7$var$_react = $288dc94be2accbc7$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $llL0N = parcelRequire("llL0N");

var $288dc94be2accbc7$var$_Field = $288dc94be2accbc7$var$_interopRequireDefault((parcelRequire("9l8Ol")));

var $288dc94be2accbc7$var$_Camera = $288dc94be2accbc7$var$_interopRequireDefault((parcelRequire("3aUqX")));

var $288dc94be2accbc7$var$_Trajectory = $288dc94be2accbc7$var$_interopRequireDefault((parcelRequire("9BMbT")));

var $288dc94be2accbc7$var$_SprayChart = $288dc94be2accbc7$var$_interopRequireDefault((parcelRequire("xXdsJ")));
function $288dc94be2accbc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $288dc94be2accbc7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($288dc94be2accbc7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $288dc94be2accbc7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $288dc94be2accbc7$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $288dc94be2accbc7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $288dc94be2accbc7$var$_slicedToArray(r, e) {
    return $288dc94be2accbc7$var$_arrayWithHoles(r) || $288dc94be2accbc7$var$_iterableToArrayLimit(r, e) || $288dc94be2accbc7$var$_unsupportedIterableToArray(r, e) || $288dc94be2accbc7$var$_nonIterableRest();
}
function $288dc94be2accbc7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $288dc94be2accbc7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $288dc94be2accbc7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $288dc94be2accbc7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $288dc94be2accbc7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $288dc94be2accbc7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $288dc94be2accbc7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */  // eslint-disable-line import/no-unresolved
/* Components */ // eslint-disable-line import/no-unresolved
function $288dc94be2accbc7$var$ThreeD(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    // Dynamically set the class after last spray item is added
    var _useState = (0, $288dc94be2accbc7$var$_react.useState)(''), _useState2 = $288dc94be2accbc7$var$_slicedToArray(_useState, 2), id = _useState2[0], setId = _useState2[1];
    // Default position is behind home plate 200ft high
    var defaultCameraPosition = [
        0,
        -150,
        200
    ];
    var defaultCameraLookAt = [
        0,
        127,
        0
    ];
    if (chartOptions.view === 'birdsEye') {
        defaultCameraPosition = [
            0,
            197,
            425
        ];
        defaultCameraLookAt = [
            0,
            197,
            0
        ];
    } else if (chartOptions.view === 'homeLow') {
        defaultCameraPosition = [
            0,
            -120,
            45
        ];
        defaultCameraLookAt = [
            0,
            127,
            0
        ];
    } else if (chartOptions.view === 'cf') {
        defaultCameraPosition = [
            0,
            650,
            225
        ];
        defaultCameraLookAt = [
            0,
            127,
            0
        ];
    }
    var scene = {
        cameraPosition: defaultCameraPosition,
        cameraLookAt: defaultCameraLookAt,
        count: 0
    };
    var chart = [];
    if (chartOptions.overlayType === 'spray') chart.push(/*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement($288dc94be2accbc7$var$_SprayChart["default"], {
        key: "spray-chart",
        settings: settings,
        isFinished: function isFinished(_isFinished) {
            if (_isFinished) setId('three-canvas');
        },
        chartOptions: chartOptions
    }));
    if (chartOptions.overlayType === 'trajectory') settings.data.forEach(function(d, i) {
        var color = chartOptions.color || '#ff0000';
        if (chartOptions.legend && chartOptions.legendType === 'homeRunTypes') {
            if (d.hrCategory === 'No Doubter') color = '#ff5722';
            else if (d.hrCategory === 'Mostly Gone') color = '#3a9098';
            else color = '#9e9e9e';
        }
        chart.push(/*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement($288dc94be2accbc7$var$_Trajectory["default"], {
            key: "trajectory",
            settings: settings,
            isAnimated: false,
            color: color,
            type: "catmull",
            polynomial: d,
            lastUpdate: settings.data.length === i + 1,
            isFinished: function isFinished(lastUpdate) {
                if (lastUpdate) setId('three-canvas');
            }
        }));
    });
    return /*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement($llL0N.Canvas, {
        className: id
    }, /*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement("ambientLight", null), /*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement("pointLight", {
        // eslint-disable-next-line react/no-unknown-property
        position: [
            0,
            -100,
            10
        ],
        intensity: 0.5,
        color: "#f5f5f5"
    }), /*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement($288dc94be2accbc7$var$_Camera["default"], {
        position: scene.cameraPosition,
        lookAt: scene.cameraLookAt,
        isAnimating: false
    }), /*#__PURE__*/ $288dc94be2accbc7$var$_react["default"].createElement($288dc94be2accbc7$var$_Field["default"], {
        id: settings.venueId,
        position: [
            0,
            0,
            0
        ],
        showStadiumName: true,
        stadium: {
            name: 'Kauffman Stadium',
            id: 3
        }
    }), chart);
}
var $288dc94be2accbc7$var$_default = module.exports["default"] = $288dc94be2accbc7$var$ThreeD;

});
parcelRegister("llL0N", function(module, exports) {

$parcel$export(module.exports, "useFrame", () => $f8b006b8f713e37e$export$82cf2c2b26f73925);
$parcel$export(module.exports, "useThree", () => $f8b006b8f713e37e$export$204447131fa2eb7c);
$parcel$export(module.exports, "useUpdate", () => $f8b006b8f713e37e$export$74524c73191a667c);
$parcel$export(module.exports, "Canvas", () => $f8b006b8f713e37e$export$8d01c972ee8b14a9);

var $fXPf9 = parcelRequire("fXPf9");

var $bXxv0 = parcelRequire("bXxv0");

var $h8GDa = parcelRequire("h8GDa");

var $j3P4n = parcelRequire("j3P4n");

var $1qOd3 = parcelRequire("1qOd3");

var $J42oT = parcelRequire("J42oT");

var $hX3ti = parcelRequire("hX3ti");

var $g9e2q = parcelRequire("g9e2q");

var $f3ft4 = parcelRequire("f3ft4");

var $hQ6hF = parcelRequire("hQ6hF");
parcelRequire("gFNaP");
var $2tgzs = parcelRequire("2tgzs");

var $fIPnF = parcelRequire("fIPnF");
var $f8b006b8f713e37e$var$version = "4.0.17";
function $f8b006b8f713e37e$var$_toPropertyKey(arg) {
    var key = $f8b006b8f713e37e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f8b006b8f713e37e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $f8b006b8f713e37e$var$roots = new Map();
const $f8b006b8f713e37e$var$emptyObject = {};
const $f8b006b8f713e37e$var$is = {
    obj: (a)=>a === Object(a),
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false; // Atomic, just compare a against b
        if ($f8b006b8f713e37e$var$is.str(a) || $f8b006b8f713e37e$var$is.num(a) || $f8b006b8f713e37e$var$is.obj(a)) return a === b; // Array, shallow compare first to see if it's a match
        if ($f8b006b8f713e37e$var$is.arr(a) && a == b) return true; // Last resort, go through keys
        let i;
        for(i in a)if (!(i in b)) return false;
        for(i in b)if (a[i] !== b[i]) return false;
        return $f8b006b8f713e37e$var$is.und(i) ? a === b : true;
    }
};
function $f8b006b8f713e37e$var$createSubs(callback, subs) {
    const index = subs.length;
    subs.push(callback);
    return ()=>void subs.splice(index, 1);
}
let $f8b006b8f713e37e$var$globalEffects = [];
let $f8b006b8f713e37e$var$globalTailEffects = [];
const $f8b006b8f713e37e$export$3866278e849dab4e = (callback)=>$f8b006b8f713e37e$var$createSubs(callback, $f8b006b8f713e37e$var$globalEffects);
const $f8b006b8f713e37e$export$55cff6614e9d3c17 = (callback)=>$f8b006b8f713e37e$var$createSubs(callback, $f8b006b8f713e37e$var$globalTailEffects);
function $f8b006b8f713e37e$export$451b5b10d98a301a(state, timestamp, repeat = 0, runGlobalEffects = false) {
    // Run global effects
    if (runGlobalEffects) $f8b006b8f713e37e$var$globalEffects.forEach((effect)=>effect(timestamp) && repeat++); // Run local effects
    const delta = state.current.clock.getDelta();
    state.current.subscribers.forEach((sub)=>sub.ref.current(state.current, delta)); // Decrease frame count
    state.current.frames = Math.max(0, state.current.frames - 1);
    repeat += !state.current.invalidateFrameloop ? 1 : state.current.frames; // Render content
    if (!state.current.manual) state.current.gl.render(state.current.scene, state.current.camera);
    return repeat;
}
let $f8b006b8f713e37e$var$running = false;
function $f8b006b8f713e37e$var$renderLoop(timestamp) {
    $f8b006b8f713e37e$var$running = true;
    let repeat = 0; // Run global effects
    $f8b006b8f713e37e$var$globalEffects.forEach((effect)=>effect(timestamp) && repeat++);
    $f8b006b8f713e37e$var$roots.forEach((root)=>{
        const state = root.containerInfo.__state; // If the frameloop is invalidated, do not run another frame
        if (state.current.active && state.current.ready && (!state.current.invalidateFrameloop || state.current.frames > 0)) repeat = $f8b006b8f713e37e$export$451b5b10d98a301a(state, timestamp, repeat);
    });
    if (repeat !== 0) return requestAnimationFrame($f8b006b8f713e37e$var$renderLoop);
    else // Tail call effects, they are called when rendering stops
    $f8b006b8f713e37e$var$globalTailEffects.forEach((effect)=>effect(timestamp));
     // Flag end of operation
    $f8b006b8f713e37e$var$running = false;
}
function $f8b006b8f713e37e$export$6d6d6ad02cee4c8f(state = true, frames = 2) {
    if (state === true) $f8b006b8f713e37e$var$roots.forEach((root)=>root.containerInfo.__state.current.frames = frames);
    else if (state && state.current) {
        if (state.current.vr) return;
        state.current.frames = frames;
    }
    if (!$f8b006b8f713e37e$var$running) {
        $f8b006b8f713e37e$var$running = true;
        requestAnimationFrame($f8b006b8f713e37e$var$renderLoop);
    }
}
let $f8b006b8f713e37e$var$catalogue = {};
const $f8b006b8f713e37e$export$8b58be045bf06082 = (objects)=>void ($f8b006b8f713e37e$var$catalogue = (0, $fXPf9.default)({}, $f8b006b8f713e37e$var$catalogue, {}, objects));
function $f8b006b8f713e37e$export$d76b848a0167f48b(instance, newProps, oldProps = {}, accumulative = false) {
    // Filter equals, events and reserved props
    const container = instance.__container;
    const sameProps = Object.keys(newProps).filter((key)=>$f8b006b8f713e37e$var$is.equ(newProps[key], oldProps[key]));
    const handlers = Object.keys(newProps).filter((key)=>typeof newProps[key] === 'function' && key.startsWith('on'));
    const leftOvers = accumulative ? Object.keys(oldProps).filter((key)=>newProps[key] === void 0) : [];
    const filteredProps = [
        ...sameProps,
        'children',
        'key',
        'ref'
    ].reduce((acc, prop)=>{
        let rest = (0, $bXxv0.default)(acc, [
            prop
        ].map($f8b006b8f713e37e$var$_toPropertyKey));
        return rest;
    }, newProps); // Add left-overs as undefined props so they can be removed
    leftOvers.forEach((key)=>key !== 'children' && (filteredProps[key] = undefined));
    if (Object.keys(filteredProps).length > 0) {
        Object.entries(filteredProps).forEach(([key, value])=>{
            if (!handlers.includes(key)) {
                let root = instance;
                let target = root[key];
                if (key.includes('-')) {
                    const entries = key.split('-');
                    target = entries.reduce((acc, key)=>acc[key], instance); // If the target is atomic, it forces us to switch the root
                    if (!(target && target.set)) {
                        const [name, ...reverseEntries] = entries.reverse();
                        root = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                        key = name;
                    }
                } // Special treatment for objects with support for set/copy
                if (target && target.set && (target.copy || target instanceof (0, $h8GDa.Layers))) {
                    // If value is an array it has got to be the set function
                    if (Array.isArray(value)) target.set(...value); // Test again target.copy(class) next ...
                    else if (target.copy && value && value.constructor && target.constructor.name === value.constructor.name) target.copy(value); // If nothing else fits, just set the single value, ignore undefined
                    else if (value !== undefined) target.set(value); // Else, just overwrite the value
                } else root[key] = value;
                $f8b006b8f713e37e$var$invalidateInstance(instance);
            }
        }); // Preemptively delete the instance from the containers interaction
        if (accumulative && container && instance.raycast && instance.__handlers) {
            instance.__handlers = undefined;
            const index = container.__interaction.indexOf(instance);
            if (index > -1) container.__interaction.splice(index, 1);
        } // Prep interaction handlers
        if (handlers.length) {
            // Add interactive object to central container
            if (container && instance.raycast) // Unless the only onUpdate is the only event present we flag the instance as interactive
            {
                if (!(handlers.length === 1 && handlers[0] === 'onUpdate')) container.__interaction.push(instance);
            } // Add handlers to the instances handler-map
            instance.__handlers = handlers.reduce((acc, key)=>(0, $fXPf9.default)({}, acc, {
                    [key.charAt(2).toLowerCase() + key.substr(3)]: newProps[key]
                }), {});
        } // Call the update lifecycle when it is being updated, but only when it is part of the scene
        if (instance.parent) $f8b006b8f713e37e$var$updateInstance(instance);
    }
}
function $f8b006b8f713e37e$var$invalidateInstance(instance) {
    if (instance.__container && instance.__container.__state) $f8b006b8f713e37e$export$6d6d6ad02cee4c8f(instance.__container.__state);
}
function $f8b006b8f713e37e$var$updateInstance(instance) {
    if (instance.__handlers && instance.__handlers.update) instance.__handlers.update(instance);
}
function $f8b006b8f713e37e$var$createInstance(type, _ref, container, hostContext, internalInstanceHandle) {
    let { args: args = [] } = _ref, props = (0, $bXxv0.default)(_ref, [
        "args"
    ]);
    let name = "" + type[0].toUpperCase() + type.slice(1);
    let instance;
    if (type === 'primitive') {
        instance = props.object;
        instance.__instance = true;
    } else if (type === 'new') instance = new props.object(args);
    else {
        const target = $f8b006b8f713e37e$var$catalogue[name] || $h8GDa[name];
        instance = $f8b006b8f713e37e$var$is.arr(args) ? new target(...args) : new target(args);
    } // Bind to the root container in case portals are being used
    // This is perhaps better for event management as we can keep them on a single instance
    while(container.__container)container = container.__container;
     // TODO: https://github.com/facebook/react/issues/17147
    // If it's still not there it means the portal was created on a virtual node outside of react
    if (!$f8b006b8f713e37e$var$roots.has(container)) {
        const fn = (node)=>{
            if (!node.return) return node.stateNode && node.stateNode.containerInfo;
            else return fn(node.return);
        };
        container = fn(internalInstanceHandle);
    } // Apply initial props
    instance.__objects = [];
    instance.__container = container; // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
    // view yet. If the callback relies on references for instance, they won't be ready yet, this is
    // why it passes "false" here
    $f8b006b8f713e37e$export$d76b848a0167f48b(instance, props, {});
    return instance;
}
function $f8b006b8f713e37e$var$appendChild(parentInstance, child) {
    if (child) {
        if (child.isObject3D) parentInstance.add(child);
        else {
            parentInstance.__objects.push(child);
            child.parent = parentInstance; // The attach attribute implies that the object attaches itself on the parent
            if (child.attach) parentInstance[child.attach] = child;
            else if (child.attachArray) {
                if (!$f8b006b8f713e37e$var$is.arr(parentInstance[child.attachArray])) parentInstance[child.attachArray] = [];
                parentInstance[child.attachArray].push(child);
            } else if (child.attachObject) {
                if (!$f8b006b8f713e37e$var$is.obj(parentInstance[child.attachObject[0]])) parentInstance[child.attachObject[0]] = {};
                parentInstance[child.attachObject[0]][child.attachObject[1]] = child;
            }
        }
        $f8b006b8f713e37e$var$updateInstance(child);
        $f8b006b8f713e37e$var$invalidateInstance(child);
    }
}
function $f8b006b8f713e37e$var$insertBefore(parentInstance, child, beforeChild) {
    if (child) {
        if (child.isObject3D) {
            child.parent = parentInstance;
            child.dispatchEvent({
                type: 'added'
            }); // TODO: the order is out of whack if data objects are present, has to be recalculated
            const index = parentInstance.children.indexOf(beforeChild);
            parentInstance.children = [
                ...parentInstance.children.slice(0, index),
                child,
                ...parentInstance.children.slice(index)
            ];
            $f8b006b8f713e37e$var$updateInstance(child);
        } else $f8b006b8f713e37e$var$appendChild(parentInstance, child); // TODO: order!!!
        $f8b006b8f713e37e$var$invalidateInstance(child);
    }
}
function $f8b006b8f713e37e$var$removeRecursive(array, parent, clone = false) {
    if (array) {
        // Three uses splice op's internally we may have to shallow-clone the array in order to safely remove items
        const target = clone ? [
            ...array
        ] : array;
        target.forEach((child)=>$f8b006b8f713e37e$var$removeChild(parent, child));
    }
}
function $f8b006b8f713e37e$var$removeChild(parentInstance, child) {
    if (child) {
        if (child.isObject3D) parentInstance.remove(child);
        else {
            child.parent = null;
            parentInstance.__objects = parentInstance.__objects.filter((x)=>x !== child); // Remove attachment
            if (child.attach) parentInstance[child.attach] = null;
            else if (child.attachArray) parentInstance[child.attachArray] = parentInstance[child.attachArray].filter((x)=>x !== child);
            else if (child.attachObject) delete parentInstance[child.attachObject[0]][child.attachObject[1]];
        }
        $f8b006b8f713e37e$var$invalidateInstance(child); // Allow objects to bail out of recursive dispose alltogether by passing dispose={null}
        if (child.dispose !== null) (0, $1qOd3.unstable_runWithPriority)((0, $1qOd3.unstable_IdlePriority), ()=>{
            // Remove interactivity
            if (child.__container) child.__container.__interaction = child.__container.__interaction.filter((x)=>x !== child); // Remove nested child objects
            $f8b006b8f713e37e$var$removeRecursive(child.__objects, child);
            $f8b006b8f713e37e$var$removeRecursive(child.children, child, true); // Dispose item
            if (child.dispose) child.dispose(); // Remove references
            delete child.__container;
            delete child.__objects;
        });
    }
}
function $f8b006b8f713e37e$var$switchInstance(instance, type, newProps, fiber) {
    const parent = instance.parent;
    const newInstance = $f8b006b8f713e37e$var$createInstance(type, newProps, instance.__container, null, fiber);
    $f8b006b8f713e37e$var$removeChild(parent, instance);
    $f8b006b8f713e37e$var$appendChild(parent, newInstance) // This evil hack switches the react-internal fiber node
    ;
    [
        fiber,
        fiber.alternate
    ].forEach((fiber)=>{
        if (fiber !== null) {
            fiber.stateNode = newInstance;
            if (fiber.ref) {
                if (typeof fiber.ref === 'function') fiber.ref(newInstance);
                else fiber.ref.current = newInstance;
            }
        }
    });
}
const $f8b006b8f713e37e$export$88530751e3977073 = (0, (/*@__PURE__*/$parcel$interopDefault($j3P4n)))({
    now: (0, $1qOd3.unstable_now),
    createInstance: $f8b006b8f713e37e$var$createInstance,
    removeChild: $f8b006b8f713e37e$var$removeChild,
    appendChild: $f8b006b8f713e37e$var$appendChild,
    insertBefore: $f8b006b8f713e37e$var$insertBefore,
    supportsMutation: true,
    isPrimaryRenderer: false,
    // @ts-ignore
    scheduleTimeout: typeof setTimeout === 'function' ? setTimeout : undefined,
    cancelTimeout: typeof clearTimeout === 'function' ? clearTimeout : undefined,
    noTimeout: -1,
    appendInitialChild: $f8b006b8f713e37e$var$appendChild,
    appendChildToContainer: $f8b006b8f713e37e$var$appendChild,
    removeChildFromContainer: $f8b006b8f713e37e$var$removeChild,
    insertInContainerBefore: $f8b006b8f713e37e$var$insertBefore,
    commitUpdate (instance, updatePayload, type, oldProps, newProps, fiber) {
        if (instance.__instance && newProps.object && newProps.object !== instance) // <instance object={...} /> where the object reference has changed
        $f8b006b8f713e37e$var$switchInstance(instance, type, newProps, fiber);
        else {
            // This is a data object, let's extract critical information about it
            const { args: argsNew = [] } = newProps, restNew = (0, $bXxv0.default)(newProps, [
                "args"
            ]);
            const { args: argsOld = [] } = oldProps, restOld = (0, $bXxv0.default)(oldProps, [
                "args"
            ]); // If it has new props or arguments, then it needs to be re-instanciated
            const hasNewArgs = argsNew.some((value, index)=>$f8b006b8f713e37e$var$is.obj(value) ? Object.entries(value).some(([key, val])=>val !== argsOld[index][key]) : value !== argsOld[index]);
            if (hasNewArgs) // Next we create a new instance and append it again
            $f8b006b8f713e37e$var$switchInstance(instance, type, newProps, fiber);
            else // Otherwise just overwrite props
            $f8b006b8f713e37e$export$d76b848a0167f48b(instance, restNew, restOld, true);
        }
    },
    hideInstance (instance) {
        if (instance.isObject3D) {
            instance.visible = false;
            $f8b006b8f713e37e$var$invalidateInstance(instance);
        }
    },
    unhideInstance (instance, props) {
        if (instance.isObject3D && props.visible == null || props.visible) {
            instance.visible = true;
            $f8b006b8f713e37e$var$invalidateInstance(instance);
        }
    },
    getPublicInstance (instance) {
        return instance;
    },
    getRootHostContext () {
        return $f8b006b8f713e37e$var$emptyObject;
    },
    getChildHostContext () {
        return $f8b006b8f713e37e$var$emptyObject;
    },
    createTextInstance () {},
    finalizeInitialChildren () {
        return false;
    },
    prepareUpdate () {
        return $f8b006b8f713e37e$var$emptyObject;
    },
    shouldDeprioritizeSubtree () {
        return false;
    },
    prepareForCommit () {},
    resetAfterCommit () {},
    shouldSetTextContent () {
        return false;
    }
});
const $f8b006b8f713e37e$var$LegacyRoot = 0;
const $f8b006b8f713e37e$var$ConcurrentRoot = 2;
const $f8b006b8f713e37e$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
const $f8b006b8f713e37e$var$REACT_PORTAL_TYPE = $f8b006b8f713e37e$var$hasSymbol ? Symbol.for('react.portal') : 0xeaca;
function $f8b006b8f713e37e$export$b3890eb0ae9dca99(element, container, state) {
    let root = $f8b006b8f713e37e$var$roots.get(container);
    if (!root) {
        container.__state = state;
        let newRoot = root = $f8b006b8f713e37e$export$88530751e3977073.createContainer(container, state !== undefined && state.current.concurrent ? $f8b006b8f713e37e$var$ConcurrentRoot : $f8b006b8f713e37e$var$LegacyRoot, false);
        $f8b006b8f713e37e$var$roots.set(container, newRoot);
    }
    $f8b006b8f713e37e$export$88530751e3977073.updateContainer(element, root, null, ()=>undefined);
    return $f8b006b8f713e37e$export$88530751e3977073.getPublicRootInstance(root);
}
function $f8b006b8f713e37e$export$502457920280e6be(container) {
    const root = $f8b006b8f713e37e$var$roots.get(container);
    if (root) $f8b006b8f713e37e$export$88530751e3977073.updateContainer(null, root, null, ()=>void $f8b006b8f713e37e$var$roots.delete(container));
}
function $f8b006b8f713e37e$export$d39a5bbd09211389(children, containerInfo, implementation, key = null) {
    if (!containerInfo.__objects) containerInfo.__objects = [];
    return {
        $$typeof: $f8b006b8f713e37e$var$REACT_PORTAL_TYPE,
        key: key == null ? null : '' + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
$f8b006b8f713e37e$export$88530751e3977073.injectIntoDevTools({
    bundleType: 1,
    version: $f8b006b8f713e37e$var$version,
    rendererPackageName: 'react-three-fiber',
    findHostInstanceByFiber: $f8b006b8f713e37e$export$88530751e3977073.findHostInstance
});
function $f8b006b8f713e37e$export$a1d5c052a051c03a(def) {
    return def.isOrthographicCamera;
}
function $f8b006b8f713e37e$var$makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index;
}
const $f8b006b8f713e37e$export$7c2f185dd4961aa6 = (0, $J42oT.createContext)({});
const $f8b006b8f713e37e$export$9682f81622c6687d = (props)=>{
    const { children: children, gl: gl, camera: camera, orthographic: orthographic, raycaster: raycaster, size: size, pixelRatio: pixelRatio, vr: vr = false, concurrent: concurrent = false, shadowMap: shadowMap = false, invalidateFrameloop: invalidateFrameloop = false, updateDefaultCamera: updateDefaultCamera = true, noEvents: noEvents = false, onCreated: onCreated, onPointerMissed: onPointerMissed } = props; // Local, reactive state
    const [ready, setReady] = (0, $J42oT.useState)(false);
    const [mouse] = (0, $J42oT.useState)(()=>new (0, $h8GDa.Vector2)());
    const [defaultRaycaster] = (0, $J42oT.useState)(()=>{
        const ray = new (0, $h8GDa.Raycaster)();
        if (raycaster) {
            const raycasterProps = (0, $bXxv0.default)(raycaster, [
                "filter"
            ]);
            $f8b006b8f713e37e$export$d76b848a0167f48b(ray, raycasterProps, {});
        }
        return ray;
    });
    const [defaultScene] = (0, $J42oT.useState)(()=>{
        const scene = new (0, $h8GDa.Scene)();
        scene.__interaction = [];
        scene.__objects = [];
        return scene;
    });
    const [defaultCam, _setDefaultCamera] = (0, $J42oT.useState)(()=>{
        const cam = orthographic ? new (0, $h8GDa.OrthographicCamera)(0, 0, 0, 0, 0.1, 1000) : new (0, $h8GDa.PerspectiveCamera)(75, 0, 0.1, 1000);
        cam.position.z = 5;
        if (camera) $f8b006b8f713e37e$export$d76b848a0167f48b(cam, camera, {});
        return cam;
    });
    const [clock] = (0, $J42oT.useState)(()=>new (0, $h8GDa.Clock)()); // Public state
    const state = (0, $J42oT.useRef)({
        ready: false,
        active: true,
        manual: 0,
        vr: vr,
        concurrent: concurrent,
        noEvents: noEvents,
        invalidateFrameloop: false,
        frames: 0,
        aspect: 0,
        subscribers: [],
        camera: defaultCam,
        scene: defaultScene,
        raycaster: defaultRaycaster,
        mouse: mouse,
        clock: clock,
        gl: gl,
        size: size,
        viewport: {
            width: 0,
            height: 0,
            factor: 0
        },
        initialClick: [
            0,
            0
        ],
        initialHits: [],
        pointer: new (0, $hX3ti.TinyEmitter)(),
        captured: undefined,
        events: undefined,
        subscribe: (ref, priority = 0)=>{
            // If this subscription was given a priority, it takes rendering into its own hands
            // For that reason we switch off automatic rendering and increase the manual flag
            // As long as this flag is positive (there could be multiple render subscription)
            // ..there can be no internal rendering at all
            if (priority) state.current.manual++;
            state.current.subscribers.push({
                ref: ref,
                priority: priority
            }); // Sort layers from lowest to highest, meaning, highest priority renders last (on top of the other frames)
            state.current.subscribers = state.current.subscribers.sort((a, b)=>a.priority - b.priority);
            return ()=>{
                // Decrease manual flag if this subscription had a priority
                if (priority) state.current.manual--;
                state.current.subscribers = state.current.subscribers.filter((s)=>s.ref !== ref);
            };
        },
        setDefaultCamera: (camera)=>_setDefaultCamera(camera),
        invalidate: ()=>$f8b006b8f713e37e$export$6d6d6ad02cee4c8f(state),
        intersect: (event)=>handlePointerMove(event || {})
    }); // Writes locals into public state for distribution among subscribers, context, etc
    (0, $J42oT.useMemo)(()=>{
        state.current.ready = ready;
        state.current.size = size;
        state.current.camera = defaultCam;
        state.current.invalidateFrameloop = invalidateFrameloop;
        state.current.vr = vr;
        state.current.gl = gl;
        state.current.concurrent = concurrent;
        state.current.noEvents = noEvents;
    }, [
        invalidateFrameloop,
        vr,
        concurrent,
        noEvents,
        ready,
        size,
        defaultCam,
        gl
    ]); // Adjusts default camera
    (0, $J42oT.useMemo)(()=>{
        state.current.aspect = size.width / size.height;
        if ($f8b006b8f713e37e$export$a1d5c052a051c03a(defaultCam)) state.current.viewport = {
            width: size.width,
            height: size.height,
            factor: 1
        };
        else {
            const target = new (0, $h8GDa.Vector3)(0, 0, 0);
            const distance = defaultCam.position.distanceTo(target);
            const fov = defaultCam.fov * Math.PI / 180; // convert vertical fov to radians
            const height = 2 * Math.tan(fov / 2) * distance; // visible height
            const width = height * state.current.aspect;
            state.current.viewport = {
                width: width,
                height: height,
                factor: size.width / width
            };
        } // #92 (https://github.com/drcmda/react-three-fiber/issues/92)
        // Sometimes automatic default camera adjustment isn't wanted behaviour
        if (updateDefaultCamera) {
            if ($f8b006b8f713e37e$export$a1d5c052a051c03a(defaultCam)) {
                defaultCam.left = size.width / -2;
                defaultCam.right = size.width / 2;
                defaultCam.top = size.height / 2;
                defaultCam.bottom = size.height / -2;
            } else defaultCam.aspect = state.current.aspect;
            defaultCam.updateProjectionMatrix(); // #178: https://github.com/react-spring/react-three-fiber/issues/178
            // Update matrix world since the renderer is a frame late
            defaultCam.updateMatrixWorld();
        }
        gl.setSize(size.width, size.height);
        if (ready) $f8b006b8f713e37e$export$6d6d6ad02cee4c8f(state);
    }, [
        defaultCam,
        size,
        updateDefaultCamera
    ]);
    /** Events ------------------------------------------------------------------------------------------------ */ /** Sets up defaultRaycaster */ const prepareRay = (0, $J42oT.useCallback)(({ clientX: clientX, clientY: clientY })=>{
        if (clientX !== void 0) {
            const { left: left, right: right, top: top, bottom: bottom } = state.current.size;
            mouse.set((clientX - left) / (right - left) * 2 - 1, -((clientY - top) / (bottom - top)) * 2 + 1);
            defaultRaycaster.setFromCamera(mouse, state.current.camera);
        }
    }, []);
    /** Intersects interaction objects using the event input */ const intersect = (0, $J42oT.useCallback)((event, prepare = true)=>{
        // Skip event handling when noEvents is set
        if (state.current.noEvents) return [];
        if (prepare) prepareRay(event);
        const seen = new Set();
        const hits = []; // Intersect known handler objects and filter against duplicates
        let intersects = defaultRaycaster.intersectObjects(state.current.scene.__interaction, true).filter((item)=>{
            const id = $f8b006b8f713e37e$var$makeId(item);
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        }); // #16031: (https://github.com/mrdoob/three.js/issues/16031)
        // Allow custom userland intersect sort order
        if (raycaster && raycaster.filter && sharedState.current) intersects = raycaster.filter(intersects, sharedState.current);
        for (let intersect of intersects){
            let eventObject = intersect.object; // Bubble event up
            while(eventObject){
                const handlers = eventObject.__handlers;
                if (handlers) hits.push((0, $fXPf9.default)({}, intersect, {
                    eventObject: eventObject
                }));
                eventObject = eventObject.parent;
            }
        }
        return hits;
    }, []);
    /**  Calculates click deltas */ const calculateDistance = (0, $J42oT.useCallback)((event)=>{
        let dx = event.clientX - state.current.initialClick[0];
        let dy = event.clientY - state.current.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }, []);
    const hovered = (0, $J42oT.useMemo)(()=>new Map(), []);
    /**  Handles intersections by forwarding them to handlers */ const handleIntersects = (0, $J42oT.useCallback)((event, fn)=>{
        prepareRay(event); // Get fresh intersects
        const hits = intersect(event, false); // If the interaction is captured take that into account, the captured event has to be part of the intersects
        if (state.current.captured && event.type !== 'click' && event.type !== 'wheel') state.current.captured.forEach((captured)=>{
            if (!hits.find((hit)=>hit.eventObject === captured.eventObject)) hits.push(captured);
        });
         // If anything has been found, forward it to the event listeners
        if (hits.length) {
            const unprojectedPoint = new (0, $h8GDa.Vector3)(mouse.x, mouse.y, 0).unproject(state.current.camera);
            const delta = event.type === 'click' ? calculateDistance(event) : 0;
            for (let hit of hits){
                let stopped = {
                    current: false
                };
                let raycastEvent = (0, $fXPf9.default)({}, event, {}, hit, {
                    stopped: stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: defaultRaycaster.ray,
                    camera: state.current.camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation: ()=>stopped.current = true,
                    sourceEvent: event
                });
                fn(raycastEvent);
                if (stopped.current === true) {
                    // Propagation is stopped, remove all other hover records
                    // An event handler is only allowed to flush other handlers if it is hovered itself
                    if (hovered.size && Array.from(hovered.values()).find((i)=>i.object === hit.object)) handlePointerCancel(raycastEvent, [
                        hit
                    ]);
                    break;
                }
            }
        }
        return hits;
    }, []);
    const handlePointerMove = (0, $J42oT.useCallback)((event)=>{
        state.current.pointer.emit('pointerMove', event);
        const hits = handleIntersects(event, (data)=>{
            const eventObject = data.eventObject;
            const handlers = eventObject.__handlers; // Check presence of handlers
            if (!handlers) return; // Call mouse move
            if (handlers.pointerMove) handlers.pointerMove(data); // Check if mouse enter or out is present
            if (handlers.pointerOver || handlers.pointerEnter || handlers.pointerOut || handlers.pointerLeave) {
                const id = $f8b006b8f713e37e$var$makeId(data);
                const hoveredItem = hovered.get(id);
                if (!hoveredItem) {
                    // If the object wasn't previously hovered, book it and call its handler
                    hovered.set(id, data);
                    if (handlers.pointerOver) handlers.pointerOver((0, $fXPf9.default)({}, data, {
                        type: 'pointerover'
                    }));
                    if (handlers.pointerEnter) handlers.pointerEnter((0, $fXPf9.default)({}, data, {
                        type: 'pointerEnter'
                    }));
                } else if (hoveredItem.stopped.current) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                data.stopPropagation();
            }
        }); // Take care of unhover
        handlePointerCancel(event, hits);
        return hits;
    }, []);
    const handlePointerCancel = (0, $J42oT.useCallback)((event, hits)=>{
        state.current.pointer.emit('pointerCancel', event);
        if (!hits) hits = handleIntersects(event, ()=>null);
        Array.from(hovered.values()).forEach((data)=>{
            // When no objects were hit or the the hovered object wasn't found underneath the cursor
            // we call onPointerOut and delete the object from the hovered-elements map
            if (hits && (!hits.length || !hits.find((i)=>i.eventObject === data.eventObject))) {
                const eventObject = data.eventObject;
                const handlers = eventObject.__handlers;
                if (handlers) {
                    if (handlers.pointerOut) handlers.pointerOut((0, $fXPf9.default)({}, data, {
                        type: 'pointerout'
                    }));
                    if (handlers.pointerLeave) handlers.pointerLeave((0, $fXPf9.default)({}, data, {
                        type: 'pointerleave'
                    }));
                }
                hovered.delete($f8b006b8f713e37e$var$makeId(data));
            }
        });
    }, []);
    const handlePointer = (0, $J42oT.useCallback)((name)=>(event)=>{
            state.current.pointer.emit(name, event); // Collect hits
            const hits = handleIntersects(event, (data)=>{
                const eventObject = data.eventObject;
                const handlers = eventObject.__handlers;
                if (handlers && handlers[name]) // Forward all events back to their respective handlers with the exception of click,
                // which must must the initial target
                {
                    if (name !== 'click' || state.current.initialHits.includes(eventObject)) handlers[name](data);
                }
            }); // If a click yields no results, pass it back to the user as a miss
            if (name === 'pointerDown') {
                state.current.initialClick = [
                    event.clientX,
                    event.clientY
                ];
                state.current.initialHits = hits.map((hit)=>hit.eventObject);
            }
            if (name === 'click' && !hits.length && onPointerMissed) {
                if (calculateDistance(event) <= 2) onPointerMissed();
            }
        }, [
        onPointerMissed
    ]);
    (0, $J42oT.useMemo)(()=>{
        state.current.events = {
            onClick: handlePointer('click'),
            onWheel: handlePointer('wheel'),
            onPointerDown: handlePointer('pointerDown'),
            onPointerUp: handlePointer('pointerUp'),
            onPointerLeave: (e)=>handlePointerCancel(e, []),
            onPointerMove: handlePointerMove,
            onGotPointerCapture: (e)=>state.current.captured = intersect(e, false),
            onLostPointerCapture: (e)=>(state.current.captured = undefined, handlePointerCancel(e))
        };
    }, [
        onPointerMissed
    ]);
    /** Events ------------------------------------------------------------------------------------------------- */ // Only trigger the context provider when necessary
    const sharedState = (0, $J42oT.useRef)();
    (0, $J42oT.useMemo)(()=>{
        const _state$current = state.current, props = (0, $bXxv0.default)(_state$current, [
            "ready",
            "manual",
            "vr",
            "noEvents",
            "invalidateFrameloop",
            "frames",
            "subscribers",
            "captured",
            "initialClick",
            "initialHits"
        ]);
        sharedState.current = props;
    }, [
        size,
        defaultCam
    ]); // Update pixel ratio
    (0, $J42oT.useLayoutEffect)(()=>void (pixelRatio && gl.setPixelRatio(pixelRatio)), [
        pixelRatio
    ]); // Update shadow map
    (0, $J42oT.useLayoutEffect)(()=>{
        if (shadowMap) {
            gl.shadowMap.enabled = true;
            if (typeof shadowMap === 'object') Object.assign(gl, shadowMap);
            else gl.shadowMap.type = (0, $h8GDa.PCFSoftShadowMap);
        }
    }, [
        shadowMap
    ]); // This component is a bridge into the three render context, when it gets rendered
    // we know we are ready to compile shaders, call subscribers, etc
    const Canvas = (0, $J42oT.useCallback)(function Canvas(props) {
        const activate = ()=>setReady(true); // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $J42oT.useEffect)(()=>{
            const result = onCreated && onCreated(state.current);
            return void (result && result.then ? result.then(activate) : activate());
        }, []);
        return props.children;
    }, []); // Render v-dom into scene
    (0, $J42oT.useLayoutEffect)(()=>{
        $f8b006b8f713e37e$export$b3890eb0ae9dca99((0, $J42oT.createElement)(Canvas, null, (0, $J42oT.createElement)($f8b006b8f713e37e$export$7c2f185dd4961aa6.Provider, {
            value: sharedState.current
        }, typeof children === 'function' ? children(state.current) : children)), defaultScene, state);
    }, [
        ready,
        children,
        sharedState.current
    ]);
    (0, $J42oT.useLayoutEffect)(()=>{
        if (ready) {
            // Start render-loop, either via RAF or setAnimationLoop for VR
            if (!state.current.vr) $f8b006b8f713e37e$export$6d6d6ad02cee4c8f(state);
            else if ((gl.xr || gl.vr) && gl.setAnimationLoop) {
                (gl.xr || gl.vr).enabled = true;
                gl.setAnimationLoop((t)=>$f8b006b8f713e37e$export$451b5b10d98a301a(state, t, 0, true));
            } else console.warn('the gl instance does not support VR!');
        }
    }, [
        ready,
        invalidateFrameloop
    ]); // Dispose renderer on unmount
    (0, $J42oT.useEffect)(()=>()=>{
            if (state.current.gl) {
                if (state.current.gl.forceContextLoss) state.current.gl.forceContextLoss();
                if (state.current.gl.dispose) state.current.gl.dispose();
                state.current.gl = undefined;
                $f8b006b8f713e37e$export$502457920280e6be(state.current.scene);
                state.current.active = false;
            }
        }, []);
    return state.current.events;
};
function $f8b006b8f713e37e$var$useContext(context) {
    let result = (0, $J42oT.useContext)(context);
    if (!result) console.warn('hooks can only be used within the canvas! https://github.com/react-spring/react-three-fiber#hooks');
    return result;
}
function $f8b006b8f713e37e$export$82cf2c2b26f73925(callback, renderPriority = 0) {
    const { subscribe: subscribe } = $f8b006b8f713e37e$var$useContext($f8b006b8f713e37e$export$7c2f185dd4961aa6); // Update ref
    const ref = (0, $J42oT.useRef)(callback);
    (0, $J42oT.useLayoutEffect)(()=>void (ref.current = callback), [
        callback
    ]); // Subscribe/unsub
    (0, $J42oT.useEffect)(()=>{
        const unsubscribe = subscribe(ref, renderPriority);
        return ()=>unsubscribe();
    }, [
        renderPriority
    ]);
    return null;
}
function $f8b006b8f713e37e$export$204447131fa2eb7c() {
    return $f8b006b8f713e37e$var$useContext($f8b006b8f713e37e$export$7c2f185dd4961aa6);
}
function $f8b006b8f713e37e$export$74524c73191a667c(callback, dependents, optionalRef) {
    const { invalidate: invalidate } = $f8b006b8f713e37e$var$useContext($f8b006b8f713e37e$export$7c2f185dd4961aa6);
    const localRef = (0, $J42oT.useRef)();
    const ref = optionalRef ? optionalRef : localRef;
    (0, $J42oT.useEffect)(()=>{
        if (ref.current) {
            callback(ref.current);
            invalidate();
        }
    }, dependents);
    return ref;
}
function $f8b006b8f713e37e$export$9f6abfd74295843b(optionalRef) {
    const [_, forceUpdate] = (0, $J42oT.useState)(false);
    const localRef = (0, $J42oT.useRef)(undefined);
    const ref = optionalRef ? optionalRef : localRef;
    (0, $J42oT.useEffect)(()=>void forceUpdate((i)=>!i), [
        ref.current
    ]);
    return [
        ref,
        ref.current
    ];
}
const $f8b006b8f713e37e$var$blackList = [
    'id',
    'uuid',
    'type',
    'children',
    'parent',
    'matrix',
    'matrixWorld',
    'matrixWorldNeedsUpdate',
    'modelViewMatrix',
    'normalMatrix'
];
function $f8b006b8f713e37e$var$prune(props) {
    const reducedProps = (0, $fXPf9.default)({}, props); // Remove black listed props
    $f8b006b8f713e37e$var$blackList.forEach((name)=>delete reducedProps[name]); // Remove functions
    Object.keys(reducedProps).forEach((name)=>typeof reducedProps[name] === 'function' && delete reducedProps[name]); // Prune materials and geometries
    if (reducedProps.material) reducedProps.material = $f8b006b8f713e37e$var$prune(reducedProps.material);
    if (reducedProps.geometry) reducedProps.geometry = $f8b006b8f713e37e$var$prune(reducedProps.geometry); // Return cleansed object
    return reducedProps;
}
function $f8b006b8f713e37e$export$14095de704efe3f9(Proto, url, extensions) {
    const loader = (0, $J42oT.useMemo)(()=>{
        // Construct new loader
        const temp = new Proto(); // Run loader extensions
        if (extensions) extensions(temp);
        return temp;
    }, [
        Proto
    ]); // Use suspense to load async assets
    const results = (0, (/*@__PURE__*/$parcel$interopDefault($g9e2q)))((Proto, url)=>{
        const urlArray = Array.isArray(url) ? url : [
            url
        ];
        return Promise.all(urlArray.map((url)=>new Promise((res)=>loader.load(url, (data)=>{
                    if (data.scene) {
                        // This has to be deprecated at some point!
                        data.__$ = []; // Nodes and materials are better
                        data.nodes = {};
                        data.materials = {};
                        data.scene.traverse((obj)=>{
                            data.__$.push($f8b006b8f713e37e$var$prune(obj));
                            if (obj.name) data.nodes = (0, $fXPf9.default)({}, data.nodes, {
                                [obj.name]: obj
                            });
                            if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
                        });
                    }
                    res(data);
                }))));
    }, [
        Proto,
        url
    ]); // Return the object/s
    return Array.isArray(url) ? results : results[0];
}
function $f8b006b8f713e37e$export$91d88843bfb219ae(camera, props) {
    const { mouse: mouse } = $f8b006b8f713e37e$export$204447131fa2eb7c();
    const [raycast] = (0, $J42oT.useState)(()=>{
        let raycaster = new (0, $h8GDa.Raycaster)();
        if (props) $f8b006b8f713e37e$export$d76b848a0167f48b(raycaster, props, {});
        return function(_, intersects) {
            raycaster.setFromCamera(mouse, camera);
            const rc = this.constructor.prototype.raycast.bind(this);
            if (rc) rc(raycaster, intersects);
        };
    });
    return raycast;
}
const $f8b006b8f713e37e$var$vector = new (0, $h8GDa.Vector3)();
function $f8b006b8f713e37e$var$calculatePosition(el, camera, size) {
    $f8b006b8f713e37e$var$vector.setFromMatrixPosition(el.matrixWorld);
    $f8b006b8f713e37e$var$vector.project(camera);
    const widthHalf = size.width / 2;
    const heightHalf = size.height / 2;
    return [
        $f8b006b8f713e37e$var$vector.x * widthHalf + widthHalf,
        -($f8b006b8f713e37e$var$vector.y * heightHalf) + heightHalf
    ];
}
const $f8b006b8f713e37e$export$1e2eb70c93855705 = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).forwardRef((_ref, ref)=>{
    let { children: children, eps: eps = 0.001, style: style, className: className, prepend: prepend, center: center } = _ref, props = (0, $bXxv0.default)(_ref, [
        "children",
        "eps",
        "style",
        "className",
        "prepend",
        "center"
    ]);
    const { gl: gl, scene: scene, camera: camera, size: size } = $f8b006b8f713e37e$export$204447131fa2eb7c();
    const [el] = (0, $J42oT.useState)(()=>document.createElement('div'));
    const group = (0, $J42oT.useRef)(null);
    const old = (0, $J42oT.useRef)([
        0,
        0
    ]);
    (0, $J42oT.useEffect)(()=>{
        if (group.current) {
            scene.updateMatrixWorld();
            const vec = $f8b006b8f713e37e$var$calculatePosition(group.current, camera, size);
            el.style.cssText = "position:absolute;top:0;left:0;transform:translate3d(" + vec[0] + "px," + vec[1] + "px,0);";
            if (gl.domElement.parentNode) {
                if (prepend) gl.domElement.parentNode.prepend(el);
                else gl.domElement.parentNode.appendChild(el);
            }
            return ()=>{
                if (gl.domElement.parentNode) gl.domElement.parentNode.removeChild(el);
                (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).unmountComponentAtNode(el);
            };
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $J42oT.useEffect)(()=>void (0, (/*@__PURE__*/$parcel$interopDefault($f3ft4))).render((0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("div", {
            style: (0, $fXPf9.default)({
                transform: center ? 'translate3d(-50%,-50%,0)' : 'none'
            }, style),
            className: className,
            ref: ref
        }, children), el));
    $f8b006b8f713e37e$export$82cf2c2b26f73925(()=>{
        if (group.current) {
            const vec = $f8b006b8f713e37e$var$calculatePosition(group.current, camera, size);
            if (Math.abs(old.current[0] - vec[0]) > eps || Math.abs(old.current[1] - vec[1]) > eps) el.style.transform = "translate3d(" + vec[0] + "px," + vec[1] + "px,0)";
            old.current = vec;
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("group", (0, $fXPf9.default)({}, props, {
        ref: group
    }));
});
const $f8b006b8f713e37e$var$defaultStyles = {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
};
function $f8b006b8f713e37e$var$Content(_ref) {
    let { children: children, setEvents: setEvents, container: container, renderer: renderer, effects: effects } = _ref, props = (0, $bXxv0.default)(_ref, [
        "children",
        "setEvents",
        "container",
        "renderer",
        "effects"
    ]);
    // Create renderer
    const [gl] = (0, $J42oT.useState)(renderer);
    if (!gl) console.warn('No renderer created!'); // Mount and unmount managemenbt
    (0, $J42oT.useEffect)(()=>effects && effects(gl, container), []); // Init canvas, fetch events, hand them back to the wrapping div
    const events = $f8b006b8f713e37e$export$9682f81622c6687d((0, $fXPf9.default)({}, props, {
        children: children,
        gl: gl
    }));
    (0, $J42oT.useEffect)(()=>void setEvents(events), [
        events
    ]);
    return null;
}
const $f8b006b8f713e37e$var$ResizeContainer = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).memo(function ResizeContainer(props) {
    const { preRender: preRender, resize: resize, style: style } = props, restSpread = (0, $bXxv0.default)(props, [
        "renderer",
        "effects",
        "children",
        "vr",
        "gl2",
        "concurrent",
        "shadowMap",
        "orthographic",
        "invalidateFrameloop",
        "updateDefaultCamera",
        "noEvents",
        "gl",
        "camera",
        "raycaster",
        "pixelRatio",
        "onCreated",
        "onPointerMissed",
        "preRender",
        "resize",
        "style"
    ]);
    const containerRef = (0, $J42oT.useRef)();
    const [events, setEvents] = (0, $J42oT.useState)({});
    const [bind, size] = (0, $hQ6hF.default)(resize || {
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        polyfill: typeof window === 'undefined' || !window.ResizeObserver ? (0, $2tgzs.ResizeObserver) : undefined
    }); // Flag view ready once it's been measured out
    const readyFlag = (0, $J42oT.useRef)(false);
    const ready = (0, $J42oT.useMemo)(()=>readyFlag.current = readyFlag.current || !!size.width && !!size.height, [
        size
    ]);
    const state = (0, $J42oT.useMemo)(()=>({
            size: size,
            setEvents: setEvents,
            container: containerRef.current
        }), [
        size
    ]); // Allow Gatsby, Next and other server side apps to run. Will output styles to reduce flickering.
    if (typeof window === 'undefined') return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("div", (0, $fXPf9.default)({
        style: (0, $fXPf9.default)({}, $f8b006b8f713e37e$var$defaultStyles, {}, style)
    }, restSpread), preRender); // Render the canvas into the dom
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("div", (0, $fXPf9.default)({
        ref: (0, $fIPnF.default)([
            bind,
            containerRef
        ]),
        style: (0, $fXPf9.default)({}, $f8b006b8f713e37e$var$defaultStyles, {}, style)
    }, events, restSpread), preRender, ready && (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement($f8b006b8f713e37e$var$Content, (0, $fXPf9.default)({}, props, state)));
});
const $f8b006b8f713e37e$export$8d01c972ee8b14a9 = (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).memo(function Canvas(_ref) {
    let { children: children } = _ref, props = (0, $bXxv0.default)(_ref, [
        "children"
    ]);
    const canvasRef = (0, $J42oT.useRef)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement($f8b006b8f713e37e$var$ResizeContainer, (0, $fXPf9.default)({}, props, {
        renderer: ()=>{
            if (canvasRef.current) {
                const params = (0, $fXPf9.default)({
                    antialias: true,
                    alpha: true
                }, props.gl);
                const temp = new (0, $h8GDa.WebGLRenderer)((0, $fXPf9.default)({
                    canvas: canvasRef.current,
                    context: props.gl2 ? canvasRef.current.getContext('webgl2', params) : undefined
                }, params));
                return temp;
            }
        },
        preRender: (0, (/*@__PURE__*/$parcel$interopDefault($J42oT))).createElement("canvas", {
            ref: canvasRef,
            style: {
                display: 'block'
            }
        })
    }), children);
});

});
parcelRegister("h8GDa", function(module, exports) {

$parcel$export(module.exports, "REVISION", () => REVISION);
$parcel$export(module.exports, "MOUSE", () => MOUSE);
$parcel$export(module.exports, "TOUCH", () => TOUCH);
$parcel$export(module.exports, "CullFaceNone", () => CullFaceNone);
$parcel$export(module.exports, "CullFaceBack", () => CullFaceBack);
$parcel$export(module.exports, "CullFaceFront", () => CullFaceFront);
$parcel$export(module.exports, "CullFaceFrontBack", () => CullFaceFrontBack);
$parcel$export(module.exports, "BasicShadowMap", () => BasicShadowMap);
$parcel$export(module.exports, "PCFShadowMap", () => PCFShadowMap);
$parcel$export(module.exports, "PCFSoftShadowMap", () => PCFSoftShadowMap);
$parcel$export(module.exports, "VSMShadowMap", () => VSMShadowMap);
$parcel$export(module.exports, "FrontSide", () => FrontSide);
$parcel$export(module.exports, "BackSide", () => BackSide);
$parcel$export(module.exports, "DoubleSide", () => DoubleSide);
$parcel$export(module.exports, "FlatShading", () => FlatShading);
$parcel$export(module.exports, "SmoothShading", () => SmoothShading);
$parcel$export(module.exports, "NoBlending", () => NoBlending);
$parcel$export(module.exports, "NormalBlending", () => NormalBlending);
$parcel$export(module.exports, "AdditiveBlending", () => AdditiveBlending);
$parcel$export(module.exports, "SubtractiveBlending", () => SubtractiveBlending);
$parcel$export(module.exports, "MultiplyBlending", () => MultiplyBlending);
$parcel$export(module.exports, "CustomBlending", () => CustomBlending);
$parcel$export(module.exports, "AddEquation", () => AddEquation);
$parcel$export(module.exports, "SubtractEquation", () => SubtractEquation);
$parcel$export(module.exports, "ReverseSubtractEquation", () => ReverseSubtractEquation);
$parcel$export(module.exports, "MinEquation", () => MinEquation);
$parcel$export(module.exports, "MaxEquation", () => MaxEquation);
$parcel$export(module.exports, "ZeroFactor", () => ZeroFactor);
$parcel$export(module.exports, "OneFactor", () => OneFactor);
$parcel$export(module.exports, "SrcColorFactor", () => SrcColorFactor);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => OneMinusSrcColorFactor);
$parcel$export(module.exports, "SrcAlphaFactor", () => SrcAlphaFactor);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => OneMinusSrcAlphaFactor);
$parcel$export(module.exports, "DstAlphaFactor", () => DstAlphaFactor);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => OneMinusDstAlphaFactor);
$parcel$export(module.exports, "DstColorFactor", () => DstColorFactor);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => OneMinusDstColorFactor);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => SrcAlphaSaturateFactor);
$parcel$export(module.exports, "NeverDepth", () => NeverDepth);
$parcel$export(module.exports, "AlwaysDepth", () => AlwaysDepth);
$parcel$export(module.exports, "LessDepth", () => LessDepth);
$parcel$export(module.exports, "LessEqualDepth", () => LessEqualDepth);
$parcel$export(module.exports, "EqualDepth", () => EqualDepth);
$parcel$export(module.exports, "GreaterEqualDepth", () => GreaterEqualDepth);
$parcel$export(module.exports, "GreaterDepth", () => GreaterDepth);
$parcel$export(module.exports, "NotEqualDepth", () => NotEqualDepth);
$parcel$export(module.exports, "MultiplyOperation", () => MultiplyOperation);
$parcel$export(module.exports, "MixOperation", () => MixOperation);
$parcel$export(module.exports, "AddOperation", () => AddOperation);
$parcel$export(module.exports, "NoToneMapping", () => NoToneMapping);
$parcel$export(module.exports, "LinearToneMapping", () => LinearToneMapping);
$parcel$export(module.exports, "ReinhardToneMapping", () => ReinhardToneMapping);
$parcel$export(module.exports, "CineonToneMapping", () => CineonToneMapping);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => ACESFilmicToneMapping);
$parcel$export(module.exports, "CustomToneMapping", () => CustomToneMapping);
$parcel$export(module.exports, "UVMapping", () => UVMapping);
$parcel$export(module.exports, "CubeReflectionMapping", () => CubeReflectionMapping);
$parcel$export(module.exports, "CubeRefractionMapping", () => CubeRefractionMapping);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => EquirectangularReflectionMapping);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => EquirectangularRefractionMapping);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => CubeUVReflectionMapping);
$parcel$export(module.exports, "CubeUVRefractionMapping", () => CubeUVRefractionMapping);
$parcel$export(module.exports, "RepeatWrapping", () => RepeatWrapping);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => ClampToEdgeWrapping);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => MirroredRepeatWrapping);
$parcel$export(module.exports, "NearestFilter", () => NearestFilter);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => NearestMipmapNearestFilter);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => NearestMipMapNearestFilter);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => NearestMipmapLinearFilter);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => NearestMipMapLinearFilter);
$parcel$export(module.exports, "LinearFilter", () => LinearFilter);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => LinearMipmapNearestFilter);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => LinearMipMapNearestFilter);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => LinearMipmapLinearFilter);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => LinearMipMapLinearFilter);
$parcel$export(module.exports, "UnsignedByteType", () => UnsignedByteType);
$parcel$export(module.exports, "ByteType", () => ByteType);
$parcel$export(module.exports, "ShortType", () => ShortType);
$parcel$export(module.exports, "UnsignedShortType", () => UnsignedShortType);
$parcel$export(module.exports, "IntType", () => IntType);
$parcel$export(module.exports, "UnsignedIntType", () => UnsignedIntType);
$parcel$export(module.exports, "FloatType", () => FloatType);
$parcel$export(module.exports, "HalfFloatType", () => HalfFloatType);
$parcel$export(module.exports, "UnsignedShort4444Type", () => UnsignedShort4444Type);
$parcel$export(module.exports, "UnsignedShort5551Type", () => UnsignedShort5551Type);
$parcel$export(module.exports, "UnsignedShort565Type", () => UnsignedShort565Type);
$parcel$export(module.exports, "UnsignedInt248Type", () => UnsignedInt248Type);
$parcel$export(module.exports, "AlphaFormat", () => AlphaFormat);
$parcel$export(module.exports, "RGBFormat", () => RGBFormat);
$parcel$export(module.exports, "RGBAFormat", () => RGBAFormat);
$parcel$export(module.exports, "LuminanceFormat", () => LuminanceFormat);
$parcel$export(module.exports, "LuminanceAlphaFormat", () => LuminanceAlphaFormat);
$parcel$export(module.exports, "RGBEFormat", () => RGBEFormat);
$parcel$export(module.exports, "DepthFormat", () => DepthFormat);
$parcel$export(module.exports, "DepthStencilFormat", () => DepthStencilFormat);
$parcel$export(module.exports, "RedFormat", () => RedFormat);
$parcel$export(module.exports, "RedIntegerFormat", () => RedIntegerFormat);
$parcel$export(module.exports, "RGFormat", () => RGFormat);
$parcel$export(module.exports, "RGIntegerFormat", () => RGIntegerFormat);
$parcel$export(module.exports, "RGBIntegerFormat", () => RGBIntegerFormat);
$parcel$export(module.exports, "RGBAIntegerFormat", () => RGBAIntegerFormat);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => RGB_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => RGBA_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => RGBA_S3TC_DXT3_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => RGBA_S3TC_DXT5_Format);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => RGB_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => RGB_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => RGBA_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => RGBA_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGB_ETC1_Format", () => RGB_ETC1_Format);
$parcel$export(module.exports, "RGB_ETC2_Format", () => RGB_ETC2_Format);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => RGBA_ETC2_EAC_Format);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => RGBA_ASTC_4x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => RGBA_ASTC_5x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => RGBA_ASTC_5x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => RGBA_ASTC_6x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => RGBA_ASTC_6x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => RGBA_ASTC_8x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => RGBA_ASTC_8x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => RGBA_ASTC_8x8_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => RGBA_ASTC_10x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => RGBA_ASTC_10x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => RGBA_ASTC_10x8_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => RGBA_ASTC_10x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => RGBA_ASTC_12x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => RGBA_ASTC_12x12_Format);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => RGBA_BPTC_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_4x4_Format", () => SRGB8_ALPHA8_ASTC_4x4_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_5x4_Format", () => SRGB8_ALPHA8_ASTC_5x4_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_5x5_Format", () => SRGB8_ALPHA8_ASTC_5x5_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_6x5_Format", () => SRGB8_ALPHA8_ASTC_6x5_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_6x6_Format", () => SRGB8_ALPHA8_ASTC_6x6_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_8x5_Format", () => SRGB8_ALPHA8_ASTC_8x5_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_8x6_Format", () => SRGB8_ALPHA8_ASTC_8x6_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_8x8_Format", () => SRGB8_ALPHA8_ASTC_8x8_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_10x5_Format", () => SRGB8_ALPHA8_ASTC_10x5_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_10x6_Format", () => SRGB8_ALPHA8_ASTC_10x6_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_10x8_Format", () => SRGB8_ALPHA8_ASTC_10x8_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_10x10_Format", () => SRGB8_ALPHA8_ASTC_10x10_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_12x10_Format", () => SRGB8_ALPHA8_ASTC_12x10_Format);
$parcel$export(module.exports, "SRGB8_ALPHA8_ASTC_12x12_Format", () => SRGB8_ALPHA8_ASTC_12x12_Format);
$parcel$export(module.exports, "LoopOnce", () => LoopOnce);
$parcel$export(module.exports, "LoopRepeat", () => LoopRepeat);
$parcel$export(module.exports, "LoopPingPong", () => LoopPingPong);
$parcel$export(module.exports, "InterpolateDiscrete", () => InterpolateDiscrete);
$parcel$export(module.exports, "InterpolateLinear", () => InterpolateLinear);
$parcel$export(module.exports, "InterpolateSmooth", () => InterpolateSmooth);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => ZeroCurvatureEnding);
$parcel$export(module.exports, "ZeroSlopeEnding", () => ZeroSlopeEnding);
$parcel$export(module.exports, "WrapAroundEnding", () => WrapAroundEnding);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => NormalAnimationBlendMode);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => AdditiveAnimationBlendMode);
$parcel$export(module.exports, "TrianglesDrawMode", () => TrianglesDrawMode);
$parcel$export(module.exports, "TriangleStripDrawMode", () => TriangleStripDrawMode);
$parcel$export(module.exports, "TriangleFanDrawMode", () => TriangleFanDrawMode);
$parcel$export(module.exports, "LinearEncoding", () => LinearEncoding);
$parcel$export(module.exports, "sRGBEncoding", () => sRGBEncoding);
$parcel$export(module.exports, "GammaEncoding", () => GammaEncoding);
$parcel$export(module.exports, "RGBEEncoding", () => RGBEEncoding);
$parcel$export(module.exports, "LogLuvEncoding", () => LogLuvEncoding);
$parcel$export(module.exports, "RGBM7Encoding", () => RGBM7Encoding);
$parcel$export(module.exports, "RGBM16Encoding", () => RGBM16Encoding);
$parcel$export(module.exports, "RGBDEncoding", () => RGBDEncoding);
$parcel$export(module.exports, "BasicDepthPacking", () => BasicDepthPacking);
$parcel$export(module.exports, "RGBADepthPacking", () => RGBADepthPacking);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => TangentSpaceNormalMap);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => ObjectSpaceNormalMap);
$parcel$export(module.exports, "ZeroStencilOp", () => ZeroStencilOp);
$parcel$export(module.exports, "KeepStencilOp", () => KeepStencilOp);
$parcel$export(module.exports, "ReplaceStencilOp", () => ReplaceStencilOp);
$parcel$export(module.exports, "IncrementStencilOp", () => IncrementStencilOp);
$parcel$export(module.exports, "DecrementStencilOp", () => DecrementStencilOp);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => IncrementWrapStencilOp);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => DecrementWrapStencilOp);
$parcel$export(module.exports, "InvertStencilOp", () => InvertStencilOp);
$parcel$export(module.exports, "NeverStencilFunc", () => NeverStencilFunc);
$parcel$export(module.exports, "LessStencilFunc", () => LessStencilFunc);
$parcel$export(module.exports, "EqualStencilFunc", () => EqualStencilFunc);
$parcel$export(module.exports, "LessEqualStencilFunc", () => LessEqualStencilFunc);
$parcel$export(module.exports, "GreaterStencilFunc", () => GreaterStencilFunc);
$parcel$export(module.exports, "NotEqualStencilFunc", () => NotEqualStencilFunc);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => GreaterEqualStencilFunc);
$parcel$export(module.exports, "AlwaysStencilFunc", () => AlwaysStencilFunc);
$parcel$export(module.exports, "StaticDrawUsage", () => StaticDrawUsage);
$parcel$export(module.exports, "DynamicDrawUsage", () => DynamicDrawUsage);
$parcel$export(module.exports, "StreamDrawUsage", () => StreamDrawUsage);
$parcel$export(module.exports, "StaticReadUsage", () => StaticReadUsage);
$parcel$export(module.exports, "DynamicReadUsage", () => DynamicReadUsage);
$parcel$export(module.exports, "StreamReadUsage", () => StreamReadUsage);
$parcel$export(module.exports, "StaticCopyUsage", () => StaticCopyUsage);
$parcel$export(module.exports, "DynamicCopyUsage", () => DynamicCopyUsage);
$parcel$export(module.exports, "StreamCopyUsage", () => StreamCopyUsage);
$parcel$export(module.exports, "GLSL1", () => GLSL1);
$parcel$export(module.exports, "GLSL3", () => GLSL3);
$parcel$export(module.exports, "EventDispatcher", () => EventDispatcher);
$parcel$export(module.exports, "Math", () => MathUtils);
$parcel$export(module.exports, "Vector2", () => Vector2);
$parcel$export(module.exports, "Matrix3", () => Matrix3);
$parcel$export(module.exports, "ImageUtils", () => ImageUtils);
$parcel$export(module.exports, "Texture", () => Texture);
$parcel$export(module.exports, "Vector4", () => Vector4);
$parcel$export(module.exports, "WebGLRenderTarget", () => WebGLRenderTarget);
$parcel$export(module.exports, "WebGLMultisampleRenderTarget", () => WebGLMultisampleRenderTarget);
$parcel$export(module.exports, "Quaternion", () => Quaternion);
$parcel$export(module.exports, "Vector3", () => Vector3);
$parcel$export(module.exports, "Box3", () => Box3);
$parcel$export(module.exports, "Sphere", () => Sphere);
$parcel$export(module.exports, "Ray", () => Ray);
$parcel$export(module.exports, "Matrix4", () => Matrix4);
$parcel$export(module.exports, "Euler", () => Euler);
$parcel$export(module.exports, "Layers", () => Layers);
$parcel$export(module.exports, "Object3D", () => Object3D);
$parcel$export(module.exports, "Plane", () => Plane);
$parcel$export(module.exports, "Triangle", () => Triangle);
$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "Face3", () => Face3);
$parcel$export(module.exports, "Material", () => Material);
$parcel$export(module.exports, "MeshBasicMaterial", () => MeshBasicMaterial);
$parcel$export(module.exports, "BufferAttribute", () => BufferAttribute);
$parcel$export(module.exports, "Int8BufferAttribute", () => Int8BufferAttribute);
$parcel$export(module.exports, "Uint8BufferAttribute", () => Uint8BufferAttribute);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => Uint8ClampedBufferAttribute);
$parcel$export(module.exports, "Int16BufferAttribute", () => Int16BufferAttribute);
$parcel$export(module.exports, "Uint16BufferAttribute", () => Uint16BufferAttribute);
$parcel$export(module.exports, "Int32BufferAttribute", () => Int32BufferAttribute);
$parcel$export(module.exports, "Uint32BufferAttribute", () => Uint32BufferAttribute);
$parcel$export(module.exports, "Float16BufferAttribute", () => Float16BufferAttribute);
$parcel$export(module.exports, "Float32BufferAttribute", () => Float32BufferAttribute);
$parcel$export(module.exports, "Float64BufferAttribute", () => Float64BufferAttribute);
$parcel$export(module.exports, "BufferGeometry", () => BufferGeometry);
$parcel$export(module.exports, "Mesh", () => Mesh);
$parcel$export(module.exports, "BoxBufferGeometry", () => BoxBufferGeometry);
$parcel$export(module.exports, "UniformsUtils", () => UniformsUtils);
$parcel$export(module.exports, "ShaderMaterial", () => ShaderMaterial);
$parcel$export(module.exports, "Camera", () => Camera);
$parcel$export(module.exports, "PerspectiveCamera", () => PerspectiveCamera);
$parcel$export(module.exports, "CubeCamera", () => CubeCamera);
$parcel$export(module.exports, "CubeTexture", () => CubeTexture);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => WebGLCubeRenderTarget);
$parcel$export(module.exports, "DataTexture", () => DataTexture);
$parcel$export(module.exports, "Frustum", () => Frustum);
$parcel$export(module.exports, "PlaneBufferGeometry", () => PlaneBufferGeometry);
$parcel$export(module.exports, "ShaderChunk", () => ShaderChunk);
$parcel$export(module.exports, "UniformsLib", () => UniformsLib);
$parcel$export(module.exports, "ShaderLib", () => ShaderLib);
$parcel$export(module.exports, "DataTexture2DArray", () => DataTexture2DArray);
$parcel$export(module.exports, "DataTexture3D", () => DataTexture3D);
$parcel$export(module.exports, "MeshDepthMaterial", () => MeshDepthMaterial);
$parcel$export(module.exports, "MeshDistanceMaterial", () => MeshDistanceMaterial);
$parcel$export(module.exports, "WebGLUtils", () => WebGLUtils);
$parcel$export(module.exports, "ArrayCamera", () => ArrayCamera);
$parcel$export(module.exports, "Group", () => Group);
$parcel$export(module.exports, "WebGLRenderer", () => WebGLRenderer);
$parcel$export(module.exports, "WebGL1Renderer", () => WebGL1Renderer);
$parcel$export(module.exports, "FogExp2", () => FogExp2);
$parcel$export(module.exports, "Fog", () => Fog);
$parcel$export(module.exports, "Scene", () => Scene);
$parcel$export(module.exports, "InterleavedBuffer", () => InterleavedBuffer);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => InterleavedBufferAttribute);
$parcel$export(module.exports, "SpriteMaterial", () => SpriteMaterial);
$parcel$export(module.exports, "Sprite", () => Sprite);
$parcel$export(module.exports, "LOD", () => LOD);
$parcel$export(module.exports, "SkinnedMesh", () => SkinnedMesh);
$parcel$export(module.exports, "Bone", () => Bone);
$parcel$export(module.exports, "Skeleton", () => Skeleton);
$parcel$export(module.exports, "InstancedMesh", () => InstancedMesh);
$parcel$export(module.exports, "LineBasicMaterial", () => LineBasicMaterial);
$parcel$export(module.exports, "Line", () => Line);
$parcel$export(module.exports, "LineSegments", () => LineSegments);
$parcel$export(module.exports, "LineLoop", () => LineLoop);
$parcel$export(module.exports, "PointsMaterial", () => PointsMaterial);
$parcel$export(module.exports, "Points", () => Points);
$parcel$export(module.exports, "VideoTexture", () => VideoTexture);
$parcel$export(module.exports, "CompressedTexture", () => CompressedTexture);
$parcel$export(module.exports, "CanvasTexture", () => CanvasTexture);
$parcel$export(module.exports, "DepthTexture", () => DepthTexture);
$parcel$export(module.exports, "Geometry", () => Geometry);
$parcel$export(module.exports, "BoxGeometry", () => BoxGeometry);
$parcel$export(module.exports, "CircleBufferGeometry", () => CircleBufferGeometry);
$parcel$export(module.exports, "CircleGeometry", () => CircleGeometry);
$parcel$export(module.exports, "CylinderBufferGeometry", () => CylinderBufferGeometry);
$parcel$export(module.exports, "CylinderGeometry", () => CylinderGeometry);
$parcel$export(module.exports, "ConeGeometry", () => ConeGeometry);
$parcel$export(module.exports, "ConeBufferGeometry", () => ConeBufferGeometry);
$parcel$export(module.exports, "PolyhedronBufferGeometry", () => PolyhedronBufferGeometry);
$parcel$export(module.exports, "DodecahedronBufferGeometry", () => DodecahedronBufferGeometry);
$parcel$export(module.exports, "DodecahedronGeometry", () => DodecahedronGeometry);
$parcel$export(module.exports, "EdgesGeometry", () => EdgesGeometry);
$parcel$export(module.exports, "ShapeUtils", () => ShapeUtils);
$parcel$export(module.exports, "ExtrudeBufferGeometry", () => ExtrudeBufferGeometry);
$parcel$export(module.exports, "ExtrudeGeometry", () => ExtrudeGeometry);
$parcel$export(module.exports, "IcosahedronBufferGeometry", () => IcosahedronBufferGeometry);
$parcel$export(module.exports, "IcosahedronGeometry", () => IcosahedronGeometry);
$parcel$export(module.exports, "LatheBufferGeometry", () => LatheBufferGeometry);
$parcel$export(module.exports, "LatheGeometry", () => LatheGeometry);
$parcel$export(module.exports, "OctahedronBufferGeometry", () => OctahedronBufferGeometry);
$parcel$export(module.exports, "OctahedronGeometry", () => OctahedronGeometry);
$parcel$export(module.exports, "ParametricBufferGeometry", () => ParametricBufferGeometry);
$parcel$export(module.exports, "ParametricGeometry", () => ParametricGeometry);
$parcel$export(module.exports, "PlaneGeometry", () => PlaneGeometry);
$parcel$export(module.exports, "PolyhedronGeometry", () => PolyhedronGeometry);
$parcel$export(module.exports, "RingBufferGeometry", () => RingBufferGeometry);
$parcel$export(module.exports, "RingGeometry", () => RingGeometry);
$parcel$export(module.exports, "ShapeBufferGeometry", () => ShapeBufferGeometry);
$parcel$export(module.exports, "ShapeGeometry", () => ShapeGeometry);
$parcel$export(module.exports, "SphereBufferGeometry", () => SphereBufferGeometry);
$parcel$export(module.exports, "SphereGeometry", () => SphereGeometry);
$parcel$export(module.exports, "TetrahedronBufferGeometry", () => TetrahedronBufferGeometry);
$parcel$export(module.exports, "TetrahedronGeometry", () => TetrahedronGeometry);
$parcel$export(module.exports, "TextBufferGeometry", () => TextBufferGeometry);
$parcel$export(module.exports, "TextGeometry", () => TextGeometry);
$parcel$export(module.exports, "TorusBufferGeometry", () => TorusBufferGeometry);
$parcel$export(module.exports, "TorusGeometry", () => TorusGeometry);
$parcel$export(module.exports, "TorusKnotBufferGeometry", () => TorusKnotBufferGeometry);
$parcel$export(module.exports, "TorusKnotGeometry", () => TorusKnotGeometry);
$parcel$export(module.exports, "TubeBufferGeometry", () => TubeBufferGeometry);
$parcel$export(module.exports, "TubeGeometry", () => TubeGeometry);
$parcel$export(module.exports, "WireframeGeometry", () => WireframeGeometry);
$parcel$export(module.exports, "ShadowMaterial", () => ShadowMaterial);
$parcel$export(module.exports, "RawShaderMaterial", () => RawShaderMaterial);
$parcel$export(module.exports, "MeshStandardMaterial", () => MeshStandardMaterial);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => MeshPhysicalMaterial);
$parcel$export(module.exports, "MeshPhongMaterial", () => MeshPhongMaterial);
$parcel$export(module.exports, "MeshToonMaterial", () => MeshToonMaterial);
$parcel$export(module.exports, "MeshNormalMaterial", () => MeshNormalMaterial);
$parcel$export(module.exports, "MeshLambertMaterial", () => MeshLambertMaterial);
$parcel$export(module.exports, "MeshMatcapMaterial", () => MeshMatcapMaterial);
$parcel$export(module.exports, "LineDashedMaterial", () => LineDashedMaterial);
$parcel$export(module.exports, "AnimationUtils", () => AnimationUtils);
$parcel$export(module.exports, "Interpolant", () => Interpolant);
$parcel$export(module.exports, "CubicInterpolant", () => CubicInterpolant);
$parcel$export(module.exports, "LinearInterpolant", () => LinearInterpolant);
$parcel$export(module.exports, "DiscreteInterpolant", () => DiscreteInterpolant);
$parcel$export(module.exports, "KeyframeTrack", () => KeyframeTrack);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => BooleanKeyframeTrack);
$parcel$export(module.exports, "ColorKeyframeTrack", () => ColorKeyframeTrack);
$parcel$export(module.exports, "NumberKeyframeTrack", () => NumberKeyframeTrack);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => QuaternionLinearInterpolant);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => QuaternionKeyframeTrack);
$parcel$export(module.exports, "StringKeyframeTrack", () => StringKeyframeTrack);
$parcel$export(module.exports, "VectorKeyframeTrack", () => VectorKeyframeTrack);
$parcel$export(module.exports, "AnimationClip", () => AnimationClip);
$parcel$export(module.exports, "Cache", () => Cache);
$parcel$export(module.exports, "LoadingManager", () => LoadingManager);
$parcel$export(module.exports, "DefaultLoadingManager", () => DefaultLoadingManager);
$parcel$export(module.exports, "Loader", () => Loader);
$parcel$export(module.exports, "FileLoader", () => FileLoader);
$parcel$export(module.exports, "AnimationLoader", () => AnimationLoader);
$parcel$export(module.exports, "CompressedTextureLoader", () => CompressedTextureLoader);
$parcel$export(module.exports, "ImageLoader", () => ImageLoader);
$parcel$export(module.exports, "CubeTextureLoader", () => CubeTextureLoader);
$parcel$export(module.exports, "DataTextureLoader", () => DataTextureLoader);
$parcel$export(module.exports, "TextureLoader", () => TextureLoader);
$parcel$export(module.exports, "Curve", () => Curve);
$parcel$export(module.exports, "EllipseCurve", () => EllipseCurve);
$parcel$export(module.exports, "ArcCurve", () => ArcCurve);
$parcel$export(module.exports, "CatmullRomCurve3", () => CatmullRomCurve3);
$parcel$export(module.exports, "CubicBezierCurve", () => CubicBezierCurve);
$parcel$export(module.exports, "CubicBezierCurve3", () => CubicBezierCurve3);
$parcel$export(module.exports, "LineCurve", () => LineCurve);
$parcel$export(module.exports, "LineCurve3", () => LineCurve3);
$parcel$export(module.exports, "QuadraticBezierCurve", () => QuadraticBezierCurve);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => QuadraticBezierCurve3);
$parcel$export(module.exports, "SplineCurve", () => SplineCurve);
$parcel$export(module.exports, "CurvePath", () => CurvePath);
$parcel$export(module.exports, "Path", () => Path);
$parcel$export(module.exports, "Shape", () => Shape);
$parcel$export(module.exports, "Light", () => Light);
$parcel$export(module.exports, "HemisphereLight", () => HemisphereLight);
$parcel$export(module.exports, "SpotLight", () => SpotLight);
$parcel$export(module.exports, "PointLight", () => PointLight);
$parcel$export(module.exports, "OrthographicCamera", () => OrthographicCamera);
$parcel$export(module.exports, "DirectionalLight", () => DirectionalLight);
$parcel$export(module.exports, "AmbientLight", () => AmbientLight);
$parcel$export(module.exports, "RectAreaLight", () => RectAreaLight);
$parcel$export(module.exports, "SphericalHarmonics3", () => SphericalHarmonics3);
$parcel$export(module.exports, "LightProbe", () => LightProbe);
$parcel$export(module.exports, "MaterialLoader", () => MaterialLoader);
$parcel$export(module.exports, "LoaderUtils", () => LoaderUtils);
$parcel$export(module.exports, "InstancedBufferGeometry", () => InstancedBufferGeometry);
$parcel$export(module.exports, "InstancedBufferAttribute", () => InstancedBufferAttribute);
$parcel$export(module.exports, "BufferGeometryLoader", () => BufferGeometryLoader);
$parcel$export(module.exports, "ObjectLoader", () => ObjectLoader);
$parcel$export(module.exports, "ImageBitmapLoader", () => ImageBitmapLoader);
$parcel$export(module.exports, "ShapePath", () => ShapePath);
$parcel$export(module.exports, "Font", () => Font);
$parcel$export(module.exports, "FontLoader", () => FontLoader);
$parcel$export(module.exports, "AudioContext", () => AudioContext);
$parcel$export(module.exports, "AudioLoader", () => AudioLoader);
$parcel$export(module.exports, "HemisphereLightProbe", () => HemisphereLightProbe);
$parcel$export(module.exports, "AmbientLightProbe", () => AmbientLightProbe);
$parcel$export(module.exports, "StereoCamera", () => StereoCamera);
$parcel$export(module.exports, "Clock", () => Clock);
$parcel$export(module.exports, "AudioListener", () => AudioListener);
$parcel$export(module.exports, "Audio", () => Audio);
$parcel$export(module.exports, "PositionalAudio", () => PositionalAudio);
$parcel$export(module.exports, "AudioAnalyser", () => AudioAnalyser);
$parcel$export(module.exports, "PropertyMixer", () => PropertyMixer);
$parcel$export(module.exports, "PropertyBinding", () => PropertyBinding);
$parcel$export(module.exports, "AnimationObjectGroup", () => AnimationObjectGroup);
$parcel$export(module.exports, "AnimationMixer", () => AnimationMixer);
$parcel$export(module.exports, "Uniform", () => Uniform);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => InstancedInterleavedBuffer);
$parcel$export(module.exports, "GLBufferAttribute", () => GLBufferAttribute);
$parcel$export(module.exports, "Raycaster", () => Raycaster);
$parcel$export(module.exports, "Spherical", () => Spherical);
$parcel$export(module.exports, "Cylindrical", () => Cylindrical);
$parcel$export(module.exports, "Box2", () => Box2);
$parcel$export(module.exports, "Line3", () => Line3);
$parcel$export(module.exports, "ImmediateRenderObject", () => ImmediateRenderObject);
$parcel$export(module.exports, "SpotLightHelper", () => SpotLightHelper);
$parcel$export(module.exports, "SkeletonHelper", () => SkeletonHelper);
$parcel$export(module.exports, "PointLightHelper", () => PointLightHelper);
$parcel$export(module.exports, "HemisphereLightHelper", () => HemisphereLightHelper);
$parcel$export(module.exports, "GridHelper", () => GridHelper);
$parcel$export(module.exports, "PolarGridHelper", () => PolarGridHelper);
$parcel$export(module.exports, "DirectionalLightHelper", () => DirectionalLightHelper);
$parcel$export(module.exports, "CameraHelper", () => CameraHelper);
$parcel$export(module.exports, "BoxHelper", () => BoxHelper);
$parcel$export(module.exports, "Box3Helper", () => Box3Helper);
$parcel$export(module.exports, "PlaneHelper", () => PlaneHelper);
$parcel$export(module.exports, "ArrowHelper", () => ArrowHelper);
$parcel$export(module.exports, "AxesHelper", () => AxesHelper);
$parcel$export(module.exports, "DataUtils", () => DataUtils);
$parcel$export(module.exports, "PMREMGenerator", () => PMREMGenerator);
$parcel$export(module.exports, "Face4", () => Face4);
$parcel$export(module.exports, "LineStrip", () => LineStrip);
$parcel$export(module.exports, "LinePieces", () => LinePieces);
$parcel$export(module.exports, "NoColors", () => NoColors);
$parcel$export(module.exports, "FaceColors", () => FaceColors);
$parcel$export(module.exports, "VertexColors", () => VertexColors);
$parcel$export(module.exports, "MeshFaceMaterial", () => MeshFaceMaterial);
$parcel$export(module.exports, "MultiMaterial", () => MultiMaterial);
$parcel$export(module.exports, "PointCloud", () => PointCloud);
$parcel$export(module.exports, "Particle", () => Particle);
$parcel$export(module.exports, "ParticleSystem", () => ParticleSystem);
$parcel$export(module.exports, "PointCloudMaterial", () => PointCloudMaterial);
$parcel$export(module.exports, "ParticleBasicMaterial", () => ParticleBasicMaterial);
$parcel$export(module.exports, "ParticleSystemMaterial", () => ParticleSystemMaterial);
$parcel$export(module.exports, "Vertex", () => Vertex);
$parcel$export(module.exports, "DynamicBufferAttribute", () => DynamicBufferAttribute);
$parcel$export(module.exports, "Int8Attribute", () => Int8Attribute);
$parcel$export(module.exports, "Uint8Attribute", () => Uint8Attribute);
$parcel$export(module.exports, "Uint8ClampedAttribute", () => Uint8ClampedAttribute);
$parcel$export(module.exports, "Int16Attribute", () => Int16Attribute);
$parcel$export(module.exports, "Uint16Attribute", () => Uint16Attribute);
$parcel$export(module.exports, "Int32Attribute", () => Int32Attribute);
$parcel$export(module.exports, "Uint32Attribute", () => Uint32Attribute);
$parcel$export(module.exports, "Float32Attribute", () => Float32Attribute);
$parcel$export(module.exports, "Float64Attribute", () => Float64Attribute);
$parcel$export(module.exports, "ClosedSplineCurve3", () => ClosedSplineCurve3);
$parcel$export(module.exports, "SplineCurve3", () => SplineCurve3);
$parcel$export(module.exports, "Spline", () => Spline);
$parcel$export(module.exports, "AxisHelper", () => AxisHelper);
$parcel$export(module.exports, "BoundingBoxHelper", () => BoundingBoxHelper);
$parcel$export(module.exports, "EdgesHelper", () => EdgesHelper);
$parcel$export(module.exports, "WireframeHelper", () => WireframeHelper);
$parcel$export(module.exports, "XHRLoader", () => XHRLoader);
$parcel$export(module.exports, "BinaryTextureLoader", () => BinaryTextureLoader);
$parcel$export(module.exports, "WebGLRenderTargetCube", () => WebGLRenderTargetCube);
$parcel$export(module.exports, "GeometryUtils", () => GeometryUtils);
$parcel$export(module.exports, "CanvasRenderer", () => CanvasRenderer);
$parcel$export(module.exports, "JSONLoader", () => JSONLoader);
$parcel$export(module.exports, "SceneUtils", () => SceneUtils);
$parcel$export(module.exports, "LensFlare", () => LensFlare);
$parcel$export(module.exports, "CubeGeometry", () => BoxGeometry);
$parcel$export(module.exports, "MathUtils", () => MathUtils);
// threejs.org/license
const REVISION = '124';
const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const TOUCH = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const FlatShading = 1;
const SmoothShading = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const CubeUVRefractionMapping = 307;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedShort565Type = 1019;
const UnsignedInt248Type = 1020;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const RGBEFormat = RGBAFormat;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const SRGB8_ALPHA8_ASTC_4x4_Format = 37840;
const SRGB8_ALPHA8_ASTC_5x4_Format = 37841;
const SRGB8_ALPHA8_ASTC_5x5_Format = 37842;
const SRGB8_ALPHA8_ASTC_6x5_Format = 37843;
const SRGB8_ALPHA8_ASTC_6x6_Format = 37844;
const SRGB8_ALPHA8_ASTC_8x5_Format = 37845;
const SRGB8_ALPHA8_ASTC_8x6_Format = 37846;
const SRGB8_ALPHA8_ASTC_8x8_Format = 37847;
const SRGB8_ALPHA8_ASTC_10x5_Format = 37848;
const SRGB8_ALPHA8_ASTC_10x6_Format = 37849;
const SRGB8_ALPHA8_ASTC_10x8_Format = 37850;
const SRGB8_ALPHA8_ASTC_10x10_Format = 37851;
const SRGB8_ALPHA8_ASTC_12x10_Format = 37852;
const SRGB8_ALPHA8_ASTC_12x12_Format = 37853;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const LinearEncoding = 3000;
const sRGBEncoding = 3001;
const GammaEncoding = 3007;
const RGBEEncoding = 3002;
const LogLuvEncoding = 3003;
const RGBM7Encoding = 3004;
const RGBM16Encoding = 3005;
const RGBDEncoding = 3006;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = '100';
const GLSL3 = '300 es';
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ function EventDispatcher() {}
Object.assign(EventDispatcher.prototype, {
    addEventListener: function(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    },
    hasEventListener: function(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    },
    removeEventListener: function(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    },
    dispatchEvent: function(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
        }
    }
});
const _lut = [];
for(let i = 0; i < 256; i++)_lut[i] = (i < 16 ? '0' : '') + i.toString(16);
let _seed = 1234567;
const MathUtils = {
    DEG2RAD: Math.PI / 180,
    RAD2DEG: 180 / Math.PI,
    generateUUID: function() {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
        const d0 = Math.random() * 0xffffffff | 0;
        const d1 = Math.random() * 0xffffffff | 0;
        const d2 = Math.random() * 0xffffffff | 0;
        const d3 = Math.random() * 0xffffffff | 0;
        const uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff];
        // .toUpperCase() here flattens concatenated strings to save heap memory space.
        return uuid.toUpperCase();
    },
    clamp: function(value, min, max) {
        return Math.max(min, Math.min(max, value));
    },
    // compute euclidian modulo of m % n
    // https://en.wikipedia.org/wiki/Modulo_operation
    euclideanModulo: function(n, m) {
        return (n % m + m) % m;
    },
    // Linear mapping from range <a1, a2> to range <b1, b2>
    mapLinear: function(x, a1, a2, b1, b2) {
        return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
    },
    // https://en.wikipedia.org/wiki/Linear_interpolation
    lerp: function(x, y, t) {
        return (1 - t) * x + t * y;
    },
    // http://en.wikipedia.org/wiki/Smoothstep
    smoothstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * (3 - 2 * x);
    },
    smootherstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * x * (x * (x * 6 - 15) + 10);
    },
    // Random integer from <low, high> interval
    randInt: function(low, high) {
        return low + Math.floor(Math.random() * (high - low + 1));
    },
    // Random float from <low, high> interval
    randFloat: function(low, high) {
        return low + Math.random() * (high - low);
    },
    // Random float from <-range/2, range/2> interval
    randFloatSpread: function(range) {
        return range * (0.5 - Math.random());
    },
    // Deterministic pseudo-random float in the interval [ 0, 1 ]
    seededRandom: function(s) {
        if (s !== undefined) _seed = s % 2147483647;
        // Park-Miller algorithm
        _seed = _seed * 16807 % 2147483647;
        return (_seed - 1) / 2147483646;
    },
    degToRad: function(degrees) {
        return degrees * MathUtils.DEG2RAD;
    },
    radToDeg: function(radians) {
        return radians * MathUtils.RAD2DEG;
    },
    isPowerOfTwo: function(value) {
        return (value & value - 1) === 0 && value !== 0;
    },
    ceilPowerOfTwo: function(value) {
        return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
    },
    floorPowerOfTwo: function(value) {
        return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
    },
    setQuaternionFromProperEuler: function(q, a, b, c, order) {
        // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
        // rotations are applied to the axes in the order specified by 'order'
        // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
        // angles are in radians
        const cos = Math.cos;
        const sin = Math.sin;
        const c2 = cos(b / 2);
        const s2 = sin(b / 2);
        const c13 = cos((a + c) / 2);
        const s13 = sin((a + c) / 2);
        const c1_3 = cos((a - c) / 2);
        const s1_3 = sin((a - c) / 2);
        const c3_1 = cos((c - a) / 2);
        const s3_1 = sin((c - a) / 2);
        switch(order){
            case 'XYX':
                q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
                break;
            case 'YZY':
                q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
                break;
            case 'ZXZ':
                q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
                break;
            case 'XZX':
                q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
                break;
            case 'YXY':
                q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
                break;
            case 'ZYZ':
                q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
                break;
            default:
                console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
        }
    }
};
class Vector2 {
    constructor(x = 0, y = 0){
        Object.defineProperty(this, 'isVector2', {
            value: true
        });
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector2: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
}
class Matrix3 {
    constructor(){
        Object.defineProperty(this, 'isMatrix3', {
            value: true
        });
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).copy(this).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
}
let _canvas;
const ImageUtils = {
    getDataURL: function(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if (_canvas === undefined) _canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
            _canvas.width = image.width;
            _canvas.height = image.height;
            const context = _canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = _canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) return canvas.toDataURL('image/jpeg', 0.6);
        else return canvas.toDataURL('image/png');
    }
};
let textureId = 0;
function Texture(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = 1, encoding = LinearEncoding) {
    Object.defineProperty(this, 'id', {
        value: textureId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.image = image;
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2(0, 0);
    this.repeat = new Vector2(1, 1);
    this.center = new Vector2(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
    // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
    //
    // Also changing the encoding after already used by a Material will not automatically make the Material
    // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
    this.encoding = encoding;
    this.version = 0;
    this.onUpdate = null;
}
Texture.DEFAULT_IMAGE = undefined;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Texture,
    isTexture: true,
    updateMatrix: function() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        return this;
    },
    toJSON: function(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = MathUtils.generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push(serializeImage(image[i].image));
                    else url.push(serializeImage(image[i]));
                } else // process single image
                url = serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    },
    transformUv: function(uv) {
        if (this.mapping !== UVMapping) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case RepeatWrapping:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case ClampToEdgeWrapping:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case RepeatWrapping:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case ClampToEdgeWrapping:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
});
Object.defineProperty(Texture.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
function serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return ImageUtils.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
class Vector4 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        Object.defineProperty(this, 'isVector4', {
            value: true
        });
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector4: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ function WebGLRenderTarget(width, height, options) {
    this.width = width;
    this.height = height;
    this.scissor = new Vector4(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector4(0, 0, width, height);
    options = options || {};
    this.texture = new Texture(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture.image = {};
    this.texture.image.width = width;
    this.texture.image.height = height;
    this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;
    this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
    this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
    this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
}
WebGLRenderTarget.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: WebGLRenderTarget,
    isWebGLRenderTarget: true,
    setSize: function(width, height) {
        if (this.width !== width || this.height !== height) {
            this.width = width;
            this.height = height;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.width = source.width;
        this.height = source.height;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
function WebGLMultisampleRenderTarget(width, height, options) {
    WebGLRenderTarget.call(this, width, height, options);
    this.samples = 4;
}
WebGLMultisampleRenderTarget.prototype = Object.assign(Object.create(WebGLRenderTarget.prototype), {
    constructor: WebGLMultisampleRenderTarget,
    isWebGLMultisampleRenderTarget: true,
    copy: function(source) {
        WebGLRenderTarget.prototype.copy.call(this, source);
        this.samples = source.samples;
        return this;
    }
});
class Quaternion {
    constructor(x = 0, y = 0, z = 0, w = 1){
        Object.defineProperty(this, 'isQuaternion', {
            value: true
        });
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        return qm.copy(qa).slerp(qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        const EPS = 0.000001;
        let r = vFrom.dot(vTo) + 1;
        if (r < EPS) {
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs(MathUtils.clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
class Vector3 {
    constructor(x = 0, y = 0, z = 0){
        Object.defineProperty(this, 'isVector3', {
            value: true
        });
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.');
        return this.applyQuaternion(_quaternion.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion(_quaternion.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        _vector.copy(this).projectOnVector(planeNormal);
        return this.sub(_vector);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub(_vector.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos(MathUtils.clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector3: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
}
const _vector = /*@__PURE__*/ new Vector3();
const _quaternion = /*@__PURE__*/ new Quaternion();
class Box3 {
    constructor(min, max){
        Object.defineProperty(this, 'isBox3', {
            value: true
        });
        this.min = min !== undefined ? min : new Vector3(Infinity, Infinity, Infinity);
        this.max = max !== undefined ? max : new Vector3(-Infinity, -Infinity, -Infinity);
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = _vector$1.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object) {
        this.makeEmpty();
        return this.expandByObject(object);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getCenter() target is now required');
            target = new Vector3();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getSize() target is now required');
            target = new Vector3();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (geometry.boundingBox === null) geometry.computeBoundingBox();
            _box.copy(geometry.boundingBox);
            _box.applyMatrix4(object.matrixWorld);
            this.union(_box);
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i]);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box3: .getParameter() target is now required');
            target = new Vector3();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, _vector$1);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return _vector$1.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter(_center);
        _extents.subVectors(this.max, _center);
        // translate triangle to aabb origin
        _v0.subVectors(triangle.a, _center);
        _v1.subVectors(triangle.b, _center);
        _v2.subVectors(triangle.c, _center);
        // compute edge vectors for triangle
        _f0.subVectors(_v1, _v0);
        _f1.subVectors(_v2, _v1);
        _f2.subVectors(_v0, _v2);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -_f0.z,
            _f0.y,
            0,
            -_f1.z,
            _f1.y,
            0,
            -_f2.z,
            _f2.y,
            _f0.z,
            0,
            -_f0.x,
            _f1.z,
            0,
            -_f1.x,
            _f2.z,
            0,
            -_f2.x,
            -_f0.y,
            _f0.x,
            0,
            -_f1.y,
            _f1.x,
            0,
            -_f2.y,
            _f2.x,
            0
        ];
        if (!satForAxes(axes, _v0, _v1, _v2, _extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!satForAxes(axes, _v0, _v1, _v2, _extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        _triangleNormal.crossVectors(_f0, _f1);
        axes = [
            _triangleNormal.x,
            _triangleNormal.y,
            _triangleNormal.z
        ];
        return satForAxes(axes, _v0, _v1, _v2, _extents);
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .clampPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = _vector$1.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        if (target === undefined) console.error('THREE.Box3: .getBoundingSphere() target is now required');
        this.getCenter(target.center);
        target.radius = this.getSize(_vector$1).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints(_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
function satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        _testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot(_testAxis);
        const p1 = v1.dot(_testAxis);
        const p2 = v2.dot(_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const _points = [
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3()
];
const _vector$1 = /*@__PURE__*/ new Vector3();
const _box = /*@__PURE__*/ new Box3();
// triangle centered vertices
const _v0 = /*@__PURE__*/ new Vector3();
const _v1 = /*@__PURE__*/ new Vector3();
const _v2 = /*@__PURE__*/ new Vector3();
// triangle edge vectors
const _f0 = /*@__PURE__*/ new Vector3();
const _f1 = /*@__PURE__*/ new Vector3();
const _f2 = /*@__PURE__*/ new Vector3();
const _center = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();
const _box$1 = /*@__PURE__*/ new Box3();
class Sphere {
    constructor(center, radius){
        this.center = center !== undefined ? center : new Vector3();
        this.radius = radius !== undefined ? radius : -1;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else _box$1.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        if (target === undefined) {
            console.warn('THREE.Sphere: .clampPoint() target is now required');
            target = new Vector3();
        }
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (target === undefined) {
            console.warn('THREE.Sphere: .getBoundingBox() target is now required');
            target = new Box3();
        }
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
}
const _vector$2 = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();
const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal = /*@__PURE__*/ new Vector3();
class Ray {
    constructor(origin, direction){
        this.origin = origin !== undefined ? origin : new Vector3();
        this.direction = direction !== undefined ? direction : new Vector3(0, 0, -1);
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .at() target is now required');
            target = new Vector3();
        }
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, _vector$2));
        return this;
    }
    closestPointToPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = _vector$2.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        _vector$2.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return _vector$2.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        _segDir.copy(v1).sub(v0).normalize();
        _diff.copy(this.origin).sub(_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot(_segDir);
        const b0 = _diff.dot(this.direction);
        const b1 = -_diff.dot(_segDir);
        const c = _diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        _vector$2.subVectors(sphere.center, this.origin);
        const tca = _vector$2.dot(this.direction);
        const d2 = _vector$2.dot(_vector$2) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, _vector$2) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        _edge1.subVectors(b, a);
        _edge2.subVectors(c, a);
        _normal.crossVectors(_edge1, _edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot(_normal);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        _diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * _diff.dot(_normal);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
}
class Matrix4 {
    constructor(){
        Object.defineProperty(this, 'isMatrix4', {
            value: true
        });
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new Matrix4().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / _v1$1.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / _v1$1.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / _v1$1.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose(_zero, q, _one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        _z.subVectors(eye, target);
        if (_z.lengthSq() === 0) // eye and target are in the same position
        _z.z = 1;
        _z.normalize();
        _x.crossVectors(up, _z);
        if (_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) _z.x += 0.0001;
            else _z.z += 0.0001;
            _z.normalize();
            _x.crossVectors(up, _z);
        }
        _x.normalize();
        _y.crossVectors(_z, _x);
        te[0] = _x.x;
        te[4] = _y.x;
        te[8] = _z.x;
        te[1] = _x.y;
        te[5] = _y.y;
        te[9] = _z.y;
        te[2] = _x.z;
        te[6] = _y.z;
        te[10] = _z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(x, y, z) {
        this.set(1, y, z, 0, x, 1, z, 0, x, y, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = _v1$1.set(te[0], te[1], te[2]).length();
        const sy = _v1$1.set(te[4], te[5], te[6]).length();
        const sz = _v1$1.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        _m1.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        _m1.elements[0] *= invSX;
        _m1.elements[1] *= invSX;
        _m1.elements[2] *= invSX;
        _m1.elements[4] *= invSY;
        _m1.elements[5] *= invSY;
        _m1.elements[6] *= invSY;
        _m1.elements[8] *= invSZ;
        _m1.elements[9] *= invSZ;
        _m1.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix(_m1);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn('THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.');
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const _v1$1 = /*@__PURE__*/ new Vector3();
const _m1 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3(0, 0, 0);
const _one = /*@__PURE__*/ new Vector3(1, 1, 1);
const _x = /*@__PURE__*/ new Vector3();
const _y = /*@__PURE__*/ new Vector3();
const _z = /*@__PURE__*/ new Vector3();
class Euler {
    constructor(x = 0, y = 0, z = 0, order = Euler.DefaultOrder){
        Object.defineProperty(this, 'isEuler', {
            value: true
        });
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order || this._order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order, update) {
        const clamp = MathUtils.clamp;
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        order = order || this._order;
        switch(order){
            case 'XYZ':
                this._y = Math.asin(clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin(clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin(clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        _matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix(_matrix, order, update);
    }
    setFromVector3(v, order) {
        return this.set(v.x, v.y, v.z, order || this._order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        _quaternion$1.setFromEuler(this);
        return this.setFromQuaternion(_quaternion$1, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new Vector3(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
Euler.DefaultOrder = 'XYZ';
Euler.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
const _matrix = /*@__PURE__*/ new Matrix4();
const _quaternion$1 = /*@__PURE__*/ new Quaternion();
class Layers {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = 1 << channel | 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
}
let _object3DId = 0;
const _v1$2 = new Vector3();
const _q1 = new Quaternion();
const _m1$1 = new Matrix4();
const _target = new Vector3();
const _position = new Vector3();
const _scale = new Vector3();
const _quaternion$2 = new Quaternion();
const _xAxis = new Vector3(1, 0, 0);
const _yAxis = new Vector3(0, 1, 0);
const _zAxis = new Vector3(0, 0, 1);
const _addedEvent = {
    type: 'added'
};
const _removedEvent = {
    type: 'removed'
};
function Object3D() {
    Object.defineProperty(this, 'id', {
        value: _object3DId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'Object3D';
    this.parent = null;
    this.children = [];
    this.up = Object3D.DefaultUp.clone();
    const position = new Vector3();
    const rotation = new Euler();
    const quaternion = new Quaternion();
    const scale = new Vector3(1, 1, 1);
    function onRotationChange() {
        quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
        rotation.setFromQuaternion(quaternion, undefined, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
        position: {
            configurable: true,
            enumerable: true,
            value: position
        },
        rotation: {
            configurable: true,
            enumerable: true,
            value: rotation
        },
        quaternion: {
            configurable: true,
            enumerable: true,
            value: quaternion
        },
        scale: {
            configurable: true,
            enumerable: true,
            value: scale
        },
        modelViewMatrix: {
            value: new Matrix4()
        },
        normalMatrix: {
            value: new Matrix3()
        }
    });
    this.matrix = new Matrix4();
    this.matrixWorld = new Matrix4();
    this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
}
Object3D.DefaultUp = new Vector3(0, 1, 0);
Object3D.DefaultMatrixAutoUpdate = true;
Object3D.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Object3D,
    isObject3D: true,
    onBeforeRender: function() {},
    onAfterRender: function() {},
    applyMatrix4: function(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    },
    applyQuaternion: function(q) {
        this.quaternion.premultiply(q);
        return this;
    },
    setRotationFromAxisAngle: function(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    },
    setRotationFromEuler: function(euler) {
        this.quaternion.setFromEuler(euler, true);
    },
    setRotationFromMatrix: function(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    },
    setRotationFromQuaternion: function(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    },
    rotateOnAxis: function(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply(_q1);
        return this;
    },
    rotateOnWorldAxis: function(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply(_q1);
        return this;
    },
    rotateX: function(angle) {
        return this.rotateOnAxis(_xAxis, angle);
    },
    rotateY: function(angle) {
        return this.rotateOnAxis(_yAxis, angle);
    },
    rotateZ: function(angle) {
        return this.rotateOnAxis(_zAxis, angle);
    },
    translateOnAxis: function(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        _v1$2.copy(axis).applyQuaternion(this.quaternion);
        this.position.add(_v1$2.multiplyScalar(distance));
        return this;
    },
    translateX: function(distance) {
        return this.translateOnAxis(_xAxis, distance);
    },
    translateY: function(distance) {
        return this.translateOnAxis(_yAxis, distance);
    },
    translateZ: function(distance) {
        return this.translateOnAxis(_zAxis, distance);
    },
    localToWorld: function(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    },
    worldToLocal: function(vector) {
        return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
    },
    lookAt: function(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) _target.copy(x);
        else _target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        _position.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) _m1$1.lookAt(_position, _target, this.up);
        else _m1$1.lookAt(_target, _position, this.up);
        this.quaternion.setFromRotationMatrix(_m1$1);
        if (parent) {
            _m1$1.extractRotation(parent.matrixWorld);
            _q1.setFromRotationMatrix(_m1$1);
            this.quaternion.premultiply(_q1.invert());
        }
    },
    add: function(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent(_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    },
    remove: function(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent(_removedEvent);
        }
        return this;
    },
    clear: function() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent(_removedEvent);
        }
        this.children.length = 0;
        return this;
    },
    attach: function(object) {
        // adds object as a child of this, while maintaining the object's world transform
        this.updateWorldMatrix(true, false);
        _m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            _m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4(_m1$1);
        object.updateWorldMatrix(false, false);
        this.add(object);
        return this;
    },
    getObjectById: function(id) {
        return this.getObjectByProperty('id', id);
    },
    getObjectByName: function(name) {
        return this.getObjectByProperty('name', name);
    },
    getObjectByProperty: function(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    },
    getWorldPosition: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldPosition() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    },
    getWorldQuaternion: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldQuaternion() target is now required');
            target = new Quaternion();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position, target, _scale);
        return target;
    },
    getWorldScale: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldScale() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position, _quaternion$2, target);
        return target;
    },
    getWorldDirection: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldDirection() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    },
    raycast: function() {},
    traverse: function(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    },
    traverseVisible: function(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    },
    traverseAncestors: function(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    },
    updateMatrix: function() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    },
    updateMatrixWorld: function(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    },
    updateWorldMatrix: function(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    },
    toJSON: function(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    },
    clone: function(recursive) {
        return new this.constructor().copy(this, recursive);
    },
    copy: function(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
});
const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();
class Plane {
    constructor(normal, constant){
        Object.defineProperty(this, 'isPlane', {
            value: true
        });
        // normal is assumed to be normalized
        this.normal = normal !== undefined ? normal : new Vector3(1, 0, 0);
        this.constant = constant !== undefined ? constant : 0;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .projectPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .intersectLine() target is now required');
            target = new Vector3();
        }
        const direction = line.delta(_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return undefined;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return undefined;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .coplanarPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
}
const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3 = /*@__PURE__*/ new Vector3();
const _v2$1 = /*@__PURE__*/ new Vector3();
const _v3 = /*@__PURE__*/ new Vector3();
const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();
class Triangle {
    constructor(a, b, c){
        this.a = a !== undefined ? a : new Vector3();
        this.b = b !== undefined ? b : new Vector3();
        this.c = c !== undefined ? c : new Vector3();
    }
    static getNormal(a, b, c, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getNormal() target is now required');
            target = new Vector3();
        }
        target.subVectors(c, b);
        _v0$1.subVectors(a, b);
        target.cross(_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        _v0$1.subVectors(c, a);
        _v1$3.subVectors(b, a);
        _v2$1.subVectors(point, a);
        const dot00 = _v0$1.dot(_v0$1);
        const dot01 = _v0$1.dot(_v1$3);
        const dot02 = _v0$1.dot(_v2$1);
        const dot11 = _v1$3.dot(_v1$3);
        const dot12 = _v1$3.dot(_v2$1);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (target === undefined) {
            console.warn('THREE.Triangle: .getBarycoord() target is now required');
            target = new Vector3();
        }
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, _v3);
        return _v3.x >= 0 && _v3.y >= 0 && _v3.x + _v3.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, _v3);
        target.set(0, 0);
        target.addScaledVector(uv1, _v3.x);
        target.addScaledVector(uv2, _v3.y);
        target.addScaledVector(uv3, _v3.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        _v0$1.subVectors(c, b);
        _v1$3.subVectors(a, b);
        // strictly front facing
        return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        _v0$1.subVectors(this.c, this.b);
        _v1$3.subVectors(this.a, this.b);
        return _v0$1.cross(_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getMidpoint() target is now required');
            target = new Vector3();
        }
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return Triangle.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getPlane() target is now required');
            target = new Plane();
        }
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return Triangle.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        _vab.subVectors(b, a);
        _vac.subVectors(c, a);
        _vap.subVectors(p, a);
        const d1 = _vab.dot(_vap);
        const d2 = _vac.dot(_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        _vbp.subVectors(p, b);
        const d3 = _vab.dot(_vbp);
        const d4 = _vac.dot(_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector(_vab, v);
        }
        _vcp.subVectors(p, c);
        const d5 = _vab.dot(_vcp);
        const d6 = _vac.dot(_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector(_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            _vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const _colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const _hslA = {
    h: 0,
    s: 0,
    l: 0
};
const _hslB = {
    h: 0,
    s: 0,
    l: 0
};
function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class Color {
    constructor(r, g, b){
        Object.defineProperty(this, 'isColor', {
            value: true
        });
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = MathUtils.euclideanModulo(h, 1);
        s = MathUtils.clamp(s, 0, 1);
        l = MathUtils.clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = hue2rgb(q, p, h + 1 / 3);
            this.g = hue2rgb(q, p, h);
            this.b = hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = _colorKeywords[style];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copyGammaToLinear(color, gammaFactor = 2.0) {
        this.r = Math.pow(color.r, gammaFactor);
        this.g = Math.pow(color.g, gammaFactor);
        this.b = Math.pow(color.b, gammaFactor);
        return this;
    }
    copyLinearToGamma(color, gammaFactor = 2.0) {
        const safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;
        this.r = Math.pow(color.r, safeInverse);
        this.g = Math.pow(color.g, safeInverse);
        this.b = Math.pow(color.b, safeInverse);
        return this;
    }
    convertGammaToLinear(gammaFactor) {
        this.copyGammaToLinear(this, gammaFactor);
        return this;
    }
    convertLinearToGamma(gammaFactor) {
        this.copyLinearToGamma(this, gammaFactor);
        return this;
    }
    copySRGBToLinear(color) {
        this.r = SRGBToLinear(color.r);
        this.g = SRGBToLinear(color.g);
        this.b = SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = LinearToSRGB(color.r);
        this.g = LinearToSRGB(color.g);
        this.b = LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ('000000' + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        if (target === undefined) {
            console.warn('THREE.Color: .getHSL() target is now required');
            target = {
                h: 0,
                s: 0,
                l: 0
            };
        }
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return 'rgb(' + (this.r * 255 | 0) + ',' + (this.g * 255 | 0) + ',' + (this.b * 255 | 0) + ')';
    }
    offsetHSL(h, s, l) {
        this.getHSL(_hslA);
        _hslA.h += h;
        _hslA.s += s;
        _hslA.l += l;
        this.setHSL(_hslA.h, _hslA.s, _hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL(_hslA);
        color.getHSL(_hslB);
        const h = MathUtils.lerp(_hslA.h, _hslB.h, alpha);
        const s = MathUtils.lerp(_hslA.s, _hslB.s, alpha);
        const l = MathUtils.lerp(_hslA.l, _hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
}
Color.NAMES = _colorKeywords;
Color.prototype.r = 1;
Color.prototype.g = 1;
Color.prototype.b = 1;
class Face3 {
    constructor(a, b, c, normal, color, materialIndex = 0){
        this.a = a;
        this.b = b;
        this.c = c;
        this.normal = normal && normal.isVector3 ? normal : new Vector3();
        this.vertexNormals = Array.isArray(normal) ? normal : [];
        this.color = color && color.isColor ? color : new Color();
        this.vertexColors = Array.isArray(color) ? color : [];
        this.materialIndex = materialIndex;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.a = source.a;
        this.b = source.b;
        this.c = source.c;
        this.normal.copy(source.normal);
        this.color.copy(source.color);
        this.materialIndex = source.materialIndex;
        for(let i = 0, il = source.vertexNormals.length; i < il; i++)this.vertexNormals[i] = source.vertexNormals[i].clone();
        for(let i = 0, il = source.vertexColors.length; i < il; i++)this.vertexColors[i] = source.vertexColors[i].clone();
        return this;
    }
}
let materialId = 0;
function Material() {
    Object.defineProperty(this, 'id', {
        value: materialId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'Material';
    this.fog = true;
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.flatShading = false;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 0xff;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 0xff;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null; // override the renderer's default precision for this material
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaTest = 0;
    this.premultipliedAlpha = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
}
Material.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Material,
    isMaterial: true,
    onBeforeCompile: function() {},
    customProgramCacheKey: function() {
        return this.onBeforeCompile.toString();
    },
    setValues: function(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === 'shading') {
                console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                this.flatShading = newValue === FlatShading ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    },
    toJSON: function(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen && this.sheen.isColor) data.sheen = this.sheen.getHex();
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) data.lightMap = this.lightMap.toJSON(meta).uuid;
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            data.reflectivity = this.reflectivity; // Scale behind envMap
            data.refractionRatio = this.refractionRatio;
            if (this.combine !== undefined) data.combine = this.combine;
            if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        }
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.size !== undefined) data.size = this.size;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== NormalBlending) data.blending = this.blending;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.side !== FrontSide) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.morphTargets === true) data.morphTargets = true;
        if (this.morphNormals === true) data.morphNormals = true;
        if (this.skinning === true) data.skinning = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.flatShading = source.flatShading;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
Object.defineProperty(Material.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>
 * }
 */ function MeshBasicMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshBasicMaterial';
    this.color = new Color(0xffffff); // emissive
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.setValues(parameters);
}
MeshBasicMaterial.prototype = Object.create(Material.prototype);
MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;
MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
MeshBasicMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    return this;
};
const _vector$3 = new Vector3();
const _vector2$1 = new Vector2();
function BufferAttribute(array, itemSize, normalized) {
    if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
    this.name = '';
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== undefined ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = {
        offset: 0,
        count: -1
    };
    this.version = 0;
}
Object.defineProperty(BufferAttribute.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(BufferAttribute.prototype, {
    isBufferAttribute: true,
    onUploadCallback: function() {},
    setUsage: function(value) {
        this.usage = value;
        return this;
    },
    copy: function(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    },
    copyAt: function(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    },
    copyArray: function(array) {
        this.array.set(array);
        return this;
    },
    copyColorsArray: function(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
                color = new Color();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    },
    copyVector2sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
                vector = new Vector2();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    },
    copyVector3sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
                vector = new Vector3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    },
    copyVector4sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
                vector = new Vector4();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    },
    applyMatrix3: function(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            _vector2$1.fromBufferAttribute(this, i);
            _vector2$1.applyMatrix3(m);
            this.setXY(i, _vector2$1.x, _vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            _vector$3.fromBufferAttribute(this, i);
            _vector$3.applyMatrix3(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    applyMatrix4: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.applyMatrix4(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    applyNormalMatrix: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.applyNormalMatrix(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    transformDirection: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.transformDirection(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    set: function(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    },
    getX: function(index) {
        return this.array[index * this.itemSize];
    },
    setX: function(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    },
    getY: function(index) {
        return this.array[index * this.itemSize + 1];
    },
    setY: function(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    },
    getZ: function(index) {
        return this.array[index * this.itemSize + 2];
    },
    setZ: function(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    },
    getW: function(index) {
        return this.array[index * this.itemSize + 3];
    },
    setW: function(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    },
    setXY: function(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    },
    setXYZ: function(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    },
    setXYZW: function(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    },
    onUpload: function(callback) {
        this.onUploadCallback = callback;
        return this;
    },
    clone: function() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    },
    toJSON: function() {
        return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
    }
});
//
function Int8BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int8Array(array), itemSize, normalized);
}
Int8BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;
function Uint8BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint8Array(array), itemSize, normalized);
}
Uint8BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;
function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint8ClampedArray(array), itemSize, normalized);
}
Uint8ClampedBufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;
function Int16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int16Array(array), itemSize, normalized);
}
Int16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;
function Uint16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint16Array(array), itemSize, normalized);
}
Uint16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;
function Int32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int32Array(array), itemSize, normalized);
}
Int32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;
function Uint32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint32Array(array), itemSize, normalized);
}
Uint32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;
function Float16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint16Array(array), itemSize, normalized);
}
Float16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float16BufferAttribute.prototype.constructor = Float16BufferAttribute;
Float16BufferAttribute.prototype.isFloat16BufferAttribute = true;
function Float32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Float32Array(array), itemSize, normalized);
}
Float32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;
function Float64BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Float64Array(array), itemSize, normalized);
}
Float64BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;
class DirectGeometry {
    constructor(){
        this.vertices = [];
        this.normals = [];
        this.colors = [];
        this.uvs = [];
        this.uvs2 = [];
        this.groups = [];
        this.morphTargets = {};
        this.skinWeights = [];
        this.skinIndices = [];
        // this.lineDistances = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // update flags
        this.verticesNeedUpdate = false;
        this.normalsNeedUpdate = false;
        this.colorsNeedUpdate = false;
        this.uvsNeedUpdate = false;
        this.groupsNeedUpdate = false;
    }
    computeGroups(geometry) {
        const groups = [];
        let group, i;
        let materialIndex = undefined;
        const faces = geometry.faces;
        for(i = 0; i < faces.length; i++){
            const face = faces[i];
            // materials
            if (face.materialIndex !== materialIndex) {
                materialIndex = face.materialIndex;
                if (group !== undefined) {
                    group.count = i * 3 - group.start;
                    groups.push(group);
                }
                group = {
                    start: i * 3,
                    materialIndex: materialIndex
                };
            }
        }
        if (group !== undefined) {
            group.count = i * 3 - group.start;
            groups.push(group);
        }
        this.groups = groups;
    }
    fromGeometry(geometry) {
        const faces = geometry.faces;
        const vertices = geometry.vertices;
        const faceVertexUvs = geometry.faceVertexUvs;
        const hasFaceVertexUv = faceVertexUvs[0] && faceVertexUvs[0].length > 0;
        const hasFaceVertexUv2 = faceVertexUvs[1] && faceVertexUvs[1].length > 0;
        // morphs
        const morphTargets = geometry.morphTargets;
        const morphTargetsLength = morphTargets.length;
        let morphTargetsPosition;
        if (morphTargetsLength > 0) {
            morphTargetsPosition = [];
            for(let i = 0; i < morphTargetsLength; i++)morphTargetsPosition[i] = {
                name: morphTargets[i].name,
                data: []
            };
            this.morphTargets.position = morphTargetsPosition;
        }
        const morphNormals = geometry.morphNormals;
        const morphNormalsLength = morphNormals.length;
        let morphTargetsNormal;
        if (morphNormalsLength > 0) {
            morphTargetsNormal = [];
            for(let i = 0; i < morphNormalsLength; i++)morphTargetsNormal[i] = {
                name: morphNormals[i].name,
                data: []
            };
            this.morphTargets.normal = morphTargetsNormal;
        }
        // skins
        const skinIndices = geometry.skinIndices;
        const skinWeights = geometry.skinWeights;
        const hasSkinIndices = skinIndices.length === vertices.length;
        const hasSkinWeights = skinWeights.length === vertices.length;
        //
        if (vertices.length > 0 && faces.length === 0) console.error('THREE.DirectGeometry: Faceless geometries are not supported.');
        for(let i = 0; i < faces.length; i++){
            const face = faces[i];
            this.vertices.push(vertices[face.a], vertices[face.b], vertices[face.c]);
            const vertexNormals = face.vertexNormals;
            if (vertexNormals.length === 3) this.normals.push(vertexNormals[0], vertexNormals[1], vertexNormals[2]);
            else {
                const normal = face.normal;
                this.normals.push(normal, normal, normal);
            }
            const vertexColors = face.vertexColors;
            if (vertexColors.length === 3) this.colors.push(vertexColors[0], vertexColors[1], vertexColors[2]);
            else {
                const color = face.color;
                this.colors.push(color, color, color);
            }
            if (hasFaceVertexUv === true) {
                const vertexUvs = faceVertexUvs[0][i];
                if (vertexUvs !== undefined) this.uvs.push(vertexUvs[0], vertexUvs[1], vertexUvs[2]);
                else {
                    console.warn('THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i);
                    this.uvs.push(new Vector2(), new Vector2(), new Vector2());
                }
            }
            if (hasFaceVertexUv2 === true) {
                const vertexUvs = faceVertexUvs[1][i];
                if (vertexUvs !== undefined) this.uvs2.push(vertexUvs[0], vertexUvs[1], vertexUvs[2]);
                else {
                    console.warn('THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i);
                    this.uvs2.push(new Vector2(), new Vector2(), new Vector2());
                }
            }
            // morphs
            for(let j = 0; j < morphTargetsLength; j++){
                const morphTarget = morphTargets[j].vertices;
                morphTargetsPosition[j].data.push(morphTarget[face.a], morphTarget[face.b], morphTarget[face.c]);
            }
            for(let j = 0; j < morphNormalsLength; j++){
                const morphNormal = morphNormals[j].vertexNormals[i];
                morphTargetsNormal[j].data.push(morphNormal.a, morphNormal.b, morphNormal.c);
            }
            // skins
            if (hasSkinIndices) this.skinIndices.push(skinIndices[face.a], skinIndices[face.b], skinIndices[face.c]);
            if (hasSkinWeights) this.skinWeights.push(skinWeights[face.a], skinWeights[face.b], skinWeights[face.c]);
        }
        this.computeGroups(geometry);
        this.verticesNeedUpdate = geometry.verticesNeedUpdate;
        this.normalsNeedUpdate = geometry.normalsNeedUpdate;
        this.colorsNeedUpdate = geometry.colorsNeedUpdate;
        this.uvsNeedUpdate = geometry.uvsNeedUpdate;
        this.groupsNeedUpdate = geometry.groupsNeedUpdate;
        if (geometry.boundingSphere !== null) this.boundingSphere = geometry.boundingSphere.clone();
        if (geometry.boundingBox !== null) this.boundingBox = geometry.boundingBox.clone();
        return this;
    }
}
function arrayMax(array) {
    if (array.length === 0) return -Infinity;
    let max = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
const TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    // Workaround for IE11 pre KB2929437. See #11440
    Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function getTypedArray(type, buffer) {
    return new TYPED_ARRAYS[type](buffer);
}
let _bufferGeometryId = 1; // BufferGeometry uses odd numbers as Id
const _m1$2 = new Matrix4();
const _obj = new Object3D();
const _offset = new Vector3();
const _box$2 = new Box3();
const _boxMorphTargets = new Box3();
const _vector$4 = new Vector3();
function BufferGeometry() {
    Object.defineProperty(this, 'id', {
        value: _bufferGeometryId += 2
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'BufferGeometry';
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = {
        start: 0,
        count: Infinity
    };
    this.userData = {};
}
BufferGeometry.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: BufferGeometry,
    isBufferGeometry: true,
    getIndex: function() {
        return this.index;
    },
    setIndex: function(index) {
        if (Array.isArray(index)) this.index = new (arrayMax(index) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
        else this.index = index;
        return this;
    },
    getAttribute: function(name) {
        return this.attributes[name];
    },
    setAttribute: function(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    },
    deleteAttribute: function(name) {
        delete this.attributes[name];
        return this;
    },
    hasAttribute: function(name) {
        return this.attributes[name] !== undefined;
    },
    addGroup: function(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    },
    clearGroups: function() {
        this.groups = [];
    },
    setDrawRange: function(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    },
    applyMatrix4: function(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new Matrix3().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    },
    rotateX: function(angle) {
        // rotate geometry around world x-axis
        _m1$2.makeRotationX(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    rotateY: function(angle) {
        // rotate geometry around world y-axis
        _m1$2.makeRotationY(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    rotateZ: function(angle) {
        // rotate geometry around world z-axis
        _m1$2.makeRotationZ(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    translate: function(x, y, z) {
        // translate geometry
        _m1$2.makeTranslation(x, y, z);
        this.applyMatrix4(_m1$2);
        return this;
    },
    scale: function(x, y, z) {
        // scale geometry
        _m1$2.makeScale(x, y, z);
        this.applyMatrix4(_m1$2);
        return this;
    },
    lookAt: function(vector) {
        _obj.lookAt(vector);
        _obj.updateMatrix();
        this.applyMatrix4(_obj.matrix);
        return this;
    },
    center: function() {
        this.computeBoundingBox();
        this.boundingBox.getCenter(_offset).negate();
        this.translate(_offset.x, _offset.y, _offset.z);
        return this;
    },
    setFromObject: function(object) {
        // console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );
        const geometry = object.geometry;
        if (object.isPoints || object.isLine) {
            const positions = new Float32BufferAttribute(geometry.vertices.length * 3, 3);
            const colors = new Float32BufferAttribute(geometry.colors.length * 3, 3);
            this.setAttribute('position', positions.copyVector3sArray(geometry.vertices));
            this.setAttribute('color', colors.copyColorsArray(geometry.colors));
            if (geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length) {
                const lineDistances = new Float32BufferAttribute(geometry.lineDistances.length, 1);
                this.setAttribute('lineDistance', lineDistances.copyArray(geometry.lineDistances));
            }
            if (geometry.boundingSphere !== null) this.boundingSphere = geometry.boundingSphere.clone();
            if (geometry.boundingBox !== null) this.boundingBox = geometry.boundingBox.clone();
        } else if (object.isMesh) {
            if (geometry && geometry.isGeometry) this.fromGeometry(geometry);
        }
        return this;
    },
    setFromPoints: function(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new Float32BufferAttribute(position, 3));
        return this;
    },
    updateFromObject: function(object) {
        let geometry = object.geometry;
        if (object.isMesh) {
            let direct = geometry.__directGeometry;
            if (geometry.elementsNeedUpdate === true) {
                direct = undefined;
                geometry.elementsNeedUpdate = false;
            }
            if (direct === undefined) return this.fromGeometry(geometry);
            direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
            direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
            direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
            direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
            direct.groupsNeedUpdate = geometry.groupsNeedUpdate;
            geometry.verticesNeedUpdate = false;
            geometry.normalsNeedUpdate = false;
            geometry.colorsNeedUpdate = false;
            geometry.uvsNeedUpdate = false;
            geometry.groupsNeedUpdate = false;
            geometry = direct;
        }
        if (geometry.verticesNeedUpdate === true) {
            const attribute = this.attributes.position;
            if (attribute !== undefined) {
                attribute.copyVector3sArray(geometry.vertices);
                attribute.needsUpdate = true;
            }
            geometry.verticesNeedUpdate = false;
        }
        if (geometry.normalsNeedUpdate === true) {
            const attribute = this.attributes.normal;
            if (attribute !== undefined) {
                attribute.copyVector3sArray(geometry.normals);
                attribute.needsUpdate = true;
            }
            geometry.normalsNeedUpdate = false;
        }
        if (geometry.colorsNeedUpdate === true) {
            const attribute = this.attributes.color;
            if (attribute !== undefined) {
                attribute.copyColorsArray(geometry.colors);
                attribute.needsUpdate = true;
            }
            geometry.colorsNeedUpdate = false;
        }
        if (geometry.uvsNeedUpdate) {
            const attribute = this.attributes.uv;
            if (attribute !== undefined) {
                attribute.copyVector2sArray(geometry.uvs);
                attribute.needsUpdate = true;
            }
            geometry.uvsNeedUpdate = false;
        }
        if (geometry.lineDistancesNeedUpdate) {
            const attribute = this.attributes.lineDistance;
            if (attribute !== undefined) {
                attribute.copyArray(geometry.lineDistances);
                attribute.needsUpdate = true;
            }
            geometry.lineDistancesNeedUpdate = false;
        }
        if (geometry.groupsNeedUpdate) {
            geometry.computeGroups(object.geometry);
            this.groups = geometry.groups;
            geometry.groupsNeedUpdate = false;
        }
        return this;
    },
    fromGeometry: function(geometry) {
        geometry.__directGeometry = new DirectGeometry().fromGeometry(geometry);
        return this.fromDirectGeometry(geometry.__directGeometry);
    },
    fromDirectGeometry: function(geometry) {
        const positions = new Float32Array(geometry.vertices.length * 3);
        this.setAttribute('position', new BufferAttribute(positions, 3).copyVector3sArray(geometry.vertices));
        if (geometry.normals.length > 0) {
            const normals = new Float32Array(geometry.normals.length * 3);
            this.setAttribute('normal', new BufferAttribute(normals, 3).copyVector3sArray(geometry.normals));
        }
        if (geometry.colors.length > 0) {
            const colors = new Float32Array(geometry.colors.length * 3);
            this.setAttribute('color', new BufferAttribute(colors, 3).copyColorsArray(geometry.colors));
        }
        if (geometry.uvs.length > 0) {
            const uvs = new Float32Array(geometry.uvs.length * 2);
            this.setAttribute('uv', new BufferAttribute(uvs, 2).copyVector2sArray(geometry.uvs));
        }
        if (geometry.uvs2.length > 0) {
            const uvs2 = new Float32Array(geometry.uvs2.length * 2);
            this.setAttribute('uv2', new BufferAttribute(uvs2, 2).copyVector2sArray(geometry.uvs2));
        }
        // groups
        this.groups = geometry.groups;
        // morphs
        for(const name in geometry.morphTargets){
            const array = [];
            const morphTargets = geometry.morphTargets[name];
            for(let i = 0, l = morphTargets.length; i < l; i++){
                const morphTarget = morphTargets[i];
                const attribute = new Float32BufferAttribute(morphTarget.data.length * 3, 3);
                attribute.name = morphTarget.name;
                array.push(attribute.copyVector3sArray(morphTarget.data));
            }
            this.morphAttributes[name] = array;
        }
        // skinning
        if (geometry.skinIndices.length > 0) {
            const skinIndices = new Float32BufferAttribute(geometry.skinIndices.length * 4, 4);
            this.setAttribute('skinIndex', skinIndices.copyVector4sArray(geometry.skinIndices));
        }
        if (geometry.skinWeights.length > 0) {
            const skinWeights = new Float32BufferAttribute(geometry.skinWeights.length * 4, 4);
            this.setAttribute('skinWeight', skinWeights.copyVector4sArray(geometry.skinWeights));
        }
        //
        if (geometry.boundingSphere !== null) this.boundingSphere = geometry.boundingSphere.clone();
        if (geometry.boundingBox !== null) this.boundingBox = geometry.boundingBox.clone();
        return this;
    },
    computeBoundingBox: function() {
        if (this.boundingBox === null) this.boundingBox = new Box3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new Vector3(-Infinity, -Infinity, -Infinity), new Vector3(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$4.addVectors(this.boundingBox.min, _box$2.min);
                    this.boundingBox.expandByPoint(_vector$4);
                    _vector$4.addVectors(this.boundingBox.max, _box$2.max);
                    this.boundingBox.expandByPoint(_vector$4);
                } else {
                    this.boundingBox.expandByPoint(_box$2.min);
                    this.boundingBox.expandByPoint(_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    },
    computeBoundingSphere: function() {
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new Vector3(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            _box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$4.addVectors(_box$2.min, _boxMorphTargets.min);
                    _box$2.expandByPoint(_vector$4);
                    _vector$4.addVectors(_box$2.max, _boxMorphTargets.max);
                    _box$2.expandByPoint(_vector$4);
                } else {
                    _box$2.expandByPoint(_boxMorphTargets.min);
                    _box$2.expandByPoint(_boxMorphTargets.max);
                }
            }
            _box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                _vector$4.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$4));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    _vector$4.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        _offset.fromBufferAttribute(position, j);
                        _vector$4.add(_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$4));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    },
    computeFaceNormals: function() {
    // backwards compatibility
    },
    computeVertexNormals: function() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
            const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
            const cb = new Vector3(), ab = new Vector3();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    },
    merge: function(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    },
    normalizeNormals: function() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            _vector$4.fromBufferAttribute(normals, i);
            _vector$4.normalize();
            normals.setXYZ(i, _vector$4.x, _vector$4.y, _vector$4.z);
        }
    },
    toNonIndexed: function() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new BufferAttribute(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.');
            return this;
        }
        const geometry2 = new BufferGeometry();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            const attributeData = attribute.toJSON(data.data);
            if (attribute.name !== '') attributeData.name = attribute.name;
            data.data.attributes[key] = attributeData;
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                const attributeData = attribute.toJSON(data.data);
                if (attribute.name !== '') attributeData.name = attribute.name;
                array.push(attributeData);
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    },
    clone: function() {
        /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new BufferGeometry().copy(this);
    },
    copy: function(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
const _inverseMatrix = new Matrix4();
const _ray = new Ray();
const _sphere = new Sphere();
const _vA = new Vector3();
const _vB = new Vector3();
const _vC = new Vector3();
const _tempA = new Vector3();
const _tempB = new Vector3();
const _tempC = new Vector3();
const _morphA = new Vector3();
const _morphB = new Vector3();
const _morphC = new Vector3();
const _uvA = new Vector2();
const _uvB = new Vector2();
const _uvC = new Vector2();
const _intersectionPoint = new Vector3();
const _intersectionPointWorld = new Vector3();
function Mesh(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
    Object3D.call(this);
    this.type = 'Mesh';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Mesh.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Mesh,
    isMesh: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere.copy(geometry.boundingSphere);
        _sphere.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere(_sphere) === false) return;
        //
        _inverseMatrix.copy(matrixWorld).invert();
        _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if (_ray.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) {
            const isMultiMaterial = Array.isArray(material);
            const vertices = geometry.vertices;
            const faces = geometry.faces;
            let uvs;
            const faceVertexUvs = geometry.faceVertexUvs[0];
            if (faceVertexUvs.length > 0) uvs = faceVertexUvs;
            for(let f = 0, fl = faces.length; f < fl; f++){
                const face = faces[f];
                const faceMaterial = isMultiMaterial ? material[face.materialIndex] : material;
                if (faceMaterial === undefined) continue;
                const fvA = vertices[face.a];
                const fvB = vertices[face.b];
                const fvC = vertices[face.c];
                intersection = checkIntersection(this, faceMaterial, raycaster, _ray, fvA, fvB, fvC, _intersectionPoint);
                if (intersection) {
                    if (uvs && uvs[f]) {
                        const uvs_f = uvs[f];
                        _uvA.copy(uvs_f[0]);
                        _uvB.copy(uvs_f[1]);
                        _uvC.copy(uvs_f[2]);
                        intersection.uv = Triangle.getUV(_intersectionPoint, fvA, fvB, fvC, _uvA, _uvB, _uvC, new Vector2());
                    }
                    intersection.face = face;
                    intersection.faceIndex = f;
                    intersects.push(intersection);
                }
            }
        }
    }
});
function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === BackSide) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point);
    if (intersect === null) return null;
    _intersectionPointWorld.copy(point);
    _intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: _intersectionPointWorld.clone(),
        object: object
    };
}
function checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    _vA.fromBufferAttribute(position, a);
    _vB.fromBufferAttribute(position, b);
    _vC.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (material.morphTargets && morphPosition && morphInfluences) {
        _morphA.set(0, 0, 0);
        _morphB.set(0, 0, 0);
        _morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            _tempA.fromBufferAttribute(morphAttribute, a);
            _tempB.fromBufferAttribute(morphAttribute, b);
            _tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                _morphA.addScaledVector(_tempA, influence);
                _morphB.addScaledVector(_tempB, influence);
                _morphC.addScaledVector(_tempC, influence);
            } else {
                _morphA.addScaledVector(_tempA.sub(_vA), influence);
                _morphB.addScaledVector(_tempB.sub(_vB), influence);
                _morphC.addScaledVector(_tempC.sub(_vC), influence);
            }
        }
        _vA.add(_morphA);
        _vB.add(_morphB);
        _vC.add(_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, _vA);
        object.boneTransform(b, _vB);
        object.boneTransform(c, _vC);
    }
    const intersection = checkIntersection(object, material, raycaster, ray, _vA, _vB, _vC, _intersectionPoint);
    if (intersection) {
        if (uv) {
            _uvA.fromBufferAttribute(uv, a);
            _uvB.fromBufferAttribute(uv, b);
            _uvC.fromBufferAttribute(uv, c);
            intersection.uv = Triangle.getUV(_intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
        }
        if (uv2) {
            _uvA.fromBufferAttribute(uv2, a);
            _uvB.fromBufferAttribute(uv2, b);
            _uvC.fromBufferAttribute(uv2, c);
            intersection.uv2 = Triangle.getUV(_intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
        }
        const face = new Face3(a, b, c);
        Triangle.getNormal(_vA, _vB, _vC, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class BoxBufferGeometry extends BufferGeometry {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxBufferGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new Vector3();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
}
/**
 * Uniform Utilities
 */ function cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const UniformsUtils = {
    clone: cloneUniforms,
    merge: mergeUniforms
};
var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function ShaderMaterial(parameters) {
    Material.call(this);
    this.type = 'ShaderMaterial';
    this.defines = {};
    this.uniforms = {};
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false; // set to use scene fog
    this.lights = false; // set to use scene lights
    this.clipping = false; // set to use user-defined clipping planes
    this.skinning = false; // set to use skinning attribute streams
    this.morphTargets = false; // set to use morph targets
    this.morphNormals = false; // set to use morph normals
    this.extensions = {
        derivatives: false,
        fragDepth: false,
        drawBuffers: false,
        shaderTextureLOD: false // set to use shader texture LOD
    };
    // When rendered geometry doesn't include these attributes but the material does,
    // use these default values in WebGL. This avoids errors when buffer data is missing.
    this.defaultAttributeValues = {
        'color': [
            1,
            1,
            1
        ],
        'uv': [
            0,
            0
        ],
        'uv2': [
            0,
            0
        ]
    };
    this.index0AttributeName = undefined;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== undefined) {
        if (parameters.attributes !== undefined) console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
        this.setValues(parameters);
    }
}
ShaderMaterial.prototype = Object.create(Material.prototype);
ShaderMaterial.prototype.constructor = ShaderMaterial;
ShaderMaterial.prototype.isShaderMaterial = true;
ShaderMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
};
ShaderMaterial.prototype.toJSON = function(meta) {
    const data = Material.prototype.toJSON.call(this, meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for(const name in this.uniforms){
        const uniform = this.uniforms[name];
        const value = uniform.value;
        if (value && value.isTexture) data.uniforms[name] = {
            type: 't',
            value: value.toJSON(meta).uuid
        };
        else if (value && value.isColor) data.uniforms[name] = {
            type: 'c',
            value: value.getHex()
        };
        else if (value && value.isVector2) data.uniforms[name] = {
            type: 'v2',
            value: value.toArray()
        };
        else if (value && value.isVector3) data.uniforms[name] = {
            type: 'v3',
            value: value.toArray()
        };
        else if (value && value.isVector4) data.uniforms[name] = {
            type: 'v4',
            value: value.toArray()
        };
        else if (value && value.isMatrix3) data.uniforms[name] = {
            type: 'm3',
            value: value.toArray()
        };
        else if (value && value.isMatrix4) data.uniforms[name] = {
            type: 'm4',
            value: value.toArray()
        };
        else data.uniforms[name] = {
            value: value
        };
    }
    if (Object.keys(this.defines).length > 0) data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    const extensions = {};
    for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
    if (Object.keys(extensions).length > 0) data.extensions = extensions;
    return data;
};
function Camera() {
    Object3D.call(this);
    this.type = 'Camera';
    this.matrixWorldInverse = new Matrix4();
    this.projectionMatrix = new Matrix4();
    this.projectionMatrixInverse = new Matrix4();
}
Camera.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Camera,
    isCamera: true,
    copy: function(source, recursive) {
        Object3D.prototype.copy.call(this, source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    },
    getWorldDirection: function(target) {
        if (target === undefined) {
            console.warn('THREE.Camera: .getWorldDirection() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    },
    updateMatrixWorld: function(force) {
        Object3D.prototype.updateMatrixWorld.call(this, force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    },
    updateWorldMatrix: function(updateParents, updateChildren) {
        Object3D.prototype.updateWorldMatrix.call(this, updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    },
    clone: function() {
        return new this.constructor().copy(this);
    }
});
function PerspectiveCamera(fov = 50, aspect = 1, near = 0.1, far = 2000) {
    Camera.call(this);
    this.type = 'PerspectiveCamera';
    this.fov = fov;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect;
    this.view = null;
    this.filmGauge = 35; // width of the film (default in millimeters)
    this.filmOffset = 0; // horizontal film offset (same unit as gauge)
    this.updateProjectionMatrix();
}
PerspectiveCamera.prototype = Object.assign(Object.create(Camera.prototype), {
    constructor: PerspectiveCamera,
    isPerspectiveCamera: true,
    copy: function(source, recursive) {
        Camera.prototype.copy.call(this, source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    },
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength: function(focalLength) {
        // see http://www.bobatkins.com/photography/technical/field_of_view.html
        const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = MathUtils.RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    },
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength: function() {
        const vExtentSlope = Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    },
    getEffectiveFOV: function() {
        return MathUtils.RAD2DEG * 2 * Math.atan(Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov) / this.zoom);
    },
    getFilmWidth: function() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    },
    getFilmHeight: function() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    },
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset: function(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    },
    clearViewOffset: function() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    },
    updateProjectionMatrix: function() {
        const near = this.near;
        let top = near * Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
});
const fov = 90, aspect = 1;
function CubeCamera(near, far, renderTarget) {
    Object3D.call(this);
    this.type = 'CubeCamera';
    if (renderTarget.isWebGLCubeRenderTarget !== true) {
        console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
        return;
    }
    this.renderTarget = renderTarget;
    const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector3(1, 0, 0));
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector3(-1, 0, 0));
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector3(0, 1, 0));
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector3(0, -1, 0));
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector3(0, 0, 1));
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector3(0, 0, -1));
    this.add(cameraNZ);
    this.update = function(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
    };
}
CubeCamera.prototype = Object.create(Object3D.prototype);
CubeCamera.prototype.constructor = CubeCamera;
function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== undefined ? images : [];
    mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
    format = format !== undefined ? format : RGBFormat;
    Texture.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.flipY = false;
    // Why CubeTexture._needsFlipEnvMap is necessary:
    //
    // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
    // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
    // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
    // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
    // and the flag _needsFlipEnvMap controls this conversion. The flip is not required (and thus _needsFlipEnvMap is set to false)
    // when using WebGLCubeRenderTarget.texture as a cube texture.
    this._needsFlipEnvMap = true;
}
CubeTexture.prototype = Object.create(Texture.prototype);
CubeTexture.prototype.constructor = CubeTexture;
CubeTexture.prototype.isCubeTexture = true;
Object.defineProperty(CubeTexture.prototype, 'images', {
    get: function() {
        return this.image;
    },
    set: function(value) {
        this.image = value;
    }
});
function WebGLCubeRenderTarget(size, options, dummy) {
    if (Number.isInteger(options)) {
        console.warn('THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )');
        options = dummy;
    }
    WebGLRenderTarget.call(this, size, size, options);
    options = options || {};
    this.texture = new CubeTexture(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture._needsFlipEnvMap = false;
}
WebGLCubeRenderTarget.prototype = Object.create(WebGLRenderTarget.prototype);
WebGLCubeRenderTarget.prototype.constructor = WebGLCubeRenderTarget;
WebGLCubeRenderTarget.prototype.isWebGLCubeRenderTarget = true;
WebGLCubeRenderTarget.prototype.fromEquirectangularTexture = function(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.format = RGBAFormat; // see #18859
    this.texture.encoding = texture.encoding;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: /* glsl */ `

			varying vec3 vWorldDirection;

			vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

				return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

			}

			void main() {

				vWorldDirection = transformDirection( position, modelMatrix );

				#include <begin_vertex>
				#include <project_vertex>

			}
		`,
        fragmentShader: /* glsl */ `

			uniform sampler2D tEquirect;

			varying vec3 vWorldDirection;

			#include <common>

			void main() {

				vec3 direction = normalize( vWorldDirection );

				vec2 sampleUV = equirectUv( direction );

				gl_FragColor = texture2D( tEquirect, sampleUV );

			}
		`
    };
    const geometry = new BoxBufferGeometry(5, 5, 5);
    const material = new ShaderMaterial({
        name: 'CubemapFromEquirect',
        uniforms: cloneUniforms(shader.uniforms),
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader,
        side: BackSide,
        blending: NoBlending
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh(geometry, material);
    const currentMinFilter = texture.minFilter;
    // Avoid blurred poles
    if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
    const camera = new CubeCamera(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
};
WebGLCubeRenderTarget.prototype.clear = function(renderer, color, depth, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for(let i = 0; i < 6; i++){
        renderer.setRenderTarget(this, i);
        renderer.clear(color, depth, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
};
function DataTexture(data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = {
        data: data || null,
        width: width || 1,
        height: height || 1
    };
    this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
    this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
}
DataTexture.prototype = Object.create(Texture.prototype);
DataTexture.prototype.constructor = DataTexture;
DataTexture.prototype.isDataTexture = true;
const _sphere$1 = /*@__PURE__*/ new Sphere();
const _vector$5 = /*@__PURE__*/ new Vector3();
class Frustum {
    constructor(p0, p1, p2, p3, p4, p5){
        this.planes = [
            p0 !== undefined ? p0 : new Plane(),
            p1 !== undefined ? p1 : new Plane(),
            p2 !== undefined ? p2 : new Plane(),
            p3 !== undefined ? p3 : new Plane(),
            p4 !== undefined ? p4 : new Plane(),
            p5 !== undefined ? p5 : new Plane()
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$1.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere(_sphere$1);
    }
    intersectsSprite(sprite) {
        _sphere$1.center.set(0, 0, 0);
        _sphere$1.radius = 0.7071067811865476;
        _sphere$1.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere(_sphere$1);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            _vector$5.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            _vector$5.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            _vector$5.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint(_vector$5) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
}
function WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn('THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.');
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class PlaneBufferGeometry extends BufferGeometry {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneBufferGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tfDet *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor.xyz *= color.xyz;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif";
var normal_fragment_begin = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t\tbitangent = bitangent * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tfloat scale = sign( st1.t * st0.s - st0.t * st1.s );\n\t\tvec3 S = normalize( ( q0 * st1.t - q1 * st0.t ) * scale );\n\t\tvec3 T = normalize( ( - q0 * st1.s + q1 * st0.s ) * scale );\n\t\tvec3 N = normalize( surf_norm );\n\t\tmat3 tsn = mat3( S, T, N );\n\t\tmapN.xy *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN );\n\t#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmissionmap_fragment = "#ifdef USE_TRANSMISSIONMAP\n\ttotalTransmission *= texture2D( transmissionMap, vUv ).r;\n#endif";
var transmissionmap_pars_fragment = "#ifdef USE_TRANSMISSIONMAP\n\tuniform sampler2D transmissionMap;\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n\t#define TRANSMISSION\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef TRANSMISSION\n\tuniform float transmission;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <transmissionmap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#ifdef TRANSMISSION\n\t\tfloat totalTransmission = transmission;\n\t#endif\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <transmissionmap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#ifdef TRANSMISSION\n\t\tdiffuseColor.a *= mix( saturate( 1. - totalTransmission + linearToRelativeLuminance( reflectedLight.directSpecular + reflectedLight.indirectSpecular ) ), 1.0, metalness );\n\t#endif\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const ShaderChunk = {
    alphamap_fragment: alphamap_fragment,
    alphamap_pars_fragment: alphamap_pars_fragment,
    alphatest_fragment: alphatest_fragment,
    aomap_fragment: aomap_fragment,
    aomap_pars_fragment: aomap_pars_fragment,
    begin_vertex: begin_vertex,
    beginnormal_vertex: beginnormal_vertex,
    bsdfs: bsdfs,
    bumpmap_pars_fragment: bumpmap_pars_fragment,
    clipping_planes_fragment: clipping_planes_fragment,
    clipping_planes_pars_fragment: clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: clipping_planes_pars_vertex,
    clipping_planes_vertex: clipping_planes_vertex,
    color_fragment: color_fragment,
    color_pars_fragment: color_pars_fragment,
    color_pars_vertex: color_pars_vertex,
    color_vertex: color_vertex,
    common: common,
    cube_uv_reflection_fragment: cube_uv_reflection_fragment,
    defaultnormal_vertex: defaultnormal_vertex,
    displacementmap_pars_vertex: displacementmap_pars_vertex,
    displacementmap_vertex: displacementmap_vertex,
    emissivemap_fragment: emissivemap_fragment,
    emissivemap_pars_fragment: emissivemap_pars_fragment,
    encodings_fragment: encodings_fragment,
    encodings_pars_fragment: encodings_pars_fragment,
    envmap_fragment: envmap_fragment,
    envmap_common_pars_fragment: envmap_common_pars_fragment,
    envmap_pars_fragment: envmap_pars_fragment,
    envmap_pars_vertex: envmap_pars_vertex,
    envmap_physical_pars_fragment: envmap_physical_pars_fragment,
    envmap_vertex: envmap_vertex,
    fog_vertex: fog_vertex,
    fog_pars_vertex: fog_pars_vertex,
    fog_fragment: fog_fragment,
    fog_pars_fragment: fog_pars_fragment,
    gradientmap_pars_fragment: gradientmap_pars_fragment,
    lightmap_fragment: lightmap_fragment,
    lightmap_pars_fragment: lightmap_pars_fragment,
    lights_lambert_vertex: lights_lambert_vertex,
    lights_pars_begin: lights_pars_begin,
    lights_toon_fragment: lights_toon_fragment,
    lights_toon_pars_fragment: lights_toon_pars_fragment,
    lights_phong_fragment: lights_phong_fragment,
    lights_phong_pars_fragment: lights_phong_pars_fragment,
    lights_physical_fragment: lights_physical_fragment,
    lights_physical_pars_fragment: lights_physical_pars_fragment,
    lights_fragment_begin: lights_fragment_begin,
    lights_fragment_maps: lights_fragment_maps,
    lights_fragment_end: lights_fragment_end,
    logdepthbuf_fragment: logdepthbuf_fragment,
    logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
    logdepthbuf_vertex: logdepthbuf_vertex,
    map_fragment: map_fragment,
    map_pars_fragment: map_pars_fragment,
    map_particle_fragment: map_particle_fragment,
    map_particle_pars_fragment: map_particle_pars_fragment,
    metalnessmap_fragment: metalnessmap_fragment,
    metalnessmap_pars_fragment: metalnessmap_pars_fragment,
    morphnormal_vertex: morphnormal_vertex,
    morphtarget_pars_vertex: morphtarget_pars_vertex,
    morphtarget_vertex: morphtarget_vertex,
    normal_fragment_begin: normal_fragment_begin,
    normal_fragment_maps: normal_fragment_maps,
    normalmap_pars_fragment: normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: clearcoat_pars_fragment,
    packing: packing,
    premultiplied_alpha_fragment: premultiplied_alpha_fragment,
    project_vertex: project_vertex,
    dithering_fragment: dithering_fragment,
    dithering_pars_fragment: dithering_pars_fragment,
    roughnessmap_fragment: roughnessmap_fragment,
    roughnessmap_pars_fragment: roughnessmap_pars_fragment,
    shadowmap_pars_fragment: shadowmap_pars_fragment,
    shadowmap_pars_vertex: shadowmap_pars_vertex,
    shadowmap_vertex: shadowmap_vertex,
    shadowmask_pars_fragment: shadowmask_pars_fragment,
    skinbase_vertex: skinbase_vertex,
    skinning_pars_vertex: skinning_pars_vertex,
    skinning_vertex: skinning_vertex,
    skinnormal_vertex: skinnormal_vertex,
    specularmap_fragment: specularmap_fragment,
    specularmap_pars_fragment: specularmap_pars_fragment,
    tonemapping_fragment: tonemapping_fragment,
    tonemapping_pars_fragment: tonemapping_pars_fragment,
    transmissionmap_fragment: transmissionmap_fragment,
    transmissionmap_pars_fragment: transmissionmap_pars_fragment,
    uv_pars_fragment: uv_pars_fragment,
    uv_pars_vertex: uv_pars_vertex,
    uv_vertex: uv_vertex,
    uv2_pars_fragment: uv2_pars_fragment,
    uv2_pars_vertex: uv2_pars_vertex,
    uv2_vertex: uv2_vertex,
    worldpos_vertex: worldpos_vertex,
    background_frag: background_frag,
    background_vert: background_vert,
    cube_frag: cube_frag,
    cube_vert: cube_vert,
    depth_frag: depth_frag,
    depth_vert: depth_vert,
    distanceRGBA_frag: distanceRGBA_frag,
    distanceRGBA_vert: distanceRGBA_vert,
    equirect_frag: equirect_frag,
    equirect_vert: equirect_vert,
    linedashed_frag: linedashed_frag,
    linedashed_vert: linedashed_vert,
    meshbasic_frag: meshbasic_frag,
    meshbasic_vert: meshbasic_vert,
    meshlambert_frag: meshlambert_frag,
    meshlambert_vert: meshlambert_vert,
    meshmatcap_frag: meshmatcap_frag,
    meshmatcap_vert: meshmatcap_vert,
    meshtoon_frag: meshtoon_frag,
    meshtoon_vert: meshtoon_vert,
    meshphong_frag: meshphong_frag,
    meshphong_vert: meshphong_vert,
    meshphysical_frag: meshphysical_frag,
    meshphysical_vert: meshphysical_vert,
    normal_frag: normal_frag,
    normal_vert: normal_vert,
    points_frag: points_frag,
    points_vert: points_vert,
    shadow_frag: shadow_frag,
    shadow_vert: shadow_vert,
    sprite_frag: sprite_frag,
    sprite_vert: sprite_vert
};
/**
 * Uniforms library for shared webgl shaders
 */ const UniformsLib = {
    common: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        },
        uv2Transform: {
            value: new Matrix3()
        },
        alphaMap: {
            value: null
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        refractionRatio: {
            value: 0.98
        },
        maxMipLevel: {
            value: 0
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new Vector2(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new Color(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        }
    },
    sprite: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new Vector2(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        }
    }
};
const ShaderLib = {
    basic: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.meshbasic_vert,
        fragmentShader: ShaderChunk.meshbasic_frag
    },
    lambert: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshlambert_vert,
        fragmentShader: ShaderChunk.meshlambert_frag
    },
    phong: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                },
                specular: {
                    value: new Color(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: ShaderChunk.meshphong_vert,
        fragmentShader: ShaderChunk.meshphong_frag
    },
    standard: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.roughnessmap,
            UniformsLib.metalnessmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: ShaderChunk.meshphysical_vert,
        fragmentShader: ShaderChunk.meshphysical_frag
    },
    toon: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.gradientmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshtoon_vert,
        fragmentShader: ShaderChunk.meshtoon_frag
    },
    matcap: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: ShaderChunk.meshmatcap_vert,
        fragmentShader: ShaderChunk.meshmatcap_frag
    },
    points: {
        uniforms: mergeUniforms([
            UniformsLib.points,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.points_vert,
        fragmentShader: ShaderChunk.points_frag
    },
    dashed: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: ShaderChunk.linedashed_vert,
        fragmentShader: ShaderChunk.linedashed_frag
    },
    depth: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.displacementmap
        ]),
        vertexShader: ShaderChunk.depth_vert,
        fragmentShader: ShaderChunk.depth_frag
    },
    normal: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.normal_vert,
        fragmentShader: ShaderChunk.normal_frag
    },
    sprite: {
        uniforms: mergeUniforms([
            UniformsLib.sprite,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.sprite_vert,
        fragmentShader: ShaderChunk.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new Matrix3()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: ShaderChunk.background_vert,
        fragmentShader: ShaderChunk.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: mergeUniforms([
            UniformsLib.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.cube_vert,
        fragmentShader: ShaderChunk.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: ShaderChunk.equirect_vert,
        fragmentShader: ShaderChunk.equirect_frag
    },
    distanceRGBA: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.displacementmap,
            {
                referencePosition: {
                    value: new Vector3()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: ShaderChunk.distanceRGBA_vert,
        fragmentShader: ShaderChunk.distanceRGBA_frag
    },
    shadow: {
        uniforms: mergeUniforms([
            UniformsLib.lights,
            UniformsLib.fog,
            {
                color: {
                    value: new Color(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.shadow_vert,
        fragmentShader: ShaderChunk.shadow_frag
    }
};
ShaderLib.physical = {
    uniforms: mergeUniforms([
        ShaderLib.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new Vector2(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: new Color(0x000000)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            }
        }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
};
function WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
    const clearColor = new Color(0x000000);
    let clearAlpha = 0;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene, camera, forceClear) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.isWebGLCubeRenderTarget || background.mapping === CubeUVReflectionMapping)) {
            if (boxMesh === undefined) {
                boxMesh = new Mesh(new BoxBufferGeometry(1, 1, 1), new ShaderMaterial({
                    name: 'BackgroundCubeMaterial',
                    uniforms: cloneUniforms(ShaderLib.cube.uniforms),
                    vertexShader: ShaderLib.cube.vertexShader,
                    fragmentShader: ShaderLib.cube.fragmentShader,
                    side: BackSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            if (background.isWebGLCubeRenderTarget) // TODO Deprecate
            background = background.texture;
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new Mesh(new PlaneBufferGeometry(2, 2), new ShaderMaterial({
                    name: 'BackgroundMaterial',
                    uniforms: cloneUniforms(ShaderLib.background.uniforms),
                    vertexShader: ShaderLib.background.vertexShader,
                    fragmentShader: ShaderLib.background.fragmentShader,
                    side: FrontSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute >= 0) {
                const geometryAttribute = geometryAttributes[name];
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
                    }
                } else if (name === 'instanceMatrix') {
                    const attribute = attributes.get(object.instanceMatrix);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute + 0, 1);
                    enableAttributeAndDivisor(programAttribute + 1, 1);
                    enableAttributeAndDivisor(programAttribute + 2, 1);
                    enableAttributeAndDivisor(programAttribute + 3, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute + 0, 4, type, false, 64, 0);
                    gl.vertexAttribPointer(programAttribute + 1, 4, type, false, 64, 16);
                    gl.vertexAttribPointer(programAttribute + 2, 4, type, false, 64, 32);
                    gl.vertexAttribPointer(programAttribute + 3, 4, type, false, 64, 48);
                } else if (name === 'instanceColor') {
                    const attribute = attributes.get(object.instanceColor);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute, 3, type, false, 12, 0);
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        const extension = extensions.get('EXT_texture_filter_anisotropic');
        if (extension !== null) maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    /* eslint-disable no-undef */ const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    /* eslint-enable no-undef */ let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || !!extensions.get('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new Plane(), viewNormalMatrix = new Matrix3(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === EquirectangularReflectionMapping) texture.mapping = CubeReflectionMapping;
        else if (mapping === EquirectangularRefractionMapping) texture.mapping = CubeRefractionMapping;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const currentRenderList = renderer.getRenderList();
                        const currentRenderTarget = renderer.getRenderTarget();
                        const renderTarget = new WebGLCubeRenderTarget(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        renderer.setRenderTarget(currentRenderTarget);
                        renderer.setRenderList(currentRenderList);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function WebGLExtensions(gl) {
    const extensions = {};
    return {
        has: function(name) {
            if (extensions[name] !== undefined) return extensions[name] !== null;
            let extension;
            switch(name){
                case 'WEBGL_depth_texture':
                    extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                    break;
                case 'EXT_texture_filter_anisotropic':
                    extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                    break;
                case 'WEBGL_compressed_texture_s3tc':
                    extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                    break;
                case 'WEBGL_compressed_texture_pvrtc':
                    extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                    break;
                default:
                    extension = gl.getExtension(name);
            }
            extensions[name] = extension;
            return extension !== null;
        },
        get: function(name) {
            if (!this.has(name)) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extensions[name];
        }
    };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = new WeakMap();
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        const buffergeometry = geometries.get(geometry);
        if (buffergeometry.index !== null) attributes.remove(buffergeometry.index);
        for(const name in buffergeometry.attributes)attributes.remove(buffergeometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        geometries.delete(geometry);
        const attribute = wireframeAttributes.get(buffergeometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(buffergeometry);
        }
        bindingStates.releaseStatesOfGeometry(buffergeometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        let buffergeometry = geometries.get(geometry);
        if (buffergeometry) return buffergeometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        if (geometry.isBufferGeometry) buffergeometry = geometry;
        else if (geometry.isGeometry) {
            if (geometry._bufferGeometry === undefined) geometry._bufferGeometry = new BufferGeometry().setFromObject(object);
            buffergeometry = geometry._bufferGeometry;
        }
        geometries.set(geometry, buffergeometry);
        info.memory.geometries++;
        return buffergeometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new (arrayMax(indices) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function numericalSort(a, b) {
    return a[0] - b[0];
}
function absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function WebGLMorphtargets(gl) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        // When object doesn't have morph target influences defined, we treat it as a 0-length array
        // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
        const length = objectInfluences === undefined ? 0 : objectInfluences.length;
        let influences = influencesList[geometry.id];
        if (influences === undefined) {
            // initialise list
            influences = [];
            for(let i = 0; i < length; i++)influences[i] = [
                i,
                0
            ];
            influencesList[geometry.id] = influences;
        }
        // Collect influences
        for(let i = 0; i < length; i++){
            const influence = influences[i];
            influence[0] = i;
            influence[1] = objectInfluences[i];
        }
        influences.sort(absNumericalSort);
        for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
            workInfluences[i][0] = influences[i][0];
            workInfluences[i][1] = influences[i][1];
        } else {
            workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
            workInfluences[i][1] = 0;
        }
        workInfluences.sort(numericalSort);
        const morphTargets = material.morphTargets && geometry.morphAttributes.position;
        const morphNormals = material.morphNormals && geometry.morphAttributes.normal;
        let morphInfluencesSum = 0;
        for(let i = 0; i < 8; i++){
            const influence = workInfluences[i];
            const index = influence[0];
            const value = influence[1];
            if (index !== Number.MAX_SAFE_INTEGER && value) {
                if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                morphInfluences[i] = value;
                morphInfluencesSum += value;
            } else {
                if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                morphInfluences[i] = 0;
            }
        }
        // GLSL shader uses formula baseinfluence * base + sum(target * influence)
        // This allows us to switch between absolute morphs and relative morphs without changing shader code
        // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
        const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
        program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
    }
    return {
        update: update
    };
}
function WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            if (geometry.isGeometry) buffergeometry.updateFromObject(object);
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
function DataTexture2DArray(data = null, width = 1, height = 1, depth = 1) {
    Texture.call(this, null);
    this.image = {
        data: data,
        width: width,
        height: height,
        depth: depth
    };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.needsUpdate = true;
}
DataTexture2DArray.prototype = Object.create(Texture.prototype);
DataTexture2DArray.prototype.constructor = DataTexture2DArray;
DataTexture2DArray.prototype.isDataTexture2DArray = true;
function DataTexture3D(data = null, width = 1, height = 1, depth = 1) {
    // We're going to add .setXXX() methods for setting properties later.
    // Users can still set in DataTexture3D directly.
    //
    //	const texture = new THREE.DataTexture3D( data, width, height, depth );
    // 	texture.anisotropy = 16;
    //
    // See #14839
    Texture.call(this, null);
    this.image = {
        data: data,
        width: width,
        height: height,
        depth: depth
    };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.needsUpdate = true;
}
DataTexture3D.prototype = Object.create(Texture.prototype);
DataTexture3D.prototype.constructor = DataTexture3D;
DataTexture3D.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const emptyTexture = new Texture();
const emptyTexture2dArray = new DataTexture2DArray();
const emptyTexture3d = new DataTexture3D();
const emptyCubeTexture = new CubeTexture();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const arrayCacheF32 = [];
const arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function allocTexUnits(textures, n) {
    let r = arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        copyArray(cache, v);
    }
}
// Single matrix (from flat array or MatrixN)
function setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, mat2array);
        copyArray(cache, elements);
    }
}
function setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, mat3array);
        copyArray(cache, elements);
    }
}
function setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, mat4array);
        copyArray(cache, elements);
    }
}
// Single texture (2D / Cube)
function setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || emptyTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || emptyTexture2dArray, unit);
}
function setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || emptyTexture3d, unit);
}
function setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || emptyCubeTexture, unit);
}
// Integer / Boolean vectors or arrays thereof (always flat arrays)
function setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
function setValueV2i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    copyArray(cache, v);
}
function setValueV3i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    copyArray(cache, v);
}
function setValueV4i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    copyArray(cache, v);
}
// uint
function setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Helper to pick the right setter for the singular case
function getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1f; // FLOAT
        case 0x8b50:
            return setValueV2f; // _VEC2
        case 0x8b51:
            return setValueV3f; // _VEC3
        case 0x8b52:
            return setValueV4f; // _VEC4
        case 0x8b5a:
            return setValueM2; // _MAT2
        case 0x8b5b:
            return setValueM3; // _MAT3
        case 0x8b5c:
            return setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4i; // _VEC4
        case 0x1405:
            return setValueV1ui; // UINT
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return setValueT2DArray1;
    }
}
// Array of scalars
function setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Integer / Boolean vectors or arrays thereof (always flat arrays)
function setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
function setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of vectors (flat or from THREE classes)
function setValueV2fArray(gl, v) {
    const data = flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
    const data = flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (flat or from THREE clases)
function setValueM2Array(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
    const data = flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
    const data = flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of textures (2D / Cube)
function setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || emptyTexture, units[i]);
}
function setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || emptyCubeTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1fArray; // FLOAT
        case 0x8b50:
            return setValueV2fArray; // _VEC2
        case 0x8b51:
            return setValueV3fArray; // _VEC3
        case 0x8b52:
            return setValueV4fArray; // _VEC4
        case 0x8b5a:
            return setValueM2Array; // _MAT2
        case 0x8b5b:
            return setValueM3Array; // _MAT3
        case 0x8b5c:
            return setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4iArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1Array;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6Array;
    }
}
// --- Uniform Classes ---
function SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    copyArray(cache, data);
};
function StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    RePathPart.lastIndex = 0;
    while(true){
        const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            addUniform(container, subscript === undefined ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new StructuredUniform(id);
                addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        parseUniform(info, addr, this);
    }
}
WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let programIdCount = 0;
function addLineNumbers(string) {
    const lines = string.split('\n');
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ': ' + lines[i];
    return lines.join('\n');
}
function getEncodingComponents(encoding) {
    switch(encoding){
        case LinearEncoding:
            return [
                'Linear',
                '( value )'
            ];
        case sRGBEncoding:
            return [
                'sRGB',
                '( value )'
            ];
        case RGBEEncoding:
            return [
                'RGBE',
                '( value )'
            ];
        case RGBM7Encoding:
            return [
                'RGBM',
                '( value, 7.0 )'
            ];
        case RGBM16Encoding:
            return [
                'RGBM',
                '( value, 16.0 )'
            ];
        case RGBDEncoding:
            return [
                'RGBD',
                '( value, 256.0 )'
            ];
        case GammaEncoding:
            return [
                'Gamma',
                '( value, float( GAMMA_FACTOR ) )'
            ];
        case LogLuvEncoding:
            return [
                'LogLuv',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const log = gl.getShaderInfoLog(shader).trim();
    if (status && log === '') return '';
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    const source = gl.getShaderSource(shader);
    return 'THREE.WebGLShader: gl.getShaderInfoLog() ' + type + '\n' + log + addLineNumbers(source);
}
function getTexelDecodingFunction(functionName, encoding) {
    const components = getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[0] + 'ToLinear' + components[1] + '; }';
}
function getTexelEncodingFunction(functionName, encoding) {
    const components = getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case CineonToneMapping:
            toneMappingName = 'OptimizedCineon';
            break;
        case ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter(filterEmptyLine).join('\n');
}
function generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = gl.getAttribLocation(program, name);
    }
    return attributes;
}
function filterEmptyLine(string) {
    return string !== '';
}
function replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
    return string.replace(includePattern, includeReplacer);
}
function includeReplacer(match, include) {
    const string = ShaderChunk[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return resolveIncludes(string);
}
// Unroll Loops
const deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
    return string.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}
function deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
    return loopReplacer(match, start, end, snippet);
}
function loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === PCFShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === PCFSoftShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === VSMShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case CubeReflectionMapping:
        case CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case CubeUVReflectionMapping:
        case CubeUVRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case CubeRefractionMapping:
        case CubeUVRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
    const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1.0;
    const customExtensions = parameters.isWebGL2 ? '' : generateExtensions(parameters);
    const customDefines = generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            '#define MAX_BONES ' + parameters.maxBones,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#ifdef USE_COLOR',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_MORPHTARGETS',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter(filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest + (parameters.alphaTest % 1 ? '' : '.0') : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#define TEXTURE_LOD_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== NoToneMapping ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== NoToneMapping ? ShaderChunk['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== NoToneMapping ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            ShaderChunk['encodings_pars_fragment'],
            parameters.map ? getTexelDecodingFunction('mapTexelToLinear', parameters.mapEncoding) : '',
            parameters.matcap ? getTexelDecodingFunction('matcapTexelToLinear', parameters.matcapEncoding) : '',
            parameters.envMap ? getTexelDecodingFunction('envMapTexelToLinear', parameters.envMapEncoding) : '',
            parameters.emissiveMap ? getTexelDecodingFunction('emissiveMapTexelToLinear', parameters.emissiveMapEncoding) : '',
            parameters.lightMap ? getTexelDecodingFunction('lightMapTexelToLinear', parameters.lightMapEncoding) : '',
            getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.depthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter(filterEmptyLine).join('\n');
    }
    vertexShader = resolveIncludes(vertexShader);
    vertexShader = replaceLightNums(vertexShader, parameters);
    vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = resolveIncludes(fragmentShader);
    fragmentShader = replaceLightNums(fragmentShader, parameters);
    fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = unrollLoops(vertexShader);
    fragmentShader = unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === GLSL3 ? '' : 'out highp vec4 pc_fragColor;',
            parameters.glslVersion === GLSL3 ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
            const fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: shader error: ', gl.getError(), '35715', gl.getProgramParameter(program, 35715), 'gl.getProgramInfoLog', programLog, vertexErrors, fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: gl.getProgramInfoLog()', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
function WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    const parameterNames = [
        'precision',
        'isWebGL2',
        'supportsVertexTextures',
        'outputEncoding',
        'instancing',
        'instancingColor',
        'map',
        'mapEncoding',
        'matcap',
        'matcapEncoding',
        'envMap',
        'envMapMode',
        'envMapEncoding',
        'envMapCubeUV',
        'lightMap',
        'lightMapEncoding',
        'aoMap',
        'emissiveMap',
        'emissiveMapEncoding',
        'bumpMap',
        'normalMap',
        'objectSpaceNormalMap',
        'tangentSpaceNormalMap',
        'clearcoatMap',
        'clearcoatRoughnessMap',
        'clearcoatNormalMap',
        'displacementMap',
        'specularMap',
        'roughnessMap',
        'metalnessMap',
        'gradientMap',
        'alphaMap',
        'combine',
        'vertexColors',
        'vertexTangents',
        'vertexUvs',
        'uvsVertexOnly',
        'fog',
        'useFog',
        'fogExp2',
        'flatShading',
        'sizeAttenuation',
        'logarithmicDepthBuffer',
        'skinning',
        'maxBones',
        'useVertexTexture',
        'morphTargets',
        'morphNormals',
        'maxMorphTargets',
        'maxMorphNormals',
        'premultipliedAlpha',
        'numDirLights',
        'numPointLights',
        'numSpotLights',
        'numHemiLights',
        'numRectAreaLights',
        'numDirLightShadows',
        'numPointLightShadows',
        'numSpotLightShadows',
        'shadowMapEnabled',
        'shadowMapType',
        'toneMapping',
        'physicallyCorrectLights',
        'alphaTest',
        'doubleSided',
        'flipSided',
        'numClippingPlanes',
        'numClipIntersection',
        'depthPacking',
        'dithering',
        'sheen',
        'transmissionMap'
    ];
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn('THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.');
                return 0;
            }
            return maxBones;
        }
    }
    function getTextureEncodingFromMap(map) {
        let encoding;
        if (map && map.isTexture) encoding = map.encoding;
        else if (map && map.isWebGLRenderTarget) {
            console.warn('THREE.WebGLPrograms.getTextureEncodingFromMap: don\'t use render targets as textures. Use their .texture property instead.');
            encoding = map.texture.encoding;
        } else encoding = LinearEncoding;
        return encoding;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = cubemaps.get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        let vertexShader, fragmentShader;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
            map: !!material.map,
            mapEncoding: getTextureEncodingFromMap(material.map),
            matcap: !!material.matcap,
            matcapEncoding: getTextureEncodingFromMap(material.matcap),
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapEncoding: getTextureEncodingFromMap(envMap),
            envMapCubeUV: !!envMap && (envMap.mapping === CubeUVReflectionMapping || envMap.mapping === CubeUVRefractionMapping),
            lightMap: !!material.lightMap,
            lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
            tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
            clearcoatMap: !!material.clearcoatMap,
            clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            alphaMap: !!material.alphaMap,
            gradientMap: !!material.gradientMap,
            sheen: !!material.sheen,
            transmissionMap: !!material.transmissionMap,
            combine: material.combine,
            vertexTangents: material.normalMap && material.vertexTangents,
            vertexColors: material.vertexColors,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmissionMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: material.skinning && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: material.morphTargets,
            morphNormals: material.morphNormals,
            maxMorphTargets: renderer.maxMorphTargets,
            maxMorphNormals: renderer.maxMorphNormals,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            alphaTest: material.alphaTest,
            doubleSided: material.side === DoubleSide,
            flipSided: material.side === BackSide,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.fragmentShader);
            array.push(parameters.vertexShader);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            for(let i = 0; i < parameterNames.length; i++)array.push(parameters[parameterNames[i]]);
            array.push(renderer.outputEncoding);
            array.push(renderer.gammaFactor);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            uniforms = UniformsUtils.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs
    };
}
function WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.program !== b.program) return a.program.id - b.program.id;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function WebGLRenderList(properties) {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transparent = [];
    const defaultProgram = {
        id: -1
    };
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        const materialProperties = properties.get(material);
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                program: materialProperties.program || defaultProgram,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.program = materialProperties.program || defaultProgram;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        (material.transparent === true ? transparent : opaque).push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        (material.transparent === true ? transparent : opaque).unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.program = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function WebGLRenderLists(properties) {
    let lists = new WeakMap();
    function get(scene, camera) {
        const cameras = lists.get(scene);
        let list;
        if (cameras === undefined) {
            list = new WebGLRenderList(properties);
            lists.set(scene, new WeakMap());
            lists.get(scene).set(camera, list);
        } else {
            list = cameras.get(camera);
            if (list === undefined) {
                list = new WebGLRenderList(properties);
                cameras.set(camera, list);
            }
        }
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new Vector3(),
                        color: new Color()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new Vector3(),
                        direction: new Vector3(),
                        color: new Color(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new Vector3(),
                        color: new Color(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new Vector3(),
                        skyColor: new Color(),
                        groundColor: new Color()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new Color(),
                        position: new Vector3(),
                        halfWidth: new Vector3(),
                        halfHeight: new Vector3()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let nextVersion = 0;
function shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function WebGLLights(extensions, capabilities) {
    const cache = new UniformsCache();
    const shadowCache = ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new Vector3());
    const vector3 = new Vector3();
    const matrix4 = new Matrix4();
    const matrix42 = new Matrix4();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort(shadowCastingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
                state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
                    state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
                    state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function WebGLRenderState(extensions, capabilities) {
    const lights = new WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, []);
            renderStates.get(scene).push(renderState);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ function MeshDepthMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshDepthMaterial';
    this.depthPacking = BasicDepthPacking;
    this.skinning = false;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.setValues(parameters);
}
MeshDepthMaterial.prototype = Object.create(Material.prototype);
MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;
MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
MeshDepthMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.depthPacking = source.depthPacking;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
};
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ function MeshDistanceMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshDistanceMaterial';
    this.referencePosition = new Vector3();
    this.nearDistance = 1;
    this.farDistance = 1000;
    this.skinning = false;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.fog = false;
    this.setValues(parameters);
}
MeshDistanceMaterial.prototype = Object.create(Material.prototype);
MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;
MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
MeshDistanceMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.referencePosition.copy(source.referencePosition);
    this.nearDistance = source.nearDistance;
    this.farDistance = source.farDistance;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
};
var vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var vsm_vert = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
function WebGLShadowMap(_renderer, _objects, maxTextureSize) {
    let _frustum = new Frustum();
    const _shadowMapSize = new Vector2(), _viewportSize = new Vector2(), _viewport = new Vector4(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {};
    const shadowSide = {
        0: BackSide,
        1: FrontSide,
        2: DoubleSide
    };
    const shadowMaterialVertical = new ShaderMaterial({
        defines: {
            SAMPLE_RATE: 0.25,
            HALF_SAMPLE_RATE: 0.125
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new Vector2()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: vsm_vert,
        fragmentShader: vsm_frag
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new BufferGeometry();
    fullScreenTri.setAttribute('position', new BufferAttribute(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = PCFShadowMap;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending(NoBlending);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > maxTextureSize || _shadowMapSize.y > maxTextureSize) {
                if (_shadowMapSize.x > maxTextureSize) {
                    _viewportSize.x = Math.floor(maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > maxTextureSize) {
                    _viewportSize.y = Math.floor(maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === VSMShadowMap) {
                const pars = {
                    minFilter: LinearFilter,
                    magFilter: LinearFilter,
                    format: RGBAFormat
                };
                shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: NearestFilter,
                    magFilter: NearestFilter,
                    format: RGBAFormat
                };
                shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === VSMShadowMap) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterialVariant(useMorphing, useSkinning, useInstancing) {
        const index = useMorphing << 0 | useSkinning << 1 | useInstancing << 2;
        let material = _depthMaterials[index];
        if (material === undefined) {
            material = new MeshDepthMaterial({
                depthPacking: RGBADepthPacking,
                morphTargets: useMorphing,
                skinning: useSkinning
            });
            _depthMaterials[index] = material;
        }
        return material;
    }
    function getDistanceMaterialVariant(useMorphing, useSkinning, useInstancing) {
        const index = useMorphing << 0 | useSkinning << 1 | useInstancing << 2;
        let material = _distanceMaterials[index];
        if (material === undefined) {
            material = new MeshDistanceMaterial({
                morphTargets: useMorphing,
                skinning: useSkinning
            });
            _distanceMaterials[index] = material;
        }
        return material;
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        let getMaterialVariant = getDepthMaterialVariant;
        let customMaterial = object.customDepthMaterial;
        if (light.isPointLight === true) {
            getMaterialVariant = getDistanceMaterialVariant;
            customMaterial = object.customDistanceMaterial;
        }
        if (customMaterial === undefined) {
            let useMorphing = false;
            if (material.morphTargets === true) useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
            let useSkinning = false;
            if (object.isSkinnedMesh === true) {
                if (material.skinning === true) useSkinning = true;
                else console.warn('THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object);
            }
            const useInstancing = object.isInstancedMesh === true;
            result = getMaterialVariant(useMorphing, useSkinning, useInstancing);
        } else result = customMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === VSMShadowMap) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new Vector4();
        let currentColorMask = null;
        const currentColorClear = new Vector4(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case NeverDepth:
                            gl.depthFunc(512);
                            break;
                        case AlwaysDepth:
                            gl.depthFunc(519);
                            break;
                        case LessDepth:
                            gl.depthFunc(513);
                            break;
                        case LessEqualDepth:
                            gl.depthFunc(515);
                            break;
                        case EqualDepth:
                            gl.depthFunc(514);
                            break;
                        case GreaterEqualDepth:
                            gl.depthFunc(518);
                            break;
                        case GreaterDepth:
                            gl.depthFunc(516);
                            break;
                        case NotEqualDepth:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let currentProgram = null;
    let currentBlendingEnabled = null;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const currentScissor = new Vector4();
    const currentViewport = new Vector4();
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc(LessEqualDepth);
    setFlipSided(false);
    setCullFace(CullFaceBack);
    enable(2884);
    setBlending(NoBlending);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [AddEquation]: 32774,
        [SubtractEquation]: 32778,
        [ReverseSubtractEquation]: 32779
    };
    if (isWebGL2) {
        equationToGL[MinEquation] = 32775;
        equationToGL[MaxEquation] = 32776;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[MinEquation] = extension.MIN_EXT;
            equationToGL[MaxEquation] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [ZeroFactor]: 0,
        [OneFactor]: 1,
        [SrcColorFactor]: 768,
        [SrcAlphaFactor]: 770,
        [SrcAlphaSaturateFactor]: 776,
        [DstColorFactor]: 774,
        [DstAlphaFactor]: 772,
        [OneMinusSrcColorFactor]: 769,
        [OneMinusSrcAlphaFactor]: 771,
        [OneMinusDstColorFactor]: 775,
        [OneMinusDstAlphaFactor]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === NoBlending) {
            if (currentBlendingEnabled) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (!currentBlendingEnabled) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== CustomBlending) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
                    gl.blendEquation(32774);
                    currentBlendEquation = AddEquation;
                    currentBlendEquationAlpha = AddEquation;
                }
                if (premultipliedAlpha) switch(blending){
                    case NormalBlending:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case AdditiveBlending:
                        gl.blendFunc(1, 1);
                        break;
                    case SubtractiveBlending:
                        gl.blendFuncSeparate(0, 0, 769, 771);
                        break;
                    case MultiplyBlending:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case NormalBlending:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case AdditiveBlending:
                        gl.blendFunc(770, 1);
                        break;
                    case SubtractiveBlending:
                        gl.blendFunc(0, 769);
                        break;
                    case MultiplyBlending:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === DoubleSide ? disable(2884) : enable(2884);
        let flipSided = material.side === BackSide;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== CullFaceNone) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === CullFaceBack) gl.cullFace(1029);
                else if (cullFace === CullFaceFront) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentProgram = null;
        currentBlendingEnabled = null;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? MathUtils.floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo(image) {
        return MathUtils.isPowerOfTwo(image.width) && MathUtils.isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
    }
    function generateMipmap(target, texture, width, height) {
        _gl.generateMipmap(target);
        const textureProperties = properties.get(texture);
        // Note: Math.log( x ) * Math.LOG2E used instead of Math.log2( x ) which is not supported by IE11
        textureProperties.__maxMipLevel = Math.log(Math.max(width, height)) * Math.LOG2E;
    }
    function getInternalFormat(internalFormatName, glFormat, glType) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 6407) {
            if (glType === 5126) internalFormat = 34837;
            if (glType === 5131) internalFormat = 34843;
            if (glType === 5121) internalFormat = 32849;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = 32856;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === NearestFilter || f === NearestMipmapNearestFilter || f === NearestMipmapLinearFilter) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
        info.memory.textures--;
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(renderTarget.texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) _gl.deleteTexture(textureProperties.__webglTexture);
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        properties.remove(renderTarget.texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn('THREE.WebGLRenderer: Texture marked for update but image is undefined');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [RepeatWrapping]: 10497,
        [ClampToEdgeWrapping]: 33071,
        [MirroredRepeatWrapping]: 33648
    };
    const filterToGL = {
        [NearestFilter]: 9728,
        [NearestMipmapNearestFilter]: 9984,
        [NearestMipmapLinearFilter]: 9986,
        [LinearFilter]: 9729,
        [LinearMipmapNearestFilter]: 9985,
        [LinearMipmapLinearFilter]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        const extension = extensions.get('EXT_texture_filter_anisotropic');
        if (extension) {
            if (texture.type === FloatType && extensions.get('OES_texture_float_linear') === null) return;
            if (texture.type === HalfFloatType && (isWebGL2 || extensions.get('OES_texture_half_float_linear')) === null) return;
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo(texture.image) === false;
        const image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        const supportsMips = isPowerOfTwo(image) || isWebGL2, glFormat = utils.convert(texture.format);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === FloatType) glInternalFormat = 36012;
                else if (texture.type === UnsignedIntType) glInternalFormat = 33190;
                else if (texture.type === UnsignedInt248Type) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === FloatType) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
            // validation checks for WebGL 1
            if (texture.format === DepthFormat && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                    texture.type = UnsignedShortType;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== UnsignedInt248Type) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                    texture.type = UnsignedInt248Type;
                    glType = utils.convert(texture.type);
                }
            }
            //
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
                textureProperties.__maxMipLevel = mipmaps.length - 1;
            } else {
                state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                textureProperties.__maxMipLevel = 0;
            }
        } else if (texture.isCompressedTexture) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
                    if (glFormat !== null) state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                } else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else if (texture.isDataTexture2DArray) {
            state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else if (texture.isDataTexture3D) {
            state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
            }
            texture.generateMipmaps = false;
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            textureProperties.__maxMipLevel = 0;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++)if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
        else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        const image = cubeImage[0], supportsMips = isPowerOfTwo(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
                        if (glFormat !== null) state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                    } else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, attachment, textureTarget) {
        const glFormat = utils.convert(renderTarget.texture.format);
        const glType = utils.convert(renderTarget.texture.type);
        const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
        state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        _gl.bindFramebuffer(36160, framebuffer);
        _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(renderTarget.texture).__webglTexture, 0);
        _gl.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === FloatType) glInternalFormat = 36012;
                    else if (depthTexture.type === UnsignedIntType) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const glFormat = utils.convert(renderTarget.texture.format);
            const glType = utils.convert(renderTarget.texture.type);
            const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        _gl.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        if (renderTarget.depthTexture.format === DepthFormat) _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        else if (renderTarget.depthTexture.format === DepthStencilFormat) _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                _gl.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            _gl.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        _gl.bindFramebuffer(36160, null);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(renderTarget.texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        textureProperties.__webglTexture = _gl.createTexture();
        info.memory.textures++;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
        const supportsMips = isPowerOfTwo(renderTarget) || isWebGL2;
        // Handles WebGL2 RGBFormat fallback - #18858
        if (isWebGL2 && renderTarget.texture.format === RGBFormat && (renderTarget.texture.type === FloatType || renderTarget.texture.type === HalfFloatType)) {
            renderTarget.texture.format = RGBAFormat;
            console.warn('THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.');
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultisample) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(renderTarget.texture.format);
                    const glType = utils.convert(renderTarget.texture.type);
                    const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    _gl.bindFramebuffer(36160, null);
                } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, renderTarget.texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(renderTarget.texture, supportsMips)) generateMipmap(34067, renderTarget.texture, renderTarget.width, renderTarget.height);
            state.bindTexture(34067, null);
        } else {
            state.bindTexture(3553, textureProperties.__webglTexture);
            setTextureParameters(3553, renderTarget.texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 36064, 3553);
            if (textureNeedsGenerateMipmaps(renderTarget.texture, supportsMips)) generateMipmap(3553, renderTarget.texture, renderTarget.width, renderTarget.height);
            state.bindTexture(3553, null);
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const texture = renderTarget.texture;
        const supportsMips = isPowerOfTwo(renderTarget) || isWebGL2;
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
            const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
            const webglTexture = properties.get(texture).__webglTexture;
            state.bindTexture(target, webglTexture);
            generateMipmap(target, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(target, null);
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.isWebGLMultisampleRenderTarget) {
            if (isWebGL2) {
                const renderTargetProperties = properties.get(renderTarget);
                _gl.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                if (renderTarget.depthBuffer) mask |= 256;
                if (renderTarget.stencilBuffer) mask |= 1024;
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                _gl.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer); // see #18905
            } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn('THREE.WebGLTextures.safeSetTexture2D: don\'t use render targets as textures. Use their .texture property instead.');
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn('THREE.WebGLTextures.safeSetTextureCube: don\'t use cube render targets as textures. Use their .texture property instead.');
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function WebGLUtils(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p) {
        let extension;
        if (p === UnsignedByteType) return 5121;
        if (p === UnsignedShort4444Type) return 32819;
        if (p === UnsignedShort5551Type) return 32820;
        if (p === UnsignedShort565Type) return 33635;
        if (p === ByteType) return 5120;
        if (p === ShortType) return 5122;
        if (p === UnsignedShortType) return 5123;
        if (p === IntType) return 5124;
        if (p === UnsignedIntType) return 5125;
        if (p === FloatType) return 5126;
        if (p === HalfFloatType) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === AlphaFormat) return 6406;
        if (p === RGBFormat) return 6407;
        if (p === RGBAFormat) return 6408;
        if (p === LuminanceFormat) return 6409;
        if (p === LuminanceAlphaFormat) return 6410;
        if (p === DepthFormat) return 6402;
        if (p === DepthStencilFormat) return 34041;
        if (p === RedFormat) return 6403;
        // WebGL2 formats.
        if (p === RedIntegerFormat) return 36244;
        if (p === RGFormat) return 33319;
        if (p === RGIntegerFormat) return 33320;
        if (p === RGBIntegerFormat) return 36248;
        if (p === RGBAIntegerFormat) return 36249;
        if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {
            extension = extensions.get('WEBGL_compressed_texture_s3tc');
            if (extension !== null) {
                if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (p === RGB_ETC1_Format) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        if (p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === RGB_ETC2_Format) return extension.COMPRESSED_RGB8_ETC2;
                if (p === RGBA_ETC2_EAC_Format) return extension.COMPRESSED_RGBA8_ETC2_EAC;
            }
        }
        if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format || p === SRGB8_ALPHA8_ASTC_4x4_Format || p === SRGB8_ALPHA8_ASTC_5x4_Format || p === SRGB8_ALPHA8_ASTC_5x5_Format || p === SRGB8_ALPHA8_ASTC_6x5_Format || p === SRGB8_ALPHA8_ASTC_6x6_Format || p === SRGB8_ALPHA8_ASTC_8x5_Format || p === SRGB8_ALPHA8_ASTC_8x6_Format || p === SRGB8_ALPHA8_ASTC_8x8_Format || p === SRGB8_ALPHA8_ASTC_10x5_Format || p === SRGB8_ALPHA8_ASTC_10x6_Format || p === SRGB8_ALPHA8_ASTC_10x8_Format || p === SRGB8_ALPHA8_ASTC_10x10_Format || p === SRGB8_ALPHA8_ASTC_12x10_Format || p === SRGB8_ALPHA8_ASTC_12x12_Format) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === RGBA_BPTC_Format) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === UnsignedInt248Type) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
function ArrayCamera(array = []) {
    PerspectiveCamera.call(this);
    this.cameras = array;
}
ArrayCamera.prototype = Object.assign(Object.create(PerspectiveCamera.prototype), {
    constructor: ArrayCamera,
    isArrayCamera: true
});
function Group() {
    Object3D.call(this);
    this.type = 'Group';
}
Group.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Group,
    isGroup: true
});
function WebXRController() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
}
Object.assign(WebXRController.prototype, {
    constructor: WebXRController,
    getHandSpace: function() {
        if (this._hand === null) {
            this._hand = new Group();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = [];
            this._hand.inputState = {
                pinching: false
            };
            if (window.XRHand) for(let i = 0; i <= window.XRHand.LITTLE_PHALANX_TIP; i++){
                // The transform of this joint will be updated with the joint pose on each frame
                const joint = new Group();
                joint.matrixAutoUpdate = false;
                joint.visible = false;
                this._hand.joints.push(joint);
                // ??
                this._hand.add(joint);
            }
        }
        return this._hand;
    },
    getTargetRaySpace: function() {
        if (this._targetRay === null) {
            this._targetRay = new Group();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
        }
        return this._targetRay;
    },
    getGripSpace: function() {
        if (this._grip === null) {
            this._grip = new Group();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
        }
        return this._grip;
    },
    dispatchEvent: function(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    },
    disconnect: function(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    },
    update: function(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for(let i = 0; i <= window.XRHand.LITTLE_PHALANX_TIP; i++)if (inputSource.hand[i]) {
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputSource.hand[i], referenceSpace);
                    const joint = hand.joints[i];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                    // Custom events
                    // Check pinch
                    const indexTip = hand.joints[window.XRHand.INDEX_PHALANX_TIP];
                    const thumbTip = hand.joints[window.XRHand.THUMB_PHALANX_TIP];
                    const distance = indexTip.position.distanceTo(thumbTip.position);
                    const distanceToPinch = 0.02;
                    const threshold = 0.005;
                    if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                        hand.inputState.pinching = false;
                        this.dispatchEvent({
                            type: 'pinchend',
                            handedness: inputSource.handedness,
                            target: this
                        });
                    } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                        hand.inputState.pinching = true;
                        this.dispatchEvent({
                            type: 'pinchstart',
                            handedness: inputSource.handedness,
                            target: this
                        });
                    }
                }
            } else {
                if (targetRay !== null) {
                    inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                    if (inputPose !== null) {
                        targetRay.matrix.fromArray(inputPose.transform.matrix);
                        targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    }
                }
                if (grip !== null && inputSource.gripSpace) {
                    gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                    if (gripPose !== null) {
                        grip.matrix.fromArray(gripPose.transform.matrix);
                        grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    }
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
});
function WebXRManager(renderer, gl) {
    const scope = this;
    let session = null;
    let framebufferScaleFactor = 1.0;
    let referenceSpace = null;
    let referenceSpaceType = 'local-floor';
    let pose = null;
    const controllers = [];
    const inputSourcesMap = new Map();
    //
    const cameraL = new PerspectiveCamera();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector4();
    const cameraR = new PerspectiveCamera();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector4();
    const cameras = [
        cameraL,
        cameraR
    ];
    const cameraVR = new ArrayCamera();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    //
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getGripSpace();
    };
    this.getHand = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getHandSpace();
    };
    //
    function onSessionEvent(event) {
        const controller = inputSourcesMap.get(event.inputSource);
        if (controller) controller.dispatchEvent({
            type: event.type,
            data: event.inputSource
        });
    }
    function onSessionEnd() {
        inputSourcesMap.forEach(function(controller, inputSource) {
            controller.disconnect(inputSource);
        });
        inputSourcesMap.clear();
        //
        renderer.setFramebuffer(null);
        renderer.setRenderTarget(renderer.getRenderTarget()); // Hack #15830
        animation.stop();
        scope.isPresenting = false;
        scope.dispatchEvent({
            type: 'sessionend'
        });
    }
    function onRequestReferenceSpace(value) {
        referenceSpace = value;
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({
            type: 'sessionstart'
        });
    }
    this.setFramebufferScaleFactor = function(value) {
        framebufferScaleFactor = value;
        if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
    };
    this.setReferenceSpaceType = function(value) {
        referenceSpaceType = value;
        if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
    };
    this.getReferenceSpace = function() {
        return referenceSpace;
    };
    this.getSession = function() {
        return session;
    };
    this.setSession = function(value) {
        session = value;
        if (session !== null) {
            session.addEventListener('select', onSessionEvent);
            session.addEventListener('selectstart', onSessionEvent);
            session.addEventListener('selectend', onSessionEvent);
            session.addEventListener('squeeze', onSessionEvent);
            session.addEventListener('squeezestart', onSessionEvent);
            session.addEventListener('squeezeend', onSessionEvent);
            session.addEventListener('end', onSessionEnd);
            const attributes = gl.getContextAttributes();
            if (attributes.xrCompatible !== true) gl.makeXRCompatible();
            const layerInit = {
                antialias: attributes.antialias,
                alpha: attributes.alpha,
                depth: attributes.depth,
                stencil: attributes.stencil,
                framebufferScaleFactor: framebufferScaleFactor
            };
            // eslint-disable-next-line no-undef
            const baseLayer = new XRWebGLLayer(session, gl, layerInit);
            session.updateRenderState({
                baseLayer: baseLayer
            });
            session.requestReferenceSpace(referenceSpaceType).then(onRequestReferenceSpace);
            //
            session.addEventListener('inputsourceschange', updateInputSources);
        }
    };
    function updateInputSources(event) {
        const inputSources = session.inputSources;
        // Assign inputSources to available controllers
        for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
        // Notify disconnected
        for(let i = 0; i < event.removed.length; i++){
            const inputSource = event.removed[i];
            const controller = inputSourcesMap.get(inputSource);
            if (controller) {
                controller.dispatchEvent({
                    type: 'disconnected',
                    data: inputSource
                });
                inputSourcesMap.delete(inputSource);
            }
        }
        // Notify connected
        for(let i = 0; i < event.added.length; i++){
            const inputSource = event.added[i];
            const controller = inputSourcesMap.get(inputSource);
            if (controller) controller.dispatchEvent({
                type: 'connected',
                data: inputSource
            });
        }
    }
    //
    const cameraLPos = new Vector3();
    const cameraRPos = new Vector3();
    /**
	 * Assumes 2 cameras that are parallel and share an X-axis, and that
	 * the cameras' projection and world matrices have already been set.
	 * And that near and far planes are identical for both cameras.
	 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
	 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
        cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
        cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
        const ipd = cameraLPos.distanceTo(cameraRPos);
        const projL = cameraL.projectionMatrix.elements;
        const projR = cameraR.projectionMatrix.elements;
        // VR systems will have identical far and near planes, and
        // most likely identical top and bottom frustum extents.
        // Use the left camera for these values.
        const near = projL[14] / (projL[10] - 1);
        const far = projL[14] / (projL[10] + 1);
        const topFov = (projL[9] + 1) / projL[5];
        const bottomFov = (projL[9] - 1) / projL[5];
        const leftFov = (projL[8] - 1) / projL[0];
        const rightFov = (projR[8] + 1) / projR[0];
        const left = near * leftFov;
        const right = near * rightFov;
        // Calculate the new camera's position offset from the
        // left camera. xOffset should be roughly half `ipd`.
        const zOffset = ipd / (-leftFov + rightFov);
        const xOffset = zOffset * -leftFov;
        // TODO: Better way to apply this offset?
        cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
        camera.translateX(xOffset);
        camera.translateZ(zOffset);
        camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        // Find the union of the frustum values of the cameras and scale
        // the values so that the near plane's position does not change in world space,
        // although must now be relative to the new union camera.
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }
    function updateCamera(camera, parent) {
        if (parent === null) camera.matrixWorld.copy(camera.matrix);
        else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.getCamera = function(camera) {
        cameraVR.near = cameraR.near = cameraL.near = camera.near;
        cameraVR.far = cameraR.far = cameraL.far = camera.far;
        if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
            // Note that the new renderState won't apply until the next frame. See #18320
            session.updateRenderState({
                depthNear: cameraVR.near,
                depthFar: cameraVR.far
            });
            _currentDepthNear = cameraVR.near;
            _currentDepthFar = cameraVR.far;
        }
        const parent = camera.parent;
        const cameras = cameraVR.cameras;
        updateCamera(cameraVR, parent);
        for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
        // update camera and its children
        camera.matrixWorld.copy(cameraVR.matrixWorld);
        const children = camera.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
        // update projection matrix for proper view frustum culling
        if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
        else // assume single camera setup (AR)
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        return cameraVR;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time, frame) {
        pose = frame.getViewerPose(referenceSpace);
        if (pose !== null) {
            const views = pose.views;
            const baseLayer = session.renderState.baseLayer;
            renderer.setFramebuffer(baseLayer.framebuffer);
            let cameraVRNeedsUpdate = false;
            // check if it's necessary to rebuild cameraVR's camera list
            if (views.length !== cameraVR.cameras.length) {
                cameraVR.cameras.length = 0;
                cameraVRNeedsUpdate = true;
            }
            for(let i = 0; i < views.length; i++){
                const view = views[i];
                const viewport = baseLayer.getViewport(view);
                const camera = cameras[i];
                camera.matrix.fromArray(view.transform.matrix);
                camera.projectionMatrix.fromArray(view.projectionMatrix);
                camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                if (i === 0) cameraVR.matrix.copy(camera.matrix);
                if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
            }
        }
        //
        const inputSources = session.inputSources;
        for(let i = 0; i < controllers.length; i++){
            const controller = controllers[i];
            const inputSource = inputSources[i];
            controller.update(inputSource, frame, referenceSpace);
        }
        if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
    };
    this.dispose = function() {};
}
Object.assign(WebXRManager.prototype, EventDispatcher.prototype);
function WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.refractionRatio.value = material.refractionRatio;
            const maxMipLevel = properties.get(envMap).__maxMipLevel;
            if (maxMipLevel !== undefined) uniforms.maxMipLevel.value = maxMipLevel;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material) {
        refreshUniformsStandard(uniforms, material);
        uniforms.reflectivity.value = material.reflectivity; // also part of uniforms common
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.sheen) uniforms.sheen.value.copy(material.sheen);
        if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
        if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        if (material.clearcoatNormalMap) {
            uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
            uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
            if (material.side === BackSide) uniforms.clearcoatNormalScale.value.negate();
        }
        uniforms.transmission.value = material.transmission;
        if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function createCanvasElement() {
    const canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    canvas.style.display = 'block';
    return canvas;
}
function WebGLRenderer(parameters) {
    parameters = parameters || {};
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its state isolated from the parent render call.
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.gammaFactor = 2.0; // for backwards compatibility
    this.outputEncoding = LinearEncoding;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = NoToneMapping;
    this.toneMappingExposure = 1.0;
    // morphs
    this.maxMorphTargets = 8;
    this.maxMorphNormals = 4;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _framebuffer = null;
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentFramebuffer = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new Vector4();
    const _currentScissor = new Vector4();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new Vector4(0, 0, _width, _height);
    const _scissor = new Vector4(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new Frustum();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // camera matrices cache
    const _projScreenMatrix = new Matrix4();
    const _vector3 = new Vector3();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: _alpha,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                'rangeMin': 1,
                'rangeMax': 1,
                'precision': 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new WebGLExtensions(_gl);
        capabilities = new WebGLCapabilities(_gl, extensions, parameters);
        if (capabilities.isWebGL2 === false) {
            extensions.get('WEBGL_depth_texture');
            extensions.get('OES_texture_float');
            extensions.get('OES_texture_half_float');
            extensions.get('OES_texture_half_float_linear');
            extensions.get('OES_standard_derivatives');
            extensions.get('OES_element_index_uint');
            extensions.get('OES_vertex_array_object');
            extensions.get('ANGLE_instanced_arrays');
        }
        extensions.get('OES_texture_float_linear');
        utils = new WebGLUtils(_gl, extensions, capabilities);
        state = new WebGLState(_gl, extensions, capabilities);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        info = new WebGLInfo(_gl);
        properties = new WebGLProperties();
        textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new WebGLCubeMaps(_this);
        attributes = new WebGLAttributes(_gl, capabilities);
        bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new WebGLMorphtargets(_gl);
        clipping = new WebGLClipping(properties);
        programCache = new WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
        materials = new WebGLMaterials(properties);
        renderLists = new WebGLRenderLists(properties);
        renderStates = new WebGLRenderStates(extensions, capabilities);
        background = new WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
        bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new WebXRManager(_this, _gl);
    this.xr = xr;
    // shadow map
    const shadowMap = new WebGLShadowMap(_this, objects, capabilities.maxTextureSize);
    this.shadowMap = shadowMap;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getsize() now requires a Vector2 as an argument');
            target = new Vector2();
        }
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getdrawingBufferSize() now requires a Vector2 as an argument');
            target = new Vector2();
        }
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getCurrentViewport() now requires a Vector4 as an argument');
            target = new Vector4();
        }
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getClearColor() now requires a Color as an argument');
            target = new Color();
        }
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        xr.dispose();
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        initGLContext();
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReference(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReference(material) {
        const programInfo = properties.get(material).program;
        if (programInfo !== undefined) programCache.releaseProgram(programInfo);
    }
    // Buffer rendering
    function renderObjectImmediate(object, program) {
        object.render(function(object) {
            _this.renderBufferImmediate(object, program);
        });
    }
    this.renderBufferImmediate = function(object, program) {
        bindingStates.initAttributes();
        const buffers = properties.get(object);
        if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
        if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
        if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
        if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
        const programAttributes = program.getAttributes();
        if (object.hasPositions) {
            _gl.bindBuffer(34962, buffers.position);
            _gl.bufferData(34962, object.positionArray, 35048);
            bindingStates.enableAttribute(programAttributes.position);
            _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
        }
        if (object.hasNormals) {
            _gl.bindBuffer(34962, buffers.normal);
            _gl.bufferData(34962, object.normalArray, 35048);
            bindingStates.enableAttribute(programAttributes.normal);
            _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
        }
        if (object.hasUvs) {
            _gl.bindBuffer(34962, buffers.uv);
            _gl.bufferData(34962, object.uvArray, 35048);
            bindingStates.enableAttribute(programAttributes.uv);
            _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
        }
        if (object.hasColors) {
            _gl.bindBuffer(34962, buffers.color);
            _gl.bufferData(34962, object.colorArray, 35048);
            bindingStates.enableAttribute(programAttributes.color);
            _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
        }
        bindingStates.disableUnusedAttributes();
        _gl.drawArrays(4, 0, object.count);
        object.count = 0;
    };
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        if (material.morphTargets || material.morphNormals) morphtargets.update(object, geometry, material, program);
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights();
        const compiled = new WeakMap();
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    if (compiled.has(material2) === false) {
                        initMaterial(material2, scene, object);
                        compiled.set(material2);
                    }
                }
                else if (compiled.has(material) === false) {
                    initMaterial(material, scene, object);
                    compiled.set(material);
                }
            }
        });
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (xr.isPresenting) return;
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== 'undefined') animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    // Rendering
    this.render = function(scene, camera) {
        let renderTarget, forceClear;
        if (arguments[2] !== undefined) {
            console.warn('THREE.WebGLRenderer.render(): the renderTarget argument has been removed. Use .setRenderTarget() instead.');
            renderTarget = arguments[2];
        }
        if (arguments[3] !== undefined) {
            console.warn('THREE.WebGLRenderer.render(): the forceClear argument has been removed. Use .clear() instead.');
            forceClear = arguments[3];
        }
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // reset caching for this frame
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) camera = xr.getCamera(camera);
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, renderTarget || _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, camera);
        currentRenderList.init();
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        currentRenderState.setupLights();
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        if (renderTarget !== undefined) this.setRenderTarget(renderTarget);
        //
        background.render(currentRenderList, scene, camera, forceClear);
        // render scene
        const opaqueObjects = currentRenderList.opaque;
        const transparentObjects = currentRenderList.transparent;
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
        }
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isImmediateRenderObject) {
                if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let j = 0, jl = cameras.length; j < jl; j++){
                    const camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        state.viewport(_currentViewport.copy(camera2.viewport));
                        currentRenderState.setupLightsView(camera2);
                        renderObject(object, scene, camera2, geometry, material, group);
                    }
                }
            } else renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        if (object.isImmediateRenderObject) {
            const program = setProgram(camera, scene, material, object);
            state.setMaterial(material);
            bindingStates.reset();
            renderObjectImmediate(object, program);
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function initMaterial(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let program = materialProperties.program;
        let programChange = true;
        if (program === undefined) // new material
        material.addEventListener('dispose', onMaterialDispose);
        else if (program.cacheKey !== programCacheKey) // changed glsl or parameters
        releaseMaterialProgramReference(material);
        else if (materialProperties.lightsStateVersion !== lightsStateVersion) programChange = false;
        else if (parameters.shaderID !== undefined) {
            // same glsl and uniform list, envMap still needs the update here to avoid a frame-late effect
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.envMap = cubemaps.get(material.envMap || environment);
            return;
        } else // only rebuild uniform list
        programChange = false;
        if (programChange) {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            materialProperties.program = program;
            materialProperties.uniforms = parameters.uniforms;
            materialProperties.outputEncoding = parameters.outputEncoding;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
            materialProperties.numClippingPlanes = clipping.numPlanes;
            materialProperties.numIntersection = clipping.numIntersection;
            uniforms.clippingPlanes = clipping.uniform;
        }
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = materialProperties.program.getUniforms();
        const uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.uniformsList = uniformsList;
    }
    function setProgram(camera, scene, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
        const envMap = cubemaps.get(material.envMap || environment);
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        if (material.version === materialProperties.__version) {
            if (material.fog && materialProperties.fog !== fog) initMaterial(material, scene, object);
            else if (materialProperties.environment !== environment) initMaterial(material, scene, object);
            else if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) initMaterial(material, scene, object);
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) initMaterial(material, scene, object);
            else if (materialProperties.outputEncoding !== encoding) initMaterial(material, scene, object);
            else if (materialProperties.envMap !== envMap) initMaterial(material, scene, object);
        } else {
            initMaterial(material, scene, object);
            materialProperties.__version = material.version;
        }
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const program = materialProperties.program, p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || material.skinning) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone texture must go before other textures
        // otherwise textures used for skinning can take over texture units reserved for other material textures
        if (material.skinning) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            const skeleton = object.skeleton;
            if (skeleton) {
                const bones = skeleton.bones;
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) {
                        // layout (1 matrix = 4 pixels)
                        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                        let size = Math.sqrt(bones.length * 4); // 4 pixels needed for 1 matrix
                        size = MathUtils.ceilPowerOfTwo(size);
                        size = Math.max(size, 4);
                        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                        boneMatrices.set(skeleton.boneMatrices); // copy current values
                        const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
                        skeleton.boneMatrices = boneMatrices;
                        skeleton.boneTexture = boneTexture;
                        skeleton.boneTextureSize = size;
                    }
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, 'boneMatrices');
            }
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height);
            WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    //
    this.setFramebuffer = function(value) {
        if (_framebuffer !== value && _currentRenderTarget === null) _gl.bindFramebuffer(36160, value);
        _framebuffer = value;
    };
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderList = function() {
        return currentRenderList;
    };
    this.setRenderList = function(renderList) {
        currentRenderList = renderList;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        if (renderTarget && properties.get(renderTarget).__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
        let framebuffer = _framebuffer;
        let isCube = false;
        if (renderTarget) {
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.isWebGLMultisampleRenderTarget) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        if (_currentFramebuffer !== framebuffer) {
            _gl.bindFramebuffer(36160, framebuffer);
            _currentFramebuffer = framebuffer;
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        }
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            let restore = false;
            if (framebuffer !== _currentFramebuffer) {
                _gl.bindFramebuffer(36160, framebuffer);
                restore = true;
            }
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                if (textureType !== UnsignedByteType && utils.convert(textureType) !== _gl.getParameter(35738) && // IE11, Edge and Chrome Mac < 52 (#9513)
                !(textureType === FloatType && (capabilities.isWebGL2 || extensions.get('OES_texture_float') || extensions.get('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !(textureType === HalfFloatType && (capabilities.isWebGL2 ? extensions.get('EXT_color_buffer_float') : extensions.get('EXT_color_buffer_half_float')))) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error('THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.');
            } finally{
                if (restore) _gl.bindFramebuffer(36160, _currentFramebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        const glFormat = utils.convert(texture.format);
        textures.setTexture2D(texture, 0);
        _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    })); // eslint-disable-line no-undef
}
function WebGL1Renderer(parameters) {
    WebGLRenderer.call(this, parameters);
}
WebGL1Renderer.prototype = Object.assign(Object.create(WebGLRenderer.prototype), {
    constructor: WebGL1Renderer,
    isWebGL1Renderer: true
});
class FogExp2 {
    constructor(color, density){
        Object.defineProperty(this, 'isFogExp2', {
            value: true
        });
        this.name = '';
        this.color = new Color(color);
        this.density = density !== undefined ? density : 0.00025;
    }
    clone() {
        return new FogExp2(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class Fog {
    constructor(color, near, far){
        Object.defineProperty(this, 'isFog', {
            value: true
        });
        this.name = '';
        this.color = new Color(color);
        this.near = near !== undefined ? near : 1;
        this.far = far !== undefined ? far : 1000;
    }
    clone() {
        return new Fog(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class Scene extends Object3D {
    constructor(){
        super();
        Object.defineProperty(this, 'isScene', {
            value: true
        });
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        })); // eslint-disable-line no-undef
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.background !== null) data.object.background = this.background.toJSON(meta);
        if (this.environment !== null) data.object.environment = this.environment.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
function InterleavedBuffer(array, stride) {
    this.array = array;
    this.stride = stride;
    this.count = array !== undefined ? array.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRange = {
        offset: 0,
        count: -1
    };
    this.version = 0;
    this.uuid = MathUtils.generateUUID();
}
Object.defineProperty(InterleavedBuffer.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(InterleavedBuffer.prototype, {
    isInterleavedBuffer: true,
    onUploadCallback: function() {},
    setUsage: function(value) {
        this.usage = value;
        return this;
    },
    copy: function(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    },
    copyAt: function(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    },
    set: function(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    },
    clone: function(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = MathUtils.generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new InterleavedBuffer(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    },
    onUpload: function(callback) {
        this.onUploadCallback = callback;
        return this;
    },
    toJSON: function(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = MathUtils.generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
});
const _vector$6 = new Vector3();
function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset, normalized) {
    this.name = '';
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized === true;
}
Object.defineProperties(InterleavedBufferAttribute.prototype, {
    count: {
        get: function() {
            return this.data.count;
        }
    },
    array: {
        get: function() {
            return this.data.array;
        }
    },
    needsUpdate: {
        set: function(value) {
            this.data.needsUpdate = value;
        }
    }
});
Object.assign(InterleavedBufferAttribute.prototype, {
    isInterleavedBufferAttribute: true,
    applyMatrix4: function(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            _vector$6.x = this.getX(i);
            _vector$6.y = this.getY(i);
            _vector$6.z = this.getZ(i);
            _vector$6.applyMatrix4(m);
            this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
        }
        return this;
    },
    setX: function(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    },
    setY: function(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    },
    setZ: function(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    },
    setW: function(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    },
    getX: function(index) {
        return this.data.array[index * this.data.stride + this.offset];
    },
    getY: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    },
    getZ: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    },
    getW: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    },
    setXY: function(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    },
    setXYZ: function(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    },
    setXYZW: function(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    },
    clone: function(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    },
    toJSON: function(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ function SpriteMaterial(parameters) {
    Material.call(this);
    this.type = 'SpriteMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.setValues(parameters);
}
SpriteMaterial.prototype = Object.create(Material.prototype);
SpriteMaterial.prototype.constructor = SpriteMaterial;
SpriteMaterial.prototype.isSpriteMaterial = true;
SpriteMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
};
let _geometry;
const _intersectPoint = new Vector3();
const _worldScale = new Vector3();
const _mvPosition = new Vector3();
const _alignedPosition = new Vector2();
const _rotatedPosition = new Vector2();
const _viewWorldMatrix = new Matrix4();
const _vA$1 = new Vector3();
const _vB$1 = new Vector3();
const _vC$1 = new Vector3();
const _uvA$1 = new Vector2();
const _uvB$1 = new Vector2();
const _uvC$1 = new Vector2();
function Sprite(material) {
    Object3D.call(this);
    this.type = 'Sprite';
    if (_geometry === undefined) {
        _geometry = new BufferGeometry();
        const float32Array = new Float32Array([
            -0.5,
            -0.5,
            0,
            0,
            0,
            0.5,
            -0.5,
            0,
            1,
            0,
            0.5,
            0.5,
            0,
            1,
            1,
            -0.5,
            0.5,
            0,
            0,
            1
        ]);
        const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
        _geometry.setIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        _geometry.setAttribute('position', new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
        _geometry.setAttribute('uv', new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material !== undefined ? material : new SpriteMaterial();
    this.center = new Vector2(0.5, 0.5);
}
Sprite.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Sprite,
    isSprite: true,
    raycast: function(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        _worldScale.setFromMatrixScale(this.matrixWorld);
        _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) _worldScale.multiplyScalar(-_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        transformVertex(_vA$1.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vB$1.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vC$1.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        _uvA$1.set(0, 0);
        _uvB$1.set(1, 0);
        _uvC$1.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle(_vA$1, _vB$1, _vC$1, false, _intersectPoint);
        if (intersect === null) {
            // check second triangle
            transformVertex(_vB$1.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
            _uvB$1.set(0, 1);
            intersect = raycaster.ray.intersectTriangle(_vA$1, _vC$1, _vB$1, false, _intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: _intersectPoint.clone(),
            uv: Triangle.getUV(_intersectPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2()),
            face: null,
            object: this
        });
    },
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
});
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
        _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
    } else _rotatedPosition.copy(_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += _rotatedPosition.x;
    vertexPosition.y += _rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _v1$4 = new Vector3();
const _v2$2 = new Vector3();
function LOD() {
    Object3D.call(this);
    this._currentLevel = 0;
    this.type = 'LOD';
    Object.defineProperties(this, {
        levels: {
            enumerable: true,
            value: []
        }
    });
    this.autoUpdate = true;
}
LOD.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: LOD,
    isLOD: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    },
    addLevel: function(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    },
    getCurrentLevel: function() {
        return this._currentLevel;
    },
    getObjectForDistance: function(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    },
    raycast: function(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            _v1$4.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo(_v1$4);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    },
    update: function(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            _v1$4.setFromMatrixPosition(camera.matrixWorld);
            _v2$2.setFromMatrixPosition(this.matrixWorld);
            const distance = _v1$4.distanceTo(_v2$2) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
});
const _basePosition = new Vector3();
const _skinIndex = new Vector4();
const _skinWeight = new Vector4();
const _vector$7 = new Vector3();
const _matrix$1 = new Matrix4();
function SkinnedMesh(geometry, material) {
    if (geometry && geometry.isGeometry) console.error('THREE.SkinnedMesh no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    Mesh.call(this, geometry, material);
    this.type = 'SkinnedMesh';
    this.bindMode = 'attached';
    this.bindMatrix = new Matrix4();
    this.bindMatrixInverse = new Matrix4();
}
SkinnedMesh.prototype = Object.assign(Object.create(Mesh.prototype), {
    constructor: SkinnedMesh,
    isSkinnedMesh: true,
    copy: function(source) {
        Mesh.prototype.copy.call(this, source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    },
    bind: function(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    },
    pose: function() {
        this.skeleton.pose();
    },
    normalizeSkinWeights: function() {
        const vector = new Vector4();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    },
    updateMatrixWorld: function(force) {
        Mesh.prototype.updateMatrixWorld.call(this, force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    },
    boneTransform: function(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        _basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = _skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = _skinIndex.getComponent(i);
                _matrix$1.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector(_vector$7.copy(_basePosition).applyMatrix4(_matrix$1), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
});
function Bone() {
    Object3D.call(this);
    this.type = 'Bone';
}
Bone.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Bone,
    isBone: true
});
const _offsetMatrix = new Matrix4();
const _identityMatrix = new Matrix4();
function Skeleton(bones = [], boneInverses = []) {
    this.uuid = MathUtils.generateUUID();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.boneTextureSize = 0;
    this.frame = -1;
    this.init();
}
Object.assign(Skeleton.prototype, {
    init: function() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new Matrix4());
        }
    },
    calculateInverses: function() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new Matrix4();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    },
    pose: function() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    },
    update: function() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;
            _offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            _offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    },
    clone: function() {
        return new Skeleton(this.bones, this.boneInverses);
    },
    getBoneByName: function(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    },
    dispose: function() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    },
    fromJSON: function(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new Bone();
            }
            this.bones.push(bone);
            this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
});
const _instanceLocalMatrix = new Matrix4();
const _instanceWorldMatrix = new Matrix4();
const _instanceIntersects = [];
const _mesh = new Mesh();
function InstancedMesh(geometry, material, count) {
    Mesh.call(this, geometry, material);
    this.instanceMatrix = new BufferAttribute(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.count = count;
    this.frustumCulled = false;
}
InstancedMesh.prototype = Object.assign(Object.create(Mesh.prototype), {
    constructor: InstancedMesh,
    isInstancedMesh: true,
    copy: function(source) {
        Mesh.prototype.copy.call(this, source);
        this.instanceMatrix.copy(source.instanceMatrix);
        this.count = source.count;
        return this;
    },
    getColorAt: function(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    },
    getMatrixAt: function(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    },
    raycast: function(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        _mesh.geometry = this.geometry;
        _mesh.material = this.material;
        if (_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, _instanceLocalMatrix);
            _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
            // the mesh represents this single instance
            _mesh.matrixWorld = _instanceWorldMatrix;
            _mesh.raycast(raycaster, _instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = _instanceIntersects.length; i < l; i++){
                const intersect = _instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            _instanceIntersects.length = 0;
        }
    },
    setColorAt: function(index, color) {
        if (this.instanceColor === null) this.instanceColor = new BufferAttribute(new Float32Array(this.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    },
    setMatrixAt: function(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    },
    updateMorphTargets: function() {},
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ function LineBasicMaterial(parameters) {
    Material.call(this);
    this.type = 'LineBasicMaterial';
    this.color = new Color(0xffffff);
    this.linewidth = 1;
    this.linecap = 'round';
    this.linejoin = 'round';
    this.morphTargets = false;
    this.setValues(parameters);
}
LineBasicMaterial.prototype = Object.create(Material.prototype);
LineBasicMaterial.prototype.constructor = LineBasicMaterial;
LineBasicMaterial.prototype.isLineBasicMaterial = true;
LineBasicMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    this.morphTargets = source.morphTargets;
    return this;
};
const _start = new Vector3();
const _end = new Vector3();
const _inverseMatrix$1 = new Matrix4();
const _ray$1 = new Ray();
const _sphere$2 = new Sphere();
function Line(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
    Object3D.call(this);
    this.type = 'Line';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Line.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Line,
    isLine: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    computeLineDistances: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    _start.fromBufferAttribute(positionAttribute, i - 1);
                    _end.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += _start.distanceTo(_end);
                }
                geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
            } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) {
            const vertices = geometry.vertices;
            const lineDistances = geometry.lineDistances;
            lineDistances[0] = 0;
            for(let i = 1, l = vertices.length; i < l; i++){
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += vertices[i - 1].distanceTo(vertices[i]);
            }
        }
        return this;
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$2.copy(geometry.boundingSphere);
        _sphere$2.applyMatrix4(matrixWorld);
        _sphere$2.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$2) === false) return;
        //
        _inverseMatrix$1.copy(matrixWorld).invert();
        _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new Vector3();
        const vEnd = new Vector3();
        const interSegment = new Vector3();
        const interRay = new Vector3();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const indices = index.array;
                for(let i = 0, l = indices.length - 1; i < l; i += step){
                    const a = indices[i];
                    const b = indices[i + 1];
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else for(let i = 0, l = positionAttribute.count - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else if (geometry.isGeometry) {
            const vertices = geometry.vertices;
            const nbVertices = vertices.length;
            for(let i = 0; i < nbVertices - 1; i += step){
                const distSq = _ray$1.distanceSqToSegment(vertices[i], vertices[i + 1], interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
});
const _start$1 = new Vector3();
const _end$1 = new Vector3();
function LineSegments(geometry, material) {
    Line.call(this, geometry, material);
    this.type = 'LineSegments';
}
LineSegments.prototype = Object.assign(Object.create(Line.prototype), {
    constructor: LineSegments,
    isLineSegments: true,
    computeLineDistances: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    _start$1.fromBufferAttribute(positionAttribute, i);
                    _end$1.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + _start$1.distanceTo(_end$1);
                }
                geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
            } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) {
            const vertices = geometry.vertices;
            const lineDistances = geometry.lineDistances;
            for(let i = 0, l = vertices.length; i < l; i += 2){
                _start$1.copy(vertices[i]);
                _end$1.copy(vertices[i + 1]);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + _start$1.distanceTo(_end$1);
            }
        }
        return this;
    }
});
function LineLoop(geometry, material) {
    Line.call(this, geometry, material);
    this.type = 'LineLoop';
}
LineLoop.prototype = Object.assign(Object.create(Line.prototype), {
    constructor: LineLoop,
    isLineLoop: true
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 *  morphTargets: <bool>
 * }
 */ function PointsMaterial(parameters) {
    Material.call(this);
    this.type = 'PointsMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.morphTargets = false;
    this.setValues(parameters);
}
PointsMaterial.prototype = Object.create(Material.prototype);
PointsMaterial.prototype.constructor = PointsMaterial;
PointsMaterial.prototype.isPointsMaterial = true;
PointsMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    this.morphTargets = source.morphTargets;
    return this;
};
const _inverseMatrix$2 = new Matrix4();
const _ray$2 = new Ray();
const _sphere$3 = new Sphere();
const _position$1 = new Vector3();
function Points(geometry = new BufferGeometry(), material = new PointsMaterial()) {
    Object3D.call(this);
    this.type = 'Points';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Points.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Points,
    isPoints: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$3.copy(geometry.boundingSphere);
        _sphere$3.applyMatrix4(matrixWorld);
        _sphere$3.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$3) === false) return;
        //
        _inverseMatrix$2.copy(matrixWorld).invert();
        _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const indices = index.array;
                for(let i = 0, il = indices.length; i < il; i++){
                    const a = indices[i];
                    _position$1.fromBufferAttribute(positionAttribute, a);
                    testPoint(_position$1, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else for(let i = 0, l = positionAttribute.count; i < l; i++){
                _position$1.fromBufferAttribute(positionAttribute, i);
                testPoint(_position$1, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const vertices = geometry.vertices;
            for(let i = 0, l = vertices.length; i < l; i++)testPoint(vertices[i], i, localThresholdSq, matrixWorld, raycaster, intersects, this);
        }
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
});
function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = _ray$2.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new Vector3();
        _ray$2.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
function VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    Texture.call(this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.format = format !== undefined ? format : RGBFormat;
    this.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
    this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
        scope.needsUpdate = true;
        video.requestVideoFrameCallback(updateVideo);
    }
    if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
}
VideoTexture.prototype = Object.assign(Object.create(Texture.prototype), {
    constructor: VideoTexture,
    clone: function() {
        return new this.constructor(this.image).copy(this);
    },
    isVideoTexture: true,
    update: function() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
});
function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = {
        width: width,
        height: height
    };
    this.mipmaps = mipmaps;
    // no flipping for cube textures
    // (also flipping doesn't work for compressed textures )
    this.flipY = false;
    // can't generate mipmaps for compressed textures
    // mips must be embedded in DDS files
    this.generateMipmaps = false;
}
CompressedTexture.prototype = Object.create(Texture.prototype);
CompressedTexture.prototype.constructor = CompressedTexture;
CompressedTexture.prototype.isCompressedTexture = true;
function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    Texture.call(this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.needsUpdate = true;
}
CanvasTexture.prototype = Object.create(Texture.prototype);
CanvasTexture.prototype.constructor = CanvasTexture;
CanvasTexture.prototype.isCanvasTexture = true;
function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    format = format !== undefined ? format : DepthFormat;
    if (format !== DepthFormat && format !== DepthStencilFormat) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
    if (type === undefined && format === DepthFormat) type = UnsignedShortType;
    if (type === undefined && format === DepthStencilFormat) type = UnsignedInt248Type;
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.image = {
        width: width,
        height: height
    };
    this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
    this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
}
DepthTexture.prototype = Object.create(Texture.prototype);
DepthTexture.prototype.constructor = DepthTexture;
DepthTexture.prototype.isDepthTexture = true;
let _geometryId = 0; // Geometry uses even numbers as Id
const _m1$3 = new Matrix4();
const _obj$1 = new Object3D();
const _offset$1 = new Vector3();
function Geometry() {
    Object.defineProperty(this, 'id', {
        value: _geometryId += 2
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'Geometry';
    this.vertices = [];
    this.colors = [];
    this.faces = [];
    this.faceVertexUvs = [
        []
    ];
    this.morphTargets = [];
    this.morphNormals = [];
    this.skinWeights = [];
    this.skinIndices = [];
    this.lineDistances = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    // update flags
    this.elementsNeedUpdate = false;
    this.verticesNeedUpdate = false;
    this.uvsNeedUpdate = false;
    this.normalsNeedUpdate = false;
    this.colorsNeedUpdate = false;
    this.lineDistancesNeedUpdate = false;
    this.groupsNeedUpdate = false;
}
Geometry.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Geometry,
    isGeometry: true,
    applyMatrix4: function(matrix) {
        const normalMatrix = new Matrix3().getNormalMatrix(matrix);
        for(let i = 0, il = this.vertices.length; i < il; i++){
            const vertex = this.vertices[i];
            vertex.applyMatrix4(matrix);
        }
        for(let i = 0, il = this.faces.length; i < il; i++){
            const face = this.faces[i];
            face.normal.applyMatrix3(normalMatrix).normalize();
            for(let j = 0, jl = face.vertexNormals.length; j < jl; j++)face.vertexNormals[j].applyMatrix3(normalMatrix).normalize();
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        this.verticesNeedUpdate = true;
        this.normalsNeedUpdate = true;
        return this;
    },
    rotateX: function(angle) {
        // rotate geometry around world x-axis
        _m1$3.makeRotationX(angle);
        this.applyMatrix4(_m1$3);
        return this;
    },
    rotateY: function(angle) {
        // rotate geometry around world y-axis
        _m1$3.makeRotationY(angle);
        this.applyMatrix4(_m1$3);
        return this;
    },
    rotateZ: function(angle) {
        // rotate geometry around world z-axis
        _m1$3.makeRotationZ(angle);
        this.applyMatrix4(_m1$3);
        return this;
    },
    translate: function(x, y, z) {
        // translate geometry
        _m1$3.makeTranslation(x, y, z);
        this.applyMatrix4(_m1$3);
        return this;
    },
    scale: function(x, y, z) {
        // scale geometry
        _m1$3.makeScale(x, y, z);
        this.applyMatrix4(_m1$3);
        return this;
    },
    lookAt: function(vector) {
        _obj$1.lookAt(vector);
        _obj$1.updateMatrix();
        this.applyMatrix4(_obj$1.matrix);
        return this;
    },
    fromBufferGeometry: function(geometry) {
        const scope = this;
        const index = geometry.index !== null ? geometry.index : undefined;
        const attributes = geometry.attributes;
        if (attributes.position === undefined) {
            console.error('THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion.');
            return this;
        }
        const position = attributes.position;
        const normal = attributes.normal;
        const color = attributes.color;
        const uv = attributes.uv;
        const uv2 = attributes.uv2;
        if (uv2 !== undefined) this.faceVertexUvs[1] = [];
        for(let i = 0; i < position.count; i++){
            scope.vertices.push(new Vector3().fromBufferAttribute(position, i));
            if (color !== undefined) scope.colors.push(new Color().fromBufferAttribute(color, i));
        }
        function addFace(a, b, c, materialIndex) {
            const vertexColors = color === undefined ? [] : [
                scope.colors[a].clone(),
                scope.colors[b].clone(),
                scope.colors[c].clone()
            ];
            const vertexNormals = normal === undefined ? [] : [
                new Vector3().fromBufferAttribute(normal, a),
                new Vector3().fromBufferAttribute(normal, b),
                new Vector3().fromBufferAttribute(normal, c)
            ];
            const face = new Face3(a, b, c, vertexNormals, vertexColors, materialIndex);
            scope.faces.push(face);
            if (uv !== undefined) scope.faceVertexUvs[0].push([
                new Vector2().fromBufferAttribute(uv, a),
                new Vector2().fromBufferAttribute(uv, b),
                new Vector2().fromBufferAttribute(uv, c)
            ]);
            if (uv2 !== undefined) scope.faceVertexUvs[1].push([
                new Vector2().fromBufferAttribute(uv2, a),
                new Vector2().fromBufferAttribute(uv2, b),
                new Vector2().fromBufferAttribute(uv2, c)
            ]);
        }
        const groups = geometry.groups;
        if (groups.length > 0) for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)if (index !== undefined) addFace(index.getX(j), index.getX(j + 1), index.getX(j + 2), group.materialIndex);
            else addFace(j, j + 1, j + 2, group.materialIndex);
        }
        else {
            if (index !== undefined) for(let i = 0; i < index.count; i += 3)addFace(index.getX(i), index.getX(i + 1), index.getX(i + 2));
            else for(let i = 0; i < position.count; i += 3)addFace(i, i + 1, i + 2);
        }
        this.computeFaceNormals();
        if (geometry.boundingBox !== null) this.boundingBox = geometry.boundingBox.clone();
        if (geometry.boundingSphere !== null) this.boundingSphere = geometry.boundingSphere.clone();
        return this;
    },
    center: function() {
        this.computeBoundingBox();
        this.boundingBox.getCenter(_offset$1).negate();
        this.translate(_offset$1.x, _offset$1.y, _offset$1.z);
        return this;
    },
    normalize: function() {
        this.computeBoundingSphere();
        const center = this.boundingSphere.center;
        const radius = this.boundingSphere.radius;
        const s = radius === 0 ? 1 : 1.0 / radius;
        const matrix = new Matrix4();
        matrix.set(s, 0, 0, -s * center.x, 0, s, 0, -s * center.y, 0, 0, s, -s * center.z, 0, 0, 0, 1);
        this.applyMatrix4(matrix);
        return this;
    },
    computeFaceNormals: function() {
        const cb = new Vector3(), ab = new Vector3();
        for(let f = 0, fl = this.faces.length; f < fl; f++){
            const face = this.faces[f];
            const vA = this.vertices[face.a];
            const vB = this.vertices[face.b];
            const vC = this.vertices[face.c];
            cb.subVectors(vC, vB);
            ab.subVectors(vA, vB);
            cb.cross(ab);
            cb.normalize();
            face.normal.copy(cb);
        }
    },
    computeVertexNormals: function(areaWeighted = true) {
        const vertices = new Array(this.vertices.length);
        for(let v = 0, vl = this.vertices.length; v < vl; v++)vertices[v] = new Vector3();
        if (areaWeighted) {
            // vertex normals weighted by triangle areas
            // http://www.iquilezles.org/www/articles/normals/normals.htm
            const cb = new Vector3(), ab = new Vector3();
            for(let f = 0, fl = this.faces.length; f < fl; f++){
                const face = this.faces[f];
                const vA = this.vertices[face.a];
                const vB = this.vertices[face.b];
                const vC = this.vertices[face.c];
                cb.subVectors(vC, vB);
                ab.subVectors(vA, vB);
                cb.cross(ab);
                vertices[face.a].add(cb);
                vertices[face.b].add(cb);
                vertices[face.c].add(cb);
            }
        } else {
            this.computeFaceNormals();
            for(let f = 0, fl = this.faces.length; f < fl; f++){
                const face = this.faces[f];
                vertices[face.a].add(face.normal);
                vertices[face.b].add(face.normal);
                vertices[face.c].add(face.normal);
            }
        }
        for(let v = 0, vl = this.vertices.length; v < vl; v++)vertices[v].normalize();
        for(let f = 0, fl = this.faces.length; f < fl; f++){
            const face = this.faces[f];
            const vertexNormals = face.vertexNormals;
            if (vertexNormals.length === 3) {
                vertexNormals[0].copy(vertices[face.a]);
                vertexNormals[1].copy(vertices[face.b]);
                vertexNormals[2].copy(vertices[face.c]);
            } else {
                vertexNormals[0] = vertices[face.a].clone();
                vertexNormals[1] = vertices[face.b].clone();
                vertexNormals[2] = vertices[face.c].clone();
            }
        }
        if (this.faces.length > 0) this.normalsNeedUpdate = true;
    },
    computeFlatVertexNormals: function() {
        this.computeFaceNormals();
        for(let f = 0, fl = this.faces.length; f < fl; f++){
            const face = this.faces[f];
            const vertexNormals = face.vertexNormals;
            if (vertexNormals.length === 3) {
                vertexNormals[0].copy(face.normal);
                vertexNormals[1].copy(face.normal);
                vertexNormals[2].copy(face.normal);
            } else {
                vertexNormals[0] = face.normal.clone();
                vertexNormals[1] = face.normal.clone();
                vertexNormals[2] = face.normal.clone();
            }
        }
        if (this.faces.length > 0) this.normalsNeedUpdate = true;
    },
    computeMorphNormals: function() {
        // save original normals
        // - create temp variables on first access
        //   otherwise just copy (for faster repeated calls)
        for(let f = 0, fl = this.faces.length; f < fl; f++){
            const face = this.faces[f];
            if (!face.__originalFaceNormal) face.__originalFaceNormal = face.normal.clone();
            else face.__originalFaceNormal.copy(face.normal);
            if (!face.__originalVertexNormals) face.__originalVertexNormals = [];
            for(let i = 0, il = face.vertexNormals.length; i < il; i++)if (!face.__originalVertexNormals[i]) face.__originalVertexNormals[i] = face.vertexNormals[i].clone();
            else face.__originalVertexNormals[i].copy(face.vertexNormals[i]);
        }
        // use temp geometry to compute face and vertex normals for each morph
        const tmpGeo = new Geometry();
        tmpGeo.faces = this.faces;
        for(let i = 0, il = this.morphTargets.length; i < il; i++){
            // create on first access
            if (!this.morphNormals[i]) {
                this.morphNormals[i] = {};
                this.morphNormals[i].faceNormals = [];
                this.morphNormals[i].vertexNormals = [];
                const dstNormalsFace = this.morphNormals[i].faceNormals;
                const dstNormalsVertex = this.morphNormals[i].vertexNormals;
                for(let f = 0, fl = this.faces.length; f < fl; f++){
                    const faceNormal = new Vector3();
                    const vertexNormals = {
                        a: new Vector3(),
                        b: new Vector3(),
                        c: new Vector3()
                    };
                    dstNormalsFace.push(faceNormal);
                    dstNormalsVertex.push(vertexNormals);
                }
            }
            const morphNormals = this.morphNormals[i];
            // set vertices to morph target
            tmpGeo.vertices = this.morphTargets[i].vertices;
            // compute morph normals
            tmpGeo.computeFaceNormals();
            tmpGeo.computeVertexNormals();
            // store morph normals
            for(let f = 0, fl = this.faces.length; f < fl; f++){
                const face = this.faces[f];
                const faceNormal = morphNormals.faceNormals[f];
                const vertexNormals = morphNormals.vertexNormals[f];
                faceNormal.copy(face.normal);
                vertexNormals.a.copy(face.vertexNormals[0]);
                vertexNormals.b.copy(face.vertexNormals[1]);
                vertexNormals.c.copy(face.vertexNormals[2]);
            }
        }
        // restore original normals
        for(let f = 0, fl = this.faces.length; f < fl; f++){
            const face = this.faces[f];
            face.normal = face.__originalFaceNormal;
            face.vertexNormals = face.__originalVertexNormals;
        }
    },
    computeBoundingBox: function() {
        if (this.boundingBox === null) this.boundingBox = new Box3();
        this.boundingBox.setFromPoints(this.vertices);
    },
    computeBoundingSphere: function() {
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        this.boundingSphere.setFromPoints(this.vertices);
    },
    merge: function(geometry, matrix, materialIndexOffset = 0) {
        if (!(geometry && geometry.isGeometry)) {
            console.error('THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry);
            return;
        }
        let normalMatrix;
        const vertexOffset = this.vertices.length, vertices1 = this.vertices, vertices2 = geometry.vertices, faces1 = this.faces, faces2 = geometry.faces, colors1 = this.colors, colors2 = geometry.colors;
        if (matrix !== undefined) normalMatrix = new Matrix3().getNormalMatrix(matrix);
        // vertices
        for(let i = 0, il = vertices2.length; i < il; i++){
            const vertex = vertices2[i];
            const vertexCopy = vertex.clone();
            if (matrix !== undefined) vertexCopy.applyMatrix4(matrix);
            vertices1.push(vertexCopy);
        }
        // colors
        for(let i = 0, il = colors2.length; i < il; i++)colors1.push(colors2[i].clone());
        // faces
        for(let i = 0, il = faces2.length; i < il; i++){
            const face = faces2[i];
            let normal, color;
            const faceVertexNormals = face.vertexNormals, faceVertexColors = face.vertexColors;
            const faceCopy = new Face3(face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset);
            faceCopy.normal.copy(face.normal);
            if (normalMatrix !== undefined) faceCopy.normal.applyMatrix3(normalMatrix).normalize();
            for(let j = 0, jl = faceVertexNormals.length; j < jl; j++){
                normal = faceVertexNormals[j].clone();
                if (normalMatrix !== undefined) normal.applyMatrix3(normalMatrix).normalize();
                faceCopy.vertexNormals.push(normal);
            }
            faceCopy.color.copy(face.color);
            for(let j = 0, jl = faceVertexColors.length; j < jl; j++){
                color = faceVertexColors[j];
                faceCopy.vertexColors.push(color.clone());
            }
            faceCopy.materialIndex = face.materialIndex + materialIndexOffset;
            faces1.push(faceCopy);
        }
        // uvs
        for(let i = 0, il = geometry.faceVertexUvs.length; i < il; i++){
            const faceVertexUvs2 = geometry.faceVertexUvs[i];
            if (this.faceVertexUvs[i] === undefined) this.faceVertexUvs[i] = [];
            for(let j = 0, jl = faceVertexUvs2.length; j < jl; j++){
                const uvs2 = faceVertexUvs2[j], uvsCopy = [];
                for(let k = 0, kl = uvs2.length; k < kl; k++)uvsCopy.push(uvs2[k].clone());
                this.faceVertexUvs[i].push(uvsCopy);
            }
        }
    },
    mergeMesh: function(mesh) {
        if (!(mesh && mesh.isMesh)) {
            console.error('THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh);
            return;
        }
        if (mesh.matrixAutoUpdate) mesh.updateMatrix();
        this.merge(mesh.geometry, mesh.matrix);
    },
    /*
	 * Checks for duplicate vertices with hashmap.
	 * Duplicated vertices are removed
	 * and faces' vertices are updated.
	 */ mergeVertices: function(precisionPoints = 4) {
        const verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
        const unique = [], changes = [];
        const precision = Math.pow(10, precisionPoints);
        for(let i = 0, il = this.vertices.length; i < il; i++){
            const v = this.vertices[i];
            const key = Math.round(v.x * precision) + '_' + Math.round(v.y * precision) + '_' + Math.round(v.z * precision);
            if (verticesMap[key] === undefined) {
                verticesMap[key] = i;
                unique.push(this.vertices[i]);
                changes[i] = unique.length - 1;
            } else //console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
            changes[i] = changes[verticesMap[key]];
        }
        // if faces are completely degenerate after merging vertices, we
        // have to remove them from the geometry.
        const faceIndicesToRemove = [];
        for(let i = 0, il = this.faces.length; i < il; i++){
            const face = this.faces[i];
            face.a = changes[face.a];
            face.b = changes[face.b];
            face.c = changes[face.c];
            const indices = [
                face.a,
                face.b,
                face.c
            ];
            // if any duplicate vertices are found in a Face3
            // we have to remove the face as nothing can be saved
            for(let n = 0; n < 3; n++)if (indices[n] === indices[(n + 1) % 3]) {
                faceIndicesToRemove.push(i);
                break;
            }
        }
        for(let i = faceIndicesToRemove.length - 1; i >= 0; i--){
            const idx = faceIndicesToRemove[i];
            this.faces.splice(idx, 1);
            for(let j = 0, jl = this.faceVertexUvs.length; j < jl; j++)this.faceVertexUvs[j].splice(idx, 1);
        }
        // Use unique set of vertices
        const diff = this.vertices.length - unique.length;
        this.vertices = unique;
        return diff;
    },
    setFromPoints: function(points) {
        this.vertices = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            this.vertices.push(new Vector3(point.x, point.y, point.z || 0));
        }
        return this;
    },
    sortFacesByMaterialIndex: function() {
        const faces = this.faces;
        const length = faces.length;
        // tag faces
        for(let i = 0; i < length; i++)faces[i]._id = i;
        // sort faces
        function materialIndexSort(a, b) {
            return a.materialIndex - b.materialIndex;
        }
        faces.sort(materialIndexSort);
        // sort uvs
        const uvs1 = this.faceVertexUvs[0];
        const uvs2 = this.faceVertexUvs[1];
        let newUvs1, newUvs2;
        if (uvs1 && uvs1.length === length) newUvs1 = [];
        if (uvs2 && uvs2.length === length) newUvs2 = [];
        for(let i = 0; i < length; i++){
            const id = faces[i]._id;
            if (newUvs1) newUvs1.push(uvs1[id]);
            if (newUvs2) newUvs2.push(uvs2[id]);
        }
        if (newUvs1) this.faceVertexUvs[0] = newUvs1;
        if (newUvs2) this.faceVertexUvs[1] = newUvs2;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Geometry',
                generator: 'Geometry.toJSON'
            }
        };
        // standard Geometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        const vertices = [];
        for(let i = 0; i < this.vertices.length; i++){
            const vertex = this.vertices[i];
            vertices.push(vertex.x, vertex.y, vertex.z);
        }
        const faces = [];
        const normals = [];
        const normalsHash = {};
        const colors = [];
        const colorsHash = {};
        const uvs = [];
        const uvsHash = {};
        for(let i = 0; i < this.faces.length; i++){
            const face = this.faces[i];
            const hasMaterial = true;
            const hasFaceUv = false; // deprecated
            const hasFaceVertexUv = this.faceVertexUvs[0][i] !== undefined;
            const hasFaceNormal = face.normal.length() > 0;
            const hasFaceVertexNormal = face.vertexNormals.length > 0;
            const hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
            const hasFaceVertexColor = face.vertexColors.length > 0;
            let faceType = 0;
            faceType = setBit(faceType, 0, 0); // isQuad
            faceType = setBit(faceType, 1, hasMaterial);
            faceType = setBit(faceType, 2, hasFaceUv);
            faceType = setBit(faceType, 3, hasFaceVertexUv);
            faceType = setBit(faceType, 4, hasFaceNormal);
            faceType = setBit(faceType, 5, hasFaceVertexNormal);
            faceType = setBit(faceType, 6, hasFaceColor);
            faceType = setBit(faceType, 7, hasFaceVertexColor);
            faces.push(faceType);
            faces.push(face.a, face.b, face.c);
            faces.push(face.materialIndex);
            if (hasFaceVertexUv) {
                const faceVertexUvs = this.faceVertexUvs[0][i];
                faces.push(getUvIndex(faceVertexUvs[0]), getUvIndex(faceVertexUvs[1]), getUvIndex(faceVertexUvs[2]));
            }
            if (hasFaceNormal) faces.push(getNormalIndex(face.normal));
            if (hasFaceVertexNormal) {
                const vertexNormals = face.vertexNormals;
                faces.push(getNormalIndex(vertexNormals[0]), getNormalIndex(vertexNormals[1]), getNormalIndex(vertexNormals[2]));
            }
            if (hasFaceColor) faces.push(getColorIndex(face.color));
            if (hasFaceVertexColor) {
                const vertexColors = face.vertexColors;
                faces.push(getColorIndex(vertexColors[0]), getColorIndex(vertexColors[1]), getColorIndex(vertexColors[2]));
            }
        }
        function setBit(value, position, enabled) {
            return enabled ? value | 1 << position : value & ~(1 << position);
        }
        function getNormalIndex(normal) {
            const hash = normal.x.toString() + normal.y.toString() + normal.z.toString();
            if (normalsHash[hash] !== undefined) return normalsHash[hash];
            normalsHash[hash] = normals.length / 3;
            normals.push(normal.x, normal.y, normal.z);
            return normalsHash[hash];
        }
        function getColorIndex(color) {
            const hash = color.r.toString() + color.g.toString() + color.b.toString();
            if (colorsHash[hash] !== undefined) return colorsHash[hash];
            colorsHash[hash] = colors.length;
            colors.push(color.getHex());
            return colorsHash[hash];
        }
        function getUvIndex(uv) {
            const hash = uv.x.toString() + uv.y.toString();
            if (uvsHash[hash] !== undefined) return uvsHash[hash];
            uvsHash[hash] = uvs.length / 2;
            uvs.push(uv.x, uv.y);
            return uvsHash[hash];
        }
        data.data = {};
        data.data.vertices = vertices;
        data.data.normals = normals;
        if (colors.length > 0) data.data.colors = colors;
        if (uvs.length > 0) data.data.uvs = [
            uvs
        ]; // temporal backward compatibility
        data.data.faces = faces;
        return data;
    },
    clone: function() {
        /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new Geometry().copy(this);
    },
    copy: function(source) {
        // reset
        this.vertices = [];
        this.colors = [];
        this.faces = [];
        this.faceVertexUvs = [
            []
        ];
        this.morphTargets = [];
        this.morphNormals = [];
        this.skinWeights = [];
        this.skinIndices = [];
        this.lineDistances = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // name
        this.name = source.name;
        // vertices
        const vertices = source.vertices;
        for(let i = 0, il = vertices.length; i < il; i++)this.vertices.push(vertices[i].clone());
        // colors
        const colors = source.colors;
        for(let i = 0, il = colors.length; i < il; i++)this.colors.push(colors[i].clone());
        // faces
        const faces = source.faces;
        for(let i = 0, il = faces.length; i < il; i++)this.faces.push(faces[i].clone());
        // face vertex uvs
        for(let i = 0, il = source.faceVertexUvs.length; i < il; i++){
            const faceVertexUvs = source.faceVertexUvs[i];
            if (this.faceVertexUvs[i] === undefined) this.faceVertexUvs[i] = [];
            for(let j = 0, jl = faceVertexUvs.length; j < jl; j++){
                const uvs = faceVertexUvs[j], uvsCopy = [];
                for(let k = 0, kl = uvs.length; k < kl; k++){
                    const uv = uvs[k];
                    uvsCopy.push(uv.clone());
                }
                this.faceVertexUvs[i].push(uvsCopy);
            }
        }
        // morph targets
        const morphTargets = source.morphTargets;
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = {};
            morphTarget.name = morphTargets[i].name;
            // vertices
            if (morphTargets[i].vertices !== undefined) {
                morphTarget.vertices = [];
                for(let j = 0, jl = morphTargets[i].vertices.length; j < jl; j++)morphTarget.vertices.push(morphTargets[i].vertices[j].clone());
            }
            // normals
            if (morphTargets[i].normals !== undefined) {
                morphTarget.normals = [];
                for(let j = 0, jl = morphTargets[i].normals.length; j < jl; j++)morphTarget.normals.push(morphTargets[i].normals[j].clone());
            }
            this.morphTargets.push(morphTarget);
        }
        // morph normals
        const morphNormals = source.morphNormals;
        for(let i = 0, il = morphNormals.length; i < il; i++){
            const morphNormal = {};
            // vertex normals
            if (morphNormals[i].vertexNormals !== undefined) {
                morphNormal.vertexNormals = [];
                for(let j = 0, jl = morphNormals[i].vertexNormals.length; j < jl; j++){
                    const srcVertexNormal = morphNormals[i].vertexNormals[j];
                    const destVertexNormal = {};
                    destVertexNormal.a = srcVertexNormal.a.clone();
                    destVertexNormal.b = srcVertexNormal.b.clone();
                    destVertexNormal.c = srcVertexNormal.c.clone();
                    morphNormal.vertexNormals.push(destVertexNormal);
                }
            }
            // face normals
            if (morphNormals[i].faceNormals !== undefined) {
                morphNormal.faceNormals = [];
                for(let j = 0, jl = morphNormals[i].faceNormals.length; j < jl; j++)morphNormal.faceNormals.push(morphNormals[i].faceNormals[j].clone());
            }
            this.morphNormals.push(morphNormal);
        }
        // skin weights
        const skinWeights = source.skinWeights;
        for(let i = 0, il = skinWeights.length; i < il; i++)this.skinWeights.push(skinWeights[i].clone());
        // skin indices
        const skinIndices = source.skinIndices;
        for(let i = 0, il = skinIndices.length; i < il; i++)this.skinIndices.push(skinIndices[i].clone());
        // line distances
        const lineDistances = source.lineDistances;
        for(let i = 0, il = lineDistances.length; i < il; i++)this.lineDistances.push(lineDistances[i]);
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // update flags
        this.elementsNeedUpdate = source.elementsNeedUpdate;
        this.verticesNeedUpdate = source.verticesNeedUpdate;
        this.uvsNeedUpdate = source.uvsNeedUpdate;
        this.normalsNeedUpdate = source.normalsNeedUpdate;
        this.colorsNeedUpdate = source.colorsNeedUpdate;
        this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
        this.groupsNeedUpdate = source.groupsNeedUpdate;
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
class BoxGeometry extends Geometry {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        this.fromBufferGeometry(new BoxBufferGeometry(width, height, depth, widthSegments, heightSegments, depthSegments));
        this.mergeVertices();
    }
}
class CircleBufferGeometry extends BufferGeometry {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleBufferGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const uv = new Vector2();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class CircleGeometry extends Geometry {
    constructor(radius, segments, thetaStart, thetaLength){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        this.fromBufferGeometry(new CircleBufferGeometry(radius, segments, thetaStart, thetaLength));
        this.mergeVertices();
    }
}
class CylinderBufferGeometry extends BufferGeometry {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderBufferGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function generateTorso() {
            const normal = new Vector3();
            const vertex = new Vector3();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new Vector2();
            const vertex = new Vector3();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
}
class CylinderGeometry extends Geometry {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        this.fromBufferGeometry(new CylinderBufferGeometry(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength));
        this.mergeVertices();
    }
}
class ConeGeometry extends CylinderGeometry {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
class ConeBufferGeometry extends CylinderBufferGeometry {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeBufferGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
class PolyhedronBufferGeometry extends BufferGeometry {
    constructor(vertices, indices, radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronBufferGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new Float32BufferAttribute(vertexBuffer, 3));
        this.setAttribute('normal', new Float32BufferAttribute(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new Vector3();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new Vector3();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            const centroid = new Vector3();
            const uvA = new Vector2();
            const uvB = new Vector2();
            const uvC = new Vector2();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
}
class DodecahedronBufferGeometry extends PolyhedronBufferGeometry {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronBufferGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class DodecahedronGeometry extends Geometry {
    constructor(radius, detail){
        super();
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
        this.fromBufferGeometry(new DodecahedronBufferGeometry(radius, detail));
        this.mergeVertices();
    }
}
const _v0$2 = new Vector3();
const _v1$5 = new Vector3();
const _normal$1 = new Vector3();
const _triangle = new Triangle();
class EdgesGeometry extends BufferGeometry {
    constructor(geometry, thresholdAngle){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            thresholdAngle: thresholdAngle
        };
        thresholdAngle = thresholdAngle !== undefined ? thresholdAngle : 1;
        if (geometry.isGeometry) geometry = new BufferGeometry().fromGeometry(geometry);
        const precisionPoints = 4;
        const precision = Math.pow(10, precisionPoints);
        const thresholdDot = Math.cos(MathUtils.DEG2RAD * thresholdAngle);
        const indexAttr = geometry.getIndex();
        const positionAttr = geometry.getAttribute('position');
        const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
        const indexArr = [
            0,
            0,
            0
        ];
        const vertKeys = [
            'a',
            'b',
            'c'
        ];
        const hashes = new Array(3);
        const edgeData = {};
        const vertices = [];
        for(let i = 0; i < indexCount; i += 3){
            if (indexAttr) {
                indexArr[0] = indexAttr.getX(i);
                indexArr[1] = indexAttr.getX(i + 1);
                indexArr[2] = indexAttr.getX(i + 2);
            } else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            const { a, b, c } = _triangle;
            a.fromBufferAttribute(positionAttr, indexArr[0]);
            b.fromBufferAttribute(positionAttr, indexArr[1]);
            c.fromBufferAttribute(positionAttr, indexArr[2]);
            _triangle.getNormal(_normal$1);
            // create hashes for the edge from the vertices
            hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
            hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
            hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
            // skip degenerate triangles
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
            // iterate over every edge
            for(let j = 0; j < 3; j++){
                // get the first and next vertex making up the edge
                const jNext = (j + 1) % 3;
                const vecHash0 = hashes[j];
                const vecHash1 = hashes[jNext];
                const v0 = _triangle[vertKeys[j]];
                const v1 = _triangle[vertKeys[jNext]];
                const hash = `${vecHash0}_${vecHash1}`;
                const reverseHash = `${vecHash1}_${vecHash0}`;
                if (reverseHash in edgeData && edgeData[reverseHash]) {
                    // if we found a sibling edge add it into the vertex array if
                    // it meets the angle threshold and delete the edge from the map.
                    if (_normal$1.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                    }
                    edgeData[reverseHash] = null;
                } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                edgeData[hash] = {
                    index0: indexArr[j],
                    index1: indexArr[jNext],
                    normal: _normal$1.clone()
                };
            }
        }
        // iterate over all remaining, unmatched edges and add them to the vertex array
        for(const key in edgeData)if (edgeData[key]) {
            const { index0, index1 } = edgeData[key];
            _v0$2.fromBufferAttribute(positionAttr, index0);
            _v1$5.fromBufferAttribute(positionAttr, index1);
            vertices.push(_v0$2.x, _v0$2.y, _v0$2.z);
            vertices.push(_v1$5.x, _v1$5.y, _v1$5.z);
        }
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const Earcut = {
    triangulate: function(data, holeIndices, dim) {
        dim = dim || 2;
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);
                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }
    queue.sort(compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        filterPoints(outerNode, outerNode.next);
        filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = new Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
const ShapeUtils = {
    // calculate area of the contour polygon
    area: function(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    },
    isClockWise: function(pts) {
        return ShapeUtils.area(pts) < 0;
    },
    triangulateShape: function(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        removeDupEndPts(contour);
        addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach(removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            addContour(vertices, holes[i]);
        }
        //
        const triangles = Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
};
function removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class ExtrudeBufferGeometry extends BufferGeometry {
    constructor(shapes, options){
        super();
        this.type = 'ExtrudeBufferGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new Float32BufferAttribute(verticesArray, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 100;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn('THREE.ExtrudeBufferGeometry: amount has been renamed to depth.');
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new Vector3();
                normal = new Vector3();
                position2 = new Vector3();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !ShapeUtils.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if (ShapeUtils.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = ShapeUtils.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new Vector2(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return toJSON(shapes, options, data);
    }
}
const WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new Vector2(a_x, a_y),
            new Vector2(b_x, b_y),
            new Vector2(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < 0.01) return [
            new Vector2(a_x, 1 - a_z),
            new Vector2(b_x, 1 - b_z),
            new Vector2(c_x, 1 - c_z),
            new Vector2(d_x, 1 - d_z)
        ];
        else return [
            new Vector2(a_y, 1 - a_z),
            new Vector2(b_y, 1 - b_z),
            new Vector2(c_y, 1 - c_z),
            new Vector2(d_y, 1 - d_z)
        ];
    }
};
function toJSON(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class ExtrudeGeometry extends Geometry {
    constructor(shapes, options){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        this.fromBufferGeometry(new ExtrudeBufferGeometry(shapes, options));
        this.mergeVertices();
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return toJSON$1(shapes, options, data);
    }
}
function toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class IcosahedronBufferGeometry extends PolyhedronBufferGeometry {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronBufferGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class IcosahedronGeometry extends Geometry {
    constructor(radius, detail){
        super();
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
        this.fromBufferGeometry(new IcosahedronBufferGeometry(radius, detail));
        this.mergeVertices();
    }
}
class LatheBufferGeometry extends BufferGeometry {
    constructor(points, segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheBufferGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = MathUtils.clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new Vector3();
        const uv = new Vector2();
        // generate vertices and uvs
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // generate normals
        this.computeVertexNormals();
        // if the geometry is closed, we need to average the normals along the seam.
        // because the corresponding vertices are identical (but still have different UVs).
        if (phiLength === Math.PI * 2) {
            const normals = this.attributes.normal.array;
            const n1 = new Vector3();
            const n2 = new Vector3();
            const n = new Vector3();
            // this is the buffer offset for the last line of vertices
            const base = segments * points.length * 3;
            for(let i = 0, j = 0; i < points.length; i++, j += 3){
                // select the normal of the vertex in the first line
                n1.x = normals[j + 0];
                n1.y = normals[j + 1];
                n1.z = normals[j + 2];
                // select the normal of the vertex in the last line
                n2.x = normals[base + j + 0];
                n2.y = normals[base + j + 1];
                n2.z = normals[base + j + 2];
                // average normals
                n.addVectors(n1, n2).normalize();
                // assign the new values to both normals
                normals[j + 0] = normals[base + j + 0] = n.x;
                normals[j + 1] = normals[base + j + 1] = n.y;
                normals[j + 2] = normals[base + j + 2] = n.z;
            }
        }
    }
}
class LatheGeometry extends Geometry {
    constructor(points, segments, phiStart, phiLength){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        this.fromBufferGeometry(new LatheBufferGeometry(points, segments, phiStart, phiLength));
        this.mergeVertices();
    }
}
class OctahedronBufferGeometry extends PolyhedronBufferGeometry {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronBufferGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class OctahedronGeometry extends Geometry {
    constructor(radius, detail){
        super();
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
        this.fromBufferGeometry(new OctahedronBufferGeometry(radius, detail));
        this.mergeVertices();
    }
}
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ function ParametricBufferGeometry(func, slices, stacks) {
    BufferGeometry.call(this);
    this.type = 'ParametricBufferGeometry';
    this.parameters = {
        func: func,
        slices: slices,
        stacks: stacks
    };
    // buffers
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const EPS = 0.00001;
    const normal = new Vector3();
    const p0 = new Vector3(), p1 = new Vector3();
    const pu = new Vector3(), pv = new Vector3();
    if (func.length < 3) console.error('THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.');
    // generate vertices, normals and uvs
    const sliceCount = slices + 1;
    for(let i = 0; i <= stacks; i++){
        const v = i / stacks;
        for(let j = 0; j <= slices; j++){
            const u = j / slices;
            // vertex
            func(u, v, p0);
            vertices.push(p0.x, p0.y, p0.z);
            // normal
            // approximate tangent vectors via finite differences
            if (u - EPS >= 0) {
                func(u - EPS, v, p1);
                pu.subVectors(p0, p1);
            } else {
                func(u + EPS, v, p1);
                pu.subVectors(p1, p0);
            }
            if (v - EPS >= 0) {
                func(u, v - EPS, p1);
                pv.subVectors(p0, p1);
            } else {
                func(u, v + EPS, p1);
                pv.subVectors(p1, p0);
            }
            // cross product of tangent vectors returns surface normal
            normal.crossVectors(pu, pv).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, v);
        }
    }
    // generate indices
    for(let i = 0; i < stacks; i++)for(let j = 0; j < slices; j++){
        const a = i * sliceCount + j;
        const b = i * sliceCount + j + 1;
        const c = (i + 1) * sliceCount + j + 1;
        const d = (i + 1) * sliceCount + j;
        // faces one and two
        indices.push(a, b, d);
        indices.push(b, c, d);
    }
    // build geometry
    this.setIndex(indices);
    this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
    this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
}
ParametricBufferGeometry.prototype = Object.create(BufferGeometry.prototype);
ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ function ParametricGeometry(func, slices, stacks) {
    Geometry.call(this);
    this.type = 'ParametricGeometry';
    this.parameters = {
        func: func,
        slices: slices,
        stacks: stacks
    };
    this.fromBufferGeometry(new ParametricBufferGeometry(func, slices, stacks));
    this.mergeVertices();
}
ParametricGeometry.prototype = Object.create(Geometry.prototype);
ParametricGeometry.prototype.constructor = ParametricGeometry;
class PlaneGeometry extends Geometry {
    constructor(width, height, widthSegments, heightSegments){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        this.fromBufferGeometry(new PlaneBufferGeometry(width, height, widthSegments, heightSegments));
        this.mergeVertices();
    }
}
class PolyhedronGeometry extends Geometry {
    constructor(vertices, indices, radius, detail){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        this.fromBufferGeometry(new PolyhedronBufferGeometry(vertices, indices, radius, detail));
        this.mergeVertices();
    }
}
class RingBufferGeometry extends BufferGeometry {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingBufferGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new Vector3();
        const uv = new Vector2();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class RingGeometry extends Geometry {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        this.fromBufferGeometry(new RingBufferGeometry(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength));
        this.mergeVertices();
    }
}
class ShapeBufferGeometry extends BufferGeometry {
    constructor(shapes, curveSegments = 12){
        super();
        this.type = 'ShapeBufferGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if (ShapeUtils.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if (ShapeUtils.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        const shapes = this.parameters.shapes;
        return toJSON$2(shapes, data);
    }
}
function toJSON$2(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class ShapeGeometry extends Geometry {
    constructor(shapes, curveSegments){
        super();
        this.type = 'ShapeGeometry';
        if (typeof curveSegments === 'object') {
            console.warn('THREE.ShapeGeometry: Options parameter has been removed.');
            curveSegments = curveSegments.curveSegments;
        }
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        this.fromBufferGeometry(new ShapeBufferGeometry(shapes, curveSegments));
        this.mergeVertices();
    }
    toJSON() {
        const data = Geometry.prototype.toJSON.call(this);
        const shapes = this.parameters.shapes;
        return toJSON$3(shapes, data);
    }
}
function toJSON$3(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class SphereBufferGeometry extends BufferGeometry {
    constructor(radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereBufferGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new Vector3();
        const normal = new Vector3();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class SphereGeometry extends Geometry {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        this.fromBufferGeometry(new SphereBufferGeometry(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength));
        this.mergeVertices();
    }
}
class TetrahedronBufferGeometry extends PolyhedronBufferGeometry {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronBufferGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class TetrahedronGeometry extends Geometry {
    constructor(radius, detail){
        super();
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
        this.fromBufferGeometry(new TetrahedronBufferGeometry(radius, detail));
        this.mergeVertices();
    }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ class TextBufferGeometry extends ExtrudeBufferGeometry {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (!(font && font.isFont)) {
            console.error('THREE.TextGeometry: font parameter is not an instance of THREE.Font.');
            return new BufferGeometry();
        }
        const shapes = font.generateShapes(text, parameters.size);
        // translate parameters to ExtrudeGeometry API
        parameters.depth = parameters.height !== undefined ? parameters.height : 50;
        // defaults
        if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
        if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
        if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
        super(shapes, parameters);
        this.type = 'TextBufferGeometry';
    }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ class TextGeometry extends Geometry {
    constructor(text, parameters){
        super();
        this.type = 'TextGeometry';
        this.parameters = {
            text: text,
            parameters: parameters
        };
        this.fromBufferGeometry(new TextBufferGeometry(text, parameters));
        this.mergeVertices();
    }
}
class TorusBufferGeometry extends BufferGeometry {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = 'TorusBufferGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new Vector3();
        const vertex = new Vector3();
        const normal = new Vector3();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class TorusGeometry extends Geometry {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        this.fromBufferGeometry(new TorusBufferGeometry(radius, tube, radialSegments, tubularSegments, arc));
        this.mergeVertices();
    }
}
class TorusKnotBufferGeometry extends BufferGeometry {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotBufferGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const P1 = new Vector3();
        const P2 = new Vector3();
        const B = new Vector3();
        const T = new Vector3();
        const N = new Vector3();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
}
class TorusKnotGeometry extends Geometry {
    constructor(radius, tube, tubularSegments, radialSegments, p, q, heightScale){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        if (heightScale !== undefined) console.warn('THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.');
        this.fromBufferGeometry(new TorusKnotBufferGeometry(radius, tube, tubularSegments, radialSegments, p, q));
        this.mergeVertices();
    }
}
class TubeBufferGeometry extends BufferGeometry {
    constructor(path, tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeBufferGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const uv = new Vector2();
        let P = new Vector3();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        data.path = this.parameters.path.toJSON();
        return data;
    }
}
class TubeGeometry extends Geometry {
    constructor(path, tubularSegments, radius, radialSegments, closed, taper){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        if (taper !== undefined) console.warn('THREE.TubeGeometry: taper has been removed.');
        const bufferGeometry = new TubeBufferGeometry(path, tubularSegments, radius, radialSegments, closed);
        // expose internals
        this.tangents = bufferGeometry.tangents;
        this.normals = bufferGeometry.normals;
        this.binormals = bufferGeometry.binormals;
        // create geometry
        this.fromBufferGeometry(bufferGeometry);
        this.mergeVertices();
    }
}
class WireframeGeometry extends BufferGeometry {
    constructor(geometry){
        super();
        this.type = 'WireframeGeometry';
        // buffer
        const vertices = [];
        // helper variables
        const edge = [
            0,
            0
        ], edges = {};
        const keys = [
            'a',
            'b',
            'c'
        ];
        // different logic for Geometry and BufferGeometry
        if (geometry && geometry.isGeometry) {
            // create a data structure that contains all edges without duplicates
            const faces = geometry.faces;
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                for(let j = 0; j < 3; j++){
                    const edge1 = face[keys[j]];
                    const edge2 = face[keys[(j + 1) % 3]];
                    edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                    edge[1] = Math.max(edge1, edge2);
                    const key = edge[0] + ',' + edge[1];
                    if (edges[key] === undefined) edges[key] = {
                        index1: edge[0],
                        index2: edge[1]
                    };
                }
            }
            // generate vertices
            for(const key in edges){
                const e = edges[key];
                let vertex = geometry.vertices[e.index1];
                vertices.push(vertex.x, vertex.y, vertex.z);
                vertex = geometry.vertices[e.index2];
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        } else if (geometry && geometry.isBufferGeometry) {
            const vertex = new Vector3();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all eges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const start = group.start;
                    const count = group.count;
                    for(let i = start, l = start + count; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const edge1 = indices.getX(i + j);
                        const edge2 = indices.getX(i + (j + 1) % 3);
                        edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                        edge[1] = Math.max(edge1, edge2);
                        const key = edge[0] + ',' + edge[1];
                        if (edges[key] === undefined) edges[key] = {
                            index1: edge[0],
                            index2: edge[1]
                        };
                    }
                }
                // generate vertices
                for(const key in edges){
                    const e = edges[key];
                    vertex.fromBufferAttribute(position, e.index1);
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    vertex.fromBufferAttribute(position, e.index2);
                    vertices.push(vertex.x, vertex.y, vertex.z);
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    vertex.fromBufferAttribute(position, index1);
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    const index2 = 3 * i + (j + 1) % 3;
                    vertex.fromBufferAttribute(position, index2);
                    vertices.push(vertex.x, vertex.y, vertex.z);
                }
            }
        }
        // build geometry
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }
}
var Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: BoxGeometry,
    BoxBufferGeometry: BoxBufferGeometry,
    CircleGeometry: CircleGeometry,
    CircleBufferGeometry: CircleBufferGeometry,
    ConeGeometry: ConeGeometry,
    ConeBufferGeometry: ConeBufferGeometry,
    CylinderGeometry: CylinderGeometry,
    CylinderBufferGeometry: CylinderBufferGeometry,
    DodecahedronGeometry: DodecahedronGeometry,
    DodecahedronBufferGeometry: DodecahedronBufferGeometry,
    EdgesGeometry: EdgesGeometry,
    ExtrudeGeometry: ExtrudeGeometry,
    ExtrudeBufferGeometry: ExtrudeBufferGeometry,
    IcosahedronGeometry: IcosahedronGeometry,
    IcosahedronBufferGeometry: IcosahedronBufferGeometry,
    LatheGeometry: LatheGeometry,
    LatheBufferGeometry: LatheBufferGeometry,
    OctahedronGeometry: OctahedronGeometry,
    OctahedronBufferGeometry: OctahedronBufferGeometry,
    ParametricGeometry: ParametricGeometry,
    ParametricBufferGeometry: ParametricBufferGeometry,
    PlaneGeometry: PlaneGeometry,
    PlaneBufferGeometry: PlaneBufferGeometry,
    PolyhedronGeometry: PolyhedronGeometry,
    PolyhedronBufferGeometry: PolyhedronBufferGeometry,
    RingGeometry: RingGeometry,
    RingBufferGeometry: RingBufferGeometry,
    ShapeGeometry: ShapeGeometry,
    ShapeBufferGeometry: ShapeBufferGeometry,
    SphereGeometry: SphereGeometry,
    SphereBufferGeometry: SphereBufferGeometry,
    TetrahedronGeometry: TetrahedronGeometry,
    TetrahedronBufferGeometry: TetrahedronBufferGeometry,
    TextGeometry: TextGeometry,
    TextBufferGeometry: TextBufferGeometry,
    TorusGeometry: TorusGeometry,
    TorusBufferGeometry: TorusBufferGeometry,
    TorusKnotGeometry: TorusKnotGeometry,
    TorusKnotBufferGeometry: TorusKnotBufferGeometry,
    TubeGeometry: TubeGeometry,
    TubeBufferGeometry: TubeBufferGeometry,
    WireframeGeometry: WireframeGeometry
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ function ShadowMaterial(parameters) {
    Material.call(this);
    this.type = 'ShadowMaterial';
    this.color = new Color(0x000000);
    this.transparent = true;
    this.setValues(parameters);
}
ShadowMaterial.prototype = Object.create(Material.prototype);
ShadowMaterial.prototype.constructor = ShadowMaterial;
ShadowMaterial.prototype.isShadowMaterial = true;
ShadowMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    return this;
};
function RawShaderMaterial(parameters) {
    ShaderMaterial.call(this, parameters);
    this.type = 'RawShaderMaterial';
}
RawShaderMaterial.prototype = Object.create(ShaderMaterial.prototype);
RawShaderMaterial.prototype.constructor = RawShaderMaterial;
RawShaderMaterial.prototype.isRawShaderMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshStandardMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'STANDARD': ''
    };
    this.type = 'MeshStandardMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.roughness = 1.0;
    this.metalness = 0.0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapIntensity = 1.0;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.vertexTangents = false;
    this.setValues(parameters);
}
MeshStandardMaterial.prototype = Object.create(Material.prototype);
MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;
MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
MeshStandardMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.defines = {
        'STANDARD': ''
    };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapIntensity = source.envMapIntensity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.vertexTangents = source.vertexTangents;
    return this;
};
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  reflectivity: <float>,
 *  ior: <float>,
 *
 *  sheen: <Color>,
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> )
 * }
 */ function MeshPhysicalMaterial(parameters) {
    MeshStandardMaterial.call(this);
    this.defines = {
        'STANDARD': '',
        'PHYSICAL': ''
    };
    this.type = 'MeshPhysicalMaterial';
    this.clearcoat = 0.0;
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0.0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2(1, 1);
    this.clearcoatNormalMap = null;
    this.reflectivity = 0.5; // maps to F0 = 0.04
    Object.defineProperty(this, 'ior', {
        get: function() {
            return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
        },
        set: function(ior) {
            this.reflectivity = MathUtils.clamp(2.5 * (ior - 1) / (ior + 1), 0, 1);
        }
    });
    this.sheen = null; // null will disable sheen bsdf
    this.transmission = 0.0;
    this.transmissionMap = null;
    this.setValues(parameters);
}
MeshPhysicalMaterial.prototype = Object.create(MeshStandardMaterial.prototype);
MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;
MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
MeshPhysicalMaterial.prototype.copy = function(source) {
    MeshStandardMaterial.prototype.copy.call(this, source);
    this.defines = {
        'STANDARD': '',
        'PHYSICAL': ''
    };
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.reflectivity = source.reflectivity;
    if (source.sheen) this.sheen = (this.sheen || new Color()).copy(source.sheen);
    else this.sheen = null;
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshPhongMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshPhongMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.specular = new Color(0x111111);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshPhongMaterial.prototype = Object.create(Material.prototype);
MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;
MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
MeshPhongMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshToonMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'TOON': ''
    };
    this.type = 'MeshToonMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshToonMaterial.prototype = Object.create(Material.prototype);
MeshToonMaterial.prototype.constructor = MeshToonMaterial;
MeshToonMaterial.prototype.isMeshToonMaterial = true;
MeshToonMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshNormalMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshNormalMaterial';
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshNormalMaterial.prototype = Object.create(Material.prototype);
MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;
MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
MeshNormalMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshLambertMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshLambertMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshLambertMaterial.prototype = Object.create(Material.prototype);
MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;
MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
MeshLambertMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshMatcapMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'MATCAP': ''
    };
    this.type = 'MeshMatcapMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshMatcapMaterial.prototype = Object.create(Material.prototype);
MeshMatcapMaterial.prototype.constructor = MeshMatcapMaterial;
MeshMatcapMaterial.prototype.isMeshMatcapMaterial = true;
MeshMatcapMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.defines = {
        'MATCAP': ''
    };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ function LineDashedMaterial(parameters) {
    LineBasicMaterial.call(this);
    this.type = 'LineDashedMaterial';
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
}
LineDashedMaterial.prototype = Object.create(LineBasicMaterial.prototype);
LineDashedMaterial.prototype.constructor = LineDashedMaterial;
LineDashedMaterial.prototype.isLineDashedMaterial = true;
LineDashedMaterial.prototype.copy = function(source) {
    LineBasicMaterial.prototype.copy.call(this, source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
};
var Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: ShadowMaterial,
    SpriteMaterial: SpriteMaterial,
    RawShaderMaterial: RawShaderMaterial,
    ShaderMaterial: ShaderMaterial,
    PointsMaterial: PointsMaterial,
    MeshPhysicalMaterial: MeshPhysicalMaterial,
    MeshStandardMaterial: MeshStandardMaterial,
    MeshPhongMaterial: MeshPhongMaterial,
    MeshToonMaterial: MeshToonMaterial,
    MeshNormalMaterial: MeshNormalMaterial,
    MeshLambertMaterial: MeshLambertMaterial,
    MeshDepthMaterial: MeshDepthMaterial,
    MeshDistanceMaterial: MeshDistanceMaterial,
    MeshBasicMaterial: MeshBasicMaterial,
    MeshMatcapMaterial: MeshMatcapMaterial,
    LineDashedMaterial: LineDashedMaterial,
    LineBasicMaterial: LineBasicMaterial,
    Material: Material
});
const AnimationUtils = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if (AnimationUtils.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = AnimationUtils.convertArray(times, track.times.constructor);
            track.values = AnimationUtils.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = AnimationUtils.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === 'quaternion') {
                const referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
                Quaternion.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = AdditiveAnimationBlendMode;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
}
Object.assign(Interpolant.prototype, {
    evaluate: function(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    },
    settings: null,
    // Note: The indirection allows central control of many interpolants.
    // --- Protected interface
    DefaultSettings_: {},
    getSettings_: function() {
        return this.settings || this.DefaultSettings_;
    },
    copySampleValue_: function(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    },
    // Template methods for derived classes:
    interpolate_: function() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    },
    intervalChanged_: function() {
    // empty
    }
});
// DECLARE ALIAS AFTER assign prototype
Object.assign(Interpolant.prototype, {
    //( 0, t, t0 ), returns this.resultBuffer
    beforeStart_: Interpolant.prototype.copySampleValue_,
    //( N-1, tN-1, t ), returns this.resultBuffer
    afterEnd_: Interpolant.prototype.copySampleValue_
});
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
}
CubicInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: CubicInterpolant,
    DefaultSettings_: {
        endingStart: ZeroCurvatureEnding,
        endingEnd: ZeroCurvatureEnding
    },
    intervalChanged_: function(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case ZeroSlopeEnding:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case ZeroSlopeEnding:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    },
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
});
function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
LinearInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: LinearInterpolant,
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
});
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
DiscreteInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: DiscreteInterpolant,
    interpolate_: function(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
});
function KeyframeTrack(name, times, values, interpolation) {
    if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
    if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
    this.name = name;
    this.times = AnimationUtils.convertArray(times, this.TimeBufferType);
    this.values = AnimationUtils.convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
}
// Static methods
Object.assign(KeyframeTrack, {
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    toJSON: function(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== undefined) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': AnimationUtils.convertArray(track.times, Array),
                'values': AnimationUtils.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
});
Object.assign(KeyframeTrack.prototype, {
    constructor: KeyframeTrack,
    TimeBufferType: Float32Array,
    ValueBufferType: Float32Array,
    DefaultInterpolation: InterpolateLinear,
    InterpolantFactoryMethodDiscrete: function(result) {
        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodLinear: function(result) {
        return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodSmooth: function(result) {
        return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    setInterpolation: function(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case InterpolateDiscrete:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case InterpolateLinear:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case InterpolateSmooth:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    },
    getInterpolation: function() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return InterpolateDiscrete;
            case this.InterpolantFactoryMethodLinear:
                return InterpolateLinear;
            case this.InterpolantFactoryMethodSmooth:
                return InterpolateSmooth;
        }
    },
    getValueSize: function() {
        return this.values.length / this.times.length;
    },
    // move all keyframes either forwards or backwards in time
    shift: function(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    },
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale: function(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    },
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim: function(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = AnimationUtils.arraySlice(times, from, to);
            this.values = AnimationUtils.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    },
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate: function() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if (AnimationUtils.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    },
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize: function() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = AnimationUtils.arraySlice(this.times), values = AnimationUtils.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== time[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = AnimationUtils.arraySlice(times, 0, writeIndex);
            this.values = AnimationUtils.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    },
    clone: function() {
        const times = AnimationUtils.arraySlice(this.times, 0);
        const values = AnimationUtils.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
});
/**
 * A Track of Boolean keyframe values.
 */ function BooleanKeyframeTrack(name, times, values) {
    KeyframeTrack.call(this, name, times, values);
}
BooleanKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: BooleanKeyframeTrack,
    ValueTypeName: 'bool',
    ValueBufferType: Array,
    DefaultInterpolation: InterpolateDiscrete,
    InterpolantFactoryMethodLinear: undefined,
    InterpolantFactoryMethodSmooth: undefined
});
/**
 * A Track of keyframe values that represent color.
 */ function ColorKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
ColorKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: ColorKeyframeTrack,
    ValueTypeName: 'color'
});
/**
 * A Track of numeric keyframe values.
 */ function NumberKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
NumberKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: NumberKeyframeTrack,
    ValueTypeName: 'number'
});
/**
 * Spherical linear unit quaternion interpolant.
 */ function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
QuaternionLinearInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: QuaternionLinearInterpolant,
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
});
/**
 * A Track of quaternion keyframe values.
 */ function QuaternionKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
QuaternionKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: QuaternionKeyframeTrack,
    ValueTypeName: 'quaternion',
    // ValueBufferType is inherited
    DefaultInterpolation: InterpolateLinear,
    InterpolantFactoryMethodLinear: function(result) {
        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodSmooth: undefined // not yet implemented
});
/**
 * A Track that interpolates Strings
 */ function StringKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
StringKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: StringKeyframeTrack,
    ValueTypeName: 'string',
    ValueBufferType: Array,
    DefaultInterpolation: InterpolateDiscrete,
    InterpolantFactoryMethodLinear: undefined,
    InterpolantFactoryMethodSmooth: undefined
});
/**
 * A Track of vectored keyframe values.
 */ function VectorKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
VectorKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: VectorKeyframeTrack,
    ValueTypeName: 'vector'
});
function AnimationClip(name, duration = -1, tracks, blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = MathUtils.generateUUID();
    // this means it should figure out its duration by scanning the tracks
    if (this.duration < 0) this.resetDuration();
}
function getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return NumberKeyframeTrack;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return VectorKeyframeTrack;
        case 'color':
            return ColorKeyframeTrack;
        case 'quaternion':
            return QuaternionKeyframeTrack;
        case 'bool':
        case 'boolean':
            return BooleanKeyframeTrack;
        case 'string':
            return StringKeyframeTrack;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        AnimationUtils.flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
Object.assign(AnimationClip, {
    parse: function(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new AnimationClip(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    },
    toJSON: function(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push(KeyframeTrack.toJSON(clipTracks[i]));
        return json;
    },
    CreateFromMorphTargetSequence: function(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = AnimationUtils.getKeyframeOrder(times);
            times = AnimationUtils.sortedArray(times, 1, order);
            values = AnimationUtils.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new NumberKeyframeTrack('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new AnimationClip(name, -1, tracks);
    },
    findByName: function(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    },
    CreateClipsFromMorphTargetSequences: function(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(AnimationClip.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    },
    // parse the animation.hierarchy format
    parseAnimation: function(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                AnimationUtils.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack(QuaternionKeyframeTrack, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new AnimationClip(clipName, duration, tracks, blendMode);
        return clip;
    }
});
Object.assign(AnimationClip.prototype, {
    resetDuration: function() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    },
    trim: function() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    },
    validate: function() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    },
    optimize: function() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    },
    clone: function() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new AnimationClip(this.name, this.duration, tracks, this.blendMode);
    },
    toJSON: function() {
        return AnimationClip.toJSON(this);
    }
});
const Cache = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
function LoadingManager(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = undefined;
    const handlers = [];
    // Refer to #5689 for the reason why we don't set .onStart
    // in the constructor
    this.onStart = undefined;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
            if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
        }
        isLoading = true;
    };
    this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
        if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== undefined) scope.onLoad();
        }
    };
    this.itemError = function(url) {
        if (scope.onError !== undefined) scope.onError(url);
    };
    this.resolveURL = function(url) {
        if (urlModifier) return urlModifier(url);
        return url;
    };
    this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
    };
    this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
    };
    this.removeHandler = function(regex) {
        const index = handlers.indexOf(regex);
        if (index !== -1) handlers.splice(index, 2);
        return this;
    };
    this.getHandler = function(file) {
        for(let i = 0, l = handlers.length; i < l; i += 2){
            const regex = handlers[i];
            const loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0; // see #17920
            if (regex.test(file)) return loader;
        }
        return null;
    };
}
const DefaultLoadingManager = new LoadingManager();
function Loader(manager) {
    this.manager = manager !== undefined ? manager : DefaultLoadingManager;
    this.crossOrigin = 'anonymous';
    this.withCredentials = false;
    this.path = '';
    this.resourcePath = '';
    this.requestHeader = {};
}
Object.assign(Loader.prototype, {
    load: function() {},
    loadAsync: function(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    },
    parse: function() {},
    setCrossOrigin: function(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    },
    setWithCredentials: function(value) {
        this.withCredentials = value;
        return this;
    },
    setPath: function(path) {
        this.path = path;
        return this;
    },
    setResourcePath: function(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    },
    setRequestHeader: function(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
});
const loading = {};
function FileLoader(manager) {
    Loader.call(this, manager);
}
FileLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: FileLoader,
    load: function(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if (loading[url] !== undefined) {
            loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Check for data: URI
        const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
        const dataUriRegexResult = url.match(dataUriRegex);
        let request;
        // Safari can not handle Data URIs through XMLHttpRequest so process manually
        if (dataUriRegexResult) {
            const mimeType = dataUriRegexResult[1];
            const isBase64 = !!dataUriRegexResult[2];
            let data = dataUriRegexResult[3];
            data = decodeURIComponent(data);
            if (isBase64) data = atob(data);
            try {
                let response;
                const responseType = (this.responseType || '').toLowerCase();
                switch(responseType){
                    case 'arraybuffer':
                    case 'blob':
                        const view = new Uint8Array(data.length);
                        for(let i = 0; i < data.length; i++)view[i] = data.charCodeAt(i);
                        if (responseType === 'blob') response = new Blob([
                            view.buffer
                        ], {
                            type: mimeType
                        });
                        else response = view.buffer;
                        break;
                    case 'document':
                        const parser = new DOMParser();
                        response = parser.parseFromString(data, mimeType);
                        break;
                    case 'json':
                        response = JSON.parse(data);
                        break;
                    default:
                        response = data;
                        break;
                }
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onLoad) onLoad(response);
                    scope.manager.itemEnd(url);
                }, 0);
            } catch (error) {
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onError) onError(error);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }, 0);
            }
        } else {
            // Initialise array for duplicate requests
            loading[url] = [];
            loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.addEventListener('load', function(event) {
                const response = this.response;
                const callbacks = loading[url];
                delete loading[url];
                if (this.status === 200 || this.status === 0) {
                    // Some browsers return HTTP Status 0 when using non-http protocol
                    // e.g. 'file://' or 'data://'. Handle as success.
                    if (this.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    Cache.add(url, response);
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(response);
                    }
                    scope.manager.itemEnd(url);
                } else {
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onError) callback.onError(event);
                    }
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
            }, false);
            request.addEventListener('progress', function(event) {
                const callbacks = loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onProgress) callback.onProgress(event);
                }
            }, false);
            request.addEventListener('error', function(event) {
                const callbacks = loading[url];
                delete loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            request.addEventListener('abort', function(event) {
                const callbacks = loading[url];
                delete loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            if (this.responseType !== undefined) request.responseType = this.responseType;
            if (this.withCredentials !== undefined) request.withCredentials = this.withCredentials;
            if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== undefined ? this.mimeType : 'text/plain');
            for(const header in this.requestHeader)request.setRequestHeader(header, this.requestHeader[header]);
            request.send(null);
        }
        scope.manager.itemStart(url);
        return request;
    },
    setResponseType: function(value) {
        this.responseType = value;
        return this;
    },
    setMimeType: function(value) {
        this.mimeType = value;
        return this;
    }
});
function AnimationLoader(manager) {
    Loader.call(this, manager);
}
AnimationLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: AnimationLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = AnimationClip.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
});
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ function CompressedTextureLoader(manager) {
    Loader.call(this, manager);
}
CompressedTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: CompressedTextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new CompressedTexture();
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
});
function ImageLoader(manager) {
    Loader.call(this, manager);
}
ImageLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: ImageLoader,
    load: function(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
        function onImageLoad() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            Cache.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.substr(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
});
function CubeTextureLoader(manager) {
    Loader.call(this, manager);
}
CubeTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: CubeTextureLoader,
    load: function(urls, onLoad, onProgress, onError) {
        const texture = new CubeTexture();
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
});
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ function DataTextureLoader(manager) {
    Loader.call(this, manager);
}
DataTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: DataTextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new DataTexture();
        const loader = new FileLoader(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = LinearMipmapLinearFilter; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = LinearFilter;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
});
function TextureLoader(manager) {
    Loader.call(this, manager);
}
TextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: TextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const texture = new Texture();
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
            const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
            texture.format = isJPEG ? RGBFormat : RGBAFormat;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
});
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ function Curve() {
    this.type = 'Curve';
    this.arcLengthDivisions = 200;
}
Object.assign(Curve.prototype, {
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint: function() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    },
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt: function(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    },
    // Get sequence of points using getPoint( t )
    getPoints: function(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    },
    // Get sequence of points using getPointAt( u )
    getSpacedPoints: function(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    },
    // Get total curve arc length
    getLength: function() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    },
    // Get list of cumulative segment lengths
    getLengths: function(divisions) {
        if (divisions === undefined) divisions = this.arcLengthDivisions;
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    },
    updateArcLengths: function() {
        this.needsUpdate = true;
        this.getLengths();
    },
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping: function(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    },
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent: function(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    },
    getTangentAt: function(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    },
    computeFrenetFrames: function(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new Vector3();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new Vector3();
        const mat = new Matrix4();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new Vector3());
            tangents[i].normalize();
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new Vector3();
        binormals[0] = new Vector3();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos(MathUtils.clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos(MathUtils.clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    },
    fromJSON: function(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
});
function EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    Curve.call(this);
    this.type = 'EllipseCurve';
    this.aX = aX || 0;
    this.aY = aY || 0;
    this.xRadius = xRadius || 1;
    this.yRadius = yRadius || 1;
    this.aStartAngle = aStartAngle || 0;
    this.aEndAngle = aEndAngle || 2 * Math.PI;
    this.aClockwise = aClockwise || false;
    this.aRotation = aRotation || 0;
}
EllipseCurve.prototype = Object.create(Curve.prototype);
EllipseCurve.prototype.constructor = EllipseCurve;
EllipseCurve.prototype.isEllipseCurve = true;
EllipseCurve.prototype.getPoint = function(t, optionalTarget) {
    const point = optionalTarget || new Vector2();
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    // ensures that deltaAngle is 0 .. 2 PI
    while(deltaAngle < 0)deltaAngle += twoPi;
    while(deltaAngle > twoPi)deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
        if (samePoints) deltaAngle = 0;
        else deltaAngle = twoPi;
    }
    if (this.aClockwise === true && !samePoints) {
        if (deltaAngle === twoPi) deltaAngle = -twoPi;
        else deltaAngle = deltaAngle - twoPi;
    }
    const angle = this.aStartAngle + t * deltaAngle;
    let x = this.aX + this.xRadius * Math.cos(angle);
    let y = this.aY + this.yRadius * Math.sin(angle);
    if (this.aRotation !== 0) {
        const cos = Math.cos(this.aRotation);
        const sin = Math.sin(this.aRotation);
        const tx = x - this.aX;
        const ty = y - this.aY;
        // Rotate the point about the center of the ellipse.
        x = tx * cos - ty * sin + this.aX;
        y = tx * sin + ty * cos + this.aY;
    }
    return point.set(x, y);
};
EllipseCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
};
EllipseCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
};
EllipseCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
};
function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    EllipseCurve.call(this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.type = 'ArcCurve';
}
ArcCurve.prototype = Object.create(EllipseCurve.prototype);
ArcCurve.prototype.constructor = ArcCurve;
ArcCurve.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const tmp = new Vector3();
const px = new CubicPoly(), py = new CubicPoly(), pz = new CubicPoly();
function CatmullRomCurve3(points = [], closed = false, curveType = 'centripetal', tension = 0.5) {
    Curve.call(this);
    this.type = 'CatmullRomCurve3';
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
}
CatmullRomCurve3.prototype = Object.create(Curve.prototype);
CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;
CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
CatmullRomCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const points = this.points;
    const l = points.length;
    const p = (l - (this.closed ? 0 : 1)) * t;
    let intPoint = Math.floor(p);
    let weight = p - intPoint;
    if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
    else if (weight === 0 && intPoint === l - 1) {
        intPoint = l - 2;
        weight = 1;
    }
    let p0, p3; // 4 points (p1 & p2 defined below)
    if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
    else {
        // extrapolate first point
        tmp.subVectors(points[0], points[1]).add(points[0]);
        p0 = tmp;
    }
    const p1 = points[intPoint % l];
    const p2 = points[(intPoint + 1) % l];
    if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
    else {
        // extrapolate last point
        tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
        p3 = tmp;
    }
    if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
        // init Centripetal / Chordal Catmull-Rom
        const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
        let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
        let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
        let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
        // safety check for repeated points
        if (dt1 < 1e-4) dt1 = 1.0;
        if (dt0 < 1e-4) dt0 = dt1;
        if (dt2 < 1e-4) dt2 = dt1;
        px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
        py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
        pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === 'catmullrom') {
        px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
        py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
        pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
    }
    point.set(px.calc(weight), py.calc(weight), pz.calc(weight));
    return point;
};
CatmullRomCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.points = [];
    for(let i = 0, l = source.points.length; i < l; i++){
        const point = source.points[i];
        this.points.push(point.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
};
CatmullRomCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.points = [];
    for(let i = 0, l = this.points.length; i < l; i++){
        const point = this.points[i];
        data.points.push(point.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
};
CatmullRomCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.points = [];
    for(let i = 0, l = json.points.length; i < l; i++){
        const point = json.points[i];
        this.points.push(new Vector3().fromArray(point));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
};
/**
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */ function CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function QuadraticBezierP2(t, p) {
    return t * t * p;
}
function QuadraticBezier(t, p0, p1, p2) {
    return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
}
//
function CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function CubicBezierP3(t, p) {
    return t * t * t * p;
}
function CubicBezier(t, p0, p1, p2, p3) {
    return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}
function CubicBezierCurve(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2()) {
    Curve.call(this);
    this.type = 'CubicBezierCurve';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
}
CubicBezierCurve.prototype = Object.create(Curve.prototype);
CubicBezierCurve.prototype.constructor = CubicBezierCurve;
CubicBezierCurve.prototype.isCubicBezierCurve = true;
CubicBezierCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
    return point;
};
CubicBezierCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
};
CubicBezierCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
};
CubicBezierCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
};
function CubicBezierCurve3(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3()) {
    Curve.call(this);
    this.type = 'CubicBezierCurve3';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
}
CubicBezierCurve3.prototype = Object.create(Curve.prototype);
CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;
CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;
CubicBezierCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
    return point;
};
CubicBezierCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
};
CubicBezierCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
};
CubicBezierCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
};
function LineCurve(v1 = new Vector2(), v2 = new Vector2()) {
    Curve.call(this);
    this.type = 'LineCurve';
    this.v1 = v1;
    this.v2 = v2;
}
LineCurve.prototype = Object.create(Curve.prototype);
LineCurve.prototype.constructor = LineCurve;
LineCurve.prototype.isLineCurve = true;
LineCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    if (t === 1) point.copy(this.v2);
    else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
    }
    return point;
};
// Line curve is linear, so we can overwrite default getPointAt
LineCurve.prototype.getPointAt = function(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
};
LineCurve.prototype.getTangent = function(t, optionalTarget) {
    const tangent = optionalTarget || new Vector2();
    tangent.copy(this.v2).sub(this.v1).normalize();
    return tangent;
};
LineCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
LineCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
LineCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function LineCurve3(v1 = new Vector3(), v2 = new Vector3()) {
    Curve.call(this);
    this.type = 'LineCurve3';
    this.v1 = v1;
    this.v2 = v2;
}
LineCurve3.prototype = Object.create(Curve.prototype);
LineCurve3.prototype.constructor = LineCurve3;
LineCurve3.prototype.isLineCurve3 = true;
LineCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    if (t === 1) point.copy(this.v2);
    else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
    }
    return point;
};
// Line curve is linear, so we can overwrite default getPointAt
LineCurve3.prototype.getPointAt = function(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
};
LineCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
LineCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
LineCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function QuadraticBezierCurve(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2()) {
    Curve.call(this);
    this.type = 'QuadraticBezierCurve';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
}
QuadraticBezierCurve.prototype = Object.create(Curve.prototype);
QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;
QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;
QuadraticBezierCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));
    return point;
};
QuadraticBezierCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
QuadraticBezierCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
QuadraticBezierCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function QuadraticBezierCurve3(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3()) {
    Curve.call(this);
    this.type = 'QuadraticBezierCurve3';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
}
QuadraticBezierCurve3.prototype = Object.create(Curve.prototype);
QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;
QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;
QuadraticBezierCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));
    return point;
};
QuadraticBezierCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
QuadraticBezierCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
QuadraticBezierCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function SplineCurve(points = []) {
    Curve.call(this);
    this.type = 'SplineCurve';
    this.points = points;
}
SplineCurve.prototype = Object.create(Curve.prototype);
SplineCurve.prototype.constructor = SplineCurve;
SplineCurve.prototype.isSplineCurve = true;
SplineCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const points = this.points;
    const p = (points.length - 1) * t;
    const intPoint = Math.floor(p);
    const weight = p - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
    return point;
};
SplineCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.points = [];
    for(let i = 0, l = source.points.length; i < l; i++){
        const point = source.points[i];
        this.points.push(point.clone());
    }
    return this;
};
SplineCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.points = [];
    for(let i = 0, l = this.points.length; i < l; i++){
        const point = this.points[i];
        data.points.push(point.toArray());
    }
    return data;
};
SplineCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.points = [];
    for(let i = 0, l = json.points.length; i < l; i++){
        const point = json.points[i];
        this.points.push(new Vector2().fromArray(point));
    }
    return this;
};
var Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: ArcCurve,
    CatmullRomCurve3: CatmullRomCurve3,
    CubicBezierCurve: CubicBezierCurve,
    CubicBezierCurve3: CubicBezierCurve3,
    EllipseCurve: EllipseCurve,
    LineCurve: LineCurve,
    LineCurve3: LineCurve3,
    QuadraticBezierCurve: QuadraticBezierCurve,
    QuadraticBezierCurve3: QuadraticBezierCurve3,
    SplineCurve: SplineCurve
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ function CurvePath() {
    Curve.call(this);
    this.type = 'CurvePath';
    this.curves = [];
    this.autoClose = false; // Automatically closes the path
}
CurvePath.prototype = Object.assign(Object.create(Curve.prototype), {
    constructor: CurvePath,
    add: function(curve) {
        this.curves.push(curve);
    },
    closePath: function() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new LineCurve(endPoint, startPoint));
    },
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint: function(t) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    },
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength: function() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    },
    // cacheLengths must be recalculated.
    updateArcLengths: function() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    },
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths: function() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    },
    getSpacedPoints: function(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    },
    getPoints: function(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    },
    copy: function(source) {
        Curve.prototype.copy.call(this, source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    },
    toJSON: function() {
        const data = Curve.prototype.toJSON.call(this);
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    },
    fromJSON: function(json) {
        Curve.prototype.fromJSON.call(this, json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
});
function Path(points) {
    CurvePath.call(this);
    this.type = 'Path';
    this.currentPoint = new Vector2();
    if (points) this.setFromPoints(points);
}
Path.prototype = Object.assign(Object.create(CurvePath.prototype), {
    constructor: Path,
    setFromPoints: function(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    },
    moveTo: function(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    },
    lineTo: function(x, y) {
        const curve = new LineCurve(this.currentPoint.clone(), new Vector2(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    },
    quadraticCurveTo: function(aCPx, aCPy, aX, aY) {
        const curve = new QuadraticBezierCurve(this.currentPoint.clone(), new Vector2(aCPx, aCPy), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    },
    bezierCurveTo: function(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new CubicBezierCurve(this.currentPoint.clone(), new Vector2(aCP1x, aCP1y), new Vector2(aCP2x, aCP2y), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    },
    splineThru: function(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new SplineCurve(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    },
    arc: function(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    },
    absarc: function(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    },
    ellipse: function(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    },
    absellipse: function(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    },
    copy: function(source) {
        CurvePath.prototype.copy.call(this, source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    },
    toJSON: function() {
        const data = CurvePath.prototype.toJSON.call(this);
        data.currentPoint = this.currentPoint.toArray();
        return data;
    },
    fromJSON: function(json) {
        CurvePath.prototype.fromJSON.call(this, json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
});
function Shape(points) {
    Path.call(this, points);
    this.uuid = MathUtils.generateUUID();
    this.type = 'Shape';
    this.holes = [];
}
Shape.prototype = Object.assign(Object.create(Path.prototype), {
    constructor: Shape,
    getPointsHoles: function(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    },
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints: function(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    },
    copy: function(source) {
        Path.prototype.copy.call(this, source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    },
    toJSON: function() {
        const data = Path.prototype.toJSON.call(this);
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    },
    fromJSON: function(json) {
        Path.prototype.fromJSON.call(this, json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new Path().fromJSON(hole));
        }
        return this;
    }
});
function Light(color, intensity = 1) {
    Object3D.call(this);
    this.type = 'Light';
    this.color = new Color(color);
    this.intensity = intensity;
}
Light.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Light,
    isLight: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
});
function HemisphereLight(skyColor, groundColor, intensity) {
    Light.call(this, skyColor, intensity);
    this.type = 'HemisphereLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.groundColor = new Color(groundColor);
}
HemisphereLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: HemisphereLight,
    isHemisphereLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
});
function LightShadow(camera) {
    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.mapSize = new Vector2(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2(1, 1);
    this._viewportCount = 1;
    this._viewports = [
        new Vector4(0, 0, 1, 1)
    ];
}
Object.assign(LightShadow.prototype, {
    _projScreenMatrix: new Matrix4(),
    _lightPositionWorld: new Vector3(),
    _lookTarget: new Vector3(),
    getViewportCount: function() {
        return this._viewportCount;
    },
    getFrustum: function() {
        return this._frustum;
    },
    updateMatrices: function(light) {
        const shadowCamera = this.camera, shadowMatrix = this.matrix, projScreenMatrix = this._projScreenMatrix, lookTarget = this._lookTarget, lightPositionWorld = this._lightPositionWorld;
        lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy(lightPositionWorld);
        lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt(lookTarget);
        shadowCamera.updateMatrixWorld();
        projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(projScreenMatrix);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    },
    getViewport: function(viewportIndex) {
        return this._viewports[viewportIndex];
    },
    getFrameExtents: function() {
        return this._frameExtents;
    },
    copy: function(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    toJSON: function() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
});
function SpotLightShadow() {
    LightShadow.call(this, new PerspectiveCamera(50, 1, 0.5, 500));
    this.focus = 1;
}
SpotLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: SpotLightShadow,
    isSpotLightShadow: true,
    updateMatrices: function(light) {
        const camera = this.camera;
        const fov = MathUtils.RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        LightShadow.prototype.updateMatrices.call(this, light);
    }
});
function SpotLight(color, intensity, distance, angle, penumbra, decay) {
    Light.call(this, color, intensity);
    this.type = 'SpotLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    Object.defineProperty(this, 'power', {
        get: function() {
            // intensity = power per solid angle.
            // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            return this.intensity * Math.PI;
        },
        set: function(power) {
            // intensity = power per solid angle.
            // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            this.intensity = power / Math.PI;
        }
    });
    this.distance = distance !== undefined ? distance : 0;
    this.angle = angle !== undefined ? angle : Math.PI / 3;
    this.penumbra = penumbra !== undefined ? penumbra : 0;
    this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.
    this.shadow = new SpotLightShadow();
}
SpotLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: SpotLight,
    isSpotLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
});
function PointLightShadow() {
    LightShadow.call(this, new PerspectiveCamera(90, 1, 0.5, 500));
    this._frameExtents = new Vector2(4, 2);
    this._viewportCount = 6;
    this._viewports = [
        // These viewports map a cube-map onto a 2D texture with the
        // following orientation:
        //
        //  xzXZ
        //   y Y
        //
        // X - Positive x direction
        // x - Negative x direction
        // Y - Positive y direction
        // y - Negative y direction
        // Z - Positive z direction
        // z - Negative z direction
        // positive X
        new Vector4(2, 1, 1, 1),
        // negative X
        new Vector4(0, 1, 1, 1),
        // positive Z
        new Vector4(3, 1, 1, 1),
        // negative Z
        new Vector4(1, 1, 1, 1),
        // positive Y
        new Vector4(3, 0, 1, 1),
        // negative Y
        new Vector4(1, 0, 1, 1)
    ];
    this._cubeDirections = [
        new Vector3(1, 0, 0),
        new Vector3(-1, 0, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1),
        new Vector3(0, 1, 0),
        new Vector3(0, -1, 0)
    ];
    this._cubeUps = [
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1)
    ];
}
PointLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: PointLightShadow,
    isPointLightShadow: true,
    updateMatrices: function(light, viewportIndex = 0) {
        const camera = this.camera, shadowMatrix = this.matrix, lightPositionWorld = this._lightPositionWorld, lookTarget = this._lookTarget, projScreenMatrix = this._projScreenMatrix;
        lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy(lightPositionWorld);
        lookTarget.copy(camera.position);
        lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt(lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-lightPositionWorld.x, -lightPositionWorld.y, -lightPositionWorld.z);
        projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(projScreenMatrix);
    }
});
function PointLight(color, intensity, distance, decay) {
    Light.call(this, color, intensity);
    this.type = 'PointLight';
    Object.defineProperty(this, 'power', {
        get: function() {
            // intensity = power per solid angle.
            // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            return this.intensity * 4 * Math.PI;
        },
        set: function(power) {
            // intensity = power per solid angle.
            // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            this.intensity = power / (4 * Math.PI);
        }
    });
    this.distance = distance !== undefined ? distance : 0;
    this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.
    this.shadow = new PointLightShadow();
}
PointLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: PointLight,
    isPointLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
});
function OrthographicCamera(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000) {
    Camera.call(this);
    this.type = 'OrthographicCamera';
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
}
OrthographicCamera.prototype = Object.assign(Object.create(Camera.prototype), {
    constructor: OrthographicCamera,
    isOrthographicCamera: true,
    copy: function(source, recursive) {
        Camera.prototype.copy.call(this, source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    },
    setViewOffset: function(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    },
    clearViewOffset: function() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    },
    updateProjectionMatrix: function() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
});
function DirectionalLightShadow() {
    LightShadow.call(this, new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
}
DirectionalLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: DirectionalLightShadow,
    isDirectionalLightShadow: true,
    updateMatrices: function(light) {
        LightShadow.prototype.updateMatrices.call(this, light);
    }
});
function DirectionalLight(color, intensity) {
    Light.call(this, color, intensity);
    this.type = 'DirectionalLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.shadow = new DirectionalLightShadow();
}
DirectionalLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: DirectionalLight,
    isDirectionalLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
});
function AmbientLight(color, intensity) {
    Light.call(this, color, intensity);
    this.type = 'AmbientLight';
}
AmbientLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: AmbientLight,
    isAmbientLight: true
});
function RectAreaLight(color, intensity, width, height) {
    Light.call(this, color, intensity);
    this.type = 'RectAreaLight';
    this.width = width !== undefined ? width : 10;
    this.height = height !== undefined ? height : 10;
}
RectAreaLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: RectAreaLight,
    isRectAreaLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.width = source.width;
        this.height = source.height;
        return this;
    },
    toJSON: function(meta) {
        const data = Light.prototype.toJSON.call(this, meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
});
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class SphericalHarmonics3 {
    constructor(){
        Object.defineProperty(this, 'isSphericalHarmonics3', {
            value: true
        });
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new Vector3());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
function LightProbe(sh, intensity) {
    Light.call(this, undefined, intensity);
    this.type = 'LightProbe';
    this.sh = sh !== undefined ? sh : new SphericalHarmonics3();
}
LightProbe.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: LightProbe,
    isLightProbe: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.sh.copy(source.sh);
        return this;
    },
    fromJSON: function(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    },
    toJSON: function(meta) {
        const data = Light.prototype.toJSON.call(this, meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
});
function MaterialLoader(manager) {
    Loader.call(this, manager);
    this.textures = {};
}
MaterialLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: MaterialLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = new Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = new Color().setHex(json.sheen);
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.skinning !== undefined) material.skinning = json.skinning;
        if (json.morphTargets !== undefined) material.morphTargets = json.morphTargets;
        if (json.morphNormals !== undefined) material.morphNormals = json.morphNormals;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.vertexTangents !== undefined) material.vertexTangents = json.vertexTangents;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new Color().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new Vector2().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new Vector3().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new Vector4().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new Matrix3().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new Matrix4().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new Vector2().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new Vector2().fromArray(json.clearcoatNormalScale);
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        return material;
    },
    setTextures: function(value) {
        this.textures = value;
        return this;
    }
});
const LoaderUtils = {
    decodeText: function(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    },
    extractUrlBase: function(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.substr(0, index + 1);
    }
};
function InstancedBufferGeometry() {
    BufferGeometry.call(this);
    this.type = 'InstancedBufferGeometry';
    this.instanceCount = Infinity;
}
InstancedBufferGeometry.prototype = Object.assign(Object.create(BufferGeometry.prototype), {
    constructor: InstancedBufferGeometry,
    isInstancedBufferGeometry: true,
    copy: function(source) {
        BufferGeometry.prototype.copy.call(this, source);
        this.instanceCount = source.instanceCount;
        return this;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    toJSON: function() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
});
function InstancedBufferAttribute(array, itemSize, normalized, meshPerAttribute) {
    if (typeof normalized === 'number') {
        meshPerAttribute = normalized;
        normalized = false;
        console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
    }
    BufferAttribute.call(this, array, itemSize, normalized);
    this.meshPerAttribute = meshPerAttribute || 1;
}
InstancedBufferAttribute.prototype = Object.assign(Object.create(BufferAttribute.prototype), {
    constructor: InstancedBufferAttribute,
    isInstancedBufferAttribute: true,
    copy: function(source) {
        BufferAttribute.prototype.copy.call(this, source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    },
    toJSON: function() {
        const data = BufferAttribute.prototype.toJSON.call(this);
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
});
function BufferGeometryLoader(manager) {
    Loader.call(this, manager);
}
BufferGeometryLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: BufferGeometryLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = getTypedArray(interleavedBuffer.type, buffer);
            const ib = new InterleavedBuffer(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = getTypedArray(index.type, index.array);
            geometry.setIndex(new BufferAttribute(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new BufferAttribute(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new Vector3();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new Sphere(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
});
class ObjectLoader extends Loader {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new Shape().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new Skeleton().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        let geometryShapes;
        if (json !== undefined) {
            const bufferGeometryLoader = new BufferGeometryLoader();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'PlaneGeometry':
                    case 'PlaneBufferGeometry':
                        geometry = new Geometries[data.type](data.width, data.height, data.widthSegments, data.heightSegments);
                        break;
                    case 'BoxGeometry':
                    case 'BoxBufferGeometry':
                    case 'CubeGeometry':
                        geometry = new Geometries[data.type](data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
                        break;
                    case 'CircleGeometry':
                    case 'CircleBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.segments, data.thetaStart, data.thetaLength);
                        break;
                    case 'CylinderGeometry':
                    case 'CylinderBufferGeometry':
                        geometry = new Geometries[data.type](data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'ConeGeometry':
                    case 'ConeBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'SphereGeometry':
                    case 'SphereBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
                        break;
                    case 'DodecahedronGeometry':
                    case 'DodecahedronBufferGeometry':
                    case 'IcosahedronGeometry':
                    case 'IcosahedronBufferGeometry':
                    case 'OctahedronGeometry':
                    case 'OctahedronBufferGeometry':
                    case 'TetrahedronGeometry':
                    case 'TetrahedronBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.detail);
                        break;
                    case 'RingGeometry':
                    case 'RingBufferGeometry':
                        geometry = new Geometries[data.type](data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
                        break;
                    case 'TorusGeometry':
                    case 'TorusBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
                        break;
                    case 'TorusKnotGeometry':
                    case 'TorusKnotBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
                        break;
                    case 'TubeGeometry':
                    case 'TubeBufferGeometry':
                        // This only works for built-in curves (e.g. CatmullRomCurve3).
                        // User defined curves or instances of CurvePath will not be deserialized.
                        geometry = new Geometries[data.type](new Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
                        break;
                    case 'LatheGeometry':
                    case 'LatheBufferGeometry':
                        geometry = new Geometries[data.type](data.points, data.segments, data.phiStart, data.phiLength);
                        break;
                    case 'PolyhedronGeometry':
                    case 'PolyhedronBufferGeometry':
                        geometry = new Geometries[data.type](data.vertices, data.indices, data.radius, data.details);
                        break;
                    case 'ShapeGeometry':
                    case 'ShapeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        geometry = new Geometries[data.type](geometryShapes, data.curveSegments);
                        break;
                    case 'ExtrudeGeometry':
                    case 'ExtrudeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        const extrudePath = data.options.extrudePath;
                        if (extrudePath !== undefined) data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
                        geometry = new Geometries[data.type](geometryShapes, data.options);
                        break;
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case 'Geometry':
                        console.error('THREE.ObjectLoader: Loading "Geometry" is not supported anymore.');
                        break;
                    default:
                        console.warn('THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"');
                        continue;
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new MaterialLoader();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === 'MultiMaterial') {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = AnimationClip.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new LoadingManager(onLoad);
            loader = new ImageLoader(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new CubeTexture(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new DataTexture(image.data, image.width, image.height);
                else texture = new Texture(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new Scene();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new Color(data.background);
                }
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new FogExp2(data.fog.color, data.fog.density);
                }
                break;
            case 'PerspectiveCamera':
                object = new PerspectiveCamera(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new AmbientLight(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new DirectionalLight(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new PointLight(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new RectAreaLight(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new HemisphereLight(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new LightProbe().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new SkinnedMesh(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new Mesh(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                object = new InstancedMesh(geometry, material, count);
                object.instanceMatrix = new BufferAttribute(new Float32Array(instanceMatrix.array), 16);
                break;
            case 'LOD':
                object = new LOD();
                break;
            case 'Line':
                object = new Line(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new LineLoop(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new LineSegments(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new Points(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new Sprite(getMaterial(data.material));
                break;
            case 'Group':
                object = new Group();
                break;
            case 'Bone':
                object = new Bone();
                break;
            default:
                object = new Object3D();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn('THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().');
        return this.setResourcePath(value);
    }
}
const TEXTURE_MAPPING = {
    UVMapping: UVMapping,
    CubeReflectionMapping: CubeReflectionMapping,
    CubeRefractionMapping: CubeRefractionMapping,
    EquirectangularReflectionMapping: EquirectangularReflectionMapping,
    EquirectangularRefractionMapping: EquirectangularRefractionMapping,
    CubeUVReflectionMapping: CubeUVReflectionMapping,
    CubeUVRefractionMapping: CubeUVRefractionMapping
};
const TEXTURE_WRAPPING = {
    RepeatWrapping: RepeatWrapping,
    ClampToEdgeWrapping: ClampToEdgeWrapping,
    MirroredRepeatWrapping: MirroredRepeatWrapping
};
const TEXTURE_FILTER = {
    NearestFilter: NearestFilter,
    NearestMipmapNearestFilter: NearestMipmapNearestFilter,
    NearestMipmapLinearFilter: NearestMipmapLinearFilter,
    LinearFilter: LinearFilter,
    LinearMipmapNearestFilter: LinearMipmapNearestFilter,
    LinearMipmapLinearFilter: LinearMipmapLinearFilter
};
function ImageBitmapLoader(manager) {
    if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
    if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
    Loader.call(this, manager);
    this.options = {
        premultiplyAlpha: 'none'
    };
}
ImageBitmapLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: ImageBitmapLoader,
    isImageBitmapLoader: true,
    setOptions: function setOptions(options) {
        this.options = options;
        return this;
    },
    load: function(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, scope.options);
        }).then(function(imageBitmap) {
            Cache.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
});
function ShapePath() {
    this.type = 'ShapePath';
    this.color = new Color();
    this.subPaths = [];
    this.currentPath = null;
}
Object.assign(ShapePath.prototype, {
    moveTo: function(x, y) {
        this.currentPath = new Path();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    },
    lineTo: function(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    },
    quadraticCurveTo: function(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    },
    bezierCurveTo: function(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    },
    splineThru: function(pts) {
        this.currentPath.splineThru(pts);
        return this;
    },
    toShapes: function(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new Shape();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = ShapeUtils.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new Shape();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new Shape(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
});
function Font(data) {
    this.type = 'Font';
    this.data = data;
}
Object.assign(Font.prototype, {
    isFont: true,
    generateShapes: function(text, size = 100) {
        const shapes = [];
        const paths = createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)Array.prototype.push.apply(shapes, paths[p].toShapes());
        return shapes;
    }
});
function createPaths(text, size, data) {
    const chars = Array.from ? Array.from(text) : String(text).split(''); // workaround for IE11, see #13988
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === '\n') {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs['?'];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');
        return;
    }
    const path = new ShapePath();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case 'm':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case 'l':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case 'q':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case 'b':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}
function FontLoader(manager) {
    Loader.call(this, manager);
}
FontLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: FontLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            let json;
            try {
                json = JSON.parse(text);
            } catch (e) {
                console.warn('THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.');
                json = JSON.parse(text.substring(65, text.length - 2));
            }
            const font = scope.parse(json);
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    },
    parse: function(json) {
        return new Font(json);
    }
});
let _context;
const AudioContext = {
    getContext: function() {
        if (_context === undefined) _context = new (window.AudioContext || window.webkitAudioContext)();
        return _context;
    },
    setContext: function(value) {
        _context = value;
    }
};
function AudioLoader(manager) {
    Loader.call(this, manager);
}
AudioLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: AudioLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = AudioContext.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
});
function HemisphereLightProbe(skyColor, groundColor, intensity) {
    LightProbe.call(this, undefined, intensity);
    const color1 = new Color().set(skyColor);
    const color2 = new Color().set(groundColor);
    const sky = new Vector3(color1.r, color1.g, color1.b);
    const ground = new Vector3(color2.r, color2.g, color2.b);
    // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
    const c0 = Math.sqrt(Math.PI);
    const c1 = c0 * Math.sqrt(0.75);
    this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
    this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
}
HemisphereLightProbe.prototype = Object.assign(Object.create(LightProbe.prototype), {
    constructor: HemisphereLightProbe,
    isHemisphereLightProbe: true,
    copy: function(source) {
        LightProbe.prototype.copy.call(this, source);
        return this;
    },
    toJSON: function(meta) {
        const data = LightProbe.prototype.toJSON.call(this, meta);
        // data.sh = this.sh.toArray(); // todo
        return data;
    }
});
function AmbientLightProbe(color, intensity) {
    LightProbe.call(this, undefined, intensity);
    const color1 = new Color().set(color);
    // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
    this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
}
AmbientLightProbe.prototype = Object.assign(Object.create(LightProbe.prototype), {
    constructor: AmbientLightProbe,
    isAmbientLightProbe: true,
    copy: function(source) {
        LightProbe.prototype.copy.call(this, source);
        return this;
    },
    toJSON: function(meta) {
        const data = LightProbe.prototype.toJSON.call(this, meta);
        // data.sh = this.sh.toArray(); // todo
        return data;
    }
});
const _eyeRight = new Matrix4();
const _eyeLeft = new Matrix4();
function StereoCamera() {
    this.type = 'StereoCamera';
    this.aspect = 1;
    this.eyeSep = 0.064;
    this.cameraL = new PerspectiveCamera();
    this.cameraL.layers.enable(1);
    this.cameraL.matrixAutoUpdate = false;
    this.cameraR = new PerspectiveCamera();
    this.cameraR.layers.enable(2);
    this.cameraR.matrixAutoUpdate = false;
    this._cache = {
        focus: null,
        fov: null,
        aspect: null,
        near: null,
        far: null,
        zoom: null,
        eyeSep: null
    };
}
Object.assign(StereoCamera.prototype, {
    update: function(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            const projectionMatrix = camera.projectionMatrix.clone();
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan(MathUtils.DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            _eyeLeft.elements[12] = -eyeSepHalf;
            _eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy(projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy(projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
    }
});
class Clock {
    constructor(autoStart){
        this.autoStart = autoStart !== undefined ? autoStart : true;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const _position$2 = /*@__PURE__*/ new Vector3();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();
const _scale$1 = /*@__PURE__*/ new Vector3();
const _orientation = /*@__PURE__*/ new Vector3();
class AudioListener extends Object3D {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = AudioContext.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new Clock();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose(_position$2, _quaternion$3, _scale$1);
        _orientation.set(0, 0, -1).applyQuaternion(_quaternion$3);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime(_position$2.x, endTime);
            listener.positionY.linearRampToValueAtTime(_position$2.y, endTime);
            listener.positionZ.linearRampToValueAtTime(_position$2.z, endTime);
            listener.forwardX.linearRampToValueAtTime(_orientation.x, endTime);
            listener.forwardY.linearRampToValueAtTime(_orientation.y, endTime);
            listener.forwardZ.linearRampToValueAtTime(_orientation.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition(_position$2.x, _position$2.y, _position$2.z);
            listener.setOrientation(_orientation.x, _orientation.y, _orientation.z, up.x, up.y, up.z);
        }
    }
}
class Audio extends Object3D {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const _position$3 = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _orientation$1 = /*@__PURE__*/ new Vector3();
class PositionalAudio extends Audio {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose(_position$3, _quaternion$4, _scale$2);
        _orientation$1.set(0, 0, 1).applyQuaternion(_quaternion$4);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime(_position$3.x, endTime);
            panner.positionY.linearRampToValueAtTime(_position$3.y, endTime);
            panner.positionZ.linearRampToValueAtTime(_position$3.z, endTime);
            panner.orientationX.linearRampToValueAtTime(_orientation$1.x, endTime);
            panner.orientationY.linearRampToValueAtTime(_orientation$1.y, endTime);
            panner.orientationZ.linearRampToValueAtTime(_orientation$1.z, endTime);
        } else {
            panner.setPosition(_position$3.x, _position$3.y, _position$3.z);
            panner.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z);
        }
    }
}
class AudioAnalyser {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
function PropertyMixer(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
    //
    // interpolators can use .buffer as their .result
    // the data then goes to 'incoming'
    //
    // 'accu0' and 'accu1' are used frame-interleaved for
    // the cumulative result and are compared to detect
    // changes
    //
    // 'orig' stores the original state of the property
    //
    // 'add' is used for additive cumulative results
    //
    // 'work' is optional and is only present for quaternion types. It is used
    // to store intermediate quaternion multiplication results
    switch(typeName){
        case 'quaternion':
            mixFunction = this._slerp;
            mixFunctionAdditive = this._slerpAdditive;
            setIdentity = this._setAdditiveIdentityQuaternion;
            this.buffer = new Float64Array(valueSize * 6);
            this._workIndex = 5;
            break;
        case 'string':
        case 'bool':
            mixFunction = this._select;
            // Use the regular mix function and for additive on these types,
            // additive is not relevant for non-numeric types
            mixFunctionAdditive = this._select;
            setIdentity = this._setAdditiveIdentityOther;
            this.buffer = new Array(valueSize * 5);
            break;
        default:
            mixFunction = this._lerp;
            mixFunctionAdditive = this._lerpAdditive;
            setIdentity = this._setAdditiveIdentityNumeric;
            this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
}
Object.assign(PropertyMixer.prototype, {
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate: function(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    },
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive: function(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    },
    // apply the state of 'accu<i>' to the binding when accus differ
    apply: function(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    },
    // remember the state of the bound property and copy it to both accus
    saveOriginalState: function() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    },
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState: function() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    },
    _setAdditiveIdentityNumeric: function() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    },
    _setAdditiveIdentityQuaternion: function() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    },
    _setAdditiveIdentityOther: function() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    },
    // mix functions
    _select: function(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    },
    _slerp: function(buffer, dstOffset, srcOffset, t) {
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    },
    _slerpAdditive: function(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    },
    _lerp: function(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    },
    _lerpAdditive: function(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
});
// Characters [].:/ are reserved for track binding syntax.
const _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const _reservedRe = new RegExp('[' + _RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
const _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const _directoryRe = /((?:WC+[\/:])*)/.source.replace('WC', _wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const _nodeRe = /(WCOD+)?/.source.replace('WCOD', _wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const _objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const _propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);
const _trackRe = new RegExp("^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + '$');
const _supportedObjectNames = [
    'material',
    'materials',
    'bones'
];
function Composite(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
}
Object.assign(Composite.prototype, {
    getValue: function(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    },
    setValue: function(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    },
    bind: function() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    },
    unbind: function() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
});
function PropertyBinding(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
    this.rootNode = rootNode;
}
Object.assign(PropertyBinding, {
    Composite: Composite,
    create: function(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
        else return new PropertyBinding.Composite(root, path, parsedPath);
    },
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ sanitizeNodeName: function(name) {
        return name.replace(/\s/g, '_').replace(_reservedRe, '');
    },
    parseTrackName: function(trackName) {
        const matches = _trackRe.exec(trackName);
        if (!matches) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if (_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    },
    findNode: function(root, nodeName) {
        if (!nodeName || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
});
Object.assign(PropertyBinding.prototype, {
    // these are used to "bind" a nonexistent property
    _getValue_unavailable: function() {},
    _setValue_unavailable: function() {},
    BindingType: {
        Direct: 0,
        EntireArray: 1,
        ArrayElement: 2,
        HasFromToArray: 3
    },
    Versioning: {
        None: 0,
        NeedsUpdate: 1,
        MatrixWorldNeedsUpdate: 2
    },
    GetterByBindingType: [
        function getValue_direct(buffer, offset) {
            buffer[offset] = this.node[this.propertyName];
        },
        function getValue_array(buffer, offset) {
            const source = this.resolvedProperty;
            for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
        },
        function getValue_arrayElement(buffer, offset) {
            buffer[offset] = this.resolvedProperty[this.propertyIndex];
        },
        function getValue_toArray(buffer, offset) {
            this.resolvedProperty.toArray(buffer, offset);
        }
    ],
    SetterByBindingTypeAndVersioning: [
        [
            // Direct
            function setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
            },
            function setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
            },
            function setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // EntireArray
            function setValue_array(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
            },
            function setValue_array_setNeedsUpdate(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.needsUpdate = true;
            },
            function setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // ArrayElement
            function setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
            },
            function setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
            },
            function setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // HasToFromArray
            function setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
            },
            function setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
            },
            function setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ]
    ],
    getValue: function getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    // Note: This class uses a State pattern on a per-method basis:
    // 'bind' sets 'this.getValue' / 'setValue' and shadows the
    // prototype version of these methods with one that represents
    // the bound state. When the property is not found, the methods
    // become no-ops.
    },
    setValue: function getValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    },
    // create getter / setter pair for a property in the scene graph
    bind: function() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.', this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    },
    unbind: function() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
});
// DECLARE ALIAS AFTER assign prototype
Object.assign(PropertyBinding.prototype, {
    // initial state of these methods that calls 'bind'
    _getValue_unbound: PropertyBinding.prototype.getValue,
    _setValue_unbound: PropertyBinding.prototype.setValue
});
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ function AnimationObjectGroup() {
    this.uuid = MathUtils.generateUUID();
    // cached objects followed by the active ones
    this._objects = Array.prototype.slice.call(arguments);
    this.nCachedObjects_ = 0; // threshold
    // note: read by PropertyBinding.Composite
    const indices = {};
    this._indicesByUUID = indices; // for bookkeeping
    for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
    this._paths = []; // inside: string
    this._parsedPaths = []; // inside: { we don't care, here }
    this._bindings = []; // inside: Array< PropertyBinding >
    this._bindingsIndicesByPath = {}; // inside: indices in these arrays
    const scope = this;
    this.stats = {
        objects: {
            get total () {
                return scope._objects.length;
            },
            get inUse () {
                return this.total - scope.nCachedObjects_;
            }
        },
        get bindingsPerObject () {
            return scope._bindings.length;
        }
    };
}
Object.assign(AnimationObjectGroup.prototype, {
    isAnimationObjectGroup: true,
    add: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new PropertyBinding(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new PropertyBinding(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    remove: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    // remove & forget
    uncache: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_: function(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new PropertyBinding(object, path, parsedPath);
        }
        return bindingsForPath;
    },
    unsubscribe_: function(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
});
class AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: ZeroCurvatureEnding,
            endingEnd: ZeroCurvatureEnding
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = LoopRepeat;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case AdditiveAnimationBlendMode:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case NormalAnimationBlendMode:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === LoopPingPong;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === LoopOnce) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = ZeroSlopeEnding;
            settings.endingEnd = ZeroSlopeEnding;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingStart = WrapAroundEnding;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingEnd = WrapAroundEnding;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
function AnimationMixer(root) {
    this._root = root;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1.0;
}
AnimationMixer.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: AnimationMixer,
    _bindAction: function(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) bindings[i] = binding;
            else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new PropertyMixer(PropertyBinding.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    },
    _activateAction: function(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    },
    _deactivateAction: function(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    },
    // Memory manager
    _initMemoryManager: function() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    },
    // Memory management for AnimationAction objects
    _isActiveAction: function(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    },
    _addInactiveAction: function(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    },
    _removeInactiveAction: function(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    },
    _removeInactiveBindingsForAction: function(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    },
    _lendAction: function(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    },
    _takeBackAction: function(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    },
    // Memory management for PropertyMixer objects
    _addInactiveBinding: function(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    },
    _removeInactiveBinding: function(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    },
    _lendBinding: function(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    },
    _takeBackBinding: function(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    },
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant: function() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new LinearInterpolant(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    },
    _takeBackControlInterpolant: function(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    },
    _controlInterpolantsResultBuffer: new Float32Array(1),
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction: function(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = NormalAnimationBlendMode;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    },
    // get an existing action
    existingAction: function(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    },
    // deactivates all previously scheduled actions
    stopAllAction: function() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    },
    // advance the time and update apply the animation
    update: function(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    },
    // Allows you to seek to a specific time in an animation.
    setTime: function(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    },
    // return this mixer's root target object
    getRoot: function() {
        return this._root;
    },
    // free all resources specific to a particular clip
    uncacheClip: function(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    },
    // free all resources specific to a particular root target object
    uncacheRoot: function(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    },
    // remove a targeted clip from the cache
    uncacheAction: function(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
});
class Uniform {
    constructor(value){
        if (typeof value === 'string') {
            console.warn('THREE.Uniform: Type parameter is no longer needed.');
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
function InstancedInterleavedBuffer(array, stride, meshPerAttribute) {
    InterleavedBuffer.call(this, array, stride);
    this.meshPerAttribute = meshPerAttribute || 1;
}
InstancedInterleavedBuffer.prototype = Object.assign(Object.create(InterleavedBuffer.prototype), {
    constructor: InstancedInterleavedBuffer,
    isInstancedInterleavedBuffer: true,
    copy: function(source) {
        InterleavedBuffer.prototype.copy.call(this, source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    },
    clone: function(data) {
        const ib = InterleavedBuffer.prototype.clone.call(this, data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    },
    toJSON: function(data) {
        const json = InterleavedBuffer.prototype.toJSON.call(this, data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
});
function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
    this.buffer = buffer;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count;
    this.version = 0;
}
Object.defineProperty(GLBufferAttribute.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(GLBufferAttribute.prototype, {
    isGLBufferAttribute: true,
    setBuffer: function(buffer) {
        this.buffer = buffer;
        return this;
    },
    setType: function(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    },
    setItemSize: function(itemSize) {
        this.itemSize = itemSize;
        return this;
    },
    setCount: function(count) {
        this.count = count;
        return this;
    }
});
function Raycaster(origin, direction, near, far) {
    this.ray = new Ray(origin, direction);
    // direction is assumed to be normalized (for accurate distance calculations)
    this.near = near || 0;
    this.far = far || Infinity;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
        Mesh: {},
        Line: {
            threshold: 1
        },
        LOD: {},
        Points: {
            threshold: 1
        },
        Sprite: {}
    };
    Object.defineProperties(this.params, {
        PointCloud: {
            get: function() {
                console.warn('THREE.Raycaster: params.PointCloud has been renamed to params.Points.');
                return this.Points;
            }
        }
    });
}
function ascSort(a, b) {
    return a.distance - b.distance;
}
function intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)intersectObject(children[i], raycaster, intersects, true);
    }
}
Object.assign(Raycaster.prototype, {
    set: function(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    },
    setFromCamera: function(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    },
    intersectObject: function(object, recursive, optionalTarget) {
        const intersects = optionalTarget || [];
        intersectObject(object, this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    },
    intersectObjects: function(objects, recursive, optionalTarget) {
        const intersects = optionalTarget || [];
        if (Array.isArray(objects) === false) {
            console.warn('THREE.Raycaster.intersectObjects: objects is not an Array.');
            return intersects;
        }
        for(let i = 0, l = objects.length; i < l; i++)intersectObject(objects[i], this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    }
});
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class Spherical {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos(MathUtils.clamp(y / this.radius, -1, 1));
        }
        return this;
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class Cylindrical {
    constructor(radius, theta, y){
        this.radius = radius !== undefined ? radius : 1.0; // distance from the origin to a point in the x-z plane
        this.theta = theta !== undefined ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y !== undefined ? y : 0; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
}
const _vector$8 = /*@__PURE__*/ new Vector2();
class Box2 {
    constructor(min, max){
        Object.defineProperty(this, 'isBox2', {
            value: true
        });
        this.min = min !== undefined ? min : new Vector2(Infinity, Infinity);
        this.max = max !== undefined ? max : new Vector2(-Infinity, -Infinity);
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = _vector$8.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getCenter() target is now required');
            target = new Vector2();
        }
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getSize() target is now required');
            target = new Vector2();
        }
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box2: .getParameter() target is now required');
            target = new Vector2();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .clampPoint() target is now required');
            target = new Vector2();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = _vector$8.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const _startP = /*@__PURE__*/ new Vector3();
const _startEnd = /*@__PURE__*/ new Vector3();
class Line3 {
    constructor(start, end){
        this.start = start !== undefined ? start : new Vector3();
        this.end = end !== undefined ? end : new Vector3();
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .getCenter() target is now required');
            target = new Vector3();
        }
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .delta() target is now required');
            target = new Vector3();
        }
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .at() target is now required');
            target = new Vector3();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        _startP.subVectors(point, this.start);
        _startEnd.subVectors(this.end, this.start);
        const startEnd2 = _startEnd.dot(_startEnd);
        const startEnd_startP = _startEnd.dot(_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = MathUtils.clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        if (target === undefined) {
            console.warn('THREE.Line3: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
}
function ImmediateRenderObject(material) {
    Object3D.call(this);
    this.material = material;
    this.render = function() {};
    this.hasPositions = false;
    this.hasNormals = false;
    this.hasColors = false;
    this.hasUvs = false;
    this.positionArray = null;
    this.normalArray = null;
    this.colorArray = null;
    this.uvArray = null;
    this.count = 0;
}
ImmediateRenderObject.prototype = Object.create(Object3D.prototype);
ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;
ImmediateRenderObject.prototype.isImmediateRenderObject = true;
const _vector$9 = /*@__PURE__*/ new Vector3();
class SpotLightHelper extends Object3D {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new BufferGeometry();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        this.cone = new LineSegments(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        _vector$9.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt(_vector$9);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const _vector$a = /*@__PURE__*/ new Vector3();
const _boneMatrix = /*@__PURE__*/ new Matrix4();
const _matrixWorldInv = /*@__PURE__*/ new Matrix4();
class SkeletonHelper extends LineSegments {
    constructor(object){
        const bones = getBoneList(object);
        const geometry = new BufferGeometry();
        const vertices = [];
        const colors = [];
        const color1 = new Color(0, 0, 1);
        const color2 = new Color(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = 'SkeletonHelper';
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        _matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
                _vector$a.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j, _vector$a.x, _vector$a.y, _vector$a.z);
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
                _vector$a.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j + 1, _vector$a.x, _vector$a.y, _vector$a.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, getBoneList(object.children[i]));
    return boneList;
}
class PointLightHelper extends Mesh {
    constructor(light, sphereSize, color){
        const geometry = new SphereBufferGeometry(sphereSize, 4, 2);
        const material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const _vector$b = /*@__PURE__*/ new Vector3();
const _color1 = /*@__PURE__*/ new Color();
const _color2 = /*@__PURE__*/ new Color();
class HemisphereLightHelper extends Object3D {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new OctahedronBufferGeometry(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new BufferAttribute(colors, 3));
        this.add(new Mesh(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            _color1.copy(this.light.color);
            _color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? _color1 : _color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt(_vector$b.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class GridHelper extends LineSegments {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
class PolarGridHelper extends LineSegments {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const _v1$6 = /*@__PURE__*/ new Vector3();
const _v2$3 = /*@__PURE__*/ new Vector3();
const _v3$1 = /*@__PURE__*/ new Vector3();
class DirectionalLightHelper extends Object3D {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new Line(geometry, material);
        this.add(this.lightPlane);
        geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new Line(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        _v1$6.setFromMatrixPosition(this.light.matrixWorld);
        _v2$3.setFromMatrixPosition(this.light.target.matrixWorld);
        _v3$1.subVectors(_v2$3, _v1$6);
        this.lightPlane.lookAt(_v2$3);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt(_v2$3);
        this.targetLine.scale.z = _v3$1.length();
    }
}
const _vector$c = /*@__PURE__*/ new Vector3();
const _camera = /*@__PURE__*/ new Camera();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */ class CameraHelper extends LineSegments {
    constructor(camera){
        const geometry = new BufferGeometry();
        const material = new LineBasicMaterial({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new Color(0xffaa00);
        const colorCone = new Color(0xff0000);
        const colorUp = new Color(0x00aaff);
        const colorTarget = new Color(0xffffff);
        const colorCross = new Color(0x333333);
        // near
        addLine('n1', 'n2', colorFrustum);
        addLine('n2', 'n4', colorFrustum);
        addLine('n4', 'n3', colorFrustum);
        addLine('n3', 'n1', colorFrustum);
        // far
        addLine('f1', 'f2', colorFrustum);
        addLine('f2', 'f4', colorFrustum);
        addLine('f4', 'f3', colorFrustum);
        addLine('f3', 'f1', colorFrustum);
        // sides
        addLine('n1', 'f1', colorFrustum);
        addLine('n2', 'f2', colorFrustum);
        addLine('n3', 'f3', colorFrustum);
        addLine('n4', 'f4', colorFrustum);
        // cone
        addLine('p', 'n1', colorCone);
        addLine('p', 'n2', colorCone);
        addLine('p', 'n3', colorCone);
        addLine('p', 'n4', colorCone);
        // up
        addLine('u1', 'u2', colorUp);
        addLine('u2', 'u3', colorUp);
        addLine('u3', 'u1', colorUp);
        // target
        addLine('c', 't', colorTarget);
        addLine('p', 'c', colorCross);
        // cross
        addLine('cn1', 'cn2', colorCross);
        addLine('cn3', 'cn4', colorCross);
        addLine('cf1', 'cf2', colorCross);
        addLine('cf3', 'cf4', colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        setPoint('c', pointMap, geometry, _camera, 0, 0, -1);
        setPoint('t', pointMap, geometry, _camera, 0, 0, 1);
        // near
        setPoint('n1', pointMap, geometry, _camera, -w, -h, -1);
        setPoint('n2', pointMap, geometry, _camera, w, -h, -1);
        setPoint('n3', pointMap, geometry, _camera, -w, h, -1);
        setPoint('n4', pointMap, geometry, _camera, w, h, -1);
        // far
        setPoint('f1', pointMap, geometry, _camera, -w, -h, 1);
        setPoint('f2', pointMap, geometry, _camera, w, -h, 1);
        setPoint('f3', pointMap, geometry, _camera, -w, h, 1);
        setPoint('f4', pointMap, geometry, _camera, w, h, 1);
        // up
        setPoint('u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, -1);
        setPoint('u2', pointMap, geometry, _camera, -w * 0.7, h * 1.1, -1);
        setPoint('u3', pointMap, geometry, _camera, 0, h * 2, -1);
        // cross
        setPoint('cf1', pointMap, geometry, _camera, -w, 0, 1);
        setPoint('cf2', pointMap, geometry, _camera, w, 0, 1);
        setPoint('cf3', pointMap, geometry, _camera, 0, -h, 1);
        setPoint('cf4', pointMap, geometry, _camera, 0, h, 1);
        setPoint('cn1', pointMap, geometry, _camera, -w, 0, -1);
        setPoint('cn2', pointMap, geometry, _camera, w, 0, -1);
        setPoint('cn3', pointMap, geometry, _camera, 0, -h, -1);
        setPoint('cn4', pointMap, geometry, _camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
}
function setPoint(point, pointMap, geometry, camera, x, y, z) {
    _vector$c.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], _vector$c.x, _vector$c.y, _vector$c.z);
    }
}
const _box$3 = /*@__PURE__*/ new Box3();
class BoxHelper extends LineSegments {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) _box$3.setFromObject(this.object);
        if (_box$3.isEmpty()) return;
        const min = _box$3.min;
        const max = _box$3.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        LineSegments.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
}
class Box3Helper extends LineSegments {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class PlaneHelper extends Line {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new BufferGeometry();
        geometry2.setAttribute('position', new Float32BufferAttribute(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new Mesh(geometry2, new MeshBasicMaterial({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? BackSide : FrontSide; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const _axis = /*@__PURE__*/ new Vector3();
let _lineGeometry, _coneGeometry;
class ArrowHelper extends Object3D {
    constructor(dir, origin, length, color, headLength, headWidth){
        super();
        // dir is assumed to be normalized
        this.type = 'ArrowHelper';
        if (dir === undefined) dir = new Vector3(0, 0, 1);
        if (origin === undefined) origin = new Vector3(0, 0, 0);
        if (length === undefined) length = 1;
        if (color === undefined) color = 0xffff00;
        if (headLength === undefined) headLength = 0.2 * length;
        if (headWidth === undefined) headWidth = 0.2 * headLength;
        if (_lineGeometry === undefined) {
            _lineGeometry = new BufferGeometry();
            _lineGeometry.setAttribute('position', new Float32BufferAttribute([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            _coneGeometry = new CylinderBufferGeometry(0, 0.5, 1, 5, 1);
            _coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new Line(_lineGeometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            _axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle(_axis, radians);
        }
    }
    setLength(length, headLength, headWidth) {
        if (headLength === undefined) headLength = 0.2 * length;
        if (headWidth === undefined) headWidth = 0.2 * headLength;
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class AxesHelper extends LineSegments {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
}
const _floatView = new Float32Array(1);
const _int32View = new Int32Array(_floatView.buffer);
const DataUtils = {
    // Converts float32 to float16 (stored as uint16 value).
    toHalfFloat: function(val) {
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ _floatView[0] = val;
        const x = _int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
};
const LOD_MIN = 4;
const LOD_MAX = 8;
const SIZE_MAX = Math.pow(2, LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const TOTAL_LODS = LOD_MAX - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const MAX_SAMPLES = 20;
const ENCODINGS = {
    [LinearEncoding]: 0,
    [sRGBEncoding]: 1,
    [RGBEEncoding]: 2,
    [RGBM7Encoding]: 3,
    [RGBM16Encoding]: 4,
    [RGBDEncoding]: 5,
    [GammaEncoding]: 6
};
const _flatCamera = /*@__PURE__*/ new OrthographicCamera();
const { _lodPlanes, _sizeLods, _sigmas } = /*@__PURE__*/ _createPlanes();
const _clearColor = /*@__PURE__*/ new Color();
let _oldTarget = null;
// Golden Ratio
const PHI = (1 + Math.sqrt(5)) / 2;
const INV_PHI = 1 / PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const _axisDirections = [
    /*@__PURE__*/ new Vector3(1, 1, 1),
    /*@__PURE__*/ new Vector3(-1, 1, 1),
    /*@__PURE__*/ new Vector3(1, 1, -1),
    /*@__PURE__*/ new Vector3(-1, 1, -1),
    /*@__PURE__*/ new Vector3(0, PHI, INV_PHI),
    /*@__PURE__*/ new Vector3(0, PHI, -INV_PHI),
    /*@__PURE__*/ new Vector3(INV_PHI, 0, PHI),
    /*@__PURE__*/ new Vector3(-INV_PHI, 0, PHI),
    /*@__PURE__*/ new Vector3(PHI, INV_PHI, 0),
    /*@__PURE__*/ new Vector3(-PHI, INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 */ class PMREMGenerator {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = _getBlurShader(MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        _oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular) {
        return this._fromTexture(equirectangular);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap) {
        return this._fromTexture(cubemap);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = _getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = _getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < _lodPlanes.length; i++)_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._pingPongRenderTarget.dispose();
        this._renderer.setRenderTarget(_oldTarget);
        outputTarget.scissorTest = false;
        _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture) {
        _oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: NearestFilter,
            minFilter: NearestFilter,
            generateMipmaps: false,
            type: UnsignedByteType,
            format: RGBEFormat,
            encoding: _isLDR(texture) ? texture.encoding : RGBEEncoding,
            depthBuffer: false
        };
        const cubeUVRenderTarget = _createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        this._pingPongRenderTarget = _createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new Mesh(_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, _flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new PerspectiveCamera(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const outputEncoding = renderer.outputEncoding;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor(_clearColor);
        const clearAlpha = renderer.getClearAlpha();
        renderer.toneMapping = NoToneMapping;
        renderer.outputEncoding = LinearEncoding;
        let background = scene.background;
        if (background && background.isColor) {
            background.convertSRGBToLinear();
            // Convert linear to RGBE
            const maxComponent = Math.max(background.r, background.g, background.b);
            const fExp = Math.min(Math.max(Math.ceil(Math.log2(maxComponent)), -128), 127.0);
            background = background.multiplyScalar(Math.pow(2.0, -fExp));
            const alpha = (fExp + 128.0) / 255.0;
            renderer.setClearColor(background, alpha);
            scene.background = null;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col == 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col == 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            _setViewport(cubeUVRenderTarget, col * SIZE_MAX, i > 2 ? SIZE_MAX : 0, SIZE_MAX, SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.outputEncoding = outputEncoding;
        renderer.setClearColor(_clearColor, clearAlpha);
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        if (texture.isCubeTexture) {
            if (this._cubemapShader == null) this._cubemapShader = _getCubemapShader();
        } else if (this._equirectShader == null) this._equirectShader = _getEquirectShader();
        const material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new Mesh(_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        if (!texture.isCubeTexture) uniforms['texelSize'].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        uniforms['inputEncoding'].value = ENCODINGS[texture.encoding];
        uniforms['outputEncoding'].value = ENCODINGS[cubeUVRenderTarget.texture.encoding];
        _setViewport(cubeUVRenderTarget, 0, 0, 3 * SIZE_MAX, 2 * SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, _flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < TOTAL_LODS; i++){
            const sigma = Math.sqrt(_sigmas[i] * _sigmas[i] - _sigmas[i - 1] * _sigmas[i - 1]);
            const poleAxis = _axisDirections[(i - 1) % _axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new Mesh(_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = _sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
        if (samples > MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i == 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = LOD_MAX - lodIn;
        blurUniforms['inputEncoding'].value = ENCODINGS[targetIn.texture.encoding];
        blurUniforms['outputEncoding'].value = ENCODINGS[targetIn.texture.encoding];
        const outputSize = _sizeLods[lodOut];
        const x = 3 * Math.max(0, SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * SIZE_MAX) + 2 * outputSize * (lodOut > LOD_MAX - LOD_MIN ? lodOut - LOD_MAX + LOD_MIN : 0);
        _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, _flatCamera);
    }
}
function _isLDR(texture) {
    if (texture === undefined || texture.type !== UnsignedByteType) return false;
    return texture.encoding === LinearEncoding || texture.encoding === sRGBEncoding || texture.encoding === GammaEncoding;
}
function _createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = LOD_MAX;
    for(let i = 0; i < TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > LOD_MAX - LOD_MIN) sigma = EXTRA_LOD_SIGMA[i - LOD_MAX + LOD_MIN - 1];
        else if (i == 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new BufferGeometry();
        planes.setAttribute('position', new BufferAttribute(position, positionSize));
        planes.setAttribute('uv', new BufferAttribute(uv, uvSize));
        planes.setAttribute('faceIndex', new BufferAttribute(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function _createRenderTarget(params) {
    const cubeUVRenderTarget = new WebGLRenderTarget(3 * SIZE_MAX, 3 * SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function _setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function _getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new Vector3(0, 1, 0);
    const shaderMaterial = new RawShaderMaterial({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': maxSamples
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			${_getEncodings()}

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getEquirectShader() {
    const texelSize = new Vector2(1, 1);
    const shaderMaterial = new RawShaderMaterial({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'texelSize': {
                value: texelSize
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			${_getEncodings()}

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x += texelSize.x;
				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.y += texelSize.y;
				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getCubemapShader() {
    const shaderMaterial = new RawShaderMaterial({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			${_getEncodings()}

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;
				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function _getEncodings() {
    return /* glsl */ `

		uniform int inputEncoding;
		uniform int outputEncoding;

		#include <encodings_pars_fragment>

		vec4 inputTexelToLinear( vec4 value ) {

			if ( inputEncoding == 0 ) {

				return value;

			} else if ( inputEncoding == 1 ) {

				return sRGBToLinear( value );

			} else if ( inputEncoding == 2 ) {

				return RGBEToLinear( value );

			} else if ( inputEncoding == 3 ) {

				return RGBMToLinear( value, 7.0 );

			} else if ( inputEncoding == 4 ) {

				return RGBMToLinear( value, 16.0 );

			} else if ( inputEncoding == 5 ) {

				return RGBDToLinear( value, 256.0 );

			} else {

				return GammaToLinear( value, 2.2 );

			}

		}

		vec4 linearToOutputTexel( vec4 value ) {

			if ( outputEncoding == 0 ) {

				return value;

			} else if ( outputEncoding == 1 ) {

				return LinearTosRGB( value );

			} else if ( outputEncoding == 2 ) {

				return LinearToRGBE( value );

			} else if ( outputEncoding == 3 ) {

				return LinearToRGBM( value, 7.0 );

			} else if ( outputEncoding == 4 ) {

				return LinearToRGBM( value, 16.0 );

			} else if ( outputEncoding == 5 ) {

				return LinearToRGBD( value, 256.0 );

			} else {

				return LinearToGamma( value, 2.2 );

			}

		}

		vec4 envMapTexelToLinear( vec4 color ) {

			return inputTexelToLinear( color );

		}
	`;
}
function Face4(a, b, c, d, normal, color, materialIndex) {
    console.warn('THREE.Face4 has been removed. A THREE.Face3 will be created instead.');
    return new Face3(a, b, c, normal, color, materialIndex);
}
const LineStrip = 0;
const LinePieces = 1;
const NoColors = 0;
const FaceColors = 1;
const VertexColors = 2;
function MeshFaceMaterial(materials) {
    console.warn('THREE.MeshFaceMaterial has been removed. Use an Array instead.');
    return materials;
}
function MultiMaterial(materials = []) {
    console.warn('THREE.MultiMaterial has been removed. Use an Array instead.');
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function PointCloud(geometry, material) {
    console.warn('THREE.PointCloud has been renamed to THREE.Points.');
    return new Points(geometry, material);
}
function Particle(material) {
    console.warn('THREE.Particle has been renamed to THREE.Sprite.');
    return new Sprite(material);
}
function ParticleSystem(geometry, material) {
    console.warn('THREE.ParticleSystem has been renamed to THREE.Points.');
    return new Points(geometry, material);
}
function PointCloudMaterial(parameters) {
    console.warn('THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function ParticleBasicMaterial(parameters) {
    console.warn('THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function ParticleSystemMaterial(parameters) {
    console.warn('THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function Vertex(x, y, z) {
    console.warn('THREE.Vertex has been removed. Use THREE.Vector3 instead.');
    return new Vector3(x, y, z);
}
//
function DynamicBufferAttribute(array, itemSize) {
    console.warn('THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.');
    return new BufferAttribute(array, itemSize).setUsage(DynamicDrawUsage);
}
function Int8Attribute(array, itemSize) {
    console.warn('THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.');
    return new Int8BufferAttribute(array, itemSize);
}
function Uint8Attribute(array, itemSize) {
    console.warn('THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.');
    return new Uint8BufferAttribute(array, itemSize);
}
function Uint8ClampedAttribute(array, itemSize) {
    console.warn('THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.');
    return new Uint8ClampedBufferAttribute(array, itemSize);
}
function Int16Attribute(array, itemSize) {
    console.warn('THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.');
    return new Int16BufferAttribute(array, itemSize);
}
function Uint16Attribute(array, itemSize) {
    console.warn('THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.');
    return new Uint16BufferAttribute(array, itemSize);
}
function Int32Attribute(array, itemSize) {
    console.warn('THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.');
    return new Int32BufferAttribute(array, itemSize);
}
function Uint32Attribute(array, itemSize) {
    console.warn('THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.');
    return new Uint32BufferAttribute(array, itemSize);
}
function Float32Attribute(array, itemSize) {
    console.warn('THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.');
    return new Float32BufferAttribute(array, itemSize);
}
function Float64Attribute(array, itemSize) {
    console.warn('THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.');
    return new Float64BufferAttribute(array, itemSize);
}
//
Curve.create = function(construct, getPoint) {
    console.log('THREE.Curve.create() has been deprecated');
    construct.prototype = Object.create(Curve.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
Object.assign(CurvePath.prototype, {
    createPointsGeometry: function(divisions) {
        console.warn('THREE.CurvePath: .createPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.');
        // generate geometry from path points (for Line or Points objects)
        const pts = this.getPoints(divisions);
        return this.createGeometry(pts);
    },
    createSpacedPointsGeometry: function(divisions) {
        console.warn('THREE.CurvePath: .createSpacedPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.');
        // generate geometry from equidistant sampling along the path
        const pts = this.getSpacedPoints(divisions);
        return this.createGeometry(pts);
    },
    createGeometry: function(points) {
        console.warn('THREE.CurvePath: .createGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.');
        const geometry = new Geometry();
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            geometry.vertices.push(new Vector3(point.x, point.y, point.z || 0));
        }
        return geometry;
    }
});
//
Object.assign(Path.prototype, {
    fromPoints: function(points) {
        console.warn('THREE.Path: .fromPoints() has been renamed to .setFromPoints().');
        return this.setFromPoints(points);
    }
});
//
function ClosedSplineCurve3(points) {
    console.warn('THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
    this.closed = true;
}
ClosedSplineCurve3.prototype = Object.create(CatmullRomCurve3.prototype);
//
function SplineCurve3(points) {
    console.warn('THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
}
SplineCurve3.prototype = Object.create(CatmullRomCurve3.prototype);
//
function Spline(points) {
    console.warn('THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
}
Spline.prototype = Object.create(CatmullRomCurve3.prototype);
Object.assign(Spline.prototype, {
    initFromArray: function() {
        console.error('THREE.Spline: .initFromArray() has been removed.');
    },
    getControlPointsArray: function() {
        console.error('THREE.Spline: .getControlPointsArray() has been removed.');
    },
    reparametrizeByArcLength: function() {
        console.error('THREE.Spline: .reparametrizeByArcLength() has been removed.');
    }
});
//
function AxisHelper(size) {
    console.warn('THREE.AxisHelper has been renamed to THREE.AxesHelper.');
    return new AxesHelper(size);
}
function BoundingBoxHelper(object, color) {
    console.warn('THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.');
    return new BoxHelper(object, color);
}
function EdgesHelper(object, hex) {
    console.warn('THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.');
    return new LineSegments(new EdgesGeometry(object.geometry), new LineBasicMaterial({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
GridHelper.prototype.setColors = function() {
    console.error('THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.');
};
SkeletonHelper.prototype.update = function() {
    console.error('THREE.SkeletonHelper: update() no longer needs to be called.');
};
function WireframeHelper(object, hex) {
    console.warn('THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.');
    return new LineSegments(new WireframeGeometry(object.geometry), new LineBasicMaterial({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
Object.assign(Loader.prototype, {
    extractUrlBase: function(url) {
        console.warn('THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.');
        return LoaderUtils.extractUrlBase(url);
    }
});
Loader.Handlers = {
    add: function() {
        console.error('THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.');
    },
    get: function() {
        console.error('THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.');
    }
};
function XHRLoader(manager) {
    console.warn('THREE.XHRLoader has been renamed to THREE.FileLoader.');
    return new FileLoader(manager);
}
function BinaryTextureLoader(manager) {
    console.warn('THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.');
    return new DataTextureLoader(manager);
}
//
Object.assign(Box2.prototype, {
    center: function(optionalTarget) {
        console.warn('THREE.Box2: .center() has been renamed to .getCenter().');
        return this.getCenter(optionalTarget);
    },
    empty: function() {
        console.warn('THREE.Box2: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    },
    isIntersectionBox: function(box) {
        console.warn('THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    size: function(optionalTarget) {
        console.warn('THREE.Box2: .size() has been renamed to .getSize().');
        return this.getSize(optionalTarget);
    }
});
Object.assign(Box3.prototype, {
    center: function(optionalTarget) {
        console.warn('THREE.Box3: .center() has been renamed to .getCenter().');
        return this.getCenter(optionalTarget);
    },
    empty: function() {
        console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    },
    isIntersectionBox: function(box) {
        console.warn('THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    isIntersectionSphere: function(sphere) {
        console.warn('THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().');
        return this.intersectsSphere(sphere);
    },
    size: function(optionalTarget) {
        console.warn('THREE.Box3: .size() has been renamed to .getSize().');
        return this.getSize(optionalTarget);
    }
});
Object.assign(Sphere.prototype, {
    empty: function() {
        console.warn('THREE.Sphere: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    }
});
Frustum.prototype.setFromMatrix = function(m) {
    console.warn('THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().');
    return this.setFromProjectionMatrix(m);
};
Line3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Line3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
Object.assign(MathUtils, {
    random16: function() {
        console.warn('THREE.Math: .random16() has been deprecated. Use Math.random() instead.');
        return Math.random();
    },
    nearestPowerOfTwo: function(value) {
        console.warn('THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo().');
        return MathUtils.floorPowerOfTwo(value);
    },
    nextPowerOfTwo: function(value) {
        console.warn('THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo().');
        return MathUtils.ceilPowerOfTwo(value);
    }
});
Object.assign(Matrix3.prototype, {
    flattenToArrayOffset: function(array, offset) {
        console.warn('THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
        return this.toArray(array, offset);
    },
    multiplyVector3: function(vector) {
        console.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
        return vector.applyMatrix3(this);
    },
    multiplyVector3Array: function() {
        console.error('THREE.Matrix3: .multiplyVector3Array() has been removed.');
    },
    applyToBufferAttribute: function(attribute) {
        console.warn('THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.');
        return attribute.applyMatrix3(this);
    },
    applyToVector3Array: function() {
        console.error('THREE.Matrix3: .applyToVector3Array() has been removed.');
    },
    getInverse: function(matrix) {
        console.warn('THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
        return this.copy(matrix).invert();
    }
});
Object.assign(Matrix4.prototype, {
    extractPosition: function(m) {
        console.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
        return this.copyPosition(m);
    },
    flattenToArrayOffset: function(array, offset) {
        console.warn('THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
        return this.toArray(array, offset);
    },
    getPosition: function() {
        console.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');
        return new Vector3().setFromMatrixColumn(this, 3);
    },
    setRotationFromQuaternion: function(q) {
        console.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');
        return this.makeRotationFromQuaternion(q);
    },
    multiplyToArray: function() {
        console.warn('THREE.Matrix4: .multiplyToArray() has been removed.');
    },
    multiplyVector3: function(vector) {
        console.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    multiplyVector4: function(vector) {
        console.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    multiplyVector3Array: function() {
        console.error('THREE.Matrix4: .multiplyVector3Array() has been removed.');
    },
    rotateAxis: function(v) {
        console.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');
        v.transformDirection(this);
    },
    crossVector: function(vector) {
        console.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    translate: function() {
        console.error('THREE.Matrix4: .translate() has been removed.');
    },
    rotateX: function() {
        console.error('THREE.Matrix4: .rotateX() has been removed.');
    },
    rotateY: function() {
        console.error('THREE.Matrix4: .rotateY() has been removed.');
    },
    rotateZ: function() {
        console.error('THREE.Matrix4: .rotateZ() has been removed.');
    },
    rotateByAxis: function() {
        console.error('THREE.Matrix4: .rotateByAxis() has been removed.');
    },
    applyToBufferAttribute: function(attribute) {
        console.warn('THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.');
        return attribute.applyMatrix4(this);
    },
    applyToVector3Array: function() {
        console.error('THREE.Matrix4: .applyToVector3Array() has been removed.');
    },
    makeFrustum: function(left, right, bottom, top, near, far) {
        console.warn('THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.');
        return this.makePerspective(left, right, top, bottom, near, far);
    },
    getInverse: function(matrix) {
        console.warn('THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
        return this.copy(matrix).invert();
    }
});
Plane.prototype.isIntersectionLine = function(line) {
    console.warn('THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().');
    return this.intersectsLine(line);
};
Object.assign(Quaternion.prototype, {
    multiplyVector3: function(vector) {
        console.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
        return vector.applyQuaternion(this);
    },
    inverse: function() {
        console.warn('THREE.Quaternion: .inverse() has been renamed to invert().');
        return this.invert();
    }
});
Object.assign(Ray.prototype, {
    isIntersectionBox: function(box) {
        console.warn('THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    isIntersectionPlane: function(plane) {
        console.warn('THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().');
        return this.intersectsPlane(plane);
    },
    isIntersectionSphere: function(sphere) {
        console.warn('THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().');
        return this.intersectsSphere(sphere);
    }
});
Object.assign(Triangle.prototype, {
    area: function() {
        console.warn('THREE.Triangle: .area() has been renamed to .getArea().');
        return this.getArea();
    },
    barycoordFromPoint: function(point, target) {
        console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
        return this.getBarycoord(point, target);
    },
    midpoint: function(target) {
        console.warn('THREE.Triangle: .midpoint() has been renamed to .getMidpoint().');
        return this.getMidpoint(target);
    },
    normal: function(target) {
        console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
        return this.getNormal(target);
    },
    plane: function(target) {
        console.warn('THREE.Triangle: .plane() has been renamed to .getPlane().');
        return this.getPlane(target);
    }
});
Object.assign(Triangle, {
    barycoordFromPoint: function(point, a, b, c, target) {
        console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
        return Triangle.getBarycoord(point, a, b, c, target);
    },
    normal: function(a, b, c, target) {
        console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
        return Triangle.getNormal(a, b, c, target);
    }
});
Object.assign(Shape.prototype, {
    extractAllPoints: function(divisions) {
        console.warn('THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.');
        return this.extractPoints(divisions);
    },
    extrude: function(options) {
        console.warn('THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.');
        return new ExtrudeGeometry(this, options);
    },
    makeGeometry: function(options) {
        console.warn('THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.');
        return new ShapeGeometry(this, options);
    }
});
Object.assign(Vector2.prototype, {
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    distanceToManhattan: function(v) {
        console.warn('THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
        return this.manhattanDistanceTo(v);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
Object.assign(Vector3.prototype, {
    setEulerFromRotationMatrix: function() {
        console.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');
    },
    setEulerFromQuaternion: function() {
        console.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');
    },
    getPositionFromMatrix: function(m) {
        console.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');
        return this.setFromMatrixPosition(m);
    },
    getScaleFromMatrix: function(m) {
        console.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');
        return this.setFromMatrixScale(m);
    },
    getColumnFromMatrix: function(index, matrix) {
        console.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');
        return this.setFromMatrixColumn(matrix, index);
    },
    applyProjection: function(m) {
        console.warn('THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.');
        return this.applyMatrix4(m);
    },
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    distanceToManhattan: function(v) {
        console.warn('THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
        return this.manhattanDistanceTo(v);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
Object.assign(Vector4.prototype, {
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
//
Object.assign(Geometry.prototype, {
    computeTangents: function() {
        console.error('THREE.Geometry: .computeTangents() has been removed.');
    },
    computeLineDistances: function() {
        console.error('THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.');
    },
    applyMatrix: function(matrix) {
        console.warn('THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
});
Object.assign(Object3D.prototype, {
    getChildByName: function(name) {
        console.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
        return this.getObjectByName(name);
    },
    renderDepth: function() {
        console.warn('THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.');
    },
    translate: function(distance, axis) {
        console.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
        return this.translateOnAxis(axis, distance);
    },
    getWorldRotation: function() {
        console.error('THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.');
    },
    applyMatrix: function(matrix) {
        console.warn('THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
});
Object.defineProperties(Object3D.prototype, {
    eulerOrder: {
        get: function() {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            return this.rotation.order;
        },
        set: function(value) {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        },
        set: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        }
    }
});
Object.assign(Mesh.prototype, {
    setDrawMode: function() {
        console.error('THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
    }
});
Object.defineProperties(Mesh.prototype, {
    drawMode: {
        get: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.');
            return TrianglesDrawMode;
        },
        set: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
        }
    }
});
Object.defineProperties(LOD.prototype, {
    objects: {
        get: function() {
            console.warn('THREE.LOD: .objects has been renamed to .levels.');
            return this.levels;
        }
    }
});
Object.defineProperty(Skeleton.prototype, 'useVertexTexture', {
    get: function() {
        console.warn('THREE.Skeleton: useVertexTexture has been removed.');
    },
    set: function() {
        console.warn('THREE.Skeleton: useVertexTexture has been removed.');
    }
});
SkinnedMesh.prototype.initBones = function() {
    console.error('THREE.SkinnedMesh: initBones() has been removed.');
};
Object.defineProperty(Curve.prototype, '__arcLengthDivisions', {
    get: function() {
        console.warn('THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.');
        return this.arcLengthDivisions;
    },
    set: function(value) {
        console.warn('THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.');
        this.arcLengthDivisions = value;
    }
});
//
PerspectiveCamera.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties(Light.prototype, {
    onlyShadow: {
        set: function() {
            console.warn('THREE.Light: .onlyShadow has been removed.');
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFov is now .shadow.camera.fov.');
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraLeft is now .shadow.camera.left.');
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraRight is now .shadow.camera.right.');
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraTop is now .shadow.camera.top.');
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.');
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraNear is now .shadow.camera.near.');
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFar is now .shadow.camera.far.');
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn('THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.');
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn('THREE.Light: .shadowBias is now .shadow.bias.');
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn('THREE.Light: .shadowDarkness has been removed.');
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.');
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.');
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties(BufferAttribute.prototype, {
    length: {
        get: function() {
            console.warn('THREE.BufferAttribute: .length has been deprecated. Use .count instead.');
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            return this.usage === DynamicDrawUsage;
        },
        set: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            this.setUsage(DynamicDrawUsage);
        }
    }
});
Object.assign(BufferAttribute.prototype, {
    setDynamic: function(value) {
        console.warn('THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.');
        this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
        return this;
    },
    copyIndicesArray: function() {
        console.error('THREE.BufferAttribute: .copyIndicesArray() has been removed.');
    },
    setArray: function() {
        console.error('THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
    }
});
Object.assign(BufferGeometry.prototype, {
    addIndex: function(index) {
        console.warn('THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().');
        this.setIndex(index);
    },
    addAttribute: function(name, attribute) {
        console.warn('THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().');
        if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
            console.warn('THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).');
            return this.setAttribute(name, new BufferAttribute(arguments[1], arguments[2]));
        }
        if (name === 'index') {
            console.warn('THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.');
            this.setIndex(attribute);
            return this;
        }
        return this.setAttribute(name, attribute);
    },
    addDrawCall: function(start, count, indexOffset) {
        if (indexOffset !== undefined) console.warn('THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.');
        console.warn('THREE.BufferGeometry: .addDrawCall() is now .addGroup().');
        this.addGroup(start, count);
    },
    clearDrawCalls: function() {
        console.warn('THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().');
        this.clearGroups();
    },
    computeTangents: function() {
        console.warn('THREE.BufferGeometry: .computeTangents() has been removed.');
    },
    computeOffsets: function() {
        console.warn('THREE.BufferGeometry: .computeOffsets() has been removed.');
    },
    removeAttribute: function(name) {
        console.warn('THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().');
        return this.deleteAttribute(name);
    },
    applyMatrix: function(matrix) {
        console.warn('THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
});
Object.defineProperties(BufferGeometry.prototype, {
    drawcalls: {
        get: function() {
            console.error('THREE.BufferGeometry: .drawcalls has been renamed to .groups.');
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn('THREE.BufferGeometry: .offsets has been renamed to .groups.');
            return this.groups;
        }
    }
});
Object.defineProperties(InstancedBufferGeometry.prototype, {
    maxInstancedCount: {
        get: function() {
            console.warn('THREE.InstancedBufferGeometry: .maxInstancedCount has been renamed to .instanceCount.');
            return this.instanceCount;
        },
        set: function(value) {
            console.warn('THREE.InstancedBufferGeometry: .maxInstancedCount has been renamed to .instanceCount.');
            this.instanceCount = value;
        }
    }
});
Object.defineProperties(Raycaster.prototype, {
    linePrecision: {
        get: function() {
            console.warn('THREE.Raycaster: .linePrecision has been deprecated. Use .params.Line.threshold instead.');
            return this.params.Line.threshold;
        },
        set: function(value) {
            console.warn('THREE.Raycaster: .linePrecision has been deprecated. Use .params.Line.threshold instead.');
            this.params.Line.threshold = value;
        }
    }
});
Object.defineProperties(InterleavedBuffer.prototype, {
    dynamic: {
        get: function() {
            console.warn('THREE.InterleavedBuffer: .length has been deprecated. Use .usage instead.');
            return this.usage === DynamicDrawUsage;
        },
        set: function(value) {
            console.warn('THREE.InterleavedBuffer: .length has been deprecated. Use .usage instead.');
            this.setUsage(value);
        }
    }
});
Object.assign(InterleavedBuffer.prototype, {
    setDynamic: function(value) {
        console.warn('THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.');
        this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
        return this;
    },
    setArray: function() {
        console.error('THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
    }
});
//
Object.assign(ExtrudeBufferGeometry.prototype, {
    getArrays: function() {
        console.error('THREE.ExtrudeBufferGeometry: .getArrays() has been removed.');
    },
    addShapeList: function() {
        console.error('THREE.ExtrudeBufferGeometry: .addShapeList() has been removed.');
    },
    addShape: function() {
        console.error('THREE.ExtrudeBufferGeometry: .addShape() has been removed.');
    }
});
//
Object.assign(Scene.prototype, {
    dispose: function() {
        console.error('THREE.Scene: .dispose() has been removed.');
    }
});
//
Object.defineProperties(Uniform.prototype, {
    dynamic: {
        set: function() {
            console.warn('THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.');
        }
    },
    onUpdate: {
        value: function() {
            console.warn('THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.');
            return this;
        }
    }
});
//
Object.defineProperties(Material.prototype, {
    wrapAround: {
        get: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        }
    },
    overdraw: {
        get: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        }
    },
    wrapRGB: {
        get: function() {
            console.warn('THREE.Material: .wrapRGB has been removed.');
            return new Color();
        }
    },
    shading: {
        get: function() {
            console.error('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
            this.flatShading = value === FlatShading;
        }
    },
    stencilMask: {
        get: function() {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            this.stencilFuncMask = value;
        }
    }
});
Object.defineProperties(MeshPhongMaterial.prototype, {
    metal: {
        get: function() {
            console.warn('THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.');
            return false;
        },
        set: function() {
            console.warn('THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead');
        }
    }
});
Object.defineProperties(MeshPhysicalMaterial.prototype, {
    transparency: {
        get: function() {
            console.warn('THREE.MeshPhysicalMaterial: .transparency has been renamed to .transmission.');
            return this.transmission;
        },
        set: function(value) {
            console.warn('THREE.MeshPhysicalMaterial: .transparency has been renamed to .transmission.');
            this.transmission = value;
        }
    }
});
Object.defineProperties(ShaderMaterial.prototype, {
    derivatives: {
        get: function() {
            console.warn('THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn('THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            this.extensions.derivatives = value;
        }
    }
});
//
Object.assign(WebGLRenderer.prototype, {
    clearTarget: function(renderTarget, color, depth, stencil) {
        console.warn('THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.');
        this.setRenderTarget(renderTarget);
        this.clear(color, depth, stencil);
    },
    animate: function(callback) {
        console.warn('THREE.WebGLRenderer: .animate() is now .setAnimationLoop().');
        this.setAnimationLoop(callback);
    },
    getCurrentRenderTarget: function() {
        console.warn('THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().');
        return this.getRenderTarget();
    },
    getMaxAnisotropy: function() {
        console.warn('THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().');
        return this.capabilities.getMaxAnisotropy();
    },
    getPrecision: function() {
        console.warn('THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.');
        return this.capabilities.precision;
    },
    resetGLState: function() {
        console.warn('THREE.WebGLRenderer: .resetGLState() is now .state.reset().');
        return this.state.reset();
    },
    supportsFloatTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).');
        return this.extensions.get('OES_texture_float');
    },
    supportsHalfFloatTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).');
        return this.extensions.get('OES_texture_half_float');
    },
    supportsStandardDerivatives: function() {
        console.warn('THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).');
        return this.extensions.get('OES_standard_derivatives');
    },
    supportsCompressedTextureS3TC: function() {
        console.warn('THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).');
        return this.extensions.get('WEBGL_compressed_texture_s3tc');
    },
    supportsCompressedTexturePVRTC: function() {
        console.warn('THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).');
        return this.extensions.get('WEBGL_compressed_texture_pvrtc');
    },
    supportsBlendMinMax: function() {
        console.warn('THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).');
        return this.extensions.get('EXT_blend_minmax');
    },
    supportsVertexTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.');
        return this.capabilities.vertexTextures;
    },
    supportsInstancedArrays: function() {
        console.warn('THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).');
        return this.extensions.get('ANGLE_instanced_arrays');
    },
    enableScissorTest: function(boolean) {
        console.warn('THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().');
        this.setScissorTest(boolean);
    },
    initMaterial: function() {
        console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.');
    },
    addPrePlugin: function() {
        console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.');
    },
    addPostPlugin: function() {
        console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.');
    },
    updateShadowMap: function() {
        console.warn('THREE.WebGLRenderer: .updateShadowMap() has been removed.');
    },
    setFaceCulling: function() {
        console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.');
    },
    allocTextureUnit: function() {
        console.warn('THREE.WebGLRenderer: .allocTextureUnit() has been removed.');
    },
    setTexture: function() {
        console.warn('THREE.WebGLRenderer: .setTexture() has been removed.');
    },
    setTexture2D: function() {
        console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.');
    },
    setTextureCube: function() {
        console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.');
    },
    getActiveMipMapLevel: function() {
        console.warn('THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().');
        return this.getActiveMipmapLevel();
    }
});
Object.defineProperties(WebGLRenderer.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.');
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.');
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    context: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.');
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr');
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
            return false;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
        }
    },
    gammaOutput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            return false;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
            return 1.0;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
        }
    }
});
Object.defineProperties(WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
        }
    }
});
function WebGLRenderTargetCube(width, height, options) {
    console.warn('THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).');
    return new WebGLCubeRenderTarget(width, options);
}
//
Object.defineProperties(WebGLRenderTarget.prototype, {
    wrapS: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            return this.texture.offset;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            return this.texture.format;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            return this.texture.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            this.texture.generateMipmaps = value;
        }
    }
});
//
Object.defineProperties(Audio.prototype, {
    load: {
        value: function(file) {
            console.warn('THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.');
            const scope = this;
            const audioLoader = new AudioLoader();
            audioLoader.load(file, function(buffer) {
                scope.setBuffer(buffer);
            });
            return this;
        }
    },
    startTime: {
        set: function() {
            console.warn('THREE.Audio: .startTime is now .play( delay ).');
        }
    }
});
AudioAnalyser.prototype.getData = function() {
    console.warn('THREE.AudioAnalyser: .getData() is now .getFrequencyData().');
    return this.getFrequencyData();
};
//
CubeCamera.prototype.updateCubeMap = function(renderer, scene) {
    console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().');
    return this.update(renderer, scene);
};
CubeCamera.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn('THREE.CubeCamera: .clear() is now .renderTarget.clear().');
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
//
const GeometryUtils = {
    merge: function(geometry1, geometry2, materialIndexOffset) {
        console.warn('THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.');
        let matrix;
        if (geometry2.isMesh) {
            geometry2.matrixAutoUpdate && geometry2.updateMatrix();
            matrix = geometry2.matrix;
            geometry2 = geometry2.geometry;
        }
        geometry1.merge(geometry2, matrix, materialIndexOffset);
    },
    center: function(geometry) {
        console.warn('THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.');
        return geometry.center();
    }
};
ImageUtils.crossOrigin = undefined;
ImageUtils.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.');
    const loader = new TextureLoader();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
ImageUtils.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.');
    const loader = new CubeTextureLoader();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
ImageUtils.loadCompressedTexture = function() {
    console.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');
};
ImageUtils.loadCompressedTextureCube = function() {
    console.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');
};
//
function CanvasRenderer() {
    console.error('THREE.CanvasRenderer has been removed');
}
//
function JSONLoader() {
    console.error('THREE.JSONLoader has been removed.');
}
//
const SceneUtils = {
    createMultiMaterialObject: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    detach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    attach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    }
};
//
function LensFlare() {
    console.error('THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js');
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') /* eslint-disable no-undef */ __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: REVISION
    }
}));

});

parcelRegister("j3P4n", function(module, exports) {
'use strict';

module.exports = (parcelRequire("NPs5k"));

});
parcelRegister("NPs5k", function(module, exports) {
/** @license React v0.24.0
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';





module.exports = function $$$reconciler($$$hostConfig) {
    'use strict';
    var _assign = (parcelRequire("7oJ2w"));
    var React = (parcelRequire("J42oT"));
    var checkPropTypes = (parcelRequire("dMZkM"));
    var Scheduler = (parcelRequire("1qOd3"));
    var tracing = (parcelRequire("kAmta"));
    // Do not require this module directly! Use normal `invariant` calls with
    // template literal strings. The messages will be replaced with error codes
    // during build.
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ /**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var warningWithoutStack = function() {};
    warningWithoutStack = function(condition, format) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        if (format === undefined) throw new Error("`warningWithoutStack(condition, format, ...args)` requires a warning message argument");
        if (args.length > 8) // Check before the condition to catch violations early.
        throw new Error('warningWithoutStack() currently supports at most 8 arguments.');
        if (condition) return;
        if (typeof console !== 'undefined') {
            var argsWithFormat = args.map(function(item) {
                return '' + item;
            });
            argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
            // breaks IE9: https://github.com/facebook/react/issues/13610
            Function.prototype.apply.call(console.error, console, argsWithFormat);
        }
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function() {
                return args[argIndex++];
            });
            throw new Error(message);
        } catch (x) {}
    };
    var warningWithoutStack$1 = warningWithoutStack;
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ /**
 * This API should be called `delete` but we'd have to make sure to always
 * transform these to strings for IE support. When this transform is fully
 * supported we can rename it.
 */ function get(key) {
        return key._reactInternalFiber;
    }
    function set(key, value) {
        key._reactInternalFiber = value;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
    // Current owner and dispatcher used to share the same ref,
    // but PR #14548 split them out to better support the react-debug-tools package.
    if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) ReactSharedInternals.ReactCurrentDispatcher = {
        current: null
    };
    if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) ReactSharedInternals.ReactCurrentBatchConfig = {
        suspense: null
    };
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var warning = warningWithoutStack$1;
    warning = function(condition, format) {
        if (condition) return;
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum(); // eslint-disable-next-line react-internal/warning-and-invariant-args
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        warningWithoutStack$1.apply(void 0, [
            false,
            format + '%s'
        ].concat(args, [
            stack
        ]));
    };
    var warning$1 = warning;
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
    }
    function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
            lazyComponent._status = Pending;
            var ctor = lazyComponent._ctor;
            var thenable = ctor();
            lazyComponent._result = thenable;
            thenable.then(function(moduleObject) {
                if (lazyComponent._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) warning$1(false, "lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    lazyComponent._status = Resolved;
                    lazyComponent._result = defaultExport;
                }
            }, function(error) {
                if (lazyComponent._status === Pending) {
                    lazyComponent._status = Rejected;
                    lazyComponent._result = error;
                }
            });
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') warningWithoutStack$1(false, "Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
                return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_LAZY_TYPE:
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) return getComponentName(resolvedThenable);
                break;
        }
        return null;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoEffect = /*              */ 0;
    var PerformedWork = /*         */ 1; // You can change the rest (and add more).
    var Placement = /*             */ 2;
    var Update = /*                */ 4;
    var PlacementAndUpdate = /*    */ 6;
    var Deletion = /*              */ 8;
    var ContentReset = /*          */ 16;
    var Callback = /*              */ 32;
    var DidCapture = /*            */ 64;
    var Ref = /*                   */ 128;
    var Snapshot = /*              */ 256;
    var Passive = /*               */ 512;
    var Hydrating = /*             */ 1024;
    var HydratingAndUpdate = /*    */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*   */ 932; // Union of all host effects
    var HostEffectMask = /*        */ 2047;
    var Incomplete = /*            */ 2048;
    var ShouldCapture = /*         */ 4096;
    var enableUserTimingAPI = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    // reducers by double invoking them in Strict Mode.
    var debugRenderPhaseSideEffectsForStrictMode = true; // To preserve the "Pause on caught exceptions" behavior of the debugger, we
    // replay the begin phase of a failed component inside invokeGuardedCallback.
    var replayFailedUnitOfWorkWithInvokeGuardedCallback = true; // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:
    var warnAboutDeprecatedLifecycles = true; // Gather advanced timing metrics for Profiler subtrees.
    var enableProfilerTimer = true; // Trace which interactions trigger each commit.
    var enableSchedulerTracing = true; // SSR experiments
    var enableSuspenseServerRenderer = false;
    // Only used in www builds.
    // Only used in www builds.
    // Disable javascript: URL strings in href for XSS protection.
    // React Fire: prevent the value and checked attributes from syncing
    // with their related DOM properties
    // These APIs will no longer be "unstable" in the upcoming 16.7 release,
    // Control this behavior with a flag to support 16.6 minor releases in the meanwhile.
    // Experimental React Flare event system and event components support.
    var enableFlareAPI = false; // Experimental Host Component support.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var enableScopeAPI = false; // New API for JSX transforms to target - https://github.com/reactjs/rfcs/pull/107
    // We will enforce mocking scheduler with scheduler/unstable_mock at some point. (v17?)
    // Till then, we warn about the missing mock, but still fallback to a legacy mode compatible version
    var warnAboutUnmockedScheduler = false; // For tests, we flush suspense fallbacks in an act scope;
    // *except* in some of our own tests, where we test incremental loading states.
    var flushSuspenseFallbacksInTests = true; // Add a callback property to suspense to notify which promises are currently
    // in the update queue. This allows reporting and tracing of what is causing
    // the user to see a loading state.
    // Also allows hydration callbacks to fire when a dehydrated boundary gets
    // hydrated or deleted.
    var enableSuspenseCallback = false; // Part of the simplification of React.createElement so we can eventually move
    // from React.createElement to React.jsx
    // https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md
    var warnAboutDefaultPropsOnFunctionComponents = false;
    var warnAboutStringRefs = false;
    var disableLegacyContext = false;
    var disableSchedulerTimeoutBasedOnReactExpirationTime = false;
    // Flag to turn event.target and event.currentTarget in ReactNative from a reactTag to a component instance
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            !instance._warnedAboutRefsInRender && warningWithoutStack$1(false, "%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI && node.tag === FundamentalComponent) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    // This is a host config that's used for the `react-reconciler` package on npm.
    // It is only used by third-party renderers.
    //
    // Its API lets you pass the host config as an argument.
    // However, inside the `react-reconciler` we treat host config as a module.
    // This file is a shim between two worlds.
    //
    // It works because the `react-reconciler` bundle is wrapped in something like:
    //
    // module.exports = function ($$$config) {
    //   /* reconciler code */
    // }
    //
    // So `$$$config` looks like a global variable, but it's
    // really an argument to a top-level wrapping function.
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    // eslint-disable-line no-undef
    var getPublicInstance = $$$hostConfig.getPublicInstance;
    var getRootHostContext = $$$hostConfig.getRootHostContext;
    var getChildHostContext = $$$hostConfig.getChildHostContext;
    var prepareForCommit = $$$hostConfig.prepareForCommit;
    var resetAfterCommit = $$$hostConfig.resetAfterCommit;
    var createInstance = $$$hostConfig.createInstance;
    var appendInitialChild = $$$hostConfig.appendInitialChild;
    var finalizeInitialChildren = $$$hostConfig.finalizeInitialChildren;
    var prepareUpdate = $$$hostConfig.prepareUpdate;
    var shouldSetTextContent = $$$hostConfig.shouldSetTextContent;
    var shouldDeprioritizeSubtree = $$$hostConfig.shouldDeprioritizeSubtree;
    var createTextInstance = $$$hostConfig.createTextInstance;
    var scheduleTimeout = $$$hostConfig.setTimeout;
    var cancelTimeout = $$$hostConfig.clearTimeout;
    var noTimeout = $$$hostConfig.noTimeout;
    var now = $$$hostConfig.now;
    var isPrimaryRenderer = $$$hostConfig.isPrimaryRenderer;
    var warnsIfNotActing = $$$hostConfig.warnsIfNotActing;
    var supportsMutation = $$$hostConfig.supportsMutation;
    var supportsPersistence = $$$hostConfig.supportsPersistence;
    var supportsHydration = $$$hostConfig.supportsHydration;
    var mountResponderInstance = $$$hostConfig.mountResponderInstance;
    var unmountResponderInstance = $$$hostConfig.unmountResponderInstance;
    var getFundamentalComponentInstance = $$$hostConfig.getFundamentalComponentInstance;
    var mountFundamentalComponent = $$$hostConfig.mountFundamentalComponent;
    var shouldUpdateFundamentalComponent = $$$hostConfig.shouldUpdateFundamentalComponent;
    var getInstanceFromNode = $$$hostConfig.getInstanceFromNode; // -------------------
    //      Mutation
    //     (optional)
    // -------------------
    var appendChild = $$$hostConfig.appendChild;
    var appendChildToContainer = $$$hostConfig.appendChildToContainer;
    var commitTextUpdate = $$$hostConfig.commitTextUpdate;
    var commitMount = $$$hostConfig.commitMount;
    var commitUpdate = $$$hostConfig.commitUpdate;
    var insertBefore = $$$hostConfig.insertBefore;
    var insertInContainerBefore = $$$hostConfig.insertInContainerBefore;
    var removeChild = $$$hostConfig.removeChild;
    var removeChildFromContainer = $$$hostConfig.removeChildFromContainer;
    var resetTextContent = $$$hostConfig.resetTextContent;
    var hideInstance = $$$hostConfig.hideInstance;
    var hideTextInstance = $$$hostConfig.hideTextInstance;
    var unhideInstance = $$$hostConfig.unhideInstance;
    var unhideTextInstance = $$$hostConfig.unhideTextInstance;
    var updateFundamentalComponent = $$$hostConfig.updateFundamentalComponent;
    var unmountFundamentalComponent = $$$hostConfig.unmountFundamentalComponent; // -------------------
    //     Persistence
    //     (optional)
    // -------------------
    var cloneInstance = $$$hostConfig.cloneInstance;
    var createContainerChildSet = $$$hostConfig.createContainerChildSet;
    var appendChildToContainerChildSet = $$$hostConfig.appendChildToContainerChildSet;
    var finalizeContainerChildren = $$$hostConfig.finalizeContainerChildren;
    var replaceContainerChildren = $$$hostConfig.replaceContainerChildren;
    var cloneHiddenInstance = $$$hostConfig.cloneHiddenInstance;
    var cloneHiddenTextInstance = $$$hostConfig.cloneHiddenTextInstance;
    var cloneFundamentalInstance = $$$hostConfig.cloneInstance; // -------------------
    //     Hydration
    //     (optional)
    // -------------------
    var canHydrateInstance = $$$hostConfig.canHydrateInstance;
    var canHydrateTextInstance = $$$hostConfig.canHydrateTextInstance;
    var canHydrateSuspenseInstance = $$$hostConfig.canHydrateSuspenseInstance;
    var isSuspenseInstancePending = $$$hostConfig.isSuspenseInstancePending;
    var isSuspenseInstanceFallback = $$$hostConfig.isSuspenseInstanceFallback;
    var registerSuspenseInstanceRetry = $$$hostConfig.registerSuspenseInstanceRetry;
    var getNextHydratableSibling = $$$hostConfig.getNextHydratableSibling;
    var getFirstHydratableChild = $$$hostConfig.getFirstHydratableChild;
    var hydrateInstance = $$$hostConfig.hydrateInstance;
    var hydrateTextInstance = $$$hostConfig.hydrateTextInstance;
    var hydrateSuspenseInstance = $$$hostConfig.hydrateSuspenseInstance;
    var getNextHydratableInstanceAfterSuspenseInstance = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance;
    var commitHydratedContainer = $$$hostConfig.commitHydratedContainer;
    var commitHydratedSuspenseInstance = $$$hostConfig.commitHydratedSuspenseInstance;
    var clearSuspenseBoundary = $$$hostConfig.clearSuspenseBoundary;
    var clearSuspenseBoundaryFromContainer = $$$hostConfig.clearSuspenseBoundaryFromContainer;
    var didNotMatchHydratedContainerTextInstance = $$$hostConfig.didNotMatchHydratedContainerTextInstance;
    var didNotMatchHydratedTextInstance = $$$hostConfig.didNotMatchHydratedTextInstance;
    var didNotHydrateContainerInstance = $$$hostConfig.didNotHydrateContainerInstance;
    var didNotHydrateInstance = $$$hostConfig.didNotHydrateInstance;
    var didNotFindHydratableContainerInstance = $$$hostConfig.didNotFindHydratableContainerInstance;
    var didNotFindHydratableContainerTextInstance = $$$hostConfig.didNotFindHydratableContainerTextInstance;
    var didNotFindHydratableContainerSuspenseInstance = $$$hostConfig.didNotFindHydratableContainerSuspenseInstance;
    var didNotFindHydratableInstance = $$$hostConfig.didNotFindHydratableInstance;
    var didNotFindHydratableTextInstance = $$$hostConfig.didNotFindHydratableTextInstance;
    var didNotFindHydratableSuspenseInstance = $$$hostConfig.didNotFindHydratableSuspenseInstance;
    var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
    var describeComponentFrame = function(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, '');
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                    var pathBeforeSlash = match[1];
                    if (pathBeforeSlash) {
                        var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                        fileName = folderName + '/' + fileName;
                    }
                }
            }
            sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) sourceInfo = ' (created by ' + ownerName + ')';
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
    };
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function describeFiber(fiber) {
        switch(fiber.tag){
            case HostRoot:
            case HostPortal:
            case HostText:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
                return '';
            default:
                var owner = fiber._debugOwner;
                var source = fiber._debugSource;
                var name = getComponentName(fiber.type);
                var ownerName = null;
                if (owner) ownerName = getComponentName(owner.type);
                return describeComponentFrame(name, source, ownerName);
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;
        do {
            info += describeFiber(node);
            node = node.return;
        }while (node);
        return info;
    }
    var current = null;
    var phase = null;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        phase = null;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        phase = null;
    }
    function setCurrentPhase(lifeCyclePhase) {
        phase = lifeCyclePhase;
    }
    // Prefix measurements so that it's possible to filter them.
    // Longer prefixes are hard to read in DevTools.
    var reactEmoji = "\u269B";
    var warningEmoji = "\u26D4";
    var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
    // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?
    var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
    // Reusing `currentFiber` would be confusing for this because user code fiber
    // can change during commit phase too, but we don't need to unwind it (since
    // lifecycles in the commit phase don't resemble a tree).
    var currentPhase = null;
    var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
    // so we will keep track of it, and include it in the report.
    // Track commits caused by cascading updates.
    var isCommitting = false;
    var hasScheduledUpdateInCurrentCommit = false;
    var hasScheduledUpdateInCurrentPhase = false;
    var commitCountInCurrentWorkLoop = 0;
    var effectCountInCurrentCommit = 0;
    // to avoid stretch the commit phase with measurement overhead.
    var labelsInCurrentCommit = new Set();
    var formatMarkName = function(markName) {
        return reactEmoji + " " + markName;
    };
    var formatLabel = function(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : '';
        return "" + prefix + label + suffix;
    };
    var beginMark = function(markName) {
        performance.mark(formatMarkName(markName));
    };
    var clearMark = function(markName) {
        performance.clearMarks(formatMarkName(markName));
    };
    var endMark = function(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
            performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.
        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
    };
    var getFiberMarkName = function(label, debugID) {
        return label + " (#" + debugID + ")";
    };
    var getFiberLabel = function(componentName, isMounted, phase) {
        if (phase === null) // These are composite component total time measurements.
        return componentName + " [" + (isMounted ? 'update' : 'mount') + "]";
        else // Composite component methods.
        return componentName + "." + phase;
    };
    var beginFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) // During the commit phase, we don't show duplicate labels because
        // there is a fixed overhead for every measurement, and we don't
        // want to stretch the commit phase beyond necessary.
        return false;
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
    };
    var clearFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
    };
    var endFiberMark = function(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
    };
    var shouldIgnoreFiber = function(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch(fiber.tag){
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
            case Mode:
                return true;
            default:
                return false;
        }
    };
    var clearPendingPhaseMeasurement = function() {
        if (currentPhase !== null && currentPhaseFiber !== null) clearFiberMark(currentPhaseFiber, currentPhase);
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
    };
    var pauseTimers = function() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while(fiber){
            if (fiber._debugIsCurrentlyTiming) endFiberMark(fiber, null, null);
            fiber = fiber.return;
        }
    };
    var resumeTimersRecursively = function(fiber) {
        if (fiber.return !== null) resumeTimersRecursively(fiber.return);
        if (fiber._debugIsCurrentlyTiming) beginFiberMark(fiber, null);
    };
    var resumeTimers = function() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) resumeTimersRecursively(currentFiber);
    };
    function recordEffect() {
        if (enableUserTimingAPI) effectCountInCurrentCommit++;
    }
    function recordScheduleUpdate() {
        if (enableUserTimingAPI) {
            if (isCommitting) hasScheduledUpdateInCurrentCommit = true;
            if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') hasScheduledUpdateInCurrentPhase = true;
        }
    }
    function startWorkTimer(fiber) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
             // If we pause, this is the fiber to unwind from.
            currentFiber = fiber;
            if (!beginFiberMark(fiber, null)) return;
            fiber._debugIsCurrentlyTiming = true;
        }
    }
    function cancelWorkTimer(fiber) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
             // Remember we shouldn't complete measurement for this fiber.
            // Otherwise flamechart will be deep even for small updates.
            fiber._debugIsCurrentlyTiming = false;
            clearFiberMark(fiber, null);
        }
    }
    function stopWorkTimer(fiber) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
             // If we pause, its parent is the fiber to unwind from.
            currentFiber = fiber.return;
            if (!fiber._debugIsCurrentlyTiming) return;
            fiber._debugIsCurrentlyTiming = false;
            endFiberMark(fiber, null, null);
        }
    }
    function stopFailedWorkTimer(fiber) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
             // If we pause, its parent is the fiber to unwind from.
            currentFiber = fiber.return;
            if (!fiber._debugIsCurrentlyTiming) return;
            fiber._debugIsCurrentlyTiming = false;
            var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
            endFiberMark(fiber, null, warning);
        }
    }
    function startPhaseTimer(fiber, phase) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            clearPendingPhaseMeasurement();
            if (!beginFiberMark(fiber, phase)) return;
            currentPhaseFiber = fiber;
            currentPhase = phase;
        }
    }
    function stopPhaseTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            if (currentPhase !== null && currentPhaseFiber !== null) {
                var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
                endFiberMark(currentPhaseFiber, currentPhase, warning);
            }
            currentPhase = null;
            currentPhaseFiber = null;
        }
    }
    function startWorkLoopTimer(nextUnitOfWork) {
        if (enableUserTimingAPI) {
            currentFiber = nextUnitOfWork;
            if (!supportsUserTiming) return;
            commitCountInCurrentWorkLoop = 0; // This is top level call.
            // Any other measurements are performed within.
            beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.
            resumeTimers();
        }
    }
    function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            var warning = null;
            if (interruptedBy !== null) {
                if (interruptedBy.tag === HostRoot) warning = 'A top-level update interrupted the previous render';
                else {
                    var componentName = getComponentName(interruptedBy.type) || 'Unknown';
                    warning = "An update to " + componentName + " interrupted the previous render";
                }
            } else if (commitCountInCurrentWorkLoop > 1) warning = 'There were cascading updates';
            commitCountInCurrentWorkLoop = 0;
            var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.
            pauseTimers();
            endMark(label, '(React Tree Reconciliation)', warning);
        }
    }
    function startCommitTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            isCommitting = true;
            hasScheduledUpdateInCurrentCommit = false;
            labelsInCurrentCommit.clear();
            beginMark('(Committing Changes)');
        }
    }
    function stopCommitTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            var warning = null;
            if (hasScheduledUpdateInCurrentCommit) warning = 'Lifecycle hook scheduled a cascading update';
            else if (commitCountInCurrentWorkLoop > 0) warning = 'Caused by a cascading update in earlier commit';
            hasScheduledUpdateInCurrentCommit = false;
            commitCountInCurrentWorkLoop++;
            isCommitting = false;
            labelsInCurrentCommit.clear();
            endMark('(Committing Changes)', '(Committing Changes)', warning);
        }
    }
    function startCommitSnapshotEffectsTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            effectCountInCurrentCommit = 0;
            beginMark('(Committing Snapshot Effects)');
        }
    }
    function stopCommitSnapshotEffectsTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Committing Snapshot Effects: " + count + " Total)", '(Committing Snapshot Effects)', null);
        }
    }
    function startCommitHostEffectsTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            effectCountInCurrentCommit = 0;
            beginMark('(Committing Host Effects)');
        }
    }
    function stopCommitHostEffectsTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Committing Host Effects: " + count + " Total)", '(Committing Host Effects)', null);
        }
    }
    function startCommitLifeCyclesTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            effectCountInCurrentCommit = 0;
            beginMark('(Calling Lifecycle Methods)');
        }
    }
    function stopCommitLifeCyclesTimer() {
        if (enableUserTimingAPI) {
            if (!supportsUserTiming) return;
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Calling Lifecycle Methods: " + count + " Total)", '(Calling Lifecycle Methods)', null);
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            warningWithoutStack$1(false, 'Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) warningWithoutStack$1(false, 'Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (disableLegacyContext) return emptyContextObject;
        else {
            if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
            // we may have already pushed its own child context on the stack. A context
            // provider should not "see" its own child context. Therefore we read the
            // previous (parent) context instead for a context provider.
            return previousContext;
            return contextStackCursor.current;
        }
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        if (disableLegacyContext) return;
        else {
            var instance = workInProgress.stateNode;
            instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
            instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        if (disableLegacyContext) return emptyContextObject;
        else {
            var type = workInProgress.type;
            var contextTypes = type.contextTypes;
            if (!contextTypes) return emptyContextObject;
             // Avoid recreating masked context unless unmasked context has changed.
            // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
            // This may trigger infinite loops if componentWillReceiveProps calls setState.
            var instance = workInProgress.stateNode;
            if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
            var context = {};
            for(var key in contextTypes)context[key] = unmaskedContext[key];
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
            // Context is created before the class component is instantiated so check for instance.
            if (instance) cacheContext(workInProgress, unmaskedContext, context);
            return context;
        }
    }
    function hasContextChanged() {
        if (disableLegacyContext) return false;
        else return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        if (disableLegacyContext) return false;
        else {
            var childContextTypes = type.childContextTypes;
            return childContextTypes !== null && childContextTypes !== undefined;
        }
    }
    function popContext(fiber) {
        if (disableLegacyContext) return;
        else {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
        }
    }
    function popTopLevelContextObject(fiber) {
        if (disableLegacyContext) return;
        else {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
        }
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (disableLegacyContext) return;
        else {
            if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
            push(contextStackCursor, context, fiber);
            push(didPerformWorkStackCursor, didChange, fiber);
        }
    }
    function processChildContext(fiber, type, parentContext) {
        if (disableLegacyContext) return parentContext;
        else {
            var instance = fiber.stateNode;
            var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
            // It has only been added in Fiber to match the (unintentional) behavior in Stack.
            if (typeof instance.getChildContext !== 'function') {
                var componentName = getComponentName(type) || 'Unknown';
                if (!warnedAboutMissingGetChildContext[componentName]) {
                    warnedAboutMissingGetChildContext[componentName] = true;
                    warningWithoutStack$1(false, "%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
                }
                return parentContext;
            }
            var childContext;
            setCurrentPhase('getChildContext');
            startPhaseTimer(fiber, 'getChildContext');
            childContext = instance.getChildContext();
            stopPhaseTimer();
            setCurrentPhase(null);
            for(var contextKey in childContext){
                if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
            }
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name, // somebody calls unstable_renderSubtreeIntoContainer() and we process
            // context from the parent component instance. The stack will be missing
            // because it's outside of the reconciliation, and so the pointer has not
            // been set. This is rare and doesn't matter. We'll also remove that API.
            getCurrentFiberStackInDev);
            return _assign({}, parentContext, {}, childContext);
        }
    }
    function pushContextProvider(workInProgress) {
        if (disableLegacyContext) return false;
        else {
            var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
            // If the instance does not exist yet, we will push null at first,
            // and replace it on the stack later when invalidating the context.
            var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
            // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
            previousContext = contextStackCursor.current;
            push(contextStackCursor, memoizedMergedChildContext, workInProgress);
            push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
            return true;
        }
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        if (disableLegacyContext) return;
        else {
            var instance = workInProgress.stateNode;
            if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
            if (didChange) {
                // Merge parent and own context.
                // Skip this if we're not updating due to sCU.
                // This avoids unnecessarily recomputing memoized values.
                var mergedContext = processChildContext(workInProgress, type, previousContext);
                instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
                // It is important to unwind the context in the reverse order.
                pop(didPerformWorkStackCursor, workInProgress);
                pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
                push(contextStackCursor, mergedContext, workInProgress);
                push(didPerformWorkStackCursor, didChange, workInProgress);
            } else {
                pop(didPerformWorkStackCursor, workInProgress);
                push(didPerformWorkStackCursor, didChange, workInProgress);
            }
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        if (disableLegacyContext) return emptyContextObject;
        else {
            // Currently this is only used with renderSubtreeIntoContainer; not sure if it
            // makes sense elsewhere
            if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
            var node = fiber;
            do {
                switch(node.tag){
                    case HostRoot:
                        return node.stateNode.context;
                    case ClassComponent:
                        var Component = node.type;
                        if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                        break;
                }
                node = node.return;
            }while (node !== null);
            throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    // CommonJS interop named imports.
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority;
    var Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback;
    var Scheduler_cancelCallback = Scheduler.unstable_cancelCallback;
    var Scheduler_shouldYield = Scheduler.unstable_shouldYield;
    var Scheduler_requestPaint = Scheduler.unstable_requestPaint;
    var Scheduler_now = Scheduler.unstable_now;
    var Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var Scheduler_NormalPriority = Scheduler.unstable_NormalPriority;
    var Scheduler_LowPriority = Scheduler.unstable_LowPriority;
    var Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    if (enableSchedulerTracing) {
        // Provide explicit error message when production+profiling bundle of e.g.
        // react-dom is used with production (non-profiling) bundle of
        // scheduler/tracing
        if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
    }
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now$1 = initialTimeMs < 10000 ? Scheduler_now : function() {
        return Scheduler_now() - initialTimeMs;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority;
            case Scheduler_NormalPriority:
                return NormalPriority;
            case Scheduler_LowPriority:
                return LowPriority;
            case Scheduler_IdlePriority:
                return IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority:
                return Scheduler_UserBlockingPriority;
            case NormalPriority:
                return Scheduler_NormalPriority;
            case LowPriority:
                return Scheduler_LowPriority;
            case IdlePriority:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync = true;
                var queue = syncQueue;
                runWithPriority(ImmediatePriority, function() {
                    for(; i < queue.length; i++){
                        var callback = queue[i];
                        do callback = callback(_isSync);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
    // Never work can be committed in an inconsistent state without tearing the UI.
    // The main example is offscreen content, like a hidden subtree. So one possible
    // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
    // which are inconsistent in the sense that they haven't finished yet, but
    // aren't visibly inconsistent because the server rendered HTML matches what the
    // hydrated tree would look like.
    var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
    // order to be consistent.
    var Idle = 2; // Continuous Hydration is a moving priority. It is slightly higher than Idle
    // and is used to increase priority of hover targets. It is increasing with
    // each usage so that last always wins.
    var ContinuousHydration = 3;
    var Sync = MAX_SIGNED_31_BIT_INT;
    var Batched = Sync - 1;
    var UNIT_SIZE = 10;
    var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.
    function msToExpirationTime(ms) {
        // Always add an offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
    }
    function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
    }
    function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
    }
    function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
    } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
    // the names to reflect.
    var LOW_PRIORITY_EXPIRATION = 5000;
    var LOW_PRIORITY_BATCH_SIZE = 250;
    function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
    }
    function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
    } // We intentionally set a higher expiration time for interactive updates in
    // dev than in production.
    //
    // If the main thread is being blocked so long that you hit the expiration,
    // it's a problem that could be solved with better scheduling.
    //
    // People will be more likely to notice this and fix it with the long
    // expiration time in development.
    //
    // In production we opt for better UX at the risk of masking scheduling
    // problems, by expiring fast.
    var HIGH_PRIORITY_EXPIRATION = 500;
    var HIGH_PRIORITY_BATCH_SIZE = 100;
    function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
    }
    function computeContinuousHydrationExpiration(currentTime) {
        // Each time we ask for a new one of these we increase the priority.
        // This ensures that the last one always wins since we can't deprioritize
        // once we've scheduled work already.
        return ContinuousHydration++;
    }
    function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) return ImmediatePriority;
        if (expirationTime === Never || expirationTime === Idle) return IdlePriority;
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) return ImmediatePriority;
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) return UserBlockingPriority;
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) return NormalPriority;
         // TODO: Handle LowPriority
        // Assume anything lower has idle priority
        return IdlePriority;
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var is$1 = typeof Object.is === 'function' ? Object.is : is;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (is$1(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty.call(objB, keysA[i]) || !is$1(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    /**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var lowPriorityWarningWithoutStack = function() {};
    var printWarning = function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    lowPriorityWarningWithoutStack = function(condition, format) {
        if (format === undefined) throw new Error("`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning message argument");
        if (!condition) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
            printWarning.apply(void 0, [
                format
            ].concat(args));
        }
    };
    var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            warningWithoutStack$1(false, "Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            warningWithoutStack$1(false, "Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            warningWithoutStack$1(false, "Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            lowPriorityWarningWithoutStack$1(false, "componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            lowPriorityWarningWithoutStack$1(false, "componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            lowPriorityWarningWithoutStack$1(false, "componentWillUpdate has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            warningWithoutStack$1(false, "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var strictRootComponentStack = getStackByFiberInDevAndProd(strictRoot);
            warningWithoutStack$1(false, "Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://fb.me/react-legacy-context%s", sortedNames, strictRootComponentStack);
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        syncUpdates(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
            default:
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleWork(fiber, Sync);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
            default:
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) throw lazyComponent._result;
        return lazyComponent._result;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        if (isPrimaryRenderer) {
            push(valueCursor, context._currentValue, providerFiber);
            context._currentValue = nextValue;
            !(context._currentRenderer === undefined || context._currentRenderer === null || context._currentRenderer === rendererSigil) && warningWithoutStack$1(false, "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            context._currentRenderer = rendererSigil;
        } else {
            push(valueCursor, context._currentValue2, providerFiber);
            context._currentValue2 = nextValue;
            !(context._currentRenderer2 === undefined || context._currentRenderer2 === null || context._currentRenderer2 === rendererSigil) && warningWithoutStack$1(false, "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            context._currentRenderer2 = rendererSigil;
        }
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        if (isPrimaryRenderer) context._currentValue = currentValue;
        else context._currentValue2 = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (is$1(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            !((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits) && warning$1(false, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (node.childExpirationTime < renderExpirationTime) {
                node.childExpirationTime = renderExpirationTime;
                if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(renderExpirationTime, null);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
                        var alternate = fiber.alternate;
                        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
                        scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.
                        if (list.expirationTime < renderExpirationTime) list.expirationTime = renderExpirationTime;
                         // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (enableSuspenseServerRenderer && fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense bounudary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (!(parentSuspense !== null)) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                if (parentSuspense.expirationTime < renderExpirationTime) parentSuspense.expirationTime = renderExpirationTime;
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null && _alternate.expirationTime < renderExpirationTime) _alternate.expirationTime = renderExpirationTime;
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childExpirationTime on
                // this fiber to indicate that a context has changed.
                scheduleWorkOnParentPath(parentSuspense, renderExpirationTime);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (dependencies.expirationTime >= renderExpirationTime) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        !!isDisallowedContextReadInDEV && warning$1(false, "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    expirationTime: NoWork,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return isPrimaryRenderer ? context._currentValue : context._currentValue2;
    }
    // UpdateQueue is a linked list of prioritized updates.
    //
    // Like fibers, update queues come in pairs: a current queue, which represents
    // the visible state of the screen, and a work-in-progress queue, which can be
    // mutated and processed asynchronously before it is committed — a form of
    // double buffering. If a work-in-progress render is discarded before finishing,
    // we create a new work-in-progress by cloning the current queue.
    //
    // Both queues share a persistent, singly-linked list structure. To schedule an
    // update, we append it to the end of both queues. Each queue maintains a
    // pointer to first update in the persistent list that hasn't been processed.
    // The work-in-progress pointer always has a position equal to or greater than
    // the current queue, since we always work on that one. The current queue's
    // pointer is only updated during the commit phase, when we swap in the
    // work-in-progress.
    //
    // For example:
    //
    //   Current pointer:           A - B - C - D - E - F
    //   Work-in-progress pointer:              D - E - F
    //                                          ^
    //                                          The work-in-progress queue has
    //                                          processed more updates than current.
    //
    // The reason we append to both queues is because otherwise we might drop
    // updates without ever processing them. For example, if we only add updates to
    // the work-in-progress queue, some updates could be lost whenever a work-in
    // -progress render restarts by cloning from current. Similarly, if we only add
    // updates to the current queue, the updates will be lost whenever an already
    // in-progress queue commits and swaps with the current queue. However, by
    // adding to both queues, we guarantee that the update will be part of the next
    // work-in-progress. (And because the work-in-progress queue becomes the
    // current queue once it commits, there's no danger of applying the same
    // update twice.)
    //
    // Prioritization
    // --------------
    //
    // Updates are not sorted by priority, but by insertion; new updates are always
    // appended to the end of the list.
    //
    // The priority is still important, though. When processing the update queue
    // during the render phase, only the updates with sufficient priority are
    // included in the result. If we skip an update because it has insufficient
    // priority, it remains in the queue to be processed later, during a lower
    // priority render. Crucially, all updates subsequent to a skipped update also
    // remain in the queue *regardless of their priority*. That means high priority
    // updates are sometimes processed twice, at two separate priorities. We also
    // keep track of a base state, that represents the state before the first
    // update in the queue is applied.
    //
    // For example:
    //
    //   Given a base state of '', and the following queue of updates
    //
    //     A1 - B2 - C1 - D2
    //
    //   where the number indicates the priority, and the update is applied to the
    //   previous state by appending a letter, React will process these updates as
    //   two separate renders, one per distinct priority level:
    //
    //   First render, at priority 1:
    //     Base state: ''
    //     Updates: [A1, C1]
    //     Result state: 'AC'
    //
    //   Second render, at priority 2:
    //     Base state: 'A'            <-  The base state does not include C1,
    //                                    because B2 was skipped.
    //     Updates: [B2, C1, D2]      <-  C1 was rebased on top of B2
    //     Result state: 'ABCD'
    //
    // Because we process updates in insertion order, and rebase high priority
    // updates when preceding updates are skipped, the final result is deterministic
    // regardless of priority. Intermediate state may vary according to system
    // resources, but the final state is always the same.
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function createUpdateQueue(baseState) {
        var queue = {
            baseState: baseState,
            firstUpdate: null,
            lastUpdate: null,
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
        };
        return queue;
    }
    function cloneUpdateQueue(currentQueue) {
        var queue = {
            baseState: currentQueue.baseState,
            firstUpdate: currentQueue.firstUpdate,
            lastUpdate: currentQueue.lastUpdate,
            // TODO: With resuming, if we bail out and resuse the child tree, we should
            // keep these effects.
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
        };
        return queue;
    }
    function createUpdate(expirationTime, suspenseConfig) {
        var update = {
            expirationTime: expirationTime,
            suspenseConfig: suspenseConfig,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null,
            nextEffect: null
        };
        update.priority = getCurrentPriorityLevel();
        return update;
    }
    function appendUpdateToQueue(queue, update) {
        // Append the update to the end of the list.
        if (queue.lastUpdate === null) // Queue is empty
        queue.firstUpdate = queue.lastUpdate = update;
        else {
            queue.lastUpdate.next = update;
            queue.lastUpdate = update;
        }
    }
    function enqueueUpdate(fiber, update) {
        // Update queues are created lazily.
        var alternate = fiber.alternate;
        var queue1;
        var queue2;
        if (alternate === null) {
            // There's only one fiber.
            queue1 = fiber.updateQueue;
            queue2 = null;
            if (queue1 === null) queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
        } else {
            // There are two owners.
            queue1 = fiber.updateQueue;
            queue2 = alternate.updateQueue;
            if (queue1 === null) {
                if (queue2 === null) {
                    // Neither fiber has an update queue. Create new ones.
                    queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
                    queue2 = alternate.updateQueue = createUpdateQueue(alternate.memoizedState);
                } else // Only one fiber has an update queue. Clone to create a new one.
                queue1 = fiber.updateQueue = cloneUpdateQueue(queue2);
            } else if (queue2 === null) // Only one fiber has an update queue. Clone to create a new one.
            queue2 = alternate.updateQueue = cloneUpdateQueue(queue1);
        }
        if (queue2 === null || queue1 === queue2) // There's only a single queue.
        appendUpdateToQueue(queue1, update);
        else // There are two queues. We need to append the update to both queues,
        // while accounting for the persistent structure of the list — we don't
        // want the same update to be added multiple times.
        if (queue1.lastUpdate === null || queue2.lastUpdate === null) {
            // One of the queues is not empty. We must add the update to both queues.
            appendUpdateToQueue(queue1, update);
            appendUpdateToQueue(queue2, update);
        } else {
            // Both queues are non-empty. The last update is the same in both lists,
            // because of structural sharing. So, only append to one of the lists.
            appendUpdateToQueue(queue1, update); // But we still need to update the `lastUpdate` pointer of queue2.
            queue2.lastUpdate = update;
        }
        if (fiber.tag === ClassComponent && (currentlyProcessingQueue === queue1 || queue2 !== null && currentlyProcessingQueue === queue2) && !didWarnUpdateInsideUpdate) {
            warningWithoutStack$1(false, "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, update) {
        // Captured updates go into a separate list, and only on the work-in-
        // progress queue.
        var workInProgressQueue = workInProgress.updateQueue;
        if (workInProgressQueue === null) workInProgressQueue = workInProgress.updateQueue = createUpdateQueue(workInProgress.memoizedState);
        else // TODO: I put this here rather than createWorkInProgress so that we don't
        // clone the queue unnecessarily. There's probably a better way to
        // structure this.
        workInProgressQueue = ensureWorkInProgressQueueIsAClone(workInProgress, workInProgressQueue);
         // Append the update to the end of the list.
        if (workInProgressQueue.lastCapturedUpdate === null) // This is the first render phase update
        workInProgressQueue.firstCapturedUpdate = workInProgressQueue.lastCapturedUpdate = update;
        else {
            workInProgressQueue.lastCapturedUpdate.next = update;
            workInProgressQueue.lastCapturedUpdate = update;
        }
    }
    function ensureWorkInProgressQueueIsAClone(workInProgress, queue) {
        var current = workInProgress.alternate;
        if (current !== null) // If the work-in-progress queue is equal to the current queue,
        // we need to clone it first.
        {
            if (queue === current.updateQueue) queue = workInProgress.updateQueue = cloneUpdateQueue(queue);
        }
        return queue;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) payload.call(instance, prevState, nextProps);
                    var nextState = payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) _payload.call(instance, prevState, nextProps);
                    partialState = _payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, queue, props, instance, renderExpirationTime) {
        hasForceUpdate = false;
        queue = ensureWorkInProgressQueueIsAClone(workInProgress, queue);
        currentlyProcessingQueue = queue;
        var newBaseState = queue.baseState;
        var newFirstUpdate = null;
        var newExpirationTime = NoWork; // Iterate through the list of updates to compute the result.
        var update = queue.firstUpdate;
        var resultState = newBaseState;
        while(update !== null){
            var updateExpirationTime = update.expirationTime;
            if (updateExpirationTime < renderExpirationTime) {
                // This update does not have sufficient priority. Skip it.
                if (newFirstUpdate === null) {
                    // This is the first skipped update. It will be the first update in
                    // the new list.
                    newFirstUpdate = update; // Since this is the first update that was skipped, the current result
                    // is the new base state.
                    newBaseState = resultState;
                } // Since this update will remain in the list, update the remaining
                // expiration time.
                if (newExpirationTime < updateExpirationTime) newExpirationTime = updateExpirationTime;
            } else {
                // This update does have sufficient priority.
                // Mark the event time of this update as relevant to this render pass.
                // TODO: This should ideally use the true event time of this update rather than
                // its priority which is a derived and not reverseable value.
                // TODO: We should skip this update if it was already committed but currently
                // we have no way of detecting the difference between a committed and suspended
                // update here.
                markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process it and compute a new result.
                resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
                var callback = update.callback;
                if (callback !== null) {
                    workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.
                    update.nextEffect = null;
                    if (queue.lastEffect === null) queue.firstEffect = queue.lastEffect = update;
                    else {
                        queue.lastEffect.nextEffect = update;
                        queue.lastEffect = update;
                    }
                }
            } // Continue to the next update.
            update = update.next;
        } // Separately, iterate though the list of captured updates.
        var newFirstCapturedUpdate = null;
        update = queue.firstCapturedUpdate;
        while(update !== null){
            var _updateExpirationTime = update.expirationTime;
            if (_updateExpirationTime < renderExpirationTime) {
                // This update does not have sufficient priority. Skip it.
                if (newFirstCapturedUpdate === null) {
                    // This is the first skipped captured update. It will be the first
                    // update in the new list.
                    newFirstCapturedUpdate = update; // If this is the first update that was skipped, the current result is
                    // the new base state.
                    if (newFirstUpdate === null) newBaseState = resultState;
                } // Since this update will remain in the list, update the remaining
                // expiration time.
                if (newExpirationTime < _updateExpirationTime) newExpirationTime = _updateExpirationTime;
            } else {
                // This update does have sufficient priority. Process it and compute
                // a new result.
                resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
                var _callback = update.callback;
                if (_callback !== null) {
                    workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.
                    update.nextEffect = null;
                    if (queue.lastCapturedEffect === null) queue.firstCapturedEffect = queue.lastCapturedEffect = update;
                    else {
                        queue.lastCapturedEffect.nextEffect = update;
                        queue.lastCapturedEffect = update;
                    }
                }
            }
            update = update.next;
        }
        if (newFirstUpdate === null) queue.lastUpdate = null;
        if (newFirstCapturedUpdate === null) queue.lastCapturedUpdate = null;
        else workInProgress.effectTag |= Callback;
        if (newFirstUpdate === null && newFirstCapturedUpdate === null) // We processed every update, without skipping. That means the new base
        // state is the same as the result state.
        newBaseState = resultState;
        queue.baseState = newBaseState;
        queue.firstUpdate = newFirstUpdate;
        queue.firstCapturedUpdate = newFirstCapturedUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
        // This should be fine because the only two other things that contribute to
        // expiration time are props and context. We're already in the middle of the
        // begin phase by the time we start processing the queue, so we've already
        // dealt with the props. Context in components that specify
        // shouldComponentUpdate is tricky; but we'll have to account for
        // that regardless.
        markUnprocessedUpdateTime(newExpirationTime);
        workInProgress.expirationTime = newExpirationTime;
        workInProgress.memoizedState = resultState;
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === 'function')) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance, renderExpirationTime) {
        // If the finished render included captured updates, and there are still
        // lower priority updates left over, we need to keep the captured updates
        // in the queue so that they are rebased and not dropped once we process the
        // queue again at the lower priority.
        if (finishedQueue.firstCapturedUpdate !== null) {
            // Join the captured update list to the end of the normal list.
            if (finishedQueue.lastUpdate !== null) {
                finishedQueue.lastUpdate.next = finishedQueue.firstCapturedUpdate;
                finishedQueue.lastUpdate = finishedQueue.lastCapturedUpdate;
            } // Clear the list of captured updates.
            finishedQueue.firstCapturedUpdate = finishedQueue.lastCapturedUpdate = null;
        } // Commit the effects
        commitUpdateEffects(finishedQueue.firstEffect, instance);
        finishedQueue.firstEffect = finishedQueue.lastEffect = null;
        commitUpdateEffects(finishedQueue.firstCapturedEffect, instance);
        finishedQueue.firstCapturedEffect = finishedQueue.lastCapturedEffect = null;
    }
    function commitUpdateEffects(effect, instance) {
        while(effect !== null){
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
            effect = effect.nextEffect;
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
    }
    var fakeInternalInstance = {};
    var isArray$1 = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            warningWithoutStack$1(false, "%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                warningWithoutStack$1(false, "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        var updateQueue = workInProgress.updateQueue;
        if (updateQueue !== null && workInProgress.expirationTime === NoWork) updateQueue.baseState = memoizedState;
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            startPhaseTimer(workInProgress, 'shouldComponentUpdate');
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            stopPhaseTimer();
            !(shouldUpdate !== undefined) && warningWithoutStack$1(false, "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') warningWithoutStack$1(false, "%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else warningWithoutStack$1(false, "%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        var noGetInitialStateOnES6 = !instance.getInitialState || instance.getInitialState.isReactClassApproved || instance.state;
        !noGetInitialStateOnES6 && warningWithoutStack$1(false, "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        var noGetDefaultPropsOnES6 = !instance.getDefaultProps || instance.getDefaultProps.isReactClassApproved;
        !noGetDefaultPropsOnES6 && warningWithoutStack$1(false, "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        var noInstancePropTypes = !instance.propTypes;
        !noInstancePropTypes && warningWithoutStack$1(false, "propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        var noInstanceContextType = !instance.contextType;
        !noInstanceContextType && warningWithoutStack$1(false, "contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (disableLegacyContext) {
            if (ctor.childContextTypes) warningWithoutStack$1(false, "%s uses the legacy childContextTypes API which is no longer supported. Use React.createContext() instead.", name);
            if (ctor.contextTypes) warningWithoutStack$1(false, "%s uses the legacy contextTypes API which is no longer supported. Use React.createContext() with static contextType instead.", name);
        } else {
            var noInstanceContextTypes = !instance.contextTypes;
            !noInstanceContextTypes && warningWithoutStack$1(false, "contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                didWarnAboutContextTypeAndContextTypes.add(ctor);
                warningWithoutStack$1(false, "%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
            }
        }
        var noComponentShouldUpdate = typeof instance.componentShouldUpdate !== 'function';
        !noComponentShouldUpdate && warningWithoutStack$1(false, "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') warningWithoutStack$1(false, "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || 'A pure component');
        var noComponentDidUnmount = typeof instance.componentDidUnmount !== 'function';
        !noComponentDidUnmount && warningWithoutStack$1(false, "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        var noComponentDidReceiveProps = typeof instance.componentDidReceiveProps !== 'function';
        !noComponentDidReceiveProps && warningWithoutStack$1(false, "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        var noComponentWillRecieveProps = typeof instance.componentWillRecieveProps !== 'function';
        !noComponentWillRecieveProps && warningWithoutStack$1(false, "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        var noUnsafeComponentWillRecieveProps = typeof instance.UNSAFE_componentWillRecieveProps !== 'function';
        !noUnsafeComponentWillRecieveProps && warningWithoutStack$1(false, "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        !(instance.props === undefined || !hasMutatedProps) && warningWithoutStack$1(false, "%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        var noInstanceDefaultProps = !instance.defaultProps;
        !noInstanceDefaultProps && warningWithoutStack$1(false, "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            warningWithoutStack$1(false, "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        var noInstanceGetDerivedStateFromProps = typeof instance.getDerivedStateFromProps !== 'function';
        !noInstanceGetDerivedStateFromProps && warningWithoutStack$1(false, "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        var noInstanceGetDerivedStateFromCatch = typeof instance.getDerivedStateFromError !== 'function';
        !noInstanceGetDerivedStateFromCatch && warningWithoutStack$1(false, "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        var noStaticGetSnapshotBeforeUpdate = typeof ctor.getSnapshotBeforeUpdate !== 'function';
        !noStaticGetSnapshotBeforeUpdate && warningWithoutStack$1(false, "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray$1(_state))) warningWithoutStack$1(false, '%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function') !(typeof ctor.childContextTypes === 'object') && warningWithoutStack$1(false, "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props, renderExpirationTime) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                warningWithoutStack$1(false, "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else if (!disableLegacyContext) {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) new ctor(props, context); // eslint-disable-line no-new
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                warningWithoutStack$1(false, "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    warningWithoutStack$1(false, "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        stopPhaseTimer();
        if (oldState !== instance.state) {
            warningWithoutStack$1(false, "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        stopPhaseTimer();
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                warningWithoutStack$1(false, "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else if (disableLegacyContext) instance.context = emptyContextObject;
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                warningWithoutStack$1(false, "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        if (warnAboutDeprecatedLifecycles) ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        var updateQueue = workInProgress.updateQueue;
        if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            instance.state = workInProgress.memoizedState;
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            updateQueue = workInProgress.updateQueue;
            if (updateQueue !== null) {
                processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
                instance.state = workInProgress.memoizedState;
            }
        }
        if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else if (!disableLegacyContext) {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        var updateQueue = workInProgress.updateQueue;
        if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            newState = workInProgress.memoizedState;
        }
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                startPhaseTimer(workInProgress, 'componentWillMount');
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
                stopPhaseTimer();
            }
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.effectTag |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else if (!disableLegacyContext) {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        var updateQueue = workInProgress.updateQueue;
        if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            newState = workInProgress.memoizedState;
        }
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                startPhaseTimer(workInProgress, 'componentWillUpdate');
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
                stopPhaseTimer();
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.effectTag |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.effectTag |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === 'object')) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var currentComponentErrorInfo = 'Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.' + getCurrentFiberStackInDev();
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
        warning$1(false, 'Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.');
    };
    var isArray = Array.isArray;
    function coerceRef(returnFiber, current$$1, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if (returnFiber.mode & StrictMode || warnAboutStringRefs) {
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    if (warnAboutStringRefs) warningWithoutStack$1(false, 'Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref%s', componentName, mixedRef, getStackByFiberInDevAndProd(returnFiber));
                    else warningWithoutStack$1(false, 'A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have refs. Did you mean to use React.forwardRef()?");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current$$1 !== null && current$$1.ref !== null && typeof current$$1.ref === 'function' && current$$1.ref._stringRef === stringRef) return current$$1.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === 'string')) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
            var addendum = '';
            addendum = " If you meant to render a collection of children, use an array instead." + getCurrentFiberStackInDev();
            throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + ")." + addendum);
        }
    }
    function warnOnFunctionType() {
        var currentComponentErrorInfo = "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it." + getCurrentFiberStackInDev();
        if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) return;
        ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
        warning$1(false, "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps, expirationTime) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps, expirationTime);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current$$1 = newFiber.alternate;
            if (current$$1 !== null) {
                var oldIndex = current$$1.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.effectTag = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.effectTag = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.effectTag = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current$$1, textContent, expirationTime) {
            if (current$$1 === null || current$$1.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current$$1, textContent, expirationTime);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current$$1, element, expirationTime) {
            if (current$$1 !== null && (current$$1.elementType === element.type || isCompatibleFamilyForHotReloading(current$$1, element))) {
                // Move based on index
                var existing = useFiber(current$$1, element.props, expirationTime);
                existing.ref = coerceRef(returnFiber, current$$1, element);
                existing.return = returnFiber;
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
                return existing;
            } else {
                // Insert
                var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
                created.ref = coerceRef(returnFiber, current$$1, element);
                created.return = returnFiber;
                return created;
            }
        }
        function updatePortal(returnFiber, current$$1, portal, expirationTime) {
            if (current$$1 === null || current$$1.tag !== HostPortal || current$$1.stateNode.containerInfo !== portal.containerInfo || current$$1.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current$$1, portal.children || [], expirationTime);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current$$1, fragment, expirationTime, key) {
            if (current$$1 === null || current$$1.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current$$1, fragment, expirationTime);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                            return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                        else return null;
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType();
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    warning$1(false, "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                default:
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === 'function')) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                !didWarnAboutGenerators && warning$1(false, "Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                !didWarnAboutMaps && warning$1(false, "Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent, expirationTime);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === Fragment ? element.type === REACT_FRAGMENT_TYPE : child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, element.type === REACT_FRAGMENT_TYPE ? element.props.children : element.props, expirationTime);
                        existing.ref = coerceRef(returnFiber, child, element);
                        existing.return = returnFiber;
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || [], expirationTime);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === 'object' && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
            if (typeof newChild === 'string' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
            if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === 'function') warnOnFunctionType();
            if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case FunctionComponent:
                    var Component = returnFiber.type;
                    throw Error((Component.displayName || Component.name || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current$$1, workInProgress) {
        if (!(current$$1 === null || workInProgress.child === current$$1.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, renderExpirationTime);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type, rootInstance); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var emptyObject = {};
    var isArray$2 = Array.isArray;
    function createResponderInstance(responder, responderProps, responderState, fiber) {
        return {
            fiber: fiber,
            props: responderProps,
            responder: responder,
            rootEventTypes: null,
            state: responderState
        };
    }
    function mountEventResponder(responder, responderProps, fiber, respondersMap, rootContainerInstance) {
        var responderState = emptyObject;
        var getInitialState = responder.getInitialState;
        if (getInitialState !== null) responderState = getInitialState(responderProps);
        var responderInstance = createResponderInstance(responder, responderProps, responderState, fiber);
        if (!rootContainerInstance) {
            var node = fiber;
            while(node !== null){
                var tag = node.tag;
                if (tag === HostComponent) {
                    rootContainerInstance = node.stateNode;
                    break;
                } else if (tag === HostRoot) {
                    rootContainerInstance = node.stateNode.containerInfo;
                    break;
                }
                node = node.return;
            }
        }
        mountResponderInstance(responder, responderInstance, responderProps, responderState, rootContainerInstance);
        respondersMap.set(responder, responderInstance);
    }
    function updateEventListener(listener, fiber, visistedResponders, respondersMap, rootContainerInstance) {
        var responder;
        var props;
        if (listener) {
            responder = listener.responder;
            props = listener.props;
        }
        if (!(responder && responder.$$typeof === REACT_RESPONDER_TYPE)) throw Error("An invalid value was used as an event listener. Expect one or many event listeners created via React.unstable_useResponder().");
        var listenerProps = props;
        if (visistedResponders.has(responder)) {
            warning$1(false, 'Duplicate event responder "%s" found in event listeners. Event listeners passed to elements cannot use the same event responder more than once.', responder.displayName);
            return;
        }
        visistedResponders.add(responder);
        var responderInstance = respondersMap.get(responder);
        if (responderInstance === undefined) // Mount (happens in either complete or commit phase)
        mountEventResponder(responder, listenerProps, fiber, respondersMap, rootContainerInstance);
        else {
            // Update (happens during commit phase only)
            responderInstance.props = listenerProps;
            responderInstance.fiber = fiber;
        }
    }
    function updateEventListeners(listeners, fiber, rootContainerInstance) {
        var visistedResponders = new Set();
        var dependencies = fiber.dependencies;
        if (listeners != null) {
            if (dependencies === null) dependencies = fiber.dependencies = {
                expirationTime: NoWork,
                firstContext: null,
                responders: new Map()
            };
            var respondersMap = dependencies.responders;
            if (respondersMap === null) respondersMap = new Map();
            if (isArray$2(listeners)) for(var i = 0, length = listeners.length; i < length; i++){
                var listener = listeners[i];
                updateEventListener(listener, fiber, visistedResponders, respondersMap, rootContainerInstance);
            }
            else updateEventListener(listeners, fiber, visistedResponders, respondersMap, rootContainerInstance);
        }
        if (dependencies !== null) {
            var _respondersMap = dependencies.responders;
            if (_respondersMap !== null) {
                // Unmount
                var mountedResponders = Array.from(_respondersMap.keys());
                for(var _i = 0, _length = mountedResponders.length; _i < _length; _i++){
                    var mountedResponder = mountedResponders[_i];
                    if (!visistedResponders.has(mountedResponder)) {
                        var responderInstance = _respondersMap.get(mountedResponder);
                        unmountResponderInstance(responderInstance);
                        _respondersMap.delete(mountedResponder);
                    }
                }
            }
        }
    }
    function createResponderListener(responder, props) {
        var eventResponderListener = {
            responder: responder,
            props: props
        };
        Object.freeze(eventResponderListener);
        return eventResponderListener;
    }
    var NoEffect$1 = /*             */ 0;
    var UnmountSnapshot = /*      */ 2;
    var UnmountMutation = /*      */ 4;
    var MountMutation = /*        */ 8;
    var UnmountLayout = /*        */ 16;
    var MountLayout = /*          */ 32;
    var MountPassive = /*         */ 64;
    var UnmountPassive = /*       */ 128;
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderExpirationTime$1 = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var nextCurrentHook = null;
    var firstWorkInProgressHook = null;
    var workInProgressHook = null;
    var nextWorkInProgressHook = null;
    var remainingExpirationTime = NoWork;
    var componentUpdateQueue = null;
    var sideEffectTag = 0; // Updates scheduled during render will trigger an immediate re-render at the
    // end of the current pass. We can't store these updates on the normal queue,
    // because if the work is aborted, they should be discarded. Because this is
    // a relatively rare case, we also don't want to add an additional field to
    // either the hook or queue object types. So we store them in a lazily create
    // map of queue -> render-phase updates, which are discarded once the component
    // completes without re-rendering.
    // Whether an update was scheduled during the currently executing render pass.
    var didScheduleRenderPhaseUpdate = false; // Lazily created map of render-phase updates
    var renderPhaseUpdates = null; // Counter to prevent infinite loops.
    var numberOfReRenders = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        warning$1(false, "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                warning$1(false, "React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            warning$1(false, "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) warning$1(false, "The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (is$1(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, refOrContext, nextRenderExpirationTime) {
        renderExpirationTime$1 = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        nextCurrentHook = current !== null ? current.memoizedState : null;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        if (nextCurrentHook !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, refOrContext);
        if (didScheduleRenderPhaseUpdate) {
            do {
                didScheduleRenderPhaseUpdate = false;
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                nextCurrentHook = current !== null ? current.memoizedState : null;
                nextWorkInProgressHook = firstWorkInProgressHook;
                currentHook = null;
                workInProgressHook = null;
                componentUpdateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
                children = Component(props, refOrContext);
            }while (didScheduleRenderPhaseUpdate);
            renderPhaseUpdates = null;
            numberOfReRenders = 0;
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        var renderedWork = currentlyRenderingFiber$1;
        renderedWork.memoizedState = firstWorkInProgressHook;
        renderedWork.expirationTime = remainingExpirationTime;
        renderedWork.updateQueue = componentUpdateQueue;
        renderedWork.effectTag |= sideEffectTag;
        renderedWork._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime$1 = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        nextCurrentHook = null;
        firstWorkInProgressHook = null;
        workInProgressHook = null;
        nextWorkInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        remainingExpirationTime = NoWork;
        componentUpdateQueue = null;
        sideEffectTag = 0; // These were reset above
        // didScheduleRenderPhaseUpdate = false;
        // renderPhaseUpdates = null;
        // numberOfReRenders = 0;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) current.expirationTime = NoWork;
    }
    function resetHooks() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher; // This is used to reset the state of this module when a component throws.
        // It's also called inside mountIndeterminateComponent if we determine the
        // component is a module-style component.
        renderExpirationTime$1 = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        nextCurrentHook = null;
        firstWorkInProgressHook = null;
        workInProgressHook = null;
        nextWorkInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        remainingExpirationTime = NoWork;
        componentUpdateQueue = null;
        sideEffectTag = 0;
        didScheduleRenderPhaseUpdate = false;
        renderPhaseUpdates = null;
        numberOfReRenders = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            queue: null,
            baseUpdate: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        firstWorkInProgressHook = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
            nextCurrentHook = currentHook !== null ? currentHook.next : null;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                queue: currentHook.queue,
                baseUpdate: currentHook.baseUpdate,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            workInProgressHook = firstWorkInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
            nextCurrentHook = currentHook.next;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        if (numberOfReRenders > 0) {
            // This is a re-render. Apply the new render phase updates to the previous
            // work-in-progress hook.
            var _dispatch = queue.dispatch;
            if (renderPhaseUpdates !== null) {
                // Render phase updates are stored in a map of queue -> linked list
                var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
                if (firstRenderPhaseUpdate !== undefined) {
                    renderPhaseUpdates.delete(queue);
                    var newState = hook.memoizedState;
                    var update = firstRenderPhaseUpdate;
                    do {
                        // Process this render phase update. We don't have to check the
                        // priority because it will always be the same as the current
                        // render's.
                        var action = update.action;
                        newState = reducer(newState, action);
                        update = update.next;
                    }while (update !== null); // Mark that the fiber performed work, but only if the new state is
                    // different from the current state.
                    if (!is$1(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
                    hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
                    // the base state unless the queue is empty.
                    // TODO: Not sure if this is the desired semantics, but it's what we
                    // do for gDSFP. I can't remember why.
                    if (hook.baseUpdate === queue.last) hook.baseState = newState;
                    queue.lastRenderedState = newState;
                    return [
                        newState,
                        _dispatch
                    ];
                }
            }
            return [
                hook.memoizedState,
                _dispatch
            ];
        } // The last update in the entire queue
        var last = queue.last; // The last update that is part of the base state.
        var baseUpdate = hook.baseUpdate;
        var baseState = hook.baseState; // Find the first unprocessed update.
        var first;
        if (baseUpdate !== null) {
            if (last !== null) // For the first update, the queue is a circular linked list where
            // `queue.last.next = queue.first`. Once the first update commits, and
            // the `baseUpdate` is no longer empty, we can unravel the list.
            last.next = null;
            first = baseUpdate.next;
        } else first = last !== null ? last.next : null;
        if (first !== null) {
            var _newState = baseState;
            var newBaseState = null;
            var newBaseUpdate = null;
            var prevUpdate = baseUpdate;
            var _update = first;
            var didSkip = false;
            do {
                var updateExpirationTime = _update.expirationTime;
                if (updateExpirationTime < renderExpirationTime$1) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    if (!didSkip) {
                        didSkip = true;
                        newBaseUpdate = prevUpdate;
                        newBaseState = _newState;
                    } // Update the remaining priority in the queue.
                    if (updateExpirationTime > remainingExpirationTime) {
                        remainingExpirationTime = updateExpirationTime;
                        markUnprocessedUpdateTime(remainingExpirationTime);
                    }
                } else {
                    // This update does have sufficient priority.
                    // Mark the event time of this update as relevant to this render pass.
                    // TODO: This should ideally use the true event time of this update rather than
                    // its priority which is a derived and not reverseable value.
                    // TODO: We should skip this update if it was already committed but currently
                    // we have no way of detecting the difference between a committed and suspended
                    // update here.
                    markRenderEventTimeAndConfig(updateExpirationTime, _update.suspenseConfig); // Process this update.
                    if (_update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    _newState = _update.eagerState;
                    else {
                        var _action = _update.action;
                        _newState = reducer(_newState, _action);
                    }
                }
                prevUpdate = _update;
                _update = _update.next;
            }while (_update !== null && _update !== first);
            if (!didSkip) {
                newBaseUpdate = prevUpdate;
                newBaseState = _newState;
            } // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!is$1(_newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = _newState;
            hook.baseUpdate = newBaseUpdate;
            hook.baseState = newBaseState;
            queue.lastRenderedState = _newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer, initialState);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        sideEffectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(hookEffectTag, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(NoEffect$1, create, destroy, nextDeps);
                    return;
                }
            }
        }
        sideEffectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(hookEffectTag, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, UnmountPassive | MountPassive, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, UnmountPassive | MountPassive, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, UnmountMutation | MountLayout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, UnmountMutation | MountLayout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            !refObject.hasOwnProperty('current') && warning$1(false, "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        !(typeof create === 'function') && warning$1(false, "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, UnmountMutation | MountLayout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        !(typeof create === 'function') && warning$1(false, "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, UnmountMutation | MountLayout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value, config) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            Scheduler.unstable_next(function() {
                var previousConfig = ReactCurrentBatchConfig$1.suspense;
                ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
                try {
                    setValue(value);
                } finally{
                    ReactCurrentBatchConfig$1.suspense = previousConfig;
                }
            });
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function updateDeferredValue(value, config) {
        var _updateState = updateState(value), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            Scheduler.unstable_next(function() {
                var previousConfig = ReactCurrentBatchConfig$1.suspense;
                ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
                try {
                    setValue(value);
                } finally{
                    ReactCurrentBatchConfig$1.suspense = previousConfig;
                }
            });
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function mountTransition(config) {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
        var startTransition = mountCallback(function(callback) {
            setPending(true);
            Scheduler.unstable_next(function() {
                var previousConfig = ReactCurrentBatchConfig$1.suspense;
                ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
                try {
                    setPending(false);
                    callback();
                } finally{
                    ReactCurrentBatchConfig$1.suspense = previousConfig;
                }
            });
        }, [
            config,
            isPending
        ]);
        return [
            startTransition,
            isPending
        ];
    }
    function updateTransition(config) {
        var _updateState2 = updateState(false), isPending = _updateState2[0], setPending = _updateState2[1];
        var startTransition = updateCallback(function(callback) {
            setPending(true);
            Scheduler.unstable_next(function() {
                var previousConfig = ReactCurrentBatchConfig$1.suspense;
                ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
                try {
                    setPending(false);
                    callback();
                } finally{
                    ReactCurrentBatchConfig$1.suspense = previousConfig;
                }
            });
        }, [
            config,
            isPending
        ]);
        return [
            startTransition,
            isPending
        ];
    }
    function dispatchAction(fiber, queue, action) {
        if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        !(typeof arguments[3] !== 'function') && warning$1(false, "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            var update = {
                expirationTime: renderExpirationTime$1,
                suspenseConfig: null,
                action: action,
                eagerReducer: null,
                eagerState: null,
                next: null
            };
            update.priority = getCurrentPriorityLevel();
            if (renderPhaseUpdates === null) renderPhaseUpdates = new Map();
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
            if (firstRenderPhaseUpdate === undefined) renderPhaseUpdates.set(queue, update);
            else {
                // Append the update to the end of the list.
                var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
                while(lastRenderPhaseUpdate.next !== null)lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
                lastRenderPhaseUpdate.next = update;
            }
        } else {
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var _update2 = {
                expirationTime: expirationTime,
                suspenseConfig: suspenseConfig,
                action: action,
                eagerReducer: null,
                eagerState: null,
                next: null
            };
            _update2.priority = getCurrentPriorityLevel();
            var last = queue.last;
            if (last === null) // This is the first update. Create a circular list.
            _update2.next = _update2;
            else {
                var first = last.next;
                if (first !== null) // Still circular.
                _update2.next = first;
                last.next = _update2;
            }
            queue.last = _update2;
            if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        _update2.eagerReducer = lastRenderedReducer;
                        _update2.eagerState = eagerState;
                        if (is$1(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleWork(fiber, expirationTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var warnInvalidContextAccess = function() {
        warning$1(false, "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        warning$1(false, "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue(value, formatterFn);
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            mountHookTypesDev();
            return createResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue(value, formatterFn);
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue(value, formatterFn);
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue(value, formatterFn);
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue(value, formatterFn);
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    // CommonJS interop named imports.
    var now$2 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        if (!enableProfilerTimer) return;
        commitTime = now$2();
    }
    function startProfilerTimer(fiber) {
        if (!enableProfilerTimer) return;
        profilerStartTime = now$2();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$2();
    }
    function stopProfilerTimerIfRunning(fiber) {
        if (!enableProfilerTimer) return;
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (!enableProfilerTimer) return;
        if (profilerStartTime >= 0) {
            var elapsedTime = now$2() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function warnIfHydrating() {
        !!isHydrating && warning$1(false, 'We should not be hydrating here. This is a bug in React. Please file a bug.');
    }
    function enterHydrationState(fiber) {
        if (!supportsHydration) return false;
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance) {
        if (!supportsHydration) return false;
        nextHydratableInstance = getNextHydratableSibling(suspenseInstance);
        popToNextHostParent(fiber);
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type, props);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableContainerSuspenseInstance(parentContainer);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type, props);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                if (enableSuspenseServerRenderer) {
                    var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                    if (suspenseInstance !== null) {
                        var suspenseState = {
                            dehydrated: suspenseInstance,
                            retryTime: Never
                        };
                        fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                        // This simplifies the code for getHostSibling and deleting nodes,
                        // since it doesn't have to consider all Suspense boundaries and
                        // check if they're dehydrated ones or not.
                        var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                        dehydratedFragment.return = fiber;
                        fiber.child = dehydratedFragment;
                        return true;
                    }
                }
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        if (!supportsHydration) throw Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        if (!supportsHydration) throw Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        if (!supportsHydration) throw Error("Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        if (!supportsHydration) throw Error("Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (!supportsHydration) return false;
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        if (!supportsHydration) return;
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    var ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutMaxDuration;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutMaxDuration = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime) {
        if (current$$1 === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current$$1.child, nextChildren, renderExpirationTime);
    }
    function forceUnmountCurrentAndReconcile(current$$1, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current$$1.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their their
        // identity matches.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
    }
    function updateForwardRef(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$2.current = workInProgress;
        setCurrentPhase('render');
        nextChildren = renderWithHooks(current$$1, workInProgress, render, nextProps, ref, renderExpirationTime);
        if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current$$1, workInProgress, render, nextProps, ref, renderExpirationTime);
        }
        setCurrentPhase(null);
        if (current$$1 !== null && !didReceiveUpdate) {
            bailoutHooks(current$$1, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMemoComponent(current$$1, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current$$1 === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current$$1, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(type), getCurrentFiberStackInDev);
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentName(_type), getCurrentFiberStackInDev);
        var currentChild = current$$1.child; // This is always exactly one child
        if (updateExpirationTime < renderExpirationTime) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current$$1.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps, renderExpirationTime);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current$$1, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) // We warn when you define propTypes on lazy()
            // so let's just skip over it to find memo() outer wrapper.
            // Inner props for memo are validated later.
            outerMemoType = refineResolvedLazyComponent(outerMemoType);
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentName(outerMemoType), getCurrentFiberStackInDev);
             // Inner propTypes will be validated in the function component path.
        }
        if (current$$1 !== null) {
            var prevProps = current$$1.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current$$1.ref === workInProgress.ref && workInProgress.type === current$$1.type) {
                didReceiveUpdate = false;
                if (updateExpirationTime < renderExpirationTime) return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
            }
        }
        return updateFunctionComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime);
    }
    function updateFragment(current$$1, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMode(current$$1, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateProfiler(current$$1, workInProgress, renderExpirationTime) {
        if (enableProfilerTimer) workInProgress.effectTag |= Update;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markRef(current$$1, workInProgress) {
        var ref = workInProgress.ref;
        if (current$$1 === null && ref !== null || current$$1 !== null && current$$1.ref !== ref) // Schedule a Ref effect
        workInProgress.effectTag |= Ref;
    }
    function updateFunctionComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        var context;
        if (!disableLegacyContext) {
            var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
            context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$2.current = workInProgress;
        setCurrentPhase('render');
        nextChildren = renderWithHooks(current$$1, workInProgress, Component, nextProps, context, renderExpirationTime);
        if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current$$1, workInProgress, Component, nextProps, context, renderExpirationTime);
        }
        setCurrentPhase(null);
        if (current$$1 !== null && !didReceiveUpdate) {
            bailoutHooks(current$$1, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateClassComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current$$1 !== null) {
                // An class component without an instance only mounts if it suspended
                // inside a non- concurrent tree, in an inconsistent state. We want to
                // tree it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current$$1.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.effectTag |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
            mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
            shouldUpdate = true;
        } else if (current$$1 === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        else shouldUpdate = updateClassInstance(current$$1, workInProgress, Component, nextProps, renderExpirationTime);
        var nextUnitOfWork = finishClassComponent(current$$1, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        var inst = workInProgress.stateNode;
        if (inst.props !== nextProps) {
            !didWarnAboutReassigningProps && warning$1(false, "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current$$1, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current$$1, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$2.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFrom catch is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            if (enableProfilerTimer) stopProfilerTimerIfRunning(workInProgress);
        } else {
            setCurrentPhase('render');
            nextChildren = instance.render();
            if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) instance.render();
            setCurrentPhase(null);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        if (current$$1 !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current$$1, workInProgress, nextChildren, renderExpirationTime);
        else reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current$$1, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        processUpdateQueue(workInProgress, updateQueue, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            // If the state is the same as before, that's a bailout because we had
            // no work that expires at this time.
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            // If we don't have any current children this might be the first pass.
            // We always try to hydrate. If this isn't a hydration pass there won't
            // be any children to hydrate which is effectively the same thing as
            // not hydrating.
            var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.effectTag = node.effectTag & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current$$1, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        if (current$$1 === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current$$1 !== null ? current$$1.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also have access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.effectTag |= ContentReset;
        markRef(current$$1, workInProgress); // Check the host config to see if the children are offscreen/hidden.
        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(type, nextProps)) {
            if (enableSchedulerTracing) markSpawnedWork(Never);
             // Schedule this fiber to re-render at offscreen priority. Then bailout.
            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
            return null;
        }
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateHostText(current$$1, workInProgress) {
        if (current$$1 === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
            // An lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.
        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                break;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                break;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                break;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentName(Component), getCurrentFiberStackInDev);
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateExpirationTime, renderExpirationTime);
                break;
            default:
                var hint = '';
                if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
                throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
        }
        return child;
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        if (!disableLegacyContext) {
            var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
            context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                warningWithoutStack$1(false, "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        ReactCurrentOwner$2.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
        workInProgress.effectTag |= PerformedWork;
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                warningWithoutStack$1(false, "The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            resetHooks(); // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === 'function') applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderExpirationTime);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (disableLegacyContext && Component.contextTypes) warningWithoutStack$1(false, "%s uses the legacy contextTypes API which is no longer supported. Use React.createContext() with React.useContext() instead.", getComponentName(Component) || 'Unknown');
            if (debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) // Only double-render components with Hooks
            {
                if (workInProgress.memoizedState !== null) value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
            }
            reconcileChildren(null, workInProgress, value, renderExpirationTime);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) !!Component.childContextTypes && warningWithoutStack$1(false, '%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                warning$1(false, "Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (warnAboutDefaultPropsOnFunctionComponents && Component.defaultProps !== undefined) {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                warningWithoutStack$1(false, "%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
                warningWithoutStack$1(false, '%s: Function components do not support getDerivedStateFromProps.', _componentName2);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
                warningWithoutStack$1(false, '%s: Function components do not support contextType.', _componentName3);
                didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
    };
    function shouldRemainOnFallback(suspenseContext, current$$1, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current$$1 === null || current$$1.memoizedState !== null);
    }
    function updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.effectTag |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current$$1, workInProgress)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            nextDidTimeout = true;
            workInProgress.effectTag &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current$$1 === null || current$$1.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext);
        if ('maxDuration' in nextProps) {
            if (!didWarnAboutMaxDuration) {
                didWarnAboutMaxDuration = true;
                warning$1(false, "maxDuration has been removed from React. Remove the maxDuration prop.");
            }
        }
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.
        if (current$$1 === null) {
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) {
                tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
                if (enableSuspenseServerRenderer) {
                    var suspenseState = workInProgress.memoizedState;
                    if (suspenseState !== null) {
                        var dehydrated = suspenseState.dehydrated;
                        if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated, renderExpirationTime);
                    }
                }
            } // This is the initial mount. This branch is pretty simple because there's
            // no previous state that needs to be preserved.
            if (nextDidTimeout) {
                // Mount separate fragments for primary and fallback children.
                var nextFallbackChildren = nextProps.fallback;
                var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
                primaryChildFragment.return = workInProgress;
                if ((workInProgress.mode & BlockingMode) === NoMode) {
                    // Outside of blocking mode, we commit the effects from the
                    // partially completed, timed-out tree, too.
                    var progressedState = workInProgress.memoizedState;
                    var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
                    primaryChildFragment.child = progressedPrimaryChild;
                    var progressedChild = progressedPrimaryChild;
                    while(progressedChild !== null){
                        progressedChild.return = primaryChildFragment;
                        progressedChild = progressedChild.sibling;
                    }
                }
                var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
                fallbackChildFragment.return = workInProgress;
                primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                workInProgress.child = primaryChildFragment;
                return fallbackChildFragment;
            } else {
                // Mount the primary children without an intermediate fragment fiber.
                var nextPrimaryChildren = nextProps.children;
                workInProgress.memoizedState = null;
                return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
            }
        } else {
            // This is an update. This branch is more complicated because we need to
            // ensure the state of the primary children is preserved.
            var prevState = current$$1.memoizedState;
            if (prevState !== null) {
                if (enableSuspenseServerRenderer) {
                    var _dehydrated = prevState.dehydrated;
                    if (_dehydrated !== null) {
                        if (!didSuspend) return updateDehydratedSuspenseComponent(current$$1, workInProgress, _dehydrated, prevState, renderExpirationTime);
                        else if (workInProgress.memoizedState !== null) {
                            // Something suspended and we should still be in dehydrated mode.
                            // Leave the existing child in place.
                            workInProgress.child = current$$1.child; // The dehydrated completion pass expects this flag to be there
                            // but the normal suspense pass doesn't.
                            workInProgress.effectTag |= DidCapture;
                            return null;
                        } else {
                            // Suspended but we should no longer be in dehydrated mode.
                            // Therefore we now have to render the fallback. Wrap the children
                            // in a fragment fiber to keep them separate from the fallback
                            // children.
                            var _nextFallbackChildren = nextProps.fallback;
                            var _primaryChildFragment = createFiberFromFragment(// going to render this fragment.
                            null, mode, NoWork, null);
                            _primaryChildFragment.return = workInProgress; // This is always null since we never want the previous child
                            // that we're not going to hydrate.
                            _primaryChildFragment.child = null;
                            if ((workInProgress.mode & BlockingMode) === NoMode) {
                                // Outside of blocking mode, we commit the effects from the
                                // partially completed, timed-out tree, too.
                                var _progressedChild = _primaryChildFragment.child = workInProgress.child;
                                while(_progressedChild !== null){
                                    _progressedChild.return = _primaryChildFragment;
                                    _progressedChild = _progressedChild.sibling;
                                }
                            } else // We will have dropped the effect list which contains the deletion.
                            // We need to reconcile to delete the current child.
                            reconcileChildFibers(workInProgress, current$$1.child, null, renderExpirationTime);
                             // Because primaryChildFragment is a new fiber that we're inserting as the
                            // parent of a new tree, we need to set its treeBaseDuration.
                            if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
                                // treeBaseDuration is the sum of all the child tree base durations.
                                var treeBaseDuration = 0;
                                var hiddenChild = _primaryChildFragment.child;
                                while(hiddenChild !== null){
                                    treeBaseDuration += hiddenChild.treeBaseDuration;
                                    hiddenChild = hiddenChild.sibling;
                                }
                                _primaryChildFragment.treeBaseDuration = treeBaseDuration;
                            } // Create a fragment from the fallback children, too.
                            var _fallbackChildFragment = createFiberFromFragment(_nextFallbackChildren, mode, renderExpirationTime, null);
                            _fallbackChildFragment.return = workInProgress;
                            _primaryChildFragment.sibling = _fallbackChildFragment;
                            _fallbackChildFragment.effectTag |= Placement;
                            _primaryChildFragment.childExpirationTime = NoWork;
                            workInProgress.memoizedState = SUSPENDED_MARKER;
                            workInProgress.child = _primaryChildFragment; // Skip the primary children, and continue working on the
                            // fallback children.
                            return _fallbackChildFragment;
                        }
                    }
                } // The current tree already timed out. That means each child set is
                // wrapped in a fragment fiber.
                var currentPrimaryChildFragment = current$$1.child;
                var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
                if (nextDidTimeout) {
                    // Still timed out. Reuse the current primary children by cloning
                    // its fragment. We're going to skip over these entirely.
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps, NoWork);
                    _primaryChildFragment2.return = workInProgress;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState = workInProgress.memoizedState;
                        var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                        if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                            _primaryChildFragment2.child = _progressedPrimaryChild;
                            var _progressedChild2 = _progressedPrimaryChild;
                            while(_progressedChild2 !== null){
                                _progressedChild2.return = _primaryChildFragment2;
                                _progressedChild2 = _progressedChild2.sibling;
                            }
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration = 0;
                        var _hiddenChild = _primaryChildFragment2.child;
                        while(_hiddenChild !== null){
                            _treeBaseDuration += _hiddenChild.treeBaseDuration;
                            _hiddenChild = _hiddenChild.sibling;
                        }
                        _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
                    } // Clone the fallback child fragment, too. These we'll continue
                    // working on.
                    var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2, currentFallbackChildFragment.expirationTime);
                    _fallbackChildFragment2.return = workInProgress;
                    _primaryChildFragment2.sibling = _fallbackChildFragment2;
                    _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment2;
                    return _fallbackChildFragment2;
                } else {
                    // No longer suspended. Switch back to showing the primary children,
                    // and remove the intermediate fragment fiber.
                    var _nextPrimaryChildren = nextProps.children;
                    var currentPrimaryChild = currentPrimaryChildFragment.child;
                    var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
                    // children. Wait until the complete phase, after we've confirmed the
                    // fallback is no longer needed.
                    // TODO: Would it be better to store the fallback fragment on
                    // the stateNode?
                    // Continue rendering the children, like we normally do.
                    workInProgress.memoizedState = null;
                    return workInProgress.child = primaryChild;
                }
            } else {
                // The current tree has not already timed out. That means the primary
                // children are not wrapped in a fragment fiber.
                var _currentPrimaryChild = current$$1.child;
                if (nextDidTimeout) {
                    // Timed out. Wrap the children in a fragment fiber to keep them
                    // separate from the fallback children.
                    var _nextFallbackChildren3 = nextProps.fallback;
                    var _primaryChildFragment3 = createFiberFromFragment(// going to render this fragment.
                    null, mode, NoWork, null);
                    _primaryChildFragment3.return = workInProgress;
                    _primaryChildFragment3.child = _currentPrimaryChild;
                    if (_currentPrimaryChild !== null) _currentPrimaryChild.return = _primaryChildFragment3;
                     // Even though we're creating a new fiber, there are no new children,
                    // because we're reusing an already mounted tree. So we don't need to
                    // schedule a placement.
                    // primaryChildFragment.effectTag |= Placement;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState2 = workInProgress.memoizedState;
                        var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                        _primaryChildFragment3.child = _progressedPrimaryChild2;
                        var _progressedChild3 = _progressedPrimaryChild2;
                        while(_progressedChild3 !== null){
                            _progressedChild3.return = _primaryChildFragment3;
                            _progressedChild3 = _progressedChild3.sibling;
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration2 = 0;
                        var _hiddenChild2 = _primaryChildFragment3.child;
                        while(_hiddenChild2 !== null){
                            _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                            _hiddenChild2 = _hiddenChild2.sibling;
                        }
                        _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
                    } // Create a fragment from the fallback children, too.
                    var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
                    _fallbackChildFragment3.return = workInProgress;
                    _primaryChildFragment3.sibling = _fallbackChildFragment3;
                    _fallbackChildFragment3.effectTag |= Placement;
                    _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment3;
                    return _fallbackChildFragment3;
                } else {
                    // Still haven't timed out.  Continue rendering the children, like we
                    // normally do.
                    workInProgress.memoizedState = null;
                    var _nextPrimaryChildren2 = nextProps.children;
                    return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
                }
            }
        }
    }
    function retrySuspenseComponentWithoutHydrating(current$$1, workInProgress, renderExpirationTime) {
        // We're now not suspended nor dehydrated.
        workInProgress.memoizedState = null; // Retry with the full children.
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children; // This will ensure that the children get Placement effects and
        // that the old child gets a Deletion effect.
        // We could also call forceUnmountCurrentAndReconcile.
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderExpirationTime) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & BlockingMode) === NoMode) {
            warning$1(false, "Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOM.createBlockingRoot(container, { hydrate: true }).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.expirationTime = Sync;
        } else if (isSuspenseInstanceFallback(suspenseInstance)) {
            // This is a client-only boundary. Since we won't get any content from the server
            // for this, we need to schedule that at a higher priority based on when it would
            // have timed out. In theory we could render it in this pass but it would have the
            // wrong priority associated with it and will prevent hydration of parent path.
            // Instead, we'll leave work left on it to render it in a separate commit.
            // TODO This time should be the time at which the server rendered response that is
            // a parent to this boundary was displayed. However, since we currently don't have
            // a protocol to transfer that time, we'll just estimate it by using the current
            // time. This will mean that Suspense timeouts are slightly shifted to later than
            // they should be.
            var serverDisplayTime = requestCurrentTimeForUpdate(); // Schedule a normal pri update to render this content.
            var newExpirationTime = computeAsyncExpiration(serverDisplayTime);
            if (enableSchedulerTracing) markSpawnedWork(newExpirationTime);
            workInProgress.expirationTime = newExpirationTime;
        } else {
            // We'll continue hydrating the rest at offscreen priority since we'll already
            // be showing the right content coming from the server, it is no rush.
            workInProgress.expirationTime = Never;
            if (enableSchedulerTracing) markSpawnedWork(Never);
        }
        return null;
    }
    function updateDehydratedSuspenseComponent(current$$1, workInProgress, suspenseInstance, suspenseState, renderExpirationTime) {
        // We should never be hydrating at this point because it is the first pass,
        // but after we've already committed once.
        warnIfHydrating();
        if ((workInProgress.mode & BlockingMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current$$1, workInProgress, renderExpirationTime);
        if (isSuspenseInstanceFallback(suspenseInstance)) // This boundary is in a permanent fallback state. In this case, we'll never
        // get an update and we'll never be able to hydrate the final content. Let's just try the
        // client side render instead.
        return retrySuspenseComponentWithoutHydrating(current$$1, workInProgress, renderExpirationTime);
         // We use childExpirationTime to indicate that a child might depend on context, so if
        // any context has changed, we need to treat is as if the input might have changed.
        var hasContextChanged$$1 = current$$1.childExpirationTime >= renderExpirationTime;
        if (didReceiveUpdate || hasContextChanged$$1) {
            // This boundary has changed since the first render. This means that we are now unable to
            // hydrate it. We might still be able to hydrate it using an earlier expiration time, if
            // we are rendering at lower expiration than sync.
            if (renderExpirationTime < Sync) {
                if (suspenseState.retryTime <= renderExpirationTime) {
                    // This render is even higher pri than we've seen before, let's try again
                    // at even higher pri.
                    var attemptHydrationAtExpirationTime = renderExpirationTime + 1;
                    suspenseState.retryTime = attemptHydrationAtExpirationTime;
                    scheduleWork(current$$1, attemptHydrationAtExpirationTime); // TODO: Early abort this render.
                }
            // so if we got here, we must have failed to hydrate at those levels. We must
            // now give up. Instead, we're going to delete the whole subtree and instead inject
            // a new real Suspense boundary to take its place, which may render content
            // or fallback. This might suspend for a while and if it does we might still have
            // an opportunity to hydrate before this pass commits.
            } // If we have scheduled higher pri work above, this will probably just abort the render
            // since we now have higher priority work, but in case it doesn't, we need to prepare to
            // render something, if we time out. Even if that requires us to delete everything and
            // skip hydration.
            // Delay having to do this as long as the suspense timeout allows us.
            renderDidSuspendDelayIfPossible();
            return retrySuspenseComponentWithoutHydrating(current$$1, workInProgress, renderExpirationTime);
        } else if (isSuspenseInstancePending(suspenseInstance)) {
            // This component is still pending more data from the server, so we can't hydrate its
            // content. We treat it as if this component suspended itself. It might seem as if
            // we could just try to render it client-side instead. However, this will perform a
            // lot of unnecessary work and is unlikely to complete since it often will suspend
            // on missing data anyway. Additionally, the server might be able to render more
            // than we can on the client yet. In that case we'd end up with more fallback states
            // on the client than if we just leave it alone. If the server times out or errors
            // these should update this boundary to the permanent Fallback state instead.
            // Mark it as having captured (i.e. suspended).
            workInProgress.effectTag |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
            workInProgress.child = current$$1.child; // Register a callback to retry this boundary once the server has sent the result.
            registerSuspenseInstanceRetry(suspenseInstance, retryDehydratedSuspenseBoundary.bind(null, current$$1));
            return null;
        } else {
            // This is the first attempt.
            reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance);
            var nextProps = workInProgress.pendingProps;
            var nextChildren = nextProps.children;
            var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.effectTag |= Hydrating;
                node = node.sibling;
            }
            workInProgress.child = child;
            return workInProgress.child;
        }
    }
    function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderExpirationTime);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    warning$1(false, '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    warning$1(false, '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    warning$1(false, '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else warning$1(false, '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                warning$1(false, '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                warning$1(false, '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
        if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            warning$1(false, "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else warning$1(false, 'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailExpiration = 0;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current$$1, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current$$1, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.effectTag |= DidCapture;
        } else {
            var didSuspendBefore = current$$1 !== null && (current$$1.effectTag & DidCapture) !== NoEffect;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // Outside of blocking mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current$$1, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current$$1 === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateContextProvider(current$$1, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
        }
        var newChildren = newProps.children;
        reconcileChildren(current$$1, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current$$1, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    warning$1(false, "Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        !(typeof render === 'function') && warningWithoutStack$1(false, "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$2.current = workInProgress;
        setCurrentPhase('render');
        newChildren = render(newValue);
        setCurrentPhase(null);
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateFundamentalComponent$1(current$$1, workInProgress, renderExpirationTime) {
        var fundamentalImpl = workInProgress.type.impl;
        if (fundamentalImpl.reconcileChildren === false) return null;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateScopeComponent(current$$1, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current$$1 !== null) // Reuse previous dependencies
        workInProgress.dependencies = current$$1.dependencies;
        if (enableProfilerTimer) // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning(workInProgress);
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) markUnprocessedUpdateTime(updateExpirationTime);
         // Check if the children have any pending work.
        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current$$1, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current$$1, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current$$1.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current$$1;
            returnFiber.lastEffect = current$$1;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current$$1;
        current$$1.nextEffect = null;
        current$$1.effectTag = Deletion;
        newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork$1(current$$1, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        if (workInProgress._debugNeedsRemount && current$$1 !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current$$1, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
        if (current$$1 !== null) {
            var oldProps = current$$1.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current$$1.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (updateExpirationTime < renderExpirationTime) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type, newProps)) {
                            if (enableSchedulerTracing) markSpawnedWork(Never);
                             // Schedule this fiber to re-render at offscreen priority. Then bailout.
                            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                            return null;
                        }
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        if (enableProfilerTimer) {
                            // Profiler should only call onRender when one of its descendants actually rendered.
                            var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                            if (hasChildWork) workInProgress.effectTag |= Update;
                        }
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            if (enableSuspenseServerRenderer) {
                                if (state.dehydrated !== null) {
                                    pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                                    // been unsuspended it has committed as a resolved Suspense component.
                                    // If it needs to be retried, it should have work scheduled on it.
                                    workInProgress.effectTag |= DidCapture;
                                    break;
                                }
                            } // If this boundary is currently timed out, we need to decide
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                            if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime);
                            else {
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current$$1.effectTag & DidCapture) !== NoEffect;
                        var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current$$1, workInProgress, renderExpirationTime);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.effectTag |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                }
                return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
            } else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear the expiration time.
        workInProgress.expirationTime = NoWork;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current$$1, workInProgress, workInProgress.type, renderExpirationTime);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current$$1, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current$$1, workInProgress, _Component, resolvedProps, renderExpirationTime);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current$$1, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            case HostRoot:
                return updateHostRoot(current$$1, workInProgress, renderExpirationTime);
            case HostComponent:
                return updateHostComponent(current$$1, workInProgress, renderExpirationTime);
            case HostText:
                return updateHostText(current$$1, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime);
            case HostPortal:
                return updatePortalComponent(current$$1, workInProgress, renderExpirationTime);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current$$1, workInProgress, type, _resolvedProps2, renderExpirationTime);
            case Fragment:
                return updateFragment(current$$1, workInProgress, renderExpirationTime);
            case Mode:
                return updateMode(current$$1, workInProgress, renderExpirationTime);
            case Profiler:
                return updateProfiler(current$$1, workInProgress, renderExpirationTime);
            case ContextProvider:
                return updateContextProvider(current$$1, workInProgress, renderExpirationTime);
            case ContextConsumer:
                return updateContextConsumer(current$$1, workInProgress, renderExpirationTime);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentName(_type2), getCurrentFiberStackInDev);
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current$$1, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current$$1, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current$$1, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current$$1, workInProgress, renderExpirationTime);
            case FundamentalComponent:
                if (enableFundamentalAPI) return updateFundamentalComponent$1(current$$1, workInProgress, renderExpirationTime);
                break;
            case ScopeComponent:
                if (enableScopeAPI) return updateScopeComponent(current$$1, workInProgress, renderExpirationTime);
                break;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function createFundamentalStateInstance(currentFiber, props, impl, state) {
        return {
            currentFiber: currentFiber,
            impl: impl,
            instance: null,
            prevProps: null,
            props: props,
            state: state
        };
    }
    function isFiberSuspenseAndTimedOut(fiber) {
        return fiber.tag === SuspenseComponent && fiber.memoizedState !== null;
    }
    function getSuspenseFallbackChild(fiber) {
        return fiber.child.sibling.child;
    }
    var emptyObject$1 = {};
    function collectScopedNodes(node, fn, scopedNodes) {
        if (enableScopeAPI) {
            if (node.tag === HostComponent) {
                var _type = node.type, memoizedProps = node.memoizedProps, stateNode = node.stateNode;
                var _instance = getPublicInstance(stateNode);
                if (_instance !== null && fn(_type, memoizedProps || emptyObject$1, _instance) === true) scopedNodes.push(_instance);
            }
            var child = node.child;
            if (isFiberSuspenseAndTimedOut(node)) child = getSuspenseFallbackChild(node);
            if (child !== null) collectScopedNodesFromChildren(child, fn, scopedNodes);
        }
    }
    function collectFirstScopedNode(node, fn) {
        if (enableScopeAPI) {
            if (node.tag === HostComponent) {
                var _type2 = node.type, memoizedProps = node.memoizedProps, stateNode = node.stateNode;
                var _instance2 = getPublicInstance(stateNode);
                if (_instance2 !== null && fn(_type2, memoizedProps, _instance2) === true) return _instance2;
            }
            var child = node.child;
            if (isFiberSuspenseAndTimedOut(node)) child = getSuspenseFallbackChild(node);
            if (child !== null) return collectFirstScopedNodeFromChildren(child, fn);
        }
        return null;
    }
    function collectScopedNodesFromChildren(startingChild, fn, scopedNodes) {
        var child = startingChild;
        while(child !== null){
            collectScopedNodes(child, fn, scopedNodes);
            child = child.sibling;
        }
    }
    function collectFirstScopedNodeFromChildren(startingChild, fn) {
        var child = startingChild;
        while(child !== null){
            var scopedNode = collectFirstScopedNode(child, fn);
            if (scopedNode !== null) return scopedNode;
            child = child.sibling;
        }
        return null;
    }
    function collectNearestScopeMethods(node, scope, childrenScopes) {
        if (isValidScopeNode(node, scope)) childrenScopes.push(node.stateNode.methods);
        else {
            var child = node.child;
            if (isFiberSuspenseAndTimedOut(node)) child = getSuspenseFallbackChild(node);
            if (child !== null) collectNearestChildScopeMethods(child, scope, childrenScopes);
        }
    }
    function collectNearestChildScopeMethods(startingChild, scope, childrenScopes) {
        var child = startingChild;
        while(child !== null){
            collectNearestScopeMethods(child, scope, childrenScopes);
            child = child.sibling;
        }
    }
    function isValidScopeNode(node, scope) {
        return node.tag === ScopeComponent && node.type === scope && node.stateNode !== null;
    }
    function createScopeMethods(scope, instance) {
        return {
            getChildren: function() {
                var currentFiber = instance.fiber;
                var child = currentFiber.child;
                var childrenScopes = [];
                if (child !== null) collectNearestChildScopeMethods(child, scope, childrenScopes);
                return childrenScopes.length === 0 ? null : childrenScopes;
            },
            getChildrenFromRoot: function() {
                var currentFiber = instance.fiber;
                var node = currentFiber;
                while(node !== null){
                    var parent = node.return;
                    if (parent === null) break;
                    node = parent;
                    if (node.tag === ScopeComponent && node.type === scope) break;
                }
                var childrenScopes = [];
                collectNearestChildScopeMethods(node.child, scope, childrenScopes);
                return childrenScopes.length === 0 ? null : childrenScopes;
            },
            getParent: function() {
                var node = instance.fiber.return;
                while(node !== null){
                    if (node.tag === ScopeComponent && node.type === scope) return node.stateNode.methods;
                    node = node.return;
                }
                return null;
            },
            getProps: function() {
                var currentFiber = instance.fiber;
                return currentFiber.memoizedProps;
            },
            queryAllNodes: function(fn) {
                var currentFiber = instance.fiber;
                var child = currentFiber.child;
                var scopedNodes = [];
                if (child !== null) collectScopedNodesFromChildren(child, fn, scopedNodes);
                return scopedNodes.length === 0 ? null : scopedNodes;
            },
            queryFirstNode: function(fn) {
                var currentFiber = instance.fiber;
                var child = currentFiber.child;
                if (child !== null) return collectFirstScopedNodeFromChildren(child, fn);
                return null;
            },
            containsNode: function(node) {
                var fiber = getInstanceFromNode(node);
                while(fiber !== null){
                    if (fiber.tag === ScopeComponent && fiber.type === scope && fiber.stateNode === instance) return true;
                    fiber = fiber.return;
                }
                return false;
            }
        };
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    if (supportsMutation) {
        // Mutation mode
        appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
            // We only have the top Fiber that was created but we need recurse down its
            // children to find all the terminal nodes.
            var node = workInProgress.child;
            while(node !== null){
                if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
                else if (enableFundamentalAPI && node.tag === FundamentalComponent) appendInitialChild(parent, node.stateNode.instance);
                else if (node.tag === HostPortal) ;
                else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === workInProgress) return;
                while(node.sibling === null){
                    if (node.return === null || node.return === workInProgress) return;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        };
        updateHostContainer = function(workInProgress) {};
        updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
            // If we have an alternate, that means this is an update and we need to
            // schedule a side-effect to do the updates.
            var oldProps = current.memoizedProps;
            if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
            // we won't touch this node even if children changed.
            return;
             // If we get updated because one of our children updated, we don't
            // have newProps so we'll have to reuse them.
            // TODO: Split the update API as separate for the props vs. children.
            // Even better would be if children weren't special cased at all tho.
            var instance = workInProgress.stateNode;
            var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
            // component is hitting the resume path. Figure out why. Possibly
            // related to `hidden`.
            var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
            workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
            // is a new ref we mark this as an update. All the work is done in commitWork.
            if (updatePayload) markUpdate(workInProgress);
        };
        updateHostText$1 = function(current, workInProgress, oldText, newText) {
            // If the text differs, mark it as an update. All the work in done in commitWork.
            if (oldText !== newText) markUpdate(workInProgress);
        };
    } else if (supportsPersistence) {
        // Persistent host tree mode
        appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
            // We only have the top Fiber that was created but we need recurse down its
            // children to find all the terminal nodes.
            var node = workInProgress.child;
            while(node !== null){
                // eslint-disable-next-line no-labels
                branches: if (node.tag === HostComponent) {
                    var instance = node.stateNode;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var props = node.memoizedProps;
                        var type = node.type;
                        instance = cloneHiddenInstance(instance, type, props, node);
                    }
                    appendInitialChild(parent, instance);
                } else if (node.tag === HostText) {
                    var _instance = node.stateNode;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var text = node.memoizedProps;
                        _instance = cloneHiddenTextInstance(_instance, text, node);
                    }
                    appendInitialChild(parent, _instance);
                } else if (enableFundamentalAPI && node.tag === FundamentalComponent) {
                    var _instance2 = node.stateNode.instance;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var _props = node.memoizedProps;
                        var _type = node.type;
                        _instance2 = cloneHiddenInstance(_instance2, _type, _props, node);
                    }
                    appendInitialChild(parent, _instance2);
                } else if (node.tag === HostPortal) ;
                else if (node.tag === SuspenseComponent) {
                    if ((node.effectTag & Update) !== NoEffect) {
                        // Need to toggle the visibility of the primary children.
                        var newIsHidden = node.memoizedState !== null;
                        if (newIsHidden) {
                            var primaryChildParent = node.child;
                            if (primaryChildParent !== null) {
                                if (primaryChildParent.child !== null) {
                                    primaryChildParent.child.return = primaryChildParent;
                                    appendAllChildren(parent, primaryChildParent, true, newIsHidden);
                                }
                                var fallbackChildParent = primaryChildParent.sibling;
                                if (fallbackChildParent !== null) {
                                    fallbackChildParent.return = node;
                                    node = fallbackChildParent;
                                    continue;
                                }
                            }
                        }
                    }
                    if (node.child !== null) {
                        // Continue traversing like normal
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                } else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                } // $FlowFixMe This is correct but Flow is confused by the labeled break.
                node;
                if (node === workInProgress) return;
                while(node.sibling === null){
                    if (node.return === null || node.return === workInProgress) return;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }; // An unfortunate fork of appendAllChildren because we have two different parent types.
        var appendAllChildrenToContainer = function(containerChildSet, workInProgress, needsVisibilityToggle, isHidden) {
            // We only have the top Fiber that was created but we need recurse down its
            // children to find all the terminal nodes.
            var node = workInProgress.child;
            while(node !== null){
                // eslint-disable-next-line no-labels
                branches: if (node.tag === HostComponent) {
                    var instance = node.stateNode;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var props = node.memoizedProps;
                        var type = node.type;
                        instance = cloneHiddenInstance(instance, type, props, node);
                    }
                    appendChildToContainerChildSet(containerChildSet, instance);
                } else if (node.tag === HostText) {
                    var _instance3 = node.stateNode;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var text = node.memoizedProps;
                        _instance3 = cloneHiddenTextInstance(_instance3, text, node);
                    }
                    appendChildToContainerChildSet(containerChildSet, _instance3);
                } else if (enableFundamentalAPI && node.tag === FundamentalComponent) {
                    var _instance4 = node.stateNode.instance;
                    if (needsVisibilityToggle && isHidden) {
                        // This child is inside a timed out tree. Hide it.
                        var _props2 = node.memoizedProps;
                        var _type2 = node.type;
                        _instance4 = cloneHiddenInstance(_instance4, _type2, _props2, node);
                    }
                    appendChildToContainerChildSet(containerChildSet, _instance4);
                } else if (node.tag === HostPortal) ;
                else if (node.tag === SuspenseComponent) {
                    if ((node.effectTag & Update) !== NoEffect) {
                        // Need to toggle the visibility of the primary children.
                        var newIsHidden = node.memoizedState !== null;
                        if (newIsHidden) {
                            var primaryChildParent = node.child;
                            if (primaryChildParent !== null) {
                                if (primaryChildParent.child !== null) {
                                    primaryChildParent.child.return = primaryChildParent;
                                    appendAllChildrenToContainer(containerChildSet, primaryChildParent, true, newIsHidden);
                                }
                                var fallbackChildParent = primaryChildParent.sibling;
                                if (fallbackChildParent !== null) {
                                    fallbackChildParent.return = node;
                                    node = fallbackChildParent;
                                    continue;
                                }
                            }
                        }
                    }
                    if (node.child !== null) {
                        // Continue traversing like normal
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                } else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                } // $FlowFixMe This is correct but Flow is confused by the labeled break.
                node;
                if (node === workInProgress) return;
                while(node.sibling === null){
                    if (node.return === null || node.return === workInProgress) return;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        };
        updateHostContainer = function(workInProgress) {
            var portalOrRoot = workInProgress.stateNode;
            var childrenUnchanged = workInProgress.firstEffect === null;
            if (childrenUnchanged) ;
            else {
                var container = portalOrRoot.containerInfo;
                var newChildSet = createContainerChildSet(container); // If children might have changed, we have to add them all to the set.
                appendAllChildrenToContainer(newChildSet, workInProgress, false, false);
                portalOrRoot.pendingChildren = newChildSet; // Schedule an update on the container to swap out the container.
                markUpdate(workInProgress);
                finalizeContainerChildren(container, newChildSet);
            }
        };
        updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
            var currentInstance = current.stateNode;
            var oldProps = current.memoizedProps; // If there are no effects associated with this node, then none of our children had any updates.
            // This guarantees that we can reuse all of them.
            var childrenUnchanged = workInProgress.firstEffect === null;
            if (childrenUnchanged && oldProps === newProps) {
                // No changes, just reuse the existing instance.
                // Note that this might release a previous clone.
                workInProgress.stateNode = currentInstance;
                return;
            }
            var recyclableInstance = workInProgress.stateNode;
            var currentHostContext = getHostContext();
            var updatePayload = null;
            if (oldProps !== newProps) updatePayload = prepareUpdate(recyclableInstance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
            if (childrenUnchanged && updatePayload === null) {
                // No changes, just reuse the existing instance.
                // Note that this might release a previous clone.
                workInProgress.stateNode = currentInstance;
                return;
            }
            var newInstance = cloneInstance(currentInstance, updatePayload, type, oldProps, newProps, workInProgress, childrenUnchanged, recyclableInstance);
            if (finalizeInitialChildren(newInstance, type, newProps, rootContainerInstance, currentHostContext)) markUpdate(workInProgress);
            workInProgress.stateNode = newInstance;
            if (childrenUnchanged) // If there are no other effects in this tree, we need to flag this node as having one.
            // Even though we're not going to use it for anything.
            // Otherwise parents won't know that there are new children to propagate upwards.
            markUpdate(workInProgress);
            else // If children might have changed, we have to add them all to the set.
            appendAllChildren(newInstance, workInProgress, false, false);
        };
        updateHostText$1 = function(current, workInProgress, oldText, newText) {
            if (oldText !== newText) {
                // If the text content differs, we'll create a new text instance for it.
                var rootContainerInstance = getRootHostContainer();
                var currentHostContext = getHostContext();
                workInProgress.stateNode = createTextInstance(newText, rootContainerInstance, currentHostContext, workInProgress); // We'll have to mark it as having an effect, even though we won't use the effect for anything.
                // This lets the parents know that at least one of their children has changed.
                markUpdate(workInProgress);
            }
        };
    } else {
        // No host operations
        updateHostContainer = function(workInProgress) {};
        updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {};
        updateHostText$1 = function(current, workInProgress, oldText, newText) {};
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                break;
            case LazyComponent:
                break;
            case SimpleMemoComponent:
            case FunctionComponent:
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                break;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                }
                updateHostContainer(workInProgress);
                break;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (enableFlareAPI) {
                        var prevListeners = current.memoizedProps.listeners;
                        var nextListeners = newProps.listeners;
                        if (prevListeners !== nextListeners) markUpdate(workInProgress);
                    }
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        break;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on we want to add then top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) {
                        // TODO: Move this and createInstance step into the beginPhase
                        // to consolidate.
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node needs to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                        if (enableFlareAPI) {
                            var listeners = newProps.listeners;
                            if (listeners != null) updateEventListeners(listeners, workInProgress, rootContainerInstance);
                        }
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners
                        workInProgress.stateNode = instance;
                        if (enableFlareAPI) {
                            var _listeners = newProps.listeners;
                            if (_listeners != null) updateEventListeners(_listeners, workInProgress, rootContainerInstance);
                        } // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance, currentHostContext)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                break;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                break;
            case ForwardRef:
                break;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if (enableSuspenseServerRenderer) {
                    if (nextState !== null && nextState.dehydrated !== null) {
                        if (current === null) {
                            var _wasHydrated3 = popHydrationState(workInProgress);
                            if (!_wasHydrated3) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            prepareToHydrateHostSuspenseInstance(workInProgress);
                            if (enableSchedulerTracing) markSpawnedWork(Never);
                            return null;
                        } else {
                            // We should never have been in a hydration state if we didn't have a current.
                            // However, in some of those paths, we might have reentered a hydration state
                            // and then we might be inside a hydration state. In that case, we'll need to
                            // exit out of it.
                            resetHydrationState();
                            if ((workInProgress.effectTag & DidCapture) === NoEffect) // This boundary did not suspend so it's now hydrated and unsuspended.
                            workInProgress.memoizedState = null;
                             // If nothing suspended, we need to schedule an effect to mark this boundary
                            // as having hydrated so events know that they're free be invoked.
                            // It's also a signal to replay events and the suspense callback.
                            // If something suspended, schedule an effect to attach retry listeners.
                            // So we might as well always mark this.
                            workInProgress.effectTag |= Update;
                            return null;
                        }
                    }
                }
                if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                    if (!nextDidTimeout && prevState !== null) {
                        // We just switched from the fallback to the normal children.
                        // Delete the fallback.
                        // TODO: Would it be better to store the fallback fragment on
                        // the stateNode during the begin phase?
                        var currentFallbackChild = current.child.sibling;
                        if (currentFallbackChild !== null) {
                            // Deletions go at the beginning of the return fiber's effect list
                            var first = workInProgress.firstEffect;
                            if (first !== null) {
                                workInProgress.firstEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = first;
                            } else {
                                workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = null;
                            }
                            currentFallbackChild.effectTag = Deletion;
                        }
                    }
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                if (supportsPersistence) // TODO: Only schedule updates if not prevDidTimeout.
                {
                    if (nextDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                    // retry listener to the proimse. This flag is also used to hide the
                    // primary children.
                    workInProgress.effectTag |= Update;
                }
                if (supportsMutation) // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                {
                    if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                    // retry listener to the proimse. This flag is also used to hide the
                    // primary children. In mutation mode, we also need the flag to
                    // *unhide* children that were previously hidden, so check if the
                    // is currently timed out, too.
                    workInProgress.effectTag |= Update;
                }
                if (enableSuspenseCallback && workInProgress.updateQueue !== null && workInProgress.memoizedProps.suspenseCallback != null) // Always notify the callback
                workInProgress.effectTag |= Update;
                break;
            case Fragment:
                break;
            case Mode:
                break;
            case Profiler:
                break;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                break;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                break;
            case ContextConsumer:
                break;
            case MemoComponent:
                break;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                break;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) break;
                var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.effectTag |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.effectTag |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.effectTag |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (now$1() > renderState.tailExpiration && renderExpirationTime > Never) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. If we can show
                            // them, then they really have the same priority as this render.
                            // So we'll pick it back up the very next render pass once we've had
                            // an opportunity to yield for paint.
                            var nextPriority = renderExpirationTime - 1;
                            workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                            if (enableSchedulerTracing) markSpawnedWork(nextPriority);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    if (renderState.tailExpiration === 0) {
                        // Heuristic for how long we're willing to spend rendering rows
                        // until we just give up and show what we have so far.
                        var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                        renderState.tailExpiration = now$1() + TAIL_EXPIRATION_TIMEOUT_MS;
                    } // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                break;
            case FundamentalComponent:
                if (enableFundamentalAPI) {
                    var fundamentalImpl = workInProgress.type.impl;
                    var fundamentalInstance = workInProgress.stateNode;
                    if (fundamentalInstance === null) {
                        var getInitialState = fundamentalImpl.getInitialState;
                        var fundamentalState;
                        if (getInitialState !== undefined) fundamentalState = getInitialState(newProps);
                        fundamentalInstance = workInProgress.stateNode = createFundamentalStateInstance(workInProgress, newProps, fundamentalImpl, fundamentalState || {});
                        var _instance5 = getFundamentalComponentInstance(fundamentalInstance);
                        fundamentalInstance.instance = _instance5;
                        if (fundamentalImpl.reconcileChildren === false) return null;
                        appendAllChildren(_instance5, workInProgress, false, false);
                        mountFundamentalComponent(fundamentalInstance);
                    } else {
                        // We fire update in commit phase
                        var prevProps = fundamentalInstance.props;
                        fundamentalInstance.prevProps = prevProps;
                        fundamentalInstance.props = newProps;
                        fundamentalInstance.currentFiber = workInProgress;
                        if (supportsPersistence) {
                            var _instance6 = cloneFundamentalInstance(fundamentalInstance);
                            fundamentalInstance.instance = _instance6;
                            appendAllChildren(_instance6, workInProgress, false, false);
                        }
                        var shouldUpdate = shouldUpdateFundamentalComponent(fundamentalInstance);
                        if (shouldUpdate) markUpdate(workInProgress);
                    }
                }
                break;
            case ScopeComponent:
                if (enableScopeAPI) {
                    if (current === null) {
                        var _type3 = workInProgress.type;
                        var scopeInstance = {
                            fiber: workInProgress,
                            methods: null
                        };
                        workInProgress.stateNode = scopeInstance;
                        scopeInstance.methods = createScopeMethods(_type3, scopeInstance);
                        if (enableFlareAPI) {
                            var _listeners2 = newProps.listeners;
                            if (_listeners2 != null) {
                                var _rootContainerInstance2 = getRootHostContainer();
                                updateEventListeners(_listeners2, workInProgress, _rootContainerInstance2);
                            }
                        }
                        if (workInProgress.ref !== null) {
                            markRef$1(workInProgress);
                            markUpdate(workInProgress);
                        }
                    } else {
                        if (enableFlareAPI) {
                            var _prevListeners = current.memoizedProps.listeners;
                            var _nextListeners = newProps.listeners;
                            if (_prevListeners !== _nextListeners || workInProgress.ref !== null) markUpdate(workInProgress);
                        } else if (workInProgress.ref !== null) markUpdate(workInProgress);
                        if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                    }
                }
                break;
            default:
                throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
        }
        return null;
    }
    function unwindWork(workInProgress, renderExpirationTime) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var effectTag = workInProgress.effectTag;
                if (effectTag & ShouldCapture) {
                    workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var _effectTag = workInProgress.effectTag;
                if (!((_effectTag & DidCapture) === NoEffect)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                if (enableSuspenseServerRenderer) {
                    var suspenseState = workInProgress.memoizedState;
                    if (suspenseState !== null && suspenseState.dehydrated !== null) {
                        if (!(workInProgress.alternate !== null)) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                        resetHydrationState();
                    }
                }
                var _effectTag2 = workInProgress.effectTag;
                if (_effectTag2 & ShouldCapture) {
                    workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            default:
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    var invokeGuardedCallbackImpl = function(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    };
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        var invokeGuardedCallbackDev = function(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://fb.me/react-crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
        };
        invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(capturedError) {
        return true;
    }
    function logCapturedError(capturedError) {
        var logError = showErrorDialog(capturedError); // Allow injected showErrorDialog() to prevent default console.error logging.
        // This enables renderers like ReactNative to better manage redbox behavior.
        if (logError === false) return;
        var error = capturedError.error;
        var componentName = capturedError.componentName, componentStack = capturedError.componentStack, errorBoundaryName = capturedError.errorBoundaryName, errorBoundaryFound = capturedError.errorBoundaryFound, willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
        // `preventDefault()` in window `error` handler.
        // We record this information as an expando on the error.
        if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) // The error is recoverable and was silenced.
            // Ignore it and don't print the stack addendum.
            // This is handy for testing error boundaries without noise.
            return;
             // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.
            console.error(error); // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
        }
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
        var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.
        if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
        } else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://fb.me/react-error-boundaries to learn more about error boundaries.";
        var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
        // We don't include the original error message and JS stack because the browser
        // has already printed it. Even if the application swallows the error, it is still
        // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
        console.error(combinedMessage);
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) stack = getStackByFiberInDevAndProd(source);
        var capturedError = {
            componentName: source !== null ? getComponentName(source.type) : null,
            componentStack: stack !== null ? stack : '',
            error: errorInfo.value,
            errorBoundary: null,
            errorBoundaryName: null,
            errorBoundaryFound: false,
            willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
            capturedError.errorBoundary = boundary.stateNode;
            capturedError.errorBoundaryName = getComponentName(boundary.type);
            capturedError.errorBoundaryFound = true;
            capturedError.willRetry = true;
        }
        try {
            logCapturedError(capturedError);
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var callComponentWillUnmountWithTimer = function(current$$1, instance) {
        startPhaseTimer(current$$1, 'componentWillUnmount');
        instance.props = current$$1.memoizedProps;
        instance.state = current$$1.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current$$1, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current$$1, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current$$1, unmountError);
        }
    }
    function safelyDetachRef(current$$1) {
        var ref = current$$1.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current$$1, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current$$1, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current$$1, error);
        }
    }
    function commitBeforeMutationLifeCycles(current$$1, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                commitHookEffectList(UnmountSnapshot, NoEffect$1, finishedWork);
                return;
            case ClassComponent:
                if (finishedWork.effectTag & Snapshot) {
                    if (current$$1 !== null) {
                        var prevProps = current$$1.memoizedProps;
                        var prevState = current$$1.memoizedState;
                        startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            !(instance.props === finishedWork.memoizedProps) && warning$1(false, "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            !(instance.state === finishedWork.memoizedState) && warning$1(false, "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            warningWithoutStack$1(false, "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                        stopPhaseTimer();
                    }
                }
                return;
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
            default:
                throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHookEffectList(unmountTag, mountTag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & unmountTag) !== NoEffect$1) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                if ((effect.tag & mountTag) !== NoEffect$1) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var _destroy = effect.destroy;
                    if (_destroy !== undefined && typeof _destroy !== 'function') {
                        var addendum = void 0;
                        if (_destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof _destroy.then === 'function') addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching";
                        else addendum = ' You returned: ' + _destroy;
                        warningWithoutStack$1(false, "An effect function must not return anything besides a function, which is used for clean-up.%s%s", addendum, getStackByFiberInDevAndProd(finishedWork));
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                commitHookEffectList(UnmountPassive, NoEffect$1, finishedWork);
                commitHookEffectList(NoEffect$1, MountPassive, finishedWork);
                break;
            default:
                break;
        }
    }
    function commitLifeCycles(finishedRoot, current$$1, finishedWork, committedExpirationTime) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                commitHookEffectList(UnmountLayout, MountLayout, finishedWork);
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.effectTag & Update) {
                    if (current$$1 === null) {
                        startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            !(instance.props === finishedWork.memoizedProps) && warning$1(false, "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            !(instance.state === finishedWork.memoizedState) && warning$1(false, "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidMount();
                        stopPhaseTimer();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current$$1.memoizedProps : resolveDefaultProps(finishedWork.type, current$$1.memoizedProps);
                        var prevState = current$$1.memoizedState;
                        startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            !(instance.props === finishedWork.memoizedProps) && warning$1(false, "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            !(instance.state === finishedWork.memoizedState) && warning$1(false, "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        stopPhaseTimer();
                    }
                }
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        !(instance.props === finishedWork.memoizedProps) && warning$1(false, "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        !(instance.state === finishedWork.memoizedState) && warning$1(false, "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance, committedExpirationTime);
                }
                return;
            case HostRoot:
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance, committedExpirationTime);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current$$1 === null && finishedWork.effectTag & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props, finishedWork);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                if (enableProfilerTimer) {
                    var onRender = finishedWork.memoizedProps.onRender;
                    if (typeof onRender === 'function') {
                        if (enableSchedulerTracing) onRender(finishedWork.memoizedProps.id, current$$1 === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                        else onRender(finishedWork.memoizedProps.id, current$$1 === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime());
                    }
                }
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
                return;
            default:
                throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        if (supportsMutation) {
            // We only have the top Fiber that was inserted but we need to recurse down its
            // children to find all the terminal nodes.
            var node = finishedWork;
            while(true){
                if (node.tag === HostComponent) {
                    var instance = node.stateNode;
                    if (isHidden) hideInstance(instance);
                    else unhideInstance(node.stateNode, node.memoizedProps);
                } else if (node.tag === HostText) {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
                    // Found a nested Suspense component that timed out. Skip over the
                    // primary child fragment, which should remain hidden.
                    var fallbackChildFragment = node.child.sibling;
                    fallbackChildFragment.return = node;
                    node = fallbackChildFragment;
                    continue;
                } else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === finishedWork) return;
                while(node.sibling === null){
                    if (node.return === null || node.return === finishedWork) return;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (enableScopeAPI && finishedWork.tag === ScopeComponent) instanceToUse = instance.methods;
            if (typeof ref === 'function') ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty('current')) warningWithoutStack$1(false, "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().%s", getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current$$1) {
        var currentRef = current$$1.ref;
        if (currentRef !== null) {
            if (typeof currentRef === 'function') currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current$$1, renderPriorityLevel) {
        onCommitUnmount(current$$1);
        switch(current$$1.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                var updateQueue = current$$1.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next; // When the owner fiber is deleted, the destroy function of a passive
                        // effect hook is called during the synchronous commit phase. This is
                        // a concession to implementation complexity. Calling it in the
                        // passive effect phase (like they usually are, when dependencies
                        // change during an update) would require either traversing the
                        // children of the deleted fiber again, or including unmount effects
                        // as part of the fiber effect list.
                        //
                        // Because this is during the sync commit phase, we need to change
                        // the priority.
                        //
                        // TODO: Reconsider this implementation trade off.
                        var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                        runWithPriority(priorityLevel, function() {
                            var effect = firstEffect;
                            do {
                                var destroy = effect.destroy;
                                if (destroy !== undefined) safelyCallDestroy(current$$1, destroy);
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        });
                    }
                }
                break;
            case ClassComponent:
                safelyDetachRef(current$$1);
                var instance = current$$1.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(current$$1, instance);
                return;
            case HostComponent:
                if (enableFlareAPI) {
                    var dependencies = current$$1.dependencies;
                    if (dependencies !== null) {
                        var respondersMap = dependencies.responders;
                        if (respondersMap !== null) {
                            var responderInstances = Array.from(respondersMap.values());
                            for(var i = 0, length = responderInstances.length; i < length; i++){
                                var responderInstance = responderInstances[i];
                                unmountResponderInstance(responderInstance);
                            }
                            dependencies.responders = null;
                        }
                    }
                }
                safelyDetachRef(current$$1);
                return;
            case HostPortal:
                // TODO: this is recursive.
                // We are also not using this parent because
                // the portal will get pushed immediately.
                if (supportsMutation) unmountHostComponents(finishedRoot, current$$1, renderPriorityLevel);
                else if (supportsPersistence) emptyPortalContainer(current$$1);
                return;
            case FundamentalComponent:
                if (enableFundamentalAPI) {
                    var fundamentalInstance = current$$1.stateNode;
                    if (fundamentalInstance !== null) {
                        unmountFundamentalComponent(fundamentalInstance);
                        current$$1.stateNode = null;
                    }
                }
                return;
            case DehydratedFragment:
                if (enableSuspenseCallback) {
                    var hydrationCallbacks = finishedRoot.hydrationCallbacks;
                    if (hydrationCallbacks !== null) {
                        var onDeleted = hydrationCallbacks.onDeleted;
                        if (onDeleted) onDeleted(current$$1.stateNode);
                    }
                }
                return;
            case ScopeComponent:
                if (enableScopeAPI) safelyDetachRef(current$$1);
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            (!supportsMutation || node.tag !== HostPortal)) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiber(current$$1) {
        var alternate = current$$1.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        current$$1.return = null;
        current$$1.child = null;
        current$$1.memoizedState = null;
        current$$1.updateQueue = null;
        current$$1.dependencies = null;
        current$$1.alternate = null;
        current$$1.firstEffect = null;
        current$$1.lastEffect = null;
        current$$1.pendingProps = null;
        current$$1.memoizedProps = null;
        if (alternate !== null) detachFiber(alternate);
    }
    function emptyPortalContainer(current$$1) {
        if (!supportsPersistence) return;
        var portal = current$$1.stateNode;
        var containerInfo = portal.containerInfo;
        var emptyChildSet = createContainerChildSet(containerInfo);
        replaceContainerChildren(containerInfo, emptyChildSet);
    }
    function commitContainer(finishedWork) {
        if (!supportsPersistence) return;
        switch(finishedWork.tag){
            case ClassComponent:
            case HostComponent:
            case HostText:
            case FundamentalComponent:
                return;
            case HostRoot:
            case HostPortal:
                var portalOrRoot = finishedWork.stateNode;
                var containerInfo = portalOrRoot.containerInfo, pendingChildren = portalOrRoot.pendingChildren;
                replaceContainerChildren(containerInfo, pendingChildren);
                return;
            default:
                throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.effectTag & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.effectTag & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        if (!supportsMutation) return;
         // Recursively insert all host nodes into the parent.
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
                if (enableFundamentalAPI) {
                    parent = parentStateNode.instance;
                    isContainer = false;
                }
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.effectTag & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            var isHost = node.tag === HostComponent || node.tag === HostText;
            if (isHost || enableFundamentalAPI && node.tag === FundamentalComponent) {
                var stateNode = isHost ? node.stateNode : node.stateNode.instance;
                if (before) {
                    if (isContainer) insertInContainerBefore(parent, stateNode, before);
                    else insertBefore(parent, stateNode, before);
                } else if (isContainer) appendChildToContainer(parent, stateNode);
                else appendChild(parent, stateNode);
            } else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function unmountHostComponents(finishedRoot, current$$1, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current$$1; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case FundamentalComponent:
                            if (enableFundamentalAPI) {
                                currentParent = parentStateNode.instance;
                                currentParentIsContainer = false;
                            }
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (enableFundamentalAPI && node.tag === FundamentalComponent) {
                var fundamentalNode = node.stateNode.instance;
                commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, fundamentalNode);
                else removeChild(currentParent, fundamentalNode);
            } else if (enableSuspenseServerRenderer && node.tag === DehydratedFragment) {
                if (enableSuspenseCallback) {
                    var hydrationCallbacks = finishedRoot.hydrationCallbacks;
                    if (hydrationCallbacks !== null) {
                        var onDeleted = hydrationCallbacks.onDeleted;
                        if (onDeleted) onDeleted(node.stateNode);
                    }
                } // Delete the dehydrated suspense boundary and all of its content.
                if (currentParentIsContainer) clearSuspenseBoundaryFromContainer(currentParent, node.stateNode);
                else clearSuspenseBoundary(currentParent, node.stateNode);
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current$$1) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current$$1) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current$$1, renderPriorityLevel) {
        if (supportsMutation) // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current$$1, renderPriorityLevel);
        else // Detach refs and call componentWillUnmount() on the whole subtree.
        commitNestedUnmounts(finishedRoot, current$$1, renderPriorityLevel);
        detachFiber(current$$1);
    }
    function commitWork(current$$1, finishedWork) {
        if (!supportsMutation) {
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    // Note: We currently never use MountMutation, but useLayout uses
                    // UnmountMutation.
                    commitHookEffectList(UnmountMutation, MountMutation, finishedWork);
                    return;
                case Profiler:
                    return;
                case SuspenseComponent:
                    commitSuspenseComponent(finishedWork);
                    attachSuspenseRetryListeners(finishedWork);
                    return;
                case SuspenseListComponent:
                    attachSuspenseRetryListeners(finishedWork);
                    return;
                case HostRoot:
                    if (supportsHydration) {
                        var root = finishedWork.stateNode;
                        if (root.hydrate) {
                            // We've just hydrated. No need to hydrate again.
                            root.hydrate = false;
                            commitHydratedContainer(root.containerInfo);
                        }
                    }
                    break;
            }
            commitContainer(finishedWork);
            return;
        }
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                // Note: We currently never use MountMutation, but useLayout uses
                // UnmountMutation.
                commitHookEffectList(UnmountMutation, MountMutation, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current$$1 !== null ? current$$1.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps, finishedWork);
                    if (enableFlareAPI) {
                        var prevListeners = oldProps.listeners;
                        var nextListeners = newProps.listeners;
                        if (prevListeners !== nextListeners) updateEventListeners(nextListeners, finishedWork, null);
                    }
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current$$1 !== null ? current$$1.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                if (supportsHydration) {
                    var _root = finishedWork.stateNode;
                    if (_root.hydrate) {
                        // We've just hydrated. No need to hydrate again.
                        _root.hydrate = false;
                        commitHydratedContainer(_root.containerInfo);
                    }
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
            case FundamentalComponent:
                if (enableFundamentalAPI) {
                    var fundamentalInstance = finishedWork.stateNode;
                    updateFundamentalComponent(fundamentalInstance);
                }
                return;
            case ScopeComponent:
                if (enableScopeAPI) {
                    var scopeInstance = finishedWork.stateNode;
                    scopeInstance.fiber = finishedWork;
                    if (enableFlareAPI) {
                        var _newProps = finishedWork.memoizedProps;
                        var _oldProps = current$$1 !== null ? current$$1.memoizedProps : _newProps;
                        var _prevListeners = _oldProps.listeners;
                        var _nextListeners = _newProps.listeners;
                        if (_prevListeners !== _nextListeners) updateEventListeners(_nextListeners, finishedWork, null);
                    }
                }
                return;
            default:
                throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) newDidTimeout = false;
        else {
            newDidTimeout = true;
            primaryChildParent = finishedWork.child;
            markCommitTimeOfFallback();
        }
        if (supportsMutation && primaryChildParent !== null) hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
        if (enableSuspenseCallback && newState !== null) {
            var suspenseCallback = finishedWork.memoizedProps.suspenseCallback;
            if (typeof suspenseCallback === 'function') {
                var thenables = finishedWork.updateQueue;
                if (thenables !== null) suspenseCallback(new Set(thenables));
            } else if (suspenseCallback !== undefined) warning$1(false, 'Unexpected type for suspenseCallback.');
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (!supportsHydration) return;
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current$$1 = finishedWork.alternate;
            if (current$$1 !== null) {
                var prevState = current$$1.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) {
                        commitHydratedSuspenseInstance(suspenseInstance);
                        if (enableSuspenseCallback) {
                            var hydrationCallbacks = finishedRoot.hydrationCallbacks;
                            if (hydrationCallbacks !== null) {
                                var onHydrated = hydrationCallbacks.onHydrated;
                                if (onHydrated) onHydrated(suspenseInstance);
                            }
                        }
                    }
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            thenables.forEach(function(thenable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
                if (!retryCache.has(thenable)) {
                    if (enableSchedulerTracing) {
                        if (thenable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    }
                    retryCache.add(thenable);
                    thenable.then(retry, retry);
                }
            });
        }
    }
    function commitResetTextContent(current$$1) {
        if (!supportsMutation) return;
        resetTextContent(current$$1.stateNode);
    }
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error = errorInfo.value;
            update.payload = function() {
                logError(fiber, errorInfo);
                return getDerivedStateFromError(error);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logError(fiber, errorInfo);
            }
            var error = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            !(fiber.expirationTime === Sync) && warningWithoutStack$1(false, "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || 'Unknown');
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
        } else {
            threadIDs = pingCache.get(thenable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(thenable, threadIDs);
            }
        }
        if (!threadIDs.has(renderExpirationTime)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(renderExpirationTime);
            var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
            thenable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a thenable.
            var thenable = value;
            checkForWrongSuspensePriorityInDEV(sourceFiber);
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var thenables = _workInProgress.updateQueue;
                    if (thenables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(thenable);
                        _workInProgress.updateQueue = updateQueue;
                    } else thenables.add(thenable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(Sync, null);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.expirationTime = Sync; // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. SuspenseConfig applies to
                    // this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, renderExpirationTime, thenable);
                    _workInProgress.effectTag |= ShouldCapture;
                    _workInProgress.expirationTime = renderExpirationTime;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.effectTag |= ShouldCapture;
                    workInProgress.expirationTime = renderExpirationTime;
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.effectTag |= ShouldCapture;
                        workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
                default:
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*                    */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The expiration time we're rendering
    var renderExpirationTime = NoWork; // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
    // This is conceptually a time stamp but expressed in terms of an ExpirationTime
    // because we deal mostly with expiration times in the hot path, so this avoids
    // the conversion happening in the hot path.
    var workInProgressRootLatestProcessedExpirationTime = Sync;
    var workInProgressRootLatestSuspenseTimeout = Sync;
    var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
    // This flag determines if it might be worthwhile to restart if an opportunity
    // happens latere.
    var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500;
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority;
    var pendingPassiveEffectsExpirationTime = NoWork;
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
    // time). However, if two updates are scheduled within the same event, we
    // should treat their start times as simultaneous, even if the actual clock
    // time has advanced between the first and second call.
    // In other words, because expiration times determine how updates are batched,
    // we want all updates of like priority that occur within the same event to
    // receive the same expiration time. Otherwise we get tearing.
    var currentEventTime = NoWork;
    function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return msToExpirationTime(now$1());
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoWork) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = msToExpirationTime(now$1());
        return currentEventTime;
    }
    function getCurrentTime() {
        return msToExpirationTime(now$1());
    }
    function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return Sync;
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) return priorityLevel === ImmediatePriority ? Sync : Batched;
        if ((executionContext & RenderContext) !== NoContext) // Use whatever time we're already rendering
        // TODO: Should there be a way to opt out, like with `runWithPriority`?
        return renderExpirationTime;
        var expirationTime;
        if (suspenseConfig !== null) // Compute an expiration time based on the Suspense timeout.
        expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        else // Compute an expiration time based on the Scheduler priority.
        switch(priorityLevel){
            case ImmediatePriority:
                expirationTime = Sync;
                break;
            case UserBlockingPriority:
                // TODO: Rename this to computeUserBlockingExpiration
                expirationTime = computeInteractiveExpiration(currentTime);
                break;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowPriority
                // TODO: Rename this to... something better.
                expirationTime = computeAsyncExpiration(currentTime);
                break;
            case IdlePriority:
                expirationTime = Idle;
                break;
            default:
                throw Error("Expected a valid priority level");
        }
         // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.
        if (workInProgressRoot !== null && expirationTime === renderExpirationTime) // This is a trick to move this update into a separate batch
        expirationTime -= 1;
        return expirationTime;
    }
    function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutInvalidUpdatesOnClassComponentsInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, expirationTime);
                if (executionContext === NoContext) // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                flushSyncCallbackQueue();
            }
        } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
        (priorityLevel === UserBlockingPriority || priorityLevel === ImmediatePriority)) {
            // This is the result of a discrete event. Track the lowest priority
            // discrete update per root so we can flush them early, if needed.
            if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Map([
                [
                    root,
                    expirationTime
                ]
            ]);
            else {
                var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
                if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
        }
    }
    var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) fiber.expirationTime = expirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) alternate.expirationTime = expirationTime;
         // Walk the parent path to the root and update the child expiration time.
        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) root = fiber.stateNode;
        else while(node !== null){
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
                node.childExpirationTime = expirationTime;
                if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            if (node.return === null && node.tag === HostRoot) {
                root = node.stateNode;
                break;
            }
            node = node.return;
        }
        if (root !== null) {
            if (workInProgressRoot === root) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that's unprocessed work on this root.
                markUnprocessedUpdateTime(expirationTime);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: This happens to work when receiving an update during the render
                // phase, because of the trick inside computeExpirationForFiber to
                // subtract 1 from `renderExpirationTime` to move it into a
                // separate bucket. But we should probably model it with an exception,
                // using the same mechanism we use to force hydration of a subtree.
                // TODO: This does not account for low pri updates that were already
                // scheduled before the root started rendering. Need to track the next
                // pending expiration time (perhaps by backtracking the return path) and
                // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
                markRootSuspendedAtTime(root, renderExpirationTime);
            } // Mark that the root has a pending update.
            markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
    }
    function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) return lastExpiredTime;
         // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.
        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) // The highest priority pending time is not suspended. Let's work on that.
        return firstPendingTime;
         // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.
        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        return lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the
    // expiration time of the existing task is the same as the expiration time of
    // the next level that the root has work on. This function is called on every
    // update, and right before exiting a task.
    function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
            // Special case: Expired work should flush synchronously.
            root.callbackExpirationTime = Sync;
            root.callbackPriority = ImmediatePriority;
            root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
            // There's nothing to work on.
            if (existingCallbackNode !== null) {
                root.callbackNode = null;
                root.callbackExpirationTime = NoWork;
                root.callbackPriority = NoPriority;
            }
            return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.
        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            var existingCallbackExpirationTime = root.callbackExpirationTime;
            if (existingCallbackExpirationTime === expirationTime && // Callback must have greater or equal priority.
            existingCallbackPriority >= priorityLevel) // Existing callback is sufficient.
            return;
             // Need to schedule a new task.
            // TODO: Instead of scheduling a new task, we should be able to change the
            // priority of the existing one.
            cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) // Sync React callbacks are scheduled on a special internal queue
        callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else if (disableSchedulerTimeoutBasedOnReactExpirationTime) callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        else callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root), // ordering because tasks are processed in timeout order.
        {
            timeout: expirationTimeToMs(expirationTime) - now$1()
        });
        root.callbackNode = callbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
            // The render task took too long to complete. Mark the current time as
            // expired to synchronously render all expired work in a single batch.
            var currentTime = requestCurrentTimeForUpdate();
            markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.
            ensureRootIsScheduled(root);
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
            var originalCallbackNode = root.callbackNode;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
            flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
            // and prepare a fresh one. Otherwise we'll continue where we left off.
            if (root !== workInProgressRoot || expirationTime !== renderExpirationTime) {
                prepareFreshStack(root, expirationTime);
                startWorkOnPendingInteractions(root, expirationTime);
            } // If we have a work-in-progress fiber, it means there's still work to do
            // in this root.
            if (workInProgress !== null) {
                var prevExecutionContext = executionContext;
                executionContext |= RenderContext;
                var prevDispatcher = pushDispatcher(root);
                var prevInteractions = pushInteractions(root);
                startWorkLoopTimer(workInProgress);
                for(;;)try {
                    workLoopConcurrent();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
                resetContextDependencies();
                executionContext = prevExecutionContext;
                popDispatcher(prevDispatcher);
                if (enableSchedulerTracing) popInteractions(prevInteractions);
                if (workInProgressRootExitStatus === RootFatalErrored) {
                    var fatalError = workInProgressRootFatalError;
                    stopInterruptedWorkLoopTimer();
                    prepareFreshStack(root, expirationTime);
                    markRootSuspendedAtTime(root, expirationTime);
                    ensureRootIsScheduled(root);
                    throw fatalError;
                }
                if (workInProgress !== null) // There's still work left over. Exit without committing.
                stopInterruptedWorkLoopTimer();
                else {
                    // We now have a consistent tree. The next step is either to commit it,
                    // or, if something suspended, wait to commit it after a timeout.
                    stopFinishedWorkLoopTimer();
                    var finishedWork = root.finishedWork = root.current.alternate;
                    root.finishedExpirationTime = expirationTime;
                    finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
                }
                ensureRootIsScheduled(root);
                if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
                // currently executed. Need to return a continuation.
                return performConcurrentWorkOnRoot.bind(null, root);
            }
        }
        return null;
    }
    function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // If this was an async render, the error may have happened due to
                // a mutation in a concurrent event. Try rendering one more time,
                // synchronously, to see if the error goes away. If there are
                // lower priority updates, let's include those, too, in case they
                // fix the inconsistency. Render at Idle to include all updates.
                // If it was Idle or Never or some not-yet-invented time, render
                // at that time.
                markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
                break;
            case RootSuspended:
                markRootSuspendedAtTime(root, expirationTime);
                var lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                flushSuspensePriorityWarningInDEV(); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                // If we have processed new updates during this render, we may now
                // have a new loading state ready. We want to ensure that we commit
                // that as soon as possible.
                var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
                if (hasNotProcessedNewUpdates && // do not delay if we're inside an act() scope
                !(flushSuspenseFallbacksInTests && IsThisRendererActing.current)) {
                    // If we have not processed any new updates during this pass, then
                    // this is either a retry of an existing fallback state or a
                    // hidden tree. Hidden trees shouldn't be batched with other work
                    // and after that's fixed it can only be a retry. We're going to
                    // throttle committing retries so that we don't show too many
                    // loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        if (workInProgressRootHasPendingPing) {
                            var lastPingedTime = root.lastPingedTime;
                            if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                                // This render was pinged but we didn't get to restart
                                // earlier so try restarting now instead.
                                root.lastPingedTime = expirationTime;
                                prepareFreshStack(root, expirationTime);
                                break;
                            }
                        }
                        var nextTime = getNextRootExpirationTimeToWorkOn(root);
                        if (nextTime !== NoWork && nextTime !== expirationTime) break;
                        if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            root.lastPingedTime = lastSuspendedTime;
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspendedAtTime(root, expirationTime);
                var _lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === _lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                flushSuspensePriorityWarningInDEV();
                if (!(flushSuspenseFallbacksInTests && IsThisRendererActing.current)) {
                    // We're suspended in a state that should be avoided. We'll try to
                    // avoid committing it for as long as the timeouts let us.
                    if (workInProgressRootHasPendingPing) {
                        var _lastPingedTime = root.lastPingedTime;
                        if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                            // This render was pinged but we didn't get to restart earlier
                            // so try restarting now instead.
                            root.lastPingedTime = expirationTime;
                            prepareFreshStack(root, expirationTime);
                            break;
                        }
                    }
                    var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                    if (_nextTime !== NoWork && _nextTime !== expirationTime) break;
                    if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                        // We should prefer to render the fallback of at the last
                        // suspended level. Ping the last suspended level to try
                        // rendering it again.
                        root.lastPingedTime = _lastSuspendedTime;
                        break;
                    }
                    var _msUntilTimeout;
                    if (workInProgressRootLatestSuspenseTimeout !== Sync) // We have processed a suspense config whose expiration time we
                    // can use as the timeout.
                    _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now$1();
                    else if (workInProgressRootLatestProcessedExpirationTime === Sync) // This should never normally happen because only new updates
                    // cause delayed states, so we should have processed something.
                    // However, this could also happen in an offscreen tree.
                    _msUntilTimeout = 0;
                    else {
                        // If we don't have a suspense config, we're going to use a
                        // heuristic to determine how long we can suspend.
                        var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                        var currentTimeMs = now$1();
                        var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                        var timeElapsed = currentTimeMs - eventTimeMs;
                        if (timeElapsed < 0) // We get this wrong some time since we estimate the time.
                        timeElapsed = 0;
                        _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                        // event time is exact instead of inferred from expiration time
                        // we don't need this.
                        if (timeUntilExpirationMs < _msUntilTimeout) _msUntilTimeout = timeUntilExpirationMs;
                    } // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                if (!(flushSuspenseFallbacksInTests && IsThisRendererActing.current) && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                    // If we have exceeded the minimum loading delay, which probably
                    // means we have shown a spinner already, we might have to suspend
                    // a bit longer to ensure that the spinner is shown for
                    // enough time.
                    var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                    if (_msUntilTimeout2 > 10) {
                        markRootSuspendedAtTime(root, expirationTime);
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                        break;
                    }
                }
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (root.finishedExpirationTime === expirationTime) // There's already a pending commit at this expiration time.
        // TODO: This is poorly factored. This case only exists for the
        // batch.commit() API.
        commitRoot(root);
        else {
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
            flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
            // and prepare a fresh one. Otherwise we'll continue where we left off.
            if (root !== workInProgressRoot || expirationTime !== renderExpirationTime) {
                prepareFreshStack(root, expirationTime);
                startWorkOnPendingInteractions(root, expirationTime);
            } // If we have a work-in-progress fiber, it means there's still work to do
            // in this root.
            if (workInProgress !== null) {
                var prevExecutionContext = executionContext;
                executionContext |= RenderContext;
                var prevDispatcher = pushDispatcher(root);
                var prevInteractions = pushInteractions(root);
                startWorkLoopTimer(workInProgress);
                for(;;)try {
                    workLoopSync();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
                resetContextDependencies();
                executionContext = prevExecutionContext;
                popDispatcher(prevDispatcher);
                if (enableSchedulerTracing) popInteractions(prevInteractions);
                if (workInProgressRootExitStatus === RootFatalErrored) {
                    var fatalError = workInProgressRootFatalError;
                    stopInterruptedWorkLoopTimer();
                    prepareFreshStack(root, expirationTime);
                    markRootSuspendedAtTime(root, expirationTime);
                    ensureRootIsScheduled(root);
                    throw fatalError;
                }
                if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
                else {
                    // We now have a consistent tree. Because this is a sync render, we
                    // will commit it even if something suspended.
                    stopFinishedWorkLoopTimer();
                    root.finishedWork = root.current.alternate;
                    root.finishedExpirationTime = expirationTime;
                    finishSyncRender(root, workInProgressRootExitStatus, expirationTime);
                } // Before exiting, make sure there's a callback scheduled for the next
                // pending level.
                ensureRootIsScheduled(root);
            }
        }
        return null;
    }
    function finishSyncRender(root, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        if (exitStatus === RootSuspended || exitStatus === RootSuspendedWithDelay) flushSuspensePriorityWarningInDEV();
        commitRoot(root);
    }
    function flushRoot(root, expirationTime) {
        markRootExpiredAtTime(root, expirationTime);
        ensureRootIsScheduled(root);
        if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbackQueue();
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) warning$1(false, "unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
             // We're already rendering, so we can't synchronously flush pending work.
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function deferredUpdates(fn) {
        // TODO: Remove in favor of Scheduler.next
        return runWithPriority(NormalPriority, fn);
    }
    function syncUpdates(fn, a, b, c) {
        return runWithPriority(ImmediatePriority, fn.bind(null, a, b, c));
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(expirationTime, root) {
                markRootExpiredAtTime(root, expirationTime);
                ensureRootIsScheduled(root);
            }); // Now flush the immediate queue.
            flushSyncCallbackQueue();
        }
    }
    function batchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function batchedEventUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function discreteUpdates(fn, a, b, c) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            // Should this
            return runWithPriority(UserBlockingPriority, fn.bind(null, a, b, c));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function flushSync(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return runWithPriority(ImmediatePriority, fn.bind(null, a));
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function flushControlled(fn) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            runWithPriority(ImmediatePriority, fn);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null, expirationTime);
        renderExpirationTime = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        if (enableSchedulerTracing) spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
        componentsThatTriggeredHighPriSuspend = null;
    }
    function handleError(root, thrownValue) {
        do {
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooks();
                resetCurrentFiber();
                if (workInProgress === null || workInProgress.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue;
                    return null;
                }
                if (enableProfilerTimer && workInProgress.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
                throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime);
                workInProgress = completeUnitOfWork(workInProgress);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher.current;
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher.current = prevDispatcher;
    }
    function pushInteractions(root) {
        if (enableSchedulerTracing) {
            var prevInteractions = tracing.__interactionsRef.current;
            tracing.__interactionsRef.current = root.memoizedInteractions;
            return prevInteractions;
        }
        return null;
    }
    function popInteractions(prevInteractions) {
        if (enableSchedulerTracing) tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now$1();
    }
    function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) workInProgressRootLatestProcessedExpirationTime = expirationTime;
        if (suspenseConfig !== null) {
            if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
                workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.
                workInProgressRootCanSuspendUsingConfig = suspenseConfig;
            }
        }
    }
    function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) workInProgressRootNextUnprocessedUpdateTime = expirationTime;
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there's a lower priority update somewhere else in the tree.
        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
            // Mark the current render as suspended, and then mark that there's a
            // pending update.
            // TODO: This should immediately interrupt the current render, instead
            // of waiting until the next time we yield.
            markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime);
            markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
    }
    function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)workInProgress = performUnitOfWork(workInProgress);
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())workInProgress = performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current$$1 = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if (enableProfilerTimer && (unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$$1(current$$1, unitOfWork, renderExpirationTime);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$$1(current$$1, unitOfWork, renderExpirationTime);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        next = completeUnitOfWork(unitOfWork);
        ReactCurrentOwner$1.current = null;
        return next;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current$$1 = workInProgress.alternate;
            var returnFiber = workInProgress.return; // Check if the work completed or if something threw.
            if ((workInProgress.effectTag & Incomplete) === NoEffect) {
                setCurrentFiber(workInProgress);
                var next = void 0;
                if (!enableProfilerTimer || (workInProgress.mode & ProfileMode) === NoMode) next = completeWork(current$$1, workInProgress, renderExpirationTime);
                else {
                    startProfilerTimer(workInProgress);
                    next = completeWork(current$$1, workInProgress, renderExpirationTime); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
                }
                stopWorkTimer(workInProgress);
                resetCurrentFiber();
                resetChildExpirationTime(workInProgress);
                if (next !== null) // Completing this fiber spawned new work. Work on that next.
                return next;
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.effectTag & Incomplete) === NoEffect) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = workInProgress.firstEffect;
                    if (workInProgress.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                        returnFiber.lastEffect = workInProgress.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (effectTag > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress;
                        else returnFiber.firstEffect = workInProgress;
                        returnFiber.lastEffect = workInProgress;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(workInProgress, renderExpirationTime); // Because this fiber did not complete, don't reset its expiration time.
                if (enableProfilerTimer && (workInProgress.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = workInProgress.actualDuration;
                    var child = workInProgress.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    workInProgress.actualDuration = actualDuration;
                }
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    // TODO: The name stopFailedWorkTimer is misleading because Suspense
                    // also captures and restarts.
                    stopFailedWorkTimer(workInProgress);
                    _next.effectTag &= HostEffectMask;
                    return _next;
                }
                stopWorkTimer(workInProgress);
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.effectTag |= Incomplete;
                }
            }
            var siblingFiber = workInProgress.sibling;
            if (siblingFiber !== null) // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
             // Otherwise, return to the parent
            workInProgress = returnFiber;
        }while (workInProgress !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
        return null;
    }
    function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
    }
    function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime !== Never && completedWork.childExpirationTime === Never) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.
        if (enableProfilerTimer && (completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                var childUpdateExpirationTime = child.expirationTime;
                var childChildExpirationTime = child.childExpirationTime;
                if (childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = childUpdateExpirationTime;
                if (childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = childChildExpirationTime;
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                var _childUpdateExpirationTime = _child.expirationTime;
                var _childChildExpirationTime = _child.childExpirationTime;
                if (_childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = _childUpdateExpirationTime;
                if (_childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = _childChildExpirationTime;
                _child = _child.sibling;
            }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            renderExpirationTime = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.
        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$1.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            startCommitSnapshotEffectsTimer();
            prepareForCommit(root.containerInfo);
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitSnapshotEffectsTimer();
            if (enableProfilerTimer) // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
             // The next phase is the mutation phase, where we mutate the host tree.
            startCommitHostEffectsTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitHostEffectsTimer();
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            startCommitLifeCyclesTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitLifeCyclesTimer();
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            if (enableSchedulerTracing) popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            // no effects.
            // TODO: Maybe there's a better way to report this.
            startCommitSnapshotEffectsTimer();
            stopCommitSnapshotEffectsTimer();
            if (enableProfilerTimer) recordCommitTime();
            startCommitHostEffectsTimer();
            stopCommitHostEffectsTimer();
            startCommitLifeCyclesTimer();
            stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsExpirationTime = expirationTime;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                nextEffect = nextNextEffect;
            }
        } // Check if there's remaining work on this root
        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
            if (enableSchedulerTracing) {
                if (spawnedWorkDuringRender !== null) {
                    var expirationTimes = spawnedWorkDuringRender;
                    spawnedWorkDuringRender = null;
                    for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
                }
                schedulePendingInteractions(root, remainingExpirationTime);
            }
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (enableSchedulerTracing) {
            if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
            // Otherwise, we'll wait until after the passive effects are flushed.
            // Wait to do this until after remaining work has been scheduled,
            // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
            finishPendingInteractions(root, expirationTime);
        }
        if (remainingExpirationTime === Sync) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // This is a legacy edge case. We just committed the initial mount of
        // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var effectTag = nextEffect.effectTag;
            if ((effectTag & Snapshot) !== NoEffect) {
                setCurrentFiber(nextEffect);
                recordEffect();
                var current$$1 = nextEffect.alternate;
                commitBeforeMutationLifeCycles(current$$1, nextEffect);
                resetCurrentFiber();
            }
            if ((effectTag & Passive) !== NoEffect) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & ContentReset) commitResetTextContent(nextEffect);
            if (effectTag & Ref) {
                var current$$1 = nextEffect.alternate;
                if (current$$1 !== null) commitDetachRef(current$$1);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
            switch(primaryEffectTag){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.effectTag &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.effectTag &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.effectTag &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.effectTag &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect, renderPriorityLevel);
                    break;
            } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.
            recordEffect();
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & (Update | Callback)) {
                recordEffect();
                var current$$1 = nextEffect.alternate;
                commitLifeCycles(root, current$$1, nextEffect, committedExpirationTime);
            }
            if (effectTag & Ref) {
                recordEffect();
                commitAttachRef(nextEffect);
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority;
            return runWithPriority(priorityLevel, flushPassiveEffectsImpl);
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root); // Note: This currently assumes there are no passive effects on the root
        // fiber, because the root is not part of its own effect list. This could
        // change in the future.
        var effect = root.current.firstEffect;
        while(effect !== null){
            setCurrentFiber(effect);
            invokeGuardedCallback(null, commitPassiveHookEffects, null, effect);
            if (hasCaughtError()) {
                if (!(effect !== null)) throw Error("Should be working on an effect.");
                var error = clearCaughtError();
                captureCommitPhaseError(effect, error);
            }
            resetCurrentFiber();
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC
            effect.nextEffect = null;
            effect = nextNextEffect;
        }
        if (enableSchedulerTracing) {
            popInteractions(prevInteractions);
            finishPendingInteractions(root, expirationTime);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, Sync);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, Sync);
                    enqueueUpdate(fiber, update);
                    var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
                    if (root !== null) {
                        ensureRootIsScheduled(root);
                        schedulePendingInteractions(root, Sync);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(thenable);
        if (workInProgressRoot === root && renderExpirationTime === suspendedTime) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, we'll always suspend so we can always
            // restart. If we're suspended without any updates, it might be a retry.
            // If it's early in the retry we can restart. We can't know for sure
            // whether we'll eventually process an update during this render pass,
            // but it's somewhat unlikely that we get to a ping before that, since
            // getting to the root most update is usually very fast.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
            return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) // The root is no longer suspended at this time.
        return;
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) // There's already a lower priority ping scheduled.
        return;
         // Mark the time at which this ping was scheduled.
        root.lastPingedTime = suspendedTime;
        if (root.finishedExpirationTime === suspendedTime) {
            // If there's a pending fallback waiting to commit, throw it away.
            root.finishedExpirationTime = NoWork;
            root.finishedWork = null;
        }
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
            var suspenseConfig = null; // Retries don't carry over the already committed update.
            var currentTime = requestCurrentTimeForUpdate();
            retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?
        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, retryTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryTime = NoWork;
        if (suspenseState !== null) retryTime = suspenseState.retryTime;
        retryTimedOutBoundary(boundaryFiber, retryTime);
    }
    function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default
        var retryCache;
        if (enableSuspenseServerRenderer) switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryTime = suspenseState.retryTime;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        else retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(thenable);
        retryTimedOutBoundary(boundaryFiber, retryTime);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) return 0;
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.
        var currentTimeMs = now$1();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) // If we haven't yet waited longer than the initial delay, we don't
        // have to wait any additional time.
        return 0;
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.
        return msUntilTimeout;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            warning$1(false, "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        if (warnAboutDeprecatedLifecycles) ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (enableUserTimingAPI && workInProgressRoot !== null && updateExpirationTime > renderExpirationTime) interruptedBy = fiberThatReceivedUpdate;
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        warningWithoutStack$1(false, "Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.%s", tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
    }
    var beginWork$$1;
    if (replayFailedUnitOfWorkWithInvokeGuardedCallback) {
        var dummyFiber = null;
        beginWork$$1 = function(current$$1, unitOfWork, expirationTime) {
            // If a component throws an error, we replay it again in a synchronously
            // dispatched event, so that the debugger will treat it as an uncaught
            // error See ReactErrorUtils for more information.
            // Before entering the begin phase, copy the work-in-progress onto a dummy
            // fiber. If beginWork throws, we'll use this to reset the state.
            var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
            try {
                return beginWork$1(current$$1, unitOfWork, expirationTime);
            } catch (originalError) {
                if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises. Treat everything else like an error.
                throw originalError;
                 // Keep this code in sync with handleError; any changes here must have
                // corresponding changes there.
                resetContextDependencies();
                resetHooks(); // Don't reset current debug fiber, since we're about to work on the
                // same fiber again.
                // Unwind the failed stack frame
                unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
                assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
                if (enableProfilerTimer && unitOfWork.mode & ProfileMode) // Reset the profiler timer.
                startProfilerTimer(unitOfWork);
                 // Run beginWork again.
                invokeGuardedCallback(null, beginWork$1, null, current$$1, unitOfWork, expirationTime);
                if (hasCaughtError()) {
                    var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                    // Rethrow this error instead of the original one.
                    throw replayError;
                } else // This branch is reachable if the render phase is impure.
                throw originalError;
            }
        };
    } else beginWork$$1 = beginWork$1;
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInGetChildContext = false;
    function warnAboutInvalidUpdatesOnClassComponentsInDEV(fiber) {
        if (fiber.tag === ClassComponent) switch(phase){
            case 'getChildContext':
                if (didWarnAboutUpdateInGetChildContext) return;
                warningWithoutStack$1(false, 'setState(...): Cannot call setState() inside getChildContext()');
                didWarnAboutUpdateInGetChildContext = true;
                break;
            case 'render':
                if (didWarnAboutUpdateInRender) return;
                warningWithoutStack$1(false, "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                didWarnAboutUpdateInRender = true;
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (warnsIfNotActing === true && IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) warningWithoutStack$1(false, "It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from 'react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);%s", getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if (warnsIfNotActing === true && (fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) warningWithoutStack$1(false, "An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (warnsIfNotActing === true && executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) warningWithoutStack$1(false, "An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                warningWithoutStack$1(false, "In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://fb.me/react-mock-scheduler");
            } else if (warnAboutUnmockedScheduler === true) {
                didWarnAboutUnmockedScheduler = true;
                warningWithoutStack$1(false, "Starting from React v17, the \"scheduler\" module will need to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://fb.me/react-mock-scheduler");
            }
        }
    }
    var componentsThatTriggeredHighPriSuspend = null;
    function checkForWrongSuspensePriorityInDEV(sourceFiber) {
        var currentPriorityLevel = getCurrentPriorityLevel();
        if ((sourceFiber.mode & ConcurrentMode) !== NoEffect && (currentPriorityLevel === UserBlockingPriority || currentPriorityLevel === ImmediatePriority)) {
            var workInProgressNode = sourceFiber;
            while(workInProgressNode !== null){
                // Add the component that triggered the suspense
                var current$$1 = workInProgressNode.alternate;
                if (current$$1 !== null) // TODO: warn component that triggers the high priority
                // suspend is the HostRoot
                switch(workInProgressNode.tag){
                    case ClassComponent:
                        // Loop through the component's update queue and see whether the component
                        // has triggered any high priority updates
                        var updateQueue = current$$1.updateQueue;
                        if (updateQueue !== null) {
                            var update = updateQueue.firstUpdate;
                            while(update !== null){
                                var priorityLevel = update.priority;
                                if (priorityLevel === UserBlockingPriority || priorityLevel === ImmediatePriority) {
                                    if (componentsThatTriggeredHighPriSuspend === null) componentsThatTriggeredHighPriSuspend = new Set([
                                        getComponentName(workInProgressNode.type)
                                    ]);
                                    else componentsThatTriggeredHighPriSuspend.add(getComponentName(workInProgressNode.type));
                                    break;
                                }
                                update = update.next;
                            }
                        }
                        break;
                    case FunctionComponent:
                    case ForwardRef:
                    case SimpleMemoComponent:
                        if (workInProgressNode.memoizedState !== null && workInProgressNode.memoizedState.baseUpdate !== null) {
                            var _update = workInProgressNode.memoizedState.baseUpdate; // Loop through the functional component's memoized state to see whether
                            // the component has triggered any high pri updates
                            while(_update !== null){
                                var priority = _update.priority;
                                if (priority === UserBlockingPriority || priority === ImmediatePriority) {
                                    if (componentsThatTriggeredHighPriSuspend === null) componentsThatTriggeredHighPriSuspend = new Set([
                                        getComponentName(workInProgressNode.type)
                                    ]);
                                    else componentsThatTriggeredHighPriSuspend.add(getComponentName(workInProgressNode.type));
                                    break;
                                }
                                if (_update.next === workInProgressNode.memoizedState.baseUpdate) break;
                                _update = _update.next;
                            }
                        }
                        break;
                    default:
                        break;
                }
                workInProgressNode = workInProgressNode.return;
            }
        }
    }
    function flushSuspensePriorityWarningInDEV() {
        if (componentsThatTriggeredHighPriSuspend !== null) {
            var componentNames = [];
            componentsThatTriggeredHighPriSuspend.forEach(function(name) {
                return componentNames.push(name);
            });
            componentsThatTriggeredHighPriSuspend = null;
            if (componentNames.length > 0) warningWithoutStack$1(false, "%s triggered a user-blocking update that suspended.\n\nThe fix is to split the update into multiple parts: a user-blocking update to provide immediate feedback, and another update that triggers the bulk of the changes.\n\nRefer to the documentation for useTransition to learn how to implement this pattern.", componentNames.sort().join(', '));
        }
    }
    function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(expirationTime) {
        if (!enableSchedulerTracing) return;
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            expirationTime
        ];
        else spawnedWorkDuringRender.push(expirationTime);
    }
    function scheduleInteractions(root, expirationTime, interactions) {
        if (!enableSchedulerTracing) return;
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(expirationTime);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, expirationTime) {
        // This is called when work is scheduled on a root.
        // It associates the current interactions with the newly-scheduled expiration.
        // They will be restored when that expiration is later committed.
        if (!enableSchedulerTracing) return;
        scheduleInteractions(root, expirationTime, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, expirationTime) {
        // This is called when new work is started on a root.
        if (!enableSchedulerTracing) return;
         // Determine which interactions this batch of work currently includes, So that
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
            if (scheduledExpirationTime >= expirationTime) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedExpirationTime) {
        if (!enableSchedulerTracing) return;
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                var threadID = computeThreadID(root, committedExpirationTime);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
                    pendingInteractionMap.delete(scheduledExpirationTime);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    }
    var onCommitFiberRoot = null;
    var onCommitFiberUnmount = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            warningWithoutStack$1(false, "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://fb.me/react-devtools");
            return true;
        }
        try {
            var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            onCommitFiberRoot = function(root, expirationTime) {
                try {
                    var didError = (root.current.effectTag & DidCapture) === DidCapture;
                    if (enableProfilerTimer) {
                        var currentTime = getCurrentTime();
                        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                        hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
                    } else hook.onCommitFiberRoot(rendererID, root, undefined, didError);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        warningWithoutStack$1(false, 'React DevTools encountered an error: %s', err);
                    }
                }
            };
            onCommitFiberUnmount = function(fiber) {
                try {
                    hook.onCommitFiberUnmount(rendererID, fiber);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        warningWithoutStack$1(false, 'React DevTools encountered an error: %s', err);
                    }
                }
            };
        } catch (err) {
            warningWithoutStack$1(false, 'React DevTools encountered an error: %s.', err);
        } // DevTools exists
        return true;
    }
    function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === 'function') onCommitFiberRoot(root, expirationTime);
    }
    function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') onCommitFiberUnmount(fiber);
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        var testMap = new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        var testSet = new Set([
            nonExtensibleObject
        ]); // This is necessary for Rollup to not consider these unused.
        // https://github.com/rollup/rollup/issues/1771
        // TODO: we can remove these if Rollup fixes the bug.
        testMap.set(0, 0);
        testSet.add(0);
    } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        if (enableProfilerTimer) {
            // Note: The following is done to avoid a v8 performance cliff.
            //
            // Initializing the fields below to smis and later updating them with
            // double values will cause Fibers to end up having separate shapes.
            // This behavior/bug has something to do with Object.preventExtension().
            // Fortunately this only impacts DEV builds.
            // Unfortunately it makes React unusably slow for some applications.
            // To work around this, initialize the fields below with doubles.
            //
            // Learn more about this here:
            // https://github.com/facebook/react/issues/14365
            // https://bugs.chromium.org/p/v8/issues/detail?id=8538
            this.actualDuration = Number.NaN;
            this.actualStartTime = Number.NaN;
            this.selfBaseDuration = Number.NaN;
            this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
            // This won't trigger the performance cliff mentioned above,
            // and it simplifies other profiler code (including DevTools).
            this.actualDuration = 0;
            this.actualStartTime = -1;
            this.selfBaseDuration = 0;
            this.treeBaseDuration = 0;
        } // This is normally DEV-only except www when it adds listeners.
        // TODO: remove the User Timing integration in favor of Root Events.
        if (enableUserTimingAPI) {
            this._debugID = debugCounter++;
            this._debugIsCurrentlyTiming = false;
        }
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps, expirationTime) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.effectTag = NoEffect; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            if (enableProfilerTimer) {
                // We intentionally reset, rather than copy, actualDuration & actualStartTime.
                // This prevents time from endlessly accumulating in new commits.
                // This has the downside of resetting values for different priority renders,
                // But works for yielding (the common case) and should support resuming.
                workInProgress.actualDuration = 0;
                workInProgress.actualStartTime = -1;
            }
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        if (enableProfilerTimer) {
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
            default:
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childExpirationTime = NoWork;
            workInProgress.expirationTime = renderExpirationTime;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            if (enableProfilerTimer) {
                // Note: We don't reset the actualTime counts. It's useful to accumulate
                // actual time across multiple render passes.
                workInProgress.selfBaseDuration = 0;
                workInProgress.treeBaseDuration = 0;
            }
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childExpirationTime = current.childExpirationTime;
            workInProgress.expirationTime = current.expirationTime;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                expirationTime: currentDependencies.expirationTime,
                firstContext: currentDependencies.firstContext,
                responders: currentDependencies.responders
            };
            if (enableProfilerTimer) {
                // Note: We don't reset the actualTime counts. It's useful to accumulate
                // actual time across multiple render passes.
                workInProgress.selfBaseDuration = current.selfBaseDuration;
                workInProgress.treeBaseDuration = current.treeBaseDuration;
            }
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (enableProfilerTimer && isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
                fiberTag = Mode;
                mode |= ConcurrentMode | BlockingMode | StrictMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_FUNDAMENTAL_TYPE:
                        if (enableFundamentalAPI) return createFiberFromFundamental(type, pendingProps, mode, expirationTime, key);
                        break;
                    case REACT_SCOPE_TYPE:
                        if (enableScopeAPI) return createFiberFromScope(type, pendingProps, mode, expirationTime, key);
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromFundamental(fundamentalComponent, pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(FundamentalComponent, pendingProps, key, mode);
        fiber.elementType = fundamentalComponent;
        fiber.type = fundamentalComponent;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromScope(scope, pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(ScopeComponent, pendingProps, key, mode);
        fiber.type = scope;
        fiber.elementType = scope;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') warningWithoutStack$1(false, 'Profiler must specify an "id" string and "onRender" function as props');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        if (enableProfilerTimer) {
            target.actualDuration = source.actualDuration;
            target.actualStartTime = source.actualStartTime;
            target.selfBaseDuration = source.selfBaseDuration;
            target.treeBaseDuration = source.treeBaseDuration;
        }
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        if (enableSchedulerTracing) {
            this.interactionThreadID = tracing.unstable_getThreadID();
            this.memoizedInteractions = new Set();
            this.pendingInteractionMap = new Map();
        }
        if (enableSuspenseCallback) this.hydrationCallbacks = null;
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        if (enableSuspenseCallback) root.hydrationCallbacks = hydrationCallbacks;
         // Cyclic construction. This cheats the type system right now because
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        return root;
    }
    function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
    }
    function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) root.firstSuspendedTime = expirationTime;
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) root.lastSuspendedTime = expirationTime;
        if (expirationTime <= root.lastPingedTime) root.lastPingedTime = NoWork;
        if (expirationTime <= root.lastExpiredTime) root.lastExpiredTime = NoWork;
    }
    function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) root.firstPendingTime = expirationTime;
         // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.
        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
            if (expirationTime >= firstSuspendedTime) // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
            else if (expirationTime >= root.lastSuspendedTime) root.lastSuspendedTime = expirationTime + 1;
             // This is a pending level. Check if it's higher priority than the next
            // known pending level.
            if (expirationTime > root.nextKnownPendingLevel) root.nextKnownPendingLevel = expirationTime;
        }
    }
    function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.
        if (finishedExpirationTime <= root.lastSuspendedTime) // The entire suspended range is now unsuspended.
        root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        else if (finishedExpirationTime <= root.firstSuspendedTime) // Part of the suspended range is now unsuspended. Narrow the range to
        // include everything between the unsuspended time (non-inclusive) and the
        // last suspended time.
        root.firstSuspendedTime = finishedExpirationTime - 1;
        if (finishedExpirationTime <= root.lastPingedTime) // Clear the pinged time
        root.lastPingedTime = NoWork;
        if (finishedExpirationTime <= root.lastExpiredTime) // Clear the expired time
        root.lastExpiredTime = NoWork;
    }
    function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) root.lastExpiredTime = expirationTime;
    }
    // This lets us hook into Fiber to debug what it's doing.
    // See https://github.com/facebook/react/pull/8033.
    // This is not part of the public API, not even for React DevTools.
    // You may only inject a debugTool if you work on React Fiber itself.
    var ReactFiberInstrumentation = {
        debugTool: null
    };
    var ReactFiberInstrumentation_1 = ReactFiberInstrumentation;
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstance(component) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                if (fiber.mode & StrictMode) warningWithoutStack$1(false, "%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
                else warningWithoutStack$1(false, "%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks);
    }
    function updateContainer(element, container, parentComponent, callback) {
        var current$$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$$1);
            warnIfNotScopedWithMatchingAct(current$$1);
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$$1, suspenseConfig);
        if (ReactFiberInstrumentation_1.debugTool) {
            if (current$$1.alternate === null) ReactFiberInstrumentation_1.debugTool.onMountContainer(container);
            else if (element === null) ReactFiberInstrumentation_1.debugTool.onUnmountContainer(container);
            else ReactFiberInstrumentation_1.debugTool.onUpdateContainer(container);
        }
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (phase === 'render' && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            warningWithoutStack$1(false, "Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || 'Unknown');
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            !(typeof callback === 'function') && warningWithoutStack$1(false, "render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$$1, update);
        scheduleWork(current$$1, expirationTime);
        return expirationTime;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (root.hydrate) // Flush the first scheduled "update".
                flushRoot(root, root.firstPendingTime);
                break;
            case SuspenseComponent:
                flushSync(function() {
                    return scheduleWork(fiber, Sync);
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryExpTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
                markRetryTimeIfNotHydrated(fiber, retryExpTime);
                break;
        }
    }
    function markRetryTimeImpl(fiber, retryTime) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
            if (suspenseState.retryTime < retryTime) suspenseState.retryTime = retryTime;
        }
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryTimeIfNotHydrated(fiber, retryTime) {
        markRetryTimeImpl(fiber, retryTime);
        var alternate = fiber.alternate;
        if (alternate) markRetryTimeImpl(alternate, retryTime);
    }
    function attemptUserBlockingHydration(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function attemptContinuousHydration(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var expTime = computeContinuousHydrationExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var currentTime = requestCurrentTimeForUpdate();
        var expTime = computeExpirationForFiber(currentTime, fiber, null);
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideProps = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithSetImpl = function(obj, path, idx, value) {
        if (idx >= path.length) return value;
        var key = path[idx];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleWork(fiber, Sync);
    };
    scheduleUpdate = function(fiber) {
        scheduleWork(fiber, Sync);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
            overrideHookState: overrideHookState,
            overrideProps: overrideProps,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: function(fiber) {
                var hostFiber = findCurrentHostFiber(fiber);
                if (hostFiber === null) return null;
                return hostFiber.stateNode;
            },
            findFiberByHostInstance: function(instance) {
                if (!findFiberByHostInstance) // Might not be implemented by the renderer.
                return null;
                return findFiberByHostInstance(instance);
            },
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: function() {
                return current;
            }
        }));
    }
    var ReactFiberReconciler = Object.freeze({
        createContainer: createContainer,
        updateContainer: updateContainer,
        batchedEventUpdates: batchedEventUpdates,
        batchedUpdates: batchedUpdates,
        unbatchedUpdates: unbatchedUpdates,
        deferredUpdates: deferredUpdates,
        syncUpdates: syncUpdates,
        discreteUpdates: discreteUpdates,
        flushDiscreteUpdates: flushDiscreteUpdates,
        flushControlled: flushControlled,
        flushSync: flushSync,
        flushPassiveEffects: flushPassiveEffects,
        IsThisRendererActing: IsThisRendererActing,
        getPublicRootInstance: getPublicRootInstance,
        attemptSynchronousHydration: attemptSynchronousHydration,
        attemptUserBlockingHydration: attemptUserBlockingHydration,
        attemptContinuousHydration: attemptContinuousHydration,
        attemptHydrationAtCurrentPriority: attemptHydrationAtCurrentPriority,
        findHostInstance: findHostInstance,
        findHostInstanceWithWarning: findHostInstanceWithWarning,
        findHostInstanceWithNoPortals: findHostInstanceWithNoPortals,
        shouldSuspend: shouldSuspend,
        injectIntoDevTools: injectIntoDevTools
    });
    // This entry point is intentionally not typed. It exists only for third-party
    // renderers. The renderers we ship (such as React DOM) instead import a named
    // "inline" entry point (for example, `react-reconciler/inline.dom`). It uses
    // the same code, but the Flow configuration redirects the host config to its
    // real implementation so we can check it against exact intended host types.
    //
    // Only one renderer (the one you passed to `yarn flow <renderer>`) is fully
    // type-checked at any given time. The Flow config maps the
    // `react-reconciler/inline.<renderer>` import (which is *not* Flow typed) to
    // `react-reconciler/inline-typed` (which *is*) for the current renderer.
    // On CI, we run Flow checks for each renderer separately.
    // TODO: decide on the top-level export form.
    // This is hacky but makes it work with both Rollup and Jest.
    var reactReconciler = ReactFiberReconciler.default || ReactFiberReconciler;
    module.exports = reactReconciler;
    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
};

});
parcelRegister("1qOd3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g34Ke"));

});
parcelRegister("g34Ke", function(module, exports) {
/** @license React v0.18.0
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    var enableSchedulerDebugging = false;
    var enableIsInputPending = false;
    var enableProfiling = true;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var shouldYieldToHost;
    var requestPaint;
    if (// implementation using setTimeout.
    typeof window === 'undefined' || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = module.exports.unstable_now();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        var initialTime = Date.now();
        module.exports.unstable_now = function() {
            return Date.now() - initialTime;
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        shouldYieldToHost = function() {
            return false;
        };
        requestPaint = module.exports.unstable_forceFrameRate = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var performance = window.performance;
        var _Date = window.Date;
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link
            if (typeof requestAnimationFrame !== 'function') console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
            if (typeof cancelAnimationFrame !== 'function') console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        }
        if (typeof performance === 'object' && typeof performance.now === 'function') module.exports.unstable_now = function() {
            return performance.now();
        };
        else {
            var _initialTime = _Date.now();
            module.exports.unstable_now = function() {
                return _Date.now() - _initialTime;
            };
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // TODO: Adjust this based on priority?
        var maxYieldInterval = 300;
        var needsPaint = false;
        if (enableIsInputPending && navigator !== undefined && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined) {
            var scheduling = navigator.scheduling;
            shouldYieldToHost = function() {
                var currentTime = module.exports.unstable_now();
                if (currentTime >= deadline) {
                    // There's no time left. We may want to yield control of the main
                    // thread, so the browser can perform high priority tasks. The main ones
                    // are painting and user input. If there's a pending paint or a pending
                    // input, then we should yield. But if there's neither, then we can
                    // yield less often while remaining responsive. We'll eventually yield
                    // regardless, since there could be a pending paint that wasn't
                    // accompanied by a call to `requestPaint`, or other main thread tasks
                    // like network events.
                    if (needsPaint || scheduling.isInputPending()) // There is either a pending paint or a pending input.
                    return true;
                     // There's no pending input. Only yield if we've reached the max
                    // yield interval.
                    return currentTime >= maxYieldInterval;
                } else // There's still time left in the frame.
                return false;
            };
            requestPaint = function() {
                needsPaint = true;
            };
        } else {
            // `isInputPending` is not available. Since we have no way of knowing if
            // there's pending input, always yield at the end of the frame.
            shouldYieldToHost = function() {
                return module.exports.unstable_now() >= deadline;
            }; // Since we yield every frame regardless, `requestPaint` has no effect.
            requestPaint = function() {};
        }
        module.exports.unstable_forceFrameRate = function(fps) {
            if (fps < 0 || fps > 125) {
                console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = module.exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
            // reset this.
            needsPaint = false;
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback(module.exports.unstable_now());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = Math.floor((index - 1) / 2);
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var NoPriority = 0;
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    var runIdCounter = 0;
    var mainThreadIdCounter = 0;
    var profilingStateSize = 4;
    var sharedProfilingBuffer = enableProfiling ? typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
     : null;
    var profilingState = enableProfiling && sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks
    var PRIORITY = 0;
    var CURRENT_TASK_ID = 1;
    var CURRENT_RUN_ID = 2;
    var QUEUE_SIZE = 3;
    if (enableProfiling) {
        profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
        // array might include canceled tasks.
        profilingState[QUEUE_SIZE] = 0;
        profilingState[CURRENT_TASK_ID] = 0;
    } // Bytes per element is 4
    var INITIAL_EVENT_LOG_SIZE = 131072;
    var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes
    var eventLogSize = 0;
    var eventLogBuffer = null;
    var eventLog = null;
    var eventLogIndex = 0;
    var TaskStartEvent = 1;
    var TaskCompleteEvent = 2;
    var TaskErrorEvent = 3;
    var TaskCancelEvent = 4;
    var TaskRunEvent = 5;
    var TaskYieldEvent = 6;
    var SchedulerSuspendEvent = 7;
    var SchedulerResumeEvent = 8;
    function logEvent(entries) {
        if (eventLog !== null) {
            var offset = eventLogIndex;
            eventLogIndex += entries.length;
            if (eventLogIndex + 1 > eventLogSize) {
                eventLogSize *= 2;
                if (eventLogSize > MAX_EVENT_LOG_SIZE) {
                    console.error("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`.");
                    stopLoggingProfilingEvents();
                    return;
                }
                var newEventLog = new Int32Array(eventLogSize * 4);
                newEventLog.set(eventLog);
                eventLogBuffer = newEventLog.buffer;
                eventLog = newEventLog;
            }
            eventLog.set(entries, offset);
        }
    }
    function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
    }
    function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
    }
    function markTaskStart(task, ms) {
        if (enableProfiling) {
            profilingState[QUEUE_SIZE]++;
            if (eventLog !== null) // performance.now returns a float, representing milliseconds. When the
            // event is logged, it's coerced to an int. Convert to microseconds to
            // maintain extra degrees of precision.
            logEvent([
                TaskStartEvent,
                ms * 1000,
                task.id,
                task.priorityLevel
            ]);
        }
    }
    function markTaskCompleted(task, ms) {
        if (enableProfiling) {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) logEvent([
                TaskCompleteEvent,
                ms * 1000,
                task.id
            ]);
        }
    }
    function markTaskCanceled(task, ms) {
        if (enableProfiling) {
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) logEvent([
                TaskCancelEvent,
                ms * 1000,
                task.id
            ]);
        }
    }
    function markTaskErrored(task, ms) {
        if (enableProfiling) {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) logEvent([
                TaskErrorEvent,
                ms * 1000,
                task.id
            ]);
        }
    }
    function markTaskRun(task, ms) {
        if (enableProfiling) {
            runIdCounter++;
            profilingState[PRIORITY] = task.priorityLevel;
            profilingState[CURRENT_TASK_ID] = task.id;
            profilingState[CURRENT_RUN_ID] = runIdCounter;
            if (eventLog !== null) logEvent([
                TaskRunEvent,
                ms * 1000,
                task.id,
                runIdCounter
            ]);
        }
    }
    function markTaskYield(task, ms) {
        if (enableProfiling) {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[CURRENT_RUN_ID] = 0;
            if (eventLog !== null) logEvent([
                TaskYieldEvent,
                ms * 1000,
                task.id,
                runIdCounter
            ]);
        }
    }
    function markSchedulerSuspended(ms) {
        if (enableProfiling) {
            mainThreadIdCounter++;
            if (eventLog !== null) logEvent([
                SchedulerSuspendEvent,
                ms * 1000,
                mainThreadIdCounter
            ]);
        }
    }
    function markSchedulerUnsuspended(ms) {
        if (enableProfiling) {
            if (eventLog !== null) logEvent([
                SchedulerResumeEvent,
                ms * 1000,
                mainThreadIdCounter
            ]);
        }
    }
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var isSchedulerPaused = false;
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
                if (enableProfiling) {
                    markTaskStart(timer, currentTime);
                    timer.isQueued = true;
                }
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        if (enableProfiling) markSchedulerUnsuspended(initialTime);
         // We'll need a host callback the next time work is scheduled.
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = module.exports.unstable_now();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod codepath.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
            if (enableProfiling) {
                var _currentTime = module.exports.unstable_now();
                markSchedulerSuspended(_currentTime);
            }
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !(enableSchedulerDebugging && isSchedulerPaused)){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (callback !== null) {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                markTaskRun(currentTask, currentTime);
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = module.exports.unstable_now();
                if (typeof continuationCallback === 'function') {
                    currentTask.callback = continuationCallback;
                    markTaskYield(currentTask, currentTime);
                } else {
                    if (enableProfiling) {
                        markTaskCompleted(currentTask, currentTime);
                        currentTask.isQueued = false;
                    }
                    if (currentTask === peek(taskQueue)) pop(taskQueue);
                }
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function timeoutForPriorityLevel(priorityLevel) {
        switch(priorityLevel){
            case ImmediatePriority:
                return IMMEDIATE_PRIORITY_TIMEOUT;
            case UserBlockingPriority:
                return USER_BLOCKING_PRIORITY;
            case IdlePriority:
                return IDLE_PRIORITY;
            case LowPriority:
                return LOW_PRIORITY_TIMEOUT;
            case NormalPriority:
            default:
                return NORMAL_PRIORITY_TIMEOUT;
        }
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = module.exports.unstable_now();
        var startTime;
        var timeout;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
            timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
            timeout = timeoutForPriorityLevel(priorityLevel);
            startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (enableProfiling) newTask.isQueued = false;
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            if (enableProfiling) {
                markTaskStart(newTask, currentTime);
                newTask.isQueued = true;
            } // Schedule a host callback, if needed. If we're already performing work,
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {
        isSchedulerPaused = true;
    }
    function unstable_continueExecution() {
        isSchedulerPaused = false;
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        if (enableProfiling) {
            if (task.isQueued) {
                var currentTime = module.exports.unstable_now();
                markTaskCanceled(task, currentTime);
                task.isQueued = false;
            }
        } // Null out the callback to indicate the task has been canceled. (Can't
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    function unstable_shouldYield() {
        var currentTime = module.exports.unstable_now();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = enableProfiling ? {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
    } : null;
    module.exports.unstable_ImmediatePriority = ImmediatePriority;
    module.exports.unstable_UserBlockingPriority = UserBlockingPriority;
    module.exports.unstable_NormalPriority = NormalPriority;
    module.exports.unstable_IdlePriority = IdlePriority;
    module.exports.unstable_LowPriority = LowPriority;
    module.exports.unstable_runWithPriority = unstable_runWithPriority;
    module.exports.unstable_next = unstable_next;
    module.exports.unstable_scheduleCallback = unstable_scheduleCallback;
    module.exports.unstable_cancelCallback = unstable_cancelCallback;
    module.exports.unstable_wrapCallback = unstable_wrapCallback;
    module.exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
    module.exports.unstable_shouldYield = unstable_shouldYield;
    module.exports.unstable_requestPaint = unstable_requestPaint;
    module.exports.unstable_continueExecution = unstable_continueExecution;
    module.exports.unstable_pauseExecution = unstable_pauseExecution;
    module.exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
    module.exports.unstable_Profiling = unstable_Profiling;
})();

});


parcelRegister("kAmta", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jYR2v"));

});
parcelRegister("jYR2v", function(module, exports) {
/** @license React v0.18.0
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    // Helps identify side effects in render-phase lifecycle hooks and setState
    // reducers by double invoking them in Strict Mode.
    // To preserve the "Pause on caught exceptions" behavior of the debugger, we
    // replay the begin phase of a failed component inside invokeGuardedCallback.
    // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:
    // Gather advanced timing metrics for Profiler subtrees.
    // Trace which interactions trigger each commit.
    var enableSchedulerTracing = true; // SSR experiments
    // Only used in www builds.
    // Only used in www builds.
    // Disable javascript: URL strings in href for XSS protection.
    // React Fire: prevent the value and checked attributes from syncing
    // with their related DOM properties
    // These APIs will no longer be "unstable" in the upcoming 16.7 release,
    // Control this behavior with a flag to support 16.6 minor releases in the meanwhile.
    // Experimental React Flare event system and event components support.
    // Experimental Host Component support.
    // Experimental Scope support.
    // New API for JSX transforms to target - https://github.com/reactjs/rfcs/pull/107
    // We will enforce mocking scheduler with scheduler/unstable_mock at some point. (v17?)
    // Till then, we warn about the missing mock, but still fallback to a legacy mode compatible version
    // For tests, we flush suspense fallbacks in an act scope;
    // *except* in some of our own tests, where we test incremental loading states.
    // Add a callback property to suspense to notify which promises are currently
    // in the update queue. This allows reporting and tracing of what is causing
    // the user to see a loading state.
    // Also allows hydration callbacks to fire when a dehydrated boundary gets
    // hydrated or deleted.
    // Part of the simplification of React.createElement so we can eventually move
    // from React.createElement to React.jsx
    // https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md
    // Flag to turn event.target and event.currentTarget in ReactNative from a reactTag to a component instance
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    // Interactions "stack"–
    // Meaning that newly traced interactions are appended to the previously active set.
    // When an interaction goes out of scope, the previous set (if any) is restored.
    module.exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.
    module.exports.__subscriberRef = null;
    if (enableSchedulerTracing) {
        module.exports.__interactionsRef = {
            current: new Set()
        };
        module.exports.__subscriberRef = {
            current: null
        };
    }
    function unstable_clear(callback) {
        if (!enableSchedulerTracing) return callback();
        var prevInteractions = module.exports.__interactionsRef.current;
        module.exports.__interactionsRef.current = new Set();
        try {
            return callback();
        } finally{
            module.exports.__interactionsRef.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        if (!enableSchedulerTracing) return null;
        else return module.exports.__interactionsRef.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        if (!enableSchedulerTracing) return callback();
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = module.exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        module.exports.__interactionsRef.current = interactions;
        var subscriber = module.exports.__subscriberRef.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    module.exports.__interactionsRef.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        if (!enableSchedulerTracing) return callback;
        var wrappedInteractions = module.exports.__interactionsRef.current;
        var subscriber = module.exports.__subscriberRef.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = module.exports.__interactionsRef.current;
            module.exports.__interactionsRef.current = wrappedInteractions;
            subscriber = module.exports.__subscriberRef.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        module.exports.__interactionsRef.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = module.exports.__subscriberRef.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    if (enableSchedulerTracing) subscribers = new Set();
    function unstable_subscribe(subscriber) {
        if (enableSchedulerTracing) {
            subscribers.add(subscriber);
            if (subscribers.size === 1) module.exports.__subscriberRef.current = {
                onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
                onInteractionTraced: onInteractionTraced,
                onWorkCanceled: onWorkCanceled,
                onWorkScheduled: onWorkScheduled,
                onWorkStarted: onWorkStarted,
                onWorkStopped: onWorkStopped
            };
        }
    }
    function unstable_unsubscribe(subscriber) {
        if (enableSchedulerTracing) {
            subscribers.delete(subscriber);
            if (subscribers.size === 0) module.exports.__subscriberRef.current = null;
        }
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    module.exports.unstable_clear = unstable_clear;
    module.exports.unstable_getCurrent = unstable_getCurrent;
    module.exports.unstable_getThreadID = unstable_getThreadID;
    module.exports.unstable_trace = unstable_trace;
    module.exports.unstable_wrap = unstable_wrap;
    module.exports.unstable_subscribe = unstable_subscribe;
    module.exports.unstable_unsubscribe = unstable_unsubscribe;
})();

});




parcelRegister("hX3ti", function(module, exports) {
function $d11aa3b914a9b572$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$d11aa3b914a9b572$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
module.exports = $d11aa3b914a9b572$var$E;
module.exports.TinyEmitter = $d11aa3b914a9b572$var$E;

});

parcelRegister("g9e2q", function(module, exports) {
"use strict";
var $bc18604987b40917$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $bc18604987b40917$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bc18604987b40917$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var $2rGPc = parcelRequire("2rGPc");
var $bc18604987b40917$var$promiseCaches = [];
var $bc18604987b40917$var$usePromise = function(promise, inputs, lifespan) {
    var e_1, _a;
    if (lifespan === void 0) lifespan = 0;
    try {
        for(var promiseCaches_1 = $bc18604987b40917$var$__values($bc18604987b40917$var$promiseCaches), promiseCaches_1_1 = promiseCaches_1.next(); !promiseCaches_1_1.done; promiseCaches_1_1 = promiseCaches_1.next()){
            var promiseCache_1 = promiseCaches_1_1.value;
            if ($2rGPc(inputs, promiseCache_1.inputs)) {
                if (Object.prototype.hasOwnProperty.call(promiseCache_1, "error")) throw promiseCache_1.error;
                else if (Object.prototype.hasOwnProperty.call(promiseCache_1, "response")) return promiseCache_1.response;
                throw promiseCache_1.promise;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (promiseCaches_1_1 && !promiseCaches_1_1.done && (_a = promiseCaches_1.return)) _a.call(promiseCaches_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var promiseCache = {
        promise: promise.apply(void 0, $bc18604987b40917$var$__spreadArray([], $bc18604987b40917$var$__read(inputs), false)).then(function(response) {
            promiseCache.response = response;
        }).catch(function(e) {
            promiseCache.error = e;
        }).then(function() {
            if (lifespan > 0) setTimeout(function() {
                var index = $bc18604987b40917$var$promiseCaches.indexOf(promiseCache);
                if (index !== -1) $bc18604987b40917$var$promiseCaches.splice(index, 1);
            }, lifespan);
        }),
        inputs: inputs
    };
    $bc18604987b40917$var$promiseCaches.push(promiseCache);
    throw promiseCache.promise;
};
module.exports = $bc18604987b40917$var$usePromise;

});
parcelRegister("2rGPc", function(module, exports) {
'use strict';
var $1c7f527bb0dc28c9$var$isArray = Array.isArray;
var $1c7f527bb0dc28c9$var$keyList = Object.keys;
var $1c7f527bb0dc28c9$var$hasProp = Object.prototype.hasOwnProperty;
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $1c7f527bb0dc28c9$var$isArray(a), arrB = $1c7f527bb0dc28c9$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $1c7f527bb0dc28c9$var$keyList(a);
        length = keys.length;
        if (length !== $1c7f527bb0dc28c9$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$1c7f527bb0dc28c9$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};

});


parcelRegister("hQ6hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfcc2adba5cb546b$export$2e2bcd8739ae039);

var $J42oT = parcelRequire("J42oT");
function $cfcc2adba5cb546b$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $cfcc2adba5cb546b$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $J42oT.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $J42oT.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $J42oT.useRef)(!1);
    (0, $J42oT.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $J42oT.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$cfcc2adba5cb546b$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $cfcc2adba5cb546b$var$g(r, f) : r,
            d ? $cfcc2adba5cb546b$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $cfcc2adba5cb546b$var$E(r), b());
    };
    return $cfcc2adba5cb546b$var$X(s, !!t), $cfcc2adba5cb546b$var$W(m), (0, $J42oT.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $J42oT.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $cfcc2adba5cb546b$var$W(n) {
    (0, $J42oT.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $cfcc2adba5cb546b$var$X(n, t) {
    (0, $J42oT.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $cfcc2adba5cb546b$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$cfcc2adba5cb546b$var$E(n.parentElement)
    ];
}
const $cfcc2adba5cb546b$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $cfcc2adba5cb546b$var$D = (n, t)=>$cfcc2adba5cb546b$var$k.every((o)=>n[o] === t[o]);

});

parcelRegister("gFNaP", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", () => (parcelRequire("2tgzs")).ResizeObserver);

var $2tgzs = parcelRequire("2tgzs");

var $gaZDm = parcelRequire("gaZDm");

var $7o7Pn = parcelRequire("7o7Pn");

});
parcelRegister("2tgzs", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", () => $1ccb24d9dd74f668$export$9caf76241ca21a11);

var $3vAkn = parcelRequire("3vAkn");

var $44TCC = parcelRequire("44TCC");
var $1ccb24d9dd74f668$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $3vAkn.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $44TCC.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $3vAkn.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $44TCC.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $3vAkn.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $3vAkn.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();

});
parcelRegister("3vAkn", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverController", () => $28e07242c920bab0$export$ed99c5bafbaf8300);

var $ecBce = parcelRequire("ecBce");

var $clxhV = parcelRequire("clxhV");

var $jOGJb = parcelRequire("jOGJb");

var $gbO7Q = parcelRequire("gbO7Q");
var $28e07242c920bab0$var$observerMap = new WeakMap();
var $28e07242c920bab0$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $28e07242c920bab0$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $jOGJb.ResizeObserverDetail)(resizeObserver, callback);
        $28e07242c920bab0$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $28e07242c920bab0$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($28e07242c920bab0$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $gbO7Q.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, $clxhV.ResizeObservation)(target, options && options.box));
            (0, $ecBce.updateCount)(1);
            (0, $ecBce.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $28e07242c920bab0$var$observerMap.get(resizeObserver);
        var index = $28e07242c920bab0$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $gbO7Q.resizeObservers).splice((0, $gbO7Q.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $ecBce.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $28e07242c920bab0$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

});
parcelRegister("ecBce", function(module, exports) {

$parcel$export(module.exports, "scheduler", () => $a56f0a15d21649cb$export$d30788f2c20241cd);
$parcel$export(module.exports, "updateCount", () => $a56f0a15d21649cb$export$1f18a74d42722835);

var $eN4mb = parcelRequire("eN4mb");

var $4jYR6 = parcelRequire("4jYR6");

var $eClII = parcelRequire("eClII");
var $a56f0a15d21649cb$var$watching = 0;
var $a56f0a15d21649cb$var$isWatching = function() {
    return !!$a56f0a15d21649cb$var$watching;
};
var $a56f0a15d21649cb$var$CATCH_PERIOD = 250;
var $a56f0a15d21649cb$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $a56f0a15d21649cb$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $a56f0a15d21649cb$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $a56f0a15d21649cb$var$scheduled = false;
var $a56f0a15d21649cb$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $a56f0a15d21649cb$var$CATCH_PERIOD;
        if ($a56f0a15d21649cb$var$scheduled) return;
        $a56f0a15d21649cb$var$scheduled = true;
        var until = $a56f0a15d21649cb$var$time(timeout);
        (0, $eClII.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $eN4mb.process)();
            } finally{
                $a56f0a15d21649cb$var$scheduled = false;
                timeout = until - $a56f0a15d21649cb$var$time();
                if (!$a56f0a15d21649cb$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $a56f0a15d21649cb$var$observerConfig);
        };
        document.body ? cb() : (0, $4jYR6.global).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $a56f0a15d21649cb$var$events.forEach(function(name) {
                return (0, $4jYR6.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $a56f0a15d21649cb$var$events.forEach(function(name) {
                return (0, $4jYR6.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $a56f0a15d21649cb$export$d30788f2c20241cd = new $a56f0a15d21649cb$var$Scheduler();
var $a56f0a15d21649cb$export$1f18a74d42722835 = function(n) {
    !$a56f0a15d21649cb$var$watching && n > 0 && $a56f0a15d21649cb$export$d30788f2c20241cd.start();
    $a56f0a15d21649cb$var$watching += n;
    !$a56f0a15d21649cb$var$watching && $a56f0a15d21649cb$export$d30788f2c20241cd.stop();
};

});
parcelRegister("eN4mb", function(module, exports) {

$parcel$export(module.exports, "process", () => $ac490571ca941b3a$export$e54fe5b0f43758f7);

var $esx7y = parcelRequire("esx7y");

var $8EVx3 = parcelRequire("8EVx3");

var $gj8Tv = parcelRequire("gj8Tv");

var $cqcOz = parcelRequire("cqcOz");

var $5yfF5 = parcelRequire("5yfF5");
var $ac490571ca941b3a$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $5yfF5.gatherActiveObservationsAtDepth)(depth);
    while((0, $esx7y.hasActiveObservations)()){
        depth = (0, $cqcOz.broadcastActiveObservations)();
        (0, $5yfF5.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, $8EVx3.hasSkippedObservations)()) (0, $gj8Tv.deliverResizeLoopError)();
    return depth > 0;
};

});
parcelRegister("esx7y", function(module, exports) {

$parcel$export(module.exports, "hasActiveObservations", () => $a86d5f4d13de5f12$export$63c81bd924f89474);

var $gbO7Q = parcelRequire("gbO7Q");
var $a86d5f4d13de5f12$export$63c81bd924f89474 = function() {
    return (0, $gbO7Q.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

});
parcelRegister("gbO7Q", function(module, exports) {

$parcel$export(module.exports, "resizeObservers", () => $bc948e4b6971a368$export$402e76927ebf6a24);
var $bc948e4b6971a368$export$402e76927ebf6a24 = [];

});


parcelRegister("8EVx3", function(module, exports) {

$parcel$export(module.exports, "hasSkippedObservations", () => $64deafd6366682cd$export$8ca35300535e324d);

var $gbO7Q = parcelRequire("gbO7Q");
var $64deafd6366682cd$export$8ca35300535e324d = function() {
    return (0, $gbO7Q.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

});

parcelRegister("gj8Tv", function(module, exports) {

$parcel$export(module.exports, "deliverResizeLoopError", () => $bdf551e5da2de146$export$888cb69481582149);
var $bdf551e5da2de146$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $bdf551e5da2de146$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $bdf551e5da2de146$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $bdf551e5da2de146$var$msg;
    }
    window.dispatchEvent(event);
};

});

parcelRegister("cqcOz", function(module, exports) {

$parcel$export(module.exports, "broadcastActiveObservations", () => $90b1da7afa820ba1$export$9cac928141e5443b);

var $gbO7Q = parcelRequire("gbO7Q");

var $gaZDm = parcelRequire("gaZDm");

var $daoYL = parcelRequire("daoYL");

var $2qoxd = parcelRequire("2qoxd");
var $90b1da7afa820ba1$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $gbO7Q.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $gaZDm.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, $daoYL.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $2qoxd.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

});
parcelRegister("gaZDm", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverEntry", () => $bc6d63b47d66e3a6$export$226159b441fc89f8);

var $2qoxd = parcelRequire("2qoxd");

var $1wJM7 = parcelRequire("1wJM7");
var $bc6d63b47d66e3a6$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $2qoxd.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $1wJM7.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $1wJM7.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $1wJM7.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

});
parcelRegister("2qoxd", function(module, exports) {

$parcel$export(module.exports, "calculateBoxSizes", () => $1c410a8c559added$export$504d039a9c501c94);
$parcel$export(module.exports, "calculateBoxSize", () => $1c410a8c559added$export$1a78030b04106bdb);

var $gO56S = parcelRequire("gO56S");

var $7o7Pn = parcelRequire("7o7Pn");

var $bc5bv = parcelRequire("bc5bv");

var $44TCC = parcelRequire("44TCC");

var $1wJM7 = parcelRequire("1wJM7");

var $4jYR6 = parcelRequire("4jYR6");
var $1c410a8c559added$var$cache = new WeakMap();
var $1c410a8c559added$var$scrollRegexp = /auto|scroll/;
var $1c410a8c559added$var$verticalRegexp = /^tb|vertical/;
var $1c410a8c559added$var$IE = /msie|trident/i.test((0, $4jYR6.global).navigator && (0, $4jYR6.global).navigator.userAgent);
var $1c410a8c559added$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $1c410a8c559added$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $7o7Pn.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $1c410a8c559added$var$zeroBoxes = (0, $1wJM7.freeze)({
    devicePixelContentBoxSize: $1c410a8c559added$var$size(),
    borderBoxSize: $1c410a8c559added$var$size(),
    contentBoxSize: $1c410a8c559added$var$size(),
    contentRect: new (0, $bc5bv.DOMRectReadOnly)(0, 0, 0, 0)
});
var $1c410a8c559added$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($1c410a8c559added$var$cache.has(target) && !forceRecalculation) return $1c410a8c559added$var$cache.get(target);
    if ((0, $44TCC.isHidden)(target)) {
        $1c410a8c559added$var$cache.set(target, $1c410a8c559added$var$zeroBoxes);
        return $1c410a8c559added$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $44TCC.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$1c410a8c559added$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $1c410a8c559added$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $1c410a8c559added$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $1c410a8c559added$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $1c410a8c559added$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $1c410a8c559added$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $1c410a8c559added$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $1wJM7.freeze)({
        devicePixelContentBoxSize: $1c410a8c559added$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $1c410a8c559added$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $1c410a8c559added$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $bc5bv.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $1c410a8c559added$var$cache.set(target, boxes);
    return boxes;
};
var $1c410a8c559added$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $1c410a8c559added$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $gO56S.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $gO56S.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

});
parcelRegister("gO56S", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverBoxOptions", () => $c3c54791309e7d35$export$416d111b83cd1483);
var $c3c54791309e7d35$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($c3c54791309e7d35$export$416d111b83cd1483 || ($c3c54791309e7d35$export$416d111b83cd1483 = {}));

});

parcelRegister("7o7Pn", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverSize", () => $5610d8b8a3abc083$export$c9ad8cdf6bbd331c);

var $1wJM7 = parcelRequire("1wJM7");
var $5610d8b8a3abc083$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $1wJM7.freeze)(this);
    }
    return ResizeObserverSize;
}();

});
parcelRegister("1wJM7", function(module, exports) {

$parcel$export(module.exports, "freeze", () => $11cc49961596afc4$export$792f3d81ea979f55);
var $11cc49961596afc4$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};

});


parcelRegister("bc5bv", function(module, exports) {

$parcel$export(module.exports, "DOMRectReadOnly", () => $8264d63cb01db520$export$51d7a67026f4e0b7);

var $1wJM7 = parcelRequire("1wJM7");
var $8264d63cb01db520$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $1wJM7.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

});

parcelRegister("44TCC", function(module, exports) {

$parcel$export(module.exports, "isSVG", () => $2f82ae84b81258ab$export$165b39ed277223c2);
$parcel$export(module.exports, "isHidden", () => $2f82ae84b81258ab$export$ee695c13482bb5dd);
$parcel$export(module.exports, "isElement", () => $2f82ae84b81258ab$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isReplacedElement", () => $2f82ae84b81258ab$export$a6eb60f7e7c182ba);
var $2f82ae84b81258ab$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $2f82ae84b81258ab$export$ee695c13482bb5dd = function(target) {
    if ($2f82ae84b81258ab$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $2f82ae84b81258ab$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $2f82ae84b81258ab$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};

});

parcelRegister("4jYR6", function(module, exports) {

$parcel$export(module.exports, "global", () => $3258246873d4e0ab$export$90b4d2ff6acb88af);
var $3258246873d4e0ab$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};

});



parcelRegister("daoYL", function(module, exports) {

$parcel$export(module.exports, "calculateDepthForNode", () => $995f95e115c79ae7$export$f8c8e3b5da1f41d2);

var $44TCC = parcelRequire("44TCC");
var $995f95e115c79ae7$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $44TCC.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

});


parcelRegister("5yfF5", function(module, exports) {

$parcel$export(module.exports, "gatherActiveObservationsAtDepth", () => $40ac46d5b0d387f6$export$9c17b8913a2a3572);

var $gbO7Q = parcelRequire("gbO7Q");

var $daoYL = parcelRequire("daoYL");
var $40ac46d5b0d387f6$export$9c17b8913a2a3572 = function(depth) {
    (0, $gbO7Q.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $daoYL.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

});


parcelRegister("eClII", function(module, exports) {

$parcel$export(module.exports, "queueResizeObserver", () => $aa45767e83b9ce9b$export$5755c7b572e34c6);

var $e8vNk = parcelRequire("e8vNk");
var $aa45767e83b9ce9b$export$5755c7b572e34c6 = function(cb) {
    (0, $e8vNk.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

});
parcelRegister("e8vNk", function(module, exports) {

$parcel$export(module.exports, "queueMicroTask", () => $a4aa79cbf576c7fe$export$4c995d4933c4abb);
var $a4aa79cbf576c7fe$var$trigger;
var $a4aa79cbf576c7fe$var$callbacks = [];
var $a4aa79cbf576c7fe$var$notify = function() {
    return $a4aa79cbf576c7fe$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $a4aa79cbf576c7fe$export$4c995d4933c4abb = function(callback) {
    if (!$a4aa79cbf576c7fe$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $a4aa79cbf576c7fe$var$notify();
        }).observe(el_1, config);
        $a4aa79cbf576c7fe$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $a4aa79cbf576c7fe$var$callbacks.push(callback);
    $a4aa79cbf576c7fe$var$trigger();
};

});



parcelRegister("clxhV", function(module, exports) {

$parcel$export(module.exports, "ResizeObservation", () => $8fd14489de4a5b98$export$fea412043713122);

var $gO56S = parcelRequire("gO56S");

var $2qoxd = parcelRequire("2qoxd");

var $44TCC = parcelRequire("44TCC");
var $8fd14489de4a5b98$var$skipNotifyOnElement = function(target) {
    return !(0, $44TCC.isSVG)(target) && !(0, $44TCC.isReplacedElement)(target) && getComputedStyle(target).display === 'inline';
};
var $8fd14489de4a5b98$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $gO56S.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $2qoxd.calculateBoxSize)(this.target, this.observedBox, true);
        if ($8fd14489de4a5b98$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

});

parcelRegister("jOGJb", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverDetail", () => $e6d3d4a6ba84bc2f$export$d86966e6e4bc97e1);
var $e6d3d4a6ba84bc2f$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

});




parcelRegister("fIPnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b722d23d82d67ed7$export$2e2bcd8739ae039);
function $b722d23d82d67ed7$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $b722d23d82d67ed7$export$2e2bcd8739ae039 = $b722d23d82d67ed7$var$mergeRefs;

});


parcelRegister("9l8Ol", function(module, exports) {
"use strict";
function $01c13d901e2ca878$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $01c13d901e2ca878$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01c13d901e2ca878$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $01c13d901e2ca878$var$_react = $01c13d901e2ca878$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $01c13d901e2ca878$var$THREE = $01c13d901e2ca878$var$_interopRequireWildcard((parcelRequire("h8GDa")));


var $7zGXF = parcelRequire("7zGXF");

var $01c13d901e2ca878$var$_StadiumOutfields = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("8Jl6x")));

var $01c13d901e2ca878$var$_Infield = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("3qPhl")));

var $01c13d901e2ca878$var$_Mound = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("bChNI")));

var $01c13d901e2ca878$var$_Base = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("cHmPj")));

var $01c13d901e2ca878$var$_HomePlate = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("3aodB")));

var $01c13d901e2ca878$var$_Fence = $01c13d901e2ca878$var$_interopRequireDefault((parcelRequire("cFDIZ")));
function $01c13d901e2ca878$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $01c13d901e2ca878$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($01c13d901e2ca878$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $01c13d901e2ca878$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $01c13d901e2ca878$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $01c13d901e2ca878$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $01c13d901e2ca878$var$_extends() {
    return $01c13d901e2ca878$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $01c13d901e2ca878$var$_extends.apply(null, arguments);
} /* eslint-disable */  // Field Components
// import Text from "../generic/text";
function $01c13d901e2ca878$var$Field(props) {
    var _ref = $01c13d901e2ca878$var$_StadiumOutfields["default"][props.id] || {}, outfield = _ref.outfield, hasTransform = _ref.hasTransform;
    var fieldPath = (0, $7zGXF.transformSVGPath2)(outfield, hasTransform);
    var extrudeSettings = {
        depth: 1,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1
    };
    var fieldPosition = props.position || [
        0,
        0,
        0
    ];
    // Slightly below
    return /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement("group", null, /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement("mesh", {
        receiveShadow: true,
        castShadow: true,
        position: fieldPosition,
        geometry: new $01c13d901e2ca878$var$THREE.ExtrudeGeometry(fieldPath, extrudeSettings),
        material: new $01c13d901e2ca878$var$THREE.MeshLambertMaterial({
            color: 0xbbe8e4,
            // shininess: 0.25,
            //        specular: '#c2c2c2',
            wireframe: false,
            flatShading: false,
            wireframeLinewidth: 0.4,
            transparent: true,
            opacity: 1
        })
    }), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Infield["default"], props), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Mound["default"], props), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Base["default"], $01c13d901e2ca878$var$_extends({
        type: "1b"
    }, props)), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Base["default"], $01c13d901e2ca878$var$_extends({
        type: "2b"
    }, props)), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Base["default"], $01c13d901e2ca878$var$_extends({
        type: "3b"
    }, props)), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_HomePlate["default"], props), /*#__PURE__*/ $01c13d901e2ca878$var$_react["default"].createElement($01c13d901e2ca878$var$_Fence["default"], {
        venueId: Number(props.id),
        position: props.position || [
            0,
            0,
            0
        ]
    }));
}
var $01c13d901e2ca878$var$_default = module.exports["default"] = $01c13d901e2ca878$var$Field;

});
parcelRegister("7zGXF", function(module, exports) {
"use strict";
function $583d2086e917e3ff$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $583d2086e917e3ff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $583d2086e917e3ff$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.transformSVGPath2 = $583d2086e917e3ff$var$transformSVGPath2;

var $583d2086e917e3ff$var$THREE = $583d2086e917e3ff$var$_interopRequireWildcard((parcelRequire("h8GDa")));
parcelRequire("337Uy");
var $3m1uH = parcelRequire("3m1uH");

var $l0lGd = parcelRequire("l0lGd");
function $583d2086e917e3ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($583d2086e917e3ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $583d2086e917e3ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $583d2086e917e3ff$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $583d2086e917e3ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $583d2086e917e3ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $583d2086e917e3ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $583d2086e917e3ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            $583d2086e917e3ff$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $583d2086e917e3ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $583d2086e917e3ff$var$_defineProperty(e, r, t) {
    return (r = $583d2086e917e3ff$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $583d2086e917e3ff$var$_toPropertyKey(t) {
    var i = $583d2086e917e3ff$var$_toPrimitive(t, "string");
    return "symbol" == $583d2086e917e3ff$var$_typeof(i) ? i : i + "";
}
function $583d2086e917e3ff$var$_toPrimitive(t, r) {
    if ("object" != $583d2086e917e3ff$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $583d2086e917e3ff$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $583d2086e917e3ff$var$_toConsumableArray(r) {
    return $583d2086e917e3ff$var$_arrayWithoutHoles(r) || $583d2086e917e3ff$var$_iterableToArray(r) || $583d2086e917e3ff$var$_unsupportedIterableToArray(r) || $583d2086e917e3ff$var$_nonIterableSpread();
}
function $583d2086e917e3ff$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $583d2086e917e3ff$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $583d2086e917e3ff$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $583d2086e917e3ff$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $583d2086e917e3ff$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $583d2086e917e3ff$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $583d2086e917e3ff$var$_arrayLikeToArray(r);
}
function $583d2086e917e3ff$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $583d2086e917e3ff$var$pathToPoints(pathStr) {
    var points = (0, $3m1uH.default)({
        type: 'path',
        d: pathStr
    });
    return points.reduce(function(acc, curr, i) {
        if (curr.curve) {
            var prev = points[i - 1];
            var curve = new $l0lGd.Bezier(prev.x, prev.y, curr.curve.x1, curr.curve.y1, curr.curve.x2, curr.curve.y2, curr.x, curr.y);
            var newPoints = curve.getLUT(20);
            var newAcc = [].concat($583d2086e917e3ff$var$_toConsumableArray(acc), $583d2086e917e3ff$var$_toConsumableArray(newPoints));
            return newAcc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
//
function $583d2086e917e3ff$var$transformSVGPath2(d, hasTransform) {
    var points = $583d2086e917e3ff$var$pathToPoints(d);
    var path = new $583d2086e917e3ff$var$THREE.Shape();
    // transform="matrix(.98 0 0 -.98 250 420)
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#matrix
    if (hasTransform) points = points.map(function(point) {
        return $583d2086e917e3ff$var$_objectSpread($583d2086e917e3ff$var$_objectSpread({}, point), {}, {
            x: 0.98 * point.x + 250,
            y: -0.98 * point.y + 420
        });
    });
    points.forEach(function(point) {
        // This the transforms found in https://github.mlbam.net/site-baseball-savant/basesite/pull/310
        if (point.moveTo) path.moveTo((point.x - 125) * 2.42, (point.y - 202) * -2.42);
        path.lineTo((point.x - 125) * 2.42, (point.y - 202) * -2.42);
    });
    return path;
}
/* eslint-disable */ function $583d2086e917e3ff$var$transformSVGPath(pathStr) {
    var DIGIT_0 = 48;
    var DIGIT_9 = 57;
    var COMMA = 44;
    var SPACE = 32;
    var PERIOD = 46;
    var MINUS = 45;
    var DEGS_TO_RADS = Math.PI / 180.0;
    var path = new $583d2086e917e3ff$var$THREE.Shape();
    var idx = 1;
    var len = pathStr.length;
    var activeCmd;
    var x = 0;
    var y = 0;
    var nx = 0;
    var ny = 0;
    var firstX = null;
    var firstY = null;
    var x1 = 0;
    var x2 = 0;
    var y1 = 0;
    var y2 = 0;
    var rx = 0;
    var ry = 0;
    var xar = 0;
    var laf = 0;
    var sf = 0;
    var cx;
    var cy;
    function eatNum() {
        var sidx;
        var c;
        var isFloat = false;
        var s;
        // eat delims
        while(idx < len){
            c = pathStr.charCodeAt(idx);
            if (c !== COMMA && c !== SPACE) break;
            idx++;
        }
        if (c === MINUS) sidx = idx++;
        else sidx = idx;
        // eat number
        while(idx < len){
            c = pathStr.charCodeAt(idx);
            if (DIGIT_0 <= c && c <= DIGIT_9) {
                idx++;
                continue;
            } else if (c === PERIOD) {
                idx++;
                isFloat = true;
                continue;
            }
            s = pathStr.substring(sidx, idx);
            return isFloat ? parseFloat(s) : parseInt(s);
        }
        s = pathStr.substring(sidx);
        return isFloat ? parseFloat(s) : parseInt(s);
    }
    function nextIsNum() {
        var c;
        // do permanently eat any delims...
        while(idx < len){
            c = pathStr.charCodeAt(idx);
            if (c !== COMMA && c !== SPACE) break;
            idx++;
        }
        c = pathStr.charCodeAt(idx);
        return c === MINUS || DIGIT_0 <= c && c <= DIGIT_9;
    }
    function eatAbsoluteArc() {
        rx = eatNum();
        ry = eatNum();
        xar = eatNum() * DEGS_TO_RADS;
        laf = eatNum();
        sf = eatNum();
        nx = eatNum();
        ny = eatNum();
        if (activeCmd == 'a') {
            // relative
            nx += x;
            ny += y;
        }
        // console.debug( "[SVGPath2ThreeShape.eatAbsoluteArc] Read arc params: rx=" + rx + ", ry=" + ry + ", xar=" + xar + ", laf=" + laf + ", sf=" + sf + ", nx=" + nx + ", ny=" + ny );
        if (rx !== ry) console.warn('Forcing elliptical arc to be a circular one :(', rx, ry);
        // SVG implementation notes does all the math for us! woo!
        // http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
        // step1, using x1 as x1'
        x1 = Math.cos(xar) * (x - nx) / 2 + Math.sin(xar) * (y - ny) / 2;
        y1 = -Math.sin(xar) * (x - nx) / 2 + Math.cos(xar) * (y - ny) / 2;
        // step 2, using x2 as cx'
        // console.debug( "[SVGPath2ThreeShape.eatAbsoluteArc] TMP x1=" + x1 + ", y1=" + y1 + ", (rx*rx * y1*y1 + ry*ry * x1*x1)=" + (rx*rx * y1*y1 + ry*ry * x1*x1) + ", (rx*rx * ry*ry - rx*rx * y1*y1 - ry*ry * x1*x1)=" + (rx*rx * ry*ry - rx*rx * y1*y1 - ry*ry * x1*x1) );
        var norm = Math.sqrt(Math.abs((rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1)));
        if (laf === sf) norm = -norm;
        x2 = norm * rx * y1 / ry;
        y2 = norm * -ry * x1 / rx;
        // console.debug( "[SVGPath2ThreeShape.eatAbsoluteArc] TMP norm=" + norm + ", x2=" + x2 + ", y2=" + y2 );
        // step 3
        cx = Math.cos(xar) * x2 - Math.sin(xar) * y2 + (x + nx) / 2;
        cy = Math.sin(xar) * x2 + Math.cos(xar) * y2 + (y + ny) / 2;
        // console.debug( "[SVGPath2ThreeShape.eatAbsoluteArc] TMP cx=" + cx + ", cy=" + cy );
        var u = new $583d2086e917e3ff$var$THREE.Vector2(1, 0);
        var v = new $583d2086e917e3ff$var$THREE.Vector2((x1 - x2) / rx, (y1 - y2) / ry);
        var startAng = Math.acos(u.dot(v) / u.length() / v.length());
        if (u.x * v.y - u.y * v.x < 0) startAng = -startAng;
        // we can reuse 'v' from start angle as our 'u' for delta angle
        u.x = (-x1 - x2) / rx;
        u.y = (-y1 - y2) / ry;
        var deltaAng = Math.acos(v.dot(u) / v.length() / u.length());
        // This normalization ends up making our curves fail to triangulate...
        if (v.x * u.y - v.y * u.x < 0) deltaAng = -deltaAng;
        if (!sf && deltaAng > 0) deltaAng -= Math.PI * 2;
        if (sf && deltaAng < 0) deltaAng += Math.PI * 2;
        // console.debug( "[SVGPath2ThreeShape.eatAbsoluteArc] Building arc from values: cx=" + cx + ", cy=" + cy + ", startAng=" + startAng + ", deltaAng=" + deltaAng + ", endAng=" + (startAng+deltaAng) + ", sweepFlag=" + sf );
        path.absarc(cx, cy, rx, startAng, startAng + deltaAng, sf);
        x = nx;
        y = ny;
    }
    var canRepeat;
    activeCmd = pathStr[0];
    while(idx <= len){
        canRepeat = true;
        switch(activeCmd){
            // moveto commands, become lineto's if repeated
            case 'M':
                x = eatNum();
                y = eatNum();
                path.moveTo(x, y);
                activeCmd = 'L';
                break;
            case 'm':
                x += eatNum();
                y += eatNum();
                path.moveTo(x, y);
                activeCmd = 'l';
                break;
            case 'Z':
            case 'z':
                canRepeat = false;
                if (x !== firstX || y !== firstY) path.lineTo(firstX, firstY);
                break;
            // - lines!
            case 'L':
            case 'H':
            case 'V':
                nx = activeCmd === 'V' ? x : eatNum();
                ny = activeCmd === 'H' ? y : eatNum();
                path.lineTo(nx, ny);
                x = nx;
                y = ny;
                break;
            case 'l':
            case 'h':
            case 'v':
                nx = activeCmd === 'v' ? x : x + eatNum();
                ny = activeCmd === 'h' ? y : y + eatNum();
                path.lineTo(nx, ny);
                x = nx;
                y = ny;
                break;
            // - cubic bezier
            case 'C':
                x1 = eatNum();
                y1 = eatNum();
            case 'S':
                if (activeCmd === 'S') {
                    x1 = 2 * x - x2;
                    y1 = 2 * y - y2;
                }
                x2 = eatNum();
                y2 = eatNum();
                nx = eatNum();
                ny = eatNum();
                path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
                x = nx;
                y = ny;
                break;
            case 'c':
                x1 = x + eatNum();
                y1 = y + eatNum();
            case 's':
                if (activeCmd === 's') {
                    x1 = 2 * x - x2;
                    y1 = 2 * y - y2;
                }
                x2 = x + eatNum();
                y2 = y + eatNum();
                nx = x + eatNum();
                ny = y + eatNum();
                path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
                x = nx;
                y = ny;
                break;
            // - quadratic bezier
            case 'Q':
                x1 = eatNum();
                y1 = eatNum();
            case 'T':
                if (activeCmd === 'T') {
                    x1 = 2 * x - x1;
                    y1 = 2 * y - y1;
                }
                nx = eatNum();
                ny = eatNum();
                path.quadraticCurveTo(x1, y1, nx, ny);
                x = nx;
                y = ny;
                break;
            case 'q':
                x1 = x + eatNum();
                y1 = y + eatNum();
            case 't':
                if (activeCmd === 't') {
                    x1 = 2 * x - x1;
                    y1 = 2 * y - y1;
                }
                nx = x + eatNum();
                ny = y + eatNum();
                path.quadraticCurveTo(x1, y1, nx, ny);
                x = nx;
                y = ny;
                break;
            // - elliptical arc
            case 'A':
            // eatAbsoluteArc();
            case 'a':
                eatAbsoluteArc();
                break;
            default:
                throw new Error("weird path command: ".concat(activeCmd));
        }
        if (firstX === null) {
            firstX = x;
            firstY = y;
        }
        // just reissue the command
        if (canRepeat && nextIsNum()) continue;
        activeCmd = pathStr[idx++];
    }
    return path;
}
var $583d2086e917e3ff$var$_default = module.exports["default"] = $583d2086e917e3ff$var$transformSVGPath;

});
parcelRegister("337Uy", function(module, exports) {

$parcel$export(module.exports, "toPoints", () => (parcelRequire("3m1uH")).default);

var $bNK3Y = parcelRequire("bNK3Y");

var $3m1uH = parcelRequire("3m1uH");

var $64fpk = parcelRequire("64fpk");

});
parcelRegister("bNK3Y", function(module, exports) {

var $3m1uH = parcelRequire("3m1uH");
var $89780078c7d5ab77$var$pointsToD = function pointsToD(p) {
    var d = '';
    var i = 0;
    var firstPoint = void 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = p[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var point = _step.value;
            var _point$curve = point.curve, curve = _point$curve === undefined ? false : _point$curve, moveTo = point.moveTo, x = point.x, y = point.y;
            var isFirstPoint = i === 0 || moveTo;
            var isLastPoint = i === p.length - 1 || p[i + 1].moveTo;
            var prevPoint = i === 0 ? null : p[i - 1];
            if (isFirstPoint) {
                firstPoint = point;
                if (!isLastPoint) d += 'M' + x + ',' + y;
            } else if (curve) {
                switch(curve.type){
                    case 'arc':
                        var _point$curve2 = point.curve, _point$curve2$largeAr = _point$curve2.largeArcFlag, largeArcFlag = _point$curve2$largeAr === undefined ? 0 : _point$curve2$largeAr, rx = _point$curve2.rx, ry = _point$curve2.ry, _point$curve2$sweepFl = _point$curve2.sweepFlag, sweepFlag = _point$curve2$sweepFl === undefined ? 0 : _point$curve2$sweepFl, _point$curve2$xAxisRo = _point$curve2.xAxisRotation, xAxisRotation = _point$curve2$xAxisRo === undefined ? 0 : _point$curve2$xAxisRo;
                        d += 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + x + ',' + y;
                        break;
                    case 'cubic':
                        var _point$curve3 = point.curve, cx1 = _point$curve3.x1, cy1 = _point$curve3.y1, cx2 = _point$curve3.x2, cy2 = _point$curve3.y2;
                        d += 'C' + cx1 + ',' + cy1 + ',' + cx2 + ',' + cy2 + ',' + x + ',' + y;
                        break;
                    case 'quadratic':
                        var _point$curve4 = point.curve, qx1 = _point$curve4.x1, qy1 = _point$curve4.y1;
                        d += 'Q' + qx1 + ',' + qy1 + ',' + x + ',' + y;
                        break;
                }
                if (isLastPoint && x === firstPoint.x && y === firstPoint.y) d += 'Z';
            } else if (isLastPoint && x === firstPoint.x && y === firstPoint.y) d += 'Z';
            else if (x !== prevPoint.x && y !== prevPoint.y) d += 'L' + x + ',' + y;
            else if (x !== prevPoint.x) d += 'H' + x;
            else if (y !== prevPoint.y) d += 'V' + y;
            i++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return d;
};
var $89780078c7d5ab77$var$toPath = function toPath(s) {
    var isPoints = Array.isArray(s);
    var isGroup = isPoints ? Array.isArray(s[0]) : s.type === 'g';
    var points = isPoints ? s : isGroup ? s.shapes.map(function(shp) {
        return (0, $3m1uH.default)(shp);
    }) : (0, $3m1uH.default)(s);
    if (isGroup) return points.map(function(p) {
        return $89780078c7d5ab77$var$pointsToD(p);
    });
    return $89780078c7d5ab77$var$pointsToD(points);
};
var $89780078c7d5ab77$export$2e2bcd8739ae039 = $89780078c7d5ab77$var$toPath;

});
parcelRegister("3m1uH", function(module, exports) {

$parcel$export(module.exports, "default", () => $271495e66d32284a$export$2e2bcd8739ae039);
var $271495e66d32284a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $271495e66d32284a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $271495e66d32284a$var$toPoints = function toPoints(_ref) {
    var type = _ref.type, props = $271495e66d32284a$var$_objectWithoutProperties(_ref, [
        'type'
    ]);
    switch(type){
        case 'circle':
            return $271495e66d32284a$var$getPointsFromCircle(props);
        case 'ellipse':
            return $271495e66d32284a$var$getPointsFromEllipse(props);
        case 'line':
            return $271495e66d32284a$var$getPointsFromLine(props);
        case 'path':
            return $271495e66d32284a$var$getPointsFromPath(props);
        case 'polygon':
            return $271495e66d32284a$var$getPointsFromPolygon(props);
        case 'polyline':
            return $271495e66d32284a$var$getPointsFromPolyline(props);
        case 'rect':
            return $271495e66d32284a$var$getPointsFromRect(props);
        case 'g':
            return $271495e66d32284a$var$getPointsFromG(props);
        default:
            throw new Error('Not a valid shape type');
    }
};
var $271495e66d32284a$var$getPointsFromCircle = function getPointsFromCircle(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, r = _ref2.r;
    return [
        {
            x: cx,
            y: cy - r,
            moveTo: true
        },
        {
            x: cx,
            y: cy + r,
            curve: {
                type: 'arc',
                rx: r,
                ry: r,
                sweepFlag: 1
            }
        },
        {
            x: cx,
            y: cy - r,
            curve: {
                type: 'arc',
                rx: r,
                ry: r,
                sweepFlag: 1
            }
        }
    ];
};
var $271495e66d32284a$var$getPointsFromEllipse = function getPointsFromEllipse(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, rx = _ref3.rx, ry = _ref3.ry;
    return [
        {
            x: cx,
            y: cy - ry,
            moveTo: true
        },
        {
            x: cx,
            y: cy + ry,
            curve: {
                type: 'arc',
                rx: rx,
                ry: ry,
                sweepFlag: 1
            }
        },
        {
            x: cx,
            y: cy - ry,
            curve: {
                type: 'arc',
                rx: rx,
                ry: ry,
                sweepFlag: 1
            }
        }
    ];
};
var $271495e66d32284a$var$getPointsFromLine = function getPointsFromLine(_ref4) {
    var x1 = _ref4.x1, x2 = _ref4.x2, y1 = _ref4.y1, y2 = _ref4.y2;
    return [
        {
            x: x1,
            y: y1,
            moveTo: true
        },
        {
            x: x2,
            y: y2
        }
    ];
};
var $271495e66d32284a$var$validCommands = /[MmLlHhVvCcSsQqTtAaZz]/g;
var $271495e66d32284a$var$commandLengths = {
    A: 7,
    C: 6,
    H: 1,
    L: 2,
    M: 2,
    Q: 4,
    S: 4,
    T: 2,
    V: 1,
    Z: 0
};
var $271495e66d32284a$var$relativeCommands = [
    'a',
    'c',
    'h',
    'l',
    'm',
    'q',
    's',
    't',
    'v'
];
var $271495e66d32284a$var$isRelative = function isRelative(command) {
    return $271495e66d32284a$var$relativeCommands.indexOf(command) !== -1;
};
var $271495e66d32284a$var$optionalArcKeys = [
    'xAxisRotation',
    'largeArcFlag',
    'sweepFlag'
];
var $271495e66d32284a$var$getCommands = function getCommands(d) {
    return d.match($271495e66d32284a$var$validCommands);
};
var $271495e66d32284a$var$getParams = function getParams(d) {
    return d.split($271495e66d32284a$var$validCommands).map(function(v) {
        return v.replace(/[0-9]+-/g, function(m) {
            return m.slice(0, -1) + ' -';
        });
    }).map(function(v) {
        return v.replace(/\.[0-9]+/g, function(m) {
            return m + ' ';
        });
    }).map(function(v) {
        return v.trim();
    }).filter(function(v) {
        return v.length > 0;
    }).map(function(v) {
        return v.split(/[ ,]+/).map(parseFloat).filter(function(n) {
            return !isNaN(n);
        });
    });
};
var $271495e66d32284a$var$getPointsFromPath = function getPointsFromPath(_ref5) {
    var d = _ref5.d;
    var commands = $271495e66d32284a$var$getCommands(d);
    var params = $271495e66d32284a$var$getParams(d);
    var points = [];
    var moveTo = void 0;
    for(var i = 0, l = commands.length; i < l; i++){
        var command = commands[i];
        var upperCaseCommand = command.toUpperCase();
        var commandLength = $271495e66d32284a$var$commandLengths[upperCaseCommand];
        var relative = $271495e66d32284a$var$isRelative(command);
        if (commandLength > 0) {
            var commandParams = params.shift();
            var iterations = commandParams.length / commandLength;
            for(var j = 0; j < iterations; j++){
                var prevPoint = points[points.length - 1] || {
                    x: 0,
                    y: 0
                };
                switch(upperCaseCommand){
                    case 'M':
                        var x = (relative ? prevPoint.x : 0) + commandParams.shift();
                        var y = (relative ? prevPoint.y : 0) + commandParams.shift();
                        if (j === 0) {
                            moveTo = {
                                x: x,
                                y: y
                            };
                            points.push({
                                x: x,
                                y: y,
                                moveTo: true
                            });
                        } else points.push({
                            x: x,
                            y: y
                        });
                        break;
                    case 'L':
                        points.push({
                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
                            y: (relative ? prevPoint.y : 0) + commandParams.shift()
                        });
                        break;
                    case 'H':
                        points.push({
                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
                            y: prevPoint.y
                        });
                        break;
                    case 'V':
                        points.push({
                            x: prevPoint.x,
                            y: (relative ? prevPoint.y : 0) + commandParams.shift()
                        });
                        break;
                    case 'A':
                        points.push({
                            curve: {
                                type: 'arc',
                                rx: commandParams.shift(),
                                ry: commandParams.shift(),
                                xAxisRotation: commandParams.shift(),
                                largeArcFlag: commandParams.shift(),
                                sweepFlag: commandParams.shift()
                            },
                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
                            y: (relative ? prevPoint.y : 0) + commandParams.shift()
                        });
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;
                        try {
                            for(var _iterator = $271495e66d32284a$var$optionalArcKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var k = _step.value;
                                if (points[points.length - 1]['curve'][k] === 0) delete points[points.length - 1]['curve'][k];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                            } finally{
                                if (_didIteratorError) throw _iteratorError;
                            }
                        }
                        break;
                    case 'C':
                        points.push({
                            curve: {
                                type: 'cubic',
                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
                                y1: (relative ? prevPoint.y : 0) + commandParams.shift(),
                                x2: (relative ? prevPoint.x : 0) + commandParams.shift(),
                                y2: (relative ? prevPoint.y : 0) + commandParams.shift()
                            },
                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
                            y: (relative ? prevPoint.y : 0) + commandParams.shift()
                        });
                        break;
                    case 'S':
                        var sx2 = (relative ? prevPoint.x : 0) + commandParams.shift();
                        var sy2 = (relative ? prevPoint.y : 0) + commandParams.shift();
                        var sx = (relative ? prevPoint.x : 0) + commandParams.shift();
                        var sy = (relative ? prevPoint.y : 0) + commandParams.shift();
                        var diff = {};
                        var sx1 = void 0;
                        var sy1 = void 0;
                        if (prevPoint.curve && prevPoint.curve.type === 'cubic') {
                            diff.x = Math.abs(prevPoint.x - prevPoint.curve.x2);
                            diff.y = Math.abs(prevPoint.y - prevPoint.curve.y2);
                            sx1 = prevPoint.x < prevPoint.curve.x2 ? prevPoint.x - diff.x : prevPoint.x + diff.x;
                            sy1 = prevPoint.y < prevPoint.curve.y2 ? prevPoint.y - diff.y : prevPoint.y + diff.y;
                        } else {
                            diff.x = Math.abs(sx - sx2);
                            diff.y = Math.abs(sy - sy2);
                            sx1 = prevPoint.x;
                            sy1 = prevPoint.y;
                        }
                        points.push({
                            curve: {
                                type: 'cubic',
                                x1: sx1,
                                y1: sy1,
                                x2: sx2,
                                y2: sy2
                            },
                            x: sx,
                            y: sy
                        });
                        break;
                    case 'Q':
                        points.push({
                            curve: {
                                type: 'quadratic',
                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
                                y1: (relative ? prevPoint.y : 0) + commandParams.shift()
                            },
                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
                            y: (relative ? prevPoint.y : 0) + commandParams.shift()
                        });
                        break;
                    case 'T':
                        var tx = (relative ? prevPoint.x : 0) + commandParams.shift();
                        var ty = (relative ? prevPoint.y : 0) + commandParams.shift();
                        var tx1 = void 0;
                        var ty1 = void 0;
                        if (prevPoint.curve && prevPoint.curve.type === 'quadratic') {
                            var _diff = {
                                x: Math.abs(prevPoint.x - prevPoint.curve.x1),
                                y: Math.abs(prevPoint.y - prevPoint.curve.y1)
                            };
                            tx1 = prevPoint.x < prevPoint.curve.x1 ? prevPoint.x - _diff.x : prevPoint.x + _diff.x;
                            ty1 = prevPoint.y < prevPoint.curve.y1 ? prevPoint.y - _diff.y : prevPoint.y + _diff.y;
                        } else {
                            tx1 = prevPoint.x;
                            ty1 = prevPoint.y;
                        }
                        points.push({
                            curve: {
                                type: 'quadratic',
                                x1: tx1,
                                y1: ty1
                            },
                            x: tx,
                            y: ty
                        });
                        break;
                }
            }
        } else {
            var _prevPoint = points[points.length - 1] || {
                x: 0,
                y: 0
            };
            if (_prevPoint.x !== moveTo.x || _prevPoint.y !== moveTo.y) points.push({
                x: moveTo.x,
                y: moveTo.y
            });
        }
    }
    return points;
};
var $271495e66d32284a$var$getPointsFromPolygon = function getPointsFromPolygon(_ref6) {
    var points = _ref6.points;
    return $271495e66d32284a$var$getPointsFromPoints({
        closed: true,
        points: points
    });
};
var $271495e66d32284a$var$getPointsFromPolyline = function getPointsFromPolyline(_ref7) {
    var points = _ref7.points;
    return $271495e66d32284a$var$getPointsFromPoints({
        closed: false,
        points: points
    });
};
var $271495e66d32284a$var$getPointsFromPoints = function getPointsFromPoints(_ref8) {
    var closed = _ref8.closed, points = _ref8.points;
    var numbers = points.split(/[\s,]+/).map(function(n) {
        return parseFloat(n);
    });
    var p = numbers.reduce(function(arr, point, i) {
        if (i % 2 === 0) arr.push({
            x: point
        });
        else arr[(i - 1) / 2].y = point;
        return arr;
    }, []);
    if (closed) p.push($271495e66d32284a$var$_extends({}, p[0]));
    p[0].moveTo = true;
    return p;
};
var $271495e66d32284a$var$getPointsFromRect = function getPointsFromRect(_ref9) {
    var height = _ref9.height, rx = _ref9.rx, ry = _ref9.ry, width = _ref9.width, x = _ref9.x, y = _ref9.y;
    if (rx || ry) return $271495e66d32284a$var$getPointsFromRectWithCornerRadius({
        height: height,
        rx: rx || ry,
        ry: ry || rx,
        width: width,
        x: x,
        y: y
    });
    return $271495e66d32284a$var$getPointsFromBasicRect({
        height: height,
        width: width,
        x: x,
        y: y
    });
};
var $271495e66d32284a$var$getPointsFromBasicRect = function getPointsFromBasicRect(_ref10) {
    var height = _ref10.height, width = _ref10.width, x = _ref10.x, y = _ref10.y;
    return [
        {
            x: x,
            y: y,
            moveTo: true
        },
        {
            x: x + width,
            y: y
        },
        {
            x: x + width,
            y: y + height
        },
        {
            x: x,
            y: y + height
        },
        {
            x: x,
            y: y
        }
    ];
};
var $271495e66d32284a$var$getPointsFromRectWithCornerRadius = function getPointsFromRectWithCornerRadius(_ref11) {
    var height = _ref11.height, rx = _ref11.rx, ry = _ref11.ry, width = _ref11.width, x = _ref11.x, y = _ref11.y;
    var curve = {
        type: 'arc',
        rx: rx,
        ry: ry,
        sweepFlag: 1
    };
    return [
        {
            x: x + rx,
            y: y,
            moveTo: true
        },
        {
            x: x + width - rx,
            y: y
        },
        {
            x: x + width,
            y: y + ry,
            curve: curve
        },
        {
            x: x + width,
            y: y + height - ry
        },
        {
            x: x + width - rx,
            y: y + height,
            curve: curve
        },
        {
            x: x + rx,
            y: y + height
        },
        {
            x: x,
            y: y + height - ry,
            curve: curve
        },
        {
            x: x,
            y: y + ry
        },
        {
            x: x + rx,
            y: y,
            curve: curve
        }
    ];
};
var $271495e66d32284a$var$getPointsFromG = function getPointsFromG(_ref12) {
    var shapes = _ref12.shapes;
    return shapes.map(function(s) {
        return $271495e66d32284a$var$toPoints(s);
    });
};
var $271495e66d32284a$export$2e2bcd8739ae039 = $271495e66d32284a$var$toPoints;

});


parcelRegister("64fpk", function(module, exports) {
var $46af1166a2a5bf9a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $46af1166a2a5bf9a$var$getErrors = function getErrors(shape) {
    var rules = $46af1166a2a5bf9a$var$getRules(shape);
    var errors = [];
    rules.map(function(_ref) {
        var match = _ref.match, prop = _ref.prop, required = _ref.required, type = _ref.type;
        if (typeof shape[prop] === 'undefined') {
            if (required) errors.push(prop + ' prop is required' + (prop === 'type' ? '' : ' on a ' + shape.type));
        } else {
            if (typeof type !== 'undefined') {
                if (type === 'array') {
                    if (!Array.isArray(shape[prop])) errors.push(prop + ' prop must be of type array');
                } else if ($46af1166a2a5bf9a$var$_typeof(shape[prop]) !== type) // eslint-disable-line valid-typeof
                errors.push(prop + ' prop must be of type ' + type);
            }
            if (Array.isArray(match)) {
                if (match.indexOf(shape[prop]) === -1) errors.push(prop + ' prop must be one of ' + match.join(', '));
            }
        }
    });
    if (shape.type === 'g' && Array.isArray(shape.shapes)) {
        var childErrors = shape.shapes.map(function(s) {
            return getErrors(s);
        });
        return [].concat.apply(errors, childErrors);
    }
    return errors;
};
var $46af1166a2a5bf9a$var$getRules = function getRules(shape) {
    var rules = [
        {
            match: [
                'circle',
                'ellipse',
                'line',
                'path',
                'polygon',
                'polyline',
                'rect',
                'g'
            ],
            prop: 'type',
            required: true,
            type: 'string'
        }
    ];
    switch(shape.type){
        case 'circle':
            rules.push({
                prop: 'cx',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'cy',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'r',
                required: true,
                type: 'number'
            });
            break;
        case 'ellipse':
            rules.push({
                prop: 'cx',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'cy',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'rx',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'ry',
                required: true,
                type: 'number'
            });
            break;
        case 'line':
            rules.push({
                prop: 'x1',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'x2',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'y1',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'y2',
                required: true,
                type: 'number'
            });
            break;
        case 'path':
            rules.push({
                prop: 'd',
                required: true,
                type: 'string'
            });
            break;
        case 'polygon':
        case 'polyline':
            rules.push({
                prop: 'points',
                required: true,
                type: 'string'
            });
            break;
        case 'rect':
            rules.push({
                prop: 'height',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'rx',
                type: 'number'
            });
            rules.push({
                prop: 'ry',
                type: 'number'
            });
            rules.push({
                prop: 'width',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'x',
                required: true,
                type: 'number'
            });
            rules.push({
                prop: 'y',
                required: true,
                type: 'number'
            });
            break;
        case 'g':
            rules.push({
                prop: 'shapes',
                required: true,
                type: 'array'
            });
            break;
    }
    return rules;
};
var $46af1166a2a5bf9a$var$valid = function valid(shape) {
    var errors = $46af1166a2a5bf9a$var$getErrors(shape);
    return {
        errors: errors,
        valid: errors.length === 0
    };
};
var $46af1166a2a5bf9a$export$2e2bcd8739ae039 = $46af1166a2a5bf9a$var$valid;

});


parcelRegister("l0lGd", function(module, exports) {

$parcel$export(module.exports, "Bezier", () => $f4aa6a375c16f903$export$2c85281379f83a27);
/**
  A javascript Bezier curve library by Pomax.

  Based on http://pomax.github.io/bezierinfo

  This code is MIT licensed.
**/ 
var $8LP0m = parcelRequire("8LP0m");

var $9TA3v = parcelRequire("9TA3v");
// math-inlining.
const { abs: $f4aa6a375c16f903$var$abs, min: $f4aa6a375c16f903$var$min, max: $f4aa6a375c16f903$var$max, cos: $f4aa6a375c16f903$var$cos, sin: $f4aa6a375c16f903$var$sin, acos: $f4aa6a375c16f903$var$acos, sqrt: $f4aa6a375c16f903$var$sqrt } = Math;
const $f4aa6a375c16f903$var$pi = Math.PI;
// a zero coordinate, which is surprisingly useful
const $f4aa6a375c16f903$var$ZERO = {
    x: 0,
    y: 0,
    z: 0
};
/**
 * Bezier curve constructor.
 *
 * ...docs pending...
 */ class $f4aa6a375c16f903$export$2c85281379f83a27 {
    constructor(coords){
        let args = coords && coords.forEach ? coords : Array.from(arguments).slice();
        let coordlen = false;
        if (typeof args[0] === "object") {
            coordlen = args.length;
            const newargs = [];
            args.forEach(function(point) {
                [
                    "x",
                    "y",
                    "z"
                ].forEach(function(d) {
                    if (typeof point[d] !== "undefined") newargs.push(point[d]);
                });
            });
            args = newargs;
        }
        let higher = false;
        const len = args.length;
        if (coordlen) {
            if (coordlen > 4) {
                if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
                higher = true;
            }
        } else if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
            if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
        }
        const _3d = this._3d = !higher && (len === 9 || len === 12) || coords && coords[0] && typeof coords[0].z !== "undefined";
        const points = this.points = [];
        for(let idx = 0, step = _3d ? 3 : 2; idx < len; idx += step){
            var point = {
                x: args[idx],
                y: args[idx + 1]
            };
            if (_3d) point.z = args[idx + 2];
            points.push(point);
        }
        const order = this.order = points.length - 1;
        const dims = this.dims = [
            "x",
            "y"
        ];
        if (_3d) dims.push("z");
        this.dimlen = dims.length;
        // is this curve, practically speaking, a straight line?
        const aligned = (0, $8LP0m.utils).align(points, {
            p1: points[0],
            p2: points[order]
        });
        const baselength = (0, $8LP0m.utils).dist(points[0], points[order]);
        this._linear = aligned.reduce((t1, p)=>t1 + $f4aa6a375c16f903$var$abs(p.y), 0) < baselength / 50;
        this._lut = [];
        this._t1 = 0;
        this._t2 = 1;
        this.update();
    }
    static quadraticFromPoints(p1, p2, p3, t1) {
        if (typeof t1 === "undefined") t1 = 0.5;
        // shortcuts, although they're really dumb
        if (t1 === 0) return new $f4aa6a375c16f903$export$2c85281379f83a27(p2, p2, p3);
        if (t1 === 1) return new $f4aa6a375c16f903$export$2c85281379f83a27(p1, p2, p2);
        // real fitting.
        const abc = $f4aa6a375c16f903$export$2c85281379f83a27.getABC(2, p1, p2, p3, t1);
        return new $f4aa6a375c16f903$export$2c85281379f83a27(p1, abc.A, p3);
    }
    static cubicFromPoints(S, B, E, t1, d1) {
        if (typeof t1 === "undefined") t1 = 0.5;
        const abc = $f4aa6a375c16f903$export$2c85281379f83a27.getABC(3, S, B, E, t1);
        if (typeof d1 === "undefined") d1 = (0, $8LP0m.utils).dist(B, abc.C);
        const d2 = d1 * (1 - t1) / t1;
        const selen = (0, $8LP0m.utils).dist(S, E), lx = (E.x - S.x) / selen, ly = (E.y - S.y) / selen, bx1 = d1 * lx, by1 = d1 * ly, bx2 = d2 * lx, by2 = d2 * ly;
        // derivation of new hull coordinates
        const e1 = {
            x: B.x - bx1,
            y: B.y - by1
        }, e2 = {
            x: B.x + bx2,
            y: B.y + by2
        }, A = abc.A, v1 = {
            x: A.x + (e1.x - A.x) / (1 - t1),
            y: A.y + (e1.y - A.y) / (1 - t1)
        }, v2 = {
            x: A.x + (e2.x - A.x) / t1,
            y: A.y + (e2.y - A.y) / t1
        }, nc1 = {
            x: S.x + (v1.x - S.x) / t1,
            y: S.y + (v1.y - S.y) / t1
        }, nc2 = {
            x: E.x + (v2.x - E.x) / (1 - t1),
            y: E.y + (v2.y - E.y) / (1 - t1)
        };
        // ...done
        return new $f4aa6a375c16f903$export$2c85281379f83a27(S, nc1, nc2, E);
    }
    static getUtils() {
        return 0, $8LP0m.utils;
    }
    getUtils() {
        return $f4aa6a375c16f903$export$2c85281379f83a27.getUtils();
    }
    static get PolyBezier() {
        return 0, $9TA3v.PolyBezier;
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return (0, $8LP0m.utils).pointsToString(this.points);
    }
    toSVG() {
        if (this._3d) return false;
        const p = this.points, x = p[0].x, y = p[0].y, s = [
            "M",
            x,
            y,
            this.order === 2 ? "Q" : "C"
        ];
        for(let i = 1, last = p.length; i < last; i++){
            s.push(p[i].x);
            s.push(p[i].y);
        }
        return s.join(" ");
    }
    setRatios(ratios) {
        if (ratios.length !== this.points.length) throw new Error("incorrect number of ratio values");
        this.ratios = ratios;
        this._lut = []; //  invalidate any precomputed LUT
    }
    verify() {
        const print = this.coordDigest();
        if (print !== this._print) {
            this._print = print;
            this.update();
        }
    }
    coordDigest() {
        return this.points.map(function(c, pos) {
            return "" + pos + c.x + c.y + (c.z ? c.z : 0);
        }).join("");
    }
    update() {
        // invalidate any precomputed LUT
        this._lut = [];
        this.dpoints = (0, $8LP0m.utils).derive(this.points, this._3d);
        this.computedirection();
    }
    computedirection() {
        const points = this.points;
        const angle = (0, $8LP0m.utils).angle(points[0], points[this.order], points[1]);
        this.clockwise = angle > 0;
    }
    length() {
        return (0, $8LP0m.utils).length(this.derivative.bind(this));
    }
    static getABC(order = 2, S, B, E, t1 = 0.5) {
        const u = (0, $8LP0m.utils).projectionratio(t1, order), um = 1 - u, C = {
            x: u * S.x + um * E.x,
            y: u * S.y + um * E.y
        }, s = (0, $8LP0m.utils).abcratio(t1, order), A = {
            x: B.x + (B.x - C.x) / s,
            y: B.y + (B.y - C.y) / s
        };
        return {
            A: A,
            B: B,
            C: C,
            S: S,
            E: E
        };
    }
    getABC(t1, B) {
        B = B || this.get(t1);
        let S = this.points[0];
        let E = this.points[this.order];
        return $f4aa6a375c16f903$export$2c85281379f83a27.getABC(this.order, S, B, E, t1);
    }
    getLUT(steps) {
        this.verify();
        steps = steps || 100;
        if (this._lut.length === steps + 1) return this._lut;
        this._lut = [];
        // n steps means n+1 points
        steps++;
        this._lut = [];
        for(let i = 0, p, t1; i < steps; i++){
            t1 = i / (steps - 1);
            p = this.compute(t1);
            p.t = t1;
            this._lut.push(p);
        }
        return this._lut;
    }
    on(point, error) {
        error = error || 5;
        const lut = this.getLUT(), hits = [];
        for(let i = 0, c, t1 = 0; i < lut.length; i++){
            c = lut[i];
            if ((0, $8LP0m.utils).dist(c, point) < error) {
                hits.push(c);
                t1 += i / lut.length;
            }
        }
        if (!hits.length) return false;
        return t /= hits.length;
    }
    project(point) {
        // step 1: coarse check
        const LUT = this.getLUT(), l = LUT.length - 1, closest = (0, $8LP0m.utils).closest(LUT, point), mpos = closest.mpos, t1 = (mpos - 1) / l, t2 = (mpos + 1) / l, step = 0.1 / l;
        // step 2: fine check
        let mdist = closest.mdist, t3 = t1, ft = t3, p;
        mdist += 1;
        for(let d; t3 < t2 + step; t3 += step){
            p = this.compute(t3);
            d = (0, $8LP0m.utils).dist(point, p);
            if (d < mdist) {
                mdist = d;
                ft = t3;
            }
        }
        ft = ft < 0 ? 0 : ft > 1 ? 1 : ft;
        p = this.compute(ft);
        p.t = ft;
        p.d = mdist;
        return p;
    }
    get(t1) {
        return this.compute(t1);
    }
    point(idx) {
        return this.points[idx];
    }
    compute(t1) {
        if (this.ratios) return (0, $8LP0m.utils).computeWithRatios(t1, this.points, this.ratios, this._3d);
        return (0, $8LP0m.utils).compute(t1, this.points, this._3d, this.ratios);
    }
    raise() {
        const p = this.points, np = [
            p[0]
        ], k = p.length;
        for(let i = 1, pi, pim; i < k; i++){
            pi = p[i];
            pim = p[i - 1];
            np[i] = {
                x: (k - i) / k * pi.x + i / k * pim.x,
                y: (k - i) / k * pi.y + i / k * pim.y
            };
        }
        np[k] = p[k - 1];
        return new $f4aa6a375c16f903$export$2c85281379f83a27(np);
    }
    derivative(t1) {
        return (0, $8LP0m.utils).compute(t1, this.dpoints[0], this._3d);
    }
    dderivative(t1) {
        return (0, $8LP0m.utils).compute(t1, this.dpoints[1], this._3d);
    }
    align() {
        let p = this.points;
        return new $f4aa6a375c16f903$export$2c85281379f83a27((0, $8LP0m.utils).align(p, {
            p1: p[0],
            p2: p[p.length - 1]
        }));
    }
    curvature(t1) {
        return (0, $8LP0m.utils).curvature(t1, this.dpoints[0], this.dpoints[1], this._3d);
    }
    inflections() {
        return (0, $8LP0m.utils).inflections(this.points);
    }
    normal(t1) {
        return this._3d ? this.__normal3(t1) : this.__normal2(t1);
    }
    __normal2(t1) {
        const d = this.derivative(t1);
        const q = $f4aa6a375c16f903$var$sqrt(d.x * d.x + d.y * d.y);
        return {
            t: t1,
            x: -d.y / q,
            y: d.x / q
        };
    }
    __normal3(t1) {
        // see http://stackoverflow.com/questions/25453159
        const r1 = this.derivative(t1), r2 = this.derivative(t1 + 0.01), q1 = $f4aa6a375c16f903$var$sqrt(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z), q2 = $f4aa6a375c16f903$var$sqrt(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
        r1.x /= q1;
        r1.y /= q1;
        r1.z /= q1;
        r2.x /= q2;
        r2.y /= q2;
        r2.z /= q2;
        // cross product
        const c = {
            x: r2.y * r1.z - r2.z * r1.y,
            y: r2.z * r1.x - r2.x * r1.z,
            z: r2.x * r1.y - r2.y * r1.x
        };
        const m = $f4aa6a375c16f903$var$sqrt(c.x * c.x + c.y * c.y + c.z * c.z);
        c.x /= m;
        c.y /= m;
        c.z /= m;
        // rotation matrix
        const R = [
            c.x * c.x,
            c.x * c.y - c.z,
            c.x * c.z + c.y,
            c.x * c.y + c.z,
            c.y * c.y,
            c.y * c.z - c.x,
            c.x * c.z - c.y,
            c.y * c.z + c.x,
            c.z * c.z
        ];
        // normal vector:
        const n = {
            t: t1,
            x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
            y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
            z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
        };
        return n;
    }
    hull(t1) {
        let p = this.points, _p = [], q = [], idx = 0;
        q[idx++] = p[0];
        q[idx++] = p[1];
        q[idx++] = p[2];
        if (this.order === 3) q[idx++] = p[3];
        // we lerp between all points at each iteration, until we have 1 point left.
        while(p.length > 1){
            _p = [];
            for(let i = 0, pt, l = p.length - 1; i < l; i++){
                pt = (0, $8LP0m.utils).lerp(t1, p[i], p[i + 1]);
                q[idx++] = pt;
                _p.push(pt);
            }
            p = _p;
        }
        return q;
    }
    split(t1, t2) {
        // shortcuts
        if (t1 === 0 && !!t2) return this.split(t2).left;
        if (t2 === 1) return this.split(t1).right;
        // no shortcut: use "de Casteljau" iteration.
        const q = this.hull(t1);
        const result = {
            left: this.order === 2 ? new $f4aa6a375c16f903$export$2c85281379f83a27([
                q[0],
                q[3],
                q[5]
            ]) : new $f4aa6a375c16f903$export$2c85281379f83a27([
                q[0],
                q[4],
                q[7],
                q[9]
            ]),
            right: this.order === 2 ? new $f4aa6a375c16f903$export$2c85281379f83a27([
                q[5],
                q[4],
                q[2]
            ]) : new $f4aa6a375c16f903$export$2c85281379f83a27([
                q[9],
                q[8],
                q[6],
                q[3]
            ]),
            span: q
        };
        // make sure we bind _t1/_t2 information!
        result.left._t1 = (0, $8LP0m.utils).map(0, 0, 1, this._t1, this._t2);
        result.left._t2 = (0, $8LP0m.utils).map(t1, 0, 1, this._t1, this._t2);
        result.right._t1 = (0, $8LP0m.utils).map(t1, 0, 1, this._t1, this._t2);
        result.right._t2 = (0, $8LP0m.utils).map(1, 0, 1, this._t1, this._t2);
        // if we have no t2, we're done
        if (!t2) return result;
        // if we have a t2, split again:
        t2 = (0, $8LP0m.utils).map(t2, t1, 1, 0, 1);
        return result.right.split(t2).left;
    }
    extrema() {
        const result = {};
        let roots = [];
        this.dims.forEach((function(dim) {
            let mfn = function(v) {
                return v[dim];
            };
            let p = this.dpoints[0].map(mfn);
            result[dim] = (0, $8LP0m.utils).droots(p);
            if (this.order === 3) {
                p = this.dpoints[1].map(mfn);
                result[dim] = result[dim].concat((0, $8LP0m.utils).droots(p));
            }
            result[dim] = result[dim].filter(function(t1) {
                return t1 >= 0 && t1 <= 1;
            });
            roots = roots.concat(result[dim].sort((0, $8LP0m.utils).numberSort));
        }).bind(this));
        result.values = roots.sort((0, $8LP0m.utils).numberSort).filter(function(v, idx) {
            return roots.indexOf(v) === idx;
        });
        return result;
    }
    bbox() {
        const extrema = this.extrema(), result = {};
        this.dims.forEach((function(d) {
            result[d] = (0, $8LP0m.utils).getminmax(this, d, extrema[d]);
        }).bind(this));
        return result;
    }
    overlaps(curve) {
        const lbbox = this.bbox(), tbbox = curve.bbox();
        return (0, $8LP0m.utils).bboxoverlap(lbbox, tbbox);
    }
    offset(t1, d) {
        if (typeof d !== "undefined") {
            const c = this.get(t1), n = this.normal(t1);
            const ret = {
                c: c,
                n: n,
                x: c.x + n.x * d,
                y: c.y + n.y * d
            };
            if (this._3d) ret.z = c.z + n.z * d;
            return ret;
        }
        if (this._linear) {
            const nv = this.normal(0), coords = this.points.map(function(p) {
                const ret = {
                    x: p.x + t1 * nv.x,
                    y: p.y + t1 * nv.y
                };
                if (p.z && nv.z) ret.z = p.z + t1 * nv.z;
                return ret;
            });
            return [
                new $f4aa6a375c16f903$export$2c85281379f83a27(coords)
            ];
        }
        return this.reduce().map(function(s) {
            if (s._linear) return s.offset(t1)[0];
            return s.scale(t1);
        });
    }
    simple() {
        if (this.order === 3) {
            const a1 = (0, $8LP0m.utils).angle(this.points[0], this.points[3], this.points[1]);
            const a2 = (0, $8LP0m.utils).angle(this.points[0], this.points[3], this.points[2]);
            if (a1 > 0 && a2 < 0 || a1 < 0 && a2 > 0) return false;
        }
        const n1 = this.normal(0);
        const n2 = this.normal(1);
        let s = n1.x * n2.x + n1.y * n2.y;
        if (this._3d) s += n1.z * n2.z;
        return $f4aa6a375c16f903$var$abs($f4aa6a375c16f903$var$acos(s)) < $f4aa6a375c16f903$var$pi / 3;
    }
    reduce() {
        // TODO: examine these var types in more detail...
        let i, t1 = 0, t2 = 0, step = 0.01, segment, pass1 = [], pass2 = [];
        // first pass: split on extrema
        let extrema = this.extrema().values;
        if (extrema.indexOf(0) === -1) extrema = [
            0
        ].concat(extrema);
        if (extrema.indexOf(1) === -1) extrema.push(1);
        for(t1 = extrema[0], i = 1; i < extrema.length; i++){
            t2 = extrema[i];
            segment = this.split(t1, t2);
            segment._t1 = t1;
            segment._t2 = t2;
            pass1.push(segment);
            t1 = t2;
        }
        // second pass: further reduce these segments to simple segments
        pass1.forEach(function(p1) {
            t1 = 0;
            t2 = 0;
            while(t2 <= 1)for(t2 = t1 + step; t2 <= 1 + step; t2 += step){
                segment = p1.split(t1, t2);
                if (!segment.simple()) {
                    t2 -= step;
                    if ($f4aa6a375c16f903$var$abs(t1 - t2) < step) // we can never form a reduction
                    return [];
                    segment = p1.split(t1, t2);
                    segment._t1 = (0, $8LP0m.utils).map(t1, 0, 1, p1._t1, p1._t2);
                    segment._t2 = (0, $8LP0m.utils).map(t2, 0, 1, p1._t1, p1._t2);
                    pass2.push(segment);
                    t1 = t2;
                    break;
                }
            }
            if (t1 < 1) {
                segment = p1.split(t1, 1);
                segment._t1 = (0, $8LP0m.utils).map(t1, 0, 1, p1._t1, p1._t2);
                segment._t2 = p1._t2;
                pass2.push(segment);
            }
        });
        return pass2;
    }
    translate(v, d1, d2) {
        d2 = typeof d2 === "number" ? d2 : d1;
        // TODO: make this take curves with control points outside
        //       of the start-end interval into account
        const o = this.order;
        let d = this.points.map((_, i)=>(1 - i / o) * d1 + i / o * d2);
        return new $f4aa6a375c16f903$export$2c85281379f83a27(this.points.map((p, i)=>({
                x: p.x + v.x * d[i],
                y: p.y + v.y * d[i]
            })));
    }
    scale(d) {
        const order = this.order;
        let distanceFn = false;
        if (typeof d === "function") distanceFn = d;
        if (distanceFn && order === 2) return this.raise().scale(distanceFn);
        // TODO: add special handling for non-linear degenerate curves.
        const clockwise = this.clockwise;
        const points = this.points;
        if (this._linear) return this.translate(this.normal(0), distanceFn ? distanceFn(0) : d, distanceFn ? distanceFn(1) : d);
        const r1 = distanceFn ? distanceFn(0) : d;
        const r2 = distanceFn ? distanceFn(1) : d;
        const v = [
            this.offset(0, 10),
            this.offset(1, 10)
        ];
        const np = [];
        const o = (0, $8LP0m.utils).lli4(v[0], v[0].c, v[1], v[1].c);
        if (!o) throw new Error("cannot scale this curve. Try reducing it first.");
        // move all points by distance 'd' wrt the origin 'o',
        // and move end points by fixed distance along normal.
        [
            0,
            1
        ].forEach(function(t1) {
            const p = np[t1 * order] = (0, $8LP0m.utils).copy(points[t1 * order]);
            p.x += (t1 ? r2 : r1) * v[t1].n.x;
            p.y += (t1 ? r2 : r1) * v[t1].n.y;
        });
        if (!distanceFn) {
            // move control points to lie on the intersection of the offset
            // derivative vector, and the origin-through-control vector
            [
                0,
                1
            ].forEach((t1)=>{
                if (order === 2 && !!t1) return;
                const p = np[t1 * order];
                const d = this.derivative(t1);
                const p2 = {
                    x: p.x + d.x,
                    y: p.y + d.y
                };
                np[t1 + 1] = (0, $8LP0m.utils).lli4(p, p2, o, points[t1 + 1]);
            });
            return new $f4aa6a375c16f903$export$2c85281379f83a27(np);
        }
        // move control points by "however much necessary to
        // ensure the correct tangent to endpoint".
        [
            0,
            1
        ].forEach(function(t1) {
            if (order === 2 && !!t1) return;
            var p = points[t1 + 1];
            var ov = {
                x: p.x - o.x,
                y: p.y - o.y
            };
            var rc = distanceFn ? distanceFn((t1 + 1) / order) : d;
            if (distanceFn && !clockwise) rc = -rc;
            var m = $f4aa6a375c16f903$var$sqrt(ov.x * ov.x + ov.y * ov.y);
            ov.x /= m;
            ov.y /= m;
            np[t1 + 1] = {
                x: p.x + rc * ov.x,
                y: p.y + rc * ov.y
            };
        });
        return new $f4aa6a375c16f903$export$2c85281379f83a27(np);
    }
    outline(d1, d2, d3, d4) {
        d2 = d2 === undefined ? d1 : d2;
        if (this._linear) {
            // TODO: find the actual extrema, because they might
            //       be before the start, or past the end.
            const n = this.normal(0);
            const start = this.points[0];
            const end = this.points[this.points.length - 1];
            let s, mid, e;
            if (d3 === undefined) {
                d3 = d1;
                d4 = d2;
            }
            s = {
                x: start.x + n.x * d1,
                y: start.y + n.y * d1
            };
            e = {
                x: end.x + n.x * d3,
                y: end.y + n.y * d3
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const fline = [
                s,
                mid,
                e
            ];
            s = {
                x: start.x - n.x * d2,
                y: start.y - n.y * d2
            };
            e = {
                x: end.x - n.x * d4,
                y: end.y - n.y * d4
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const bline = [
                e,
                mid,
                s
            ];
            const ls = (0, $8LP0m.utils).makeline(bline[2], fline[0]);
            const le = (0, $8LP0m.utils).makeline(fline[2], bline[0]);
            const segments = [
                ls,
                new $f4aa6a375c16f903$export$2c85281379f83a27(fline),
                le,
                new $f4aa6a375c16f903$export$2c85281379f83a27(bline)
            ];
            return new (0, $9TA3v.PolyBezier)(segments);
        }
        const reduced = this.reduce(), len = reduced.length, fcurves = [];
        let bcurves = [], p, alen = 0, tlen = this.length();
        const graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";
        function linearDistanceFunction(s, e, tlen, alen, slen) {
            return function(v) {
                const f1 = alen / tlen, f2 = (alen + slen) / tlen, d = e - s;
                return (0, $8LP0m.utils).map(v, 0, 1, s + f1 * d, s + f2 * d);
            };
        }
        // form curve oulines
        reduced.forEach(function(segment) {
            const slen = segment.length();
            if (graduated) {
                fcurves.push(segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen)));
                bcurves.push(segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen)));
            } else {
                fcurves.push(segment.scale(d1));
                bcurves.push(segment.scale(-d2));
            }
            alen += slen;
        });
        // reverse the "return" outline
        bcurves = bcurves.map(function(s) {
            p = s.points;
            if (p[3]) s.points = [
                p[3],
                p[2],
                p[1],
                p[0]
            ];
            else s.points = [
                p[2],
                p[1],
                p[0]
            ];
            return s;
        }).reverse();
        // form the endcaps as lines
        const fs = fcurves[0].points[0], fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1], bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1], be = bcurves[0].points[0], ls = (0, $8LP0m.utils).makeline(bs, fs), le = (0, $8LP0m.utils).makeline(fe, be), segments = [
            ls
        ].concat(fcurves).concat([
            le
        ]).concat(bcurves);
        return new (0, $9TA3v.PolyBezier)(segments);
    }
    outlineshapes(d1, d2, curveIntersectionThreshold) {
        d2 = d2 || d1;
        const outline = this.outline(d1, d2).curves;
        const shapes = [];
        for(let i = 1, len = outline.length; i < len / 2; i++){
            const shape = (0, $8LP0m.utils).makeshape(outline[i], outline[len - i], curveIntersectionThreshold);
            shape.startcap.virtual = i > 1;
            shape.endcap.virtual = i < len / 2 - 1;
            shapes.push(shape);
        }
        return shapes;
    }
    intersects(curve, curveIntersectionThreshold) {
        if (!curve) return this.selfintersects(curveIntersectionThreshold);
        if (curve.p1 && curve.p2) return this.lineIntersects(curve);
        if (curve instanceof $f4aa6a375c16f903$export$2c85281379f83a27) curve = curve.reduce();
        return this.curveintersects(this.reduce(), curve, curveIntersectionThreshold);
    }
    lineIntersects(line) {
        const mx = $f4aa6a375c16f903$var$min(line.p1.x, line.p2.x), my = $f4aa6a375c16f903$var$min(line.p1.y, line.p2.y), MX = $f4aa6a375c16f903$var$max(line.p1.x, line.p2.x), MY = $f4aa6a375c16f903$var$max(line.p1.y, line.p2.y);
        return (0, $8LP0m.utils).roots(this.points, line).filter((t1)=>{
            var p = this.get(t1);
            return (0, $8LP0m.utils).between(p.x, mx, MX) && (0, $8LP0m.utils).between(p.y, my, MY);
        });
    }
    selfintersects(curveIntersectionThreshold) {
        // "simple" curves cannot intersect with their direct
        // neighbour, so for each segment X we check whether
        // it intersects [0:x-2][x+2:last].
        const reduced = this.reduce(), len = reduced.length - 2, results = [];
        for(let i = 0, result, left, right; i < len; i++){
            left = reduced.slice(i, i + 1);
            right = reduced.slice(i + 2);
            result = this.curveintersects(left, right, curveIntersectionThreshold);
            results.push(...result);
        }
        return results;
    }
    curveintersects(c1, c2, curveIntersectionThreshold) {
        const pairs = [];
        // step 1: pair off any overlapping segments
        c1.forEach(function(l) {
            c2.forEach(function(r) {
                if (l.overlaps(r)) pairs.push({
                    left: l,
                    right: r
                });
            });
        });
        // step 2: for each pairing, run through the convergence algorithm.
        let intersections = [];
        pairs.forEach(function(pair) {
            const result = (0, $8LP0m.utils).pairiteration(pair.left, pair.right, curveIntersectionThreshold);
            if (result.length > 0) intersections = intersections.concat(result);
        });
        return intersections;
    }
    arcs(errorThreshold) {
        errorThreshold = errorThreshold || 0.5;
        return this._iterate(errorThreshold, []);
    }
    _error(pc, np1, s, e) {
        const q = (e - s) / 4, c1 = this.get(s + q), c2 = this.get(e - q), ref = (0, $8LP0m.utils).dist(pc, np1), d1 = (0, $8LP0m.utils).dist(pc, c1), d2 = (0, $8LP0m.utils).dist(pc, c2);
        return $f4aa6a375c16f903$var$abs(d1 - ref) + $f4aa6a375c16f903$var$abs(d2 - ref);
    }
    _iterate(errorThreshold, circles) {
        let t_s = 0, t_e = 1, safety;
        // we do a binary search to find the "good `t` closest to no-longer-good"
        do {
            safety = 0;
            // step 1: start with the maximum possible arc
            t_e = 1;
            // points:
            let np1 = this.get(t_s), np2, np3, arc, prev_arc;
            // booleans:
            let curr_good = false, prev_good = false, done;
            // numbers:
            let t_m = t_e, prev_e = 1, step = 0;
            // step 2: find the best possible arc
            do {
                prev_good = curr_good;
                prev_arc = arc;
                t_m = (t_s + t_e) / 2;
                step++;
                np2 = this.get(t_m);
                np3 = this.get(t_e);
                arc = (0, $8LP0m.utils).getccenter(np1, np2, np3);
                //also save the t values
                arc.interval = {
                    start: t_s,
                    end: t_e
                };
                let error = this._error(arc, np1, t_s, t_e);
                curr_good = error <= errorThreshold;
                done = prev_good && !curr_good;
                if (!done) prev_e = t_e;
                // this arc is fine: we can move 'e' up to see if we can find a wider arc
                if (curr_good) {
                    // if e is already at max, then we're done for this arc.
                    if (t_e >= 1) {
                        // make sure we cap at t=1
                        arc.interval.end = prev_e = 1;
                        prev_arc = arc;
                        // if we capped the arc segment to t=1 we also need to make sure that
                        // the arc's end angle is correct with respect to the bezier end point.
                        if (t_e > 1) {
                            let d = {
                                x: arc.x + arc.r * $f4aa6a375c16f903$var$cos(arc.e),
                                y: arc.y + arc.r * $f4aa6a375c16f903$var$sin(arc.e)
                            };
                            arc.e += (0, $8LP0m.utils).angle({
                                x: arc.x,
                                y: arc.y
                            }, d, this.get(1));
                        }
                        break;
                    }
                    // if not, move it up by half the iteration distance
                    t_e = t_e + (t_e - t_s) / 2;
                } else // this is a bad arc: we need to move 'e' down to find a good arc
                t_e = t_m;
            }while (!done && safety++ < 100);
            if (safety >= 100) break;
            // console.log("L835: [F] arc found", t_s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);
            prev_arc = prev_arc ? prev_arc : arc;
            circles.push(prev_arc);
            t_s = prev_e;
        }while (t_e < 1);
        return circles;
    }
}

});
parcelRegister("8LP0m", function(module, exports) {

$parcel$export(module.exports, "utils", () => $662a4702b3c1b395$export$eab97d15b1788b8d);

var $l0lGd = parcelRequire("l0lGd");
// math-inlining.
const { abs: $662a4702b3c1b395$var$abs, cos: $662a4702b3c1b395$var$cos, sin: $662a4702b3c1b395$var$sin, acos: $662a4702b3c1b395$var$acos, atan2: $662a4702b3c1b395$var$atan2, sqrt: $662a4702b3c1b395$var$sqrt, pow: $662a4702b3c1b395$var$pow } = Math;
// cube root function yielding real roots
function $662a4702b3c1b395$var$crt(v) {
    return v < 0 ? -$662a4702b3c1b395$var$pow(-v, 1 / 3) : $662a4702b3c1b395$var$pow(v, 1 / 3);
}
// trig constants
const $662a4702b3c1b395$var$pi = Math.PI, $662a4702b3c1b395$var$tau = 2 * $662a4702b3c1b395$var$pi, $662a4702b3c1b395$var$quart = $662a4702b3c1b395$var$pi / 2, // float precision significant decimal
$662a4702b3c1b395$var$epsilon = 0.000001, // extremas used in bbox calculation and similar algorithms
$662a4702b3c1b395$var$nMax = Number.MAX_SAFE_INTEGER || 9007199254740991, $662a4702b3c1b395$var$nMin = Number.MIN_SAFE_INTEGER || -9007199254740991, // a zero coordinate, which is surprisingly useful
$662a4702b3c1b395$var$ZERO = {
    x: 0,
    y: 0,
    z: 0
};
// Bezier utility functions
const $662a4702b3c1b395$export$eab97d15b1788b8d = {
    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
    Tvalues: [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ],
    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
    Cvalues: [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ],
    arcfn: function(t, derivativeFn) {
        const d = derivativeFn(t);
        let l = d.x * d.x + d.y * d.y;
        if (typeof d.z !== "undefined") l += d.z * d.z;
        return $662a4702b3c1b395$var$sqrt(l);
    },
    compute: function(t, points, _3d) {
        // shortcuts
        if (t === 0) {
            points[0].t = 0;
            return points[0];
        }
        const order = points.length - 1;
        if (t === 1) {
            points[order].t = 1;
            return points[order];
        }
        const mt = 1 - t;
        let p = points;
        // constant?
        if (order === 0) {
            points[0].t = t;
            return points[0];
        }
        // linear?
        if (order === 1) {
            const ret = {
                x: mt * p[0].x + t * p[1].x,
                y: mt * p[0].y + t * p[1].y,
                t: t
            };
            if (_3d) ret.z = mt * p[0].z + t * p[1].z;
            return ret;
        }
        // quadratic/cubic curve?
        if (order < 4) {
            let mt2 = mt * mt, t2 = t * t, a, b, c, d = 0;
            if (order === 2) {
                p = [
                    p[0],
                    p[1],
                    p[2],
                    $662a4702b3c1b395$var$ZERO
                ];
                a = mt2;
                b = mt * t * 2;
                c = t2;
            } else if (order === 3) {
                a = mt2 * mt;
                b = mt2 * t * 3;
                c = mt * t2 * 3;
                d = t * t2;
            }
            const ret = {
                x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y,
                t: t
            };
            if (_3d) ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
            return ret;
        }
        // higher order curves: use de Casteljau's computation
        const dCpts = JSON.parse(JSON.stringify(points));
        while(dCpts.length > 1){
            for(let i = 0; i < dCpts.length - 1; i++){
                dCpts[i] = {
                    x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t,
                    y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t
                };
                if (typeof dCpts[i].z !== "undefined") dCpts[i].z = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t;
            }
            dCpts.splice(dCpts.length - 1, 1);
        }
        dCpts[0].t = t;
        return dCpts[0];
    },
    computeWithRatios: function(t, points, ratios, _3d) {
        const mt = 1 - t, r = ratios, p = points;
        let f1 = r[0], f2 = r[1], f3 = r[2], f4 = r[3], d;
        // spec for linear
        f1 *= mt;
        f2 *= t;
        if (p.length === 2) {
            d = f1 + f2;
            return {
                x: (f1 * p[0].x + f2 * p[1].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z) / d,
                t: t
            };
        }
        // upgrade to quadratic
        f1 *= mt;
        f2 *= 2 * mt;
        f3 *= t * t;
        if (p.length === 3) {
            d = f1 + f2 + f3;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z) / d,
                t: t
            };
        }
        // upgrade to cubic
        f1 *= mt;
        f2 *= 1.5 * mt;
        f3 *= 3 * mt;
        f4 *= t * t * t;
        if (p.length === 4) {
            d = f1 + f2 + f3 + f4;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x + f4 * p[3].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y + f4 * p[3].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z + f4 * p[3].z) / d,
                t: t
            };
        }
    },
    derive: function(points, _3d) {
        const dpoints = [];
        for(let p = points, d = p.length, c = d - 1; d > 1; d--, c--){
            const list = [];
            for(let j = 0, dpt; j < c; j++){
                dpt = {
                    x: c * (p[j + 1].x - p[j].x),
                    y: c * (p[j + 1].y - p[j].y)
                };
                if (_3d) dpt.z = c * (p[j + 1].z - p[j].z);
                list.push(dpt);
            }
            dpoints.push(list);
            p = list;
        }
        return dpoints;
    },
    between: function(v, m, M) {
        return m <= v && v <= M || $662a4702b3c1b395$export$eab97d15b1788b8d.approximately(v, m) || $662a4702b3c1b395$export$eab97d15b1788b8d.approximately(v, M);
    },
    approximately: function(a, b, precision) {
        return $662a4702b3c1b395$var$abs(a - b) <= (precision || $662a4702b3c1b395$var$epsilon);
    },
    length: function(derivativeFn) {
        const z = 0.5, len = $662a4702b3c1b395$export$eab97d15b1788b8d.Tvalues.length;
        let sum = 0;
        for(let i = 0, t; i < len; i++){
            t = z * $662a4702b3c1b395$export$eab97d15b1788b8d.Tvalues[i] + z;
            sum += $662a4702b3c1b395$export$eab97d15b1788b8d.Cvalues[i] * $662a4702b3c1b395$export$eab97d15b1788b8d.arcfn(t, derivativeFn);
        }
        return z * sum;
    },
    map: function(v, ds, de, ts, te) {
        const d1 = de - ds, d2 = te - ts, v2 = v - ds, r = v2 / d1;
        return ts + d2 * r;
    },
    lerp: function(r, v1, v2) {
        const ret = {
            x: v1.x + r * (v2.x - v1.x),
            y: v1.y + r * (v2.y - v1.y)
        };
        if (v1.z !== undefined && v2.z !== undefined) ret.z = v1.z + r * (v2.z - v1.z);
        return ret;
    },
    pointToString: function(p) {
        let s = p.x + "/" + p.y;
        if (typeof p.z !== "undefined") s += "/" + p.z;
        return s;
    },
    pointsToString: function(points) {
        return "[" + points.map($662a4702b3c1b395$export$eab97d15b1788b8d.pointToString).join(", ") + "]";
    },
    copy: function(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    angle: function(o, v1, v2) {
        const dx1 = v1.x - o.x, dy1 = v1.y - o.y, dx2 = v2.x - o.x, dy2 = v2.y - o.y, cross = dx1 * dy2 - dy1 * dx2, dot = dx1 * dx2 + dy1 * dy2;
        return $662a4702b3c1b395$var$atan2(cross, dot);
    },
    // round as string, to avoid rounding errors
    round: function(v, d) {
        const s = "" + v;
        const pos = s.indexOf(".");
        return parseFloat(s.substring(0, pos + 1 + d));
    },
    dist: function(p1, p2) {
        const dx = p1.x - p2.x, dy = p1.y - p2.y;
        return $662a4702b3c1b395$var$sqrt(dx * dx + dy * dy);
    },
    closest: function(LUT, point) {
        let mdist = $662a4702b3c1b395$var$pow(2, 63), mpos, d;
        LUT.forEach(function(p, idx) {
            d = $662a4702b3c1b395$export$eab97d15b1788b8d.dist(point, p);
            if (d < mdist) {
                mdist = d;
                mpos = idx;
            }
        });
        return {
            mdist: mdist,
            mpos: mpos
        };
    },
    abcratio: function(t, n) {
        // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
        if (n !== 2 && n !== 3) return false;
        if (typeof t === "undefined") t = 0.5;
        else if (t === 0 || t === 1) return t;
        const bottom = $662a4702b3c1b395$var$pow(t, n) + $662a4702b3c1b395$var$pow(1 - t, n), top = bottom - 1;
        return $662a4702b3c1b395$var$abs(top / bottom);
    },
    projectionratio: function(t, n) {
        // see u(t) note on http://pomax.github.io/bezierinfo/#abc
        if (n !== 2 && n !== 3) return false;
        if (typeof t === "undefined") t = 0.5;
        else if (t === 0 || t === 1) return t;
        const top = $662a4702b3c1b395$var$pow(1 - t, n), bottom = $662a4702b3c1b395$var$pow(t, n) + top;
        return top / bottom;
    },
    lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
        const nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (d == 0) return false;
        return {
            x: nx / d,
            y: ny / d
        };
    },
    lli4: function(p1, p2, p3, p4) {
        const x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, x3 = p3.x, y3 = p3.y, x4 = p4.x, y4 = p4.y;
        return $662a4702b3c1b395$export$eab97d15b1788b8d.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
    },
    lli: function(v1, v2) {
        return $662a4702b3c1b395$export$eab97d15b1788b8d.lli4(v1, v1.c, v2, v2.c);
    },
    makeline: function(p1, p2) {
        return new (0, $l0lGd.Bezier)(p1.x, p1.y, (p1.x + p2.x) / 2, (p1.y + p2.y) / 2, p2.x, p2.y);
    },
    findbbox: function(sections) {
        let mx = $662a4702b3c1b395$var$nMax, my = $662a4702b3c1b395$var$nMax, MX = $662a4702b3c1b395$var$nMin, MY = $662a4702b3c1b395$var$nMin;
        sections.forEach(function(s) {
            const bbox = s.bbox();
            if (mx > bbox.x.min) mx = bbox.x.min;
            if (my > bbox.y.min) my = bbox.y.min;
            if (MX < bbox.x.max) MX = bbox.x.max;
            if (MY < bbox.y.max) MY = bbox.y.max;
        });
        return {
            x: {
                min: mx,
                mid: (mx + MX) / 2,
                max: MX,
                size: MX - mx
            },
            y: {
                min: my,
                mid: (my + MY) / 2,
                max: MY,
                size: MY - my
            }
        };
    },
    shapeintersections: function(s1, bbox1, s2, bbox2, curveIntersectionThreshold) {
        if (!$662a4702b3c1b395$export$eab97d15b1788b8d.bboxoverlap(bbox1, bbox2)) return [];
        const intersections = [];
        const a1 = [
            s1.startcap,
            s1.forward,
            s1.back,
            s1.endcap
        ];
        const a2 = [
            s2.startcap,
            s2.forward,
            s2.back,
            s2.endcap
        ];
        a1.forEach(function(l1) {
            if (l1.virtual) return;
            a2.forEach(function(l2) {
                if (l2.virtual) return;
                const iss = l1.intersects(l2, curveIntersectionThreshold);
                if (iss.length > 0) {
                    iss.c1 = l1;
                    iss.c2 = l2;
                    iss.s1 = s1;
                    iss.s2 = s2;
                    intersections.push(iss);
                }
            });
        });
        return intersections;
    },
    makeshape: function(forward, back, curveIntersectionThreshold) {
        const bpl = back.points.length;
        const fpl = forward.points.length;
        const start = $662a4702b3c1b395$export$eab97d15b1788b8d.makeline(back.points[bpl - 1], forward.points[0]);
        const end = $662a4702b3c1b395$export$eab97d15b1788b8d.makeline(forward.points[fpl - 1], back.points[0]);
        const shape = {
            startcap: start,
            forward: forward,
            back: back,
            endcap: end,
            bbox: $662a4702b3c1b395$export$eab97d15b1788b8d.findbbox([
                start,
                forward,
                back,
                end
            ])
        };
        shape.intersections = function(s2) {
            return $662a4702b3c1b395$export$eab97d15b1788b8d.shapeintersections(shape, shape.bbox, s2, s2.bbox, curveIntersectionThreshold);
        };
        return shape;
    },
    getminmax: function(curve, d, list) {
        if (!list) return {
            min: 0,
            max: 0
        };
        let min = $662a4702b3c1b395$var$nMax, max = $662a4702b3c1b395$var$nMin, t, c;
        if (list.indexOf(0) === -1) list = [
            0
        ].concat(list);
        if (list.indexOf(1) === -1) list.push(1);
        for(let i = 0, len = list.length; i < len; i++){
            t = list[i];
            c = curve.get(t);
            if (c[d] < min) min = c[d];
            if (c[d] > max) max = c[d];
        }
        return {
            min: min,
            mid: (min + max) / 2,
            max: max,
            size: max - min
        };
    },
    align: function(points, line) {
        const tx = line.p1.x, ty = line.p1.y, a = -$662a4702b3c1b395$var$atan2(line.p2.y - ty, line.p2.x - tx), d = function(v) {
            return {
                x: (v.x - tx) * $662a4702b3c1b395$var$cos(a) - (v.y - ty) * $662a4702b3c1b395$var$sin(a),
                y: (v.x - tx) * $662a4702b3c1b395$var$sin(a) + (v.y - ty) * $662a4702b3c1b395$var$cos(a)
            };
        };
        return points.map(d);
    },
    roots: function(points, line) {
        line = line || {
            p1: {
                x: 0,
                y: 0
            },
            p2: {
                x: 1,
                y: 0
            }
        };
        const order = points.length - 1;
        const aligned = $662a4702b3c1b395$export$eab97d15b1788b8d.align(points, line);
        const reduce = function(t) {
            return 0 <= t && t <= 1;
        };
        if (order === 2) {
            const a = aligned[0].y, b = aligned[1].y, c = aligned[2].y, d = a - 2 * b + c;
            if (d !== 0) {
                const m1 = -$662a4702b3c1b395$var$sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                return [
                    v1,
                    v2
                ].filter(reduce);
            } else if (b !== c && d === 0) return [
                (2 * b - c) / (2 * b - 2 * c)
            ].filter(reduce);
            return [];
        }
        // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
        const pa = aligned[0].y, pb = aligned[1].y, pc = aligned[2].y, pd = aligned[3].y;
        let d = -pa + 3 * pb - 3 * pc + pd, a = 3 * pa - 6 * pb + 3 * pc, b = -3 * pa + 3 * pb, c = pa;
        if ($662a4702b3c1b395$export$eab97d15b1788b8d.approximately(d, 0)) {
            // this is not a cubic curve.
            if ($662a4702b3c1b395$export$eab97d15b1788b8d.approximately(a, 0)) {
                // in fact, this is not a quadratic curve either.
                if ($662a4702b3c1b395$export$eab97d15b1788b8d.approximately(b, 0)) // in fact in fact, there are no solutions.
                return [];
                // linear solution:
                return [
                    -c / b
                ].filter(reduce);
            }
            // quadratic solution:
            const q = $662a4702b3c1b395$var$sqrt(b * b - 4 * a * c), a2 = 2 * a;
            return [
                (q - b) / a2,
                (-b - q) / a2
            ].filter(reduce);
        }
        // at this point, we know we need a cubic solution:
        a /= d;
        b /= d;
        c /= d;
        const p = (3 * b - a * a) / 3, p3 = p / 3, q = (2 * a * a * a - 9 * a * b + 27 * c) / 27, q2 = q / 2, discriminant = q2 * q2 + p3 * p3 * p3;
        let u1, v1, x1, x2, x3;
        if (discriminant < 0) {
            const mp3 = -p / 3, mp33 = mp3 * mp3 * mp3, r = $662a4702b3c1b395$var$sqrt(mp33), t = -q / (2 * r), cosphi = t < -1 ? -1 : t > 1 ? 1 : t, phi = $662a4702b3c1b395$var$acos(cosphi), crtr = $662a4702b3c1b395$var$crt(r), t1 = 2 * crtr;
            x1 = t1 * $662a4702b3c1b395$var$cos(phi / 3) - a / 3;
            x2 = t1 * $662a4702b3c1b395$var$cos((phi + $662a4702b3c1b395$var$tau) / 3) - a / 3;
            x3 = t1 * $662a4702b3c1b395$var$cos((phi + 2 * $662a4702b3c1b395$var$tau) / 3) - a / 3;
            return [
                x1,
                x2,
                x3
            ].filter(reduce);
        } else if (discriminant === 0) {
            u1 = q2 < 0 ? $662a4702b3c1b395$var$crt(-q2) : -$662a4702b3c1b395$var$crt(q2);
            x1 = 2 * u1 - a / 3;
            x2 = -u1 - a / 3;
            return [
                x1,
                x2
            ].filter(reduce);
        } else {
            const sd = $662a4702b3c1b395$var$sqrt(discriminant);
            u1 = $662a4702b3c1b395$var$crt(-q2 + sd);
            v1 = $662a4702b3c1b395$var$crt(q2 + sd);
            return [
                u1 - v1 - a / 3
            ].filter(reduce);
        }
    },
    droots: function(p) {
        // quadratic roots are easy
        if (p.length === 3) {
            const a = p[0], b = p[1], c = p[2], d = a - 2 * b + c;
            if (d !== 0) {
                const m1 = -$662a4702b3c1b395$var$sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                return [
                    v1,
                    v2
                ];
            } else if (b !== c && d === 0) return [
                (2 * b - c) / (2 * (b - c))
            ];
            return [];
        }
        // linear roots are even easier
        if (p.length === 2) {
            const a = p[0], b = p[1];
            if (a !== b) return [
                a / (a - b)
            ];
            return [];
        }
        return [];
    },
    curvature: function(t, d1, d2, _3d, kOnly) {
        let num, dnm, adk, dk, k = 0, r = 0;
        //
        // We're using the following formula for curvature:
        //
        //              x'y" - y'x"
        //   k(t) = ------------------
        //           (x'² + y'²)^(3/2)
        //
        // from https://en.wikipedia.org/wiki/Radius_of_curvature#Definition
        //
        // With it corresponding 3D counterpart:
        //
        //          sqrt( (y'z" - y"z')² + (z'x" - z"x')² + (x'y" - x"y')²)
        //   k(t) = -------------------------------------------------------
        //                     (x'² + y'² + z'²)^(3/2)
        //
        const d = $662a4702b3c1b395$export$eab97d15b1788b8d.compute(t, d1);
        const dd = $662a4702b3c1b395$export$eab97d15b1788b8d.compute(t, d2);
        const qdsum = d.x * d.x + d.y * d.y;
        if (_3d) {
            num = $662a4702b3c1b395$var$sqrt($662a4702b3c1b395$var$pow(d.y * dd.z - dd.y * d.z, 2) + $662a4702b3c1b395$var$pow(d.z * dd.x - dd.z * d.x, 2) + $662a4702b3c1b395$var$pow(d.x * dd.y - dd.x * d.y, 2));
            dnm = $662a4702b3c1b395$var$pow(qdsum + d.z * d.z, 1.5);
        } else {
            num = d.x * dd.y - d.y * dd.x;
            dnm = $662a4702b3c1b395$var$pow(qdsum, 1.5);
        }
        if (num === 0 || dnm === 0) return {
            k: 0,
            r: 0
        };
        k = num / dnm;
        r = dnm / num;
        // We're also computing the derivative of kappa, because
        // there is value in knowing the rate of change for the
        // curvature along the curve. And we're just going to
        // ballpark it based on an epsilon.
        if (!kOnly) {
            // compute k'(t) based on the interval before, and after it,
            // to at least try to not introduce forward/backward pass bias.
            const pk = $662a4702b3c1b395$export$eab97d15b1788b8d.curvature(t - 0.001, d1, d2, _3d, true).k;
            const nk = $662a4702b3c1b395$export$eab97d15b1788b8d.curvature(t + 0.001, d1, d2, _3d, true).k;
            dk = (nk - k + (k - pk)) / 2;
            adk = ($662a4702b3c1b395$var$abs(nk - k) + $662a4702b3c1b395$var$abs(k - pk)) / 2;
        }
        return {
            k: k,
            r: r,
            dk: dk,
            adk: adk
        };
    },
    inflections: function(points) {
        if (points.length < 4) return [];
        // FIXME: TODO: add in inflection abstraction for quartic+ curves?
        const p = $662a4702b3c1b395$export$eab97d15b1788b8d.align(points, {
            p1: points[0],
            p2: points.slice(-1)[0]
        }), a = p[2].x * p[1].y, b = p[3].x * p[1].y, c = p[1].x * p[2].y, d = p[3].x * p[2].y, v1 = 18 * (-3 * a + 2 * b + 3 * c - d), v2 = 18 * (3 * a - b - 3 * c), v3 = 18 * (c - a);
        if ($662a4702b3c1b395$export$eab97d15b1788b8d.approximately(v1, 0)) {
            if (!$662a4702b3c1b395$export$eab97d15b1788b8d.approximately(v2, 0)) {
                let t = -v3 / v2;
                if (0 <= t && t <= 1) return [
                    t
                ];
            }
            return [];
        }
        const d2 = 2 * v1;
        if ($662a4702b3c1b395$export$eab97d15b1788b8d.approximately(d2, 0)) return [];
        const trm = v2 * v2 - 4 * v1 * v3;
        if (trm < 0) return [];
        const sq = Math.sqrt(trm);
        return [
            (sq - v2) / d2,
            -(v2 + sq) / d2
        ].filter(function(r) {
            return 0 <= r && r <= 1;
        });
    },
    bboxoverlap: function(b1, b2) {
        const dims = [
            "x",
            "y"
        ], len = dims.length;
        for(let i = 0, dim, l, t, d; i < len; i++){
            dim = dims[i];
            l = b1[dim].mid;
            t = b2[dim].mid;
            d = (b1[dim].size + b2[dim].size) / 2;
            if ($662a4702b3c1b395$var$abs(l - t) >= d) return false;
        }
        return true;
    },
    expandbox: function(bbox, _bbox) {
        if (_bbox.x.min < bbox.x.min) bbox.x.min = _bbox.x.min;
        if (_bbox.y.min < bbox.y.min) bbox.y.min = _bbox.y.min;
        if (_bbox.z && _bbox.z.min < bbox.z.min) bbox.z.min = _bbox.z.min;
        if (_bbox.x.max > bbox.x.max) bbox.x.max = _bbox.x.max;
        if (_bbox.y.max > bbox.y.max) bbox.y.max = _bbox.y.max;
        if (_bbox.z && _bbox.z.max > bbox.z.max) bbox.z.max = _bbox.z.max;
        bbox.x.mid = (bbox.x.min + bbox.x.max) / 2;
        bbox.y.mid = (bbox.y.min + bbox.y.max) / 2;
        if (bbox.z) bbox.z.mid = (bbox.z.min + bbox.z.max) / 2;
        bbox.x.size = bbox.x.max - bbox.x.min;
        bbox.y.size = bbox.y.max - bbox.y.min;
        if (bbox.z) bbox.z.size = bbox.z.max - bbox.z.min;
    },
    pairiteration: function(c1, c2, curveIntersectionThreshold) {
        const c1b = c1.bbox(), c2b = c2.bbox(), r = 100000, threshold = curveIntersectionThreshold || 0.5;
        if (c1b.x.size + c1b.y.size < threshold && c2b.x.size + c2b.y.size < threshold) return [
            (r * (c1._t1 + c1._t2) / 2 | 0) / r + "/" + (r * (c2._t1 + c2._t2) / 2 | 0) / r
        ];
        let cc1 = c1.split(0.5), cc2 = c2.split(0.5), pairs = [
            {
                left: cc1.left,
                right: cc2.left
            },
            {
                left: cc1.left,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.left
            }
        ];
        pairs = pairs.filter(function(pair) {
            return $662a4702b3c1b395$export$eab97d15b1788b8d.bboxoverlap(pair.left.bbox(), pair.right.bbox());
        });
        let results = [];
        if (pairs.length === 0) return results;
        pairs.forEach(function(pair) {
            results = results.concat($662a4702b3c1b395$export$eab97d15b1788b8d.pairiteration(pair.left, pair.right, threshold));
        });
        results = results.filter(function(v, i) {
            return results.indexOf(v) === i;
        });
        return results;
    },
    getccenter: function(p1, p2, p3) {
        const dx1 = p2.x - p1.x, dy1 = p2.y - p1.y, dx2 = p3.x - p2.x, dy2 = p3.y - p2.y, dx1p = dx1 * $662a4702b3c1b395$var$cos($662a4702b3c1b395$var$quart) - dy1 * $662a4702b3c1b395$var$sin($662a4702b3c1b395$var$quart), dy1p = dx1 * $662a4702b3c1b395$var$sin($662a4702b3c1b395$var$quart) + dy1 * $662a4702b3c1b395$var$cos($662a4702b3c1b395$var$quart), dx2p = dx2 * $662a4702b3c1b395$var$cos($662a4702b3c1b395$var$quart) - dy2 * $662a4702b3c1b395$var$sin($662a4702b3c1b395$var$quart), dy2p = dx2 * $662a4702b3c1b395$var$sin($662a4702b3c1b395$var$quart) + dy2 * $662a4702b3c1b395$var$cos($662a4702b3c1b395$var$quart), // chord midpoints
        mx1 = (p1.x + p2.x) / 2, my1 = (p1.y + p2.y) / 2, mx2 = (p2.x + p3.x) / 2, my2 = (p2.y + p3.y) / 2, // midpoint offsets
        mx1n = mx1 + dx1p, my1n = my1 + dy1p, mx2n = mx2 + dx2p, my2n = my2 + dy2p, // intersection of these lines:
        arc = $662a4702b3c1b395$export$eab97d15b1788b8d.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n), r = $662a4702b3c1b395$export$eab97d15b1788b8d.dist(arc, p1);
        // arc start/end values, over mid point:
        let s = $662a4702b3c1b395$var$atan2(p1.y - arc.y, p1.x - arc.x), m = $662a4702b3c1b395$var$atan2(p2.y - arc.y, p2.x - arc.x), e = $662a4702b3c1b395$var$atan2(p3.y - arc.y, p3.x - arc.x), _;
        // determine arc direction (cw/ccw correction)
        if (s < e) {
            // if s<m<e, arc(s, e)
            // if m<s<e, arc(e, s + tau)
            // if s<e<m, arc(e, s + tau)
            if (s > m || m > e) s += $662a4702b3c1b395$var$tau;
            if (s > e) {
                _ = e;
                e = s;
                s = _;
            }
        } else // if e<m<s, arc(e, s)
        // if m<e<s, arc(s, e + tau)
        // if e<s<m, arc(s, e + tau)
        if (e < m && m < s) {
            _ = e;
            e = s;
            s = _;
        } else e += $662a4702b3c1b395$var$tau;
        // assign and done.
        arc.s = s;
        arc.e = e;
        arc.r = r;
        return arc;
    },
    numberSort: function(a, b) {
        return a - b;
    }
};

});

parcelRegister("9TA3v", function(module, exports) {

$parcel$export(module.exports, "PolyBezier", () => $01dbf484305a3c69$export$86641174d8fa723d);

var $8LP0m = parcelRequire("8LP0m");
/**
 * Poly Bezier
 * @param {[type]} curves [description]
 */ class $01dbf484305a3c69$export$86641174d8fa723d {
    constructor(curves){
        this.curves = [];
        this._3d = false;
        if (!!curves) {
            this.curves = curves;
            this._3d = this.curves[0]._3d;
        }
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return "[" + this.curves.map(function(curve) {
            return (0, $8LP0m.utils).pointsToString(curve.points);
        }).join(", ") + "]";
    }
    addCurve(curve) {
        this.curves.push(curve);
        this._3d = this._3d || curve._3d;
    }
    length() {
        return this.curves.map(function(v) {
            return v.length();
        }).reduce(function(a, b) {
            return a + b;
        });
    }
    curve(idx) {
        return this.curves[idx];
    }
    bbox() {
        const c = this.curves;
        var bbox = c[0].bbox();
        for(var i = 1; i < c.length; i++)(0, $8LP0m.utils).expandbox(bbox, c[i].bbox());
        return bbox;
    }
    offset(d) {
        const offset = [];
        this.curves.forEach(function(v) {
            offset.push(...v.offset(d));
        });
        return new $01dbf484305a3c69$export$86641174d8fa723d(offset);
    }
}

});



parcelRegister("8Jl6x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
var $65b2e5965f161194$var$_default = module.exports["default"] = {
    1: {
        grass: 'M124.6,220.3c-10.9,0-17.2-7.8-21.2-14.3c-4.5-7.2-18.3-28.9-21.4-33.3l-13.2-19.8L36.7,111    l-2.9-6.8l-0.7-3.3L33,98.2l0.3-2.4l0.6-2.1l0.9-1.9L36,90l1.2-1.6l3.4-3.6l23.1-24.5l1-0.8l67.2-17.7h0.6l74.7,40.9l1.6,0.9    l4.8,4.8l1.1,1.5l1.1,1.9l0.8,1.9l0.5,2.1l0.3,2.6v2.7l-0.5,2.5l-32.7,43l-34.3,51.8C149.9,198.6,137.4,220.3,124.6,220.3    L124.6,220.3z',
        outfield: 'M125,226.5c-13.8,0-17.8-7.4-24.6-15.6c-8.3-10.1-35.3-53.3-39.2-58.3    c-4.4-5.6-8.8-11.2-13.3-16.7c-3.8-4.8-7.6-9.5-11.3-14.2c-1.9-2.4-6-7.5-6-7.6l-2.4-8.1l-0.9-4.4l-0.1-3.7l0.4-3.3l0.8-2.9    l1.2-2.6l1.4-2.4l1.6-2.2l1.8-1.9l1.8-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l2-2.1l2-2.1l2-2.1l2-2.1l2.1-2.2l2.1-2.2l2.3-1.8    l2.8-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L81,49l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L100,44l2.7-0.7l2.8-0.7    l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.9-0.8l2.9-0.8l2.9-0.8l2.9-0.8h2.9l2.8,1.5l2.8,1.5l2.7,1.5l2.7,1.5l2.7,1.5l2.6,1.4    l2.6,1.4l2.6,1.4L158,49l2.5,1.4l2.5,1.4l2.5,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.3,1.3l2.3,1.3l2.3,1.3    l2.3,1.3l2.3,1.3l2.3,1.3L196,70l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3L214,81l1.9,1.9l1.9,1.9l1.6,2.2    l1.4,2.4L222,92l0.8,3l0.3,3.4v3.7l-0.9,4.4l-0.4,0.4l-35.3,49.9c0,0-37.4,55.7-43.8,61.1C137.8,222.1,131.8,226.5,125,226.5    L125,226.5z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    2: {
        grass: 'M175.2,58.2l-61.9-17.2-29.6,20-19,12.1-7-.6-1.6.9-25.1,17.4,4.2,13.8-1.3,3.3s47.1,68,70.5,97.3c6.2,8.8,12.9,15.5,20.3,15.5s15.1-8.3,18.6-13.4c2.6-3.7,11.8-11.9,21.7-26.5,19.7-28.9,46.1-70.4,46.1-70.4l-35.8-52.3h-.1Z',
        outfield: 'M27.2,105.1l-.5-4-1.8-5.6-2-6,1-3,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.6-.8,3.8,1.9,2.6-.6,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.3-1.6,2.3-1.6,2.3-1.6,2.4-1.6,2.4-1.6,2.4-1.7,2.5-1.7,2.5-1.7,2.5-1.7,2.6-1.7,2.6-1.8,2.6-1.8,2.7-1.8,2.7-1.9,2.8-1.9,3-.2,3,.8,3,.8,3,.8,2.9.8,2.9.8,2.9.8,2.8.8,2.8.8,2.8.7,2.8.8,2.8.7,2.7.7,2.7.8,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.4,1.6,2,2.7,1.9,2.7,1.8,2.7,1.7,2.6,1.7,2.6,1.7,2.5,1.7,2.5,1.7,2.4,1.6,2.4,1.6,2.3,1.6,2.2,1.5,2.2,1.5,2.2,1.5,2.2,1.5,2.1,1.5,2.1,1.5,2.1,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.3,2,1.3,2,3.3,11.6c-1.3,2-9.2-.5-10.9,2-17.6,25.7-53.7,77.2-64.4,88.6-13.8,14.9-27.2,23.4-46-3.1-7-9.9-19.1-26.8-31.5-43.6l-2.2.9c-20.3-27.6-40.3-58.2-40.3-58.2l.5-2.6v.2Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    3: {
        grass: 'M80.2,171.3L75.9,144l-30.5-31.5l56.6-54l40.4-11.4l69.7,33.5l1.6,0.9l1.1,0.9l0.9,1l0.6,1.1    l0.4,1.3l0.1,1.6l-0.9,3.6l-7,14.2l-2.7,5.5L179.5,144l-15.7,33.5c0,0-29.2,35.1-30.4,36.6c-2.3,3-12,3.4-15,0.2    S80.2,171.3,80.2,171.3L80.2,171.3z',
        outfield: 'M72.1,173.9l-3.7-26.2l-34.2-35.4l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6    l1.6-1.6l1.6-1.6l1.6-1.6l1.7-1.6l1.7-1.6l1.7-1.6L57,90l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.7l1.8-1.7l1.8-1.7l1.8-1.8l1.8-1.8    l1.9-1.8l1.9-1.8l1.9-1.9l1.9-1.9l2-1.9l2-2l2.1-2l2.1-2l2.1-2.1l2.2-2.1l2.2-2.2l2.3-2.2L98,50l2.4-2.3l2.5-1.9h2.8l2.8-0.2    l2.7-0.7l2.7-0.7l2.7-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.9-0.8l2.9-0.8l2.9-0.8l3-0.8l3-0.8l3-0.8l3.1-0.8l3.1-0.8l3.2-0.8    l3.2-0.8l2.2,4l1.6,6.1l1.5,5.7l2.5,1.6l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2    l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.5,1.2l2.4,1.3l2.2,1.7l1.9,2.1l1.5,2.6l1,3.1    l0.2,3.9l-1.4,5.6l-3.9,7.9l-3.5,7.1l-3.1,6.3l-23.7,27l-18.1,36.1c0,0-30.6,37.8-33.4,41.6c-2.8,3.8-20.4,3.9-23.9,0.3    C110.4,216.6,72.1,173.9,72.1,173.9z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    4: {
        grass: 'M110.1,208.5l-32.5-38l-31.8-54.4c0,0-4.7-5.8-5.5-7.4c-0.9-1.6-0.8-3.4-0.8-3.4    s-0.4-0.9,1.4-4c2-3.4,5.4-8.4,11.1-14.1c10.9-10.9,27.2-26,27.2-26l1.8-1.4l2.2-1.5l2-1.3c0,0,21.4-13.4,41-13.4    c11.4,0,22.1,3.1,33.6,7.9c11.5,4.7,30.7,28.4,30.7,28.4l20.4,22.7l1.2,3.5l-0.7,3.9l-1.6,2.7l-21.3,36l-16,24.3l-32.7,35.1    c-2.4,2.5-8.5,8.7-15.7,8.7S112,210.8,110.1,208.5L110.1,208.5z',
        outfield: 'M27.4,107.2l1-0.6l1.4-2l1.4-2l1.4-2l1.4-2l1.4-2.1l1.5-2.1l1.5-2.1l1.5-2.1l1.5-2.1    l1.5-2.2l1.5-2.2l1.7-2.1l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.8l1.9-1.9l2-1.9l2-1.9l2-1.9l2-2l2.1-2l2.1-2l2.1-2l2.2-2    l2.3-1.7l2.4-1.6l2.4-1.6l2.5-1.4l2.5-1.4l2.6-1.4l2.6-1.1l2.7-1l2.7-1l2.7-1l2.7-1.3l2.7-1.6l2.7-1.6l2.9-0.5h29l2.9,0.4l2.7,1.6    l2.7,1.6l2.7,1.2l2.7,1l2.7,1l2.7,1l2.7,1l2.5,1.5l2.5,1.5l2.5,1.4l2.5,1.4l2.5,1.4l2.4,1.5l2.2,1.9l2.2,1.8l2.2,1.8l2,2.2l2,2.1    l2,2.1l1.9,2.1l1.9,2l1.9,2l1.9,2l1.8,2l1.8,2l1.8,2l1.7,2l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.7,1.9l1.6,1.8    l1.6,1.8l1.6,1.8l1.6,1.8l1.6,1.8l1,1.9l-9.7,10.3L177.4,176L150,208.2c0,0-13.4,14.3-24.6,14.6c-16.3,0-26.9-16.4-26.9-16.4    l-24.9-29.3L68,166.3l-29.3-48.4L27.4,107.2L27.4,107.2z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    5: {
        grass: 'M126.7,218c-10.4,0-17.5-7.7-17.5-7.7l-49.4-75.1l-22-26.4l11.8-22.6l0.4-0.5l65.7-43.9    l68.2,25.6l0.3,0.3l28,43.5l-11.8,11.2c-20,29.5-57.5,86.1-57.5,86.1C142.5,209,136.5,218,126.7,218z',
        outfield: 'M204.2,129.3c0,0-13.1,16.3-28.1,38.7s-28.8,44.3-29.7,45.3c0,0-7.9,10.9-20.1,10.9    s-21.1-10.4-21.1-10.4l-50.3-76.1l-26.6-27.6l1.3-2.5l1.1-2.2l1.2-2.2l1.2-2.3l1.2-2.3l1.2-2.3l1.2-2.4l1.2-2.4l1.3-2.4l1.3-2.5    l1.3-2.5l1.3-2.6l1.8-2l2.1-1.4l2.1-1.4l2.1-1.4l2.2-1.4l2.2-1.4l2.2-1.4l2.2-1.5l2-1.6l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.3-1.5    l2.3-1.5l2.3-1.5L80,56l2.3-1.6l2.4-1.6l2.4-1.6l2.4-1.6L92,48l2.5-1.7l2.5-1.7l2.6-1.7l2.6-1.7l2.7-1.8l2.7-1.8l2.8-1.8l2.8-1.9    l2.9-0.5l3,1.1l3,1.1l2.9,1.1l2.9,1.1l2.9,1.1l2.8,1.1l2.8,1l2.8,1l2.7,1l2.7,1l2.7,1l2.7,1l2.6,1l2.6,1l2.6,1l2.6,1l2.6,1l2.6,1    l2.6,1l2.6,1l2.6,1l2.5,1l2.5,1l2.5,1l2.5,1l2.5,1l2.6,1l2,2.2l1.7,2.6l1.7,2.5l1.7,2.5l1.6,2.4l1.6,2.4l1.6,2.4l1.6,2.3l1.5,2.3    l1.5,2.3l1.5,2.2l1.5,2.2l1.5,2.2l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.3,2.1l1.3,2l1.3,2l1.9,3L204.2,129.3L204.2,129.3z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    7: {
        grass: 'M214.5,100.6l.2-2.3-.12-.81-22.56-24.29-1.62-1.32-17.76-13.55-14.54-10.17-1.9-1.31-5.09-1.96-2.6-.9-2.3-.7-5.4-1.2-2.5-.6-8.1-1-2.5-.1-5.7-.1-2.6.1-1.48.11-1.4.13-2.32.36-5.7.9-2.4.5-5.2,1.5-2.5.8-2.4.89-15.8,11.32-19.84,15.24-1.53,1.37-22.7,25.53,1.1,7.51v.02l23.37,41.22,13.4,18.8s25.9,39.8,30.9,43.6c3.8,2.9,11.4,6.4,21.2,6.4s17-5.5,19.6-7.9,12.3-15.9,12.3-15.9l18.4-28.7,12.8-15.7s5-8,9.7-15.3c4.3-6.8,9.7-15.2,12.7-22.6l1.8-5.9,1.1-4h-.01Z',
        outfield: 'M29.48,107.32l-1.75-5.21-.27-3.88,1.26-2.34,1.67-1.91,1.68-1.92,1.69-1.93,1.7-1.94,1.71-1.95,1.73-1.97,1.74-1.98,1.75-2,1.77-2.02,1.79-2.04,1.81-2.06,1.83-2.08,1.85-2.11,1.91-2.07,2.1-1.77,2.13-1.75,2.15-1.76,2.2-1.72,2.23-1.69,2.25-1.71,2.31-1.64,2.35-1.58,2.37-1.6,2.39-1.62,2.42-1.63,2.44-1.65,2.47-1.67,2.5-1.69,2.53-1.71,2.57-1.73,2.6-1.76,2.64-1.78,2.78-1.19,2.85-.86,2.89-.72,2.91-.59,2.93-.56,2.95-.44,2.96-.32,2.97-.21,2.98-.13,2.98-.1,2.98.04,2.98.09,2.97.23,2.95.43,2.94.47,2.92.57,2.92.57,2.89.68,2.85.9,2.8,1.1,2.64,1.8,2.6,1.78,2.56,1.75,2.53,1.73,2.5,1.71,2.47,1.68,2.44,1.66,2.41,1.65,2.39,1.63,2.36,1.61,2.34,1.6,2.32,1.59,2.3,1.57,2.26,1.63,2.18,1.75,2.15,1.77,2.1,1.81,2.08,1.79,1.95,1.99,1.86,2.09,1.84,2.07,1.82,2.04,1.8,2.02,1.78,2,1.77,1.99,1.75,1.97,1.74,1.95,1.73,1.94,1.72,1.93,1.71,1.92,1.7,1.91,1.69,1.9,1.24,2.36-.24,3.85-1.68,5.15-.48.52-.7,5.86c-5.8,14.5-30.4,52.6-39,57.8-8.6,5.1-26.7,40.6-26.7,40.6,0,0-11.5,12.8-29.2,12.8h0c-17.7,0-27.7-12.3-27.7-12.3,0,0-22.4-34.5-29.1-39.3-11.5-8.2-39.2-64.6-39.2-64.6l.36-1.1Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    10: {
        grass: 'M107.4,209.7l-6.9-3.1c-1.7-0.5-38.6-13.8-51.1-67.3l4.9-4l-19.8-23.8l13.9-31.6l1.1-0.5    l19.9-8.3l3-1.7L96,53.3l2-1.2l14.6-7.1l1.1-0.1l22.5-0.1l1.1,0.1l14.6,7.1l2,1.2l23.8,16.3l3.1,1.6l21.7,8.7l13.3,31.9L201,132.2    c4.2,26.3-16.3,51.1-33.7,64.9c-13.1,10.3-24,13.2-24,13.2l-2.7,5.9c0,0-8.3,2.1-15.1,2.1s-12.9-1.9-12.9-1.9L107.4,209.7    L107.4,209.7z',
        outfield: 'M141.9,222.2c0,0-9.7,2.1-16.4,2.1s-16.4-1.9-16.4-1.9L102,215c0,0-56-19.7-60.2-82.7    l-16.1-20.7l2.3-5.5l1-2.4l1.1-2.4l1.1-2.4l1.1-2.5l1.1-2.5l1.1-2.6l1.1-2.6l1.2-2.7l1.2-2.7l1.2-2.8l1.2-2.8l1.3-2.9l2-1.8    l2.4-1.1l2.5-1l2.5-1l2.5-1l2.5-1l2.4-1l2.4-1l2.4-1l2.4-1l2.3-1.3l2.2-1.5l2.3-1.5L75,58l2.3-1.6l2.3-1.6l2.4-1.6l2.4-1.6    l2.4-1.6l2.4-1.7l2.5-1.7l2.6-1.5l2.6-1.3l2.7-1.3l2.7-1.3l2.7-1.3l2.7-1.3l2.8-1.3l2.9-0.3h23.2l2.9,0.3l2.8,1.4L145,40l2.7,1.3    l2.7,1.3l2.7,1.3l2.6,1.3l2.5,1.5l2.5,1.7l2.4,1.7l2.4,1.7l2.4,1.6l2.4,1.6l2.3,1.6L175,58l2.3,1.6l2.3,1.5l2.2,1.5l2.4,1.2l2.4,1    l2.4,1l2.4,1l2.5,1l2.5,1l2.5,1l2.5,1l2.5,1l2.4,1.1l2,1.9l1.3,2.9l1.2,2.8l1.2,2.8l1.2,2.7l1.2,2.7l1.1,2.6l1.1,2.6l1.1,2.5    l1.1,2.5l1.1,2.4l1.1,2.4l1.1,2.3l2.5,5l-15.9,22c-4.1,62.9-61.3,81.9-61.3,81.9L141.9,222.2L141.9,222.2z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    12: {
        grass: 'M107.1,207.7l-5.1,0.1l-19.8-20l0.6-8.7l-24.2-21.9l-9-15.8l2-3.8l-3.8-4.5    c0,0-1.3,0.4-1.9-0.1l-5.2-23.3l-0.9-4.6l-0.8-4l-0.1-1.1l58.3-58.8l53.3,3.4l1.9,0.3l6,2l1.1,1.1l51.1,52l-2.5,20.2l0.5,9    l-2.4,5.8l-7.2,7.1l-7.5,12.5l-24.6,24.5l-0.1,8.5l-21.4,21.1l-2.3-2.1c0,0-11.3,11.4-14.5,11.4s-0.4,0.2-6.2,0.2    S107.1,207.7,107.1,207.7z',
        outfield: 'M219.2,109l-8,13.3l1.8,2.7l-0.7,6.7l-2.7,6l-6.5,6.5l-9.6,15.9l-21.1,21.5l-0.1,7.5    L150.7,210l-2.4,2.2l-4.4-0.3c0,0-9.4,8.5-12.4,9.4s-5.2,1.9-11.7,0.3s-14.6-9.8-14.6-9.8h-4.8l-22.8-22.1l0.2-8l-22.6-22.1    l-9-15.2l-8.2-9.1L32.8,111l-0.9-4.2l-0.9-4.3l-0.5-4.1l1.1-2.4l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8    l1.8-1.8l1.8-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-2l2-2l2-2l2-2l2-2.1l2.1-2.1l2.1-2.1l2.1-2.2l2.2-2.2l2.2-2.2l2.3-2.3    l2.3-2.3l2.5-1.7l2.8-0.7l2.4-2.6l2.1-4.3l2.6-2.3l3.1,0.2l3.1,0.2l3,0.2l3,0.2l3,0.2l3,0.2l3,0.2l3,0.2l2.9,0.2l2.9,0.2l2.9,0.2    l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.2l2.9,0.5l2.8,0.9l2.8,0.9l2.8,0.9l2.4,2.4L167,45l2.3,2.3    l2.3,2.3l2.2,2.2L176,54l2.1,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l1.9,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8    l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l-0.5,4.2l-0.5,4.1L219.2,109L219.2,109z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    13: {
        grass: 'M36.58,109.13v-13.23l38.7-48.66,18.44-10.35,58.89-.3,15.33,12.8h6.5l43.75,47.41-2.95,12.94-16.32,17.51-.72,2.41s-54.61,77.46-60.14,84.67-13.71,14.43-21.41,4.09-66.65-86.59-66.65-86.59v-4.57s-13.42-18.13-13.42-18.13Z',
        outfield: 'M27.36,108.91l.06-14,43.76-52.67,19.38-10.79,67.28-.3,16,13.56h8.52l43.12,47.64-1.48,16.91-16.59,16.92-1.58,2.32s-57.18,84.47-63.13,92c-8.74,11-21.62,12.66-32.25.48-11.45-13.26-59.11-75.56-66.81-87.1l.72-3.37s-17-21.6-17-21.6Z',
        infield: 'M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53,0,4.51,3.66,8.17,8.18,8.16,4.51,0,8.16-3.66,8.16-8.16,0-1.41-.38-2.79-1.1-4l32.13-30.95ZM120.75,195.16l-17.67-17.71c1.14-1.37,3.31-3.3,3.31-5.2,0-.92-.17-1.83-.49-2.69l14.58-14.19c1.34.94,2.9,1,4.68,1s3.36,0,4.67-.83l14.54,14.16c-.3.83-.46,1.71-.46,2.6,0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66h-8.59Z',
        hasTransform: false
    },
    14: {
        grass: 'M190.9,144.1c-2.6,4.8-13.4,22.5-16,25.8    c-2.7,3.3-16,19.3-19,23.1s-11,14.3-14.3,16.9c-3.3,2.6-9.6,6.4-11.9,6.4c-2.3,0-6.6,0-9.3,0c-2.7,0-11.5-5.1-14.6-7.4    c-3.2-2.3-6.6-5.2-9.3-8.7c-2.7-3.6-9-13.2-12.4-17.3S73.7,169,70.4,164.2c-3.3-4.8-11.5-20.6-13-23.9c-1.5-3.4-6.8-14.8-7.6-16.5    s-3.7-6.2-3.7-6.2s-0.9-1.8-1.9-3.1c-1-1.3-6.1-6.8-6.1-6.8s5.2-4.7,7.6-7.3s10.2-12.7,11.9-14.9S64,73.1,66.4,71    c2.4-2.2,12.1-11.7,15.4-13.5s12.1-5.6,16.3-7.2c4.2-1.6,17.3-7.1,19.8-7.1s10.8,0,14.9,0c4.1,0,29.2,12.9,32.4,15.3    s7.8,7,10.1,9.9s12.3,12.3,15,14.5s6.9,4.2,8.9,5.9c2,1.7,13.7,18.7,13.7,18.7l-9.2,9.4l-1.9,2.7    C201.9,119.4,197.6,131.9,190.9,144.1z',
        outfield: 'M28.6,106.5l1.7-1.6l1.6-1.7l1.7-1.7    l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.6-1.9l1.6-1.9l1.6-2l1.6-2l1.6-2l1.7-2l1.4-2.4L53,78l1.5-2.5L56,73l1.6-2.6l1.8-2.2l2-1.9    l2-2l2-2l2-2l2.1-2l2.1-2l2.2-2.1l2.2-2.1l2.5-1.2l2.6-1.1l2.6-1l2.6-1l2.6-1.1l2.6-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1    l2.8-1l2.8-1l2.8-0.7l2.9-0.4l2.9-0.4l2.9-0.2h2.9h2.9l2.9,0.2l2.9,0.4l2.9,0.4l2.8,0.8l2.8,0.9l2.8,1l2.7,1.2l2.7,1.3l2.7,1.3    l2.6,1.3l2.6,1.2l2.6,1.2l2.6,1.2L166,50l2.5,1.2l2.4,1.6l2.2,2.2l2.1,2.2l2.1,2.2l2,2.1l2,2.1l2,2l2,2l1.9,2l2,1.8l2,1.7l2,1.7    l2,1.7l2,1.5l2.1,1.3l2.2,1.3l2.1,1.3l2.1,1.3l1.5,2.2l1.5,2.2l1.5,2.1l1.5,2.1l1.5,2.1l1.5,2l1.5,2.1l1.4,2l1.4,2l1.4,2l1.4,2    l0.5,0.8c0,0-7.3,7.6-8.9,9.1c-1.6,1.5-3,2.3-4.8,5.2c-1.9,2.9-3,5.7-4.3,8.3s-4.8,10.4-6.2,13.7s-3.9,8.3-5.2,10.4    c-1.3,2.1-5.6,9.2-7.5,12.3s-9.2,13.6-11.6,16.5c-2.4,3-8.9,11.2-8.9,11.2s-2.6,3.4-3.5,4.9l-4.3,5.7l0.5,0.9c0,0-7,6.5-8.2,7.5    c-1.1,0.9-4.2,3.3-4.2,3.3l-0.8-0.8c-4.2,2.7-7.2,4.8-10,5.4s-2.3,0.8-4.2,0.8s-9.6,0-11.6,0s-8.9-3.4-10.1-4.1l-1,0.7    c0,0-7.2-5.7-9-7.4s-6.2-5.1-6.2-5.1l0.5-0.8c0,0-2.7-4.1-3.6-5.4s-3.1-4.4-3.1-4.4s-0.7-0.8-2.1-2.3s-7.2-9.4-9.7-12.4    c-2.4-3-3.8-5.4-6.4-9.2s-5.3-8.7-7.3-12.2s-5.3-9.4-7.2-13.1c-1.9-3.7-3.9-8.6-4.8-11.2c-0.9-2.6-4.2-8.9-4.9-10.2    c-0.7-1.3-1.8-3.4-3.2-5.1c-1.4-1.6-12.1-12.8-12.1-12.8L28.6,106.5z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    15: {
        grass: 'M125.7,220.2c-3.1,0-6.3-1.6-7.4-2.2c-3.8-2.9-23.2-24.2-40.5-42.8l-22.9-41.9L36,114.4v-11.8    l0.8-8l4.3-3.6l53.4-48l4.3-1.1h51.6l4.8,1.1l0.2,0.1l59.2,53.1v16.5l-17.2,18.4l-22.9,39.4c-16.6,18.5-38.8,44.7-42.8,47.7    C131.7,218.3,129.3,220.2,125.7,220.2z',
        outfield: 'M223.2,105l-0.5,1.8l-1.4,2.2v7.4h-0.8L202.7,135l-22.8,39.3c0,0-41.1,45.9-45.7,48.1    c-1.6,1-3,2.9-8.8,2.9c-5.1,0-8-1.9-9.9-2.9c-4.2-2.1-43.2-47-43.2-47l-23.8-40.3L30,115.7h-2l-0.1-9.6V95.3l-0.1-3.9l-0.1-4.1    l2.9-0.7h3.3l2-1.6l1.9-1.7l1.9-1.7l1.9-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2.1-1.9l2.1-1.9l2.1-1.9l2.1-1.9l2.2-1.9    l2.2-2l2.2-2l2.2-2l2.3-2l2.3-2.1l2.3-2.1l2.4-2.2l2.4-2.2l2.5-2.2l2.5-2.3l2.7-1.7l2.9-0.6l3-0.5h21l3,0.8h5.8l3-0.8h21l2.8,1.1    h3l2.7,1.9l2.5,2.3l2.5,2.2l2.4,2.2l2.4,2.1l2.3,2.1l2.3,2.1l2.3,2l2.2,2l2.2,2l2.2,2l2.2,1.9l2.2,1.7l2.1,1.9l2.1,1.9l2.1,1.9    l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l1.9,1.8l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7l3.1,0.3l2.1,1.5v11.3L223.2,105L223.2,105z',
        infield: 'M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7    s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.3,0,0.5,0,0.8l-12.6,2.5l7.2,8l6.7-7.4c1.2,1.7,3.2,2.8,5.4,2.8    s4.2-1.1,5.4-2.8l6.7,7.4l7.2-8l-12.6-2.5C131.9,202.9,131.9,202.7,131.9,202.4z M125.2,195.7c-1.6,0-3.2,0.6-4.3,1.6l-17.7-17.7    l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5    l-17.7,17.7C128.4,196.3,126.8,195.7,125.2,195.7z',
        hasTransform: false
    },
    16: {
        grass: 'M225.3,118.4l-5.8-13.5l-23.8-47l-18.3-12.2c0,0-34.3-10.8-44.3-10.5c-57.5,1.9-91.1,43.4-91.1,43.4\n\t\tl-13.5,24.7L28,118.2l12.2,10.3l26,45.3c0,0,19,22.2,23.5,27.3c4.5,5.1,15.6,17.5,19.2,21c3.5,3.5,8.6,6.9,15.1,7.2\n\t\tc6.4,0.3,15.6-7.4,25.2-18.6c9.6-11.2,31.2-32.5,31.2-32.5l19.6-32.8L225.3,118.4z',
        outfield: 'M231.6,116.3l-6.6-11.2l-23.7-48.5l-21.1-14.8c0,0-39.8-11.1-50-10.8c-59,1.9-96.8,47.1-96.8,47.1l-11.5,22.1\n\t\tl-3.3,15.2l18.8,15.5L64,177.3c0,0,19.5,22.7,24.1,28c4.6,5.3,16.1,17.9,19.7,21.5c3.6,3.6,8.9,7.1,15.5,7.4\n\t\tc6.6,0.3,16-7.5,25.9-19.1c9.9-11.5,32-33.3,32-33.3l20.1-33.6L231.6,116.3z',
        infield: 'M164.3,168.5c0,0-12-31-38.8-30.8c-27.3,0.2-39.4,30.1-39.4,30.1l32.5,31.2c-1.2,1.1-1.6,3.3-1.6,4.5    c0,4.4,3.7,8,8.2,8c4.5,0,8.2-3.6,8.2-8c0-1.4-0.4-2.8-1.1-4L164.3,168.5z M125.1,195.5c-1.2,0-2.3,0.2-3.3,0.7l-18.3-17.9    c1.1-1.4,1.8-3.1,1.8-5c0-0.9-0.2-1.8-0.5-2.7l15.6-15.2c1.3,0.9,3,1.5,4.8,1.5c1.7,0,3.3-0.5,4.6-1.4l15.5,15.2    c-0.3,0.8-0.5,1.7-0.5,2.6c0,1.9,0.7,3.6,1.8,5l-18.4,17.9C127.4,195.7,126.3,195.5,125.1,195.5z',
        hasTransform: false
    },
    17: {
        grass: 'M122.5,217.3c-0.4,0-2.4-1-4.1-2.9l-52.6-70c0,0-30.4-35.1-29.8-40.9    c0.5-5.8,22.3-20.3,22.3-20.3l7.5-0.9L69,80l1.9-1.1l44-28l2.2-1.1l2.2-0.9l2.4-0.8l2.2-0.6l5.4-0.9l2.6-0.4l2.4-0.2l4.8-0.1    l1.8,0.3l2.8,0.7l2.7,0.5l4,1.5l2.1,0.8l2.1,1.1l2.4,1.3l2.4,1.5l2.2,1.4l2,1.5l4.2,3.6l2,1.9l23.9,24.2c0,0,2.9,2.6,4.8,3.1    s4.4,0.3,5.5,0.7s10,12.8,10,14.9c0,0.5-3.5,4.4-3.5,4.4l-16.7,16.1l-0.4,0.7c-4.5,6.8-35.7,61-39.4,67.7    c-1.9,3.3-7.2,7.6-15.2,14.9c-2,1.8-5.1,3.7-7.3,5.7C126.4,218.6,123.6,217.3,122.5,217.3L122.5,217.3z',
        outfield: 'M60.1,148.8l-17.3-27.2L20.9,99.8l1.3,0.6l0.5-3.1l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6    l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.6l2-1.7l2-1.7l3.5,1l2.6-0.5l2.1-1.5l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3l2.2-1.3    l2.2-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.3-1.4l2.4-1.4l2.4-1.4l2.4-1.5l2.4-1.5l2.5-1.5l2.5-1.5l2.5-1.5l2.6-1.6l2.6-1.6    l2.7-1.6l2.7-1.4l2.8-1.1l2.8-1l2.9-0.8l2.9-0.5l2.9-0.5l2.9-0.5l2.9-0.3l2.9-0.1l2.9-0.1l2.9,0.5l2.9,0.7l2.9,0.5l2.8,0.8    l2.8,0.8l2.8,1l2.7,1.4L162,43l2.6,1.6l2.5,1.6l2.4,1.8l2.3,2l2.3,1.9l2.2,2.1l2.2,2.1l2.1,2.1l2.1,2.1l2.1,2l2,2l2,2l2,2l2,1.9    l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l2.6,0.7l4-1.4l2.9,0.3l1.9,2l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2    l1.6,2l-22.2,22.3c0,0-41.7,66.6-45.4,73.2c-3,5.5-13.3,13.2-25.9,24.6c-7.3,6.6-15.2,7.5-22.9-1.7L60.1,148.8L60.1,148.8z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    19: {
        grass: 'M125,215.6c-6.6,0-8.8-3.1-11.6-5.8c-0.2-0.2-3.1-0.7-5.9-2.6c-4.1-2.9-40.8-49.4-40.8-49.4    l-16.6-29.7l-19.7-23.7l3.5-4.2l48.7-58l58.4-5.1l3.1-0.3l1.4-0.1l74.4,62.2l0.2,1.8l0.1,2.1l-21.7,21.8l1.5,6.8l-17.3,28    c0,0-39.4,45.9-41.2,47.4c-1.8,1.5-6.4,2.6-6.4,2.6C134.9,209.7,132,215.6,125,215.6L125,215.6z',
        outfield: 'M19.4,105l3.4-4l1.6-2l1.6-2l1.6-2l1.6-2l1.7-2l1.7-2l1.7-2l1.7-2l1.7-2l1.7-2.1l1.7-2.1    l1.8-2.1l1.8-2.1l1.8-2.1l1.8-2.2l1.8-2.2l1.9-2.2l1.9-2.3l1.9-2.3l2-2.3l2-2.4l2-2.4l2.1-2.4l2.1-2.5l2.1-2.5l2.2-2.6l2.2-2.6    l2.3-2.7l2.3-2.8l2.7-1.8l3.1-0.3l3.1-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3l3-0.3    l3-0.3l3-0.3l3.1-0.3l3.1-0.3l3.1-0.3l3.1-0.2l3,1l2.7,2.3l2.7,2.2l2.6,2.2l2.6,2.2l2.5,2.1l2.5,2.1l2.4,2l2.4,2l2.4,2l2.3,1.9    l2.3,1.9l2.3,1.9l2.2,1.9l2.2,1.8l2.2,1.8l2.2,1.8l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.7l2.1,1.7l2.1,1.7l2,1.7l2,1.7l2,1.7l2,1.7    l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l2,1.7l1,2.7l0.3,3.3l0.2,5.8l-21.5,21.6l0.4,3.7L189,160.3l-45.2,53.4    c0,0-7,9.9-18.9,9.9s-15.4-5.8-19-8.7l-46.1-52.7l-23.6-41.3L19.4,105z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    22: {
        grass: 'M123.8,218.2c-16.7,0-23.5-15.8-23.9-16.3l-36.8-68.1l-23.9-25.9l-0.5-1.9v-2.1l0.2-2.8    l0.4-2.6l0.5-2.4l0.7-2.3l0.7-1.9l0.9-1.5l1.4-1.9l1-1.3l3.1-3.6l2.2-1.5l4.3-2.9l2.1-1.4l2.2-1.4l2.2-1.4l2.2-1.4l2.3-1.4    l6.8-4.2l2.3-1.3l2.2-1.3l7.1-3.8l2.3-1.2l2.4-1.2l2.3-1.1l2.4-1.1l2.5-1.1l5.2-2.2l2.4-1l2.7-1l2.6-1l2.5-0.9l2.8-0.9l2.6-0.9    l2.3-0.7l2.2-0.5l2.5-0.3l2-0.2l1.9,0.2l2.2,0.3l2.4,0.6l2.6,0.7l2.5,0.7l5.3,1.8l2.6,0.9l7.8,3.2l2.5,1l2.3,1l4.9,2.3l2.4,1.1    l2.3,1.2l2.4,1.2l2.3,1.2l2.3,1.3l2.2,1.3l2.2,1.3l4.5,2.8l2.3,1.4l2.2,1.4l4.4,2.8l2.2,1.4l4.4,2.8l2.1,1.3l4.2,2.9l2,1.4    l0.9,0.7l2.4,3.4l0.8,1.3l1.4,4.5l0.5,2.4l0.4,2.7l0.2,2.6v1.9l-1.7,8.3L186.3,140c0,0-37.8,61.9-38.2,62.4    c-2.7,3-8.5,15.4-23.8,15.4L123.8,218.2L123.8,218.2z',
        outfield: 'M30.1,112l-1.3-5v-3.4l0.2-3.3l0.4-3.2l0.7-3l0.9-2.9l1.1-2.8l1.4-2.4l1.6-2.2l1.6-2.2    l2.1-1.6l2.2-1.5l2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.5l2.2-1.4l2.2-1.4l2.3-1.4l2.3-1.4L63,64l2.3-1.4l2.3-1.4l2.3-1.4l2.4-1.4    l2.4-1.3l2.4-1.3l2.4-1.3l2.5-1.3l2.5-1.2l2.5-1.2l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.7-1l2.7-1l2.7-0.9l2.8-0.9l2.8-0.9    l2.8-0.8l2.8-0.6l2.9-0.4l2.9-0.3l2.9,0.3l2.9,0.4l2.8,0.7l2.8,0.8l2.8,0.8l2.7,1l2.7,1l2.7,0.9l2.7,1.1l2.6,1.1l2.6,1.1l2.6,1    l2.6,1.1L163,51l2.5,1.2l2.5,1.2l2.5,1.2l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.3,1.4l2.3,1.4L187,64l2.3,1.4l2.3,1.4l2.2,1.4    l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.4l2.2,1.5l2.2,1.5l2.2,1.5l2.1,1.6l1.6,2.3l1.6,2.2l1.5,2.3l0.9,2.9l0.9,2.9l0.7,3    l0.4,3.2l0.3,3.2l-0.1,3.5l-1.5,9L196,140.3c0,0-42.9,66-46.9,70.5c-3.2,3.6-9.5,15.1-25.3,15.1c-17.9,0-26.2-18.1-26.2-18.1    l-41.7-70.4L30.1,112z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    31: {
        grass: 'M125.2,219.2h-1.4c-5.8,0-11.7-7.4-15.2-11.9l-51.4-66.7l1-12.2L37.7,107l2-23.2L80,50l2,2.3    l7.3-0.9l34.1-5.6l1.4-0.2l26.1,5.6l1.7,0.7L179,65.3l0.6,0.5l31.5,45.7l-16.7,16.8l-9.6,28.3c-6.4,7.5-41.5,49-50.1,58.3    C130.8,219.2,125.5,219.2,125.2,219.2L125.2,219.2z',
        outfield: 'M29.3,109.8l0.3-2l0.3-3.1l0.3-3.2l0.3-3.3l0.3-3.4l0.3-3.5l0.3-3.7l0.3-3.8l0.3-3.9l2-1.9    l2.1-1.7l2.1-1.7l2.1-1.8l2.1-1.8l2.1-1.8l2.1-1.8l2.1-1.8l2.2-1.8l2.2-1.8l2.2-1.8l2.2-1.8l2.2-1.9l2.2-1.9l2.3-1.9l2.3-1.9    l2.3-1.9l2.4-2l2.4-2l2.4-2l2.5-2.1l2.5-2.1l4.3,5l2.9-0.3l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5l2.8-0.5    l2.8-0.5l2.8-0.5l2.9-0.5l2.9-0.5l2.9-0.4l2.9,0.6l2.9,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6l2.8,0.6    l2.7,1.1l2.6,1.3l2.6,1.3l2.6,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.2l2.4,1.2l2.4,1.2l2.2,1.8l1.8,2.6l1.8,2.6    l1.7,2.5l1.7,2.5l1.7,2.4l1.6,2.4l1.6,2.3l1.6,2.3l1.6,2.3l1.5,2.2l1.5,2.2l1.5,2.2l1.5,2.1l1.4,2.1l1.4,2.1l1.4,2.1l1.4,2l1.4,2    l1.4,2l1.4,2l1.4,2l1.4,1.9l2.5,3.3l-20.2,20.3l-9.4,28c0,0-41.7,49.3-51.4,59.8c-7.5,8.1-13.9,6.8-16.9,6.8    c-9.4,0-16.6-8.7-21.4-14.9L49,143.1l1-11.7C50,131.4,29.3,109.8,29.3,109.8z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    32: {
        grass: 'M125.5,219.1c-7.7,0-14.6-6-23.2-17.9l-24.2-31.4l-19.8-30.9l-2.7-10.4l-23.5-23.2l0.1-0.5    l3.1-10.3l0.4-0.7L53.4,76l1-0.8l19-8.4l2.6-1.4l2.2-1.1L96.6,56l4-3.4l4.7-6.5l0.1-0.1h0.3l2.7-0.3l2.9-0.2l2.7-0.3l2.7-0.2    l2.8-0.1l2.8-0.1h5.5l2.7,0.1l2.8,0.1l2.8,0.2l2.7,0.2l2.8,0.3l2.6,0.3l0.3,0.1l0.2,0.1l2.6,3.6l4.2,3l27.6,12.4l9.4,8.1l0.3,2.8    l2.7,5.5l26,22.8L179,143.9l0.9,3.9l-11.5,26.6c-3.7,4.6-31.6,38.1-31.6,38.1S131.9,219.1,125.5,219.1z',
        outfield: 'M229.1,104.1l-41.3,42.3l0.6,2.5l-13.7,28.6c0,0-27,33.8-32.7,40.2    c-4.2,5.2-10.9,8.4-18.4,8.4c-12.1,0-19.1-8.4-27.7-20.1l-24.3-31.5L51,142.2l-2.5-9.5l-25.1-24.9l1.2-5.1l0.8-2.7l0.8-2.8    l0.8-2.8l0.9-2.9l1.3-2.5l1.8-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2.1-1.7l2.5-1.1l2.5-1.1    l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.4-1.3l2.4-1.3l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.5-1.1l2.6-1.2    l2.4-2.1l2.3-3.1l2.3-3.2l2.6-2.3l2.9-0.4l2.9-0.3l2.9-0.2l2.9-0.3l2.9-0.2l2.9-0.1l2.9-0.1h5.8l2.9,0.1l2.9,0.1l2.9,0.2l2.9,0.2    l2.9,0.3l2.9,0.3l2.9,0.4l2.6,2.3l2.3,3.3l2.5,1.8l2.6,1.2l2.6,1.2l2.6,1.2l2.6,1.2l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1L179,56    l2.5,1.1l2.5,1.1l2.2,1.9l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.8l2.1,1.8l0.5,4.5l1.4,2.8l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7    l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.6l1.9,1.6L219,95l1.9,1.6l1.9,1.6l1.9,1.6l1.8,1.7L229.1,104.1L229.1,104.1z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    680: {
        grass: 'M126.2,219.4c-3.7,0-9.9-2.5-13.1-5.6l-31.8-35.5L71.5,168l-19.1-35.9l0.4-5.5l-17.9-16.9V109    l0.7-1.9v-1.8l36.7-40l1.4-1.1l13.8-8.9l1.9-0.9L119,42.8l0.2-0.1L173,59.8l0.5,0.4l37.9,47L192,125.8v4.9l-17.6,39l-6,6.8    l-29.6,36.8C137.3,214.6,132.3,219.4,126.2,219.4L126.2,219.4z',
        outfield: 'M65.6,172l-18.4-36.9l0.3-3.9l-19.9-20.9l-0.7-2.9l0.6-1.6l-0.1-3.5l1.7-1.8l1.7-1.8    l1.7-1.8l1.7-1.8l1.7-1.8l1.7-1.8l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.8-1.9l1.8-1.9l1.8-1.9l1.8-2l1.8-2l1.8-2l1.9-2l1.9-2.1    l1.9-2.1l2-2.1l2-2.2l2-2.2l2.3-1.7l2.3-1.5l2.4-1.5l2.4-1.5l2.4-1.6l2.4-1.6l2.5-1.6l2.6-1.3l2.6-1l2.7-1l2.7-1l2.7-1.1l2.7-1.1    l2.7-1.1l2.8-1.1l2.8-1.1l2.8-1.1l2.8-1.1l2.9-1.1l2.9-0.9l3,0.9l2.9,0.9l2.9,0.9l2.9,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9    l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.8l2.7,0.8l2.7,0.8l2.7,0.8l2.7,0.8l2.6,0.8l2.6,0.8l2.6,0.8l2.3,1.9l2,2.5l2,2.4    l1.9,2.4l1.9,2.3l1.9,2.3l1.8,2.3l1.8,2.2l1.8,2.2l1.7,2.2l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9    l1.6,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l0.9,0.9L200,129.2v3.2l-19.8,39.4l-12,14.6c0,0-21.8,28-26.1,32.5    c-4.7,5-18.6,15.3-34.9-0.7L65.6,172z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    2392: {
        grass: 'M125.7,214.2c-7.2,0-13.3-6.3-13.7-6.9l-45.6-54.4l1-10.4l-22.1-22.6v-10.7l16-15.7l1.5-1.4    L78.9,79l-1.8-12.1L112,40.7l39.8,0.1l21,24.6l5.3,2l0.5,0.1l30.4,37.8l-0.7,6.3l-13.5,12.9c0,0,2.1,9-5.1,19    c-4.4,6.2-44.4,54.9-51.5,64.1C138.2,207.7,132.9,214.2,125.7,214.2L125.7,214.2z',
        outfield: 'M125.7,222.2c-11.4,0-19.8-9.7-19.8-9.7l-45.4-55.1l1-12.9l-31.3-31.3l2.3-2.7L34,109    l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6L42,101l1.6-1.6l1.7-1.6l1.7-1.6l1.7-1.6l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.7l1.9-1.5    l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.6L67,66.5l1.9-2.2l2-2.2l2-2.2l21.4-15.2l2.5-2l2.6-2.1l2.6-2.1l2.7-2.1l2.7-2.2l2.9-1.4    h45.1l2.6,2.5l2.4,3.1l2.6,1.8l2.3,2.8l2.2,2.8l2.2,2.7l2.1,2.6l2.1,2.6l2,2.5l2,2.5l2.5,0.9l2.7,0.4l1.9,2.4l1.9,2.3l1.8,2.3    l1.8,2.3l1.8,2.2l1.8,2.2l1.7,2.2l1.7,2.1l1.7,2.1l1.7,2.1l1.6,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9l1.6,1.9l1.5,1.9l1.5,1.9    l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.6l-23.5,23.2c0,0,1.8,12.2-6.7,20.6c-5.3,5.2-47.7,59.9-47.7,59.9    S137.1,222.2,125.7,222.2L125.7,222.2z',
        infield: 'M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7    s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.2,0,0.3,0,0.4l-11.1,2.5l4.4,6.2l7.7-5.7    c1.2,1.9,3.3,3.2,5.7,3.2s4.5-1.3,5.7-3.2l7.7,5.7l4.4-6.2l-11.1-2.5C131.9,202.7,131.9,202.6,131.9,202.4z M120.9,197.3    l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6    l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6C123.6,195.7,122,196.3,120.9,197.3z',
        hasTransform: false
    },
    2394: {
        grass: 'M111.3,211.3c-5.8-5.5-26.9-27.9-30.9-32l-23.8-39.9-7.9-12.6-.3-6-15.5-15.5,61.4-61.8s2.1-1.7,4.2-2.9,4.4-2,4.4-2l47.7.6,7.4,3.2,14.1,13.6.9,1.1,1.6,8.3,20.8,20.5,16.4,16.6,2,2.1-.4,2.2.4,2.1-18.7,18.9.6,13.9-14.2,21.1-13.3,18.8c0,0-14.6,14.9-29,29.7-2.1,2.1-8.5,8.5-14.4,8.3-6.8-.4-12.8-7.5-13.4-8.1Z',
        outfield: 'M24.8,102.6l.6-3,2.7-.8,1.8-1.8,1.8-1.7,1.8-1.8,1.8-1.8,1.8-1.9,1.8-1.8,1.8-1.8,1.8-1.9,1.9-1.8,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,2-2,2-2,2-2,2-2,2-2,2.1-2.1,2.1-2.1,2.2-2.1,2.2-2.2,2.2-2.2,2.3-2.3,2.3-2.3,2.3-2.3,2.4-2.4,2.4-2.4,2.5-2.5,2.5-2.5,2.6-2.2,2.8-1.3,2.8-1.3,2.8-1.3h51.6l2.8,1.2,2.8,1.2,2.8,1.2,2.8,1.2,2.5,2.5,2.5,2.5,2.4,2.4,2.4,2.4,2.3,2.3,2.3,2.3,2.3,2.3,1.4,4.2,1,4.8,1.9,2.5,2,2,2,2,2,2,2,2,2,2,1.9,1.9,1.9,1.9,1.9,1.9,1.9,1.8,1.9,1.9,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,2,1.6,1.7,1.8,1.8,1.8,1.8,1.7,1.7,1.9.9,2.5v3.3c0,0,0,4.6,0,4.6l-20.8,21v13.8l-25.5,37.8s-15.3,18.6-30,33.6h0c-14.7,15.1-30.2,8.9-36.7,2.7s-32-32.5-32-32.5l-35.3-58.4.3-3.6-17.4-17.6-.4-4.5Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7v3.2l6.1,6.2,6-6v-3.4l32.6-32.7ZM120.8,197.2l-17.6-17.6,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c.8.5,1.8.8,2.7.8s2-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.6,17.6h-8.8Z',
        hasTransform: false
    },
    2395: {
        grass: 'M126,215c-2.1,0-9.1-0.9-13.5-6.7s-48.3-56.7-48.3-56.7l-16.3-26.3l-16.5-16.2l1.1-3.1l2.7-6.8    l0.4-0.5l60.9-51.6l79.2,0.1l9.1,22l3.2,5.6l5.9,2.7l13.8,34.9l-0.3,0.1l-13.6,13.2l0.5,6.2l-6.1,5.8l1.6,8.5L135,209.6    C134.1,210.6,129.2,215,126,215L126,215z',
        outfield: 'M23.4,106.8L42,126l22.5,35.2l43.7,50.9    c13.5,15.4,27.3,4.9,27.3,4.9l43.9-50.7l12.1-14.8c1-1.6,6.3-18.6,6.3-18.6l10.3-10l4.8-1.2l-1.2-2.3l5.2-2.9l0,0l-2.2-3l-0.9-2.3    l-0.9-2.3l-0.9-2.4l-0.9-2.4l-0.9-2.5l-1-2.5l-1-2.5l-1-2.6l-1-2.7l-1-2.7l-1-2.8l-1.1-2.9l-1.1-3l-1.1-3l-1.2-3.1l-1.2-3.2    l-2.3-1.3l-2.4-1.1l-1.6-2.8L191,62l-1.3-3.6l-1.4-3.7l-1.5-3.9l-1.5-4l-1.6-4.2l-2.4-2.2h-3.2H175h-3.1h-3.1h-3h-3h-3h-3h-3H151    h-2.9h-2.9h-2.9l-2.9-0.1h-2.8h-2.9h-2.8H128h-2.8h-2.8h-2.9h-2.8h-2.9H111h-2.9h-2.9h-2.9h-2.9h-2.9h-3l-2.6,1.8L88.5,44l-2.4,2    l-2.4,2l-2.3,2L79,52l-2.2,1.9l-2.2,1.9l-2.2,1.9l-2.2,1.8L68,61.3l-2.1,1.8l-2.1,1.8l-2.1,1.7l-2.1,1.7l-2,1.7l-2,1.7l-2,1.7    l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.7l-2,1.6l-2,1.6l-1.9,1.7l-2,1.6l-1.9,1.6l-2,1.7l-1.6,2L27,97.9l-1,2.6l-1,2.6    L23.4,106.8z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    2523: {
        grass: 'M49.2,120.8s-3.1-3.6-5.8-6.2-2.9-3.6-3-7.7,2.9-9.4,4.1-12.6,2.8-6.8,4.3-8.8,2.3-2.9,4.8-5.7,10.1-10,13.1-13,10.1-9.8,12.2-11.7,6.4-4.5,8.5-5.9,8.8-4.2,11.8-5.8,9.2-2.2,13.1-2.5,11.7.5,13.6.6c1.9,0,16.6,3.2,19,4.3s8.6,5.4,14.1,9.3c1.2.8,44.6,46.4,46.1,48.1s3,3.7,2.9,6.1-.4,3-1.8,4.7-10.8,10.6-13.8,13.7c-3,3.1-5.1,6.2-5.8,7.1s-5.9,7.7-10.9,15.9c-7.8,12.7-16.7,27.5-17.6,29.1-3,5.3-6.9,12.2-8.2,14s-9.9,13.5-11.2,15.1-3,3.6-4.8,5.1-5.5,3-8.6,2.9c-4.8-.1-7.7-2.7-9.1-4.1s-5.6-7-7.2-9-4.7-6.3-7-9.3-8-12.1-10.9-16.4-4.3-8.2-7.8-13.9-3.2-5.1-4.6-7.4c-2.1-3.4-3.9-6.2-5.3-7.7-3.1-3.4-7.6-10.7-8.8-12.6s-13.3-13.6-13.3-13.6l-1.9-2Z',
        outfield: 'M216.5,108.5l-1.1-1.7-1.2-2-1.1-1.9-1.2-1.9-1.5-2.2-1.6-1.7-1.6-1.9-1.7-1.6-1.7-2-1.8-1.9-1.5-1.5-1.8-1.9-1.9-2.1-1.4-1.4-2.1-2.2-1.8-2.1-1.8-1.8-1.8-1.9-1.9-1.9-1.9-1.9-1.9-1.9-1.9-2-2-2-2-2-2-2.1-2.1-2.1-2.1-2.1-2.2-2.2-2.2-2.2-2.2-2.3-2.3-1.7-2.5-1.7-2.5-1.9-2.7-2.1-2.5-1.8-2.4-1.4-3-1.1-2.7-1-2.5-.7-2.7-.8-2.7-.7-3.1-.5-3-.4-3.5-.7h-2.9c0-.1-2.7,0-2.7,0h-6.1s-3,.4-3,.4l-2.7.3-3,.5-3.6.5-1.9.7-2.8,1-2.9.9-3.6,1.3-2.7,1.5-2.5,1.6-2.1,1.2-2.9,1.7-2.5,1.5-2.4,1.6-2.3,2.1-2.2,2.2-2.2,2.2-2.1,2.1-2.1,2.1-2.1,2.1-2,2-2,2-2,2-2,2-2,2-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.7,2-1.3,2.5-1.5,2.6-1.2,2.9-.9,2.9-.8,2.5-.5,2.3-.5,3.7-.4,3.2-.6,3.4,2.2,2.5,1.9,3.4.9-.7,23.8,24.1,11.8,20,1.5-.6,1.1,2.1,8.4,14-.5.5,19.5,32.7,1.8-1s2.1,2.9,3.1,4.4,2.8,3.7,4.7,4.9c2.5,1.4,6.5,4.1,10.3,4.8s5.8.5,8.6-.3,5.9-2.7,7.8-3.9,1.9-1,2.9-1.8c1.5-1.2,2.8-3,3.4-4.3,1.7-2.5,2.7-4.2,2.7-4.2l2.8,1.9,18.7-32.9-1.4-1,9.9-16.3,1.2.7,5.6-9.7,6.9-11.5,9-9.3,17.7-17.5-.6-2-.5-.9Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    2529: {
        grass: 'M34.7,112.7l23.8-37.3,3-3.5,27.2-18.9,23.1-7.9h27.3l53.2,30.7,19.3,34.5,2.4,4-2.7,4.8-38.6,43.8-24.2,46.3s-6.8,18.2-23.9,18.2-25.2-18.2-25.2-18.2l-18.7-43.1-45.9-53.5Z',
        outfield: 'M220.3,117.7l-42.5,47.1-24.2,47.4s-8.7,19.8-29.5,19.8-31-21.3-31-21.3l-17.4-42.1-48.1-54.2-2.5-2.8,3-5.6,1.3-2.1,1.3-2.1,1.3-2.1,1.4-2.1,1.4-2.2,1.4-2.2,1.4-2.2,1.5-2.2,1.4-2.2,1.5-2.3,1.5-2.3,1.5-2.4,1.5-2.4,1.5-2.4,1.6-2.5,1.6-2.5,1.7-2.6,2-1.9,2.2-1.5,2.2-1.5,2.2-1.6,2.3-1.6,2.3-1.6,2.3-1.6,2.3-1.6,2.4-1.7,2.4-1.6,2.4-1.7,2.5-1.7,2.5-1.7,2.5-1.7,2.7-.9,2.7-.9,2.7-.9,2.8-.9,2.7-.9,2.8-.9,2.8-.9,2.8-.9,2.9-1,2.9-.6h26.4l2.9.2,2.8,1.5,2.7,1.5,2.7,1.5,2.7,1.5,2.7,1.5,2.6,1.4,2.6,1.4,2.6,1.4,2.5,1.4,2.5,1.4,2.5,1.3,2.5,1.4,2.5,1.3,2.5,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.4,1.3,2.2,1.7,1.5,2.8,1.5,2.8,1.4,2.7,1.4,2.7,1.4,2.6,1.3,2.6,1.3,2.5,1.3,2.5,1.2,2.4,1.2,2.4,1.2,2.4,1.2,2.3,1.2,2.3,1.2,2.3,1.2,2.2,1.1,2.2,2.4,7-3,3.3Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    2535: {
        grass: 'M126.4,218.8c-16.6,0-25.8-9.9-25.8-9.9l-.2-3.6-15-17.9h-3.9l-19.9-33.8-24.7-47.1-1.4-3.9s-1.8-12.2,4.1-20.2c7.7-10.4,53.3-39,74.4-41.9,0,0,11-3.6,23.6-.5,12.5,3.2,62.1,33.1,67.7,39,5.1,5.4,10,19.5,4.5,33.1-5.4,13.6-13.6,29.3-14.8,34.3s-22.2,39.8-24.8,40.8c-2.6,1.1-3.6,0-3.6,0l-15.1,17.4.2,4.1s-8.6,10.1-25.3,10.1Z',
        outfield: 'M126.5,227.7c-18.3,0-28.5-10.9-28.5-10.9l-.2-4-16.5-19.8h-4.3l-21.9-37.3-27.1-51.3-1.5-4.2s-2-13.5,4.5-22.2c8.5-11.5,58.8-43,82-46.2,0,0,12.2-4,26-.5s68.5,36.5,74.7,43c5.6,5.9,11,21.5,5,36.5s-15.2,31.8-16.5,37.3-24.5,43.8-27.3,45-4,0-4,0l-16.7,19.2.2,4.5c-.1-.2-9.6,10.9-27.9,10.9Z',
        infield: 'M101.7,170l-6.1,6.1,6.1,6.1c3.4-3.4,3.4-8.8,0-12.2ZM148.6,182.2l6.1-6.1-6.1-6.1c-3.3,3.4-3.3,8.8,0,12.2ZM131.2,152.6l-6.1-6.1-6.1,6.1c3.4,3.4,8.9,3.4,12.2,0ZM125.2,173.5c2.15,0,3.9,1.75,3.9,3.9s-1.75,3.9-3.9,3.9-3.9-1.75-3.9-3.9,1.75-3.9,3.9-3.9ZM125.2,197.8c3.09,0,5.6,2.51,5.6,5.6s-2.51,5.6-5.6,5.6-5.6-2.51-5.6-5.6,2.51-5.6,5.6-5.6Z',
        hasTransform: false
    },
    2602: {
        grass: 'M-124.7,205.9c-0.9,0-1.9,0.1-3.2,0.2c-8.6,1-12.2,4.9-12.8,5.5l-1.1,1.8l-1.2,0.4    c-1.9,2-7.7,9.3-26.2,36.2l-0.5,0.8l-9.7,28.2l-38.5,38.6l-0.1,1.4l0.7,3.5l0.1,0.2l50.3,49l1,0.9l1,0.3l2.6,0.8l34.9,10.5    l0.4-0.1l11-4.1l2.7-1.1l2.7-1.1l2.6-1.1l7.7-3.7l2.4-1.3l2.5-1.4l2.5-1.3l2.2-1.3l7.1-4.6l2.2-1.5l2.1-1.5l4.3-3.2l2-1.6l2.1-1.7    l2.1-1.7l1.9-1.6l1.8-1.7l7.5-7.3l1.6-1.7l6.7-7.8l3.4-3.9l1.6-1.9l3.1-3.6l0.9-1.2l0.8-1.6l1.3-2.6l0.1-0.1l-0.6-6.5    c-4-4.4-15.7-16.4-26.3-27l-0.9-0.9l-0.6-1.1c-7.5-14.8-20.8-40-24.2-44.8c-9.5-13.3-20.8-26.5-24.3-28.2    C-119.9,206.2-122.5,205.9-124.7,205.9L-124.7,205.9z',
        outfield: 'M-147.3,207c-3.5,1.8-26.4,35.5-29.7,40.3l-9.4,27.4l-39.4,39.5l-0.2,5.6l0.6,2.9l0.6,2.9    l1.3,2.3l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.9,1.8l1.9,1.8l1.9,1.8l1.9,1.9l1.9,1.9l1.9,1.9    l2,1.9l2,1.9l2,1.9l2,2l2.1,2l2.1,2l2.1,2.1l2.1,2.1l2.2,2.1l2.2,2.2l2.2,2.2l2.3,2.2l2.4,2.2l2.7,0.9l2.8,0.8l2.8,0.8l2.8,0.8    l2.8,0.8l2.8,0.8l2.8,0.8l2.8,0.8l2.8,0.9l2.9,0.9l2.9,0.9l2.9,0.9l2.9,0.9l3,0.9l3,0.9l3-0.7l2.9-1.1l2.9-1.1l2.9-1.1l2.9-1.1    l2.8-1.2l2.8-1.2l2.8-1.2l2.7-1.3l2.7-1.3l2.7-1.3l2.6-1.4l2.6-1.4l2.5-1.4l2.5-1.5l2.4-1.6l2.4-1.6l2.4-1.6l2.4-1.6l2.3-1.6    l2.2-1.7l2.2-1.7l2.2-1.7l2.1-1.8l2.1-1.8l2.1-1.8l2-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.8-1.9l1.7-2l1.7-2l1.7-2l1.7-2    l1.7-1.9l1.7-1.9l1.6-1.9l1.6-1.9l1.6-1.9l1.5-2l1.1-2.4l1.2-2.3l1.3-2.2l-1.1-11.6c-2-3-28.4-29.5-28.4-29.5S-79,238.5-84,231.5    c-5-7.1-20.4-27.4-27.4-30.8c-7-3.3-11.6-3.7-17.1-3C-142.3,199.6-147.3,207-147.3,207z',
        infield: 'M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4    c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7    c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6    s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z',
        hasTransform: true
    },
    2680: {
        grass: 'M-129.5,210.3l-5.9,2.5l-11.3,11.2l-17.1,18.4l-3.8,3.5l-21.6,33.6v8.2l-25.9,26.8l-0.7,8.1    l3.2,5.6l43,42.9l1.6,1.4l10.6,6.1h0.8l19.6,0.1l4,0.2l3,2.3l22.7,0.1l2.2-0.3l13-2.5l1.4-0.8l7.3-4.5l1.7-1.2l37-40    c0,0,1.7-1.7,2.1-5.2c0.4-3.5,0-20.4,0-20.4l-25.6-25.6l-20.4-35l-2.2-2.2l-21.3-22.9l-8.1-7.7l-5.3-2.6h-4V210.3z',
        outfield: 'M-228,314.7v7l2.2,1.3l1.5,2l1.4,2.2l1.4,2.2l1.4,2.2l1.6,2l1.8,1.8l1.8,1.8l1.8,1.8    l1.8,1.8l1.8,1.8l1.9,1.8l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l2,1.9l2,2l2,2l2,2l2.1,2l2.1,2.1l2.1,2.1l2.1,2.1l2.2,2.2    l2.2,2.2l2.3,2.3l2.4,2.1l2.6,1.5l2.6,1.5l2.6,1.5l2.6,1.5l2.7,1.5l3,0.1h17.6l2.8,1.6l2.9,1h26.4l2.9-0.4l2.9-0.6l2.9-0.6    l2.9-0.6l2.9-0.6l2.9-0.6l2.7-1.5l2.6-1.6l2.6-1.6l2.6-1.6l2.5-1.8l2.3-2.3l2.2-2.2l2.2-2.2l2.2-2.2l2.1-2.1l2.1-2.1l2.1-2.1l2-2    l2-2l2-2l2-2l2-2l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.8-1.8l0.6-3.3v-11.5l1.5-1.9l1.7-1.7l1.5-1.9    l0.6-10.6l-31.5-31.5l-20.4-35l-2.4-2.4l-4.8-7.3l-16.3-17.6l-2.7-0.5l-7.2-6.8l-8.2-4h-7.3l-8.8,3.7l-9.6,9.6l-3-0.3l-13.5,14    l-4.2,8.1l-3.6,3.2l-23.4,36.5v7.2L-228,314.7L-228,314.7z',
        infield: 'M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4    c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7    c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6    s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z',
        hasTransform: true
    },
    2681: {
        grass: 'M70.2,169.7l-9.8-23.5l0.2-13.4l-26.1-24l2-2.4l51-51h4.4l6.1-0.1l13.1-13l41,5.7h0.3    l62.9,61.5L191,133.3l-0.5,11.7l-8.6,22.5l-46.5,47.1h-18.8L70.2,169.7z',
        outfield: 'M199.8,132l-2.4,2.3l-0.2,10.4L186.8,173l-49.7,48.3l-21.8,0.1l-49.2-47.2l-10.9-27.1    l0.1-9.4l-27.1-27.6l0.1-3.5v-3.5l1.7-1.8l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8    l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2-2l2-2l2-2l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.2-2.2    l2.3-2.3l2.7-0.7h8.6l2.4-2.4l2.5-2.4l2.5-2.5l2.6-2.6l2.7-2.6l2.9-0.6l3,0.4l3,0.4l3,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4    l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.9,0.4l2.8,0.8l2.4,2.4l2.4,2.4l2.3,2.3l2.3,2.3l2.2,2.2l2.2,2.2    l2.2,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l2,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8    l1.8,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l0.1,3.5L199.8,132L199.8,132z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    2889: {
        grass: 'M125.6,215.8c-8,0-17.8-9-27.8-20.2L69,167.5l-9.7-39.4L38.8,107l-1.9-11.1l38.5-38.4l1-0.9    l1.1-0.4l34.4-11.1l1.7-0.1h24.7l34.3,11l1.2,0.5l1,0.9l36.3,36.8l0.4,8.9l0.1,3L201,117.3l0.9,11.1L177,171.7    c-3.7,4.3-32.5,32.7-32.9,33.1C139.7,209.5,134.8,215.8,125.6,215.8L125.6,215.8z',
        outfield: 'M223.8,107.4l-14.2,14.2l-0.4,6.9l-29.9,52c0,0-18.3,18.4-24.2,25    c-4.4,5.4-15.6,18.5-29.5,18.5c-12.4,0-20.5-8.2-29.4-18.5L62,171.3l-8.4-37L28.2,108l-1.9-3.6l-1-4.6v-3.6l1.8-1.8l1.8-1.8    l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2-2l2-2l2-2l2.1-2.1    l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.3-2l2.6-1l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.8-0.9l2.8-0.9    l2.8-0.9l2.8-0.9l2.8-0.9l2.9-0.1h26.1l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9    l2.7,0.9l2.7,0.9l2.7,1l2.3,1.9l2.2,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l2,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9    l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.1,2.6l0.5,3.2l0.4,3.1l0.4,3.1L223.8,107.4L223.8,107.4z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    3289: {
        grass: 'M-126.5,208.1c-10.9-0.1-18.1,1.4-24.8,9.8l-27.7,36.8l-8.1,31.3l-33.9,32.9l9.2,18.6l0.5,0.4    l6.2,4.5l2,1.3l29.9,18.7l2.6,1.6l30.3,21.8l0.7,0.4l18.6,0.2l0.8-0.1l43.2-25.1l3.3-1.9l6.3-1.7l2.7-0.7l20.1-28l2.6-3.8l3.7-5.1    l-33.4-34.6l-5.1-29.4c-8.8-13.2-22.5-33.2-26.3-37.6l-0.4-0.4l-0.3-0.5C-108.3,211.4-115.5,208.3-126.5,208.1L-126.5,208.1z',
        outfield: 'M-26.2,318.5L-26.2,318.5l-37.4-37.7    l-5.4-28.5c0,0-22.6-33-28.4-39.5c-7.9-11.7-21.6-12.8-29.2-12.8c-12.3,0-22.5,2-31.3,13.3l-28.2,38.6l-7.6,30.8l-35.9,35.8    l1.8,3.3l1.2,2.3l1.2,2.3l1.2,2.4l1.3,2.4l1.2,2.5l1.3,2.5l1.3,2.5l1.3,2.5l1.3,2.6l2.1,1.6l2.2,1.5l2.2,1.5l2.2,1.5l2.3,1.4    l2.2,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.4,1.4l2.4,1.5l2.4,1.6    l2.4,1.7l2.4,1.7l2.5,1.7l2.5,1.7l2.5,1.8l2.6,1.8l2.6,1.8l2.7,1.8l2.7,1.9l2.8,1.9l2.8,2l2.9,1.6h3h3.1h3h3h3h3h3.1l3-0.5    l2.9-1.8l2.8-1.7l2.8-1.7l2.8-1.6l2.7-1.6l2.7-1.6l2.6-1.6l2.6-1.5l2.5-1.6l2.5-1.5l2.5-1.5l2.5-1.5l2.4-1.5l2.5-1.4l2.4-1.5    l2.4-1.4l2.4-1.4l2.4-1.4l2.8-0.5l2.8-0.6l2.8-0.5l2.4-1.4l1.7-2.7l1.7-2.5l1.7-2.5l1.7-2.4l1.7-2.4l1.7-2.3l1.6-2.3l1.6-2.3    l1.6-2.3l1.6-2.2l1.5-2.2l1.5-2.2l1.5-2.1l1.5-2.1l1.5-2.1l1.4-2.1l1.4-2.1l1.4-2l1.4-2L-26.2,318.5z',
        infield: 'M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4    c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7    c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6    s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z',
        hasTransform: true
    },
    3309: {
        grass: 'M125.7,216.9c-2.5,0-6-1.2-8.7-3.8l-0.2-0.2L73,173l-19.8-35.5l-0.7-12.3l-18.8-18.1l17-28.4    l0.4-0.5l2.6-1.4l1.8-2.3l31-17.1l3.2,1.4l6-2.9l24.4-13.4l79,34.9l0.2,0.2l16.1,29l-20,19.8l-0.8,12.6    c-5.4,12.1-12.4,23.3-14.8,28.3l-45,44.6c-0.6,0.4-1.1,0.8-1.4,1.1C130.4,215.5,128.4,216.9,125.7,216.9L125.7,216.9z',
        outfield: 'M109.7,215l-42.1-39.9l-20.1-36.5l-0.3-7.5l-22.9-23.9l1.7-3l1.3-2.2l1.3-2.2l1.3-2.2    l1.3-2.2l1.4-2.3l1.4-2.3l1.4-2.3l1.4-2.3l1.4-2.4l1.4-2.4l1.5-2.5l1.5-2.5l1.5-2.5l1.8-2.1l2.3-1.3l1.8-2.3l2.4-1.3l2.4-1.3    l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.4-1.3l2.5-1.4l2.5-1.4l2.5-1.4l2.6-1.1l3.2,1.4l2.5-1.2    l2.5-1.4l2.6-1.4l2.6-1.4l2.6-1.4l2.7-1.5l2.7-1.5l2.7-1.5l2.8-1.5l2.8-1.6l2.9-1.6l3,0.6l2.9,1.3l2.9,1.3l2.9,1.3l2.8,1.2    l2.8,1.2l2.7,1.2l2.7,1.2l2.7,1.2l2.7,1.2l2.6,1.2l2.6,1.1l2.6,1l2.6,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1    l2.5,1.1l2.5,1.1l2.5,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.4,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l2.5,1.1l1.7,2.4l1.5,2.7    l1.4,2.6l1.4,2.6l1.4,2.5l1.4,2.5l1.3,2.4l1.3,2.4l1.3,2.4l1.3,2.3l1.3,2.3l1.3,2.3l1.2,2.2l1.2,2.2l2,3.2L200,134.4l1.3,8.6    c0,0-16.8,28.4-17.7,30l-43,43.2C138.4,218.1,125,230,109.7,215L109.7,215z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    3312: {
        grass: 'M125.9,216.3c-6.7,0-11.7-5.4-11.8-5.5l-0.2-0.2l-0.1-0.1l-48.4-49.1l-14.6-40.2L35,104.8    l34.7-39.4l1.3-1.1l40.3-22.9l29.4,2.9l1,0.4l39.8,25.7l1.1,1.3l32.1,39.3l-24.6,23.9l-8.4,24.2l-11.9,17.4    c-3,3-14.4,14.3-31.8,32.3C133.2,213.8,130.5,216.3,125.9,216.3L125.9,216.3z',
        outfield: 'M24,105.1l1.3-1.7l1.6-1.8l1.6-1.9l1.6-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9l1.7-1.9    l1.7-1.9l1.7-1.9l1.7-2l1.7-2l1.8-2l1.8-2l1.8-2l1.8-2.1l1.8-2.1l1.9-2.1l1.9-2.1l1.9-2.2l2-2.2l2-2.2l2.2-1.9l2.4-1.5l2.4-1.5    l2.4-1.5l2.4-1.5l2.4-1.5l2.5-1.5l2.5-1.5l2.5-1.5l2.5-1.6l2.6-1.6l2.6-1.6l2.6-1.6l2.7-1.6l2.7-1.7l2.8-1.7l2.9-1.1l3,0.3l3,0.3    l3,0.3l3,0.3l3,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.9,0.3l2.8,1.1l2.7,1.7l2.7,1.7l2.6,1.7l2.6,1.7l2.5,1.6    l2.5,1.6l2.5,1.6l2.4,1.6l2.4,1.6l2.4,1.5l2.4,1.5l2.3,1.5l2.3,1.5L180,60l2.3,1.5l2.3,1.5l2.3,1.5l1.9,2.2l1.8,2.2l1.8,2.2    l1.8,2.2l1.8,2.1l1.7,2.1l1.7,2.1l1.7,2.1l1.7,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9l1.6,1.9l1.6,1.9l1.5,1.9l1.5,1.9l1.5,1.9    l1.5,1.9l1.5,1.9l2,2l-29.4,29.7l-9,27.1l-9.9,14c0,0-13.3,14.3-34.5,34.9c-15.9,15.5-32.5-1.3-32.5-1.3L56.8,158l-14.7-34.2    L24,105.1z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    3313: {
        grass: 'M125.8,216.5c-9.2,0-15.7-7.8-15.8-7.9l-32.4-37.1L59,129.8l-18.1-16.9l-1.4-4.4V107l0.3-2.5    l0.4-2.8l0.5-2.3l1.6-4.7l0.9-2.1l3-3.9l0.9-1.1c0,0,26.1-27.6,30.8-31.7c12.6-11.3,34.8-12.8,34.8-12.8h10.6l8.2,1.3l2.3,0.4    l7.8,2.6l1.6,0.6L157,58l47,45.1l1.1,1.1c0,0,2.7,3.1,0,6.5s-11.9,14.7-11.9,14.7l-23.1,43.3l-32.5,42    C135.9,212.7,131.6,216.5,125.8,216.5z',
        outfield: 'M125.8,222.5c-13.4,0-22-10.9-22-10.9L79.4,182L69,168.9l-16.7-34.3l-18.5-17.2l-2.4-7.7    l0.1-3.3l0.4-3l0.5-3.1l0.6-3l0.9-2.7l1-2.8l1.1-2.6l1.3-2.5l1.3-2.5l1.7-2l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2    l2-2l2-2l2-2l2-2l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.2-2.2l2.3-2.1l2.5-1.5l2.5-1.5l2.6-1.5l2.6-1.6l2.6-1.6l2.6-1.6l2.8-0.9    l2.8-0.9l2.9-0.8l2.9-0.7l2.9-0.7l2.9-0.6l2.9-0.5l2.9-0.4h12l3,0.5l2.9,0.5l2.9,0.5l2.9,0.5l2.9,0.9l2.8,0.9l2.8,0.9l2.8,1.1    l2.6,1.9l2.6,1.9l2.5,1.8l2.5,1.8l2.5,1.8l2.4,1.7l2.3,2.2l2.2,2.2l2.2,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l1.9,1.9l1.9,1.9    l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7l1.7,1.7    l1.4,2.1l1.3,2l0.9,2.4l0.9,2.4l0.4,2.8l-0.7,4.3l-21.8,21.8l-24.5,43.3l-24.9,32.4C145.6,212.7,138.2,222.5,125.8,222.5    L125.8,222.5z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    4169: {
        grass: 'M125,214.2c-3.3,0-6.9-0.3-10.7-4.8l-83.5-102l6.5-10.3l1.3-1.9L45,87l1.5-1.8l9.1-9.4l1.8-1.5    l8.4-6.9l1.9-1.4l2.2-1.4l2.5-1.6l2.4-1.6l2.3-1.5l2.2-1.3l2-1.1l2.1-0.9l2.1-0.8l2.3-0.6l2.8-0.7l3.3-1l3.5-1.5l3.4-1.9l3.3-2.3    l3.3-3l0.9-1c0,0,6.3-1.4,11.2-0.2s47,11.6,47,11.6l6.1,2.6l2,1.4l4.4,4.6l1.5,1.6l9.1,11.5l26.1,32.8l0.8,1l-80.7,98.9    C134.5,211.4,129.9,214.2,125,214.2L125,214.2z',
        outfield: 'M23.1,102.6l-2.1,3.2l87.1,105.6    c18.4,22.3,34.3-0.3,34.3-0.3l84.4-102.6l-3.1-3.9l-1.5-1.9l-1.5-1.9l-1.5-1.9l-1.6-2l-1.5-2l-1.6-2l-1.5-2l-1.6-2l-1.6-2l-1.6-2    l-1.6-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.8-2.2l-1.7-2.2l-1.8-2.3l-1.8-2.3l-1.8-2.3l-1.9-2.4l-1.9-2.5l-2.2-2l-2.5-1.3    l-2.5-1.3l-2.5-1.3l-2.5-1.3l-2.5-1.4l-2.5-1.2l-2.7-0.7l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.7L151,44l-2.7-0.7l-2.8-0.6    l-2.7-0.9l-2.7-1l-2.8-0.5l-2.8-0.4l-2.8-0.5l-2.8-0.6l-2.9-0.7l-2.9-0.7l-3-0.7l-2.9-0.2h-2.9h-2.9h-3h-2.9l-2.9,0.7l-2.6,2.3    l-2.6,2L94.1,43l-2.7,1.1l-2.7,0.8L86,45.6l-2.7,0.8l-2.7,1L78,48.5l-2.5,1.3L73,51.3l-2.5,1.5l-2.4,1.5l-2.4,1.6l-2.3,1.5    l-2.3,1.7L58.9,61l-2.2,1.8l-2.1,1.8l-2.2,1.7l-2.1,1.8l-2,2l-2,2L44.6,74l-1.9,2l-1.9,1.9L39,80l-1.7,2.2l-1.7,2.1L34,86.4    l-1.7,2l-1.5,2.2l-1.4,2.3L28,95.1l-1.4,2.3l-1.3,2.2l-1.3,2.2L23.1,102.6z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    4705: {
        grass: 'M124.7,216.6c-3.3,0-6.6-1.9-10.1-5.5l-61-71.9c-1.1-1.9-4.4-4.7-4.1-8.6l1.2-4.6l-17-18    l14.9-32.7l0.5-0.4l17.6-12.2l1.7-0.9l41.2-17.1l1.3-0.2l28.2,0.2l1,0.1L179,65.1l0.8,0.7l32.8,44.5l-13.4,13.3l1.5,3.6    c1.4,4.4,0.6,9.3-2.2,13c-6.3,7.7-61.8,69.4-62.4,70.1C136.1,210.3,131.6,216.6,124.7,216.6L124.7,216.6z',
        outfield: 'M222.4,111.8l-16.8,16.6c2.2,6.9,0.9,8.5-3.5,14.3c-5.8,7.2-59.8,72.7-59.8,72.7    s-15.9,20-33.6,1c0,0-61.2-72.7-63.9-77.1c-2.4-3.9-4.8-6.9-1.5-11.1l-19-18.4v-1l1.2-2.4l1-1.7l1.1-2.4l1.1-2.4l1.1-2.4l1.1-2.5    l1.2-2.5l1.2-2.6l1.2-2.6l1.2-2.7l1.2-2.7l1.3-2.8l1.3-2.8l1.3-2.9l1.3-2.9l2.1-1.8l2.3-1.6l2.3-1.6l2.3-1.6l2.3-1.6l2.3-1.6    l2.3-1.6l2.3-1.6l2.3-1.6l2.5-1.4l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.6-1.1l2.7-1.1l2.7-1.1l2.7-1.1    l2.7-1.1l2.7-1.1l2.7-1.1l2.8-1.1l2.8-1.2l2.9-0.4h29l2.9,0.3l2.8,1.4l2.7,1.4l2.7,1.4l2.7,1.4l2.6,1.4l2.6,1.4l2.6,1.3l2.6,1.3    l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.5,1.3l2.4,1.3l2.4,1.3l2.2,1.9l1.9,2.5l1.8,2.5l1.8,2.4l1.7,2.4l1.7,2.3l1.7,2.3    l1.7,2.3l1.6,2.2l1.6,2.2l1.6,2.2l1.6,2.1l1.6,2.1l1.5,2.1l1.5,2.1l1.5,2l1.5,2l1.5,2l1.5,2l1.4,2l1.4,1.9l1.4,1.9l1.4,1.9    l0.5,0.4l1.5,2L222.4,111.8L222.4,111.8z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    5325: {
        grass: 'M148.4,39.7l22.9,22.6l6.4-1.9l11.5,11.3    l0.3,1.5l4.7,5.1l17.1,16.1l2.4,14.4l-20,19.7l1.7,4.4c0,0-2.5,10.7-3.4,12.2s-7.2,8.7-8.1,10.1c0,0-13,17.5-15.7,20.8    c-2.7,3.2-11.6,15.6-13.4,17.6s-7.8,10.2-9.3,12.1s-9.1,8-11.9,9c-1.4,0.5-4.8,0.3-8.3,0.4c-3.5,0-7.1,0.3-8.7-0.4    c-3.2-1.3-7.5-3.8-11.7-9.1c0,0-10.4-13.2-14.5-18.8s-4.2-5.5-4.2-5.5s-15.3-19.2-18-22.5c-2.7-3.2-4.3-13-5.2-15.9    s-0.2-5.6-3.6-9.3C56,129.9,33.8,108,33.8,108s3-16.7,3.3-18s1.8-8.3,1.8-8.3l41.4-24.2l1.2-4.5l23.4-13.5h43.5V39.7z',
        outfield: 'M27.8,110L56,138.6l6.9,22.9l8.5,12.1    l33.5,41.2c0,0,9.6,5.8,10.2,6s6.6,0.1,10.2,0.1c3,0,9.1,0.2,9.8,0s8.9-5.1,9.4-5.8c17.6-20.9,30.5-37.4,30.5-37.4l22.3-29.5    l3.9-14l-0.2-3.5l17.3-17.7l1.6-2l-0.2-2.5l-0.5-2.8l-0.6-2.9l-0.5-2.9l-0.6-3l-0.6-3.1l-1.1-2.6l-1.8-1.8l-1.8-1.8l-1.8-1.8    l-1.8-1.8l-1.8-1.8l-1.8-1.9l-1.9-1.8l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.4-3l-2-2l-2-2l-2-2l-2-2l-2.1-2.1l-2.1-2.1    l-2.8-0.4l-3.1,0.5l-2.7-0.4l-2.2-2.2l-2.2-2.2l-2.2-2.2l-2.3-2.3l-2.4-2.4l-2.4-2.4l-2.5-2.5l-2.5-2.5l-2.5-2.6l-3-0.2h-3h-3h-3    h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3l-2.8,1.4l-2.7,1.6l-2.7,1.6L93.5,40l-2.7,1.5L88.3,43l-2.6,1.5L83.1,46l-2.5,1.5L78.1,49    l-1.8,3.5l-2.2,2.3L71.7,56l-2.4,1.4l-2.4,1.4l-2.4,1.4l-2.4,1.3l-2.4,1.4l-2.3,1.3l-2.3,1.4l-2.3,1.3l-2.3,1.3l-2.3,1.4l-2.3,1.3    l-2.3,1.3l-2.3,1.3L38.8,75l-2.3,1.3l-2.3,1.5l-0.7,3.5l-0.7,3.5l-0.6,3.4l-0.7,3.2l-0.6,3.2l-0.6,3.1l-0.6,3l-0.6,2.9l-0.6,2.8    L27.8,110z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7    c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7    c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6    s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z',
        hasTransform: false
    },
    5355: {
        grass: 'M198.8,121.61s11.44-12.04,12.42-13.3,1.48-5.57-.77-7.71-25.76-25.65-27.8-27.84-16.4-16.56-16.4-16.56l-8.75.84-32.28-17.22-31.47,7.39s-53.78,53.36-55.04,54.55-1.41,6.34-.42,7.46,13.23,13.94,13.23,13.94l-1.87,4.76s14.62,25.93,15.46,27.33,26.54,29.14,29.56,32.59,17.67,20.2,19.92,22.17,6.3,5.63,10.22,5.63,7.51-1.2,9.98-4.08,50.05-54.83,51.03-55.89,15.13-27.03,15.13-27.03l-2.14-7.04h0Z',
        outfield: 'M205.8,125l1.55,4.8-16.75,29.5-47.16,52.13s-7.71,10.7-18.64,10.7-18.53-12.25-18.53-12.25l-26.75-29.7-19.15-20.88-17.08-29.5,1.31-5.16-19.78-21.97,1.76-1.75,1.78-1.73,1.76-1.75,1.76-1.76,1.76-1.76,1.77-1.77,1.77-1.77,1.78-1.78,1.79-1.79,1.8-1.8,1.81-1.81,1.82-1.82,1.84-1.84,1.85-1.85,1.87-1.87,1.89-1.89,1.9-1.9,1.93-1.93,1.95-1.95,1.97-1.97,2-2,2.02-2.02,2.05-2.05,2.08-2.08,2.12-2.12,2.15-2.15,2.19-2.19,2.22-2.23,2.27-2.27,2.31-2.32,2.36-2.36,2.41-2.42,2.68-1.46,2.86-.66,2.87-.66,2.87-.66,2.88-.66,2.89-.67,2.9-.67,2.91-.67,2.92-.67,2.94-.68,2.96-.68,2.98-.69,3-.68,3,.72,2.94,1.7,2.89,1.67,2.84,1.64,2.79,1.61,2.74,1.59,2.7,1.56,2.66,1.54,2.62,1.52,2.59,1.5,2.56,1.48,2.63.95,2.94-.44,2.98-.45,3.03-.45,2.56,1.31,2.26,2.24,2.22,2.2,2.18,2.17,2.14,2.14,2.1,2.11,2.07,2.07,2.04,2.04,2.01,2.01,1.99,1.99,1.96,1.96,1.94,1.94,1.91,1.92,1.89,1.9,1.88,1.88,1.86,1.86,1.84,1.84,1.83,1.83,1.81,1.82,1.8,1.8,1.79,1.79,1.78,1.78,1.77,1.77,1.76,1.77,1.76,1.76,1.75,1.75,1.75,1.75,1.75,1.74,1.77,1.72,1.75,1.74-19.23,21.79h-.02Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    5445: {
        grass: 'M57.37,139.02s10.33,15.96,11.17,17.36,13.59,24.49,16.61,27.94,26.57,25.6,28.82,27.57,7.11,2.06,11.03,2.06,7.32.47,9.79-2.41c.69-.81,25.61-26.22,25.61-26.22,0,0,19.78-29.88,20.48-30.64.98-1.06,11.97-20.63,11.97-20.63l22.74-23.93s-29.86-32.75-31.9-34.94-30.02-29.28-30.02-29.28l-2.06-.75-56.83.98L31.09,112.37l24.03,23.28,2.25,3.38Z',
        outfield: 'M26.6,104.44l1.7-1.74,1.7-1.75,1.7-1.75,1.71-1.75,1.71-1.76,1.72-1.76,1.73-1.77,1.73-1.78,1.74-1.79,1.75-1.8,1.77-1.81,1.78-1.83,1.79-1.84,1.81-1.86,1.82-1.87,1.84-1.89,1.86-1.91,1.88-1.93,1.91-1.96,1.93-1.98,1.95-2.01,1.98-2.04,2.01-2.07,2.04-2.1,2.08-2.13,2.11-2.17,2.15-2.21,2.19-2.25,2.23-2.29,2.28-2.34,2.32-2.39,2.37-2.44,2.43-2.49,2.5-2.46h3.01s2.99,0,2.99,0h2.97s2.96,0,2.96,0h2.94s2.93,0,2.93,0h2.92s2.92,0,2.92,0h2.91s2.91,0,2.91,0h2.91s2.91,0,2.91,0h2.91s2.91,0,2.91,0h2.92s2.92,0,2.92,0h2.93s2.94,0,2.94,0h2.96s2.97,0,2.97,0h2.99s3.01,0,3.01,0l2.5,2.46,2.43,2.49,2.37,2.44,2.32,2.39,2.28,2.34,2.23,2.29,2.19,2.25,2.15,2.21,2.11,2.17,2.08,2.13,2.04,2.1,2.01,2.07,1.98,2.04,1.95,2.01,1.93,1.98,1.91,1.96,1.88,1.93,1.86,1.91,1.84,1.89,1.82,1.87,1.81,1.86,1.79,1.84,1.78,1.83,1.77,1.81,1.75,1.8,1.74,1.79,1.73,1.78,1.73,1.77,1.72,1.76,1.71,1.76,1.71,1.75,1.7,1.75,1.7,1.75,1.7,1.74,3.19,4.08-28.51,27.45-16.4,25.9-5.77,8.87-7.53,11.33.49.77-2.18,4.79-23.72,22.81-9.36,9.22h-19.71l-32.66-31.32-10.28-17.1-23.23-35.69-26.75-25.62,5.22-5.49Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    },
    6130: {
        grass: 'M120.5,217.3l8.5.6,33.8-41.3,53-64.2-31.9-37.7-34.2-27.2-49.2.3-40,22.9-26.1,41.7,86,105Z',
        outfield: 'M225.8,109.8s-92.3,113.7-93.5,114.3-13.6.6-14.7,0S25.2,110.5,25.2,110.5l1.4-3,1.5-1.6,1.3-2.1,1.3-2.1,1.3-2.1,1.3-2.2,1.4-2.2,1.4-2.2,1.4-2.2,1.4-2.3,1.4-2.3,1.4-2.3,1.5-2.4,1.5-2.4,1.5-2.4,1.5-2.5,1.6-2.5,1.6-2.6,1.6-2.6,1.7-2.7,1.8-2.6,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.4-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.5-1.4,2.6-1.5,2.6-1.5,2.6-1.5,2.6-1.5,2.7-1.5,2.7-1.5,2.9-.3h3s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s2.9,0,2.9,0h2.9s3,0,3,0h3c0,0,2.6,2.2,2.6,2.2l2.6,2.1,2.5,2,2.5,2,2.4,2,2.4,1.9,2.4,1.9,2.3,1.9,2.3,1.8,2.3,1.8,2.2,1.8,2.2,1.8,2.2,1.7,2.2,1.7,2.1,1.7,2.1,1.7,2,1.8,1.8,2.2,1.8,2.2,1.8,2.1,1.7,2.1,1.7,2.1,1.7,2,1.7,2,1.7,2,1.6,2,1.6,2,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.6,1.9,1.5,1.9,1.5,1.9,3.5,3.9Z',
        infield: 'M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z',
        hasTransform: false
    }
};

});

parcelRegister("3qPhl", function(module, exports) {
"use strict";
function $27fb93b0fc61227d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $27fb93b0fc61227d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $27fb93b0fc61227d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $27fb93b0fc61227d$var$_reactDom = $27fb93b0fc61227d$var$_interopRequireDefault((parcelRequire("f3ft4")));

var $27fb93b0fc61227d$var$_react = $27fb93b0fc61227d$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $27fb93b0fc61227d$var$THREE = $27fb93b0fc61227d$var$_interopRequireWildcard((parcelRequire("h8GDa")));


var $7zGXF = parcelRequire("7zGXF");

var $27fb93b0fc61227d$var$_StadiumOutfields = $27fb93b0fc61227d$var$_interopRequireDefault((parcelRequire("8Jl6x")));

var $27fb93b0fc61227d$var$_Stadiums = $27fb93b0fc61227d$var$_interopRequireDefault((parcelRequire("2U8Vm")));
function $27fb93b0fc61227d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27fb93b0fc61227d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27fb93b0fc61227d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $27fb93b0fc61227d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $27fb93b0fc61227d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $27fb93b0fc61227d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $27fb93b0fc61227d$var$Infield(props) {
    var mesh = (0, $27fb93b0fc61227d$var$_react.useRef)();
    var stadiums = new $27fb93b0fc61227d$var$_Stadiums["default"]();
    var _ref = $27fb93b0fc61227d$var$_StadiumOutfields["default"][props.id] || {}, infield = _ref.infield, hasTransform = _ref.hasTransform;
    var fieldPath = (0, $7zGXF.transformSVGPath2)(infield, hasTransform);
    var extrudeSettings = {
        depth: 2,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1
    };
    return /*#__PURE__*/ $27fb93b0fc61227d$var$_react["default"].createElement("mesh", {
        ref: mesh,
        position: props.position || [
            0,
            0,
            0
        ],
        geometry: new $27fb93b0fc61227d$var$THREE.ExtrudeGeometry(fieldPath, extrudeSettings),
        material: new $27fb93b0fc61227d$var$THREE.MeshBasicMaterial({
            color: 0xffffff,
            wireframe: false,
            flatShading: false,
            wireframeLinewidth: 0.4,
            transparent: true,
            opacity: 1,
            side: $27fb93b0fc61227d$var$THREE.DoubleSide
        })
    });
}
var $27fb93b0fc61227d$var$_default = module.exports["default"] = $27fb93b0fc61227d$var$Infield;

});
parcelRegister("2U8Vm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $21d7bbe4847c951e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21d7bbe4847c951e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21d7bbe4847c951e$var$_typeof(o);
}
function $21d7bbe4847c951e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $21d7bbe4847c951e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $21d7bbe4847c951e$var$_toPropertyKey(o.key), o);
    }
}
function $21d7bbe4847c951e$var$_createClass(e, r, t) {
    return r && $21d7bbe4847c951e$var$_defineProperties(e.prototype, r), t && $21d7bbe4847c951e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $21d7bbe4847c951e$var$_toPropertyKey(t) {
    var i = $21d7bbe4847c951e$var$_toPrimitive(t, "string");
    return "symbol" == $21d7bbe4847c951e$var$_typeof(i) ? i : i + "";
}
function $21d7bbe4847c951e$var$_toPrimitive(t, r) {
    if ("object" != $21d7bbe4847c951e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $21d7bbe4847c951e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/* eslint-disable class-methods-use-this */ var $21d7bbe4847c951e$var$Stadiums = /*#__PURE__*/ function() {
    function Stadiums() {
        $21d7bbe4847c951e$var$_classCallCheck(this, Stadiums);
        this.ids = [
            {
                name: 'Progressive Field',
                id: 5
            },
            {
                name: 'Wrigley Field',
                id: 17
            },
            {
                name: 'Chase Field',
                id: 15
            },
            {
                name: 'GABP',
                id: 2602
            },
            {
                name: 'Coors Field',
                id: 19
            },
            {
                name: 'Comerica Park',
                id: 2394
            },
            {
                name: 'Petco Park',
                id: 2680
            },
            {
                name: 'Tropicana Field',
                id: 12
            },
            {
                name: 'Marlins Park',
                id: 4169
            },
            {
                name: 'Target Field',
                id: 3312
            },
            {
                name: 'Oracle Park',
                id: 2395
            },
            {
                name: 'Busch Stadium',
                id: 2889
            },
            {
                name: 'Angel Stadium',
                id: 1
            },
            {
                name: 'Truist Park',
                id: 4705
            },
            {
                name: 'Citi Field',
                id: 3289
            },
            {
                name: 'Citizens Bank Park',
                id: 2681
            },
            {
                name: 'T-Mobile Park',
                id: 680
            },
            {
                name: 'Rogers Centre',
                id: 14
            },
            {
                name: 'American Family Field',
                id: 32
            },
            {
                name: 'Globe Life Park',
                id: 13
            },
            {
                name: 'Oriole Park',
                id: 2
            },
            {
                name: 'Rate Field',
                id: 4
            },
            {
                name: 'Dodger Stadium',
                id: 22
            },
            {
                name: 'Fenway Park',
                id: 3
            },
            {
                name: 'Daikin Park',
                id: 2392
            },
            {
                name: 'Kauffman Stadium',
                id: 7
            },
            {
                name: 'Yankee Stadium',
                id: 3313
            },
            {
                name: 'Oakland Coliseum',
                id: 10
            },
            {
                name: 'PNC Park',
                id: 31
            },
            {
                name: 'Nationals Park',
                id: 3309
            }
        ];
    }
    return $21d7bbe4847c951e$var$_createClass(Stadiums, [
        {
            key: "getInfield",
            value: function getInfield() {
                // return "M77,28.8 C76.8,29 71,0.7 39.9,0.7 C6.5,0.7 0.9,26.2 0.4,28.8 L0,29.2 L14.8,44 L15.5,43.3 L33.7,61.2 C33,62.2 32.6,63.4 32.6,64.8 C32.6,66 33,67.2 33.6,68.2 C33.6,68.2 33.6,68.2 33.6,68.3 C34.7,70.1 36.7,71.3 39,71.3 C42.5,71.3 45.4,68.4 45.4,64.9 C45.4,63.4 44.9,62.1 44.1,61 L62.8,43.3 L64.3,43.8 L77.8,30.3 L77,28.8 Z M42.6,59.7 C41.6,59 40.3,58.5 38.9,58.5 C37.4,58.5 36.1,59 35,59.8 L17.4,41.6 C17.4,41.6 23.6,36 20.1,31.4 L37.5,16.9 C38,16.6 38.6,16.5 39.3,16.5 C40.2,16.5 41,17 41.6,17.6 C41.6,17.6 41.7,17.6 41.7,17.7 L57.9,33.2 C57.4,34.2 58,39.5 60.9,42.1 L42.6,59.7 Z";
                // return "M163,165.8c-0.2,0.2-6-28.1-37.1-28.1c-33.4,0-39,25.5-39.5,28.1l-0.4,0.4l14.8,14.8l0.7-0.7l18.2,17.9c-0.7,1-1.1,2.2-1.1,3.6c0,1.2,0.4,2.4,1,3.4c0,0,0,0,0,0.1c1.1,1.8,3.1,3,5.4,3c3.5,0,6.4-2.9,6.4-6.4c0-1.5-0.5-2.8-1.3-3.9l18.7-17.7l1.5,0.5l13.5-13.5L163,165.8z M128.6,196.7c-1-0.7-2.3-1.2-3.7-1.2c-1.5,0-2.8,0.5-3.9,1.3l-17.6-18.2c0,0,6.2-5.6,2.7-10.2l17.4-14.5c0.5-0.3,1.1-0.4,1.8-0.4c0.9,0,1.7,0.5,2.3,1.1c0,0,0.1,0,0.1,0.1l16.2,15.5c-0.5,1,0.1,6.3,3,8.9L128.6,196.7z";
                return 'M87.4 82.3L97.5 92.3L94.7 95.1L88.8 89.1C85.3 101.3 68 151.1 -0.4 151.3C-69.3 151.6 -84.8 103.1 -90.3 86.8L-96.5 93L-99.2 90.3L-91.7 82.7C-91.7 82.7 -91.7 82.7 -91.7 82.7C-91.7 82.7 -91.7 82.7 -91.7 82.7L-88.5 79.5C-88.9 79.8 -84.8 69.2 -81.2 63.5C-73.6 52.1 -65.1 46.6 -58.5 49.3C-58.3 49.3 -58.1 49.3 -57.8 49.3L-14.4 6.3C-15.7 4.1 -16.4 1.3 -16.4 -1.7C-16.4 -10.8 -9.1 -18.1 0 -18.1C9.2 -18.1 16.5 -10.8 16.5 -1.7C16.5 1.5 15.6 4.7 14 7.3L55.6 50.3C56.3 50.3 62 49.8 63.4 49.8C73 50.7 82.6 64 85.6 73.4C85.8 74.3 86.5 79.8 86.3 80.7L87.4 82.3ZM11.7 10.5C8.7 13.2 4.8 14.8 0.5 14.8C-3.9 14.8 -7.7 13.2 -10.7 10.5L-53.5 53.2C-48 55.7 -45 62.1 -45 68.5C-45 70.6 -45.5 72.7 -46.2 74.5L-7.3 113.8C-5.5 112.2 -2.7 111.1 -0.4 111.1C2.5 111.1 5.1 112 7.6 113.4L45.3 75.6C44.2 73.6 43.7 71.1 43.7 68.5C43.7 61.9 47.8 56.4 53.8 53.9L11.7 10.5Z';
            /*        if (id===1) { return "M133.2,138.54C96,128.44,86.31,168.31,86.31,168.31s0,0,0,0l0,0L99,181l1.29-1.29,20,20a5.52,5.52,0,1,0,9.75-.55l19.55-19.55,1,1L163,168.15l-.39-.39.39-.52C162.83,167.44,159,145.54,133.2,138.54Zm15.15,39.84-19.69,19.69h-7l-19.92-19.92,3.64-3.64-.08-.08c.59-.71,1.1-2.08,0-4.22l16.52-16.52H128L144.38,170c-.45,1-1.47,2.8-.19,4.2Z" }
      if (id===2) { return "M-2.8 156.9C-80.3 156.5 -93.7 88.8 -93.7 88.8C-93.7 88.8 -92.5 89.9 -92.5 89.9L-93.7 88.8L-14.5 9.6C-16.8 5 -16.1 -1.1 -12.2 -5.1C-7.3 -10.2 1.1 -10.4 6.3 -5.5C10.7 -1.3 11.4 5.2 8.6 10.3L87.3 89C86.6 88.5 82.6 157.4 -2.8 156.9ZM51.8 59.4L5.1 12.9L-11.5 13.1L-57.7 61.2L-54.4 64.3C-53 65.9 -51.9 69.4 -54.4 74.5L-11.5 118.2L3.5 117.9L48.3 73.4C47.1 71 44.8 66.8 47.6 63.6L51.8 59.4Z" }
      if (id===4) { return "M94 89.8C93.6 89.3 75.6 156.7 4.1 156.7C-72.7 156.7 -85.6 93.5 -86.8 87.5L-87.7 86.6L-53.6 52.5L-52 54.1L-10.2 13C-11.8 10.7 -12.7 7.9 -12.7 4.7C-12.7 1.9 -11.8 -0.8 -10.4 -3.1C-10.4 -3.1 -10.4 -3.1 -10.4 -3.4C-7.9 -7.5 -3.3 -10.3 2 -10.3C10.1 -10.3 16.7 -3.6 16.7 4.5C16.7 7.9 15.6 10.9 13.8 13.4L56.8 54.1L57.9 53L93.6 88.6L93.3 88.9L94 89.8ZM10.3 16.7C8 18.3 5 19.4 1.8 19.4C-1.7 19.4 -4.6 18.3 -7.2 16.4L-47.7 58.3C-47.7 58.3 -38.2 67.3 -46.3 77.6L-1.4 122.5C-0.3 123.1 1.1 123.4 2.7 123.4C4.8 123.4 6.6 122.2 8 120.8C8 120.8 8.2 120.8 8.2 120.6L51.5 75.8C50.3 73.5 45.7 63.1 52.6 57.1L10.3 16.7Z" }
      if (id===5) { return "M164.46,167.69c-.16.2-7.35-28.72-38.62-28.72-33.55,0-39,24.95-39.5,27.61h0l10.48,11.3v2.21l4.5,5,2.37.25,16.64,16.74a6.42,6.42,0,0,0-.13,7l0,.05a6.41,6.41,0,1,0,10.51-7.34l16.87-17.05,1.82,0,4.32-4.67.12-3.07,10.24-8.85.32-.48Zm-35.1,32.74a6.41,6.41,0,0,0-7.63.16l-20.06-21.22L105,176l.85-4.83,17.23-16.83h4.3L145.81,172l.64,5.11,2.85,3.24Z" }
      if (id===7) { return "M165.41,168c-.17.2-7-30.75-40.33-30.54-35.75.23-39.8,28-40.28,30.74h0L95.49,179.1l.26,3.14,4.21,3.91,2.5.14,17.19,15.49a6.29,6.29,0,0,0-.09,7.11l0,.05a6.91,6.91,0,0,0,5.79,3,6.69,6.69,0,0,0,6.79-6.58c0-1.49.08-1.9-.81-3l16.23-16,3.13-.82,3.6-3.64.78-3.46,10.23-10.2h0Zm-34.65,31.29c-.2-.12-4-.09-5.43-.09l-4.87,0-19.66-19.07,3.76-3.65c2.09-2.11.13-4.83.13-4.83l17.93-17.27,5.35,0,17.18,17.3s-2,2.06,1.4,5.38h0l3,2.88Z" }
      if (id===10) { return "M125.13,139.71c-26.78.18-37.93,29.52-37.93,29.52L90.88,173l.88,1,27.42,27.31a8.19,8.19,0,1,0,12.46-.32l26.61-26.61,1-1,3.34-4.09S151.45,139.53,125.13,139.71ZM101,178l.12.36-.26-.22Zm27.83,20.88a8.15,8.15,0,0,0-6.66.08l-18.21-18.21-.13-.11a8.1,8.1,0,0,0,1.59-7l16.85-16.51a8.09,8.09,0,0,0,5.86,0l18.32,17.53a8.15,8.15,0,0,0,.87,5.71l-.45.43Z" }
      if (id===12) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===13) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-43.59,26.67-17.67-17.71c1.14-1.37,3.31-3.3,3.31-5.2a7.76,7.76,0,0,0-.49-2.69l14.58-14.19c1.34.94,2.9,1,4.68,1s3.36,0,4.67-.83l14.54,14.16a7.75,7.75,0,0,0-.46,2.6c0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66Z" }
      if (id===14) { return "M131.25,152.62l-6.08-6.08-6.09,6.09A8.61,8.61,0,0,0,131.25,152.62ZM148.63,182.16l6.08-6.08L148.63,170A8.61,8.61,0,0,0,148.63,182.16ZM101.72,170l-6.08,6.08,6.09,6.09A8.61,8.61,0,0,0,101.72,170Z" }
      if (id===15) { return "M133.32,203.44a7.77,7.77,0,0,0-1.1-4l32.12-31s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a7.76,7.76,0,0,0,.51,2.76l-5.16,3.55,2.83,3.83,4.11-4.61a8.29,8.29,0,0,0,11.78,0l4.77,4.65,3.5-4.17-6.71-2.76A7.76,7.76,0,0,0,133.32,203.44Zm-30.24-26c1.14-1.37,3.31-3.3,3.31-5.2a7.76,7.76,0,0,0-.49-2.69l14.58-14.19,9.35.12,14.54,14.16a7.75,7.75,0,0,0-.46,2.6c0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66-8.6.05Z" }
      if (id===16) { return "M164.3,168.5c0,0-12-31-38.8-30.8c-27.3,0.2-39.4,30.1-39.4,30.1l32.5,31.2c-1.2,1.1-1.6,3.3-1.6,4.5c0,4.4,3.7,8,8.2,8c4.5,0,8.2-3.6,8.2-8c0-1.4-0.4-2.8-1.1-4L164.3,168.5z M125.1,195.5c-1.2,0-2.3,0.2-3.3,0.7l-18.3-17.9    c1.1-1.4,1.8-3.1,1.8-5c0-0.9-0.2-1.8-0.5-2.7l15.6-15.2c1.3,0.9,3,1.5,4.8,1.5c1.7,0,3.3-0.5,4.6-1.4l15.5,15.2    c-0.3,0.8-0.5,1.7-0.5,2.6c0,1.9,0.7,3.6,1.8,5l-18.4,17.9C127.4,195.7,126.3,195.5,125.1,195.5z" }
      if (id===17) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19,9.35.12,15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===19) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67L103,177.45l3.5-4.25-.22-4,14.21-13.85a8.32,8.32,0,0,0,9.35.12L144.71,170l-.58,3.92,3.13,3.53-18.9,18.66A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===22) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===31) { return "M170.64,162.24l-2-2-5.57,5.47c-3.7-7.63-15.71-28.17-37.56-28-22.15.15-34.29,19.88-38.07,27.31L80,157.52l-2,2,40.58,39.39c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-42.29,33.87a8.35,8.35,0,0,0-6.47,0L103,177.45l3.5-4.25-.22-4,14.21-13.85,9.35.12L144.71,170l-.58,3.92,3.13,3.53Z" }
      if (id===32) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-19.13-18.69,3-3.53c.76-1,0-3-.35-3.89l15-14.66a8.32,8.32,0,0,0,9.35.12L145,170.26c-.81,1.32-1.17,2.94-.47,3.95l2.93,3.27-19.09,18.63A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===680) { return "M152.36,183.51l12.72-12.7-.75-2.3h0l-.1-.26-.07-.23h0c-1.61-3.83-13.72-30.53-38.63-30.36-26.22.17-38.39,27.77-39.32,29.94h0v0l-.05.12,0,0-.67,2.69,13.59,11.76,1.08-1,18.45,17.7c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4l18.19-17.54Zm-24,12.6a8.35,8.35,0,0,0-6.47,0l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55Z"}
      if (id===2392) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.17,31.46c-1.2,1.06-1.33,3-1.33,4.23a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-34.51-13,15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9a8.35,8.35,0,0,0-6.47,0l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19m.43,0,8.92.12" }
      if (id===2394) { return "M165,170.72l-.67-2.43,0,0c-1-2.41-13.06-30.82-38.75-30.65-27.29.18-39.38,30.1-39.38,30.1l-.58,2.45,17.69,15.89.89-1.07,13.94,13.37v9.44l7.17,5,7.17-5v-8.55L146.5,185.7l1.39,1.54Zm-36.17,25h-2.55V178.91h-1.92v16.76h-2.94l-18.64-18.22,3-3.53c.76-1,0-3-.35-3.89l15-14.66a8.32,8.32,0,0,0,9.35.12L145,170.26c-.81,1.32-1.17,2.94-.47,3.95l2.93,3.27Z" }
      if (id===2395) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-19.13-18.69,3-3.53c.76-1,0-3-.35-3.89l15-14.66a8.32,8.32,0,0,0,9.35.12L145,170.26c-.81,1.32-1.17,2.94-.47,3.95l2.93,3.27-19.09,18.63A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===2602) { return "M147.75,184l.51.54,16.24-16.71c-3.7-7.63-17.12-30.32-39-30.17-22.15.15-35.91,22.68-39.69,30.11l16.72,16.54.57-.52,15.48,15.12c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-19.4,12.11a8.35,8.35,0,0,0-6.47,0L103,177.45l3.5-4.25-.22-4,14.21-13.85,9.35.12L144.71,170l-.58,3.92,3.13,3.53Z" }
      if (id===2680) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-19.13-18.69,3-3.53c.76-1,0-3-.35-3.89l15-14.66a8.32,8.32,0,0,0,9.35.12L145,170.26c-.81,1.32-1.17,2.94-.47,3.95l2.93,3.27-19.09,18.63A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===2681) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===2889) { return "M147.75,184l.51.54,16.24-16.71c-3.7-7.63-17.12-30.32-39-30.17-22.15.15-35.91,22.68-39.69,30.11l16.72,16.54.57-.52,15.48,15.12c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-19.4,12.11a8.35,8.35,0,0,0-6.47,0L103,177.45s2.5-3.12,3.5-4.25-.22-4-.22-4l14.21-13.85,9.35.12L144.71,170s-1.88,2.27-.58,3.92,3.13,3.53,3.13,3.53Z" }
      if (id===3289) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z"}
      if (id===3309) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67L103,177.45s2.42-3,3.5-4.25-.22-4-.22-4l14.21-13.85a8.32,8.32,0,0,0,9.35.12L144.71,170c-.37,1.33-1.67,2.75-.58,3.92l3.13,3.53-18.9,18.66A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===3312) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67L103,177.45s2.42-3,3.5-4.25-.22-4-.22-4l14.21-13.85a8.32,8.32,0,0,0,9.35.12L144.71,170c-.37,1.33-1.67,2.75-.58,3.92l3.13,3.53-18.9,18.66A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===3313) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67L103,177.45s2.42-3,3.5-4.25-.22-4-.22-4l14.21-13.85a8.32,8.32,0,0,0,9.35.12L144.71,170c-.37,1.33-1.67,2.75-.58,3.92l3.13,3.53-18.9,18.66A8.32,8.32,0,0,0,125.15,195.47Z" }
      if (id===4169) { return "M147.75,184l.51.54,16.24-16.71c-3.7-7.63-17.12-30.32-39-30.17-22.15.15-35.91,22.68-39.69,30.11l16.72,16.54.57-.52,15.48,15.12c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-19.4,12.11a8.35,8.35,0,0,0-6.47,0L103,177.45s2.5-3.12,3.5-4.25-.22-4-.22-4l14.21-13.85,9.35.12L144.71,170s-1.88,2.27-.58,3.92,3.13,3.53,3.13,3.53Z" }
      if (id===4705) { return "M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-39.19,27a8.31,8.31,0,0,0-3.27.67l-18.33-17.88a7.71,7.71,0,0,0,1.36-7.7l15.58-15.19a8.32,8.32,0,0,0,9.35.12l15.54,15.16a7.7,7.7,0,0,0,1.33,7.55l-18.36,17.9A8.32,8.32,0,0,0,125.15,195.47Z" } */ }
        },
        {
            key: "getStadiums",
            value: function getStadiums(id) {
                if (id === 1) return 'M3.3 -50.8C-27.9 -50.8 -56.1 -10.8 -56.1 -10.8L-225.6 214.3L-233.307549 233.307549L-235.5476084 243.9166888L-235.7462367 252.8068878L-234.7231879 260.68651L-232.7387775 267.7353368L-229.8899032 273.9721181L-226.5575434 279.7752661L-222.725143 285.0751831L-218.3428836 289.7507931L-213.9340235 294.4549221L-209.482217 299.1716107L-204.9980494 303.9221067L-200.4785788 308.7099395L-195.9206375 313.5385612L-191.3209362 318.4115086L-186.67595 323.33223L-181.9822599 328.3046875L-177.236125 333.3326709L-172.4337182 338.4202269L-167.571097 343.5716639L-162.6440464 348.791283L-157.648235 354.0837332L-152.1318291 358.4001295L-145.5083642 360.1458392L-138.9142041 361.8838741L-132.3451049 363.6151872L-125.797028 365.3410971L-119.2658197 367.0624499L-112.7475052 368.7804725L-106.2380791 370.4962117L-99.73351201 372.2105341L-93.22990056 373.9247076L-86.72324295 375.6396346L-80.20958588 377.3564328L-73.68491963 379.0760492L-67.14527018 380.79975L-60.58653643 382.5283362L-54.00466051 384.2631263L-47.39546294 386.0050693L-40.75472798 387.7553352L-34.07815688 389.5151155L-27.36134204 391.2854209L-20.5997935 393.0674754L-13.78890632 394.8626137L-6.923935092 396.6719757L0 398.4969L6.987938302 400.3387172L14.04508956 402.198742L21.07560061 402.146416L27.86094488 398.4300744L34.53816489 394.7730312L41.11378325 391.1715179L47.59403685 387.622324L53.98484226 384.1221121L60.29186083 380.6678276L66.52048404 377.2564118L72.67590259 373.8851065L78.76308188 370.5511665L84.78681928 367.2520622L90.75167685 363.9850952L96.66213229 360.7479889L102.52246 357.5383079L108.3368441 354.3538502L114.109284 351.1922649L119.8437538 348.0515335L125.5440685 344.9294934L131.2139878 341.8241248L136.857162 338.7333625L142.4772146 335.6552831L148.0776811 332.5879172L153.6620982 329.529433L159.2338477 326.4777696L164.7964177 323.4311805L170.3532024 320.3877763L175.9075469 317.3456151L181.4629 314.3029625L187.0226344 311.2579332L192.590148 308.2086637L198.1688191 305.1532215L203.7621772 302.0898507L209.2953458 298.9047309L213.8705427 294.3675482L218.42124 289.8547754L222.9502904 285.3633586L226.8373392 280.1207852L230.1830144 274.3214343L233.0313798 268.0719372L234.8721364 260.851934L235.6954278 252.7524019L235.6054039 243.9765379L233.3799567 233.3799567L232.9 232.8C232.9 232.8 68.4 -10.1 68.4 -10.1C68.4 -10.1 39.5 -50.8 3.3 -50.8Z';
                if (id === 2) return 'M227.722 215.38 130.922 363l-163.108 44.528-69.938-47.916-15.246 22.264-120.274-81.554-9.68-23.232 12.826-40.172-1.936-2.42 2.178-8.712L-61.952-18.392C-16.214-83.248 32.67-66.308 58.08-23.474';
                if (id === 3) return 'M-46.4 -47.4L-124.2 60.1L-134.2 130.5L-218.1 217.2L-218.3442503 218.3442503L-214.488762 222.109615L-210.6325337 225.8757385L-206.7732679 229.6449791L-202.9084295 233.4194469L-199.0358408 237.2016784L-195.1529455 240.9938175L-191.2574537 244.7983774L-187.3468222 248.6176302L-183.4186231 252.4540767L-179.4703462 256.3102172L-175.4993376 260.1884679L-171.5030197 264.0914912L-167.4786518 268.0218694L-163.4234353 271.9822703L-159.3346 275.9756226L-155.2091819 280.0047763L-151.0440718 284.0725832L-146.8361449 288.1821605L-142.5821882 292.3368081L-138.2787512 296.5397389L-133.9223105 300.7944342L-129.509161 305.1044634L-125.035477 309.4736653L-120.4972093 313.9059623L-115.8901054 318.4054476L-111.2097515 322.97657L-106.4514103 327.623753L-101.6101898 332.3519554L-96.68082241 337.1660965L-91.65786605 342.071813L-86.53541367 347.0745872L-81.30729887 352.1806034L-75.96691913 357.3962551L-70.50726295 362.7284228L-64.92083702 368.1843627L-59.19965104 373.7718864L-53.1658364 378.2945826L-46.45836081 378.3729849L-39.81293698 378.7947924L-33.29016438 380.50832L-26.72827414 382.2321281L-20.12287686 383.9673639L-13.46947471 385.7152894L-6.763435781 387.4769764L0 389.2537L6.825747853 391.0468326L13.71889095 392.8576359L20.68469812 394.6875521L27.72863778 396.5379946L34.85639666 398.4104369L42.07390854 400.3064999L49.38735642 402.2277399L56.80322281 404.1759317L64.32827676 406.1527548L71.96963331 408.160073L79.73480505 410.2000115L85.12742506 400.4930471L89.08633128 385.8752947L92.79514272 372.1809891L98.71016739 368.3913599L104.8035521 365.4934213L110.8616784 362.6122111L116.8885211 359.745877L122.8879789 356.892605L128.8638529 354.0505259L134.8198861 351.2178111L140.759851 348.3928567L146.6873425 345.5737229L152.6060836 342.7588756L158.519588 339.9463534L164.4315705 337.1346807L170.3455889 334.3220424L176.2652109 331.506647L182.1941217 328.6868964L188.13595 325.8610241L194.0943647 323.0272688L200.0730849 320.1838661L206.0758342 317.3289569L212.1065096 314.4608323L218.1689174 311.5775046L224.0193016 308.3361166L229.1865071 304.1407674L233.6409441 299.0467713L237.1793388 292.8920911L239.5157762 285.4437868L240.0653823 276.1636315L236.6103369 262.7824013L227.3487909 243.8017296L219.0562102 226.8393461L211.6685259 211.6685259L148 129.4L94 7.9L55.1 -45.3L22.4 -57.5L-18 -58.2L-46.4 -47.4Z';
                // if (id === 4) { return "M22.2,107.4l43.6-55.7c0,0,16.8-20.2,59.5-20.2c41,0,60.9,21.6,60.9,21.6l40.6,53.7l-10.1,10.7l-39.7,49.3l-5.1,13.2l-23.5,32.3c0,0-10.8,11.7-22.5,12c-11.6,0.3-21.3-11.8-21.3-11.8l-32-43.8l-37.7-50.2L22.2,107.4z" }
                if (id === 4) return 'M-234.6 230.8L-232.0522223 232.0522223L-228.7025142 236.8283863L-225.3300758 241.6369227L-221.9326894 246.4812223L-218.5078075 251.3644784L-215.0531439 256.2903568L-211.5661248 261.2624059L-208.0440795 266.2842787L-204.4843475 271.3598944L-200.8841329 276.4932886L-197.2404899 281.6886124L-193.5503641 286.9502153L-189.5724545 291.9159807L-185.0884519 296.2034405L-180.571834 300.5219985L-176.0195 304.8747171L-171.4281969 309.2646538L-166.7946549 313.6951218L-162.1153314 318.1692524L-157.3866832 322.6905211L-152.6050031 327.2624853L-147.7664463 331.8888723L-142.867008 336.5735787L-137.9023893 341.3203909L-132.8683218 346.1338121L-127.7601197 351.0180438L-122.5729591 355.9777212L-117.0281968 360.1757546L-111.3272511 364.1350308L-105.5122984 367.9651135L-99.4699307 371.2268352L-93.37723099 374.5156177L-87.22985522 377.8340134L-80.88652556 380.5411836L-74.45000646 383.0120797L-67.97372827 385.4981694L-61.4533398 388.0011173L-54.95382106 391.0167545L-48.48041696 394.8413107L-41.90764557 398.7246134L-34.98147386 399.8400759L-27.95868765 399.8278611L-20.95345372 399.8157145L-13.96144943 399.803602L-6.9783866 399.7915005L0 399.7794L6.977962506 399.7672042L13.9597568 399.7551315L20.94964366 399.7430143L27.95190035 399.7307981L34.97084958 399.7186397L41.9046247 398.6958717L48.48002698 394.8381345L54.95684111 391.0382433L61.47093868 388.1122322L68.01734869 385.7455531L74.52774205 383.4119947L81.00337193 381.0909025L87.43867728 378.7385211L93.54444741 375.1862861L99.58865099 371.6699054L105.5758328 368.1866843L111.5103928 364.7340601L117.3965759 361.309509L123.1467404 357.6441032L128.5464582 353.1784912L133.8795286 348.768096L139.123944 344.3438448L143.9491769 339.123009L148.7021439 333.9904836L153.3885796 328.9428706L158.0089949 323.9664492L162.5674605 319.0566058L167.0680282 314.2092622L171.5143961 309.4201612L175.8512 304.583213L180.1360603 299.7967492L184.3749686 295.0616285L188.5711901 290.3741687L192.7278473 285.7307839L196.8481062 281.1282305L200.9347999 276.5630258L204.9908952 272.0321059L209.0191641 267.5323301L213.0222463 263.0605662L217.0028473 258.6139228L220.9635676 254.1895073L224.906975 249.7845011L228.8354791 245.3960076L232.7516779 241.021418L236.6578916 236.6578916L235.9 232.2L212.7 207.6L121.4 94.2L109.7 63.8L55.6 -10.5C55.6 -10.5 30.8 -37.4 3.9 -38.1C-22.8 -38.8 -45.1 -10.9 -45.1 -10.9L-118.7 89.8L-205.4 205.3L-234.6 230.8Z';
                if (id === 5) return 'M196.9 185C196.9 185 53.5 -27 47.1 -29.3C47.1 -29.3 46.4 -30.5 46.4 -30.5C46.4 -30.5 32.7 -53.4 2.9 -53.4C-26.8 -53.4 -41.3 -30.5 -41.3 -30.5L-161.3 150.7L-233.2 223.7L-229.668424 229.668424L-226.9102956 234.9724896L-224.1196651 240.3389161L-221.2943388 245.7722622L-218.4317702 251.2770076L-215.5295781 256.858149L-212.5849945 262.5206052L-209.5953617 268.2698294L-206.5577206 274.1113535L-203.4690361 280.0511026L-200.3260443 286.0952409L-197.1253403 292.2503354L-192.8618019 296.9811316L-187.7217267 300.4175611L-182.5761047 303.857665L-177.4218 307.303572L-172.2556215 310.7573673L-167.074413 314.2212703L-161.874898 317.6973754L-156.6538143 321.1879173L-151.4078101 324.6950966L-146.1335207 328.2212613L-140.8274305 331.7686354L-135.486027 335.3396842L-130.1056274 338.9367473L-124.6824856 342.5623138L-119.2128028 346.2191185L-113.6925437 349.9096701L-108.1176238 353.6368129L-102.483733 357.4032506L-96.78652072 361.2122128L-91.02129881 365.0664898L-85.18331801 368.9694868L-79.26753801 372.924446L-73.26872705 376.934924L-67.18140637 381.0046885L-60.99977372 385.1374137L-54.71776956 389.3371608L-48.32903086 393.6083698L-41.82680326 397.9554501L-35.20396504 402.3831617L-28.45297505 406.8965002L-21.38822421 408.1116296L-14.1566109 405.3922954L-7.029368569 402.7122556L0 400.0691L6.937694569 397.4602557L13.78964618 394.8838008L20.56153068 392.3373774L27.25880003 389.8190017L33.88670186 387.3267746L40.45027838 384.8586907L46.9544056 382.4129455L53.40379456 379.9877429L59.80303441 377.5814991L66.15653482 375.1923532L72.46864586 372.8188631L78.74355897 370.4593185L84.98540607 368.1122361L91.19821629 365.7760671L97.38594563 363.449297L103.5525168 361.1305429L109.7017522 358.8182633L115.8374616 356.5110485L121.9634304 354.2075213L128.0833971 351.9062413L134.2010922 349.6057977L140.3202501 347.3048064L146.4446203 345.0019053L152.5779374 342.6956582L157.3615717 337.4629795L161.5530064 331.2327496L165.6605432 325.1271224L169.6891349 319.1388469L173.6434375 313.2610537L177.5278 307.4871694L181.3463998 301.8110924L185.1031306 296.2269314L188.8017358 290.729178L192.4457904 285.3126174L196.0386178 279.9721612L199.5834229 274.7030149L203.0833221 269.500671L206.5411883 264.3606656L209.9599733 259.278974L213.3422361 254.2513763L216.6907208 249.2741593L220.0078014 244.3434176L223.1399062 239.2882534L226.348317 234.3905438L229.5314574 229.5314574L233.3 223.7L196.9 185Z';
                if (id === 7) return 'M4.2 -55.7C-38.4 -55.7 -61.9 -30.5 -61.9 -30.5L-62.3 -21.4L-100.6 24.4L-110.5 24.4L-161.3 110.7L-229 228.2L-231.613109 231.613109L-235.0230718 243.3735153L-235.4938973 252.5362869L-234.6123129 260.5633709L-232.6639868 267.6492999L-229.5575178 273.5759965L-225.429109 278.3817657L-221.2107389 283.1368342L-217.0027018 287.9723117L-212.7537507 292.830416L-208.4532782 297.7021338L-204.1701643 302.6947165L-199.8347065 307.7184632L-195.5279674 312.9101576L-191.1130153 318.0654702L-186.6102 323.2183476L-181.9929257 328.3239292L-176.9720003 332.8359246L-171.8050322 337.1863611L-166.569682 341.5184588L-161.2830465 345.8726094L-155.8867806 350.1274419L-150.3832682 354.2807783L-144.8145927 358.4286947L-139.0893027 362.3400215L-133.314048 366.2773364L-127.4059858 370.0138499L-121.4489012 373.7812838L-115.352157 377.2999046L-109.1838983 380.7695038L-102.9208168 384.1057174L-96.53443269 387.1784621L-90.10173784 390.2735037L-83.59330707 393.2755894L-76.93344278 395.788252L-70.23382876 398.3158362L-63.44105869 400.5510804L-56.57642633 402.5621909L-49.67661331 404.5835482L-42.66351179 405.9162001L-35.61554061 407.0874919L-28.54845771 408.2619659L-21.44816458 409.25536L-14.31121218 409.8194969L-7.159048675 410.1416239L0 410.0718L7.15661232 410.0020452L14.3116589 409.8322891L21.43418565 408.9886261L28.54040782 408.146847L35.63470615 407.3065551L42.65037256 405.7911887L49.63631112 404.2553132L56.5992368 402.7244958L63.44656518 400.585847L70.19894284 398.1179883L76.88026431 395.5146725L83.51939446 392.9278579L89.99538098 389.8128215L96.3497979 386.4379324L102.6492638 383.092268L108.8982553 379.7733483L115.1011558 376.478917L121.262224 373.2067505L127.2248071 369.4876688L133.0547967 365.5650494L138.8345389 361.6763392L144.5681016 357.8186077L150.2595237 353.9892544L155.8251194 349.9889484L161.1826747 345.6573613L166.4939753 341.3632371L171.7628111 337.1034975L176.9928448 332.8751275L181.8953821 328.1479557L186.48665 323.0043527L191.0039817 317.8840079L195.5353862 312.9220302L200.0086098 307.9862507L204.435054 303.0874316L208.8234071 298.2307326L213.1767797 293.4126655L217.4830103 288.6097027L221.7253088 283.7954536L225.913434 278.9798572L229.9746226 274.0730827L232.650472 267.6337529L234.4681822 260.4032975L235.4595928 252.4994998L234.7611161 243.1022523L231.4683643 231.4683643L228.4 216.9C214.5 182.1 182.1 141.7 179 129C176 116.3 122.4 27.5 115.8 24.9C109.2 22.3 106.6 24.9 106.6 24.9L68.3 -19.5C68.3 -19.5 68.8 -29.8 68.8 -29.8C68.6 -30.1 46.7 -55.7 4.2 -55.7Z';
                if (id === 10) return 'M23 -63.8L-21.1 -64.3L-64.4 -25.6C-64.4 -25.6 -179.1 5.9 -189.2 157.1C-189.2 157.1 -238.9 220.9 -238.9 220.9L-233.0599909 233.0599909L-230.5556544 238.7473691L-228.0153079 244.5164816L-225.4366588 250.3727745L-222.8171312 256.3217883L-220.1541135 262.3694557L-217.4449212 268.5221149L-214.6865743 274.7862843L-211.8760201 281.1689753L-209.0100876 287.6777058L-206.0851532 294.3201008L-203.0976882 301.1047054L-200.043739 308.0403449L-195.1415502 312.2917609L-189.2640801 314.9883253L-183.2987 317.4826614L-177.3598911 319.9657134L-171.4440196 322.439305L-165.5472725 324.9048162L-159.6660378 327.3638907L-153.7966598 329.8180014L-147.9355267 332.2686331L-142.0790986 334.7173807L-136.4765243 337.791251L-131.0792773 341.4731919L-125.6373374 345.1857476L-120.1467276 348.9314331L-114.6034022 352.7130043L-109.0032177 356.53346L-103.3418196 360.3957544L-97.61463814 364.3027891L-91.81700411 368.2578895L-85.94403499 372.2645141L-79.99055092 376.3259543L-73.8577735 379.9653053L-67.53544027 383.0125146L-61.15062347 386.0898416L-54.69845234 389.1997116L-48.17383025 392.3443623L-41.57151339 395.5265293L-34.88599475 398.7487446L-27.93059672 399.4261421L-20.93536118 399.4704883L-13.95136347 399.514778L-6.97432717 399.558936L0 399.6031L6.975869963 399.6473225L13.95753719 399.6915703L20.94926684 399.7358241L27.95536027 399.7802773L34.91466027 399.076393L41.60250608 395.821405L48.20613781 392.6074863L54.73108843 389.4319295L61.18264561 386.2920214L67.56591553 383.1853484L73.88580334 380.1095063L80.00876398 376.41164L85.96047891 372.3357405L91.8313017 368.3152339L97.62636264 364.3465455L103.3506125 360.4264187L109.0087727 356.5516298L114.6053181 352.7189008L120.1446439 348.9253818L125.6309417 345.1681754L131.0682754 341.444531L136.460566 337.751753L142.1616601 334.9118834L148.0262696 332.4724451L153.8958906 330.0308024L159.774184 327.5856232L165.6647653 325.1354087L171.5711994 322.6784955L177.4971892 320.2134057L183.44655 317.7387451L189.4229179 315.2526757L195.2979824 312.5421047L199.9960831 307.9669612L203.0476405 301.0305065L206.032671 294.2451484L208.9551297 287.6020627L211.8187273 281.0929452L214.6267935 274.7097684L217.3827444 268.4453329L220.0895134 262.2924683L222.750082 256.244657L225.367203 250.2956361L227.9434935 244.4394701L230.4814649 238.6705436L233.2373333 233.2373333L238.8 222.3C238.8 222.3 191.6 157.3 191.6 157.3C181.8 6.1 66.9 -25.3 66.9 -25.3L23 -63.8Z';
                if (id === 12) return 'M226.2369762 226.2369762L195.6 157.9L178.7 144.9L162.5 94.4L108.2 47.6L108 27.4L35.6 -38.1L29.3 -32.3L10 -47.8L-18 -48.5L-40.1 -32.3L-47.3 -39.5L-119.5 28.1L-118.1 48.8L-172.6 98.9C-172.6 98.9 -186.5 126.8 -190.2 132.2C-194 137.6 -221 156.4 -221 156.4L-221.4873399 221.4873399L-223.5389796 231.4813897L-225.5980329 241.9242716L-226.7100812 251.7870534L-223.9654969 257.642832L-219.7480646 261.8855454L-215.5173128 266.1417168L-211.2705766 270.4140066L-207.0051099 274.7050591L-202.718258 279.0177452L-198.4071443 283.3547677L-194.0689037 287.7189818L-189.7007169 292.1134876L-185.2994657 296.5411332L-180.862161 301.0051837L-176.3855 305.5086477L-171.8663194 310.0550477L-167.3011209 314.6476457L-162.686406 319.2900495L-158.0185075 323.985953L-153.2936596 328.7393139L-148.5077645 333.5539002L-143.6567537 338.4341031L-138.7361887 343.3841168L-133.7415928 348.4087609L-128.6681147 353.5127398L-123.5106931 358.7010984L-118.2640484 363.9793149L-112.9225189 369.3529165L-107.4801838 374.8279453L-101.9307563 380.4107614L-95.89210587 384.6022299L-89.1657165 386.2191499L-83.42342243 392.476345L-78.31858252 402.9141782L-72.01059692 408.3923891L-64.60902969 407.9253591L-57.26504091 407.4619383L-49.97353578 407.0017876L-42.72957378 406.5447379L-35.52829771 406.090301L-28.36499819 405.6383724L-21.2350264 405.1884413L-14.13384596 404.7403928L-7.056974786 404.2938147L0 403.8485L7.04144738 403.4042502L14.07169345 402.9605777L21.09504342 402.5174068L28.11577923 402.0743754L35.1381886 401.6313336L42.16654167 401.1878452L49.20513738 400.7436849L56.25830445 400.2986361L63.33039695 399.8523897L70.30804599 398.736743L77.06521547 396.4661638L83.79109346 394.2061012L90.48998087 391.955169L96.28684982 386.1854614L101.9544641 380.4992402L107.5085744 374.9269552L112.95582 369.4618396L118.3024901 364.0976263L123.5545146 358.8283652L128.7175024 353.6484314L133.7967815 348.5525323L138.797362 343.5355259L143.7240767 338.5927061L148.5814245 333.7193433L153.3738303 328.9112404L158.1054365 324.1641839L162.780155 319.4740424L167.4019164 314.8372145L171.9742865 310.2498255L176.50085 305.7084398L180.9849461 301.2095324L185.4299848 296.7500075L189.8390553 292.32651L194.2152445 287.935941L198.5616085 283.5753653L202.8810157 279.241762L207.1763263 274.9322709L211.4504113 270.6441846L215.7059831 266.3747052L219.9457218 262.1211041L224.1722211 257.880641L228.3882608 253.6508607L227.2031161 243.6455125L225.886786 233.9126144Z';
                if (id === 13) return 'M-235.5 219.2L-234.9519258 234.9519258L-233.1971623 241.4827306L-231.4051808 248.1516752L-229.5738264 254.9675647L-227.700441 261.9393936L-225.7825547 269.0771707L-222.938133 275.3056666L-218.5361823 279.7135579L-214.1151331 284.1403786L-209.6722865 288.5891444L-205.2047134 293.0627024L-200.7094313 297.5639688L-196.1834465 302.0960157L-191.6236282 306.6619088L-187.0267547 311.2647905L-182.38965 315.9081406L-177.7088086 320.5951772L-172.9807878 325.3295456L-168.2018912 330.1147987L-163.3683452 334.9547457L-158.4762273 339.8533662L-153.5214037 344.8147183L-148.4996316 349.8432085L-143.4063716 354.9432251L-138.2369604 360.1195938L-132.9863927 365.3771109L-126.8675938 368.4502459L-120.6073243 371.1911764L-114.325406 373.9415536L-108.0178971 376.7031746L-101.6807371 379.477677L-95.30987244 382.2670192L-88.90110658 385.0729983L-82.45014622 387.8974404L-75.95258914 390.7421975L-69.40394676 393.6093415L-62.79958352 396.5009656L-56.05484729 398.8509632L-48.97307378 398.8536785L-41.92148514 398.8562881L-34.89564289 398.8590233L-27.89112153 398.8616206L-20.90359325 398.8643201L-13.92874162 398.8669729L-6.962295481 398.869641L0 398.8722L6.962386234 398.8748402L13.92911155 398.8775665L20.9044254 398.8801984L27.89260735 398.8828687L34.89796123 398.8855221L41.9248405 398.8882122L48.97763169 398.8907997L56.06083174 398.8935448L63.17895274 398.8962086L70.33664585 398.8989409L77.41620862 398.271867L83.38456373 392.2935292L89.21889493 386.4494909L94.92710362 380.7318173L100.516569 375.1329426L105.9943055 369.6460718L111.3668675 364.2646101L116.6404113 358.9822737L121.9977128 354.3070844L128.9694345 354.340609L136.0316357 354.3745266L141.3347597 349.8158057L146.3565495 344.7944235L151.3080242 339.8433866L156.1935816 334.9582166L161.0174922 330.1347828L165.7837562 325.3689415L170.4962504 320.6568104L175.1587585 315.994765L179.7748 311.3790875L184.3478872 306.8064062L188.881349 302.2733447L193.3784465 297.7766945L197.8422815 293.3132445L202.2759174 288.8799482L206.6823993 284.4739176L211.0645328 280.0920952L215.4252449 275.7317396L219.7673652 271.3900944L224.0935017 267.0642357L228.4064917 262.7516121L229.178504 254.5285147L229.1462658 245.7292855L229.1152108 237.2557461L229.085273 229.085273L229.3 207.1L200.3 177.4L196.4 171.8C196.4 171.8 58.1 -32.5 43.8 -50.6C22.8 -77.2 -8.4 -81.4 -34 -51.8C-61.8 -19.9 -177.2 130.7 -195.8 158.8C-195.8 158.8 -194.1 167 -194.1 167L-235.5 219.2Z';
                if (id === 14) return 'M217.7 199.2C206.1 150.4 187.5 59.2 150.3 10.2C150.3 10.2 160.4 -0.5 160.4 -0.5L107.2 -58.7L88.4 -44.2C88.4 -44.2 43.2 -55.8 6.2 -57.3C-28.9 -58.5 -70.5 -47.6 -70.5 -47.6L-86.7 -58.5L-156.5 -3.6C-156.5 -3.6 -149.7 10.6 -149.7 10.6C-190.6 63.8 -212.6 163.2 -222.3 207.2C-224.9 219.3 -232.2 231.1 -231.9 231.8L-232.0097959 232.0097959L-228.4979373 236.6165408L-224.9673208 241.2479156L-221.4155853 245.90692L-217.8404642 250.5967879L-214.2393748 255.3205446L-210.6098724 260.0815326L-206.9494334 264.8831955L-203.255381 269.7290008L-199.5249382 274.6225177L-195.755271 279.5675001L-191.9433556 284.5677271L-188.0862435 289.6274165L-184.1806472 294.7506493L-180.2232563 299.9418676L-176.21055 305.2056254L-172.1388793 310.5467589L-168.0043423 315.9702129L-163.8029956 321.4814801L-159.5304934 327.0859836L-155.1823829 332.789694L-150.7539269 338.5988636L-146.2400726 344.520021L-141.1165514 349.2757211L-135.5595217 353.1446277L-129.9544183 357.0468298L-124.2972332 360.9853767L-118.5837265 364.9631828L-112.809488 368.9832091L-106.9700066 373.048746L-101.0605031 377.1629324L-95.07607912 381.3293254L-89.01158004 385.5515115L-82.41384484 387.7266559L-75.71802764 389.5354832L-69.00535473 391.3488137L-62.27167978 393.1679125L-55.51274023 394.9936711L-48.6449162 396.1810495L-41.73692968 397.1003602L-34.82227518 398.0204266L-27.89674391 398.9420242L-20.95607052 399.865646L-13.97758695 400.2657203L-6.986488007 400.2556298L0 400.2456L6.986137213 400.2355329L13.9761805 400.2254449L20.95327578 399.8123192L27.89437219 398.9081071L34.82100271 398.0058822L41.73741051 397.104935L48.64782887 396.2047713L55.51242013 394.9913934L62.27047523 393.1603073L69.00311467 391.3361097L75.714574 389.5177157L82.4090005 387.703865L88.99104201 385.4625515L95.06134608 381.2702344L101.0523762 377.1326023L106.9692624 373.0461506L112.8169142 369.0074992L118.6000735 365.0134937L124.3232135 361.0608291L129.9907408 357.1466252L135.6068263 353.2678603L141.1756268 349.421938L146.3025114 344.6671176L150.8210385 338.7495986L155.254228 332.9437663L159.6071646 327.2431826L163.8845323 321.6415048L168.0908659 316.1329401L172.2303629 310.7117996L176.3071 305.3728549L180.3249248 300.1110725L184.2874789 294.9216158L188.1983302 289.8000149L192.0607301 284.7417421L195.877959 279.7427168L199.6530166 274.7988025L203.3889238 269.9062181L207.0885113 265.0612072L210.7545532 260.2601985L214.3896585 255.4996458L217.9964095 250.7761823L221.5773142 246.0865381L225.1348878 241.4276093L228.6713935 236.7961599L232.1891889 232.1891889L232.2 231.8C232.4 230.6 222.3 218.1 217.7 199.2Z';
                if (id === 15) return 'M235.9056714 235.9056714L236.3 235.9L236.3 232.6L233 227.5L233 209.5L231.1 209.5L177.1 154.6L122.1 59.7C122.1 59.7 31.6 -41 20.5 -46.4C17.4 -47.8 13.4 -50.7 4 -50.9C-2.9 -50.9 -8.1 -48.8 -12.6 -46.4C-22.7 -41.2 -116.8 59.7 -116.8 59.7L-171.8 154.6L-228.4 210.9L-233.1 210.9L-233.1620971 233.1620971L-233.076778 241.3580691L-233.1907207 250.0664323L-233.3090473 259.1159477L-233.4322975 268.5331403L-233.5606704 278.3467681L-226.6895119 279.9382336L-218.7192801 279.9479123L-213.9214089 283.8832979L-209.2880513 288.06029L-204.6375036 292.2526429L-199.9669349 296.4631727L-195.2732457 300.6944294L-190.5534563 304.9492757L-185.8044149 309.2304754L-181.02295 313.5409467L-176.2057533 317.8835937L-171.349468 322.2614793L-166.4506228 326.677741L-161.5056185 331.13559L-156.5107566 335.6384006L-151.4621774 340.1896203L-146.3559244 344.7929507L-141.1877641 349.4519788L-135.953404 354.170726L-130.6482745 358.9531842L-125.2676867 363.8037785L-119.8065995 368.7267988L-114.2598563 373.7271501L-108.6219288 378.8096835L-102.8870409 383.9796641L-97.04904895 389.2424751L-91.1015328 394.6040914L-85.03764879 400.070683L-78.57415209 404.2289697L-71.52151682 405.6186781L-64.41562976 406.70428L-57.15851782 406.7039871L-49.93692623 406.7036267L-42.74623562 406.7032647L-35.58189849 406.7029608L-28.43941439 406.7025738L-21.31436247 406.7022638L-14.2023432 406.7018972L-7.067116379 404.8748262L0 404.8574L7.06650729 404.8399315L14.20572845 406.7988381L21.31971121 406.8043237L28.44691321 406.8098119L35.59172966 406.8153315L42.75860134 406.8209167L49.95201365 406.826504L57.1765129 406.8320287L64.43676406 406.8377167L71.27870458 404.2416214L78.57926577 404.2552773L84.97683462 399.7845748L91.0390189 394.333314L96.98520576 388.9864141L102.8221809 383.7376031L108.5564098 378.5811916L114.1939849 373.5116946L119.7406861 368.5239384L125.2020196 363.6130674L130.5831197 358.7741728L135.8890052 354.0029616L141.1244181 349.295192L146.2938372 344.6466824L151.5844018 340.4641408L156.6357671 335.9064865L161.6333598 331.3974986L166.5809635 326.933549L171.4823285 322.5113535L176.3410152 318.1276126L181.16055 313.7792769L185.9442477 309.4631963L190.6954216 305.1764678L195.4173027 300.9162578L200.1129402 296.6796344L204.785429 292.4639023L209.4377602 288.2663466L214.0729459 284.0843943L218.6937917 279.9152887L223.3032018 275.7564889L230.8594841 275.1276195L236.0123152 271.5011112L235.9840976 262.0868921L235.9569742 253.0328761L235.9308514 244.3135486Z';
                if (id === 16) return 'M231.6,116.3l-6.6-11.2l-23.7-48.5l-21.1-14.8c0,0-39.8-11.1-50-10.8c-59,1.9-96.8,47.1-96.8,47.1l-11.5,22.1l-3.3,15.2l18.8,15.5L64,177.3c0,0,19.5,22.7,24.1,28c4.6,5.3,16.1,17.9,19.7,21.5c3.6,3.6,8.9,7.1,15.5,7.4c6.6,0.3,16-7.5,25.9-19.1c9.9-11.5,32-33.3,32-33.3l20.1-33.6L231.6,116.3z';
                if (id === 17) return 'M-153.1 129.7L-246.9621345 246.9621345L-245.7177542 254.4481831L-240.9333117 258.3693446L-236.1596106 262.281819L-231.3935941 266.1878802L-226.6324485 270.0900346L-221.8731971 273.9905802L-217.1130193 277.8919923L-212.3489264 281.7965431L-207.5780076 285.7066168L-202.7974131 289.6247213L-198.0041119 293.5531679L-193.1951755 297.4944819L-188.3675923 301.4511621L-183.5182123 305.4255954L-178.64395 309.4203979L-170.2294082 307.1019817L-163.9567463 308.3577919L-158.9141081 311.8864981L-153.6399688 315.0086183L-148.374214 318.1895287L-143.0886902 321.38246L-137.7800403 324.589434L-132.4447833 327.8123421L-127.0794968 331.0534074L-121.6806432 334.3148196L-116.2445653 337.5987311L-110.7675125 340.9073495L-105.2456565 344.2430312L-99.67504344 347.6081862L-94.05157987 351.0052746L-88.37102025 354.4368031L-82.62899879 357.9055148L-76.82093719 361.4140941L-70.94209757 364.9654529L-64.98751793 368.5625289L-58.95203092 372.2084745L-52.83022046 375.9065511L-46.61642535 379.6603173L-40.30464932 383.4731228L-33.88864543 387.3489898L-27.3253756 390.7710769L-20.62307253 393.5116658L-13.82422112 395.8738973L-6.944809915 397.8678936L0 399.043L6.986041225 400.2300337L14.01624513 401.3727455L21.0728739 402.0943874L28.12651475 402.2279005L35.20165541 402.3567625L42.1666671 401.1890386L49.03969975 399.3963035L55.95056489 398.1089554L62.73338046 396.0829759L69.48750626 394.0832309L76.1260536 391.6345948L82.54029673 388.3215652L88.84336164 384.8228775L95.013252 381.0773396L101.0957802 377.294588L106.9555907 372.998472L112.5926066 368.2738222L118.1468383 363.6185791L123.4445702 358.5090635L128.6215658 353.3848477L133.716077 348.34229L138.7330795 343.3764211L143.6773453 338.4826137L148.5533596 333.6563086L153.3654624 328.8932955L158.1177547 324.18944L162.8142043 319.5408679L167.4586286 314.9438746L172.0546194 310.3947499L176.6057 305.8900453L181.1153022 301.4264814L187.2878818 299.7232641L196.8025921 303.0494164L203.883522 302.2697519L208.3599 297.5687759L212.4877779 292.4643358L216.5770982 287.4075166L220.6308474 282.3946069L224.6519613 277.4220682L228.6432809 272.4864515L232.6075001 267.5843194L236.5473048 262.7123971L240.4652562 257.8674166L244.3639345 253.0462618L248.2899396 248.2899396L248.7 247.6L194.3 192.9C194.3 192.9 90.2 34.5 81.5 18.8C74.3 5.9 52.2 -12.6 22.4 -39.6C5.1 -55.3 -16.1 -67 -34.3 -45.1C-34.3 -45.1 -153.1 129.7 -153.1 129.7Z';
                if (id === 19) return 'M-252 237.9L-245.5832056 245.5832056L-241.6837341 250.2708331L-237.7693167 254.9763754L-233.8375266 259.7028835L-229.8752767 264.4412559L-225.8821868 269.1959076L-221.8645124 273.9798556L-217.8195524 278.7963134L-213.7445354 283.6485789L-209.6366079 288.540037L-205.4928208 293.4741625L-201.3101163 298.454521L-197.0854776 303.4850219L-192.8155226 308.5693386L-188.4969309 313.7115746L-184.1262 318.9159334L-179.6996308 324.1867156L-175.2134537 329.5285795L-170.6636093 334.9461925L-166.0459161 340.4445797L-161.3559904 346.0290381L-156.5891742 351.7050435L-151.740551 357.478336L-146.8050274 363.3551934L-141.777134 369.3420614L-136.6511043 375.4458234L-131.4207946 381.6737013L-126.0797062 388.0334363L-120.6209582 394.533377L-115.0371402 401.1821843L-108.6430212 405.4612749L-101.2550304 406.1117455L-93.90763974 406.7586759L-86.59607166 407.4024861L-79.31561676 408.0434748L-72.06170158 408.682218L-64.82975872 409.3189873L-57.61529785 409.9541459L-50.41389846 410.5882539L-43.22112933 411.2215766L-36.03259827 411.8544828L-28.84393218 412.4874477L-21.6507466 413.1208552L-14.44863942 413.7548981L-7.233209186 414.3902767L0 415.0271L7.255476711 415.6659824L14.53776576 416.3071424L21.85148116 416.9510988L29.20131553 417.5982676L36.59205098 418.2490566L44.02467099 418.8667648L51.49639072 419.4044458L58.59666306 416.9369222L65.1669845 411.4481471L71.60155127 406.072576L77.90838134 400.8038761L84.09493561 395.6355661L90.16830086 390.5618198L96.1351648 385.577086L102.0018539 380.6761012L107.7743164 375.8537076L113.4582608 371.1052493L119.0591183 366.4262882L124.5820077 361.8124218L130.0318516 357.2595762L135.4133793 352.7639136L140.7310063 348.3214635L145.989145 343.9288727L151.1918602 339.582478L156.3431884 335.2790496L161.4469644 331.0153314L166.5069177 326.7882258L171.5266466 322.5947038L176.509632 318.4318054L181.45935 314.2968137L186.3790943 310.1869026L191.2720268 306.0992289L196.1414548 302.0313542L200.9903698 297.9804773L205.821939 293.9441919L210.6391345 289.9198964L215.4449638 285.9051235L220.2423034 281.8972933L225.0342105 277.8941066L229.8235675 273.8930623L234.6132694 269.891693L239.4062992 265.887632L244.2055398 261.8783797L246.6501247 255.413681L247.4218246 247.4218246L246.3 235.3L194.9 183.7L195.8 174.7L152.7 105.9L42.6 -21.5C42.6 -21.5 28.3 -45.3 0 -45.3C-28.3 -45.3 -36.9 -31.5 -45.4 -24.5C-45.4 -24.5 -155.3 101.2 -155.3 101.2L-190.1 178.4L-252 237.9Z';
                if (id === 22) return 'M-226.1 216.2L-231.2367868 231.2367868L-231.2248188 239.4403091L-230.6951523 247.3902628L-229.6215354 255.0205509L-227.9884509 262.2707111L-225.9045558 269.2225659L-223.381678 275.853399L-220.0094603 281.5992677L-216.1688269 286.8657223L-212.2412019 292.1249531L-207.3045767 296.061618L-202.1300049 299.6700559L-196.919744 303.2298144L-191.6956442 306.7771585L-186.4479549 310.3015059L-181.18545 313.822405L-175.9009535 317.3337203L-170.5367658 320.7330088L-165.1471253 324.1194831L-159.7287687 327.4925081L-154.3042244 330.906477L-148.8437696 334.3085801L-143.3558126 337.7251303L-137.8377697 341.1604517L-132.2395294 344.4957519L-126.5887691 347.7997846L-120.8253744 350.9023666L-115.025025 354.0106258L-109.1907449 357.1468338L-103.2958709 360.2355121L-97.30185532 363.1354677L-91.25376155 365.998847L-85.11482041 368.6727912L-78.92049182 371.2917221L-72.67927991 373.9024813L-66.39280053 376.5322826L-60.04394349 379.1025392L-53.60267293 381.402836L-47.13009245 383.8438001L-40.57840937 386.0777757L-33.96074938 388.1731417L-27.30010283 390.4096594L-20.56356131 392.3761242L-13.75096009 393.7759761L-6.889169898 394.6802791L0 395.4326L6.890932591 394.7812637L13.75099848 393.7770754L20.54290954 391.982065L27.27990833 390.1208646L33.95803012 388.1420604L40.55388699 385.8444608L47.09532312 383.5606266L53.59762094 381.3668892L59.99142844 378.7709722L66.33351704 376.1960692L72.6283339 373.6403869L78.9028817 371.208873L85.08969338 368.563954L91.18469285 365.7218275L97.23839289 362.8986227L103.2401646 360.0412411L109.166098 357.0662173L115.0265701 354.0153811L120.8311369 350.9191023L126.5528227 347.7010229L132.2353006 344.4847357L137.803231 341.0749654L143.3186541 337.6375903L148.8072447 334.2265437L154.2818679 330.8585334L159.7266645 327.4881939L165.124562 324.0752001L170.5050295 320.6733215L175.8646897 317.2682988L181.19875 313.8454413L186.5240776 310.4281952L191.8256864 306.9852695L197.0244236 303.3910069L202.21791 299.8003806L207.4171124 296.2223357L212.379449 292.3152339L216.1629291 286.8578957L219.9058444 281.4666454L223.4272408 275.9096644L225.5982032 268.8574691L227.7207132 261.9627141L229.3176832 254.6830888L230.3173252 246.9850929L231.049487 239.2587478L230.8695862 230.8695862L229 215.3L150.1 136.1C150.1 136.1 134.6 44.6 134.6 44.6C114 11 93.2 -11.2 83.6 -22.1C75.8 -30.8 50.2 -58.7 -1.1 -58.3C-57.5 -57.6 -85.7 -14.8 -85.7 -14.8L-125.7 44.9L-145.1 135L-226.1 216.2Z';
                if (id === 31) return 'M-230.1 222L-229.2607062 229.2607062L-228.6179743 236.7408427L-227.9552921 244.4521225L-227.2714818 252.4105519L-226.564934 260.6331423L-225.834042 269.1385308L-225.0771301 277.947108L-224.2923093 287.0810645L-223.4773889 296.5645117L-218.527095 300.7767427L-213.5317814 304.9549879L-208.521468 309.1457895L-203.4929925 313.3517295L-198.4432122 317.5755246L-193.3688821 321.8198629L-188.2667 326.0874898L-183.1332949 330.3812096L-177.9652613 334.7039768L-172.7590024 339.0586331L-167.5109525 343.4483494L-162.2172864 347.8760934L-156.8742152 352.3452562L-151.4777061 356.8591124L-146.0235981 361.4210879L-140.5076155 366.0348527L-134.9252706 370.7041344L-129.271882 375.432806L-123.542584 380.224977L-117.7322673 385.0848948L-111.8356123 390.0171297L-105.8469473 395.026185L-95.48843499 382.9831944L-88.61251687 383.822979L-81.82065199 384.9359029L-75.03994972 386.0470747L-68.26623863 387.157078L-61.49540503 388.2667067L-54.72328082 389.3763754L-47.94577615 390.4870107L-41.15874094 391.5992618L-34.35799654 392.7136975L-27.53935359 393.8311046L-20.69856191 394.9520891L-13.83133014 396.0774732L-6.933287836 397.2077941L0 398.183L6.923880989 396.6688762L13.80024865 395.1874158L20.6337386 393.7151865L27.42888026 392.2512624L34.19009972 390.794628L40.92174356 389.3443823L47.62807496 387.8995421L54.31331861 386.4593428L60.98161167 385.0227431L67.63707655 383.5889226L74.05900067 381.0005293L80.31075571 377.8323994L86.50481547 374.6935212L92.64570757 371.5816375L98.73778338 368.4944242L104.7853049 365.4297858L110.7924156 362.3856626L116.763122 359.3599383L122.7013632 356.3506337L128.6110316 353.3559051L134.4958498 350.3736676L140.3595838 347.4021607L145.6158796 343.0495145L149.9419992 336.7752442L154.176805 330.6332252L158.325718 324.6158279L162.3938091 318.7157958L166.3857452 312.9260744L170.3060566 307.2402591L174.15895 301.65215L177.9484876 296.1560168L181.6784744 290.7463358L185.3524278 285.4177096L188.9739294 280.1653718L192.5461109 274.9843444L196.0722289 269.8702709L199.5552417 264.8187501L202.9979949 259.8255849L206.4032432 254.8867781L209.7736721 249.9985274L213.1117876 245.1570676L216.4200569 240.3588237L219.7009977 235.6004755L222.956717 230.8784391L226.2033886 226.2033886L232.8 215.9L184.3 167.1L161.5 99.8C161.5 99.8 61.1 -18.9 37.9 -44C19.8 -63.5 4.3 -60.4 -2.7 -60.4C-25.5 -60.4 -42.6 -39.3 -54.3 -24.5C-54.3 -24.5 -182.7 142 -182.7 142L-180.3 170.2L-230.1 222Z';
                if (id === 32) return 'M249.6 238.2L150.4 136.4L151.8 130.4L116.3 61.5C116.3 61.5 51.4 -19.8 37.7 -35.1C27.5 -47.6 13.9 -55.3 -4.2 -55.3C-33.2 -55.3 -50.1 -35.1 -70.7 -6.8C-70.7 -6.8 -129.1 69 -129.1 69L-178.7 146.6L-184.8 169.5L-245.3 229.3L-241.4458531 241.4458531L-239.4927122 248.0019634L-237.5006775 254.6882952L-235.4674619 261.51311L-233.3904409 268.4849898L-230.234116 274.3823349L-225.7964433 278.8353858L-221.3421211 283.3049957L-216.8684368 287.7941361L-212.3724544 292.3056066L-207.8512524 296.8423518L-203.3018496 301.407387L-198.721192 306.0038012L-194.106141 310.6347597L-189.4534596 315.3035057L-184.7598 320.0133608L-179.6153709 324.0347067L-173.6893612 326.6621784L-167.7781365 329.2831332L-161.8780148 331.8991155L-155.9854421 334.51186L-150.0967218 337.1227569L-144.2083489 339.7335798L-138.3167042 342.3458563L-132.4181758 344.9611418L-126.6769761 348.0421313L-120.8768467 351.0518531L-114.9343903 353.7316809L-108.9690979 356.4218592L-102.977179 359.1241013L-96.95472722 361.839968L-90.89787025 364.5714449L-84.80256585 367.3202681L-78.66467727 370.0882093L-72.89670676 375.0210455L-67.45439867 382.5529048L-61.82446493 390.3443091L-55.65007625 395.9708676L-48.73685443 396.9298263L-41.79605098 397.6628618L-34.84168477 398.2422792L-27.89569058 398.926961L-20.92866741 399.3427636L-13.9544102 399.6020249L-6.977688503 399.7515066L0 399.8175L6.978948567 399.8236956L13.95631571 399.6565916L20.92853134 399.3401671L27.89584405 398.9291557L34.85284942 398.3698917L41.79603008 397.6626629L48.72978601 396.8722586L55.62992398 395.8274768L61.80724149 390.2355646L67.42706644 382.3978961L73.48483732 378.046715L79.75482064 375.2169306L85.97732775 372.4087209L92.15658988 369.6198936L98.29680749 366.8486798L104.4020863 364.0933436L110.4763618 361.3518971L116.523572 358.6226793L122.5475648 355.9039708L128.5521357 353.19409L134.5409684 350.4912054L140.5138468 347.783975L145.7230572 343.3020089L150.8745243 338.8697299L155.9722987 334.4836739L161.0202539 330.1404452L166.0221466 325.8368091L170.9816371 321.5696899L172.2103888 310.6757653L175.47115 303.9249471L180.1556833 299.8294073L184.8109862 295.7594025L189.4401616 291.7122676L194.0462005 287.6853229L198.6320436 283.6759572L203.2007121 279.6817864L207.7549112 275.7000791L212.297623 271.7285662L216.8315226 267.7646307L221.3595331 263.8060189L225.8842728 259.8501311L230.4085668 255.8946378L234.9352043 251.9371619L239.4668709 247.9752039L243.84344 243.84344L249.6 238.2Z';
                if (id === 680) return 'M-114.4 36L-143.2 67.1L-192.4 166.1L-191.7 175.5L-234.5 216L-233.8 229.3L-234.1116001 234.1116001L-234.2389415 242.5615245L-230.2487843 246.9115918L-226.2457715 251.2713852L-222.2294335 255.6457195L-218.1972109 260.03731L-214.1465901 264.4490152L-210.0749004 268.8836109L-205.9794967 273.3440245L-201.8576816 277.8332634L-197.7066354 282.3543373L-193.5234669 286.9103386L-189.3052545 291.5045289L-185.0489199 296.1401761L-180.7513763 300.820807L-176.4093 305.5498705L-172.0193253 310.3310776L-167.5779682 315.1683199L-163.0815139 320.0654925L-158.5261851 325.0268464L-153.9079775 330.0567229L-149.2226855 335.1596391L-144.4659188 340.3403766L-139.6330718 345.6039803L-134.2092988 349.6271767L-128.5763849 353.2607143L-122.8985273 356.9232398L-117.1717043 360.6174252L-111.3916898 364.3458004L-105.5542229 368.1113214L-99.65480514 371.916796L-93.47876561 374.9228508L-87.13263137 377.4128906L-80.75360761 379.9158538L-74.33752456 382.4334105L-67.88009717 384.967161L-61.37695285 387.5188291L-54.82359679 390.0901607L-48.21542426 392.6831183L-41.54763909 395.2993805L-34.81532015 397.9409303L-28.01336975 400.6098516L-21.13648826 403.3082216L-14.16211106 405.5497994L-7.039454315 403.2900676L0 401.0568L6.961918509 398.8480443L13.85174984 396.6622168L20.67474382 394.4976128L27.43596054 392.3525151L34.14031636 390.2256016L40.79254638 388.1151532L47.39726661 386.019759L53.95896998 383.9380213L60.48203821 381.8685604L66.9707364 379.8099198L73.42929282 377.7609633L79.86179121 375.7201875L86.27230606 373.6864123L92.66484359 371.6583879L99.04334515 369.6347962L105.4117183 367.6143491L111.7739074 365.5959776L118.133736 363.5782543L124.4951135 361.5600629L129.9533238 357.0438228L134.7688904 351.0849626L139.4881365 345.2452529L144.1167224 339.5177214L148.6599653 333.8957489L153.1229218 328.3731655L157.5103477 322.9440709L161.8267296 317.6028396L166.0764104 312.3443003L170.2633448 307.1632051L174.3915 302.0549384L178.4645557 297.0148984L182.4860184 292.0386763L186.4592433 287.1220559L190.3875131 282.2610959L194.2739525 277.4519581L198.1215422 272.6909087L201.9331332 267.9743188L205.7115228 263.2987423L209.4595377 258.6609875L213.1796108 254.0575671L216.8744829 249.4855535L220.5464516 244.9416492L224.1980949 240.4230218L227.83176 235.9266939L231.4497674 231.4497674L234.3 228.4L181.2 176.9L181.2 169.2L136 69.2L107.9 37.2L104.9 39.5L42.4 -38.4C42.4 -38.4 -2.1 -77.5 -41.2 -39.1C-41.2 -39.1 -109.8 37.4 -109.8 37.4L-114.4 36Z';
                if (id === 2392) return 'M0.9 -48.1C-26.7 -48.1 -47 -24.7 -47 -24.7L-156.7 108.4L-154.4 139.5L-230 215.2L-222.4148519 222.4148519L-218.5078469 226.2714993L-214.599309 230.1295841L-210.686879 233.9914845L-206.7682216 237.8596297L-202.8408864 241.7363551L-198.9023735 245.6239754L-194.9503144 249.5250235L-190.9822062 253.4419477L-186.9955315 257.3772687L-182.9876316 261.3334214L-178.9559326 265.3130808L-174.8977548 269.3189248L-170.8103072 273.3536326L-166.6907853 277.420054L-162.4573 281.3842977L-157.9801113 285.0036652L-153.4753711 288.6451922L-148.9401185 292.3114412L-144.3712685 296.0049664L-139.7655222 299.7281297L-135.1197025 303.4838206L-139.4514709 328.5270776L-134.8318889 333.7206357L-130.1317525 339.0048053L-125.3459705 344.3852235L-119.6737096 347.5576892L-113.6284227 349.7123259L-108.6501788 355.378722L-103.5634321 361.1686088L-97.39081143 363.4674564L-91.50809404 367.0189189L-86.15197974 373.1652218L-80.65861276 379.4689382L-74.03389021 380.8713472L-68.01229553 385.7168952L-61.87389822 390.6564186L-55.61140004 395.6956721L-49.21710495 400.8411529L-42.68274503 406.0991921L-35.83257584 409.568216L-28.63868771 409.552315L-21.46289715 409.5364743L-14.30077374 409.5205791L-7.147933238 409.5048209L0 409.489L7.147381742 409.4732257L14.2985681 409.4574176L21.45792 409.4415046L28.62983561 409.4257241L35.81517955 409.3693755L43.02288065 409.3353664L50.25587049 409.3012193L57.51872564 409.2669989L64.81607071 409.2325646L72.15264113 409.1979619L78.37006279 403.1790212L84.13086275 395.80459L90.40269986 391.5771134L95.92687004 384.7416614L101.3073389 378.0841358L106.5527467 371.593588L111.6712264 365.2601234L116.6703551 359.0744311L121.5571539 353.0276087L126.3383077 347.1116477L132.3886821 344.8843081L138.9139395 343.8240655L143.5182786 338.1078762L148.0374142 332.4974762L152.4764004 326.9866959L156.8399029 321.5694553L161.1324873 316.2403124L165.3584475 310.9940085L169.5217316 305.8252993L173.6263 300.7295731L177.6758264 295.7022324L181.6738111 290.7388729L185.6236036 285.8352836L189.528481 280.9875283L193.3915052 276.1916926L197.2156475 271.4440517L201.0038707 266.7411457L204.7588483 262.0793745L208.4833988 257.4555564L212.1800118 252.8662914L215.8512932 248.3085084L219.4996636 243.7790734L223.1276303 239.275089L226.7375341 234.7935898L230.3316194 230.3316194L234.7 225.7L178 169.7C178 169.7 182.3 140.1 161.6 119.9C148.8 107.2 46.5 -24.9 46.5 -24.9C46.5 -24.9 28.5 -48.1 0.9 -48.1Z';
                if (id === 2394) return 'M113 42.8C113 42.8 83.1 11.5 47.7 -24.6C12 -60.9 -22 -44.6 -37.7 -29.6C-53.3 -14.7 -116.5 50.6 -116.5 50.6L-186.2 165L-186 178.3L-245.3 237.9L-241.5379184 241.5379184L-237.4820235 245.9198343L-233.2430299 250.1225271L-228.9995116 254.3297235L-224.7488314 258.5439552L-220.4884274 262.7678754L-216.2156068 267.004038L-211.9277336 271.2551293L-207.6221508 275.5239001L-203.2959921 279.812928L-198.9465356 284.1250983L-194.5708912 288.4632089L-190.1661655 292.8302155L-185.7293362 297.2290698L-181.2572982 301.6628024L-176.74685 306.1345243L-172.1947779 310.6476025L-167.597686 315.2054037L-162.9519904 319.8112883L-158.2540443 324.468875L-153.5001509 329.1821358L-148.6862405 333.954764L-143.8082402 338.7909829L-138.8617943 343.6950015L-133.8424017 348.6713771L-128.7453087 353.7248284L-123.5654862 358.8602291L-118.2977004 364.0828849L-112.9363773 369.3982453L-107.4756633 374.8121806L-101.909352 380.3308793L-96.23082071 385.9607409L-90.43309074 391.7087508L-84.50874224 397.5823733L-78.44982095 403.5893414L-72.24788715 409.7381289L-65.89388853 416.0376385L-59.1422912 420.8192681L-51.68748185 420.9607582L-44.25956735 421.1016544L-36.85391912 421.2422231L-29.46592973 421.3824271L-22.09105423 421.5224254L-14.72476773 421.6621782L-7.362580385 421.8019477L0 421.9416L7.367458332 422.0814052L14.74429749 422.2214373L22.13503737 422.3616736L29.54423835 422.5022925L36.97650368 422.643371L44.43648178 422.7848827L51.92891721 422.9270914L59.45861774 423.0700484L67.03046313 423.2136881L74.25640616 421.1290063L80.62924129 414.8014871L86.85485935 408.6199864L92.94201484 402.576095L98.89883215 396.6615503L104.7329901 390.8688403L110.4516923 385.190827L116.0616846 379.620665L121.5693869 374.1521007L126.9808264 368.7790972L132.3017025 363.4959403L136.0352194 354.3838624L138.5260344 342.8639666L141.9610588 334.4392962L146.7646132 329.6387184L151.5042939 324.9020067L156.1842311 320.2251291L160.8082473 315.6039555L165.3801841 311.034889L169.9036646 306.5143247L174.3821 302.0386571L178.8189019 297.6046296L183.217307 293.2089826L187.5804916 288.848627L191.9114256 284.5203891L196.2131571 280.2214292L200.4884946 275.9487392L204.7403596 271.699634L208.9713888 267.4711805L213.3974471 263.5239006L217.5337898 259.2466756L221.6550538 254.9849712L225.7638636 250.7361723L229.6770651 246.298498L231.9392054 240.1800782L232.1701677 232.1701677L231.9 215.6L181.8 164.7L181.8 131.4L119.9 41.2L112.1 41.2Z';
                if (id === 2395) return 'M-38.3 -28.2L-45.7 -28.2L-138.6 91.7L-146.7 88.9L-199.2 178.3L-245.4 223.8L-240.27446 240.27446L-237.852068 246.3030266L-235.3915294 252.4265107L-232.8903722 258.650962L-229.4050135 263.90028L-224.7297329 267.8224665L-220.0544611 271.7446283L-215.3763614 275.6691715L-210.6925509 279.5984586L-206.0001569 283.5348916L-201.2963635 287.4810004L-196.5782259 291.439205L-191.8427278 295.4118951L-187.0868834 299.4015994L-182.3076668 303.4109094L-177.502 307.4424824L-172.6666916 311.4989573L-167.7984321 315.5829521L-162.8939705 319.6974177L-157.9498148 323.845112L-152.9624537 328.0290404L-147.9282868 332.252372L-142.8434469 336.5180723L-137.7040726 340.8295398L-132.5061193 345.1902424L-127.2453109 349.6036185L-121.9172323 354.0733523L-116.5173299 358.6034679L-111.0407269 363.1978522L-105.4823918 367.8608166L-99.83701375 372.5968078L-94.09900497 377.410495L-88.26249303 382.3068592L-82.32126176 387.2910867L-76.26874056 392.3686556L-70.09796643 397.5453226L-63.18092382 398.9086535L-56.06140235 398.8976049L-48.97710765 398.8865318L-41.92351299 398.8755818L-34.89613967 398.8647016L-27.89057046 398.8537398L-20.90247326 398.8429495L-13.92752363 398.8320942L-6.961450785 398.8212483L0 398.8104L6.961072067 398.7995516L13.92600899 398.7887206L20.89906619 398.7779387L27.88450862 398.7670515L34.88664841 398.756216L41.90981976 398.7452994L48.9584129 398.7342752L56.03690788 398.7233177L63.149809 398.7122022L70.30175993 398.701093L77.49747417 398.689942L84.74176967 398.6786811L92.03960119 398.6673121L99.39607841 398.6558962L106.8164316 398.64435L114.3060948 398.632726L121.8706426 398.6209104L129.5159134 398.6089945L136.1617832 395.4425319L140.1238742 384.9871803L143.9286318 374.9469048L147.5874682 365.2918023L151.1106924 355.9944822L154.5077401 347.030066L157.787275 338.3759033L160.9571285 330.0110189L164.7312246 323.303232L170.5221183 320.7054608L176.3265679 318.101549L181.26165 313.9543873L184.1873498 306.5392272L187.0357992 299.3198476L189.8117144 292.2844087L192.5193802 285.4217187L195.162996 278.7216437L197.7462413 272.1743513L200.2727858 265.7709633L202.7458815 259.5028945L205.1687054 253.3622509L207.5442276 247.3415789L209.8751859 241.4337834L212.1642524 235.632274L214.4138054 229.9306559L216.6263647 224.3231674L218.8039404 218.8039404L222.2 211.3L205.6 204.4L183 182.5C183 182.5 156.2 120 153.9 116.1C153.9 116.1 134.3 89.6 134.3 89.6L128.6 93L29.4 -28L24.4 -27.5C24.4 -27.5 -6.3 -64.9 -38.3 -28.2Z';
                if (id === 2602) return 'M-46.5 -29C-54.8 -24.7 -108.8 54.6 -116.6 66C-116.6 66 -138.9 130.7 -138.9 130.7L-231.7 223.7L-232.1640866 232.1640866L-230.7298747 238.9277795L-229.2614553 245.8528111L-226.169223 251.1863695L-221.9382089 255.3107039L-217.6987291 259.4432426L-213.4481703 263.5865386L-209.1839151 267.7432018L-204.9032709 271.9158246L-200.6035242 276.1070639L-196.2819289 280.3196455L-191.9356387 284.5562864L-187.5618105 288.8198606L-183.1573731 293.1130684L-178.7194481 297.4391105L-174.2448 301.8008466L-169.7302482 306.2014732L-165.1724898 310.644273L-160.5680409 315.132524L-155.9133616 319.6697642L-151.204742 324.2596157L-146.4382884 328.9057809L-141.6099869 333.6122226L-136.7156731 338.3831652L-131.7508588 343.2227217L-126.7109387 348.1354428L-121.5910781 353.1261317L-116.3861522 358.1997444L-111.0907517 363.3614759L-105.6992357 368.6170412L-100.1426532 373.7374696L-93.72719521 375.9192475L-87.24247497 377.8886755L-80.73759841 379.8405365L-74.2140139 381.7980032L-67.66763863 383.7622487L-61.09436964 385.7346688L-54.48998495 387.7163891L-47.85020621 389.708656L-41.17068854 391.7129356L-34.44694769 393.7304138L-27.67441607 395.7625881L-20.84838405 397.8108659L-13.96399709 399.8765575L-7.016260067 401.96127L0 404.0666L7.024021152 402.4059023L13.96179144 399.813396L20.81904975 397.251134L27.60128338 394.7167419L34.31379986 392.2085271L40.93788275 389.4979365L47.49180066 386.789677L53.9670281 383.9953578L60.34179471 380.9830978L66.65184888 378.0014188L72.90197308 375.0481384L79.02771188 371.7961528L85.06521871 368.4579426L91.05528883 365.2028163L96.93156291 361.7535176L102.6576326 358.0097106L108.3222255 354.3060349L113.9297761 350.6397962L119.4646297 346.9504772L124.883696 343.1151349L130.1749358 339.1173017L135.4132035 335.1594397L140.5344213 331.0783488L145.561771 326.9370905L150.5186213 322.788225L155.4004674 318.6181752L160.113324 314.2400919L164.6985113 309.7528491L169.2368574 305.3113727L173.73125 300.9113519L178.184066 296.5480851L182.4738302 292.0191712L186.5394141 287.2455082L190.5629319 282.521165L194.5474911 277.8426117L198.5011927 273.2134528L202.4410651 268.6483671L206.3513183 264.1176431L210.2062263 259.5830712L214.018513 255.0573317L217.8077269 250.5591278L221.3662704 245.8521502L224.062991 240.2781406L226.7806029 234.8381889L229.7420338 229.7420338L227.6 207.2C222.8 200.1 160.5 137.8 160.5 137.8C160.5 137.8 113.9 46.3 102 29.7C90.2 13.2 53.9 -34.9 37.4 -43C20.8 -50.8 9.9 -51.5 -2.9 -50.1C-34.7 -46.3 -46.5 -29 -46.5 -29Z';
                if (id === 2680) return 'M-237.2 216.5L-237.2 234.1L-236.586686 236.586686L-231.5010844 239.7263906L-227.9792984 244.4778661L-224.7505992 249.6108281L-221.4897926 254.7948599L-218.1943827 260.0339394L-214.334631 264.6812264L-210.094971 268.9093001L-205.8372276 273.155227L-201.5587928 277.4218783L-197.2568941 281.7120402L-192.9285975 286.0284084L-188.5710267 290.3739171L-184.1812301 294.7515821L-179.7561682 299.1645026L-175.29265 303.615776L-170.7873756 308.1085815L-166.2370636 312.6464449L-161.6381419 317.2327155L-156.9869764 321.8710007L-152.2798406 326.5651721L-147.5127646 331.319094L-142.6816842 336.1369833L-137.7822156 341.0229503L-132.809872 345.9815452L-127.7599486 351.017574L-122.6274592 356.136001L-117.4071134 361.3419401L-112.0934112 366.6410275L-106.5424379 371.5576368L-100.4918777 375.0407933L-94.38708556 378.5659231L-88.22085459 382.1265033L-81.98843673 385.7252681L-75.6849032 389.3650727L-68.68080629 389.508208L-61.69496848 389.5267007L-54.74700983 389.5452161L-47.8324011 389.563645L-40.94670495 389.5818741L-34.08559998 389.6001906L-27.24476502 389.6182918L-20.61167899 393.2942642L-13.81224361 395.5309064L-6.90426972 395.5453474L0 395.5598L6.904774095 395.5742429L13.8142608 395.5886712L20.73268496 395.6031955L27.66428046 395.617642L34.61333672 395.6322491L41.58415088 395.646767L48.5811176 395.6614516L55.48885813 394.8237411L62.32780846 393.5222951L69.15938066 392.2223382L75.98771708 390.922915L82.81698561 389.6232841L89.65136334 388.3227174L95.95002197 384.8345187L102.109005 381.0759945L108.2050549 377.3558713L114.2427818 373.6713019L120.0276393 369.4070895L125.3641526 364.0839356L130.6108575 358.8503818L135.773109 353.7010416L140.855975 348.630772L145.8643846 343.6349555L150.8028573 338.7087632L155.6758319 333.847899L160.4875453 329.0482307L165.2420093 324.3057035L169.9430251 319.6163449L174.5943916 314.9766202L179.19965 310.3828985L183.7622374 305.8317213L188.2854548 301.3197146L192.77259 296.8437574L197.2267779 292.4007228L201.6510632 287.987564L206.0483553 283.601231L210.4216138 279.2389129L214.7736288 274.897709L216.2572678 267.055485L216.260749 257.7295245L216.2641512 248.7834471L216.2673613 240.189238L219.8766123 235.7887991L223.9102051 231.8658049L227.4435832 227.4435832L228.2 225.3L228.2 199L154 124.8L105.9 42.3L100.3 36.7L89 19.6L50.6 -21.8L44.2 -22.9L27.3 -38.9L8.1 -48.4L-9 -48.4L-29.8 -39.6L-52.5 -17.1L-59.6 -17.8L-91.3 15.2L-101.2 34.2L-109.6 41.8L-164.8 127.8L-164.8 144.7Z';
                if (id === 2681) return 'M174.4 173.4L175.3 159.6L132.6 90.5L23.8 -19.6L-20 -19.8L-128.5 85.3L-174.3 156.7L-174.1 171.2L-226.2 224.4L-231.9368225 231.9368225L-231.9931109 240.235899L-227.9505181 244.447003L-223.820173 248.5774853L-219.6822843 252.7155595L-215.5342704 256.8637411L-211.3736157 261.024677L-207.1976065 265.2008427L-203.0036418 269.3949316L-198.7890899 273.6097093L-194.5511047 277.8477723L-190.2870262 282.1121178L-185.9938492 286.4054119L-181.6687239 290.7307317L-177.3086043 295.0910722L-172.91035 299.4895114L-168.4707613 303.9292987L-163.9865108 308.4137708L-159.4541298 312.9463504L-154.8700383 317.5306344L-150.2304802 322.1703044L-145.5316318 326.8693967L-140.7693679 331.6318484L-135.9394508 336.4619475L-131.0374199 341.3641497L-126.0586036 346.343167L-120.9980883 351.4039642L-115.8506257 356.5515635L-110.6108235 361.7917017L-105.2727971 367.1298732L-99.83049151 372.5724665L-93.33099972 374.3301942L-86.42806217 374.3610662L-79.57940555 374.3916674L-72.78540787 374.4484624L-67.03606284 380.1804045L-61.14489797 386.0536922L-55.10288937 392.0774306L-48.90032997 398.2612277L-42.52679902 404.6154649L-35.53499127 406.1668088L-28.33280557 405.1779966L-21.18304109 404.1965025L-14.08080222 403.2214187L-7.021338717 402.2522257L0 401.2883L6.987769013 400.3290187L13.94643566 399.3736641L20.88039796 398.4217275L27.79399262 397.4726124L34.69149799 396.5256365L41.57716838 395.5803329L48.45521438 394.6360521L55.32983894 393.6922608L62.20524206 392.7484413L69.08558019 391.8037949L75.79370249 389.9247965L81.63945695 384.0834473L87.35427564 378.3729375L92.94588425 372.7855804L98.42150651 367.3140629L103.7879662 361.9516526L109.0516637 356.6919197L114.2186451 351.5288438L119.294618 346.4567274L124.2849556 341.470109L129.1947994 336.5639593L134.0289946 331.7334026L138.7921902 326.9739098L143.4887156 322.280932L148.1227561 317.6502756L152.6983914 313.0780986L157.2194524 308.560549L161.6895273 304.0937731L166.1122594 299.6744487L170.49095 295.2989876L174.8289535 290.9642402L179.1294568 286.6670548L183.3954308 282.4041985L187.6299652 278.1728629L191.8359659 273.9701523L196.0161542 269.7930907L200.1733659 265.6390287L204.3102773 261.5052298L208.429529 257.3890327L212.5338021 253.2879222L216.6255741 249.1992167L220.7074444 245.1204498L224.7818855 241.0490606L228.8513795 236.9825409L232.9184988 232.9184988L226.5 225.3Z';
                if (id === 2889) return 'M236.8 229.5L188.1 180.2L129.7 63.5C129.7 63.5 75.7 -0.2 61.7 -15.9C51.2 -28.8 34.2 -52.9 0.8 -52.9C-29 -52.9 -46.4 -32.2 -67.6 -3.1C-67.6 -3.1 -140.9 72.3 -140.9 72.3L-181.7 174.7L-236.1 229.8L-237.2739938 237.2739938L-239.7748824 248.2941592L-239.6590659 257.0028834L-235.3193163 261.3485777L-230.9714857 265.7023001L-226.612972 270.0668235L-222.2409719 274.4447443L-217.8527981 278.838866L-213.4456741 283.2519765L-209.0167884 287.6869286L-204.5632255 292.1465628L-200.0820727 296.6338716L-195.5702374 301.1517565L-191.0247665 305.7035297L-186.442341 310.2921628L-181.81975 314.9210448L-177.1536046 319.5935627L-172.4403791 324.3131847L-167.676488 329.0836368L-162.8580811 333.9085494L-157.9812991 338.7919892L-153.0420239 343.7380136L-148.035951 348.7508454L-142.9586793 353.8351477L-137.8054137 358.9953762L-132.5712828 364.236606L-127.0960124 369.1136217L-120.7500592 371.6304694L-114.2604995 373.7292539L-107.7673152 375.8292916L-101.2664972 377.9317127L-94.75408108 380.0378618L-88.22607345 382.1491087L-81.67841961 384.2667522L-75.107 386.3920185L-68.50767905 388.5263547L-61.87621345 390.6710364L-55.20829907 392.8274597L-48.49956263 394.9972397L-41.74545921 397.1815132L-34.94140837 399.3821252L-27.94371791 399.6137839L-20.94300746 399.616388L-13.95500698 399.6191144L-6.975423181 399.6217264L0 399.6244L6.975515679 399.6270256L13.95537691 399.629708L20.94384484 399.6323661L27.94520373 399.635032L34.95727071 399.5634326L41.76375169 397.3555545L48.52002449 395.1638882L55.23073378 392.9870909L61.90038257 390.8236342L68.53336162 388.6720078L75.13398039 386.5308205L81.70648768 384.3988021L88.25504715 382.2746075L94.7837407 380.15682L101.2966238 378.0441465L107.797718 375.9353187L114.2909939 373.8289965L120.7804356 371.7239583L127.1508706 369.2729416L132.7035078 364.5998911L137.9441379 359.3567652L143.1039143 354.1946169L148.187711 349.1083695L153.2002851 344.0934741L158.1460779 339.1453586L163.0293527 334.2597082L167.8542707 329.432555L172.6246936 324.6598299L177.3444741 319.9379005L182.01715 315.2629516L186.6462961 310.631601L191.2353034 306.0404592L195.7874394 301.4862183L200.3058617 296.9656524L204.7936885 292.475698L209.253901 288.0132861L213.6895295 283.5755836L218.1034339 279.1596652L222.4983639 274.762597L226.877222 270.3817444L231.2426349 266.0142216L234.0010621 259.8845081L235.1002479 252.1141495L236.1687719 244.5599224L237.2086571 237.2086571L236.8 229.5Z';
                if (id === 3289) // return 'M236.88 229.125-87.89-88.595-12.69-66.975L83.19-3.995 69.56-19.27C50.995-46.765 18.8-49.35.94-49.35C-28.905 0-52.875 4.7-73.555 31.255L-66.27 90.71-17.86 72.38-84.365 84.13 4.23 7.755 2.82 5.405 2.82 5.405 2.82 5.64 3.055 5.64 2.82 5.875 3.055 5.875 3.055 5.875 3.055 5.875 3.055 6.11 4.935 3.76 5.17 3.525 5.17 3.525 5.17 3.525 5.405 3.29 5.17 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.405 3.29 5.64 3.29 5.64 3.525 5.64 3.76 5.64 3.995 5.64 3.995 5.875 3.995 5.875 3.995 5.875 4.23 6.11 4.23 6.11 4.23 6.345 4.23 6.345 4.465 6.58 4.465 6.58 4.7 6.815 3.76H20.68L7.05-1.175 6.815-4.23 6.58-3.995 6.58-3.995 6.58-3.76 6.345-3.76 6.345-3.76 6.11-3.76 6.11-3.525 5.875-3.76 5.875-3.525 5.875-3.525 5.875-3.525 5.64-3.525 5.875-3.29 5.64-3.525 5.64-3.29 5.64-3.29 5.64-3.29 6.58-1.175 6.58-1.41 6.58-1.175 5.64-3.29 3.995-6.345 3.995-5.875 3.995-5.875 3.995-5.64 3.995-5.64 3.995-5.405 3.76-5.405 3.76-5.405L197.4 282L3.76-5.17 3.525-5.17 3.525-5.17 3.525-4.935 3.525-4.935 3.525-4.935 3.29-4.935 3.29-4.935 3.29-4.7 3.29-4.7 4.935-3.29Z'
                return 'M-26.2,318.5L-26.2,318.5l-37.4-37.7 l-5.4-28.5c0,0-22.6-33-28.4-39.5c-7.9-11.7-21.6-12.8-29.2-12.8c-12.3,0-22.5,2-31.3,13.3l-28.2,38.6l-7.6,30.8l-35.9,35.8 l1.8,3.3l1.2,2.3l1.2,2.3l1.2,2.4l1.3,2.4l1.2,2.5l1.3,2.5l1.3,2.5l1.3,2.5l1.3,2.6l2.1,1.6l2.2,1.5l2.2,1.5l2.2,1.5l2.3,1.4 l2.2,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.4,1.4l2.4,1.5l2.4,1.6 l2.4,1.7l2.4,1.7l2.5,1.7l2.5,1.7l2.5,1.8l2.6,1.8l2.6,1.8l2.7,1.8l2.7,1.9l2.8,1.9l2.8,2l2.9,1.6l3,0h3.1h3h3h3l3,0h3.1l3-0.5 l2.9-1.8l2.8-1.7l2.8-1.7l2.8-1.6l2.7-1.6l2.7-1.6l2.6-1.6l2.6-1.5l2.5-1.6l2.5-1.5l2.5-1.5l2.5-1.5l2.4-1.5l2.5-1.4l2.4-1.5 l2.4-1.4l2.4-1.4l2.4-1.4l2.8-0.5l2.8-0.6l2.8-0.5l2.4-1.4l1.7-2.7l1.7-2.5l1.7-2.5l1.7-2.4l1.7-2.4l1.7-2.3l1.6-2.3l1.6-2.3 l1.6-2.3l1.6-2.2l1.5-2.2l1.5-2.2l1.5-2.1l1.5-2.1l1.5-2.1l1.4-2.1l1.4-2.1l1.4-2l1.4-2L-26.2,318.5z';
                if (id === 3309) return 'M-33 -38.3L-140.8 59.7L-192.2 151.9L-193.6 178.4L-244.3 227.2L-237.633699 237.633699L-234.5093025 242.8414916L-231.3554631 248.0983595L-228.1697896 253.4082239L-224.9498479 258.7751982L-221.6931399 264.2035959L-218.3968942 269.6977036L-215.0584954 275.2623216L-211.6748936 280.9020714L-208.2431454 286.6221004L-204.7600769 292.4276957L-201.2223789 298.324445L-197.6264676 304.3180733L-193.9687329 310.4148609L-189.5637293 315.4870252L-183.93555 318.5857179L-179.6999702 324.1873278L-174.0349862 327.3122045L-168.3670075 330.4388578L-162.6924645 333.568985L-157.007967 336.7046717L-151.3099766 339.8477716L-145.5949755 343.0002675L-139.8594091 346.1641848L-134.0996024 349.3414078L-128.3118665 352.533956L-122.4925112 355.7440836L-116.6376302 358.9737142L-110.7433264 362.225099L-104.8055918 365.5005346L-98.82024313 368.8021682L-92.62531355 371.4998415L-85.00988075 368.2182475L-78.88693487 371.133849L-72.79164732 374.4805616L-66.62778125 377.8649245L-60.39036761 381.289775L-54.07417747 384.7577652L-47.67381252 388.2720447L-41.18358736 391.8356596L-34.59755281 395.4518382L-27.90947446 399.1240797L-21.1127853 402.8559423L-14.2005738 406.6512281L-7.073090338 405.2170741L0 402.0966L6.964986642 399.0238175L13.82848234 395.9959229L20.59677894 393.0099544L27.27588339 390.0633052L33.87154548 387.1535364L40.38925466 384.2780889L46.83430336 381.4347913L53.21173568 378.621173L59.52647392 375.8353649L65.78319124 373.0750165L71.9864906 370.3383893L78.14073981 367.6232773L84.25026603 364.9279947L90.31919308 362.2504975L96.35162708 359.5891676L102.3515373 356.9422295L108.322781 354.3078519L114.2692312 351.6845318L120.1945861 349.0704244L126.1025874 346.4640115L131.9968784 343.8636246L137.8810742 341.2676342L143.7588518 338.674631L149.6336928 336.0827767L155.5092358 333.4906324L161.3890994 330.8966905L167.2767947 328.2991947L173.1759941 325.6966753L179.0902736 323.0874061L185.0234 320.4699294L190.9790539 317.842521L195.0096533 312.0806817L198.5326925 305.7135373L201.9908777 299.4637913L205.3879137 293.3243396L208.7275393 287.2888113L212.0131136 281.3509045L215.2478728 275.5047137L218.435031 269.7447986L221.5773739 264.0656313L224.6778458 258.4622956L227.7390703 252.9298616L230.7636249 247.4636908L233.753931 242.0592815L236.7124803 236.7124803L241.6 228.6L188 175.8L186.4 149.3C186.4 149.3 147.5 61.9 145.2 57.8C145.2 57.8 33.3 -38.3 33.3 -38.3C37.8 -32.2 3.7 -74.4 -33 -38.3Z';
                if (id === 3312) return 'M-245.3 232.7L-239.5824853 239.5824853L-235.6502789 244.0230072L-231.7073742 248.475738L-227.7511815 252.9433125L-223.7793074 257.4286454L-219.7892673 261.9346489L-215.7783549 266.464077L-211.7440202 271.0199869L-207.683536 275.6053609L-203.5942343 280.2234232L-199.4731935 284.8772437L-195.3175255 289.5701398L-191.12424 294.3055209L-186.8902304 299.0868888L-182.6123119 303.9179239L-178.2871 308.8023155L-173.9111494 313.7440187L-169.4808304 318.747083L-164.9924053 323.8158281L-160.4418671 328.9545764L-155.8251852 334.1681881L-151.1379676 339.4614333L-146.3756172 344.8393441L-141.1255794 349.2980662L-135.4299359 352.807045L-129.6968087 356.3390533L-123.9223415 359.8966121L-118.1024943 363.4821025L-112.2331356 367.0980455L-106.3100481 370.7471971L-100.3287699 374.4320669L-94.28480098 378.1556821L-88.17336742 381.9208137L-81.98953866 385.7304522L-75.72823592 389.5880002L-69.38404668 393.4964825L-62.95140317 397.4595171L-56.42442146 401.4806201L-49.79695929 405.5636875L-42.89999699 408.1662064L-35.65260794 407.5111735L-28.45042894 406.8600891L-21.28870739 406.2127356L-14.16277066 405.5686879L-7.068032631 404.9273182L0 404.2885L7.045765105 403.6516125L14.07364084 403.0163437L21.08796236 402.3822923L28.09303165 401.7490697L35.09312908 401.1163009L42.09252506 400.4836242L48.84331949 397.7969146L55.31967931 393.6199712L61.69230909 389.50991L67.96747694 385.4627163L74.15114233 381.4745571L80.24898515 377.5417918L86.26638985 373.6607864L92.20857889 369.8284101L98.08048654 366.041359L103.8868374 362.2964572L109.6322554 358.5909497L115.3211251 354.9219281L120.9576853 351.2866254L126.5460507 347.682417L132.0901975 344.106729L137.5939757 340.5570405L143.0611623 337.0309776L148.4953997 333.5261284L153.0119423 328.1351691L157.4169308 322.7525379L161.7517304 317.4556453L166.0205902 312.2393178L170.2275659 307.0986581L174.37645 302.028871L178.4709937 297.025613L182.514634 292.0844709L186.5107661 287.2013941L190.4626127 282.3724356L194.373296 277.5938352L198.2457412 272.861854L202.082925 268.1730991L205.8875405 263.5240346L209.6623677 258.9114617L213.4099217 254.3320408L217.1329046 249.7828336L220.8337093 245.2606813L224.5147467 240.7625893L228.178464 236.2857164L231.827221 231.827221L241 221.2L173.1 155.2L154 100L128 54.7C128 54.7 99.5 26.9 50.5 -24C1.5 -74.8 -39.2 -28.1 -39.2 -28.1L-157.2 91.5L-197 182.8L-245.3 232.7Z';
                if (id === 3313) return 'M1.4 -62.1C-31 -62.1 -51.8 -35.8 -51.8 -35.8L-131.5 65.5L-175.9 164.7C-175.9 164.7 -220.5 206.3 -220.5 206.3L-224.837329 224.837329L-224.6653682 232.6477992L-223.6883693 239.8764081L-222.5877683 247.2087611L-221.1193816 254.3687509L-218.880687 260.8518451L-216.5945835 267.4720353L-213.8485359 273.713644L-210.7527324 279.6783222L-207.6047519 285.7434271L-203.4184243 290.5116172L-198.9578154 294.9670915L-194.4669076 299.4527776L-189.9426713 303.9718154L-185.3819291 308.527341L-180.78135 313.1224833L-176.137686 317.7607971L-171.4473998 322.4456622L-166.7069005 327.1807142L-161.9124269 331.9696709L-157.0600758 336.8164195L-152.1457797 341.7250162L-147.1653239 346.6997765L-142.1142037 351.7449972L-136.987833 356.8655059L-131.7812505 362.06601L-126.4893812 367.3518369L-121.0359618 372.5103869L-115.0042639 376.1619976L-108.9190934 379.8460197L-102.7759817 383.5651853L-96.57026132 387.3221629L-90.29715282 391.119939L-83.94912714 394.9495912L-77.1965493 397.1418177L-70.41503064 399.3434831L-63.54843531 401.2290297L-56.63184505 402.9565156L-49.68972645 404.6903461L-42.69788075 406.2431989L-35.64387494 407.4113548L-28.56223462 408.4589848L-21.40550554 408.4413771L-14.26247504 408.4238476L-7.128758279 408.4062883L0 408.3739L7.108724661 407.2585631L14.18302284 406.1486344L21.22742722 405.0434403L28.24375446 403.9045064L35.13853723 401.6353183L41.97702111 399.3846775L48.76400692 397.1509656L55.45676481 394.5953852L61.77742508 390.0473112L67.98789796 385.5785297L74.09473919 381.1843881L80.10413307 376.8603164L86.02195803 372.6020359L91.85384882 368.4056655L97.26719945 363.0061303L102.5674716 357.6952819L107.7659591 352.4865695L112.8685808 347.373773L117.8810337 342.3513803L122.8086598 337.4140198L127.656505 332.5565653L132.429387 327.7742348L137.1318565 323.0624085L141.768301 318.4168174L146.3428148 313.833179L150.8594245 309.3076576L155.3218629 304.8363199L159.7338496 300.4156783L164.0987966 296.0420656L168.4201 291.7121702L172.7010222 287.4227678L176.9447056 283.1707221L181.1541323 278.9529014L185.3322975 274.7664304L189.4820655 270.6084342L193.6062346 266.4761211L197.7075492 262.3667794L201.7885895 258.2776166L205.8520215 254.206076L209.864948 250.1073057L213.118873 245.1652185L216.3326685 240.261769L218.6070041 234.427311L220.8328685 228.6791296L221.8944213 221.8944213L220.8 211.6L187.5 173.5L132.1 72C132.1 72 49.1 -35.8 49.1 -35.8C49.3 -36 31.5 -62.1 1.4 -62.1Z';
                if (id === 4169) return 'M236.7388554 236.7388554L244.6 227.9L41.8 -30.5C41.8 -30.5 3.8 -84.8 -40.5 -31.3C-40.5 -31.3 -249.7 234.3 -249.7 234.3L-243.4376315 243.4376315L-240.1517346 248.6844011L-236.8372977 253.9769074L-233.4918537 259.3189749L-230.1128356 264.7145362L-226.6976914 270.1677882L-223.0663885 275.4640489L-219.140885 280.4875421L-215.1810679 285.5549218L-211.1840702 290.6699361L-207.1469006 295.8364331L-202.9498936 300.8855907L-198.4232745 305.5450484L-193.8605234 310.2416894L-189.2584147 314.9788964L-184.61355 319.7600484L-179.9224978 324.5887783L-174.8739319 328.8900318L-169.7366969 333.1270244L-164.5594872 337.3969488L-159.3386222 341.7027779L-154.0704168 346.0478219L-148.5815289 350.0361463L-142.9049982 353.7022823L-137.1759404 357.3555422L-131.4459681 361.1448293L-125.6400716 364.8852626L-119.7474536 368.5447666L-113.6571905 371.7559191L-107.3955907 374.532934L-100.9814339 376.867842L-94.42838163 378.7315526L-87.79922883 380.3002415L-81.24473661 382.2264341L-74.81473786 384.8884601L-68.49729489 388.4674632L-62.22152689 392.8512596L-56.00523208 398.4979327L-49.80942652 405.665225L-42.72430555 406.494614L-35.62545893 407.2008589L-28.50120468 407.586216L-21.36767711 407.7195677L-14.23024186 407.5008102L-7.105457571 407.0713916L0 406.5074L7.077683811 405.480234L14.11929636 404.3237468L21.12172952 403.026608L28.09179696 401.7314128L35.03559758 400.4587128L41.98377365 399.4489237L48.91310187 398.3652465L55.79382814 396.9937155L62.66082615 395.624886L69.47193002 393.9948937L76.217661 392.105874L82.94426914 390.222106L89.38983524 387.1899147L95.78116049 384.1572523L102.1277176 381.1458309L108.3415505 377.8318881L114.4286425 374.2792248L120.3750362 370.4762673L126.2261268 366.5872906L132.013619 362.7044372L137.4929527 358.1813875L142.9085195 353.7109978L147.8902474 348.4075891L152.5253057 342.5774455L157.0768537 336.8523999L161.5498063 331.2261884L165.9488271 325.6929115L170.2813733 320.2526853L174.5521647 314.9004408L178.7619 309.6246933L182.9144332 304.4207382L187.0133306 299.2838904L191.0620967 294.2098286L195.0640993 289.19442L199.020699 284.2310146L202.9363263 279.3178905L206.8143947 274.4519715L210.6577471 269.6296207L214.4691797 264.8473802L218.2513336 260.101811L222.0068327 255.3896465L225.7382359 250.7077099L229.4480501 246.0529095L233.1386721 241.4221622Z';
                if (id === 4705) return 'M231.4 222.7C231.4 222.7 197.7 189.4 197.7 189.4C202.9 172.8 199.8 154.7 189.3 140.8C175.4 123.7 40.1 -39 40.1 -39C40.1 -39 2.1 -86.8 -40.2 -41.5C-40.2 -41.5 -201.2 144.1 -201.2 144.1C-201.2 144.1 -217.5 169.8 -203.7 187.6C-203.7 187.6 -241.6 227.5 -241.6 227.5L-241.6 229.9L-238.8 235.7L-236.7588665 236.7588665L-234.1530817 242.4726141L-231.5111633 248.2653276L-228.8308907 254.142451L-226.109629 260.1093738L-223.3447184 266.1718705L-220.5334369 272.3361141L-217.6728403 278.6085304L-214.7597974 284.995877L-211.791076 291.5054079L-208.7631242 298.1446398L-205.6723242 304.9217602L-202.5147663 311.8453933L-199.2862078 318.9245995L-194.2736495 323.3256487L-188.84535 327.089741L-183.4013462 330.8647869L-177.9381728 334.6530308L-172.452468 338.4570255L-166.9406316 342.2790183L-161.399182 346.1216628L-155.8243872 349.987304L-150.2125969 353.8787018L-144.3009322 357.1573402L-138.0863383 359.7272099L-131.8662083 362.2994296L-125.6367182 364.8755238L-119.3940309 367.4570432L-113.1342837 370.045568L-106.8536049 372.6428052L-100.5480414 375.2503992L-94.21353079 377.869833L-87.84604114 380.5030079L-81.44137949 383.1515661L-74.99526225 385.8171776L-68.50333785 388.5017345L-61.96112608 391.2071536L-55.36399202 393.9352725L-48.70716706 396.688042L-41.98572833 399.4675212L-35.03508336 400.4528352L-27.99867904 400.3997646L-20.98129121 400.3468856L-13.9785781 400.294103L-6.986240183 400.241432L0 400.1887L6.984400699 400.1360481L13.9712178 400.0833315L20.96471642 400.0306196L27.96917205 399.977795L34.98889953 399.9249517L41.96723725 399.2915903L48.60157946 395.8281001L55.14959586 392.4097646L61.61686075 389.0335479L68.00873574 385.6967066L74.33036922 382.3965995L80.58667532 379.1304991L86.78245006 375.8960888L92.92224848 372.6907825L99.01055277 369.5124134L105.0516808 366.3587491L111.0497611 363.227402L117.008945 360.1165037L122.9331677 357.023843L128.826299 353.9473477L134.6921638 350.885083L140.5345251 347.8351556L145.7340367 343.3278751L150.178842 337.3072017L154.5364531 331.4044932L158.812047 325.61295L163.0104644 319.92605L167.1361955 314.3374662L171.193646 308.8415128L175.1868 303.4324384L179.1196842 298.1052153L182.9959067 292.8546681L186.8189773 287.6759978L190.5923455 282.5647723L194.3192077 277.5165892L198.0025744 272.5271637L201.6455258 267.5926509L205.2508234 262.7090739L208.821218 257.8727284L212.3594139 253.0800944L215.8678915 248.3276026L219.3492431 243.6120145L222.805727 238.9298901L226.2398808 234.2782548L229.6537868 229.6537868L231.8 227.1L231.4 222.7Z';
                return 'M4.2 -55.7C-38.4 -55.7 -61.9 -30.5 -61.9 -30.5L-62.3 -21.4L-100.6 24.4L-110.5 24.4L-161.3 110.7L-229 228.2L-231.613109 231.613109L-235.0230718 243.3735153L-235.4938973 252.5362869L-234.6123129 260.5633709L-232.6639868 267.6492999L-229.5575178 273.5759965L-225.429109 278.3817657L-221.2107389 283.1368342L-217.0027018 287.9723117L-212.7537507 292.830416L-208.4532782 297.7021338L-204.1701643 302.6947165L-199.8347065 307.7184632L-195.5279674 312.9101576L-191.1130153 318.0654702L-186.6102 323.2183476L-181.9929257 328.3239292L-176.9720003 332.8359246L-171.8050322 337.1863611L-166.569682 341.5184588L-161.2830465 345.8726094L-155.8867806 350.1274419L-150.3832682 354.2807783L-144.8145927 358.4286947L-139.0893027 362.3400215L-133.314048 366.2773364L-127.4059858 370.0138499L-121.4489012 373.7812838L-115.352157 377.2999046L-109.1838983 380.7695038L-102.9208168 384.1057174L-96.53443269 387.1784621L-90.10173784 390.2735037L-83.59330707 393.2755894L-76.93344278 395.788252L-70.23382876 398.3158362L-63.44105869 400.5510804L-56.57642633 402.5621909L-49.67661331 404.5835482L-42.66351179 405.9162001L-35.61554061 407.0874919L-28.54845771 408.2619659L-21.44816458 409.25536L-14.31121218 409.8194969L-7.159048675 410.1416239L0 410.0718L7.15661232 410.0020452L14.3116589 409.8322891L21.43418565 408.9886261L28.54040782 408.146847L35.63470615 407.3065551L42.65037256 405.7911887L49.63631112 404.2553132L56.5992368 402.7244958L63.44656518 400.585847L70.19894284 398.1179883L76.88026431 395.5146725L83.51939446 392.9278579L89.99538098 389.8128215L96.3497979 386.4379324L102.6492638 383.092268L108.8982553 379.7733483L115.1011558 376.478917L121.262224 373.2067505L127.2248071 369.4876688L133.0547967 365.5650494L138.8345389 361.6763392L144.5681016 357.8186077L150.2595237 353.9892544L155.8251194 349.9889484L161.1826747 345.6573613L166.4939753 341.3632371L171.7628111 337.1034975L176.9928448 332.8751275L181.8953821 328.1479557L186.48665 323.0043527L191.0039817 317.8840079L195.5353862 312.9220302L200.0086098 307.9862507L204.435054 303.0874316L208.8234071 298.2307326L213.1767797 293.4126655L217.4830103 288.6097027L221.7253088 283.7954536L225.913434 278.9798572L229.9746226 274.0730827L232.650472 267.6337529L234.4681822 260.4032975L235.4595928 252.4994998L234.7611161 243.1022523L231.4683643 231.4683643L228.4 216.9C214.5 182.1 182.1 141.7 179 129C176 116.3 122.4 27.5 115.8 24.9C109.2 22.3 106.6 24.9 106.6 24.9L68.3 -19.5C68.3 -19.5 68.8 -29.8 68.8 -29.8C68.6 -30.1 46.7 -55.7 4.2 -55.7Z';
            }
        }
    ]);
}();
var $21d7bbe4847c951e$var$_default = module.exports["default"] = $21d7bbe4847c951e$var$Stadiums;

});


parcelRegister("bChNI", function(module, exports) {
"use strict";
function $87510d2f2c6bce1f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $87510d2f2c6bce1f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $87510d2f2c6bce1f$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $87510d2f2c6bce1f$var$_react = $87510d2f2c6bce1f$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $87510d2f2c6bce1f$var$THREE = $87510d2f2c6bce1f$var$_interopRequireWildcard((parcelRequire("h8GDa")));

function $87510d2f2c6bce1f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($87510d2f2c6bce1f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $87510d2f2c6bce1f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $87510d2f2c6bce1f$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $87510d2f2c6bce1f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ function $87510d2f2c6bce1f$var$Mound(props) {
    var mesh = (0, $87510d2f2c6bce1f$var$_react.useRef)();
    var moundShape = new $87510d2f2c6bce1f$var$THREE.Shape();
    var radius = 8;
    var extrudeSettings = {
        depth: 2,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1
    };
    var rx = 0;
    var ry = 0;
    var rz = 0;
    var s = 1;
    var moundPosition = [
        0,
        59,
        0
    ];
    // Set mound position
    if (props.position && props.position.length == 3) {
        moundPosition[0] = props.position[0];
        moundPosition[1] = props.position[1] + 59;
        moundPosition[2] = props.position[2];
    }
    moundShape.moveTo(0, 0);
    moundShape.absarc(0, 0, radius, 0, 2 * Math.PI, false);
    var geometry = new $87510d2f2c6bce1f$var$THREE.ExtrudeGeometry(moundShape, extrudeSettings);
    return /*#__PURE__*/ $87510d2f2c6bce1f$var$_react["default"].createElement("group", null, /*#__PURE__*/ $87510d2f2c6bce1f$var$_react["default"].createElement("mesh", {
        ref: mesh,
        rotation: [
            rx,
            ry,
            rz
        ],
        position: moundPosition,
        geometry: geometry,
        material: new $87510d2f2c6bce1f$var$THREE.MeshPhongMaterial({
            color: 0xffffff
        })
    }));
}
var $87510d2f2c6bce1f$var$_default = module.exports["default"] = $87510d2f2c6bce1f$var$Mound;

});

parcelRegister("cHmPj", function(module, exports) {
"use strict";
function $93eb351793a736ad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $93eb351793a736ad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $93eb351793a736ad$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $93eb351793a736ad$var$_react = $93eb351793a736ad$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $93eb351793a736ad$var$THREE = $93eb351793a736ad$var$_interopRequireWildcard((parcelRequire("h8GDa")));

function $93eb351793a736ad$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($93eb351793a736ad$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $93eb351793a736ad$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $93eb351793a736ad$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $93eb351793a736ad$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ function $93eb351793a736ad$var$Base(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? '1b' : _ref$type, _ref$position = _ref.position, position = _ref$position === void 0 ? [
        0,
        0,
        3
    ] : _ref$position;
    var mesh = (0, $93eb351793a736ad$var$_react.useRef)();
    var homePlate = {
        x: 0,
        y: 0
    };
    var n = Math.sqrt(4050);
    var baseRadius = Math.sqrt(2);
    var basePosition = {};
    if (type === '1b') {
        basePosition.x = position[0] + (homePlate.x + n - baseRadius);
        basePosition.y = homePlate.y + n;
    }
    if (type === '2b') {
        basePosition.x = position[0] + homePlate.x;
        basePosition.y = homePlate.y + 2 * n;
    }
    if (type === '3b') {
        basePosition.x = position[0] + (homePlate.x - n + baseRadius);
        basePosition.y = homePlate.y + n;
    }
    var rotationZ = 0.25 * Math.PI;
    var geometry = new $93eb351793a736ad$var$THREE.BoxGeometry(2, 2, 0.5);
    var material = new $93eb351793a736ad$var$THREE.MeshLambertMaterial({
        color: 0xc2c2c2
    });
    return /*#__PURE__*/ $93eb351793a736ad$var$_react["default"].createElement("mesh", {
        ref: mesh,
        rotation: [
            0,
            0,
            rotationZ
        ],
        name: "base_".concat(type),
        position: [
            basePosition.x,
            basePosition.y,
            6
        ],
        geometry: geometry,
        material: material
    });
}
var $93eb351793a736ad$var$_default = module.exports["default"] = $93eb351793a736ad$var$Base;

});

parcelRegister("3aodB", function(module, exports) {
"use strict";
function $24e517881acfd182$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24e517881acfd182$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24e517881acfd182$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $24e517881acfd182$var$_react = $24e517881acfd182$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $24e517881acfd182$var$THREE = $24e517881acfd182$var$_interopRequireWildcard((parcelRequire("h8GDa")));

function $24e517881acfd182$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24e517881acfd182$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24e517881acfd182$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $24e517881acfd182$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $24e517881acfd182$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ function $24e517881acfd182$var$HomePlate(_ref) {
    var _ref$position = _ref.position, position = _ref$position === void 0 ? [
        0,
        0,
        3
    ] : _ref$position;
    var mesh = (0, $24e517881acfd182$var$_react.useRef)();
    var rectWidth = 17 / 12.0;
    var halfRectWidth = 0.5 * rectWidth;
    var rectLength = 17 / 12.0;
    var halfRectLength = 0.5 * rectWidth;
    var rectShape = new $24e517881acfd182$var$THREE.Shape();
    rectShape.moveTo(0, 0);
    rectShape.lineTo(halfRectWidth, halfRectLength);
    rectShape.lineTo(halfRectWidth, rectLength);
    rectShape.lineTo(-halfRectWidth, rectLength);
    rectShape.lineTo(-halfRectWidth, halfRectLength);
    rectShape.lineTo(0, 0);
    var geometry = new $24e517881acfd182$var$THREE.ExtrudeGeometry(rectShape, {
        depth: 0.1,
        steps: 1,
        bevelEnabled: false
    });
    var material = new $24e517881acfd182$var$THREE.MeshBasicMaterial({
        color: 0xc2c2c2
    });
    return /*#__PURE__*/ $24e517881acfd182$var$_react["default"].createElement("mesh", {
        ref: mesh,
        name: "base_hp",
        position: [
            position[0],
            0,
            6
        ],
        geometry: geometry,
        material: material
    });
}
var $24e517881acfd182$var$_default = module.exports["default"] = $24e517881acfd182$var$HomePlate;

});

parcelRegister("cFDIZ", function(module, exports) {
"use strict";
function $939820ddd20c5385$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $939820ddd20c5385$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $939820ddd20c5385$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $939820ddd20c5385$var$_react = $939820ddd20c5385$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $939820ddd20c5385$var$THREE = $939820ddd20c5385$var$_interopRequireWildcard((parcelRequire("h8GDa")));


var $kgDOI = parcelRequire("kgDOI");

var $939820ddd20c5385$var$_BaseLine = $939820ddd20c5385$var$_interopRequireDefault((parcelRequire("9qiXz")));

var $939820ddd20c5385$var$_FoulPole = $939820ddd20c5385$var$_interopRequireDefault((parcelRequire("h093E")));
function $939820ddd20c5385$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $939820ddd20c5385$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($939820ddd20c5385$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $939820ddd20c5385$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $939820ddd20c5385$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $939820ddd20c5385$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $939820ddd20c5385$var$_extends() {
    return $939820ddd20c5385$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $939820ddd20c5385$var$_extends.apply(null, arguments);
} /* eslint-disable */ 
function $939820ddd20c5385$var$Fence(props) {
    var mesh = (0, $939820ddd20c5385$var$_react.useRef)();
    var _toFenceGeometry = (0, $kgDOI.toFenceGeometry)({
        venueId: props.venueId,
        squaredSegmentJoins: true
    }), geometry = _toFenceGeometry.geometry, distance = _toFenceGeometry.distance;
    return /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement("group", null, /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement("mesh", {
        useRef: mesh,
        position: props.position || [
            0,
            0,
            0
        ],
        material: new $939820ddd20c5385$var$THREE.MeshBasicMaterial({
            color: 0x77c6bf,
            // shininess: 1,
            // specular: '#ffffff',
            wireframe: false,
            flatShading: false,
            wireframeLinewidth: 0.4,
            transparent: true,
            side: $939820ddd20c5385$var$THREE.DoubleSide,
            opacity: 1
        }),
        geometry: geometry
    }), /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement($939820ddd20c5385$var$_BaseLine["default"], $939820ddd20c5385$var$_extends({}, props, {
        side: "l",
        dist: distance.lf
    })), /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement($939820ddd20c5385$var$_BaseLine["default"], $939820ddd20c5385$var$_extends({}, props, {
        side: "r",
        dist: distance.rf
    })), /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement($939820ddd20c5385$var$_FoulPole["default"], $939820ddd20c5385$var$_extends({}, props, {
        side: "l",
        dist: distance.lf
    })), /*#__PURE__*/ $939820ddd20c5385$var$_react["default"].createElement($939820ddd20c5385$var$_FoulPole["default"], $939820ddd20c5385$var$_extends({}, props, {
        side: "r",
        dist: distance.rf
    })));
}
var $939820ddd20c5385$var$_default = module.exports["default"] = $939820ddd20c5385$var$Fence;

});
parcelRegister("kgDOI", function(module, exports) {
"use strict";
function $ec143014a92f2248$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec143014a92f2248$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec143014a92f2248$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toFenceMap = module.exports.toFenceGeometry = module.exports.toAllFencesGroup = void 0;

var $61RGp = parcelRequire("61RGp");

var $ec143014a92f2248$var$THREE = $ec143014a92f2248$var$_interopRequireWildcard((parcelRequire("h8GDa")));

var $ec143014a92f2248$var$_groupBy = $ec143014a92f2248$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $ec143014a92f2248$var$_mapValues = $ec143014a92f2248$var$_interopRequireDefault((parcelRequire("7wHWI")));

var $ec143014a92f2248$var$_orderBy = $ec143014a92f2248$var$_interopRequireDefault((parcelRequire("4u1Vd")));

var $ec143014a92f2248$var$_find = $ec143014a92f2248$var$_interopRequireDefault((parcelRequire("ihZKh")));

var $le4ng = parcelRequire("le4ng");

var $ax2xX = parcelRequire("ax2xX");
function $ec143014a92f2248$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ec143014a92f2248$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ec143014a92f2248$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ec143014a92f2248$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $ec143014a92f2248$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $ec143014a92f2248$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ec143014a92f2248$var$_toConsumableArray(r) {
    return $ec143014a92f2248$var$_arrayWithoutHoles(r) || $ec143014a92f2248$var$_iterableToArray(r) || $ec143014a92f2248$var$_unsupportedIterableToArray(r) || $ec143014a92f2248$var$_nonIterableSpread();
}
function $ec143014a92f2248$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ec143014a92f2248$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ec143014a92f2248$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ec143014a92f2248$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ec143014a92f2248$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $ec143014a92f2248$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ec143014a92f2248$var$_arrayLikeToArray(r);
}
function $ec143014a92f2248$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
} // import fenceLidar from "./Lidar/FenceData";
var $ec143014a92f2248$var$toFenceMap = module.exports.toFenceMap = function toFenceMap(_ref) {
    var data = _ref.data;
    var map = (0, $ec143014a92f2248$var$_groupBy["default"])(data, 'venue_id');
    map = (0, $ec143014a92f2248$var$_mapValues["default"])(map, function(d) {
        return {
            venueId: d[0].venue_id,
            points: (0, $ec143014a92f2248$var$_orderBy["default"])(d, 'angle').map($ax2xX.toPoint)
        };
    });
    return map;
};
// const getFencePoints = (venueId) => {
//     const fences = fenceLidar.fenceMap[venueId]
//     const points = fences.map((d) => ({
//         venueId: d.venueId,
//         angle: d.angle,
//         x: d.x,
//         y: d.y,
//         z: d.z,
//         distance: d.distance,
//     }))
//     return points
// }
var $ec143014a92f2248$var$toSegments = function toSegments(points) {
    var segments = [];
    var segment = [];
    var z = null;
    points.forEach(function(p) {
        if (p.z === z) segment.push(p);
        else {
            if (segment.length > 0) segments.push(segment);
            segment = [
                p
            ];
            z = p.z;
        }
    });
    if (segment.length > 0) segments.push(segment);
    return segments;
};
var $ec143014a92f2248$var$toCappedSegments = function toCappedSegments(segments) {
    var copy = $ec143014a92f2248$var$_toConsumableArray(segments);
    var pairs = (0, $61RGp.default)(copy);
    pairs.forEach(function(pair) {
        var segment0 = pair[0];
        var segment1 = pair[1];
        var p = segment0[segment0.length - 1];
        var q = segment1[0];
        var x = 0.5 * (p.x + q.x);
        var y = 0.5 * (p.y + q.y);
        segment0.push({
            x: x,
            y: y,
            z: p.z
        });
        segment1.unshift({
            x: x,
            y: y,
            z: q.z
        });
    });
    return copy;
};
var $ec143014a92f2248$var$addFenceVerticesAndFaces = function addFenceVerticesAndFaces(_ref2) {
    var geometry = _ref2.geometry, points = _ref2.points, _ref2$vertexOffset = _ref2.vertexOffset, vertexOffset = _ref2$vertexOffset === void 0 ? 0 : _ref2$vertexOffset;
    var pointPairs = (0, $61RGp.default)(points);
    points.forEach(function(p) {
        geometry.vertices.push(new $ec143014a92f2248$var$THREE.Vector3(p.x, p.y, p.z), new $ec143014a92f2248$var$THREE.Vector3(p.x, p.y, 0));
    });
    pointPairs.forEach(function(pair, i) {
        var j = vertexOffset + 2 * i;
        geometry.faces.push(new $ec143014a92f2248$var$THREE.Face3(j, j + 1, j + 2), new $ec143014a92f2248$var$THREE.Face3(j + 2, j + 1, j + 3));
    });
};
var $ec143014a92f2248$var$toFenceGeometry = module.exports.toFenceGeometry = function toFenceGeometry(_ref3) {
    var venueId = _ref3.venueId, _ref3$squaredSegmentJ = _ref3.squaredSegmentJoins, squaredSegmentJoins = _ref3$squaredSegmentJ === void 0 ? true : _ref3$squaredSegmentJ;
    var points = $le4ng.fenceMap[venueId];
    // If venue doesn't exist default to KC
    if (!points) // eslint-disable-next-line prefer-destructuring
    points = $le4ng.fenceMap[7];
    var distance = {
        lf: (0, $ec143014a92f2248$var$_find["default"])(points, function(d) {
            return d.angle === -45;
        }).distance,
        rf: (0, $ec143014a92f2248$var$_find["default"])(points, function(d) {
            return d.angle === 45;
        }).distance
    };
    var segments = $ec143014a92f2248$var$toSegments(points);
    var geometry = new $ec143014a92f2248$var$THREE.Geometry();
    if (squaredSegmentJoins) {
        var cappedSegments = $ec143014a92f2248$var$toCappedSegments(segments);
        var vertexOffset = 0;
        cappedSegments.forEach(function(segment) {
            $ec143014a92f2248$var$addFenceVerticesAndFaces({
                geometry: geometry,
                points: segment,
                vertexOffset: vertexOffset
            });
            vertexOffset += 2 * segment.length;
        });
    } else {
        var pointPairs = (0, $61RGp.default)(points);
        // add vertices
        points.forEach(function(p) {
            geometry.vertices.push(new $ec143014a92f2248$var$THREE.Vector3(p.x, p.y, p.z), new $ec143014a92f2248$var$THREE.Vector3(p.x, p.y, 0));
        });
        // add faces – 2 faces for each point pair
        pointPairs.forEach(function(pair, i) {
            var j = 2 * i;
            geometry.faces.push(new $ec143014a92f2248$var$THREE.Face3(j, j + 1, j + 2), new $ec143014a92f2248$var$THREE.Face3(j + 2, j + 1, j + 3));
        });
    }
    geometry.computeFaceNormals();
    geometry.computeFlatVertexNormals();
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();
    return {
        geometry: new $ec143014a92f2248$var$THREE.BufferGeometry().fromGeometry(geometry),
        distance: distance
    };
};
var $ec143014a92f2248$var$toAllFencesGroup = module.exports.toAllFencesGroup = function toAllFencesGroup() {
    var g = new $ec143014a92f2248$var$THREE.Group();
    return g;
};

});
parcelRegister("61RGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $463c7a675b2fa522$export$2e2bcd8739ae039);
function $463c7a675b2fa522$export$2e2bcd8739ae039(values, pairof = $463c7a675b2fa522$export$a04cb3fe8b81dd) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $463c7a675b2fa522$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("7wHWI", function(module, exports) {

var $l8IaK = parcelRequire("l8IaK");

var $9gOGv = parcelRequire("9gOGv");

var $hUuQW = parcelRequire("hUuQW");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $57ad9c4fd8d41973$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $hUuQW(iteratee, 3);
    $9gOGv(object, function(value, key, object) {
        $l8IaK(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $57ad9c4fd8d41973$var$mapValues;

});

parcelRegister("4u1Vd", function(module, exports) {

var $bTUVC = parcelRequire("bTUVC");

var $9yDvq = parcelRequire("9yDvq");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $343b7465984c8a05$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$9yDvq(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$9yDvq(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $bTUVC(collection, iteratees, orders);
}
module.exports = $343b7465984c8a05$var$orderBy;

});

parcelRegister("le4ng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fencesLidar = module.exports.fenceMap = void 0;

var $aGeJV = parcelRequire("aGeJV");

var $f73e4c6c39cdd830$var$_groupBy2 = $f73e4c6c39cdd830$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $f73e4c6c39cdd830$var$_mapValues2 = $f73e4c6c39cdd830$var$_interopRequireDefault((parcelRequire("7wHWI")));

var $f73e4c6c39cdd830$var$_orderBy2 = $f73e4c6c39cdd830$var$_interopRequireDefault((parcelRequire("4u1Vd")));
function $f73e4c6c39cdd830$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ // Query is roughly...
// select f.venue_id,
//        f.venue_name_short,
//        f.park,
//        f.angle,
//        f.fence_height,
//        f.fence_distance,
//        f.fence_x,
//        f.fence_y,
//        f.fence_x_inches,
//        f.fence_y_inches
// from fences_v f
//          join (select venue_id, max(year_max) recent_year
//                from fences_v
//                group by venue_id) m on f.venue_id = m.venue_id and f.year_max = m.recent_year
// order by f.venue_id, angle
var $f73e4c6c39cdd830$var$csv = "venue_id,venue_name_short,park,angle,fence_height,fence_distance,fence_x,fence_y,fence_x_inches,fence_y_inches\n1,Angel Stadium,Angel Stadium,-45,3.18,329.63218838304965,-233,233,-2796,2796\n1,Angel Stadium,Angel Stadium,-44,3.21,339.00698658195694,-235,244,-2820,2928\n1,Angel Stadium,Angel Stadium,-43,3.18,345.3787487024481,-236,253,-2832,3036\n1,Angel Stadium,Angel Stadium,-42,3.18,350.58120410488425,-235,261,-2820,3132\n1,Angel Stadium,Angel Stadium,-41,3.12,354.67274207880126,-233,268,-2796,3216\n1,Angel Stadium,Angel Stadium,-40,3.12,357.7864291311607,-230,274,-2760,3288\n1,Angel Stadium,Angel Stadium,-39,3.13,360.03925821111415,-227,280,-2724,3360\n1,Angel Stadium,Angel Stadium,-38,6.63,362.3299979807358,-223,286,-2676,3432\n1,Angel Stadium,Angel Stadium,-37,6.63,363.58532254494173,-219,290,-2628,3480\n1,Angel Stadium,Angel Stadium,-36,6.51,364.74217810926376,-214,295,-2568,3540\n1,Angel Stadium,Angel Stadium,-35,6.47,365.95619206737854,-210,300,-2520,3600\n1,Angel Stadium,Angel Stadium,-34,6.47,367.28913575433677,-205,304,-2460,3648\n1,Angel Stadium,Angel Stadium,-33,6.47,368.7445588377388,-201,309,-2412,3708\n1,Angel Stadium,Angel Stadium,-32,6.47,370.32481565866505,-196,314,-2352,3768\n1,Angel Stadium,Angel Stadium,-31,6.47,372.03248761601617,-192,319,-2304,3828\n1,Angel Stadium,Angel Stadium,-30,6.47,373.8703937757183,-187,324,-2244,3888\n1,Angel Stadium,Angel Stadium,-29,6.47,375.8416026289867,-182,329,-2184,3948\n1,Angel Stadium,Angel Stadium,-28,6.47,377.9494450938511,-177,334,-2124,4008\n1,Angel Stadium,Angel Stadium,-27,6.47,380.19752886613406,-173,339,-2076,4068\n1,Angel Stadium,Angel Stadium,-26,6.47,382.5897542394963,-168,344,-2016,4128\n1,Angel Stadium,Angel Stadium,-25,6.47,385.1303315292439,-163,349,-1956,4188\n1,Angel Stadium,Angel Stadium,-24,6.47,387.8238002515848,-158,354,-1896,4248\n1,Angel Stadium,Angel Stadium,-23,6.56,389.5704416471529,-152,359,-1824,4308\n1,Angel Stadium,Angel Stadium,-22,6.56,388.6317813878445,-146,360,-1752,4320\n1,Angel Stadium,Angel Stadium,-21,6.56,387.81548201266287,-139,362,-1668,4344\n1,Angel Stadium,Angel Stadium,-20,6.56,387.1202780527236,-132,364,-1584,4368\n1,Angel Stadium,Angel Stadium,-19,6.56,386.54509678578444,-126,365,-1512,4380\n1,Angel Stadium,Angel Stadium,-18,6.56,386.08905417187674,-119,367,-1428,4404\n1,Angel Stadium,Angel Stadium,-17,6.56,385.75145152288474,-113,369,-1356,4428\n1,Angel Stadium,Angel Stadium,-16,6.56,385.5317728826112,-106,371,-1272,4452\n1,Angel Stadium,Angel Stadium,-15,6.56,385.4296830989866,-100,372,-1200,4464\n1,Angel Stadium,Angel Stadium,-14,6.56,385.44502657498697,-93,374,-1116,4488\n1,Angel Stadium,Angel Stadium,-13,6.56,385.57782668958544,-87,376,-1044,4512\n1,Angel Stadium,Angel Stadium,-12,6.56,385.82828588472097,-80,377,-960,4524\n1,Angel Stadium,Angel Stadium,-11,6.56,386.19678641889004,-74,379,-888,4548\n1,Angel Stadium,Angel Stadium,-10,6.56,386.6838917925857,-67,381,-804,4572\n1,Angel Stadium,Angel Stadium,-9,6.56,387.29034885549095,-61,383,-732,4596\n1,Angel Stadium,Angel Stadium,-8,6.56,388.01709061012957,-54,384,-648,4608\n1,Angel Stadium,Angel Stadium,-7,6.56,388.86523973163145,-47,386,-564,4632\n1,Angel Stadium,Angel Stadium,-6,6.56,389.8361128284512,-41,388,-492,4656\n1,Angel Stadium,Angel Stadium,-5,6.56,390.931225474343,-34,389,-408,4668\n1,Angel Stadium,Angel Stadium,-4,6.56,392.1522980477054,-27,391,-324,4692\n1,Angel Stadium,Angel Stadium,-3,6.56,393.5012624206419,-21,393,-252,4716\n1,Angel Stadium,Angel Stadium,-2,6.56,394.98026954681495,-14,395,-168,4740\n1,Angel Stadium,Angel Stadium,-1,6.56,396.5916980044886,-7,397,-84,4764\n1,Angel Stadium,Angel Stadium,0,6.56,398.3381635591541,0,398,0,4776\n1,Angel Stadium,Angel Stadium,1,6.56,400.222529818931,7,400,84,4800\n1,Angel Stadium,Angel Stadium,2,6.56,402.2479200656505,14,402,168,4824\n1,Angel Stadium,Angel Stadium,3,6.55,402.61398753247454,21,402,252,4824\n1,Angel Stadium,Angel Stadium,4,6.55,399.3044936389025,28,398,336,4776\n1,Angel Stadium,Angel Stadium,5,6.55,396.16865728149065,35,395,420,4740\n1,Angel Stadium,Angel Stadium,6,6.55,393.2005295450834,41,391,492,4692\n1,Angel Stadium,Angel Stadium,7,6.55,390.3945796378452,48,387,576,4644\n1,Angel Stadium,Angel Stadium,8,6.55,387.7456676953117,54,384,648,4608\n1,Angel Stadium,Angel Stadium,9,6.55,385.24902007456086,60,381,720,4572\n1,Angel Stadium,Angel Stadium,10,6.55,382.9002069040999,66,377,792,4524\n1,Angel Stadium,Angel Stadium,11,6.55,380.6951216818068,73,374,876,4488\n1,Angel Stadium,Angel Stadium,12,6.55,378.6299627367836,79,370,948,4440\n1,Angel Stadium,Angel Stadium,13,6.55,376.7012163917119,85,367,1020,4404\n1,Angel Stadium,Angel Stadium,14,6.55,374.90564168062747,91,364,1092,4368\n1,Angel Stadium,Angel Stadium,15,6.55,373.2402564932741,97,361,1164,4332\n1,Angel Stadium,Angel Stadium,16,6.55,371.70232503162936,102,357,1224,4284\n1,Angel Stadium,Angel Stadium,17,6.55,370.2893464770653,108,354,1296,4248\n1,Angel Stadium,Angel Stadium,18,6.55,368.99904477811566,114,351,1368,4212\n1,Angel Stadium,Angel Stadium,19,6.55,367.8293594791463,120,348,1440,4176\n1,Angel Stadium,Angel Stadium,20,6.55,366.77843751953304,125,345,1500,4140\n1,Angel Stadium,Angel Stadium,21,6.55,365.8446259413645,131,342,1572,4104\n1,Angel Stadium,Angel Stadium,22,6.55,365.0264654513424,137,338,1644,4056\n1,Angel Stadium,Angel Stadium,23,6.55,364.32268478953637,142,335,1704,4020\n1,Angel Stadium,Angel Stadium,24,6.55,363.7321958640755,148,332,1776,3984\n1,Angel Stadium,Angel Stadium,25,6.55,363.2540896167965,154,329,1848,3948\n1,Angel Stadium,Angel Stadium,26,6.55,362.88763259040087,159,326,1908,3912\n1,Angel Stadium,Angel Stadium,27,6.55,362.6322641728634,165,323,1980,3876\n1,Angel Stadium,Angel Stadium,28,6.55,362.4875944997513,170,320,2040,3840\n1,Angel Stadium,Angel Stadium,29,6.55,362.4534029998053,176,317,2112,3804\n1,Angel Stadium,Angel Stadium,30,6.55,362.5296375736711,181,314,2172,3768\n1,Angel Stadium,Angel Stadium,31,6.55,362.7164144000821,187,311,2244,3732\n1,Angel Stadium,Angel Stadium,32,6.55,363.01401836814966,192,308,2304,3696\n1,Angel Stadium,Angel Stadium,33,6.55,363.4229041387587,198,305,2376,3660\n1,Angel Stadium,Angel Stadium,34,6.55,363.9436978424365,204,302,2448,3624\n1,Angel Stadium,Angel Stadium,35,6.56,364.6425020123418,209,299,2508,3588\n1,Angel Stadium,Angel Stadium,36,6.67,364.6283992589662,214,295,2568,3540\n1,Angel Stadium,Angel Stadium,37,6.54,363.7122188001717,219,290,2628,3480\n1,Angel Stadium,Angel Stadium,38,6.54,362.5879310375426,223,286,2676,3432\n1,Angel Stadium,Angel Stadium,39,3.15,360.27582247919315,227,280,2724,3360\n1,Angel Stadium,Angel Stadium,40,3.25,358.10921131727207,230,274,2760,3288\n1,Angel Stadium,Angel Stadium,41,3.25,354.9036368747739,233,268,2796,3216\n1,Angel Stadium,Angel Stadium,42,3.21,350.7630727090453,235,261,2820,3132\n1,Angel Stadium,Angel Stadium,43,3.18,345.4293863553374,236,253,2832,3036\n1,Angel Stadium,Angel Stadium,44,3.22,338.97995895887277,235,244,2820,2928\n1,Angel Stadium,Angel Stadium,45,3.21,329.5501850626354,233,233,2796,2796\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-45,6.420330162,332.91458075438345,-235,235,-2820,2820\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-44,6.465316613,340.4282311331902,-236,245,-2832,2940\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-43,6.465316613,353.2748479349407,-241,258,-2892,3096\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-42,6.465316613,367.2453179042321,-246,273,-2952,3276\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-41,7.891527957,371.0658166657953,-243,280,-2916,3360\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-40,7.891527957,370.3786921701508,-238,284,-2856,3408\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-39,7.891527957,369.8065461964013,-233,287,-2796,3444\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-38,7.891527957,369.3484987543153,-227,291,-2724,3492\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-37,7.891527957,369.0038476921942,-222,295,-2664,3540\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-36,7.891527957,368.7720660618099,-217,298,-2604,3576\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-35,7.891527957,368.6528001483445,-211,302,-2532,3624\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-34,7.891527957,368.64586815159555,-206,306,-2472,3672\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-33,7.891527957,368.7512595092771,-201,309,-2412,3708\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-32,7.891527957,368.9691348577293,-196,313,-2352,3756\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-31,7.891527957,369.29982662976045,-190,317,-2280,3804\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-30,7.891527957,369.7438402937683,-185,320,-2220,3840\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-29,7.891527957,370.3018562427484,-180,324,-2160,3888\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-28,7.891527957,370.9747323463568,-174,328,-2088,3936\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-27,7.891527957,371.76350718390336,-169,331,-2028,3972\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-26,7.491040057,370.7210119921879,-163,333,-1956,3996\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-25,7.491040057,362.7266081636302,-153,329,-1836,3948\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-24,6.336676328,361.500617609041,-147,330,-1764,3960\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-23,6.336676328,362.73139434711555,-142,334,-1704,4008\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-22,6.336676328,364.08186213624896,-136,338,-1632,4056\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-21,6.336676328,365.55419069021985,-131,341,-1572,4092\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-20,6.336676328,367.1507674216809,-126,345,-1512,4140\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-19,6.336676328,368.87420715268235,-120,349,-1440,4188\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-18,6.336676328,370.72736290040746,-115,353,-1380,4236\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-17,6.336676328,372.7133378233551,-109,356,-1308,4272\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-16,6.336676328,374.83549842413555,-103,360,-1236,4320\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-15,6.336676328,377.09748911725785,-98,364,-1176,4368\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-14,6.336676328,379.5032482839751,-92,368,-1104,4416\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-13,6.336676328,382.05702595163837,-86,372,-1032,4464\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-12,6.336676328,384.7634032523608,-80,376,-960,4512\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-11,6.336676328,387.62731383540245,-74,381,-888,4572\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-10,6.336676328,390.65406742991536,-68,385,-816,4620\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-9,6.336676328,393.8493757799492,-62,389,-744,4668\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-8,6.336676328,397.21938120238457,-55,393,-660,4716\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-7,6.336676328,400.7706880513213,-49,398,-588,4776\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-6,6.336676328,404.51039741004763,-42,402,-504,4824\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-5,6.336676328,408.4461453748657,-36,407,-432,4884\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-4,5.935392137,408.4714853492277,-28,407,-336,4884\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-3,5.935392137,406.0302138361237,-21,405,-252,4860\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-2,5.935392137,403.74020249458516,-14,403,-168,4836\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,-1,5.935392137,401.59752204056286,-7,402,-84,4824\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,0,5.935392137,399.5985432793271,0,400,0,4800\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,1,5.935392137,397.7399214185122,7,398,84,4776\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,2,5.935392137,396.0185818523092,14,396,168,4752\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,3,5.935392137,394.431707300264,21,394,252,4728\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,4,5.935392137,392.97672619727615,27,392,324,4704\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,5,5.935392137,391.65130224315516,34,390,408,4680\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,6,5.935392137,390.4533250306635,41,388,492,4656\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,7,5.935392137,389.3809016805129,47,386,564,4632\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,8,5.935392137,388.4323494204212,54,385,648,4620\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,9,5.935392137,387.6061890532046,61,383,732,4596\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,10,5.935392137,386.9011392660852,67,381,804,4572\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,11,5.935392137,386.3161117400229,74,379,888,4548\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,12,5.935392137,385.8502070240318,80,377,960,4524\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,13,5.935392137,385.5027111451818,87,376,1044,4512\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,14,5.935392137,385.27309293039264,93,374,1116,4488\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,15,5.935392137,385.16100202125756,100,372,1200,4464\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,16,5.935392137,385.1662675680609,106,370,1272,4440\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,17,5.935392137,385.2888975939126,113,368,1356,4416\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,18,5.935392137,385.5290790245946,119,367,1428,4404\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,19,5.935392137,385.8871783843231,126,365,1512,4380\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,20,6.245471234,384.20582665470243,131,361,1572,4332\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,21,6.616593237,379.86345908978956,136,355,1632,4260\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,22,6.616593237,375.3354308637115,141,348,1692,4176\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,23,6.616593237,371.02576726516503,145,342,1740,4104\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,24,6.616593237,366.92444869882377,149,335,1788,4020\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,25,6.616593237,363.02218183339005,153,329,1836,3948\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,26,6.616593237,359.3103409406474,158,323,1896,3876\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,27,6.616593237,355.7809150984238,162,317,1944,3804\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,28,6.616593237,352.4264606009779,165,311,1980,3732\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,29,19.93356002,349.1949115902297,169,305,2028,3660\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,30,19.93356002,346.2294426818271,173,300,2076,3600\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,31,19.93356002,343.41764441658836,177,294,2124,3528\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,32,19.93356002,340.75410942597557,181,289,2172,3468\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,33,19.93356002,338.2338093698092,184,284,2208,3408\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,34,19.93356002,335.85206978195356,188,278,2256,3336\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,35,19.93356002,333.6045472265781,191,273,2292,3276\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,36,19.93356002,331.4872085440732,195,268,2340,3216\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,37,19.93356002,329.49631199105926,198,263,2376,3156\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,38,19.93356002,327.62839010119694,202,258,2424,3096\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,39,19.93356002,325.8802341130916,205,253,2460,3036\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,40,19.93356002,324.2488798288781,208,248,2496,2976\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,41,19.93356002,322.7315947823514,212,244,2544,2928\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,42,19.93356002,321.32586660907634,215,239,2580,2868\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,43,19.93356002,320.0293925229658,218,234,2616,2808\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,44,19.93356002,318.84006981457713,221,229,2652,2748\n2,Oriole Park at Camden Yards,Oriole Park at Camden Yards,45,19.93356002,317.75598729601205,225,225,2700,2700\n3,Fenway Park,Fenway Park,-45,37.31,308.51127692066336,-218,218,-2616,2616\n3,Fenway Park,Fenway Park,-44,37.31,308.51359749847387,-214,222,-2568,2664\n3,Fenway Park,Fenway Park,-43,37.31,308.60992439083753,-210,226,-2520,2712\n3,Fenway Park,Fenway Park,-42,37.31,308.8004044272473,-207,229,-2484,2748\n3,Fenway Park,Fenway Park,-41,37.31,309.08532827733495,-203,233,-2436,2796\n3,Fenway Park,Fenway Park,-40,37.31,309.4651315345208,-199,237,-2388,2844\n3,Fenway Park,Fenway Park,-39,37.31,309.94039634433693,-195,241,-2340,2892\n3,Fenway Park,Fenway Park,-38,37.31,310.51185358877683,-191,245,-2292,2940\n3,Fenway Park,Fenway Park,-37,37.31,311.180385641981,-187,249,-2244,2988\n3,Fenway Park,Fenway Park,-36,37.31,311.94702971668886,-183,252,-2196,3024\n3,Fenway Park,Fenway Park,-35,37.31,312.81298182523653,-179,256,-2148,3072\n3,Fenway Park,Fenway Park,-34,37.31,313.7796013834988,-175,260,-2100,3120\n3,Fenway Park,Fenway Park,-33,37.31,314.8484164911243,-171,264,-2052,3168\n3,Fenway Park,Fenway Park,-32,37.31,316.0211299267541,-167,268,-2004,3216\n3,Fenway Park,Fenway Park,-31,37.31,317.2996259027178,-163,272,-1956,3264\n3,Fenway Park,Fenway Park,-30,37.31,318.6859776300445,-159,276,-1908,3312\n3,Fenway Park,Fenway Park,-29,37.31,320.1824557515927,-155,280,-1860,3360\n3,Fenway Park,Fenway Park,-28,37.31,321.7915377087987,-151,284,-1812,3408\n3,Fenway Park,Fenway Park,-27,37.31,323.5159181160691,-147,288,-1764,3456\n3,Fenway Park,Fenway Park,-26,37.31,325.3585202263406,-143,292,-1716,3504\n3,Fenway Park,Fenway Park,-25,37.31,327.32250858193345,-138,297,-1656,3564\n3,Fenway Park,Fenway Park,-24,37.31,329.41130295671445,-134,301,-1608,3612\n3,Fenway Park,Fenway Park,-23,37.31,331.6285937089472,-130,305,-1560,3660\n3,Fenway Park,Fenway Park,-22,37.31,333.9783586792734,-125,310,-1500,3720\n3,Fenway Park,Fenway Park,-21,37.31,336.46488178530626,-121,314,-1452,3768\n3,Fenway Park,Fenway Park,-20,37.31,339.0927734836168,-116,319,-1392,3828\n3,Fenway Park,Fenway Park,-19,37.31,341.8669932918388,-111,323,-1332,3876\n3,Fenway Park,Fenway Park,-18,37.31,344.79287458860404,-107,328,-1284,3936\n3,Fenway Park,Fenway Park,-17,37.31,347.87615193755653,-102,333,-1224,3996\n3,Fenway Park,Fenway Park,-16,37.31,351.12299121435774,-97,338,-1164,4056\n3,Fenway Park,Fenway Park,-15,37.31,354.54002285307064,-92,342,-1104,4104\n3,Fenway Park,Fenway Park,-14,37.31,358.13437857141395,-87,347,-1044,4164\n3,Fenway Park,Fenway Park,-13,37.31,361.9137319840741,-81,353,-972,4236\n3,Fenway Park,Fenway Park,-12,37.31,365.88634357070424,-76,358,-912,4296\n3,Fenway Park,Fenway Park,-11,37.31,370.06111053179467,-71,363,-852,4356\n3,Fenway Park,Fenway Park,-10,37.31,374.4476221429239,-65,369,-780,4428\n3,Fenway Park,Fenway Park,-9,37.31,379.0562213079636,-59,374,-708,4488\n3,Fenway Park,Fenway Park,-8,17.15,381.19912307955343,-53,377,-636,4524\n3,Fenway Park,Fenway Park,-7,17.15,380.34679173919403,-46,378,-552,4536\n3,Fenway Park,Fenway Park,-6,17.17,380.0115633157493,-40,378,-480,4536\n3,Fenway Park,Fenway Park,-5,17.17,381.105292320269,-33,380,-396,4560\n3,Fenway Park,Fenway Park,-4,17.17,382.3221305005588,-27,381,-324,4572\n3,Fenway Park,Fenway Park,-3,17.17,383.66400621900493,-20,383,-240,4596\n3,Fenway Park,Fenway Park,-2,17.17,385.13306302134043,-13,385,-156,4620\n3,Fenway Park,Fenway Park,-1,17.17,386.73166817232294,-7,387,-84,4644\n3,Fenway Park,Fenway Park,0,17.17,388.4624221996375,0,388,0,4656\n3,Fenway Park,Fenway Park,1,17.17,390.32816951932864,7,390,84,4680\n3,Fenway Park,Fenway Park,2,17.17,392.33201022574707,14,392,168,4704\n3,Fenway Park,Fenway Park,3,17.17,394.47731313974265,21,394,252,4728\n3,Fenway Park,Fenway Park,4,17.17,396.7677302208094,28,396,336,4752\n3,Fenway Park,Fenway Park,5,17.17,399.20721246228374,35,398,420,4776\n3,Fenway Park,Fenway Park,6,17.17,401.800027403722,42,400,504,4800\n3,Fenway Park,Fenway Park,7,17.17,404.5507784114917,49,402,588,4824\n3,Fenway Park,Fenway Park,8,17.17,407.46442589769174,57,403,684,4836\n3,Fenway Park,Fenway Park,9,17.17,410.54631066910935,64,405,768,4860\n3,Fenway Park,Fenway Park,10,17.17,413.80217962240687,72,408,864,4896\n3,Fenway Park,Fenway Park,11,17.17,417.2382140295909,80,410,960,4920\n3,Fenway Park,Fenway Park,12,6.78,409.77548528120656,85,401,1020,4812\n3,Fenway Park,Fenway Park,13,6.92,396.2068450155689,89,386,1068,4632\n3,Fenway Park,Fenway Park,14,5.05,383.0996028140246,93,372,1116,4464\n3,Fenway Park,Fenway Park,15,3.96,380.9345606597027,99,368,1188,4416\n3,Fenway Park,Fenway Park,16,3.96,379.7788714463915,105,365,1260,4380\n3,Fenway Park,Fenway Park,17,3.96,378.74519384629855,111,362,1332,4344\n3,Fenway Park,Fenway Park,18,3.96,377.83190673046465,117,359,1404,4308\n3,Fenway Park,Fenway Park,19,3.96,377.03758655429976,123,356,1476,4272\n3,Fenway Park,Fenway Park,20,3.96,376.361001884647,129,354,1548,4248\n3,Fenway Park,Fenway Park,21,3.96,375.80110870224604,135,351,1620,4212\n3,Fenway Park,Fenway Park,22,3.96,375.35704644596717,141,348,1692,4176\n3,Fenway Park,Fenway Park,23,3.96,375.0281347707395,147,345,1764,4140\n3,Fenway Park,Fenway Park,24,3.96,374.8138709963356,152,342,1824,4104\n3,Fenway Park,Fenway Park,25,3.96,374.71392822914936,158,340,1896,4080\n3,Fenway Park,Fenway Park,26,3.96,374.7281541438782,164,337,1968,4044\n3,Fenway Park,Fenway Park,27,3.96,374.85657041664587,170,334,2040,4008\n3,Fenway Park,Fenway Park,28,3.96,375.09937280563776,176,331,2112,3972\n3,Fenway Park,Fenway Park,29,3.96,375.45693187980646,182,328,2184,3936\n3,Fenway Park,Fenway Park,30,3.96,375.9297944007012,188,326,2256,3912\n3,Fenway Park,Fenway Park,31,3.96,376.51868536702597,194,323,2328,3876\n3,Fenway Park,Fenway Park,32,3.96,377.2245107361894,200,320,2400,3840\n3,Fenway Park,Fenway Park,33,3.96,378.048360841929,206,317,2472,3804\n3,Fenway Park,Fenway Park,34,3.96,378.9915145321279,212,314,2544,3768\n3,Fenway Park,Fenway Park,35,3.96,380.0554440562464,218,311,2616,3732\n3,Fenway Park,Fenway Park,36,1.65,380.943321110874,224,308,2688,3696\n3,Fenway Park,Fenway Park,37,1.6,380.68449978286264,229,304,2748,3648\n3,Fenway Park,Fenway Park,38,1.71,379.2790052184209,234,299,2808,3588\n3,Fenway Park,Fenway Park,39,1.8,376.636535091357,237,293,2844,3516\n3,Fenway Park,Fenway Park,40,1.87,372.3762457729305,239,285,2868,3420\n3,Fenway Park,Fenway Park,41,2.63,365.6039082590629,240,276,2880,3312\n3,Fenway Park,Fenway Park,42,3.58,352.7094479433455,236,262,2832,3144\n3,Fenway Park,Fenway Park,43,3.58,332.8144583306132,227,243,2724,2916\n3,Fenway Park,Fenway Park,44,3.58,315.13489834938326,219,227,2628,2724\n3,Fenway Park,Fenway Park,45,3.58,299.32549540410884,212,212,2544,2544\n4,Rate Field,Rate Field,-45,6.55,328.4263954609172,-232,232,-2784,2784\n4,Rate Field,Rate Field,-44,6.55,329.48880250875885,-229,237,-2748,2844\n4,Rate Field,Rate Field,-43,6.55,330.6591541566685,-226,242,-2712,2904\n4,Rate Field,Rate Field,-42,6.55,331.93932203820356,-222,247,-2664,2964\n4,Rate Field,Rate Field,-41,6.55,333.33137154361606,-219,252,-2628,3024\n4,Rate Field,Rate Field,-40,6.55,334.83757016102226,-215,257,-2580,3084\n4,Rate Field,Rate Field,-39,6.55,336.46039675821476,-212,261,-2544,3132\n4,Rate Field,Rate Field,-38,6.55,338.2025518777762,-208,267,-2496,3204\n4,Rate Field,Rate Field,-37,6.55,340.06696912754074,-205,272,-2460,3264\n4,Rate Field,Rate Field,-36,6.55,342.0568277589193,-201,277,-2412,3324\n4,Rate Field,Rate Field,-35,6.55,344.1755665373164,-197,282,-2364,3384\n4,Rate Field,Rate Field,-34,6.55,346.42689902201266,-194,287,-2328,3444\n4,Rate Field,Rate Field,-33,6.55,348.3182676987007,-190,292,-2280,3504\n4,Rate Field,Rate Field,-32,6.61,349.6102966195745,-185,296,-2220,3552\n4,Rate Field,Rate Field,-31,6.58,351.4577435944995,-181,301,-2172,3612\n4,Rate Field,Rate Field,-30,6.58,352.8685758676285,-176,306,-2112,3672\n4,Rate Field,Rate Field,-29,6.58,354.3991691198609,-172,310,-2064,3720\n4,Rate Field,Rate Field,-28,6.58,356.05202772411695,-167,314,-2004,3768\n4,Rate Field,Rate Field,-27,6.58,357.8298850645971,-162,319,-1944,3828\n4,Rate Field,Rate Field,-26,6.58,359.735714965735,-158,323,-1896,3876\n4,Rate Field,Rate Field,-25,6.58,361.7727443255813,-153,328,-1836,3936\n4,Rate Field,Rate Field,-24,6.58,363.94446705713284,-148,332,-1776,3984\n4,Rate Field,Rate Field,-23,6.58,366.25465945419637,-143,337,-1716,4044\n4,Rate Field,Rate Field,-22,6.58,368.7073971130748,-138,342,-1656,4104\n4,Rate Field,Rate Field,-21,6.58,371.30707355792856,-133,347,-1596,4164\n4,Rate Field,Rate Field,-20,6.76,374.0227010254148,-128,351,-1536,4212\n4,Rate Field,Rate Field,-19,6.8,376.7442833728362,-123,356,-1476,4272\n4,Rate Field,Rate Field,-18,6.8,378.9218734408589,-117,360,-1404,4320\n4,Rate Field,Rate Field,-17,6.8,381.05578531541386,-111,364,-1332,4368\n4,Rate Field,Rate Field,-16,6.81,383.06945303359254,-106,368,-1272,4416\n4,Rate Field,Rate Field,-15,6.73,384.7571594542594,-100,372,-1200,4464\n4,Rate Field,Rate Field,-14,6.73,386.35255326963494,-93,375,-1116,4500\n4,Rate Field,Rate Field,-13,6.73,388.079937879161,-87,378,-1044,4536\n4,Rate Field,Rate Field,-12,6.75,389.14838714579525,-81,381,-972,4572\n4,Rate Field,Rate Field,-11,6.75,390.33835561522034,-74,383,-888,4596\n4,Rate Field,Rate Field,-10,6.84,391.646485376964,-68,386,-816,4632\n4,Rate Field,Rate Field,-9,6.84,393.00238961437924,-61,388,-732,4656\n4,Rate Field,Rate Field,-8,6.7,395.13093830233805,-55,391,-660,4692\n4,Rate Field,Rate Field,-7,6.68,397.91597290890047,-48,395,-576,4740\n4,Rate Field,Rate Field,-6,6.72,400.96071030306956,-42,399,-504,4788\n4,Rate Field,Rate Field,-5,6.78,401.54995247648986,-35,400,-420,4800\n4,Rate Field,Rate Field,-4,6.78,401.0563848113279,-28,400,-336,4800\n4,Rate Field,Rate Field,-3,6.78,400.58946948982924,-21,400,-252,4800\n4,Rate Field,Rate Field,-2,6.87,400.18804002830984,-14,400,-168,4800\n4,Rate Field,Rate Field,-1,6.82,399.87162372557657,-7,400,-84,4800\n4,Rate Field,Rate Field,0,6.75,399.96934723456417,0,400,0,4800\n4,Rate Field,Rate Field,1,6.75,399.85454631441047,7,400,84,4800\n4,Rate Field,Rate Field,2,6.78,400.0275073547006,14,400,168,4800\n4,Rate Field,Rate Field,3,6.78,400.35059524005413,21,400,252,4800\n4,Rate Field,Rate Field,4,6.78,400.7963905880221,28,400,336,4800\n4,Rate Field,Rate Field,5,6.78,401.3655759721674,35,400,420,4800\n4,Rate Field,Rate Field,6,6.57,401.0121522301611,42,399,504,4788\n4,Rate Field,Rate Field,7,6.57,397.93770600709416,48,395,576,4740\n4,Rate Field,Rate Field,8,6.63,395.01667104143826,55,391,660,4692\n4,Rate Field,Rate Field,9,6.64,392.8321917665194,61,388,732,4656\n4,Rate Field,Rate Field,10,5.82,391.5346736699819,68,386,816,4632\n4,Rate Field,Rate Field,11,5.82,390.3860707031872,74,383,888,4596\n4,Rate Field,Rate Field,12,6.63,389.42722764015645,81,381,972,4572\n4,Rate Field,Rate Field,13,6.6,388.4097917875908,87,378,1044,4536\n4,Rate Field,Rate Field,14,6.6,386.4127369125959,93,375,1116,4500\n4,Rate Field,Rate Field,15,6.6,384.55265243885793,100,371,1200,4452\n4,Rate Field,Rate Field,16,6.6,382.82644403452605,106,368,1272,4416\n4,Rate Field,Rate Field,17,6.6,381.2312716285759,111,365,1332,4380\n4,Rate Field,Rate Field,18,6.6,379.76453762070275,117,361,1404,4332\n4,Rate Field,Rate Field,19,6.59,378.0441820000208,123,357,1476,4284\n4,Rate Field,Rate Field,20,6.43,375.88744542789914,129,353,1548,4236\n4,Rate Field,Rate Field,21,6.64,373.7402827470698,134,349,1608,4188\n4,Rate Field,Rate Field,22,6.4,371.4644983840488,139,344,1668,4128\n4,Rate Field,Rate Field,23,6.54,368.47060647259445,144,339,1728,4068\n4,Rate Field,Rate Field,24,6.54,365.56397585823186,149,334,1788,4008\n4,Rate Field,Rate Field,25,6.54,362.81249469498295,153,329,1836,3948\n4,Rate Field,Rate Field,26,6.54,360.2110272037822,158,324,1896,3888\n4,Rate Field,Rate Field,27,6.54,357.75480037923916,162,319,1944,3828\n4,Rate Field,Rate Field,28,6.54,355.4393809977601,167,314,2004,3768\n4,Rate Field,Rate Field,29,6.54,353.26065472529535,171,309,2052,3708\n4,Rate Field,Rate Field,30,6.54,351.2148071309955,176,304,2112,3648\n4,Rate Field,Rate Field,31,6.54,349.2983064350127,180,299,2160,3588\n4,Rate Field,Rate Field,32,6.54,347.5078878380292,184,295,2208,3540\n4,Rate Field,Rate Field,33,6.54,345.84053929720005,188,290,2256,3480\n4,Rate Field,Rate Field,34,6.54,344.2934886283389,193,285,2316,3420\n4,Rate Field,Rate Field,35,6.54,342.8641918276434,197,281,2364,3372\n4,Rate Field,Rate Field,36,6.54,341.55032251824827,201,276,2412,3312\n4,Rate Field,Rate Field,37,6.54,340.3497624376197,205,272,2460,3264\n4,Rate Field,Rate Field,38,6.54,339.26059289142705,209,267,2508,3204\n4,Rate Field,Rate Field,39,6.54,338.2810871081907,213,263,2556,3156\n4,Rate Field,Rate Field,40,6.54,337.40970343684097,217,258,2604,3096\n4,Rate Field,Rate Field,41,6.54,336.64507933643824,221,254,2652,3048\n4,Rate Field,Rate Field,42,6.54,335.9860261138095,225,250,2700,3000\n4,Rate Field,Rate Field,43,6.54,335.4315243708166,229,245,2748,2940\n4,Rate Field,Rate Field,44,6.54,334.9807201284963,233,241,2796,2892\n4,Rate Field,Rate Field,45,6.54,334.6329216004389,237,237,2844,2844\n5,Progressive Field,Progressive Field,-45,20.14,324.808474495808,-230,230,-2760,2760\n5,Progressive Field,Progressive Field,-44,20.14,326.653846538217,-227,235,-2724,2820\n5,Progressive Field,Progressive Field,-43,20.14,328.6209801449434,-224,240,-2688,2880\n5,Progressive Field,Progressive Field,-42,20.14,330.71329854612304,-221,246,-2652,2952\n5,Progressive Field,Progressive Field,-41,20.14,332.9344960262501,-218,251,-2616,3012\n5,Progressive Field,Progressive Field,-40,20.14,335.28855482589256,-216,257,-2592,3084\n5,Progressive Field,Progressive Field,-39,20.14,337.77976374046796,-213,263,-2556,3156\n5,Progressive Field,Progressive Field,-38,20.14,340.41273858672537,-210,268,-2520,3216\n5,Progressive Field,Progressive Field,-37,20.14,343.19244472949583,-207,274,-2484,3288\n5,Progressive Field,Progressive Field,-36,20.14,346.12422188622685,-203,280,-2436,3360\n5,Progressive Field,Progressive Field,-35,20.14,349.2138114553165,-200,286,-2400,3432\n5,Progressive Field,Progressive Field,-34,20.14,352.46738664687797,-197,292,-2364,3504\n5,Progressive Field,Progressive Field,-33,19.97,354.0701661577733,-193,297,-2316,3564\n5,Progressive Field,Progressive Field,-32,19.97,354.2016312331306,-188,300,-2256,3600\n5,Progressive Field,Progressive Field,-31,19.97,354.4412002953885,-183,304,-2196,3648\n5,Progressive Field,Progressive Field,-30,19.97,354.7892390332567,-177,307,-2124,3684\n5,Progressive Field,Progressive Field,-29,19.97,355.2462797661761,-172,311,-2064,3732\n5,Progressive Field,Progressive Field,-28,19.97,355.8130234355034,-167,314,-2004,3768\n5,Progressive Field,Progressive Field,-27,19.97,356.4903422368503,-162,318,-1944,3816\n5,Progressive Field,Progressive Field,-26,19.97,357.27928291204313,-157,321,-1884,3852\n5,Progressive Field,Progressive Field,-25,19.97,358.18107072394963,-151,325,-1812,3900\n5,Progressive Field,Progressive Field,-24,19.97,359.1971141424614,-146,328,-1752,3936\n5,Progressive Field,Progressive Field,-23,19.97,360.32901027529306,-141,332,-1692,3984\n5,Progressive Field,Progressive Field,-22,19.97,361.5785510830206,-135,335,-1620,4020\n5,Progressive Field,Progressive Field,-21,19.97,362.94773042400533,-130,339,-1560,4068\n5,Progressive Field,Progressive Field,-20,19.97,364.43875198162783,-125,342,-1500,4104\n5,Progressive Field,Progressive Field,-19,19.97,366.0540381336611,-119,346,-1428,4152\n5,Progressive Field,Progressive Field,-18,19.97,367.79623983176566,-114,350,-1368,4200\n5,Progressive Field,Progressive Field,-17,19.97,369.6682475680885,-108,354,-1296,4248\n5,Progressive Field,Progressive Field,-16,19.97,371.6732035159426,-102,357,-1224,4284\n5,Progressive Field,Progressive Field,-15,19.97,373.8145149426715,-97,361,-1164,4332\n5,Progressive Field,Progressive Field,-14,19.97,376.09586900524346,-91,365,-1092,4380\n5,Progressive Field,Progressive Field,-13,19.97,378.52124905307153,-85,369,-1020,4428\n5,Progressive Field,Progressive Field,-12,19.97,381.09495257825034,-79,373,-948,4476\n5,Progressive Field,Progressive Field,-11,19.97,383.82161097110213,-73,377,-876,4524\n5,Progressive Field,Progressive Field,-10,19.97,386.7062112589489,-67,381,-804,4572\n5,Progressive Field,Progressive Field,-9,19.97,389.7541200287369,-61,385,-732,4620\n5,Progressive Field,Progressive Field,-8,19.97,392.97110975995105,-55,389,-660,4668\n5,Progressive Field,Progressive Field,-7,19.97,396.3633878236823,-48,393,-576,4716\n5,Progressive Field,Progressive Field,-6,19.97,399.9376284373173,-42,398,-504,4776\n5,Progressive Field,Progressive Field,-5,19.97,403.7010079028126,-35,402,-420,4824\n5,Progressive Field,Progressive Field,-4,19.97,407.6612435006934,-28,407,-336,4884\n5,Progressive Field,Progressive Field,-3,7.53,408.5382293589945,-21,408,-252,4896\n5,Progressive Field,Progressive Field,-2,7.53,405.5182878515338,-14,405,-168,4860\n5,Progressive Field,Progressive Field,-1,7.53,402.6644214029301,-7,403,-84,4836\n5,Progressive Field,Progressive Field,0,7.53,399.97142659242934,0,400,0,4800\n5,Progressive Field,Progressive Field,1,7.53,397.4344717526907,7,397,84,4764\n5,Progressive Field,Progressive Field,2,7.53,395.0490743813721,14,395,168,4740\n5,Progressive Field,Progressive Field,3,7.53,392.8110806137214,21,392,252,4704\n5,Progressive Field,Progressive Field,4,7.53,390.71664657213415,27,390,324,4680\n5,Progressive Field,Progressive Field,5,7.53,388.76222142933904,34,387,408,4644\n5,Progressive Field,Progressive Field,6,7.53,386.9445320401705,40,385,480,4620\n5,Progressive Field,Progressive Field,7,7.53,385.26056901313126,47,382,564,4584\n5,Progressive Field,Progressive Field,8,7.53,383.7075741073825,53,380,636,4560\n5,Progressive Field,Progressive Field,9,7.53,382.2830288536885,60,378,720,4536\n5,Progressive Field,Progressive Field,10,7.53,380.9846443093773,66,375,792,4500\n5,Progressive Field,Progressive Field,11,7.53,379.8103518677377,72,373,864,4476\n5,Progressive Field,Progressive Field,12,7.53,378.7582950516207,79,370,948,4440\n5,Progressive Field,Progressive Field,13,7.53,377.82682222947835,85,368,1020,4416\n5,Progressive Field,Progressive Field,14,7.53,377.014480199778,91,366,1092,4392\n5,Progressive Field,Progressive Field,15,7.53,376.32000859677714,97,363,1164,4356\n5,Progressive Field,Progressive Field,16,7.53,375.7423350771368,104,361,1248,4332\n5,Progressive Field,Progressive Field,17,7.53,375.2805712528602,110,359,1320,4308\n5,Progressive Field,Progressive Field,18,7.53,374.93400934165845,116,357,1392,4284\n5,Progressive Field,Progressive Field,19,7.53,374.7021195111184,122,354,1464,4248\n5,Progressive Field,Progressive Field,20,7.53,374.58454789806444,128,352,1536,4224\n5,Progressive Field,Progressive Field,21,7.53,374.5811152893002,134,350,1608,4200\n5,Progressive Field,Progressive Field,22,7.53,374.69181645456416,140,347,1680,4164\n5,Progressive Field,Progressive Field,23,7.53,374.9168201270732,146,345,1752,4140\n5,Progressive Field,Progressive Field,24,7.53,375.2564696315194,153,343,1836,4116\n5,Progressive Field,Progressive Field,25,7.61,372.4879369645115,157,338,1884,4056\n5,Progressive Field,Progressive Field,26,7.61,368.6386891942079,162,331,1944,3972\n5,Progressive Field,Progressive Field,27,7.61,364.97822186350317,166,325,1992,3900\n5,Progressive Field,Progressive Field,28,7.61,361.49876775475525,170,319,2040,3828\n5,Progressive Field,Progressive Field,29,7.61,358.19310740244754,174,313,2088,3756\n5,Progressive Field,Progressive Field,30,7.61,355.0545282857441,178,307,2136,3684\n5,Progressive Field,Progressive Field,31,7.61,352.07678791636243,181,302,2172,3624\n5,Progressive Field,Progressive Field,32,7.61,349.25408041378967,185,296,2220,3552\n5,Progressive Field,Progressive Field,33,7.61,346.58100620924074,189,291,2268,3492\n5,Progressive Field,Progressive Field,34,7.61,344.052544562615,192,285,2304,3420\n5,Progressive Field,Progressive Field,35,7.61,341.66402861398905,196,280,2352,3360\n5,Progressive Field,Progressive Field,36,7.61,339.4111227237014,200,275,2400,3300\n5,Progressive Field,Progressive Field,37,7.61,337.28980188351136,203,269,2436,3228\n5,Progressive Field,Progressive Field,38,7.61,335.2963330062188,206,264,2472,3168\n5,Progressive Field,Progressive Field,39,7.61,333.427257923022,210,259,2520,3108\n5,Progressive Field,Progressive Field,40,7.61,331.6793779371508,213,254,2556,3048\n5,Progressive Field,Progressive Field,41,7.61,330.04973979933135,217,249,2604,2988\n5,Progressive Field,Progressive Field,42,7.61,328.53562298569614,220,244,2640,2928\n5,Progressive Field,Progressive Field,43,12.03,327.03320659420905,223,239,2676,2868\n5,Progressive Field,Progressive Field,44,12.03,325.77374749225464,226,234,2712,2808\n5,Progressive Field,Progressive Field,45,12.03,324.62245573627155,230,230,2760,2760\n7,Kauffman Stadium,Kauffman Stadium,-45,8.042832624,325.20613725147956,-230,230,-2760,2760\n7,Kauffman Stadium,Kauffman Stadium,-44,8.06916989,337.08591391102647,-234,242,-2808,2904\n7,Kauffman Stadium,Kauffman Stadium,-43,8.011822593,344.3094041452742,-235,252,-2820,3024\n7,Kauffman Stadium,Kauffman Stadium,-42,7.032377513,346.39887678631806,-232,257,-2784,3084\n7,Kauffman Stadium,Kauffman Stadium,-41,7.032377513,347.1683958940347,-228,262,-2736,3144\n7,Kauffman Stadium,Kauffman Stadium,-40,7.032377513,348.0475962729849,-224,267,-2688,3204\n7,Kauffman Stadium,Kauffman Stadium,-39,7.032377513,349.03785133927624,-220,271,-2640,3252\n7,Kauffman Stadium,Kauffman Stadium,-38,7.032377513,350.14071795007396,-216,276,-2592,3312\n7,Kauffman Stadium,Kauffman Stadium,-37,7.032377513,351.35794246360297,-211,281,-2532,3372\n7,Kauffman Stadium,Kauffman Stadium,-36,7.032377513,352.691467606789,-207,285,-2484,3420\n7,Kauffman Stadium,Kauffman Stadium,-35,7.032377513,354.1434402016636,-203,290,-2436,3480\n7,Kauffman Stadium,Kauffman Stadium,-34,7.032377513,355.7162198088685,-199,295,-2388,3540\n7,Kauffman Stadium,Kauffman Stadium,-33,7.032377513,357.4123883545402,-195,300,-2340,3600\n7,Kauffman Stadium,Kauffman Stadium,-32,7.032377513,359.2347608156231,-190,305,-2280,3660\n7,Kauffman Stadium,Kauffman Stadium,-31,7.032377513,361.18639704839933,-186,310,-2232,3720\n7,Kauffman Stadium,Kauffman Stadium,-30,7.032377513,363.27061485586586,-182,315,-2184,3780\n7,Kauffman Stadium,Kauffman Stadium,-29,7.032377513,365.4910044017167,-177,320,-2124,3840\n7,Kauffman Stadium,Kauffman Stadium,-28,7.070744188,367.6659490289966,-173,325,-2076,3900\n7,Kauffman Stadium,Kauffman Stadium,-27,6.942803891,369.1080581224094,-168,329,-2016,3948\n7,Kauffman Stadium,Kauffman Stadium,-26,6.937377842,370.5861640435488,-162,333,-1944,3996\n7,Kauffman Stadium,Kauffman Stadium,-25,6.937377842,372.1675798558698,-157,337,-1884,4044\n7,Kauffman Stadium,Kauffman Stadium,-24,7.018322857,373.7323288726664,-152,341,-1824,4092\n7,Kauffman Stadium,Kauffman Stadium,-23,7.018322857,375.32442218293187,-147,345,-1764,4140\n7,Kauffman Stadium,Kauffman Stadium,-22,7.018322857,377.0454811712443,-141,350,-1692,4200\n7,Kauffman Stadium,Kauffman Stadium,-21,6.962585957,378.6770881260389,-136,354,-1632,4248\n7,Kauffman Stadium,Kauffman Stadium,-20,7.078221471,380.26252789234326,-130,357,-1560,4284\n7,Kauffman Stadium,Kauffman Stadium,-19,7.071610363,381.9751088034064,-124,361,-1488,4332\n7,Kauffman Stadium,Kauffman Stadium,-18,7.071610363,383.8326939238117,-119,365,-1428,4380\n7,Kauffman Stadium,Kauffman Stadium,-17,7.071610363,385.82653543721074,-113,369,-1356,4428\n7,Kauffman Stadium,Kauffman Stadium,-16,6.953365834,387.96071949028925,-107,373,-1284,4476\n7,Kauffman Stadium,Kauffman Stadium,-15,6.953365834,390.2438803722446,-101,377,-1212,4524\n7,Kauffman Stadium,Kauffman Stadium,-14,6.953365834,392.6743937981537,-95,381,-1140,4572\n7,Kauffman Stadium,Kauffman Stadium,-13,6.953365834,395.2565259046105,-89,385,-1068,4620\n7,Kauffman Stadium,Kauffman Stadium,-12,7.104338081,397.9888726456183,-83,389,-996,4668\n7,Kauffman Stadium,Kauffman Stadium,-11,7.104338081,400.87611790580684,-76,394,-912,4728\n7,Kauffman Stadium,Kauffman Stadium,-10,7.045744689,403.92397439024603,-70,398,-840,4776\n7,Kauffman Stadium,Kauffman Stadium,-9,7.669253023,405.63602559633125,-63,401,-756,4812\n7,Kauffman Stadium,Kauffman Stadium,-8,7.571028025,406.67442467202375,-57,403,-684,4836\n7,Kauffman Stadium,Kauffman Stadium,-7,7.682193229,407.47228991938914,-50,404,-600,4848\n7,Kauffman Stadium,Kauffman Stadium,-6,7.58115545,408.0947524559327,-43,406,-516,4872\n7,Kauffman Stadium,Kauffman Stadium,-5,7.555183442,408.76805822752124,-36,407,-432,4884\n7,Kauffman Stadium,Kauffman Stadium,-4,7.555183442,409.260406893615,-29,408,-348,4896\n7,Kauffman Stadium,Kauffman Stadium,-3,7.536918552,409.59131508111443,-21,409,-252,4908\n7,Kauffman Stadium,Kauffman Stadium,-2,7.536918552,409.77613544983336,-14,410,-168,4920\n7,Kauffman Stadium,Kauffman Stadium,-1,7.542568695,409.90408117084905,-7,410,-84,4920\n7,Kauffman Stadium,Kauffman Stadium,0,7.563218982,410.07015464505366,0,410,0,4920\n7,Kauffman Stadium,Kauffman Stadium,1,7.507460387,410.0421151991469,7,410,84,4920\n7,Kauffman Stadium,Kauffman Stadium,2,7.566536219,410.0165143395552,14,410,168,4920\n7,Kauffman Stadium,Kauffman Stadium,3,7.566536219,409.7754198209575,21,409,252,4908\n7,Kauffman Stadium,Kauffman Stadium,4,7.480856807,409.18161847389047,29,408,348,4896\n7,Kauffman Stadium,Kauffman Stadium,5,7.514056918,408.6051113887162,36,407,432,4884\n7,Kauffman Stadium,Kauffman Stadium,6,7.514056918,407.91537682369477,43,406,516,4872\n7,Kauffman Stadium,Kauffman Stadium,7,7.533006938,407.3398039742453,50,404,600,4848\n7,Kauffman Stadium,Kauffman Stadium,8,7.533006938,406.61658465755966,57,403,684,4836\n7,Kauffman Stadium,Kauffman Stadium,9,7.529745143,405.49240102210706,63,401,756,4812\n7,Kauffman Stadium,Kauffman Stadium,10,7.142617853,403.9860767232107,70,398,840,4776\n7,Kauffman Stadium,Kauffman Stadium,11,7.142617853,400.88165269552104,76,394,912,4728\n7,Kauffman Stadium,Kauffman Stadium,12,7.142617853,397.944870078336,83,389,996,4668\n7,Kauffman Stadium,Kauffman Stadium,13,7.142617853,395.1703004413318,89,385,1068,4620\n7,Kauffman Stadium,Kauffman Stadium,14,7.142617853,392.55290036128343,95,381,1140,4572\n7,Kauffman Stadium,Kauffman Stadium,15,7.142617853,390.0879874275013,101,377,1212,4524\n7,Kauffman Stadium,Kauffman Stadium,16,7.142617853,387.77121843661445,107,373,1284,4476\n7,Kauffman Stadium,Kauffman Stadium,17,7.142617853,385.59856957731427,113,369,1356,4428\n7,Kauffman Stadium,Kauffman Stadium,18,7.142617853,383.5663184281904,119,365,1428,4380\n7,Kauffman Stadium,Kauffman Stadium,19,7.142617853,381.67102761166194,124,361,1488,4332\n7,Kauffman Stadium,Kauffman Stadium,20,7.142617853,379.9095299645953,130,357,1560,4284\n7,Kauffman Stadium,Kauffman Stadium,21,7.142617853,378.27891510180746,136,353,1632,4236\n7,Kauffman Stadium,Kauffman Stadium,22,7.142617853,376.7765172625415,141,349,1692,4188\n7,Kauffman Stadium,Kauffman Stadium,23,7.142617853,375.3999043424049,147,346,1764,4152\n7,Kauffman Stadium,Kauffman Stadium,24,7.102919729,373.9716490942014,152,342,1824,4104\n7,Kauffman Stadium,Kauffman Stadium,25,7.102919729,372.3317690517559,157,337,1884,4044\n7,Kauffman Stadium,Kauffman Stadium,26,7.109352381,370.7099710221904,163,333,1956,3996\n7,Kauffman Stadium,Kauffman Stadium,27,7.040354164,369.0608361866624,168,329,2016,3948\n7,Kauffman Stadium,Kauffman Stadium,28,7.040354164,367.54754946240814,173,325,2076,3900\n7,Kauffman Stadium,Kauffman Stadium,29,7.112417371,365.5841214000038,177,320,2124,3840\n7,Kauffman Stadium,Kauffman Stadium,30,7.112417371,363.41570495232895,182,315,2184,3780\n7,Kauffman Stadium,Kauffman Stadium,31,7.112417371,361.3822916784439,186,310,2232,3720\n7,Kauffman Stadium,Kauffman Stadium,32,7.112417371,359.48039876341954,190,305,2280,3660\n7,Kauffman Stadium,Kauffman Stadium,33,7.112417371,357.7068102353578,195,300,2340,3600\n7,Kauffman Stadium,Kauffman Stadium,34,7.112417371,356.05856309664404,199,295,2388,3540\n7,Kauffman Stadium,Kauffman Stadium,35,7.112417371,354.53293475828053,203,290,2436,3480\n7,Kauffman Stadium,Kauffman Stadium,36,7.112417371,353.1274316745574,208,286,2496,3432\n7,Kauffman Stadium,Kauffman Stadium,37,7.112417371,351.8397790869133,212,281,2544,3372\n7,Kauffman Stadium,Kauffman Stadium,38,7.112417371,350.66791179622294,216,276,2592,3312\n7,Kauffman Stadium,Kauffman Stadium,39,7.112417371,349.6099658920863,220,272,2640,3264\n7,Kauffman Stadium,Kauffman Stadium,40,7.112417371,348.6642713761217,224,267,2688,3204\n7,Kauffman Stadium,Kauffman Stadium,41,7.112417371,347.82934562390807,228,263,2736,3156\n7,Kauffman Stadium,Kauffman Stadium,42,7.112417371,347.10388763718413,232,258,2784,3096\n7,Kauffman Stadium,Kauffman Stadium,43,8.104486477,344.9365533190643,235,252,2820,3024\n7,Kauffman Stadium,Kauffman Stadium,44,8.022461247,337.829936734602,235,243,2820,2916\n7,Kauffman Stadium,Kauffman Stadium,45,8.071615886,326.1642330897055,231,231,2772,2772\n10,Oakland Coliseum,Oakland Coliseum,-45,7.99,329.5153406895023,-233,233,-2796,2796\n10,Oakland Coliseum,Oakland Coliseum,-44,7.99,331.7818590202994,-230,239,-2760,2868\n10,Oakland Coliseum,Oakland Coliseum,-43,7.99,334.1822732546835,-228,244,-2736,2928\n10,Oakland Coliseum,Oakland Coliseum,-42,7.99,336.7209901688056,-225,250,-2700,3000\n10,Oakland Coliseum,Oakland Coliseum,-41,7.99,339.40275139313695,-223,256,-2676,3072\n10,Oakland Coliseum,Oakland Coliseum,-40,7.99,342.2326567996876,-220,262,-2640,3144\n10,Oakland Coliseum,Oakland Coliseum,-39,7.99,345.21619026030146,-217,268,-2604,3216\n10,Oakland Coliseum,Oakland Coliseum,-38,7.99,348.3592480347321,-214,275,-2568,3300\n10,Oakland Coliseum,Oakland Coliseum,-37,7.99,351.6681700817009,-212,281,-2544,3372\n10,Oakland Coliseum,Oakland Coliseum,-36,7.99,355.1497746257584,-209,287,-2508,3444\n10,Oakland Coliseum,Oakland Coliseum,-35,7.99,358.8113963583852,-206,294,-2472,3528\n10,Oakland Coliseum,Oakland Coliseum,-34,7.99,362.6609287044154,-203,301,-2436,3612\n10,Oakland Coliseum,Oakland Coliseum,-33,7.99,366.7068706457802,-200,308,-2400,3696\n10,Oakland Coliseum,Oakland Coliseum,-32,7.81,368.06505899247486,-195,312,-2340,3744\n10,Oakland Coliseum,Oakland Coliseum,-31,15.3,367.3996550964631,-189,315,-2268,3780\n10,Oakland Coliseum,Oakland Coliseum,-30,15.3,366.50224585756064,-183,317,-2196,3804\n10,Oakland Coliseum,Oakland Coliseum,-29,15.3,365.7203404657974,-177,320,-2124,3840\n10,Oakland Coliseum,Oakland Coliseum,-28,15.3,365.05272611374943,-171,322,-2052,3864\n10,Oakland Coliseum,Oakland Coliseum,-27,15.3,364.49837217279645,-165,325,-1980,3900\n10,Oakland Coliseum,Oakland Coliseum,-26,15.3,364.05642628561304,-160,327,-1920,3924\n10,Oakland Coliseum,Oakland Coliseum,-25,15.3,363.72621115330656,-154,330,-1848,3960\n10,Oakland Coliseum,Oakland Coliseum,-24,15.3,363.50722199455225,-148,332,-1776,3984\n10,Oakland Coliseum,Oakland Coliseum,-23,15.3,363.39912465892763,-142,335,-1704,4020\n10,Oakland Coliseum,Oakland Coliseum,-22,14.78,364.0832615850502,-136,338,-1632,4056\n10,Oakland Coliseum,Oakland Coliseum,-21,14.78,365.5208209296576,-131,341,-1572,4092\n10,Oakland Coliseum,Oakland Coliseum,-20,14.78,367.0820374927124,-126,345,-1512,4140\n10,Oakland Coliseum,Oakland Coliseum,-19,14.78,368.7694604306424,-120,349,-1440,4188\n10,Oakland Coliseum,Oakland Coliseum,-18,14.78,370.58587404469284,-115,352,-1380,4224\n10,Oakland Coliseum,Oakland Coliseum,-17,14.78,372.5343093863945,-109,356,-1308,4272\n10,Oakland Coliseum,Oakland Coliseum,-16,14.78,374.61805709129055,-103,360,-1236,4320\n10,Oakland Coliseum,Oakland Coliseum,-15,14.78,376.8406815456475,-98,364,-1176,4368\n10,Oakland Coliseum,Oakland Coliseum,-14,14.78,379.2060365041262,-92,368,-1104,4416\n10,Oakland Coliseum,Oakland Coliseum,-13,14.78,381.7182822912525,-86,372,-1032,4464\n10,Oakland Coliseum,Oakland Coliseum,-12,14.78,384.381904736292,-80,376,-960,4512\n10,Oakland Coliseum,Oakland Coliseum,-11,7.73,386.97638011940006,-74,380,-888,4560\n10,Oakland Coliseum,Oakland Coliseum,-10,7.73,388.8087037941813,-68,383,-816,4596\n10,Oakland Coliseum,Oakland Coliseum,-9,7.73,390.77806312840914,-61,386,-732,4632\n10,Oakland Coliseum,Oakland Coliseum,-8,7.73,392.8877607578116,-55,389,-660,4668\n10,Oakland Coliseum,Oakland Coliseum,-7,7.73,395.14137855571937,-48,392,-576,4704\n10,Oakland Coliseum,Oakland Coliseum,-6,7.73,397.542793166568,-42,395,-504,4740\n10,Oakland Coliseum,Oakland Coliseum,-5,7.73,400.0961931229794,-35,399,-420,4788\n10,Oakland Coliseum,Oakland Coliseum,-4,7.64,400.3722606442592,-28,399,-336,4788\n10,Oakland Coliseum,Oakland Coliseum,-3,7.64,399.9396057902975,-21,399,-252,4788\n10,Oakland Coliseum,Oakland Coliseum,-2,7.64,399.6294846157794,-14,399,-168,4788\n10,Oakland Coliseum,Oakland Coliseum,-1,7.64,399.44142346886827,-7,399,-84,4788\n10,Oakland Coliseum,Oakland Coliseum,0,7.64,399.37513555089294,0,399,0,4788\n10,Oakland Coliseum,Oakland Coliseum,1,7.64,399.4305198481062,7,399,84,4788\n10,Oakland Coliseum,Oakland Coliseum,2,7.64,399.60766075585815,14,399,168,4788\n10,Oakland Coliseum,Oakland Coliseum,3,7.64,399.9068283925782,21,399,252,4788\n10,Oakland Coliseum,Oakland Coliseum,4,7.64,400.32847960574304,28,399,336,4788\n10,Oakland Coliseum,Oakland Coliseum,5,7.5,400.38668079222816,35,399,420,4788\n10,Oakland Coliseum,Oakland Coliseum,6,7.5,397.80656837392695,42,396,504,4752\n10,Oakland Coliseum,Oakland Coliseum,7,7.5,395.3791609939977,48,392,576,4704\n10,Oakland Coliseum,Oakland Coliseum,8,7.5,393.1002138245085,55,389,660,4668\n10,Oakland Coliseum,Oakland Coliseum,9,7.5,390.96579704951455,61,386,732,4632\n10,Oakland Coliseum,Oakland Coliseum,10,7.5,388.97227845498537,68,383,816,4596\n10,Oakland Coliseum,Oakland Coliseum,11,7.5,387.1163076268223,74,380,888,4560\n10,Oakland Coliseum,Oakland Coliseum,12,14.8,384.7552715162682,80,376,960,4512\n10,Oakland Coliseum,Oakland Coliseum,13,14.8,382.0709802034241,86,372,1032,4464\n10,Oakland Coliseum,Oakland Coliseum,14,14.8,379.53869413147163,92,368,1104,4416\n10,Oakland Coliseum,Oakland Coliseum,15,14.8,377.15388227617393,98,364,1176,4368\n10,Oakland Coliseum,Oakland Coliseum,16,14.8,374.912341798877,103,360,1236,4320\n10,Oakland Coliseum,Oakland Coliseum,17,14.8,372.8101788668605,109,357,1308,4284\n10,Oakland Coliseum,Oakland Coliseum,18,14.8,370.8437912285359,115,353,1380,4236\n10,Oakland Coliseum,Oakland Coliseum,19,14.8,369.0098523914895,120,349,1440,4188\n10,Oakland Coliseum,Oakland Coliseum,20,14.8,367.30529726839336,126,345,1512,4140\n10,Oakland Coliseum,Oakland Coliseum,21,14.8,365.72730917091957,131,341,1572,4092\n10,Oakland Coliseum,Oakland Coliseum,22,14.8,364.2733080452409,136,338,1632,4056\n10,Oakland Coliseum,Oakland Coliseum,23,15.17,363.6133350222834,142,335,1704,4020\n10,Oakland Coliseum,Oakland Coliseum,24,15.17,363.711715453623,148,332,1776,3984\n10,Oakland Coliseum,Oakland Coliseum,25,15.17,363.92103300878836,154,330,1848,3960\n10,Oakland Coliseum,Oakland Coliseum,26,15.17,364.24160704068566,160,327,1920,3924\n10,Oakland Coliseum,Oakland Coliseum,27,15.17,364.6739275000445,166,325,1992,3900\n10,Oakland Coliseum,Oakland Coliseum,28,15.17,365.21865676614834,171,322,2052,3864\n10,Oakland Coliseum,Oakland Coliseum,29,15.17,365.87663213080936,177,320,2124,3840\n10,Oakland Coliseum,Oakland Coliseum,30,15.17,366.64886895298275,183,318,2196,3816\n10,Oakland Coliseum,Oakland Coliseum,31,15.17,367.53656450624277,189,315,2268,3780\n10,Oakland Coliseum,Oakland Coliseum,32,7.75,368.3152313005965,195,312,2340,3744\n10,Oakland Coliseum,Oakland Coliseum,33,7.64,366.87488269231466,200,308,2400,3696\n10,Oakland Coliseum,Oakland Coliseum,34,7.64,362.8182438453865,203,301,2436,3612\n10,Oakland Coliseum,Oakland Coliseum,35,7.64,358.95848110974305,206,294,2472,3528\n10,Oakland Coliseum,Oakland Coliseum,36,7.81,355.2745535241911,209,287,2508,3444\n10,Oakland Coliseum,Oakland Coliseum,37,7.81,351.7411335787797,212,281,2544,3372\n10,Oakland Coliseum,Oakland Coliseum,38,7.81,348.38238109770106,214,275,2568,3300\n10,Oakland Coliseum,Oakland Coliseum,39,7.81,345.1913209581214,217,268,2604,3216\n10,Oakland Coliseum,Oakland Coliseum,40,7.81,342.1614678942818,220,262,2640,3144\n10,Oakland Coliseum,Oakland Coliseum,41,7.81,339.2867907966062,223,256,2676,3072\n10,Oakland Coliseum,Oakland Coliseum,42,7.81,336.56168038503733,225,250,2700,3000\n10,Oakland Coliseum,Oakland Coliseum,43,7.81,333.9809199093738,228,244,2736,2928\n10,Oakland Coliseum,Oakland Coliseum,44,7.81,331.53965857090344,230,238,2760,2856\n10,Oakland Coliseum,Oakland Coliseum,45,7.85,329.7492132665469,233,233,2796,2796\n12,Tropicana Field,Tropicana Field,-45,4.79,313.2137693777133,-221,221,-2652,2652\n12,Tropicana Field,Tropicana Field,-44,4.79,321.94736305902927,-224,232,-2688,2784\n12,Tropicana Field,Tropicana Field,-43,4.84,330.980511253833,-226,242,-2712,2904\n12,Tropicana Field,Tropicana Field,-42,4.84,338.5595566669427,-227,252,-2724,3024\n12,Tropicana Field,Tropicana Field,-41,11.35,342.5833982255952,-225,259,-2700,3108\n12,Tropicana Field,Tropicana Field,-40,11.35,343.05145499976095,-221,263,-2652,3156\n12,Tropicana Field,Tropicana Field,-39,11.35,343.6256073876929,-216,267,-2592,3204\n12,Tropicana Field,Tropicana Field,-38,11.35,344.30673986728993,-212,271,-2544,3252\n12,Tropicana Field,Tropicana Field,-37,11.35,345.0959063201043,-208,276,-2496,3312\n12,Tropicana Field,Tropicana Field,-36,11.35,345.99433404014053,-203,280,-2436,3360\n12,Tropicana Field,Tropicana Field,-35,11.35,347.00342843690015,-199,284,-2388,3408\n12,Tropicana Field,Tropicana Field,-34,11.35,348.1247784665426,-195,289,-2340,3468\n12,Tropicana Field,Tropicana Field,-33,11.35,349.36016283069864,-190,293,-2280,3516\n12,Tropicana Field,Tropicana Field,-32,11.35,350.71155698861395,-186,297,-2232,3564\n12,Tropicana Field,Tropicana Field,-31,11.35,352.18114103498044,-181,302,-2172,3624\n12,Tropicana Field,Tropicana Field,-30,11.35,353.77130850314404,-177,306,-2124,3672\n12,Tropicana Field,Tropicana Field,-29,11.35,355.4846761614366,-172,311,-2064,3732\n12,Tropicana Field,Tropicana Field,-28,11.35,357.3240948793046,-168,315,-2016,3780\n12,Tropicana Field,Tropicana Field,-27,11.35,359.29266164981607,-163,320,-1956,3840\n12,Tropicana Field,Tropicana Field,-26,11.35,361.3937328661732,-158,325,-1896,3900\n12,Tropicana Field,Tropicana Field,-25,11.35,363.6309389622218,-154,330,-1848,3960\n12,Tropicana Field,Tropicana Field,-24,11.35,366.00820054082004,-149,334,-1788,4008\n12,Tropicana Field,Tropicana Field,-23,11.35,368.5297461295451,-144,339,-1728,4068\n12,Tropicana Field,Tropicana Field,-22,11.35,371.20013172084634,-139,344,-1668,4128\n12,Tropicana Field,Tropicana Field,-21,11.35,374.0242622737057,-134,349,-1608,4188\n12,Tropicana Field,Tropicana Field,-20,11.35,377.0074153765076,-129,354,-1548,4248\n12,Tropicana Field,Tropicana Field,-19,11.35,380.15526729657796,-124,359,-1488,4308\n12,Tropicana Field,Tropicana Field,-18,11.35,383.47392167122246,-118,365,-1416,4380\n12,Tropicana Field,Tropicana Field,-17,11.35,386.96994112867077,-113,370,-1356,4440\n12,Tropicana Field,Tropicana Field,-16,11.35,390.6503821658049,-108,376,-1296,4512\n12,Tropicana Field,Tropicana Field,-15,11.35,394.5228336537397,-102,381,-1224,4572\n12,Tropicana Field,Tropicana Field,-14,9.09,396.4169442276659,-96,385,-1152,4620\n12,Tropicana Field,Tropicana Field,-13,9.11,396.7568906431653,-89,387,-1068,4644\n12,Tropicana Field,Tropicana Field,-12,9.2,401.8494564076589,-84,393,-1008,4716\n12,Tropicana Field,Tropicana Field,-11,9.2,411.0117909726189,-78,403,-936,4836\n12,Tropicana Field,Tropicana Field,-10,9.09,414.8210933918109,-72,409,-864,4908\n12,Tropicana Field,Tropicana Field,-9,9.09,413.13887331527474,-65,408,-780,4896\n12,Tropicana Field,Tropicana Field,-8,9.09,411.5951113913296,-57,408,-684,4896\n12,Tropicana Field,Tropicana Field,-7,9.09,410.18732544844227,-50,407,-600,4884\n12,Tropicana Field,Tropicana Field,-6,9.09,408.9132711940243,-43,407,-516,4884\n12,Tropicana Field,Tropicana Field,-5,9.09,407.77093330323396,-36,406,-432,4872\n12,Tropicana Field,Tropicana Field,-4,9.09,406.7585175054214,-28,406,-336,4872\n12,Tropicana Field,Tropicana Field,-3,9.09,405.87444360941936,-21,405,-252,4860\n12,Tropicana Field,Tropicana Field,-2,9.09,405.1173394165249,-14,405,-168,4860\n12,Tropicana Field,Tropicana Field,-1,9.09,404.48603547704005,-7,404,-84,4848\n12,Tropicana Field,Tropicana Field,0,9.09,403.97956065274764,0,404,0,4848\n12,Tropicana Field,Tropicana Field,1,9.09,403.5971384537718,7,404,84,4848\n12,Tropicana Field,Tropicana Field,2,9.09,403.3381841239748,14,403,168,4836\n12,Tropicana Field,Tropicana Field,3,9.09,403.2023024544577,21,403,252,4836\n12,Tropicana Field,Tropicana Field,4,9.09,403.18928630991223,28,402,336,4824\n12,Tropicana Field,Tropicana Field,5,9.09,403.29911585758055,35,402,420,4824\n12,Tropicana Field,Tropicana Field,6,9.09,403.53195849347867,42,401,504,4812\n12,Tropicana Field,Tropicana Field,7,9.09,403.88816946536923,49,401,588,4812\n12,Tropicana Field,Tropicana Field,8,9.09,404.3682931968035,56,400,672,4800\n12,Tropicana Field,Tropicana Field,9,9.09,404.97306532143165,63,400,756,4800\n12,Tropicana Field,Tropicana Field,10,9.05,405.0753841205355,70,399,840,4788\n12,Tropicana Field,Tropicana Field,11,9.05,404.0660233874701,77,397,924,4764\n12,Tropicana Field,Tropicana Field,12,9.05,403.18418891577085,84,394,1008,4728\n12,Tropicana Field,Tropicana Field,13,9.15,402.26089609098915,90,392,1080,4704\n12,Tropicana Field,Tropicana Field,14,11.24,398.8183005674036,96,387,1152,4644\n12,Tropicana Field,Tropicana Field,15,11.24,394.7308923524597,102,381,1224,4572\n12,Tropicana Field,Tropicana Field,16,11.24,390.84426338295793,108,376,1296,4512\n12,Tropicana Field,Tropicana Field,17,11.24,387.1502056435348,113,370,1356,4440\n12,Tropicana Field,Tropicana Field,18,11.24,383.6410893699163,119,365,1428,4380\n12,Tropicana Field,Tropicana Field,19,11.24,380.3098201725214,124,360,1488,4320\n12,Tropicana Field,Tropicana Field,20,11.24,377.14980024374313,129,354,1548,4248\n12,Tropicana Field,Tropicana Field,21,11.24,374.15489322282866,134,349,1608,4188\n12,Tropicana Field,Tropicana Field,22,11.24,371.31939234371043,139,344,1668,4128\n12,Tropicana Field,Tropicana Field,23,11.24,368.6379915357936,144,339,1728,4068\n12,Tropicana Field,Tropicana Field,24,11.24,366.10575918658515,149,334,1788,4008\n12,Tropicana Field,Tropicana Field,25,11.24,363.7181143089608,154,330,1848,3960\n12,Tropicana Field,Tropicana Field,26,11.24,361.4708048855389,158,325,1896,3900\n12,Tropicana Field,Tropicana Field,27,11.24,359.3598881886369,163,320,1956,3840\n12,Tropicana Field,Tropicana Field,28,11.24,357.3817128971485,168,316,2016,3792\n12,Tropicana Field,Tropicana Field,29,11.24,355.5329028518174,172,311,2064,3732\n12,Tropicana Field,Tropicana Field,30,11.24,353.8103423081835,177,306,2124,3672\n12,Tropicana Field,Tropicana Field,31,11.24,352.2111625622239,181,302,2172,3624\n12,Tropicana Field,Tropicana Field,32,11.24,350.7327298377179,186,297,2232,3564\n12,Tropicana Field,Tropicana Field,33,11.24,349.372634336823,190,293,2280,3516\n12,Tropicana Field,Tropicana Field,34,11.24,348.12868036649525,195,289,2340,3468\n12,Tropicana Field,Tropicana Field,35,11.24,346.9988774633718,199,284,2388,3408\n12,Tropicana Field,Tropicana Field,36,11.24,345.98143244872745,203,280,2436,3360\n12,Tropicana Field,Tropicana Field,37,11.24,345.0747423532407,208,276,2496,3312\n12,Tropicana Field,Tropicana Field,38,11.24,344.2773881586778,212,271,2544,3252\n12,Tropicana Field,Tropicana Field,39,11.24,343.58812931033884,216,267,2592,3204\n12,Tropicana Field,Tropicana Field,40,11.24,343.00589896027964,220,263,2640,3156\n12,Tropicana Field,Tropicana Field,41,11.24,342.5297999070273,225,259,2700,3108\n12,Tropicana Field,Tropicana Field,42,11.24,342.1591012028076,229,254,2748,3048\n12,Tropicana Field,Tropicana Field,43,8.86,332.9246524739043,227,243,2724,2916\n12,Tropicana Field,Tropicana Field,44,8.86,325.30291868328914,226,234,2712,2808\n12,Tropicana Field,Tropicana Field,45,8.92,319.87254549886376,226,226,2712,2712\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-45,12.148,331.7438722468797,-235,235,-2820,2820\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-44,12.148,335.1789411494384,-233,241,-2796,2892\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-43,12.148,338.79017028584894,-231,248,-2772,2976\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-42,12.148,342.58555338882223,-229,255,-2748,3060\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-41,12.148,346.57370320755155,-227,262,-2724,3144\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-40,12.148,350.76390597157416,-225,269,-2700,3228\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-39,12.148,353.8669132295619,-223,275,-2676,3300\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-38,12.148,354.57382302937594,-218,279,-2616,3348\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-37,12.148,355.39203537877296,-214,284,-2568,3408\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-36,12.148,356.3228230935344,-209,288,-2508,3456\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-35,12.148,357.36764265841225,-205,293,-2460,3516\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-34,12.148,358.52813985819637,-200,297,-2400,3564\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-33,12.148,359.80615620144005,-196,302,-2352,3624\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-32,12.148,361.2037361842091,-191,306,-2292,3672\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-31,12.148,362.72313544812965,-187,311,-2244,3732\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-30,12.148,364.3668298945914,-182,316,-2184,3792\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-29,12.148,366.1375258253069,-178,320,-2136,3840\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-28,12.148,368.0381711886606,-173,325,-2076,3900\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-27,12.148,370.0719680215432,-168,330,-2016,3960\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-26,12.148,372.24238618780157,-163,335,-1956,4020\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-25,12.148,374.55317852723977,-158,339,-1896,4068\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-24,12.148,377.00839754347396,-153,344,-1836,4128\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-23,12.148,379.61241377511953,-148,349,-1776,4188\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-22,12.148,382.3699360130574,-143,355,-1716,4260\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-21,12.148,385.28603354719473,-138,360,-1656,4320\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-20,12.148,388.36616064960754,-133,365,-1596,4380\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-19,5.819,389.3776397531881,-127,368,-1524,4416\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-18,5.819,389.998718459494,-121,371,-1452,4452\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-17,5.819,390.7409952850575,-114,374,-1368,4488\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-16,5.819,391.60561735403047,-108,376,-1296,4512\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-15,5.819,392.5939274592155,-102,379,-1224,4548\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-14,5.819,393.707469197501,-95,382,-1140,4584\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-13,5.819,394.9479929216342,-89,385,-1068,4620\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-12,5.819,396.317462551538,-82,388,-984,4656\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-11,5.819,397.8180632951967,-76,391,-912,4692\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-10,5.819,399.4522103365628,-69,393,-828,4716\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-9,5.819,401.22255855605687,-63,396,-756,4752\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-8,5.87,402.5865857823952,-56,399,-672,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-7,5.87,401.6589144035598,-49,399,-588,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-6,5.87,400.8573327310835,-42,399,-504,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-5,5.87,400.18060018453747,-35,399,-420,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-4,5.87,399.6276740245513,-28,399,-336,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-3,5.87,399.19770541016766,-21,399,-252,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-2,5.87,398.89003620645695,-14,399,-168,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,-1,5.87,398.7041965199538,-7,399,-84,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,0,5.87,398.6399029446908,0,399,0,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,1,5.87,398.6970575066204,7,399,84,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,2,5.87,398.87574729910096,14,399,168,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,3,5.87,399.1762448069187,21,399,252,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,4,5.87,399.5990089210928,28,399,336,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,5,5.87,400.14468665150514,35,399,420,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,6,5.87,400.81411554927126,42,399,504,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,7,5.87,401.60832685577924,49,399,588,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,8,5.87,402.52854940052185,56,399,672,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,9,5.87,403.5762142752964,63,399,756,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,10,5.87,404.7529603181146,70,399,840,4788\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,11,5.88,405.4321642882417,77,398,924,4776\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,12,5.88,400.75610098871294,83,392,996,4704\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,13,5.88,396.30601306237565,89,386,1068,4632\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,14,5.88,392.0717866245735,95,380,1140,4560\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,15,5.88,388.044035070481,100,375,1200,4500\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,16,5.88,384.2140414136425,106,369,1272,4428\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,17,5.88,380.5737063205509,111,364,1332,4368\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,18,5.88,377.1155012134425,117,359,1404,4308\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,19,5.96,374.3963661618286,122,354,1464,4248\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,20,5.96,376.76642213020847,129,354,1548,4248\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,21,5.96,379.2829450594776,136,354,1632,4248\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,22,5.87,376.9078617840589,141,349,1692,4188\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,23,5.87,374.1921910211591,146,344,1752,4128\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,24,5.87,371.6277654647477,151,339,1812,4068\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,25,5.87,369.20994928943105,156,335,1872,4020\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,26,5.87,366.93443975106055,161,330,1932,3960\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,27,5.87,364.7972472906428,166,325,1992,3900\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,28,5.87,362.79467745507264,170,320,2040,3840\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,29,5.87,360.92331447459935,175,316,2100,3792\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,30,5.87,359.18000635490324,180,311,2160,3732\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,31,5.87,357.5618513575711,184,306,2208,3672\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,32,5.87,356.06618575689384,189,302,2268,3624\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,33,5.87,354.6905727735057,193,297,2316,3564\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,34,5.87,353.43279259663524,198,293,2376,3516\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,35,5.87,352.29083341683497,202,289,2424,3468\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,36,5.87,351.26288340014094,206,284,2472,3408\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,37,5.87,350.34732354282653,211,280,2532,3360\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,38,5.87,349.542721353371,215,275,2580,3300\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,39,5.87,348.8478253150731,220,271,2640,3252\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,40,5.87,348.26156008898045,224,267,2688,3204\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,41,5.87,347.7830224225799,228,262,2736,3144\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,42,5.89,341.99214748147523,229,254,2748,3048\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,43,5.89,335.52309417739065,229,245,2748,2940\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,44,5.89,329.39270554135095,229,237,2748,2844\n13,Globe Life Park in Arlington,Globe Life Park in Arlington,45,5.89,323.5791123730707,229,229,2748,2748\n14,Rogers Centre,Rogers Centre,-45,14.11,328.14720626973315,-232,232,-2784,2784\n14,Rogers Centre,Rogers Centre,-44,14.11,328.18865760498477,-228,236,-2736,2832\n14,Rogers Centre,Rogers Centre,-43,14.11,328.33014459153077,-224,240,-2688,2880\n14,Rogers Centre,Rogers Centre,-42,14.11,328.57188297070275,-220,244,-2640,2928\n14,Rogers Centre,Rogers Centre,-41,14.11,328.9142418652753,-216,248,-2592,2976\n14,Rogers Centre,Rogers Centre,-40,14.11,329.3577451568701,-212,252,-2544,3024\n14,Rogers Centre,Rogers Centre,-39,14.11,329.90307344693827,-208,256,-2496,3072\n14,Rogers Centre,Rogers Centre,-38,14.11,330.5510666150202,-204,260,-2448,3120\n14,Rogers Centre,Rogers Centre,-37,14.2,331.8105813846321,-200,265,-2400,3180\n14,Rogers Centre,Rogers Centre,-36,14.2,333.29935911114734,-196,270,-2352,3240\n14,Rogers Centre,Rogers Centre,-35,14.2,334.90403163589673,-192,274,-2304,3288\n14,Rogers Centre,Rogers Centre,-34,14.2,336.62726632378616,-188,279,-2256,3348\n14,Rogers Centre,Rogers Centre,-33,14.2,338.4719614838037,-184,284,-2208,3408\n14,Rogers Centre,Rogers Centre,-32,14.15,340.47309650650686,-180,289,-2160,3468\n14,Rogers Centre,Rogers Centre,-31,14.15,343.5602604407659,-177,294,-2124,3528\n14,Rogers Centre,Rogers Centre,-30,14.15,346.8105294832683,-173,300,-2076,3600\n14,Rogers Centre,Rogers Centre,-29,14.15,350.23058711478126,-170,306,-2040,3672\n14,Rogers Centre,Rogers Centre,-28,14.15,353.82762284252027,-166,312,-1992,3744\n14,Rogers Centre,Rogers Centre,-27,14.15,357.60937351704115,-162,319,-1944,3828\n14,Rogers Centre,Rogers Centre,-26,10.19,360.1556683506035,-158,324,-1896,3888\n14,Rogers Centre,Rogers Centre,-25,10.21,362.25483675688116,-153,328,-1836,3936\n14,Rogers Centre,Rogers Centre,-24,10.21,364.5210848044104,-148,333,-1776,3996\n14,Rogers Centre,Rogers Centre,-23,10.21,366.9283399800306,-143,338,-1716,4056\n14,Rogers Centre,Rogers Centre,-22,10.21,369.48089664097927,-138,343,-1656,4116\n14,Rogers Centre,Rogers Centre,-21,10.21,372.18338093923643,-133,347,-1596,4164\n14,Rogers Centre,Rogers Centre,-20,10.21,375.04077274392245,-128,352,-1536,4224\n14,Rogers Centre,Rogers Centre,-19,10.21,378.058429768291,-123,357,-1476,4284\n14,Rogers Centre,Rogers Centre,-18,10.21,381.2421141323367,-118,363,-1416,4356\n14,Rogers Centre,Rogers Centre,-17,12.73,382.3590449118629,-112,366,-1344,4392\n14,Rogers Centre,Rogers Centre,-16,12.73,383.0020105092991,-106,368,-1272,4416\n14,Rogers Centre,Rogers Centre,-15,12.73,383.76423734819576,-99,371,-1188,4452\n14,Rogers Centre,Rogers Centre,-14,12.73,384.64690492730875,-93,373,-1116,4476\n14,Rogers Centre,Rogers Centre,-13,12.73,385.65138614511784,-87,376,-1044,4512\n14,Rogers Centre,Rogers Centre,-12,12.73,386.77925256190537,-80,378,-960,4536\n14,Rogers Centre,Rogers Centre,-11,12.73,388.03228047439893,-74,381,-888,4572\n14,Rogers Centre,Rogers Centre,-10,12.73,389.41245784721366,-68,383,-816,4596\n14,Rogers Centre,Rogers Centre,-9,12.73,390.92199215218386,-61,386,-732,4632\n14,Rogers Centre,Rogers Centre,-8,12.73,392.5633191741432,-55,389,-660,4668\n14,Rogers Centre,Rogers Centre,-7,7.75,394.21671656928726,-48,391,-576,4692\n14,Rogers Centre,Rogers Centre,-6,7.75,395.71594478670096,-41,394,-492,4728\n14,Rogers Centre,Rogers Centre,-5,7.75,397.348117984739,-35,396,-420,4752\n14,Rogers Centre,Rogers Centre,-4,7.76,398.62228967910613,-28,398,-336,4776\n14,Rogers Centre,Rogers Centre,-3,7.76,399.1576566747206,-21,399,-252,4788\n14,Rogers Centre,Rogers Centre,-2,7.76,399.816415386101,-14,400,-168,4800\n14,Rogers Centre,Rogers Centre,-1,7.66,400.11842338365653,-7,400,-84,4800\n14,Rogers Centre,Rogers Centre,0,7.66,400.0498790250958,0,400,0,4800\n14,Rogers Centre,Rogers Centre,1,7.66,400.1032125867399,7,400,84,4800\n14,Rogers Centre,Rogers Centre,2,7.68,399.78328420824874,14,400,168,4800\n14,Rogers Centre,Rogers Centre,3,7.68,399.1694637870286,21,399,252,4788\n14,Rogers Centre,Rogers Centre,4,7.68,398.6787806204033,28,398,336,4776\n14,Rogers Centre,Rogers Centre,5,7.69,397.45655736373374,35,396,420,4752\n14,Rogers Centre,Rogers Centre,6,7.69,395.8333909736058,41,394,492,4728\n14,Rogers Centre,Rogers Centre,7,7.69,394.3430604593056,48,391,576,4692\n14,Rogers Centre,Rogers Centre,8,13.51,392.19741480610844,55,388,660,4656\n14,Rogers Centre,Rogers Centre,9,13.51,390.05364273652015,61,385,732,4620\n14,Rogers Centre,Rogers Centre,10,13.51,388.05074062476757,67,382,804,4584\n14,Rogers Centre,Rogers Centre,11,13.5,386.18259475329177,74,379,888,4548\n14,Rogers Centre,Rogers Centre,12,13.5,384.447673999067,80,376,960,4512\n14,Rogers Centre,Rogers Centre,13,13.5,382.8443682911471,86,373,1032,4476\n14,Rogers Centre,Rogers Centre,14,13.5,381.37006649528354,92,370,1104,4440\n14,Rogers Centre,Rogers Centre,15,13.5,380.0223904028539,98,367,1176,4404\n14,Rogers Centre,Rogers Centre,16,13.5,378.7991851286039,104,364,1248,4368\n14,Rogers Centre,Rogers Centre,17,10.8,376.8480852298787,110,360,1320,4320\n14,Rogers Centre,Rogers Centre,18,10.8,373.2982005062581,115,355,1380,4260\n14,Rogers Centre,Rogers Centre,19,10.8,369.9262025768671,120,350,1440,4200\n14,Rogers Centre,Rogers Centre,20,14.09,366.7376960096939,125,345,1500,4140\n14,Rogers Centre,Rogers Centre,21,14.09,363.6735900990021,130,340,1560,4080\n14,Rogers Centre,Rogers Centre,22,14.09,360.76924460930684,135,334,1620,4008\n14,Rogers Centre,Rogers Centre,23,14.09,358.01911261611326,140,330,1680,3960\n14,Rogers Centre,Rogers Centre,24,14.09,355.4180364820209,145,325,1740,3900\n14,Rogers Centre,Rogers Centre,25,14.09,352.96122227925105,149,320,1788,3840\n14,Rogers Centre,Rogers Centre,26,13.9,351.1777421992768,154,316,1848,3792\n14,Rogers Centre,Rogers Centre,27,13.9,349.6138932051805,159,312,1908,3744\n14,Rogers Centre,Rogers Centre,28,13.9,348.16949619878517,163,307,1956,3684\n14,Rogers Centre,Rogers Centre,29,13.9,346.8422016705485,168,303,2016,3636\n14,Rogers Centre,Rogers Centre,30,14.18,345.99201901857685,173,300,2076,3600\n14,Rogers Centre,Rogers Centre,31,14.18,345.82428511029457,178,296,2136,3552\n14,Rogers Centre,Rogers Centre,32,14.18,345.7619851705669,183,293,2196,3516\n14,Rogers Centre,Rogers Centre,33,14.18,345.8050242609424,188,290,2256,3480\n14,Rogers Centre,Rogers Centre,34,14.18,345.9534679640105,193,287,2316,3444\n14,Rogers Centre,Rogers Centre,35,10.52,343.8150500662067,197,282,2364,3384\n14,Rogers Centre,Rogers Centre,36,10.52,341.69941082304257,201,276,2412,3312\n14,Rogers Centre,Rogers Centre,37,10.52,339.7124960450046,204,271,2448,3252\n14,Rogers Centre,Rogers Centre,38,10.52,337.85087240846855,208,266,2496,3192\n14,Rogers Centre,Rogers Centre,39,10.52,336.1113657350941,212,261,2544,3132\n14,Rogers Centre,Rogers Centre,40,10.52,334.49104714539783,215,256,2580,3072\n14,Rogers Centre,Rogers Centre,41,10.52,332.9872205022953,218,251,2616,3012\n14,Rogers Centre,Rogers Centre,42,10.52,331.5974110405832,222,246,2664,2952\n14,Rogers Centre,Rogers Centre,43,10.52,330.3193550900209,225,242,2700,2904\n14,Rogers Centre,Rogers Centre,44,12.33,329.2485409017315,229,237,2748,2844\n14,Rogers Centre,Rogers Centre,45,12.33,328.25508031150747,232,232,2784,2784\n15,Chase Field,Chase Field,-45,8.04,328.6968626315445,-232,232,-2784,2784\n15,Chase Field,Chase Field,-44,8.04,334.67368861262855,-232,241,-2784,2892\n15,Chase Field,Chase Field,-43,8.04,340.97768681817513,-233,249,-2796,2988\n15,Chase Field,Chase Field,-42,8.04,347.63165655385836,-233,258,-2796,3096\n15,Chase Field,Chase Field,-41,8.04,354.6606744503922,-233,268,-2796,3216\n15,Chase Field,Chase Field,-40,8.22,362.248738851685,-233,277,-2796,3324\n15,Chase Field,Chase Field,-39,10.1,361.798413703032,-228,281,-2736,3372\n15,Chase Field,Chase Field,-38,10.1,356.8023512463859,-220,281,-2640,3372\n15,Chase Field,Chase Field,-37,7.31,355.99450104526903,-214,284,-2568,3408\n15,Chase Field,Chase Field,-36,7.31,356.617890430229,-210,289,-2520,3468\n15,Chase Field,Chase Field,-35,7.31,357.35251089108186,-205,293,-2460,3516\n15,Chase Field,Chase Field,-34,7.31,358.1995004514069,-200,297,-2400,3564\n15,Chase Field,Chase Field,-33,7.31,359.16017817703306,-196,301,-2352,3612\n15,Chase Field,Chase Field,-32,7.31,360.2360492409827,-191,305,-2292,3660\n15,Chase Field,Chase Field,-31,7.31,361.42881075344775,-186,310,-2232,3720\n15,Chase Field,Chase Field,-30,7.31,362.74035839936266,-181,314,-2172,3768\n15,Chase Field,Chase Field,-29,7.31,364.1727939326415,-177,319,-2124,3828\n15,Chase Field,Chase Field,-28,7.31,365.7284335832366,-172,323,-2064,3876\n15,Chase Field,Chase Field,-27,7.31,367.4098174409608,-167,327,-2004,3924\n15,Chase Field,Chase Field,-26,7.31,369.21971988858826,-162,332,-1944,3984\n15,Chase Field,Chase Field,-25,7.31,371.1611611662501,-157,336,-1884,4032\n15,Chase Field,Chase Field,-24,7.31,373.23742015970106,-152,341,-1824,4092\n15,Chase Field,Chase Field,-23,7.31,375.45204851681615,-147,346,-1764,4152\n15,Chase Field,Chase Field,-22,7.31,377.8088862098781,-142,350,-1704,4200\n15,Chase Field,Chase Field,-21,7.31,380.3120786760279,-136,355,-1632,4260\n15,Chase Field,Chase Field,-20,7.31,382.9660956849588,-131,360,-1572,4320\n15,Chase Field,Chase Field,-19,7.31,385.7757521017838,-126,365,-1512,4380\n15,Chase Field,Chase Field,-18,7.31,388.74623073437505,-120,370,-1440,4440\n15,Chase Field,Chase Field,-17,7.31,391.8831074787255,-115,375,-1380,4500\n15,Chase Field,Chase Field,-16,7.31,395.19237900349015,-109,380,-1308,4560\n15,Chase Field,Chase Field,-15,7.31,398.680493246371,-103,385,-1236,4620\n15,Chase Field,Chase Field,-14,7.31,402.3543830310397,-97,390,-1164,4680\n15,Chase Field,Chase Field,-13,7.31,406.2215031546061,-91,396,-1092,4752\n15,Chase Field,Chase Field,-12,7.31,410.28987134312473,-85,401,-1020,4812\n15,Chase Field,Chase Field,-11,24.33,401.23821877654115,-77,394,-924,4728\n15,Chase Field,Chase Field,-10,24.4,403.3862215501467,-70,397,-840,4764\n15,Chase Field,Chase Field,-9,24.4,402.24138382163756,-63,397,-756,4764\n15,Chase Field,Chase Field,-8,24.4,401.22489707045196,-56,397,-672,4764\n15,Chase Field,Chase Field,-7,24.4,400.3351733928958,-49,397,-588,4764\n15,Chase Field,Chase Field,-6,24.4,399.57083078390474,-42,397,-504,4764\n15,Chase Field,Chase Field,-5,24.46,407.7578530281881,-36,406,-432,4872\n15,Chase Field,Chase Field,-4,24.46,407.2129226903437,-28,406,-336,4872\n15,Chase Field,Chase Field,-3,24.46,406.7931946762029,-21,406,-252,4872\n15,Chase Field,Chase Field,-2,24.46,406.498026766051,-14,406,-168,4872\n15,Chase Field,Chase Field,-1,24.46,406.3269682790764,-7,406,-84,4872\n15,Chase Field,Chase Field,0,24.46,406.27975839177117,0,406,0,4872\n15,Chase Field,Chase Field,1,24.46,406.3563251666868,7,406,84,4872\n15,Chase Field,Chase Field,2,24.46,406.55678528480945,14,406,168,4872\n15,Chase Field,Chase Field,3,24.46,406.88144447969745,21,406,252,4872\n15,Chase Field,Chase Field,4,24.46,407.33079867639134,28,406,336,4872\n15,Chase Field,Chase Field,5,24.46,407.90553584300176,36,406,432,4872\n15,Chase Field,Chase Field,6,24.34,399.8487925858659,42,398,504,4776\n15,Chase Field,Chase Field,7,24.34,400.677852568148,49,398,588,4776\n15,Chase Field,Chase Field,8,24.34,401.6329531774635,56,398,672,4776\n15,Chase Field,Chase Field,9,24.34,402.7155822149474,63,398,756,4776\n15,Chase Field,Chase Field,10,24.34,403.9274363986165,70,398,840,4776\n15,Chase Field,Chase Field,11,24.44,401.74329798635665,77,394,924,4728\n15,Chase Field,Chase Field,12,6.9,410.5339612020635,85,402,1020,4824\n15,Chase Field,Chase Field,13,6.9,406.5279917402931,91,396,1092,4752\n15,Chase Field,Chase Field,14,6.9,402.72093409643264,97,391,1164,4692\n15,Chase Field,Chase Field,15,6.9,399.1049629491668,103,386,1236,4632\n15,Chase Field,Chase Field,16,6.9,395.67280169888755,109,380,1308,4560\n15,Chase Field,Chase Field,17,6.9,392.4176829147798,115,375,1380,4500\n15,Chase Field,Chase Field,18,6.9,389.33331250334726,120,370,1440,4440\n15,Chase Field,Chase Field,19,6.9,386.41383721877213,126,365,1512,4380\n15,Chase Field,Chase Field,20,6.9,383.6538151806205,131,361,1572,4332\n15,Chase Field,Chase Field,21,6.9,381.04818910371733,137,356,1644,4272\n15,Chase Field,Chase Field,22,6.9,378.5922619793205,142,351,1704,4212\n15,Chase Field,Chase Field,23,6.9,376.28167497675315,147,346,1764,4152\n15,Chase Field,Chase Field,24,6.9,374.112387360994,152,342,1824,4104\n15,Chase Field,Chase Field,25,6.9,372.0806582448861,157,337,1884,4044\n15,Chase Field,Chase Field,26,6.9,370.183030015047,162,333,1944,3996\n15,Chase Field,Chase Field,27,6.9,368.41631328860916,167,328,2004,3936\n15,Chase Field,Chase Field,28,6.9,366.7775732739148,172,324,2064,3888\n15,Chase Field,Chase Field,29,6.9,365.26411742250485,177,319,2124,3828\n15,Chase Field,Chase Field,30,6.9,363.8734842724088,182,315,2184,3780\n15,Chase Field,Chase Field,31,6.9,362.6034333940785,187,311,2244,3732\n15,Chase Field,Chase Field,32,6.9,361.4519363604721,192,307,2304,3684\n15,Chase Field,Chase Field,33,6.9,360.4171686719557,196,302,2352,3624\n15,Chase Field,Chase Field,34,6.9,359.497502574977,201,298,2412,3576\n15,Chase Field,Chase Field,35,6.9,358.69150072099285,206,294,2472,3528\n15,Chase Field,Chase Field,36,6.9,357.9979106190135,210,290,2520,3480\n15,Chase Field,Chase Field,37,6.9,357.41565984144506,215,285,2580,3420\n15,Chase Field,Chase Field,38,6.9,356.9438519487558,220,281,2640,3372\n15,Chase Field,Chase Field,39,6.92,356.6315435293787,224,277,2688,3324\n15,Chase Field,Chase Field,40,6.92,361.53642269441366,232,277,2784,3324\n15,Chase Field,Chase Field,41,8.69,359.80803678803517,236,272,2832,3264\n15,Chase Field,Chase Field,42,8.29,352.74614879942914,236,262,2832,3144\n15,Chase Field,Chase Field,43,8.29,346.0697883681159,236,253,2832,3036\n15,Chase Field,Chase Field,44,8.29,339.7430246537439,236,244,2832,2928\n15,Chase Field,Chase Field,45,8.29,333.7432727345652,236,236,2832,2832\n16,Turner Field,Turner Field,-45,8,336,-238,238,-2851,2851\n16,Turner Field,Turner Field,-44,8,338,-235,243,-2818,2918\n16,Turner Field,Turner Field,-43,8,340.1,-232,249,-2783,2985\n16,Turner Field,Turner Field,-42,8,342.4,-229,254,-2749,3053\n16,Turner Field,Turner Field,-41,8,344.8,-226,260,-2715,3123\n16,Turner Field,Turner Field,-40,8,347.3,-223,266,-2679,3193\n16,Turner Field,Turner Field,-39,8,349.7,-220,272,-2641,3261\n16,Turner Field,Turner Field,-38,8,351.9,-217,277,-2600,3328\n16,Turner Field,Turner Field,-37,8,354.3,-213,283,-2559,3395\n16,Turner Field,Turner Field,-36,8,356.6,-210,288,-2515,3462\n16,Turner Field,Turner Field,-35,8,358.7,-206,294,-2469,3526\n16,Turner Field,Turner Field,-34,8,361,-202,299,-2422,3591\n16,Turner Field,Turner Field,-33,8,363.3,-198,305,-2374,3656\n16,Turner Field,Turner Field,-32,8,365.1,-193,310,-2322,3715\n16,Turner Field,Turner Field,-31,8,367.1,-189,315,-2269,3776\n16,Turner Field,Turner Field,-30,8,369.2,-185,320,-2215,3837\n16,Turner Field,Turner Field,-29,8,371.2,-180,325,-2160,3896\n16,Turner Field,Turner Field,-28,8,372.9,-175,329,-2101,3951\n16,Turner Field,Turner Field,-27,8,374.7,-170,334,-2041,4006\n16,Turner Field,Turner Field,-26,8,376.6,-165,338,-1981,4062\n16,Turner Field,Turner Field,-25,8,378.1,-160,343,-1918,4112\n16,Turner Field,Turner Field,-24,8,379.8,-154,347,-1854,4164\n16,Turner Field,Turner Field,-23,8,381.6,-149,351,-1789,4215\n16,Turner Field,Turner Field,-22,8,383.3,-144,355,-1723,4265\n16,Turner Field,Turner Field,-21,8,384.5,-138,359,-1654,4308\n16,Turner Field,Turner Field,-20,8,385.9,-132,363,-1584,4352\n16,Turner Field,Turner Field,-19,8,387.4,-126,366,-1514,4396\n16,Turner Field,Turner Field,-18,8,388.5,-120,369,-1441,4434\n16,Turner Field,Turner Field,-17,8,389.5,-114,372,-1367,4470\n16,Turner Field,Turner Field,-16,8,390.7,-108,376,-1292,4507\n16,Turner Field,Turner Field,-15,8,392,-101,379,-1217,4544\n16,Turner Field,Turner Field,-14,8,393.3,-95,382,-1142,4579\n16,Turner Field,Turner Field,-13,8,394.1,-89,384,-1064,4608\n16,Turner Field,Turner Field,-12,8,395,-82,386,-986,4636\n16,Turner Field,Turner Field,-11,8,396,-76,389,-907,4665\n16,Turner Field,Turner Field,-10,8,396.9,-69,391,-827,4690\n16,Turner Field,Turner Field,-9,8,397.5,-62,393,-746,4711\n16,Turner Field,Turner Field,-8,8,398.2,-55,394,-665,4732\n16,Turner Field,Turner Field,-7,8,399,-49,396,-584,4752\n16,Turner Field,Turner Field,-6,8,399.6,-42,397,-501,4769\n16,Turner Field,Turner Field,-5,8,400,-35,398,-418,4782\n16,Turner Field,Turner Field,-4,8,400.5,-28,400,-335,4794\n16,Turner Field,Turner Field,-3,8,401.1,-21,401,-252,4807\n16,Turner Field,Turner Field,-2,8,401.4,-14,401,-168,4814\n16,Turner Field,Turner Field,-1,8,401.6,-7,402,-84,4818\n16,Turner Field,Turner Field,0,8,401.9,0,402,0,4823\n16,Turner Field,Turner Field,1,8,402.2,7,402,84,4826\n16,Turner Field,Turner Field,2,8,402.2,14,402,168,4823\n16,Turner Field,Turner Field,3,8,402.3,21,402,253,4821\n16,Turner Field,Turner Field,4,8,402.5,28,402,337,4818\n16,Turner Field,Turner Field,5,8,402.5,35,401,421,4812\n16,Turner Field,Turner Field,6,8,402.6,42,400,505,4805\n16,Turner Field,Turner Field,7,8,402.8,49,400,589,4798\n16,Turner Field,Turner Field,8,8,402.3,56,398,672,4781\n16,Turner Field,Turner Field,9,8,401.8,63,397,754,4762\n16,Turner Field,Turner Field,10,8,401.5,70,395,837,4745\n16,Turner Field,Turner Field,11,8,401.2,77,394,919,4726\n16,Turner Field,Turner Field,12,8,400.6,83,392,999,4702\n16,Turner Field,Turner Field,13,8,400.2,90,390,1080,4679\n16,Turner Field,Turner Field,14,8,399.5,97,388,1160,4652\n16,Turner Field,Turner Field,15,8,398.7,103,385,1238,4621\n16,Turner Field,Turner Field,16,8,397.9,110,382,1316,4590\n16,Turner Field,Turner Field,17,8,397.2,116,380,1394,4558\n16,Turner Field,Turner Field,18,8,396.2,122,377,1469,4522\n16,Turner Field,Turner Field,19,8,395.3,129,374,1544,4485\n16,Turner Field,Turner Field,20,8,394.6,135,371,1620,4450\n16,Turner Field,Turner Field,21,8,393.2,141,367,1691,4405\n16,Turner Field,Turner Field,22,8,391.9,147,363,1762,4360\n16,Turner Field,Turner Field,23,8,390.6,153,360,1831,4315\n16,Turner Field,Turner Field,24,8,389.2,158,356,1900,4267\n16,Turner Field,Turner Field,25,8,387.8,164,351,1967,4218\n16,Turner Field,Turner Field,26,8,386.4,169,347,2033,4168\n16,Turner Field,Turner Field,27,8,384.8,175,343,2096,4114\n16,Turner Field,Turner Field,28,8,380.4,179,336,2143,4030\n16,Turner Field,Turner Field,29,8,376.1,182,329,2188,3947\n16,Turner Field,Turner Field,30,8,372,186,322,2232,3866\n16,Turner Field,Turner Field,31,8,368.2,190,316,2276,3787\n16,Turner Field,Turner Field,32,8,364.5,193,309,2318,3709\n16,Turner Field,Turner Field,33,8,361,197,303,2359,3633\n16,Turner Field,Turner Field,34,8,357.7,200,297,2400,3559\n16,Turner Field,Turner Field,35,8,354.5,203,290,2440,3485\n16,Turner Field,Turner Field,36,8,351.5,207,284,2479,3412\n16,Turner Field,Turner Field,37,8,348.7,210,278,2518,3342\n16,Turner Field,Turner Field,38,8,346,213,273,2556,3272\n16,Turner Field,Turner Field,39,8,343.4,216,267,2593,3202\n16,Turner Field,Turner Field,40,8,341,219,261,2630,3135\n16,Turner Field,Turner Field,41,8,338.8,222,256,2667,3068\n16,Turner Field,Turner Field,42,8,336.6,225,250,2703,3002\n16,Turner Field,Turner Field,43,8,334.6,228,245,2738,2937\n16,Turner Field,Turner Field,44,8,332.8,231,239,2774,2873\n16,Turner Field,Turner Field,45,8,331,234,234,2809,2809\n17,Wrigley Field,Wrigley Field,-45,11.33,354.1923867117466,-250,250,-3000,3000\n17,Wrigley Field,Wrigley Field,-44,11.24,351.7972652452496,-244,253,-2928,3036\n17,Wrigley Field,Wrigley Field,-43,11.29,351.63639442636986,-240,257,-2880,3084\n17,Wrigley Field,Wrigley Field,-42,11.4,351.30605072354393,-235,261,-2820,3132\n17,Wrigley Field,Wrigley Field,-41,11.4,351.0289372439791,-230,265,-2760,3180\n17,Wrigley Field,Wrigley Field,-40,11.4,350.85905142752847,-226,269,-2712,3228\n17,Wrigley Field,Wrigley Field,-39,11.4,350.79613418038645,-221,273,-2652,3276\n17,Wrigley Field,Wrigley Field,-38,11.4,350.8400896235037,-216,276,-2592,3312\n17,Wrigley Field,Wrigley Field,-37,11.4,350.99098473585383,-211,280,-2532,3360\n17,Wrigley Field,Wrigley Field,-36,11.4,351.2490496036161,-206,284,-2472,3408\n17,Wrigley Field,Wrigley Field,-35,11.4,351.6146782769976,-202,288,-2424,3456\n17,Wrigley Field,Wrigley Field,-34,11.4,352.08843024064373,-197,292,-2364,3504\n17,Wrigley Field,Wrigley Field,-33,11.4,352.6710325078631,-192,296,-2304,3552\n17,Wrigley Field,Wrigley Field,-32,11.4,353.3633823532987,-187,300,-2244,3600\n17,Wrigley Field,Wrigley Field,-31,11.4,354.16655070323606,-182,304,-2184,3648\n17,Wrigley Field,Wrigley Field,-30,11.24,354.08673424263884,-177,307,-2124,3684\n17,Wrigley Field,Wrigley Field,-29,11.24,349.1230717582865,-169,305,-2028,3660\n17,Wrigley Field,Wrigley Field,-28,11.16,347.3955772171606,-163,307,-1956,3684\n17,Wrigley Field,Wrigley Field,-27,11.13,347.7007600213415,-158,310,-1896,3720\n17,Wrigley Field,Wrigley Field,-26,11.13,348.20373118044057,-153,313,-1836,3756\n17,Wrigley Field,Wrigley Field,-25,11.13,348.81456582593387,-147,316,-1764,3792\n17,Wrigley Field,Wrigley Field,-24,11.13,349.5342059552623,-142,319,-1704,3828\n17,Wrigley Field,Wrigley Field,-23,11.13,350.363766441235,-137,323,-1644,3876\n17,Wrigley Field,Wrigley Field,-22,11.13,351.3045392806021,-132,326,-1584,3912\n17,Wrigley Field,Wrigley Field,-21,11.13,352.3579985554715,-126,329,-1512,3948\n17,Wrigley Field,Wrigley Field,-20,11.13,353.5258061433923,-121,332,-1452,3984\n17,Wrigley Field,Wrigley Field,-19,11.13,354.80981821780415,-116,335,-1392,4020\n17,Wrigley Field,Wrigley Field,-18,11.13,356.21209258690925,-110,339,-1320,4068\n17,Wrigley Field,Wrigley Field,-17,11.13,357.73489692596945,-105,342,-1260,4104\n17,Wrigley Field,Wrigley Field,-16,11.13,359.3807179656513,-99,345,-1188,4140\n17,Wrigley Field,Wrigley Field,-15,11.13,361.1522717074341,-93,349,-1116,4188\n17,Wrigley Field,Wrigley Field,-14,11.13,363.05251474640266,-88,352,-1056,4224\n17,Wrigley Field,Wrigley Field,-13,11.13,365.0846567920799,-82,356,-984,4272\n17,Wrigley Field,Wrigley Field,-12,11.13,367.2521744895023,-76,359,-912,4308\n17,Wrigley Field,Wrigley Field,-11,11.13,369.55882665565593,-71,363,-852,4356\n17,Wrigley Field,Wrigley Field,-10,11.13,372.0086710609092,-65,366,-780,4392\n17,Wrigley Field,Wrigley Field,-9,11.13,374.60608290142756,-59,370,-708,4440\n17,Wrigley Field,Wrigley Field,-8,11.13,377.3557751270262,-53,374,-636,4488\n17,Wrigley Field,Wrigley Field,-7,11.13,380.2628208098356,-46,377,-552,4524\n17,Wrigley Field,Wrigley Field,-6,11.14,383.32750767719506,-40,381,-480,4572\n17,Wrigley Field,Wrigley Field,-5,11.07,386.3636703240432,-34,385,-408,4620\n17,Wrigley Field,Wrigley Field,-4,11.12,389.1034673845335,-27,388,-324,4656\n17,Wrigley Field,Wrigley Field,-3,11.11,391.5510777393934,-20,391,-240,4692\n17,Wrigley Field,Wrigley Field,-2,11.06,393.7237618590874,-14,393,-168,4716\n17,Wrigley Field,Wrigley Field,-1,11.05,395.6141295113475,-7,396,-84,4752\n17,Wrigley Field,Wrigley Field,0,10.9,397.1785454682871,0,397,0,4764\n17,Wrigley Field,Wrigley Field,1,10.91,398.48236864453474,7,398,84,4776\n17,Wrigley Field,Wrigley Field,2,10.89,399.51564501457284,14,399,168,4788\n17,Wrigley Field,Wrigley Field,3,10.93,400.2671801588457,21,400,252,4800\n17,Wrigley Field,Wrigley Field,4,10.9,400.79978144781194,28,400,336,4800\n17,Wrigley Field,Wrigley Field,5,10.9,401.0761379457849,35,400,420,4800\n17,Wrigley Field,Wrigley Field,6,11.06,401.01541208393076,42,399,504,4788\n17,Wrigley Field,Wrigley Field,7,11.02,400.5503514199405,49,398,588,4776\n17,Wrigley Field,Wrigley Field,8,11.28,399.9721873378083,56,396,672,4752\n17,Wrigley Field,Wrigley Field,9,11.15,399.1258814978107,62,394,744,4728\n17,Wrigley Field,Wrigley Field,10,11.21,397.9529743523447,69,392,828,4704\n17,Wrigley Field,Wrigley Field,11,11.18,396.54375660012926,76,389,912,4668\n17,Wrigley Field,Wrigley Field,12,11.13,394.79970506199226,82,386,984,4632\n17,Wrigley Field,Wrigley Field,13,11.11,392.93111786118175,88,383,1056,4596\n17,Wrigley Field,Wrigley Field,14,11.09,390.7483444235267,95,379,1140,4548\n17,Wrigley Field,Wrigley Field,15,11.09,388.27440405977705,100,375,1200,4500\n17,Wrigley Field,Wrigley Field,16,11.07,385.3623202787326,106,370,1272,4440\n17,Wrigley Field,Wrigley Field,17,11.1,382.20930864758645,112,366,1344,4392\n17,Wrigley Field,Wrigley Field,18,11.19,378.9471438984525,117,360,1404,4320\n17,Wrigley Field,Wrigley Field,19,11.19,375.70098946586955,122,355,1464,4260\n17,Wrigley Field,Wrigley Field,20,11.19,372.62251776480724,127,350,1524,4200\n17,Wrigley Field,Wrigley Field,21,11.19,369.7057863675212,132,345,1584,4140\n17,Wrigley Field,Wrigley Field,22,11.19,366.94526915375025,137,340,1644,4080\n17,Wrigley Field,Wrigley Field,23,11.19,364.33582853554043,142,335,1704,4020\n17,Wrigley Field,Wrigley Field,24,11.19,361.8726902359771,147,331,1764,3972\n17,Wrigley Field,Wrigley Field,25,11.19,359.55142037662785,152,326,1824,3912\n17,Wrigley Field,Wrigley Field,26,11.19,357.36790465670464,157,321,1884,3852\n17,Wrigley Field,Wrigley Field,27,11.19,355.31832943169104,161,317,1932,3804\n17,Wrigley Field,Wrigley Field,28,11.19,353.39916452094747,166,312,1992,3744\n17,Wrigley Field,Wrigley Field,29,11.19,351.60714759299424,170,308,2040,3696\n17,Wrigley Field,Wrigley Field,30,11.16,350.15046100007834,175,303,2100,3636\n17,Wrigley Field,Wrigley Field,31,11.34,349.5021044659616,180,300,2160,3600\n17,Wrigley Field,Wrigley Field,32,11.4,350.9956565144793,186,298,2232,3576\n17,Wrigley Field,Wrigley Field,33,11.08,357.3373204723106,195,300,2340,3600\n17,Wrigley Field,Wrigley Field,34,11.06,361.53709886582305,202,300,2424,3600\n17,Wrigley Field,Wrigley Field,35,11.05,360.8022344577299,207,296,2484,3552\n17,Wrigley Field,Wrigley Field,36,11.05,359.1083835414958,211,291,2532,3492\n17,Wrigley Field,Wrigley Field,37,11.05,357.5387633476186,215,286,2580,3432\n17,Wrigley Field,Wrigley Field,38,11.05,356.09080135554626,219,281,2628,3372\n17,Wrigley Field,Wrigley Field,39,11.05,354.76214809859135,223,276,2676,3312\n17,Wrigley Field,Wrigley Field,40,11.05,353.5506675987634,227,271,2724,3252\n17,Wrigley Field,Wrigley Field,41,11.05,352.45442878401127,231,266,2772,3192\n17,Wrigley Field,Wrigley Field,42,11.05,351.47169782222767,235,261,2820,3132\n17,Wrigley Field,Wrigley Field,43,11.05,350.60093131426777,239,256,2868,3072\n17,Wrigley Field,Wrigley Field,44,11.05,349.8407702954174,243,252,2916,3024\n17,Wrigley Field,Wrigley Field,45,11.05,349.1900350013236,247,247,2964,2964\n19,Coors Field,Coors Field,-45,12.41,346.9475862006799,-245,245,-2940,2940\n19,Coors Field,Coors Field,-44,12.5,347.56701696209325,-241,250,-2892,3000\n19,Coors Field,Coors Field,-43,12.5,348.2220861275116,-237,255,-2844,3060\n19,Coors Field,Coors Field,-42,12.5,348.98613450025937,-234,259,-2808,3108\n19,Coors Field,Coors Field,-41,7.74,349.87764580570195,-230,264,-2760,3168\n19,Coors Field,Coors Field,-40,7.74,350.8991206446926,-226,269,-2712,3228\n19,Coors Field,Coors Field,-39,7.74,352.0341243708344,-222,274,-2664,3288\n19,Coors Field,Coors Field,-38,7.74,353.28445747654274,-218,278,-2616,3336\n19,Coors Field,Coors Field,-37,7.74,354.6521194871361,-213,283,-2556,3396\n19,Coors Field,Coors Field,-36,7.74,356.1393169355573,-209,288,-2508,3456\n19,Coors Field,Coors Field,-35,7.74,357.74847227345145,-205,293,-2460,3516\n19,Coors Field,Coors Field,-34,7.74,359.48223378718615,-201,298,-2412,3576\n19,Coors Field,Coors Field,-33,7.74,361.34348659643973,-197,303,-2364,3636\n19,Coors Field,Coors Field,-32,7.74,363.3353648230063,-193,308,-2316,3696\n19,Coors Field,Coors Field,-31,7.67,365.457342082545,-188,313,-2256,3756\n19,Coors Field,Coors Field,-30,7.67,367.71241878911326,-184,318,-2208,3816\n19,Coors Field,Coors Field,-29,7.67,370.1089372133122,-179,324,-2148,3888\n19,Coors Field,Coors Field,-28,7.67,372.6511563771075,-175,329,-2100,3948\n19,Coors Field,Coors Field,-27,7.67,375.343665368848,-170,334,-2040,4008\n19,Coors Field,Coors Field,-26,7.67,378.1914049742126,-166,340,-1992,4080\n19,Coors Field,Coors Field,-25,7.6,381.2102846704439,-161,345,-1932,4140\n19,Coors Field,Coors Field,-24,7.6,384.4001355053662,-156,351,-1872,4212\n19,Coors Field,Coors Field,-23,7.6,387.76293324118706,-152,357,-1824,4284\n19,Coors Field,Coors Field,-22,7.6,391.30533422479715,-147,363,-1764,4356\n19,Coors Field,Coors Field,-21,7.6,395.0344957652782,-142,369,-1704,4428\n19,Coors Field,Coors Field,-20,7.6,398.9581152400228,-136,375,-1632,4500\n19,Coors Field,Coors Field,-19,7.62,403.10473259624564,-131,381,-1572,4572\n19,Coors Field,Coors Field,-18,7.62,407.5005431327783,-126,388,-1512,4656\n19,Coors Field,Coors Field,-17,7.62,412.1202021288343,-120,394,-1440,4728\n19,Coors Field,Coors Field,-16,7.62,416.97427516791174,-115,401,-1380,4812\n19,Coors Field,Coors Field,-15,7.66,419.35515360960005,-109,405,-1308,4860\n19,Coors Field,Coors Field,-14,7.66,418.1032624190438,-101,406,-1212,4872\n19,Coors Field,Coors Field,-13,7.66,416.9854632216364,-94,406,-1128,4872\n19,Coors Field,Coors Field,-12,7.66,416.00000471564834,-86,407,-1032,4884\n19,Coors Field,Coors Field,-11,7.66,415.14535222557413,-79,408,-948,4896\n19,Coors Field,Coors Field,-10,7.66,414.4201818094895,-72,408,-864,4896\n19,Coors Field,Coors Field,-9,7.61,413.8360186645377,-65,409,-780,4908\n19,Coors Field,Coors Field,-8,7.61,413.4343898092144,-58,409,-696,4908\n19,Coors Field,Coors Field,-7,7.61,413.15927005607233,-50,410,-600,4920\n19,Coors Field,Coors Field,-6,7.61,413.01023947346926,-43,411,-516,4932\n19,Coors Field,Coors Field,-5,7.61,412.9870708672766,-36,411,-432,4932\n19,Coors Field,Coors Field,-4,7.61,413.08972893509286,-29,412,-348,4944\n19,Coors Field,Coors Field,-3,7.63,413.2980167518731,-22,413,-264,4956\n19,Coors Field,Coors Field,-2,7.63,413.6265116686323,-14,413,-168,4956\n19,Coors Field,Coors Field,-1,7.63,414.08176283375656,-7,414,-84,4968\n19,Coors Field,Coors Field,0,7.63,414.6644672211184,0,415,0,4980\n19,Coors Field,Coors Field,1,7.63,415.37504587090496,7,415,84,4980\n19,Coors Field,Coors Field,2,7.63,416.2026523290382,15,416,180,4992\n19,Coors Field,Coors Field,3,7.63,417.16088820393423,22,417,264,5004\n19,Coors Field,Coors Field,4,7.63,418.25124399359856,29,417,348,5004\n19,Coors Field,Coors Field,5,7.63,419.4754256922617,37,418,444,5016\n19,Coors Field,Coors Field,6,16.25,421.1192189735426,44,419,528,5028\n19,Coors Field,Coors Field,7,16.25,422.4567153471423,51,419,612,5028\n19,Coors Field,Coors Field,8,16.21,420.8701571135727,59,417,708,5004\n19,Coors Field,Coors Field,9,16.21,416.4304771197822,65,411,780,4932\n19,Coors Field,Coors Field,10,16.21,412.2077378251192,72,406,864,4872\n19,Coors Field,Coors Field,11,16.21,408.1928700246576,78,401,936,4812\n19,Coors Field,Coors Field,12,16.21,404.37744587944377,84,396,1008,4752\n19,Coors Field,Coors Field,13,16.13,400.74522647821743,90,390,1080,4680\n19,Coors Field,Coors Field,14,16.13,397.27089466915544,96,385,1152,4620\n19,Coors Field,Coors Field,15,16.13,393.97526492458707,102,381,1224,4572\n19,Coors Field,Coors Field,16,16.13,390.85194200513286,108,376,1296,4512\n19,Coors Field,Coors Field,17,16.13,387.89497842147273,113,371,1356,4452\n19,Coors Field,Coors Field,18,16.13,385.09884434246504,119,366,1428,4392\n19,Coors Field,Coors Field,19,16.13,382.4584002743834,125,362,1500,4344\n19,Coors Field,Coors Field,20,16.13,379.9688722437133,130,357,1560,4284\n19,Coors Field,Coors Field,21,16.15,377.65302396195875,135,353,1620,4236\n19,Coors Field,Coors Field,22,16.15,375.49271762220525,141,348,1692,4176\n19,Coors Field,Coors Field,23,16.15,373.4701016603109,146,344,1752,4128\n19,Coors Field,Coors Field,24,16.15,371.58173983236816,151,339,1812,4068\n19,Coors Field,Coors Field,25,16.15,369.8244634123415,156,335,1872,4020\n19,Coors Field,Coors Field,26,16.15,368.19535767116986,161,331,1932,3972\n19,Coors Field,Coors Field,27,16.18,367.08093697633655,167,327,2004,3924\n19,Coors Field,Coors Field,28,16.18,365.6662859868756,172,323,2064,3876\n19,Coors Field,Coors Field,29,16.18,364.373062129226,177,319,2124,3828\n19,Coors Field,Coors Field,30,16.18,363.1991974280496,182,315,2184,3780\n19,Coors Field,Coors Field,31,16.18,362.14282986000245,187,310,2244,3720\n19,Coors Field,Coors Field,32,16.15,361.2004177144275,191,306,2292,3672\n19,Coors Field,Coors Field,33,16.15,360.3663411450621,196,302,2352,3624\n19,Coors Field,Coors Field,34,16.15,359.6454068496658,201,298,2412,3576\n19,Coors Field,Coors Field,35,16.15,359.0364989782595,206,294,2472,3528\n19,Coors Field,Coors Field,36,16.15,358.53867923840903,211,290,2532,3480\n19,Coors Field,Coors Field,37,16.15,358.15118334716743,216,286,2592,3432\n19,Coors Field,Coors Field,38,16.14,357.87603545929045,220,282,2640,3384\n19,Coors Field,Coors Field,39,16.14,357.7114858034928,225,278,2700,3336\n19,Coors Field,Coors Field,40,16.14,357.6559828038862,230,274,2760,3288\n19,Coors Field,Coors Field,41,16.14,357.70944188262376,235,270,2820,3240\n19,Coors Field,Coors Field,42,16.14,357.87194450237956,239,266,2868,3192\n19,Coors Field,Coors Field,43,16.14,358.1437384694257,244,262,2928,3144\n19,Coors Field,Coors Field,44,16.16,355.31289640420925,247,256,2964,3072\n19,Coors Field,Coors Field,45,16.23,350.7922840360932,248,248,2976,2976\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-45,3.64,326.51428536506546,-231,231,-2772,2772\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-44,3.59,332.6544457340925,-231,239,-2772,2868\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-43,3.63,338.1018809925021,-231,247,-2772,2964\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-42,3.52,342.9620202861342,-229,255,-2748,3060\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-41,3.54,347.3727867644951,-228,262,-2736,3144\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-40,3.47,351.38416455987146,-226,269,-2712,3228\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-39,3.56,355.1434811916504,-223,276,-2676,3312\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-38,7.6,357.36115002416693,-220,282,-2640,3384\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-37,7.6,359.2402151778194,-216,287,-2592,3444\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-36,7.6,361.2497675162928,-212,292,-2544,3504\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-35,7.59,361.4032825164372,-207,296,-2484,3552\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-34,7.59,361.34656486978713,-202,300,-2424,3600\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-33,7.59,361.32588586685375,-197,303,-2364,3636\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-32,7.59,361.35376778010004,-191,306,-2292,3672\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-31,7.59,361.4917763913194,-186,310,-2232,3720\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-30,7.59,361.7401221048372,-181,313,-2172,3756\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-29,7.59,362.09918402804044,-176,317,-2112,3804\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-28,7.59,362.5695113854702,-170,320,-2040,3840\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-27,7.59,363.1518255734898,-165,324,-1980,3888\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-26,7.59,363.84702286986675,-160,327,-1920,3924\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-25,7.59,364.65617781728275,-154,330,-1848,3960\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-24,7.59,365.5805473046703,-149,334,-1788,4008\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-23,7.57,366.5874454518486,-143,337,-1716,4044\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-22,7.57,367.711010402443,-138,341,-1656,4092\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-21,7.49,368.7519742591675,-132,344,-1584,4128\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-20,7.49,369.7333451737567,-126,347,-1512,4164\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-19,7.55,370.8317163187868,-121,351,-1452,4212\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-18,7.55,371.93390107144603,-115,354,-1380,4248\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-17,7.53,373.1450118231485,-109,357,-1308,4284\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-16,7.53,374.38607939129577,-103,360,-1236,4320\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-15,7.5,375.52112007333255,-97,363,-1164,4356\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-14,7.5,376.7342392768872,-91,366,-1092,4392\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-13,7.5,378.0707590929177,-85,368,-1020,4416\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-12,7.46,379.47272673034183,-79,371,-948,4452\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-11,7.46,380.7130232471898,-73,374,-876,4488\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-10,7.42,382.0528646481323,-66,376,-792,4512\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-9,7.42,383.26435193696614,-60,379,-720,4548\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-8,7.42,384.60107279066574,-54,381,-648,4572\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-7,7.48,385.9559503289793,-47,383,-564,4596\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-6,7.48,387.4317932126072,-40,385,-480,4620\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-5,7.48,389.0379258710341,-34,388,-408,4656\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-4,7.3,390.7402160052722,-27,390,-324,4680\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-3,7.3,392.4866000363681,-21,392,-252,4704\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-2,7.64,393.83068222850795,-14,394,-168,4728\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,-1,7.52,394.4764221538355,-7,394,-84,4728\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,0,7.51,394.9487367759827,0,395,0,4740\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,1,7.51,394.34816967678256,7,394,84,4728\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,2,7.65,393.6312265573381,14,393,168,4716\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,3,7.65,392.234070048043,21,392,252,4704\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,4,7.62,390.9035378996079,27,390,324,4680\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,5,7.59,389.36892796540224,34,388,408,4656\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,6,7.59,387.882073574233,41,386,492,4632\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,7,7.38,386.48016135620855,47,384,564,4608\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,8,7.38,384.84395114329624,54,381,648,4572\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,9,7.33,383.287344953425,60,379,720,4548\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,10,7.33,381.85774837210505,66,376,792,4512\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,11,7.33,380.55426622541825,73,374,876,4488\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,12,7.41,379.32150024679373,79,371,948,4452\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,13,7.41,377.8623634243345,85,368,1020,4416\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,14,7.41,376.52866408926405,91,365,1092,4380\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,15,7.41,375.31826994269915,97,363,1164,4356\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,16,7.55,374.2267017574557,103,360,1236,4320\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,17,7.58,373.0216917480422,109,357,1308,4284\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,18,7.58,371.59630742503265,115,353,1380,4236\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,19,7.58,370.2941407571815,121,350,1452,4200\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,20,7.58,369.1131112609127,126,347,1512,4164\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,21,7.58,368.0513470176333,132,344,1584,4128\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,22,7.58,367.10717730224223,138,340,1656,4080\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,23,7.58,366.279126071841,143,337,1716,4044\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,24,7.64,365.7753949175722,149,334,1788,4008\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,25,7.64,364.8431378730621,154,331,1848,3972\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,26,7.64,364.0262248780542,160,327,1920,3924\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,27,7.64,363.3233865510636,165,324,1980,3888\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,28,7.64,362.7335362128779,170,320,2040,3840\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,29,7.64,362.2557657573298,176,317,2112,3804\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,30,7.64,361.8893422218789,181,313,2172,3756\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,31,7.64,361.6337050337672,186,310,2232,3720\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,32,7.64,361.4884639124196,192,307,2304,3684\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,33,7.64,361.4533974134423,197,303,2364,3636\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,34,7.41,361.4683405796041,202,300,2424,3600\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,35,7.41,361.52087701523715,207,296,2484,3552\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,36,7.62,361.19604210646827,212,292,2544,3504\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,37,7.62,359.22082208539274,216,287,2592,3444\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,38,7.62,357.3753556892022,220,282,2640,3384\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,39,3.67,354.8895625711173,223,276,2676,3312\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,40,3.44,351.2882099061386,226,269,2712,3228\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,41,3.59,347.2765926514406,228,262,2736,3144\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,42,3.62,342.83980909087086,229,255,2748,3060\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,43,3.63,337.9949339780296,231,247,2772,2964\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,44,3.63,332.5022372267683,231,239,2772,2868\n22,UNIQLO Field at Dodger Stadium,UNIQLO Field at Dodger Stadium,45,3.47,326.32238814898307,231,231,2772,2772\n31,PNC Park,PNC Park,-45,4.83,324.40866798223624,-229,229,-2748,2748\n31,PNC Park,PNC Park,-44,5.31,329.25782492275437,-229,237,-2748,2844\n31,PNC Park,PNC Park,-43,4.88,334.35864241161306,-228,245,-2736,2940\n31,PNC Park,PNC Park,-42,4.88,339.7682937179236,-227,252,-2724,3024\n31,PNC Park,PNC Park,-41,4.88,345.46283313818174,-227,261,-2724,3132\n31,PNC Park,PNC Park,-40,5.26,351.4856091109129,-226,269,-2712,3228\n31,PNC Park,PNC Park,-39,4.86,357.824045537503,-225,278,-2700,3336\n31,PNC Park,PNC Park,-38,4.86,364.52185383455327,-224,287,-2688,3444\n31,PNC Park,PNC Park,-37,5.32,371.3462399004319,-223,297,-2676,3564\n31,PNC Park,PNC Park,-36,4.78,371.7148032943694,-218,301,-2616,3612\n31,PNC Park,PNC Park,-35,4.78,372.2388971211418,-214,305,-2568,3660\n31,PNC Park,PNC Park,-34,4.78,372.87821359719527,-209,309,-2508,3708\n31,PNC Park,PNC Park,-33,4.78,373.6337381544859,-203,313,-2436,3756\n31,PNC Park,PNC Park,-32,5.31,374.50901495416065,-198,318,-2376,3816\n31,PNC Park,PNC Park,-31,4.81,375.44305372193764,-193,322,-2316,3864\n31,PNC Park,PNC Park,-30,4.81,376.51447069021094,-188,326,-2256,3912\n31,PNC Park,PNC Park,-29,4.81,377.7074028566802,-183,330,-2196,3960\n31,PNC Park,PNC Park,-28,4.81,379.0237395849645,-178,335,-2136,4020\n31,PNC Park,PNC Park,-27,4.81,380.4655822634901,-173,339,-2076,4068\n31,PNC Park,PNC Park,-26,5.33,382.13983908434875,-168,343,-2016,4116\n31,PNC Park,PNC Park,-25,4.93,383.81888280381617,-162,348,-1944,4176\n31,PNC Park,PNC Park,-24,4.93,385.6925363575979,-157,352,-1884,4224\n31,PNC Park,PNC Park,-23,4.93,387.7032500375462,-151,357,-1812,4284\n31,PNC Park,PNC Park,-22,4.93,389.85441407994415,-146,361,-1752,4332\n31,PNC Park,PNC Park,-21,4.93,392.14970177246056,-141,366,-1692,4392\n31,PNC Park,PNC Park,-20,4.81,394.530520225814,-135,371,-1620,4452\n31,PNC Park,PNC Park,-19,4.81,397.119511944263,-129,375,-1548,4500\n31,PNC Park,PNC Park,-18,4.81,399.86531454624344,-124,380,-1488,4560\n31,PNC Park,PNC Park,-17,4.81,402.7728948471983,-118,385,-1416,4620\n31,PNC Park,PNC Park,-16,4.81,405.847599842709,-112,390,-1344,4680\n31,PNC Park,PNC Park,-15,5.31,409.1291489541152,-106,395,-1272,4740\n31,PNC Park,PNC Park,-14,9.55,394.9557843403049,-96,383,-1152,4596\n31,PNC Park,PNC Park,-13,9.59,394.0963450275872,-89,384,-1068,4608\n31,PNC Park,PNC Park,-12,9.59,393.6937137011314,-82,385,-984,4620\n31,PNC Park,PNC Park,-11,9.59,393.4116189201475,-75,386,-900,4632\n31,PNC Park,PNC Park,-10,9.59,393.24962998686266,-68,387,-816,4644\n31,PNC Park,PNC Park,-9,9.59,393.20749991402056,-62,388,-744,4656\n31,PNC Park,PNC Park,-8,9.59,393.2851645052008,-55,389,-660,4668\n31,PNC Park,PNC Park,-7,9.59,393.48274211599426,-48,391,-576,4692\n31,PNC Park,PNC Park,-6,9.59,393.8005340943809,-41,392,-492,4704\n31,PNC Park,PNC Park,-5,9.59,394.2390259033611,-34,393,-408,4716\n31,PNC Park,PNC Park,-4,9.59,394.79888893363346,-28,394,-336,4728\n31,PNC Park,PNC Park,-3,9.59,395.4809830189419,-21,395,-252,4740\n31,PNC Park,PNC Park,-2,9.59,396.28635967168174,-14,396,-168,4752\n31,PNC Park,PNC Park,-1,9.59,397.216266061525,-7,397,-84,4764\n31,PNC Park,PNC Park,0,9.59,398.2721497652496,0,398,0,4776\n31,PNC Park,PNC Park,1,9.46,396.8496574111374,7,397,84,4764\n31,PNC Park,PNC Park,2,9.46,395.53896437194874,14,395,168,4740\n31,PNC Park,PNC Park,3,9.46,394.35663001510136,21,394,252,4728\n31,PNC Park,PNC Park,4,9.46,393.300789181275,27,392,324,4704\n31,PNC Park,PNC Park,5,9.46,392.36978750941626,34,391,408,4692\n31,PNC Park,PNC Park,6,9.46,391.5621750284238,41,389,492,4668\n31,PNC Park,PNC Park,7,9.46,390.8767005891742,48,388,576,4656\n31,PNC Park,PNC Park,8,9.46,390.31230709668847,54,387,648,4644\n31,PNC Park,PNC Park,9,9.46,389.86812750834355,61,385,732,4620\n31,PNC Park,PNC Park,10,9.46,389.5434815697662,68,384,816,4608\n31,PNC Park,PNC Park,11,9.57,388.23431941061017,74,381,888,4572\n31,PNC Park,PNC Park,12,9.57,386.37844337490196,80,378,960,4536\n31,PNC Park,PNC Park,13,9.57,384.65683896394,87,375,1044,4500\n31,PNC Park,PNC Park,14,9.57,383.06667676616894,93,372,1116,4464\n31,PNC Park,PNC Park,15,9.57,381.60536996085983,99,369,1188,4428\n31,PNC Park,PNC Park,16,9.57,380.2705637485248,105,366,1260,4392\n31,PNC Park,PNC Park,17,9.58,379.0485763836036,111,362,1332,4344\n31,PNC Park,PNC Park,18,9.58,377.91169034105275,117,359,1404,4308\n31,PNC Park,PNC Park,19,9.58,376.89606654627124,123,356,1476,4272\n31,PNC Park,PNC Park,20,9.58,376.00011332146926,129,353,1548,4236\n31,PNC Park,PNC Park,21,9.58,375.22243502386516,134,350,1608,4200\n31,PNC Park,PNC Park,22,9.58,374.5618266849128,140,347,1680,4164\n31,PNC Park,PNC Park,23,22.05,372.0897676281738,145,343,1740,4116\n31,PNC Park,PNC Park,24,22.05,368.07226202053266,150,336,1800,4032\n31,PNC Park,PNC Park,25,22.05,364.25035385348514,154,330,1848,3960\n31,PNC Park,PNC Park,26,22.05,360.6157183531762,158,324,1896,3888\n31,PNC Park,PNC Park,27,22.05,357.1606216177576,162,318,1944,3816\n31,PNC Park,PNC Park,28,22.05,353.87787548519,166,312,1992,3744\n31,PNC Park,PNC Park,29,22.05,350.76079676416595,170,307,2040,3684\n31,PNC Park,PNC Park,30,22.05,347.80317036182976,174,301,2088,3612\n31,PNC Park,PNC Park,31,22.05,344.99921589925674,178,296,2136,3552\n31,PNC Park,PNC Park,32,22.05,342.3435574552424,181,290,2172,3480\n31,PNC Park,PNC Park,33,22.05,339.8311961219706,185,285,2220,3420\n31,PNC Park,PNC Park,34,22.05,337.45748509354945,189,280,2268,3360\n31,PNC Park,PNC Park,35,22.05,335.21810704102415,192,275,2304,3300\n31,PNC Park,PNC Park,36,22.05,333.10905355599186,196,269,2352,3228\n31,PNC Park,PNC Park,37,22.05,331.12660646991463,199,264,2388,3168\n31,PNC Park,PNC Park,38,22.05,329.2673208781667,203,259,2436,3108\n31,PNC Park,PNC Park,39,22.05,327.52800971715857,206,255,2472,3060\n31,PNC Park,PNC Park,40,22.05,325.90572975992507,209,250,2508,3000\n31,PNC Park,PNC Park,41,22.05,324.39776891064463,213,245,2556,2940\n31,PNC Park,PNC Park,42,22.05,323.0016346919396,216,240,2592,2880\n31,PNC Park,PNC Park,43,22.05,321.71504383071346,219,235,2628,2820\n31,PNC Park,PNC Park,44,22.05,320.535912858913,223,231,2676,2772\n31,PNC Park,PNC Park,45,22.05,319.4623496551226,226,226,2712,2712\n32,American Family Field,American Family Field,-45,14.81,340.7537468066515,-241,241,-2892,2892\n32,American Family Field,American Family Field,-44,7.04,344.3326279021047,-239,248,-2868,2976\n32,American Family Field,American Family Field,-43,7.04,348.0697499963856,-237,255,-2844,3060\n32,American Family Field,American Family Field,-42,6.89,352.4947226360314,-236,262,-2832,3144\n32,American Family Field,American Family Field,-41,6.81,355.1360179429517,-233,268,-2796,3216\n32,American Family Field,American Family Field,-40,6.86,356.4087444443565,-229,273,-2748,3276\n32,American Family Field,American Family Field,-39,6.86,357.0265081178164,-225,277,-2700,3324\n32,American Family Field,American Family Field,-38,6.86,357.75558208241193,-220,282,-2640,3384\n32,American Family Field,American Family Field,-37,6.86,358.59709544906997,-216,286,-2592,3432\n32,American Family Field,American Family Field,-36,6.86,359.55235832766834,-211,291,-2532,3492\n32,American Family Field,American Family Field,-35,6.86,360.62286685522474,-207,295,-2484,3540\n32,American Family Field,American Family Field,-34,6.86,361.8103089878011,-202,300,-2424,3600\n32,American Family Field,American Family Field,-33,6.86,363.1165710983832,-198,305,-2376,3660\n32,American Family Field,American Family Field,-32,6.86,364.5437454294707,-193,309,-2316,3708\n32,American Family Field,American Family Field,-31,6.86,366.0941384561802,-189,314,-2268,3768\n32,American Family Field,American Family Field,-30,6.86,367.7702802234099,-184,318,-2208,3816\n32,American Family Field,American Family Field,-29,6.86,368.7047703548056,-179,322,-2148,3864\n32,American Family Field,American Family Field,-28,6.83,368.26082310874847,-173,325,-2076,3900\n32,American Family Field,American Family Field,-27,6.83,367.8849147478901,-167,328,-2004,3936\n32,American Family Field,American Family Field,-26,6.83,367.621639956628,-161,330,-1932,3960\n32,American Family Field,American Family Field,-25,6.83,367.4705967732626,-155,333,-1860,3996\n32,American Family Field,American Family Field,-24,6.83,367.4315549003706,-149,336,-1788,4032\n32,American Family Field,American Family Field,-23,6.83,367.5044548472733,-144,338,-1728,4056\n32,American Family Field,American Family Field,-22,6.83,367.68940770871967,-138,341,-1656,4092\n32,American Family Field,American Family Field,-21,6.83,367.98669557824843,-132,344,-1584,4128\n32,American Family Field,American Family Field,-20,6.79,368.7816966338312,-126,347,-1512,4164\n32,American Family Field,American Family Field,-19,6.72,370.61679086722796,-121,350,-1452,4200\n32,American Family Field,American Family Field,-18,6.72,371.2607388656842,-115,353,-1380,4236\n32,American Family Field,American Family Field,-17,6.72,372.02044675318183,-109,356,-1308,4272\n32,American Family Field,American Family Field,-16,6.72,372.8970911616287,-103,358,-1236,4296\n32,American Family Field,American Family Field,-15,6.72,373.89203699939014,-97,361,-1164,4332\n32,American Family Field,American Family Field,-14,6.72,375.0068426903744,-91,364,-1092,4368\n32,American Family Field,American Family Field,-13,6.72,376.2432662078171,-85,367,-1020,4404\n32,American Family Field,American Family Field,-12,6.72,377.60327194679707,-79,369,-948,4428\n32,American Family Field,American Family Field,-11,6.8,380.89352728608014,-73,374,-876,4488\n32,American Family Field,American Family Field,-10,6.8,387.2400806389163,-67,381,-804,4572\n32,American Family Field,American Family Field,-9,6.8,393.9237399887622,-62,389,-744,4668\n32,American Family Field,American Family Field,-8,6.84,399.04558978846154,-56,395,-672,4740\n32,American Family Field,American Family Field,-7,6.84,399.01483637307604,-49,396,-588,4752\n32,American Family Field,American Family Field,-6,6.84,399.04663087621077,-42,397,-504,4764\n32,American Family Field,American Family Field,-5,6.84,398.9377923728493,-35,397,-420,4764\n32,American Family Field,American Family Field,-4,6.84,398.9505042759878,-28,398,-336,4776\n32,American Family Field,American Family Field,-3,6.83,398.99108536715045,-21,398,-252,4776\n32,American Family Field,American Family Field,-2,6.88,399.0319749613283,-14,399,-168,4788\n32,American Family Field,American Family Field,-1,6.88,399.04371752636365,-7,399,-84,4788\n32,American Family Field,American Family Field,0,6.9,399.05985194902576,0,399,0,4788\n32,American Family Field,American Family Field,1,6.9,399.09287493287707,7,399,84,4788\n32,American Family Field,American Family Field,2,6.9,399.1257805568052,14,399,168,4788\n32,American Family Field,American Family Field,3,6.89,399.06892639138226,21,399,252,4788\n32,American Family Field,American Family Field,4,6.83,399.06471941972416,28,398,336,4776\n32,American Family Field,American Family Field,5,6.91,399.08929953093786,35,398,420,4776\n32,American Family Field,American Family Field,6,6.83,399.10315283407084,42,397,504,4764\n32,American Family Field,American Family Field,7,6.83,399.0984946424885,49,396,588,4752\n32,American Family Field,American Family Field,8,6.81,399.17796153435233,56,395,672,4740\n32,American Family Field,American Family Field,9,6.8,394.7889604570252,62,390,744,4680\n32,American Family Field,American Family Field,10,6.8,388.0024961903345,67,382,804,4584\n32,American Family Field,American Family Field,11,6.77,384.52492724848247,73,377,876,4524\n32,American Family Field,American Family Field,12,6.77,383.031423437017,80,375,960,4500\n32,American Family Field,American Family Field,13,6.77,381.6652854842838,86,372,1032,4464\n32,American Family Field,American Family Field,14,6.77,380.4243270598121,92,369,1104,4428\n32,American Family Field,American Family Field,15,6.77,379.3065782677865,98,366,1176,4392\n32,American Family Field,American Family Field,16,6.77,378.31027787288724,104,364,1248,4368\n32,American Family Field,American Family Field,17,6.77,377.43386642273595,110,361,1320,4332\n32,American Family Field,American Family Field,18,6.77,376.6759802162091,116,358,1392,4296\n32,American Family Field,American Family Field,19,6.77,376.03544607365944,122,356,1464,4272\n32,American Family Field,American Family Field,20,6.77,375.5112768713473,128,353,1536,4236\n32,American Family Field,American Family Field,21,6.77,375.1026678081995,134,350,1608,4200\n32,American Family Field,American Family Field,22,6.77,374.80899337846694,140,348,1680,4176\n32,American Family Field,American Family Field,23,6.74,372.7116270698105,146,343,1752,4116\n32,American Family Field,American Family Field,24,6.74,370.7120093547672,151,339,1812,4068\n32,American Family Field,American Family Field,25,6.74,368.8454875923844,156,334,1872,4008\n32,American Family Field,American Family Field,26,6.74,367.1089321324663,161,330,1932,3960\n32,American Family Field,American Family Field,27,6.74,365.4994647062705,166,326,1992,3912\n32,American Family Field,American Family Field,28,6.74,364.0144463538785,171,321,2052,3852\n32,American Family Field,American Family Field,29,6.77,354.29281822118696,172,310,2064,3720\n32,American Family Field,American Family Field,30,7.1,350.36619569267066,175,303,2100,3636\n32,American Family Field,American Family Field,31,7.1,349.2170658756367,180,299,2160,3588\n32,American Family Field,American Family Field,32,7.1,348.1811618796371,185,295,2220,3540\n32,American Family Field,American Family Field,33,7.1,347.25685039160743,189,291,2268,3492\n32,American Family Field,American Family Field,34,7.1,346.4426838136778,194,287,2328,3444\n32,American Family Field,American Family Field,35,7.1,345.73739465952553,198,283,2376,3396\n32,American Family Field,American Family Field,36,7.1,345.139890690045,203,279,2436,3348\n32,American Family Field,American Family Field,37,7.1,344.649250753236,207,275,2484,3300\n32,American Family Field,American Family Field,38,7.1,344.264721298589,212,271,2544,3252\n32,American Family Field,American Family Field,39,7.1,343.9857135412694,216,267,2592,3204\n32,American Family Field,American Family Field,40,7.1,343.8118012561538,221,263,2652,3156\n32,American Family Field,American Family Field,41,7.1,343.7427191862904,226,259,2712,3108\n32,American Family Field,American Family Field,42,7.1,343.77836205469987,230,255,2760,3060\n32,American Family Field,American Family Field,43,7.1,343.9187841726581,235,252,2820,3024\n32,American Family Field,American Family Field,44,7.1,344.1641996417443,239,248,2868,2976\n32,American Family Field,American Family Field,45,7.1,344.51498315105596,244,244,2928,2928\n680,T-Mobile Park,T-Mobile Park,-45,7.66,330.6529079003023,-234,234,-2808,2808\n680,T-Mobile Park,T-Mobile Park,-44,7.66,336.7191794359088,-234,242,-2808,2904\n680,T-Mobile Park,T-Mobile Park,-43,7.63,337.22177603329754,-230,247,-2760,2964\n680,T-Mobile Park,T-Mobile Park,-42,7.63,337.733500201165,-226,251,-2712,3012\n680,T-Mobile Park,T-Mobile Park,-41,7.63,338.3500011055405,-222,255,-2664,3060\n680,T-Mobile Park,T-Mobile Park,-40,7.63,339.0722304227296,-218,260,-2616,3120\n680,T-Mobile Park,T-Mobile Park,-39,7.63,339.90130833379675,-214,264,-2568,3168\n680,T-Mobile Park,T-Mobile Park,-38,7.63,340.8385278005238,-210,269,-2520,3228\n680,T-Mobile Park,T-Mobile Park,-37,7.63,341.88535954004954,-206,273,-2472,3276\n680,T-Mobile Park,T-Mobile Park,-36,7.63,343.0434577341985,-202,278,-2424,3336\n680,T-Mobile Park,T-Mobile Park,-35,7.63,344.3146665153065,-197,282,-2364,3384\n680,T-Mobile Park,T-Mobile Park,-34,7.63,345.7010272766376,-193,287,-2316,3444\n680,T-Mobile Park,T-Mobile Park,-33,7.63,347.20478686236527,-189,291,-2268,3492\n680,T-Mobile Park,T-Mobile Park,-32,7.63,348.8284066996402,-185,296,-2220,3552\n680,T-Mobile Park,T-Mobile Park,-31,7.63,350.5745729435983,-181,301,-2172,3612\n680,T-Mobile Park,T-Mobile Park,-30,7.63,352.4462077154048,-176,305,-2112,3660\n680,T-Mobile Park,T-Mobile Park,-29,7.63,354.4464815237032,-172,310,-2064,3720\n680,T-Mobile Park,T-Mobile Park,-28,7.63,356.5788269713263,-167,315,-2004,3780\n680,T-Mobile Park,T-Mobile Park,-27,7.63,358.8469538619854,-163,320,-1956,3840\n680,T-Mobile Park,T-Mobile Park,-26,7.63,361.2548658361215,-158,325,-1896,3900\n680,T-Mobile Park,T-Mobile Park,-25,7.63,363.80687868139614,-154,330,-1848,3960\n680,T-Mobile Park,T-Mobile Park,-24,7.63,366.50764048173346,-149,335,-1788,4020\n680,T-Mobile Park,T-Mobile Park,-23,7.63,369.36215378970144,-144,340,-1728,4080\n680,T-Mobile Park,T-Mobile Park,-22,7.63,372.3758000307464,-139,345,-1668,4140\n680,T-Mobile Park,T-Mobile Park,-21,7.66,374.15444649477735,-134,349,-1608,4188\n680,T-Mobile Park,T-Mobile Park,-20,7.66,375.5930554278661,-128,353,-1536,4236\n680,T-Mobile Park,T-Mobile Park,-19,7.66,377.15809929691255,-123,357,-1476,4284\n680,T-Mobile Park,T-Mobile Park,-18,7.66,378.8521252828086,-117,360,-1404,4320\n680,T-Mobile Park,T-Mobile Park,-17,7.66,380.6779189105322,-111,364,-1332,4368\n680,T-Mobile Park,T-Mobile Park,-16,7.66,382.63851560353453,-105,368,-1260,4416\n680,T-Mobile Park,T-Mobile Park,-15,7.66,384.7372134698014,-100,372,-1200,4464\n680,T-Mobile Park,T-Mobile Park,-14,7.59,386.13312366838613,-93,375,-1116,4500\n680,T-Mobile Park,T-Mobile Park,-13,7.59,387.05911712759814,-87,377,-1044,4524\n680,T-Mobile Park,T-Mobile Park,-12,7.59,388.1080682175497,-81,380,-972,4560\n680,T-Mobile Park,T-Mobile Park,-11,7.59,389.2816213668218,-74,382,-888,4584\n680,T-Mobile Park,T-Mobile Park,-10,7.59,390.5816289657547,-68,385,-816,4620\n680,T-Mobile Park,T-Mobile Park,-9,7.59,392.0101586180263,-61,387,-732,4644\n680,T-Mobile Park,T-Mobile Park,-8,7.59,393.56950132282884,-55,390,-660,4680\n680,T-Mobile Park,T-Mobile Park,-7,7.59,395.26218064903844,-48,392,-576,4704\n680,T-Mobile Park,T-Mobile Park,-6,7.59,397.0909629712475,-42,395,-504,4740\n680,T-Mobile Park,T-Mobile Park,-5,7.59,399.0588688468812,-35,398,-420,4776\n680,T-Mobile Park,T-Mobile Park,-4,7.59,401.1691856239754,-28,400,-336,4800\n680,T-Mobile Park,T-Mobile Park,-3,7.59,403.42548138071663,-21,403,-252,4836\n680,T-Mobile Park,T-Mobile Park,-2,7.68,405.38302434851647,-14,405,-168,4860\n680,T-Mobile Park,T-Mobile Park,-1,7.68,402.94537256501627,-7,403,-84,4836\n680,T-Mobile Park,T-Mobile Park,0,7.68,400.6581766277819,0,401,0,4812\n680,T-Mobile Park,T-Mobile Park,1,7.68,398.51750640897797,7,398,84,4776\n680,T-Mobile Park,T-Mobile Park,2,7.68,396.51973117604524,14,396,168,4752\n680,T-Mobile Park,T-Mobile Park,3,7.68,394.6615038685706,21,394,252,4728\n680,T-Mobile Park,T-Mobile Park,4,7.68,392.93974684754016,27,392,324,4704\n680,T-Mobile Park,T-Mobile Park,5,7.68,391.35163899989493,34,390,408,4680\n680,T-Mobile Park,T-Mobile Park,6,7.68,389.89460409449316,41,388,492,4656\n680,T-Mobile Park,T-Mobile Park,7,7.68,388.5663002973911,47,386,564,4632\n680,T-Mobile Park,T-Mobile Park,8,7.68,387.36461076495704,54,384,648,4608\n680,T-Mobile Park,T-Mobile Park,9,7.68,386.28763524289604,60,382,720,4584\n680,T-Mobile Park,T-Mobile Park,10,7.68,385.3336826079223,67,379,804,4548\n680,T-Mobile Park,T-Mobile Park,11,7.68,384.5012642966976,73,377,876,4524\n680,T-Mobile Park,T-Mobile Park,12,7.68,383.78908857386705,80,375,960,4500\n680,T-Mobile Park,T-Mobile Park,13,7.68,383.19605559764955,86,373,1032,4476\n680,T-Mobile Park,T-Mobile Park,14,7.68,382.72125324759907,93,371,1116,4452\n680,T-Mobile Park,T-Mobile Park,15,7.68,382.36395368487564,99,369,1188,4428\n680,T-Mobile Park,T-Mobile Park,16,7.68,382.1236106207653,105,367,1260,4404\n680,T-Mobile Park,T-Mobile Park,17,7.68,381.9998572743045,112,365,1344,4380\n680,T-Mobile Park,T-Mobile Park,18,7.68,381.9925050047636,118,363,1416,4356\n680,T-Mobile Park,T-Mobile Park,19,7.68,382.1015426094864,124,361,1488,4332\n680,T-Mobile Park,T-Mobile Park,20,7.61,379.60458650450056,130,357,1560,4284\n680,T-Mobile Park,T-Mobile Park,21,7.61,375.7065753098448,135,351,1620,4212\n680,T-Mobile Park,T-Mobile Park,22,7.61,371.9999677678454,139,345,1668,4140\n680,T-Mobile Park,T-Mobile Park,23,7.61,368.4769273891943,144,339,1728,4068\n680,T-Mobile Park,T-Mobile Park,24,7.61,365.1301698893657,149,334,1788,4008\n680,T-Mobile Park,T-Mobile Park,25,7.61,361.95292219823347,153,328,1836,3936\n680,T-Mobile Park,T-Mobile Park,26,7.61,358.93888537575884,157,323,1884,3876\n680,T-Mobile Park,T-Mobile Park,27,7.61,356.0822010258354,162,317,1944,3804\n680,T-Mobile Park,T-Mobile Park,28,7.61,353.3774208496503,166,312,1992,3744\n680,T-Mobile Park,T-Mobile Park,29,7.61,350.81947902269263,170,307,2040,3684\n680,T-Mobile Park,T-Mobile Park,30,7.61,348.40366711677285,174,302,2088,3624\n680,T-Mobile Park,T-Mobile Park,31,7.61,346.1256113208947,178,297,2136,3564\n680,T-Mobile Park,T-Mobile Park,32,7.61,343.98125174323064,182,292,2184,3504\n680,T-Mobile Park,T-Mobile Park,33,7.61,341.96682360135117,186,287,2232,3444\n680,T-Mobile Park,T-Mobile Park,34,7.61,340.0788401297444,190,282,2280,3384\n680,T-Mobile Park,T-Mobile Park,35,7.61,338.31407705293856,194,277,2328,3324\n680,T-Mobile Park,T-Mobile Park,36,7.61,336.6695584895716,198,272,2376,3264\n680,T-Mobile Park,T-Mobile Park,37,7.61,335.14254416782524,202,268,2424,3216\n680,T-Mobile Park,T-Mobile Park,38,7.61,333.73051784603854,205,263,2460,3156\n680,T-Mobile Park,T-Mobile Park,39,7.61,332.4311768442357,209,258,2508,3096\n680,T-Mobile Park,T-Mobile Park,40,7.61,331.2424226029624,213,254,2556,3048\n680,T-Mobile Park,T-Mobile Park,41,7.61,330.16235219537606,217,249,2604,2988\n680,T-Mobile Park,T-Mobile Park,42,7.61,329.18925072713273,220,245,2640,2940\n680,T-Mobile Park,T-Mobile Park,43,7.61,328.32158456637814,224,240,2688,2880\n680,T-Mobile Park,T-Mobile Park,44,7.61,327.55799535320165,228,236,2736,2832\n680,T-Mobile Park,T-Mobile Park,45,7.61,326.8972947443414,231,231,2772,2772\n2392,Daikin Park,Daikin Park,-45,18.1823324,314.6558245193506,-222,222,-2664,2664\n2392,Daikin Park,Daikin Park,-44,18.1823324,314.74757518125574,-219,226,-2628,2712\n2392,Daikin Park,Daikin Park,-43,18.1823324,314.9353397024646,-215,230,-2580,2760\n2392,Daikin Park,Daikin Park,-42,18.1823324,315.2194045805169,-211,234,-2532,2808\n2392,Daikin Park,Daikin Park,-41,18.1823324,315.6002040312775,-207,238,-2484,2856\n2392,Daikin Park,Daikin Park,-40,18.1823324,316.07832161175884,-203,242,-2436,2904\n2392,Daikin Park,Daikin Park,-39,18.1823324,316.6544924091382,-199,246,-2388,2952\n2392,Daikin Park,Daikin Park,-38,18.1823324,317.3296058113007,-195,250,-2340,3000\n2392,Daikin Park,Daikin Park,-37,18.1823324,318.10470887844014,-191,254,-2292,3048\n2392,Daikin Park,Daikin Park,-36,18.1823324,318.9810103396573,-187,258,-2244,3096\n2392,Daikin Park,Daikin Park,-35,18.1823324,319.9598852431955,-184,262,-2208,3144\n2392,Daikin Park,Daikin Park,-34,18.1823324,321.04288029396866,-180,266,-2160,3192\n2392,Daikin Park,Daikin Park,-33,18.1823324,322.2317199174624,-175,270,-2100,3240\n2392,Daikin Park,Daikin Park,-32,18.1823324,323.52831309497157,-171,274,-2052,3288\n2392,Daikin Park,Daikin Park,-31,18.1823324,324.9347610215652,-167,279,-2004,3348\n2392,Daikin Park,Daikin Park,-30,17.8167185,326.12907026913865,-163,282,-1956,3384\n2392,Daikin Park,Daikin Park,-29,17.8167185,326.99617392105944,-159,286,-1908,3432\n2392,Daikin Park,Daikin Park,-28,17.8167185,327.96806930771703,-154,290,-1848,3480\n2392,Daikin Park,Daikin Park,-27,17.8167185,329.04628871609367,-149,293,-1788,3516\n2392,Daikin Park,Daikin Park,-26,17.8167185,330.23254478812584,-145,297,-1740,3564\n2392,Daikin Park,Daikin Park,-25,17.8167185,331.5287372856901,-140,300,-1680,3600\n2392,Daikin Park,Daikin Park,-24,17.8167185,332.93696068280934,-135,304,-1620,3648\n2392,Daikin Park,Daikin Park,-23,24.1068767,356.9541647044419,-139,329,-1668,3948\n2392,Daikin Park,Daikin Park,-22,24.1068767,358.7747178575282,-134,333,-1608,3996\n2392,Daikin Park,Daikin Park,-21,24.1068767,360.72438016808576,-129,337,-1548,4044\n2392,Daikin Park,Daikin Park,-20,24.1068767,362.80646626827,-124,341,-1488,4092\n2392,Daikin Park,Daikin Park,-19,24.1138766,364.969611756902,-119,345,-1428,4140\n2392,Daikin Park,Daikin Park,-18,24.2408766,367.2935529438808,-113,349,-1356,4188\n2392,Daikin Park,Daikin Park,-17,24.2408766,369.80674112210005,-108,354,-1296,4248\n2392,Daikin Park,Daikin Park,-16,24.2408766,372.4687982675558,-103,358,-1236,4296\n2392,Daikin Park,Daikin Park,-15,24.1198766,375.27251414611027,-97,362,-1164,4344\n2392,Daikin Park,Daikin Park,-14,24.1978766,378.21207985928186,-91,367,-1092,4404\n2392,Daikin Park,Daikin Park,-13,24.1978766,381.35380337424067,-86,372,-1032,4464\n2392,Daikin Park,Daikin Park,-12,24.1978766,384.6663138591475,-80,376,-960,4512\n2392,Daikin Park,Daikin Park,-11,9.28024391,387.7497675642705,-74,381,-888,4572\n2392,Daikin Park,Daikin Park,-10,9.28024391,391.4048924554341,-68,385,-816,4620\n2392,Daikin Park,Daikin Park,-9,9.2470161,395.2443664508627,-62,390,-744,4680\n2392,Daikin Park,Daikin Park,-8,9.2470161,399.2762179599734,-56,395,-672,4740\n2392,Daikin Park,Daikin Park,-7,9.2470161,403.51535575825403,-49,401,-588,4812\n2392,Daikin Park,Daikin Park,-6,9.33024411,408.0234356109401,-43,406,-516,4872\n2392,Daikin Park,Daikin Park,-5,9.35124401,410.81591467180556,-36,409,-432,4908\n2392,Daikin Park,Daikin Park,-4,9.35124401,410.22715709685343,-29,409,-348,4908\n2392,Daikin Park,Daikin Park,-3,9.35124401,409.7647243315248,-21,409,-252,4908\n2392,Daikin Park,Daikin Park,-2,9.35124401,409.42790823472916,-14,409,-168,4908\n2392,Daikin Park,Daikin Park,-1,9.35124401,409.21619423253986,-7,409,-84,4908\n2392,Daikin Park,Daikin Park,0,9.35124401,409.1292593965482,0,409,0,4908\n2392,Daikin Park,Daikin Park,1,9.35124401,409.1669712407324,7,409,84,4908\n2392,Daikin Park,Daikin Park,2,9.35124401,409.32938722848553,14,409,168,4908\n2392,Daikin Park,Daikin Park,3,9.22715484,409.67363151922194,21,409,252,4908\n2392,Daikin Park,Daikin Park,4,9.22715484,410.1784393033989,29,409,348,4908\n2392,Daikin Park,Daikin Park,5,9.417244,410.7666593645498,36,409,432,4908\n2392,Daikin Park,Daikin Park,6,9.417244,411.45538378099246,43,409,516,4908\n2392,Daikin Park,Daikin Park,7,9.417244,412.2722146428477,50,409,600,4908\n2392,Daikin Park,Daikin Park,8,9.417244,413.2184158496504,58,409,696,4908\n2392,Daikin Park,Daikin Park,9,9.417244,414.2954589914109,65,409,780,4908\n2392,Daikin Park,Daikin Park,10,9.417244,415.5050289882502,72,409,864,4908\n2392,Daikin Park,Daikin Park,11,9.50401607,410.6707092490738,78,403,936,4836\n2392,Daikin Park,Daikin Park,12,9.50401607,404.55393832930895,84,396,1008,4752\n2392,Daikin Park,Daikin Park,13,9.34824375,402.1226089819228,90,392,1080,4704\n2392,Daikin Park,Daikin Park,14,9.34824375,396.73281254543167,96,385,1152,4620\n2392,Daikin Park,Daikin Park,15,9.34824375,391.6032964605869,101,378,1212,4536\n2392,Daikin Park,Daikin Park,16,9.34824375,386.72102571426905,107,372,1284,4464\n2392,Daikin Park,Daikin Park,17,9.56224398,382.07115325195144,112,365,1344,4380\n2392,Daikin Park,Daikin Park,18,9.56224398,377.6417656440283,117,359,1404,4308\n2392,Daikin Park,Daikin Park,19,9.56224398,373.4263473844229,122,353,1464,4236\n2392,Daikin Park,Daikin Park,20,9.56224398,369.4152845214516,126,347,1512,4164\n2392,Daikin Park,Daikin Park,21,9.43824391,369.41489233062737,132,345,1584,4140\n2392,Daikin Park,Daikin Park,22,6.27524404,370.55894328198934,139,344,1668,4128\n2392,Daikin Park,Daikin Park,23,6.27524404,367.04102814245954,143,338,1716,4056\n2392,Daikin Park,Daikin Park,24,6.27524404,363.6990241469084,148,332,1776,3984\n2392,Daikin Park,Daikin Park,25,6.27524404,360.52615948508776,152,327,1824,3924\n2392,Daikin Park,Daikin Park,26,6.27524404,357.51613643850817,157,321,1884,3852\n2392,Daikin Park,Daikin Park,27,6.27524404,354.66309774930215,161,316,1932,3792\n2392,Daikin Park,Daikin Park,28,6.27524404,351.96159613438624,165,311,1980,3732\n2392,Daikin Park,Daikin Park,29,6.27524404,349.4065666281185,169,306,2028,3672\n2392,Daikin Park,Daikin Park,30,6.27524404,346.99330147401236,173,301,2076,3612\n2392,Daikin Park,Daikin Park,31,6.27524404,344.71742731866385,178,295,2136,3540\n2392,Daikin Park,Daikin Park,32,6.27524404,342.5748844895487,182,291,2184,3492\n2392,Daikin Park,Daikin Park,33,6.27524404,340.5619081633311,185,286,2220,3432\n2392,Daikin Park,Daikin Park,34,6.26124386,338.6756543807023,189,281,2268,3372\n2392,Daikin Park,Daikin Park,35,6.26124386,336.9128546298188,193,276,2316,3312\n2392,Daikin Park,Daikin Park,36,6.26124386,335.2699081790828,197,271,2364,3252\n2392,Daikin Park,Daikin Park,37,6.26124386,333.74407587107936,201,267,2412,3204\n2392,Daikin Park,Daikin Park,38,6.26124386,332.3328421198609,205,262,2460,3144\n2392,Daikin Park,Daikin Park,39,6.26124386,331.0339044376786,208,257,2496,3084\n2392,Daikin Park,Daikin Park,40,6.26124386,329.84516398825787,212,253,2544,3036\n2392,Daikin Park,Daikin Park,41,6.26124386,328.7647170924596,216,248,2592,2976\n2392,Daikin Park,Daikin Park,42,6.26124386,327.79084762076735,219,244,2628,2928\n2392,Daikin Park,Daikin Park,43,6.26124386,326.9220202148107,223,239,2676,2868\n2392,Daikin Park,Daikin Park,44,6.26124386,326.1568742871869,227,235,2724,2820\n2392,Daikin Park,Daikin Park,45,6.26124386,325.49421875526923,230,230,2760,2760\n2394,Comerica Park,Comerica Park,-45,7.89,342.6824359178831,-242,242,-2904,2904\n2394,Comerica Park,Comerica Park,-44,6.39,343.33412775764486,-238,247,-2856,2964\n2394,Comerica Park,Comerica Park,-43,6.39,343.4534915029617,-234,251,-2808,3012\n2394,Comerica Park,Comerica Park,-42,6.39,343.67766222686924,-230,255,-2760,3060\n2394,Comerica Park,Comerica Park,-41,6.39,344.006982071072,-226,260,-2712,3120\n2394,Comerica Park,Comerica Park,-40,6.39,344.4419546339118,-221,264,-2652,3168\n2394,Comerica Park,Comerica Park,-39,6.39,344.9832468536234,-217,268,-2604,3216\n2394,Comerica Park,Comerica Park,-38,6.39,345.6316915121138,-213,272,-2556,3264\n2394,Comerica Park,Comerica Park,-37,6.39,346.38829037681836,-208,277,-2496,3324\n2394,Comerica Park,Comerica Park,-36,6.39,347.2542180028118,-204,281,-2448,3372\n2394,Comerica Park,Comerica Park,-35,6.39,348.2308262222132,-200,285,-2400,3420\n2394,Comerica Park,Comerica Park,-34,6.39,349.3196493531099,-195,290,-2340,3480\n2394,Comerica Park,Comerica Park,-33,6.39,350.5224101657799,-191,294,-2292,3528\n2394,Comerica Park,Comerica Park,-32,6.39,351.84102664998954,-186,298,-2232,3576\n2394,Comerica Park,Comerica Park,-31,6.39,353.27761963367305,-182,303,-2184,3636\n2394,Comerica Park,Comerica Park,-30,6.39,354.83452131042736,-177,307,-2124,3684\n2394,Comerica Park,Comerica Park,-29,6.39,356.51428474110315,-173,312,-2076,3744\n2394,Comerica Park,Comerica Park,-28,6.72,357.7338762758943,-168,316,-2016,3792\n2394,Comerica Park,Comerica Park,-27,6.72,359.6932448051215,-163,320,-1956,3840\n2394,Comerica Park,Comerica Park,-26,6.72,361.7850052655909,-159,325,-1908,3900\n2394,Comerica Park,Comerica Park,-25,6.72,364.01276729672617,-154,330,-1848,3960\n2394,Comerica Park,Comerica Park,-24,6.72,366.3804295812276,-149,335,-1788,4020\n2394,Comerica Park,Comerica Park,-23,6.72,368.89219746851234,-144,340,-1728,4080\n2394,Comerica Park,Comerica Park,-22,6.72,371.55260236975266,-139,344,-1668,4128\n2394,Comerica Park,Comerica Park,-21,6.72,374.36652309985357,-134,350,-1608,4200\n2394,Comerica Park,Comerica Park,-20,6.72,377.3392093641154,-129,355,-1548,4260\n2394,Comerica Park,Comerica Park,-19,6.72,380.47630761281283,-124,360,-1488,4320\n2394,Comerica Park,Comerica Park,-18,6.72,383.7838895159695,-119,365,-1428,4380\n2394,Comerica Park,Comerica Park,-17,6.72,387.2684833438111,-113,370,-1356,4440\n2394,Comerica Park,Comerica Park,-16,6.72,390.9371085764153,-108,376,-1296,4512\n2394,Comerica Park,Comerica Park,-15,6.72,394.7973141097565,-102,381,-1224,4572\n2394,Comerica Park,Comerica Park,-14,6.72,398.8572204756203,-96,387,-1152,4644\n2394,Comerica Park,Comerica Park,-13,6.72,403.12556655088724,-91,393,-1092,4716\n2394,Comerica Park,Comerica Park,-12,6.72,407.6117612988031,-85,399,-1020,4788\n2394,Comerica Park,Comerica Park,-11,6.73,411.4548457560426,-79,404,-948,4848\n2394,Comerica Park,Comerica Park,-10,6.73,413.1404435994453,-72,407,-864,4884\n2394,Comerica Park,Comerica Park,-9,6.73,414.9668318343407,-65,410,-780,4920\n2394,Comerica Park,Comerica Park,-8,6.73,416.9370067551422,-58,413,-696,4956\n2394,Comerica Park,Comerica Park,-7,6.71,415.94049274549457,-51,413,-612,4956\n2394,Comerica Park,Comerica Park,-6,6.71,415.0318398381347,-43,413,-516,4956\n2394,Comerica Park,Comerica Park,-5,6.71,414.25305875035446,-36,413,-432,4956\n2394,Comerica Park,Comerica Park,-4,6.71,413.60294635525247,-29,413,-348,4956\n2394,Comerica Park,Comerica Park,-3,6.71,413.0805024463657,-22,413,-264,4956\n2394,Comerica Park,Comerica Park,-2,6.71,412.6849259641433,-14,412,-168,4944\n2394,Comerica Park,Comerica Park,-1,6.71,412.41561198864537,-7,412,-84,4944\n2394,Comerica Park,Comerica Park,0,6.71,412.27214947737536,0,412,0,4944\n2394,Comerica Park,Comerica Park,1,6.71,412.2543197324673,7,412,84,4944\n2394,Comerica Park,Comerica Park,2,6.71,412.3620955865708,14,412,168,4944\n2394,Comerica Park,Comerica Park,3,6.71,412.59564130178796,22,412,264,4944\n2394,Comerica Park,Comerica Park,4,6.71,412.95531318096346,29,412,348,4944\n2394,Comerica Park,Comerica Park,5,6.71,413.44166089556296,36,412,432,4944\n2394,Comerica Park,Comerica Park,6,6.71,414.05542953936606,43,412,516,4944\n2394,Comerica Park,Comerica Park,7,6.71,414.7975624222811,51,412,612,4944\n2394,Comerica Park,Comerica Park,8,6.71,415.6692046238453,58,412,696,4944\n2394,Comerica Park,Comerica Park,9,6.71,416.67170733143774,65,412,780,4944\n2394,Comerica Park,Comerica Park,10,6.74,415.0373881956299,72,409,864,4908\n2394,Comerica Park,Comerica Park,11,6.74,413.4303030684511,79,406,948,4872\n2394,Comerica Park,Comerica Park,12,6.74,411.9606188349496,86,403,1032,4836\n2394,Comerica Park,Comerica Park,13,6.74,410.6259841973115,92,400,1104,4800\n2394,Comerica Park,Comerica Park,14,6.65,406.39100474534615,98,394,1176,4728\n2394,Comerica Park,Comerica Park,15,6.65,402.20697765856517,104,389,1248,4668\n2394,Comerica Park,Comerica Park,16,6.65,398.22829452350413,110,383,1320,4596\n2394,Comerica Park,Comerica Park,17,6.65,394.4465309593778,115,377,1380,4524\n2394,Comerica Park,Comerica Park,18,6.65,390.85385640603033,121,372,1452,4464\n2394,Comerica Park,Comerica Park,19,6.65,387.4429899782303,126,366,1512,4392\n2394,Comerica Park,Comerica Park,20,6.65,384.20716052968623,131,361,1572,4332\n2394,Comerica Park,Comerica Park,21,6.68,375.71023486427805,135,351,1620,4212\n2394,Comerica Park,Comerica Park,22,6.68,365.7600540528621,137,339,1644,4068\n2394,Comerica Park,Comerica Park,23,6.75,362.0409801691133,141,333,1692,3996\n2394,Comerica Park,Comerica Park,24,6.75,359.5486847956453,146,328,1752,3936\n2394,Comerica Park,Comerica Park,25,6.75,357.1985310451971,151,324,1812,3888\n2394,Comerica Park,Comerica Park,26,6.75,354.98633093628615,156,319,1872,3828\n2394,Comerica Park,Comerica Park,27,6.75,352.9082009344969,160,314,1920,3768\n2394,Comerica Park,Comerica Park,28,6.75,350.96054432303316,165,310,1980,3720\n2394,Comerica Park,Comerica Park,29,6.75,349.1400351881037,169,305,2028,3660\n2394,Comerica Park,Comerica Park,30,6.75,347.4436038802748,174,301,2088,3612\n2394,Comerica Park,Comerica Park,31,6.75,345.86842382846976,178,296,2136,3552\n2394,Comerica Park,Comerica Park,32,6.75,344.4118995971081,183,292,2196,3504\n2394,Comerica Park,Comerica Park,33,6.75,343.0716560891737,187,288,2244,3456\n2394,Comerica Park,Comerica Park,34,6.75,341.8455288089917,191,283,2292,3396\n2394,Comerica Park,Comerica Park,35,6.75,340.7315551083472,195,279,2340,3348\n2394,Comerica Park,Comerica Park,36,6.75,339.727966348443,200,275,2400,3300\n2394,Comerica Park,Comerica Park,37,6.75,338.8331809182026,204,271,2448,3252\n2394,Comerica Park,Comerica Park,38,6.75,338.04579805670204,208,266,2496,3192\n2394,Comerica Park,Comerica Park,39,6.59,338.0648309685681,213,263,2556,3156\n2394,Comerica Park,Comerica Park,40,6.59,337.3783874428363,217,258,2604,3096\n2394,Comerica Park,Comerica Park,41,6.59,336.79710969820894,221,254,2652,3048\n2394,Comerica Park,Comerica Park,42,6.59,336.32010166185404,225,250,2700,3000\n2394,Comerica Park,Comerica Park,43,5.94,335.7592612719227,229,246,2748,2952\n2394,Comerica Park,Comerica Park,44,9.04,333.0651614963585,231,240,2772,2880\n2394,Comerica Park,Comerica Park,45,9.04,327.4205445934909,232,232,2784,2784\n2395,Oracle Park,Oracle Park,-45,8.17,339.77017745966157,-240,240,-2880,2880\n2395,Oracle Park,Oracle Park,-44,8.17,342.4107532150113,-238,246,-2856,2952\n2395,Oracle Park,Oracle Park,-43,8.17,345.1986681722185,-235,252,-2820,3024\n2395,Oracle Park,Oracle Park,-42,11.09,348.0070193261041,-233,259,-2796,3108\n2395,Oracle Park,Oracle Park,-41,8.19,349.1222482841458,-229,263,-2748,3156\n2395,Oracle Park,Oracle Park,-40,8.19,349.0846624024911,-224,267,-2688,3204\n2395,Oracle Park,Oracle Park,-39,8.19,349.15342868071156,-220,271,-2640,3252\n2395,Oracle Park,Oracle Park,-38,8.19,349.3286519138848,-215,275,-2580,3300\n2395,Oracle Park,Oracle Park,-37,8.19,349.61059935424373,-210,279,-2520,3348\n2395,Oracle Park,Oracle Park,-36,8.19,349.9997017067858,-206,283,-2472,3396\n2395,Oracle Park,Oracle Park,-35,8.19,350.49655473748146,-201,287,-2412,3444\n2395,Oracle Park,Oracle Park,-34,8.19,351.10192150527996,-196,291,-2352,3492\n2395,Oracle Park,Oracle Park,-33,8.19,351.8167352335222,-192,295,-2304,3540\n2395,Oracle Park,Oracle Park,-32,8.19,352.6421028409566,-187,299,-2244,3588\n2395,Oracle Park,Oracle Park,-31,8.19,353.5793091573732,-182,303,-2184,3636\n2395,Oracle Park,Oracle Park,-30,8.19,354.6298218539735,-177,307,-2124,3684\n2395,Oracle Park,Oracle Park,-29,8.19,355.7952971240444,-172,311,-2064,3732\n2395,Oracle Park,Oracle Park,-28,8.19,357.0775861553746,-168,315,-2016,3780\n2395,Oracle Park,Oracle Park,-27,8.19,358.47874244221174,-163,319,-1956,3828\n2395,Oracle Park,Oracle Park,-26,8.19,360.00102999149124,-158,324,-1896,3888\n2395,Oracle Park,Oracle Park,-25,8.19,361.6469324856762,-153,328,-1836,3936\n2395,Oracle Park,Oracle Park,-24,8.19,363.4191634729266,-148,332,-1776,3984\n2395,Oracle Park,Oracle Park,-23,8.19,365.32067766459306,-143,336,-1716,4032\n2395,Oracle Park,Oracle Park,-22,8.19,367.3546834303451,-138,341,-1656,4092\n2395,Oracle Park,Oracle Park,-21,8.19,369.5246565927447,-132,345,-1584,4140\n2395,Oracle Park,Oracle Park,-20,8.19,371.8343556359572,-127,349,-1524,4188\n2395,Oracle Park,Oracle Park,-19,8.19,374.2878384577523,-122,354,-1464,4248\n2395,Oracle Park,Oracle Park,-18,8.19,376.8894808102348,-116,358,-1392,4296\n2395,Oracle Park,Oracle Park,-17,8.19,379.64399659313904,-111,363,-1332,4356\n2395,Oracle Park,Oracle Park,-16,8.19,382.5564601843529,-105,368,-1260,4416\n2395,Oracle Park,Oracle Park,-15,8.19,385.6323310159781,-100,372,-1200,4464\n2395,Oracle Park,Oracle Park,-14,8.19,388.8774806311512,-94,377,-1128,4524\n2395,Oracle Park,Oracle Park,-13,8.18,392.2964212706539,-88,382,-1056,4584\n2395,Oracle Park,Oracle Park,-12,8.18,395.8561598136562,-82,387,-984,4644\n2395,Oracle Park,Oracle Park,-11,6.77,398.7292036805891,-76,391,-912,4692\n2395,Oracle Park,Oracle Park,-10,6.77,397.42829818652035,-69,391,-828,4692\n2395,Oracle Park,Oracle Park,-9,6.77,396.25616476752765,-62,391,-744,4692\n2395,Oracle Park,Oracle Park,-8,6.77,395.2109560310735,-55,391,-660,4692\n2395,Oracle Park,Oracle Park,-7,6.77,394.29103560393855,-48,391,-576,4692\n2395,Oracle Park,Oracle Park,-6,6.77,393.49497180097416,-41,391,-492,4692\n2395,Oracle Park,Oracle Park,-5,9.13,392.81018279203954,-34,391,-408,4692\n2395,Oracle Park,Oracle Park,-4,9.13,392.24468232234244,-27,391,-324,4692\n2395,Oracle Park,Oracle Park,-3,9.13,391.7999822355176,-21,391,-252,4692\n2395,Oracle Park,Oracle Park,-2,9.13,391.4754015060646,-14,391,-168,4692\n2395,Oracle Park,Oracle Park,-1,9.13,391.2704442319425,-7,391,-84,4692\n2395,Oracle Park,Oracle Park,0,9.13,391.18479778253993,0,391,0,4692\n2395,Oracle Park,Oracle Park,1,9.13,391.2183316338648,7,391,84,4692\n2395,Oracle Park,Oracle Park,2,9.13,391.3710968828658,14,391,168,4692\n2395,Oracle Park,Oracle Park,3,9.13,391.6433264375194,20,391,240,4692\n2395,Oracle Park,Oracle Park,4,9.13,392.0354358839992,27,391,324,4692\n2395,Oracle Park,Oracle Park,5,9.13,392.54802503694293,34,391,408,4692\n2395,Oracle Park,Oracle Park,6,6.56,393.0337926581251,41,391,492,4692\n2395,Oracle Park,Oracle Park,7,6.56,393.80382792842846,48,391,576,4692\n2395,Oracle Park,Oracle Park,8,6.56,394.69735109374193,55,391,660,4692\n2395,Oracle Park,Oracle Park,9,6.56,395.71575117807004,62,391,744,4692\n2395,Oracle Park,Oracle Park,10,6.56,396.8606205305345,69,391,828,4692\n2395,Oracle Park,Oracle Park,11,6.56,398.1337609748835,76,391,912,4692\n2395,Oracle Park,Oracle Park,12,6.56,399.53719083355327,83,391,996,4692\n2395,Oracle Park,Oracle Park,13,6.56,401.0731528779876,90,391,1080,4692\n2395,Oracle Park,Oracle Park,14,6.56,402.7441232645212,97,391,1164,4692\n2395,Oracle Park,Oracle Park,15,6.56,404.5528215234526,105,391,1260,4692\n2395,Oracle Park,Oracle Park,16,6.56,406.50222167809113,112,391,1344,4692\n2395,Oracle Park,Oracle Park,17,6.56,408.59556458068806,119,391,1428,4692\n2395,Oracle Park,Oracle Park,18,6.56,410.83637156341246,127,391,1524,4692\n2395,Oracle Park,Oracle Park,19,6.56,413.228459515062,135,391,1620,4692\n2395,Oracle Park,Oracle Park,20,20.52,410.3280520043243,140,386,1680,4632\n2395,Oracle Park,Oracle Park,21,20.52,402.223860676306,144,376,1728,4512\n2395,Oracle Park,Oracle Park,22,20.52,394.5514496020929,148,366,1776,4392\n2395,Oracle Park,Oracle Park,23,20.52,387.28202358951506,151,356,1812,4272\n2395,Oracle Park,Oracle Park,24,20.52,380.38939706958354,155,348,1860,4176\n2395,Oracle Park,Oracle Park,25,20.52,373.8497095249831,158,339,1896,4068\n2395,Oracle Park,Oracle Park,26,20.52,367.64117754156797,161,330,1932,3960\n2395,Oracle Park,Oracle Park,27,20.45,363.25369706244106,165,324,1980,3888\n2395,Oracle Park,Oracle Park,28,20.45,363.54672280451484,171,321,2052,3852\n2395,Oracle Park,Oracle Park,29,23.81,363.64631661681415,176,318,2112,3816\n2395,Oracle Park,Oracle Park,30,23.81,358.3743827569871,179,310,2148,3720\n2395,Oracle Park,Oracle Park,31,23.81,353.35922188558857,182,303,2184,3636\n2395,Oracle Park,Oracle Park,32,23.81,348.587207687529,185,296,2220,3552\n2395,Oracle Park,Oracle Park,33,23.81,344.0457686584138,187,289,2244,3468\n2395,Oracle Park,Oracle Park,34,23.81,339.72329285906306,190,282,2280,3384\n2395,Oracle Park,Oracle Park,35,23.81,335.60904302037073,192,275,2304,3300\n2395,Oracle Park,Oracle Park,36,23.81,331.6930807217494,195,268,2340,3216\n2395,Oracle Park,Oracle Park,37,23.81,327.96619854403764,197,262,2364,3144\n2395,Oracle Park,Oracle Park,38,23.81,324.4198592480975,200,256,2400,3072\n2395,Oracle Park,Oracle Park,39,23.81,321.0461411580014,202,249,2424,2988\n2395,Oracle Park,Oracle Park,40,23.81,317.8376890364155,204,243,2448,2916\n2395,Oracle Park,Oracle Park,41,23.81,314.78766983264507,207,238,2484,2856\n2395,Oracle Park,Oracle Park,42,23.81,311.88973276332194,209,232,2508,2784\n2395,Oracle Park,Oracle Park,43,23.81,309.13797325400367,211,226,2532,2712\n2395,Oracle Park,Oracle Park,44,23.81,306.5269003287531,213,220,2556,2640\n2395,Oracle Park,Oracle Park,45,23.81,304.051407085521,215,215,2580,2580\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-45,6.565885981,318.6939439044125,-225,225,-2700,2700\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-44,6.565885981,322.9115081208625,-224,232,-2688,2784\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-43,6.565885981,327.34324830300153,-223,239,-2676,2868\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-42,6.565885981,332.00086437913995,-222,247,-2664,2964\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-41,6.515886029,336.20150617228614,-221,254,-2652,3048\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-40,6.515886029,339.8720392412216,-218,260,-2616,3120\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-39,6.515886029,343.72946329589547,-216,267,-2592,3204\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-38,6.38688608,347.00315657670257,-214,273,-2568,3276\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-37,6.38688608,349.9560376631754,-211,279,-2532,3348\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-36,6.38688608,353.06807715680145,-208,286,-2496,3432\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-35,6.00188609,354.3858487512018,-203,290,-2436,3480\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-34,6.00188609,355.51154927383516,-199,295,-2388,3540\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-33,6.00188609,356.75344096627987,-194,299,-2328,3588\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-32,6.00188609,358.1135067972581,-190,304,-2280,3648\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-31,6.00188609,359.59393736639566,-185,308,-2220,3696\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-30,6.00188609,361.1971397299749,-181,313,-2172,3756\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-29,6.00188609,362.92574722878425,-176,317,-2112,3804\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-28,6.00188609,364.7826303947554,-171,322,-2052,3864\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-27,6.00188609,366.7709090230106,-167,327,-2004,3924\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-26,6.00188609,368.8939655070219,-162,332,-1944,3984\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-25,6.00188609,371.15545954696825,-157,336,-1884,4032\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-24,6.00188609,373.5593443552597,-152,341,-1824,4092\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-23,6.00188609,376.1098844988335,-147,346,-1764,4152\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-22,6.00188609,378.81167553545714,-142,351,-1704,4212\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-21,6.00188609,381.66966562122195,-137,356,-1644,4272\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-20,6.00188609,384.6891792890399,-132,361,-1584,4332\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-19,6.00188609,387.87594362368407,-126,367,-1512,4404\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-18,6.088885983,391.0048738107715,-121,372,-1452,4464\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-17,6.088885983,392.7168287140093,-115,376,-1380,4512\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-16,6.088885983,394.56455733228177,-109,379,-1308,4548\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-15,6.088885983,396.551119561841,-103,383,-1236,4596\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-14,6.088885983,398.6798432650302,-96,387,-1152,4644\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-13,6.088885983,400.95433843685794,-90,391,-1080,4692\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-12,6.088885983,403.3785128354843,-84,395,-1008,4740\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-11,5.981886109,404.2821993863455,-77,397,-924,4764\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-10,5.981886109,405.2116433318871,-70,399,-840,4788\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-9,5.981886109,406.26940946706407,-64,401,-768,4812\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-8,5.889270654,407.36658667886803,-57,403,-684,4836\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-7,5.889270654,407.4788014398879,-50,404,-600,4848\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-6,5.889270654,407.7153062924724,-43,405,-516,4860\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-5,5.889270654,408.0764620768607,-36,407,-432,4884\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-4,5.96103975,408.4194507181038,-28,407,-336,4884\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-3,5.96103975,408.0430555856161,-21,407,-252,4884\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-2,5.96103975,407.7914564341458,-14,408,-168,4896\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,-1,5.96103975,407.6642693276692,-7,408,-84,4896\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,0,5.897039747,407.4160902793502,0,407,0,4884\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,1,5.897039747,406.39174063597585,7,406,84,4872\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,2,5.897039747,405.4957371876559,14,405,168,4860\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,3,5.897039747,404.72668847919135,21,404,252,4848\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,4,5.90603975,403.7777534084965,28,403,336,4836\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,5,5.90603975,402.18892201012,35,401,420,4812\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,6,5.90603975,400.73413449478574,42,399,504,4788\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,7,5.90603975,399.4110594709064,49,396,588,4752\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,8,5.90603975,398.2175940640536,55,394,660,4728\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,9,6.073885878,395.63708231740105,62,391,744,4692\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,10,6.073885878,392.1292698451089,68,386,816,4632\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,11,6.073885878,388.80050449787853,74,382,888,4584\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,12,6.073885878,385.64426103698827,80,377,960,4524\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,13,6.073885878,382.6544707198992,86,373,1032,4476\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,14,6.073885878,379.82549020257966,92,369,1104,4428\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,15,6.203885993,376.29158572863884,97,363,1164,4356\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,16,6.203885993,372.42468267920697,103,358,1236,4296\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,17,6.203885993,368.7476280590195,108,353,1296,4236\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,18,6.203885993,365.2526445016349,113,347,1356,4164\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,19,6.203885993,361.9325027291593,118,342,1416,4104\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,20,6.203885993,358.7804808498767,123,337,1476,4044\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,21,6.203885993,355.7903275352889,128,332,1536,3984\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,22,6.203885993,352.95622867129686,132,327,1584,3924\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,23,6.203885993,350.2727771272185,137,322,1644,3864\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,24,6.203885993,347.7349453288411,141,318,1692,3816\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,25,6.203885993,345.3380603587038,146,313,1752,3756\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,26,6.203885993,343.0777813390771,150,308,1800,3696\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,27,6.203885993,340.9500788813321,155,304,1860,3648\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,28,6.203885993,338.95121641013253,159,299,1908,3588\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,29,6.203885993,337.0777331926223,163,295,1956,3540\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,30,6.203885993,335.32642892193786,168,290,2016,3480\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,31,6.203885993,333.6943497212848,172,286,2064,3432\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,32,6.203885993,332.17877544980024,176,282,2112,3384\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,33,6.203885993,330.77720820472206,180,277,2160,3324\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,34,6.203885993,329.48736192623096,184,273,2208,3276\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,35,6.203885993,328.3071530219152,188,269,2256,3228\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,36,6.203885993,327.23469193729295,192,265,2304,3180\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,37,6.203885993,326.268275607367,196,261,2352,3132\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,38,6.203885993,325.40638073189245,200,256,2400,3072\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,39,6.203885993,324.64765782404464,204,252,2448,3024\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,40,6.254886111,322.8344207744466,208,247,2496,2964\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,41,6.254886111,320.830219540934,210,242,2520,2904\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,42,6.254886111,318.9473045074964,213,237,2556,2844\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,43,6.254886111,317.1824148493162,216,232,2592,2784\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,44,6.254886111,315.5325350286269,219,227,2628,2724\n2523,George M. Steinbrenner Field,George M. Steinbrenner Field,45,6.254886111,313.9948816024408,222,222,2664,2664\n2529,Sutter Health Park,Sutter Health Park,-45,7.919749132,330.1775000660759,-233,233,-2796,2796\n2529,Sutter Health Park,Sutter Health Park,-44,7.919749132,332.2753100598013,-231,239,-2772,2868\n2529,Sutter Health Park,Sutter Health Park,-43,7.919749132,334.5024919457885,-228,245,-2736,2940\n2529,Sutter Health Park,Sutter Health Park,-42,7.919749132,336.86303628301107,-225,250,-2700,3000\n2529,Sutter Health Park,Sutter Health Park,-41,7.629500891,339.29380124228726,-223,256,-2676,3072\n2529,Sutter Health Park,Sutter Health Park,-40,7.629500891,341.4181700702508,-219,262,-2628,3144\n2529,Sutter Health Park,Sutter Health Park,-39,7.629500891,343.67465470074404,-216,267,-2592,3204\n2529,Sutter Health Park,Sutter Health Park,-38,7.629500891,346.06728146211987,-213,273,-2556,3276\n2529,Sutter Health Park,Sutter Health Park,-37,7.629500891,348.60038771317517,-210,278,-2520,3336\n2529,Sutter Health Park,Sutter Health Park,-36,7.423682715,350.69834499546135,-206,284,-2472,3408\n2529,Sutter Health Park,Sutter Health Park,-35,7.423682715,352.7574811784517,-202,289,-2424,3468\n2529,Sutter Health Park,Sutter Health Park,-34,7.423682715,354.9497004437204,-198,294,-2376,3528\n2529,Sutter Health Park,Sutter Health Park,-33,7.401671687,356.9181532135994,-194,299,-2328,3588\n2529,Sutter Health Park,Sutter Health Park,-32,7.401671687,358.8624591846851,-190,304,-2280,3648\n2529,Sutter Health Park,Sutter Health Park,-31,7.401671687,360.93861193850955,-186,309,-2232,3708\n2529,Sutter Health Park,Sutter Health Park,-30,7.539049572,363.1259327134011,-182,314,-2184,3768\n2529,Sutter Health Park,Sutter Health Park,-29,7.539049572,364.96879015814477,-177,319,-2124,3828\n2529,Sutter Health Park,Sutter Health Park,-28,7.539049572,366.94279242510885,-172,324,-2064,3888\n2529,Sutter Health Park,Sutter Health Park,-27,7.539049572,369.05129227041806,-168,329,-2016,3948\n2529,Sutter Health Park,Sutter Health Park,-26,7.612505859,371.0416329124215,-163,333,-1956,3996\n2529,Sutter Health Park,Sutter Health Park,-25,7.612505859,373.15956619915636,-158,338,-1896,4056\n2529,Sutter Health Park,Sutter Health Park,-24,7.697994087,375.0299446905429,-153,343,-1836,4116\n2529,Sutter Health Park,Sutter Health Park,-23,7.697994087,376.7466970112355,-147,347,-1764,4164\n2529,Sutter Health Park,Sutter Health Park,-22,7.634831539,378.6345003534565,-142,351,-1704,4212\n2529,Sutter Health Park,Sutter Health Park,-21,7.672338835,380.63788565893685,-136,355,-1632,4260\n2529,Sutter Health Park,Sutter Health Park,-20,7.672338835,382.3519082540663,-131,359,-1572,4308\n2529,Sutter Health Park,Sutter Health Park,-19,7.672338835,384.1989973670247,-125,363,-1500,4356\n2529,Sutter Health Park,Sutter Health Park,-18,7.605233048,385.7045283919051,-119,367,-1428,4404\n2529,Sutter Health Park,Sutter Health Park,-17,7.605233048,387.2929105298878,-113,370,-1356,4440\n2529,Sutter Health Park,Sutter Health Park,-16,7.571336052,388.8254366709033,-107,374,-1284,4488\n2529,Sutter Health Park,Sutter Health Park,-15,7.571336052,390.34660406339356,-101,377,-1212,4524\n2529,Sutter Health Park,Sutter Health Park,-14,7.468218281,391.7601540183074,-95,380,-1140,4560\n2529,Sutter Health Park,Sutter Health Park,-13,7.468218281,393.2549202698067,-88,383,-1056,4596\n2529,Sutter Health Park,Sutter Health Park,-12,7.75616782,394.9214760176278,-82,386,-984,4632\n2529,Sutter Health Park,Sutter Health Park,-11,7.820916678,396.76289664399326,-76,389,-912,4668\n2529,Sutter Health Park,Sutter Health Park,-10,7.820916678,397.7421072862117,-69,392,-828,4704\n2529,Sutter Health Park,Sutter Health Park,-9,7.820916678,398.8479568073024,-62,394,-744,4728\n2529,Sutter Health Park,Sutter Health Park,-8,7.662147871,399.7887934599602,-56,396,-672,4752\n2529,Sutter Health Park,Sutter Health Park,-7,7.662147871,400.7543746616655,-49,398,-588,4776\n2529,Sutter Health Park,Sutter Health Park,-6,7.662147871,401.84733430024306,-42,400,-504,4800\n2529,Sutter Health Park,Sutter Health Park,-5,7.766118458,402.44324219438903,-35,401,-420,4812\n2529,Sutter Health Park,Sutter Health Park,-4,7.766118458,401.9536988696451,-28,401,-336,4812\n2529,Sutter Health Park,Sutter Health Park,-3,7.766118458,401.587523914832,-21,401,-252,4812\n2529,Sutter Health Park,Sutter Health Park,-2,7.901440646,401.34662799056986,-14,401,-168,4812\n2529,Sutter Health Park,Sutter Health Park,-1,7.901440646,401.26370697426097,-7,401,-84,4812\n2529,Sutter Health Park,Sutter Health Park,0,7.901440646,401.3030357566133,0,401,0,4812\n2529,Sutter Health Park,Sutter Health Park,1,7.901440646,401.46467426509065,7,401,84,4812\n2529,Sutter Health Park,Sutter Health Park,2,7.901440646,401.74886894542635,14,402,168,4824\n2529,Sutter Health Park,Sutter Health Park,3,7.5788615,402.0748037006386,21,402,252,4824\n2529,Sutter Health Park,Sutter Health Park,4,7.5788615,402.52369997341884,28,402,336,4824\n2529,Sutter Health Park,Sutter Health Park,5,7.5788615,403.0965240516345,35,402,420,4824\n2529,Sutter Health Park,Sutter Health Park,6,11.02741984,402.21209065342794,42,400,504,4800\n2529,Sutter Health Park,Sutter Health Park,7,11.02741984,399.1542758840978,49,396,588,4752\n2529,Sutter Health Park,Sutter Health Park,8,11.02741984,396.26239897198496,55,392,660,4704\n2529,Sutter Health Park,Sutter Health Park,9,11.02741984,393.5311351692785,62,389,744,4668\n2529,Sutter Health Park,Sutter Health Park,10,11.02741984,390.9555380871176,68,385,816,4620\n2529,Sutter Health Park,Sutter Health Park,11,11.02741984,388.53101627875867,74,381,888,4572\n2529,Sutter Health Park,Sutter Health Park,12,11.02741984,386.25331195904636,80,378,960,4536\n2529,Sutter Health Park,Sutter Health Park,13,11.02741984,384.1184816666803,86,374,1032,4488\n2529,Sutter Health Park,Sutter Health Park,14,11.02741984,382.1228786975938,92,371,1104,4452\n2529,Sutter Health Park,Sutter Health Park,15,8.019652179,380.1636075032566,98,367,1176,4404\n2529,Sutter Health Park,Sutter Health Park,16,4.795157458,378.15949978435174,104,364,1248,4368\n2529,Sutter Health Park,Sutter Health Park,17,4.795157458,376.69769528015445,110,360,1320,4320\n2529,Sutter Health Park,Sutter Health Park,18,4.795157458,375.36104702053535,116,357,1392,4284\n2529,Sutter Health Park,Sutter Health Park,19,4.795157458,374.1474169213315,122,354,1464,4248\n2529,Sutter Health Park,Sutter Health Park,20,4.795157458,373.05487933201425,128,351,1536,4212\n2529,Sutter Health Park,Sutter Health Park,21,4.795157458,372.0817134410081,133,347,1596,4164\n2529,Sutter Health Park,Sutter Health Park,22,4.795157458,371.2263965598955,139,344,1668,4128\n2529,Sutter Health Park,Sutter Health Park,23,4.795157458,370.48759823700055,145,341,1740,4092\n2529,Sutter Health Park,Sutter Health Park,24,4.795157458,369.8641751574793,150,338,1800,4056\n2529,Sutter Health Park,Sutter Health Park,25,4.795157458,369.35516679317504,156,335,1872,4020\n2529,Sutter Health Park,Sutter Health Park,26,4.795157458,368.9597917711997,162,332,1944,3984\n2529,Sutter Health Park,Sutter Health Park,27,4.795157458,368.67744493554125,167,328,2004,3936\n2529,Sutter Health Park,Sutter Health Park,28,4.795157458,368.5076950810457,173,325,2076,3900\n2529,Sutter Health Park,Sutter Health Park,29,4.614701654,367.0896826567446,178,321,2136,3852\n2529,Sutter Health Park,Sutter Health Park,30,4.614701654,363.26825435837446,182,315,2184,3780\n2529,Sutter Health Park,Sutter Health Park,31,4.614701654,359.63398833628304,185,308,2220,3696\n2529,Sutter Health Park,Sutter Health Park,32,4.614701654,356.1791399757364,189,302,2268,3624\n2529,Sutter Health Park,Sutter Health Park,33,4.614701654,352.8965113419585,192,296,2304,3552\n2529,Sutter Health Park,Sutter Health Park,34,4.614701654,349.77941028140407,196,290,2352,3480\n2529,Sutter Health Park,Sutter Health Park,35,4.614701654,346.82161343498893,199,284,2388,3408\n2529,Sutter Health Park,Sutter Health Park,36,4.614701654,344.01733275216435,202,278,2424,3336\n2529,Sutter Health Park,Sutter Health Park,37,4.614701654,341.3611851446069,205,273,2460,3276\n2529,Sutter Health Park,Sutter Health Park,38,4.614701654,338.84816496156,209,267,2508,3204\n2529,Sutter Health Park,Sutter Health Park,39,4.614701654,336.47361900649264,212,261,2544,3132\n2529,Sutter Health Park,Sutter Health Park,40,4.614701654,334.2332238475423,215,256,2580,3072\n2529,Sutter Health Park,Sutter Health Park,41,4.614701654,332.12296520286804,218,251,2616,3012\n2529,Sutter Health Park,Sutter Health Park,42,4.614701654,330.13911920715003,221,245,2652,2940\n2529,Sutter Health Park,Sutter Health Park,43,4.614701654,328.27823538751,224,240,2688,2880\n2529,Sutter Health Park,Sutter Health Park,44,4.614701654,326.53712119653517,227,235,2724,2820\n2529,Sutter Health Park,Sutter Health Park,45,13.25423047,324.4852904086303,229,229,2748,2748\n2536,TD Ballpark,TD Ballpark,-45,8.506,328.45090679438556,-232,232,-2784,2784\n2536,TD Ballpark,TD Ballpark,-44,8.506,329.3691705734531,-229,237,-2748,2844\n2536,TD Ballpark,TD Ballpark,-43,8.819,330.3352425506937,-225,242,-2700,2904\n2536,TD Ballpark,TD Ballpark,-42,8.819,331.3032267825145,-222,246,-2664,2952\n2536,TD Ballpark,TD Ballpark,-41,8.819,332.3784439188998,-218,251,-2616,3012\n2536,TD Ballpark,TD Ballpark,-40,8.819,333.56260006309384,-214,256,-2568,3072\n2536,TD Ballpark,TD Ballpark,-39,8.819,334.857589461016,-211,260,-2532,3120\n2536,TD Ballpark,TD Ballpark,-38,8.819,336.2655020592171,-207,265,-2484,3180\n2536,TD Ballpark,TD Ballpark,-37,8.819,337.78863194889806,-203,270,-2436,3240\n2536,TD Ballpark,TD Ballpark,-36,8.819,339.42948676102316,-200,275,-2400,3300\n2536,TD Ballpark,TD Ballpark,-35,8.819,341.19079808611536,-196,279,-2352,3348\n2536,TD Ballpark,TD Ballpark,-34,8.819,343.07553300182497,-192,284,-2304,3408\n2536,TD Ballpark,TD Ballpark,-33,8.819,345.08690680196304,-188,289,-2256,3468\n2536,TD Ballpark,TD Ballpark,-32,8.819,347.22839703254766,-184,294,-2208,3528\n2536,TD Ballpark,TD Ballpark,-31,8.819,349.50375895372554,-180,300,-2160,3600\n2536,TD Ballpark,TD Ballpark,-30,8.819,351.91704256141463,-176,305,-2112,3660\n2536,TD Ballpark,TD Ballpark,-29,8.819,354.47261131943753,-172,310,-2064,3720\n2536,TD Ballpark,TD Ballpark,-28,8.819,357.17516277206454,-168,315,-2016,3780\n2536,TD Ballpark,TD Ballpark,-27,8.819,360.02975122862233,-163,321,-1956,3852\n2536,TD Ballpark,TD Ballpark,-26,8.819,363.0418127365539,-159,326,-1908,3912\n2536,TD Ballpark,TD Ballpark,-25,8.819,366.2171925875183,-155,332,-1860,3984\n2536,TD Ballpark,TD Ballpark,-24,8.819,369.5621756333594,-150,338,-1800,4056\n2536,TD Ballpark,TD Ballpark,-23,8.819,373.08351972572444,-146,343,-1752,4116\n2536,TD Ballpark,TD Ballpark,-22,8.609,376.2445541555082,-141,349,-1692,4188\n2536,TD Ballpark,TD Ballpark,-21,8.609,378.2395705859069,-136,353,-1632,4236\n2536,TD Ballpark,TD Ballpark,-20,8.623,380.165696271127,-130,357,-1560,4284\n2536,TD Ballpark,TD Ballpark,-19,8.623,381.9443560684603,-124,361,-1488,4332\n2536,TD Ballpark,TD Ballpark,-18,8.647,383.7521749939303,-119,365,-1428,4380\n2536,TD Ballpark,TD Ballpark,-17,8.647,385.2055977238184,-113,368,-1356,4416\n2536,TD Ballpark,TD Ballpark,-16,8.647,386.78833909457353,-107,372,-1284,4464\n2536,TD Ballpark,TD Ballpark,-15,8.647,388.50297055286075,-101,375,-1212,4500\n2536,TD Ballpark,TD Ballpark,-14,8.635,389.886811688735,-94,378,-1128,4536\n2536,TD Ballpark,TD Ballpark,-13,8.635,391.2824595601148,-88,381,-1056,4572\n2536,TD Ballpark,TD Ballpark,-12,8.674,392.5732682627989,-82,384,-984,4608\n2536,TD Ballpark,TD Ballpark,-11,8.674,393.7895982163953,-75,387,-900,4644\n2536,TD Ballpark,TD Ballpark,-10,8.584,394.73445857862197,-69,389,-828,4668\n2536,TD Ballpark,TD Ballpark,-9,8.487,395.68592160860504,-62,391,-744,4692\n2536,TD Ballpark,TD Ballpark,-8,8.571,396.5099701163661,-55,393,-660,4716\n2536,TD Ballpark,TD Ballpark,-7,8.494,397.18453056452023,-48,394,-576,4728\n2536,TD Ballpark,TD Ballpark,-6,8.494,397.7908510595119,-42,396,-504,4752\n2536,TD Ballpark,TD Ballpark,-5,8.494,398.5206043694026,-35,397,-420,4764\n2536,TD Ballpark,TD Ballpark,-4,8.648,399.1377932872301,-28,398,-336,4776\n2536,TD Ballpark,TD Ballpark,-3,8.43,399.59805627416335,-21,399,-252,4788\n2536,TD Ballpark,TD Ballpark,-2,8.43,399.7034337962571,-14,399,-168,4788\n2536,TD Ballpark,TD Ballpark,-1,8.365,399.713239021719,-7,400,-84,4800\n2536,TD Ballpark,TD Ballpark,0,8.492,399.716118902,0,400,0,4800\n2536,TD Ballpark,TD Ballpark,1,8.462,399.5709823548501,7,400,84,4800\n2536,TD Ballpark,TD Ballpark,2,8.565,398.9479131714273,14,399,168,4788\n2536,TD Ballpark,TD Ballpark,3,8.622,397.9383891955239,21,397,252,4764\n2536,TD Ballpark,TD Ballpark,4,8.622,396.434245479967,28,395,336,4740\n2536,TD Ballpark,TD Ballpark,5,12.705,394.4998167330773,34,393,408,4716\n2536,TD Ballpark,TD Ballpark,6,12.571,390.8134071453959,41,389,492,4668\n2536,TD Ballpark,TD Ballpark,7,12.365,387.47243145310114,47,385,564,4620\n2536,TD Ballpark,TD Ballpark,8,12.435,384.14381238379576,53,380,636,4560\n2536,TD Ballpark,TD Ballpark,9,12.489,381.1057625404413,60,376,720,4512\n2536,TD Ballpark,TD Ballpark,10,12.503,378.0923279932813,66,372,792,4464\n2536,TD Ballpark,TD Ballpark,11,12.326,375.5019553412107,72,369,864,4428\n2536,TD Ballpark,TD Ballpark,12,12.464,372.9890443531326,78,365,936,4380\n2536,TD Ballpark,TD Ballpark,13,12.412,370.56690850416936,83,361,996,4332\n2536,TD Ballpark,TD Ballpark,14,12.538,368.2900986292658,89,357,1068,4284\n2536,TD Ballpark,TD Ballpark,15,12.519,366.2480083091072,95,354,1140,4248\n2536,TD Ballpark,TD Ballpark,16,12.397,364.2136509879313,100,350,1200,4200\n2536,TD Ballpark,TD Ballpark,17,12.346,362.1884269898474,106,346,1272,4152\n2536,TD Ballpark,TD Ballpark,18,12.547,360.53271796336617,111,343,1332,4116\n2536,TD Ballpark,TD Ballpark,19,12.547,358.9026581024618,117,339,1404,4068\n2536,TD Ballpark,TD Ballpark,20,12.547,357.3956479074667,122,336,1464,4032\n2536,TD Ballpark,TD Ballpark,21,12.547,356.0092308958854,128,332,1536,3984\n2536,TD Ballpark,TD Ballpark,22,12.547,354.7411687941884,133,329,1596,3948\n2536,TD Ballpark,TD Ballpark,23,12.105,352.6984581941432,138,325,1656,3900\n2536,TD Ballpark,TD Ballpark,24,12.179,350.4736545887426,143,320,1716,3840\n2536,TD Ballpark,TD Ballpark,25,12.179,348.2178028275995,147,316,1764,3792\n2536,TD Ballpark,TD Ballpark,26,12.136,346.09679353980613,152,311,1824,3732\n2536,TD Ballpark,TD Ballpark,27,12.294,344.10425141709567,156,307,1872,3684\n2536,TD Ballpark,TD Ballpark,28,12.294,342.2303895258099,161,302,1932,3624\n2536,TD Ballpark,TD Ballpark,29,12.294,340.47997756164074,165,298,1980,3576\n2536,TD Ballpark,TD Ballpark,30,12.294,338.8500719831962,169,293,2028,3516\n2536,TD Ballpark,TD Ballpark,31,12.239,337.2994466229803,174,289,2088,3468\n2536,TD Ballpark,TD Ballpark,32,12.239,335.8647825017499,178,285,2136,3420\n2536,TD Ballpark,TD Ballpark,33,12.239,334.543744704825,182,281,2184,3372\n2536,TD Ballpark,TD Ballpark,34,12.345,333.3220945049198,186,276,2232,3312\n2536,TD Ballpark,TD Ballpark,35,12.345,332.2037907725244,191,272,2292,3264\n2536,TD Ballpark,TD Ballpark,36,12.345,331.1935132345263,195,268,2340,3216\n2536,TD Ballpark,TD Ballpark,37,12.172,330.3805146422175,199,264,2388,3168\n2536,TD Ballpark,TD Ballpark,38,12.172,329.6746571696148,203,260,2436,3120\n2536,TD Ballpark,TD Ballpark,39,12.304,329.0308591900127,207,256,2484,3072\n2536,TD Ballpark,TD Ballpark,40,12.304,328.45879230877404,211,252,2532,3024\n2536,TD Ballpark,TD Ballpark,41,12.304,327.98844626848296,215,248,2580,2976\n2536,TD Ballpark,TD Ballpark,42,12.304,327.6190986029624,219,243,2628,2916\n2536,TD Ballpark,TD Ballpark,43,12.304,327.35018372172885,223,239,2676,2868\n2536,TD Ballpark,TD Ballpark,44,12.31,327.21552378899787,227,235,2724,2820\n2536,TD Ballpark,TD Ballpark,45,12.31,327.24618052051426,231,231,2772,2772\n2602,Great American Ball Park,Great American Ball Park,-45,11.35,327.7825287445923,-232,232,-2784,2784\n2602,Great American Ball Park,Great American Ball Park,-44,11.35,331.6014707203927,-230,239,-2760,2868\n2602,Great American Ball Park,Great American Ball Park,-43,11.35,335.61388582962934,-229,245,-2748,2940\n2602,Great American Ball Park,Great American Ball Park,-42,11.31,337.632715487056,-226,251,-2712,3012\n2602,Great American Ball Park,Great American Ball Park,-41,11.31,337.9135678307282,-222,255,-2664,3060\n2602,Great American Ball Park,Great American Ball Park,-40,11.31,338.29802245016026,-217,259,-2604,3108\n2602,Great American Ball Park,Great American Ball Park,-39,11.31,338.7866681235569,-213,263,-2556,3156\n2602,Great American Ball Park,Great American Ball Park,-38,11.31,339.38025551349375,-209,267,-2508,3204\n2602,Great American Ball Park,Great American Ball Park,-37,11.31,340.0796999928215,-205,272,-2460,3264\n2602,Great American Ball Park,Great American Ball Park,-36,11.31,340.8860851098349,-200,276,-2400,3312\n2602,Great American Ball Park,Great American Ball Park,-35,11.31,341.8006667172691,-196,280,-2352,3360\n2602,Great American Ball Park,Great American Ball Park,-34,11.31,342.824877794643,-192,284,-2304,3408\n2602,Great American Ball Park,Great American Ball Park,-33,11.31,343.96033399877126,-187,288,-2244,3456\n2602,Great American Ball Park,Great American Ball Park,-32,11.31,345.20883998296927,-183,293,-2196,3516\n2602,Great American Ball Park,Great American Ball Park,-31,11.31,346.57239653166744,-178,297,-2136,3564\n2602,Great American Ball Park,Great American Ball Park,-30,11.31,348.0532085639016,-174,301,-2088,3612\n2602,Great American Ball Park,Great American Ball Park,-29,11.31,349.65369406655185,-170,306,-2040,3672\n2602,Great American Ball Park,Great American Ball Park,-28,11.31,351.37649402636896,-165,310,-1980,3720\n2602,Great American Ball Park,Great American Ball Park,-27,11.31,353.2244834388695,-160,315,-1920,3780\n2602,Great American Ball Park,Great American Ball Park,-26,11.31,355.20078348223274,-156,319,-1872,3828\n2602,Great American Ball Park,Great American Ball Park,-25,11.31,357.30877495555353,-151,324,-1812,3888\n2602,Great American Ball Park,Great American Ball Park,-24,11.31,359.55211309336806,-146,328,-1752,3936\n2602,Great American Ball Park,Great American Ball Park,-23,11.31,361.93474388247563,-141,333,-1692,3996\n2602,Great American Ball Park,Great American Ball Park,-22,11.31,364.46092202298104,-137,338,-1644,4056\n2602,Great American Ball Park,Great American Ball Park,-21,11.31,367.1352306934322,-132,343,-1584,4116\n2602,Great American Ball Park,Great American Ball Park,-20,11.31,369.962603300268,-127,348,-1524,4176\n2602,Great American Ball Park,Great American Ball Park,-19,11.31,372.94834741487995,-121,353,-1452,4236\n2602,Great American Ball Park,Great American Ball Park,-18,11.31,376.0981711278784,-116,358,-1392,4296\n2602,Great American Ball Park,Great American Ball Park,-17,11.31,379.41821208014574,-111,363,-1332,4356\n2602,Great American Ball Park,Great American Ball Park,-16,11.31,382.9150694645642,-106,368,-1272,4416\n2602,Great American Ball Park,Great American Ball Park,-15,11.31,386.5958393316414,-100,373,-1200,4476\n2602,Great American Ball Park,Great American Ball Park,-14,11.32,387.0927882848021,-94,376,-1128,4512\n2602,Great American Ball Park,Great American Ball Park,-13,7.54,387.52508648376704,-87,378,-1044,4536\n2602,Great American Ball Park,Great American Ball Park,-12,7.54,388.00151834044067,-81,380,-972,4560\n2602,Great American Ball Park,Great American Ball Park,-11,7.54,388.59763942266324,-74,381,-888,4572\n2602,Great American Ball Park,Great American Ball Park,-10,7.54,389.3143664771059,-68,383,-816,4596\n2602,Great American Ball Park,Great American Ball Park,-9,7.54,390.15280619567534,-61,385,-732,4620\n2602,Great American Ball Park,Great American Ball Park,-8,7.54,391.11425941275786,-54,387,-648,4644\n2602,Great American Ball Park,Great American Ball Park,-7,7.74,392.06217173632473,-48,389,-576,4668\n2602,Great American Ball Park,Great American Ball Park,-6,7.74,393.3061966432224,-41,391,-492,4692\n2602,Great American Ball Park,Great American Ball Park,-5,7.74,394.6787469907315,-34,393,-408,4716\n2602,Great American Ball Park,Great American Ball Park,-4,7.74,396.1820141753611,-28,395,-336,4740\n2602,Great American Ball Park,Great American Ball Park,-3,7.74,397.8184192052849,-21,397,-252,4764\n2602,Great American Ball Park,Great American Ball Park,-2,7.74,399.59062245302505,-14,399,-168,4788\n2602,Great American Ball Park,Great American Ball Park,-1,7.74,401.50153451593513,-7,401,-84,4812\n2602,Great American Ball Park,Great American Ball Park,0,7.74,403.5543282692137,0,404,0,4848\n2602,Great American Ball Park,Great American Ball Park,1,7.57,401.86938908256195,7,402,84,4824\n2602,Great American Ball Park,Great American Ball Park,2,7.57,399.4743509773526,14,399,168,4788\n2602,Great American Ball Park,Great American Ball Park,3,7.57,397.2279740001037,21,397,252,4764\n2602,Great American Ball Park,Great American Ball Park,4,7.57,395.1264062912041,28,394,336,4728\n2602,Great American Ball Park,Great American Ball Park,5,7.58,393.1472634040068,34,392,408,4704\n2602,Great American Ball Park,Great American Ball Park,6,7.58,391.0972357436306,41,389,492,4668\n2602,Great American Ball Park,Great American Ball Park,7,7.58,389.1864115062119,47,386,564,4632\n2602,Great American Ball Park,Great American Ball Park,8,7.65,387.3824645494105,54,384,648,4608\n2602,Great American Ball Park,Great American Ball Park,9,7.65,385.58488836146495,60,381,720,4572\n2602,Great American Ball Park,Great American Ball Park,10,7.66,383.799867828254,67,378,804,4536\n2602,Great American Ball Park,Great American Ball Park,11,7.62,381.58917730177626,73,375,876,4500\n2602,Great American Ball Park,Great American Ball Park,12,7.56,379.5496707225984,79,371,948,4452\n2602,Great American Ball Park,Great American Ball Park,13,7.59,377.69495681663096,85,368,1020,4416\n2602,Great American Ball Park,Great American Ball Park,14,7.6,375.93322463850194,91,365,1092,4380\n2602,Great American Ball Park,Great American Ball Park,15,7.6,374.22167180156197,97,361,1164,4332\n2602,Great American Ball Park,Great American Ball Park,16,7.6,372.1179126633786,103,358,1236,4296\n2602,Great American Ball Park,Great American Ball Park,17,7.57,370.138009837911,108,354,1296,4248\n2602,Great American Ball Park,Great American Ball Park,18,7.58,368.2636426350206,114,350,1368,4200\n2602,Great American Ball Park,Great American Ball Park,19,7.58,366.45819039335987,119,346,1428,4152\n2602,Great American Ball Park,Great American Ball Park,20,7.55,364.8381654643784,125,343,1500,4116\n2602,Great American Ball Park,Great American Ball Park,21,7.6,363.0640594632971,130,339,1560,4068\n2602,Great American Ball Park,Great American Ball Park,22,7.58,361.0779556661896,135,335,1620,4020\n2602,Great American Ball Park,Great American Ball Park,23,7.6,359.18674739820733,140,331,1680,3972\n2602,Great American Ball Park,Great American Ball Park,24,7.6,357.39543803193243,145,326,1740,3912\n2602,Great American Ball Park,Great American Ball Park,25,7.65,355.72552778665374,150,322,1800,3864\n2602,Great American Ball Park,Great American Ball Park,26,7.65,354.1671080685053,155,318,1860,3816\n2602,Great American Ball Park,Great American Ball Park,27,7.65,352.24155639765803,160,314,1920,3768\n2602,Great American Ball Park,Great American Ball Park,28,7.63,350.3807422502411,164,309,1968,3708\n2602,Great American Ball Park,Great American Ball Park,29,7.67,348.64649432816776,169,305,2028,3660\n2602,Great American Ball Park,Great American Ball Park,30,7.67,346.9855554632523,173,300,2076,3600\n2602,Great American Ball Park,Great American Ball Park,31,7.6,345.5217842004147,178,296,2136,3552\n2602,Great American Ball Park,Great American Ball Park,32,7.68,343.9886997083713,182,292,2184,3504\n2602,Great American Ball Park,Great American Ball Park,33,7.65,342.13198850864757,186,287,2232,3444\n2602,Great American Ball Park,Great American Ball Park,34,7.64,340.3787868432228,190,282,2280,3384\n2602,Great American Ball Park,Great American Ball Park,35,7.64,338.70142096464497,194,277,2328,3324\n2602,Great American Ball Park,Great American Ball Park,36,7.76,337.262530636662,198,273,2376,3276\n2602,Great American Ball Park,Great American Ball Park,37,7.63,335.89705061937394,202,268,2424,3216\n2602,Great American Ball Park,Great American Ball Park,38,7.58,334.576231061173,206,264,2472,3168\n2602,Great American Ball Park,Great American Ball Park,39,7.56,333.5653273939682,210,259,2520,3108\n2602,Great American Ball Park,Great American Ball Park,40,7.56,332.47206756323214,214,255,2568,3060\n2602,Great American Ball Park,Great American Ball Park,41,7.56,331.48659480322044,217,250,2604,3000\n2602,Great American Ball Park,Great American Ball Park,42,7.34,330.283325873463,221,245,2652,2940\n2602,Great American Ball Park,Great American Ball Park,43,7.34,328.0740266504121,224,240,2688,2880\n2602,Great American Ball Park,Great American Ball Park,44,7.34,325.96357170607047,226,234,2712,2808\n2602,Great American Ball Park,Great American Ball Park,45,11.78,324.4045098553994,229,229,2748,2748\n2680,Petco Park,Petco Park,-45,4.39,334.6291889548419,-237,237,-2844,2844\n2680,Petco Park,Petco Park,-44,4.35,333.4439595031788,-232,240,-2784,2880\n2680,Petco Park,Petco Park,-43,4.3,334.38485724506324,-228,245,-2736,2940\n2680,Petco Park,Petco Park,-42,4.3,336.04208205238564,-225,250,-2700,3000\n2680,Petco Park,Petco Park,-41,4.3,337.8192307632739,-222,255,-2664,3060\n2680,Petco Park,Petco Park,-40,4.3,339.7193081690056,-218,260,-2616,3120\n2680,Petco Park,Petco Park,-39,6.15,340.87451897205415,-215,265,-2580,3180\n2680,Petco Park,Petco Park,-38,6.15,341.5558553037296,-210,269,-2520,3228\n2680,Petco Park,Petco Park,-37,6.15,342.34441106392444,-206,273,-2472,3276\n2680,Petco Park,Petco Park,-36,6.15,343.24141295893,-202,278,-2424,3336\n2680,Petco Park,Petco Park,-35,6.15,344.24826463761923,-197,282,-2364,3384\n2680,Petco Park,Petco Park,-34,6.15,345.36655211841554,-193,286,-2316,3432\n2680,Petco Park,Petco Park,-33,6.15,346.59804997996656,-189,291,-2268,3492\n2680,Petco Park,Petco Park,-32,6.15,347.94472836117023,-184,295,-2208,3540\n2680,Petco Park,Petco Park,-31,6.15,349.4087608228621,-180,300,-2160,3600\n2680,Petco Park,Petco Park,-30,6.15,350.99253313077446,-175,304,-2100,3648\n2680,Petco Park,Petco Park,-29,6.15,352.6986530274224,-171,308,-2052,3696\n2680,Petco Park,Petco Park,-28,6.15,354.52996106946733,-166,313,-1992,3756\n2680,Petco Park,Petco Park,-27,6.15,356.48954261699606,-162,318,-1944,3816\n2680,Petco Park,Petco Park,-26,6.15,358.5807410721754,-157,322,-1884,3864\n2680,Petco Park,Petco Park,-25,6.15,360.8071724770809,-152,327,-1824,3924\n2680,Petco Park,Petco Park,-24,6.15,363.1727415943431,-148,332,-1776,3984\n2680,Petco Park,Petco Park,-23,6.15,365.6816596098456,-143,337,-1716,4044\n2680,Petco Park,Petco Park,-22,6.15,368.3384636143106,-138,342,-1656,4104\n2680,Petco Park,Petco Park,-21,6.15,371.14803804053224,-133,346,-1596,4152\n2680,Petco Park,Petco Park,-20,6.15,374.1156382556299,-128,352,-1536,4224\n2680,Petco Park,Petco Park,-19,6.15,377.24691653342336,-123,357,-1476,4284\n2680,Petco Park,Petco Park,-18,6.15,380.5479506613681,-118,362,-1416,4344\n2680,Petco Park,Petco Park,-17,6.15,384.0252754700417,-112,367,-1344,4404\n2680,Petco Park,Petco Park,-16,6.18,386.9590863470438,-107,372,-1284,4464\n2680,Petco Park,Petco Park,-15,6.18,388.8291684275764,-101,376,-1212,4512\n2680,Petco Park,Petco Park,-14,7.17,390.79807829851586,-95,379,-1140,4548\n2680,Petco Park,Petco Park,-13,7.17,392.7860626906658,-88,383,-1056,4596\n2680,Petco Park,Petco Park,-12,7.17,394.9152862844429,-82,386,-984,4632\n2680,Petco Park,Petco Park,-11,7.23,397.013411654497,-76,390,-912,4680\n2680,Petco Park,Petco Park,-10,7.23,395.7624194248915,-69,390,-828,4680\n2680,Petco Park,Petco Park,-9,7.23,394.63911950636003,-62,390,-744,4680\n2680,Petco Park,Petco Park,-8,7.23,393.641745824665,-55,390,-660,4680\n2680,Petco Park,Petco Park,-7,7.23,392.7687403260045,-48,390,-576,4680\n2680,Petco Park,Petco Park,-6,7.23,392.0187469678254,-41,390,-492,4680\n2680,Petco Park,Petco Park,-5,7.23,391.3906065314448,-34,390,-408,4680\n2680,Petco Park,Petco Park,-4,7.23,390.8833522192098,-27,390,-324,4680\n2680,Petco Park,Petco Park,-3,7.24,394.062417752864,-21,394,-252,4728\n2680,Petco Park,Petco Park,-2,7.16,396.2171047277083,-14,396,-168,4752\n2680,Petco Park,Petco Park,-1,7.2,396.504469166977,-7,396,-84,4752\n2680,Petco Park,Petco Park,0,7.13,395.86433748951066,0,396,0,4752\n2680,Petco Park,Petco Park,1,7.16,395.96923920456896,7,396,84,4752\n2680,Petco Park,Petco Park,2,7.16,396.1543522583466,14,396,168,4752\n2680,Petco Park,Petco Park,3,7.16,396.4604606518814,21,396,252,4752\n2680,Petco Park,Petco Park,4,7.16,396.8880318987936,28,396,336,4752\n2680,Petco Park,Petco Park,5,7.16,397.43772047214173,35,396,420,4752\n2680,Petco Park,Petco Park,6,7.16,398.1103702553148,42,396,504,4752\n2680,Petco Park,Petco Park,7,5.2,399.00442018221224,49,396,588,4752\n2680,Petco Park,Petco Park,8,5.3,399.0482456731773,56,395,672,4740\n2680,Petco Park,Petco Park,9,5.3,398.77773830153455,62,394,744,4728\n2680,Petco Park,Petco Park,10,5.3,398.62894140560087,69,393,828,4716\n2680,Petco Park,Petco Park,11,5.3,398.60162813934716,76,391,912,4692\n2680,Petco Park,Petco Park,12,5.3,398.6957568848286,83,390,996,4680\n2680,Petco Park,Petco Park,13,5.3,398.9114710973632,90,389,1080,4668\n2680,Petco Park,Petco Park,14,5.35,397.0783349357856,96,385,1152,4620\n2680,Petco Park,Petco Park,15,5.35,394.9069107668874,102,381,1224,4572\n2680,Petco Park,Petco Park,16,5.35,392.87812991709336,108,378,1296,4536\n2680,Petco Park,Petco Park,17,5.11,390.97052575296294,114,374,1368,4488\n2680,Petco Park,Petco Park,18,7.3,388.66194792733484,120,370,1440,4440\n2680,Petco Park,Petco Park,19,7.3,385.31146252744986,125,364,1500,4368\n2680,Petco Park,Petco Park,20,7.3,382.1336563002842,131,359,1572,4308\n2680,Petco Park,Petco Park,21,7.3,379.1223780919166,136,354,1632,4248\n2680,Petco Park,Petco Park,22,7.3,376.27190752894717,141,349,1692,4188\n2680,Petco Park,Petco Park,23,7.3,373.57692616682675,146,344,1752,4128\n2680,Petco Park,Petco Park,24,7.3,371.0324912931508,151,339,1812,4068\n2680,Petco Park,Petco Park,25,7.3,368.634012130257,156,334,1872,4008\n2680,Petco Park,Petco Park,26,7.3,366.3772282109095,161,329,1932,3948\n2680,Petco Park,Petco Park,27,7.3,364.25818972667844,165,325,1980,3900\n2680,Petco Park,Petco Park,28,7.3,362.2732396713276,170,320,2040,3840\n2680,Petco Park,Petco Park,29,7.3,360.41899762153645,175,315,2100,3780\n2680,Petco Park,Petco Park,30,7.3,358.69234501497317,179,311,2148,3732\n2680,Petco Park,Petco Park,31,7.3,357.09041180140434,184,306,2208,3672\n2680,Petco Park,Petco Park,32,7.3,355.6105643564532,188,302,2256,3624\n2680,Petco Park,Petco Park,33,7.3,354.25039456003094,193,297,2316,3564\n2680,Petco Park,Petco Park,34,7.3,353.00770995256045,197,293,2364,3516\n2680,Petco Park,Petco Park,35,7.3,351.8805248920695,202,288,2424,3456\n2680,Petco Park,Petco Park,36,7.3,350.8670526441947,206,284,2472,3408\n2680,Petco Park,Petco Park,37,7.3,349.96569834524894,211,279,2532,3348\n2680,Petco Park,Petco Park,38,7.3,349.1750527858705,215,275,2580,3300\n2680,Petco Park,Petco Park,39,7.37,343.7844686847697,216,267,2592,3204\n2680,Petco Park,Petco Park,40,9.23,337.62603549079347,217,259,2604,3108\n2680,Petco Park,Petco Park,41,9.23,330.79469993999527,217,250,2604,3000\n2680,Petco Park,Petco Park,42,9.23,324.3311598481089,217,241,2604,2892\n2680,Petco Park,Petco Park,43,9.14,323.22217569390244,220,236,2640,2832\n2680,Petco Park,Petco Park,44,10.45,322.90506688271364,224,232,2688,2784\n2680,Petco Park,Petco Park,45,10.45,321.80944585804644,228,228,2736,2736\n2681,Citizens Bank Park,Citizens Bank Park,-45,10.91,328.3238190074133,-232,232,-2784,2784\n2681,Citizens Bank Park,Citizens Bank Park,-44,9.58,334.2804316048772,-232,240,-2784,2880\n2681,Citizens Bank Park,Citizens Bank Park,-43,9.58,334.4451265901115,-228,245,-2736,2940\n2681,Citizens Bank Park,Citizens Bank Park,-42,9.58,334.7119907128837,-224,249,-2688,2988\n2681,Citizens Bank Park,Citizens Bank Park,-41,9.58,335.08143161321345,-220,253,-2640,3036\n2681,Citizens Bank Park,Citizens Bank Park,-40,9.58,335.55401490766513,-216,257,-2592,3084\n2681,Citizens Bank Park,Citizens Bank Park,-39,9.58,336.1304663081537,-212,261,-2544,3132\n2681,Citizens Bank Park,Citizens Bank Park,-38,9.58,336.8116743524154,-207,265,-2484,3180\n2681,Citizens Bank Park,Citizens Bank Park,-37,9.58,337.59869376534306,-203,270,-2436,3240\n2681,Citizens Bank Park,Citizens Bank Park,-36,9.58,338.49274947499464,-199,274,-2388,3288\n2681,Citizens Bank Park,Citizens Bank Park,-35,9.58,339.4952413119573,-195,278,-2340,3336\n2681,Citizens Bank Park,Citizens Bank Park,-34,9.58,340.60774942595924,-190,282,-2280,3384\n2681,Citizens Bank Park,Citizens Bank Park,-33,9.58,341.8320404592285,-186,287,-2232,3444\n2681,Citizens Bank Park,Citizens Bank Park,-32,9.58,343.17007452216694,-182,291,-2184,3492\n2681,Citizens Bank Park,Citizens Bank Park,-31,9.58,344.6240130235364,-177,295,-2124,3540\n2681,Citizens Bank Park,Citizens Bank Park,-30,9.58,346.19622741460864,-173,300,-2076,3600\n2681,Citizens Bank Park,Citizens Bank Park,-29,9.58,347.889308914733,-169,304,-2028,3648\n2681,Citizens Bank Park,Citizens Bank Park,-28,9.58,349.7060792946324,-164,309,-1968,3708\n2681,Citizens Bank Park,Citizens Bank Park,-27,9.58,351.6496028035745,-160,313,-1920,3756\n2681,Citizens Bank Park,Citizens Bank Park,-26,9.58,353.72319933754807,-155,318,-1860,3816\n2681,Citizens Bank Park,Citizens Bank Park,-25,9.58,355.93045895785747,-150,323,-1800,3876\n2681,Citizens Bank Park,Citizens Bank Park,-24,9.58,358.2752578833496,-146,327,-1752,3924\n2681,Citizens Bank Park,Citizens Bank Park,-23,9.58,360.76177609501997,-141,332,-1692,3984\n2681,Citizens Bank Park,Citizens Bank Park,-22,9.58,363.3945167092974,-136,337,-1632,4044\n2681,Citizens Bank Park,Citizens Bank Park,-21,9.58,366.1783272961655,-131,342,-1572,4104\n2681,Citizens Bank Park,Citizens Bank Park,-20,9.58,369.1184233408402,-126,347,-1512,4164\n2681,Citizens Bank Park,Citizens Bank Park,-19,9.58,372.2204140733804,-121,352,-1452,4224\n2681,Citizens Bank Park,Citizens Bank Park,-18,9.58,375.49033091988633,-116,357,-1392,4284\n2681,Citizens Bank Park,Citizens Bank Park,-17,9.58,378.9346588624207,-111,362,-1332,4344\n2681,Citizens Bank Park,Citizens Bank Park,-16,9.58,382.560371033159,-105,368,-1260,4416\n2681,Citizens Bank Park,Citizens Bank Park,-15,9.58,386.37496691236686,-100,373,-1200,4476\n2681,Citizens Bank Park,Citizens Bank Park,-14,11.93,386.3830080764818,-93,375,-1116,4500\n2681,Citizens Bank Park,Citizens Bank Park,-13,11.93,384.7714054393405,-87,375,-1044,4500\n2681,Citizens Bank Park,Citizens Bank Park,-12,11.93,383.2894596679123,-80,375,-960,4500\n2681,Citizens Bank Park,Citizens Bank Park,-11,12,382.2211417646482,-73,375,-876,4500\n2681,Citizens Bank Park,Citizens Bank Park,-10,12,386.795449138039,-67,381,-804,4572\n2681,Citizens Bank Park,Citizens Bank Park,-9,12,391.6013009783016,-61,387,-732,4644\n2681,Citizens Bank Park,Citizens Bank Park,-8,12,396.6504223422752,-55,393,-660,4716\n2681,Citizens Bank Park,Citizens Bank Park,-7,16.9,401.99415224596584,-49,399,-588,4788\n2681,Citizens Bank Park,Citizens Bank Park,-6,16.9,407.7039103830122,-43,405,-516,4860\n2681,Citizens Bank Park,Citizens Bank Park,-5,5.56,408.51782247264464,-36,407,-432,4884\n2681,Citizens Bank Park,Citizens Bank Park,-4,5.56,406.9000944343413,-28,406,-336,4872\n2681,Citizens Bank Park,Citizens Bank Park,-3,5.56,405.418135428894,-21,405,-252,4860\n2681,Citizens Bank Park,Citizens Bank Park,-2,5.56,404.06956890319856,-14,404,-168,4848\n2681,Citizens Bank Park,Citizens Bank Park,-1,5.56,402.852250132718,-7,403,-84,4836\n2681,Citizens Bank Park,Citizens Bank Park,0,5.56,401.76425773473255,0,402,0,4824\n2681,Citizens Bank Park,Citizens Bank Park,1,5.56,400.80388614717765,7,401,84,4812\n2681,Citizens Bank Park,Citizens Bank Park,2,5.56,399.9696390174073,14,400,168,4800\n2681,Citizens Bank Park,Citizens Bank Park,3,5.56,399.26022345257,21,399,252,4788\n2681,Citizens Bank Park,Citizens Bank Park,4,5.56,398.67454509004267,28,398,336,4776\n2681,Citizens Bank Park,Citizens Bank Park,5,5.56,398.2117039526557,35,397,420,4764\n2681,Citizens Bank Park,Citizens Bank Park,6,5.56,397.8709910593075,42,396,504,4752\n2681,Citizens Bank Park,Citizens Bank Park,7,5.56,397.65188576710443,48,395,576,4740\n2681,Citizens Bank Park,Citizens Bank Park,8,5.56,397.5540538264211,55,394,660,4728\n2681,Citizens Bank Park,Citizens Bank Park,9,5.56,397.5773461353336,62,393,744,4716\n2681,Citizens Bank Park,Citizens Bank Park,10,5.56,397.721798184771,69,392,828,4704\n2681,Citizens Bank Park,Citizens Bank Park,11,12.47,397.49338210614025,76,390,912,4680\n2681,Citizens Bank Park,Citizens Bank Park,12,12.47,392.928838919773,82,384,984,4608\n2681,Citizens Bank Park,Citizens Bank Park,13,12.47,388.5849607186209,87,379,1044,4548\n2681,Citizens Bank Park,Citizens Bank Park,14,12.47,384.45190388471957,93,373,1116,4476\n2681,Citizens Bank Park,Citizens Bank Park,15,12.47,380.52053194987064,98,368,1176,4416\n2681,Citizens Bank Park,Citizens Bank Park,16,12.47,376.78235966791004,104,362,1248,4344\n2681,Citizens Bank Park,Citizens Bank Park,17,12.47,373.2295026033741,109,357,1308,4284\n2681,Citizens Bank Park,Citizens Bank Park,18,12.47,369.85463162978897,114,352,1368,4224\n2681,Citizens Bank Park,Citizens Bank Park,19,12.47,366.65093180705895,119,347,1428,4164\n2681,Citizens Bank Park,Citizens Bank Park,20,12.47,363.61206517316725,124,342,1488,4104\n2681,Citizens Bank Park,Citizens Bank Park,21,12.47,360.73213704219944,129,337,1548,4044\n2681,Citizens Bank Park,Citizens Bank Park,22,12.47,358.00566544991267,134,332,1608,3984\n2681,Citizens Bank Park,Citizens Bank Park,23,12.47,355.4275534308108,139,327,1668,3924\n2681,Citizens Bank Park,Citizens Bank Park,24,12.47,352.99306384788974,144,322,1728,3864\n2681,Citizens Bank Park,Citizens Bank Park,25,12.47,350.69779652868624,148,318,1776,3816\n2681,Citizens Bank Park,Citizens Bank Park,26,12.47,348.53766748966564,153,313,1836,3756\n2681,Citizens Bank Park,Citizens Bank Park,27,12.47,346.50889005588687,157,309,1884,3708\n2681,Citizens Bank Park,Citizens Bank Park,28,12.47,344.60795770477824,162,304,1944,3648\n2681,Citizens Bank Park,Citizens Bank Park,29,12.47,342.83162848214425,166,300,1992,3600\n2681,Citizens Bank Park,Citizens Bank Park,30,12.47,341.1769108555704,171,295,2052,3540\n2681,Citizens Bank Park,Citizens Bank Park,31,12.47,339.6410508854868,175,291,2100,3492\n2681,Citizens Bank Park,Citizens Bank Park,32,12.47,338.22152060756576,179,287,2148,3444\n2681,Citizens Bank Park,Citizens Bank Park,33,12.47,336.91600753207115,183,283,2196,3396\n2681,Citizens Bank Park,Citizens Bank Park,34,12.47,335.72240517645935,188,278,2256,3336\n2681,Citizens Bank Park,Citizens Bank Park,35,12.47,334.63880455711,192,274,2304,3288\n2681,Citizens Bank Park,Citizens Bank Park,36,12.47,333.6634865746798,196,270,2352,3240\n2681,Citizens Bank Park,Citizens Bank Park,37,12.47,332.79491523537445,200,266,2400,3192\n2681,Citizens Bank Park,Citizens Bank Park,38,12.47,332.03173165750144,204,262,2448,3144\n2681,Citizens Bank Park,Citizens Bank Park,39,12.47,331.3727488191348,209,258,2508,3096\n2681,Citizens Bank Park,Citizens Bank Park,40,12.47,330.81694700864153,213,253,2556,3036\n2681,Citizens Bank Park,Citizens Bank Park,41,12.47,330.36346994530436,217,249,2604,2988\n2681,Citizens Bank Park,Citizens Bank Park,42,12.47,330.0116215423604,221,245,2652,2940\n2681,Citizens Bank Park,Citizens Bank Park,43,12.47,329.7608632895537,225,241,2700,2892\n2681,Citizens Bank Park,Citizens Bank Park,44,12.47,329.6108122368076,229,237,2748,2844\n2681,Citizens Bank Park,Citizens Bank Park,45,12.47,329.56123956492803,233,233,2796,2796\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-45,8,320.225986372518,-226,226,-2712,2712\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-44,8,322.3168091437831,-224,232,-2688,2784\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-43,8,324.5346202806131,-221,237,-2652,2844\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-42,8,326.88342544205165,-219,243,-2628,2916\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-41,8,329.3675371712012,-216,249,-2592,2988\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-40,8,331.99159568896414,-213,254,-2556,3048\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-39,8,334.7605917848451,-211,260,-2532,3120\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-38,8,337.67989202860474,-208,266,-2496,3192\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-37,8,338.71501801412666,-204,271,-2448,3252\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-36,8,339.05271227522877,-199,274,-2388,3288\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-35,8,339.4945971091114,-195,278,-2340,3336\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-34,8,340.05857516868576,-190,282,-2280,3384\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-33,12,340.7312385474384,-186,286,-2232,3432\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-32,12,341.4732009703126,-181,290,-2172,3480\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-31,12,342.32290421208245,-176,293,-2112,3516\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-30,12,343.2816744839497,-172,297,-2064,3564\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-29,12,344.35101770616035,-167,301,-2004,3612\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-28,12,345.5326253617194,-162,305,-1944,3660\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-27,12,346.8283811381754,-157,309,-1884,3708\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-26,12,348.2403684068192,-153,313,-1836,3756\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-25,12,349.77087859565387,-148,317,-1776,3804\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-24,12,351.42242052019293,-143,321,-1716,3852\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-23,12,353.1977307446553,-138,325,-1656,3900\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-22,12,355.09978505555796,-133,329,-1596,3948\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-21,12,357.1318111402215,-128,333,-1536,3996\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-20,12,359.2973025744348,-123,338,-1476,4056\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-19,12,361.60003423669644,-118,342,-1416,4104\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-18,12,364.0478994273041,-112,346,-1344,4152\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-17,12,366.6422048600511,-107,351,-1284,4212\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-16,12,369.3870776269284,-102,355,-1224,4260\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-15,12,372.28761727938644,-96,360,-1152,4320\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-14,12,375.3493092229421,-91,364,-1092,4368\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-13,12,378.5780522215272,-85,369,-1020,4428\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-12,12,381.9801887034686,-79,374,-948,4488\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-11,12,385.5625381794444,-74,378,-888,4536\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-10,12,389.33243412451907,-68,383,-816,4596\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-9,12,392.7988108154493,-61,388,-732,4656\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-8,12,394.523952879251,-55,391,-660,4692\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-7,12,396.3855906942783,-48,393,-576,4716\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-6,12,398.38680862475763,-42,396,-504,4752\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-5,12,400.53096074928436,-35,399,-420,4788\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-4,12,402.82168514884023,-28,402,-336,4824\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-3,12,405.2629196703693,-21,405,-252,4860\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-2,12,407.74840794344675,-14,408,-168,4896\n2735,Journey Bank Ballpark,Journey Bank Ballpark,-1,16,409.1898926024473,-7,409,-84,4908\n2735,Journey Bank Ballpark,Journey Bank Ballpark,0,16,410.89986649609773,0,411,0,4932\n2735,Journey Bank Ballpark,Journey Bank Ballpark,1,16,411.16616783919017,7,411,84,4932\n2735,Journey Bank Ballpark,Journey Bank Ballpark,2,16,411.5106928434851,14,411,168,4932\n2735,Journey Bank Ballpark,Journey Bank Ballpark,3,16,410.7302311029315,21,410,252,4920\n2735,Journey Bank Ballpark,Journey Bank Ballpark,4,12,409.59395245919114,29,409,348,4908\n2735,Journey Bank Ballpark,Journey Bank Ballpark,5,12,408.1095452012775,36,407,432,4884\n2735,Journey Bank Ballpark,Journey Bank Ballpark,6,12,406.75931376965605,43,405,516,4860\n2735,Journey Bank Ballpark,Journey Bank Ballpark,7,12,405.54111175759107,49,403,588,4836\n2735,Journey Bank Ballpark,Journey Bank Ballpark,8,12,404.4530171720018,56,401,672,4812\n2735,Journey Bank Ballpark,Journey Bank Ballpark,9,12,403.493324914299,63,399,756,4788\n2735,Journey Bank Ballpark,Journey Bank Ballpark,10,12,402.66054017441866,70,397,840,4764\n2735,Journey Bank Ballpark,Journey Bank Ballpark,11,12,400.91655182721803,76,394,912,4728\n2735,Journey Bank Ballpark,Journey Bank Ballpark,12,12,398.16505996912036,83,389,996,4668\n2735,Journey Bank Ballpark,Journey Bank Ballpark,13,12,395.5707510453766,89,385,1068,4620\n2735,Journey Bank Ballpark,Journey Bank Ballpark,14,12,393.12900624877363,95,381,1140,4572\n2735,Journey Bank Ballpark,Journey Bank Ballpark,15,12,390.83554282690073,101,378,1212,4536\n2735,Journey Bank Ballpark,Journey Bank Ballpark,16,12,388.68639466352073,107,374,1284,4488\n2735,Journey Bank Ballpark,Journey Bank Ballpark,17,12,386.677894639169,113,370,1356,4440\n2735,Journey Bank Ballpark,Journey Bank Ballpark,18,12,384.80665861822854,119,366,1428,4392\n2735,Journey Bank Ballpark,Journey Bank Ballpark,19,12,383.0695709268338,125,362,1500,4344\n2735,Journey Bank Ballpark,Journey Bank Ballpark,20,12,381.46377120114687,130,358,1560,4296\n2735,Journey Bank Ballpark,Journey Bank Ballpark,21,12,379.98664249908364,136,355,1632,4260\n2735,Journey Bank Ballpark,Journey Bank Ballpark,22,12,378.63580058065935,142,351,1704,4212\n2735,Journey Bank Ballpark,Journey Bank Ballpark,23,12,376.5878979645079,147,347,1764,4164\n2735,Journey Bank Ballpark,Journey Bank Ballpark,24,12,374.00123933190855,152,342,1824,4104\n2735,Journey Bank Ballpark,Journey Bank Ballpark,25,12,371.5622814793165,157,337,1884,4044\n2735,Journey Bank Ballpark,Journey Bank Ballpark,26,12,369.2666811015583,162,332,1944,3984\n2735,Journey Bank Ballpark,Journey Bank Ballpark,27,12,367.11041082968416,167,327,2004,3924\n2735,Journey Bank Ballpark,Journey Bank Ballpark,28,12,365.08974096443643,171,322,2052,3864\n2735,Journey Bank Ballpark,Journey Bank Ballpark,29,12,363.2012228832544,176,318,2112,3816\n2735,Journey Bank Ballpark,Journey Bank Ballpark,30,12,361.4416739770739,181,313,2172,3756\n2735,Journey Bank Ballpark,Journey Bank Ballpark,31,12,359.80816398927465,185,308,2220,3696\n2735,Journey Bank Ballpark,Journey Bank Ballpark,32,12,358.29800264342305,190,304,2280,3648\n2735,Journey Bank Ballpark,Journey Bank Ballpark,33,12,356.9087284591942,194,299,2328,3588\n2735,Journey Bank Ballpark,Journey Bank Ballpark,34,12,355.6380986672308,199,295,2388,3540\n2735,Journey Bank Ballpark,Journey Bank Ballpark,35,12,354.4841085905664,203,290,2436,3480\n2735,Journey Bank Ballpark,Journey Bank Ballpark,36,8,353.4502493457582,208,286,2496,3432\n2735,Journey Bank Ballpark,Journey Bank Ballpark,37,8,352.52947471863695,212,282,2544,3384\n2735,Journey Bank Ballpark,Journey Bank Ballpark,38,8,349.1952842300662,215,275,2580,3300\n2735,Journey Bank Ballpark,Journey Bank Ballpark,39,8,345.68117348542404,218,269,2616,3228\n2735,Journey Bank Ballpark,Journey Bank Ballpark,40,8,342.34032746420945,220,262,2640,3144\n2735,Journey Bank Ballpark,Journey Bank Ballpark,41,8,339.16576299913464,223,256,2676,3072\n2735,Journey Bank Ballpark,Journey Bank Ballpark,42,8,336.1509878974835,225,250,2700,3000\n2735,Journey Bank Ballpark,Journey Bank Ballpark,43,8,333.28996491525646,227,244,2724,2928\n2735,Journey Bank Ballpark,Journey Bank Ballpark,44,8,330.57707914626036,230,238,2760,2856\n2735,Journey Bank Ballpark,Journey Bank Ballpark,45,8,328.0071084728183,232,232,2784,2784\n2756,Sahlen Field,Sahlen Field,-45,10.507,325.2439326295804,-230,230,-2760,2760\n2756,Sahlen Field,Sahlen Field,-44,10.501,327.3268119706087,-227,235,-2724,2820\n2756,Sahlen Field,Sahlen Field,-43,10.533,329.2309015225756,-225,241,-2700,2892\n2756,Sahlen Field,Sahlen Field,-42,10.536,331.2064245296585,-222,246,-2664,2952\n2756,Sahlen Field,Sahlen Field,-41,10.536,333.25177241133736,-219,252,-2628,3024\n2756,Sahlen Field,Sahlen Field,-40,10.41,335.348670083797,-216,257,-2592,3084\n2756,Sahlen Field,Sahlen Field,-39,10.41,337.5387698479203,-212,262,-2544,3144\n2756,Sahlen Field,Sahlen Field,-38,10.33,339.83223258440813,-209,268,-2508,3216\n2756,Sahlen Field,Sahlen Field,-37,10.33,342.26125668663155,-206,273,-2472,3276\n2756,Sahlen Field,Sahlen Field,-36,10.539,344.6682166713182,-203,279,-2436,3348\n2756,Sahlen Field,Sahlen Field,-35,10.539,347.1875331775033,-199,284,-2388,3408\n2756,Sahlen Field,Sahlen Field,-34,10.496,349.7240981461116,-196,290,-2352,3480\n2756,Sahlen Field,Sahlen Field,-33,10.496,352.338552184451,-192,295,-2304,3540\n2756,Sahlen Field,Sahlen Field,-32,10.433,355.04920176303546,-188,301,-2256,3612\n2756,Sahlen Field,Sahlen Field,-31,10.548,357.8497809527948,-184,307,-2208,3684\n2756,Sahlen Field,Sahlen Field,-30,10.548,360.636576482465,-180,312,-2160,3744\n2756,Sahlen Field,Sahlen Field,-29,10.548,363.5787365048494,-176,318,-2112,3816\n2756,Sahlen Field,Sahlen Field,-28,7.103,364.6848635252796,-171,322,-2052,3864\n2756,Sahlen Field,Sahlen Field,-27,7.103,364.8102059827188,-166,325,-1992,3900\n2756,Sahlen Field,Sahlen Field,-26,7.103,365.0468696747308,-160,328,-1920,3936\n2756,Sahlen Field,Sahlen Field,-25,7.103,365.3952158031488,-154,331,-1848,3972\n2756,Sahlen Field,Sahlen Field,-24,7.103,365.8557770455771,-149,334,-1788,4008\n2756,Sahlen Field,Sahlen Field,-23,7.103,366.42925954730566,-143,337,-1716,4044\n2756,Sahlen Field,Sahlen Field,-22,7.103,367.11654557212535,-138,340,-1656,4080\n2756,Sahlen Field,Sahlen Field,-21,7.103,367.918696830631,-132,343,-1584,4116\n2756,Sahlen Field,Sahlen Field,-20,7.103,368.8369585094988,-126,347,-1512,4164\n2756,Sahlen Field,Sahlen Field,-19,7.103,369.87276403039414,-120,350,-1440,4200\n2756,Sahlen Field,Sahlen Field,-18,7.103,371.02774057266254,-115,353,-1380,4236\n2756,Sahlen Field,Sahlen Field,-17,7.103,372.3037153998535,-109,356,-1308,4272\n2756,Sahlen Field,Sahlen Field,-16,7.103,373.70272303649176,-103,359,-1236,4308\n2756,Sahlen Field,Sahlen Field,-15,7.103,375.22701334843424,-97,362,-1164,4344\n2756,Sahlen Field,Sahlen Field,-14,7.103,376.87906058771796,-91,366,-1092,4392\n2756,Sahlen Field,Sahlen Field,-13,7.103,378.6615734711247,-85,369,-1020,4428\n2756,Sahlen Field,Sahlen Field,-12,7.103,380.5775063708769,-79,372,-948,4464\n2756,Sahlen Field,Sahlen Field,-11,7.103,382.6300717060711,-73,376,-876,4512\n2756,Sahlen Field,Sahlen Field,-10,7.103,384.8227536348084,-67,379,-804,4548\n2756,Sahlen Field,Sahlen Field,-9,7.103,387.15932315965915,-61,382,-732,4584\n2756,Sahlen Field,Sahlen Field,-8,7.103,389.64385477332485,-54,386,-648,4632\n2756,Sahlen Field,Sahlen Field,-7,7.103,392.28074478734726,-48,389,-576,4668\n2756,Sahlen Field,Sahlen Field,-6,7.103,395.0747315047512,-41,393,-492,4716\n2756,Sahlen Field,Sahlen Field,-5,7.103,398.0309174179009,-35,397,-420,4764\n2756,Sahlen Field,Sahlen Field,-4,7.103,401.1547936359706,-28,400,-336,4800\n2756,Sahlen Field,Sahlen Field,-3,7.103,404.4522667727103,-21,404,-252,4848\n2756,Sahlen Field,Sahlen Field,-2,7.038,401.93443173844804,-14,402,-168,4824\n2756,Sahlen Field,Sahlen Field,-1,7.038,399.07158512403515,-7,399,-84,4788\n2756,Sahlen Field,Sahlen Field,0,7.038,396.36911629162375,0,396,0,4752\n2756,Sahlen Field,Sahlen Field,1,7.038,393.82215804575003,7,394,84,4728\n2756,Sahlen Field,Sahlen Field,2,7.038,391.4261938619336,14,391,168,4692\n2756,Sahlen Field,Sahlen Field,3,7.038,389.1770371017909,20,389,240,4668\n2756,Sahlen Field,Sahlen Field,4,7.038,387.07081212723523,27,386,324,4632\n2756,Sahlen Field,Sahlen Field,5,7.038,385.1039371474348,34,384,408,4608\n2756,Sahlen Field,Sahlen Field,6,7.038,383.27310865085616,40,381,480,4572\n2756,Sahlen Field,Sahlen Field,7,7.038,381.5752872912471,47,379,564,4548\n2756,Sahlen Field,Sahlen Field,8,7.038,380.00768511111414,53,376,636,4512\n2756,Sahlen Field,Sahlen Field,9,7.038,378.5677539993439,59,374,708,4488\n2756,Sahlen Field,Sahlen Field,10,7.038,377.25317529133866,66,372,792,4464\n2756,Sahlen Field,Sahlen Field,11,7.038,376.0618504305553,72,369,864,4428\n2756,Sahlen Field,Sahlen Field,12,7.038,374.991892619809,78,367,936,4404\n2756,Sahlen Field,Sahlen Field,13,7.038,374.04161939928093,84,364,1008,4368\n2756,Sahlen Field,Sahlen Field,14,7.038,373.2095460959615,90,362,1080,4344\n2756,Sahlen Field,Sahlen Field,15,7.038,372.49438009638635,96,360,1152,4320\n2756,Sahlen Field,Sahlen Field,16,7.038,371.8950159010639,103,357,1236,4284\n2756,Sahlen Field,Sahlen Field,17,7.038,371.41053092505325,109,355,1308,4260\n2756,Sahlen Field,Sahlen Field,18,7.038,371.0401820147897,115,353,1380,4236\n2756,Sahlen Field,Sahlen Field,19,7.038,370.7834026565523,121,351,1452,4212\n2756,Sahlen Field,Sahlen Field,20,7.038,370.639800856984,127,348,1524,4176\n2756,Sahlen Field,Sahlen Field,21,7.038,370.6091576808682,133,346,1596,4152\n2756,Sahlen Field,Sahlen Field,22,7.038,370.6914264359947,139,344,1668,4128\n2756,Sahlen Field,Sahlen Field,23,7.038,370.88673249945884,145,341,1740,4092\n2756,Sahlen Field,Sahlen Field,24,7.038,371.19537378419295,151,339,1812,4068\n2756,Sahlen Field,Sahlen Field,25,7.175,371.1814508073173,157,336,1884,4032\n2756,Sahlen Field,Sahlen Field,26,7.175,367.48546011403556,161,330,1932,3960\n2756,Sahlen Field,Sahlen Field,27,7.175,363.97212477579524,165,324,1980,3888\n2756,Sahlen Field,Sahlen Field,28,7.175,360.63414392445543,169,318,2028,3816\n2756,Sahlen Field,Sahlen Field,29,7.175,357.46472948062575,173,313,2076,3756\n2756,Sahlen Field,Sahlen Field,30,7.175,354.45756875602535,177,307,2124,3684\n2756,Sahlen Field,Sahlen Field,31,7.175,351.60679059145804,181,301,2172,3612\n2756,Sahlen Field,Sahlen Field,32,7.175,348.9069346663763,185,296,2220,3552\n2756,Sahlen Field,Sahlen Field,33,7.175,346.3529236595418,189,290,2268,3480\n2756,Sahlen Field,Sahlen Field,34,7.175,343.9400379781709,192,285,2304,3420\n2756,Sahlen Field,Sahlen Field,35,7.175,341.6638928059758,196,280,2352,3360\n2756,Sahlen Field,Sahlen Field,36,7.175,339.52041724937857,200,275,2400,3300\n2756,Sahlen Field,Sahlen Field,37,7.175,337.50583538646697,203,270,2436,3240\n2756,Sahlen Field,Sahlen Field,38,7.175,335.61664904547735,207,264,2484,3168\n2756,Sahlen Field,Sahlen Field,39,7.175,333.84962215914226,210,259,2520,3108\n2756,Sahlen Field,Sahlen Field,40,7.175,332.2017665585115,214,254,2568,3048\n2756,Sahlen Field,Sahlen Field,41,6.649,330.9561523334919,217,250,2604,3000\n2756,Sahlen Field,Sahlen Field,42,6.649,329.9920254870584,221,245,2652,2940\n2756,Sahlen Field,Sahlen Field,43,6.438,328.7433759276276,224,240,2688,2880\n2756,Sahlen Field,Sahlen Field,44,6.438,327.2242877447453,227,235,2724,2820\n2756,Sahlen Field,Sahlen Field,45,10.103,325.0640672651778,230,230,2760,2760\n2889,Busch Stadium,Busch Stadium,-45,7.43,334.8036231250652,-237,237,-2844,2844\n2889,Busch Stadium,Busch Stadium,-44,7.43,344.6457411762276,-239,248,-2868,2976\n2889,Busch Stadium,Busch Stadium,-43,7.41,351.09767019857486,-239,257,-2868,3084\n2889,Busch Stadium,Busch Stadium,-42,7.41,351.3691722942565,-235,261,-2820,3132\n2889,Busch Stadium,Busch Stadium,-41,7.41,351.74832348370813,-231,265,-2772,3180\n2889,Busch Stadium,Busch Stadium,-40,7.41,352.2357041274931,-226,270,-2712,3240\n2889,Busch Stadium,Busch Stadium,-39,7.41,352.83206245853927,-222,274,-2664,3288\n2889,Busch Stadium,Busch Stadium,-38,7.41,353.53831739623797,-218,279,-2616,3348\n2889,Busch Stadium,Busch Stadium,-37,7.41,354.35556202105323,-213,283,-2556,3396\n2889,Busch Stadium,Busch Stadium,-36,7.41,355.28506773423413,-209,287,-2508,3444\n2889,Busch Stadium,Busch Stadium,-35,7.41,356.32828913231884,-204,292,-2448,3504\n2889,Busch Stadium,Busch Stadium,-34,7.41,357.4868696315563,-200,296,-2400,3552\n2889,Busch Stadium,Busch Stadium,-33,7.41,358.7626478832203,-195,301,-2340,3612\n2889,Busch Stadium,Busch Stadium,-32,7.41,360.15766502712506,-191,305,-2292,3660\n2889,Busch Stadium,Busch Stadium,-31,7.41,361.67417283755134,-186,310,-2232,3720\n2889,Busch Stadium,Busch Stadium,-30,7.43,363.5424573291633,-182,315,-2184,3780\n2889,Busch Stadium,Busch Stadium,-29,7.43,365.32151622114293,-177,320,-2124,3840\n2889,Busch Stadium,Busch Stadium,-28,7.43,367.23048508817374,-172,324,-2064,3888\n2889,Busch Stadium,Busch Stadium,-27,7.43,369.2725840641287,-168,329,-2016,3948\n2889,Busch Stadium,Busch Stadium,-26,7.43,371.45130186535897,-163,334,-1956,4008\n2889,Busch Stadium,Busch Stadium,-25,7.43,373.7704110501934,-158,339,-1896,4068\n2889,Busch Stadium,Busch Stadium,-24,7.43,376.2339848271458,-153,344,-1836,4128\n2889,Busch Stadium,Busch Stadium,-23,7.43,378.84641555769133,-148,349,-1776,4188\n2889,Busch Stadium,Busch Stadium,-22,7.43,381.6124351179184,-143,354,-1716,4248\n2889,Busch Stadium,Busch Stadium,-21,7.43,384.5371373042494,-138,359,-1656,4308\n2889,Busch Stadium,Busch Stadium,-20,7.43,387.626002492133,-133,364,-1596,4368\n2889,Busch Stadium,Busch Stadium,-19,7.45,390.48141225033874,-127,369,-1524,4428\n2889,Busch Stadium,Busch Stadium,-18,7.4,390.40054370387725,-121,371,-1452,4452\n2889,Busch Stadium,Busch Stadium,-17,7.4,390.47083138157734,-114,373,-1368,4476\n2889,Busch Stadium,Busch Stadium,-16,7.4,390.6601646719814,-108,376,-1296,4512\n2889,Busch Stadium,Busch Stadium,-15,7.4,390.9688323291003,-101,378,-1212,4536\n2889,Busch Stadium,Busch Stadium,-14,7.4,391.3973058256734,-95,380,-1140,4560\n2889,Busch Stadium,Busch Stadium,-13,7.4,391.9462411133275,-88,382,-1056,4584\n2889,Busch Stadium,Busch Stadium,-12,7.4,392.6164810795371,-82,384,-984,4608\n2889,Busch Stadium,Busch Stadium,-11,7.4,393.40905871856654,-75,386,-900,4632\n2889,Busch Stadium,Busch Stadium,-10,7.4,394.3252010386907,-68,388,-816,4656\n2889,Busch Stadium,Busch Stadium,-9,7.4,395.36633373335764,-62,390,-744,4680\n2889,Busch Stadium,Busch Stadium,-8,7.4,396.5340866496533,-55,393,-660,4716\n2889,Busch Stadium,Busch Stadium,-7,7.4,397.83030009349295,-48,395,-576,4740\n2889,Busch Stadium,Busch Stadium,-6,7.4,399.25703201750486,-42,397,-504,4764\n2889,Busch Stadium,Busch Stadium,-5,7.4,400.8165661446478,-35,399,-420,4788\n2889,Busch Stadium,Busch Stadium,-4,7.37,400.5125415892391,-28,400,-336,4800\n2889,Busch Stadium,Busch Stadium,-3,7.37,400.09976577132886,-21,400,-252,4800\n2889,Busch Stadium,Busch Stadium,-2,7.37,399.80950036788266,-14,400,-168,4800\n2889,Busch Stadium,Busch Stadium,-1,7.37,399.64130218383224,-7,400,-84,4800\n2889,Busch Stadium,Busch Stadium,0,7.37,399.59491475704834,0,400,0,4800\n2889,Busch Stadium,Busch Stadium,1,7.37,399.67026740333847,7,400,84,4800\n2889,Busch Stadium,Busch Stadium,2,7.37,399.86747495348357,14,400,168,4800\n2889,Busch Stadium,Busch Stadium,3,7.37,400.18683818049226,21,400,252,4800\n2889,Busch Stadium,Busch Stadium,4,7.37,400.6288449200324,28,400,336,4800\n2889,Busch Stadium,Busch Stadium,5,7.34,400.9871204994837,35,399,420,4788\n2889,Busch Stadium,Busch Stadium,6,7.34,399.43627916141503,42,397,504,4764\n2889,Busch Stadium,Busch Stadium,7,7.34,398.01816063813305,49,395,588,4740\n2889,Busch Stadium,Busch Stadium,8,7.34,396.7304964071159,55,393,660,4716\n2889,Busch Stadium,Busch Stadium,9,7.34,395.571243250567,62,391,744,4692\n2889,Busch Stadium,Busch Stadium,10,7.34,394.5385751965006,69,389,828,4668\n2889,Busch Stadium,Busch Stadium,11,7.34,393.63087639209385,75,386,900,4632\n2889,Busch Stadium,Busch Stadium,12,7.34,392.84673485676575,82,384,984,4608\n2889,Busch Stadium,Busch Stadium,13,7.34,392.1849370694812,88,382,1056,4584\n2889,Busch Stadium,Busch Stadium,14,7.34,391.6444633512839,95,380,1140,4560\n2889,Busch Stadium,Busch Stadium,15,7.34,391.2244840101084,101,378,1212,4536\n2889,Busch Stadium,Busch Stadium,16,7.34,390.924356220587,108,376,1296,4512\n2889,Busch Stadium,Busch Stadium,17,7.34,390.74362161692335,114,374,1368,4488\n2889,Busch Stadium,Busch Stadium,18,7.34,390.6820045820086,121,372,1452,4464\n2889,Busch Stadium,Busch Stadium,19,7.35,390.59393311950674,127,369,1524,4428\n2889,Busch Stadium,Busch Stadium,20,7.44,387.9775954266341,133,365,1596,4380\n2889,Busch Stadium,Busch Stadium,21,7.44,384.8928201994561,138,359,1656,4308\n2889,Busch Stadium,Busch Stadium,22,7.44,381.9721461791228,143,354,1716,4248\n2889,Busch Stadium,Busch Stadium,23,7.44,379.21010525556613,148,349,1776,4188\n2889,Busch Stadium,Busch Stadium,24,7.44,376.6016151468032,153,344,1836,4128\n2889,Busch Stadium,Busch Stadium,25,7.44,374.14195482291456,158,339,1896,4068\n2889,Busch Stadium,Busch Stadium,26,7.44,371.82674217517337,163,334,1956,4008\n2889,Busch Stadium,Busch Stadium,27,7.44,369.6519137223763,168,329,2016,3948\n2889,Busch Stadium,Busch Stadium,28,7.44,367.6137061700179,173,325,2076,3900\n2889,Busch Stadium,Busch Stadium,29,7.44,365.7086396587407,177,320,2124,3840\n2889,Busch Stadium,Busch Stadium,30,7.44,363.93350255684874,182,315,2184,3780\n2889,Busch Stadium,Busch Stadium,31,7.44,362.2853376679375,187,311,2244,3732\n2889,Busch Stadium,Busch Stadium,32,7.44,360.7614297391304,191,306,2292,3672\n2889,Busch Stadium,Busch Stadium,33,7.44,359.35929416827247,196,301,2352,3612\n2889,Busch Stadium,Busch Stadium,34,7.44,358.0766668199301,200,297,2400,3564\n2889,Busch Stadium,Busch Stadium,35,7.44,356.9114948703417,205,292,2460,3504\n2889,Busch Stadium,Busch Stadium,36,7.44,355.86192861074437,209,288,2508,3456\n2889,Busch Stadium,Busch Stadium,37,7.44,354.926314146875,214,283,2568,3396\n2889,Busch Stadium,Busch Stadium,38,7.44,354.10318694005264,218,279,2616,3348\n2889,Busch Stadium,Busch Stadium,39,7.44,353.3912661421867,222,275,2664,3300\n2889,Busch Stadium,Busch Stadium,40,7.44,352.78944968341995,227,270,2724,3240\n2889,Busch Stadium,Busch Stadium,41,7.44,352.29681007699503,231,266,2772,3192\n2889,Busch Stadium,Busch Stadium,42,7.34,349.08595527901684,234,259,2808,3108\n2889,Busch Stadium,Busch Stadium,43,7.34,344.11301814673084,235,252,2820,3024\n2889,Busch Stadium,Busch Stadium,44,7.34,339.3817028189228,236,244,2832,2928\n2889,Busch Stadium,Busch Stadium,45,7.34,334.8793514977192,237,237,2844,2844\n3289,Citi Field,Citi Field,-45,8.21,334.3487393880915,-236,236,-2832,2832\n3289,Citi Field,Citi Field,-44,8.21,336.3079898703689,-234,242,-2808,2904\n3289,Citi Field,Citi Field,-43,8.21,338.3940234138192,-231,247,-2772,2964\n3289,Citi Field,Citi Field,-42,8.21,340.61049758336264,-228,253,-2736,3036\n3289,Citi Field,Citi Field,-41,8.21,342.9613570497076,-225,259,-2700,3108\n3289,Citi Field,Citi Field,-40,8.21,345.4508518311571,-222,265,-2664,3180\n3289,Citi Field,Citi Field,-39,8.21,348.0835573665992,-219,271,-2628,3252\n3289,Citi Field,Citi Field,-38,8.21,350.86439660628446,-216,276,-2592,3312\n3289,Citi Field,Citi Field,-37,8.21,353.79866433106116,-213,283,-2556,3396\n3289,Citi Field,Citi Field,-36,8.21,356.8920539382023,-210,289,-2520,3468\n3289,Citi Field,Citi Field,-35,8.16,356.9856032964646,-205,292,-2460,3504\n3289,Citi Field,Citi Field,-34,8.16,356.9913898222675,-200,296,-2400,3552\n3289,Citi Field,Citi Field,-33,8.16,357.1059562325518,-194,299,-2328,3588\n3289,Citi Field,Citi Field,-32,8.16,357.3294771627924,-189,303,-2268,3636\n3289,Citi Field,Citi Field,-31,7.8,357.46889244853855,-184,306,-2208,3672\n3289,Citi Field,Citi Field,-30,7.8,357.5721684231521,-179,310,-2148,3720\n3289,Citi Field,Citi Field,-29,7.8,357.7845202162577,-173,313,-2076,3756\n3289,Citi Field,Citi Field,-28,7.8,358.1062718374245,-168,316,-2016,3792\n3289,Citi Field,Citi Field,-27,7.8,358.53791510036655,-163,319,-1956,3828\n3289,Citi Field,Citi Field,-26,7.8,359.08011146097857,-157,323,-1884,3876\n3289,Citi Field,Citi Field,-25,7.8,359.7336944984718,-152,326,-1824,3912\n3289,Citi Field,Citi Field,-24,7.8,360.49967305698885,-147,329,-1764,3948\n3289,Citi Field,Citi Field,-23,7.8,361.37923506984066,-141,333,-1692,3996\n3289,Citi Field,Citi Field,-22,7.8,362.3737520935201,-136,336,-1632,4032\n3289,Citi Field,Citi Field,-21,7.8,363.48478458397796,-130,339,-1560,4068\n3289,Citi Field,Citi Field,-20,7.8,364.7140879533461,-125,343,-1500,4116\n3289,Citi Field,Citi Field,-19,7.8,366.06361945144835,-119,346,-1428,4152\n3289,Citi Field,Citi Field,-18,7.8,367.5355459231181,-114,350,-1368,4200\n3289,Citi Field,Citi Field,-17,7.8,369.13225249964046,-108,353,-1296,4236\n3289,Citi Field,Citi Field,-16,7.78,371.0446012842231,-102,357,-1224,4284\n3289,Citi Field,Citi Field,-15,7.78,373.34459905373706,-97,361,-1164,4332\n3289,Citi Field,Citi Field,-14,7.78,375.7884715063835,-91,365,-1092,4380\n3289,Citi Field,Citi Field,-13,7.78,378.3805672359964,-85,369,-1020,4428\n3289,Citi Field,Citi Field,-12,7.78,381.1255714995783,-79,373,-948,4476\n3289,Citi Field,Citi Field,-11,7.78,384.02852834035866,-73,377,-876,4524\n3289,Citi Field,Citi Field,-10,7.78,387.0948649346501,-67,381,-804,4572\n3289,Citi Field,Citi Field,-9,7.78,390.3304183946239,-61,386,-732,4632\n3289,Citi Field,Citi Field,-8,7.78,393.7414652893683,-55,390,-660,4680\n3289,Citi Field,Citi Field,-7,7.78,397.3347541811776,-48,394,-576,4728\n3289,Citi Field,Citi Field,-6,7.78,401.11754151363806,-42,399,-504,4788\n3289,Citi Field,Citi Field,-5,7.78,405.09763123359426,-35,404,-420,4848\n3289,Citi Field,Citi Field,-4,7.86,408.4595345294221,-28,407,-336,4884\n3289,Citi Field,Citi Field,-3,7.86,408.0091732384976,-21,407,-252,4884\n3289,Citi Field,Citi Field,-2,7.86,407.6838516542888,-14,407,-168,4884\n3289,Citi Field,Citi Field,-1,7.86,407.48307284175485,-7,407,-84,4884\n3289,Citi Field,Citi Field,0,7.86,407.4065305819692,0,407,0,4884\n3289,Citi Field,Citi Field,1,7.86,407.45410823140537,7,407,84,4884\n3289,Citi Field,Citi Field,2,7.86,407.62587828793846,14,407,168,4884\n3289,Citi Field,Citi Field,3,7.86,407.9221026605565,21,407,252,4884\n3289,Citi Field,Citi Field,4,7.87,407.1904994390593,28,406,336,4872\n3289,Citi Field,Citi Field,5,7.87,403.690623177639,35,402,420,4824\n3289,Citi Field,Citi Field,6,7.87,400.3713160169849,42,398,504,4776\n3289,Citi Field,Citi Field,7,7.87,397.2261612072646,48,394,576,4728\n3289,Citi Field,Citi Field,8,7.57,394.27525186152263,55,390,660,4680\n3289,Citi Field,Citi Field,9,7.57,391.56071204241806,61,387,732,4644\n3289,Citi Field,Citi Field,10,7.53,388.91498063716784,68,383,816,4596\n3289,Citi Field,Citi Field,11,7.53,386.36584986330814,74,379,888,4548\n3289,Citi Field,Citi Field,12,7.53,383.96611606218437,80,376,960,4512\n3289,Citi Field,Citi Field,13,7.53,381.7115632618445,86,372,1032,4464\n3289,Citi Field,Citi Field,14,7.53,379.59828657687865,92,368,1104,4416\n3289,Citi Field,Citi Field,15,7.53,377.6226748044641,98,365,1176,4380\n3289,Citi Field,Citi Field,16,7.53,375.78139462378346,104,361,1248,4332\n3289,Citi Field,Citi Field,17,7.53,374.07137626464163,109,358,1308,4296\n3289,Citi Field,Citi Field,18,7.53,372.489800526131,115,354,1380,4248\n3289,Citi Field,Citi Field,19,7.58,371.0525783124054,121,351,1452,4212\n3289,Citi Field,Citi Field,20,7.58,369.7610982718115,126,347,1512,4164\n3289,Citi Field,Citi Field,21,7.58,368.59046405515215,132,344,1584,4128\n3289,Citi Field,Citi Field,22,7.51,367.5571511135416,138,341,1656,4092\n3289,Citi Field,Citi Field,23,7.51,368.8302208725463,144,340,1728,4080\n3289,Citi Field,Citi Field,24,7.51,370.22530625982006,151,338,1812,4056\n3289,Citi Field,Citi Field,25,7.51,371.74465238867214,157,337,1884,4044\n3289,Citi Field,Citi Field,26,7.62,371.1592877739684,163,334,1956,4008\n3289,Citi Field,Citi Field,27,9.77,367.5205376245675,167,327,2004,3924\n3289,Citi Field,Citi Field,28,9.77,364.1971159648641,171,322,2052,3864\n3289,Citi Field,Citi Field,29,9.77,361.0422532255196,175,316,2100,3792\n3289,Citi Field,Citi Field,30,9.77,358.04970790616613,179,310,2148,3720\n3289,Citi Field,Citi Field,31,9.77,355.2136750359405,183,304,2196,3648\n3289,Citi Field,Citi Field,32,9.77,352.52875608315395,187,299,2244,3588\n3289,Citi Field,Citi Field,33,9.77,349.98993165348264,191,294,2292,3528\n3289,Citi Field,Citi Field,34,9.77,347.59253670207187,194,288,2328,3456\n3289,Citi Field,Citi Field,35,9.77,345.33223801691895,198,283,2376,3396\n3289,Citi Field,Citi Field,36,9.77,343.2050137588768,202,278,2424,3336\n3289,Citi Field,Citi Field,37,9.77,341.20713486814293,205,273,2460,3276\n3289,Citi Field,Citi Field,38,9.77,339.33514816866153,209,267,2508,3204\n3289,Citi Field,Citi Field,39,9.77,337.5858610208635,212,262,2544,3144\n3289,Citi Field,Citi Field,40,9.77,335.9563273899555,216,257,2592,3084\n3289,Citi Field,Citi Field,41,9.77,334.44383521183414,219,252,2628,3024\n3289,Citi Field,Citi Field,42,9.77,333.0458949519123,223,248,2676,2976\n3289,Citi Field,Citi Field,43,9.77,331.7602292639077,226,243,2712,2916\n3289,Citi Field,Citi Field,44,9.77,330.5847636661625,230,238,2760,2856\n3289,Citi Field,Citi Field,45,9.77,329.5176181624932,233,233,2796,2796\n3309,Nationals Park,Nationals Park,-45,8.61,336.34141986110876,-238,238,-2856,2856\n3309,Nationals Park,Nationals Park,-44,8.61,337.8498269388515,-235,243,-2820,2916\n3309,Nationals Park,Nationals Park,-43,8.61,339.4756980559532,-232,248,-2784,2976\n3309,Nationals Park,Nationals Park,-42,8.61,341.2217356185923,-228,254,-2736,3048\n3309,Nationals Park,Nationals Park,-41,8.61,343.09087606068,-225,259,-2700,3108\n3309,Nationals Park,Nationals Park,-40,8.61,345.0863024123004,-222,264,-2664,3168\n3309,Nationals Park,Nationals Park,-39,8.61,347.2114581609822,-219,270,-2628,3240\n3309,Nationals Park,Nationals Park,-38,8.61,349.4700625228373,-215,275,-2580,3300\n3309,Nationals Park,Nationals Park,-37,8.61,351.86612725535616,-212,281,-2544,3372\n3309,Nationals Park,Nationals Park,-36,8.61,354.40397516030225,-208,287,-2496,3444\n3309,Nationals Park,Nationals Park,-35,8.61,357.088260443989,-205,293,-2460,3516\n3309,Nationals Park,Nationals Park,-34,8.61,359.92399112359783,-201,298,-2412,3576\n3309,Nationals Park,Nationals Park,-33,8.61,362.91655369251066,-198,304,-2376,3648\n3309,Nationals Park,Nationals Park,-32,8.61,366.07174028534257,-194,310,-2328,3720\n3309,Nationals Park,Nationals Park,-31,8.7,368.144906351542,-190,316,-2280,3792\n3309,Nationals Park,Nationals Park,-30,8.7,367.9392715122365,-184,319,-2208,3828\n3309,Nationals Park,Nationals Park,-29,7.67,370.60746016092736,-180,324,-2160,3888\n3309,Nationals Park,Nationals Park,-28,7.67,370.66003007360615,-174,327,-2088,3924\n3309,Nationals Park,Nationals Park,-27,7.67,370.82558799364415,-168,330,-2016,3960\n3309,Nationals Park,Nationals Park,-26,7.67,371.10438637962454,-163,334,-1956,4008\n3309,Nationals Park,Nationals Park,-25,7.67,371.4968509818948,-157,337,-1884,4044\n3309,Nationals Park,Nationals Park,-24,7.67,372.0035824314908,-151,340,-1812,4080\n3309,Nationals Park,Nationals Park,-23,7.67,372.62535848882726,-146,343,-1752,4116\n3309,Nationals Park,Nationals Park,-22,7.67,373.36313696786374,-140,346,-1680,4152\n3309,Nationals Park,Nationals Park,-21,7.67,374.2180593562949,-134,349,-1608,4188\n3309,Nationals Park,Nationals Park,-20,7.67,375.1914551573718,-128,353,-1536,4236\n3309,Nationals Park,Nationals Park,-19,7.67,376.28484698432544,-123,356,-1476,4272\n3309,Nationals Park,Nationals Park,-18,7.67,377.49995644407454,-117,359,-1404,4308\n3309,Nationals Park,Nationals Park,-17,7.67,378.8387108530489,-111,362,-1332,4344\n3309,Nationals Park,Nationals Park,-16,7.67,380.3032508346071,-105,366,-1260,4392\n3309,Nationals Park,Nationals Park,-15,7.67,381.8959388547743,-99,369,-1188,4428\n3309,Nationals Park,Nationals Park,-14,8.7,382.7960176084653,-93,371,-1116,4452\n3309,Nationals Park,Nationals Park,-13,8.71,377.6720495902664,-85,368,-1020,4416\n3309,Nationals Park,Nationals Park,-12,8.74,379.2638381269348,-79,371,-948,4452\n3309,Nationals Park,Nationals Park,-11,8.74,381.3574684267039,-73,374,-876,4488\n3309,Nationals Park,Nationals Park,-10,8.74,383.5918361364088,-67,378,-804,4536\n3309,Nationals Park,Nationals Park,-9,8.74,385.9708037546799,-60,381,-720,4572\n3309,Nationals Park,Nationals Park,-8,8.74,388.4985423020804,-54,385,-648,4620\n3309,Nationals Park,Nationals Park,-7,8.74,391.17955022314015,-48,388,-576,4656\n3309,Nationals Park,Nationals Park,-6,8.74,394.0186741878885,-41,392,-492,4704\n3309,Nationals Park,Nationals Park,-5,8.74,397.02113198152836,-35,396,-420,4752\n3309,Nationals Park,Nationals Park,-4,8.74,400.1925376950171,-28,399,-336,4788\n3309,Nationals Park,Nationals Park,-3,8.74,403.5389294567795,-21,403,-252,4836\n3309,Nationals Park,Nationals Park,-2,8.74,407.0667999770731,-14,407,-168,4884\n3309,Nationals Park,Nationals Park,-1,7.23,405.3757939722664,-7,405,-84,4860\n3309,Nationals Park,Nationals Park,0,6.96,401.6099997547863,0,402,0,4824\n3309,Nationals Park,Nationals Park,1,6.96,398.7802842704679,7,399,84,4788\n3309,Nationals Park,Nationals Park,2,6.96,396.10998046798017,14,396,168,4752\n3309,Nationals Park,Nationals Park,3,6.96,393.5942956044505,21,393,252,4716\n3309,Nationals Park,Nationals Park,4,6.96,391.22878318357454,27,390,324,4680\n3309,Nationals Park,Nationals Park,5,6.96,389.0093225833266,34,388,408,4656\n3309,Nationals Park,Nationals Park,6,13.31,386.7567051120318,40,385,480,4620\n3309,Nationals Park,Nationals Park,7,13.31,384.6624269353233,47,382,564,4584\n3309,Nationals Park,Nationals Park,8,13.31,382.70665583195415,53,379,636,4548\n3309,Nationals Park,Nationals Park,9,13.31,380.88610658535885,60,376,720,4512\n3309,Nationals Park,Nationals Park,10,14.14,379.3040601411165,66,374,792,4488\n3309,Nationals Park,Nationals Park,11,14.14,377.71497656292934,72,371,864,4452\n3309,Nationals Park,Nationals Park,12,14.14,376.2532845178088,78,368,936,4416\n3309,Nationals Park,Nationals Park,13,14.14,374.9166248487248,84,365,1008,4380\n3309,Nationals Park,Nationals Park,14,14.14,373.70285921132654,90,363,1080,4356\n3309,Nationals Park,Nationals Park,15,14.14,372.61006154122373,96,360,1152,4320\n3309,Nationals Park,Nationals Park,16,14.14,371.6365104565523,102,357,1224,4284\n3309,Nationals Park,Nationals Park,17,14.14,370.78068253905684,108,355,1296,4260\n3309,Nationals Park,Nationals Park,18,14.14,370.04124644414503,114,352,1368,4224\n3309,Nationals Park,Nationals Park,19,14.14,369.41705779701306,120,349,1440,4188\n3309,Nationals Park,Nationals Park,20,14.14,368.9071548380667,126,347,1512,4164\n3309,Nationals Park,Nationals Park,21,14.14,368.51075478656156,132,344,1584,4128\n3309,Nationals Park,Nationals Park,22,14.14,368.2272508967273,138,341,1656,4092\n3309,Nationals Park,Nationals Park,23,14.14,368.05621018568365,144,339,1728,4068\n3309,Nationals Park,Nationals Park,24,14.14,367.9973718172697,150,336,1800,4032\n3309,Nationals Park,Nationals Park,25,14.14,368.05064613053736,156,334,1872,4008\n3309,Nationals Park,Nationals Park,26,14.14,368.21611430616633,161,331,1932,3972\n3309,Nationals Park,Nationals Park,27,13.49,368.41250794719645,167,328,2004,3936\n3309,Nationals Park,Nationals Park,28,13.49,368.8147339408195,173,326,2076,3912\n3309,Nationals Park,Nationals Park,29,13.49,369.3304637787714,179,323,2148,3876\n3309,Nationals Park,Nationals Park,30,13.49,369.960489325727,185,320,2220,3840\n3309,Nationals Park,Nationals Park,31,13.29,370.5168676261704,191,318,2292,3816\n3309,Nationals Park,Nationals Park,32,7.55,368.01743815890313,195,312,2340,3744\n3309,Nationals Park,Nationals Park,33,7.55,364.553781310965,199,306,2388,3672\n3309,Nationals Park,Nationals Park,34,7.55,361.26373251076586,202,300,2424,3600\n3309,Nationals Park,Nationals Park,35,7.55,358.1406544300592,205,293,2460,3516\n3309,Nationals Park,Nationals Park,36,7.55,355.17837425516836,209,287,2508,3444\n3309,Nationals Park,Nationals Park,37,7.55,352.37115090200354,212,281,2544,3372\n3309,Nationals Park,Nationals Park,38,7.55,349.713645291817,215,276,2580,3312\n3309,Nationals Park,Nationals Park,39,7.55,347.2008933806391,219,270,2628,3240\n3309,Nationals Park,Nationals Park,40,7.55,344.8282816714696,222,264,2664,3168\n3309,Nationals Park,Nationals Park,41,7.55,342.5915249698276,225,259,2700,3108\n3309,Nationals Park,Nationals Park,42,7.55,340.4866461708545,228,253,2736,3036\n3309,Nationals Park,Nationals Park,43,7.55,338.5099578903496,231,248,2772,2976\n3309,Nationals Park,Nationals Park,44,7.55,336.6580457733945,234,242,2808,2904\n3309,Nationals Park,Nationals Park,45,16.32,334.9201300299049,237,237,2844,2844\n3312,Target Field,Target Field,-45,7.69,338.31358118386606,-239,239,-2868,2868\n3312,Target Field,Target Field,-44,7.69,338.81394760095765,-235,244,-2820,2928\n3312,Target Field,Target Field,-43,7.66,339.3615867096641,-231,248,-2772,2976\n3312,Target Field,Target Field,-42,7.66,340.0084594230071,-228,253,-2736,3036\n3312,Target Field,Target Field,-41,7.66,340.7618004936445,-224,257,-2688,3084\n3312,Target Field,Target Field,-40,7.66,341.6227799480024,-220,262,-2640,3144\n3312,Target Field,Target Field,-39,7.66,342.5927425862478,-216,266,-2592,3192\n3312,Target Field,Target Field,-38,7.66,343.6732131679635,-212,271,-2544,3252\n3312,Target Field,Target Field,-37,7.66,344.8659023461264,-208,275,-2496,3300\n3312,Target Field,Target Field,-36,7.66,346.1727133929789,-203,280,-2436,3360\n3312,Target Field,Target Field,-35,7.66,347.5957497678452,-199,285,-2388,3420\n3312,Target Field,Target Field,-34,7.66,349.1373235840211,-195,289,-2340,3468\n3312,Target Field,Target Field,-33,7.66,350.79996503963787,-191,294,-2292,3528\n3312,Target Field,Target Field,-32,7.66,352.58643288600166,-187,299,-2244,3588\n3312,Target Field,Target Field,-31,7.66,354.4997260164439,-183,304,-2196,3648\n3312,Target Field,Target Field,-30,7.66,356.54309626934247,-178,309,-2136,3708\n3312,Target Field,Target Field,-29,7.66,358.72006255085097,-174,314,-2088,3768\n3312,Target Field,Target Field,-28,7.66,361.0344263961909,-169,319,-2028,3828\n3312,Target Field,Target Field,-27,7.66,363.49028910334636,-165,324,-1980,3888\n3312,Target Field,Target Field,-26,7.69,366.1610358910164,-161,329,-1932,3948\n3312,Target Field,Target Field,-25,7.69,368.86053617304356,-156,334,-1872,4008\n3312,Target Field,Target Field,-24,7.67,371.5787039496383,-151,339,-1812,4068\n3312,Target Field,Target Field,-23,7.67,374.6822918552989,-146,345,-1752,4140\n3312,Target Field,Target Field,-22,7.75,376.90884256427546,-141,349,-1692,4188\n3312,Target Field,Target Field,-21,7.75,378.0480881334483,-135,353,-1620,4236\n3312,Target Field,Target Field,-20,7.75,379.3101333911095,-130,356,-1560,4272\n3312,Target Field,Target Field,-19,7.75,380.6969855038662,-124,360,-1488,4320\n3312,Target Field,Target Field,-18,7.71,382.34573163203345,-118,364,-1416,4368\n3312,Target Field,Target Field,-17,7.71,383.96515142486135,-112,367,-1344,4404\n3312,Target Field,Target Field,-16,7.71,385.7163403155892,-106,371,-1272,4452\n3312,Target Field,Target Field,-15,7.71,387.6021843722797,-100,374,-1200,4488\n3312,Target Field,Target Field,-14,7.71,389.6258264871172,-94,378,-1128,4536\n3312,Target Field,Target Field,-13,7.71,391.79067966005033,-88,382,-1056,4584\n3312,Target Field,Target Field,-12,7.71,394.1004416646715,-82,385,-984,4620\n3312,Target Field,Target Field,-11,7.71,396.5591112181817,-76,389,-912,4668\n3312,Target Field,Target Field,-10,7.71,399.17100579265536,-69,393,-828,4716\n3312,Target Field,Target Field,-9,7.71,401.9407812221225,-63,397,-756,4764\n3312,Target Field,Target Field,-8,7.71,404.87345327952744,-56,401,-672,4812\n3312,Target Field,Target Field,-7,7.71,407.9744214197429,-50,405,-600,4860\n3312,Target Field,Target Field,-6,7.61,409.9222184341266,-43,408,-516,4896\n3312,Target Field,Target Field,-5,7.61,408.5832615644122,-36,407,-432,4884\n3312,Target Field,Target Field,-4,7.61,407.376710154076,-28,406,-336,4872\n3312,Target Field,Target Field,-3,7.61,406.3006624049,-21,406,-252,4872\n3312,Target Field,Target Field,-2,7.61,405.35343353562337,-14,405,-168,4860\n3312,Target Field,Target Field,-1,7.61,404.5335492626979,-7,404,-84,4848\n3312,Target Field,Target Field,0,7.61,403.83974014426695,0,404,0,4848\n3312,Target Field,Target Field,1,7.61,403.2709367465811,7,403,84,4836\n3312,Target Field,Target Field,2,7.61,402.8262655983225,14,403,168,4836\n3312,Target Field,Target Field,3,7.61,402.50504590418876,21,402,252,4824\n3312,Target Field,Target Field,4,7.61,402.3067869946217,28,401,336,4812\n3312,Target Field,Target Field,5,7.61,402.23118649384963,35,401,420,4812\n3312,Target Field,Target Field,6,7.61,402.278129193489,42,400,504,4800\n3312,Target Field,Target Field,7,22.99,400.95419490204876,49,398,588,4776\n3312,Target Field,Target Field,8,22.99,397.6597656758408,55,394,660,4728\n3312,Target Field,Target Field,9,22.99,394.53823319215206,62,390,744,4680\n3312,Target Field,Target Field,10,22.99,391.58367671093475,68,386,816,4632\n3312,Target Field,Target Field,11,22.99,388.79059165313913,74,382,888,4584\n3312,Target Field,Target Field,12,22.99,386.1538625396701,80,378,960,4536\n3312,Target Field,Target Field,13,22.99,383.66873840802157,86,374,1032,4488\n3312,Target Field,Target Field,14,22.99,381.330810473406,92,370,1104,4440\n3312,Target Field,Target Field,15,22.99,379.1359918277945,98,366,1176,4392\n3312,Target Field,Target Field,16,22.99,377.08049899368206,104,362,1248,4344\n3312,Target Field,Target Field,17,22.99,375.1608351700112,110,359,1320,4308\n3312,Target Field,Target Field,18,22.99,373.3737750259253,115,355,1380,4260\n3312,Target Field,Target Field,19,22.99,371.71635091417545,121,351,1452,4212\n3312,Target Field,Target Field,20,22.99,370.18584039036836,127,348,1524,4176\n3312,Target Field,Target Field,21,22.99,368.77975493704406,132,344,1584,4128\n3312,Target Field,Target Field,22,22.99,367.4958298030208,138,341,1656,4092\n3312,Target Field,Target Field,23,22.99,366.33201487872304,143,337,1716,4044\n3312,Target Field,Target Field,24,22.99,365.2864665374621,149,334,1788,4008\n3312,Target Field,Target Field,25,23.05,362.2159821945486,153,328,1836,3936\n3312,Target Field,Target Field,26,23.05,359.2548513043309,157,323,1884,3876\n3312,Target Field,Target Field,27,23.05,356.4494400908223,162,318,1944,3816\n3312,Target Field,Target Field,28,21.76,345.25273498211544,162,305,1944,3660\n3312,Target Field,Target Field,29,21.76,343.4828899507244,167,300,2004,3600\n3312,Target Field,Target Field,30,21.76,341.8346927498313,171,296,2052,3552\n3312,Target Field,Target Field,31,21.76,340.3054029920884,175,292,2100,3504\n3312,Target Field,Target Field,32,21.76,338.89250584176716,180,287,2160,3444\n3312,Target Field,Target Field,33,21.76,337.5937015820887,184,283,2208,3396\n3312,Target Field,Target Field,34,21.76,336.40689621144406,188,279,2256,3348\n3312,Target Field,Target Field,35,21.76,335.33019299499,192,275,2304,3300\n3312,Target Field,Target Field,36,21.76,334.3618849066685,197,271,2364,3252\n3312,Target Field,Target Field,37,21.76,333.5004479044455,201,266,2412,3192\n3312,Target Field,Target Field,38,21.76,332.74453498859805,205,262,2460,3144\n3312,Target Field,Target Field,39,21.76,332.09297099930586,209,258,2508,3096\n3312,Target Field,Target Field,40,20.49,332.3067211466348,214,255,2568,3060\n3312,Target Field,Target Field,41,20.41,331.26879258559984,217,250,2604,3000\n3312,Target Field,Target Field,42,20.41,330.2618282800649,221,245,2652,2940\n3312,Target Field,Target Field,43,20.41,329.3609897087522,225,241,2700,2892\n3312,Target Field,Target Field,44,20.41,328.5648639022113,228,236,2736,2832\n3312,Target Field,Target Field,45,20.41,327.87220980052643,232,232,2784,2784\n3313,Yankee Stadium,Yankee Stadium,-45,8.05,317.5212677422606,-225,225,-2700,2700\n3313,Yankee Stadium,Yankee Stadium,-44,8.09,323.346071897152,-225,233,-2700,2796\n3313,Yankee Stadium,Yankee Stadium,-43,8.14,327.71603219208436,-224,240,-2688,2880\n3313,Yankee Stadium,Yankee Stadium,-42,8.16,332.30895771332433,-222,247,-2664,2964\n3313,Yankee Stadium,Yankee Stadium,-41,8.12,336.6089270484594,-221,254,-2652,3048\n3313,Yankee Stadium,Yankee Stadium,-40,8.15,340.2200800206725,-219,261,-2628,3132\n3313,Yankee Stadium,Yankee Stadium,-39,8.14,343.95342563097546,-216,267,-2592,3204\n3313,Yankee Stadium,Yankee Stadium,-38,8.14,347.2173245073734,-214,274,-2568,3288\n3313,Yankee Stadium,Yankee Stadium,-37,8.15,350.1259103923532,-211,280,-2532,3360\n3313,Yankee Stadium,Yankee Stadium,-36,8.14,353.1464332343331,-208,286,-2496,3432\n3313,Yankee Stadium,Yankee Stadium,-35,8.22,354.5360285167061,-203,290,-2436,3480\n3313,Yankee Stadium,Yankee Stadium,-34,8.22,355.67430974747185,-199,295,-2388,3540\n3313,Yankee Stadium,Yankee Stadium,-33,8.09,356.9402895176893,-194,299,-2328,3588\n3313,Yankee Stadium,Yankee Stadium,-32,8.09,358.3252946093803,-190,304,-2280,3648\n3313,Yankee Stadium,Yankee Stadium,-31,8.09,359.8311248101274,-185,308,-2220,3696\n3313,Yankee Stadium,Yankee Stadium,-30,8.09,361.4602336020401,-181,313,-2172,3756\n3313,Yankee Stadium,Yankee Stadium,-29,8.02,362.605207239642,-176,317,-2112,3804\n3313,Yankee Stadium,Yankee Stadium,-28,8.5,363.9079526769423,-171,321,-2052,3852\n3313,Yankee Stadium,Yankee Stadium,-27,8.5,365.91650607746334,-166,326,-1992,3912\n3313,Yankee Stadium,Yankee Stadium,-26,8.5,368.06009146037144,-161,331,-1932,3972\n3313,Yankee Stadium,Yankee Stadium,-25,8.5,370.3424142627198,-157,336,-1884,4032\n3313,Yankee Stadium,Yankee Stadium,-24,8.5,372.76747591232305,-152,341,-1824,4092\n3313,Yankee Stadium,Yankee Stadium,-23,8.5,375.33959196033845,-147,346,-1764,4152\n3313,Yankee Stadium,Yankee Stadium,-22,8.5,378.0634120360329,-142,351,-1704,4212\n3313,Yankee Stadium,Yankee Stadium,-21,8.5,380.94394180468754,-137,356,-1644,4272\n3313,Yankee Stadium,Yankee Stadium,-20,8.13,385.3890797829193,-132,362,-1584,4344\n3313,Yankee Stadium,Yankee Stadium,-19,8.13,388.62224167983163,-127,367,-1524,4404\n3313,Yankee Stadium,Yankee Stadium,-18,8.12,391.7530730786308,-121,373,-1452,4476\n3313,Yankee Stadium,Yankee Stadium,-17,8.12,393.44178068055896,-115,376,-1380,4512\n3313,Yankee Stadium,Yankee Stadium,-16,8.12,395.26603326211,-109,380,-1308,4560\n3313,Yankee Stadium,Yankee Stadium,-15,8.12,397.22884489636584,-103,384,-1236,4608\n3313,Yankee Stadium,Yankee Stadium,-14,8.12,399.33349558172995,-97,387,-1164,4644\n3313,Yankee Stadium,Yankee Stadium,-13,8.12,401.5835451571402,-90,391,-1080,4692\n3313,Yankee Stadium,Yankee Stadium,-12,8.15,403.8955608993772,-84,395,-1008,4740\n3313,Yankee Stadium,Yankee Stadium,-11,8.15,404.73783666395843,-77,397,-924,4764\n3313,Yankee Stadium,Yankee Stadium,-10,8.15,405.70747338133816,-70,400,-840,4800\n3313,Yankee Stadium,Yankee Stadium,-9,8.15,406.8059818290736,-64,402,-768,4824\n3313,Yankee Stadium,Yankee Stadium,-8,8.07,407.98336319081494,-57,404,-684,4848\n3313,Yankee Stadium,Yankee Stadium,-7,8.07,408.09486533587545,-50,405,-600,4860\n3313,Yankee Stadium,Yankee Stadium,-6,8.07,408.3308439783494,-43,406,-516,4872\n3313,Yankee Stadium,Yankee Stadium,-5,8.07,408.6916591520734,-36,407,-432,4884\n3313,Yankee Stadium,Yankee Stadium,-4,8.1,409.0686978730683,-29,408,-348,4896\n3313,Yankee Stadium,Yankee Stadium,-3,8.1,408.60763351959923,-21,408,-252,4896\n3313,Yankee Stadium,Yankee Stadium,-2,8.1,408.2718308755166,-14,408,-168,4896\n3313,Yankee Stadium,Yankee Stadium,-1,8.1,408.0607769157123,-7,408,-84,4896\n3313,Yankee Stadium,Yankee Stadium,0,8.15,407.967097969385,0,408,0,4896\n3313,Yankee Stadium,Yankee Stadium,1,8.15,406.92683319580397,7,407,84,4884\n3313,Yankee Stadium,Yankee Stadium,2,8.15,406.01522163098724,14,406,168,4872\n3313,Yankee Stadium,Yankee Stadium,3,8.15,405.23084671520695,21,405,252,4860\n3313,Yankee Stadium,Yankee Stadium,4,8.12,404.3984299338778,28,403,336,4836\n3313,Yankee Stadium,Yankee Stadium,5,8.13,402.86275306954946,35,401,420,4812\n3313,Yankee Stadium,Yankee Stadium,6,8.14,401.33347732827883,42,399,504,4788\n3313,Yankee Stadium,Yankee Stadium,7,8.09,400.0466571465859,49,397,588,4764\n3313,Yankee Stadium,Yankee Stadium,8,8.09,398.7577251304412,55,395,660,4740\n3313,Yankee Stadium,Yankee Stadium,9,8.18,395.11206943689314,62,390,744,4680\n3313,Yankee Stadium,Yankee Stadium,10,8.18,391.6315979179521,68,386,816,4632\n3313,Yankee Stadium,Yankee Stadium,11,8.18,388.32916461919996,74,381,888,4572\n3313,Yankee Stadium,Yankee Stadium,12,8.15,385.27325683560167,80,377,960,4524\n3313,Yankee Stadium,Yankee Stadium,13,8.15,382.41025313414036,86,373,1032,4476\n3313,Yankee Stadium,Yankee Stadium,14,8.18,379.4887141687654,92,368,1104,4416\n3313,Yankee Stadium,Yankee Stadium,15,8.2,375.7839642108125,97,363,1164,4356\n3313,Yankee Stadium,Yankee Stadium,16,8.17,371.87019197542384,103,357,1236,4284\n3313,Yankee Stadium,Yankee Stadium,17,8.31,367.0404110230201,107,351,1284,4212\n3313,Yankee Stadium,Yankee Stadium,18,8.31,363.73413541470927,112,346,1344,4152\n3313,Yankee Stadium,Yankee Stadium,19,8.31,360.5957538096812,117,341,1404,4092\n3313,Yankee Stadium,Yankee Stadium,20,8.31,357.61906863698886,122,336,1464,4032\n3313,Yankee Stadium,Yankee Stadium,21,8.31,354.79831579219314,127,331,1524,3972\n3313,Yankee Stadium,Yankee Stadium,22,8.31,352.12813482693684,132,326,1584,3912\n3313,Yankee Stadium,Yankee Stadium,23,8.31,349.60354189932644,137,322,1644,3864\n3313,Yankee Stadium,Yankee Stadium,24,8.31,347.21990521373186,141,317,1692,3804\n3313,Yankee Stadium,Yankee Stadium,25,7.63,346.1060954664215,146,314,1752,3768\n3313,Yankee Stadium,Yankee Stadium,26,7.63,343.96513099686405,151,309,1812,3708\n3313,Yankee Stadium,Yankee Stadium,27,7.63,341.95401323910096,155,305,1860,3660\n3313,Yankee Stadium,Yankee Stadium,28,7.63,340.06926249104566,160,300,1920,3600\n3313,Yankee Stadium,Yankee Stadium,29,7.63,338.3076611625794,164,296,1968,3552\n3313,Yankee Stadium,Yankee Stadium,30,7.63,336.6662397158444,168,292,2016,3504\n3313,Yankee Stadium,Yankee Stadium,31,7.63,335.1422639139425,173,287,2076,3444\n3313,Yankee Stadium,Yankee Stadium,32,7.63,333.7332232721874,177,283,2124,3396\n3313,Yankee Stadium,Yankee Stadium,33,7.63,332.436820617949,181,279,2172,3348\n3313,Yankee Stadium,Yankee Stadium,34,7.63,331.2509626757509,185,275,2220,3300\n3313,Yankee Stadium,Yankee Stadium,35,7.63,330.1737516038098,189,270,2268,3240\n3313,Yankee Stadium,Yankee Stadium,36,7.63,329.2034774167768,194,266,2328,3192\n3313,Yankee Stadium,Yankee Stadium,37,7.63,328.3386112371863,198,262,2376,3144\n3313,Yankee Stadium,Yankee Stadium,38,7.63,327.57779932515103,202,258,2424,3096\n3313,Yankee Stadium,Yankee Stadium,39,7.63,326.9198578422571,206,254,2472,3048\n3313,Yankee Stadium,Yankee Stadium,40,7.72,326.25415363960263,210,250,2520,3000\n3313,Yankee Stadium,Yankee Stadium,41,7.72,324.57027625155985,213,245,2556,2940\n3313,Yankee Stadium,Yankee Stadium,42,7.69,322.9350250739372,216,240,2592,2880\n3313,Yankee Stadium,Yankee Stadium,43,7.69,320.2032582588617,218,234,2616,2808\n3313,Yankee Stadium,Yankee Stadium,44,7.68,317.54224237259467,221,228,2652,2736\n3313,Yankee Stadium,Yankee Stadium,45,7.68,313.4340887302452,222,222,2664,2664\n3949,Rickwood Field,Rickwood Field,-45,10,324.986347665869,-230,230,-2760,2760\n3949,Rickwood Field,Rickwood Field,-44,10,327.4794333088241,-227,236,-2724,2832\n3949,Rickwood Field,Rickwood Field,-43,10,330.1123981390483,-225,241,-2700,2892\n3949,Rickwood Field,Rickwood Field,-42,10,332.89026818087257,-223,247,-2676,2964\n3949,Rickwood Field,Rickwood Field,-41,10,335.8184477366283,-220,253,-2640,3036\n3949,Rickwood Field,Rickwood Field,-40,10,338.9027475067895,-218,260,-2616,3120\n3949,Rickwood Field,Rickwood Field,-39,10,342.14941561102165,-215,266,-2580,3192\n3949,Rickwood Field,Rickwood Field,-38,10,345.56517184185196,-213,272,-2556,3264\n3949,Rickwood Field,Rickwood Field,-37,10,349.15724552826725,-210,279,-2520,3348\n3949,Rickwood Field,Rickwood Field,-36,10,352.93341743920547,-207,286,-2484,3432\n3949,Rickwood Field,Rickwood Field,-35,10,356.9020662178591,-205,292,-2460,3504\n3949,Rickwood Field,Rickwood Field,-34,10,361.07221990844914,-202,299,-2424,3588\n3949,Rickwood Field,Rickwood Field,-33,10,365.4536132194501,-199,306,-2388,3672\n3949,Rickwood Field,Rickwood Field,-32,10,370.05675126328987,-196,314,-2352,3768\n3949,Rickwood Field,Rickwood Field,-31,10,374.8929806249204,-193,321,-2316,3852\n3949,Rickwood Field,Rickwood Field,-30,10,377.28726056059116,-189,327,-2268,3924\n3949,Rickwood Field,Rickwood Field,-29,10,378.5560645949939,-184,331,-2208,3972\n3949,Rickwood Field,Rickwood Field,-28,10,379.94955816039976,-178,335,-2136,4020\n3949,Rickwood Field,Rickwood Field,-27,10,381.4699775106325,-173,340,-2076,4080\n3949,Rickwood Field,Rickwood Field,-26,10,383.11978494836393,-168,344,-2016,4128\n3949,Rickwood Field,Rickwood Field,-25,10,384.90167882253127,-163,349,-1956,4188\n3949,Rickwood Field,Rickwood Field,-24,10,386.8186046374877,-157,353,-1884,4236\n3949,Rickwood Field,Rickwood Field,-23,10,388.8737673614717,-152,358,-1824,4296\n3949,Rickwood Field,Rickwood Field,-22,10,389.53353138749435,-146,361,-1752,4332\n3949,Rickwood Field,Rickwood Field,-21,10,389.387574753708,-140,364,-1680,4368\n3949,Rickwood Field,Rickwood Field,-20,10,389.36028594920236,-133,366,-1596,4392\n3949,Rickwood Field,Rickwood Field,-19,10,389.4516233932702,-127,368,-1524,4416\n3949,Rickwood Field,Rickwood Field,-18,10,389.6617262867901,-120,371,-1440,4452\n3949,Rickwood Field,Rickwood Field,-17,10,389.9909151302128,-114,373,-1368,4476\n3949,Rickwood Field,Rickwood Field,-16,10,390.4396929178074,-108,375,-1296,4500\n3949,Rickwood Field,Rickwood Field,-15,10,391.0087470164602,-101,378,-1212,4536\n3949,Rickwood Field,Rickwood Field,-14,10,391.6989517421143,-95,380,-1140,4560\n3949,Rickwood Field,Rickwood Field,-13,10,392.5113716518796,-88,382,-1056,4584\n3949,Rickwood Field,Rickwood Field,-12,10,393.44726557498745,-82,385,-984,4620\n3949,Rickwood Field,Rickwood Field,-11,10,394.5080914111745,-75,387,-900,4644\n3949,Rickwood Field,Rickwood Field,-10,10,395.695511730815,-69,390,-828,4680\n3949,Rickwood Field,Rickwood Field,-9,10,397.01140021725416,-62,392,-744,4704\n3949,Rickwood Field,Rickwood Field,-8,10,398.45784899840646,-55,395,-660,4740\n3949,Rickwood Field,Rickwood Field,-7,10,400.0371769218461,-49,397,-588,4764\n3949,Rickwood Field,Rickwood Field,-6,10,401.75193883544165,-42,400,-504,4800\n3949,Rickwood Field,Rickwood Field,-5,10,401.6684773592839,-35,400,-420,4800\n3949,Rickwood Field,Rickwood Field,-4,10,401.1171071361095,-28,400,-336,4800\n3949,Rickwood Field,Rickwood Field,-3,10,400.689135047991,-21,400,-252,4800\n3949,Rickwood Field,Rickwood Field,-2,10,400.38390606549666,-14,400,-168,4800\n3949,Rickwood Field,Rickwood Field,-1,10,400.20095404723105,-7,400,-84,4800\n3949,Rickwood Field,Rickwood Field,0,10,400.1400000000092,0,400,0,4800\n3949,Rickwood Field,Rickwood Field,1,10,400.2009510397659,7,400,84,4800\n3949,Rickwood Field,Rickwood Field,2,10,400.38390004598295,14,400,168,4800\n3949,Rickwood Field,Rickwood Field,3,10,400.68912600724383,21,400,252,4800\n3949,Rickwood Field,Rickwood Field,4,10,401.1170950603097,28,400,336,4800\n3949,Rickwood Field,Rickwood Field,5,10,401.668462229925,35,400,420,4800\n3949,Rickwood Field,Rickwood Field,6,10,401.37478570404517,42,399,504,4788\n3949,Rickwood Field,Rickwood Field,7,10,398.0775590694389,49,395,588,4740\n3949,Rickwood Field,Rickwood Field,8,10,394.95338975549026,55,391,660,4692\n3949,Rickwood Field,Rickwood Field,9,10,391.9963525021183,61,387,732,4644\n3949,Rickwood Field,Rickwood Field,10,10,389.2009385363057,68,383,816,4596\n3949,Rickwood Field,Rickwood Field,11,10,386.56202849322085,74,379,888,4548\n3949,Rickwood Field,Rickwood Field,12,10,384.07486781660884,80,376,960,4512\n3949,Rickwood Field,Rickwood Field,13,10,381.73504440514336,86,372,1032,4464\n3949,Rickwood Field,Rickwood Field,14,10,379.5384682980394,92,368,1104,4416\n3949,Rickwood Field,Rickwood Field,15,10,377.48135321663943,98,365,1176,4380\n3949,Rickwood Field,Rickwood Field,16,10,375.56019979931784,104,361,1248,4332\n3949,Rickwood Field,Rickwood Field,17,10,373.7717803852919,109,357,1308,4284\n3949,Rickwood Field,Rickwood Field,18,10,372.1131252190939,115,354,1380,4248\n3949,Rickwood Field,Rickwood Field,19,10,370.5815099618252,121,350,1452,4200\n3949,Rickwood Field,Rickwood Field,20,10,369.17444440812824,126,347,1512,4164\n3949,Rickwood Field,Rickwood Field,21,10,367.88966231926327,132,343,1584,4116\n3949,Rickwood Field,Rickwood Field,22,10,366.72511229296174,137,340,1644,4080\n3949,Rickwood Field,Rickwood Field,23,10,365.2208850919744,143,336,1716,4032\n3949,Rickwood Field,Rickwood Field,24,10,363.09664673461384,148,332,1776,3984\n3949,Rickwood Field,Rickwood Field,25,10,361.1063363616587,153,327,1836,3924\n3949,Rickwood Field,Rickwood Field,26,10,359.2465601791749,157,323,1884,3876\n3949,Rickwood Field,Rickwood Field,27,10,357.51418663374415,162,319,1944,3828\n3949,Rickwood Field,Rickwood Field,28,10,355.9063329861034,167,314,2004,3768\n3949,Rickwood Field,Rickwood Field,29,10,354.42035315279406,172,310,2064,3720\n3949,Rickwood Field,Rickwood Field,30,10,353.0538267170767,177,306,2124,3672\n3949,Rickwood Field,Rickwood Field,31,10,351.80454902153616,181,302,2172,3624\n3949,Rickwood Field,Rickwood Field,32,10,350.67052226482707,186,297,2232,3564\n3949,Rickwood Field,Rickwood Field,33,10,348.7156661910381,190,292,2280,3504\n3949,Rickwood Field,Rickwood Field,34,10,346.67269330015097,194,287,2328,3444\n3949,Rickwood Field,Rickwood Field,35,10,344.75792369847034,198,282,2376,3384\n3949,Rickwood Field,Rickwood Field,36,10,342.9680870679936,202,277,2424,3324\n3949,Rickwood Field,Rickwood Field,37,10,341.30016498782703,205,273,2460,3276\n3949,Rickwood Field,Rickwood Field,38,10,339.751377965333,209,268,2508,3216\n3949,Rickwood Field,Rickwood Field,39,10,338.3191736896954,213,263,2556,3156\n3949,Rickwood Field,Rickwood Field,40,10,337.0012164122716,217,258,2604,3096\n3949,Rickwood Field,Rickwood Field,41,10,335.7953773689032,220,253,2640,3036\n3949,Rickwood Field,Rickwood Field,42,10,334.6997261690519,224,249,2688,2988\n3949,Rickwood Field,Rickwood Field,43,10,333.71252308534827,228,244,2736,2928\n3949,Rickwood Field,Rickwood Field,44,10,332.83221218501484,231,239,2772,2868\n3949,Rickwood Field,Rickwood Field,45,10,332.05741525178337,235,235,2820,2820\n4169,loanDepot park,loanDepot park,-45,11,343.7870973000777,-243,243,-2916,2916\n4169,loanDepot park,loanDepot park,-44,11,345.3057694219505,-240,248,-2880,2976\n4169,loanDepot park,loanDepot park,-43,11,346.9440699272523,-237,254,-2844,3048\n4169,loanDepot park,loanDepot park,-42,11,348.70471553999175,-233,259,-2796,3108\n4169,loanDepot park,loanDepot park,-41,11.13,350.5387313559857,-230,265,-2760,3180\n4169,loanDepot park,loanDepot park,-40,11.13,352.4887530921554,-227,270,-2724,3240\n4169,loanDepot park,loanDepot park,-39,6.67,354.1905537268492,-223,275,-2676,3300\n4169,loanDepot park,loanDepot park,-38,6.67,355.7051386660189,-219,280,-2628,3360\n4169,loanDepot park,loanDepot park,-37,6.67,357.34204984102496,-215,285,-2580,3420\n4169,loanDepot park,loanDepot park,-36,6.67,359.10398865813994,-211,291,-2532,3492\n4169,loanDepot park,loanDepot park,-35,6.78,360.9579282631712,-207,296,-2484,3552\n4169,loanDepot park,loanDepot park,-34,6.78,362.62952833713763,-203,301,-2436,3612\n4169,loanDepot park,loanDepot park,-33,6.82,364.077176793112,-198,305,-2376,3660\n4169,loanDepot park,loanDepot park,-32,6.82,365.56559791208053,-194,310,-2328,3720\n4169,loanDepot park,loanDepot park,-31,6.81,367.1891923588878,-189,315,-2268,3780\n4169,loanDepot park,loanDepot park,-30,6.81,368.9471371309111,-184,320,-2208,3840\n4169,loanDepot park,loanDepot park,-29,6.76,370.8159262354708,-180,324,-2160,3888\n4169,loanDepot park,loanDepot park,-28,6.71,372.2016168304142,-175,329,-2100,3948\n4169,loanDepot park,loanDepot park,-27,6.71,373.6183882772082,-170,333,-2040,3996\n4169,loanDepot park,loanDepot park,-26,6.71,375.1247299247604,-164,337,-1968,4044\n4169,loanDepot park,loanDepot park,-25,6.67,376.7679163804841,-159,341,-1908,4092\n4169,loanDepot park,loanDepot park,-24,6.67,378.5450476464067,-154,346,-1848,4152\n4169,loanDepot park,loanDepot park,-23,6.75,379.94978743196884,-148,350,-1776,4200\n4169,loanDepot park,loanDepot park,-22,6.63,381.20139148813576,-143,353,-1716,4236\n4169,loanDepot park,loanDepot park,-21,11.11,382.54756453609036,-137,357,-1644,4284\n4169,loanDepot park,loanDepot park,-20,11.11,384.07153350019166,-131,361,-1572,4332\n4169,loanDepot park,loanDepot park,-19,11.15,385.6765207521081,-126,365,-1512,4380\n4169,loanDepot park,loanDepot park,-18,11.03,387.16474290467676,-120,368,-1440,4416\n4169,loanDepot park,loanDepot park,-17,11.14,388.27655252519776,-114,371,-1368,4452\n4169,loanDepot park,loanDepot park,-16,11.14,389.28836619504824,-107,374,-1284,4488\n4169,loanDepot park,loanDepot park,-15,11.08,389.83717304589413,-101,377,-1212,4524\n4169,loanDepot park,loanDepot park,-14,11.03,390.01054604435717,-94,378,-1128,4536\n4169,loanDepot park,loanDepot park,-13,11.05,389.95523078004226,-88,380,-1056,4560\n4169,loanDepot park,loanDepot park,-12,11.04,390.37494710716874,-81,382,-972,4584\n4169,loanDepot park,loanDepot park,-11,11.11,391.7463722857511,-75,385,-900,4620\n4169,loanDepot park,loanDepot park,-10,11.16,394.0235141559383,-68,388,-816,4656\n4169,loanDepot park,loanDepot park,-9,11.2,397.40107309233275,-62,393,-744,4716\n4169,loanDepot park,loanDepot park,-8,11.11,402.15730171849447,-56,398,-672,4776\n4169,loanDepot park,loanDepot park,-7,8.33,403.1339313593774,-49,400,-588,4800\n4169,loanDepot park,loanDepot park,-6,8.33,402.31493511785646,-42,400,-504,4800\n4169,loanDepot park,loanDepot park,-5,8.33,401.6213495512315,-35,400,-420,4800\n4169,loanDepot park,loanDepot park,-4,8.33,401.05210544247143,-28,400,-336,4800\n4169,loanDepot park,loanDepot park,-3,8.33,400.6063285575447,-21,400,-252,4800\n4169,loanDepot park,loanDepot park,-2,8.25,399.70752516405383,-14,399,-168,4788\n4169,loanDepot park,loanDepot park,-1,8.25,397.9215981758919,-7,398,-84,4776\n4169,loanDepot park,loanDepot park,0,8.25,396.27173081510034,0,396,0,4752\n4169,loanDepot park,loanDepot park,1,8.26,394.73905794999945,7,395,84,4740\n4169,loanDepot park,loanDepot park,2,8.26,393.33295704099396,14,393,168,4716\n4169,loanDepot park,loanDepot park,3,8.26,392.05583804201086,21,392,252,4704\n4169,loanDepot park,loanDepot park,4,8.26,390.9056738821577,27,390,324,4680\n4169,loanDepot park,loanDepot park,5,8.26,389.8806524321464,34,388,408,4656\n4169,loanDepot park,loanDepot park,6,8.26,388.97916942902384,41,387,492,4644\n4169,loanDepot park,loanDepot park,7,8.26,388.1998222719703,47,385,564,4620\n4169,loanDepot park,loanDepot park,8,8.26,387.54140464396033,54,384,648,4608\n4169,loanDepot park,loanDepot park,9,8.26,387.00290192051966,61,382,732,4584\n4169,loanDepot park,loanDepot park,10,8.26,386.58348733280354,67,381,804,4572\n4169,loanDepot park,loanDepot park,11,8.26,386.28251885783715,74,379,888,4548\n4169,loanDepot park,loanDepot park,12,8.26,386.0995368140558,80,378,960,4536\n4169,loanDepot park,loanDepot park,13,8.26,386.03426214533573,87,376,1044,4512\n4169,loanDepot park,loanDepot park,14,8.26,386.08659538157514,93,375,1116,4500\n4169,loanDepot park,loanDepot park,15,8.26,386.2566162686075,100,373,1200,4476\n4169,loanDepot park,loanDepot park,16,8.26,386.5445840648845,107,372,1284,4464\n4169,loanDepot park,loanDepot park,17,8.09,385.5495561722675,113,369,1356,4428\n4169,loanDepot park,loanDepot park,18,8.09,384.3464916418409,119,366,1428,4392\n4169,loanDepot park,loanDepot park,19,8.09,383.2672955829041,125,362,1500,4344\n4169,loanDepot park,loanDepot park,20,8.09,382.3102723811304,131,359,1572,4308\n4169,loanDepot park,loanDepot park,21,8.09,381.473927894627,137,356,1644,4272\n4169,loanDepot park,loanDepot park,22,8.09,380.75696369611825,143,353,1716,4236\n4169,loanDepot park,loanDepot park,23,8.21,378.15640311138145,148,348,1776,4176\n4169,loanDepot park,loanDepot park,24,8.21,374.67279725998515,152,342,1824,4104\n4169,loanDepot park,loanDepot park,25,8.21,371.3648768098586,157,337,1884,4044\n4169,loanDepot park,loanDepot park,26,8.21,368.2260388779545,161,331,1932,3972\n4169,loanDepot park,loanDepot park,27,8.21,365.2501424333948,166,325,1992,3900\n4169,loanDepot park,loanDepot park,28,11.09,362.24756932187364,170,320,2040,3840\n4169,loanDepot park,loanDepot park,29,11.09,359.65069946079336,174,315,2088,3780\n4169,loanDepot park,loanDepot park,30,11.09,357.1988290857851,179,309,2148,3708\n4169,loanDepot park,loanDepot park,31,11.09,354.88753313838413,183,304,2196,3648\n4169,loanDepot park,loanDepot park,32,11.09,352.7127048783473,187,299,2244,3588\n4169,loanDepot park,loanDepot park,33,11.09,350.670536934015,191,294,2292,3528\n4169,loanDepot park,loanDepot park,34,11.09,348.7575040834817,195,289,2340,3468\n4169,loanDepot park,loanDepot park,35,6.59,346.6005276522834,199,284,2388,3408\n4169,loanDepot park,loanDepot park,36,6.59,344.8717133274166,203,279,2436,3348\n4169,loanDepot park,loanDepot park,37,6.59,343.264102382467,207,274,2484,3288\n4169,loanDepot park,loanDepot park,38,6.59,341.77503451541884,210,269,2520,3228\n4169,loanDepot park,loanDepot park,39,6.59,340.40207180716726,214,265,2568,3180\n4169,loanDepot park,loanDepot park,40,6.59,339.142988670273,218,260,2616,3120\n4169,loanDepot park,loanDepot park,41,6.59,337.99576280066816,222,255,2664,3060\n4169,loanDepot park,loanDepot park,42,6.59,336.9585670620813,225,250,2700,3000\n4169,loanDepot park,loanDepot park,43,6.59,336.0297622412054,229,246,2748,2952\n4169,loanDepot park,loanDepot park,44,6.59,335.207890619115,233,241,2796,2892\n4169,loanDepot park,loanDepot park,45,11.04,334.5888949784615,237,237,2844,2844\n4705,Truist Park,Truist Park,-45,5.298133244,334.74779688013547,-237,237,-2844,2844\n4705,Truist Park,Truist Park,-44,5.298133244,336.9939996081851,-234,242,-2808,2904\n4705,Truist Park,Truist Park,-43,5.298133244,339.3746257788878,-231,248,-2772,2976\n4705,Truist Park,Truist Park,-42,5.298133244,341.89401132233075,-229,254,-2748,3048\n4705,Truist Park,Truist Park,-41,5.298133244,344.55682283202026,-226,260,-2712,3120\n4705,Truist Park,Truist Park,-40,5.298133244,347.3680803301859,-223,266,-2676,3192\n4705,Truist Park,Truist Park,-39,5.298133244,350.33318233477223,-220,272,-2640,3264\n4705,Truist Park,Truist Park,-38,5.298133244,353.45793347661487,-218,279,-2616,3348\n4705,Truist Park,Truist Park,-37,5.298133244,356.74857494823635,-215,285,-2580,3420\n4705,Truist Park,Truist Park,-36,5.298133244,360.2118181034811,-212,291,-2544,3492\n4705,Truist Park,Truist Park,-35,5.298133244,363.85488157066317,-209,298,-2508,3576\n4705,Truist Park,Truist Park,-34,5.298133244,367.6855322919902,-206,305,-2472,3660\n4705,Truist Park,Truist Park,-33,5.298133244,371.7121309599167,-202,312,-2424,3744\n4705,Truist Park,Truist Park,-32,5.298133244,375.9436823881456,-199,319,-2388,3828\n4705,Truist Park,Truist Park,-31,8.012935271,377.1957785948002,-194,323,-2328,3876\n4705,Truist Park,Truist Park,-30,8.012935271,377.6605842521595,-189,327,-2268,3924\n4705,Truist Park,Truist Park,-29,8.012935271,378.2418951490986,-183,331,-2196,3972\n4705,Truist Park,Truist Park,-28,8.012935271,378.9406052869647,-178,335,-2136,4020\n4705,Truist Park,Truist Park,-27,8.012935271,379.75779358214237,-172,338,-2064,4056\n4705,Truist Park,Truist Park,-26,8.012935271,380.69472795820053,-167,342,-2004,4104\n4705,Truist Park,Truist Park,-25,8.012935271,381.75287018835513,-161,346,-1932,4152\n4705,Truist Park,Truist Park,-24,8.012935271,382.9338815229756,-156,350,-1872,4200\n4705,Truist Park,Truist Park,-23,8.012935271,384.23962914289797,-150,354,-1800,4248\n4705,Truist Park,Truist Park,-22,7.97017466,384.94050266289565,-144,357,-1728,4284\n4705,Truist Park,Truist Park,-21,7.97017466,385.0603660088384,-138,359,-1656,4308\n4705,Truist Park,Truist Park,-20,7.97017466,385.2977059949944,-132,362,-1584,4344\n4705,Truist Park,Truist Park,-19,7.97017466,385.6528847970737,-126,365,-1512,4380\n4705,Truist Park,Truist Park,-18,7.97017466,386.12644541138053,-119,367,-1428,4404\n4705,Truist Park,Truist Park,-17,7.97017466,386.71911368460763,-113,370,-1356,4440\n4705,Truist Park,Truist Park,-16,7.97017466,387.43180103735654,-107,372,-1284,4464\n4705,Truist Park,Truist Park,-15,7.97017466,388.2656079004656,-100,375,-1200,4500\n4705,Truist Park,Truist Park,-14,7.97017466,389.2218278883802,-94,378,-1128,4536\n4705,Truist Park,Truist Park,-13,7.97017466,390.3019527392168,-88,380,-1056,4560\n4705,Truist Park,Truist Park,-12,7.97017466,391.50767805694034,-81,383,-972,4596\n4705,Truist Park,Truist Park,-11,7.97017466,392.84090989724433,-75,386,-900,4632\n4705,Truist Park,Truist Park,-10,7.97017466,394.3037722453915,-68,388,-816,4656\n4705,Truist Park,Truist Park,-9,7.97017466,395.8986154415108,-62,391,-744,4692\n4705,Truist Park,Truist Park,-8,7.97017466,397.62802561675664,-55,394,-660,4728\n4705,Truist Park,Truist Park,-7,7.97017466,399.4948352124309,-49,397,-588,4764\n4705,Truist Park,Truist Park,-6,7.97017466,401.5021346637634,-42,399,-504,4788\n4705,Truist Park,Truist Park,-5,7.990174641,401.7767711470161,-35,400,-420,4800\n4705,Truist Park,Truist Park,-4,7.990174641,401.17233795800166,-28,400,-336,4800\n4705,Truist Park,Truist Park,-3,7.990174641,400.6915918537606,-21,400,-252,4800\n4705,Truist Park,Truist Park,-2,7.990174641,400.3337961710815,-14,400,-168,4800\n4705,Truist Park,Truist Park,-1,7.990174641,400.09840402240724,-7,400,-84,4800\n4705,Truist Park,Truist Park,0,7.990174641,399.98505625208986,0,400,0,4800\n4705,Truist Park,Truist Park,1,7.990174641,399.99358009768486,7,400,84,4800\n4705,Truist Park,Truist Park,2,7.990174641,400.12398854698347,14,400,168,4800\n4705,Truist Park,Truist Park,3,7.990174641,400.3764803863276,21,400,252,4800\n4705,Truist Park,Truist Park,4,7.990174641,400.7514409405398,28,400,336,4800\n4705,Truist Park,Truist Park,5,7.990174641,401.2494435096005,35,400,420,4800\n4705,Truist Park,Truist Park,6,8.011175026,401.15342538394316,42,399,504,4788\n4705,Truist Park,Truist Park,7,8.011175026,398.47070699015956,49,396,588,4752\n4705,Truist Park,Truist Park,8,8.011175026,395.94343865278387,55,392,660,4704\n4705,Truist Park,Truist Park,9,8.011175026,393.56715506620213,62,389,744,4668\n4705,Truist Park,Truist Park,10,8.011175026,391.337718308035,68,385,816,4620\n4705,Truist Park,Truist Park,11,8.011175026,389.251299260715,74,382,888,4584\n4705,Truist Park,Truist Park,12,8.011175026,387.30436074008713,81,379,972,4548\n4705,Truist Park,Truist Park,13,8.011175026,385.49364218655705,87,376,1044,4512\n4705,Truist Park,Truist Park,14,8.011175026,383.81614579048994,93,372,1116,4464\n4705,Truist Park,Truist Park,15,15.34721636,382.77168069677083,99,370,1188,4440\n4705,Truist Park,Truist Park,16,15.34721636,381.32439880135183,105,367,1260,4404\n4705,Truist Park,Truist Park,17,15.34721636,380.00333687186765,111,363,1332,4356\n4705,Truist Park,Truist Park,18,15.34721636,378.8063864503734,117,360,1404,4320\n4705,Truist Park,Truist Park,19,15.34721636,377.7316521968135,123,357,1476,4284\n4705,Truist Park,Truist Park,20,15.34721636,376.77744443548534,129,354,1548,4248\n4705,Truist Park,Truist Park,21,15.34721636,375.9422725780344,135,351,1620,4212\n4705,Truist Park,Truist Park,22,15.34721636,375.22483937465813,141,348,1692,4176\n4705,Truist Park,Truist Park,23,15.32721635,372.9815971966861,146,343,1752,4116\n4705,Truist Park,Truist Park,24,15.32721635,369.30520780742575,150,337,1800,4044\n4705,Truist Park,Truist Park,25,15.32721635,365.81092752692115,155,332,1860,3984\n4705,Truist Park,Truist Park,26,15.32721635,362.49153507171894,159,326,1908,3912\n4705,Truist Park,Truist Park,27,15.32721635,359.3403159137992,163,320,1956,3840\n4705,Truist Park,Truist Park,28,15.32721635,356.3510255389806,167,315,2004,3780\n4705,Truist Park,Truist Park,29,15.32721635,353.5178561704093,171,309,2052,3708\n4705,Truist Park,Truist Park,30,15.32721635,350.83540660202465,175,304,2100,3648\n4705,Truist Park,Truist Park,31,15.32721635,348.29865482924214,179,299,2148,3588\n4705,Truist Park,Truist Park,32,15.32721635,345.9029332009446,183,293,2196,3516\n4705,Truist Park,Truist Park,33,15.32721635,343.64390584903003,187,288,2244,3456\n4705,Truist Park,Truist Park,34,15.32721635,341.5175481798856,191,283,2292,3396\n4705,Truist Park,Truist Park,35,15.32721635,339.52012823681235,195,278,2340,3336\n4705,Truist Park,Truist Park,36,15.32721635,337.6481897640955,198,273,2376,3276\n4705,Truist Park,Truist Park,37,15.32721635,335.8985368224997,202,268,2424,3216\n4705,Truist Park,Truist Park,38,15.32721635,334.2682198228358,206,263,2472,3156\n4705,Truist Park,Truist Park,39,15.32721635,332.75452285917487,209,259,2508,3108\n4705,Truist Park,Truist Park,40,15.32721635,331.35495223654664,213,254,2556,3048\n4705,Truist Park,Truist Park,41,15.32721635,330.0672260997744,217,249,2604,2988\n4705,Truist Park,Truist Park,42,15.32721635,328.88926508064986,220,244,2640,2928\n4705,Truist Park,Truist Park,43,15.32721635,327.81918389011537,224,240,2688,2880\n4705,Truist Park,Truist Park,44,15.32721635,326.85528379063794,227,235,2724,2820\n4705,Truist Park,Truist Park,45,15.32721635,325.99604589165267,231,231,2772,2772\n5325,Globe Life Field,Globe Life Field,-45,7.97,328.2400012949943,-232,232,-2784,2784\n5325,Globe Life Field,Globe Life Field,-44,7.97,332.1841917064749,-231,239,-2772,2868\n5325,Globe Life Field,Globe Life Field,-43,7.97,336.32801794117415,-229,246,-2748,2952\n5325,Globe Life Field,Globe Life Field,-42,7.97,340.6816201286836,-228,253,-2736,3036\n5325,Globe Life Field,Globe Life Field,-41,7.97,345.2559584621938,-227,261,-2724,3132\n5325,Globe Life Field,Globe Life Field,-40,7.97,350.0628918503841,-225,268,-2700,3216\n5325,Globe Life Field,Globe Life Field,-39,7.97,355.11526606306927,-223,276,-2676,3312\n5325,Globe Life Field,Globe Life Field,-38,7.97,360.4270127195701,-222,284,-2664,3408\n5325,Globe Life Field,Globe Life Field,-37,7.97,366.0132606933328,-220,292,-2640,3504\n5325,Globe Life Field,Globe Life Field,-36,7.97,371.890461773748,-219,301,-2628,3612\n5325,Globe Life Field,Globe Life Field,-35,8.02,371.72087755555896,-213,304,-2556,3648\n5325,Globe Life Field,Globe Life Field,-34,8.02,371.20012299723766,-208,308,-2496,3696\n5325,Globe Life Field,Globe Life Field,-33,8.02,370.79361479523556,-202,311,-2424,3732\n5325,Globe Life Field,Globe Life Field,-32,8.02,370.5007306225815,-196,314,-2352,3768\n5325,Globe Life Field,Globe Life Field,-31,8.02,370.3210231138477,-191,317,-2292,3804\n5325,Globe Life Field,Globe Life Field,-30,8.02,370.25421819498695,-185,321,-2220,3852\n5325,Globe Life Field,Globe Life Field,-29,8.02,370.3002140624053,-180,324,-2160,3888\n5325,Globe Life Field,Globe Life Field,-28,8.02,370.4590808041859,-174,327,-2088,3924\n5325,Globe Life Field,Globe Life Field,-27,8.02,370.7310606608367,-168,330,-2016,3960\n5325,Globe Life Field,Globe Life Field,-26,8.02,371.11656892737113,-163,334,-1956,4008\n5325,Globe Life Field,Globe Life Field,-25,8.02,371.61619550297934,-157,337,-1884,4044\n5325,Globe Life Field,Globe Life Field,-24,8.02,372.23070709907057,-151,340,-1812,4080\n5325,Globe Life Field,Globe Life Field,-23,8.02,372.96105012111246,-146,343,-1752,4116\n5325,Globe Life Field,Globe Life Field,-22,8.02,373.8083542445048,-140,347,-1680,4164\n5325,Globe Life Field,Globe Life Field,-21,8.02,374.7739367097759,-134,350,-1608,4200\n5325,Globe Life Field,Globe Life Field,-20,8.02,375.8593073677199,-129,353,-1548,4236\n5325,Globe Life Field,Globe Life Field,-19,8.02,377.0661745107842,-123,357,-1476,4284\n5325,Globe Life Field,Globe Life Field,-18,8.05,380.69861932362863,-118,362,-1416,4344\n5325,Globe Life Field,Globe Life Field,-17,6.3,387.1513311032907,-113,370,-1356,4440\n5325,Globe Life Field,Globe Life Field,-16,6.3,388.79702661160695,-107,374,-1284,4488\n5325,Globe Life Field,Globe Life Field,-15,6.3,390.5762540276661,-101,377,-1212,4524\n5325,Globe Life Field,Globe Life Field,-14,6.3,392.49194712567856,-95,381,-1140,4572\n5325,Globe Life Field,Globe Life Field,-13,6.3,394.5473002871019,-89,384,-1068,4608\n5325,Globe Life Field,Globe Life Field,-12,6.3,396.7457820121655,-82,388,-984,4656\n5325,Globe Life Field,Globe Life Field,-11,6.3,399.09114983623635,-76,392,-912,4704\n5325,Globe Life Field,Globe Life Field,-10,6.3,401.5874667750772,-70,395,-840,4740\n5325,Globe Life Field,Globe Life Field,-9,6.3,404.2391194386895,-63,399,-756,4788\n5325,Globe Life Field,Globe Life Field,-8,6.3,407.05083797105334,-57,403,-684,4836\n5325,Globe Life Field,Globe Life Field,-7,8.05,409.5425214445896,-50,406,-600,4872\n5325,Globe Life Field,Globe Life Field,-6,8.05,408.7078778642592,-43,406,-516,4872\n5325,Globe Life Field,Globe Life Field,-5,8.05,408.0006575398901,-36,406,-432,4872\n5325,Globe Life Field,Globe Life Field,-4,8.05,407.4197701413301,-28,406,-336,4872\n5325,Globe Life Field,Globe Life Field,-3,8.05,406.9643234896754,-21,406,-252,4872\n5325,Globe Life Field,Globe Life Field,-2,8.05,406.63362019963984,-14,406,-168,4872\n5325,Globe Life Field,Globe Life Field,-1,8.05,406.42715506663274,-7,406,-84,4872\n5325,Globe Life Field,Globe Life Field,0,8.05,406.34461318026854,0,406,0,4872\n5325,Globe Life Field,Globe Life Field,1,8.05,406.38586875117267,7,406,84,4872\n5325,Globe Life Field,Globe Life Field,2,8.05,406.5509846429378,14,406,168,4872\n5325,Globe Life Field,Globe Life Field,3,8.05,406.8402126059889,21,406,252,4872\n5325,Globe Life Field,Globe Life Field,4,8.05,407.2539942149746,28,406,336,4872\n5325,Globe Life Field,Globe Life Field,5,8.05,407.7929625161903,36,406,432,4872\n5325,Globe Life Field,Globe Life Field,6,8.05,408.45794439649035,43,406,516,4872\n5325,Globe Life Field,Globe Life Field,7,8.05,409.2499636902305,50,406,600,4872\n5325,Globe Life Field,Globe Life Field,8,8.05,410.1702450460531,57,406,684,4872\n5325,Globe Life Field,Globe Life Field,9,6.43,410.7515750557466,64,406,768,4872\n5325,Globe Life Field,Globe Life Field,10,6.43,405.66300380998797,70,400,840,4800\n5325,Globe Life Field,Globe Life Field,11,6.43,400.8195681591146,76,393,912,4716\n5325,Globe Life Field,Globe Life Field,12,6.43,396.2096901739237,82,388,984,4656\n5325,Globe Life Field,Globe Life Field,13,6.43,391.822640001457,88,382,1056,4584\n5325,Globe Life Field,Globe Life Field,14,6.43,387.6484658602482,94,376,1128,4512\n5325,Globe Life Field,Globe Life Field,15,6.43,383.67793113719523,99,371,1188,4452\n5325,Globe Life Field,Globe Life Field,16,6.43,379.9024577761954,105,365,1260,4380\n5325,Globe Life Field,Globe Life Field,17,6.43,376.3140752536122,110,360,1320,4320\n5325,Globe Life Field,Globe Life Field,18,6.43,372.9053745256003,115,355,1380,4260\n5325,Globe Life Field,Globe Life Field,19,6.35,374.20559661942866,122,354,1464,4248\n5325,Globe Life Field,Globe Life Field,20,6.35,377.91490589887155,129,355,1548,4260\n5325,Globe Life Field,Globe Life Field,21,9.74,379.2749962737646,136,354,1632,4248\n5325,Globe Life Field,Globe Life Field,22,9.74,376.3983305246914,141,349,1692,4188\n5325,Globe Life Field,Globe Life Field,23,9.74,373.67794235704866,146,344,1752,4128\n5325,Globe Life Field,Globe Life Field,24,9.74,371.1088269875769,151,339,1812,4068\n5325,Globe Life Field,Globe Life Field,25,9.74,368.68633540736926,156,334,1872,4008\n5325,Globe Life Field,Globe Life Field,26,9.74,366.40615239646655,161,329,1932,3948\n5325,Globe Life Field,Globe Life Field,27,9.74,364.264276544131,165,325,1980,3900\n5325,Globe Life Field,Globe Life Field,28,8.07,359.70253800439633,169,318,2028,3816\n5325,Globe Life Field,Globe Life Field,29,8.07,357.84192654042846,173,313,2076,3756\n5325,Globe Life Field,Globe Life Field,30,8.07,356.108380419406,178,308,2136,3696\n5325,Globe Life Field,Globe Life Field,31,8.07,354.4990126995072,183,304,2196,3648\n5325,Globe Life Field,Globe Life Field,32,8.07,353.01117287451245,187,299,2244,3588\n5325,Globe Life Field,Globe Life Field,33,8.07,351.6424358551152,192,295,2304,3540\n5325,Globe Life Field,Globe Life Field,34,8.07,350.3905920329291,196,290,2352,3480\n5325,Globe Life Field,Globe Life Field,35,8.07,349.2536383493263,200,286,2400,3432\n5325,Globe Life Field,Globe Life Field,36,8.07,348.229770300286,205,282,2460,3384\n5325,Globe Life Field,Globe Life Field,37,8.07,347.3173748166096,209,277,2508,3324\n5325,Globe Life Field,Globe Life Field,38,8.07,346.5150239662835,213,273,2556,3276\n5325,Globe Life Field,Globe Life Field,39,8.07,345.8214694325391,218,269,2616,3228\n5325,Globe Life Field,Globe Life Field,40,8.03,342.72765621602696,220,263,2640,3156\n5325,Globe Life Field,Globe Life Field,41,8.03,337.9952372820673,222,255,2664,3060\n5325,Globe Life Field,Globe Life Field,42,8.03,333.4919310692303,223,248,2676,2976\n5325,Globe Life Field,Globe Life Field,43,8.03,329.2060081829761,225,241,2700,2892\n5325,Globe Life Field,Globe Life Field,44,8.03,325.1266299724921,226,234,2712,2808\n5325,Globe Life Field,Globe Life Field,45,8.03,321.24377032791983,227,227,2724,2724\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-45,20.5,341.00213196472464,-241,241,-2892,2892\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-44,20.5,341.0350593297078,-237,245,-2844,2940\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-43,20.5,341.1074782833649,-233,249,-2796,2988\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-42,14,341.36401174453965,-228,254,-2736,3048\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-41,14,341.7286196508739,-224,258,-2688,3096\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-40,14,342.19835564669063,-220,262,-2640,3144\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-39,14,342.7739407910978,-216,266,-2592,3192\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-38,14,343.4562618658726,-211,271,-2532,3252\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-37,14,344.2463747278476,-207,275,-2484,3300\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-36,14,345.1455083259724,-203,279,-2436,3348\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-35,14,346.1550694117138,-199,284,-2388,3408\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-34,14,347.27664797672395,-194,288,-2328,3456\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-33,14,348.5120234573755,-190,292,-2280,3504\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-32,14,349.8631717518952,-185,297,-2220,3564\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-31,14,351.3322731025169,-181,301,-2172,3612\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-30,14,352.92172090239313,-176,306,-2112,3672\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-29,14,354.63413149507534,-172,310,-2064,3720\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-28,14,356.472355043297,-167,315,-2004,3780\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-27,14,358.43948755370155,-163,319,-1956,3828\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-26,14,360.53888415521715,-158,324,-1896,3888\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-25,14,362.7741737411415,-153,329,-1836,3948\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-24,14,365.14927509888923,-149,334,-1788,4008\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-23,14,367.6684146669736,-144,338,-1728,4056\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-22,14,370.33614607644495,-139,343,-1668,4116\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-21,14,373.15737165397246,-134,348,-1608,4176\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-20,14,376.13736608642307,-129,353,-1548,4236\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-19,14,379.2818024725704,-123,359,-1476,4308\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-18,14,382.6073192059126,-118,364,-1416,4368\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-17,14,386.1119360185041,-113,369,-1356,4428\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-16,14,389.80118460982044,-107,375,-1284,4500\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-15,14,393.6826903204993,-102,380,-1224,4560\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-14,14,397.7646565044239,-96,386,-1152,4632\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-13,14,402.05591199232146,-90,392,-1080,4704\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-12,9,404.0809509738187,-84,395,-1008,4740\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-11,9,404.26501380655213,-77,397,-924,4764\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-10,9,404.57253727569946,-70,398,-840,4776\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-9,9,405.00399102214766,-63,400,-756,4800\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-8,9,405.5600353950608,-56,402,-672,4824\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-7,9,406.24152392441437,-50,403,-600,4836\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-6,9,407.049506530478,-43,405,-516,4860\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-5,9,407.98523349280623,-36,406,-432,4872\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-4,9,409.05016020681364,-29,408,-348,4896\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-3,9,410.24595276187745,-21,410,-252,4920\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-2,9,411.5744943811408,-14,411,-168,4932\n5355,Las Vegas Ballpark,Las Vegas Ballpark,-1,9,413.0378927699138,-7,413,-84,4956\n5355,Las Vegas Ballpark,Las Vegas Ballpark,0,9,414.6000218447755,0,415,0,4980\n5355,Las Vegas Ballpark,Las Vegas Ballpark,1,9,412.9430726252263,7,413,84,4956\n5355,Las Vegas Ballpark,Las Vegas Ballpark,2,9,409.0371592141304,14,409,168,4908\n5355,Las Vegas Ballpark,Las Vegas Ballpark,3,9,405.3267529035635,21,405,252,4860\n5355,Las Vegas Ballpark,Las Vegas Ballpark,4,9,401.8043494423504,28,401,336,4812\n5355,Las Vegas Ballpark,Las Vegas Ballpark,5,9,398.46296986645444,35,397,420,4764\n5355,Las Vegas Ballpark,Las Vegas Ballpark,6,9,395.29612331618506,41,393,492,4716\n5355,Las Vegas Ballpark,Las Vegas Ballpark,7,9,392.2977733282292,48,389,576,4668\n5355,Las Vegas Ballpark,Las Vegas Ballpark,8,9,389.4623072531069,54,386,648,4632\n5355,Las Vegas Ballpark,Las Vegas Ballpark,9,9,386.78450848981487,61,382,732,4584\n5355,Las Vegas Ballpark,Las Vegas Ballpark,10,9,384.25953126534665,67,378,804,4536\n5355,Las Vegas Ballpark,Las Vegas Ballpark,11,9,381.8828777181889,73,375,876,4500\n5355,Las Vegas Ballpark,Las Vegas Ballpark,12,9,380.9080798425834,79,373,948,4476\n5355,Las Vegas Ballpark,Las Vegas Ballpark,13,9,383.472815533598,86,374,1032,4488\n5355,Las Vegas Ballpark,Las Vegas Ballpark,14,9,386.19075807470756,93,375,1116,4500\n5355,Las Vegas Ballpark,Las Vegas Ballpark,15,9,389.0668631154058,101,376,1212,4512\n5355,Las Vegas Ballpark,Las Vegas Ballpark,16,9,387.68059623486477,107,373,1284,4476\n5355,Las Vegas Ballpark,Las Vegas Ballpark,17,9,384.0506890149453,112,367,1344,4404\n5355,Las Vegas Ballpark,Las Vegas Ballpark,18,9,380.6029858001254,118,362,1416,4344\n5355,Las Vegas Ballpark,Las Vegas Ballpark,19,9,377.31259507873415,123,357,1476,4284\n5355,Las Vegas Ballpark,Las Vegas Ballpark,20,9,374.1809011982201,128,352,1536,4224\n5355,Las Vegas Ballpark,Las Vegas Ballpark,21,9,371.21290974366747,133,347,1596,4164\n5355,Las Vegas Ballpark,Las Vegas Ballpark,22,9,368.4029677928123,138,342,1656,4104\n5355,Las Vegas Ballpark,Las Vegas Ballpark,23,9,365.74581937710434,143,337,1716,4044\n5355,Las Vegas Ballpark,Las Vegas Ballpark,24,9,363.2365795069223,148,332,1776,3984\n5355,Las Vegas Ballpark,Las Vegas Ballpark,25,9,360.8707105771217,153,327,1836,3924\n5355,Las Vegas Ballpark,Las Vegas Ballpark,26,9,358.64400092779846,157,322,1884,3864\n5355,Las Vegas Ballpark,Las Vegas Ballpark,27,9,356.55254536088347,162,318,1944,3816\n5355,Las Vegas Ballpark,Las Vegas Ballpark,28,9,354.59272743579385,166,313,1992,3756\n5355,Las Vegas Ballpark,Las Vegas Ballpark,29,9,352.76120338729453,171,309,2052,3708\n5355,Las Vegas Ballpark,Las Vegas Ballpark,30,9,351.0548875263261,176,304,2112,3648\n5355,Las Vegas Ballpark,Las Vegas Ballpark,31,9,349.47093900014613,180,300,2160,3600\n5355,Las Vegas Ballpark,Las Vegas Ballpark,32,9,348.0067498019774,184,295,2208,3540\n5355,Las Vegas Ballpark,Las Vegas Ballpark,33,9,346.6599339326973,189,291,2268,3492\n5355,Las Vegas Ballpark,Las Vegas Ballpark,34,9,345.42831762812267,193,286,2316,3432\n5355,Las Vegas Ballpark,Las Vegas Ballpark,35,9,344.30993057533453,197,282,2364,3384\n5355,Las Vegas Ballpark,Las Vegas Ballpark,36,9,343.30299805038464,202,278,2424,3336\n5355,Las Vegas Ballpark,Las Vegas Ballpark,37,9,342.4059339177674,206,273,2472,3276\n5355,Las Vegas Ballpark,Las Vegas Ballpark,38,9,341.6173344393469,210,269,2520,3228\n5355,Las Vegas Ballpark,Las Vegas Ballpark,39,9,340.9359728470877,215,265,2580,3180\n5355,Las Vegas Ballpark,Las Vegas Ballpark,40,9,340.36079464005707,219,261,2628,3132\n5355,Las Vegas Ballpark,Las Vegas Ballpark,41,9,339.890913571812,223,257,2676,3084\n5355,Las Vegas Ballpark,Las Vegas Ballpark,42,9,339.5256082995347,227,252,2724,3024\n5355,Las Vegas Ballpark,Las Vegas Ballpark,43,9,339.2728163420288,231,248,2772,2976\n5355,Las Vegas Ballpark,Las Vegas Ballpark,44,20.5,339.19640145749224,236,244,2832,2928\n5355,Las Vegas Ballpark,Las Vegas Ballpark,45,20.5,339.16365494428214,240,240,2880,2880\n5445,Field of Dreams,Field of Dreams,-45,7,334.9996157624465,-237,237,-2844,2844\n5445,Field of Dreams,Field of Dreams,-44,7,335.127641616322,-233,241,-2796,2892\n5445,Field of Dreams,Field of Dreams,-43,7,335.3579576993207,-229,245,-2748,2940\n5445,Field of Dreams,Field of Dreams,-42,7,335.6909155965107,-225,249,-2700,2988\n5445,Field of Dreams,Field of Dreams,-41,7,336.1270246044452,-221,254,-2652,3048\n5445,Field of Dreams,Field of Dreams,-40,7,336.66695363646306,-216,258,-2592,3096\n5445,Field of Dreams,Field of Dreams,-39,7,337.3115337351536,-212,262,-2544,3144\n5445,Field of Dreams,Field of Dreams,-38,7,338.06176120961254,-208,266,-2496,3192\n5445,Field of Dreams,Field of Dreams,-37,7,338.9188014196519,-204,271,-2448,3252\n5445,Field of Dreams,Field of Dreams,-36,7,339.8839932339033,-200,275,-2400,3300\n5445,Field of Dreams,Field of Dreams,-35,7,340.95885419384825,-196,279,-2352,3348\n5445,Field of Dreams,Field of Dreams,-34,7,342.1450864212781,-191,284,-2292,3408\n5445,Field of Dreams,Field of Dreams,-33,7,343.4445833125905,-187,288,-2244,3456\n5445,Field of Dreams,Field of Dreams,-32,7,344.85943706976013,-183,292,-2196,3504\n5445,Field of Dreams,Field of Dreams,-31,7,346.39194712485414,-178,297,-2136,3564\n5445,Field of Dreams,Field of Dreams,-30,7,348.0446295227003,-174,301,-2088,3612\n5445,Field of Dreams,Field of Dreams,-29,7,349.8202273348647,-170,306,-2040,3672\n5445,Field of Dreams,Field of Dreams,-28,7,351.7217221875849,-165,311,-1980,3732\n5445,Field of Dreams,Field of Dreams,-27,7,353.7523469968772,-161,315,-1932,3780\n5445,Field of Dreams,Field of Dreams,-26,7,355.9156000158506,-156,320,-1872,3840\n5445,Field of Dreams,Field of Dreams,-25,7,358.21526031251915,-151,325,-1812,3900\n5445,Field of Dreams,Field of Dreams,-24,7,360.65540481131285,-147,329,-1764,3948\n5445,Field of Dreams,Field of Dreams,-23,7,363.24042704831015,-142,334,-1704,4008\n5445,Field of Dreams,Field of Dreams,-22,7,365.97505780924735,-137,339,-1644,4068\n5445,Field of Dreams,Field of Dreams,-21,7,368.8643878409369,-132,344,-1584,4128\n5445,Field of Dreams,Field of Dreams,-20,7,371.91389285127025,-127,349,-1524,4188\n5445,Field of Dreams,Field of Dreams,-19,7,375.1294610409432,-122,355,-1464,4260\n5445,Field of Dreams,Field of Dreams,-18,7,378.51742344199783,-117,360,-1404,4320\n5445,Field of Dreams,Field of Dreams,-17,7,382.0845873748664,-112,365,-1344,4380\n5445,Field of Dreams,Field of Dreams,-16,7,385.8382733776138,-106,371,-1272,4452\n5445,Field of Dreams,Field of Dreams,-15,7,389.7863560094225,-101,377,-1212,4524\n5445,Field of Dreams,Field of Dreams,-14,7,393.9373089861271,-95,382,-1140,4584\n5445,Field of Dreams,Field of Dreams,-13,7,398.3002551701152,-90,388,-1080,4656\n5445,Field of Dreams,Field of Dreams,-12,7,402.8850220116807,-84,394,-1008,4728\n5445,Field of Dreams,Field of Dreams,-11,7,407.48684517190543,-78,400,-936,4800\n5445,Field of Dreams,Field of Dreams,-10,8,406.1707959264079,-71,400,-852,4800\n5445,Field of Dreams,Field of Dreams,-9,8,404.986185708518,-63,400,-756,4800\n5445,Field of Dreams,Field of Dreams,-8,8,403.9311488344633,-56,400,-672,4800\n5445,Field of Dreams,Field of Dreams,-7,12,403.0040346311474,-49,400,-588,4800\n5445,Field of Dreams,Field of Dreams,-6,12,402.2034010556188,-42,400,-504,4800\n5445,Field of Dreams,Field of Dreams,-5,12,401.528009167906,-35,400,-420,4800\n5445,Field of Dreams,Field of Dreams,-4,12,400.97681841740166,-28,400,-336,4800\n5445,Field of Dreams,Field of Dreams,-3,12,400.54898270916794,-21,400,-252,4800\n5445,Field of Dreams,Field of Dreams,-2,12,400.2438472223266,-14,400,-168,4800\n5445,Field of Dreams,Field of Dreams,-1,12,400.06094595817433,-7,400,-84,4800\n5445,Field of Dreams,Field of Dreams,0,12,400.0000000008911,0,400,0,4800\n5445,Field of Dreams,Field of Dreams,1,12,400.0609164787353,7,400,84,4800\n5445,Field of Dreams,Field of Dreams,2,12,400.2437882185184,14,400,168,4800\n5445,Field of Dreams,Field of Dreams,3,12,400.5488940909632,21,400,252,4800\n5445,Field of Dreams,Field of Dreams,4,12,400.97670004934,28,400,336,4800\n5445,Field of Dreams,Field of Dreams,5,12,401.5278608685883,35,400,420,4800\n5445,Field of Dreams,Field of Dreams,6,12,402.20322259702584,42,400,504,4800\n5445,Field of Dreams,Field of Dreams,7,12,403.003825737781,49,400,588,4800\n5445,Field of Dreams,Field of Dreams,8,8,403.93090918230195,56,400,672,4800\n5445,Field of Dreams,Field of Dreams,9,8,404.9859149237792,63,400,756,4800\n5445,Field of Dreams,Field of Dreams,10,8,406.17049358411026,71,400,852,4800\n5445,Field of Dreams,Field of Dreams,11,8,407.4865107942187,78,400,936,4800\n5445,Field of Dreams,Field of Dreams,12,7,402.8860961169925,84,394,1008,4728\n5445,Field of Dreams,Field of Dreams,13,7,398.3012125339522,90,388,1080,4656\n5445,Field of Dreams,Field of Dreams,14,7,393.9381547855235,95,382,1140,4584\n5445,Field of Dreams,Field of Dreams,15,7,389.7870950219317,101,377,1212,4524\n5445,Field of Dreams,Field of Dreams,16,7,385.8389100134086,106,371,1272,4452\n5445,Field of Dreams,Field of Dreams,17,7,382.08512570559964,112,365,1344,4380\n5445,Field of Dreams,Field of Dreams,18,7,378.51786722678605,117,360,1404,4320\n5445,Field of Dreams,Field of Dreams,19,7,375.1298137497859,122,355,1464,4260\n5445,Field of Dreams,Field of Dreams,20,7,371.91415768618236,127,349,1524,4188\n5445,Field of Dreams,Field of Dreams,21,7,368.8645677550345,132,344,1584,4128\n5445,Field of Dreams,Field of Dreams,22,7,365.975155523998,137,339,1644,4068\n5445,Field of Dreams,Field of Dreams,23,7,363.24044506913606,142,334,1704,4008\n5445,Field of Dreams,Field of Dreams,24,7,360.65534544170816,147,329,1764,3948\n5445,Field of Dreams,Field of Dreams,25,7,358.21512566682844,151,325,1812,3900\n5445,Field of Dreams,Field of Dreams,26,7,355.9153920308344,156,320,1872,3840\n5445,Field of Dreams,Field of Dreams,27,7,353.75206744217917,161,315,1932,3780\n5445,Field of Dreams,Field of Dreams,28,7,351.72137267519827,165,311,1980,3732\n5445,Field of Dreams,Field of Dreams,29,7,349.8198093276891,170,306,2040,3672\n5445,Field of Dreams,Field of Dreams,30,7,348.04414434226476,174,301,2088,3612\n5445,Field of Dreams,Field of Dreams,31,7,346.39139595827686,178,297,2136,3564\n5445,Field of Dreams,Field of Dreams,32,7,344.858820976007,183,292,2196,3504\n5445,Field of Dreams,Field of Dreams,33,7,343.44390322808454,187,288,2244,3456\n5445,Field of Dreams,Field of Dreams,34,7,342.14434316491054,191,284,2292,3408\n5445,Field of Dreams,Field of Dreams,35,7,340.9580484714308,196,279,2352,3348\n5445,Field of Dreams,Field of Dreams,36,7,339.8831256421019,200,275,2400,3300\n5445,Field of Dreams,Field of Dreams,37,7,338.91787244943134,204,271,2448,3252\n5445,Field of Dreams,Field of Dreams,38,7,338.06077124922274,208,266,2496,3192\n5445,Field of Dreams,Field of Dreams,39,7,337.31048307268173,212,262,2544,3144\n5445,Field of Dreams,Field of Dreams,40,7,336.6658424619714,216,258,2592,3096\n5445,Field of Dreams,Field of Dreams,41,7,336.1258530117134,221,254,2652,3048\n5445,Field of Dreams,Field of Dreams,42,7,335.68968358439827,225,249,2700,2988\n5445,Field of Dreams,Field of Dreams,43,7,335.3566651727593,229,245,2748,2940\n5445,Field of Dreams,Field of Dreams,44,7,335.1262883869486,233,241,2796,2892\n5445,Field of Dreams,Field of Dreams,45,7,334.99820154888414,237,237,2844,2844\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-45,8,329.8655028947405,-233,233,-2796,2796\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-44,8,331.2545527119226,-230,238,-2760,2856\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-43,8,332.7571401408175,-227,243,-2724,2916\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-42,8,334.37573952059074,-224,248,-2688,2976\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-41,8,336.1130460086665,-221,254,-2652,3048\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-40,8,337.9719869581668,-217,259,-2604,3108\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-39,8,339.95573448076055,-214,264,-2568,3168\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-38,8,342.0677192991374,-211,270,-2532,3240\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-37,8,344.3116460064618,-207,275,-2484,3300\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-36,8,346.69150986496186,-204,280,-2448,3360\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-35,8,349.2116152925155,-200,286,-2400,3432\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-34,8,351.8765962050058,-197,292,-2364,3504\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-33,8,354.69143840368554,-193,297,-2316,3564\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-32,8,357.6615042212114,-190,303,-2280,3636\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-31,8,360.7925596678611,-186,309,-2232,3708\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-30,8,364.09080435129346,-182,315,-2184,3780\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-29,8,367.56290447970446,-178,321,-2136,3852\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-28,8,371.21602930016036,-174,328,-2088,3936\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-27,8,375.0578913721647,-170,334,-2040,4008\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-26,8,378.75979586267175,-166,340,-1992,4080\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-25,8,379.28949514763315,-160,344,-1920,4128\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-24,8,379.9365725268073,-155,347,-1860,4164\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-23,8,380.7020252425367,-149,350,-1788,4200\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-22,8,381.58703823601473,-143,354,-1716,4248\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-21,8,382.59298865789293,-137,357,-1644,4284\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-20,8,383.7214511500008,-131,361,-1572,4332\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-19,8,384.97420393625356,-125,364,-1500,4368\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-18,8,386.3532357671455,-119,367,-1428,4404\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-17,8,387.84806248155314,-113,371,-1356,4452\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-16,8,389.4163287070537,-107,374,-1284,4488\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-15,8,391.1169507159391,-101,378,-1212,4536\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-14,8,392.95271369270165,-95,381,-1140,4572\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-13,8,394.92665655039417,-89,385,-1068,4620\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-12,8,397.04208465492565,-83,388,-996,4656\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-11,8,399.30258388785825,-76,392,-912,4704\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-10,8,401.71203616313653,-70,396,-840,4752\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-9,8,404.3023889303703,-63,399,-756,4788\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-8,12,403.97139230737577,-56,400,-672,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-7,12,403.0518703183986,-49,400,-588,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-6,12,402.25877851142195,-42,400,-504,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-5,12,401.5908899749268,-35,400,-420,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-4,12,401.04717597203916,-28,400,-336,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-3,12,400.6268020528861,-21,400,-252,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-2,12,400.32912491769395,-14,400,-168,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,-1,12,400.15369000859084,-7,400,-84,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,0,12,400.1009051403717,0,400,0,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,1,12,400.1803388221537,7,400,84,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,2,12,400.3817884401992,14,400,168,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,3,12,400.70556124936473,21,400,252,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,4,12,401.15215185224804,28,400,336,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,5,12,401.7222440460111,35,400,420,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,6,12,402.4167133842398,42,400,504,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,7,12,403.23663047176007,49,400,588,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,8,12,404.1832650155844,56,400,672,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,9,12,405.0222592323585,63,400,756,4800\n6130,Bristol Motor Speedway,Bristol Motor Speedway,10,12,401.07117939464786,70,395,840,4740\n6130,Bristol Motor Speedway,Bristol Motor Speedway,11,12,397.31629925868475,76,390,912,4680\n6130,Bristol Motor Speedway,Bristol Motor Speedway,12,12,393.74990190181194,82,385,984,4620\n6130,Bristol Motor Speedway,Bristol Motor Speedway,13,12,390.36481151121734,88,380,1056,4560\n6130,Bristol Motor Speedway,Bristol Motor Speedway,14,12,387.15435438602987,94,376,1128,4512\n6130,Bristol Motor Speedway,Bristol Motor Speedway,15,12,384.11232360840233,99,371,1188,4452\n6130,Bristol Motor Speedway,Bristol Motor Speedway,16,12,381.2329470093677,105,366,1260,4392\n6130,Bristol Motor Speedway,Bristol Motor Speedway,17,12,378.51085809974205,111,362,1332,4344\n6130,Bristol Motor Speedway,Bristol Motor Speedway,18,12,375.94106967508236,116,358,1392,4296\n6130,Bristol Motor Speedway,Bristol Motor Speedway,19,12,373.5265973590138,122,353,1464,4236\n6130,Bristol Motor Speedway,Bristol Motor Speedway,20,12,371.2664575644555,127,349,1524,4188\n6130,Bristol Motor Speedway,Bristol Motor Speedway,21,12,369.14527356954534,132,345,1584,4140\n6130,Bristol Motor Speedway,Bristol Motor Speedway,22,12,367.15939506577456,138,340,1656,4080\n6130,Bristol Motor Speedway,Bristol Motor Speedway,23,12,365.30544911601237,143,336,1716,4032\n6130,Bristol Motor Speedway,Bristol Motor Speedway,24,12,363.58032551940806,148,332,1776,3984\n6130,Bristol Motor Speedway,Bristol Motor Speedway,25,12,361.9811635447989,153,328,1836,3936\n6130,Bristol Motor Speedway,Bristol Motor Speedway,26,8,360.10469182183806,158,324,1896,3888\n6130,Bristol Motor Speedway,Bristol Motor Speedway,27,8,357.3593300981262,162,318,1944,3816\n6130,Bristol Motor Speedway,Bristol Motor Speedway,28,8,354.76275831428177,167,313,2004,3756\n6130,Bristol Motor Speedway,Bristol Motor Speedway,29,8,352.31019065891854,171,308,2052,3696\n6130,Bristol Motor Speedway,Bristol Motor Speedway,30,8,349.9971812152855,175,303,2100,3636\n6130,Bristol Motor Speedway,Bristol Motor Speedway,31,8,347.8196028867441,179,298,2148,3576\n6130,Bristol Motor Speedway,Bristol Motor Speedway,32,8,345.7736282449187,183,293,2196,3516\n6130,Bristol Motor Speedway,Bristol Motor Speedway,33,8,343.85571212611603,187,288,2244,3456\n6130,Bristol Motor Speedway,Bristol Motor Speedway,34,8,342.06257582128717,191,284,2292,3408\n6130,Bristol Motor Speedway,Bristol Motor Speedway,35,8,340.3911927221791,195,279,2340,3348\n6130,Bristol Motor Speedway,Bristol Motor Speedway,36,8,338.83877530170304,199,274,2388,3288\n6130,Bristol Motor Speedway,Bristol Motor Speedway,37,8,337.4027633202074,203,269,2436,3228\n6130,Bristol Motor Speedway,Bristol Motor Speedway,38,8,336.08081316150094,207,265,2484,3180\n6130,Bristol Motor Speedway,Bristol Motor Speedway,39,8,334.8707882133358,211,260,2532,3120\n6130,Bristol Motor Speedway,Bristol Motor Speedway,40,8,333.7707502167939,215,256,2580,3072\n6130,Bristol Motor Speedway,Bristol Motor Speedway,41,8,332.77895151778057,218,251,2616,3012\n6130,Bristol Motor Speedway,Bristol Motor Speedway,42,8,331.89382816173685,222,247,2664,2964\n6130,Bristol Motor Speedway,Bristol Motor Speedway,43,8,331.11399377986027,226,242,2712,2904\n6130,Bristol Motor Speedway,Bristol Motor Speedway,44,8,330.43823422166895,230,238,2760,2856\n6130,Bristol Motor Speedway,Bristol Motor Speedway,45,8,329.8655028947404,233,233,2796,2796";
var $f73e4c6c39cdd830$var$toRow = function toRow(d) {
    return {
        venueId: +d.venue_id,
        angle: +d.angle,
        x: Math.sin(+d.angle * Math.PI / 180) * d.fence_distance,
        y: Math.cos(+d.angle * Math.PI / 180) * d.fence_distance,
        z: +d.fence_height,
        // distance_top_of_wall doesn't always exist in this spreadsheet :/
        distance: +d.fence_distance,
        height: +d.fence_height
    };
};
var $f73e4c6c39cdd830$var$fencesLidar = module.exports.fencesLidar = (0, $aGeJV.csvParse)($f73e4c6c39cdd830$var$csv, $f73e4c6c39cdd830$var$toRow);
var $f73e4c6c39cdd830$var$fenceMap = module.exports.fenceMap = (0, $f73e4c6c39cdd830$var$_mapValues2["default"])((0, $f73e4c6c39cdd830$var$_groupBy2["default"])($f73e4c6c39cdd830$var$fencesLidar, 'venueId'), function(points) {
    return (0, $f73e4c6c39cdd830$var$_orderBy2["default"])(points, 'angle');
});

});

parcelRegister("ax2xX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPoint = module.exports.toMinPoints = module.exports.toMaxPoints = void 0;

var $7aaef62f4cdd4e3a$var$_groupBy = $7aaef62f4cdd4e3a$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $7aaef62f4cdd4e3a$var$_mapValues = $7aaef62f4cdd4e3a$var$_interopRequireDefault((parcelRequire("7wHWI")));

var $7aaef62f4cdd4e3a$var$_values = $7aaef62f4cdd4e3a$var$_interopRequireDefault((parcelRequire("emlAi")));

var $7aaef62f4cdd4e3a$var$_orderBy = $7aaef62f4cdd4e3a$var$_interopRequireDefault((parcelRequire("4u1Vd")));
function $7aaef62f4cdd4e3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $7aaef62f4cdd4e3a$var$toPoint = module.exports.toPoint = function toPoint(d) {
    return {
        angle: d.angle,
        x: d.fence_x,
        y: d.fence_y,
        z: d.fence_height,
        distance: d.fence_distance
    };
};
var $7aaef62f4cdd4e3a$var$toMinPoints = module.exports.toMinPoints = function toMinPoints(data, field) {
    var byAngle = (0, $7aaef62f4cdd4e3a$var$_groupBy["default"])(data, 'angle');
    var orderedByField = (0, $7aaef62f4cdd4e3a$var$_mapValues["default"])(byAngle, function(d) {
        return (0, $7aaef62f4cdd4e3a$var$_orderBy["default"])(d, field);
    });
    var points = (0, $7aaef62f4cdd4e3a$var$_values["default"])((0, $7aaef62f4cdd4e3a$var$_mapValues["default"])(orderedByField, function(d) {
        return d[0];
    }));
    var ordered = (0, $7aaef62f4cdd4e3a$var$_orderBy["default"])(points, 'angle');
    // console.log('byAngle', byAngle);
    // console.log('orderedByField', orderedByField);
    // console.log('ordered', ordered);
    return ordered.map($7aaef62f4cdd4e3a$var$toPoint);
};
var $7aaef62f4cdd4e3a$var$toMaxPoints = module.exports.toMaxPoints = function toMaxPoints(data, field) {
    var byAngle = (0, $7aaef62f4cdd4e3a$var$_groupBy["default"])(data, 'angle');
    var orderedByAttribute = (0, $7aaef62f4cdd4e3a$var$_mapValues["default"])(byAngle, function(d) {
        return (0, $7aaef62f4cdd4e3a$var$_orderBy["default"])(d, field);
    });
    var points = (0, $7aaef62f4cdd4e3a$var$_values["default"])((0, $7aaef62f4cdd4e3a$var$_mapValues["default"])(orderedByAttribute, function(d) {
        return d[d.length - 1];
    }));
    var ordered = (0, $7aaef62f4cdd4e3a$var$_orderBy["default"])(points, 'angle');
    return ordered.map($7aaef62f4cdd4e3a$var$toPoint);
};

});
parcelRegister("emlAi", function(module, exports) {

var $bksAO = parcelRequire("bksAO");

var $ivNeF = parcelRequire("ivNeF");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $a743dcf81f8bc1f3$var$values(object) {
    return object == null ? [] : $bksAO(object, $ivNeF(object));
}
module.exports = $a743dcf81f8bc1f3$var$values;

});
parcelRegister("bksAO", function(module, exports) {

var $e9Ynw = parcelRequire("e9Ynw");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $83f7bde9ef65ee65$var$baseValues(object, props) {
    return $e9Ynw(props, function(key) {
        return object[key];
    });
}
module.exports = $83f7bde9ef65ee65$var$baseValues;

});




parcelRegister("9qiXz", function(module, exports) {
"use strict";
function $6dc53fcfd20849dd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6dc53fcfd20849dd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6dc53fcfd20849dd$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6dc53fcfd20849dd$var$_react = $6dc53fcfd20849dd$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $6dc53fcfd20849dd$var$THREE = $6dc53fcfd20849dd$var$_interopRequireWildcard((parcelRequire("h8GDa")));

function $6dc53fcfd20849dd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6dc53fcfd20849dd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6dc53fcfd20849dd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6dc53fcfd20849dd$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6dc53fcfd20849dd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ function $6dc53fcfd20849dd$var$BaseLine(_ref) {
    var _ref$side = _ref.side, side = _ref$side === void 0 ? 'l' : _ref$side, _ref$dist = _ref.dist, dist = _ref$dist === void 0 ? 300 : _ref$dist, _ref$position = _ref.position, position = _ref$position === void 0 ? [
        0,
        0,
        3
    ] : _ref$position;
    var mesh = (0, $6dc53fcfd20849dd$var$_react.useRef)();
    var isLeft = side === 'l';
    var width = 1;
    var halfWidth = 0.5 * width;
    var halfLength = 0.5 * dist;
    var theta = isLeft ? 0.25 * Math.PI : -0.25 * Math.PI;
    var translate = {
        x: isLeft ? width : -halfWidth,
        y: 0,
        z: -halfLength - 4
    };
    var geometry = new $6dc53fcfd20849dd$var$THREE.BoxGeometry(width, 0.01, dist);
    var material = new $6dc53fcfd20849dd$var$THREE.MeshPhongMaterial({
        color: 0xf5f5f5
    });
    geometry.translate(translate.x, translate.y, translate.z);
    return /*#__PURE__*/ $6dc53fcfd20849dd$var$_react["default"].createElement("mesh", {
        ref: mesh,
        name: isLeft ? 'left_baseline' : 'right_baseline',
        rotation: [
            0.5 * Math.PI,
            theta,
            0
        ],
        translate: translate,
        position: [
            position[0],
            0,
            2.5
        ],
        geometry: geometry,
        material: material
    });
}
var $6dc53fcfd20849dd$var$_default = module.exports["default"] = $6dc53fcfd20849dd$var$BaseLine;

});

parcelRegister("h093E", function(module, exports) {
"use strict";
function $c60976781bf7c72b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c60976781bf7c72b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c60976781bf7c72b$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c60976781bf7c72b$var$_react = $c60976781bf7c72b$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $c60976781bf7c72b$var$THREE = $c60976781bf7c72b$var$_interopRequireWildcard((parcelRequire("h8GDa")));

function $c60976781bf7c72b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c60976781bf7c72b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c60976781bf7c72b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $c60976781bf7c72b$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c60976781bf7c72b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ function $c60976781bf7c72b$var$BaseLine(_ref) {
    var _ref$side = _ref.side, side = _ref$side === void 0 ? 'l' : _ref$side, _ref$dist = _ref.dist, dist = _ref$dist === void 0 ? 300 : _ref$dist, _ref$position = _ref.position, position = _ref$position === void 0 ? [
        0,
        0,
        3
    ] : _ref$position;
    var mesh = (0, $c60976781bf7c72b$var$_react.useRef)();
    var geometry = new $c60976781bf7c72b$var$THREE.CylinderGeometry(1, 1, 90, 8);
    var material = new $c60976781bf7c72b$var$THREE.MeshBasicMaterial({
        color: 0xaaaa00
    });
    var v;
    var vOffset;
    var offset = 1.5;
    if (side === 'l') {
        v = new $c60976781bf7c72b$var$THREE.Vector3(-1, 1, 0).normalize().multiplyScalar(dist);
        vOffset = new $c60976781bf7c72b$var$THREE.Vector3(-1, -1, 0).normalize().multiplyScalar(offset);
    } else {
        v = new $c60976781bf7c72b$var$THREE.Vector3(1, 1, 0).normalize().multiplyScalar(dist);
        vOffset = new $c60976781bf7c72b$var$THREE.Vector3(1, -1, 0).normalize().multiplyScalar(offset);
    }
    v.add(vOffset);
    return /*#__PURE__*/ $c60976781bf7c72b$var$_react["default"].createElement("mesh", {
        ref: mesh,
        rotation: [
            -0.5 * Math.PI,
            0,
            0
        ],
        name: side === 'l' ? 'left_baseline' : 'right_baseline',
        position: [
            v.x + position[0],
            v.y,
            45
        ],
        geometry: geometry,
        material: material
    });
}
var $c60976781bf7c72b$var$_default = module.exports["default"] = $c60976781bf7c72b$var$BaseLine;

});



parcelRegister("3aUqX", function(module, exports) {
"use strict";
function $24fe14dc4cbf174a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24fe14dc4cbf174a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24fe14dc4cbf174a$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $24fe14dc4cbf174a$var$Camera;

var $24fe14dc4cbf174a$var$_reactDom = $24fe14dc4cbf174a$var$_interopRequireDefault((parcelRequire("f3ft4")));

var $24fe14dc4cbf174a$var$_react = $24fe14dc4cbf174a$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $llL0N = parcelRequire("llL0N");

var $24fe14dc4cbf174a$var$THREE = $24fe14dc4cbf174a$var$_interopRequireWildcard((parcelRequire("h8GDa")));
function $24fe14dc4cbf174a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24fe14dc4cbf174a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24fe14dc4cbf174a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $24fe14dc4cbf174a$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $24fe14dc4cbf174a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $24fe14dc4cbf174a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ // import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// extend({ OrbitControls });
function $24fe14dc4cbf174a$var$Camera(props) {
    var _useThree = (0, $llL0N.useThree)(), camera = _useThree.camera, gl = _useThree.gl;
    gl.shadowMap.type = $24fe14dc4cbf174a$var$THREE.PCFSoftShadowMap;
    gl.shadowMap.enabled = true;
    camera.fov = 75;
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.near = 0.1;
    camera.far = 15000;
    var position = {
        x: 0,
        y: 0,
        z: 500
    };
    if (props.position) {
        var p = props.position;
        var position = {
            x: p[0],
            y: p[1],
            z: p[2]
        };
    }
    var lookAt = {
        x: 0,
        y: 127,
        z: 0
    };
    if (props.lookAt) {
        var la = props.lookAt;
        var lookAt = {
            x: la[0],
            y: la[1],
            z: la[2]
        };
    }
    camera.position.set(position.x, position.y, position.z);
    camera.up.set(0, 1, 1);
    camera.lookAt(new $24fe14dc4cbf174a$var$THREE.Vector3(lookAt.x, lookAt.y, lookAt.z));
    var waiting = true;
    setTimeout(function() {
        waiting = false;
    }, 5000);
    (0, $llL0N.useFrame)(function(_ref) {
        var camera = _ref.camera;
        if (props.isAnimating) {
            if (waiting == false) camera.position.x += 10;
            if (camera.position.x % 600 == 0 && !waiting) {
                waiting = true;
                setTimeout(function() {
                    waiting = false;
                }, 1800);
            }
        }
    });
    /* var st = setTimeout(function() {
      props.parentCallback();
      st = null;
  }, 500); */ return null; // <orbitControls args={[camera, gl.domElement]} />;
}

});

parcelRegister("9BMbT", function(module, exports) {
"use strict";
function $6fecf3770d6d5542$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6fecf3770d6d5542$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6fecf3770d6d5542$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6fecf3770d6d5542$var$_react = $6fecf3770d6d5542$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $6fecf3770d6d5542$var$THREE = $6fecf3770d6d5542$var$_interopRequireWildcard((parcelRequire("h8GDa")));

var $llL0N = parcelRequire("llL0N");

var $6fecf3770d6d5542$var$_Trajectory = $6fecf3770d6d5542$var$_interopRequireDefault((parcelRequire("g7r4t")));
function $6fecf3770d6d5542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $6fecf3770d6d5542$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fecf3770d6d5542$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fecf3770d6d5542$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6fecf3770d6d5542$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6fecf3770d6d5542$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable */ /* Mock Trajectory Data
  const data = [
    {
      polynomial_x: [
        27.41442803575749,
        -70.18051616123861,
        17.08407598318996,
        -4.611170856221415,
        0.9642700567627676,
        -0.15678243470324288,
        0.018482780660988046,
        -0.0013244573787721601,
        0.00004142852081362038,
      ],
      polynomial_y: [
        -55.20183821755383,
        151.1982528759672,
        -54.223969969570376,
        16.10990600476229,
        -3.360033559385342,
        0.4964499549831538,
        -0.050335790278066436,
        0.0031593983350885683,
        -0.00009087582861788655,
      ],
      polynomial_z: [
        -41.919334657074806,
        110.12632683441825,
        -10.397856679817393,
        -5.301545560460903,
        2.310218779696486,
        -0.5422136932317498,
        0.07238640761767902,
        -0.005065950458812853,
        0.0001449962234188665,
      ],
    },
  ];
*/ function $6fecf3770d6d5542$var$BallPath(_ref) {
    var polynomial = _ref.polynomial, position = _ref.position, color = _ref.color, _ref$type = _ref.type, type = _ref$type === void 0 ? 'line' : _ref$type, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, _ref$showSphere = _ref.showSphere, showSphere = _ref$showSphere === void 0 ? false : _ref$showSphere, _ref$isAnimated = _ref.isAnimated, isAnimated = _ref$isAnimated === void 0 ? false : _ref$isAnimated, isFinished = _ref.isFinished, lastUpdate = _ref.lastUpdate;
    var _useThree = (0, $llL0N.useThree)(), camera = _useThree.camera;
    var mesh = (0, $6fecf3770d6d5542$var$_react.useRef)();
    var sphere = (0, $6fecf3770d6d5542$var$_react.useRef)();
    var end = 0;
    var max = null;
    var step = null;
    var endVector;
    var updateLineBuffer = (0, $llL0N.useUpdate)(function(geometry) {
        geometry.setFromPoints(vectors);
        geometry.attributes.position.needsUpdate = true;
        if (isAnimated) geometry.setDrawRange(0, 0);
        max = geometry.attributes.position.count;
        end = 0;
        step = geometry.attributes.position.count / 100;
        endVector = vectors[vectors.length - 1];
    }, []);
    var updateTubeBuffer = (0, $llL0N.useUpdate)(function(geometry) {
        var catmull = new $6fecf3770d6d5542$var$THREE.CatmullRomCurve3(vectors, false);
        var tube = new $6fecf3770d6d5542$var$THREE.TubeGeometry(catmull, 100, 1, 8, false);
        geometry.fromGeometry(tube);
        if (isAnimated) geometry.setDrawRange(0, 0);
        max = geometry.attributes.position.count;
        end = 0;
        step = geometry.attributes.position.count / 100;
        endVector = vectors[vectors.length - 1];
    }, []);
    var vectors = (0, $6fecf3770d6d5542$var$_Trajectory["default"])(polynomial);
    (0, $llL0N.useFrame)(function(state) {
        return animateTrajectory(state);
    });
    var isStart = false;
    if (isAnimated) setTimeout(function() {
        isStart = true;
    }, delay);
    function animateTrajectory(state) {
        if (mesh && mesh.current && isStart) {
            var m = mesh.current;
            if (m && camera.position.x === position[0]) {
                var nMax = max;
                var shootOnce = true;
                if (shootOnce && end + step >= nMax) m.geometry.setDrawRange(max, max);
                else {
                    end = (end + step) % max;
                    var half = end * 0.95;
                    m.geometry.setDrawRange(half, end);
                    if (showSphere) {
                        var scale = 6;
                        sphere.current.material.opacity = 1;
                        var pos = m.geometry.getAttribute('position');
                        var currentLocation = (half + end).toFixed(0) * 3;
                        if (pos.array && pos.array[currentLocation]) {
                            sphere.current.position.x = pos.array[currentLocation];
                            sphere.current.position.y = pos.array[currentLocation + 1];
                            sphere.current.position.z = pos.array[currentLocation + 2];
                        } else {
                            sphere.current.position.x = endVector.x;
                            sphere.current.position.y = endVector.y;
                            sphere.current.position.z = endVector.z;
                        }
                    }
                }
            }
        }
    }
    function triggerShooting() {
        end = 0;
    }
    var trajectory;
    if (type === 'catmull') trajectory = /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("mesh", {
        ref: mesh,
        position: position
    }, /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("meshPhongMaterial", {
        attach: "material",
        color: color || 0xff0000,
        wireframe: false,
        opacity: 1,
        transparent: true,
        shininess: 10,
        side: $6fecf3770d6d5542$var$THREE.DoubleSide,
        depthWrite: true
    }), /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("bufferGeometry", {
        ref: updateTubeBuffer,
        attach: "geometry"
    }));
    else trajectory = /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("line", {
        ref: mesh,
        position: position,
        receiveShadow: true,
        castShadow: false
    }, /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("bufferGeometry", {
        ref: updateLineBuffer,
        attach: "geometry"
    }), /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("lineBasicMaterial", {
        attach: "material",
        color: color || 0xff0000,
        transparent: true,
        opacity: 1
    }));
    var ball = null;
    if (showSphere) ball = /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("mesh", {
        onClick: function onClick(e) {
            triggerShooting();
        },
        ref: sphere,
        visible: true,
        position: vectors[0],
        receiveShadow: true,
        castShadow: true
    }, /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("sphereGeometry", {
        attach: "geometry",
        args: [
            4,
            16,
            16
        ]
    }), /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("meshPhongMaterial", {
        attach: "material",
        color: color || 0xff0000,
        transparent: true,
        opacity: 0
    }));
    return /*#__PURE__*/ $6fecf3770d6d5542$var$_react["default"].createElement("group", {
        onUpdate: function onUpdate() {
            isFinished(lastUpdate);
        }
    }, "$", trajectory, "$", ball);
}
var $6fecf3770d6d5542$var$_default = module.exports["default"] = $6fecf3770d6d5542$var$BallPath;

});
parcelRegister("g7r4t", function(module, exports) {
"use strict";
function $bbc24c9411e316bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bbc24c9411e316bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bbc24c9411e316bb$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $bbc24c9411e316bb$var$getVectorsFromPolynomial;

var $bbc24c9411e316bb$var$_get = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("jWTe4")));

var $bbc24c9411e316bb$var$_filter = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("Aq07U")));

var $bbc24c9411e316bb$var$_findIndex = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("bJjBi")));

var $bbc24c9411e316bb$var$_sum = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("dyAUz")));

var $bbc24c9411e316bb$var$_map = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("fMSWj")));

var $bbc24c9411e316bb$var$_range = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("3NBD0")));

var $bbc24c9411e316bb$var$_underscore = $bbc24c9411e316bb$var$_interopRequireDefault((parcelRequire("clgVw")));

var $bbc24c9411e316bb$var$THREE = $bbc24c9411e316bb$var$_interopRequireWildcard((parcelRequire("h8GDa")));
function $bbc24c9411e316bb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bbc24c9411e316bb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bbc24c9411e316bb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $bbc24c9411e316bb$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $bbc24c9411e316bb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bbc24c9411e316bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $bbc24c9411e316bb$var$getVectorsFromPolynomial(polynomial) {
    var px = (0, $bbc24c9411e316bb$var$_get["default"])(polynomial, 'polynomial_x');
    var py = (0, $bbc24c9411e316bb$var$_get["default"])(polynomial, 'polynomial_y');
    var pz = (0, $bbc24c9411e316bb$var$_get["default"])(polynomial, 'polynomial_z');
    var tEnd = +polynomial.api_end_time;
    // const tEndMs = Math.round(1000 * tEnd),
    var tPlate = +polynomial.api_plate_time;
    var tPlateMs = Math.round(1000 * tPlate);
    // const tTrackEndMs = Math.min(tEndMs, tPlateMs);
    var tTrackEndMs = tPlateMs;
    var pfx = $bbc24c9411e316bb$var$pf(px);
    var pfy = $bbc24c9411e316bb$var$pf(py);
    var pfz = $bbc24c9411e316bb$var$pf(pz);
    var useGivenInterval = false;
    var heightThreshold = 0;
    // var interval = hitSegment.trajectoryData.validTimeInterval;
    var hit = [];
    var start = useGivenInterval ? hit.result.hit.interval[0] : 0;
    var end = useGivenInterval ? hit.result.hit.interval[1] : 7;
    var step = 0.05;
    var pathLen = Math.ceil((end - start) / step);
    var path = new Float32Array(3 * pathLen);
    for(var i = 0; i < pathLen; i++){
        var p = path.subarray(3 * i, 3 * i + 3);
        var t = start + i * step;
        p[0] = pfx(t);
        p[1] = pfy(t);
        p[2] = pfz(t);
    }
    var points = $bbc24c9411e316bb$var$_underscore["default"].values($bbc24c9411e316bb$var$_underscore["default"].groupBy(path, function(n, i) {
        return Math.floor(i / 3);
    }));
    if (!useGivenInterval) {
        points = $bbc24c9411e316bb$var$clipHeadToPlate(points);
        points = $bbc24c9411e316bb$var$clipTailToHeightThreshold(points, heightThreshold);
    }
    path = $bbc24c9411e316bb$var$_underscore["default"].flatten(points);
    var vectors = [];
    for(var _i = 0; _i < points.length; _i++)vectors.push(new $bbc24c9411e316bb$var$THREE.Vector3(points[_i][0], points[_i][1], points[_i][2]));
    return vectors;
}
/**
 * Limits to points up to first point that falls below given height threshold
 * @param points
 * @param height
 */ function $bbc24c9411e316bb$var$clipTailToHeightThreshold(points, height) {
    var halfPoints = 0.5 * points.length;
    var i = (0, $bbc24c9411e316bb$var$_findIndex["default"])(points, function(p, i) {
        return i >= halfPoints && p[2] < height;
    });
    if (i !== -1) return points.slice(0, i);
    return points;
}
/**
 * Filters out points behind the tip of the plate
 * @param points
 */ function $bbc24c9411e316bb$var$clipHeadToPlate(points) {
    return (0, $bbc24c9411e316bb$var$_filter["default"])(points, function(p) {
        return p[1] >= 0;
    });
}
function $bbc24c9411e316bb$var$terms(n, coef) {
    return (0, $bbc24c9411e316bb$var$_map["default"])(coef, function(c, i) {
        return c * Math.pow(n, i);
    });
}
function $bbc24c9411e316bb$var$val(n, coef) {
    return (0, $bbc24c9411e316bb$var$_sum["default"])($bbc24c9411e316bb$var$terms(n, coef));
// if pre-processing, round to 2 decimal places (or even just 1?)
// return _.round(_.sum(terms(n, coef)), 2)
}
/**
 * Generates xyzt samples at specific times
 *  @param polynomial - coefficients
 * @param times - array of sample times, in ms
 */ function $bbc24c9411e316bb$var$toSamples(polynomial, times) {
    var tSec;
    return times.map(function(t) {
        tSec = t / 1000;
        return {
            t: t,
            x: $bbc24c9411e316bb$var$val(tSec, polynomial.x),
            y: $bbc24c9411e316bb$var$val(tSec, polynomial.y),
            z: $bbc24c9411e316bb$var$val(tSec, polynomial.z)
        };
    });
}
/**
 * Generates xyzt samples at even intervals
 * @param polynomial - coefficients
 * @param extent - array of in and out times, in ms
 * @param interval - time between samples, in ms
 */ var $bbc24c9411e316bb$var$SAMPLE_INTERVAL = 34;
function $bbc24c9411e316bb$var$toSamplesEven(polynomial, extent) {
    var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $bbc24c9411e316bb$var$SAMPLE_INTERVAL;
    var times = (0, $bbc24c9411e316bb$var$_range["default"])(extent[0], extent[1], interval);
    times.push(extent[1]);
    return $bbc24c9411e316bb$var$toSamples(polynomial, times);
}
function $bbc24c9411e316bb$var$clampY(points) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.4;
    return (0, $bbc24c9411e316bb$var$_map["default"])(points, function(p) {
        return {
            x: p.x,
            y: Math.max(y, p.y),
            z: p.z
        };
    });
}
function $bbc24c9411e316bb$var$pf(coef) {
    return function(val) {
        var sum = 0;
        if (coef) for(var i = coef.length - 1; i >= 0; i--){
            var c = coef[i];
            sum += c * Math.pow(val, i);
        }
        return sum;
    };
}

});
parcelRegister("dyAUz", function(module, exports) {

var $8NfC6 = parcelRequire("8NfC6");

var $77uJf = parcelRequire("77uJf");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $9deb152aed6f6f72$var$sum(array) {
    return array && array.length ? $8NfC6(array, $77uJf) : 0;
}
module.exports = $9deb152aed6f6f72$var$sum;

});

parcelRegister("fMSWj", function(module, exports) {

var $e9Ynw = parcelRequire("e9Ynw");

var $hUuQW = parcelRequire("hUuQW");

var $f3TrK = parcelRequire("f3TrK");

var $9yDvq = parcelRequire("9yDvq");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $b7e5f494586baf0d$var$map(collection, iteratee) {
    var func = $9yDvq(collection) ? $e9Ynw : $f3TrK;
    return func(collection, $hUuQW(iteratee, 3));
}
module.exports = $b7e5f494586baf0d$var$map;

});

parcelRegister("3NBD0", function(module, exports) {

var $gKe9y = parcelRequire("gKe9y");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $2c4322e07ee8f91c$var$range = $gKe9y();
module.exports = $2c4322e07ee8f91c$var$range;

});
parcelRegister("gKe9y", function(module, exports) {

var $3Xo9e = parcelRequire("3Xo9e");

var $cYbK3 = parcelRequire("cYbK3");

var $fwAkU = parcelRequire("fwAkU");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $c30bebb9f1aa9d4b$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $cYbK3(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $fwAkU(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $fwAkU(end);
        step = step === undefined ? start < end ? 1 : -1 : $fwAkU(step);
        return $3Xo9e(start, end, step, fromRight);
    };
}
module.exports = $c30bebb9f1aa9d4b$var$createRange;

});
parcelRegister("3Xo9e", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2e199d0f5727c3d7$var$nativeCeil = Math.ceil, $2e199d0f5727c3d7$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $2e199d0f5727c3d7$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $2e199d0f5727c3d7$var$nativeMax($2e199d0f5727c3d7$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $2e199d0f5727c3d7$var$baseRange;

});



parcelRegister("clgVw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("giNyT")).default);
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $giNyT = parcelRequire("giNyT");

var $goeSI = parcelRequire("goeSI");
$parcel$exportWildcard(module.exports, $goeSI);

});
parcelRegister("giNyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde4c5b5559c24f4$export$2e2bcd8739ae039);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("goeSI");
var $5DSEc = parcelRequire("5DSEc");
var $goeSI = parcelRequire("goeSI");
// Add all of the Underscore functions to the wrapper object.
var $bde4c5b5559c24f4$var$_ = (0, $5DSEc.default)($goeSI);
// Legacy Node.js API.
$bde4c5b5559c24f4$var$_._ = $bde4c5b5559c24f4$var$_;
var // Export the Underscore API.
$bde4c5b5559c24f4$export$2e2bcd8739ae039 = $bde4c5b5559c24f4$var$_;

});
parcelRegister("goeSI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", () => (parcelRequire("6iQQG")).VERSION);
$parcel$export(module.exports, "restArguments", () => (parcelRequire("bRRTL")).default);
$parcel$export(module.exports, "isObject", () => (parcelRequire("iYzbD")).default);
$parcel$export(module.exports, "isNull", () => (parcelRequire("aDItr")).default);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("1cTIB")).default);
$parcel$export(module.exports, "isBoolean", () => (parcelRequire("dqwBU")).default);
$parcel$export(module.exports, "isElement", () => (parcelRequire("jTt5G")).default);
$parcel$export(module.exports, "isString", () => (parcelRequire("6thfQ")).default);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("lPxOu")).default);
$parcel$export(module.exports, "isDate", () => (parcelRequire("8riLo")).default);
$parcel$export(module.exports, "isRegExp", () => (parcelRequire("cIiNZ")).default);
$parcel$export(module.exports, "isError", () => (parcelRequire("7usxu")).default);
$parcel$export(module.exports, "isSymbol", () => (parcelRequire("jMi0q")).default);
$parcel$export(module.exports, "isArrayBuffer", () => (parcelRequire("9aHE4")).default);
$parcel$export(module.exports, "isDataView", () => (parcelRequire("bYT3N")).default);
$parcel$export(module.exports, "isArray", () => (parcelRequire("5wqba")).default);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("3CoyW")).default);
$parcel$export(module.exports, "isArguments", () => (parcelRequire("4OsVS")).default);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("cfIKD")).default);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("lLvNN")).default);
$parcel$export(module.exports, "isTypedArray", () => (parcelRequire("bH6wg")).default);
$parcel$export(module.exports, "isEmpty", () => (parcelRequire("j5KQq")).default);
$parcel$export(module.exports, "isMatch", () => (parcelRequire("gsgoH")).default);
$parcel$export(module.exports, "isEqual", () => (parcelRequire("B31sg")).default);
$parcel$export(module.exports, "isMap", () => (parcelRequire("7S8IT")).default);
$parcel$export(module.exports, "isWeakMap", () => (parcelRequire("1n9va")).default);
$parcel$export(module.exports, "isSet", () => (parcelRequire("313Zk")).default);
$parcel$export(module.exports, "isWeakSet", () => (parcelRequire("gKkKC")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("6NhpM")).default);
$parcel$export(module.exports, "allKeys", () => (parcelRequire("bf5SX")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("8Dx9d")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("6mrU3")).default);
$parcel$export(module.exports, "invert", () => (parcelRequire("fxzje")).default);
$parcel$export(module.exports, "functions", () => (parcelRequire("ck3Mo")).default);
$parcel$export(module.exports, "methods", () => (parcelRequire("ck3Mo")).default);
$parcel$export(module.exports, "extend", () => (parcelRequire("e2dVt")).default);
$parcel$export(module.exports, "extendOwn", () => (parcelRequire("8PEyZ")).default);
$parcel$export(module.exports, "assign", () => (parcelRequire("8PEyZ")).default);
$parcel$export(module.exports, "defaults", () => (parcelRequire("ggZBt")).default);
$parcel$export(module.exports, "create", () => (parcelRequire("fian7")).default);
$parcel$export(module.exports, "clone", () => (parcelRequire("lsS5Y")).default);
$parcel$export(module.exports, "tap", () => (parcelRequire("dC2V3")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("3CJRY")).default);
$parcel$export(module.exports, "has", () => (parcelRequire("4QEse")).default);
$parcel$export(module.exports, "mapObject", () => (parcelRequire("kyDe7")).default);
$parcel$export(module.exports, "identity", () => (parcelRequire("hKhcs")).default);
$parcel$export(module.exports, "constant", () => (parcelRequire("eXGH7")).default);
$parcel$export(module.exports, "noop", () => (parcelRequire("cLQXb")).default);
$parcel$export(module.exports, "toPath", () => (parcelRequire("dGNA7")).default);
$parcel$export(module.exports, "property", () => (parcelRequire("dnC7d")).default);
$parcel$export(module.exports, "propertyOf", () => (parcelRequire("dzfKt")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("fb4LJ")).default);
$parcel$export(module.exports, "matches", () => (parcelRequire("fb4LJ")).default);
$parcel$export(module.exports, "times", () => (parcelRequire("abL1W")).default);
$parcel$export(module.exports, "random", () => (parcelRequire("8GDbt")).default);
$parcel$export(module.exports, "now", () => (parcelRequire("48JCA")).default);
$parcel$export(module.exports, "escape", () => (parcelRequire("5Jrzy")).default);
$parcel$export(module.exports, "unescape", () => (parcelRequire("dD6xF")).default);
$parcel$export(module.exports, "templateSettings", () => (parcelRequire("ihryk")).default);
$parcel$export(module.exports, "template", () => (parcelRequire("jekwp")).default);
$parcel$export(module.exports, "result", () => (parcelRequire("2Ys54")).default);
$parcel$export(module.exports, "uniqueId", () => (parcelRequire("4raBi")).default);
$parcel$export(module.exports, "chain", () => (parcelRequire("jIJjj")).default);
$parcel$export(module.exports, "iteratee", () => (parcelRequire("60yqm")).default);
$parcel$export(module.exports, "partial", () => (parcelRequire("dhBwm")).default);
$parcel$export(module.exports, "bind", () => (parcelRequire("5a07j")).default);
$parcel$export(module.exports, "bindAll", () => (parcelRequire("8dri8")).default);
$parcel$export(module.exports, "memoize", () => (parcelRequire("20jJS")).default);
$parcel$export(module.exports, "delay", () => (parcelRequire("j04CR")).default);
$parcel$export(module.exports, "defer", () => (parcelRequire("9cyuR")).default);
$parcel$export(module.exports, "throttle", () => (parcelRequire("67z6k")).default);
$parcel$export(module.exports, "debounce", () => (parcelRequire("iYpZW")).default);
$parcel$export(module.exports, "wrap", () => (parcelRequire("dxzdF")).default);
$parcel$export(module.exports, "negate", () => (parcelRequire("gbT7N")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("khL0u")).default);
$parcel$export(module.exports, "after", () => (parcelRequire("13KDJ")).default);
$parcel$export(module.exports, "before", () => (parcelRequire("6sd5P")).default);
$parcel$export(module.exports, "once", () => (parcelRequire("2ymX3")).default);
$parcel$export(module.exports, "findKey", () => (parcelRequire("glwsf")).default);
$parcel$export(module.exports, "findIndex", () => (parcelRequire("fY0vK")).default);
$parcel$export(module.exports, "findLastIndex", () => (parcelRequire("3h0Rl")).default);
$parcel$export(module.exports, "sortedIndex", () => (parcelRequire("mt0Q4")).default);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("6Lf8V")).default);
$parcel$export(module.exports, "lastIndexOf", () => (parcelRequire("7ob71")).default);
$parcel$export(module.exports, "find", () => (parcelRequire("amUyI")).default);
$parcel$export(module.exports, "detect", () => (parcelRequire("amUyI")).default);
$parcel$export(module.exports, "findWhere", () => (parcelRequire("ioNrE")).default);
$parcel$export(module.exports, "each", () => (parcelRequire("62SK1")).default);
$parcel$export(module.exports, "forEach", () => (parcelRequire("62SK1")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("8qLHw")).default);
$parcel$export(module.exports, "collect", () => (parcelRequire("8qLHw")).default);
$parcel$export(module.exports, "reduce", () => (parcelRequire("8S1Ey")).default);
$parcel$export(module.exports, "foldl", () => (parcelRequire("8S1Ey")).default);
$parcel$export(module.exports, "inject", () => (parcelRequire("8S1Ey")).default);
$parcel$export(module.exports, "reduceRight", () => (parcelRequire("jlbhV")).default);
$parcel$export(module.exports, "foldr", () => (parcelRequire("jlbhV")).default);
$parcel$export(module.exports, "filter", () => (parcelRequire("bW0kA")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("bW0kA")).default);
$parcel$export(module.exports, "reject", () => (parcelRequire("gezip")).default);
$parcel$export(module.exports, "every", () => (parcelRequire("eje7J")).default);
$parcel$export(module.exports, "all", () => (parcelRequire("eje7J")).default);
$parcel$export(module.exports, "some", () => (parcelRequire("iLgyx")).default);
$parcel$export(module.exports, "any", () => (parcelRequire("iLgyx")).default);
$parcel$export(module.exports, "contains", () => (parcelRequire("8JjMh")).default);
$parcel$export(module.exports, "includes", () => (parcelRequire("8JjMh")).default);
$parcel$export(module.exports, "include", () => (parcelRequire("8JjMh")).default);
$parcel$export(module.exports, "invoke", () => (parcelRequire("dSdRP")).default);
$parcel$export(module.exports, "pluck", () => (parcelRequire("fRJ8S")).default);
$parcel$export(module.exports, "where", () => (parcelRequire("3uXdq")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("fKyPa")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("8qqjt")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("f6Lt9")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("a4acY")).default);
$parcel$export(module.exports, "sortBy", () => (parcelRequire("g6u94")).default);
$parcel$export(module.exports, "groupBy", () => (parcelRequire("3ttpw")).default);
$parcel$export(module.exports, "indexBy", () => (parcelRequire("dOZeV")).default);
$parcel$export(module.exports, "countBy", () => (parcelRequire("i1sJF")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("cc1Wj")).default);
$parcel$export(module.exports, "toArray", () => (parcelRequire("gCZmx")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("8j91q")).default);
$parcel$export(module.exports, "pick", () => (parcelRequire("fkrOa")).default);
$parcel$export(module.exports, "omit", () => (parcelRequire("59pKP")).default);
$parcel$export(module.exports, "first", () => (parcelRequire("5in42")).default);
$parcel$export(module.exports, "head", () => (parcelRequire("5in42")).default);
$parcel$export(module.exports, "take", () => (parcelRequire("5in42")).default);
$parcel$export(module.exports, "initial", () => (parcelRequire("fnxc5")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("1BGff")).default);
$parcel$export(module.exports, "rest", () => (parcelRequire("bdjiM")).default);
$parcel$export(module.exports, "tail", () => (parcelRequire("bdjiM")).default);
$parcel$export(module.exports, "drop", () => (parcelRequire("bdjiM")).default);
$parcel$export(module.exports, "compact", () => (parcelRequire("bA8FR")).default);
$parcel$export(module.exports, "flatten", () => (parcelRequire("lgeYU")).default);
$parcel$export(module.exports, "without", () => (parcelRequire("9NbpU")).default);
$parcel$export(module.exports, "uniq", () => (parcelRequire("7jjyS")).default);
$parcel$export(module.exports, "unique", () => (parcelRequire("7jjyS")).default);
$parcel$export(module.exports, "union", () => (parcelRequire("jd2LA")).default);
$parcel$export(module.exports, "intersection", () => (parcelRequire("cvJpz")).default);
$parcel$export(module.exports, "difference", () => (parcelRequire("haTgB")).default);
$parcel$export(module.exports, "unzip", () => (parcelRequire("8LUBv")).default);
$parcel$export(module.exports, "transpose", () => (parcelRequire("8LUBv")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("auDrS")).default);
$parcel$export(module.exports, "object", () => (parcelRequire("5OUsm")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("ficcS")).default);
$parcel$export(module.exports, "chunk", () => (parcelRequire("bYgmn")).default);
$parcel$export(module.exports, "mixin", () => (parcelRequire("5DSEc")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("iax1W")).default);
// Named Exports
// =============
//     Underscore.js 1.13.7
//     https://underscorejs.org
//     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $6iQQG = parcelRequire("6iQQG");

var $bRRTL = parcelRequire("bRRTL");

var $iYzbD = parcelRequire("iYzbD");

var $aDItr = parcelRequire("aDItr");

var $1cTIB = parcelRequire("1cTIB");

var $dqwBU = parcelRequire("dqwBU");

var $jTt5G = parcelRequire("jTt5G");

var $6thfQ = parcelRequire("6thfQ");

var $lPxOu = parcelRequire("lPxOu");

var $8riLo = parcelRequire("8riLo");

var $cIiNZ = parcelRequire("cIiNZ");

var $7usxu = parcelRequire("7usxu");

var $jMi0q = parcelRequire("jMi0q");

var $9aHE4 = parcelRequire("9aHE4");

var $bYT3N = parcelRequire("bYT3N");

var $5wqba = parcelRequire("5wqba");

var $3CoyW = parcelRequire("3CoyW");

var $4OsVS = parcelRequire("4OsVS");

var $cfIKD = parcelRequire("cfIKD");

var $lLvNN = parcelRequire("lLvNN");

var $bH6wg = parcelRequire("bH6wg");

var $j5KQq = parcelRequire("j5KQq");

var $gsgoH = parcelRequire("gsgoH");

var $B31sg = parcelRequire("B31sg");

var $7S8IT = parcelRequire("7S8IT");

var $1n9va = parcelRequire("1n9va");

var $313Zk = parcelRequire("313Zk");

var $gKkKC = parcelRequire("gKkKC");

var $6NhpM = parcelRequire("6NhpM");

var $bf5SX = parcelRequire("bf5SX");

var $8Dx9d = parcelRequire("8Dx9d");

var $6mrU3 = parcelRequire("6mrU3");

var $fxzje = parcelRequire("fxzje");

var $ck3Mo = parcelRequire("ck3Mo");

var $e2dVt = parcelRequire("e2dVt");

var $8PEyZ = parcelRequire("8PEyZ");

var $ggZBt = parcelRequire("ggZBt");

var $fian7 = parcelRequire("fian7");

var $lsS5Y = parcelRequire("lsS5Y");

var $dC2V3 = parcelRequire("dC2V3");

var $3CJRY = parcelRequire("3CJRY");

var $4QEse = parcelRequire("4QEse");

var $kyDe7 = parcelRequire("kyDe7");

var $hKhcs = parcelRequire("hKhcs");

var $eXGH7 = parcelRequire("eXGH7");

var $cLQXb = parcelRequire("cLQXb");

var $dGNA7 = parcelRequire("dGNA7");

var $dnC7d = parcelRequire("dnC7d");

var $dzfKt = parcelRequire("dzfKt");

var $fb4LJ = parcelRequire("fb4LJ");

var $abL1W = parcelRequire("abL1W");

var $8GDbt = parcelRequire("8GDbt");

var $48JCA = parcelRequire("48JCA");

var $5Jrzy = parcelRequire("5Jrzy");

var $dD6xF = parcelRequire("dD6xF");

var $ihryk = parcelRequire("ihryk");

var $jekwp = parcelRequire("jekwp");

var $2Ys54 = parcelRequire("2Ys54");

var $4raBi = parcelRequire("4raBi");

var $jIJjj = parcelRequire("jIJjj");

var $60yqm = parcelRequire("60yqm");

var $dhBwm = parcelRequire("dhBwm");

var $5a07j = parcelRequire("5a07j");

var $8dri8 = parcelRequire("8dri8");

var $20jJS = parcelRequire("20jJS");

var $j04CR = parcelRequire("j04CR");

var $9cyuR = parcelRequire("9cyuR");

var $67z6k = parcelRequire("67z6k");

var $iYpZW = parcelRequire("iYpZW");

var $dxzdF = parcelRequire("dxzdF");

var $gbT7N = parcelRequire("gbT7N");

var $khL0u = parcelRequire("khL0u");

var $13KDJ = parcelRequire("13KDJ");

var $6sd5P = parcelRequire("6sd5P");

var $2ymX3 = parcelRequire("2ymX3");

var $glwsf = parcelRequire("glwsf");

var $fY0vK = parcelRequire("fY0vK");

var $3h0Rl = parcelRequire("3h0Rl");

var $mt0Q4 = parcelRequire("mt0Q4");

var $6Lf8V = parcelRequire("6Lf8V");

var $7ob71 = parcelRequire("7ob71");

var $amUyI = parcelRequire("amUyI");

var $ioNrE = parcelRequire("ioNrE");

var $62SK1 = parcelRequire("62SK1");

var $8qLHw = parcelRequire("8qLHw");

var $8S1Ey = parcelRequire("8S1Ey");

var $jlbhV = parcelRequire("jlbhV");

var $bW0kA = parcelRequire("bW0kA");

var $gezip = parcelRequire("gezip");

var $eje7J = parcelRequire("eje7J");

var $iLgyx = parcelRequire("iLgyx");

var $8JjMh = parcelRequire("8JjMh");

var $dSdRP = parcelRequire("dSdRP");

var $fRJ8S = parcelRequire("fRJ8S");

var $3uXdq = parcelRequire("3uXdq");

var $fKyPa = parcelRequire("fKyPa");

var $8qqjt = parcelRequire("8qqjt");

var $f6Lt9 = parcelRequire("f6Lt9");

var $a4acY = parcelRequire("a4acY");

var $g6u94 = parcelRequire("g6u94");

var $3ttpw = parcelRequire("3ttpw");

var $dOZeV = parcelRequire("dOZeV");

var $i1sJF = parcelRequire("i1sJF");

var $cc1Wj = parcelRequire("cc1Wj");

var $gCZmx = parcelRequire("gCZmx");

var $8j91q = parcelRequire("8j91q");

var $fkrOa = parcelRequire("fkrOa");

var $59pKP = parcelRequire("59pKP");

var $5in42 = parcelRequire("5in42");

var $fnxc5 = parcelRequire("fnxc5");

var $1BGff = parcelRequire("1BGff");

var $bdjiM = parcelRequire("bdjiM");

var $bA8FR = parcelRequire("bA8FR");

var $lgeYU = parcelRequire("lgeYU");

var $9NbpU = parcelRequire("9NbpU");

var $7jjyS = parcelRequire("7jjyS");

var $jd2LA = parcelRequire("jd2LA");

var $cvJpz = parcelRequire("cvJpz");

var $haTgB = parcelRequire("haTgB");

var $8LUBv = parcelRequire("8LUBv");

var $auDrS = parcelRequire("auDrS");

var $5OUsm = parcelRequire("5OUsm");

var $ficcS = parcelRequire("ficcS");

var $bYgmn = parcelRequire("bYgmn");

var $5DSEc = parcelRequire("5DSEc");

var $iax1W = parcelRequire("iax1W");

});
parcelRegister("6iQQG", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $496d6b27a342a26b$export$a4ad2735b021c132);
$parcel$export(module.exports, "root", () => $496d6b27a342a26b$export$e8e78c978b129247);
$parcel$export(module.exports, "ArrayProto", () => $496d6b27a342a26b$export$aabeece9448a227a);
$parcel$export(module.exports, "ObjProto", () => $496d6b27a342a26b$export$e77bb59b5e655b3d);
$parcel$export(module.exports, "SymbolProto", () => $496d6b27a342a26b$export$e229dcb397ceea81);
$parcel$export(module.exports, "push", () => $496d6b27a342a26b$export$4cbf152802aa238);
$parcel$export(module.exports, "slice", () => $496d6b27a342a26b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "toString", () => $496d6b27a342a26b$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "hasOwnProperty", () => $496d6b27a342a26b$export$5a15a386532a5ea4);
$parcel$export(module.exports, "supportsArrayBuffer", () => $496d6b27a342a26b$export$20eaf89d899ede58);
$parcel$export(module.exports, "supportsDataView", () => $496d6b27a342a26b$export$a2e478ad34dac33e);
$parcel$export(module.exports, "nativeIsArray", () => $496d6b27a342a26b$export$552cf9b635cef256);
$parcel$export(module.exports, "nativeKeys", () => $496d6b27a342a26b$export$e676cf06d7fd2114);
$parcel$export(module.exports, "nativeCreate", () => $496d6b27a342a26b$export$5b53dc95b548c58c);
$parcel$export(module.exports, "nativeIsView", () => $496d6b27a342a26b$export$35fc70fc5e80d5a7);
$parcel$export(module.exports, "_isNaN", () => $496d6b27a342a26b$export$a739ba33a90be0a1);
$parcel$export(module.exports, "_isFinite", () => $496d6b27a342a26b$export$8b48b92f6c9d5ad);
$parcel$export(module.exports, "hasEnumBug", () => $496d6b27a342a26b$export$7dcea4d27900b116);
$parcel$export(module.exports, "nonEnumerableProps", () => $496d6b27a342a26b$export$f8fa596d5e31cb19);
$parcel$export(module.exports, "MAX_ARRAY_INDEX", () => $496d6b27a342a26b$export$63b3abc5cd28bc48);
// Current version.
var $496d6b27a342a26b$export$a4ad2735b021c132 = '1.13.7';
var $496d6b27a342a26b$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $496d6b27a342a26b$export$aabeece9448a227a = Array.prototype, $496d6b27a342a26b$export$e77bb59b5e655b3d = Object.prototype;
var $496d6b27a342a26b$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $496d6b27a342a26b$export$4cbf152802aa238 = $496d6b27a342a26b$export$aabeece9448a227a.push, $496d6b27a342a26b$export$58adb3bec8346d0f = $496d6b27a342a26b$export$aabeece9448a227a.slice, $496d6b27a342a26b$export$f84e8e69fd4488a5 = $496d6b27a342a26b$export$e77bb59b5e655b3d.toString, $496d6b27a342a26b$export$5a15a386532a5ea4 = $496d6b27a342a26b$export$e77bb59b5e655b3d.hasOwnProperty;
var $496d6b27a342a26b$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $496d6b27a342a26b$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $496d6b27a342a26b$export$552cf9b635cef256 = Array.isArray, $496d6b27a342a26b$export$e676cf06d7fd2114 = Object.keys, $496d6b27a342a26b$export$5b53dc95b548c58c = Object.create, $496d6b27a342a26b$export$35fc70fc5e80d5a7 = $496d6b27a342a26b$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $496d6b27a342a26b$export$a739ba33a90be0a1 = isNaN, $496d6b27a342a26b$export$8b48b92f6c9d5ad = isFinite;
var $496d6b27a342a26b$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $496d6b27a342a26b$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $496d6b27a342a26b$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("bRRTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3e7410a56f7527$export$2e2bcd8739ae039);
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $8a3e7410a56f7527$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("iYzbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd091fec9fd2a66f$export$2e2bcd8739ae039);
// Is a given variable an object?
function $dd091fec9fd2a66f$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("aDItr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf00b7cba54bba5$export$2e2bcd8739ae039);
// Is a given value equal to null?
function $7bf00b7cba54bba5$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("1cTIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1221f1a292003a$export$2e2bcd8739ae039);
// Is a given variable undefined?
function $0e1221f1a292003a$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("dqwBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c66ffd2217bdf68$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $9c66ffd2217bdf68$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $6iQQG.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("jTt5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b9b82f2e01b9ba$export$2e2bcd8739ae039);
// Is a given value a DOM element?
function $e7b9b82f2e01b9ba$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("6thfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b62d5e871c61c55$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $4b62d5e871c61c55$export$2e2bcd8739ae039 = (0, $30JCP.default)('String');

});
parcelRegister("30JCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2314c3662ca748f5$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $2314c3662ca748f5$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $6iQQG.toString).call(obj) === tag;
    };
}

});


parcelRegister("lPxOu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe48970902ffa2ca$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $fe48970902ffa2ca$export$2e2bcd8739ae039 = (0, $30JCP.default)('Number');

});

parcelRegister("8riLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $624f665e4a60f2ca$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $624f665e4a60f2ca$export$2e2bcd8739ae039 = (0, $30JCP.default)('Date');

});

parcelRegister("cIiNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $94182e6bf267a27f$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $94182e6bf267a27f$export$2e2bcd8739ae039 = (0, $30JCP.default)('RegExp');

});

parcelRegister("7usxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $57417907b308ca0b$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $57417907b308ca0b$export$2e2bcd8739ae039 = (0, $30JCP.default)('Error');

});

parcelRegister("jMi0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e660779c2d510b8c$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $e660779c2d510b8c$export$2e2bcd8739ae039 = (0, $30JCP.default)('Symbol');

});

parcelRegister("9aHE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad6e74017df09bd$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $6ad6e74017df09bd$export$2e2bcd8739ae039 = (0, $30JCP.default)('ArrayBuffer');

});

parcelRegister("bYT3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b900223019123e0$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $3CoyW = parcelRequire("3CoyW");

var $9aHE4 = parcelRequire("9aHE4");

var $5YBY8 = parcelRequire("5YBY8");
var $8b900223019123e0$var$isDataView = (0, $30JCP.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $8b900223019123e0$var$alternateIsDataView(obj) {
    return obj != null && (0, $3CoyW.default)(obj.getInt8) && (0, $9aHE4.default)(obj.buffer);
}
var $8b900223019123e0$export$2e2bcd8739ae039 = (0, $5YBY8.hasDataViewBug) ? $8b900223019123e0$var$alternateIsDataView : $8b900223019123e0$var$isDataView;

});
parcelRegister("3CoyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a27f95227baa0b9$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $6iQQG = parcelRequire("6iQQG");
var $2a27f95227baa0b9$var$isFunction = (0, $30JCP.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $2a27f95227baa0b9$var$nodelist = (0, $6iQQG.root).document && (0, $6iQQG.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $2a27f95227baa0b9$var$nodelist != 'function') $2a27f95227baa0b9$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $2a27f95227baa0b9$export$2e2bcd8739ae039 = $2a27f95227baa0b9$var$isFunction;

});

parcelRegister("5YBY8", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", () => $45a00232963b5815$export$29b9ed4126fa90ab);
$parcel$export(module.exports, "isIE11", () => $45a00232963b5815$export$f7bad96d83325a34);

var $6iQQG = parcelRequire("6iQQG");

var $4bC4P = parcelRequire("4bC4P");
var $45a00232963b5815$export$29b9ed4126fa90ab = (0, $6iQQG.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $4bC4P.default)(new DataView(new ArrayBuffer(8)))), $45a00232963b5815$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $4bC4P.default)(new Map);

});
parcelRegister("4bC4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c5b9ce1c60d294$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $30c5b9ce1c60d294$export$2e2bcd8739ae039 = (0, $30JCP.default)('Object');

});



parcelRegister("5wqba", function(module, exports) {

$parcel$export(module.exports, "default", () => $01099ded7acac9ec$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");

var $30JCP = parcelRequire("30JCP");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$01099ded7acac9ec$export$2e2bcd8739ae039 = (0, $6iQQG.nativeIsArray) || (0, $30JCP.default)('Array');

});

parcelRegister("4OsVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $38124654c3ce28e5$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $frTbd = parcelRequire("frTbd");
var $38124654c3ce28e5$var$isArguments = (0, $30JCP.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$38124654c3ce28e5$var$isArguments(arguments)) $38124654c3ce28e5$var$isArguments = function(obj) {
        return (0, $frTbd.default)(obj, 'callee');
    };
})();
var $38124654c3ce28e5$export$2e2bcd8739ae039 = $38124654c3ce28e5$var$isArguments;

});
parcelRegister("frTbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f42e36854333b9$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $b3f42e36854333b9$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $6iQQG.hasOwnProperty).call(obj, key);
}

});


parcelRegister("cfIKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb999628ba30188$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");

var $jMi0q = parcelRequire("jMi0q");
function $8eb999628ba30188$export$2e2bcd8739ae039(obj) {
    return !(0, $jMi0q.default)(obj) && (0, $6iQQG._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("lLvNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd86a803ee0e2848$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");

var $lPxOu = parcelRequire("lPxOu");
function $fd86a803ee0e2848$export$2e2bcd8739ae039(obj) {
    return (0, $lPxOu.default)(obj) && (0, $6iQQG._isNaN)(obj);
}

});

parcelRegister("bH6wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8838c47916891a5f$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");

var $bYT3N = parcelRequire("bYT3N");

var $eXGH7 = parcelRequire("eXGH7");

var $kV7Dg = parcelRequire("kV7Dg");
// Is a given value a typed array?
var $8838c47916891a5f$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $8838c47916891a5f$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $6iQQG.nativeIsView) ? (0, $6iQQG.nativeIsView)(obj) && !(0, $bYT3N.default)(obj) : (0, $kV7Dg.default)(obj) && $8838c47916891a5f$var$typedArrayPattern.test((0, $6iQQG.toString).call(obj));
}
var $8838c47916891a5f$export$2e2bcd8739ae039 = (0, $6iQQG.supportsArrayBuffer) ? $8838c47916891a5f$var$isTypedArray : (0, $eXGH7.default)(false);

});
parcelRegister("eXGH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae47b19534d165d1$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $ae47b19534d165d1$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("kV7Dg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3af0d1b8ef567db$export$2e2bcd8739ae039);

var $cGExt = parcelRequire("cGExt");

var $6DmBr = parcelRequire("6DmBr");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$f3af0d1b8ef567db$export$2e2bcd8739ae039 = (0, $cGExt.default)((0, $6DmBr.default));

});
parcelRegister("cGExt", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c8da7045f49a8f$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $93c8da7045f49a8f$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $6iQQG.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("6DmBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d47eb1548b55af5$export$2e2bcd8739ae039);

var $dBYfv = parcelRequire("dBYfv");
var // Internal helper to obtain the `byteLength` property of an object.
$4d47eb1548b55af5$export$2e2bcd8739ae039 = (0, $dBYfv.default)('byteLength');

});
parcelRegister("dBYfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e8d7744a744c41c$export$2e2bcd8739ae039);
// Internal helper to generate a function to obtain property `key` from `obj`.
function $9e8d7744a744c41c$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("j5KQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de62d24fa5978e2d$export$2e2bcd8739ae039);

var $9AVUV = parcelRequire("9AVUV");

var $5wqba = parcelRequire("5wqba");

var $6thfQ = parcelRequire("6thfQ");

var $4OsVS = parcelRequire("4OsVS");

var $6NhpM = parcelRequire("6NhpM");
function $de62d24fa5978e2d$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $9AVUV.default)(obj);
    if (typeof length == 'number' && ((0, $5wqba.default)(obj) || (0, $6thfQ.default)(obj) || (0, $4OsVS.default)(obj))) return length === 0;
    return (0, $9AVUV.default)((0, $6NhpM.default)(obj)) === 0;
}

});
parcelRegister("9AVUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc4670291a38e99$export$2e2bcd8739ae039);

var $dBYfv = parcelRequire("dBYfv");
var // Internal helper to obtain the `length` property of an object.
$6fc4670291a38e99$export$2e2bcd8739ae039 = (0, $dBYfv.default)('length');

});

parcelRegister("6NhpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f24d3e1fca50789$export$2e2bcd8739ae039);

var $iYzbD = parcelRequire("iYzbD");

var $6iQQG = parcelRequire("6iQQG");

var $frTbd = parcelRequire("frTbd");

var $ky45H = parcelRequire("ky45H");
function $4f24d3e1fca50789$export$2e2bcd8739ae039(obj) {
    if (!(0, $iYzbD.default)(obj)) return [];
    if (0, $6iQQG.nativeKeys) return (0, $6iQQG.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $frTbd.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $6iQQG.hasEnumBug) (0, $ky45H.default)(obj, keys);
    return keys;
}

});
parcelRegister("ky45H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5a27f9cf2d5d3f$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");

var $3CoyW = parcelRequire("3CoyW");

var $frTbd = parcelRequire("frTbd");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $ef5a27f9cf2d5d3f$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $ef5a27f9cf2d5d3f$export$2e2bcd8739ae039(obj, keys) {
    keys = $ef5a27f9cf2d5d3f$var$emulatedSet(keys);
    var nonEnumIdx = (0, $6iQQG.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $3CoyW.default)(constructor) && constructor.prototype || (0, $6iQQG.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $frTbd.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $6iQQG.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("gsgoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfabfb095f76a750$export$2e2bcd8739ae039);

var $6NhpM = parcelRequire("6NhpM");
function $bfabfb095f76a750$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $6NhpM.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("B31sg", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f5cd03d96f52b9$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $6iQQG = parcelRequire("6iQQG");

var $6DmBr = parcelRequire("6DmBr");

var $bH6wg = parcelRequire("bH6wg");

var $3CoyW = parcelRequire("3CoyW");

var $5YBY8 = parcelRequire("5YBY8");

var $bYT3N = parcelRequire("bYT3N");

var $6NhpM = parcelRequire("6NhpM");

var $frTbd = parcelRequire("frTbd");

var $3nZL1 = parcelRequire("3nZL1");
// We use this string twice, so give it a name for minification.
var $06f5cd03d96f52b9$var$tagDataView = '[object DataView]';
// Internal recursive comparison function for `_.isEqual`.
function $06f5cd03d96f52b9$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return $06f5cd03d96f52b9$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $06f5cd03d96f52b9$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $ejzvC.default)) a = a._wrapped;
    if (b instanceof (0, $ejzvC.default)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $6iQQG.toString).call(a);
    if (className !== (0, $6iQQG.toString).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $5YBY8.hasDataViewBug) && className == '[object Object]' && (0, $bYT3N.default)(a)) {
        if (!(0, $bYT3N.default)(b)) return false;
        className = $06f5cd03d96f52b9$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return '' + a === '' + b;
        case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case '[object Symbol]':
            return (0, $6iQQG.SymbolProto).valueOf.call(a) === (0, $6iQQG.SymbolProto).valueOf.call(b);
        case '[object ArrayBuffer]':
        case $06f5cd03d96f52b9$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $06f5cd03d96f52b9$var$deepEq((0, $3nZL1.default)(a), (0, $3nZL1.default)(b), aStack, bStack);
    }
    var areArrays = className === '[object Array]';
    if (!areArrays && (0, $bH6wg.default)(a)) {
        var byteLength = (0, $6DmBr.default)(a);
        if (byteLength !== (0, $6DmBr.default)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != 'object' || typeof b != 'object') return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $3CoyW.default)(aCtor) && aCtor instanceof aCtor && (0, $3CoyW.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$06f5cd03d96f52b9$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $6NhpM.default)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $6NhpM.default)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $frTbd.default)(b, key) && $06f5cd03d96f52b9$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $06f5cd03d96f52b9$export$2e2bcd8739ae039(a, b) {
    return $06f5cd03d96f52b9$var$eq(a, b);
}

});
parcelRegister("ejzvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6be625c3d4a560a$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $a6be625c3d4a560a$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $a6be625c3d4a560a$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $a6be625c3d4a560a$export$2e2bcd8739ae039)) return new $a6be625c3d4a560a$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$a6be625c3d4a560a$export$2e2bcd8739ae039.VERSION = (0, $6iQQG.VERSION);
// Extracts the result from a wrapped and chained object.
$a6be625c3d4a560a$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$a6be625c3d4a560a$export$2e2bcd8739ae039.prototype.valueOf = $a6be625c3d4a560a$export$2e2bcd8739ae039.prototype.toJSON = $a6be625c3d4a560a$export$2e2bcd8739ae039.prototype.value;
$a6be625c3d4a560a$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("3nZL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27736ccac5700920$export$2e2bcd8739ae039);

var $6DmBr = parcelRequire("6DmBr");
function $27736ccac5700920$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $6DmBr.default)(bufferSource));
}

});


parcelRegister("7S8IT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb457c780d85463$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $5YBY8 = parcelRequire("5YBY8");

var $cCpBQ = parcelRequire("cCpBQ");
var $5bb457c780d85463$export$2e2bcd8739ae039 = (0, $5YBY8.isIE11) ? (0, $cCpBQ.ie11fingerprint)((0, $cCpBQ.mapMethods)) : (0, $30JCP.default)('Map');

});
parcelRegister("cCpBQ", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", () => $92fce623f76b5bf5$export$15230eca1f400e40);
$parcel$export(module.exports, "weakMapMethods", () => $92fce623f76b5bf5$export$2f74b890a72cf48);
$parcel$export(module.exports, "mapMethods", () => $92fce623f76b5bf5$export$de9acb94190bb764);
$parcel$export(module.exports, "setMethods", () => $92fce623f76b5bf5$export$60e14a5e2a057f78);

var $9AVUV = parcelRequire("9AVUV");

var $3CoyW = parcelRequire("3CoyW");

var $bf5SX = parcelRequire("bf5SX");
function $92fce623f76b5bf5$export$15230eca1f400e40(methods) {
    var length = (0, $9AVUV.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $bf5SX.default)(obj);
        if ((0, $9AVUV.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $3CoyW.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $92fce623f76b5bf5$export$2f74b890a72cf48 || !(0, $3CoyW.default)(obj[$92fce623f76b5bf5$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $92fce623f76b5bf5$var$forEachName = 'forEach', $92fce623f76b5bf5$var$hasName = 'has', $92fce623f76b5bf5$var$commonInit = [
    'clear',
    'delete'
], $92fce623f76b5bf5$var$mapTail = [
    'get',
    $92fce623f76b5bf5$var$hasName,
    'set'
];
var $92fce623f76b5bf5$export$de9acb94190bb764 = $92fce623f76b5bf5$var$commonInit.concat($92fce623f76b5bf5$var$forEachName, $92fce623f76b5bf5$var$mapTail), $92fce623f76b5bf5$export$2f74b890a72cf48 = $92fce623f76b5bf5$var$commonInit.concat($92fce623f76b5bf5$var$mapTail), $92fce623f76b5bf5$export$60e14a5e2a057f78 = [
    'add'
].concat($92fce623f76b5bf5$var$commonInit, $92fce623f76b5bf5$var$forEachName, $92fce623f76b5bf5$var$hasName);

});
parcelRegister("bf5SX", function(module, exports) {

$parcel$export(module.exports, "default", () => $82f5a92343d68e6e$export$2e2bcd8739ae039);

var $iYzbD = parcelRequire("iYzbD");

var $6iQQG = parcelRequire("6iQQG");

var $ky45H = parcelRequire("ky45H");
function $82f5a92343d68e6e$export$2e2bcd8739ae039(obj) {
    if (!(0, $iYzbD.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $6iQQG.hasEnumBug) (0, $ky45H.default)(obj, keys);
    return keys;
}

});



parcelRegister("1n9va", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fff4f3e2d587ac3$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $5YBY8 = parcelRequire("5YBY8");

var $cCpBQ = parcelRequire("cCpBQ");
var $0fff4f3e2d587ac3$export$2e2bcd8739ae039 = (0, $5YBY8.isIE11) ? (0, $cCpBQ.ie11fingerprint)((0, $cCpBQ.weakMapMethods)) : (0, $30JCP.default)('WeakMap');

});

parcelRegister("313Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $23248f0cd6610fad$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");

var $5YBY8 = parcelRequire("5YBY8");

var $cCpBQ = parcelRequire("cCpBQ");
var $23248f0cd6610fad$export$2e2bcd8739ae039 = (0, $5YBY8.isIE11) ? (0, $cCpBQ.ie11fingerprint)((0, $cCpBQ.setMethods)) : (0, $30JCP.default)('Set');

});

parcelRegister("gKkKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c31109ec4cbbc67c$export$2e2bcd8739ae039);

var $30JCP = parcelRequire("30JCP");
var $c31109ec4cbbc67c$export$2e2bcd8739ae039 = (0, $30JCP.default)('WeakSet');

});

parcelRegister("8Dx9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $649badafe913e33f$export$2e2bcd8739ae039);

var $6NhpM = parcelRequire("6NhpM");
function $649badafe913e33f$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $6NhpM.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("6mrU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0131f990eecd34b5$export$2e2bcd8739ae039);

var $6NhpM = parcelRequire("6NhpM");
function $0131f990eecd34b5$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $6NhpM.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("fxzje", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50553c140f3c326$export$2e2bcd8739ae039);

var $6NhpM = parcelRequire("6NhpM");
function $b50553c140f3c326$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $6NhpM.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("ck3Mo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8a48d17a3c7c10$export$2e2bcd8739ae039);

var $3CoyW = parcelRequire("3CoyW");
function $8f8a48d17a3c7c10$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $3CoyW.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("e2dVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a37c0e00b943f106$export$2e2bcd8739ae039);

var $74WQO = parcelRequire("74WQO");

var $bf5SX = parcelRequire("bf5SX");
var // Extend a given object with all the properties in passed-in object(s).
$a37c0e00b943f106$export$2e2bcd8739ae039 = (0, $74WQO.default)((0, $bf5SX.default));

});
parcelRegister("74WQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $52768eabc51f75f2$export$2e2bcd8739ae039);
// An internal function for creating assigner functions.
function $52768eabc51f75f2$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("8PEyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e28d31f04a4116$export$2e2bcd8739ae039);

var $74WQO = parcelRequire("74WQO");

var $6NhpM = parcelRequire("6NhpM");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$66e28d31f04a4116$export$2e2bcd8739ae039 = (0, $74WQO.default)((0, $6NhpM.default));

});

parcelRegister("ggZBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8ded18a56d013a$export$2e2bcd8739ae039);

var $74WQO = parcelRequire("74WQO");

var $bf5SX = parcelRequire("bf5SX");
var // Fill in a given object with default properties.
$bd8ded18a56d013a$export$2e2bcd8739ae039 = (0, $74WQO.default)((0, $bf5SX.default), true);

});

parcelRegister("fian7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b220951a6524d8ac$export$2e2bcd8739ae039);

var $krMUV = parcelRequire("krMUV");

var $8PEyZ = parcelRequire("8PEyZ");
function $b220951a6524d8ac$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $krMUV.default)(prototype);
    if (props) (0, $8PEyZ.default)(result, props);
    return result;
}

});
parcelRegister("krMUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2c462cc9306957$export$2e2bcd8739ae039);

var $iYzbD = parcelRequire("iYzbD");

var $6iQQG = parcelRequire("6iQQG");
// Create a naked function reference for surrogate-prototype-swapping.
function $ee2c462cc9306957$var$ctor() {
    return function() {};
}
function $ee2c462cc9306957$export$2e2bcd8739ae039(prototype) {
    if (!(0, $iYzbD.default)(prototype)) return {};
    if (0, $6iQQG.nativeCreate) return (0, $6iQQG.nativeCreate)(prototype);
    var Ctor = $ee2c462cc9306957$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("lsS5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa062cb5a83ba829$export$2e2bcd8739ae039);

var $iYzbD = parcelRequire("iYzbD");

var $5wqba = parcelRequire("5wqba");

var $e2dVt = parcelRequire("e2dVt");
function $fa062cb5a83ba829$export$2e2bcd8739ae039(obj) {
    if (!(0, $iYzbD.default)(obj)) return obj;
    return (0, $5wqba.default)(obj) ? obj.slice() : (0, $e2dVt.default)({}, obj);
}

});

parcelRegister("dC2V3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9116a8fadfece5$export$2e2bcd8739ae039);
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $9e9116a8fadfece5$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("3CJRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a388076cea4f5ee$export$2e2bcd8739ae039);

var $b5eL1 = parcelRequire("b5eL1");

var $7dsqy = parcelRequire("7dsqy");

var $1cTIB = parcelRequire("1cTIB");
function $2a388076cea4f5ee$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $7dsqy.default)(object, (0, $b5eL1.default)(path));
    return (0, $1cTIB.default)(value) ? defaultValue : value;
}

});
parcelRegister("b5eL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $811b9bdaa6096ebe$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");
parcelRequire("dGNA7");
function $811b9bdaa6096ebe$export$2e2bcd8739ae039(path) {
    return (0, $ejzvC.default).toPath(path);
}

});
parcelRegister("dGNA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f75a87a02f06b5d$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $5wqba = parcelRequire("5wqba");
function $9f75a87a02f06b5d$export$2e2bcd8739ae039(path) {
    return (0, $5wqba.default)(path) ? path : [
        path
    ];
}
(0, $ejzvC.default).toPath = $9f75a87a02f06b5d$export$2e2bcd8739ae039;

});


parcelRegister("7dsqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $540fcc5b5ccf3310$export$2e2bcd8739ae039);
// Internal function to obtain a nested property in `obj` along `path`.
function $540fcc5b5ccf3310$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("4QEse", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b66270fb8934b$export$2e2bcd8739ae039);

var $frTbd = parcelRequire("frTbd");

var $b5eL1 = parcelRequire("b5eL1");
function $387b66270fb8934b$export$2e2bcd8739ae039(obj, path) {
    path = (0, $b5eL1.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $frTbd.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("kyDe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef756938905b8566$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $6NhpM = parcelRequire("6NhpM");
function $ef756938905b8566$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $ckga9.default)(iteratee, context);
    var _keys = (0, $6NhpM.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("ckga9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f93e3e5780e3edb$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $jnIeS = parcelRequire("jnIeS");

var $60yqm = parcelRequire("60yqm");
function $8f93e3e5780e3edb$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $ejzvC.default).iteratee !== (0, $60yqm.default)) return (0, $ejzvC.default).iteratee(value, context);
    return (0, $jnIeS.default)(value, context, argCount);
}

});
parcelRegister("jnIeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c27b42d1a56ebc$export$2e2bcd8739ae039);

var $hKhcs = parcelRequire("hKhcs");

var $3CoyW = parcelRequire("3CoyW");

var $iYzbD = parcelRequire("iYzbD");

var $5wqba = parcelRequire("5wqba");

var $fb4LJ = parcelRequire("fb4LJ");

var $dnC7d = parcelRequire("dnC7d");

var $aQP0M = parcelRequire("aQP0M");
function $e1c27b42d1a56ebc$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $hKhcs.default;
    if ((0, $3CoyW.default)(value)) return (0, $aQP0M.default)(value, context, argCount);
    if ((0, $iYzbD.default)(value) && !(0, $5wqba.default)(value)) return (0, $fb4LJ.default)(value);
    return (0, $dnC7d.default)(value);
}

});
parcelRegister("hKhcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb413157e44e5ab$export$2e2bcd8739ae039);
// Keep the identity function around for default iteratees.
function $ceb413157e44e5ab$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("fb4LJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cb951784b3d601$export$2e2bcd8739ae039);

var $8PEyZ = parcelRequire("8PEyZ");

var $gsgoH = parcelRequire("gsgoH");
function $b0cb951784b3d601$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $8PEyZ.default)({}, attrs);
    return function(obj) {
        return (0, $gsgoH.default)(obj, attrs);
    };
}

});

parcelRegister("dnC7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bdafd3f78aa2d30$export$2e2bcd8739ae039);

var $7dsqy = parcelRequire("7dsqy");

var $b5eL1 = parcelRequire("b5eL1");
function $9bdafd3f78aa2d30$export$2e2bcd8739ae039(path) {
    path = (0, $b5eL1.default)(path);
    return function(obj) {
        return (0, $7dsqy.default)(obj, path);
    };
}

});

parcelRegister("aQP0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e665487dc9d341d$export$2e2bcd8739ae039);
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $7e665487dc9d341d$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("60yqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45fd7213fc62fa38$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $jnIeS = parcelRequire("jnIeS");
function $45fd7213fc62fa38$export$2e2bcd8739ae039(value, context) {
    return (0, $jnIeS.default)(value, context, Infinity);
}
(0, $ejzvC.default).iteratee = $45fd7213fc62fa38$export$2e2bcd8739ae039;

});



parcelRegister("cLQXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c2f3482d2bdfae$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $94c2f3482d2bdfae$export$2e2bcd8739ae039() {}

});

parcelRegister("dzfKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0ac298c56b0405$export$2e2bcd8739ae039);

var $cLQXb = parcelRequire("cLQXb");

var $3CJRY = parcelRequire("3CJRY");
function $9e0ac298c56b0405$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $cLQXb.default;
    return function(path) {
        return (0, $3CJRY.default)(obj, path);
    };
}

});

parcelRegister("abL1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af69b8b90de1ed$export$2e2bcd8739ae039);

var $aQP0M = parcelRequire("aQP0M");
function $76af69b8b90de1ed$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $aQP0M.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("8GDbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6530a41becb3d73f$export$2e2bcd8739ae039);
// Return a random integer between `min` and `max` (inclusive).
function $6530a41becb3d73f$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("48JCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $303b4c3ce15ddf32$export$2e2bcd8739ae039);
// A (possibly faster) way to get the current timestamp as an integer.
var $303b4c3ce15ddf32$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("5Jrzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c68b0451fec319$export$2e2bcd8739ae039);

var $brjBi = parcelRequire("brjBi");

var $2Zpl3 = parcelRequire("2Zpl3");
var // Function for escaping strings to HTML interpolation.
$42c68b0451fec319$export$2e2bcd8739ae039 = (0, $brjBi.default)((0, $2Zpl3.default));

});
parcelRegister("brjBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $85416b9a6af1d86d$export$2e2bcd8739ae039);

var $6NhpM = parcelRequire("6NhpM");
function $85416b9a6af1d86d$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $6NhpM.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("2Zpl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d4eef85b16aff2$export$2e2bcd8739ae039);
// Internal list of HTML entities for escaping.
var $22d4eef85b16aff2$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("dD6xF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec3fdffe5a58e66$export$2e2bcd8739ae039);

var $brjBi = parcelRequire("brjBi");

var $iYqPy = parcelRequire("iYqPy");
var // Function for unescaping strings from HTML interpolation.
$9ec3fdffe5a58e66$export$2e2bcd8739ae039 = (0, $brjBi.default)((0, $iYqPy.default));

});
parcelRegister("iYqPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd02a498d32e625f$export$2e2bcd8739ae039);

var $fxzje = parcelRequire("fxzje");

var $2Zpl3 = parcelRequire("2Zpl3");
var // Internal list of HTML entities for unescaping.
$dd02a498d32e625f$export$2e2bcd8739ae039 = (0, $fxzje.default)((0, $2Zpl3.default));

});


parcelRegister("ihryk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ef2fe5e188cab8$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$d4ef2fe5e188cab8$export$2e2bcd8739ae039 = (0, $ejzvC.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("jekwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfff3e4b1a8c09d3$export$2e2bcd8739ae039);

var $ggZBt = parcelRequire("ggZBt");

var $ejzvC = parcelRequire("ejzvC");
parcelRequire("ihryk");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $dfff3e4b1a8c09d3$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $dfff3e4b1a8c09d3$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $dfff3e4b1a8c09d3$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $dfff3e4b1a8c09d3$var$escapeChar(match) {
    return '\\' + $dfff3e4b1a8c09d3$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $dfff3e4b1a8c09d3$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $dfff3e4b1a8c09d3$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $ggZBt.default)({}, settings, (0, $ejzvC.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $dfff3e4b1a8c09d3$var$noMatch).source,
        (settings.interpolate || $dfff3e4b1a8c09d3$var$noMatch).source,
        (settings.evaluate || $dfff3e4b1a8c09d3$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($dfff3e4b1a8c09d3$var$escapeRegExp, $dfff3e4b1a8c09d3$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$dfff3e4b1a8c09d3$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $ejzvC.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("2Ys54", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a6f79ef4584684$export$2e2bcd8739ae039);

var $3CoyW = parcelRequire("3CoyW");

var $b5eL1 = parcelRequire("b5eL1");
function $22a6f79ef4584684$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $b5eL1.default)(path);
    var length = path.length;
    if (!length) return (0, $3CoyW.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $3CoyW.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("4raBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b1e813214aa5aa$export$2e2bcd8739ae039);
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $33b1e813214aa5aa$var$idCounter = 0;
function $33b1e813214aa5aa$export$2e2bcd8739ae039(prefix) {
    var id = ++$33b1e813214aa5aa$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("jIJjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5b546178a3d371c$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");
function $e5b546178a3d371c$export$2e2bcd8739ae039(obj) {
    var instance = (0, $ejzvC.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("dhBwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab9f7cb33f79180$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $l5S9M = parcelRequire("l5S9M");

var $ejzvC = parcelRequire("ejzvC");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $9ab9f7cb33f79180$var$partial = (0, $bRRTL.default)(function(func, boundArgs) {
    var placeholder = $9ab9f7cb33f79180$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $l5S9M.default)(func, bound, this, this, args);
    };
    return bound;
});
$9ab9f7cb33f79180$var$partial.placeholder = (0, $ejzvC.default);
var $9ab9f7cb33f79180$export$2e2bcd8739ae039 = $9ab9f7cb33f79180$var$partial;

});
parcelRegister("l5S9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b412fcdc90543a$export$2e2bcd8739ae039);

var $krMUV = parcelRequire("krMUV");

var $iYzbD = parcelRequire("iYzbD");
function $f5b412fcdc90543a$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $krMUV.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $iYzbD.default)(result)) return result;
    return self;
}

});


parcelRegister("5a07j", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c1dfa229722aafb$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $3CoyW = parcelRequire("3CoyW");

var $l5S9M = parcelRequire("l5S9M");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$3c1dfa229722aafb$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(func, context, args) {
    if (!(0, $3CoyW.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $bRRTL.default)(function(callArgs) {
        return (0, $l5S9M.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("8dri8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb4b52d27f39841$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $lYyIg = parcelRequire("lYyIg");

var $5a07j = parcelRequire("5a07j");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$5fb4b52d27f39841$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(obj, keys) {
    keys = (0, $lYyIg.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $5a07j.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("lYyIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fffa20d6f07cdff9$export$2e2bcd8739ae039);

var $9AVUV = parcelRequire("9AVUV");

var $9S3ZU = parcelRequire("9S3ZU");

var $5wqba = parcelRequire("5wqba");

var $4OsVS = parcelRequire("4OsVS");
function $fffa20d6f07cdff9$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $9AVUV.default)(input); i < length; i++){
        var value = input[i];
        if ((0, $9S3ZU.default)(value) && ((0, $5wqba.default)(value) || (0, $4OsVS.default)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $fffa20d6f07cdff9$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("9S3ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $72fc420a024a0fb4$export$2e2bcd8739ae039);

var $cGExt = parcelRequire("cGExt");

var $9AVUV = parcelRequire("9AVUV");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$72fc420a024a0fb4$export$2e2bcd8739ae039 = (0, $cGExt.default)((0, $9AVUV.default));

});



parcelRegister("20jJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $175ae49a1446b064$export$2e2bcd8739ae039);

var $frTbd = parcelRequire("frTbd");
function $175ae49a1446b064$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $frTbd.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("j04CR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd519afb3a698be8$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$dd519afb3a698be8$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("9cyuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2ffe62623fa161$export$2e2bcd8739ae039);

var $dhBwm = parcelRequire("dhBwm");

var $j04CR = parcelRequire("j04CR");

var $ejzvC = parcelRequire("ejzvC");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$6b2ffe62623fa161$export$2e2bcd8739ae039 = (0, $dhBwm.default)((0, $j04CR.default), (0, $ejzvC.default), 1);

});

parcelRegister("67z6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $474e9fde3a2af670$export$2e2bcd8739ae039);

var $48JCA = parcelRequire("48JCA");
function $474e9fde3a2af670$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $48JCA.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $48JCA.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("iYpZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd01ff42c8187c5d$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $48JCA = parcelRequire("48JCA");
function $dd01ff42c8187c5d$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $48JCA.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $bRRTL.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $48JCA.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("dxzdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db9ad4059b57b9e$export$2e2bcd8739ae039);

var $dhBwm = parcelRequire("dhBwm");
function $9db9ad4059b57b9e$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $dhBwm.default)(wrapper, func);
}

});

parcelRegister("gbT7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc986f1070ce5dc1$export$2e2bcd8739ae039);
// Returns a negated version of the passed-in predicate.
function $bc986f1070ce5dc1$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("khL0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec49dbc284bd758a$export$2e2bcd8739ae039);
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $ec49dbc284bd758a$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("13KDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a3ff8080d2904$export$2e2bcd8739ae039);
// Returns a function that will only be executed on and after the Nth call.
function $0c5a3ff8080d2904$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("6sd5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b2f839f4e53e40a$export$2e2bcd8739ae039);
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $4b2f839f4e53e40a$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("2ymX3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc08f708f6ae94b$export$2e2bcd8739ae039);

var $dhBwm = parcelRequire("dhBwm");

var $6sd5P = parcelRequire("6sd5P");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$1dc08f708f6ae94b$export$2e2bcd8739ae039 = (0, $dhBwm.default)((0, $6sd5P.default), 2);

});

parcelRegister("glwsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $be67c84c86ac44f3$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $6NhpM = parcelRequire("6NhpM");
function $be67c84c86ac44f3$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $ckga9.default)(predicate, context);
    var _keys = (0, $6NhpM.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("fY0vK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9fcdb1da22ca596$export$2e2bcd8739ae039);

var $83AXL = parcelRequire("83AXL");
var // Returns the first index on an array-like that passes a truth test.
$b9fcdb1da22ca596$export$2e2bcd8739ae039 = (0, $83AXL.default)(1);

});
parcelRegister("83AXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddb46996656b492$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $9AVUV = parcelRequire("9AVUV");
function $5ddb46996656b492$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $ckga9.default)(predicate, context);
        var length = (0, $9AVUV.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("3h0Rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2623a04917ecefb2$export$2e2bcd8739ae039);

var $83AXL = parcelRequire("83AXL");
var // Returns the last index on an array-like that passes a truth test.
$2623a04917ecefb2$export$2e2bcd8739ae039 = (0, $83AXL.default)(-1);

});

parcelRegister("mt0Q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $04388f78fc3b2b31$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $9AVUV = parcelRequire("9AVUV");
function $04388f78fc3b2b31$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $ckga9.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $9AVUV.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("6Lf8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec2e0f4a94c19f8$export$2e2bcd8739ae039);

var $mt0Q4 = parcelRequire("mt0Q4");

var $fY0vK = parcelRequire("fY0vK");

var $7rUtO = parcelRequire("7rUtO");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$4ec2e0f4a94c19f8$export$2e2bcd8739ae039 = (0, $7rUtO.default)(1, (0, $fY0vK.default), (0, $mt0Q4.default));

});
parcelRegister("7rUtO", function(module, exports) {

$parcel$export(module.exports, "default", () => $56c6ddc066b93316$export$2e2bcd8739ae039);

var $9AVUV = parcelRequire("9AVUV");

var $6iQQG = parcelRequire("6iQQG");

var $lLvNN = parcelRequire("lLvNN");
function $56c6ddc066b93316$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $9AVUV.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $6iQQG.slice).call(array, i, length), (0, $lLvNN.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("7ob71", function(module, exports) {

$parcel$export(module.exports, "default", () => $561364f0ff054335$export$2e2bcd8739ae039);

var $3h0Rl = parcelRequire("3h0Rl");

var $7rUtO = parcelRequire("7rUtO");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$561364f0ff054335$export$2e2bcd8739ae039 = (0, $7rUtO.default)(-1, (0, $3h0Rl.default));

});

parcelRegister("amUyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c7d4de43a7d251$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $fY0vK = parcelRequire("fY0vK");

var $glwsf = parcelRequire("glwsf");
function $78c7d4de43a7d251$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $9S3ZU.default)(obj) ? (0, $fY0vK.default) : (0, $glwsf.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("ioNrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d650d2a7bacbed3f$export$2e2bcd8739ae039);

var $amUyI = parcelRequire("amUyI");

var $fb4LJ = parcelRequire("fb4LJ");
function $d650d2a7bacbed3f$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $amUyI.default)(obj, (0, $fb4LJ.default)(attrs));
}

});

parcelRegister("62SK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $466d647b32905d1c$export$2e2bcd8739ae039);

var $aQP0M = parcelRequire("aQP0M");

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");
function $466d647b32905d1c$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $aQP0M.default)(iteratee, context);
    var i, length;
    if ((0, $9S3ZU.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $6NhpM.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("8qLHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6235c0df09dfd2cc$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");
function $6235c0df09dfd2cc$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $ckga9.default)(iteratee, context);
    var _keys = !(0, $9S3ZU.default)(obj) && (0, $6NhpM.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("8S1Ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $6754a624849a4deb$export$2e2bcd8739ae039);

var $eHWHR = parcelRequire("eHWHR");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$6754a624849a4deb$export$2e2bcd8739ae039 = (0, $eHWHR.default)(1);

});
parcelRegister("eHWHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab529eb17fc7dce3$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");

var $aQP0M = parcelRequire("aQP0M");
function $ab529eb17fc7dce3$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $9S3ZU.default)(obj) && (0, $6NhpM.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $aQP0M.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("jlbhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e148bc0de6a1300b$export$2e2bcd8739ae039);

var $eHWHR = parcelRequire("eHWHR");
var // The right-associative version of reduce, also known as `foldr`.
$e148bc0de6a1300b$export$2e2bcd8739ae039 = (0, $eHWHR.default)(-1);

});

parcelRegister("bW0kA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b055e398aab55d4$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $62SK1 = parcelRequire("62SK1");
function $8b055e398aab55d4$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $ckga9.default)(predicate, context);
    (0, $62SK1.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("gezip", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1955317490d679$export$2e2bcd8739ae039);

var $bW0kA = parcelRequire("bW0kA");

var $gbT7N = parcelRequire("gbT7N");

var $ckga9 = parcelRequire("ckga9");
function $bd1955317490d679$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $bW0kA.default)(obj, (0, $gbT7N.default)((0, $ckga9.default)(predicate)), context);
}

});

parcelRegister("eje7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6adcbbbc24131e3$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");
function $a6adcbbbc24131e3$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $ckga9.default)(predicate, context);
    var _keys = !(0, $9S3ZU.default)(obj) && (0, $6NhpM.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("iLgyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $da89757d02dce414$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");
function $da89757d02dce414$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $ckga9.default)(predicate, context);
    var _keys = !(0, $9S3ZU.default)(obj) && (0, $6NhpM.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("8JjMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b1de1db996d576$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $8Dx9d = parcelRequire("8Dx9d");

var $6Lf8V = parcelRequire("6Lf8V");
function $65b1de1db996d576$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $9S3ZU.default)(obj)) obj = (0, $8Dx9d.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $6Lf8V.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("dSdRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a19b133e5b5c5cff$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $3CoyW = parcelRequire("3CoyW");

var $8qLHw = parcelRequire("8qLHw");

var $7dsqy = parcelRequire("7dsqy");

var $b5eL1 = parcelRequire("b5eL1");
var // Invoke a method (with arguments) on every item in a collection.
$a19b133e5b5c5cff$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $3CoyW.default)(path)) func = path;
    else {
        path = (0, $b5eL1.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $8qLHw.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $7dsqy.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("fRJ8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ced29257a2a265$export$2e2bcd8739ae039);

var $8qLHw = parcelRequire("8qLHw");

var $dnC7d = parcelRequire("dnC7d");
function $b8ced29257a2a265$export$2e2bcd8739ae039(obj, key) {
    return (0, $8qLHw.default)(obj, (0, $dnC7d.default)(key));
}

});

parcelRegister("3uXdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $28c21b66e9583b5f$export$2e2bcd8739ae039);

var $bW0kA = parcelRequire("bW0kA");

var $fb4LJ = parcelRequire("fb4LJ");
function $28c21b66e9583b5f$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $bW0kA.default)(obj, (0, $fb4LJ.default)(attrs));
}

});

parcelRegister("fKyPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7762a3f32916bad$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $8Dx9d = parcelRequire("8Dx9d");

var $ckga9 = parcelRequire("ckga9");

var $62SK1 = parcelRequire("62SK1");
function $b7762a3f32916bad$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $9S3ZU.default)(obj) ? obj : (0, $8Dx9d.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $ckga9.default)(iteratee, context);
        (0, $62SK1.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("8qqjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $622529ab8152528d$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $8Dx9d = parcelRequire("8Dx9d");

var $ckga9 = parcelRequire("ckga9");

var $62SK1 = parcelRequire("62SK1");
function $622529ab8152528d$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $9S3ZU.default)(obj) ? obj : (0, $8Dx9d.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $ckga9.default)(iteratee, context);
        (0, $62SK1.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("f6Lt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $affc3cf652db7f4e$export$2e2bcd8739ae039);

var $a4acY = parcelRequire("a4acY");
function $affc3cf652db7f4e$export$2e2bcd8739ae039(obj) {
    return (0, $a4acY.default)(obj, Infinity);
}

});
parcelRegister("a4acY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7542324210680365$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $8Dx9d = parcelRequire("8Dx9d");

var $9AVUV = parcelRequire("9AVUV");

var $8GDbt = parcelRequire("8GDbt");

var $gCZmx = parcelRequire("gCZmx");
function $7542324210680365$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $9S3ZU.default)(obj)) obj = (0, $8Dx9d.default)(obj);
        return obj[(0, $8GDbt.default)(obj.length - 1)];
    }
    var sample = (0, $gCZmx.default)(obj);
    var length = (0, $9AVUV.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $8GDbt.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("gCZmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1afcb49e98d5e1c$export$2e2bcd8739ae039);

var $5wqba = parcelRequire("5wqba");

var $6iQQG = parcelRequire("6iQQG");

var $6thfQ = parcelRequire("6thfQ");

var $9S3ZU = parcelRequire("9S3ZU");

var $8qLHw = parcelRequire("8qLHw");

var $hKhcs = parcelRequire("hKhcs");

var $8Dx9d = parcelRequire("8Dx9d");
// Safely create a real, live array from anything iterable.
var $c1afcb49e98d5e1c$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $c1afcb49e98d5e1c$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $5wqba.default)(obj)) return (0, $6iQQG.slice).call(obj);
    if ((0, $6thfQ.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($c1afcb49e98d5e1c$var$reStrSymbol);
    if ((0, $9S3ZU.default)(obj)) return (0, $8qLHw.default)(obj, (0, $hKhcs.default));
    return (0, $8Dx9d.default)(obj);
}

});



parcelRegister("g6u94", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb94971b7498f5b9$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $fRJ8S = parcelRequire("fRJ8S");

var $8qLHw = parcelRequire("8qLHw");
function $bb94971b7498f5b9$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $ckga9.default)(iteratee, context);
    return (0, $fRJ8S.default)((0, $8qLHw.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("3ttpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $287ae4de5906f1c1$export$2e2bcd8739ae039);

var $XlN5y = parcelRequire("XlN5y");

var $frTbd = parcelRequire("frTbd");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$287ae4de5906f1c1$export$2e2bcd8739ae039 = (0, $XlN5y.default)(function(result, value, key) {
    if ((0, $frTbd.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("XlN5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b2669fe1af0992a$export$2e2bcd8739ae039);

var $ckga9 = parcelRequire("ckga9");

var $62SK1 = parcelRequire("62SK1");
function $0b2669fe1af0992a$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $ckga9.default)(iteratee, context);
        (0, $62SK1.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("dOZeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ff72c901ae0332$export$2e2bcd8739ae039);

var $XlN5y = parcelRequire("XlN5y");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$a0ff72c901ae0332$export$2e2bcd8739ae039 = (0, $XlN5y.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("i1sJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ee9c40da2f3bc4$export$2e2bcd8739ae039);

var $XlN5y = parcelRequire("XlN5y");

var $frTbd = parcelRequire("frTbd");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$d1ee9c40da2f3bc4$export$2e2bcd8739ae039 = (0, $XlN5y.default)(function(result, value, key) {
    if ((0, $frTbd.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("cc1Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e081c2818d073a5$export$2e2bcd8739ae039);

var $XlN5y = parcelRequire("XlN5y");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$8e081c2818d073a5$export$2e2bcd8739ae039 = (0, $XlN5y.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("8j91q", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c718a1f8983c7d$export$2e2bcd8739ae039);

var $9S3ZU = parcelRequire("9S3ZU");

var $6NhpM = parcelRequire("6NhpM");
function $60c718a1f8983c7d$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $9S3ZU.default)(obj) ? obj.length : (0, $6NhpM.default)(obj).length;
}

});

parcelRegister("fkrOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28e4b62f45805d4$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $3CoyW = parcelRequire("3CoyW");

var $aQP0M = parcelRequire("aQP0M");

var $bf5SX = parcelRequire("bf5SX");

var $5zYue = parcelRequire("5zYue");

var $lYyIg = parcelRequire("lYyIg");
var // Return a copy of the object only containing the allowed properties.
$b28e4b62f45805d4$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $3CoyW.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $aQP0M.default)(iteratee, keys[1]);
        keys = (0, $bf5SX.default)(obj);
    } else {
        iteratee = (0, $5zYue.default);
        keys = (0, $lYyIg.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("5zYue", function(module, exports) {

$parcel$export(module.exports, "default", () => $40ff240962771a15$export$2e2bcd8739ae039);
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $40ff240962771a15$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("59pKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c01c54ddd22f480$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $3CoyW = parcelRequire("3CoyW");

var $gbT7N = parcelRequire("gbT7N");

var $8qLHw = parcelRequire("8qLHw");

var $lYyIg = parcelRequire("lYyIg");

var $8JjMh = parcelRequire("8JjMh");

var $fkrOa = parcelRequire("fkrOa");
var // Return a copy of the object without the disallowed properties.
$3c01c54ddd22f480$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $3CoyW.default)(iteratee)) {
        iteratee = (0, $gbT7N.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $8qLHw.default)((0, $lYyIg.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $8JjMh.default)(keys, key);
        };
    }
    return (0, $fkrOa.default)(obj, iteratee, context);
});

});

parcelRegister("5in42", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db0863fe12cac0f$export$2e2bcd8739ae039);

var $fnxc5 = parcelRequire("fnxc5");
function $3db0863fe12cac0f$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $fnxc5.default)(array, array.length - n);
}

});
parcelRegister("fnxc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b322c0a3b392f342$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $b322c0a3b392f342$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $6iQQG.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("1BGff", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ba041f5d61a867$export$2e2bcd8739ae039);

var $bdjiM = parcelRequire("bdjiM");
function $12ba041f5d61a867$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $bdjiM.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("bdjiM", function(module, exports) {

$parcel$export(module.exports, "default", () => $829fe18dfbadc50a$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $829fe18dfbadc50a$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $6iQQG.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("bA8FR", function(module, exports) {

$parcel$export(module.exports, "default", () => $86e9c907e136ba22$export$2e2bcd8739ae039);

var $bW0kA = parcelRequire("bW0kA");
function $86e9c907e136ba22$export$2e2bcd8739ae039(array) {
    return (0, $bW0kA.default)(array, Boolean);
}

});

parcelRegister("lgeYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a6b69aceec6b70$export$2e2bcd8739ae039);

var $lYyIg = parcelRequire("lYyIg");
function $f7a6b69aceec6b70$export$2e2bcd8739ae039(array, depth) {
    return (0, $lYyIg.default)(array, depth, false);
}

});

parcelRegister("9NbpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $72118bd1b8ea79f9$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $haTgB = parcelRequire("haTgB");
var // Return a version of the array that does not contain the specified value(s).
$72118bd1b8ea79f9$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(array, otherArrays) {
    return (0, $haTgB.default)(array, otherArrays);
});

});
parcelRegister("haTgB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c80e3dafe7ea79fe$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $lYyIg = parcelRequire("lYyIg");

var $bW0kA = parcelRequire("bW0kA");

var $8JjMh = parcelRequire("8JjMh");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$c80e3dafe7ea79fe$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(array, rest) {
    rest = (0, $lYyIg.default)(rest, true, true);
    return (0, $bW0kA.default)(array, function(value) {
        return !(0, $8JjMh.default)(rest, value);
    });
});

});


parcelRegister("7jjyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $55297b4a0077f016$export$2e2bcd8739ae039);

var $dqwBU = parcelRequire("dqwBU");

var $ckga9 = parcelRequire("ckga9");

var $9AVUV = parcelRequire("9AVUV");

var $8JjMh = parcelRequire("8JjMh");
function $55297b4a0077f016$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $dqwBU.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $ckga9.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $9AVUV.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $8JjMh.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $8JjMh.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("jd2LA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfc1609ce394d5e9$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $7jjyS = parcelRequire("7jjyS");

var $lYyIg = parcelRequire("lYyIg");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$dfc1609ce394d5e9$export$2e2bcd8739ae039 = (0, $bRRTL.default)(function(arrays) {
    return (0, $7jjyS.default)((0, $lYyIg.default)(arrays, true, true));
});

});

parcelRegister("cvJpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $91bb9b0f68af8ab9$export$2e2bcd8739ae039);

var $9AVUV = parcelRequire("9AVUV");

var $8JjMh = parcelRequire("8JjMh");
function $91bb9b0f68af8ab9$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $9AVUV.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $8JjMh.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $8JjMh.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("8LUBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $662e9edba73a0b6d$export$2e2bcd8739ae039);

var $fKyPa = parcelRequire("fKyPa");

var $9AVUV = parcelRequire("9AVUV");

var $fRJ8S = parcelRequire("fRJ8S");
function $662e9edba73a0b6d$export$2e2bcd8739ae039(array) {
    var length = array && (0, $fKyPa.default)(array, (0, $9AVUV.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $fRJ8S.default)(array, index);
    return result;
}

});

parcelRegister("auDrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3b4e6b6bb8860a$export$2e2bcd8739ae039);

var $bRRTL = parcelRequire("bRRTL");

var $8LUBv = parcelRequire("8LUBv");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$7a3b4e6b6bb8860a$export$2e2bcd8739ae039 = (0, $bRRTL.default)((0, $8LUBv.default));

});

parcelRegister("5OUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $43cd6a4f21405cc2$export$2e2bcd8739ae039);

var $9AVUV = parcelRequire("9AVUV");
function $43cd6a4f21405cc2$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $9AVUV.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("ficcS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2220178fa0121e4$export$2e2bcd8739ae039);
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $b2220178fa0121e4$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("bYgmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $023fc6256291c62e$export$2e2bcd8739ae039);

var $6iQQG = parcelRequire("6iQQG");
function $023fc6256291c62e$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $6iQQG.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("5DSEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bafc156be6b627$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $62SK1 = parcelRequire("62SK1");

var $ck3Mo = parcelRequire("ck3Mo");

var $6iQQG = parcelRequire("6iQQG");

var $3CQkQ = parcelRequire("3CQkQ");
function $41bafc156be6b627$export$2e2bcd8739ae039(obj) {
    (0, $62SK1.default)((0, $ck3Mo.default)(obj), function(name) {
        var func = (0, $ejzvC.default)[name] = obj[name];
        (0, $ejzvC.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $6iQQG.push).apply(args, arguments);
            return (0, $3CQkQ.default)(this, func.apply((0, $ejzvC.default), args));
        };
    });
    return 0, $ejzvC.default;
}

});
parcelRegister("3CQkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a3d846654e6dafa$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");
function $2a3d846654e6dafa$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $ejzvC.default)(obj).chain() : obj;
}

});


parcelRegister("iax1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3a2c84e1a56bb1a$export$2e2bcd8739ae039);

var $ejzvC = parcelRequire("ejzvC");

var $62SK1 = parcelRequire("62SK1");

var $6iQQG = parcelRequire("6iQQG");

var $3CQkQ = parcelRequire("3CQkQ");
// Add all mutator `Array` functions to the wrapper.
(0, $62SK1.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $6iQQG.ArrayProto)[name];
    (0, $ejzvC.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $3CQkQ.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $62SK1.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $6iQQG.ArrayProto)[name];
    (0, $ejzvC.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $3CQkQ.default)(this, obj);
    };
});
var $d3a2c84e1a56bb1a$export$2e2bcd8739ae039 = (0, $ejzvC.default);

});






parcelRegister("xXdsJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $06610445d93096b3$var$SprayChart;

var $06610445d93096b3$var$_react = $06610445d93096b3$var$_interopRequireDefault((parcelRequire("J42oT")));

var $06610445d93096b3$var$_SprayPoint = $06610445d93096b3$var$_interopRequireDefault((parcelRequire("3IEt9")));
function $06610445d93096b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $06610445d93096b3$var$SprayChart(_ref) {
    var settings = _ref.settings, _isFinished = _ref.isFinished, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var sprayData = settings.data;
    return /*#__PURE__*/ $06610445d93096b3$var$_react["default"].createElement($06610445d93096b3$var$_react["default"].Fragment, null, sprayData.map(function(d, i) {
        var coords = {
            x: d.x,
            y: d.y
        };
        // Stagger z plane to prevent mesh bug in three.js and add 2 to fix infield bug issue
        var z = i / 100 + 2;
        return /*#__PURE__*/ $06610445d93096b3$var$_react["default"].createElement($06610445d93096b3$var$_SprayPoint["default"], {
            key: "spray_".concat(i),
            settings: settings,
            coords: coords,
            legendField: d[chartOptions.legendType],
            z: z,
            lastUpdate: sprayData.length === i + 1,
            isFinished: function isFinished(finishedUpdate) {
                _isFinished(finishedUpdate);
            },
            chartOptions: chartOptions
        });
    }));
}

});
parcelRegister("3IEt9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $2b54df7d6be433b5$var$SprayPoint;

var $2b54df7d6be433b5$var$_react = $2b54df7d6be433b5$var$_interopRequireDefault((parcelRequire("J42oT")));

var $llL0N = parcelRequire("llL0N");

var $2b54df7d6be433b5$var$_ColorMap = $2b54df7d6be433b5$var$_interopRequireDefault((parcelRequire("uw3x8")));
function $2b54df7d6be433b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $2b54df7d6be433b5$var$SprayPoint(_ref) {
    var settings = _ref.settings, coords = _ref.coords, legendField = _ref.legendField, z = _ref.z, lastUpdate = _ref.lastUpdate, isFinished = _ref.isFinished, chartOptions = _ref.chartOptions;
    var updateGeometry = (0, $llL0N.useUpdate)(function(geometry) {
        for(var i = 0; i < geometry.faces.length; i++)if (geometry.faces[i].normal.y === 0) geometry.faces[i].color.setHex(0x111111);
    }, []);
    return /*#__PURE__*/ $2b54df7d6be433b5$var$_react["default"].createElement("mesh", {
        key: "spray",
        visible: true,
        position: [
            coords.x,
            coords.y,
            z
        ],
        rotation: [
            Math.PI / 2,
            0,
            0
        ],
        onUpdate: function onUpdate() {
            isFinished(lastUpdate);
        }
    }, /*#__PURE__*/ $2b54df7d6be433b5$var$_react["default"].createElement("cylinderGeometry", {
        ref: updateGeometry,
        attach: "geometry",
        args: [
            8,
            8,
            4,
            16
        ]
    }), /*#__PURE__*/ $2b54df7d6be433b5$var$_react["default"].createElement("meshPhongMaterial", {
        attach: "material",
        vertexColors: "#000000",
        color: (0, $2b54df7d6be433b5$var$_ColorMap["default"])(chartOptions.legendType, legendField)
    }));
}

});



parcelRegister("7cM02", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $53eee31bb3278b67$var$Legend;

var $53eee31bb3278b67$var$_react = $53eee31bb3278b67$var$_interopRequireDefault((parcelRequire("J42oT")));

var $53eee31bb3278b67$var$_ColorMap = $53eee31bb3278b67$var$_interopRequireDefault((parcelRequire("uw3x8")));
function $53eee31bb3278b67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ /*
Current Supported Legend Types:
'call_name': from gumbo, 'STRIKE', 'BALL', 'IN PLAY'
'events':
'description':
'pitch_name':

*/ function $53eee31bb3278b67$var$Legend(_ref) {
    var settings = _ref.settings, _ref$type = _ref.type, type = _ref$type === void 0 ? 'homeRunTypes' : _ref$type;
    var legendData = [
        'No Doubter',
        'Mostly Gone',
        'Doubter'
    ];
    var SCALE_SPACING = 36;
    var SCALE_RADIUS = 5;
    var SPLIT_COUNT = 6;
    var COLUMN_LENGTH = 200;
    var column = 0;
    var translate = [
        settings.vizWidth * 1.05,
        0
    ];
    if (settings.orientation === 'portrait') translate = [
        0,
        settings.vizWidth * 1.05
    ];
    if (settings.orientation === 'portrait') column = -COLUMN_LENGTH;
    var ySize = 0;
    return /*#__PURE__*/ $53eee31bb3278b67$var$_react["default"].createElement("g", {
        id: "legend",
        transform: "translate(".concat(translate, ")")
    }, legendData.map(function(d, i) {
        ySize++;
        // If in portrait orientation split legend into multiple columns
        if (settings.orientation === 'portrait' && i % SPLIT_COUNT == 0) {
            column += COLUMN_LENGTH;
            ySize = 0;
        }
        return /*#__PURE__*/ $53eee31bb3278b67$var$_react["default"].createElement("g", {
            key: "homeRunLegend_".concat(i)
        }, /*#__PURE__*/ $53eee31bb3278b67$var$_react["default"].createElement("text", {
            x: column,
            y: ySize * SCALE_SPACING,
            className: "legend",
            style: {
                fontSize: "1rem"
            }
        }, d), /*#__PURE__*/ $53eee31bb3278b67$var$_react["default"].createElement("circle", {
            cx: column - 14,
            cy: ySize * SCALE_SPACING - 6,
            r: SCALE_RADIUS / settings.vizScale,
            stroke: "#000",
            fill: (0, $53eee31bb3278b67$var$_ColorMap["default"])(type, d)
        }));
    }));
}

});

parcelRegister("69H9A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $47b50ec5ec68af56$var$FieldDegreeMarkers;

var $47b50ec5ec68af56$var$_react = $47b50ec5ec68af56$var$_interopRequireDefault((parcelRequire("J42oT")));


var $1izgn = parcelRequire("1izgn");

var $47b50ec5ec68af56$var$_CalculateHitLocation = $47b50ec5ec68af56$var$_interopRequireDefault((parcelRequire("4hAZJ")));
function $47b50ec5ec68af56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ function $47b50ec5ec68af56$var$FieldDegreeMarkers(_ref) {
    var settings = _ref.settings;
    var draw = (0, $1izgn.default)().x(function(d) {
        return (0, $47b50ec5ec68af56$var$_CalculateHitLocation["default"])({
            x: d.x,
            y: d.y
        }, settings.vizWidth, settings.vizHeight).x;
    }).y(function(d) {
        return (0, $47b50ec5ec68af56$var$_CalculateHitLocation["default"])({
            x: d.x,
            y: d.y
        }, settings.vizWidth, settings.vizHeight).y;
    });
    var angles = [
        {
            angle: -45,
            x: -233,
            y: 233,
            textx: -269,
            texty: 269,
            hide: true
        },
        {
            angle: -30,
            x: -184,
            y: 319,
            textx: -195,
            texty: 338
        },
        {
            angle: -15,
            x: -102,
            y: 381,
            textx: -106,
            texty: 396
        },
        {
            angle: 0,
            x: -1.5,
            y: 402,
            textx: 0,
            texty: 412
        },
        {
            angle: 15,
            x: 101,
            y: 377,
            textx: 106,
            texty: 396
        },
        {
            angle: 30,
            x: 183,
            y: 316,
            textx: 190,
            texty: 329
        },
        {
            angle: 45,
            x: 226,
            y: 226,
            textx: 237,
            texty: 237,
            hide: true
        }
    ];
    var paths = [];
    for(var i = 0; i < angles.length; i++){
        var a = angles[i];
        paths.push(/*#__PURE__*/ $47b50ec5ec68af56$var$_react["default"].createElement($47b50ec5ec68af56$var$_react["default"].Fragment, null, /*#__PURE__*/ $47b50ec5ec68af56$var$_react["default"].createElement("path", {
            d: draw([
                {
                    x: 0,
                    y: 0
                },
                {
                    x: a.x,
                    y: a.y
                }
            ]),
            fill: "none",
            stroke: "#c2c2c2"
        }), /*#__PURE__*/ $47b50ec5ec68af56$var$_react["default"].createElement("text", {
            x: (0, $47b50ec5ec68af56$var$_CalculateHitLocation["default"])({
                x: a.textx,
                y: a.texty
            }, settings.vizWidth, settings.vizHeight).x,
            y: (0, $47b50ec5ec68af56$var$_CalculateHitLocation["default"])({
                x: a.textx,
                y: a.texty
            }, settings.vizWidth, settings.vizHeight).y,
            fill: "#f00"
        }, a.angle, "\xB0")));
    }
    return /*#__PURE__*/ $47b50ec5ec68af56$var$_react["default"].createElement("g", {
        id: "field-degrees"
    }, paths);
}

});

parcelRegister("6e0KX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a263db163ce47825$var$PitchType;

var $a263db163ce47825$var$_react = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("J42oT")));

var $mdo2f = parcelRequire("mdo2f");

var $a263db163ce47825$var$_Pitches = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("69FZF")));

var $a263db163ce47825$var$_Zone = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("2fCCE")));

var $a263db163ce47825$var$_HexBin = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("7BxGS")));

var $a263db163ce47825$var$_Contour = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("jIEnw")));

var $a263db163ce47825$var$_Pie = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("cG5Fx")));

var $a263db163ce47825$var$_Axis = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("1rGPT")));

var $a263db163ce47825$var$_HomePlate = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("bMYA4")));

var $a263db163ce47825$var$_StrikeZone = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("iMsqL")));

var $a263db163ce47825$var$_RightHandedBatter = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("dvpmi")));

var $a263db163ce47825$var$_LeftHandedBatter = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("gKtE2")));

var $a263db163ce47825$var$_StrikeZoneBackground = $a263db163ce47825$var$_interopRequireDefault((parcelRequire("4DcOz")));
function $a263db163ce47825$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// VISUALS
// The below (Axis) uses a data type that isn't like Gamefeed or Illustrator data types.
// Therefore I'm not going to bother TS'ing it (yet)
// @ts-expect-error - TODO: Convert to TypeScript
/// VISUAL HELPERS
function $a263db163ce47825$var$PitchType(_ref) {
    var chartOptions = _ref.chartOptions, settings = _ref.settings, onPitchClick = _ref.onPitchClick;
    var pitcherPerspective = chartOptions.pitcherPerspective;
    var data = settings.data;
    // Memoize perhaps
    var hasFrontPlate = Boolean(data.find(function(d) {
        return d.szDepth === $mdo2f.depthFrontOfPlateInches;
    }));
    var hasMidPlate = Boolean(data.find(function(d) {
        return d.szDepth === $mdo2f.depthMidPlateInches;
    }));
    return /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_react["default"].Fragment, null, chartOptions.showRHB ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_RightHandedBatter["default"], {
        pitcherPerspective: pitcherPerspective
    }) : null, chartOptions.showLHB ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_LeftHandedBatter["default"], {
        pitcherPerspective: pitcherPerspective
    }) : null, chartOptions.showPlate ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_HomePlate["default"], {
        pitcherPerspective: pitcherPerspective,
        showFrontPlateShadow: hasFrontPlate,
        showMidPlateShadow: hasMidPlate
    }) : null, chartOptions.showStrikeZone ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_StrikeZoneBackground["default"], null) : null, chartOptions.overlayType === 'pie' && data.length > 0 ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_Pie["default"], null) : null, chartOptions.overlayType === 'pitch' ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_Pitches["default"], {
        onPitchClick: onPitchClick
    }) : null, chartOptions.overlayType === 'zone' ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_Zone["default"], {
        settings: settings,
        chartOptions: chartOptions
    }) : null, chartOptions.overlayType === 'contour' && data.length > 0 ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_Contour["default"], null) : null, chartOptions.overlayType === 'hexbin' && data.length > 0 ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_HexBin["default"], null) : null, chartOptions.overlayType === 'spinAxis' && data.length > 0 ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_Axis["default"], {
        settings: settings,
        chartOptions: chartOptions
    }) : null, chartOptions.showStrikeZone ? /*#__PURE__*/ $a263db163ce47825$var$_react["default"].createElement($a263db163ce47825$var$_StrikeZone["default"], null) : null);
}

});
parcelRegister("69FZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $cbc1d5a214795985$var$Pitches;

var $cbc1d5a214795985$var$_react = $cbc1d5a214795985$var$_interopRequireDefault((parcelRequire("J42oT")));

var $22K6d = parcelRequire("22K6d");

var $cbc1d5a214795985$var$_setTextColorWithBackground = $cbc1d5a214795985$var$_interopRequireDefault((parcelRequire("koIK5")));

var $cbc1d5a214795985$var$_ColorMap = $cbc1d5a214795985$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $cbc1d5a214795985$var$_Legend = $cbc1d5a214795985$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $cbc1d5a214795985$var$_Tooltip = $cbc1d5a214795985$var$_interopRequireDefault((parcelRequire("ksMP3")));

var $3wgDt = parcelRequire("3wgDt");
function $cbc1d5a214795985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/no-array-index-key */ /* eslint-disable react/prop-types */ function $cbc1d5a214795985$var$Pitches(_ref) {
    var onPitchClick = _ref.onPitchClick;
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), settings = _useChartOptions.settings, chartOptions = _useChartOptions.chartOptions;
    var _useTooltip = (0, $3wgDt.useTooltip)(), tooltipRef = _useTooltip.tooltipRef;
    var _useZoom = (0, $3wgDt.useZoom)(), zoom = _useZoom.zoom;
    var isZoomed = zoom !== 1;
    // let pitchData = RemoveBadPitchPoints(settings.data);
    var pitchData = settings.data;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale;
    function handleMouseOver(event, pitch) {
        var tip = pitch.tooltip;
        if (!isZoomed && tip && tooltipRef.current) (0, $cbc1d5a214795985$var$_Tooltip["default"])(event, settings, tooltipRef.current, tip);
    }
    function handleMouseOut(event) {
        if (tooltipRef.current) (0, $cbc1d5a214795985$var$_Tooltip["default"])(event, settings, tooltipRef.current);
    }
    function handleClick(event, pitch) {
        if (settings.enableZoom) {
            onPitchClick(event, pitch);
            return;
        }
        if (pitch.videoUrl) window.open(pitch.videoUrl);
    }
    // TODO handle relative size
    var fullBallRadius = Math.abs(xScale($22K6d.ballRadiusFeet) - xScale(0));
    var strokeWidth = 1;
    var ballRadius = fullBallRadius - strokeWidth / 2;
    // TODO: We need to see where this chartOption actually is used
    // let radiusSize = 5
    // if (settings.shape === 'twitter') {
    //     radiusSize = 4
    // }
    // if (chartOptions.labelPitches && pitchData.length >= 1000) {
    //     radiusSize = 10
    // } else if (chartOptions.labelPitches && pitchData.length >= 100) {
    //     radiusSize = 8
    // } else if (chartOptions.labelPitches && pitchData.length >= 10) {
    //     radiusSize = 6
    // } else if (chartOptions.labelPitches && pitchData.length >= 1) {
    //     radiusSize = 5
    // }
    var filteredPitches = pitchData.filter(function(d) {
        return chartOptions.legendType === 'battedBallType' ? d.battedBallType !== null : d;
    });
    var pixelPositions = (0, $3wgDt.usePixelPositions)(filteredPitches);
    var legendType = chartOptions.legendType;
    return /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement($cbc1d5a214795985$var$_react["default"].Fragment, null, /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement("g", {
        key: "pitchChart",
        id: "pitchChart"
    }, filteredPitches.map(function(d, i) {
        // This seems like a bad API to stringify, but trying not to modify too much right now (Haha)
        var stringValue = String(d[chartOptions.legendType]);
        var fillColor = (0, $cbc1d5a214795985$var$_ColorMap["default"])(legendType, stringValue) || '#fff';
        return /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement("g", {
            key: "g_pitch_key_".concat(i),
            transform: "translate(".concat(pixelPositions[i].x, ",").concat(pixelPositions[i].y, ")"),
            style: {
                cursor: 'pointer'
            },
            onMouseOver: function onMouseOver(evt) {
                return handleMouseOver(evt, d);
            },
            onMouseOut: handleMouseOut,
            onClick: function onClick(evt) {
                return handleClick(evt, d);
            }
        }, /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement("circle", {
            key: "pitch_".concat(i),
            r: ballRadius,
            opacity: chartOptions.opacity,
            fill: fillColor,
            stroke: "black",
            strokeWidth: strokeWidth
        }), chartOptions.labelPitches ? /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement("text", {
            className: "pitch-label",
            key: "text_key_".concat(i),
            textAnchor: "middle",
            dominantBaseline: "middle",
            dy: 1 // nudge
            ,
            fill: (0, $cbc1d5a214795985$var$_setTextColorWithBackground["default"])(fillColor)
        }, chartOptions.pitchNumberOverride ? d.illustrator_pitch_number : i + 1) : null);
    })), chartOptions.legend ? /*#__PURE__*/ $cbc1d5a214795985$var$_react["default"].createElement($cbc1d5a214795985$var$_Legend["default"], {
        settings: settings,
        type: chartOptions.legendType
    }) : null);
}

});

parcelRegister("2fCCE", function(module, exports) {
"use strict";
function $4f3056da9d20a995$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4f3056da9d20a995$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4f3056da9d20a995$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4f3056da9d20a995$var$Zone;

var $4f3056da9d20a995$var$_react = $4f3056da9d20a995$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $1izgn = parcelRequire("1izgn");

var $4f3056da9d20a995$var$_find = $4f3056da9d20a995$var$_interopRequireDefault((parcelRequire("ihZKh")));

var $5eFx0 = parcelRequire("5eFx0");

var $4f3056da9d20a995$var$_setTextColorWithBackground = $4f3056da9d20a995$var$_interopRequireDefault((parcelRequire("koIK5")));

var $4f3056da9d20a995$var$_ZoneSizing = $4f3056da9d20a995$var$_interopRequireWildcard((parcelRequire("c8zCs")));

var $4f3056da9d20a995$var$_RunCalculations = $4f3056da9d20a995$var$_interopRequireDefault((parcelRequire("fKd4Q")));

var $4f3056da9d20a995$var$_Palettes = $4f3056da9d20a995$var$_interopRequireDefault((parcelRequire("8uo4Y")));
function $4f3056da9d20a995$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4f3056da9d20a995$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4f3056da9d20a995$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4f3056da9d20a995$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4f3056da9d20a995$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4f3056da9d20a995$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4f3056da9d20a995$var$_slicedToArray(r, e) {
    return $4f3056da9d20a995$var$_arrayWithHoles(r) || $4f3056da9d20a995$var$_iterableToArrayLimit(r, e) || $4f3056da9d20a995$var$_unsupportedIterableToArray(r, e) || $4f3056da9d20a995$var$_nonIterableRest();
}
function $4f3056da9d20a995$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4f3056da9d20a995$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4f3056da9d20a995$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4f3056da9d20a995$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4f3056da9d20a995$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4f3056da9d20a995$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4f3056da9d20a995$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
// import ZoneLegend from "../Legend/ZoneLegend";
var $4f3056da9d20a995$var$zoneValues = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '11',
    '12',
    '13',
    '14'
];
var $4f3056da9d20a995$var$nullValues = [
    null,
    undefined,
    ''
];
function $4f3056da9d20a995$var$isNullish(value) {
    return $4f3056da9d20a995$var$nullValues.includes(value);
}
var $4f3056da9d20a995$var$nullishColor = 'rgb(237, 237, 237)';
function $4f3056da9d20a995$var$getFill(chartType, calculations, colorFn) {
    var stat = calculations[chartType];
    if ($4f3056da9d20a995$var$isNullish(stat)) return $4f3056da9d20a995$var$nullishColor;
    var color = colorFn(Number(stat));
    return calculations !== null && calculations !== void 0 && calculations.totalPitches ? color : $4f3056da9d20a995$var$nullishColor;
}
var $4f3056da9d20a995$var$guffType = {
    attackAngle: 'attack_angle',
    attackDirection: 'attack_direction',
    batSpeed: 'sweetspot_speed_mph',
    batSpeedCompetitive: 'sweetspot_speed_mph',
    idealAttackAngle: 'rate_ideal_attack_angle',
    swingLength: 'swing_length',
    swingLengthCompetitive: 'swing_length',
    swingPathTilt: 'bat_path_angle'
};
function $4f3056da9d20a995$var$Zone(_ref) {
    var settings = _ref.settings, chartOptions = _ref.chartOptions;
    // TODO: Can we improve this typing
    var chartType = chartOptions.type;
    var pitcherView = chartOptions.pitcherPerspective;
    var groupedData;
    // Use this option if you want to directly send in pre-processed zones
    if (!chartOptions.skipDataProcess) groupedData = Object.groupBy(settings.data, function(d) {
        return d.zone || '';
    });
    else groupedData = settings.data;
    var counts = $4f3056da9d20a995$var$zoneValues.map(function(zone) {
        if (groupedData[zone]) return {
            zone: "zone_".concat(zone),
            calculations: (0, $4f3056da9d20a995$var$_RunCalculations["default"])(groupedData[zone], settings.data.length)
        };
        return {
            zone: "zone_".concat(zone),
            calculations: (0, $4f3056da9d20a995$var$_RunCalculations["default"])([], settings.data.length)
        };
    });
    var palette = new $4f3056da9d20a995$var$_Palettes["default"]({
        type: chartType,
        data: counts
    });
    var color = palette.color;
    var x = (0, $csdlO.default)().range([
        0,
        settings.vizWidth
    ]).domain([
        -4,
        4
    ]);
    var y = (0, $csdlO.default)().range([
        settings.vizHeight,
        0
    ]).domain([
        -4,
        4
    ]);
    var draw = (0, $1izgn.default)().x(function(d) {
        return x(d.x);
    }).y(function(d) {
        return y(d.y);
    });
    function getValue(zoneNum) {
        var zoneObj = counts.find(function(d) {
            return d.zone === zoneNum;
        });
        if (!(zoneObj !== null && zoneObj !== void 0 && zoneObj.calculations.totalPitches)) return "\u2014";
        try {
            var stat = zoneObj.calculations[chartType];
            if ($4f3056da9d20a995$var$isNullish(stat)) return "\u2014";
            if (chartType in $4f3056da9d20a995$var$guffType) return (0, $5eFx0.guff)(stat, $4f3056da9d20a995$var$guffType[chartType]);
            return stat;
        } catch (e) {
            console.error(e);
            return "\u2014";
        }
    }
    var zonesView = pitcherView ? $4f3056da9d20a995$var$_ZoneSizing.zonesReversed : $4f3056da9d20a995$var$_ZoneSizing["default"];
    var zonePaths = Object.entries(zonesView).map(function(_ref2) {
        var _count$calculations;
        var _ref3 = $4f3056da9d20a995$var$_slicedToArray(_ref2, 2), zone = _ref3[0], points = _ref3[1];
        var id = Number(zone.split('_')[1]);
        var dx = 0;
        if (id < 10) dx = x(1 / 3) - x(0);
        else if (pitcherView && (id === 11 || id === 13)) dx = -8;
        else if (!pitcherView && (id === 12 || id === 14)) dx = -8;
        else if (pitcherView && (id === 12 || id === 14)) dx = 8;
        else if (!pitcherView && (id === 11 || id === 13)) dx = 8;
        var dy;
        if (id < 10) dy = y(0) - y(1 / 3);
        else if (id === 11 || id === 12) dy = 10;
        else dy = -8;
        var count = (0, $4f3056da9d20a995$var$_find["default"])(counts, function(d) {
            return d.zone === zone;
        });
        var classes = [
            "zone-text-".concat(id > 10 ? 'outer' : 'inner'),
            "zone-text-".concat(id),
            "zone-text-perspective-".concat(pitcherView ? 'pitcher' : 'catcher')
        ];
        var fill = count !== null && count !== void 0 && count.calculations ? $4f3056da9d20a995$var$getFill(chartType, count.calculations, color) : $4f3056da9d20a995$var$nullishColor;
        var fillColor = count !== null && count !== void 0 && (_count$calculations = count.calculations) !== null && _count$calculations !== void 0 && _count$calculations.totalPitches ? (0, $4f3056da9d20a995$var$_setTextColorWithBackground["default"])(String(fill)) : '#666';
        return /*#__PURE__*/ $4f3056da9d20a995$var$_react["default"].createElement("g", {
            key: "zone_".concat(zone)
        }, /*#__PURE__*/ $4f3056da9d20a995$var$_react["default"].createElement("path", {
            id: zone,
            d: draw(points) || undefined,
            fill: fill !== undefined ? String(fill) : '#fff',
            className: "evp-zone",
            opacity: chartOptions.opacity
        }), chartOptions.showText ? /*#__PURE__*/ $4f3056da9d20a995$var$_react["default"].createElement("text", {
            className: classes.join(' '),
            x: x(points[0].x),
            y: y(points[0].y),
            fill: fillColor,
            dx: dx,
            dy: dy
        }, getValue(zone)) : null);
    });
    return /*#__PURE__*/ $4f3056da9d20a995$var$_react["default"].createElement($4f3056da9d20a995$var$_react["default"].Fragment, null, /*#__PURE__*/ $4f3056da9d20a995$var$_react["default"].createElement("g", {
        id: "zones"
    }, zonePaths));
}

});
parcelRegister("c8zCs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zonesReversed = module.exports["default"] = void 0;
var $b21a2308672446e4$var$zoneMaxX = 1.35;
var $b21a2308672446e4$var$zoneMaxY = 1.35;
var $b21a2308672446e4$var$zonesReversed = module.exports.zonesReversed = {
    zone_12: [
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: 0.0
        },
        {
            x: -1,
            y: 0.0
        },
        {
            x: -1,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 0,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_11: [
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 0,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_14: [
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: 0.0
        },
        {
            x: -1,
            y: 0.0
        },
        {
            x: -1,
            y: -1
        },
        {
            x: 0,
            y: -1
        },
        {
            x: 0,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_13: [
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: -1
        },
        {
            x: 0,
            y: -1
        },
        {
            x: 0,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_3: [
        {
            x: -1,
            y: 1.0
        },
        {
            x: -1,
            y: 0.3332
        },
        {
            x: -0.3331,
            y: 0.3332
        },
        {
            x: -0.3331,
            y: 1.0
        },
        {
            x: -1,
            y: 1.0
        }
    ],
    zone_2: [
        {
            x: -0.333,
            y: 1.0
        },
        {
            x: -0.333,
            y: 0.3332
        },
        {
            x: 0.333,
            y: 0.3332
        },
        {
            x: 0.333,
            y: 1.0
        },
        {
            x: -0.333,
            y: 1.0
        }
    ],
    zone_1: [
        {
            x: 0.3331,
            y: 1.0
        },
        {
            x: 0.3331,
            y: 0.3332
        },
        {
            x: 1.0,
            y: 0.3332
        },
        {
            x: 1.0,
            y: 1.0
        },
        {
            x: 0.3331,
            y: 1.0
        }
    ],
    zone_6: [
        {
            x: -1,
            y: 0.333
        },
        {
            x: -1,
            y: -0.333
        },
        {
            x: -0.3331,
            y: -0.333
        },
        {
            x: -0.3331,
            y: 0.333
        },
        {
            x: -1,
            y: 0.333
        }
    ],
    zone_5: [
        {
            x: -0.333,
            y: 0.333
        },
        {
            x: -0.333,
            y: -0.333
        },
        {
            x: 0.333,
            y: -0.333
        },
        {
            x: 0.333,
            y: 0.333
        },
        {
            x: -0.333,
            y: 0.333
        }
    ],
    zone_4: [
        {
            x: 0.3331,
            y: 0.333
        },
        {
            x: 0.3331,
            y: -0.333
        },
        {
            x: 1.0,
            y: -0.333
        },
        {
            x: 1.0,
            y: 0.333
        },
        {
            x: 0.3331,
            y: 0.333
        }
    ],
    zone_9: [
        {
            x: -1,
            y: -0.3332
        },
        {
            x: -1,
            y: -1
        },
        {
            x: -0.3331,
            y: -1
        },
        {
            x: -0.3331,
            y: -0.3332
        },
        {
            x: -1,
            y: -0.3332
        }
    ],
    zone_8: [
        {
            x: -0.333,
            y: -0.3332
        },
        {
            x: -0.333,
            y: -1
        },
        {
            x: 0.333,
            y: -1
        },
        {
            x: 0.333,
            y: -0.3332
        },
        {
            x: -0.333,
            y: -0.3332
        }
    ],
    zone_7: [
        {
            x: 0.3331,
            y: -0.3332
        },
        {
            x: 0.3331,
            y: -1
        },
        {
            x: 1.0,
            y: -1
        },
        {
            x: 1.0,
            y: -0.3332
        },
        {
            x: 0.3331,
            y: -0.3332
        }
    ]
};
var $b21a2308672446e4$var$_default = module.exports["default"] = {
    zone_11: [
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: 0.0
        },
        {
            x: -1,
            y: 0.0
        },
        {
            x: -1,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 0,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_12: [
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 0,
            y: $b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: $b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_13: [
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: 0.0
        },
        {
            x: -1,
            y: 0.0
        },
        {
            x: -1,
            y: -1
        },
        {
            x: 0,
            y: -1
        },
        {
            x: 0,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: -$b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_14: [
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: -1
        },
        {
            x: 0,
            y: -1
        },
        {
            x: 0,
            y: -$b21a2308672446e4$var$zoneMaxY
        },
        {
            x: $b21a2308672446e4$var$zoneMaxX,
            y: -$b21a2308672446e4$var$zoneMaxY
        }
    ],
    zone_1: [
        {
            x: -1,
            y: 1.0
        },
        {
            x: -1,
            y: 0.3332
        },
        {
            x: -0.3331,
            y: 0.3332
        },
        {
            x: -0.3331,
            y: 1.0
        },
        {
            x: -1,
            y: 1.0
        }
    ],
    zone_2: [
        {
            x: -0.333,
            y: 1.0
        },
        {
            x: -0.333,
            y: 0.3332
        },
        {
            x: 0.333,
            y: 0.3332
        },
        {
            x: 0.333,
            y: 1.0
        },
        {
            x: -0.333,
            y: 1.0
        }
    ],
    zone_3: [
        {
            x: 0.3331,
            y: 1.0
        },
        {
            x: 0.3331,
            y: 0.3332
        },
        {
            x: 1.0,
            y: 0.3332
        },
        {
            x: 1.0,
            y: 1.0
        },
        {
            x: 0.3331,
            y: 1.0
        }
    ],
    zone_4: [
        {
            x: -1,
            y: 0.333
        },
        {
            x: -1,
            y: -0.333
        },
        {
            x: -0.3331,
            y: -0.333
        },
        {
            x: -0.3331,
            y: 0.333
        },
        {
            x: -1,
            y: 0.333
        }
    ],
    zone_5: [
        {
            x: -0.333,
            y: 0.333
        },
        {
            x: -0.333,
            y: -0.333
        },
        {
            x: 0.333,
            y: -0.333
        },
        {
            x: 0.333,
            y: 0.333
        },
        {
            x: -0.333,
            y: 0.333
        }
    ],
    zone_6: [
        {
            x: 0.3331,
            y: 0.333
        },
        {
            x: 0.3331,
            y: -0.333
        },
        {
            x: 1.0,
            y: -0.333
        },
        {
            x: 1.0,
            y: 0.333
        },
        {
            x: 0.3331,
            y: 0.333
        }
    ],
    zone_7: [
        {
            x: -1,
            y: -0.3332
        },
        {
            x: -1,
            y: -1
        },
        {
            x: -0.3331,
            y: -1
        },
        {
            x: -0.3331,
            y: -0.3332
        },
        {
            x: -1,
            y: -0.3332
        }
    ],
    zone_8: [
        {
            x: -0.333,
            y: -0.3332
        },
        {
            x: -0.333,
            y: -1
        },
        {
            x: 0.333,
            y: -1
        },
        {
            x: 0.333,
            y: -0.3332
        },
        {
            x: -0.333,
            y: -0.3332
        }
    ],
    zone_9: [
        {
            x: 0.3331,
            y: -0.3332
        },
        {
            x: 0.3331,
            y: -1
        },
        {
            x: 1.0,
            y: -1
        },
        {
            x: 1.0,
            y: -0.3332
        },
        {
            x: 0.3331,
            y: -0.3332
        }
    ]
};

});


parcelRegister("7BxGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0ae22f3537cb6869$var$HexBin;

var $0ae22f3537cb6869$var$_react = $0ae22f3537cb6869$var$_interopRequireDefault((parcelRequire("J42oT")));

var $0ae22f3537cb6869$var$d3 = $0ae22f3537cb6869$var$_interopRequireWildcard((parcelRequire("jEBA8")));
parcelRequire("ee3f6");
var $ezPfT = parcelRequire("ezPfT");

var $esw4H = parcelRequire("esw4H");

var $0ae22f3537cb6869$var$_RunCalculations = $0ae22f3537cb6869$var$_interopRequireDefault((parcelRequire("fKd4Q")));

var $0ae22f3537cb6869$var$_Palettes = $0ae22f3537cb6869$var$_interopRequireDefault((parcelRequire("8uo4Y")));

var $0ae22f3537cb6869$var$_HexLegend = $0ae22f3537cb6869$var$_interopRequireDefault((parcelRequire("cM8HK")));

var $3wgDt = parcelRequire("3wgDt");
function $0ae22f3537cb6869$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0ae22f3537cb6869$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0ae22f3537cb6869$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $0ae22f3537cb6869$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $0ae22f3537cb6869$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0ae22f3537cb6869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0ae22f3537cb6869$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0ae22f3537cb6869$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0ae22f3537cb6869$var$_typeof(o);
}
function $0ae22f3537cb6869$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ae22f3537cb6869$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ae22f3537cb6869$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0ae22f3537cb6869$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ae22f3537cb6869$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ae22f3537cb6869$var$_defineProperty(e, r, t) {
    return (r = $0ae22f3537cb6869$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0ae22f3537cb6869$var$_toPropertyKey(t) {
    var i = $0ae22f3537cb6869$var$_toPrimitive(t, "string");
    return "symbol" == $0ae22f3537cb6869$var$_typeof(i) ? i : i + "";
}
function $0ae22f3537cb6869$var$_toPrimitive(t, r) {
    if ("object" != $0ae22f3537cb6869$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0ae22f3537cb6869$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /* eslint-disable react/prop-types */ 
function $0ae22f3537cb6869$var$HexBin() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), settings = _useChartOptions.settings, chartOptions = _useChartOptions.chartOptions;
    var pitchData = settings.data;
    // TODO: Can we do better?
    var chartType = chartOptions.type;
    var pixelPositions = (0, $3wgDt.usePixelPositions)();
    var dataWithPixels = pitchData.map(function(d, i) {
        return $0ae22f3537cb6869$var$_objectSpread($0ae22f3537cb6869$var$_objectSpread({}, d), {}, {
            px: pixelPositions[i].x,
            py: pixelPositions[i].y
        });
    });
    var radiusSize = 14;
    var hex = (0, $ezPfT.default)().x(function(d) {
        return d.px;
    }).y(function(d) {
        return d.py;
    }).radius(radiusSize * settings.vizWidth / settings.vizWidth - 1).extent([
        [
            0,
            0
        ],
        [
            settings.vizWidth - 0,
            settings.vizHeight - 0
        ]
    ]);
    var bins = hex(dataWithPixels);
    var binsWithCalcs = bins.map(function(d) {
        return {
            data: d,
            calculations: (0, $0ae22f3537cb6869$var$_RunCalculations["default"])(d, d.length)
        };
    });
    var palette = new $0ae22f3537cb6869$var$_Palettes["default"]({
        type: chartType,
        data: binsWithCalcs
    });
    var color = palette.color;
    var maxCount = (0, $esw4H.default)(bins, function(d) {
        return d.length;
    });
    if (!maxCount) return null;
    var radius = $0ae22f3537cb6869$var$d3.scaleSqrt([
        0,
        maxCount * 1.8
    ], [
        0,
        hex.radius() * Math.SQRT2
    ]);
    if (!chartOptions.scaleRadius) radius = function radius() {
        return radiusSize;
    };
    return /*#__PURE__*/ $0ae22f3537cb6869$var$_react["default"].createElement($0ae22f3537cb6869$var$_react["default"].Fragment, null, /*#__PURE__*/ $0ae22f3537cb6869$var$_react["default"].createElement("g", {
        id: "hexbinChart"
    }, binsWithCalcs.map(function(d, i) {
        var fill = String(color(Number(d.calculations[chartType])) || '#000');
        return /*#__PURE__*/ $0ae22f3537cb6869$var$_react["default"].createElement("path", {
            // eslint-disable-next-line react/no-array-index-key
            key: "hexPath_".concat(i),
            d: hex.hexagon(radius(d.data.length)),
            transform: "translate(".concat(d.data.x, ",").concat(d.data.y, ")"),
            fill: fill,
            stroke: "#000",
            opacity: chartOptions.opacity
        });
    })), chartOptions.legend ? /*#__PURE__*/ $0ae22f3537cb6869$var$_react["default"].createElement($0ae22f3537cb6869$var$_HexLegend["default"], {
        settings: settings,
        color: color,
        radius: radius,
        maxCount: maxCount,
        chartOptions: chartOptions,
        hex: hex
    }) : null);
}

});

parcelRegister("jIEnw", function(module, exports) {
"use strict";
function $a117c9a3989d43b1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a117c9a3989d43b1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a117c9a3989d43b1$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a117c9a3989d43b1$var$Contour;

var $a117c9a3989d43b1$var$_react = $a117c9a3989d43b1$var$_interopRequireDefault((parcelRequire("J42oT")));

var $a117c9a3989d43b1$var$d3 = $a117c9a3989d43b1$var$_interopRequireWildcard((parcelRequire("jEBA8")));

var $csdlO = parcelRequire("csdlO");

var $1S3JZ = parcelRequire("1S3JZ");
parcelRequire("5kU6m");
var $6FOtT = parcelRequire("6FOtT");

var $3wgDt = parcelRequire("3wgDt");
function $a117c9a3989d43b1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a117c9a3989d43b1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a117c9a3989d43b1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $a117c9a3989d43b1$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $a117c9a3989d43b1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a117c9a3989d43b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable no-param-reassign */ /* eslint-disable react/prop-types */ function $a117c9a3989d43b1$var$Contour() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions, settings = _useChartOptions.settings;
    var pixelPositions = (0, $3wgDt.usePixelPositions)();
    var density = (0, $6FOtT.default)().x(function(d) {
        return d.x;
    }).y(function(d) {
        return d.y;
    }).thresholds(9).size([
        settings.vizWidth,
        settings.vizHeight
    ]).bandwidth(8);
    var contours = density(pixelPositions);
    var densityExtent = $a117c9a3989d43b1$var$d3.max(contours, function(d) {
        return d.value;
    });
    if (!density.length || !densityExtent) return null;
    var colorDensity = (0, $csdlO.default)().range([
        '#3661AD',
        '#ffffff',
        '#D82129'
    ]).domain([
        0,
        densityExtent / 2,
        densityExtent
    ]);
    var path = (0, $1S3JZ.default)();
    return /*#__PURE__*/ $a117c9a3989d43b1$var$_react["default"].createElement("g", {
        key: "contourChart",
        id: "contourChart"
    }, contours.map(function(d, i) {
        var stroke = 'none';
        var dAttr = path(d);
        if (!dAttr) return null;
        return /*#__PURE__*/ $a117c9a3989d43b1$var$_react["default"].createElement("path", {
            // eslint-disable-next-line react/no-array-index-key
            key: "contour_".concat(i),
            stroke: stroke,
            d: dAttr,
            fill: colorDensity(d.value),
            opacity: chartOptions.opacity
        });
    }));
}

});

parcelRegister("cG5Fx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4e5192f03dc9bc42$var$PitchPie;

var $4e5192f03dc9bc42$var$_react = $4e5192f03dc9bc42$var$_interopRequireDefault((parcelRequire("J42oT")));

var $csdlO = parcelRequire("csdlO");

var $esw4H = parcelRequire("esw4H");

var $4e5192f03dc9bc42$var$_groupBy = $4e5192f03dc9bc42$var$_interopRequireDefault((parcelRequire("7fnPG")));

var $hAvpi = parcelRequire("hAvpi");
var $aRYI3 = parcelRequire("aRYI3");

var $4e5192f03dc9bc42$var$_ColorMap = $4e5192f03dc9bc42$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $4e5192f03dc9bc42$var$_PieLegend = $4e5192f03dc9bc42$var$_interopRequireDefault((parcelRequire("ePrzG")));

var $4e5192f03dc9bc42$var$_Legend = $4e5192f03dc9bc42$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $3wgDt = parcelRequire("3wgDt");
function $4e5192f03dc9bc42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4e5192f03dc9bc42$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4e5192f03dc9bc42$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4e5192f03dc9bc42$var$_typeof(o);
}
function $4e5192f03dc9bc42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e5192f03dc9bc42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e5192f03dc9bc42$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4e5192f03dc9bc42$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e5192f03dc9bc42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4e5192f03dc9bc42$var$_defineProperty(e, r, t) {
    return (r = $4e5192f03dc9bc42$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4e5192f03dc9bc42$var$_toPropertyKey(t) {
    var i = $4e5192f03dc9bc42$var$_toPrimitive(t, "string");
    return "symbol" == $4e5192f03dc9bc42$var$_typeof(i) ? i : i + "";
}
function $4e5192f03dc9bc42$var$_toPrimitive(t, r) {
    if ("object" != $4e5192f03dc9bc42$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4e5192f03dc9bc42$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /* eslint-disable react/prop-types */ 
function $4e5192f03dc9bc42$var$PitchPie() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions, settings = _useChartOptions.settings;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var zonePositions = (0, $3wgDt.useStrikeZonePositions)();
    var pitchData = $4e5192f03dc9bc42$var$groupPitchesAndLocation(settings.data, zonePositions);
    var pitches = (0, $4e5192f03dc9bc42$var$_groupBy["default"])(pitchData, 'pzpx');
    var radius = 15;
    var radiusScale;
    if (chartOptions.scaleRadius) {
        var maxes = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var zone in pitches){
            var count = 0;
            for(var i = 0; i < pitches[zone].length; i++)count += Number(pitches[zone][i].count);
            maxes.push(count);
        }
        var maxValue = (0, $esw4H.default)(maxes, function(d) {
            return Number(d);
        }) || 100;
        radiusScale = (0, $csdlO.default)().range([
            settings.vizWidth * 0.025,
            settings.vizWidth * 0.045
        ]).domain([
            1,
            maxValue
        ]);
    }
    var pitchPie = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    var _loop = function _loop(pitch) {
        var size = 0;
        for(var _i = 0; _i < pitches[pitch].length; _i++)size += Number(pitches[pitch][_i].count);
        if (chartOptions.scaleRadius && radiusScale) radius = radiusScale(size);
        var pp = (0, $aRYI3.default)().sort(null).value(function(d) {
            return Number(d.count);
        });
        var path = (0, $hAvpi.default)().outerRadius(radius - settings.vizWidth * 0.014).innerRadius(0);
        pitchPie.push(pp(pitches[pitch]).map(function(d, i) {
            var _path;
            return /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement("g", {
                // eslint-disable-next-line react/no-array-index-key
                key: "pie_key_".concat(pitch, "_").concat(d.data.count, "_").concat(i),
                id: "id_".concat(pitch, "_").concat(d.data.count)
            }, /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement("path", {
                transform: "translate(".concat(xScale(Number(d.data.px)), ",").concat(yScale(Number(d.data.pz)), ")"),
                d: (_path = path(d)) !== null && _path !== void 0 ? _path : undefined,
                fill: (0, $4e5192f03dc9bc42$var$_ColorMap["default"])('pitch_name', d.data.pitch),
                stroke: "#000",
                strokeWidth: 0.5
            }));
        }));
    };
    for(var pitch in pitches)_loop(pitch);
    return /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement($4e5192f03dc9bc42$var$_react["default"].Fragment, null, /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement("g", {
        id: "pitchPie"
    }, pitchPie), chartOptions.legend ? /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement($4e5192f03dc9bc42$var$_react["default"].Fragment, null, /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement($4e5192f03dc9bc42$var$_Legend["default"], {
        settings: settings,
        type: "pitchName"
    }), radiusScale ? /*#__PURE__*/ $4e5192f03dc9bc42$var$_react["default"].createElement($4e5192f03dc9bc42$var$_PieLegend["default"], {
        settings: settings,
        radiusScale: radiusScale
    }) : null) : null);
}
var $4e5192f03dc9bc42$var$BIN_SIZE = 0.5;
function $4e5192f03dc9bc42$var$roundAndGroupPitches(pitches, normalizedPositions) {
    return pitches.map(function(p, i) {
        var _normalizedPositions$ = normalizedPositions[i], x = _normalizedPositions$.x, z = _normalizedPositions$.z;
        var piePx = (Math.round(Number(x) / $4e5192f03dc9bc42$var$BIN_SIZE) * $4e5192f03dc9bc42$var$BIN_SIZE).toFixed(2);
        var piePz = (Math.round(Number(z) / $4e5192f03dc9bc42$var$BIN_SIZE) * $4e5192f03dc9bc42$var$BIN_SIZE).toFixed(2);
        // new
        var pieId = "p_".concat(piePz).concat(piePx).replaceAll('-', '_').replaceAll('.', '');
        // old
        // const pieId1 = `p_${piePz < 0 ? `_${Math.abs(piePz)}` : piePz}${
        //     piePx < 0 ? `_${Math.abs(piePx)}` : piePx
        // }`
        // const pieIdOld = pieId1.split('.').join('')
        return $4e5192f03dc9bc42$var$_objectSpread($4e5192f03dc9bc42$var$_objectSpread({}, p), {}, {
            piePx: piePx,
            piePz: piePz,
            pieId: pieId
        });
    });
}
function $4e5192f03dc9bc42$var$groupPitchesAndLocation(pitches, normalizedPositions) {
    //  const pitches = removeBadPitches
    var roundedPitches = $4e5192f03dc9bc42$var$roundAndGroupPitches(pitches, normalizedPositions);
    var pitchLocations = (0, $4e5192f03dc9bc42$var$_groupBy["default"])(roundedPitches, function(d) {
        return d.pieId;
    });
    var pitchBreakdown = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for(var location in pitchLocations){
        var l = pitchLocations[location];
        var pitchTypes = (0, $4e5192f03dc9bc42$var$_groupBy["default"])(l, function(d) {
            return d.pitchType;
        });
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var pitchType in pitchTypes){
            var p = pitchTypes[pitchType];
            pitchBreakdown.push({
                count: p.length,
                px: p[0].piePx,
                pz: p[0].piePz,
                pzpx: p[0].pieId,
                pitch: pitchType
            });
        }
    }
    return pitchBreakdown;
}

});
parcelRegister("ePrzG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $2d1dda695fbefc94$var$PieLegend;

var $2d1dda695fbefc94$var$_react = $2d1dda695fbefc94$var$_interopRequireDefault((parcelRequire("J42oT")));
function $2d1dda695fbefc94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $2d1dda695fbefc94$var$PieLegend(_ref) {
    var settings = _ref.settings, radiusScale = _ref.radiusScale;
    var domain = radiusScale.domain().reverse();
    var domainTotal = 0;
    // Get total sum of domain... if it equals 2 it has 1,1 in array which we don't want showing up on the legend
    for(var i = 0; i < domain.length; i++)domainTotal += domain[i];
    if (domainTotal === 2) domain = [
        1
    ];
    var translate = [
        settings.vizWidth * 1.02,
        settings.vizHeight * 0.9
    ];
    if (settings.orientation === 'portrait') translate = [
        settings.vizWidth / 1.4,
        settings.vizWidth * 1.05
    ];
    return /*#__PURE__*/ $2d1dda695fbefc94$var$_react["default"].createElement("g", {
        key: "pieLegend",
        id: "pieLegend",
        transform: "translate(".concat([
            translate
        ], ")")
    }, domain.map(function(d, i) {
        return /*#__PURE__*/ $2d1dda695fbefc94$var$_react["default"].createElement("g", {
            key: "g_".concat(d)
        }, /*#__PURE__*/ $2d1dda695fbefc94$var$_react["default"].createElement("circle", {
            r: radiusScale(d) - settings.vizWidth * 0.014,
            transform: "translate(0, ".concat(i * 28, ")"),
            fill: "none",
            stroke: "#000"
        }), /*#__PURE__*/ $2d1dda695fbefc94$var$_react["default"].createElement("text", {
            className: "legend",
            dy: "4",
            transform: "translate(20, ".concat(i * 28, ")"),
            fill: "#000",
            style: {
                fontSize: "1rem"
            }
        }, d, " ", d === 1 ? 'Pitch' : 'Pitches'));
    }));
}

});


parcelRegister("1rGPT", function(module, exports) {
"use strict";
function $10d98a645c2d2626$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $10d98a645c2d2626$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10d98a645c2d2626$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $10d98a645c2d2626$var$Axis;

var $10d98a645c2d2626$var$_react = $10d98a645c2d2626$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $8qjng = parcelRequire("8qjng");
var $3O9c9 = parcelRequire("3O9c9");

var $esw4H = parcelRequire("esw4H");

var $hAvpi = parcelRequire("hAvpi");
var $awfCb = parcelRequire("awfCb");

var $10d98a645c2d2626$var$_ColorMap = $10d98a645c2d2626$var$_interopRequireDefault((parcelRequire("uw3x8")));

var $10d98a645c2d2626$var$_Legend = $10d98a645c2d2626$var$_interopRequireDefault((parcelRequire("ixwYs")));

var $10d98a645c2d2626$var$_PitchTypeToPitchName = $10d98a645c2d2626$var$_interopRequireDefault((parcelRequire("bHq0o")));
function $10d98a645c2d2626$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $10d98a645c2d2626$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($10d98a645c2d2626$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $10d98a645c2d2626$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $10d98a645c2d2626$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $10d98a645c2d2626$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $10d98a645c2d2626$var$_slicedToArray(r, e) {
    return $10d98a645c2d2626$var$_arrayWithHoles(r) || $10d98a645c2d2626$var$_iterableToArrayLimit(r, e) || $10d98a645c2d2626$var$_unsupportedIterableToArray(r, e) || $10d98a645c2d2626$var$_nonIterableRest();
}
function $10d98a645c2d2626$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $10d98a645c2d2626$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $10d98a645c2d2626$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $10d98a645c2d2626$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $10d98a645c2d2626$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $10d98a645c2d2626$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $10d98a645c2d2626$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */ 
function $10d98a645c2d2626$var$Axis(_ref) {
    var settings = _ref.settings, _ref$chartOptions = _ref.chartOptions, chartOptions = _ref$chartOptions === void 0 ? {} : _ref$chartOptions;
    var innerRadius = chartOptions.innerRadius || 67;
    var outerRadius = chartOptions.outerRadius || 220;
    var pitchTypes = chartOptions.pitchTypes || [
        'infer_n_ff',
        'infer_n_si',
        'infer_n_fc',
        'infer_n_ch',
        'infer_n_sl',
        'infer_n_st',
        'infer_n_sv',
        'infer_n_cu',
        'infer_n_kc',
        'infer_n_fs',
        'infer_n_sc',
        'infer_n_fo'
    ];
    var spinData = settings.data;
    var pitchTypeOrder = pitchTypes.map(function(d) {
        return d.split('_')[2].toUpperCase();
    });
    var usedPitchTypes = spinData.map(function(row) {
        return pitchTypes.map(function(type) {
            return {
                type: type,
                n: Number(row[type])
            };
        }).filter(function(d) {
            return d.n > 0;
        })// This may not work someday...
        .map(function(d) {
            return d.type.split('_')[2].toUpperCase();
        });
    }).flat();
    var uniquePitchTypes = Array.from(new Set(usedPitchTypes)).map(function(d) {
        return {
            pitchType: d,
            // These are used by legend. We use the preFormatted prop to skip formatting/sorting
            event: d,
            eventFormatted: (0, $10d98a645c2d2626$var$_PitchTypeToPitchName["default"])(d).toUpperCase()
        };
    }).sort(function(a, b) {
        var aIndex = pitchTypeOrder.indexOf(a.pitchType);
        var bIndex = pitchTypeOrder.indexOf(b.pitchType);
        return aIndex - bIndex;
    });
    var y = (0, $3O9c9.default)().domain([
        0,
        (0, $esw4H.default)(spinData, function(d) {
            return Number(d.y);
        })
    ]).range([
        innerRadius,
        outerRadius
    ]);
    var x = (0, $8qjng.default)().domain(spinData.map(function(d) {
        return d.x;
    })).range([
        0,
        2 * Math.PI
    ]).align(0);
    var fifteenMinutes = 2 * Math.PI / 48;
    var arcShape = (0, $hAvpi.default)().innerRadius(function(d) {
        return y(d[0]);
    }).outerRadius(function(d) {
        return y(d[1]);
    }).startAngle(function(d) {
        return x(d.data.x) - fifteenMinutes;
    }).endAngle(function(d) {
        return x(d.data.x) - fifteenMinutes + x.bandwidth();
    }).padAngle(0.01).padRadius(innerRadius);
    var initStacks = (0, $awfCb.default)().keys(pitchTypes)(spinData);
    var _useState = (0, $10d98a645c2d2626$var$_react.useState)(initStacks), _useState2 = $10d98a645c2d2626$var$_slicedToArray(_useState, 2), stacks = _useState2[0], setStacks = _useState2[1];
    var wholeNumbers = spinData.filter(function(d) {
        return Math.round(Number(d.x)) === Number(d.x);
    });
    var texts = wholeNumbers.map(function(d) {
        var angle = x(d.x) - Math.PI / 2;
        var xVal = Math.cos(angle) * (innerRadius * 0.75);
        var yVal = Math.sin(angle) * (innerRadius * 0.75);
        return /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("text", {
            key: d.x,
            x: xVal,
            y: yVal,
            textAnchor: "middle",
            dominantBaseline: "middle"
        }, d.x);
    });
    var ticks = wholeNumbers.map(function(d) {
        var angle = (x(d.x) - Math.PI / 2) * 180 / Math.PI;
        var transform = "rotate(".concat(angle, ")");
        return /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("g", {
            key: d.x,
            transform: transform
        }, /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("line", {
            x1: innerRadius - 4,
            y1: "0",
            x2: innerRadius,
            y2: "0",
            strokeWidth: "2",
            stroke: "black"
        }));
    });
    // reduce flicker by waiting a split second
    var mouseOver = false;
    var handleMouseOver = (0, $10d98a645c2d2626$var$_react.useCallback)(function(e, _ref2) {
        var pitchType = _ref2.pitchType;
        var filteredPitchType = pitchTypes.filter(function(d) {
            return d.includes("_".concat(pitchType.toLowerCase()));
        });
        var newStacks = (0, $awfCb.default)().keys(filteredPitchType)(spinData);
        setStacks(newStacks);
        mouseOver = true;
    }, [
        setStacks
    ]);
    var handleMouseOut = (0, $10d98a645c2d2626$var$_react.useCallback)(function() {
        mouseOver = false;
        setTimeout(function() {
            if (!mouseOver) setStacks(initStacks);
        }, 200);
    }, [
        setStacks
    ]);
    return /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement($10d98a645c2d2626$var$_react["default"].Fragment, null, /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("g", {
        transform: "translate(".concat(settings.vizWidth / 2, ",").concat(settings.vizWidth / 2, ")"),
        key: "spinAxisChart",
        id: "spinAxisChart"
    }, /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("circle", {
        r: innerRadius,
        strokeWidth: chartOptions.strokeWidth || 0.75,
        stroke: chartOptions.stroke || '#000',
        fill: "none"
    }), stacks.map(function(layer, i) {
        var pitchType = String(layer.key.split('_')[2]).toUpperCase();
        var pitchColor = (0, $10d98a645c2d2626$var$_ColorMap["default"])('pitchName', pitchType);
        return /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("g", {
            // eslint-disable-next-line react/no-array-index-key
            key: "radial_".concat(i),
            fill: pitchColor,
            opacity: chartOptions.opacity
        }, layer.map(function(pitch, j) {
            return /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement("path", {
                // eslint-disable-next-line react/no-array-index-key
                key: "axis_path_".concat(j),
                d: arcShape(pitch),
                className: "arc-".concat(pitchType),
                strokeWidth: chartOptions.strokeWidth || 0.75,
                stroke: chartOptions.stroke || '#000',
                opacity: pitch[0] === pitch[1] ? 0 : 1
            });
        }));
    }), texts, ticks), chartOptions.legend ? /*#__PURE__*/ $10d98a645c2d2626$var$_react["default"].createElement($10d98a645c2d2626$var$_Legend["default"], {
        settings: {
            data: uniquePitchTypes,
            vizWidth: settings.vizWidth,
            vizScale: 1
        },
        handleMouseOver: handleMouseOver,
        handleMouseOut: handleMouseOut,
        preFormatted: true,
        type: chartOptions.legendType
    }) : null);
}

});
parcelRegister("8qjng", function(module, exports) {

$parcel$export(module.exports, "default", () => $621fc7bb4b5e7048$export$2e2bcd8739ae039);

var $fHmde = parcelRequire("fHmde");

var $9HCq2 = parcelRequire("9HCq2");

var $bNAby = parcelRequire("bNAby");
function $621fc7bb4b5e7048$export$2e2bcd8739ae039() {
    var scale = (0, $bNAby.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $fHmde.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $621fc7bb4b5e7048$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $9HCq2.initRange).apply(rescale(), arguments);
}
function $621fc7bb4b5e7048$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $621fc7bb4b5e7048$var$pointish(copy());
    };
    return scale;
}
function $621fc7bb4b5e7048$export$105684a3041cb6f3() {
    return $621fc7bb4b5e7048$var$pointish($621fc7bb4b5e7048$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("fHmde", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dc1a15842189a3$export$2e2bcd8739ae039);
function $b6dc1a15842189a3$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("bNAby", function(module, exports) {

$parcel$export(module.exports, "default", () => $897056f58b803c18$export$2e2bcd8739ae039);

var $9HCq2 = parcelRequire("9HCq2");
const $897056f58b803c18$export$e4f898ab14d9d460 = Symbol("implicit");
function $897056f58b803c18$export$2e2bcd8739ae039() {
    var index = new Map(), domain = [], range = [], unknown = $897056f58b803c18$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $897056f58b803c18$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $897056f58b803c18$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $9HCq2.initRange).apply(scale, arguments);
    return scale;
}

});


parcelRegister("3O9c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5d2c8ea6ee0a9a$export$2e2bcd8739ae039);

var $g7ot1 = parcelRequire("g7ot1");

var $9HCq2 = parcelRequire("9HCq2");

var $csdlO = parcelRequire("csdlO");

var $cl20v = parcelRequire("cl20v");
function $2c5d2c8ea6ee0a9a$var$square(x) {
    return Math.sign(x) * x * x;
}
function $2c5d2c8ea6ee0a9a$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $2c5d2c8ea6ee0a9a$export$2e2bcd8739ae039() {
    var squared = (0, $g7ot1.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $2c5d2c8ea6ee0a9a$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($2c5d2c8ea6ee0a9a$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $cl20v.default))).map($2c5d2c8ea6ee0a9a$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $2c5d2c8ea6ee0a9a$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $9HCq2.initRange).apply(scale, arguments);
    return (0, $csdlO.linearish)(scale);
}

});

parcelRegister("bHq0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8847e1fc08b483e9$var$PitchTypeToPitchName;
function $8847e1fc08b483e9$var$PitchTypeToPitchName(pitchType) {
    if (pitchType === 'FT') return '2-Seam Fastball';
    if (pitchType === 'FF') return '4-Seam Fastball';
    if (pitchType === 'AB') return 'Automatic Ball';
    if (pitchType === 'CH') return 'Changeup';
    if (pitchType === 'CS') return 'Curveball';
    if (pitchType === 'CU') return 'Curveball';
    if (pitchType === 'FC') return 'Cutter';
    if (pitchType === 'EP') return 'Eephus';
    if (pitchType === 'FA') return 'Other';
    if (pitchType === 'FO') return 'Forkball';
    if (pitchType === 'IN') return 'Intentional Ball';
    if (pitchType === 'KC') return 'Knuckle Curve';
    if (pitchType === 'KN') return 'Knuckleball';
    if (pitchType === 'PO') return 'Pitch Out';
    if (pitchType === 'SC') return 'Screwball';
    if (pitchType === 'SI') return 'Sinker';
    if (pitchType === 'SL') return 'Slider';
    if (pitchType === 'ST') return 'Sweeper';
    if (pitchType === 'SV') return 'Slurve';
    if (pitchType === 'FS') return 'Split-Finger';
    if (pitchType === 'UN') return 'Unknown';
    return '';
}

});


parcelRegister("bMYA4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7914d07356b879c8$var$HomePlate;

var $7914d07356b879c8$var$_react = $7914d07356b879c8$var$_interopRequireDefault((parcelRequire("J42oT")));

var $7914d07356b879c8$var$_ZoneDepthText = $7914d07356b879c8$var$_interopRequireDefault((parcelRequire("hT5ae")));

var $3wgDt = parcelRequire("3wgDt");

var $7914d07356b879c8$var$_ZoneScaleText = $7914d07356b879c8$var$_interopRequireDefault((parcelRequire("hXkZz")));

var $7914d07356b879c8$var$_useFlag = $7914d07356b879c8$var$_interopRequireDefault((parcelRequire("kDnsA")));
function $7914d07356b879c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $7914d07356b879c8$var$shouldShowPlateDepthLegend(_ref) {
    var chartType = _ref.chartType, overlayType = _ref.overlayType;
    var overlayTypes = [
        'pitch',
        'hexbin',
        'contour',
        'pie'
    ];
    return chartType === 'pitch' && overlayTypes.includes(overlayType);
}
function $7914d07356b879c8$var$HomePlate(_ref2) {
    var _ref2$pitcherPerspect = _ref2.pitcherPerspective, pitcherPerspective = _ref2$pitcherPerspect === void 0 ? false : _ref2$pitcherPerspect, _ref2$showMidPlateSha = _ref2.showMidPlateShadow, showMidPlateShadow = _ref2$showMidPlateSha === void 0 ? false : _ref2$showMidPlateSha, _ref2$showFrontPlateS = _ref2.showFrontPlateShadow, showFrontPlateShadow = _ref2$showFrontPlateS === void 0 ? false : _ref2$showFrontPlateS;
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions, settings = _useChartOptions.settings;
    var showPlateDepth = $7914d07356b879c8$var$shouldShowPlateDepthLegend(chartOptions);
    var shouldShowZoneDepthText = showPlateDepth && (0, $7914d07356b879c8$var$_useFlag["default"])('showZoneDepthText');
    var shouldShowZoneScaleText = showPlateDepth && (0, $7914d07356b879c8$var$_useFlag["default"])('showZoneScaleText') && settings.data.length;
    var wrapperTransform = pitcherPerspective ? 'translate(190, 435)' : 'translate(190, 400) scale(1.13, 0.954)';
    var homeplatePathD = pitcherPerspective ? 'M15.65,12.74S58.68,.52,58.68,.52l44.2,12.22,16.74,36H.75L15.65,12.74Z' : 'M.5,33.51s52.15,17.56,52.15,17.56l53.21-17.56L91.81,.85,13.85,.5,.5,33.51Z';
    return /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement($7914d07356b879c8$var$_react["default"].Fragment, null, /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement("style", null, ".e{fill:#eaeaea;stroke:#d6d6d6;stroke-miterlimit:10;}")), /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement("g", {
        transform: wrapperTransform
    }, /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement("g", null, /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement("path", {
        className: "e",
        d: homeplatePathD
    }))), shouldShowZoneScaleText && /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement($7914d07356b879c8$var$_ZoneScaleText["default"], null), shouldShowZoneDepthText && /*#__PURE__*/ $7914d07356b879c8$var$_react["default"].createElement($7914d07356b879c8$var$_ZoneDepthText["default"], {
        showMidPlateShadow: showMidPlateShadow,
        showFrontPlateShadow: showFrontPlateShadow,
        pitcherPerspective: pitcherPerspective
    }));
}

});
parcelRegister("hT5ae", function(module, exports) {
"use strict";
function $61f8da543c970a60$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61f8da543c970a60$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61f8da543c970a60$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $61f8da543c970a60$var$ZoneDepthText;

var $61f8da543c970a60$var$_react = $61f8da543c970a60$var$_interopRequireWildcard((parcelRequire("J42oT")));
function $61f8da543c970a60$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($61f8da543c970a60$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $61f8da543c970a60$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $61f8da543c970a60$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $61f8da543c970a60$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $61f8da543c970a60$var$_slicedToArray(r, e) {
    return $61f8da543c970a60$var$_arrayWithHoles(r) || $61f8da543c970a60$var$_iterableToArrayLimit(r, e) || $61f8da543c970a60$var$_unsupportedIterableToArray(r, e) || $61f8da543c970a60$var$_nonIterableRest();
}
function $61f8da543c970a60$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $61f8da543c970a60$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $61f8da543c970a60$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $61f8da543c970a60$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $61f8da543c970a60$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $61f8da543c970a60$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $61f8da543c970a60$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $61f8da543c970a60$var$ZoneDepthText(_ref) {
    var showMidPlateShadow = _ref.showMidPlateShadow, showFrontPlateShadow = _ref.showFrontPlateShadow, pitcherPerspective = _ref.pitcherPerspective;
    var _useState = (0, $61f8da543c970a60$var$_react.useState)(false), _useState2 = $61f8da543c970a60$var$_slicedToArray(_useState, 2), hovered = _useState2[0], setHovered = _useState2[1];
    if (!showMidPlateShadow && !showFrontPlateShadow) return null;
    // If you change one variable, it's height
    var height = 6; // "rise"
    var slope = 2;
    var run = height / slope;
    var width = pitcherPerspective ? 88 : 112;
    var startPoint = 250 - width / 2;
    var returnWidth = -width - 2 * run;
    var topWidth = pitcherPerspective ? 112 : 90;
    var topStartPoint = 250 - topWidth / 2;
    var topReturnWidth = -topWidth - 2 * run;
    var midY = pitcherPerspective ? 449 : 426;
    var frontY = pitcherPerspective ? 478 : 401;
    var plateSize = 20;
    var halfPlate = plateSize / 2;
    var bandHeight = 3;
    var zoneText = '';
    // let homePlateOffSet = 0
    if (showFrontPlateShadow && showMidPlateShadow) zoneText = 'Mix of Front and Middle Zones';
    else if (showFrontPlateShadow) zoneText = 'Zone at Front of Plate';
    else if (showMidPlateShadow) zoneText = 'Zone at Middle of Plate';
    var catcherYNudge = halfPlate / 3;
    var iconPath = pitcherPerspective ? "M".concat(halfPlate, ",").concat(-catcherYNudge, " l").concat(halfPlate, ",").concat(halfPlate, " l0,").concat(halfPlate, " l").concat(-plateSize, ",0 l0,").concat(-halfPlate) : "M0,0 l".concat(plateSize, ",0 l0,").concat(halfPlate, " l-").concat(halfPlate, ",").concat(halfPlate, " l").concat(-halfPlate, ",").concat(-halfPlate, " l0,").concat(-halfPlate);
    var iconShadowY = pitcherPerspective ? halfPlate + catcherYNudge : 0;
    return /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement($61f8da543c970a60$var$_react["default"].Fragment, null, hovered && showMidPlateShadow && /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("path", {
        d: "M".concat(startPoint, ",").concat(midY, " l").concat(width, ",0 l").concat(run, ",").concat(height, " l").concat(returnWidth, ",0"),
        fill: "#ccc"
    }), hovered && showFrontPlateShadow && /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("path", {
        d: "M".concat(topStartPoint, ",").concat(frontY, " l").concat(topWidth, ",0 l").concat(run, ",").concat(height, " l").concat(topReturnWidth, ",0"),
        fill: "#ccc"
    }), /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("g", {
        transform: "translate(515, 520)",
        onMouseOver: function onMouseOver() {
            return setHovered(true);
        },
        onMouseOut: function onMouseOut() {
            return setHovered(false);
        }
    }, /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("g", {
        transform: "translate(".concat(10, ",-15)")
    }, /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("path", {
        d: iconPath,
        fill: "#ddd"
    }), showFrontPlateShadow && /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("path", {
        d: "M0,".concat(iconShadowY, " l").concat(plateSize, ",0 l0,").concat(bandHeight, " l").concat(-plateSize, ",0"),
        fill: "#999"
    }), showMidPlateShadow && /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("path", {
        d: "M0,".concat(halfPlate - bandHeight / 2, " l").concat(plateSize, ",0 l0,").concat(bandHeight / 2, " l").concat(-bandHeight / 2, ",").concat(bandHeight / 2, " l").concat(-plateSize + bandHeight, ",0"),
        fill: "#999"
    })), /*#__PURE__*/ $61f8da543c970a60$var$_react["default"].createElement("text", {
        className: "legend",
        fontSize: "18",
        textAnchor: "end",
        fill: "#666"
    }, zoneText)));
}

});

parcelRegister("hXkZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c87d8fa60dd47ba2$var$ZoneScaleText;

var $c87d8fa60dd47ba2$var$_react = $c87d8fa60dd47ba2$var$_interopRequireDefault((parcelRequire("J42oT")));

var $3wgDt = parcelRequire("3wgDt");
function $c87d8fa60dd47ba2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c87d8fa60dd47ba2$var$ZoneScaleText() {
    var shouldShowNormalized = (0, $3wgDt.useShouldShowNormalized)();
    var strikeZone = (0, $3wgDt.useStrikeZoneType)();
    var zoneText = strikeZone === 'personal' || !shouldShowNormalized ? 'Actual Pitch Height' : 'Pitch Location Adjusted for Batter Zone';
    // const zoneX = shouldShowNormalized ? -170 : -145
    var zoneHeight = 16;
    return /*#__PURE__*/ $c87d8fa60dd47ba2$var$_react["default"].createElement("g", {
        transform: "translate(-5, 520)"
    }, /*#__PURE__*/ $c87d8fa60dd47ba2$var$_react["default"].createElement("g", {
        className: "here",
        transform: "translate(".concat(-16, ", ").concat(-zoneHeight + 1, ")")
    }, /*#__PURE__*/ $c87d8fa60dd47ba2$var$_react["default"].createElement("rect", {
        fill: "#f2f2f2",
        stroke: "#666",
        width: "10",
        height: zoneHeight,
        strokeWidth: "2",
        strokeDasharray: "4 2"
    })), /*#__PURE__*/ $c87d8fa60dd47ba2$var$_react["default"].createElement("text", {
        className: "legend",
        fontSize: "18",
        textAnchor: "start",
        fill: "#666"
    }, zoneText));
}

});

parcelRegister("kDnsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $902df76ef762eb80$var$useFlag;

var $3wgDt = parcelRequire("3wgDt");
var $902df76ef762eb80$var$defaults = {
    showZoneDepthText: true,
    showZoneScaleText: true
};
function $902df76ef762eb80$var$useFlag(flag) {
    var _chartOptions$flags;
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions;
    if (typeof ((_chartOptions$flags = chartOptions.flags) === null || _chartOptions$flags === void 0 ? void 0 : _chartOptions$flags[flag]) === 'boolean') return chartOptions.flags[flag];
    return Boolean($902df76ef762eb80$var$defaults[flag]);
}

});


parcelRegister("iMsqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5833ce211fc896be$var$StrikeZoneWrapper;

var $5833ce211fc896be$var$_react = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("J42oT")));

var $5833ce211fc896be$var$_Generic = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("eATPu")));

var $5833ce211fc896be$var$_Dumb = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("drWWu")));

var $5833ce211fc896be$var$_Fuzzy = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("lHNxm")));

var $5833ce211fc896be$var$_getStrikeZoneDims = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("15SjV")));

var $3wgDt = parcelRequire("3wgDt");

var $5833ce211fc896be$var$_canBePersonalized = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("ibFsF")));

var $5833ce211fc896be$var$_shouldShowNormalized = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("lbfwa")));

var $5833ce211fc896be$var$_FuzzyForeground = $5833ce211fc896be$var$_interopRequireDefault((parcelRequire("334W6")));
function $5833ce211fc896be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ var $5833ce211fc896be$var$colors = {
    average: '#111',
    personal: '#111',
    generic: '#111',
    'generic-old': '#111',
    fuzzy: '#111'
};
function $5833ce211fc896be$var$StrikeZone() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), chartOptions = _useChartOptions.chartOptions, settings = _useChartOptions.settings;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var strikeZone = (0, $3wgDt.useStrikeZoneType)();
    var isPersonal = strikeZone === 'personal';
    var strikeZoneDims = (0, $5833ce211fc896be$var$_getStrikeZoneDims["default"])(strikeZone, settings.data);
    var strokeDasharray = isPersonal ? 'none' : '8 2.5';
    var isLocationAccurate = (0, $3wgDt.useLocationAccurate_TODOFIX)();
    if (isLocationAccurate) return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_FuzzyForeground["default"], null);
    // Only necessary while isLocationAccurate is kneecapped
    var showNormalized = (0, $3wgDt.useShouldShowNormalized)();
    var actualLocationAccurate = !isPersonal && !showNormalized;
    var strokeColor = actualLocationAccurate ? '#888' : $5833ce211fc896be$var$colors[strikeZone];
    switch(strikeZone){
        // case 'generic-old':
        case 'personal':
        case 'average':
        case 'generic':
            return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_Dumb["default"], {
                xScale: xScale,
                yScale: yScale,
                szTop: strikeZoneDims.top,
                szBot: strikeZoneDims.bot,
                plateWidthFt: strikeZoneDims.width,
                styles: {
                    stroke: strokeColor,
                    strokeDasharray: strokeDasharray
                }
            });
        case 'fuzzy':
            return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_Fuzzy["default"], {
                xScale: xScale,
                yScale: yScale,
                data: settings.data
            });
        default:
            return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_Generic["default"], {
                xScale: xScale,
                yScale: yScale,
                chartOptions: chartOptions
            });
    }
}
function $5833ce211fc896be$var$QuickRuler(_ref) {
    var yScale = _ref.yScale;
    var y = yScale(6);
    var height = yScale(0) - y;
    var width = 8;
    var tickWidth = 12;
    var ticks = [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ];
    return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("g", null, /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("rect", {
        y: y,
        height: height,
        width: "8",
        fill: "#ccc"
    }), ticks.map(function(tick) {
        return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("g", {
            key: tick,
            transform: "translate(0, ".concat(yScale(tick) - 1, ")")
        }, /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("text", {
            dx: -tickWidth - 2,
            dy: 2,
            dominantBaseline: "middle"
        }, tick), /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("rect", {
            x: -tickWidth + width,
            height: 2,
            fill: "#666",
            width: tickWidth
        }));
    }));
}
var $5833ce211fc896be$var$showCycler = false;
function $5833ce211fc896be$var$StrikeZoneWrapper() {
    var _useChartOptions2 = (0, $3wgDt.useChartOptions)(), cycleStrikeZone = _useChartOptions2.cycleStrikeZone, updateChartOptions = _useChartOptions2.updateChartOptions, chartOptions = _useChartOptions2.chartOptions, settings = _useChartOptions2.settings;
    var strikeZone = (0, $3wgDt.useStrikeZoneType)();
    var _useScales2 = (0, $3wgDt.useScales)(), yScale = _useScales2.yScale;
    var canBePersonal = (0, $5833ce211fc896be$var$_canBePersonalized["default"])(settings.data);
    var showNormalized = (0, $5833ce211fc896be$var$_shouldShowNormalized["default"])(chartOptions, strikeZone);
    return /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_react["default"].Fragment, null, $5833ce211fc896be$var$showCycler && /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$_react["default"].Fragment, null, /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("text", {
        onClick: function onClick() {
            cycleStrikeZone(canBePersonal);
        },
        x: 250,
        fontSize: "16",
        textAnchor: "middle",
        style: {
            cursor: 'pointer'
        }
    }, "Zone: ", strikeZone), /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement("text", {
        x: 250,
        y: 30,
        textAnchor: "middle",
        onClick: function onClick() {
            updateChartOptions({
                normalize: !showNormalized
            });
        },
        fontSize: "16",
        style: {
            cursor: 'pointer'
        }
    }, showNormalized ? 'Scale: Normalized (to generic)' : 'Scale: Actual')), $5833ce211fc896be$var$showCycler && /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$QuickRuler, {
        yScale: yScale
    }), /*#__PURE__*/ $5833ce211fc896be$var$_react["default"].createElement($5833ce211fc896be$var$StrikeZone, null));
}

});
parcelRegister("eATPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $14edac4fed1d95fb$var$StrikeZoneGeneric;

var $14edac4fed1d95fb$var$_react = $14edac4fed1d95fb$var$_interopRequireDefault((parcelRequire("J42oT")));

var $mdo2f = parcelRequire("mdo2f");

var $14edac4fed1d95fb$var$_Dumb = $14edac4fed1d95fb$var$_interopRequireDefault((parcelRequire("drWWu")));
function $14edac4fed1d95fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $14edac4fed1d95fb$var$_extends() {
    return $14edac4fed1d95fb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $14edac4fed1d95fb$var$_extends.apply(null, arguments);
} /* eslint-disable react/prop-types */ 
function $14edac4fed1d95fb$var$StrikeZoneGeneric(_ref) {
    var xScale = _ref.xScale, yScale = _ref.yScale, chartOptions = _ref.chartOptions;
    var styles = {
        strokeOpacity: chartOptions.strikeZoneBorderOpacity,
        fillOpacity: chartOptions.strikeZoneFillOpacity
    };
    return /*#__PURE__*/ $14edac4fed1d95fb$var$_react["default"].createElement($14edac4fed1d95fb$var$_Dumb["default"], $14edac4fed1d95fb$var$_extends({
        xScale: xScale,
        yScale: yScale,
        szTop: $mdo2f.topZoneAverage,
        szBot: $mdo2f.bottomZoneAverage,
        plateWidthFt: $mdo2f.plateWidthFt
    }, styles));
}

});
parcelRegister("drWWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1a7d6483f30326c4$var$StrikeZoneDumb;

var $mdo2f = parcelRequire("mdo2f");

var $1a7d6483f30326c4$var$_react = $1a7d6483f30326c4$var$_interopRequireDefault((parcelRequire("J42oT")));
function $1a7d6483f30326c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1a7d6483f30326c4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a7d6483f30326c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a7d6483f30326c4$var$_typeof(o);
}
function $1a7d6483f30326c4$var$_extends() {
    return $1a7d6483f30326c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1a7d6483f30326c4$var$_extends.apply(null, arguments);
}
function $1a7d6483f30326c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a7d6483f30326c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a7d6483f30326c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a7d6483f30326c4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a7d6483f30326c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a7d6483f30326c4$var$_defineProperty(e, r, t) {
    return (r = $1a7d6483f30326c4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a7d6483f30326c4$var$_toPropertyKey(t) {
    var i = $1a7d6483f30326c4$var$_toPrimitive(t, "string");
    return "symbol" == $1a7d6483f30326c4$var$_typeof(i) ? i : i + "";
}
function $1a7d6483f30326c4$var$_toPrimitive(t, r) {
    if ("object" != $1a7d6483f30326c4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1a7d6483f30326c4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /* eslint-disable react/prop-types */ 
var $1a7d6483f30326c4$var$defaultStrokeWidth = 4;
var $1a7d6483f30326c4$var$defaultStyles = {
    fill: '',
    stroke: '#333',
    fillOpacity: 0.001,
    strokeOpacity: 0.8,
    strokeDasharray: '8 2.5'
};
function $1a7d6483f30326c4$var$StrikeZoneDumb(_ref) {
    var _ref$fuzz = _ref.fuzz, fuzz = _ref$fuzz === void 0 ? false : _ref$fuzz, xScale = _ref.xScale, yScale = _ref.yScale, szTop = _ref.szTop, szBot = _ref.szBot, plateWidthFt = _ref.plateWidthFt, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? $1a7d6483f30326c4$var$defaultStrokeWidth : _ref$strokeWidth, _ref$styles = _ref.styles, styles = _ref$styles === void 0 ? {} : _ref$styles;
    var _getSVGRectPositionin = (0, $mdo2f.getSVGRectPositioning)(szTop, szBot, plateWidthFt, xScale, yScale, strokeWidth), x = _getSVGRectPositionin.x, y = _getSVGRectPositionin.y, width = _getSVGRectPositionin.width, height = _getSVGRectPositionin.height;
    var rectStyles = $1a7d6483f30326c4$var$_objectSpread($1a7d6483f30326c4$var$_objectSpread({}, $1a7d6483f30326c4$var$defaultStyles), styles);
    return /*#__PURE__*/ $1a7d6483f30326c4$var$_react["default"].createElement("g", {
        className: "strike-zone-wrapper"
    }, /*#__PURE__*/ $1a7d6483f30326c4$var$_react["default"].createElement("rect", $1a7d6483f30326c4$var$_extends({
        className: "strike-zone",
        style: {
            pointerEvents: 'none'
        },
        x: x,
        width: width,
        y: y,
        height: height,
        strokeWidth: $1a7d6483f30326c4$var$defaultStrokeWidth
    }, rectStyles, {
        strokeOpacity: typeof rectStyles.strokeOpacity === 'number' ? rectStyles.strokeOpacity / 4 : 0.2,
        strokeDasharray: "none"
    })), /*#__PURE__*/ $1a7d6483f30326c4$var$_react["default"].createElement("rect", $1a7d6483f30326c4$var$_extends({
        className: "strike-zone",
        style: {
            pointerEvents: 'none'
        },
        x: x,
        width: width,
        y: y,
        height: height,
        strokeWidth: $1a7d6483f30326c4$var$defaultStrokeWidth
    }, rectStyles, {
        filter: fuzz ? 'url(#fuzzFilter)' : ''
    })));
}

});


parcelRegister("lHNxm", function(module, exports) {
"use strict";
function $9200c65df55aa937$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9200c65df55aa937$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9200c65df55aa937$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9200c65df55aa937$var$StrikeZoneFuzzy;

var $9200c65df55aa937$var$_react = $9200c65df55aa937$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $9200c65df55aa937$var$d3 = $9200c65df55aa937$var$_interopRequireWildcard((parcelRequire("jEBA8")));

var $9200c65df55aa937$var$_Dumb = $9200c65df55aa937$var$_interopRequireDefault((parcelRequire("drWWu")));
function $9200c65df55aa937$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9200c65df55aa937$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9200c65df55aa937$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9200c65df55aa937$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9200c65df55aa937$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9200c65df55aa937$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9200c65df55aa937$var$_slicedToArray(r, e) {
    return $9200c65df55aa937$var$_arrayWithHoles(r) || $9200c65df55aa937$var$_iterableToArrayLimit(r, e) || $9200c65df55aa937$var$_unsupportedIterableToArray(r, e) || $9200c65df55aa937$var$_nonIterableRest();
}
function $9200c65df55aa937$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9200c65df55aa937$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9200c65df55aa937$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9200c65df55aa937$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9200c65df55aa937$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9200c65df55aa937$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9200c65df55aa937$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */ 
var $9200c65df55aa937$var$defaultStrokeWidth = 4;
function $9200c65df55aa937$var$useId() {
    var idRef = (0, $9200c65df55aa937$var$_react.useRef)("id-".concat(Math.random().toString(36).substring(2, 9)));
    return idRef.current;
}
function $9200c65df55aa937$var$StrikeZoneFuzzy(_ref) {
    var xScale = _ref.xScale, yScale = _ref.yScale, data = _ref.data;
    var _d3$extent = $9200c65df55aa937$var$d3.extent(data, function(d) {
        return d.szTop;
    }), _d3$extent2 = $9200c65df55aa937$var$_slicedToArray(_d3$extent, 2), topMin = _d3$extent2[0], topMax = _d3$extent2[1];
    var _d3$extent3 = $9200c65df55aa937$var$d3.extent(data, function(d) {
        return d.szBot;
    }), _d3$extent4 = $9200c65df55aa937$var$_slicedToArray(_d3$extent3, 2), botMin = _d3$extent4[0], botMax = _d3$extent4[1];
    if (topMin === undefined || topMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    if (botMin === undefined || botMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    // We will assume that we never have a state where top and bottom are equal but width and depth are different.
    // Fair assumption?
    if (topMin === topMax && botMin === botMax) {
        var szWidth = data[0].szWidth || 17;
        return /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement($9200c65df55aa937$var$_Dumb["default"], {
            xScale: xScale,
            yScale: yScale,
            szTop: topMin,
            szBot: botMin,
            plateWidthFt: szWidth / 12
        });
    }
    var height = yScale(botMax) - yScale(topMin);
    var topHeight = yScale(topMin) - yScale(topMax);
    var bottomHeight = yScale(botMin) - yScale(botMax);
    var fullWidth = xScale(8.5 / 12) - xScale(-8.5 / 12);
    var patternId = $9200c65df55aa937$var$useId();
    return /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("g", {
        id: "strikeZone"
    }, /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("pattern", {
        id: patternId,
        patternUnits: "userSpaceOnUse",
        width: "4",
        height: "4"
    }, /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("path", {
        id: "background-ball",
        d: "M-1,3 L3,-1 M1,5 L5,1",
        style: {
            stroke: 'rgb(78, 121, 167)',
            strokeWidth: '10px'
        }
    }), /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("path", {
        id: "hatches-ball",
        d: "M-2,2 L2,-2 M0,4 L4,0 M2,6 L6,2",
        style: {
            stroke: 'white',
            strokeWidth: 1
        }
    }))), /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("rect", {
        height: topHeight,
        width: fullWidth,
        fill: "url(#".concat(patternId, ")"),
        fillOpacity: 0.6,
        x: xScale(-8.5 / 12),
        y: yScale(topMax),
        strokeWidth: 0
    }), /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("rect", {
        height: bottomHeight,
        width: fullWidth,
        fill: "url(#".concat(patternId, ")"),
        fillOpacity: 0.6,
        x: xScale(-8.5 / 12),
        y: yScale(botMax),
        strokeWidth: 0
    }), /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("rect", {
        height: height,
        width: $9200c65df55aa937$var$defaultStrokeWidth,
        fill: "#ccc",
        x: xScale(-8.5 / 12),
        y: yScale(topMin),
        strokeWidth: 0
    }), /*#__PURE__*/ $9200c65df55aa937$var$_react["default"].createElement("rect", {
        height: height,
        width: $9200c65df55aa937$var$defaultStrokeWidth,
        fill: "#ccc",
        x: xScale(8.5 / 12) - $9200c65df55aa937$var$defaultStrokeWidth,
        y: yScale(topMin),
        strokeWidth: 0
    }));
}

});

parcelRegister("334W6", function(module, exports) {
"use strict";
function $3fbecef8f4c891c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3fbecef8f4c891c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fbecef8f4c891c7$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $3fbecef8f4c891c7$var$StrikeZoneFuzzyForeground;

var $3fbecef8f4c891c7$var$_react = $3fbecef8f4c891c7$var$_interopRequireDefault((parcelRequire("J42oT")));

var $3fbecef8f4c891c7$var$d3 = $3fbecef8f4c891c7$var$_interopRequireWildcard((parcelRequire("jEBA8")));

var $3wgDt = parcelRequire("3wgDt");
function $3fbecef8f4c891c7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3fbecef8f4c891c7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3fbecef8f4c891c7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $3fbecef8f4c891c7$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $3fbecef8f4c891c7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3fbecef8f4c891c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $3fbecef8f4c891c7$var$_slicedToArray(r, e) {
    return $3fbecef8f4c891c7$var$_arrayWithHoles(r) || $3fbecef8f4c891c7$var$_iterableToArrayLimit(r, e) || $3fbecef8f4c891c7$var$_unsupportedIterableToArray(r, e) || $3fbecef8f4c891c7$var$_nonIterableRest();
}
function $3fbecef8f4c891c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3fbecef8f4c891c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3fbecef8f4c891c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3fbecef8f4c891c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3fbecef8f4c891c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3fbecef8f4c891c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3fbecef8f4c891c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */ 
var $3fbecef8f4c891c7$var$defaultStrokeWidth = 4;
function $3fbecef8f4c891c7$var$StrikeZoneFuzzyForeground() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), settings = _useChartOptions.settings;
    var data = settings.data;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var _d3$extent = $3fbecef8f4c891c7$var$d3.extent(data, function(d) {
        return d.szTop;
    }), _d3$extent2 = $3fbecef8f4c891c7$var$_slicedToArray(_d3$extent, 2), topMin = _d3$extent2[0], topMax = _d3$extent2[1];
    var _d3$extent3 = $3fbecef8f4c891c7$var$d3.extent(data, function(d) {
        return d.szBot;
    }), _d3$extent4 = $3fbecef8f4c891c7$var$_slicedToArray(_d3$extent3, 2), botMin = _d3$extent4[0], botMax = _d3$extent4[1];
    if (topMin === undefined || topMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    if (botMin === undefined || botMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    var height = yScale(botMax) - yScale(topMin);
    return /*#__PURE__*/ $3fbecef8f4c891c7$var$_react["default"].createElement("g", {
        id: "strikeZone"
    }, /*#__PURE__*/ $3fbecef8f4c891c7$var$_react["default"].createElement("line", {
        x1: xScale(-8.5 / 12) + $3fbecef8f4c891c7$var$defaultStrokeWidth / 2,
        y1: yScale(topMin),
        x2: xScale(-8.5 / 12) + $3fbecef8f4c891c7$var$defaultStrokeWidth / 2,
        y2: yScale(topMin) + height,
        stroke: "#111",
        strokeDasharray: "8 2.5",
        strokeWidth: $3fbecef8f4c891c7$var$defaultStrokeWidth
    }), /*#__PURE__*/ $3fbecef8f4c891c7$var$_react["default"].createElement("line", {
        x1: xScale(8.5 / 12) - $3fbecef8f4c891c7$var$defaultStrokeWidth / 2,
        x2: xScale(8.5 / 12) - $3fbecef8f4c891c7$var$defaultStrokeWidth / 2,
        y1: yScale(topMin),
        y2: yScale(topMin) + height,
        stroke: "#111",
        strokeDasharray: "8 2.5",
        strokeWidth: $3fbecef8f4c891c7$var$defaultStrokeWidth
    }));
}

});


parcelRegister("dvpmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ad8a84a6427625b0$var$RightHandedBatter;

var $ad8a84a6427625b0$var$_react = $ad8a84a6427625b0$var$_interopRequireDefault((parcelRequire("J42oT")));
function $ad8a84a6427625b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ad8a84a6427625b0$var$RightHandedBatter(_ref) {
    var _ref$pitcherPerspecti = _ref.pitcherPerspective, pitcherPerspective = _ref$pitcherPerspecti === void 0 ? false : _ref$pitcherPerspecti;
    // Someday project
    var scale = 1;
    if (pitcherPerspective) return /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement($ad8a84a6427625b0$var$_react["default"].Fragment, null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("style", null, ".e{fill:#eaeaea;stroke:#d6d6d6;}.e,.f{stroke-miterlimit:10;}.f{fill:#cecece;stroke:#bababa;}")), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", {
        className: "evp-batter evp-right-handed-batter-pitcher-perspective",
        transform: "translate(340,0) scale(".concat(scale, ")")
    }, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "f",
        d: "M163.76,4.56c-4.53-4.62-5.13-5.13-9.08-2.37-2.07,1.45-42.64,26.45-59.61,39.48-16.98,13.03-41.68,35.77-63.43,48.67C8.34,104.16,2.3,106.8,2.3,106.8c0,0-2.54-.65-1.58,1.97,.99,2.7,1.91,4.4,3.22,5.85,.96,1.05,2.31-1.11,2.31-2.3,0-1.18,17.38-10.7,17.38-10.7,0,0,34.37-21.34,34.73-21.28,0,0,40.66-24.48,48.16-28.03,7.5-3.55,51.5-33.27,59.22-37.9,3.95-2.37-1.97-9.87-1.97-9.87Z"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M9.6,119.83c.79,1.18,2.37,5.13,1.97,7.11s-6.71,22.11-6.71,30,0,20.13,2.37,24.08,10.26,2.37,14.21,1.97,21.71-5.13,21.71-5.13c0,0,3.95,9.87,4.34,13.03,.39,3.16,2.76,26.05,8.68,38.69,5.92,12.63,8.68,17.76,11.45,17.37s5.92-1.97,5.92-1.97c0,0,.79,7.9-.79,10.66-1.58,2.76-10.66,7.11-16.98,30.79-6.32,23.69-11.27,39.53-10.59,46.78,.77,8.21,8.23,27.13,8.23,27.13,0,0,8.9,26.84-.18,38.68s-10.15,9.45-16.41,10.97c-4.47,1.09-14.21,3.16-13.42,6.32s9.47,8.68,15.79,9.87c6.32,1.18,14.21-1.97,23.29-1.97s20.13,2.76,24.48-2.76-2.37-19.34-2.37-19.34c0,0-5.9-11.01-9.45-32.64,1.71,2.93,2.92,4.97,3.14,5.4,.79,1.58,18.95,45.4,19.74,46.58s3.87,7.73,5.11,9.26c2.28,2.8,6.35,8.31,4.38,10.68-1.97,2.37-6.97,5.12-13.83,10.15-10.5,7.7-30.4,9.78-28.82,16.1,1.58,6.32,8.68,8.29,17.76,9.08,9.08,.79,21.32-4.34,29.21-3.55s28.42,3.16,31.58-2.37-3.55-28.82-3.55-28.82c0,0-9.47-37.9-15-51.71s-11.39-27.97-14.21-32.54-5.93-8.12-6.32-8.52-1.58-12.63,.79-17.76,18.83-33.58,20.13-35.13c4.01-4.79,14.07-18.38,16.19-22.11,2.54-4.47,7.5-17.37,1.97-33.95-5.53-16.58-13.42-18.55-13.42-18.55,0,0-2.37-1.58-1.18-3.55,1.18-1.97,2.37-6.32,1.58-8.29-.79-1.97-8.29-25.27-9.08-46.98-.79-21.71-2.37-47.37-9.87-52.11-6.98-4.41-22.16-11.89-34.1-14.82,8.33-20.47-16.47-28.22-20.38-28.61-3.95-.39-25.27-1.18-25.66,16.98v5.92l-9.63,5.55c-1.57-.46-3.41-.42-5.37,.76-5.92,3.55-12.63,7.9-11.84,11.45,.79,3.55,4.34,10.66,5.13,11.84Zm13.42,3.16c1.97-1.58,5.13-4.34,5.13-7.5s1.18-10.66,.39-12.63c-.79-1.97-1.58-3.16-1.58-3.16,0,0-.22-.31-.62-.76,.43,0,.9,0,1.41-.03,0,0,.33,.74,.79,1.75,.96,2.13,2.5,5.48,2.77,5.75,.39,.39,4.34,11.84,4.34,11.84,0,0-.39,9.08,6.71,9.08,7.11,0,13.03,3.55,13.82,6.71l.79,3.16s-9.87-.79-16.98,4.74-15.79,10.26-15.79,10.26c0,0-3.16-11.05-3.55-16.19-.39-5.13,.39-11.45,2.37-13.03Z"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M77.24,96.22c-9.08,20.92,9.63,20.13,9.63,20.13"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M28.49,100.9c-.46-1.01-.79-1.75-.79-1.75-.51,.03-.97,.04-1.41,.03"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M21.64,96.02l-.64,.37s-.78,2.52,5.21,2.57c.4,.45,1.97,.48,1.97,.48"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("line", {
        className: "e",
        x1: "21.64",
        y1: "96.02",
        x2: "29.67",
        y2: "91.22"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M75.15,369.44c-4.57-7.84-11.98-22.07-14.66-28.83-1.82-4.6,1.97-19.74,1.97-19.74,0,0,6.71-36.71,7.5-37.11"
    })))));
    return /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement($ad8a84a6427625b0$var$_react["default"].Fragment, null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("style", null, ".e{fill:#eaeaea;stroke:#d6d6d6;}.e,.f{stroke-miterlimit:10;}.f{fill:#cecece;stroke:#bababa;}")), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", {
        className: "evp-batter evp-right-handed-batter",
        style: {
            transform: "scale(".concat(scale, ")")
        }
    }, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("g", null, /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "f",
        d: "M146.94,96.6c23.31,13.83,19.38,9.82,19.38,9.82,0,0,2.54-.65,1.58,1.98-.99,2.7-1.91,4.41-3.22,5.85-.96,1.05-2.31-1.11-2.31-2.3s-17.4-10.71-17.4-10.71"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M163.54,107.7c.79-3.56-5.93-7.9-11.85-11.46-1.97-1.18-3.8-1.23-5.38-.76l-9.64-5.56v-5.93c-.4-18.18-21.73-17.39-25.69-16.99-3.91,.39-28.75,8.15-20.4,28.64-11.95,2.93-27.14,10.42-34.13,14.83-7.51,4.74-9.09,30.43-9.88,52.16-.79,21.73-8.3,45.05-9.09,47.02-.79,1.98,.4,6.32,1.58,8.3s-1.19,3.56-1.19,3.56c0,0-7.9,1.98-13.44,18.57-5.53,16.6-.57,29.5,1.98,33.98,2.12,3.73,12.19,17.34,16.2,22.13,1.3,1.55,17.78,30.03,20.15,35.17s1.19,17.39,.79,17.78-3.52,3.97-6.33,8.52c-2.82,4.58-8.69,18.74-14.22,32.57s-15.02,51.77-15.02,51.77c0,0-6.72,23.31-3.56,28.85,3.16,5.53,23.71,3.16,31.61,2.37s20.15,4.35,29.24,3.56,16.2-2.77,17.78-9.09-18.33-8.4-28.85-16.11c-6.86-5.03-11.87-7.79-13.84-10.16-1.98-2.37,2.1-7.88,4.38-10.69,1.25-1.53,4.32-8.09,5.12-9.27,.79-1.19,18.97-45.05,19.76-46.63,.22-.43,1.43-2.47,3.14-5.41-3.56,21.65-9.46,32.68-9.46,32.68,0,0-6.72,13.83-2.37,19.36s15.41,2.77,24.5,2.77,16.99,3.16,23.31,1.98,15.02-6.72,15.81-9.88-8.96-5.24-13.44-6.32c-6.27-1.52-7.34,.87-16.43-10.98s-.18-38.72-.18-38.72c0,0,7.47-18.94,8.23-27.16,.68-7.25-4.27-23.12-10.6-46.82s-15.41-28.06-16.99-30.82-.79-10.67-.79-10.67c0,0,3.16,1.58,5.93,1.98s5.53-4.74,11.46-17.39c5.93-12.65,8.3-35.56,8.69-38.73,.4-3.16,4.35-13.04,4.35-13.04,0,0,17.78,4.74,21.73,5.14s11.85,1.98,14.23-1.98c2.37-3.95,2.37-16.2,2.37-24.1s-6.32-28.06-6.72-30.03,1.19-5.93,1.98-7.11c.79-1.19,4.35-8.3,5.14-11.85Zm-16.2,28.06c-.4,5.14-3.56,16.2-3.56,16.2,0,0-8.69-4.74-15.81-10.27-7.11-5.53-16.99-4.74-16.99-4.74l.79-3.16c.79-3.16,6.72-6.72,13.83-6.72s6.72-9.09,6.72-9.09c0,0,3.95-11.46,4.35-11.85,.27-.27,1.81-3.62,2.77-5.76,.46-1.01,1.37-.87,1.37-.87,.51,.03,.39-.85,.82-.85-.4,.45-.62,.76-.62,.76,0,0-.79,1.19-1.58,3.16s.4,9.48,.4,12.65,3.16,5.93,5.14,7.51c1.98,1.58,2.77,7.9,2.37,13.04Z"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M139.48,100.6c.46-1.01,.79-1.75,.79-1.75,.51,.03,.97,.04,1.41,.03"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M92.78,369.4c4.58-7.84,12-22.09,14.67-28.86,1.82-4.61-1.98-19.76-1.98-19.76,0,0-6.72-36.75-7.51-37.14"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "f",
        d: "M144.1,101.73s-34.4-21.36-34.76-21.3c0,0-40.7-24.5-48.21-28.06C53.62,48.82,9.59,19.08,1.86,14.44c-3.95-2.37,1.98-9.88,1.98-9.88C8.37-.06,8.97-.57,12.92,2.19c2.07,1.45,42.68,26.48,59.67,39.52s41.72,35.8,63.49,48.72"
    }), /*#__PURE__*/ $ad8a84a6427625b0$var$_react["default"].createElement("path", {
        className: "e",
        d: "M59.34,117.54c.09,.26,3.33,14.72,21.29,17.52,0,0,5.78,2.28,8.5-3.07s10.86-11.74,18.31-14.81c7.45-3.07,21.46-9.9,22.95-10.16s8.06-2.54,9.99-3.94c1.93-1.4,9.55-7.1,7.01-9.46s-14.02-11.39-17.17-11.04-6.31,1.58-8.23,4.03c-1.93,2.45-2.63,5.96-3.68,6.48s-2.28,.88-8.76,1.75-20.28,1.14-20.28,1.14c.21-.18-19.86,6.44-33.92,15.37"
    })))));
}

});

parcelRegister("gKtE2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f3bf829b8dd5990b$var$LeftHandedBatter;

var $f3bf829b8dd5990b$var$_react = $f3bf829b8dd5990b$var$_interopRequireDefault((parcelRequire("J42oT")));
function $f3bf829b8dd5990b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f3bf829b8dd5990b$var$LeftHandedBatter(_ref) {
    var _ref$pitcherPerspecti = _ref.pitcherPerspective, pitcherPerspective = _ref$pitcherPerspecti === void 0 ? false : _ref$pitcherPerspecti;
    // return (
    //   <g id="lhb" transform="translate(340,0)">
    //     <path
    //       d="M107.3,117c-7,19-28,18-28,18c-1.8-1.9-5.5-9-8-11c-5.3-4.3-22-12-44.6-21.5c-3.6-5-6.4-7.5-8.4-7.5c-3,0,14-15.6,20-12.6s8,8,9.5,10.2c1.5,2.2,24.5,1.9,38.5,6.4c12.4,5.8,21.4,8.7,25,14c6,9,8,30,8,30c-1.2,32.8,12,72.1,9.6,74.8c-2.4,2.8-1.2,1.4-1.2,4.3h2.1c27.2,29.9,9.5,57.2,7.4,59.3c-2.1,2.1-13.6,16-15.7,21.3c-2.1,5.4-13.1,24-16.2,27c-2.1,2-3,6-2.1,12.9c0.4,3.3-2.4,6.4,2.1,11.9c9.3,11.3,19.9,39.9,31.9,85.7c6.3,17.7,7.7,28.7,4.2,33c-5.3,6.4-25.1,3.2-29.3,2.1c-4.2-1.1-11.5,5.3-34.5,3.2c-23-2.2-13.6-16-9.4-17.1c4.2-1.1,25.1-12.8,25.1-12.8c6.8-4.8,12-15.5,12-15.5s-5.3-3.2-6.3-4.3c-1-1-25.8-58.5-25.8-58.5s6.4,29.7,8.5,31.9s6.8,19.2,1.6,23.5c-5.3,4.3-23-1-29.3,1.1c-6.3,2.1-16.2,1.6-16.2,1.6s-28.3-9.6-10.5-13.9s25.1-19.2,27.2-23.5c2.1-4.2-1.1-23.4-2.1-27.7S44.6,335,44.6,335s-2.4-3.2,6.6-38.4s20.1-39.9,20.1-39.9c0-1.8,0.7-8.3,0.5-10.1c-3.6-0.1-7.6,4.3-10.6-2.7c-13-17-16.6-55.8-16.6-55.8c-1.7-6-4.4-9.9-4.4-9.2c0,0.4-8,3.8-16,4.8c-9,1.2-18.2,0-18.2,0c-10.4-19.2,4.2-59.7,4.2-59.7s-9.9-12.2-7.9-18.1c1.3-4,6.3-7.6,15-11c2-3,9.5-9.6,13-11c0-4,1.4-8.3,5-11c10.2-7.6,21-6.1,25-4c11.2-8.1,20-16,30-24s56.6-39.4,64.6-42.5s12.5,9.6,9.4,12.8l-63.7,40.5c-7,4.2-14,7.3-32.6,18.6c5.1,4.3,8.3,7.6,8.3,12.6s-0.2,4.9-1,9 M55.1,137.2c0,0-3.8-7.3-11.8-9.3c-5.5-1.4-5.3,1.5-8-2.5c-1.4-2-2-6.5-3-8.5c-1-3-3.9-14.2-5-14c-0.9,0.2-0.7,14.5-2,16c-2.5,2.9-1.8,1.2-5,6.5s-0.1,23.9,2,26.9c5.9-4,10-5.4,14-8.4C44.3,136.9,52.1,137.5,55.1,137.2z"
    //       className="batter"
    //     />
    //     <path
    //       d="M67.1,285.8c0,5-6.1,34.6-9.2,45.5c-2,-17.5,0.7,16.8,8.2,28.7l8.2,11.9"
    //       className="batter"
    //     />
    //     <line className="batter" x1={45.3} y1={88.2} x2={69.3} y2={73.5} />
    //     <line className="batter" x1={39.3} y1={82.9} x2={60.3} y2={68.9} />
    //   </g>
    // )
    if (pitcherPerspective) return /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement($f3bf829b8dd5990b$var$_react["default"].Fragment, null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("style", null, ".e{fill:#eaeaea;stroke:#d6d6d6;}.e,.f{stroke-miterlimit:10;}.f{fill:#cecece;stroke:#bababa;}")), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", {
        className: "evp-batter evp-left-handed-batter-pitcher-pov"
    }, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "f",
        d: "M3.83,4.56C8.36-.06,8.96-.57,12.91,2.19c2.07,1.45,42.64,26.45,59.61,39.48,16.98,13.03,41.68,35.77,63.43,48.67,23.29,13.82,29.34,16.46,29.34,16.46,0,0,2.54-.65,1.58,1.97-.99,2.7-1.91,4.4-3.22,5.85-.96,1.05-2.31-1.11-2.31-2.3s-17.38-10.7-17.38-10.7c0,0-34.37-21.34-34.73-21.28,0,0-40.66-24.48-48.16-28.03S9.58,19.06,1.86,14.43c-3.95-2.37,1.97-9.87,1.97-9.87Z"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M163.12,107.99c.79-3.55-5.92-7.9-11.84-11.45-1.97-1.18-3.8-1.22-5.37-.76l-9.63-5.55v-5.92c-.39-18.16-21.71-17.37-25.66-16.98-3.91,.39-28.72,8.14-20.38,28.61-11.94,2.93-27.12,10.41-34.1,14.82-7.5,4.74-9.08,30.4-9.87,52.11-.79,21.71-8.29,45-9.08,46.98s.39,6.32,1.58,8.29c1.18,1.97-1.18,3.55-1.18,3.55,0,0-7.9,1.97-13.42,18.55-5.53,16.58-.57,29.48,1.97,33.95,2.12,3.73,12.18,17.32,16.19,22.11,1.3,1.55,17.76,30,20.13,35.13s1.18,17.37,.79,17.76-3.52,3.96-6.32,8.52c-2.81,4.57-8.68,18.72-14.21,32.54-5.53,13.82-15,51.71-15,51.71,0,0-6.71,23.29-3.55,28.82,3.16,5.53,23.69,3.16,31.58,2.37,7.9-.79,20.13,4.34,29.21,3.55s16.19-2.76,17.76-9.08c1.58-6.32-18.32-8.39-28.82-16.1-6.86-5.03-11.85-7.78-13.83-10.15-1.97-2.37,2.1-7.88,4.38-10.68,1.24-1.53,4.32-8.08,5.11-9.26,.79-1.18,18.95-45,19.74-46.58,.21-.43,1.43-2.47,3.14-5.4-3.56,21.63-9.45,32.64-9.45,32.64,0,0-6.71,13.82-2.37,19.34s15.4,2.76,24.48,2.76,16.98,3.16,23.29,1.97c6.32-1.18,15-6.71,15.79-9.87s-8.95-5.23-13.42-6.32c-6.26-1.52-7.33,.87-16.41-10.97-9.08-11.84-.18-38.68-.18-38.68,0,0,7.46-18.92,8.23-27.13,.68-7.25-4.27-23.09-10.59-46.78-6.32-23.69-15.4-28.03-16.98-30.79s-.79-10.66-.79-10.66c0,0,3.16,1.58,5.92,1.97s5.53-4.74,11.45-17.37c5.92-12.63,8.29-35.53,8.68-38.69s4.34-13.03,4.34-13.03c0,0,17.76,4.74,21.71,5.13s11.84,1.97,14.21-1.97,2.37-16.19,2.37-24.08-6.32-28.03-6.71-30,1.18-5.92,1.97-7.11c.79-1.18,4.34-8.29,5.13-11.84Zm-16.19,28.03c-.39,5.13-3.55,16.19-3.55,16.19,0,0-8.68-4.74-15.79-10.26s-16.98-4.74-16.98-4.74l.79-3.16c.79-3.16,6.71-6.71,13.82-6.71s6.71-9.08,6.71-9.08c0,0,3.95-11.45,4.34-11.84,.27-.27,1.8-3.62,2.77-5.75,.46-1.01,.79-1.75,.79-1.75,.51,.03,.97,.04,1.41,.03-.4,.45-.62,.76-.62,.76,0,0-.79,1.18-1.58,3.16-.79,1.97,.39,9.47,.39,12.63s3.16,5.92,5.13,7.5,2.76,7.9,2.37,13.03Z"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M90.35,96.22c9.08,20.92-9.63,20.13-9.63,20.13"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M139.09,100.9c.46-1.01,.79-1.75,.79-1.75,.51,.03,.97,.04,1.41,.03"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M145.95,96.02l.64,.37s.78,2.52-5.21,2.57c-.4,.45-1.97,.48-1.97,.48"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("line", {
        className: "e",
        x1: "145.95",
        y1: "96.02",
        x2: "137.92",
        y2: "91.22"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M92.43,369.44c4.57-7.84,11.98-22.07,14.66-28.83,1.82-4.6-1.97-19.74-1.97-19.74,0,0-6.71-36.71-7.5-37.11"
    })))));
    return /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement($f3bf829b8dd5990b$var$_react["default"].Fragment, null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("style", null, ".e{fill:#eaeaea;stroke:#d6d6d6;}.e,.f{stroke-miterlimit:10;}.f{fill:#cecece;stroke:#bababa;}")), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", {
        className: "evp-batter evp-left-handed-batter",
        transform: "translate(340, 0)"
    }, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("g", null, /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "f",
        d: "M21.68,96.6C-1.64,110.43,2.3,106.42,2.3,106.42c0,0-2.54-.65-1.58,1.98,.99,2.7,1.91,4.41,3.22,5.85,.96,1.05,2.31-1.11,2.31-2.3s17.4-10.71,17.4-10.71"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M10.22,119.55c.79,1.19,2.37,5.14,1.98,7.11s-6.72,22.13-6.72,30.03c0,7.9,0,20.15,2.37,24.1s10.27,2.37,14.23,1.98,21.73-5.14,21.73-5.14c0,0,3.95,9.88,4.35,13.04,.4,3.16,2.77,26.08,8.69,38.73,5.93,12.65,8.69,17.78,11.46,17.39s5.93-1.98,5.93-1.98c0,0,.79,7.9-.79,10.67s-10.67,7.11-16.99,30.82c-6.32,23.71-11.28,39.57-10.6,46.82,.77,8.21,8.23,27.16,8.23,27.16,0,0,8.91,26.87-.18,38.72s-10.16,9.46-16.43,10.98c-4.48,1.09-14.23,3.16-13.44,6.32,.79,3.16,9.48,8.69,15.81,9.88s14.23-1.98,23.31-1.98,20.15,2.77,24.5-2.77c4.35-5.53-2.37-19.36-2.37-19.36,0,0-5.9-11.02-9.46-32.68,1.71,2.94,2.93,4.98,3.14,5.41,.79,1.58,18.97,45.44,19.76,46.63s3.87,7.74,5.12,9.27c2.28,2.8,6.36,8.32,4.38,10.69s-6.98,5.13-13.84,10.16c-10.51,7.71-30.43,9.79-28.85,16.11,1.58,6.32,8.69,8.3,17.78,9.09,9.09,.79,21.34-4.35,29.24-3.56s28.45,3.16,31.61-2.37c3.16-5.53-3.56-28.85-3.56-28.85,0,0-9.48-37.94-15.02-51.77-5.53-13.83-11.4-28-14.22-32.57-2.8-4.56-5.93-8.13-6.33-8.52s-1.58-12.65,.79-17.78,18.85-33.62,20.15-35.17c4.01-4.79,14.08-18.4,16.2-22.13,2.55-4.48,7.51-17.39,1.98-33.98-5.53-16.6-13.44-18.57-13.44-18.57,0,0-2.37-1.58-1.19-3.56,1.19-1.98,2.37-6.32,1.58-8.3s-8.3-25.29-9.09-47.02-2.37-47.42-9.88-52.16c-6.99-4.41-22.18-11.9-34.13-14.83,8.34-20.49-16.49-28.24-20.4-28.64-3.95-.4-25.29-1.19-25.69,16.99v5.93l-9.64,5.56c-1.58-.46-3.41-.42-5.38,.76-5.93,3.56-12.65,7.9-11.85,11.46s4.35,10.67,5.14,11.85Zm13.44,3.16c1.98-1.58,5.14-4.35,5.14-7.51,0-3.16,1.19-10.67,.4-12.65-.79-1.98-1.58-3.16-1.58-3.16,0,0-.22-.31-.62-.76,.43,0,.31,.88,.82,.85,0,0,.92-.15,1.37,.87,.96,2.13,2.5,5.49,2.77,5.76,.4,.4,4.35,11.85,4.35,11.85,0,0-.4,9.09,6.72,9.09s13.04,3.56,13.83,6.72l.79,3.16s-9.88-.79-16.99,4.74c-7.11,5.53-15.81,10.27-15.81,10.27,0,0-3.16-11.06-3.56-16.2-.4-5.14,.4-11.46,2.37-13.04Z"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M29.14,100.6c-.46-1.01-.79-1.75-.79-1.75-.51,.03-.97,.04-1.41,.03"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M75.84,369.4c-4.58-7.84-12-22.09-14.67-28.86-1.82-4.61,1.98-19.76,1.98-19.76,0,0,6.72-36.75,7.51-37.14"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "f",
        d: "M24.52,101.73s34.4-21.36,34.76-21.3c0,0,40.7-24.5,48.21-28.06,7.51-3.56,51.55-33.3,59.27-37.94,3.95-2.37-1.98-9.88-1.98-9.88-4.54-4.62-5.14-5.14-9.09-2.37-2.07,1.45-42.68,26.48-59.67,39.52-16.99,13.04-41.72,35.8-63.49,48.72"
    }), /*#__PURE__*/ $f3bf829b8dd5990b$var$_react["default"].createElement("path", {
        className: "e",
        d: "M109.28,117.54c-.09,.26-3.33,14.72-21.29,17.52,0,0-5.78,2.28-8.5-3.07s-10.86-11.74-18.31-14.81-21.46-9.9-22.95-10.16-8.06-2.54-9.99-3.94c-1.93-1.4-9.55-7.1-7.01-9.46s14.02-11.39,17.17-11.04,6.31,1.58,8.23,4.03c1.93,2.45,2.63,5.96,3.68,6.48s2.28,.88,8.76,1.75c6.48,.88,20.28,1.14,20.28,1.14-.21-.18,19.86,6.44,33.92,15.37"
    })))));
}

});

parcelRegister("4DcOz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fffcc54fe4f737a3$var$StrikeZoneBackground;

var $fffcc54fe4f737a3$var$_react = $fffcc54fe4f737a3$var$_interopRequireDefault((parcelRequire("J42oT")));

var $fffcc54fe4f737a3$var$_Dumb = $fffcc54fe4f737a3$var$_interopRequireDefault((parcelRequire("drWWu")));

var $fffcc54fe4f737a3$var$_getStrikeZoneDims = $fffcc54fe4f737a3$var$_interopRequireDefault((parcelRequire("15SjV")));

var $3wgDt = parcelRequire("3wgDt");

var $fffcc54fe4f737a3$var$_FuzzyBackground = $fffcc54fe4f737a3$var$_interopRequireDefault((parcelRequire("fQetD")));
function $fffcc54fe4f737a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ var $fffcc54fe4f737a3$var$strikeZoneBackground = '#f2f2f2';
function $fffcc54fe4f737a3$var$StrikeZone() {
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), settings = _useChartOptions.settings;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var strikeZone = (0, $3wgDt.useStrikeZoneType)();
    var strikeZoneDims = (0, $fffcc54fe4f737a3$var$_getStrikeZoneDims["default"])(strikeZone, settings.data);
    var isLocationAccurate = (0, $3wgDt.useLocationAccurate_TODOFIX)();
    if (isLocationAccurate) return /*#__PURE__*/ $fffcc54fe4f737a3$var$_react["default"].createElement($fffcc54fe4f737a3$var$_FuzzyBackground["default"], {
        bgColor: $fffcc54fe4f737a3$var$strikeZoneBackground
    });
    switch(strikeZone){
        // case 'generic-old':
        case 'personal':
        case 'average':
        case 'generic':
            return /*#__PURE__*/ $fffcc54fe4f737a3$var$_react["default"].createElement($fffcc54fe4f737a3$var$_Dumb["default"], {
                xScale: xScale,
                yScale: yScale,
                szTop: strikeZoneDims.top,
                szBot: strikeZoneDims.bot,
                plateWidthFt: strikeZoneDims.width,
                styles: {
                    strokeDasharray: 'none',
                    fill: $fffcc54fe4f737a3$var$strikeZoneBackground,
                    fillOpacity: 1,
                    stroke: $fffcc54fe4f737a3$var$strikeZoneBackground,
                    strokeOpacity: 1
                }
            });
        // case 'fuzzy':
        //     return (
        //         <StrikeZoneFuzzy
        //             xScale={xScale}
        //             yScale={yScale}
        //             data={settings.data}
        //         />
        //     )
        default:
            return null;
    }
}
function $fffcc54fe4f737a3$var$StrikeZoneBackground() {
    return /*#__PURE__*/ $fffcc54fe4f737a3$var$_react["default"].createElement("g", null, /*#__PURE__*/ $fffcc54fe4f737a3$var$_react["default"].createElement($fffcc54fe4f737a3$var$StrikeZone, null));
}

});
parcelRegister("fQetD", function(module, exports) {
"use strict";
function $d36ed24ab9bb65f4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d36ed24ab9bb65f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d36ed24ab9bb65f4$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d36ed24ab9bb65f4$var$StrikeZoneFuzzyBackground;

var $d36ed24ab9bb65f4$var$_react = $d36ed24ab9bb65f4$var$_interopRequireWildcard((parcelRequire("J42oT")));

var $d36ed24ab9bb65f4$var$d3 = $d36ed24ab9bb65f4$var$_interopRequireWildcard((parcelRequire("jEBA8")));

var $mdo2f = parcelRequire("mdo2f");

var $3wgDt = parcelRequire("3wgDt");
function $d36ed24ab9bb65f4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d36ed24ab9bb65f4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d36ed24ab9bb65f4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $d36ed24ab9bb65f4$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $d36ed24ab9bb65f4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d36ed24ab9bb65f4$var$_slicedToArray(r, e) {
    return $d36ed24ab9bb65f4$var$_arrayWithHoles(r) || $d36ed24ab9bb65f4$var$_iterableToArrayLimit(r, e) || $d36ed24ab9bb65f4$var$_unsupportedIterableToArray(r, e) || $d36ed24ab9bb65f4$var$_nonIterableRest();
}
function $d36ed24ab9bb65f4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d36ed24ab9bb65f4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d36ed24ab9bb65f4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d36ed24ab9bb65f4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d36ed24ab9bb65f4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d36ed24ab9bb65f4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d36ed24ab9bb65f4$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
} /* eslint-disable react/prop-types */ 
function $d36ed24ab9bb65f4$var$useId() {
    var idRef = (0, $d36ed24ab9bb65f4$var$_react.useRef)("id-".concat(Math.random().toString(36).substring(2, 9)));
    return idRef.current;
}
var $d36ed24ab9bb65f4$var$defaultStrokeWidth = 4;
function $d36ed24ab9bb65f4$var$StrikeZoneFuzzyBackground(_ref) {
    var bgColor = _ref.bgColor;
    var _useChartOptions = (0, $3wgDt.useChartOptions)(), settings = _useChartOptions.settings;
    var data = settings.data;
    var _useScales = (0, $3wgDt.useScales)(), xScale = _useScales.xScale, yScale = _useScales.yScale;
    var _d3$extent = $d36ed24ab9bb65f4$var$d3.extent(data, function(d) {
        return d.szTop;
    }), _d3$extent2 = $d36ed24ab9bb65f4$var$_slicedToArray(_d3$extent, 2), topMin = _d3$extent2[0], topMax = _d3$extent2[1];
    var _d3$extent3 = $d36ed24ab9bb65f4$var$d3.extent(data, function(d) {
        return d.szBot;
    }), _d3$extent4 = $d36ed24ab9bb65f4$var$_slicedToArray(_d3$extent3, 2), botMin = _d3$extent4[0], botMax = _d3$extent4[1];
    if (topMin === undefined || topMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    if (botMin === undefined || botMax === undefined) {
        console.warn('No data or no strike zone data');
        return null;
    }
    var dims = (0, $mdo2f.getSVGRectPositioning)(topMax, botMin, 17 / 12, xScale, yScale, $d36ed24ab9bb65f4$var$defaultStrokeWidth);
    var patternId = $d36ed24ab9bb65f4$var$useId();
    return /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("g", {
        id: "strikeZone"
    }, /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("pattern", {
        id: patternId,
        patternUnits: "userSpaceOnUse",
        width: "10",
        height: "10",
        patternTransform: "rotate(45)"
    }, /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("rect", {
        height: "10",
        width: "10",
        fill: bgColor
    }), /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("line", {
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "10",
        stroke: "#ffffff",
        strokeWidth: "6"
    }), /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("line", {
        x1: "0",
        y1: "0",
        x2: "10",
        y2: "0",
        stroke: "#ffffff",
        strokeWidth: "6"
    })))), /*#__PURE__*/ $d36ed24ab9bb65f4$var$_react["default"].createElement("rect", {
        className: "strike-zone",
        style: {
            pointerEvents: 'none'
        },
        x: dims.x,
        width: dims.width,
        y: dims.y,
        height: dims.height,
        strokeWidth: $d36ed24ab9bb65f4$var$defaultStrokeWidth,
        fill: "url(#".concat(patternId, ")"),
        strokeOpacity: 0.5,
        stroke: "#ccc"
    }));
}

});






parcelRegister("hOWcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f0ec647400ea0bb3$var$PlayerStats;

var $f0ec647400ea0bb3$var$_react = $f0ec647400ea0bb3$var$_interopRequireDefault((parcelRequire("J42oT")));
function $f0ec647400ea0bb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f0ec647400ea0bb3$var$PlayerStats(_ref) {
    var stats = _ref.stats;
    return /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement($f0ec647400ea0bb3$var$_react["default"].Fragment, null, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("br", null), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("br", null), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "additional-info"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "additional-info-position"
    }, "Additional Info")), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("hr", null), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "Pitches"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.pitches)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "PA"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.pa)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "H"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.hits)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "1B"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.single)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "2B"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats["double"])), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "3B"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.triple)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "HR"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.hr)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "AVG"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.ba)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "SO"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.so)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "wOBA"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.woba)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "K%"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.kPercent)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "EV"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.avgExitVelocity)), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-box"
    }, /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-title"
    }, "LA"), /*#__PURE__*/ $f0ec647400ea0bb3$var$_react["default"].createElement("div", {
        className: "stats-value"
    }, stats.avgLaunchAngle))));
}

});

parcelRegister("lvjWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $89d869d2bebd92c1$var$FormOption;

var $89d869d2bebd92c1$var$_react = $89d869d2bebd92c1$var$_interopRequireDefault((parcelRequire("J42oT")));
function $89d869d2bebd92c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $89d869d2bebd92c1$var$FormOption(_ref) {
    var _options$find;
    var title = _ref.title, value = _ref.value, onChange = _ref.onChange, options = _ref.options;
    var selected = ((_options$find = options.find(function(o) {
        return o.value === value;
    })) === null || _options$find === void 0 ? void 0 : _options$find.label) || '';
    return /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("div", {
        className: "form-option"
    }, /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("div", {
        className: "dropdown"
    }, /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("span", {
        id: "lbl-".concat(title),
        className: "ddl-label",
        style: {
            fontSize: '0.8rem'
        }
    }, title, ": ", selected), /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("div", {
        className: "dropdown-arrow"
    }, "\u25BE"), /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("select", {
        value: value,
        onChange: onChange
    }, options.map(function(o) {
        return /*#__PURE__*/ $89d869d2bebd92c1$var$_react["default"].createElement("option", {
            key: o.value,
            value: o.value
        }, o.label);
    }))));
}

});

parcelRegister("aQQ9o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7e6736b7338af0dc$var$SaveImage;

var $7e6736b7338af0dc$var$_omit = $7e6736b7338af0dc$var$_interopRequireDefault((parcelRequire("IDKnE")));

var $7e6736b7338af0dc$var$_Schema = $7e6736b7338af0dc$var$_interopRequireDefault((parcelRequire("394kY")));

var $7e6736b7338af0dc$var$_SaveFile = $7e6736b7338af0dc$var$_interopRequireDefault((parcelRequire("6FSTC")));
function $7e6736b7338af0dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/* eslint-disable */ // import DownloadImage from "bam-node-evp/src/Utilities/DownloadImage";
function $7e6736b7338af0dc$var$SaveImage(_ref, callback) {
    var data = _ref.data, player = _ref.player, options = _ref.options;
    var schema = (0, $7e6736b7338af0dc$var$_Schema["default"])(data, player, options);
    schema.shapeRatio = 2;
    schema.embed = options.embed;
    options.appType = 'evp';
    data = data.map(function(d) {
        return (0, $7e6736b7338af0dc$var$_omit["default"])(d, [
            'des',
            'on_3b',
            'on_2b',
            'on_1b',
            'sv_id',
            'play_id',
            'h_launch_speedangle_code',
            'if_fielding_alignment',
            'of_fielding_alignment',
            'pos1_int_start_distance',
            'pos4_int_start_distance',
            'pos7_int_start_distance',
            'pos2_int_start_distance',
            'pos5_int_start_distance',
            'pos8_int_start_distance',
            'pos3_int_start_distance',
            'pos6_int_start_distance',
            'pos9_int_start_distance'
        ]);
    });
    fetch("/evp/add", {
        method: 'POST',
        // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache',
        // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow',
        // manual, *follow, error
        body: JSON.stringify({
            player: player,
            data: data,
            schema: schema,
            appType: 'evp'
        })
    }).then(function(response) {
        if (!response.ok) return {
            error: 'No data'
        };
        return response.json();
    }).then(function(response) {
        if (response.error) callback(response.err);
        else // callback(null, response.id);
        if (!options.embed) (0, $7e6736b7338af0dc$var$_SaveFile["default"])(response.id, player, schema, options, function() {
            callback(null, response.id);
        });
        else callback(null, {
            link: response.id
        });
    });
}

});
parcelRegister("IDKnE", function(module, exports) {

var $cuXSp = parcelRequire("cuXSp");

var $hDz4f = parcelRequire("hDz4f");

var $tE3Ko = parcelRequire("tE3Ko");

var $6HxlX = parcelRequire("6HxlX");

var $brXXW = parcelRequire("brXXW");

var $1Mb94 = parcelRequire("1Mb94");

var $dD4Ir = parcelRequire("dD4Ir");

var $6WsyT = parcelRequire("6WsyT");
/** Used to compose bitmasks for cloning. */ var $0862f11db4f5c5cf$var$CLONE_DEEP_FLAG = 1, $0862f11db4f5c5cf$var$CLONE_FLAT_FLAG = 2, $0862f11db4f5c5cf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $0862f11db4f5c5cf$var$omit = $dD4Ir(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $cuXSp(paths, function(path) {
        path = $6HxlX(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $brXXW(object, $6WsyT(object), result);
    if (isDeep) result = $hDz4f(result, $0862f11db4f5c5cf$var$CLONE_DEEP_FLAG | $0862f11db4f5c5cf$var$CLONE_FLAT_FLAG | $0862f11db4f5c5cf$var$CLONE_SYMBOLS_FLAG, $1Mb94);
    var length = paths.length;
    while(length--)$tE3Ko(result, paths[length]);
    return result;
});
module.exports = $0862f11db4f5c5cf$var$omit;

});
parcelRegister("tE3Ko", function(module, exports) {

var $6HxlX = parcelRequire("6HxlX");

var $78uf3 = parcelRequire("78uf3");

var $hehO1 = parcelRequire("hehO1");

var $iRWdG = parcelRequire("iRWdG");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $0591c884bad0e1c2$var$baseUnset(object, path) {
    path = $6HxlX(path, object);
    object = $hehO1(object, path);
    return object == null || delete object[$iRWdG($78uf3(path))];
}
module.exports = $0591c884bad0e1c2$var$baseUnset;

});
parcelRegister("78uf3", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $01573cdb65a9e69a$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $01573cdb65a9e69a$var$last;

});

parcelRegister("hehO1", function(module, exports) {

var $hNgrA = parcelRequire("hNgrA");

var $78hSw = parcelRequire("78hSw");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $c8b18e5c1535c7e9$var$parent(object, path) {
    return path.length < 2 ? object : $hNgrA(object, $78hSw(path, 0, -1));
}
module.exports = $c8b18e5c1535c7e9$var$parent;

});
parcelRegister("78hSw", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $5317260786d5ae35$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $5317260786d5ae35$var$baseSlice;

});



parcelRegister("1Mb94", function(module, exports) {

var $7OWVz = parcelRequire("7OWVz");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $14b2eb5fc41ecb20$var$customOmitClone(value) {
    return $7OWVz(value) ? undefined : value;
}
module.exports = $14b2eb5fc41ecb20$var$customOmitClone;

});
parcelRegister("7OWVz", function(module, exports) {

var $fmOnE = parcelRequire("fmOnE");

var $onQAM = parcelRequire("onQAM");

var $1cw4V = parcelRequire("1cw4V");
/** `Object#toString` result references. */ var $5b1ae9b3b4ab8480$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5b1ae9b3b4ab8480$var$funcProto = Function.prototype, $5b1ae9b3b4ab8480$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5b1ae9b3b4ab8480$var$funcToString = $5b1ae9b3b4ab8480$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5b1ae9b3b4ab8480$var$hasOwnProperty = $5b1ae9b3b4ab8480$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $5b1ae9b3b4ab8480$var$objectCtorString = $5b1ae9b3b4ab8480$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $5b1ae9b3b4ab8480$var$isPlainObject(value) {
    if (!$1cw4V(value) || $fmOnE(value) != $5b1ae9b3b4ab8480$var$objectTag) return false;
    var proto = $onQAM(value);
    if (proto === null) return true;
    var Ctor = $5b1ae9b3b4ab8480$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $5b1ae9b3b4ab8480$var$funcToString.call(Ctor) == $5b1ae9b3b4ab8480$var$objectCtorString;
}
module.exports = $5b1ae9b3b4ab8480$var$isPlainObject;

});


parcelRegister("dD4Ir", function(module, exports) {

var $hLolY = parcelRequire("hLolY");

var $4fRQb = parcelRequire("4fRQb");

var $hiG9p = parcelRequire("hiG9p");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $9ec2935b14aa86ec$var$flatRest(func) {
    return $hiG9p($4fRQb(func, undefined, $hLolY), func + '');
}
module.exports = $9ec2935b14aa86ec$var$flatRest;

});
parcelRegister("hLolY", function(module, exports) {

var $luj8w = parcelRequire("luj8w");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $cee9b786c29d0c6c$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $luj8w(array, 1) : [];
}
module.exports = $cee9b786c29d0c6c$var$flatten;

});



parcelRegister("6FSTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4dc127a7a66b50c6$var$SaveImage;
/* eslint-disable */ // Queries Cloud Function to Save & Log Image
function $4dc127a7a66b50c6$var$SaveImage(guid, player, schema, options, callback) {
    var venueId = schema.chartType === 'field' ? options.venueId : '';
    var queryString = "guid=".concat(guid, "&chartType=").concat(schema.chartType, "&chartTypeCategory=").concat(schema.chartTypeCategory, "&chartSize=").concat(schema.shape, "&playerId=").concat(player.playerId, "&playerName=").concat(player.playerName, "&playerType=").concat(player.playerType, "&appType=").concat(options.appType, "&venueId=7");
    fetch("https://us-central1-mlb-savant-sbx-617e.cloudfunctions.net/saveImage?".concat(queryString)).then(function(response) {
        response.blob().then(function(blob) {
            if (blob && blob.size > 1000) {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "".concat(guid, ".jpg");
                a.click();
                callback();
            } else throw 'Error returning image.';
        })["catch"](function(err) {
            callback(err);
        });
    });
/* DownloadImage(playerType, schema, data, 'evp', (json) => {
      if (json) {
          callback(json)
      }
      else {
          callback();
      }
  }); */ }

});



"use strict";

var $87ad0018a4299ee7$var$_react = $87ad0018a4299ee7$var$_interopRequireDefault((parcelRequire("J42oT")));

var $87ad0018a4299ee7$var$_reactDom = $87ad0018a4299ee7$var$_interopRequireDefault((parcelRequire("f3ft4")));

var $87ad0018a4299ee7$var$_Data = $87ad0018a4299ee7$var$_interopRequireDefault((parcelRequire("01EAe")));

function $87ad0018a4299ee7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// Important, this becomes index.css
$87ad0018a4299ee7$var$_reactDom["default"].render(/*#__PURE__*/ $87ad0018a4299ee7$var$_react["default"].createElement($87ad0018a4299ee7$var$_Data["default"], null), document.getElementById('root'));

})();
//# sourceMappingURL=index.js.map
